
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb792"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb792"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = 60103, $8ed5b7d8837dad8a$var$c = 60106, $8ed5b7d8837dad8a$var$d = 60107, $8ed5b7d8837dad8a$var$e = 60108, $8ed5b7d8837dad8a$var$f = 60114, $8ed5b7d8837dad8a$var$g = 60109, $8ed5b7d8837dad8a$var$h = 60110, $8ed5b7d8837dad8a$var$k = 60112, $8ed5b7d8837dad8a$var$l = 60113, $8ed5b7d8837dad8a$var$m = 60120, $8ed5b7d8837dad8a$var$n = 60115, $8ed5b7d8837dad8a$var$p = 60116, $8ed5b7d8837dad8a$var$q = 60121, $8ed5b7d8837dad8a$var$r = 60122, $8ed5b7d8837dad8a$var$u = 60117, $8ed5b7d8837dad8a$var$v = 60129, $8ed5b7d8837dad8a$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $8ed5b7d8837dad8a$var$x = Symbol.for;
    $8ed5b7d8837dad8a$var$b = $8ed5b7d8837dad8a$var$x("react.element");
    $8ed5b7d8837dad8a$var$c = $8ed5b7d8837dad8a$var$x("react.portal");
    $8ed5b7d8837dad8a$var$d = $8ed5b7d8837dad8a$var$x("react.fragment");
    $8ed5b7d8837dad8a$var$e = $8ed5b7d8837dad8a$var$x("react.strict_mode");
    $8ed5b7d8837dad8a$var$f = $8ed5b7d8837dad8a$var$x("react.profiler");
    $8ed5b7d8837dad8a$var$g = $8ed5b7d8837dad8a$var$x("react.provider");
    $8ed5b7d8837dad8a$var$h = $8ed5b7d8837dad8a$var$x("react.context");
    $8ed5b7d8837dad8a$var$k = $8ed5b7d8837dad8a$var$x("react.forward_ref");
    $8ed5b7d8837dad8a$var$l = $8ed5b7d8837dad8a$var$x("react.suspense");
    $8ed5b7d8837dad8a$var$m = $8ed5b7d8837dad8a$var$x("react.suspense_list");
    $8ed5b7d8837dad8a$var$n = $8ed5b7d8837dad8a$var$x("react.memo");
    $8ed5b7d8837dad8a$var$p = $8ed5b7d8837dad8a$var$x("react.lazy");
    $8ed5b7d8837dad8a$var$q = $8ed5b7d8837dad8a$var$x("react.block");
    $8ed5b7d8837dad8a$var$r = $8ed5b7d8837dad8a$var$x("react.server.block");
    $8ed5b7d8837dad8a$var$u = $8ed5b7d8837dad8a$var$x("react.fundamental");
    $8ed5b7d8837dad8a$var$v = $8ed5b7d8837dad8a$var$x("react.debug_trace_mode");
    $8ed5b7d8837dad8a$var$w = $8ed5b7d8837dad8a$var$x("react.legacy_hidden");
}
function $8ed5b7d8837dad8a$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$l:
                    case $8ed5b7d8837dad8a$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$n:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return t;
        }
    }
}
var $8ed5b7d8837dad8a$var$z = $8ed5b7d8837dad8a$var$g, $8ed5b7d8837dad8a$var$A = $8ed5b7d8837dad8a$var$b, $8ed5b7d8837dad8a$var$B = $8ed5b7d8837dad8a$var$k, $8ed5b7d8837dad8a$var$C = $8ed5b7d8837dad8a$var$d, $8ed5b7d8837dad8a$var$D = $8ed5b7d8837dad8a$var$p, $8ed5b7d8837dad8a$var$E = $8ed5b7d8837dad8a$var$n, $8ed5b7d8837dad8a$var$F = $8ed5b7d8837dad8a$var$c, $8ed5b7d8837dad8a$var$G = $8ed5b7d8837dad8a$var$f, $8ed5b7d8837dad8a$var$H = $8ed5b7d8837dad8a$var$e, $8ed5b7d8837dad8a$var$I = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$z;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$A;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$B;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$C;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$D;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$E;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$F;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$G;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$H;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$I;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$k;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$v || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$l || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$w || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$n || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$k || a.$$typeof === $8ed5b7d8837dad8a$var$u || a.$$typeof === $8ed5b7d8837dad8a$var$q || a[0] === $8ed5b7d8837dad8a$var$r) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$y;

});

parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});

parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("1j1sX", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("jlGhZ", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("2XKUe", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $22857a03c9104471$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $22857a03c9104471$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($22857a03c9104471$var$_a = String.fromCodePoint) !== null && $22857a03c9104471$var$_a !== void 0 ? $22857a03c9104471$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $22857a03c9104471$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $22857a03c9104471$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $22857a03c9104471$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $22857a03c9104471$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($22857a03c9104471$var$replaceCodePoint(codePoint));
}
module.exports.default = $22857a03c9104471$var$decodeCodePoint;

});

parcelRegister("7c5y3", function(module, exports) {

$parcel$export(module.exports, "g", () => getDefaultExportFromCjs);
$parcel$export(module.exports, "E", () => ESdkControlsEvents);
$parcel$export(module.exports, "a", () => getConfig);
$parcel$export(module.exports, "u", () => updateConfig);
$parcel$export(module.exports, "S", () => SdkEventEmitter);
$parcel$export(module.exports, "r", () => renderChat);
$parcel$export(module.exports, "s", () => setAuth);
$parcel$export(module.exports, "e", () => setChannelUrl);
$parcel$export(module.exports, "i", () => init);

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $4hUQH = parcelRequire("4hUQH");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
var $4TSkt = parcelRequire("4TSkt");

var $1u0KT = parcelRequire("1u0KT");

var $kSjqI = parcelRequire("kSjqI");

var $gPJZG = parcelRequire("gPJZG");

var $99y5v = parcelRequire("99y5v");

var $7Uc0p = parcelRequire("7Uc0p");

var $eShmq = parcelRequire("eShmq");

var $ki1Eq = parcelRequire("ki1Eq");


var $a1McR = parcelRequire("a1McR");

var $7etJZ = parcelRequire("7etJZ");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("9ORqK");

var $6ZWSX = parcelRequire("6ZWSX");
var _a, _b, _c;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a3() {
            if (this instanceof a3) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k2) {
        var d2 = Object.getOwnPropertyDescriptor(n2, k2);
        Object.defineProperty(a2, k2, d2.get ? d2 : {
            enumerable: true,
            get: function() {
                return n2[k2];
            }
        });
    });
    return a2;
}
var lodash_merge = {
    exports: {}
};
lodash_merge.exports;
(function(module2, exports2) {
    var LARGE_ARRAY_SIZE2 = 200;
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var HOT_COUNT2 = 800, HOT_SPAN2 = 16;
    var MAX_SAFE_INTEGER2 = 9007199254740991;
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = function() {
        try {
            var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
            if (types2) return types2;
            return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
        } catch (e2) {}
    }();
    var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    function baseTimes2(n2, iteratee) {
        var index2 = -1, result2 = Array(n2);
        while(++index2 < n2)result2[index2] = iteratee(index2);
        return result2;
    }
    function baseUnary2(func) {
        return function(value2) {
            return func(value2);
        };
    }
    function getValue2(object2, key) {
        return object2 == null ? void 0 : object2[key];
    }
    function overArg2(func, transform2) {
        return function(arg) {
            return func(transform2(arg));
        };
    }
    var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
    var coreJsData2 = root2["__core-js_shared__"];
    var funcToString2 = funcProto2.toString;
    var hasOwnProperty2 = objectProto2.hasOwnProperty;
    var maskSrcKey2 = function() {
        var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString2 = objectProto2.toString;
    var objectCtorString2 = funcToString2.call(Object);
    var reIsNative2 = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports2 ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array;
    Buffer2 && Buffer2.allocUnsafe;
    var getPrototype2 = overArg2(Object.getPrototypeOf, Object), objectCreate2 = Object.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
    var defineProperty2 = function() {
        try {
            var func = getNative2(Object, "defineProperty");
            func({}, "", {});
            return func;
        } catch (e2) {}
    }();
    var nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0, nativeMax2 = Math.max, nativeNow2 = Date.now;
    var Map2 = getNative2(root2, "Map"), nativeCreate2 = getNative2(Object, "create");
    var baseCreate2 = /* @__PURE__ */ function() {
        function object2() {}
        return function(proto) {
            if (!isObject2(proto)) return {};
            if (objectCreate2) return objectCreate2(proto);
            object2.prototype = proto;
            var result2 = new object2();
            object2.prototype = void 0;
            return result2;
        };
    }();
    function Hash2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index2 < length){
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
        }
    }
    function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
    }
    function hashDelete2(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
    }
    function hashGet2(key) {
        var data = this.__data__;
        if (nativeCreate2) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED2 ? void 0 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : void 0;
    }
    function hashHas2(key) {
        var data = this.__data__;
        return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
    }
    function hashSet2(key, value2) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate2 && value2 === void 0 ? HASH_UNDEFINED2 : value2;
        return this;
    }
    Hash2.prototype.clear = hashClear2;
    Hash2.prototype["delete"] = hashDelete2;
    Hash2.prototype.get = hashGet2;
    Hash2.prototype.has = hashHas2;
    Hash2.prototype.set = hashSet2;
    function ListCache2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index2 < length){
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
        }
    }
    function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
    }
    function listCacheDelete2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) return false;
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) data.pop();
        else splice2.call(data, index2, 1);
        --this.size;
        return true;
    }
    function listCacheGet2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        return index2 < 0 ? void 0 : data[index2][1];
    }
    function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
    }
    function listCacheSet2(key, value2) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
            ++this.size;
            data.push([
                key,
                value2
            ]);
        } else data[index2][1] = value2;
        return this;
    }
    ListCache2.prototype.clear = listCacheClear2;
    ListCache2.prototype["delete"] = listCacheDelete2;
    ListCache2.prototype.get = listCacheGet2;
    ListCache2.prototype.has = listCacheHas2;
    ListCache2.prototype.set = listCacheSet2;
    function MapCache2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index2 < length){
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
        }
    }
    function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
            "hash": new Hash2(),
            "map": new (Map2 || ListCache2)(),
            "string": new Hash2()
        };
    }
    function mapCacheDelete2(key) {
        var result2 = getMapData2(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
    }
    function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
    }
    function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
    }
    function mapCacheSet2(key, value2) {
        var data = getMapData2(this, key), size2 = data.size;
        data.set(key, value2);
        this.size += data.size == size2 ? 0 : 1;
        return this;
    }
    MapCache2.prototype.clear = mapCacheClear2;
    MapCache2.prototype["delete"] = mapCacheDelete2;
    MapCache2.prototype.get = mapCacheGet2;
    MapCache2.prototype.has = mapCacheHas2;
    MapCache2.prototype.set = mapCacheSet2;
    function Stack2(entries) {
        var data = this.__data__ = new ListCache2(entries);
        this.size = data.size;
    }
    function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
    }
    function stackDelete2(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
    }
    function stackGet2(key) {
        return this.__data__.get(key);
    }
    function stackHas2(key) {
        return this.__data__.has(key);
    }
    function stackSet2(key, value2) {
        var data = this.__data__;
        if (data instanceof ListCache2) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
                pairs.push([
                    key,
                    value2
                ]);
                this.size = ++data.size;
                return this;
            }
            data = this.__data__ = new MapCache2(pairs);
        }
        data.set(key, value2);
        this.size = data.size;
        return this;
    }
    Stack2.prototype.clear = stackClear2;
    Stack2.prototype["delete"] = stackDelete2;
    Stack2.prototype.get = stackGet2;
    Stack2.prototype.has = stackHas2;
    Stack2.prototype.set = stackSet2;
    function arrayLikeKeys2(value2, inherited) {
        var isArr = isArray2(value2), isArg = !isArr && isArguments3(value2), isBuff = !isArr && !isArg && isBuffer2(value2), isType = !isArr && !isArg && !isBuff && isTypedArray2(value2), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes2(value2.length, String) : [], length = result2.length;
        for(var key in value2)if (!(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex2(key, length)))) result2.push(key);
        return result2;
    }
    function assignMergeValue2(object2, key, value2) {
        if (value2 !== void 0 && !eq2(object2[key], value2) || value2 === void 0 && !(key in object2)) baseAssignValue2(object2, key, value2);
    }
    function assignValue2(object2, key, value2) {
        var objValue = object2[key];
        if (!(hasOwnProperty2.call(object2, key) && eq2(objValue, value2)) || value2 === void 0 && !(key in object2)) baseAssignValue2(object2, key, value2);
    }
    function assocIndexOf2(array, key) {
        var length = array.length;
        while(length--){
            if (eq2(array[length][0], key)) return length;
        }
        return -1;
    }
    function baseAssignValue2(object2, key, value2) {
        if (key == "__proto__" && defineProperty2) defineProperty2(object2, key, {
            "configurable": true,
            "enumerable": true,
            "value": value2,
            "writable": true
        });
        else object2[key] = value2;
    }
    var baseFor2 = createBaseFor2();
    function baseGetTag2(value2) {
        if (value2 == null) return value2 === void 0 ? undefinedTag2 : nullTag2;
        return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag2(value2) : objectToString2(value2);
    }
    function baseIsArguments2(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == argsTag2;
    }
    function baseIsNative2(value2) {
        if (!isObject2(value2) || isMasked2(value2)) return false;
        var pattern = isFunction3(value2) ? reIsNative2 : reIsHostCtor2;
        return pattern.test(toSource2(value2));
    }
    function baseIsTypedArray2(value2) {
        return isObjectLike2(value2) && isLength2(value2.length) && !!typedArrayTags2[baseGetTag2(value2)];
    }
    function baseKeysIn2(object2) {
        if (!isObject2(object2)) return nativeKeysIn2(object2);
        var isProto = isPrototype2(object2), result2 = [];
        for(var key in object2)if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) result2.push(key);
        return result2;
    }
    function baseMerge2(object2, source, srcIndex, customizer, stack) {
        if (object2 === source) return;
        baseFor2(source, function(srcValue, key) {
            stack || (stack = new Stack2());
            if (isObject2(srcValue)) baseMergeDeep2(object2, source, key, srcIndex, baseMerge2, customizer, stack);
            else {
                var newValue = customizer ? customizer(safeGet2(object2, key), srcValue, key + "", object2, source, stack) : void 0;
                if (newValue === void 0) newValue = srcValue;
                assignMergeValue2(object2, key, newValue);
            }
        }, keysIn2);
    }
    function baseMergeDeep2(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet2(object2, key), srcValue = safeGet2(source, key), stacked = stack.get(srcValue);
        if (stacked) {
            assignMergeValue2(object2, key, stacked);
            return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : void 0;
        var isCommon = newValue === void 0;
        if (isCommon) {
            var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
                if (isArray2(objValue)) newValue = objValue;
                else if (isArrayLikeObject2(objValue)) newValue = copyArray2(objValue);
                else if (isBuff) {
                    isCommon = false;
                    newValue = cloneBuffer2(srcValue);
                } else if (isTyped) {
                    isCommon = false;
                    newValue = cloneTypedArray2(srcValue);
                } else newValue = [];
            } else if (isPlainObject2(srcValue) || isArguments3(srcValue)) {
                newValue = objValue;
                if (isArguments3(objValue)) newValue = toPlainObject2(objValue);
                else if (!isObject2(objValue) || isFunction3(objValue)) newValue = initCloneObject2(srcValue);
            } else isCommon = false;
        }
        if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
        }
        assignMergeValue2(object2, key, newValue);
    }
    function baseRest2(func, start) {
        return setToString2(overRest2(func, start, identity2), func + "");
    }
    var baseSetToString2 = !defineProperty2 ? identity2 : function(func, string) {
        return defineProperty2(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant2(string),
            "writable": true
        });
    };
    function cloneBuffer2(buffer, isDeep) {
        return buffer.slice();
    }
    function cloneArrayBuffer2(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
    }
    function cloneTypedArray2(typedArray, isDeep) {
        var buffer = cloneArrayBuffer2(typedArray.buffer);
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    function copyArray2(source, array) {
        var index2 = -1, length = source.length;
        array || (array = Array(length));
        while(++index2 < length)array[index2] = source[index2];
        return array;
    }
    function copyObject2(source, props, object2, customizer) {
        var isNew = !object2;
        object2 || (object2 = {});
        var index2 = -1, length = props.length;
        while(++index2 < length){
            var key = props[index2];
            var newValue = void 0;
            if (newValue === void 0) newValue = source[key];
            if (isNew) baseAssignValue2(object2, key, newValue);
            else assignValue2(object2, key, newValue);
        }
        return object2;
    }
    function createAssigner2(assigner) {
        return baseRest2(function(object2, sources) {
            var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
            if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
                customizer = length < 3 ? void 0 : customizer;
                length = 1;
            }
            object2 = Object(object2);
            while(++index2 < length){
                var source = sources[index2];
                if (source) assigner(object2, source, index2, customizer);
            }
            return object2;
        });
    }
    function createBaseFor2(fromRight) {
        return function(object2, iteratee, keysFunc) {
            var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
            while(length--){
                var key = props[++index2];
                if (iteratee(iterable[key], key, iterable) === false) break;
            }
            return object2;
        };
    }
    function getMapData2(map, key) {
        var data = map.__data__;
        return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative2(object2, key) {
        var value2 = getValue2(object2, key);
        return baseIsNative2(value2) ? value2 : void 0;
    }
    function getRawTag2(value2) {
        var isOwn = hasOwnProperty2.call(value2, symToStringTag2), tag = value2[symToStringTag2];
        try {
            value2[symToStringTag2] = void 0;
            var unmasked = true;
        } catch (e2) {}
        var result2 = nativeObjectToString2.call(value2);
        if (unmasked) {
            if (isOwn) value2[symToStringTag2] = tag;
            else delete value2[symToStringTag2];
        }
        return result2;
    }
    function initCloneObject2(object2) {
        return typeof object2.constructor == "function" && !isPrototype2(object2) ? baseCreate2(getPrototype2(object2)) : {};
    }
    function isIndex2(value2, length) {
        var type = typeof value2;
        length = length == null ? MAX_SAFE_INTEGER2 : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value2)) && value2 > -1 && value2 % 1 == 0 && value2 < length;
    }
    function isIterateeCall2(value2, index2, object2) {
        if (!isObject2(object2)) return false;
        var type = typeof index2;
        if (type == "number" ? isArrayLike2(object2) && isIndex2(index2, object2.length) : type == "string" && index2 in object2) return eq2(object2[index2], value2);
        return false;
    }
    function isKeyable2(value2) {
        var type = typeof value2;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
    }
    function isMasked2(func) {
        return !!maskSrcKey2 && maskSrcKey2 in func;
    }
    function isPrototype2(value2) {
        var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value2 === proto;
    }
    function nativeKeysIn2(object2) {
        var result2 = [];
        if (object2 != null) for(var key in Object(object2))result2.push(key);
        return result2;
    }
    function objectToString2(value2) {
        return nativeObjectToString2.call(value2);
    }
    function overRest2(func, start, transform2) {
        start = nativeMax2(start === void 0 ? func.length - 1 : start, 0);
        return function() {
            var args = arguments, index2 = -1, length = nativeMax2(args.length - start, 0), array = Array(length);
            while(++index2 < length)array[index2] = args[start + index2];
            index2 = -1;
            var otherArgs = Array(start + 1);
            while(++index2 < start)otherArgs[index2] = args[index2];
            otherArgs[start] = transform2(array);
            return apply2(func, this, otherArgs);
        };
    }
    function safeGet2(object2, key) {
        if (key === "constructor" && typeof object2[key] === "function") return;
        if (key == "__proto__") return;
        return object2[key];
    }
    var setToString2 = shortOut2(baseSetToString2);
    function shortOut2(func) {
        var count2 = 0, lastCalled = 0;
        return function() {
            var stamp = nativeNow2(), remaining = HOT_SPAN2 - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
                if (++count2 >= HOT_COUNT2) return arguments[0];
            } else count2 = 0;
            return func.apply(void 0, arguments);
        };
    }
    function toSource2(func) {
        if (func != null) {
            try {
                return funcToString2.call(func);
            } catch (e2) {}
            try {
                return func + "";
            } catch (e2) {}
        }
        return "";
    }
    function eq2(value2, other) {
        return value2 === other || value2 !== value2 && other !== other;
    }
    var isArguments3 = baseIsArguments2(/* @__PURE__ */ function() {
        return arguments;
    }()) ? baseIsArguments2 : function(value2) {
        return isObjectLike2(value2) && hasOwnProperty2.call(value2, "callee") && !propertyIsEnumerable2.call(value2, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike2(value2) {
        return value2 != null && isLength2(value2.length) && !isFunction3(value2);
    }
    function isArrayLikeObject2(value2) {
        return isObjectLike2(value2) && isArrayLike2(value2);
    }
    var isBuffer2 = nativeIsBuffer2 || stubFalse2;
    function isFunction3(value2) {
        if (!isObject2(value2)) return false;
        var tag = baseGetTag2(value2);
        return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
    }
    function isLength2(value2) {
        return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
    }
    function isObject2(value2) {
        var type = typeof value2;
        return value2 != null && (type == "object" || type == "function");
    }
    function isObjectLike2(value2) {
        return value2 != null && typeof value2 == "object";
    }
    function isPlainObject2(value2) {
        if (!isObjectLike2(value2) || baseGetTag2(value2) != objectTag2) return false;
        var proto = getPrototype2(value2);
        if (proto === null) return true;
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString2;
    }
    var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
    function toPlainObject2(value2) {
        return copyObject2(value2, keysIn2(value2));
    }
    function keysIn2(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeysIn2(object2);
    }
    var merge2 = createAssigner2(function(object2, source, srcIndex) {
        baseMerge2(object2, source, srcIndex);
    });
    function constant2(value2) {
        return function() {
            return value2;
        };
    }
    function identity2(value2) {
        return value2;
    }
    function stubFalse2() {
        return false;
    }
    module2.exports = merge2;
})(lodash_merge, lodash_merge.exports);
var lodash_mergeExports = lodash_merge.exports;
const merge$3 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_mergeExports);
var EBlockType = /* @__PURE__ */ ((EBlockType2)=>{
    EBlockType2[EBlockType2["unstyled"] = 0] = "unstyled";
    EBlockType2[EBlockType2["paragraph"] = 1] = "paragraph";
    EBlockType2[EBlockType2["header-one"] = 2] = "header-one";
    EBlockType2[EBlockType2["header-two"] = 3] = "header-two";
    EBlockType2[EBlockType2["header-three"] = 4] = "header-three";
    EBlockType2[EBlockType2["header-four"] = 5] = "header-four";
    EBlockType2[EBlockType2["header-five"] = 6] = "header-five";
    EBlockType2[EBlockType2["header-six"] = 7] = "header-six";
    EBlockType2[EBlockType2["unordered-list-item"] = 8] = "unordered-list-item";
    EBlockType2[EBlockType2["ordered-list-item"] = 9] = "ordered-list-item";
    EBlockType2[EBlockType2["blockquote"] = 10] = "blockquote";
    EBlockType2[EBlockType2["code-block"] = 11] = "code-block";
    EBlockType2[EBlockType2["atomic"] = 12] = "atomic";
    return EBlockType2;
})(EBlockType || {});
var EStyleType = /* @__PURE__ */ ((EStyleType2)=>{
    EStyleType2[EStyleType2["BOLD"] = 0] = "BOLD";
    EStyleType2[EStyleType2["CODE"] = 1] = "CODE";
    EStyleType2[EStyleType2["ITALIC"] = 2] = "ITALIC";
    EStyleType2[EStyleType2["STRIKETHROUGH"] = 3] = "STRIKETHROUGH";
    EStyleType2[EStyleType2["UNDERLINE"] = 4] = "UNDERLINE";
    return EStyleType2;
})(EStyleType || {});
var EPackedTextBlock = /* @__PURE__ */ ((EPackedTextBlock2)=>{
    EPackedTextBlock2[EPackedTextBlock2["TEXT"] = 0] = "TEXT";
    EPackedTextBlock2[EPackedTextBlock2["TYPE"] = 1] = "TYPE";
    EPackedTextBlock2[EPackedTextBlock2["STYLE_RANGES"] = 2] = "STYLE_RANGES";
    return EPackedTextBlock2;
})(EPackedTextBlock || {});
var EPackedStyleRange = /* @__PURE__ */ ((EPackedStyleRange2)=>{
    EPackedStyleRange2[EPackedStyleRange2["STYLE"] = 0] = "STYLE";
    EPackedStyleRange2[EPackedStyleRange2["OFFSET"] = 1] = "OFFSET";
    EPackedStyleRange2[EPackedStyleRange2["LENGTH"] = 2] = "LENGTH";
    return EPackedStyleRange2;
})(EPackedStyleRange || {});
var EConvertedStyleRange = /* @__PURE__ */ ((EConvertedStyleRange2)=>{
    EConvertedStyleRange2[EConvertedStyleRange2["STYLE"] = 0] = "STYLE";
    EConvertedStyleRange2[EConvertedStyleRange2["START"] = 1] = "START";
    EConvertedStyleRange2[EConvertedStyleRange2["END"] = 2] = "END";
    return EConvertedStyleRange2;
})(EConvertedStyleRange || {});
var EActionsJournalEventType = /* @__PURE__ */ ((EActionsJournalEventType2)=>{
    EActionsJournalEventType2["SUBSCRIPTION"] = "subscription";
    EActionsJournalEventType2["FOLLOWING"] = "following";
    EActionsJournalEventType2["WINNER_SELECTION"] = "winner_selection";
    EActionsJournalEventType2["HOSTING"] = "hosting";
    EActionsJournalEventType2["RAIDING"] = "raiding";
    EActionsJournalEventType2["REWARD"] = "reward_demand";
    EActionsJournalEventType2["PREDICTION"] = "prediction";
    EActionsJournalEventType2["SUBSCRIPTION_GIFT_BUY"] = "subscription_gift_buy";
    EActionsJournalEventType2["SUBSCRIPTION_GIFT"] = "subscription_gift";
    return EActionsJournalEventType2;
})(EActionsJournalEventType || {});
var EAlertType = /* @__PURE__ */ ((EAlertType2)=>{
    EAlertType2[EAlertType2["SUCCESS"] = 0] = "SUCCESS";
    EAlertType2[EAlertType2["ERROR"] = 1] = "ERROR";
    EAlertType2[EAlertType2["CHECK"] = 2] = "CHECK";
    return EAlertType2;
})(EAlertType || {});
var EAnalyticsPresetPeriod = /* @__PURE__ */ ((EAnalyticsPresetPeriod2)=>{
    EAnalyticsPresetPeriod2["TODAY"] = "today";
    EAnalyticsPresetPeriod2["LAST_7_DAYS"] = "7day";
    EAnalyticsPresetPeriod2["LAST_30_DAYS"] = "30day";
    EAnalyticsPresetPeriod2["CURRENT_MONTH"] = "month";
    EAnalyticsPresetPeriod2["PREVIOUS_MONTH"] = "previous_month";
    EAnalyticsPresetPeriod2["CUSTOM"] = "custom";
    return EAnalyticsPresetPeriod2;
})(EAnalyticsPresetPeriod || {});
var EApiContext = /* @__PURE__ */ ((EApiContext2)=>{
    EApiContext2["BOOSTY"] = "boosty";
    EApiContext2["STREAMS"] = "streams";
    return EApiContext2;
})(EApiContext || {});
var EAppId = /* @__PURE__ */ ((EAppId2)=>{
    EAppId2["WEB"] = "web";
    EAppId2["WEB_MOBILE"] = "web_mobile";
    EAppId2["WEB_WIDGETS"] = "web_widgets";
    EAppId2["WEB_DEV"] = "web_dev";
    EAppId2["WEB_X"] = "web_x";
    EAppId2["WEB_X_MOBILE"] = "web_x_mobile";
    EAppId2["STREAMS_WEB"] = "streams_web";
    EAppId2["STREAMS_WEB_EMBED"] = "streams_web_embed";
    EAppId2["STREAMS_WEB_MOBILE"] = "streams_web_mobile";
    EAppId2["STREAMS_WEB_MOBILE_EMBED"] = "streams_web_mobile_embed";
    EAppId2["LETTERS_FOUNDER"] = "letters_founder";
    EAppId2["LETTERS_FOUNDER_X"] = "letters_founder_x";
    EAppId2["UNSET"] = "unset";
    EAppId2["WEB_VIEW"] = "web_mobile";
    EAppId2["BOOSTY_ANDROID"] = "boosty-android";
    EAppId2["BOOSTY_ANDROID_DEBUG"] = "boosty-android-debug";
    EAppId2["BOOSTY_IOS"] = "boosty-ios";
    EAppId2["BOOSTY_IOS_DEBUG"] = "boosty-ios-debug";
    EAppId2["BOOSTY_LIVE_ANDROID"] = "boosty-live-android";
    EAppId2["BOOSTY_LIVE_ANDROID_DEBUG"] = "boosty-live-android-debug";
    EAppId2["BOOSTY_LIVE_ANDROID_QA"] = "boosty-live-android-qa";
    EAppId2["BOOSTY_LIVE_IOS"] = "boosty-live-ios";
    EAppId2["BOOSTY_LIVE_IOS_DEBUG"] = "boosty-live-ios-debug";
    return EAppId2;
})(EAppId || {});
var EAuthSource = /* @__PURE__ */ ((EAuthSource2)=>{
    EAuthSource2["BOOSTY"] = "boosty";
    EAuthSource2["VK"] = "vk";
    EAuthSource2["VK_ID"] = "vk_vkconnect";
    EAuthSource2["VK_PLAY"] = "vkplay";
    return EAuthSource2;
})(EAuthSource || {});
var EAvatarSize = /* @__PURE__ */ ((EAvatarSize2)=>{
    EAvatarSize2["XXXS"] = "16";
    EAvatarSize2["XXS"] = "20";
    EAvatarSize2["XXS_OVERSIZE"] = "25";
    EAvatarSize2["XS"] = "30";
    EAvatarSize2["XS_MIDDLE"] = "32";
    EAvatarSize2["XS_OVERSIZE"] = "35";
    EAvatarSize2["S_MINUS"] = "38";
    EAvatarSize2["S"] = "40";
    EAvatarSize2["S_PLUS"] = "42";
    EAvatarSize2["S_PLUS_EXTRA"] = "48";
    EAvatarSize2["S_OVERSIZE"] = "50";
    EAvatarSize2["S_MAX"] = "55";
    EAvatarSize2["SM"] = "60";
    EAvatarSize2["SM_OVERSIZE"] = "65";
    EAvatarSize2["SMM"] = "70";
    EAvatarSize2["M_MINUS"] = "72";
    EAvatarSize2["M"] = "75";
    EAvatarSize2["L"] = "80";
    EAvatarSize2["XL"] = "84";
    return EAvatarSize2;
})(EAvatarSize || {});
var EBadgeAchievementType = /* @__PURE__ */ ((EBadgeAchievementType2)=>{
    EBadgeAchievementType2["BLOG_CONTROL"] = "blog_control";
    EBadgeAchievementType2["SUBSCRIPTION"] = "subscription";
    return EBadgeAchievementType2;
})(EBadgeAchievementType || {});
var EBlogPostFrom = /* @__PURE__ */ ((EBlogPostFrom2)=>{
    EBlogPostFrom2["BLOG"] = "blog";
    EBlogPostFrom2["BLOG_POST"] = "blog_post";
    EBlogPostFrom2["ABOUT_AUTHOR"] = "about_author";
    EBlogPostFrom2["MESSAGE"] = "message";
    EBlogPostFrom2["MESSAGE_PREVIEW"] = "message_preview";
    EBlogPostFrom2["DIALOGUE_LIST"] = "dialogue_list";
    EBlogPostFrom2["EMAIL"] = "email";
    EBlogPostFrom2["COMMENTS"] = "comments";
    EBlogPostFrom2["SUBSCRIPTION_LEVEL_ITEM"] = "subscription_level_items";
    EBlogPostFrom2["BLOG_STREAM_CHAT_MESSAGE"] = "blog_stream_chat_message";
    EBlogPostFrom2["ACTIVITY_CONTENT"] = "activity_content";
    EBlogPostFrom2["SEARCH_BY_POSTS"] = "search_by_posts";
    return EBlogPostFrom2;
})(EBlogPostFrom || {});
var EBlogSettingsFlags = /* @__PURE__ */ ((EBlogSettingsFlags2)=>{
    EBlogSettingsFlags2["IS_RSS_FEED_ENABLED"] = "is_rss_feed_enabled";
    EBlogSettingsFlags2["SHOW_POST_DONATION"] = "show_post_donations";
    EBlogSettingsFlags2["HAS_ADULT_CONTENT"] = "has_adult_content";
    return EBlogSettingsFlags2;
})(EBlogSettingsFlags || {});
var EBrowserFamily = /* @__PURE__ */ ((EBrowserFamily2)=>{
    EBrowserFamily2["IE"] = "IE";
    EBrowserFamily2["CHROME"] = "Chrome";
    EBrowserFamily2["SAFARI"] = "Safari";
    EBrowserFamily2["FIREFOX"] = "Firefox";
    return EBrowserFamily2;
})(EBrowserFamily || {});
var EChatAccessLevel = /* @__PURE__ */ ((EChatAccessLevel2)=>{
    EChatAccessLevel2["ANY"] = "any";
    EChatAccessLevel2["SUBSCRIBERS"] = "subscribers";
    EChatAccessLevel2["PAID_SUBSCRIBERS"] = "paid_subscribers";
    return EChatAccessLevel2;
})(EChatAccessLevel || {});
var EChatLinkUsageType = /* @__PURE__ */ ((EChatLinkUsageType2)=>{
    EChatLinkUsageType2["ALL"] = "all";
    EChatLinkUsageType2["NOBODY"] = "nobody";
    EChatLinkUsageType2["OWNER"] = "owner";
    return EChatLinkUsageType2;
})(EChatLinkUsageType || {});
var EChatMessageTextSize = /* @__PURE__ */ ((EChatMessageTextSize2)=>{
    EChatMessageTextSize2["SMALL"] = "12";
    EChatMessageTextSize2["NORMAL"] = "13";
    EChatMessageTextSize2["BIG"] = "15";
    EChatMessageTextSize2["EXTRA_BIG"] = "17";
    EChatMessageTextSize2["LARGE"] = "20";
    return EChatMessageTextSize2;
})(EChatMessageTextSize || {});
var EChatMode = /* @__PURE__ */ ((EChatMode2)=>{
    EChatMode2["CHAT"] = "chat";
    EChatMode2["MENTIONS"] = "mentions";
    EChatMode2["USERS"] = "users";
    EChatMode2["PLAYLIST"] = "playlist";
    return EChatMode2;
})(EChatMode || {});
var EChatPauseType = /* @__PURE__ */ ((EChatPauseType2)=>{
    EChatPauseType2["SCROLL"] = "scroll";
    EChatPauseType2["MOUSEOVER"] = "mouseover";
    EChatPauseType2["ALT"] = "alt";
    EChatPauseType2["MOUSEOVER_ALT"] = "mouseover_alt";
    return EChatPauseType2;
})(EChatPauseType || {});
var EPinnedMessageKind = /* @__PURE__ */ ((EPinnedMessageKind2)=>{
    EPinnedMessageKind2["PERMANENT"] = "permanent";
    EPinnedMessageKind2["TEMPORARY"] = "temporary";
    EPinnedMessageKind2["STREAM"] = "stream";
    return EPinnedMessageKind2;
})(EPinnedMessageKind || {});
var EChatModule = /* @__PURE__ */ ((EChatModule2)=>{
    EChatModule2["STREAM"] = "stream";
    EChatModule2["MENTIONS"] = "mentions";
    EChatModule2["HISTORY"] = "history";
    EChatModule2["RECORD"] = "record";
    return EChatModule2;
})(EChatModule || {});
var EChatAction = /* @__PURE__ */ ((EChatAction2)=>{
    EChatAction2["THREAD"] = "thread";
    EChatAction2["REPLY"] = "reply";
    EChatAction2["DELETE_SINGLE_MESSAGE"] = "deleteSingleMessage";
    EChatAction2["DELETE_ALL_USER_MESSAGES"] = "deleteAllUserMessages";
    EChatAction2["PIN"] = "pin";
    EChatAction2["BAN_INFO"] = "banInfo";
    EChatAction2["COPY"] = "copy";
    EChatAction2["TIMEOUT"] = "timeout";
    EChatAction2["BAN"] = "ban";
    EChatAction2["MODERATION"] = "moderation";
    return EChatAction2;
})(EChatAction || {});
var EChatHoverAction = /* @__PURE__ */ ((EChatHoverAction2)=>{
    EChatHoverAction2["THREAD"] = "thread";
    EChatHoverAction2["DELETE_SINGLE_MESSAGE"] = "deleteSingleMessage";
    EChatHoverAction2["REPLY"] = "reply";
    return EChatHoverAction2;
})(EChatHoverAction || {});
var EConditionalFeature = /* @__PURE__ */ ((EConditionalFeature2)=>{
    EConditionalFeature2["ANALYTICS"] = "ANALYTICS";
    EConditionalFeature2["BECOME_STREAMER_ON_SITE"] = "BECOME_STREAMER_ON_SITE";
    EConditionalFeature2["BROWSER_NOTIFICATIONS"] = "BROWSER_NOTIFICATIONS";
    EConditionalFeature2["COMMUNITY_INFORMERS"] = "COMMUNITY_INFORMERS";
    EConditionalFeature2["DROP_CAMPAIGNS"] = "DROP_CAMPAIGNS";
    EConditionalFeature2["PAYMENT_YANDEX"] = "PAYMENT_YANDEX";
    EConditionalFeature2["PAYMENT_QIWI"] = "PAYMENT_QIWI";
    EConditionalFeature2["PAYMENT_PAYPAL"] = "PAYMENT_PAYPAL";
    EConditionalFeature2["PAYMENT_CARD_BANK131"] = "PAYMENT_CARD_BANK131";
    EConditionalFeature2["PAYMENT_CARD_GLOBAL"] = "PAYMENT_CARD_GLOBAL";
    EConditionalFeature2["PAYOUT_CARD_EUR"] = "PAYOUT_CARD_EUR";
    EConditionalFeature2["PAYOUT_CARD_UAH"] = "PAYOUT_CARD_UAH";
    EConditionalFeature2["PAYOUT_CARD_USD"] = "PAYOUT_CARD_USD";
    EConditionalFeature2["PAYMENT_APPLE_PAY"] = "PAYMENT_APPLE_PAY";
    EConditionalFeature2["MAIN_PAGE_NEWEST_CATEGORIES"] = "MAIN_PAGE_NEWEST_CATEGORIES";
    EConditionalFeature2["MAIN_PAGE_FOLLOWED_CATEGORIES"] = "MAIN_PAGE_FOLLOWED_CATEGORIES";
    EConditionalFeature2["MAIN_PAGE_COZY_STREAMS"] = "MAIN_PAGE_COZY_STREAMS";
    EConditionalFeature2["MAIN_PAGE_OFTEN_STREAMS"] = "MAIN_PAGE_OFTEN_STREAMS";
    EConditionalFeature2["MAIN_PAGE_RECORDED_STREAMS"] = "MAIN_PAGE_RECORDED_STREAMS";
    EConditionalFeature2["MAIN_PAGE_VISITED_STREAMS"] = "MAIN_PAGE_VISITED_STREAMS";
    EConditionalFeature2["INVITES"] = "INVITES";
    EConditionalFeature2["MULTI_CURRENCY"] = "MULTI_CURRENCY";
    EConditionalFeature2["BOOSTY_LINK"] = "BOOSTY_LINK";
    EConditionalFeature2["SMILES_AND_BADGES_SETTINGS"] = "SMILES_AND_BADGES_SETTINGS";
    EConditionalFeature2["SMILES_AND_BADGES_USAGE_DISABLE"] = "SMILES_AND_BADGES_USAGE_DISABLE";
    EConditionalFeature2["SMILES_IN_COMMENTS"] = "SMILES_IN_COMMENTS";
    EConditionalFeature2["VK_PLAYER_LIVE_CATCH_UP"] = "VK_PLAYER_LIVE_CATCH_UP";
    EConditionalFeature2["VK_PLAYER_ADS_STREAMS"] = "VK_PLAYER_ADS_STREAMS";
    EConditionalFeature2["VK_PLAYER_ADS_RECORDS"] = "VK_PLAYER_ADS_RECORDS";
    EConditionalFeature2["VK_PLAYER_ADS_EMBED"] = "VK_PLAYER_ADS_EMBED";
    EConditionalFeature2["VK_PLAYER_ADS_MOBILE"] = "VK_PLAYER_ADS_MOBILE";
    EConditionalFeature2["VK_PLAYER_ADS_CLIP"] = "VK_PLAYER_ADS_CLIP";
    EConditionalFeature2["VK_PLAYER_ADS_PREVIEW_PARAM"] = "VK_PLAYER_ADS_PREVIEW_PARAM";
    EConditionalFeature2["PLAYBACK_POSITION_SAVING"] = "PLAYBACK_POSITION_SAVING";
    EConditionalFeature2["STREAM_RECORD"] = "STREAM_RECORD";
    EConditionalFeature2["STREAM_RAID"] = "STREAM_RAID";
    EConditionalFeature2["CHAT_PINNED_MESSAGES"] = "CHAT_PINNED_MESSAGES";
    EConditionalFeature2["OFFLINE_CHANNEL_COVER"] = "OFFLINE_CHANNEL_COVER";
    EConditionalFeature2["PUBLIC_STREAM_ADULT_CONTENT"] = "PUBLIC_STREAM_ADULT_CONTENT";
    EConditionalFeature2["PUBLIC_STREAM_SELF_HIDDEN"] = "PUBLIC_STREAM_SELF_HIDDEN";
    EConditionalFeature2["STREAM_QUICK_ACTIONS"] = "STREAM_QUICK_ACTIONS";
    EConditionalFeature2["RECOMMENDED"] = "RECOMMENDED";
    EConditionalFeature2["CHAT_USERS_LIST"] = "CHAT_USERS_LIST";
    EConditionalFeature2["CHAT_USER_STAT"] = "CHAT_USER_STAT";
    EConditionalFeature2["CHAT_PAUSE"] = "CHAT_PAUSE";
    EConditionalFeature2["EMBED_SUBSCRIBE_VIEWERS_CHANNEL"] = "EMBED_SUBSCRIBE_VIEWERS_CHANNEL";
    EConditionalFeature2["EMBED_SUBSCRIBE_VIEWERS_DISABLED_SUPPORT_PROGRAM"] = "EMBED_SUBSCRIBE_VIEWERS_DISABLED_SUPPORT_PROGRAM";
    EConditionalFeature2["EMBED_RANDOM_SUBSCRIBE_VIEWERS_CHANNEL"] = "EMBED_RANDOM_SUBSCRIBE_VIEWERS_CHANNEL";
    EConditionalFeature2["EMBED_CATALOG_AUTOPLAY"] = "EMBED_CATALOG_AUTOPLAY";
    EConditionalFeature2["CHAT_MESSAGES_BATCHING"] = "CHAT_MESSAGES_BATCHING";
    EConditionalFeature2["CHAT_STORE_LIMIT"] = "CHAT_STORE_LIMIT";
    EConditionalFeature2["CHAT_USER_COLOR_CONFIG"] = "CHAT_USER_COLOR_CONFIG";
    EConditionalFeature2["CHAT_USER_MENTION"] = "CHAT_USER_MENTION";
    EConditionalFeature2["AUTH_THIRD_PARTY"] = "AUTH_THIRD_PARTY";
    EConditionalFeature2["FEEDBACK_LOADER"] = "FEEDBACK_LOADER";
    EConditionalFeature2["CHAT_MODERATION_PANEL"] = "CHAT_MODERATION_PANEL";
    EConditionalFeature2["CHAT_CONTROLS_ON_CLICK"] = "CHAT_CONTROLS_ON_CLICK";
    EConditionalFeature2["CHAT_SLOWMODE_SETTINGS"] = "CHAT_SLOWMODE_SETTINGS";
    EConditionalFeature2["CHAT_MENTIONS"] = "CHAT_MENTIONS";
    EConditionalFeature2["NATIVE_APP_BANNER"] = "NATIVE_APP_BANNER";
    EConditionalFeature2["RATING_PROGRAM"] = "RATING_PROGRAM";
    EConditionalFeature2["SMILE_SUGGEST_WITHOUT_MAXIMAL_LIMIT"] = "SMILE_SUGGEST_WITHOUT_MAXIMAL_LIMIT";
    EConditionalFeature2["SMILE_SUGGEST"] = "SMILE_SUGGEST";
    EConditionalFeature2["SMILE_SUGGEST_NAVIGATION"] = "SMILE_SUGGEST_NAVIGATION";
    EConditionalFeature2["SUPPORT_PROGRAM"] = "SUPPORT_PROGRAM";
    EConditionalFeature2["CHAT_SETTINGS"] = "CHAT_SETTINGS";
    EConditionalFeature2["POINTS_APP_DEEPLINK"] = "POINTS_APP_DEEPLINK";
    EConditionalFeature2["DISCORD"] = "DISCORD";
    EConditionalFeature2["TELEGRAM"] = "TELEGRAM";
    EConditionalFeature2["HIDE_CHAT_USER_AVATAR"] = "HIDE_CHAT_USER_AVATAR";
    EConditionalFeature2["VIDEO_CLIP"] = "VIDEO_CLIP";
    EConditionalFeature2["VIDEO_CLIP_FROM_RECORD"] = "VIDEO_CLIP_FROM_RECORD";
    EConditionalFeature2["VIDEO_CLIP_FROM_STREAM"] = "VIDEO_CLIP_FROM_STREAM";
    EConditionalFeature2["VIDEO_COVER"] = "VIDEO_COVER";
    EConditionalFeature2["FOLLOW_CATEGORY"] = "FOLLOW_CATEGORY";
    EConditionalFeature2["BIND_CARD_CURRENCY_SELECTION"] = "BIND_CARD_CURRENCY_SELECTION";
    EConditionalFeature2["USER_GENERATED_POLLS"] = "USER_GENERATED_POLLS";
    EConditionalFeature2["CHANNEL_ROLES"] = "CHANNEL_ROLES";
    EConditionalFeature2["CHANNEL_POINTS"] = "CHANNEL_POINTS";
    EConditionalFeature2["REWARD_PREVIEW"] = "REWARD_PREVIEW";
    EConditionalFeature2["RECORDS_ACCESS"] = "RECORDS_ACCESS";
    EConditionalFeature2["NEW_BOOSTY_LINKING"] = "NEW_BOOSTY_LINKING";
    EConditionalFeature2["CHATBOT_SETTINGS"] = "CHATBOT_SETTINGS";
    EConditionalFeature2["ACTIVITY_USER_STAT_POPUP"] = "ACTIVITY_USER_STAT_POPUP";
    EConditionalFeature2["SUBSCRIPTIONS_PAGE"] = "SUBSCRIPTIONS_PAGE";
    EConditionalFeature2["SUBSCRIPTION_GIFT"] = "SUBSCRIPTION_GIFT";
    EConditionalFeature2["CMAF_ENABLED"] = "CMAF_ENABLED";
    EConditionalFeature2["CMAF_LOW_LATENCY_ENABLED"] = "CMAF_LOW_LATENCY_ENABLED";
    EConditionalFeature2["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
    EConditionalFeature2["CONNECTED_APPS"] = "CONNECTED_APPS";
    EConditionalFeature2["SDK_CHAT_TABS"] = "SDK_CHAT_TABS";
    EConditionalFeature2["SDK_CHAT_FOOTER"] = "SDK_CHAT_FOOTER";
    EConditionalFeature2["VK_PLAYER_TIMELINE_PREVIEW"] = "VK_PLAYER_TIMELINE_PREVIEW";
    EConditionalFeature2["VK_ID_LINK"] = "VK_ID_LINK";
    EConditionalFeature2["THEME_SWITCHER"] = "THEME_SWITCHER";
    EConditionalFeature2["VK_PLAY_LINK"] = "VK_PLAY_LINK";
    EConditionalFeature2["VK_ID_AUTH"] = "VK_ID_AUTH";
    EConditionalFeature2["MULTI_CHANNEL"] = "MULTI_CHANNEL";
    EConditionalFeature2["MEDIASCOPE_ENABLED"] = "MEDIASCOPE_ENABLED";
    EConditionalFeature2["AUTH_LS_RECOVER_ENABLED"] = "AUTH_LS_RECOVER_ENABLED";
    EConditionalFeature2["HLS_URL_LATENCY"] = "HLS_URL_LATENCY";
    EConditionalFeature2["REDUX_DEV_TOOLS"] = "REDUX_DEV_TOOLS";
    EConditionalFeature2["REFRESH_REQUESTS_ON_AUTH"] = "REFRESH_REQUESTS_ON_AUTH";
    EConditionalFeature2["CATEGORY_FILTER_SPORT"] = "CATEGORY_FILTER_SPORT";
    EConditionalFeature2["MULTI_STREAM"] = "MULTI_STREAM";
    EConditionalFeature2["STREAM_END_REDIRECT_ENABLED"] = "STREAM_END_REDIRECT_ENABLED";
    EConditionalFeature2["PLAYER_ROUNDING_DISABLED"] = "PLAYER_ROUNDING_DISABLED";
    return EConditionalFeature2;
})(EConditionalFeature || {});
var EConfigOffer = /* @__PURE__ */ ((EConfigOffer2)=>{
    EConfigOffer2["PRIVACY_POLICY"] = "privacyPolicy";
    EConfigOffer2["SUPPORT_PROGRAM_OFFER"] = "supportProgramOffer";
    EConfigOffer2["USER_AGREEMENT"] = "userAgreement";
    return EConfigOffer2;
})(EConfigOffer || {});
var ECookieKey = /* @__PURE__ */ ((ECookieKey2)=>{
    ECookieKey2["CLIENT_ID"] = "_clientId";
    ECookieKey2["AUTH"] = "auth";
    ECookieKey2["INVITE"] = "invite";
    ECookieKey2["NEW_USER"] = "newUser";
    ECookieKey2["LOCALE"] = "locale";
    ECookieKey2["THEME"] = "theme";
    ECookieKey2["GDPR"] = "gdpr";
    ECookieKey2["ONE_LINK_LOGIN"] = "1ltr";
    ECookieKey2["ONE_LINK_REGISTRATION_USER"] = "1ltr_reg";
    ECookieKey2["ONE_LINK_REGISTRATION_BLOGGER"] = "1ltr_reg_bl";
    ECookieKey2["LAST_ACCOUNT"] = "last_acc";
    ECookieKey2["DIALOGUE_LIST_SORT"] = "dialogue_list_sort";
    ECookieKey2["CONTACT_LIST_SORT"] = "contact_list_sort";
    ECookieKey2["MAILING_LIST_SORT"] = "mailing_list_sort";
    ECookieKey2["SKIP_GRANTS"] = "skip_grants";
    ECookieKey2["CHAT_SETTINGS"] = "chat_settings";
    ECookieKey2["ACTIVITY_FILTERS"] = "activityFilters";
    ECookieKey2["NO_SSR"] = "no_ssr";
    ECookieKey2["MODERATION_LOG_FILTERS"] = "moderationLogFilters";
    ECookieKey2["BREAK_PARAMS"] = "break_params";
    ECookieKey2["BROWSER_NOTIFICATION_REFRESH_EXPIRED"] = "browser_notification_refresh_expired";
    ECookieKey2["EFFECTIVE_USER_ID"] = "effective_user_id";
    ECookieKey2["EMAIL_CONFIRMATION"] = "email_confirmation";
    return ECookieKey2;
})(ECookieKey || {});
var ECurrency = /* @__PURE__ */ ((ECurrency2)=>{
    ECurrency2["RUB"] = "RUB";
    ECurrency2["EUR"] = "EUR";
    ECurrency2["USD"] = "USD";
    ECurrency2["UAH"] = "UAH";
    return ECurrency2;
})(ECurrency || {});
var ECurrentUserAccessRight = /* @__PURE__ */ ((ECurrentUserAccessRight2)=>{
    ECurrentUserAccessRight2["EDIT_OWN_BLOG_SETTINGS"] = "canEditOwnBlogSettings";
    ECurrentUserAccessRight2["EDIT_OWN_BLOG_POSTS"] = "canEditOwnBlogPosts";
    ECurrentUserAccessRight2["EDIT_OWN_BLOG_ABOUT_AUTHOR"] = "canEditOwnBlogAboutAuthor";
    ECurrentUserAccessRight2["VIEW_BLOG"] = "canViewBlog";
    ECurrentUserAccessRight2["REPORT_BLOG"] = "canReportBlog";
    ECurrentUserAccessRight2["FOLLOW_BLOG"] = "canFollowBlog";
    ECurrentUserAccessRight2["PUBLISH_POST"] = "canPublishPost";
    ECurrentUserAccessRight2["EDIT_POST_SETTINGS"] = "canEditPostSettings";
    ECurrentUserAccessRight2["VIEW_POST"] = "canViewPost";
    ECurrentUserAccessRight2["LIKE_POST"] = "canLikePost";
    ECurrentUserAccessRight2["REACTION_POST"] = "canReactionPost";
    ECurrentUserAccessRight2["REPORT_POST"] = "canReportPost";
    ECurrentUserAccessRight2["PUBLISH_COMMENT"] = "canPublishComment";
    ECurrentUserAccessRight2["REACTION_COMMENT"] = "canReactionComment";
    ECurrentUserAccessRight2["REPLY_COMMENT"] = "canReplyComment";
    ECurrentUserAccessRight2["REPORT_COMMENT"] = "canReportComment";
    ECurrentUserAccessRight2["REMOVE_COMMENT"] = "canRemoveComment";
    ECurrentUserAccessRight2["EDIT_COMMENT"] = "canEditComment";
    ECurrentUserAccessRight2["BLOCK_COMMENT_AUTHOR"] = "canBlockCommentAuthor";
    ECurrentUserAccessRight2["MODERATE_CHANNEL"] = "canModerateChannel";
    ECurrentUserAccessRight2["CHANGE_CHANNEL"] = "canChangeChannel";
    ECurrentUserAccessRight2["MODERATE_SOME_CHANNEL"] = "canModerateSomeChannel";
    ECurrentUserAccessRight2["ADMINISTRATE_CHANNEL"] = "canAdministrateChannel";
    ECurrentUserAccessRight2["MODERATE_CHAT_CHANNEL"] = "canModerateChatChannel";
    return ECurrentUserAccessRight2;
})(ECurrentUserAccessRight || {});
var ECurrentUserAccessRole = /* @__PURE__ */ ((ECurrentUserAccessRole2)=>{
    ECurrentUserAccessRole2["ADMIN"] = "isAdmin";
    ECurrentUserAccessRole2["BANNED"] = "isBanned";
    ECurrentUserAccessRole2["BANNED_COMPLETELY"] = "isBannedCompletely";
    ECurrentUserAccessRole2["BLOG_OWNER"] = "isBlogOwner";
    ECurrentUserAccessRole2["CHANNEL_OWNER"] = "isChannelOwner";
    ECurrentUserAccessRole2["BLOG_OWNER_AGENT"] = "isBlogOwnerAgent";
    ECurrentUserAccessRole2["EXTERNAL_BLOG_OWNER"] = "isExternalBlogOwner";
    ECurrentUserAccessRole2["COMMENT_AUTHOR"] = "isCommentAuthor";
    ECurrentUserAccessRole2["CRM_MANAGER"] = "isCrmManager";
    ECurrentUserAccessRole2["MODERATOR"] = "isModerator";
    ECurrentUserAccessRole2["SMILE_OWNER"] = "isSmileOwner";
    ECurrentUserAccessRole2["STREAM_OWNER"] = "isStreamOwner";
    ECurrentUserAccessRole2["CHAT_MODERATOR"] = "isChatModerator";
    ECurrentUserAccessRole2["CHANNEL_ADMIN"] = "isChannelAdmin";
    ECurrentUserAccessRole2["CHANNEL_MODERATOR"] = "isChannelModerator";
    ECurrentUserAccessRole2["CHANNEL_CHAT_MODERATOR"] = "isChannelChatModerator";
    ECurrentUserAccessRole2["STREAMER"] = "isStreamer";
    return ECurrentUserAccessRole2;
})(ECurrentUserAccessRole || {});
var ECurrentUserFlag = /* @__PURE__ */ ((ECurrentUserFlag2)=>{
    ECurrentUserFlag2["CAN_VIEW_ADULT_CONTENT"] = "canViewAdultContent";
    ECurrentUserFlag2["HAS_TEASER_HELPER"] = "hasTeaserHelper";
    ECurrentUserFlag2["HAS_STREAM_HELPER"] = "hasStreamHelper";
    ECurrentUserFlag2["GDPR"] = "GDPR";
    ECurrentUserFlag2["HAS_BLOG_POST_DRAFT_HELPER"] = "hasBlogPostDraftHelper";
    ECurrentUserFlag2["HAS_BLOG_POST_SELECTOR_HELPER"] = "hasBlogPostSelectorHelper";
    ECurrentUserFlag2["HAS_ACCEPTED_COMMON_SETTINGS"] = "hasAcceptedCommonSettings";
    ECurrentUserFlag2["HAS_MESSAGE_HEADER_HELPER"] = "hasMessageHeaderHelper";
    ECurrentUserFlag2["HAS_MESSAGE_BUTTON_HELPER"] = "hasMessageButtonHelper";
    ECurrentUserFlag2["IS_TIP_DONATIONS_HELPER_SEEN"] = "isTipDonationHelperSeen";
    ECurrentUserFlag2["IS_SHARE_DONATION_HELPER_SEEN"] = "isShareDonationHelperSeen";
    ECurrentUserFlag2["HAS_RECORD_HELPER"] = "hasRecordHelper";
    ECurrentUserFlag2["HAS_DIALOG_SETTINGS_PROMO"] = "hasDialogSettingsPromo";
    ECurrentUserFlag2["IS_SHOWED_RECORD_HELP"] = "isShowedRecordHelp";
    ECurrentUserFlag2["IS_ADD_PHONE_HELPER_SEEN"] = "isAddPhoneHelperSeen";
    ECurrentUserFlag2["HAS_RECOMMENDATION_TECHNOLOGIES_ALERT"] = "hasRecommendationTechnologiesAlert";
    ECurrentUserFlag2["HAS_WEBPUSH_PROMPT"] = "hasWebpushPrompt";
    ECurrentUserFlag2["IS_VK_LINK_POPUP_SHOWED"] = "isVKLinkPopupShowed";
    ECurrentUserFlag2["IS_CHANNEL_POLL_ADDITIONAL_VOTE_CONFIRM"] = "isChannelPollAdditionalVoteConfirm";
    return ECurrentUserFlag2;
})(ECurrentUserFlag || {});
var EBlogUrlStrategyPart = /* @__PURE__ */ ((EBlogUrlStrategyPart2)=>{
    EBlogUrlStrategyPart2["URL"] = "url";
    EBlogUrlStrategyPart2["BLOG"] = "blog";
    EBlogUrlStrategyPart2["EXTERNAL_BLOG"] = "externalBlog";
    EBlogUrlStrategyPart2["GLOBAL_STORAGE"] = "globalStorage";
    return EBlogUrlStrategyPart2;
})(EBlogUrlStrategyPart || {});
var EDonationType = /* @__PURE__ */ ((EDonationType2)=>{
    EDonationType2["POST"] = "post";
    EDonationType2["TARGET"] = "target";
    EDonationType2["AUTHOR"] = "author";
    EDonationType2["DIALOG"] = "dialog";
    return EDonationType2;
})(EDonationType || {});
var EDropCampaignRuleRequest = /* @__PURE__ */ ((EDropCampaignRuleRequest2)=>{
    EDropCampaignRuleRequest2["DONE"] = "done";
    EDropCampaignRuleRequest2["NEW"] = "new";
    EDropCampaignRuleRequest2["SEND_ERROR"] = "send_error";
    return EDropCampaignRuleRequest2;
})(EDropCampaignRuleRequest || {});
var EDropCampaignRulesMode = /* @__PURE__ */ ((EDropCampaignRulesMode2)=>{
    EDropCampaignRulesMode2["LOOP"] = "loop";
    EDropCampaignRulesMode2["LOOP_LAST"] = "loop_last";
    EDropCampaignRulesMode2["ONE_TIME"] = "one_time";
    return EDropCampaignRulesMode2;
})(EDropCampaignRulesMode || {});
var EElementPosition = /* @__PURE__ */ ((EElementPosition2)=>{
    EElementPosition2[EElementPosition2["TOP"] = 0] = "TOP";
    EElementPosition2[EElementPosition2["BOTTOM"] = 1] = "BOTTOM";
    EElementPosition2[EElementPosition2["LEFT"] = 2] = "LEFT";
    EElementPosition2[EElementPosition2["RIGHT"] = 3] = "RIGHT";
    return EElementPosition2;
})(EElementPosition || {});
var EExternalAppPaths = /* @__PURE__ */ ((EExternalAppPaths2)=>{
    EExternalAppPaths2["TELEGRAM"] = "tg";
    EExternalAppPaths2["DISCORD"] = "discord";
    return EExternalAppPaths2;
})(EExternalAppPaths || {});
var EExternalNotificationType = /* @__PURE__ */ ((EExternalNotificationType2)=>{
    EExternalNotificationType2["SUBSCRIBER"] = "newSubscriber";
    EExternalNotificationType2["MESSAGE"] = "newMessage";
    EExternalNotificationType2["COMMENT"] = "newComment";
    EExternalNotificationType2["NEWS"] = "otherNews";
    EExternalNotificationType2["REPLY"] = "newReply";
    EExternalNotificationType2["STREAM"] = "newStream";
    EExternalNotificationType2["POST"] = "newPost";
    EExternalNotificationType2["NEW_TARGET"] = "newTarget";
    EExternalNotificationType2["NEW_REFERRAL_REGISTRATION"] = "newReferal";
    EExternalNotificationType2["REFERRAL_IS_BLOGGER"] = "newReferalBlogger";
    EExternalNotificationType2["DONATION"] = "newDonation";
    EExternalNotificationType2["POST_PURCHASE"] = "buyPost";
    EExternalNotificationType2["MESSAGE_PURCHASE"] = "buyMessage";
    EExternalNotificationType2["NEW_PROMO"] = "newPromo";
    return EExternalNotificationType2;
})(EExternalNotificationType || {});
var EFileSizeUnit = /* @__PURE__ */ ((EFileSizeUnit2)=>{
    EFileSizeUnit2["B"] = "Byte";
    EFileSizeUnit2["KB"] = "Kb";
    EFileSizeUnit2["MB"] = "Mb";
    EFileSizeUnit2["GB"] = "Gb";
    return EFileSizeUnit2;
})(EFileSizeUnit || {});
var EFloatingItemPlacement = /* @__PURE__ */ ((EFloatingItemPlacement2)=>{
    EFloatingItemPlacement2["TOP"] = "top";
    EFloatingItemPlacement2["RIGHT"] = "right";
    EFloatingItemPlacement2["LEFT"] = "left";
    EFloatingItemPlacement2["BOTTOM"] = "bottom";
    EFloatingItemPlacement2["TOP_START"] = "top-start";
    EFloatingItemPlacement2["TOP_END"] = "top-end";
    EFloatingItemPlacement2["RIGHT_START"] = "right-start";
    EFloatingItemPlacement2["RIGHT_END"] = "right-end";
    EFloatingItemPlacement2["BOTTOM_START"] = "bottom-start";
    EFloatingItemPlacement2["BOTTOM_END"] = "bottom-end";
    EFloatingItemPlacement2["LEFT_START"] = "left-start";
    EFloatingItemPlacement2["LEFT_END"] = "left-end";
    return EFloatingItemPlacement2;
})(EFloatingItemPlacement || {});
var EFormAutocomplete = /* @__PURE__ */ ((EFormAutocomplete2)=>{
    EFormAutocomplete2["OFF"] = "off";
    EFormAutocomplete2["ON"] = "on";
    return EFormAutocomplete2;
})(EFormAutocomplete || {});
var EHostStatusState = /* @__PURE__ */ ((EHostStatusState2)=>{
    EHostStatusState2["ALREADY_HOST"] = "already_host";
    EHostStatusState2["HOSTER_ONLINE"] = "hoster_online";
    EHostStatusState2["FREE"] = "free";
    return EHostStatusState2;
})(EHostStatusState || {});
var EImageUploaderError = /* @__PURE__ */ ((EImageUploaderError2)=>{
    EImageUploaderError2["IMAGE_SIZE_LIMIT"] = "FILE_SIZE_LIMIT";
    EImageUploaderError2["IMAGE_WIDTH_LIMIT"] = "IMAGE_WEIGHT_LIMIT";
    EImageUploaderError2["IMAGE_RESOLUTION_LIMIT"] = "IMAGE_RESOLUTION_LIMIT";
    EImageUploaderError2["INVALID_FORMAT"] = "INVALID_FORMAT";
    EImageUploaderError2["NETWORK_ERROR"] = "NETWORK_ERROR";
    EImageUploaderError2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    return EImageUploaderError2;
})(EImageUploaderError || {});
var EKeyboardKey = /* @__PURE__ */ ((EKeyboardKey2)=>{
    EKeyboardKey2["SPACE"] = " ";
    EKeyboardKey2["ESCAPE"] = "Escape";
    EKeyboardKey2["ENTER"] = "Enter";
    EKeyboardKey2["BACKSPACE"] = "Backspace";
    EKeyboardKey2["DELETE"] = "Delete";
    EKeyboardKey2["TAB"] = "Tab";
    EKeyboardKey2["ARROW_LEFT"] = "ArrowLeft";
    EKeyboardKey2["ARROW_RIGHT"] = "ArrowRight";
    EKeyboardKey2["ARROW_UP"] = "ArrowUp";
    EKeyboardKey2["ARROW_DOWN"] = "ArrowDown";
    EKeyboardKey2["ALT"] = "Alt";
    return EKeyboardKey2;
})(EKeyboardKey || {});
var EKeyboardModifierKey = /* @__PURE__ */ ((EKeyboardModifierKey2)=>{
    EKeyboardModifierKey2["ALT"] = "Alt";
    EKeyboardModifierKey2["ALT_GRAPH"] = "AltGraph";
    EKeyboardModifierKey2["CAPS_LOCK"] = "CapsLock";
    EKeyboardModifierKey2["CONTROL"] = "Control";
    EKeyboardModifierKey2["FN"] = "Fn";
    EKeyboardModifierKey2["FN_LOCK"] = "FnLock";
    EKeyboardModifierKey2["HYPER"] = "Hyper";
    EKeyboardModifierKey2["META"] = "Meta";
    EKeyboardModifierKey2["NUM_LOCK"] = "NumLock";
    EKeyboardModifierKey2["OS"] = "OS";
    EKeyboardModifierKey2["SCROLL_LOCK"] = "ScrollLock";
    EKeyboardModifierKey2["SHIFT"] = "Shift";
    EKeyboardModifierKey2["SUPER"] = "Super";
    EKeyboardModifierKey2["SYMBOL"] = "Symbol";
    EKeyboardModifierKey2["SYMBOL_LOCK"] = "SymbolLock";
    return EKeyboardModifierKey2;
})(EKeyboardModifierKey || {});
var ELocale = /* @__PURE__ */ ((ELocale2)=>{
    ELocale2["RU"] = "ru_RU";
    ELocale2["EN"] = "en_US";
    return ELocale2;
})(ELocale || {});
var ELocalStorageKey = /* @__PURE__ */ ((ELocalStorageKey2)=>{
    ELocalStorageKey2["AUTH"] = "auth";
    ELocalStorageKey2["BANNERS"] = "banners";
    ELocalStorageKey2["CLIENT_ID"] = "_clientId";
    ELocalStorageKey2["THEME"] = "theme";
    ELocalStorageKey2["LIKE_TOP_COORDS"] = "LIKE_TOP_COORDS";
    ELocalStorageKey2["APP_LAYOUT_CHAT_STATE"] = "APP_LAYOUT_CHAT_STATE";
    ELocalStorageKey2["APP_LAYOUT_LEFT_MENU_STATE"] = "APP_LAYOUT_LEFT_MENU_STATE";
    ELocalStorageKey2["PUBLISHER_TEXT_BEFORE_CARET"] = "publisherTextBeforeCaret";
    ELocalStorageKey2["CATALOG_ACTIVE_TAB_OF_GROUP_BLOCK"] = "CATALOG_ACTIVE_TAB_OF_GROUP_BLOCK_";
    ELocalStorageKey2["ANALYTICS_CHANNEL_INDICATOR_VALUE_VISIBILITY"] = "ANALYTICS_CHANNEL_INDICATOR_VALUE_VISIBILITY_";
    ELocalStorageKey2["APP_PLAYER_PREFER_VOLUME_MUTE"] = "appPlayerPreferVolumeMute";
    ELocalStorageKey2["PINNED_MESSAGE_SETTINGS"] = "pinnedMessageSettings";
    ELocalStorageKey2["SHOW_ADBLOCK_ALERT"] = "showAdBlockAlert";
    ELocalStorageKey2["CHAT_SLOWMODE_EXPIRATION_TIME"] = "chatSlowmodeExpirationTime";
    ELocalStorageKey2["CHAT_SLOWMODE_START_TIME"] = "chatSlowmodeStartTime";
    ELocalStorageKey2["STUDIO_CHAT_WIDTH"] = "studioChatWidth";
    ELocalStorageKey2["INDICATION_BOXES"] = "INDICATION_BOXES";
    ELocalStorageKey2["INDICATION_BROWSER_NOTIFICATIONS"] = "INDICATION_BROWSER_NOTIFICATIONS";
    return ELocalStorageKey2;
})(ELocalStorageKey || {});
var EMediaDataTextModificator = /* @__PURE__ */ ((EMediaDataTextModificator2)=>{
    EMediaDataTextModificator2["BLOCK_END"] = "BLOCK_END";
    return EMediaDataTextModificator2;
})(EMediaDataTextModificator || {});
var EMediaDataType = /* @__PURE__ */ ((EMediaDataType2)=>{
    EMediaDataType2["TEXT"] = "text";
    EMediaDataType2["IMAGE"] = "image";
    EMediaDataType2["VIDEO"] = "video";
    EMediaDataType2["VIDEO_FILE"] = "ok_video";
    EMediaDataType2["VIDEO_STREAM"] = "ok_stream";
    EMediaDataType2["FILE"] = "file";
    EMediaDataType2["AUDIO"] = "audio";
    EMediaDataType2["AUDIO_FILE"] = "audio_file";
    EMediaDataType2["LINK"] = "link";
    EMediaDataType2["MENTION"] = "mention";
    EMediaDataType2["SPACE"] = "space";
    EMediaDataType2["SMILE"] = "smile";
    return EMediaDataType2;
})(EMediaDataType || {});
var ENewUserHeader = /* @__PURE__ */ ((ENewUserHeader2)=>{
    ENewUserHeader2[ENewUserHeader2["AUTHORIZE"] = 0] = "AUTHORIZE";
    ENewUserHeader2[ENewUserHeader2["REGISTER"] = 1] = "REGISTER";
    ENewUserHeader2[ENewUserHeader2["RELINK"] = 2] = "RELINK";
    return ENewUserHeader2;
})(ENewUserHeader || {});
var ENotificationStandaloneType = /* @__PURE__ */ ((ENotificationStandaloneType2)=>{
    ENotificationStandaloneType2["COMMENT"] = "post_comment_new";
    ENotificationStandaloneType2["REPLY"] = "post_comment_new_reply";
    ENotificationStandaloneType2["POST"] = "post_new";
    ENotificationStandaloneType2["NEWS"] = "project_news";
    ENotificationStandaloneType2["STREAM"] = "video_stream_start";
    ENotificationStandaloneType2["PUBLIC_STREAM"] = "public_video_stream_start";
    return ENotificationStandaloneType2;
})(ENotificationStandaloneType || {});
var EPaymentBank131Status = /* @__PURE__ */ ((EPaymentBank131Status2)=>{
    EPaymentBank131Status2["CREATED"] = "created";
    EPaymentBank131Status2["IN_PROGRESS"] = "in_progress";
    EPaymentBank131Status2["ACCEPTED"] = "accepted";
    EPaymentBank131Status2["CANCELLED"] = "cancelled";
    EPaymentBank131Status2["ERROR"] = "error";
    return EPaymentBank131Status2;
})(EPaymentBank131Status || {});
var EPaymentMethod = /* @__PURE__ */ ((EPaymentMethod2)=>{
    EPaymentMethod2["CARD_BANK131"] = "card_bank131";
    EPaymentMethod2["CARD"] = "card";
    EPaymentMethod2["CARD_GLOBAL"] = "card_global";
    EPaymentMethod2["PAYPAL"] = "paypal";
    EPaymentMethod2["APPLE_PAY"] = "applepay";
    EPaymentMethod2["QIWI"] = "qiwi";
    EPaymentMethod2["YANDEX"] = "yandex";
    return EPaymentMethod2;
})(EPaymentMethod || {});
var EPaymentRejectReason = /* @__PURE__ */ ((EPaymentRejectReason2)=>{
    EPaymentRejectReason2["NEED_3DS"] = "need3ds";
    return EPaymentRejectReason2;
})(EPaymentRejectReason || {});
var EPaymentStatus = /* @__PURE__ */ ((EPaymentStatus2)=>{
    EPaymentStatus2["REDIRECT"] = "redirect";
    EPaymentStatus2["WAIT"] = "wait";
    EPaymentStatus2["NEED_DATA"] = "need_data";
    EPaymentStatus2["STOP"] = "stop";
    return EPaymentStatus2;
})(EPaymentStatus || {});
var EPaymentType = /* @__PURE__ */ ((EPaymentType2)=>{
    EPaymentType2["POST"] = "post";
    EPaymentType2["STREAM"] = "stream";
    EPaymentType2["MESSAGE"] = "message";
    EPaymentType2["DONATION"] = "donation";
    EPaymentType2["SUBSCRIPTION"] = "subscription";
    EPaymentType2["GIFT"] = "gift";
    return EPaymentType2;
})(EPaymentType || {});
var EPlaybackPositionType = /* @__PURE__ */ ((EPlaybackPositionType2)=>{
    EPlaybackPositionType2["RECORD"] = "RECORD";
    EPlaybackPositionType2["STREAM"] = "STREAM";
    return EPlaybackPositionType2;
})(EPlaybackPositionType || {});
var EPopup = /* @__PURE__ */ ((EPopup2)=>{
    EPopup2["EDIT_CUSTOM_BLOCK"] = "EDIT_CUSTOM_BLOCK";
    EPopup2["AUTH_SIGN_IN"] = "AUTH_SIGN_IN";
    EPopup2["BECOME_STREAMER"] = "BECOME_STREAMER";
    EPopup2["BECOME_STREAMER_ON_SITE"] = "BECOME_STREAMER_ON_SITE";
    EPopup2["CHANNELS"] = "CHANNELS";
    EPopup2["CONTACT_SUPPORT"] = "CONTACT_SUPPORT";
    EPopup2["MENU"] = "MENU";
    EPopup2["SUBSCRIPTION_LEVELS"] = "SUBSCRIPTION_LEVELS";
    EPopup2["ACCEPT_COMMON_SETTINGS"] = "ACCEPT_COMMON_SETTINGS";
    EPopup2["CUSTOM_BLOCKS_DELETE_APPROVE"] = "CUSTOM_BLOCKS_DELETE_APPROVE";
    EPopup2["TELEGRAM_CONNECTION"] = "TELEGRAM_CONNECTION";
    EPopup2["CONFIRM"] = "CONFIRM";
    EPopup2["UNBIND_CARD_ERROR"] = "UNBIND_CARD_ERROR";
    EPopup2["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    EPopup2["UNFOLLOW"] = "UNFOLLOW";
    EPopup2["SETTINGS_NEW_CARD"] = "SETTINGS_NEW_CARD";
    EPopup2["SHARE_HOST_CONFIRM_START_POPUP"] = "SHARE_HOST_CONFIRM_START_POPUP";
    EPopup2["SMILES_CREATE"] = "SMILES_CREATE";
    EPopup2["SMILES_EDIT"] = "SMILES_EDIT";
    EPopup2["BADGES_CREATE"] = "BADGES_CREATE";
    EPopup2["BADGES_EDIT"] = "BADGES_EDIT";
    EPopup2["NOTIFICATIONS"] = "NOTIFICATIONS";
    EPopup2["PAYMENT"] = "PAYMENT";
    EPopup2["RATING_PROGRAM_LEVEL_UP"] = "RATING_PROGRAM_LEVEL_UP";
    EPopup2["RATING_PROGRAM_SEASON_FINISHED"] = "RATING_PROGRAM_SEASON_FINISHED";
    EPopup2["SUPPORT_PROGRAM"] = "SUPPORT_PROGRAM";
    EPopup2["SUPPORT_PROGRAM_LEVEL_UP"] = "SUPPORT_PROGRAM_LEVEL_UP";
    EPopup2["SUPPORT_PROGRAM_FEEDBACK"] = "SUPPORT_PROGRAM_FEEDBACK";
    EPopup2["SUPPORT_PROGRAM_VERIFICATION_FEEDBACK"] = "SUPPORT_PROGRAM_VERIFICATION_FEEDBACK";
    EPopup2["SUPPORT_PROGRAM_PAYMENT"] = "SUPPORT_PROGRAM_PAYMENT";
    EPopup2["SUPPORT_PROGRAM_PAYOUT"] = "SUPPORT_PROGRAM_PAYOUT";
    EPopup2["SUPPORT_PROGRAM_CHECK_INN"] = "SUPPORT_PROGRAM_CHECK_INN";
    EPopup2["STREAM_HOSTING_POPUP"] = "STREAM_HOSTING_POPUP";
    EPopup2["SMILE_INFO"] = "SMILE_INFO";
    EPopup2["ROLES_CREATE"] = "ROLES_CREATE";
    EPopup2["ROLES_EDIT"] = "ROLES_EDIT";
    EPopup2["ROLES_ASSIGN"] = "ROLES_ASSIGN";
    EPopup2["RECORD_EDIT"] = "RECORD_EDIT";
    EPopup2["RECORD_DELETE"] = "RECORD_DELETE";
    EPopup2["VIDEO_CLIP_EDIT"] = "VIDEO_CLIP_EDIT";
    EPopup2["VIDEO_CLIP_DELETE"] = "VIDEO_CLIP_DELETE";
    EPopup2["HIDE_CHANNEL"] = "HIDE_CHANNEL";
    EPopup2["POINTS_EDITOR"] = "POINTS_EDITOR";
    EPopup2["MULTIPLICATORS"] = "MULTIPLICATORS";
    EPopup2["REWARD_CREATOR"] = "REWARD_CREATOR";
    EPopup2["REWARD_EDITOR"] = "REWARD_EDITOR";
    EPopup2["REWARD_DELETE_CONFIRM_POPUP"] = "REWARD_DELETE_CONFIRM_POPUP";
    EPopup2["PREDICTION_CREATOR"] = "PREDICTION_CREATOR";
    EPopup2["POLL_CREATOR"] = "POLL_CREATOR";
    EPopup2["NEWS"] = "NEWS";
    EPopup2["ACTION_RAID"] = "ACTION_RAID";
    EPopup2["ACTION_RAID_CONFIRM"] = "ACTION_RAID_CONFIRM";
    EPopup2["QR_CODE"] = "QR_CODE";
    EPopup2["SEND_GIFT"] = "SEND_GIFT";
    EPopup2["PLAYLIST_FORM"] = "PLAYLIST_FORM";
    EPopup2["PLAYLIST_ADD_VIDEO"] = "PLAYLIST_ADD_VIDEO";
    EPopup2["PLAYLIST_DELETE"] = "PLAYLIST_DELETE";
    EPopup2["PLAYLIST_HIDE"] = "PLAYLIST_HIDE";
    EPopup2["VIDEO_DELETE_FROM_PLAYLIST"] = "VIDEO_DELETE_FROM_PLAYLIST";
    EPopup2["CLEAR_CHAT"] = "CLEAR_CHAT";
    EPopup2["DISCONNECT_APP"] = "DISCONNECT_APP";
    EPopup2["ASSIGN_MODERATOR_ROLE"] = "ASSIGN_MODERATOR_ROLE";
    EPopup2["EDIT_MODERATOR_ROLE"] = "EDIT_MODERATOR_ROLE";
    EPopup2["CHANNEL_DESCRIPTION"] = "CHANNEL_DESCRIPTION";
    EPopup2["DROPS_VK_AUTH"] = "DROPS_VK_AUTH";
    EPopup2["DROPS_VKPLAY_LINK"] = "DROPS_VKPLAY_LINK";
    EPopup2["BROWSER_NOTIFICATION"] = "BROWSER_NOTIFICATION";
    EPopup2["DELETE_RECORD_FROM_PLAYLIST_AND_LIST"] = "DELETE_RECORD_FROM_PLAYLIST_AND_LIST";
    EPopup2["VK_COMMUNITIES_LIST"] = "VK_COMMUNITIES_LIST";
    EPopup2["VK_PLAY_MERGE_CONFIRMATION"] = "VK_PLAY_MERGE_CONFIRMATION";
    EPopup2["VK_PLAY_MERGE_PROMPT"] = "VK_PLAY_MERGE_PROMPT";
    EPopup2["VK_PLAY_MERGE_NO_VK_PLAY_LIVE_ERROR"] = "VK_PLAY_MERGE_NO_VK_PLAY_LIVE_ERROR";
    EPopup2["VK_PLAY_MERGE_VK_ID_CONFLICT_ERROR"] = "VK_PLAY_MERGE_VK_ID_CONFLICT_ERROR";
    EPopup2["VKPLAY_LINK_DELETE_APPROVE"] = "VKPLAY_LINK_DELETE_APPROVE";
    EPopup2["STREAM_SLOT_DELETE"] = "STREAM_SLOT_DELETE";
    EPopup2["STREAM_SLOT_EDIT_CANCEL"] = "STREAM_SLOT_EDIT_CANCEL";
    EPopup2["USER_EMAIL"] = "USER_EMAIL";
    EPopup2["BLACK_LIST"] = "BLACK_LIST";
    EPopup2["OAUTH_INVALID_REQUEST"] = "OAUTH_INVALID_REQUEST";
    return EPopup2;
})(EPopup || {});
var EPortal = /* @__PURE__ */ ((EPortal2)=>{
    EPortal2["ANALYTICS_HEADER"] = "analyticsHeader";
    EPortal2["FLOATING_TOOLTIP"] = "floating-tooltip";
    EPortal2["MODAL"] = "modal";
    EPortal2["PREDICTION_MODAL"] = "predictionModalPortal";
    EPortal2["CHANNEL_POLL_MODAL"] = "channelPollModalPortal";
    EPortal2["TOOLTIP"] = "tooltip";
    EPortal2["VIDEO_CLIP_EDITOR"] = "videoClipEditorPortal";
    EPortal2["VIDEO_CLIP_SUCCESS"] = "videoClipSuccessPortal";
    return EPortal2;
})(EPortal || {});
var EPublishCommentStatus = /* @__PURE__ */ ((EPublishCommentStatus2)=>{
    EPublishCommentStatus2["LOADING"] = "LOADING";
    EPublishCommentStatus2["ERROR"] = "ERROR";
    EPublishCommentStatus2["SUCCESS"] = "SUCCESS";
    return EPublishCommentStatus2;
})(EPublishCommentStatus || {});
var ERaidStatus = /* @__PURE__ */ ((ERaidStatus2)=>{
    ERaidStatus2["PREPARE"] = "prepare";
    ERaidStatus2["READY"] = "ready";
    ERaidStatus2["CANCELED"] = "canceled";
    ERaidStatus2["STARTED"] = "started";
    ERaidStatus2["CREATED"] = "created";
    return ERaidStatus2;
})(ERaidStatus || {});
var ERenderScheduler = /* @__PURE__ */ ((ERenderScheduler2)=>{
    ERenderScheduler2["REQUEST_ANIMATION_FRAME"] = "raf";
    ERenderScheduler2["SET_TIMEOUT"] = "timeout";
    return ERenderScheduler2;
})(ERenderScheduler || {});
var EResizableImageSize = /* @__PURE__ */ ((EResizableImageSize2)=>{
    EResizableImageSize2["SMALL"] = "small";
    EResizableImageSize2["MEDIUM"] = "medium";
    EResizableImageSize2["LARGE"] = "large";
    EResizableImageSize2["ORIGINAL"] = "original";
    return EResizableImageSize2;
})(EResizableImageSize || {});
var ERewardStatus = /* @__PURE__ */ ((ERewardStatus2)=>{
    ERewardStatus2["Rejected"] = "rejected";
    ERewardStatus2["Approved"] = "approved";
    ERewardStatus2["Pending"] = "pending";
    return ERewardStatus2;
})(ERewardStatus || {});
var ESendStreamChatMessageError = /* @__PURE__ */ ((ESendStreamChatMessageError2)=>{
    ESendStreamChatMessageError2["INVALID_PARAM"] = "invalid_param";
    ESendStreamChatMessageError2["MESSAGE_TOO_LONG"] = "message_too_long";
    ESendStreamChatMessageError2["SAME_MESSAGE"] = "same_message";
    ESendStreamChatMessageError2["SEND_TOO_FAST"] = "send_too_fast";
    ESendStreamChatMessageError2["INVALID_SMILES_USED"] = "invalid_smiles_used";
    ESendStreamChatMessageError2["CANT_SEND"] = "cant_send";
    ESendStreamChatMessageError2["ONLY_SMILES_ALLOWED"] = "only_smiles_allowed";
    ESendStreamChatMessageError2["LINKS_NOT_ALLOWED"] = "links_not_allowed";
    ESendStreamChatMessageError2["ONLY_RU_EN_NUMBERS_ALLOWED"] = "only_ru_en_numbers_allowed";
    return ESendStreamChatMessageError2;
})(ESendStreamChatMessageError || {});
var EShareTarget = /* @__PURE__ */ ((EShareTarget2)=>{
    EShareTarget2["CHAT"] = "chat";
    EShareTarget2["DOWNLOAD"] = "download";
    EShareTarget2["EMBED"] = "embed";
    EShareTarget2["EMBED_LINK"] = "embed_link";
    EShareTarget2["VK"] = "vk";
    EShareTarget2["FB"] = "fb";
    EShareTarget2["OK"] = "ok";
    EShareTarget2["TELEGRAM"] = "telegram";
    EShareTarget2["TWITTER"] = "twitter";
    EShareTarget2["QR"] = "qr";
    EShareTarget2["LINK"] = "link";
    EShareTarget2["VLC"] = "vlc";
    return EShareTarget2;
})(EShareTarget || {});
var ESmileAccessType = /* @__PURE__ */ ((ESmileAccessType2)=>{
    ESmileAccessType2["BLOG_SUBSCRIPTION"] = "blog_subscription";
    ESmileAccessType2["GLOBAL"] = "global";
    return ESmileAccessType2;
})(ESmileAccessType || {});
var ESmileSetMode = /* @__PURE__ */ ((ESmileSetMode2)=>{
    ESmileSetMode2["PUBLIC_STREAM"] = "public_video_stream";
    ESmileSetMode2["BLOG"] = "blog";
    return ESmileSetMode2;
})(ESmileSetMode || {});
var ESmileUserSetType = /* @__PURE__ */ ((ESmileUserSetType2)=>{
    ESmileUserSetType2["GLOBAL"] = "global";
    ESmileUserSetType2["OTHER_BLOGS"] = "other_blogs";
    ESmileUserSetType2["CURRENT_BLOG"] = "current_blog";
    ESmileUserSetType2["SELF_BLOG"] = "self_blog";
    ESmileUserSetType2["USER_POPULAR"] = "user_popular";
    return ESmileUserSetType2;
})(ESmileUserSetType || {});
var ESocialLink = /* @__PURE__ */ ((ESocialLink2)=>{
    ESocialLink2["YOUTUBE"] = "youtube";
    ESocialLink2["VK"] = "vk";
    ESocialLink2["FB"] = "facebook";
    ESocialLink2["OK"] = "ok";
    ESocialLink2["TWITTER"] = "twitter";
    ESocialLink2["TWITCH"] = "twitch";
    ESocialLink2["INSTAGRAM"] = "instagram";
    ESocialLink2["SOUNDCLOUD"] = "soundcloud";
    ESocialLink2["TELEGRAM"] = "telegram";
    ESocialLink2["BEHANCE"] = "behance";
    ESocialLink2["DRIBBBLE"] = "dribbble";
    ESocialLink2["TIKTOK"] = "tiktok";
    ESocialLink2["WEBSITE"] = "website";
    return ESocialLink2;
})(ESocialLink || {});
var EStatAuthStartSource = /* @__PURE__ */ ((EStatAuthStartSource2)=>{
    EStatAuthStartSource2["HEADER_LOGIN"] = "HEADER_LOGIN";
    EStatAuthStartSource2["HEADER_REGISTER"] = "HEADER_REGISTER";
    EStatAuthStartSource2["BLOG_FOLLOW"] = "BLOG_FOLLOW";
    EStatAuthStartSource2["MESSAGE"] = "MESSAGE";
    EStatAuthStartSource2["SUBSCRIBE"] = "SUBSCRIBE";
    EStatAuthStartSource2["SUBSCRIBE_LEVEL"] = "SUBSCRIBE_LEVEL";
    EStatAuthStartSource2["BLOG_POST_SUBSCRIBE"] = "BLOG_POST_SUBSCRIBE";
    EStatAuthStartSource2["BLOG_POST_LIKE"] = "BLOG_POST_LIKE";
    EStatAuthStartSource2["BLOG_POST_REACTION"] = "BLOG_POST_REACTION";
    EStatAuthStartSource2["BLOG_POST_COMMENT"] = "BLOG_POST_COMMENT";
    EStatAuthStartSource2["BLOG_POST_COMMENT_REACTION"] = "BLOG_POST_COMMENT_REACTION";
    EStatAuthStartSource2["MAIN_BECOME_AUTHOR"] = "MAIN_BECOME_AUTHOR";
    EStatAuthStartSource2["MAIN_LOGIN"] = "MAIN_LOGIN";
    EStatAuthStartSource2["LANDINGS_DA"] = "LANDINGS_DA";
    EStatAuthStartSource2["LANDING_BLOG_2125"] = "LANDING_BLOG_2125";
    EStatAuthStartSource2["OTHER"] = "OTHER";
    EStatAuthStartSource2["REWARDS_WINDOW_LOGIN"] = "REWARDS_WINDOW_LOGIN";
    return EStatAuthStartSource2;
})(EStatAuthStartSource || {});
var EStatEventType = /* @__PURE__ */ ((EStatEventType2)=>{
    EStatEventType2["ROUTE_ENTER"] = "ROUTE_ENTER";
    EStatEventType2["UPLOAD_FILE"] = "UPLOAD_FILE";
    EStatEventType2["UPLOAD_FILE_SUCCESS"] = "UPLOAD_FILE_SUCCESS";
    EStatEventType2["UPLOAD_FILE_CANCELLED"] = "UPLOAD_FILE_CANCELLED";
    EStatEventType2["UPLOAD_FILE_ERROR"] = "UPLOAD_FILE_ERROR";
    EStatEventType2["UPLOAD_FILE_CHUNK_ERROR"] = "UPLOAD_FILE_CHUNK_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_FILE"] = "PUBLISHER_UPLOAD_FILE";
    EStatEventType2["PUBLISHER_UPLOAD_FILE_SUCCESS"] = "PUBLISHER_UPLOAD_FILE_SUCCESS";
    EStatEventType2["PUBLISHER_UPLOAD_FILE_ERROR"] = "PUBLISHER_UPLOAD_FILE_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_FILE_CHUNK_ERROR"] = "PUBLISHER_UPLOAD_FILE_CHUNK_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_AUDIO"] = "PUBLISHER_UPLOAD_AUDIO";
    EStatEventType2["PUBLISHER_UPLOAD_AUDIO_SUCCESS"] = "PUBLISHER_UPLOAD_AUDIO_SUCCESS";
    EStatEventType2["PUBLISHER_UPLOAD_AUDIO_ERROR"] = "PUBLISHER_UPLOAD_AUDIO_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_AUDIO_CHUNK_ERROR"] = "PUBLISHER_UPLOAD_AUDIO_CHUNK_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO"] = "PUBLISHER_UPLOAD_VIDEO";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_SUCCESS"] = "PUBLISHER_UPLOAD_VIDEO_SUCCESS";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_ERROR"] = "PUBLISHER_UPLOAD_VIDEO_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_RETRY"] = "PUBLISHER_UPLOAD_VIDEO_RETRY";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_CHUNK_SUCCESS"] = "PUBLISHER_UPLOAD_VIDEO_CHUNK_SUCCESS";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_CHUNK_ERROR"] = "PUBLISHER_UPLOAD_VIDEO_CHUNK_ERROR";
    EStatEventType2["PUBLISHER_UPLOAD_VIDEO_CHUNK_RETRY"] = "PUBLISHER_UPLOAD_VIDEO_CHUNK_RETRY";
    EStatEventType2["BLOG_SOCIAL_LINK_CLICK"] = "BLOG_SOCIAL_LINK_CLICK";
    EStatEventType2["POST_FILE_DOWNLOAD"] = "POST_FILE_DOWNLOAD";
    EStatEventType2["POST_AUDIO_PLAY"] = "POST_AUDIO_PLAY";
    EStatEventType2["POST_AUDIO_PLAY_ERROR"] = "POST_AUDIO_PLAY_ERROR";
    EStatEventType2["POST_PUBLISHED_OVERLAY_SHOW"] = "POST_PUBLISHED_OVERLAY_SHOW";
    EStatEventType2["POST_PUBLISHED_OVERLAY_CLICK_SHARE"] = "POST_PUBLISHED_OVERLAY_CLICK_SHARE";
    EStatEventType2["MESSAGE_FILE_DOWNLOAD"] = "MESSAGE_FILE_DOWNLOAD";
    EStatEventType2["MESSAGE_AUDIO_PLAY"] = "MESSAGE_AUDIO_PLAY";
    EStatEventType2["MESSAGE_AUDIO_PLAY_ERROR"] = "MESSAGE_AUDIO_PLAY_ERROR";
    EStatEventType2["SHARE_DROPDOWN_SHOW"] = "SHARE_DROPDOWN_SHOW";
    EStatEventType2["SHARE_DROPDOWN_CLICK_ITEM"] = "SHARE_DROPDOWN_CLICK_ITEM";
    EStatEventType2["SELECT_LOCALE"] = "SELECT_LOCALE";
    EStatEventType2["VIDEO_STARTED"] = "VIDEO_STARTED";
    EStatEventType2["VIDEO_PAUSED"] = "VIDEO_PAUSED";
    EStatEventType2["VIDEO_RESUMED"] = "VIDEO_RESUMED";
    EStatEventType2["VIDEO_ENDED"] = "VIDEO_ENDED";
    EStatEventType2["VIDEO_REWOUND"] = "VIDEO_REWOUND";
    EStatEventType2["VIDEO_PROGRESS"] = "VIDEO_PROGRESS";
    EStatEventType2["VIDEO_LOAD_PLAYER_ERROR"] = "VIDEO_LOAD_PLAYER_ERROR";
    EStatEventType2["VIDEO_START_LOADING_PLAYER"] = "VIDEO_START_LOADING_PLAYER";
    EStatEventType2["MAYBE_WRONG_LANGUAGE"] = "MAYBE_WRONG_LANGUAGE";
    EStatEventType2["AUTH_POPUP_SHOW"] = "AUTH_POPUP_SHOW";
    EStatEventType2["AUTH_POPUP_CLICK_PROVIDER"] = "AUTH_POPUP_CLICK_PROVIDER";
    EStatEventType2["AUTH_ERROR"] = "AUTH_ERROR";
    EStatEventType2["AUTH_REFRESH_TOKEN"] = "AUTH_REFRESH_TOKEN";
    EStatEventType2["SUBSCRIBE_POPUP_SHOW"] = "SUBSCRIBE_POPUP_SHOW";
    EStatEventType2["SUBSCRIBE_POPUP_3DS_SHOW"] = "SUBSCRIBE_POPUP_3DS_SHOW";
    EStatEventType2["SUBSCRIBE_POPUP_FINISHED"] = "SUBSCRIBE_POPUP_FINISHED";
    EStatEventType2["SINGLE_PAYMENT_POPUP_SHOW"] = "SINGLE_PAYMENT_SHOW";
    EStatEventType2["SINGLE_PAYMENT_POPUP_3DS_SHOW"] = "SINGLE_PAYMENT_3DS_SHOW";
    EStatEventType2["SINGLE_PAYMENT_POPUP_FINISHED"] = "SINGLE_PAYMENT_FINISHED";
    EStatEventType2["POLICY_POPUP_SHOW"] = "POLICY_POPUP_SHOW";
    EStatEventType2["POLICY_POPUP_ACCEPT"] = "POLICY_POPUP_ACCEPT";
    EStatEventType2["WIDGET_DONATE_SHOW"] = "WIDGET_DONATE_SHOW";
    EStatEventType2["WIDGET_DONATE_3DS_SHOW"] = "WIDGET_DONATE_3DS_SHOW";
    EStatEventType2["WIDGET_DONATE_FINISHED"] = "WIDGET_DONATE_FINISHED";
    EStatEventType2["WIDGET_WEB_VIEW_SUBSCRIBE_CANCEL"] = "WIDGET_WEB_VIEW_SUBSCRIBE_CANCEL";
    EStatEventType2["WIDGET_WEB_VIEW_SUBSCRIBE_FAILURE"] = "WIDGET_WEB_VIEW_SUBSCRIBE_FAILURE";
    EStatEventType2["WIDGET_WEB_VIEW_SUBSCRIBE_SHOW"] = "WIDGET_WEB_VIEW_SUBSCRIBE_SHOW";
    EStatEventType2["WIDGET_WEB_VIEW_SUBSCRIBE_SUCCESS"] = "WIDGET_WEB_VIEW_SUBSCRIBE_SUCCESS";
    EStatEventType2["WIDGET_WEB_VIEW_POST_PURCHASE_CANCEL"] = "WIDGET_WEB_VIEW_POST_PURCHASE_CANCEL";
    EStatEventType2["WIDGET_WEB_VIEW_POST_PURCHASE_FAILURE"] = "WIDGET_WEB_VIEW_POST_PURCHASE_FAILURE";
    EStatEventType2["WIDGET_WEB_VIEW_POST_PURCHASE_SHOW"] = "WIDGET_WEB_VIEW_POST_PURCHASE_SHOW";
    EStatEventType2["WIDGET_WEB_VIEW_POST_PURCHASE_SUCCESS"] = "WIDGET_WEB_VIEW_POST_PURCHASE_SUCCESS";
    EStatEventType2["WIDGET_WEB_VIEW_DONATION_CANCEL"] = "WIDGET_WEB_VIEW_DONATION_CANCEL";
    EStatEventType2["WIDGET_WEB_VIEW_DONATION_FAILURE"] = "WIDGET_WEB_VIEW_DONATION_FAILURE";
    EStatEventType2["WIDGET_WEB_VIEW_DONATION_SHOW"] = "WIDGET_WEB_VIEW_DONATION_SHOW";
    EStatEventType2["WIDGET_WEB_VIEW_DONATION_SUCCESS"] = "WIDGET_WEB_VIEW_DONATION_SUCCESS";
    EStatEventType2["WIDGET_WEB_VIEW_MESSAGE_PURCHASE_CANCEL"] = "WIDGET_WEB_VIEW_MESSAGE_PURCHASE_CANCEL";
    EStatEventType2["WIDGET_WEB_VIEW_MESSAGE_PURCHASE_FAILURE"] = "WIDGET_WEB_VIEW_MESSAGE_PURCHASE_FAILURE";
    EStatEventType2["WIDGET_WEB_VIEW_MESSAGE_PURCHASE_SHOW"] = "WIDGET_WEB_VIEW_MESSAGE_PURCHASE_SHOW";
    EStatEventType2["WIDGET_WEB_VIEW_MESSAGE_PURCHASE_SUCCESS"] = "WIDGET_WEB_VIEW_MESSAGE_PURCHASE_SUCCESS";
    EStatEventType2["WIDGET_WEB_VIEW_BIND_CARD_CANCEL"] = "WIDGET_WEB_VIEW_BIND_CARD_CANCEL";
    EStatEventType2["WIDGET_WEB_VIEW_BIND_CARD_FAILURE"] = "WIDGET_WEB_VIEW_BIND_CARD_FAILURE";
    EStatEventType2["WIDGET_WEB_VIEW_BIND_CARD_SHOW"] = "WIDGET_WEB_VIEW_BIND_CARD_SHOW";
    EStatEventType2["WIDGET_WEB_VIEW_BIND_CARD_SUCCESS"] = "WIDGET_WEB_VIEW_BIND_CARD_SUCCESS";
    EStatEventType2["BANK131_FRAME_WAITING"] = "BANK131_FRAME_WAITING";
    EStatEventType2["BANK131_FRAME_LOADED"] = "BANK131_FRAME_LOADED";
    EStatEventType2["DMR_FRAME_WAITING"] = "DMR_FRAME_WAITING";
    EStatEventType2["DMR_FRAME_LOADED"] = "DMR_FRAME_LOADED";
    EStatEventType2["BECOME_AUTHOR_POPUP_SHOW"] = "BECOME_AUTHOR_POPUP_SHOW";
    EStatEventType2["PHOTO_LAYER_OPEN"] = "PHOTO_LAYER_OPEN";
    EStatEventType2["MEDIA_ALBUM_PAGE_OPEN"] = "MEDIA_ALBUM_PAGE_OPEN";
    EStatEventType2["MEDIA_ALBUM_TYPE_FILTER_CLICK"] = "MEDIA_ALBUM_TYPE_FILTER_CLICK";
    EStatEventType2["MEDIA_ALBUM_TILE_CLICK"] = "MEDIA_ALBUM_TILE_CLICK";
    EStatEventType2["MEDIA_VIEWER_OPEN"] = "MEDIA_VIEWER_OPEN";
    EStatEventType2["MEDIA_VIEWER_ITEM_SHOW"] = "MEDIA_VIEWER_ITEM_SHOW";
    EStatEventType2["MAIN_PAGE_BANNER_CLICK"] = "MAIN_PAGE_BANNER_CLICK";
    EStatEventType2["MARKETING_ALERT_SHOW"] = "MARKETING_ALERT_SHOW";
    EStatEventType2["MARKETING_ALERT_DISMISS"] = "MARKETING_ALERT_DISMISS";
    EStatEventType2["MARKETING_ALERT_ACCEPT"] = "MARKETING_ALERT_ACCEPT";
    EStatEventType2["NOTIFICATIONS_LINK_CLICK"] = "NOTIFICATIONS_LINK_CLICK";
    EStatEventType2["BANNER_CLICKED"] = "BANNER_CLICKED";
    EStatEventType2["BANNER_CLOSED"] = "BANNER_CLOSED";
    EStatEventType2["BANNER_SHOWN"] = "BANNER_SHOWN";
    EStatEventType2["DONATION_OPEN_FORM"] = "DONATION_OPEN_FORM";
    EStatEventType2["PAYMENT_WINDOW_ACTION"] = "PAYMENT_WINDOW_ACTION";
    EStatEventType2["DONATION_WINDOW_ACTION"] = "DONATION_WINDOW_ACTION";
    EStatEventType2["SUBSCRIBE_MOBILE_CLICK"] = "SUBSCRIBE_MOBILE_CLICK";
    EStatEventType2["NOTIFICATION_SETTINGS_WEB_PUSH_OK"] = "NOTIFICATION_SETTINGS_WEB_PUSH_OK";
    EStatEventType2["NOTIFICATION_SETTINGS_WEB_PUSH_CANCEL"] = "NOTIFICATION_SETTINGS_WEB_PUSH_CANCEL";
    EStatEventType2["CAROUSEL_CLICK"] = "CAROUSEL_CLICK";
    EStatEventType2["STREAMS_CATALOG_CLICK"] = "STREAMS_CATALOG_CLICK";
    EStatEventType2["RECORDS_CATALOG_CLICK"] = "RECORDS_CATALOG_CLICK";
    EStatEventType2["CHAT_TAB_SHOW"] = "CHAT_TAB_SHOW";
    EStatEventType2["CHAT_USER_CARD_SHOW"] = "CHAT_USER_CARD_SHOW";
    EStatEventType2["CHAT_SMILE_POPUP_SHOW"] = "CHAT_SMILE_POPUP_SHOW";
    EStatEventType2["CHAT_REWARD_SHOP_SHOW"] = "CHAT_REWARD_SHOP_SHOW";
    EStatEventType2["CHAT_REWARD_PRICE_LIST_SHOW"] = "CHAT_REWARD_PRICE_LIST_SHOW";
    EStatEventType2["CHAT_SETTINGS_SHOW"] = "CHAT_SETTINGS_SHOW";
    EStatEventType2["CHAT_DROPS_SHOW"] = "CHAT_DROPS_SHOW";
    EStatEventType2["STREAM_TAB_SHOW"] = "STREAM_TAB_SHOW";
    EStatEventType2["NEWS_POPUP_CLOSE"] = "NEWS_POPUP_CLOSE";
    EStatEventType2["THEME"] = "THEME";
    return EStatEventType2;
})(EStatEventType || {});
var EStreamCategoryType = /* @__PURE__ */ ((EStreamCategoryType2)=>{
    EStreamCategoryType2["ALL"] = "all";
    EStreamCategoryType2["GAME"] = "game";
    EStreamCategoryType2["IRL"] = "irl";
    EStreamCategoryType2["SPORT"] = "sport";
    return EStreamCategoryType2;
})(EStreamCategoryType || {});
var EStreamUserTimeoutOptions = /* @__PURE__ */ ((EStreamUserTimeoutOptions2)=>{
    EStreamUserTimeoutOptions2["10_MINUTES"] = "tenMinutes";
    EStreamUserTimeoutOptions2["1_HOUR"] = "oneHour";
    EStreamUserTimeoutOptions2["UNTIL_STREAM_END"] = "untilStreamEnd";
    return EStreamUserTimeoutOptions2;
})(EStreamUserTimeoutOptions || {});
var ESubscriptionDuration = /* @__PURE__ */ ((ESubscriptionDuration2)=>{
    ESubscriptionDuration2["LONGER_THAN_0_MINUTES"] = "longer_than_0_minutes";
    ESubscriptionDuration2["LONGER_THAN_10_MINUTES"] = "longer_than_10_minutes";
    ESubscriptionDuration2["LONGER_THAN_30_MINUTES"] = "longer_than_30_minutes";
    ESubscriptionDuration2["LONGER_THAN_1_HOUR"] = "longer_than_1_hour";
    ESubscriptionDuration2["LONGER_THAN_1_DAY"] = "longer_than_1_day";
    ESubscriptionDuration2["LONGER_THAN_1_WEEK"] = "longer_than_1_week";
    ESubscriptionDuration2["LONGER_THAN_1_MONTH"] = "longer_than_1_month";
    ESubscriptionDuration2["LONGER_THAN_3_MONTHS"] = "longer_than_3_months";
    return ESubscriptionDuration2;
})(ESubscriptionDuration || {});
var ESubscriptionKind = /* @__PURE__ */ ((ESubscriptionKind2)=>{
    ESubscriptionKind2["NONE"] = "none";
    ESubscriptionKind2["FREE"] = "free";
    ESubscriptionKind2["PAID"] = "paid";
    return ESubscriptionKind2;
})(ESubscriptionKind || {});
var ESupportProgramSeasonLevelMetricName = /* @__PURE__ */ ((ESupportProgramSeasonLevelMetricName2)=>{
    ESupportProgramSeasonLevelMetricName2["DAYS_ON_AIR"] = "days_on_air";
    ESupportProgramSeasonLevelMetricName2["BEST_DAYS_ON_AIR"] = "best_days_on_air";
    ESupportProgramSeasonLevelMetricName2["RAID_MEMBERS"] = "raid_members";
    ESupportProgramSeasonLevelMetricName2["STREAM_TIME"] = "stream_time";
    ESupportProgramSeasonLevelMetricName2["VIEW_TIME"] = "view_time";
    ESupportProgramSeasonLevelMetricName2["AVERAGE_VIEWER_COUNT"] = "average_viewer_count";
    ESupportProgramSeasonLevelMetricName2["TOTAL_PROFIT"] = "total_profit";
    ESupportProgramSeasonLevelMetricName2["LIKE"] = "like";
    ESupportProgramSeasonLevelMetricName2["CHANNEL_POINT_REWARD_ACTIVATE"] = "cp_reward_activate";
    ESupportProgramSeasonLevelMetricName2["VK_GIFTS"] = "vk_gifts";
    ESupportProgramSeasonLevelMetricName2["PAYOUT"] = "payout";
    return ESupportProgramSeasonLevelMetricName2;
})(ESupportProgramSeasonLevelMetricName || {});
var ETargetType = /* @__PURE__ */ ((ETargetType2)=>{
    ETargetType2["MONEY"] = "money";
    ETargetType2["SUBSCRIBERS"] = "subscribers";
    return ETargetType2;
})(ETargetType || {});
var EUITheme = /* @__PURE__ */ ((EUITheme2)=>{
    EUITheme2["DARK"] = "dark-theme";
    EUITheme2["LIGHT"] = "light-theme";
    EUITheme2["SYSTEM"] = "system-theme";
    return EUITheme2;
})(EUITheme || {});
var EVideoClipStatus = /* @__PURE__ */ ((EVideoClipStatus2)=>{
    EVideoClipStatus2["ACTIVE"] = "active";
    EVideoClipStatus2["DELETED"] = "deleted";
    EVideoClipStatus2["ERROR"] = "error";
    EVideoClipStatus2["ERROR_DONE"] = "error_done";
    EVideoClipStatus2["HIDDEN"] = "hidden";
    EVideoClipStatus2["PROCESSING"] = "processing";
    return EVideoClipStatus2;
})(EVideoClipStatus || {});
var EVideoClipsOrderBy = /* @__PURE__ */ ((EVideoClipsOrderBy2)=>{
    EVideoClipsOrderBy2["CREATED"] = "created";
    EVideoClipsOrderBy2["LIKED"] = "liked";
    EVideoClipsOrderBy2["VIEWED"] = "viewed";
    return EVideoClipsOrderBy2;
})(EVideoClipsOrderBy || {});
var EVideoClipSourceType = /* @__PURE__ */ ((EVideoClipSourceType2)=>{
    EVideoClipSourceType2["RECORD"] = "record";
    EVideoClipSourceType2["STREAM"] = "stream";
    return EVideoClipSourceType2;
})(EVideoClipSourceType || {});
var EWSChannel = /* @__PURE__ */ ((EWSChannel2)=>{
    EWSChannel2["USER"] = "user";
    EWSChannel2["CHAT"] = "chat";
    EWSChannel2["CUSTOM"] = "custom";
    EWSChannel2["DIALOG"] = "dialog";
    EWSChannel2["STREAM"] = "stream";
    EWSChannel2["STREAM_SLOT"] = "stream_slot";
    EWSChannel2["STREAM_MANAGEMENT"] = "stream_management";
    EWSChannel2["PRIVATE_STREAM"] = "private_stream";
    EWSChannel2["VIEWERS"] = "viewers";
    EWSChannel2["PRIVATE"] = "private";
    EWSChannel2["STREAM_SHOWCASE"] = "stream_showcase";
    EWSChannel2["VIEWERS_SHOWCASE"] = "viewers_showcase";
    EWSChannel2["SUBSCRIBED_STREAMS"] = "subscribed_streams";
    EWSChannel2["RECOMMENDED_STREAMS"] = "recommended_streams";
    return EWSChannel2;
})(EWSChannel || {});
var EWSChatMessageType = /* @__PURE__ */ ((EWSChatMessageType2)=>{
    EWSChatMessageType2["MESSAGE"] = "message";
    EWSChatMessageType2["CLEAN_CHAT_MESSAGES"] = "clean_chat_messages";
    EWSChatMessageType2["STREAM_START"] = "stream_start";
    EWSChatMessageType2["STREAM_END"] = "stream_end";
    EWSChatMessageType2["STREAM_LIKE_COUNTER"] = "stream_like_counter";
    EWSChatMessageType2["STREAM_ONLINE_STATUS"] = "stream_online_status";
    EWSChatMessageType2["DELETE_MESSAGE"] = "delete_message";
    EWSChatMessageType2["CHAT_PINNED_MESSAGE_PIN"] = "chat_pinned_message_pin";
    EWSChatMessageType2["CHAT_PINNED_MESSAGE_EDIT"] = "chat_pinned_message_edit";
    EWSChatMessageType2["CHAT_PINNED_MESSAGE_UNPIN"] = "chat_pinned_message_unpin";
    EWSChatMessageType2["CHAT_PINNED_MESSAGE_REACTION"] = "chat_pinned_message_reaction";
    EWSChatMessageType2["CHAT_CLEAN"] = "chat_clean";
    EWSChatMessageType2["CHAT_BAN"] = "chat_ban";
    return EWSChatMessageType2;
})(EWSChatMessageType || {});
var EWSCustomMessageType = /* @__PURE__ */ ((EWSCustomMessageType2)=>{
    EWSCustomMessageType2["DIALOG_CHATMATE_ACTION"] = "dialog_chatmate_action";
    return EWSCustomMessageType2;
})(EWSCustomMessageType || {});
var EWSDialoguesMessageType = /* @__PURE__ */ ((EWSDialoguesMessageType2)=>{
    EWSDialoguesMessageType2["DIALOG_MESSAGE"] = "dialog_message";
    EWSDialoguesMessageType2["DIALOG_MESSAGE_READ"] = "dialog_message_read";
    EWSDialoguesMessageType2["DIALOG_MESSAGE_PAID"] = "dialog_message_paid";
    EWSDialoguesMessageType2["DIALOG_DELETE_MESSAGE"] = "dialog_delete_message";
    EWSDialoguesMessageType2["DIALOG_BROADCAST_MESSAGES_DONE"] = "dialog_broadcast_messages_done";
    return EWSDialoguesMessageType2;
})(EWSDialoguesMessageType || {});
var EWSEvent = /* @__PURE__ */ ((EWSEvent2)=>{
    EWSEvent2["CONNECT"] = "connect";
    return EWSEvent2;
})(EWSEvent || {});
var EWSSubscribedStreamsMessageType = /* @__PURE__ */ ((EWSSubscribedStreamsMessageType2)=>{
    EWSSubscribedStreamsMessageType2["STREAM_SLOT_ONLINE_STATUS"] = "stream_slot_online_status";
    EWSSubscribedStreamsMessageType2["STREAM_SLOT_END"] = "stream_slot_end";
    return EWSSubscribedStreamsMessageType2;
})(EWSSubscribedStreamsMessageType || {});
var EWSClipMessageType = /* @__PURE__ */ ((EWSClipMessageType2)=>{
    EWSClipMessageType2["VIDEO_CLIP_ERROR"] = "clip_error";
    EWSClipMessageType2["VIDEO_CLIP_READY"] = "clip_ready";
    EWSClipMessageType2["VIDEO_SNIPPET_ERROR"] = "clip_template_error";
    EWSClipMessageType2["VIDEO_SNIPPET_READY"] = "clip_template_ready";
    return EWSClipMessageType2;
})(EWSClipMessageType || {});
var EWSRecommendedStreamsMessageType = /* @__PURE__ */ ((EWSRecommendedStreamsMessageType2)=>{
    EWSRecommendedStreamsMessageType2["STREAM_SLOT_ONLINE_STATUS"] = "stream_slot_online_status";
    EWSRecommendedStreamsMessageType2["STREAM_SLOT_END"] = "stream_slot_end";
    return EWSRecommendedStreamsMessageType2;
})(EWSRecommendedStreamsMessageType || {});
var EWSPrivateStreamMessageType = /* @__PURE__ */ ((EWSPrivateStreamMessageType2)=>{
    EWSPrivateStreamMessageType2["CP_BALANCE_CHANGE"] = "cp_balance_change";
    EWSPrivateStreamMessageType2["CP_BONUS_PENDING"] = "cp_bonus_pending";
    EWSPrivateStreamMessageType2["DROP_PROGRESS"] = "drop_campaign_progress";
    EWSPrivateStreamMessageType2["START_PREDICTION"] = "start_prediction";
    EWSPrivateStreamMessageType2["POLL_START"] = "poll_start";
    EWSPrivateStreamMessageType2["SUBSCRIPTION_GIFT_BUY"] = "subscription_gift_buy";
    EWSPrivateStreamMessageType2["STREAM_PREDICTION"] = "prediction";
    EWSPrivateStreamMessageType2["STREAM_POLL"] = "poll";
    return EWSPrivateStreamMessageType2;
})(EWSPrivateStreamMessageType || {});
var EChannelPointUpdaterReasonType = /* @__PURE__ */ ((EChannelPointUpdaterReasonType2)=>{
    EChannelPointUpdaterReasonType2["BONUS"] = "bonus";
    EChannelPointUpdaterReasonType2["REWARD"] = "reward";
    return EChannelPointUpdaterReasonType2;
})(EChannelPointUpdaterReasonType || {});
var EBonusType = /* @__PURE__ */ ((EBonusType2)=>{
    EBonusType2["STREAM_VIEW"] = "stream_view";
    EBonusType2["STREAM_ACTIVE_VIEW"] = "stream_active_view";
    EBonusType2["CHAT_MESSAGE"] = "chat_message";
    EBonusType2["STREAM_LIKE"] = "stream_like";
    EBonusType2["STREAM_RAID"] = "stream_raid";
    EBonusType2["CHANNEL_FOLLOW"] = "channel_follow";
    EBonusType2["MULTIPLIER"] = "multiplier";
    return EBonusType2;
})(EBonusType || {});
var ERewardDenyReasonType = /* @__PURE__ */ ((ERewardDenyReasonType2)=>{
    ERewardDenyReasonType2["NO_ACTIVE_STREAM"] = "no_active_stream";
    ERewardDenyReasonType2["COOLDOWN_NOT_EXPIRED"] = "cooldown_not_expired";
    ERewardDenyReasonType2["ACTIVATION_LIMIT_IS_REACHED"] = "activation_limit_is_reached";
    ERewardDenyReasonType2["NOT_ENOUGH_CHANNEL_POINTS"] = "not_enough_channel_points";
    ERewardDenyReasonType2["USER_IS_BANNED"] = "user_is_banned";
    ERewardDenyReasonType2["UNKNOWN"] = "unknown";
    return ERewardDenyReasonType2;
})(ERewardDenyReasonType || {});
var EPredictionStatus = /* @__PURE__ */ ((EPredictionStatus2)=>{
    EPredictionStatus2["ACTIVE"] = "active";
    EPredictionStatus2["DECISION"] = "decision";
    EPredictionStatus2["ENDED"] = "ended";
    EPredictionStatus2["CANCELED"] = "canceled";
    return EPredictionStatus2;
})(EPredictionStatus || {});
var EUsersStatsContext = /* @__PURE__ */ ((EUsersStatsContext2)=>{
    EUsersStatsContext2["OWNER"] = "OWNER";
    EUsersStatsContext2["MODERATORS"] = "MODERATORS";
    EUsersStatsContext2["USERS"] = "USERS";
    EUsersStatsContext2["TEMPORARYBANNEDUSERS"] = "TEMPORARYBANNEDUSERS";
    EUsersStatsContext2["PERMANENTBANNEDUSERS"] = "PERMANENTBANNEDUSERS";
    return EUsersStatsContext2;
})(EUsersStatsContext || {});
var EVKVideoPlayerControl = /* @__PURE__ */ ((EVKVideoPlayerControl2)=>{
    EVKVideoPlayerControl2["LIVE_BUTTON"] = "player_live_button";
    EVKVideoPlayerControl2["SETTINGS_BUTTON"] = "player_settings_button";
    EVKVideoPlayerControl2["W_MAX"] = "w_max";
    EVKVideoPlayerControl2["TIMELINE"] = "timeline";
    return EVKVideoPlayerControl2;
})(EVKVideoPlayerControl || {});
var EVKVideoPlayerCustomControl = /* @__PURE__ */ ((EVKVideoPlayerCustomControl2)=>{
    EVKVideoPlayerCustomControl2["ADULT_CONTENT_SIGN"] = "adult_content_sign";
    EVKVideoPlayerCustomControl2["CLIP_BUTTON"] = "clip_button";
    EVKVideoPlayerCustomControl2["THEATRE_BUTTON"] = "theatre_button";
    return EVKVideoPlayerCustomControl2;
})(EVKVideoPlayerCustomControl || {});
var EWSStreamMessageType = /* @__PURE__ */ ((EWSStreamMessageType2)=>{
    EWSStreamMessageType2["STREAM_START"] = "stream_start";
    EWSStreamMessageType2["STREAM_END"] = "stream_end";
    EWSStreamMessageType2["STREAM_LIKE_COUNTER"] = "stream_like_counter";
    EWSStreamMessageType2["STREAM_ONLINE_STATUS"] = "stream_online_status";
    EWSStreamMessageType2["STREAM_RAID_STATUS"] = "raid_status";
    EWSStreamMessageType2["STREAM_INFO_UPDATE"] = "stream_info_update";
    EWSStreamMessageType2["STREAM_PREDICTION"] = "prediction";
    EWSStreamMessageType2["STREAM_POLL"] = "poll";
    EWSStreamMessageType2["CHAT_SETTINGS_UPDATE"] = "public_video_stream_chat_settings_update";
    EWSStreamMessageType2["CUSTOM_BLOCK_CREATE"] = "custom_block_create";
    EWSStreamMessageType2["CUSTOM_BLOCK_UPDATE"] = "custom_block_update";
    EWSStreamMessageType2["CUSTOM_BLOCK_DELETE"] = "custom_block_delete";
    EWSStreamMessageType2["CUSTOM_BLOCK_REORDER"] = "custom_block_reorder";
    EWSStreamMessageType2["CHANNEL_STREAM"] = "channel_stream";
    EWSStreamMessageType2["SLOT_ONLINE_STATUS"] = "stream_slot_online_status";
    EWSStreamMessageType2["STREAM_SLOT_END"] = "stream_slot_end";
    return EWSStreamMessageType2;
})(EWSStreamMessageType || {});
var EWSStreamShowcaseMessageType = /* @__PURE__ */ ((EWSStreamShowcaseMessageType2)=>{
    EWSStreamShowcaseMessageType2["STREAM_ONLINE_STATUS"] = "stream_online_status";
    return EWSStreamShowcaseMessageType2;
})(EWSStreamShowcaseMessageType || {});
var EWSUserMessageType = /* @__PURE__ */ ((EWSUserMessageType2)=>{
    EWSUserMessageType2["SUBSCRIBERS_CHANGE_COUNT"] = "subscribers_change_count";
    EWSUserMessageType2["DIALOG_MESSAGE_COUNTERS"] = "dialog_message_counters";
    EWSUserMessageType2["PUBLISH_POST"] = "publish_post";
    EWSUserMessageType2["CHAT_BAN"] = "chat_ban";
    EWSUserMessageType2["CHAT_UNBAN"] = "chat_unban";
    EWSUserMessageType2["USER_BAN"] = "user_ban";
    EWSUserMessageType2["USER_UNBAN"] = "user_unban";
    EWSUserMessageType2["VIDEO_UPLOADED"] = "video_uploaded";
    EWSUserMessageType2["VIDEO_UPLOADED_FAILED"] = "video_upload_failed";
    EWSUserMessageType2["BLACK_LISTED"] = "blacklisted";
    EWSUserMessageType2["UNBLACK_LISTED"] = "unblacklisted";
    EWSUserMessageType2["ACTIONS_JOURNAL_NEW_EVENT"] = "actions_journal_new_event";
    EWSUserMessageType2["BLOG_SUBSCRIBER_STAT"] = "blog_subscriber_stat";
    EWSUserMessageType2["NOTIFICATIONS_SETTINGS_UPDATE"] = "notify_subscription_settings";
    EWSUserMessageType2["USER_CHANGE_CURRENCY"] = "user_change_currency";
    EWSUserMessageType2["BOOSTY_USER_LINK"] = "boosty_user_link";
    EWSUserMessageType2["UPLOAD_ORIGINAL_SMILE_IMAGE"] = "smile_resize";
    EWSUserMessageType2["UPLOAD_ORIGINAL_BADGE_IMAGE"] = "badge_resize";
    EWSUserMessageType2["UPLOAD_ORIGINAL_REWARD_IMAGE"] = "reward_resize";
    EWSUserMessageType2["UPLOAD_ORIGINAL_POINTS_IMAGE"] = "channel_point_resize";
    EWSUserMessageType2["UPLOAD_ORIGINAL_ROLE_IMAGE"] = "role_resize";
    EWSUserMessageType2["BANK_CARDS"] = "bank_cards_list_update";
    EWSUserMessageType2["BLACKLIST_ADD"] = "blacklist_add";
    EWSUserMessageType2["BLACKLIST_DELETE"] = "blacklist_delete";
    return EWSUserMessageType2;
})(EWSUserMessageType || {});
var EButtonType = /* @__PURE__ */ ((EButtonType2)=>{
    EButtonType2["SUBMIT"] = "submit";
    EButtonType2["RESET"] = "reset";
    EButtonType2["BUTTON"] = "button";
    return EButtonType2;
})(EButtonType || {});
var EWSStreamManagementMessageType = /* @__PURE__ */ ((EWSStreamManagementMessageType2)=>{
    EWSStreamManagementMessageType2["REWARD_DEMAND"] = "cp_reward_demand";
    EWSStreamManagementMessageType2["ACTIONS_JOURNAL_NEW_EVENT"] = "actions_journal_new_event";
    EWSStreamManagementMessageType2["CHANNEL_MODERATION_LOG_EVENT"] = "channel_moderation_log_event";
    EWSStreamManagementMessageType2["STREAM_POLL"] = "poll";
    return EWSStreamManagementMessageType2;
})(EWSStreamManagementMessageType || {});
var EModerationLogEventType = /* @__PURE__ */ ((EModerationLogEventType2)=>{
    EModerationLogEventType2["DELETE_MESSAGE"] = "delete_message";
    EModerationLogEventType2["CLEAN_USER_MESSAGES"] = "clean_user_messages";
    EModerationLogEventType2["CLEAR_CHAT"] = "clear_chat";
    EModerationLogEventType2["PIN_MESSAGE"] = "pin_message";
    EModerationLogEventType2["TEMPORARY_BAN"] = "temporary_ban";
    EModerationLogEventType2["BAN_VIEWER"] = "ban_viewer";
    EModerationLogEventType2["UNBAN_VIEWER"] = "unban_viewer";
    EModerationLogEventType2["SET_MODERATOR"] = "set_moderator";
    EModerationLogEventType2["UNSET_MODERATOR"] = "unset_moderator";
    EModerationLogEventType2["RAID"] = "raid";
    EModerationLogEventType2["CANCEL_RAID"] = "cancel_raid";
    EModerationLogEventType2["CHANGE_CATEGORY"] = "change_category";
    EModerationLogEventType2["CHANGE_TITLE"] = "change_title";
    return EModerationLogEventType2;
})(EModerationLogEventType || {});
var ECantSendReason = /* @__PURE__ */ ((ECantSendReason2)=>{
    ECantSendReason2["SLOW_MODE_COOLDOWN"] = "slow_mode_cooldown";
    ECantSendReason2["SAME_MESSAGE_COOLDOWN"] = "same_message_cooldown";
    ECantSendReason2["FOLLOW_MODE_COOLDOWN"] = "follow_mode_cooldown";
    ECantSendReason2["FOR_PAID_SUBSCRIBERS"] = "for_paid_subscribers";
    return ECantSendReason2;
})(ECantSendReason || {});
var EIndication = /* @__PURE__ */ ((EIndication2)=>{
    EIndication2["BOXES"] = "boxes";
    EIndication2["BROWSER_NOTIFICATIONS"] = "browserNotifications";
    return EIndication2;
})(EIndication || {});
var ESchemaType = /* @__PURE__ */ ((ESchemaType2)=>{
    ESchemaType2["MAIN"] = "main";
    ESchemaType2["SUBSCRIPTION"] = "subscription";
    return ESchemaType2;
})(ESchemaType || {});
var EIndicationType = /* @__PURE__ */ ((EIndicationType2)=>{
    EIndicationType2["POINT"] = "point";
    EIndicationType2["BUTTON"] = "button";
    return EIndicationType2;
})(EIndicationType || {});
var EModeratorRoles = /* @__PURE__ */ ((EModeratorRoles2)=>{
    EModeratorRoles2["NONE"] = "none";
    EModeratorRoles2["OWNER"] = "owner";
    EModeratorRoles2["CHANNEL_ADMIN"] = "channel_admin";
    EModeratorRoles2["CHANNEL_MODERATOR"] = "channel_moderator";
    EModeratorRoles2["CHANNEL_CHAT_MODERATOR"] = "channel_chat_moderator";
    return EModeratorRoles2;
})(EModeratorRoles || {});
var EHTMLDataRole = /* @__PURE__ */ ((EHTMLDataRole2)=>{
    EHTMLDataRole2["MARKUP"] = "markup";
    EHTMLDataRole2["SCROLL"] = "scroll";
    EHTMLDataRole2["MESSAGE_CONTAINER"] = "messageContainer";
    EHTMLDataRole2["MESSAGE_MAIN_CONTENT"] = "messageMainContent";
    EHTMLDataRole2["MESSAGE_PARENT_MESSAGE"] = "messageParentMessage";
    EHTMLDataRole2["MESSAGE_HOVERS_CONTAINER"] = "messageHoversContainer";
    EHTMLDataRole2["MESSAGE_MENTION_CONTENT"] = "messageMentionContent";
    EHTMLDataRole2["MESSAGE_SMILE_CONTENT"] = "messageSmileContent";
    EHTMLDataRole2["REPLY_BUTTON"] = "replyButton";
    EHTMLDataRole2["THREAD_BUTTON"] = "threadButton";
    EHTMLDataRole2["DELETE_MESSAGE_BUTTON"] = "deleteMessageButton";
    EHTMLDataRole2["COPY_BUTTON"] = "copyButton";
    EHTMLDataRole2["PIN_BUTTON"] = "pinButton";
    EHTMLDataRole2["TIMEOUT_BUTTON"] = "timeoutButton";
    EHTMLDataRole2["BAN_BUTTON"] = "banButton";
    EHTMLDataRole2["UNBAN_BUTTON"] = "unbanButton";
    EHTMLDataRole2["MESSAGE_AUTHOR"] = "messageAuthor";
    EHTMLDataRole2["DELETE_ALL_USER_MESSAGES_BUTTON"] = "deleteAllUserMessagesButton";
    EHTMLDataRole2["MESSAGE_MENU"] = "messageMenu";
    return EHTMLDataRole2;
})(EHTMLDataRole || {});
var EAllowedActorStatus = /* @__PURE__ */ ((EAllowedActorStatus2)=>{
    EAllowedActorStatus2["EXISTING_ACCOUNT"] = "0";
    EAllowedActorStatus2["NEW_ACCOUNT"] = "1";
    EAllowedActorStatus2["LINKING"] = "2";
    return EAllowedActorStatus2;
})(EAllowedActorStatus || {});
var EExternalLinksSource = /* @__PURE__ */ ((EExternalLinksSource2)=>{
    EExternalLinksSource2["BOOSTY"] = "boosty";
    EExternalLinksSource2["VK"] = "vk";
    EExternalLinksSource2["VKPLAY"] = "vkplay";
    EExternalLinksSource2["DZEN"] = "dzen";
    EExternalLinksSource2["OK"] = "ok";
    return EExternalLinksSource2;
})(EExternalLinksSource || {});
var EMediaDataImageContainerType = /* @__PURE__ */ ((EMediaDataImageContainerType2)=>{
    EMediaDataImageContainerType2["PLAYLIST"] = "playlist";
    EMediaDataImageContainerType2["SLOT"] = "channel_stream_slot_cover_image";
    return EMediaDataImageContainerType2;
})(EMediaDataImageContainerType || {});
var EHeartbeatHeaders = /* @__PURE__ */ ((EHeartbeatHeaders2)=>{
    EHeartbeatHeaders2["WEB"] = "X-Source";
    EHeartbeatHeaders2["EMBED"] = "X-Super-Source";
    return EHeartbeatHeaders2;
})(EHeartbeatHeaders || {});
var EChatSettingsMode = /* @__PURE__ */ ((EChatSettingsMode2)=>{
    EChatSettingsMode2["IO"] = "io";
    EChatSettingsMode2["AVAILABILITY"] = "availability";
    EChatSettingsMode2["SLOWING"] = "slowing";
    EChatSettingsMode2["PAUSING"] = "pausing";
    EChatSettingsMode2["PROFILE"] = "profile";
    EChatSettingsMode2["STYLE"] = "style";
    EChatSettingsMode2["WINDOWED"] = "windowed";
    return EChatSettingsMode2;
})(EChatSettingsMode || {});
var EChatIOMode = /* @__PURE__ */ ((EChatIOMode2)=>{
    EChatIOMode2["ONLY_SMILES"] = "only_smiles";
    EChatIOMode2["GENERAL"] = "general";
    return EChatIOMode2;
})(EChatIOMode || {});
var EChatIOCheckbox = /* @__PURE__ */ ((EChatIOCheckbox2)=>{
    EChatIOCheckbox2["LINKS_PROHIBITED"] = "mode_option_links_prohibited";
    EChatIOCheckbox2["RU_EN_NUMBERS"] = "mode_option_ru_en_numbers";
    EChatIOCheckbox2["CAPS_PROHIBITED"] = "mode_option_caps_prohibited";
    return EChatIOCheckbox2;
})(EChatIOCheckbox || {});
var EInputMode = /* @__PURE__ */ ((EInputMode2)=>{
    EInputMode2["DEFAULT"] = "default";
    EInputMode2["LARGE"] = "large";
    return EInputMode2;
})(EInputMode || {});
var EAccessRole = /* @__PURE__ */ ((EAccessRole2)=>{
    EAccessRole2["OWNER"] = "owner";
    return EAccessRole2;
})(EAccessRole || {});
var EIntegrationType = /* @__PURE__ */ ((EIntegrationType2)=>{
    EIntegrationType2["VK_COMMUNITY"] = "vkCommunity";
    EIntegrationType2["BOOSTY"] = "boosty";
    return EIntegrationType2;
})(EIntegrationType || {});
var EChannelPollStatus = /* @__PURE__ */ ((EChannelPollStatus2)=>{
    EChannelPollStatus2["ACTIVE"] = "active";
    EChannelPollStatus2["DECISION"] = "decision";
    EChannelPollStatus2["ENDED"] = "ended";
    EChannelPollStatus2["CANCELED"] = "canceled";
    return EChannelPollStatus2;
})(EChannelPollStatus || {});
var ESdkControlsEvents = /* @__PURE__ */ ((ESdkControlsEvents2)=>{
    ESdkControlsEvents2["START_VIDEO"] = "start_video";
    ESdkControlsEvents2["PLAY_VIDEO"] = "play_video";
    ESdkControlsEvents2["PAUSE_VIDEO"] = "pause_video";
    ESdkControlsEvents2["SEEK_VIDEO"] = "seek_video";
    ESdkControlsEvents2["END_VIDEO"] = "end_video";
    ESdkControlsEvents2["LIKE"] = "like";
    ESdkControlsEvents2["LIKES_COUNT"] = "likes_count";
    ESdkControlsEvents2["VIEWERS_COUNT"] = "viewers_count";
    ESdkControlsEvents2["STREAM_INFO_UPDATE"] = "stream_info_update";
    ESdkControlsEvents2["STREAM_TITLE_UPDATE"] = "stream_title_update";
    ESdkControlsEvents2["STREAM_CATEGORY_UPDATE"] = "stream_category_update";
    ESdkControlsEvents2["STREAM_DATE_UPDATE"] = "stream_date_update";
    ESdkControlsEvents2["STREAM_SUBSCRIBERS_UPDATE"] = "stream_subscribers_update";
    ESdkControlsEvents2["STREAM_VIDEO_SOURCES_UPDATE"] = "STREAM_VIDEO_SOURCES_UPDATE";
    ESdkControlsEvents2["CHANNEL_URL_UPDATE"] = "channel_url_update";
    ESdkControlsEvents2["AUTHORIZED_STATUS_UPDATE"] = "AUTHORIZED_STATUS_UPDATE";
    ESdkControlsEvents2["THEME_UPDATED"] = "THEME_UPDATED";
    ESdkControlsEvents2["SET_THEME"] = "SET_THEME";
    return ESdkControlsEvents2;
})(ESdkControlsEvents || {});
var EContainers = /* @__PURE__ */ ((EContainers2)=>{
    EContainers2["chat"] = "chat";
    return EContainers2;
})(EContainers || {});
const DEFAULT_CONFIG = {
    appId: "",
    stream: {
        refetchMaxDelay: 0,
        raidTransitionMaxDelay: 0,
        slot: {
            maxCount: 50
        }
    },
    studio: {
        rightAsideContainer: {
            defaultWidth: 660,
            maxWidth: 660,
            minWidth: 360
        },
        defaultCover: {
            onHoldTime: 60
        }
    },
    publisher: {
        files: {
            isEnable: false,
            limits: {
                fileSize: null,
                unit: EFileSizeUnit.MB
            },
            upload: {
                chunkSize: null,
                retryCount: null,
                retryDelay: null
            }
        },
        audioFiles: {
            isEnable: false,
            limits: {
                fileSize: null,
                unit: EFileSizeUnit.MB
            },
            upload: {
                chunkSize: null,
                retryCount: null,
                retryDelay: null
            }
        },
        videoFiles: {
            isEnable: false,
            limits: {
                fileSize: null,
                unit: EFileSizeUnit.MB
            },
            upload: {
                chunkSize: null,
                retryCount: null,
                retryDelay: null,
                fileRetryCount: null
            },
            isStatChunkSuccessEnabled: false
        },
        images: {
            limits: {
                checkWidth: false,
                maxWidth: null,
                maxSize: null,
                unit: EFileSizeUnit.B
            }
        },
        tags: {
            maxCount: null,
            maxLength: null
        },
        drafts: {
            savingTimeout: 1
        }
    },
    paidPosts: {
        isCreateEnable: false,
        minPrice: null
    },
    recaptcha: {
        isEnabled: false,
        siteKeyV2: "",
        siteKeyV3: ""
    },
    payment: {
        default: {
            retries: 10,
            timeout: 1500
        },
        card_bank131: {
            retries: 100,
            timeout: 1500
        },
        qiwi: {
            retries: 100,
            timeout: 1500
        },
        yandex: {
            retries: 100,
            timeout: 1500
        }
    },
    isMergePaymentBindsCards: false,
    countriesListPaymentCardsRU: [],
    customUrls: {
        badgesDetails: "",
        smilesDetails: ""
    },
    singlePaymentMaxPrice: null,
    qiwi: {
        accountInfoUrl: ""
    },
    bank131: {
        frame: {
            height: null
        },
        frameWith3ds: {
            height: null
        },
        paymentCheck: {
            delay: null
        }
    },
    dmr: {
        dmrFrameHeight: null,
        dmrFramePaypalHeight: null,
        dmrFrameQiwiHeight: null,
        dmrFrame3dsHeight: null
    },
    message: {
        minPaymentSum: {},
        maxPaymentSum: {},
        defaultPaymentSum: {}
    },
    donation: {
        minPaymentSum: {},
        maxPaymentSum: {},
        defaultPaymentSum: {}
    },
    target: {
        minPrice: null,
        minMoneyTargetSum: null,
        maxMoneyTargetSum: null,
        maxSubscribersTargetSum: null,
        defaultPaymentSum: null
    },
    externalApps: {
        telegram: {
            botName: null,
            tutorialUrl: ""
        },
        discord: {
            tutorialUrl: ""
        }
    },
    firstStreamTutorialUrl: "",
    banners: [],
    applePay: {
        merchantId: "",
        version: 3,
        label: "boosty.to",
        enable: true
    },
    websocket: {
        isEnabled: false,
        isDebug: false,
        token: null
    },
    isAuthorizeByPhoneEnabled: false,
    hiddenMetaApps: {
        isEnabled: false,
        countriesList: []
    },
    location: {
        isEnabled: false,
        country: "",
        region: "",
        isEUCountry: false
    },
    heartbeats: {
        defaultInterval: null,
        breakOn: {
            mute: false,
            pageHide: false,
            volumeBelow: null
        }
    },
    playbackPosition: {
        defaultInterval: 60
    },
    subscription: {
        gift: {
            maxGiftCount: 10
        }
    },
    image: {
        upload: {
            avatar: {
                allowedFormats: [],
                maxSize: null,
                maxWidth: null
            },
            badge: {
                allowedFormats: [],
                maxSize: null,
                animationAllowed: false,
                sizeRatio: null,
                large: {
                    maxWidth: null
                },
                medium: {
                    maxWidth: null
                },
                original: {
                    maxWidth: null
                },
                small: {
                    maxWidth: null
                }
            },
            channelPoint: {
                allowedFormats: [],
                maxSize: null,
                animationAllowed: false,
                sizeRatio: null,
                large: {
                    maxWidth: null
                },
                medium: {
                    maxWidth: null
                },
                original: {
                    maxWidth: null
                },
                small: {
                    maxWidth: null
                }
            },
            channelPointReward: {
                allowedFormats: [],
                maxSize: null,
                animationAllowed: false,
                sizeRatio: null,
                large: {
                    maxWidth: null
                },
                medium: {
                    maxWidth: null
                },
                original: {
                    maxWidth: null
                },
                small: {
                    maxWidth: null
                }
            },
            channelRole: {
                allowedFormats: [],
                maxSize: null,
                animationAllowed: false,
                sizeRatio: null,
                large: {
                    maxWidth: null
                },
                medium: {
                    maxWidth: null
                },
                original: {
                    maxWidth: null
                },
                small: {
                    maxWidth: null
                }
            },
            smile: {
                allowedFormats: [],
                maxSize: null,
                animationAllowed: false,
                sizeRatio: null,
                large: {
                    maxWidth: null
                },
                medium: {
                    maxWidth: null
                },
                original: {
                    maxWidth: null
                },
                small: {
                    maxWidth: null
                }
            },
            slotCover: {
                allowedFormats: [],
                maxSize: null,
                maxWidth: null,
                maxHeight: null
            }
        }
    },
    viewersChannel: {
        unsubscribeOn: {
            mute: false,
            pageHide: false,
            volumeBelow: null
        }
    },
    badge: {
        levels: {
            silver: []
        }
    },
    tmr: {
        anytimeActivityId: null,
        ids: [],
        proxyIds: []
    },
    conditionalFeatures: {
        [EConditionalFeature.PAYMENT_YANDEX]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYMENT_QIWI]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYMENT_PAYPAL]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYMENT_CARD_GLOBAL]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_COZY_STREAMS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_NEWEST_CATEGORIES]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_FOLLOWED_CATEGORIES]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_OFTEN_STREAMS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_RECORDED_STREAMS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MAIN_PAGE_VISITED_STREAMS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYOUT_CARD_EUR]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYOUT_CARD_UAH]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYOUT_CARD_USD]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYMENT_APPLE_PAY]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.MULTI_CURRENCY]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_LIVE_CATCH_UP]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_STREAMS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_RECORDS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_EMBED]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.STREAM_RECORD]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.STREAM_RAID]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_PINNED_MESSAGES]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.STREAM_QUICK_ACTIONS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_USERS_LIST]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_USER_STAT]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.EMBED_SUBSCRIBE_VIEWERS_CHANNEL]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.EMBED_SUBSCRIBE_VIEWERS_DISABLED_SUPPORT_PROGRAM]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.EMBED_RANDOM_SUBSCRIBE_VIEWERS_CHANNEL]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_MESSAGES_BATCHING]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_STORE_LIMIT]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.RECOMMENDED]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_PAUSE]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_USER_COLOR_CONFIG]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_MENTIONS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_USER_MENTION]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.AUTH_THIRD_PARTY]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.FEEDBACK_LOADER]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_MODERATION_PANEL]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_CONTROLS_ON_CLICK]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SMILES_AND_BADGES_USAGE_DISABLE]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SMILES_IN_COMMENTS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SMILE_SUGGEST_WITHOUT_MAXIMAL_LIMIT]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SMILE_SUGGEST]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SMILE_SUGGEST_NAVIGATION]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_SETTINGS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.POINTS_APP_DEEPLINK]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHAT_SLOWMODE_SETTINGS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.HIDE_CHAT_USER_AVATAR]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.BIND_CARD_CURRENCY_SELECTION]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHANNEL_ROLES]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHANNEL_POINTS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.REWARD_PREVIEW]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.RECORDS_ACCESS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.CHATBOT_SETTINGS]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.SUBSCRIPTIONS_PAGE]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PUSH_NOTIFICATION]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.PAYMENT_CARD_BANK131]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_MOBILE]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_PREVIEW_PARAM]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.VK_PLAYER_ADS_CLIP]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.EMBED_CATALOG_AUTOPLAY]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        },
        [EConditionalFeature.BECOME_STREAMER_ON_SITE]: {
            threshold: 0,
            users: [],
            apps: [],
            disabledApps: []
        }
    },
    currencies: {
        list: [],
        methods: {},
        bindCard: {},
        default: void 0
    },
    limits: {
        donation: {
            min: {},
            max: {}
        },
        level: {
            min: {},
            max: {}
        },
        message: {
            min: {},
            max: {}
        },
        post: {
            min: {},
            max: {}
        }
    },
    comments: {
        feedLimit: 2,
        feedRepliesLimit: 1,
        extraCommentsLimit: 20,
        fullPageLimit: 20,
        fullPageRepliesLimit: 2,
        maxAttachedImages: 2
    },
    changePhone: {
        isNotifierFlowForced: false
    },
    locale: null,
    isLocaleEnabled: false,
    auth: {
        access: null,
        refresh: null,
        expiresIn: null
    },
    clientId: null,
    vkPlayId: null,
    currentTimeStamp: +Date.now(),
    isLogoutByApi: false,
    oauthRedirect: "",
    oauthRedirectNotSavingAuthCookie: "",
    discordLinkRedirect: "",
    oauthCookieDomain: null,
    oauthProviders: {},
    oauth: {
        boosty: {
            appId: "",
            redirectUri: "",
            from: "",
            url: "",
            createBlogUrl: ""
        },
        vkId: {
            appId: null,
            redirectUri: "",
            oauthUri: ""
        },
        vkplay: {
            redirectUri: ""
        }
    },
    isTestServer: false,
    isServerRendering: true,
    isMobile: false,
    isAndroid: false,
    isIOs: false,
    isWidget: false,
    isErrorsReportEnable: false,
    isSendLogsEnable: false,
    isRefHeaderEnable: false,
    isResourceIdHeaderEnable: false,
    isLocaleHeaderEnable: false,
    isWithCredentialsEnable: false,
    isError: false,
    isError403: false,
    isError404: false,
    isError500: false,
    isError502: false,
    isBlogNotFound: false,
    browserFamily: "",
    corporateBlogUrl: "",
    supportEmail: null,
    supportUrl: "",
    hosts: {
        main: "",
        api: "",
        websocket: "",
        static: "",
        boosty: "boosty.to",
        js: "",
        css: "",
        uploadRegExp: "",
        uploadImg: "",
        sdk: "",
        widgetLinkHost: ""
    },
    defaultTitle: "",
    chat: {
        linkUsageType: null,
        messagesLimit: 20,
        maxMessageLength: 1e3,
        overscanRowCount: 10,
        messageAuthorDoubleClickDelay: 300,
        cleanChatMessageCount: 200,
        cleanChatMessageInterval: 3600
    },
    stat: {
        videoStartDelay: 0
    },
    user: {
        nick: {
            changeLockPeriod: 86400
        },
        avatar: {
            limits: {
                checkWidth: false,
                unit: EFileSizeUnit.B
            }
        },
        isBoostyAccountLinkInRequestAccessEnabled: false
    },
    record: {
        cover: {
            limits: {
                formats: [],
                maxWidth: null,
                maxHeight: null,
                maxSize: null
            }
        },
        playbackPositionDefault: 0
    },
    videoClips: {
        defaultOrderBy: EVideoClipsOrderBy.CREATED,
        initialClipDuration: 60,
        maxClipDuration: 60,
        maxStreamOffset: 600,
        minClipDuration: 5,
        optimization: {
            renderScheduler: ERenderScheduler.REQUEST_ANIMATION_FRAME,
            timeout: null
        },
        snippetDuration: 180
    },
    chatbot: {
        timer: {
            maxTimeInterval: 5184e3,
            maxMessageInterval: 1e4
        }
    },
    topMenu: {
        actionsLinks: [],
        links: [],
        isBlacklistEnabled: false
    },
    footer: {
        copyright: "",
        links: []
    },
    support: {
        isEnabled: true,
        url: ""
    },
    applications: {
        url: ""
    },
    notifications: {
        antiAdblockBannerDelay: 6048e5,
        isEnabled: false,
        opacity: {
            icon: "0.8",
            dropdown: "0.8"
        },
        texts: {
            title: "",
            content: ""
        },
        firebase: {
            config: {},
            vapidKey: "",
            timeToLive: ""
        }
    },
    boostyLink: {
        url: "",
        from: ""
    },
    offer: {
        [EConfigOffer.PRIVACY_POLICY]: {
            url: "",
            title: "",
            text: {
                ru: "",
                en: ""
            }
        },
        [EConfigOffer.SUPPORT_PROGRAM_OFFER]: {
            url: "",
            title: "",
            text: {
                ru: "",
                en: ""
            },
            textForSelfEmployed: {
                ru: "",
                en: ""
            }
        },
        [EConfigOffer.USER_AGREEMENT]: {
            url: "",
            title: "",
            text: {
                ru: "",
                en: ""
            }
        }
    },
    project: {
        name: {
            ru: "",
            en: ""
        }
    },
    sidePanel: {
        recommendedCount: 5,
        recommendedLimit: 50,
        subscribedCount: 5,
        viewedCount: 2
    },
    supportProgram: {
        isBeta: true,
        isSelfEmployed: false,
        isVkPay: false,
        textHtml: ""
    },
    selfEmployedUrl: "",
    isWebView: false,
    feedback: {
        main: null,
        stream: null
    },
    embed: {
        catalog: {
            isSliderDisabledWhileNotPlayingVideo: false
        },
        direct: {
            whiteList: [],
            blackList: []
        },
        random: {
            whiteList: [],
            blackList: []
        }
    },
    channelPoint: {
        default: {
            name: ""
        }
    },
    reward: {
        maxFilesize: {
            large: null,
            medium: null,
            original: null,
            small: null
        },
        size: {
            large: null,
            medium: null,
            original: null,
            small: null
        },
        count: null
    },
    drops: {
        vkPlayMarketUrl: "",
        refetchCampaignWithRequestedProductsTimeout: 1e3,
        notificationTimeout: 1e3
    },
    urls: {
        vkUrl: null,
        telegramUrl: null,
        profileSettingsUrl: null,
        recomendationTechnologiesHelp: null,
        bitrateInfoUrl: null
    },
    pushNotification: {
        web: {
            settings: {
                transport: "",
                switch: ""
            }
        },
        email: {
            settings: {
                transport: "",
                switch: ""
            }
        },
        mobile: {
            settings: {
                transport: "",
                switch: ""
            }
        },
        giftEmail: {
            settings: {
                transport: "",
                switch: ""
            }
        },
        timeout: null
    },
    videoPlayer: {
        cmafLowLatency: {
            permille: 1e3,
            whiteList: []
        },
        streamsAdsSlotId: null,
        recordsAdsSlotId: null,
        adsPermille: 1e3,
        adsWhiteList: [],
        adsBlackList: [],
        adsSiteBlackList: [],
        androidPreferredFormat: ""
    },
    apps: {
        instructions: {
            LG: "",
            samsung: ""
        },
        names: {
            androidTv: "",
            LG: "",
            samsung: ""
        },
        urls: {
            apk: "",
            appStore: "",
            googlePlay: "",
            getApps: "",
            appGallery: "",
            ruStore: "",
            androidTv: ""
        }
    },
    indication: {
        [EIndication.BOXES]: null,
        [EIndication.BROWSER_NOTIFICATIONS]: null
    },
    logo: "",
    playlist: {
        cover: {
            limits: {
                formats: [],
                maxWidth: null,
                maxHeight: null,
                maxSize: null
            }
        }
    },
    mediaScope: {
        hosts: {
            start: "",
            end: "",
            ping: ""
        },
        pingInterval: 3e4
    },
    theme: EUITheme.SYSTEM,
    email: {
        confirmationCodeExpirationTime: null,
        changeExpirationTime: null
    }
};
let CONFIG = {
    ...DEFAULT_CONFIG
};
const getConfig = ()=>CONFIG;
const updateConfig = (config2)=>CONFIG = merge$3(CONFIG, config2);
EAppId.WEB, ECurrency.USD;
const LocalDatePatterns = {
    [ELocale.RU]: {
        "dd/LLL/yyyy": "dd LLL yyyy",
        "HH/mm": "HH:mm",
        "HH/mm/ss": "HH:mm:ss",
        "&/HH/mm": "& HH:mm",
        "dd/MM/yyyy": "dd.MM.yyyy",
        "yyyy/MM/dd": "yyyy-MM-dd",
        "LLLL/yyyy": "LLLL yyyy",
        "dd/MM": "dd.MM",
        "dd/MM/yy": "dd.MM.yy",
        "dd/MM/yy/&/HH/mm": "dd.MM.yy & HH:mm",
        "EEEEEE": "EEEEEE",
        "dd/MMMM/yyyy": "dd MMMM yyyy",
        "dd/MM/yyyy/HH/mm": "dd.MM.yyyy HH:mm",
        "dd/MMMM/&/HH/mm": "dd MMMM & HH:mm",
        "dd/MMMM/HH/mm": "dd MMMM HH:mm",
        "dd/MMM/&/HH/mm": "dd MMM & HH:mm",
        "dd/MMMM": "dd MMMM",
        "dd/MMMM/yyyy/&/HH/mm": "dd MMMM yyyy & HH:mm",
        "dd/MMM/yyyy/&/HH/mm": "dd MMM yyyy & HH:mm",
        "d/MMMM": "d MMMM",
        "dd/LLL": "dd LLL",
        "LLLL": "LLLL",
        "dd/MM/yy/HH/mm/ss": "dd.MM.yy HH:mm:ss"
    },
    [ELocale.EN]: {
        "dd/LLL/yyyy": "dd LLL yyyy",
        "HH/mm": "HH:mm",
        "HH/mm/ss": "HH:mm:ss",
        "&/HH/mm": "& HH:mm",
        "dd/MM/yyyy": "MMM dd yyy",
        "yyyy/MM/dd": "yyyy-MM-dd",
        "LLLL/yyyy": "LLLL yyyy",
        "dd/MM": "MMM dd",
        "dd/MM/yy": "MMM dd yy",
        "EEEEEE": "EEEEEE",
        "dd/MMMM/yyyy": "dd MMMM yyyy",
        "dd/MM/yy/&/HH/mm": "dd.MM.yy HH:mm",
        "dd/MM/yyyy/HH/mm": "MMM dd yyyy HH:mm",
        "dd/MMMM/&/HH/mm": "MMMM dd HH:mm",
        "dd/MM/yy/HH/mm/ss": "MMM dd yyyy HH:mm:ss",
        "dd/MMMM/HH/mm": "MMMM dd HH:mm",
        "dd/MMM/&/HH/mm": "MMM dd HH:mm",
        "dd/MMMM": "dd MMMM",
        "dd/MMMM/yyyy/&/HH/mm": "MMMM dd yyyy HH:mm",
        "dd/MMM/yyyy/&/HH/mm": "MMM dd yyyy HH:mm",
        "d/MMMM": "dd MMMM",
        "dd/LLL": "dd LLL",
        "LLLL": "LLLL"
    }
};
const PHONE_COUNTRY_CODES = '["93","358","355","213","1684","376","244","1264","672","1268","54","374","297","61","43","994","1242","973","880","1246","375","32","501","229","1441","975","591","387","267","55","246","673","359","226","257","855","237","1","238"," 345","236","235","56","86","61","61","57","269","242","243","682","506","225","385","53","357","420","45","253","1767","1849","593","20","503","240","291","372","251","500","298","679","358","33","594","689","241","220","995","49","233","350","30","299","1473","590","1671","502","44","224","245","595","509","379","504","852","36","354","91","62","98","964","353","44","972","39","1876","81","44","962","77","254","686","850","82","965","996","856","371","961","266","231","218","423","370","352","853","389","261","265","60","960","223","356","692","596","222","230","262","52","691","373","377","976","382","1664","212","258","95","264","674","977","31","599","687","64","505","227","234","683","672","1670","47","968","92","680","970","507","675","595","51","63","872","48","351","1939","974","40","7","250","262","590","290","1869","1758","590","508","1784","685","378","239","966","221","381","248","232","65","421","386","677","252","27","211","500","34","94","249","597","47","268","46","41","963","886","992","255","66","670","228","690","676","1868","216","90","993","1649","688","256","380","971","44","1","598","998","678","58","84","1284","1340","681","967","260","263"]';
const PHONE_COUNTRY_CODES_MASKS = {
    "380": [
        "(",
        /[1-9]/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ],
    "default": [
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ]
};
const URL_LINK_REGEXP = /(\b(https?|ftp|file):\/\/[-A-Zа-яёА-ЯЁ0-9+&@#\/%?=~_|!:,.;]*[-A-Zа-яёА-ЯЁ0-9+&@#\/%=~_|])/ig;
const SEC_PER_MIN = 60;
const MIN_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const DAYS_PER_WEEK$1 = 7;
const DAYS_PER_MONTH = 30;
const MONTHS_PER_YEAR = 12;
const SEC_PER_HOUR = SEC_PER_MIN * MIN_PER_HOUR;
const SEC_PER_DAY = SEC_PER_HOUR * HOURS_PER_DAY;
const SEC_PER_WEEK = SEC_PER_DAY * DAYS_PER_WEEK$1;
const SEC_PER_MONTH = SEC_PER_DAY * DAYS_PER_MONTH;
const SEC_PER_YEAR = SEC_PER_MONTH * MONTHS_PER_YEAR;
const MS_PER_SEC = 1e3;
const MS_PER_MIN = SEC_PER_MIN * MS_PER_SEC;
const MS_PER_HOUR = SEC_PER_HOUR * MS_PER_SEC;
const MS_PER_DAY = SEC_PER_DAY * MS_PER_SEC;
const MS_PER_WEEK = SEC_PER_WEEK * MS_PER_SEC;
const MS_PER_MONTH = SEC_PER_MONTH * MS_PER_SEC;
const MS_PER_YEAR = SEC_PER_YEAR * MS_PER_SEC;
const URL_PREFIX = "app";
const RATING_PROGRAM_SEASON_CURRENT = "/channel/:blogUrl/support_program/season/current";
const API_URL = {
    OAUTH_REFRESH_TOKEN: "/oauth/token/",
    OAUTH_TOKEN: "/oauth/token",
    OAUTH_SERVER_CHECK_APP: "/oauth/server/check_app",
    OAUTH_SERVER_AUTHORIZE: "/oauth/server/authorize",
    OAUTH_SERVER_TOKEN: "/oauth/server/token",
    OAUTH_PHONE_AUTHORIZE: "/oauth/phone/authorize",
    OAUTH_PHONE_TOKEN: "/oauth/phone/token",
    DEV_USER_TOKEN: "/dev/v1/user/token",
    OAUTH_DEVICE_INFO: "/oauth/device_flow/device_info/",
    OAUTH_DEVICE_EXCHANGE: "/oauth/device_flow/exchange/",
    OAUTH_VKPLAY_TOKEN: "/oauth/vkplay/token",
    OAUTH_VK_ID_TOKEN: "/oauth/vkconnect/vk/token",
    AUTH_BY_EMAIL_SIGN_IN: "/user/auth/email/token",
    AUTH_BY_EMAIL_SIGN_UP: "/user/auth/email",
    AUTH_BY_EMAIL_CHANGE_PASSWORD_WITH_CODE: "/user/auth/email/password/restore",
    AUTH_BY_EMAIL_CHANGE_PASSWORD: "/user/auth/email/password",
    AUTH_BY_EMAIL_SEND_LINK_FOR_CHANGE_PASSWORD: "/user/auth/email/password/restore/send",
    AUTH_MERGE: "/user/auth/merge",
    BLOG: "/blog/:blogUrl",
    BLOG_CREATE: "/blog/",
    BLOG_SUBSCRIPTION_LEVELS: "/blog/:blogUrl/subscription_level/",
    BLOG_SUBSCRIPTION_LEVELS_BY_ID: "/blog/:blogUrl/subscription/level/:levelId",
    BLOG_SUBSCRIPTION_LEVELS_CREATE: "/blog/:blogUrl/subscription/level",
    BLOG_COVER_EDIT: "/blog/:blogUrl/cover",
    BLOG_SUBSCRIBERS: "/blog/:blogUrl/subscribers",
    BLOG_RESUBSCRIBE: "/blog/:blogUrl/resubscribe/:levelId",
    BLOG_UNSUBSCRIBE: "/blog/:blogUrl/unsubscribe",
    BLOG_FOLLOW: "/blog/:blogUrl/follow",
    BLOG_COMPLAIN: "/blog/:blogUrl/complain/",
    BLOG_REVERT_CHANGES: "/blog/:blogUrl/subscription/revert_changes",
    BLOG_SOCIAL_LINKS: "/blog/:blogUrl/social_links",
    BLOG_ADDITIONAL_PAYMENT: "/blog/:blogUrl/additional_payment/:levelId",
    BLOG_PAYMENT_INFO: "/blog/:blogUrl/payment_info/:levelId",
    BLOG_SEARCH_USER: "/blog/:blogUrl/search",
    BLOG_REF_LINK: "/blog/:blogUrl/ref",
    BLOG_STAT_BASE: "/blog/stat/:blogUrl/current",
    BLOG_STAT_METRICS: "/blog/stat/:blogUrl/metrics",
    BLOG_STAT_REF: "/blog/referral/:blogUrl/stat/",
    BLOG_STAT_REF_USERS: "/blog/referral/:blogUrl/user/",
    BLOG_STAT_CHARTS: "/blog/:blogUrl/stat/data",
    BLOG_STAT_SUBSCRIPTIONS: "/blog/:blogUrl/stat/subscriptions",
    BLOG_STAT_CSV: "/blog/stat/:blogUrl/csv/:dataType",
    BLOG_STAT_EVENTS: "/blog/stat/:blogUrl/events",
    BLOG_STAT_EVENTS_CONSTANTS: "/blog/stat/:blogUrl/events/constants",
    BLOG_STAT_SEARCH: "/blog/stat/:blogUrl/search",
    BLOG_BROADCAST_MESSAGE_STATS: "/blog/:blogUrl/sales/dialog_broadcast_message/",
    BLOG_HOLDS_STATS: "/blog/:blogUrl/sales/hold/",
    BLOG_DONATIONS: "/blog/:blogUrl/donations",
    BLOG_DONATIONS_SALES: "/blog/:blogUrl/sales/donation/",
    BLOG_POST_SALES: "/blog/:blogUrl/post_sales",
    BLOG_BLACKLIST: "/blacklist/",
    BLOG_BLACKLIST_ADD_USER: "/blacklist/:userId",
    BLOG_BLACKLIST_DELETE_USER: "/blacklist/:userId",
    BLOG_AGENT_ASSIGN: "/blog/:blogUrl/agent",
    BLOG_AGENT_UNASSIGN: "/blog/:blogUrl/agent/:userId",
    BLOG_AGENT_LIST: "/blog/:blogUrl/agent/",
    DROP_CAMPAIGNS: "/drop_campaign/relevant/",
    DROP_CAMPAIGN: "/drop_campaign/:dropCampaignId",
    DROP_CAMPAIGN_PRODUCT_CLAIM: "/drop_campaign/:dropCampaignId/products_request",
    DROP_CAMPAIGN_RANDOM_STREAM: "/drop_campaign/:dropCampaignId/channel/random",
    POST: "/blog/:blogUrl/post/:postId",
    POST_CREATE: "/blog/:blogUrl/post/",
    POST_LIKE: "/blog/:blogUrl/post/:postId/like",
    POST_REACTION: "/blog/:blogUrl/post/:postId/reaction",
    POST_COMPLAIN: "/blog/:blogUrl/post/:postId/complain/",
    POST_COMMENT: "/blog/:blogUrl/post/:postId/comment/:commentId",
    CHANNEL_POINT: "/channel/:blogUrl/point",
    CHANNEL_MANAGE_PREDICTION: "/channel/:blogUrl/manage/prediction",
    CHANNEL_MANAGE_PREDICTION_DONE: "/channel/:blogUrl/manage/prediction/done",
    CHANNEL_MANAGE_PREDICTION_DECISION: "/channel/:blogUrl/manage/prediction/decision",
    CHANNEL_PREDICTION: "/channel/:blogUrl/prediction",
    CHANNEL_PREDICTION_BY_ID: "/channel/:blogUrl/prediction/:predictionId",
    CHANNEL_PREDICTION_BID: "/channel/:blogUrl/prediction/bid",
    CHANNEL_DROPS_PROGRESS: "/channel/:blogUrl/stream/slot/:slotUrl/drop_campaign/progress/",
    STREAM_RECORD_CHAT: "/channel/:blogUrl/record/:recordId/chat/",
    // TODO: delete if not used
    STREAM_SETTINGS: "/channel/:blogUrl/manage/stream",
    STREAM_SLOTS_MANAGE: "/channel/:blogUrl/manage/stream/slot/",
    STREAM_SLOT_MANAGE: "/channel/:blogUrl/manage/stream/slot/:slotId",
    CHANNEL_VK_COMMUNITIES_LIST: "/channel/:blogUrl/manage/vk/group/",
    CHANNEL_VK_COMMUNITY: "/channel/:blogUrl/manage/vk/group",
    CHANNEL_BOOSTY_LINK: "/channel/:blogUrl/manage/boosty_link",
    CHANNEL_CREATE: "/channel/",
    CHANNEL_SETTINGS: "/channel/:blogUrl/manage",
    CHANNEL_SETTINGS_AVATAR: "/channel/:blogUrl/manage/avatar",
    CHANNEL_BAN: "/channel/:blogUrl/ban/",
    CHANNEL_BAN_USER: "/channel/:blogUrl/ban/:userId",
    CHANNEL_MANAGE_NEW_RECORDS_SUBSCRIPTION_LEVEL: "/channel/:blogUrl/manage/record_subscription_level",
    CHANNEL_MANAGE_COVER_TYPE: "/channel/:blogUrl/manage/cover_type",
    CHANNEL_MANAGE_COVER_IMAGE: "/channel/:blogUrl/manage/cover_image",
    CHANNEL_MANAGE_RAIDABLE: "/channel/:blogUrl/manage/raidable",
    CHANNEL_MANAGE_RAID_SETTINGS: "/channel/:blogUrl/manage/raid_settings",
    CHANNEL_MANAGE_SELF_HIDDEN: "/channel/:blogUrl/manage/self_hidden",
    CHANNEL_MANAGE_RECORDING: "/channel/:blogUrl/manage/stream_recording",
    CHANNEL_MANAGE_DESCRIPTION: "/channel/:blogUrl/manage/description",
    CHANNEL_MANAGE_DROP_CAMPAIGNS: "/channel/:blogUrl/manage/drop_campaigns",
    CHANNEL_MANAGE_FLAG: "/channel/:blogUrl/manage/:flag",
    CHANNEL_STREAM_HEARTBEAT: "/channel/:blogUrl/stream/:streamId/heartbeat/viewer",
    CHANNEL_DONATION_SERVICE: "/channel/:blogUrl/manage/donation_service",
    CHANNEL_DONATION_SERVICE_LIST: "/channel/:blogUrl/manage/donation_service/",
    CHANNEL_STREAM_SLOT: "/channel/:blogUrl/stream/slot/:slotUrl",
    REQUEST_DROP_CAMPAIGN_PRODUCTS: "/drop_campaign/:dropCampaignId/products_request",
    REWARD_ACTIVATE: "/channel/:blogUrl/point/reward/:id/activate",
    STREAM: "/blog/:blogUrl/video_stream",
    STREAM_CREDENTIALS: "/blog/:blogUrl/video_stream/credentials",
    STREAM_COMPLAIN: "/blog/:blogUrl/video_stream/complain/",
    STREAM_LIKE: "/blog/:blogUrl/video_stream/like",
    STREAM_NOTIFY: "/blog/:blogUrl/video_stream/notify",
    STREAM_RECORD: "/blog/:blogUrl/video_stream/record",
    STREAM_HEARTBEAT: "/blog/:blogUrl/video_stream/heartbeat/viewer",
    PUBLIC_STREAM: "/blog/:blogUrl/public_video_stream",
    PUBLIC_STREAM_CREDENTIALS: "/blog/:blogUrl/public_video_stream/credentials",
    PUBLIC_STREAM_COMPLAIN: "/blog/:blogUrl/public_video_stream/complain/",
    PUBLIC_STREAM_LIKE: "/channel/:blogUrl/stream/slot/:slotUrl/like",
    PUBLIC_STREAM_NOTIFY: "/blog/:blogUrl/public_video_stream/notify",
    PUBLIC_STREAM_CATEGORY: "/public_video_stream/category/",
    PUBLIC_STREAM_RECORDS_TOGGLE: "/blog/:blogUrl/public_video_stream/record",
    PUBLIC_STREAM_SELF_HIDDEN: "/blog/:blogUrl/public_video_stream/self_hide",
    PUBLIC_STREAM_CAN_BE_RAIDED: "/blog/:blogUrl/public_video_stream/can_be_raided",
    PUBLIC_STREAM_RAID: "/blog/:blogUrl/public_video_stream/raid",
    PUBLIC_STREAM_RAID_START: "/blog/:blogUrl/public_video_stream/raid/start",
    PUBLIC_STREAM_RAID_REJECT: "/blog/:blogUrl/public_video_stream/raid/reject",
    PUBLIC_STREAM_RAID_USER_STATE: "/blog/:blogUrl/public_video_stream/raid/user_state",
    PUBLIC_STREAM_RAIDABLE_STREAMS: "/user/public_video_stream/subscriptions/raidable/",
    PUBLIC_STREAM_REQUEST_ACCESS: "/public_video_stream/request_access/",
    PUBLIC_STREAM_SEARCH: "/search/public_video_stream/blog/",
    PUBLIC_STREAM_HIDE_STREAM: "/blog/:blogUrl/public_video_stream/hide",
    CHANNEL_RAID_VIEWER: "/channel/:blogUrl/raid/viewer",
    CHANNEL_ANALYTICS: "/channel/:blogUrl/analytics",
    CHANNEL_ANALYTICS_STREAM: "/channel/:blogUrl/analytics/stream/:streamId",
    CHANNEL_ANALYTICS_STREAMS_LIST: "/channel/:blogUrl/analytics/stream/",
    CHANNEL_SAVE_RECORD_TIME_CODE: "/channel/:blogUrl/record/:recordId/timecode/",
    CHANNEL_SAVE_STREAM_TIME_CODE: "/channel/:blogUrl/stream/:streamId/timecode/",
    CHANNEL_SUBSCRIPTIONS_LIST: "/channel/:blogUrl/subscription_level/",
    CHANNEL_NOTIFICATION_SETTINGS: "/channel/:blogUrl/notify_subscription",
    CHANNEL_NOTIFICATION_SETTINGS_TRANSPORT: "/channel/:blogUrl/notify_subscription/transport",
    CHANNEL_MODERATOR_USER: "/channel/:blogUrl/moderator/:userId",
    CHANNEL_MANAGE_MODERATOR: "/channel/:blogUrl/manage/moderator/",
    CHANNEL_MANAGE_MODERATOR_USER: "/channel/:blogUrl/manage/moderator/:userId",
    STREAM_SLOTS_LIST: "/channel/:blogUrl/stream/all/",
    STREAM_CHAT: "/blog/:blogUrl/video_stream/chat",
    STREAM_CHAT_DELETE: "/blog/:blogUrl/video_stream/chat/:messageId",
    STREAM_CHAT_CLEAN: "/blog/:blogUrl/chat/clean",
    STREAM_CHAT_TOKEN: "/blog/:blogUrl/video_stream/chat/token",
    STREAM_CHAT_BAN_STAT: "/blog/:blogUrl/video_stream/chat/stat",
    STREAM_CHAT_BAN: "/blog/:blogUrl/video_stream/ban",
    STREAM_CHAT_STOP_WORD: "/blog/:blogUrl/video_stream/chat/stop_word",
    PUBLIC_STREAM_CHAT: "/blog/:blogUrl/public_video_stream/chat",
    PUBLIC_STREAM_CHAT_POST: "/channel/:blogUrl/stream/slot/:slotUrl/chat",
    PUBLIC_STREAM_CHAT_DELETE: "/blog/:blogUrl/public_video_stream/chat/:messageId",
    PUBLIC_STREAM_CHAT_CLEAN: "/blog/:blogUrl/public_video_stream/chat/clean",
    PUBLIC_STREAM_CHAT_CLEAN_ALL: "/channel/:blogUrl/chat/all",
    PUBLIC_STREAM_CHAT_TOKEN: "/blog/:blogUrl/public_video_stream/chat/token",
    PUBLIC_STREAM_CHAT_BAN_STAT: "/blog/:blogUrl/public_video_stream/chat/stat",
    PUBLIC_STREAM_CHAT_BAN: "/channel/:blogUrl/public_video_stream/ban/stream/slot/:slotUrl",
    PUBLIC_STREAM_CHAT_STOP_WORD: "/blog/:blogUrl/public_video_stream/chat/stop_word",
    PUBLIC_STREAM_CHAT_MODERATOR: "/blog/:blogUrl/public_video_stream/moderator",
    PUBLIC_STREAM_CHAT_REMOVE_MODERATOR: "/blog/:blogUrl/public_video_stream/moderator/:userId",
    PUBLIC_STREAM_CHAT_SETTINGS: "/blog/:blogUrl/public_video_stream/chat/settings",
    PUBLIC_STREAM_CHAT_USERS: "/blog/:blogUrl/public_video_stream/chat/user/",
    PUBLIC_STREAM_CHAT_USER_STAT: "/blog/:blogUrl/public_video_stream/chat/stat",
    PUBLIC_STREAM_CHAT_USER_SEARCH_LIST: "/blog/:blogUrl/public_video_stream/chat/user/search/",
    PUBLIC_STREAM_CHAT_PINNED_MESSAGE: "/channel/:blogUrl/public_video_stream/chat/pinned_message",
    PUBLIC_STREAM_CHAT_PINNED_MESSAGE_REACTION: "/channel/:blogUrl/public_video_stream/chat/pinned_message/reaction",
    PUBLIC_STREAM_CHAT_THREAD_MESSAGES: "/blog/:blogUrl/public_video_stream/chat/thread/:threadId",
    PUBLIC_STREAM_CHAT_WINNER_SUBSCRIBER: "/channel/:blogUrl/chat/winner/subscriber",
    PUBLIC_STREAM_CHAT_WINNER_CHAT_VIEWER: "/channel/:blogUrl/chat/winner/chat_viewer",
    PUBLIC_STREAM_CHAT_WINNER_WORD: "/channel/:blogUrl/chat/winner/word",
    VIDEO_CLIP: "/channel/:channelUrl/clip/:videoClipId",
    VIDEO_CLIP_CREATE_FROM_RECORD: "/channel/:channelUrl/clip/record/",
    VIDEO_CLIP_CREATE_FROM_STREAM: "/channel/:channelUrl/clip/stream/",
    VIDEO_CLIP_HIDE: "/channel/:channelUrl/clip/:videoClipId/hide",
    VIDEO_CLIP_LIKE: "/channel/:channelUrl/clip/:videoClipId/like",
    VIDEO_CLIP_UNRESTRICTED: "/channel/:channelUrl/manage/clip/:videoClipId",
    VIDEO_CLIP_VIEW: "/channel/:channelUrl/clip/:videoClipId/view",
    VIDEO_CLIP_CHAT: "/channel/:channelUrl/clip/:videoClipId/chat/",
    VIDEO_CLIPS_ACTIVE: "/channel/:channelUrl/clip/",
    VIDEO_CLIPS_PROCESSING: "/channel/:channelUrl/clip/processing/",
    VIDEO_CLIPS_UNRESTRICTED: "/channel/:channelUrl/manage/clip/",
    VIDEO_SNIPPET: "/channel/:channelUrl/clip/template/:videoSnippetId",
    VIDEO_SNIPPET_CREATE: "/channel/:channelUrl/clip/template/",
    CHANNEL_MANAGE_VIDEO_CLIP_CREATION: "/channel/:channelUrl/manage/clip_creation",
    DIALOG_TOKEN: "/dialog/:dialogId/token",
    DIALOG_BY_USER_ID: "/dialog",
    DIALOG_LIST: "/dialog/",
    DIALOG_CREATE: "/dialog/",
    DIALOG: "/dialog/:dialogId",
    DIALOG_SHORT: "/dialog/:dialogId/short",
    DIALOG_READ_ALL: "/dialog/read",
    DIALOG_MESSAGE_LIST: "/dialog/:dialogId/message/",
    DIALOG_MESSAGE_CREATE: "/dialog/:dialogId/message",
    DIALOG_BROADCAST_MESSAGE_CREATE: "/dialog/blog/:blogUrl/broadcast/message/",
    DIALOG_MESSAGE: "/dialog/:dialogId/message",
    DIALOG_CURRENT_MESSAGE: "/dialog/message/:messageId",
    DIALOG_MESSAGE_READ: "/dialog/message/:messageId/read",
    DIALOG_CONTACTS: "/dialog/contacts",
    DIALOG_MAILING_LIST: "/dialog/blog/:blogUrl/broadcast/contact/",
    DIALOG_CAN_WRITE_WITH_DONATION: "/dialog/:blogUrl/can_write_whith_donation",
    DEFERRED_ACCESS: "/blog/:blogUrl/post/:id/deferred_access/",
    DEFERRED_ACCESS_EDIT: "/blog/:blogUrl/post/:id/deferred_access/:deferredAccessId",
    COMMENTS: "/blog/:blogUrl/post/:id/comment/",
    COMMENTS_DELETE: "/blog/:blogUrl/post/:postId/comment/:commentId",
    COMMENTS_COMPLAIN: "/blog/:blogUrl/post/:postId/comment/:commentId/complain/",
    COMMENTS_RESTORE: "/blog/:blogUrl/post/:postId/comment/:commentId/restore",
    COMMENTS_REACTION: "/blog/:blogUrl/post/:postId/comment/:commentId/reaction",
    BLOG_POST_SALES_BY_DATE: "/blog/:blogUrl/post/paid/by_date",
    BLOG_POST_SALES_DAYS_BY_MONTH: "/blog/:blogUrl/post/paid/days",
    BLOG_POSTS_FEED: "/blog/:blogUrl/post/",
    BLOG_POSTS_TAGS: "/blog/:blogUrl/post/tag/",
    USER: "/user/:id",
    USER_CURRENT: "/user/current",
    USER_CURRENT_FLAG: "/user/current/flag/:flag",
    USER_CURRENT_FETCH_VKPLAY_FOR_MERGE: "/user/current/onboarding",
    USER_CURRENT_VKPLAY_LINK: "/user/current/vkplay/link",
    USER_CURRENT_VKPLAY_LINK_BOOSTY: "/user/current/vkplay/link/boosty",
    USER_CURRENT_NICK_COLOR: "/user/current/nick_color",
    USER_CURRENT_GIFT_RECEIVING_MODE_FOLLOWER: "/user/current/subscriptions/receive_gift_only_as_follower",
    USER_SUBSCRIPTIONS: "/user/subscriptions",
    USER_AVATAR: "/user/current/avatar",
    USER_CHECK_NICK: "/user/current/nick",
    USER_FOLLOWING: "/user/following/",
    USER_SEND_EMAIL_CONFIRMATION_LETTER: "/user/current/email",
    USER_CONFIRM_EMAIL_LINK: "/v1/user/email/confirm/:code",
    USER_FINISH_TUTORIAL: "/user/current/finish_tutorial",
    USER_AUTH_LINK: "/user/auth_link/:type",
    USER_PHONE: "/user/current/phone",
    USER_PHONE_CHANGE: "/user/phone",
    USER_PHONE_CHECK: "/user/phone/check",
    USER_PHONE_CURRENT_CHECK: "/user/phone/check_current",
    USER_PHONE_APPROVE: "/user/phone/approve",
    USER_PHONE_CAN_ADD: "/user/phone/can_add",
    USER_PHONE_VERIFY_OLD: "/user/phone/verify_old",
    USER_NOTIFY_SETTINGS_OLD: "/user/notify_settings/:notificationType",
    USER_PRIVACY_POLICY: "/user/current/privacy",
    USER_REF_POLICY: "/user/current/ref_conv",
    USER_LOGIN: "/user/login",
    USER_LOCALE: "/user/locale",
    USER_BOOSTY_LINK: "/user/boosty_link",
    USER_DIALOG_SETTINGS: "/user/dialog_settings",
    USER_MANAGED_CHANNEL: "/user/managed_channel/",
    USER_CURRENT_LINK: "/user/current/link/",
    USER_OAUTH_LINK_VKPLAY: "/user/oauth_link/vkplay",
    USER_SEND_EMAIL_CONFIRMATION_CODE: "/user/current/send_email_confirm_code",
    USER_CONFIRM_EMAIL: "/user/current/confirm_email",
    SMILES: "/blog/:blogUrl/smile_level/",
    SMILES_IN_SUBSCRIPTION: "/blog/:blogUrl/smile_level/:levelId",
    USER_CURRENT_SCHEDULED_DELETION: "/user/current/scheduled_deletion",
    USER_MARKETING_ALERTS: "/user/alerts",
    USER_MARKETING_ALERT_DISMISS: "/user/alerts/:alertId/skip",
    USERS: "/users",
    PUBLIC_STREAM_USER_SUBSCRIPTIONS: "/user/public_video_stream/subscriptions",
    MEDIA_DATA_IMAGE_UPLOAD: "/media_data/image/",
    MEDIA_DATA_FILE_CONTAINER_CREATE: "/media_data/file/",
    MEDIA_DATA_AUDIO_CONTAINER_CREATE: "/media_data/audio/",
    MEDIA_DATA_VIDEO_CONTAINER_CREATE: "/media_data/ok_video/",
    MEDIA_DATA_VIDEO_UPLOAD_URL: "/media_data/video/upload_url",
    MEDIA_DATA_VIDEO_UPLOAD_FINISH: "/media_data/video/:id/finish",
    MEDIA_ALBUM_TILE: "/blog/:blogUrl/media_album/",
    MEDIA_ALBUM_COUNTERS: "/blog/:blogUrl/media_album/counters/",
    PAYMENT_BANK131_GET_SUBSCRIPTION_PAY_URL: "/channel/:blogUrl/subscription/level/:levelId/bank131/pay_url/",
    PAYMENT_BANK131_PAY_FOR_SUBSCRIPTION: "/channel/:blogUrl/subscription/level/:levelId/bank131/pay/",
    PAYMENT_BANK131_GET_GIFT_PAY_URL: "/channel/:blogUrl/subscription/level/:levelId/gift/bank131/pay_url/",
    PAYMENT_BANK131_PAY_FOR_GIFT: "/channel/:blogUrl/subscription/level/:levelId/gift/bank131/pay/",
    PAYMENT_LIST: "/payment/bind/list",
    PAYMENT_PAY_SINGLE_PAYMENT_POST_WITH_BOUND_CARD: "/payment/pay/:blogUrl/post/:postId",
    PAYMENT_GET_SINGLE_PAYMENT_POST_URL: "/payment/url/:blogUrl/post/:postId",
    PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_URL: "/payment/url/message/:messageId",
    PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_WITH_BOUND_CARD: "/payment/pay/message/:messageId",
    PAYMENT_PAY_SINGLE_PAYMENT_DONATION_WITH_BOUND_CARD: "/payment/pay/:blogUrl/donation/:type",
    PAYMENT_GET_SINGLE_PAYMENT_DONATION_URL: "/payment/url/:blogUrl/donation/:type",
    PAYMENT_GET_SINGLE_PAYMENT_ONLY_BIND_URL: "/payment/url/bind",
    PAYMENT_DELETE_BIND: "/payment/bind/:bindId",
    PAYMENT_CHECK_ID: "/payment/check/:paymentId",
    PAYMENT_VALIDATE_APPLE_PAY_SESSION: "/payment/applepay/session",
    PAYMENT_TRANSACTION_STATUS: "/payment/:paymentId/transaction/status",
    PAYMENT_QIWI_STATUS: "/payment/:paymentId/qiwi_status",
    PAYMENT_DEFAULT_CURRENCY: "/payment/default_currency",
    CATALOG_SCHEMA: "/catalog/schema",
    CATALOG_ALL_SCHEMAS: "/catalog/schemas/",
    PAYOUT_SELF_EMPLOYED: "/user/current/self_employed",
    PAYOUT_CHECK_INN_STATE: "/user/current/self_employed/inn_state",
    PAYOUT_BIND_INN: "/user/current/self_employed/bind_inn",
    PAYOUT_BANK_CARD: "/user/current/bank_card/",
    PAYOUT_BIND_BANK_CARD: "/user/current/bank_card/bind",
    CATALOG_CATEGORIES: "/catalog/category/",
    PUBLIC_STREAM_CATALOG_CATEGORY: "/catalog/public_video_streams/category/",
    PUBLIC_STREAM_CATALOG_NEWEST_CATEGORY: "/catalog/public_video_streams/new_releases/",
    PUBLIC_STREAM_CATALOG_FOLLOWED_CATEGORY: "/public_video_stream/category/follow/",
    PUBLIC_STREAM_CATALOG_CATEGORY_STREAMS: "/catalog/public_video_streams/category/:categoryId/stream/",
    PUBLIC_STREAM_CATALOG_CATEGORY_RECORDS: "/catalog/public_video_streams/category/:categoryId/record/",
    PUBLIC_STREAM_CATALOG: "/catalog/public_video_streams/",
    PUBLIC_STREAM_CATALOG_RECOMMENDATIONS: "/catalog/public_video_streams/recommendations/",
    PUBLIC_STREAM_CATALOG_TOP: "/catalog/public_video_streams/top/",
    PUBLIC_STREAM_CATALOG_COZY: "/catalog/public_video_streams/warmlamp/",
    PUBLIC_STREAM_CATALOG_RECORDED: "/catalog/public_video_streams/records/",
    PUBLIC_STREAM_CATALOG_VISITED: "/catalog/public_video_streams/visits/",
    PUBLIC_STREAM_CATALOG_OFTEN: "/catalog/public_video_streams/active/",
    PUBLIC_STREAM_USER_CHAT_HISTORY: "/blog/:blogUrl/public_video_stream/chat/user/:userId",
    PUBLIC_STREAM_CATALOG_HISTORY: "/user/stream/views/",
    PUBLIC_STREAM_HIDDEN: "/public_video_stream/hide/",
    PUBLIC_STREAM_HIDDEN_CATEGORIES: "/public_video_stream/category/hide/",
    SUPPORT_CONTACT: "/support/",
    STAT: "/stat/:category/",
    STAT_GRAPHITE: "/graphite/:metric/",
    PAYOUT_HISTORY: "/blog/:blogUrl/payout/history/",
    BLOG_PAYOUTS: "/blog/:blogUrl/payout/",
    BLOG_PAYOUT_CREATE: "/blog/payout/:systemId",
    BLOG_PAYOUT_UPDATE: "/blog/payout/:payoutId",
    BLOG_PAYOUT_DELETE: "/blog/payout/:payoutId",
    BLOG_PAYOUT_CARD_FRAME: "/blog/payout/card_frame",
    BLOG_FLAG_SETTINGS: "/blog/:blogUrl/flag/:flag",
    BLOG_RSS_SETTINGS: "/blog/:blogUrl/rss/settings",
    BLOG_RSS_URL: "/blog/:blogUrl/rss/url",
    TARGET_TARGETS: "/target/:blogUrl/",
    TARGET_BY_ID: "/target/:targetId",
    TARGET_MONEY_CREATE: "/target/money",
    TARGET_SUBSCRIBERS_CREATE: "/target/subscribers",
    EXTERNAL_APPS_TELEGRAM_CONNECTION_URL: "/telegram/login/url",
    EXTERNAL_APPS_TELEGRAM_GROUP: "/telegram/:blogUrl/groups",
    EXTERNAL_APPS_DISCORD_BOT: "/discord/bot",
    EXTERNAL_APPS_DISCORD_ROLE: "/discord/role/",
    EXTERNAL_APP: "/external_app/:appId",
    THIRD_PARTY_APP_OAUTH: "/third_party_app/:slug/oauth",
    THIRD_PARTY_APP_CONNECTED: "/third_party_app/:slug/connected",
    THIRD_PARTY_APP_CONNECTED_LIST: "/third_party_app/connected/",
    GIFT: "/gift/:giftKey",
    GIFT_LIST: "/gift/",
    GIFT_ACCEPT: "/gift/:giftKey/accept",
    GIFT_SEND: "/gift/:giftKey/send",
    DOC_PAGES: "/doc/index/",
    DOC_PAGE: "/doc/page/:id",
    DOC_REQUEST_ACCESS: "/doc/request_access/",
    ACTIONS_JOURNAL: "/blog/:blogUrl/actions_journal/",
    NOTIFICATIONS: "/notification/standalone/event/",
    NOTIFICATION: "/notification/standalone/event/:eventId",
    NOTIFICATIONS_READ: "/notification/standalone/read/",
    NOTIFICATION_SETTINS: "/notification/settings/",
    NOTIFICATION_SETTINGS_UPDATE: "/notification/settings/:transport/:switch",
    POLL_UNSUBS: "/poll/unsubscribe_reasons",
    VOTE_UNSUBS: "/poll/unsubscribe_reasons/vote",
    POLL_UNSUB_REASONS_FETCH: "/poll/unsubscribe_reasons",
    POLL_UNSUB_REASONS_VOTE: "/poll/unsubscribe_reasons/vote",
    POLL_UNSUB_REASONS_FETCH_VOTERS: "/blog/:blogUrl/unsubscribe_reasons/",
    POLL_USER_GENERATED_FETCH_VOTERS: "/blog/:blogUrl/poll/:pollId/vote/",
    POLL_USER_GENERATED_CREATE: "/blog/:blogUrl/poll/",
    POLL_USER_GENERATED_VOTE: "/poll/:pollId/vote",
    POLL_USER_GENERATED_POLL: "/blog/:blogUrl/poll/:pollId",
    SEARCH_BLOG: "/search/blog/",
    SEARCH_BLOG_SUGGEST: "/search/blog/suggest/",
    SEARCH_BLOG_POST: "/search/blog/post/",
    SEARCH_USER: "/search/user/",
    SMILE: "/blog/:blogUrl/smile/:smileId",
    SMILE_CREATE: "/blog/:blogUrl/smile/",
    SMILE_LIST: "/blog/:blogUrl/smile_level/",
    SMILE_LIST_BY_LEVEL: "/blog/:blogUrl/smile_level/:levelId",
    SMILE_CHECK_NAME: "/blog/:blogUrl/smile/name",
    SMILE_IMAGE: "/blog/:blogUrl/smile/size/:sizeName",
    SMILE_USER_SET: "/blog/:blogUrl/smile/user_set/",
    SMILE_USER_SET_POPULAR: "/smile/user_set/popular/",
    SMILE_ORDER: "/blog/:blogUrl/smile_level/:levelId/order",
    SMILE_DATA: "/smile/:smileId",
    BADGE: "/blog/:blogUrl/badge/:badgeId",
    BADGE_LIST: "/blog/:blogUrl/badge/subscription/",
    BADGE_IMAGE: "/blog/:blogUrl/badge/size/:sizeName",
    BADGE_CREATE: "/blog/:blogUrl/badge/",
    CHANNEL_ROLE: "/channel/:blogUrl/role/:roleId",
    CHANNEL_ROLE_CREATE: "/channel/:blogUrl/role/",
    CHANNEL_ROLE_IMAGE: "/channel/:blogUrl/role/size/:sizeName",
    CHANNEL_ROLE_LIST: "/channel/:blogUrl/role/",
    CHANNEL_ROLE_USER_SET: "/channel/:blogUrl/role/user/",
    CHANNEL_ROLE_USER: "/channel/:blogUrl/role/user/:userId",
    CHANNEL_ROLE_USER_SEARCH: "/channel/:blogUrl/role/user/search",
    CHANNEL_ROLE_ORDER: "/channel/:blogUrl/role/order",
    CHANNEL_ROLE_CHECK_NAME: "/channel/:blogUrl/role/name",
    CHANNEL_POLL_MANAGE: "/channel/:blogUrl/manage/poll",
    CHANNEL_POLL: "/channel/:blogUrl/poll",
    CHANNEL_POLL_VOTE: "/channel/:blogUrl/poll/vote",
    CHANNEL_POLL_MANAGE_DONE: "/channel/:blogUrl/manage/poll/done",
    RATING_PROGRAM_SEASON_CURRENT: RATING_PROGRAM_SEASON_CURRENT,
    RATING_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT: "/channel/:blogUrl/support_program/season/current/reached_level_alert/accept",
    RATING_PROGRAM_SEASON_PREVIOUS_SEASON_FINISHED_ALERT_ACCEPT: "/channel/:blogUrl/support_program/season/previous/finished/accept",
    RATING_PROGRAM_SEASONS_HISTORY: "/channel/:blogUrl/support_program/season/history/",
    RATING_PROGRAM_STAT_DAILY: "/channel/:blogUrl/support_program/season/:seasonId/statistic/:metricName/daily/",
    RATING_PROGRAM_VERIFICATION_STATE: "/channel/:blogUrl/active_streamer/request",
    REWARD_MANAGER_FILTER: "/channel/:blogUrl/reward/manager/filter/",
    REWARD_MANAGER_DEMAND_LIST: "/channel/:blogUrl/reward/manager/demand/",
    REWARD_MANAGER_ACTION_ALL_DEMANDS: "/channel/:blogUrl/reward/manager/demand/all",
    REWARD_MANAGER_ACTION_DEMAND: "/channel/:blogUrl/reward/manager/demand",
    REWARD_MANAGER_ACTION_DEMAND_BY_ID: "/channel/:blogUrl/reward/manager/:id/demand",
    REWARD_MANAGER_REWARD_AVAILABILITY: "/channel/:blogUrl/manage/point/reward/:rewardId/enabled",
    REWARD_MANAGER_REWARD_CSV: "/channel/:blogUrl/reward/manager/demand/csv",
    SUPPORT_PROGRAM_ARCHIVE: "/channel/:blogUrl/support_program/season/archive/",
    SUPPORT_PROGRAM_SEASON: "/channel/:blogUrl/support_program/season/:seasonId",
    SUPPORT_PROGRAM_SEASON_CURRENT: RATING_PROGRAM_SEASON_CURRENT,
    SUPPORT_PROGRAM_SEASON_CURRENT_UNAUTHORIZED: RATING_PROGRAM_SEASON_CURRENT,
    SUPPORT_PROGRAM_SEASON_CURRENT_FEEDBACK: "/channel/:blogUrl/support_program/season/current/feedback",
    SUPPORT_PROGRAM_SEASON_CURRENT_SUBSCRIBE: "/channel/:blogUrl/support_program/season/current/subscribe",
    SUPPORT_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT: "/channel/:blogUrl/support_program/season/current/reached_level_alert/accept",
    SUPPORT_PROGRAM_SEASONS: "/channel/:blogUrl/support_program/season/",
    SUPPORT_PROGRAM_SEASONS_HISTORY: "/channel/:blogUrl/support_program/season/history/",
    SUPPORT_PROGRAM_STAT: "/channel/:blogUrl/support_program/stat",
    SUPPORT_PROGRAM_STAT_DAILY: "/channel/:blogUrl/support_program/season/:seasonId/statistic/:metricName/daily/",
    SUPPORT_PROGRAM_PAYOUT: "/channel/:blogUrl/support_program/season/:seasonId/payout",
    CHANNEL_SUBSCRIPTION_GIFT: "/channel/:blogUrl/subscription/gift/",
    CHANNEL_SUBSCRIPTION_GIFT_LEVEL: "/channel/:blogUrl/subscription/gift/:levelId",
    CHANNEL_SUBSCRIPTION_LEVEL_GIFT: "/channel/:blogUrl/subscription/level/:levelId/gift/",
    CHANNEL_SUBSCRIPTION_LEVEL_BOOSTY: "/channel/:blogUrl/subscription/level/boosty/:levelId",
    CHANNEL_SUBSCRIPTION_LEVEL_PAY_URL: "/channel/:blogUrl/subscription/level/:levelId/pay_url/",
    CHANNEL_SUBSCRIPTION_LEVEL_PAY: "/channel/:blogUrl/subscription/level/:levelId/pay/",
    CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY_URL: "/channel/:blogUrl/subscription/level/:levelId/gift/pay_url/",
    CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY: "/channel/:blogUrl/subscription/level/:levelId/gift/pay/",
    SUPPORT: "/support/",
    CHATBOT_TIMERS: "/channel/:blogUrl/chatbot/timer/",
    CHATBOT_TIMER: "/channel/:blogUrl/chatbot/timer/:timerId",
    CHATBOT_COMMAND_CREATE: "/v8/channel/:blogUrl/manage/chatbot/command",
    CHATBOT_COMMAND: "/v8/channel/:blogUrl/manage/chatbot/command/:commandId",
    CHATBOT_COMMANDS: "/v8/channel/:blogUrl/manage/chatbot/commands",
    CHATBOT_COMMAND_TOGGLE: "/v8/channel/:blogUrl/manage/chatbot/command/:commandId/active",
    NEWS: "/novelty/:noveltyId/view",
    NEWS_LATEST: "/novelty/new",
    NEWS_LAST: "/novelty/last",
    CHANNEL_STAT_BASIC: "/channel/:blogUrl/stat/basic",
    CHANNEl_POINT_BONUS: "/channel/:blogUrl/point/bonus/",
    CHANNEl_POINT_PENDING_BONUS: "/channel/:blogUrl/point/pending_bonus/",
    CHANNEl_POINT_PENDING_BONUS_GATHER: "/channel/:blogUrl/point/pending_bonus/:id/gather",
    OWN_CHANNEL_POINT: "/channel/:blogUrl/manage/point",
    OWN_CHANNEL_POINT_RESET: "/channel/:blogUrl/manage/point/reset",
    OWN_CHANNEL_POINT_ENABLED: "/channel/:blogUrl/manage/point/enabled",
    OWN_CHANNEL_POINT_IMAGE: "/channel/:blogUrl/manage/point/size/:sizeName",
    PUBLIC_STREAM_RANDOM: "/public_video_stream/random",
    PUBLIC_STREAM_RECORDS: "/blog/:blogUrl/public_video_stream/record/",
    PUBLIC_STREAM_RECORD: "/blog/:blogUrl/public_video_stream/record/:recordId",
    PUBLIC_STREAM_VIEW_RECORD: "/blog/:blogUrl/public_video_stream/record/:recordId/view",
    PUBLIC_STREAM_LIKE_RECORD: "/blog/:blogUrl/public_video_stream/record/:recordId/like",
    PUBLIC_STREAM_HIDE_RECORD: "/blog/:blogUrl/public_video_stream/record/:recordId/hide",
    PUBLIC_STREAM_UPLOAD_RECORD_PREVIEW: "/blog/:blogUrl/public_video_stream/record/:recordId/preview",
    HOST: "/blog/:blogUrl/public_video_stream/host",
    PUBLIC_STREAM_HIDE_CATEGORY: "/public_video_stream/category/:categoryId/hide",
    PUBLIC_STREAM_FOLLOW_CATEGORY: "/public_video_stream/category/:categoryId/follow",
    PUBLIC_STREAM_SEARCH_CATEGORY: "/search/stream_category/",
    SELF_USER: "/int/self/user/",
    CUSTOM_BLOCKS: "/blog/:blogUrl/custom_block/",
    CUSTOM_BLOCK: "/blog/:blogUrl/custom_block/:blockId",
    CUSTOM_BLOCKS_ORDER: "/blog/:blogUrl/custom_block/order",
    REWARD_LIST: "/channel/:blogUrl/point/reward/",
    REWARD_ID: "/channel/:blogUrl/reward/:id",
    REWARD_ENABLED: "/channel/:blogUrl/manage/point/reward/:id/enabled",
    OWN_REWARD_IMAGE: "/channel/:blogUrl/manage/point/reward/size/:size",
    OWN_REWARD: "/channel/:blogUrl/manage/point/reward",
    OWN_REWARD_LIST: "/channel/:blogUrl/manage/point/reward/",
    OWN_REWARD_ID: "/channel/:blogUrl/manage/point/reward/:id",
    STANDARD_REWARD_LIST: "/channel/:blogUrl/manage/point/general_reward/",
    STANDARD_REWARD_ID: "/channel/:blogUrl/manage/point/general_reward/:id",
    MULTIPLICATORS: "/channel/:blogUrl/manage/point/multiplier",
    DEVICE_TOKEN: "/oauth/device_token/",
    MODERATION_LOG: "/channel/:blogUrl/moderation/log/",
    PLAYLIST_MODERATOR: "/channel/:blogUrl/manage/playlist/:playlistId",
    PLAYLIST: "/channel/:blogUrl/playlist/:playlistId",
    PLAYLIST_ENTITY_LIST_MODERATOR: "/channel/:blogUrl/manage/playlist/:playlistId/entity/",
    PLAYLIST_ENTITY_LIST_RECORD: "/channel/:blogUrl/manage/playlist/:playlistId/record",
    PLAYLIST_ENTITY_DELETE: "/channel/:blogUrl/manage/playlist/:playlistId/entity/:entityId",
    PLAYLIST_ENTITY: "/channel/:blogUrl/playlist/:playlistId/entity/:entityId",
    PLAYLIST_ENTITY_LIST: "/channel/:blogUrl/playlist/:playlistId/entity/",
    PLAYLISTS_MODERATOR: "/channel/:blogUrl/manage/playlist/",
    PLAYLISTS: "/channel/:blogUrl/playlist/",
    PLAYLIST_MOVE: "/channel/:blogUrl/manage/playlist/:playlistId/move",
    PLAYLIST_ENTITY_MOVE: "/channel/:blogUrl/manage/playlist/:playlistId/entity/:entityId/move",
    PLAYLIST_MANAGE_RECORD: "/channel/:blogUrl/manage/record/for_playlist/:playlistId",
    PLAYLIST_HIDE: "/channel/:blogUrl/playlist/:playlistId/hide"
};
const INTERNAL_API_PREFIX = "int/self";
const INTERNAL_API_URLS = {
    MESSAGE: `/${INTERNAL_API_PREFIX}/message/:messageId`,
    DONATION: `/${INTERNAL_API_PREFIX}/donation/:donationId`,
    GIFT: `/${INTERNAL_API_PREFIX}/gift/:giftKey`,
    COMMENT: `/${INTERNAL_API_PREFIX}/comment/:commentId`,
    USERS: `/${INTERNAL_API_PREFIX}/users`
};
const WS_URLS = {
    CONNECT_TOKEN: "/ws/connect",
    REFRESH_TOKEN: "/ws/refresh",
    PRIVATE_TOKEN: "/ws/subscribe"
};
const URLS = {
    MAIN: "/",
    BLOG_POST: "/:blogUrl/posts/:postId",
    COMMUNITY_ROLES: `/${URL_PREFIX}/community/roles`,
    COMMUNITY_BLOG_POINTS: `/${URL_PREFIX}/channel/:blogUrl/points`,
    DROPS_CAMPAIGNS: `/${URL_PREFIX}/box/campaigns`,
    SETTINGS_EXTERNAL_APP: `/${URL_PREFIX}/settings/external-apps`,
    BLOG: "/:blogUrl",
    EMBED_VIDEO_LIVE: `/${URL_PREFIX}/embed/:blogUrl`,
    EMBED_VIDEO_VOD: `/${URL_PREFIX}/embed/:blogUrl/:videoId`,
    // отображается стрим с активной вкладкой channelTab
    // channelTab = '' | 'about' | 'records' (все записи) | 'video_clips' | 'chat' | 'video'(записи и плейлисты) | 'playlists' | 'playlist_moderate'
    // на десктопе 'about' и 'chat' редиректят на '', на мобвебе 'chat' должен редиректить на ''
    CHANNEL_STREAM: "/:blogUrl/:channelTab?",
    CHANNEL_STREAM_SLOT: "/:blogUrl/stream/:slotUrl/:channelTab?",
    // отображается запись с активной вкладкой channelTab
    // channelTab = '' | 'about' | 'records' (все записи) | 'video_clips' | 'chat' | 'video'(записи и плейлисты) | 'playlists' | 'playlist_moderate'
    // на десктопе 'about' и 'chat' редиректят на '', на мобвебе 'chat' должен редиректить на ''
    CHANNEL_VIDEO: "/:blogUrl/record/:recordId/:channelTab?",
    CHANNEL_PLAYLIST_ENTITY: "/:blogUrl/playlist/:playlistId/video/:videoId/:channelTab?",
    // отображается клип с активной вкладкой channelTab
    // channelTab = '' | 'about' | 'records' (все записи) | 'video_clips' | 'chat' | 'video'(записи и плейлисты) |
    // на десктопе 'about' и 'chat' редиректят на '', на мобвебе 'chat' должен редиректить на ''
    CHANNEL_VIDEO_CLIP: "/:blogUrl/clip/:videoClipId/:channelTab?",
    STREAM: "/:blogUrl",
    STREAM_SLOT: "/:blogUrl/stream/:slotUrl",
    STREAM_RECORDS: "/:blogUrl/records",
    STREAM_RECORD: "/:blogUrl/record/:recordId",
    STREAM_RECORD_RECORDS: "/:blogUrl/record/:recordId/records",
    STREAM_ABOUT: "/:blogUrl/about",
    STREAM_STUDIO: "/:blogUrl/studio",
    CHAT: "/:blogUrl/only-chat",
    REWARD_MANAGER: "/:blogUrl/reward-manager",
    PREDICTION: "/:blogUrl/prediction/:predictionId",
    ACTIVITY: "/:blogUrl/activity"
};
const EXTERNAL_API = {
    soundcloudTrackEmbedApi: "https://soundcloud.com/oembed?format=js&url=:url&iframe=true"
};
const ANTI_DDOS_API = {
    VERIFICATION: "/*/check"
};
const STREAM_PAGE_TABS = [
    URLS.STREAM,
    URLS.STREAM_SLOT,
    URLS.STREAM_ABOUT,
    URLS.STREAM_RECORDS,
    URLS.STREAM_RECORD,
    URLS.STREAM_RECORD_RECORDS,
    URLS.BLOG,
    URLS.CHANNEL_STREAM,
    URLS.CHANNEL_STREAM_SLOT,
    URLS.CHANNEL_VIDEO,
    URLS.CHANNEL_VIDEO_CLIP,
    URLS.CHANNEL_PLAYLIST_ENTITY
];
const ISOLATED_WINDOW_URLS = [
    URLS.CHAT,
    URLS.ACTIVITY,
    URLS.REWARD_MANAGER,
    URLS.PREDICTION
];
const PROJECT_START_DATE = new Date(2022, 7);
const RECORD_CHAT_FETCH_LIMIT = 200;
const DEFAULT_SLOT = "default";
const SdkEventEmitter = new (0, $kSjqI.EventEmitter)();
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}
const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 256).toString(16).slice(1));
function unsafeStringify(arr, offset2 = 0) {
    return (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
    randomUUID: randomUUID
};
function v4(options, buf, offset2) {
    if (native.randomUUID && true && !options) return native.randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || rng)();
    rnds[6] = rnds[6] & 15 | 64;
    rnds[8] = rnds[8] & 63 | 128;
    return unsafeStringify(rnds);
}
var queryString = {};
var strictUriEncode = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x2)=>`%${x2.charCodeAt(0).toString(16).toUpperCase()}`);
var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp(token, "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        return decodeURIComponent(components.join(""));
    } catch (err) {}
    if (components.length === 1) return components;
    split = split || 1;
    var left2 = components.slice(0, split);
    var right2 = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left2), decodeComponents(right2));
}
function decode$2(input2) {
    try {
        return decodeURIComponent(input2);
    } catch (err) {
        var tokens = input2.match(singleMatcher);
        for(var i = 1; i < tokens.length; i++){
            input2 = decodeComponents(tokens, i).join("");
            tokens = input2.match(singleMatcher);
        }
        return input2;
    }
}
function customDecodeURIComponent(input2) {
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match2 = multiMatcher.exec(input2);
    while(match2){
        try {
            replaceMap[match2[0]] = decodeURIComponent(match2[0]);
        } catch (err) {
            var result2 = decode$2(match2[0]);
            if (result2 !== match2[0]) replaceMap[match2[0]] = result2;
        }
        match2 = multiMatcher.exec(input2);
    }
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        var key = entries[i];
        input2 = input2.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input2;
}
var decodeUriComponent = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        return decodeURIComponent(encodedURI);
    } catch (err) {
        return customDecodeURIComponent(encodedURI);
    }
};
var splitOnFirst = (string, separator2)=>{
    if (!(typeof string === "string" && typeof separator2 === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator2 === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator2);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator2.length)
    ];
};
var filterObj = function(obj, predicate2) {
    var ret = {};
    var keys3 = Object.keys(obj);
    var isArr = Array.isArray(predicate2);
    for(var i = 0; i < keys3.length; i++){
        var key = keys3[i];
        var val = obj[key];
        if (isArr ? predicate2.indexOf(key) !== -1 : predicate2(key, val, obj)) ret[key] = val;
    }
    return ret;
};
(function(exports2) {
    const strictUriEncode$1 = strictUriEncode;
    const decodeComponent = decodeUriComponent;
    const splitOnFirst$1 = splitOnFirst;
    const filterObject = filterObj;
    const isNullOrUndefined = (value2)=>value2 === null || value2 === void 0;
    const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
    function encoderForArrayFormat(options) {
        switch(options.arrayFormat){
            case "index":
                return (key)=>(result2, value2)=>{
                        const index2 = result2.length;
                        if (value2 === void 0 || options.skipNull && value2 === null || options.skipEmptyString && value2 === "") return result2;
                        if (value2 === null) return [
                            ...result2,
                            [
                                encode2(key, options),
                                "[",
                                index2,
                                "]"
                            ].join("")
                        ];
                        return [
                            ...result2,
                            [
                                encode2(key, options),
                                "[",
                                encode2(index2, options),
                                "]=",
                                encode2(value2, options)
                            ].join("")
                        ];
                    };
            case "bracket":
                return (key)=>(result2, value2)=>{
                        if (value2 === void 0 || options.skipNull && value2 === null || options.skipEmptyString && value2 === "") return result2;
                        if (value2 === null) return [
                            ...result2,
                            [
                                encode2(key, options),
                                "[]"
                            ].join("")
                        ];
                        return [
                            ...result2,
                            [
                                encode2(key, options),
                                "[]=",
                                encode2(value2, options)
                            ].join("")
                        ];
                    };
            case "colon-list-separator":
                return (key)=>(result2, value2)=>{
                        if (value2 === void 0 || options.skipNull && value2 === null || options.skipEmptyString && value2 === "") return result2;
                        if (value2 === null) return [
                            ...result2,
                            [
                                encode2(key, options),
                                ":list="
                            ].join("")
                        ];
                        return [
                            ...result2,
                            [
                                encode2(key, options),
                                ":list=",
                                encode2(value2, options)
                            ].join("")
                        ];
                    };
            case "comma":
            case "separator":
            case "bracket-separator":
                {
                    const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                    return (key)=>(result2, value2)=>{
                            if (value2 === void 0 || options.skipNull && value2 === null || options.skipEmptyString && value2 === "") return result2;
                            value2 = value2 === null ? "" : value2;
                            if (result2.length === 0) return [
                                [
                                    encode2(key, options),
                                    keyValueSep,
                                    encode2(value2, options)
                                ].join("")
                            ];
                            return [
                                [
                                    result2,
                                    encode2(value2, options)
                                ].join(options.arrayFormatSeparator)
                            ];
                        };
                }
            default:
                return (key)=>(result2, value2)=>{
                        if (value2 === void 0 || options.skipNull && value2 === null || options.skipEmptyString && value2 === "") return result2;
                        if (value2 === null) return [
                            ...result2,
                            encode2(key, options)
                        ];
                        return [
                            ...result2,
                            [
                                encode2(key, options),
                                "=",
                                encode2(value2, options)
                            ].join("")
                        ];
                    };
        }
    }
    function parserForArrayFormat(options) {
        let result2;
        switch(options.arrayFormat){
            case "index":
                return (key, value2, accumulator)=>{
                    result2 = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, "");
                    if (!result2) {
                        accumulator[key] = value2;
                        return;
                    }
                    if (accumulator[key] === void 0) accumulator[key] = {};
                    accumulator[key][result2[1]] = value2;
                };
            case "bracket":
                return (key, value2, accumulator)=>{
                    result2 = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, "");
                    if (!result2) {
                        accumulator[key] = value2;
                        return;
                    }
                    if (accumulator[key] === void 0) {
                        accumulator[key] = [
                            value2
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value2);
                };
            case "colon-list-separator":
                return (key, value2, accumulator)=>{
                    result2 = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, "");
                    if (!result2) {
                        accumulator[key] = value2;
                        return;
                    }
                    if (accumulator[key] === void 0) {
                        accumulator[key] = [
                            value2
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value2);
                };
            case "comma":
            case "separator":
                return (key, value2, accumulator)=>{
                    const isArray2 = typeof value2 === "string" && value2.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value2 === "string" && !isArray2 && decode2(value2, options).includes(options.arrayFormatSeparator);
                    value2 = isEncodedArray ? decode2(value2, options) : value2;
                    const newValue = isArray2 || isEncodedArray ? value2.split(options.arrayFormatSeparator).map((item2)=>decode2(item2, options)) : value2 === null ? value2 : decode2(value2, options);
                    accumulator[key] = newValue;
                };
            case "bracket-separator":
                return (key, value2, accumulator)=>{
                    const isArray2 = /(\[\])$/.test(key);
                    key = key.replace(/\[\]$/, "");
                    if (!isArray2) {
                        accumulator[key] = value2 ? decode2(value2, options) : value2;
                        return;
                    }
                    const arrayValue = value2 === null ? [] : value2.split(options.arrayFormatSeparator).map((item2)=>decode2(item2, options));
                    if (accumulator[key] === void 0) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], arrayValue);
                };
            default:
                return (key, value2, accumulator)=>{
                    if (accumulator[key] === void 0) {
                        accumulator[key] = value2;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value2);
                };
        }
    }
    function validateArrayFormatSeparator(value2) {
        if (typeof value2 !== "string" || value2.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
    }
    function encode2(value2, options) {
        if (options.encode) return options.strict ? strictUriEncode$1(value2) : encodeURIComponent(value2);
        return value2;
    }
    function decode2(value2, options) {
        if (options.decode) return decodeComponent(value2);
        return value2;
    }
    function keysSorter(input2) {
        if (Array.isArray(input2)) return input2.sort();
        if (typeof input2 === "object") return keysSorter(Object.keys(input2)).sort((a2, b2)=>Number(a2) - Number(b2)).map((key)=>input2[key]);
        return input2;
    }
    function removeHash(input2) {
        const hashStart = input2.indexOf("#");
        if (hashStart !== -1) input2 = input2.slice(0, hashStart);
        return input2;
    }
    function getHash(url) {
        let hash = "";
        const hashStart = url.indexOf("#");
        if (hashStart !== -1) hash = url.slice(hashStart);
        return hash;
    }
    function extract(input2) {
        input2 = removeHash(input2);
        const queryStart = input2.indexOf("?");
        if (queryStart === -1) return "";
        return input2.slice(queryStart + 1);
    }
    function parseValue(value2, options) {
        if (options.parseNumbers && !Number.isNaN(Number(value2)) && typeof value2 === "string" && value2.trim() !== "") value2 = Number(value2);
        else if (options.parseBooleans && value2 !== null && (value2.toLowerCase() === "true" || value2.toLowerCase() === "false")) value2 = value2.toLowerCase() === "true";
        return value2;
    }
    function parse2(query, options) {
        options = Object.assign({
            decode: true,
            sort: true,
            arrayFormat: "none",
            arrayFormatSeparator: ",",
            parseNumbers: false,
            parseBooleans: false
        }, options);
        validateArrayFormatSeparator(options.arrayFormatSeparator);
        const formatter = parserForArrayFormat(options);
        const ret = /* @__PURE__ */ Object.create(null);
        if (typeof query !== "string") return ret;
        query = query.trim().replace(/^[?#&]/, "");
        if (!query) return ret;
        for (const param of query.split("&")){
            if (param === "") continue;
            let [key, value2] = splitOnFirst$1(options.decode ? param.replace(/\+/g, " ") : param, "=");
            value2 = value2 === void 0 ? null : [
                "comma",
                "separator",
                "bracket-separator"
            ].includes(options.arrayFormat) ? value2 : decode2(value2, options);
            formatter(decode2(key, options), value2, ret);
        }
        for (const key of Object.keys(ret)){
            const value2 = ret[key];
            if (typeof value2 === "object" && value2 !== null) for (const k2 of Object.keys(value2))value2[k2] = parseValue(value2[k2], options);
            else ret[key] = parseValue(value2, options);
        }
        if (options.sort === false) return ret;
        return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result2, key)=>{
            const value2 = ret[key];
            if (Boolean(value2) && typeof value2 === "object" && !Array.isArray(value2)) result2[key] = keysSorter(value2);
            else result2[key] = value2;
            return result2;
        }, /* @__PURE__ */ Object.create(null));
    }
    exports2.extract = extract;
    exports2.parse = parse2;
    exports2.stringify = (object2, options)=>{
        if (!object2) return "";
        options = Object.assign({
            encode: true,
            strict: true,
            arrayFormat: "none",
            arrayFormatSeparator: ","
        }, options);
        validateArrayFormatSeparator(options.arrayFormatSeparator);
        const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object2[key]) || options.skipEmptyString && object2[key] === "";
        const formatter = encoderForArrayFormat(options);
        const objectCopy = {};
        for (const key of Object.keys(object2))if (!shouldFilter(key)) objectCopy[key] = object2[key];
        const keys3 = Object.keys(objectCopy);
        if (options.sort !== false) keys3.sort(options.sort);
        return keys3.map((key)=>{
            const value2 = object2[key];
            if (value2 === void 0) return "";
            if (value2 === null) return encode2(key, options);
            if (Array.isArray(value2)) {
                if (value2.length === 0 && options.arrayFormat === "bracket-separator") return encode2(key, options) + "[]";
                return value2.reduce(formatter(key), []).join("&");
            }
            return encode2(key, options) + "=" + encode2(value2, options);
        }).filter((x2)=>x2.length > 0).join("&");
    };
    exports2.parseUrl = (url, options)=>{
        options = Object.assign({
            decode: true
        }, options);
        const [url_, hash] = splitOnFirst$1(url, "#");
        return Object.assign({
            url: url_.split("?")[0] || "",
            query: parse2(extract(url), options)
        }, options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: decode2(hash, options)
        } : {});
    };
    exports2.stringifyUrl = (object2, options)=>{
        options = Object.assign({
            encode: true,
            strict: true,
            [encodeFragmentIdentifier]: true
        }, options);
        const url = removeHash(object2.url).split("?")[0] || "";
        const queryFromUrl = exports2.extract(object2.url);
        const parsedQueryFromUrl = exports2.parse(queryFromUrl, {
            sort: false
        });
        const query = Object.assign(parsedQueryFromUrl, object2.query);
        let queryString2 = exports2.stringify(query, options);
        if (queryString2) queryString2 = `?${queryString2}`;
        let hash = getHash(object2.url);
        if (object2.fragmentIdentifier) hash = `#${options[encodeFragmentIdentifier] ? encode2(object2.fragmentIdentifier, options) : object2.fragmentIdentifier}`;
        return `${url}${queryString2}${hash}`;
    };
    exports2.pick = (input2, filter, options)=>{
        options = Object.assign({
            parseFragmentIdentifier: true,
            [encodeFragmentIdentifier]: false
        }, options);
        const { url, query, fragmentIdentifier } = exports2.parseUrl(input2, options);
        return exports2.stringifyUrl({
            url: url,
            query: filterObject(query, filter),
            fragmentIdentifier: fragmentIdentifier
        }, options);
    };
    exports2.exclude = (input2, filter, options)=>{
        const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value2)=>!filter(key, value2);
        return exports2.pick(input2, exclusionFilter, options);
    };
})(queryString);
const addLeadZero = (num2)=>`00${num2}`.slice(-2);
class ApiError {
    constructor(params){
        const { status, statusText, message: message2, code, serverError, request: request2, response } = params;
        this.status = status;
        this.statusText = statusText;
        this.message = message2;
        this.code = code;
        this.request = request2;
        this.response = response;
        if (serverError) this.serverError = {
            error: serverError == null ? void 0 : serverError.error,
            errorDescription: serverError == null ? void 0 : serverError.error_description,
            errorUri: serverError == null ? void 0 : serverError.error_uri,
            ...serverError.data ? {
                data: serverError.data
            } : {}
        };
        else if (this.response) this.serverError = this.response.data;
    }
}
let APP_ID = EAppId.UNSET;
const setAppId = (appId)=>APP_ID = appId;
const getAppId = ()=>APP_ID;
const isStreamApp = ()=>{
    return [
        EAppId.STREAMS_WEB,
        EAppId.STREAMS_WEB_EMBED,
        EAppId.STREAMS_WEB_MOBILE,
        EAppId.STREAMS_WEB_MOBILE_EMBED
    ].includes(getAppId());
};
const getDefaultNetworkStatus$1 = ()=>{
    return {
        isFetching: false,
        isFetched: false,
        error: null
    };
};
const getNetworkStatusStarted$1 = ()=>{
    return {
        isFetching: true,
        isFetched: false,
        error: null
    };
};
const getNetworkStatusDone$1 = ()=>{
    return {
        isFetching: false,
        isFetched: true,
        error: null
    };
};
const getNetworkStatusFailed$1 = (error2)=>{
    return {
        isFetching: false,
        isFetched: false,
        error: error2
    };
};
const applyAsyncReducer = ()=>{
    return (propName, networkStatusPropName, action, builder, prepareResult = null)=>builder.case(action.started, (store2, payload)=>({
                ...store2,
                [propName]: {
                    ...store2[propName],
                    meta: {
                        ...store2[propName].meta,
                        [networkStatusPropName]: getNetworkStatusStarted$1()
                    }
                }
            })).case(action.failed, (store2, { error: error2 })=>({
                ...store2,
                [propName]: {
                    ...store2[propName],
                    meta: {
                        ...store2[propName].meta,
                        [networkStatusPropName]: getNetworkStatusFailed$1(error2)
                    }
                }
            })).case(action.done, (store2, payload)=>{
            let data;
            if (prepareResult) {
                const result2 = prepareResult({
                    store: store2,
                    result: payload.result,
                    params: payload.params
                });
                if (result2 === null) data = result2;
                else if (Array.isArray(result2)) data = result2;
                else data = {
                    ...store2[propName].data,
                    ...result2
                };
            } else data = store2[propName].data;
            return {
                ...store2,
                [propName]: {
                    ...store2[propName],
                    data: data,
                    meta: {
                        ...store2[propName].meta,
                        [networkStatusPropName]: getNetworkStatusDone$1()
                    }
                }
            };
        });
};
ESocialLink.FB, ESocialLink.INSTAGRAM;
const concatUniqueById = (storedList, addingList)=>{
    const list2 = storedList || [];
    const objFromList = Object.fromEntries(list2.map((item2)=>[
            item2.id,
            item2
        ]));
    const overlappingIds = addingList.filter((item2)=>Boolean(objFromList[item2.id])).map((item2)=>item2.id);
    return list2.filter((item2)=>!overlappingIds.includes(item2.id)).concat(addingList);
};
const copyToClipboard$1 = async (text2, onSuccess)=>{
    try {
        await navigator.clipboard.writeText(text2);
    } catch (err) {
        copyToClipboardFallback(text2);
    } finally{
        onSuccess && onSuccess();
    }
};
const copyToClipboardFallback = (text2)=>{
    const elm = document.createElement("textarea");
    elm.value = text2;
    elm.setAttribute("readonly", "");
    elm.style.position = "absolute";
    elm.style.left = "-9999px";
    document.body.appendChild(elm);
    elm.select();
    document.execCommand("copy");
    document.body.removeChild(elm);
};
ECurrency.RUB, ECurrency.UAH, ECurrency.EUR, ECurrency.USD;
ECurrency.RUB, ECurrency.UAH, ECurrency.EUR, ECurrency.USD;
const declOfNum = (titles, num2)=>{
    const cases = [
        2,
        0,
        1,
        1,
        1,
        2
    ];
    return titles[num2 % 100 > 4 && num2 % 100 < 20 ? 2 : cases[num2 % 10 < 5 ? num2 % 10 : 5]];
};
const getRandomInt$3 = (startInt = 0, endInt = Number.MAX_SAFE_INTEGER)=>{
    return Math.floor(startInt + Math.random() * (endInt - startInt + 1));
};
const getRandomStr = ()=>{
    return Math.random().toString(36).slice(2);
};
const PRECISION = 1e3;
const distributeEvenly = (from2, to)=>{
    return getRandomInt$3(from2 * PRECISION, to * PRECISION) / PRECISION;
};
const fixPostsOrder = (posts)=>{
    return [
        ...posts
    ].sort((postA, postB)=>{
        if (postA.publishTime === postB.publishTime) return postB.createdAt - postA.createdAt;
        return postB.publishTime - postA.publishTime;
    });
};
var dist$5 = {
    exports: {}
};
(()=>{
    var e2 = {
        d: (t3, r3)=>{
            for(var n3 in r3)e2.o(r3, n3) && !e2.o(t3, n3) && Object.defineProperty(t3, n3, {
                enumerable: true,
                get: r3[n3]
            });
        },
        o: (e3, t3)=>Object.prototype.hasOwnProperty.call(e3, t3),
        r: (e3)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e3, "__esModule", {
                value: true
            });
        }
    }, t2 = {};
    e2.r(t2), e2.d(t2, {
        getLocales: ()=>c2,
        getParametrizedText: ()=>l2,
        getReactText: ()=>s2,
        getTranslation: ()=>i,
        setLocales: ()=>a2,
        setSsrMode: ()=>u2
    });
    const r2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
    var n2 = {}, o2 = false, a2 = function(e3) {
        return n2 = e3;
    }, c2 = function() {
        return n2;
    }, u2 = function(e3) {
        return o2 = e3;
    }, l2 = function(e3, t3) {
        return Object.keys(t3).reduce(function(e4, r3) {
            return e4.replace(new RegExp("{{".concat(r3, "}}"), "g"), String(t3[r3]));
        }, e3);
    }, i = function(e3) {
        var t3 = c2();
        return o2 ? new Proxy({}, {
            get: function(t4, r3) {
                var n3;
                return (null === (n3 = c2()[e3]) || void 0 === n3 ? void 0 : n3[r3]) || "";
            }
        }) : t3[e3];
    }, f2 = {
        Br: function() {
            return r2.createElement("br", null);
        }
    }, s2 = function(e3, t3) {
        void 0 === t3 && (t3 = {});
        var n3 = e3.split(/(<[^\s\/]+?>.*?<\/[^\s]+?>)/).map(function(e4) {
            return e4.split(/(<[^\s]+?\/>)/);
        }).flat();
        return r2.createElement(r2.Fragment, null, n3.map(function(e4, n4) {
            var o3 = e4.match(/(<([^\s]+?)>(.*?)<\/[^\s]+?>)/), a3 = e4.match(/(<([^\s]+?)\/>)/), c3 = o3 || a3;
            if (c3) {
                var u3 = function(e5, t4) {
                    var r3 = "function" == typeof Symbol && e5[Symbol.iterator];
                    if (!r3) return e5;
                    var n5, o4, a4 = r3.call(e5), c4 = [];
                    try {
                        for(; (void 0 === t4 || t4-- > 0) && !(n5 = a4.next()).done;)c4.push(n5.value);
                    } catch (e6) {
                        o4 = {
                            error: e6
                        };
                    } finally{
                        try {
                            n5 && !n5.done && (r3 = a4.return) && r3.call(a4);
                        } finally{
                            if (o4) throw o4.error;
                        }
                    }
                    return c4;
                }(c3, 4), l3 = u3[2], i2 = u3[3], s3 = t3[l3] || f2[l3];
                return s3 || console.error("Call getReactText with empty component ".concat(l3)), r2.createElement(s3, {
                    key: n4,
                    text: i2
                });
            }
            return e4;
        }));
    };
    dist$5.exports = t2;
})();
var distExports$1 = dist$5.exports;
const locales$1V = {
    providers: {
        VK: "VK",
        OK: "\u041E\u0434\u043D\u043E\u043A\u043B\u0430\u0441\u0441\u043D\u0438\u043A\u0438",
        FB: "Facebook",
        google: "Google",
        youtube: "Youtube",
        mailru: "Mail.ru",
        twitch: "Twitch",
        instagram: "Instagram",
        discord: "Discord",
        discord_bot: "DiscordBot",
        vkplay: "VKPlay"
    }
};
const t$1X = distExports$1.getTranslation && locales$1V;
const getAuthProviderTitle = (provider)=>{
    return t$1X.providers[provider];
};
const getStreamWithMaximalOnline = (currentStream, element)=>{
    if (!currentStream) return element;
    if (!currentStream.isOnline && element.isOnline) return element;
    return element.isOnline && element.count.viewers > currentStream.count.viewers ? element : currentStream;
};
const getIOModeStoreVariant = (data)=>{
    return {
        value: data.kind,
        parameters: [
            data.isCapsProhibited && EChatIOCheckbox.CAPS_PROHIBITED,
            data.isLinksProhibited && EChatIOCheckbox.LINKS_PROHIBITED,
            data.isRuEnNumbers && EChatIOCheckbox.RU_EN_NUMBERS
        ].filter(Boolean)
    };
};
const SWAGGER_PATH_PARAM_PLACEHOLDER = "item";
const SWAGGER_ENDING_SLASH_MEANING = "list";
const getApiResourceId = (method, apiResource)=>{
    return [
        method.toLowerCase(),
        ...apiResource.replace(/^\/(v1\/)?/, "").split("/").map((fragment)=>{
            if (fragment.startsWith(":")) return SWAGGER_PATH_PARAM_PLACEHOLDER;
            else if (fragment === "") return SWAGGER_ENDING_SLASH_MEANING;
            else return fragment;
        })
    ].join("_");
};
const getBlogUrlFromStream = (stream2)=>{
    return stream2 == null ? void 0 : stream2.embedUrl.split(`/app/embed/`)[1];
};
const getColorPaletteTheme = (theme)=>{
    if (theme === EUITheme.SYSTEM && typeof window !== "undefined") return window.matchMedia("(prefers-color-scheme: dark)").matches ? EUITheme.DARK : EUITheme.LIGHT;
    return theme;
};
const getStringHashCode = (str)=>str.split("").reduce((a2, b2)=>{
        a2 = (a2 << 5) - a2 + b2.charCodeAt(0);
        return a2 & a2;
    }, 0);
const CHAT_COLORS = {
    LIGHT: [
        "#D66E34",
        "#4A2DDA",
        "#00579F",
        "#8B3FFD",
        "#59A840",
        "#D45124",
        "#DE6489",
        "#20BBA1",
        "#F8B301",
        "#0099BB",
        "#1D90FF",
        "#E542FF",
        "#A36C59",
        "#8BA259",
        "#002F47",
        "#7008AF"
    ],
    DARK: [
        "#D66E34",
        "#B8AAFF",
        "#1D90FF",
        "#9961F9",
        "#59A840",
        "#E73629",
        "#DE6489",
        "#20BBA1",
        "#F8B301",
        "#0099BB",
        "#7BBEFF",
        "#E542FF",
        "#A36C59",
        "#8BA259",
        "#00A9FF",
        "#A20BFF"
    ]
};
const MAX_SIGNED_32BIT_INTEGER_VALUE = 2147483647;
const getChatNicknameColor = (value2, theme)=>{
    const palette = CHAT_COLORS[getColorPaletteTheme(theme) === EUITheme.LIGHT ? "LIGHT" : "DARK"];
    const paletteSize = Object.keys(palette).length;
    const index2 = typeof value2 === "number" && value2 in palette ? value2 : Math.floor(Math.abs(getStringHashCode(String(value2)) / (MAX_SIGNED_32BIT_INTEGER_VALUE / paletteSize)));
    return palette[index2];
};
var js_cookie = {
    exports: {}
};
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(module2, exports2) {
    (function(factory) {
        var registeredInModuleLoader;
        module2.exports = factory();
        registeredInModuleLoader = true;
        if (!registeredInModuleLoader) {
            var OldCookies = window.Cookies;
            var api2 = window.Cookies = factory();
            api2.noConflict = function() {
                window.Cookies = OldCookies;
                return api2;
            };
        }
    })(function() {
        function extend2() {
            var i = 0;
            var result2 = {};
            for(; i < arguments.length; i++){
                var attributes = arguments[i];
                for(var key in attributes)result2[key] = attributes[key];
            }
            return result2;
        }
        function decode2(s2) {
            return s2.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }
        function init2(converter) {
            function api2() {}
            function set2(key, value2, attributes) {
                if (typeof document === "undefined") return;
                attributes = extend2({
                    path: "/"
                }, api2.defaults, attributes);
                if (typeof attributes.expires === "number") attributes.expires = new Date(/* @__PURE__ */ new Date() * 1 + attributes.expires * 864e5);
                attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
                try {
                    var result2 = JSON.stringify(value2);
                    if (/^[\{\[]/.test(result2)) value2 = result2;
                } catch (e2) {}
                value2 = converter.write ? converter.write(value2, key) : encodeURIComponent(String(value2)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                var stringifiedAttributes = "";
                for(var attributeName in attributes){
                    if (!attributes[attributeName]) continue;
                    stringifiedAttributes += "; " + attributeName;
                    if (attributes[attributeName] === true) continue;
                    stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
                }
                return document.cookie = key + "=" + value2 + stringifiedAttributes;
            }
            function get2(key, json2) {
                if (typeof document === "undefined") return;
                var jar = {};
                var cookies2 = document.cookie ? document.cookie.split("; ") : [];
                var i = 0;
                for(; i < cookies2.length; i++){
                    var parts = cookies2[i].split("=");
                    var cookie = parts.slice(1).join("=");
                    if (!json2 && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                    try {
                        var name2 = decode2(parts[0]);
                        cookie = (converter.read || converter)(cookie, name2) || decode2(cookie);
                        if (json2) try {
                            cookie = JSON.parse(cookie);
                        } catch (e2) {}
                        jar[name2] = cookie;
                        if (key === name2) break;
                    } catch (e2) {}
                }
                return key ? jar[key] : jar;
            }
            api2.set = set2;
            api2.get = function(key) {
                return get2(key, false);
            };
            api2.getJSON = function(key) {
                return get2(key, true);
            };
            api2.remove = function(key, attributes) {
                set2(key, "", extend2(attributes, {
                    expires: -1
                }));
            };
            api2.defaults = {};
            api2.withConverter = init2;
            return api2;
        }
        return init2(function() {});
    });
})(js_cookie);
var js_cookieExports = js_cookie.exports;
let Log$5 = (_a = class {
    static setUserId(userId) {
        this.userId = userId;
    }
    static getUserId() {
        return this.userId;
    }
    static message(...args) {
        const log2 = [
            `${/* @__PURE__ */ new Date().toString()}: main : ${this.userId}:`
        ].concat(args.slice());
        if (console && console.log) console.log(...log2);
        this.logs.push(log2.join(" "));
        this.slice();
    }
    static error(...args) {
        const log2 = [
            `${/* @__PURE__ */ new Date().toString()}: ${this.userId}:`
        ].concat(args.slice());
        if (console && console.error) console.error(...log2);
        this.logs.push(log2.join(" "));
        this.slice();
    }
    static errorRequest(err) {
        if (err && err.request) {
            const { status, request: { url = "", method = "", data } } = err;
            _a.error(`Failed network request: ${status} ${method.toUpperCase()} ${url} ${data}`);
        }
    }
    static slice() {
        this.logs = this.logs.slice(-this.MAX_ITEMS);
    }
    static getLogs() {
        return this.logs;
    }
    static isSendLogsEnable() {
        return getConfig().isSendLogsEnable;
    }
}, _a.userId = null, _a.logs = [], _a.MAX_ITEMS = 300, _a);
window.FounderLogger = Log$5;
const getCookie = (name2)=>{
    return js_cookieExports.get(name2);
};
const setCookie = (name2, value2, options = {})=>{
    js_cookieExports.set(name2, value2, {
        ...options,
        secure: true
    });
};
const setStringifiedToCookies = (name2, value2, options = {})=>{
    setCookie(name2, JSON.stringify(value2), options);
};
EChatMessageTextSize.NORMAL, EChatPauseType.SCROLL;
const getCleanPhone = (phone, withPlus = false)=>{
    return phone.replace(withPlus ? /[\s-()]/g : /\D+/g, "");
};
const getProgressPercent = (goal, current)=>Math.trunc(current * 100 / goal);
const getProjectName = ()=>{
    const { project: { name: projectName }, locale: locale2 } = getConfig();
    const language = locale2 === ELocale.RU ? "ru" : "en";
    return projectName[language];
};
const FileSizeUnitMap = {
    [EFileSizeUnit.B]: 1,
    [EFileSizeUnit.KB]: 1024,
    [EFileSizeUnit.MB]: 1024 ** 2,
    [EFileSizeUnit.GB]: 1024 ** 3
};
const getConvertedFileSize = (size2, sourceUnit, targetUnit)=>{
    return size2 * FileSizeUnitMap[sourceUnit] / FileSizeUnitMap[targetUnit];
};
const getFactoryTestId = (componentName)=>(testId)=>`${componentName}:${testId}`;
function toInteger$1(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
function toDate(argument) {
    requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
            console.warn(new Error().stack);
        }
        return /* @__PURE__ */ new Date(NaN);
    }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var timestamp = toDate(dirtyDate).getTime();
    var amount = toInteger$1(dirtyAmount);
    return new Date(timestamp + amount);
}
function getTimezoneOffsetInMilliseconds(date2) {
    var utcDate = new Date(Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds()));
    utcDate.setUTCFullYear(date2.getFullYear());
    return date2.getTime() - utcDate.getTime();
}
function isDate$1(value2) {
    requiredArgs(1, arguments);
    return value2 instanceof Date || typeof value2 === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid(dirtyDate) {
    requiredArgs(1, arguments);
    if (!isDate$1(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date2 = toDate(dirtyDate);
    return !isNaN(Number(date2));
}
var formatDistanceLocale$1 = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance$1 = function(token2, count2, options) {
    var result2;
    var tokenValue = formatDistanceLocale$1[token2];
    if (typeof tokenValue === "string") result2 = tokenValue;
    else if (count2 === 1) result2 = tokenValue.one;
    else result2 = tokenValue.other.replace("{{count}}", count2.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result2;
        else return result2 + " ago";
    }
    return result2;
};
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format2 = args.formats[width] || args.formats[args.defaultWidth];
        return format2;
    };
}
var dateFormats$1 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats$1 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats$1 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong$1 = {
    date: buildFormatLongFn({
        formats: dateFormats$1,
        defaultWidth: "full"
    }),
    time: buildFormatLongFn({
        formats: timeFormats$1,
        defaultWidth: "full"
    }),
    dateTime: buildFormatLongFn({
        formats: dateTimeFormats$1,
        defaultWidth: "full"
    })
};
var formatRelativeLocale$1 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative$1 = function(token2, _date, _baseDate, _options) {
    return formatRelativeLocale$1[token2];
};
function buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index2];
    };
}
var eraValues$1 = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues$1 = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
var monthValues$1 = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues$1 = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues$1 = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues$1 = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber$1 = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize$1 = {
    ordinalNumber: ordinalNumber$1,
    era: buildLocalizeFn({
        values: eraValues$1,
        defaultWidth: "wide"
    }),
    quarter: buildLocalizeFn({
        values: quarterValues$1,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: buildLocalizeFn({
        values: monthValues$1,
        defaultWidth: "wide"
    }),
    day: buildLocalizeFn({
        values: dayValues$1,
        defaultWidth: "wide"
    }),
    dayPeriod: buildLocalizeFn({
        values: dayPeriodValues$1,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues$1,
        defaultFormattingWidth: "wide"
    })
};
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value2;
        value2 = args.valueCallback ? args.valueCallback(key) : key;
        value2 = options.valueCallback ? options.valueCallback(value2) : value2;
        var rest = string.slice(matchedString.length);
        return {
            value: value2,
            rest: rest
        };
    };
}
function findKey(object2, predicate2) {
    for(var key in object2){
        if (object2.hasOwnProperty(key) && predicate2(object2[key])) return key;
    }
    return void 0;
}
function findIndex(array, predicate2) {
    for(var key = 0; key < array.length; key++){
        if (predicate2(array[key])) return key;
    }
    return void 0;
}
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value2 = options.valueCallback ? options.valueCallback(value2) : value2;
        var rest = string.slice(matchedString.length);
        return {
            value: value2,
            rest: rest
        };
    };
}
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns$1 = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns$1 = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns$1 = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns$1 = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match$1 = {
    ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern$1,
        parsePattern: parseOrdinalNumberPattern$1,
        valueCallback: function(value2) {
            return parseInt(value2, 10);
        }
    }),
    era: buildMatchFn({
        matchPatterns: matchEraPatterns$1,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns$1,
        defaultParseWidth: "any"
    }),
    quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns$1,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns$1,
        defaultParseWidth: "any",
        valueCallback: function(index2) {
            return index2 + 1;
        }
    }),
    month: buildMatchFn({
        matchPatterns: matchMonthPatterns$1,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns$1,
        defaultParseWidth: "any"
    }),
    day: buildMatchFn({
        matchPatterns: matchDayPatterns$1,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns$1,
        defaultParseWidth: "any"
    }),
    dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns$1,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns$1,
        defaultParseWidth: "any"
    })
};
var locale$2 = {
    code: "en-US",
    formatDistance: formatDistance$1,
    formatLong: formatLong$1,
    formatRelative: formatRelative$1,
    localize: localize$1,
    match: match$1,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function subMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger$1(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date2 = toDate(dirtyDate);
    var timestamp = date2.getTime();
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date2.getTime();
    var difference2 = timestamp - startOfYearTimestamp;
    return Math.floor(difference2 / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date2 = toDate(dirtyDate);
    var day = date2.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date2.setUTCDate(date2.getUTCDate() - diff);
    date2.setUTCHours(0, 0, 0, 0);
    return date2;
}
function getUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date2 = toDate(dirtyDate);
    var year = date2.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
    if (date2.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date2.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
function startOfUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = /* @__PURE__ */ new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date2 = startOfUTCISOWeek(fourthOfJanuary);
    return date2;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date2 = toDate(dirtyDate);
    var diff = startOfUTCISOWeek(date2).getTime() - startOfUTCISOWeekYear(date2).getTime();
    return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale2 = options.locale;
    var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date2 = toDate(dirtyDate);
    var day = date2.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date2.setUTCDate(date2.getUTCDate() - diff);
    date2.setUTCHours(0, 0, 0, 0);
    return date2;
}
function getUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var date2 = toDate(dirtyDate);
    var year = date2.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale2 = options.locale;
    var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate);
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
    if (date2.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date2.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale2 = options.locale;
    var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate);
    var year = getUTCWeekYear(dirtyDate, dirtyOptions);
    var firstWeek = /* @__PURE__ */ new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date2 = startOfUTCWeek(firstWeek, dirtyOptions);
    return date2;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
    requiredArgs(1, arguments);
    var date2 = toDate(dirtyDate);
    var diff = startOfUTCWeek(date2, options).getTime() - startOfUTCWeekYear(date2, options).getTime();
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
var formatters$1 = {
    // Year
    y: function(date2, token2) {
        var signedYear = date2.getUTCFullYear();
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
    },
    // Month
    M: function(date2, token2) {
        var month = date2.getUTCMonth();
        return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function(date2, token2) {
        return addLeadingZeros(date2.getUTCDate(), token2.length);
    },
    // AM or PM
    a: function(date2, token2) {
        var dayPeriodEnumValue = date2.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token2){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date2, token2) {
        return addLeadingZeros(date2.getUTCHours() % 12 || 12, token2.length);
    },
    // Hour [0-23]
    H: function(date2, token2) {
        return addLeadingZeros(date2.getUTCHours(), token2.length);
    },
    // Minute
    m: function(date2, token2) {
        return addLeadingZeros(date2.getUTCMinutes(), token2.length);
    },
    // Second
    s: function(date2, token2) {
        return addLeadingZeros(date2.getUTCSeconds(), token2.length);
    },
    // Fraction of second
    S: function(date2, token2) {
        var numberOfDigits = token2.length;
        var milliseconds = date2.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return addLeadingZeros(fractionalSeconds, token2.length);
    }
};
var dayPeriodEnum = {
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var formatters = {
    // Era
    G: function(date2, token2, localize2) {
        var era = date2.getUTCFullYear() > 0 ? 1 : 0;
        switch(token2){
            case "G":
            case "GG":
            case "GGG":
                return localize2.era(era, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return localize2.era(era, {
                    width: "narrow"
                });
            case "GGGG":
            default:
                return localize2.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date2, token2, localize2) {
        if (token2 === "yo") {
            var signedYear = date2.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize2.ordinalNumber(year, {
                unit: "year"
            });
        }
        return formatters$1.y(date2, token2);
    },
    // Local week-numbering year
    Y: function(date2, token2, localize2, options) {
        var signedWeekYear = getUTCWeekYear(date2, options);
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        if (token2 === "YY") {
            var twoDigitYear = weekYear % 100;
            return addLeadingZeros(twoDigitYear, 2);
        }
        if (token2 === "Yo") return localize2.ordinalNumber(weekYear, {
            unit: "year"
        });
        return addLeadingZeros(weekYear, token2.length);
    },
    // ISO week-numbering year
    R: function(date2, token2) {
        var isoWeekYear = getUTCISOWeekYear(date2);
        return addLeadingZeros(isoWeekYear, token2.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date2, token2) {
        var year = date2.getUTCFullYear();
        return addLeadingZeros(year, token2.length);
    },
    // Quarter
    Q: function(date2, token2, localize2) {
        var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
        switch(token2){
            case "Q":
                return String(quarter);
            case "QQ":
                return addLeadingZeros(quarter, 2);
            case "Qo":
                return localize2.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            case "QQQ":
                return localize2.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return localize2.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            case "QQQQ":
            default:
                return localize2.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date2, token2, localize2) {
        var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
        switch(token2){
            case "q":
                return String(quarter);
            case "qq":
                return addLeadingZeros(quarter, 2);
            case "qo":
                return localize2.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            case "qqq":
                return localize2.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return localize2.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            case "qqqq":
            default:
                return localize2.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date2, token2, localize2) {
        var month = date2.getUTCMonth();
        switch(token2){
            case "M":
            case "MM":
                return formatters$1.M(date2, token2);
            case "Mo":
                return localize2.ordinalNumber(month + 1, {
                    unit: "month"
                });
            case "MMM":
                return localize2.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return localize2.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            case "MMMM":
            default:
                return localize2.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date2, token2, localize2) {
        var month = date2.getUTCMonth();
        switch(token2){
            case "L":
                return String(month + 1);
            case "LL":
                return addLeadingZeros(month + 1, 2);
            case "Lo":
                return localize2.ordinalNumber(month + 1, {
                    unit: "month"
                });
            case "LLL":
                return localize2.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return localize2.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            case "LLLL":
            default:
                return localize2.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date2, token2, localize2, options) {
        var week = getUTCWeek(date2, options);
        if (token2 === "wo") return localize2.ordinalNumber(week, {
            unit: "week"
        });
        return addLeadingZeros(week, token2.length);
    },
    // ISO week of year
    I: function(date2, token2, localize2) {
        var isoWeek = getUTCISOWeek(date2);
        if (token2 === "Io") return localize2.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return addLeadingZeros(isoWeek, token2.length);
    },
    // Day of the month
    d: function(date2, token2, localize2) {
        if (token2 === "do") return localize2.ordinalNumber(date2.getUTCDate(), {
            unit: "date"
        });
        return formatters$1.d(date2, token2);
    },
    // Day of year
    D: function(date2, token2, localize2) {
        var dayOfYear = getUTCDayOfYear(date2);
        if (token2 === "Do") return localize2.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return addLeadingZeros(dayOfYear, token2.length);
    },
    // Day of week
    E: function(date2, token2, localize2) {
        var dayOfWeek = date2.getUTCDay();
        switch(token2){
            case "E":
            case "EE":
            case "EEE":
                return localize2.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return localize2.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return localize2.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            case "EEEE":
            default:
                return localize2.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date2, token2, localize2, options) {
        var dayOfWeek = date2.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token2){
            case "e":
                return String(localDayOfWeek);
            case "ee":
                return addLeadingZeros(localDayOfWeek, 2);
            case "eo":
                return localize2.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize2.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return localize2.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return localize2.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            case "eeee":
            default:
                return localize2.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date2, token2, localize2, options) {
        var dayOfWeek = date2.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token2){
            case "c":
                return String(localDayOfWeek);
            case "cc":
                return addLeadingZeros(localDayOfWeek, token2.length);
            case "co":
                return localize2.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize2.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return localize2.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return localize2.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            case "cccc":
            default:
                return localize2.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date2, token2, localize2) {
        var dayOfWeek = date2.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token2){
            case "i":
                return String(isoDayOfWeek);
            case "ii":
                return addLeadingZeros(isoDayOfWeek, token2.length);
            case "io":
                return localize2.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            case "iii":
                return localize2.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return localize2.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return localize2.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            case "iiii":
            default:
                return localize2.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date2, token2, localize2) {
        var hours = date2.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token2){
            case "a":
            case "aa":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date2, token2, localize2) {
        var hours = date2.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token2){
            case "b":
            case "bb":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date2, token2, localize2) {
        var hours = date2.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token2){
            case "B":
            case "BB":
            case "BBB":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize2.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date2, token2, localize2) {
        if (token2 === "ho") {
            var hours = date2.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize2.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return formatters$1.h(date2, token2);
    },
    // Hour [0-23]
    H: function(date2, token2, localize2) {
        if (token2 === "Ho") return localize2.ordinalNumber(date2.getUTCHours(), {
            unit: "hour"
        });
        return formatters$1.H(date2, token2);
    },
    // Hour [0-11]
    K: function(date2, token2, localize2) {
        var hours = date2.getUTCHours() % 12;
        if (token2 === "Ko") return localize2.ordinalNumber(hours, {
            unit: "hour"
        });
        return addLeadingZeros(hours, token2.length);
    },
    // Hour [1-24]
    k: function(date2, token2, localize2) {
        var hours = date2.getUTCHours();
        if (hours === 0) hours = 24;
        if (token2 === "ko") return localize2.ordinalNumber(hours, {
            unit: "hour"
        });
        return addLeadingZeros(hours, token2.length);
    },
    // Minute
    m: function(date2, token2, localize2) {
        if (token2 === "mo") return localize2.ordinalNumber(date2.getUTCMinutes(), {
            unit: "minute"
        });
        return formatters$1.m(date2, token2);
    },
    // Second
    s: function(date2, token2, localize2) {
        if (token2 === "so") return localize2.ordinalNumber(date2.getUTCSeconds(), {
            unit: "second"
        });
        return formatters$1.s(date2, token2);
    },
    // Fraction of second
    S: function(date2, token2) {
        return formatters$1.S(date2, token2);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token2){
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token2){
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token2){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token2){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timestamp = Math.floor(originalDate.getTime() / 1e3);
        return addLeadingZeros(timestamp, token2.length);
    },
    // Milliseconds timestamp
    T: function(date2, token2, _localize, options) {
        var originalDate = options._originalDate || date2;
        var timestamp = originalDate.getTime();
        return addLeadingZeros(timestamp, token2.length);
    }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
    var sign = offset2 > 0 ? "-" : "+";
    var absOffset = Math.abs(offset2);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter2 = dirtyDelimiter;
    return sign + String(hours) + delimiter2 + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
    if (offset2 % 60 === 0) {
        var sign = offset2 > 0 ? "-" : "+";
        return sign + addLeadingZeros(Math.abs(offset2) / 60, 2);
    }
    return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
    var delimiter2 = dirtyDelimiter || "";
    var sign = offset2 > 0 ? "-" : "+";
    var absOffset = Math.abs(offset2);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter2 + minutes;
}
function dateLongFormatter(pattern, formatLong2) {
    switch(pattern){
        case "P":
            return formatLong2.date({
                width: "short"
            });
        case "PP":
            return formatLong2.date({
                width: "medium"
            });
        case "PPP":
            return formatLong2.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong2.date({
                width: "full"
            });
    }
}
function timeLongFormatter(pattern, formatLong2) {
    switch(pattern){
        case "p":
            return formatLong2.time({
                width: "short"
            });
        case "pp":
            return formatLong2.time({
                width: "medium"
            });
        case "ppp":
            return formatLong2.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong2.time({
                width: "full"
            });
    }
}
function dateTimeLongFormatter(pattern, formatLong2) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong2);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong2.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong2.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong2.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong2.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token2) {
    return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
    return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input2) {
    if (token2 === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://git.io/fxCyr"));
    else if (token2 === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://git.io/fxCyr"));
    else if (token2 === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://git.io/fxCyr"));
    else if (token2 === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://git.io/fxCyr"));
}
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
    requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale2 = options.locale || locale$2;
    var localeFirstWeekContainsDate = locale2.options && locale2.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate);
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale2.options && locale2.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale2.localize) throw new RangeError("locale must contain localize property");
    if (!locale2.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = toDate(dirtyDate);
    if (!isValid(originalDate)) throw new RangeError("Invalid time value");
    var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale2,
        _originalDate: originalDate
    };
    var result2 = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = longFormatters[firstCharacter];
            return longFormatter(substring, locale2.formatLong, formatterOptions);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = formatters[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale2.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result2;
}
function cleanEscapedString(input2) {
    return input2.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    requiredArgs(2, arguments);
    var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
    var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
function declension(scheme, count2) {
    if (scheme.one !== void 0 && count2 === 1) return scheme.one;
    var rem10 = count2 % 10;
    var rem100 = count2 % 100;
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", count2);
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", count2);
    else return scheme.pluralGenitive.replace("{{count}}", count2);
}
function buildLocalizeTokenFn(scheme) {
    return function(count2, options) {
        if (options.addSuffix) {
            if (options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count2);
                else return "\u0447\u0435\u0440\u0435\u0437 " + declension(scheme.regular, count2);
            } else {
                if (scheme.past) return declension(scheme.past, count2);
                else return declension(scheme.regular, count2) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return declension(scheme.regular, count2);
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function(_2, options) {
        if (options.addSuffix) {
            if (options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
function formatDistance(token2, count2, options) {
    options = options || {};
    return formatDistanceLocale[token2](count2, options);
}
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
var timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var formatLong = {
    date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: "any"
    })
};
var accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 2) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function(date2, baseDate, options) {
        var day = date2.getUTCDay();
        if (isSameUTCWeek(date2, baseDate, options)) return thisWeek(day);
        else return lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function(date2, baseDate, options) {
        var day = date2.getUTCDay();
        if (isSameUTCWeek(date2, baseDate, options)) return thisWeek(day);
        else return nextWeek(day);
    },
    other: "P"
};
function formatRelative(token2, date2, baseDate, options) {
    var format2 = formatRelativeLocale[token2];
    if (typeof format2 === "function") return format2(date2, baseDate, options);
    return format2;
}
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
function ordinalNumber(dirtyNumber, dirtyOptions) {
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    var suffix;
    if (unit === "date") suffix = "-\u0435";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = "-\u0439";
    return dirtyNumber + suffix;
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function(value2) {
            return parseInt(value2, 10);
        }
    }),
    era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index2) {
            return index2 + 1;
        }
    }),
    month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var locale$1 = {
    code: "ru",
    formatDistance: formatDistance,
    formatLong: formatLong,
    formatRelative: formatRelative,
    localize: localize,
    match: match,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
const locales$1U = {
    at: "\u0432"
};
const t$1W = distExports$1.getTranslation && locales$1U;
const replaceLocalDateSeparator = (pattern, localesObject)=>{
    return pattern == null ? void 0 : pattern.replace(/&/, (t$1W == null ? void 0 : t$1W.at) || (localesObject == null ? void 0 : localesObject.at) || "");
};
const getLocalDatePattern = (key, locale2, localesObject)=>{
    var _a3;
    const { locale: configLocale } = getConfig();
    return replaceLocalDateSeparator((_a3 = LocalDatePatterns[configLocale]) == null ? void 0 : _a3[key], localesObject);
};
const getUnixTime = (time2)=>time2 * MS_PER_SEC;
const getFormattedDate = (time2, patternKey, isUnixTime = false)=>{
    const { locale: locale2 } = getConfig();
    try {
        return format$1(isUnixTime ? time2 : getUnixTime(time2), getLocalDatePattern(patternKey), {
            locale: locale2 === ELocale.RU ? locale$1 : locale$2
        });
    } catch (err) {
        Log$5.error(`
			Failed getFormattedDate
			time: ${time2}
			getLocalDatePattern(patternKey): ${getLocalDatePattern(patternKey)}
			locale: ${JSON.stringify(locale2 === ELocale.RU ? locale$1 : locale$2)}
		`, err);
        return "";
    }
};
const getDaysBetweenDates = (from2, to)=>{
    return Math.round((getNormalizedTimestamp(to) - getNormalizedTimestamp(from2)) / SEC_PER_DAY);
};
const getNormalizedTimestamp = (date2)=>Math.floor(Number(date2) / 1e3);
const locales$1T = {
    Byte: "\u0431",
    Kb: "\u041A\u0431",
    Mb: "\u041C\u0431",
    Gb: "\u0413\u0431"
};
const t$1V = distExports$1.getTranslation && locales$1T;
const FILE_SIZE_UNIT_ARRAY = Object.keys(FileSizeUnitMap);
const LAST_AVAILABLE_FILE_SIZE_UNIT = FILE_SIZE_UNIT_ARRAY[FILE_SIZE_UNIT_ARRAY.length - 1];
const getFormattedFileSize = (size2, sourceUnit = EFileSizeUnit.B, targetUnit, useLocale = false)=>{
    if (targetUnit && sourceUnit !== targetUnit) {
        const converted = getConvertedFileSize(size2, sourceUnit, targetUnit);
        return `${converted} ${useLocale ? t$1V[targetUnit] : targetUnit}`;
    }
    if (size2 >= 1024 && sourceUnit !== LAST_AVAILABLE_FILE_SIZE_UNIT) {
        const nextUnit = FILE_SIZE_UNIT_ARRAY[FILE_SIZE_UNIT_ARRAY.indexOf(sourceUnit) + 1];
        return getFormattedFileSize(getConvertedFileSize(size2, sourceUnit, nextUnit), nextUnit, targetUnit, useLocale);
    }
    const formattedSize = Number.isInteger(size2) ? size2 : (size2 || 0).toFixed(2);
    return `${formattedSize} ${useLocale ? t$1V[sourceUnit] : sourceUnit}`;
};
const getDiffBetweenDates = (from2, to)=>{
    const diffMS = Math.abs(Number(to) - Number(from2));
    return {
        years: Math.floor(diffMS / MS_PER_YEAR),
        months: Math.floor(diffMS / MS_PER_MONTH),
        weeks: Math.floor(diffMS / MS_PER_WEEK),
        days: Math.floor(diffMS / MS_PER_DAY),
        hours: Math.floor(diffMS / MS_PER_HOUR),
        minutes: Math.floor(diffMS / MS_PER_MIN),
        seconds: Math.floor(diffMS / MS_PER_SEC)
    };
};
const isFollowerLevel = (level)=>level.priority === 0;
const getOptimizedImageUrl = (options)=>{
    const { url, width, height } = options;
    let { isCroped, isRetina } = options;
    const { url: shortUrl, query } = queryString.parseUrl(url);
    isCroped = isCroped === void 0 ? true : isCroped;
    isRetina = isRetina === void 0 ? true : isRetina;
    const newQuery = queryString.stringify({
        ...query,
        mh: height ? isRetina ? height * 2 : height : void 0,
        mw: width ? isRetina ? width * 2 : width : void 0,
        croped: isCroped ? 1 : void 0
    });
    return `${shortUrl}?${newQuery}`;
};
const config$2 = /* @__PURE__ */ new Map([
    [
        1e6,
        "M"
    ],
    [
        1e3,
        "K"
    ],
    [
        1,
        ""
    ]
]);
const floor$2 = (n2, d2)=>Math.floor(n2 / d2);
const roundToOneDec = (n2, d2)=>Math.floor(n2 / d2 * 10) / 10;
const toString$2 = (n2, suf)=>`${n2}${suf}`.replace(".", ",");
const convertToIntLabel = (n2, mult, suf)=>toString$2(floor$2(n2, mult), suf);
const convertToFloatLabel = (n2, mult, suf)=>toString$2(roundToOneDec(n2, mult), suf);
const getShortNum = (num2, params)=>{
    const { limit10KDisabled = false, limit100KDisabled = true } = params ?? {};
    for (const [mult, suffix] of config$2){
        if (!limit10KDisabled && num2 < 10 ** 4 || !limit100KDisabled && num2 < 10 ** 5) return num2.toLocaleString("en");
        else if (num2 >= 10 * mult) return convertToIntLabel(num2, mult, suffix);
        else if (num2 >= mult) return convertToFloatLabel(num2, mult, suffix);
    }
    return "0";
};
const PHONE_CODE_MAX_LENGTH = 4;
const getNumberMaskByCountryCode = (code)=>{
    return PHONE_COUNTRY_CODES_MASKS[code] || PHONE_COUNTRY_CODES_MASKS.default;
};
const getCountryCodeByRawPhone = (rawPhone)=>{
    var _a3;
    const phone = getCleanPhone(rawPhone);
    const greedy = phone.length > PHONE_CODE_MAX_LENGTH ? "?" : "";
    return (_a3 = new RegExp(`"(${phone.slice(0, PHONE_CODE_MAX_LENGTH)}${greedy})`).exec(PHONE_COUNTRY_CODES)) == null ? void 0 : _a3.pop();
};
const createCountryCodeMask = (countryCode)=>{
    return [
        "+",
        ...countryCode.split("").fill(/\d/)
    ];
};
const getCountryCodeMask = (countryCode)=>{
    const defaultMask = [
        "+",
        /\d/
    ];
    if (countryCode) return createCountryCodeMask(countryCode);
    return defaultMask;
};
const createPhoneMask = (countryCodeMask, countryPhoneMask)=>{
    return [
        ...countryCodeMask,
        " ",
        ...countryPhoneMask
    ];
};
const getPhoneMask = (inputValue)=>{
    const countryCode = getCountryCodeByRawPhone(inputValue);
    const countryCodeMask = getCountryCodeMask(countryCode);
    const numberMask = getNumberMaskByCountryCode(countryCode);
    return createPhoneMask(countryCodeMask, numberMask);
};
var axios$3 = {
    exports: {}
};
var bind$4 = function bind(fn2, thisArg) {
    return function wrap2() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn2.apply(thisArg, args);
    };
};
var bind$3 = bind$4;
var toString$1 = Object.prototype.toString;
function isArray$1(val) {
    return toString$1.call(val) === "[object Array]";
}
function isUndefined(val) {
    return typeof val === "undefined";
}
function isBuffer$1(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
    return toString$1.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
    var result2;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result2 = ArrayBuffer.isView(val);
    else result2 = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result2;
}
function isString$1(val) {
    return typeof val === "string";
}
function isNumber$1(val) {
    return typeof val === "number";
}
function isObject$3(val) {
    return val !== null && typeof val === "object";
}
function isPlainObject$3(val) {
    if (toString$1.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
    return toString$1.call(val) === "[object Date]";
}
function isFile(val) {
    return toString$1.call(val) === "[object File]";
}
function isBlob(val) {
    return toString$1.call(val) === "[object Blob]";
}
function isFunction$4(val) {
    return toString$1.call(val) === "[object Function]";
}
function isStream(val) {
    return isObject$3(val) && isFunction$4(val.pipe);
}
function isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn2) {
    if (obj === null || typeof obj === "undefined") return;
    if (typeof obj !== "object") obj = [
        obj
    ];
    if (isArray$1(obj)) for(var i = 0, l2 = obj.length; i < l2; i++)fn2.call(null, obj[i], i, obj);
    else {
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn2.call(null, obj[key], key, obj);
    }
}
function merge$2() {
    var result2 = {};
    function assignValue2(val, key) {
        if (isPlainObject$3(result2[key]) && isPlainObject$3(val)) result2[key] = merge$2(result2[key], val);
        else if (isPlainObject$3(val)) result2[key] = merge$2({}, val);
        else if (isArray$1(val)) result2[key] = val.slice();
        else result2[key] = val;
    }
    for(var i = 0, l2 = arguments.length; i < l2; i++)forEach(arguments[i], assignValue2);
    return result2;
}
function extend(a2, b2, thisArg) {
    forEach(b2, function assignValue2(val, key) {
        if (thisArg && typeof val === "function") a2[key] = bind$3(val, thisArg);
        else a2[key] = val;
    });
    return a2;
}
function stripBOM(content2) {
    if (content2.charCodeAt(0) === 65279) content2 = content2.slice(1);
    return content2;
}
var utils$d = {
    isArray: isArray$1,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer$1,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString$1,
    isNumber: isNumber$1,
    isObject: isObject$3,
    isPlainObject: isPlainObject$3,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction$4,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge$2,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
};
var utils$c = utils$d;
function encode$1(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
    if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if (utils$c.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        utils$c.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if (utils$c.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            utils$c.forEach(val, function parseValue(v2) {
                if (utils$c.isDate(v2)) v2 = v2.toISOString();
                else if (utils$c.isObject(v2)) v2 = JSON.stringify(v2);
                parts.push(encode$1(key) + "=" + encode$1(v2));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};
var utils$b = utils$d;
function InterceptorManager$1() {
    this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
InterceptorManager$1.prototype.forEach = function forEach2(fn2) {
    utils$b.forEach(this.handlers, function forEachHandler(h2) {
        if (h2 !== null) fn2(h2);
    });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$a = utils$d;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
    utils$a.forEach(headers, function processHeader(value2, name2) {
        if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value2;
            delete headers[name2];
        }
    });
};
var enhanceError$1 = function enhanceError(error2, config2, code, request2, response) {
    error2.config = config2;
    if (code) error2.code = code;
    error2.request = request2;
    error2.response = response;
    error2.isAxiosError = true;
    error2.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error2;
};
var createError;
var hasRequiredCreateError;
function requireCreateError() {
    if (hasRequiredCreateError) return createError;
    hasRequiredCreateError = 1;
    var enhanceError3 = enhanceError$1;
    createError = function createError2(message2, config2, code, request2, response) {
        var error2 = new Error(message2);
        return enhanceError3(error2, config2, code, request2, response);
    };
    return createError;
}
var settle;
var hasRequiredSettle;
function requireSettle() {
    if (hasRequiredSettle) return settle;
    hasRequiredSettle = 1;
    var createError2 = requireCreateError();
    settle = function settle2(resolve, reject, response) {
        var validateStatus2 = response.config.validateStatus;
        if (!response.status || !validateStatus2 || validateStatus2(response.status)) resolve(response);
        else reject(createError2("Request failed with status code " + response.status, response.config, null, response.request, response));
    };
    return settle;
}
var cookies$2;
var hasRequiredCookies;
function requireCookies() {
    if (hasRequiredCookies) return cookies$2;
    hasRequiredCookies = 1;
    var utils2 = utils$d;
    cookies$2 = utils2.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
    /* @__PURE__ */ function standardBrowserEnv() {
        return {
            write: function write(name2, value2, expires, path2, domain2, secure) {
                var cookie = [];
                cookie.push(name2 + "=" + encodeURIComponent(value2));
                if (utils2.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
                if (utils2.isString(path2)) cookie.push("path=" + path2);
                if (utils2.isString(domain2)) cookie.push("domain=" + domain2);
                if (secure === true) cookie.push("secure");
                document.cookie = cookie.join("; ");
            },
            read: function read(name2) {
                var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
                return match2 ? decodeURIComponent(match2[3]) : null;
            },
            remove: function remove2(name2) {
                this.write(name2, "", Date.now() - 864e5);
            }
        };
    }() : // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function nonStandardBrowserEnv() {
        return {
            write: function write() {},
            read: function read() {
                return null;
            },
            remove: function remove2() {}
        };
    }();
    return cookies$2;
}
var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
    if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
    hasRequiredIsAbsoluteURL = 1;
    isAbsoluteURL = function isAbsoluteURL2(url) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
    return isAbsoluteURL;
}
var combineURLs;
var hasRequiredCombineURLs;
function requireCombineURLs() {
    if (hasRequiredCombineURLs) return combineURLs;
    hasRequiredCombineURLs = 1;
    combineURLs = function combineURLs2(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
    return combineURLs;
}
var buildFullPath;
var hasRequiredBuildFullPath;
function requireBuildFullPath() {
    if (hasRequiredBuildFullPath) return buildFullPath;
    hasRequiredBuildFullPath = 1;
    var isAbsoluteURL2 = requireIsAbsoluteURL();
    var combineURLs2 = requireCombineURLs();
    buildFullPath = function buildFullPath2(baseURL, requestedURL) {
        if (baseURL && !isAbsoluteURL2(requestedURL)) return combineURLs2(baseURL, requestedURL);
        return requestedURL;
    };
    return buildFullPath;
}
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
    if (hasRequiredParseHeaders) return parseHeaders;
    hasRequiredParseHeaders = 1;
    var utils2 = utils$d;
    var ignoreDuplicateOf = [
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent"
    ];
    parseHeaders = function parseHeaders2(headers) {
        var parsed = {};
        var key;
        var val;
        var i;
        if (!headers) return parsed;
        utils2.forEach(headers.split("\n"), function parser(line) {
            i = line.indexOf(":");
            key = utils2.trim(line.substr(0, i)).toLowerCase();
            val = utils2.trim(line.substr(i + 1));
            if (key) {
                if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                    val
                ]);
                else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
            }
        });
        return parsed;
    };
    return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
    if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
    hasRequiredIsURLSameOrigin = 1;
    var utils2 = utils$d;
    isURLSameOrigin = utils2.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url) {
            var href = url;
            if (msie) {
                urlParsingNode.setAttribute("href", href);
                href = urlParsingNode.href;
            }
            urlParsingNode.setAttribute("href", href);
            return {
                href: urlParsingNode.href,
                protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
                host: urlParsingNode.host,
                search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
                hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
                hostname: urlParsingNode.hostname,
                port: urlParsingNode.port,
                pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
            };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin2(requestURL) {
            var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
            return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
    }() : // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function nonStandardBrowserEnv() {
        return function isURLSameOrigin2() {
            return true;
        };
    }();
    return isURLSameOrigin;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
    if (hasRequiredXhr) return xhr;
    hasRequiredXhr = 1;
    var utils2 = utils$d;
    var settle2 = requireSettle();
    var cookies2 = requireCookies();
    var buildURL3 = buildURL$1;
    var buildFullPath2 = requireBuildFullPath();
    var parseHeaders2 = requireParseHeaders();
    var isURLSameOrigin2 = requireIsURLSameOrigin();
    var createError2 = requireCreateError();
    xhr = function xhrAdapter(config2) {
        return new Promise(function dispatchXhrRequest(resolve, reject) {
            var requestData = config2.data;
            var requestHeaders = config2.headers;
            var responseType = config2.responseType;
            if (utils2.isFormData(requestData)) delete requestHeaders["Content-Type"];
            var request2 = new XMLHttpRequest();
            if (config2.auth) {
                var username2 = config2.auth.username || "";
                var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
                requestHeaders.Authorization = "Basic " + btoa(username2 + ":" + password);
            }
            var fullPath = buildFullPath2(config2.baseURL, config2.url);
            request2.open(config2.method.toUpperCase(), buildURL3(fullPath, config2.params, config2.paramsSerializer), true);
            request2.timeout = config2.timeout;
            function onloadend() {
                if (!request2) return;
                var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
                var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
                var response = {
                    data: responseData,
                    status: request2.status,
                    statusText: request2.statusText,
                    headers: responseHeaders,
                    config: config2,
                    request: request2
                };
                settle2(resolve, reject, response);
                request2 = null;
            }
            if ("onloadend" in request2) request2.onloadend = onloadend;
            else request2.onreadystatechange = function handleLoad() {
                if (!request2 || request2.readyState !== 4) return;
                if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) return;
                setTimeout(onloadend);
            };
            request2.onabort = function handleAbort() {
                if (!request2) return;
                reject(createError2("Request aborted", config2, "ECONNABORTED", request2));
                request2 = null;
            };
            request2.onerror = function handleError() {
                reject(createError2("Network Error", config2, null, request2));
                request2 = null;
            };
            request2.ontimeout = function handleTimeout() {
                var timeoutErrorMessage = "timeout of " + config2.timeout + "ms exceeded";
                if (config2.timeoutErrorMessage) timeoutErrorMessage = config2.timeoutErrorMessage;
                reject(createError2(timeoutErrorMessage, config2, config2.transitional && config2.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
                request2 = null;
            };
            if (utils2.isStandardBrowserEnv()) {
                var xsrfValue = (config2.withCredentials || isURLSameOrigin2(fullPath)) && config2.xsrfCookieName ? cookies2.read(config2.xsrfCookieName) : void 0;
                if (xsrfValue) requestHeaders[config2.xsrfHeaderName] = xsrfValue;
            }
            if ("setRequestHeader" in request2) utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
                if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") delete requestHeaders[key];
                else request2.setRequestHeader(key, val);
            });
            if (!utils2.isUndefined(config2.withCredentials)) request2.withCredentials = !!config2.withCredentials;
            if (responseType && responseType !== "json") request2.responseType = config2.responseType;
            if (typeof config2.onDownloadProgress === "function") request2.addEventListener("progress", config2.onDownloadProgress);
            if (typeof config2.onUploadProgress === "function" && request2.upload) request2.upload.addEventListener("progress", config2.onUploadProgress);
            if (config2.cancelToken) config2.cancelToken.promise.then(function onCanceled(cancel) {
                if (!request2) return;
                request2.abort();
                reject(cancel);
                request2 = null;
            });
            if (!requestData) requestData = null;
            request2.send(requestData);
        });
    };
    return xhr;
}
var utils$9 = utils$d;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$1;
var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value2) {
    if (!utils$9.isUndefined(headers) && utils$9.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value2;
}
function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") adapter = requireXhr();
    return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
    if (utils$9.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return utils$9.trim(rawValue);
    } catch (e2) {
        if (e2.name !== "SyntaxError") throw e2;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults$4 = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            normalizeHeaderName2(headers, "Accept");
            normalizeHeaderName2(headers, "Content-Type");
            if (utils$9.isFormData(data) || utils$9.isArrayBuffer(data) || utils$9.isBuffer(data) || utils$9.isStream(data) || utils$9.isFile(data) || utils$9.isBlob(data)) return data;
            if (utils$9.isArrayBufferView(data)) return data.buffer;
            if (utils$9.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if (utils$9.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                setContentTypeIfUnset(headers, "application/json");
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional2 = this.transitional;
            var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
            var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && utils$9.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e2) {
                if (strictJSONParsing) {
                    if (e2.name === "SyntaxError") throw enhanceError2(e2, this, "E_JSON_PARSE");
                    throw e2;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
defaults$4.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
utils$9.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    defaults$4.headers[method] = {};
});
utils$9.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    defaults$4.headers[method] = utils$9.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$4;
var utils$8 = utils$d;
var defaults$3 = defaults_1;
var transformData$1 = function transformData(data, headers, fns) {
    var context = this || defaults$3;
    utils$8.forEach(fns, function transform2(fn2) {
        data = fn2.call(context, data, headers);
    });
    return data;
};
var isCancel$1;
var hasRequiredIsCancel;
function requireIsCancel() {
    if (hasRequiredIsCancel) return isCancel$1;
    hasRequiredIsCancel = 1;
    isCancel$1 = function isCancel2(value2) {
        return !!(value2 && value2.__CANCEL__);
    };
    return isCancel$1;
}
var utils$7 = utils$d;
var transformData2 = transformData$1;
var isCancel = requireIsCancel();
var defaults$2 = defaults_1;
function throwIfCancellationRequested(config2) {
    if (config2.cancelToken) config2.cancelToken.throwIfRequested();
}
var dispatchRequest$1 = function dispatchRequest(config2) {
    throwIfCancellationRequested(config2);
    config2.headers = config2.headers || {};
    config2.data = transformData2.call(config2, config2.data, config2.headers, config2.transformRequest);
    config2.headers = utils$7.merge(config2.headers.common || {}, config2.headers[config2.method] || {}, config2.headers);
    utils$7.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config2.headers[method];
    });
    var adapter = config2.adapter || defaults$2.adapter;
    return adapter(config2).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config2);
        response.data = transformData2.call(config2, response.data, response.headers, config2.transformResponse);
        return response;
    }, function onAdapterRejection(reason2) {
        if (!isCancel(reason2)) {
            throwIfCancellationRequested(config2);
            if (reason2 && reason2.response) reason2.response.data = transformData2.call(config2, reason2.response.data, reason2.response.headers, config2.transformResponse);
        }
        return Promise.reject(reason2);
    });
};
var utils$6 = utils$d;
var mergeConfig$2 = function mergeConfig(config1, config2) {
    config2 = config2 || {};
    var config3 = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target2, source) {
        if (utils$6.isPlainObject(target2) && utils$6.isPlainObject(source)) return utils$6.merge(target2, source);
        else if (utils$6.isPlainObject(source)) return utils$6.merge({}, source);
        else if (utils$6.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!utils$6.isUndefined(config2[prop])) config3[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!utils$6.isUndefined(config1[prop])) config3[prop] = getMergedValue(void 0, config1[prop]);
    }
    utils$6.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils$6.isUndefined(config2[prop])) config3[prop] = getMergedValue(void 0, config2[prop]);
    });
    utils$6.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    utils$6.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils$6.isUndefined(config2[prop])) config3[prop] = getMergedValue(void 0, config2[prop]);
        else if (!utils$6.isUndefined(config1[prop])) config3[prop] = getMergedValue(void 0, config1[prop]);
    });
    utils$6.forEach(directMergeKeys, function merge2(prop) {
        if (prop in config2) config3[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config3[prop] = getMergedValue(void 0, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    utils$6.forEach(otherKeys, mergeDeepProperties);
    return config3;
};
const version$3 = "0.21.4";
const require$$0$1 = {
    version: version$3
};
var pkg = require$$0$1;
var validators$1 = {};
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    validators$1[type] = function validator2(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split(".");
function isOlderVersion(version2, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
    var destVer = version2.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
validators$1.transitional = function transitional(validator2, version2, message2) {
    var isDeprecated = version2 && isOlderVersion(version2);
    function formatMessage(opt, desc) {
        return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
    }
    return function(value2, opt, opts) {
        if (validator2 === false) throw new Error(formatMessage(opt, " has been removed in " + version2));
        if (isDeprecated && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
        }
        return validator2 ? validator2(value2, opt, opts) : true;
    };
};
function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys3 = Object.keys(options);
    var i = keys3.length;
    while(i-- > 0){
        var opt = keys3[i];
        var validator2 = schema[opt];
        if (validator2) {
            var value2 = options[opt];
            var result2 = value2 === void 0 || validator2(value2, opt, options);
            if (result2 !== true) throw new TypeError("option " + opt + " must be " + result2);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
var validator$1 = {
    isOlderVersion: isOlderVersion,
    assertOptions: assertOptions,
    validators: validators$1
};
var utils$5 = utils$d;
var buildURL2 = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
Axios$1.prototype.request = function request(config2) {
    if (typeof config2 === "string") {
        config2 = arguments[1] || {};
        config2.url = arguments[0];
    } else config2 = config2 || {};
    config2 = mergeConfig$1(this.defaults, config2);
    if (config2.method) config2.method = config2.method.toLowerCase();
    else if (this.defaults.method) config2.method = this.defaults.method.toLowerCase();
    else config2.method = "get";
    var transitional2 = config2.transitional;
    if (transitional2 !== void 0) validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
        forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
        clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
    }, false);
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest2,
            void 0
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config2);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config2;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error2) {
            onRejected(error2);
            break;
        }
    }
    try {
        promise = dispatchRequest2(newConfig);
    } catch (error2) {
        return Promise.reject(error2);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
Axios$1.prototype.getUri = function getUri(config2) {
    config2 = mergeConfig$1(this.defaults, config2);
    return buildURL2(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$5.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData2(method) {
    Axios$1.prototype[method] = function(url, config2) {
        return this.request(mergeConfig$1(config2 || {}, {
            method: method,
            url: url,
            data: (config2 || {}).data
        }));
    };
});
utils$5.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData2(method) {
    Axios$1.prototype[method] = function(url, data, config2) {
        return this.request(mergeConfig$1(config2 || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
var Axios_1 = Axios$1;
var Cancel_1;
var hasRequiredCancel;
function requireCancel() {
    if (hasRequiredCancel) return Cancel_1;
    hasRequiredCancel = 1;
    function Cancel(message2) {
        this.message = message2;
    }
    Cancel.prototype.toString = function toString2() {
        return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    Cancel_1 = Cancel;
    return Cancel_1;
}
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
    if (hasRequiredCancelToken) return CancelToken_1;
    hasRequiredCancelToken = 1;
    var Cancel = requireCancel();
    function CancelToken(executor) {
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token2 = this;
        executor(function cancel(message2) {
            if (token2.reason) return;
            token2.reason = new Cancel(message2);
            resolvePromise(token2.reason);
        });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) throw this.reason;
    };
    CancelToken.source = function source() {
        var cancel;
        var token2 = new CancelToken(function executor(c2) {
            cancel = c2;
        });
        return {
            token: token2,
            cancel: cancel
        };
    };
    CancelToken_1 = CancelToken;
    return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
    if (hasRequiredSpread) return spread;
    hasRequiredSpread = 1;
    spread = function spread2(callback) {
        return function wrap2(arr) {
            return callback.apply(null, arr);
        };
    };
    return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
    if (hasRequiredIsAxiosError) return isAxiosError;
    hasRequiredIsAxiosError = 1;
    isAxiosError = function isAxiosError2(payload) {
        return typeof payload === "object" && payload.isAxiosError === true;
    };
    return isAxiosError;
}
var utils$4 = utils$d;
var bind$2 = bind$4;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults$1 = defaults_1;
function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind$2(Axios.prototype.request, context);
    utils$4.extend(instance, Axios.prototype, context);
    utils$4.extend(instance, context);
    return instance;
}
var axios$2 = createInstance(defaults$1);
axios$2.Axios = Axios;
axios$2.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(axios$2.defaults, instanceConfig));
};
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();
axios$2.all = function all(promises) {
    return Promise.all(promises);
};
axios$2.spread = requireSpread();
axios$2.isAxiosError = requireIsAxiosError();
axios$3.exports = axios$2;
axios$3.exports.default = axios$2;
var axiosExports = axios$3.exports;
var axios = axiosExports;
const axios$1 = /* @__PURE__ */ getDefaultExportFromCjs(axios);
var dist$4 = {};
var addQueryStringParams$2 = {};
var addQueryStringParams$1 = {};
Object.defineProperty(addQueryStringParams$1, "__esModule", {
    value: true
});
addQueryStringParams$1.addQueryStringParams = void 0;
var addQueryStringParams = function(url, params) {
    var newUrl = url;
    var isFirstParam = false;
    var querySymbolPosition = url.indexOf("?");
    if (querySymbolPosition === -1) {
        newUrl += "?";
        isFirstParam = true;
    } else if (querySymbolPosition === url.length - 1) isFirstParam = true;
    Object.keys(params).forEach(function(key, index2) {
        var reg = new RegExp("([?&])".concat(key, "=[^&]*"));
        if (!url.match(reg)) {
            if (!isFirstParam) newUrl += "&";
            newUrl += "".concat(key, "=").concat(params[key]);
        } else newUrl = newUrl.replace(reg, "$1".concat(key, "=").concat(params[key]));
        isFirstParam = false;
    });
    return newUrl;
};
addQueryStringParams$1.addQueryStringParams = addQueryStringParams;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(addQueryStringParams$1, exports2);
})(addQueryStringParams$2);
var cookies$1 = {};
var cookies = {};
var Log$4 = {};
var Log$3 = {};
Object.defineProperty(Log$3, "__esModule", {
    value: true
});
Log$3.Log = void 0;
var Log$2 = /** @class */ function() {
    function Log2() {}
    Log2.setUserId = function(userId) {
        this.userId = userId;
    };
    Log2.getUserId = function() {
        return this.userId;
    };
    Log2.setIsServer = function(isServer) {
        this.isServer = isServer;
    };
    Log2.message = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var log2 = [
            "".concat(/* @__PURE__ */ new Date().toString(), ":")
        ].concat(args.slice());
        if (console && console.log) console.log.apply(console, log2);
        if (!this.isServer) {
            this.logs.push(log2.join(" "));
            this.slice();
        }
    };
    Log2.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var log2 = [
            "".concat(/* @__PURE__ */ new Date().toString(), ":")
        ].concat(args.slice());
        if (console && console.error) console.error.apply(console, log2);
        if (!this.isServer) {
            this.logs.push(log2.join(" "));
            this.slice();
        }
    };
    Log2.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var log2 = [
            "".concat(/* @__PURE__ */ new Date().toString(), ":")
        ].concat(args.slice());
        if (console && console.debug) console.debug.apply(console, log2);
        if (!this.isServer) {
            this.logs.push(log2.join(" "));
            this.slice();
        }
    };
    Log2.errorRequest = function(err) {
        if (err && err.request) {
            var status_1 = err.status, _a3 = err.request, _b2 = _a3.url, url = _b2 === void 0 ? "" : _b2, _c2 = _a3.method, method = _c2 === void 0 ? "" : _c2, data = _a3.data;
            this.error("Failed network request: ".concat(status_1, " ").concat(method.toUpperCase(), " ").concat(url, " ").concat(data));
            if (err.body) this.error("Body: ".concat(err.body));
            if (err.message) this.error("Error message: ".concat(err.message));
        }
    };
    Log2.slice = function() {
        this.logs = this.logs.slice(-this.MAX_ITEMS);
    };
    Log2.getLogs = function() {
        return this.logs;
    };
    Log2.userId = null;
    Log2.logs = [];
    Log2.MAX_ITEMS = 300;
    Log2.isServer = false;
    return Log2;
}();
Log$3.Log = Log$2;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(Log$3, exports2);
})(Log$4);
Object.defineProperty(cookies, "__esModule", {
    value: true
});
cookies.removeFromCookies = cookies.setToCookies = cookies.getFromCookies = void 0;
var Cookies = js_cookieExports;
var Log_1 = Log$4;
var getFromCookies = function(key) {
    Log_1.Log.debug('Read from cookies "'.concat(key, '"'));
    return Cookies.get(key);
};
cookies.getFromCookies = getFromCookies;
var setToCookies = function(key, value2, options) {
    if (options === void 0) options = {};
    Log_1.Log.debug('Write to cookies "'.concat(key, '": "').concat(value2, '" with options "').concat(options ? JSON.stringify(options) : "", '"'));
    Cookies.set(key, value2, options);
};
cookies.setToCookies = setToCookies;
var removeFromCookies = function(key) {
    Log_1.Log.debug('Remove from cookies "'.concat(key, '"'));
    Cookies.remove(key);
};
cookies.removeFromCookies = removeFromCookies;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(cookies, exports2);
})(cookies$1);
var delay$2 = {};
var delay$1 = {};
var __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P2, generator) {
    function adopt(value2) {
        return value2 instanceof P2 ? value2 : new P2(function(resolve) {
            resolve(value2);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value2) {
            try {
                step(generator.next(value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function rejected(value2) {
            try {
                step(generator["throw"](value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$2 = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body2) {
    var _2 = {
        label: 0,
        sent: function() {
            if (t2[0] & 1) throw t2[1];
            return t2[1];
        },
        trys: [],
        ops: []
    }, f2, y2, t2, g2;
    return g2 = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
    }), g2;
    function verb(n2) {
        return function(v2) {
            return step([
                n2,
                v2
            ]);
        };
    }
    function step(op) {
        if (f2) throw new TypeError("Generator is already executing.");
        while(_2)try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done) return t2;
            if (y2 = 0, t2) op = [
                op[0] & 2,
                t2.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t2 = op;
                    break;
                case 4:
                    _2.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _2.label++;
                    y2 = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _2.ops.pop();
                    _2.trys.pop();
                    continue;
                default:
                    if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _2 = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                        _2.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _2.label < t2[1]) {
                        _2.label = t2[1];
                        t2 = op;
                        break;
                    }
                    if (t2 && _2.label < t2[2]) {
                        _2.label = t2[2];
                        _2.ops.push(op);
                        break;
                    }
                    if (t2[2]) _2.ops.pop();
                    _2.trys.pop();
                    continue;
            }
            op = body2.call(thisArg, _2);
        } catch (e2) {
            op = [
                6,
                e2
            ];
            y2 = 0;
        } finally{
            f2 = t2 = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(delay$1, "__esModule", {
    value: true
});
delay$1.delay = void 0;
var delay = function(time2) {
    return __awaiter$3(void 0, void 0, void 0, function() {
        return __generator$2(this, function(_a3) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, time2);
                })
            ];
        });
    });
};
delay$1.delay = delay;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(delay$1, exports2);
})(delay$2);
var getFormattedNumber$2 = {};
var getFormattedNumber$1 = {};
Object.defineProperty(getFormattedNumber$1, "__esModule", {
    value: true
});
getFormattedNumber$1.getFormattedNumber = void 0;
var getFormattedNumber = function(num2, separator2) {
    if (separator2 === void 0) separator2 = " ";
    return String(num2).replace(/\B(?=(\d{3})+(?!\d))/g, separator2);
};
getFormattedNumber$1.getFormattedNumber = getFormattedNumber;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getFormattedNumber$1, exports2);
})(getFormattedNumber$2);
var getHumanReadableNumber$2 = {};
var getHumanReadableNumber$1 = {};
Object.defineProperty(getHumanReadableNumber$1, "__esModule", {
    value: true
});
getHumanReadableNumber$1.getHumanReadableNumber = void 0;
var getHumanReadableNumber = function(value2, separator2) {
    if (separator2 === void 0) separator2 = "";
    var humanNumber;
    if (value2 < 1e3) humanNumber = String(value2);
    else if (value2 < 999950) humanNumber = (value2 / 1e3).toFixed(1).replace(/\.0$/, "") + separator2 + "K";
    else humanNumber = (value2 / 1e6).toFixed(1).replace(/\.0$/, "") + separator2 + "M";
    return humanNumber;
};
getHumanReadableNumber$1.getHumanReadableNumber = getHumanReadableNumber;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getHumanReadableNumber$1, exports2);
})(getHumanReadableNumber$2);
var getParametrizedUrl$3 = {};
var getParametrizedUrl$2 = {};
var utils$3 = {};
var isObjectToQueryPropertyNotEmpty$2 = {};
Object.defineProperty(isObjectToQueryPropertyNotEmpty$2, "__esModule", {
    value: true
});
isObjectToQueryPropertyNotEmpty$2.isObjectToQueryPropertyNotEmpty = void 0;
var isObjectToQueryPropertyNotEmpty$1 = function(key, object2) {
    var value2 = object2[key];
    return Boolean(Array.isArray(value2) ? value2.length : value2);
};
isObjectToQueryPropertyNotEmpty$2.isObjectToQueryPropertyNotEmpty = isObjectToQueryPropertyNotEmpty$1;
var objectToQueryPropertyToParam$2 = {};
Object.defineProperty(objectToQueryPropertyToParam$2, "__esModule", {
    value: true
});
objectToQueryPropertyToParam$2.objectToQueryPropertyToParam = void 0;
var objectToQueryPropertyToParam$1 = function(key, object2) {
    var value2 = object2[key];
    return "".concat(key, "=").concat(encodeURIComponent(Array.isArray(value2) ? value2.join(",") : String(value2)));
};
objectToQueryPropertyToParam$2.objectToQueryPropertyToParam = objectToQueryPropertyToParam$1;
var objectToQueryString$2 = {};
Object.defineProperty(objectToQueryString$2, "__esModule", {
    value: true
});
objectToQueryString$2.objectToQueryString = void 0;
var isObjectToQueryPropertyNotEmpty_1 = isObjectToQueryPropertyNotEmpty$2;
var objectToQueryPropertyToParam_1 = objectToQueryPropertyToParam$2;
var objectToQueryString$1 = function(object2) {
    var queryParams = Object.keys(object2).filter(function(key) {
        return (0, isObjectToQueryPropertyNotEmpty_1.isObjectToQueryPropertyNotEmpty)(key, object2);
    }).map(function(key) {
        return (0, objectToQueryPropertyToParam_1.objectToQueryPropertyToParam)(key, object2);
    }).join("&");
    return queryParams ? "?".concat(queryParams) : "";
};
objectToQueryString$2.objectToQueryString = objectToQueryString$1;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isObjectToQueryPropertyNotEmpty$2, exports2);
    __exportStar(objectToQueryPropertyToParam$2, exports2);
    __exportStar(objectToQueryString$2, exports2);
})(utils$3);
Object.defineProperty(getParametrizedUrl$2, "__esModule", {
    value: true
});
getParametrizedUrl$2.getParametrizedUrl = void 0;
var utils_1 = utils$3;
var getParametrizedUrl$1 = function(url, params, query) {
    var resultUrl = url.replace(/\/\?$/, "");
    if (params) Object.keys(params).forEach(function(key) {
        return resultUrl = resultUrl.replace(new RegExp(":".concat(key), "g"), String(params[key]));
    });
    if (query && Object.keys(query).length) resultUrl += (0, utils_1.objectToQueryString)(query);
    return resultUrl;
};
getParametrizedUrl$2.getParametrizedUrl = getParametrizedUrl$1;
var types$2 = {};
Object.defineProperty(types$2, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getParametrizedUrl$2, exports2);
    __exportStar(types$2, exports2);
})(getParametrizedUrl$3);
var getRandomInt$2 = {};
var getRandomInt$1 = {};
Object.defineProperty(getRandomInt$1, "__esModule", {
    value: true
});
getRandomInt$1.getRandomInt = void 0;
var getRandomInt = function(startInt, endInt) {
    if (startInt === void 0) startInt = 0;
    if (endInt === void 0) endInt = Number.MAX_SAFE_INTEGER;
    return Math.floor(startInt + Math.random() * (endInt - startInt + 1));
};
getRandomInt$1.getRandomInt = getRandomInt;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getRandomInt$1, exports2);
})(getRandomInt$2);
var getURIParams$6 = {};
var getURIParams$5 = {};
Object.defineProperty(getURIParams$5, "__esModule", {
    value: true
});
getURIParams$5.getURIParams = void 0;
var getURIParams$4 = function(params) {
    return Object.keys(params).reduce(function(prev, cur) {
        if (params[cur] == null) return prev;
        return "".concat(prev).concat(prev ? "&" : "").concat(cur, "=").concat(encodeURIComponent(String(params[cur])));
    }, "");
};
getURIParams$5.getURIParams = getURIParams$4;
var types$1 = {};
Object.defineProperty(types$1, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getURIParams$5, exports2);
    __exportStar(types$1, exports2);
})(getURIParams$6);
var htmlEntities$3 = {};
var htmlEntities$2 = {};
var enums$1 = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ECharsDecoded = exports2.ECharsEncoded = void 0;
    (function(ECharsEncoded) {
        ECharsEncoded["AMP"] = "&amp;";
        ECharsEncoded["LT"] = "&lt;";
        ECharsEncoded["GT"] = "&gt;";
        ECharsEncoded["QUOTE"] = "&#39;";
        ECharsEncoded["DOUBLE_QUOTE"] = "&quot;";
    })(exports2.ECharsEncoded || (exports2.ECharsEncoded = {}));
    (function(ECharsDecoded) {
        ECharsDecoded["AMP"] = "&";
        ECharsDecoded["LT"] = "<";
        ECharsDecoded["GT"] = ">";
        ECharsDecoded["QUOTE"] = "'";
        ECharsDecoded["DOUBLE_QUOTE"] = '"';
    })(exports2.ECharsDecoded || (exports2.ECharsDecoded = {}));
})(enums$1);
var _a2;
Object.defineProperty(htmlEntities$2, "__esModule", {
    value: true
});
htmlEntities$2.htmlEntitiesDecode = htmlEntities$2.htmlEntitiesEncode = void 0;
var enums_1 = enums$1;
var encodingMap = (_a2 = {}, _a2[enums_1.ECharsDecoded.AMP] = enums_1.ECharsEncoded.AMP, _a2[enums_1.ECharsDecoded.LT] = enums_1.ECharsEncoded.LT, _a2[enums_1.ECharsDecoded.GT] = enums_1.ECharsEncoded.GT, _a2[enums_1.ECharsDecoded.QUOTE] = enums_1.ECharsEncoded.QUOTE, _a2[enums_1.ECharsDecoded.DOUBLE_QUOTE] = enums_1.ECharsEncoded.DOUBLE_QUOTE, _a2);
var decodingMap = Object.entries(encodingMap).reduce(function(acc, _a3) {
    var key = _a3[0], val = _a3[1];
    acc[val] = key;
    return acc;
}, {});
var htmlEntitiesEncode$1 = function(str, charsToEncode) {
    if (charsToEncode === void 0) charsToEncode = [
        enums_1.ECharsDecoded.LT,
        enums_1.ECharsDecoded.GT
    ];
    var searchValue = new RegExp(charsToEncode.join("|"), "g");
    return str.replace(searchValue, function(symbol) {
        return encodingMap[symbol];
    });
};
htmlEntities$2.htmlEntitiesEncode = htmlEntitiesEncode$1;
var htmlEntitiesDecode$1 = function(str, charsToDecode) {
    if (charsToDecode === void 0) charsToDecode = [
        enums_1.ECharsEncoded.LT,
        enums_1.ECharsEncoded.GT
    ];
    var searchValue = new RegExp(charsToDecode.map(function(char) {
        return "(".concat(char, ")");
    }).join("|"), "g");
    return str.replace(searchValue, function(symbol) {
        return decodingMap[symbol];
    });
};
htmlEntities$2.htmlEntitiesDecode = htmlEntitiesDecode$1;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(htmlEntities$2, exports2);
    __exportStar(enums$1, exports2);
})(htmlEntities$3);
var isValidEmail$2 = {};
var isValidEmail$1 = {};
Object.defineProperty(isValidEmail$1, "__esModule", {
    value: true
});
isValidEmail$1.isValidEmail = void 0;
function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
isValidEmail$1.isValidEmail = isValidEmail;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isValidEmail$1, exports2);
})(isValidEmail$2);
var localStorage$2 = {};
var localStorage$1 = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.removeFromLocalStorage = exports2.setStringifiedToLocalStorage = exports2.setToLocalStorage = exports2.getParsedFromLocalStorage = exports2.getFromLocalStorage = void 0;
    var Log_12 = Log$4;
    var getFromLocalStorage2 = function(key) {
        Log_12.Log.debug('Read from localStorage "'.concat(key, '"'));
        try {
            return window.localStorage.getItem(key);
        } catch (err) {
            if (err instanceof Error) Log_12.Log.error("Failed read key ".concat(key, " from localStorage: ").concat(err && err.toString() ? err.toString() : String(err)));
            return null;
        }
    };
    exports2.getFromLocalStorage = getFromLocalStorage2;
    var getParsedFromLocalStorage2 = function(key) {
        Log_12.Log.debug('Read from localStorage "'.concat(key, '"'));
        try {
            return JSON.parse((0, exports2.getFromLocalStorage)(key));
        } catch (err) {
            if (err instanceof Error) Log_12.Log.error("Failed parse JSON from localStorage item ".concat(String(key), " : ").concat(err && err.toString() ? err.toString() : String(err)));
            return null;
        }
    };
    exports2.getParsedFromLocalStorage = getParsedFromLocalStorage2;
    var setToLocalStorage2 = function(key, value2) {
        Log_12.Log.debug('Write to localStorage "'.concat(key, '": "').concat(value2, '"'));
        try {
            window.localStorage.setItem(key, value2);
        } catch (err) {
            if (err instanceof Error) Log_12.Log.error("Failed write key ".concat(key, " to localStorage: ").concat(err && err.toString() ? err.toString() : String(err)));
        }
    };
    exports2.setToLocalStorage = setToLocalStorage2;
    var setStringifiedToLocalStorage = function(key, value2) {
        (0, exports2.setToLocalStorage)(key, JSON.stringify(value2));
    };
    exports2.setStringifiedToLocalStorage = setStringifiedToLocalStorage;
    var removeFromLocalStorage2 = function(key) {
        Log_12.Log.debug('Remove from localStorage "'.concat(key, '"'));
        try {
            window.localStorage.removeItem(key);
        } catch (err) {
            if (err instanceof Error) Log_12.Log.error("Failed remove key ".concat(key, " from localStorage: ").concat(err && err.toString() ? err.toString() : String(err)));
        }
    };
    exports2.removeFromLocalStorage = removeFromLocalStorage2;
})(localStorage$1);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(localStorage$1, exports2);
})(localStorage$2);
var noop$5 = {};
var noop$4 = {};
Object.defineProperty(noop$4, "__esModule", {
    value: true
});
noop$4.noopPromise = noop$4.noop = void 0;
var noop$3 = function() {
    return null;
};
noop$4.noop = noop$3;
var noopPromise = function() {
    return new Promise(function(resolve) {
        resolve(null);
    });
};
noop$4.noopPromise = noopPromise;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(noop$4, exports2);
})(noop$5);
var strCapitalize$2 = {};
var strCapitalize$1 = {};
Object.defineProperty(strCapitalize$1, "__esModule", {
    value: true
});
strCapitalize$1.strCapitalize = void 0;
var strCapitalize = function(str) {
    if (str === void 0) str = "";
    return str.length ? "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1)) : "";
};
strCapitalize$1.strCapitalize = strCapitalize;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(strCapitalize$1, exports2);
})(strCapitalize$2);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(addQueryStringParams$2, exports2);
    __exportStar(cookies$1, exports2);
    __exportStar(delay$2, exports2);
    __exportStar(getFormattedNumber$2, exports2);
    __exportStar(getHumanReadableNumber$2, exports2);
    __exportStar(getParametrizedUrl$3, exports2);
    __exportStar(getRandomInt$2, exports2);
    __exportStar(getURIParams$6, exports2);
    __exportStar(htmlEntities$3, exports2);
    __exportStar(isValidEmail$2, exports2);
    __exportStar(localStorage$2, exports2);
    __exportStar(Log$4, exports2);
    __exportStar(noop$5, exports2);
    __exportStar(strCapitalize$2, exports2);
})(dist$4);
const sendToGraphite = async (metric)=>{
    const { hosts: { api: api2 } } = getConfig();
    return axios$1({
        method: "POST",
        url: `${api2}/v1${dist$4.getParametrizedUrl(API_URL.STAT_GRAPHITE, {
            metric: metric
        })}`
    });
};
class HtmlEntities {
    static encode(str) {
        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    static decode(str) {
        return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    }
    static escapeURL(str) {
        return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/\'/g, "&#39;");
    }
}
const isUserLinkedToBoosty = (currentUser2)=>{
    return Boolean(currentUser2 == null ? void 0 : currentUser2.hasBoostyIntegration);
};
const isUserLinkedToVkPlay = (currentUser2)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.authSource) == null ? void 0 : _a3.list) == null ? void 0 : _b2.includes(EExternalLinksSource.VKPLAY);
};
const isChatSystemMessage = (message2)=>{
    return message2 && message2.isSystemMessage;
};
const isChatUserMessage = (message2)=>{
    return message2 && !isChatSystemMessage(message2);
};
const MAX_THRESHOLD = 1e3;
const isConditionalFeatureEnable = (feature)=>{
    const { conditionalFeatures: conditionalFeatures2 } = getConfig();
    const { threshold = 0, users = [] } = conditionalFeatures2[feature] || {};
    return threshold === MAX_THRESHOLD ? true : false;
};
const getTextFromTextMediaDataItem = (item2)=>{
    var _a3;
    if ((_a3 = item2.content) == null ? void 0 : _a3.match(/^\[".+\]$/g)) return JSON.parse(item2.content)[EPackedTextBlock.TEXT];
    return item2.content;
};
const isEmptyMediaData = (data)=>{
    return !Array.isArray(data) || data.every((item2)=>isEmptyMediaDataItem(item2));
};
const isEmptyMediaDataItem = (item2)=>{
    try {
        if (item2.type === EMediaDataType.TEXT) {
            if (item2.modificator === EMediaDataTextModificator.BLOCK_END) return true;
            const text2 = getTextFromTextMediaDataItem(item2);
            if (text2.trim() === "") return true;
        }
        return false;
    } catch  {
        return false;
    }
};
function isSmileMediaDataItem(item2) {
    return item2.type === EMediaDataType.SMILE;
}
function isTextOrLinkItem(item2) {
    return Boolean(item2.type === EMediaDataType.LINK || item2.type === EMediaDataType.TEXT && item2.modificator !== EMediaDataTextModificator.BLOCK_END);
}
const isMentionItem = (item2)=>{
    return item2.type === EMediaDataType.MENTION;
};
const isSpaceItem = (item2)=>{
    return item2.type === EMediaDataType.SPACE;
};
function isParagraphEnd$1(block2) {
    return block2.type === EMediaDataType.TEXT && block2.modificator === EMediaDataTextModificator.BLOCK_END;
}
const isMentionInteractive = (data, currentUserId, shouldHighlightCurrentUser)=>{
    return shouldHighlightCurrentUser ? true : currentUserId !== Number(data.id);
};
const isTextItem = (item2)=>Boolean(item2.type === EMediaDataType.TEXT && item2.modificator !== EMediaDataTextModificator.BLOCK_END);
const linkifyText = (text2, customLinkRegexp)=>{
    return text2.replace(customLinkRegexp || URL_LINK_REGEXP, (url)=>`<a href='${url}'>${url}</a>`);
};
const isEqualType = (a2, b2)=>(a2 == null ? void 0 : a2.type) === (b2 == null ? void 0 : b2.type);
const isEqualTextItem = (a2, b2)=>a2.content === b2.content;
const isEqualMentionItem = (a2, b2)=>a2.nick === b2.nick;
const isEqualSmileItem = (a2, b2)=>a2.name === b2.name;
const isEqualLinkItem = (a2, b2)=>a2.content === b2.content;
const filterItems = (item2)=>!((item2 == null ? void 0 : item2.modificator) === "BLOCK_END" && (item2 == null ? void 0 : item2.content) === "") && !((item2 == null ? void 0 : item2.content) === '["","unstyled",[]]');
const isEqualMediaData = (a2, b2)=>{
    const itemsA = a2.filter(filterItems);
    const itemsB = b2.filter(filterItems);
    if (itemsA.length !== itemsB.length) return false;
    for(let index2 = 0; index2 < itemsA.length; index2++){
        const itemA = itemsA[index2];
        const itemB = itemsB[index2];
        if (!isEqualType(itemA, itemB)) return false;
        if (itemA.type === EMediaDataType.TEXT && !isEqualTextItem(itemA, itemB)) return false;
        if (itemA.type === EMediaDataType.MENTION && !isEqualMentionItem(itemA, itemB)) return false;
        if (itemA.type === EMediaDataType.SMILE && !isEqualSmileItem(itemA, itemB)) return false;
        if (itemA.type === EMediaDataType.LINK && !isEqualLinkItem(itemA, itemB)) return false;
    }
    return true;
};
const noop$2 = ()=>null;
const omit = (object2, ...names)=>{
    const res = {
        ...object2
    };
    for (const name2 of names)delete res[name2];
    return res;
};
const prepareBlogPostDataForSave = (blogPostData)=>blogPostData.map((item2)=>item2.type === EMediaDataType.IMAGE ? omit(item2, "url") : item2);
var dist$3 = function(e2) {
    var t2 = {};
    function r2(n2) {
        if (t2[n2]) return t2[n2].exports;
        var o2 = t2[n2] = {
            i: n2,
            l: false,
            exports: {}
        };
        return e2[n2].call(o2.exports, o2, o2.exports, r2), o2.l = true, o2.exports;
    }
    return r2.m = e2, r2.c = t2, r2.d = function(e3, t3, n2) {
        r2.o(e3, t3) || Object.defineProperty(e3, t3, {
            enumerable: true,
            get: n2
        });
    }, r2.r = function(e3) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e3, "__esModule", {
            value: true
        });
    }, r2.t = function(e3, t3) {
        if (1 & t3 && (e3 = r2(e3)), 8 & t3) return e3;
        if (4 & t3 && "object" == typeof e3 && e3 && e3.__esModule) return e3;
        var n2 = /* @__PURE__ */ Object.create(null);
        if (r2.r(n2), Object.defineProperty(n2, "default", {
            enumerable: true,
            value: e3
        }), 2 & t3 && "string" != typeof e3) for(var o2 in e3)r2.d(n2, o2, (function(t4) {
            return e3[t4];
        }).bind(null, o2));
        return n2;
    }, r2.n = function(e3) {
        var t3 = e3 && e3.__esModule ? function() {
            return e3.default;
        } : function() {
            return e3;
        };
        return r2.d(t3, "a", t3), t3;
    }, r2.o = function(e3, t3) {
        return Object.prototype.hasOwnProperty.call(e3, t3);
    }, r2.p = "/", r2(r2.s = 1);
}([
    function(e2, t2, r2) {
        Object.defineProperty(t2, "__esModule", {
            value: true
        }), t2.AuthRejection = t2.AuthFailureLevel = t2.AuthOperationType = void 0, function(e3) {
            e3.GET_TOKEN = "GET_TOKEN", e3.GET_USER_DATA = "GET_USER_DATA", e3.REFRESH_TOKEN = "REFRESH_TOKEN";
        }(t2.AuthOperationType || (t2.AuthOperationType = {})), function(e3) {
            e3.MINOR = "MINOR", e3.EXPECTED = "EXPECTED", e3.SEVERE = "SEVERE";
        }(t2.AuthFailureLevel || (t2.AuthFailureLevel = {}));
        var n2 = function(e3, t3, r3) {
            this.reason = e3, this.operation = t3, this.level = r3;
        };
        t2.AuthRejection = n2;
    },
    function(e2, t2, r2) {
        var n2 = this && this.__createBinding || (Object.create ? function(e3, t3, r3, n3) {
            void 0 === n3 && (n3 = r3), Object.defineProperty(e3, n3, {
                enumerable: true,
                get: function() {
                    return t3[r3];
                }
            });
        } : function(e3, t3, r3, n3) {
            void 0 === n3 && (n3 = r3), e3[n3] = t3[r3];
        }), o2 = this && this.__exportStar || function(e3, t3) {
            for(var r3 in e3)"default" === r3 || t3.hasOwnProperty(r3) || n2(t3, e3, r3);
        };
        Object.defineProperty(t2, "__esModule", {
            value: true
        }), o2(r2(0), t2), o2(r2(2), t2), o2(r2(5), t2);
    },
    function(e2, t2, r2) {
        var n2 = this && this.__awaiter || function(e3, t3, r3, n3) {
            return new (r3 || (r3 = Promise))(function(o3, i2) {
                function s3(e4) {
                    try {
                        a3(n3.next(e4));
                    } catch (e5) {
                        i2(e5);
                    }
                }
                function u3(e4) {
                    try {
                        a3(n3.throw(e4));
                    } catch (e5) {
                        i2(e5);
                    }
                }
                function a3(e4) {
                    var t4;
                    e4.done ? o3(e4.value) : (t4 = e4.value, t4 instanceof r3 ? t4 : new r3(function(e5) {
                        e5(t4);
                    })).then(s3, u3);
                }
                a3((n3 = n3.apply(e3, t3 || [])).next());
            });
        }, o2 = this && this.__generator || function(e3, t3) {
            var r3, n3, o3, i2, s3 = {
                label: 0,
                sent: function() {
                    if (1 & o3[0]) throw o3[1];
                    return o3[1];
                },
                trys: [],
                ops: []
            };
            return i2 = {
                next: u3(0),
                throw: u3(1),
                return: u3(2)
            }, "function" == typeof Symbol && (i2[Symbol.iterator] = function() {
                return this;
            }), i2;
            function u3(i3) {
                return function(u4) {
                    return function(i4) {
                        if (r3) throw new TypeError("Generator is already executing.");
                        for(; s3;)try {
                            if (r3 = 1, n3 && (o3 = 2 & i4[0] ? n3.return : i4[0] ? n3.throw || ((o3 = n3.return) && o3.call(n3), 0) : n3.next) && !(o3 = o3.call(n3, i4[1])).done) return o3;
                            switch(n3 = 0, o3 && (i4 = [
                                2 & i4[0],
                                o3.value
                            ]), i4[0]){
                                case 0:
                                case 1:
                                    o3 = i4;
                                    break;
                                case 4:
                                    return s3.label++, {
                                        value: i4[1],
                                        done: false
                                    };
                                case 5:
                                    s3.label++, n3 = i4[1], i4 = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    i4 = s3.ops.pop(), s3.trys.pop();
                                    continue;
                                default:
                                    if (!(o3 = s3.trys, (o3 = o3.length > 0 && o3[o3.length - 1]) || 6 !== i4[0] && 2 !== i4[0])) {
                                        s3 = 0;
                                        continue;
                                    }
                                    if (3 === i4[0] && (!o3 || i4[1] > o3[0] && i4[1] < o3[3])) {
                                        s3.label = i4[1];
                                        break;
                                    }
                                    if (6 === i4[0] && s3.label < o3[1]) {
                                        s3.label = o3[1], o3 = i4;
                                        break;
                                    }
                                    if (o3 && s3.label < o3[2]) {
                                        s3.label = o3[2], s3.ops.push(i4);
                                        break;
                                    }
                                    o3[2] && s3.ops.pop(), s3.trys.pop();
                                    continue;
                            }
                            i4 = t3.call(e3, s3);
                        } catch (e4) {
                            i4 = [
                                6,
                                e4
                            ], n3 = 0;
                        } finally{
                            r3 = o3 = 0;
                        }
                        if (5 & i4[0]) throw i4[1];
                        return {
                            value: i4[0] ? i4[1] : void 0,
                            done: true
                        };
                    }([
                        i3,
                        u4
                    ]);
                };
            }
        }, i = this && this.__read || function(e3, t3) {
            var r3 = "function" == typeof Symbol && e3[Symbol.iterator];
            if (!r3) return e3;
            var n3, o3, i2 = r3.call(e3), s3 = [];
            try {
                for(; (void 0 === t3 || t3-- > 0) && !(n3 = i2.next()).done;)s3.push(n3.value);
            } catch (e4) {
                o3 = {
                    error: e4
                };
            } finally{
                try {
                    n3 && !n3.done && (r3 = i2.return) && r3.call(i2);
                } finally{
                    if (o3) throw o3.error;
                }
            }
            return s3;
        };
        Object.defineProperty(t2, "__esModule", {
            value: true
        }), t2.AuthActions = void 0;
        var s2 = r2(3), u2 = r2(0), a2 = r2(4);
        var c2 = function() {
            function e3(e4) {
                var t3 = e4.providers, r3 = e4.api, n3 = e4.cookieName, o3 = e4.tryGetCookie, i2 = e4.setCookie, u3 = e4.resetCookie, a3 = e4.getUserData, c3 = e4.refreshToken;
                if (!r3 || !r3.get) throw "No means to get auth token for auth code";
                if (this.api = {
                    get: r3.get,
                    post: r3.post
                }, this.providers = t3, this.getUserData = a3, i2) this.setCookie = i2;
                else {
                    if (!n3) throw "No means to set cookie";
                    this.setCookie = function(e5) {
                        var t4 = 3 * Math.min(1, (e5.expiresAt - Date.now()) / 864e5);
                        s2.set(n3, e5, {
                            expires: t4
                        });
                    };
                }
                if (u3) this.resetCookie = u3;
                else {
                    if (!n3) throw "No means to reset cookie";
                    this.resetCookie = function() {
                        return s2.remove(n3);
                    };
                }
                if (o3) this.tryGetCookie = o3;
                else {
                    if (!n3) throw "No means to get cookie";
                    this.tryGetCookie = function() {
                        return s2.getJSON(n3);
                    };
                }
                if (this.getUserData = a3 || function() {
                    return r3.get("/user/current");
                }, !c3) throw "No means to refresh token";
                this.refreshToken = c3;
            }
            return e3.prototype.requestAuth = function(e4, t3, r3) {
                return void 0 === t3 && (t3 = false), void 0 === r3 && (r3 = false), n2(this, void 0, void 0, function() {
                    var n3, s3, c3;
                    return o2(this, function(o3) {
                        switch(o3.label){
                            case 0:
                                return o3.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]), [
                                    4,
                                    a2.default.openWindow(e4.url(t3 ? "-" : void 0, r3), e4.width, e4.height, e4.redirectUrl, void 0 === e4.isRejectByCloseWindow || e4.isRejectByCloseWindow)
                                ];
                            case 1:
                                if ((n3 = o3.sent()).indexOf("code") >= 0) return [
                                    2,
                                    this.doAuthWithCode(e4, n3)
                                ];
                                if (n3.indexOf("accessToken") >= 0) return s3 = n3.slice(1).split("&").reduce(function(e5, t4) {
                                    var r4 = i(t4.split("="), 2), n4 = r4[0], o4 = r4[1];
                                    return e5[n4] = o4, e5;
                                }, {}), this.setCookie(s3), [
                                    2,
                                    this.getUserData()
                                ];
                                if (this.tryGetCookie()) return [
                                    2,
                                    this.getUserData()
                                ];
                                throw new u2.AuthRejection("response contained neither code nor cookie", u2.AuthOperationType.GET_TOKEN, u2.AuthFailureLevel.EXPECTED);
                            case 2:
                                if ((c3 = o3.sent()) === a2.POPUP_BLOCKED_ERROR) return this.authWithRedirect(e4), [
                                    2,
                                    null
                                ];
                                throw new u2.AuthRejection(c3, u2.AuthOperationType.GET_TOKEN, u2.AuthFailureLevel.EXPECTED);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, e3.prototype.tryInstantAuth = function() {
                return n2(this, void 0, void 0, function() {
                    var e4, t3, r3, n3, i2, s3, a3, c3, h2;
                    return o2(this, function(o3) {
                        switch(o3.label){
                            case 0:
                                if (l2 = location.search, d2 = l2.replace(/^\?/, "").split("&").map(function(e5) {
                                    return e5.split("=");
                                }), e4 = d2 && d2.length ? {
                                    code: d2.find(function(e5) {
                                        return "code" === e5[0];
                                    }),
                                    state: d2.find(function(e5) {
                                        return "state" === e5[0];
                                    }),
                                    provCode: d2.find(function(e5) {
                                        return "prov" === e5[0];
                                    }),
                                    error: d2.find(function(e5) {
                                        return "prov" === e5[0];
                                    })
                                } : {}, t3 = e4.code, r3 = e4.state, i2 = e4.error, s3 = (n3 = e4.provCode) ? this.providers.find(function(e5) {
                                    return e5.code === n3[1];
                                }) : null, !(t3 && r3 && s3 && n3)) return [
                                    3,
                                    8
                                ];
                                if (h2 = function(e5, t4, r4) {
                                    return location.toString().replace(e5.join("="), "").replace(t4.join("="), "").replace(r4.join("="), "").replace(/&&+/, "&").replace(/\?&$/, "").replace(/\?&/, "?");
                                }(t3, r3, n3), !(history && history.replaceState)) return [
                                    3,
                                    5
                                ];
                                o3.label = 1;
                            case 1:
                                return o3.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), history.replaceState(null, history.state && history.state.title, h2), [
                                    4,
                                    this.doAuthWithCode(s3, "?" + t3.join("=") + "&" + r3.join("="))
                                ];
                            case 2:
                                return [
                                    2,
                                    o3.sent()
                                ];
                            case 3:
                                return a3 = o3.sent(), console.log(a3), [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    this.doAuthWithCode(s3, "?" + t3.join("=") + "&" + r3.join("="))
                                ];
                            case 6:
                                return c3 = o3.sent(), location.assign(h2), [
                                    2,
                                    c3
                                ];
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                if (i2 && r3 && n3) throw h2 = location.toString().replace(location.search, ""), history.replaceState(null, history.state.title, h2), new u2.AuthRejection(i2, u2.AuthOperationType.GET_TOKEN, u2.AuthFailureLevel.SEVERE);
                                o3.label = 9;
                            case 9:
                                throw new u2.AuthRejection(i2, u2.AuthOperationType.GET_TOKEN, u2.AuthFailureLevel.MINOR);
                        }
                        var l2, d2;
                    });
                });
            }, e3.prototype.tryRestoreAuth = function() {
                return n2(this, void 0, void 0, function() {
                    return o2(this, function(e4) {
                        switch(e4.label){
                            case 0:
                                return null == this.tryGetCookie() ? [
                                    3,
                                    2
                                ] : [
                                    4,
                                    this.loadUserData()
                                ];
                            case 1:
                                return [
                                    2,
                                    e4.sent()
                                ];
                            case 2:
                                throw new u2.AuthRejection("No auth token", u2.AuthOperationType.GET_USER_DATA, u2.AuthFailureLevel.MINOR);
                        }
                    });
                });
            }, e3.prototype.authWithRedirect = function(e4) {
                var t3 = location.toString();
                if (window.top && window.top !== window) {
                    var r3 = e4.url({
                        topUrl: window.top.location.toString(),
                        videoUrl: t3
                    });
                    window.top.location.assign(r3);
                } else {
                    r3 = e4.url(t3);
                    location.assign(r3);
                }
            }, e3.prototype.restoreSession = function() {
                return n2(this, void 0, void 0, function() {
                    var e4, t3, r3;
                    return o2(this, function(n3) {
                        switch(n3.label){
                            case 0:
                                if (null == (e4 = this.tryGetCookie())) return [
                                    3,
                                    6
                                ];
                                n3.label = 1;
                            case 1:
                                return n3.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]), [
                                    4,
                                    this.refreshToken(e4.refreshToken)
                                ];
                            case 2:
                                return t3 = n3.sent(), [
                                    4,
                                    this.onTokenReceive(t3)
                                ];
                            case 3:
                                return [
                                    2,
                                    n3.sent()
                                ];
                            case 4:
                                return r3 = n3.sent(), this.onTokenRejected(r3, u2.AuthOperationType.REFRESH_TOKEN), [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw new u2.AuthRejection("No auth token", u2.AuthOperationType.GET_USER_DATA, u2.AuthFailureLevel.EXPECTED);
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, e3.prototype.doAuthWithCode = function(e4, t3) {
                return n2(this, void 0, void 0, function() {
                    var r3;
                    return o2(this, function(n3) {
                        switch(n3.label){
                            case 0:
                                return [
                                    4,
                                    this.api.get("" + e4.apiUrl + t3 + "&redirect_uri=" + e4.redirectUrl)
                                ];
                            case 1:
                                if ((r3 = n3.sent()).error || r3.error_description) throw new u2.AuthRejection(r3.error || r3.error_description, u2.AuthOperationType.GET_USER_DATA, u2.AuthFailureLevel.SEVERE);
                                return e4.isIgnoreTokens ? [
                                    4,
                                    this.loadUserData()
                                ] : [
                                    3,
                                    3
                                ];
                            case 2:
                                return [
                                    2,
                                    n3.sent()
                                ];
                            case 3:
                                return [
                                    4,
                                    this.onTokenReceive(r3)
                                ];
                            case 4:
                                return [
                                    2,
                                    n3.sent()
                                ];
                        }
                    });
                });
            }, e3.prototype.authorizeByPhone = function(e4) {
                return n2(this, void 0, void 0, function() {
                    return o2(this, function(t3) {
                        return [
                            2,
                            this.api.post("/oauth/phone/authorize", e4)
                        ];
                    });
                });
            }, e3.prototype.checkApp = function(e4) {
                return n2(this, void 0, void 0, function() {
                    return o2(this, function(t3) {
                        return [
                            2,
                            this.api.get("/oauth/server/check_app?client_id=" + e4.client_id + "&redirect_uri=" + e4.redirect_uri)
                        ];
                    });
                });
            }, e3.prototype.fetchTokenByPhone = function(e4) {
                return n2(this, void 0, void 0, function() {
                    var t3, r3;
                    return o2(this, function(n3) {
                        switch(n3.label){
                            case 0:
                                return n3.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]), [
                                    4,
                                    this.api.post("/oauth/phone/token", e4)
                                ];
                            case 1:
                                return [
                                    2,
                                    {
                                        accessToken: (t3 = n3.sent()).access_token,
                                        refreshToken: t3.refresh_token,
                                        expiresAt: Date.now() + 1e3 * t3.expires_in
                                    }
                                ];
                            case 2:
                                return r3 = n3.sent(), this.onTokenRejected(r3, u2.AuthOperationType.GET_TOKEN), [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, e3.prototype.authorizeByOAuth = function(e4) {
                return n2(this, void 0, void 0, function() {
                    return o2(this, function(t3) {
                        return [
                            2,
                            this.api.post("/oauth/server/authorize", e4)
                        ];
                    });
                });
            }, e3.prototype.loadUserData = function(e4) {
                return void 0 === e4 && (e4 = this.tryGetCookie()), n2(this, void 0, void 0, function() {
                    var t3;
                    return o2(this, function(r3) {
                        switch(r3.label){
                            case 0:
                                if (!e4) return [
                                    3,
                                    5
                                ];
                                r3.label = 1;
                            case 1:
                                return r3.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    this.getUserData()
                                ];
                            case 2:
                                return [
                                    2,
                                    r3.sent()
                                ];
                            case 3:
                                return t3 = r3.sent(), this.onTokenRejected(t3, u2.AuthOperationType.GET_USER_DATA), [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new u2.AuthRejection("No auth data", u2.AuthOperationType.GET_USER_DATA, u2.AuthFailureLevel.EXPECTED);
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, e3.prototype.onTokenReceive = function(e4) {
                return n2(this, void 0, void 0, function() {
                    return o2(this, function(t3) {
                        switch(t3.label){
                            case 0:
                                return this.setCookie({
                                    accessToken: e4.access_token,
                                    refreshToken: e4.refresh_token,
                                    expiresAt: Date.now() + 1e3 * e4.expires_in
                                }), [
                                    4,
                                    this.loadUserData()
                                ];
                            case 1:
                                return [
                                    2,
                                    t3.sent()
                                ];
                        }
                    });
                });
            }, e3.prototype.onTokenRejected = function(e4, t3) {
                throw this.resetCookie(), {
                    reason: e4,
                    operation: t3
                };
            }, e3;
        }();
        t2.AuthActions = c2;
    },
    function(e2, t2, r2) {
        var n2, o2;
        /*!
   * JavaScript Cookie v2.2.1
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   */ !function(i) {
            void 0 === (o2 = "function" == typeof (n2 = i) ? n2.call(t2, r2, t2, e2) : n2) || (e2.exports = o2), e2.exports = i();
        }(function() {
            function e3() {
                for(var e4 = 0, t4 = {}; e4 < arguments.length; e4++){
                    var r3 = arguments[e4];
                    for(var n3 in r3)t4[n3] = r3[n3];
                }
                return t4;
            }
            function t3(e4) {
                return e4.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
            }
            return function r3(n3) {
                function o3() {}
                function i(t4, r4, i2) {
                    if ("undefined" != typeof document) {
                        "number" == typeof (i2 = e3({
                            path: "/"
                        }, o3.defaults, i2)).expires && (i2.expires = new Date(1 * /* @__PURE__ */ new Date() + 864e5 * i2.expires)), i2.expires = i2.expires ? i2.expires.toUTCString() : "";
                        try {
                            var s3 = JSON.stringify(r4);
                            /^[\{\[]/.test(s3) && (r4 = s3);
                        } catch (e4) {}
                        r4 = n3.write ? n3.write(r4, t4) : encodeURIComponent(String(r4)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t4 = encodeURIComponent(String(t4)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                        var u2 = "";
                        for(var a2 in i2)i2[a2] && (u2 += "; " + a2, true !== i2[a2] && (u2 += "=" + i2[a2].split(";")[0]));
                        return document.cookie = t4 + "=" + r4 + u2;
                    }
                }
                function s2(e4, r4) {
                    if ("undefined" != typeof document) {
                        for(var o4 = {}, i2 = document.cookie ? document.cookie.split("; ") : [], s3 = 0; s3 < i2.length; s3++){
                            var u2 = i2[s3].split("="), a2 = u2.slice(1).join("=");
                            r4 || '"' !== a2.charAt(0) || (a2 = a2.slice(1, -1));
                            try {
                                var c2 = t3(u2[0]);
                                if (a2 = (n3.read || n3)(a2, c2) || t3(a2), r4) try {
                                    a2 = JSON.parse(a2);
                                } catch (e5) {}
                                if (o4[c2] = a2, e4 === c2) break;
                            } catch (e5) {}
                        }
                        return e4 ? o4[e4] : o4;
                    }
                }
                return o3.set = i, o3.get = function(e4) {
                    return s2(e4, false);
                }, o3.getJSON = function(e4) {
                    return s2(e4, true);
                }, o3.remove = function(t4, r4) {
                    i(t4, "", e3(r4, {
                        expires: -1
                    }));
                }, o3.defaults = {}, o3.withConverter = r3, o3;
            }(function() {});
        });
    },
    function(e2, t2, r2) {
        var n2;
        Object.defineProperty(t2, "__esModule", {
            value: true
        }), t2.POPUP_PREMATURE_CLOSED_ERROR = t2.POPUP_BLOCKED_ERROR = void 0, t2.POPUP_BLOCKED_ERROR = "Popups blocked", t2.POPUP_PREMATURE_CLOSED_ERROR = "Login window was closed by the user or authentication was incomplete and never reached final redirect page.";
        var o2 = {
            openWindow: function(e3, r3, o3, i, s2) {
                void 0 === r3 && (r3 = 600), void 0 === o3 && (o3 = 500), n2 && n2.close();
                var u2 = {
                    width: r3,
                    height: o3,
                    left: Math.floor(screen.width / 2 - r3 / 2) + (screen.availLeft || 0),
                    top: Math.floor(screen.height / 2 - o3 / 2)
                }, a2 = Object.keys(u2).map(function(e4) {
                    return e4 + "=" + u2[e4];
                }).join(",");
                return n2 = window.open(e3, "Authorisation", a2), new Promise(function(e4, r4) {
                    n2 || r4(t2.POPUP_BLOCKED_ERROR);
                    var o4 = function(n3, a3) {
                        if (n3.closed) return s2 && r4(new Error(t2.POPUP_PREMATURE_CLOSED_ERROR)), void window.removeEventListener("message", u3);
                        try {
                            if (null != i && n3.location.href.indexOf(i) >= 0 || n3.location.host === window.location.host && "complete" === n3.document.readyState) return void (a3 ? (e4(n3.location.search), n3.close(), window.removeEventListener("message", u3)) : setTimeout(function() {
                                return o4(n3, true);
                            }, 1e3));
                        } catch (e5) {}
                        setTimeout(function() {
                            return o4(n3);
                        }, 100);
                    };
                    o4(n2);
                    var u3 = function(t3) {
                        var r5 = i.substring(0, i.indexOf("/", 9));
                        t3.origin === r5 && "AuthRedirectWindowOpened" === t3.data.name && (e4(t3.data.search || ""), n2.close(), window.removeEventListener("message", u3));
                    };
                    null != i && window.addEventListener("message", u3);
                });
            }
        };
        t2.default = o2;
    },
    function(e2, t2, r2) {
        Object.defineProperty(t2, "__esModule", {
            value: true
        }), t2.getProviderState = t2.OAuthProvider = t2.ProviderCodes = void 0, function(e3) {
            e3.FB = "FB", e3.OK = "OK", e3.VK = "VK", e3.MailRu = "mailru", e3.Google = "google", e3.Instagram = "instagram", e3.Youtube = "youtube", e3.Twitch = "twitch", e3.Discord = "discord", e3.DiscordBot = "discord_bot", e3.VKPlay = "vkplay";
        }(t2.ProviderCodes || (t2.ProviderCodes = {}));
        var n2 = function() {
            function e3(e4) {
                this.isRejectByCloseWindow = true, this.isIgnoreTokens = false, this.isAuthorizeEnabled = e4.isAuthorizeEnabled, this.state = e4.state, this.code = e4.code, this.appId = e4.appId, this.scope = e4.scope, this.redirectUrl = e4.redirectUrl, this.isRejectByCloseWindow = e4.isRejectByCloseWindow, this.isIgnoreTokens = e4.isIgnoreTokens, this.urlTemplate = e4.urlTemplate, this.apiUrl = e4.apiUrl, this.width = e4.width, this.height = e4.height;
            }
            return e3.prototype.url = function(e4, r3) {
                return this.urlTemplate(this.appId, this.scope, this.redirectUrl, t2.getProviderState(e4, this.code, this.state), r3);
            }, e3;
        }();
        t2.OAuthProvider = n2, t2.getProviderState = function(e3, t3, r3) {
            var n3 = "";
            if (e3 && "string" == typeof e3) n3 = "***" + e3 + "***" + t3;
            else if (e3 && null != e3.topUrl) {
                var o2 = e3;
                n3 = "***" + o2.videoUrl + "***" + t3 + "***" + o2.topUrl;
            }
            var i = encodeURIComponent(r3 + n3);
            return "VK" === t3 ? encodeURIComponent(i) : i;
        };
    }
]);
const codeToType = {
    [dist$3.ProviderCodes.VK]: "vk",
    [dist$3.ProviderCodes.OK]: "ok",
    [dist$3.ProviderCodes.FB]: "fb",
    [dist$3.ProviderCodes.MailRu]: "mr",
    [dist$3.ProviderCodes.Instagram]: "instagram",
    [dist$3.ProviderCodes.Google]: "google",
    [dist$3.ProviderCodes.Youtube]: "youtube",
    [dist$3.ProviderCodes.Twitch]: "twitch",
    [dist$3.ProviderCodes.Discord]: "discord",
    [dist$3.ProviderCodes.DiscordBot]: "discord_bot",
    [dist$3.ProviderCodes.VKPlay]: "vkplay"
};
const getProviderCodeBySourceType = (type)=>{
    return (Object.entries(codeToType).find((entry)=>entry[1] === type) || [])[0];
};
const getEmbedLink = (pageUrl)=>`<iframe src="${pageUrl}" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>`;
const getVkShareLink = (pageUrl)=>`https://vk.com/share.php?url=${encodeURI(pageUrl)}`;
const getOkShareLink = (pageUrl)=>`https://connect.ok.ru/offer?url=${encodeURI(pageUrl)}`;
const getFbShareLink = (pageUrl)=>`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(pageUrl)}`;
const getTwitterLink = (pageUrl)=>`https://twitter.com/share?url=${encodeURI(pageUrl)}`;
EShareTarget.EMBED, EShareTarget.VK, EShareTarget.FB, EShareTarget.OK, EShareTarget.TWITTER;
const _TemporaryStorage = class _TemporaryStorage {
    static get size() {
        return Object.keys(this.store).length;
    }
    static getItem(key) {
        if (this.store[key]) return JSON.parse(this.store[key]);
        return null;
    }
    static setItem(key, value2) {
        this.store[key] = JSON.stringify(value2);
    }
    static removeItem(key) {
        delete this.store[key];
    }
    static clear() {
        this.store = {};
    }
};
_TemporaryStorage.store = {};
let TemporaryStorage = _TemporaryStorage;
const testAttr = (testId, testValue)=>({
        ...testId ? {
            ["data-test-id"]: testId
        } : {}
    });
function isCommentInThread(comment) {
    return Boolean(comment.parentId);
}
function isPublishedComment(publishingComment) {
    return publishingComment.status === EPublishCommentStatus.SUCCESS;
}
const findCommentBy = (post, publishingCommentsList, predicateIsTruthyFor)=>{
    var _a3, _b2;
    if (post) {
        for (const comment of (_a3 = post == null ? void 0 : post.comments) == null ? void 0 : _a3.data){
            if (predicateIsTruthyFor(comment)) return comment;
            const { replies } = comment;
            if (replies == null ? void 0 : replies.data) for (const reply of replies == null ? void 0 : replies.data){
                if (predicateIsTruthyFor(reply)) return reply;
            }
        }
        if ((_b2 = publishingCommentsList == null ? void 0 : publishingCommentsList.post) == null ? void 0 : _b2[post.id]) for (const comment of publishingCommentsList.post[post.id]){
            if (isPublishedComment(comment) && predicateIsTruthyFor(comment.publishedComment)) return comment.publishedComment;
        }
        if (publishingCommentsList == null ? void 0 : publishingCommentsList.thread) {
            const threadComments = Object.values(publishingCommentsList.thread).flat();
            for (const threadComment of threadComments){
                if (isPublishedComment(threadComment) && predicateIsTruthyFor(threadComment.publishedComment)) return threadComment.publishedComment;
            }
        }
    }
    return void 0;
};
var ESendingGiftError = /* @__PURE__ */ ((ESendingGiftError2)=>{
    ESendingGiftError2["NOT_FOUND"] = "not_found";
    ESendingGiftError2["ALREADY_EXISTS"] = "already_exists";
    ESendingGiftError2["SELF_SUBSCRIBER"] = "self_subscriber";
    ESendingGiftError2["SELF_DONATER"] = "self_donater";
    ESendingGiftError2["USER_BANNED"] = "user_baned";
    return ESendingGiftError2;
})(ESendingGiftError || {});
const locales$1S = {
    default: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u043F\u043E\u0434\u0430\u0440\u043A\u0430",
    notFound: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442",
    selfSubscriber: "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u043E\u0434\u0430\u0440\u0438\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 \u043A\u0430\u043D\u0430\u043B\u0430",
    selfDonater: "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u043E\u0434\u0430\u0440\u0438\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u0441\u0435\u0431\u0435",
    userBanned: "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u043E\u0434\u0430\u0440\u0438\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u0437\u0430\u0431\u0430\u043D\u0435\u043D\u043D\u043E\u043C\u0443 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E",
    alreadyExists: "\u0423 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430"
};
const t$1U = distExports$1.getTranslation && locales$1S;
const getErrorText = (error2)=>{
    switch(error2){
        case ESendingGiftError.NOT_FOUND:
            return t$1U.notFound;
        case ESendingGiftError.ALREADY_EXISTS:
            return t$1U.alreadyExists;
        case ESendingGiftError.SELF_SUBSCRIBER:
            return t$1U.selfSubscriber;
        case ESendingGiftError.SELF_DONATER:
            return t$1U.selfDonater;
        case ESendingGiftError.USER_BANNED:
            return t$1U.userBanned;
        default:
            return t$1U.default;
    }
};
const handleSendGiftError = (error2, showAlert)=>{
    showAlert({
        type: EAlertType.ERROR,
        text: getErrorText(error2)
    });
};
const concatWithDuplicatesPrevented = (array1, array2, idKey)=>{
    const res = [
        ...array1
    ];
    array2.forEach((item2)=>{
        if (!res.find((srcItem)=>srcItem[idKey] === item2[idKey])) res.push(item2);
    });
    return res;
};
function n(n2) {
    for(var r2 = arguments.length, t2 = Array(r2 > 1 ? r2 - 1 : 0), e2 = 1; e2 < r2; e2++)t2[e2 - 1] = arguments[e2];
    var i, o2;
    throw Error("[Immer] minified error nr: " + n2 + (t2.length ? " " + t2.map(function(n3) {
        return "'" + n3 + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n2) {
    return !!n2 && !!n2[Q];
}
function t$1T(n2) {
    return !!n2 && (function(n3) {
        if (!n3 || "object" != typeof n3) return false;
        var r2 = Object.getPrototypeOf(n3);
        if (null === r2) return true;
        var t2 = Object.hasOwnProperty.call(r2, "constructor") && r2.constructor;
        return t2 === Object || "function" == typeof t2 && Function.toString.call(t2) === Z$1;
    }(n2) || Array.isArray(n2) || !!n2[L$1] || !!n2.constructor[L$1] || s$3A(n2) || v(n2));
}
function i$4(n2, r2, t2) {
    void 0 === t2 && (t2 = false), 0 === o(n2) ? (t2 ? Object.keys : nn)(n2).forEach(function(e2) {
        t2 && "symbol" == typeof e2 || r2(e2, n2[e2], n2);
    }) : n2.forEach(function(t3, e2) {
        return r2(e2, t3, n2);
    });
}
function o(n2) {
    var r2 = n2[Q];
    return r2 ? r2.i > 3 ? r2.i - 4 : r2.i : Array.isArray(n2) ? 1 : s$3A(n2) ? 2 : v(n2) ? 3 : 0;
}
function u$1(n2, r2) {
    return 2 === o(n2) ? n2.has(r2) : Object.prototype.hasOwnProperty.call(n2, r2);
}
function a$1(n2, r2) {
    return 2 === o(n2) ? n2.get(r2) : n2[r2];
}
function f$1(n2, r2, t2) {
    var e2 = o(n2);
    2 === e2 ? n2.set(r2, t2) : 3 === e2 ? (n2.delete(r2), n2.add(t2)) : n2[r2] = t2;
}
function c(n2, r2) {
    return n2 === r2 ? 0 !== n2 || 1 / n2 == 1 / r2 : n2 != n2 && r2 != r2;
}
function s$3A(n2) {
    return X && n2 instanceof Map;
}
function v(n2) {
    return q && n2 instanceof Set;
}
function p(n2) {
    return n2.o || n2.t;
}
function l$1(n2) {
    if (Array.isArray(n2)) return Array.prototype.slice.call(n2);
    var r2 = rn(n2);
    delete r2[Q];
    for(var t2 = nn(r2), e2 = 0; e2 < t2.length; e2++){
        var i = t2[e2], o2 = r2[i];
        false === o2.writable && (o2.writable = true, o2.configurable = true), (o2.get || o2.set) && (r2[i] = {
            configurable: true,
            writable: true,
            enumerable: o2.enumerable,
            value: n2[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n2), r2);
}
function d(n2, e2) {
    return void 0 === e2 && (e2 = false), y(n2) || r(n2) || !t$1T(n2) ? n2 : (o(n2) > 1 && (n2.set = n2.add = n2.clear = n2.delete = h), Object.freeze(n2), e2 && i$4(n2, function(n3, r2) {
        return d(r2, true);
    }, true), n2);
}
function h() {
    n(2);
}
function y(n2) {
    return null == n2 || "object" != typeof n2 || Object.isFrozen(n2);
}
function b(r2) {
    var t2 = tn[r2];
    return t2 || n(18, r2), t2;
}
function _() {
    return U$1;
}
function j(n2, r2) {
    r2 && (b("Patches"), n2.u = [], n2.s = [], n2.v = r2);
}
function O(n2) {
    g(n2), n2.p.forEach(S), n2.p = null;
}
function g(n2) {
    n2 === U$1 && (U$1 = n2.l);
}
function w(n2) {
    return U$1 = {
        p: [],
        l: U$1,
        h: n2,
        m: true,
        _: 0
    };
}
function S(n2) {
    var r2 = n2[Q];
    0 === r2.i || 1 === r2.i ? r2.j() : r2.O = true;
}
function P(r2, e2) {
    e2._ = e2.p.length;
    var i = e2.p[0], o2 = void 0 !== r2 && r2 !== i;
    return e2.h.g || b("ES5").S(e2, r2, o2), o2 ? (i[Q].P && (O(e2), n(4)), t$1T(r2) && (r2 = M(e2, r2), e2.l || x(e2, r2)), e2.u && b("Patches").M(i[Q].t, r2, e2.u, e2.s)) : r2 = M(e2, i, []), O(e2), e2.u && e2.v(e2.u, e2.s), r2 !== H ? r2 : void 0;
}
function M(n2, r2, t2) {
    if (y(r2)) return r2;
    var e2 = r2[Q];
    if (!e2) return i$4(r2, function(i, o3) {
        return A$1(n2, e2, r2, i, o3, t2);
    }, true), r2;
    if (e2.A !== n2) return r2;
    if (!e2.P) return x(n2, e2.t, true), e2.t;
    if (!e2.I) {
        e2.I = true, e2.A._--;
        var o2 = 4 === e2.i || 5 === e2.i ? e2.o = l$1(e2.k) : e2.o;
        i$4(3 === e2.i ? new Set(o2) : o2, function(r3, i) {
            return A$1(n2, e2, o2, r3, i, t2);
        }), x(n2, o2, false), t2 && n2.u && b("Patches").R(e2, t2, n2.u, n2.s);
    }
    return e2.o;
}
function A$1(e2, i, o2, a2, c2, s2) {
    if (r(c2)) {
        var v2 = M(e2, c2, s2 && i && 3 !== i.i && !u$1(i.D, a2) ? s2.concat(a2) : void 0);
        if (f$1(o2, a2, v2), !r(v2)) return;
        e2.m = false;
    }
    if (t$1T(c2) && !y(c2)) {
        if (!e2.h.F && e2._ < 1) return;
        M(e2, c2), i && i.A.l || x(e2, c2);
    }
}
function x(n2, r2, t2) {
    void 0 === t2 && (t2 = false), n2.h.F && n2.m && d(r2, t2);
}
function z$1(n2, r2) {
    var t2 = n2[Q];
    return (t2 ? p(t2) : n2)[r2];
}
function I(n2, r2) {
    if (r2 in n2) for(var t2 = Object.getPrototypeOf(n2); t2;){
        var e2 = Object.getOwnPropertyDescriptor(t2, r2);
        if (e2) return e2;
        t2 = Object.getPrototypeOf(t2);
    }
}
function k(n2) {
    n2.P || (n2.P = true, n2.l && k(n2.l));
}
function E$1(n2) {
    n2.o || (n2.o = l$1(n2.t));
}
function R(n2, r2, t2) {
    var e2 = s$3A(r2) ? b("MapSet").N(r2, t2) : v(r2) ? b("MapSet").T(r2, t2) : n2.g ? function(n3, r3) {
        var t3 = Array.isArray(n3), e3 = {
            i: t3 ? 1 : 0,
            A: r3 ? r3.A : _(),
            P: false,
            I: false,
            D: {},
            l: r3,
            t: n3,
            k: null,
            o: null,
            j: null,
            C: false
        }, i = e3, o2 = en;
        t3 && (i = [
            e3
        ], o2 = on);
        var u2 = Proxy.revocable(i, o2), a2 = u2.revoke, f2 = u2.proxy;
        return e3.k = f2, e3.j = a2, f2;
    }(r2, t2) : b("ES5").J(r2, t2);
    return (t2 ? t2.A : _()).p.push(e2), e2;
}
function D(e2) {
    return r(e2) || n(22, e2), function n2(r2) {
        if (!t$1T(r2)) return r2;
        var e3, u2 = r2[Q], c2 = o(r2);
        if (u2) {
            if (!u2.P && (u2.i < 4 || !b("ES5").K(u2))) return u2.t;
            u2.I = true, e3 = F$1(r2, c2), u2.I = false;
        } else e3 = F$1(r2, c2);
        return i$4(e3, function(r3, t2) {
            u2 && a$1(u2.t, r3) === t2 || f$1(e3, r3, n2(t2));
        }), 3 === c2 ? new Set(e3) : e3;
    }(e2);
}
function F$1(n2, r2) {
    switch(r2){
        case 2:
            return new Map(n2);
        case 3:
            return Array.from(n2);
    }
    return l$1(n2);
}
var G, U$1, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = true, G), L$1 = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n2) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n2;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n2) {
        return "Cannot apply patch, path doesn't resolve: " + n2;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n2) {
        return "Unsupported patch operation: " + n2;
    },
    18: function(n2) {
        return "The plugin for '" + n2 + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n2 + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n2) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n2 + "'";
    },
    22: function(n2) {
        return "'current' expects a draft, got: " + n2;
    },
    23: function(n2) {
        return "'original' expects a draft, got: " + n2;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z$1 = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n2) {
    return Object.getOwnPropertyNames(n2).concat(Object.getOwnPropertySymbols(n2));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n2) {
    var r2 = {};
    return nn(n2).forEach(function(t2) {
        r2[t2] = Object.getOwnPropertyDescriptor(n2, t2);
    }), r2;
}, tn = {}, en = {
    get: function(n2, r2) {
        if (r2 === Q) return n2;
        var e2 = p(n2);
        if (!u$1(e2, r2)) return function(n3, r3, t2) {
            var e3, i2 = I(r3, t2);
            return i2 ? "value" in i2 ? i2.value : null === (e3 = i2.get) || void 0 === e3 ? void 0 : e3.call(n3.k) : void 0;
        }(n2, e2, r2);
        var i = e2[r2];
        return n2.I || !t$1T(i) ? i : i === z$1(n2.t, r2) ? (E$1(n2), n2.o[r2] = R(n2.A.h, i, n2)) : i;
    },
    has: function(n2, r2) {
        return r2 in p(n2);
    },
    ownKeys: function(n2) {
        return Reflect.ownKeys(p(n2));
    },
    set: function(n2, r2, t2) {
        var e2 = I(p(n2), r2);
        if (null == e2 ? void 0 : e2.set) return e2.set.call(n2.k, t2), true;
        if (!n2.P) {
            var i = z$1(p(n2), r2), o2 = null == i ? void 0 : i[Q];
            if (o2 && o2.t === t2) return n2.o[r2] = t2, n2.D[r2] = false, true;
            if (c(t2, i) && (void 0 !== t2 || u$1(n2.t, r2))) return true;
            E$1(n2), k(n2);
        }
        return n2.o[r2] === t2 && "number" != typeof t2 && (void 0 !== t2 || r2 in n2.o) || (n2.o[r2] = t2, n2.D[r2] = true, true);
    },
    deleteProperty: function(n2, r2) {
        return void 0 !== z$1(n2.t, r2) || r2 in n2.t ? (n2.D[r2] = false, E$1(n2), k(n2)) : delete n2.D[r2], n2.o && delete n2.o[r2], true;
    },
    getOwnPropertyDescriptor: function(n2, r2) {
        var t2 = p(n2), e2 = Reflect.getOwnPropertyDescriptor(t2, r2);
        return e2 ? {
            writable: true,
            configurable: 1 !== n2.i || "length" !== r2,
            enumerable: e2.enumerable,
            value: t2[r2]
        } : e2;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n2) {
        return Object.getPrototypeOf(n2.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i$4(en, function(n2, r2) {
    on[n2] = function() {
        return arguments[0] = arguments[0][0], r2.apply(this, arguments);
    };
}), on.deleteProperty = function(r2, t2) {
    return on.set.call(this, r2, t2, void 0);
}, on.set = function(r2, t2, e2) {
    return en.set.call(this, r2[0], t2, e2, r2[0]);
};
var un = function() {
    function e2(r2) {
        var e3 = this;
        this.g = B, this.F = true, this.produce = function(r3, i2, o2) {
            if ("function" == typeof r3 && "function" != typeof i2) {
                var u2 = i2;
                i2 = r3;
                var a2 = e3;
                return function(n2) {
                    var r4 = this;
                    void 0 === n2 && (n2 = u2);
                    for(var t2 = arguments.length, e4 = Array(t2 > 1 ? t2 - 1 : 0), o3 = 1; o3 < t2; o3++)e4[o3 - 1] = arguments[o3];
                    return a2.produce(n2, function(n3) {
                        var t3;
                        return (t3 = i2).call.apply(t3, [
                            r4,
                            n3
                        ].concat(e4));
                    });
                };
            }
            var f2;
            if ("function" != typeof i2 && n(6), void 0 !== o2 && "function" != typeof o2 && n(7), t$1T(r3)) {
                var c2 = w(e3), s2 = R(e3, r3, void 0), v2 = true;
                try {
                    f2 = i2(s2), v2 = false;
                } finally{
                    v2 ? O(c2) : g(c2);
                }
                return "undefined" != typeof Promise && f2 instanceof Promise ? f2.then(function(n2) {
                    return j(c2, o2), P(n2, c2);
                }, function(n2) {
                    throw O(c2), n2;
                }) : (j(c2, o2), P(f2, c2));
            }
            if (!r3 || "object" != typeof r3) {
                if (void 0 === (f2 = i2(r3)) && (f2 = r3), f2 === H && (f2 = void 0), e3.F && d(f2, true), o2) {
                    var p2 = [], l2 = [];
                    b("Patches").M(r3, f2, p2, l2), o2(p2, l2);
                }
                return f2;
            }
            n(21, r3);
        }, this.produceWithPatches = function(n2, r3) {
            if ("function" == typeof n2) return function(r4) {
                for(var t3 = arguments.length, i3 = Array(t3 > 1 ? t3 - 1 : 0), o3 = 1; o3 < t3; o3++)i3[o3 - 1] = arguments[o3];
                return e3.produceWithPatches(r4, function(r5) {
                    return n2.apply(void 0, [
                        r5
                    ].concat(i3));
                });
            };
            var t2, i2, o2 = e3.produce(n2, r3, function(n3, r4) {
                t2 = n3, i2 = r4;
            });
            return "undefined" != typeof Promise && o2 instanceof Promise ? o2.then(function(n3) {
                return [
                    n3,
                    t2,
                    i2
                ];
            }) : [
                o2,
                t2,
                i2
            ];
        }, "boolean" == typeof (null == r2 ? void 0 : r2.useProxies) && this.setUseProxies(r2.useProxies), "boolean" == typeof (null == r2 ? void 0 : r2.autoFreeze) && this.setAutoFreeze(r2.autoFreeze);
    }
    var i = e2.prototype;
    return i.createDraft = function(e3) {
        t$1T(e3) || n(8), r(e3) && (e3 = D(e3));
        var i2 = w(this), o2 = R(this, e3, void 0);
        return o2[Q].C = true, g(i2), o2;
    }, i.finishDraft = function(r2, t2) {
        var e3 = r2 && r2[Q];
        var i2 = e3.A;
        return j(i2, t2), P(void 0, i2);
    }, i.setAutoFreeze = function(n2) {
        this.F = n2;
    }, i.setUseProxies = function(r2) {
        r2 && !B && n(20), this.g = r2;
    }, i.applyPatches = function(n2, t2) {
        var e3;
        for(e3 = t2.length - 1; e3 >= 0; e3--){
            var i2 = t2[e3];
            if (0 === i2.path.length && "replace" === i2.op) {
                n2 = i2.value;
                break;
            }
        }
        e3 > -1 && (t2 = t2.slice(e3 + 1));
        var o2 = b("Patches").$;
        return r(n2) ? o2(n2, t2) : this.produce(n2, function(n3) {
            return o2(n3, t2);
        });
    }, e2;
}(), an = new un(), fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
function immerCase(actionCreator2, handler2) {
    return (reducer)=>reducer.case(actionCreator2, (state, payload)=>fn(state, (draft)=>handler2(draft, payload)));
}
const isValidNotificationType = (type)=>{
    return Boolean(Object.values(ENotificationStandaloneType).find((item2)=>item2 === type));
};
const getLangByLocale = (locale2)=>{
    return locale2.split("_")[0];
};
const deepCopy = (o2)=>JSON.parse(JSON.stringify(o2));
const getCurrentLanguage = ()=>{
    return getConfig().locale.split("_")[0];
};
const VIEWERS_LIST = [
    100,
    500,
    1e3,
    2e3,
    5e3,
    1e4,
    3e4,
    5e4
];
const getDelaysList = (maxDelay)=>{
    return [
        0,
        maxDelay * 0.05,
        maxDelay * 0.083,
        maxDelay * 0.167,
        maxDelay * 0.25,
        maxDelay * 0.333,
        maxDelay * 0.5,
        maxDelay
    ];
};
const getMaxDelay = (viewersCount, maxDelay)=>{
    const targetIndex = VIEWERS_LIST.findIndex((value2)=>value2 >= viewersCount);
    return targetIndex > -1 ? getDelaysList(maxDelay)[targetIndex] : maxDelay;
};
const getRequestWithViewersDelay = (viewersCount, maxDelay)=>{
    return getRandomInt$3(0, getMaxDelay(viewersCount, maxDelay));
};
const isObjectToQueryPropertyNotEmpty = (key, object2)=>{
    const value2 = object2[key];
    return Boolean(Array.isArray(value2) ? value2.length : value2);
};
const objectToQueryPropertyToParam = (key, object2)=>{
    const value2 = object2[key];
    return `${key}=${encodeURIComponent(Array.isArray(value2) ? value2.join(",") : String(value2))}`;
};
const objectToQueryString = (object2)=>{
    const queryParams = Object.keys(object2).filter((key)=>isObjectToQueryPropertyNotEmpty(key, object2)).map((key)=>objectToQueryPropertyToParam(key, object2)).join("&");
    return "?" + queryParams;
};
const prettyJson = (o2)=>JSON.stringify(o2, void 0, 2);
const getParametrizedUrl = (url, params, query, hash)=>{
    let resultUrl = url.replace(/\/\?$/, "");
    let isQueryExist = false;
    if (params) Object.keys(params).forEach((key)=>resultUrl = resultUrl.replace(new RegExp(`\\/:${key}\\?`, "g"), params[key] == null ? "" : `/:${key}`).replace(new RegExp(`:${key}`, "g"), String(params[key])));
    const [originUrl, queryInUrl] = resultUrl.split("?");
    resultUrl = originUrl;
    if (query && Object.keys(query).length) {
        resultUrl += objectToQueryString(query);
        isQueryExist = true;
    }
    if (queryInUrl) resultUrl += (isQueryExist ? "&" : "?") + queryInUrl;
    return resultUrl;
};
const getURIParams$3 = (params)=>{
    return Object.keys(params).reduce((prev, cur)=>{
        if (params[cur] == null) return prev;
        return `${prev}${prev ? "&" : ""}${cur}=${encodeURIComponent(String(params[cur]))}`;
    }, "");
};
const convertStyleToAttrString = (style)=>Object.entries(style || {}).map(([key, value2])=>`${key.replace(/[A-Z]/g, (match2)=>"-" + match2.toLowerCase())}:${value2};`).join("");
const locales$1R = {
    lastStream: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0442\u0440\u0438\u043C {{time}} \u043D\u0430\u0437\u0430\u0434",
    minutes1: "\u043C\u0438\u043D\u0443\u0442\u0443",
    minutes2: "\u043C\u0438\u043D\u0443\u0442\u044B",
    minutes5: "\u043C\u0438\u043D\u0443\u0442",
    hours1: "\u0447\u0430\u0441",
    hours2: "\u0447\u0430\u0441\u0430",
    hours5: "\u0447\u0430\u0441\u043E\u0432",
    days1: "\u0434\u0435\u043D\u044C",
    days2: "\u0434\u043D\u044F",
    days5: "\u0434\u043D\u0435\u0439",
    month1: "\u043C\u0435\u0441\u044F\u0446",
    month2: "\u043C\u0435\u0441\u044F\u0446\u0430",
    month5: "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
    year: "\u0431\u043E\u043B\u044C\u0448\u0435 \u0433\u043E\u0434\u0430",
    recently: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0442\u0440\u0438\u043C \u0431\u044B\u043B \u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E",
    notStreamed: "\u041D\u0435 \u0432\u044B\u0445\u043E\u0434\u0438\u043B \u0432 \u044D\u0444\u0438\u0440"
};
const t$1S = distExports$1.getTranslation && locales$1R;
const getTextWithParams = (value2, params, tDir)=>{
    return distExports$1.getParametrizedText(tDir.lastStream, {
        time: `${value2} ${declOfNum(params, value2)}`
    });
};
const getLastStreamText = (timestamp, tDir = t$1S)=>{
    if (timestamp) {
        const { years, months, days, hours, minutes } = getDiffBetweenDates(getUnixTime(timestamp), Date.now());
        switch(true){
            case Boolean(years):
                return distExports$1.getParametrizedText(tDir.lastStream, {
                    time: tDir.year
                });
            case Boolean(months):
                return getTextWithParams(months, [
                    tDir.month1,
                    tDir.month2,
                    tDir.month5
                ], t$1S);
            case Boolean(days):
                return getTextWithParams(days, [
                    tDir.days1,
                    tDir.days2,
                    tDir.days5
                ], t$1S);
            case Boolean(hours):
                return getTextWithParams(hours, [
                    tDir.hours1,
                    tDir.hours2,
                    tDir.hours5
                ], t$1S);
            case Boolean(minutes):
                return getTextWithParams(minutes, [
                    tDir.minutes1,
                    tDir.minutes2,
                    tDir.minutes5
                ], t$1S);
            default:
                return tDir.recently;
        }
    }
    return tDir.notStreamed;
};
const clearChatMessages = (messages2, ids)=>{
    return messages2.filter((message2)=>{
        if (!isChatUserMessage(message2)) return true;
        return !ids.some((item2)=>message2.id === item2.id);
    });
};
const debouncePromise = (fn2, ms = 0)=>{
    let timeoutId2;
    const pending = [];
    return (...args)=>new Promise((res, rej)=>{
            clearTimeout(timeoutId2);
            timeoutId2 = setTimeout(()=>{
                const currentPending = [
                    ...pending
                ];
                pending.length = 0;
                Promise.resolve(fn2(...args)).then((data)=>{
                    currentPending.forEach(({ resolve })=>resolve(data));
                }, (error2)=>{
                    currentPending.forEach(({ reject })=>reject(error2));
                });
            }, ms);
            pending.push({
                resolve: res,
                reject: rej
            });
        });
};
function isFirefoxBrowser() {
    return getConfig().browserFamily === EBrowserFamily.FIREFOX;
}
const charIsBreakspace = (char)=>{
    return (char == null ? void 0 : char.charCodeAt(0)) === 32 || (char == null ? void 0 : char.charCodeAt(0)) === 160;
};
const generateSpace = (dir, elem)=>{
    if (!elem) return "";
    if (elem.type === "text" && elem.content !== "") {
        const [content2] = JSON.parse(elem.content);
        const index2 = dir === "prev" ? content2.length - 1 : 0;
        return charIsBreakspace(content2[index2]) ? "" : " ";
    } else if (elem.type === "text") return isFirefoxBrowser() ? "&nbsp;" : " ";
    if (elem.type === "smile" || elem.type === "link" || elem.type === "mention") return " ";
    return "";
};
const locales$1Q = {
    hours: "{{hours}}\u0447.",
    minutes: "{{minutes}}\u043C."
};
const t$1R = distExports$1.getTranslation && locales$1Q;
const getDropsDurationText = (watchingDuration)=>{
    const seconds = watchingDuration % 60;
    const minutes = (watchingDuration - seconds) / 60 % 60;
    const hours = (watchingDuration - minutes * 60 - seconds) / 60 / 60;
    const hoursDuration = hours ? distExports$1.getParametrizedText(t$1R.hours, {
        hours: hours
    }) : "";
    const minutesDuration = minutes ? distExports$1.getParametrizedText(t$1R.minutes, {
        minutes: minutes
    }) : "";
    return [
        hoursDuration,
        minutesDuration
    ].join(" ");
};
const isMessageHasCurrentUserMention = (message2, currentUserId)=>{
    const parentMessage2 = message2.parent;
    const mention2 = message2.data.find(({ type })=>type === EMediaDataType.MENTION);
    const isCurrentUserMention = mention2 && mention2.id === currentUserId;
    const isCurrentUserMentioned = mention2 && message2.author.id === currentUserId;
    const hasParentMessage = Boolean(parentMessage2) && (message2.author.id === currentUserId || (parentMessage2 == null ? void 0 : parentMessage2.author.id) === currentUserId);
    return isCurrentUserMention || isCurrentUserMentioned || hasParentMessage;
};
const filterHeaderDuplicates = (headers)=>{
    const caseIndependentHeaderNames = Object.entries(headers).reduceRight((list2, [headerName])=>{
        list2[headerName.toLowerCase()] = headerName;
        return list2;
    }, {});
    return Object.entries(caseIndependentHeaderNames).reduceRight((list2, [ignore, headerName])=>{
        list2[headerName] = headers[headerName];
        return list2;
    }, {});
};
const locales$1P = {
    periods: {
        days: [
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u044F",
            "\u0434\u043D\u0435\u0439"
        ],
        hours: [
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430",
            "\u0447\u0430\u0441\u043E\u0432"
        ],
        minutes: [
            "\u043C\u0438\u043D\u0443\u0442\u0443",
            "\u043C\u0438\u043D\u0443\u0442\u044B",
            "\u043C\u0438\u043D\u0443\u0442"
        ],
        seconds: [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            "\u0441\u0435\u043A\u0443\u043D\u0434"
        ]
    }
};
const t$1Q = distExports$1.getTranslation && locales$1P;
const SECONDS_IN = {
    day: 86400,
    hour: 3600,
    minute: 60
};
const formatText = (period, variants, errorText2)=>{
    return Boolean(period) ? distExports$1.getParametrizedText(errorText2, {
        period: `${period} ${declOfNum(variants, period)}`
    }) : null;
};
const getPeriodText = (periodInSeconds, errorText2)=>{
    const { days, hours, minutes, seconds } = t$1Q.periods;
    if (periodInSeconds < SECONDS_IN.minute) return formatText(periodInSeconds, seconds, errorText2);
    if (periodInSeconds < SECONDS_IN.hour) return formatText(Math.round(periodInSeconds / SECONDS_IN.minute), minutes, errorText2);
    if (periodInSeconds <= SECONDS_IN.day) return formatText(Math.round(periodInSeconds / SECONDS_IN.hour), hours, errorText2);
    return formatText(Math.round(periodInSeconds / SECONDS_IN.day), days, errorText2);
};
var ENickNameErrors = /* @__PURE__ */ ((ENickNameErrors2)=>{
    ENickNameErrors2["EXIST"] = "already_exists";
    ENickNameErrors2["LIMITED"] = "limited";
    ENickNameErrors2["INVALID"] = "invalid_param";
    return ENickNameErrors2;
})(ENickNameErrors || {});
const locales$1O = {
    already_exists: '\u0418\u043C\u044F "{{nick}}" \u0437\u0430\u043D\u044F\u0442\u043E. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0432\u0435\u0441\u0442\u0438 \u0434\u0440\u0443\u0433\u043E\u0435.',
    invalid: "\u0412\u044B \u0432\u0432\u0435\u043B\u0438 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0435 \u0438\u043C\u044F",
    unknown: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u043C\u044F \u043D\u0430 "{{nick}}". \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0436\u0435.'
};
const t$1P = distExports$1.getTranslation && locales$1O;
const getNameChangeErrorText = (err, nick2, nameChangePeriodText)=>{
    const defaultText = distExports$1.getParametrizedText(t$1P.unknown, {
        nick: nick2
    });
    if (err instanceof ApiError) {
        const { error: error2 } = (err == null ? void 0 : err.serverError) ?? {};
        switch(error2){
            case ENickNameErrors.EXIST:
                return distExports$1.getParametrizedText(t$1P.already_exists, {
                    nick: nick2
                });
            case ENickNameErrors.LIMITED:
                return nameChangePeriodText || defaultText;
            case ENickNameErrors.INVALID:
                return t$1P.invalid;
            default:
                return defaultText;
        }
    }
    return defaultText;
};
let refFromQuery = "";
let refFromHeader = "";
let refType = "";
try {
    const { from: from2, from_type: fromType } = queryString.parseUrl(window.location.search).query;
    refFromQuery = window.sessionStorage.refFromQuery || from2 || "";
    refType = window.sessionStorage.refType || fromType || "";
} catch (err) {
    Log$5.error("Failed parse referer from query string: ", err);
}
try {
    if (window.sessionStorage.refFromHeader) refFromHeader = window.sessionStorage.refFromHeader;
    else if (document.referrer) {
        const matched = document.referrer.match(/(^https?:\/\/)?([^/]+)/);
        if (document.referrer.includes("android-app")) refFromHeader = document.referrer;
        else if (matched && matched[2]) refFromHeader = matched[2].split(".").slice(-2).join(".");
    }
} catch (err) {
    Log$5.error("Failed parse document.referrer: ", err);
}
try {
    window.sessionStorage.refFromQuery = refFromQuery;
    window.sessionStorage.refFromHeader = refFromHeader;
    window.sessionStorage.refType = refType;
} catch (err) {
    Log$5.error("Failed write referer to sessionStorage: ", err);
}
const getReferer = ()=>{
    let referer2 = "";
    try {
        try {
            referer2 = window.sessionStorage.refFromQuery || window.sessionStorage.refFromHeader;
        } catch (err) {
            Log$5.error("Failed read referer from sessionStorage: ", err);
        }
    } catch (ignore) {}
    return refFromQuery || refFromHeader || referer2;
};
const getRefererType = ()=>{
    return refType || "";
};
class BaseApi {
    constructor(api2){
        this.api = api2;
    }
    getContext() {
        return this.api.getContext();
    }
    async http(params) {
        var _a3, _b2, _c2;
        const transport = this.api.getTransport();
        const isAbsoluteUrl = /^https?/.test(params.url);
        const isOauthUrl = /^\/?oauth.*/.test(params.url);
        const isInternalApi = /^\/?int\/self.*/.test(params.url);
        const isAntiDdosUrl = /^\/\*\/check$/.test(params.url);
        const data = params.data && !params.isNoProcessData ? getURIParams$3(params.data) : params.data || null;
        if (!isAbsoluteUrl && !isOauthUrl && !isInternalApi && !isAntiDdosUrl) params.url = `${params.withoutVersion ? "" : "/v1"}${params.url}`;
        try {
            return await transport.http({
                ...params,
                data: data
            });
        } catch (err) {
            const error2 = new ApiError({
                ...err,
                status: (_a3 = err.response) == null ? void 0 : _a3.status,
                statusText: (_b2 = err.response) == null ? void 0 : _b2.statusText,
                serverError: (_c2 = err.response) == null ? void 0 : _c2.data,
                request: {
                    url: params.url,
                    method: params.method,
                    data: data
                }
            });
            const { status, request: { url } } = error2;
            const isGraphiteStat = url.includes(API_URL.STAT_GRAPHITE.split("/:").shift());
            if (status >= 400 && status <= 526 && !isGraphiteStat) try {
                await sendToGraphite(`api_error_${status}`);
            } catch (errGraphite) {
                Log$5.error(`Failed send to graphite: `, err);
            }
            Log$5.errorRequest(error2);
            throw error2;
        }
    }
    async get(params) {
        params.method = "GET";
        return this.http(params);
    }
    async post(params) {
        params.method = "POST";
        return this.http(params);
    }
    async put(params) {
        params.method = "PUT";
        return this.http(params);
    }
    async delete(params) {
        params.method = "DELETE";
        params.headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
        return this.http(params);
    }
}
class AgentsApi extends BaseApi {
    async assignAgent(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.BLOG_AGENT_ASSIGN,
            url: getParametrizedUrl(API_URL.BLOG_AGENT_ASSIGN, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async unassignAgent(blogUrl, userId) {
        return this.delete({
            apiUrl: API_URL.BLOG_AGENT_UNASSIGN,
            url: getParametrizedUrl(API_URL.BLOG_AGENT_UNASSIGN, {
                userId: userId,
                blogUrl: blogUrl
            })
        });
    }
    async fetchAgents(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.BLOG_AGENT_LIST,
            url: getParametrizedUrl(API_URL.BLOG_AGENT_LIST, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
}
class AnalyticsApi extends BaseApi {
    async fetchChannelAnalytics(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ANALYTICS,
            url: getParametrizedUrl(API_URL.CHANNEL_ANALYTICS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchStreamAnalytics(blogUrl, streamId) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ANALYTICS_STREAM,
            url: getParametrizedUrl(API_URL.CHANNEL_ANALYTICS_STREAM, {
                blogUrl: blogUrl,
                streamId: streamId
            })
        });
    }
    async fetchStreams(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ANALYTICS_STREAMS_LIST,
            url: getParametrizedUrl(API_URL.CHANNEL_ANALYTICS_STREAMS_LIST, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
}
class AntiDDoSApi extends BaseApi {
    async fetchInfo(params) {
        return this.post({
            apiUrl: ANTI_DDOS_API.VERIFICATION,
            url: ANTI_DDOS_API.VERIFICATION,
            data: params
        });
    }
}
class AuthByEmailApi extends BaseApi {
    async signUp(params) {
        return this.post({
            apiUrl: API_URL.AUTH_BY_EMAIL_SIGN_UP,
            url: API_URL.AUTH_BY_EMAIL_SIGN_UP,
            data: params
        });
    }
    async signIn(params) {
        return this.post({
            apiUrl: API_URL.AUTH_BY_EMAIL_SIGN_IN,
            url: API_URL.AUTH_BY_EMAIL_SIGN_IN,
            data: params
        });
    }
    async changePassword(params) {
        return this.put({
            apiUrl: API_URL.AUTH_BY_EMAIL_CHANGE_PASSWORD,
            url: getParametrizedUrl(API_URL.AUTH_BY_EMAIL_CHANGE_PASSWORD),
            data: params
        });
    }
    async changePasswordWithCode(params) {
        return this.put({
            apiUrl: API_URL.AUTH_BY_EMAIL_CHANGE_PASSWORD_WITH_CODE,
            url: getParametrizedUrl(API_URL.AUTH_BY_EMAIL_CHANGE_PASSWORD_WITH_CODE),
            data: params
        });
    }
    async sendLinkForChangePassword(params) {
        return this.post({
            apiUrl: API_URL.AUTH_BY_EMAIL_SEND_LINK_FOR_CHANGE_PASSWORD,
            url: API_URL.AUTH_BY_EMAIL_SEND_LINK_FOR_CHANGE_PASSWORD,
            data: params
        });
    }
}
class BadgeApi extends BaseApi {
    async fetchList(blogUrl) {
        return this.get({
            apiUrl: API_URL.BADGE_LIST,
            url: getParametrizedUrl(API_URL.BADGE_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async update(blogUrl, badgeId, params) {
        return this.put({
            apiUrl: API_URL.BADGE,
            url: getParametrizedUrl(API_URL.BADGE, {
                blogUrl: blogUrl,
                badgeId: badgeId
            }),
            data: params
        });
    }
    async uploadBadgeImage(blogUrl, sizeName, file) {
        return this.put({
            apiUrl: API_URL.BADGE_IMAGE,
            url: getParametrizedUrl(API_URL.BADGE_IMAGE, {
                blogUrl: blogUrl,
                sizeName: sizeName
            }),
            data: file,
            isNoProcessData: true
        });
    }
    async create(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.BADGE_CREATE,
            url: getParametrizedUrl(API_URL.BADGE_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async remove(blogUrl, badgeId) {
        return this.delete({
            apiUrl: API_URL.BADGE,
            url: getParametrizedUrl(API_URL.BADGE, {
                blogUrl: blogUrl,
                badgeId: badgeId
            })
        });
    }
}
class BlackListApi extends BaseApi {
    async fetchBlackList() {
        return this.get({
            apiUrl: API_URL.BLOG_BLACKLIST,
            url: API_URL.BLOG_BLACKLIST
        });
    }
    async putToBlackList(blogUrl, userId) {
        return this.put({
            apiUrl: API_URL.BLOG_BLACKLIST_ADD_USER,
            url: getParametrizedUrl(API_URL.BLOG_BLACKLIST_ADD_USER, {
                userId: userId,
                blogUrl: blogUrl
            })
        });
    }
    async removeFromBlackList(blogUrl, userId) {
        return this.delete({
            apiUrl: API_URL.BLOG_BLACKLIST_ADD_USER,
            url: getParametrizedUrl(API_URL.BLOG_BLACKLIST_ADD_USER, {
                userId: userId,
                blogUrl: blogUrl
            })
        });
    }
}
class BlogApi extends BaseApi {
    async fetch(blogUrl) {
        return this.get({
            apiUrl: API_URL.BLOG,
            url: getParametrizedUrl(API_URL.BLOG, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchSubscriptionLevels(blogUrl, showFree = true, showDeleted) {
        return this.get({
            apiUrl: API_URL.BLOG_SUBSCRIPTION_LEVELS,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIPTION_LEVELS, {
                blogUrl: blogUrl
            }, {
                show_deleted: showDeleted,
                show_free_level: showFree
            })
        });
    }
    async create(params) {
        return this.post({
            apiUrl: API_URL.BLOG_CREATE,
            url: API_URL.BLOG_CREATE,
            data: params
        });
    }
    async update(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.BLOG,
            url: getParametrizedUrl(API_URL.BLOG, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async coverUpload(blogUrl, file) {
        const { hosts: { uploadImg: uploadImgHost } } = getConfig();
        const url = uploadImgHost ? getParametrizedUrl(`${uploadImgHost}/v1${API_URL.BLOG_COVER_EDIT}`, {
            blogUrl: blogUrl
        }) : getParametrizedUrl(API_URL.BLOG_COVER_EDIT, {
            blogUrl: blogUrl
        });
        return this.put({
            apiUrl: API_URL.BLOG_COVER_EDIT,
            url: url,
            data: file,
            isNoProcessData: true
        });
    }
    async resubscribe(blogUrl, levelId, params) {
        return this.post({
            apiUrl: API_URL.BLOG_RESUBSCRIBE,
            url: getParametrizedUrl(API_URL.BLOG_RESUBSCRIBE, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async fetchPosts(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.BLOG_POSTS_FEED,
            url: getParametrizedUrl(API_URL.BLOG_POSTS_FEED, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
    async fetchPostsTags(blogUrl) {
        return this.get({
            apiUrl: API_URL.BLOG_POSTS_TAGS,
            url: getParametrizedUrl(API_URL.BLOG_POSTS_TAGS, {
                blogUrl: blogUrl
            })
        });
    }
    async unsubscribe(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.BLOG_UNSUBSCRIBE,
            url: getParametrizedUrl(API_URL.BLOG_UNSUBSCRIBE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async follow(blogUrl) {
        return this.post({
            apiUrl: API_URL.BLOG_FOLLOW,
            url: getParametrizedUrl(API_URL.BLOG_FOLLOW, {
                blogUrl: blogUrl
            })
        });
    }
    async complain(blogUrl) {
        return this.post({
            apiUrl: API_URL.BLOG_COMPLAIN,
            url: getParametrizedUrl(API_URL.BLOG_COMPLAIN, {
                blogUrl: blogUrl
            })
        });
    }
    async revertUnsubscribe(blogUrl) {
        return this.post({
            apiUrl: API_URL.BLOG_REVERT_CHANGES,
            url: getParametrizedUrl(API_URL.BLOG_REVERT_CHANGES, {
                blogUrl: blogUrl
            })
        });
    }
    async updateSocialLinks(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.BLOG_SOCIAL_LINKS,
            url: getParametrizedUrl(API_URL.BLOG_SOCIAL_LINKS, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async searchUser(blogUrl, chunk, limit) {
        return this.get({
            apiUrl: API_URL.BLOG_SEARCH_USER,
            url: getParametrizedUrl(API_URL.BLOG_SEARCH_USER, {
                blogUrl: blogUrl
            }, {
                chunk: chunk,
                limit: limit || 20
            })
        });
    }
    async fetchActionsJournal(blogUrl, eventsTypes) {
        return this.get({
            apiUrl: API_URL.ACTIONS_JOURNAL,
            url: getParametrizedUrl(API_URL.ACTIONS_JOURNAL, {
                blogUrl: blogUrl
            }, {
                type: eventsTypes
            })
        });
    }
    async fetchRef(blogUrl) {
        return this.get({
            apiUrl: API_URL.BLOG_REF_LINK,
            url: getParametrizedUrl(API_URL.BLOG_REF_LINK, {
                blogUrl: blogUrl
            })
        });
    }
    // для редактирования флагов hasAdultContent, isRssFeedEnabled, showPostDonations
    async updateFlag(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_FLAG,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_FLAG, {
                blogUrl: blogUrl,
                flag: params.flag
            }),
            data: {
                value: params.value
            }
        });
    }
    async fetchPostDonations(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_DONATIONS_SALES,
            url: getParametrizedUrl(API_URL.BLOG_DONATIONS_SALES, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async updateRssSettings(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.BLOG_RSS_SETTINGS,
            url: getParametrizedUrl(API_URL.BLOG_RSS_SETTINGS, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async fetchRssLink(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.BLOG_RSS_URL,
            url: getParametrizedUrl(API_URL.BLOG_RSS_URL, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
    async updateDescription(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_DESCRIPTION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_DESCRIPTION, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
}
class BlogPostApi extends BaseApi {
    async fetch(blogUrl, postId, commentsLimit, repliesLimit = 2, commentId) {
        return this.get({
            apiUrl: API_URL.POST,
            url: getParametrizedUrl(API_URL.POST, {
                blogUrl: blogUrl,
                postId: postId
            }, {
                comments_limit: commentsLimit,
                reply_limit: repliesLimit,
                comment_id: commentId
            })
        });
    }
    async create(blogUrl, params) {
        if (!params.subscription_level_id) delete params.subscription_level_id;
        return this.post({
            apiUrl: API_URL.POST_CREATE,
            url: getParametrizedUrl(API_URL.POST_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async update(blogUrl, postId, params) {
        if (!params.subscription_level_id) delete params.subscription_level_id;
        return this.put({
            apiUrl: API_URL.POST,
            url: getParametrizedUrl(API_URL.POST, {
                blogUrl: blogUrl,
                postId: postId
            }),
            data: params
        });
    }
    async remove(blogUrl, postId) {
        return this.delete({
            apiUrl: API_URL.POST,
            url: getParametrizedUrl(API_URL.POST, {
                blogUrl: blogUrl,
                postId: postId
            })
        });
    }
    async like(blogUrl, postId) {
        return this.post({
            apiUrl: API_URL.POST_LIKE,
            url: getParametrizedUrl(API_URL.POST_LIKE, {
                blogUrl: blogUrl,
                postId: postId
            })
        });
    }
    async unlike(blogUrl, postId) {
        return this.delete({
            apiUrl: API_URL.POST_LIKE,
            url: getParametrizedUrl(API_URL.POST_LIKE, {
                blogUrl: blogUrl,
                postId: postId
            })
        });
    }
    async reaction(blogUrl, postId, reaction) {
        return this.post({
            apiUrl: API_URL.POST_REACTION,
            url: getParametrizedUrl(API_URL.POST_REACTION, {
                blogUrl: blogUrl,
                postId: postId
            }),
            data: {
                reaction: reaction
            }
        });
    }
    async removeReaction(blogUrl, postId) {
        return this.delete({
            apiUrl: API_URL.POST_REACTION,
            url: getParametrizedUrl(API_URL.POST_REACTION, {
                blogUrl: blogUrl,
                postId: postId
            })
        });
    }
    async complain(blogUrl, postId) {
        return this.post({
            apiUrl: API_URL.POST_COMPLAIN,
            url: getParametrizedUrl(API_URL.POST_COMPLAIN, {
                blogUrl: blogUrl,
                postId: postId
            })
        });
    }
    async fetchComments(blogUrl, postId, params = {}) {
        return this.get({
            apiUrl: API_URL.COMMENTS,
            url: getParametrizedUrl(API_URL.COMMENTS, {
                blogUrl: blogUrl,
                id: postId
            }, {
                ...params
            })
        });
    }
    async complainComment(blogUrl, postId, commentId) {
        return this.post({
            apiUrl: API_URL.COMMENTS_COMPLAIN,
            url: getParametrizedUrl(API_URL.COMMENTS_COMPLAIN, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            })
        });
    }
    async reactionComment(blogUrl, postId, commentId, reaction) {
        return this.post({
            apiUrl: API_URL.COMMENTS_REACTION,
            url: getParametrizedUrl(API_URL.COMMENTS_REACTION, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            }),
            data: {
                reaction: reaction
            }
        });
    }
    async removeReactionComment(blogUrl, postId, commentId) {
        return this.delete({
            apiUrl: API_URL.COMMENTS_REACTION,
            url: getParametrizedUrl(API_URL.COMMENTS_REACTION, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            })
        });
    }
    async createComment(blogUrl, postId, data, replyId) {
        return this.post({
            apiUrl: API_URL.COMMENTS,
            url: getParametrizedUrl(API_URL.COMMENTS, {
                blogUrl: blogUrl,
                id: postId
            }),
            data: {
                data: data,
                reply_id: replyId
            }
        });
    }
    async removeComment(blogUrl, postId, commentId) {
        return this.delete({
            apiUrl: API_URL.COMMENTS_DELETE,
            url: getParametrizedUrl(API_URL.COMMENTS_DELETE, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            })
        });
    }
    async restoreComment(blogUrl, postId, commentId) {
        return this.put({
            apiUrl: API_URL.COMMENTS_RESTORE,
            url: getParametrizedUrl(API_URL.COMMENTS_RESTORE, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            })
        });
    }
    async fetchDeferredAccessLevels(blogUrl, postId) {
        return this.get({
            apiUrl: API_URL.DEFERRED_ACCESS,
            url: getParametrizedUrl(API_URL.DEFERRED_ACCESS, {
                blogUrl: blogUrl,
                id: postId
            })
        });
    }
    async createDeferredAccessLevels(blogUrl, postId, params) {
        return this.post({
            apiUrl: API_URL.DEFERRED_ACCESS,
            url: getParametrizedUrl(API_URL.DEFERRED_ACCESS, {
                blogUrl: blogUrl,
                id: postId
            }),
            data: params
        });
    }
    async updateDeferredAccessLevels(blogUrl, postId, deferredAccessId, params) {
        return this.put({
            apiUrl: API_URL.DEFERRED_ACCESS_EDIT,
            url: getParametrizedUrl(API_URL.DEFERRED_ACCESS_EDIT, {
                blogUrl: blogUrl,
                id: postId,
                deferredAccessId: deferredAccessId
            }),
            data: params
        });
    }
    async removeDeferredAccessLevels(blogUrl, postId, deferredAccessId) {
        return this.delete({
            apiUrl: API_URL.DEFERRED_ACCESS_EDIT,
            url: getParametrizedUrl(API_URL.DEFERRED_ACCESS_EDIT, {
                blogUrl: blogUrl,
                id: postId,
                deferredAccessId: deferredAccessId
            })
        });
    }
    async updateComment(blogUrl, postId, commentId, params) {
        return this.put({
            apiUrl: API_URL.POST_COMMENT,
            url: getParametrizedUrl(API_URL.POST_COMMENT, {
                blogUrl: blogUrl,
                postId: postId,
                commentId: commentId
            }),
            data: params
        });
    }
}
class BlogPostChatApi extends BaseApi {
    constructor(){
        super(...arguments);
        this.URLS = {
            [EApiContext.BOOSTY]: {
                STREAM_CHAT: API_URL.STREAM_CHAT,
                STREAM_CHAT_POST: API_URL.PUBLIC_STREAM_CHAT_POST,
                STREAM_CHAT_DELETE: API_URL.STREAM_CHAT_DELETE,
                STREAM_CHAT_CLEAN: API_URL.STREAM_CHAT_CLEAN,
                // TODO check if needed
                STREAM_CHAT_CLEAN_ALL: "",
                STREAM_CHAT_TOKEN: API_URL.STREAM_CHAT_TOKEN,
                STREAM_CHAT_BAN_STAT: API_URL.STREAM_CHAT_BAN_STAT,
                STREAM_CHAT_BAN: API_URL.STREAM_CHAT_BAN
            },
            [EApiContext.STREAMS]: {
                STREAM_CHAT: API_URL.PUBLIC_STREAM_CHAT,
                STREAM_CHAT_POST: API_URL.PUBLIC_STREAM_CHAT_POST,
                STREAM_CHAT_DELETE: API_URL.PUBLIC_STREAM_CHAT_DELETE,
                STREAM_CHAT_CLEAN: API_URL.PUBLIC_STREAM_CHAT_CLEAN,
                STREAM_CHAT_CLEAN_ALL: API_URL.PUBLIC_STREAM_CHAT_CLEAN_ALL,
                STREAM_CHAT_TOKEN: API_URL.PUBLIC_STREAM_CHAT_TOKEN,
                STREAM_CHAT_BAN_STAT: API_URL.PUBLIC_STREAM_CHAT_BAN_STAT,
                STREAM_CHAT_BAN: API_URL.PUBLIC_STREAM_CHAT_BAN
            }
        };
    }
    async fetch(blogUrl, limit = 10, getAbort) {
        return this.get({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT, {
                blogUrl: blogUrl
            }, {
                limit: limit
            }),
            getAbort: getAbort
        });
    }
    async create(blogUrl, slotUrl, params) {
        return this.post({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_POST,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_POST, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            }),
            data: params
        });
    }
    async remove(blogUrl, messageId) {
        return this.delete({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_DELETE,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_DELETE, {
                blogUrl: blogUrl,
                messageId: messageId
            })
        });
    }
    async clean(blogUrl, userId) {
        return this.delete({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_CLEAN,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_CLEAN, {
                blogUrl: blogUrl
            }, {
                user_id: userId
            })
        });
    }
    async cleanAll(blogUrl) {
        return this.delete({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_CLEAN_ALL,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_CLEAN_ALL, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchBanStat(blogUrl, userId) {
        return this.get({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_BAN_STAT,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_BAN_STAT, {
                blogUrl: blogUrl
            }, {
                user_id: userId
            })
        });
    }
    async blockUser(blogUrl, slotUrl, params) {
        return this.put({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_BAN,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_BAN, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            }),
            data: params
        });
    }
    /* eslint-disable camelcase */ async unblockUser(blogUrl, slotUrl, { by_stream, user_id }) {
        return this.delete({
            apiUrl: this.URLS[this.getContext()].STREAM_CHAT_BAN,
            url: getParametrizedUrl(this.URLS[this.getContext()].STREAM_CHAT_BAN, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            }, {
                by_stream: by_stream,
                user_id: user_id
            })
        });
    }
    /* eslint-enable camelcase */ async fetchStopWords(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.STREAM_CHAT_STOP_WORD,
            url: getParametrizedUrl(API_URL.STREAM_CHAT_STOP_WORD, {
                blogUrl: blogUrl
            }, {
                limit: params.limit,
                offset: params.offset
            }),
            data: params
        });
    }
    async addStopWord(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.STREAM_CHAT_STOP_WORD,
            url: getParametrizedUrl(API_URL.STREAM_CHAT_STOP_WORD, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async removeStopWord(blogUrl, params) {
        return this.delete({
            apiUrl: API_URL.STREAM_CHAT_STOP_WORD,
            url: getParametrizedUrl(API_URL.STREAM_CHAT_STOP_WORD, {
                blogUrl: blogUrl
            }, {
                word: params.word
            })
        });
    }
    async fetchSettings(blogUrl) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_SETTINGS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async saveSettings(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_SETTINGS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_SETTINGS, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async fetchChatUsers(blogUrl, searchQuery) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_USERS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_USERS, {
                blogUrl: blogUrl
            }, {
                search_query: searchQuery,
                with_bans: true
            })
        });
    }
    async fetchChatUserStat(blogUrl, userId) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_USER_STAT,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_USER_STAT, {
                blogUrl: blogUrl
            }, {
                user_id: userId
            })
        });
    }
    async fetchChatUserSearchList(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_USER_SEARCH_LIST,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_USER_SEARCH_LIST, {
                blogUrl: blogUrl
            }, {
                limit: params.limit,
                search_query: params.search_query
            })
        });
    }
    async fetchPinnedMessage(blogUrl) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE, {
                blogUrl: blogUrl
            })
        });
    }
    async pinChatMessage({ blogUrl, kind, messageId, reactable }) {
        return this.post({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE, {
                blogUrl: blogUrl
            }),
            data: {
                kind: kind,
                message_id: messageId,
                reactable: reactable
            }
        });
    }
    async editPinnedChatMessage({ blogUrl, kind, reactable }) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE, {
                blogUrl: blogUrl
            }),
            data: {
                kind: kind,
                reactable: reactable
            }
        });
    }
    async addPinnedChatMessageReaction({ blogUrl, reaction }) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE_REACTION,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE_REACTION, {
                blogUrl: blogUrl
            }),
            data: {
                reaction: reaction
            }
        });
    }
    async unpinChatMessage(blogUrl) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_PINNED_MESSAGE, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchThreadMessages(blogUrl, threadId) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_THREAD_MESSAGES,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_THREAD_MESSAGES, {
                blogUrl: blogUrl,
                threadId: threadId
            })
        });
    }
}
class BlogStatApi extends BaseApi {
    /* eslint-disable camelcase */ async fetchCsv(blogUrl, dataType, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_CSV,
            url: getParametrizedUrl(API_URL.BLOG_STAT_CSV, {
                blogUrl: blogUrl,
                dataType: dataType
            }, {
                ...params
            }),
            responseType: "blob"
        });
    }
    async fetchBlogBroadcastMessageStats(blogUrl, offset2, limit) {
        return this.get({
            apiUrl: API_URL.BLOG_BROADCAST_MESSAGE_STATS,
            url: getParametrizedUrl(API_URL.BLOG_BROADCAST_MESSAGE_STATS, {
                blogUrl: blogUrl
            }, {
                offset: offset2,
                limit: limit
            })
        });
    }
    async fetchBlogHoldsStats(blogUrl, offset2, limit) {
        return this.get({
            apiUrl: API_URL.BLOG_HOLDS_STATS,
            url: getParametrizedUrl(API_URL.BLOG_HOLDS_STATS, {
                blogUrl: blogUrl
            }, {
                offset: offset2,
                limit: limit
            })
        });
    }
    async fetchBlogBaseStat(blogUrl) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_BASE,
            url: getParametrizedUrl(API_URL.BLOG_STAT_BASE, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchBlogMetrics(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_METRICS,
            url: getParametrizedUrl(API_URL.BLOG_STAT_METRICS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchBlogCharts(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_CHARTS,
            url: getParametrizedUrl(API_URL.BLOG_STAT_CHARTS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchBlogEvents(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_EVENTS,
            url: getParametrizedUrl(API_URL.BLOG_STAT_EVENTS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchBlogSearchUsers(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_SEARCH,
            url: getParametrizedUrl(API_URL.BLOG_STAT_SEARCH, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchBlogRefs(blogUrl) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_REF,
            url: getParametrizedUrl(API_URL.BLOG_STAT_REF, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchBlogRefsUsers(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_STAT_REF_USERS,
            url: getParametrizedUrl(API_URL.BLOG_STAT_REF_USERS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchSubscribers(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.BLOG_SUBSCRIBERS,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIBERS, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
    async fetchDonations(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_DONATIONS,
            url: getParametrizedUrl(API_URL.BLOG_DONATIONS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchPostSales(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_POST_SALES,
            url: getParametrizedUrl(API_URL.BLOG_POST_SALES, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchPostSalesByDate(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_POST_SALES_BY_DATE,
            url: getParametrizedUrl(API_URL.BLOG_POST_SALES_BY_DATE, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchPostSalesDaysByMonth(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.BLOG_POST_SALES_DAYS_BY_MONTH,
            url: getParametrizedUrl(API_URL.BLOG_POST_SALES_DAYS_BY_MONTH, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
}
class BrowserNotificationsApi extends BaseApi {
    async postDeviceToken({ accessToken, deviceToken }) {
        return this.post({
            apiUrl: API_URL.DEVICE_TOKEN,
            url: API_URL.DEVICE_TOKEN,
            data: {
                access_token: accessToken,
                device_token: deviceToken
            }
        });
    }
}
class CatalogApi extends BaseApi {
    async fetchSchema(params) {
        return this.get({
            apiUrl: API_URL.CATALOG_SCHEMA,
            url: getParametrizedUrl(API_URL.CATALOG_SCHEMA, {}, {
                ...params
            })
        });
    }
    async fetchAllSchemas(params) {
        return this.get({
            apiUrl: API_URL.CATALOG_ALL_SCHEMAS,
            url: getParametrizedUrl(API_URL.CATALOG_ALL_SCHEMAS, {}, {
                ...params
            })
        });
    }
    async fetchBlockData({ url, getAbort, ...params }) {
        return this.get({
            apiUrl: url,
            // TODO SR: какой тут api url?
            url: getParametrizedUrl(url, {}, {
                ...params
            }),
            getAbort: getAbort,
            withoutVersion: true
        });
    }
    async fetchCategories(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_CATEGORY, {}, {
                ...params
            })
        });
    }
    async fetchNewestCategories(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_NEWEST_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_NEWEST_CATEGORY, {}, {
                ...params
            })
        });
    }
    async fetchFollowedCategories(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_FOLLOWED_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_FOLLOWED_CATEGORY, {}, {
                ...params
            })
        });
    }
    async fetchRecommendedStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_RECOMMENDATIONS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_RECOMMENDATIONS, {}, {
                ...params
            })
        });
    }
    async fetchShowcaseStreams() {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_TOP,
            url: API_URL.PUBLIC_STREAM_CATALOG_TOP
        });
    }
    async fetchCozyStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_COZY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_COZY, {}, {
                ...params
            })
        });
    }
    async fetchOftenStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_OFTEN,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_OFTEN, {}, {
                ...params
            })
        });
    }
    async fetchVisitedStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_VISITED,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_VISITED, {}, {
                ...params
            })
        });
    }
    async fetchRecordedStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_RECORDED,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_RECORDED, {}, {
                ...params
            })
        });
    }
    async fetchStreams(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG, {}, {
                ...params
            })
        });
    }
    async fetchStreamsByCategory({ categoryId, ...params }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_CATEGORY_STREAMS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_CATEGORY_STREAMS, {
                categoryId: categoryId
            }, {
                ...params
            })
        });
    }
    async fetchRecordsByCategory({ categoryId, ...params }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_CATEGORY_RECORDS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_CATEGORY_RECORDS, {
                categoryId: categoryId
            }, {
                ...params
            })
        });
    }
    async fetchHistory(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATALOG_HISTORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATALOG_HISTORY, {}, {
                ...params
            })
        });
    }
}
class CategoryApi extends BaseApi {
    async hideCategory(categoryId) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_CATEGORY, {
                categoryId: categoryId
            })
        });
    }
    async removeCategoryFromHidden(categoryId) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_CATEGORY, {
                categoryId: categoryId
            })
        });
    }
    async followCategory(categoryId) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_FOLLOW_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_FOLLOW_CATEGORY, {
                categoryId: categoryId
            })
        });
    }
    async unfollowCategory(categoryId) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_FOLLOW_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_FOLLOW_CATEGORY, {
                categoryId: categoryId
            })
        });
    }
    async fetchHiddenCategories(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_HIDDEN_CATEGORIES,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDDEN_CATEGORIES, {}, {
                ...params
            })
        });
    }
    async search({ query, offset: offset2, limit }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_SEARCH_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_SEARCH_CATEGORY, {}, {
                search_query: query,
                limit: limit,
                offset: offset2
            })
        });
    }
}
class ChannelApi extends BaseApi {
    async create(params) {
        const { avatar: avatar2, email, channelUrl, hasAdultContent, nick: nick2 } = params;
        return this.post({
            apiUrl: API_URL.CHANNEL_CREATE,
            url: API_URL.CHANNEL_CREATE,
            data: {
                avatar: avatar2,
                channel_url: channelUrl,
                email: email,
                has_adult_content: hasAdultContent,
                nick: nick2
            }
        });
    }
    async changeCoverType(coverType, blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_COVER_TYPE,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_COVER_TYPE, {
                blogUrl: blogUrl
            }),
            data: {
                cover_type: coverType
            }
        });
    }
    async uploadCoverImage(file, blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_COVER_IMAGE,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_COVER_IMAGE, {
                blogUrl: blogUrl
            }),
            data: file,
            isNoProcessData: true
        });
    }
    async saveRecordTimeCode(blogUrl, recordId, timeCode) {
        return this.put({
            apiUrl: API_URL.CHANNEL_SAVE_RECORD_TIME_CODE,
            url: getParametrizedUrl(API_URL.CHANNEL_SAVE_RECORD_TIME_CODE, {
                blogUrl: blogUrl,
                recordId: recordId
            }),
            data: {
                time_code: timeCode
            }
        });
    }
    async saveStreamTimeCode(blogUrl, streamId, timeCode) {
        return this.put({
            apiUrl: API_URL.CHANNEL_SAVE_STREAM_TIME_CODE,
            url: getParametrizedUrl(API_URL.CHANNEL_SAVE_STREAM_TIME_CODE, {
                blogUrl: blogUrl,
                streamId: streamId
            }),
            data: {
                time_code: timeCode
            }
        });
    }
    async turnOnDrops(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_DROP_CAMPAIGNS,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_DROP_CAMPAIGNS, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOffDrops(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_DROP_CAMPAIGNS,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_DROP_CAMPAIGNS, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOnVideoClipCreation(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_VIDEO_CLIP_CREATION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_VIDEO_CLIP_CREATION, {
                channelUrl: blogUrl
            })
        });
    }
    async turnOffVideoClipCreation(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_VIDEO_CLIP_CREATION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_VIDEO_CLIP_CREATION, {
                channelUrl: blogUrl
            })
        });
    }
    async fetchAccessSelectorSubscriptionLevels(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTIONS_LIST,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTIONS_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchSubscriptionLevelBoosty(blogUrl, levelId) {
        return this.get({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_BOOSTY,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_BOOSTY, {
                blogUrl: blogUrl,
                levelId: levelId
            })
        });
    }
    async fetchVkCommunitiesList(blogUrl, limit = 20, offset2) {
        return this.get({
            apiUrl: API_URL.CHANNEL_VK_COMMUNITIES_LIST,
            url: getParametrizedUrl(API_URL.CHANNEL_VK_COMMUNITIES_LIST, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2
            })
        });
    }
    async fetchBoostyLink(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_BOOSTY_LINK,
            url: getParametrizedUrl(API_URL.CHANNEL_BOOSTY_LINK, {
                blogUrl: blogUrl
            })
        });
    }
    async linkVkCommunity(blogUrl, groupId) {
        return this.put({
            apiUrl: API_URL.CHANNEL_VK_COMMUNITY,
            url: getParametrizedUrl(API_URL.CHANNEL_VK_COMMUNITY, {
                blogUrl: blogUrl
            }),
            data: {
                vk_group_id: groupId
            }
        });
    }
    async unlinkVkCommunity(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_VK_COMMUNITY,
            url: getParametrizedUrl(API_URL.CHANNEL_VK_COMMUNITY, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChannelBanApi extends BaseApi {
    async fetchBan(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_BAN,
            url: getParametrizedUrl(API_URL.CHANNEL_BAN, {
                blogUrl: blogUrl
            })
        });
    }
    async deleteBan(blogUrl, userId, byStream) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_BAN_USER,
            url: getParametrizedUrl(API_URL.CHANNEL_BAN_USER, {
                blogUrl: blogUrl,
                userId: userId
            }, {
                by_stream: String(byStream)
            })
        });
    }
}
class ChannelDropsApi extends BaseApi {
    async fetchProgress(blogUrl, slotUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_DROPS_PROGRESS,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_DROPS_PROGRESS, {
                blogUrl: blogUrl,
                slotUrl: slotUrl || DEFAULT_SLOT
            })
        });
    }
    async requestProducts(dropCampaignId) {
        return this.put({
            apiUrl: API_URL.REQUEST_DROP_CAMPAIGN_PRODUCTS,
            url: dist$4.getParametrizedUrl(API_URL.REQUEST_DROP_CAMPAIGN_PRODUCTS, {
                dropCampaignId: dropCampaignId
            })
        });
    }
}
class ChannelModeratorApi extends BaseApi {
    async fetchModerators(params) {
        const { blogUrl, offset: offset2 = null, limit = 100, roles: roles2 = null, pattern = null } = params;
        return this.get({
            apiUrl: API_URL.CHANNEL_MANAGE_MODERATOR,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_MANAGE_MODERATOR, {
                blogUrl: blogUrl
            }, {
                offset: offset2,
                limit: limit,
                roles: roles2,
                pattern: pattern
            })
        });
    }
    async assignNewRole(blogUrl, userId, role2) {
        return this.post({
            apiUrl: API_URL.CHANNEL_MODERATOR_USER,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_MODERATOR_USER, {
                blogUrl: blogUrl,
                userId: userId
            }),
            data: {
                role: role2
            }
        });
    }
    async setRole(blogUrl, userId, role2) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_MODERATOR_USER,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_MANAGE_MODERATOR_USER, {
                blogUrl: blogUrl,
                userId: userId
            }),
            data: {
                role: role2
            }
        });
    }
    async deleteRole(blogUrl, userId) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_MODERATOR_USER,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_MANAGE_MODERATOR_USER, {
                blogUrl: blogUrl,
                userId: userId
            })
        });
    }
}
class ChannelPointApi extends BaseApi {
    async getChannelPoint(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_POINT,
            url: getParametrizedUrl(API_URL.CHANNEL_POINT, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChannelPointBonusApi extends BaseApi {
    async getPendingBonus(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEl_POINT_PENDING_BONUS,
            url: getParametrizedUrl(API_URL.CHANNEl_POINT_PENDING_BONUS, {
                blogUrl: blogUrl
            })
        });
    }
    async gatherPendingBonus(blogUrl, id) {
        return this.put({
            apiUrl: API_URL.CHANNEl_POINT_PENDING_BONUS_GATHER,
            url: getParametrizedUrl(API_URL.CHANNEl_POINT_PENDING_BONUS_GATHER, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async getBonus(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEl_POINT_BONUS,
            url: getParametrizedUrl(API_URL.CHANNEl_POINT_BONUS, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChannelPollApi extends BaseApi {
    async createChannelPoll(blogUrl, params) {
        const data = {
            ...params,
            decisions: JSON.stringify(params.decisions)
        };
        return this.put({
            apiUrl: API_URL.CHANNEL_POLL_MANAGE,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL_MANAGE, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async getChannelPoll(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_POLL,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL, {
                blogUrl: blogUrl
            })
        });
    }
    async getChannelPollManage(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_POLL_MANAGE,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL_MANAGE, {
                blogUrl: blogUrl
            })
        });
    }
    async voteChannelPoll(blogUrl, params) {
        const data = {
            decision_id: params.decisionId
        };
        return this.put({
            apiUrl: API_URL.CHANNEL_POLL_VOTE,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL_VOTE, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async deleteChannelPoll(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_POLL_MANAGE,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL_MANAGE, {
                blogUrl: blogUrl
            })
        });
    }
    async doneChannelPoll(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_POLL_MANAGE_DONE,
            url: dist$4.getParametrizedUrl(API_URL.CHANNEL_POLL_MANAGE_DONE, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChannelPredictionApi extends BaseApi {
    async createPrediction(blogUrl, params) {
        const data = {
            ...params,
            decisions: JSON.stringify(params.decisions)
        };
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_PREDICTION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_PREDICTION, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async fetchActivePrediction(blogUrl) {
        let result2 = void 0;
        try {
            result2 = await this.get({
                apiUrl: API_URL.CHANNEL_PREDICTION,
                url: getParametrizedUrl(API_URL.CHANNEL_PREDICTION, {
                    blogUrl: blogUrl
                })
            });
        } catch (error2) {
            if (error2.status !== 404) throw error2;
        }
        return result2;
    }
    async fetchPredictionById(blogUrl, predictionId) {
        let result2 = void 0;
        try {
            result2 = await this.get({
                apiUrl: API_URL.CHANNEL_PREDICTION_BY_ID,
                url: getParametrizedUrl(API_URL.CHANNEL_PREDICTION_BY_ID, {
                    blogUrl: blogUrl,
                    predictionId: predictionId
                })
            });
        } catch (error2) {
            if (error2.status !== 404) throw error2;
        }
        return result2;
    }
    async deletePrediction(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_PREDICTION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_PREDICTION, {
                blogUrl: blogUrl
            })
        });
    }
    async donePrediction(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_PREDICTION_DONE,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_PREDICTION_DONE, {
                blogUrl: blogUrl
            })
        });
    }
    async manageDecisionPrediction(blogUrl, id) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_PREDICTION_DECISION,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_PREDICTION_DECISION, {
                blogUrl: blogUrl
            }),
            data: {
                decision_id: id
            }
        });
    }
    async decisionPrediction(blogUrl, id, amount) {
        return this.put({
            apiUrl: API_URL.CHANNEL_PREDICTION_BID,
            url: getParametrizedUrl(API_URL.CHANNEL_PREDICTION_BID, {
                blogUrl: blogUrl
            }),
            data: {
                decision_id: id,
                amount: amount
            }
        });
    }
}
class ChannelRewardApi extends BaseApi {
    async activateReward(blogUrl, id, text2) {
        return this.put({
            apiUrl: API_URL.REWARD_ACTIVATE,
            url: getParametrizedUrl(API_URL.REWARD_ACTIVATE, {
                blogUrl: blogUrl,
                id: id
            }),
            data: {
                text: text2
            }
        });
    }
}
class ChannelSettingsApi extends BaseApi {
    async fetchSettingsSet(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async updateChannel(blogUrl, nick2) {
        return this.put({
            apiUrl: API_URL.CHANNEL_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_SETTINGS, {
                blogUrl: blogUrl
            }),
            data: {
                nick: nick2
            }
        });
    }
    async updateChannelAvatar(blogUrl, avatar2) {
        return this.put({
            apiUrl: API_URL.CHANNEL_SETTINGS_AVATAR,
            url: getParametrizedUrl(API_URL.CHANNEL_SETTINGS_AVATAR, {
                blogUrl: blogUrl
            }),
            data: {
                avatar: avatar2
            }
        });
    }
    async updateNewRecordsSubscriptionLevel(blogUrl, subscriptionLevelId) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_NEW_RECORDS_SUBSCRIPTION_LEVEL,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_NEW_RECORDS_SUBSCRIPTION_LEVEL, {
                blogUrl: blogUrl
            }),
            data: {
                subscription_level_id: subscriptionLevelId
            }
        });
    }
    async turnOnStreamsRecord(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_RECORDING,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_RECORDING, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOffStreamsRecord(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_RECORDING,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_RECORDING, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOnSelfPublicStreamHidden(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_SELF_HIDDEN,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_SELF_HIDDEN, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOffSelfPublicStreamHidden(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_SELF_HIDDEN,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_SELF_HIDDEN, {
                blogUrl: blogUrl
            })
        });
    }
    async turnOnStreamRaided(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_RAIDABLE,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_RAIDABLE, {
                blogUrl: blogUrl
            })
        });
    }
    async setRaidMinimumViewers(blogUrl, minimumViewers) {
        return this.put({
            apiUrl: API_URL.CHANNEL_MANAGE_RAID_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_RAID_SETTINGS, {
                blogUrl: blogUrl
            }),
            data: {
                minimum_viewers: minimumViewers
            }
        });
    }
    async turnOffStreamRaided(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_MANAGE_RAIDABLE,
            url: getParametrizedUrl(API_URL.CHANNEL_MANAGE_RAIDABLE, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChannelStatApi extends BaseApi {
    async fetchChannelBasicStat(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_STAT_BASIC,
            url: getParametrizedUrl(API_URL.CHANNEL_STAT_BASIC, {
                blogUrl: blogUrl
            })
        });
    }
}
class ChatBotApi extends BaseApi {
    async fetchTimers(blogUrl, limit, after) {
        return this.get({
            apiUrl: API_URL.CHATBOT_TIMERS,
            url: getParametrizedUrl(API_URL.CHATBOT_TIMERS, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                after: after
            })
        });
    }
    async createTimer(blogUrl, data) {
        return this.post({
            apiUrl: API_URL.CHATBOT_TIMERS,
            url: getParametrizedUrl(API_URL.CHATBOT_TIMERS, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async editTimer(blogUrl, timerId2, data) {
        return this.put({
            apiUrl: API_URL.CHATBOT_TIMER,
            url: getParametrizedUrl(API_URL.CHATBOT_TIMER, {
                blogUrl: blogUrl,
                timerId: timerId2
            }),
            data: data
        });
    }
    async deleteTimer(blogUrl, timerId2) {
        return this.delete({
            apiUrl: API_URL.CHATBOT_TIMER,
            url: getParametrizedUrl(API_URL.CHATBOT_TIMER, {
                blogUrl: blogUrl,
                timerId: timerId2
            })
        });
    }
    async fetchCommandsList(blogUrl, limit, offset2) {
        return this.get({
            apiUrl: API_URL.CHATBOT_COMMANDS,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMANDS, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2
            }),
            withoutVersion: true
        });
    }
    async createCommand(blogUrl, data) {
        return this.post({
            apiUrl: API_URL.CHATBOT_COMMAND_CREATE,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND_CREATE, {
                blogUrl: blogUrl
            }),
            // eslint-disable-next-line sonarjs/no-duplicate-string
            headers: {
                "Content-Type": "application/json"
            },
            isNoProcessData: true,
            data: data,
            withoutVersion: true
        });
    }
    async editCommand(blogUrl, commandId, data) {
        return this.put({
            apiUrl: API_URL.CHATBOT_COMMAND,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND, {
                blogUrl: blogUrl,
                commandId: commandId
            }),
            headers: {
                "Content-Type": "application/json"
            },
            isNoProcessData: true,
            data: data,
            withoutVersion: true
        });
    }
    async deleteCommand(blogUrl, commandId) {
        return this.delete({
            apiUrl: API_URL.CHATBOT_COMMAND,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND, {
                blogUrl: blogUrl,
                commandId: commandId
            }),
            withoutVersion: true
        });
    }
    async toggleCommandActive(blogUrl, commandId) {
        return this.put({
            apiUrl: API_URL.CHATBOT_COMMAND_TOGGLE,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND_TOGGLE, {
                blogUrl: blogUrl,
                commandId: commandId
            }),
            withoutVersion: true
        });
    }
    async toggleCommandInactive(blogUrl, commandId) {
        return this.delete({
            apiUrl: API_URL.CHATBOT_COMMAND_TOGGLE,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND_TOGGLE, {
                blogUrl: blogUrl,
                commandId: commandId
            }),
            withoutVersion: true
        });
    }
    async fetchCommand(blogUrl, commandId) {
        return this.get({
            apiUrl: API_URL.CHATBOT_COMMAND,
            url: getParametrizedUrl(API_URL.CHATBOT_COMMAND, {
                blogUrl: blogUrl,
                commandId: commandId
            }),
            withoutVersion: true
        });
    }
}
class ChatWinnerApi extends BaseApi {
    async getChatWinnerSubscriber(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_WINNER_SUBSCRIBER,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_WINNER_SUBSCRIBER, {
                blogUrl: blogUrl
            }, {
                selection_type: params.selectionType
            })
        });
    }
    async getChatWinnerViewer(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_WINNER_CHAT_VIEWER,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_WINNER_CHAT_VIEWER, {
                blogUrl: blogUrl
            }),
            params: params
        });
    }
    async getChatWinnerPattern(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CHAT_WINNER_WORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CHAT_WINNER_WORD, {
                blogUrl: blogUrl
            }),
            params: params
        });
    }
}
class CustomBlocksApi extends BaseApi {
    async fetch(blogUrl) {
        return this.get({
            apiUrl: API_URL.CUSTOM_BLOCKS,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCKS, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchItem(blogUrl, blockId) {
        return this.get({
            apiUrl: API_URL.CUSTOM_BLOCK,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCK, {
                blogUrl: blogUrl,
                blockId: blockId
            })
        });
    }
    async createItem(blogUrl, data) {
        return this.post({
            apiUrl: API_URL.CUSTOM_BLOCKS,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCKS, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async editItem(blogUrl, blockId, data) {
        return this.put({
            apiUrl: API_URL.CUSTOM_BLOCK,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCK, {
                blogUrl: blogUrl,
                blockId: blockId
            }),
            data: data
        });
    }
    async deleteItem(blogUrl, blockId) {
        return this.delete({
            apiUrl: API_URL.CUSTOM_BLOCK,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCK, {
                blogUrl: blogUrl,
                blockId: blockId
            })
        });
    }
    async updateOrder(blogUrl, data) {
        return this.put({
            apiUrl: API_URL.CUSTOM_BLOCKS_ORDER,
            url: getParametrizedUrl(API_URL.CUSTOM_BLOCKS_ORDER, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
}
class DeviceApi extends BaseApi {
    async getDeviceInfo(userCode) {
        return this.post({
            apiUrl: API_URL.OAUTH_DEVICE_INFO,
            url: API_URL.OAUTH_DEVICE_INFO,
            data: {
                user_code: userCode
            }
        });
    }
    async deviceExchange(userCode) {
        return this.post({
            apiUrl: API_URL.OAUTH_DEVICE_EXCHANGE,
            url: API_URL.OAUTH_DEVICE_EXCHANGE,
            data: {
                user_code: userCode
            }
        });
    }
}
class DialogueApi extends BaseApi {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async token(dialogId, data) {
        return this.post({
            apiUrl: API_URL.DIALOG_TOKEN,
            url: getParametrizedUrl(API_URL.DIALOG_TOKEN, {
                dialogId: dialogId
            }),
            data: JSON.stringify(data),
            isNoProcessData: true
        });
    }
    async fetchList(params) {
        return this.get({
            apiUrl: API_URL.DIALOG_LIST,
            url: getParametrizedUrl(API_URL.DIALOG_LIST, {}, {
                ...params
            })
        });
    }
    async fetchDialogueByUserId(params) {
        return this.get({
            apiUrl: API_URL.DIALOG_BY_USER_ID,
            url: getParametrizedUrl(API_URL.DIALOG_BY_USER_ID, {}, {
                ...params
            })
        });
    }
    async create(params) {
        return this.post({
            apiUrl: API_URL.DIALOG_CREATE,
            url: API_URL.DIALOG_CREATE,
            data: params
        });
    }
    async fetchDialog(dialogId) {
        return this.get({
            apiUrl: API_URL.DIALOG,
            url: getParametrizedUrl(API_URL.DIALOG, {
                dialogId: dialogId
            })
        });
    }
    async fetchDialogShort(dialogId) {
        return this.get({
            apiUrl: API_URL.DIALOG_SHORT,
            url: getParametrizedUrl(API_URL.DIALOG_SHORT, {
                dialogId: dialogId
            })
        });
    }
    async fetchMessages(dialogId, params) {
        return this.get({
            apiUrl: API_URL.DIALOG_MESSAGE_LIST,
            url: getParametrizedUrl(API_URL.DIALOG_MESSAGE_LIST, {
                dialogId: dialogId
            }, {
                ...params
            })
        });
    }
    async sendMessage(dialogId, data, teaserData, price) {
        return this.post({
            apiUrl: API_URL.DIALOG_MESSAGE_CREATE,
            url: getParametrizedUrl(API_URL.DIALOG_MESSAGE_CREATE, {
                dialogId: dialogId
            }),
            data: {
                data: data,
                teaser_data: teaserData,
                price: price
            }
        });
    }
    async sendBroadcastMessage(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.DIALOG_BROADCAST_MESSAGE_CREATE,
            url: getParametrizedUrl(API_URL.DIALOG_BROADCAST_MESSAGE_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async markAsReadAll(params) {
        return this.put({
            apiUrl: API_URL.DIALOG_READ_ALL,
            url: getParametrizedUrl(API_URL.DIALOG_READ_ALL, {}, {
                ...params
            })
        });
    }
    async markAsReadMessage(messageId) {
        return this.post({
            apiUrl: API_URL.DIALOG_MESSAGE_READ,
            url: getParametrizedUrl(API_URL.DIALOG_MESSAGE_READ, {
                messageId: messageId
            })
        });
    }
    async deleteMessage(dialogId, params) {
        return this.delete({
            apiUrl: API_URL.DIALOG_MESSAGE,
            url: getParametrizedUrl(API_URL.DIALOG_MESSAGE, {
                dialogId: dialogId
            }, {
                ...params
            })
        });
    }
    async fetchMessage(messageId) {
        return this.get({
            apiUrl: API_URL.DIALOG_CURRENT_MESSAGE,
            url: getParametrizedUrl(API_URL.DIALOG_CURRENT_MESSAGE, {
                messageId: messageId
            })
        });
    }
    async fetchContacts(params) {
        return this.get({
            apiUrl: API_URL.DIALOG_CONTACTS,
            url: getParametrizedUrl(API_URL.DIALOG_CONTACTS, {}, {
                ...params
            })
        });
    }
    async fetchMailingList(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.DIALOG_MAILING_LIST,
            url: getParametrizedUrl(API_URL.DIALOG_MAILING_LIST, {
                blogUrl: blogUrl
            }, {
                sort_by: params.sort_by,
                sort_order: params.sort_order,
                offset: params.offset,
                limit: params.limit
            }),
            data: {
                subscription_months_duration_from: params.subscription_months_duration_from,
                subscription_months_duration_to: params.subscription_months_duration_to,
                money_spent_from: params.money_spent_from,
                money_spent_to: params.money_spent_to,
                paid_subscription_canceled: params.paid_subscription_canceled,
                subscription_level_ids: params.subscription_level_ids,
                chunk: params.chunk
            }
        });
    }
    async getCanWriteWithDonationFlag(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.DIALOG_CAN_WRITE_WITH_DONATION,
            url: getParametrizedUrl(API_URL.DIALOG_CAN_WRITE_WITH_DONATION, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
}
class DonationServiceApi extends BaseApi {
    async fetchDonationServiceList(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_DONATION_SERVICE_LIST,
            url: getParametrizedUrl(API_URL.CHANNEL_DONATION_SERVICE_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async updateDonationService(blogUrl, serviceId, param, value2) {
        return this.put({
            apiUrl: API_URL.CHANNEL_DONATION_SERVICE,
            url: getParametrizedUrl(API_URL.CHANNEL_DONATION_SERVICE, {
                blogUrl: blogUrl
            }),
            data: {
                service_id: serviceId,
                param: param,
                value: value2
            }
        });
    }
    async deleteDonationService(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_DONATION_SERVICE,
            url: getParametrizedUrl(API_URL.CHANNEL_DONATION_SERVICE, {
                blogUrl: blogUrl
            })
        });
    }
}
class DropCampaignsApi extends BaseApi {
    async claimDropCampaignProduct(dropCampaignId) {
        return this.put({
            apiUrl: API_URL.DROP_CAMPAIGN_PRODUCT_CLAIM,
            url: dist$4.getParametrizedUrl(API_URL.DROP_CAMPAIGN_PRODUCT_CLAIM, {
                dropCampaignId: dropCampaignId
            })
        });
    }
    async fetchDropCampaigns() {
        return this.get({
            apiUrl: API_URL.DROP_CAMPAIGNS,
            url: API_URL.DROP_CAMPAIGNS
        });
    }
    async fetchDropCampaign(dropCampaignId) {
        return this.get({
            apiUrl: API_URL.DROP_CAMPAIGN,
            url: dist$4.getParametrizedUrl(API_URL.DROP_CAMPAIGN, {
                dropCampaignId: dropCampaignId
            })
        });
    }
}
class ExternalAppsApi extends BaseApi {
    async fetchTelegramUrl() {
        return this.get({
            apiUrl: API_URL.EXTERNAL_APPS_TELEGRAM_CONNECTION_URL,
            url: API_URL.EXTERNAL_APPS_TELEGRAM_CONNECTION_URL
        });
    }
    async disconnectDiscordServer() {
        return this.delete({
            apiUrl: API_URL.EXTERNAL_APPS_DISCORD_BOT,
            url: API_URL.EXTERNAL_APPS_DISCORD_BOT
        });
    }
    async fetchDiscordRoles() {
        return this.get({
            apiUrl: API_URL.EXTERNAL_APPS_DISCORD_ROLE,
            url: API_URL.EXTERNAL_APPS_DISCORD_ROLE
        });
    }
    async fetchTelegramGroups(blogUrl) {
        return this.get({
            apiUrl: API_URL.EXTERNAL_APPS_TELEGRAM_GROUP,
            url: getParametrizedUrl(API_URL.EXTERNAL_APPS_TELEGRAM_GROUP, {
                blogUrl: blogUrl
            })
        });
    }
    async deleteVkplayLink() {
        return this.delete({
            apiUrl: API_URL.USER_OAUTH_LINK_VKPLAY,
            url: API_URL.USER_OAUTH_LINK_VKPLAY
        });
    }
}
class GiftApi extends BaseApi {
    async fetch(giftKey) {
        return this.get({
            apiUrl: API_URL.GIFT,
            url: getParametrizedUrl(API_URL.GIFT, {
                giftKey: giftKey
            })
        });
    }
    async fetchGifts() {
        return this.get({
            apiUrl: API_URL.GIFT_LIST,
            url: API_URL.GIFT_LIST
        });
    }
    async accept(giftKey, isOff) {
        return this.post({
            apiUrl: API_URL.GIFT_ACCEPT,
            url: getParametrizedUrl(API_URL.GIFT_ACCEPT, {
                giftKey: giftKey
            }),
            data: {
                is_off: isOff
            }
        });
    }
    async send(giftKey, email) {
        return this.post({
            apiUrl: API_URL.GIFT_SEND,
            url: getParametrizedUrl(API_URL.GIFT_SEND, {
                giftKey: giftKey
            }),
            data: {
                email: email
            }
        });
    }
    async changeAnonymity(giftKey, isAnonymous) {
        return this.put({
            apiUrl: API_URL.GIFT,
            url: getParametrizedUrl(API_URL.GIFT, {
                giftKey: giftKey
            }),
            data: {
                is_anonymous: isAnonymous
            }
        });
    }
}
class HostStatusApi extends BaseApi {
    async fetchHostStatus(blogUrl) {
        return this.get({
            apiUrl: API_URL.HOST,
            url: getParametrizedUrl(API_URL.HOST, {
                blogUrl: blogUrl
            })
        });
    }
    async startHost(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.HOST,
            url: getParametrizedUrl(API_URL.HOST, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async stopHost(blogUrl) {
        return this.delete({
            apiUrl: API_URL.HOST,
            url: getParametrizedUrl(API_URL.HOST, {
                blogUrl: blogUrl
            })
        });
    }
}
class InternalApi extends BaseApi {
    async fetchDonation(donationId) {
        return this.get({
            apiUrl: INTERNAL_API_URLS.DONATION,
            url: getParametrizedUrl(INTERNAL_API_URLS.DONATION, {
                donationId: donationId
            })
        });
    }
    async fetchGift(giftKey) {
        return this.get({
            apiUrl: INTERNAL_API_URLS.GIFT,
            url: getParametrizedUrl(INTERNAL_API_URLS.GIFT, {
                giftKey: giftKey
            })
        });
    }
    async fetchUsers(userIds) {
        return this.get({
            apiUrl: INTERNAL_API_URLS.USERS,
            url: getParametrizedUrl(INTERNAL_API_URLS.USERS, {}, {
                user_ids: userIds
            })
        });
    }
    async fetchComments(commentId) {
        return this.get({
            apiUrl: INTERNAL_API_URLS.COMMENT,
            url: getParametrizedUrl(INTERNAL_API_URLS.COMMENT, {
                commentId: commentId
            })
        });
    }
    async fetchMessage(messageId) {
        return this.get({
            apiUrl: INTERNAL_API_URLS.MESSAGE,
            url: getParametrizedUrl(INTERNAL_API_URLS.MESSAGE, {
                messageId: messageId
            })
        });
    }
}
class MediaDataApi extends BaseApi {
    async uploadImage(file, containerType) {
        const { hosts: { uploadImg: uploadImgHost } } = getConfig();
        const url = uploadImgHost ? getParametrizedUrl(`${uploadImgHost}/v1${API_URL.MEDIA_DATA_IMAGE_UPLOAD}`, null, {
            container_type: containerType
        }) : getParametrizedUrl(API_URL.MEDIA_DATA_IMAGE_UPLOAD, null, {
            container_type: containerType
        });
        return this.post({
            apiUrl: API_URL.MEDIA_DATA_IMAGE_UPLOAD,
            url: url,
            data: file,
            isNoProcessData: true
        });
    }
    async createUploadFileContainer() {
        return this.post({
            apiUrl: API_URL.MEDIA_DATA_FILE_CONTAINER_CREATE,
            url: getParametrizedUrl(API_URL.MEDIA_DATA_FILE_CONTAINER_CREATE, {}, {
                rnd: Math.random()
            })
        });
    }
    async uploadFileChunk(url, data, headers, onUploadProgress, getAbort) {
        return this.post({
            apiUrl: url,
            url: // TODO SR: какой тут API_URL?
            url,
            data: data,
            headers: {
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "Content-Type": "application/octet-stream",
                ...headers
            },
            getAbort: getAbort,
            isNoProcessData: true,
            onUploadProgress: onUploadProgress
        });
    }
    async createUploadAudioContainer() {
        return this.post({
            apiUrl: API_URL.MEDIA_DATA_AUDIO_CONTAINER_CREATE,
            url: getParametrizedUrl(API_URL.MEDIA_DATA_AUDIO_CONTAINER_CREATE, {}, {
                rnd: Math.random()
            })
        });
    }
    async uploadAudioChunk(url, data, headers, onUploadProgress, getAbort) {
        return this.post({
            apiUrl: url,
            url: // TODO SR: какой тут API_URL
            url,
            data: data,
            headers: {
                "Content-Type": "application/octet-stream",
                ...headers
            },
            getAbort: getAbort,
            isNoProcessData: true,
            onUploadProgress: onUploadProgress
        });
    }
    async getSoundcloudTrackEmbed(url) {
        const resp = await this.api.getTransport().http({
            url: getParametrizedUrl(EXTERNAL_API.soundcloudTrackEmbedApi, {
                url: url
            })
        });
        const data = JSON.parse(resp.data.substring(1, resp.data.length - 2));
        const match2 = data.html.match(/<iframe(?:[^>]*) src\s*=\s*['|"](.+?)['|"]/i);
        if (match2 == null) throw new ApiError({
            message: "Failed to extract embed url"
        });
        const embedUrl = match2[1];
        return {
            url: embedUrl,
            title: data.title
        };
    }
    async createUploadVideoContainer(params) {
        return this.get({
            apiUrl: API_URL.MEDIA_DATA_VIDEO_UPLOAD_URL,
            url: getParametrizedUrl(API_URL.MEDIA_DATA_VIDEO_UPLOAD_URL, {}, {
                ...params
            })
        });
    }
    async uploadVideoChunk(url, data, headers, onUploadProgress, getAbort) {
        return this.post({
            apiUrl: url,
            url: // TODO SR: какой тут API_URL?
            url,
            data: data,
            headers: {
                "Content-Type": "application/octet-stream",
                ...headers
            },
            getAbort: getAbort,
            isNoProcessData: true,
            onUploadProgress: onUploadProgress
        });
    }
    async videoUploadFinish(id) {
        return this.post({
            apiUrl: API_URL.MEDIA_DATA_VIDEO_UPLOAD_FINISH,
            url: getParametrizedUrl(API_URL.MEDIA_DATA_VIDEO_UPLOAD_FINISH, {
                id: id
            })
        });
    }
}
class ModerationLogApi extends BaseApi {
    async fetchModerationLog(blogUrl, moderatorId, eventTypes, limit, after) {
        return this.get({
            apiUrl: API_URL.MODERATION_LOG,
            url: getParametrizedUrl(API_URL.MODERATION_LOG, {
                blogUrl: blogUrl
            }, {
                moderator_id: moderatorId,
                event_types: eventTypes,
                limit: limit,
                after: after
            })
        });
    }
}
class MultiplicatorsApi extends BaseApi {
    async fetchMultiplicators(blogUrl) {
        return this.get({
            apiUrl: API_URL.MULTIPLICATORS,
            url: getParametrizedUrl(API_URL.MULTIPLICATORS, {
                blogUrl: blogUrl
            })
        });
    }
    async updateMultiplicators(blogUrl, payload) {
        return this.put({
            apiUrl: API_URL.MULTIPLICATORS,
            url: getParametrizedUrl(API_URL.MULTIPLICATORS, {
                blogUrl: blogUrl
            }),
            data: {
                level_ids: payload.levelIds,
                multipliers: payload.multipliers
            }
        });
    }
}
class NewsApi extends BaseApi {
    async fetchLatestNews(platform2) {
        return this.get({
            apiUrl: API_URL.NEWS_LATEST,
            url: getParametrizedUrl(API_URL.NEWS_LATEST, {}, {
                platform: platform2
            })
        });
    }
    async viewNews(id) {
        return this.put({
            apiUrl: API_URL.NEWS,
            url: getParametrizedUrl(API_URL.NEWS, {
                noveltyId: id
            })
        });
    }
    async fetchLastNews(platform2) {
        return this.get({
            apiUrl: API_URL.NEWS_LAST,
            url: getParametrizedUrl(API_URL.NEWS_LAST, {}, {
                platform: platform2
            })
        });
    }
}
class NotificationSettingsApi extends BaseApi {
    async setNotificationsOn(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_NOTIFICATION_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_NOTIFICATION_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async setNotificationsOff(blogUrl) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_NOTIFICATION_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_NOTIFICATION_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async getNotificationSettings(transports) {
        return this.get({
            apiUrl: API_URL.NOTIFICATION_SETTINS,
            url: getParametrizedUrl(API_URL.NOTIFICATION_SETTINS, {}, {
                transports: transports
            })
        });
    }
    async notificationSettingsUpdate(values2) {
        return this.put({
            apiUrl: API_URL.NOTIFICATION_SETTINGS_UPDATE,
            url: getParametrizedUrl(API_URL.NOTIFICATION_SETTINGS_UPDATE, {
                transport: values2.transport,
                switch: values2.switch
            }),
            data: {
                value: values2.value
            }
        });
    }
    async getNotificationChannelSettings({ blogUrl }) {
        return this.get({
            apiUrl: API_URL.CHANNEL_NOTIFICATION_SETTINGS,
            url: getParametrizedUrl(API_URL.CHANNEL_NOTIFICATION_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async notificationChannelSettingsUpdate({ blogUrl, mail, mobilePush, webPush }) {
        const payload = {};
        if (typeof mail === "boolean") payload.mail = mail;
        if (typeof mobilePush === "boolean") payload.mobile_push = mobilePush;
        if (typeof mobilePush === "boolean") payload.web_push = webPush;
        return this.put({
            apiUrl: API_URL.CHANNEL_NOTIFICATION_SETTINGS_TRANSPORT,
            url: getParametrizedUrl(API_URL.CHANNEL_NOTIFICATION_SETTINGS_TRANSPORT, {
                blogUrl: blogUrl
            }),
            data: payload
        });
    }
}
class NotificationsStandaloneApi extends BaseApi {
    async fetchNotifications() {
        return this.get({
            apiUrl: API_URL.NOTIFICATIONS,
            url: API_URL.NOTIFICATIONS
        });
    }
    async markAsRead(ids) {
        return this.put({
            apiUrl: API_URL.NOTIFICATIONS_READ,
            url: API_URL.NOTIFICATIONS_READ,
            data: {
                event_id: ids
            }
        });
    }
    async remove(id) {
        return this.delete({
            apiUrl: API_URL.NOTIFICATION,
            url: getParametrizedUrl(API_URL.NOTIFICATION, {
                eventId: id
            })
        });
    }
}
class OwnChannelPointApi extends BaseApi {
    async getOwnChannelPoint(blogUrl) {
        return this.get({
            apiUrl: API_URL.OWN_CHANNEL_POINT,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT, {
                blogUrl: blogUrl
            })
        });
    }
    async enableOwnChannelPoint(blogUrl) {
        return this.put({
            apiUrl: API_URL.OWN_CHANNEL_POINT_ENABLED,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT_ENABLED, {
                blogUrl: blogUrl
            })
        });
    }
    async disableOwnChannelPoint(blogUrl) {
        return this.delete({
            apiUrl: API_URL.OWN_CHANNEL_POINT_ENABLED,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT_ENABLED, {
                blogUrl: blogUrl
            })
        });
    }
    async createOwnChannelPoint(blogUrl, name2) {
        return this.post({
            apiUrl: API_URL.OWN_CHANNEL_POINT,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT, {
                blogUrl: blogUrl
            }),
            data: {
                name: name2
            }
        });
    }
    async resetOwnChannelPoint(blogUrl) {
        return this.put({
            apiUrl: API_URL.OWN_CHANNEL_POINT_RESET,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT_RESET, {
                blogUrl: blogUrl
            })
        });
    }
    async updateOwnChannelPoint(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.OWN_CHANNEL_POINT,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async uploadImageOwnChannelPoint(blogUrl, size2, file) {
        return this.put({
            apiUrl: API_URL.OWN_CHANNEL_POINT_IMAGE,
            url: getParametrizedUrl(API_URL.OWN_CHANNEL_POINT_IMAGE, {
                blogUrl: blogUrl,
                sizeName: size2
            }),
            data: file,
            isNoProcessData: true
        });
    }
}
class PaymentApi extends BaseApi {
    async getBank131PageUrl(blogUrl, levelId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_BANK131_GET_SUBSCRIPTION_PAY_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_BANK131_GET_SUBSCRIPTION_PAY_URL, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async getDmrPageUrl(levelId, blogUrl, params) {
        return this.post({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_PAY_URL,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_PAY_URL, {
                levelId: levelId,
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async removePaymentBind(bindId) {
        return this.delete({
            apiUrl: API_URL.PAYMENT_DELETE_BIND,
            url: getParametrizedUrl(API_URL.PAYMENT_DELETE_BIND, {
                bindId: bindId
            })
        });
    }
    async getSinglePaymentGiftSubscriptionBank131PageUrl(blogUrl, levelId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_BANK131_GET_GIFT_PAY_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_BANK131_GET_GIFT_PAY_URL, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async getSinglePaymentGiftSubscriptionDmrPageUrl(levelId, blogUrl, params) {
        return this.post({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY_URL,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY_URL, {
                levelId: levelId,
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async getSinglePaymentDonationDmrPageUrl(blogUrl, type, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_DONATION_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_DONATION_URL, {
                blogUrl: blogUrl,
                type: type
            }),
            data: params
        });
    }
    async getSinglePaymentPostDmrPageUrl(blogUrl, postId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_POST_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_POST_URL, {
                blogUrl: blogUrl,
                postId: postId
            }),
            data: params
        });
    }
    async getSinglePaymentMessageDmrPageUrl(messageId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_URL, {
                messageId: messageId
            }),
            data: params
        });
    }
    async getSinglePaymentOnlyBindBank131PageUrl(params) {
        return this.get({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_ONLY_BIND_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_ONLY_BIND_URL, {}, {
                ...params
            })
        });
    }
    async getSinglePaymentOnlyBindDmrPageUrl(params) {
        return this.get({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_ONLY_BIND_URL,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_ONLY_BIND_URL, {}, {
                ...params
            })
        });
    }
    async checkPaymentId(paymentId) {
        return this.get({
            apiUrl: API_URL.PAYMENT_CHECK_ID,
            url: getParametrizedUrl(API_URL.PAYMENT_CHECK_ID, {
                paymentId: paymentId
            })
        });
    }
    async payWithExistingBank131Bind(blogUrl, levelId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_BANK131_PAY_FOR_SUBSCRIPTION,
            url: getParametrizedUrl(API_URL.PAYMENT_BANK131_PAY_FOR_SUBSCRIPTION, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async payWithExistingBind(levelId, blogUrl, params) {
        return this.post({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_PAY,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_PAY, {
                levelId: levelId,
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async payDonationWithExistingBind(blogUrl, type, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_PAY_SINGLE_PAYMENT_DONATION_WITH_BOUND_CARD,
            url: getParametrizedUrl(API_URL.PAYMENT_PAY_SINGLE_PAYMENT_DONATION_WITH_BOUND_CARD, {
                blogUrl: blogUrl,
                type: type
            }),
            data: params
        });
    }
    async payMessageWithExistingBind(messageId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_WITH_BOUND_CARD,
            url: getParametrizedUrl(API_URL.PAYMENT_GET_SINGLE_PAYMENT_MESSAGE_WITH_BOUND_CARD, {
                messageId: messageId
            }),
            data: params
        });
    }
    async payPostWithExistingBind(blogUrl, targetId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_PAY_SINGLE_PAYMENT_POST_WITH_BOUND_CARD,
            url: getParametrizedUrl(API_URL.PAYMENT_PAY_SINGLE_PAYMENT_POST_WITH_BOUND_CARD, {
                blogUrl: blogUrl,
                postId: targetId
            }),
            data: params
        });
    }
    async payGiftSubscriptionWithExistingBank131Bind(blogUrl, levelId, params) {
        return this.post({
            apiUrl: API_URL.PAYMENT_BANK131_PAY_FOR_GIFT,
            url: getParametrizedUrl(API_URL.PAYMENT_BANK131_PAY_FOR_GIFT, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async payGiftSubscriptionWithExistingBind(levelId, blogUrl, params) {
        return this.post({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT_PAY, {
                levelId: levelId,
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async fetchPaymentInfo(blogUrl, levelId, query) {
        return this.get({
            apiUrl: API_URL.BLOG_PAYMENT_INFO,
            url: getParametrizedUrl(API_URL.BLOG_PAYMENT_INFO, {
                blogUrl: blogUrl,
                levelId: levelId
            }, {
                ...query
            })
        });
    }
    async validateApplePaySession(validationUrl) {
        return this.post({
            apiUrl: API_URL.PAYMENT_VALIDATE_APPLE_PAY_SESSION,
            url: API_URL.PAYMENT_VALIDATE_APPLE_PAY_SESSION,
            data: {
                // eslint-disable-next-line camelcase
                endpoint_url: validationUrl
            }
        });
    }
    async fetchAdditionalPayment(blogUrl, levelId, query) {
        return this.get({
            apiUrl: API_URL.BLOG_ADDITIONAL_PAYMENT,
            url: getParametrizedUrl(API_URL.BLOG_ADDITIONAL_PAYMENT, {
                blogUrl: blogUrl,
                levelId: levelId
            }, {
                ...query
            })
        });
    }
    async fetchTransactionStatus(paymentId) {
        return this.get({
            apiUrl: API_URL.PAYMENT_TRANSACTION_STATUS,
            url: getParametrizedUrl(API_URL.PAYMENT_TRANSACTION_STATUS, {
                paymentId: paymentId
            })
        });
    }
    async sendQiwiSmsCode(paymentId, code) {
        return this.put({
            apiUrl: API_URL.PAYMENT_QIWI_STATUS,
            url: getParametrizedUrl(API_URL.PAYMENT_QIWI_STATUS, {
                paymentId: paymentId
            }),
            data: {
                code: code
            }
        });
    }
    async fetchDefaultCurrency() {
        return this.get({
            apiUrl: API_URL.PAYMENT_DEFAULT_CURRENCY,
            url: API_URL.PAYMENT_DEFAULT_CURRENCY
        });
    }
}
class PayoutApi extends BaseApi {
    async checkInnState() {
        return this.get({
            apiUrl: API_URL.PAYOUT_CHECK_INN_STATE,
            url: API_URL.PAYOUT_CHECK_INN_STATE
        });
    }
    async bindInn(inn) {
        return this.put({
            apiUrl: API_URL.PAYOUT_BIND_INN,
            url: dist$4.getParametrizedUrl(API_URL.PAYOUT_BIND_INN),
            data: {
                inn: inn
            }
        });
    }
    async deleteSelfEmployment() {
        return this.delete({
            apiUrl: API_URL.PAYOUT_SELF_EMPLOYED,
            url: API_URL.PAYOUT_SELF_EMPLOYED
        });
    }
    async getBankCards() {
        return this.get({
            apiUrl: API_URL.PAYOUT_BANK_CARD,
            url: API_URL.PAYOUT_BANK_CARD
        });
    }
    async bindBankCards() {
        return this.post({
            apiUrl: API_URL.PAYOUT_BIND_BANK_CARD,
            url: API_URL.PAYOUT_BIND_BANK_CARD
        });
    }
    async updateBankCards() {
        return this.put({
            apiUrl: API_URL.PAYOUT_BANK_CARD,
            url: API_URL.PAYOUT_BANK_CARD
        });
    }
}
class PlaylistApi extends BaseApi {
    async createPlaylist(blogUrl, data) {
        return this.post({
            apiUrl: API_URL.PLAYLISTS_MODERATOR,
            url: getParametrizedUrl(API_URL.PLAYLISTS_MODERATOR, {
                blogUrl: blogUrl
            }),
            data: data
        });
    }
    async editPlaylist(blogUrl, playlistId, data) {
        return this.put({
            apiUrl: API_URL.PLAYLIST_MODERATOR,
            url: getParametrizedUrl(API_URL.PLAYLIST_MODERATOR, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }),
            data: data
        });
    }
    async getPlaylists(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PLAYLISTS,
            url: getParametrizedUrl(API_URL.PLAYLISTS, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchPlaylistVideo(blogUrl, playlistId, isAllowed, params) {
        const apiUrl = isAllowed ? API_URL.PLAYLIST_ENTITY_LIST_MODERATOR : API_URL.PLAYLIST_ENTITY_LIST;
        return this.get({
            apiUrl: apiUrl,
            url: getParametrizedUrl(apiUrl, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }, {
                ...params
            })
        });
    }
    async getModeratorPlaylists(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.PLAYLISTS_MODERATOR,
            url: getParametrizedUrl(API_URL.PLAYLISTS_MODERATOR, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async fetchAvailableRecords(blogUrl, playlistId, params) {
        return this.get({
            apiUrl: API_URL.PLAYLIST_MANAGE_RECORD,
            url: getParametrizedUrl(API_URL.PLAYLIST_MANAGE_RECORD, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }, {
                ...params
            })
        });
    }
    async addPlaylistVideo(blogUrl, playlistId, data) {
        return this.put({
            apiUrl: API_URL.PLAYLIST_ENTITY_LIST_RECORD,
            url: getParametrizedUrl(API_URL.PLAYLIST_ENTITY_LIST_RECORD, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }),
            data: data
        });
    }
    async deletePlaylist(blogUrl, playlistId) {
        return this.delete({
            apiUrl: API_URL.PLAYLIST_MODERATOR,
            url: getParametrizedUrl(API_URL.PLAYLIST_MODERATOR, {
                blogUrl: blogUrl,
                playlistId: playlistId
            })
        });
    }
    async hidePlaylist(blogUrl, playlistId, data) {
        return this.put({
            apiUrl: API_URL.PLAYLIST_HIDE,
            url: getParametrizedUrl(API_URL.PLAYLIST_HIDE, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }),
            data: data
        });
    }
    async deleteFromHidePlaylist(blogUrl, playlistId, data) {
        return this.delete({
            apiUrl: API_URL.PLAYLIST_HIDE,
            url: getParametrizedUrl(API_URL.PLAYLIST_HIDE, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }),
            data: data
        });
    }
    async movePlaylist(blogUrl, playlistId, data) {
        return this.put({
            apiUrl: API_URL.PLAYLIST_MOVE,
            url: getParametrizedUrl(API_URL.PLAYLIST_MOVE, {
                blogUrl: blogUrl,
                playlistId: playlistId
            }),
            data: data
        });
    }
    async movePlaylistEntity(blogUrl, playlistId, entityId, data) {
        return this.put({
            apiUrl: API_URL.PLAYLIST_ENTITY_MOVE,
            url: getParametrizedUrl(API_URL.PLAYLIST_ENTITY_MOVE, {
                blogUrl: blogUrl,
                playlistId: playlistId,
                entityId: entityId
            }),
            data: data
        });
    }
    async fetchPlaylistEntity(blogUrl, playlistId, entityId) {
        return this.get({
            apiUrl: API_URL.PLAYLIST_ENTITY,
            url: getParametrizedUrl(API_URL.PLAYLIST_ENTITY, {
                blogUrl: blogUrl,
                playlistId: playlistId,
                entityId: entityId
            })
        });
    }
    async deleteFromPlaylist(blogUrl, playlistId, entityId) {
        return this.delete({
            apiUrl: API_URL.PLAYLIST_ENTITY_DELETE,
            url: getParametrizedUrl(API_URL.PLAYLIST_ENTITY_DELETE, {
                blogUrl: blogUrl,
                playlistId: playlistId,
                entityId: entityId
            })
        });
    }
    async fetchPlaylist(blogUrl, playlistId, isAllowed) {
        const apiUrl = isAllowed ? API_URL.PLAYLIST_MODERATOR : API_URL.PLAYLIST;
        return this.get({
            apiUrl: apiUrl,
            url: getParametrizedUrl(apiUrl, {
                blogUrl: blogUrl,
                playlistId: playlistId
            })
        });
    }
}
class PollApi extends BaseApi {
    async fetchUnsubs() {
        return this.get({
            apiUrl: API_URL.POLL_UNSUB_REASONS_FETCH,
            url: API_URL.POLL_UNSUB_REASONS_FETCH
        });
    }
    async fetchUnsubsList(params) {
        const { blogUrl, limit, offset: offset2, sortBy: sortBy2, orderBy, levelIds, answers, from: from2, to } = params;
        return this.get({
            apiUrl: API_URL.POLL_UNSUB_REASONS_FETCH_VOTERS,
            url: getParametrizedUrl(API_URL.POLL_UNSUB_REASONS_FETCH_VOTERS, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                sort_by: sortBy2,
                order: orderBy,
                level_ids: levelIds,
                answers: answers,
                from: from2,
                to: to
            })
        });
    }
    async voteUnsubs(params) {
        return this.post({
            apiUrl: API_URL.POLL_UNSUB_REASONS_VOTE,
            url: API_URL.POLL_UNSUB_REASONS_VOTE,
            data: params
        });
    }
    async fetchPollVoters(blogUrl, pollId, params) {
        return this.get({
            apiUrl: API_URL.POLL_USER_GENERATED_FETCH_VOTERS,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_FETCH_VOTERS, {
                blogUrl: blogUrl,
                pollId: pollId
            }, {
                ...params
            })
        });
    }
    async createPoll(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.POLL_USER_GENERATED_CREATE,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async commitVote(pollId, params) {
        return this.post({
            apiUrl: API_URL.POLL_USER_GENERATED_VOTE,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_VOTE, {
                pollId: pollId
            }),
            data: params
        });
    }
    async retractVote(pollId) {
        return this.delete({
            apiUrl: API_URL.POLL_USER_GENERATED_VOTE,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_VOTE, {
                pollId: pollId
            })
        });
    }
    async fetchPoll(blogUrl, pollId, limit) {
        return this.get({
            apiUrl: API_URL.POLL_USER_GENERATED_POLL,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_POLL, {
                blogUrl: blogUrl,
                pollId: pollId
            }, {
                voters_limit: limit
            })
        });
    }
    async editPoll(blogUrl, pollId, params) {
        return this.put({
            apiUrl: API_URL.POLL_USER_GENERATED_POLL,
            url: getParametrizedUrl(API_URL.POLL_USER_GENERATED_POLL, {
                blogUrl: blogUrl,
                pollId: pollId
            }),
            data: params
        });
    }
}
class RatingProgramApi extends BaseApi {
    async fetchCurrentSeason(blogUrl) {
        return this.get({
            apiUrl: API_URL.RATING_PROGRAM_SEASON_CURRENT,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_SEASON_CURRENT, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchSeasonsHistory(blogUrl) {
        return this.get({
            apiUrl: API_URL.RATING_PROGRAM_SEASONS_HISTORY,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_SEASONS_HISTORY, {
                blogUrl: blogUrl
            })
        });
    }
    async dismissReachedLevelAlert(blogUrl) {
        return this.put({
            apiUrl: API_URL.RATING_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT, {
                blogUrl: blogUrl
            })
        });
    }
    async dismissSeasonFinishedAlert(blogUrl) {
        return this.put({
            apiUrl: API_URL.RATING_PROGRAM_SEASON_PREVIOUS_SEASON_FINISHED_ALERT_ACCEPT,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_SEASON_PREVIOUS_SEASON_FINISHED_ALERT_ACCEPT, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchDailyStat(blogUrl, seasonId, metricName) {
        return this.get({
            apiUrl: API_URL.RATING_PROGRAM_STAT_DAILY,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_STAT_DAILY, {
                blogUrl: blogUrl,
                seasonId: seasonId,
                metricName: metricName
            })
        });
    }
    async fetchVerificationState(blogUrl) {
        return this.get({
            apiUrl: API_URL.RATING_PROGRAM_VERIFICATION_STATE,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_VERIFICATION_STATE, {
                blogUrl: blogUrl
            })
        });
    }
    async sendVerificationRequest(blogUrl, name2, anotherCommunication) {
        return this.put({
            apiUrl: API_URL.RATING_PROGRAM_VERIFICATION_STATE,
            url: getParametrizedUrl(API_URL.RATING_PROGRAM_VERIFICATION_STATE, {
                blogUrl: blogUrl
            }),
            data: {
                full_name: name2,
                contact_info: anotherCommunication
            }
        });
    }
}
class RecordApi extends BaseApi {
    async fetchRecord({ blogUrl, recordId, getAbort }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            }),
            getAbort: getAbort
        });
    }
    async viewRecord(blogUrl, recordId) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_VIEW_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_VIEW_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async fetch(blogUrl, limit, offset2) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RECORDS,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RECORDS, {
                blogUrl: blogUrl
            }, {
                limit: limit || 100,
                offset: offset2
            })
        });
    }
    async deleteRecord(blogUrl, recordId, reason2) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            }),
            data: {
                reason: reason2
            }
        });
    }
    async likeRecord(blogUrl, recordId) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_LIKE_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_LIKE_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async unlikeRecord(blogUrl, recordId) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_LIKE_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_LIKE_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async hideRecord(blogUrl, recordId) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async removeRecordFromHidden(blogUrl, recordId) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async uploadRecordPreview(blogUrl, recordId, file) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_UPLOAD_RECORD_PREVIEW,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_UPLOAD_RECORD_PREVIEW, {
                blogUrl: blogUrl,
                recordId: recordId
            }),
            isNoProcessData: true,
            data: file
        });
    }
    async removeRecordPreview(blogUrl, recordId) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_UPLOAD_RECORD_PREVIEW,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_UPLOAD_RECORD_PREVIEW, {
                blogUrl: blogUrl,
                recordId: recordId
            })
        });
    }
    async editRecord(blogUrl, recordId, categoryId, subscriptionLevelId, titleData) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_RECORD,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RECORD, {
                blogUrl: blogUrl,
                recordId: recordId
            }),
            data: {
                category_id: categoryId,
                subscription_level_id: subscriptionLevelId,
                title_data: JSON.stringify(titleData)
            }
        });
    }
    async fetchRecordChat(blogUrl, recordId, additionalParams) {
        return this.get({
            apiUrl: API_URL.STREAM_RECORD_CHAT,
            url: getParametrizedUrl(API_URL.STREAM_RECORD_CHAT, {
                blogUrl: blogUrl,
                recordId: recordId
            }, {
                time_code: additionalParams == null ? void 0 : additionalParams.timeCode,
                last_message_id: additionalParams == null ? void 0 : additionalParams.lastMessageId,
                limit: additionalParams == null ? void 0 : additionalParams.limit,
                offset: additionalParams == null ? void 0 : additionalParams.offset
            })
        });
    }
}
var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1$ = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root$1$.Symbol;
var objectProto$f = Object.prototype;
var hasOwnProperty$b = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value2) {
    var isOwn = hasOwnProperty$b.call(value2, symToStringTag$1), tag = value2[symToStringTag$1];
    try {
        value2[symToStringTag$1] = void 0;
        var unmasked = true;
    } catch (e2) {}
    var result2 = nativeObjectToString$1.call(value2);
    if (unmasked) {
        if (isOwn) value2[symToStringTag$1] = tag;
        else delete value2[symToStringTag$1];
    }
    return result2;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString$1(value2) {
    return nativeObjectToString.call(value2);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value2) {
    if (value2 == null) return value2 === void 0 ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString$1(value2);
}
function isObjectLike$1(value2) {
    return value2 != null && typeof value2 == "object";
}
var symbolTag$2 = "[object Symbol]";
function isSymbol$2(value2) {
    return typeof value2 == "symbol" || isObjectLike$1(value2) && baseGetTag(value2) == symbolTag$2;
}
function arrayMap(array, iteratee) {
    var index2 = -1, length = array == null ? 0 : array.length, result2 = Array(length);
    while(++index2 < length)result2[index2] = iteratee(array[index2], index2, array);
    return result2;
}
var isArray = Array.isArray;
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value2) {
    if (typeof value2 == "string") return value2;
    if (isArray(value2)) return arrayMap(value2, baseToString) + "";
    if (isSymbol$2(value2)) return symbolToString ? symbolToString.call(value2) : "";
    var result2 = value2 + "";
    return result2 == "0" && 1 / value2 == -Infinity ? "-0" : result2;
}
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
    var index2 = string.length;
    while(index2-- && reWhitespace.test(string.charAt(index2)));
    return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
function isObject$2(value2) {
    var type = typeof value2;
    return value2 != null && (type == "object" || type == "function");
}
var NAN$1 = 0 / 0;
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary$1 = /^0b[01]+$/i;
var reIsOctal$1 = /^0o[0-7]+$/i;
var freeParseInt$1 = parseInt;
function toNumber$1(value2) {
    if (typeof value2 == "number") return value2;
    if (isSymbol$2(value2)) return NAN$1;
    if (isObject$2(value2)) {
        var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
        value2 = isObject$2(other) ? other + "" : other;
    }
    if (typeof value2 != "string") return value2 === 0 ? value2 : +value2;
    value2 = baseTrim(value2);
    var isBinary = reIsBinary$1.test(value2);
    return isBinary || reIsOctal$1.test(value2) ? freeParseInt$1(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value2) ? NAN$1 : +value2;
}
function identity(value2) {
    return value2;
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(value2) {
    if (!isObject$2(value2)) return false;
    var tag = baseGetTag(value2);
    return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1$["__core-js_shared__"];
var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
    if (func != null) {
        try {
            return funcToString$2.call(func);
        } catch (e2) {}
        try {
            return func + "";
        } catch (e2) {}
    }
    return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$a = objectProto$d.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value2) {
    if (!isObject$2(value2) || isMasked(value2)) return false;
    var pattern = isFunction$3(value2) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value2));
}
function getValue(object2, key) {
    return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
    var value2 = getValue(object2, key);
    return baseIsNative(value2) ? value2 : void 0;
}
var WeakMap$1 = getNative(root$1$, "WeakMap");
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
    function object2() {}
    return function(proto) {
        if (!isObject$2(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object2.prototype = proto;
        var result2 = new object2();
        object2.prototype = void 0;
        return result2;
    };
}();
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
function noop$1() {}
function copyArray(source, array) {
    var index2 = -1, length = source.length;
    array || (array = Array(length));
    while(++index2 < length)array[index2] = source[index2];
    return array;
}
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
    var count2 = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count2 >= HOT_COUNT) return arguments[0];
        } else count2 = 0;
        return func.apply(void 0, arguments);
    };
}
function constant(value2) {
    return function() {
        return value2;
    };
}
var defineProperty$1 = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e2) {}
}();
var baseSetToString = !defineProperty$1 ? identity : function(func, string) {
    return defineProperty$1(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
var setToString = shortOut(baseSetToString);
function baseFindIndex(array, predicate2, fromIndex, fromRight) {
    var length = array.length, index2 = fromIndex + -1;
    while(++index2 < length){
        if (predicate2(array[index2], index2, array)) return index2;
    }
    return -1;
}
function baseIsNaN(value2) {
    return value2 !== value2;
}
function strictIndexOf(array, value2, fromIndex) {
    var index2 = fromIndex - 1, length = array.length;
    while(++index2 < length){
        if (array[index2] === value2) return index2;
    }
    return -1;
}
function baseIndexOf(array, value2, fromIndex) {
    return value2 === value2 ? strictIndexOf(array, value2, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
function arrayIncludes(array, value2) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value2, 0) > -1;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value2, length) {
    var type = typeof value2;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value2)) && value2 > -1 && value2 % 1 == 0 && value2 < length;
}
function baseAssignValue(object2, key, value2) {
    if (key == "__proto__" && defineProperty$1) defineProperty$1(object2, key, {
        "configurable": true,
        "enumerable": true,
        "value": value2,
        "writable": true
    });
    else object2[key] = value2;
}
function eq(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
}
var objectProto$c = Object.prototype;
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
function assignValue(object2, key, value2) {
    var objValue = object2[key];
    if (!(hasOwnProperty$9.call(object2, key) && eq(objValue, value2)) || value2 === void 0 && !(key in object2)) baseAssignValue(object2, key, value2);
}
function copyObject(source, props, object2, customizer) {
    var isNew = !object2;
    object2 || (object2 = {});
    var index2 = -1, length = props.length;
    while(++index2 < length){
        var key = props[index2];
        var newValue = void 0;
        if (newValue === void 0) newValue = source[key];
        if (isNew) baseAssignValue(object2, key, newValue);
        else assignValue(object2, key, newValue);
    }
    return object2;
}
var nativeMax$1 = Math.max;
function overRest(func, start, transform2) {
    start = nativeMax$1(start === void 0 ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index2 = -1, length = nativeMax$1(args.length - start, 0), array = Array(length);
        while(++index2 < length)array[index2] = args[start + index2];
        index2 = -1;
        var otherArgs = Array(start + 1);
        while(++index2 < start)otherArgs[index2] = args[index2];
        otherArgs[start] = transform2(array);
        return apply(func, this, otherArgs);
    };
}
function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$1(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
}
function isArrayLike(value2) {
    return value2 != null && isLength$1(value2.length) && !isFunction$3(value2);
}
function isIterateeCall(value2, index2, object2) {
    if (!isObject$2(object2)) return false;
    var type = typeof index2;
    if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) return eq(object2[index2], value2);
    return false;
}
function createAssigner(assigner) {
    return baseRest(function(object2, sources) {
        var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? void 0 : customizer;
            length = 1;
        }
        object2 = Object(object2);
        while(++index2 < length){
            var source = sources[index2];
            if (source) assigner(object2, source, index2, customizer);
        }
        return object2;
    });
}
var objectProto$b = Object.prototype;
function isPrototype(value2) {
    var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$b;
    return value2 === proto;
}
function baseTimes(n2, iteratee) {
    var index2 = -1, result2 = Array(n2);
    while(++index2 < n2)result2[index2] = iteratee(index2);
    return result2;
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value2) {
    return isObjectLike$1(value2) && baseGetTag(value2) == argsTag$2;
}
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;
var isArguments$1 = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
}()) ? baseIsArguments : function(value2) {
    return isObjectLike$1(value2) && hasOwnProperty$8.call(value2, "callee") && !propertyIsEnumerable$1.call(value2, "callee");
};
function stubFalse() {
    return false;
}
var freeExports$2 = exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && true && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$2 = moduleExports$2 ? root$1$.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$3] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$3] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value2) {
    return isObjectLike$1(value2) && isLength$1(value2.length) && !!typedArrayTags[baseGetTag(value2)];
}
function baseUnary(func) {
    return function(value2) {
        return func(value2);
    };
}
var freeExports$1 = exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && true && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = function() {
    try {
        var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
        if (types2) return types2;
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {}
}();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function arrayLikeKeys(value2, inherited) {
    var isArr = isArray(value2), isArg = !isArr && isArguments$1(value2), isBuff = !isArr && !isArg && isBuffer(value2), isType = !isArr && !isArg && !isBuff && isTypedArray(value2), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value2.length, String) : [], length = result2.length;
    for(var key in value2)if ((inherited || hasOwnProperty$7.call(value2, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result2.push(key);
    return result2;
}
function overArg(func, transform2) {
    return function(arg) {
        return func(transform2(arg));
    };
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function baseKeys(object2) {
    if (!isPrototype(object2)) return nativeKeys(object2);
    var result2 = [];
    for(var key in Object(object2))if (hasOwnProperty$6.call(object2, key) && key != "constructor") result2.push(key);
    return result2;
}
function keys$1(object2) {
    return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function nativeKeysIn(object2) {
    var result2 = [];
    if (object2 != null) for(var key in Object(object2))result2.push(key);
    return result2;
}
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function baseKeysIn(object2) {
    if (!isObject$2(object2)) return nativeKeysIn(object2);
    var isProto = isPrototype(object2), result2 = [];
    for(var key in object2)if (!(key == "constructor" && (isProto || !hasOwnProperty$5.call(object2, key)))) result2.push(key);
    return result2;
}
function keysIn(object2) {
    return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value2, object2) {
    if (isArray(value2)) return false;
    var type = typeof value2;
    if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol$2(value2)) return true;
    return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object2 != null && value2 in Object(object2);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
function hashDelete(key) {
    var result2 = this.has(key) && delete this.__data__[key];
    this.size -= result2 ? 1 : 0;
    return result2;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$6 = Object.prototype;
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result2 = data[key];
        return result2 === HASH_UNDEFINED$2 ? void 0 : result2;
    }
    return hasOwnProperty$4.call(data, key) ? data[key] : void 0;
}
var objectProto$5 = Object.prototype;
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;
function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty$3.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value2) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED$1 : value2;
    return this;
}
function Hash(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index2 < length){
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
    }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) return false;
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) data.pop();
    else splice.call(data, index2, 1);
    --this.size;
    return true;
}
function listCacheGet(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value2) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
        ++this.size;
        data.push([
            key,
            value2
        ]);
    } else data[index2][1] = value2;
    return this;
}
function ListCache(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index2 < length){
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
    }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$1$, "Map");
function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash(),
        "map": new (Map$1 || ListCache)(),
        "string": new Hash()
    };
}
function isKeyable(value2) {
    var type = typeof value2;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
    var result2 = getMapData(this, key)["delete"](key);
    this.size -= result2 ? 1 : 0;
    return result2;
}
function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
function mapCacheSet(key, value2) {
    var data = getMapData(this, key), size2 = data.size;
    data.set(key, value2);
    this.size += data.size == size2 ? 0 : 1;
    return this;
}
function MapCache(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index2 < length){
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
    }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$3 = "Expected a function";
function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT$3);
    var memoized2 = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized2.cache;
        if (cache.has(key)) return cache.get(key);
        var result2 = func.apply(this, args);
        memoized2.cache = cache.set(key, result2) || cache;
        return result2;
    };
    memoized2.cache = new (memoize.Cache || MapCache)();
    return memoized2;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
    var result2 = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result2.cache;
    return result2;
}
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
    var result2 = [];
    if (string.charCodeAt(0) === 46) result2.push("");
    string.replace(rePropName$1, function(match2, number, quote, subString) {
        result2.push(quote ? subString.replace(reEscapeChar$1, "$1") : number || match2);
    });
    return result2;
});
function toString(value2) {
    return value2 == null ? "" : baseToString(value2);
}
function castPath(value2, object2) {
    if (isArray(value2)) return value2;
    return isKey(value2, object2) ? [
        value2
    ] : stringToPath$1(toString(value2));
}
function toKey(value2) {
    if (typeof value2 == "string" || isSymbol$2(value2)) return value2;
    var result2 = value2 + "";
    return result2 == "0" && 1 / value2 == -Infinity ? "-0" : result2;
}
function baseGet(object2, path2) {
    path2 = castPath(path2, object2);
    var index2 = 0, length = path2.length;
    while(object2 != null && index2 < length)object2 = object2[toKey(path2[index2++])];
    return index2 && index2 == length ? object2 : void 0;
}
function get(object2, path2, defaultValue) {
    var result2 = object2 == null ? void 0 : baseGet(object2, path2);
    return result2 === void 0 ? defaultValue : result2;
}
function arrayPush(array, values2) {
    var index2 = -1, length = values2.length, offset2 = array.length;
    while(++index2 < length)array[offset2 + index2] = values2[index2];
    return array;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(value2) {
    return isArray(value2) || isArguments$1(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
}
function baseFlatten(array, depth, predicate2, isStrict, result2) {
    var index2 = -1, length = array.length;
    predicate2 || (predicate2 = isFlattenable);
    result2 || (result2 = []);
    while(++index2 < length){
        var value2 = array[index2];
        if (predicate2(value2)) arrayPush(result2, value2);
        else if (!isStrict) result2[result2.length] = value2;
    }
    return result2;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectTag$2 = "[object Object]";
var funcProto = Function.prototype, objectProto$4 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$2(value2) {
    if (!isObjectLike$1(value2) || baseGetTag(value2) != objectTag$2) return false;
    var proto = getPrototype(value2);
    if (proto === null) return true;
    var Ctor = hasOwnProperty$2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsZWJ$1 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode(string) {
    return reHasUnicode.test(string);
}
function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
}
function stackDelete(key) {
    var data = this.__data__, result2 = data["delete"](key);
    this.size = data.size;
    return result2;
}
function stackGet(key) {
    return this.__data__.get(key);
}
function stackHas(key) {
    return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE$2 = 200;
function stackSet(key, value2) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
            pairs.push([
                key,
                value2
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value2);
    this.size = data.size;
    return this;
}
function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var freeExports = exports && !exports.nodeType && exports;
var freeModule = freeExports && true && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$1 = moduleExports ? root$1$.Buffer : void 0;
Buffer$1 && Buffer$1.allocUnsafe;
function cloneBuffer(buffer, isDeep) {
    return buffer.slice();
}
function arrayFilter(array, predicate2) {
    var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while(++index2 < length){
        var value2 = array[index2];
        if (predicate2(value2, index2, array)) result2[resIndex++] = value2;
    }
    return result2;
}
function stubArray() {
    return [];
}
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
    if (object2 == null) return [];
    object2 = Object(object2);
    return arrayFilter(nativeGetSymbols(object2), function(symbol) {
        return propertyIsEnumerable.call(object2, symbol);
    });
};
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
    var result2 = keysFunc(object2);
    return isArray(object2) ? result2 : arrayPush(result2, symbolsFunc(object2));
}
function getAllKeys(object2) {
    return baseGetAllKeys(object2, keys$1, getSymbols);
}
var DataView$1 = getNative(root$1$, "DataView");
var Promise$1 = getNative(root$1$, "Promise");
var Set$1 = getNative(root$1$, "Set");
var mapTag$2 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$2 = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$1 || Map$1 && getTag(new Map$1()) != mapTag$2 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$2 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) getTag = function(value2) {
    var result2 = baseGetTag(value2), Ctor = result2 == objectTag$1 ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag$1;
        case mapCtorString:
            return mapTag$2;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag$2;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result2;
};
var Uint8Array$1 = root$1$.Uint8Array;
function cloneArrayBuffer(arrayBuffer) {
    var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array$1(result2).set(new Uint8Array$1(arrayBuffer));
    return result2;
}
function cloneTypedArray(typedArray, isDeep) {
    var buffer = cloneArrayBuffer(typedArray.buffer);
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
function initCloneObject(object2) {
    return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value2) {
    this.__data__.set(value2, HASH_UNDEFINED);
    return this;
}
function setCacheHas(value2) {
    return this.__data__.has(value2);
}
function SetCache(values2) {
    var index2 = -1, length = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache();
    while(++index2 < length)this.add(values2[index2]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate2) {
    var index2 = -1, length = array == null ? 0 : array.length;
    while(++index2 < length){
        if (predicate2(array[index2], index2, array)) return true;
    }
    return false;
}
function cacheHas(cache, key) {
    return cache.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while(++index2 < arrLength){
        var arrValue = array[index2], othValue = other[index2];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
        if (compared !== void 0) {
            if (compared) continue;
            result2 = false;
            break;
        }
        if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result2 = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result2;
}
function mapToArray(map) {
    var index2 = -1, result2 = Array(map.size);
    map.forEach(function(value2, key) {
        result2[++index2] = [
            key,
            value2
        ];
    });
    return result2;
}
function setToArray(set2) {
    var index2 = -1, result2 = Array(set2.size);
    set2.forEach(function(value2) {
        result2[++index2] = value2;
    });
    return result2;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) return false;
            object2 = object2.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag$1:
            return eq(+object2, +other);
        case errorTag:
            return object2.name == other.name && object2.message == other.message;
        case regexpTag:
        case stringTag$1:
            return object2 == other + "";
        case mapTag$1:
            var convert = mapToArray;
        case setTag$1:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
            convert || (convert = setToArray);
            if (object2.size != other.size && !isPartial) return false;
            var stacked = stack.get(object2);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG$2;
            stack.set(object2, other);
            var result2 = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object2);
            return result2;
        case symbolTag$1:
            if (symbolValueOf) return symbolValueOf.call(object2) == symbolValueOf.call(other);
    }
    return false;
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index2 = objLength;
    while(index2--){
        var key = objProps[index2];
        if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) return false;
    }
    var objStacked = stack.get(object2);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object2;
    var result2 = true;
    stack.set(object2, other);
    stack.set(other, object2);
    var skipCtor = isPartial;
    while(++index2 < objLength){
        key = objProps[index2];
        var objValue = object2[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result2 && !skipCtor) {
        var objCtor = object2.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result2 = false;
    }
    stack["delete"](object2);
    stack["delete"](other);
    return result2;
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object2)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack());
    return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value2, other, bitmask, customizer, stack) {
    if (value2 === other) return true;
    if (value2 == null || other == null || !isObjectLike$1(value2) && !isObjectLike$1(other)) return value2 !== value2 && other !== other;
    return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer) {
    var index2 = matchData.length, length = index2;
    if (object2 == null) return !length;
    object2 = Object(object2);
    while(index2--){
        var data = matchData[index2];
        if (data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) return false;
    }
    while(++index2 < length){
        data = matchData[index2];
        var key = data[0], objValue = object2[key], srcValue = data[1];
        if (data[2]) {
            if (objValue === void 0 && !(key in object2)) return false;
        } else {
            var stack = new Stack();
            var result2;
            if (!(result2 === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result2)) return false;
        }
    }
    return true;
}
function isStrictComparable(value2) {
    return value2 === value2 && !isObject$2(value2);
}
function getMatchData(object2) {
    var result2 = keys$1(object2), length = result2.length;
    while(length--){
        var key = result2[length], value2 = object2[key];
        result2[length] = [
            key,
            value2,
            isStrictComparable(value2)
        ];
    }
    return result2;
}
function matchesStrictComparable(key, srcValue) {
    return function(object2) {
        if (object2 == null) return false;
        return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
    };
}
function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object2) {
        return object2 === source || baseIsMatch(object2, source, matchData);
    };
}
function baseHasIn(object2, key) {
    return object2 != null && key in Object(object2);
}
function hasPath(object2, path2, hasFunc) {
    path2 = castPath(path2, object2);
    var index2 = -1, length = path2.length, result2 = false;
    while(++index2 < length){
        var key = toKey(path2[index2]);
        if (!(result2 = object2 != null && hasFunc(object2, key))) break;
        object2 = object2[key];
    }
    if (result2 || ++index2 != length) return result2;
    length = object2 == null ? 0 : object2.length;
    return !!length && isLength$1(length) && isIndex(key, length) && (isArray(object2) || isArguments$1(object2));
}
function hasIn(object2, path2) {
    return object2 != null && hasPath(object2, path2, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path2, srcValue) {
    if (isKey(path2) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path2), srcValue);
    return function(object2) {
        var objValue = get(object2, path2);
        return objValue === void 0 && objValue === srcValue ? hasIn(object2, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
function baseProperty(key) {
    return function(object2) {
        return object2 == null ? void 0 : object2[key];
    };
}
function basePropertyDeep(path2) {
    return function(object2) {
        return baseGet(object2, path2);
    };
}
function property(path2) {
    return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
}
function baseIteratee(value2) {
    if (typeof value2 == "function") return value2;
    if (value2 == null) return identity;
    if (typeof value2 == "object") return isArray(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
    return property(value2);
}
function createBaseFor(fromRight) {
    return function(object2, iteratee, keysFunc) {
        var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
        while(length--){
            var key = props[++index2];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object2;
    };
}
var baseFor = createBaseFor();
function baseForOwn(object2, iteratee) {
    return object2 && baseFor(object2, iteratee, keys$1);
}
function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index2 = -1, iterable = Object(collection);
        while(++index2 < length){
            if (iteratee(iterable[index2], index2, iterable) === false) break;
        }
        return collection;
    };
}
var baseEach = createBaseEach(baseForOwn);
var now = function() {
    return root$1$.Date.now();
};
var FUNC_ERROR_TEXT$2 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result2, timerId2, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT$2);
    wait = toNumber$1(wait) || 0;
    if (isObject$2(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber$1(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time2) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time2;
        result2 = func.apply(thisArg, args);
        return result2;
    }
    function leadingEdge(time2) {
        lastInvokeTime = time2;
        timerId2 = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time2) : result2;
    }
    function remainingWait(time2) {
        var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time2) {
        var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time2 = now();
        if (shouldInvoke(time2)) return trailingEdge(time2);
        timerId2 = setTimeout(timerExpired, remainingWait(time2));
    }
    function trailingEdge(time2) {
        timerId2 = void 0;
        if (trailing && lastArgs) return invokeFunc(time2);
        lastArgs = lastThis = void 0;
        return result2;
    }
    function cancel() {
        if (timerId2 !== void 0) clearTimeout(timerId2);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId2 = void 0;
    }
    function flush() {
        return timerId2 === void 0 ? result2 : trailingEdge(now());
    }
    function debounced() {
        var time2 = now(), isInvoking = shouldInvoke(time2);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time2;
        if (isInvoking) {
            if (timerId2 === void 0) return leadingEdge(lastCallTime);
            if (maxing) {
                clearTimeout(timerId2);
                timerId2 = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId2 === void 0) timerId2 = setTimeout(timerExpired, wait);
        return result2;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
function assignMergeValue(object2, key, value2) {
    if (value2 !== void 0 && !eq(object2[key], value2) || value2 === void 0 && !(key in object2)) baseAssignValue(object2, key, value2);
}
function isArrayLikeObject(value2) {
    return isObjectLike$1(value2) && isArrayLike(value2);
}
function safeGet(object2, key) {
    if (key === "constructor" && typeof object2[key] === "function") return;
    if (key == "__proto__") return;
    return object2[key];
}
function toPlainObject(value2) {
    return copyObject(value2, keysIn(value2));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object2, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue);
            } else newValue = [];
        } else if (isPlainObject$2(srcValue) || isArguments$1(srcValue)) {
            newValue = objValue;
            if (isArguments$1(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject$2(objValue) || isFunction$3(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack) {
    if (object2 === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject$2(srcValue)) baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack) : void 0;
            if (newValue === void 0) newValue = srcValue;
            assignMergeValue(object2, key, newValue);
        }
    }, keysIn);
}
function arrayIncludesWith(array, value2, comparator) {
    var index2 = -1, length = array == null ? 0 : array.length;
    while(++index2 < length){
        if (comparator(value2, array[index2])) return true;
    }
    return false;
}
var LARGE_ARRAY_SIZE$1 = 200;
function baseDifference(array, values2, iteratee, comparator) {
    var index2 = -1, includes = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
    if (!length) return result2;
    if (iteratee) values2 = arrayMap(values2, baseUnary(iteratee));
    if (values2.length >= LARGE_ARRAY_SIZE$1) {
        includes = cacheHas;
        isCommon = false;
        values2 = new SetCache(values2);
    }
    outer: while(++index2 < length){
        var value2 = array[index2], computed = iteratee == null ? value2 : iteratee(value2);
        value2 = value2 !== 0 ? value2 : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values2[valuesIndex] === computed) continue outer;
            }
            result2.push(value2);
        } else if (!includes(values2, computed, comparator)) result2.push(value2);
    }
    return result2;
}
var difference = baseRest(function(array, values2) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
});
function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
var differenceBy = baseRest(function(array, values2) {
    var iteratee = last(values2);
    if (isArrayLikeObject(iteratee)) iteratee = void 0;
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), baseIteratee(iteratee)) : [];
});
function head$3(array) {
    return array && array.length ? array[0] : void 0;
}
function baseMap(collection, iteratee) {
    var index2 = -1, result2 = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value2, key, collection2) {
        result2[++index2] = iteratee(value2, key, collection2);
    });
    return result2;
}
var stringTag = "[object String]";
function isString(value2) {
    return typeof value2 == "string" || !isArray(value2) && isObjectLike$1(value2) && baseGetTag(value2) == stringTag;
}
function isEqual(value2, other) {
    return baseIsEqual(value2, other);
}
var numberTag = "[object Number]";
function isNumber(value2) {
    return typeof value2 == "number" || isObjectLike$1(value2) && baseGetTag(value2) == numberTag;
}
function isNil(value2) {
    return value2 == null;
}
var merge$1 = createAssigner(function(object2, source, srcIndex) {
    baseMerge(object2, source, srcIndex);
});
function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
function compareAscending(value2, other) {
    if (value2 !== other) {
        var valIsDefined = value2 !== void 0, valIsNull = value2 === null, valIsReflexive = value2 === value2, valIsSymbol = isSymbol$2(value2);
        var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$2(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value2 > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value2 < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
function compareMultiple(object2, other, orders) {
    var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index2 < length){
        var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
        if (result2) {
            if (index2 >= ordersLength) return result2;
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
        }
    }
    return object2.index - other.index;
}
function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value2) {
            return baseGet(value2, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index2 = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result2 = baseMap(collection, function(value2, key, collection2) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value2);
        });
        return {
            "criteria": criteria,
            "index": ++index2,
            "value": value2
        };
    });
    return baseSortBy(result2, function(object2, other) {
        return compareMultiple(object2, other, orders);
    });
}
var asciiSize = baseProperty("length");
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeSize(string) {
    var result2 = reUnicode.lastIndex = 0;
    while(reUnicode.test(string))++result2;
    return result2;
}
function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
var mapTag = "[object Map]", setTag = "[object Set]";
function size$3(collection) {
    if (collection == null) return 0;
    if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
    var tag = getTag(collection);
    if (tag == mapTag || tag == setTag) return collection.size;
    return baseKeys(collection).length;
}
var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees), []);
});
var FUNC_ERROR_TEXT$1 = "Expected a function";
function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT$1);
    if (isObject$2(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
function toPath(value2) {
    if (isArray(value2)) return arrayMap(value2, toKey);
    return isSymbol$2(value2) ? [
        value2
    ] : copyArray(stringToPath$1(toString(value2)));
}
var INFINITY$1 = 1 / 0;
var createSet = !(Set$1 && 1 / setToArray(new Set$1([
    ,
    -0
]))[1] == INFINITY$1) ? noop$1 : function(values2) {
    return new Set$1(values2);
};
var LARGE_ARRAY_SIZE = 200;
function baseUniq(array, iteratee, comparator) {
    var index2 = -1, includes = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set2 = iteratee ? null : createSet(array);
        if (set2) return setToArray(set2);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache();
    } else seen = iteratee ? [] : result2;
    outer: while(++index2 < length){
        var value2 = array[index2], computed = iteratee ? iteratee(value2) : value2;
        value2 = comparator || value2 !== 0 ? value2 : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result2.push(value2);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result2) seen.push(computed);
            result2.push(value2);
        }
    }
    return result2;
}
var unionWith = baseRest(function(arrays) {
    var comparator = last(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), void 0, comparator);
});
function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}
var idCounter = 0;
function uniqueId(prefix2) {
    var id = ++idCounter;
    return toString(prefix2) + id;
}
const isEmpty = (value2)=>{
    if (typeof value2 === "string") return value2.length === 0;
    return isNil(value2);
};
const prepare = (params)=>({
        ...isEmpty(params.bgcolor) ? {} : {
            bgcolor: params.bgcolor
        },
        description: params.description,
        large_image_id: params.large_image_id,
        medium_image_id: params.medium_image_id,
        name: params.name,
        ...isEmpty(params.price) ? {} : {
            price: params.price
        },
        small_image_id: params.small_image_id,
        ...isNil(params.is_text_required) ? {} : {
            is_text_required: params.is_text_required
        },
        max_uses_number_per_user: params.max_uses_number_per_user,
        max_uses_number: params.max_uses_number,
        repair_timeout: params.repair_timeout,
        repair_timeout_per_user: params.repair_timeout_per_user,
        is_autoapproved: params.is_autoapproved,
        is_hidden_text: params.is_hidden_text,
        is_unlimited: params.is_unlimited
    });
class RewardApi extends BaseApi {
    async fetchRewards(blogUrl) {
        return this.get({
            apiUrl: API_URL.REWARD_LIST,
            url: getParametrizedUrl(API_URL.REWARD_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchRewardById(blogUrl, id) {
        return this.get({
            apiUrl: API_URL.REWARD_ID,
            url: getParametrizedUrl(API_URL.REWARD_ID, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async fetchOwnRewards(blogUrl) {
        return this.get({
            apiUrl: API_URL.OWN_REWARD_LIST,
            url: getParametrizedUrl(API_URL.OWN_REWARD_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async uploadImageOwnReward(blogUrl, size2, file) {
        return this.put({
            apiUrl: API_URL.OWN_REWARD_IMAGE,
            url: getParametrizedUrl(API_URL.OWN_REWARD_IMAGE, {
                blogUrl: blogUrl,
                size: size2
            }),
            data: file,
            isNoProcessData: true
        });
    }
    async createOwnReward(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.OWN_REWARD,
            url: getParametrizedUrl(API_URL.OWN_REWARD, {
                blogUrl: blogUrl
            }),
            data: prepare(params)
        });
    }
    async updateOwnReward(blogUrl, id, params) {
        return this.put({
            apiUrl: API_URL.OWN_REWARD_ID,
            url: getParametrizedUrl(API_URL.OWN_REWARD_ID, {
                blogUrl: blogUrl,
                id: id
            }),
            data: prepare(params)
        });
    }
    async deleteOwnReward(blogUrl, id) {
        return this.delete({
            apiUrl: API_URL.OWN_REWARD_ID,
            url: getParametrizedUrl(API_URL.OWN_REWARD_ID, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async enableReward(blogUrl, id) {
        return this.put({
            apiUrl: API_URL.REWARD_ENABLED,
            url: getParametrizedUrl(API_URL.REWARD_ENABLED, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async disableReward(blogUrl, id) {
        return this.delete({
            apiUrl: API_URL.REWARD_ENABLED,
            url: getParametrizedUrl(API_URL.REWARD_ENABLED, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async fetchStandardRewards(blogUrl) {
        return this.get({
            apiUrl: API_URL.STANDARD_REWARD_LIST,
            url: getParametrizedUrl(API_URL.STANDARD_REWARD_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async updateStandardReward(blogUrl, id, params) {
        return this.put({
            apiUrl: API_URL.STANDARD_REWARD_ID,
            url: getParametrizedUrl(API_URL.STANDARD_REWARD_ID, {
                blogUrl: blogUrl,
                id: id
            }),
            data: params
        });
    }
}
class RewardManagerApi extends BaseApi {
    async fetchRewardById(blogUrl, id) {
        return this.get({
            apiUrl: API_URL.REWARD_MANAGER_ACTION_DEMAND_BY_ID,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_ACTION_DEMAND_BY_ID, {
                blogUrl: blogUrl,
                id: id
            })
        });
    }
    async fetchFilter(blogUrl) {
        return this.get({
            apiUrl: API_URL.REWARD_MANAGER_FILTER,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_FILTER, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchRewardRequestsList(blogUrl, rewardId, limit, offset2) {
        return this.get({
            apiUrl: API_URL.REWARD_MANAGER_DEMAND_LIST,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_DEMAND_LIST, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                ...rewardId ? {
                    reward_id: rewardId
                } : {}
            })
        });
    }
    async rejectAllDemands(blogUrl, rewardId) {
        return this.delete({
            apiUrl: API_URL.REWARD_MANAGER_ACTION_ALL_DEMANDS,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_ACTION_ALL_DEMANDS, {
                blogUrl: blogUrl
            }, {
                ...rewardId ? {
                    reward_id: rewardId
                } : {}
            })
        });
    }
    async fulfillAllDemands(blogUrl, rewardId) {
        return this.put({
            apiUrl: API_URL.REWARD_MANAGER_ACTION_ALL_DEMANDS,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_ACTION_ALL_DEMANDS, {
                blogUrl: blogUrl
            }, {
                ...rewardId ? {
                    reward_id: rewardId
                } : {}
            })
        });
    }
    async fulfillDemandsBulk(blogUrl, demandIds) {
        return this.put({
            apiUrl: API_URL.REWARD_MANAGER_ACTION_DEMAND,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_ACTION_DEMAND, {
                blogUrl: blogUrl
            }),
            data: {
                demand_ids: demandIds
            }
        });
    }
    async rejectDemandsBulk(blogUrl, demandIds) {
        return this.delete({
            apiUrl: API_URL.REWARD_MANAGER_ACTION_DEMAND,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_ACTION_DEMAND, {
                blogUrl: blogUrl
            }),
            data: {
                demand_ids: demandIds
            }
        });
    }
    async enableReward(blogUrl, rewardId) {
        return this.put({
            apiUrl: API_URL.REWARD_MANAGER_REWARD_AVAILABILITY,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_REWARD_AVAILABILITY, {
                blogUrl: blogUrl,
                rewardId: rewardId
            })
        });
    }
    async disableReward(blogUrl, rewardId) {
        return this.delete({
            apiUrl: API_URL.REWARD_MANAGER_REWARD_AVAILABILITY,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_REWARD_AVAILABILITY, {
                blogUrl: blogUrl,
                rewardId: rewardId
            })
        });
    }
    async fetchCsv(blogUrl, rewardId) {
        return this.get({
            apiUrl: API_URL.REWARD_MANAGER_REWARD_CSV,
            url: dist$4.getParametrizedUrl(API_URL.REWARD_MANAGER_REWARD_CSV, {
                blogUrl: blogUrl
            }, {
                ...rewardId ? {
                    reward_id: rewardId
                } : {}
            }),
            responseType: "blob"
        });
    }
}
class RoleApi extends BaseApi {
    async fetchListRoles(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ROLE_LIST,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchListUsersWithRoles(blogUrl, { limit, offset: offset2, roleIds, nick: nick2 }) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ROLE_USER_SET,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_USER_SET, {
                blogUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                role_ids: roleIds,
                nick: nick2
            })
        });
    }
    async create(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.CHANNEL_ROLE_CREATE,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async update(blogUrl, roleId, params) {
        return this.put({
            apiUrl: API_URL.CHANNEL_ROLE,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE, {
                blogUrl: blogUrl,
                roleId: roleId
            }),
            data: params
        });
    }
    async uploadBadgeImage(blogUrl, sizeName, file) {
        return this.put({
            apiUrl: API_URL.CHANNEL_ROLE_IMAGE,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_IMAGE, {
                blogUrl: blogUrl,
                sizeName: sizeName
            }),
            data: file,
            isNoProcessData: true
        });
    }
    async remove(blogUrl, roleId) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_ROLE,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE, {
                blogUrl: blogUrl,
                roleId: roleId
            })
        });
    }
    async changeOrder(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.CHANNEL_ROLE_ORDER,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_ORDER, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async assign(blogUrl, userId, params) {
        return this.put({
            apiUrl: API_URL.CHANNEL_ROLE_USER,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_USER, {
                blogUrl: blogUrl,
                userId: userId
            }),
            data: params
        });
    }
    async removeRoles(blogUrl, userId) {
        return this.delete({
            apiUrl: API_URL.CHANNEL_ROLE_USER,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_USER, {
                blogUrl: blogUrl,
                userId: userId
            })
        });
    }
    async searchByUsers(blogUrl, chunk, limit) {
        return this.get({
            apiUrl: API_URL.CHANNEL_ROLE_USER_SEARCH,
            url: getParametrizedUrl(API_URL.CHANNEL_ROLE_USER_SEARCH, {
                blogUrl: blogUrl
            }, {
                chunk: chunk,
                limit: limit
            })
        });
    }
}
class SearchApi extends BaseApi {
    async searchBlog({ query, offset: offset2, limit, forRaid }) {
        return this.get({
            apiUrl: API_URL.SEARCH_BLOG,
            url: getParametrizedUrl(API_URL.SEARCH_BLOG, {}, {
                limit: limit,
                offset: offset2,
                search_query: query,
                for_raid: forRaid
            })
        });
    }
    async searchBlogSuggest({ query, offset: offset2, limit }) {
        return this.get({
            apiUrl: API_URL.SEARCH_BLOG_SUGGEST,
            url: getParametrizedUrl(API_URL.SEARCH_BLOG_SUGGEST, {}, {
                limit: limit,
                offset: offset2,
                search_query: query
            })
        });
    }
    async searchBlogPost({ blogUrl, query, filter, offset: offset2, limit }) {
        return this.get({
            apiUrl: API_URL.SEARCH_BLOG_POST,
            url: getParametrizedUrl(API_URL.SEARCH_BLOG_POST, {}, {
                blog_url: blogUrl,
                search_query: query,
                ...filter && {
                    only_allowed: filter == null ? void 0 : filter.isOnlyAllowedPosts,
                    subscription_level: filter == null ? void 0 : filter.subscriptionLevelId,
                    has_image: filter == null ? void 0 : filter.hasImage,
                    has_audio_file: filter == null ? void 0 : filter.hasAudioFile,
                    has_audio: filter == null ? void 0 : filter.hasAudio,
                    has_ok_video: filter == null ? void 0 : filter.hasVideoFile,
                    has_video: filter == null ? void 0 : filter.hasVideo,
                    has_file: filter == null ? void 0 : filter.hasFile,
                    from_ts: filter == null ? void 0 : filter.postsFrom,
                    to_ts: filter == null ? void 0 : filter.postsTo
                },
                limit: limit,
                offset: offset2
            })
        });
    }
    async searchUser({ searchQuery, limit }) {
        return this.get({
            apiUrl: API_URL.SEARCH_USER,
            url: getParametrizedUrl(API_URL.SEARCH_USER, {}, {
                search_query: searchQuery,
                limit: limit
            })
        });
    }
}
class SmileApi extends BaseApi {
    async fetchList(blogUrl) {
        return this.get({
            apiUrl: API_URL.SMILE_LIST,
            url: getParametrizedUrl(API_URL.SMILE_LIST, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchListByLevel(blogUrl, levelId) {
        return this.get({
            apiUrl: API_URL.SMILE_LIST_BY_LEVEL,
            url: getParametrizedUrl(API_URL.SMILE_LIST_BY_LEVEL, {
                blogUrl: blogUrl,
                levelId: levelId
            })
        });
    }
    async create(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.SMILE_CREATE,
            url: getParametrizedUrl(API_URL.SMILE_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async update(blogUrl, smileId, params) {
        return this.put({
            apiUrl: API_URL.SMILE,
            url: getParametrizedUrl(API_URL.SMILE, {
                blogUrl: blogUrl,
                smileId: smileId
            }),
            data: params
        });
    }
    async remove(blogUrl, smileId) {
        return this.delete({
            apiUrl: API_URL.SMILE,
            url: getParametrizedUrl(API_URL.SMILE, {
                blogUrl: blogUrl,
                smileId: smileId
            })
        });
    }
    async checkSmileName(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.SMILE_CHECK_NAME,
            url: getParametrizedUrl(API_URL.SMILE_CHECK_NAME, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async uploadImage(blogUrl, sizeName, file) {
        return this.post({
            apiUrl: API_URL.SMILE_IMAGE,
            url: getParametrizedUrl(API_URL.SMILE_IMAGE, {
                blogUrl: blogUrl,
                sizeName: sizeName
            }),
            data: file,
            isNoProcessData: true
        });
    }
    async fetchUserSet(blogUrl) {
        return this.get({
            apiUrl: API_URL.SMILE_USER_SET,
            url: getParametrizedUrl(API_URL.SMILE_USER_SET, {
                blogUrl: blogUrl
            }, {
                mode: this.getContext() === EApiContext.BOOSTY ? ESmileSetMode.BLOG : ESmileSetMode.PUBLIC_STREAM
            })
        });
    }
    async fetchUserSetPopular(blogUrl) {
        return this.get({
            apiUrl: API_URL.SMILE_USER_SET_POPULAR,
            url: getParametrizedUrl(API_URL.SMILE_USER_SET_POPULAR, {
                blogUrl: blogUrl
            })
        });
    }
    async changeOrder(blogUrl, levelId, params) {
        return this.put({
            apiUrl: API_URL.SMILE_ORDER,
            url: getParametrizedUrl(API_URL.SMILE_ORDER, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async fetchSmileData(smileId) {
        return this.get({
            apiUrl: API_URL.SMILE_DATA,
            url: getParametrizedUrl(API_URL.SMILE_DATA, {
                smileId: smileId
            })
        });
    }
}
const statsParamsApiToClientInfoRecord = (params)=>{
    const { clientId } = getConfig();
    return {
        /* eslint-disable camelcase */ app_id: getAppId(),
        from_id: clientId,
        referer: params.referer,
        referer_type: params.refererType,
        action: String(params.action),
        user_id: params.userId,
        email: params.email,
        blog_url: params.blogUrl,
        url: params.url,
        /* eslint-enable camelcase */ data0: params.data0,
        data1: params.data1,
        data2: params.data2,
        data3: params.data3,
        data4: params.data4,
        data5: params.data5,
        data6: params.data6,
        data7: params.data7,
        data8: params.data8,
        data9: params.data9
    };
};
class BaseStatApi extends BaseApi {
    async sendStat(params) {
        let data;
        if (Array.isArray(params)) data = params.map(statsParamsApiToClientInfoRecord);
        else data = statsParamsApiToClientInfoRecord(params);
        return this.post({
            apiUrl: API_URL.STAT,
            url: getParametrizedUrl(API_URL.STAT, {
                category: "ClientInfo"
            }),
            data: {
                data: JSON.stringify(data)
            }
        });
    }
}
class StatLogsApi extends BaseApi {
    async sendLogs(userId, message2) {
        return this.post({
            apiUrl: API_URL.STAT,
            url: getParametrizedUrl(API_URL.STAT, {
                category: "Logs"
            }),
            data: {
                data: JSON.stringify({
                    type: "logs",
                    user: userId || 0,
                    message: message2
                })
            }
        });
    }
}
class StatApi {
    // graphite: StatGraphiteApi;
    constructor(api2){
        this.logs = new StatLogsApi(api2);
        this.baseStat = new BaseStatApi(api2);
    }
}
class StreamApi extends BaseApi {
    constructor(){
        super(...arguments);
        this.URLS = {
            STREAM: API_URL.PUBLIC_STREAM,
            STREAM_SLOT: API_URL.CHANNEL_STREAM_SLOT,
            STREAM_CREDENTIALS: API_URL.PUBLIC_STREAM_CREDENTIALS,
            STREAM_COMPLAIN: API_URL.PUBLIC_STREAM_COMPLAIN,
            STREAM_LIKE: API_URL.PUBLIC_STREAM_LIKE,
            STREAM_NOTIFY: API_URL.PUBLIC_STREAM_NOTIFY,
            STREAM_HEARTBEAT: API_URL.CHANNEL_STREAM_HEARTBEAT,
            STREAM_RECORD: API_URL.PUBLIC_STREAM_RECORD
        };
    }
    async fetch({ blogUrl, slotUrl, from: from2, getAbort }) {
        return this.get({
            apiUrl: this.URLS.STREAM_SLOT,
            url: getParametrizedUrl(this.URLS.STREAM_SLOT, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            }, {
                from: from2
            }),
            getAbort: getAbort
        });
    }
    async remove(blogUrl) {
        return this.delete({
            apiUrl: this.URLS.STREAM,
            url: getParametrizedUrl(this.URLS.STREAM, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchCredentials(blogUrl, refresh, slotId) {
        return this.get({
            apiUrl: this.URLS.STREAM_CREDENTIALS,
            url: getParametrizedUrl(this.URLS.STREAM_CREDENTIALS, {
                blogUrl: blogUrl
            }, {
                refresh: refresh,
                slot_id: slotId
            })
        });
    }
    async create(blogUrl, params) {
        return this.post({
            apiUrl: this.URLS.STREAM,
            url: getParametrizedUrl(this.URLS.STREAM, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async update(blogUrl, params) {
        return this.put({
            apiUrl: this.URLS.STREAM,
            url: getParametrizedUrl(this.URLS.STREAM, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async complain(blogUrl) {
        return this.post({
            apiUrl: this.URLS.STREAM_COMPLAIN,
            url: getParametrizedUrl(this.URLS.STREAM_COMPLAIN, {
                blogUrl: blogUrl
            })
        });
    }
    async like(blogUrl, slotUrl) {
        return this.put({
            apiUrl: this.URLS.STREAM_LIKE,
            url: getParametrizedUrl(this.URLS.STREAM_LIKE, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            })
        });
    }
    async unlike(blogUrl, slotUrl) {
        return this.delete({
            apiUrl: this.URLS.STREAM_LIKE,
            url: getParametrizedUrl(this.URLS.STREAM_LIKE, {
                blogUrl: blogUrl,
                slotUrl: slotUrl ?? DEFAULT_SLOT
            })
        });
    }
    async notify(blogUrl) {
        return this.put({
            apiUrl: this.URLS.STREAM_NOTIFY,
            url: getParametrizedUrl(this.URLS.STREAM_NOTIFY, {
                blogUrl: blogUrl
            })
        });
    }
    async record(blogUrl, willRecord) {
        return this.put({
            apiUrl: this.URLS.STREAM_RECORD,
            url: getParametrizedUrl(this.URLS.STREAM_RECORD, {
                blogUrl: blogUrl
            }),
            data: {
                on: willRecord
            }
        });
    }
    async initRaid(blogUrl, targetBlogUrl) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_RAID,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID, {
                blogUrl: blogUrl
            }, {
                target_blog_url: targetBlogUrl
            })
        });
    }
    async startRaid(blogUrl) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_RAID_START,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID_START, {
                blogUrl: blogUrl
            })
        });
    }
    async cancelRaid(blogUrl) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_RAID,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID, {
                blogUrl: blogUrl
            })
        });
    }
    async rejectRaid(blogUrl) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_RAID_REJECT,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID_REJECT, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchStreamRaid(blogUrl) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RAID,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchRaidUserState(blogUrl) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RAID_USER_STATE,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RAID_USER_STATE, {
                blogUrl: blogUrl
            })
        });
    }
    async incrementRaidViewers(blogUrl) {
        return this.put({
            apiUrl: API_URL.CHANNEL_RAID_VIEWER,
            url: getParametrizedUrl(API_URL.CHANNEL_RAID_VIEWER, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchCategories({ search, type, limit, offset: offset2 }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_CATEGORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_CATEGORY, {}, {
                search: search,
                type: type,
                limit: limit,
                offset: offset2
            })
        });
    }
    async requestAccess(params) {
        return this.post({
            apiUrl: API_URL.PUBLIC_STREAM_REQUEST_ACCESS,
            url: API_URL.PUBLIC_STREAM_REQUEST_ACCESS,
            data: params
        });
    }
    async search({ query, offset: offset2, limit, forRaid }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_SEARCH,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_SEARCH, {}, {
                search_query: query,
                limit: limit,
                offset: offset2,
                for_raid: forRaid
            })
        });
    }
    async fetchRaidableStreams() {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RAIDABLE_STREAMS,
            url: API_URL.PUBLIC_STREAM_RAIDABLE_STREAMS
        });
    }
    async sendHeartbeat(blogUrl, streamId, { stop, autoplay, source, sourceType }) {
        const headers = source && {
            [EHeartbeatHeaders[sourceType]]: encodeURI(source)
        };
        return this.put({
            apiUrl: this.URLS.STREAM_HEARTBEAT,
            url: getParametrizedUrl(this.URLS.STREAM_HEARTBEAT, {
                blogUrl: blogUrl,
                streamId: streamId
            }, {
                stop: stop,
                autoplay: autoplay
            }),
            headers: headers
        });
    }
    async hide(blogUrl) {
        return this.put({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_STREAM,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_STREAM, {
                blogUrl: blogUrl
            })
        });
    }
    async removeFromHidden(blogUrl) {
        return this.delete({
            apiUrl: API_URL.PUBLIC_STREAM_HIDE_STREAM,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDE_STREAM, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchHidden(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_HIDDEN,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_HIDDEN, {}, {
                ...params
            })
        });
    }
    async fetchUserChatHistory({ userId, blogUrl, ...restParams }) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_USER_CHAT_HISTORY,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_USER_CHAT_HISTORY, {
                blogUrl: blogUrl,
                userId: userId
            }, {
                ...restParams
            })
        });
    }
    async fetchStreamSlots(blogUrl) {
        return this.get({
            apiUrl: API_URL.STREAM_SLOTS_LIST,
            url: getParametrizedUrl(API_URL.STREAM_SLOTS_LIST, {
                blogUrl: blogUrl
            })
        });
    }
}
class StreamRandomApi extends BaseApi {
    async fetchRandomStream(params) {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_RANDOM,
            url: getParametrizedUrl(API_URL.PUBLIC_STREAM_RANDOM, {}, {
                ...params
            })
        });
    }
    async fetchRandomStreamForDropCampaign(dropCampaignId) {
        return this.get({
            apiUrl: API_URL.DROP_CAMPAIGN_RANDOM_STREAM,
            url: getParametrizedUrl(API_URL.DROP_CAMPAIGN_RANDOM_STREAM, {
                dropCampaignId: dropCampaignId
            })
        });
    }
}
class StreamSettingsApi extends BaseApi {
    async fetchSettingsSet(blogUrl) {
        return this.get({
            apiUrl: API_URL.STREAM_SETTINGS,
            url: getParametrizedUrl(API_URL.STREAM_SETTINGS, {
                blogUrl: blogUrl
            })
        });
    }
    async updateSettingsSet(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.STREAM_SETTINGS,
            url: getParametrizedUrl(API_URL.STREAM_SETTINGS, {
                blogUrl: blogUrl
            }),
            data: {
                category_id: params.categoryId,
                da_nick: params.daNick,
                subscription_level_id: params.subscriptionLevelId === 0 ? "" : params.subscriptionLevelId,
                title_data: JSON.stringify(params.titleData),
                planned_at: params.plannedAt
            }
        });
    }
}
class StreamSlotsApi extends BaseApi {
    async fetchStreamSlots(blogUrl, params) {
        return this.get({
            apiUrl: API_URL.STREAM_SLOTS_MANAGE,
            url: getParametrizedUrl(API_URL.STREAM_SLOTS_MANAGE, {
                blogUrl: blogUrl
            }, {
                ...params
            })
        });
    }
    async createStreamSlot(blogUrl, data) {
        return this.post({
            apiUrl: API_URL.STREAM_SLOTS_MANAGE,
            url: getParametrizedUrl(API_URL.STREAM_SLOTS_MANAGE, {
                blogUrl: blogUrl
            }),
            data: {
                category_id: data.categoryId,
                name: data.name,
                subscription_level_id: data.subscriptionLevelId === 0 ? "" : data.subscriptionLevelId,
                title_data: JSON.stringify(data.titleData),
                planned_at: data.plannedAt,
                is_temporary: data.isTemporary,
                cover_image_id: data.coverImageId || void 0,
                slot_url: data.slotUrl || void 0,
                is_vk_wallpost_create: data.isVkWallpostCreate || void 0
            }
        });
    }
    async editStreamSlot(blogUrl, slotId, data) {
        return this.put({
            apiUrl: API_URL.STREAM_SLOT_MANAGE,
            url: getParametrizedUrl(API_URL.STREAM_SLOT_MANAGE, {
                blogUrl: blogUrl,
                slotId: slotId
            }),
            data: {
                category_id: data.categoryId,
                name: data.name,
                subscription_level_id: data.subscriptionLevelId === 0 ? "" : data.subscriptionLevelId,
                title_data: JSON.stringify(data.titleData),
                planned_at: data.plannedAt,
                is_temporary: data.isTemporary,
                slot_url: data.slotUrl || void 0,
                cover_image_id: data.coverImageId,
                is_vk_wallpost_create: data.isVkWallpostCreate
            }
        });
    }
    async deleteStreamSlot(blogUrl, slotId) {
        return this.delete({
            apiUrl: API_URL.STREAM_SLOT_MANAGE,
            url: getParametrizedUrl(API_URL.STREAM_SLOT_MANAGE, {
                blogUrl: blogUrl,
                slotId: slotId
            })
        });
    }
}
class SubscriptionGiftApi extends BaseApi {
    async fetchSubscriptionGiftLevelId(blogUrl, levelId) {
        return this.get({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_GIFT_LEVEL,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_GIFT_LEVEL, {
                blogUrl: blogUrl,
                levelId: levelId
            })
        });
    }
    async fetchSubscriptionGift(blogUrl) {
        return this.get({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_GIFT,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_GIFT, {
                blogUrl: blogUrl
            })
        });
    }
    async sendSubscriptionGift(blogUrl, levelId, count2, userId) {
        return this.post({
            apiUrl: API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT,
            url: getParametrizedUrl(API_URL.CHANNEL_SUBSCRIPTION_LEVEL_GIFT, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: {
                count: count2,
                user_id: userId,
                is_anonymous: false
            }
        });
    }
}
class SubscriptionLevelsApi extends BaseApi {
    async fetch(blogUrl, levelId, withContentCounters) {
        return this.get({
            apiUrl: API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID, {
                blogUrl: blogUrl,
                levelId: levelId
            }, {
                with_content_counters: withContentCounters
            })
        });
    }
    async create(blogUrl, params) {
        return this.post({
            apiUrl: API_URL.BLOG_SUBSCRIPTION_LEVELS_CREATE,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIPTION_LEVELS_CREATE, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async update(blogUrl, levelId, params) {
        return this.put({
            apiUrl: API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
    async remove(blogUrl, levelId, params) {
        return this.delete({
            apiUrl: API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID,
            url: getParametrizedUrl(API_URL.BLOG_SUBSCRIPTION_LEVELS_BY_ID, {
                blogUrl: blogUrl,
                levelId: levelId
            }),
            data: params
        });
    }
}
class SupportApi extends BaseApi {
    async contactSupport(params) {
        return this.post({
            apiUrl: API_URL.SUPPORT_CONTACT,
            url: API_URL.SUPPORT_CONTACT,
            data: params
        });
    }
}
class SupportProgramApi extends BaseApi {
    async fetchArchive(blogUrl) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_ARCHIVE,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_ARCHIVE, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchSeason(blogUrl, seasonId) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASON, {
                blogUrl: blogUrl,
                seasonId: seasonId
            })
        });
    }
    async fetchCurrentSeason(blogUrl) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASON_CURRENT, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchCurrentSeasonUnauthorized() {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_UNAUTHORIZED,
            url: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_UNAUTHORIZED
        });
    }
    async fetchSeasons(blogUrl) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASONS,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASONS, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchSeasonsHistory(blogUrl) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASONS_HISTORY,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASONS_HISTORY, {
                blogUrl: blogUrl
            })
        });
    }
    async sendCurrentSeasonFeedback(blogUrl, params) {
        return this.put({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_FEEDBACK,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_FEEDBACK, {
                blogUrl: blogUrl
            }),
            data: params
        });
    }
    async subscribeToCurrentSeason(blogUrl) {
        return this.put({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_SUBSCRIBE,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_SUBSCRIBE, {
                blogUrl: blogUrl
            })
        });
    }
    async dismissReachedLevelAlert(blogUrl) {
        return this.put({
            apiUrl: API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_SEASON_CURRENT_REACHED_LEVEL_ALERT_ACCEPT, {
                blogUrl: blogUrl
            })
        });
    }
    async fetchDailyStat(blogUrl, seasonId, metricName) {
        return this.get({
            apiUrl: API_URL.SUPPORT_PROGRAM_STAT_DAILY,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_STAT_DAILY, {
                blogUrl: blogUrl,
                seasonId: seasonId,
                metricName: metricName
            })
        });
    }
    async receivePayout(blogUrl, seasonId, params) {
        return this.put({
            apiUrl: API_URL.SUPPORT_PROGRAM_PAYOUT,
            url: getParametrizedUrl(API_URL.SUPPORT_PROGRAM_PAYOUT, {
                blogUrl: blogUrl,
                seasonId: seasonId
            }),
            data: params
        });
    }
}
class SystemApi extends BaseApi {
    async fetchExternalApp(appId) {
        return this.get({
            apiUrl: API_URL.EXTERNAL_APP,
            url: getParametrizedUrl(API_URL.EXTERNAL_APP, {
                appId: appId
            })
        });
    }
    async getSupportFrameUrl() {
        return this.get({
            apiUrl: API_URL.SUPPORT,
            url: API_URL.SUPPORT
        });
    }
    async fetchThirdPartyApp(appId, scope) {
        return this.get({
            apiUrl: API_URL.THIRD_PARTY_APP_OAUTH,
            url: getParametrizedUrl(API_URL.THIRD_PARTY_APP_OAUTH, {
                slug: appId
            }, {
                scope: scope
            })
        });
    }
    async fetchConnectedAppsList() {
        return this.get({
            apiUrl: API_URL.THIRD_PARTY_APP_CONNECTED_LIST,
            url: API_URL.THIRD_PARTY_APP_CONNECTED_LIST
        });
    }
    async disconnectApp(slug) {
        return this.delete({
            apiUrl: API_URL.THIRD_PARTY_APP_CONNECTED,
            url: getParametrizedUrl(API_URL.THIRD_PARTY_APP_CONNECTED, {
                slug: slug
            })
        });
    }
}
class TargetApi extends BaseApi {
    async fetchTargetById(targetId, currency) {
        return this.get({
            apiUrl: API_URL.TARGET_BY_ID,
            url: getParametrizedUrl(API_URL.TARGET_BY_ID, {
                targetId: targetId
            }, {
                currency: currency
            })
        });
    }
    async createMoneyTarget(params) {
        return this.post({
            apiUrl: API_URL.TARGET_MONEY_CREATE,
            url: API_URL.TARGET_MONEY_CREATE,
            data: params
        });
    }
    async createSubscribersTarget(params) {
        return this.post({
            apiUrl: API_URL.TARGET_SUBSCRIBERS_CREATE,
            url: API_URL.TARGET_SUBSCRIBERS_CREATE,
            data: params
        });
    }
    async edit(targetId, params) {
        return this.put({
            apiUrl: API_URL.TARGET_BY_ID,
            url: getParametrizedUrl(API_URL.TARGET_BY_ID, {
                targetId: targetId
            }),
            data: params
        });
    }
    async remove(targetId) {
        return this.delete({
            apiUrl: API_URL.TARGET_BY_ID,
            url: getParametrizedUrl(API_URL.TARGET_BY_ID, {
                targetId: targetId
            })
        });
    }
    async fetchTargets(blogUrl, queryParams = {}) {
        return this.get({
            apiUrl: API_URL.TARGET_TARGETS,
            url: getParametrizedUrl(API_URL.TARGET_TARGETS, {
                blogUrl: blogUrl
            }, {
                ...queryParams
            })
        });
    }
}
const CONTENT_TYPE = {
    formUrlencoded: "application/x-www-form-urlencoded"
};
class UserApi extends BaseApi {
    async fetch(id) {
        return this.get({
            apiUrl: API_URL.USER,
            url: getParametrizedUrl(API_URL.USER, {
                id: id
            })
        });
    }
    async fetchCurrent() {
        return this.get({
            apiUrl: API_URL.USER_CURRENT,
            url: API_URL.USER_CURRENT
        });
    }
    async logout(params) {
        return this.delete({
            apiUrl: API_URL.OAUTH_TOKEN,
            url: getParametrizedUrl(API_URL.OAUTH_TOKEN, {}, params)
        });
    }
    async fetchCurrentPhone() {
        return this.get({
            apiUrl: API_URL.USER_PHONE,
            url: API_URL.USER_PHONE
        });
    }
    async getSubscriptions(queryParams = {}, withFollow = false) {
        return this.get({
            apiUrl: API_URL.USER_SUBSCRIPTIONS,
            url: getParametrizedUrl(API_URL.USER_SUBSCRIPTIONS, {}, // eslint-disable-next-line camelcase
            {
                ...queryParams,
                with_follow: String(withFollow)
            })
        });
    }
    async getPaymentBinds(currency, withDeleted = false) {
        return this.get({
            apiUrl: API_URL.PAYMENT_LIST,
            url: getParametrizedUrl(API_URL.PAYMENT_LIST, {}, {
                deleted: String(withDeleted),
                currency: currency
            })
        });
    }
    async refreshToken(data) {
        const formData = {
            /* eslint-disable camelcase */ device_id: data.fromId,
            grant_type: "refresh_token",
            refresh_token: data.refreshToken,
            device_os: data.appId
        };
        return this.api.getTransport().http({
            url: API_URL.OAUTH_REFRESH_TOKEN,
            method: "POST",
            config: {
                headers: {
                    "Content-Type": CONTENT_TYPE.formUrlencoded
                }
            },
            data: queryString.stringify(formData)
        });
    }
    async oauthServerAuthorize(data) {
        return this.api.getTransport().http({
            url: API_URL.OAUTH_SERVER_AUTHORIZE,
            method: "POST",
            config: {
                headers: {
                    "Content-Type": CONTENT_TYPE.formUrlencoded
                }
            },
            data: queryString.stringify(data)
        });
    }
    async update(params) {
        return this.put({
            apiUrl: API_URL.USER_CURRENT,
            url: getParametrizedUrl(API_URL.USER_CURRENT),
            data: params
        });
    }
    async updateUserFlag(flag) {
        return this.put({
            apiUrl: API_URL.USER_CURRENT_FLAG,
            url: getParametrizedUrl(API_URL.USER_CURRENT_FLAG, {
                flag: flag
            })
        });
    }
    async linkVKPlay(params) {
        return this.put({
            apiUrl: API_URL.USER_CURRENT_VKPLAY_LINK,
            url: API_URL.USER_CURRENT_VKPLAY_LINK,
            data: params
        });
    }
    async getLinkedBoosty() {
        return this.get({
            apiUrl: API_URL.USER_CURRENT_VKPLAY_LINK_BOOSTY,
            url: API_URL.USER_CURRENT_VKPLAY_LINK_BOOSTY
        });
    }
    // запрос делается не от текущего пользователя, а от аккаунта, который будет вмержен в текущий
    async fetchVkPlayMergeTargetUser(params) {
        const { targetAccessToken } = params;
        return this.get({
            apiUrl: API_URL.USER_CURRENT_FETCH_VKPLAY_FOR_MERGE,
            url: API_URL.USER_CURRENT_FETCH_VKPLAY_FOR_MERGE,
            headers: {
                "Authorization": `Bearer ${targetAccessToken}`
            }
        });
    }
    async mergeVKPlay(params) {
        const { targetAccessToken } = params;
        return this.put({
            apiUrl: API_URL.AUTH_MERGE,
            url: API_URL.AUTH_MERGE,
            data: {
                target_access_token: targetAccessToken
            }
        });
    }
    async updateCurrentUserPhone(params) {
        return this.put({
            apiUrl: API_URL.USER_PHONE_CHANGE,
            url: API_URL.USER_PHONE_CHANGE,
            data: params
        });
    }
    async approveCurrentUserPhone(params) {
        return this.post({
            apiUrl: API_URL.USER_PHONE_APPROVE,
            url: API_URL.USER_PHONE_APPROVE,
            data: params
        });
    }
    async acceptPrivacyPolicy(params) {
        return this.put({
            apiUrl: API_URL.USER_PRIVACY_POLICY,
            url: API_URL.USER_PRIVACY_POLICY,
            data: params
        });
    }
    async acceptRefPolicy(params) {
        return this.put({
            apiUrl: API_URL.USER_REF_POLICY,
            url: API_URL.USER_REF_POLICY,
            data: params
        });
    }
    async uploadAvatar(file) {
        const { hosts: { uploadImg: uploadImgHost } } = getConfig();
        const url = uploadImgHost ? getParametrizedUrl(`${uploadImgHost}/v1${API_URL.USER_AVATAR}`) : getParametrizedUrl(API_URL.USER_AVATAR);
        return this.put({
            apiUrl: API_URL.USER_AVATAR,
            url: url,
            isNoProcessData: true,
            data: file
        });
    }
    async checkNick(nick2) {
        return this.put({
            apiUrl: API_URL.USER_CHECK_NICK,
            url: API_URL.USER_CHECK_NICK,
            isNoProcessData: true,
            data: getURIParams$3({
                nick: nick2
            }),
            headers: {
                "Content-Type": CONTENT_TYPE.formUrlencoded
            }
        });
    }
    async fetchFollowings(queryParams = {}) {
        return this.get({
            apiUrl: API_URL.USER_FOLLOWING,
            url: getParametrizedUrl(API_URL.USER_FOLLOWING, {}, {
                ...queryParams
            })
        });
    }
    async sendEmailConfirmationLetter() {
        return this.put({
            apiUrl: API_URL.USER_SEND_EMAIL_CONFIRMATION_LETTER,
            url: API_URL.USER_SEND_EMAIL_CONFIRMATION_LETTER
        });
    }
    async finishTutorial() {
        return this.put({
            apiUrl: API_URL.USER_FINISH_TUTORIAL,
            url: API_URL.USER_FINISH_TUTORIAL
        });
    }
    async removeAuthLink(type) {
        return this.delete({
            apiUrl: API_URL.USER_AUTH_LINK,
            url: getParametrizedUrl(API_URL.USER_AUTH_LINK, {
                type: type
            })
        });
    }
    async checkPhone(queryParams) {
        const authToken = TemporaryStorage.getItem("auth");
        return this.get({
            apiUrl: API_URL.USER_PHONE_CHECK,
            url: getParametrizedUrl(API_URL.USER_PHONE_CHECK, {}, {
                ...queryParams
            }),
            // That's need for authorization by phone
            headers: {
                "Authorization": `Bearer ${authToken.accessToken}`
            }
        });
    }
    async checkCurrentUserPhone(queryParams) {
        return this.get({
            apiUrl: API_URL.USER_PHONE_CURRENT_CHECK,
            url: getParametrizedUrl(API_URL.USER_PHONE_CURRENT_CHECK, {}, {
                ...queryParams
            })
        });
    }
    async checkPhoneAdditionStatus() {
        return this.get({
            apiUrl: API_URL.USER_PHONE_CAN_ADD,
            url: API_URL.USER_PHONE_CAN_ADD
        });
    }
    async verifyOldPhone(params) {
        return this.put({
            apiUrl: API_URL.USER_PHONE_VERIFY_OLD,
            url: API_URL.USER_PHONE_VERIFY_OLD,
            data: params
        });
    }
    async notifySettingsOld(notificationType, transport) {
        return this.put({
            apiUrl: API_URL.USER_NOTIFY_SETTINGS_OLD,
            url: getParametrizedUrl(API_URL.USER_NOTIFY_SETTINGS_OLD, {
                notificationType: notificationType
            }),
            data: transport
        });
    }
    async scheduleAccountDeletion() {
        return this.put({
            apiUrl: API_URL.USER_CURRENT_SCHEDULED_DELETION,
            url: API_URL.USER_CURRENT_SCHEDULED_DELETION
        });
    }
    async cancelAccountDeletion() {
        return this.delete({
            apiUrl: API_URL.USER_CURRENT_SCHEDULED_DELETION,
            url: API_URL.USER_CURRENT_SCHEDULED_DELETION
        });
    }
    async fetchMarketingAlerts(queryParams) {
        return this.get({
            apiUrl: API_URL.USER_MARKETING_ALERTS,
            url: getParametrizedUrl(API_URL.USER_MARKETING_ALERTS, {}, {
                ...queryParams
            })
        });
    }
    async dismissMarketingAlert(alertId) {
        return this.post({
            apiUrl: API_URL.USER_MARKETING_ALERT_DISMISS,
            url: getParametrizedUrl(API_URL.USER_MARKETING_ALERT_DISMISS, {
                alertId: alertId
            })
        });
    }
    async loginWithExistsToken(accessToken) {
        return this.put({
            apiUrl: API_URL.USER_LOGIN,
            url: API_URL.USER_LOGIN,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    }
    async setLocale(locale2) {
        return this.post({
            apiUrl: API_URL.USER_LOCALE,
            url: getParametrizedUrl(API_URL.USER_LOCALE, {}, {
                locale: locale2
            })
        });
    }
    async fetchBoostyLink() {
        return this.get({
            apiUrl: API_URL.USER_BOOSTY_LINK,
            url: API_URL.USER_BOOSTY_LINK
        });
    }
    async updateDialogSettings(params) {
        return this.post({
            apiUrl: API_URL.USER_DIALOG_SETTINGS,
            url: API_URL.USER_DIALOG_SETTINGS,
            data: params
        });
    }
    async updateNicknameColor(color2) {
        return this.put({
            apiUrl: API_URL.USER_CURRENT_NICK_COLOR,
            url: API_URL.USER_CURRENT_NICK_COLOR,
            data: {
                nick_color: color2
            }
        });
    }
    async fetchSubscribedStreams() {
        return this.get({
            apiUrl: API_URL.PUBLIC_STREAM_USER_SUBSCRIPTIONS,
            url: API_URL.PUBLIC_STREAM_USER_SUBSCRIPTIONS
        });
    }
    async fetchManagedChannels() {
        return this.get({
            apiUrl: API_URL.USER_MANAGED_CHANNEL,
            url: API_URL.USER_MANAGED_CHANNEL
        });
    }
    async fetchSelf({ userIds }) {
        return this.get({
            apiUrl: API_URL.SELF_USER,
            url: getParametrizedUrl(API_URL.SELF_USER, null, {
                user_ids: userIds
            }),
            withoutVersion: true
        });
    }
    async enableGiftReceivingOnlyAsFollower() {
        return this.put({
            apiUrl: API_URL.USER_CURRENT_GIFT_RECEIVING_MODE_FOLLOWER,
            url: API_URL.USER_CURRENT_GIFT_RECEIVING_MODE_FOLLOWER
        });
    }
    async disableGiftReceivingOnlyAsFollower() {
        return this.delete({
            apiUrl: API_URL.USER_CURRENT_GIFT_RECEIVING_MODE_FOLLOWER,
            url: API_URL.USER_CURRENT_GIFT_RECEIVING_MODE_FOLLOWER
        });
    }
    async fetchUserCurrentLink() {
        return this.get({
            apiUrl: API_URL.USER_CURRENT_LINK,
            url: API_URL.USER_CURRENT_LINK
        });
    }
    async fetchVKIDToken(params) {
        const url = getParametrizedUrl(API_URL.OAUTH_VK_ID_TOKEN, null, {
            device_id: params.deviceId,
            device_os: params.deviceOS,
            silent_token: params.silentToken,
            uuid: params.uuid
        });
        const additionalQueryParams = new URLSearchParams(params.allowedActorStatus.map((item2)=>{
            return [
                "allowed_actor_status",
                item2
            ];
        })).toString();
        return this.get({
            apiUrl: API_URL.OAUTH_VK_ID_TOKEN,
            url: `${url}&${additionalQueryParams}`,
            withoutVersion: true
        });
    }
    async fetchVKPlayToken(params) {
        const { allowedActorStatus, code, state } = params;
        const url = getParametrizedUrl(API_URL.OAUTH_VKPLAY_TOKEN, null, {
            state: state,
            code: code,
            allowed_actor_status: allowedActorStatus
        });
        const withoutAuthorization = allowedActorStatus === EAllowedActorStatus.EXISTING_ACCOUNT;
        return this.get({
            apiUrl: API_URL.OAUTH_VKPLAY_TOKEN,
            url: url,
            withoutVersion: true,
            headers: {
                ...withoutAuthorization && {
                    ["Authorization"]: null
                }
            }
        });
    }
    async sendEmailConfirmationCode(email) {
        return this.post({
            apiUrl: API_URL.USER_SEND_EMAIL_CONFIRMATION_CODE,
            url: API_URL.USER_SEND_EMAIL_CONFIRMATION_CODE,
            data: {
                email: email
            }
        });
    }
    async confirmEmail(params) {
        return this.put({
            apiUrl: API_URL.USER_CONFIRM_EMAIL,
            url: API_URL.USER_CONFIRM_EMAIL,
            data: {
                email_code: params.email_code,
                email: params.email
            }
        });
    }
}
class VideoClipApi extends BaseApi {
    async createVideoSnippet(params) {
        const { blogUrl, playbackPosition, streamId } = params;
        return this.post({
            apiUrl: API_URL.VIDEO_SNIPPET_CREATE,
            url: getParametrizedUrl(API_URL.VIDEO_SNIPPET_CREATE, {
                channelUrl: blogUrl
            }),
            data: {
                stream_id: streamId,
                timestamp: playbackPosition
            }
        });
    }
    async fetchVideoSnippet(params) {
        const { blogUrl, videoSnippetId, getAbort } = params;
        return this.get({
            apiUrl: API_URL.VIDEO_SNIPPET,
            url: getParametrizedUrl(API_URL.VIDEO_SNIPPET, {
                channelUrl: blogUrl,
                videoSnippetId: videoSnippetId
            }),
            getAbort: getAbort
        });
    }
    async fetchVideoClipChat(blogUrl, videoClipId, additionalParams) {
        return this.get({
            apiUrl: API_URL.VIDEO_CLIP_CHAT,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_CHAT, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            }, {
                time_code: additionalParams == null ? void 0 : additionalParams.timeCode,
                last_message_id: additionalParams == null ? void 0 : additionalParams.lastMessageId,
                limit: additionalParams == null ? void 0 : additionalParams.limit,
                offset: additionalParams == null ? void 0 : additionalParams.offset
            })
        });
    }
    async createVideoClipFromStream(params) {
        const { blogUrl, end, start, snippetId, titleData } = params;
        return this.post({
            apiUrl: API_URL.VIDEO_CLIP_CREATE_FROM_STREAM,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_CREATE_FROM_STREAM, {
                channelUrl: blogUrl
            }),
            data: {
                offset_end: end,
                offset_start: start,
                template_id: snippetId,
                title_data: JSON.stringify(titleData)
            }
        });
    }
    async createVideoClipFromRecord(params) {
        const { blogUrl, end, start, streamId, titleData } = params;
        return this.post({
            apiUrl: API_URL.VIDEO_CLIP_CREATE_FROM_RECORD,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_CREATE_FROM_RECORD, {
                channelUrl: blogUrl
            }),
            data: {
                offset_end: end,
                offset_start: start,
                stream_id: streamId,
                title_data: JSON.stringify(titleData)
            }
        });
    }
    async fetchVideoClip(params) {
        const { blogUrl, isUnrestricted = false, videoClipId, getAbort } = params;
        const apiUrl = isUnrestricted ? API_URL.VIDEO_CLIP_UNRESTRICTED : API_URL.VIDEO_CLIP;
        return this.get({
            apiUrl: apiUrl,
            url: getParametrizedUrl(apiUrl, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            }),
            getAbort: getAbort
        });
    }
    async editVideoClip(blogUrl, videoClipId, params) {
        const { categoryId, titleData } = params;
        return this.put({
            apiUrl: API_URL.VIDEO_CLIP_UNRESTRICTED,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_UNRESTRICTED, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            }),
            data: {
                category_id: categoryId,
                title_data: JSON.stringify(titleData)
            }
        });
    }
    async deleteVideoClip(blogUrl, videoClipId, params) {
        const { reason: reason2 } = params;
        return this.delete({
            apiUrl: API_URL.VIDEO_CLIP_UNRESTRICTED,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_UNRESTRICTED, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            }),
            data: {
                reason: reason2
            }
        });
    }
    async fetchVideoClips(params) {
        const { blogUrl, limit = 100, offset: offset2 = 0, from: from2, to, orderBy, isUnrestricted } = params;
        const { videoClips: { defaultOrderBy } } = getConfig();
        const apiUrl = isUnrestricted ? API_URL.VIDEO_CLIPS_UNRESTRICTED : API_URL.VIDEO_CLIPS_ACTIVE;
        return this.get({
            apiUrl: apiUrl,
            url: getParametrizedUrl(apiUrl, {
                channelUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                from: from2,
                to: to,
                order: orderBy || defaultOrderBy
            })
        });
    }
    async fetchActiveVideClips(params) {
        const { blogUrl, limit = 100, offset: offset2 = 0, from: from2, to, orderBy } = params;
        return this.get({
            apiUrl: API_URL.VIDEO_CLIPS_ACTIVE,
            url: getParametrizedUrl(API_URL.VIDEO_CLIPS_ACTIVE, {
                channelUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                from: from2,
                to: to,
                order: orderBy
            })
        });
    }
    async fetchProcessingVideClips(params) {
        const { blogUrl, limit = 100, offset: offset2 = 0, from: from2, to } = params;
        return this.get({
            apiUrl: API_URL.VIDEO_CLIPS_PROCESSING,
            url: getParametrizedUrl(API_URL.VIDEO_CLIPS_PROCESSING, {
                channelUrl: blogUrl
            }, {
                limit: limit,
                offset: offset2,
                from: from2,
                to: to
            })
        });
    }
    async likeVideoClip(blogUrl, videoClipId) {
        return this.put({
            apiUrl: API_URL.VIDEO_CLIP_LIKE,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_LIKE, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            })
        });
    }
    async unlikeVideoClip(blogUrl, videoClipId) {
        return this.delete({
            apiUrl: API_URL.VIDEO_CLIP_LIKE,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_LIKE, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            })
        });
    }
    async hideVideoClip(blogUrl, videoClipId) {
        return this.put({
            apiUrl: API_URL.VIDEO_CLIP_HIDE,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_HIDE, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            })
        });
    }
    async unhideVideoClip(blogUrl, videoClipId) {
        return this.delete({
            apiUrl: API_URL.VIDEO_CLIP_HIDE,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_HIDE, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            })
        });
    }
    async viewVideoClip(blogUrl, videoClipId) {
        return this.put({
            apiUrl: API_URL.VIDEO_CLIP_VIEW,
            url: getParametrizedUrl(API_URL.VIDEO_CLIP_VIEW, {
                channelUrl: blogUrl,
                videoClipId: videoClipId
            })
        });
    }
}
class WebSocketApi extends BaseApi {
    async fetchToken() {
        return this.get({
            apiUrl: WS_URLS.CONNECT_TOKEN,
            url: WS_URLS.CONNECT_TOKEN
        });
    }
    async refreshToken() {
        return this.post({
            apiUrl: WS_URLS.REFRESH_TOKEN,
            url: WS_URLS.REFRESH_TOKEN
        });
    }
    async fetchPrivateToken(channels) {
        return this.get({
            apiUrl: WS_URLS.PRIVATE_TOKEN,
            url: getParametrizedUrl(WS_URLS.PRIVATE_TOKEN, {}, {
                channels: channels
            })
        });
    }
}
let Api$1 = (_b = class {
    static setTransport(transport) {
        this.transport = transport;
    }
    static getTransport() {
        return this.transport;
    }
    static setContext(context) {
        this.context = context;
    }
    static getContext() {
        return this.context;
    }
}, _b.context = EApiContext.BOOSTY, _b.stat = new StatApi(_b), _b.agents = new AgentsApi(_b), _b.analytics = new AnalyticsApi(_b), _b.antiDDoS = new AntiDDoSApi(_b), _b.authByEmail = new AuthByEmailApi(_b), _b.badge = new BadgeApi(_b), _b.blackList = new BlackListApi(_b), _b.blog = new BlogApi(_b), _b.blogPost = new BlogPostApi(_b), _b.blogPostChat = new BlogPostChatApi(_b), _b.blogStat = new BlogStatApi(_b), _b.catalog = new CatalogApi(_b), _b.category = new CategoryApi(_b), _b.channel = new ChannelApi(_b), _b.dropCampaigns = new DropCampaignsApi(_b), _b.drops = new ChannelDropsApi(_b), _b.channelPoint = new ChannelPointApi(_b), _b.channelPointBonus = new ChannelPointBonusApi(_b), _b.channelPrediction = new ChannelPredictionApi(_b), _b.channelReward = new ChannelRewardApi(_b), _b.channelStat = new ChannelStatApi(_b), _b.channelModerator = new ChannelModeratorApi(_b), _b.channelPoll = new ChannelPollApi(_b), _b.chatBot = new ChatBotApi(_b), _b.chatWinner = new ChatWinnerApi(_b), _b.customBlocks = new CustomBlocksApi(_b), _b.deviceApi = new DeviceApi(_b), _b.dialog = new DialogueApi(_b), _b.donationService = new DonationServiceApi(_b), _b.externalApps = new ExternalAppsApi(_b), _b.gift = new GiftApi(_b), _b.browserNotifications = new BrowserNotificationsApi(_b), _b.hostStatus = new HostStatusApi(_b), _b.internal = new InternalApi(_b), _b.streamSettings = new StreamSettingsApi(_b), _b.streamSlot = new StreamSlotsApi(_b), _b.channelSettings = new ChannelSettingsApi(_b), _b.mediaData = new MediaDataApi(_b), _b.news = new NewsApi(_b), _b.notificationSettings = new NotificationSettingsApi(_b), _b.notifications = new NotificationsStandaloneApi(_b), _b.ownChannelPoint = new OwnChannelPointApi(_b), _b.payment = new PaymentApi(_b), _b.payout = new PayoutApi(_b), _b.poll = new PollApi(_b), _b.ratingProgram = new RatingProgramApi(_b), _b.record = new RecordApi(_b), _b.reward = new RewardApi(_b), _b.rewardManager = new RewardManagerApi(_b), _b.role = new RoleApi(_b), _b.search = new SearchApi(_b), _b.smile = new SmileApi(_b), _b.stream = new StreamApi(_b), _b.streamRandom = new StreamRandomApi(_b), _b.subscriptionLevels = new SubscriptionLevelsApi(_b), _b.support = new SupportApi(_b), _b.supportProgram = new SupportProgramApi(_b), _b.systemApi = new SystemApi(_b), _b.target = new TargetApi(_b), _b.user = new UserApi(_b), _b.videoClip = new VideoClipApi(_b), _b.webSocket = new WebSocketApi(_b), _b.multiplicators = new MultiplicatorsApi(_b), _b.subscriptionGift = new SubscriptionGiftApi(_b), _b.moderationLog = new ModerationLogApi(_b), _b.playlist = new PlaylistApi(_b), _b.channelBan = new ChannelBanApi(_b), _b.base = new BaseApi(_b), _b);
window.FounderApi = Api$1;
const APP_STAT_SEND_DELAY = 1e3;
const _StatsQueue = class _StatsQueue {
    static scheduleSend() {
        if (!this.isDebouncing) {
            this.isDebouncing = true;
            this.timerId = window.setTimeout(()=>{
                this.isDebouncing = false;
                this.send();
            }, APP_STAT_SEND_DELAY);
        }
    }
    static getStatsToSend() {
        const stats = this.stats.slice();
        this.stats = [];
        return stats.length === 1 ? stats[0] : stats;
    }
    static add(stat2) {
        this.stats.push(stat2);
        this.scheduleSend();
    }
    static async send() {
        if (this.timerId != void 0) clearTimeout(this.timerId);
        if (!this.stats.length) return Promise.resolve();
        const stats = this.getStatsToSend();
        return Api$1.stat.baseStat.sendStat(stats);
    }
};
_StatsQueue.stats = [];
_StatsQueue.isDebouncing = false;
let StatsQueue = _StatsQueue;
class StatInstanceBase {
    constructor(parent){
        this.parent = parent;
    }
    async sendStat(params, isImmediately = false) {
        StatsQueue.add({
            ...params,
            ...this.getBasicParams()
        });
        if (isImmediately) return StatsQueue.send();
        return Promise.resolve();
    }
    getBasicParams() {
        var _a3, _b2, _c2;
        const currentUser2 = this.parent.currentUser;
        const blogUrl = (_b2 = (_a3 = this.parent.routeData) == null ? void 0 : _a3.match) == null ? void 0 : _b2.blogUrl;
        const url = (_c2 = this.parent.routeData) == null ? void 0 : _c2.url;
        return {
            userId: currentUser2 != null ? currentUser2.id : null,
            email: currentUser2 != null ? currentUser2.email : null,
            blogUrl: blogUrl,
            url: url,
            referer: getReferer(),
            refererType: getRefererType()
        };
    }
}
class StatAuthApi extends StatInstanceBase {
    openPopup({ source, price }) {
        this.sendStat({
            action: EStatEventType.AUTH_POPUP_SHOW,
            data0: source,
            data1: price != null ? `${price}` : void 0
        });
    }
    clickProvider({ providerCode }) {
        this.sendStat({
            action: EStatEventType.AUTH_POPUP_CLICK_PROVIDER,
            data0: providerCode
        });
    }
    error({ providerCode, step, status }) {
        this.sendStat({
            action: EStatEventType.AUTH_ERROR,
            data0: providerCode,
            data1: step,
            data2: String(status)
        });
    }
    refreshToken({ method, path: path2, status }) {
        this.sendStat({
            action: EStatEventType.AUTH_REFRESH_TOKEN,
            data0: method,
            data1: path2,
            data2: String(status)
        }, true);
    }
}
const FRAME_WAITING_MAX_DURATION = 60;
const FRAME_WAITING_STEP = 5;
class StatBank131FrameApi extends StatInstanceBase {
    constructor(){
        super(...arguments);
        this.startTime = Date.now();
        this.frameWaitingTimeout = null;
        this.frameWaiting = ()=>{
            const duration2 = this.getDuration(FRAME_WAITING_STEP);
            if (duration2 < FRAME_WAITING_MAX_DURATION) this.setFrameWaitingTimeout();
            this.sendStat({
                action: EStatEventType.BANK131_FRAME_WAITING,
                data0: `${Math.min(duration2, FRAME_WAITING_MAX_DURATION)}`
            });
        };
    }
    frameStart() {
        this.startTime = Date.now();
        this.setFrameWaitingTimeout();
    }
    setFrameWaitingTimeout() {
        this.clearFrameWaitingTimeout();
        this.frameWaitingTimeout = window.setTimeout(this.frameWaiting, FRAME_WAITING_STEP * 1e3);
    }
    clearFrameWaitingTimeout() {
        if (this.frameWaitingTimeout) {
            window.clearTimeout(this.frameWaitingTimeout);
            this.frameWaitingTimeout = null;
        }
    }
    getDuration(step = 1) {
        return Math.round((Date.now() - this.startTime) / 1e3 / step) * step;
    }
    frameLoaded({ paymentMethod, paymentType }) {
        this.clearFrameWaitingTimeout();
        this.sendStat({
            action: EStatEventType.BANK131_FRAME_LOADED,
            data0: paymentMethod,
            data1: paymentType,
            data2: "",
            // зарезервировано для возможного transactionId
            data3: `${this.getDuration()}`
        });
        this.startTime = Date.now();
    }
}
class StatBannerApi extends StatInstanceBase {
    clicked(bannerId) {
        this.sendStat({
            action: EStatEventType.BANNER_CLICKED,
            data0: bannerId
        });
    }
    closed(bannerId, type) {
        this.sendStat({
            action: EStatEventType.BANNER_CLOSED,
            data0: bannerId,
            data1: type
        });
    }
    shown(bannerId) {
        this.sendStat({
            action: EStatEventType.BANNER_SHOWN,
            data0: bannerId
        });
    }
}
class StatBlogApi extends StatInstanceBase {
    socialLinkClick({ type, url }) {
        this.sendStat({
            action: EStatEventType.BLOG_SOCIAL_LINK_CLICK,
            data0: type,
            data1: url
        });
    }
    async selectLocale(locale2) {
        return this.sendStat({
            action: EStatEventType.SELECT_LOCALE,
            data0: locale2
        }, true);
    }
    maybeWrongLanguage(header2) {
        this.sendStat({
            action: EStatEventType.MAYBE_WRONG_LANGUAGE,
            data0: header2
        });
    }
}
class StatChatApi extends StatInstanceBase {
    tabShow(tab2) {
        this.sendStat({
            action: EStatEventType.CHAT_TAB_SHOW,
            data0: tab2
        });
    }
    userCardShow() {
        this.sendStat({
            action: EStatEventType.CHAT_USER_CARD_SHOW
        });
    }
    smilePopupShow() {
        this.sendStat({
            action: EStatEventType.CHAT_SMILE_POPUP_SHOW
        });
    }
    rewardShopShow() {
        this.sendStat({
            action: EStatEventType.CHAT_REWARD_SHOP_SHOW
        });
    }
    rewardPriceListShow() {
        this.sendStat({
            action: EStatEventType.CHAT_REWARD_PRICE_LIST_SHOW
        });
    }
    settingsShow() {
        this.sendStat({
            action: EStatEventType.CHAT_SETTINGS_SHOW
        });
    }
    dropsShow() {
        this.sendStat({
            action: EStatEventType.CHAT_DROPS_SHOW
        });
    }
}
const DMR_FRAME_WAITING_MAX_DURATION = 60;
const DMR_FRAME_WAITING_STEP = 5;
class StatDmrFrameApi extends StatInstanceBase {
    constructor(){
        super(...arguments);
        this.startTime = Date.now();
        this.dmrFrameWaitingTimeout = null;
        this.dmrFrameWaiting = ()=>{
            const duration2 = this.getDuration(DMR_FRAME_WAITING_STEP);
            if (duration2 < DMR_FRAME_WAITING_MAX_DURATION) this.setDmrFrameWaitingTimeout();
            this.sendStat({
                action: EStatEventType.DMR_FRAME_WAITING,
                data0: `${Math.min(duration2, DMR_FRAME_WAITING_MAX_DURATION)}`
            });
        };
    }
    dmrFrameStart() {
        this.startTime = Date.now();
        this.setDmrFrameWaitingTimeout();
    }
    setDmrFrameWaitingTimeout() {
        this.clearDmrFrameWaitingTimeout();
        this.dmrFrameWaitingTimeout = window.setTimeout(this.dmrFrameWaiting, DMR_FRAME_WAITING_STEP * 1e3);
    }
    clearDmrFrameWaitingTimeout() {
        if (this.dmrFrameWaitingTimeout) {
            window.clearTimeout(this.dmrFrameWaitingTimeout);
            this.dmrFrameWaitingTimeout = null;
        }
    }
    getDuration(step = 1) {
        return Math.round((Date.now() - this.startTime) / 1e3 / step) * step;
    }
    dmrFrameLoaded({ paymentMethod, paymentType, transactionId }) {
        this.clearDmrFrameWaitingTimeout();
        this.sendStat({
            action: EStatEventType.DMR_FRAME_LOADED,
            data0: paymentMethod,
            data1: paymentType,
            data2: transactionId || "",
            data3: `${this.getDuration()}`
        });
        this.startTime = Date.now();
    }
}
class StatDonationApi extends StatInstanceBase {
    openForm({ openedFrom }) {
        this.sendStat({
            action: EStatEventType.DONATION_OPEN_FORM,
            data0: openedFrom
        });
    }
}
class StatMainPageApi extends StatInstanceBase {
    goToStreamFromCarousel() {
        this.sendStat({
            action: EStatEventType.CAROUSEL_CLICK
        });
    }
    goToStreamFromCatalog(streamType) {
        this.sendStat({
            action: EStatEventType.STREAMS_CATALOG_CLICK,
            data0: streamType
        });
    }
    gotToRecordFromCatalog() {
        this.sendStat({
            action: EStatEventType.RECORDS_CATALOG_CLICK
        });
    }
}
class StatMarketingApi extends StatInstanceBase {
    showAlert({ alertId }) {
        this.sendStat({
            action: EStatEventType.MARKETING_ALERT_SHOW,
            data0: String(alertId)
        });
    }
    dismissAlert({ alertId }) {
        this.sendStat({
            action: EStatEventType.MARKETING_ALERT_DISMISS,
            data0: String(alertId)
        });
    }
    acceptAlert({ alertId }) {
        this.sendStat({
            action: EStatEventType.MARKETING_ALERT_ACCEPT,
            data0: String(alertId)
        }, true);
    }
}
class StatMediaAlbumApi extends StatInstanceBase {
    albumOpen() {
        this.sendStat({
            action: EStatEventType.MEDIA_ALBUM_PAGE_OPEN
        });
    }
    albumTypeFilterClick(type) {
        this.sendStat({
            action: EStatEventType.MEDIA_ALBUM_TYPE_FILTER_CLICK,
            data0: type
        });
    }
    tileClick(type) {
        this.sendStat({
            action: EStatEventType.MEDIA_ALBUM_TILE_CLICK,
            data0: type
        });
    }
}
class StatMediaViewerApi extends StatInstanceBase {
    viewerOpen({ contentType, openingSource }) {
        this.sendStat({
            action: EStatEventType.MEDIA_VIEWER_OPEN,
            data0: contentType,
            data1: openingSource
        });
    }
    itemShow({ contentType, transitionType, openingSource }) {
        this.sendStat({
            action: EStatEventType.MEDIA_VIEWER_ITEM_SHOW,
            data0: contentType,
            data1: transitionType,
            data2: openingSource
        });
    }
}
class StatMessageApi extends StatInstanceBase {
    downloadFile() {
        this.sendStat({
            action: EStatEventType.MESSAGE_FILE_DOWNLOAD
        });
    }
    audioPlay() {
        this.sendStat({
            action: EStatEventType.MESSAGE_AUDIO_PLAY
        });
    }
    audioPlayError() {
        this.sendStat({
            action: EStatEventType.MESSAGE_AUDIO_PLAY_ERROR
        });
    }
}
class StatNavigationApi extends StatInstanceBase {
    visitRoute({ isBlogger, shareReferrer, hasNotifications, hasMessages }) {
        const { locale: configLocale } = getConfig();
        const locale2 = getCookie(ECookieKey.LOCALE);
        this.sendStat({
            action: EStatEventType.ROUTE_ENTER,
            data0: shareReferrer != null ? shareReferrer : void 0,
            data1: locale2 || configLocale || void 0,
            data2: isBlogger ? "1" : "0",
            data3: hasNotifications ? "1" : "0",
            data4: hasMessages ? "1" : "0"
        });
    }
    notificationLinkClick() {
        this.sendStat({
            action: EStatEventType.NOTIFICATIONS_LINK_CLICK
        });
    }
    subcribeMobileClick() {
        this.sendStat({
            action: EStatEventType.SUBSCRIBE_MOBILE_CLICK
        });
    }
}
class StatNewsApi extends StatInstanceBase {
    popupClose(openedTime) {
        this.sendStat({
            action: EStatEventType.NEWS_POPUP_CLOSE,
            data0: String(openedTime)
        });
    }
}
class StatNotificationSettingsApi extends StatInstanceBase {
    webPushOk() {
        this.sendStat({
            action: EStatEventType.NOTIFICATION_SETTINGS_WEB_PUSH_OK
        });
    }
    webPushCancel() {
        this.sendStat({
            action: EStatEventType.NOTIFICATION_SETTINGS_WEB_PUSH_CANCEL
        });
    }
}
class StatPaymentWindowApi extends StatInstanceBase {
    sendPaymentAction(data) {
        this.sendStat(data);
    }
}
class StatPostApi extends StatInstanceBase {
    downloadFile() {
        this.sendStat({
            action: EStatEventType.POST_FILE_DOWNLOAD
        });
    }
    audioPlay() {
        this.sendStat({
            action: EStatEventType.POST_AUDIO_PLAY
        });
    }
    audioPlayError() {
        this.sendStat({
            action: EStatEventType.POST_AUDIO_PLAY_ERROR
        });
    }
}
class StatPublisherApi extends StatInstanceBase {
    uploadFile({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_FILE,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadFileSuccess({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_FILE_SUCCESS,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadFileError({ ext, type, size: size2, error: error2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_FILE_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2)
        });
    }
    uploadFileChunkError({ ext, type, size: size2, error: error2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_FILE_CHUNK_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2)
        });
    }
    uploadAudio({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_AUDIO,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadAudioSuccess({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_AUDIO_SUCCESS,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadAudioError({ ext, type, size: size2, error: error2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_AUDIO_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2)
        });
    }
    uploadAudioChunkError({ ext, type, size: size2, error: error2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_AUDIO_CHUNK_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2)
        });
    }
    uploadVideo({ ext, type, size: size2, vid, videoId }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO,
            data0: ext,
            data1: type,
            data2: String(size2),
            data3: videoId,
            data4: String(vid)
        });
    }
    uploadVideoSuccess({ ext, type, size: size2, vid, videoId }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_SUCCESS,
            data0: ext,
            data1: type,
            data2: String(size2),
            data3: videoId,
            data4: String(vid)
        });
    }
    uploadVideoError({ ext, type, size: size2, vid, videoId, error: error2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2),
            data4: videoId,
            data5: String(vid)
        });
    }
    uploadVideoRetry({ ext, type, size: size2, vid, videoId, retryCount }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_RETRY,
            data0: ext,
            data1: type,
            data2: String(size2),
            data3: videoId,
            data4: String(vid),
            data5: String(retryCount)
        });
    }
    uploadVideoChunkSuccess({ range: range2, ext, type, size: size2, vid, videoId, time: time2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_CHUNK_SUCCESS,
            data0: range2 || "",
            data1: ext,
            data2: type,
            data3: String(size2),
            data4: videoId,
            data5: String(vid),
            data6: String(time2)
        });
    }
    uploadVideoChunkError({ ext, type, size: size2, vid, videoId, error: error2, range: range2, time: time2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_CHUNK_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2),
            data4: videoId,
            data5: String(vid),
            data6: range2,
            data7: String(time2)
        });
    }
    uploadVideoChunkRetry({ ext, type, size: size2, vid, videoId, range: range2, retryCount, time: time2 }) {
        this.sendStat({
            action: EStatEventType.PUBLISHER_UPLOAD_VIDEO_CHUNK_RETRY,
            data1: ext,
            data2: type,
            data3: String(size2),
            data4: videoId,
            data5: String(vid),
            data6: range2,
            data7: String(time2),
            data8: String(retryCount)
        });
    }
}
class StatShareApi extends StatInstanceBase {
    openShareDropdown() {
        this.sendStat({
            action: EStatEventType.SHARE_DROPDOWN_SHOW
        });
    }
    shareDropdownItemClick(shareTarget) {
        this.sendStat({
            action: EStatEventType.SHARE_DROPDOWN_CLICK_ITEM,
            data0: shareTarget
        });
    }
    showPostPublishedOverlay() {
        this.sendStat({
            action: EStatEventType.POST_PUBLISHED_OVERLAY_SHOW
        });
    }
    postPublishedOverlayShareClick(shareTarget) {
        this.sendStat({
            action: EStatEventType.POST_PUBLISHED_OVERLAY_CLICK_SHARE,
            data0: shareTarget
        });
    }
}
class StatSinglePaymentApi extends StatInstanceBase {
    openPopup({ type, source, price }) {
        this.sendStat({
            action: EStatEventType.SINGLE_PAYMENT_POPUP_SHOW,
            data0: source,
            data1: `${price}`,
            data2: type
        });
    }
    show3ds({ type }) {
        this.sendStat({
            action: EStatEventType.SINGLE_PAYMENT_POPUP_3DS_SHOW,
            data0: type
        });
    }
    singlePaymentFinished({ result: result2, type, price, paymentId, transactionId, dmrErrorCode }) {
        this.sendStat({
            action: EStatEventType.SINGLE_PAYMENT_POPUP_FINISHED,
            data0: result2,
            data1: transactionId || "",
            data2: dmrErrorCode || "",
            data3: `${price}`,
            data4: type,
            data5: `${paymentId}`
        });
    }
}
class StatStreamApi extends StatInstanceBase {
    tabShow(tab2) {
        this.sendStat({
            action: EStatEventType.STREAM_TAB_SHOW,
            data0: tab2
        });
    }
}
class StatSubscriptionPurchaseApi extends StatInstanceBase {
    openPopup({ source, price }) {
        this.sendStat({
            action: EStatEventType.SUBSCRIBE_POPUP_SHOW,
            data0: source,
            data1: `${price}`
        });
    }
    show3ds() {
        this.sendStat({
            action: EStatEventType.SUBSCRIBE_POPUP_3DS_SHOW
        });
    }
    purchaseFinished({ result: result2, price, paymentId, transactionId, dmrErrorCode }) {
        this.sendStat({
            action: EStatEventType.SUBSCRIBE_POPUP_FINISHED,
            data0: result2,
            data1: transactionId || "",
            data2: dmrErrorCode || "",
            data3: `${price}`,
            data4: `${paymentId}`
        });
    }
}
class StatUploadApi extends StatInstanceBase {
    uploadFile({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.UPLOAD_FILE,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadFileSuccess({ ext, type, size: size2 }) {
        this.sendStat({
            action: EStatEventType.UPLOAD_FILE_SUCCESS,
            data0: ext,
            data1: type,
            data2: String(size2)
        });
    }
    uploadFileCancelled() {
        this.sendStat({
            action: EStatEventType.UPLOAD_FILE_CANCELLED
        });
    }
    uploadFileError({ ext, type, size: size2, error: error2 }) {
        this.sendStat({
            action: EStatEventType.UPLOAD_FILE_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2)
        });
    }
    uploadFileChunkError({ ext, type, size: size2, error: error2, range: range2, time: time2 }) {
        this.sendStat({
            action: EStatEventType.UPLOAD_FILE_CHUNK_ERROR,
            data0: error2 || "",
            data1: ext,
            data2: type,
            data3: String(size2),
            data4: range2,
            data5: String(time2)
        });
    }
}
class StatUserApi extends StatInstanceBase {
    setTheme(theme) {
        this.sendStat({
            action: EStatEventType.THEME,
            data0: theme
        });
    }
}
class StatVideoApi extends StatInstanceBase {
    started({ vid, videoId, duration: duration2, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_STARTED,
            data0: videoId,
            data1: String(vid),
            data2: String(duration2),
            data4: postId
        });
    }
    paused({ vid, videoId, time: time2, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_PAUSED,
            data0: videoId,
            data1: String(vid),
            data2: String(time2),
            data4: postId
        });
    }
    resumed({ vid, videoId, time: time2, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_RESUMED,
            data0: videoId,
            data1: String(vid),
            data2: String(time2),
            data4: postId
        });
    }
    ended({ vid, videoId, time: time2, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_ENDED,
            data0: videoId,
            data1: String(vid),
            data2: String(time2),
            data4: postId
        });
    }
    rewound({ vid, videoId, from: from2, to, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_REWOUND,
            data0: videoId,
            data1: String(vid),
            data2: String(from2),
            data3: String(to),
            data4: postId
        });
    }
    progress({ vid, videoId, time: time2, percent, postId }) {
        this.sendStat({
            action: EStatEventType.VIDEO_PROGRESS,
            data0: videoId,
            data1: String(vid),
            data2: String(time2),
            data3: String(percent),
            data4: postId
        });
    }
    loadPlayerError() {
        this.sendStat({
            action: EStatEventType.VIDEO_LOAD_PLAYER_ERROR
        });
    }
    startLoadingPlayer() {
        this.sendStat({
            action: EStatEventType.VIDEO_START_LOADING_PLAYER
        });
    }
}
class StatWidgetWebViewApi extends StatInstanceBase {
    // SUBSCRIPTION
    [EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_CANCEL]() {
        this.sendStat({
            action: EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_CANCEL,
            data0: getAppId()
        });
    }
    [EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_FAILURE]({ error: error2 }) {
        this.sendStat({
            action: EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_FAILURE,
            data0: getAppId(),
            data1: error2
        });
    }
    [EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_SHOW]() {
        this.sendStat({
            action: EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_SHOW,
            data0: getAppId()
        });
    }
    [EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_SUCCESS]() {
        this.sendStat({
            action: EStatEventType.WIDGET_WEB_VIEW_SUBSCRIBE_SUCCESS,
            data0: getAppId()
        });
    }
}
var EGraphitePaymentMetrics = /* @__PURE__ */ ((EGraphitePaymentMetrics2)=>{
    EGraphitePaymentMetrics2["DMR_FRAME_ERROR"] = "payments_dmr_frame_error";
    EGraphitePaymentMetrics2["CHECK_FAILED"] = "payments_check_failed";
    return EGraphitePaymentMetrics2;
})(EGraphitePaymentMetrics || {});
class StatGraphiteBase {
    send(metric) {
        sendToGraphite(metric);
    }
}
class StatGraphitePayments extends StatGraphiteBase {
    dmrFrameError() {
        this.send(EGraphitePaymentMetrics.DMR_FRAME_ERROR);
    }
    checkFailed() {
        this.send(EGraphitePaymentMetrics.CHECK_FAILED);
    }
}
var EStatGtmActions = /* @__PURE__ */ ((EStatGtmActions2)=>{
    EStatGtmActions2["CREATE_BLOG_SUCCESS"] = "CreateBlogSuccess";
    EStatGtmActions2["CREATE_TEAR_SUCCESS"] = "CreateTearSuccess";
    EStatGtmActions2["PAID_SUBSCRIPTION_SUCCESS"] = "PaidSubscriptionSuccess";
    EStatGtmActions2["PUBLIC_STREAMS_REQUEST_ACCESS_SUCCESS"] = "PUBLIC_STREAMS_REQUEST_ACCESS_SUCCESS";
    return EStatGtmActions2;
})(EStatGtmActions || {});
var EStatGtmEvents = /* @__PURE__ */ ((EStatGtmEvents2)=>{
    EStatGtmEvents2["MAIN_EVENT"] = "MainEvent";
    EStatGtmEvents2["BOOSTY_REGISTRATION"] = "Boosty_Registration";
    EStatGtmEvents2["BOOSTY_CREATOR_APPLICATION_START"] = "Boosty_CreatorApplicationStart";
    EStatGtmEvents2["BOOSTY_CREATOR_APPLICATION_COMPLETED"] = "Boosty_CreatorApplicationCompleted";
    return EStatGtmEvents2;
})(EStatGtmEvents || {});
class StatGtm {
    add(event2, action) {
        if (Array.isArray(window.GtmDataLayer)) window.GtmDataLayer.push({
            event: event2,
            ...action ? {
                action: action
            } : {}
        });
    }
    createBlogSuccess() {
        this.add(EStatGtmEvents.MAIN_EVENT, EStatGtmActions.CREATE_BLOG_SUCCESS);
    }
    createTearSuccess() {
        this.add(EStatGtmEvents.MAIN_EVENT, EStatGtmActions.CREATE_TEAR_SUCCESS);
    }
    paidSubscriptionSuccess() {
        this.add(EStatGtmEvents.MAIN_EVENT, EStatGtmActions.PAID_SUBSCRIPTION_SUCCESS);
    }
    requestPublicStreamsAccessSuccess() {
        this.add(EStatGtmEvents.MAIN_EVENT, EStatGtmActions.PUBLIC_STREAMS_REQUEST_ACCESS_SUCCESS);
    }
    registrationSuccess() {
        this.add(EStatGtmEvents.BOOSTY_REGISTRATION);
    }
    startBecomingAuthor() {
        this.add(EStatGtmEvents.BOOSTY_CREATOR_APPLICATION_START);
    }
    finishBecomingAuthor() {
        this.add(EStatGtmEvents.BOOSTY_CREATOR_APPLICATION_COMPLETED);
    }
}
class StatLocale extends StatInstanceBase {
    async selectLocale(locale2) {
        return this.sendStat({
            action: EStatEventType.SELECT_LOCALE,
            data0: locale2
        }, true);
    }
}
const SUBSCRIPTION_PURCHASE_SOURCE_QUERY_PARAM_NAME = "ssource";
const _AppStat = class _AppStat {
    static setCurrentUser(currentUser2) {
        this.currentUser = currentUser2;
    }
    static setRouteData(routeData) {
        this.routeData = routeData;
    }
};
_AppStat.log = {
    auth: new StatAuthApi(_AppStat),
    graphite: {
        payments: new StatGraphitePayments()
    },
    gtm: new StatGtm(),
    post: new StatPostApi(_AppStat),
    share: new StatShareApi(_AppStat),
    singlePayment: new StatSinglePaymentApi(_AppStat),
    subscriptionPurchase: new StatSubscriptionPurchaseApi(_AppStat),
    bank131Frame: new StatBank131FrameApi(_AppStat),
    blog: new StatBlogApi(_AppStat),
    dmrFrame: new StatDmrFrameApi(_AppStat),
    navigation: new StatNavigationApi(_AppStat),
    publisher: new StatPublisherApi(_AppStat),
    upload: new StatUploadApi(_AppStat),
    video: new StatVideoApi(_AppStat),
    locale: new StatLocale(_AppStat),
    marketing: new StatMarketingApi(_AppStat),
    notificationSettings: new StatNotificationSettingsApi(_AppStat),
    message: new StatMessageApi(_AppStat),
    mediaAlbum: new StatMediaAlbumApi(_AppStat),
    mediaViewer: new StatMediaViewerApi(_AppStat),
    banner: new StatBannerApi(_AppStat),
    donation: new StatDonationApi(_AppStat),
    paymentWindow: new StatPaymentWindowApi(_AppStat),
    widgets: {
        webView: new StatWidgetWebViewApi(_AppStat)
    },
    news: new StatNewsApi(_AppStat),
    mainPage: new StatMainPageApi(_AppStat),
    chat: new StatChatApi(_AppStat),
    stream: new StatStreamApi(_AppStat),
    user: new StatUserApi(_AppStat)
};
let AppStat = _AppStat;
var EStatSubscriptionPurchaseStartSource = /* @__PURE__ */ ((EStatSubscriptionPurchaseStartSource2)=>{
    EStatSubscriptionPurchaseStartSource2["SMILES_SELECTOR"] = "SMILES_SELECTOR";
    EStatSubscriptionPurchaseStartSource2["SMILE_INFO_TOOLTIP"] = "SMILE_INFO_TOOLTIP";
    EStatSubscriptionPurchaseStartSource2["SUBSCRIBE_LEVEL"] = "SUBSCRIBE_LEVEL";
    EStatSubscriptionPurchaseStartSource2["SUBSCRIBE_LEVEL_MEDIA"] = "SUBSCRIBE_LEVEL_MEDIA";
    EStatSubscriptionPurchaseStartSource2["BLOG_POST_SUBSCRIBE"] = "BLOG_POST_SUBSCRIBE";
    EStatSubscriptionPurchaseStartSource2["BLOG_STREAM_SUBSCRIBE"] = "BLOG_STREAM_SUBSCRIBE";
    EStatSubscriptionPurchaseStartSource2["BLOG_EXTERNAL_STREAM_SUBSCRIBE"] = "BLOG_EXTERNAL_STREAM_SUBSCRIBE";
    EStatSubscriptionPurchaseStartSource2["NOTICE_LIST"] = "NOTICE_LIST";
    EStatSubscriptionPurchaseStartSource2["AFTER_FOLLOW_POPUP"] = "AFTER_FOLLOW_POPUP";
    EStatSubscriptionPurchaseStartSource2["WEB_VIEW"] = "WEB_VIEW";
    EStatSubscriptionPurchaseStartSource2["DIRECT"] = "DIRECT";
    return EStatSubscriptionPurchaseStartSource2;
})(EStatSubscriptionPurchaseStartSource || {});
const getFromLocalStorage = (key)=>{
    try {
        return window.localStorage.getItem(String(key));
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed read key ${String(key)} from localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
        return null;
    }
};
const getParsedFromLocalStorage = (key)=>{
    try {
        return JSON.parse(getFromLocalStorage(key));
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed parse JSON from localStorage item ${String(key)} : ${err && err.toString() ? err.toString() : String(err)}`);
        return null;
    }
};
const setToLocalStorage = (key, value2)=>{
    try {
        window.localStorage.setItem(String(key), value2);
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed write key ${String(key)} to localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
    }
};
const removeFromLocalStorage = (key)=>{
    try {
        window.localStorage.removeItem(String(key));
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed remove key ${String(key)} from localStorage: ${err && err.toString() ? err.toString() : String(err)}`);
    }
};
const clearAuthLocalStorage = ()=>{
    removeFromLocalStorage(ELocalStorageKey.AUTH);
};
const isSafariBrowser = ()=>!!navigator.userAgent.match(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari/);
const BlogPostFromContext = $acw62.createContext(null);
const useBlogPostFrom = ()=>$acw62.useContext(BlogPostFromContext);
async function getImageDimensions(imageFile) {
    return new Promise((resolve)=>{
        const image2 = new Image();
        image2.onload = ()=>{
            resolve({
                width: image2.width,
                height: image2.height
            });
        };
        image2.src = URL.createObjectURL(imageFile);
    });
}
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function _extends$3() {
    _extends$3 = Object.assign ? Object.assign.bind() : function(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
        }
        return target2;
    };
    return _extends$3.apply(this, arguments);
}
var Action$1;
(function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
})(Action$1 || (Action$1 = {}));
function invariant(value2, message2) {
    if (value2 === false || value2 === null || typeof value2 === "undefined") throw new Error(message2);
}
function warning$2(cond, message2) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message2);
        try {
            throw new Error(message2);
        } catch (e2) {}
    }
}
function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path2) {
    let parsedPath = {};
    if (path2) {
        let hashIndex = path2.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path2.substr(hashIndex);
            path2 = path2.substr(0, hashIndex);
        }
        let searchIndex = path2.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path2.substr(searchIndex);
            path2 = path2.substr(0, searchIndex);
        }
        if (path2) parsedPath.pathname = path2;
    }
    return parsedPath;
}
var ResultType;
(function(ResultType2) {
    ResultType2["data"] = "data";
    ResultType2["deferred"] = "deferred";
    ResultType2["redirect"] = "redirect";
    ResultType2["error"] = "error";
})(ResultType || (ResultType = {}));
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match2 = pathname.match(matcher);
    if (!match2) return null;
    let matchedPathname = match2[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match2.slice(1);
    let params = compiledParams.reduce((memo, _ref, index2)=>{
        let { paramName, isOptional } = _ref;
        if (paramName === "*") {
            let splatValue = captureGroups[index2] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value2 = captureGroups[index2];
        if (isOptional && !value2) memo[paramName] = void 0;
        else memo[paramName] = safelyDecodeURIComponent(value2 || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path2, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning$2(path2 === "*" || !path2.endsWith("*") || path2.endsWith("/*"), 'Route path "' + path2 + '" will be treated as if it were ' + ('"' + path2.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path2.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path2.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_2, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path2.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path2 === "*" || path2 === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path2 !== "" && path2 !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function safelyDecodeURIComponent(value2, paramName) {
    try {
        return decodeURIComponent(value2);
    } catch (error2) {
        warning$2(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value2 + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error2 + ")."));
        return value2;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path2) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path2) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function getPathContributingMatches(matches2) {
    return matches2.filter((match2, index2)=>index2 === 0 || match2.route.path && match2.route.path.length > 0);
}
function getResolveToMatches(matches2, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches2);
    if (v7_relativeSplatPath) return pathMatches.map((match2, idx)=>idx === matches2.length - 1 ? match2.pathname : match2.pathnameBase);
    return pathMatches.map((match2)=>match2.pathnameBase);
}
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends$3({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from2;
    if (toPathname == null) from2 = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from2 = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path2 = resolvePath(to, from2);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path2.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path2.pathname += "/";
    return path2;
}
const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
new Set(validRequestMethodsArr);
/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ const DataRouterContext = /* @__PURE__ */ $acw62.createContext(null);
const DataRouterStateContext = /* @__PURE__ */ $acw62.createContext(null);
const AwaitContext = /* @__PURE__ */ $acw62.createContext(null);
const NavigationContext = /* @__PURE__ */ $acw62.createContext(null);
const LocationContext = /* @__PURE__ */ $acw62.createContext(null);
const RouteContext = /* @__PURE__ */ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /* @__PURE__ */ $acw62.createContext(null);
function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && invariant(false);
    let { basename, navigator: navigator2 } = $acw62.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $acw62.useContext(LocationContext) != null;
}
function useLocation() {
    !useInRouterContext() && invariant(false);
    return $acw62.useContext(LocationContext).location;
}
function useParams() {
    let { matches: matches2 } = $acw62.useContext(RouteContext);
    let routeMatch = matches2[matches2.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = $acw62.useContext(NavigationContext);
    let { matches: matches2 } = $acw62.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches2, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
var DataRouterStateHook$1 = /* @__PURE__ */ function(DataRouterStateHook2) {
    DataRouterStateHook2["UseBlocker"] = "useBlocker";
    DataRouterStateHook2["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook2["UseActionData"] = "useActionData";
    DataRouterStateHook2["UseRouteError"] = "useRouteError";
    DataRouterStateHook2["UseNavigation"] = "useNavigation";
    DataRouterStateHook2["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook2["UseMatches"] = "useMatches";
    DataRouterStateHook2["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook2["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook2["UseRouteId"] = "useRouteId";
    return DataRouterStateHook2;
}(DataRouterStateHook$1 || {});
function getDataRouterConsoleError$1(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useRouteContext(hookName) {
    let route = $acw62.useContext(RouteContext);
    !route && invariant(false);
    return route;
}
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && invariant(false);
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook$1.UseRouteId);
}
new Promise(()=>{});
const isPathMatching = (pathname, route, strict = true)=>{
    const routes = Array.isArray(route) ? route : [
        route
    ];
    if (pathname === URLS.MAIN && routes.includes(URLS.MAIN)) return true;
    return routes.filter((routeItem)=>routeItem !== URLS.MAIN).some((routeItem)=>Boolean(matchPath({
            path: routeItem,
            end: strict
        }, pathname)));
};
const getScrollIntoViewOptions = (block2 = "center", behavior = "smooth")=>{
    if (isSafariBrowser()) return false;
    else return {
        behavior: behavior,
        block: block2
    };
};
const getInitialLayers = ()=>{
    return [
        {}
    ];
};
const isEditing = (element)=>{
    const isInputElement2 = element.matches("input");
    const isTextareaElement2 = element.matches("textarea");
    const isEditorElement = element.matches('div[contentEditable="true"]');
    return isInputElement2 || isTextareaElement2 || isEditorElement;
};
const _Hotkeys = class _Hotkeys {
    static getCurrentLayer() {
        return this.layers[this.layers.length - 1];
    }
    static init() {
        if (this.isListening) return;
        window.addEventListener("keydown", this.handleKeyDown);
        this.isListening = true;
    }
    static destroy() {
        window.removeEventListener("keydown", this.handleKeyDown);
        this.layers = getInitialLayers();
        this.isDisabled = false;
        this.isListening = false;
    }
    static addHandler(keyboardCode, handlerAdding) {
        if (!handlerAdding || typeof handlerAdding !== "function") return;
        const currentLayer = this.getCurrentLayer();
        if (!currentLayer[keyboardCode]) currentLayer[keyboardCode] = [];
        const handlers = currentLayer[keyboardCode];
        const hasHandler = handlers.some((handler2)=>{
            return handler2.toString() === handlerAdding.toString();
        });
        if (!hasHandler) handlers.push(handlerAdding);
    }
    static removeHandler(keyboardCode, handlerRemoving) {
        if (!handlerRemoving || typeof handlerRemoving !== "function") return;
        const currentLayer = this.getCurrentLayer();
        const handlers = currentLayer[keyboardCode];
        if (handlers) {
            const removalIndex = handlers.findIndex((handler2)=>{
                return handler2.toString() === handlerRemoving.toString();
            });
            if (removalIndex > -1) handlers.splice(removalIndex, 1);
        }
    }
    static createLayer() {
        this.layers.push({});
    }
    static deleteCurrentLayer() {
        this.layers.pop();
        if (this.layers.length === 0) this.layers = getInitialLayers();
    }
    static enable() {
        this.isDisabled = false;
    }
    static disable() {
        this.isDisabled = true;
    }
    static handleKeyDown(event2) {
        var _a3;
        if (_Hotkeys.isDisabled || isEditing(event2.target)) return;
        const currentLayer = _Hotkeys.getCurrentLayer();
        (_a3 = currentLayer[event2.code]) == null || _a3.forEach((handler2)=>{
            handler2();
        });
    }
};
_Hotkeys.isListening = false;
_Hotkeys.isDisabled = false;
_Hotkeys.layers = getInitialLayers();
let Hotkeys = _Hotkeys;
let referer = "";
const getSuperReferer = ()=>{
    try {
        if (!referer && window && window.parent !== window) referer = get(document, "referrer", "");
    } catch (ignore) {}
    return referer;
};
const getExtendedState = (state, isExternalAccountLink)=>{
    let extendedState = state;
    const stateParts = state.split("***");
    if (isExternalAccountLink) try {
        const [sourceState, , prov] = stateParts;
        const encodedSourceState = prov === dist$3.ProviderCodes.VK ? decodeURIComponent(decodeURIComponent(sourceState)) : decodeURIComponent(sourceState);
        extendedState = encodeURIComponent(JSON.stringify({
            ...JSON.parse(encodedSourceState),
            isExternalAccountLink: isExternalAccountLink
        }));
        extendedState += "***" + stateParts.slice(1).join("***");
        if (prov === dist$3.ProviderCodes.VK) extendedState = encodeURIComponent(extendedState);
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed parse state: ${err && err.toString() ? err.toString() : String(err)}`);
    }
    return extendedState;
};
const getOAuthProviders = (params)=>{
    const CONFIG2 = getConfig();
    const unregId = `${getAppId()}:${CONFIG2.clientId}`;
    const hasProvider = (name2)=>CONFIG2.oauthProviders && CONFIG2.oauthProviders[name2];
    const from2 = getReferer();
    const redirectAppId = CONFIG2.appId;
    const appState = JSON.stringify({
        unregId: unregId,
        from: from2,
        redirectAppId: redirectAppId
    });
    const VKProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.vk.appId,
            scope: CONFIG2.oauthProviders.vk.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://oauth.vk.com/authorize?client_id=${appId}&display=page&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&v=5.73&scope=${scope}&redirect_uri=${redirectUrl}`,
            apiUrl: CONFIG2.oauthProviders.vk.tokenEndpoint,
            width: 670,
            height: 370,
            code: dist$3.ProviderCodes.VK,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const FacebookOAuthProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.fb.appId,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://www.facebook.com/v3.0/dialog/oauth?client_id=${appId}&redirect_uri=${redirectUrl}&state=${getExtendedState(state, isExternalAccountLink)}`,
            apiUrl: CONFIG2.oauthProviders.fb.tokenEndpoint,
            width: 620,
            height: 560,
            code: dist$3.ProviderCodes.FB,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const OKProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.ok.appId,
            scope: CONFIG2.oauthProviders.ok.scope,
            redirectUrl: CONFIG2.oauthRedirect,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://connect.ok.ru/oauth/authorize?client_id=${appId}&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&scope=${scope}&redirect_uri=${redirectUrl}`,
            apiUrl: CONFIG2.oauthProviders.ok.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.OK,
            state: appState,
            isAuthorizeEnabled: true
        });
    const MailProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.mr.appId,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://connect.mail.ru/oauth/authorize?client_id=${appId}&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&redirect_uri=${redirectUrl}`,
            apiUrl: CONFIG2.oauthProviders.mr.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.MailRu,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const GoogleProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.google.appId,
            scope: CONFIG2.oauthProviders.google.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://accounts.google.com/o/oauth2/v2/auth?client_id=${appId}&redirect_uri=${redirectUrl}&access_type=offline&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&scope=${scope}`,
            apiUrl: CONFIG2.oauthProviders.google.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.Google,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const YoutubeProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.youtube.appId,
            scope: CONFIG2.oauthProviders.youtube.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://accounts.google.com/o/oauth2/v2/auth?client_id=${appId}&redirect_uri=${redirectUrl}&access_type=offline&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&scope=${scope}`,
            apiUrl: CONFIG2.oauthProviders.youtube.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.Youtube,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const TwitchProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.twitch.appId,
            scope: CONFIG2.oauthProviders.twitch.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://id.twitch.tv/oauth2/authorize?client_id=${appId}&redirect_uri=${redirectUrl}&response_type=code&state=${getExtendedState(state, isExternalAccountLink)}&hl=en`,
            apiUrl: CONFIG2.oauthProviders.twitch.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.Twitch,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    const DiscordProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.discord.appId,
            scope: CONFIG2.oauthProviders.discord.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://discordapp.com/api/oauth2/authorize?response_type=code&client_id=${appId}&state=${getExtendedState(state, isExternalAccountLink)}&scope=${scope}&access_type=offline&redirect_uri=${redirectUrl}`,
            apiUrl: CONFIG2.oauthProviders.discord.tokenEndpoint,
            width: 600,
            height: 345,
            code: dist$3.ProviderCodes.Discord,
            redirectUrl: isStreamApp() ? CONFIG2.oauthProviders.discord.redirectUrl : CONFIG2.oauthRedirect,
            isRejectByCloseWindow: false,
            isIgnoreTokens: true,
            state: appState,
            isAuthorizeEnabled: false
        });
    const DiscordBotProvider = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.discordBot.appId,
            scope: CONFIG2.oauthProviders.discordBot.scope,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>`https://discordapp.com/api/oauth2/authorize?response_type=code&client_id=${appId}&state=${getExtendedState(state, isExternalAccountLink)}&scope=${scope}&redirect_uri=${redirectUrl}&permissions=${CONFIG2.oauthProviders.discordBot.permissions}`,
            apiUrl: CONFIG2.oauthProviders.discordBot.tokenEndpoint,
            width: 600,
            height: 750,
            code: dist$3.ProviderCodes.DiscordBot,
            redirectUrl: CONFIG2.discordLinkRedirect,
            isRejectByCloseWindow: false,
            isIgnoreTokens: true,
            state: appState,
            isAuthorizeEnabled: false
        });
    const VKPlay = ()=>new dist$3.OAuthProvider({
            appId: CONFIG2.oauthProviders.vkplay.appId,
            urlTemplate: (appId, scope, redirectUrl, state, isExternalAccountLink)=>{
                var _a3;
                const host = CONFIG2.isTestServer ? "account.dev-vkplay.ru" : "account.vkplay.ru";
                let skipGrantsParam = "";
                const skipGrants = (_a3 = CONFIG2.oauthProviders.vkplay.skipGrants) == null ? void 0 : _a3.enabled;
                if (skipGrants && !getCookie(ECookieKey.SKIP_GRANTS)) skipGrantsParam = `&skip_grants=${Number(skipGrants)}`;
                let ignoreCurrentSessionParam = "";
                return `https://${host}/oauth2/?client_id=${appId}&response_type=code${skipGrantsParam}&state=${getExtendedState(state, isExternalAccountLink)}&redirect_uri=${redirectUrl}${ignoreCurrentSessionParam}`;
            },
            apiUrl: CONFIG2.oauthProviders.vkplay.tokenEndpoint,
            width: 670,
            height: 370,
            code: dist$3.ProviderCodes.VKPlay,
            redirectUrl: CONFIG2.oauthRedirect,
            state: appState,
            isAuthorizeEnabled: true
        });
    return [
        /* eslint-disable new-cap */ hasProvider("vk") && VKProvider(),
        hasProvider("fb") && FacebookOAuthProvider(),
        hasProvider("youtube") && YoutubeProvider(),
        hasProvider("google") && GoogleProvider(),
        hasProvider("mr") && MailProvider(),
        hasProvider("ok") && OKProvider(),
        hasProvider("twitch") && TwitchProvider(),
        hasProvider("discord") && DiscordProvider(),
        hasProvider("discordBot") && DiscordBotProvider(),
        hasProvider("vkplay") && VKPlay()
    ].filter((v2)=>Boolean(v2));
};
const getOAuthProviderByCode = (code, params)=>{
    const providers = getOAuthProviders();
    return providers.find((item2)=>item2.code.toLowerCase() === code.toLowerCase());
};
const getProviderActions = ()=>{
    const actions2 = new dist$3.AuthActions({
        providers: getOAuthProviders(),
        api: {
            get: async (url)=>{
                const { isWidget, isMobile: isMobile2 } = getConfig();
                const resp = await Api$1.base.get({
                    apiUrl: url,
                    url: // TODO SR: какой тут api url?
                    url,
                    headers: {
                        ["X-App"]: isWidget && !isMobile2 ? EAppId.WEB_WIDGETS : getAppId()
                    }
                });
                return resp.data;
            },
            post: async (url, data)=>{
                const { isWidget, isMobile: isMobile2 } = getConfig();
                const isPhoneTokenUrl = url === API_URL.OAUTH_PHONE_TOKEN;
                const invite = isConditionalFeatureEnable(EConditionalFeature.INVITES) && getCookie(ECookieKey.INVITE);
                const resp = await Api$1.base.post({
                    apiUrl: url,
                    url: // TODO SR: какой тут api url?
                    url,
                    data: data,
                    headers: {
                        ["X-App"]: isWidget && !isMobile2 ? EAppId.WEB_WIDGETS : getAppId(),
                        ...isPhoneTokenUrl && invite && {
                            ["X-Invite"]: invite
                        }
                    }
                });
                if (isPhoneTokenUrl) return {
                    ...resp.data,
                    isNewUser: Number(resp.headers["X-New-User"]) === 1
                };
                return resp.data;
            }
        },
        cookieName: ECookieKey.AUTH,
        setCookie: (token2)=>{
            const { oauthCookieDomain } = getConfig();
            const expires = new Date(Number(token2.expiresAt) + 1814400000).toUTCString();
            try {
                document.cookie = `${ECookieKey.AUTH}=${JSON.stringify(token2)};domain=${oauthCookieDomain};expires=${expires};path=/;SameSite=None;Secure;`;
            } catch (err) {
                Log$5.error("Failed write auth cookie: ", err);
            }
            TemporaryStorage.setItem("token", token2);
        },
        resetCookie: ()=>{
            const { oauthCookieDomain } = getConfig();
            document.cookie = `${ECookieKey.AUTH}=;expires=${/* @__PURE__ */ new Date(0).toUTCString()}${oauthCookieDomain ? ";path=/;domain=" + oauthCookieDomain : ""};Secure;`;
            document.cookie = `${ECookieKey.NEW_USER}=;expires=${/* @__PURE__ */ new Date(0).toUTCString()}${oauthCookieDomain ? ";path=/;domain=" + oauthCookieDomain : ""};Secure;`;
            clearAuthLocalStorage();
            TemporaryStorage.removeItem("auth");
            TemporaryStorage.removeItem("token");
        },
        getUserData: async ()=>{
            const resp = await Api$1.user.fetchCurrent();
            return resp.data;
        },
        refreshToken: async (refreshToken)=>{
            const { clientId } = getConfig();
            const appId = getAppId();
            if (refreshToken) {
                const resp = await Api$1.user.refreshToken({
                    refreshToken: refreshToken,
                    appId: appId,
                    fromId: clientId
                });
                return resp.data;
            }
            return void 0;
        }
    });
    const requestAuthSource = actions2.requestAuth.bind(actions2);
    actions2.requestAuth = (provider, packProvInState, isExternalAccountLink)=>{
        const { isMobile: isMobile2, isWidget, isFromStreams } = getConfig();
        return isMobile2 && !isWidget && !isFromStreams && !isStreamApp() ? actions2.authWithRedirect(provider) : requestAuthSource(provider, packProvInState, isExternalAccountLink);
    };
    actions2.tryInstantAuth = actions2.tryInstantAuth.bind(actions2);
    actions2.tryRestoreAuth = actions2.tryRestoreAuth.bind(actions2);
    actions2.restoreSession = actions2.restoreSession.bind(actions2);
    actions2.authorizeByPhone = actions2.authorizeByPhone.bind(actions2);
    actions2.fetchTokenByPhone = actions2.fetchTokenByPhone.bind(actions2);
    actions2.authorizeByOAuth = actions2.authorizeByOAuth.bind(actions2);
    actions2.checkApp = actions2.checkApp.bind(actions2);
    return actions2;
};
const cookiesStoreForFrame = {
    authToken: null
};
function setAuthCookie(accessToken) {
    cookiesStoreForFrame.authToken = accessToken;
    getProviderActions().setCookie(accessToken);
}
function tryGetAuthCookie() {
    const tokenReadFromCookie = getProviderActions().tryGetCookie();
    if (!tokenReadFromCookie && cookiesStoreForFrame.authToken) return cookiesStoreForFrame.authToken;
    if (!tokenReadFromCookie && !cookiesStoreForFrame.authToken && TemporaryStorage.getItem("token")) return TemporaryStorage.getItem("token");
    return tokenReadFromCookie;
}
function isForeign(url) {
    const urlHost = /^(https?:)?\/\//.test(url) && url.substring(url.indexOf("//"), url.indexOf("/", 9));
    const { hosts: { api: apiHost, uploadImg: uploadImgHost, uploadRegExp } } = getConfig();
    return urlHost && urlHost !== window.location.host && urlHost !== apiHost && urlHost !== uploadImgHost && !new RegExp(`^${uploadRegExp}$`).test(urlHost);
}
const _HttpTransportBrowser = class _HttpTransportBrowser {
    static setup(getAuthToken, sdkVariant) {
        const { hosts: hosts2 } = getConfig();
        axios$1.defaults.baseURL = hosts2.api;
        if (sdkVariant) this.sdkVariant = sdkVariant;
        if (getAuthToken) this.getAuthToken = getAuthToken;
        this.setUnregHeaders();
        this.setAuthorizationHeader();
        this.setRefererHeader();
        this.setLocaleHeader();
        this.setSuperReferer();
        this.setResourceIdHeader();
    }
    static async http(params) {
        const { isWithCredentialsEnable } = getConfig();
        return axios$1({
            // eslint-disable-next-line import/no-named-as-default-member
            cancelToken: new axios$1.CancelToken((abort)=>params.getAbort && params.getAbort(abort)),
            ...params,
            withCredentials: isWithCredentialsEnable
        });
    }
    static setUnregHeaders() {
        const { clientId } = getConfig();
        axios$1.interceptors.request.use((config2)=>{
            if (isForeign(config2.url)) return config2;
            const headers = {
                ...config2.headers
            };
            return {
                ...config2,
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                headers: filterHeaderDuplicates({
                    ["X-From-Id"]: clientId,
                    ["X-App"]: getAppId(),
                    ["X-SDK-App"]: this.sdkVariant,
                    ...headers
                })
            };
        });
    }
    static setSuperReferer() {
        axios$1.interceptors.request.use((config2)=>{
            const referrerUrl = getSuperReferer();
            return {
                ...config2,
                headers: {
                    ...config2.headers,
                    ["X-Super-Referer"]: referrerUrl
                }
            };
        });
    }
    static setAuthorizationHeader() {
        axios$1.interceptors.request.use((config2)=>{
            var _a3;
            if (isForeign(config2.url)) return config2;
            const authToken = this.getAuthToken();
            if (authToken == null) return config2;
            const path2 = String((_a3 = config2.url) == null ? void 0 : _a3.split("?")[0]).replace(/^\/v\d/, "");
            const authorizationExcludedUrls = [
                API_URL.OAUTH_PHONE_TOKEN,
                API_URL.USER_PHONE_CHECK,
                API_URL.OAUTH_PHONE_AUTHORIZE,
                API_URL.STAT,
                API_URL.USER_CURRENT_FETCH_VKPLAY_FOR_MERGE
            ];
            const isAuthorizationExcludedUrl = authorizationExcludedUrls.includes(path2);
            if (isAuthorizationExcludedUrl) return config2;
            const { ["Authorization"]: authHeader, ...headers } = {
                ...config2.headers
            };
            if (authHeader === null) return {
                ...config2,
                headers: headers
            };
            return {
                ...config2,
                headers: {
                    ...headers,
                    ["Authorization"]: authHeader || `Bearer ${authToken.accessToken}`
                }
            };
        });
    }
    static setRefererHeader() {
        const { isRefHeaderEnable } = getConfig();
        axios$1.interceptors.request.use((config2)=>{
            if (isForeign(config2.url) || !isRefHeaderEnable) return config2;
            return {
                ...config2,
                headers: {
                    ...config2.headers,
                    ["X-Referer"]: getReferer()
                }
            };
        });
    }
    static setLocaleHeader() {
        const { isLocaleHeaderEnable, locale: locale2 } = getConfig();
        axios$1.interceptors.request.use((config2)=>{
            if (isForeign(config2.url) || !isLocaleHeaderEnable) return config2;
            return {
                ...config2,
                headers: {
                    ...config2.headers,
                    ["X-Locale"]: locale2
                }
            };
        });
    }
    static setResourceIdHeader() {
        const { isResourceIdHeaderEnable } = getConfig();
        axios$1.interceptors.request.use((config2)=>{
            if (isForeign(config2.url) || !isResourceIdHeaderEnable) return config2;
            return {
                ...config2,
                headers: {
                    ...config2.headers,
                    ["X-Resource-Id"]: getApiResourceId(config2.method, config2.apiUrl)
                }
            };
        });
    }
};
_HttpTransportBrowser.axios = axios$1;
_HttpTransportBrowser.getAuthToken = tryGetAuthCookie;
let HttpTransportBrowser = _HttpTransportBrowser;
var createNumberMask$1 = {
    exports: {}
};
(function(module2, exports2) {
    !function(e2, t2) {
        module2.exports = t2();
    }(commonjsGlobal, function() {
        return function(e2) {
            function t2(n2) {
                if (o2[n2]) return o2[n2].exports;
                var i = o2[n2] = {
                    exports: {},
                    id: n2,
                    loaded: false
                };
                return e2[n2].call(i.exports, i, i.exports, t2), i.loaded = true, i.exports;
            }
            var o2 = {};
            return t2.m = e2, t2.c = o2, t2.p = "", t2(0);
        }([
            function(e2, t2, o2) {
                e2.exports = o2(2);
            },
            ,
            function(e2, t2) {
                function o2() {
                    function e3() {
                        var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l2, t4 = e4.length;
                        if (e4 === l2 || e4[0] === y2[0] && 1 === t4) return y2.split(l2).concat([
                            v2
                        ]).concat(g2.split(l2));
                        if (e4 === k2 && M2) return y2.split(l2).concat([
                            "0",
                            k2,
                            v2
                        ]).concat(g2.split(l2));
                        var o4 = e4[0] === s2 && q2;
                        o4 && (e4 = e4.toString().substr(1));
                        var c3 = e4.lastIndexOf(k2), u3 = c3 !== -1, a3 = void 0, b3 = void 0, h3 = void 0;
                        if (e4.slice(T2 * -1) === g2 && (e4 = e4.slice(0, T2 * -1)), u3 && (M2 || $) ? (a3 = e4.slice(e4.slice(0, R2) === y2 ? R2 : 0, c3), b3 = e4.slice(c3 + 1, t4), b3 = n2(b3.replace(f2, l2))) : a3 = e4.slice(0, R2) === y2 ? e4.slice(R2) : e4, P2 && ("undefined" == typeof P2 ? "undefined" : r2(P2)) === p2) {
                            var S3 = "." === j2 ? "[.]" : "" + j2, w3 = (a3.match(new RegExp(S3, "g")) || []).length;
                            a3 = a3.slice(0, P2 + w3 * Z2);
                        }
                        return a3 = a3.replace(f2, l2), E2 || (a3 = a3.replace(/^0+(0$|[^0])/, "$1")), a3 = x2 ? i(a3, j2) : a3, h3 = n2(a3), (u3 && M2 || $ === true) && (e4[c3 - 1] !== k2 && h3.push(m2), h3.push(k2, m2), b3 && (("undefined" == typeof L2 ? "undefined" : r2(L2)) === p2 && (b3 = b3.slice(0, L2)), h3 = h3.concat(b3)), $ === true && e4[c3 - 1] === k2 && h3.push(v2)), R2 > 0 && (h3 = y2.split(l2).concat(h3)), o4 && (h3.length === R2 && h3.push(v2), h3 = [
                            d2
                        ].concat(h3)), g2.length > 0 && (h3 = h3.concat(g2.split(l2))), h3;
                    }
                    var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, o3 = t3.prefix, y2 = void 0 === o3 ? c2 : o3, b2 = t3.suffix, g2 = void 0 === b2 ? l2 : b2, h2 = t3.includeThousandsSeparator, x2 = void 0 === h2 || h2, S2 = t3.thousandsSeparatorSymbol, j2 = void 0 === S2 ? u2 : S2, w2 = t3.allowDecimal, M2 = void 0 !== w2 && w2, N = t3.decimalSymbol, k2 = void 0 === N ? a2 : N, D2 = t3.decimalLimit, L2 = void 0 === D2 ? 2 : D2, O2 = t3.requireDecimal, $ = void 0 !== O2 && O2, _2 = t3.allowNegative, q2 = void 0 !== _2 && _2, B3 = t3.allowLeadingZeroes, E2 = void 0 !== B3 && B3, I2 = t3.integerLimit, P2 = void 0 === I2 ? null : I2, R2 = y2 && y2.length || 0, T2 = g2 && g2.length || 0, Z2 = j2 && j2.length || 0;
                    return e3.instanceOf = "createNumberMask", e3;
                }
                function n2(e3) {
                    return e3.split(l2).map(function(e4) {
                        return v2.test(e4) ? v2 : e4;
                    });
                }
                function i(e3, t3) {
                    return e3.replace(/\B(?=(\d{3})+(?!\d))/g, t3);
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                });
                var r2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
                    return typeof e3;
                } : function(e3) {
                    return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
                };
                t2.default = o2;
                var c2 = "$", l2 = "", u2 = ",", a2 = ".", s2 = "-", d2 = /-/, f2 = /\D+/g, p2 = "number", v2 = /\d/, m2 = "[]";
            }
        ]);
    });
})(createNumberMask$1);
var createNumberMaskExports = createNumberMask$1.exports;
const createNumberMask = /* @__PURE__ */ getDefaultExportFromCjs(createNumberMaskExports);
const defaultPattern = {
    "#": /\d/,
    "*": /./
};
const makePattern = (input2, map = defaultPattern)=>input2.split("").map((char)=>map[char] || char);
createNumberMask({
    prefix: "+",
    suffix: "",
    includeThousandsSeparator: false
});
makePattern("#### #### #### ####");
makePattern("##.##.####");
makePattern("## ## ######");
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(d2, b2) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d3, b3) {
        d3.__proto__ = b3;
    } || function(d3, b3) {
        for(var p2 in b3)if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
    };
    return extendStatics(d2, b2);
};
function __extends$2(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null) throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics(d2, b2);
    function __() {
        this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
function __awaiter$2(thisArg, _arguments, P2, generator) {
    function adopt(value2) {
        return value2 instanceof P2 ? value2 : new P2(function(resolve) {
            resolve(value2);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value2) {
            try {
                step(generator.next(value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function rejected(value2) {
            try {
                step(generator["throw"](value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, [])).next());
    });
}
function __generator$1(thisArg, body2) {
    var _2 = {
        label: 0,
        sent: function() {
            if (t2[0] & 1) throw t2[1];
            return t2[1];
        },
        trys: [],
        ops: []
    }, f2, y2, t2, g2;
    return g2 = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
    }), g2;
    function verb(n2) {
        return function(v2) {
            return step([
                n2,
                v2
            ]);
        };
    }
    function step(op) {
        if (f2) throw new TypeError("Generator is already executing.");
        while(_2)try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done) return t2;
            if (y2 = 0, t2) op = [
                op[0] & 2,
                t2.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t2 = op;
                    break;
                case 4:
                    _2.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _2.label++;
                    y2 = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _2.ops.pop();
                    _2.trys.pop();
                    continue;
                default:
                    if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _2 = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                        _2.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _2.label < t2[1]) {
                        _2.label = t2[1];
                        t2 = op;
                        break;
                    }
                    if (t2 && _2.label < t2[2]) {
                        _2.label = t2[2];
                        _2.ops.push(op);
                        break;
                    }
                    if (t2[2]) _2.ops.pop();
                    _2.trys.pop();
                    continue;
            }
            op = body2.call(thisArg, _2);
        } catch (e2) {
            op = [
                6,
                e2
            ];
            y2 = 0;
        } finally{
            f2 = t2 = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var Bounds = /** @class */ function() {
    function Bounds2(left2, top2, width, height) {
        this.left = left2;
        this.top = top2;
        this.width = width;
        this.height = height;
    }
    Bounds2.prototype.add = function(x2, y2, w2, h2) {
        return new Bounds2(this.left + x2, this.top + y2, this.width + w2, this.height + h2);
    };
    Bounds2.fromClientRect = function(context, clientRect) {
        return new Bounds2(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
    };
    Bounds2.fromDOMRectList = function(context, domRectList) {
        var domRect = Array.from(domRectList).find(function(rect) {
            return rect.width !== 0;
        });
        return domRect ? new Bounds2(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds2.EMPTY;
    };
    Bounds2.EMPTY = new Bounds2(0, 0, 0, 0);
    return Bounds2;
}();
var parseBounds = function(context, node) {
    return Bounds.fromClientRect(context, node.getBoundingClientRect());
};
var toCodePoints$1 = function(str) {
    var codePoints = [];
    var i = 0;
    var length = str.length;
    while(i < length){
        var value2 = str.charCodeAt(i++);
        if (value2 >= 55296 && value2 <= 56319 && i < length) {
            var extra = str.charCodeAt(i++);
            if ((extra & 64512) === 56320) codePoints.push(((value2 & 1023) << 10) + (extra & 1023) + 65536);
            else {
                codePoints.push(value2);
                i--;
            }
        } else codePoints.push(value2);
    }
    return codePoints;
};
var fromCodePoint$1 = function() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
    var length = codePoints.length;
    if (!length) return "";
    var codeUnits = [];
    var index2 = -1;
    var result2 = "";
    while(++index2 < length){
        var codePoint = codePoints[index2];
        if (codePoint <= 65535) codeUnits.push(codePoint);
        else {
            codePoint -= 65536;
            codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
        }
        if (index2 + 1 === length || codeUnits.length > 16384) {
            result2 += String.fromCharCode.apply(String, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result2;
};
var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
var decode$1 = function(base642) {
    var bufferLength = base642.length * 0.75, len = base642.length, i, p2 = 0, encoded1, encoded2, encoded3, encoded4;
    if (base642[base642.length - 1] === "=") {
        bufferLength--;
        if (base642[base642.length - 2] === "=") bufferLength--;
    }
    var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
    for(i = 0; i < len; i += 4){
        encoded1 = lookup$1$1[base642.charCodeAt(i)];
        encoded2 = lookup$1$1[base642.charCodeAt(i + 1)];
        encoded3 = lookup$1$1[base642.charCodeAt(i + 2)];
        encoded4 = lookup$1$1[base642.charCodeAt(i + 3)];
        bytes[p2++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p2++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p2++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
};
var polyUint16Array$1 = function(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
    return bytes;
};
var polyUint32Array$1 = function(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
    return bytes;
};
var UTRIE2_SHIFT_2$1 = 5;
var UTRIE2_SHIFT_1$1 = 11;
var UTRIE2_INDEX_SHIFT$1 = 2;
var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 65536 >> UTRIE2_SHIFT_2$1;
var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 1024 >> UTRIE2_SHIFT_2$1;
var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32;
var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 65536 >> UTRIE2_SHIFT_1$1;
var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
var slice16$1 = function(view, start, end) {
    if (view.slice) return view.slice(start, end);
    return new Uint16Array(Array.prototype.slice.call(view, start, end));
};
var slice32$1 = function(view, start, end) {
    if (view.slice) return view.slice(start, end);
    return new Uint32Array(Array.prototype.slice.call(view, start, end));
};
var createTrieFromBase64$1 = function(base642, _byteLength) {
    var buffer = decode$1(base642);
    var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
    var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
    var headerLength = 24;
    var index2 = slice16$1(view16, headerLength / 2, view32[4] / 2);
    var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
    return new Trie$1(view32[0], view32[1], view32[2], view32[3], index2, data);
};
var Trie$1 = /** @class */ function() {
    function Trie2(initialValue, errorValue, highStart, highValueIndex, index2, data) {
        this.initialValue = initialValue;
        this.errorValue = errorValue;
        this.highStart = highStart;
        this.highValueIndex = highValueIndex;
        this.index = index2;
        this.data = data;
    }
    Trie2.prototype.get = function(codePoint) {
        var ix;
        if (codePoint >= 0) {
            if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
            }
            if (codePoint <= 65535) {
                ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 55296 >> UTRIE2_SHIFT_2$1)];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
            }
            if (codePoint < this.highStart) {
                ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                ix = this.index[ix];
                ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                ix = this.index[ix];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
            }
            if (codePoint <= 1114111) return this.data[this.highValueIndex];
        }
        return this.errorValue;
    };
    return Trie2;
}();
var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
var base64$1 = "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";
var LETTER_NUMBER_MODIFIER = 50;
var BK = 1;
var CR$1 = 2;
var LF$1 = 3;
var CM = 4;
var NL = 5;
var WJ = 7;
var ZW = 8;
var GL = 9;
var SP = 10;
var ZWJ$1 = 11;
var B2 = 12;
var BA = 13;
var BB = 14;
var HY = 15;
var CB = 16;
var CL = 17;
var CP = 18;
var EX = 19;
var IN = 20;
var NS = 21;
var OP = 22;
var QU = 23;
var IS = 24;
var NU = 25;
var PO = 26;
var PR = 27;
var SY = 28;
var AI = 29;
var AL = 30;
var CJ = 31;
var EB = 32;
var EM = 33;
var H2 = 34;
var H3 = 35;
var HL = 36;
var ID = 37;
var JL = 38;
var JV = 39;
var JT = 40;
var RI$1 = 41;
var SA = 42;
var XX = 43;
var ea_OP = [
    9001,
    65288
];
var BREAK_MANDATORY = "!";
var BREAK_NOT_ALLOWED$1 = "\xd7";
var BREAK_ALLOWED$1 = "\xf7";
var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
var ALPHABETICS = [
    AL,
    HL
];
var HARD_LINE_BREAKS = [
    BK,
    CR$1,
    LF$1,
    NL
];
var SPACE$1 = [
    SP,
    ZW
];
var PREFIX_POSTFIX = [
    PR,
    PO
];
var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
var KOREAN_SYLLABLE_BLOCK = [
    JL,
    JV,
    JT,
    H2,
    H3
];
var HYPHEN = [
    HY,
    BA
];
var codePointsToCharacterClasses = function(codePoints, lineBreak2) {
    if (lineBreak2 === void 0) lineBreak2 = "strict";
    var types2 = [];
    var indices = [];
    var categories = [];
    codePoints.forEach(function(codePoint, index2) {
        var classType = UnicodeTrie$1.get(codePoint);
        if (classType > LETTER_NUMBER_MODIFIER) {
            categories.push(true);
            classType -= LETTER_NUMBER_MODIFIER;
        } else categories.push(false);
        if ([
            "normal",
            "auto",
            "loose"
        ].indexOf(lineBreak2) !== -1) {
            if ([
                8208,
                8211,
                12316,
                12448
            ].indexOf(codePoint) !== -1) {
                indices.push(index2);
                return types2.push(CB);
            }
        }
        if (classType === CM || classType === ZWJ$1) {
            if (index2 === 0) {
                indices.push(index2);
                return types2.push(AL);
            }
            var prev = types2[index2 - 1];
            if (LINE_BREAKS.indexOf(prev) === -1) {
                indices.push(indices[index2 - 1]);
                return types2.push(prev);
            }
            indices.push(index2);
            return types2.push(AL);
        }
        indices.push(index2);
        if (classType === CJ) return types2.push(lineBreak2 === "strict" ? NS : ID);
        if (classType === SA) return types2.push(AL);
        if (classType === AI) return types2.push(AL);
        if (classType === XX) {
            if (codePoint >= 131072 && codePoint <= 196605 || codePoint >= 196608 && codePoint <= 262141) return types2.push(ID);
            else return types2.push(AL);
        }
        types2.push(classType);
    });
    return [
        indices,
        types2,
        categories
    ];
};
var isAdjacentWithSpaceIgnored = function(a2, b2, currentIndex, classTypes) {
    var current = classTypes[currentIndex];
    if (Array.isArray(a2) ? a2.indexOf(current) !== -1 : a2 === current) {
        var i = currentIndex;
        while(i <= classTypes.length){
            i++;
            var next2 = classTypes[i];
            if (next2 === b2) return true;
            if (next2 !== SP) break;
        }
    }
    if (current === SP) {
        var i = currentIndex;
        while(i > 0){
            i--;
            var prev = classTypes[i];
            if (Array.isArray(a2) ? a2.indexOf(prev) !== -1 : a2 === prev) {
                var n2 = currentIndex;
                while(n2 <= classTypes.length){
                    n2++;
                    var next2 = classTypes[n2];
                    if (next2 === b2) return true;
                    if (next2 !== SP) break;
                }
            }
            if (prev !== SP) break;
        }
    }
    return false;
};
var previousNonSpaceClassType = function(currentIndex, classTypes) {
    var i = currentIndex;
    while(i >= 0){
        var type = classTypes[i];
        if (type === SP) i--;
        else return type;
    }
    return 0;
};
var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index2, forbiddenBreaks) {
    if (indicies[index2] === 0) return BREAK_NOT_ALLOWED$1;
    var currentIndex = index2 - 1;
    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
    var beforeIndex = currentIndex - 1;
    var afterIndex = currentIndex + 1;
    var current = classTypes[currentIndex];
    var before2 = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
    var next2 = classTypes[afterIndex];
    if (current === CR$1 && next2 === LF$1) return BREAK_NOT_ALLOWED$1;
    if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
    if (HARD_LINE_BREAKS.indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (SPACE$1.indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
    if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
    if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
    if (current === WJ || next2 === WJ) return BREAK_NOT_ALLOWED$1;
    if (current === GL) return BREAK_NOT_ALLOWED$1;
    if ([
        SP,
        BA,
        HY
    ].indexOf(current) === -1 && next2 === GL) return BREAK_NOT_ALLOWED$1;
    if ([
        CL,
        CP,
        EX,
        IS,
        SY
    ].indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
    if (isAdjacentWithSpaceIgnored([
        CL,
        CP
    ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
    if (current === SP) return BREAK_ALLOWED$1;
    if (current === QU || next2 === QU) return BREAK_NOT_ALLOWED$1;
    if (next2 === CB || current === CB) return BREAK_ALLOWED$1;
    if ([
        BA,
        HY,
        NS
    ].indexOf(next2) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
    if (before2 === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
    if (current === SY && next2 === HL) return BREAK_NOT_ALLOWED$1;
    if (next2 === IN) return BREAK_NOT_ALLOWED$1;
    if (ALPHABETICS.indexOf(next2) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next2 === NU) return BREAK_NOT_ALLOWED$1;
    if (current === PR && [
        ID,
        EB,
        EM
    ].indexOf(next2) !== -1 || [
        ID,
        EB,
        EM
    ].indexOf(current) !== -1 && next2 === PO) return BREAK_NOT_ALLOWED$1;
    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next2) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (// (PR | PO) × ( OP | HY )? NU
    [
        PR,
        PO
    ].indexOf(current) !== -1 && (next2 === NU || [
        OP,
        HY
    ].indexOf(next2) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
    [
        OP,
        HY
    ].indexOf(current) !== -1 && next2 === NU || // NU ×	(NU | SY | IS)
    current === NU && [
        NU,
        SY,
        IS
    ].indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if ([
        NU,
        SY,
        IS,
        CL,
        CP
    ].indexOf(next2) !== -1) {
        var prevIndex = currentIndex;
        while(prevIndex >= 0){
            var type = classTypes[prevIndex];
            if (type === NU) return BREAK_NOT_ALLOWED$1;
            else if ([
                SY,
                IS
            ].indexOf(type) !== -1) prevIndex--;
            else break;
        }
    }
    if ([
        PR,
        PO
    ].indexOf(next2) !== -1) {
        var prevIndex = [
            CL,
            CP
        ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
        while(prevIndex >= 0){
            var type = classTypes[prevIndex];
            if (type === NU) return BREAK_NOT_ALLOWED$1;
            else if ([
                SY,
                IS
            ].indexOf(type) !== -1) prevIndex--;
            else break;
        }
    }
    if (JL === current && [
        JL,
        JV,
        H2,
        H3
    ].indexOf(next2) !== -1 || [
        JV,
        H2
    ].indexOf(current) !== -1 && [
        JV,
        JT
    ].indexOf(next2) !== -1 || [
        JT,
        H3
    ].indexOf(current) !== -1 && next2 === JT) return BREAK_NOT_ALLOWED$1;
    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
        IN,
        PO
    ].indexOf(next2) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next2) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (current === IS && ALPHABETICS.indexOf(next2) !== -1) return BREAK_NOT_ALLOWED$1;
    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next2 === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next2) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
    if (current === RI$1 && next2 === RI$1) {
        var i = indicies[currentIndex];
        var count2 = 1;
        while(i > 0){
            i--;
            if (classTypes[i] === RI$1) count2++;
            else break;
        }
        if (count2 % 2 !== 0) return BREAK_NOT_ALLOWED$1;
    }
    if (current === EB && next2 === EM) return BREAK_NOT_ALLOWED$1;
    return BREAK_ALLOWED$1;
};
var cssFormattedClasses = function(codePoints, options) {
    if (!options) options = {
        lineBreak: "normal",
        wordBreak: "normal"
    };
    var _a3 = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a3[0], classTypes = _a3[1], isLetterNumber = _a3[2];
    if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
        return [
            NU,
            AL,
            SA
        ].indexOf(type) !== -1 ? ID : type;
    });
    var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
        return letterNumber && codePoints[i] >= 19968 && codePoints[i] <= 40959;
    }) : void 0;
    return [
        indicies,
        classTypes,
        forbiddenBreakpoints
    ];
};
var Break = /** @class */ function() {
    function Break2(codePoints, lineBreak2, start, end) {
        this.codePoints = codePoints;
        this.required = lineBreak2 === BREAK_MANDATORY;
        this.start = start;
        this.end = end;
    }
    Break2.prototype.slice = function() {
        return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
    };
    return Break2;
}();
var LineBreaker = function(str, options) {
    var codePoints = toCodePoints$1(str);
    var _a3 = cssFormattedClasses(codePoints, options), indicies = _a3[0], classTypes = _a3[1], forbiddenBreakpoints = _a3[2];
    var length = codePoints.length;
    var lastEnd = 0;
    var nextIndex = 0;
    return {
        next: function() {
            if (nextIndex >= length) return {
                done: true,
                value: null
            };
            var lineBreak2 = BREAK_NOT_ALLOWED$1;
            while(nextIndex < length && (lineBreak2 = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
            if (lineBreak2 !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                var value2 = new Break(codePoints, lineBreak2, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return {
                    value: value2,
                    done: false
                };
            }
            return {
                done: true,
                value: null
            };
        }
    };
};
var FLAG_UNRESTRICTED = 1;
var FLAG_ID = 2;
var FLAG_INTEGER = 4;
var FLAG_NUMBER = 8;
var LINE_FEED = 10;
var SOLIDUS = 47;
var REVERSE_SOLIDUS = 92;
var CHARACTER_TABULATION = 9;
var SPACE = 32;
var QUOTATION_MARK = 34;
var EQUALS_SIGN = 61;
var NUMBER_SIGN = 35;
var DOLLAR_SIGN = 36;
var PERCENTAGE_SIGN = 37;
var APOSTROPHE = 39;
var LEFT_PARENTHESIS = 40;
var RIGHT_PARENTHESIS = 41;
var LOW_LINE = 95;
var HYPHEN_MINUS = 45;
var EXCLAMATION_MARK = 33;
var LESS_THAN_SIGN = 60;
var GREATER_THAN_SIGN = 62;
var COMMERCIAL_AT = 64;
var LEFT_SQUARE_BRACKET = 91;
var RIGHT_SQUARE_BRACKET = 93;
var CIRCUMFLEX_ACCENT = 61;
var LEFT_CURLY_BRACKET = 123;
var QUESTION_MARK = 63;
var RIGHT_CURLY_BRACKET = 125;
var VERTICAL_LINE = 124;
var TILDE = 126;
var CONTROL = 128;
var REPLACEMENT_CHARACTER = 65533;
var ASTERISK = 42;
var PLUS_SIGN = 43;
var COMMA = 44;
var COLON = 58;
var SEMICOLON = 59;
var FULL_STOP = 46;
var NULL = 0;
var BACKSPACE = 8;
var LINE_TABULATION = 11;
var SHIFT_OUT = 14;
var INFORMATION_SEPARATOR_ONE = 31;
var DELETE = 127;
var EOF = -1;
var ZERO = 48;
var a = 97;
var e = 101;
var f = 102;
var u = 117;
var z = 122;
var A = 65;
var E = 69;
var F = 70;
var U = 85;
var Z = 90;
var isDigit = function(codePoint) {
    return codePoint >= ZERO && codePoint <= 57;
};
var isSurrogateCodePoint = function(codePoint) {
    return codePoint >= 55296 && codePoint <= 57343;
};
var isHex = function(codePoint) {
    return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
};
var isLowerCaseLetter = function(codePoint) {
    return codePoint >= a && codePoint <= z;
};
var isUpperCaseLetter = function(codePoint) {
    return codePoint >= A && codePoint <= Z;
};
var isLetter = function(codePoint) {
    return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
};
var isNonASCIICodePoint = function(codePoint) {
    return codePoint >= CONTROL;
};
var isWhiteSpace = function(codePoint) {
    return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
};
var isNameStartCodePoint = function(codePoint) {
    return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
};
var isNameCodePoint = function(codePoint) {
    return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
};
var isNonPrintableCodePoint = function(codePoint) {
    return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
};
var isValidEscape = function(c1, c2) {
    if (c1 !== REVERSE_SOLIDUS) return false;
    return c2 !== LINE_FEED;
};
var isIdentifierStart = function(c1, c2, c3) {
    if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
    else if (isNameStartCodePoint(c1)) return true;
    else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
    return false;
};
var isNumberStart = function(c1, c2, c3) {
    if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
        if (isDigit(c2)) return true;
        return c2 === FULL_STOP && isDigit(c3);
    }
    if (c1 === FULL_STOP) return isDigit(c2);
    return isDigit(c1);
};
var stringToNumber = function(codePoints) {
    var c2 = 0;
    var sign = 1;
    if (codePoints[c2] === PLUS_SIGN || codePoints[c2] === HYPHEN_MINUS) {
        if (codePoints[c2] === HYPHEN_MINUS) sign = -1;
        c2++;
    }
    var integers = [];
    while(isDigit(codePoints[c2]))integers.push(codePoints[c2++]);
    var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
    if (codePoints[c2] === FULL_STOP) c2++;
    var fraction = [];
    while(isDigit(codePoints[c2]))fraction.push(codePoints[c2++]);
    var fracd = fraction.length;
    var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
    if (codePoints[c2] === E || codePoints[c2] === e) c2++;
    var expsign = 1;
    if (codePoints[c2] === PLUS_SIGN || codePoints[c2] === HYPHEN_MINUS) {
        if (codePoints[c2] === HYPHEN_MINUS) expsign = -1;
        c2++;
    }
    var exponent = [];
    while(isDigit(codePoints[c2]))exponent.push(codePoints[c2++]);
    var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
    return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
};
var LEFT_PARENTHESIS_TOKEN = {
    type: 2
};
var RIGHT_PARENTHESIS_TOKEN = {
    type: 3
};
var COMMA_TOKEN = {
    type: 4
};
var SUFFIX_MATCH_TOKEN = {
    type: 13
};
var PREFIX_MATCH_TOKEN = {
    type: 8
};
var COLUMN_TOKEN = {
    type: 21
};
var DASH_MATCH_TOKEN = {
    type: 9
};
var INCLUDE_MATCH_TOKEN = {
    type: 10
};
var LEFT_CURLY_BRACKET_TOKEN = {
    type: 11
};
var RIGHT_CURLY_BRACKET_TOKEN = {
    type: 12
};
var SUBSTRING_MATCH_TOKEN = {
    type: 14
};
var BAD_URL_TOKEN = {
    type: 23
};
var BAD_STRING_TOKEN = {
    type: 1
};
var CDO_TOKEN = {
    type: 25
};
var CDC_TOKEN = {
    type: 24
};
var COLON_TOKEN = {
    type: 26
};
var SEMICOLON_TOKEN = {
    type: 27
};
var LEFT_SQUARE_BRACKET_TOKEN = {
    type: 28
};
var RIGHT_SQUARE_BRACKET_TOKEN = {
    type: 29
};
var WHITESPACE_TOKEN = {
    type: 31
};
var EOF_TOKEN = {
    type: 32
};
var Tokenizer$1 = /** @class */ function() {
    function Tokenizer2() {
        this._value = [];
    }
    Tokenizer2.prototype.write = function(chunk) {
        this._value = this._value.concat(toCodePoints$1(chunk));
    };
    Tokenizer2.prototype.read = function() {
        var tokens = [];
        var token2 = this.consumeToken();
        while(token2 !== EOF_TOKEN){
            tokens.push(token2);
            token2 = this.consumeToken();
        }
        return tokens;
    };
    Tokenizer2.prototype.consumeToken = function() {
        var codePoint = this.consumeCodePoint();
        switch(codePoint){
            case QUOTATION_MARK:
                return this.consumeStringToken(QUOTATION_MARK);
            case NUMBER_SIGN:
                var c1 = this.peekCodePoint(0);
                var c2 = this.peekCodePoint(1);
                var c3 = this.peekCodePoint(2);
                if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                    var flags2 = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                    var value2 = this.consumeName();
                    return {
                        type: 5,
                        value: value2,
                        flags: flags2
                    };
                }
                break;
            case DOLLAR_SIGN:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return SUFFIX_MATCH_TOKEN;
                }
                break;
            case APOSTROPHE:
                return this.consumeStringToken(APOSTROPHE);
            case LEFT_PARENTHESIS:
                return LEFT_PARENTHESIS_TOKEN;
            case RIGHT_PARENTHESIS:
                return RIGHT_PARENTHESIS_TOKEN;
            case ASTERISK:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return SUBSTRING_MATCH_TOKEN;
                }
                break;
            case PLUS_SIGN:
                if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                }
                break;
            case COMMA:
                return COMMA_TOKEN;
            case HYPHEN_MINUS:
                var e1 = codePoint;
                var e2 = this.peekCodePoint(0);
                var e3 = this.peekCodePoint(1);
                if (isNumberStart(e1, e2, e3)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                }
                if (isIdentifierStart(e1, e2, e3)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                }
                if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                    this.consumeCodePoint();
                    this.consumeCodePoint();
                    return CDC_TOKEN;
                }
                break;
            case FULL_STOP:
                if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                }
                break;
            case SOLIDUS:
                if (this.peekCodePoint(0) === ASTERISK) {
                    this.consumeCodePoint();
                    while(true){
                        var c4 = this.consumeCodePoint();
                        if (c4 === ASTERISK) {
                            c4 = this.consumeCodePoint();
                            if (c4 === SOLIDUS) return this.consumeToken();
                        }
                        if (c4 === EOF) return this.consumeToken();
                    }
                }
                break;
            case COLON:
                return COLON_TOKEN;
            case SEMICOLON:
                return SEMICOLON_TOKEN;
            case LESS_THAN_SIGN:
                if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                    this.consumeCodePoint();
                    this.consumeCodePoint();
                    return CDO_TOKEN;
                }
                break;
            case COMMERCIAL_AT:
                var a1 = this.peekCodePoint(0);
                var a2 = this.peekCodePoint(1);
                var a3 = this.peekCodePoint(2);
                if (isIdentifierStart(a1, a2, a3)) {
                    var value2 = this.consumeName();
                    return {
                        type: 7,
                        value: value2
                    };
                }
                break;
            case LEFT_SQUARE_BRACKET:
                return LEFT_SQUARE_BRACKET_TOKEN;
            case REVERSE_SOLIDUS:
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                }
                break;
            case RIGHT_SQUARE_BRACKET:
                return RIGHT_SQUARE_BRACKET_TOKEN;
            case CIRCUMFLEX_ACCENT:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return PREFIX_MATCH_TOKEN;
                }
                break;
            case LEFT_CURLY_BRACKET:
                return LEFT_CURLY_BRACKET_TOKEN;
            case RIGHT_CURLY_BRACKET:
                return RIGHT_CURLY_BRACKET_TOKEN;
            case u:
            case U:
                var u1 = this.peekCodePoint(0);
                var u2 = this.peekCodePoint(1);
                if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                    this.consumeCodePoint();
                    this.consumeUnicodeRangeToken();
                }
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            case VERTICAL_LINE:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return DASH_MATCH_TOKEN;
                }
                if (this.peekCodePoint(0) === VERTICAL_LINE) {
                    this.consumeCodePoint();
                    return COLUMN_TOKEN;
                }
                break;
            case TILDE:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                    this.consumeCodePoint();
                    return INCLUDE_MATCH_TOKEN;
                }
                break;
            case EOF:
                return EOF_TOKEN;
        }
        if (isWhiteSpace(codePoint)) {
            this.consumeWhiteSpace();
            return WHITESPACE_TOKEN;
        }
        if (isDigit(codePoint)) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeNumericToken();
        }
        if (isNameStartCodePoint(codePoint)) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeIdentLikeToken();
        }
        return {
            type: 6,
            value: fromCodePoint$1(codePoint)
        };
    };
    Tokenizer2.prototype.consumeCodePoint = function() {
        var value2 = this._value.shift();
        return typeof value2 === "undefined" ? -1 : value2;
    };
    Tokenizer2.prototype.reconsumeCodePoint = function(codePoint) {
        this._value.unshift(codePoint);
    };
    Tokenizer2.prototype.peekCodePoint = function(delta) {
        if (delta >= this._value.length) return -1;
        return this._value[delta];
    };
    Tokenizer2.prototype.consumeUnicodeRangeToken = function() {
        var digits = [];
        var codePoint = this.consumeCodePoint();
        while(isHex(codePoint) && digits.length < 6){
            digits.push(codePoint);
            codePoint = this.consumeCodePoint();
        }
        var questionMarks = false;
        while(codePoint === QUESTION_MARK && digits.length < 6){
            digits.push(codePoint);
            codePoint = this.consumeCodePoint();
            questionMarks = true;
        }
        if (questionMarks) {
            var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                return digit === QUESTION_MARK ? ZERO : digit;
            })), 16);
            var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                return digit === QUESTION_MARK ? F : digit;
            })), 16);
            return {
                type: 30,
                start: start_1,
                end: end
            };
        }
        var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
        if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
            this.consumeCodePoint();
            codePoint = this.consumeCodePoint();
            var endDigits = [];
            while(isHex(codePoint) && endDigits.length < 6){
                endDigits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
            return {
                type: 30,
                start: start,
                end: end
            };
        } else return {
            type: 30,
            start: start,
            end: start
        };
    };
    Tokenizer2.prototype.consumeIdentLikeToken = function() {
        var value2 = this.consumeName();
        if (value2.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
            this.consumeCodePoint();
            return this.consumeUrlToken();
        } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
            this.consumeCodePoint();
            return {
                type: 19,
                value: value2
            };
        }
        return {
            type: 20,
            value: value2
        };
    };
    Tokenizer2.prototype.consumeUrlToken = function() {
        var value2 = [];
        this.consumeWhiteSpace();
        if (this.peekCodePoint(0) === EOF) return {
            type: 22,
            value: ""
        };
        var next2 = this.peekCodePoint(0);
        if (next2 === APOSTROPHE || next2 === QUOTATION_MARK) {
            var stringToken = this.consumeStringToken(this.consumeCodePoint());
            if (stringToken.type === 0) {
                this.consumeWhiteSpace();
                if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                    this.consumeCodePoint();
                    return {
                        type: 22,
                        value: stringToken.value
                    };
                }
            }
            this.consumeBadUrlRemnants();
            return BAD_URL_TOKEN;
        }
        while(true){
            var codePoint = this.consumeCodePoint();
            if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                type: 22,
                value: fromCodePoint$1.apply(void 0, value2)
            };
            else if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                    this.consumeCodePoint();
                    return {
                        type: 22,
                        value: fromCodePoint$1.apply(void 0, value2)
                    };
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            } else if (codePoint === REVERSE_SOLIDUS) {
                if (isValidEscape(codePoint, this.peekCodePoint(0))) value2.push(this.consumeEscapedCodePoint());
                else {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
            } else value2.push(codePoint);
        }
    };
    Tokenizer2.prototype.consumeWhiteSpace = function() {
        while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
    };
    Tokenizer2.prototype.consumeBadUrlRemnants = function() {
        while(true){
            var codePoint = this.consumeCodePoint();
            if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
            if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
        }
    };
    Tokenizer2.prototype.consumeStringSlice = function(count2) {
        var SLICE_STACK_SIZE = 5e4;
        var value2 = "";
        while(count2 > 0){
            var amount = Math.min(SLICE_STACK_SIZE, count2);
            value2 += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
            count2 -= amount;
        }
        this._value.shift();
        return value2;
    };
    Tokenizer2.prototype.consumeStringToken = function(endingCodePoint) {
        var value2 = "";
        var i = 0;
        do {
            var codePoint = this._value[i];
            if (codePoint === EOF || codePoint === void 0 || codePoint === endingCodePoint) {
                value2 += this.consumeStringSlice(i);
                return {
                    type: 0,
                    value: value2
                };
            }
            if (codePoint === LINE_FEED) {
                this._value.splice(0, i);
                return BAD_STRING_TOKEN;
            }
            if (codePoint === REVERSE_SOLIDUS) {
                var next2 = this._value[i + 1];
                if (next2 !== EOF && next2 !== void 0) {
                    if (next2 === LINE_FEED) {
                        value2 += this.consumeStringSlice(i);
                        i = -1;
                        this._value.shift();
                    } else if (isValidEscape(codePoint, next2)) {
                        value2 += this.consumeStringSlice(i);
                        value2 += fromCodePoint$1(this.consumeEscapedCodePoint());
                        i = -1;
                    }
                }
            }
            i++;
        }while (true);
    };
    Tokenizer2.prototype.consumeNumber = function() {
        var repr = [];
        var type = FLAG_INTEGER;
        var c1 = this.peekCodePoint(0);
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
        while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
        c1 = this.peekCodePoint(0);
        var c2 = this.peekCodePoint(1);
        if (c1 === FULL_STOP && isDigit(c2)) {
            repr.push(this.consumeCodePoint(), this.consumeCodePoint());
            type = FLAG_NUMBER;
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
        }
        c1 = this.peekCodePoint(0);
        c2 = this.peekCodePoint(1);
        var c3 = this.peekCodePoint(2);
        if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
            repr.push(this.consumeCodePoint(), this.consumeCodePoint());
            type = FLAG_NUMBER;
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
        }
        return [
            stringToNumber(repr),
            type
        ];
    };
    Tokenizer2.prototype.consumeNumericToken = function() {
        var _a3 = this.consumeNumber(), number = _a3[0], flags2 = _a3[1];
        var c1 = this.peekCodePoint(0);
        var c2 = this.peekCodePoint(1);
        var c3 = this.peekCodePoint(2);
        if (isIdentifierStart(c1, c2, c3)) {
            var unit = this.consumeName();
            return {
                type: 15,
                number: number,
                flags: flags2,
                unit: unit
            };
        }
        if (c1 === PERCENTAGE_SIGN) {
            this.consumeCodePoint();
            return {
                type: 16,
                number: number,
                flags: flags2
            };
        }
        return {
            type: 17,
            number: number,
            flags: flags2
        };
    };
    Tokenizer2.prototype.consumeEscapedCodePoint = function() {
        var codePoint = this.consumeCodePoint();
        if (isHex(codePoint)) {
            var hex = fromCodePoint$1(codePoint);
            while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
            if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
            var hexCodePoint = parseInt(hex, 16);
            if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 1114111) return REPLACEMENT_CHARACTER;
            return hexCodePoint;
        }
        if (codePoint === EOF) return REPLACEMENT_CHARACTER;
        return codePoint;
    };
    Tokenizer2.prototype.consumeName = function() {
        var result2 = "";
        while(true){
            var codePoint = this.consumeCodePoint();
            if (isNameCodePoint(codePoint)) result2 += fromCodePoint$1(codePoint);
            else if (isValidEscape(codePoint, this.peekCodePoint(0))) result2 += fromCodePoint$1(this.consumeEscapedCodePoint());
            else {
                this.reconsumeCodePoint(codePoint);
                return result2;
            }
        }
    };
    return Tokenizer2;
}();
var Parser$1 = /** @class */ function() {
    function Parser2(tokens) {
        this._tokens = tokens;
    }
    Parser2.create = function(value2) {
        var tokenizer = new Tokenizer$1();
        tokenizer.write(value2);
        return new Parser2(tokenizer.read());
    };
    Parser2.parseValue = function(value2) {
        return Parser2.create(value2).parseComponentValue();
    };
    Parser2.parseValues = function(value2) {
        return Parser2.create(value2).parseComponentValues();
    };
    Parser2.prototype.parseComponentValue = function() {
        var token2 = this.consumeToken();
        while(token2.type === 31)token2 = this.consumeToken();
        if (token2.type === 32) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
        this.reconsumeToken(token2);
        var value2 = this.consumeComponentValue();
        do token2 = this.consumeToken();
        while (token2.type === 31);
        if (token2.type === 32) return value2;
        throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    };
    Parser2.prototype.parseComponentValues = function() {
        var values2 = [];
        while(true){
            var value2 = this.consumeComponentValue();
            if (value2.type === 32) return values2;
            values2.push(value2);
            values2.push();
        }
    };
    Parser2.prototype.consumeComponentValue = function() {
        var token2 = this.consumeToken();
        switch(token2.type){
            case 11:
            case 28:
            case 2:
                return this.consumeSimpleBlock(token2.type);
            case 19:
                return this.consumeFunction(token2);
        }
        return token2;
    };
    Parser2.prototype.consumeSimpleBlock = function(type) {
        var block2 = {
            type: type,
            values: []
        };
        var token2 = this.consumeToken();
        while(true){
            if (token2.type === 32 || isEndingTokenFor(token2, type)) return block2;
            this.reconsumeToken(token2);
            block2.values.push(this.consumeComponentValue());
            token2 = this.consumeToken();
        }
    };
    Parser2.prototype.consumeFunction = function(functionToken) {
        var cssFunction = {
            name: functionToken.value,
            values: [],
            type: 18
        };
        while(true){
            var token2 = this.consumeToken();
            if (token2.type === 32 || token2.type === 3) return cssFunction;
            this.reconsumeToken(token2);
            cssFunction.values.push(this.consumeComponentValue());
        }
    };
    Parser2.prototype.consumeToken = function() {
        var token2 = this._tokens.shift();
        return typeof token2 === "undefined" ? EOF_TOKEN : token2;
    };
    Parser2.prototype.reconsumeToken = function(token2) {
        this._tokens.unshift(token2);
    };
    return Parser2;
}();
var isDimensionToken = function(token2) {
    return token2.type === 15;
};
var isNumberToken = function(token2) {
    return token2.type === 17;
};
var isIdentToken = function(token2) {
    return token2.type === 20;
};
var isIdentWithValue = function(token2, value2) {
    return isIdentToken(token2) && token2.value === value2;
};
var nonFunctionArgSeparator = function(token2) {
    return token2.type !== 31 && token2.type !== 4;
};
var parseFunctionArgs = function(tokens) {
    var args = [];
    var arg = [];
    tokens.forEach(function(token2) {
        if (token2.type === 4) {
            if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
            args.push(arg);
            arg = [];
            return;
        }
        if (token2.type !== 31) arg.push(token2);
    });
    if (arg.length) args.push(arg);
    return args;
};
var isEndingTokenFor = function(token2, type) {
    if (type === 11 && token2.type === 12) return true;
    if (type === 28 && token2.type === 29) return true;
    return type === 2 && token2.type === 3;
};
var isLength = function(token2) {
    return token2.type === 17 || token2.type === 15;
};
var isLengthPercentage = function(token2) {
    return token2.type === 16 || isLength(token2);
};
var parseLengthPercentageTuple = function(tokens) {
    return tokens.length > 1 ? [
        tokens[0],
        tokens[1]
    ] : [
        tokens[0]
    ];
};
var ZERO_LENGTH = {
    type: 17,
    number: 0,
    flags: FLAG_INTEGER
};
var FIFTY_PERCENT = {
    type: 16,
    number: 50,
    flags: FLAG_INTEGER
};
var HUNDRED_PERCENT = {
    type: 16,
    number: 100,
    flags: FLAG_INTEGER
};
var getAbsoluteValueForTuple = function(tuple, width, height) {
    var x2 = tuple[0], y2 = tuple[1];
    return [
        getAbsoluteValue(x2, width),
        getAbsoluteValue(typeof y2 !== "undefined" ? y2 : x2, height)
    ];
};
var getAbsoluteValue = function(token2, parent) {
    if (token2.type === 16) return token2.number / 100 * parent;
    if (isDimensionToken(token2)) switch(token2.unit){
        case "rem":
        case "em":
            return 16 * token2.number;
        case "px":
        default:
            return token2.number;
    }
    return token2.number;
};
var DEG = "deg";
var GRAD = "grad";
var RAD = "rad";
var TURN = "turn";
var angle = {
    name: "angle",
    parse: function(_context, value2) {
        if (value2.type === 15) switch(value2.unit){
            case DEG:
                return Math.PI * value2.number / 180;
            case GRAD:
                return Math.PI / 200 * value2.number;
            case RAD:
                return value2.number;
            case TURN:
                return Math.PI * 2 * value2.number;
        }
        throw new Error("Unsupported angle type");
    }
};
var isAngle = function(value2) {
    if (value2.type === 15) {
        if (value2.unit === DEG || value2.unit === GRAD || value2.unit === RAD || value2.unit === TURN) return true;
    }
    return false;
};
var parseNamedSide = function(tokens) {
    var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
        return ident.value;
    }).join(" ");
    switch(sideOrCorner){
        case "to bottom right":
        case "to right bottom":
        case "left top":
        case "top left":
            return [
                ZERO_LENGTH,
                ZERO_LENGTH
            ];
        case "to top":
        case "bottom":
            return deg(0);
        case "to bottom left":
        case "to left bottom":
        case "right top":
        case "top right":
            return [
                ZERO_LENGTH,
                HUNDRED_PERCENT
            ];
        case "to right":
        case "left":
            return deg(90);
        case "to top left":
        case "to left top":
        case "right bottom":
        case "bottom right":
            return [
                HUNDRED_PERCENT,
                HUNDRED_PERCENT
            ];
        case "to bottom":
        case "top":
            return deg(180);
        case "to top right":
        case "to right top":
        case "left bottom":
        case "bottom left":
            return [
                HUNDRED_PERCENT,
                ZERO_LENGTH
            ];
        case "to left":
        case "right":
            return deg(270);
    }
    return 0;
};
var deg = function(deg2) {
    return Math.PI * deg2 / 180;
};
var color$1 = {
    name: "color",
    parse: function(context, value2) {
        if (value2.type === 18) {
            var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value2.name];
            if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value2.name + '"');
            return colorFunction(context, value2.values);
        }
        if (value2.type === 5) {
            if (value2.value.length === 3) {
                var r2 = value2.value.substring(0, 1);
                var g2 = value2.value.substring(1, 2);
                var b2 = value2.value.substring(2, 3);
                return pack(parseInt(r2 + r2, 16), parseInt(g2 + g2, 16), parseInt(b2 + b2, 16), 1);
            }
            if (value2.value.length === 4) {
                var r2 = value2.value.substring(0, 1);
                var g2 = value2.value.substring(1, 2);
                var b2 = value2.value.substring(2, 3);
                var a2 = value2.value.substring(3, 4);
                return pack(parseInt(r2 + r2, 16), parseInt(g2 + g2, 16), parseInt(b2 + b2, 16), parseInt(a2 + a2, 16) / 255);
            }
            if (value2.value.length === 6) {
                var r2 = value2.value.substring(0, 2);
                var g2 = value2.value.substring(2, 4);
                var b2 = value2.value.substring(4, 6);
                return pack(parseInt(r2, 16), parseInt(g2, 16), parseInt(b2, 16), 1);
            }
            if (value2.value.length === 8) {
                var r2 = value2.value.substring(0, 2);
                var g2 = value2.value.substring(2, 4);
                var b2 = value2.value.substring(4, 6);
                var a2 = value2.value.substring(6, 8);
                return pack(parseInt(r2, 16), parseInt(g2, 16), parseInt(b2, 16), parseInt(a2, 16) / 255);
            }
        }
        if (value2.type === 20) {
            var namedColor = COLORS[value2.value.toUpperCase()];
            if (typeof namedColor !== "undefined") return namedColor;
        }
        return COLORS.TRANSPARENT;
    }
};
var isTransparent = function(color2) {
    return (255 & color2) === 0;
};
var asString = function(color2) {
    var alpha = 255 & color2;
    var blue = 255 & color2 >> 8;
    var green = 255 & color2 >> 16;
    var red = 255 & color2 >> 24;
    return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
};
var pack = function(r2, g2, b2, a2) {
    return (r2 << 24 | g2 << 16 | b2 << 8 | Math.round(a2 * 255) << 0) >>> 0;
};
var getTokenColorValue = function(token2, i) {
    if (token2.type === 17) return token2.number;
    if (token2.type === 16) {
        var max2 = i === 3 ? 1 : 255;
        return i === 3 ? token2.number / 100 * max2 : Math.round(token2.number / 100 * max2);
    }
    return 0;
};
var rgb = function(_context, args) {
    var tokens = args.filter(nonFunctionArgSeparator);
    if (tokens.length === 3) {
        var _a3 = tokens.map(getTokenColorValue), r2 = _a3[0], g2 = _a3[1], b2 = _a3[2];
        return pack(r2, g2, b2, 1);
    }
    if (tokens.length === 4) {
        var _b2 = tokens.map(getTokenColorValue), r2 = _b2[0], g2 = _b2[1], b2 = _b2[2], a2 = _b2[3];
        return pack(r2, g2, b2, a2);
    }
    return 0;
};
function hue2rgb(t1, t2, hue) {
    if (hue < 0) hue += 1;
    if (hue >= 1) hue -= 1;
    if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
    else if (hue < 0.5) return t2;
    else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
    else return t1;
}
var hsl = function(context, args) {
    var tokens = args.filter(nonFunctionArgSeparator);
    var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
    var h2 = (hue.type === 17 ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
    var s2 = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
    var l2 = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
    var a2 = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
    if (s2 === 0) return pack(l2 * 255, l2 * 255, l2 * 255, 1);
    var t2 = l2 <= 0.5 ? l2 * (s2 + 1) : l2 + s2 - l2 * s2;
    var t1 = l2 * 2 - t2;
    var r2 = hue2rgb(t1, t2, h2 + 1 / 3);
    var g2 = hue2rgb(t1, t2, h2);
    var b2 = hue2rgb(t1, t2, h2 - 1 / 3);
    return pack(r2 * 255, g2 * 255, b2 * 255, a2);
};
var SUPPORTED_COLOR_FUNCTIONS = {
    hsl: hsl,
    hsla: hsl,
    rgb: rgb,
    rgba: rgb
};
var parseColor = function(context, value2) {
    return color$1.parse(context, Parser$1.create(value2).parseComponentValue());
};
var COLORS = {
    ALICEBLUE: 4042850303,
    ANTIQUEWHITE: 4209760255,
    AQUA: 16777215,
    AQUAMARINE: 2147472639,
    AZURE: 4043309055,
    BEIGE: 4126530815,
    BISQUE: 4293182719,
    BLACK: 255,
    BLANCHEDALMOND: 4293643775,
    BLUE: 65535,
    BLUEVIOLET: 2318131967,
    BROWN: 2771004159,
    BURLYWOOD: 3736635391,
    CADETBLUE: 1604231423,
    CHARTREUSE: 2147418367,
    CHOCOLATE: 3530104575,
    CORAL: 4286533887,
    CORNFLOWERBLUE: 1687547391,
    CORNSILK: 4294499583,
    CRIMSON: 3692313855,
    CYAN: 16777215,
    DARKBLUE: 35839,
    DARKCYAN: 9145343,
    DARKGOLDENROD: 3095837695,
    DARKGRAY: 2846468607,
    DARKGREEN: 6553855,
    DARKGREY: 2846468607,
    DARKKHAKI: 3182914559,
    DARKMAGENTA: 2332068863,
    DARKOLIVEGREEN: 1433087999,
    DARKORANGE: 4287365375,
    DARKORCHID: 2570243327,
    DARKRED: 2332033279,
    DARKSALMON: 3918953215,
    DARKSEAGREEN: 2411499519,
    DARKSLATEBLUE: 1211993087,
    DARKSLATEGRAY: 793726975,
    DARKSLATEGREY: 793726975,
    DARKTURQUOISE: 13554175,
    DARKVIOLET: 2483082239,
    DEEPPINK: 4279538687,
    DEEPSKYBLUE: 12582911,
    DIMGRAY: 1768516095,
    DIMGREY: 1768516095,
    DODGERBLUE: 512819199,
    FIREBRICK: 2988581631,
    FLORALWHITE: 4294635775,
    FORESTGREEN: 579543807,
    FUCHSIA: 4278255615,
    GAINSBORO: 3705462015,
    GHOSTWHITE: 4177068031,
    GOLD: 4292280575,
    GOLDENROD: 3668254975,
    GRAY: 2155905279,
    GREEN: 8388863,
    GREENYELLOW: 2919182335,
    GREY: 2155905279,
    HONEYDEW: 4043305215,
    HOTPINK: 4285117695,
    INDIANRED: 3445382399,
    INDIGO: 1258324735,
    IVORY: 4294963455,
    KHAKI: 4041641215,
    LAVENDER: 3873897215,
    LAVENDERBLUSH: 4293981695,
    LAWNGREEN: 2096890111,
    LEMONCHIFFON: 4294626815,
    LIGHTBLUE: 2916673279,
    LIGHTCORAL: 4034953471,
    LIGHTCYAN: 3774873599,
    LIGHTGOLDENRODYELLOW: 4210742015,
    LIGHTGRAY: 3553874943,
    LIGHTGREEN: 2431553791,
    LIGHTGREY: 3553874943,
    LIGHTPINK: 4290167295,
    LIGHTSALMON: 4288707327,
    LIGHTSEAGREEN: 548580095,
    LIGHTSKYBLUE: 2278488831,
    LIGHTSLATEGRAY: 2005441023,
    LIGHTSLATEGREY: 2005441023,
    LIGHTSTEELBLUE: 2965692159,
    LIGHTYELLOW: 4294959359,
    LIME: 16711935,
    LIMEGREEN: 852308735,
    LINEN: 4210091775,
    MAGENTA: 4278255615,
    MAROON: 2147483903,
    MEDIUMAQUAMARINE: 1724754687,
    MEDIUMBLUE: 52735,
    MEDIUMORCHID: 3126187007,
    MEDIUMPURPLE: 2473647103,
    MEDIUMSEAGREEN: 1018393087,
    MEDIUMSLATEBLUE: 2070474495,
    MEDIUMSPRINGGREEN: 16423679,
    MEDIUMTURQUOISE: 1221709055,
    MEDIUMVIOLETRED: 3340076543,
    MIDNIGHTBLUE: 421097727,
    MINTCREAM: 4127193855,
    MISTYROSE: 4293190143,
    MOCCASIN: 4293178879,
    NAVAJOWHITE: 4292783615,
    NAVY: 33023,
    OLDLACE: 4260751103,
    OLIVE: 2155872511,
    OLIVEDRAB: 1804477439,
    ORANGE: 4289003775,
    ORANGERED: 4282712319,
    ORCHID: 3664828159,
    PALEGOLDENROD: 4008225535,
    PALEGREEN: 2566625535,
    PALETURQUOISE: 2951671551,
    PALEVIOLETRED: 3681588223,
    PAPAYAWHIP: 4293907967,
    PEACHPUFF: 4292524543,
    PERU: 3448061951,
    PINK: 4290825215,
    PLUM: 3718307327,
    POWDERBLUE: 2967529215,
    PURPLE: 2147516671,
    REBECCAPURPLE: 1714657791,
    RED: 4278190335,
    ROSYBROWN: 3163525119,
    ROYALBLUE: 1097458175,
    SADDLEBROWN: 2336560127,
    SALMON: 4202722047,
    SANDYBROWN: 4104413439,
    SEAGREEN: 780883967,
    SEASHELL: 4294307583,
    SIENNA: 2689740287,
    SILVER: 3233857791,
    SKYBLUE: 2278484991,
    SLATEBLUE: 1784335871,
    SLATEGRAY: 1887473919,
    SLATEGREY: 1887473919,
    SNOW: 4294638335,
    SPRINGGREEN: 16744447,
    STEELBLUE: 1182971135,
    TAN: 3535047935,
    TEAL: 8421631,
    THISTLE: 3636451583,
    TOMATO: 4284696575,
    TRANSPARENT: 0,
    TURQUOISE: 1088475391,
    VIOLET: 4001558271,
    WHEAT: 4125012991,
    WHITE: 4294967295,
    WHITESMOKE: 4126537215,
    YELLOW: 4294902015,
    YELLOWGREEN: 2597139199
};
var backgroundClip = {
    name: "background-clip",
    initialValue: "border-box",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return tokens.map(function(token2) {
            if (isIdentToken(token2)) switch(token2.value){
                case "padding-box":
                    return 1;
                case "content-box":
                    return 2;
            }
            return 0;
        });
    }
};
var backgroundColor = {
    name: "background-color",
    initialValue: "transparent",
    prefix: false,
    type: 3,
    format: "color"
};
var parseColorStop = function(context, args) {
    var color2 = color$1.parse(context, args[0]);
    var stop = args[1];
    return stop && isLengthPercentage(stop) ? {
        color: color2,
        stop: stop
    } : {
        color: color2,
        stop: null
    };
};
var processColorStops = function(stops, lineLength) {
    var first = stops[0];
    var last2 = stops[stops.length - 1];
    if (first.stop === null) first.stop = ZERO_LENGTH;
    if (last2.stop === null) last2.stop = HUNDRED_PERCENT;
    var processStops = [];
    var previous = 0;
    for(var i = 0; i < stops.length; i++){
        var stop_1 = stops[i].stop;
        if (stop_1 !== null) {
            var absoluteValue = getAbsoluteValue(stop_1, lineLength);
            if (absoluteValue > previous) processStops.push(absoluteValue);
            else processStops.push(previous);
            previous = absoluteValue;
        } else processStops.push(null);
    }
    var gapBegin = null;
    for(var i = 0; i < processStops.length; i++){
        var stop_2 = processStops[i];
        if (stop_2 === null) {
            if (gapBegin === null) gapBegin = i;
        } else if (gapBegin !== null) {
            var gapLength = i - gapBegin;
            var beforeGap = processStops[gapBegin - 1];
            var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
            for(var g2 = 1; g2 <= gapLength; g2++)processStops[gapBegin + g2 - 1] = gapValue * g2;
            gapBegin = null;
        }
    }
    return stops.map(function(_a3, i2) {
        var color2 = _a3.color;
        return {
            color: color2,
            stop: Math.max(Math.min(1, processStops[i2] / lineLength), 0)
        };
    });
};
var getAngleFromCorner = function(corner, width, height) {
    var centerX = width / 2;
    var centerY = height / 2;
    var x2 = getAbsoluteValue(corner[0], width) - centerX;
    var y2 = centerY - getAbsoluteValue(corner[1], height);
    return (Math.atan2(y2, x2) + Math.PI * 2) % (Math.PI * 2);
};
var calculateGradientDirection = function(angle2, width, height) {
    var radian = typeof angle2 === "number" ? angle2 : getAngleFromCorner(angle2, width, height);
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var halfLineLength = lineLength / 2;
    var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
    var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
    return [
        lineLength,
        halfWidth - xDiff,
        halfWidth + xDiff,
        halfHeight - yDiff,
        halfHeight + yDiff
    ];
};
var distance = function(a2, b2) {
    return Math.sqrt(a2 * a2 + b2 * b2);
};
var findCorner = function(width, height, x2, y2, closest) {
    var corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return corners.reduce(function(stat2, corner) {
        var cx = corner[0], cy = corner[1];
        var d2 = distance(x2 - cx, y2 - cy);
        if (closest ? d2 < stat2.optimumDistance : d2 > stat2.optimumDistance) return {
            optimumCorner: corner,
            optimumDistance: d2
        };
        return stat2;
    }, {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null
    }).optimumCorner;
};
var calculateRadius = function(gradient, x2, y2, width, height) {
    var rx = 0;
    var ry = 0;
    switch(gradient.size){
        case 0:
            if (gradient.shape === 0) rx = ry = Math.min(Math.abs(x2), Math.abs(x2 - width), Math.abs(y2), Math.abs(y2 - height));
            else if (gradient.shape === 1) {
                rx = Math.min(Math.abs(x2), Math.abs(x2 - width));
                ry = Math.min(Math.abs(y2), Math.abs(y2 - height));
            }
            break;
        case 2:
            if (gradient.shape === 0) rx = ry = Math.min(distance(x2, y2), distance(x2, y2 - height), distance(x2 - width, y2), distance(x2 - width, y2 - height));
            else if (gradient.shape === 1) {
                var c2 = Math.min(Math.abs(y2), Math.abs(y2 - height)) / Math.min(Math.abs(x2), Math.abs(x2 - width));
                var _a3 = findCorner(width, height, x2, y2, true), cx = _a3[0], cy = _a3[1];
                rx = distance(cx - x2, (cy - y2) / c2);
                ry = c2 * rx;
            }
            break;
        case 1:
            if (gradient.shape === 0) rx = ry = Math.max(Math.abs(x2), Math.abs(x2 - width), Math.abs(y2), Math.abs(y2 - height));
            else if (gradient.shape === 1) {
                rx = Math.max(Math.abs(x2), Math.abs(x2 - width));
                ry = Math.max(Math.abs(y2), Math.abs(y2 - height));
            }
            break;
        case 3:
            if (gradient.shape === 0) rx = ry = Math.max(distance(x2, y2), distance(x2, y2 - height), distance(x2 - width, y2), distance(x2 - width, y2 - height));
            else if (gradient.shape === 1) {
                var c2 = Math.max(Math.abs(y2), Math.abs(y2 - height)) / Math.max(Math.abs(x2), Math.abs(x2 - width));
                var _b2 = findCorner(width, height, x2, y2, false), cx = _b2[0], cy = _b2[1];
                rx = distance(cx - x2, (cy - y2) / c2);
                ry = c2 * rx;
            }
            break;
    }
    if (Array.isArray(gradient.size)) {
        rx = getAbsoluteValue(gradient.size[0], width);
        ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
    }
    return [
        rx,
        ry
    ];
};
var linearGradient = function(context, tokens) {
    var angle$1 = deg(180);
    var stops = [];
    parseFunctionArgs(tokens).forEach(function(arg, i) {
        if (i === 0) {
            var firstToken = arg[0];
            if (firstToken.type === 20 && firstToken.value === "to") {
                angle$1 = parseNamedSide(arg);
                return;
            } else if (isAngle(firstToken)) {
                angle$1 = angle.parse(context, firstToken);
                return;
            }
        }
        var colorStop = parseColorStop(context, arg);
        stops.push(colorStop);
    });
    return {
        angle: angle$1,
        stops: stops,
        type: 1
    };
};
var prefixLinearGradient = function(context, tokens) {
    var angle$1 = deg(180);
    var stops = [];
    parseFunctionArgs(tokens).forEach(function(arg, i) {
        if (i === 0) {
            var firstToken = arg[0];
            if (firstToken.type === 20 && [
                "top",
                "left",
                "right",
                "bottom"
            ].indexOf(firstToken.value) !== -1) {
                angle$1 = parseNamedSide(arg);
                return;
            } else if (isAngle(firstToken)) {
                angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                return;
            }
        }
        var colorStop = parseColorStop(context, arg);
        stops.push(colorStop);
    });
    return {
        angle: angle$1,
        stops: stops,
        type: 1
    };
};
var webkitGradient = function(context, tokens) {
    var angle2 = deg(180);
    var stops = [];
    var type = 1;
    var shape2 = 0;
    var size2 = 3;
    var position2 = [];
    parseFunctionArgs(tokens).forEach(function(arg, i) {
        var firstToken = arg[0];
        if (i === 0) {
            if (isIdentToken(firstToken) && firstToken.value === "linear") {
                type = 1;
                return;
            } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                type = 2;
                return;
            }
        }
        if (firstToken.type === 18) {
            if (firstToken.name === "from") {
                var color2 = color$1.parse(context, firstToken.values[0]);
                stops.push({
                    stop: ZERO_LENGTH,
                    color: color2
                });
            } else if (firstToken.name === "to") {
                var color2 = color$1.parse(context, firstToken.values[0]);
                stops.push({
                    stop: HUNDRED_PERCENT,
                    color: color2
                });
            } else if (firstToken.name === "color-stop") {
                var values2 = firstToken.values.filter(nonFunctionArgSeparator);
                if (values2.length === 2) {
                    var color2 = color$1.parse(context, values2[1]);
                    var stop_1 = values2[0];
                    if (isNumberToken(stop_1)) stops.push({
                        stop: {
                            type: 16,
                            number: stop_1.number * 100,
                            flags: stop_1.flags
                        },
                        color: color2
                    });
                }
            }
        }
    });
    return type === 1 ? {
        angle: (angle2 + deg(180)) % deg(360),
        stops: stops,
        type: type
    } : {
        size: size2,
        shape: shape2,
        stops: stops,
        position: position2,
        type: type
    };
};
var CLOSEST_SIDE = "closest-side";
var FARTHEST_SIDE = "farthest-side";
var CLOSEST_CORNER = "closest-corner";
var FARTHEST_CORNER = "farthest-corner";
var CIRCLE = "circle";
var ELLIPSE = "ellipse";
var COVER = "cover";
var CONTAIN = "contain";
var radialGradient = function(context, tokens) {
    var shape2 = 0;
    var size2 = 3;
    var stops = [];
    var position2 = [];
    parseFunctionArgs(tokens).forEach(function(arg, i) {
        var isColorStop = true;
        if (i === 0) {
            var isAtPosition_1 = false;
            isColorStop = arg.reduce(function(acc, token2) {
                if (isAtPosition_1) {
                    if (isIdentToken(token2)) switch(token2.value){
                        case "center":
                            position2.push(FIFTY_PERCENT);
                            return acc;
                        case "top":
                        case "left":
                            position2.push(ZERO_LENGTH);
                            return acc;
                        case "right":
                        case "bottom":
                            position2.push(HUNDRED_PERCENT);
                            return acc;
                    }
                    else if (isLengthPercentage(token2) || isLength(token2)) position2.push(token2);
                } else if (isIdentToken(token2)) switch(token2.value){
                    case CIRCLE:
                        shape2 = 0;
                        return false;
                    case ELLIPSE:
                        shape2 = 1;
                        return false;
                    case "at":
                        isAtPosition_1 = true;
                        return false;
                    case CLOSEST_SIDE:
                        size2 = 0;
                        return false;
                    case COVER:
                    case FARTHEST_SIDE:
                        size2 = 1;
                        return false;
                    case CONTAIN:
                    case CLOSEST_CORNER:
                        size2 = 2;
                        return false;
                    case FARTHEST_CORNER:
                        size2 = 3;
                        return false;
                }
                else if (isLength(token2) || isLengthPercentage(token2)) {
                    if (!Array.isArray(size2)) size2 = [];
                    size2.push(token2);
                    return false;
                }
                return acc;
            }, isColorStop);
        }
        if (isColorStop) {
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        }
    });
    return {
        size: size2,
        shape: shape2,
        stops: stops,
        position: position2,
        type: 2
    };
};
var prefixRadialGradient = function(context, tokens) {
    var shape2 = 0;
    var size2 = 3;
    var stops = [];
    var position2 = [];
    parseFunctionArgs(tokens).forEach(function(arg, i) {
        var isColorStop = true;
        if (i === 0) isColorStop = arg.reduce(function(acc, token2) {
            if (isIdentToken(token2)) switch(token2.value){
                case "center":
                    position2.push(FIFTY_PERCENT);
                    return false;
                case "top":
                case "left":
                    position2.push(ZERO_LENGTH);
                    return false;
                case "right":
                case "bottom":
                    position2.push(HUNDRED_PERCENT);
                    return false;
            }
            else if (isLengthPercentage(token2) || isLength(token2)) {
                position2.push(token2);
                return false;
            }
            return acc;
        }, isColorStop);
        else if (i === 1) isColorStop = arg.reduce(function(acc, token2) {
            if (isIdentToken(token2)) switch(token2.value){
                case CIRCLE:
                    shape2 = 0;
                    return false;
                case ELLIPSE:
                    shape2 = 1;
                    return false;
                case CONTAIN:
                case CLOSEST_SIDE:
                    size2 = 0;
                    return false;
                case FARTHEST_SIDE:
                    size2 = 1;
                    return false;
                case CLOSEST_CORNER:
                    size2 = 2;
                    return false;
                case COVER:
                case FARTHEST_CORNER:
                    size2 = 3;
                    return false;
            }
            else if (isLength(token2) || isLengthPercentage(token2)) {
                if (!Array.isArray(size2)) size2 = [];
                size2.push(token2);
                return false;
            }
            return acc;
        }, isColorStop);
        if (isColorStop) {
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        }
    });
    return {
        size: size2,
        shape: shape2,
        stops: stops,
        position: position2,
        type: 2
    };
};
var isLinearGradient = function(background) {
    return background.type === 1;
};
var isRadialGradient = function(background) {
    return background.type === 2;
};
var image$5 = {
    name: "image",
    parse: function(context, value2) {
        if (value2.type === 22) {
            var image_1 = {
                url: value2.value,
                type: 0
            };
            context.cache.addImage(value2.value);
            return image_1;
        }
        if (value2.type === 18) {
            var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value2.name];
            if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value2.name + '"');
            return imageFunction(context, value2.values);
        }
        throw new Error("Unsupported image type " + value2.type);
    }
};
function isSupportedImage(value2) {
    return !(value2.type === 20 && value2.value === "none") && (value2.type !== 18 || !!SUPPORTED_IMAGE_FUNCTIONS[value2.name]);
}
var SUPPORTED_IMAGE_FUNCTIONS = {
    "linear-gradient": linearGradient,
    "-moz-linear-gradient": prefixLinearGradient,
    "-ms-linear-gradient": prefixLinearGradient,
    "-o-linear-gradient": prefixLinearGradient,
    "-webkit-linear-gradient": prefixLinearGradient,
    "radial-gradient": radialGradient,
    "-moz-radial-gradient": prefixRadialGradient,
    "-ms-radial-gradient": prefixRadialGradient,
    "-o-radial-gradient": prefixRadialGradient,
    "-webkit-radial-gradient": prefixRadialGradient,
    "-webkit-gradient": webkitGradient
};
var backgroundImage = {
    name: "background-image",
    initialValue: "none",
    type: 1,
    prefix: false,
    parse: function(context, tokens) {
        if (tokens.length === 0) return [];
        var first = tokens[0];
        if (first.type === 20 && first.value === "none") return [];
        return tokens.filter(function(value2) {
            return nonFunctionArgSeparator(value2) && isSupportedImage(value2);
        }).map(function(value2) {
            return image$5.parse(context, value2);
        });
    }
};
var backgroundOrigin = {
    name: "background-origin",
    initialValue: "border-box",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return tokens.map(function(token2) {
            if (isIdentToken(token2)) switch(token2.value){
                case "padding-box":
                    return 1;
                case "content-box":
                    return 2;
            }
            return 0;
        });
    }
};
var backgroundPosition = {
    name: "background-position",
    initialValue: "0% 0%",
    type: 1,
    prefix: false,
    parse: function(_context, tokens) {
        return parseFunctionArgs(tokens).map(function(values2) {
            return values2.filter(isLengthPercentage);
        }).map(parseLengthPercentageTuple);
    }
};
var backgroundRepeat = {
    name: "background-repeat",
    initialValue: "repeat",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return parseFunctionArgs(tokens).map(function(values2) {
            return values2.filter(isIdentToken).map(function(token2) {
                return token2.value;
            }).join(" ");
        }).map(parseBackgroundRepeat);
    }
};
var parseBackgroundRepeat = function(value2) {
    switch(value2){
        case "no-repeat":
            return 1;
        case "repeat-x":
        case "repeat no-repeat":
            return 2;
        case "repeat-y":
        case "no-repeat repeat":
            return 3;
        case "repeat":
        default:
            return 0;
    }
};
var BACKGROUND_SIZE;
(function(BACKGROUND_SIZE2) {
    BACKGROUND_SIZE2["AUTO"] = "auto";
    BACKGROUND_SIZE2["CONTAIN"] = "contain";
    BACKGROUND_SIZE2["COVER"] = "cover";
})(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
var backgroundSize = {
    name: "background-size",
    initialValue: "0",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return parseFunctionArgs(tokens).map(function(values2) {
            return values2.filter(isBackgroundSizeInfoToken);
        });
    }
};
var isBackgroundSizeInfoToken = function(value2) {
    return isIdentToken(value2) || isLengthPercentage(value2);
};
var borderColorForSide = function(side) {
    return {
        name: "border-" + side + "-color",
        initialValue: "transparent",
        prefix: false,
        type: 3,
        format: "color"
    };
};
var borderTopColor = borderColorForSide("top");
var borderRightColor = borderColorForSide("right");
var borderBottomColor = borderColorForSide("bottom");
var borderLeftColor = borderColorForSide("left");
var borderRadiusForSide = function(side) {
    return {
        name: "border-radius-" + side,
        initialValue: "0 0",
        prefix: false,
        type: 1,
        parse: function(_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    };
};
var borderTopLeftRadius = borderRadiusForSide("top-left");
var borderTopRightRadius = borderRadiusForSide("top-right");
var borderBottomRightRadius = borderRadiusForSide("bottom-right");
var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
var borderStyleForSide = function(side) {
    return {
        name: "border-" + side + "-style",
        initialValue: "solid",
        prefix: false,
        type: 2,
        parse: function(_context, style) {
            switch(style){
                case "none":
                    return 0;
                case "dashed":
                    return 2;
                case "dotted":
                    return 3;
                case "double":
                    return 4;
            }
            return 1;
        }
    };
};
var borderTopStyle = borderStyleForSide("top");
var borderRightStyle = borderStyleForSide("right");
var borderBottomStyle = borderStyleForSide("bottom");
var borderLeftStyle = borderStyleForSide("left");
var borderWidthForSide = function(side) {
    return {
        name: "border-" + side + "-width",
        initialValue: "0",
        type: 0,
        prefix: false,
        parse: function(_context, token2) {
            if (isDimensionToken(token2)) return token2.number;
            return 0;
        }
    };
};
var borderTopWidth = borderWidthForSide("top");
var borderRightWidth = borderWidthForSide("right");
var borderBottomWidth = borderWidthForSide("bottom");
var borderLeftWidth = borderWidthForSide("left");
var color$2 = {
    name: "color",
    initialValue: "transparent",
    prefix: false,
    type: 3,
    format: "color"
};
var direction = {
    name: "direction",
    initialValue: "ltr",
    prefix: false,
    type: 2,
    parse: function(_context, direction2) {
        switch(direction2){
            case "rtl":
                return 1;
            case "ltr":
            default:
                return 0;
        }
    }
};
var display = {
    name: "display",
    initialValue: "inline-block",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return tokens.filter(isIdentToken).reduce(function(bit, token2) {
            return bit | parseDisplayValue(token2.value);
        }, 0);
    }
};
var parseDisplayValue = function(display2) {
    switch(display2){
        case "block":
        case "-webkit-box":
            return 2;
        case "inline":
            return 4;
        case "run-in":
            return 8;
        case "flow":
            return 16;
        case "flow-root":
            return 32;
        case "table":
            return 64;
        case "flex":
        case "-webkit-flex":
            return 128;
        case "grid":
        case "-ms-grid":
            return 256;
        case "ruby":
            return 512;
        case "subgrid":
            return 1024;
        case "list-item":
            return 2048;
        case "table-row-group":
            return 4096;
        case "table-header-group":
            return 8192;
        case "table-footer-group":
            return 16384;
        case "table-row":
            return 32768;
        case "table-cell":
            return 65536;
        case "table-column-group":
            return 131072;
        case "table-column":
            return 262144;
        case "table-caption":
            return 524288;
        case "ruby-base":
            return 1048576;
        case "ruby-text":
            return 2097152;
        case "ruby-base-container":
            return 4194304;
        case "ruby-text-container":
            return 8388608;
        case "contents":
            return 16777216;
        case "inline-block":
            return 33554432;
        case "inline-list-item":
            return 67108864;
        case "inline-table":
            return 134217728;
        case "inline-flex":
            return 268435456;
        case "inline-grid":
            return 536870912;
    }
    return 0;
};
var float = {
    name: "float",
    initialValue: "none",
    prefix: false,
    type: 2,
    parse: function(_context, float2) {
        switch(float2){
            case "left":
                return 1;
            case "right":
                return 2;
            case "inline-start":
                return 3;
            case "inline-end":
                return 4;
        }
        return 0;
    }
};
var letterSpacing = {
    name: "letter-spacing",
    initialValue: "0",
    prefix: false,
    type: 0,
    parse: function(_context, token2) {
        if (token2.type === 20 && token2.value === "normal") return 0;
        if (token2.type === 17) return token2.number;
        if (token2.type === 15) return token2.number;
        return 0;
    }
};
var LINE_BREAK;
(function(LINE_BREAK2) {
    LINE_BREAK2["NORMAL"] = "normal";
    LINE_BREAK2["STRICT"] = "strict";
})(LINE_BREAK || (LINE_BREAK = {}));
var lineBreak = {
    name: "line-break",
    initialValue: "normal",
    prefix: false,
    type: 2,
    parse: function(_context, lineBreak2) {
        switch(lineBreak2){
            case "strict":
                return LINE_BREAK.STRICT;
            case "normal":
            default:
                return LINE_BREAK.NORMAL;
        }
    }
};
var lineHeight = {
    name: "line-height",
    initialValue: "normal",
    prefix: false,
    type: 4
};
var computeLineHeight = function(token2, fontSize2) {
    if (isIdentToken(token2) && token2.value === "normal") return 1.2 * fontSize2;
    else if (token2.type === 17) return fontSize2 * token2.number;
    else if (isLengthPercentage(token2)) return getAbsoluteValue(token2, fontSize2);
    return fontSize2;
};
var listStyleImage = {
    name: "list-style-image",
    initialValue: "none",
    type: 0,
    prefix: false,
    parse: function(context, token2) {
        if (token2.type === 20 && token2.value === "none") return null;
        return image$5.parse(context, token2);
    }
};
var listStylePosition = {
    name: "list-style-position",
    initialValue: "outside",
    prefix: false,
    type: 2,
    parse: function(_context, position2) {
        switch(position2){
            case "inside":
                return 0;
            case "outside":
            default:
                return 1;
        }
    }
};
var listStyleType = {
    name: "list-style-type",
    initialValue: "none",
    prefix: false,
    type: 2,
    parse: function(_context, type) {
        switch(type){
            case "disc":
                return 0;
            case "circle":
                return 1;
            case "square":
                return 2;
            case "decimal":
                return 3;
            case "cjk-decimal":
                return 4;
            case "decimal-leading-zero":
                return 5;
            case "lower-roman":
                return 6;
            case "upper-roman":
                return 7;
            case "lower-greek":
                return 8;
            case "lower-alpha":
                return 9;
            case "upper-alpha":
                return 10;
            case "arabic-indic":
                return 11;
            case "armenian":
                return 12;
            case "bengali":
                return 13;
            case "cambodian":
                return 14;
            case "cjk-earthly-branch":
                return 15;
            case "cjk-heavenly-stem":
                return 16;
            case "cjk-ideographic":
                return 17;
            case "devanagari":
                return 18;
            case "ethiopic-numeric":
                return 19;
            case "georgian":
                return 20;
            case "gujarati":
                return 21;
            case "gurmukhi":
                return 22;
            case "hebrew":
                return 22;
            case "hiragana":
                return 23;
            case "hiragana-iroha":
                return 24;
            case "japanese-formal":
                return 25;
            case "japanese-informal":
                return 26;
            case "kannada":
                return 27;
            case "katakana":
                return 28;
            case "katakana-iroha":
                return 29;
            case "khmer":
                return 30;
            case "korean-hangul-formal":
                return 31;
            case "korean-hanja-formal":
                return 32;
            case "korean-hanja-informal":
                return 33;
            case "lao":
                return 34;
            case "lower-armenian":
                return 35;
            case "malayalam":
                return 36;
            case "mongolian":
                return 37;
            case "myanmar":
                return 38;
            case "oriya":
                return 39;
            case "persian":
                return 40;
            case "simp-chinese-formal":
                return 41;
            case "simp-chinese-informal":
                return 42;
            case "tamil":
                return 43;
            case "telugu":
                return 44;
            case "thai":
                return 45;
            case "tibetan":
                return 46;
            case "trad-chinese-formal":
                return 47;
            case "trad-chinese-informal":
                return 48;
            case "upper-armenian":
                return 49;
            case "disclosure-open":
                return 50;
            case "disclosure-closed":
                return 51;
            case "none":
            default:
                return -1;
        }
    }
};
var marginForSide = function(side) {
    return {
        name: "margin-" + side,
        initialValue: "0",
        prefix: false,
        type: 4
    };
};
var marginTop = marginForSide("top");
var marginRight = marginForSide("right");
var marginBottom = marginForSide("bottom");
var marginLeft = marginForSide("left");
var overflow = {
    name: "overflow",
    initialValue: "visible",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return tokens.filter(isIdentToken).map(function(overflow2) {
            switch(overflow2.value){
                case "hidden":
                    return 1;
                case "scroll":
                    return 2;
                case "clip":
                    return 3;
                case "auto":
                    return 4;
                case "visible":
                default:
                    return 0;
            }
        });
    }
};
var overflowWrap = {
    name: "overflow-wrap",
    initialValue: "normal",
    prefix: false,
    type: 2,
    parse: function(_context, overflow2) {
        switch(overflow2){
            case "break-word":
                return "break-word";
            case "normal":
            default:
                return "normal";
        }
    }
};
var paddingForSide = function(side) {
    return {
        name: "padding-" + side,
        initialValue: "0",
        prefix: false,
        type: 3,
        format: "length-percentage"
    };
};
var paddingTop = paddingForSide("top");
var paddingRight = paddingForSide("right");
var paddingBottom = paddingForSide("bottom");
var paddingLeft = paddingForSide("left");
var textAlign = {
    name: "text-align",
    initialValue: "left",
    prefix: false,
    type: 2,
    parse: function(_context, textAlign2) {
        switch(textAlign2){
            case "right":
                return 2;
            case "center":
            case "justify":
                return 1;
            case "left":
            default:
                return 0;
        }
    }
};
var position = {
    name: "position",
    initialValue: "static",
    prefix: false,
    type: 2,
    parse: function(_context, position2) {
        switch(position2){
            case "relative":
                return 1;
            case "absolute":
                return 2;
            case "fixed":
                return 3;
            case "sticky":
                return 4;
        }
        return 0;
    }
};
var textShadow = {
    name: "text-shadow",
    initialValue: "none",
    type: 1,
    prefix: false,
    parse: function(context, tokens) {
        if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
        return parseFunctionArgs(tokens).map(function(values2) {
            var shadow = {
                color: COLORS.TRANSPARENT,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH
            };
            var c2 = 0;
            for(var i = 0; i < values2.length; i++){
                var token2 = values2[i];
                if (isLength(token2)) {
                    if (c2 === 0) shadow.offsetX = token2;
                    else if (c2 === 1) shadow.offsetY = token2;
                    else shadow.blur = token2;
                    c2++;
                } else shadow.color = color$1.parse(context, token2);
            }
            return shadow;
        });
    }
};
var textTransform = {
    name: "text-transform",
    initialValue: "none",
    prefix: false,
    type: 2,
    parse: function(_context, textTransform2) {
        switch(textTransform2){
            case "uppercase":
                return 2;
            case "lowercase":
                return 1;
            case "capitalize":
                return 3;
        }
        return 0;
    }
};
var transform$1 = {
    name: "transform",
    initialValue: "none",
    prefix: true,
    type: 0,
    parse: function(_context, token2) {
        if (token2.type === 20 && token2.value === "none") return null;
        if (token2.type === 18) {
            var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token2.name];
            if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token2.name + '"');
            return transformFunction(token2.values);
        }
        return null;
    }
};
var matrix = function(args) {
    var values2 = args.filter(function(arg) {
        return arg.type === 17;
    }).map(function(arg) {
        return arg.number;
    });
    return values2.length === 6 ? values2 : null;
};
var matrix3d = function(args) {
    var values2 = args.filter(function(arg) {
        return arg.type === 17;
    }).map(function(arg) {
        return arg.number;
    });
    var a1 = values2[0], b1 = values2[1];
    values2[2];
    values2[3];
    var a2 = values2[4], b2 = values2[5];
    values2[6];
    values2[7];
    values2[8];
    values2[9];
    values2[10];
    values2[11];
    var a4 = values2[12], b4 = values2[13];
    values2[14];
    values2[15];
    return values2.length === 16 ? [
        a1,
        b1,
        a2,
        b2,
        a4,
        b4
    ] : null;
};
var SUPPORTED_TRANSFORM_FUNCTIONS = {
    matrix: matrix,
    matrix3d: matrix3d
};
var DEFAULT_VALUE = {
    type: 16,
    number: 50,
    flags: FLAG_INTEGER
};
var DEFAULT = [
    DEFAULT_VALUE,
    DEFAULT_VALUE
];
var transformOrigin = {
    name: "transform-origin",
    initialValue: "50% 50%",
    prefix: true,
    type: 1,
    parse: function(_context, tokens) {
        var origins = tokens.filter(isLengthPercentage);
        if (origins.length !== 2) return DEFAULT;
        return [
            origins[0],
            origins[1]
        ];
    }
};
var visibility = {
    name: "visible",
    initialValue: "none",
    prefix: false,
    type: 2,
    parse: function(_context, visibility2) {
        switch(visibility2){
            case "hidden":
                return 1;
            case "collapse":
                return 2;
            case "visible":
            default:
                return 0;
        }
    }
};
var WORD_BREAK;
(function(WORD_BREAK2) {
    WORD_BREAK2["NORMAL"] = "normal";
    WORD_BREAK2["BREAK_ALL"] = "break-all";
    WORD_BREAK2["KEEP_ALL"] = "keep-all";
})(WORD_BREAK || (WORD_BREAK = {}));
var wordBreak = {
    name: "word-break",
    initialValue: "normal",
    prefix: false,
    type: 2,
    parse: function(_context, wordBreak2) {
        switch(wordBreak2){
            case "break-all":
                return WORD_BREAK.BREAK_ALL;
            case "keep-all":
                return WORD_BREAK.KEEP_ALL;
            case "normal":
            default:
                return WORD_BREAK.NORMAL;
        }
    }
};
var zIndex = {
    name: "z-index",
    initialValue: "auto",
    prefix: false,
    type: 0,
    parse: function(_context, token2) {
        if (token2.type === 20) return {
            auto: true,
            order: 0
        };
        if (isNumberToken(token2)) return {
            auto: false,
            order: token2.number
        };
        throw new Error("Invalid z-index number parsed");
    }
};
var time = {
    name: "time",
    parse: function(_context, value2) {
        if (value2.type === 15) switch(value2.unit.toLowerCase()){
            case "s":
                return 1e3 * value2.number;
            case "ms":
                return value2.number;
        }
        throw new Error("Unsupported time type");
    }
};
var opacity = {
    name: "opacity",
    initialValue: "1",
    type: 0,
    prefix: false,
    parse: function(_context, token2) {
        if (isNumberToken(token2)) return token2.number;
        return 1;
    }
};
var textDecorationColor = {
    name: "text-decoration-color",
    initialValue: "transparent",
    prefix: false,
    type: 3,
    format: "color"
};
var textDecorationLine = {
    name: "text-decoration-line",
    initialValue: "none",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        return tokens.filter(isIdentToken).map(function(token2) {
            switch(token2.value){
                case "underline":
                    return 1;
                case "overline":
                    return 2;
                case "line-through":
                    return 3;
                case "none":
                    return 4;
            }
            return 0;
        }).filter(function(line) {
            return line !== 0;
        });
    }
};
var fontFamily = {
    name: "font-family",
    initialValue: "",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        var accumulator = [];
        var results = [];
        tokens.forEach(function(token2) {
            switch(token2.type){
                case 20:
                case 0:
                    accumulator.push(token2.value);
                    break;
                case 17:
                    accumulator.push(token2.number.toString());
                    break;
                case 4:
                    results.push(accumulator.join(" "));
                    accumulator.length = 0;
                    break;
            }
        });
        if (accumulator.length) results.push(accumulator.join(" "));
        return results.map(function(result2) {
            return result2.indexOf(" ") === -1 ? result2 : "'" + result2 + "'";
        });
    }
};
var fontSize = {
    name: "font-size",
    initialValue: "0",
    prefix: false,
    type: 3,
    format: "length"
};
var fontWeight = {
    name: "font-weight",
    initialValue: "normal",
    type: 0,
    prefix: false,
    parse: function(_context, token2) {
        if (isNumberToken(token2)) return token2.number;
        if (isIdentToken(token2)) switch(token2.value){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
        return 400;
    }
};
var fontVariant = {
    name: "font-variant",
    initialValue: "none",
    type: 1,
    prefix: false,
    parse: function(_context, tokens) {
        return tokens.filter(isIdentToken).map(function(token2) {
            return token2.value;
        });
    }
};
var fontStyle = {
    name: "font-style",
    initialValue: "normal",
    prefix: false,
    type: 2,
    parse: function(_context, overflow2) {
        switch(overflow2){
            case "oblique":
                return "oblique";
            case "italic":
                return "italic";
            case "normal":
            default:
                return "normal";
        }
    }
};
var contains$1 = function(bit, value2) {
    return (bit & value2) !== 0;
};
var duration = {
    name: "duration",
    initialValue: "0s",
    prefix: false,
    type: 1,
    parse: function(context, tokens) {
        return tokens.filter(isDimensionToken).map(function(token2) {
            return time.parse(context, token2);
        });
    }
};
var boxShadow = {
    name: "box-shadow",
    initialValue: "none",
    type: 1,
    prefix: false,
    parse: function(context, tokens) {
        if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
        return parseFunctionArgs(tokens).map(function(values2) {
            var shadow = {
                color: 255,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH,
                spread: ZERO_LENGTH,
                inset: false
            };
            var c2 = 0;
            for(var i = 0; i < values2.length; i++){
                var token2 = values2[i];
                if (isIdentWithValue(token2, "inset")) shadow.inset = true;
                else if (isLength(token2)) {
                    if (c2 === 0) shadow.offsetX = token2;
                    else if (c2 === 1) shadow.offsetY = token2;
                    else if (c2 === 2) shadow.blur = token2;
                    else shadow.spread = token2;
                    c2++;
                } else shadow.color = color$1.parse(context, token2);
            }
            return shadow;
        });
    }
};
var paintOrder = {
    name: "paint-order",
    initialValue: "normal",
    prefix: false,
    type: 1,
    parse: function(_context, tokens) {
        var DEFAULT_VALUE2 = [
            0,
            1,
            2
        ];
        var layers = [];
        tokens.filter(isIdentToken).forEach(function(token2) {
            switch(token2.value){
                case "stroke":
                    layers.push(1);
                    break;
                case "fill":
                    layers.push(0);
                    break;
                case "markers":
                    layers.push(2);
                    break;
            }
        });
        DEFAULT_VALUE2.forEach(function(value2) {
            if (layers.indexOf(value2) === -1) layers.push(value2);
        });
        return layers;
    }
};
var webkitTextStrokeColor = {
    name: "-webkit-text-stroke-color",
    initialValue: "currentcolor",
    prefix: false,
    type: 3,
    format: "color"
};
var webkitTextStrokeWidth = {
    name: "-webkit-text-stroke-width",
    initialValue: "0",
    type: 0,
    prefix: false,
    parse: function(_context, token2) {
        if (isDimensionToken(token2)) return token2.number;
        return 0;
    }
};
var CSSParsedDeclaration = /** @class */ function() {
    function CSSParsedDeclaration2(context, declaration) {
        var _a3, _b2;
        this.animationDuration = parse$1(context, duration, declaration.animationDuration);
        this.backgroundClip = parse$1(context, backgroundClip, declaration.backgroundClip);
        this.backgroundColor = parse$1(context, backgroundColor, declaration.backgroundColor);
        this.backgroundImage = parse$1(context, backgroundImage, declaration.backgroundImage);
        this.backgroundOrigin = parse$1(context, backgroundOrigin, declaration.backgroundOrigin);
        this.backgroundPosition = parse$1(context, backgroundPosition, declaration.backgroundPosition);
        this.backgroundRepeat = parse$1(context, backgroundRepeat, declaration.backgroundRepeat);
        this.backgroundSize = parse$1(context, backgroundSize, declaration.backgroundSize);
        this.borderTopColor = parse$1(context, borderTopColor, declaration.borderTopColor);
        this.borderRightColor = parse$1(context, borderRightColor, declaration.borderRightColor);
        this.borderBottomColor = parse$1(context, borderBottomColor, declaration.borderBottomColor);
        this.borderLeftColor = parse$1(context, borderLeftColor, declaration.borderLeftColor);
        this.borderTopLeftRadius = parse$1(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
        this.borderTopRightRadius = parse$1(context, borderTopRightRadius, declaration.borderTopRightRadius);
        this.borderBottomRightRadius = parse$1(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
        this.borderBottomLeftRadius = parse$1(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
        this.borderTopStyle = parse$1(context, borderTopStyle, declaration.borderTopStyle);
        this.borderRightStyle = parse$1(context, borderRightStyle, declaration.borderRightStyle);
        this.borderBottomStyle = parse$1(context, borderBottomStyle, declaration.borderBottomStyle);
        this.borderLeftStyle = parse$1(context, borderLeftStyle, declaration.borderLeftStyle);
        this.borderTopWidth = parse$1(context, borderTopWidth, declaration.borderTopWidth);
        this.borderRightWidth = parse$1(context, borderRightWidth, declaration.borderRightWidth);
        this.borderBottomWidth = parse$1(context, borderBottomWidth, declaration.borderBottomWidth);
        this.borderLeftWidth = parse$1(context, borderLeftWidth, declaration.borderLeftWidth);
        this.boxShadow = parse$1(context, boxShadow, declaration.boxShadow);
        this.color = parse$1(context, color$2, declaration.color);
        this.direction = parse$1(context, direction, declaration.direction);
        this.display = parse$1(context, display, declaration.display);
        this.float = parse$1(context, float, declaration.cssFloat);
        this.fontFamily = parse$1(context, fontFamily, declaration.fontFamily);
        this.fontSize = parse$1(context, fontSize, declaration.fontSize);
        this.fontStyle = parse$1(context, fontStyle, declaration.fontStyle);
        this.fontVariant = parse$1(context, fontVariant, declaration.fontVariant);
        this.fontWeight = parse$1(context, fontWeight, declaration.fontWeight);
        this.letterSpacing = parse$1(context, letterSpacing, declaration.letterSpacing);
        this.lineBreak = parse$1(context, lineBreak, declaration.lineBreak);
        this.lineHeight = parse$1(context, lineHeight, declaration.lineHeight);
        this.listStyleImage = parse$1(context, listStyleImage, declaration.listStyleImage);
        this.listStylePosition = parse$1(context, listStylePosition, declaration.listStylePosition);
        this.listStyleType = parse$1(context, listStyleType, declaration.listStyleType);
        this.marginTop = parse$1(context, marginTop, declaration.marginTop);
        this.marginRight = parse$1(context, marginRight, declaration.marginRight);
        this.marginBottom = parse$1(context, marginBottom, declaration.marginBottom);
        this.marginLeft = parse$1(context, marginLeft, declaration.marginLeft);
        this.opacity = parse$1(context, opacity, declaration.opacity);
        var overflowTuple = parse$1(context, overflow, declaration.overflow);
        this.overflowX = overflowTuple[0];
        this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
        this.overflowWrap = parse$1(context, overflowWrap, declaration.overflowWrap);
        this.paddingTop = parse$1(context, paddingTop, declaration.paddingTop);
        this.paddingRight = parse$1(context, paddingRight, declaration.paddingRight);
        this.paddingBottom = parse$1(context, paddingBottom, declaration.paddingBottom);
        this.paddingLeft = parse$1(context, paddingLeft, declaration.paddingLeft);
        this.paintOrder = parse$1(context, paintOrder, declaration.paintOrder);
        this.position = parse$1(context, position, declaration.position);
        this.textAlign = parse$1(context, textAlign, declaration.textAlign);
        this.textDecorationColor = parse$1(context, textDecorationColor, (_a3 = declaration.textDecorationColor) !== null && _a3 !== void 0 ? _a3 : declaration.color);
        this.textDecorationLine = parse$1(context, textDecorationLine, (_b2 = declaration.textDecorationLine) !== null && _b2 !== void 0 ? _b2 : declaration.textDecoration);
        this.textShadow = parse$1(context, textShadow, declaration.textShadow);
        this.textTransform = parse$1(context, textTransform, declaration.textTransform);
        this.transform = parse$1(context, transform$1, declaration.transform);
        this.transformOrigin = parse$1(context, transformOrigin, declaration.transformOrigin);
        this.visibility = parse$1(context, visibility, declaration.visibility);
        this.webkitTextStrokeColor = parse$1(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
        this.webkitTextStrokeWidth = parse$1(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
        this.wordBreak = parse$1(context, wordBreak, declaration.wordBreak);
        this.zIndex = parse$1(context, zIndex, declaration.zIndex);
    }
    CSSParsedDeclaration2.prototype.isVisible = function() {
        return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    };
    CSSParsedDeclaration2.prototype.isTransparent = function() {
        return isTransparent(this.backgroundColor);
    };
    CSSParsedDeclaration2.prototype.isTransformed = function() {
        return this.transform !== null;
    };
    CSSParsedDeclaration2.prototype.isPositioned = function() {
        return this.position !== 0;
    };
    CSSParsedDeclaration2.prototype.isPositionedWithZIndex = function() {
        return this.isPositioned() && !this.zIndex.auto;
    };
    CSSParsedDeclaration2.prototype.isFloating = function() {
        return this.float !== 0;
    };
    CSSParsedDeclaration2.prototype.isInlineLevel = function() {
        return contains$1(this.display, 4) || contains$1(this.display, 33554432) || contains$1(this.display, 268435456) || contains$1(this.display, 536870912) || contains$1(this.display, 67108864) || contains$1(this.display, 134217728);
    };
    return CSSParsedDeclaration2;
}();
var parse$1 = function(context, descriptor, style) {
    var tokenizer = new Tokenizer$1();
    var value2 = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
    tokenizer.write(value2);
    var parser = new Parser$1(tokenizer.read());
    switch(descriptor.type){
        case 2:
            var token2 = parser.parseComponentValue();
            return descriptor.parse(context, isIdentToken(token2) ? token2.value : descriptor.initialValue);
        case 0:
            return descriptor.parse(context, parser.parseComponentValue());
        case 1:
            return descriptor.parse(context, parser.parseComponentValues());
        case 4:
            return parser.parseComponentValue();
        case 3:
            switch(descriptor.format){
                case "angle":
                    return angle.parse(context, parser.parseComponentValue());
                case "color":
                    return color$1.parse(context, parser.parseComponentValue());
                case "image":
                    return image$5.parse(context, parser.parseComponentValue());
                case "length":
                    var length_1 = parser.parseComponentValue();
                    return isLength(length_1) ? length_1 : ZERO_LENGTH;
                case "length-percentage":
                    var value_1 = parser.parseComponentValue();
                    return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                case "time":
                    return time.parse(context, parser.parseComponentValue());
            }
            break;
    }
};
var elementDebuggerAttribute = "data-html2canvas-debug";
var getElementDebugType = function(element) {
    var attribute = element.getAttribute(elementDebuggerAttribute);
    switch(attribute){
        case "all":
            return 1;
        case "clone":
            return 2;
        case "parse":
            return 3;
        case "render":
            return 4;
        default:
            return 0;
    }
};
var isDebugging = function(element, type) {
    var elementType2 = getElementDebugType(element);
    return elementType2 === 1 || type === elementType2;
};
var ElementContainer = /** @class */ /* @__PURE__ */ function() {
    function ElementContainer2(context, element) {
        this.context = context;
        this.textNodes = [];
        this.elements = [];
        this.flags = 0;
        if (isDebugging(element, 3)) debugger;
        this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
        if (isHTMLElementNode(element)) {
            if (this.styles.animationDuration.some(function(duration2) {
                return duration2 > 0;
            })) element.style.animationDuration = "0s";
            if (this.styles.transform !== null) element.style.transform = "none";
        }
        this.bounds = parseBounds(this.context, element);
        if (isDebugging(element, 4)) this.flags |= 16;
    }
    return ElementContainer2;
}();
var base64$2 = "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";
var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
var decode = function(base642) {
    var bufferLength = base642.length * 0.75, len = base642.length, i, p2 = 0, encoded1, encoded2, encoded3, encoded4;
    if (base642[base642.length - 1] === "=") {
        bufferLength--;
        if (base642[base642.length - 2] === "=") bufferLength--;
    }
    var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
    for(i = 0; i < len; i += 4){
        encoded1 = lookup$1[base642.charCodeAt(i)];
        encoded2 = lookup$1[base642.charCodeAt(i + 1)];
        encoded3 = lookup$1[base642.charCodeAt(i + 2)];
        encoded4 = lookup$1[base642.charCodeAt(i + 3)];
        bytes[p2++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p2++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p2++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
};
var polyUint16Array = function(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
    return bytes;
};
var polyUint32Array = function(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
    return bytes;
};
var UTRIE2_SHIFT_2 = 5;
var UTRIE2_SHIFT_1 = 11;
var UTRIE2_INDEX_SHIFT = 2;
var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
var UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> UTRIE2_SHIFT_2;
var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
var UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> UTRIE2_SHIFT_2;
var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32;
var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> UTRIE2_SHIFT_1;
var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
var slice16 = function(view, start, end) {
    if (view.slice) return view.slice(start, end);
    return new Uint16Array(Array.prototype.slice.call(view, start, end));
};
var slice32 = function(view, start, end) {
    if (view.slice) return view.slice(start, end);
    return new Uint32Array(Array.prototype.slice.call(view, start, end));
};
var createTrieFromBase64 = function(base642, _byteLength) {
    var buffer = decode(base642);
    var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
    var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
    var headerLength = 24;
    var index2 = slice16(view16, headerLength / 2, view32[4] / 2);
    var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
    return new Trie(view32[0], view32[1], view32[2], view32[3], index2, data);
};
var Trie = /** @class */ function() {
    function Trie2(initialValue, errorValue, highStart, highValueIndex, index2, data) {
        this.initialValue = initialValue;
        this.errorValue = errorValue;
        this.highStart = highStart;
        this.highValueIndex = highValueIndex;
        this.index = index2;
        this.data = data;
    }
    Trie2.prototype.get = function(codePoint) {
        var ix;
        if (codePoint >= 0) {
            if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
            }
            if (codePoint <= 65535) {
                ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> UTRIE2_SHIFT_2)];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
            }
            if (codePoint < this.highStart) {
                ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                ix = this.index[ix];
                ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                ix = this.index[ix];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
            }
            if (codePoint <= 1114111) return this.data[this.highValueIndex];
        }
        return this.errorValue;
    };
    return Trie2;
}();
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
var Prepend = 1;
var CR = 2;
var LF = 3;
var Control = 4;
var Extend = 5;
var SpacingMark = 7;
var L = 8;
var V = 9;
var T = 10;
var LV = 11;
var LVT = 12;
var ZWJ = 13;
var Extended_Pictographic = 14;
var RI = 15;
var toCodePoints = function(str) {
    var codePoints = [];
    var i = 0;
    var length = str.length;
    while(i < length){
        var value2 = str.charCodeAt(i++);
        if (value2 >= 55296 && value2 <= 56319 && i < length) {
            var extra = str.charCodeAt(i++);
            if ((extra & 64512) === 56320) codePoints.push(((value2 & 1023) << 10) + (extra & 1023) + 65536);
            else {
                codePoints.push(value2);
                i--;
            }
        } else codePoints.push(value2);
    }
    return codePoints;
};
var fromCodePoint = function() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
    var length = codePoints.length;
    if (!length) return "";
    var codeUnits = [];
    var index2 = -1;
    var result2 = "";
    while(++index2 < length){
        var codePoint = codePoints[index2];
        if (codePoint <= 65535) codeUnits.push(codePoint);
        else {
            codePoint -= 65536;
            codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
        }
        if (index2 + 1 === length || codeUnits.length > 16384) {
            result2 += String.fromCharCode.apply(String, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result2;
};
var UnicodeTrie = createTrieFromBase64(base64$2);
var BREAK_NOT_ALLOWED = "\xd7";
var BREAK_ALLOWED = "\xf7";
var codePointToClass = function(codePoint) {
    return UnicodeTrie.get(codePoint);
};
var _graphemeBreakAtIndex = function(_codePoints, classTypes, index2) {
    var prevIndex = index2 - 2;
    var prev = classTypes[prevIndex];
    var current = classTypes[index2 - 1];
    var next2 = classTypes[index2];
    if (current === CR && next2 === LF) return BREAK_NOT_ALLOWED;
    if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
    if (next2 === CR || next2 === LF || next2 === Control) return BREAK_ALLOWED;
    if (current === L && [
        L,
        V,
        LV,
        LVT
    ].indexOf(next2) !== -1) return BREAK_NOT_ALLOWED;
    if ((current === LV || current === V) && (next2 === V || next2 === T)) return BREAK_NOT_ALLOWED;
    if ((current === LVT || current === T) && next2 === T) return BREAK_NOT_ALLOWED;
    if (next2 === ZWJ || next2 === Extend) return BREAK_NOT_ALLOWED;
    if (next2 === SpacingMark) return BREAK_NOT_ALLOWED;
    if (current === Prepend) return BREAK_NOT_ALLOWED;
    if (current === ZWJ && next2 === Extended_Pictographic) {
        while(prev === Extend)prev = classTypes[--prevIndex];
        if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
    }
    if (current === RI && next2 === RI) {
        var countRI = 0;
        while(prev === RI){
            countRI++;
            prev = classTypes[--prevIndex];
        }
        if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
    }
    return BREAK_ALLOWED;
};
var GraphemeBreaker = function(str) {
    var codePoints = toCodePoints(str);
    var length = codePoints.length;
    var index2 = 0;
    var lastEnd = 0;
    var classTypes = codePoints.map(codePointToClass);
    return {
        next: function() {
            if (index2 >= length) return {
                done: true,
                value: null
            };
            var graphemeBreak = BREAK_NOT_ALLOWED;
            while(index2 < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index2)) === BREAK_NOT_ALLOWED);
            if (graphemeBreak !== BREAK_NOT_ALLOWED || index2 === length) {
                var value2 = fromCodePoint.apply(null, codePoints.slice(lastEnd, index2));
                lastEnd = index2;
                return {
                    value: value2,
                    done: false
                };
            }
            return {
                done: true,
                value: null
            };
        }
    };
};
var splitGraphemes = function(str) {
    var breaker = GraphemeBreaker(str);
    var graphemes = [];
    var bk;
    while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
    return graphemes;
};
var testRangeBounds = function(document2) {
    var TEST_HEIGHT = 123;
    if (document2.createRange) {
        var range2 = document2.createRange();
        if (range2.getBoundingClientRect) {
            var testElement = document2.createElement("boundtest");
            testElement.style.height = TEST_HEIGHT + "px";
            testElement.style.display = "block";
            document2.body.appendChild(testElement);
            range2.selectNode(testElement);
            var rangeBounds = range2.getBoundingClientRect();
            var rangeHeight = Math.round(rangeBounds.height);
            document2.body.removeChild(testElement);
            if (rangeHeight === TEST_HEIGHT) return true;
        }
    }
    return false;
};
var testIOSLineBreak = function(document2) {
    var testElement = document2.createElement("boundtest");
    testElement.style.width = "50px";
    testElement.style.display = "block";
    testElement.style.fontSize = "12px";
    testElement.style.letterSpacing = "0px";
    testElement.style.wordSpacing = "0px";
    document2.body.appendChild(testElement);
    var range2 = document2.createRange();
    testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
    var node = testElement.firstChild;
    var textList = toCodePoints$1(node.data).map(function(i) {
        return fromCodePoint$1(i);
    });
    var offset2 = 0;
    var prev = {};
    var supports = textList.every(function(text2, i) {
        range2.setStart(node, offset2);
        range2.setEnd(node, offset2 + text2.length);
        var rect = range2.getBoundingClientRect();
        offset2 += text2.length;
        var boundAhead = rect.x > prev.x || rect.y > prev.y;
        prev = rect;
        if (i === 0) return true;
        return boundAhead;
    });
    document2.body.removeChild(testElement);
    return supports;
};
var testCORS = function() {
    return typeof new Image().crossOrigin !== "undefined";
};
var testResponseType = function() {
    return typeof new XMLHttpRequest().responseType === "string";
};
var testSVG = function(document2) {
    var img = new Image();
    var canvas = document2.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (!ctx) return false;
    img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch (e2) {
        return false;
    }
    return true;
};
var isGreenPixel = function(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};
var testForeignObject = function(document2) {
    var canvas = document2.createElement("canvas");
    var size2 = 100;
    canvas.width = size2;
    canvas.height = size2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return Promise.reject(false);
    ctx.fillStyle = "rgb(0, 255, 0)";
    ctx.fillRect(0, 0, size2, size2);
    var img = new Image();
    var greenImageSrc = canvas.toDataURL();
    img.src = greenImageSrc;
    var svg2 = createForeignObjectSVG(size2, size2, 0, 0, img);
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, size2, size2);
    return loadSerializedSVG$1(svg2).then(function(img2) {
        ctx.drawImage(img2, 0, 0);
        var data = ctx.getImageData(0, 0, size2, size2).data;
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size2, size2);
        var node = document2.createElement("div");
        node.style.backgroundImage = "url(" + greenImageSrc + ")";
        node.style.height = size2 + "px";
        return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size2, size2, 0, 0, node)) : Promise.reject(false);
    }).then(function(img2) {
        ctx.drawImage(img2, 0, 0);
        return isGreenPixel(ctx.getImageData(0, 0, size2, size2).data);
    }).catch(function() {
        return false;
    });
};
var createForeignObjectSVG = function(width, height, x2, y2, node) {
    var xmlns = "http://www.w3.org/2000/svg";
    var svg2 = document.createElementNS(xmlns, "svg");
    var foreignObject = document.createElementNS(xmlns, "foreignObject");
    svg2.setAttributeNS(null, "width", width.toString());
    svg2.setAttributeNS(null, "height", height.toString());
    foreignObject.setAttributeNS(null, "width", "100%");
    foreignObject.setAttributeNS(null, "height", "100%");
    foreignObject.setAttributeNS(null, "x", x2.toString());
    foreignObject.setAttributeNS(null, "y", y2.toString());
    foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
    svg2.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return svg2;
};
var loadSerializedSVG$1 = function(svg2) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg2));
    });
};
var FEATURES = {
    get SUPPORT_RANGE_BOUNDS () {
        var value2 = testRangeBounds(document);
        Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
            value: value2
        });
        return value2;
    },
    get SUPPORT_WORD_BREAKING () {
        var value21 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
        Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
            value: value21
        });
        return value21;
    },
    get SUPPORT_SVG_DRAWING () {
        var value22 = testSVG(document);
        Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
            value: value22
        });
        return value22;
    },
    get SUPPORT_FOREIGNOBJECT_DRAWING () {
        var value23 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
        Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
            value: value23
        });
        return value23;
    },
    get SUPPORT_CORS_IMAGES () {
        var value24 = testCORS();
        Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
            value: value24
        });
        return value24;
    },
    get SUPPORT_RESPONSE_TYPE () {
        var value25 = testResponseType();
        Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
            value: value25
        });
        return value25;
    },
    get SUPPORT_CORS_XHR () {
        var value26 = "withCredentials" in new XMLHttpRequest();
        Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
            value: value26
        });
        return value26;
    },
    get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
        var value27 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
        Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
            value: value27
        });
        return value27;
    }
};
var TextBounds = /** @class */ /* @__PURE__ */ function() {
    function TextBounds2(text2, bounds) {
        this.text = text2;
        this.bounds = bounds;
    }
    return TextBounds2;
}();
var parseTextBounds = function(context, value2, styles, node) {
    var textList = breakText(value2, styles);
    var textBounds = [];
    var offset2 = 0;
    textList.forEach(function(text2) {
        if (styles.textDecorationLine.length || text2.trim().length > 0) {
            if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                var clientRects = createRange(node, offset2, text2.length).getClientRects();
                if (clientRects.length > 1) {
                    var subSegments = segmentGraphemes(text2);
                    var subOffset_1 = 0;
                    subSegments.forEach(function(subSegment) {
                        textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset2, subSegment.length).getClientRects())));
                        subOffset_1 += subSegment.length;
                    });
                } else textBounds.push(new TextBounds(text2, Bounds.fromDOMRectList(context, clientRects)));
            } else {
                var replacementNode = node.splitText(text2.length);
                textBounds.push(new TextBounds(text2, getWrapperBounds(context, node)));
                node = replacementNode;
            }
        } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text2.length);
        offset2 += text2.length;
    });
    return textBounds;
};
var getWrapperBounds = function(context, node) {
    var ownerDocument = node.ownerDocument;
    if (ownerDocument) {
        var wrapper2 = ownerDocument.createElement("html2canvaswrapper");
        wrapper2.appendChild(node.cloneNode(true));
        var parentNode = node.parentNode;
        if (parentNode) {
            parentNode.replaceChild(wrapper2, node);
            var bounds = parseBounds(context, wrapper2);
            if (wrapper2.firstChild) parentNode.replaceChild(wrapper2.firstChild, wrapper2);
            return bounds;
        }
    }
    return Bounds.EMPTY;
};
var createRange = function(node, offset2, length) {
    var ownerDocument = node.ownerDocument;
    if (!ownerDocument) throw new Error("Node has no owner document");
    var range2 = ownerDocument.createRange();
    range2.setStart(node, offset2);
    range2.setEnd(node, offset2 + length);
    return range2;
};
var segmentGraphemes = function(value2) {
    if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
        var segmenter = new Intl.Segmenter(void 0, {
            granularity: "grapheme"
        });
        return Array.from(segmenter.segment(value2)).map(function(segment) {
            return segment.segment;
        });
    }
    return splitGraphemes(value2);
};
var segmentWords = function(value2, styles) {
    if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
        var segmenter = new Intl.Segmenter(void 0, {
            granularity: "word"
        });
        return Array.from(segmenter.segment(value2)).map(function(segment) {
            return segment.segment;
        });
    }
    return breakWords(value2, styles);
};
var breakText = function(value2, styles) {
    return styles.letterSpacing !== 0 ? segmentGraphemes(value2) : segmentWords(value2, styles);
};
var wordSeparators = [
    32,
    160,
    4961,
    65792,
    65793,
    4153,
    4241
];
var breakWords = function(str, styles) {
    var breaker = LineBreaker(str, {
        lineBreak: styles.lineBreak,
        wordBreak: styles.overflowWrap === "break-word" ? "break-word" : styles.wordBreak
    });
    var words = [];
    var bk;
    var _loop_1 = function() {
        if (bk.value) {
            var value2 = bk.value.slice();
            var codePoints = toCodePoints$1(value2);
            var word_1 = "";
            codePoints.forEach(function(codePoint) {
                if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                else {
                    if (word_1.length) words.push(word_1);
                    words.push(fromCodePoint$1(codePoint));
                    word_1 = "";
                }
            });
            if (word_1.length) words.push(word_1);
        }
    };
    while(!(bk = breaker.next()).done)_loop_1();
    return words;
};
var TextContainer = /** @class */ /* @__PURE__ */ function() {
    function TextContainer2(context, node, styles) {
        this.text = transform(node.data, styles.textTransform);
        this.textBounds = parseTextBounds(context, this.text, styles, node);
    }
    return TextContainer2;
}();
var transform = function(text2, transform2) {
    switch(transform2){
        case 1:
            return text2.toLowerCase();
        case 3:
            return text2.replace(CAPITALIZE, capitalize$3);
        case 2:
            return text2.toUpperCase();
        default:
            return text2;
    }
};
var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
var capitalize$3 = function(m2, p1, p2) {
    if (m2.length > 0) return p1 + p2.toUpperCase();
    return m2;
};
var ImageElementContainer = /** @class */ function(_super) {
    __extends$2(ImageElementContainer2, _super);
    function ImageElementContainer2(context, img) {
        var _this = _super.call(this, context, img) || this;
        _this.src = img.currentSrc || img.src;
        _this.intrinsicWidth = img.naturalWidth;
        _this.intrinsicHeight = img.naturalHeight;
        _this.context.cache.addImage(_this.src);
        return _this;
    }
    return ImageElementContainer2;
}(ElementContainer);
var CanvasElementContainer = /** @class */ function(_super) {
    __extends$2(CanvasElementContainer2, _super);
    function CanvasElementContainer2(context, canvas) {
        var _this = _super.call(this, context, canvas) || this;
        _this.canvas = canvas;
        _this.intrinsicWidth = canvas.width;
        _this.intrinsicHeight = canvas.height;
        return _this;
    }
    return CanvasElementContainer2;
}(ElementContainer);
var SVGElementContainer = /** @class */ function(_super) {
    __extends$2(SVGElementContainer2, _super);
    function SVGElementContainer2(context, img) {
        var _this = _super.call(this, context, img) || this;
        var s2 = new XMLSerializer();
        var bounds = parseBounds(context, img);
        img.setAttribute("width", bounds.width + "px");
        img.setAttribute("height", bounds.height + "px");
        _this.svg = "data:image/svg+xml," + encodeURIComponent(s2.serializeToString(img));
        _this.intrinsicWidth = img.width.baseVal.value;
        _this.intrinsicHeight = img.height.baseVal.value;
        _this.context.cache.addImage(_this.svg);
        return _this;
    }
    return SVGElementContainer2;
}(ElementContainer);
var LIElementContainer = /** @class */ function(_super) {
    __extends$2(LIElementContainer2, _super);
    function LIElementContainer2(context, element) {
        var _this = _super.call(this, context, element) || this;
        _this.value = element.value;
        return _this;
    }
    return LIElementContainer2;
}(ElementContainer);
var OLElementContainer = /** @class */ function(_super) {
    __extends$2(OLElementContainer2, _super);
    function OLElementContainer2(context, element) {
        var _this = _super.call(this, context, element) || this;
        _this.start = element.start;
        _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
        return _this;
    }
    return OLElementContainer2;
}(ElementContainer);
var CHECKBOX_BORDER_RADIUS = [
    {
        type: 15,
        flags: 0,
        unit: "px",
        number: 3
    }
];
var RADIO_BORDER_RADIUS = [
    {
        type: 16,
        flags: 0,
        number: 50
    }
];
var reformatInputBounds = function(bounds) {
    if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
    else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
    return bounds;
};
var getInputValue = function(node) {
    var value2 = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
    return value2.length === 0 ? node.placeholder || "" : value2;
};
var CHECKBOX = "checkbox";
var RADIO = "radio";
var PASSWORD = "password";
var INPUT_COLOR = 707406591;
var InputElementContainer = /** @class */ function(_super) {
    __extends$2(InputElementContainer2, _super);
    function InputElementContainer2(context, input2) {
        var _this = _super.call(this, context, input2) || this;
        _this.type = input2.type.toLowerCase();
        _this.checked = input2.checked;
        _this.value = getInputValue(input2);
        if (_this.type === CHECKBOX || _this.type === RADIO) {
            _this.styles.backgroundColor = 3739148031;
            _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 2779096575;
            _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
            _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1;
            _this.styles.backgroundClip = [
                0
            ];
            _this.styles.backgroundOrigin = [
                0
            ];
            _this.bounds = reformatInputBounds(_this.bounds);
        }
        switch(_this.type){
            case CHECKBOX:
                _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                break;
            case RADIO:
                _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                break;
        }
        return _this;
    }
    return InputElementContainer2;
}(ElementContainer);
var SelectElementContainer = /** @class */ function(_super) {
    __extends$2(SelectElementContainer2, _super);
    function SelectElementContainer2(context, element) {
        var _this = _super.call(this, context, element) || this;
        var option2 = element.options[element.selectedIndex || 0];
        _this.value = option2 ? option2.text || "" : "";
        return _this;
    }
    return SelectElementContainer2;
}(ElementContainer);
var TextareaElementContainer = /** @class */ function(_super) {
    __extends$2(TextareaElementContainer2, _super);
    function TextareaElementContainer2(context, element) {
        var _this = _super.call(this, context, element) || this;
        _this.value = element.value;
        return _this;
    }
    return TextareaElementContainer2;
}(ElementContainer);
var IFrameElementContainer = /** @class */ function(_super) {
    __extends$2(IFrameElementContainer2, _super);
    function IFrameElementContainer2(context, iframe) {
        var _this = _super.call(this, context, iframe) || this;
        _this.src = iframe.src;
        _this.width = parseInt(iframe.width, 10) || 0;
        _this.height = parseInt(iframe.height, 10) || 0;
        _this.backgroundColor = _this.styles.backgroundColor;
        try {
            if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
            }
        } catch (e2) {}
        return _this;
    }
    return IFrameElementContainer2;
}(ElementContainer);
var LIST_OWNERS = [
    "OL",
    "UL",
    "MENU"
];
var parseNodeTree = function(context, node, parent, root2) {
    for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
        nextNode = childNode.nextSibling;
        if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
        else if (isElementNode(childNode)) {
            if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode2) {
                return parseNodeTree(context, childNode2, parent, root2);
            });
            else {
                var container2 = createContainer(context, childNode);
                if (container2.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container2, root2)) container2.flags |= 4;
                    else if (createsStackingContext(container2.styles)) container2.flags |= 2;
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container2.flags |= 8;
                    parent.elements.push(container2);
                    childNode.slot;
                    if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container2, root2);
                    else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container2, root2);
                }
            }
        }
    }
};
var createContainer = function(context, element) {
    if (isImageElement(element)) return new ImageElementContainer(context, element);
    if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
    if (isSVGElement(element)) return new SVGElementContainer(context, element);
    if (isLIElement(element)) return new LIElementContainer(context, element);
    if (isOLElement(element)) return new OLElementContainer(context, element);
    if (isInputElement$1(element)) return new InputElementContainer(context, element);
    if (isSelectElement(element)) return new SelectElementContainer(context, element);
    if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
    if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
    return new ElementContainer(context, element);
};
var parseTree = function(context, element) {
    var container2 = createContainer(context, element);
    container2.flags |= 4;
    parseNodeTree(context, element, container2, container2);
    return container2;
};
var createsRealStackingContext = function(node, container2, root2) {
    return container2.styles.isPositionedWithZIndex() || container2.styles.opacity < 1 || container2.styles.isTransformed() || isBodyElement(node) && root2.styles.isTransparent();
};
var createsStackingContext = function(styles) {
    return styles.isPositioned() || styles.isFloating();
};
var isTextNode = function(node) {
    return node.nodeType === Node.TEXT_NODE;
};
var isElementNode = function(node) {
    return node.nodeType === Node.ELEMENT_NODE;
};
var isHTMLElementNode = function(node) {
    return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
};
var isSVGElementNode = function(element) {
    return typeof element.className === "object";
};
var isLIElement = function(node) {
    return node.tagName === "LI";
};
var isOLElement = function(node) {
    return node.tagName === "OL";
};
var isInputElement$1 = function(node) {
    return node.tagName === "INPUT";
};
var isSVGElement = function(node) {
    return node.tagName === "svg";
};
var isBodyElement = function(node) {
    return node.tagName === "BODY";
};
var isCanvasElement = function(node) {
    return node.tagName === "CANVAS";
};
var isImageElement = function(node) {
    return node.tagName === "IMG";
};
var isIFrameElement = function(node) {
    return node.tagName === "IFRAME";
};
var isTextareaElement = function(node) {
    return node.tagName === "TEXTAREA";
};
var isSelectElement = function(node) {
    return node.tagName === "SELECT";
};
var isSlotElement = function(node) {
    return node.tagName === "SLOT";
};
var ROMAN_UPPER = {
    integers: [
        1e3,
        900,
        500,
        400,
        100,
        90,
        50,
        40,
        10,
        9,
        5,
        4,
        1
    ],
    values: [
        "M",
        "CM",
        "D",
        "CD",
        "C",
        "XC",
        "L",
        "XL",
        "X",
        "IX",
        "V",
        "IV",
        "I"
    ]
};
var ARMENIAN = {
    integers: [
        9e3,
        8e3,
        7e3,
        6e3,
        5e3,
        4e3,
        3e3,
        2e3,
        1e3,
        900,
        800,
        700,
        600,
        500,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u0554",
        "\u0553",
        "\u0552",
        "\u0551",
        "\u0550",
        "\u054F",
        "\u054E",
        "\u054D",
        "\u054C",
        "\u054B",
        "\u054A",
        "\u0549",
        "\u0548",
        "\u0547",
        "\u0546",
        "\u0545",
        "\u0544",
        "\u0543",
        "\u0542",
        "\u0541",
        "\u0540",
        "\u053F",
        "\u053E",
        "\u053D",
        "\u053C",
        "\u053B",
        "\u053A",
        "\u0539",
        "\u0538",
        "\u0537",
        "\u0536",
        "\u0535",
        "\u0534",
        "\u0533",
        "\u0532",
        "\u0531"
    ]
};
var HEBREW = {
    integers: [
        1e4,
        9e3,
        8e3,
        7e3,
        6e3,
        5e3,
        4e3,
        3e3,
        2e3,
        1e3,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        19,
        18,
        17,
        16,
        15,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u05D9\u05F3",
        "\u05D8\u05F3",
        "\u05D7\u05F3",
        "\u05D6\u05F3",
        "\u05D5\u05F3",
        "\u05D4\u05F3",
        "\u05D3\u05F3",
        "\u05D2\u05F3",
        "\u05D1\u05F3",
        "\u05D0\u05F3",
        "\u05EA",
        "\u05E9",
        "\u05E8",
        "\u05E7",
        "\u05E6",
        "\u05E4",
        "\u05E2",
        "\u05E1",
        "\u05E0",
        "\u05DE",
        "\u05DC",
        "\u05DB",
        "\u05D9\u05D8",
        "\u05D9\u05D7",
        "\u05D9\u05D6",
        "\u05D8\u05D6",
        "\u05D8\u05D5",
        "\u05D9",
        "\u05D8",
        "\u05D7",
        "\u05D6",
        "\u05D5",
        "\u05D4",
        "\u05D3",
        "\u05D2",
        "\u05D1",
        "\u05D0"
    ]
};
var GEORGIAN = {
    integers: [
        1e4,
        9e3,
        8e3,
        7e3,
        6e3,
        5e3,
        4e3,
        3e3,
        2e3,
        1e3,
        900,
        800,
        700,
        600,
        500,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u10F5",
        "\u10F0",
        "\u10EF",
        "\u10F4",
        "\u10EE",
        "\u10ED",
        "\u10EC",
        "\u10EB",
        "\u10EA",
        "\u10E9",
        "\u10E8",
        "\u10E7",
        "\u10E6",
        "\u10E5",
        "\u10E4",
        "\u10F3",
        "\u10E2",
        "\u10E1",
        "\u10E0",
        "\u10DF",
        "\u10DE",
        "\u10DD",
        "\u10F2",
        "\u10DC",
        "\u10DB",
        "\u10DA",
        "\u10D9",
        "\u10D8",
        "\u10D7",
        "\u10F1",
        "\u10D6",
        "\u10D5",
        "\u10D4",
        "\u10D3",
        "\u10D2",
        "\u10D1",
        "\u10D0"
    ]
};
var createAdditiveCounter = function(value2, min2, max2, symbols, fallback, suffix) {
    if (value2 < min2 || value2 > max2) return createCounterText(value2, fallback, suffix.length > 0);
    return symbols.integers.reduce(function(string, integer2, index2) {
        while(value2 >= integer2){
            value2 -= integer2;
            string += symbols.values[index2];
        }
        return string;
    }, "") + suffix;
};
var createCounterStyleWithSymbolResolver = function(value2, codePointRangeLength, isNumeric, resolver) {
    var string = "";
    do {
        if (!isNumeric) value2--;
        string = resolver(value2) + string;
        value2 /= codePointRangeLength;
    }while (value2 * codePointRangeLength >= codePointRangeLength);
    return string;
};
var createCounterStyleFromRange = function(value2, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
    return (value2 < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value2), codePointRangeLength, isNumeric, function(codePoint) {
        return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
    }) + suffix);
};
var createCounterStyleFromSymbols = function(value2, symbols, suffix) {
    if (suffix === void 0) suffix = ". ";
    var codePointRangeLength = symbols.length;
    return createCounterStyleWithSymbolResolver(Math.abs(value2), codePointRangeLength, false, function(codePoint) {
        return symbols[Math.floor(codePoint % codePointRangeLength)];
    }) + suffix;
};
var CJK_ZEROS = 1;
var CJK_TEN_COEFFICIENTS = 2;
var CJK_TEN_HIGH_COEFFICIENTS = 4;
var CJK_HUNDRED_COEFFICIENTS = 8;
var createCJKCounter = function(value2, numbers, multipliers, negativeSign, suffix, flags2) {
    if (value2 < -9999 || value2 > 9999) return createCounterText(value2, 4, suffix.length > 0);
    var tmp = Math.abs(value2);
    var string = suffix;
    if (tmp === 0) return numbers[0] + string;
    for(var digit = 0; tmp > 0 && digit <= 4; digit++){
        var coefficient = tmp % 10;
        if (coefficient === 0 && contains$1(flags2, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
        else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains$1(flags2, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains$1(flags2, CJK_TEN_HIGH_COEFFICIENTS) && value2 > 100 || coefficient === 1 && digit > 1 && contains$1(flags2, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
        else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
        tmp = Math.floor(tmp / 10);
    }
    return (value2 < 0 ? negativeSign : "") + string;
};
var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
var createCounterText = function(value2, type, appendSuffix) {
    var defaultSuffix = appendSuffix ? ". " : "";
    var cjkSuffix = appendSuffix ? "\u3001" : "";
    var koreanSuffix = appendSuffix ? ", " : "";
    var spaceSuffix = appendSuffix ? " " : "";
    switch(type){
        case 0:
            return "\u2022" + spaceSuffix;
        case 1:
            return "\u25E6" + spaceSuffix;
        case 2:
            return "\u25FE" + spaceSuffix;
        case 5:
            var string = createCounterStyleFromRange(value2, 48, 57, true, defaultSuffix);
            return string.length < 4 ? "0" + string : string;
        case 4:
            return createCounterStyleFromSymbols(value2, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
        case 6:
            return createAdditiveCounter(value2, 1, 3999, ROMAN_UPPER, 3, defaultSuffix).toLowerCase();
        case 7:
            return createAdditiveCounter(value2, 1, 3999, ROMAN_UPPER, 3, defaultSuffix);
        case 8:
            return createCounterStyleFromRange(value2, 945, 969, false, defaultSuffix);
        case 9:
            return createCounterStyleFromRange(value2, 97, 122, false, defaultSuffix);
        case 10:
            return createCounterStyleFromRange(value2, 65, 90, false, defaultSuffix);
        case 11:
            return createCounterStyleFromRange(value2, 1632, 1641, true, defaultSuffix);
        case 12:
        case 49:
            return createAdditiveCounter(value2, 1, 9999, ARMENIAN, 3, defaultSuffix);
        case 35:
            return createAdditiveCounter(value2, 1, 9999, ARMENIAN, 3, defaultSuffix).toLowerCase();
        case 13:
            return createCounterStyleFromRange(value2, 2534, 2543, true, defaultSuffix);
        case 14:
        case 30:
            return createCounterStyleFromRange(value2, 6112, 6121, true, defaultSuffix);
        case 15:
            return createCounterStyleFromSymbols(value2, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
        case 16:
            return createCounterStyleFromSymbols(value2, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
        case 17:
        case 48:
            return createCJKCounter(value2, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case 47:
            return createCJKCounter(value2, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case 42:
            return createCJKCounter(value2, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case 41:
            return createCJKCounter(value2, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case 26:
            return createCJKCounter(value2, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
        case 25:
            return createCJKCounter(value2, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case 31:
            return createCJKCounter(value2, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case 33:
            return createCJKCounter(value2, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
        case 32:
            return createCJKCounter(value2, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case 18:
            return createCounterStyleFromRange(value2, 2406, 2415, true, defaultSuffix);
        case 20:
            return createAdditiveCounter(value2, 1, 19999, GEORGIAN, 3, defaultSuffix);
        case 21:
            return createCounterStyleFromRange(value2, 2790, 2799, true, defaultSuffix);
        case 22:
            return createCounterStyleFromRange(value2, 2662, 2671, true, defaultSuffix);
        case 22:
            return createAdditiveCounter(value2, 1, 10999, HEBREW, 3, defaultSuffix);
        case 23:
            return createCounterStyleFromSymbols(value2, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
        case 24:
            return createCounterStyleFromSymbols(value2, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
        case 27:
            return createCounterStyleFromRange(value2, 3302, 3311, true, defaultSuffix);
        case 28:
            return createCounterStyleFromSymbols(value2, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
        case 29:
            return createCounterStyleFromSymbols(value2, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
        case 34:
            return createCounterStyleFromRange(value2, 3792, 3801, true, defaultSuffix);
        case 37:
            return createCounterStyleFromRange(value2, 6160, 6169, true, defaultSuffix);
        case 38:
            return createCounterStyleFromRange(value2, 4160, 4169, true, defaultSuffix);
        case 39:
            return createCounterStyleFromRange(value2, 2918, 2927, true, defaultSuffix);
        case 40:
            return createCounterStyleFromRange(value2, 1776, 1785, true, defaultSuffix);
        case 43:
            return createCounterStyleFromRange(value2, 3046, 3055, true, defaultSuffix);
        case 44:
            return createCounterStyleFromRange(value2, 3174, 3183, true, defaultSuffix);
        case 45:
            return createCounterStyleFromRange(value2, 3664, 3673, true, defaultSuffix);
        case 46:
            return createCounterStyleFromRange(value2, 3872, 3881, true, defaultSuffix);
        case 3:
        default:
            return createCounterStyleFromRange(value2, 48, 57, true, defaultSuffix);
    }
};
var PseudoElementType;
(function(PseudoElementType2) {
    PseudoElementType2[PseudoElementType2["BEFORE"] = 0] = "BEFORE";
    PseudoElementType2[PseudoElementType2["AFTER"] = 1] = "AFTER";
})(PseudoElementType || (PseudoElementType = {}));
var CacheStorage = /** @class */ function() {
    function CacheStorage2() {}
    CacheStorage2.getOrigin = function(url) {
        var link2 = CacheStorage2._link;
        if (!link2) return "about:blank";
        link2.href = url;
        link2.href = link2.href;
        return link2.protocol + link2.hostname + link2.port;
    };
    CacheStorage2.isSameOrigin = function(src2) {
        return CacheStorage2.getOrigin(src2) === CacheStorage2._origin;
    };
    CacheStorage2.setContext = function(window2) {
        CacheStorage2._link = window2.document.createElement("a");
        CacheStorage2._origin = CacheStorage2.getOrigin(window2.location.href);
    };
    CacheStorage2._origin = "about:blank";
    return CacheStorage2;
}();
var Vector = /** @class */ function() {
    function Vector2(x2, y2) {
        this.type = 0;
        this.x = x2;
        this.y = y2;
    }
    Vector2.prototype.add = function(deltaX, deltaY) {
        return new Vector2(this.x + deltaX, this.y + deltaY);
    };
    return Vector2;
}();
var lerp = function(a2, b2, t2) {
    return new Vector(a2.x + (b2.x - a2.x) * t2, a2.y + (b2.y - a2.y) * t2);
};
var BezierCurve = /** @class */ function() {
    function BezierCurve2(start, startControl, endControl, end) {
        this.type = 1;
        this.start = start;
        this.startControl = startControl;
        this.endControl = endControl;
        this.end = end;
    }
    BezierCurve2.prototype.subdivide = function(t2, firstHalf) {
        var ab = lerp(this.start, this.startControl, t2);
        var bc = lerp(this.startControl, this.endControl, t2);
        var cd = lerp(this.endControl, this.end, t2);
        var abbc = lerp(ab, bc, t2);
        var bccd = lerp(bc, cd, t2);
        var dest = lerp(abbc, bccd, t2);
        return firstHalf ? new BezierCurve2(this.start, ab, abbc, dest) : new BezierCurve2(dest, bccd, cd, this.end);
    };
    BezierCurve2.prototype.add = function(deltaX, deltaY) {
        return new BezierCurve2(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
    };
    BezierCurve2.prototype.reverse = function() {
        return new BezierCurve2(this.end, this.endControl, this.startControl, this.start);
    };
    return BezierCurve2;
}();
var isBezierCurve = function(path2) {
    return path2.type === 1;
};
var BoundCurves = /** @class */ /* @__PURE__ */ function() {
    function BoundCurves2(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var _a3 = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a3[0], tlv = _a3[1];
        var _b2 = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b2[0], trv = _b2[1];
        var _c2 = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c2[0], brv = _c2[1];
        var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
        var factors = [];
        factors.push((tlh + trh) / bounds.width);
        factors.push((blh + brh) / bounds.width);
        factors.push((tlv + blv) / bounds.height);
        factors.push((trv + brv) / bounds.height);
        var maxFactor = Math.max.apply(Math, factors);
        if (maxFactor > 1) {
            tlh /= maxFactor;
            tlv /= maxFactor;
            trh /= maxFactor;
            trv /= maxFactor;
            brh /= maxFactor;
            brv /= maxFactor;
            blh /= maxFactor;
            blv /= maxFactor;
        }
        var topWidth = bounds.width - trh;
        var rightHeight = bounds.height - brv;
        var bottomWidth = bounds.width - brh;
        var leftHeight = bounds.height - blv;
        var borderTopWidth2 = styles.borderTopWidth;
        var borderRightWidth2 = styles.borderRightWidth;
        var borderBottomWidth2 = styles.borderBottomWidth;
        var borderLeftWidth2 = styles.borderLeftWidth;
        var paddingTop2 = getAbsoluteValue(styles.paddingTop, element.bounds.width);
        var paddingRight2 = getAbsoluteValue(styles.paddingRight, element.bounds.width);
        var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
        var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
        this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3, tlh - borderLeftWidth2 / 3, tlv - borderTopWidth2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3);
        this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 3, trh - borderRightWidth2 / 3, trv - borderTopWidth2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + borderTopWidth2 / 3);
        this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 3, brv - borderBottomWidth2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
        this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 / 3, blv - borderBottomWidth2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
        this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3, tlh - borderLeftWidth2 * 2 / 3, tlv - borderTopWidth2 * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
        this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 * 2 / 3, trh - borderRightWidth2 * 2 / 3, trv - borderTopWidth2 * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
        this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 * 2 / 3, brv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
        this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 * 2 / 3, blv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
        this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2, tlh - borderLeftWidth2 / 2, tlv - borderTopWidth2 / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2);
        this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 2, trh - borderRightWidth2 / 2, trv - borderTopWidth2 / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + borderTopWidth2 / 2);
        this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 2, brv - borderBottomWidth2 / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
        this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + leftHeight, blh - borderLeftWidth2 / 2, blv - borderBottomWidth2 / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
        this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
        this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
        this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
        this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
        this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2, Math.max(0, tlh - borderLeftWidth2), Math.max(0, tlv - borderTopWidth2), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2);
        this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth2), bounds.top + borderTopWidth2, topWidth > bounds.width + borderRightWidth2 ? 0 : Math.max(0, trh - borderRightWidth2), Math.max(0, trv - borderTopWidth2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + borderTopWidth2);
        this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth2), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth2), Math.max(0, brh - borderRightWidth2), Math.max(0, brv - borderBottomWidth2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + bounds.height - borderBottomWidth2);
        this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth2), Math.max(0, blh - borderLeftWidth2), Math.max(0, blv - borderBottomWidth2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + bounds.height - borderBottomWidth2);
        this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2, Math.max(0, tlh - (borderLeftWidth2 + paddingLeft2)), Math.max(0, tlv - (borderTopWidth2 + paddingTop2)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2);
        this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth2 + paddingLeft2), bounds.top + borderTopWidth2 + paddingTop2, topWidth > bounds.width + borderLeftWidth2 + paddingLeft2 ? 0 : trh - borderLeftWidth2 + paddingLeft2, trv - (borderTopWidth2 + paddingTop2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + borderTopWidth2 + paddingTop2);
        this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth2 + paddingLeft2)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth2 + paddingTop2), Math.max(0, brh - (borderRightWidth2 + paddingRight2)), brv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
        this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth2 + paddingLeft2)), blv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
    }
    return BoundCurves2;
}();
var CORNER;
(function(CORNER2) {
    CORNER2[CORNER2["TOP_LEFT"] = 0] = "TOP_LEFT";
    CORNER2[CORNER2["TOP_RIGHT"] = 1] = "TOP_RIGHT";
    CORNER2[CORNER2["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
    CORNER2[CORNER2["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
})(CORNER || (CORNER = {}));
var getCurvePoints = function(x2, y2, r1, r2, position2) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = r1 * kappa;
    var oy = r2 * kappa;
    var xm = x2 + r1;
    var ym = y2 + r2;
    switch(position2){
        case CORNER.TOP_LEFT:
            return new BezierCurve(new Vector(x2, ym), new Vector(x2, ym - oy), new Vector(xm - ox, y2), new Vector(xm, y2));
        case CORNER.TOP_RIGHT:
            return new BezierCurve(new Vector(x2, y2), new Vector(x2 + ox, y2), new Vector(xm, ym - oy), new Vector(xm, ym));
        case CORNER.BOTTOM_RIGHT:
            return new BezierCurve(new Vector(xm, y2), new Vector(xm, y2 + oy), new Vector(x2 + ox, ym), new Vector(x2, ym));
        case CORNER.BOTTOM_LEFT:
        default:
            return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x2, y2 + oy), new Vector(x2, y2));
    }
};
var calculateBorderBoxPath = function(curves) {
    return [
        curves.topLeftBorderBox,
        curves.topRightBorderBox,
        curves.bottomRightBorderBox,
        curves.bottomLeftBorderBox
    ];
};
var calculateContentBoxPath = function(curves) {
    return [
        curves.topLeftContentBox,
        curves.topRightContentBox,
        curves.bottomRightContentBox,
        curves.bottomLeftContentBox
    ];
};
var calculatePaddingBoxPath = function(curves) {
    return [
        curves.topLeftPaddingBox,
        curves.topRightPaddingBox,
        curves.bottomRightPaddingBox,
        curves.bottomLeftPaddingBox
    ];
};
var TransformEffect = /** @class */ /* @__PURE__ */ function() {
    function TransformEffect2(offsetX, offsetY, matrix2) {
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.matrix = matrix2;
        this.type = 0;
        this.target = 6;
    }
    return TransformEffect2;
}();
var ClipEffect = /** @class */ /* @__PURE__ */ function() {
    function ClipEffect2(path2, target2) {
        this.path = path2;
        this.target = target2;
        this.type = 1;
    }
    return ClipEffect2;
}();
var OpacityEffect = /** @class */ /* @__PURE__ */ function() {
    function OpacityEffect2(opacity2) {
        this.opacity = opacity2;
        this.type = 2;
        this.target = 6;
    }
    return OpacityEffect2;
}();
var isTransformEffect = function(effect) {
    return effect.type === 0;
};
var isClipEffect = function(effect) {
    return effect.type === 1;
};
var isOpacityEffect = function(effect) {
    return effect.type === 2;
};
var equalPath = function(a2, b2) {
    if (a2.length === b2.length) return a2.some(function(v2, i) {
        return v2 === b2[i];
    });
    return false;
};
var transformPath = function(path2, deltaX, deltaY, deltaW, deltaH) {
    return path2.map(function(point2, index2) {
        switch(index2){
            case 0:
                return point2.add(deltaX, deltaY);
            case 1:
                return point2.add(deltaX + deltaW, deltaY);
            case 2:
                return point2.add(deltaX + deltaW, deltaY + deltaH);
            case 3:
                return point2.add(deltaX, deltaY + deltaH);
        }
        return point2;
    });
};
var StackingContext = /** @class */ /* @__PURE__ */ function() {
    function StackingContext2(container2) {
        this.element = container2;
        this.inlineLevel = [];
        this.nonInlineLevel = [];
        this.negativeZIndex = [];
        this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
        this.positiveZIndex = [];
        this.nonPositionedFloats = [];
        this.nonPositionedInlineLevel = [];
    }
    return StackingContext2;
}();
var ElementPaint = /** @class */ function() {
    function ElementPaint2(container2, parent) {
        this.container = container2;
        this.parent = parent;
        this.effects = [];
        this.curves = new BoundCurves(this.container);
        if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
        if (this.container.styles.transform !== null) {
            var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
            var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
            var matrix2 = this.container.styles.transform;
            this.effects.push(new TransformEffect(offsetX, offsetY, matrix2));
        }
        if (this.container.styles.overflowX !== 0) {
            var borderBox = calculateBorderBoxPath(this.curves);
            var paddingBox2 = calculatePaddingBoxPath(this.curves);
            if (equalPath(borderBox, paddingBox2)) this.effects.push(new ClipEffect(borderBox, 6));
            else {
                this.effects.push(new ClipEffect(borderBox, 2));
                this.effects.push(new ClipEffect(paddingBox2, 4));
            }
        }
    }
    ElementPaint2.prototype.getEffects = function(target2) {
        var inFlow = [
            2,
            3
        ].indexOf(this.container.styles.position) === -1;
        var parent = this.parent;
        var effects = this.effects.slice(0);
        while(parent){
            var croplessEffects = parent.effects.filter(function(effect) {
                return !isClipEffect(effect);
            });
            if (inFlow || parent.container.styles.position !== 0 || !parent.parent) {
                effects.unshift.apply(effects, croplessEffects);
                inFlow = [
                    2,
                    3
                ].indexOf(parent.container.styles.position) === -1;
                if (parent.container.styles.overflowX !== 0) {
                    var borderBox = calculateBorderBoxPath(parent.curves);
                    var paddingBox2 = calculatePaddingBoxPath(parent.curves);
                    if (!equalPath(borderBox, paddingBox2)) effects.unshift(new ClipEffect(paddingBox2, 6));
                }
            } else effects.unshift.apply(effects, croplessEffects);
            parent = parent.parent;
        }
        return effects.filter(function(effect) {
            return contains$1(effect.target, target2);
        });
    };
    return ElementPaint2;
}();
var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
    parent.container.elements.forEach(function(child) {
        var treatAsRealStackingContext = contains$1(child.flags, 4);
        var createsStackingContext2 = contains$1(child.flags, 2);
        var paintContainer = new ElementPaint(child, parent);
        if (contains$1(child.styles.display, 2048)) listItems.push(paintContainer);
        var listOwnerItems = contains$1(child.flags, 8) ? [] : listItems;
        if (treatAsRealStackingContext || createsStackingContext2) {
            var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
            var stack = new StackingContext(paintContainer);
            if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                var order_1 = child.styles.zIndex.order;
                if (order_1 < 0) {
                    var index_1 = 0;
                    parentStack.negativeZIndex.some(function(current, i) {
                        if (order_1 > current.element.container.styles.zIndex.order) {
                            index_1 = i;
                            return false;
                        } else if (index_1 > 0) return true;
                        return false;
                    });
                    parentStack.negativeZIndex.splice(index_1, 0, stack);
                } else if (order_1 > 0) {
                    var index_2 = 0;
                    parentStack.positiveZIndex.some(function(current, i) {
                        if (order_1 >= current.element.container.styles.zIndex.order) {
                            index_2 = i + 1;
                            return false;
                        } else if (index_2 > 0) return true;
                        return false;
                    });
                    parentStack.positiveZIndex.splice(index_2, 0, stack);
                } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
            } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
            else parentStack.nonPositionedInlineLevel.push(stack);
            parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
        } else {
            if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
            else stackingContext.nonInlineLevel.push(paintContainer);
            parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
        }
        if (contains$1(child.flags, 8)) processListItems(child, listOwnerItems);
    });
};
var processListItems = function(owner, elements) {
    var numbering = owner instanceof OLElementContainer ? owner.start : 1;
    var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
    for(var i = 0; i < elements.length; i++){
        var item2 = elements[i];
        if (item2.container instanceof LIElementContainer && typeof item2.container.value === "number" && item2.container.value !== 0) numbering = item2.container.value;
        item2.listValue = createCounterText(numbering, item2.container.styles.listStyleType, true);
        numbering += reversed ? -1 : 1;
    }
};
var parseStackingContexts = function(container2) {
    var paintContainer = new ElementPaint(container2, null);
    var root2 = new StackingContext(paintContainer);
    var listItems = [];
    parseStackTree(paintContainer, root2, root2, listItems);
    processListItems(paintContainer.container, listItems);
    return root2;
};
var parsePathForBorder = function(curves, borderSide) {
    switch(borderSide){
        case 0:
            return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
        case 1:
            return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
        case 2:
            return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
        case 3:
        default:
            return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
    }
};
var parsePathForBorderDoubleOuter = function(curves, borderSide) {
    switch(borderSide){
        case 0:
            return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
        case 1:
            return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
        case 2:
            return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
        case 3:
        default:
            return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
    }
};
var parsePathForBorderDoubleInner = function(curves, borderSide) {
    switch(borderSide){
        case 0:
            return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
        case 1:
            return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
        case 2:
            return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
        case 3:
        default:
            return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
    }
};
var parsePathForBorderStroke = function(curves, borderSide) {
    switch(borderSide){
        case 0:
            return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
        case 1:
            return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
        case 2:
            return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
        case 3:
        default:
            return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
    }
};
var createStrokePathFromCurves = function(outer1, outer2) {
    var path2 = [];
    if (isBezierCurve(outer1)) path2.push(outer1.subdivide(0.5, false));
    else path2.push(outer1);
    if (isBezierCurve(outer2)) path2.push(outer2.subdivide(0.5, true));
    else path2.push(outer2);
    return path2;
};
var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
    var path2 = [];
    if (isBezierCurve(outer1)) path2.push(outer1.subdivide(0.5, false));
    else path2.push(outer1);
    if (isBezierCurve(outer2)) path2.push(outer2.subdivide(0.5, true));
    else path2.push(outer2);
    if (isBezierCurve(inner2)) path2.push(inner2.subdivide(0.5, true).reverse());
    else path2.push(inner2);
    if (isBezierCurve(inner1)) path2.push(inner1.subdivide(0.5, false).reverse());
    else path2.push(inner1);
    return path2;
};
var paddingBox = function(element) {
    var bounds = element.bounds;
    var styles = element.styles;
    return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
};
var contentBox = function(element) {
    var styles = element.styles;
    var bounds = element.bounds;
    var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, bounds.width);
    var paddingRight2 = getAbsoluteValue(styles.paddingRight, bounds.width);
    var paddingTop2 = getAbsoluteValue(styles.paddingTop, bounds.width);
    var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, bounds.width);
    return bounds.add(paddingLeft2 + styles.borderLeftWidth, paddingTop2 + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft2 + paddingRight2), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop2 + paddingBottom2));
};
var calculateBackgroundPositioningArea = function(backgroundOrigin2, element) {
    if (backgroundOrigin2 === 0) return element.bounds;
    if (backgroundOrigin2 === 2) return contentBox(element);
    return paddingBox(element);
};
var calculateBackgroundPaintingArea = function(backgroundClip2, element) {
    if (backgroundClip2 === 0) return element.bounds;
    if (backgroundClip2 === 2) return contentBox(element);
    return paddingBox(element);
};
var calculateBackgroundRendering = function(container2, index2, intrinsicSize) {
    var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container2.styles.backgroundOrigin, index2), container2);
    var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container2.styles.backgroundClip, index2), container2);
    var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container2.styles.backgroundSize, index2), intrinsicSize, backgroundPositioningArea);
    var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
    var position2 = getAbsoluteValueForTuple(getBackgroundValueForIndex(container2.styles.backgroundPosition, index2), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
    var path2 = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container2.styles.backgroundRepeat, index2), position2, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
    var offsetX = Math.round(backgroundPositioningArea.left + position2[0]);
    var offsetY = Math.round(backgroundPositioningArea.top + position2[1]);
    return [
        path2,
        offsetX,
        offsetY,
        sizeWidth,
        sizeHeight
    ];
};
var isAuto = function(token2) {
    return isIdentToken(token2) && token2.value === BACKGROUND_SIZE.AUTO;
};
var hasIntrinsicValue = function(value2) {
    return typeof value2 === "number";
};
var calculateBackgroundSize = function(size2, _a3, bounds) {
    var intrinsicWidth = _a3[0], intrinsicHeight = _a3[1], intrinsicProportion = _a3[2];
    var first = size2[0], second = size2[1];
    if (!first) return [
        0,
        0
    ];
    if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
        getAbsoluteValue(first, bounds.width),
        getAbsoluteValue(second, bounds.height)
    ];
    var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
    if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
        if (hasIntrinsicValue(intrinsicProportion)) {
            var targetRatio = bounds.width / bounds.height;
            return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                bounds.width,
                bounds.width / intrinsicProportion
            ] : [
                bounds.height * intrinsicProportion,
                bounds.height
            ];
        }
        return [
            bounds.width,
            bounds.height
        ];
    }
    var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
    var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
    var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
    if (isAuto(first) && (!second || isAuto(second))) {
        if (hasIntrinsicWidth && hasIntrinsicHeight) return [
            intrinsicWidth,
            intrinsicHeight
        ];
        if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
            bounds.width,
            bounds.height
        ];
        if (hasIntrinsicDimensions && hasIntrinsicProportion) {
            var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
            var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
            return [
                width_1,
                height_1
            ];
        }
        var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
        var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
        return [
            width_2,
            height_2
        ];
    }
    if (hasIntrinsicProportion) {
        var width_3 = 0;
        var height_3 = 0;
        if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
        else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
        if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
        else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
        return [
            width_3,
            height_3
        ];
    }
    var width = null;
    var height = null;
    if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
    else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
    if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
    if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
    if (width !== null && height !== null) return [
        width,
        height
    ];
    throw new Error("Unable to calculate background-size for element");
};
var getBackgroundValueForIndex = function(values2, index2) {
    var value2 = values2[index2];
    if (typeof value2 === "undefined") return values2[0];
    return value2;
};
var calculateBackgroundRepeatPath = function(repeat, _a3, _b2, backgroundPositioningArea, backgroundPaintingArea) {
    var x2 = _a3[0], y2 = _a3[1];
    var width = _b2[0], height = _b2[1];
    switch(repeat){
        case 2:
            return [
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y2)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y2)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y2)),
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y2))
            ];
        case 3:
            return [
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
            ];
        case 1:
            return [
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top + y2)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top + y2)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top + y2 + height)),
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top + y2 + height))
            ];
        default:
            return [
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
            ];
    }
};
var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var SAMPLE_TEXT = "Hidden Text";
var FontMetrics = /** @class */ function() {
    function FontMetrics2(document2) {
        this._data = {};
        this._document = document2;
    }
    FontMetrics2.prototype.parseMetrics = function(fontFamily2, fontSize2) {
        var container2 = this._document.createElement("div");
        var img = this._document.createElement("img");
        var span = this._document.createElement("span");
        var body2 = this._document.body;
        container2.style.visibility = "hidden";
        container2.style.fontFamily = fontFamily2;
        container2.style.fontSize = fontSize2;
        container2.style.margin = "0";
        container2.style.padding = "0";
        container2.style.whiteSpace = "nowrap";
        body2.appendChild(container2);
        img.src = SMALL_IMAGE;
        img.width = 1;
        img.height = 1;
        img.style.margin = "0";
        img.style.padding = "0";
        img.style.verticalAlign = "baseline";
        span.style.fontFamily = fontFamily2;
        span.style.fontSize = fontSize2;
        span.style.margin = "0";
        span.style.padding = "0";
        span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
        container2.appendChild(span);
        container2.appendChild(img);
        var baseline = img.offsetTop - span.offsetTop + 2;
        container2.removeChild(span);
        container2.appendChild(this._document.createTextNode(SAMPLE_TEXT));
        container2.style.lineHeight = "normal";
        img.style.verticalAlign = "super";
        var middle = img.offsetTop - container2.offsetTop + 2;
        body2.removeChild(container2);
        return {
            baseline: baseline,
            middle: middle
        };
    };
    FontMetrics2.prototype.getMetrics = function(fontFamily2, fontSize2) {
        var key = fontFamily2 + " " + fontSize2;
        if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily2, fontSize2);
        return this._data[key];
    };
    return FontMetrics2;
}();
var Renderer$1 = /** @class */ /* @__PURE__ */ function() {
    function Renderer2(context, options) {
        this.context = context;
        this.options = options;
    }
    return Renderer2;
}();
var MASK_OFFSET = 1e4;
(function(_super) {
    __extends$2(CanvasRenderer, _super);
    function CanvasRenderer(context, options) {
        var _this = _super.call(this, context, options) || this;
        _this._activeEffects = [];
        _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
        _this.ctx = _this.canvas.getContext("2d");
        if (!options.canvas) {
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
        }
        _this.fontMetrics = new FontMetrics(document);
        _this.ctx.scale(_this.options.scale, _this.options.scale);
        _this.ctx.translate(-options.x, -options.y);
        _this.ctx.textBaseline = "bottom";
        _this._activeEffects = [];
        _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
        return _this;
    }
    CanvasRenderer.prototype.applyEffects = function(effects) {
        var _this = this;
        while(this._activeEffects.length)this.popEffect();
        effects.forEach(function(effect) {
            return _this.applyEffect(effect);
        });
    };
    CanvasRenderer.prototype.applyEffect = function(effect) {
        this.ctx.save();
        if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
        if (isTransformEffect(effect)) {
            this.ctx.translate(effect.offsetX, effect.offsetY);
            this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
            this.ctx.translate(-effect.offsetX, -effect.offsetY);
        }
        if (isClipEffect(effect)) {
            this.path(effect.path);
            this.ctx.clip();
        }
        this._activeEffects.push(effect);
    };
    CanvasRenderer.prototype.popEffect = function() {
        this._activeEffects.pop();
        this.ctx.restore();
    };
    CanvasRenderer.prototype.renderStack = function(stack) {
        return __awaiter$2(this, void 0, void 0, function() {
            var styles;
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        styles = stack.element.container.styles;
                        if (!styles.isVisible()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.renderStackContent(stack)
                        ];
                    case 1:
                        _a3.sent();
                        _a3.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderNode = function(paint) {
        return __awaiter$2(this, void 0, void 0, function() {
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        if (contains$1(paint.container.flags, 16)) debugger;
                        if (!paint.container.styles.isVisible()) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            this.renderNodeBackgroundAndBorders(paint)
                        ];
                    case 1:
                        _a3.sent();
                        return [
                            4,
                            this.renderNodeContent(paint)
                        ];
                    case 2:
                        _a3.sent();
                        _a3.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text2, letterSpacing2, baseline) {
        var _this = this;
        if (letterSpacing2 === 0) this.ctx.fillText(text2.text, text2.bounds.left, text2.bounds.top + baseline);
        else {
            var letters = segmentGraphemes(text2.text);
            letters.reduce(function(left2, letter) {
                _this.ctx.fillText(letter, left2, text2.bounds.top + baseline);
                return left2 + _this.ctx.measureText(letter).width;
            }, text2.bounds.left);
        }
    };
    CanvasRenderer.prototype.createFontStyle = function(styles) {
        var fontVariant2 = styles.fontVariant.filter(function(variant) {
            return variant === "normal" || variant === "small-caps";
        }).join("");
        var fontFamily2 = fixIOSSystemFonts(styles.fontFamily).join(", ");
        var fontSize2 = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
        return [
            [
                styles.fontStyle,
                fontVariant2,
                styles.fontWeight,
                fontSize2,
                fontFamily2
            ].join(" "),
            fontFamily2,
            fontSize2
        ];
    };
    CanvasRenderer.prototype.renderTextNode = function(text2, styles) {
        return __awaiter$2(this, void 0, void 0, function() {
            var _a3, font, fontFamily2, fontSize2, _b2, baseline, middle, paintOrder2;
            var _this = this;
            return __generator$1(this, function(_c2) {
                _a3 = this.createFontStyle(styles), font = _a3[0], fontFamily2 = _a3[1], fontSize2 = _a3[2];
                this.ctx.font = font;
                this.ctx.direction = styles.direction === 1 ? "rtl" : "ltr";
                this.ctx.textAlign = "left";
                this.ctx.textBaseline = "alphabetic";
                _b2 = this.fontMetrics.getMetrics(fontFamily2, fontSize2), baseline = _b2.baseline, middle = _b2.middle;
                paintOrder2 = styles.paintOrder;
                text2.textBounds.forEach(function(text3) {
                    paintOrder2.forEach(function(paintOrderLayer) {
                        switch(paintOrderLayer){
                            case 0:
                                _this.ctx.fillStyle = asString(styles.color);
                                _this.renderTextWithLetterSpacing(text3, styles.letterSpacing, baseline);
                                var textShadows = styles.textShadow;
                                if (textShadows.length && text3.text.trim().length) {
                                    textShadows.slice(0).reverse().forEach(function(textShadow2) {
                                        _this.ctx.shadowColor = asString(textShadow2.color);
                                        _this.ctx.shadowOffsetX = textShadow2.offsetX.number * _this.options.scale;
                                        _this.ctx.shadowOffsetY = textShadow2.offsetY.number * _this.options.scale;
                                        _this.ctx.shadowBlur = textShadow2.blur.number;
                                        _this.renderTextWithLetterSpacing(text3, styles.letterSpacing, baseline);
                                    });
                                    _this.ctx.shadowColor = "";
                                    _this.ctx.shadowOffsetX = 0;
                                    _this.ctx.shadowOffsetY = 0;
                                    _this.ctx.shadowBlur = 0;
                                }
                                if (styles.textDecorationLine.length) {
                                    _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                    styles.textDecorationLine.forEach(function(textDecorationLine2) {
                                        switch(textDecorationLine2){
                                            case 1:
                                                _this.ctx.fillRect(text3.bounds.left, Math.round(text3.bounds.top + baseline), text3.bounds.width, 1);
                                                break;
                                            case 2:
                                                _this.ctx.fillRect(text3.bounds.left, Math.round(text3.bounds.top), text3.bounds.width, 1);
                                                break;
                                            case 3:
                                                _this.ctx.fillRect(text3.bounds.left, Math.ceil(text3.bounds.top + middle), text3.bounds.width, 1);
                                                break;
                                        }
                                    });
                                }
                                break;
                            case 1:
                                if (styles.webkitTextStrokeWidth && text3.text.trim().length) {
                                    _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                    _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                    _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                    _this.ctx.strokeText(text3.text, text3.bounds.left, text3.bounds.top + baseline);
                                }
                                _this.ctx.strokeStyle = "";
                                _this.ctx.lineWidth = 0;
                                _this.ctx.lineJoin = "miter";
                                break;
                        }
                    });
                });
                return [
                    2
                ];
            });
        });
    };
    CanvasRenderer.prototype.renderReplacedElement = function(container2, curves, image2) {
        if (image2 && container2.intrinsicWidth > 0 && container2.intrinsicHeight > 0) {
            var box = contentBox(container2);
            var path2 = calculatePaddingBoxPath(curves);
            this.path(path2);
            this.ctx.save();
            this.ctx.clip();
            this.ctx.drawImage(image2, 0, 0, container2.intrinsicWidth, container2.intrinsicHeight, box.left, box.top, box.width, box.height);
            this.ctx.restore();
        }
    };
    CanvasRenderer.prototype.renderNodeContent = function(paint) {
        return __awaiter$2(this, void 0, void 0, function() {
            var container2, curves, styles, _i, _a3, child, image2, image2, iframeRenderer, canvas, size2, _b2, fontFamily2, fontSize2, baseline, bounds, x2, textBounds, img, image2, url, fontFamily2, bounds;
            return __generator$1(this, function(_c2) {
                switch(_c2.label){
                    case 0:
                        this.applyEffects(paint.getEffects(4));
                        container2 = paint.container;
                        curves = paint.curves;
                        styles = container2.styles;
                        _i = 0, _a3 = container2.textNodes;
                        _c2.label = 1;
                    case 1:
                        if (!(_i < _a3.length)) return [
                            3,
                            4
                        ];
                        child = _a3[_i];
                        return [
                            4,
                            this.renderTextNode(child, styles)
                        ];
                    case 2:
                        _c2.sent();
                        _c2.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        if (!(container2 instanceof ImageElementContainer)) return [
                            3,
                            8
                        ];
                        _c2.label = 5;
                    case 5:
                        _c2.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            this.context.cache.match(container2.src)
                        ];
                    case 6:
                        image2 = _c2.sent();
                        this.renderReplacedElement(container2, curves, image2);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        _c2.sent();
                        this.context.logger.error("Error loading image " + container2.src);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        if (container2 instanceof CanvasElementContainer) this.renderReplacedElement(container2, curves, container2.canvas);
                        if (!(container2 instanceof SVGElementContainer)) return [
                            3,
                            12
                        ];
                        _c2.label = 9;
                    case 9:
                        _c2.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            this.context.cache.match(container2.svg)
                        ];
                    case 10:
                        image2 = _c2.sent();
                        this.renderReplacedElement(container2, curves, image2);
                        return [
                            3,
                            12
                        ];
                    case 11:
                        _c2.sent();
                        this.context.logger.error("Error loading svg " + container2.svg.substring(0, 255));
                        return [
                            3,
                            12
                        ];
                    case 12:
                        if (!(container2 instanceof IFrameElementContainer && container2.tree)) return [
                            3,
                            14
                        ];
                        iframeRenderer = new CanvasRenderer(this.context, {
                            scale: this.options.scale,
                            backgroundColor: container2.backgroundColor,
                            x: 0,
                            y: 0,
                            width: container2.width,
                            height: container2.height
                        });
                        return [
                            4,
                            iframeRenderer.render(container2.tree)
                        ];
                    case 13:
                        canvas = _c2.sent();
                        if (container2.width && container2.height) this.ctx.drawImage(canvas, 0, 0, container2.width, container2.height, container2.bounds.left, container2.bounds.top, container2.bounds.width, container2.bounds.height);
                        _c2.label = 14;
                    case 14:
                        if (container2 instanceof InputElementContainer) {
                            size2 = Math.min(container2.bounds.width, container2.bounds.height);
                            if (container2.type === CHECKBOX) {
                                if (container2.checked) {
                                    this.ctx.save();
                                    this.path([
                                        new Vector(container2.bounds.left + size2 * 0.39363, container2.bounds.top + size2 * 0.79),
                                        new Vector(container2.bounds.left + size2 * 0.16, container2.bounds.top + size2 * 0.5549),
                                        new Vector(container2.bounds.left + size2 * 0.27347, container2.bounds.top + size2 * 0.44071),
                                        new Vector(container2.bounds.left + size2 * 0.39694, container2.bounds.top + size2 * 0.5649),
                                        new Vector(container2.bounds.left + size2 * 0.72983, container2.bounds.top + size2 * 0.23),
                                        new Vector(container2.bounds.left + size2 * 0.84, container2.bounds.top + size2 * 0.34085),
                                        new Vector(container2.bounds.left + size2 * 0.39363, container2.bounds.top + size2 * 0.79)
                                    ]);
                                    this.ctx.fillStyle = asString(INPUT_COLOR);
                                    this.ctx.fill();
                                    this.ctx.restore();
                                }
                            } else if (container2.type === RADIO) {
                                if (container2.checked) {
                                    this.ctx.save();
                                    this.ctx.beginPath();
                                    this.ctx.arc(container2.bounds.left + size2 / 2, container2.bounds.top + size2 / 2, size2 / 4, 0, Math.PI * 2, true);
                                    this.ctx.fillStyle = asString(INPUT_COLOR);
                                    this.ctx.fill();
                                    this.ctx.restore();
                                }
                            }
                        }
                        if (isTextInputElement(container2) && container2.value.length) {
                            _b2 = this.createFontStyle(styles), fontFamily2 = _b2[0], fontSize2 = _b2[1];
                            baseline = this.fontMetrics.getMetrics(fontFamily2, fontSize2).baseline;
                            this.ctx.font = fontFamily2;
                            this.ctx.fillStyle = asString(styles.color);
                            this.ctx.textBaseline = "alphabetic";
                            this.ctx.textAlign = canvasTextAlign(container2.styles.textAlign);
                            bounds = contentBox(container2);
                            x2 = 0;
                            switch(container2.styles.textAlign){
                                case 1:
                                    x2 += bounds.width / 2;
                                    break;
                                case 2:
                                    x2 += bounds.width;
                                    break;
                            }
                            textBounds = bounds.add(x2, 0, 0, -bounds.height / 2 + 1);
                            this.ctx.save();
                            this.path([
                                new Vector(bounds.left, bounds.top),
                                new Vector(bounds.left + bounds.width, bounds.top),
                                new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                new Vector(bounds.left, bounds.top + bounds.height)
                            ]);
                            this.ctx.clip();
                            this.renderTextWithLetterSpacing(new TextBounds(container2.value, textBounds), styles.letterSpacing, baseline);
                            this.ctx.restore();
                            this.ctx.textBaseline = "alphabetic";
                            this.ctx.textAlign = "left";
                        }
                        if (!contains$1(container2.styles.display, 2048)) return [
                            3,
                            20
                        ];
                        if (!(container2.styles.listStyleImage !== null)) return [
                            3,
                            19
                        ];
                        img = container2.styles.listStyleImage;
                        if (!(img.type === 0)) return [
                            3,
                            18
                        ];
                        image2 = void 0;
                        url = img.url;
                        _c2.label = 15;
                    case 15:
                        _c2.trys.push([
                            15,
                            17,
                            ,
                            18
                        ]);
                        return [
                            4,
                            this.context.cache.match(url)
                        ];
                    case 16:
                        image2 = _c2.sent();
                        this.ctx.drawImage(image2, container2.bounds.left - (image2.width + 10), container2.bounds.top);
                        return [
                            3,
                            18
                        ];
                    case 17:
                        _c2.sent();
                        this.context.logger.error("Error loading list-style-image " + url);
                        return [
                            3,
                            18
                        ];
                    case 18:
                        return [
                            3,
                            20
                        ];
                    case 19:
                        if (paint.listValue && container2.styles.listStyleType !== -1) {
                            fontFamily2 = this.createFontStyle(styles)[0];
                            this.ctx.font = fontFamily2;
                            this.ctx.fillStyle = asString(styles.color);
                            this.ctx.textBaseline = "middle";
                            this.ctx.textAlign = "right";
                            bounds = new Bounds(container2.bounds.left, container2.bounds.top + getAbsoluteValue(container2.styles.paddingTop, container2.bounds.width), container2.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                            this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                            this.ctx.textBaseline = "bottom";
                            this.ctx.textAlign = "left";
                        }
                        _c2.label = 20;
                    case 20:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderStackContent = function(stack) {
        return __awaiter$2(this, void 0, void 0, function() {
            var _i, _a3, child, _b2, _c2, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
            return __generator$1(this, function(_p) {
                switch(_p.label){
                    case 0:
                        if (contains$1(stack.element.container.flags, 16)) debugger;
                        return [
                            4,
                            this.renderNodeBackgroundAndBorders(stack.element)
                        ];
                    case 1:
                        _p.sent();
                        _i = 0, _a3 = stack.negativeZIndex;
                        _p.label = 2;
                    case 2:
                        if (!(_i < _a3.length)) return [
                            3,
                            5
                        ];
                        child = _a3[_i];
                        return [
                            4,
                            this.renderStack(child)
                        ];
                    case 3:
                        _p.sent();
                        _p.label = 4;
                    case 4:
                        _i++;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            4,
                            this.renderNodeContent(stack.element)
                        ];
                    case 6:
                        _p.sent();
                        _b2 = 0, _c2 = stack.nonInlineLevel;
                        _p.label = 7;
                    case 7:
                        if (!(_b2 < _c2.length)) return [
                            3,
                            10
                        ];
                        child = _c2[_b2];
                        return [
                            4,
                            this.renderNode(child)
                        ];
                    case 8:
                        _p.sent();
                        _p.label = 9;
                    case 9:
                        _b2++;
                        return [
                            3,
                            7
                        ];
                    case 10:
                        _d = 0, _e = stack.nonPositionedFloats;
                        _p.label = 11;
                    case 11:
                        if (!(_d < _e.length)) return [
                            3,
                            14
                        ];
                        child = _e[_d];
                        return [
                            4,
                            this.renderStack(child)
                        ];
                    case 12:
                        _p.sent();
                        _p.label = 13;
                    case 13:
                        _d++;
                        return [
                            3,
                            11
                        ];
                    case 14:
                        _f = 0, _g = stack.nonPositionedInlineLevel;
                        _p.label = 15;
                    case 15:
                        if (!(_f < _g.length)) return [
                            3,
                            18
                        ];
                        child = _g[_f];
                        return [
                            4,
                            this.renderStack(child)
                        ];
                    case 16:
                        _p.sent();
                        _p.label = 17;
                    case 17:
                        _f++;
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _h = 0, _j = stack.inlineLevel;
                        _p.label = 19;
                    case 19:
                        if (!(_h < _j.length)) return [
                            3,
                            22
                        ];
                        child = _j[_h];
                        return [
                            4,
                            this.renderNode(child)
                        ];
                    case 20:
                        _p.sent();
                        _p.label = 21;
                    case 21:
                        _h++;
                        return [
                            3,
                            19
                        ];
                    case 22:
                        _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                        _p.label = 23;
                    case 23:
                        if (!(_k < _l.length)) return [
                            3,
                            26
                        ];
                        child = _l[_k];
                        return [
                            4,
                            this.renderStack(child)
                        ];
                    case 24:
                        _p.sent();
                        _p.label = 25;
                    case 25:
                        _k++;
                        return [
                            3,
                            23
                        ];
                    case 26:
                        _m = 0, _o = stack.positiveZIndex;
                        _p.label = 27;
                    case 27:
                        if (!(_m < _o.length)) return [
                            3,
                            30
                        ];
                        child = _o[_m];
                        return [
                            4,
                            this.renderStack(child)
                        ];
                    case 28:
                        _p.sent();
                        _p.label = 29;
                    case 29:
                        _m++;
                        return [
                            3,
                            27
                        ];
                    case 30:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.mask = function(paths) {
        this.ctx.beginPath();
        this.ctx.moveTo(0, 0);
        this.ctx.lineTo(this.canvas.width, 0);
        this.ctx.lineTo(this.canvas.width, this.canvas.height);
        this.ctx.lineTo(0, this.canvas.height);
        this.ctx.lineTo(0, 0);
        this.formatPath(paths.slice(0).reverse());
        this.ctx.closePath();
    };
    CanvasRenderer.prototype.path = function(paths) {
        this.ctx.beginPath();
        this.formatPath(paths);
        this.ctx.closePath();
    };
    CanvasRenderer.prototype.formatPath = function(paths) {
        var _this = this;
        paths.forEach(function(point2, index2) {
            var start = isBezierCurve(point2) ? point2.start : point2;
            if (index2 === 0) _this.ctx.moveTo(start.x, start.y);
            else _this.ctx.lineTo(start.x, start.y);
            if (isBezierCurve(point2)) _this.ctx.bezierCurveTo(point2.startControl.x, point2.startControl.y, point2.endControl.x, point2.endControl.y, point2.end.x, point2.end.y);
        });
    };
    CanvasRenderer.prototype.renderRepeat = function(path2, pattern, offsetX, offsetY) {
        this.path(path2);
        this.ctx.fillStyle = pattern;
        this.ctx.translate(offsetX, offsetY);
        this.ctx.fill();
        this.ctx.translate(-offsetX, -offsetY);
    };
    CanvasRenderer.prototype.resizeImage = function(image2, width, height) {
        var _a3;
        if (image2.width === width && image2.height === height) return image2;
        var ownerDocument = (_a3 = this.canvas.ownerDocument) !== null && _a3 !== void 0 ? _a3 : document;
        var canvas = ownerDocument.createElement("canvas");
        canvas.width = Math.max(1, width);
        canvas.height = Math.max(1, height);
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image2, 0, 0, image2.width, image2.height, 0, 0, width, height);
        return canvas;
    };
    CanvasRenderer.prototype.renderBackgroundImage = function(container2) {
        return __awaiter$2(this, void 0, void 0, function() {
            var index2, _loop_1, this_1, _i, _a3, backgroundImage2;
            return __generator$1(this, function(_b2) {
                switch(_b2.label){
                    case 0:
                        index2 = container2.styles.backgroundImage.length - 1;
                        _loop_1 = function(backgroundImage3) {
                            var image2, url, _c2, path2, x2, y2, width, height, pattern, _d, path2, x2, y2, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path2, left2, top_1, width, height, position2, x2, y2, _g, rx, ry, radialGradient_1, midX, midY, f2, invF;
                            return __generator$1(this, function(_h) {
                                switch(_h.label){
                                    case 0:
                                        if (!(backgroundImage3.type === 0)) return [
                                            3,
                                            5
                                        ];
                                        image2 = void 0;
                                        url = backgroundImage3.url;
                                        _h.label = 1;
                                    case 1:
                                        _h.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            this_1.context.cache.match(url)
                                        ];
                                    case 2:
                                        image2 = _h.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        _h.sent();
                                        this_1.context.logger.error("Error loading background-image " + url);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        if (image2) {
                                            _c2 = calculateBackgroundRendering(container2, index2, [
                                                image2.width,
                                                image2.height,
                                                image2.width / image2.height
                                            ]), path2 = _c2[0], x2 = _c2[1], y2 = _c2[2], width = _c2[3], height = _c2[4];
                                            pattern = this_1.ctx.createPattern(this_1.resizeImage(image2, width, height), "repeat");
                                            this_1.renderRepeat(path2, pattern, x2, y2);
                                        }
                                        return [
                                            3,
                                            6
                                        ];
                                    case 5:
                                        if (isLinearGradient(backgroundImage3)) {
                                            _d = calculateBackgroundRendering(container2, index2, [
                                                null,
                                                null,
                                                null
                                            ]), path2 = _d[0], x2 = _d[1], y2 = _d[2], width = _d[3], height = _d[4];
                                            _e = calculateGradientDirection(backgroundImage3.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                            canvas = document.createElement("canvas");
                                            canvas.width = width;
                                            canvas.height = height;
                                            ctx = canvas.getContext("2d");
                                            gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                            processColorStops(backgroundImage3.stops, lineLength).forEach(function(colorStop) {
                                                return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                            });
                                            ctx.fillStyle = gradient_1;
                                            ctx.fillRect(0, 0, width, height);
                                            if (width > 0 && height > 0) {
                                                pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                this_1.renderRepeat(path2, pattern, x2, y2);
                                            }
                                        } else if (isRadialGradient(backgroundImage3)) {
                                            _f = calculateBackgroundRendering(container2, index2, [
                                                null,
                                                null,
                                                null
                                            ]), path2 = _f[0], left2 = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                            position2 = backgroundImage3.position.length === 0 ? [
                                                FIFTY_PERCENT
                                            ] : backgroundImage3.position;
                                            x2 = getAbsoluteValue(position2[0], width);
                                            y2 = getAbsoluteValue(position2[position2.length - 1], height);
                                            _g = calculateRadius(backgroundImage3, x2, y2, width, height), rx = _g[0], ry = _g[1];
                                            if (rx > 0 && ry > 0) {
                                                radialGradient_1 = this_1.ctx.createRadialGradient(left2 + x2, top_1 + y2, 0, left2 + x2, top_1 + y2, rx);
                                                processColorStops(backgroundImage3.stops, rx * 2).forEach(function(colorStop) {
                                                    return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                this_1.path(path2);
                                                this_1.ctx.fillStyle = radialGradient_1;
                                                if (rx !== ry) {
                                                    midX = container2.bounds.left + 0.5 * container2.bounds.width;
                                                    midY = container2.bounds.top + 0.5 * container2.bounds.height;
                                                    f2 = ry / rx;
                                                    invF = 1 / f2;
                                                    this_1.ctx.save();
                                                    this_1.ctx.translate(midX, midY);
                                                    this_1.ctx.transform(1, 0, 0, f2, 0, 0);
                                                    this_1.ctx.translate(-midX, -midY);
                                                    this_1.ctx.fillRect(left2, invF * (top_1 - midY) + midY, width, height * invF);
                                                    this_1.ctx.restore();
                                                } else this_1.ctx.fill();
                                            }
                                        }
                                        _h.label = 6;
                                    case 6:
                                        index2--;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, _a3 = container2.styles.backgroundImage.slice(0).reverse();
                        _b2.label = 1;
                    case 1:
                        if (!(_i < _a3.length)) return [
                            3,
                            4
                        ];
                        backgroundImage2 = _a3[_i];
                        return [
                            5,
                            _loop_1(backgroundImage2)
                        ];
                    case 2:
                        _b2.sent();
                        _b2.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderSolidBorder = function(color2, side, curvePoints) {
        return __awaiter$2(this, void 0, void 0, function() {
            return __generator$1(this, function(_a3) {
                this.path(parsePathForBorder(curvePoints, side));
                this.ctx.fillStyle = asString(color2);
                this.ctx.fill();
                return [
                    2
                ];
            });
        });
    };
    CanvasRenderer.prototype.renderDoubleBorder = function(color2, width, side, curvePoints) {
        return __awaiter$2(this, void 0, void 0, function() {
            var outerPaths, innerPaths;
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        if (!(width < 3)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.renderSolidBorder(color2, side, curvePoints)
                        ];
                    case 1:
                        _a3.sent();
                        return [
                            2
                        ];
                    case 2:
                        outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                        this.path(outerPaths);
                        this.ctx.fillStyle = asString(color2);
                        this.ctx.fill();
                        innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                        this.path(innerPaths);
                        this.ctx.fill();
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
        return __awaiter$2(this, void 0, void 0, function() {
            var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
            var _this = this;
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        this.applyEffects(paint.getEffects(2));
                        styles = paint.container.styles;
                        hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                        borders = [
                            {
                                style: styles.borderTopStyle,
                                color: styles.borderTopColor,
                                width: styles.borderTopWidth
                            },
                            {
                                style: styles.borderRightStyle,
                                color: styles.borderRightColor,
                                width: styles.borderRightWidth
                            },
                            {
                                style: styles.borderBottomStyle,
                                color: styles.borderBottomColor,
                                width: styles.borderBottomWidth
                            },
                            {
                                style: styles.borderLeftStyle,
                                color: styles.borderLeftColor,
                                width: styles.borderLeftWidth
                            }
                        ];
                        backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                        if (!(hasBackground || styles.boxShadow.length)) return [
                            3,
                            2
                        ];
                        this.ctx.save();
                        this.path(backgroundPaintingArea);
                        this.ctx.clip();
                        if (!isTransparent(styles.backgroundColor)) {
                            this.ctx.fillStyle = asString(styles.backgroundColor);
                            this.ctx.fill();
                        }
                        return [
                            4,
                            this.renderBackgroundImage(paint.container)
                        ];
                    case 1:
                        _a3.sent();
                        this.ctx.restore();
                        styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                            _this.ctx.save();
                            var borderBoxArea = calculateBorderBoxPath(paint.curves);
                            var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                            var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                            if (shadow.inset) {
                                _this.path(borderBoxArea);
                                _this.ctx.clip();
                                _this.mask(shadowPaintingArea);
                            } else {
                                _this.mask(borderBoxArea);
                                _this.ctx.clip();
                                _this.path(shadowPaintingArea);
                            }
                            _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                            _this.ctx.shadowOffsetY = shadow.offsetY.number;
                            _this.ctx.shadowColor = asString(shadow.color);
                            _this.ctx.shadowBlur = shadow.blur.number;
                            _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                            _this.ctx.fill();
                            _this.ctx.restore();
                        });
                        _a3.label = 2;
                    case 2:
                        side = 0;
                        _i = 0, borders_1 = borders;
                        _a3.label = 3;
                    case 3:
                        if (!(_i < borders_1.length)) return [
                            3,
                            13
                        ];
                        border = borders_1[_i];
                        if (!(border.style !== 0 && !isTransparent(border.color) && border.width > 0)) return [
                            3,
                            11
                        ];
                        if (!(border.style === 2)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2)
                        ];
                    case 4:
                        _a3.sent();
                        return [
                            3,
                            11
                        ];
                    case 5:
                        if (!(border.style === 3)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3)
                        ];
                    case 6:
                        _a3.sent();
                        return [
                            3,
                            11
                        ];
                    case 7:
                        if (!(border.style === 4)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                        ];
                    case 8:
                        _a3.sent();
                        return [
                            3,
                            11
                        ];
                    case 9:
                        return [
                            4,
                            this.renderSolidBorder(border.color, side, paint.curves)
                        ];
                    case 10:
                        _a3.sent();
                        _a3.label = 11;
                    case 11:
                        side++;
                        _a3.label = 12;
                    case 12:
                        _i++;
                        return [
                            3,
                            3
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CanvasRenderer.prototype.renderDashedDottedBorder = function(color2, width, side, curvePoints, style) {
        return __awaiter$2(this, void 0, void 0, function() {
            var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
            return __generator$1(this, function(_a3) {
                this.ctx.save();
                strokePaths = parsePathForBorderStroke(curvePoints, side);
                boxPaths = parsePathForBorder(curvePoints, side);
                if (style === 2) {
                    this.path(boxPaths);
                    this.ctx.clip();
                }
                if (isBezierCurve(boxPaths[0])) {
                    startX = boxPaths[0].start.x;
                    startY = boxPaths[0].start.y;
                } else {
                    startX = boxPaths[0].x;
                    startY = boxPaths[0].y;
                }
                if (isBezierCurve(boxPaths[1])) {
                    endX = boxPaths[1].end.x;
                    endY = boxPaths[1].end.y;
                } else {
                    endX = boxPaths[1].x;
                    endY = boxPaths[1].y;
                }
                if (side === 0 || side === 2) length = Math.abs(startX - endX);
                else length = Math.abs(startY - endY);
                this.ctx.beginPath();
                if (style === 3) this.formatPath(strokePaths);
                else this.formatPath(boxPaths.slice(0, 2));
                dashLength = width < 3 ? width * 3 : width * 2;
                spaceLength = width < 3 ? width * 2 : width;
                if (style === 3) {
                    dashLength = width;
                    spaceLength = width;
                }
                useLineDash = true;
                if (length <= dashLength * 2) useLineDash = false;
                else if (length <= dashLength * 2 + spaceLength) {
                    multiplier = length / (2 * dashLength + spaceLength);
                    dashLength *= multiplier;
                    spaceLength *= multiplier;
                } else {
                    numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                    minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                    maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                    spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                }
                if (useLineDash) {
                    if (style === 3) this.ctx.setLineDash([
                        0,
                        dashLength + spaceLength
                    ]);
                    else this.ctx.setLineDash([
                        dashLength,
                        spaceLength
                    ]);
                }
                if (style === 3) {
                    this.ctx.lineCap = "round";
                    this.ctx.lineWidth = width;
                } else this.ctx.lineWidth = width * 2 + 1.1;
                this.ctx.strokeStyle = asString(color2);
                this.ctx.stroke();
                this.ctx.setLineDash([]);
                if (style === 2) {
                    if (isBezierCurve(boxPaths[0])) {
                        path1 = boxPaths[3];
                        path2 = boxPaths[0];
                        this.ctx.beginPath();
                        this.formatPath([
                            new Vector(path1.end.x, path1.end.y),
                            new Vector(path2.start.x, path2.start.y)
                        ]);
                        this.ctx.stroke();
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        path1 = boxPaths[1];
                        path2 = boxPaths[2];
                        this.ctx.beginPath();
                        this.formatPath([
                            new Vector(path1.end.x, path1.end.y),
                            new Vector(path2.start.x, path2.start.y)
                        ]);
                        this.ctx.stroke();
                    }
                }
                this.ctx.restore();
                return [
                    2
                ];
            });
        });
    };
    CanvasRenderer.prototype.render = function(element) {
        return __awaiter$2(this, void 0, void 0, function() {
            var stack;
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        if (this.options.backgroundColor) {
                            this.ctx.fillStyle = asString(this.options.backgroundColor);
                            this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                        }
                        stack = parseStackingContexts(element);
                        return [
                            4,
                            this.renderStack(stack)
                        ];
                    case 1:
                        _a3.sent();
                        this.applyEffects([]);
                        return [
                            2,
                            this.canvas
                        ];
                }
            });
        });
    };
    return CanvasRenderer;
})(Renderer$1);
var isTextInputElement = function(container2) {
    if (container2 instanceof TextareaElementContainer) return true;
    else if (container2 instanceof SelectElementContainer) return true;
    else if (container2 instanceof InputElementContainer && container2.type !== RADIO && container2.type !== CHECKBOX) return true;
    return false;
};
var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
    switch(clip){
        case 0:
            return calculateBorderBoxPath(curves);
        case 2:
            return calculateContentBoxPath(curves);
        case 1:
        default:
            return calculatePaddingBoxPath(curves);
    }
};
var canvasTextAlign = function(textAlign2) {
    switch(textAlign2){
        case 1:
            return "center";
        case 2:
            return "right";
        case 0:
        default:
            return "left";
    }
};
var iOSBrokenFonts = [
    "-apple-system",
    "system-ui"
];
var fixIOSSystemFonts = function(fontFamilies) {
    return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily2) {
        return iOSBrokenFonts.indexOf(fontFamily2) === -1;
    }) : fontFamilies;
};
(function(_super) {
    __extends$2(ForeignObjectRenderer, _super);
    function ForeignObjectRenderer(context, options) {
        var _this = _super.call(this, context, options) || this;
        _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
        _this.ctx = _this.canvas.getContext("2d");
        _this.options = options;
        _this.canvas.width = Math.floor(options.width * options.scale);
        _this.canvas.height = Math.floor(options.height * options.scale);
        _this.canvas.style.width = options.width + "px";
        _this.canvas.style.height = options.height + "px";
        _this.ctx.scale(_this.options.scale, _this.options.scale);
        _this.ctx.translate(-options.x, -options.y);
        _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        return _this;
    }
    ForeignObjectRenderer.prototype.render = function(element) {
        return __awaiter$2(this, void 0, void 0, function() {
            var svg2, img;
            return __generator$1(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        svg2 = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                        return [
                            4,
                            loadSerializedSVG(svg2)
                        ];
                    case 1:
                        img = _a3.sent();
                        if (this.options.backgroundColor) {
                            this.ctx.fillStyle = asString(this.options.backgroundColor);
                            this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                        }
                        this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                        return [
                            2,
                            this.canvas
                        ];
                }
            });
        });
    };
    return ForeignObjectRenderer;
})(Renderer$1);
var loadSerializedSVG = function(svg2) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            resolve(img);
        };
        img.onerror = reject;
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg2));
    });
};
if (typeof window !== "undefined") CacheStorage.setContext(window);
const getLinkText = (href)=>{
    return href.startsWith("https://") || href.startsWith("http://") || href.startsWith("//") ? " " + href + " " : "";
};
const sanitizePastedText = (dirty)=>{
    return $gPJZG(// без &nbsp; содержимое тегов будет слипаться
    dirty.replace(/<(?!\/)/g, "&nbsp;<"), {
        allowedTags: [
            "img"
        ],
        allowedAttributes: {
            "img": [
                "*"
            ]
        },
        exclusiveFilter: function(frame) {
            const isSmile = frame.tag === "img" && frame.attribs["data-type"] === "smile";
            return !isSmile;
        },
        transformTags: {
            "a": function(tagName, attribs) {
                return {
                    text: getLinkText(attribs.href),
                    tagName: null,
                    attribs: null
                };
            }
        }
    }).replace(/&nbsp;/g, " ").replace(/\s+/g, " ");
};
var ETopMailGoalId = /* @__PURE__ */ ((ETopMailGoalId2)=>{
    ETopMailGoalId2["FOLLOW"] = "follow";
    ETopMailGoalId2["SUBSCRIBE"] = "subscribe";
    ETopMailGoalId2["REGISTRATION"] = "mt_registration";
    ETopMailGoalId2["LOGIN"] = "mt_login";
    return ETopMailGoalId2;
})(ETopMailGoalId || {});
const setTopMailGoalReached = (params)=>{
    const { counterId, goalId, userId } = params;
    const { clientId, tmr: { ids, proxyIds }, vkPlayId } = getConfig();
    const proxyCounterIdIndex = ids.indexOf(counterId);
    const proxyCounterId = proxyIds[proxyCounterIdIndex];
    try {
        if (!window._tmr) window._tmr = [];
        if (!window._tmrp && proxyCounterId) window._tmrp = [];
        const getData = (id)=>{
            return {
                id: id,
                type: "reachGoal",
                goal: goalId,
                userid: userId || "",
                params: {
                    from_id: clientId,
                    VKPlayID: vkPlayId || ""
                }
            };
        };
        window._tmr.push(getData(counterId));
        if (proxyCounterId) window._tmrp.push(getData(proxyCounterId));
    } catch (ignore) {}
};
function getDefaults$1() {
    return {
        baseUrl: null,
        breaks: false,
        extensions: null,
        gfm: true,
        headerIds: true,
        headerPrefix: "",
        highlight: null,
        langPrefix: "language-",
        mangle: true,
        pedantic: false,
        renderer: null,
        sanitize: false,
        sanitizer: null,
        silent: false,
        smartLists: false,
        smartypants: false,
        tokenizer: null,
        walkTokens: null,
        xhtml: false
    };
}
let defaults = getDefaults$1();
function changeDefaults(newDefaults) {
    defaults = newDefaults;
}
const escapeTest = /[&<>"']/;
const escapeReplace = /[&<>"']/g;
const escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
const escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
const escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
const getEscapeReplacement = (ch)=>escapeReplacements[ch];
function escape$1(html, encode2) {
    if (encode2) {
        if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
    } else {
        if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
    return html;
}
const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function unescape$1(html) {
    return html.replace(unescapeTest, (_2, n2)=>{
        n2 = n2.toLowerCase();
        if (n2 === "colon") return ":";
        if (n2.charAt(0) === "#") return n2.charAt(1) === "x" ? String.fromCharCode(parseInt(n2.substring(2), 16)) : String.fromCharCode(+n2.substring(1));
        return "";
    });
}
const caret = /(^|[^\[])\^/g;
function edit(regex, opt) {
    regex = typeof regex === "string" ? regex : regex.source;
    opt = opt || "";
    const obj = {
        replace: (name2, val)=>{
            val = val.source || val;
            val = val.replace(caret, "$1");
            regex = regex.replace(name2, val);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(regex, opt);
        }
    };
    return obj;
}
const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function cleanUrl(sanitize, base, href) {
    if (sanitize) {
        let prot;
        try {
            prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, "").toLowerCase();
        } catch (e2) {
            return null;
        }
        if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) return null;
    }
    if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
    try {
        href = encodeURI(href).replace(/%25/g, "%");
    } catch (e2) {
        return null;
    }
    return href;
}
const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function resolveUrl(base, href) {
    if (!baseUrls[" " + base]) {
        if (justDomain.test(base)) baseUrls[" " + base] = base + "/";
        else baseUrls[" " + base] = rtrim(base, "/", true);
    }
    base = baseUrls[" " + base];
    const relativeBase = base.indexOf(":") === -1;
    if (href.substring(0, 2) === "//") {
        if (relativeBase) return href;
        return base.replace(protocol, "$1") + href;
    } else if (href.charAt(0) === "/") {
        if (relativeBase) return href;
        return base.replace(domain, "$1") + href;
    } else return base + href;
}
const noopTest = {
    exec: function noopTest2() {}
};
function merge(obj) {
    let i = 1, target2, key;
    for(; i < arguments.length; i++){
        target2 = arguments[i];
        for(key in target2)if (Object.prototype.hasOwnProperty.call(target2, key)) obj[key] = target2[key];
    }
    return obj;
}
function splitCells(tableRow, count2) {
    const row2 = tableRow.replace(/\|/g, (match2, offset2, str)=>{
        let escaped = false, curr = offset2;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row2.split(/ \|/);
    let i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
    if (cells.length > count2) cells.splice(count2);
    else while(cells.length < count2)cells.push("");
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace(/\\\|/g, "|");
    return cells;
}
function rtrim(str, c2, invert) {
    const l2 = str.length;
    if (l2 === 0) return "";
    let suffLen = 0;
    while(suffLen < l2){
        const currChar = str.charAt(l2 - suffLen - 1);
        if (currChar === c2 && !invert) suffLen++;
        else if (currChar !== c2 && invert) suffLen++;
        else break;
    }
    return str.slice(0, l2 - suffLen);
}
function findClosingBracket(str, b2) {
    if (str.indexOf(b2[1]) === -1) return -1;
    const l2 = str.length;
    let level = 0, i = 0;
    for(; i < l2; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b2[0]) level++;
        else if (str[i] === b2[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    return -1;
}
function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
}
function repeatString(pattern, count2) {
    if (count2 < 1) return "";
    let result2 = "";
    while(count2 > 1){
        if (count2 & 1) result2 += pattern;
        count2 >>= 1;
        pattern += pattern;
    }
    return result2 + pattern;
}
function outputLink(cap, link2, raw, lexer2) {
    const href = link2.href;
    const title2 = link2.title ? escape$1(link2.title) : null;
    const text2 = cap[1].replace(/\\([\[\]])/g, "$1");
    if (cap[0].charAt(0) !== "!") {
        lexer2.state.inLink = true;
        const token2 = {
            type: "link",
            raw: raw,
            href: href,
            title: title2,
            text: text2,
            tokens: lexer2.inlineTokens(text2, [])
        };
        lexer2.state.inLink = false;
        return token2;
    }
    return {
        type: "image",
        raw: raw,
        href: href,
        title: title2,
        text: escape$1(text2)
    };
}
function indentCodeCompensation(raw, text2) {
    const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) return text2;
    const indentToCode = matchIndentToCode[1];
    return text2.split("\n").map((node)=>{
        const matchIndentInNode = node.match(/^\s+/);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
class Tokenizer {
    constructor(options){
        this.options = options || defaults;
    }
    space(src2) {
        const cap = this.rules.block.newline.exec(src2);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src2) {
        const cap = this.rules.block.code.exec(src2);
        if (cap) {
            const text2 = cap[0].replace(/^ {1,4}/gm, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? rtrim(text2, "\n") : text2
            };
        }
    }
    fences(src2) {
        const cap = this.rules.block.fences.exec(src2);
        if (cap) {
            const raw = cap[0];
            const text2 = indentCodeCompensation(raw, cap[3] || "");
            return {
                type: "code",
                raw: raw,
                lang: cap[2] ? cap[2].trim() : cap[2],
                text: text2
            };
        }
    }
    heading(src2) {
        const cap = this.rules.block.heading.exec(src2);
        if (cap) {
            let text2 = cap[2].trim();
            if (/#$/.test(text2)) {
                const trimmed = rtrim(text2, "#");
                if (this.options.pedantic) text2 = trimmed.trim();
                else if (!trimmed || / $/.test(trimmed)) text2 = trimmed.trim();
            }
            const token2 = {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text: text2,
                tokens: []
            };
            this.lexer.inline(token2.text, token2.tokens);
            return token2;
        }
    }
    hr(src2) {
        const cap = this.rules.block.hr.exec(src2);
        if (cap) return {
            type: "hr",
            raw: cap[0]
        };
    }
    blockquote(src2) {
        const cap = this.rules.block.blockquote.exec(src2);
        if (cap) {
            const text2 = cap[0].replace(/^ *>[ \t]?/gm, "");
            return {
                type: "blockquote",
                raw: cap[0],
                tokens: this.lexer.blockTokens(text2, []),
                text: text2
            };
        }
    }
    list(src2) {
        let cap = this.rules.block.list.exec(src2);
        if (cap) {
            let raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list2 = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            const itemRegex = new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`);
            while(src2){
                endEarly = false;
                if (!(cap = itemRegex.exec(src2))) break;
                if (this.rules.block.hr.test(src2)) break;
                raw = cap[0];
                src2 = src2.substring(raw.length);
                line = cap[2].split("\n", 1)[0];
                nextLine = src2.split("\n", 1)[0];
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimLeft();
                } else {
                    indent = cap[2].search(/[^ ]/);
                    indent = indent > 4 ? 1 : indent;
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                blankLine = false;
                if (!line && /^ *$/.test(nextLine)) {
                    raw += nextLine + "\n";
                    src2 = src2.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))`);
                    const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                    while(src2){
                        rawLine = src2.split("\n", 1)[0];
                        line = rawLine;
                        if (this.options.pedantic) line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                        if (nextBulletRegex.test(line)) break;
                        if (hrRegex.test(src2)) break;
                        if (line.search(/[^ ]/) >= indent || !line.trim()) itemContents += "\n" + line.slice(indent);
                        else if (!blankLine) itemContents += "\n" + line;
                        else break;
                        if (!blankLine && !line.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src2 = src2.substring(rawLine.length + 1);
                    }
                }
                if (!list2.loose) {
                    if (endsWithBlankLine) list2.loose = true;
                    else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                }
                if (this.options.gfm) {
                    istask = /^\[[ xX]\] /.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                    }
                }
                list2.items.push({
                    type: "list_item",
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents
                });
                list2.raw += raw;
            }
            list2.items[list2.items.length - 1].raw = raw.trimRight();
            list2.items[list2.items.length - 1].text = itemContents.trimRight();
            list2.raw = list2.raw.trimRight();
            const l2 = list2.items.length;
            for(i = 0; i < l2; i++){
                this.lexer.state.top = false;
                list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                const spacers = list2.items[i].tokens.filter((t2)=>t2.type === "space");
                const hasMultipleLineBreaks = spacers.every((t2)=>{
                    const chars2 = t2.raw.split("");
                    let lineBreaks = 0;
                    for (const char of chars2){
                        if (char === "\n") lineBreaks += 1;
                        if (lineBreaks > 1) return true;
                    }
                    return false;
                });
                if (!list2.loose && spacers.length && hasMultipleLineBreaks) {
                    list2.loose = true;
                    list2.items[i].loose = true;
                }
            }
            return list2;
        }
    }
    html(src2) {
        const cap = this.rules.block.html.exec(src2);
        if (cap) {
            const token2 = {
                type: "html",
                raw: cap[0],
                pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
                text: cap[0]
            };
            if (this.options.sanitize) {
                token2.type = "paragraph";
                token2.text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]);
                token2.tokens = [];
                this.lexer.inline(token2.text, token2.tokens);
            }
            return token2;
        }
    }
    def(src2) {
        const cap = this.rules.block.def.exec(src2);
        if (cap) {
            if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
            const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
            return {
                type: "def",
                tag: tag,
                raw: cap[0],
                href: cap[2],
                title: cap[3]
            };
        }
    }
    table(src2) {
        const cap = this.rules.block.table.exec(src2);
        if (cap) {
            const item2 = {
                type: "table",
                header: splitCells(cap[1]).map((c2)=>{
                    return {
                        text: c2
                    };
                }),
                align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
            };
            if (item2.header.length === item2.align.length) {
                item2.raw = cap[0];
                let l2 = item2.align.length;
                let i, j2, k2, row2;
                for(i = 0; i < l2; i++){
                    if (/^ *-+: *$/.test(item2.align[i])) item2.align[i] = "right";
                    else if (/^ *:-+: *$/.test(item2.align[i])) item2.align[i] = "center";
                    else if (/^ *:-+ *$/.test(item2.align[i])) item2.align[i] = "left";
                    else item2.align[i] = null;
                }
                l2 = item2.rows.length;
                for(i = 0; i < l2; i++)item2.rows[i] = splitCells(item2.rows[i], item2.header.length).map((c2)=>{
                    return {
                        text: c2
                    };
                });
                l2 = item2.header.length;
                for(j2 = 0; j2 < l2; j2++){
                    item2.header[j2].tokens = [];
                    this.lexer.inline(item2.header[j2].text, item2.header[j2].tokens);
                }
                l2 = item2.rows.length;
                for(j2 = 0; j2 < l2; j2++){
                    row2 = item2.rows[j2];
                    for(k2 = 0; k2 < row2.length; k2++){
                        row2[k2].tokens = [];
                        this.lexer.inline(row2[k2].text, row2[k2].tokens);
                    }
                }
                return item2;
            }
        }
    }
    lheading(src2) {
        const cap = this.rules.block.lheading.exec(src2);
        if (cap) {
            const token2 = {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: []
            };
            this.lexer.inline(token2.text, token2.tokens);
            return token2;
        }
    }
    paragraph(src2) {
        const cap = this.rules.block.paragraph.exec(src2);
        if (cap) {
            const token2 = {
                type: "paragraph",
                raw: cap[0],
                text: cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1],
                tokens: []
            };
            this.lexer.inline(token2.text, token2.tokens);
            return token2;
        }
    }
    text(src2) {
        const cap = this.rules.block.text.exec(src2);
        if (cap) {
            const token2 = {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: []
            };
            this.lexer.inline(token2.text, token2.tokens);
            return token2;
        }
    }
    escape(src2) {
        const cap = this.rules.inline.escape.exec(src2);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: escape$1(cap[1])
        };
    }
    tag(src2) {
        const cap = this.rules.inline.tag.exec(src2);
        if (cap) {
            if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: this.options.sanitize ? "text" : "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]) : cap[0]
            };
        }
    }
    link(src2) {
        const cap = this.rules.inline.link.exec(src2);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                if (!/>$/.test(trimmedUrl)) return;
                const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                const lastParenIndex = findClosingBracket(cap[2], "()");
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title2 = "";
            if (this.options.pedantic) {
                const link2 = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                if (link2) {
                    href = link2[1];
                    title2 = link2[3];
                }
            } else title2 = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (/^</.test(href)) {
                if (this.options.pedantic && !/>$/.test(trimmedUrl)) href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return outputLink(cap, {
                href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                title: title2 ? title2.replace(this.rules.inline._escapes, "$1") : title2
            }, cap[0], this.lexer);
        }
    }
    reflink(src2, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src2)) || (cap = this.rules.inline.nolink.exec(src2))) {
            let link2 = (cap[2] || cap[1]).replace(/\s+/g, " ");
            link2 = links[link2.toLowerCase()];
            if (!link2 || !link2.href) {
                const text2 = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text2,
                    text: text2
                };
            }
            return outputLink(cap, link2, cap[0], this.lexer);
        }
    }
    emStrong(src2, maskedSrc, prevChar = "") {
        let match2 = this.rules.inline.emStrong.lDelim.exec(src2);
        if (!match2) return;
        if (match2[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
        const nextChar = match2[1] || match2[2] || "";
        if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
            const lLength = match2[0].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match2[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            endReg.lastIndex = 0;
            maskedSrc = maskedSrc.slice(-1 * src2.length + lLength);
            while((match2 = endReg.exec(maskedSrc)) != null){
                rDelim = match2[1] || match2[2] || match2[3] || match2[4] || match2[5] || match2[6];
                if (!rDelim) continue;
                rLength = rDelim.length;
                if (match2[3] || match2[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match2[5] || match2[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue;
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue;
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                if (Math.min(lLength, rLength) % 2) {
                    const text3 = src2.slice(1, lLength + match2.index + rLength);
                    return {
                        type: "em",
                        raw: src2.slice(0, lLength + match2.index + rLength + 1),
                        text: text3,
                        tokens: this.lexer.inlineTokens(text3, [])
                    };
                }
                const text2 = src2.slice(2, lLength + match2.index + rLength - 1);
                return {
                    type: "strong",
                    raw: src2.slice(0, lLength + match2.index + rLength + 1),
                    text: text2,
                    tokens: this.lexer.inlineTokens(text2, [])
                };
            }
        }
    }
    codespan(src2) {
        const cap = this.rules.inline.code.exec(src2);
        if (cap) {
            let text2 = cap[2].replace(/\n/g, " ");
            const hasNonSpaceChars = /[^ ]/.test(text2);
            const hasSpaceCharsOnBothEnds = /^ /.test(text2) && / $/.test(text2);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text2 = text2.substring(1, text2.length - 1);
            text2 = escape$1(text2, true);
            return {
                type: "codespan",
                raw: cap[0],
                text: text2
            };
        }
    }
    br(src2) {
        const cap = this.rules.inline.br.exec(src2);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src2) {
        const cap = this.rules.inline.del.exec(src2);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2], [])
        };
    }
    autolink(src2, mangle2) {
        const cap = this.rules.inline.autolink.exec(src2);
        if (cap) {
            let text2, href;
            if (cap[2] === "@") {
                text2 = escape$1(this.options.mangle ? mangle2(cap[1]) : cap[1]);
                href = "mailto:" + text2;
            } else {
                text2 = escape$1(cap[1]);
                href = text2;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text2,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text2,
                        text: text2
                    }
                ]
            };
        }
    }
    url(src2, mangle2) {
        let cap;
        if (cap = this.rules.inline.url.exec(src2)) {
            let text2, href;
            if (cap[2] === "@") {
                text2 = escape$1(this.options.mangle ? mangle2(cap[0]) : cap[0]);
                href = "mailto:" + text2;
            } else {
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                }while (prevCapZero !== cap[0]);
                text2 = escape$1(cap[0]);
                if (cap[1] === "www.") href = "http://" + text2;
                else href = text2;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text2,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text2,
                        text: text2
                    }
                ]
            };
        }
    }
    inlineText(src2, smartypants2) {
        const cap = this.rules.inline.text.exec(src2);
        if (cap) {
            let text2;
            if (this.lexer.state.inRawBlock) text2 = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]) : cap[0];
            else text2 = escape$1(this.options.smartypants ? smartypants2(cap[0]) : cap[0]);
            return {
                type: "text",
                raw: cap[0],
                text: text2
            };
        }
    }
}
const block$6 = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
    def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
};
block$6._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block$6._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block$6.def = edit(block$6.def).replace("label", block$6._label).replace("title", block$6._title).getRegex();
block$6.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block$6.listItemStart = edit(/^( *)(bull) */).replace("bull", block$6.bullet).getRegex();
block$6.list = edit(block$6.list).replace(/bull/g, block$6.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block$6.def.source + ")").getRegex();
block$6._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
block$6._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block$6.html = edit(block$6.html, "i").replace("comment", block$6._comment).replace("tag", block$6._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
block$6.paragraph = edit(block$6._paragraph).replace("hr", block$6.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$6._tag).getRegex();
block$6.blockquote = edit(block$6.blockquote).replace("paragraph", block$6.paragraph).getRegex();
block$6.normal = merge({}, block$6);
block$6.gfm = merge({}, block$6.normal, {
    table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
});
block$6.gfm.table = edit(block$6.gfm.table).replace("hr", block$6.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$6._tag).getRegex();
block$6.gfm.paragraph = edit(block$6._paragraph).replace("hr", block$6.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", block$6.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$6._tag).getRegex();
block$6.pedantic = merge({}, block$6.normal, {
    html: edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", block$6._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    paragraph: edit(block$6.normal._paragraph).replace("hr", block$6.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block$6.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
});
const inline$1 = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: "reflink|nolink(?!\\()",
    emStrong: {
        lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
        //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
        //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
        rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
        rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    },
    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
};
inline$1._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
inline$1.punctuation = edit(inline$1.punctuation).replace(/punctuation/g, inline$1._punctuation).getRegex();
inline$1.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
inline$1.escapedEmSt = /\\\*|\\_/g;
inline$1._comment = edit(block$6._comment).replace("(?:-->|$)", "-->").getRegex();
inline$1.emStrong.lDelim = edit(inline$1.emStrong.lDelim).replace(/punct/g, inline$1._punctuation).getRegex();
inline$1.emStrong.rDelimAst = edit(inline$1.emStrong.rDelimAst, "g").replace(/punct/g, inline$1._punctuation).getRegex();
inline$1.emStrong.rDelimUnd = edit(inline$1.emStrong.rDelimUnd, "g").replace(/punct/g, inline$1._punctuation).getRegex();
inline$1._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
inline$1._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline$1._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline$1.autolink = edit(inline$1.autolink).replace("scheme", inline$1._scheme).replace("email", inline$1._email).getRegex();
inline$1._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
inline$1.tag = edit(inline$1.tag).replace("comment", inline$1._comment).replace("attribute", inline$1._attribute).getRegex();
inline$1._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline$1._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline$1._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
inline$1.link = edit(inline$1.link).replace("label", inline$1._label).replace("href", inline$1._href).replace("title", inline$1._title).getRegex();
inline$1.reflink = edit(inline$1.reflink).replace("label", inline$1._label).replace("ref", block$6._label).getRegex();
inline$1.nolink = edit(inline$1.nolink).replace("ref", block$6._label).getRegex();
inline$1.reflinkSearch = edit(inline$1.reflinkSearch, "g").replace("reflink", inline$1.reflink).replace("nolink", inline$1.nolink).getRegex();
inline$1.normal = merge({}, inline$1);
inline$1.pedantic = merge({}, inline$1.normal, {
    strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
    },
    em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline$1._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline$1._label).getRegex()
});
inline$1.gfm = merge({}, inline$1.normal, {
    escape: edit(inline$1.escape).replace("])", "~|])").getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
inline$1.gfm.url = edit(inline$1.gfm.url, "i").replace("email", inline$1.gfm._extended_email).getRegex();
inline$1.breaks = merge({}, inline$1.gfm, {
    br: edit(inline$1.br).replace("{2,}", "*").getRegex(),
    text: edit(inline$1.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
function smartypants(text2) {
    return text2.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026");
}
function mangle(text2) {
    let out = "", i, ch;
    const l2 = text2.length;
    for(i = 0; i < l2; i++){
        ch = text2.charCodeAt(i);
        if (Math.random() > 0.5) ch = "x" + ch.toString(16);
        out += "&#" + ch + ";";
    }
    return out;
}
class Lexer {
    constructor(options){
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options || defaults;
        this.options.tokenizer = this.options.tokenizer || new Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            block: block$6.normal,
            inline: inline$1.normal
        };
        if (this.options.pedantic) {
            rules.block = block$6.pedantic;
            rules.inline = inline$1.pedantic;
        } else if (this.options.gfm) {
            rules.block = block$6.gfm;
            if (this.options.breaks) rules.inline = inline$1.breaks;
            else rules.inline = inline$1.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: block$6,
            inline: inline$1
        };
    }
    /**
   * Static Lex Method
   */ static lex(src2, options) {
        const lexer2 = new Lexer(options);
        return lexer2.lex(src2);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src2, options) {
        const lexer2 = new Lexer(options);
        return lexer2.inlineTokens(src2);
    }
    /**
   * Preprocessing
   */ lex(src2) {
        src2 = src2.replace(/\r\n|\r/g, "\n");
        this.blockTokens(src2, this.tokens);
        let next2;
        while(next2 = this.inlineQueue.shift())this.inlineTokens(next2.src, next2.tokens);
        return this.tokens;
    }
    /**
   * Lexing
   */ blockTokens(src2, tokens = []) {
        if (this.options.pedantic) src2 = src2.replace(/\t/g, "    ").replace(/^ +$/gm, "");
        else src2 = src2.replace(/^( *)(\t+)/gm, (_2, leading, tabs)=>{
            return leading + "    ".repeat(tabs.length);
        });
        let token2, lastToken, cutSrc, lastParagraphClipped;
        while(src2){
            if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                if (token2 = extTokenizer.call({
                    lexer: this
                }, src2, tokens)) {
                    src2 = src2.substring(token2.raw.length);
                    tokens.push(token2);
                    return true;
                }
                return false;
            })) continue;
            if (token2 = this.tokenizer.space(src2)) {
                src2 = src2.substring(token2.raw.length);
                if (token2.raw.length === 1 && tokens.length > 0) tokens[tokens.length - 1].raw += "\n";
                else tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.code(src2)) {
                src2 = src2.substring(token2.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                    lastToken.raw += "\n" + token2.raw;
                    lastToken.text += "\n" + token2.text;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.fences(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.heading(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.hr(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.blockquote(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.list(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.html(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.def(src2)) {
                src2 = src2.substring(token2.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                    lastToken.raw += "\n" + token2.raw;
                    lastToken.text += "\n" + token2.raw;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else if (!this.tokens.links[token2.tag]) this.tokens.links[token2.tag] = {
                    href: token2.href,
                    title: token2.title
                };
                continue;
            }
            if (token2 = this.tokenizer.table(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.lheading(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            cutSrc = src2;
            if (this.options.extensions && this.options.extensions.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src2.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach(function(getStartIndex) {
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src2.substring(0, startIndex + 1);
            }
            if (this.state.top && (token2 = this.tokenizer.paragraph(cutSrc))) {
                lastToken = tokens[tokens.length - 1];
                if (lastParagraphClipped && lastToken.type === "paragraph") {
                    lastToken.raw += "\n" + token2.raw;
                    lastToken.text += "\n" + token2.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token2);
                lastParagraphClipped = cutSrc.length !== src2.length;
                src2 = src2.substring(token2.raw.length);
                continue;
            }
            if (token2 = this.tokenizer.text(src2)) {
                src2 = src2.substring(token2.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === "text") {
                    lastToken.raw += "\n" + token2.raw;
                    lastToken.text += "\n" + token2.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token2);
                continue;
            }
            if (src2) {
                const errMsg = "Infinite loop on byte: " + src2.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src2, tokens) {
        this.inlineQueue.push({
            src: src2,
            tokens: tokens
        });
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src2, tokens = []) {
        let token2, lastToken, cutSrc;
        let maskedSrc = src2;
        let match2;
        let keepPrevChar, prevChar;
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match2 = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match2[0].slice(match2[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match2.index) + "[" + repeatString("a", match2[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        while((match2 = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match2.index) + "[" + repeatString("a", match2[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        while((match2 = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match2.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        while(src2){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                if (token2 = extTokenizer.call({
                    lexer: this
                }, src2, tokens)) {
                    src2 = src2.substring(token2.raw.length);
                    tokens.push(token2);
                    return true;
                }
                return false;
            })) continue;
            if (token2 = this.tokenizer.escape(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.tag(src2)) {
                src2 = src2.substring(token2.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token2.type === "text" && lastToken.type === "text") {
                    lastToken.raw += token2.raw;
                    lastToken.text += token2.text;
                } else tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.link(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.reflink(src2, this.tokens.links)) {
                src2 = src2.substring(token2.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token2.type === "text" && lastToken.type === "text") {
                    lastToken.raw += token2.raw;
                    lastToken.text += token2.text;
                } else tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.emStrong(src2, maskedSrc, prevChar)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.codespan(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.br(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.del(src2)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (token2 = this.tokenizer.autolink(src2, mangle)) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            if (!this.state.inLink && (token2 = this.tokenizer.url(src2, mangle))) {
                src2 = src2.substring(token2.raw.length);
                tokens.push(token2);
                continue;
            }
            cutSrc = src2;
            if (this.options.extensions && this.options.extensions.startInline) {
                let startIndex = Infinity;
                const tempSrc = src2.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach(function(getStartIndex) {
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src2.substring(0, startIndex + 1);
            }
            if (token2 = this.tokenizer.inlineText(cutSrc, smartypants)) {
                src2 = src2.substring(token2.raw.length);
                if (token2.raw.slice(-1) !== "_") prevChar = token2.raw.slice(-1);
                keepPrevChar = true;
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === "text") {
                    lastToken.raw += token2.raw;
                    lastToken.text += token2.text;
                } else tokens.push(token2);
                continue;
            }
            if (src2) {
                const errMsg = "Infinite loop on byte: " + src2.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
}
class Renderer {
    constructor(options){
        this.options = options || defaults;
    }
    code(code, infostring, escaped) {
        const lang = (infostring || "").match(/\S*/)[0];
        if (this.options.highlight) {
            const out = this.options.highlight(code, lang);
            if (out != null && out !== code) {
                escaped = true;
                code = out;
            }
        }
        code = code.replace(/\n$/, "") + "\n";
        if (!lang) return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
        return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
    }
    /**
   * @param {string} quote
   */ blockquote(quote) {
        return `<blockquote>
${quote}</blockquote>
`;
    }
    html(html) {
        return html;
    }
    /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */ heading(text2, level, raw, slugger) {
        if (this.options.headerIds) {
            const id = this.options.headerPrefix + slugger.slug(raw);
            return `<h${level} id="${id}">${text2}</h${level}>
`;
        }
        return `<h${level}>${text2}</h${level}>
`;
    }
    hr() {
        return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
    }
    list(body2, ordered, start) {
        const type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startatt + ">\n" + body2 + "</" + type + ">\n";
    }
    /**
   * @param {string} text
   */ listitem(text2) {
        return `<li>${text2}</li>
`;
    }
    checkbox(checked2) {
        return "<input " + (checked2 ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
    }
    /**
   * @param {string} text
   */ paragraph(text2) {
        return `<p>${text2}</p>
`;
    }
    /**
   * @param {string} header
   * @param {string} body
   */ table(header2, body2) {
        if (body2) body2 = `<tbody>${body2}</tbody>`;
        return "<table>\n<thead>\n" + header2 + "</thead>\n" + body2 + "</table>\n";
    }
    /**
   * @param {string} content
   */ tablerow(content2) {
        return `<tr>
${content2}</tr>
`;
    }
    tablecell(content2, flags2) {
        const type = flags2.header ? "th" : "td";
        const tag = flags2.align ? `<${type} align="${flags2.align}">` : `<${type}>`;
        return tag + content2 + `</${type}>
`;
    }
    /**
   * span level renderer
   * @param {string} text
   */ strong(text2) {
        return `<strong>${text2}</strong>`;
    }
    /**
   * @param {string} text
   */ em(text2) {
        return `<em>${text2}</em>`;
    }
    /**
   * @param {string} text
   */ codespan(text2) {
        return `<code>${text2}</code>`;
    }
    br() {
        return this.options.xhtml ? "<br/>" : "<br>";
    }
    /**
   * @param {string} text
   */ del(text2) {
        return `<del>${text2}</del>`;
    }
    /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */ link(href, title2, text2) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
        if (href === null) return text2;
        let out = '<a href="' + escape$1(href) + '"';
        if (title2) out += ' title="' + title2 + '"';
        out += ">" + text2 + "</a>";
        return out;
    }
    /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */ image(href, title2, text2) {
        href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
        if (href === null) return text2;
        let out = `<img src="${href}" alt="${text2}"`;
        if (title2) out += ` title="${title2}"`;
        out += this.options.xhtml ? "/>" : ">";
        return out;
    }
    text(text2) {
        return text2;
    }
}
class TextRenderer {
    // no need for block level renderers
    strong(text2) {
        return text2;
    }
    em(text2) {
        return text2;
    }
    codespan(text2) {
        return text2;
    }
    del(text2) {
        return text2;
    }
    html(text2) {
        return text2;
    }
    text(text2) {
        return text2;
    }
    link(href, title2, text2) {
        return "" + text2;
    }
    image(href, title2, text2) {
        return "" + text2;
    }
    br() {
        return "";
    }
}
class Slugger {
    constructor(){
        this.seen = {};
    }
    /**
   * @param {string} value
   */ serialize(value2) {
        return value2.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
    }
    /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */ getNextSafeSlug(originalSlug, isDryRun) {
        let slug = originalSlug;
        let occurenceAccumulator = 0;
        if (this.seen.hasOwnProperty(slug)) {
            occurenceAccumulator = this.seen[originalSlug];
            do {
                occurenceAccumulator++;
                slug = originalSlug + "-" + occurenceAccumulator;
            }while (this.seen.hasOwnProperty(slug));
        }
        if (!isDryRun) {
            this.seen[originalSlug] = occurenceAccumulator;
            this.seen[slug] = 0;
        }
        return slug;
    }
    /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */ slug(value2, options = {}) {
        const slug = this.serialize(value2);
        return this.getNextSafeSlug(slug, options.dryrun);
    }
}
class Parser {
    constructor(options){
        this.options = options || defaults;
        this.options.renderer = this.options.renderer || new Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.textRenderer = new TextRenderer();
        this.slugger = new Slugger();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options) {
        const parser = new Parser(options);
        return parser.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options) {
        const parser = new Parser(options);
        return parser.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top2 = true) {
        let out = "", i, j2, k2, l2, l3, row2, cell2, header2, body2, token2, ordered, start, loose, itemBody, item2, checked2, task, checkbox2, ret;
        const l4 = tokens.length;
        for(i = 0; i < l4; i++){
            token2 = tokens[i];
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token2.type]) {
                ret = this.options.extensions.renderers[token2.type].call({
                    parser: this
                }, token2);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(token2.type)) {
                    out += ret || "";
                    continue;
                }
            }
            switch(token2.type){
                case "space":
                    continue;
                case "hr":
                    out += this.renderer.hr();
                    continue;
                case "heading":
                    out += this.renderer.heading(this.parseInline(token2.tokens), token2.depth, unescape$1(this.parseInline(token2.tokens, this.textRenderer)), this.slugger);
                    continue;
                case "code":
                    out += this.renderer.code(token2.text, token2.lang, token2.escaped);
                    continue;
                case "table":
                    header2 = "";
                    cell2 = "";
                    l2 = token2.header.length;
                    for(j2 = 0; j2 < l2; j2++)cell2 += this.renderer.tablecell(this.parseInline(token2.header[j2].tokens), {
                        header: true,
                        align: token2.align[j2]
                    });
                    header2 += this.renderer.tablerow(cell2);
                    body2 = "";
                    l2 = token2.rows.length;
                    for(j2 = 0; j2 < l2; j2++){
                        row2 = token2.rows[j2];
                        cell2 = "";
                        l3 = row2.length;
                        for(k2 = 0; k2 < l3; k2++)cell2 += this.renderer.tablecell(this.parseInline(row2[k2].tokens), {
                            header: false,
                            align: token2.align[k2]
                        });
                        body2 += this.renderer.tablerow(cell2);
                    }
                    out += this.renderer.table(header2, body2);
                    continue;
                case "blockquote":
                    body2 = this.parse(token2.tokens);
                    out += this.renderer.blockquote(body2);
                    continue;
                case "list":
                    ordered = token2.ordered;
                    start = token2.start;
                    loose = token2.loose;
                    l2 = token2.items.length;
                    body2 = "";
                    for(j2 = 0; j2 < l2; j2++){
                        item2 = token2.items[j2];
                        checked2 = item2.checked;
                        task = item2.task;
                        itemBody = "";
                        if (item2.task) {
                            checkbox2 = this.renderer.checkbox(checked2);
                            if (loose) {
                                if (item2.tokens.length > 0 && item2.tokens[0].type === "paragraph") {
                                    item2.tokens[0].text = checkbox2 + " " + item2.tokens[0].text;
                                    if (item2.tokens[0].tokens && item2.tokens[0].tokens.length > 0 && item2.tokens[0].tokens[0].type === "text") item2.tokens[0].tokens[0].text = checkbox2 + " " + item2.tokens[0].tokens[0].text;
                                } else item2.tokens.unshift({
                                    type: "text",
                                    text: checkbox2
                                });
                            } else itemBody += checkbox2;
                        }
                        itemBody += this.parse(item2.tokens, loose);
                        body2 += this.renderer.listitem(itemBody, task, checked2);
                    }
                    out += this.renderer.list(body2, ordered, start);
                    continue;
                case "html":
                    out += this.renderer.html(token2.text);
                    continue;
                case "paragraph":
                    out += this.renderer.paragraph(this.parseInline(token2.tokens));
                    continue;
                case "text":
                    body2 = token2.tokens ? this.parseInline(token2.tokens) : token2.text;
                    while(i + 1 < l4 && tokens[i + 1].type === "text"){
                        token2 = tokens[++i];
                        body2 += "\n" + (token2.tokens ? this.parseInline(token2.tokens) : token2.text);
                    }
                    out += top2 ? this.renderer.paragraph(body2) : body2;
                    continue;
                default:
                    {
                        const errMsg = 'Token with "' + token2.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer) {
        renderer = renderer || this.renderer;
        let out = "", i, token2, ret;
        const l2 = tokens.length;
        for(i = 0; i < l2; i++){
            token2 = tokens[i];
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token2.type]) {
                ret = this.options.extensions.renderers[token2.type].call({
                    parser: this
                }, token2);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(token2.type)) {
                    out += ret || "";
                    continue;
                }
            }
            switch(token2.type){
                case "escape":
                    out += renderer.text(token2.text);
                    break;
                case "html":
                    out += renderer.html(token2.text);
                    break;
                case "link":
                    out += renderer.link(token2.href, token2.title, this.parseInline(token2.tokens, renderer));
                    break;
                case "image":
                    out += renderer.image(token2.href, token2.title, token2.text);
                    break;
                case "strong":
                    out += renderer.strong(this.parseInline(token2.tokens, renderer));
                    break;
                case "em":
                    out += renderer.em(this.parseInline(token2.tokens, renderer));
                    break;
                case "codespan":
                    out += renderer.codespan(token2.text);
                    break;
                case "br":
                    out += renderer.br();
                    break;
                case "del":
                    out += renderer.del(this.parseInline(token2.tokens, renderer));
                    break;
                case "text":
                    out += renderer.text(token2.text);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token2.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
}
function marked$1(src2, opt, callback) {
    if (typeof src2 === "undefined" || src2 === null) throw new Error("marked(): input parameter is undefined or null");
    if (typeof src2 !== "string") throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src2) + ", string expected");
    if (typeof opt === "function") {
        callback = opt;
        opt = null;
    }
    opt = merge({}, marked$1.defaults, opt || {});
    checkSanitizeDeprecation(opt);
    if (callback) {
        const highlight2 = opt.highlight;
        let tokens;
        try {
            tokens = Lexer.lex(src2, opt);
        } catch (e2) {
            return callback(e2);
        }
        const done = function(err) {
            let out;
            if (!err) try {
                if (opt.walkTokens) marked$1.walkTokens(tokens, opt.walkTokens);
                out = Parser.parse(tokens, opt);
            } catch (e2) {
                err = e2;
            }
            opt.highlight = highlight2;
            return err ? callback(err) : callback(null, out);
        };
        if (!highlight2 || highlight2.length < 3) return done();
        delete opt.highlight;
        if (!tokens.length) return done();
        let pending = 0;
        marked$1.walkTokens(tokens, function(token2) {
            if (token2.type === "code") {
                pending++;
                setTimeout(()=>{
                    highlight2(token2.text, token2.lang, function(err, code) {
                        if (err) return done(err);
                        if (code != null && code !== token2.text) {
                            token2.text = code;
                            token2.escaped = true;
                        }
                        pending--;
                        if (pending === 0) done();
                    });
                }, 0);
            }
        });
        if (pending === 0) done();
        return;
    }
    try {
        const tokens = Lexer.lex(src2, opt);
        if (opt.walkTokens) marked$1.walkTokens(tokens, opt.walkTokens);
        return Parser.parse(tokens, opt);
    } catch (e2) {
        e2.message += "\nPlease report this to https://github.com/markedjs/marked.";
        if (opt.silent) return "<p>An error occurred:</p><pre>" + escape$1(e2.message + "", true) + "</pre>";
        throw e2;
    }
}
marked$1.options = marked$1.setOptions = function(opt) {
    merge(marked$1.defaults, opt);
    changeDefaults(marked$1.defaults);
    return marked$1;
};
marked$1.getDefaults = getDefaults$1;
marked$1.defaults = defaults;
marked$1.use = function(...args) {
    const opts = merge({}, ...args);
    const extensions = marked$1.defaults.extensions || {
        renderers: {},
        childTokens: {}
    };
    let hasExtensions;
    args.forEach((pack2)=>{
        if (pack2.extensions) {
            hasExtensions = true;
            pack2.extensions.forEach((ext)=>{
                if (!ext.name) throw new Error("extension name required");
                if (ext.renderer) {
                    const prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
                    if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                        let ret = ext.renderer.apply(this, args2);
                        if (ret === false) ret = prevRenderer.apply(this, args2);
                        return ret;
                    };
                    else extensions.renderers[ext.name] = ext.renderer;
                }
                if (ext.tokenizer) {
                    if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                    if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                    else extensions[ext.level] = [
                        ext.tokenizer
                    ];
                    if (ext.start) {
                        if (ext.level === "block") {
                            if (extensions.startBlock) extensions.startBlock.push(ext.start);
                            else extensions.startBlock = [
                                ext.start
                            ];
                        } else if (ext.level === "inline") {
                            if (extensions.startInline) extensions.startInline.push(ext.start);
                            else extensions.startInline = [
                                ext.start
                            ];
                        }
                    }
                }
                if (ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
            });
        }
        if (pack2.renderer) {
            const renderer = marked$1.defaults.renderer || new Renderer();
            for(const prop in pack2.renderer){
                const prevRenderer = renderer[prop];
                renderer[prop] = (...args2)=>{
                    let ret = pack2.renderer[prop].apply(renderer, args2);
                    if (ret === false) ret = prevRenderer.apply(renderer, args2);
                    return ret;
                };
            }
            opts.renderer = renderer;
        }
        if (pack2.tokenizer) {
            const tokenizer = marked$1.defaults.tokenizer || new Tokenizer();
            for(const prop in pack2.tokenizer){
                const prevTokenizer = tokenizer[prop];
                tokenizer[prop] = (...args2)=>{
                    let ret = pack2.tokenizer[prop].apply(tokenizer, args2);
                    if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                    return ret;
                };
            }
            opts.tokenizer = tokenizer;
        }
        if (pack2.walkTokens) {
            const walkTokens = marked$1.defaults.walkTokens;
            opts.walkTokens = function(token2) {
                pack2.walkTokens.call(this, token2);
                if (walkTokens) walkTokens.call(this, token2);
            };
        }
        if (hasExtensions) opts.extensions = extensions;
        marked$1.setOptions(opts);
    });
};
marked$1.walkTokens = function(tokens, callback) {
    for (const token2 of tokens){
        callback.call(marked$1, token2);
        switch(token2.type){
            case "table":
                for (const cell2 of token2.header)marked$1.walkTokens(cell2.tokens, callback);
                for (const row2 of token2.rows)for (const cell2 of row2)marked$1.walkTokens(cell2.tokens, callback);
                break;
            case "list":
                marked$1.walkTokens(token2.items, callback);
                break;
            default:
                if (marked$1.defaults.extensions && marked$1.defaults.extensions.childTokens && marked$1.defaults.extensions.childTokens[token2.type]) marked$1.defaults.extensions.childTokens[token2.type].forEach(function(childTokens) {
                    marked$1.walkTokens(token2[childTokens], callback);
                });
                else if (token2.tokens) marked$1.walkTokens(token2.tokens, callback);
        }
    }
};
marked$1.parseInline = function(src2, opt) {
    if (typeof src2 === "undefined" || src2 === null) throw new Error("marked.parseInline(): input parameter is undefined or null");
    if (typeof src2 !== "string") throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(src2) + ", string expected");
    opt = merge({}, marked$1.defaults, opt || {});
    checkSanitizeDeprecation(opt);
    try {
        const tokens = Lexer.lexInline(src2, opt);
        if (opt.walkTokens) marked$1.walkTokens(tokens, opt.walkTokens);
        return Parser.parseInline(tokens, opt);
    } catch (e2) {
        e2.message += "\nPlease report this to https://github.com/markedjs/marked.";
        if (opt.silent) return "<p>An error occurred:</p><pre>" + escape$1(e2.message + "", true) + "</pre>";
        throw e2;
    }
};
marked$1.Parser = Parser;
marked$1.parser = Parser.parse;
marked$1.Renderer = Renderer;
marked$1.TextRenderer = TextRenderer;
marked$1.Lexer = Lexer;
marked$1.lexer = Lexer.lex;
marked$1.Tokenizer = Tokenizer;
marked$1.Slugger = Slugger;
marked$1.parse = marked$1;
marked$1.options;
marked$1.setOptions;
marked$1.use;
marked$1.walkTokens;
marked$1.parseInline;
Parser.parse;
Lexer.lex;
const clearDeepL = ()=>{
    document.querySelectorAll("deepl-inline-translate").forEach((item2)=>item2.remove());
};
const CUSTOM_CONTROL_CLASSNAMES = {
    [EVKVideoPlayerCustomControl.ADULT_CONTENT_SIGN]: "vkpl-adult-content-sign",
    [EVKVideoPlayerCustomControl.CLIP_BUTTON]: "vkpl-clip-button",
    [EVKVideoPlayerCustomControl.THEATRE_BUTTON]: "vkpl-theatre-button"
};
const CUSTOM_CONTROL_TOOLTIP_CLASSNAMES = {
    [EVKVideoPlayerCustomControl.ADULT_CONTENT_SIGN]: "vkpl-adult-content-sign-tooltip",
    [EVKVideoPlayerCustomControl.CLIP_BUTTON]: "vkpl-clip-button-tooltip",
    [EVKVideoPlayerCustomControl.THEATRE_BUTTON]: "vkpl-theatre-button-tooltip"
};
EVKVideoPlayerCustomControl.ADULT_CONTENT_SIGN, EVKVideoPlayerControl.W_MAX, EVKVideoPlayerCustomControl.THEATRE_BUTTON, EVKVideoPlayerControl.SETTINGS_BUTTON, EVKVideoPlayerCustomControl.CLIP_BUTTON, EVKVideoPlayerControl.SETTINGS_BUTTON;
const queryPlayerBySelector = (player, selector)=>{
    try {
        return player.playerContainer.querySelector(selector);
    } catch (ignore) {}
};
EVKVideoPlayerCustomControl.ADULT_CONTENT_SIGN, EVKVideoPlayerCustomControl.CLIP_BUTTON, EVKVideoPlayerControl.LIVE_BUTTON, EVKVideoPlayerControl.SETTINGS_BUTTON, EVKVideoPlayerCustomControl.THEATRE_BUTTON, EVKVideoPlayerControl.W_MAX, EVKVideoPlayerControl.TIMELINE;
EVKVideoPlayerCustomControl.ADULT_CONTENT_SIGN, EVKVideoPlayerCustomControl.CLIP_BUTTON, EVKVideoPlayerCustomControl.THEATRE_BUTTON;
const getClientIdCookies = ()=>{
    let clientId = getCookie(ECookieKey.CLIENT_ID);
    if (clientId == null) {
        clientId = v4();
        setCookie(ECookieKey.CLIENT_ID, clientId, {
            expires: new Date(Date.now() + 315360000000),
            domain: "*",
            path: "/"
        });
    }
    return clientId;
};
const _Api = class _Api {
    static setTransport(transport) {
        this.transport = transport;
    }
    static getTransport() {
        return this.transport;
    }
    static setContext(context) {
        this.context = context;
    }
    static getContext() {
        return this.context;
    }
};
_Api.context = EApiContext.STREAMS;
_Api.stat = new StatApi(_Api);
_Api.blog = new BlogApi(_Api);
_Api.stream = new StreamApi(_Api);
_Api.user = new UserApi(_Api);
_Api.base = new BaseApi(_Api);
let Api = _Api;
let authTokenData = null;
const resetAuthTokenData = ()=>{
    authTokenData = null;
};
const getAuthTokenData = ()=>authTokenData;
const setAuthTokenData = (data)=>{
    authTokenData = data;
};
const setAccessToken = (token2)=>{
    try {
        authTokenData = {
            ...authTokenData,
            ...token2
        };
    } catch (ignore) {
        console.log("token tried to set before init authTokenData structure");
    }
};
const restoreSession = async ()=>{
    const authData = getAuthTokenData();
    if (authData != null) try {
        const newToken = await Api.user.refreshToken(authData);
        setAccessToken({
            accessToken: newToken.data.access_token,
            refreshToken: newToken.data.refresh_token,
            expiresAt: newToken.data.expires_in
        });
        const newUser = await Api.user.fetchCurrent();
        return newUser.data;
    } catch (e2) {
        console.log("refresh auth token failure");
    }
    else console.log("No auth/refresh token");
    return null;
};
const actionCreator$19 = (0, $99y5v.actionCreatorFactory)("Agents");
const actionCreatorAsync$10 = (0, $7Uc0p.asyncFactory)(actionCreator$19);
const fetchAgents = actionCreatorAsync$10("fetchAgents", async ({ blogUrl })=>{
    const response = await Api$1.agents.fetchAgents(blogUrl);
    return response.data;
});
const unassignAgent = actionCreatorAsync$10("unassignAgent", async ({ blogUrl, userId })=>{
    await Api$1.agents.unassignAgent(blogUrl, userId);
});
const assignAgent = actionCreatorAsync$10("assignAgent", async ({ userId, blogUrl })=>{
    const response = await Api$1.agents.assignAgent(blogUrl, {
        agent_id: userId
    });
    return response.data;
});
const actionCreator$18 = (0, $99y5v.actionCreatorFactory)("ActivityFeed");
const actionCreatorAsync$$ = (0, $7Uc0p.asyncFactory)(actionCreator$18);
const fetchActivityJournal = actionCreatorAsync$$("fetchActivityJournal", async ({ blogUrl, types: types2 }, dispatch)=>{
    let response;
    if (types2.length) {
        const isAll = types2.length === Object.keys(EActionsJournalEventType).length;
        response = await Api$1.blog.fetchActionsJournal(blogUrl, isAll ? null : types2.join(","));
    } else response = {
        data: {
            data: {
                actionsJournal: {
                    updateTime: Date.now() / 1e3,
                    events: []
                }
            }
        }
    };
    dispatch(clearActivityFeedNewEvents());
    dispatch(setActivityNewEventsFilter({
        types: types2
    }));
    return response.data.data.actionsJournal;
});
const addActivityFeedNewEvent = actionCreator$18("addActivityFeedNewEvent");
const clearActivityFeedNewEvents = actionCreator$18("clearActivityFeedNewEvents");
const clearActivityJournal = actionCreator$18("clearActivityJournal");
const setActivityNewEventsFilter = actionCreator$18("setActivityNewEventsFilter");
const actionCreator$17 = (0, $99y5v.actionCreatorFactory)("BlackList");
const actionCreatorAsync$_ = (0, $7Uc0p.asyncFactory)(actionCreator$17);
const removeFromBlackList = actionCreatorAsync$_("removeFromBlackList", async ({ blogUrl, userId })=>{
    await Api$1.blackList.removeFromBlackList(blogUrl, userId);
});
actionCreatorAsync$_("putToBlackList", async ({ userId, blogUrl }, dispatch)=>{
    await Api$1.blackList.putToBlackList(blogUrl, userId);
});
const fetchBlackList = actionCreatorAsync$_("fetchBlackList", async ()=>{
    const response = await Api$1.blackList.fetchBlackList();
    return response.data.data;
});
const resetBlackList = actionCreator$17("resetBlackList");
const addToBlackListFromWS = actionCreator$17("addToBlackListFromWS");
const removeFromBlackListFromWS = actionCreator$17("removeFromBlackListFromWS");
const actionCreator$16 = (0, $99y5v.actionCreatorFactory)("Blog");
const actionCreatorAsync$Z = (0, $7Uc0p.asyncFactory)(actionCreator$16);
const fetchBlog = actionCreatorAsync$Z("fetchBlog", async ({ blogUrl })=>{
    const response = await Api$1.blog.fetch(blogUrl);
    return {
        blog: response.data
    };
});
const refetchBlog = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.blog.blog.meta.networkStatus.isFetched) return dispatch(fetchBlog.action({
            blogUrl: state.blog.blog.data.blogUrl
        }));
        else return null;
    };
const fetchFeed = actionCreatorAsync$Z("fetchFeed", async ({ blogUrl, limit, offset: offset2, filter, repliesLimit = getConfig().comments.feedRepliesLimit, commentsLimit = getConfig().comments.feedLimit })=>{
    const response = await Api$1.blog.fetchPosts(blogUrl, {
        limit: limit,
        offset: offset2,
        comments_limit: commentsLimit,
        reply_limit: repliesLimit,
        is_only_allowed: filter == null ? void 0 : filter.isOnlyAllowedPosts,
        from_ts: filter == null ? void 0 : filter.postsFrom,
        to_ts: filter == null ? void 0 : filter.postsTo,
        level_id: filter == null ? void 0 : filter.subscriptionLevelId,
        tags_ids: filter == null ? void 0 : filter.postsTagsIds
    });
    return {
        isLast: response.data.extra.isLast,
        offset: response.data.extra.offset,
        data: response.data.data
    };
});
const refetchFeed = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.blog.posts.meta.networkStatus.isFetched) return dispatch(fetchFeed.action({
            blogUrl: state.blog.blog.data.blogUrl,
            filter: {
                ...state.blog.posts.data.posts.length === 1 && {
                    postsFrom: state.blog.posts.data.posts[0].createdAt,
                    postsTo: state.blog.posts.data.posts[0].createdAt
                }
            },
            limit: state.blog.posts.data.posts.length,
            offset: null
        }));
        else return null;
    };
const actionCreator$15 = (0, $99y5v.actionCreatorFactory)("Stream");
const actionCreatorAsync$Y = (0, $7Uc0p.asyncFactory)(actionCreator$15);
const addNewStreamChatMessages = actionCreator$15("addNewStreamChatMessages");
const addStopWord = actionCreatorAsync$Y("addStopWord", async ({ blogUrl, word })=>{
    await Api$1.blogPostChat.addStopWord(blogUrl, {
        word: word
    });
    return {};
});
const addMentionedUser = actionCreator$15("addMentionedUser");
const fetchUserBanStat = actionCreatorAsync$Y("fetchUserBanStat", async ({ blogUrl, userId })=>{
    const { data } = await Api$1.blogPostChat.fetchBanStat(blogUrl, userId);
    return data;
});
const blockUserPermanently = actionCreatorAsync$Y("blockUserPermanently", async ({ blogUrl, slotUrl, userId }, dispatch)=>{
    await Api$1.blogPostChat.blockUser(blogUrl, slotUrl, {
        user_id: userId,
        is_permanent: true,
        by_stream: false,
        clean_messages: true
    });
    dispatch(fetchUserBanStat.action({
        blogUrl: blogUrl,
        userId: userId
    }));
    return {};
});
const TIMEOUT_PERIOD_IN_SECONDS = {
    [EStreamUserTimeoutOptions["10_MINUTES"]]: 600,
    [EStreamUserTimeoutOptions["1_HOUR"]]: 3600
};
const blockUserTemporarily = actionCreatorAsync$Y("blockUserTemporarily", async (params, dispatch)=>{
    const { blogUrl, slotUrl, userId, period } = params;
    let calculatedPeriod;
    let byStream;
    if (period === EStreamUserTimeoutOptions.UNTIL_STREAM_END) byStream = true;
    else {
        byStream = false;
        calculatedPeriod = TIMEOUT_PERIOD_IN_SECONDS[period];
    }
    await Api$1.blogPostChat.blockUser(blogUrl, slotUrl, {
        user_id: userId,
        period: calculatedPeriod,
        by_stream: byStream,
        is_permanent: false
    });
    dispatch(fetchUserBanStat.action({
        blogUrl: blogUrl,
        userId: userId
    }));
    return {};
});
const changeStreamOnlineStatus = actionCreator$15("changeStreamOnlineStatus");
const fetchAccessSelectorSubscriptionLevels = actionCreatorAsync$Y("fetchAccessSelectorSubscriptionLevels", debouncePromise(async ({ blogUrl })=>{
    const response = await Api$1.channel.fetchAccessSelectorSubscriptionLevels(blogUrl);
    return response.data.data;
}, 300));
const cleanStreamChatMentions = actionCreator$15("cleanStreamChatMentions");
const removeStreamChatMessagesByUserIdFromWS = actionCreator$15("removeStreamChatMessagesByUserIdFromWS");
const cleanStreamChatMessages = actionCreatorAsync$Y("cleanStreamChatMessages", async ({ blogUrl, userId }, dispatch)=>{
    await Api$1.blogPostChat.clean(blogUrl, userId);
    dispatch(removeStreamChatMessagesByUserIdFromWS({
        userId: userId
    }));
    return {};
});
actionCreatorAsync$Y("cleanAllStreamChatMessages", async ({ blogUrl })=>{
    const response = await Api$1.blogPostChat.cleanAll(blogUrl);
    return response.data.data;
});
const cleanStreamChatMessagesFromWS = actionCreator$15("cleanStreamChatMessagesFromWS");
const cleanStreamChatUserSearchList = actionCreator$15("cleanStreamChatUserSearchList");
const clearStreamChatSettings = actionCreator$15("clearStreamChatSettings");
const clearStream = actionCreator$15("clearStream");
const clearStreamStopWords = actionCreator$15("clearStreamStopWords");
const clearStreamChat = actionCreator$15("clearStreamChat");
const clearStreamChatThreadMessages = actionCreator$15("clearStreamChatThreadMessages");
actionCreatorAsync$Y("complainStream", async ({ blogUrl })=>{
    await Api$1.stream.complain(blogUrl);
    return {};
});
const createStream = actionCreatorAsync$Y("createStream", async ({ blogUrl, stream: stream2 })=>{
    const { teaserData, description: description2, publishTime: publishTime2, title: title2, subscriptionLevelId, daNick, categoryId } = stream2;
    const response = await Api$1.stream.create(blogUrl, {
        teaser_data: JSON.stringify(teaserData),
        description: JSON.stringify(description2),
        publish_time: publishTime2,
        title: title2,
        subscription_level_id: subscriptionLevelId,
        da_nick: daNick,
        category_id: categoryId
    });
    return response.data;
});
const fetchChatSettings = actionCreatorAsync$Y("fetchChatSettings", async (params)=>{
    const { blogUrl } = params;
    const { data: { data: { chatSettings } } } = await Api$1.blogPostChat.fetchSettings(blogUrl);
    return chatSettings;
});
const fetchStopWords = actionCreatorAsync$Y("fetchStopWords", async ({ blogUrl, limit, offset: offset2 })=>{
    const { data: { data, extra } } = await Api$1.blogPostChat.fetchStopWords(blogUrl, {
        limit: limit,
        offset: offset2
    });
    return {
        ...extra,
        data: data
    };
});
const fetchStream = actionCreatorAsync$Y("fetchStream", async (payload)=>{
    const { blogUrl, slotUrl, chatSettingsFromCookies, from: from2 } = payload;
    const response = await Api$1.stream.fetch({
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        from: from2
    });
    if (!Object.keys(response.data).length) return null;
    response.data.data.stream.chatSettings = {
        ...response.data.data.stream.chatSettings,
        ...chatSettingsFromCookies,
        mode: getIOModeStoreVariant(response.data.data.stream.chatSettings.mode)
    };
    return response.data.data.stream;
});
const fetchStreamCredentials = actionCreatorAsync$Y("fetchStreamCredentials", async ({ blogUrl, refresh = false, slotId })=>{
    const response = await Api$1.stream.fetchCredentials(blogUrl, refresh, slotId);
    return response.data;
});
const fetchStreamChat = actionCreatorAsync$Y("fetchStreamChat", async ({ blogUrl, limit, getAbort }, dispatch)=>{
    const { data: { extra: { banInfo: banInfo2, isBaned, ...restExtra }, data } } = await Api$1.blogPostChat.fetch(blogUrl, limit, getAbort);
    if (!isStreamApp()) {
        dispatch(cleanStreamChatMessagesFromWS());
        dispatch(cleanStreamChatMentions());
    }
    return {
        ...restExtra,
        banRemainingTime: banInfo2 == null ? void 0 : banInfo2.remainingTime,
        isBanned: isBaned,
        isBannedByStreamEnd: Boolean(banInfo2 == null ? void 0 : banInfo2.isByStream),
        data: data.reverse()
    };
});
const fetchStreamChatUsers = actionCreatorAsync$Y("fetchStreamChatUsers", async ({ blogUrl, searchQuery })=>{
    const response = await Api$1.blogPostChat.fetchChatUsers(blogUrl, searchQuery);
    return {
        data: response.data.data,
        searchQuery: searchQuery
    };
});
const streamChatUsersReset = actionCreator$15("streamChatUsersReset");
const fetchStreamChatUserStat = actionCreatorAsync$Y("fetchStreamChatUserStat", async ({ blogUrl, userId, context })=>{
    const response = await Api$1.blogPostChat.fetchChatUserStat(blogUrl, userId);
    return {
        ...response.data,
        context: context
    };
});
const streamChatUserStatReset = actionCreator$15("streamChatUserStatReset");
const REQUEST_LIMIT = 4;
const fetchChatUserSearchList = actionCreatorAsync$Y("fetchChatUserSearchList", async ({ blogUrl, searchQuery }, dispatch, getState)=>{
    dispatch(cleanStreamChatUserSearchList());
    if (!searchQuery) {
        const state = getState();
        const { user: { data: { id } } } = state.currentUser;
        const { data: { owner, users, moderators } } = await dispatch(fetchStreamChatUsers({
            blogUrl: blogUrl
        }));
        const res = [
            owner,
            ...moderators,
            ...users
        ].filter((user)=>user.id !== id).slice(0, REQUEST_LIMIT);
        return {
            data: {
                users: res
            }
        };
    } else {
        const { data } = await Api$1.blogPostChat.fetchChatUserSearchList(blogUrl, {
            limit: REQUEST_LIMIT,
            search_query: searchQuery
        });
        return data;
    }
});
const likeStream = actionCreatorAsync$Y("likeStream", async ({ blogUrl, slotUrl })=>{
    await Api$1.stream.like(blogUrl, slotUrl);
    return {};
});
const markStreamEnded = actionCreator$15("markStreamEnded");
actionCreatorAsync$Y("notifyStream", async ({ blogUrl })=>{
    await Api$1.stream.notify(blogUrl);
    return {};
});
actionCreatorAsync$Y("recordStream", async ({ blogUrl, willRecord })=>{
    await Api$1.stream.record(blogUrl, willRecord);
    return {
        on: willRecord
    };
});
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get2(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value2) {
            entry = {
                key: key,
                value: value2
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get2(key) {
        var cacheIndex = entries.findIndex(function(entry2) {
            return equals(key, entry2.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value2) {
        if (get2(key) === NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value2
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get2,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck2(a2, b2) {
    return a2 === b2;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next2) {
        if (prev === null || next2 === null || prev.length !== next2.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next2[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck2 = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized2() {
        var value2 = cache.get(arguments);
        if (value2 === NOT_FOUND) {
            value2 = func.apply(null, arguments);
            if (resultEqualityCheck2) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck2(entry.value, value2);
                });
                if (matchingEntry) value2 = matchingEntry.value;
            }
            cache.put(arguments, value2);
        }
        return value2;
    }
    memoized2.clearCache = function() {
        return cache.clear();
    };
    return memoized2;
}
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize2) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector2 = function createSelector3() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult;
        var directlyPassedOptions = {
            memoizeOptions: void 0
        };
        var resultFunc = funcs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2;
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize2.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions));
        var selector = memoize2(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)params.push(dependencies[i].apply(null, arguments));
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    };
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(defaultMemoize);
const blogPostFromPropsSelector = (state, props)=>(props == null ? void 0 : props.post) || null;
const commentFromPropsSelector = (state, props)=>(props == null ? void 0 : props.comment) || null;
const blogPostFetchNetworkStatusSelector = (state)=>state.blog.posts.meta.networkStatus;
const blogPostUpdateNetworkStatusSelector = (state)=>state.blog.posts.meta.updatePostNetworkStatus;
const blogPostRemoveNetworkStatusSelector = (state)=>state.blog.posts.meta.removePostNetworkStatus;
const blogPostCreateNetworkStatusSelector = (state)=>state.blog.posts.meta.createPostNetworkStatus;
createSelector(blogPostFetchNetworkStatusSelector, (networkStatus2)=>networkStatus2.isFetched);
createSelector(blogPostCreateNetworkStatusSelector, (networkStatus2)=>networkStatus2.isFetching);
createSelector([
    blogPostUpdateNetworkStatusSelector,
    blogPostRemoveNetworkStatusSelector
], (updateNS, removeNS)=>updateNS.isFetching || removeNS.isFetching);
const blogPostsSelector = (state)=>state.blog.posts.data;
createSelector(blogPostsSelector, (posts)=>posts != null && posts.posts.length > 0);
const blogSelector = (state)=>state.blog.blog.data;
const blogExternalSelector = (state)=>state.blog.blogExternal.data;
const blogExternalNetworkStatusSelector = (state)=>state.blog.blogExternal.meta.networkStatus;
const blogFollowNetworkStatusSelector = (state)=>state.blog.blog.meta.followNetworkStatus;
const blogUpdateNetworkStatusSelector = (state)=>state.blog.blog.meta.editNetworkStatus;
createSelector(blogSelector, (blog2)=>blog2 != null ? blog2.owner : null);
createSelector(blogExternalSelector, (blog2)=>blog2 != null ? blog2.owner : null);
createSelector(blogSelector, (blog2)=>blog2 != null ? blog2.owner.name : null);
createSelector(blogSelector, (blog2)=>blog2 != null ? blog2.owner.nick : null);
createSelector(blogSelector, (blog2)=>blog2 != null ? blog2.owner.id : null);
createSelector(blogSelector, (blog2)=>blog2 != null && blog2.category ? blog2.category.mnemonic : null);
createSelector(blogSelector, (blog2)=>blog2 != null ? blog2.thanksMsg : null);
createSelector(blogSelector, (blog2)=>blog2 != null && Boolean(blog2.coverUrl));
createSelector(blogSelector, (blog2)=>blog2 != null && blog2.channelCoverType);
createSelector(blogSelector, (blog2)=>blog2 != null && blog2.channelCoverImageUrl);
createSelector(blogSelector, (blog2)=>blog2 != null && !!blog2.title);
createSelector(blogUpdateNetworkStatusSelector, (networkStatus2)=>networkStatus2.isFetching);
const blogUrlSelector = createSelector(blogSelector, (blog2)=>blog2 != null && blog2.blogUrl);
createSelector(blogSelector, (blog2)=>blog2 && blog2.socialLinks.length > 0);
const blogHasSubscriptionLevelsSelector = createSelector(blogSelector, (blog2)=>blog2 != null && blog2.flags.hasSubscriptionLevels);
const blogExternalHasSubscriptionLevelsSelector = createSelector(blogExternalSelector, (blog2)=>blog2 != null && blog2.flags.hasSubscriptionLevels);
const blogIsOwnerSelector = createSelector(blogSelector, (blog2)=>blog2 != null && blog2.isOwner);
createSelector(blogSelector, (blog2)=>blog2 != null && Boolean(blog2.isBlackListed));
const blogIsBanned = (blog2)=>blog2 && (blog2.isReadOnly || blog2.isTotalBaned);
const blogIsBannedSelector = createSelector(blogSelector, blogIsBanned);
createSelector(blogSelector, (blog2)=>{
    var _a3;
    return blog2 != null && ((_a3 = blog2.flags) == null ? void 0 : _a3.isRssFeedEnabled);
});
createSelector(blogSelector, (blog2)=>blog2 != null && blog2.hasAdultContent);
createSelector(blogSelector, (blog2)=>{
    var _a3;
    return blog2 != null && ((_a3 = blog2.owner.streamerActivity) == null ? void 0 : _a3.level);
});
const ONLINE_RECOMMENDED_STREAMS_COUNT = 5;
const STATIC_OBJECT$2 = {};
const resultEqualityCheck = (a2, b2)=>{
    if (a2 === b2) return true;
    if (a2 && b2) return isEqual(a2, b2);
    return false;
};
const catalogSelector = (state)=>state.catalog;
const catalogRecommendedDataSelector = (state)=>{
    var _a3;
    return ((_a3 = state.catalog.recommendedStreams.data) == null ? void 0 : _a3.data) ?? STATIC_OBJECT$2;
};
const catalogSubscribedDataSelector = (state)=>{
    var _a3;
    return ((_a3 = state.catalog.subscribedStreams.data) == null ? void 0 : _a3.data) ?? STATIC_OBJECT$2;
};
const catalogRecommendedStreamsBlogUrlsSelector = createSelector(catalogSelector, (catalog2)=>{
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = catalog2.recommendedStreams.data) == null ? void 0 : _a3.blogUrls) == null ? void 0 : _b2.filter((blogUrl)=>{
        var _a4, _b3, _c3, _d;
        const channelSlots = (_b3 = (_a4 = catalog2.recommendedStreams.data) == null ? void 0 : _a4.data) == null ? void 0 : _b3[blogUrl];
        const stream2 = channelSlots && Object.values((_d = (_c3 = catalog2.recommendedStreams.data) == null ? void 0 : _c3.data) == null ? void 0 : _d[blogUrl]).reduce(getStreamWithMaximalOnline, null);
        return stream2.isOnline && !stream2.hostForStreamer;
    })) == null ? void 0 : _c2.slice(0, ONLINE_RECOMMENDED_STREAMS_COUNT);
}, {
    memoizeOptions: {
        resultEqualityCheck: resultEqualityCheck
    }
});
createSelector([
    (state)=>state.catalog,
    (state, blogUrl)=>blogUrl,
    (state, blogUrl, module2)=>module2
], (catalogStore, blogUrl, module2)=>{
    var _a3, _b2;
    const key = module2 === "recommended" ? "recommendedStreams" : "subscribedStreams";
    const channelSlots = (_b2 = (_a3 = catalogStore[key].data) == null ? void 0 : _a3.data) == null ? void 0 : _b2[blogUrl];
    const stream2 = channelSlots && Object.values(channelSlots).reduce(getStreamWithMaximalOnline, null);
    return stream2 || {};
}, {
    memoizeOptions: {
        resultEqualityCheck: resultEqualityCheck
    }
});
createSelector(catalogRecommendedStreamsBlogUrlsSelector, catalogRecommendedDataSelector, (blogUrls, data)=>{
    var _a3;
    return (_a3 = blogUrls == null ? void 0 : blogUrls.map((blogUrl)=>{
        var _a4, _b2;
        const channelSlots = data == null ? void 0 : data[blogUrl];
        const fistKey = channelSlots && Object.keys(channelSlots)[0];
        return (_b2 = (_a4 = data == null ? void 0 : data[blogUrl]) == null ? void 0 : _a4[fistKey]) == null ? void 0 : _b2.wsStreamChannel;
    })) == null ? void 0 : _a3.sort();
}, {
    memoizeOptions: {
        resultEqualityCheck: resultEqualityCheck
    }
});
const catalogSubscribedStreamsBlogUrlsSelector = createSelector(catalogSelector, (catalog2)=>{
    var _a3;
    return (_a3 = catalog2.subscribedStreams.data) == null ? void 0 : _a3.blogUrls;
}, {
    memoizeOptions: {
        resultEqualityCheck: resultEqualityCheck
    }
});
createSelector(catalogSubscribedStreamsBlogUrlsSelector, catalogSubscribedDataSelector, (blogUrls, data)=>{
    var _a3;
    return (_a3 = blogUrls == null ? void 0 : blogUrls.map((blogUrl)=>{
        var _a4, _b2;
        const channelSlots = data == null ? void 0 : data[blogUrl];
        const fistKey = channelSlots && Object.keys(channelSlots)[0];
        return (_b2 = (_a4 = data == null ? void 0 : data[blogUrl]) == null ? void 0 : _a4[fistKey]) == null ? void 0 : _b2.wsStreamChannel;
    })) == null ? void 0 : _a3.sort();
}, {
    memoizeOptions: {
        resultEqualityCheck: resultEqualityCheck
    }
});
const catalogSubscribedStreamsNetworkStatusSelector = (state)=>state.catalog.subscribedStreams.meta.networkStatus;
const catalogStreamsDataListSelector = (state)=>state.catalog.streams.data.list;
const getPaymentDefaultCurrency = (state)=>state.payment.currency.data.defaultCurrency;
const currentUserSelector = (state)=>{
    var _a3;
    return (_a3 = state.currentUser.user) == null ? void 0 : _a3.data;
};
const currentUserIdSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.currentUser.user) == null ? void 0 : _a3.data) == null ? void 0 : _b2.id;
};
const currentUserRecaptchaSelector = createSelector(currentUserSelector, (user)=>user == null ? void 0 : user.recaptcha.data);
createSelector(currentUserRecaptchaSelector, (recaptcha)=>recaptcha == null ? void 0 : recaptcha.success);
createSelector(currentUserSelector, (user)=>user == null ? void 0 : user.blogUrl);
createSelector(currentUserSelector, (user)=>user != null && user.hasAvatar);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.telegram && user.externalApps.telegram.hasAccount);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.telegram && user.externalApps.telegram.loginUrl);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.telegram && user.externalApps.telegram.username);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.discord && user.externalApps.discord.hasAccount);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.discord && user.externalApps.discord.username);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.discord && user.externalApps.discord.hasServer);
createSelector(currentUserSelector, (user)=>user != null && user.externalApps && user.externalApps.discord && user.externalApps.discord.serverName);
createSelector(currentUserSelector, (user)=>user != null && user.isTestUser);
const currentUserDefaultCurrencySelector = createSelector(currentUserSelector, getPaymentDefaultCurrency, (user, paymentCurrency)=>(user == null ? void 0 : user.defaultCurrency) || paymentCurrency);
createSelector((state)=>state.currentUser, currentUserDefaultCurrencySelector, (userStore, defaultCurrency)=>(userStore == null ? void 0 : userStore.selectedCurrency) || defaultCurrency);
createSelector(currentUserSelector, (user)=>user == null ? void 0 : user.receiveGiftSubscriptionsOnlyAsFollower);
const currentUserMarketingAlertsDataSelector = (state)=>{
    var _a3;
    return (_a3 = state.currentUser) == null ? void 0 : _a3.marketingAlerts.data;
};
createSelector(currentUserMarketingAlertsDataSelector, (alerts)=>{
    var _a3;
    return (_a3 = alerts == null ? void 0 : alerts.sort((a2, b2)=>(a2 == null ? void 0 : a2.id) < (b2 == null ? void 0 : b2.id) ? 1 : -1)) == null ? void 0 : _a3[0];
});
const currentUserHasWebpushPrompt = (state)=>{
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = state.currentUser) == null ? void 0 : _a3.user) == null ? void 0 : _b2.data) == null ? void 0 : _c2.flags.hasWebpushPrompt;
};
const currentUserManagedChannelsSelector = (state)=>{
    var _a3;
    return (_a3 = state.currentUser.user.data) == null ? void 0 : _a3.managedChannels;
};
const currentUserOwnerRoleSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.currentUser.user.data) == null ? void 0 : _a3.managedChannels) == null ? void 0 : _b2.find((channel2)=>channel2.moderatorRole === EModeratorRoles.OWNER);
};
const currentUserChannelAdminRoleSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.currentUser.user.data) == null ? void 0 : _a3.managedChannels) == null ? void 0 : _b2.find((channel2)=>channel2.moderatorRole === EModeratorRoles.CHANNEL_ADMIN);
};
const currentUserChannelModeratorRoleSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.currentUser.user.data) == null ? void 0 : _a3.managedChannels) == null ? void 0 : _b2.find((channel2)=>channel2.moderatorRole === EModeratorRoles.CHANNEL_MODERATOR);
};
const currentUserChannelChatModeratorRoleSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.currentUser.user.data) == null ? void 0 : _a3.managedChannels) == null ? void 0 : _b2.find((channel2)=>channel2.moderatorRole === EModeratorRoles.CHANNEL_CHAT_MODERATOR);
};
createSelector([
    currentUserOwnerRoleSelector,
    currentUserChannelAdminRoleSelector,
    currentUserChannelModeratorRoleSelector,
    currentUserChannelChatModeratorRoleSelector
], (owner, admin, moderator, chatModerator)=>{
    return owner || admin || moderator || chatModerator;
});
const currentUserExternalLinksSelector = (state)=>{
    var _a3;
    return (_a3 = state.currentUser) == null ? void 0 : _a3.externalLinks.data;
};
createSelector(currentUserExternalLinksSelector, (externalLinks)=>externalLinks == null ? void 0 : externalLinks.find((link2)=>link2.source === EExternalLinksSource.VK));
createSelector(currentUserExternalLinksSelector, (externalLinks)=>externalLinks == null ? void 0 : externalLinks.find((link2)=>link2.source === EExternalLinksSource.VKPLAY));
createSelector(currentUserSelector, (user)=>user == null ? void 0 : user.email);
createSelector(currentUserSelector, (user)=>{
    var _a3;
    return Boolean((user == null ? void 0 : user.email) && ((_a3 = user == null ? void 0 : user.emailConfirmed) == null ? void 0 : _a3.noSocial));
});
const currentBlogSmilesUserSetSelector = (state)=>state.smiles.currentBlogSmiles.data;
const currentBlogSmilesUserSetNetworkStatusSelector = (state)=>state.smiles.currentBlogSmiles.meta.networkStatus;
const currentBlogSmilesDataSelector = createSelector(currentBlogSmilesUserSetSelector, (data)=>data && data.find((item2)=>item2.type === ESmileUserSetType.CURRENT_BLOG));
const currentBlogFreeSubscriptionSmilesSelector = createSelector(currentBlogSmilesDataSelector, (data)=>data ? data.smiles.filter((smile2)=>{
        var _a3, _b2;
        return ((_b2 = (_a3 = smile2 == null ? void 0 : smile2.access) == null ? void 0 : _a3.subscriptionLevel) == null ? void 0 : _b2.price) === 0;
    }) : []);
const currentBlogSubscriptionSmilesSelector = createSelector([
    currentBlogSmilesDataSelector,
    (state, levelPrice)=>levelPrice
], (data, levelPrice)=>data ? data.smiles.filter((smile2)=>{
        var _a3, _b2;
        return ((_b2 = (_a3 = smile2 == null ? void 0 : smile2.access) == null ? void 0 : _a3.subscriptionLevel) == null ? void 0 : _b2.price) <= levelPrice;
    }) : []);
const smileDataSelector = (state)=>state.smiles.smileData.data;
const smileDataSelectorNetworkStatusSelector = (state)=>state.smiles.smileData.meta.networkStatus;
var ESourceTypes = /* @__PURE__ */ ((ESourceTypes2)=>{
    ESourceTypes2["TINY_MPEG"] = "tiny";
    ESourceTypes2["LOWEST_MPEG"] = "lowest";
    ESourceTypes2["LOW_MPEG"] = "low";
    ESourceTypes2["MEDIUM_MPEG"] = "medium";
    ESourceTypes2["HIGH_MPEG"] = "high";
    ESourceTypes2["FULL_HD_MPEG"] = "full_hd";
    ESourceTypes2["QUADHD_MPEG"] = "quad_hd";
    ESourceTypes2["ULTRAHD_MPEG"] = "ultra_hd";
    ESourceTypes2["DASH"] = "dash";
    ESourceTypes2["DASH_UNI"] = "dash_uni";
    ESourceTypes2["LIVE_DASH"] = "live_dash";
    ESourceTypes2["LIVE_PLAYBACK_DASH"] = "live_playback_dash";
    ESourceTypes2["HLS"] = "hls";
    ESourceTypes2["LIVE_HLS"] = "live_hls";
    ESourceTypes2["LIVE_PLAYBACK_HLS"] = "live_playback_hls";
    ESourceTypes2["LIVE_CMAF"] = "live_cmaf";
    ESourceTypes2["LIVE_ONDEMAND_HLS"] = "live_ondemand_hls";
    return ESourceTypes2;
})(ESourceTypes || {});
const innerPlainSwallowCheck = (a2, b2)=>{
    if (!isObject$2(a2) || !isObject$2(b2)) return a2 === b2;
    let isEqual2 = true;
    const aKeys = Object.keys(a2);
    const bKeys = Object.keys(b2);
    aKeys.forEach((key)=>{
        if (a2[key] !== b2[key]) isEqual2 = false;
    });
    return aKeys.length === bKeys.length && isEqual2;
};
const selectorOptions = {
    memoizeOptions: {
        resultEqualityCheck: innerPlainSwallowCheck
    }
};
const isNotStreamObjectEmpty = (stream2)=>{
    return Boolean(stream2) && Boolean(stream2.id);
};
const streamSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.stream) == null ? void 0 : _a3.data) == null ? void 0 : _b2.stream) ?? null;
};
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.isOnline);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.isSupportProgramMember);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.isEnded);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.id, selectorOptions);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.title);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.data);
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.isChatModerator);
createSelector(streamSelector, (stream2)=>Boolean(stream2));
const hasStreamAccessSelector = createSelector(streamSelector, (stream2)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = stream2 == null ? void 0 : stream2.accessRestrictions) == null ? void 0 : _a3.view) == null ? void 0 : _b2.allowed;
});
createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.streamSlot) == null ? void 0 : _a3.coverImageUrl;
});
const currentStreamSlotUrlSelector = createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.streamSlot) == null ? void 0 : _a3.slotUrl;
});
const streamerIdSelector = createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.user) == null ? void 0 : _a3.id;
});
const streamerNameSelector = createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.user) == null ? void 0 : _a3.nick;
});
const streamViewersSelector = createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.count) == null ? void 0 : _a3.viewers;
});
createSelector(streamSelector, (stream2)=>{
    var _a3;
    return (_a3 = stream2 == null ? void 0 : stream2.count) == null ? void 0 : _a3.likes;
});
const streamStaticFieldsSelector = createSelector(streamSelector, (stream2)=>{
    var _a3, _b2, _c2, _d, _e, _f, _g, _h;
    return isNotStreamObjectEmpty(stream2) ? {
        isOnline: stream2.isOnline,
        embedUrl: stream2.embedUrl,
        isEnded: Boolean(stream2.isEnded),
        streamerName: (_a3 = stream2.user) == null ? void 0 : _a3.nick,
        streamerId: (_b2 = stream2.user) == null ? void 0 : _b2.id,
        streamerAvatarUrl: (_c2 = stream2 == null ? void 0 : stream2.user) == null ? void 0 : _c2.avatarUrl,
        isStreamerVerified: (_d = stream2 == null ? void 0 : stream2.user) == null ? void 0 : _d.isVerifiedStreamer,
        hasAccess: stream2.hasAccess,
        endTime: stream2.endTime,
        startTime: stream2.startTime,
        isHidden: stream2.isHidden,
        daNick: stream2.daNick,
        donationUrl: stream2.donationUrl,
        id: stream2.id,
        previewUrl: stream2.previewUrl,
        hasStream: true,
        createdAt: stream2.createdAt,
        hasNeverStreamed: Boolean(!stream2.startTime && !stream2.endTime),
        streamHlsUrl: (_f = (_e = stream2.data[0]) == null ? void 0 : _e.sharedPlayerUrls.find((item2)=>item2.type === ESourceTypes.LIVE_ONDEMAND_HLS)) == null ? void 0 : _f.url,
        isViewAllowed: (_h = (_g = stream2.accessRestrictions) == null ? void 0 : _g.view) == null ? void 0 : _h.allowed,
        plannedAt: stream2.plannedAt
    } : {};
}, selectorOptions);
createSelector(streamSelector, (stream2)=>stream2 ? {
        isLiked: stream2.isLiked,
        title: stream2.title,
        titleData: stream2.titleData,
        isModerator: stream2.isChannelModerator
    } : {}, selectorOptions);
createSelector(streamSelector, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(stream2)=>{
    var _a3;
    return stream2 ? (_a3 = stream2 == null ? void 0 : stream2.data) == null ? void 0 : _a3[0] : {
        preview: "",
        vid: ""
    };
}, selectorOptions);
const streamSubscriptionLevelFieldSelector = createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.subscriptionLevel, selectorOptions);
const streamHostForStreamerSelector = createSelector(streamSelector, (stream2)=>{
    var _a3, _b2, _c2;
    return stream2 ? {
        isHostActive: Boolean(stream2.hostForStreamer),
        hostFor: (_b2 = (_a3 = stream2.hostForStreamer) == null ? void 0 : _a3.owner) == null ? void 0 : _b2.nick,
        hostUrl: (_c2 = stream2.hostForStreamer) == null ? void 0 : _c2.blogUrl
    } : {};
}, selectorOptions);
createSelector(streamSelector, (stream2)=>{
    var _a3, _b2, _c2, _d;
    return stream2 ? {
        isCategorySet: Boolean(stream2.category),
        categoryId: (_a3 = stream2.category) == null ? void 0 : _a3.id,
        categoryTitle: (_b2 = stream2.category) == null ? void 0 : _b2.title,
        categoryPlayGameUrl: (_c2 = stream2.category) == null ? void 0 : _c2.playGameUrl,
        categoryPlayGameUrlPixelCounter: (_d = stream2.category) == null ? void 0 : _d.showPlayGameUrl
    } : {};
}, selectorOptions);
createSelector(streamSelector, (stream2)=>{
    var _a3;
    return stream2 ? {
        isOnline: stream2.isOnline,
        isEnded: stream2.isEnded,
        streamerId: stream2.user.id,
        id: stream2.id,
        hasStream: true,
        hostForStreamer: Boolean((_a3 = stream2.hostForStreamer) == null ? void 0 : _a3.blogUrl)
    } : {};
}, selectorOptions);
const streamCurrentUserAccessSelector = createSelector(streamSelector, (stream2)=>{
    var _a3;
    return stream2 ? {
        isChannelModerator: stream2.isChannelModerator,
        /**
       * @deprecated
       */ isChatModerator: stream2.isChatModerator,
        streamerId: (_a3 = stream2.user) == null ? void 0 : _a3.id
    } : {};
}, selectorOptions);
const streamWsChannelsSelector = createSelector(streamSelector, (stream2)=>{
    var _a3, _b2, _c2, _d, _e, _f;
    const result2 = {
        wsStreamChannel: stream2 == null ? void 0 : stream2.wsStreamChannel,
        wsStreamSlotChannel: stream2 == null ? void 0 : stream2.wsStreamSlot,
        wsChatChannel: stream2 == null ? void 0 : stream2.wsChatChannel,
        wsStreamViewersChannel: stream2 == null ? void 0 : stream2.wsStreamViewersChannel,
        wsChatChannelPrivate: stream2 == null ? void 0 : stream2.wsChatChannelPrivate,
        wsStreamChannelPrivate: stream2 == null ? void 0 : stream2.wsStreamChannelPrivate,
        wsLimitedChatChannel: (_a3 = stream2 == null ? void 0 : stream2.wsLimitedChatChannel) == null ? void 0 : _a3.channel,
        wsLimitedChatChannelToken: (_b2 = stream2 == null ? void 0 : stream2.wsLimitedChatChannel) == null ? void 0 : _b2.token,
        wsLimitedChatChannelPrivate: (_c2 = stream2 == null ? void 0 : stream2.wsLimitedChatChannelPrivate) == null ? void 0 : _c2.channel,
        wsLimitedChatChannelPrivateToken: (_d = stream2 == null ? void 0 : stream2.wsLimitedChatChannelPrivate) == null ? void 0 : _d.token,
        wsLimitedChannel: (_e = stream2 == null ? void 0 : stream2.wsLimitedChannel) == null ? void 0 : _e.channel,
        wsLimitedChannelToken: (_f = stream2 == null ? void 0 : stream2.wsLimitedChannel) == null ? void 0 : _f.token
    };
    if (!stream2) return {};
    return result2;
}, selectorOptions);
const streamUserSelector = (state)=>{
    var _a3, _b2, _c2;
    return ((_c2 = (_b2 = (_a3 = state.stream.stream) == null ? void 0 : _a3.data) == null ? void 0 : _b2.stream) == null ? void 0 : _c2.user) ?? null;
};
const streamNetworkStatusSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.stream) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.networkStatus) ?? null;
};
createSelector([
    streamUserSelector,
    currentUserSelector
], (streamUser, currentUser2)=>(currentUser2 == null ? void 0 : currentUser2.id) === (streamUser == null ? void 0 : streamUser.id));
createSelector(streamSelector, (stream2)=>stream2 == null ? void 0 : stream2.isChatModerator);
const currentUserIsAuthorized = (currentUser2)=>!!currentUser2;
const currentUserIsAuthorizedSelector = createSelector(currentUserSelector, currentUserIsAuthorized);
const currentUserCanViewBlog = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canView);
};
const currentUserIsBlackListed = (blog2)=>blog2 == null ? void 0 : blog2.isBlackListed;
const currentUserCanViewBlogSelector = createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanViewBlog);
const currentUserCanEditBlog = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canEdit);
};
const currentUserCanEditBlogSelector = createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanEditBlog);
const currentUserCanCreateBlog = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && Boolean((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canCreate);
};
createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanCreateBlog);
const currentUserCanCreateBlogComments = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && Boolean((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canCreateComments);
};
const currentUserCanCreateBlogCommentsSelector = createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanCreateBlogComments);
const currentUserCanDeleteBlogComments = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canDeleteComments);
};
const currentUserCanDeleteBlogCommentsSelector = createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanDeleteBlogComments);
const currentUserCanSetBlogPayout = (blog2, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canSetPayout);
};
const currentUserCanSetBlogPayoutSelector = createSelector(blogSelector, currentUserIsAuthorizedSelector, currentUserCanSetBlogPayout);
const currentUserIsStreamer = (user, isAuthorized)=>isAuthorized && user.isStreamer;
createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsStreamer);
const currentUserIsAdmin = (user, isAuthorized)=>isAuthorized && (user == null ? void 0 : user.isAdmin);
const currentUserIsAdminSelector = createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsAdmin);
const currentUserIsModerator = (user, isAuthorized)=>isAuthorized && user.isModerator;
const currentUserIsModeratorSelector = createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsModerator);
const currentUserIsCrmManager = (user, isAuthorized)=>isAuthorized && user.isCrmManager;
createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsCrmManager);
const currentUserIsBanned = (user, isAuthorized)=>isAuthorized && ((user == null ? void 0 : user.isReadOnly) || (user == null ? void 0 : user.isTotalBaned));
const currentUserIsBannedSelector = createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsBanned);
const currentUserIsBlackListedSelector = createSelector(blogSelector, currentUserIsBlackListed);
const currentUserIsBannedCompletely = (user, isAuthorized)=>isAuthorized && Boolean(user == null ? void 0 : user.isTotalBaned);
const currentUserIsBannedCompletelySelector = createSelector(currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsBannedCompletely);
const currentUserIsBlogOwner = (blog2, user, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((blog2 == null ? void 0 : blog2.isOwner) || ((_a3 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _a3.id) === user.id);
};
const currentUserIsChannelOwner = (currentUser2, blogUrl)=>{
    var _a3, _b2;
    return (currentUser2 == null ? void 0 : currentUser2.blogUrl) === blogUrl || ((_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _b2.accessRole) === EAccessRole.OWNER;
};
const currentUserIsExternalBlogOwner = (blog2, user, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((blog2 == null ? void 0 : blog2.isOwner) || ((_a3 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _a3.id) === user.id);
};
const currentUserIsBlogOwnerSelector = createSelector(blogSelector, currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsBlogOwner);
const currentUserIsBlogOwnerAgent = (canEditBlog, canSetBlogPayout, isAdmin, isBannedCompletely)=>canEditBlog && !canSetBlogPayout && !isAdmin && !isBannedCompletely;
const currentUserIsBlogOwnerAgentSelector = createSelector(currentUserCanEditBlogSelector, currentUserCanSetBlogPayoutSelector, currentUserIsAdminSelector, currentUserIsBannedCompletelySelector, currentUserIsBlogOwnerAgent);
const currentUserIsStreamOwner = (stream2, user, isAuthorized)=>isAuthorized && (stream2 == null ? void 0 : stream2.streamerId) === user.id;
createSelector(streamCurrentUserAccessSelector, currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsStreamOwner);
const currentUserHasChannelAdminRole = (currentUser2, blogUrl)=>{
    var _a3, _b2, _c2, _d;
    return ((_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _b2.moderatorRole) === EModeratorRoles.CHANNEL_ADMIN || ((_d = (_c2 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _c2.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _d.accessRole) === EAccessRole.OWNER;
};
const currentUserHasChannelModeratorRole = (currentUser2, blogUrl)=>{
    var _a3, _b2, _c2, _d;
    return ((_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _b2.moderatorRole) === EModeratorRoles.CHANNEL_MODERATOR || ((_d = (_c2 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _c2.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _d.accessRole) === EAccessRole.OWNER;
};
const currentUserHasChannelChatModeratorRole = (currentUser2, blogUrl)=>{
    var _a3, _b2, _c2, _d;
    return ((_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _b2.moderatorRole) === EModeratorRoles.CHANNEL_CHAT_MODERATOR || ((_d = (_c2 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _c2.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _d.accessRole) === EAccessRole.OWNER;
};
const currentUserIsChatModerator = (stream2, isAuthorized)=>isAuthorized && (stream2 == null ? void 0 : stream2.isChatModerator);
const currentUserIsSmileOwner = (smileData, user, isAuthorized)=>{
    var _a3;
    return isAuthorized && ((_a3 = smileData == null ? void 0 : smileData.ownerInfo) == null ? void 0 : _a3.blog.owner.id) === user.id;
};
createSelector(smileDataSelector, currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsSmileOwner);
const currentUserIsPostConsumer = (post, isAuthorized)=>isAuthorized && !!(post == null ? void 0 : post.hasAccess);
const getCurrentUserIsPostConsumerSelector = ()=>createSelector(blogPostFromPropsSelector, currentUserIsAuthorizedSelector, currentUserIsPostConsumer);
const currentUserIsPostCommentsEnabled = (post, isAuthorized)=>isAuthorized && post && !post.isCommentsDenied;
const getCurrentUserIsPostCommentsEnabledSelector = ()=>createSelector(blogPostFromPropsSelector, currentUserIsAuthorizedSelector, currentUserIsPostCommentsEnabled);
const currentUserIsCommentAuthor = (comment, blog2, user, isAuthorized, isOwnerAgent)=>{
    var _a3, _b2, _c2;
    return isAuthorized && (user.id === ((_a3 = comment == null ? void 0 : comment.author) == null ? void 0 : _a3.id) || isOwnerAgent && ((_b2 = comment == null ? void 0 : comment.author) == null ? void 0 : _b2.id) === ((_c2 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _c2.id));
};
const getCurrentUserIsCommentAuthorSelector = ()=>createSelector(commentFromPropsSelector, blogSelector, currentUserSelector, currentUserIsAuthorizedSelector, currentUserIsBlogOwnerAgentSelector, currentUserIsCommentAuthor);
const currentUserCanReportBlog = (isAuthorized, isOwner, isOwnerAgent)=>isAuthorized && !isOwner && !isOwnerAgent;
createSelector(currentUserIsAuthorizedSelector, currentUserIsBlogOwnerSelector, currentUserIsBlogOwnerAgentSelector, currentUserCanReportBlog);
const currentUserCanFollowBlog = (isOwner, isOwnerAgent)=>!isOwner && !isOwnerAgent;
createSelector(currentUserIsBlogOwnerSelector, currentUserIsBlogOwnerAgentSelector, currentUserCanFollowBlog);
const currentUserCanViewPost = (isPostConsumer, canViewBlog)=>isPostConsumer || canViewBlog;
const currentUserCanLikePost = (isPostConsumer, isBanned)=>isPostConsumer && !isBanned;
const currentUserCanReactionPost = (isPostConsumer, isBanned)=>isPostConsumer && !isBanned;
const currentUserCanReportPost = (isPostConsumer, isOwner, isOwnerAgent)=>isPostConsumer && !(isOwner || isOwnerAgent);
const currentUserCanModerateChannel = (currentUser2, blogUrl)=>{
    var _a3;
    const channel2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl);
    return (channel2 == null ? void 0 : channel2.moderatorRole) === EModeratorRoles.CHANNEL_ADMIN || (channel2 == null ? void 0 : channel2.moderatorRole) === EModeratorRoles.CHANNEL_MODERATOR || (channel2 == null ? void 0 : channel2.accessRole) === EAccessRole.OWNER || (currentUser2 == null ? void 0 : currentUser2.blogUrl) === blogUrl;
};
const currentUserCanModerateChatChannel = (currentUser2, blogUrl)=>{
    var _a3;
    const channel2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl);
    return (channel2 == null ? void 0 : channel2.moderatorRole) === EModeratorRoles.CHANNEL_ADMIN || (channel2 == null ? void 0 : channel2.moderatorRole) === EModeratorRoles.CHANNEL_MODERATOR || (channel2 == null ? void 0 : channel2.moderatorRole) === EModeratorRoles.CHANNEL_CHAT_MODERATOR || (channel2 == null ? void 0 : channel2.accessRole) === EAccessRole.OWNER || (currentUser2 == null ? void 0 : currentUser2.blogUrl) === blogUrl;
};
const currentUserCanAdministrateChannel = (currentUser2, blogUrl)=>{
    var _a3, _b2, _c2, _d;
    return ((_b2 = (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _b2.moderatorRole) === EModeratorRoles.CHANNEL_ADMIN || ((_d = (_c2 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _c2.find((item2)=>item2.channelUrl === blogUrl)) == null ? void 0 : _d.accessRole) === EAccessRole.OWNER || (currentUser2 == null ? void 0 : currentUser2.blogUrl) === blogUrl;
};
const currentUserCanChangeChannel = (currentUser2, blogUrl)=>{
    var _a3;
    return Boolean((_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.find((item2)=>item2.channelUrl === blogUrl)) || (currentUser2 == null ? void 0 : currentUser2.blogUrl) === blogUrl;
};
const currentUserCanModerateSomeChannels = (currentUser2)=>{
    var _a3;
    return (_a3 = currentUser2 == null ? void 0 : currentUser2.managedChannels) == null ? void 0 : _a3.some((channel2)=>currentUserCanModerateChannel(currentUser2, channel2.channelUrl));
};
const currentUserCanPublishComment = (isBlogBanned, isPostConsumer, isPostCommentsEnabled, isOwner, isOwnerAgent, isBanned, isBannedCompletely, canCreateBlogComments, isBlackListed)=>(!isOwner && !isOwnerAgent && canCreateBlogComments || (isOwner || isOwnerAgent && !isBlogBanned) && !isBanned || isPostConsumer && !isBanned && isPostCommentsEnabled) && !isBlackListed;
const currentUserCanEditComment = (isCommentAuthor, canPublishComment)=>isCommentAuthor && canPublishComment;
const currentUserCanRemoveComment = (isCommentAuthor, canDeleteBlogComments)=>isCommentAuthor || canDeleteBlogComments;
const currentUserCanReactionComment = (canViewPost, isBanned)=>canViewPost && !isBanned;
const currentUserCanReplyComment = (canViewPost, canPublishComment)=>canViewPost && canPublishComment;
const currentUserCanReportComment = (canViewPost, isCommentAuthor)=>canViewPost && !isCommentAuthor;
const currentUserCanBlockCommentAuthor = (isOwner, _isOwnerAgent, isCommentAuthor)=>isOwner && !isCommentAuthor;
const isPostConsumerSelector = getCurrentUserIsPostConsumerSelector();
const isPostCommentsEnabledSelector = getCurrentUserIsPostCommentsEnabledSelector();
const isCommentAuthorSelector = getCurrentUserIsCommentAuthorSelector();
const canViewPostSelector = createSelector(isPostConsumerSelector, currentUserCanViewBlogSelector, currentUserCanViewPost);
createSelector(isPostConsumerSelector, currentUserIsBannedSelector, currentUserCanLikePost);
createSelector(isPostConsumerSelector, currentUserIsBannedSelector, currentUserCanReactionPost);
createSelector(isPostConsumerSelector, currentUserIsBlogOwnerSelector, currentUserIsBlogOwnerAgentSelector, currentUserCanReportPost);
const canPublishCommentSelector = createSelector(blogIsBannedSelector, isPostConsumerSelector, isPostCommentsEnabledSelector, currentUserIsBlogOwnerSelector, currentUserIsBlogOwnerAgentSelector, currentUserIsBannedSelector, currentUserIsBannedCompletelySelector, currentUserCanCreateBlogCommentsSelector, currentUserIsBlackListedSelector, currentUserCanPublishComment);
createSelector(isCommentAuthorSelector, canPublishCommentSelector, currentUserCanEditComment);
createSelector(isCommentAuthorSelector, currentUserCanDeleteBlogCommentsSelector, currentUserCanRemoveComment);
createSelector(canViewPostSelector, currentUserIsBannedSelector, currentUserCanReactionComment);
createSelector(canViewPostSelector, currentUserIsBlackListedSelector, currentUserCanReplyComment);
createSelector(canViewPostSelector, isCommentAuthorSelector, currentUserCanReportComment);
createSelector(currentUserIsBlogOwnerSelector, currentUserIsBlogOwnerAgentSelector, isCommentAuthorSelector, currentUserCanBlockCommentAuthor);
const globalBlogUrlSelector = (store2)=>{
    var _a3;
    return ((_a3 = store2.globalData) == null ? void 0 : _a3.blogUrl) ?? null;
};
const globalslotUrlSelector = (store2)=>store2.globalData.slotUrl ?? null;
const getRouterParams = (_2, props)=>{
    return props.match ? props.match.params : {};
};
const getStreamByBlogUrl = (streams, blogUrl)=>{
    return streams.find((stream2)=>blogUrl === getBlogUrlFromStream(stream2));
};
const blogUrlFromPropsSelector$2 = (state, props)=>(props == null ? void 0 : props.blogUrl) || null;
const overallStreamsSelector = createSelector(catalogStreamsDataListSelector, streamSelector, (catalogList, currentStream)=>[
        currentStream,
        ...catalogList || []
    ].filter(Boolean));
createSelector(blogUrlFromPropsSelector$2, streamSelector, overallStreamsSelector, (blogUrl, currentStream, streams)=>blogUrl ? getStreamByBlogUrl(streams, blogUrl) : currentStream);
const schemasListSelector = (state)=>state.schemas.list;
createSelector(schemasListSelector, (schemas2)=>{
    const schemasKeys = Object.keys(schemas2);
    return schemasKeys == null ? void 0 : schemasKeys.reduce((acc, key)=>{
        var _a3;
        if ((_a3 = schemas2 == null ? void 0 : schemas2[key]) == null ? void 0 : _a3.data) acc.push(...schemas2[key].data);
        return acc;
    }, []);
});
createSelector(schemasListSelector, (schemas2)=>{
    const schemasKeys = Object.keys(schemas2);
    if (!schemasKeys || (schemasKeys == null ? void 0 : schemasKeys.length) === 0) return false;
    return schemasKeys == null ? void 0 : schemasKeys.reduce((acc, key)=>{
        var _a3, _b2, _c2;
        if (!((_c2 = (_b2 = (_a3 = schemas2 == null ? void 0 : schemas2[key]) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.networkStatus) == null ? void 0 : _c2.isFetched)) acc = false;
        return acc;
    }, true);
});
const streamUsersNetworkStatusSelector = (state)=>state.stream.streamUsers.meta.networkStatus;
createSelector(streamUsersNetworkStatusSelector, (networkStatus2)=>networkStatus2.isFetched);
createSelector(streamUsersNetworkStatusSelector, (networkStatus2)=>!networkStatus2.isFetched);
const streamChatUsersSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.streamChatUsers) == null ? void 0 : _a3.data) == null ? void 0 : _b2.data) ?? null;
};
const streamChatUsersSearchQuerySelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.streamChatUsers) == null ? void 0 : _a3.data) == null ? void 0 : _b2.searchQuery) ?? null;
};
const streamChatUsersNetworkStatusSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.streamChatUsers) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.networkStatus) ?? null;
};
const streamChatUserStatSelector = (state)=>state.stream.streamChatUserStat.data;
const streamChatUserStatNetworkStatusSelector = (state)=>state.stream.streamChatUserStat.meta.networkStatus;
const streamChatThreadMainMessageSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.stream.streamChatThreadMessages.data) == null ? void 0 : _a3.data) == null ? void 0 : _b2.mainMessage;
};
const streamChatThreadRepliesSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.stream.streamChatThreadMessages.data) == null ? void 0 : _a3.data) == null ? void 0 : _b2.replies;
};
const streamChatThreadMessagesNetworkStatusSelector = (state)=>state.stream.streamChatThreadMessages.meta.networkStatus;
const subscriptionsSelector = (state)=>state.subscriptions.subscriptions.data || [];
createSelector(subscriptionsSelector, (arr)=>arr.reduce((res, item2)=>res.some((otherItem)=>item2.ownerId === otherItem.ownerId) ? res : [
            ...res,
            item2
        ], []));
const subscriptionLevelSelector = (state)=>state.subscriptions.subscriptionLevel.data;
const locales$1N = {
    freeLevelName: "\u041F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A"
};
const t$1O = distExports$1.getTranslation && locales$1N;
const subscriptionLevelsDataSelector = (state)=>state.subscriptions.subscriptionLevels.data;
createSelector(subscriptionLevelsDataSelector, (data)=>{
    const currentLevelId = data == null ? void 0 : data.currentLevelId;
    const levels = data == null ? void 0 : data.levels;
    const currentLevel = levels == null ? void 0 : levels.find((item2)=>item2.id === currentLevelId);
    return (currentLevel == null ? void 0 : currentLevel.price) > 0 ? currentLevel : null;
});
createSelector(subscriptionLevelsDataSelector, (data)=>data == null ? void 0 : data.blogUrl);
const subscriptionLevelsCurrentIdSelector = createSelector(subscriptionLevelsDataSelector, (data)=>data == null ? void 0 : data.currentLevelId);
const subscriptionLevelsNextIdSelector = createSelector(subscriptionLevelsDataSelector, (data)=>data == null ? void 0 : data.nextLevelId);
const subscriptionLevelsUserSubscriptionsSelector = createSelector(subscriptionLevelsDataSelector, (data)=>(data == null ? void 0 : data.subscriptions) || []);
createSelector(subscriptionLevelsDataSelector, (data)=>(data == null ? void 0 : data.levels) || []);
const subscriptionLevelsAllSelector = createSelector([
    subscriptionLevelsDataSelector,
    subscriptionLevelsCurrentIdSelector,
    subscriptionLevelsNextIdSelector,
    subscriptionLevelsUserSubscriptionsSelector
], (data, currentLevelId, nextLevelId, subscriptions2)=>{
    if (!data) return [];
    return data.levels.map((level)=>level.price === 0 ? {
            ...level,
            name: t$1O.freeLevelName
        } : level).map((item2)=>{
        const subscription2 = subscriptions2.find((s2)=>s2.levelId === item2.id) || {
            levelId: item2.id,
            offTime: null,
            nextPayTime: null,
            customPrice: null
        };
        return {
            ...item2,
            ...subscription2,
            isCurrent: item2.id === currentLevelId,
            isNext: item2.id === nextLevelId
        };
    });
});
const subscriptionLevelsSelector = createSelector(subscriptionLevelsAllSelector, (levels)=>levels.filter((level)=>!level.deleted && level.price > 0));
const subscriptionLevelsWithFreeSelector = createSelector([
    subscriptionLevelsAllSelector,
    subscriptionLevelsCurrentIdSelector
], (levels)=>levels.filter((level)=>!level.deleted));
createSelector([
    subscriptionLevelsWithFreeSelector,
    subscriptionLevelSelector
], (levels, subscriptionLevel)=>levels.filter((level)=>subscriptionLevel && subscriptionLevel.id !== level.id && level.price > 0));
createSelector(subscriptionLevelsAllSelector, (levels)=>{
    const filteredLevels = levels.filter((level)=>!level.deleted && level.price > 0);
    return filteredLevels && filteredLevels[0];
});
createSelector(subscriptionLevelsDataSelector, (data)=>data != null && data.levels && data.levels.length > 1);
const currentLevelSelector = createSelector(subscriptionLevelsAllSelector, (subscriptions2)=>{
    return subscriptions2.find((item2)=>item2.isCurrent) || null;
});
createSelector(subscriptionLevelsAllSelector, (subscriptions2)=>subscriptions2.find((item2)=>item2.isNext) || null);
createSelector([
    subscriptionLevelsAllSelector,
    getRouterParams
], (levels, routerParams)=>levels.find((item2)=>item2.id === Number(routerParams.levelId)) || null);
createSelector(currentLevelSelector, (currentLevel)=>currentLevel && currentLevel.externalApps.telegram.isConfigured);
createSelector(currentLevelSelector, (currentLevel)=>currentLevel && currentLevel.externalApps.discord.isConfigured);
const isFreeSubscriptionSelector = createSelector(blogSelector, (blog2)=>Boolean((blog2 == null ? void 0 : blog2.isSubscribed) && (blog2 == null ? void 0 : blog2.subscriptionKind) === ESubscriptionKind.FREE));
const isPaidSubscriptionSelector = createSelector(blogSelector, (blog2)=>Boolean((blog2 == null ? void 0 : blog2.isSubscribed) && (blog2 == null ? void 0 : blog2.subscriptionKind) === ESubscriptionKind.PAID));
createSelector(blogSelector, (blog2)=>Boolean(blog2 == null ? void 0 : blog2.notifySubscription));
createSelector(blogExternalSelector, (blog2)=>Boolean(blog2 == null ? void 0 : blog2.notifySubscription));
const t$1N = distExports$1.getTranslation && locales$1N;
const subscriptionLevelsExternalBlogDataSelector = (state)=>state.subscriptions.subscriptionLevelsExternalBlog.data;
const subscriptionLevelsExternalBlogNetworkStatusSelector = (state)=>state.subscriptions.subscriptionLevelsExternalBlog.meta.networkStatus;
createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>{
    const currentLevelId = data == null ? void 0 : data.currentLevelId;
    const levels = data == null ? void 0 : data.levels;
    const currentLevel = levels == null ? void 0 : levels.find((item2)=>item2.id === currentLevelId);
    return (currentLevel == null ? void 0 : currentLevel.price) > 0 ? currentLevel : null;
});
createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>data == null ? void 0 : data.blogUrl);
const subscriptionLevelsCurrentIdExternalBlogSelector = createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>data == null ? void 0 : data.currentLevelId);
const subscriptionLevelsNextIdExternalBlogSelector = createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>data == null ? void 0 : data.nextLevelId);
const subscriptionLevelsUserSubscriptionsExternalBlogSelector = createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>(data == null ? void 0 : data.subscriptions) || []);
createSelector(subscriptionLevelsExternalBlogDataSelector, (data)=>(data == null ? void 0 : data.levels) || []);
const subscriptionLevelsAllExternalBlogSelector = createSelector([
    subscriptionLevelsExternalBlogDataSelector,
    subscriptionLevelsCurrentIdExternalBlogSelector,
    subscriptionLevelsNextIdExternalBlogSelector,
    subscriptionLevelsUserSubscriptionsExternalBlogSelector
], (data, currentLevelId, nextLevelId, subscriptions2)=>{
    if (!data) return [];
    return data.levels.map((level)=>level.price === 0 ? {
            ...level,
            name: t$1N.freeLevelName
        } : level).map((item2)=>{
        const subscription2 = subscriptions2.find((s2)=>s2.levelId === item2.id) || {
            levelId: item2.id,
            offTime: null,
            nextPayTime: null,
            customPrice: null
        };
        return {
            ...item2,
            ...subscription2,
            isCurrent: item2.id === currentLevelId,
            isNext: item2.id === nextLevelId
        };
    });
});
const subscriptionLevelsExternalBlogSelector = createSelector(subscriptionLevelsAllExternalBlogSelector, (levels)=>levels.filter((level)=>!level.deleted && level.price > 0));
createSelector([
    subscriptionLevelsAllExternalBlogSelector,
    subscriptionLevelsCurrentIdExternalBlogSelector
], (levels)=>levels.filter((level)=>!level.deleted));
createSelector(subscriptionLevelsAllExternalBlogSelector, (levels)=>{
    const filteredLevels = levels.filter((level)=>!level.deleted && level.price > 0);
    return filteredLevels && filteredLevels[0];
});
const currentLevelExternalBlogSelector = createSelector(subscriptionLevelsAllExternalBlogSelector, (subscriptions2)=>{
    return subscriptions2.find((item2)=>item2.isCurrent) || null;
});
const isPaidSubscriptionExternalBlogSelector = createSelector(blogExternalSelector, subscriptionLevelsExternalBlogSelector, (blog2, subscriptionLevels)=>(blog2 == null ? void 0 : blog2.isSubscribed) && subscriptionLevels.some((level)=>level.isCurrent && level.price > 0));
const mediaDataUploadsSelector = (state)=>state.mediaData.uploads;
const pollIdFromPropsSelector = (state, props)=>(props == null ? void 0 : props.pollId) || null;
const pollsNetworkStatusSelector = (state)=>state.blog.posts.meta.pollsNetworkStatus;
createSelector(pollsNetworkStatusSelector, pollIdFromPropsSelector, (data, pollId)=>data.polls[pollId]);
createSelector(pollsNetworkStatusSelector, pollIdFromPropsSelector, (data, pollId)=>data.votes[pollId]);
const streamRaidSelector = (state)=>state.stream.streamRaid;
const streamRaidStatusSelector = (state)=>state.stream.streamRaid.status;
const streamRaidSelectorLoaded = (state)=>state.stream.streamRaidLoaded;
const STREAM_CHAT_MESSAGES_STATIC_ARRAY = [];
const STREAM_CHAT_MESSAGES_FROM_WS_STATIC_ARRAY = [];
const streamChatSelector = (state)=>state.stream.streamChat.data;
const streamChatModeSelector = (state)=>state.stream.streamChat.data.streamChatMode;
const streamChatSettingsSelector = (state)=>state.stream.streamChat.data.chatSettings;
const streamChatIsDropInstructionSelector = (state)=>state.stream.streamChat.data.isDropInstruction;
const streamChatMessagesSelector = createSelector(streamChatSelector, (streamChat)=>streamChat.data || STREAM_CHAT_MESSAGES_STATIC_ARRAY);
const streamChatMessagesFromWSSelector = (state)=>state.stream.streamChatFromWebSocket || STREAM_CHAT_MESSAGES_FROM_WS_STATIC_ARRAY;
const streamChatCurrentUserMessagesSelector = createSelector(streamChatMessagesSelector, streamChatMessagesFromWSSelector, currentUserIdSelector, (streamChatMessages, streamChatFromWebSocket, currentUserId)=>streamChatMessages.concat(streamChatFromWebSocket).filter((item2)=>{
        var _a3;
        return ((_a3 = item2 == null ? void 0 : item2.author) == null ? void 0 : _a3.id) === currentUserId;
    }), {
    memoizeOptions: {
        resultEqualityCheck: (a2, b2)=>{
            const aLastIndex = ((a2 == null ? void 0 : a2.length) || 1) - 1;
            const bLastIndex = ((b2 == null ? void 0 : b2.length) || 1) - 1;
            return (a2 == null ? void 0 : a2.length) === (b2 == null ? void 0 : b2.length) && (a2 == null ? void 0 : a2[0]) === (b2 == null ? void 0 : b2[0]) && (a2 == null ? void 0 : a2[aLastIndex]) === (b2 == null ? void 0 : b2[bLastIndex]);
        }
    }
});
const streamChatExtraSelector = createSelector(streamChatSelector, (streamChat)=>({
        banRemainingTime: streamChat.banRemainingTime,
        isBanned: streamChat.isBanned,
        isBannedByStreamEnd: streamChat.isBannedByStreamEnd,
        isLast: streamChat.isLast,
        offset: streamChat.offset
    }), selectorOptions);
const streamChatUserSearchListSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.stream.streamChatUserSearchList) == null ? void 0 : _a3.data) == null ? void 0 : _b2.users) ?? null;
};
const activeIndexPopoverSelector = (state)=>{
    var _a3;
    return ((_a3 = state.stream.streamChatUserSearchList) == null ? void 0 : _a3.data.activeIndexPopover) ?? 0;
};
const targetsSelector = (state)=>state.target.targets.data;
createSelector(targetsSelector, (data)=>data && data.length > 0);
const streamChatMentionsSelector = (state)=>state.stream.streamChatMentions;
const hasStreamChatMentionsSelector = createSelector(streamChatMentionsSelector, (mentions)=>Boolean(mentions.length));
const streamChatCurrentUserMentionMessagesSelector = defaultMemoize((state)=>{
    const currentUser2 = state.currentUser.user.data;
    if (currentUser2) return state.stream.streamChatMentions.filter((message2)=>isChatUserMessage(message2) && currentUser2.id !== message2.author.id);
    return [];
}, (previousVal, currentVal)=>{
    return currentVal.length === previousVal.length;
});
const rolesSelector = (state)=>{
    var _a3;
    return (_a3 = state.roles.roles.data) == null ? void 0 : _a3.list;
};
const dropSelector = (state)=>state.drop;
const dropsProgressSelector = (state)=>state.drop.drop.data.progress || [];
const dropsProgressNetworkStatusSelector = (state)=>state.drop.drop.meta.networkStatus;
const dropProductsToShowSelector = (state)=>state.drop.dropProductsToShow;
const hasDropsProgressSelector = createSelector(dropsProgressSelector, (dropsProgresses)=>{
    return dropsProgresses.length > 0;
});
const campaignExternalLinkSelector = createSelector(dropSelector, (drop2)=>drop2.campaignExternalLink);
const nonReceivedDropsProgressSelector = createSelector(dropsProgressSelector, (dropsProgresses)=>{
    return dropsProgresses.filter((dropsProgress)=>{
        var _a3, _b2, _c2, _d, _e, _f, _g;
        const currenRuleIndex = (_b2 = (_a3 = dropsProgress.campaign) == null ? void 0 : _a3.rules) == null ? void 0 : _b2.findIndex((rule)=>rule.id === dropsProgress.currentRule.id);
        if (currenRuleIndex === -1) return false;
        return dropsProgress.campaign.rulesMode !== EDropCampaignRulesMode.ONE_TIME || ((_c2 = dropsProgress.campaign) == null ? void 0 : _c2.rulesMode) === EDropCampaignRulesMode.ONE_TIME && ![
            EDropCampaignRuleRequest.DONE,
            EDropCampaignRuleRequest.NEW
        ].includes((_g = (_f = (_e = (_d = dropsProgress.campaign) == null ? void 0 : _d.rules) == null ? void 0 : _e[currenRuleIndex]) == null ? void 0 : _f.request) == null ? void 0 : _g.state);
    });
});
const dropsHighestProgressSelector = createSelector(dropsProgressSelector, (dropsProgresses)=>{
    return dropsProgresses.reduce((highestPercentage, dropProgress)=>{
        const { currentRule: { progress: progress2 } } = dropProgress;
        const currentItemPercentage = getProgressPercent(progress2 == null ? void 0 : progress2.goal, progress2 == null ? void 0 : progress2.current);
        if (currentItemPercentage > highestPercentage && !(progress2 == null ? void 0 : progress2.goalReached)) return currentItemPercentage;
        return highestPercentage;
    }, 0);
});
const dropsFinishedProgressSelector = createSelector(dropsProgressSelector, (dropsProgresses)=>{
    return dropsProgresses.filter((dropProgress)=>{
        var _a3, _b2, _c2, _d, _e, _f;
        const currenRuleIndex = (_b2 = (_a3 = dropProgress.campaign) == null ? void 0 : _a3.rules) == null ? void 0 : _b2.findIndex((rule)=>rule.id === dropProgress.currentRule.id);
        if (currenRuleIndex === -1) return false;
        return dropProgress.currentRule.progress.goalReached && (!dropProgress.currentRule.request || dropProgress.currentRule.request.state !== EDropCampaignRuleRequest.DONE) && (dropProgress.campaign.rulesMode !== EDropCampaignRulesMode.ONE_TIME || dropProgress.campaign.rulesMode === EDropCampaignRulesMode.ONE_TIME && ![
            EDropCampaignRuleRequest.DONE,
            EDropCampaignRuleRequest.NEW
        ].includes((_f = (_e = (_d = (_c2 = dropProgress.campaign) == null ? void 0 : _c2.rules) == null ? void 0 : _d[currenRuleIndex]) == null ? void 0 : _e.request) == null ? void 0 : _f.state));
    });
}, {
    memoizeOptions: {
        resultEqualityCheck: isEqual
    }
});
const streamChatPinnedMessage = (state)=>{
    var _a3;
    return (_a3 = state.stream.streamChatPinnedMessage) == null ? void 0 : _a3.data;
};
const streamChatPinnedMessageNetworkStatus = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.stream.streamChatPinnedMessage) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.networkStatus;
};
const streamChatPinnedMessageId = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.stream.streamChatPinnedMessage) == null ? void 0 : _a3.data) == null ? void 0 : _b2.messageId;
};
const streamBlocksPinnedHiddenItemsSelector = (state)=>state.stream.streamBlocksPinnedHiddenItems;
const hasChatPinnedMessage = (state)=>{
    var _a3;
    return (_a3 = state.stream.stream.data.stream) == null ? void 0 : _a3.hasChatPinnedMessage;
};
const STATIC_ARRAY$4 = [];
const blackListSelector = (state)=>{
    var _a3, _b2;
    return ((_b2 = (_a3 = state.blackList) == null ? void 0 : _a3.blackList) == null ? void 0 : _b2.data) || STATIC_ARRAY$4;
};
const blackListIdsSelector = createSelector(blackListSelector, (blackList2)=>blackList2.map((item2)=>item2.id));
const getPostponedRewardSelector = (state)=>state.postponedReward.postponedReward;
const pointNetworkStatusSelector = (state)=>state.channelPoint.channelPoint.meta.networkStatus;
const pointSelector = (state)=>state.channelPoint.channelPoint.data;
const pointNameSelector = (state)=>{
    var _a3;
    return (_a3 = state.channelPoint.channelPoint.data) == null ? void 0 : _a3.name;
};
const pointBalanceSelector = (state)=>{
    var _a3;
    return (_a3 = state.channelPoint.channelPoint.data) == null ? void 0 : _a3.balance;
};
const pointIsEnabledSelector = (state)=>Boolean(state.channelPoint.channelPoint.data);
const pointSmallImageSelector = (state)=>{
    var _a3;
    return (_a3 = state.channelPoint.channelPoint.data) == null ? void 0 : _a3.smallUrl;
};
const pointMediumImageSelector = (state)=>{
    var _a3;
    return (_a3 = state.channelPoint.channelPoint.data) == null ? void 0 : _a3.mediumUrl;
};
const channelPredictionSelector = (state)=>state.channelPrediction.channelPrediction.prediction.data;
const isVisiblePredictionSelector = (state)=>state.channelPrediction.channelPrediction.isVisible;
createSelector((state)=>state.channelPrediction.channelPrediction, ({ prediction: { data: prediction, meta } })=>prediction && !meta.networkStatus.isFetching && ![
        EPredictionStatus.ENDED,
        EPredictionStatus.CANCELED
    ].includes(prediction.state));
const STATIC_ARRAY$3 = [];
const STATIC_OBJECT$1 = {};
const MAX_VALUE_FOR_UPDATE_LIST = 50;
const RECORD_CHAT_MEMOIZE_OPTIONS = {
    memoizeOptions: {
        resultEqualityCheck: (a2, b2)=>{
            const isBothArraysEmpty = a2.length === 0 && b2.length === 0;
            const isFirstAndLastElementsEqual = a2[0] === b2[0] && a2[a2.length - 1] === b2[b2.length - 1];
            return isBothArraysEmpty || isFirstAndLastElementsEqual;
        }
    }
};
const selectedSmileSelector = (state)=>state.chat.selectedSmile;
const userChatHistoriesNetworkStatusSelector = (state)=>state.chat.userChatHistories.meta.networkStatus;
const userChatHistorySelector = (userId)=>(state)=>{
        var _a3;
        return ((_a3 = state.chat.userChatHistories.data.list[userId]) == null ? void 0 : _a3.messages) ?? [];
    };
const userChatHistoryIsFullyFetchedSelector = (userId)=>(state)=>{
        var _a3;
        return ((_a3 = state.chat.userChatHistories.data.list[userId]) == null ? void 0 : _a3.isLast) ?? false;
    };
const recordChatCurrentIndexSelector = (state)=>state.chat.recordChatCurrentIndex;
const recordChatDataSelector = (state)=>{
    var _a3;
    return ((_a3 = state.chat.recordChat.data) == null ? void 0 : _a3.data) ?? STATIC_ARRAY$3;
};
const recordChatNetworkStatusSelector = (state)=>state.chat.recordChat.meta.networkStatus;
const recordChatExtraSelector = (state)=>{
    var _a3;
    return ((_a3 = state.chat.recordChat.data) == null ? void 0 : _a3.extra) ?? STATIC_OBJECT$1;
};
const recordChatSelector = createSelector(recordChatCurrentIndexSelector, recordChatDataSelector, (index2, chatData)=>chatData == null ? void 0 : chatData.slice(0, index2), RECORD_CHAT_MEMOIZE_OPTIONS);
const recordChatLeftMessagesSelector = createSelector(recordChatCurrentIndexSelector, recordChatDataSelector, (index2, chatData)=>chatData == null ? void 0 : chatData.slice(index2), RECORD_CHAT_MEMOIZE_OPTIONS);
createSelector(recordChatCurrentIndexSelector, recordChatDataSelector, (index2, chatData)=>{
    var _a3, _b2, _c2;
    return {
        current: (_a3 = chatData[index2]) == null ? void 0 : _a3.timeCode,
        start: (_b2 = chatData[0]) == null ? void 0 : _b2.timeCode,
        end: (_c2 = chatData[(chatData == null ? void 0 : chatData.length) >= MAX_VALUE_FOR_UPDATE_LIST ? (chatData == null ? void 0 : chatData.length) - MAX_VALUE_FOR_UPDATE_LIST - 1 : (chatData == null ? void 0 : chatData.length) - 1 || 0]) == null ? void 0 : _c2.timeCode
    };
});
const streamShowcaseSelector = (state)=>state.stream.showcase.stream;
const currentRecordSelector = (state)=>state.record.currentRecord.data;
const recordsSelector = (state)=>{
    var _a3, _b2, _c2;
    return ((_c2 = (_b2 = (_a3 = state.record) == null ? void 0 : _a3.records) == null ? void 0 : _b2.data) == null ? void 0 : _c2.data) || [];
};
createSelector(currentRecordSelector, (record2)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = record2 == null ? void 0 : record2.accessRestrictions) == null ? void 0 : _a3.view) == null ? void 0 : _b2.allowed;
});
const getRecordById = (records, recordId)=>{
    return records.find((record2)=>record2.id === recordId);
};
const recordIdFromPropsSelector = (state, props)=>(props == null ? void 0 : props.recordId) || null;
const overallRecordsSelector = createSelector(recordsSelector, (records)=>[
        ...records
    ]);
createSelector(recordIdFromPropsSelector, currentRecordSelector, overallRecordsSelector, (recordId, currentRecord, records)=>recordId ? getRecordById(records, recordId) : currentRecord);
const pointPendingBonusNetworkStatusSelector = (state)=>state.pendingBonus.pendingBonus.meta.networkStatus;
const hasPointPendingBonusSelector = (state)=>state.pendingBonus.pendingBonus.data.length > 0;
const pointPendingBonusSelector = (state)=>state.pendingBonus.pendingBonus.data;
const pointBonusesNetworkStatusSelector = (state)=>state.bonuses.bonuses.meta.networkStatus;
const pointBonusesSelector = (state)=>state.bonuses.bonuses.data.bonuses;
const pointBonusMultipliersSelector = (state)=>state.bonuses.bonuses.data.bonusMultipliers;
const pointUpdaterSelector = (state)=>state.channelPointUpdater.channelPointUpdater;
const rewardsSelector = (state)=>state.rewards.rewards.data;
const getRewardByIdSelector = (rewardId)=>(state)=>state.rewards.rewards.data.find((reward2)=>reward2.id === rewardId);
const subscriptionGiftSelector = (state)=>state.subscriptionGift.subscriptionGift.data;
const nonZeroCountSubscriptionGiftSelector = createSelector(subscriptionGiftSelector, (gifts)=>(gifts ?? []).filter((gift2)=>gift2.count > 0).sort((a2, b2)=>a2.subscriptionLevel.price - b2.subscriptionLevel.price));
const subscriptionGiftNetworkStatusSelector = (state)=>state.subscriptionGift.subscriptionGift.meta.networkStatus;
const publisherStateSelector = (state)=>{
    var _a3;
    return ((_a3 = state == null ? void 0 : state.publisherState) == null ? void 0 : _a3.publisherState) || {};
};
const getVideoClipById = (videoClips2, videoClipId)=>{
    return videoClips2.find((videoClip)=>videoClip.id === videoClipId);
};
const currentVideoClipDataSelector = (state)=>state.videoClips.currentVideoClip.data;
const videoClipsDataSelector = (state)=>state.videoClips.videoClips.data.data;
const videoClipsExtraSelector = (state)=>state.videoClips.videoClips.data.extra;
const videoClipsInProcessSelector = (state)=>state.videoClips.videoClipsCreationPipeline.inProcess;
const videoClipsReadySelector = (state)=>state.videoClips.videoClipsCreationPipeline.ready;
const videoClipsFailedSelector = (state)=>state.videoClips.videoClipsCreationPipeline.failed;
const blogUrlFromPropsSelector$1 = (state, props)=>(props == null ? void 0 : props.blogUrl) || null;
createSelector(blogUrlFromPropsSelector$1, videoClipsInProcessSelector, (blogUrl, videoClipsInProcess)=>Object.values(videoClipsInProcess[blogUrl] || {})[0]);
createSelector(blogUrlFromPropsSelector$1, videoClipsReadySelector, (blogUrl, videoClipsReady)=>Object.values(videoClipsReady[blogUrl] || {})[0]);
createSelector(blogUrlFromPropsSelector$1, videoClipsFailedSelector, (blogUrl, videoClipsFailed)=>Object.values(videoClipsFailed[blogUrl] || {})[0]);
const videoSnippetsInProcessSelector = (state)=>state.videoClips.videoSnippetsCreationPipeline.inProcess;
const videoSnippetsReadySelector = (state)=>state.videoClips.videoSnippetsCreationPipeline.ready;
const videoSnippetsFailedSelector = (state)=>state.videoClips.videoSnippetsCreationPipeline.failed;
const blogUrlFromPropsSelector = (state, props)=>(props == null ? void 0 : props.blogUrl) || null;
createSelector(blogUrlFromPropsSelector, videoSnippetsInProcessSelector, (blogUrl, videoSnippetsInProcess)=>Object.values(videoSnippetsInProcess[blogUrl] || {})[0]);
createSelector(blogUrlFromPropsSelector, videoSnippetsReadySelector, (blogUrl, videoSnippetsReady)=>Object.values(videoSnippetsReady[blogUrl] || {})[0]);
createSelector(blogUrlFromPropsSelector, videoSnippetsFailedSelector, (blogUrl, videoSnippetsFailed)=>Object.values(videoSnippetsFailed[blogUrl] || {})[0]);
const videoClipIdFromPropsSelector = (state, props)=>(props == null ? void 0 : props.videoClipId) || null;
const overallVideoClipsSelector = createSelector(videoClipsDataSelector, (videoClips2)=>[
        ...videoClips2
    ]);
createSelector(videoClipIdFromPropsSelector, currentVideoClipDataSelector, overallVideoClipsSelector, (videoClipId, currentVideoClip, videoClips2)=>videoClipId ? getVideoClipById(videoClips2, videoClipId) : currentVideoClip);
const notificationSettingsSelector = (state)=>state.notificationSettings.settings.data;
const notificationChannelSettingsSelector = (state)=>state.notificationSettings.channelSettings.data;
const webSocketTokenSelector = (state)=>{
    return state.webSocketToken.webSocketToken.data.token;
};
const integrationsSelector = (state)=>state.integrations;
createSelector([
    integrationsSelector,
    (state, type)=>type
], (integrations2, type)=>integrations2[type].data);
createSelector([
    integrationsSelector,
    (state, type)=>type
], (integrations2, type)=>integrations2[type].meta.networkStatus);
createSelector((state)=>state.integrations.vkCommunity.data, (state)=>{
    var _a3;
    return (_a3 = state.globalData) == null ? void 0 : _a3.blogUrl;
}, (vkCommunityList, userBlogUrl)=>{
    const foundVkCommunity = Array.isArray(vkCommunityList) && vkCommunityList.find((vkCommunity)=>{
        var _a3;
        return ((_a3 = vkCommunity == null ? void 0 : vkCommunity.channel) == null ? void 0 : _a3.channelUrl) === userBlogUrl;
    });
    if (!foundVkCommunity) return null;
    return {
        title: foundVkCommunity.name,
        image: foundVkCommunity.avatarUrl,
        description: `ID ${foundVkCommunity.id}`
    };
});
createSelector((state)=>state.integrations.boosty.data, (boostyLinking)=>{
    if (!boostyLinking) return null;
    return {
        id: boostyLinking.id,
        title: boostyLinking.name,
        image: boostyLinking.avatarUrl,
        provider: getAuthProviderTitle(getProviderCodeBySourceType(boostyLinking.authSource.type))
    };
});
const channelPollSelector = (state)=>{
    var _a3, _b2;
    return (_b2 = (_a3 = state.channelPoll) == null ? void 0 : _a3.channelPoll) == null ? void 0 : _b2.data;
};
const refetchStream = actionCreatorAsync$Y("refetchStream", async (payload, dispatch, getState)=>{
    const state = getState();
    const blogUrl = blogUrlSelector(state) || globalBlogUrlSelector(state);
    if (state.stream.stream.meta.networkStatus.isFetched) return dispatch(fetchStream.action({
        blogUrl: blogUrl
    }));
    else return null;
});
const registerStreamPlayer = actionCreator$15("registerStreamPlayer");
const removeStopWord = actionCreatorAsync$Y("removeStopWord", async ({ blogUrl, word })=>{
    await Api$1.blogPostChat.removeStopWord(blogUrl, {
        word: word
    });
    return {};
});
const resetStream = actionCreator$15("resetStream");
const removeStream = actionCreatorAsync$Y("removeStream", async ({ blogUrl })=>{
    const response = await Api$1.stream.remove(blogUrl);
    return response.data;
});
const removeStreamChatMessage = actionCreatorAsync$Y("removeStreamChatMessage", async ({ blogUrl, messageId })=>{
    await Api$1.blogPostChat.remove(blogUrl, messageId);
    return {};
});
const removeStreamChatMessageFromWS = actionCreator$15("removeStreamChatMessageFromWS");
const removeStreamChatMessagesByUserIdLocally = actionCreator$15("removeStreamChatMessagesByUserIdLocally");
const removeStreamChatMessagesByUserIdFromMentions = actionCreator$15("removeStreamChatMessagesByUserIdFromMentions");
const removeStreamChatMessagesLocally = actionCreator$15("removeStreamChatMessagesLocally");
const removeStreamChatMessagesFromWS = actionCreator$15("removeStreamChatMessagesFromWS");
const removeStreamChatMessagesFromMentions = actionCreator$15("removeStreamChatMessagesFromMentions");
const removeMentionedUser = actionCreator$15("removeMentionedUser");
const saveChatSettings = actionCreatorAsync$Y("saveChatSettings", async (params)=>{
    const { blogUrl, allowAccess, allowAccessAfter, anyMessageTimeout, mode: mode2 } = params;
    await Api$1.blogPostChat.saveSettings(blogUrl, {
        allow_access: allowAccess,
        allow_access_after: allowAccessAfter,
        any_message_timeout: anyMessageTimeout,
        mode: mode2 == null ? void 0 : mode2.value,
        mode_options: mode2 == null ? void 0 : mode2.parameters
    });
    return {};
});
const sendHeartbeat = actionCreatorAsync$Y("sendHeartbeat", async ({ blogUrl, streamId, stop, autoplay, source, sourceType })=>{
    const { data: { data: { nextRequestInterval } } } = await Api$1.stream.sendHeartbeat(blogUrl, streamId, {
        stop: stop,
        autoplay: autoplay,
        source: source,
        sourceType: sourceType
    });
    return {
        nextRequestInterval: nextRequestInterval
    };
});
const sendStreamChatMessage = actionCreatorAsync$Y("sendStreamChatMessage", async (params)=>{
    const { blogUrl, slotUrl, data, replyToId } = params;
    await Api$1.blogPostChat.create(blogUrl, slotUrl, {
        data: JSON.stringify(data),
        reply_to_id: replyToId
    });
    return {};
});
const setActiveIndexPopover = actionCreator$15("setActiveIndexPopover");
const setStreamData = actionCreator$15("setStreamData");
const setStreamIsOnline = actionCreator$15("setStreamIsOnline");
const setStreamViewers = actionCreator$15("setStreamViewers");
const streamLikesCounterUpdate = actionCreator$15("streamLikesCounterUpdate");
const unblockUser = actionCreatorAsync$Y("unblockUser", async ({ blogUrl, slotUrl, userId, byStream }, dispatch)=>{
    const { data } = await Api$1.blogPostChat.unblockUser(blogUrl, slotUrl, {
        user_id: String(userId),
        by_stream: String(byStream)
    });
    dispatch(fetchUserBanStat.action({
        blogUrl: blogUrl,
        userId: userId
    }));
    return data;
});
const unlikeStream = actionCreatorAsync$Y("unlikeStream", async ({ blogUrl, slotUrl })=>{
    await Api$1.stream.unlike(blogUrl, slotUrl);
    return {};
});
const updateChatMode = actionCreator$15("updateChatMode");
const updateChatBanStatusFromWS = actionCreator$15("updateChatBanStatusFromWS");
const updateStreamChatTemporaryBannedUsersFromWS = actionCreator$15("updateStreamChatTemporaryBannedUsersFromWS");
const updateStreamChatPermanentBannedUsersFromWS = actionCreator$15("updateStreamChatPermanentBannedUsersFromWS");
const updateChatSettingsFromCookies = actionCreator$15("updateChatSettingsFromCookies");
const updateChatSettingsFromWS = actionCreator$15("updateChatSettingsFromWS");
const updateStream = actionCreatorAsync$Y("updateStream", async ({ blogUrl, stream: stream2 })=>{
    const { description: description2, subscriptionLevelId, daNick, title: title2, categoryId, publishTime: publishTime2 } = stream2;
    const response = await Api$1.stream.update(blogUrl, {
        description: JSON.stringify(description2),
        subscription_level_id: subscriptionLevelId,
        da_nick: daNick,
        category_id: categoryId,
        title: title2,
        publish_time: publishTime2
    });
    return response.data;
});
const updateSelfPublicStreamHidden = actionCreatorAsync$Y("updateSelfPublicStreamHidden", async ({ blogUrl, isPublicStreamSelfHidden })=>{
    if (isPublicStreamSelfHidden) await Api$1.channelSettings.turnOnSelfPublicStreamHidden(blogUrl);
    else await Api$1.channelSettings.turnOffSelfPublicStreamHidden(blogUrl);
    return {
        isPublicStreamSelfHidden: isPublicStreamSelfHidden
    };
});
const unregisterStreamPlayer = actionCreator$15("unregisterStreamPlayer");
const turnOnStreamsRecord = actionCreatorAsync$Y("turnOnStreamsRecord", async ({ blogUrl })=>{
    await Api$1.channelSettings.turnOnStreamsRecord(blogUrl);
});
const turnOffStreamsRecord = actionCreatorAsync$Y("turnOffStreamsRecord", async ({ blogUrl })=>{
    await Api$1.channelSettings.turnOffStreamsRecord(blogUrl);
});
actionCreatorAsync$Y("initRaid", async ({ blogUrl, targetBlogUrl })=>{
    await Api$1.stream.initRaid(blogUrl, targetBlogUrl);
});
const startRaid = actionCreatorAsync$Y("startRaid", async ({ blogUrl })=>{
    await Api$1.stream.startRaid(blogUrl);
});
const cancelRaid = actionCreatorAsync$Y("cancelRaid", async ({ blogUrl })=>{
    await Api$1.stream.cancelRaid(blogUrl);
});
const rejectRaid = actionCreatorAsync$Y("rejectRaid", async ({ blogUrl })=>{
    await Api$1.stream.rejectRaid(blogUrl);
});
actionCreatorAsync$Y("incrementRaidViewers", async ({ blogUrl })=>{
    await Api$1.stream.incrementRaidViewers(blogUrl);
});
const setStreamRaid = actionCreator$15("setStreamRaid");
const resetStreamRaidLoaded = actionCreator$15("resetStreamRaidLoaded");
const cleanStreamRaid = actionCreator$15("cleanStreamRaid");
const fetchRaidUserState = actionCreatorAsync$Y("fetchRaidUserState", async ({ blogUrl })=>{
    const response = await Api$1.stream.fetchRaidUserState(blogUrl);
    return response.data.data.raid;
});
const cleanRaidUserState = actionCreator$15("cleanRaidUserState");
const turnOnStreamRaided = actionCreatorAsync$Y("turnOnStreamRaided", async ({ blogUrl })=>{
    await Api$1.channelSettings.turnOnStreamRaided(blogUrl);
});
const turnOffStreamRaided = actionCreatorAsync$Y("turnOffStreamRaided", async ({ blogUrl })=>{
    await Api$1.channelSettings.turnOffStreamRaided(blogUrl);
});
const fetchRaidableStreams = actionCreatorAsync$Y("fetchRaidableStreams", async ()=>{
    const response = await Api$1.stream.fetchRaidableStreams();
    const newData = response.data.data.streamBlogs.map((streamBlog)=>({
            ...streamBlog.stream,
            blogUrl: streamBlog.blog.blogUrl,
            user: streamBlog.blog.owner
        }));
    return {
        data: newData
    };
});
const setStreamChatIsPaused = actionCreator$15("setStreamChatIsPaused");
const assignUserRoles = actionCreatorAsync$Y("assignUserRoles", async ({ blogUrl, userId, selectedRoles })=>{
    const response = await Api$1.role.assign(blogUrl, userId, {
        role_ids: selectedRoles.map((role2)=>role2.id)
    });
    return response.data;
});
const fetchPinnedMessage = actionCreatorAsync$Y("fetchPinnedMessage", async (params)=>{
    const { blogUrl } = params;
    const response = await Api$1.blogPostChat.fetchPinnedMessage(blogUrl);
    return {
        data: response.data.data.pinnedMessage
    };
});
const pinChatMessage = actionCreatorAsync$Y("pinChatMessage", async (params)=>{
    const { blogUrl, kind, messageId, reactable } = params;
    await Api$1.blogPostChat.pinChatMessage({
        blogUrl: blogUrl,
        kind: kind,
        messageId: messageId,
        reactable: reactable
    });
});
const editPinnedChatMessage = actionCreatorAsync$Y("editPinnedChatMessage", async (params)=>{
    const { blogUrl, kind, reactable } = params;
    await Api$1.blogPostChat.editPinnedChatMessage({
        blogUrl: blogUrl,
        kind: kind,
        reactable: reactable
    });
});
const pinChatMessageWS = actionCreator$15("pinChatMessageWS");
const editPinnedChatMessageWS = actionCreator$15("editPinnedChatMessageWS");
const addChatMessageReactionWS = actionCreator$15("addChatMessageReactionWS");
const setStreamBlocksPinnedHidden = actionCreator$15("setStreamBlocksPinnedHidden");
const clearStreamBlocksPinnedHidden = actionCreator$15("clearStreamBlocksPinnedHidden");
const unpinChatMessage = actionCreatorAsync$Y("unpinChatMessage", async (params)=>{
    const { blogUrl } = params;
    await Api$1.blogPostChat.unpinChatMessage(blogUrl);
});
const unpinChatMessageWS = actionCreator$15("unpinChatMessageWS");
const addPinnedChatMessageReaction = actionCreatorAsync$Y("addPinnedChatMessageReaction", async (params)=>{
    const { blogUrl, reaction } = params;
    await Api$1.blogPostChat.addPinnedChatMessageReaction({
        blogUrl: blogUrl,
        reaction: reaction
    });
});
actionCreator$15("addPinnedChatMessageReactionWS");
const hideStream = actionCreatorAsync$Y("hideStream", async ({ blogUrl })=>{
    await Api$1.stream.hide(blogUrl);
    return {};
});
const removeStreamFromHidden = actionCreatorAsync$Y("removeStreamFromHidden", async ({ blogUrl })=>{
    await Api$1.stream.removeFromHidden(blogUrl);
    return {};
});
const fetchStreamChatThreadMessages = actionCreatorAsync$Y("fetchStreamChatThreadMessages", async ({ blogUrl, threadId })=>{
    const { data } = await Api$1.blogPostChat.fetchThreadMessages(blogUrl, threadId);
    return data;
});
const clearStreamShowcase = actionCreator$15("clearStreamShowcase");
const updateStreamShowcase = actionCreator$15("updateStreamShowcase");
const fetchStreamShowcase = actionCreatorAsync$Y("fetchStreamShowcase", async (payload)=>{
    const { blogUrl, slotUrl, from: from2 } = payload;
    const response = await Api$1.stream.fetch({
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        from: from2
    });
    return response.data.data.stream;
});
actionCreatorAsync$Y("fetchCategories", async ({ query, categoryType, offset: offset2, limit })=>{
    const response = await Api$1.stream.fetchCategories({
        search: query,
        type: categoryType,
        offset: offset2,
        limit: limit
    });
    return {
        data: response.data.data,
        offset: response.data.extra.offset,
        isLast: response.data.extra.isLast
    };
});
actionCreatorAsync$Y("requestAccess", async (params)=>{
    const { boosty, ...restParams } = params;
    const response = await Api$1.stream.requestAccess({
        ...restParams,
        ...boosty ? {
            boosty_blog_url: boosty
        } : {}
    });
    return response.data;
});
const searchStreams = actionCreatorAsync$Y("searchStreams", async ({ query, offset: offset2, limit, forRaid })=>{
    const response = await Api$1.stream.search({
        query: query,
        offset: offset2,
        limit: limit,
        forRaid: forRaid
    });
    return {
        data: response.data.data.searchBlogs.map(({ blog: blog2, stream: stream2 })=>({
                id: blog2.blogUrl,
                blog: blog2,
                stream: stream2
            })),
        offset: response.data.extra.offset,
        isLast: response.data.extra.isLast
    };
});
const actionCreator$14 = (0, $99y5v.actionCreatorFactory)("Category");
const actionCreatorAsync$X = (0, $7Uc0p.asyncFactory)(actionCreator$14);
const searchCategories = actionCreatorAsync$X("searchCategories", async ({ query, offset: offset2, limit })=>{
    const response = await Api$1.category.search({
        query: query,
        offset: offset2,
        limit: limit
    });
    return {
        data: response.data.data.searchStreamCategories,
        offset: response.data.extra.offset,
        isLast: response.data.extra.isLast
    };
});
const getDefaultData = ()=>({
        data: [],
        isLast: true,
        offset: null
    });
actionCreatorAsync$Y("searchStreamsAndCategories", async ({ query, isFetchedCategory, offsetStream, offsetCategory, limitStream, limitCategory }, dispatch)=>{
    const [streamsRes, categoriesRes] = await Promise.allSettled([
        dispatch(searchStreams.action({
            query: query,
            offset: offsetStream,
            limit: limitStream
        })),
        !isFetchedCategory && dispatch(searchCategories.action({
            query: query,
            offset: offsetCategory,
            limit: limitCategory
        }))
    ]);
    let [streams, categories] = [
        getDefaultData(),
        getDefaultData()
    ];
    if (streamsRes.status === "fulfilled") streams = streamsRes.value;
    if (categoriesRes.status === "fulfilled" && Boolean(categoriesRes.value)) categories = categoriesRes.value;
    return {
        streams: streams,
        categories: categories
    };
});
const fetchStreamRandom = actionCreatorAsync$Y("fetchStreamRandom", async (params = {})=>{
    const { categoryId, categoryType, dropCampaignId, mode: mode2 } = params;
    if (dropCampaignId) {
        const { data } = await Api$1.streamRandom.fetchRandomStreamForDropCampaign(dropCampaignId);
        return data;
    } else {
        const { data } = await Api$1.streamRandom.fetchRandomStream({
            category_id: categoryId,
            type: categoryType,
            mode: mode2
        });
        return data;
    }
});
const fetchStreamRaid = actionCreatorAsync$Y("fetchStreamRaid", async ({ blogUrl })=>{
    const response = await Api$1.stream.fetchStreamRaid(blogUrl);
    return response.data.data;
});
const fetchStreamUserCard = actionCreatorAsync$Y("fetchStreamUserCard", async (payload)=>{
    const { blogUrl, from: from2 } = payload;
    const response = await Api$1.stream.fetch({
        blogUrl: blogUrl,
        from: from2
    });
    return response.data.data.stream;
});
const clearStreamUserCard = actionCreator$15("clearStreamUserCard");
actionCreatorAsync$Y("getChatWinnerPattern", async ({ blogUrl, params })=>{
    await Api$1.chatWinner.getChatWinnerPattern(blogUrl, params);
});
actionCreatorAsync$Y("getChatWinnerViewer", async ({ blogUrl, params })=>{
    await Api$1.chatWinner.getChatWinnerViewer(blogUrl, params);
});
actionCreatorAsync$Y("getChatWinnerSubscriber", async ({ blogUrl, params })=>{
    await Api$1.chatWinner.getChatWinnerSubscriber(blogUrl, params);
});
const addNewMentionChatMessage = actionCreator$15("addNewMentionChatMessage");
const toggleVisibilityDropInstruction = actionCreator$15("toggleVisibilityDropInstruction");
const actionCreator$13 = (0, $99y5v.actionCreatorFactory)("SubscriptionsSettings");
const actionCreatorAsync$W = (0, $7Uc0p.asyncFactory)(actionCreator$13);
const fetchSubscriptions = actionCreatorAsync$W("fetchSubscriptions", async ({ withFollow, shouldReset }, dispatch, getState)=>{
    const { subscriptions: { subscriptions: { data, meta: { limit } } } } = getState();
    const response = await Api$1.user.getSubscriptions({
        limit: limit,
        offset: shouldReset ? 0 : data.length
    }, withFollow);
    return {
        data: response.data
    };
});
const fetchBlogSubscriptionLevel = actionCreatorAsync$Z("fetchBlogSubscriptionLevel", async ({ blogUrl, levelId, withContentCounters })=>{
    const response = await Api$1.subscriptionLevels.fetch(blogUrl, levelId, withContentCounters);
    return {
        level: response.data
    };
});
const refetchSubscriptions = ()=>async (dispatch)=>{
        const authToken = tryGetAuthCookie();
        if (authToken) await dispatch(fetchSubscriptions.action({
            withFollow: true,
            shouldReset: true
        }));
    };
const fetchSubscriptionsSettingsData = actionCreatorAsync$W("fetchSubscriptionsSettingsData", async ({ pageNumber, withFollow }, dispatch, getState)=>{
    const { subscriptions: { subscriptionsSettings: { meta: { limit } } } } = getState();
    const authToken = tryGetAuthCookie();
    if (authToken) {
        const response = await Api$1.user.getSubscriptions({
            limit: limit,
            offset: limit * pageNumber
        }, withFollow);
        return {
            data: response.data
        };
    } else return null;
});
const refetchSubscriptionsSettingsData = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.subscriptions.subscriptionsSettings.meta.networkStatus.isFetched) return dispatch(fetchSubscriptionsSettingsData.action({
            pageNumber: 0,
            withFollow: true
        }));
        else return null;
    };
const clearSubscriptions = actionCreator$13("clearSubscriptions");
const clearBlogSubscriptionLevel = actionCreator$13("clearBlogSubscriptionLevel");
const fetchBlogSubscriptionLevels = actionCreatorAsync$Z("fetchBlogSubscriptionLevels", async ({ blogUrl, showFree, showDeleted })=>{
    const response = await Api$1.blog.fetchSubscriptionLevels(blogUrl, showFree, showDeleted);
    return {
        subscriptionLevels: response.data.data,
        subscriptions: response.data.subscriptions,
        currentLevelId: response.data.currentId,
        nextLevelId: response.data.nextId
    };
});
const refetchBlogSubscriptionLevels = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.subscriptions.subscriptionLevels.meta.networkStatus.isFetched && state.blog.blog.meta.networkStatus.isFetched) return dispatch(fetchBlogSubscriptionLevels.action({
            blogUrl: state.blog.blog.data.blogUrl
        }));
        else return null;
    };
const createBlogSubscriptionLevel = actionCreatorAsync$Z("createBlogSubscriptionLevel", async ({ blogUrl, level, discordRoleId, tgGroupIds }, dispatch)=>{
    const { name: name2, price, data, thankMessage } = level;
    const response = await Api$1.subscriptionLevels.create(blogUrl, {
        name: name2,
        price: price,
        data: JSON.stringify(data),
        thank_msg_data: JSON.stringify(thankMessage == null ? void 0 : thankMessage.data),
        thank_msg_teaser_data: JSON.stringify(thankMessage == null ? void 0 : thankMessage.teaser),
        is_thank_msg_enabled: (thankMessage == null ? void 0 : thankMessage.data.length) > 0,
        thank_msg_price: thankMessage == null ? void 0 : thankMessage.price,
        discord_role_id: discordRoleId || "",
        tg_group_ids: tgGroupIds || []
    });
    dispatch(refetchBlogSubscriptionLevels());
    return {
        level: response.data
    };
});
const editBlogSubscriptionLevel = actionCreatorAsync$Z("editBlogSubscriptionLevel", async ({ blogUrl, levelId, level, discordRoleId, tgGroupIds }, dispatch)=>{
    const { name: name2, price, data, thankMessage, isThankMessageEnabled } = level;
    const response = await Api$1.subscriptionLevels.update(blogUrl, levelId, {
        blog_url: blogUrl,
        name: name2,
        price: price,
        data: JSON.stringify(data),
        thank_msg_data: JSON.stringify(thankMessage == null ? void 0 : thankMessage.data),
        thank_msg_teaser_data: JSON.stringify(thankMessage == null ? void 0 : thankMessage.teaser),
        is_thank_msg_enabled: isThankMessageEnabled,
        thank_msg_price: thankMessage == null ? void 0 : thankMessage.price,
        discord_role_id: discordRoleId || "",
        tg_group_ids: tgGroupIds || []
    });
    dispatch(refetchBlogSubscriptionLevels());
    return {
        level: response.data
    };
});
const removeBlogSubscriptionLevel = actionCreatorAsync$Z("removeBlogSubscriptionLevel", async ({ blogUrl, levelId, postsMigrationLevelId })=>{
    return await Api$1.subscriptionLevels.remove(blogUrl, levelId, {
        posts_migration_level_id: postsMigrationLevelId
    });
});
const resetBlogSubscriptionLevels = actionCreator$13("resetBlogSubscriptionLevels");
const clearBlogSubscriptionLevels = actionCreator$13("clearBlogSubscriptionLevels");
const clearBlogSubscriptionLevelsExternalBlog = actionCreator$13("clearBlogSubscriptionLevelsExternalBlog");
const actionCreator$12 = (0, $99y5v.actionCreatorFactory)("Target");
const actionCreatorAsync$V = (0, $7Uc0p.asyncFactory)(actionCreator$12);
const fetchTargets = actionCreatorAsync$V("fetchTargets", async ({ blogUrl, type })=>{
    const response = await Api$1.target.fetchTargets(blogUrl, {
        type: type
    });
    return {
        data: response.data.data
    };
});
const fetchTargetById = actionCreatorAsync$V("fetchTargetById", async ({ id, currency })=>{
    const response = await Api$1.target.fetchTargetById(id, currency);
    return {
        target: response.data
    };
});
const fetchAllTargets = actionCreatorAsync$V("fetchAllTargets", async ({ blogUrl, type })=>{
    const response = await Api$1.target.fetchTargets(blogUrl, {
        type: type,
        show_deleted: true
    });
    return {
        data: response.data.data
    };
});
const createMoneyTarget = actionCreatorAsync$V("createMoneyTarget", async ({ blogUrl, description: description2, targetSum })=>{
    const response = await Api$1.target.createMoneyTarget({
        blog_url: blogUrl,
        description: description2,
        target_sum: targetSum
    });
    return {
        target: response.data
    };
});
const createSubscribersTarget = actionCreatorAsync$V("createSubscribersTarget", async ({ blogUrl, description: description2, targetSum })=>{
    const response = await Api$1.target.createSubscribersTarget({
        blog_url: blogUrl,
        description: description2,
        target_sum: targetSum
    });
    return {
        target: response.data
    };
});
const editTarget = actionCreatorAsync$V("editTarget", async ({ description: description2, targetSum, id })=>{
    const response = await Api$1.target.edit(id, {
        target_sum: targetSum,
        description: description2,
        target_id: id
    });
    return {
        target: response.data
    };
});
const removeTarget = actionCreatorAsync$V("removeTarget", async ({ id })=>{
    const response = await Api$1.target.remove(id);
    return {
        target: response.data
    };
});
const refetchTargets = ({ blogUrl, type })=>async (dispatch, getState)=>{
        var _a3;
        const state = getState();
        if ((_a3 = state.target) == null ? void 0 : _a3.targets.meta.networkStatus.isFetched) return dispatch(fetchTargets.action({
            blogUrl: blogUrl,
            type: type
        }));
        else return null;
    };
const incrementSubscribers = actionCreator$12("incrementSubscribers");
const decrementSubscribers = actionCreator$12("decrementSubscribers");
const actionCreator$11 = (0, $99y5v.actionCreatorFactory)("Target");
(0, $7Uc0p.asyncFactory)(actionCreator$11);
const resetTargets = actionCreator$11("resetTargets");
const onSubscribedStateChange = (isUnsubscribe)=>async (dispatch)=>{
        if (!isUnsubscribe) AppStat.log.gtm.paidSubscriptionSuccess();
        const promises = [
            dispatch(refetchBlog()),
            dispatch(refetchStream()),
            dispatch(refetchBlogSubscriptionLevels()),
            dispatch(refetchSubscriptionsSettingsData()),
            dispatch(refetchFeed())
        ];
        if (!isUnsubscribe) promises.push(dispatch(incrementSubscribers()));
        return Promise.all(promises);
    };
const actionCreator$10 = (0, $99y5v.actionCreatorFactory)("Badge");
const actionCreatorAsync$U = (0, $7Uc0p.asyncFactory)(actionCreator$10);
const fetchBadgesList = actionCreatorAsync$U("fetchBadgesList", async ({ blogUrl })=>{
    const response = await Api$1.badge.fetchList(blogUrl);
    return response.data.data;
});
const createBadge = actionCreatorAsync$U("createBadge", async ({ blogUrl, achievementName, params })=>{
    const { name: name2, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.badge.create(blogUrl, {
        name: name2,
        achievement_name: achievementName,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data.data.badge;
});
const updateBadge = actionCreatorAsync$U("updateBadge", async ({ blogUrl, badgeId, params })=>{
    const { name: name2, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.badge.update(blogUrl, badgeId, {
        name: name2,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data.data.badge;
});
actionCreatorAsync$U("uploadBadgeImage", async ({ blogUrl, smileSize, file })=>{
    const response = await Api$1.badge.uploadBadgeImage(blogUrl, smileSize, file);
    return response.data.data.upload;
});
const removeBadge = actionCreatorAsync$U("removeBadge", async ({ blogUrl, badgeId })=>{
    await Api$1.badge.remove(blogUrl, badgeId);
    return {};
});
const clearBadges = actionCreator$10("clearBadges");
const actionCreator$$ = (0, $99y5v.actionCreatorFactory)("BlogPost");
const actionCreatorAsync$T = (0, $7Uc0p.asyncFactory)(actionCreator$$);
const fetchBlogPost = actionCreatorAsync$T("fetchBlogPost", async ({ blogUrl, postId, commentId, commentsLimit = getConfig().comments.fullPageLimit, repliesLimit = getConfig().comments.fullPageRepliesLimit })=>{
    const apiCommentsLimit = commentId ? Math.floor(commentsLimit / 2) : commentsLimit;
    const response = await Api$1.blogPost.fetch(blogUrl, postId, apiCommentsLimit, repliesLimit, commentId);
    return {
        blogPost: response.data
    };
});
const refetchBlogPost = (postId)=>async (dispatch, getState)=>{
        const state = getState();
        if (state.blog.posts.meta.networkStatus.isFetched) {
            const id = postId || state.blog.posts.data.posts[0].id;
            return dispatch(fetchBlogPost.action({
                blogUrl: state.blog.blog.data.blogUrl,
                postId: id
            }));
        } else return null;
    };
const actionCreator$_ = (0, $99y5v.actionCreatorFactory)("DialogueMessages");
const actionCreatorAsync$S = (0, $7Uc0p.asyncFactory)(actionCreator$_);
const fetchDialogueListCommon = async (params)=>{
    const { data } = await Api$1.dialog.fetchList({
        with_subscriptions: params.withSubscriptions,
        with_subscribers: params.withSubscribers,
        level_ids: params.levelIds,
        chunk: params.chunk,
        offset: params.offset,
        sort_by: params.sortBy,
        sort_order: params.sortOrder,
        limit: 100
    });
    return data;
};
const fetchDialogList = actionCreatorAsync$S("fetchDialogList", async (params)=>{
    return fetchDialogueListCommon(params);
});
const fetchDialogListMore = actionCreatorAsync$S("fetchDialogListMore", async (params)=>{
    return fetchDialogueListCommon(params);
});
const fetchDialogById = actionCreatorAsync$S("fetchDialogById", async (params, dispatch)=>{
    const { data } = await Api$1.dialog.fetchDialog(params.dialogId);
    if (data == null ? void 0 : data.messages) dispatch(addMessagesFromActiveDialogue({
        messages: data.messages.data
    }));
    return data;
});
const fetchDialogByUserId = actionCreatorAsync$S("fetchDialogByIUserId", async (params, dispatch)=>{
    const { data } = await Api$1.dialog.fetchDialogueByUserId({
        user_id: params.userId
    });
    if (data == null ? void 0 : data.messages) dispatch(addMessagesFromActiveDialogue({
        messages: data.messages.data
    }));
    return data;
});
actionCreatorAsync$S("fetchCurrentDialog", async (params, dispatch)=>{
    const { data } = await Api$1.dialog.fetchDialogueByUserId({
        user_id: params.userId
    });
    dispatch(updateActiveDialogueRelation({
        relation: data.relation
    }));
    return data;
});
actionCreatorAsync$S("createDialog", async ({ userId })=>{
    try {
        const { data } = await Api$1.dialog.create({
            user_id: userId
        });
        return data;
    } catch (err) {
        throw new ApiError(err);
    }
});
actionCreatorAsync$S("sendMessage", async ({ userId, dialogId, data, teaserData, price }, dispatch)=>{
    const messageId = Date.now();
    const sentMessage = {
        authorId: userId,
        createdAt: Math.floor(Date.now() / 1e3),
        data: data,
        teaser: teaserData,
        dialogId: dialogId,
        id: messageId,
        isSending: true,
        price: price
    };
    dispatch(addNewMessageDialogue({
        message: sentMessage
    }));
    try {
        const { data: message2 } = await Api$1.dialog.sendMessage(dialogId, JSON.stringify(data), JSON.stringify(teaserData), price);
        dispatch(markAsReadMessage.action({
            dialogId: message2.dialogId,
            messageId: message2.id
        }));
        dispatch(removeMessageSendingStatus({
            dialogId: dialogId,
            messageId: messageId
        }));
        dispatch(addNewMessageDialogue({
            message: message2
        }));
        dispatch(updateLastMessageDialogue({
            message: message2
        }));
        return message2;
    } catch (err) {
        dispatch(setErrorStatusSendingMessage({
            dialogId: dialogId,
            messageId: messageId
        }));
        throw new ApiError(err);
    }
});
const sendBroadcastMessage = actionCreatorAsync$S("sendBroadcastMessage", async (params)=>{
    const { data } = await Api$1.dialog.sendBroadcastMessage(params.blogUrl, {
        subscription_level_ids: params.subscriptionLevelIds,
        subscription_months_duration_from: params.subscriptionMonthsDurationFrom,
        subscription_months_duration_to: params.subscriptionMonthsDurationTo,
        money_spent_from: params.moneySpentFrom,
        money_spent_to: params.moneySpentTo,
        paid_subscription_canceled: params.paidSubscriptionCanceled,
        exclude_subscriber_ids: params.excludeSubscriberIds,
        fixed_subscriber_ids: params.fixedSubscriberIds,
        all_subscribers: params.isAllSubscribers,
        price: params.price,
        notify_users_by_email: params.isNotifyUsersByEmail,
        data: JSON.stringify(params.data),
        teaser_data: JSON.stringify(params.teaserData)
    });
    return data;
});
const fetchMessage = actionCreatorAsync$S("fetchMessage", async ({ messageId }, dispatch)=>{
    const { data } = await Api$1.dialog.fetchMessage(messageId);
    dispatch(updateMessage({
        message: data
    }));
    dispatch(updateLastMessageDialogue({
        message: data
    }));
    return data;
});
actionCreatorAsync$S("deleteMessage", async ({ dialogId, messageIds, forAll }, dispatch)=>{
    const { data } = await Api$1.dialog.deleteMessage(dialogId, {
        message_ids: messageIds,
        for_all: forAll
    });
    messageIds.forEach((messageId)=>void dispatch(removeMessageDialogue({
            dialogId: dialogId,
            messageId: messageId
        })));
    return data;
});
const markAsReadMessage = actionCreatorAsync$S("markAsReadMessage", async ({ dialogId, messageId })=>{
    await Api$1.dialog.markAsReadMessage(messageId);
});
actionCreatorAsync$S("markAsReadAllMessages", async ({ messageId })=>{
    await Api$1.dialog.markAsReadAll({
        message_id: messageId
    });
});
actionCreatorAsync$S("fetchDialogShort", async ({ dialogId }, dispatch)=>{
    const { data } = await Api$1.dialog.fetchDialogShort(dialogId);
    dispatch(updateDialogueList({
        dialogue: data
    }));
    return data;
});
const fetchMessagesPart = actionCreatorAsync$S("fetchMessagesPart", async ({ dialogId, limit, reverse, offset: offset2 })=>{
    const { data } = await Api$1.dialog.fetchMessages(dialogId, {
        limit: limit,
        reverse: reverse,
        offset: offset2
    });
    return data;
});
const fetchContactsCommon = async (params)=>{
    const { data } = await Api$1.dialog.fetchContacts({
        with_subscriptions: params.withSubscriptions,
        with_subscribers: params.withSubscribers,
        level_ids: params.levelIds,
        chunk: params.chunk,
        offset: params.offset,
        sort_by: params.sortBy,
        sort_order: params.sortOrder,
        limit: 100
    });
    return data;
};
const fetchContacts = actionCreatorAsync$S("fetchContacts", async (params)=>{
    return fetchContactsCommon(params);
});
const fetchContactsMore = actionCreatorAsync$S("fetchContactsMore", async (params)=>{
    return fetchContactsCommon(params);
});
const fetchMailingListCommon = async (params)=>{
    const { data } = await Api$1.dialog.fetchMailingList(params.blogUrl, {
        subscription_months_duration_from: params.subscriptionMonthsDurationFrom,
        subscription_months_duration_to: params.subscriptionMonthsDurationTo,
        money_spent_from: params.moneySpentFrom,
        money_spent_to: params.moneySpentTo,
        paid_subscription_canceled: params.paidSubscriptionCanceled,
        subscription_level_ids: params.subscriptionLevelIds,
        sort_by: params.sortBy,
        sort_order: params.sortOrder,
        chunk: params.chunk,
        offset: params.offset,
        limit: 100
    });
    return data;
};
const fetchMailingList = actionCreatorAsync$S("fetchMailingList", async (params)=>{
    return fetchMailingListCommon(params);
});
const fetchMailingListMore = actionCreatorAsync$S("fetchMailingListMore", async (params)=>{
    return fetchMailingListCommon(params);
});
const fetchChatMateSubscriptionLevels = actionCreatorAsync$S("fetchChatMateSubscriptionLevels", async ({ blogUrl, showFree, showDeleted })=>{
    const { data } = await Api$1.blog.fetchSubscriptionLevels(blogUrl, showFree, showDeleted);
    return {
        levels: data.data,
        subscriptions: data.subscriptions,
        currentLevelId: data.currentId,
        nextLevelId: data.nextId
    };
});
const fetchCanWriteWithDonationFlag = actionCreatorAsync$S("fetchCanWriteWithDonationFlag", async (params)=>{
    const { data } = await Api$1.dialog.getCanWriteWithDonationFlag(params.blogUrl);
    return data;
});
const updateActiveDialogueRelation = actionCreator$_("updateActiveDialogueRelation");
const updateDialogueList = actionCreator$_("updateDialogueList");
const updateMessage = actionCreator$_("updateMessage");
const messageHasBeenPaid = actionCreator$_("messageHasBeenPaid");
const updateLastMessageDialogue = actionCreator$_("updateLastMessageDialogue");
const updateContactBlackListedFromWs = actionCreator$_("updateContactBlackListedFromWs");
const markAsReadMessageFromWs = actionCreator$_("markAsReadMessageFromWs");
const addMessagesFromActiveDialogue = actionCreator$_("addMessageListFromActiveDialogue");
const addNewMessageDialogue = actionCreator$_("addNewMessageDialogue");
const saveDonationMessage = actionCreator$_("saveDonationMessage");
const clearDonationMessage = actionCreator$_("clearDonationMessage");
const dialogueListToggleIsNeedUpdate = actionCreator$_("dialogueListToggleIsNeedUpdate");
const dialogueBroadcastMessagesDone = actionCreator$_("dialogueBroadcastMessagesDone");
const removeMessageDialogue = actionCreator$_("removeMessageDialogue");
const removeMessageSendingStatus = actionCreator$_("removeMessageSendingStatus");
const setErrorStatusSendingMessage = actionCreator$_("setErrorStatusSendingMessage");
const chatmateSetIsTypingMessage = actionCreator$_("chatmateSetIsTypingMessage");
const clearMessagesActiveDialogue = actionCreator$_("clearMessagesActiveDialog");
const clearMailingList = actionCreator$_("clearMailingList");
const clearContactList = actionCreator$_("clearContactList");
const clearDialogueList = actionCreator$_("clearDialogList");
const changeMessagesCount = actionCreator$_("changeMessagesCount");
const actionCreator$Z = (0, $99y5v.actionCreatorFactory)("Payment");
const actionCreatorAsync$R = (0, $7Uc0p.asyncFactory)(actionCreator$Z);
const fetchDefaultCurrency = actionCreatorAsync$R("fetchDefaultCurrency", async ()=>{
    const response = await Api$1.payment.fetchDefaultCurrency();
    return response.data;
});
const actionCreator$Y = (0, $99y5v.actionCreatorFactory)("Smile");
const actionCreatorAsync$Q = (0, $7Uc0p.asyncFactory)(actionCreator$Y);
const fetchSmileUserSet = actionCreatorAsync$Q("fetchSmileUserSet", async ({ blogUrl })=>{
    const response = await Api$1.smile.fetchUserSet(blogUrl);
    return response.data.data.sets;
});
const fetchSmileUserPopularSet = actionCreatorAsync$Q("fetchSmileUserPopularSet", async ({ blogUrl })=>{
    const response = await Api$1.smile.fetchUserSetPopular(blogUrl);
    return response.data.data.set;
});
const createSmile = actionCreatorAsync$Q("createSmile", async ({ blogUrl, params })=>{
    const { baseName, levelId, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.smile.create(blogUrl, {
        base_name: baseName,
        level_id: levelId,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data.data.smile;
});
const updateSmile = actionCreatorAsync$Q("updateSmile", async ({ blogUrl, smileId, params })=>{
    const { baseName, levelId, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.smile.update(blogUrl, smileId, {
        base_name: baseName,
        level_id: levelId,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data.data.smile;
});
const removeSmile = actionCreatorAsync$Q("removeSmile", async ({ blogUrl, smileId })=>{
    await Api$1.smile.remove(blogUrl, smileId);
    return {};
});
const fetchSmileList = actionCreatorAsync$Q("fetchSmileList", async ({ blogUrl })=>{
    const response = await Api$1.smile.fetchList(blogUrl);
    return response.data.data;
});
actionCreatorAsync$Q("fetchSmileListByLevel", async ({ blogUrl, levelId })=>{
    const response = await Api$1.smile.fetchListByLevel(blogUrl, levelId);
    return response.data.data.smiles;
});
actionCreatorAsync$Q("checkSmileName", async ({ blogUrl, baseName })=>{
    const response = await Api$1.smile.checkSmileName(blogUrl, {
        base_name: baseName
    });
    return response.data;
});
actionCreatorAsync$Q("uploadSmileImage", async ({ blogUrl, smileSize, file })=>{
    const response = await Api$1.smile.uploadImage(blogUrl, smileSize, file);
    return response.data.data.upload;
});
const changeSmileOrder = actionCreatorAsync$Q("changeSmileOrder", async ({ blogUrl, levelId, params })=>{
    const response = await Api$1.smile.changeOrder(blogUrl, levelId, {
        moved_smile_id: params.movedSmileId,
        smile_ids: params.smileIds
    });
    return response.data;
});
const clearSmiles = actionCreator$Y("clearSmiles");
const clearSmilesList = actionCreator$Y("clearSmilesList");
const fetchSmileData = actionCreatorAsync$Q("fetchSmileData", async ({ smileId })=>{
    const response = await Api$1.smile.fetchSmileData(smileId);
    return response.data.data;
});
const clearSmileData = actionCreator$Y("clearSmileData");
const actionCreator$X = (0, $99y5v.actionCreatorFactory)("CurrentUser");
const actionCreatorAsync$P = (0, $7Uc0p.asyncFactory)(actionCreator$X);
const setCurrentUserStore = actionCreator$X("setCurrentUserStore");
const resetCurrentUserStore = actionCreator$X("resetCurrentUserStore");
const setCurrentUser = actionCreatorAsync$P("setCurrentUser", async (payload, dispatch, getState)=>{
    var _a3, _b2;
    const { currentUser: currentUser2, blog: { blog: blog2 } } = getState();
    const isBlogPostPage = Boolean(matchPath(URLS.BLOG_POST, window.location.pathname));
    if (payload != null && (payload.user != null && (currentUser2.user.data == null || currentUser2.user.data.id !== payload.user.id) || payload.user == null && currentUser2.user !== null)) {
        AppStat.setCurrentUser(payload.user);
        const promises = [
            dispatch(refetchBlog()),
            dispatch(refetchBlogSubscriptionLevels()),
            dispatch(refetchSubscriptionsSettingsData()),
            dispatch(refetchStream())
        ];
        if (!isStreamApp()) promises.push(dispatch(refetchSubscriptions()));
        if (isBlogPostPage) {
            const matchBlogPostPage = matchPath(URLS.BLOG_POST, window.location.pathname);
            const postId = matchBlogPostPage && matchBlogPostPage.params.postId;
            promises.push(dispatch(refetchBlogPost(postId)));
        } else promises.push(dispatch(refetchFeed()));
        if ((_a3 = blog2 == null ? void 0 : blog2.data) == null ? void 0 : _a3.blogUrl) promises.push(dispatch(refetchTargets({
            blogUrl: (_b2 = blog2 == null ? void 0 : blog2.data) == null ? void 0 : _b2.blogUrl
        })));
        if (payload.user == null) promises.push(dispatch(resetCurrentUserStore(null)), dispatch(clearSubscriptions()), dispatch(resetBlackList()), dispatch(clearSmiles()), dispatch(clearBadges()));
        await Promise.allSettled(promises);
    }
    dispatch(setCurrentUserStore(payload));
});
const setCurrentUserPhone = actionCreator$X("setCurrentUserPhone");
const removePayBind = actionCreator$X("removePayBind");
const fetchCurrentUser = actionCreatorAsync$P("fetchCurrentUser", async (payload, dispatch)=>{
    const authToken = tryGetAuthCookie();
    if (authToken) {
        const response = await Api$1.user.fetchCurrent();
        return dispatch(setCurrentUser.action({
            user: response.data
        }));
    } else throw new ApiError({
        message: "Empty auth token"
    });
});
const fetchCurrentUserPhone = actionCreatorAsync$P("fetchCurrentUserPhone", async ()=>{
    const { data } = await Api$1.user.fetchCurrentPhone();
    return {
        refPhone: data.phone
    };
});
const refetchUser = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.currentUser.user.meta.networkStatus.isFetched) return dispatch(fetchCurrentUser.action());
        else return null;
    };
const fetchPaymentBinds = actionCreatorAsync$P("getPaymentBinds", async ({ withDeleted, currency })=>{
    const { data } = await Api$1.user.getPaymentBinds(currency, withDeleted);
    const isCardBank131Enabled = isConditionalFeatureEnable(EConditionalFeature.PAYMENT_CARD_BANK131);
    const list2 = data.data.filter((bindItem)=>{
        return isCardBank131Enabled && bindItem.payMethod === EPaymentMethod.CARD_BANK131 || !isCardBank131Enabled && bindItem.payMethod === EPaymentMethod.CARD;
    });
    return {
        list: list2,
        extra: data.extra
    };
});
actionCreatorAsync$P("requestToRemovePayBind", async ({ id }, dispatch)=>{
    const { data: { status } } = await Api$1.payment.removePaymentBind(id);
    if (status) dispatch(removePayBind({
        id: id
    }));
    else throw new ApiError({
        message: "Remove bind status false"
    });
});
const updateUserFlag = actionCreatorAsync$P("updateUserFlag", async ({ flag })=>{
    const { data } = await Api$1.user.updateUserFlag(flag);
    return data;
});
const setUserFlag = actionCreator$X("setUserFlag");
const unsetUserFlag = actionCreator$X("unsetUserFlag");
const updateUserData = actionCreatorAsync$P("updateUserData", async (params)=>{
    const { notifyComment: notify_comment, notifyNews: notify_news, notifySubscriber: notify_subscriber, socialEmailConfirmed: social_email_confirmed, canViewAdultContent: can_view_adult_content, sendMsgRule: send_msg_rule, sendMsgLevelId: send_msg_level_id, ...updateUserDataParams } = params;
    const { data } = await Api$1.user.update({
        ...updateUserDataParams,
        notify_comment: notify_comment,
        notify_news: notify_news,
        notify_subscriber: notify_subscriber,
        social_email_confirmed: social_email_confirmed,
        can_view_adult_content: can_view_adult_content,
        send_msg_rule: send_msg_rule,
        send_msg_level_id: send_msg_level_id
    });
    return data;
});
const updateCurrentUserPhone = actionCreatorAsync$P("updateCurrentUserPhone", async (params)=>{
    const { changePhone: { isNotifierFlowForced } } = getConfig();
    const { oldPhone, phone } = params;
    const { data } = await Api$1.user.updateCurrentUserPhone({
        old_phone: oldPhone,
        phone: phone,
        token: params == null ? void 0 : params.token,
        captcha_version: params == null ? void 0 : params.captchaVersion,
        force: !!(params == null ? void 0 : params.force) || isNotifierFlowForced
    });
    return data;
});
const approveCurrentUserPhone = actionCreatorAsync$P("approveCurrentUserPhone", async (params, dispatch)=>{
    const { changePhone: { isNotifierFlowForced } } = getConfig();
    const { isOld, smsCode, phone, code, force } = params;
    const { data } = await Api$1.user.approveCurrentUserPhone({
        is_old: isOld,
        sms_code: smsCode,
        phone: phone,
        code: code,
        force: !!force || isNotifierFlowForced
    });
    dispatch(setCurrentUserPhone(data.phone));
    return data;
});
const verifyOldPhone = actionCreatorAsync$P("verifyOldPhone", async (params)=>{
    const { changePhone: { isNotifierFlowForced } } = getConfig();
    const { data } = await Api$1.user.verifyOldPhone({
        token: params == null ? void 0 : params.token,
        captcha_version: params == null ? void 0 : params.captchaVersion,
        force: !!(params == null ? void 0 : params.force) || isNotifierFlowForced
    });
    return data;
});
const acceptPrivacyPolicy = actionCreatorAsync$P("acceptPrivacyPolicy", async ({ version: version2 })=>{
    const { data } = await Api$1.user.acceptPrivacyPolicy({
        version: version2
    });
    return data;
});
const acceptRefPolicy = actionCreatorAsync$P("acceptRefPolicy", async ({ version: version2 })=>{
    const { data } = await Api$1.user.acceptRefPolicy({
        version: version2
    });
    return data;
});
const uploadUserAvatar = actionCreatorAsync$P("uploadUserAvatar", async ({ avatar: avatar2 })=>{
    const { data } = await Api$1.user.uploadAvatar(avatar2);
    return data;
});
const checkNick = actionCreatorAsync$P("checkNick", async ({ nick: nick2 })=>{
    const { data } = await Api$1.user.checkNick(nick2);
    return data;
});
const editSettings = actionCreatorAsync$P("editSettings", async (settings2, dispatch)=>{
    const { name: name2, nick: nick2, photo } = settings2;
    const [userRes, photoRes] = await Promise.all([
        dispatch(updateUserData.action({
            name: name2,
            nick: nick2
        })),
        photo ? dispatch(uploadUserAvatar.action({
            avatar: photo
        })) : null
    ]);
    const newAvatarUrl = photoRes != null ? photoRes.url : userRes.avatarUrl;
    return {
        ...userRes,
        avatarUrl: newAvatarUrl,
        hasAvatar: newAvatarUrl != null
    };
});
actionCreatorAsync$P("sendEmailConfirmationLetter", async ()=>{
    await Api$1.user.sendEmailConfirmationLetter();
});
const dismissEmail = actionCreatorAsync$P("dismissEmail", async ()=>{
    const { data } = await Api$1.user.update({
        email: ""
    });
    return data;
});
actionCreatorAsync$P("finishTutorial", async ()=>{
    await Api$1.user.finishTutorial();
});
actionCreatorAsync$P("removeAuthLink", async ({ type }, dispatch)=>{
    const appPath = EExternalAppPaths[type.toUpperCase()];
    await Api$1.user.removeAuthLink(appPath);
    dispatch(fetchCurrentUser.action());
    dispatch(refetchBlogSubscriptionLevels());
});
const checkPhone = actionCreatorAsync$P("checkPhone", async (params)=>{
    const { data } = await Api$1.user.checkPhone(params);
    return data;
});
const checkPhoneAdditionStatus = actionCreatorAsync$P("checkPhoneAdditionStatus", async ()=>{
    const { data } = await Api$1.user.checkPhoneAdditionStatus();
    return data;
});
actionCreatorAsync$P("checkCurrentUserPhone", async (params)=>{
    const { data } = await Api$1.user.checkCurrentUserPhone(params);
    return data;
});
actionCreator$X("setAccountDeletionTime");
actionCreatorAsync$P("deleteAccount", async (_2, dispatch)=>{
    const { data } = await Api$1.user.scheduleAccountDeletion();
    dispatch(fetchCurrentUser.action());
    return data;
});
actionCreatorAsync$P("cancelAccountDeletion", async (_2, dispatch)=>{
    await Api$1.user.cancelAccountDeletion();
    dispatch(fetchCurrentUser.action());
});
const updateUserBanStatus = actionCreator$X("updateUserBanStatus");
const fetchMarketingAlerts = actionCreatorAsync$P("fetchMarketingAlerts", async ()=>{
    const lang = getCurrentLanguage();
    const response = await Api$1.user.fetchMarketingAlerts({
        lang: lang
    });
    return response.data;
});
const dismissMarketingAlert = actionCreatorAsync$P("dismissMarketingAlert", async ({ alertId }, dispatch)=>{
    const response = await Api$1.user.dismissMarketingAlert(alertId);
    dispatch(fetchMarketingAlerts.action());
    return response;
});
actionCreatorAsync$P("oauthServerAuthorize", async (payload)=>{
    const { clientId, redirectUrl, responseType } = payload;
    const response = await Api$1.user.oauthServerAuthorize({
        client_id: clientId,
        redirect_uri: redirectUrl,
        response_type: responseType
    });
    return response.data;
});
const selectCurrency = actionCreator$X("selectCurrency");
const clearSelectedCurrency = actionCreator$X("clearSelectedCurrency");
actionCreator$X("changeDefaultCurrency", ({ currency }, dispatch, getState)=>{
    const { currentUser: { user: { data, meta: { networkStatus: networkStatus2 } } } } = getState();
    if (currency !== data.defaultCurrency && networkStatus2.isFetched) dispatch(refetchItemsWithPrices());
});
const refetchItemsWithPrices = ()=>async (dispatch, getState)=>{
        var _a3, _b2, _c2, _d;
        const { dialogue: { dialogueActive }, blog: { blog: blog2 } } = getState();
        const promises = [
            dispatch(refetchBlogSubscriptionLevels()),
            dispatch(refetchStream()),
            dispatch(refetchUser()),
            dispatch(refetchFeed())
        ];
        if ((_a3 = blog2 == null ? void 0 : blog2.data) == null ? void 0 : _a3.blogUrl) promises.push(dispatch(refetchTargets({
            blogUrl: (_b2 = blog2 == null ? void 0 : blog2.data) == null ? void 0 : _b2.blogUrl
        })));
        if ((_c2 = dialogueActive == null ? void 0 : dialogueActive.data) == null ? void 0 : _c2.id) promises.push(dispatch(fetchDialogById({
            dialogId: (_d = dialogueActive == null ? void 0 : dialogueActive.data) == null ? void 0 : _d.id
        })));
        return Promise.all(promises);
    };
actionCreatorAsync$P("setLocale", async ({ locale: locale2 })=>{
    const lang = getLangByLocale(locale2);
    return Api$1.user.setLocale(lang);
});
const updateUserDialogsSettings = actionCreatorAsync$P("updateUserDialogsSettings", async (data)=>{
    await Api$1.user.updateDialogSettings({
        send_msg_level_id: data.sendMsgLevelId,
        can_send_all: data.canSendAll,
        can_send_donation: data.canSendDonation,
        can_send_my_authors: data.canSendMyAuthors,
        can_send_paid_subscribers: data.canSendPaidSubscribers,
        can_send_subscribers: data.canSendSubscribers
    });
});
const updateNicknameColor = actionCreatorAsync$P("updateNicknameColor", async ({ color: color2 })=>{
    await Api$1.user.updateNicknameColor(color2);
});
const fetchLinkedBoosty = actionCreatorAsync$P("fetchLinkedBoosty", async ()=>{
    const { data } = await Api$1.user.fetchBoostyLink();
    return data.data;
});
const clearVkPlayMergeTarget = actionCreator$X("clearVkPlayMergeTarget");
const fetchVkPlayMergeTargetAccessToken = actionCreatorAsync$P("fetchVkPlayMergeTargetAccessToken", async (params)=>{
    const result2 = await Api$1.user.fetchVKPlayToken({
        ...params,
        allowedActorStatus: EAllowedActorStatus.EXISTING_ACCOUNT
    });
    return {
        data: result2.data.access_token
    };
});
const fetchVkPlayMergeTargetUser = actionCreatorAsync$P("fetchVkPlayMergeTargetUser", async (params, dispatch)=>{
    const { targetAccessToken } = params;
    const result2 = await Api$1.user.fetchVkPlayMergeTargetUser({
        targetAccessToken: targetAccessToken
    });
    return {
        data: result2.data.data
    };
});
actionCreatorAsync$P("mergeVkPlayTargetUser", async (params, dispatch)=>{
    const { targetAccessToken } = params;
    await Api$1.user.mergeVKPlay({
        targetAccessToken: targetAccessToken
    });
    dispatch(clearVkPlayMergeTarget());
    dispatch(refetchUser());
    dispatch(refetchSubscriptions());
    return {};
});
actionCreator$X("setVkPlayMergeTargetAccessToken");
actionCreatorAsync$P("linkVKPlay", async ({ accessTokenVKPlay })=>{
    const { data } = await Api$1.user.linkVKPlay({
        access_token: accessTokenVKPlay
    });
    return data;
});
actionCreatorAsync$P("loginWithExistsToken", async (params)=>{
    const { accessToken } = params;
    return await Api$1.user.loginWithExistsToken(accessToken);
});
const fetchNotifications = actionCreatorAsync$P("fetchNotifications", async ()=>{
    const { data: { data } } = await Api$1.notifications.fetchNotifications();
    const validNotificationList = data.notificationStandalone.events.filter(({ type })=>isValidNotificationType(type));
    return {
        list: validNotificationList,
        updateTime: data.notificationStandalone.updateTime,
        count: data.notificationStandalone.count
    };
});
const markNotificationsAsRead = actionCreatorAsync$P("markNotificationsAsRead", async (params = {}, _2, getState)=>{
    var _a3, _b2, _c2, _d;
    const ids = params.notificationIds || ((_a3 = getState().currentUser.notifications.data) == null ? void 0 : _a3.list.filter(({ isRead })=>!isRead).map(({ id })=>id));
    if (ids.length) {
        const { data: { data } } = await Api$1.notifications.markAsRead(ids);
        return {
            notificationIds: ids,
            newUnreadCount: data.notificationStandalone.count.unread
        };
    }
    return {
        notificationIds: ids,
        newUnreadCount: (_d = (_c2 = (_b2 = getState().currentUser) == null ? void 0 : _b2.user) == null ? void 0 : _c2.data) == null ? void 0 : _d.counts.unreadStandaloneNotify
    };
});
const removeNotification = actionCreatorAsync$P("removeNotification", async (params)=>{
    await Api$1.notifications.remove(params.id);
});
const changeUnreadNotificationsCount = actionCreator$X("changeUnreadNotificationsCount");
const NOTIFICATION_TYPE_MAP = {
    [EExternalNotificationType.SUBSCRIBER]: "new_subscriber",
    [EExternalNotificationType.MESSAGE]: "new_message",
    [EExternalNotificationType.COMMENT]: "new_comment",
    [EExternalNotificationType.REPLY]: "new_reply",
    [EExternalNotificationType.NEWS]: "other_news",
    [EExternalNotificationType.STREAM]: "new_stream"
};
actionCreatorAsync$P("notifySettingsOld", async ({ notificationType, transport })=>{
    return await Api$1.user.notifySettingsOld(NOTIFICATION_TYPE_MAP[notificationType], transport);
});
const toggleUserFlag = actionCreatorAsync$P("toggleUserFlag", async ({ blogUrl, value: value2, flag }, _2)=>{
    await Api$1.blog.updateFlag(blogUrl, {
        flag: flag,
        value: value2
    });
    return {
        value: value2,
        flag: flag
    };
});
const fetchManagedChannels = actionCreatorAsync$P("fetchManagedChannels", async ()=>{
    const result2 = await Api$1.user.fetchManagedChannels();
    return {
        data: result2.data.data.channels,
        extra: result2.data.extra
    };
});
const toggleGiftOnlyAsFollower = actionCreatorAsync$P("toggleGiftOnlyAsFollower", async ({ isChecked }, _2)=>{
    try {
        if (isChecked) await Api$1.user.enableGiftReceivingOnlyAsFollower();
        else await Api$1.user.disableGiftReceivingOnlyAsFollower();
    } catch (ignore) {
        return {};
    }
    return {
        isChecked: isChecked
    };
});
const fetchUserCurrentLink = actionCreatorAsync$P("fetchUserCurrentLink", async ()=>{
    const result2 = await Api$1.user.fetchUserCurrentLink();
    return {
        links: result2.data.data.links
    };
});
const cleanManageChannels = actionCreator$X("cleanManageChannels");
const confirmEmail = actionCreatorAsync$P("confirmEmail", async ({ code, email })=>{
    const { data } = await Api$1.user.confirmEmail({
        email_code: code,
        email: email
    });
    return data;
});
const editBlogCover = actionCreatorAsync$Z("editBlogCover", async ({ blogUrl, file })=>{
    const response = await Api$1.blog.coverUpload(blogUrl, file);
    return {
        url: response.data.url
    };
});
actionCreatorAsync$Z("becomeStreamer", async ({ blogUrl, hasAdultContent }, dispatch)=>{
    await Api$1.blog.update(blogUrl, {
        is_streamer: true,
        ...hasAdultContent ? {
            has_adult_content: true
        } : {}
    });
    dispatch(refetchUser());
    return {};
});
const editBlog = actionCreatorAsync$Z("editBlog", async ({ blogUrl, blog: blog2 }, dispatch)=>{
    const { title: title2, description: description2, hasAdultContent } = blog2;
    const response = await Api$1.blog.update(blogUrl, {
        title: title2 || "",
        data: JSON.stringify(prepareBlogPostDataForSave(description2)),
        ...hasAdultContent != null && {
            has_adult_content: Boolean(hasAdultContent)
        }
    });
    return {
        blog: response.data
    };
});
const createBlog = actionCreatorAsync$Z("createBlog", async ({ email, blogUrl, hasAdultContent, isStreamer, nick: nick2 }, dispatch)=>{
    const response = await Api$1.blog.create({
        email: email,
        blog_url: blogUrl,
        has_adult_content: hasAdultContent,
        ...isStreamer ? {
            is_streamer: true
        } : {},
        ...nick2 ? {
            nick: nick2
        } : {}
    });
    dispatch(refetchUser());
    return {
        blogUrl: response.data.blogUrl
    };
});
actionCreator$16("resetBlogStore");
const fetchFeedTags = actionCreatorAsync$Z("fetchFeedTags", async ({ blogUrl })=>{
    const response = await Api$1.blog.fetchPostsTags(blogUrl);
    return {
        data: response.data.data
    };
});
const refetchFeedTags = ()=>async (dispatch, getState)=>{
        const state = getState();
        if (state.blog.postsTags.meta.networkStatus.isFetched) return dispatch(fetchFeedTags.action({
            blogUrl: state.blog.blog.data.blogUrl
        }));
        else return null;
    };
const unsubscribeBlog = actionCreatorAsync$Z("unsubscribeBlog", async ({ blogUrl, isKeepFollow }, dispatch)=>{
    await Api$1.blog.unsubscribe(blogUrl, {
        keep_follow: isKeepFollow
    });
    dispatch(refetchUser());
    dispatch(refetchSubscriptions());
    dispatch(onSubscribedStateChange(true));
    if (!isStreamApp()) dispatch(refetchStream());
    return {
        blogUrl: blogUrl
    };
});
const followBlog = actionCreatorAsync$Z("followBlog", async ({ blogUrl }, dispatch)=>{
    await Api$1.blog.follow(blogUrl);
    dispatch(refetchSubscriptions());
    if (!isStreamApp()) dispatch(refetchStream());
});
const unfollowBlog = actionCreatorAsync$Z("unfollowBlog", async ({ blogUrl }, dispatch)=>{
    await Api$1.blog.unsubscribe(blogUrl);
    dispatch(refetchSubscriptions());
    if (!isStreamApp()) dispatch(refetchStream());
    return {
        blogUrl: blogUrl
    };
});
actionCreatorAsync$Z("complainBlog", async ({ blogUrl })=>{
    await Api$1.blog.complain(blogUrl);
    return {};
});
actionCreatorAsync$Z("updateSocialLinks", async ({ blogUrl, socialLinks }, dispatch)=>{
    const socialLinksData = socialLinks.reduce((acc, current)=>({
            ...acc,
            [current.type]: current.url
        }), {});
    await Api$1.blog.updateSocialLinks(blogUrl, {
        ...socialLinksData
    });
    return dispatch(refetchBlog());
});
actionCreatorAsync$Z("fetchBlogOwner", async ({ blogUrl })=>{
    const response = await Api$1.blog.fetch(blogUrl);
    return response.data.owner;
});
actionCreatorAsync$Z("searchUser", async ({ blogUrl, chunk, limit })=>{
    const { data: { data } } = await Api$1.blog.searchUser(blogUrl, chunk, limit);
    return data;
});
const changeSubscribersCount = actionCreator$16("changeSubscribersCount");
const setIsCurrentUserTouchedFeedFilter = actionCreator$16("setIsCurrentUserTouchedFeedFilter");
const fetchPostDonations = actionCreatorAsync$Z("fetchPostDonations", async (params)=>{
    var _a3;
    const { data } = await Api$1.blog.fetchPostDonations(params.blogUrl, {
        limit: params.limit,
        offset: (_a3 = params.offset) == null ? void 0 : _a3.toString(),
        target_id: params.postId,
        type: "post"
    });
    return data;
});
const changeBlacklistedStatus = actionCreator$16("changeBlacklistedStatus");
const increasePostDonationsSum = actionCreator$16("increasePostDonationsSum");
actionCreatorAsync$Z("fetchBlogRef", async ({ blogUrl })=>{
    const { data: { blogger_id: bloggerId } } = await Api$1.blog.fetchRef(blogUrl);
    return {
        bloggerId: bloggerId
    };
});
const fetchRssLink = actionCreatorAsync$Z("fetchRssLink", async ({ blogUrl })=>{
    const { data: { rss } } = await Api$1.blog.fetchRssLink(blogUrl);
    return rss;
});
const toggleRss = actionCreatorAsync$Z("toggleRss", async ({ blogUrl, value: value2 }, _2, getState)=>{
    var _a3;
    let payloadValue;
    if (value2 !== void 0) payloadValue = value2;
    else {
        const isRssCurrentlyEnabled = (_a3 = getState().blog.blog.data.flags) == null ? void 0 : _a3.isRssFeedEnabled;
        payloadValue = !isRssCurrentlyEnabled;
    }
    await Api$1.blog.updateFlag(blogUrl, {
        flag: EBlogSettingsFlags.IS_RSS_FEED_ENABLED,
        value: payloadValue
    });
    return {
        isRssFeedEnabled: payloadValue
    };
});
const resetBlog = actionCreator$16("resetBlog");
const resetFeed = actionCreator$16("resetFeed");
const resetFeedTags = actionCreator$16("resetFeedTags");
const fetchBlogItem = actionCreatorAsync$Z("fetchBlogItem", async ({ blogUrl })=>{
    const response = await Api$1.blog.fetch(blogUrl);
    return {
        blog: response.data
    };
});
const updateHasAdultContent = actionCreatorAsync$Z("updateHasAdultContent", async ({ blogUrl, hasAdultContent })=>{
    await Api$1.blog.updateFlag(blogUrl, {
        flag: EBlogSettingsFlags.HAS_ADULT_CONTENT,
        value: hasAdultContent
    });
    return {
        hasAdultContent: hasAdultContent
    };
});
const fetchBlogExternal = actionCreatorAsync$Z("fetchBlogExternal", async ({ blogUrl })=>{
    const response = await Api$1.blog.fetch(blogUrl);
    return {
        blog: response.data
    };
});
const clearBlogExternal = actionCreator$16("clearBlogExternal");
const updateDescription = actionCreatorAsync$Z("updateDescription", async ({ blogUrl, description: description2 })=>{
    await Api$1.blog.updateDescription(blogUrl, {
        description: description2
    });
    return {};
});
const actionCreator$W = (0, $99y5v.actionCreatorFactory)("BlogStat");
const actionCreatorAsync$O = (0, $7Uc0p.asyncFactory)(actionCreator$W);
const clearBlogEvents = actionCreator$W("clearBlogEvens");
const clearBlogMetrics = actionCreator$W("clearBlogMetrics");
const clearBlogRefsUsers = actionCreator$W("clearBlogRefsUsers");
const fetchBlogBaseEvents = async (blogUrl, from2, to, types2, userIds, limit, offset2)=>{
    const res = await Api$1.blogStat.fetchBlogEvents(blogUrl, {
        types: types2,
        from: from2,
        to: to,
        user_ids: userIds,
        limit: limit,
        offset: offset2
    });
    return {
        ...res.data
    };
};
const fetchBlogCharts = async (blogUrl, lastTime, limit)=>{
    const { data } = await Api$1.blogStat.fetchBlogCharts(blogUrl, {
        last_time: lastTime,
        limit: limit
    });
    return {
        ...data
    };
};
const updateBlogChartsForPeriod = actionCreator$W("updateBlogChartsForPeriod");
actionCreatorAsync$O("fetchBlogChartsForPeriod", async ({ blogUrl, lastTime, limit }, dispatch)=>{
    const res = await fetchBlogCharts(blogUrl, lastTime, limit);
    dispatch(updateBlogChartsForPeriod(res));
});
const fetchBlogEvents = actionCreatorAsync$O("fetchBlogEvents", async ({ blogUrl, limit, types: types2, offset: offset2, userIds, from: from2, to })=>{
    return await fetchBlogBaseEvents(blogUrl, from2, to, types2, userIds, limit, offset2);
});
const fetchBlogHolds = actionCreatorAsync$O("fetchBlogHolds", async ({ blogUrl, offset: offset2, limit })=>{
    const { data } = await Api$1.blogStat.fetchBlogHoldsStats(blogUrl, offset2, limit);
    return data;
});
const fetchBlogMetrics = actionCreatorAsync$O("fetchBlogMetrics", async ({ blogUrl, from: from2, to })=>{
    const { data } = await Api$1.blogStat.fetchBlogMetrics(blogUrl, {
        from: from2,
        to: to
    });
    return {
        ...data
    };
});
const fetchBlogRefs = actionCreatorAsync$O("fetchBlogRefs", async ({ blogUrl })=>{
    const res = await Api$1.blogStat.fetchBlogRefs(blogUrl);
    return {
        ...res.data
    };
});
const fetchBlogRefsUsers = actionCreatorAsync$O("fetchBlogRefsUsers", async ({ blogUrl, offset: offset2, limit, onlyBloggers })=>{
    const res = await Api$1.blogStat.fetchBlogRefsUsers(blogUrl, {
        offset: offset2,
        limit: limit,
        only_bloggers: onlyBloggers
    });
    return {
        ...res.data
    };
});
const fetchBlogSearchUsers = actionCreatorAsync$O("fetchBlogSearchUsers", async (params)=>{
    const { data } = await Api$1.blogStat.fetchBlogSearchUsers(params.blogUrl, {
        chunk: params.chunk,
        limit: params.limit
    });
    return {
        ...data
    };
});
const fetchBlogStatCharts = actionCreatorAsync$O("fetchBlogStatCharts", async (params)=>{
    const { data } = await Api$1.blogStat.fetchBlogCharts(params.blogUrl, {
        last_time: params.lastTime,
        limit: params.limit
    });
    return {
        ...data
    };
});
actionCreatorAsync$O("fetchStatCsv", async ({ blogUrl, dataType, separator: separator2, from: from2, to })=>{
    const res = await Api$1.blogStat.fetchCsv(blogUrl, dataType, {
        separator: separator2,
        from: from2,
        to: to
    });
    return {
        data: res.data
    };
});
const updateBlogMetricsForPeriod = actionCreator$W("updateBlogMetricsForPeriod");
const fetchDonations = actionCreatorAsync$Z("fetchDonations", async (params)=>{
    const { data } = await Api$1.blogStat.fetchDonations(params.blogUrl, {
        limit: params.limit,
        offset: params.offset.toString(),
        sort_by: params.sortType,
        order: params.orderBy,
        target_id: params.targetId
    });
    return data;
});
const fetchPostSales = actionCreatorAsync$Z("fetchPostSales", async (params)=>{
    const { data } = await Api$1.blogStat.fetchPostSales(params.blogUrl, {
        limit: params.limit,
        offset: params.offset.toString(),
        sort_by: params.sortType,
        order: params.orderBy,
        post_ids: params.postIds
    });
    return data;
});
const fetchPostSalesByDate = actionCreatorAsync$Z("fetchPostSalesByDate", async (params)=>{
    const { data } = await Api$1.blogStat.fetchPostSalesByDate(params.blogUrl, {
        from: params.from,
        to: params.to
    });
    return data;
});
const fetchSubscribers = actionCreatorAsync$Z("fetchSubscribers", async (params)=>{
    var _a3;
    const res = await Api$1.blogStat.fetchSubscribers(params.blogUrl, {
        level_id: params.levelId,
        sort_by: params.sortBy,
        limit: params.limit,
        offset: params.offset,
        is_active: (_a3 = params.isActive) == null ? void 0 : _a3.toString(),
        user_ids: params.userIds,
        level_ids: params.levelIds,
        from: params.from,
        order: params.orderBy
    });
    return res.data;
});
const fetchPostSalesDaysByMonth = actionCreatorAsync$Z("fetchPostSalesDaysByMonth", async (params)=>{
    const { data } = await Api$1.blogStat.fetchPostSalesDaysByMonth(params.blogUrl, {
        date: params.date
    });
    return data;
});
const clearDonations = actionCreator$16("clearDonations");
const clearPostSales = actionCreator$16("clearPostSales");
const clearSubscribers = actionCreator$16("clearSubscribers");
const fetchBroadcastMessageStats = actionCreatorAsync$O("fetchBlogBroadcastMessageStat", async ({ blogUrl, offset: offset2, limit })=>{
    const { data } = await Api$1.blogStat.fetchBlogBroadcastMessageStats(blogUrl, offset2, limit);
    return {
        ...data
    };
});
const fetchBlogBaseStat = actionCreatorAsync$O("fetchBlogBaseStat", async ({ blogUrl })=>{
    const { data } = await Api$1.blogStat.fetchBlogBaseStat(blogUrl);
    return {
        ...data
    };
});
const updateNewPostId = actionCreator$$("updateNewPostId");
const updateBlogPostIsPublishedState = actionCreator$$("updateBlogPostIsPublishedState");
const resetRemovedComments = actionCreator$$("resetRemovedComments");
const createBlogPost = actionCreatorAsync$T("createBlogPost", async ({ blogUrl, blogPost, pollId }, dispatch)=>{
    const { title: title2, data, subscriptionLevel, price, teaser, tags, isCommentsDenied, isWaitingVideo, publishTime: publishTime2 } = blogPost;
    const response = await Api$1.blogPost.create(blogUrl, {
        title: title2,
        data: JSON.stringify(data),
        subscription_level_id: subscriptionLevel && subscriptionLevel.id,
        price: price,
        teaser_data: JSON.stringify(teaser),
        tags: tags.map((tag)=>tag.title),
        deny_comments: isCommentsDenied,
        wait_video: isWaitingVideo,
        publish_time: publishTime2,
        poll_id: pollId
    });
    if (response.data.isPublished) dispatch(updateNewPostId({
        postId: response.data.id
    }));
    dispatch(refetchFeedTags());
    return {
        blogPost: response.data
    };
});
const updateBlogPost = actionCreatorAsync$T("updateBlogPost", async ({ blogUrl, postId, blogPost, pollId }, dispatch)=>{
    const { title: title2, data, subscriptionLevel, price, teaser, tags, isCommentsDenied, isWaitingVideo, publishTime: publishTime2 } = blogPost;
    const response = await Api$1.blogPost.update(blogUrl, postId, {
        title: title2,
        data: JSON.stringify(data),
        subscription_level_id: subscriptionLevel && subscriptionLevel.id,
        price: price,
        teaser_data: JSON.stringify(teaser),
        tags: tags.map((tag)=>tag.title),
        deny_comments: isCommentsDenied,
        publish_time: publishTime2,
        wait_video: isWaitingVideo,
        poll_id: pollId
    });
    dispatch(refetchFeedTags());
    return {
        blogPost: response.data
    };
});
const removeBlogPost = actionCreatorAsync$T("removeBlogPost", async ({ blogUrl, postId }, dispatch)=>{
    await Api$1.blogPost.remove(blogUrl, postId);
    return {};
});
actionCreator$$("resetBlogPostStore");
const removeRedundantCommentsForPost = actionCreator$$("removeRedundantCommentsForPost");
const reactionBlogPost = actionCreatorAsync$T("reactionBlogPost", async ({ blogUrl, postId, reaction })=>{
    await Api$1.blogPost.reaction(blogUrl, postId, reaction);
    return {};
});
const removeReactionBlogPost = actionCreatorAsync$T("removeReactionBlogPost", async ({ blogUrl, postId })=>{
    await Api$1.blogPost.removeReaction(blogUrl, postId);
    return {};
});
actionCreatorAsync$T("complainBlogPost", async ({ blogUrl, postId })=>{
    await Api$1.blogPost.complain(blogUrl, postId);
    return {};
});
actionCreatorAsync$T("complainComment", async ({ blogUrl, postId, commentId })=>{
    await Api$1.blogPost.complainComment(blogUrl, postId, commentId);
});
const sendComment = actionCreatorAsync$T("sendComment", async ({ blogUrl, postId, commentData, replyComment })=>{
    const response = await Api$1.blogPost.createComment(blogUrl, postId, JSON.stringify(commentData), replyComment == null ? void 0 : replyComment.intId);
    return response.data;
});
const editComment = actionCreatorAsync$T("editComment", async ({ blogUrl, postId, commentData, originalComment })=>{
    const response = await Api$1.blogPost.updateComment(blogUrl, postId, originalComment.id, {
        data: JSON.stringify(commentData)
    });
    return response.data;
});
const removeComment = actionCreatorAsync$T("removeComment", async ({ blogUrl, postId, commentId })=>{
    return await Api$1.blogPost.removeComment(blogUrl, postId, commentId);
});
const reactionComment = actionCreatorAsync$T("reactionComment", async ({ blogUrl, postId, commentId, reaction })=>{
    return await Api$1.blogPost.reactionComment(blogUrl, postId, commentId, reaction);
});
const removeReactionComment = actionCreatorAsync$T("removeReactionComment", async ({ blogUrl, postId, commentId })=>{
    return await Api$1.blogPost.removeReactionComment(blogUrl, postId, commentId);
});
const removeCommentFromStore = actionCreator$$("removeCommentFromStore");
const restoreComment = actionCreatorAsync$T("restoreComment", async ({ blogUrl, postId, commentId })=>{
    const response = await Api$1.blogPost.restoreComment(blogUrl, postId, commentId);
    return response.data;
});
const fetchDeferredAccessLevels = actionCreatorAsync$T("fetchDeferredAccessLevels", async ({ blogUrl, postId })=>{
    const response = await Api$1.blogPost.fetchDeferredAccessLevels(blogUrl, postId);
    return response.data;
});
actionCreatorAsync$T("createDeferredAccessLevels", async ({ blogUrl, postId, denyComments, price, subscriptionLevelId, applyTime }, dispatch)=>{
    const response = await Api$1.blogPost.createDeferredAccessLevels(blogUrl, postId, {
        deny_comments: denyComments,
        price: price,
        subscription_level_id: subscriptionLevelId,
        apply_time: applyTime
    });
    dispatch(fetchDeferredAccessLevels({
        blogUrl: blogUrl,
        postId: postId
    }));
    return response.data;
});
actionCreatorAsync$T("updateDeferredAccessLevels", async ({ blogUrl, postId, deferredAccessId, denyComments, price, subscriptionLevelId, applyTime }, dispatch)=>{
    const response = await Api$1.blogPost.updateDeferredAccessLevels(blogUrl, postId, deferredAccessId, {
        deny_comments: denyComments,
        price: price,
        subscription_level_id: subscriptionLevelId,
        apply_time: applyTime
    });
    dispatch(fetchDeferredAccessLevels({
        blogUrl: blogUrl,
        postId: postId
    }));
    return response.data;
});
actionCreatorAsync$T("removeDeferredAccessLevels", async ({ blogUrl, postId, deferredAccessId }, dispatch)=>{
    const response = await Api$1.blogPost.removeDeferredAccessLevels(blogUrl, postId, deferredAccessId);
    dispatch(fetchDeferredAccessLevels({
        blogUrl: blogUrl,
        postId: postId
    }));
    return response.data;
});
const setBlogPostDrafts = actionCreatorAsync$T("setBlogPostDrafts", ({ blogPostDrafts })=>({
        blogPostDrafts: blogPostDrafts
    }));
const saveBlogPostDraft = actionCreatorAsync$T("saveBlogPostDraft", ({ blogPostDraft })=>{
    return {
        blogPostDraft: blogPostDraft
    };
});
const removeBlogPostDraft = actionCreatorAsync$T("removeBlogPostDraft", // eslint-disable-next-line sonarjs/no-identical-functions
({ blogPostDraft })=>{
    return {
        blogPostDraft: blogPostDraft
    };
});
const selectBlogPostDraft = actionCreatorAsync$T("selectBlogPostDraft", ({ blogPostDraft })=>({
        blogPostDraft: blogPostDraft
    }));
const cancelNotPublishedComment = actionCreator$$("cancelComment");
actionCreator$$("retrySendComment");
const fetchCurrentBlogPost = actionCreatorAsync$T("fetchCurrentBlogPost", async ({ blogUrl, postId, commentId, commentsLimit = getConfig().comments.fullPageLimit, repliesLimit = getConfig().comments.fullPageRepliesLimit })=>{
    const response = await Api$1.blogPost.fetch(blogUrl, postId, commentsLimit, repliesLimit, commentId);
    return {
        blogPost: response.data
    };
});
const refetchBlogPostData = actionCreatorAsync$T("refetchBlogPostData", async ({ blogUrl, postId: stringPostId, postIntId }, _2, getState)=>{
    var _a3, _b2, _c2;
    const postId = stringPostId || ((_c2 = (_b2 = (_a3 = getState().blog.posts) == null ? void 0 : _a3.data.posts) == null ? void 0 : _b2.find((post)=>post.int_id === postIntId)) == null ? void 0 : _c2.id);
    const response = await Api$1.blogPost.fetch(blogUrl, postId, 0, 0);
    return {
        blogPost: response.data
    };
});
const getCommentsListOffset = (commentsList, nextCommentsDirection)=>{
    if (nextCommentsDirection === "later") return commentsList.data[commentsList.data.length - 1].intId.toString();
    else return commentsList.data[0].intId.toString();
};
const fetchComments = actionCreatorAsync$T("fetchComments", async ({ blogUrl, postId, rootComments, threadComments, replace }, _2, getState)=>{
    var _a3, _b2, _c2, _d, _e, _f;
    const { posts } = getState().blog.posts.data;
    const post = posts.find(({ id })=>id === postId);
    if (!post) Log$5.error(`Can't find post with id ${postId} in store`);
    const requestParams = {};
    if (rootComments) {
        if (((_a3 = post.comments) == null ? void 0 : _a3.data.length) > 0 && !replace) requestParams.offset = getCommentsListOffset(post.comments, rootComments.nextCommentsDirection);
        else {
            const publishedCommentsList = ((_c2 = (_b2 = getState().blog.posts.meta.publishingCommentsList) == null ? void 0 : _b2.post[postId]) == null ? void 0 : _c2.filter((item2)=>isPublishedComment(item2))) || [];
            if (publishedCommentsList.length > 0 && !replace) requestParams.offset = publishedCommentsList[0].publishedComment.intId.toString();
        }
        requestParams.limit = rootComments.limit;
        requestParams.reply_limit = rootComments.repliesLimit;
        requestParams.order = rootComments.nextCommentsDirection === "later" ? "bottom" : "top";
    }
    if (threadComments) {
        const threadRootComment = (_d = post.comments) == null ? void 0 : _d.data.find(({ intId })=>intId === threadComments.parentId);
        if ((threadRootComment == null ? void 0 : threadRootComment.replies.data.length) > 0) requestParams.offset = getCommentsListOffset(threadRootComment.replies, threadComments.nextCommentsDirection);
        else {
            const publishedCommentsList = ((_f = (_e = getState().blog.posts.meta.publishingCommentsList) == null ? void 0 : _e.thread[threadRootComment.intId]) == null ? void 0 : _f.filter((item2)=>isPublishedComment(item2))) || [];
            if (publishedCommentsList.length > 0 && !replace) requestParams.offset = publishedCommentsList[0].publishedComment.intId.toString();
        }
        requestParams.limit = threadComments.limit;
        requestParams.parent_id = threadComments.parentId;
        requestParams.order = threadComments.nextCommentsDirection === "later" ? "bottom" : "top";
    }
    const response = await Api$1.blogPost.fetchComments(blogUrl, postId, requestParams);
    return {
        ...response.data,
        postId: postId
    };
});
const clearComments = actionCreator$$("clearComments");
const setLastActivePostId = actionCreator$$("setLastActivePostId");
const setCommentViewMeta = actionCreator$$("setCommentViewMeta");
const actionCreator$V = (0, $99y5v.actionCreatorFactory)("Catalog");
const actionCreatorAsync$N = (0, $7Uc0p.asyncFactory)(actionCreator$V);
const clearCatalogCategories = actionCreator$V("clearCatalogCategories");
const clearCatalogHistory = actionCreator$V("clearCatalogHistory");
const clearCatalogHiddenCategories = actionCreator$V("clearCatalogHiddenCategories");
const clearCatalogBlockData = actionCreator$V("clearCatalogBlockData");
const clearCatalogCategoryStreams = actionCreator$V("clearCatalogCategoryStreams");
const clearCatalogCategoryRecords = actionCreator$V("clearCatalogCategoryRecords");
actionCreator$V("clearCatalogNewestCategoriesStreams");
const clearCatalogFollowedCategoriesStreams = actionCreator$V("clearCatalogFollowedCategoriesStreams");
const clearCatalogShowcaseStreams = actionCreator$V("clearCatalogShowcaseStreams");
actionCreator$V("clearCatalogCozyStreams");
actionCreator$V("clearCatalogOftenStreams");
actionCreator$V("clearCatalogRecordedStreams");
actionCreator$V("clearCatalogVisitedStreams");
const clearCatalogStreams = actionCreator$V("clearCatalogStreams");
const clearCatalogHiddenStreams = actionCreator$V("clearCatalogHiddenStreams");
const clearCatalogSubscribedStreams = actionCreator$V("clearCatalogSubscribedStreams");
const fetchCatalogCategories = actionCreatorAsync$N("fetchCatalogCategories", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchCategories(params);
    return {
        categories: (_a3 = response.data.data) == null ? void 0 : _a3.categories,
        extra: response.data.extra
    };
});
const fetchCatalogHiddenCategories = actionCreatorAsync$N("fetchCatalogHiddenCategories", async (params)=>{
    const response = await Api$1.category.fetchHiddenCategories(params);
    return {
        categories: response.data.data.categories,
        extra: response.data.extra
    };
});
const fetchCatalogCategoryStreams = actionCreatorAsync$N("fetchCatalogCategoryStreams", async (params)=>{
    const response = await Api$1.catalog.fetchStreamsByCategory(params);
    const newData = {
        category: response.data.data.category,
        streams: response.data.data.streamBlogs.map((streamBlog)=>({
                ...streamBlog.stream,
                blogUrl: streamBlog.blog.blogUrl,
                user: streamBlog.blog.owner
            }))
    };
    return {
        data: newData,
        extra: response.data.extra
    };
});
const fetchCatalogCategoryRecords = actionCreatorAsync$N("fetchCatalogCategoryRecords", async (params)=>{
    const response = await Api$1.catalog.fetchRecordsByCategory(params);
    return response.data;
});
actionCreatorAsync$N("fetchCatalogNewestCategoriesStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchNewestCategories(params);
    return {
        categories: (_a3 = response.data.data) == null ? void 0 : _a3.categories,
        extra: response.data.extra
    };
});
const fetchCatalogFollowedCategoriesStreams = actionCreatorAsync$N("fetchCatalogFollowedCategoriesStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchFollowedCategories(params);
    return {
        categories: (_a3 = response.data.data) == null ? void 0 : _a3.categories,
        extra: response.data.extra
    };
});
const fetchCatalogRecommendedStreams = actionCreatorAsync$N("fetchCatalogRecommendedStreams", async (params)=>{
    const response = await Api$1.catalog.fetchRecommendedStreams(params);
    const newRecommendedData = response.data.data.streamBlogs.map((streamBlog)=>({
            ...streamBlog.stream,
            blogUrl: streamBlog.blog.blogUrl,
            user: streamBlog.blog.owner
        }));
    return {
        recommendedStreams: newRecommendedData
    };
});
const fetchCatalogShowcaseStreams = actionCreatorAsync$N("fetchCatalogShowcaseStreams", async ()=>{
    var _a3;
    const response = await Api$1.catalog.fetchShowcaseStreams();
    return {
        showcaseStreams: (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs.map(({ blog: blog2, stream: stream2 })=>({
                ...stream2,
                blogUrl: blog2.blogUrl,
                user: blog2.owner
            }))
    };
});
actionCreatorAsync$N("fetchCatalogCozyStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchCozyStreams(params);
    return {
        cozyStreams: (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs,
        extra: response.data.extra
    };
});
actionCreatorAsync$N("fetchCatalogOftenStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchOftenStreams(params);
    return {
        oftenStreams: (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs,
        extra: response.data.extra
    };
});
actionCreatorAsync$N("fetchCatalogRecordedStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchRecordedStreams(params);
    return {
        recordedStreams: (_a3 = response.data.data) == null ? void 0 : _a3.records,
        extra: response.data.extra
    };
});
actionCreatorAsync$N("fetchCatalogVisitedStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchVisitedStreams(params);
    return {
        visitedStreams: (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs,
        extra: response.data.extra
    };
});
const fetchCatalogHiddenStreams = actionCreatorAsync$N("fetchCatalogHiddenStreams", async (params)=>{
    const response = await Api$1.stream.fetchHidden(params);
    const newStreams = response.data.data.streamBlogs.map((streamBlog)=>({
            ...streamBlog.stream,
            blogUrl: streamBlog.blog.blogUrl,
            user: streamBlog.blog.owner
        }));
    return {
        streams: newStreams,
        extra: response.data.extra
    };
});
const fetchCatalogStreams = actionCreatorAsync$N("fetchCatalogStreams", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchStreams(params);
    const newStreams = (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs.map((streamBlog)=>({
            ...streamBlog.stream,
            blogUrl: streamBlog.blog.blogUrl,
            user: streamBlog.blog.owner
        }));
    return {
        streams: newStreams,
        extra: response.data.extra
    };
});
const fetchCatalogHistory = actionCreatorAsync$N("fetchCatalogHistory", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchHistory(params);
    const modifiedViews = (_a3 = response.data.data) == null ? void 0 : _a3.views.map((view)=>{
        if (view.stream) return {
            ...view,
            stream: {
                ...view.stream,
                blogUrl: view.channel.channelUrl,
                user: view.channel.owner
            }
        };
        return view;
    });
    return {
        views: modifiedViews ?? [],
        extra: response.data.extra
    };
});
const fetchCatalogBlockData = actionCreatorAsync$N("fetchCatalogBlockData", async ({ blockId, ...params })=>{
    const response = await Api$1.catalog.fetchBlockData(params);
    const mappedStreams = response.data.data.streamBlogs ? {
        streamBlogs: response.data.data.streamBlogs.map((element)=>({
                ...element.stream,
                blogUrl: element.blog.blogUrl,
                user: element.blog.owner
            }))
    } : {};
    return {
        blockId: blockId,
        extra: response.data.extra,
        ...response.data.data.streamBlogs ? mappedStreams : response.data.data
    };
});
const fetchCatalogSchema = actionCreatorAsync$N("fetchCatalogSchema", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchSchema(params);
    return {
        blocks: (_a3 = response.data.data) == null ? void 0 : _a3.blocks
    };
});
const fetchCatalogSubscribedStreams = actionCreatorAsync$N("fetchCatalogSubscribedStreams", async ()=>{
    var _a3;
    const response = await Api$1.user.fetchSubscribedStreams();
    const subscribedStreams = (_a3 = response.data.data) == null ? void 0 : _a3.streamBlogs.map(({ blog: blog2, stream: stream2 })=>({
            ...stream2,
            blogUrl: blog2.blogUrl,
            user: blog2.owner
        }));
    return {
        subscribedStreams: subscribedStreams
    };
});
const hideCatalogCategoryStreams = actionCreatorAsync$N("hideCatalogCategoryStreams", async ({ categoryId })=>{
    await Api$1.category.hideCategory(categoryId);
    return {};
});
const removeFromHiddenCatalogCategoryStreams = actionCreatorAsync$N("removeFromHiddenCatalogCategoryStreams", async ({ categoryId })=>{
    await Api$1.category.removeCategoryFromHidden(categoryId);
    return {};
});
const followCatalogCategoryStreams = actionCreatorAsync$N("followCatalogCategoryStreams", async ({ categoryId })=>{
    await Api$1.category.followCategory(categoryId);
    return {};
});
const unfollowCatalogCategoryStreams = actionCreatorAsync$N("unfollowCatalogCategoryStreams", async ({ categoryId })=>{
    await Api$1.category.unfollowCategory(categoryId);
    return {};
});
var EStreamSchemaType = /* @__PURE__ */ ((EStreamSchemaType2)=>{
    EStreamSchemaType2["STREAM"] = "stream";
    EStreamSchemaType2["STREAM_RECORD"] = "stream_record";
    EStreamSchemaType2["STREAM_CATEGORY"] = "stream_category";
    EStreamSchemaType2["GROUP_BLOCK"] = "group_block";
    EStreamSchemaType2["BUTTON"] = "button";
    EStreamSchemaType2["CHANNEL"] = "channel";
    return EStreamSchemaType2;
})(EStreamSchemaType || {});
var EStreamSchemaStyle = /* @__PURE__ */ ((EStreamSchemaStyle2)=>{
    EStreamSchemaStyle2["LIST"] = "list";
    EStreamSchemaStyle2["CAROUSEL"] = "carousel";
    EStreamSchemaStyle2["TABS"] = "tabs";
    return EStreamSchemaStyle2;
})(EStreamSchemaStyle || {});
const getAllVideoBlocks$1 = (blocks2)=>{
    const result2 = [];
    blocks2.forEach((block2)=>{
        if ([
            EStreamSchemaType.STREAM,
            EStreamSchemaType.STREAM_RECORD
        ].includes(block2.type) && block2.style !== EStreamSchemaStyle.CAROUSEL) result2.push({
            key: block2.id,
            sourceUrl: block2.sourceUrl
        });
        if (block2.type === EStreamSchemaType.GROUP_BLOCK) result2.push(...getAllVideoBlocks$1(block2.blocks));
    });
    return result2;
};
const abortControllers = {};
const hideCatalogStream = actionCreatorAsync$N("hideCatalogStream", async ({ blogUrl, limit, schemaType }, dispatch, getState)=>{
    await Api$1.stream.hide(blogUrl);
    if (limit && schemaType) {
        const state = getState();
        const { catalog: { dynamicBlockData }, schemas: { list: { [schemaType]: schema } } } = state;
        const streamBlocks = getAllVideoBlocks$1(schema.data);
        const requests = streamBlocks.reduce((acc, { key, sourceUrl })=>{
            var _a3;
            if (!dynamicBlockData[key]) return acc;
            const list2 = dynamicBlockData[key].data.data;
            const neededStreams = list2.filter((item2)=>item2.blog.blogUrl === blogUrl);
            const hasStream = (neededStreams == null ? void 0 : neededStreams.length) > 0;
            if (hasStream && list2.length - neededStreams.length < limit / 2) {
                (_a3 = abortControllers[key]) == null || _a3.abort();
                dispatch(clearCatalogBlockData({
                    blockId: key
                }));
                acc.push(dispatch((0, $7Uc0p.thunkToAction)(fetchCatalogBlockData.action)({
                    limit: limit,
                    blockId: key,
                    url: sourceUrl,
                    getAbort: (abort)=>{
                        abortControllers[key] = {
                            abort: abort
                        };
                    }
                })));
            }
            return acc;
        }, []);
        await Promise.all(requests);
        return {
            schema: schema
        };
    }
    return {};
});
const removeCatalogStreamFromHidden = actionCreatorAsync$N("removeCatalogStreamFromHidden", async ({ blogUrl })=>{
    await Api$1.stream.removeFromHidden(blogUrl);
    return {};
});
const removeFromHiddenCategory = actionCreatorAsync$N("removeFromHiddenCategory", async ({ categoryId })=>{
    await Api$1.category.removeCategoryFromHidden(categoryId);
    return {};
});
const updateCatalogRecommendedStreams = actionCreator$V("updateCatalogRecommendedStreams");
const updateCatalogSubscribedStreams = actionCreator$V("updateCatalogSubscribedStreams");
const actionCreator$U = (0, $99y5v.actionCreatorFactory)("Channel");
const actionCreatorAsync$M = (0, $7Uc0p.asyncFactory)(actionCreator$U);
const changeCoverType = actionCreatorAsync$M("changeCoverType", async ({ blogUrl, coverType })=>{
    await Api$1.channel.changeCoverType(coverType, blogUrl);
    return {
        coverType: coverType
    };
});
const createChannel = actionCreatorAsync$M("createChannel", async (params, dispatch)=>{
    const response = await Api$1.channel.create(params);
    dispatch(refetchUser());
    return {
        channel: response.data.data.channel
    };
});
const clearChannel = actionCreator$U("clearChannel");
actionCreatorAsync$M("saveNotificationSettings", async ({ blogUrl, isOn })=>{
    if (isOn) await Api$1.notificationSettings.setNotificationsOn(blogUrl);
    else await Api$1.notificationSettings.setNotificationsOff(blogUrl);
    return {};
});
const getNotificationSettings = actionCreatorAsync$M("getNotificationSettings", // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
async ({ transports })=>{
    return await Api$1.notificationSettings.getNotificationSettings(transports);
});
const notificationSettingsUpdate = actionCreatorAsync$M("notificationSettingsUpdate", async (values2)=>{
    return await Api$1.notificationSettings.notificationSettingsUpdate({
        transport: values2.transport,
        switch: values2.switch,
        value: values2.value
    });
});
const getNotificationChannelSettings = actionCreatorAsync$M("getNotificationChannelSettings", // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
async ({ blogUrl })=>{
    return await Api$1.notificationSettings.getNotificationChannelSettings({
        blogUrl: blogUrl
    });
});
const notificationChannelSettingsUpdate = actionCreatorAsync$M("notificationChannelSettingsUpdate", async (values2)=>{
    return await Api$1.notificationSettings.notificationChannelSettingsUpdate(values2);
});
const savePlaybackPosition = actionCreatorAsync$M("savePlaybackPosition", async ({ blogUrl, id, position: position2, type })=>{
    switch(type){
        case EPlaybackPositionType.RECORD:
            await Api$1.channel.saveRecordTimeCode(blogUrl, id, position2);
            break;
        case EPlaybackPositionType.STREAM:
            await Api$1.channel.saveStreamTimeCode(blogUrl, id, position2);
            break;
    }
    return {};
});
const updateNotificationSettingsFromWS = actionCreator$U("updateNotificationSettingsFromWS");
const uploadCoverImage = actionCreatorAsync$M("uploadCoverImage", async (payload)=>{
    const { blogUrl, image: image2 } = payload;
    try {
        const { data } = image2;
        const response = await Api$1.channel.uploadCoverImage(data, blogUrl);
        return {
            image: response.data.data
        };
    } catch (error2) {
        throw new ApiError(error2);
    }
});
const turnOnDropCampaigns = actionCreatorAsync$M("turnOnDropCampaigns", async ({ blogUrl })=>{
    await Api$1.channel.turnOnDrops(blogUrl);
});
const turnOffDropCampaigns = actionCreatorAsync$M("turnOffDropCampaigns", async ({ blogUrl })=>{
    await Api$1.channel.turnOffDrops(blogUrl);
});
const turnOnVideoClipCreation = actionCreatorAsync$M("turnOnVideoClipCreation", async ({ blogUrl })=>{
    await Api$1.channel.turnOnVideoClipCreation(blogUrl);
});
const turnOffVideoClipCreation = actionCreatorAsync$M("turnOffVideoClipCreation", async ({ blogUrl })=>{
    await Api$1.channel.turnOffVideoClipCreation(blogUrl);
});
const actionCreator$T = (0, $99y5v.actionCreatorFactory)("DropCampaigns");
const actionCreatorAsync$L = (0, $7Uc0p.asyncFactory)(actionCreator$T);
const claimDropCampaignProduct = actionCreatorAsync$L("claimDropCampaignProduct", async (payload)=>{
    const { dropCampaignId } = payload;
    const response = await Api$1.dropCampaigns.claimDropCampaignProduct(dropCampaignId);
    return response.data.data.dropProgress;
});
const clearDropCampaign = actionCreator$T("clearDropCampaign");
const clearDropCampaigns = actionCreator$T("clearDropCampaigns");
const fetchDropCampaign = actionCreatorAsync$L("fetchDropCampaign", async (payload)=>{
    const { dropCampaignId } = payload;
    const response = await Api$1.dropCampaigns.fetchDropCampaign(dropCampaignId);
    return response.data.data.dropProgress;
});
const fetchDropCampaigns = actionCreatorAsync$L("fetchDropCampaigns", async ()=>{
    const response = await Api$1.dropCampaigns.fetchDropCampaigns();
    return response.data.data;
});
const actionCreator$S = (0, $99y5v.actionCreatorFactory)("Settings");
const actionCreatorAsync$K = (0, $7Uc0p.asyncFactory)(actionCreator$S);
const fetchStreamSettingsSet = actionCreatorAsync$K("fetchStreamSettingsSet", async ({ blogUrl })=>{
    const response = await Api$1.streamSettings.fetchSettingsSet(blogUrl);
    return response.data.data.stream;
});
const updateStreamSettingsSet = actionCreatorAsync$K("updateStreamSettingsSet", async ({ blogUrl, ...params })=>{
    const response = await Api$1.streamSettings.updateSettingsSet(blogUrl, params);
    return response.data.data.stream;
});
const clearStreamSettingsSet = actionCreator$S("clearStreamSettingsSet");
const clearChannelSettingsSet = actionCreator$S("clearChannelSettingsSet");
const fetchChannelSettingsSet = actionCreatorAsync$K("fetchChannelSettingsSet", async ({ blogUrl })=>{
    const response = await Api$1.channelSettings.fetchSettingsSet(blogUrl);
    return response.data.data.channel;
});
const updateNewRecordsSubscriptionLevel = actionCreatorAsync$K("updateNewRecordsSubscriptionLevel", async ({ blogUrl, subscriptionLevelId })=>{
    const response = await Api$1.channelSettings.updateNewRecordsSubscriptionLevel(blogUrl, subscriptionLevelId);
    return response.data;
});
actionCreatorAsync$K("setRaidMinimumViewers", async ({ blogUrl, minimumViewers })=>{
    await Api$1.channelSettings.setRaidMinimumViewers(blogUrl, minimumViewers);
});
const actionCreator$R = (0, $99y5v.actionCreatorFactory)("globalData");
const clearGlobalData = actionCreator$R("clearGlobalData");
const setGlobalBlogUrl = actionCreator$R("setGlobalBlogUrl");
const clearGlobalBlogUrl = actionCreator$R("clearGlobalBlogUrl");
const actionCreator$Q = (0, $99y5v.actionCreatorFactory)("Internal");
const actionCreatorAsync$J = (0, $7Uc0p.asyncFactory)(actionCreator$Q);
const fetchInternalDonation = actionCreatorAsync$J("fetchInternalDonation", async ({ donationId })=>{
    const { data } = await Api$1.internal.fetchDonation(donationId);
    return data;
});
const fetchInternalGift = actionCreatorAsync$J("fetchInternalGift", async ({ giftKey })=>{
    const { data } = await Api$1.internal.fetchGift(giftKey);
    return data;
});
const fetchInternalUsers = actionCreatorAsync$J("fetchInternalUsers", async ({ userIds })=>{
    const { data } = await Api$1.internal.fetchUsers(userIds);
    return data;
});
const fetchInternalComments = actionCreatorAsync$J("fetchInternalComments", async ({ commentId })=>{
    const response = await Api$1.internal.fetchComments(commentId);
    return response.data;
});
const fetchInternalMessage = actionCreatorAsync$J("fetchInternalMessage", async ({ messageId })=>{
    const response = await Api$1.internal.fetchMessage(messageId);
    return response.data;
});
const actionCreator$P = (0, $99y5v.actionCreatorFactory)("ExternalApps");
const actionCreatorAsync$I = (0, $7Uc0p.asyncFactory)(actionCreator$P);
const fetchTelegramUrl = actionCreatorAsync$I("fetchTelegramUrl", async ()=>{
    const response = await Api$1.externalApps.fetchTelegramUrl();
    return {
        url: response.data.url
    };
});
actionCreatorAsync$I("disconnectDiscordServer", async (payload, dispatch)=>{
    await Api$1.externalApps.disconnectDiscordServer();
    dispatch(refetchUser());
    dispatch(refetchBlogSubscriptionLevels());
});
const fetchDiscordRoles = actionCreatorAsync$I("fetchDiscordRoles", async ()=>{
    const response = await Api$1.externalApps.fetchDiscordRoles();
    return {
        list: response.data.data
    };
});
const fetchTelegramGroups = actionCreatorAsync$I("fetchTelegramGroups", async (params)=>{
    const response = await Api$1.externalApps.fetchTelegramGroups(params.blogUrl);
    return {
        list: response.data.data.groups
    };
});
actionCreatorAsync$I("deleteVkplayLink", async ()=>await Api$1.externalApps.deleteVkplayLink());
const actionCreator$O = (0, $99y5v.actionCreatorFactory)("Gift");
const actionCreatorAsync$H = (0, $7Uc0p.asyncFactory)(actionCreator$O);
const fetchCurrentGift = actionCreatorAsync$H("fetchCurrentGift", async ({ giftKey })=>{
    const response = await Api$1.gift.fetch(giftKey);
    return response.data;
});
const fetchGifts = actionCreatorAsync$H("fetchGifts", async ({})=>{
    const { data: { data } } = await Api$1.gift.fetchGifts();
    return {
        data: data
    };
});
const acceptGift = actionCreatorAsync$H("acceptGift", async ({ giftKey, renewDisabled }, dispatch)=>{
    let isSuccess = false;
    try {
        await Api$1.gift.accept(giftKey, renewDisabled);
        dispatch(onSubscribedStateChange());
        isSuccess = true;
    } catch (err) {
        throw new ApiError({
            message: "accept gift failed"
        });
    }
    return {
        succeeded: isSuccess
    };
});
actionCreatorAsync$H("sendGift", async ({ giftKey, email })=>{
    try {
        await Api$1.gift.send(giftKey, email);
    } catch (err) {
        throw new ApiError(err);
    }
});
const changeAnonymityGift = actionCreatorAsync$H("changeAnonymityGift", async ({ giftKey, isAnonymous })=>{
    try {
        const response = await Api$1.gift.changeAnonymity(giftKey, isAnonymous);
        return response.data;
    } catch (err) {
        throw new ApiError({
            message: "change anonymity gift failed"
        });
    }
});
const clearCurrentGift = actionCreator$O("clearCurrentGift");
const clearAcceptGiftSucceeded = actionCreator$O("clearAcceptGiftSucceeded");
const actionCreator$N = (0, $99y5v.actionCreatorFactory)("MediaPlayingState");
const setCurrentPlayingMedia = actionCreator$N("setMediaPlaying");
const resetCurrentPlayingMedia = actionCreator$N("resetMediaPlaying");
const actionCreator$M = (0, $99y5v.actionCreatorFactory)("MediaData");
const actionCreatorAsync$G = (0, $7Uc0p.asyncFactory)(actionCreator$M);
const uploadImage = actionCreatorAsync$G("uploadImage", async ({ image: image2 })=>{
    try {
        const { data } = image2;
        const response = await Api$1.mediaData.uploadImage(data);
        return {
            image: response.data
        };
    } catch (err) {
        throw new ApiError(err);
    }
});
const updateUploads = actionCreator$M("updateUploads");
actionCreatorAsync$G("createUploadFileContainer", async ()=>{
    const response = await Api$1.mediaData.createUploadFileContainer();
    return {
        container: response.data
    };
});
actionCreatorAsync$G("createUploadAudioContainer", async ()=>{
    const response = await Api$1.mediaData.createUploadAudioContainer();
    return {
        container: response.data
    };
});
actionCreatorAsync$G("createUploadVideoContainer", async ({ fileName })=>{
    const { data: { id, uploadUrl, videoId } } = await Api$1.mediaData.createUploadVideoContainer({
        file_name: fileName
    });
    return {
        container: {
            id: id,
            url: uploadUrl,
            videoId: videoId
        }
    };
});
actionCreatorAsync$G("uploadVideoFinish", async ({ id })=>{
    const response = await Api$1.mediaData.videoUploadFinish(id);
    return response.data;
});
const fetchBank131PageUrl = actionCreatorAsync$R("fetchBank131PageUrl", async ({ blogUrl, type = EPaymentType.SUBSCRIPTION, levelId, bindId, payMethod, period, applePayToken, phone, merchantData, currency, countGift = 1 })=>{
    let response;
    const { isMobile: isMobile2 } = getConfig();
    switch(type){
        case EPaymentType.SUBSCRIPTION:
            response = await Api$1.payment.getBank131PageUrl(blogUrl, levelId, {
                bind_id: bindId,
                is_mobile: isMobile2,
                pay_method: payMethod,
                token: applePayToken,
                period: period,
                phone: phone,
                currency: currency
            });
            break;
        case EPaymentType.GIFT:
            response = await Api$1.payment.getSinglePaymentGiftSubscriptionBank131PageUrl(blogUrl, levelId, {
                bind_id: bindId,
                pay_method: payMethod,
                token: applePayToken,
                is_mobile: isMobile2,
                phone: phone,
                merchant_data: merchantData,
                currency: currency,
                count: countGift
            });
            break;
    }
    const { paymentId, status, url } = response.data.data;
    if (status === "error") throw new ApiError({
        message: "Failed fetch BANK131 url"
    });
    return {
        url: url,
        paymentId: paymentId,
        status: status
    };
});
const fetchDmrPageUrl = actionCreatorAsync$R("fetchDmrPageUrl", async ({ blogUrl, type, typeDonation, levelId, bindId, payMethod, price, id, period, applePayToken, phone, merchantData, message: message2, currency, countGift = 1 })=>{
    let response;
    const { isMobile: isMobile2 } = getConfig();
    switch(type){
        case EPaymentType.POST:
            response = await Api$1.payment.getSinglePaymentPostDmrPageUrl(blogUrl, String(id), {
                bind_id: bindId,
                pay_method: payMethod,
                token: applePayToken,
                is_mobile: isMobile2,
                phone: phone,
                currency: currency
            });
            break;
        case EPaymentType.DONATION:
            response = await Api$1.payment.getSinglePaymentDonationDmrPageUrl(blogUrl, typeDonation, {
                bind_id: bindId,
                amount: price,
                pay_method: payMethod,
                ...typeDonation === EDonationType.TARGET || typeDonation === EDonationType.POST ? {
                    target_id: Number(id)
                } : {},
                message: JSON.stringify(message2),
                token: applePayToken,
                is_mobile: isMobile2,
                phone: phone,
                merchant_data: merchantData,
                currency: currency
            });
            break;
        case EPaymentType.SUBSCRIPTION:
            response = await Api$1.payment.getDmrPageUrl(levelId, blogUrl, {
                bind_id: bindId,
                is_mobile: isMobile2,
                pay_method: payMethod,
                token: applePayToken,
                period: period,
                phone: phone,
                currency: currency
            });
            break;
        case EPaymentType.MESSAGE:
            response = await Api$1.payment.getSinglePaymentMessageDmrPageUrl(Number(id), {
                bind_id: bindId,
                pay_method: payMethod,
                token: applePayToken,
                is_mobile: isMobile2,
                phone: phone,
                merchant_data: merchantData,
                currency: currency
            });
            break;
        case EPaymentType.GIFT:
            response = await Api$1.payment.getSinglePaymentGiftSubscriptionDmrPageUrl(levelId, blogUrl, {
                bind_id: bindId,
                pay_method: payMethod,
                token: applePayToken,
                is_mobile: isMobile2,
                phone: phone,
                merchant_data: merchantData,
                currency: currency,
                count: countGift
            });
            break;
    }
    if (response.data.status === "error") throw new ApiError({
        message: "Failed fetch DMR url"
    });
    return {
        url: response.data.url,
        paymentId: response.data.paymentId,
        status: response.data.status
    };
});
const runCheckPaymentId = actionCreatorAsync$R("runCheckPaymentId", async ({ blogUrl, type, typeDonation, payMethod, paymentId }, dispatch, getState)=>{
    let checks = 0;
    let isSuccess = false;
    let itemId = null;
    const { payment: paymentCfg } = getConfig();
    const { retries = 10, timeout: timeout2 = 1500 } = paymentCfg[payMethod || "default"] || {};
    while(!isSuccess && checks < retries){
        checks += 1;
        try {
            const checkPaymentResponse = await Api$1.payment.checkPaymentId(paymentId);
            if (checkPaymentResponse.data.status) {
                isSuccess = true;
                itemId = checkPaymentResponse.data.itemId;
            }
        } catch (err) {}
        if (!isSuccess) await dist$4.delay(timeout2);
    }
    if (!isSuccess) {
        AppStat.log.graphite.payments.checkFailed();
        throw new ApiError({
            message: "payment id check failed"
        });
    } else {
        const { currentUser: { selectedCurrency, user: { data: userData, meta: { networkStatus: networkStatus2 } } } } = getState();
        if (selectedCurrency && userData.defaultCurrency !== selectedCurrency && networkStatus2.isFetched) dispatch(refetchItemsWithPrices());
    }
    switch(type){
        case EPaymentType.SUBSCRIPTION:
            dispatch(onSubscribedStateChange());
            break;
        case EPaymentType.GIFT:
            break;
        case EPaymentType.POST:
            dispatch(refetchFeed());
            break;
        case EPaymentType.DONATION:
            if (typeDonation === EDonationType.TARGET) dispatch(refetchTargets({
                blogUrl: blogUrl
            }));
            if (typeDonation === EDonationType.DIALOG) dispatch(dialogueListToggleIsNeedUpdate({
                isNeedUpdate: true
            }));
            break;
        case EPaymentType.MESSAGE:
            dispatch(fetchMessage({
                messageId: itemId
            }));
            break;
    }
    return {
        successful: isSuccess,
        itemId: itemId
    };
});
actionCreatorAsync$R("resubscribe", async ({ blogUrl, levelId, period }, dispatch)=>{
    const response = await Api$1.blog.resubscribe(blogUrl, levelId, {
        period: period
    });
    if (!response.data.status) throw new ApiError({
        message: "Failure - status: false in response"
    });
    dispatch(onSubscribedStateChange());
    return response.data;
});
const revertUnsubscribe = actionCreatorAsync$R("revertUnsubscribe", async ({ blogUrl }, dispatch)=>{
    const response = await Api$1.blog.revertUnsubscribe(blogUrl);
    if (!response.data.status) throw new ApiError({
        message: "Failure - status: false in response"
    });
    dispatch(onSubscribedStateChange());
    return response.data;
});
actionCreatorAsync$R("payWithExistingBank131Bind", async ({ blogUrl, levelId, bindId, period, currency, countGift, type = EPaymentType.SUBSCRIPTION })=>{
    let response;
    switch(type){
        case EPaymentType.SUBSCRIPTION:
            response = await Api$1.payment.payWithExistingBank131Bind(blogUrl, levelId, {
                bind_id: bindId,
                period: period,
                currency: currency
            });
            break;
        case EPaymentType.GIFT:
            response = await Api$1.payment.payGiftSubscriptionWithExistingBank131Bind(blogUrl, levelId, {
                bind_id: bindId,
                currency: currency,
                count: countGift
            });
            break;
    }
    const { id: paymentId, reason: reason2, status = null } = response.data.data.payment;
    const data = {
        paymentId: paymentId,
        reason: reason2,
        status: status
    };
    if ([
        null,
        EPaymentBank131Status.ERROR,
        EPaymentBank131Status.CANCELLED
    ].includes(status)) {
        if (reason2 === EPaymentRejectReason.NEED_3DS) return data;
        else throw new ApiError({
            message: "response status: false"
        });
    }
    return data;
});
const payWithExistingBind = actionCreatorAsync$R("payWithExistingBind", async ({ blogUrl, targetId, levelId, bindId, price, period, currency, message: message2, countGift, type = EPaymentType.SUBSCRIPTION, typeDonation })=>{
    var _a3, _b2;
    let response;
    switch(type){
        case EPaymentType.GIFT:
            response = await Api$1.payment.payGiftSubscriptionWithExistingBind(levelId, blogUrl, {
                bind_id: bindId,
                currency: currency,
                count: countGift
            });
            break;
        case EPaymentType.MESSAGE:
            response = await Api$1.payment.payMessageWithExistingBind(targetId, {
                bind_id: bindId,
                currency: currency
            });
            break;
        case EPaymentType.DONATION:
            response = await Api$1.payment.payDonationWithExistingBind(blogUrl, typeDonation, {
                bind_id: bindId,
                ...typeDonation === EDonationType.TARGET || typeDonation === EDonationType.POST ? {
                    target_id: targetId
                } : {},
                amount: price,
                message: JSON.stringify(message2),
                currency: currency
            });
            break;
        case EPaymentType.POST:
            response = await Api$1.payment.payPostWithExistingBind(blogUrl, targetId, {
                bind_id: bindId,
                currency: currency
            });
            break;
        default:
            response = await Api$1.payment.payWithExistingBind(levelId, blogUrl, {
                bind_id: bindId,
                period: period,
                currency: currency
            });
            break;
    }
    const data = {
        status: response.data.status,
        paymentId: response.data.paymentId,
        reason: (_a3 = response.data) == null ? void 0 : _a3.reason
    };
    if (!response.data.status) {
        if (((_b2 = response.data) == null ? void 0 : _b2.reason) === EPaymentRejectReason.NEED_3DS) return data;
        else throw new ApiError({
            message: "response status: false"
        });
    }
    return data;
});
const abandonSubscriptionPurchase = actionCreator$Z("abandonSubscriptionPurchase");
actionCreatorAsync$R("validateApplePaySession", async ({ validationUrl })=>{
    const response = await Api$1.payment.validateApplePaySession(validationUrl);
    return {
        data: response.data
    };
});
const fetchPaymentInfo = actionCreatorAsync$R("fetchPaymentInfo", async ({ blogUrl, levelId, period = 1, currency })=>{
    const { currencies: { default: defaultCurrency } } = getConfig();
    const response = await Api$1.payment.fetchPaymentInfo(blogUrl, levelId, {
        period: period,
        currency: currency || defaultCurrency
    });
    return response.data;
});
actionCreatorAsync$R("fetchTransactionStatus", async ({ paymentId })=>{
    const { data: { status, url } } = await Api$1.payment.fetchTransactionStatus(paymentId);
    return {
        status: status,
        url: url
    };
});
actionCreatorAsync$R("runCheckTransactionStatus", async ({ payMethod, paymentId }, dispatch)=>{
    const { payment: paymentCfg } = getConfig();
    const { retries = 10, timeout: timeout2 = 1500 } = paymentCfg[payMethod || "default"] || {};
    let result2 = null;
    let checks = 0;
    while(checks < retries){
        checks += 1;
        try {
            result2 = await Api$1.payment.fetchTransactionStatus(paymentId);
            if (result2.data.status !== EPaymentStatus.WAIT) return {
                status: result2.data.status,
                url: result2.data.url
            };
            else await dist$4.delay(timeout2);
        } catch (err) {}
    }
    throw new ApiError({
        message: "transaction status check failed"
    });
});
actionCreatorAsync$R("sendQiwiSmsCode", async ({ paymentId, code })=>{
    const response = await Api$1.payment.sendQiwiSmsCode(paymentId, code);
    return response.data;
});
const actionCreator$L = (0, $99y5v.actionCreatorFactory)("RouteParams");
const updateRouteParams = actionCreator$L("updateRouteParams");
const actionCreator$K = (0, $99y5v.actionCreatorFactory)("Search");
const actionCreatorAsync$F = (0, $7Uc0p.asyncFactory)(actionCreator$K);
actionCreatorAsync$F("searchBlog", async ({ query, limit, offset: offset2, forRaid })=>{
    const { data: { data: { searchBlogs }, extra } } = await Api$1.search.searchBlog({
        limit: limit,
        offset: offset2,
        query: query,
        forRaid: forRaid
    });
    return {
        data: searchBlogs,
        offset: extra.offset,
        isLast: extra.isLast
    };
});
actionCreatorAsync$F("searchBlogSuggest", async ({ query, limit, offset: offset2 })=>{
    const { data: { data: { searchBlogs }, extra } } = await Api$1.search.searchBlogSuggest({
        limit: limit,
        offset: offset2,
        query: query
    });
    return {
        data: searchBlogs,
        offset: extra.offset,
        isLast: extra.isLast
    };
});
const searchBlogPost = actionCreatorAsync$F("searchBlogPost", async ({ blogUrl, query, filter, limit, offset: offset2 })=>{
    const { data: { data: { searchPosts }, extra } } = await Api$1.search.searchBlogPost({
        blogUrl: blogUrl,
        query: query,
        limit: limit,
        offset: offset2,
        filter: filter
    });
    return {
        data: searchPosts,
        offset: extra.offset,
        isLast: extra.isLast
    };
});
const clearSearchBlogPost = actionCreator$K("clearSearchBlogPost");
const searchUsers = actionCreatorAsync$F("searchUsers", async ({ query, limit })=>{
    const response = await Api$1.search.searchUser({
        searchQuery: query,
        limit: limit
    });
    return response.data.data;
});
const clearUsersSearchList = actionCreator$K("clearUsersSearchList");
actionCreatorAsync$F("searchUserSub", async ({ searchQuery, limit })=>{
    const { data } = await Api$1.search.searchUser({
        searchQuery: searchQuery,
        limit: limit
    });
    return data.data.users;
});
const actionCreator$J = (0, $99y5v.actionCreatorFactory)("SinglePayment");
const actionCreatorAsync$E = (0, $7Uc0p.asyncFactory)(actionCreator$J);
const fetchSinglePaymentDmrPageUrl = actionCreatorAsync$E("fetchSinglePaymentDmrPageUrl", async ({ blogUrl, type, typeDonation, bindId, price, payMethod, id, applePayToken, isMobile: isMobile2, merchantData, phone, levelId, currency })=>{
    let response;
    switch(type){
        case EPaymentType.POST:
            response = await Api$1.payment.getSinglePaymentPostDmrPageUrl(blogUrl, String(id), {
                bind_id: bindId,
                pay_method: payMethod,
                token: applePayToken,
                currency: currency
            });
            break;
        case EPaymentType.DONATION:
            response = await Api$1.payment.getSinglePaymentDonationDmrPageUrl(blogUrl, typeDonation, {
                bind_id: bindId,
                amount: price,
                pay_method: payMethod,
                target_id: Number(id),
                token: applePayToken,
                is_mobile: isMobile2,
                merchant_data: merchantData,
                currency: currency
            });
            break;
        case EPaymentType.GIFT:
            response = await Api$1.payment.getSinglePaymentGiftSubscriptionDmrPageUrl(levelId, blogUrl, {
                merchant_data: merchantData,
                pay_method: payMethod,
                token: applePayToken,
                phone: phone,
                currency: currency
            });
            break;
    }
    return {
        url: response.data.url,
        paymentId: response.data.paymentId,
        status: response.data.status
    };
});
const fetchSinglePaymentOnlyBindBank131PageUrl = actionCreatorAsync$E("fetchSinglePaymentOnlyBindBank131PageUrl", async ({ payMethod, isMobile: isMobile2, currency })=>{
    const response = await Api$1.payment.getSinglePaymentOnlyBindBank131PageUrl({
        pay_method: payMethod,
        is_mobile: isMobile2,
        currency: currency
    });
    const { paymentId, status, url } = response.data;
    return {
        paymentId: paymentId,
        status: status,
        url: url
    };
});
const fetchSinglePaymentOnlyBindDmrPageUrl = actionCreatorAsync$E("fetchSinglePaymentOnlyBindDmrPageUrl", async ({ payMethod, isMobile: isMobile2, currency })=>{
    const response = await Api$1.payment.getSinglePaymentOnlyBindDmrPageUrl({
        pay_method: payMethod,
        is_mobile: isMobile2,
        currency: currency
    });
    return {
        url: response.data.url,
        paymentId: response.data.paymentId,
        status: response.data.status
    };
});
const actionCreator$I = (0, $99y5v.actionCreatorFactory)("Support");
const actionCreatorAsync$D = (0, $7Uc0p.asyncFactory)(actionCreator$I);
actionCreatorAsync$D("contactSupport", async ({ name: name2, email, text: text2 })=>{
    await Api$1.support.contactSupport({
        name: name2,
        email: email,
        text: text2
    });
    return {};
});
actionCreatorAsync$D("getSupportFrameUrl", async ()=>{
    const { data: { url } } = await Api$1.systemApi.getSupportFrameUrl();
    return {
        url: url
    };
});
const actionCreator$H = (0, $99y5v.actionCreatorFactory)("OAuth");
const actionCreatorAsync$C = (0, $7Uc0p.asyncFactory)(actionCreator$H);
const actions$2 = getProviderActions();
const checkApp$1 = actionCreatorAsync$C("checkApp", async (params)=>{
    return await actions$2.checkApp({
        client_id: params.appId,
        redirect_uri: params.redirectUri
    });
});
const authorizeByPhone = actionCreatorAsync$C("authorizeByPhone", async (params)=>{
    const response = await actions$2.authorizeByPhone({
        client_id: params.phone,
        data: params.token
    });
    return {
        expires_in: response.expires_in,
        client_id: response.client_id,
        code: response.code
    };
});
const authorizeByOAuth = actionCreatorAsync$C("authorizeByOAuth", async (params)=>{
    const { url } = await actions$2.authorizeByOAuth({
        client_id: params.appId,
        redirect_uri: params.redirectUri,
        response_type: params.responseType,
        state: params.state,
        scope: params.code
    });
    return {
        url: url
    };
});
const fetchTokenByPhone = actionCreatorAsync$C("fetchTokenByPhone", async (params)=>{
    return await actions$2.fetchTokenByPhone({
        device_id: params.deviceId,
        sms_code: params.smsCode,
        device_os: params.deviceOS,
        client_id: params.clientId,
        code: params.code,
        allowed_actor_status: params.allowedActorStatus
    });
});
const wrapAuthAction = (f2)=>(arg1, arg2, arg3)=>(dispatch)=>// eslint-disable-next-line prefer-promise-reject-errors,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
            (f2(arg1, arg2, arg3) || Promise.reject({})).then((user)=>{
                const newUserHeader = Number(getCookie(ECookieKey.NEW_USER));
                dispatch(setCurrentUser.action({
                    user: user
                }));
                if (newUserHeader === ENewUserHeader.REGISTER) AppStat.log.gtm.registrationSuccess();
                return true;
            }).catch((error2)=>{
                switch(error2.level){
                    case dist$3.AuthFailureLevel.SEVERE:
                        Log$5.error(error2.reason, error2.operation);
                        dispatch(setCurrentUser.action({
                            user: null
                        }));
                        break;
                    case dist$3.AuthFailureLevel.EXPECTED:
                        Log$5.message(error2.reason, error2.operation);
                        break;
                    case dist$3.AuthFailureLevel.MINOR:
                        Log$5.message(error2.reason, error2.operation);
                        break;
                }
                return false;
            });
const authActions = {
    requestAuth: (provider, isExternalAccountLink)=>wrapAuthAction(getProviderActions().requestAuth)(provider, true, isExternalAccountLink),
    tryInstantAuth: wrapAuthAction(getProviderActions().tryInstantAuth),
    tryRestoreAuth: wrapAuthAction(getProviderActions().tryRestoreAuth),
    restoreSession: wrapAuthAction(getProviderActions().restoreSession),
    authorizeByOAuth: authorizeByOAuth,
    authorizeByPhone: authorizeByPhone,
    fetchTokenByPhone: fetchTokenByPhone,
    checkApp: checkApp$1
};
const actionCreator$G = (0, $99y5v.actionCreatorFactory)("AuthByEmail");
const actionCreatorAsync$B = (0, $7Uc0p.asyncFactory)(actionCreator$G);
actionCreatorAsync$B("signIn", async ({ email, password, recaptchaToken })=>{
    const response = await Api$1.authByEmail.signIn({
        email: email,
        password: password,
        recaptchaToken: recaptchaToken
    });
    return response.data;
});
actionCreatorAsync$B("signUp", async ({ name: name2, email, password, recaptchaToken })=>{
    const response = await Api$1.authByEmail.signUp({
        name: name2,
        email: email,
        password: password,
        recaptchaToken: recaptchaToken
    });
    return response.data;
});
actionCreatorAsync$B("changePassword", async ({ oldPassword, password })=>{
    const response = await Api$1.authByEmail.changePassword({
        old_password: oldPassword,
        password: password
    });
    return response.data;
});
actionCreatorAsync$B("changePasswordWithCode", async (params)=>{
    const response = await Api$1.authByEmail.changePasswordWithCode(params);
    return response.data;
});
actionCreatorAsync$B("sendLinkForChangePassword", async ({ email })=>{
    const response = await Api$1.authByEmail.sendLinkForChangePassword({
        email: email
    });
    return response.data;
});
const actionCreator$F = (0, $99y5v.actionCreatorFactory)("VideoClips");
const actionCreatorAsync$A = (0, $7Uc0p.asyncFactory)(actionCreator$F);
const clearVideoClip = actionCreator$F("clearVideoClip");
const clearVideoClips = actionCreator$F("clearVideoClips");
const clearVideoClipsCreationPipeline = actionCreator$F("clearVideoClipsCreationPipeline");
const clearVideoClipSourceVideo = actionCreator$F("clearVideoClipSourceVideo");
const clearVideoSnippet = actionCreator$F("clearVideoSnippet");
const clearVideoSnippetsCreationPipeline = actionCreator$F("clearVideoSnippetsCreationPipeline");
const handleVideoClipStatusChange = actionCreator$F("handleVideoClipStatusChange");
const createVideoClip = actionCreatorAsync$A("createVideoClip", async (payload, dispatch)=>{
    const { channelUrl, sourceType, sourceId, params } = payload;
    let response;
    if (sourceType === EVideoClipSourceType.STREAM) response = await Api$1.videoClip.createVideoClipFromStream({
        ...params,
        blogUrl: channelUrl,
        snippetId: sourceId
    });
    else response = await Api$1.videoClip.createVideoClipFromRecord({
        ...params,
        blogUrl: channelUrl,
        streamId: sourceId
    });
    dispatch(handleVideoClipStatusChange(response.data.data.clip));
    return {
        data: response.data.data.clip
    };
});
const handleVideoSnippetStatusChange = actionCreator$F("handleVideoSnippetStatusChange");
const createVideoSnippet = actionCreatorAsync$A("createVideoSnippet", async (payload, dispatch)=>{
    const response = await Api$1.videoClip.createVideoSnippet(payload);
    dispatch(handleVideoSnippetStatusChange(response.data.data.template));
    return {
        data: response.data.data.template
    };
});
const deleteVideoClip = actionCreatorAsync$A("deleteVideoClip", async (payload)=>{
    const { blogUrl, videoClipId, params } = payload;
    await Api$1.videoClip.deleteVideoClip(blogUrl, videoClipId, params);
    return {};
});
const editVideoClip = actionCreatorAsync$A("editVideoClip", async (payload)=>{
    const { blogUrl, videoClipId, params } = payload;
    const response = await Api$1.videoClip.editVideoClip(blogUrl, videoClipId, params);
    return {
        data: response.data.data.clip
    };
});
const fetchActiveVideoClips = actionCreatorAsync$A("fetchActiveVideoClips", async (payload)=>{
    const response = await Api$1.videoClip.fetchActiveVideClips(payload);
    return {
        data: response.data.data.clips,
        extra: response.data.extra
    };
});
const fetchProcessingVideoClips = actionCreatorAsync$A("fetchProcessingVideoClips", async (payload)=>{
    const response = await Api$1.videoClip.fetchProcessingVideClips(payload);
    return {
        data: response.data.data.clips,
        extra: response.data.extra
    };
});
const fetchVideoClip = actionCreatorAsync$A("fetchVideoClip", async (payload, dispatch, getState)=>{
    const state = getState();
    const currentUser2 = currentUserSelector(state);
    const canModerateChannel = currentUserCanModerateChannel(currentUser2, payload.blogUrl);
    const response = await Api$1.videoClip.fetchVideoClip({
        ...payload,
        isUnrestricted: canModerateChannel
    });
    return {
        data: response.data.data.clip
    };
});
actionCreatorAsync$A("fetchVideoClipInPlace", async (payload, dispatch, getState)=>{
    const state = getState();
    const blog2 = blogSelector(state);
    const managedChannels = currentUserManagedChannelsSelector(state);
    const canManageChannel = Boolean(blog2 == null ? void 0 : blog2.isOwner) || (managedChannels == null ? void 0 : managedChannels.some((channel2)=>channel2.channelUrl === payload.blogUrl));
    const response = await Api$1.videoClip.fetchVideoClip({
        ...payload,
        isUnrestricted: canManageChannel
    });
    return {
        data: response.data.data.clip
    };
});
const fetchVideoClips = actionCreatorAsync$A("fetchVideoClips", async (payload, dispatch, getState)=>{
    const state = getState();
    const extra = videoClipsExtraSelector(state);
    const currentUser2 = currentUserSelector(state);
    const canModerateChannel = currentUserCanModerateChannel(currentUser2, payload.blogUrl);
    const response = await Api$1.videoClip.fetchVideoClips({
        ...payload,
        isUnrestricted: canModerateChannel,
        offset: extra.offset
    });
    return {
        data: response.data.data.clips,
        extra: response.data.extra
    };
});
const fetchVideoSnippet = actionCreatorAsync$A("fetchVideoSnippet", async (payload)=>{
    const response = await Api$1.videoClip.fetchVideoSnippet(payload);
    return {
        data: response.data.data.template
    };
});
const hideVideoClip = actionCreatorAsync$A("hideVideoClip", async (payload)=>{
    const { blogUrl, videoClipId } = payload;
    await Api$1.videoClip.hideVideoClip(blogUrl, videoClipId);
    return {};
});
const likeVideoClip = actionCreatorAsync$A("likeVideoClip", async (payload)=>{
    const { blogUrl, videoClipId } = payload;
    await Api$1.videoClip.likeVideoClip(blogUrl, videoClipId);
    return {};
});
const removeVideoClipFromCreationPipeline = actionCreator$F("removeVideoClipFromCreationPipeline");
const removeVideoSnippetFromCreationPipeline = actionCreator$F("removeVideoSnippetFromCreationPipeline");
const setVideoClipCurrent = actionCreator$F("setVideoClipCurrent");
const setVideoClipSourceVideo = actionCreator$F("setVideoClipSourceVideo");
const setVideoSnippetCurrent = actionCreator$F("setVideoSnippetCurrent");
const unhideVideoClip = actionCreatorAsync$A("unhideVideoClip", async (payload)=>{
    const { blogUrl, videoClipId } = payload;
    await Api$1.videoClip.unhideVideoClip(blogUrl, videoClipId);
    return {};
});
actionCreatorAsync$A("toggleVisibilityVideoClip", async (payload, dispatch)=>{
    const { blogUrl, isHidden: isHidden3, videoClipId } = payload;
    if (isHidden3) await dispatch(unhideVideoClip.action({
        blogUrl: blogUrl,
        videoClipId: videoClipId
    }));
    else await dispatch(hideVideoClip.action({
        blogUrl: blogUrl,
        videoClipId: videoClipId
    }));
    return {};
});
const unlikeVideoClip = actionCreatorAsync$A("unlikeVideoClip", async (payload)=>{
    const { blogUrl, videoClipId } = payload;
    await Api$1.videoClip.unlikeVideoClip(blogUrl, videoClipId);
    return {};
});
const viewVideoClip = actionCreatorAsync$A("viewVideoClip", async (payload)=>{
    const { blogUrl, videoClipId } = payload;
    await Api$1.videoClip.viewVideoClip(blogUrl, videoClipId);
    return {};
});
const actionCreator$E = (0, $99y5v.actionCreatorFactory)("WebSocket");
const actionCreatorAsync$z = (0, $7Uc0p.asyncFactory)(actionCreator$E);
const fetchWebSocketToken = actionCreatorAsync$z("fetchWebSocketToken", async ()=>{
    const response = await Api$1.webSocket.fetchToken();
    return {
        token: response.data.token
    };
});
const actionCreator$D = (0, $99y5v.actionCreatorFactory)("Poll");
const actionCreatorAsync$y = (0, $7Uc0p.asyncFactory)(actionCreator$D);
const fetchPollUnsubs = actionCreatorAsync$y("fetchPollUnsubs", async ()=>{
    const response = await Api$1.poll.fetchUnsubs();
    return response.data;
});
const fetchUnsubsList = actionCreatorAsync$y("fetchUnsubsList", async (payload)=>{
    const response = await Api$1.poll.fetchUnsubsList(payload);
    return response.data;
});
const voteUnsubs = actionCreatorAsync$y("voteUnsubs", async (payload)=>{
    const { isAnonymous, answer, other, bloggerId } = payload;
    let succeeded = false;
    try {
        await Api$1.poll.voteUnsubs({
            is_anonymous: isAnonymous,
            answer: answer,
            other: other,
            blogger_id: bloggerId
        });
        succeeded = true;
    } catch (err) {
        throw new ApiError(err);
    }
    return {
        succeeded: succeeded
    };
});
const clearCurrentPoll = actionCreator$D("clearCurrentPoll");
const actionCreator$C = (0, $99y5v.actionCreatorFactory)("Drops");
const actionCreatorAsync$x = (0, $7Uc0p.asyncFactory)(actionCreator$C);
const fetchDropsProgress = actionCreatorAsync$x("fetchDropsProgress", async ({ blogUrl, slotUrl })=>{
    const response = await Api$1.drops.fetchProgress(blogUrl, slotUrl);
    return response.data.data;
});
const clearDropsProgress = actionCreator$C("clearDropsProgress");
const updateDropsProgress = actionCreator$C("updateDropsProgress");
const requestDropRewards = actionCreatorAsync$x("requestDropRewards", async ({ dropCampaignId })=>{
    const response = await Api$1.drops.requestProducts(dropCampaignId);
    return response.data.data;
});
const clearDropRewards = actionCreator$C("clearDropReward");
const clearDropRewardsToShow = actionCreator$C("clearDropRewardToShow");
const actionCreator$B = (0, $99y5v.actionCreatorFactory)("Polls");
const actionCreatorAsync$w = (0, $7Uc0p.asyncFactory)(actionCreator$B);
actionCreatorAsync$w("createPoll", async (payload)=>{
    const { blogUrl, hasOther, isMultiple, title: title2, options, finishTime } = payload;
    const response = await Api$1.poll.createPoll(blogUrl, {
        has_other: hasOther,
        is_multiple: isMultiple,
        title: title2,
        options: JSON.stringify(options),
        finish_time: finishTime
    });
    return response.data;
});
actionCreatorAsync$w("editPoll", async (payload)=>{
    const { blogUrl, pollId, hasOther, isMultiple, title: title2, options, finishTime } = payload;
    const response = await Api$1.poll.editPoll(blogUrl, pollId, {
        title: title2,
        options: JSON.stringify(options),
        has_other: hasOther,
        is_multiple: isMultiple,
        finish_time: finishTime
    });
    return response.data;
});
const fetchPoll = actionCreatorAsync$w("fetchPoll", async (payload)=>{
    const { blogUrl, pollId, limit } = payload;
    const response = await Api$1.poll.fetchPoll(blogUrl, pollId, limit);
    return response.data;
});
const fetchPollVoters = actionCreatorAsync$w("fetchPollVoters", async (payload, dispatch, getState)=>{
    const { blogUrl, pollId, ...params } = payload;
    const targetPost = getState().blog.posts.data.posts.find((post)=>{
        var _a3;
        return ((_a3 = post.poll) == null ? void 0 : _a3.id) === pollId;
    });
    const { voters: { extra: { offset: offset2 } } } = targetPost.poll.options.find((option2)=>option2.id === params.option);
    const response = await Api$1.poll.fetchPollVoters(blogUrl, pollId, {
        ...params,
        offset: offset2
    });
    return response.data;
});
const commitVote = actionCreatorAsync$w("commitVote", async (payload, dispatch)=>{
    const { blogUrl, pollId, answer, other, isAnonymous } = payload;
    const response = await Api$1.poll.commitVote(pollId, {
        answer: answer,
        other: other,
        is_anonymous: isAnonymous
    });
    dispatch(fetchPoll({
        blogUrl: blogUrl,
        pollId: pollId
    }));
    return response.data;
});
const retractVote = actionCreatorAsync$w("retractVote", async (payload, dispatch)=>{
    const { blogUrl, pollId } = payload;
    const response = await Api$1.poll.retractVote(pollId);
    dispatch(fetchPoll({
        blogUrl: blogUrl,
        pollId: pollId
    }));
    return response.data;
});
const markPollAsFinished = actionCreator$B("markPollAsFinished", (payload, dispatch)=>{
    const { blogUrl, pollId } = payload;
    dispatch(fetchPoll({
        blogUrl: blogUrl,
        pollId: pollId
    }));
});
const actionCreator$A = (0, $99y5v.actionCreatorFactory)("OverlayPopupState");
const setCurrentOpenedPopup = actionCreator$A("setOverlayPopup");
const resetCurrentOpenedPopup = actionCreator$A("resetOverlayPopup");
const actionCreator$z = (0, $99y5v.actionCreatorFactory)("RewardManager");
const actionCreatorAsync$v = (0, $7Uc0p.asyncFactory)(actionCreator$z);
const fetchRewardsManagerFilter = actionCreatorAsync$v("fetchRewardsManagerFilter", async ({ blogUrl })=>{
    const result2 = await Api$1.rewardManager.fetchFilter(blogUrl);
    return {
        data: result2.data.data.rewards
    };
});
const fetchRewardRequests = actionCreatorAsync$v("fetchRewardRequests", async ({ blogUrl, rewardId, limit = 10, offset: offset2 })=>{
    const result2 = await Api$1.rewardManager.fetchRewardRequestsList(blogUrl, rewardId, limit, offset2);
    return {
        data: result2.data.data.demands,
        extra: result2.data.extra
    };
});
actionCreatorAsync$v("fetchStatCsv", async ({ blogUrl, rewardId })=>{
    const res = await Api$1.rewardManager.fetchCsv(blogUrl, rewardId);
    return {
        data: res.data
    };
});
const fulfillAllDemands = actionCreatorAsync$v("fulfillAllDemands", async ({ blogUrl, rewardId })=>{
    await Api$1.rewardManager.fulfillAllDemands(blogUrl, rewardId);
    return {};
});
const fulfillDemandsBulk = actionCreatorAsync$v("fulfillDemandsBulk", async ({ blogUrl, rewardRequestIds })=>{
    await Api$1.rewardManager.fulfillDemandsBulk(blogUrl, rewardRequestIds);
    return {};
});
const rejectAllDemands = actionCreatorAsync$v("rejectAllDemands", async ({ blogUrl, rewardId })=>{
    await Api$1.rewardManager.rejectAllDemands(blogUrl, rewardId);
    return {};
});
const rejectDemandsBulk = actionCreatorAsync$v("rejectDemandsBulk", async ({ blogUrl, rewardRequestIds })=>{
    await Api$1.rewardManager.rejectDemandsBulk(blogUrl, rewardRequestIds);
    return {};
});
const updateRewardRequests = actionCreatorAsync$v("updateRewardRequests", async ({ blogUrl, rewardId, limit = 10, offset: offset2 })=>{
    const result2 = await Api$1.rewardManager.fetchRewardRequestsList(blogUrl, rewardId, limit, offset2);
    return {
        data: result2.data.data.demands,
        extra: result2.data.extra
    };
});
const selectRewardGroup = actionCreator$z("selectRewardGroup");
const processRewardEvent = actionCreator$z("processRewardEvent");
const clearRewardRequests = actionCreator$z("clearRewardRequests");
const clearRewardsManagerFilter = actionCreator$z("clearRewardsManagerFilter");
const actionCreator$y = (0, $99y5v.actionCreatorFactory)("Role");
const actionCreatorAsync$u = (0, $7Uc0p.asyncFactory)(actionCreator$y);
const clearRoles = actionCreator$y("clearRoles");
const clearUsersWithRoles = actionCreator$y("clearUsersWithRoles");
const fetchRoles = actionCreatorAsync$u("fetchRoles", async ({ blogUrl })=>{
    const response = await Api$1.role.fetchListRoles(blogUrl);
    return response.data.data;
});
const fetchUsersWithRoles = actionCreatorAsync$u("fetchUsersWithRoles", async ({ blogUrl, wasChangedFilters, params }, dispatch)=>{
    if (wasChangedFilters) dispatch(clearUsersWithRoles());
    const response = await Api$1.role.fetchListUsersWithRoles(blogUrl, params);
    return {
        users: response.data.data.users,
        extra: response.data.extra
    };
});
const createRole = actionCreatorAsync$u("createRole", async ({ blogUrl, params })=>{
    const { name: name2, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.role.create(blogUrl, {
        name: name2,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data;
});
const removeRole = actionCreatorAsync$u("removeRole", async ({ blogUrl, roleId, hasFilter })=>{
    await Api$1.role.remove(blogUrl, roleId);
    return {};
});
const updateRole = actionCreatorAsync$u("updateRole", async ({ blogUrl, roleId, params })=>{
    const { name: name2, smallImageId, mediumImageId, largeImageId } = params;
    const response = await Api$1.role.update(blogUrl, roleId, {
        name: name2,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return response.data.data.role;
});
actionCreatorAsync$u("uploadBadgeImage", async ({ blogUrl, smileSize, file })=>{
    const response = await Api$1.role.uploadBadgeImage(blogUrl, smileSize, file);
    return response.data.data.upload;
});
const changeRoleOrder = actionCreatorAsync$u("changeRoleOrder", async ({ blogUrl, params })=>{
    const response = await Api$1.role.changeOrder(blogUrl, {
        moved_role_id: params.movedRoleId,
        role_ids: params.roleIds
    });
    return response.data;
});
const assignRoles = actionCreatorAsync$u("assignRoles", async ({ blogUrl, user, params, filters }, dispatch)=>{
    var _a3;
    const response = await Api$1.role.assign(blogUrl, user.id, {
        role_ids: params.roleIds
    });
    if (((_a3 = filters == null ? void 0 : filters.roleIds) == null ? void 0 : _a3.length) > 0 || (filters == null ? void 0 : filters.nick)) {
        dispatch(clearUsersWithRoles());
        await dispatch(fetchUsersWithRoles({
            blogUrl: blogUrl,
            params: {
                limit: 20,
                roleIds: filters.roleIds,
                nick: filters.nick
            }
        }));
    }
    return response.data;
});
const removeUserRoles = actionCreatorAsync$u("removeUserRoles", async ({ blogUrl, userId })=>{
    await Api$1.role.removeRoles(blogUrl, userId);
    return {};
});
actionCreatorAsync$u("searchByUsers", async ({ blogUrl, query, limit })=>{
    const { data: { data } } = await Api$1.role.searchByUsers(blogUrl, query, limit);
    return data;
});
const actionCreator$x = (0, $99y5v.actionCreatorFactory)("Reward");
const postponeReward = actionCreator$x("postponeReward");
const clearPostponedReward = actionCreator$x("clearPostponedReward");
const actionCreator$w = (0, $99y5v.actionCreatorFactory)("Reward");
const actionCreatorAsync$t = (0, $7Uc0p.asyncFactory)(actionCreator$w);
const activateReward = actionCreatorAsync$t("activateReward", async ({ blogUrl, id, text: text2 })=>{
    await Api$1.channelReward.activateReward(blogUrl, id, text2);
});
actionCreatorAsync$t("uploadImageReward", async ({ blogUrl, size: size2, file })=>{
    const { data } = await Api$1.reward.uploadImageOwnReward(blogUrl, size2, file);
    return data.data.upload;
});
const createOwnReward = actionCreatorAsync$t("createOwnReward", async ({ blogUrl, params })=>{
    const { data } = await Api$1.reward.createOwnReward(blogUrl, {
        bgcolor: params.bgcolor,
        description: params.description,
        large_image_id: params.largeImageId,
        medium_image_id: params.mediumImageId,
        name: params.name,
        price: params.price,
        small_image_id: params.smallImageId,
        is_text_required: params.isTextRequired,
        max_uses_number_per_user: params.maxUsesNumberPerUser,
        max_uses_number: params.maxUsesNumber,
        repair_timeout: params.repairTimeout,
        repair_timeout_per_user: params.repairTimeoutPerUser,
        is_autoapproved: params.isAutoapproved,
        is_hidden_text: params.isHiddenText,
        is_unlimited: params.isUnlimited
    });
    return data.data.reward;
});
const fetchOwnRewards = actionCreatorAsync$t("fetchOwnRewards", async ({ blogUrl })=>{
    const { data } = await Api$1.reward.fetchOwnRewards(blogUrl);
    return data.data.rewards;
});
const updateOwnReward = actionCreatorAsync$t("updateReward", async ({ blogUrl, id, params })=>{
    const { data } = await Api$1.reward.updateOwnReward(blogUrl, id, {
        bgcolor: params.bgcolor,
        description: params.description,
        large_image_id: params.largeImageId,
        medium_image_id: params.mediumImageId,
        name: params.name,
        price: params.price,
        small_image_id: params.smallImageId,
        is_text_required: params.isTextRequired,
        max_uses_number_per_user: params.maxUsesNumberPerUser,
        max_uses_number: params.maxUsesNumber,
        repair_timeout: params.repairTimeout,
        repair_timeout_per_user: params.repairTimeoutPerUser,
        is_autoapproved: params.isAutoapproved,
        is_hidden_text: params.isHiddenText,
        is_unlimited: params.isUnlimited
    });
    return data.data.reward;
});
const deleteOwnReward = actionCreatorAsync$t("deleteOwnReward", async ({ blogUrl, id })=>{
    await Api$1.reward.deleteOwnReward(blogUrl, id);
    return {
        id: id
    };
});
const toggleReward = actionCreatorAsync$t("toggleReward", async ({ blogUrl, id, isEnabled })=>{
    let response = null;
    if (isEnabled) response = await Api$1.reward.enableReward(blogUrl, id);
    else response = await Api$1.reward.disableReward(blogUrl, id);
    return response.data.data.reward;
});
const fetchRewards = actionCreatorAsync$t("fetchRewards", async ({ blogUrl })=>{
    const { data } = await Api$1.reward.fetchRewards(blogUrl);
    return data.data.rewards;
});
const fetchRewardById = actionCreatorAsync$t("fetchRewardById", async ({ blogUrl, id })=>{
    const { data } = await Api$1.reward.fetchRewardById(blogUrl, id);
    return data.data.reward;
});
actionCreatorAsync$t("fetchManagerRewardById", async ({ blogUrl, id })=>{
    const { data } = await Api$1.rewardManager.fetchRewardById(blogUrl, id);
    return data.data.reward;
});
const clearRewards = actionCreator$w("clearRewards");
const markAsDeletedOwnReward = actionCreator$w("markAsDeletedOwnReward");
const clearChannelRewards = actionCreator$w("clearChannelRewards");
const fetchStandardRewards = actionCreatorAsync$t("fetchStandardRewards", async ({ blogUrl })=>{
    const response = await Api$1.reward.fetchStandardRewards(blogUrl);
    return {
        rewards: response.data.data.rewards
    };
});
const updateStandardReward = actionCreatorAsync$t("updateStandardReward", async ({ blogUrl, id, params })=>{
    const { data } = await Api$1.reward.updateStandardReward(blogUrl, id, {
        small_image_id: params.smallImageId,
        medium_image_id: params.mediumImageId,
        large_image_id: params.largeImageId,
        price: params.price,
        bgcolor: params.bgcolor
    });
    return data.data.reward;
});
const actionCreator$v = (0, $99y5v.actionCreatorFactory)("ChannelPoint");
const actionCreatorAsync$s = (0, $7Uc0p.asyncFactory)(actionCreator$v);
const getChannelPoint = actionCreatorAsync$s("getChannelPoint", async ({ blogUrl })=>{
    const { data } = await Api$1.channelPoint.getChannelPoint(blogUrl);
    return data.data.channelPoint;
});
const clearChannelPoint = actionCreator$v("clearChannelPoint");
const updateChannelPointBalance = actionCreator$v("updateChannelPointBalance");
const clearChannelPointUpdater = actionCreator$v("clearChannelPointUpdater");
const actionCreator$u = (0, $99y5v.actionCreatorFactory)("Prediction");
const actionCreatorAsync$r = (0, $7Uc0p.asyncFactory)(actionCreator$u);
const fetchPrediction = actionCreatorAsync$r("fetchPrediction", async ({ blogUrl, predictionId })=>{
    const result2 = predictionId ? await Api$1.channelPrediction.fetchPredictionById(blogUrl, predictionId) : await Api$1.channelPrediction.fetchActivePrediction(blogUrl);
    if (!result2) return null;
    const { data } = result2;
    return data == null ? void 0 : data.data.prediction;
});
const clearPrediction = actionCreator$u("clearPrediction");
const deletePrediction = actionCreatorAsync$r("deletePrediction", async ({ blogUrl })=>{
    await Api$1.channelPrediction.deletePrediction(blogUrl);
});
const setPrediction = actionCreator$u("setPrediction");
const donePrediction = actionCreatorAsync$r("donePrediction", async ({ blogUrl })=>{
    await Api$1.channelPrediction.donePrediction(blogUrl);
});
const manageDecisionPrediction = actionCreatorAsync$r("manageDecisionPrediction", async ({ blogUrl, id })=>{
    await Api$1.channelPrediction.manageDecisionPrediction(blogUrl, id);
});
const decisionPrediction = actionCreatorAsync$r("decisionPrediction", async ({ blogUrl, id, amount })=>{
    await Api$1.channelPrediction.decisionPrediction(blogUrl, id, amount);
});
actionCreatorAsync$r("createPrediction", async ({ blogUrl, params })=>{
    await Api$1.channelPrediction.createPrediction(blogUrl, params);
});
const decisionPredictionVoice = actionCreator$u("decisionPredictionVoice");
const subtractVoicePrediction = actionCreator$u("subtractVoicePrediction");
const unsetPreviousDecisionPrediction = actionCreator$u("unsetPreviousDecisionPrediction");
const decisionPredictionUnvoice = ({ id, amount })=>(dispatch)=>{
        dispatch(unsetPreviousDecisionPrediction({
            id: id
        }));
        dispatch(subtractVoicePrediction({
            id: id,
            amount: amount
        }));
    };
const setStatePrediction = actionCreator$u("setStatePrediction");
const setWinnerPrediction = actionCreator$u("setWinnerPrediction");
const unsetWinnerPrediction = actionCreator$u("unsetWinnerPrediction");
const setVisibilityPrediction = actionCreator$u("setVisibilityPrediction");
const mergePrediction = actionCreator$u("mergePrediction");
const actionCreator$t = (0, $99y5v.actionCreatorFactory)("Chat");
const actionCreatorAsync$q = (0, $7Uc0p.asyncFactory)(actionCreator$t);
const selectSmileInfoChatAction = actionCreator$t("selectSmileInfoChatAction");
const clearSmileInfoChat = actionCreator$t("clearSmileInfoChat");
const clearUserChatHistory = actionCreator$t("clearUserChatHistory");
const clearMessagesHoverElements = actionCreator$t("clearMessagesHoverElements");
const fetchUserChatHistory = actionCreatorAsync$q("fetchUserChatHistory", async ({ blogUrl, userId, ...restParams })=>{
    const result2 = await Api$1.stream.fetchUserChatHistory({
        blogUrl: blogUrl,
        userId: userId,
        ...restParams
    });
    return result2.data;
});
const fetchRecordChat = actionCreatorAsync$q("fetchRecordChat", async ({ blogUrl, recordId, limit = RECORD_CHAT_FETCH_LIMIT, ...restParams }, ignore, getState)=>{
    const result2 = await Api$1.record.fetchRecordChat(blogUrl, recordId, {
        ...restParams,
        limit: limit
    });
    const reversedData = result2.data.data.reverse();
    return {
        ...result2.data,
        data: reversedData,
        state: getState()
    };
});
const fetchClipChat = actionCreatorAsync$q("fetchClipChat", async ({ blogUrl, videoClipId, limit = RECORD_CHAT_FETCH_LIMIT, ...restParams })=>{
    const result2 = await Api$1.videoClip.fetchVideoClipChat(blogUrl, videoClipId, {
        ...restParams,
        limit: limit
    });
    const reversedData = result2.data.data.reverse();
    return {
        ...result2.data,
        data: reversedData
    };
});
const clearRecordChat = actionCreator$t("clearRecordChat");
const setRecordChatCurrentIndex = actionCreator$t("setRecordChatCurrentIndex");
const addMessageToChatHistory = actionCreator$t("addMessageToChatHistory");
const actionCreator$s = (0, $99y5v.actionCreatorFactory)("Analytics");
const actionCreatorAsync$p = (0, $7Uc0p.asyncFactory)(actionCreator$s);
const clearAnalytics = actionCreator$s("clearAnalytics");
const getMaxToDate = ()=>getNormalizedTimestamp(Date.now());
const MIN_FROM_DATE = getNormalizedTimestamp(PROJECT_START_DATE);
const fetchAnalyticsStreams = actionCreatorAsync$p("fetchAnalyticsStreams", async (params)=>{
    const { blogUrl, limit = 30, period: { fromDate, toDate: toDate2 } = {} } = params;
    const response = await Api$1.analytics.fetchStreams(blogUrl, {
        from_epoch: Math.max(getNormalizedTimestamp(fromDate), MIN_FROM_DATE) || MIN_FROM_DATE,
        limit: limit,
        to_epoch: Math.min(getNormalizedTimestamp(toDate2), getMaxToDate()) || getMaxToDate()
    });
    response.data.data.extra = {
        isLast: response.data.data.streams.length < limit
    };
    return response.data.data;
});
const fetchChannelAnalytics = actionCreatorAsync$p("fetchChannelAnalytics", async (params)=>{
    const { aggregationInterval, blogUrl, period: { presetPeriod, fromDate, toDate: toDate2 } } = params;
    const response = await Api$1.analytics.fetchChannelAnalytics(blogUrl, {
        aggregate_interval: aggregationInterval,
        date_interval: presetPeriod,
        from_epoch: presetPeriod === EAnalyticsPresetPeriod.CUSTOM ? Math.max(getNormalizedTimestamp(fromDate), MIN_FROM_DATE) || MIN_FROM_DATE : void 0,
        to_epoch: presetPeriod === EAnalyticsPresetPeriod.CUSTOM ? Math.min(getNormalizedTimestamp(toDate2), getMaxToDate()) || getMaxToDate() : void 0
    });
    return response.data.data;
});
const fetchStreamAnalytics = actionCreatorAsync$p("fetchStreamAnalytics", async (params)=>{
    const { blogUrl, streamId } = params;
    const response = await Api$1.analytics.fetchStreamAnalytics(blogUrl, streamId);
    return response.data.data;
});
const actionCreator$r = (0, $99y5v.actionCreatorFactory)("ChannelStat");
const actionCreatorAsync$o = (0, $7Uc0p.asyncFactory)(actionCreator$r);
const updateChannelSubscribersStat = actionCreator$r("updateChannelSubscribersStat");
const fetchChannelBasicStat = actionCreatorAsync$o("fetchChannelBasicStat", async ({ blogUrl })=>{
    const { data } = await Api$1.channelStat.fetchChannelBasicStat(blogUrl);
    return data.data.stat;
});
const actionCreator$q = (0, $99y5v.actionCreatorFactory)("CustomBlocks");
const actionCreatorAsync$n = (0, $7Uc0p.asyncFactory)(actionCreator$q);
const addCustomBlock = actionCreator$q("addCustomBlock");
const updateCustomBlock = actionCreator$q("updateCustomBlock");
const removeCustomBlock = actionCreator$q("removeCustomBlock");
const reorderCustomBlocksByIds = actionCreator$q("reorderCustomBlocksByIds");
const clearCustomBlocks = actionCreator$q("clearCustomBlocks");
const fetchCustomBlocks = actionCreatorAsync$n("fetchCustomBlocks", async ({ blogUrl })=>{
    const response = await Api$1.customBlocks.fetch(blogUrl);
    return {
        data: response.data.data.blocks
    };
});
actionCreatorAsync$n("fetchCustomBlocksItem", async ({ blogUrl, blockId })=>{
    const response = await Api$1.customBlocks.fetchItem(blogUrl, blockId);
    return {
        data: response.data.data.block
    };
});
actionCreatorAsync$n("createCustomBlock", async ({ blogUrl, data: { title: title2, imageId, description: description2, imageLinkUrl } })=>{
    const imageData = imageId ? {
        image_id: imageId,
        image_link: imageLinkUrl
    } : null;
    const response = await Api$1.customBlocks.createItem(blogUrl, {
        title: title2,
        description: description2,
        ...imageData
    });
    return {
        data: response.data.data.block
    };
});
actionCreatorAsync$n("editCustomBlock", async ({ blogUrl, blockId, data: { title: title2, imageId, description: description2, imageLinkUrl } })=>{
    const defaultData = {
        title: title2,
        description: description2
    };
    const imageData = imageId ? {
        image_id: imageId,
        image_link: imageLinkUrl
    } : {
        image_id: ""
    };
    const response = await Api$1.customBlocks.editItem(blogUrl, blockId, {
        ...defaultData,
        ...imageData
    });
    return {
        data: response.data.data.block
    };
});
actionCreatorAsync$n("deleteCustomBlock", async ({ blogUrl, blockId })=>{
    await Api$1.customBlocks.deleteItem(blogUrl, blockId);
});
actionCreatorAsync$n("updateCustomBlocksOrder", async ({ blogUrl, order })=>{
    const response = await Api$1.customBlocks.updateOrder(blogUrl, {
        block_ids: order
    });
    return {
        data: response.data.data.blocks
    };
});
const actionCreator$p = (0, $99y5v.actionCreatorFactory)("RatingProgram");
const actionCreatorAsync$m = (0, $7Uc0p.asyncFactory)(actionCreator$p);
const clearRatingProgram = actionCreator$p("clearRatingProgram");
const fetchRatingProgramCurrentSeason = actionCreatorAsync$m("fetchRatingProgramCurrentSeason", async (params)=>{
    const { blogUrl } = params;
    const response = await Api$1.ratingProgram.fetchCurrentSeason(blogUrl);
    return response.data.data;
});
actionCreatorAsync$m("dismissRatingProgramReachedLevelAlert", async ({ blogUrl }, dispatch)=>{
    const response = await Api$1.ratingProgram.dismissReachedLevelAlert(blogUrl);
    await dispatch(fetchRatingProgramCurrentSeason.action({
        blogUrl: blogUrl
    }));
    return response;
});
actionCreatorAsync$m("dismissRatingProgramSeasonFinishedAlert", async ({ blogUrl }, dispatch)=>{
    const response = await Api$1.ratingProgram.dismissSeasonFinishedAlert(blogUrl);
    await dispatch(fetchRatingProgramCurrentSeason.action({
        blogUrl: blogUrl
    }));
    return response;
});
const fetchRatingProgramSeasonsHistory = actionCreatorAsync$m("fetchRatingProgramSeasonsHistory", async ({ blogUrl })=>{
    const response = await Api$1.ratingProgram.fetchSeasonsHistory(blogUrl);
    return response.data.data;
});
const fetchRatingProgramDailyStat = actionCreatorAsync$m("fetchRatingProgramDailyStat", async ({ blogUrl, seasonId, metricName })=>{
    const response = await Api$1.ratingProgram.fetchDailyStat(blogUrl, seasonId, metricName);
    return response.data.data;
});
const requestVerificationState = actionCreatorAsync$m("requestVerificationState", // eslint-disable-next-line
// @ts-ignore
async ({ blogUrl })=>{
    return await Api$1.ratingProgram.fetchVerificationState(blogUrl);
});
actionCreatorAsync$m("sendVerificationRequest", async ({ blogUrl, name: name2, anotherCommunication })=>{
    return await Api$1.ratingProgram.sendVerificationRequest(blogUrl, name2, anotherCommunication);
});
const actionCreator$o = (0, $99y5v.actionCreatorFactory)("SupportProgram");
const actionCreatorAsync$l = (0, $7Uc0p.asyncFactory)(actionCreator$o);
const clearSupportProgram = actionCreator$o("clearSupportProgram");
const replacePaymentByTotalProfit = (metric)=>{
    if (metric.name === "payment") return {
        ...metric,
        name: ESupportProgramSeasonLevelMetricName.TOTAL_PROFIT
    };
    return metric;
};
const ensureTotalProfit = (season)=>{
    if (season.blogStatistics) season.blogStatistics = season.blogStatistics.map(replacePaymentByTotalProfit);
    if (season.levels) season.levels = season.levels.map((level)=>{
        level.metrics = level.metrics.map(replacePaymentByTotalProfit);
        return level;
    });
    return season;
};
const fetchSupportProgramCurrentSeason = actionCreatorAsync$l("fetchSupportProgramCurrentSeason", async (params)=>{
    let response;
    if (params == null ? void 0 : params.blogUrl) response = await Api$1.supportProgram.fetchCurrentSeason(params.blogUrl);
    else response = await Api$1.supportProgram.fetchCurrentSeasonUnauthorized();
    response.data.data.season = ensureTotalProfit(response.data.data.season);
    return response.data.data;
});
actionCreatorAsync$l("dismissSupportProgramReachedLevelAlert", async ({ blogUrl }, dispatch)=>{
    const response = await Api$1.supportProgram.dismissReachedLevelAlert(blogUrl);
    await dispatch(fetchSupportProgramCurrentSeason.action({
        blogUrl: blogUrl
    }));
    return response;
});
const fetchSupportProgramArchive = actionCreatorAsync$l("fetchSupportProgramArchive", async ({ blogUrl })=>{
    const response = await Api$1.supportProgram.fetchArchive(blogUrl);
    return response.data.data;
});
actionCreatorAsync$l("fetchSupportProgramSeason", async ({ blogUrl, seasonId })=>{
    const response = await Api$1.supportProgram.fetchSeason(blogUrl, seasonId);
    response.data.data.season = ensureTotalProfit(response.data.data.season);
    return response.data.data;
});
const fetchSupportProgramSeasons = actionCreatorAsync$l("fetchSupportProgramSeasons", async ({ blogUrl })=>{
    const response = await Api$1.supportProgram.fetchSeasons(blogUrl);
    return response.data.data;
});
const fetchSupportProgramSeasonsHistory = actionCreatorAsync$l("fetchSupportProgramSeasonsHistory", async ({ blogUrl })=>{
    const response = await Api$1.supportProgram.fetchSeasonsHistory(blogUrl);
    response.data.data.seasons = response.data.data.seasons.map(ensureTotalProfit);
    return response.data.data;
});
actionCreatorAsync$l("sendSupportProgramCurrentSeasonFeedback", async (payload, dispatch)=>{
    const { anotherCommunication, blogUrl, country, negativeExperience, name: name2, positiveExperience } = payload;
    await Api$1.supportProgram.sendCurrentSeasonFeedback(blogUrl, {
        another_communication: anotherCommunication,
        country: country,
        negative_experience: negativeExperience,
        name: name2,
        positive_experience: positiveExperience
    });
    await dispatch(fetchSupportProgramCurrentSeason.action({
        blogUrl: blogUrl
    }));
});
actionCreatorAsync$l("subscribeSupportProgramCurrentSeason", async ({ blogUrl }, dispatch, getState)=>{
    const state = getState();
    const marketingAlerts = state.currentUser.marketingAlerts.data || [];
    const supportProgramAlert = marketingAlerts.find((alert)=>alert.link.includes("/support-program"));
    if (supportProgramAlert) dispatch(dismissMarketingAlert.action({
        alertId: supportProgramAlert.id
    }));
    await Api$1.supportProgram.subscribeToCurrentSeason(blogUrl);
    await dispatch(fetchSupportProgramCurrentSeason.action({
        blogUrl: blogUrl
    }));
});
actionCreatorAsync$l("deleteSupportProgramSelfEmployment", async ()=>{
    await Api$1.payout.deleteSelfEmployment();
    return {};
});
const checkSupportProgramInn = actionCreatorAsync$l("checkSupportProgramInn", async ({ ignoreWidgetUrl } = {})=>{
    const response = await Api$1.payout.checkInnState();
    return {
        status: response.data.data.state,
        widgetUrl: ignoreWidgetUrl ? null : response.data.data.widgetUrl
    };
});
const bindSupportProgramInn = actionCreatorAsync$l("bindSupportProgramInn", async ({ inn })=>{
    const response = await Api$1.payout.bindInn(inn);
    return {
        status: response.data.data.state,
        widgetUrl: response.data.data.widgetUrl
    };
});
const clearSupportProgramInnWidgetUrl = actionCreator$o("clearSupportProgramInnWidgetUrl");
const fetchSupportProgramDailyStat = actionCreatorAsync$l("fetchSupportProgramDailyStat", async ({ blogUrl, seasonId, metricName })=>{
    const response = await Api$1.supportProgram.fetchDailyStat(blogUrl, seasonId, metricName);
    return response.data.data;
});
const updateSupportProgramBankCards = actionCreatorAsync$l("updateSupportProgramBankCards", async ()=>{
    const response = await Api$1.payout.updateBankCards();
    return response.data.data;
});
const updateSupportProgramBankCardsFromWS = actionCreator$o("updateSupportProgramBankCardsFromWS");
const bindSupportProgramBankCards = actionCreatorAsync$l("bindSupportProgramBankCards", async ()=>{
    const response = await Api$1.payout.bindBankCards();
    return response.data.data;
});
const fetchSupportProgramBankCards = actionCreatorAsync$l("fetchSupportProgramBankCards", async ()=>{
    const response = await Api$1.payout.getBankCards();
    return {
        bankCards: response.data.data.bankCards,
        isBankCardsListBeingUpdated: response.data.data.isBankCardsListBeingUpdated
    };
});
const clearSupportProgramBankCardBindUrl = actionCreator$o("clearSupportProgramBankCardBindUrl");
const receiveSupportProgramPayout = actionCreatorAsync$l("receiveSupportProgramPayout", async ({ blogUrl, seasonId, cardId })=>{
    const response = await Api$1.supportProgram.receivePayout(blogUrl, seasonId, {
        card_id: cardId
    });
    return response.data.data;
});
const fetchRecord = actionCreatorAsync$Y("fetchRecord", async ({ blogUrl, recordId, getAbort })=>{
    const response = await Api$1.record.fetchRecord({
        blogUrl: blogUrl,
        recordId: recordId,
        getAbort: getAbort
    });
    return {
        data: response.data.data.record
    };
});
actionCreatorAsync$Y("fetchRecordForDownload", async ({ blogUrl, recordId })=>{
    const response = await Api$1.record.fetchRecord({
        blogUrl: blogUrl,
        recordId: recordId
    });
    return {
        playerUrls: response.data.data.record.data[0].playerUrls
    };
});
const viewRecord = actionCreatorAsync$Y("viewRecord", async ({ blogUrl, recordId })=>{
    await Api$1.record.viewRecord(blogUrl, recordId);
});
const actionCreator$n = (0, $99y5v.actionCreatorFactory)("Records");
const actionCreatorAsync$k = (0, $7Uc0p.asyncFactory)(actionCreator$n);
const clearRecords = actionCreator$n("clearRecords");
const fetchRecords = actionCreatorAsync$k("fetchRecords", async ({ blogUrl, limit, offset: offset2 })=>{
    const response = await Api$1.record.fetch(blogUrl, limit, offset2 || "0");
    return {
        data: response.data.data.records,
        extra: response.data.extra
    };
});
actionCreatorAsync$k("fetchRecordAutoplayData", async ({ blogUrl, recordId, index: index2, getAbort })=>{
    const response = await Api$1.record.fetchRecord({
        blogUrl: blogUrl,
        recordId: recordId,
        getAbort: getAbort
    });
    return {
        data: response.data.data.record,
        recordId: recordId
    };
});
const deleteRecord = actionCreatorAsync$k("deleteRecord", async ({ blogUrl, recordId, reason: reason2 })=>{
    await Api$1.record.deleteRecord(blogUrl, recordId, reason2);
});
const likeRecord = actionCreatorAsync$Y("likeRecord", async ({ blogUrl, recordId })=>{
    await Api$1.record.likeRecord(blogUrl, recordId);
    return {};
});
const unlikeRecord = actionCreatorAsync$Y("unlikeRecord", async ({ blogUrl, recordId })=>{
    await Api$1.record.unlikeRecord(blogUrl, recordId);
    return {};
});
const clearRecord = actionCreator$15("clearRecord");
const hideRecord = actionCreatorAsync$Y("hideRecord", async ({ blogUrl, recordId })=>{
    await Api$1.record.hideRecord(blogUrl, recordId);
    return {};
});
const removeRecordFromHidden = actionCreatorAsync$Y("removeRecordFromHidden", async ({ blogUrl, recordId })=>{
    await Api$1.record.removeRecordFromHidden(blogUrl, recordId);
    return {};
});
const uploadRecordPreview = actionCreatorAsync$Y("uploadRecordPreview", async ({ blogUrl, recordId, file })=>{
    const response = await Api$1.record.uploadRecordPreview(blogUrl, recordId, file);
    return {
        url: response.data.data.url
    };
});
const removeRecordPreview = actionCreatorAsync$Y("removeRecordPreview", async ({ blogUrl, recordId })=>{
    const response = await Api$1.record.removeRecordPreview(blogUrl, recordId);
    return {
        url: response.data.data.url
    };
});
const toggleVisibilityRecord = actionCreatorAsync$Y("toggleVisibilityRecord", async ({ isHidden: isHidden3, blogUrl, recordId }, dispatch)=>{
    if (isHidden3) await dispatch(removeRecordFromHidden.action({
        blogUrl: blogUrl,
        recordId: recordId
    }));
    else await dispatch(hideRecord.action({
        blogUrl: blogUrl,
        recordId: recordId
    }));
    return {};
});
const updateRecord = actionCreatorAsync$Y("updateRecord", async ({ blogUrl, recordId, data })=>{
    const response = await Api$1.record.editRecord(blogUrl, recordId, data.categoryId, data.subscriptionLevelId, data.titleData);
    return {
        data: response.data.data.record
    };
});
const updateRecordPart = actionCreatorAsync$Y("updateRecordPart", async ({ blogUrl, recordId, data })=>{
    const response = await Api$1.record.editRecord(blogUrl, recordId, data.categoryId, data.subscriptionLevelId, data.titleData);
    return {
        data: response.data.data.record
    };
});
const editRecord = actionCreatorAsync$Y("editRecord", async (params, dispatch)=>{
    const { blogUrl, categoryId, cover, isRemovableCover, recordId, subscriptionLevelId, titleData } = params;
    const [recordRes, imageRes] = await Promise.all([
        dispatch(updateRecordPart.action({
            blogUrl: blogUrl,
            recordId: recordId,
            data: {
                titleData: titleData,
                categoryId: categoryId,
                subscriptionLevelId: subscriptionLevelId
            }
        })),
        cover ? dispatch(uploadRecordPreview.action({
            blogUrl: blogUrl,
            recordId: recordId,
            file: cover
        })) : isRemovableCover ? dispatch(removeRecordPreview.action({
            blogUrl: blogUrl,
            recordId: recordId
        })) : null
    ]);
    const newPreviewUrl = imageRes == null ? void 0 : imageRes.url;
    if (newPreviewUrl) recordRes.data.previewUrl = newPreviewUrl;
    return recordRes;
});
const registerRecordPlayer = actionCreator$15("registerRecordPlayer");
const unregisterRecordPlayer = actionCreator$15("unregisterRecordPlayer");
const actionCreator$m = (0, $99y5v.actionCreatorFactory)("HostStatus");
const actionCreatorAsync$j = (0, $7Uc0p.asyncFactory)(actionCreator$m);
const fetchHostStatus = actionCreatorAsync$j("fetchHostStatus", async ({ blogUrl })=>{
    const response = await Api$1.hostStatus.fetchHostStatus(blogUrl);
    return response.data.data;
});
const startHostStream = actionCreatorAsync$j("startHostStream", async ({ ownBlogUrl, sourceUrl })=>{
    const response = await Api$1.hostStatus.startHost(ownBlogUrl, {
        source_url: sourceUrl
    });
    return response.data.data.stream;
});
const stopHostStream = actionCreatorAsync$j("stopHostStream", async ({ blogUrl })=>{
    await Api$1.hostStatus.stopHost(blogUrl);
    return {};
});
const clearHostStatus = actionCreator$m("clearHostStatus");
const computeHostStatus = actionCreator$m("computeHostStatus");
const actionCreator$l = (0, $99y5v.actionCreatorFactory)("ExternalApp");
const actionCreatorAsync$i = (0, $7Uc0p.asyncFactory)(actionCreator$l);
const { checkApp } = getProviderActions();
const fetchExternalApp = actionCreatorAsync$i("fetchExternalApp", async ({ appId, redirectUri })=>{
    await checkApp({
        client_id: appId,
        redirect_uri: redirectUri
    });
    const response = await Api$1.systemApi.fetchExternalApp(appId);
    return response.data;
});
const fetchThirdPartyApp = actionCreatorAsync$i("fetchThirdPartyApp", async ({ appId, redirectUri, scope })=>{
    await checkApp({
        client_id: appId,
        redirect_uri: redirectUri
    });
    const response = await Api$1.systemApi.fetchThirdPartyApp(appId, scope);
    return response.data;
});
const fetchConnectedAppsList = actionCreatorAsync$i("fetchConnectedAppsList", async ()=>{
    const response = await Api$1.systemApi.fetchConnectedAppsList();
    return response.data;
});
actionCreatorAsync$i("disconnectApp", async ({ slug })=>{
    await Api$1.systemApi.disconnectApp(slug);
});
const actionCreator$k = (0, $99y5v.actionCreatorFactory)("ExternalApp");
const actionCreatorAsync$h = (0, $7Uc0p.asyncFactory)(actionCreator$k);
actionCreatorAsync$h("getDeviceInfo", async ({ userCode })=>{
    const response = await Api$1.deviceApi.getDeviceInfo(userCode);
    return response.data;
});
actionCreatorAsync$h("deviceExchange", async ({ userCode })=>{
    return await Api$1.deviceApi.deviceExchange(userCode);
});
const actionCreator$j = (0, $99y5v.actionCreatorFactory)("ChannelPoint");
const actionCreatorAsync$g = (0, $7Uc0p.asyncFactory)(actionCreator$j);
const getOwnChannelPoint = actionCreatorAsync$g("getOwnChannelPoint", async ({ blogUrl })=>{
    const { data } = await Api$1.ownChannelPoint.getOwnChannelPoint(blogUrl);
    return data.data.channelPoint;
});
const enableOwnChannelPoint = actionCreatorAsync$g("enableOwnChannelPoint", async ({ blogUrl })=>{
    const { data } = await Api$1.ownChannelPoint.enableOwnChannelPoint(blogUrl);
    return data.data.channelPoint;
});
const disableOwnChannelPoint = actionCreatorAsync$g("disableOwnChannelPoint", async ({ blogUrl })=>{
    const { data } = await Api$1.ownChannelPoint.disableOwnChannelPoint(blogUrl);
    return data.data.channelPoint;
});
const createOwnChannelPoint = actionCreatorAsync$g("createOwnChannelPoint", async ({ blogUrl, name: name2 })=>{
    const { data } = await Api$1.ownChannelPoint.createOwnChannelPoint(blogUrl, name2);
    return data.data.channelPoint;
});
actionCreatorAsync$g("uploadImageChannelPoint", async ({ blogUrl, size: size2, file })=>{
    const { data } = await Api$1.ownChannelPoint.uploadImageOwnChannelPoint(blogUrl, size2, file);
    return data.data.upload;
});
const updateOwnChannelPoint = actionCreatorAsync$g("updateChannelPoint", async ({ blogUrl, params: { name: name2, smallImageId, largeImageId, mediumImageId } })=>{
    const { data } = await Api$1.ownChannelPoint.updateOwnChannelPoint(blogUrl, {
        name: name2,
        small_image_id: smallImageId,
        medium_image_id: mediumImageId,
        large_image_id: largeImageId
    });
    return data.data.channelPoint;
});
const resetOwnChannelPoint = actionCreatorAsync$g("resetOwnChannelPoint", async ({ blogUrl })=>{
    const { data } = await Api$1.ownChannelPoint.resetOwnChannelPoint(blogUrl);
    return data.data.channelPoint;
});
const clearOwnChannelPoint = actionCreator$j("clearOwnChannelPoint");
const actionCreator$i = (0, $99y5v.actionCreatorFactory)("ChannelPointBonus");
const actionCreatorAsync$f = (0, $7Uc0p.asyncFactory)(actionCreator$i);
const getChannelPointPendingBonus = actionCreatorAsync$f("getChannelPointPendingBonus", async ({ blogUrl })=>{
    const { data } = await Api$1.channelPointBonus.getPendingBonus(blogUrl);
    return data.data.bonuses;
});
const getChannelPointBonus = actionCreatorAsync$f("getChannelPointBonus", async ({ blogUrl })=>{
    const { data } = await Api$1.channelPointBonus.getBonus(blogUrl);
    return data.data;
});
const gatherChannelPointPendingBonus = actionCreatorAsync$f("gatherChannelPointPendingBonus", async ({ blogUrl, id })=>{
    await Api$1.channelPointBonus.gatherPendingBonus(blogUrl, id);
    return {
        id: id
    };
});
const clearChannelPointPendingBonus = actionCreator$i("clearChannelPointPendingBonus");
const clearChannelPointBonus = actionCreator$i("clearChannelPointBonus");
const updateChannelPointPendingBonus = actionCreator$i("updateChannelPointPendingBonus");
const actionCreator$h = (0, $99y5v.actionCreatorFactory)("ChatBot");
const actionCreatorAsync$e = (0, $7Uc0p.asyncFactory)(actionCreator$h);
const clearTimers = actionCreator$h("clearTimers");
const fetchTimers = actionCreatorAsync$e("fetchTimers", async ({ blogUrl, limit, after })=>{
    const response = await Api$1.chatBot.fetchTimers(blogUrl, limit, after);
    return {
        timers: response.data.data.timers,
        extra: response.data.extra
    };
});
const createTimer = actionCreatorAsync$e("createTimer", async ({ blogUrl, data })=>{
    const { name: name2, messages: messages2, timeInterval, messageInterval, disabled: disabled2 = false } = data;
    const response = await Api$1.chatBot.createTimer(blogUrl, {
        name: name2,
        messages: JSON.stringify(messages2).replace(/mediaData/ig, "media_data"),
        time_interval: timeInterval,
        message_interval: messageInterval ? Number(messageInterval) : 0,
        disabled: disabled2
    });
    return response.data.data;
});
const editTimer = actionCreatorAsync$e("editTimer", async ({ blogUrl, timerId: timerId2, data })=>{
    const { name: name2, messages: messages2, timeInterval, messageInterval, disabled: disabled2 = false } = data;
    const response = await Api$1.chatBot.editTimer(blogUrl, timerId2, {
        name: name2,
        messages: JSON.stringify(messages2).replace(/mediaData/ig, "media_data"),
        time_interval: timeInterval,
        message_interval: messageInterval ? Number(messageInterval) : 0,
        disabled: disabled2
    });
    return response.data.data;
});
const deleteTimer = actionCreatorAsync$e("deleteTimer", async ({ blogUrl, timerId: timerId2 })=>{
    await Api$1.chatBot.deleteTimer(blogUrl, timerId2);
    return {};
});
const createCommand = actionCreatorAsync$e("createCommand", async ({ blogUrl, data })=>{
    const response = await Api$1.chatBot.createCommand(blogUrl, data);
    return response.data;
});
const fetchCommandsList = actionCreatorAsync$e("fetchCommandsList", async ({ blogUrl, limit, offset: offset2 })=>{
    const response = await Api$1.chatBot.fetchCommandsList(blogUrl, limit, offset2 = offset2 || 0);
    return {
        commands: response.data.data.commands,
        extra: response.data.extra
    };
});
const editCommand = actionCreatorAsync$e("editCommand", async ({ blogUrl, commandId, data })=>{
    const response = await Api$1.chatBot.editCommand(blogUrl, commandId, data);
    return response.data;
});
const deleteCommand = actionCreatorAsync$e("deleteCommand", async ({ blogUrl, id })=>{
    await Api$1.chatBot.deleteCommand(blogUrl, id);
    return {};
});
const toggleCommand = actionCreatorAsync$e("toggleCommand", async ({ blogUrl, commandId, isActive })=>{
    isActive ? await Api$1.chatBot.toggleCommandInactive(blogUrl, commandId) : await Api$1.chatBot.toggleCommandActive(blogUrl, commandId);
    return {};
});
const fetchCommand = actionCreatorAsync$e("fetchCommand", async ({ blogUrl, commandId })=>{
    const response = await Api$1.chatBot.fetchCommand(blogUrl, commandId);
    return response.data;
});
const clearCommand = actionCreator$h("clearCommand");
const clearCommands = actionCreator$h("clearCommands");
const actionCreator$g = (0, $99y5v.actionCreatorFactory)("News");
const actionCreatorAsync$d = (0, $7Uc0p.asyncFactory)(actionCreator$g);
const fetchLatestNews = actionCreatorAsync$d("fetchLatestNews", async ({ platform: platform2 })=>{
    const response = await Api$1.news.fetchLatestNews(platform2);
    return response.data.data.novelty;
});
const fetchLastNews = actionCreatorAsync$d("fetchLastNews", async ({ platform: platform2 })=>{
    const response = await Api$1.news.fetchLastNews(platform2);
    return response.data.data.novelty;
});
const viewNews = actionCreatorAsync$d("viewNews", async ({ id })=>{
    await Api$1.news.viewNews(id);
    return {};
});
const actionCreator$f = (0, $99y5v.actionCreatorFactory)("ServiceStates");
const disableHotkeys = actionCreator$f("disableHotkeys");
const actionCreator$e = (0, $99y5v.actionCreatorFactory)("Multiplicators");
const actionCreatorAsync$c = (0, $7Uc0p.asyncFactory)(actionCreator$e);
const fetchMultiplicators = actionCreatorAsync$c("fetchMultiplicators", async ({ blogUrl })=>{
    const response = await Api$1.multiplicators.fetchMultiplicators(blogUrl);
    return response.data.data.subscriptionLevels;
});
actionCreatorAsync$c("updateMultiplicators", async ({ blogUrl, payload })=>{
    return Api$1.multiplicators.updateMultiplicators(blogUrl, payload);
});
const actionCreator$d = (0, $99y5v.actionCreatorFactory)("SubscriptionGift");
const actionCreatorAsync$b = (0, $7Uc0p.asyncFactory)(actionCreator$d);
actionCreatorAsync$b("fetchSubscriptionGiftLevelId", async ({ blogUrl, levelId })=>{
    const { data } = await Api$1.subscriptionGift.fetchSubscriptionGiftLevelId(blogUrl, levelId);
    return data.data;
});
const fetchSubscriptionGift = actionCreatorAsync$b("fetchSubscriptionGift", async ({ blogUrl })=>{
    const { data } = await Api$1.subscriptionGift.fetchSubscriptionGift(blogUrl);
    return {
        gifts: data.data.gifts
    };
});
const clearSubscriptionGift = actionCreator$d("clearSubscriptionGift");
const clearSubscriptionGiftExternalBlog = actionCreator$d("clearSubscriptionGiftExternalBlog");
const sendSubscriptionGift = actionCreatorAsync$b("sendSubscriptionGift", async ({ blogUrl, levelId, count: count2, isAnonymous, userId })=>{
    await Api$1.subscriptionGift.sendSubscriptionGift(blogUrl, levelId, count2, userId);
    return {};
});
const addSubscriptionGift = actionCreator$d("addSubscriptionGift");
const setAutofillGiftUser = actionCreator$d("setAutofillGiftUser");
const decrementSubscriptionGift = actionCreator$d("decrementSubscriptionGift");
const setSubscriptionGiftExternalBlogStatusSendGiftPopup = actionCreator$d("setSubscriptionGiftExternalBlogStatusSendGiftPopup");
const actionCreator$c = (0, $99y5v.actionCreatorFactory)("SelfUser");
const actionCreatorAsync$a = (0, $7Uc0p.asyncFactory)(actionCreator$c);
const fetchLettersSubscriptionGiftUsers = actionCreatorAsync$a("fetchLettersSubscriptionGiftUsers", async ({ donatorId, streamerId })=>{
    const { data } = await Api$1.user.fetchSelf({
        userIds: [
            donatorId,
            streamerId
        ]
    });
    const donator = data.data.users.find((user)=>user.id === donatorId);
    const streamer = data.data.users.find((user)=>user.id === streamerId);
    return {
        donator: donator,
        streamer: streamer
    };
});
const actionCreator$b = (0, $99y5v.actionCreatorFactory)("SubscriptionLevelBoosty");
const actionCreatorAsync$9 = (0, $7Uc0p.asyncFactory)(actionCreator$b);
const fetchSubscriptionLevelBoosty = actionCreatorAsync$9("fetchSubscriptionLevelBoosty", async ({ blogUrl, levelId })=>{
    const { data } = await Api$1.channel.fetchSubscriptionLevelBoosty(blogUrl, levelId);
    return data.data.subscriptionLevel;
});
const actionCreator$a = (0, $99y5v.actionCreatorFactory)("Notifications");
const actionCreatorAsync$8 = (0, $7Uc0p.asyncFactory)(actionCreator$a);
const postDeviceTokenNotifications = actionCreatorAsync$8("postDeviceTokenNotifications", async ({ accessToken, deviceToken })=>{
    await Api$1.browserNotifications.postDeviceToken({
        accessToken: accessToken,
        deviceToken: deviceToken
    });
});
const actionCreator$9 = (0, $99y5v.actionCreatorFactory)("ModerationLog");
const actionCreatorAsync$7 = (0, $7Uc0p.asyncFactory)(actionCreator$9);
const clearModerationLog = actionCreator$9("clearModerationLog");
const fetchModerationLog = actionCreatorAsync$7("fetchModerationLog", async ({ blogUrl, wasChangedFilters, moderatorId, eventTypes, limit, after }, dispatch)=>{
    if ((eventTypes == null ? void 0 : eventTypes.length) === 0) return {
        events: [],
        extra: {
            after: null
        }
    };
    const isAll = (eventTypes == null ? void 0 : eventTypes.length) === Object.keys(EModerationLogEventType).length;
    const response = await Api$1.moderationLog.fetchModerationLog(blogUrl, moderatorId, isAll ? null : eventTypes, limit, after);
    if (wasChangedFilters) dispatch(clearModerationLog());
    return {
        events: response.data.data.events,
        extra: response.data.extra
    };
});
const addModerationLogFromWS = actionCreator$9("addModerationLogFromWS");
const actionCreator$8 = (0, $99y5v.actionCreatorFactory)("Playlist");
const actionCreatorAsync$6 = (0, $7Uc0p.asyncFactory)(actionCreator$8);
const uploadPlaylistCover = actionCreatorAsync$6("uploadPlaylistCover", async ({ cover, containerType })=>{
    const response = await Api$1.mediaData.uploadImage(cover, EMediaDataImageContainerType.PLAYLIST);
    return {
        id: response.data.id
    };
});
const createPlaylist = actionCreatorAsync$6("createPlaylist", async ({ blogUrl, title: title2, categoryId, cover }, dispatch)=>{
    let coverId = null;
    if (Boolean(cover)) try {
        coverId = await dispatch(uploadPlaylistCover.action({
            cover: cover,
            containerType: EMediaDataImageContainerType.PLAYLIST
        }));
    } catch (ignore) {}
    const response = await Api$1.playlist.createPlaylist(blogUrl, {
        title: title2,
        category_id: categoryId,
        cover_image_id: coverId == null ? void 0 : coverId.id
    });
    return {
        playlist: response.data.data.playlist
    };
});
const editPlaylist = actionCreatorAsync$6("editPlaylist", async ({ blogUrl, playlistId, title: title2, categoryId, cover, isCoverRemoved }, dispatch)=>{
    let coverId = null;
    if (Boolean(cover)) try {
        coverId = await dispatch(uploadPlaylistCover.action({
            cover: cover,
            containerType: EMediaDataImageContainerType.PLAYLIST
        }));
    } catch (ignore) {}
    const response = await Api$1.playlist.editPlaylist(blogUrl, playlistId, {
        title: title2,
        category_id: categoryId,
        cover_image_id: (coverId == null ? void 0 : coverId.id) ?? (isCoverRemoved ? "" : null)
    });
    return {
        playlist: response.data.data.playlist
    };
});
const fetchPlaylist = actionCreatorAsync$6("fetchPlaylist", async ({ blogUrl, playlistId, isAllowed })=>{
    const response = await Api$1.playlist.fetchPlaylist(blogUrl, playlistId, isAllowed);
    return response.data.data;
});
const fetchPlaylists = actionCreatorAsync$6("fetchPlaylists", async ({ blogUrl, limit, offset: offset2, isModerator })=>{
    var _a3, _b2, _c2;
    const response = isModerator ? await Api$1.playlist.getModeratorPlaylists(blogUrl, {
        limit: limit,
        offset: offset2 || 0
    }) : await Api$1.playlist.getPlaylists(blogUrl, {
        limit: limit,
        offset: offset2 || 0
    });
    return {
        playlists: (_b2 = (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3.data) == null ? void 0 : _b2.playlists,
        extra: (_c2 = response == null ? void 0 : response.data) == null ? void 0 : _c2.extra
    };
});
const clearCurrentPlaylistEntities = actionCreator$8("clearCurrentPlaylistEntities");
const clearCurrentPlaylistEntity = actionCreator$8("clearCurrentPlaylistEntity");
const fetchPlaylistVideo = actionCreatorAsync$6("fetchPlaylistVideo", async ({ blogUrl, playlistId, limit, isAllowed, offset: offset2 }, dispatch)=>{
    const response = await Api$1.playlist.fetchPlaylistVideo(blogUrl, playlistId, isAllowed, {
        limit: limit,
        offset: offset2 || 0
    });
    if (!response.data.data.playlistEntities.length) {
        dispatch(clearCurrentPlaylistEntity());
        dispatch(clearRecord());
    }
    if (!offset2) dispatch(clearCurrentPlaylistEntities());
    return {
        videos: response.data.data.playlistEntities,
        extra: response.data.extra
    };
});
const fetchPlaylistEntity = actionCreatorAsync$6("fetchPlaylistEntity", async ({ blogUrl, playlistId, entityId })=>{
    var _a3;
    const response = await Api$1.playlist.fetchPlaylistEntity(blogUrl, playlistId, entityId);
    return (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3.data;
});
const fetchAvailableRecords = actionCreatorAsync$6("fetchAvailableRecords", async ({ blogUrl, playlistId, limit, offset: offset2 })=>{
    const response = await Api$1.playlist.fetchAvailableRecords(blogUrl, playlistId, {
        limit: limit,
        offset: offset2
    });
    return {
        records: response.data.data.records,
        extra: response.data.extra
    };
});
const addPlaylistVideo = actionCreatorAsync$6("addPlaylistVideo", async ({ blogUrl, playlistId, recordsIds })=>{
    const response = await Api$1.playlist.addPlaylistVideo(blogUrl, playlistId, {
        record_id: recordsIds
    });
    return {
        playlistEntities: response.data.data.playlistEntities
    };
});
const clearAvailableRecords = actionCreator$8("clearAvailableRecords");
const clearCurrentPlaylist = actionCreator$8("clearCurrentPlaylist");
const clearPlaylists = actionCreator$8("clearPlaylists");
const deletePlaylist = actionCreatorAsync$6("deletePlaylist", async ({ blogUrl, playlistId })=>{
    await Api$1.playlist.deletePlaylist(blogUrl, playlistId);
});
const hidePlaylist = actionCreatorAsync$6("hidePlaylist", async ({ blogUrl, playlistId, withContent })=>{
    await Api$1.playlist.hidePlaylist(blogUrl, playlistId, {
        with_content: withContent
    });
});
const deletefromHidePlaylist = actionCreatorAsync$6("deleteFromHidePlaylist", async ({ blogUrl, playlistId, withContent })=>{
    await Api$1.playlist.deleteFromHidePlaylist(blogUrl, playlistId, {
        with_content: withContent
    });
});
const movePlaylist = actionCreatorAsync$6("movePlaylist", async ({ blogUrl, playlistId, beforeId })=>{
    await Api$1.playlist.movePlaylist(blogUrl, playlistId, {
        before_playlist_id: beforeId
    });
});
const movePlaylistEntity = actionCreatorAsync$6("movePlaylistEntity", async ({ blogUrl, playlistId, entityId, beforeId })=>{
    await Api$1.playlist.movePlaylistEntity(blogUrl, playlistId, entityId, {
        before_entity_id: beforeId
    });
});
const deleteFromPlaylist = actionCreatorAsync$6("deleteFromPlaylist", async ({ blogUrl, playlistId, entityId })=>{
    await Api$1.playlist.deleteFromPlaylist(blogUrl, playlistId, entityId);
});
const actionCreator$7 = (0, $99y5v.actionCreatorFactory)("ChannelModerator");
const actionCreatorAsync$5 = (0, $7Uc0p.asyncFactory)(actionCreator$7);
actionCreatorAsync$5("assignNewRole", async ({ blogUrl, userId, role: role2 })=>await Api$1.channelModerator.assignNewRole(blogUrl, userId, role2));
const deleteRole = actionCreatorAsync$5("deleteRole", async ({ blogUrl, userId })=>{
    const { data } = await Api$1.channelModerator.deleteRole(blogUrl, userId);
    return data;
});
const fetchChannelModerators = actionCreatorAsync$5("fetchChannelModerators", async ({ blogUrl, roles: roles2, pattern, limit, offset: offset2 })=>{
    const { data } = await Api$1.channelModerator.fetchModerators({
        blogUrl: blogUrl,
        roles: roles2,
        pattern: pattern,
        limit: limit,
        offset: offset2
    });
    return {
        ...data.data,
        extra: data.extra
    };
});
const cleanChannelModerators = actionCreator$7("cleanChannelModerators");
const setRole = actionCreatorAsync$5("setRole", async ({ blogUrl, userId, role: role2 })=>{
    const { data } = await Api$1.channelModerator.setRole(blogUrl, userId, role2);
    return data.data.moderator;
});
const deleteRoleStorage = actionCreator$7("deleteRoleStorage");
const restoreRoleStorage = actionCreator$7("restoreRoleStorage");
const actionCreator$6 = (0, $99y5v.actionCreatorFactory)("Publisher");
const focusPublisher = actionCreator$6("focusPublisher");
const actionCreator$5 = (0, $99y5v.actionCreatorFactory)("VkVideoPlayerState");
const focusVkVideoPlayerState = actionCreator$5("focusVkVideoPlayerState");
const setMainVideoPlayer = actionCreator$5("setMainVideoPlayer");
actionCreator$5("setStreamPlayer");
const actionCreator$4 = (0, $99y5v.actionCreatorFactory)("ChannelBan");
const actionCreatorAsync$4 = (0, $7Uc0p.asyncFactory)(actionCreator$4);
const clearChannelBan = actionCreator$4("clearChannelBan");
const fetchChannelBan = actionCreatorAsync$4("fetchChannelBan", async ({ blogUrl })=>{
    const { data } = await Api$1.channelBan.fetchBan(blogUrl);
    return {
        permanent: data.data.permanent.bans,
        temporary: data.data.temporary.bans
    };
});
const deleteChannelBan = actionCreatorAsync$4("deleteChannelBan", async ({ blogUrl, userId, byStream })=>{
    await Api$1.channelBan.deleteBan(blogUrl, userId, byStream);
});
const addChannelTemporaryBanFromWS = actionCreator$4("addChannelTemporaryBanFromWS");
const addChannelPermanentBanFromWS = actionCreator$4("addChannelPermanentBanFromWS");
const actionCreator$3 = (0, $99y5v.actionCreatorFactory)("Integration");
const actionCreatorAsync$3 = (0, $7Uc0p.asyncFactory)(actionCreator$3);
const fetchVkIntegrationList = actionCreatorAsync$3("fetchVkIntegrationList", async (payload)=>{
    const { blogUrl, limit, offset: offset2 } = payload;
    const response = await Api$1.channel.fetchVkCommunitiesList(blogUrl, limit, offset2);
    return {
        data: response.data.data.vkGroups
    };
});
const COMMUNITIES_LIMIT = 100;
const linkVkIntegration = actionCreatorAsync$3("linkVkIntegration", async (payload)=>{
    const { blogUrl, groupId } = payload;
    await Api$1.channel.linkVkCommunity(blogUrl, groupId);
    const response = await Api$1.channel.fetchVkCommunitiesList(blogUrl, COMMUNITIES_LIMIT);
    return {
        data: response.data.data.vkGroups
    };
});
const unlinkVkIntegration = actionCreatorAsync$3("unlinkVkIntegration", async (payload)=>{
    const { blogUrl } = payload;
    await Api$1.channel.unlinkVkCommunity(blogUrl);
    return {};
});
const clearIntegrationByType = actionCreator$3("clearIntegrationByType");
const fetchBoostyIntegrationList = actionCreatorAsync$3("fetchBoostyIntegrationList", async (payload)=>{
    const { blogUrl } = payload;
    const response = await Api$1.channel.fetchBoostyLink(blogUrl);
    return {
        data: response.data.data.user
    };
});
const actionCreator$2 = (0, $99y5v.actionCreatorFactory)("DonationService");
const actionCreatorAsync$2 = (0, $7Uc0p.asyncFactory)(actionCreator$2);
const fetchDonationServiceList = actionCreatorAsync$2("fetchDonationServiceList", async ({ blogUrl })=>{
    const response = await Api$1.donationService.fetchDonationServiceList(blogUrl);
    return response.data.data;
});
const updateDonationService = actionCreatorAsync$2("updateDonationService", async ({ blogUrl, serviceId, param, value: value2 })=>{
    await Api$1.donationService.updateDonationService(blogUrl, serviceId, param, value2);
    return {};
});
const deleteDonationService = actionCreatorAsync$2("deleteDonationService", async ({ blogUrl })=>{
    await Api$1.donationService.deleteDonationService(blogUrl);
    return {};
});
const clearDonationServiceList = actionCreator$2("clearDonationServiceList");
const actionCreator$1 = (0, $99y5v.actionCreatorFactory)("ChannelPoll");
const actionCreatorAsync$1 = (0, $7Uc0p.asyncFactory)(actionCreator$1);
actionCreatorAsync$1("createChannelPoll", async ({ blogUrl, params })=>{
    await Api$1.channelPoll.createChannelPoll(blogUrl, params);
});
const getChannelPoll = actionCreatorAsync$1("getChannelPoll", async ({ blogUrl })=>{
    const { data } = await Api$1.channelPoll.getChannelPoll(blogUrl);
    return data.data.poll;
});
const clearChannelPoll = actionCreator$1("clearChannelPoll");
const voteChannelPoll = actionCreatorAsync$1("voteChannelPoll", async ({ blogUrl, decisionId })=>await Api$1.channelPoll.voteChannelPoll(blogUrl, {
        decisionId: decisionId
    }));
const setVoteChannelPoll = actionCreator$1("setVoteChannelPoll");
const deleteChannelPoll = actionCreatorAsync$1("deleteChannelPoll", async ({ blogUrl })=>await Api$1.channelPoll.deleteChannelPoll(blogUrl));
const setChannelPoll = actionCreator$1("setChannelPoll");
const doneChannelPoll = actionCreatorAsync$1("doneChannelPoll", async ({ blogUrl })=>await Api$1.channelPoll.doneChannelPoll(blogUrl));
const unsetVoteChannelPoll = actionCreator$1("unsetVoteChannelPoll");
const mergeChannelPoll = actionCreator$1("mergeChannelPoll");
const getChannelPollManage = actionCreatorAsync$1("getChannelPollManage", async ({ blogUrl })=>{
    const { data } = await Api$1.channelPoll.getChannelPollManage(blogUrl);
    return data.data.poll;
});
const actionCreator = (0, $99y5v.actionCreatorFactory)("streamSlotsActions");
const actionCreatorAsync = (0, $7Uc0p.asyncFactory)(actionCreator);
const { stream: { slot: { maxCount } } } = getConfig();
const fetchStreamSlots = actionCreatorAsync("fetchStreamSlots", async ({ blogUrl })=>{
    const limit = maxCount + 1;
    const response = await Api$1.streamSlot.fetchStreamSlots(blogUrl, {
        limit: limit,
        offset: 0
    });
    return {
        streamSlots: response.data.data.streamSlots,
        extra: response.data.extra
    };
});
const createStreamSlot = actionCreatorAsync("createStreamSlot", async ({ blogUrl, params }, dispatch)=>{
    await Api$1.streamSlot.createStreamSlot(blogUrl, params);
    dispatch(fetchStreamSlots.action({
        blogUrl: blogUrl
    }));
});
const deleteStreamSlot = actionCreatorAsync("deleteStreamSlot", async ({ blogUrl, slotId }, dispatch)=>{
    await Api$1.streamSlot.deleteStreamSlot(blogUrl, slotId);
    dispatch(fetchStreamSlots.action({
        blogUrl: blogUrl
    }));
});
const editStreamSlot = actionCreatorAsync("editStreamSlot", async ({ blogUrl, slotId, params }, dispatch)=>{
    await Api$1.streamSlot.editStreamSlot(blogUrl, slotId, params);
    dispatch(fetchStreamSlots.action({
        blogUrl: blogUrl
    }));
});
const fetchChannelPageStreamSlots = actionCreatorAsync("fetchChannelPageStreamSlots", async ({ blogUrl })=>{
    const response = await Api$1.stream.fetchStreamSlots(blogUrl);
    return {
        data: response.data.data.streams.map((element)=>({
                ...element,
                blogUrl: blogUrl
            }))
    };
});
const clearChannelPageStreamSlots = actionCreator("clearChannelPageStreamSlots");
const updateChannelPageStreamSlotOnlineStatus = actionCreator("updateChannelPageStreamSlotOnlineStatus");
const updateChannelPageStreamSlot = actionCreator("updateChannelPageStreamSlot");
actionCreatorAsync("uploadSlotCover", async ({ cover })=>{
    const response = await Api$1.mediaData.uploadImage(cover, EMediaDataImageContainerType.SLOT);
    return {
        id: response.data.id
    };
});
const getGlobalDataInitialState = ()=>({
        blogUrl: null
    });
const globalData = (0, $ki1Eq.reducerWithInitialState)(getGlobalDataInitialState());
globalData.case(clearGlobalData, (state)=>getGlobalDataInitialState());
globalData.case(setGlobalBlogUrl, (state, { blogUrl, slotUrl })=>({
        ...state,
        blogUrl: blogUrl,
        slotUrl: slotUrl
    }));
globalData.case(clearGlobalBlogUrl, (state)=>({
        ...state,
        blogUrl: null
    }));
const getActivityFeedInitialState = ()=>({
        history: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        newEvents: {
            data: null,
            filters: null
        }
    });
const activityFeed = (0, $ki1Eq.reducerWithInitialState)(getActivityFeedInitialState()).case(addActivityFeedNewEvent, (state, { event: event2 })=>{
    var _a3, _b2;
    if (event2.type === EActionsJournalEventType.REWARD) {
        const comparator = (storedEvent)=>storedEvent.type === EActionsJournalEventType.REWARD && storedEvent.reward_demand.demandId === event2.reward_demand.demandId;
        const searchResult = ((_a3 = state.newEvents.data) == null ? void 0 : _a3.find(comparator)) || ((_b2 = state.history.data) == null ? void 0 : _b2.find(comparator));
        if (searchResult) {
            searchResult.reward_demand = event2.reward_demand;
            searchResult.actionTime = event2.actionTime;
            return {
                ...state
            };
        }
    }
    return {
        ...state,
        newEvents: {
            ...state.newEvents,
            data: [
                {
                    ...event2,
                    uniqueId: uniqueId()
                },
                ...state.newEvents.data || []
            ]
        }
    };
}).case(clearActivityFeedNewEvents, (state)=>({
        ...state,
        newEvents: {
            ...state.newEvents,
            data: []
        }
    })).case(setActivityNewEventsFilter, (state, { types: types2 })=>({
        ...state,
        newEvents: {
            ...state.newEvents,
            filters: types2
        }
    })).case(clearActivityJournal, (state)=>({
        ...state,
        history: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
applyAsyncReducer()("history", "networkStatus", fetchActivityJournal.async, activityFeed, ({ result: result2 })=>result2.events.map((event2)=>{
        event2.uniqueId = uniqueId();
        return event2;
    }));
const agentsReducerAssignAgent = (agents2)=>{
    applyAsyncReducer()("agents", "networkStatus", assignAgent.async, agents2, ({ store: store2, result: result2 })=>({
            ...store2.agents.data,
            ...result2.data
        }));
};
const agentsReducerFetchAgents = (agents2)=>{
    applyAsyncReducer()("agents", "networkStatus", fetchAgents.async, agents2, (props)=>props.result.data);
};
const agentsReducerUnassignAgents = (agents2)=>{
    applyAsyncReducer()("agents", "networkStatus", unassignAgent.async, agents2, ({ store: store2, result: result2, params })=>store2.agents.data.filter((agent)=>agent.id !== params.userId));
};
const getAgentsInitialState = ()=>({
        agents: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const agents = (0, $ki1Eq.reducerWithInitialState)(getAgentsInitialState());
agentsReducerFetchAgents(agents);
agentsReducerAssignAgent(agents);
agentsReducerUnassignAgents(agents);
const getAnalyticsInitialState = ()=>({
        blogUrl: null,
        channelAnalytics: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamAnalytics: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streams: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const analyticsReducerAnalyticsStreams = (analytics2)=>{
    analytics2.withHandling(immerCase(fetchAnalyticsStreams.async.started, (newState, payload)=>{
        newState.streams.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchAnalyticsStreams.async.done, (newState, payload)=>{
        newState.blogUrl = payload.params.blogUrl;
        newState.streams.data = {
            streams: payload.params.isLoadingMore ? newState.streams.data.streams.concat(payload.result.streams) : payload.result.streams,
            extra: payload.result.extra
        };
        newState.streams.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchAnalyticsStreams.async.failed, (newState, { error: error2 })=>{
        newState.streams.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const analyticsReducerChannelAnalytics = (analytics2)=>{
    analytics2.withHandling(immerCase(fetchChannelAnalytics.async.started, (newState, payload)=>{
        newState.channelAnalytics.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchChannelAnalytics.async.done, (newState, payload)=>{
        newState.blogUrl = payload.params.blogUrl;
        newState.channelAnalytics.data = payload.result;
        newState.channelAnalytics.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchChannelAnalytics.async.failed, (newState, { error: error2 })=>{
        newState.channelAnalytics.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const analyticsReducerClear = (analytics2)=>{
    analytics2.case(clearAnalytics, ()=>getAnalyticsInitialState());
};
const analyticsReducerStreamAnalytics = (analytics2)=>{
    analytics2.withHandling(immerCase(fetchStreamAnalytics.async.started, (newState, payload)=>{
        newState.streamAnalytics.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchStreamAnalytics.async.done, (newState, payload)=>{
        newState.blogUrl = payload.params.blogUrl;
        newState.streamAnalytics.data = payload.result;
        newState.streamAnalytics.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchStreamAnalytics.async.failed, (newState, { error: error2 })=>{
        newState.streamAnalytics.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const analytics = (0, $ki1Eq.reducerWithInitialState)(getAnalyticsInitialState());
analyticsReducerAnalyticsStreams(analytics);
analyticsReducerChannelAnalytics(analytics);
analyticsReducerClear(analytics);
analyticsReducerStreamAnalytics(analytics);
const badgeReducerFetchBadges = (store2)=>{
    applyAsyncReducer()("badges", "networkStatus", fetchBadgesList.async, store2, ({ result: result2 })=>result2.badges);
};
const badgesReducerClearBadges = (smiles2, initialState2)=>{
    smiles2.case(clearBadges, (state)=>({
            ...initialState2
        }));
};
const badgesReducerCreateBadge = (badges2)=>{
    badges2.case(createBadge.async.done, (state, { result: result2 })=>{
        return {
            ...state,
            badges: {
                ...state.badges,
                data: state.badges.data.map((badge2)=>badge2.achievement.name === result2.achievement.name ? result2 : badge2)
            }
        };
    });
};
const DEFAULT_BADGE_ID = "00000000-0000-0000-0000-000000000000";
const emptyBadge = {
    id: DEFAULT_BADGE_ID,
    name: "",
    largeUrl: "",
    mediumUrl: "",
    smallUrl: "",
    isCreated: false
};
const badgesReducerRemoveBadge = (badges2)=>{
    badges2.case(removeBadge.async.done, (state, { params })=>{
        return {
            ...state,
            badges: {
                ...state.badges,
                data: state.badges.data.map((badge2)=>badge2.id !== params.badgeId ? badge2 : {
                        ...badge2,
                        ...emptyBadge
                    })
            }
        };
    });
};
const badgesReducerUpdateBadge = (badges2)=>{
    badges2.case(updateBadge.async.done, (state, { result: result2, params })=>{
        return {
            ...state,
            badges: {
                ...state.badges,
                data: state.badges.data.map((badge2)=>{
                    return badge2.id === result2.id ? result2 : badge2;
                })
            }
        };
    });
};
const getBadgesInitialState = ()=>({
        badges: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const badges$1 = (0, $ki1Eq.reducerWithInitialState)(getBadgesInitialState());
badgeReducerFetchBadges(badges$1);
badgesReducerUpdateBadge(badges$1);
badgesReducerCreateBadge(badges$1);
badgesReducerRemoveBadge(badges$1);
badgesReducerClearBadges(badges$1, getBadgesInitialState());
const blackListReducerAddToBlackListFromWS = (blackList2)=>{
    blackList2.withHandling(immerCase(addToBlackListFromWS, (newState, user)=>{
        newState.blackList.data = [
            ...newState.blackList.data || [],
            user
        ];
    }));
};
const blackListReducerFetchBlackList = (blackList2)=>{
    applyAsyncReducer()("blackList", "networkStatus", fetchBlackList.async, blackList2, ({ result: result2 })=>result2);
};
const blackListReducerRemoveFromBlackList = (blackList2)=>{
    blackList2.case(removeFromBlackList.async.done, (store2, payload)=>{
        const { params: { userId } } = payload;
        return {
            ...store2,
            blackList: {
                ...store2.blackList,
                data: store2.blackList.data.filter((blocked)=>blocked.id !== userId)
            }
        };
    });
};
const blackListReducerRemoveFromBlackListFromWS = (blackList2)=>{
    blackList2.withHandling(immerCase(removeFromBlackListFromWS, (newState, user)=>{
        var _a3;
        newState.blackList.data = (_a3 = newState.blackList.data) == null ? void 0 : _a3.filter((item2)=>item2.id !== user.id);
    }));
};
const blackListReducerResetBlackList = (blackList2)=>{
    blackList2.case(resetBlackList, (store2)=>{
        return {
            ...store2,
            blacklist: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        };
    });
};
const getBlackListInitialState = ()=>({
        blackList: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const blackList = (0, $ki1Eq.reducerWithInitialState)(getBlackListInitialState());
blackListReducerFetchBlackList(blackList);
blackListReducerResetBlackList(blackList);
blackListReducerRemoveFromBlackList(blackList);
blackListReducerAddToBlackListFromWS(blackList);
blackListReducerRemoveFromBlackListFromWS(blackList);
const blogOwnerUpdates = (reducer)=>{
    return reducer.case(editSettings.async.done, (state, { result: result2 })=>{
        const { id, email, name: name2, avatarUrl } = result2;
        if (state.blog.data != null && id === state.blog.data.owner.id) {
            const newAvatarUrl = avatarUrl != null ? avatarUrl : state.blog.data.owner.avatarUrl;
            return {
                ...state,
                blog: {
                    ...state.blog,
                    data: {
                        ...state.blog.data,
                        owner: {
                            ...state.blog.data.owner,
                            name: name2,
                            email: email,
                            avatarUrl: newAvatarUrl,
                            hasAvatar: newAvatarUrl != null && String(newAvatarUrl).length > 0
                        }
                    }
                },
                posts: {
                    ...state.posts,
                    data: {
                        ...state.posts.data,
                        posts: state.posts.data.posts.map((post)=>({
                                ...post,
                                comments: {
                                    ...post.comments,
                                    data: post.comments.data.map((comment)=>({
                                            ...comment,
                                            author: {
                                                ...comment.author,
                                                avatarUrl: comment.author.id === id && avatarUrl != null ? avatarUrl : comment.author.avatarUrl
                                            }
                                        }))
                                }
                            }))
                    }
                }
            };
        } else return state;
    });
};
const blogReducerBlacklistStatus = (blog2)=>{
    blog2.case(changeBlacklistedStatus, (state, { userId, isBlackListed })=>{
        var _a3, _b2;
        if (((_b2 = (_a3 = state.blog.data) == null ? void 0 : _a3.owner) == null ? void 0 : _b2.id) !== userId) return state;
        return {
            ...state,
            blog: {
                ...state.blog,
                data: {
                    ...state.blog.data,
                    isBlackListed: isBlackListed
                }
            }
        };
    });
};
const blogReducerChangeSubscribersCount = (blog2)=>{
    blog2.case(changeSubscribersCount, (state, { count: count2 })=>({
            ...state,
            blog: {
                ...state.blog,
                data: {
                    ...state.blog.data,
                    count: {
                        ...state.blog.data.count,
                        subscribers: count2
                    }
                }
            }
        }));
};
const blogReducerChannelCoverImageUpload = (blog2)=>{
    blog2.withHandling(immerCase(uploadCoverImage.async.done, (newState, payload)=>{
        newState.blog.data.channelCoverImageUrl = payload.result.image.url;
    }));
};
const blogReducerChannelCoverTypeChange = (blog2)=>{
    blog2.withHandling(immerCase(changeCoverType.async.done, (newState, payload)=>{
        newState.blog.data.channelCoverType = payload.result.coverType;
    }));
};
const blogReducerChannelNotificationSettingsUpdate = (blog2)=>{
    blog2.withHandling(immerCase(updateNotificationSettingsFromWS, (newState, params)=>{
        var _a3;
        if (params.blogUrl === ((_a3 = newState.blogExternal.data) == null ? void 0 : _a3.blogUrl)) newState.blogExternal.data.notifySubscription = params.notifySubscription;
        if (params.blogUrl === newState.blog.data.blogUrl) newState.blog.data.notifySubscription = params.notifySubscription;
    }));
};
const blogReducerClearComments = (reducer)=>{
    return reducer.withHandling(immerCase(clearComments, (newState, { postId })=>{
        var _a3, _b2, _c2, _d, _e;
        if (postId) {
            const targetPostIndex = newState.posts.data.posts.findIndex((post)=>post.id === postId);
            if (targetPostIndex === -1) return;
            const postToUpdate = newState.posts.data.posts[targetPostIndex];
            if ((_a3 = newState.posts.meta.publishingCommentsList.post) == null ? void 0 : _a3[postId]) {
                postToUpdate.comments.data.forEach((comment)=>{
                    if (newState.posts.meta.publishingCommentsList.thread[comment.intId]) newState.posts.meta.publishingCommentsList.thread[comment.intId] = void 0;
                });
                newState.posts.meta.publishingCommentsList.post[postId].forEach((comment)=>{
                    if (isPublishedComment(comment) && newState.posts.meta.publishingCommentsList.thread[comment.publishedComment.intId]) newState.posts.meta.publishingCommentsList.thread[comment.publishedComment.intId] = void 0;
                });
            }
            newState.posts.meta.commentsNetworkStatus.post[postId] = getDefaultNetworkStatus$1();
            postToUpdate.comments.data.forEach((comment)=>{
                if (newState.posts.meta.commentsNetworkStatus.thread[comment.intId]) newState.posts.meta.commentsNetworkStatus.thread[comment.intId] = getDefaultNetworkStatus$1();
            });
            (_d = (_c2 = (_b2 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _b2.post) == null ? void 0 : _c2[postId]) == null || _d.forEach((comment)=>{
                if (isPublishedComment(comment) && newState.posts.meta.commentsNetworkStatus.thread[comment.publishedComment.intId]) newState.posts.meta.commentsNetworkStatus.thread[comment.publishedComment.intId] = getDefaultNetworkStatus$1();
            });
            if ((_e = newState.posts.meta.publishingCommentsList.post) == null ? void 0 : _e[postId]) newState.posts.meta.publishingCommentsList.post[postId] = void 0;
            postToUpdate.comments = {
                data: [],
                extra: {
                    isFirst: true,
                    isLast: true
                }
            };
        } else newState.posts.meta.publishingCommentsList = {
            post: {},
            thread: {}
        };
    }));
};
const blogReducerClearExternal = (blog2)=>{
    blog2.case(clearBlogExternal, (state)=>({
            ...state,
            blogExternal: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const blogReducerClearUsersSearchList = (blog2)=>{
    blog2.case(clearUsersSearchList, (state)=>({
            ...state,
            usersSearch: {
                data: {
                    users: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const blogReducerCommentEdit = (blog2)=>{
    blog2.withHandling(immerCase(editComment.async.started, (newState, { originalComment })=>{
        newState.posts.meta.editCommentNetworkStatus[originalComment.intId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editComment.async.done, (newState, { result: result2, params: { postId, originalComment } })=>{
        const posts = newState.posts.data.posts;
        newState.posts.meta.editCommentNetworkStatus[originalComment.intId] = getNetworkStatusDone$1();
        const postToUpdate = posts.find((post)=>post.id === postId);
        if (!postToUpdate) return;
        const commentToUpdate = findCommentBy(postToUpdate, newState.posts.meta.publishingCommentsList, ({ intId })=>intId === originalComment.intId);
        if (!commentToUpdate) return;
        commentToUpdate.data = result2.data;
        commentToUpdate.updatedAt = result2.createdAt;
        commentToUpdate.isUpdated = true;
    })).withHandling(immerCase(editComment.async.failed, (newState, { params: { originalComment }, error: error2 })=>{
        newState.posts.meta.editCommentNetworkStatus[originalComment.intId] = getNetworkStatusFailed$1(error2);
    }));
};
const removeCommentFromPublishingList = (publishingMap, rootId, indexToDeleteFromList)=>{
    publishingMap[rootId].splice(indexToDeleteFromList, 1);
};
const findIndexOfPublishingCommentBy = (publishingMap, rootId, predicateIsTruthy)=>{
    const found = publishingMap[rootId].findIndex((item2)=>predicateIsTruthy(item2));
    if (found === -1) Log$5.error(`No comment found in publishingList of ${rootId}, all comments: ${prettyJson(publishingMap[rootId])}`);
    return found;
};
const getThreadRoot = (replyComment)=>{
    const isReplyToThreadComment = Boolean(replyComment == null ? void 0 : replyComment.parentId);
    return isReplyToThreadComment ? replyComment == null ? void 0 : replyComment.parentId : replyComment == null ? void 0 : replyComment.intId;
};
const updateCommentsCount = (postToUpdate)=>{
    postToUpdate.count.comments = postToUpdate.count.comments + 1;
};
const setErrorStatusToPublishingComment = (publishingMap, rootId, publishedComment)=>{
    const commentToUpdateIndex = findIndexOfPublishingCommentBy(publishingMap, rootId, ({ publishTimestamp })=>publishTimestamp === publishedComment.publishTimestamp);
    const commentToUpdate = publishingMap[rootId][commentToUpdateIndex];
    commentToUpdate.status = EPublishCommentStatus.ERROR;
};
const setSuccessStatusToPublishingComment = (publishingMap, rootId, publishingComment, publishedResult)=>{
    const commentToUpdateIndex = findIndexOfPublishingCommentBy(publishingMap, rootId, ({ publishTimestamp })=>publishTimestamp === publishingComment.publishTimestamp);
    const commentToUpdate = publishingMap[rootId][commentToUpdateIndex];
    commentToUpdate.status = EPublishCommentStatus.SUCCESS;
    commentToUpdate.publishedComment = publishedResult;
};
const blogReducerCommentSend = (blog2)=>{
    blog2.withHandling(immerCase(sendComment.async.started, (newState, { postId, commentData, replyComment, publishTimestamp })=>{
        const isRootComment = !replyComment;
        const publishingMap = isRootComment ? newState.posts.meta.publishingCommentsList.post : newState.posts.meta.publishingCommentsList.thread;
        const rootId = isRootComment ? postId : getThreadRoot(replyComment);
        if (!publishingMap[rootId]) publishingMap[rootId] = [];
        publishingMap[rootId].push({
            commentData: commentData,
            replyComment: replyComment,
            status: EPublishCommentStatus.LOADING,
            publishTimestamp: publishTimestamp
        });
    })).withHandling(immerCase(sendComment.async.done, (newState, { result: result2, params: publishingCommentParams })=>{
        const postId = result2.post.id;
        const posts = newState.posts.data.posts;
        const targetPostIndex = posts.findIndex((post)=>post.id === postId);
        const postToUpdate = newState.posts.data.posts[targetPostIndex];
        updateCommentsCount(postToUpdate);
        const isRootComment = !publishingCommentParams.replyComment;
        const publishingMap = isRootComment ? newState.posts.meta.publishingCommentsList.post : newState.posts.meta.publishingCommentsList.thread;
        const rootId = isRootComment ? postId : getThreadRoot(publishingCommentParams.replyComment);
        setSuccessStatusToPublishingComment(publishingMap, rootId, publishingCommentParams, result2);
    })).withHandling(immerCase(sendComment.async.failed, (newState, { params: publishedComment })=>{
        const isRootComment = !publishedComment.replyComment;
        const publishingMap = isRootComment ? newState.posts.meta.publishingCommentsList.post : newState.posts.meta.publishingCommentsList.thread;
        const rootId = isRootComment ? publishedComment.postId : getThreadRoot(publishedComment.replyComment);
        setErrorStatusToPublishingComment(publishingMap, rootId, publishedComment);
    })).withHandling(immerCase(cancelNotPublishedComment, (newState, { postId, parentId, publishTimestamp })=>{
        const isRootComment = !parentId;
        const publishingMap = isRootComment ? newState.posts.meta.publishingCommentsList.post : newState.posts.meta.publishingCommentsList.thread;
        const rootId = isRootComment ? postId : parentId;
        const indexOfCommentToRemove = findIndexOfPublishingCommentBy(publishingMap, rootId, (item2)=>item2.publishTimestamp === publishTimestamp);
        removeCommentFromPublishingList(publishingMap, rootId, indexOfCommentToRemove);
    }));
};
const getPublishingCommentsListWithoutFetchedComments = (list2, fetchedComments)=>{
    const newPublishingList = [];
    const removedElements = [];
    list2.forEach((publishingComment)=>{
        if (isPublishedComment(publishingComment)) {
            const fetchedCommentsContainsPublished = Boolean(fetchedComments.find((fetchedComment)=>fetchedComment.intId === publishingComment.publishedComment.intId));
            if (fetchedCommentsContainsPublished) {
                removedElements.push(publishingComment);
                return;
            }
        }
        newPublishingList.push(publishingComment);
    });
    return {
        newPublishingList: newPublishingList,
        removedElements: removedElements
    };
};
const blogReducerCommentsFetch = (blog2)=>{
    blog2.withHandling(immerCase(fetchComments.async.started, (newState, { postId, threadComments })=>{
        if (threadComments) newState.posts.meta.commentsNetworkStatus.thread[threadComments.parentId] = getNetworkStatusStarted$1();
        else newState.posts.meta.commentsNetworkStatus.post[postId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchComments.async.done, (newState, { result: { data, postId, extra }, params })=>{
        var _a3, _b2, _c2, _d, _e;
        const posts = newState.posts.data.posts;
        const targetIndexPost = posts.findIndex((post)=>post.id === postId);
        const targetPost = posts[targetIndexPost];
        if (params.threadComments) {
            newState.posts.meta.commentsNetworkStatus.thread[params.threadComments.parentId] = getNetworkStatusDone$1();
            const targetComment = newState.posts.data.posts[targetIndexPost].comments.data.find(({ intId })=>intId === params.threadComments.parentId);
            if (targetComment) {
                const isLater = params.threadComments.nextCommentsDirection === "later";
                const newData = isLater ? concatWithDuplicatesPrevented(targetComment.replies.data, data, "intId") : concatWithDuplicatesPrevented(data, targetComment.replies.data, "intId");
                targetComment.replies.data = newData;
                if (isLater) {
                    targetComment.replies.extra.isFirst = extra.isFirst;
                    if ((_b2 = (_a3 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _a3.thread) == null ? void 0 : _b2[params.threadComments.parentId]) newState.posts.meta.publishingCommentsList.thread[params.threadComments.parentId] = getPublishingCommentsListWithoutFetchedComments(newState.posts.meta.publishingCommentsList.thread[params.threadComments.parentId], data).newPublishingList;
                } else targetComment.replies.extra.isLast = extra.isLast;
            }
        } else {
            newState.posts.meta.commentsNetworkStatus.post[postId] = getNetworkStatusDone$1();
            if (params.replace) {
                const threadRootsToReset = newState.posts.data.posts[targetIndexPost].comments.data;
                threadRootsToReset.forEach(({ intId })=>{
                    if (newState.posts.meta.publishingCommentsList.thread[intId]) newState.posts.meta.publishingCommentsList.thread[intId] = newState.posts.meta.publishingCommentsList.thread[intId].filter(({ status })=>status === EPublishCommentStatus.LOADING);
                });
                newState.posts.meta.publishingCommentsList.post[postId] = (_c2 = newState.posts.meta.publishingCommentsList.post[postId]) == null ? void 0 : _c2.filter(({ status })=>status === EPublishCommentStatus.LOADING);
                newState.posts.data.posts[targetIndexPost].comments.data = data;
                newState.posts.data.posts[targetIndexPost].comments.extra.isFirst = extra.isFirst;
                newState.posts.data.posts[targetIndexPost].comments.extra.isLast = extra.isLast;
            } else {
                const isLater = params.rootComments.nextCommentsDirection === "later";
                const newData = isLater ? concatWithDuplicatesPrevented(targetPost.comments.data, data, "intId") : concatWithDuplicatesPrevented(data, targetPost.comments.data, "intId");
                newState.posts.data.posts[targetIndexPost].comments.data = newData;
                if (isLater) {
                    newState.posts.data.posts[targetIndexPost].comments.extra.isFirst = extra.isFirst;
                    if ((_e = (_d = newState.posts.meta.publishingCommentsList) == null ? void 0 : _d.post) == null ? void 0 : _e[postId]) {
                        const { newPublishingList, removedElements } = getPublishingCommentsListWithoutFetchedComments(newState.posts.meta.publishingCommentsList.post[postId], data);
                        newState.posts.meta.publishingCommentsList.post[postId] = newPublishingList;
                        removedElements.forEach((removedRootComment)=>{
                            newState.posts.meta.publishingCommentsList.thread[removedRootComment.publishedComment.intId] = void 0;
                        });
                    }
                } else newState.posts.data.posts[targetIndexPost].comments.extra.isLast = extra.isLast;
            }
        }
    })).withHandling(immerCase(fetchComments.async.failed, (newState, { params: { postId }, error: error2, params })=>{
        if (params.threadComments) newState.posts.meta.commentsNetworkStatus.thread[params.threadComments.parentId] = getNetworkStatusFailed$1(error2);
        else newState.posts.meta.commentsNetworkStatus.post[postId] = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerCommentViewMeta = (blog2)=>{
    blog2.withHandling(immerCase(setCommentViewMeta, (newState, { type, postIds })=>{
        newState.posts.meta.commentsViewMeta = {
            lastCommentPageTypeVisited: type,
            postIdsToRefetch: postIds
        };
    }));
};
const blogReducerCommitVote = (blog2)=>{
    blog2.withHandling(immerCase(commitVote.async.started, (newState, { pollId })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(commitVote.async.done, (newState, { result: result2, params: { pollId } })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusDone$1();
    })).withHandling(immerCase(commitVote.async.failed, (newState, { params: { pollId }, error: error2 })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerCoverEdit = (blog2)=>{
    applyAsyncReducer()("blog", "editCoverNetworkStatus", editBlogCover.async, blog2, ({ result: result2 })=>({
            coverUrl: result2.url
        }));
};
const blogReducerCreate = (blog2)=>{
    applyAsyncReducer()("blog", "createNetworkStatus", createBlog.async, blog2);
};
const blogReducerDeferredAccessLevelsFetch = (blog2)=>{
    applyAsyncReducer()("posts", "deferredAccessNetworkStatus", fetchDeferredAccessLevels.async, blog2, ({ store: store2, result: result2, params })=>({
            posts: store2.posts.data.posts.map((post)=>{
                if (post.id === params.postId) return {
                    ...post,
                    deferredAccessLevels: [
                        ...result2.data
                    ]
                };
                return post;
            })
        }));
};
const blogReducerEdit = (blog2)=>{
    applyAsyncReducer()("blog", "editNetworkStatus", editBlog.async, blog2, ({ params, result: result2 })=>({
            title: result2.blog.title,
            description: result2.blog.description,
            hasAdultContent: result2.blog.hasAdultContent
        }));
};
const blogReducerFetch = (blog2)=>{
    applyAsyncReducer()("blog", "networkStatus", fetchBlog.async, blog2, ({ store: store2, result: result2 })=>({
            ...result2.blog
        }));
};
const blogReducerFetchExternal = (blog2)=>{
    applyAsyncReducer()("blogExternal", "networkStatus", fetchBlogExternal.async, blog2, ({ store: store2, result: result2 })=>({
            ...result2.blog
        }));
};
const blogReducerFetchItem = (blog2)=>{
    applyAsyncReducer()("blogItem", "networkStatus", fetchBlogItem.async, blog2, ({ store: store2, result: result2 })=>({
            ...result2.blog
        }));
};
const blogReducerFetchPoll = (blog2)=>{
    blog2.withHandling(immerCase(fetchPoll.async.started, (newState, { pollId })=>{
        newState.posts.meta.pollsNetworkStatus.polls[pollId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPoll.async.done, (newState, { result: { data: { poll } }, params: { pollId } })=>{
        const targetPost = newState.posts.data.posts.find((post)=>{
            var _a3;
            return ((_a3 = post == null ? void 0 : post.poll) == null ? void 0 : _a3.id) === pollId;
        });
        targetPost.poll = poll;
        newState.posts.meta.pollsNetworkStatus.polls[pollId] = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPoll.async.failed, (newState, { params: { pollId }, error: error2 })=>{
        newState.posts.meta.pollsNetworkStatus.polls[pollId] = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerFetchRssLink = (blog2)=>{
    applyAsyncReducer()("rss", "networkStatus", fetchRssLink.async, blog2, (props)=>props.result);
};
const blogReducerFetchVoters = (blog2)=>{
    blog2.withHandling(immerCase(fetchPollVoters.async.started, (newState, { pollId, option: option2 })=>{
        if (!newState.posts.meta.pollsNetworkStatus.voters[pollId]) newState.posts.meta.pollsNetworkStatus.voters[pollId] = {};
        newState.posts.meta.pollsNetworkStatus.voters[pollId][option2] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPollVoters.async.done, (newState, { result: { data: { voters }, extra }, params: { pollId, option: option2 } })=>{
        const targetPost = newState.posts.data.posts.find((post)=>{
            var _a3;
            return ((_a3 = post == null ? void 0 : post.poll) == null ? void 0 : _a3.id) === pollId;
        });
        const targetOption = targetPost.poll.options.find((pollOption)=>pollOption.id === option2);
        targetOption.voters = {
            data: {
                voters: [
                    ...targetOption.voters.data.voters,
                    ...voters
                ]
            },
            extra: extra
        };
        newState.posts.meta.pollsNetworkStatus.voters[pollId][option2] = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPollVoters.async.failed, (newState, { params: { pollId, option: option2 }, error: error2 })=>{
        newState.posts.meta.pollsNetworkStatus.voters[pollId][option2] = getNetworkStatusFailed$1(error2);
    }));
};
const getUpdatedState = (params)=>{
    const { blogUrl, isSubscribed, networkStatus: networkStatus2, state, subscriptionKind } = params;
    if (state.blog.data && state.blog.data.blogUrl === blogUrl) return {
        ...state,
        blog: {
            ...state.blog,
            data: state.blog.data ? {
                ...state.blog.data,
                isSubscribed: isSubscribed !== null ? isSubscribed : state.blog.data.isSubscribed,
                subscriptionKind: subscriptionKind !== null ? subscriptionKind : state.blog.data.subscriptionKind,
                count: {
                    ...state.blog.data.count,
                    subscribers: isSubscribed !== null ? state.blog.data.count.subscribers + (isSubscribed ? 1 : -1) : state.blog.data.count.subscribers
                }
            } : null,
            meta: state.blog.meta ? {
                ...state.blog.meta,
                followNetworkStatus: networkStatus2 || getDefaultNetworkStatus$1()
            } : null
        }
    };
    else return state;
};
const blogReducerFollow = (blog2)=>{
    blog2.case(followBlog.async.started, (state, { blogUrl })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusStarted$1()
        })).case(unfollowBlog.async.started, (state, { blogUrl })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusStarted$1()
        })).case(unsubscribeBlog.async.started, (state, { blogUrl })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusStarted$1()
        })).case(followBlog.async.done, (state, { params: { blogUrl } })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: true,
            subscriptionKind: ESubscriptionKind.FREE,
            networkStatus: getNetworkStatusDone$1()
        })).case(unfollowBlog.async.done, (state, { params: { blogUrl } })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: false,
            subscriptionKind: ESubscriptionKind.NONE,
            networkStatus: getNetworkStatusDone$1()
        })).case(unsubscribeBlog.async.done, (state, { params: { blogUrl } })=>getUpdatedState({
            state: state,
            blogUrl: blogUrl,
            isSubscribed: false,
            subscriptionKind: ESubscriptionKind.NONE,
            networkStatus: getNetworkStatusDone$1()
        })).case(followBlog.async.failed, (state, { error: error2 })=>getUpdatedState({
            state: state,
            blogUrl: null,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusFailed$1(error2)
        })).case(unfollowBlog.async.failed, (state, { error: error2 })=>getUpdatedState({
            state: state,
            blogUrl: null,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusFailed$1(error2)
        })).case(unsubscribeBlog.async.failed, (state, { error: error2 })=>getUpdatedState({
            state: state,
            blogUrl: null,
            isSubscribed: null,
            subscriptionKind: null,
            networkStatus: getNetworkStatusFailed$1(error2)
        }));
};
const blogReducerIncreasePostDonationsSum = (blog2)=>{
    blog2.withHandling(immerCase(increasePostDonationsSum, (newState, { intId, value: value2 })=>{
        const post = newState.posts.data.posts.find(({ int_id })=>intId === int_id);
        if (post) post.donations += value2;
    }));
};
const blogReducerLastActivePostId = (reducer)=>{
    return reducer.withHandling(immerCase(setLastActivePostId, (newState, { postId })=>{
        newState.lastActivePostId = postId;
    }));
};
const blogReducerMarkPollAsFinished = (blog2)=>{
    blog2.withHandling(immerCase(markPollAsFinished, (newState, { pollId })=>{
        const targetPost = newState.posts.data.posts.find((post)=>{
            var _a3;
            return ((_a3 = post == null ? void 0 : post.poll) == null ? void 0 : _a3.id) === pollId;
        });
        targetPost.poll.isFinished = true;
    }));
};
const blogReducerNewPostCreate = (reducer)=>{
    return reducer.case(updateNewPostId, (state, { postId })=>({
            ...state,
            newPostId: postId
        }));
};
const blogReducerPostDonations = (blog2)=>{
    blog2.withHandling(immerCase(fetchPostDonations.async.started, (newState, { postId })=>{
        newState.postDonationsNetworkStatuses[postId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPostDonations.async.done, (newState, { result: result2, params })=>{
        var _a3;
        newState.postDonationsNetworkStatuses[params.postId] = getNetworkStatusDone$1();
        const postToUpdate = (_a3 = newState.posts.data) == null ? void 0 : _a3.posts.find(// eslint-disable-next-line camelcase
        ({ int_id })=>int_id === params.postId);
        postToUpdate.donators.data = [
            ...postToUpdate.donators.data,
            ...result2.data.donations
        ];
        postToUpdate.donators.extra = {
            isLast: postToUpdate.donators.data.length <= result2.extra.total,
            offset: result2.extra.offset
        };
    })).withHandling(immerCase(fetchPostDonations.async.failed, (newState, { params, error: error2 })=>{
        newState.postDonationsNetworkStatuses[params.postId] = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerPostDraftRemove = (blog2)=>{
    applyAsyncReducer()("postDrafts", "networkStatus", removeBlogPostDraft.async, blog2, ({ store: store2, params })=>{
        var _a3;
        return {
            ...store2.postDrafts.data,
            blogPostDrafts: store2.postDrafts.data.blogPostDrafts.filter((postDraft)=>postDraft.key.hash !== params.blogPostDraft.key.hash),
            activeBlogPostDraft: ((_a3 = store2.postDrafts.data.activeBlogPostDraft) == null ? void 0 : _a3.key.hash) === params.blogPostDraft.key.hash ? null : store2.postDrafts.data.activeBlogPostDraft
        };
    });
};
const blogReducerPostDraftSave = (blog2)=>{
    applyAsyncReducer()("postDrafts", "networkStatus", saveBlogPostDraft.async, blog2, ({ store: store2, params })=>{
        const prevBlogPostDraft = store2.postDrafts.data.blogPostDrafts.find((draft)=>draft.key.hash === params.blogPostDraft.key.hash) || {};
        const blogPostDraft = {
            ...prevBlogPostDraft,
            ...params.blogPostDraft
        };
        const blogPostDrafts = store2.postDrafts.data.blogPostDrafts.filter((draft)=>draft !== prevBlogPostDraft);
        return {
            ...store2.postDrafts.data,
            blogPostDrafts: [
                blogPostDraft,
                ...blogPostDrafts
            ],
            activeBlogPostDraft: blogPostDraft
        };
    });
};
const blogReducerPostDraftSelect = (blog2)=>{
    applyAsyncReducer()("postDrafts", "networkStatus", selectBlogPostDraft.async, blog2, ({ store: store2, params })=>({
            ...store2.postDrafts.data,
            activeBlogPostDraft: params.blogPostDraft ? store2.postDrafts.data.blogPostDrafts.find((draft)=>draft.key.hash === params.blogPostDraft.key.hash) : null
        }));
};
const blogReducerPostDraftsSet = (blog2)=>{
    applyAsyncReducer()("postDrafts", "networkStatus", setBlogPostDrafts.async, blog2, ({ store: store2, result: result2, params })=>({
            ...store2.postDrafts.data,
            blogPostDrafts: result2.blogPostDrafts.sort((a2, b2)=>b2.updatedAt - a2.updatedAt)
        }));
};
const blogReducerPostReaction = (blog2)=>{
    blog2.withHandling(immerCase(reactionBlogPost.async.started, (newState, payload)=>{
        const { postId, reaction } = payload;
        newState.posts.data.posts = newState.posts.data.posts.map((postItem)=>{
            var _a3;
            if (postItem.id === postId) {
                const reactions = postItem.count.reactions;
                if ((_a3 = postItem == null ? void 0 : postItem.reacted) == null ? void 0 : _a3.actor) reactions[postItem.reacted.actor] = reactions[postItem.reacted.actor] - 1;
                reactions[reaction] = reactions[reaction] + 1;
                postItem.reacted = {
                    actor: reaction
                };
                return postItem;
            } else return postItem;
        });
    }));
    blog2.withHandling(immerCase(reactionBlogPost.async.failed, (newState, payload)=>{
        const { params: { postId, reaction } } = payload;
        newState.posts.data.posts.forEach((postItem)=>{
            if (postItem.id === postId) {
                postItem.count.reactions[reaction] = postItem.count.reactions[reaction] - 1;
                postItem.reacted.actor = null;
            }
        });
    }));
    blog2.case(removeReactionBlogPost.async.started, (store2, payload)=>{
        const { postId } = payload;
        return {
            ...store2,
            posts: {
                ...store2.posts,
                data: {
                    ...store2.posts.data,
                    posts: store2.posts.data.posts.map((postItem)=>postItem.id === postId ? {
                            ...postItem,
                            count: {
                                ...postItem.count,
                                reactions: {
                                    ...postItem.count.reactions,
                                    [postItem.reacted.actor]: postItem.count.reactions[postItem.reacted.actor] - 1
                                }
                            },
                            reacted: {
                                actor: null,
                                author: null
                            }
                        } : postItem)
                }
            }
        };
    });
};
const blogReducerPosts = (blog2)=>{
    applyAsyncReducer()("posts", "networkStatus", fetchFeed.async, blog2, ({ store: store2, result: result2, params })=>({
            isLast: result2.isLast,
            offset: result2.isLast ? store2.posts.data.offset : result2.offset,
            posts: params.offset != null ? [
                ...store2.posts.data.posts,
                ...result2.data
            ] : result2.data,
            blogUrl: params.blogUrl
        }));
    applyAsyncReducer()("posts", "networkStatus", fetchBlogPost.async, blog2, ({ store: store2, result: { blogPost } })=>({
            ...store2.posts.data,
            offset: null,
            posts: [
                blogPost
            ]
        }));
    applyAsyncReducer()("postsSearch", "networkStatus", searchBlogPost.async, blog2, ({ store: store2, result: result2 })=>({
            ...store2.postsSearch.data,
            searchPosts: result2.data,
            offset: result2.offset,
            isLast: result2.isLast
        }));
    applyAsyncReducer()("currentPost", "networkStatus", fetchCurrentBlogPost.async, blog2, ({ store: store2, result: { blogPost } })=>blogPost);
    applyAsyncReducer()("posts", "removePostNetworkStatus", removeBlogPost.async, blog2, ({ store: store2, result: result2, params })=>({
            ...store2.posts.data,
            posts: store2.posts.data.posts.filter((post)=>post.id !== params.postId)
        }));
    applyAsyncReducer()("posts", "updatePostNetworkStatus", updateBlogPost.async, blog2, ({ store: store2, result: result2 })=>({
            ...store2.posts.data,
            posts: fixPostsOrder(store2.posts.data.posts.map((post)=>post.id === result2.blogPost.id ? {
                    ...result2.blogPost,
                    comments: post.comments
                } : post))
        }));
    applyAsyncReducer()("posts", "createPostNetworkStatus", createBlogPost.async, blog2, ({ store: store2, result: result2 })=>({
            ...store2.posts.data,
            posts: fixPostsOrder([
                result2.blogPost,
                ...store2.posts.data.posts
            ])
        }));
    blog2.withHandling(immerCase(clearSearchBlogPost, (newState)=>{
        newState.postsSearch.data = {
            searchPosts: [],
            isLast: null,
            offset: null
        };
    }));
    blog2.withHandling(immerCase(refetchBlogPostData.async.done, (newState, { result: result2, params })=>{
        var _a3, _b2;
        const postToUpdateIndex = (_a3 = newState.posts) == null ? void 0 : _a3.data.posts.findIndex((post)=>{
            if (params.postId) return post.id === params.postId;
            return params.postIntId === post.int_id;
        });
        if (postToUpdateIndex > -1) {
            const currentComments = (_b2 = newState.posts) == null ? void 0 : _b2.data.posts[postToUpdateIndex].comments;
            newState.posts.data.posts[postToUpdateIndex] = {
                ...result2.blogPost,
                comments: currentComments
            };
        }
    }));
};
const blogReducerPostsTags = (blog2)=>{
    applyAsyncReducer()("postsTags", "networkStatus", fetchFeedTags.async, blog2, ({ store: store2, result: result2 })=>({
            tags: result2.data
        }));
};
const findCommentForReaction = (store2, postId, commentId)=>{
    const targetPostIndex = store2.posts.data.posts.findIndex((post)=>post.id === postId);
    if (targetPostIndex === -1) return null;
    const postToUpdate = store2.posts.data.posts[targetPostIndex];
    if (!postToUpdate) return null;
    return findCommentBy(postToUpdate, store2.posts.meta.publishingCommentsList, ({ id })=>id === commentId);
};
const updateCommentReactionInfo = (comment, isOwner, reaction)=>{
    var _a3, _b2;
    if ((_a3 = comment == null ? void 0 : comment.reacted) == null ? void 0 : _a3.actor) comment.reactions[comment.reacted.actor] = comment.reactions[comment.reacted.actor] - 1;
    if (reaction) comment.reactions[reaction] = comment.reactions[reaction] + 1;
    comment.reacted = {
        actor: reaction,
        author: isOwner ? reaction : (_b2 = comment == null ? void 0 : comment.reacted) == null ? void 0 : _b2.author
    };
};
const blogReducerReactionComment = (blog2)=>{
    blog2.withHandling(immerCase(reactionComment.async.started, (newState, payload)=>{
        const { postId, commentId, reaction } = payload;
        const commentToUpdate = findCommentForReaction(newState, postId, commentId);
        if (!commentToUpdate) return;
        updateCommentReactionInfo(commentToUpdate, newState.blog.data.isOwner, reaction);
    }));
    blog2.withHandling(immerCase(reactionComment.async.failed, (newState, payload)=>{
        const { params: { postId, commentId, reaction } } = payload;
        const commentToUpdate = findCommentForReaction(newState, postId, commentId);
        if (!commentToUpdate) return;
        commentToUpdate.reacted = {
            actor: null,
            author: newState.blog.data.isOwner ? null : commentToUpdate.reacted.author
        };
        commentToUpdate.reactions[reaction] = commentToUpdate.reactions[reaction] - 1;
    }));
    blog2.withHandling(immerCase(removeReactionComment.async.started, (newState, payload)=>{
        const { postId, commentId } = payload;
        const commentToUpdate = findCommentForReaction(newState, postId, commentId);
        updateCommentReactionInfo(commentToUpdate, newState.blog.data.isOwner, null);
    }));
};
const blogReducerRemoveCommentFromStore = (blog2)=>{
    blog2.case(removeCommentFromStore, (store2, payload)=>{
        const { postId, commentId } = payload;
        const newPostsData = store2.posts.data.posts.map((post)=>{
            if (post.id === postId) return {
                ...post,
                comments: {
                    ...post.comments,
                    data: post.comments.data.filter((comment)=>{
                        return comment.id !== commentId;
                    })
                }
            };
            else return post;
        });
        return {
            ...store2,
            posts: {
                ...store2.posts,
                data: {
                    ...store2.posts.data,
                    posts: newPostsData
                }
            }
        };
    });
};
const blogReducerRemovedComments = (blog2)=>{
    blog2.withHandling(immerCase(removeComment.async.done, (newState, payload)=>{
        const { params: { commentId, postId } } = payload;
        newState.posts.meta.justRemovedComments[postId] = [
            ...newState.posts.meta.justRemovedComments[postId] || [],
            commentId
        ];
        const post = newState.posts.data.posts.find((item2)=>item2.id === postId);
        if (post) {
            const comment = findCommentBy(post, newState.posts.meta.publishingCommentsList, ({ id })=>id === commentId);
            comment.isDeleted = true;
            post.count.comments = post.count.comments - 1;
        }
        if (!newState.posts.meta.commentsViewMeta.postIdsToRefetch.includes(postId)) newState.posts.meta.commentsViewMeta.postIdsToRefetch.push(postId);
    }));
    blog2.withHandling(immerCase(restoreComment.async.done, (newState, payload)=>{
        const { params: { commentId, postId } } = payload;
        if (newState.posts.meta.justRemovedComments[postId]) {
            newState.posts.meta.justRemovedComments[postId] = newState.posts.meta.justRemovedComments[postId].filter((id)=>id !== commentId);
            if (newState.posts.meta.justRemovedComments[postId].length === 0) newState.posts.meta.commentsViewMeta.postIdsToRefetch = newState.posts.meta.commentsViewMeta.postIdsToRefetch.filter((id)=>id !== postId);
        }
        const post = newState.posts.data.posts.find((item2)=>item2.id === postId);
        if (post) {
            const comment = findCommentBy(post, newState.posts.meta.publishingCommentsList, ({ id })=>id === commentId);
            comment.isDeleted = false;
        }
        post.count.comments = post.count.comments + 1;
    }));
    blog2.withHandling(immerCase(resetRemovedComments, (newState)=>{
        newState.posts.meta.justRemovedComments = {};
    }));
};
const blogReducerRemoveRedundantComments = (blog2)=>{
    blog2.withHandling(immerCase(removeRedundantCommentsForPost, (newState, { postId })=>{
        var _a3, _b2, _c2;
        const { feedLimit, feedRepliesLimit } = getConfig().comments;
        const post = newState.posts.data.posts.find(({ id })=>id === postId);
        if (!post) return;
        if ((_a3 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _a3.post[postId]) newState.posts.meta.publishingCommentsList.post[postId] = newState.posts.meta.publishingCommentsList.post[postId].filter((item2)=>item2.status !== EPublishCommentStatus.ERROR);
        const publishedCommentsCount = ((_c2 = (_b2 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _b2.post[postId]) == null ? void 0 : _c2.length) || 0;
        if (post.comments.data.length + publishedCommentsCount > feedLimit) {
            post.comments.extra.isLast = false;
            if (publishedCommentsCount >= feedLimit) {
                post.comments.data = [];
                newState.posts.meta.publishingCommentsList.post[postId] = newState.posts.meta.publishingCommentsList.post[postId].slice(-feedLimit);
            } else post.comments.data = post.comments.data.slice(-(feedLimit - publishedCommentsCount));
        }
        const removeRedundantReplies = (comment)=>{
            var _a4, _b3, _c3, _d;
            const publishedRepliesCount = ((_b3 = (_a4 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _a4.thread[comment.intId]) == null ? void 0 : _b3.length) || 0;
            const fetchedRepliesLength = ((_d = (_c3 = comment.replies) == null ? void 0 : _c3.data) == null ? void 0 : _d.length) || 0;
            if (fetchedRepliesLength + publishedRepliesCount > feedRepliesLimit) {
                comment.replies.extra.isLast = false;
                if (publishedRepliesCount >= feedRepliesLimit) {
                    comment.replies.data = [];
                    newState.posts.meta.publishingCommentsList.thread[comment.intId] = newState.posts.meta.publishingCommentsList.thread[comment.intId].slice(-feedRepliesLimit);
                } else comment.replies.data = comment.replies.data.slice(-(feedRepliesLimit - publishedRepliesCount));
            }
        };
        post.comments.data.forEach((comment)=>{
            var _a4;
            if ((_a4 = newState.posts.meta.publishingCommentsList) == null ? void 0 : _a4.thread[comment.intId]) newState.posts.meta.publishingCommentsList.thread[comment.intId] = newState.posts.meta.publishingCommentsList.thread[comment.intId].filter((item2)=>item2.status !== EPublishCommentStatus.ERROR);
            removeRedundantReplies(comment);
        });
        if (publishedCommentsCount > 0) newState.posts.meta.publishingCommentsList.post[postId].forEach((publishingComment)=>{
            if (isPublishedComment(publishingComment)) removeRedundantReplies(publishingComment.publishedComment);
        });
    }));
};
const blogReducerResetBlog = (blog2)=>{
    blog2.case(resetBlog, (store2)=>({
            ...store2,
            blog: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    createNetworkStatus: getDefaultNetworkStatus$1(),
                    editNetworkStatus: getDefaultNetworkStatus$1(),
                    editCoverNetworkStatus: getDefaultNetworkStatus$1(),
                    followNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const blogReducerResetFeed = (blog2)=>{
    blog2.case(resetFeed, (store2)=>({
            ...store2,
            posts: {
                data: {
                    isLast: false,
                    offset: null,
                    posts: [],
                    blogUrl: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    pollsNetworkStatus: {
                        polls: {},
                        votes: {},
                        voters: {}
                    },
                    commentsNetworkStatus: {
                        post: {},
                        thread: {}
                    },
                    editCommentNetworkStatus: {},
                    publishingCommentsList: {
                        post: {},
                        thread: {}
                    },
                    removePostNetworkStatus: getDefaultNetworkStatus$1(),
                    createPostNetworkStatus: getDefaultNetworkStatus$1(),
                    updatePostNetworkStatus: getDefaultNetworkStatus$1(),
                    deferredAccessNetworkStatus: getDefaultNetworkStatus$1(),
                    justRemovedComments: {},
                    commentsViewMeta: {
                        lastCommentPageTypeVisited: null,
                        postIdsToRefetch: []
                    }
                }
            }
        }));
};
const blogReducerResetFeedTags = (blog2)=>{
    blog2.case(resetFeedTags, (store2)=>({
            ...store2,
            postsTags: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const blogReducerRestoreComment = (blog2)=>{
    blog2.case(restoreComment.async.done, (store2, payload)=>{
        const { params: { postId }, result: result2 } = payload;
        const newPostsData = store2.posts.data.posts.map((post)=>{
            if (post.id === postId) {
                const newComments = post.comments.data.map((comment)=>{
                    if (comment.intId === result2.intId) return {
                        ...comment,
                        data: result2.data,
                        isDeleted: false,
                        isRemoved: false
                    };
                    if (isCommentInThread(result2) && result2.parentId === comment.intId) return {
                        ...comment,
                        replies: {
                            ...comment.replies,
                            data: comment.replies.data.map((reply)=>{
                                if (reply.intId === result2.intId) return {
                                    ...reply,
                                    data: result2.data,
                                    isDeleted: false,
                                    isRemoved: false
                                };
                                return reply;
                            })
                        }
                    };
                    return comment;
                });
                return {
                    ...post,
                    comments: {
                        ...post.comments,
                        data: newComments
                    },
                    count: {
                        ...post.count,
                        comments: post.count.comments + 1
                    }
                };
            } else return post;
        });
        return {
            ...store2,
            posts: {
                ...store2.posts,
                data: {
                    ...store2.posts.data,
                    posts: newPostsData
                }
            }
        };
    });
};
const blogReducerRetractVote = (blog2)=>{
    blog2.withHandling(immerCase(retractVote.async.started, (newState, { pollId })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusStarted$1();
    })).withHandling(immerCase(retractVote.async.done, (newState, { result: result2, params: { pollId } })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusDone$1();
    })).withHandling(immerCase(retractVote.async.failed, (newState, { params: { pollId }, error: error2 })=>{
        newState.posts.meta.pollsNetworkStatus.votes[pollId] = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerSearchUsers = (blog2)=>{
    blog2.withHandling(immerCase(searchUsers.async.started, (newState)=>{
        newState.usersSearch.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(searchUsers.async.done, (newState, { result: result2 })=>{
        newState.usersSearch.data.users = result2.users;
        newState.usersSearch.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(searchUsers.async.failed, (newState, { error: error2 })=>{
        newState.usersSearch.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const blogReducerSetIsCurrentUserTouchedFeedFilter = (reducer)=>{
    return reducer.case(setIsCurrentUserTouchedFeedFilter, (state, value2)=>({
            ...state,
            isCurrentUserTouchedFeedFilter: value2
        }));
};
const blogReducerToggleRss = (blog2)=>{
    blog2.withHandling(immerCase(toggleRss.async.done, (newStore, payload)=>{
        const { result: { isRssFeedEnabled } } = payload;
        newStore.blog.data.flags.isRssFeedEnabled = isRssFeedEnabled;
    }));
};
const blogReducerUpdateDescription = (blog2)=>{
    blog2.withHandling(immerCase(updateDescription.async.done, (newStore, payload)=>{
        newStore.blog.data.description = payload.params.description;
    }));
};
const blogReducerUpdateHasAdultContent = (blog2)=>{
    blog2.withHandling(immerCase(updateHasAdultContent.async.done, (newStore, payload)=>{
        const { result: { hasAdultContent } } = payload;
        newStore.blog.data.hasAdultContent = hasAdultContent;
    }));
};
const blogReducerUpdatePostPublishTime = (reducer)=>{
    return reducer.case(updateBlogPostIsPublishedState, (state, { postId })=>({
            ...state,
            posts: {
                ...state.posts,
                data: {
                    ...state.posts.data,
                    posts: [
                        ...state.posts.data.posts.map((post)=>{
                            if (post.id === postId) {
                                post.isPublished = true;
                                return {
                                    ...post
                                };
                            }
                            return post;
                        })
                    ]
                }
            }
        }));
};
const getBlogInitialState = ()=>({
        blog: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createNetworkStatus: getDefaultNetworkStatus$1(),
                editNetworkStatus: getDefaultNetworkStatus$1(),
                editCoverNetworkStatus: getDefaultNetworkStatus$1(),
                followNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogExternal: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogItem: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        posts: {
            data: {
                isLast: false,
                offset: null,
                posts: [],
                blogUrl: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                pollsNetworkStatus: {
                    polls: {},
                    votes: {},
                    voters: {}
                },
                commentsNetworkStatus: {
                    post: {},
                    thread: {}
                },
                publishingCommentsList: {
                    post: {},
                    thread: {}
                },
                editCommentNetworkStatus: {},
                removePostNetworkStatus: getDefaultNetworkStatus$1(),
                createPostNetworkStatus: getDefaultNetworkStatus$1(),
                updatePostNetworkStatus: getDefaultNetworkStatus$1(),
                deferredAccessNetworkStatus: getDefaultNetworkStatus$1(),
                commentsViewMeta: {
                    lastCommentPageTypeVisited: null,
                    postIdsToRefetch: []
                },
                justRemovedComments: {}
            }
        },
        postsSearch: {
            data: {
                searchPosts: [],
                offset: null,
                isLast: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        postsTags: {
            data: {
                tags: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentPost: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        postDrafts: {
            data: {
                blogPostDrafts: [],
                activeBlogPostDraft: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        newPostId: null,
        rss: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        usersSearch: {
            data: {
                users: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        isCurrentUserTouchedFeedFilter: false,
        lastActivePostId: null,
        postDonationsNetworkStatuses: {}
    });
const blog = (0, $ki1Eq.reducerWithInitialState)(getBlogInitialState());
blogOwnerUpdates(blog);
blogReducerBlacklistStatus(blog);
blogReducerChannelCoverImageUpload(blog);
blogReducerChannelCoverTypeChange(blog);
blogReducerChannelNotificationSettingsUpdate(blog);
blogReducerChangeSubscribersCount(blog);
blogReducerCommentSend(blog);
blogReducerCommentsFetch(blog);
blogReducerCoverEdit(blog);
blogReducerCreate(blog);
blogReducerDeferredAccessLevelsFetch(blog);
blogReducerEdit(blog);
blogReducerFetch(blog);
blogReducerClearExternal(blog);
blogReducerFetchExternal(blog);
blogReducerFollow(blog);
blogReducerNewPostCreate(blog);
blogReducerPostReaction(blog);
blogReducerPostDraftsSet(blog);
blogReducerPostDraftSave(blog);
blogReducerPostDraftRemove(blog);
blogReducerPostDraftSelect(blog);
blogReducerPosts(blog);
blogReducerPostsTags(blog);
blogReducerReactionComment(blog);
blogReducerRemoveCommentFromStore(blog);
blogReducerRestoreComment(blog);
blogReducerSetIsCurrentUserTouchedFeedFilter(blog);
blogReducerUpdatePostPublishTime(blog);
blogReducerFetchRssLink(blog);
blogReducerToggleRss(blog);
blogReducerUpdateHasAdultContent(blog);
blogReducerClearComments(blog);
blogReducerLastActivePostId(blog);
blogReducerCommentEdit(blog);
blogReducerResetBlog(blog);
blogReducerResetFeed(blog);
blogReducerResetFeedTags(blog);
blogReducerCommentViewMeta(blog);
blogReducerRemovedComments(blog);
blogReducerRemoveRedundantComments(blog);
blogReducerFetchItem(blog);
blogReducerPostDonations(blog);
blogReducerIncreasePostDonationsSum(blog);
blogReducerFetchPoll(blog);
blogReducerCommitVote(blog);
blogReducerRetractVote(blog);
blogReducerFetchVoters(blog);
blogReducerMarkPollAsFinished(blog);
blogReducerSearchUsers(blog);
blogReducerClearUsersSearchList(blog);
blogReducerUpdateDescription(blog);
const blogStatFetchPostSalesDaysByMonth = (blogStat2)=>{
    applyAsyncReducer()("blogPostSalesDaysByMonth", "networkStatus", fetchPostSalesDaysByMonth.async, blogStat2, (props)=>props.result);
};
const blogStatReducerClearBlogEvents = (blogStat2)=>{
    blogStat2.withHandling(immerCase(clearBlogEvents, (newState)=>{
        newState.blogEvents.data = {
            data: [],
            extra: null
        };
    }));
};
const blogStatReducerClearBlogMetrics = (blogStat2)=>{
    blogStat2.case(clearBlogMetrics, (state)=>({
            ...state,
            blogBase: {
                ...state.blogBase,
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            },
            blogMetrics: {
                ...state.blogMetrics,
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            },
            blogMetricsStatCharts: {
                ...state.blogMetricsStatCharts,
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const blogStatReducerClearBlogRefsUsers = (blogStat2)=>{
    blogStat2.withHandling(immerCase(clearBlogRefsUsers, (newState)=>{
        newState.blogRefsUsers.data = {
            data: {
                referrals: []
            },
            extra: {
                total: null,
                offset: null
            }
        };
    }));
};
const blogStatReducerClearDonations = (blogStat2)=>{
    blogStat2.case(clearDonations, (state)=>{
        const newState = deepCopy(state);
        newState.blogDonations = {
            data: {
                data: {
                    donations: []
                },
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        };
        return newState;
    });
};
const blogStatReducerClearPostSales = (blogStat2)=>{
    blogStat2.case(clearPostSales, (state)=>{
        const newState = deepCopy(state);
        newState.blogPostSales = {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        };
        return newState;
    });
};
const blogStatReducerClearSubscribers = (blogStat2)=>{
    blogStat2.case(clearSubscribers, (state)=>{
        const newState = deepCopy(state);
        newState.blogSubscribers = {
            data: {
                list: [],
                total: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        };
        return newState;
    });
};
const blogStatReducerFetchBlogBaseStat = (blogStat2)=>{
    applyAsyncReducer()("blogBase", "networkStatus", fetchBlogBaseStat.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogEvents = (blogStat2)=>{
    applyAsyncReducer()("blogEvents", "networkStatus", fetchBlogEvents.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogHolds = (blogStat2)=>{
    applyAsyncReducer()("blogHolds", "networkStatus", fetchBlogHolds.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogMetrics = (blogStat2)=>{
    applyAsyncReducer()("blogMetrics", "networkStatus", fetchBlogMetrics.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogRefs = (blogStat2)=>{
    applyAsyncReducer()("blogRefs", "networkStatus", fetchBlogRefs.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogRefsUsers = (blogStat2)=>{
    applyAsyncReducer()("blogRefsUsers", "networkStatus", fetchBlogRefsUsers.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBlogSearchUsers = (blogStat2)=>{
    applyAsyncReducer()("blogSearchUsers", "networkStatus", fetchBlogSearchUsers.async, blogStat2, (props)=>props.result.data);
};
const blogStatReducerFetchBlogStatCharts = (blogStat2)=>{
    applyAsyncReducer()("blogMetricsStatCharts", "networkStatus", fetchBlogStatCharts.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchBroadcastMessageStats = (blogStat2)=>{
    applyAsyncReducer()("broadcastMessageStats", "networkStatus", fetchBroadcastMessageStats.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchDonations = (blogStat2)=>{
    applyAsyncReducer()("blogDonations", "networkStatus", fetchDonations.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchPostSales = (blogStat2)=>{
    applyAsyncReducer()("blogPostSales", "networkStatus", fetchPostSales.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchPostSalesByDate = (blogStat2)=>{
    applyAsyncReducer()("blogPostSalesByDate", "networkStatus", fetchPostSalesByDate.async, blogStat2, (props)=>props.result);
};
const blogStatReducerFetchSubscribers = (blogStat2)=>{
    applyAsyncReducer()("blogSubscribers", "networkStatus", fetchSubscribers.async, blogStat2, ({ result: result2 })=>({
            list: result2.data,
            total: result2.total
        }));
};
const blogStatReducerFetchUnsubList = (blogStat2)=>{
    blogStat2.case(fetchUnsubsList.async.started, (state)=>({
            ...state,
            blogUnsubscribes: {
                ...state.blogUnsubscribes,
                meta: {
                    ...state.blogUnsubscribes.meta,
                    networkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(fetchUnsubsList.async.done, (state, { result: resp })=>({
            ...state,
            blogUnsubscribes: {
                ...state.blogUnsubscribes,
                data: resp,
                meta: {
                    ...state.blogUnsubscribes.meta,
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        })).case(fetchUnsubsList.async.failed, (state, { error: error2 })=>({
            ...state,
            blogUnsubscribes: {
                ...state.blogUnsubscribes,
                meta: {
                    ...state.blogUnsubscribes.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const blogStatReducerUpdateBlogChartsForPeriod = (blogStat2)=>{
    blogStat2.case(updateBlogChartsForPeriod, (state, payload)=>{
        return {
            ...state,
            blogMetricsStatCharts: {
                ...state.blogMetricsStatCharts,
                data: {
                    ...state.blogMetricsStatCharts.data,
                    ...payload
                }
            }
        };
    });
};
const blogStatReducerUpdateBlogMetricsForPeriod = (blogStat2)=>{
    blogStat2.case(updateBlogMetricsForPeriod, (state, payload)=>({
            ...state,
            blogMetricsNew: {
                ...state.blogMetrics,
                data: {
                    ...state.blogMetrics.data,
                    ...payload
                }
            }
        }));
};
const getBlogStatReducerInitialState = ()=>({
        blogBase: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogMetrics: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogMetricsStatCharts: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogEvents: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogRefs: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogRefsUsers: {
            data: {
                data: {
                    referrals: []
                },
                extra: {
                    total: null,
                    offset: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogSearchUsers: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogUnsubscribes: {
            data: {
                data: {
                    unsubscribeAnswers: []
                },
                extra: {
                    isLast: null,
                    offset: null,
                    total: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogSubscribers: {
            data: {
                list: [],
                total: 0
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogDonations: {
            data: {
                data: {
                    donations: []
                },
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogPostSales: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogPostSalesByDate: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogPostSalesDaysByMonth: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        blogHolds: {
            data: {
                data: {
                    holds: []
                },
                extra: {
                    total: null,
                    offset: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        broadcastMessageStats: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const blogStat = (0, $ki1Eq.reducerWithInitialState)(getBlogStatReducerInitialState());
blogStatFetchPostSalesDaysByMonth(blogStat);
blogStatReducerClearBlogEvents(blogStat);
blogStatReducerClearBlogMetrics(blogStat);
blogStatReducerClearBlogRefsUsers(blogStat);
blogStatReducerFetchBlogBaseStat(blogStat);
blogStatReducerFetchBlogEvents(blogStat);
blogStatReducerFetchBlogHolds(blogStat);
blogStatReducerFetchBlogMetrics(blogStat);
blogStatReducerFetchBlogRefs(blogStat);
blogStatReducerFetchBlogRefsUsers(blogStat);
blogStatReducerFetchBlogSearchUsers(blogStat);
blogStatReducerFetchBlogStatCharts(blogStat);
blogStatReducerUpdateBlogChartsForPeriod(blogStat);
blogStatReducerUpdateBlogMetricsForPeriod(blogStat);
blogStatReducerFetchSubscribers(blogStat);
blogStatReducerClearSubscribers(blogStat);
blogStatReducerFetchDonations(blogStat);
blogStatReducerClearDonations(blogStat);
blogStatReducerFetchPostSales(blogStat);
blogStatReducerClearPostSales(blogStat);
blogStatReducerFetchPostSalesByDate(blogStat);
blogStatReducerFetchBroadcastMessageStats(blogStat);
blogStatReducerFetchUnsubList(blogStat);
const catalogReducerClearHistory = (builder)=>{
    builder.case(clearCatalogHistory, (state, {})=>({
            ...state,
            history: {
                data: {
                    views: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchHistory = (builder)=>{
    applyAsyncReducer()("history", "networkStatus", fetchCatalogHistory.async, builder, ({ result: result2, store: store2 })=>{
        var _a3;
        const { views, extra } = result2 ?? {};
        return {
            views: [
                ...((_a3 = store2.history.data) == null ? void 0 : _a3.views) ?? [],
                ...views
            ],
            extra: extra
        };
    });
};
const catalogReducerClearBlockData = (catalog2)=>{
    catalog2.case(clearCatalogBlockData, (state, { blockId })=>({
            ...state,
            dynamicBlockData: !blockId ? {} : {
                ...state.dynamicBlockData,
                [blockId]: {
                    data: {
                        data: null,
                        extra: {
                            offset: null,
                            isLast: false
                        }
                    },
                    meta: {
                        networkStatus: getDefaultNetworkStatus$1()
                    }
                }
            }
        }));
};
const catalogReducerFetchBlockData = (catalog2)=>{
    catalog2.case(fetchCatalogBlockData.async.started, (store2, payload)=>{
        var _a3, _b2, _c2;
        return {
            ...store2,
            dynamicBlockData: {
                ...store2.dynamicBlockData,
                [payload.blockId]: {
                    ...(_a3 = store2.dynamicBlockData) == null ? void 0 : _a3[payload.blockId],
                    meta: {
                        ...(_c2 = (_b2 = store2.dynamicBlockData) == null ? void 0 : _b2[payload.blockId]) == null ? void 0 : _c2.meta,
                        networkStatus: getNetworkStatusStarted$1()
                    }
                }
            }
        };
    }).case(fetchCatalogBlockData.async.failed, (store2, { error: error2, params })=>{
        var _a3, _b2, _c2;
        return {
            ...store2,
            dynamicBlockData: {
                ...store2.dynamicBlockData,
                [params.blockId]: {
                    ...(_a3 = store2.dynamicBlockData) == null ? void 0 : _a3[params.blockId],
                    meta: {
                        ...(_c2 = (_b2 = store2.dynamicBlockData) == null ? void 0 : _b2[params.blockId]) == null ? void 0 : _c2.meta,
                        networkStatus: getNetworkStatusFailed$1(error2)
                    }
                }
            }
        };
    }).case(fetchCatalogBlockData.async.done, (store2, payload)=>{
        var _a3, _b2, _c2, _d, _e, _f;
        const { categories, records, streamBlogs, extra } = payload.result;
        return {
            ...store2,
            dynamicBlockData: {
                ...store2.dynamicBlockData,
                [payload.params.blockId]: {
                    ...((_a3 = store2.dynamicBlockData) == null ? void 0 : _a3[payload.params.blockId]) ?? {},
                    data: {
                        data: payload.params.appendData ? [
                            ...((_d = (_c2 = (_b2 = store2.dynamicBlockData) == null ? void 0 : _b2[payload.params.blockId]) == null ? void 0 : _c2.data) == null ? void 0 : _d.data) ?? [],
                            ...categories ?? records ?? streamBlogs
                        ] : categories ?? records ?? streamBlogs,
                        extra: extra
                    },
                    meta: {
                        ...((_f = (_e = store2.dynamicBlockData) == null ? void 0 : _e[payload.params.blockId]) == null ? void 0 : _f.meta) ?? {},
                        networkStatus: getNetworkStatusDone$1()
                    }
                }
            }
        };
    });
};
const catalogReducerClearCategories = (catalog2)=>{
    catalog2.case(clearCatalogCategories, (state, {})=>({
            ...state,
            categories: {
                data: {
                    list: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchCategories = (catalog2)=>{
    applyAsyncReducer()("categories", "networkStatus", fetchCatalogCategories.async, catalog2, ({ store: store2, result: result2 })=>({
            list: (store2.categories.data.list || []).concat(result2.categories),
            extra: result2.extra
        }));
};
const catalogReducerClearCategoryRecords = (catalog2)=>{
    catalog2.case(clearCatalogCategoryRecords, (state, {})=>({
            ...state,
            categoryRecords: {
                data: {
                    category: null,
                    records: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchCategoryRecords = (catalog2)=>{
    applyAsyncReducer()("categoryRecords", "networkStatus", fetchCatalogCategoryRecords.async, catalog2, ({ store: store2, result: result2 })=>{
        var _a3;
        const { category: prevCategory, records: prevRecords = [] } = ((_a3 = store2.categoryRecords) == null ? void 0 : _a3.data) ?? {};
        const { data: { category: category2, records = [] }, extra } = result2 ?? {};
        const isNewCategory = (prevCategory == null ? void 0 : prevCategory.id) !== (category2 == null ? void 0 : category2.id);
        return {
            category: category2,
            records: isNewCategory ? records : [
                ...prevRecords || [],
                ...records
            ],
            extra: extra
        };
    });
};
const catalogReducerClearCategoryStreams = (catalog2)=>{
    catalog2.case(clearCatalogCategoryStreams, (state, {})=>({
            ...state,
            categoryStreams: {
                data: {
                    category: null,
                    streams: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchCategoryStreams = (catalog2)=>{
    applyAsyncReducer()("categoryStreams", "networkStatus", fetchCatalogCategoryStreams.async, catalog2, ({ store: store2, result: result2 })=>{
        var _a3;
        const { category: prevCategory, streams: prevStreams = [] } = ((_a3 = store2.categoryStreams) == null ? void 0 : _a3.data) ?? {};
        const { data: { category: category2, streams = [] }, extra } = result2 ?? {};
        const isNewCategory = (prevCategory == null ? void 0 : prevCategory.id) !== (category2 == null ? void 0 : category2.id);
        return {
            category: category2,
            streams: isNewCategory ? streams : [
                ...prevStreams || [],
                ...streams
            ],
            extra: extra
        };
    });
};
const catalogReducerHideCategoryStreams = (catalog2)=>{
    catalog2.withHandling(immerCase(hideCatalogCategoryStreams.async.started, (newState)=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(hideCatalogCategoryStreams.async.done, (newState)=>{
        newState.categoryStreams.data.category.isHidden = true;
        newState.categoryStreams.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(hideCatalogCategoryStreams.async.failed, (newState, { error: error2 })=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const catalogReducerRemoveFromHiddenCategoryStreams = (catalog2)=>{
    catalog2.withHandling(immerCase(removeFromHiddenCatalogCategoryStreams.async.started, (newState)=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(removeFromHiddenCatalogCategoryStreams.async.done, (newState)=>{
        newState.categoryStreams.data.category.isHidden = false;
        newState.categoryStreams.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(removeFromHiddenCatalogCategoryStreams.async.failed, (newState, { error: error2 })=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const catalogReducerFollowCategoryStreams = (catalog2)=>{
    catalog2.withHandling(immerCase(followCatalogCategoryStreams.async.started, (newState)=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(followCatalogCategoryStreams.async.done, (newState)=>{
        newState.categoryStreams.data.category.isFollowed = true;
        newState.categoryStreams.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(followCatalogCategoryStreams.async.failed, (newState, { error: error2 })=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const catalogReducerUnfollowCategoryStreams = (catalog2)=>{
    catalog2.withHandling(immerCase(unfollowCatalogCategoryStreams.async.started, (newState)=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(unfollowCatalogCategoryStreams.async.done, (newState)=>{
        newState.categoryStreams.data.category.isFollowed = false;
        newState.categoryStreams.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(unfollowCatalogCategoryStreams.async.failed, (newState, { error: error2 })=>{
        newState.categoryStreams.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const catalogReducerClearFollowedCategoriesStreams = (catalog2)=>{
    catalog2.case(clearCatalogFollowedCategoriesStreams, (state, {})=>({
            ...state,
            followedCategories: {
                data: {
                    categories: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchFollowedCategoriesStreams = (catalog2)=>{
    applyAsyncReducer()("followedCategories", "networkStatus", fetchCatalogFollowedCategoriesStreams.async, catalog2, ({ result: result2 })=>{
        const { categories, extra } = result2 ?? {};
        return {
            categories: categories,
            extra: extra
        };
    });
};
const catalogReducerClearHiddenCategories = (catalog2)=>{
    catalog2.case(clearCatalogHiddenCategories, (state, {})=>({
            ...state,
            hiddenCategories: {
                data: {
                    list: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchHiddenCategories = (catalog2)=>{
    applyAsyncReducer()("hiddenCategories", "networkStatus", fetchCatalogHiddenCategories.async, catalog2, ({ store: store2, result: result2 })=>({
            list: (store2.hiddenCategories.data.list || []).concat(result2.categories),
            extra: result2.extra
        }));
};
const catalogReducerRemoveFromHiddenCategory = (catalog2)=>{
    catalog2.case(removeFromHiddenCategory.async.done, (state, { params })=>{
        const { hiddenCategories: { data } } = state;
        const { list: list2 } = data;
        const newList = list2.filter((item2)=>item2.id !== params.categoryId);
        return {
            ...state,
            hiddenCategories: {
                ...state.hiddenCategories,
                data: {
                    ...state.hiddenCategories.data,
                    list: newList
                }
            }
        };
    });
};
const catalogReducerClearHiddenStreams = (catalog2)=>{
    catalog2.case(clearCatalogHiddenStreams, (state, {})=>({
            ...state,
            hiddenStreams: {
                data: {
                    list: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchHiddenStreams = (catalog2)=>{
    applyAsyncReducer()("hiddenStreams", "networkStatus", fetchCatalogHiddenStreams.async, catalog2, ({ store: store2, result: result2 })=>({
            list: (store2.hiddenStreams.data.list || []).concat(result2.streams),
            extra: result2.extra
        }));
};
const catalogReducerRemoveFromHiddenStream = (catalog2)=>{
    catalog2.case(removeCatalogStreamFromHidden.async.done, (state, { params })=>{
        const { hiddenStreams: { data } } = state;
        const { list: list2 } = data;
        const newList = list2.filter((item2)=>item2.blogUrl !== params.blogUrl);
        return {
            ...state,
            hiddenStreams: {
                ...state.hiddenStreams,
                data: {
                    ...state.hiddenStreams.data,
                    list: newList
                }
            }
        };
    });
};
const getViewers = (streamsData, channelUrl)=>{
    const stream2 = Object.values(streamsData[channelUrl]).reduce(getStreamWithMaximalOnline, null);
    const { isOnline, count: { viewers: viewers2 } = {
        viewers: void 0
    } } = stream2 || {};
    return isOnline ? viewers2 ?? 0 : -1;
};
const getComparator = (streamsData)=>(a2, b2)=>{
        return getViewers(streamsData, b2) - getViewers(streamsData, a2);
    };
const catalogReducerFetchRecommendedStreams = (catalog2)=>{
    applyAsyncReducer()("recommendedStreams", "networkStatus", fetchCatalogRecommendedStreams.async, catalog2, ({ store: store2, result: result2 })=>{
        const streamsData = result2.recommendedStreams.reduce((acc, stream2)=>{
            var _a3;
            acc[stream2.blogUrl] = {
                ...acc[stream2.blogUrl] ?? {},
                [((_a3 = stream2 == null ? void 0 : stream2.streamSlot) == null ? void 0 : _a3.slotUrl) ?? DEFAULT_SLOT]: stream2
            };
            return acc;
        }, {});
        const streamsDataMeta = result2.recommendedStreams.reduce((acc, stream2)=>{
            acc[stream2.blogUrl] = stream2;
            return acc;
        }, {});
        return {
            blogUrls: Object.keys(streamsData).sort(getComparator(streamsData)),
            data: streamsData,
            metaInfo: streamsDataMeta
        };
    });
    catalog2.withHandling(immerCase(updateCatalogRecommendedStreams, (newState, subscription2)=>{
        var _a3, _b2, _c2, _d;
        const recommendedStreamSlots = (_a3 = newState.recommendedStreams.data) == null ? void 0 : _a3.data[subscription2.channelUrl];
        if (!recommendedStreamSlots) return;
        const data = {
            ...((_b2 = newState.recommendedStreams.data) == null ? void 0 : _b2.metaInfo[subscription2.channelUrl]) ?? {},
            isOnline: subscription2.isOnline,
            id: subscription2.streamId,
            isEnded: Boolean(subscription2.isEnded),
            endTime: Boolean(subscription2.isEnded) ? Number(/* @__PURE__ */ new Date()) / 1e3 : null,
            count: {
                viewers: subscription2.viewers
            },
            streamSlot: subscription2.streamSlot,
            category: subscription2.category,
            ...subscription2.title ? {
                title: subscription2.title,
                titleData: Boolean(subscription2.titleData) ? subscription2.titleData : null
            } : {}
        };
        const slotKey = ((_c2 = subscription2.streamSlot) == null ? void 0 : _c2.slotUrl) ?? DEFAULT_SLOT;
        recommendedStreamSlots[slotKey] = data;
        const streamsData = (_d = newState.recommendedStreams.data) == null ? void 0 : _d.data;
        newState.recommendedStreams.data.blogUrls.sort(getComparator(streamsData));
    }));
};
const catalogReducerClearShowcaseStreams = (catalog2)=>{
    catalog2.case(clearCatalogShowcaseStreams, (state, {})=>({
            ...state,
            showcaseStreams: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchShowcaseStreams = (catalog2)=>{
    applyAsyncReducer()("showcaseStreams", "networkStatus", fetchCatalogShowcaseStreams.async, catalog2, ({ store: store2, result: result2 })=>result2.showcaseStreams);
};
const getAllVideoBlocks = (blocks2)=>{
    const result2 = [];
    blocks2 == null || blocks2.forEach((block2)=>{
        if ([
            EStreamSchemaType.STREAM,
            EStreamSchemaType.STREAM_RECORD
        ].includes(block2.type) && block2.style !== EStreamSchemaStyle.CAROUSEL) result2.push(block2.id);
        if (block2.type === EStreamSchemaType.GROUP_BLOCK) result2.push(...getAllVideoBlocks(block2.blocks));
    });
    return result2;
};
const catalogReducerClearStreams = (catalog2)=>{
    catalog2.case(clearCatalogStreams, (state, {})=>({
            ...state,
            streams: {
                data: {
                    list: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const catalogReducerFetchStreams = (catalog2)=>{
    applyAsyncReducer()("streams", "networkStatus", fetchCatalogStreams.async, catalog2, ({ store: store2, result: result2 })=>({
            list: (store2.streams.data.list || []).concat(result2.streams),
            extra: result2.extra
        }));
};
const catalogReducerHideStream = (catalog2)=>{
    catalog2.case(hideCatalogStream.async.done, (state, { params, result: result2 })=>{
        var _a3, _b2, _c2;
        const newRecomendedStreams = {
            ...state.recommendedStreams,
            data: {
                blogUrls: ((_a3 = state.recommendedStreams.data) == null ? void 0 : _a3.blogUrls.filter((blogUrl)=>blogUrl !== params.blogUrl)) ?? null,
                data: (_b2 = state.recommendedStreams.data) == null ? void 0 : _b2.data,
                metaInfo: (_c2 = state.recommendedStreams.data) == null ? void 0 : _c2.metaInfo
            }
        };
        if (!result2.schema) return {
            ...state,
            recommendedStreams: newRecomendedStreams
        };
        const filterStreams = (item2)=>item2.blog.blogUrl !== params.blogUrl;
        const findStream = (item2)=>item2.blog.blogUrl === params.blogUrl;
        const hiddenStreamBlockIds = getAllVideoBlocks(result2.schema.data).filter((key)=>{
            var _a4, _b3, _c3, _d;
            return ((_c3 = (_b3 = (_a4 = state.dynamicBlockData[key]) == null ? void 0 : _a4.data) == null ? void 0 : _b3.data) == null ? void 0 : _c3.length) > 0 && ((_d = state.dynamicBlockData[key].data.data) == null ? void 0 : _d.some(findStream));
        });
        const newDynamicBlockData = hiddenStreamBlockIds.reduce((acc, key)=>{
            var _a4;
            const streamBlock = state.dynamicBlockData[key].data.data;
            const newList = streamBlock.filter(filterStreams);
            return {
                ...acc,
                [key]: {
                    ...(acc == null ? void 0 : acc[key]) ?? {},
                    data: {
                        ...((_a4 = acc == null ? void 0 : acc[key]) == null ? void 0 : _a4.data) ?? {},
                        data: newList
                    }
                }
            };
        }, {
            ...state.dynamicBlockData
        });
        return {
            ...state,
            dynamicBlockData: newDynamicBlockData,
            recommendedStreams: newRecomendedStreams
        };
    });
};
const catalogReducerFetchSubscribedStreams = (catalog2)=>{
    applyAsyncReducer()("subscribedStreams", "networkStatus", fetchCatalogSubscribedStreams.async, catalog2, ({ store: store2, result: result2 })=>{
        const streamsData = result2.subscribedStreams.reduce((acc, stream2)=>{
            var _a3;
            acc[stream2.blogUrl] = {
                ...acc[stream2.blogUrl] ?? {},
                [((_a3 = stream2 == null ? void 0 : stream2.streamSlot) == null ? void 0 : _a3.slotUrl) ?? DEFAULT_SLOT]: stream2
            };
            return acc;
        }, {});
        const streamsDataMeta = result2.subscribedStreams.reduce((acc, stream2)=>{
            acc[stream2.blogUrl] = stream2;
            return acc;
        }, {});
        return {
            blogUrls: Object.keys(streamsData).sort(getComparator(streamsData)),
            data: streamsData,
            metaInfo: streamsDataMeta
        };
    });
    catalog2.case(clearCatalogSubscribedStreams, (state)=>({
            ...state,
            subscribedStreams: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
    catalog2.withHandling(immerCase(updateCatalogSubscribedStreams, (newState, subscription2)=>{
        var _a3, _b2, _c2, _d, _e;
        const subscribedStreamSlots = (_b2 = (_a3 = newState.subscribedStreams.data) == null ? void 0 : _a3.data) == null ? void 0 : _b2[subscription2.channelUrl];
        if (!subscribedStreamSlots) return;
        const data = {
            ...((_c2 = newState.subscribedStreams.data) == null ? void 0 : _c2.metaInfo[subscription2.channelUrl]) ?? {},
            isOnline: subscription2.isOnline,
            id: subscription2.streamId,
            isEnded: Boolean(subscription2.isEnded),
            endTime: Boolean(subscription2.isEnded) ? Number(/* @__PURE__ */ new Date()) / 1e3 : null,
            count: {
                viewers: subscription2.viewers
            },
            streamSlot: subscription2.streamSlot,
            category: subscription2.category,
            ...subscription2.title ? {
                title: subscription2.title,
                titleData: Boolean(subscription2.titleData) ? subscription2.titleData : null
            } : {}
        };
        const slotKey = ((_d = subscription2.streamSlot) == null ? void 0 : _d.slotUrl) ?? DEFAULT_SLOT;
        subscribedStreamSlots[slotKey] = data;
        const streamsData = (_e = newState.subscribedStreams.data) == null ? void 0 : _e.data;
        newState.subscribedStreams.data.blogUrls.sort(getComparator(streamsData));
    }));
};
const getCatalogInitialState = ()=>({
        dynamicBlockData: {},
        categories: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        hiddenCategories: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        recommendedStreams: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        showcaseStreams: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        subscribedStreams: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        hiddenStreams: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streams: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        categoryStreams: {
            data: {
                category: null,
                streams: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        categoryRecords: {
            data: {
                category: null,
                records: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        followedCategories: {
            data: {
                categories: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        history: {
            data: {
                views: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const catalog = (0, $ki1Eq.reducerWithInitialState)(getCatalogInitialState());
catalogReducerClearCategories(catalog);
catalogReducerFetchCategories(catalog);
catalogReducerClearCategoryStreams(catalog);
catalogReducerFetchCategoryStreams(catalog);
catalogReducerClearFollowedCategoriesStreams(catalog);
catalogReducerFetchFollowedCategoriesStreams(catalog);
catalogReducerClearHiddenCategories(catalog);
catalogReducerFetchHiddenCategories(catalog);
catalogReducerRemoveFromHiddenCategory(catalog);
catalogReducerFetchCategoryStreams(catalog);
catalogReducerClearCategoryStreams(catalog);
catalogReducerHideCategoryStreams(catalog);
catalogReducerRemoveFromHiddenCategoryStreams(catalog);
catalogReducerFollowCategoryStreams(catalog);
catalogReducerUnfollowCategoryStreams(catalog);
catalogReducerFetchCategoryRecords(catalog);
catalogReducerClearCategoryRecords(catalog);
catalogReducerFetchRecommendedStreams(catalog);
catalogReducerClearShowcaseStreams(catalog);
catalogReducerFetchShowcaseStreams(catalog);
catalogReducerFetchSubscribedStreams(catalog);
catalogReducerClearStreams(catalog);
catalogReducerFetchStreams(catalog);
catalogReducerHideStream(catalog);
catalogReducerFetchHiddenStreams(catalog);
catalogReducerRemoveFromHiddenStream(catalog);
catalogReducerClearHiddenStreams(catalog);
catalogReducerFetchBlockData(catalog);
catalogReducerClearBlockData(catalog);
catalogReducerFetchHistory(catalog);
catalogReducerClearHistory(catalog);
const channelBanReducerAddChannelPermanentBanFromWS = (channelBan2)=>{
    channelBan2.withHandling(immerCase(addChannelTemporaryBanFromWS, (newState, user)=>{
        newState.channelBan.data.permanent = [
            ...newState.channelBan.data.permanent || [],
            user
        ];
    }));
};
const channelBanReducerAddChannelTemporaryBanFromWS = (channelBan2)=>{
    channelBan2.withHandling(immerCase(addChannelTemporaryBanFromWS, (newState, user)=>{
        newState.channelBan.data.temporary = [
            ...newState.channelBan.data.temporary || [],
            user
        ];
    }));
};
const BanType = {
    PERMANENT: "permanent",
    TEMPORARY: "temporary"
};
const channelBanReducerUnbanUser = (channelBan2)=>{
    channelBan2.withHandling(immerCase(deleteChannelBan.async.started, (newState)=>{
        newState.channelBan.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deleteChannelBan.async.done, (newState, { params })=>{
        var _a3;
        const type = params.isPermanent ? BanType.PERMANENT : BanType.TEMPORARY;
        newState.channelBan.data[type] = (_a3 = newState.channelBan.data[type]) == null ? void 0 : _a3.filter((item2)=>item2.id !== params.userId);
        newState.channelBan.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(deleteChannelBan.async.failed, (newState, { error: error2 })=>{
        newState.channelBan.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getChannelBanInitialState = ()=>({
        channelBan: {
            data: {
                permanent: null,
                temporary: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelBan = (0, $ki1Eq.reducerWithInitialState)(getChannelBanInitialState());
applyAsyncReducer()("channelBan", "networkStatus", fetchChannelBan.async, channelBan, (props)=>props.result);
channelBan.case(clearChannelBan, ()=>({
        channelBan: {
            data: {
                permanent: null,
                temporary: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
channelBanReducerUnbanUser(channelBan);
channelBanReducerAddChannelPermanentBanFromWS(channelBan);
channelBanReducerAddChannelTemporaryBanFromWS(channelBan);
const getChannelModeratorInitialState = ()=>({
        channelModerator: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelModerator = (0, $ki1Eq.reducerWithInitialState)(getChannelModeratorInitialState());
applyAsyncReducer()("channelModerator", "networkStatus", fetchChannelModerators.async, channelModerator, (props)=>({
        list: props.result.moderators,
        extra: props.result.extra
    }));
applyAsyncReducer()("channelModerator", "networkStatus", setRole.async, channelModerator, (props)=>{
    var _a3;
    const channelModeratorList = [
        ...((_a3 = props.store.channelModerator.data) == null ? void 0 : _a3.list) ?? []
    ];
    const replaceTargetIndex = channelModeratorList.findIndex((item2)=>item2.id === props.result.id);
    if (replaceTargetIndex !== -1) channelModeratorList.splice(replaceTargetIndex, 1, props.result);
    else channelModeratorList.push(props.result);
    return {
        list: channelModeratorList,
        extra: props.store.channelModerator.data.extra
    };
});
channelModerator.case(cleanChannelModerators, ()=>getChannelModeratorInitialState());
channelModerator.case(deleteRoleStorage, (state, payload)=>{
    var _a3;
    return {
        ...state,
        channelModerator: {
            ...state.channelModerator,
            data: {
                ...state.channelModerator.data,
                list: (((_a3 = state.channelModerator.data) == null ? void 0 : _a3.list) || []).filter((item2)=>item2.id !== payload.userId)
            }
        }
    };
});
channelModerator.case(restoreRoleStorage, (state, { moderator, index: index2 })=>{
    var _a3, _b2;
    (_a3 = state.channelModerator.data.list) == null || _a3.splice(index2, 0, moderator);
    return {
        ...state,
        channelModerator: {
            ...state.channelModerator,
            data: {
                ...state.channelModerator.data,
                list: [
                    ...((_b2 = state.channelModerator.data) == null ? void 0 : _b2.list) || []
                ]
            }
        }
    };
});
const getPendingBonusInitialState = ()=>({
        pendingBonus: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const getBonusInitialState = ()=>({
        bonuses: {
            data: {
                bonuses: [],
                bonusMultipliers: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelPointPendingBonus = (0, $ki1Eq.reducerWithInitialState)(getPendingBonusInitialState());
const channelPointBonus = (0, $ki1Eq.reducerWithInitialState)(getBonusInitialState());
applyAsyncReducer()("pendingBonus", "networkStatus", getChannelPointPendingBonus.async, channelPointPendingBonus, (props)=>props.result);
channelPointPendingBonus.case(clearChannelPointPendingBonus, (state)=>({
        ...state,
        pendingBonus: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
applyAsyncReducer()("pendingBonus", "networkStatus", gatherChannelPointPendingBonus.async, channelPointPendingBonus, (props)=>props.store.pendingBonus.data.filter((bonus)=>bonus.id !== props.result.id));
channelPointPendingBonus.case(updateChannelPointPendingBonus, (state, payload)=>{
    let data;
    if (state.pendingBonus.data.some((item2)=>item2.id === payload.id)) data = state.pendingBonus.data.map((item2)=>item2.id === payload.id ? payload : item2);
    else data = [
        ...state.pendingBonus.data,
        payload
    ];
    return {
        ...state,
        pendingBonus: {
            data: data,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    };
});
applyAsyncReducer()("bonuses", "networkStatus", getChannelPointBonus.async, channelPointBonus, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.result);
channelPointBonus.case(clearChannelPointBonus, (state)=>({
        bonuses: {
            data: {
                bonuses: [],
                bonusMultipliers: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
const getChannelPointInitialState = ()=>({
        channelPoint: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelPoint = (0, $ki1Eq.reducerWithInitialState)(getChannelPointInitialState());
applyAsyncReducer()("channelPoint", "networkStatus", getChannelPoint.async, channelPoint, (props)=>props.result);
channelPoint.case(clearChannelPoint, (state)=>({
        ...state,
        channelPoint: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
channelPoint.case(updateChannelPointBalance, (state, { balance })=>({
        ...state,
        channelPoint: {
            data: {
                ...state.channelPoint.data,
                balance: balance
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
const getChannelPointUpdaterInitialState = ()=>({
        channelPointUpdater: {
            balance: 0,
            delta: 0,
            reason: null
        }
    });
const channelPointUpdater = (0, $ki1Eq.reducerWithInitialState)(getChannelPointUpdaterInitialState());
channelPointUpdater.case(updateChannelPointBalance, (state, payload)=>({
        ...state,
        channelPointUpdater: {
            ...payload
        }
    }));
channelPointUpdater.case(clearChannelPointUpdater, (state)=>getChannelPointUpdaterInitialState());
const getChannelPollInitialState = ()=>({
        channelPoll: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelPoll = (0, $ki1Eq.reducerWithInitialState)(getChannelPollInitialState());
applyAsyncReducer()("channelPoll", "networkStatus", getChannelPoll.async, channelPoll, (props)=>props.result);
applyAsyncReducer()("channelPoll", "networkStatus", getChannelPollManage.async, channelPoll, (props)=>props.result);
channelPoll.case(getChannelPoll.async.done, (store2, { result: result2 })=>({
        ...store2,
        channelPoll: {
            data: result2,
            meta: {
                ...store2.channelPoll.meta,
                networkStatus: getNetworkStatusDone$1()
            }
        }
    }));
channelPoll.case(getChannelPoll.async.failed, (store2, { error: error2 })=>({
        ...store2,
        channelPoll: {
            data: null,
            meta: {
                ...store2.channelPoll.meta,
                networkStatus: getNetworkStatusFailed$1(error2)
            }
        }
    }));
channelPoll.case(clearChannelPoll, (store2)=>{
    return {
        ...store2,
        channelPoll: {
            data: null,
            meta: {
                ...store2.channelPoll.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    };
});
channelPoll.case(setVoteChannelPoll, (state, { decisionId })=>{
    var _a3, _b2, _c2, _d;
    const hasVote = (_b2 = (_a3 = state.channelPoll.data) == null ? void 0 : _a3.decisions) == null ? void 0 : _b2.some((item2)=>item2.previousDecision);
    return {
        ...state,
        channelPoll: {
            ...state.channelPoll,
            data: {
                ...state.channelPoll.data,
                decisions: state.channelPoll.data.decisions.map((decision2)=>decision2.id === decisionId ? {
                        ...decision2,
                        votesCount: (decision2.votesCount || 0) + 1,
                        votersCount: !decision2.previousDecision ? (decision2.votersCount || 0) + 1 : decision2.votersCount,
                        userVotesCount: (decision2.userVotesCount || 0) + 1,
                        previousDecision: true
                    } : decision2),
                votesCount: (((_c2 = state.channelPoll.data) == null ? void 0 : _c2.votesCount) || 0) + 1,
                votersCount: !hasVote ? (((_d = state.channelPoll.data) == null ? void 0 : _d.votersCount) || 0) + 1 : state.channelPoll.data.votersCount
            }
        }
    };
}).case(unsetVoteChannelPoll, (state, { decisionId })=>{
    var _a3;
    const decision2 = (_a3 = state.channelPoll.data) == null ? void 0 : _a3.decisions.find((item2)=>item2.id === decisionId);
    let { votesCount, votersCount, userVotesCount, previousDecision } = decision2;
    let { votesCount: votesCountOfVote, votersCount: votersCountOfVote } = state.channelPoll.data || {};
    if (decision2 && decision2.previousDecision && decision2.userVotesCount === 1) {
        votersCount -= 1;
        previousDecision = false;
        votersCountOfVote -= 1;
    }
    votesCount -= 1;
    userVotesCount -= 1;
    votesCountOfVote -= 1;
    return {
        ...state,
        channelPoll: {
            ...state.channelPoll,
            data: {
                ...state.channelPoll.data,
                decisions: state.channelPoll.data.decisions.map((item2)=>item2.id === decisionId ? {
                        ...item2,
                        votesCount: votesCount,
                        votersCount: votersCount,
                        userVotesCount: userVotesCount,
                        previousDecision: previousDecision
                    } : item2),
                votesCount: votesCountOfVote,
                votersCount: votersCountOfVote
            }
        }
    };
});
channelPoll.case(setChannelPoll, (state, { poll })=>({
        ...state,
        channelPoll: {
            data: {
                ...poll
            },
            meta: {
                ...state.channelPoll.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    })).case(mergeChannelPoll, (state, { data })=>{
    const stateData = {
        ...state.channelPoll.data,
        ...data,
        decisions: [
            ...state.channelPoll.data.decisions.map((item2)=>{
                const incomeDecision = data.decisions.find((incDes)=>incDes.id === item2.id);
                if (incomeDecision) return {
                    ...item2,
                    ...incomeDecision
                };
                return item2;
            })
        ]
    };
    return {
        ...state,
        channelPoll: {
            ...state.channelPoll,
            data: {
                ...stateData
            }
        }
    };
});
const calculateProportion = (predictionPointsBank, pointsBank)=>{
    if (!pointsBank) return 0;
    return Math.round(predictionPointsBank / pointsBank * 100) / 100;
};
const getChannelPredictionInitialState = ()=>({
        channelPrediction: {
            prediction: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            },
            isVisible: false
        }
    });
const channelPrediction = (0, $ki1Eq.reducerWithInitialState)(getChannelPredictionInitialState());
channelPrediction.case(fetchPrediction.async.done, (store2, { result: result2 })=>{
    return {
        ...store2,
        channelPrediction: {
            prediction: {
                data: result2,
                meta: {
                    ...store2.channelPrediction.prediction.meta,
                    networkStatus: getNetworkStatusDone$1()
                }
            },
            isVisible: true
        }
    };
});
channelPrediction.case(fetchPrediction.async.failed, (store2, { error: error2 })=>{
    return {
        ...store2,
        channelPrediction: {
            prediction: {
                data: null,
                meta: {
                    ...store2.channelPrediction.prediction.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            },
            isVisible: false
        }
    };
});
channelPrediction.case(deletePrediction.async.done, (store2)=>{
    return {
        ...store2,
        channelPrediction: {
            prediction: {
                data: null,
                meta: {
                    ...store2.channelPrediction.prediction.meta,
                    networkStatus: getNetworkStatusDone$1()
                }
            },
            isVisible: false
        }
    };
});
channelPrediction.case(deletePrediction.async.failed, (store2, { error: error2 })=>{
    return {
        ...store2,
        channelPrediction: {
            prediction: {
                data: {
                    ...store2.channelPrediction.prediction.data
                },
                meta: {
                    ...store2.channelPrediction.prediction.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            },
            isVisible: store2.channelPrediction.isVisible
        }
    };
});
channelPrediction.case(clearPrediction, ()=>getChannelPredictionInitialState());
channelPrediction.case(decisionPredictionVoice, (state, { id, amount })=>{
    const predictionPointsBank = (state.channelPrediction.prediction.data.pointsBank || 0) + amount;
    return {
        channelPrediction: {
            prediction: {
                data: {
                    ...state.channelPrediction.prediction.data,
                    decisions: state.channelPrediction.prediction.data.decisions.map((item2)=>{
                        if (item2.id === id) {
                            const pointsBank = item2.pointsBank + amount;
                            const userAmount = !item2.previousDecision ? item2.userAmount + 1 : item2.userAmount;
                            const userBid = (item2.userBid || 0) + amount;
                            const proportion = calculateProportion(predictionPointsBank, pointsBank);
                            return {
                                ...item2,
                                userAmount: userAmount,
                                previousDecision: true,
                                pointsBank: pointsBank,
                                proportion: proportion,
                                userBid: userBid
                            };
                        } else {
                            const proportion = calculateProportion(predictionPointsBank, item2.pointsBank);
                            return {
                                ...item2,
                                proportion: proportion
                            };
                        }
                    }),
                    pointsBank: predictionPointsBank
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: state.channelPrediction.isVisible
        }
    };
});
channelPrediction.case(unsetPreviousDecisionPrediction, (state, { id })=>({
        channelPrediction: {
            prediction: {
                data: {
                    ...state.channelPrediction.prediction.data,
                    decisions: state.channelPrediction.prediction.data.decisions.map((item2)=>{
                        if (item2.id === id) {
                            const userAmount = item2.userAmount - 1;
                            return {
                                ...item2,
                                userAmount: userAmount,
                                previousDecision: false
                            };
                        }
                        return item2;
                    })
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: state.channelPrediction.isVisible
        }
    }));
channelPrediction.case(subtractVoicePrediction, (state, { id, amount })=>{
    var _a3;
    const predictionPointsBank = state.channelPrediction.prediction.data.pointsBank - amount;
    return {
        channelPrediction: {
            prediction: {
                data: {
                    ...state.channelPrediction.prediction.data,
                    decisions: (((_a3 = state.channelPrediction.prediction.data) == null ? void 0 : _a3.decisions) || []).map((item2)=>{
                        if (item2.id === id) {
                            const pointsBank = item2.pointsBank - amount;
                            const userBid = item2.userBid - amount;
                            const proportion = calculateProportion(predictionPointsBank, pointsBank);
                            return {
                                ...item2,
                                pointsBank: pointsBank,
                                proportion: proportion,
                                userBid: userBid
                            };
                        } else {
                            const proportion = calculateProportion(predictionPointsBank, item2.pointsBank);
                            return {
                                ...item2,
                                proportion: proportion
                            };
                        }
                    }),
                    pointsBank: state.channelPrediction.prediction.data.pointsBank - amount
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: state.channelPrediction.isVisible
        }
    };
});
channelPrediction.case(setStatePrediction, (store2, { state })=>({
        channelPrediction: {
            prediction: {
                data: {
                    ...store2.channelPrediction.prediction.data,
                    state: state
                },
                meta: {
                    ...store2.channelPrediction.prediction.meta
                }
            },
            isVisible: store2.channelPrediction.isVisible
        }
    }));
channelPrediction.case(setPrediction, (state, { data })=>{
    if (data.bid) data.decisions = data.decisions.map((item2)=>({
            ...item2,
            userBid: data.bid.userBid,
            previousDecision: data.bid.decisionId === item2.id
        }));
    return {
        channelPrediction: {
            prediction: {
                data: data,
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: data.state !== EPredictionStatus.CANCELED
        }
    };
});
channelPrediction.case(mergePrediction, (state, { data })=>{
    const stateData = merge$1(state.channelPrediction.prediction.data, data);
    return {
        channelPrediction: {
            prediction: {
                data: {
                    ...stateData
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: data.state !== EPredictionStatus.CANCELED
        }
    };
});
channelPrediction.case(setWinnerPrediction, (state, { id })=>({
        channelPrediction: {
            prediction: {
                data: {
                    ...state.channelPrediction.prediction.data,
                    state: EPredictionStatus.ENDED,
                    decisions: state.channelPrediction.prediction.data.decisions.map((item2)=>item2.id === id ? {
                            ...item2,
                            isWinner: true
                        } : item2)
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: state.channelPrediction.isVisible
        }
    }));
channelPrediction.case(unsetWinnerPrediction, (state, { id })=>({
        channelPrediction: {
            prediction: {
                data: {
                    ...state.channelPrediction.prediction.data,
                    state: EPredictionStatus.DECISION,
                    decisions: state.channelPrediction.prediction.data.decisions.map((item2)=>item2.id === id ? {
                            ...item2,
                            isWinner: false
                        } : item2)
                },
                meta: {
                    ...state.channelPrediction.prediction.meta
                }
            },
            isVisible: state.channelPrediction.isVisible
        }
    }));
channelPrediction.case(setVisibilityPrediction, (state, { isVisible })=>({
        channelPrediction: {
            prediction: {
                ...state.channelPrediction.prediction
            },
            isVisible: isVisible
        }
    }));
const getChannelInitialState = ()=>({
        channel: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createNetworkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const applyClearChannelReducer = (channelReducer)=>{
    channelReducer.withHandling(immerCase(clearChannel, (newState)=>{
        newState.channel = getChannelInitialState().channel;
    }));
};
const applyCreateChannelReducer = (channelReducer)=>{
    channelReducer.withHandling(immerCase(createChannel.async.started, (newState)=>{
        newState.channel.data = null;
        newState.channel.meta.createNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createChannel.async.done, (newState, { result: result2 })=>{
        newState.channel.meta.createNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createChannel.async.failed, (newState, { error: error2 })=>{
        newState.channel.meta.createNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const channel = (0, $ki1Eq.reducerWithInitialState)(getChannelInitialState());
applyClearChannelReducer(channel);
applyCreateChannelReducer(channel);
const getChannelStatInitialState = ()=>({
        basicStat: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelStat = (0, $ki1Eq.reducerWithInitialState)(getChannelStatInitialState());
applyAsyncReducer()("basicStat", "networkStatus", fetchChannelBasicStat.async, channelStat, (props)=>props.result);
channelStat.case(updateChannelSubscribersStat, (state, { followersCount, paidSubscribersCount })=>({
        ...state,
        basicStat: {
            ...state.basicStat,
            data: {
                ...state.basicStat.data,
                followersCount: followersCount,
                paidSubscribersCount: paidSubscribersCount
            }
        }
    }));
const chatBotReducerFetchCommandsList = (chatBot2)=>{
    applyAsyncReducer()("commands", "networkStatus", fetchCommandsList.async, chatBot2, ({ store: store2, result: result2 })=>({
            data: (store2.commands.data.data || []).concat(result2.commands),
            extra: result2.extra
        }));
};
const chatBotReducerCreateCommand = (chatBot2)=>{
    chatBot2.withHandling(immerCase(createCommand.async.started, (newState)=>{
        newState.currentCommand.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createCommand.async.done, (newState, { result: result2, params })=>{
        newState.commands.data.data = [
            ...newState.commands.data.data || [],
            result2.data
        ];
        newState.currentCommand.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createCommand.async.failed, (newState, { error: error2 })=>{
        newState.currentCommand.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const chatBotReducerEditCommand = (chatBot2)=>{
    chatBot2.withHandling(immerCase(editCommand.async.started, (newState)=>{
        newState.currentCommand.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editCommand.async.done, (newState, { result: result2, params })=>{
        newState.commands.data.data = (newState.commands.data.data || []).map((item2)=>{
            if (item2.id === params.commandId) item2 = result2.data;
            return item2;
        });
        newState.currentCommand.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(editCommand.async.failed, (newState, { error: error2 })=>{
        newState.currentCommand.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const chatBotReducerDeleteCommand = (chatBot2)=>{
    applyAsyncReducer()("commands", "networkStatus", deleteCommand.async, chatBot2, ({ store: store2, params })=>({
            ...store2.commands.data,
            data: (store2.commands.data.data || []).filter((item2)=>item2.id !== params.id)
        }));
};
const chatBotReducerFetchCommand = (chatBot2)=>{
    applyAsyncReducer()("currentCommand", "networkStatus", fetchCommand.async, chatBot2, ({ store: store2, result: result2 })=>({
            data: result2.data
        }));
};
const chatBotReducerClearCommand = (chatBot2)=>{
    chatBot2.case(clearCommand, (state)=>({
            ...state,
            currentCommand: {
                data: {
                    data: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const chatBotReducerClearCommands = (chatBot2)=>{
    chatBot2.case(clearCommands, (state)=>({
            ...state,
            commands: {
                data: {
                    data: null,
                    extra: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const chatBotReducerToggleCommand = (chatBot2)=>{
    chatBot2.withHandling(immerCase(toggleCommand.async.done, (newState, { result: result2, params })=>{
        newState.commands.data.data = (newState.commands.data.data || []).map((item2)=>{
            if (item2.id === params.commandId) item2.isActive = !params.isActive;
            return item2;
        });
    }));
};
const chatBotReducerClearTimers = (chatBot2)=>{
    chatBot2.case(clearTimers, (state)=>({
            ...state,
            timers: {
                data: {
                    data: null,
                    extra: {
                        after: null
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const chatBotReducerFetchTimers = (chatBot2)=>{
    applyAsyncReducer()("timers", "networkStatus", fetchTimers.async, chatBot2, ({ store: store2, result: result2 })=>({
            data: (store2.timers.data.data || []).concat(result2.timers),
            extra: result2.extra
        }));
};
const chatBotReducerCreateTimer = (chatBot2)=>{
    applyAsyncReducer()("timers", "networkStatus", createTimer.async, chatBot2, ({ store: store2, result: result2 })=>({
            ...store2.timers.data,
            data: [
                ...store2.timers.data.data,
                result2.timer
            ]
        }));
};
const chatBotReducerEditTimer = (chatBot2)=>{
    applyAsyncReducer()("timers", "networkStatus", editTimer.async, chatBot2, ({ store: store2, params, result: result2 })=>({
            ...store2.timers.data,
            data: (store2.timers.data.data || []).map((item2)=>{
                if (item2.id === params.timerId) item2 = result2.timer;
                return item2;
            })
        }));
};
const chatBotReducerDeleteTimer = (chatBot2)=>{
    applyAsyncReducer()("timers", "networkStatus", deleteTimer.async, chatBot2, ({ store: store2, params })=>({
            ...store2.timers.data,
            data: (store2.timers.data.data || []).filter((item2)=>item2.id !== params.timerId)
        }));
};
const getChatBotInitialState = ()=>({
        timers: {
            data: {
                data: null,
                extra: {
                    after: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        commands: {
            data: {
                data: null,
                extra: {
                    isLast: false,
                    offset: 0
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentCommand: {
            data: {
                data: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const chatBot = (0, $ki1Eq.reducerWithInitialState)(getChatBotInitialState());
chatBotReducerClearTimers(chatBot);
chatBotReducerFetchTimers(chatBot);
chatBotReducerCreateTimer(chatBot);
chatBotReducerEditTimer(chatBot);
chatBotReducerDeleteTimer(chatBot);
chatBotReducerFetchCommandsList(chatBot);
chatBotReducerDeleteCommand(chatBot);
chatBotReducerFetchCommand(chatBot);
chatBotReducerClearCommand(chatBot);
chatBotReducerCreateCommand(chatBot);
chatBotReducerEditCommand(chatBot);
chatBotReducerClearCommands(chatBot);
chatBotReducerToggleCommand(chatBot);
const getChatInitialState = ()=>({
        selectedSmile: null,
        module: {
            [EChatModule.STREAM]: {},
            [EChatModule.MENTIONS]: {},
            [EChatModule.HISTORY]: {},
            [EChatModule.RECORD]: {}
        },
        userChatHistories: {
            data: {
                queue: [],
                list: {}
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        recordChat: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        recordChatCurrentIndex: 0
    });
const chat$2 = (0, $ki1Eq.reducerWithInitialState)(getChatInitialState());
chat$2.withHandling(immerCase(selectSmileInfoChatAction, (newState, { smile: smile2 })=>{
    newState.selectedSmile = smile2;
}));
chat$2.withHandling(immerCase(clearSmileInfoChat, (newState)=>{
    newState.selectedSmile = null;
}));
applyAsyncReducer()("userChatHistories", "networkStatus", fetchUserChatHistory.async, chat$2, ({ store: store2, result: result2, params })=>{
    var _a3;
    const userChatHistory = (_a3 = store2.userChatHistories.data.list[params.userId]) == null ? void 0 : _a3.messages;
    const isUserChatHistoryExists = Boolean(userChatHistory);
    const userIdToErase = store2.userChatHistories.data.queue[0];
    const newList = {
        ...store2.userChatHistories.data.list,
        [params.userId]: {
            messages: isUserChatHistoryExists ? [
                ...userChatHistory,
                ...result2.data
            ] : result2.data,
            isLast: result2.extra.isLast
        }
    };
    if (isUserChatHistoryExists) return {
        ...store2.userChatHistories.data,
        list: newList
    };
    if (userIdToErase) delete newList[userIdToErase];
    return {
        list: newList,
        queue: [
            ...store2.userChatHistories.data.queue.slice(1),
            params.userId
        ]
    };
});
chat$2.withHandling(immerCase(addMessageToChatHistory, (newState, { message: message2 })=>{
    if (isChatSystemMessage(message2)) return;
    const userIdsWithHistories = Object.keys(newState.userChatHistories.data.list);
    if (userIdsWithHistories.includes(String(message2.author.id))) newState.userChatHistories.data.list[message2.author.id].messages = [
        message2,
        ...newState.userChatHistories.data.list[message2.author.id].messages
    ];
}));
chat$2.withHandling(immerCase(clearUserChatHistory, (newState)=>{
    newState.userChatHistories = getChatInitialState().userChatHistories;
}));
chat$2.withHandling(immerCase(clearRecordChat, (newState)=>{
    newState.recordChat = getChatInitialState().recordChat;
    newState.recordChatCurrentIndex = getChatInitialState().recordChatCurrentIndex;
}));
chat$2.withHandling(immerCase(setRecordChatCurrentIndex, (newState, payload)=>{
    var _a3, _b2;
    newState.recordChatCurrentIndex = payload;
    const messagesStoreLimit = (_b2 = (_a3 = getConfig()) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.messagesStoreLimit;
    const hasChatStoreLimit = isConditionalFeatureEnable(EConditionalFeature.CHAT_STORE_LIMIT);
    const shouldTrunkMessagesList = hasChatStoreLimit && messagesStoreLimit && newState.recordChatCurrentIndex > messagesStoreLimit;
    if (shouldTrunkMessagesList) {
        const messagesToTrunk = newState.recordChatCurrentIndex - messagesStoreLimit;
        const newIndex = newState.recordChatCurrentIndex - messagesToTrunk;
        newState.recordChatCurrentIndex = newIndex > 0 ? newIndex : 0;
        newState.recordChat.data.data = newState.recordChat.data.data.slice(messagesToTrunk);
    }
}));
chat$2.withHandling(immerCase(clearMessagesHoverElements, (newState, payload)=>{
    const { module: module2, messageIds } = payload;
    if (!messageIds) {
        newState.module[module2].messages = {};
        return;
    }
    messageIds.forEach((messageId)=>{
        if (newState.module[module2].messages[messageId]) delete newState.module[module2].messages[messageId];
    });
}));
chat$2.case(fetchRecordChat.async.started, (state, payload)=>{
    return {
        ...state,
        recordChat: {
            ...state.recordChat,
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    };
}).case(fetchRecordChat.async.failed, (state, payload)=>{
    return {
        ...state,
        recordChat: {
            ...state.recordChat,
            meta: {
                networkStatus: getNetworkStatusFailed$1(payload.error)
            }
        }
    };
}).case(fetchRecordChat.async.done, (store2, payload)=>{
    var _a3, _b2;
    const result2 = payload.result;
    const params = payload.params;
    const isResetData = Boolean(params == null ? void 0 : params.timeCode) && !Boolean(params == null ? void 0 : params.lastMessageId) && !Boolean(params == null ? void 0 : params.offset);
    if (isResetData) {
        const index2 = result2.data.findLastIndex((element)=>element.timeCode <= params.timeCode);
        return {
            ...store2,
            recordChatCurrentIndex: index2 >= 0 ? index2 : 0,
            recordChat: {
                ...store2.recordChat,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                },
                data: {
                    data: result2.data,
                    extra: result2.extra
                }
            }
        };
    }
    if (result2.data.length === 0) return {
        ...store2,
        recordChat: {
            ...store2.recordChat,
            data: {
                ...store2.recordChat.data,
                extra: {
                    ...(_a3 = store2.recordChat.data) == null ? void 0 : _a3.extra,
                    isLast: true
                }
            },
            meta: {
                networkStatus: getNetworkStatusDone$1()
            }
        }
    };
    return {
        ...store2,
        recordChat: {
            ...store2.recordChat,
            meta: {
                networkStatus: getNetworkStatusDone$1()
            },
            data: {
                data: [
                    ...((_b2 = store2.recordChat.data) == null ? void 0 : _b2.data) ?? [],
                    ...result2.data
                ],
                extra: result2.extra
            }
        }
    };
});
chat$2.case(fetchClipChat.async.started, (state, payload)=>{
    return {
        ...state,
        recordChat: {
            ...state.recordChat,
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    };
}).case(fetchClipChat.async.failed, (state, payload)=>{
    return {
        ...state,
        recordChat: {
            ...state.recordChat,
            meta: {
                networkStatus: getNetworkStatusFailed$1(payload.error)
            }
        }
    };
}).case(fetchClipChat.async.done, (store2, payload)=>{
    var _a3, _b2;
    const result2 = payload.result;
    const params = payload.params;
    const isResetData = Boolean(params == null ? void 0 : params.timeCode) && !Boolean(params == null ? void 0 : params.lastMessageId) && !Boolean(params == null ? void 0 : params.offset);
    if (isResetData) {
        const index2 = result2.data.findLastIndex((element)=>element.timeCode <= params.timeCode);
        return {
            ...store2,
            recordChatCurrentIndex: index2 >= 0 ? index2 : 0,
            recordChat: {
                ...store2.recordChat,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                },
                data: {
                    data: result2.data,
                    extra: result2.extra
                }
            }
        };
    }
    if (result2.data.length === 0) return {
        ...store2,
        recordChat: {
            ...store2.recordChat,
            data: {
                ...store2.recordChat.data,
                extra: {
                    ...(_a3 = store2.recordChat.data) == null ? void 0 : _a3.extra,
                    isLast: true
                }
            },
            meta: {
                networkStatus: getNetworkStatusDone$1()
            }
        }
    };
    return {
        ...store2,
        recordChat: {
            ...store2.recordChat,
            meta: {
                networkStatus: getNetworkStatusDone$1()
            },
            data: {
                data: [
                    ...((_b2 = store2.recordChat.data) == null ? void 0 : _b2.data) ?? [],
                    ...result2.data
                ],
                extra: result2.extra
            }
        }
    };
});
const getCurrentPollInitialState = ()=>({
        data: null,
        meta: {
            networkStatus: getDefaultNetworkStatus$1()
        },
        stored: false
    });
const currentPoll = (0, $ki1Eq.reducerWithInitialState)(getCurrentPollInitialState()).case(fetchPollUnsubs.async.started, (state)=>({
        ...state,
        meta: {
            ...state.meta,
            networkStatus: getNetworkStatusStarted$1()
        }
    })).case(fetchPollUnsubs.async.done, (state, { result: poll })=>({
        ...state,
        data: poll,
        meta: {
            ...state.meta,
            networkStatus: getNetworkStatusDone$1()
        }
    })).case(fetchPollUnsubs.async.failed, (state, { error: error2 })=>({
        ...state,
        meta: {
            ...state.meta,
            networkStatus: getNetworkStatusFailed$1(error2)
        }
    })).case(clearCurrentPoll, (state)=>({
        ...getCurrentPollInitialState()
    })).case(voteUnsubs.async.done, (state, { result: { succeeded } })=>({
        ...state,
        stored: succeeded
    }));
const currentUserReducerConfirmEmail = (currentUser2)=>{
    currentUser2.case(confirmEmail.async.done, (state, { result: result2 })=>({
            ...state,
            user: {
                ...state.user,
                data: {
                    ...state.user.data,
                    ...result2
                }
            }
        }));
};
const currentUserReducerDismissEmail = (currentUser2)=>{
    currentUser2.case(dismissEmail.async.done, (state, { result: result2 })=>({
            ...state,
            user: {
                ...state.user,
                data: {
                    ...state.user.data,
                    ...result2
                }
            }
        }));
};
const currentUserReducerFetchExternalLinks = (currentUser2)=>{
    currentUser2.withHandling(immerCase(fetchUserCurrentLink.async.started, (newState)=>{
        newState.externalLinks.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchUserCurrentLink.async.done, (newState, { result: result2 })=>{
        newState.externalLinks.data = result2.links;
        newState.externalLinks.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchUserCurrentLink.async.failed, (newState, { error: error2 })=>{
        newState.externalLinks.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const currentUserReducerFetchLinkedBoosty = (currentUserReducer2)=>{
    applyAsyncReducer()("linkedBoosty", "networkStatus", fetchLinkedBoosty.async, currentUserReducer2, (props)=>props.result.data);
};
const currentUserReducerNotifications = (currentUser2)=>{
    currentUser2.case(fetchNotifications.async.started, (state)=>{
        const newState = deepCopy(state);
        newState.notifications.meta.networkStatus = getNetworkStatusStarted$1();
        return newState;
    }).case(fetchNotifications.async.failed, (state, payload)=>{
        const newState = deepCopy(state);
        newState.notifications.meta.networkStatus = getNetworkStatusFailed$1(payload.error);
        return newState;
    }).case(fetchNotifications.async.done, (state, { result: result2 })=>{
        var _a3;
        const newState = deepCopy(state);
        if ((_a3 = newState.user) == null ? void 0 : _a3.data) newState.user.data.counts.unreadStandaloneNotify = result2.count.unread;
        newState.notifications.data = result2;
        newState.notifications.meta.networkStatus = getNetworkStatusDone$1();
        return newState;
    }).case(markNotificationsAsRead.async.done, (state, { result: result2 })=>{
        var _a3;
        const newState = deepCopy(state);
        newState.notifications.data.list = newState.notifications.data.list.map((item2)=>({
                ...item2,
                isRead: true
            }));
        if ((_a3 = newState.user) == null ? void 0 : _a3.data) newState.user.data.counts.unreadStandaloneNotify = result2.newUnreadCount;
        return newState;
    }).case(removeNotification.async.done, (state, { params })=>{
        const newState = deepCopy(state);
        if (newState.notifications.data) newState.notifications.data.list = newState.notifications.data.list.filter((item2)=>item2.id !== params.id);
        return newState;
    }).case(changeUnreadNotificationsCount, (state, count2)=>{
        var _a3;
        const newState = deepCopy(state);
        if ((_a3 = newState.user) == null ? void 0 : _a3.data) newState.user.data.counts.unreadStandaloneNotify = count2;
        return newState;
    });
};
const currentUserReducerNickColor = (reducer)=>{
    reducer.case(updateNicknameColor.async.done, (state, { params })=>({
            ...state,
            user: {
                ...state.user,
                data: {
                    ...state.user.data,
                    nickColor: params.color
                }
            }
        }));
};
const currentUserReducerToggleFlag = (currentUser2)=>{
    currentUser2.withHandling(immerCase(toggleUserFlag.async.done, (newStore, payload)=>{
        const { result: { flag, value: value2 } } = payload;
        switch(flag){
            case EBlogSettingsFlags.HAS_ADULT_CONTENT:
                newStore.user.data.blog.hasAdultContent = value2;
                break;
            case EBlogSettingsFlags.SHOW_POST_DONATION:
                newStore.user.data.blog.showPostDonations = value2;
                break;
        }
    }));
};
const currentUserReducerUpdateBanStatus = (currentUser2)=>{
    currentUser2.case(updateUserBanStatus, (state, { isReadOnly, isTotalBaned })=>{
        return {
            ...state,
            user: {
                ...state.user,
                data: {
                    ...state.user.data,
                    ...isReadOnly !== null && {
                        isReadOnly: isReadOnly
                    },
                    ...isTotalBaned !== null && {
                        isTotalBaned: isTotalBaned
                    }
                }
            }
        };
    });
};
const applyVkPlayMergeTargetClearReducer = (currentUserReducer2)=>{
    currentUserReducer2.withHandling(immerCase(clearVkPlayMergeTarget, (newState)=>{
        newState.vkPlayMergeTargetAccessToken.data = null;
        newState.vkPlayMergeTargetAccessToken.meta.networkStatus = getDefaultNetworkStatus$1();
        newState.vkPlayMergeTargetUser.data = null;
        newState.vkPlayMergeTargetUser.meta.networkStatus = getDefaultNetworkStatus$1();
    }));
};
const applyVkPlayMergeTargetFetchAccessTokenReducer = (currentUserReducer2)=>{
    applyAsyncReducer()("vkPlayMergeTargetAccessToken", "networkStatus", fetchVkPlayMergeTargetAccessToken.async, currentUserReducer2, (props)=>({
            token: props.result.data
        }));
};
const applyVkPlayMergeTargetFetchUserReducer = (currentUserReducer2)=>{
    applyAsyncReducer()("vkPlayMergeTargetUser", "networkStatus", fetchVkPlayMergeTargetUser.async, currentUserReducer2, (props)=>props.result.data);
};
const getCurrentUserInitialState = ()=>({
        user: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                updateNetworkStatus: getDefaultNetworkStatus$1(),
                acceptPrivacyPolicyNetworkStatus: getDefaultNetworkStatus$1(),
                acceptRefPolicyNetworkStatus: getDefaultNetworkStatus$1(),
                uploadAvatarNetworkStatus: getDefaultNetworkStatus$1(),
                fetchTelegramLoginUrlNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        selectedCurrency: null,
        paymentBinds: {
            data: {
                list: [],
                extra: {
                    allowDeleteLastBind: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        phone: {
            data: {
                refPhone: null,
                phone: null,
                expiresIn: null,
                code: null
            },
            meta: {
                refPhoneNetworkStatus: getDefaultNetworkStatus$1(),
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        recaptcha: {
            data: {
                score: null,
                success: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        marketingAlerts: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        notifications: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        notificationSettings: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        linkedBoosty: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        vkPlayMergeTargetAccessToken: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        vkPlayMergeTargetUser: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        managedChannels: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: true
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        externalLinks: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const currentUserReducer = (0, $ki1Eq.reducerWithInitialState)(getCurrentUserInitialState()).case(setCurrentUserStore, (state, { user })=>({
        ...state,
        user: {
            ...state.user,
            data: user,
            meta: {
                ...state.user.meta,
                networkStatus: {
                    isFetching: false,
                    isFetched: true,
                    error: null
                }
            }
        }
    })).case(setCurrentUserPhone, (state, phone)=>{
    var _a3, _b2;
    return {
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                authSource: {
                    ...(_a3 = state.user.data) == null ? void 0 : _a3.authSource,
                    list: ((_b2 = state.user.data) == null ? void 0 : _b2.authSource.list) || []
                }
            }
        },
        phone: {
            ...state.phone,
            data: {
                ...state.phone.data,
                phone: phone
            }
        }
    };
}).case(fetchCurrentUser.async.started, (state)=>({
        ...state,
        user: {
            ...state.user,
            meta: {
                ...state.user.meta,
                networkStatus: {
                    isFetching: true,
                    isFetched: false,
                    error: null
                }
            }
        }
    })).case(fetchCurrentUser.async.failed, (state, { error: error2 })=>({
        ...state,
        user: {
            ...state.user,
            meta: {
                ...state.user.meta,
                networkStatus: {
                    isFetching: false,
                    isFetched: false,
                    error: error2
                }
            }
        }
    })).case(resetCurrentUserStore, getCurrentUserInitialState).case(createBlog.async.done, (state, { params, result: result2 })=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                blogUrl: result2.blogUrl,
                email: params.email
            }
        }
    })).case(removePayBind, (state, payload)=>{
    const newPaymentsState = state.paymentBinds.data.list.filter((bind4)=>bind4.id !== payload.id);
    return {
        ...state,
        paymentBinds: {
            ...state.paymentBinds,
            data: {
                ...state.paymentBinds.data,
                list: newPaymentsState
            }
        }
    };
}).case(editSettings.async.started, (state, payload)=>{
    const { name: name2 } = payload;
    return {
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                name: name2
            }
        }
    };
}).case(fetchTelegramUrl.async.started, (state)=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data
            },
            meta: {
                ...state.user.meta,
                fetchTelegramLoginUrlNetworkStatus: getNetworkStatusStarted$1()
            }
        }
    })).case(fetchTelegramUrl.async.done, (state, { result: { url } })=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                externalApps: {
                    ...state.user.data.externalApps,
                    telegram: {
                        ...state.user.data.externalApps.telegram,
                        loginUrl: url
                    }
                }
            },
            meta: {
                ...state.user.meta,
                fetchTelegramLoginUrlNetworkStatus: getNetworkStatusDone$1()
            }
        }
    })).case(fetchTelegramUrl.async.failed, (state, { error: error2 })=>({
        ...state,
        user: {
            ...state.user,
            meta: {
                ...state.user.meta,
                fetchTelegramLoginUrlNetworkStatus: getNetworkStatusFailed$1(error2)
            }
        }
    })).case(selectCurrency, (state, { currency })=>({
        ...state,
        selectedCurrency: currency,
        paymentBinds: {
            data: {
                list: [],
                extra: {
                    allowDeleteLastBind: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    })).case(clearSelectedCurrency, (state)=>({
        ...state,
        selectCurrency: null
    })).case(turnOnDropCampaigns.async.done, (state)=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                canBeDropCampaignMember: true
            }
        }
    })).case(turnOffDropCampaigns.async.done, (state)=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                canBeDropCampaignMember: false
            }
        }
    })).case(updateUserDialogsSettings.async.done, (state, { params })=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                dialogSettings: params
            }
        }
    })).case(toggleGiftOnlyAsFollower.async.done, (state, { result: result2 })=>{
    var _a3;
    return {
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                receiveGiftSubscriptionsOnlyAsFollower: result2.isChecked ?? Boolean((_a3 = state.user.data) == null ? void 0 : _a3.receiveGiftSubscriptionsOnlyAsFollower)
            }
        }
    };
}).case(setUserFlag, (state, { flag })=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                flags: {
                    ...state.user.data.flags,
                    [flag]: true
                }
            }
        }
    })).case(unsetUserFlag, (state, { flag })=>({
        ...state,
        user: {
            ...state.user,
            data: {
                ...state.user.data,
                flags: {
                    ...state.user.data.flags,
                    [flag]: false
                }
            }
        }
    }));
applyAsyncReducer()("paymentBinds", "networkStatus", fetchPaymentBinds.async, currentUserReducer, ({ result: result2 })=>({
        list: result2.list,
        extra: result2.extra
    }));
applyAsyncReducer()("user", "updateNetworkStatus", updateUserFlag.async, currentUserReducer, ({ result: result2 })=>{
    return result2;
});
applyAsyncReducer()("user", "updateNetworkStatus", updateUserData.async, currentUserReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("user", "acceptPrivacyPolicyNetworkStatus", acceptPrivacyPolicy.async, currentUserReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("user", "acceptRefPolicyNetworkStatus", acceptRefPolicy.async, currentUserReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("user", "uploadAvatarNetworkStatus", uploadUserAvatar.async, currentUserReducer, ({ result: result2 })=>({
        avatarUrl: result2.url,
        hasAvatar: true
    }));
applyAsyncReducer()("phone", "networkStatus", checkPhone.async, currentUserReducer, ({ result: result2 })=>({
        isExist: result2.isExist
    }));
applyAsyncReducer()("phone", "networkStatus", checkPhoneAdditionStatus.async, currentUserReducer, ({ result: result2 })=>({
        canAdd: result2.canAdd
    }));
applyAsyncReducer()("phone", "refPhoneNetworkStatus", fetchCurrentUserPhone.async, currentUserReducer, ({ result: result2 })=>({
        refPhone: result2.refPhone
    }));
applyAsyncReducer()("phone", "networkStatus", updateCurrentUserPhone.async, currentUserReducer, ({ result: result2 })=>({
        phone: result2.phone,
        expiresIn: result2.expiresIn,
        code: result2.code
    }));
applyAsyncReducer()("phone", "networkStatus", approveCurrentUserPhone.async, currentUserReducer);
applyAsyncReducer()("phone", "networkStatus", verifyOldPhone.async, currentUserReducer, // eslint-disable-next-line sonarjs/no-identical-functions
({ result: result2 })=>({
        phone: result2.phone,
        expiresIn: result2.expiresIn,
        code: result2.code
    }));
applyAsyncReducer()("marketingAlerts", "networkStatus", fetchMarketingAlerts.async, currentUserReducer, ({ result: result2 })=>result2.data);
applyAsyncReducer()("managedChannels", "networkStatus", fetchManagedChannels.async, currentUserReducer, ({ result: result2 })=>({
        data: result2.data || [],
        extra: result2.extra
    }));
currentUserReducer.case(cleanManageChannels, (state)=>({
        ...state,
        managedChannels: {
            ...state.managedChannels,
            data: {
                ...state.managedChannels.data,
                data: null,
                extra: {
                    offset: null,
                    isLast: true
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
currentUserReducerDismissEmail(currentUserReducer);
currentUserReducerUpdateBanStatus(currentUserReducer);
currentUserReducerNickColor(currentUserReducer);
currentUserReducerNotifications(currentUserReducer);
currentUserReducerFetchLinkedBoosty(currentUserReducer);
currentUserReducerToggleFlag(currentUserReducer);
currentUserReducerFetchExternalLinks(currentUserReducer);
currentUserReducerConfirmEmail(currentUserReducer);
applyVkPlayMergeTargetClearReducer(currentUserReducer);
applyVkPlayMergeTargetFetchAccessTokenReducer(currentUserReducer);
applyVkPlayMergeTargetFetchUserReducer(currentUserReducer);
const currentUser = currentUserReducer;
const getCustomBlockInitialState = ()=>({
        blocks: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const customBlocks = (0, $ki1Eq.reducerWithInitialState)(getCustomBlockInitialState());
applyAsyncReducer()("blocks", "networkStatus", fetchCustomBlocks.async, customBlocks, ({ result: result2 })=>result2.data);
customBlocks.case(addCustomBlock, (state, { data })=>{
    return {
        ...state,
        blocks: {
            ...state.blocks,
            data: [
                ...state.blocks.data.filter((item2)=>item2.id !== data.id),
                data
            ]
        }
    };
});
customBlocks.case(updateCustomBlock, (state, { data: updatedCustomBlock })=>{
    const { blocks: { data } } = state;
    const newData = data.map((block2)=>block2.id === updatedCustomBlock.id ? updatedCustomBlock : block2);
    return {
        ...state,
        blocks: {
            ...state.blocks,
            data: newData
        }
    };
});
customBlocks.case(removeCustomBlock, (state, { id })=>{
    const { blocks: { data } } = state;
    const newData = data.filter((block2)=>block2.id !== id);
    return {
        ...state,
        blocks: {
            ...state.blocks,
            data: newData
        }
    };
});
customBlocks.case(reorderCustomBlocksByIds, (state, { order })=>{
    const { data: blocks2 } = state.blocks;
    const newBlocks = [];
    const orderHash = order.reduce((a2, v2, index2)=>({
            ...a2,
            [v2]: index2
        }), {});
    blocks2.forEach((customBlock)=>{
        const indexById = orderHash[customBlock.id];
        newBlocks[indexById] = customBlock;
    });
    return {
        ...state,
        blocks: {
            ...state.blocks,
            data: newBlocks
        }
    };
});
customBlocks.case(clearCustomBlocks, (state)=>({
        ...state,
        blocks: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
const dialogueMessageReducer = (dialogue2)=>{
    dialogue2.case(addMessagesFromActiveDialogue, (state, { messages: messages2 })=>{
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            }
        };
    }).case(addNewMessageDialogue, (state, { message: message2 })=>{
        var _a3, _b2;
        if (((_b2 = (_a3 = state.dialogueActive) == null ? void 0 : _a3.data) == null ? void 0 : _b2.id) !== message2.dialogId) return state;
        if (state.messages.data.data.some((el)=>el.id === message2.id)) return state;
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: [
                        ...state.messages.data.data,
                        message2
                    ]
                }
            }
        };
    }).case(updateLastMessageDialogue, (state, { message: message2 })=>{
        const dialogues = state.dialogues.data.data.map((dialogueItem)=>{
            if (dialogueItem.id === message2.dialogId) return {
                ...dialogueItem,
                lastMessage: message2
            };
            return dialogueItem;
        }).sort((a2, b2)=>{
            var _a3, _b2;
            return ((_a3 = b2 == null ? void 0 : b2.lastMessage) == null ? void 0 : _a3.createdAt) - ((_b2 = a2 == null ? void 0 : a2.lastMessage) == null ? void 0 : _b2.createdAt);
        });
        return {
            ...state,
            dialogues: {
                ...state.dialogues,
                data: {
                    ...state.dialogues.data,
                    data: dialogues
                }
            }
        };
    }).case(removeMessageDialogue, (state, { dialogId, messageId })=>{
        const messages2 = state.messages.data.data.map((message22)=>{
            if (message22.id === messageId) return {
                ...message22,
                data: [],
                isDeleted: true
            };
            return message22;
        });
        const message2 = messages2.find((messageItem)=>messageItem.id === messageId);
        const dialogues = state.dialogues.data.data.map((dialogItem)=>{
            var _a3;
            if (dialogItem.id === dialogId && ((_a3 = dialogItem == null ? void 0 : dialogItem.lastMessage) == null ? void 0 : _a3.id) === messageId) return {
                ...dialogItem,
                lastMessage: message2
            };
            return dialogItem;
        });
        return {
            ...state,
            dialogues: {
                ...state.dialogues,
                data: {
                    ...state.dialogues.data,
                    data: dialogues
                }
            },
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            }
        };
    }).case(markAsReadMessageFromWs, (state, { actorId, dialogId, messageId })=>{
        const dialogues = state.dialogues.data.data.map((dialogItem)=>{
            if (dialogItem.id === dialogId && (dialogItem == null ? void 0 : dialogItem.lastMessage.id) === messageId && (dialogItem == null ? void 0 : dialogItem.lastMessage.authorId) !== actorId) return {
                ...dialogItem,
                lastMessage: {
                    ...dialogItem.lastMessage,
                    isRead: true
                }
            };
            return dialogItem;
        });
        const messages2 = state.messages.data.data.map((message2)=>{
            if (message2.id <= messageId && message2.authorId !== actorId) return {
                ...message2,
                isRead: true
            };
            return message2;
        });
        return {
            ...state,
            dialogues: {
                ...state.dialogues,
                data: {
                    ...state.dialogues.data,
                    data: dialogues
                }
            },
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            }
        };
    }).case(messageHasBeenPaid, (state, { dialogId, messageId })=>{
        const dialogues = state.dialogues.data.data.map((dialogueItem)=>{
            if (dialogueItem.id === dialogId && (dialogueItem == null ? void 0 : dialogueItem.lastMessage.id) === messageId) return {
                ...dialogueItem,
                lastMessage: {
                    ...dialogueItem.lastMessage,
                    isPaid: true
                }
            };
            else return dialogueItem;
        });
        const messages2 = state.messages.data.data.map((message2)=>{
            if (message2.id === messageId) return {
                ...message2,
                isPaid: true
            };
            return message2;
        });
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            },
            dialogues: {
                ...state.dialogues,
                data: {
                    ...state.dialogues.data,
                    data: dialogues
                }
            }
        };
    }).case(updateMessage, (state, { message: responseMessage })=>{
        const messages2 = state.messages.data.data.map((message2)=>{
            if (message2.id === responseMessage.id) return {
                ...responseMessage
            };
            return message2;
        });
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            }
        };
    }).case(removeMessageSendingStatus, (state, { dialogId, messageId })=>{
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: state.messages.data.data.filter((message2)=>message2.id !== messageId)
                }
            }
        };
    }).case(setErrorStatusSendingMessage, (state, { dialogId, messageId })=>{
        const messages2 = state.messages.data.data.map((message2)=>{
            if (message2.id === messageId) return {
                ...message2,
                isSending: false,
                isSendingError: true
            };
            return message2;
        });
        return {
            ...state,
            messages: {
                ...state.messages,
                data: {
                    ...state.messages.data,
                    data: messages2
                }
            }
        };
    }).case(chatmateSetIsTypingMessage, (state, { isTyping })=>({
            ...state,
            dialogueActive: {
                ...state.dialogueActive,
                data: {
                    ...state.dialogueActive.data,
                    chatmate: {
                        ...state.dialogueActive.data.chatmate,
                        isTyping: isTyping
                    }
                }
            }
        })).case(sendBroadcastMessage.async.done, (state, { result: result2 })=>({
            ...state,
            recipientsCount: {
                ...state.recipientsCount,
                data: {
                    ...state.recipientsCount.data,
                    recipientsCount: result2.data.recipientsCount,
                    isSending: true
                }
            }
        }));
};
const getDialogueInitialState = ()=>({
        unreadMsgCount: 0,
        dialogueActive: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        dialogues: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        messages: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        messageDonation: null,
        isNeedUpdate: false,
        recipientsCount: {
            data: {
                recipientsCount: 0,
                isSending: false
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        contacts: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        mailingList: {
            data: {
                data: [],
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        chatMateSubscriptionLevels: {
            data: {
                blogUrl: null,
                levels: [],
                subscriptions: [],
                currentLevelId: null,
                nextLevelId: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createNetworkStatus: getDefaultNetworkStatus$1(),
                editNetworkStatus: getDefaultNetworkStatus$1(),
                removeNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        chatMateInfo: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        canWriteDonationMessage: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const dialogueReducer = (0, $ki1Eq.reducerWithInitialState)(getDialogueInitialState()).case(changeMessagesCount, (state, { dialogId, dialogUnreadCounter })=>{
    const dialogues = state.dialogues.data.data.map((dialogue2)=>{
        if (dialogue2.id === dialogId) return {
            ...dialogue2,
            unreadMsgCount: dialogUnreadCounter
        };
        return dialogue2;
    });
    return {
        ...state,
        dialogues: {
            ...state.dialogues,
            data: {
                ...state.dialogues.data,
                data: dialogues
            }
        }
    };
}).case(updateContactBlackListedFromWs, (state, { isBlackListed, userId })=>{
    var _a3, _b2;
    if (!state.dialogueActive) return state;
    if (((_b2 = (_a3 = state.dialogueActive.data) == null ? void 0 : _a3.chatmate) == null ? void 0 : _b2.id) !== userId) return state;
    return {
        ...state,
        dialogueActive: {
            ...state.dialogueActive,
            data: {
                ...state.dialogueActive.data,
                relation: {
                    ...state.dialogueActive.data.relation,
                    isBlackListed: isBlackListed,
                    canWrite: !isBlackListed
                }
            }
        }
    };
}).case(updateDialogueList, (state, { dialogue: dialogue2 })=>{
    const hasUpdateDialog = state.dialogues.data.data.find((dialogItem)=>dialogItem.id === dialogue2.id);
    if (!hasUpdateDialog) return {
        ...state,
        dialogues: {
            ...state.dialogues,
            data: {
                ...state.dialogues.data,
                data: [
                    dialogue2,
                    ...state.dialogues.data.data
                ]
            }
        }
    };
    return {
        ...state
    };
}).case(dialogueBroadcastMessagesDone, (state, { recipientsCount })=>{
    return {
        ...state,
        recipientsCount: {
            ...state.recipientsCount,
            data: {
                recipientsCount: recipientsCount
            }
        }
    };
}).case(updateActiveDialogueRelation, (state, { relation })=>{
    return {
        ...state,
        dialogueActive: {
            ...state.dialogueActive,
            data: {
                ...state.dialogueActive.data,
                relation: relation
            }
        }
    };
}).case(clearMessagesActiveDialogue, (state)=>({
        ...state,
        dialogueActive: {
            ...state.dialogueActive,
            data: null,
            meta: {
                ...state.dialogueActive.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        messages: {
            ...state.messages,
            data: {
                ...state.messages.data,
                data: [],
                extra: null
            },
            meta: {
                ...state.messages.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    })).case(clearContactList, (state)=>({
        ...state,
        contacts: {
            ...state.contacts,
            data: {
                ...state.contacts.data,
                data: [],
                extra: null
            },
            meta: {
                ...state.contacts.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    })).case(clearMailingList, (state)=>({
        ...state,
        mailingList: {
            ...state.mailingList,
            data: {
                ...state.mailingList.data,
                data: [],
                extra: null
            },
            meta: {
                ...state.mailingList.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    })).case(clearDialogueList, (state)=>{
    return {
        ...state,
        dialogues: {
            ...state.dialogues,
            data: {
                ...state.dialogues.data,
                data: [],
                extra: null
            },
            meta: {
                ...state.dialogues.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    };
}).case(saveDonationMessage, (state, { message: message2 })=>({
        ...state,
        messageDonation: message2
    })).case(clearDonationMessage, (state)=>({
        ...state,
        messageDonation: null
    })).case(dialogueListToggleIsNeedUpdate, (state, { isNeedUpdate })=>({
        ...state,
        isNeedUpdate: isNeedUpdate
    }));
dialogueMessageReducer(dialogueReducer);
applyAsyncReducer()("canWriteDonationMessage", "networkStatus", fetchCanWriteWithDonationFlag.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("dialogues", "networkStatus", fetchDialogList.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("dialogues", "networkStatus", fetchDialogListMore.async, dialogueReducer, ({ store: store2, result: result2 })=>({
        ...result2,
        data: [
            ...store2.dialogues.data.data,
            ...result2.data
        ]
    }));
applyAsyncReducer()("messages", "networkStatus", fetchMessagesPart.async, dialogueReducer, ({ store: store2, result: result2 })=>({
        ...result2,
        data: sortBy(unionWith(result2.data, store2.messages.data.data, (a2, b2)=>a2.id === b2.id), "id")
    }));
applyAsyncReducer()("chatMateSubscriptionLevels", "networkStatus", fetchChatMateSubscriptionLevels.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("contacts", "networkStatus", fetchContacts.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("contacts", "networkStatus", fetchContactsMore.async, dialogueReducer, ({ store: store2, result: result2 })=>({
        ...result2,
        data: [
            ...store2.contacts.data.data,
            ...result2.data
        ]
    }));
applyAsyncReducer()("mailingList", "networkStatus", fetchMailingList.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("mailingList", "networkStatus", fetchMailingListMore.async, dialogueReducer, ({ store: store2, result: result2 })=>({
        ...result2,
        data: [
            ...store2.mailingList.data.data,
            ...result2.data
        ]
    }));
applyAsyncReducer()("dialogueActive", "networkStatus", fetchDialogById.async, dialogueReducer, ({ result: result2 })=>result2);
applyAsyncReducer()("dialogueActive", "networkStatus", fetchDialogByUserId.async, dialogueReducer, ({ result: result2 })=>result2);
const dialogue = dialogueReducer;
const donationServiceReducerClearList = (donationService2)=>{
    donationService2.case(clearDonationServiceList, (store2)=>({
            ...store2,
            donationService: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const donationServiceReducerDeleteService = (donationService2)=>{
    donationService2.withHandling(immerCase(deleteDonationService.async.done, (newState, {})=>{
        newState.donationService.data = newState.donationService.data.map((service)=>{
            return {
                ...service,
                isSelected: false,
                params: [
                    {
                        ...service.params[0],
                        value: null
                    }
                ]
            };
        });
    }));
};
const donationServiceReducerFetchList = (donationService2)=>{
    donationService2.withHandling(immerCase(fetchDonationServiceList.async.started, (newState)=>{
        newState.donationService.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchDonationServiceList.async.done, (newState, { result: result2 })=>{
        newState.donationService.data = result2.donationServices;
        newState.donationService.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchDonationServiceList.async.failed, (newState, { error: error2 })=>{
        newState.donationService.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const donationServiceReducerUpdateService = (donationService2)=>{
    donationService2.withHandling(immerCase(updateDonationService.async.done, (newState, { params })=>{
        newState.donationService.data = newState.donationService.data.map((service)=>{
            if (service.id === params.serviceId) return {
                ...service,
                isSelected: true,
                params: [
                    {
                        ...service.params[0],
                        value: params.value[0]
                    }
                ]
            };
            return {
                ...service,
                isSelected: false,
                params: [
                    {
                        ...service.params[0],
                        value: null
                    }
                ]
            };
        });
    }));
};
const getDonationServiceInitialState = ()=>({
        donationService: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const donationService = (0, $ki1Eq.reducerWithInitialState)(getDonationServiceInitialState());
donationServiceReducerClearList(donationService);
donationServiceReducerFetchList(donationService);
donationServiceReducerUpdateService(donationService);
donationServiceReducerDeleteService(donationService);
const getDropCampaignsInitialState = ()=>({
        dropCampaigns: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        dropCampaign: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const claimProductDropCampaignReducer = (reducer)=>{
    applyAsyncReducer()("dropCampaign", "networkStatus", claimDropCampaignProduct.async, reducer, ({ result: result2, store: store2 })=>({
            ...store2.dropCampaign.data,
            ...result2
        }));
};
const clearDropCampaignReducer = (reducer)=>{
    reducer.case(clearDropCampaign, (store2)=>({
            ...store2,
            dropCampaign: getDropCampaignsInitialState().dropCampaign
        }));
};
const clearDropCampaignsReducer = (reducer)=>{
    reducer.case(clearDropCampaigns, getDropCampaignsInitialState);
};
const fetchDropCampaignReducer = (reducer)=>{
    applyAsyncReducer()("dropCampaign", "networkStatus", fetchDropCampaign.async, reducer, ({ result: result2, store: store2 })=>({
            ...store2.dropCampaign.data,
            ...result2
        }));
};
const fetchDropCampaignsReducer = (reducer)=>{
    applyAsyncReducer()("dropCampaigns", "networkStatus", fetchDropCampaigns.async, reducer, ({ result: result2, store: store2 })=>({
            ...store2.dropCampaigns.data,
            ...result2
        }));
};
const dropCampaigns = (0, $ki1Eq.reducerWithInitialState)(getDropCampaignsInitialState());
claimProductDropCampaignReducer(dropCampaigns);
clearDropCampaignReducer(dropCampaigns);
clearDropCampaignsReducer(dropCampaigns);
fetchDropCampaignReducer(dropCampaigns);
fetchDropCampaignsReducer(dropCampaigns);
const clearDropRewardReducer = (reducer)=>{
    reducer.withHandling(immerCase(clearDropRewards, (newState, payload)=>{
        newState.drop.data.progress = newState.drop.data.progress.filter((dropProgress)=>!payload.dropCampaignIds.includes(dropProgress.campaign.id));
    }));
};
const clearDropRewardToShowReducer = (reducer)=>{
    reducer.withHandling(immerCase(clearDropRewardsToShow, (newState, payload)=>{
        newState.drop.meta.networkStatus = getDefaultNetworkStatus$1();
        if (payload.dropProductIdsToShow === void 0) {
            newState.dropProductsToShow = [];
            return;
        }
        newState.dropProductsToShow = newState.dropProductsToShow.filter((dropProductToShow)=>!payload.dropProductIdsToShow.includes(dropProductToShow.id));
    }));
};
const clearDropProgressReducer = (reducer)=>{
    reducer.case(clearDropsProgress, (store2)=>({
            drop: {
                data: {
                    ...store2.drop.data,
                    progress: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            },
            dropProductsToShow: store2.dropProductsToShow,
            campaignExternalLink: ""
        }));
};
const fetchDropsProgressReducer = (reducer)=>{
    applyAsyncReducer()("drop", "networkStatus", fetchDropsProgress.async, reducer, ({ result: result2, store: store2 })=>({
            ...store2.drop.data,
            progress: result2.dropProgresses
        }));
};
const requestDropRewardsReducer = (reducer)=>{
    reducer.withHandling(immerCase(requestDropRewards.async.started, (newState, payload)=>{
        newState.drop.meta.networkStatus.isFetching = true;
    })).withHandling(immerCase(requestDropRewards.async.done, (newState, payload)=>{
        const { params: { dropCampaignId, ruleId }, result: { dropProgress: { campaign: { rules } } } } = payload;
        newState.drop.meta.networkStatus.isFetching = false;
        newState.drop.meta.networkStatus.isFetched = true;
        const requestedDropIndex = newState.drop.data.progress.findIndex((element)=>{
            return element.campaign.id === dropCampaignId;
        });
        newState.drop.data.progress[requestedDropIndex] = payload.result.dropProgress;
        const requestedRule = rules.find((rule)=>rule.id === ruleId);
        const filteredProducts = requestedRule == null ? void 0 : requestedRule.products.filter((product)=>{
            let allowed = true;
            newState.dropProductsToShow.forEach((element)=>{
                if (element.id === product.id) allowed = false;
            });
            return allowed;
        });
        newState.dropProductsToShow.push(...filteredProducts || []);
        newState.campaignExternalLink = payload.result.dropProgress.campaign.externalLink;
    })).withHandling(immerCase(requestDropRewards.async.failed, (newState, payload)=>{
        const { params: { dropCampaignId }, error: error2 } = payload;
        newState.drop.meta.networkStatus.error = error2;
        newState.drop.meta.networkStatus.isFetching = false;
        newState.drop.meta.networkStatus.isFetched = true;
        if (error2.serverError.errorDescription) {
            const requestedDropIndex = newState.drop.data.progress.findIndex((element)=>{
                return element.campaign.id === dropCampaignId;
            });
            newState.drop.data.progress[requestedDropIndex].currentRule.products = newState.drop.data.progress[requestedDropIndex].currentRule.products.map((product)=>({
                    ...product,
                    error: error2
                }));
            newState.dropProductsToShow.push(...newState.drop.data.progress[requestedDropIndex].currentRule.products);
            newState.drop.data.progress.splice(requestedDropIndex, 1);
        }
    }));
};
const updateDropProgressReducer = (reducer)=>{
    reducer.case(updateDropsProgress, (store2, { event: event2 })=>{
        const copyEvent = event2.map((progress2)=>{
            var _a3;
            const currentProgressOld = store2.drop.data.progress.find((element)=>element.campaign.id === progress2.campaign.id);
            return {
                ...progress2,
                campaign: {
                    ...progress2.campaign,
                    rules: (_a3 = currentProgressOld == null ? void 0 : currentProgressOld.campaign) == null ? void 0 : _a3.rules
                }
            };
        });
        return {
            ...store2,
            drop: {
                ...store2.drop,
                data: {
                    ...store2.drop.data,
                    // заменяем текущие элементы пришедшими в сокете
                    progress: [
                        ...differenceBy(store2.drop.data.progress, event2, "campaign.id"),
                        ...copyEvent
                    ]
                }
            }
        };
    });
};
const getDropInitialState = ()=>({
        drop: {
            data: {
                progress: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        dropProductsToShow: [],
        campaignExternalLink: ""
    });
const drop = (0, $ki1Eq.reducerWithInitialState)(getDropInitialState());
fetchDropsProgressReducer(drop);
updateDropProgressReducer(drop);
clearDropProgressReducer(drop);
requestDropRewardsReducer(drop);
clearDropRewardReducer(drop);
clearDropRewardToShowReducer(drop);
const getExternalAppsInitialState = ()=>({
        discordRoles: {
            data: {
                list: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        telegramGroups: {
            data: {
                list: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const externalApps = (0, $ki1Eq.reducerWithInitialState)(getExternalAppsInitialState());
applyAsyncReducer()("discordRoles", "networkStatus", fetchDiscordRoles.async, externalApps, ({ result: result2 })=>({
        list: result2.list
    }));
applyAsyncReducer()("telegramGroups", "networkStatus", fetchTelegramGroups.async, externalApps, ({ result: result2 })=>({
        list: result2.list
    }));
const getGiftInitialState = ()=>({
        gifts: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentGift: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        acceptGift: {
            data: {
                succeeded: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const gift = (0, $ki1Eq.reducerWithInitialState)(getGiftInitialState());
applyAsyncReducer()("currentGift", "networkStatus", fetchCurrentGift.async, gift, ({ result: result2 })=>result2);
applyAsyncReducer()("gifts", "networkStatus", fetchGifts.async, gift, ({ result: result2 })=>result2.data);
applyAsyncReducer()("acceptGift", "networkStatus", acceptGift.async, gift, ({ result: result2 })=>({
        succeeded: result2.succeeded
    }));
gift.case(changeAnonymityGift.async.done, (state, payload)=>{
    var _a3;
    return {
        ...state,
        gifts: {
            ...state.gifts,
            data: state.gifts.data.map((storedGift)=>storedGift.key === payload.result.key ? payload.result : storedGift)
        },
        currentGift: {
            ...state.currentGift,
            data: ((_a3 = state.currentGift.data) == null ? void 0 : _a3.key) === payload.result.key ? payload.result : state.currentGift.data
        }
    };
});
gift.case(clearAcceptGiftSucceeded, (state)=>({
        ...state,
        acceptGift: {
            data: {
                succeeded: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
gift.case(clearCurrentGift, (state)=>({
        ...state,
        currentGift: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
const getHostStatusInitialState = ()=>({
        hostStatus: {
            data: {
                hostForStreamer: null,
                state: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const hostStatus = (0, $ki1Eq.reducerWithInitialState)(getHostStatusInitialState());
applyAsyncReducer()("hostStatus", "networkStatus", fetchHostStatus.async, hostStatus, (props)=>props.result.hostStatus);
applyAsyncReducer()("hostStatus", "networkStatus", startHostStream.async, hostStatus, (props)=>({
        hostForStreamer: props.result.hostForStreamer,
        state: EHostStatusState.ALREADY_HOST
    }));
hostStatus.case(stopHostStream.async.done, (state)=>({
        ...state,
        hostStatus: {
            ...state.hostStatus,
            data: {
                ...state.hostStatus.data,
                hostForStreamer: null,
                state: EHostStatusState.FREE
            }
        }
    }));
hostStatus.case(computeHostStatus, (state, stream2)=>({
        ...state,
        data: {
            ...state.hostStatus.data,
            hostForStreamer: (stream2 == null ? void 0 : stream2.hostForStreamer) ?? null,
            state: (stream2 == null ? void 0 : stream2.hostForStreamer) ? EHostStatusState.ALREADY_HOST : (stream2 == null ? void 0 : stream2.isOnline) ? EHostStatusState.HOSTER_ONLINE : EHostStatusState.FREE
        },
        meta: {
            networkStatus: getNetworkStatusDone$1()
        }
    }));
hostStatus.case(clearHostStatus, ()=>getHostStatusInitialState());
const boostyIntegrationReducer = (builder)=>{
    applyAsyncReducer()(EIntegrationType.BOOSTY, "networkStatus", fetchBoostyIntegrationList.async, builder, (props)=>props.result.data);
};
const clearIntegration = (builder)=>{
    builder.withHandling(immerCase(clearIntegrationByType, (newState, payload)=>{
        newState[payload.type] = {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        };
    }));
};
const vkIntegrationReducer = (builder)=>{
    applyAsyncReducer()(EIntegrationType.VK_COMMUNITY, "networkStatus", fetchVkIntegrationList.async, builder, ({ store: store2, result: result2, params })=>params.isRewrite ? result2.data : [
            ...store2[EIntegrationType.VK_COMMUNITY].data ?? [],
            ...result2.data
        ]);
    applyAsyncReducer()(EIntegrationType.VK_COMMUNITY, "networkStatus", linkVkIntegration.async, builder, ({ result: result2 })=>result2.data);
    applyAsyncReducer()(EIntegrationType.VK_COMMUNITY, "networkStatus", unlinkVkIntegration.async, builder, ({ store: store2, params })=>{
        var _a3, _b2;
        return (_b2 = (_a3 = store2.vkCommunity) == null ? void 0 : _a3.data) == null ? void 0 : _b2.reduce((acc, element)=>{
            var _a4;
            let newElement = element;
            if (((_a4 = element.channel) == null ? void 0 : _a4.channelUrl) === params.blogUrl) newElement = {
                ...element,
                channel: null
            };
            acc.push(newElement);
            return acc;
        }, []);
    });
};
const getIntegrationReducerInitialState = ()=>({
        vkCommunity: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        boosty: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const integrations = (0, $ki1Eq.reducerWithInitialState)(getIntegrationReducerInitialState());
vkIntegrationReducer(integrations);
boostyIntegrationReducer(integrations);
clearIntegration(integrations);
const getInternalInitialState = ()=>({
        message: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        donation: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        gift: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        users: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        comments: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const internal = (0, $ki1Eq.reducerWithInitialState)(getInternalInitialState());
applyAsyncReducer()("donation", "networkStatus", fetchInternalDonation.async, internal, ({ result: result2 })=>result2);
applyAsyncReducer()("gift", "networkStatus", fetchInternalGift.async, internal, ({ result: result2 })=>result2);
applyAsyncReducer()("users", "networkStatus", fetchInternalUsers.async, internal, ({ result: result2 })=>result2.data);
applyAsyncReducer()("comments", "networkStatus", fetchInternalComments.async, internal, ({ result: result2 })=>result2.data);
applyAsyncReducer()("message", "networkStatus", fetchInternalMessage.async, internal, ({ result: result2 })=>result2.data);
const getLettersSubscriptionGiftUsersInitialState = ()=>({
        lettersSubscriptionGiftUsers: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const lettersSubscriptionGiftUsers = (0, $ki1Eq.reducerWithInitialState)(getLettersSubscriptionGiftUsersInitialState());
applyAsyncReducer()("lettersSubscriptionGiftUsers", "networkStatus", fetchLettersSubscriptionGiftUsers.async, lettersSubscriptionGiftUsers, (props)=>props.result);
const getMediaDataInitialState = ()=>({
        uploads: {}
    });
const mediaData = (0, $ki1Eq.reducerWithInitialState)(getMediaDataInitialState()).case(uploadImage.async.started, (state, payload)=>{
    const newState = deepCopy(state);
    newState.uploads[payload.image.uploadId] = {
        data: null,
        meta: getNetworkStatusStarted$1(),
        uploadData: payload.image
    };
    return newState;
}).case(uploadImage.async.done, (state, payload)=>{
    const newState = deepCopy(state);
    newState.uploads[payload.params.image.uploadId] = {
        data: payload.result.image,
        meta: getNetworkStatusDone$1(),
        uploadData: payload.params.image
    };
    return newState;
}).case(uploadImage.async.failed, (state, payload)=>{
    const newState = deepCopy(state);
    newState.uploads[payload.params.image.uploadId] = {
        data: null,
        meta: getNetworkStatusFailed$1(payload.error),
        uploadData: payload.params.image
    };
    return newState;
}).case(updateUploads, (state, payload)=>{
    if (!payload.uploadsSucceeded.length) return state;
    const newState = {
        ...state
    };
    payload.uploadsSucceeded.forEach((uploadId)=>{
        delete newState.uploads[uploadId];
    });
    return newState;
});
const getMediaPlayingStateInitialState = ()=>({
        currentMediaId: null
    });
const mediaPlayingState = (0, $ki1Eq.reducerWithInitialState)(getMediaPlayingStateInitialState()).withHandling(immerCase(setCurrentPlayingMedia, (newState, { mediaId })=>{
    newState.currentMediaId = mediaId;
})).withHandling(immerCase(resetCurrentPlayingMedia, (newState)=>{
    newState.currentMediaId = null;
}));
const TIMEOUT = 300;
const moderationLogReducerAddLog = (moderationLog2)=>{
    moderationLog2.withHandling(immerCase(addModerationLogFromWS, (newState, data)=>{
        if (data.eventType === EModerationLogEventType.DELETE_MESSAGE) {
            const lastEvent = newState.moderationLog.data.events[0];
            if (lastEvent && lastEvent.eventType === EModerationLogEventType.DELETE_MESSAGE) {
                const actionTime = lastEvent.actionTime;
                const moderatorId = lastEvent.moderator.id;
                if (data.actionTime - actionTime < TIMEOUT && data.moderator.id === moderatorId) {
                    newState.moderationLog.data.events = newState.moderationLog.data.events.map((event2, index2)=>{
                        if (index2 === 0) return {
                            ...lastEvent,
                            messages: data.messages
                        };
                        return event2;
                    });
                    return;
                }
            }
        }
        newState.moderationLog.data.events = [
            data,
            ...newState.moderationLog.data.events ?? []
        ];
    }));
};
const moderationLogReducerFetchLog = (moderationLog2)=>{
    moderationLog2.withHandling(immerCase(fetchModerationLog.async.started, (newState)=>{
        newState.moderationLog.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchModerationLog.async.done, (newState, { result: result2 })=>{
        newState.moderationLog.data.events = [
            ...newState.moderationLog.data.events || [],
            ...result2.events
        ];
        newState.moderationLog.data.extra = result2.extra;
        newState.moderationLog.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchModerationLog.async.failed, (newState, { error: error2 })=>{
        newState.moderationLog.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getModerationLogInitialState = ()=>({
        moderationLog: {
            data: {
                events: null,
                extra: {
                    after: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const moderationLog = (0, $ki1Eq.reducerWithInitialState)(getModerationLogInitialState());
moderationLogReducerFetchLog(moderationLog);
moderationLogReducerAddLog(moderationLog);
moderationLog.case(clearModerationLog, ()=>getModerationLogInitialState());
const getMultiplicatorsState = ()=>({
        multiplicators: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const multiplicatorsReducer = (0, $ki1Eq.reducerWithInitialState)(getMultiplicatorsState());
applyAsyncReducer()("multiplicators", "networkStatus", fetchMultiplicators.async, multiplicatorsReducer, ({ result: result2 })=>result2);
const multiplicators = multiplicatorsReducer;
const getNewsInitialState = ()=>({
        latestNews: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        lastNews: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const news = (0, $ki1Eq.reducerWithInitialState)(getNewsInitialState());
applyAsyncReducer()("latestNews", "networkStatus", fetchLatestNews.async, news, ({ result: result2 })=>result2);
applyAsyncReducer()("lastNews", "networkStatus", fetchLastNews.async, news, ({ result: result2 })=>result2);
applyAsyncReducer()("latestNews", "networkStatus", viewNews.async, news, ()=>null);
const getNotificationSettingsInitialState = ()=>({
        settings: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        channelSettings: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const notificationSettings = (0, $ki1Eq.reducerWithInitialState)(getNotificationSettingsInitialState());
notificationSettings.withHandling(immerCase(notificationChannelSettingsUpdate.async.done, (state, payload)=>{
    state.channelSettings.data = payload.result.data.data.subscription;
    state.channelSettings.meta.networkStatus = getNetworkStatusDone$1();
}));
notificationSettings.withHandling(immerCase(updateNotificationSettingsFromWS, (state, payload)=>{
    state.channelSettings.data = payload.transports;
    state.channelSettings.meta.networkStatus = getNetworkStatusDone$1();
}));
applyAsyncReducer()("settings", "networkStatus", getNotificationSettings.async, notificationSettings, // eslint-disable-next-line @typescript-eslint/no-explicit-any
({ result: result2 })=>{
    return result2.data.settings;
});
applyAsyncReducer()("channelSettings", "networkStatus", getNotificationChannelSettings.async, notificationSettings, // eslint-disable-next-line @typescript-eslint/no-explicit-any
({ result: result2 })=>{
    return result2.data.data.subscription;
});
const getOverlayPopupInitialState = ()=>({
        currentPopupId: null,
        currentPopupType: null
    });
const overlayPopupState = (0, $ki1Eq.reducerWithInitialState)(getOverlayPopupInitialState()).withHandling(immerCase(setCurrentOpenedPopup, (newState, { popupId, popupType })=>{
    newState.currentPopupId = popupId;
    newState.currentPopupType = popupType;
})).withHandling(immerCase(resetCurrentOpenedPopup, (newState)=>{
    newState.currentPopupId = null;
    newState.currentPopupType = null;
}));
const getOwnChannelPointInitialState = ()=>({
        ownChannelPoint: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const ownChannelPoint = (0, $ki1Eq.reducerWithInitialState)(getOwnChannelPointInitialState());
applyAsyncReducer()("ownChannelPoint", "networkStatus", getOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
applyAsyncReducer()("ownChannelPoint", "networkStatus", createOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
applyAsyncReducer()("ownChannelPoint", "networkStatus", disableOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
applyAsyncReducer()("ownChannelPoint", "networkStatus", enableOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
applyAsyncReducer()("ownChannelPoint", "networkStatus", resetOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
applyAsyncReducer()("ownChannelPoint", "networkStatus", updateOwnChannelPoint.async, ownChannelPoint, (props)=>props.result);
ownChannelPoint.case(clearOwnChannelPoint, ()=>getOwnChannelPointInitialState());
const { currencies } = getConfig();
const getPaymentInitialState = ()=>({
        bank131PageUrl: {
            data: {
                url: null,
                paymentId: null,
                status: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        dmrPageUrl: {
            data: {
                url: null,
                paymentId: null,
                status: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        payWithExistingBind: {
            data: {
                status: null,
                paymentId: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        pollingCheck: {
            data: {
                successful: false
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        paymentInfo: {
            data: {
                onTime: 0,
                periodPayment: 0,
                nextPayTime: 0,
                additionalPayment: 0
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currency: {
            data: {
                defaultCurrency: currencies.default
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const payment = (0, $ki1Eq.reducerWithInitialState)(getPaymentInitialState());
applyAsyncReducer()("bank131PageUrl", "networkStatus", fetchBank131PageUrl.async, payment, (props)=>({
        url: props.result.url,
        paymentId: props.result.paymentId,
        status: props.result.status
    })).case(fetchBank131PageUrl.async.started, (store2)=>({
        ...store2,
        bank131PageUrl: {
            data: {
                ...store2.bank131PageUrl.data,
                url: null
            },
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    }));
applyAsyncReducer()("dmrPageUrl", "networkStatus", fetchDmrPageUrl.async, payment, (props)=>({
        url: props.result.url,
        paymentId: props.result.paymentId,
        status: props.result.status
    })).case(fetchDmrPageUrl.async.started, (store2)=>({
        ...store2,
        dmrPageUrl: {
            data: {
                ...store2.dmrPageUrl.data,
                url: null
            },
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    }));
applyAsyncReducer()("payWithExistingBind", "networkStatus", payWithExistingBind.async, payment, (props)=>({
        paymentId: props.result.paymentId,
        status: props.result.status
    }));
applyAsyncReducer()("pollingCheck", "networkStatus", runCheckPaymentId.async, payment, ({ result: result2 })=>({
        successful: result2.successful
    }));
payment.case(abandonSubscriptionPurchase, (store2)=>({
        ...getPaymentInitialState(),
        currency: store2.currency
    }));
applyAsyncReducer()("paymentInfo", "networkStatus", fetchPaymentInfo.async, payment, ({ result: result2 })=>result2);
applyAsyncReducer()("currency", "networkStatus", fetchDefaultCurrency.async, payment, ({ result: result2 })=>result2);
const playlistReducerDeleteFromHidePlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(deletefromHidePlaylist.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deletefromHidePlaylist.async.done, (newState, { params, result: result2 })=>{
        var _a3;
        newState.playlists.data.data = newState.playlists.data.data.map((item2)=>{
            if (item2.id === params.playlistId) item2.isHidden = false;
            return item2;
        });
        if (((_a3 = newState.currentPlaylist.playlist) == null ? void 0 : _a3.id) === params.playlistId) newState.currentPlaylist.playlist.isHidden = false;
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(deletefromHidePlaylist.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerAddVideo = (playlist2)=>{
    playlist2.withHandling(immerCase(addPlaylistVideo.async.started, (newState)=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(addPlaylistVideo.async.done, (newState, { result: result2, params })=>{
        newState.currentPlaylist.playlist.entityCount = newState.currentPlaylist.playlist.entityCount + result2.playlistEntities.length;
        newState.currentPlaylist.entities.data = [
            ...result2.playlistEntities,
            ...newState.currentPlaylist.entities.data || []
        ];
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(addPlaylistVideo.async.failed, (newState, { error: error2 })=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerClearAvailableRecords = (playlist2)=>{
    playlist2.case(clearAvailableRecords, (state)=>({
            ...state,
            currentPlaylist: {
                ...state.currentPlaylist,
                availableRecords: {
                    data: null,
                    extra: null
                },
                meta: {
                    ...state.currentPlaylist.meta,
                    availableRecordsNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const playlistReducerClearCurrentPlaylist = (playlist2)=>{
    playlist2.case(clearCurrentPlaylist, (state)=>({
            ...state,
            currentPlaylist: {
                playlist: null,
                entities: {
                    playlistId: null,
                    data: null,
                    extra: null
                },
                availableRecords: {
                    data: null,
                    extra: null
                },
                meta: {
                    playlistNetworkStatus: getDefaultNetworkStatus$1(),
                    playlistEntitiesNetworkStatus: getDefaultNetworkStatus$1(),
                    availableRecordsNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const playlistReducerClearCurrentPlaylistEntity = (playlist2)=>{
    playlist2.case(clearCurrentPlaylistEntity, (state)=>({
            ...state,
            currentEntity: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const playlistReducerClearPlaylistEntities = (playlist2)=>{
    playlist2.case(clearCurrentPlaylistEntities, (state)=>({
            ...state,
            currentPlaylist: {
                ...state.currentPlaylist,
                entities: {
                    playlistId: null,
                    data: null,
                    extra: null
                },
                meta: {
                    ...state.currentPlaylist.meta,
                    playlistEntitiesNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const playlistReducerClearPlaylists = (playlist2)=>{
    playlist2.case(clearPlaylists, (state)=>({
            ...state,
            playlists: {
                data: {
                    data: null,
                    extra: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const playlistReducerCreatePlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(createPlaylist.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createPlaylist.async.done, (newState, { params, result: result2 })=>{
        newState.playlists.data.data = [
            result2.playlist,
            ...newState.playlists.data.data || []
        ];
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createPlaylist.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerDeleteFromPlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(deleteFromPlaylist.async.started, (newState)=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deleteFromPlaylist.async.done, (newState, { params, result: result2 })=>{
        newState.currentPlaylist.entities.data = newState.currentPlaylist.entities.data.filter((item2)=>item2.id !== params.entityId);
        newState.currentPlaylist.playlist.entityCount = newState.currentPlaylist.playlist.entityCount - 1;
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(deleteFromPlaylist.async.failed, (newState, { error: error2 })=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerDeletePlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(deletePlaylist.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deletePlaylist.async.done, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(deletePlaylist.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerEditPlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(editPlaylist.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editPlaylist.async.done, (newState, { params, result: result2 })=>{
        var _a3, _b2;
        newState.playlists.data.data = (_a3 = newState.playlists.data.data) == null ? void 0 : _a3.map((item2)=>{
            if (item2.id === params.playlistId) return result2.playlist;
            return item2;
        });
        if (((_b2 = newState.currentPlaylist.playlist) == null ? void 0 : _b2.id) === params.playlistId) newState.currentPlaylist.playlist = result2.playlist;
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(editPlaylist.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerFetchAvailableRecords = (playlist2)=>{
    playlist2.withHandling(immerCase(fetchAvailableRecords.async.started, (newState)=>{
        newState.currentPlaylist.meta.availableRecordsNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchAvailableRecords.async.done, (newState, { result: result2 })=>{
        newState.currentPlaylist.availableRecords.data = [
            ...newState.currentPlaylist.availableRecords.data || [],
            ...result2.records
        ];
        newState.currentPlaylist.availableRecords.extra = result2.extra;
        newState.currentPlaylist.meta.availableRecordsNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchAvailableRecords.async.failed, (newState, { error: error2 })=>{
        newState.currentPlaylist.meta.availableRecordsNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerFetchPlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(fetchPlaylist.async.started, (newState)=>{
        newState.currentPlaylist.meta.playlistNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPlaylist.async.done, (newState, { result: result2 })=>{
        newState.currentPlaylist.playlist = result2.playlist;
        newState.currentPlaylist.meta.playlistNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPlaylist.async.failed, (newState, { error: error2 })=>{
        newState.currentPlaylist.meta.playlistNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerFetchPlaylistEntity = (playlist2)=>{
    playlist2.withHandling(immerCase(fetchPlaylistEntity.async.started, (newState)=>{
        newState.currentEntity.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPlaylistEntity.async.done, (newState, { result: result2 })=>{
        newState.currentEntity.data = result2.playlistEntity;
        newState.currentEntity.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPlaylistEntity.async.failed, (newState, { error: error2 })=>{
        newState.currentEntity.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerFetchPlaylists = (playlist2)=>{
    playlist2.withHandling(immerCase(fetchPlaylists.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPlaylists.async.done, (newState, { result: result2 })=>{
        newState.playlists.data.data = result2.playlists;
        newState.playlists.data.extra = result2.extra;
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPlaylists.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerHidePlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(hidePlaylist.async.started, (newState)=>{
        newState.playlists.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(hidePlaylist.async.done, (newState, { params, result: result2 })=>{
        var _a3;
        newState.playlists.data.data = newState.playlists.data.data.map((item2)=>{
            if (item2.id === params.playlistId) item2.isHidden = true;
            return item2;
        });
        if (((_a3 = newState.currentPlaylist.playlist) == null ? void 0 : _a3.id) === params.playlistId) newState.currentPlaylist.playlist.isHidden = true;
        newState.playlists.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(hidePlaylist.async.failed, (newState, { error: error2 })=>{
        newState.playlists.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const playlistReducerMovePlaylist = (playlist2)=>{
    playlist2.withHandling(immerCase(movePlaylist.async.done, (newState, { params })=>{
        const index2 = newState.playlists.data.data.findIndex((item2)=>item2.id === params.playlistId);
        const moved = newState.playlists.data.data.splice(index2, 1);
        newState.playlists.data.data.splice(params.activeIndex, 0, moved[0]);
    }));
};
const playlistReducerMovePlaylistEntity = (playlist2)=>{
    playlist2.withHandling(immerCase(movePlaylistEntity.async.done, (newState, { params })=>{
        const index2 = newState.currentPlaylist.entities.data.findIndex((item2)=>item2.id === params.entityId);
        const moved = newState.currentPlaylist.entities.data.splice(index2, 1);
        newState.currentPlaylist.entities.data.splice(params.activeIndex, 0, moved[0]);
    }));
};
const playlistReducerPlaylistVideo = (playlist2)=>{
    playlist2.withHandling(immerCase(fetchPlaylistVideo.async.started, (newState)=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchPlaylistVideo.async.done, (newState, { params, result: result2 })=>{
        newState.currentPlaylist.entities.playlistId = params.playlistId;
        newState.currentPlaylist.entities.data = [
            ...newState.currentPlaylist.entities.data || [],
            ...result2.videos
        ];
        newState.currentPlaylist.entities.extra = result2.extra;
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchPlaylistVideo.async.failed, (newState, { error: error2 })=>{
        newState.currentPlaylist.meta.playlistEntitiesNetworkStatus = getNetworkStatusFailed$1(error2);
    })).withHandling(immerCase(editRecord.async.done, (newState, { result: result2 })=>{
        var _a3, _b2, _c2;
        newState.currentPlaylist.entities.data = (_a3 = newState.currentPlaylist.entities.data) == null ? void 0 : _a3.map((item2)=>{
            if (item2.record.id === result2.data.id) return {
                ...item2,
                record: {
                    ...result2.data
                }
            };
            else return item2;
        });
        if (((_c2 = (_b2 = newState.currentEntity.data) == null ? void 0 : _b2.record) == null ? void 0 : _c2.id) === result2.data.id) newState.currentEntity.data.record = result2.data;
    })).withHandling(immerCase(toggleVisibilityRecord.async.done, (newState, { params })=>{
        var _a3, _b2, _c2;
        newState.currentPlaylist.entities.data = (_a3 = newState.currentPlaylist.entities.data) == null ? void 0 : _a3.map((item2)=>{
            if (item2.record.id === params.recordId) return {
                ...item2,
                isHidden: !params.isHidden,
                record: {
                    ...item2.record,
                    isHidden: !params.isHidden
                }
            };
            else return item2;
        });
        if (((_c2 = (_b2 = newState.currentEntity.data) == null ? void 0 : _b2.record) == null ? void 0 : _c2.id) === params.recordId) newState.currentEntity.data.record.isHidden = !params.isHidden;
    })).withHandling(immerCase(updateRecord.async.done, (newState, { params, result: result2 })=>{
        var _a3, _b2, _c2;
        newState.currentPlaylist.entities.data = (_a3 = newState.currentPlaylist.entities.data) == null ? void 0 : _a3.map((item2)=>{
            if (item2.record.id === params.recordId) return {
                ...item2,
                record: result2.data
            };
            return item2;
        });
        if (((_c2 = (_b2 = newState.currentEntity.data) == null ? void 0 : _b2.record) == null ? void 0 : _c2.id) === result2.data.id) newState.currentEntity.data.record = result2.data;
    }));
};
const getPlaylistInitialState = ()=>({
        playlists: {
            data: {
                data: null,
                extra: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentPlaylist: {
            playlist: null,
            entities: {
                playlistId: null,
                data: null,
                extra: null
            },
            availableRecords: {
                data: null,
                extra: null
            },
            meta: {
                playlistNetworkStatus: getDefaultNetworkStatus$1(),
                playlistEntitiesNetworkStatus: getDefaultNetworkStatus$1(),
                availableRecordsNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentEntity: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const playlist = (0, $ki1Eq.reducerWithInitialState)(getPlaylistInitialState());
playlistReducerCreatePlaylist(playlist);
playlistReducerEditPlaylist(playlist);
playlistReducerFetchPlaylist(playlist);
playlistReducerFetchPlaylists(playlist);
playlistReducerFetchAvailableRecords(playlist);
playlistReducerClearAvailableRecords(playlist);
playlistReducerAddVideo(playlist);
playlistReducerPlaylistVideo(playlist);
playlistReducerHidePlaylist(playlist);
playlistReducerDeleteFromHidePlaylist(playlist);
playlistReducerDeletePlaylist(playlist);
playlistReducerDeleteFromPlaylist(playlist);
playlistReducerClearPlaylistEntities(playlist);
playlistReducerClearCurrentPlaylist(playlist);
playlistReducerClearPlaylists(playlist);
playlistReducerFetchPlaylistEntity(playlist);
playlistReducerClearCurrentPlaylistEntity(playlist);
playlistReducerMovePlaylist(playlist);
playlistReducerMovePlaylistEntity(playlist);
const getPostponedRewardInitialState = ()=>({
        postponedReward: null
    });
const postponedReward = (0, $ki1Eq.reducerWithInitialState)(getPostponedRewardInitialState());
postponedReward.case(postponeReward, (state, payload)=>({
        postponedReward: {
            ...payload
        }
    }));
postponedReward.case(clearPostponedReward, ()=>({
        postponedReward: null
    }));
const getPublisherInitialState = ()=>({
        publisherState: {
            focus: false
        }
    });
const publisherState = (0, $ki1Eq.reducerWithInitialState)(getPublisherInitialState());
publisherState.case(focusPublisher, (state, { focus })=>({
        ...state,
        publisherState: {
            focus: focus
        }
    }));
const getRatingProgramInitialState = ()=>({
        currentSeason: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                subscribeNetworkStatus: getDefaultNetworkStatus$1(),
                dailyStatNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        seasonsHistory: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        verificationState: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const ratingProgramReducerClear = (supportProgram2)=>{
    supportProgram2.case(clearRatingProgram, ()=>getRatingProgramInitialState());
};
const ratingProgramReducerFetchCurrentSeason = (ratingProgram2)=>{
    ratingProgram2.withHandling(immerCase(fetchRatingProgramCurrentSeason.async.started, (newState, payload)=>{
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusStarted$1();
        newState.currentSeason.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchRatingProgramCurrentSeason.async.done, (newState, payload)=>{
        newState.currentSeason.data = payload.result.season;
        newState.currentSeason.data.localFinishTime = Date.now() + payload.result.season.timeLeft * MS_PER_SEC;
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusDone$1();
        newState.currentSeason.meta.networkStatus = getNetworkStatusDone$1();
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchRatingProgramCurrentSeason.async.failed, (newState, { error: error2 })=>{
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusFailed$1(error2);
        newState.currentSeason.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const ratingProgramReducerDailyStat = (ratingProgram2)=>{
    applyAsyncReducer()("currentSeason", "dailyStatNetworkStatus", fetchRatingProgramDailyStat.async, ratingProgram2, ({ store: store2, result: result2 })=>{
        var _a3, _b2;
        return {
            ...store2.currentSeason.data,
            blogStatistics: (_b2 = (_a3 = store2.currentSeason.data) == null ? void 0 : _a3.blogStatistics) == null ? void 0 : _b2.map((stat2)=>{
                return result2.blogStatistic.name === stat2.name ? {
                    ...stat2,
                    value: result2.blogStatistic.value,
                    dailies: result2.blogStatistic.details
                } : stat2;
            })
        };
    });
};
const ratingProgramReducerFetchSeasonsHistory = (ratingProgram2)=>{
    applyAsyncReducer()("seasonsHistory", "networkStatus", fetchRatingProgramSeasonsHistory.async, ratingProgram2, ({ store: store2, result: result2 })=>result2.seasons);
};
const ratingProgramReducerVerificationState = (ratingProgram2)=>{
    applyAsyncReducer()("verificationState", "networkStatus", requestVerificationState.async, ratingProgram2, ({ result: result2 })=>{
        return result2.data.data.request;
    });
};
const ratingProgram = (0, $ki1Eq.reducerWithInitialState)(getRatingProgramInitialState());
ratingProgramReducerClear(ratingProgram);
ratingProgramReducerFetchCurrentSeason(ratingProgram);
ratingProgramReducerFetchSeasonsHistory(ratingProgram);
ratingProgramReducerDailyStat(ratingProgram);
ratingProgramReducerVerificationState(ratingProgram);
const recordReducerDeleteRecord = (record2)=>{
    record2.withHandling(immerCase(deleteRecord.async.started, (newState)=>{
        newState.records.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentRecord.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deleteRecord.async.done, (newState, { params, result: result2 })=>{
        if (newState.records.data.data) {
            newState.records.data.data = newState.records.data.data.filter((item2)=>item2.id !== params.recordId);
            newState.records.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(deleteRecord.async.failed, (newState, { error: error2 })=>{
        newState.records.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentRecord.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const recordReducerEditRecord = (record2)=>{
    record2.withHandling(immerCase(editRecord.async.started, (newState)=>{
        newState.records.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentRecord.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editRecord.async.done, (newState, { params, result: result2 })=>{
        if (newState.records.data.data) {
            newState.records.meta.networkStatus = getNetworkStatusDone$1();
            newState.records.data.data = newState.records.data.data.map((item2)=>{
                if (item2.id === result2.data.id) {
                    if (params.cover) result2.data.isCustomPreview = true;
                    if (params.isRemovableCover) result2.data.isCustomPreview = false;
                    return result2.data;
                }
                return item2;
            });
        }
        if (newState.currentRecord.data) {
            newState.currentRecord.data = result2.data;
            newState.currentRecord.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(editRecord.async.failed, (newState, { error: error2 })=>{
        newState.records.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentRecord.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
    record2.withHandling(immerCase(updateRecord.async.started, (newState)=>{
        newState.records.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentRecord.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(updateRecord.async.done, (newState, { params, result: result2 })=>{
        if (newState.records.data.data) {
            newState.records.meta.networkStatus = getNetworkStatusDone$1();
            newState.records.data.data = newState.records.data.data.map((item2)=>{
                if (item2.id === result2.data.id) return result2.data;
                return item2;
            });
        }
        if (newState.currentRecord.data) {
            newState.currentRecord.data = result2.data;
            newState.currentRecord.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(updateRecord.async.failed, (newState, { error: error2 })=>{
        newState.records.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentRecord.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const recordReducerPlaylistRecord = (record2)=>{
    record2.withHandling(immerCase(fetchPlaylistEntity.async.done, (newState, { result: result2 })=>{
        var _a3;
        if (Boolean((_a3 = result2.playlistEntity) == null ? void 0 : _a3.record)) newState.currentRecord.data = result2.playlistEntity.record;
    }));
};
const recordReducerToggleVisibilityRecord = (record2)=>{
    record2.withHandling(immerCase(toggleVisibilityRecord.async.started, (newState)=>{
        newState.records.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentRecord.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(toggleVisibilityRecord.async.done, (newState, { params })=>{
        if (newState.records.data.data) {
            newState.records.meta.networkStatus = getNetworkStatusDone$1();
            newState.records.data.data = newState.records.data.data.map((item2)=>{
                if (item2.id === params.recordId) item2.isHidden = !params.isHidden;
                return item2;
            });
        }
        if (newState.currentRecord.data) {
            newState.currentRecord.data.isHidden = !params.isHidden;
            newState.currentRecord.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(toggleVisibilityRecord.async.failed, (newState, { error: error2 })=>{
        newState.records.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentRecord.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getRecordInitialState = ()=>({
        currentRecord: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        records: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        playerId: ""
    });
const record = (0, $ki1Eq.reducerWithInitialState)(getRecordInitialState());
recordReducerEditRecord(record);
recordReducerToggleVisibilityRecord(record);
recordReducerDeleteRecord(record);
recordReducerPlaylistRecord(record);
applyAsyncReducer()("currentRecord", "networkStatus", fetchRecord.async, record, (props)=>props.result.data);
applyAsyncReducer()("records", "networkStatus", fetchRecords.async, record, ({ store: store2, result: result2, params })=>({
        data: (store2.records.data.data || []).concat(result2.data).filter(({ blog: blog2 })=>blog2.blogUrl === params.blogUrl).reduce((list2, item2)=>[
                ...list2,
                list2.some((e2)=>e2.id === item2.id) ? null : item2
            ], []).filter(Boolean),
        extra: result2.extra
    }));
record.case(viewRecord.async.done, (state)=>({
        ...state,
        currentRecord: {
            ...state.currentRecord,
            data: {
                ...state.currentRecord.data,
                count: {
                    ...state.currentRecord.data.count,
                    views: state.currentRecord.data.count.views + 1
                }
            }
        }
    }));
record.case(clearRecords, (state)=>({
        ...state,
        records: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
record.case(likeRecord.async.done, (state)=>({
        ...state,
        currentRecord: {
            ...state.currentRecord,
            data: {
                ...state.currentRecord.data,
                count: {
                    ...state.currentRecord.data.count,
                    likes: state.currentRecord.data.count.likes + 1
                },
                isLiked: true
            }
        }
    }));
record.case(unlikeRecord.async.done, (state)=>({
        ...state,
        currentRecord: {
            ...state.currentRecord,
            data: {
                ...state.currentRecord.data,
                count: {
                    ...state.currentRecord.data.count,
                    likes: state.currentRecord.data.count.likes - 1
                },
                isLiked: false
            }
        }
    }));
record.case(clearRecord, (state)=>({
        ...state,
        currentRecord: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
record.case(registerRecordPlayer, (state, { playerId })=>({
        ...state,
        playerId: playerId
    }));
record.case(unregisterRecordPlayer, (state)=>({
        ...state,
        playerId: ""
    }));
var dist$2 = {};
var dist$1 = {};
var api$2 = {};
var NerveRequestError$2 = {};
var NerveRequestError$1 = {};
var NerveObject$1 = {};
var utils$2 = {};
var capitalize$2 = {};
var capitalize$1 = {};
Object.defineProperty(capitalize$1, "__esModule", {
    value: true
});
capitalize$1.capitalize = void 0;
var capitalize = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
capitalize$1.capitalize = capitalize;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(capitalize$1, exports2);
})(capitalize$2);
var deviceInfo = {};
var isAndroid$3 = {};
var isAndroid$2 = {};
Object.defineProperty(isAndroid$2, "__esModule", {
    value: true
});
isAndroid$2.isAndroid = void 0;
var isAndroid$1 = function(userAgent) {
    return /android/i.test(userAgent);
};
isAndroid$2.isAndroid = isAndroid$1;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isAndroid$2, exports2);
})(isAndroid$3);
var isIOS$2 = {};
var isIOS$1 = {};
Object.defineProperty(isIOS$1, "__esModule", {
    value: true
});
isIOS$1.isIOS = void 0;
var isIOS = function(userAgent) {
    return /iPad|iPhone|iPod/.test(userAgent);
};
isIOS$1.isIOS = isIOS;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isIOS$1, exports2);
})(isIOS$2);
var isMobile$2 = {};
var isMobile$1 = {};
Object.defineProperty(isMobile$1, "__esModule", {
    value: true
});
isMobile$1.isMobile = void 0;
var isAndroid_1 = isAndroid$3;
var isIOS_1 = isIOS$2;
var isMobile = function(userAgent) {
    return (0, isIOS_1.isIOS)(userAgent) || (0, isAndroid_1.isAndroid)(userAgent);
};
isMobile$1.isMobile = isMobile;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isMobile$1, exports2);
})(isMobile$2);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(isAndroid$3, exports2);
    __exportStar(isIOS$2, exports2);
    __exportStar(isMobile$2, exports2);
})(deviceInfo);
var getURIParams$2 = {};
var getURIParams$1 = {};
Object.defineProperty(getURIParams$1, "__esModule", {
    value: true
});
getURIParams$1.getURIParams = void 0;
var getURIParams = function(params) {
    return Object.keys(params).reduce(function(prev, cur) {
        if (params[cur] == null) return prev;
        if (Array.isArray(params[cur])) {
            var value2 = params[cur].map(function(item2) {
                return "".concat(cur, "[]=").concat(encodeURIComponent(String(item2)));
            }).join("&");
            return "".concat(prev).concat(prev ? "&" : "").concat(value2);
        } else return "".concat(prev).concat(prev ? "&" : "").concat(cur, "=").concat(encodeURIComponent(String(params[cur])));
    }, "");
};
getURIParams$1.getURIParams = getURIParams;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(getURIParams$1, exports2);
})(getURIParams$2);
var htmlEntities$1 = {};
var htmlEntities = {};
Object.defineProperty(htmlEntities, "__esModule", {
    value: true
});
htmlEntities.htmlEntitiesDecode = htmlEntities.htmlEntitiesEncode = void 0;
var htmlEntitiesEncode = function(str) {
    return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};
htmlEntities.htmlEntitiesEncode = htmlEntitiesEncode;
var htmlEntitiesDecode = function(str) {
    return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
};
htmlEntities.htmlEntitiesDecode = htmlEntitiesDecode;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(htmlEntities, exports2);
})(htmlEntities$1);
var Log$1 = {};
var Log = {};
var errorStackParser = {
    exports: {}
};
var stackframe = {
    exports: {}
};
var hasRequiredStackframe;
function requireStackframe() {
    if (hasRequiredStackframe) return stackframe.exports;
    hasRequiredStackframe = 1;
    (function(module2, exports2) {
        (function(root2, factory) {
            module2.exports = factory();
        })(commonjsGlobal, function() {
            function _isNumber(n2) {
                return !isNaN(parseFloat(n2)) && isFinite(n2);
            }
            function _capitalize(str) {
                return str.charAt(0).toUpperCase() + str.substring(1);
            }
            function _getter(p2) {
                return function() {
                    return this[p2];
                };
            }
            var booleanProps = [
                "isConstructor",
                "isEval",
                "isNative",
                "isToplevel"
            ];
            var numericProps = [
                "columnNumber",
                "lineNumber"
            ];
            var stringProps = [
                "fileName",
                "functionName",
                "source"
            ];
            var arrayProps = [
                "args"
            ];
            var objectProps = [
                "evalOrigin"
            ];
            var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
            function StackFrame(obj) {
                if (!obj) return;
                for(var i2 = 0; i2 < props.length; i2++)if (obj[props[i2]] !== void 0) this["set" + _capitalize(props[i2])](obj[props[i2]]);
            }
            StackFrame.prototype = {
                getArgs: function() {
                    return this.args;
                },
                setArgs: function(v2) {
                    if (Object.prototype.toString.call(v2) !== "[object Array]") throw new TypeError("Args must be an Array");
                    this.args = v2;
                },
                getEvalOrigin: function() {
                    return this.evalOrigin;
                },
                setEvalOrigin: function(v2) {
                    if (v2 instanceof StackFrame) this.evalOrigin = v2;
                    else if (v2 instanceof Object) this.evalOrigin = new StackFrame(v2);
                    else throw new TypeError("Eval Origin must be an Object or StackFrame");
                },
                toString: function() {
                    var fileName = this.getFileName() || "";
                    var lineNumber = this.getLineNumber() || "";
                    var columnNumber = this.getColumnNumber() || "";
                    var functionName = this.getFunctionName() || "";
                    if (this.getIsEval()) {
                        if (fileName) return "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                        return "[eval]:" + lineNumber + ":" + columnNumber;
                    }
                    if (functionName) return functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                    return fileName + ":" + lineNumber + ":" + columnNumber;
                }
            };
            StackFrame.fromString = function StackFrame$$fromString(str) {
                var argsStartIndex = str.indexOf("(");
                var argsEndIndex = str.lastIndexOf(")");
                var functionName = str.substring(0, argsStartIndex);
                var args = str.substring(argsStartIndex + 1, argsEndIndex).split(",");
                var locationString = str.substring(argsEndIndex + 1);
                if (locationString.indexOf("@") === 0) {
                    var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, "");
                    var fileName = parts[1];
                    var lineNumber = parts[2];
                    var columnNumber = parts[3];
                }
                return new StackFrame({
                    functionName: functionName,
                    args: args || void 0,
                    fileName: fileName,
                    lineNumber: lineNumber || void 0,
                    columnNumber: columnNumber || void 0
                });
            };
            for(var i = 0; i < booleanProps.length; i++){
                StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
                StackFrame.prototype["set" + _capitalize(booleanProps[i])] = /* @__PURE__ */ function(p2) {
                    return function(v2) {
                        this[p2] = Boolean(v2);
                    };
                }(booleanProps[i]);
            }
            for(var j2 = 0; j2 < numericProps.length; j2++){
                StackFrame.prototype["get" + _capitalize(numericProps[j2])] = _getter(numericProps[j2]);
                StackFrame.prototype["set" + _capitalize(numericProps[j2])] = /* @__PURE__ */ function(p2) {
                    return function(v2) {
                        if (!_isNumber(v2)) throw new TypeError(p2 + " must be a Number");
                        this[p2] = Number(v2);
                    };
                }(numericProps[j2]);
            }
            for(var k2 = 0; k2 < stringProps.length; k2++){
                StackFrame.prototype["get" + _capitalize(stringProps[k2])] = _getter(stringProps[k2]);
                StackFrame.prototype["set" + _capitalize(stringProps[k2])] = /* @__PURE__ */ function(p2) {
                    return function(v2) {
                        this[p2] = String(v2);
                    };
                }(stringProps[k2]);
            }
            return StackFrame;
        });
    })(stackframe);
    return stackframe.exports;
}
(function(module2, exports2) {
    (function(root2, factory) {
        module2.exports = factory(requireStackframe());
    })(commonjsGlobal, function ErrorStackParser(StackFrame) {
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
        return {
            /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */ parse: function ErrorStackParser$$parse(error2) {
                if (typeof error2.stacktrace !== "undefined" || typeof error2["opera#sourceloc"] !== "undefined") return this.parseOpera(error2);
                else if (error2.stack && error2.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error2);
                else if (error2.stack) return this.parseFFOrSafari(error2);
                else throw new Error("Cannot parse given Error object");
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                if (urlLike.indexOf(":") === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
                return [
                    parts[1],
                    parts[2] || void 0,
                    parts[3] || void 0
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error2) {
                var filtered = error2.stack.split("\n").filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf("(eval ") > -1) line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, "");
                    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, "");
                    var location2 = sanitizedLine.match(/ (\(.+\)$)/);
                    sanitizedLine = location2 ? sanitizedLine.replace(location2[0], "") : sanitizedLine;
                    var locationParts = this.extractLocation(location2 ? location2[1] : sanitizedLine);
                    var functionName = location2 && sanitizedLine || void 0;
                    var fileName = [
                        "eval",
                        "<anonymous>"
                    ].indexOf(locationParts[0]) > -1 ? void 0 : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error2) {
                var filtered = error2.stack.split("\n").filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
                    if (line.indexOf("@") === -1 && line.indexOf(":") === -1) return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches2 = line.match(functionNameRegex);
                        var functionName = matches2 && matches2[1] ? matches2[1] : void 0;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e2) {
                if (!e2.stacktrace || e2.message.indexOf("\n") > -1 && e2.message.split("\n").length > e2.stacktrace.split("\n").length) return this.parseOpera9(e2);
                else if (!e2.stack) return this.parseOpera10(e2);
                else return this.parseOpera11(e2);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e2) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e2.message.split("\n");
                var result2 = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match2 = lineRE.exec(lines[i]);
                    if (match2) result2.push(new StackFrame({
                        fileName: match2[2],
                        lineNumber: match2[1],
                        source: lines[i]
                    }));
                }
                return result2;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e2) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e2.stacktrace.split("\n");
                var result2 = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match2 = lineRE.exec(lines[i]);
                    if (match2) result2.push(new StackFrame({
                        functionName: match2[3] || void 0,
                        fileName: match2[2],
                        lineNumber: match2[1],
                        source: lines[i]
                    }));
                }
                return result2;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error2) {
                var filtered = error2.stack.split("\n").filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || "";
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                    var argsRaw;
                    if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
                    var args = argsRaw === void 0 || argsRaw === "[arguments not available]" ? void 0 : argsRaw.split(",");
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
})(errorStackParser);
var errorStackParserExports = errorStackParser.exports;
var enums = {};
var ENerveContentType = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ENerveContentType = void 0;
    (function(ENerveContentType2) {
        ENerveContentType2["JSON"] = "application/json";
        ENerveContentType2["IMAGE_PNG"] = "image/png";
        ENerveContentType2["AUDIO_MPEG"] = "audio/mpeg";
        ENerveContentType2["TEXT_HTML"] = "text/html";
        ENerveContentType2["TEXT_PLAIN"] = "text/plain";
    })(exports2.ENerveContentType || (exports2.ENerveContentType = {}));
})(ENerveContentType);
var ENerveHTTPMethod = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ENerveHTTPMethod = void 0;
    (function(ENerveHTTPMethod2) {
        ENerveHTTPMethod2["GET"] = "GET";
        ENerveHTTPMethod2["POST"] = "POST";
        ENerveHTTPMethod2["PUT"] = "PUT";
        ENerveHTTPMethod2["PATCH"] = "PATCH";
        ENerveHTTPMethod2["DELETE"] = "DELETE";
        ENerveHTTPMethod2["OPTIONS"] = "OPTIONS";
    })(exports2.ENerveHTTPMethod || (exports2.ENerveHTTPMethod = {}));
})(ENerveHTTPMethod);
var ENerveHTTPStatus = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ENerveHTTPStatus = void 0;
    (function(ENerveHTTPStatus2) {
        ENerveHTTPStatus2[ENerveHTTPStatus2["OK"] = 200] = "OK";
        ENerveHTTPStatus2[ENerveHTTPStatus2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
        ENerveHTTPStatus2[ENerveHTTPStatus2["FOUND"] = 302] = "FOUND";
        ENerveHTTPStatus2[ENerveHTTPStatus2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
        ENerveHTTPStatus2[ENerveHTTPStatus2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
        ENerveHTTPStatus2[ENerveHTTPStatus2["NOT_FOUND"] = 404] = "NOT_FOUND";
        ENerveHTTPStatus2[ENerveHTTPStatus2["FORBIDDEN"] = 403] = "FORBIDDEN";
        ENerveHTTPStatus2[ENerveHTTPStatus2["INTERNAL_ERROR"] = 500] = "INTERNAL_ERROR";
    })(exports2.ENerveHTTPStatus || (exports2.ENerveHTTPStatus = {}));
})(ENerveHTTPStatus);
var ENerveLocale = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ENerveLocale = void 0;
    (function(ENerveLocale2) {
        ENerveLocale2["RU_RU"] = "ru_RU";
        ENerveLocale2["EN_US"] = "en_US";
    })(exports2.ENerveLocale || (exports2.ENerveLocale = {}));
})(ENerveLocale);
var ENerveLogLevel = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.ENerveLogLevel = void 0;
    (function(ENerveLogLevel2) {
        ENerveLogLevel2[ENerveLogLevel2["NONE"] = 0] = "NONE";
        ENerveLogLevel2[ENerveLogLevel2["ERROR"] = 1] = "ERROR";
        ENerveLogLevel2[ENerveLogLevel2["INFO"] = 2] = "INFO";
        ENerveLogLevel2[ENerveLogLevel2["DEBUG"] = 3] = "DEBUG";
    })(exports2.ENerveLogLevel || (exports2.ENerveLogLevel = {}));
})(ENerveLogLevel);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(ENerveContentType, exports2);
    __exportStar(ENerveHTTPMethod, exports2);
    __exportStar(ENerveHTTPStatus, exports2);
    __exportStar(ENerveLocale, exports2);
    __exportStar(ENerveLogLevel, exports2);
})(enums);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.Log = exports2.DEFAULT_LOG_LEVEL = void 0;
    var ErrorStackParser = errorStackParserExports;
    var _enums_12 = enums;
    exports2.DEFAULT_LOG_LEVEL = _enums_12.ENerveLogLevel.INFO;
    var Log2 = function() {
        function Log3() {}
        Log3.getLevel = function() {
            return this.level;
        };
        Log3.setLevel = function(level) {
            this.level = level;
        };
        Log3.error = function(message2, err) {
            if (this.level >= _enums_12.ENerveLogLevel.ERROR) {
                var log2 = message2;
                if (err) log2 += "\nmessage: ".concat(err.toString ? err.toString() : String(err));
                if (err) {
                    var parsedError = ErrorStackParser.parse(err);
                    if (parsedError === null || parsedError === void 0 ? void 0 : parsedError[0]) log2 += "\nfile: ".concat(parsedError[0].fileName, "\nline: ").concat(parsedError[0].lineNumber, "\nfunction: ").concat(parsedError[0].functionName, "\n").concat(err.stack);
                }
                console.log(log2);
            }
        };
        Log3.info = function(message2) {
            if (this.level >= _enums_12.ENerveLogLevel.INFO) console.log(message2);
        };
        Log3.debug = function(message2) {
            if (this.level >= _enums_12.ENerveLogLevel.DEBUG) console.log(message2);
        };
        Log3.level = exports2.DEFAULT_LOG_LEVEL;
        return Log3;
    }();
    exports2.Log = Log2;
})(Log);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(Log, exports2);
})(Log$1);
var networkStatus$1 = {};
var networkStatus = {};
Object.defineProperty(networkStatus, "__esModule", {
    value: true
});
networkStatus.getNetworkStatusFailed = networkStatus.getNetworkStatusDone = networkStatus.getNetworkStatusStarted = networkStatus.getDefaultNetworkStatus = void 0;
var getDefaultNetworkStatus = function() {
    return {
        isFetching: false,
        isFetched: false,
        error: null
    };
};
networkStatus.getDefaultNetworkStatus = getDefaultNetworkStatus;
var getNetworkStatusStarted = function() {
    return {
        isFetching: true,
        isFetched: false,
        error: null
    };
};
networkStatus.getNetworkStatusStarted = getNetworkStatusStarted;
var getNetworkStatusDone = function() {
    return {
        isFetching: false,
        isFetched: true,
        error: null
    };
};
networkStatus.getNetworkStatusDone = getNetworkStatusDone;
var getNetworkStatusFailed = function(error2) {
    return {
        isFetching: false,
        isFetched: false,
        error: error2
    };
};
networkStatus.getNetworkStatusFailed = getNetworkStatusFailed;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(networkStatus, exports2);
})(networkStatus$1);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(capitalize$2, exports2);
    __exportStar(deviceInfo, exports2);
    __exportStar(getURIParams$2, exports2);
    __exportStar(htmlEntities$1, exports2);
    __exportStar(Log$1, exports2);
    __exportStar(networkStatus$1, exports2);
})(utils$2);
Object.defineProperty(NerveObject$1, "__esModule", {
    value: true
});
NerveObject$1.NerveObject = void 0;
var _utils_1$1 = utils$2;
var NerveObject = function() {
    function NerveObject2() {
        var _this = this;
        this.log = {
            setLevel: function(level) {
                return _utils_1$1.Log.setLevel(level);
            },
            error: function(message2, err) {
                return _utils_1$1.Log.error(_this.getLogText(message2), err);
            },
            info: function(message2) {
                return _utils_1$1.Log.info(_this.getLogText(message2));
            },
            debug: function(message2) {
                return _utils_1$1.Log.debug(_this.getLogText(message2));
            }
        };
    }
    NerveObject2.prototype.getLogText = function(message2) {
        return message2.replace(/%NERVE_SOURCE_NAME%/g, this.logPrefix || this.constructor.name);
    };
    NerveObject2.prototype.getLogLevel = function() {
        return _utils_1$1.Log.getLevel();
    };
    return NerveObject2;
}();
NerveObject$1.NerveObject = NerveObject;
var __extends$1 = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var extendStatics2 = function(d2, b2) {
        extendStatics2 = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d3, b3) {
            d3.__proto__ = b3;
        } || function(d3, b3) {
            for(var p2 in b3)if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
        };
        return extendStatics2(d2, b2);
    };
    return function(d2, b2) {
        if (typeof b2 !== "function" && b2 !== null) throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
        extendStatics2(d2, b2);
        function __() {
            this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
}();
Object.defineProperty(NerveRequestError$1, "__esModule", {
    value: true
});
NerveRequestError$1.NerveRequestError = void 0;
var NerveObject_1 = NerveObject$1;
var NerveRequestError = function(_super) {
    __extends$1(NerveRequestError2, _super);
    function NerveRequestError2(options) {
        var _this = _super.call(this) || this;
        var request2 = options.request, response = options.response;
        _this.request = request2;
        _this.response = response;
        return _this;
    }
    return NerveRequestError2;
}(NerveObject_1.NerveObject);
NerveRequestError$1.NerveRequestError = NerveRequestError;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(NerveRequestError$1, exports2);
})(NerveRequestError$2);
var NerveApi$1 = {};
Object.defineProperty(NerveApi$1, "__esModule", {
    value: true
});
NerveApi$1.NerveApi = void 0;
var NerveApi = function() {
    function NerveApi2() {}
    NerveApi2.setTransport = function(transport) {
        this.transport = transport;
    };
    NerveApi2.getTransport = function() {
        return this.transport;
    };
    return NerveApi2;
}();
NerveApi$1.NerveApi = NerveApi;
var NerveApiMethod$1 = {};
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign$1 = Object.assign || function(t2) {
        for(var s2, i = 1, n2 = arguments.length; i < n2; i++){
            s2 = arguments[i];
            for(var p2 in s2)if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
        }
        return t2;
    };
    return __assign$1.apply(this, arguments);
};
var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P2, generator) {
    function adopt(value2) {
        return value2 instanceof P2 ? value2 : new P2(function(resolve) {
            resolve(value2);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value2) {
            try {
                step(generator.next(value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function rejected(value2) {
            try {
                step(generator["throw"](value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body2) {
    var _2 = {
        label: 0,
        sent: function() {
            if (t2[0] & 1) throw t2[1];
            return t2[1];
        },
        trys: [],
        ops: []
    }, f2, y2, t2, g2;
    return g2 = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
    }), g2;
    function verb(n2) {
        return function(v2) {
            return step([
                n2,
                v2
            ]);
        };
    }
    function step(op) {
        if (f2) throw new TypeError("Generator is already executing.");
        while(g2 && (g2 = 0, op[0] && (_2 = 0)), _2)try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done) return t2;
            if (y2 = 0, t2) op = [
                op[0] & 2,
                t2.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t2 = op;
                    break;
                case 4:
                    _2.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _2.label++;
                    y2 = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _2.ops.pop();
                    _2.trys.pop();
                    continue;
                default:
                    if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _2 = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                        _2.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _2.label < t2[1]) {
                        _2.label = t2[1];
                        t2 = op;
                        break;
                    }
                    if (t2 && _2.label < t2[2]) {
                        _2.label = t2[2];
                        _2.ops.push(op);
                        break;
                    }
                    if (t2[2]) _2.ops.pop();
                    _2.trys.pop();
                    continue;
            }
            op = body2.call(thisArg, _2);
        } catch (e2) {
            op = [
                6,
                e2
            ];
            y2 = 0;
        } finally{
            f2 = t2 = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(NerveApiMethod$1, "__esModule", {
    value: true
});
NerveApiMethod$1.NerveApiMethod = void 0;
var _enums_1 = enums;
var _utils_1 = utils$2;
var NerveRequestError_1 = NerveRequestError$2;
var NerveApiMethod = function() {
    function NerveApiMethod2(api2) {
        this.api = api2;
    }
    NerveApiMethod2.prototype.http = function(params) {
        var _a3;
        return __awaiter$1(this, void 0, void 0, function() {
            var transport, data, err_1, error2;
            return __generator(this, function(_b2) {
                switch(_b2.label){
                    case 0:
                        transport = this.api.getTransport();
                        data = params.data && !params.isNoProcessData ? (0, _utils_1.getURIParams)(params.data) : params.data || null;
                        _b2.label = 1;
                    case 1:
                        _b2.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            transport.http(__assign$1(__assign$1({}, params), {
                                data: data
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _b2.sent()
                        ];
                    case 3:
                        err_1 = _b2.sent();
                        error2 = err_1;
                        throw new NerveRequestError_1.NerveRequestError({
                            response: error2 === null || error2 === void 0 ? void 0 : error2.response,
                            request: {
                                url: params.url,
                                method: params.method,
                                data: data,
                                headers: (_a3 = error2 === null || error2 === void 0 ? void 0 : error2.response) === null || _a3 === void 0 ? void 0 : _a3.headers
                            }
                        });
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    NerveApiMethod2.prototype.get = function(params) {
        return __awaiter$1(this, void 0, void 0, function() {
            return __generator(this, function(_a3) {
                params.method = _enums_1.ENerveHTTPMethod.GET;
                return [
                    2,
                    this.http(params)
                ];
            });
        });
    };
    NerveApiMethod2.prototype.post = function(params) {
        return __awaiter$1(this, void 0, void 0, function() {
            return __generator(this, function(_a3) {
                params.method = _enums_1.ENerveHTTPMethod.POST;
                return [
                    2,
                    this.http(params)
                ];
            });
        });
    };
    NerveApiMethod2.prototype.put = function(params) {
        return __awaiter$1(this, void 0, void 0, function() {
            return __generator(this, function(_a3) {
                params.method = _enums_1.ENerveHTTPMethod.PUT;
                return [
                    2,
                    this.http(params)
                ];
            });
        });
    };
    NerveApiMethod2.prototype.patch = function(params) {
        return __awaiter$1(this, void 0, void 0, function() {
            return __generator(this, function(_a3) {
                params.method = _enums_1.ENerveHTTPMethod.PATCH;
                return [
                    2,
                    this.http(params)
                ];
            });
        });
    };
    NerveApiMethod2.prototype.delete = function(params) {
        return __awaiter$1(this, void 0, void 0, function() {
            return __generator(this, function(_a3) {
                params.method = _enums_1.ENerveHTTPMethod.DELETE;
                params.headers = {
                    "Content-Type": "application/x-www-form-urlencoded"
                };
                return [
                    2,
                    this.http(params)
                ];
            });
        });
    };
    return NerveApiMethod2;
}();
NerveApiMethod$1.NerveApiMethod = NerveApiMethod;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(NerveRequestError$2, exports2);
    __exportStar(NerveApi$1, exports2);
    __exportStar(NerveApiMethod$1, exports2);
})(api$2);
var interfaces$1 = {};
var api$1 = {};
var INerveApiRequest = {};
Object.defineProperty(INerveApiRequest, "__esModule", {
    value: true
});
var INerveApiResponse = {};
Object.defineProperty(INerveApiResponse, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(INerveApiRequest, exports2);
    __exportStar(INerveApiResponse, exports2);
})(api$1);
var INerveActiveUserData = {};
Object.defineProperty(INerveActiveUserData, "__esModule", {
    value: true
});
var INerveClientConfig = {};
Object.defineProperty(INerveClientConfig, "__esModule", {
    value: true
});
var INerveCommonTemplateVars = {};
Object.defineProperty(INerveCommonTemplateVars, "__esModule", {
    value: true
});
var INerveContentTemplateVars = {};
Object.defineProperty(INerveContentTemplateVars, "__esModule", {
    value: true
});
var INerveFooterTemplateVars = {};
Object.defineProperty(INerveFooterTemplateVars, "__esModule", {
    value: true
});
var INerveHeadTemplateVars = {};
Object.defineProperty(INerveHeadTemplateVars, "__esModule", {
    value: true
});
var INerveHttpTransport = {};
Object.defineProperty(INerveHttpTransport, "__esModule", {
    value: true
});
var INerveSimpleTemplate = {};
Object.defineProperty(INerveSimpleTemplate, "__esModule", {
    value: true
});
var INerveStaticVersion = {};
Object.defineProperty(INerveStaticVersion, "__esModule", {
    value: true
});
var INerveStaticVersionItem = {};
Object.defineProperty(INerveStaticVersionItem, "__esModule", {
    value: true
});
var INerveTemplate = {};
Object.defineProperty(INerveTemplate, "__esModule", {
    value: true
});
var INerveTemplateRenderResult = {};
Object.defineProperty(INerveTemplateRenderResult, "__esModule", {
    value: true
});
var INetworkStatus = {};
Object.defineProperty(INetworkStatus, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(api$1, exports2);
    __exportStar(INerveActiveUserData, exports2);
    __exportStar(INerveClientConfig, exports2);
    __exportStar(INerveCommonTemplateVars, exports2);
    __exportStar(INerveContentTemplateVars, exports2);
    __exportStar(INerveFooterTemplateVars, exports2);
    __exportStar(INerveHeadTemplateVars, exports2);
    __exportStar(INerveHttpTransport, exports2);
    __exportStar(INerveSimpleTemplate, exports2);
    __exportStar(INerveStaticVersion, exports2);
    __exportStar(INerveStaticVersionItem, exports2);
    __exportStar(INerveTemplate, exports2);
    __exportStar(INerveTemplateRenderResult, exports2);
    __exportStar(INetworkStatus, exports2);
})(interfaces$1);
var constants$1 = {};
var clientConfig$1 = {};
Object.defineProperty(clientConfig$1, "__esModule", {
    value: true
});
clientConfig$1.getDefaultNerveClientConfig = void 0;
var getDefaultNerveClientConfig = function() {
    return {
        hosts: {
            main: "",
            api: "",
            static: "",
            js: "",
            css: ""
        }
    };
};
clientConfig$1.getDefaultNerveClientConfig = getDefaultNerveClientConfig;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(clientConfig$1, exports2);
})(constants$1);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(api$2, exports2);
    __exportStar(enums, exports2);
    __exportStar(interfaces$1, exports2);
    __exportStar(constants$1, exports2);
    __exportStar(utils$2, exports2);
})(dist$1);
var interfaces = {};
var api = {};
var IMydawnFeApiResponseData = {};
Object.defineProperty(IMydawnFeApiResponseData, "__esModule", {
    value: true
});
var IMydawnFeApiResponseDataList = {};
Object.defineProperty(IMydawnFeApiResponseDataList, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(IMydawnFeApiResponseData, exports2);
    __exportStar(IMydawnFeApiResponseDataList, exports2);
})(api);
var IMydawnFeActiveUserData = {};
Object.defineProperty(IMydawnFeActiveUserData, "__esModule", {
    value: true
});
var IMydawnFeClientConfig = {};
Object.defineProperty(IMydawnFeClientConfig, "__esModule", {
    value: true
});
var IMydawnFeCommonTemplateVars = {};
Object.defineProperty(IMydawnFeCommonTemplateVars, "__esModule", {
    value: true
});
var IMydawnFeContentTemplateVars = {};
Object.defineProperty(IMydawnFeContentTemplateVars, "__esModule", {
    value: true
});
var IMydawnFeFooterTemplateVars = {};
Object.defineProperty(IMydawnFeFooterTemplateVars, "__esModule", {
    value: true
});
var IMydawnFeHttpTransport = {};
Object.defineProperty(IMydawnFeHttpTransport, "__esModule", {
    value: true
});
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(api, exports2);
    __exportStar(IMydawnFeActiveUserData, exports2);
    __exportStar(IMydawnFeClientConfig, exports2);
    __exportStar(IMydawnFeCommonTemplateVars, exports2);
    __exportStar(IMydawnFeContentTemplateVars, exports2);
    __exportStar(IMydawnFeFooterTemplateVars, exports2);
    __exportStar(IMydawnFeHttpTransport, exports2);
})(interfaces);
var constants = {};
var locales$1M = {};
Object.defineProperty(locales$1M, "__esModule", {
    value: true
});
locales$1M.getLocales = locales$1M.setLocales = void 0;
var LOCALES = {};
var setLocales = function(locales2) {
    return LOCALES = locales2;
};
locales$1M.setLocales = setLocales;
var getLocales = function() {
    return LOCALES;
};
locales$1M.getLocales = getLocales;
var clientConfig = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign = Object.assign || function(t2) {
        for(var s2, i = 1, n2 = arguments.length; i < n2; i++){
            s2 = arguments[i];
            for(var p2 in s2)if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
        }
        return t2;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(clientConfig, "__esModule", {
    value: true
});
clientConfig.getDefaultMydawnFeClientConfig = void 0;
var common_1$1 = dist$1;
var getDefaultMydawnFeClientConfig = function() {
    return __assign({}, (0, common_1$1.getDefaultNerveClientConfig)());
};
clientConfig.getDefaultMydawnFeClientConfig = getDefaultMydawnFeClientConfig;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(locales$1M, exports2);
    __exportStar(clientConfig, exports2);
})(constants);
var MydawnFeRequestError$2 = {};
var MydawnFeRequestError$1 = {};
var __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var extendStatics2 = function(d2, b2) {
        extendStatics2 = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d3, b3) {
            d3.__proto__ = b3;
        } || function(d3, b3) {
            for(var p2 in b3)if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
        };
        return extendStatics2(d2, b2);
    };
    return function(d2, b2) {
        if (typeof b2 !== "function" && b2 !== null) throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
        extendStatics2(d2, b2);
        function __() {
            this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
}();
Object.defineProperty(MydawnFeRequestError$1, "__esModule", {
    value: true
});
MydawnFeRequestError$1.MydawnFeRequestError = void 0;
var common_1 = dist$1;
var MydawnFeRequestError = function(_super) {
    __extends(MydawnFeRequestError2, _super);
    function MydawnFeRequestError2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MydawnFeRequestError2;
}(common_1.NerveRequestError);
MydawnFeRequestError$1.MydawnFeRequestError = MydawnFeRequestError;
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(MydawnFeRequestError$1, exports2);
})(MydawnFeRequestError$2);
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    __exportStar(dist$1, exports2);
    __exportStar(interfaces, exports2);
    __exportStar(constants, exports2);
    __exportStar(MydawnFeRequestError$2, exports2);
})(dist$2);
const getRewardManagerActionsInitialState = ()=>({
        fulfill: {
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus()
            }
        },
        reject: {
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus()
            }
        }
    });
const rewardManagerActions = (0, $ki1Eq.reducerWithInitialState)(getRewardManagerActionsInitialState());
applyAsyncReducer()("fulfill", "networkStatus", fulfillAllDemands.async, rewardManagerActions);
applyAsyncReducer()("fulfill", "networkStatus", fulfillDemandsBulk.async, rewardManagerActions);
applyAsyncReducer()("reject", "networkStatus", rejectAllDemands.async, rewardManagerActions);
applyAsyncReducer()("reject", "networkStatus", rejectDemandsBulk.async, rewardManagerActions);
const disableReward = actionCreatorAsync$v("disableReward", async ({ blogUrl, requestId })=>{
    await Api$1.rewardManager.disableReward(blogUrl, requestId);
    return {};
});
const enableReward = actionCreatorAsync$v("enableReward", async ({ blogUrl, requestId })=>{
    await Api$1.rewardManager.enableReward(blogUrl, requestId);
    return {};
});
const getRewardManagerDataInitialState = ()=>({
        rewardGroupsList: {
            data: null,
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus(),
                rewardAvailabilityNetworkStatus: dist$2.getDefaultNetworkStatus()
            }
        },
        rewardRequests: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: true
                }
            },
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus()
            }
        },
        currentRewardId: null
    });
const rewardManagerData = (0, $ki1Eq.reducerWithInitialState)(getRewardManagerDataInitialState()).withHandling(immerCase(processRewardEvent, (newState, { event: { status, ...data } })=>{
    var _a3, _b2;
    const rewardGroup = (_a3 = newState.rewardGroupsList.data) == null ? void 0 : _a3.find((group)=>group.id === data.reward.id);
    const changeOffset = (changeValue)=>{
        if (newState.currentRewardId && newState.currentRewardId !== data.reward.id) return;
        newState.rewardRequests.data.extra.offset = `${Math.max(0, Number(newState.rewardRequests.data.extra.offset) + changeValue)}`;
    };
    if (!rewardGroup) return;
    switch(status){
        case ERewardStatus.Pending:
            newState.rewardRequests.data.data = [
                data,
                ...newState.rewardRequests.data.data || []
            ];
            changeOffset(1);
            rewardGroup.demandsAmount++;
            break;
        case ERewardStatus.Approved:
        case ERewardStatus.Rejected:
            newState.rewardRequests.data.data = (_b2 = newState.rewardRequests.data.data) == null ? void 0 : _b2.filter((element)=>element.demandId !== data.demandId);
            changeOffset(-1);
            rewardGroup.demandsAmount--;
            break;
    }
})).withHandling(immerCase(fulfillDemandsBulk.async.done, (newState, { params })=>{
    newState.rewardRequests.data.data = newState.rewardRequests.data.data.filter((item2)=>!params.rewardRequestIds.includes(item2.demandId));
})).withHandling(immerCase(rejectDemandsBulk.async.done, (newState, { params })=>{
    newState.rewardRequests.data.data = newState.rewardRequests.data.data.filter((item2)=>!params.rewardRequestIds.includes(item2.demandId));
})).withHandling(immerCase(fulfillAllDemands.async.done, (newState)=>{
    newState.rewardRequests.data.data = [];
})).withHandling(immerCase(rejectAllDemands.async.done, (newState)=>{
    newState.rewardRequests.data.data = [];
}));
applyAsyncReducer()("rewardGroupsList", "networkStatus", fetchRewardsManagerFilter.async, rewardManagerData, ({ result: result2 })=>result2.data);
applyAsyncReducer()("rewardRequests", "networkStatus", fetchRewardRequests.async, rewardManagerData, ({ result: result2 })=>({
        data: result2.data || [],
        extra: result2.extra
    }));
applyAsyncReducer()("rewardRequests", "networkStatus", updateRewardRequests.async, rewardManagerData, ({ store: store2, result: result2 })=>({
        data: (store2.rewardRequests.data.data || []).concat(result2.data),
        extra: result2.extra
    }));
applyAsyncReducer()("rewardGroupsList", "rewardAvailabilityNetworkStatus", enableReward.async, rewardManagerData, ({ store: store2 })=>{
    const rewardGroupsList = store2.rewardGroupsList.data;
    const currentGroup = rewardGroupsList.find((group)=>group.id === store2.currentRewardId);
    currentGroup.isDisabled = false;
    return [
        ...rewardGroupsList
    ];
});
applyAsyncReducer()("rewardGroupsList", "rewardAvailabilityNetworkStatus", disableReward.async, rewardManagerData, ({ store: store2 })=>{
    const rewardGroupsList = store2.rewardGroupsList.data;
    const currentGroup = rewardGroupsList.find((group)=>group.id === store2.currentRewardId);
    currentGroup.isDisabled = true;
    return [
        ...rewardGroupsList
    ];
});
rewardManagerData.case(clearRewardsManagerFilter, (state)=>({
        ...state,
        rewardGroupsList: {
            data: null,
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus(),
                rewardAvailabilityNetworkStatus: dist$2.getDefaultNetworkStatus()
            }
        }
    }));
rewardManagerData.case(selectRewardGroup, (state, payload)=>({
        ...state,
        currentRewardId: payload
    }));
rewardManagerData.case(clearRewardRequests, (state)=>({
        ...state,
        rewardRequests: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: true
                }
            },
            meta: {
                networkStatus: dist$2.getDefaultNetworkStatus()
            }
        }
    }));
const rewardManager = (0, $eShmq.combineReducers)({
    rewardManagerData: rewardManagerData,
    rewardManagerActions: rewardManagerActions
});
const rewardReducerFetchStandardRewards = (channelRewards2)=>{
    applyAsyncReducer()("standardRewards", "networkStatus", fetchStandardRewards.async, channelRewards2, (props)=>props.result.rewards);
};
const rewardReducerToggleReward = (channelRewards2)=>{
    channelRewards2.withHandling(immerCase(toggleReward.async.started, (newState, { isStandard })=>{
        if (isStandard) newState.standardRewards.meta.networkStatus = getNetworkStatusStarted$1();
        else newState.ownRewards.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(toggleReward.async.done, (newState, { params, result: result2 })=>{
        const typeReward = params.isStandard ? "standardRewards" : "ownRewards";
        newState[typeReward].data = newState[typeReward].data.map((reward2)=>{
            if (reward2.id === params.id) return {
                ...reward2,
                ...result2
            };
            return reward2;
        });
        newState[typeReward].meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(toggleReward.async.failed, (newState, { error: error2, params })=>{
        if (params.isStandard) newState.standardRewards.meta.networkStatus = getNetworkStatusFailed$1(error2);
        else newState.ownRewards.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const rewardReducerUpdateStandardReward = (channelRewards2)=>{
    channelRewards2.withHandling(immerCase(updateStandardReward.async.started, (newState)=>{
        newState.standardRewards.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(updateStandardReward.async.done, (newState, { params, result: result2 })=>{
        newState.standardRewards.data = newState.standardRewards.data.map((reward2)=>{
            if (reward2.id === params.id) return {
                ...reward2,
                ...result2
            };
            return reward2;
        });
        newState.standardRewards.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(updateStandardReward.async.failed, (newState, { error: error2 })=>{
        newState.standardRewards.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getChannelRewardInitialState = ()=>({
        ownRewards: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        standardRewards: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const getRewardInitialState = ()=>({
        rewards: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const channelRewards = (0, $ki1Eq.reducerWithInitialState)(getChannelRewardInitialState());
const rewards = (0, $ki1Eq.reducerWithInitialState)(getRewardInitialState());
const updateRewardResult = (props)=>{
    return props.store.ownRewards.data.map((item2)=>item2.id === props.result.id ? {
            ...props.result,
            _deleted: item2._deleted
        } : item2);
};
channelRewards.case(clearChannelRewards, ()=>getChannelRewardInitialState());
applyAsyncReducer()("ownRewards", "networkStatus", fetchOwnRewards.async, channelRewards, (props)=>props.result.map((item2)=>({
            ...item2,
            _deleted: false
        })));
applyAsyncReducer()("rewards", "networkStatus", fetchRewards.async, rewards, (props)=>props.result);
applyAsyncReducer()("ownRewards", "networkStatus", createOwnReward.async, channelRewards, (props)=>{
    return [
        ...props.store.ownRewards.data,
        {
            ...props.result,
            _deleted: false
        }
    ];
});
applyAsyncReducer()("ownRewards", "networkStatus", updateOwnReward.async, channelRewards, updateRewardResult);
applyAsyncReducer()("ownRewards", "networkStatus", deleteOwnReward.async, channelRewards, (props)=>{
    return props.store.ownRewards.data.filter((item2)=>item2.id !== props.result.id);
});
channelRewards.case(markAsDeletedOwnReward, (state, payload)=>({
        ...state,
        ownRewards: {
            ...state.ownRewards.data,
            data: state.ownRewards.data.map((item2)=>item2.id === payload.id ? {
                    ...item2,
                    _deleted: payload.isDeleted
                } : item2),
            meta: {
                ...state.ownRewards.meta,
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
applyAsyncReducer()("rewards", "networkStatus", fetchRewardById.async, rewards, (props)=>{
    return props.store.rewards.data.map((item2)=>props.result.id === item2.id ? props.result : item2);
});
rewards.case(clearRewards, (state)=>({
        ...state,
        rewards: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    }));
rewardReducerFetchStandardRewards(channelRewards);
rewardReducerToggleReward(channelRewards);
rewardReducerUpdateStandardReward(channelRewards);
const roleReducerAssignRoles = (roles2)=>{
    roles2.withHandling(immerCase(assignRoles.async.started, (newState)=>{
        newState.users.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(assignRoles.async.done, (newState, { params: { user, filters, params: { roleIds } } })=>{
        var _a3;
        const hasFilters = Boolean(((_a3 = filters == null ? void 0 : filters.roleIds) == null ? void 0 : _a3.length) || (filters == null ? void 0 : filters.nick));
        if (!hasFilters) {
            const userId = user.id;
            if (roleIds.length) {
                const needRoles = newState.roles.data.list.filter((role2)=>roleIds.includes(role2.id));
                const hasUser = newState.users.data.list.some((item2)=>item2.id === userId);
                if (hasUser) newState.users.data.list = newState.users.data.list.map((item2)=>{
                    if (item2.id === userId) item2.roles = needRoles;
                    return item2;
                });
                else newState.users.data.list = [
                    {
                        ...user,
                        roles: needRoles
                    },
                    ...newState.users.data.list
                ];
            } else newState.users.data.list = newState.users.data.list.filter((item2)=>item2.id !== userId);
        }
        newState.users.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(assignRoles.async.failed, (newState, { error: error2 })=>{
        newState.users.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const roleReducerChangeRoleOrder = (roles2)=>{
    roles2.withHandling(immerCase(changeRoleOrder.async.started, (newState)=>{
        newState.roles.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(changeRoleOrder.async.done, (newState, { params: { params: { roleIds } } })=>{
        newState.roles.data.list = newState.roles.data.list.map((item2)=>{
            const index2 = roleIds.indexOf(item2.id);
            item2.priority = index2 + 1;
            return item2;
        }).sort((a2, b2)=>a2.priority - b2.priority);
        newState.users.data.list = newState.users.data.list.map((user)=>{
            const rolesList = user.roles;
            const updatedRoles = rolesList.map((role2)=>{
                role2.priority = roleIds.indexOf(role2.id);
                return role2;
            }).sort((a2, b2)=>a2.priority - b2.priority);
            user.roles = updatedRoles;
            return user;
        });
        newState.roles.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(changeRoleOrder.async.failed, (newState, { error: error2 })=>{
        newState.roles.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const roleReducerClearRoles = (roles2)=>{
    roles2.case(clearRoles, (state)=>({
            ...state,
            roles: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const roleReducerClearUsers = (roles2)=>{
    roles2.case(clearUsersWithRoles, (state, {})=>({
            ...state,
            users: {
                data: {
                    list: null,
                    extra: {
                        offset: null,
                        isLast: false
                    }
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const roleReducerCreateRole = (roles2)=>{
    roles2.withHandling(immerCase(createRole.async.started, (newState)=>{
        newState.roles.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createRole.async.done, (newState, { params, result: result2 })=>{
        newState.roles.data.list = [
            ...newState.roles.data.list,
            result2.data.role
        ];
        newState.roles.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createRole.async.failed, (newState, { error: error2 })=>{
        newState.roles.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const roleReducerFetchRoles = (roles2)=>{
    applyAsyncReducer()("roles", "networkStatus", fetchRoles.async, roles2, ({ result: result2 })=>({
            totalAvailableCount: result2.totalAvailableCount,
            list: result2.roles
        }));
};
const roleReducerFetchUsers = (roles2)=>{
    applyAsyncReducer()("users", "networkStatus", fetchUsersWithRoles.async, roles2, ({ store: store2, result: result2 })=>({
            list: (store2.users.data.list || []).concat(result2.users),
            extra: result2.extra
        }));
};
const roleReducerRemoveRole = (roles2)=>{
    roles2.withHandling(immerCase(removeRole.async.started, (newState)=>{
        newState.roles.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(removeRole.async.done, (newState, { params: { hasFilter, roleId } })=>{
        newState.roles.data.list = newState.roles.data.list.filter((item2)=>item2.id !== roleId);
        if (!hasFilter) {
            const list2 = newState.users.data.list;
            newState.users.data.list = list2.map((user)=>{
                const rolesList = user.roles;
                const updatedRoles = rolesList.filter((role2)=>role2.id !== roleId);
                user.roles = updatedRoles;
                return user;
            }).filter((user)=>user.roles.length > 0);
        }
        newState.roles.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(removeRole.async.failed, (newState, { error: error2 })=>{
        newState.roles.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const roleReducerRemoveUserRoles = (roles2)=>{
    roles2.withHandling(immerCase(removeUserRoles.async.started, (newState)=>{
        newState.users.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(removeUserRoles.async.done, (newState, { params: { userId } })=>{
        newState.users.data.list = newState.users.data.list.filter((item2)=>item2.id !== userId);
        newState.users.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(removeUserRoles.async.failed, (newState, { error: error2 })=>{
        newState.users.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const roleReducerUpdateRole = (roles2)=>{
    roles2.withHandling(immerCase(updateRole.async.started, (newState)=>{
        newState.roles.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(updateRole.async.done, (newState, { result: result2 })=>{
        newState.roles.data.list = newState.roles.data.list.map((item2)=>{
            if (item2.id === result2.id) return result2;
            return item2;
        });
        newState.users.data.list = newState.users.data.list.map((user)=>{
            const rolesList = user.roles;
            const updatedRoles = rolesList.map((role2)=>{
                if (role2.id === result2.id) role2 = result2;
                return role2;
            });
            user.roles = updatedRoles;
            return user;
        });
        newState.roles.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(updateRole.async.failed, (newState, { error: error2 })=>{
        newState.roles.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getRolesInitialState = ()=>({
        users: {
            data: {
                list: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        roles: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const roles$1 = (0, $ki1Eq.reducerWithInitialState)(getRolesInitialState());
roleReducerClearRoles(roles$1);
roleReducerFetchRoles(roles$1);
roleReducerCreateRole(roles$1);
roleReducerUpdateRole(roles$1);
roleReducerRemoveRole(roles$1);
roleReducerChangeRoleOrder(roles$1);
roleReducerClearUsers(roles$1);
roleReducerFetchUsers(roles$1);
roleReducerAssignRoles(roles$1);
roleReducerRemoveUserRoles(roles$1);
const getRouteParamsInitialState = ()=>({});
const routeParams = (0, $ki1Eq.reducerWithInitialState)(getRouteParamsInitialState());
routeParams.case(updateRouteParams, (state, payload)=>({
        ...payload
    }));
const getEmptySchemaElement = ()=>({
        data: null,
        meta: {
            networkStatus: getDefaultNetworkStatus$1()
        }
    });
const fetchCatalogAllSchemas = actionCreatorAsync$N("fetchCatalogAllSchemas", async (params)=>{
    var _a3;
    const response = await Api$1.catalog.fetchAllSchemas(params);
    return {
        schemas: (_a3 = response.data.data) == null ? void 0 : _a3.schemas
    };
});
const allSchemasReducerFetch = (schemas2)=>{
    schemas2.withHandling(immerCase(fetchCatalogAllSchemas.async.started, (state)=>{
        Object.values(ESchemaType).forEach((type)=>{
            if (!state.list[type]) state.list[type] = getEmptySchemaElement();
            state.list[type].meta.networkStatus = getNetworkStatusStarted$1();
        });
    })).withHandling(immerCase(fetchCatalogAllSchemas.async.done, (state, { params, result: result2 })=>{
        result2.schemas.forEach((schema)=>{
            state.list[schema.name] = {
                data: schema.blocks,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            };
        });
    })).withHandling(immerCase(fetchCatalogAllSchemas.async.failed, (state, { params, error: error2 })=>{
        Object.values(ESchemaType).forEach((type)=>{
            state.list[type].meta.networkStatus = getNetworkStatusFailed$1(error2);
        });
    }));
};
const clearCatalogSchema = actionCreator$V("clearCatalogSchema");
const schemaReducerClear = (catalog2)=>{
    catalog2.case(clearCatalogSchema, (state, type)=>({
            ...state,
            list: omit(state.list, type)
        }));
};
const schemaReducerFetch = (schemas2)=>{
    schemas2.withHandling(immerCase(fetchCatalogSchema.async.started, (state, { type })=>{
        if (!state.list[type]) state.list[type] = getEmptySchemaElement();
        state.list[type].meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchCatalogSchema.async.done, (state, { params, result: result2 })=>{
        state.list[params.type].data = result2.blocks;
    })).withHandling(immerCase(fetchCatalogSchema.async.failed, (state, { params, error: error2 })=>{
        if (params) state.list[params.type].meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getSchemasInitialState = ()=>({
        list: {}
    });
const schemas = (0, $ki1Eq.reducerWithInitialState)(getSchemasInitialState());
schemaReducerFetch(schemas);
schemaReducerClear(schemas);
allSchemasReducerFetch(schemas);
const getServiceRolesInitialState = ()=>({
        isHotkeysDisabled: false
    });
const serviceStates = (0, $ki1Eq.reducerWithInitialState)(getServiceRolesInitialState());
serviceStates.case(disableHotkeys, (state, { isDisabled: isDisabled2 })=>({
        ...state,
        isHotkeysDisabled: isDisabled2
    }));
const clearChannelSettingsSetReducer = (channelSettings)=>{
    channelSettings.case(clearChannelSettingsSet, (state)=>({
            ...state,
            channel: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const fetchChannelSettingsSetReducer = (reducer)=>{
    applyAsyncReducer()("channel", "networkStatus", fetchChannelSettingsSet.async, reducer, ({ store: store2, result: result2 })=>result2);
};
const updateNewRecordsSubscriptionLevelReducer = (reducer)=>{
    applyAsyncReducer()("channel", "networkStatus", updateNewRecordsSubscriptionLevel.async, reducer, ({ store: store2, params })=>({
            ...store2.channel,
            recordSubscriptionLevel: store2.channel.data.subscriptionLevels.find((level)=>level.id === params.subscriptionLevelId) ?? null
        }));
};
const clearStreamSettingsSetReducer = (streamSettings)=>{
    streamSettings.case(clearStreamSettingsSet, (state)=>({
            ...state,
            stream: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const fetchStreamSettingsSetReducer = (reducer)=>{
    applyAsyncReducer()("stream", "networkStatus", fetchStreamSettingsSet.async, reducer, ({ store: store2, result: result2 })=>result2);
};
const updateStreamSettingsSetReducer = (reducer)=>{
    applyAsyncReducer()("stream", "networkStatus", updateStreamSettingsSet.async, reducer, ({ store: store2, result: result2 })=>result2);
};
const turnOffStreamRaidedReducer = (builder)=>{
    builder.case(turnOffStreamRaided.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    canBeRaided: false
                }
            }
        }));
};
const turnOnStreamRaidedReducer = (builder)=>{
    builder.case(turnOnStreamRaided.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    canBeRaided: true
                }
            }
        }));
};
const turnOnStreamsRecordReducer = (builder)=>{
    builder.case(turnOnStreamsRecord.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    streamsRecording: true
                }
            }
        }));
};
const turnOffStreamsRecordReducer = (builder)=>{
    builder.case(turnOffStreamsRecord.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    streamsRecording: false
                }
            }
        }));
};
const turnOffVideoClipCreationReducer = (builder)=>{
    builder.case(turnOffVideoClipCreation.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    isClipCreationAllowed: false
                }
            }
        }));
};
const turnOnVideoClipCreationReducer = (builder)=>{
    builder.case(turnOnVideoClipCreation.async.done, (state)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    isClipCreationAllowed: true
                }
            }
        }));
};
const updateHasAdultContentReducer = (builder)=>{
    builder.case(updateHasAdultContent.async.done, (state, payload)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    hasAdultContent: payload.result.hasAdultContent
                }
            }
        }));
};
const updateSelfPublicStreamHiddenReducer = (builder)=>{
    builder.case(updateSelfPublicStreamHidden.async.done, (state, payload)=>({
            ...state,
            channel: {
                ...state.channel,
                data: {
                    ...state.channel.data,
                    isHidden: payload.result.isPublicStreamSelfHidden
                }
            }
        }));
};
const getSettingsInitialState = ()=>({
        stream: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        channel: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const settings$1 = (0, $ki1Eq.reducerWithInitialState)(getSettingsInitialState());
updateStreamSettingsSetReducer(settings$1);
fetchStreamSettingsSetReducer(settings$1);
clearStreamSettingsSetReducer(settings$1);
clearChannelSettingsSetReducer(settings$1);
fetchChannelSettingsSetReducer(settings$1);
updateNewRecordsSubscriptionLevelReducer(settings$1);
turnOffStreamRaidedReducer(settings$1);
turnOnStreamRaidedReducer(settings$1);
turnOnStreamsRecordReducer(settings$1);
turnOffStreamsRecordReducer(settings$1);
turnOffVideoClipCreationReducer(settings$1);
turnOnVideoClipCreationReducer(settings$1);
updateSelfPublicStreamHiddenReducer(settings$1);
updateHasAdultContentReducer(settings$1);
const getSinglePaymentInitialState = ()=>({
        singlePaymentDmrPageUrl: {
            data: {
                url: null,
                paymentId: null,
                status: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        singlePaymentOnlyBindBank131PageUrl: {
            data: {
                url: null,
                paymentId: null,
                status: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        singlePaymentOnlyBindDmrPageUrl: {
            data: {
                url: null,
                paymentId: null,
                status: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        pollingCheck: {
            data: {
                status: false
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const singlePaymentReducer = (0, $ki1Eq.reducerWithInitialState)(getSinglePaymentInitialState());
applyAsyncReducer()("singlePaymentDmrPageUrl", "networkStatus", fetchSinglePaymentDmrPageUrl.async, singlePaymentReducer, ({ result: result2 })=>({
        url: result2.url,
        paymentId: result2.paymentId,
        status: result2.status
    }));
applyAsyncReducer()("singlePaymentOnlyBindBank131PageUrl", "networkStatus", fetchSinglePaymentOnlyBindBank131PageUrl.async, singlePaymentReducer, // eslint-disable-next-line sonarjs/no-identical-functions
({ result: result2 })=>({
        url: result2.url,
        paymentId: result2.paymentId,
        status: result2.status
    })).case(fetchSinglePaymentOnlyBindBank131PageUrl.async.started, (store2)=>({
        ...store2,
        singlePaymentOnlyBindBank131PageUrl: {
            data: {
                ...store2.singlePaymentOnlyBindBank131PageUrl.data,
                url: null
            },
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    }));
applyAsyncReducer()("singlePaymentOnlyBindDmrPageUrl", "networkStatus", fetchSinglePaymentOnlyBindDmrPageUrl.async, singlePaymentReducer, // eslint-disable-next-line sonarjs/no-identical-functions
({ result: result2 })=>({
        url: result2.url,
        paymentId: result2.paymentId,
        status: result2.status
    })).case(fetchSinglePaymentOnlyBindDmrPageUrl.async.started, (store2)=>({
        ...store2,
        singlePaymentOnlyBindDmrPageUrl: {
            data: {
                ...store2.singlePaymentOnlyBindDmrPageUrl.data,
                url: null
            },
            meta: {
                networkStatus: getNetworkStatusStarted$1()
            }
        }
    }));
applyAsyncReducer()("pollingCheck", "networkStatus", runCheckPaymentId.async, singlePaymentReducer, ({ result: result2 })=>({
        status: result2.successful
    }));
const singlePayment = singlePaymentReducer;
const smilesReducerChangeOrder = (reducer)=>{
    return reducer.withHandling(immerCase(changeSmileOrder.async.done, (newState, { params })=>{
        var _a3;
        const { smileIds } = params.params;
        newState.smiles.data.smileLevels = (_a3 = newState.smiles.data.smileLevels) == null ? void 0 : _a3.map((level)=>{
            if (level.subscriptionLevel.id === params.levelId) {
                const hash = level.smiles.reduce((previousValue, currentValue)=>{
                    return {
                        ...previousValue,
                        [currentValue.id]: currentValue
                    };
                }, {});
                return {
                    ...level,
                    smiles: smileIds.map((id)=>{
                        return hash[id];
                    })
                };
            } else return level;
        });
    }));
};
const smilesReducerClearSmileData = (smiles2)=>{
    smiles2.case(clearSmileData, (state)=>({
            ...state,
            smileData: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const smilesReducerClearSmiles = (smiles2)=>{
    smiles2.case(clearSmiles, (state)=>({
            ...state,
            currentBlogSmiles: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            },
            smiles: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const smilesReducerClearSmilesList = (smiles2)=>{
    smiles2.case(clearSmilesList, (state)=>({
            ...state,
            smiles: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const smilesReducerCreateSmile = (smiles2)=>{
    smiles2.case(createSmile.async.done, (state, { result: result2, params })=>{
        const { params: { levelId } } = params;
        return {
            ...state,
            smiles: {
                ...state.smiles,
                data: {
                    ...state.smiles.data,
                    smileLevels: state.smiles.data.smileLevels.map((level)=>{
                        if (level.subscriptionLevel.id === levelId) return {
                            ...level,
                            smiles: [
                                ...level.smiles,
                                result2
                            ]
                        };
                        else return level;
                    })
                }
            }
        };
    });
};
const smilesReducerFetchSmile = (store2)=>{
    applyAsyncReducer()("smileData", "networkStatus", fetchSmileData.async, store2, ({ result: result2 })=>result2);
};
const smilesReducerFetchSmileLevels = (store2)=>{
    applyAsyncReducer()("smiles", "networkStatus", fetchSmileList.async, store2, ({ result: result2 })=>result2);
};
const smilesReducerFetchSmileUserPopularSet = (smiles2)=>{
    applyAsyncReducer()("currentBlogSmiles", "networkStatus", fetchSmileUserPopularSet.async, smiles2, ({ store: store2, result: result2 })=>store2.currentBlogSmiles.data.map((list2)=>list2.type === ESmileUserSetType.USER_POPULAR ? result2 : list2));
};
const smilesReducerFetchSmileUserSet = (store2)=>{
    applyAsyncReducer()("currentBlogSmiles", "networkStatus", fetchSmileUserSet.async, store2, ({ result: result2 })=>result2);
};
const smilesReducerRemoveSmile = (smiles2)=>{
    smiles2.case(removeSmile.async.done, (state, { result: result2, params })=>{
        return {
            ...state,
            smiles: {
                ...state.smiles,
                data: {
                    ...state.smiles.data,
                    smileLevels: state.smiles.data.smileLevels.map((level)=>{
                        return {
                            ...level,
                            smiles: level.smiles.filter((smile2)=>smile2.id !== params.smileId)
                        };
                    })
                }
            }
        };
    });
};
const smilesReducerUpdateSmile = (smiles2)=>{
    smiles2.case(updateSmile.async.done, (state, { result: result2, params })=>{
        return {
            ...state,
            smiles: {
                ...state.smiles,
                data: {
                    ...state.smiles.data,
                    smileLevels: state.smiles.data.smileLevels.map((level)=>{
                        if (params.params.levelId === level.subscriptionLevel.id) return {
                            ...level,
                            smiles: level.smiles.map((smile2)=>smile2.id === params.smileId ? result2 : smile2)
                        };
                        else return level;
                    })
                }
            }
        };
    });
};
const getSmilesInitialState = ()=>({
        currentBlogSmiles: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        smiles: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        smileData: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const smiles = (0, $ki1Eq.reducerWithInitialState)(getSmilesInitialState());
smilesReducerFetchSmileUserSet(smiles);
smilesReducerFetchSmileUserPopularSet(smiles);
smilesReducerFetchSmileLevels(smiles);
smilesReducerCreateSmile(smiles);
smilesReducerRemoveSmile(smiles);
smilesReducerUpdateSmile(smiles);
smilesReducerClearSmiles(smiles);
smilesReducerFetchSmile(smiles);
smilesReducerClearSmileData(smiles);
smilesReducerChangeOrder(smiles);
smilesReducerClearSmilesList(smiles);
const streamChangeStreamOnlineStatus = (stream2)=>{
    stream2.case(changeStreamOnlineStatus, (store2, { isOnline })=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        isOnline: isOnline,
                        ...isOnline ? {
                            isEnded: false
                        } : {}
                    }
                }
            }
        }));
};
const streamReducerAddMentionedUser = (stream2)=>{
    stream2.case(addMentionedUser, (state, { user })=>({
            ...state,
            streamChatUserSearchList: {
                ...state.streamChatUserSearchList,
                data: {
                    ...state.streamChatUserSearchList.data,
                    mentionedUser: user
                }
            }
        }));
};
const MESSAGES_GAP = 50;
const streamReducerAddNewMentionChatMessages = (stream2)=>{
    stream2.withHandling(immerCase(addNewMentionChatMessage, (newState, message2)=>{
        if (!newState.streamChatMentions) newState.streamChatMentions = [];
        newState.streamChatMentions.push(message2);
    }));
};
const streamReducerAddNewStreamChatMessages = (stream2)=>{
    stream2.withHandling(immerCase(addNewStreamChatMessages, (newState, { messages: messages2, currentUserId })=>{
        var _a3, _b2;
        const messagesStoreLimit = (_b2 = (_a3 = getConfig()) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.messagesStoreLimit;
        const hasChatStoreLimit = isConditionalFeatureEnable(EConditionalFeature.CHAT_STORE_LIMIT);
        messages2.forEach((message2)=>{
            var _a4;
            if (isChatSystemMessage(message2)) {
                const lastMessage = newState.streamChatFromWebSocket[newState.streamChatFromWebSocket.length - 1];
                const isSystemMessageRepeating = isChatSystemMessage(lastMessage) && lastMessage.type === message2.type;
                message2.id = uniqueId(message2.type);
                newState.streamChatFromWebSocket = [
                    ...newState.streamChatFromWebSocket,
                    ...isSystemMessageRepeating ? [] : [
                        message2
                    ]
                ];
                return;
            }
            if (message2.threadId && message2.parent) {
                newState.streamChat.data.data = newState.streamChat.data.data.map((item2)=>setThreadId(item2, message2));
                newState.streamChatFromWebSocket = newState.streamChatFromWebSocket.map((item2)=>setThreadId(item2, message2));
                newState.streamChatMentions = newState.streamChatMentions.map((item2)=>setThreadId(item2, message2));
                const isOpenThread = (_a4 = newState.streamChatThreadMessages.data.data.replies) == null ? void 0 : _a4.some((item2)=>{
                    return item2.threadId === message2.threadId;
                });
                if (isOpenThread) newState.streamChatThreadMessages.data.data.replies = [
                    ...newState.streamChatThreadMessages.data.data.replies,
                    message2
                ];
            }
            if (newState.streamChat.data.data.some((el)=>isChatUserMessage(el) && el.id === message2.id)) return;
            const streamChatLength = newState.streamChat.data.data.length;
            const length = newState.streamChatFromWebSocket.length + streamChatLength;
            const shouldTrunkMessagesList = hasChatStoreLimit && messagesStoreLimit && length > messagesStoreLimit + MESSAGES_GAP;
            if (shouldTrunkMessagesList && !newState.streamChatIsPaused) {
                let messagesToTrunkLeft = length - messagesStoreLimit;
                if (streamChatLength) {
                    newState.streamChat.data.data = newState.streamChat.data.data.slice(messagesToTrunkLeft);
                    messagesToTrunkLeft -= streamChatLength;
                }
                newState.streamChatFromWebSocket = [
                    ...newState.streamChatFromWebSocket,
                    message2
                ].slice(messagesToTrunkLeft);
                return;
            }
            newState.streamChatFromWebSocket = [
                ...newState.streamChatFromWebSocket,
                message2
            ];
        });
    }));
};
const setThreadId = (item2, message2)=>{
    if (isChatUserMessage(item2) && item2.id === message2.parent.id) item2.threadId = message2.threadId;
    return item2;
};
const streamReducerAddStopWord = (stream2)=>{
    applyAsyncReducer()("streamStopWords", "networkStatus", addStopWord.async, stream2, ({ store: store2, result: result2, params })=>({
            ...store2.streamStopWords.data,
            data: [
                ...store2.streamStopWords.data.data,
                params.word
            ]
        }));
};
const streamReducerAssignUserRoles = (stream2)=>{
    stream2.withHandling(immerCase(assignUserRoles.async.started, (newState)=>{
        newState.streamChatUserStat.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(assignUserRoles.async.done, (newState, { params: { userId, selectedRoles } })=>{
        const sortedRoles = selectedRoles.sort((a2, b2)=>a2.priority - b2.priority);
        newState.streamChat.data.data = newState.streamChat.data.data.map((message2)=>{
            if (isChatUserMessage(message2) && message2.author.id === userId) {
                message2.author.roles = sortedRoles;
                return message2;
            }
            return message2;
        });
        newState.streamChatUserStat.data.user.roles = sortedRoles;
        newState.streamChatUserStat.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(assignUserRoles.async.failed, (newState, { error: error2 })=>{
        newState.streamChatUserStat.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamReducerChatMessageByUserIdFromWs = (stream2)=>{
    stream2.case(removeStreamChatMessagesByUserIdFromWS, (store2, { userId })=>({
            ...store2,
            streamChatFromWebSocket: store2.streamChatFromWebSocket.filter((message2)=>isChatUserMessage(message2) && message2.user.id !== userId)
        }));
};
const streamReducerCleanStreamChatMentions = (stream2)=>{
    stream2.case(cleanStreamChatMentions, (state)=>({
            ...state,
            streamChatMentions: []
        }));
};
const streamReducerCleanStreamChatMessages = (stream2)=>{
    applyAsyncReducer()("streamChat", "networkStatus", cleanStreamChatMessages.async, stream2, ({ store: store2, result: result2, params })=>({
            ...result2,
            data: store2.streamChat.data.data.filter((message2)=>isChatUserMessage(message2) && message2.author.id !== params.userId)
        }));
};
const streamReducerCleanStreamChatMessagesFromWs = (stream2)=>{
    stream2.withHandling(immerCase(cleanStreamChatMessagesFromWS, (newState)=>{
        newState.streamChatFromWebSocket = [];
    }));
};
const streamReducerCleanStreamChatUserSearchList = (stream2)=>{
    stream2.case(cleanStreamChatUserSearchList, (state)=>({
            ...state,
            streamChatUserSearchList: {
                data: {
                    ...state.streamChatUserSearchList.data,
                    users: null,
                    activeIndexPopover: 0
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerCleanStreamRaid = (stream2)=>{
    stream2.case(cleanStreamRaid, (store2)=>({
            ...store2,
            streamRaid: {}
        }));
};
const streamReducerClearStream = (stream2)=>{
    stream2.case(clearStream, (store2)=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    stream: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    credentialsNetworkStatus: getDefaultNetworkStatus$1(),
                    createStreamNetworkStatus: getDefaultNetworkStatus$1(),
                    updateStreamNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerClearStreamChat = (stream2)=>{
    stream2.withHandling(immerCase(clearStreamChat, (newState)=>{
        newState.streamChat = {
            data: {
                ...newState.streamChat.data,
                banRemainingTime: null,
                streamChatMode: newState.streamChat.data.streamChatMode,
                isBanned: null,
                isBannedByStreamEnd: false,
                isLast: true,
                offset: 0,
                data: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                chatSettingsNetworkStatus: getDefaultNetworkStatus$1()
            }
        };
    }));
};
const streamReducerClearStreamChatSettings = (stream2)=>{
    stream2.withHandling(immerCase(clearStreamChatSettings, (newState)=>{
        newState.streamChat = {
            ...newState.streamChat,
            data: {
                ...newState.streamChat.data,
                chatSettings: {
                    // from API
                    allowAccess: EChatAccessLevel.ANY,
                    allowAccessAfter: 0,
                    anyMessageTimeout: 0,
                    blogId: null,
                    sameMessageTimeout: 0,
                    // from stream
                    allowed: true,
                    notRestrictable: false,
                    remainingTime: null,
                    // from cookies
                    isMessagePublishTimeVisible: false,
                    messageTextSize: EChatMessageTextSize.NORMAL,
                    pauseType: EChatPauseType.SCROLL,
                    mode: {
                        value: null,
                        parameters: []
                    }
                }
            }
        };
    }));
};
const streamReducerClearStreamChatThreadMessages = (stream2)=>{
    stream2.withHandling(immerCase(clearStreamChatThreadMessages, (newState)=>{
        newState.streamChatThreadMessages.data.data.mainMessage = null;
        newState.streamChatThreadMessages.data.data.replies = null;
        newState.streamChatThreadMessages.meta.networkStatus = getDefaultNetworkStatus$1();
    }));
};
const streamReducerClearStreamStopWords = (stream2)=>{
    stream2.case(clearStreamStopWords, (store2)=>({
            ...store2,
            streamStopWords: {
                ...store2.streamStopWords,
                data: {
                    isLast: null,
                    offset: 0,
                    data: null
                },
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerCreateStream = (stream2)=>{
    applyAsyncReducer()("stream", "createStreamNetworkStatus", createStream.async, stream2, ({ store: store2, result: result2 })=>{
        var _a3;
        return {
            ...store2.stream.data,
            stream: {
                ...result2,
                chatSettings: (_a3 = store2.stream.data.stream) == null ? void 0 : _a3.chatSettings
            }
        };
    });
};
const streamReducerFetchAccessSelectorSubscriptionLevels = (builder)=>{
    applyAsyncReducer()("accessSelectorSubscriptionLevels", "networkStatus", fetchAccessSelectorSubscriptionLevels.async, builder, ({ result: result2 })=>result2 == null ? void 0 : result2.subscriptionLevels);
};
const streamReducerFetchChat = (stream2)=>{
    applyAsyncReducer()("streamChat", "networkStatus", fetchStreamChat.async, stream2, ({ store: store2, result: result2 })=>({
            ...store2.streamChat.data,
            ...result2,
            data: isStreamApp() ? [
                ...store2.streamChat.data.data,
                ...result2.data
            ] : [
                ...result2.data
            ]
        }));
};
const streamReducerFetchChatSettings = (stream2)=>{
    applyAsyncReducer()("streamChat", "chatSettingsNetworkStatus", fetchChatSettings.async, stream2, ({ store: store2, result: result2 })=>({
            ...store2.streamChat.data,
            chatSettings: {
                ...store2.streamChat.data.chatSettings,
                ...result2,
                mode: getIOModeStoreVariant(result2.mode)
            }
        }));
};
const streamReducerFetchChatThreadMessages = (stream2)=>{
    stream2.withHandling(immerCase(fetchStreamChatThreadMessages.async.started, (newState)=>{
        newState.streamChatThreadMessages.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchStreamChatThreadMessages.async.done, (newState, { result: result2 })=>{
        newState.streamChatThreadMessages.data.data.mainMessage = result2.data.find((item2)=>item2.parent === null);
        newState.streamChatThreadMessages.data.data.replies = result2.data.filter((item2)=>{
            var _a3;
            return Boolean(item2.parent || ((_a3 = item2.flags) == null ? void 0 : _a3.isParentDeleted));
        });
        newState.streamChatThreadMessages.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchStreamChatThreadMessages.async.failed, (newState, { error: error2 })=>{
        newState.streamChatThreadMessages.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamReducerFetchChatUserSearchList = (stream2)=>{
    applyAsyncReducer()("streamChatUserSearchList", "networkStatus", fetchChatUserSearchList.async, stream2, ({ store: store2, result: result2 })=>({
            ...store2.streamChatUserSearchList.data,
            users: result2.data.users
        }));
};
const streamReducerFetchRaidableStreams = (blog2)=>{
    applyAsyncReducer()("streamRaidableStreams", "networkStatus", fetchRaidableStreams.async, blog2, ({ result: result2 })=>result2.data);
};
const streamReducerFetchStopWords = (stream2)=>{
    applyAsyncReducer()("streamStopWords", "networkStatus", fetchStopWords.async, stream2, ({ store: store2, result: result2, params })=>({
            isLast: result2.isLast,
            offset: result2.isLast ? store2.streamStopWords.data.offset : result2.offset,
            data: params.offset != null ? [
                ...store2.streamStopWords.data.data,
                ...result2.data
            ] : result2.data
        }));
};
const streamReducerFetchStream = (stream2)=>{
    stream2.case(fetchStream.async.done, (store2, payload)=>{
        const { result: result2, params: { blogUrl } } = payload;
        return {
            ...store2,
            stream: {
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...result2,
                        blogUrl: blogUrl
                    }
                },
                meta: {
                    ...store2.stream.meta,
                    networkStatus: getNetworkStatusDone$1()
                }
            },
            streamChat: {
                data: {
                    ...store2.streamChat.data,
                    chatSettings: {
                        ...store2.streamChat.data.chatSettings,
                        ...(result2 == null ? void 0 : result2.chatSettings) ?? {}
                    }
                },
                meta: {
                    ...store2.streamChat.meta,
                    chatSettingsNetworkStatus: getNetworkStatusDone$1()
                }
            }
        };
    });
    stream2.case(fetchStream.async.failed, (store2, { error: error2 })=>({
            ...store2,
            stream: {
                data: {
                    ...store2.stream.data,
                    stream: null
                },
                meta: {
                    ...store2.stream.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            },
            streamChat: {
                data: {
                    ...store2.streamChat.data,
                    chatSettings: null
                },
                meta: {
                    ...store2.streamChat.meta,
                    chatSettingsNetworkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const streamReducerFetchStreamChatUsers = (stream2)=>{
    applyAsyncReducer()("streamChatUsers", "networkStatus", fetchStreamChatUsers.async, stream2, ({ result: result2 })=>result2);
};
const streamReducerFetchStreamChatUserStat = (stream2)=>{
    applyAsyncReducer()("streamChatUserStat", "networkStatus", fetchStreamChatUserStat.async, stream2, ({ result: result2 })=>result2);
};
const streamReducerFetchStreamCredentials = (stream2)=>{
    applyAsyncReducer()("stream", "credentialsNetworkStatus", fetchStreamCredentials.async, stream2, ({ store: store2, result: result2 })=>({
            ...store2.stream.data,
            credentials: result2
        }));
};
const streamReducerFetchStreamRandom = (stream2)=>{
    applyAsyncReducer()("random", "networkStatus", fetchStreamRandom.async, stream2, ({ result: result2 })=>result2.data);
};
const streamReducerFetchUserBanStat = (stream2)=>{
    applyAsyncReducer()("streamUsers", "networkStatus", fetchUserBanStat.async, stream2, ({ store: store2, result: result2, params })=>({
            ...store2.streamUsers.data,
            [params.userId]: result2
        }));
};
const streamReducerHideStream = (stream2)=>{
    stream2.withHandling(immerCase(hideStream.async.done, (newState)=>{
        newState.stream.data.stream = {
            ...newState.stream.data.stream,
            isHidden: true
        };
    }));
};
const streamReducerLikeStream = (stream2)=>{
    stream2.withHandling(immerCase(likeStream.async.done, (newState)=>{
        newState.stream.data.stream = {
            ...newState.stream.data.stream,
            count: {
                ...newState.stream.data.stream.count,
                likes: newState.stream.data.stream.count.likes + 1
            },
            isLiked: true
        };
    }));
};
const streamReducerMarkStreamEnded = (stream2)=>{
    stream2.case(markStreamEnded, (store2)=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        isEnded: true,
                        isOnline: false,
                        endTime: Number(/* @__PURE__ */ new Date()) / 1e3
                    }
                }
            }
        }));
};
const streamReducerRegisterStreamPlayer = (stream2)=>{
    stream2.case(registerStreamPlayer, (state, { playerId })=>({
            ...state,
            playerId: playerId
        }));
};
const streamReducerRejectRaid = (stream2)=>{
    stream2.case(rejectRaid.async.done, (store2)=>({
            ...store2,
            streamRaid: {
                ...store2.streamRaid,
                canceled: true
            }
        }));
};
const streamReducerRemoveMentionedUser = (stream2)=>{
    stream2.case(removeMentionedUser, (state)=>({
            ...state,
            streamChatUserSearchList: {
                ...state.streamChatUserSearchList,
                data: {
                    ...state.streamChatUserSearchList.data,
                    mentionedUser: null
                }
            }
        }));
};
const streamReducerRemoveStopWord = (stream2)=>{
    applyAsyncReducer()("streamStopWords", "networkStatus", removeStopWord.async, stream2, ({ store: store2, result: result2, params })=>({
            ...store2.streamStopWords.data,
            data: [
                ...store2.streamStopWords.data.data.filter((word)=>word !== params.word)
            ]
        }));
};
const streamReducerRemoveStream = (stream2)=>{
    applyAsyncReducer()("stream", "networkStatus", removeStream.async, stream2, ({ store: store2 })=>({
            ...store2.stream.data,
            stream: null
        }));
};
const streamReducerRemoveStreamChatMessage = (stream2)=>{
    stream2.case(removeStreamChatMessage.async.done, (state, { params })=>{
        var _a3, _b2, _c2, _d, _e;
        return {
            ...state,
            streamChat: {
                ...state.streamChat,
                data: {
                    ...state.streamChat.data,
                    data: state.streamChat.data.data.filter((message2)=>isChatUserMessage(message2) && message2.id !== params.messageId).map((message2)=>removeMessageFromThread$1(message2, params.messageId))
                }
            },
            streamChatFromWebSocket: state.streamChatFromWebSocket.filter((message2)=>isChatUserMessage(message2) && message2.id !== params.messageId).map((message2)=>removeMessageFromThread$1(message2, params.messageId)),
            streamChatMentions: state.streamChatMentions.filter((message2)=>isChatUserMessage(message2) && message2.id !== params.messageId).map((message2)=>removeMessageFromThread$1(message2, params.messageId)),
            streamChatThreadMessages: {
                ...state.streamChatThreadMessages,
                data: {
                    ...state.streamChatThreadMessages.data,
                    data: {
                        ...state.streamChatThreadMessages.data.data,
                        mainMessage: ((_b2 = (_a3 = state.streamChatThreadMessages.data.data) == null ? void 0 : _a3.mainMessage) == null ? void 0 : _b2.id) !== params.messageId ? (_c2 = state.streamChatThreadMessages.data.data) == null ? void 0 : _c2.mainMessage : null,
                        replies: (_e = (_d = state.streamChatThreadMessages.data.data) == null ? void 0 : _d.replies) == null ? void 0 : _e.filter((message2)=>message2.id !== params.messageId)
                    }
                }
            }
        };
    });
};
const removeMessageFromThread$1 = (message2, id)=>{
    var _a3;
    if (isChatUserMessage(message2) && id === ((_a3 = message2.parent) == null ? void 0 : _a3.id)) message2 = {
        ...message2,
        parent: null,
        flags: {
            isParentDeleted: true
        }
    };
    return message2;
};
const streamReducerRemoveStreamChatMessageFromWs = (stream2)=>{
    stream2.case(removeStreamChatMessageFromWS, (state, { messageId })=>{
        var _a3, _b2, _c2, _d, _e;
        return {
            ...state,
            streamChat: {
                ...state.streamChat,
                data: {
                    ...state.streamChat.data,
                    data: state.streamChat.data.data.filter((message2)=>isChatUserMessage(message2) && message2.id !== messageId).map((message2)=>removeMessageFromThread(message2, messageId))
                }
            },
            streamChatFromWebSocket: state.streamChatFromWebSocket.filter((message2)=>isChatUserMessage(message2) && message2.id !== messageId).map((message2)=>removeMessageFromThread(message2, messageId)),
            streamChatMentions: state.streamChatMentions.filter((message2)=>isChatUserMessage(message2) && message2.id !== messageId).map((message2)=>removeMessageFromThread(message2, messageId)),
            streamChatThreadMessages: {
                ...state.streamChatThreadMessages,
                data: {
                    ...state.streamChatThreadMessages.data,
                    data: {
                        ...state.streamChatThreadMessages.data.data,
                        mainMessage: ((_b2 = (_a3 = state.streamChatThreadMessages.data.data) == null ? void 0 : _a3.mainMessage) == null ? void 0 : _b2.id) !== messageId ? (_c2 = state.streamChatThreadMessages.data.data) == null ? void 0 : _c2.mainMessage : null,
                        replies: (_e = (_d = state.streamChatThreadMessages.data.data) == null ? void 0 : _d.replies) == null ? void 0 : _e.filter((message2)=>message2.id !== messageId)
                    }
                }
            }
        };
    });
};
const removeMessageFromThread = (message2, id)=>{
    var _a3;
    if (isChatUserMessage(message2) && id === ((_a3 = message2.parent) == null ? void 0 : _a3.id)) message2 = {
        ...message2,
        parent: null,
        flags: {
            isParentDeleted: true
        }
    };
    return message2;
};
const streamReducerRemoveStreamChatMessagesByUserIdFromMentions = (stream2)=>{
    stream2.case(removeStreamChatMessagesByUserIdFromMentions, (state, { userId })=>({
            ...state,
            streamChatMentions: state.streamChatMentions.filter((message2)=>isChatUserMessage(message2) && message2.user.id !== userId)
        }));
};
const streamReducerRemoveStreamChatMessagesByUserIdFromWS = (stream2)=>{
    stream2.case(removeStreamChatMessagesByUserIdFromWS, (state, { userId })=>({
            ...state,
            streamChatFromWebSocket: state.streamChatFromWebSocket.filter((message2)=>isChatUserMessage(message2) && message2.user.id !== userId)
        }));
};
const streamReducerRemoveStreamChatMessagesByUserIdLocally = (stream2)=>{
    stream2.case(removeStreamChatMessagesByUserIdLocally, (store2, { userId })=>({
            ...store2,
            streamChat: {
                ...store2.streamChat,
                data: {
                    ...store2.streamChat.data,
                    data: store2.streamChat.data.data.filter((message2)=>isChatUserMessage(message2) && message2.author.id !== userId)
                }
            }
        }));
};
const streamReducerRemoveStreamChatMessagesFromMentions = (stream2)=>{
    stream2.case(removeStreamChatMessagesFromMentions, (state, ids)=>({
            ...state,
            streamChatMentions: clearChatMessages(state.streamChatMentions, ids)
        }));
};
const streamReducerRemoveStreamChatMessagesFromWS = (stream2)=>{
    stream2.case(removeStreamChatMessagesFromWS, (state, ids)=>({
            ...state,
            streamChatFromWebSocket: clearChatMessages(state.streamChatFromWebSocket, ids)
        }));
};
const streamReducerRemoveStreamChatMessagesLocally = (stream2)=>{
    stream2.case(removeStreamChatMessagesLocally, (store2, ids)=>({
            ...store2,
            streamChat: {
                ...store2.streamChat,
                data: {
                    ...store2.streamChat.data,
                    data: clearChatMessages(store2.streamChat.data.data, ids)
                }
            }
        }));
};
const streamReducerRemoveStreamFromHidden = (stream2)=>{
    stream2.withHandling(immerCase(removeStreamFromHidden.async.done, (newState)=>{
        newState.stream.data.stream = {
            ...newState.stream.data.stream,
            isHidden: false
        };
    }));
};
const streamReducerResetStream = (stream2)=>{
    stream2.case(resetStream, (store2)=>({
            ...store2,
            stream: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    credentialsNetworkStatus: getDefaultNetworkStatus$1(),
                    createStreamNetworkStatus: getDefaultNetworkStatus$1(),
                    updateStreamNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerSetActiveIndexPopover = (stream2)=>{
    stream2.case(setActiveIndexPopover, (state, { activeIndexPopover })=>({
            ...state,
            streamChatUserSearchList: {
                ...state.streamChatUserSearchList,
                data: {
                    ...state.streamChatUserSearchList.data,
                    activeIndexPopover: activeIndexPopover ?? 0
                }
            }
        }));
};
const streamReducerSetStreamChatIsPaused = (stream2)=>{
    stream2.case(setStreamChatIsPaused, (state, value2)=>{
        return {
            ...state,
            streamChatIsPaused: value2
        };
    });
};
const streamReducerSetStreamData = (stream2)=>{
    stream2.case(setStreamData, (store2, payload)=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        ...payload
                    }
                }
            }
        }));
};
const streamReducerSetStreamIsOnline = (stream2)=>{
    stream2.case(setStreamIsOnline, (store2, payload)=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        isOnline: payload.isOnline,
                        ...payload.isOnline ? {
                            isEnded: false
                        } : {}
                    }
                }
            }
        }));
};
const streamReducerSetStreamRaid = (stream2)=>{
    stream2.case(setStreamRaid, (store2, result2)=>{
        var _a3;
        const { blogUrl, owner, targetOwner, viewersCount, status, ownerBlogUrl } = result2;
        return {
            ...store2,
            streamRaid: {
                ...store2.streamRaid,
                blogUrl: blogUrl,
                owner: owner,
                targetOwner: targetOwner,
                viewersCount: viewersCount,
                status: status,
                canceled: Boolean((_a3 = store2 == null ? void 0 : store2.streamRaid) == null ? void 0 : _a3.canceled),
                ownerBlogUrl: ownerBlogUrl
            }
        };
    });
    stream2.case(resetStreamRaidLoaded, (store2)=>{
        return {
            ...store2,
            streamRaidLoaded: false
        };
    });
    stream2.case(fetchStreamRaid.async.failed, (store2)=>{
        return {
            ...store2,
            streamRaidLoaded: true
        };
    });
    stream2.case(fetchStreamRaid.async.done, (store2, { result: result2 })=>{
        var _a3, _b2;
        const blogUrl = result2.target.blogUrl;
        const targetOwner = result2.target.owner;
        const timestamp = result2.createTime * 1e3;
        const canceled = Boolean((_a3 = store2 == null ? void 0 : store2.streamRaid) == null ? void 0 : _a3.canceled);
        const isStarted = !(result2 == null ? void 0 : result2.status) || (result2 == null ? void 0 : result2.status) === ERaidStatus.STARTED;
        return {
            ...store2,
            streamRaid: isStarted ? {} : {
                ...result2,
                blogUrl: blogUrl,
                targetOwner: targetOwner,
                timestamp: timestamp,
                canceled: canceled,
                owner: {
                    ...result2.owner,
                    ...result2.owner.owner
                },
                ownerBlogUrl: (_b2 = result2 == null ? void 0 : result2.owner) == null ? void 0 : _b2.blogUrl
            },
            streamRaidLoaded: true
        };
    });
};
const streamReducerSetStreamViewers = (stream2)=>{
    stream2.case(setStreamViewers, (store2, { viewers: viewers2 })=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        count: {
                            ...store2.stream.data.stream.count,
                            viewers: viewers2
                        }
                    }
                }
            }
        }));
};
const streamReducerClearShowcase = (streams)=>{
    streams.case(clearStreamShowcase, (state, {})=>({
            ...state,
            showcase: {
                stream: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerUpdateShowcase = (streams)=>{
    streams.case(updateStreamShowcase, (state, { data })=>{
        var _a3, _b2;
        const showcaseStream = (_a3 = state.showcase) == null ? void 0 : _a3.stream;
        const { streamId, viewers: viewers2, isOnline, title: title2 } = data;
        const isFieldsChanged = viewers2 !== ((_b2 = showcaseStream == null ? void 0 : showcaseStream.count) == null ? void 0 : _b2.viewers) || isOnline !== showcaseStream.isOnline || title2 !== showcaseStream.title;
        if ((showcaseStream == null ? void 0 : showcaseStream.id) === streamId && isFieldsChanged) return {
            ...state,
            showcase: {
                ...state.showcase,
                stream: {
                    ...showcaseStream,
                    isOnline: isOnline,
                    title: title2,
                    count: {
                        ...showcaseStream.count,
                        viewers: viewers2
                    }
                }
            }
        };
        return state;
    });
};
const streamReducerFetchShowcase = (streams)=>{
    streams.withHandling(immerCase(fetchStreamShowcase.async.started, (newState)=>{
        newState.showcase.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchStreamShowcase.async.done, (newState, { result: result2 })=>{
        newState.showcase.stream = result2;
        newState.showcase.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchStreamShowcase.async.failed, (newState, { error: error2 })=>{
        newState.showcase.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamReducerStreamChatPinnedMessage = (stream2)=>{
    stream2.case(fetchPinnedMessage.async.done, (store2, payload)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: payload.result.data,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(fetchPinnedMessage.async.failed, (store2)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: null,
                meta: {
                    networkStatus: getNetworkStatusFailed$1(null)
                }
            }
        }));
    stream2.case(pinChatMessage.async.done, (store2, { params })=>({
            ...store2,
            streamChatPinnedMessage: {
                ...store2.streamChatPinnedMessage,
                data: {
                    ...store2.streamChatPinnedMessage.data,
                    messageId: params.messageId
                }
            }
        }));
    stream2.case(pinChatMessageWS, (store2, data)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: data,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(editPinnedChatMessageWS, (store2, data)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: {
                    ...data,
                    reacted: store2.streamChatPinnedMessage.data.reacted
                },
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(unpinChatMessageWS, (store2)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: null,
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(addPinnedChatMessageReaction.async.done, (store2, { params })=>({
            ...store2,
            streamChatPinnedMessage: {
                data: {
                    ...store2.streamChatPinnedMessage.data,
                    reacted: params.reaction
                },
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(addChatMessageReactionWS, (store2, data)=>({
            ...store2,
            streamChatPinnedMessage: {
                data: {
                    ...store2.streamChatPinnedMessage.data,
                    reactions: data
                },
                meta: {
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        }));
    stream2.case(setStreamBlocksPinnedHidden, (store2, data)=>({
            ...store2,
            streamBlocksPinnedHiddenItems: data
        }));
    stream2.case(clearStreamBlocksPinnedHidden, (store2)=>({
            ...store2,
            streamBlocksPinnedHiddenItems: []
        }));
};
const streamReducerStreamChatUsersReset = (stream2)=>{
    stream2.case(streamChatUsersReset, (store2)=>({
            ...store2,
            streamChatUsers: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerStreamChatUserStatReset = (stream2)=>{
    stream2.case(streamChatUserStatReset, (store2)=>({
            ...store2,
            streamChatUserStat: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerStreamLikesCounterUpdate = (stream2)=>{
    stream2.case(streamLikesCounterUpdate, (store2, { streamLikesCounter })=>({
            ...store2,
            stream: {
                ...store2.stream,
                data: {
                    ...store2.stream.data,
                    stream: {
                        ...store2.stream.data.stream,
                        count: {
                            ...store2.stream.data.stream.count,
                            likes: streamLikesCounter
                        }
                    }
                }
            }
        }));
};
const streamReducerStreamRaid = (stream2)=>{
    applyAsyncReducer()("streamRaidUserState", "networkStatus", fetchRaidUserState.async, stream2, ({ result: result2 })=>result2);
    stream2.case(cleanRaidUserState, (store2)=>({
            ...store2,
            streamRaidUserState: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerToggleVisibilityDropInstruction = (stream2)=>{
    stream2.case(toggleVisibilityDropInstruction, (store2, isEnabled)=>({
            ...store2,
            streamChat: {
                ...store2.streamChat,
                data: {
                    ...store2.streamChat.data,
                    isDropInstruction: isEnabled
                }
            }
        }));
};
const streamReducerUnblockStreamChatUsers = (stream2)=>{
    stream2.withHandling(immerCase(unblockUser.async.done, (newState, { params: { userId } })=>{
        newState.streamChatUsers.data.data.permanentBannedUsers = newState.streamChatUsers.data.data.permanentBannedUsers.filter((item2)=>item2.id !== userId);
        newState.streamChatUsers.data.data.temporaryBannedUsers = newState.streamChatUsers.data.data.temporaryBannedUsers.filter((item2)=>item2.id !== userId);
    }));
};
const streamReducerUnblockUser = (stream2)=>{
    applyAsyncReducer()("streamUsers", "networkStatus", unblockUser.async, stream2, ({ store: store2, result: result2, params })=>({
            ...store2.streamUsers.data,
            [params.userId]: result2
        }));
};
const streamReducerUnlikeStream = (stream2)=>{
    stream2.withHandling(immerCase(unlikeStream.async.done, (newState)=>{
        newState.stream.data.stream = {
            ...newState.stream.data.stream,
            count: {
                ...newState.stream.data.stream.count,
                likes: newState.stream.data.stream.count.likes - 1
            },
            isLiked: false
        };
    }));
};
const streamReducerUnregisterStreamPlayer = (stream2)=>{
    stream2.case(unregisterStreamPlayer, (state)=>({
            ...state,
            playerId: ""
        }));
};
const streamReducerUpdateChatBanStatusFromWs = (stream2)=>{
    stream2.case(updateChatBanStatusFromWS, (state, { isBanned, blogId, ownerId, remainingTime = null, isByStream = false })=>{
        if (ownerId !== blogId) return state;
        return {
            ...state,
            streamChat: {
                ...state.streamChat,
                data: {
                    ...state.streamChat.data,
                    banRemainingTime: remainingTime,
                    isBanned: isBanned,
                    isBannedByStreamEnd: isByStream
                }
            }
        };
    });
};
const streamReducerUpdateChatMode = (stream2)=>{
    stream2.withHandling(immerCase(updateChatMode, (newState, { mode: mode2 })=>{
        newState.streamChat.data.streamChatMode = mode2;
    }));
};
const streamReducerUpdateChatSettingsFromCookies = (stream2)=>{
    stream2.case(updateChatSettingsFromCookies, (state, { chatSettingsFromCookies })=>({
            ...state,
            streamChat: {
                ...state.streamChat,
                data: {
                    ...state.streamChat.data,
                    chatSettings: {
                        ...state.streamChat.data.chatSettings,
                        ...chatSettingsFromCookies
                    }
                }
            }
        }));
};
const streamReducerUpdateChatSettingsFromWS = (stream2)=>{
    stream2.case(updateChatSettingsFromWS, (state, { blogId, ownerId, ...chatSettings })=>{
        if (ownerId !== blogId) return state;
        return {
            ...state,
            streamChat: {
                ...state.streamChat,
                data: {
                    ...state.streamChat.data,
                    chatSettings: {
                        ...state.streamChat.data.chatSettings,
                        ...chatSettings,
                        mode: getIOModeStoreVariant(chatSettings.mode)
                    }
                }
            }
        };
    });
};
const streamReducerUpdateStream = (stream2)=>{
    applyAsyncReducer()("stream", "updateStreamNetworkStatus", updateStream.async, stream2, ({ store: store2, result: result2 })=>({
            ...store2.stream.data,
            stream: result2
        }));
};
const streamReducerUpdateStreamChatPermanentBannedUsersFromWS = (stream2)=>{
    stream2.withHandling(immerCase(updateStreamChatPermanentBannedUsersFromWS, (newState, user)=>{
        newState.streamChatUsers.data.data.permanentBannedUsers = [
            ...newState.streamChatUsers.data.data.permanentBannedUsers || [],
            user
        ];
    }));
};
const streamReducerUpdateStreamChatTemporaryBannedUsersFromWS = (stream2)=>{
    stream2.withHandling(immerCase(updateStreamChatTemporaryBannedUsersFromWS, (newState, user)=>{
        newState.streamChatUsers.data.data.temporaryBannedUsers = [
            ...newState.streamChatUsers.data.data.temporaryBannedUsers || [],
            user
        ];
    }));
};
const streamReducerClearUserCard = (streams)=>{
    streams.case(clearStreamUserCard, (state, {})=>({
            ...state,
            streamUserCard: {
                stream: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const streamReducerFetchUserCard = (streams)=>{
    streams.withHandling(immerCase(fetchStreamUserCard.async.started, (newState)=>{
        newState.streamUserCard.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchStreamUserCard.async.done, (newState, { result: result2 })=>{
        newState.streamUserCard.stream = result2;
        newState.streamUserCard.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchStreamUserCard.async.failed, (newState, { error: error2 })=>{
        newState.streamUserCard.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getStreamInitialState = ()=>({
        stream: {
            data: {
                stream: null,
                credentials: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createStreamNetworkStatus: getDefaultNetworkStatus$1(),
                credentialsNetworkStatus: getDefaultNetworkStatus$1(),
                updateStreamNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        showcase: {
            stream: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChat: {
            data: {
                banRemainingTime: null,
                chatSettings: {
                    // from API
                    allowAccess: EChatAccessLevel.ANY,
                    allowAccessAfter: 0,
                    anyMessageTimeout: 0,
                    blogId: null,
                    sameMessageTimeout: 0,
                    mode: {
                        value: null,
                        parameters: []
                    },
                    // from stream
                    allowed: true,
                    notRestrictable: false,
                    remainingTime: null,
                    // from cookies
                    isMessagePublishTimeVisible: false,
                    messageTextSize: EChatMessageTextSize.NORMAL,
                    pauseType: EChatPauseType.SCROLL
                },
                isBanned: null,
                isBannedByStreamEnd: false,
                isLast: true,
                streamChatMode: EChatMode.CHAT,
                offset: 0,
                data: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                chatSettingsNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamBlocksPinnedHiddenItems: [],
        streamChatPinnedMessage: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamRaid: {},
        streamRaidLoaded: false,
        streamRaidUserState: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamRaidableStreams: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamUsers: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChatUsers: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChatUserStat: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChatMentions: [],
        streamStopWords: {
            data: {
                isLast: true,
                offset: 0,
                data: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChatUserSearchList: {
            data: {
                users: null,
                mentionedUser: null,
                activeIndexPopover: 0
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamChatFromWebSocket: [],
        streamChatIsPaused: false,
        streamChatThreadMessages: {
            data: {
                data: {
                    mainMessage: null,
                    replies: null
                },
                extra: {
                    isBaned: null,
                    isLast: null
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        random: {
            data: {
                url: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        accessSelectorSubscriptionLevels: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        streamUserCard: {
            stream: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        playerId: ""
    });
const stream = (0, $ki1Eq.reducerWithInitialState)(getStreamInitialState());
streamReducerClearShowcase(stream);
streamReducerFetchShowcase(stream);
streamReducerUpdateShowcase(stream);
streamReducerFetchChat(stream);
streamReducerCleanStreamChatMessages(stream);
streamReducerRemoveStreamChatMessageFromWs(stream);
streamReducerRemoveStreamChatMessagesByUserIdLocally(stream);
streamReducerChatMessageByUserIdFromWs(stream);
streamReducerCleanStreamChatMessagesFromWs(stream);
streamReducerClearStreamChat(stream);
streamReducerClearStreamChatSettings(stream);
streamReducerHideStream(stream);
streamReducerRemoveStreamFromHidden(stream);
streamReducerLikeStream(stream);
streamReducerUnlikeStream(stream);
streamReducerFetchStream(stream);
streamReducerFetchStreamRandom(stream);
streamReducerCreateStream(stream);
streamReducerUpdateStream(stream);
streamReducerRemoveStream(stream);
streamReducerFetchStreamCredentials(stream);
streamReducerFetchStopWords(stream);
streamReducerStreamRaid(stream);
streamReducerFetchRaidableStreams(stream);
streamReducerAddStopWord(stream);
streamReducerRemoveStopWord(stream);
streamReducerFetchUserBanStat(stream);
streamReducerUnblockUser(stream);
streamReducerResetStream(stream);
streamReducerSetStreamData(stream);
streamReducerClearStream(stream);
streamReducerClearStreamStopWords(stream);
streamReducerSetStreamViewers(stream);
streamReducerStreamLikesCounterUpdate(stream);
streamChangeStreamOnlineStatus(stream);
streamReducerMarkStreamEnded(stream);
streamReducerUpdateChatBanStatusFromWs(stream);
streamReducerUpdateChatMode(stream);
streamReducerFetchStreamChatUsers(stream);
streamReducerUnblockStreamChatUsers(stream);
streamReducerStreamChatUsersReset(stream);
streamReducerFetchStreamChatUserStat(stream);
streamReducerStreamChatUserStatReset(stream);
streamReducerFetchChatUserSearchList(stream);
streamReducerAddMentionedUser(stream);
streamReducerRemoveMentionedUser(stream);
streamReducerCleanStreamChatUserSearchList(stream);
streamReducerUpdateChatSettingsFromCookies(stream);
streamReducerUpdateChatSettingsFromWS(stream);
streamReducerFetchChatSettings(stream);
streamReducerRejectRaid(stream);
streamReducerSetStreamRaid(stream);
streamReducerCleanStreamRaid(stream);
streamReducerSetStreamIsOnline(stream);
streamReducerRemoveStreamChatMessage(stream);
streamReducerSetStreamChatIsPaused(stream);
streamReducerAddNewStreamChatMessages(stream);
streamReducerAddNewMentionChatMessages(stream);
streamReducerRemoveStreamChatMessagesByUserIdFromWS(stream);
streamReducerRemoveStreamChatMessagesByUserIdFromMentions(stream);
streamReducerCleanStreamChatMentions(stream);
streamReducerSetActiveIndexPopover(stream);
streamReducerStreamChatPinnedMessage(stream);
streamReducerAssignUserRoles(stream);
streamReducerFetchChatThreadMessages(stream);
streamReducerClearStreamChatThreadMessages(stream);
streamReducerRemoveStreamChatMessagesLocally(stream);
streamReducerRemoveStreamChatMessagesFromWS(stream);
streamReducerRemoveStreamChatMessagesFromMentions(stream);
streamReducerUpdateStreamChatTemporaryBannedUsersFromWS(stream);
streamReducerUpdateStreamChatPermanentBannedUsersFromWS(stream);
streamReducerFetchAccessSelectorSubscriptionLevels(stream);
streamReducerClearUserCard(stream);
streamReducerFetchUserCard(stream);
streamReducerRegisterStreamPlayer(stream);
streamReducerUnregisterStreamPlayer(stream);
streamReducerToggleVisibilityDropInstruction(stream);
const streamSlotsChannelPageReducer = (streamSlots2)=>{
    applyAsyncReducer()("channelPage", "networkStatus", fetchChannelPageStreamSlots.async, streamSlots2, ({ result: result2 })=>result2.data);
    streamSlots2.case(clearChannelPageStreamSlots, (state, type)=>({
            ...state,
            channelPage: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
    streamSlots2.case(updateChannelPageStreamSlotOnlineStatus, (state, slot)=>{
        var _a3;
        const foundElementId = (_a3 = state.channelPage.data) == null ? void 0 : _a3.findIndex((element)=>{
            var _a4, _b2;
            return ((_a4 = element.streamSlot) == null ? void 0 : _a4.id) === ((_b2 = slot.streamSlot) == null ? void 0 : _b2.id);
        });
        if (foundElementId === -1) return state;
        const updatedData = [
            ...state.channelPage.data
        ];
        updatedData[foundElementId] = {
            ...updatedData[foundElementId],
            isOnline: slot.isOnline,
            count: {
                ...updatedData[foundElementId].count,
                viewers: slot.viewers
            },
            ...slot.category && slot.streamId ? {
                category: slot.category,
                id: slot.streamId
            } : {}
        };
        return {
            ...state,
            channelPage: {
                ...state.channelPage,
                data: updatedData
            }
        };
    });
    streamSlots2.case(updateChannelPageStreamSlot, (state, slotWithFlag)=>{
        const { isDeleted, ...slot } = slotWithFlag;
        if (!state.channelPage.data) return state;
        const foundElementId = state.channelPage.data.findIndex((element)=>element.id === slot.id);
        const updatedData = [
            ...state.channelPage.data
        ];
        if (foundElementId) updatedData[foundElementId] = isDeleted ? null : slot.isOnline ? {
            ...slot,
            data: updatedData[foundElementId].data
        } : slot;
        else updatedData.push(slot);
        return {
            ...state,
            channelPage: {
                ...state.channelPage,
                data: updatedData.filter(Boolean)
            }
        };
    });
};
const streamSlotCreateStreamSlotReducer = (streamSlots2)=>{
    streamSlots2.withHandling(immerCase(createStreamSlot.async.started, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createStreamSlot.async.done, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createStreamSlot.async.failed, (newState, { error: error2 })=>{
        newState.studio.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamSlotDeleteStreamSlotReducer = (streamSlots2)=>{
    streamSlots2.withHandling(immerCase(deleteStreamSlot.async.started, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deleteStreamSlot.async.done, (newState, { params })=>{
        newState.studio.data.data = newState.studio.data.data.filter((slot)=>slot.id !== params.slotId);
        newState.studio.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(deleteStreamSlot.async.failed, (newState, { error: error2 })=>{
        newState.studio.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamSlotEditStreamSlotReducer = (streamSlots2)=>{
    streamSlots2.withHandling(immerCase(editStreamSlot.async.started, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editStreamSlot.async.done, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(editStreamSlot.async.failed, (newState, { error: error2 })=>{
        newState.studio.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const streamSlotsFetchStreamSlotsReducer = (streamSlots2)=>{
    streamSlots2.withHandling(immerCase(fetchStreamSlots.async.started, (newState)=>{
        newState.studio.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchStreamSlots.async.done, (newState, { result: result2 })=>{
        newState.studio.data.data = result2.streamSlots;
        newState.studio.data.extra = result2.extra;
        newState.studio.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchStreamSlots.async.failed, (newState, { error: error2 })=>{
        newState.studio.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const getStreamSlotsInitialState = ()=>({
        channelPage: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        studio: {
            data: {
                data: [],
                extra: {
                    total: 0,
                    isLast: true,
                    offset: 0
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const streamSlots = (0, $ki1Eq.reducerWithInitialState)(getStreamSlotsInitialState());
streamSlotsFetchStreamSlotsReducer(streamSlots);
streamSlotDeleteStreamSlotReducer(streamSlots);
streamSlotCreateStreamSlotReducer(streamSlots);
streamSlotEditStreamSlotReducer(streamSlots);
streamSlotsChannelPageReducer(streamSlots);
const subscriptionGiftReducerClearSubscriptionGiftsExternalBlog = (subscriptions2)=>{
    subscriptions2.case(clearSubscriptionGiftExternalBlog, (store2)=>({
            ...store2,
            subscriptionGiftExternalBlog: {
                data: null,
                isOpenSendGiftPopup: false,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const subscriptionGiftReducerFetchSubscriptionGifts = (subscriptions2)=>{
    subscriptions2.withHandling(immerCase(fetchSubscriptionGift.async.started, (newState, { isExternalBlog })=>{
        if (isExternalBlog) newState.subscriptionGiftExternalBlog.meta.networkStatus = getNetworkStatusStarted$1();
        else newState.subscriptionGift.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchSubscriptionGift.async.done, (newState, { result: result2, params: { isExternalBlog } })=>{
        if (isExternalBlog) {
            newState.subscriptionGiftExternalBlog.data = result2.gifts;
            newState.subscriptionGiftExternalBlog.meta.networkStatus = getNetworkStatusDone$1();
        } else {
            newState.subscriptionGift.data = result2.gifts;
            newState.subscriptionGift.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(fetchSubscriptionGift.async.failed, (newState, { params: { isExternalBlog }, error: error2 })=>{
        if (isExternalBlog) newState.subscriptionGiftExternalBlog.meta.networkStatus = getNetworkStatusFailed$1(error2);
        else newState.subscriptionGift.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const generateNewGiftsState = (state, data)=>({
        ...state,
        subscriptionGift: {
            ...state.subscriptionGift,
            data: data
        }
    });
const getSubscriptionGiftInitialState = ()=>({
        subscriptionGift: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        subscriptionGiftExternalBlog: {
            data: null,
            isOpenSendGiftPopup: false,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        autofillGiftUser: null
    });
const subscriptionGift = (0, $ki1Eq.reducerWithInitialState)(getSubscriptionGiftInitialState());
subscriptionGiftReducerFetchSubscriptionGifts(subscriptionGift);
subscriptionGiftReducerClearSubscriptionGiftsExternalBlog(subscriptionGift);
subscriptionGift.case(setSubscriptionGiftExternalBlogStatusSendGiftPopup, (state, isOpen)=>({
        ...state,
        subscriptionGiftExternalBlog: {
            ...state.subscriptionGiftExternalBlog,
            isOpenSendGiftPopup: isOpen
        }
    })).case(clearSubscriptionGift, (state)=>({
        ...state,
        ...getSubscriptionGiftInitialState()
    })).case(addSubscriptionGift, (state, { levelId, count: count2, levelInfo })=>{
    let wasIncremented = false;
    const gifts = (state.subscriptionGift.data ?? []).map((gift2)=>{
        if (gift2.subscriptionLevel.id === levelId) {
            wasIncremented = true;
            return {
                ...gift2,
                count: gift2.count + count2
            };
        }
        return gift2;
    });
    if (!wasIncremented) gifts.push({
        subscriptionLevel: {
            id: levelId,
            name: levelInfo.name,
            price: levelInfo.price
        },
        count: count2
    });
    return generateNewGiftsState(state, gifts);
}).case(decrementSubscriptionGift, (state, { levelId, count: count2 })=>{
    var _a3;
    return {
        ...state,
        subscriptionGift: {
            ...state.subscriptionGift,
            data: (_a3 = state.subscriptionGift.data) == null ? void 0 : _a3.map((item2)=>({
                    ...item2,
                    count: item2.subscriptionLevel.id === levelId ? item2.count - count2 : item2.count
                }))
        }
    };
}).case(setAutofillGiftUser, (state, autofillGiftUser)=>({
        ...state,
        autofillGiftUser: autofillGiftUser
    }));
const getSubscriptionLevelBoostyInitialState = ()=>({
        subscriptionLevelBoosty: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const subscriptionLevelBoosty = (0, $ki1Eq.reducerWithInitialState)(getSubscriptionLevelBoostyInitialState());
applyAsyncReducer()("subscriptionLevelBoosty", "networkStatus", fetchSubscriptionLevelBoosty.async, subscriptionLevelBoosty, (props)=>props.result);
const subscriptionReducerClearBlogSubscriptionLevel = (subscriptions2)=>{
    subscriptions2.case(clearBlogSubscriptionLevel, (store2)=>({
            ...store2,
            subscriptionLevel: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const subscriptionReducerClearSubscriptionLevels = (subscriptions2)=>{
    subscriptions2.case(clearBlogSubscriptionLevels, (store2)=>({
            ...store2,
            subscriptionLevels: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    createNetworkStatus: getDefaultNetworkStatus$1(),
                    editNetworkStatus: getDefaultNetworkStatus$1(),
                    removeNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const subscriptionReducerClearSubscriptionLevelsExternalBlog = (subscriptions2)=>{
    subscriptions2.case(clearBlogSubscriptionLevelsExternalBlog, (store2)=>({
            ...store2,
            subscriptionLevelsExternalBlog: {
                data: null,
                meta: {
                    networkStatus: getDefaultNetworkStatus$1(),
                    createNetworkStatus: getDefaultNetworkStatus$1(),
                    editNetworkStatus: getDefaultNetworkStatus$1(),
                    removeNetworkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const subscriptionReducerClearSubscriptions = (store2, initialState2)=>{
    store2.case(clearSubscriptions, ()=>({
            ...initialState2
        }));
};
const subscriptionReducerCreateSubscriptionLevel = (subscriptions2)=>{
    applyAsyncReducer()("subscriptionLevels", "createNetworkStatus", createBlogSubscriptionLevel.async, subscriptions2, ({ store: store2, result: result2 })=>({
            levels: store2.subscriptionLevels.data.levels.concat(result2.level),
            currentLevelId: store2.subscriptionLevels.data.currentLevelId
        }));
};
const subscriptionReducerEditBlogSubscriptionLevel = (subscriptions2)=>{
    subscriptions2.case(editBlogSubscriptionLevel.async.started, (state)=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                meta: {
                    ...state.subscriptionLevels.meta,
                    editNetworkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(editBlogSubscriptionLevel.async.done, (state, { result: result2 })=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                data: {
                    ...state.subscriptionLevels.data,
                    levels: state.subscriptionLevels.data.levels.map((item2)=>item2.id === result2.level.id ? result2.level : item2)
                },
                meta: {
                    ...state.subscriptionLevels.meta,
                    editNetworkStatus: getNetworkStatusDone$1()
                }
            }
        })).case(editBlogSubscriptionLevel.async.failed, (state, { error: error2 })=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                meta: {
                    ...state.subscriptionLevels.meta,
                    editNetworkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const subscriptionReducerFetchBlogSubscriptionLevel = (subscriptions2)=>{
    subscriptions2.case(fetchBlogSubscriptionLevel.async.started, (state)=>({
            ...state,
            subscriptionLevel: {
                ...state.subscriptionLevel,
                meta: {
                    ...state.subscriptionLevel.meta,
                    networkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(fetchBlogSubscriptionLevel.async.done, (state, { result: result2 })=>({
            ...state,
            subscriptionLevel: {
                ...state.subscriptionLevel,
                data: result2.level,
                meta: {
                    ...state.subscriptionLevel.meta,
                    networkStatus: getNetworkStatusDone$1()
                }
            }
        })).case(fetchBlogSubscriptionLevel.async.failed, (state, { error: error2 })=>({
            ...state,
            subscriptionLevel: {
                ...state.subscriptionLevel,
                meta: {
                    ...state.subscriptionLevel.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const subscriptionReducerFetchBlogSubscriptionLevels = (subscriptions2)=>{
    subscriptions2.withHandling(immerCase(fetchBlogSubscriptionLevels.async.started, (newState, { isExternalBlog })=>{
        if (isExternalBlog) newState.subscriptionLevelsExternalBlog.meta.networkStatus = getNetworkStatusStarted$1();
        else newState.subscriptionLevels.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchBlogSubscriptionLevels.async.done, (newState, { result: result2, params: { blogUrl, isExternalBlog } })=>{
        const data = {
            blogUrl: blogUrl,
            levels: result2.subscriptionLevels,
            subscriptions: result2.subscriptions,
            currentLevelId: result2.currentLevelId,
            nextLevelId: result2.nextLevelId
        };
        if (isExternalBlog) {
            newState.subscriptionLevelsExternalBlog.data = data;
            newState.subscriptionLevelsExternalBlog.meta.networkStatus = getNetworkStatusDone$1();
        } else {
            newState.subscriptionLevels.data = data;
            newState.subscriptionLevels.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(fetchBlogSubscriptionLevels.async.failed, (newState, { params: { isExternalBlog }, error: error2 })=>{
        if (isExternalBlog) newState.subscriptionLevelsExternalBlog.meta.networkStatus = getNetworkStatusFailed$1(error2);
        else newState.subscriptionLevels.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const subscriptionReducerFetchSubscriptions = (store2)=>{
    store2.case(fetchSubscriptions.async.started, (state)=>({
            ...state,
            subscriptions: {
                ...state.subscriptions,
                meta: {
                    ...state.subscriptions.meta,
                    networkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(fetchSubscriptions.async.done, (state, { result: { data: { data: subscriptions2, total, offset: offset2 } } })=>({
            ...state,
            subscriptions: {
                ...state.subscriptions,
                data: offset2 === 0 ? subscriptions2 : [
                    ...state.subscriptions.data,
                    ...subscriptions2
                ],
                meta: {
                    ...state.subscriptions.meta,
                    networkStatus: getNetworkStatusDone$1(),
                    total: total,
                    offset: offset2,
                    isLast: (offset2 === 0 ? 0 : state.subscriptions.data.length) + subscriptions2.length >= total
                }
            }
        })).case(fetchSubscriptions.async.failed, (state, { error: error2 })=>({
            ...state,
            subscriptions: {
                ...state.subscriptions,
                meta: {
                    ...state.subscriptions.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const subscriptionReducerFetchSubscriptionsSettingsData = (subscriptions2)=>{
    subscriptions2.case(fetchSubscriptionsSettingsData.async.started, (state)=>({
            ...state,
            subscriptionsSettings: {
                ...state.subscriptionsSettings,
                meta: {
                    ...state.subscriptionsSettings.meta,
                    networkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(fetchSubscriptionsSettingsData.async.done, (state, { result: result2 })=>{
        if (result2) {
            const { data: { data, total } } = result2;
            return {
                ...state,
                subscriptionsSettings: {
                    ...state.subscriptionsSettings,
                    data: data,
                    meta: {
                        ...state.subscriptionsSettings.meta,
                        networkStatus: getNetworkStatusDone$1(),
                        total: total
                    }
                }
            };
        } else return state;
    }).case(fetchSubscriptionsSettingsData.async.failed, (state, { error: error2 })=>({
            ...state,
            subscriptionsSettings: {
                ...state.subscriptionsSettings,
                meta: {
                    ...state.subscriptionsSettings.meta,
                    networkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const subscriptionReducerRemoveBlogSubscriptionLevelRemove = (subscriptions2)=>{
    subscriptions2.case(removeBlogSubscriptionLevel.async.started, (state)=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                meta: {
                    ...state.subscriptionLevels.meta,
                    removeNetworkStatus: getNetworkStatusStarted$1()
                }
            }
        })).case(removeBlogSubscriptionLevel.async.done, (state, { params })=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                data: {
                    ...state.subscriptionLevels.data,
                    levels: state.subscriptionLevels.data.levels.filter((item2)=>item2.id !== params.levelId)
                },
                meta: {
                    ...state.subscriptionLevels.meta,
                    removeNetworkStatus: getNetworkStatusDone$1()
                }
            }
        })).case(removeBlogSubscriptionLevel.async.failed, (state, { error: error2 })=>({
            ...state,
            subscriptionLevels: {
                ...state.subscriptionLevels,
                meta: {
                    ...state.subscriptionLevels.meta,
                    removeNetworkStatus: getNetworkStatusFailed$1(error2)
                }
            }
        }));
};
const subscriptionReducerResetBlogSubscriptionLevels = (subscriptions2)=>{
    subscriptions2.case(resetBlogSubscriptionLevels, (store2)=>({
            ...store2,
            subscriptionLevels: {
                data: null,
                meta: {
                    createNetworkStatus: getDefaultNetworkStatus$1(),
                    editNetworkStatus: getDefaultNetworkStatus$1(),
                    removeNetworkStatus: getDefaultNetworkStatus$1(),
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const DEFAULT_LIMIT = 30;
const getSubscriptionsInitialState = ()=>({
        subscriptionLevel: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        subscriptionLevels: {
            data: {
                blogUrl: null,
                levels: [],
                subscriptions: [],
                currentLevelId: null,
                nextLevelId: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createNetworkStatus: getDefaultNetworkStatus$1(),
                editNetworkStatus: getDefaultNetworkStatus$1(),
                removeNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        subscriptionLevelsExternalBlog: {
            data: {
                blogUrl: null,
                levels: [],
                subscriptions: [],
                currentLevelId: null,
                nextLevelId: null
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                createNetworkStatus: getDefaultNetworkStatus$1(),
                editNetworkStatus: getDefaultNetworkStatus$1(),
                removeNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        subscriptions: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                limit: DEFAULT_LIMIT,
                total: 0,
                isLast: true
            }
        },
        subscriptionsSettings: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                limit: DEFAULT_LIMIT,
                total: 0
            }
        }
    });
const subscriptions = (0, $ki1Eq.reducerWithInitialState)(getSubscriptionsInitialState());
subscriptionReducerFetchSubscriptions(subscriptions);
subscriptionReducerCreateSubscriptionLevel(subscriptions);
subscriptionReducerEditBlogSubscriptionLevel(subscriptions);
subscriptionReducerFetchBlogSubscriptionLevel(subscriptions);
subscriptionReducerRemoveBlogSubscriptionLevelRemove(subscriptions);
subscriptionReducerFetchBlogSubscriptionLevels(subscriptions);
subscriptionReducerResetBlogSubscriptionLevels(subscriptions);
subscriptionReducerClearSubscriptions(subscriptions, getSubscriptionsInitialState());
subscriptionReducerClearBlogSubscriptionLevel(subscriptions);
subscriptionReducerFetchSubscriptionsSettingsData(subscriptions);
subscriptionReducerClearSubscriptionLevels(subscriptions);
subscriptionReducerClearSubscriptionLevelsExternalBlog(subscriptions);
const getSupportProgramInitialState = ()=>({
        archive: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentSeason: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1(),
                subscribeNetworkStatus: getDefaultNetworkStatus$1(),
                dailyStatNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        finishedSeason: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        seasons: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        seasonsHistory: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        inn: {
            data: {
                status: null,
                widgetUrl: null
            },
            meta: {
                bindingNetworkStatus: getDefaultNetworkStatus$1(),
                checkingNetworkStatus: getDefaultNetworkStatus$1()
            }
        },
        bankCards: {
            data: {
                bankCards: null,
                bindUrl: null,
                isBankCardsListBeingUpdated: false
            },
            meta: {
                bindingNetworkStatus: getDefaultNetworkStatus$1(),
                fetchingNetworkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const supportProgramReducerFetchArchive = (supportProgram2)=>{
    applyAsyncReducer()("archive", "networkStatus", fetchSupportProgramArchive.async, supportProgram2, ({ store: store2, result: result2 })=>result2.seasons);
};
const supportProgramReducerFetchBankCards = (supportProgram2)=>{
    applyAsyncReducer()("bankCards", "fetchingNetworkStatus", fetchSupportProgramBankCards.async, supportProgram2, ({ store: store2, result: result2 })=>({
            ...store2.bankCards.data,
            bankCards: result2.bankCards,
            isBankCardsListBeingUpdated: result2.isBankCardsListBeingUpdated
        }));
};
const supportProgramReducerBindBankCards = (supportProgram2)=>{
    applyAsyncReducer()("bankCards", "bindingNetworkStatus", bindSupportProgramBankCards.async, supportProgram2, ({ store: store2, result: result2 })=>({
            ...store2.bankCards.data,
            ...result2
        }));
};
const supportProgramReducerUpdateBankCards = (supportProgram2)=>{
    applyAsyncReducer()("bankCards", "fetchingNetworkStatus", updateSupportProgramBankCards.async, supportProgram2, ({ store: store2, result: result2 })=>({
            ...store2.bankCards.data,
            bankCards: result2.bankCards,
            isBankCardsListBeingUpdated: result2.isBankCardsListBeingUpdated
        }));
};
const supportProgramReducerUpdateBankCardsFromWS = (supportProgram2)=>{
    supportProgram2.withHandling(immerCase(updateSupportProgramBankCardsFromWS, (newState, { bankCards })=>{
        newState.bankCards.data.bankCards = bankCards;
        newState.bankCards.data.isBankCardsListBeingUpdated = false;
        newState.bankCards.meta.bindingNetworkStatus.isFetched = true;
        newState.bankCards.meta.bindingNetworkStatus.error = null;
    }));
};
const supportProgramReducerClear = (supportProgram2)=>{
    supportProgram2.case(clearSupportProgram, ()=>getSupportProgramInitialState());
};
const supportProgramReducerClearBankCardBindUrl = (supportProgram2)=>{
    supportProgram2.withHandling(immerCase(clearSupportProgramBankCardBindUrl, (newState)=>{
        newState.bankCards.data.bindUrl = null;
        newState.bankCards.meta.bindingNetworkStatus = getDefaultNetworkStatus$1();
    }));
};
const supportProgramReducerClearInnBindWidget = (supportProgram2)=>{
    supportProgram2.withHandling(immerCase(clearSupportProgramInnWidgetUrl, (newState)=>{
        newState.inn.data.widgetUrl = null;
        newState.inn.meta.bindingNetworkStatus = getDefaultNetworkStatus$1();
        newState.inn.meta.checkingNetworkStatus = getDefaultNetworkStatus$1();
    }));
};
const supportProgramReducerFetchCurrentSeason = (supportProgram2)=>{
    supportProgram2.withHandling(immerCase(fetchSupportProgramCurrentSeason.async.started, (newState, payload)=>{
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusStarted$1();
        newState.currentSeason.meta.networkStatus = getNetworkStatusStarted$1();
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(fetchSupportProgramCurrentSeason.async.done, (newState, payload)=>{
        newState.currentSeason.data = payload.result.season;
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusDone$1();
        newState.currentSeason.meta.networkStatus = getNetworkStatusDone$1();
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(fetchSupportProgramCurrentSeason.async.failed, (newState, { error: error2 })=>{
        newState.currentSeason.meta.subscribeNetworkStatus = getNetworkStatusFailed$1(error2);
        newState.currentSeason.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentSeason.meta.dailyStatNetworkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const supportProgramReducerDailyStat = (supportProgram2)=>{
    applyAsyncReducer()("currentSeason", "dailyStatNetworkStatus", fetchSupportProgramDailyStat.async, supportProgram2, ({ store: store2, result: result2 })=>({
            ...store2.currentSeason.data,
            blogStatistics: store2.currentSeason.data.blogStatistics.map((stat2)=>{
                return result2.blogStatistic.name === stat2.name ? {
                    ...stat2,
                    value: result2.blogStatistic.value,
                    dailies: result2.blogStatistic.details
                } : stat2;
            })
        }));
};
const supportProgramReducerCheckInn = (supportProgram2)=>{
    applyAsyncReducer()("inn", "checkingNetworkStatus", checkSupportProgramInn.async, supportProgram2, ({ store: store2, result: result2 })=>result2);
};
const supportProgramReducerBindInn = (supportProgram2)=>{
    applyAsyncReducer()("inn", "bindingNetworkStatus", bindSupportProgramInn.async, supportProgram2, ({ store: store2, result: result2 })=>result2);
};
const supportProgramReducerReceivePayout = (supportProgram2)=>{
    supportProgram2.withHandling(immerCase(receiveSupportProgramPayout.async.done, (newState, { params, result: result2 })=>{
        if (newState.currentSeason.data.id === params.seasonId) {
            newState.currentSeason.data = result2.season;
            newState.currentSeason.meta.networkStatus = getNetworkStatusDone$1();
        } else {
            newState.seasons.data = newState.seasons.data.map((item2)=>{
                if (item2.id === params.seasonId) return result2.season;
                return item2;
            });
            newState.seasons.meta.networkStatus = getNetworkStatusDone$1();
        }
    }));
};
const supportProgramReducerFetchSeasons = (supportProgram2)=>{
    applyAsyncReducer()("seasons", "networkStatus", fetchSupportProgramSeasons.async, supportProgram2, ({ store: store2, result: result2 })=>result2.seasons);
};
const supportProgramReducerFetchSeasonsHistory = (supportProgram2)=>{
    applyAsyncReducer()("seasonsHistory", "networkStatus", fetchSupportProgramSeasonsHistory.async, supportProgram2, ({ store: store2, result: result2 })=>result2.seasons);
};
const supportProgram = (0, $ki1Eq.reducerWithInitialState)(getSupportProgramInitialState());
supportProgramReducerClear(supportProgram);
supportProgramReducerFetchArchive(supportProgram);
supportProgramReducerFetchCurrentSeason(supportProgram);
supportProgramReducerFetchSeasons(supportProgram);
supportProgramReducerFetchSeasonsHistory(supportProgram);
supportProgramReducerDailyStat(supportProgram);
supportProgramReducerCheckInn(supportProgram);
supportProgramReducerBindInn(supportProgram);
supportProgramReducerClearInnBindWidget(supportProgram);
supportProgramReducerFetchBankCards(supportProgram);
supportProgramReducerBindBankCards(supportProgram);
supportProgramReducerUpdateBankCards(supportProgram);
supportProgramReducerClearBankCardBindUrl(supportProgram);
supportProgramReducerUpdateBankCardsFromWS(supportProgram);
supportProgramReducerReceivePayout(supportProgram);
const getSystemInitialState = ()=>({
        externalAppOauth: {
            data: {
                app: {
                    avatarUrl: "",
                    name: "",
                    requestedScopeDescriptions: []
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        connectedApps: {
            data: {
                list: []
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const system = (0, $ki1Eq.reducerWithInitialState)(getSystemInitialState());
applyAsyncReducer()("externalAppOauth", "networkStatus", fetchExternalApp.async, system, ({ result: result2 })=>({
        app: result2
    }));
applyAsyncReducer()("externalAppOauth", "networkStatus", fetchThirdPartyApp.async, system, ({ result: result2 })=>({
        app: result2.data.application
    }));
applyAsyncReducer()("connectedApps", "networkStatus", fetchConnectedAppsList.async, system, ({ result: result2 })=>({
        list: result2.data.applications
    }));
const targetReducerResetTargets = (reducer)=>{
    return reducer.case(resetTargets, (store2)=>({
            ...store2,
            targets: {
                data: null,
                meta: {
                    ...store2.targets.meta,
                    networkStatus: getDefaultNetworkStatus$1()
                }
            }
        }));
};
const getTargetsInitialState = ()=>({
        targets: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        targetsAll: {
            data: [],
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const target = (0, $ki1Eq.reducerWithInitialState)(getTargetsInitialState()).case(incrementSubscribers, (state)=>({
        ...state,
        targets: {
            ...state.targets,
            data: state.targets.data ? state.targets.data.map((item2)=>item2.type === ETargetType.MONEY ? item2 : {
                    ...item2,
                    currentSum: item2.currentSum < item2.targetSum ? item2.currentSum + 1 : item2.currentSum,
                    finishTime: item2.currentSum + 1 === item2.targetSum ? Date.now() : 0
                }) : null
        }
    })).case(decrementSubscribers, (state)=>({
        ...state,
        targets: {
            ...state.targets,
            data: state.targets.data ? state.targets.data.map((item2)=>item2.type === ETargetType.MONEY ? item2 : {
                    ...item2,
                    currentSum: item2.currentSum - 1,
                    finishTime: item2.currentSum + 1 === item2.targetSum ? Date.now() : 0
                }) : null
        }
    }));
targetReducerResetTargets(target);
applyAsyncReducer()("targets", "networkStatus", fetchTargets.async, target, ({ result: result2 })=>[
        ...result2.data
    ]);
applyAsyncReducer()("targetsAll", "networkStatus", fetchAllTargets.async, target, ({ result: result2 })=>[
        ...result2.data
    ]);
applyAsyncReducer()("targets", "networkStatus", createMoneyTarget.async, target, ({ store: store2, result: result2 })=>[
        ...store2.targets.data,
        result2.target
    ]);
applyAsyncReducer()("targets", "networkStatus", createSubscribersTarget.async, target, ({ store: store2, result: result2 })=>[
        ...store2.targets.data,
        result2.target
    ]);
applyAsyncReducer()("targets", "networkStatus", editTarget.async, target, ({ store: store2, result: result2 })=>[
        ...store2.targets.data.map((item2)=>item2.id === result2.target.id ? result2.target : item2)
    ]);
applyAsyncReducer()("targets", "networkStatus", fetchTargetById.async, target, ({ store: store2, result: result2 })=>{
    const hasTarget = store2.targets.data.find((item2)=>item2.id === result2.target.id);
    if (hasTarget) return store2.targets.data.map((item2)=>{
        if (item2.id === result2.target.id) return {
            ...item2,
            selectedCurrencyCurrentSum: result2.target.currentSum,
            selectedCurrencyTargetSum: result2.target.targetSum
        };
        else return item2;
    });
    return [
        ...store2.targets.data,
        result2.target
    ];
});
applyAsyncReducer()("targets", "networkStatus", removeTarget.async, target, ({ store: store2, params })=>[
        ...store2.targets.data.filter((item2)=>item2.id !== params.id)
    ]);
const getVideoClipInitialState = ()=>({
        currentVideoClip: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        currentVideoSnippet: {
            data: null,
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        sourceVideo: null,
        videoClips: {
            data: {
                data: null,
                extra: {
                    offset: null,
                    isLast: false
                }
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        },
        videoClipsCreationPipeline: {
            failed: {},
            inProcess: {},
            ready: {}
        },
        videoSnippetsCreationPipeline: {
            failed: {},
            inProcess: {},
            ready: {}
        }
    });
const applyClearVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoClip, (newState)=>{
        newState.currentVideoClip = getVideoClipInitialState().currentVideoClip;
    }));
};
const applyClearVideoClipsReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoClips, (newState)=>{
        newState.videoClips = getVideoClipInitialState().videoClips;
    }));
};
const applyClearVideoClipsCreationPipelineReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoClipsCreationPipeline, (newState)=>{
        newState.videoClipsCreationPipeline = getVideoClipInitialState().videoClipsCreationPipeline;
    }));
};
const applyClearVideoClipSourceVideoReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoClipSourceVideo, (newState)=>{
        newState.sourceVideo = getVideoClipInitialState().sourceVideo;
    }));
};
const applyClearVideoSnippetReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoSnippet, (newState)=>{
        newState.currentVideoSnippet = getVideoClipInitialState().currentVideoSnippet;
    }));
};
const applyClearVideoSnippetsCreationPipelineReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(clearVideoSnippetsCreationPipeline, (newState)=>{
        newState.videoSnippetsCreationPipeline = getVideoClipInitialState().videoSnippetsCreationPipeline;
    }));
};
const applyCreateVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(createVideoClip.async.started, (newState)=>{
        newState.currentVideoClip.data = null;
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createVideoClip.async.done, (newState, { result: result2 })=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createVideoClip.async.failed, (newState, { error: error2 })=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyCreateVideoSnippetReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(createVideoSnippet.async.started, (newState)=>{
        newState.currentVideoSnippet.data = null;
        newState.currentVideoSnippet.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(createVideoSnippet.async.done, (newState, { result: result2 })=>{
        newState.currentVideoSnippet.meta.networkStatus = getNetworkStatusDone$1();
    })).withHandling(immerCase(createVideoSnippet.async.failed, (newState, { error: error2 })=>{
        newState.currentVideoSnippet.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyDeleteVideoClipReducer = (videoClip)=>{
    videoClip.withHandling(immerCase(deleteVideoClip.async.started, (newState)=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(deleteVideoClip.async.done, (newState, { params })=>{
        if (newState.videoClips.data.data) {
            newState.videoClips.data.data = newState.videoClips.data.data.filter((item2)=>item2.id !== params.videoClipId);
            newState.videoClips.meta.networkStatus = getNetworkStatusDone$1();
        }
        if (newState.currentVideoClip.data) {
            newState.currentVideoClip.data = null;
            newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(deleteVideoClip.async.failed, (newState, { error: error2 })=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyEditVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(editVideoClip.async.started, (newState)=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusStarted$1();
    })).withHandling(immerCase(editVideoClip.async.done, (newState, { result: result2 })=>{
        if (newState.videoClips.data.data) {
            newState.videoClips.meta.networkStatus = getNetworkStatusDone$1();
            newState.videoClips.data.data = newState.videoClips.data.data.map((item2)=>{
                if (item2.id === result2.data.id) return {
                    ...item2,
                    ...result2.data
                };
                return item2;
            });
        }
        if (newState.currentVideoClip.data) {
            newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
            newState.currentVideoClip.data = {
                ...newState.currentVideoClip.data,
                ...result2.data
            };
        }
    })).withHandling(immerCase(editVideoClip.async.failed, (newState, { error: error2 })=>{
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyFetchActiveVideoClipsReducer = (videoClipsReducer)=>{
    applyAsyncReducer()("videoClips", "networkStatus", fetchActiveVideoClips.async, videoClipsReducer, ({ store: store2, result: result2 })=>({
            data: concatUniqueById(store2.videoClips.data.data, result2.data),
            extra: result2.extra
        }));
};
const applyFetchProcessingVideoClipsReducer = (videoClipsReducer)=>{
    applyAsyncReducer()("videoClips", "networkStatus", fetchProcessingVideoClips.async, videoClipsReducer, ({ store: store2, result: result2 })=>({
            data: concatUniqueById(store2.videoClips.data.data, result2.data),
            extra: result2.extra
        }));
};
const applyFetchVideoClipReducer = (videoClipsReducer)=>{
    applyAsyncReducer()("currentVideoClip", "networkStatus", fetchVideoClip.async, videoClipsReducer, (props)=>props.result.data);
};
const applyFetchVideoClipsReducer = (videoClipsReducer)=>{
    applyAsyncReducer()("videoClips", "networkStatus", fetchVideoClips.async, videoClipsReducer, ({ store: store2, result: result2 })=>({
            data: concatUniqueById(store2.videoClips.data.data, result2.data),
            extra: result2.extra
        }));
};
const applyFetchVideoSnippetReducer = (videoClipsReducer)=>{
    applyAsyncReducer()("currentVideoSnippet", "networkStatus", fetchVideoSnippet.async, videoClipsReducer, (props)=>props.result.data);
};
const applyHandleVideoClipStatusChangeReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(handleVideoClipStatusChange, (newState, videoClip)=>{
        const blogUrl = videoClip.blog.blogUrl;
        const videoClipId = videoClip.id;
        const videoClipsInProcess = newState.videoClipsCreationPipeline.inProcess;
        const videoClipsReady = newState.videoClipsCreationPipeline.ready;
        const videoClipsFailed = newState.videoClipsCreationPipeline.failed;
        if (!videoClipsInProcess[blogUrl]) videoClipsInProcess[blogUrl] = {};
        if (!videoClipsReady[blogUrl]) videoClipsReady[blogUrl] = {};
        if (!videoClipsFailed[blogUrl]) videoClipsFailed[blogUrl] = {};
        if (videoClip.state === EVideoClipStatus.PROCESSING) videoClipsInProcess[blogUrl][videoClipId] = videoClip;
        else if (videoClip.state === EVideoClipStatus.ACTIVE) {
            delete videoClipsInProcess[blogUrl][videoClipId];
            videoClipsReady[blogUrl][videoClipId] = videoClip;
        } else if ([
            EVideoClipStatus.ERROR,
            EVideoClipStatus.ERROR_DONE
        ].includes(videoClip.state)) {
            delete videoClipsInProcess[blogUrl][videoClipId];
            videoClipsFailed[blogUrl][videoClipId] = videoClip;
        }
    }));
};
const applyHandleVideoSnippetStatusChangeReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(handleVideoSnippetStatusChange, (newState, videoSnippet)=>{
        const blogUrl = videoSnippet.blog.blogUrl;
        const videoSnippetId = videoSnippet.id;
        const videoSnippetsInProcess = newState.videoSnippetsCreationPipeline.inProcess;
        const videoSnippetsReady = newState.videoSnippetsCreationPipeline.ready;
        const videoSnippetsFailed = newState.videoSnippetsCreationPipeline.failed;
        if (!videoSnippetsInProcess[blogUrl]) videoSnippetsInProcess[blogUrl] = {};
        if (!videoSnippetsReady[blogUrl]) videoSnippetsReady[blogUrl] = {};
        if (!videoSnippetsFailed[blogUrl]) videoSnippetsFailed[blogUrl] = {};
        if (videoSnippet.state === EVideoClipStatus.PROCESSING) videoSnippetsInProcess[blogUrl][videoSnippetId] = videoSnippet;
        else if (videoSnippet.state === EVideoClipStatus.ACTIVE) {
            delete videoSnippetsInProcess[blogUrl][videoSnippetId];
            videoSnippetsReady[blogUrl][videoSnippetId] = videoSnippet;
        } else if ([
            EVideoClipStatus.ERROR,
            EVideoClipStatus.ERROR_DONE
        ].includes(videoSnippet.state)) {
            delete videoSnippetsInProcess[blogUrl][videoSnippetId];
            videoSnippetsFailed[blogUrl][videoSnippetId] = videoSnippet;
        }
    }));
};
const applyHideVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(hideVideoClip.async.done, (newState, { params })=>{
        if (newState.videoClips.data.data) {
            newState.videoClips.meta.networkStatus = getNetworkStatusDone$1();
            newState.videoClips.data.data = newState.videoClips.data.data.map((item2)=>{
                if (item2.id === params.videoClipId) item2.state = EVideoClipStatus.HIDDEN;
                return item2;
            });
        }
        if (newState.currentVideoClip.data) {
            newState.currentVideoClip.data.state = EVideoClipStatus.HIDDEN;
            newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(hideVideoClip.async.failed, (newState, { error: error2 })=>{
        newState.videoClips.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyLikeVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(likeVideoClip.async.done, (newState)=>{
        newState.currentVideoClip.data.isLiked = true;
        newState.currentVideoClip.data.count.likes = newState.currentVideoClip.data.count.likes + 1;
    }));
};
const applyRemoveVideoClipFromCreationPipelineReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(removeVideoClipFromCreationPipeline, (newState, videoClip)=>{
        const blogUrl = videoClip.blog.blogUrl;
        const videoClipId = videoClip.id;
        const videoClipsInProcess = newState.videoClipsCreationPipeline.inProcess;
        const videoClipsReady = newState.videoClipsCreationPipeline.ready;
        const videoClipsFailed = newState.videoClipsCreationPipeline.failed;
        if (!videoClipsInProcess[blogUrl]) videoClipsInProcess[blogUrl] = {};
        if (!videoClipsReady[blogUrl]) videoClipsReady[blogUrl] = {};
        if (!videoClipsFailed[blogUrl]) videoClipsFailed[blogUrl] = {};
        delete videoClipsInProcess[blogUrl][videoClipId];
        delete videoClipsReady[blogUrl][videoClipId];
        delete videoClipsFailed[blogUrl][videoClipId];
    }));
};
const applyRemoveVideoSnippetFromCreationPipelineReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(removeVideoSnippetFromCreationPipeline, (newState, videoSnippet)=>{
        const blogUrl = videoSnippet.blog.blogUrl;
        const videoSnippetId = videoSnippet.id;
        const videoSnippetsInProcess = newState.videoSnippetsCreationPipeline.inProcess;
        const videoSnippetsReady = newState.videoSnippetsCreationPipeline.ready;
        const videoSnippetsFailed = newState.videoSnippetsCreationPipeline.failed;
        if (!videoSnippetsInProcess[blogUrl]) videoSnippetsInProcess[blogUrl] = {};
        if (!videoSnippetsReady[blogUrl]) videoSnippetsReady[blogUrl] = {};
        if (!videoSnippetsFailed[blogUrl]) videoSnippetsFailed[blogUrl] = {};
        delete videoSnippetsInProcess[blogUrl][videoSnippetId];
        delete videoSnippetsReady[blogUrl][videoSnippetId];
        delete videoSnippetsFailed[blogUrl][videoSnippetId];
    }));
};
const applySetVideoClipCurrentReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(setVideoClipCurrent, (newState, videoClip)=>{
        newState.currentVideoClip.data = videoClip;
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
    }));
};
const applySetVideoClipSourceVideoReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(setVideoClipSourceVideo, (newState, sourceVideo)=>{
        newState.sourceVideo = sourceVideo;
    }));
};
const applySetVideoSnippetCurrentReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(setVideoSnippetCurrent, (newState, videoSnippet)=>{
        newState.currentVideoSnippet.data = videoSnippet;
        newState.currentVideoSnippet.meta.networkStatus = getNetworkStatusDone$1();
    }));
};
const applyUnhideVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(unhideVideoClip.async.done, (newState, { params })=>{
        if (newState.videoClips.data.data) {
            newState.videoClips.meta.networkStatus = getNetworkStatusDone$1();
            newState.videoClips.data.data = newState.videoClips.data.data.map((item2)=>{
                if (item2.id === params.videoClipId) item2.state = EVideoClipStatus.ACTIVE;
                return item2;
            });
        }
        if (newState.currentVideoClip.data) {
            newState.currentVideoClip.data.state = EVideoClipStatus.ACTIVE;
            newState.currentVideoClip.meta.networkStatus = getNetworkStatusDone$1();
        }
    })).withHandling(immerCase(unhideVideoClip.async.failed, (newState, { error: error2 })=>{
        newState.videoClips.meta.networkStatus = getNetworkStatusFailed$1(error2);
        newState.currentVideoClip.meta.networkStatus = getNetworkStatusFailed$1(error2);
    }));
};
const applyUnlikeVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(unlikeVideoClip.async.done, (newState)=>{
        newState.currentVideoClip.data.isLiked = false;
        newState.currentVideoClip.data.count.likes = newState.currentVideoClip.data.count.likes - 1;
    }));
};
const applyViewVideoClipReducer = (videoClipsReducer)=>{
    videoClipsReducer.withHandling(immerCase(viewVideoClip.async.done, (newState, { params })=>{
        newState.currentVideoClip.data.count.views = newState.currentVideoClip.data.count.views + 1;
    }));
};
const videoClips = (0, $ki1Eq.reducerWithInitialState)(getVideoClipInitialState());
applyClearVideoClipReducer(videoClips);
applyClearVideoClipsReducer(videoClips);
applyClearVideoClipsCreationPipelineReducer(videoClips);
applyClearVideoClipSourceVideoReducer(videoClips);
applyClearVideoSnippetReducer(videoClips);
applyCreateVideoClipReducer(videoClips);
applyCreateVideoSnippetReducer(videoClips);
applyClearVideoSnippetsCreationPipelineReducer(videoClips);
applyDeleteVideoClipReducer(videoClips);
applyEditVideoClipReducer(videoClips);
applyFetchActiveVideoClipsReducer(videoClips);
applyFetchProcessingVideoClipsReducer(videoClips);
applyFetchVideoClipReducer(videoClips);
applyFetchVideoClipsReducer(videoClips);
applyFetchVideoSnippetReducer(videoClips);
applyHandleVideoClipStatusChangeReducer(videoClips);
applyHandleVideoSnippetStatusChangeReducer(videoClips);
applyHideVideoClipReducer(videoClips);
applyLikeVideoClipReducer(videoClips);
applyRemoveVideoClipFromCreationPipelineReducer(videoClips);
applyRemoveVideoSnippetFromCreationPipelineReducer(videoClips);
applySetVideoClipCurrentReducer(videoClips);
applySetVideoClipSourceVideoReducer(videoClips);
applySetVideoSnippetCurrentReducer(videoClips);
applyUnhideVideoClipReducer(videoClips);
applyUnlikeVideoClipReducer(videoClips);
applyViewVideoClipReducer(videoClips);
const getVkVideoPlayerInitialState = ()=>({
        mainVideoPlayer: null,
        vkVideoPlayerState: {
            focus: false
        }
    });
const vkVideoPlayerState = (0, $ki1Eq.reducerWithInitialState)(getVkVideoPlayerInitialState());
vkVideoPlayerState.case(focusVkVideoPlayerState, (state, { focus })=>({
        ...state,
        vkVideoPlayerState: {
            focus: focus
        }
    }));
vkVideoPlayerState.case(setMainVideoPlayer, (state, { player })=>({
        ...state,
        mainVideoPlayer: player
    }));
const getWebSocketTokenInitialState = ()=>({
        webSocketToken: {
            data: {
                token: ""
            },
            meta: {
                networkStatus: getDefaultNetworkStatus$1()
            }
        }
    });
const webSocketToken = (0, $ki1Eq.reducerWithInitialState)(getWebSocketTokenInitialState());
applyAsyncReducer()("webSocketToken", "networkStatus", fetchWebSocketToken.async, webSocketToken, // eslint-disable-next-line
({ result: result2 })=>result2);
(0, $eShmq.combineReducers)({
    agents: agents,
    blackList: blackList,
    catalog: catalog,
    channel: channel,
    currentUser: currentUser,
    dropCampaigns: dropCampaigns,
    blog: blog,
    blogStat: blogStat,
    dialogue: dialogue,
    externalApps: externalApps,
    gift: gift,
    mediaData: mediaData,
    mediaPlayingState: mediaPlayingState,
    subscriptions: subscriptions,
    target: target,
    webSocketToken: webSocketToken,
    payment: payment,
    internal: internal,
    activityFeed: activityFeed,
    notificationSettings: notificationSettings,
    currentPoll: currentPoll,
    singlePayment: singlePayment,
    smiles: smiles,
    badges: badges$1,
    overlayPopupState: overlayPopupState,
    roles: roles$1,
    stream: stream,
    postponedReward: postponedReward,
    channelPoint: channelPoint,
    rewardManager: rewardManager,
    channelPrediction: channelPrediction,
    chat: chat$2,
    drop: drop,
    analytics: analytics,
    customBlocks: customBlocks,
    channelStat: channelStat,
    record: record,
    ratingProgram: ratingProgram,
    supportProgram: supportProgram,
    hostStatus: hostStatus,
    ownChannelPoint: ownChannelPoint,
    channelRewards: channelRewards,
    rewards: rewards,
    routeParams: routeParams,
    pendingBonus: channelPointPendingBonus,
    bonuses: channelPointBonus,
    channelPointUpdater: channelPointUpdater,
    chatBot: chatBot,
    system: system,
    news: news,
    serviceStates: serviceStates,
    multiplicators: multiplicators,
    settings: settings$1,
    streamSlots: streamSlots,
    subscriptionGift: subscriptionGift,
    lettersSubscriptionGiftUsers: lettersSubscriptionGiftUsers,
    subscriptionLevelBoosty: subscriptionLevelBoosty,
    globalData: globalData,
    moderationLog: moderationLog,
    playlist: playlist,
    channelModerator: channelModerator,
    publisherState: publisherState,
    videoClips: videoClips,
    vkVideoPlayerState: vkVideoPlayerState,
    channelBan: channelBan,
    integrations: integrations,
    schemas: schemas,
    donationService: donationService,
    channelPoll: channelPoll
});
let initialState;
try {
    initialState = JSON.parse(HtmlEntities.decode(document.getElementById("initial-state").innerHTML));
} catch (err) {
    initialState = {};
}
let refreshCallback;
const setRefreshTokenCallback = (callback)=>{
    refreshCallback = callback;
};
let refreshPromise = null;
const refreshExcludedUrls = [
    API_URL.OAUTH_TOKEN,
    API_URL.OAUTH_REFRESH_TOKEN
];
let isCreated = false;
const refreshTokenMiddleware = ({ dispatch })=>(next2)=>(action)=>{
            if (!isCreated) {
                HttpTransportBrowser.axios.interceptors.response.use((response)=>response, async (axiosError)=>{
                    const authToken = getAuthTokenData();
                    if (authToken != null && axiosError.response && refreshExcludedUrls.every((url)=>!axiosError.config.url.startsWith(url)) && (axiosError.response.status === 401 || axiosError.response.status === 400 && axiosError.response.data.error_description && axiosError.response.data.error_description.match(/authorization/i) != null)) try {
                        if (refreshPromise == null) refreshPromise = restoreSession().then((user)=>{
                            dispatch(setCurrentUser.action({
                                user: user
                            }));
                        });
                        const success = await Promise.race([
                            dist$4.delay(1e4),
                            refreshPromise
                        ]);
                        if (success) return HttpTransportBrowser.axios.request(axiosError.config);
                        else {
                            resetAuthTokenData();
                            if (typeof refreshCallback === "function") {
                                const authData = refreshCallback({
                                    text: "unexpected error"
                                });
                                if (authData) setAuthTokenData(authData);
                            }
                        }
                    } catch (err) {
                        resetAuthTokenData();
                        if (typeof refreshCallback === "function") {
                            const authData = refreshCallback(err);
                            if (authData) setAuthTokenData(authData);
                        }
                    } finally{
                        refreshPromise = null;
                    }
                    return Promise.reject(axiosError);
                });
                isCreated = true;
            }
            next2(action);
        };
const reducers = {
    chat: chat$2,
    blog: blog,
    stream: stream,
    currentUser: currentUser,
    smiles: smiles,
    subscriptions: subscriptions,
    postponedReward: postponedReward,
    channelPoint: channelPoint,
    channelPrediction: channelPrediction,
    mediaData: mediaData,
    drop: drop,
    record: record,
    rewards: rewards,
    roles: roles$1,
    pendingBonus: channelPointPendingBonus,
    bonuses: channelPointBonus,
    channelPointUpdater: channelPointUpdater,
    webSocketToken: webSocketToken,
    globalData: globalData
};
const getInitialState = ()=>({
        chat: getChatInitialState(),
        blog: getBlogInitialState(),
        stream: getStreamInitialState(),
        currentUser: getCurrentUserInitialState(),
        smiles: getSmilesInitialState(),
        subscriptions: getSubscriptionsInitialState(),
        postponedReward: getPostponedRewardInitialState(),
        channelPoint: getChannelPointInitialState(),
        channelPrediction: getChannelPredictionInitialState(),
        mediaData: getMediaDataInitialState(),
        drop: getDropInitialState(),
        record: getRecordInitialState(),
        webSocketToken: getWebSocketTokenInitialState(),
        bonuses: getBonusInitialState(),
        pendingBonus: getPendingBonusInitialState(),
        channelPointUpdater: getChannelPointUpdaterInitialState(),
        globalData: getGlobalDataInitialState(),
        rewards: getRewardInitialState(),
        roles: getRolesInitialState()
    });
const store = (0, $a1McR.configureStore)({
    reducer: reducers,
    preloadedState: getInitialState(),
    middleware: (getDefaultMiddleware)=>{
        return [
            refreshTokenMiddleware,
            ...getDefaultMiddleware()
        ];
    }
});
var build$2 = {};
var centrifuge = {};
var subscription = {};
var codes = {};
Object.defineProperty(codes, "__esModule", {
    value: true
});
codes.unsubscribedCodes = codes.subscribingCodes = codes.disconnectedCodes = codes.connectingCodes = codes.errorCodes = void 0;
codes.errorCodes = {
    timeout: 1,
    transportClosed: 2,
    clientDisconnected: 3,
    clientClosed: 4,
    clientConnectToken: 5,
    clientRefreshToken: 6,
    subscriptionUnsubscribed: 7,
    subscriptionSubscribeToken: 8,
    subscriptionRefreshToken: 9,
    transportWriteError: 10,
    connectionClosed: 11,
    badConfiguration: 12
};
codes.connectingCodes = {
    connectCalled: 0,
    transportClosed: 1,
    noPing: 2,
    subscribeTimeout: 3,
    unsubscribeError: 4
};
codes.disconnectedCodes = {
    disconnectCalled: 0,
    unauthorized: 1,
    badProtocol: 2,
    messageSizeLimit: 3
};
codes.subscribingCodes = {
    subscribeCalled: 0,
    transportClosed: 1
};
codes.unsubscribedCodes = {
    unsubscribeCalled: 0,
    unauthorized: 1,
    clientClosed: 2
};
var types = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.SubscriptionState = exports2.State = void 0;
    (function(State) {
        State["Disconnected"] = "disconnected";
        State["Connecting"] = "connecting";
        State["Connected"] = "connected";
    })(exports2.State || (exports2.State = {}));
    (function(SubscriptionState) {
        SubscriptionState["Unsubscribed"] = "unsubscribed";
        SubscriptionState["Subscribing"] = "subscribing";
        SubscriptionState["Subscribed"] = "subscribed";
    })(exports2.SubscriptionState || (exports2.SubscriptionState = {}));
})(types);
var utils$1 = {};
Object.defineProperty(utils$1, "__esModule", {
    value: true
});
utils$1.ttlMilliseconds = utils$1.errorExists = utils$1.backoff = utils$1.log = utils$1.isFunction = utils$1.startsWith = void 0;
function startsWith(value2, prefix2) {
    return value2.lastIndexOf(prefix2, 0) === 0;
}
utils$1.startsWith = startsWith;
function isFunction$2(value2) {
    if (value2 === void 0 || value2 === null) return false;
    return typeof value2 === "function";
}
utils$1.isFunction = isFunction$2;
function log(level, args) {
    if (globalThis.console) {
        const logger2 = globalThis.console[level];
        if (isFunction$2(logger2)) logger2.apply(globalThis.console, args);
    }
}
utils$1.log = log;
function randomInt(min2, max2) {
    return Math.floor(Math.random() * (max2 - min2 + 1) + min2);
}
function backoff(step, min2, max2) {
    if (step > 31) step = 31;
    const interval = randomInt(0, Math.min(max2, min2 * Math.pow(2, step)));
    return Math.min(max2, min2 + interval);
}
utils$1.backoff = backoff;
function errorExists(data) {
    return "error" in data && data.error !== null;
}
utils$1.errorExists = errorExists;
function ttlMilliseconds(ttl) {
    return Math.min(ttl * 1e3, 2147483647);
}
utils$1.ttlMilliseconds = ttlMilliseconds;
var hasRequiredSubscription;
function requireSubscription() {
    if (hasRequiredSubscription) return subscription;
    hasRequiredSubscription = 1;
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(subscription, "__esModule", {
        value: true
    });
    subscription.Subscription = void 0;
    const events_1 = __importDefault((0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))));
    const centrifuge_1 = requireCentrifuge();
    const codes_1 = codes;
    const types_1 = types;
    const utils_12 = utils$1;
    class Subscription2 extends events_1.default {
        /** Subscription constructor should not be used directly, create subscriptions using Client method. */ constructor(centrifuge2, channel2, options){
            super();
            this._resubscribeTimeout = null;
            this._refreshTimeout = null;
            this.channel = channel2;
            this.state = types_1.SubscriptionState.Unsubscribed;
            this._centrifuge = centrifuge2;
            this._token = "";
            this._getToken = null;
            this._data = null;
            this._getData = null;
            this._recover = false;
            this._offset = null;
            this._epoch = null;
            this._recoverable = false;
            this._positioned = false;
            this._joinLeave = false;
            this._minResubscribeDelay = 500;
            this._maxResubscribeDelay = 2e4;
            this._resubscribeTimeout = null;
            this._resubscribeAttempts = 0;
            this._promises = {};
            this._promiseId = 0;
            this._inflight = false;
            this._refreshTimeout = null;
            this._setOptions(options);
            if (this._centrifuge._debugEnabled) {
                this.on("state", (ctx)=>{
                    this._centrifuge._debug("subscription state", channel2, ctx.oldState, "->", ctx.newState);
                });
                this.on("error", (ctx)=>{
                    this._centrifuge._debug("subscription error", channel2, ctx);
                });
            } else this.on("error", function() {
                Function.prototype();
            });
        }
        /** ready returns a Promise which resolves upon subscription goes to Subscribed
     * state and rejects in case of subscription goes to Unsubscribed state.
     * Optional timeout can be passed.*/ ready(timeout2) {
            if (this.state === types_1.SubscriptionState.Unsubscribed) return Promise.reject({
                code: codes_1.errorCodes.subscriptionUnsubscribed,
                message: this.state
            });
            if (this.state === types_1.SubscriptionState.Subscribed) return Promise.resolve();
            return new Promise((res, rej)=>{
                const ctx = {
                    resolve: res,
                    reject: rej
                };
                if (timeout2) ctx.timeout = setTimeout(function() {
                    rej({
                        code: codes_1.errorCodes.timeout,
                        message: "timeout"
                    });
                }, timeout2);
                this._promises[this._nextPromiseId()] = ctx;
            });
        }
        /** subscribe to a channel.*/ subscribe() {
            if (this._isSubscribed()) return;
            this._resubscribeAttempts = 0;
            this._setSubscribing(codes_1.subscribingCodes.subscribeCalled, "subscribe called");
        }
        /** unsubscribe from a channel, keeping position state.*/ unsubscribe() {
            this._setUnsubscribed(codes_1.unsubscribedCodes.unsubscribeCalled, "unsubscribe called", true);
        }
        /** publish data to a channel.*/ publish(data) {
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._centrifuge.publish(self2.channel, data);
            });
        }
        /** get online presence for a channel.*/ presence() {
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._centrifuge.presence(self2.channel);
            });
        }
        /** presence stats for a channel (num clients and unique users).*/ presenceStats() {
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._centrifuge.presenceStats(self2.channel);
            });
        }
        /** history for a channel. By default it does not return publications (only current
     *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/ history(opts) {
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._centrifuge.history(self2.channel, opts);
            });
        }
        _methodCall() {
            if (this._isSubscribed()) return Promise.resolve();
            if (this._isUnsubscribed()) return Promise.reject({
                code: codes_1.errorCodes.subscriptionUnsubscribed,
                message: this.state
            });
            return new Promise((res, rej)=>{
                const timeout2 = setTimeout(function() {
                    rej({
                        code: codes_1.errorCodes.timeout,
                        message: "timeout"
                    });
                }, this._centrifuge._config.timeout);
                this._promises[this._nextPromiseId()] = {
                    timeout: timeout2,
                    resolve: res,
                    reject: rej
                };
            });
        }
        _nextPromiseId() {
            return ++this._promiseId;
        }
        _needRecover() {
            return this._recover === true;
        }
        _isUnsubscribed() {
            return this.state === types_1.SubscriptionState.Unsubscribed;
        }
        _isSubscribing() {
            return this.state === types_1.SubscriptionState.Subscribing;
        }
        _isSubscribed() {
            return this.state === types_1.SubscriptionState.Subscribed;
        }
        _setState(newState) {
            if (this.state !== newState) {
                const oldState = this.state;
                this.state = newState;
                this.emit("state", {
                    newState: newState,
                    oldState: oldState,
                    channel: this.channel
                });
                return true;
            }
            return false;
        }
        _usesToken() {
            return this._token !== "" || this._getToken !== null;
        }
        _clearSubscribingState() {
            this._resubscribeAttempts = 0;
            this._clearResubscribeTimeout();
        }
        _clearSubscribedState() {
            this._clearRefreshTimeout();
        }
        _setSubscribed(result2) {
            if (!this._isSubscribing()) return;
            this._clearSubscribingState();
            if (result2.recoverable) {
                this._recover = true;
                this._offset = result2.offset || 0;
                this._epoch = result2.epoch || "";
            }
            this._setState(types_1.SubscriptionState.Subscribed);
            const ctx = this._centrifuge._getSubscribeContext(this.channel, result2);
            this.emit("subscribed", ctx);
            this._resolvePromises();
            const pubs = result2.publications;
            if (pubs && pubs.length > 0) for(const i in pubs){
                if (!pubs.hasOwnProperty(i)) continue;
                this._handlePublication(pubs[i]);
            }
            if (result2.expires === true) this._refreshTimeout = setTimeout(()=>this._refresh(), (0, utils_12.ttlMilliseconds)(result2.ttl));
        }
        _setSubscribing(code, reason2) {
            if (this._isSubscribing()) return;
            if (this._isSubscribed()) this._clearSubscribedState();
            if (this._setState(types_1.SubscriptionState.Subscribing)) this.emit("subscribing", {
                channel: this.channel,
                code: code,
                reason: reason2
            });
            this._subscribe(false, false);
        }
        _subscribe(optimistic, skipSending) {
            this._centrifuge._debug("subscribing on", this.channel);
            if (this._centrifuge.state !== types_1.State.Connected && !optimistic) {
                this._centrifuge._debug("delay subscribe on", this.channel, "till connected");
                return null;
            }
            const self2 = this;
            const getDataCtx = {
                channel: self2.channel
            };
            if (!this._usesToken() || this._token) {
                if (self2._getData) {
                    self2._getData(getDataCtx).then(function(data) {
                        if (!self2._isSubscribing()) return;
                        self2._data = data;
                        self2._sendSubscribe(self2._token, false);
                    });
                    return null;
                } else return self2._sendSubscribe(self2._token, skipSending);
            }
            if (optimistic) return null;
            this._getSubscriptionToken().then(function(token2) {
                if (!self2._isSubscribing()) return;
                if (!token2) {
                    self2._failUnauthorized();
                    return;
                }
                self2._token = token2;
                if (self2._getData) self2._getData(getDataCtx).then(function(data) {
                    if (!self2._isSubscribing()) return;
                    self2._data = data;
                    self2._sendSubscribe(token2, false);
                });
                else self2._sendSubscribe(token2, false);
            }).catch(function(e2) {
                if (!self2._isSubscribing()) return;
                if (e2 instanceof centrifuge_1.UnauthorizedError) {
                    self2._failUnauthorized();
                    return;
                }
                self2.emit("error", {
                    type: "subscribeToken",
                    channel: self2.channel,
                    error: {
                        code: codes_1.errorCodes.subscriptionSubscribeToken,
                        message: e2 !== void 0 ? e2.toString() : ""
                    }
                });
                self2._scheduleResubscribe();
            });
            return null;
        }
        _sendSubscribe(token2, skipSending) {
            const channel2 = this.channel;
            const req = {
                channel: channel2
            };
            if (token2) req.token = token2;
            if (this._data) req.data = this._data;
            if (this._positioned) req.positioned = true;
            if (this._recoverable) req.recoverable = true;
            if (this._joinLeave) req.join_leave = true;
            if (this._needRecover()) {
                req.recover = true;
                const offset2 = this._getOffset();
                if (offset2) req.offset = offset2;
                const epoch = this._getEpoch();
                if (epoch) req.epoch = epoch;
            }
            const cmd = {
                subscribe: req
            };
            this._inflight = true;
            this._centrifuge._call(cmd, skipSending).then((resolveCtx)=>{
                this._inflight = false;
                const result2 = resolveCtx.reply.subscribe;
                this._handleSubscribeResponse(result2);
                if (resolveCtx.next) resolveCtx.next();
            }, (rejectCtx)=>{
                this._inflight = false;
                this._handleSubscribeError(rejectCtx.error);
                if (rejectCtx.next) rejectCtx.next();
            });
            return cmd;
        }
        _handleSubscribeError(error2) {
            if (!this._isSubscribing()) return;
            if (error2.code === codes_1.errorCodes.timeout) {
                this._centrifuge._disconnect(codes_1.connectingCodes.subscribeTimeout, "subscribe timeout", true);
                return;
            }
            this._subscribeError(error2);
        }
        _handleSubscribeResponse(result2) {
            if (!this._isSubscribing()) return;
            this._setSubscribed(result2);
        }
        _setUnsubscribed(code, reason2, sendUnsubscribe) {
            if (this._isUnsubscribed()) return;
            if (this._isSubscribed()) {
                if (sendUnsubscribe) this._centrifuge._unsubscribe(this);
                this._clearSubscribedState();
            }
            if (this._isSubscribing()) {
                if (this._inflight && sendUnsubscribe) this._centrifuge._unsubscribe(this);
                this._clearSubscribingState();
            }
            if (this._setState(types_1.SubscriptionState.Unsubscribed)) this.emit("unsubscribed", {
                channel: this.channel,
                code: code,
                reason: reason2
            });
            this._rejectPromises({
                code: codes_1.errorCodes.subscriptionUnsubscribed,
                message: this.state
            });
        }
        _handlePublication(pub) {
            const ctx = this._centrifuge._getPublicationContext(this.channel, pub);
            this.emit("publication", ctx);
            if (pub.offset) this._offset = pub.offset;
        }
        _handleJoin(join) {
            const info2 = this._centrifuge._getJoinLeaveContext(join.info);
            this.emit("join", {
                channel: this.channel,
                info: info2
            });
        }
        _handleLeave(leave) {
            const info2 = this._centrifuge._getJoinLeaveContext(leave.info);
            this.emit("leave", {
                channel: this.channel,
                info: info2
            });
        }
        _resolvePromises() {
            for(const id in this._promises){
                if (this._promises[id].timeout) clearTimeout(this._promises[id].timeout);
                this._promises[id].resolve();
                delete this._promises[id];
            }
        }
        _rejectPromises(err) {
            for(const id in this._promises){
                if (this._promises[id].timeout) clearTimeout(this._promises[id].timeout);
                this._promises[id].reject(err);
                delete this._promises[id];
            }
        }
        _scheduleResubscribe() {
            const self2 = this;
            const delay2 = this._getResubscribeDelay();
            this._resubscribeTimeout = setTimeout(function() {
                if (self2._isSubscribing()) self2._subscribe(false, false);
            }, delay2);
        }
        _subscribeError(err) {
            if (!this._isSubscribing()) return;
            if (err.code < 100 || err.code === 109 || err.temporary === true) {
                if (err.code === 109) this._token = "";
                const errContext = {
                    channel: this.channel,
                    type: "subscribe",
                    error: err
                };
                if (this._centrifuge.state === types_1.State.Connected) this.emit("error", errContext);
                this._scheduleResubscribe();
            } else this._setUnsubscribed(err.code, err.message, false);
        }
        _getResubscribeDelay() {
            const delay2 = (0, utils_12.backoff)(this._resubscribeAttempts, this._minResubscribeDelay, this._maxResubscribeDelay);
            this._resubscribeAttempts++;
            return delay2;
        }
        _setOptions(options) {
            if (!options) return;
            if (options.since) {
                this._offset = options.since.offset;
                this._epoch = options.since.epoch;
                this._recover = true;
            }
            if (options.data) this._data = options.data;
            if (options.getData) this._getData = options.getData;
            if (options.minResubscribeDelay !== void 0) this._minResubscribeDelay = options.minResubscribeDelay;
            if (options.maxResubscribeDelay !== void 0) this._maxResubscribeDelay = options.maxResubscribeDelay;
            if (options.token) this._token = options.token;
            if (options.getToken) this._getToken = options.getToken;
            if (options.positioned === true) this._positioned = true;
            if (options.recoverable === true) this._recoverable = true;
            if (options.joinLeave === true) this._joinLeave = true;
        }
        _getOffset() {
            const offset2 = this._offset;
            if (offset2 !== null) return offset2;
            return 0;
        }
        _getEpoch() {
            const epoch = this._epoch;
            if (epoch !== null) return epoch;
            return "";
        }
        _clearRefreshTimeout() {
            if (this._refreshTimeout !== null) {
                clearTimeout(this._refreshTimeout);
                this._refreshTimeout = null;
            }
        }
        _clearResubscribeTimeout() {
            if (this._resubscribeTimeout !== null) {
                clearTimeout(this._resubscribeTimeout);
                this._resubscribeTimeout = null;
            }
        }
        _getSubscriptionToken() {
            this._centrifuge._debug("get subscription token for channel", this.channel);
            const ctx = {
                channel: this.channel
            };
            const getToken2 = this._getToken;
            if (getToken2 === null) {
                this.emit("error", {
                    type: "configuration",
                    channel: this.channel,
                    error: {
                        code: codes_1.errorCodes.badConfiguration,
                        message: "provide a function to get channel subscription token"
                    }
                });
                throw new centrifuge_1.UnauthorizedError("");
            }
            return getToken2(ctx);
        }
        _refresh() {
            this._clearRefreshTimeout();
            const self2 = this;
            this._getSubscriptionToken().then(function(token2) {
                if (!self2._isSubscribed()) return;
                if (!token2) {
                    self2._failUnauthorized();
                    return;
                }
                self2._token = token2;
                const req = {
                    channel: self2.channel,
                    token: token2
                };
                const msg = {
                    "sub_refresh": req
                };
                self2._centrifuge._call(msg).then((resolveCtx)=>{
                    const result2 = resolveCtx.reply.sub_refresh;
                    self2._refreshResponse(result2);
                    if (resolveCtx.next) resolveCtx.next();
                }, (rejectCtx)=>{
                    self2._refreshError(rejectCtx.error);
                    if (rejectCtx.next) rejectCtx.next();
                });
            }).catch(function(e2) {
                if (e2 instanceof centrifuge_1.UnauthorizedError) {
                    self2._failUnauthorized();
                    return;
                }
                self2.emit("error", {
                    type: "refreshToken",
                    channel: self2.channel,
                    error: {
                        code: codes_1.errorCodes.subscriptionRefreshToken,
                        message: e2 !== void 0 ? e2.toString() : ""
                    }
                });
                self2._refreshTimeout = setTimeout(()=>self2._refresh(), self2._getRefreshRetryDelay());
            });
        }
        _refreshResponse(result2) {
            if (!this._isSubscribed()) return;
            this._centrifuge._debug("subscription token refreshed, channel", this.channel);
            this._clearRefreshTimeout();
            if (result2.expires === true) this._refreshTimeout = setTimeout(()=>this._refresh(), (0, utils_12.ttlMilliseconds)(result2.ttl));
        }
        _refreshError(err) {
            if (!this._isSubscribed()) return;
            if (err.code < 100 || err.temporary === true) {
                this.emit("error", {
                    type: "refresh",
                    channel: this.channel,
                    error: err
                });
                this._refreshTimeout = setTimeout(()=>this._refresh(), this._getRefreshRetryDelay());
            } else this._setUnsubscribed(err.code, err.message, true);
        }
        _getRefreshRetryDelay() {
            return (0, utils_12.backoff)(0, 1e4, 2e4);
        }
        _failUnauthorized() {
            this._setUnsubscribed(codes_1.unsubscribedCodes.unauthorized, "unauthorized", true);
        }
    }
    subscription.Subscription = Subscription2;
    return subscription;
}
var transport_sockjs = {};
Object.defineProperty(transport_sockjs, "__esModule", {
    value: true
});
transport_sockjs.SockjsTransport = void 0;
class SockjsTransport {
    constructor(endpoint, options){
        this.endpoint = endpoint;
        this.options = options;
        this._transport = null;
    }
    name() {
        return "sockjs";
    }
    subName() {
        return "sockjs-" + this._transport.transport;
    }
    emulation() {
        return false;
    }
    supported() {
        return this.options.sockjs !== null;
    }
    initialize(_protocol, callbacks) {
        this._transport = new this.options.sockjs(this.endpoint, null, this.options.sockjsOptions);
        this._transport.onopen = ()=>{
            callbacks.onOpen();
        };
        this._transport.onerror = (e2)=>{
            callbacks.onError(e2);
        };
        this._transport.onclose = (closeEvent)=>{
            callbacks.onClose(closeEvent);
        };
        this._transport.onmessage = (event2)=>{
            callbacks.onMessage(event2.data);
        };
    }
    close() {
        this._transport.close();
    }
    send(data) {
        this._transport.send(data);
    }
}
transport_sockjs.SockjsTransport = SockjsTransport;
var transport_websocket = {};
Object.defineProperty(transport_websocket, "__esModule", {
    value: true
});
transport_websocket.WebsocketTransport = void 0;
class WebsocketTransport {
    constructor(endpoint, options){
        this.endpoint = endpoint;
        this.options = options;
        this._transport = null;
    }
    name() {
        return "websocket";
    }
    subName() {
        return "websocket";
    }
    emulation() {
        return false;
    }
    supported() {
        return this.options.websocket !== void 0 && this.options.websocket !== null;
    }
    initialize(protocol2, callbacks) {
        let subProtocol = "";
        if (protocol2 === "protobuf") subProtocol = "centrifuge-protobuf";
        if (subProtocol !== "") this._transport = new this.options.websocket(this.endpoint, subProtocol);
        else this._transport = new this.options.websocket(this.endpoint);
        if (protocol2 === "protobuf") this._transport.binaryType = "arraybuffer";
        this._transport.onopen = ()=>{
            callbacks.onOpen();
        };
        this._transport.onerror = (e2)=>{
            callbacks.onError(e2);
        };
        this._transport.onclose = (closeEvent)=>{
            callbacks.onClose(closeEvent);
        };
        this._transport.onmessage = (event2)=>{
            callbacks.onMessage(event2.data);
        };
    }
    close() {
        this._transport.close();
    }
    send(data) {
        this._transport.send(data);
    }
}
transport_websocket.WebsocketTransport = WebsocketTransport;
var transport_http_stream = {};
Object.defineProperty(transport_http_stream, "__esModule", {
    value: true
});
transport_http_stream.HttpStreamTransport = void 0;
class HttpStreamTransport {
    constructor(endpoint, options){
        this.endpoint = endpoint;
        this.options = options;
        this._abortController = null;
        this._utf8decoder = new TextDecoder();
        this._protocol = "json";
    }
    name() {
        return "http_stream";
    }
    subName() {
        return "http_stream";
    }
    emulation() {
        return true;
    }
    _handleErrors(response) {
        if (!response.ok) throw new Error(response.status);
        return response;
    }
    _fetchEventTarget(self2, endpoint, options) {
        const eventTarget = new EventTarget();
        const fetchFunc = self2.options.fetch;
        fetchFunc(endpoint, options).then(self2._handleErrors).then((response)=>{
            eventTarget.dispatchEvent(new Event("open"));
            let jsonStreamBuf = "";
            let jsonStreamPos = 0;
            let protoStreamBuf = new Uint8Array();
            const reader = response.body.getReader();
            return new self2.options.readableStream({
                start (controller2) {
                    function pump() {
                        return reader.read().then(({ done, value: value2 })=>{
                            if (done) {
                                eventTarget.dispatchEvent(new Event("close"));
                                controller2.close();
                                return;
                            }
                            try {
                                if (self2._protocol === "json") {
                                    jsonStreamBuf += self2._utf8decoder.decode(value2);
                                    while(jsonStreamPos < jsonStreamBuf.length)if (jsonStreamBuf[jsonStreamPos] === "\n") {
                                        const line = jsonStreamBuf.substring(0, jsonStreamPos);
                                        eventTarget.dispatchEvent(new MessageEvent("message", {
                                            data: line
                                        }));
                                        jsonStreamBuf = jsonStreamBuf.substring(jsonStreamPos + 1);
                                        jsonStreamPos = 0;
                                    } else ++jsonStreamPos;
                                } else {
                                    const mergedArray = new Uint8Array(protoStreamBuf.length + value2.length);
                                    mergedArray.set(protoStreamBuf);
                                    mergedArray.set(value2, protoStreamBuf.length);
                                    protoStreamBuf = mergedArray;
                                    while(true){
                                        const result2 = self2.options.decoder.decodeReply(protoStreamBuf);
                                        if (result2.ok) {
                                            const data = protoStreamBuf.slice(0, result2.pos);
                                            eventTarget.dispatchEvent(new MessageEvent("message", {
                                                data: data
                                            }));
                                            protoStreamBuf = protoStreamBuf.slice(result2.pos);
                                            continue;
                                        }
                                        break;
                                    }
                                }
                            } catch (error2) {
                                eventTarget.dispatchEvent(new Event("error", {
                                    detail: error2
                                }));
                                eventTarget.dispatchEvent(new Event("close"));
                                controller2.close();
                                return;
                            }
                            pump();
                        }).catch(function(e2) {
                            eventTarget.dispatchEvent(new Event("error", {
                                detail: e2
                            }));
                            eventTarget.dispatchEvent(new Event("close"));
                            controller2.close();
                            return;
                        });
                    }
                    return pump();
                }
            });
        }).catch((error2)=>{
            eventTarget.dispatchEvent(new Event("error", {
                detail: error2
            }));
            eventTarget.dispatchEvent(new Event("close"));
        });
        return eventTarget;
    }
    supported() {
        return this.options.fetch !== null && this.options.readableStream !== null && typeof TextDecoder !== "undefined" && typeof AbortController !== "undefined" && typeof EventTarget !== "undefined" && typeof Event !== "undefined" && typeof MessageEvent !== "undefined" && typeof Error !== "undefined";
    }
    initialize(protocol2, callbacks, initialData) {
        this._protocol = protocol2;
        this._abortController = new AbortController();
        let headers;
        let body2;
        if (protocol2 === "json") {
            headers = {
                "Accept": "application/json",
                "Content-Type": "application/json"
            };
            body2 = initialData;
        } else {
            headers = {
                "Accept": "application/octet-stream",
                "Content-Type": "application/octet-stream"
            };
            body2 = initialData;
        }
        const fetchOptions = {
            method: "POST",
            headers: headers,
            body: body2,
            mode: "cors",
            credentials: "same-origin",
            cache: "no-cache",
            signal: this._abortController.signal
        };
        const eventTarget = this._fetchEventTarget(this, this.endpoint, fetchOptions);
        eventTarget.addEventListener("open", ()=>{
            callbacks.onOpen();
        });
        eventTarget.addEventListener("error", (e2)=>{
            this._abortController.abort();
            callbacks.onError(e2);
        });
        eventTarget.addEventListener("close", ()=>{
            this._abortController.abort();
            callbacks.onClose({
                code: 4,
                reason: "connection closed"
            });
        });
        eventTarget.addEventListener("message", (e2)=>{
            callbacks.onMessage(e2.data);
        });
    }
    close() {
        this._abortController.abort();
    }
    send(data, session, node) {
        let headers;
        let body2;
        const req = {
            session: session,
            node: node,
            data: data
        };
        if (this._protocol === "json") {
            headers = {
                "Content-Type": "application/json"
            };
            body2 = JSON.stringify(req);
        } else {
            headers = {
                "Content-Type": "application/octet-stream"
            };
            body2 = this.options.encoder.encodeEmulationRequest(req);
        }
        const fetchFunc = this.options.fetch;
        const fetchOptions = {
            method: "POST",
            headers: headers,
            body: body2,
            mode: "cors",
            credentials: "same-origin",
            cache: "no-cache"
        };
        fetchFunc(this.options.emulationEndpoint, fetchOptions);
    }
}
transport_http_stream.HttpStreamTransport = HttpStreamTransport;
var transport_sse = {};
Object.defineProperty(transport_sse, "__esModule", {
    value: true
});
transport_sse.SseTransport = void 0;
class SseTransport {
    constructor(endpoint, options){
        this.endpoint = endpoint;
        this.options = options;
        this._protocol = "json";
        this._transport = null;
        this._onClose = null;
    }
    name() {
        return "sse";
    }
    subName() {
        return "sse";
    }
    emulation() {
        return true;
    }
    supported() {
        return this.options.eventsource !== null && this.options.fetch !== null;
    }
    initialize(_protocol, callbacks, initialData) {
        let url;
        if (globalThis && globalThis.document && globalThis.document.baseURI) url = new URL(this.endpoint, globalThis.document.baseURI);
        else url = new URL(this.endpoint);
        url.searchParams.append("cf_connect", initialData);
        const eventsourceOptions = {};
        const eventSource = new this.options.eventsource(url.toString(), eventsourceOptions);
        this._transport = eventSource;
        const self2 = this;
        eventSource.onopen = function() {
            callbacks.onOpen();
        };
        eventSource.onerror = function(e2) {
            eventSource.close();
            callbacks.onError(e2);
            callbacks.onClose({
                code: 4,
                reason: "connection closed"
            });
        };
        eventSource.onmessage = function(e2) {
            callbacks.onMessage(e2.data);
        };
        self2._onClose = function() {
            callbacks.onClose({
                code: 4,
                reason: "connection closed"
            });
        };
    }
    close() {
        this._transport.close();
        if (this._onClose !== null) this._onClose();
    }
    send(data, session, node) {
        const req = {
            session: session,
            node: node,
            data: data
        };
        const headers = {
            "Content-Type": "application/json"
        };
        const body2 = JSON.stringify(req);
        const fetchFunc = this.options.fetch;
        const fetchOptions = {
            method: "POST",
            headers: headers,
            body: body2,
            mode: "cors",
            credentials: "same-origin",
            cache: "no-cache"
        };
        fetchFunc(this.options.emulationEndpoint, fetchOptions);
    }
}
transport_sse.SseTransport = SseTransport;
var transport_webtransport = {};
var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P2, generator) {
    function adopt(value2) {
        return value2 instanceof P2 ? value2 : new P2(function(resolve) {
            resolve(value2);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value2) {
            try {
                step(generator.next(value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function rejected(value2) {
            try {
                step(generator["throw"](value2));
            } catch (e2) {
                reject(e2);
            }
        }
        function step(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(transport_webtransport, "__esModule", {
    value: true
});
transport_webtransport.WebtransportTransport = void 0;
class WebtransportTransport {
    constructor(endpoint, options){
        this.endpoint = endpoint;
        this.options = options;
        this._transport = null;
        this._stream = null;
        this._writer = null;
        this._utf8decoder = new TextDecoder();
        this._protocol = "json";
    }
    name() {
        return "webtransport";
    }
    subName() {
        return "webtransport";
    }
    emulation() {
        return false;
    }
    supported() {
        return this.options.webtransport !== void 0 && this.options.webtransport !== null;
    }
    initialize(protocol2, callbacks) {
        return __awaiter(this, void 0, void 0, function*() {
            let url;
            if (globalThis && globalThis.document && globalThis.document.baseURI) url = new URL(this.endpoint, globalThis.document.baseURI);
            else url = new URL(this.endpoint);
            if (protocol2 === "protobuf") url.searchParams.append("cf_protocol", "protobuf");
            this._protocol = protocol2;
            const eventTarget = new EventTarget();
            this._transport = new this.options.webtransport(url.toString());
            this._transport.closed.then(()=>{
                callbacks.onClose({
                    code: 4,
                    reason: "connection closed"
                });
            }).catch(()=>{
                callbacks.onClose({
                    code: 4,
                    reason: "connection closed"
                });
            });
            try {
                yield this._transport.ready;
            } catch (_a3) {
                this.close();
                return;
            }
            let stream2;
            try {
                stream2 = yield this._transport.createBidirectionalStream();
            } catch (_b2) {
                this.close();
                return;
            }
            this._stream = stream2;
            this._writer = this._stream.writable.getWriter();
            eventTarget.addEventListener("close", ()=>{
                callbacks.onClose({
                    code: 4,
                    reason: "connection closed"
                });
            });
            eventTarget.addEventListener("message", (e2)=>{
                callbacks.onMessage(e2.data);
            });
            this._startReading(eventTarget);
            callbacks.onOpen();
        });
    }
    _startReading(eventTarget) {
        return __awaiter(this, void 0, void 0, function*() {
            const reader = this._stream.readable.getReader();
            let jsonStreamBuf = "";
            let jsonStreamPos = 0;
            let protoStreamBuf = new Uint8Array();
            try {
                while(true){
                    const { done, value: value2 } = yield reader.read();
                    if (value2.length > 0) {
                        if (this._protocol === "json") {
                            jsonStreamBuf += this._utf8decoder.decode(value2);
                            while(jsonStreamPos < jsonStreamBuf.length)if (jsonStreamBuf[jsonStreamPos] === "\n") {
                                const line = jsonStreamBuf.substring(0, jsonStreamPos);
                                eventTarget.dispatchEvent(new MessageEvent("message", {
                                    data: line
                                }));
                                jsonStreamBuf = jsonStreamBuf.substring(jsonStreamPos + 1);
                                jsonStreamPos = 0;
                            } else ++jsonStreamPos;
                        } else {
                            const mergedArray = new Uint8Array(protoStreamBuf.length + value2.length);
                            mergedArray.set(protoStreamBuf);
                            mergedArray.set(value2, protoStreamBuf.length);
                            protoStreamBuf = mergedArray;
                            while(true){
                                const result2 = this.options.decoder.decodeReply(protoStreamBuf);
                                if (result2.ok) {
                                    const data = protoStreamBuf.slice(0, result2.pos);
                                    eventTarget.dispatchEvent(new MessageEvent("message", {
                                        data: data
                                    }));
                                    protoStreamBuf = protoStreamBuf.slice(result2.pos);
                                    continue;
                                }
                                break;
                            }
                        }
                    }
                    if (done) break;
                }
            } catch (_a3) {
                eventTarget.dispatchEvent(new Event("close"));
            }
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                if (this._writer) yield this._writer.close();
                this._transport.close();
            } catch (e2) {}
        });
    }
    send(data) {
        return __awaiter(this, void 0, void 0, function*() {
            let binary;
            if (this._protocol === "json") binary = new TextEncoder().encode(data + "\n");
            else binary = data;
            try {
                yield this._writer.write(binary);
            } catch (e2) {
                this.close();
            }
        });
    }
}
transport_webtransport.WebtransportTransport = WebtransportTransport;
var json = {};
Object.defineProperty(json, "__esModule", {
    value: true
});
json.JsonDecoder = json.JsonEncoder = void 0;
class JsonEncoder {
    encodeCommands(commands) {
        return commands.map((c2)=>JSON.stringify(c2)).join("\n");
    }
}
json.JsonEncoder = JsonEncoder;
class JsonDecoder {
    decodeReplies(data) {
        return data.trim().split("\n").map((r2)=>JSON.parse(r2));
    }
}
json.JsonDecoder = JsonDecoder;
var hasRequiredCentrifuge;
function requireCentrifuge() {
    if (hasRequiredCentrifuge) return centrifuge;
    hasRequiredCentrifuge = 1;
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(centrifuge, "__esModule", {
        value: true
    });
    centrifuge.Centrifuge = centrifuge.UnauthorizedError = void 0;
    const subscription_1 = requireSubscription();
    const codes_1 = codes;
    const transport_sockjs_1 = transport_sockjs;
    const transport_websocket_1 = transport_websocket;
    const transport_http_stream_1 = transport_http_stream;
    const transport_sse_1 = transport_sse;
    const transport_webtransport_1 = transport_webtransport;
    const json_1 = json;
    const utils_12 = utils$1;
    const types_1 = types;
    const events_1 = __importDefault((0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))));
    const defaults2 = {
        protocol: "json",
        token: "",
        getToken: null,
        data: null,
        getData: null,
        debug: false,
        name: "js",
        version: "",
        fetch: null,
        readableStream: null,
        websocket: null,
        eventsource: null,
        sockjs: null,
        sockjsOptions: {},
        emulationEndpoint: "/emulation",
        minReconnectDelay: 500,
        maxReconnectDelay: 2e4,
        timeout: 5e3,
        maxServerPingDelay: 1e4,
        networkEventTarget: null
    };
    class UnauthorizedError extends Error {
        constructor(message2){
            super(message2);
            this.name = this.constructor.name;
        }
    }
    centrifuge.UnauthorizedError = UnauthorizedError;
    class Centrifuge extends events_1.default {
        /** Constructs Centrifuge client. Call connect() method to start connecting. */ constructor(endpoint, options){
            super();
            this._reconnectTimeout = null;
            this._refreshTimeout = null;
            this._serverPingTimeout = null;
            this.state = types_1.State.Disconnected;
            this._endpoint = endpoint;
            this._emulation = false;
            this._transports = [];
            this._currentTransportIndex = 0;
            this._triedAllTransports = false;
            this._transportWasOpen = false;
            this._transport = null;
            this._transportId = 0;
            this._deviceWentOffline = false;
            this._transportClosed = true;
            this._encoder = null;
            this._decoder = null;
            this._reconnecting = false;
            this._reconnectTimeout = null;
            this._reconnectAttempts = 0;
            this._client = null;
            this._session = "";
            this._node = "";
            this._subs = {};
            this._serverSubs = {};
            this._commandId = 0;
            this._commands = [];
            this._batching = false;
            this._refreshRequired = false;
            this._refreshTimeout = null;
            this._callbacks = {};
            this._token = "";
            this._data = null;
            this._dispatchPromise = Promise.resolve();
            this._serverPing = 0;
            this._serverPingTimeout = null;
            this._sendPong = false;
            this._promises = {};
            this._promiseId = 0;
            this._debugEnabled = false;
            this._networkEventsSet = false;
            this._config = Object.assign(Object.assign({}, defaults2), options);
            this._configure();
            if (this._debugEnabled) {
                this.on("state", (ctx)=>{
                    this._debug("client state", ctx.oldState, "->", ctx.newState);
                });
                this.on("error", (ctx)=>{
                    this._debug("client error", ctx);
                });
            } else this.on("error", function() {
                Function.prototype();
            });
        }
        /** newSubscription allocates new Subscription to a channel. Since server only allows
     * one subscription per channel per client this method throws if client already has
     * channel subscription in internal registry.
     * */ newSubscription(channel2, options) {
            if (this.getSubscription(channel2) !== null) throw new Error("Subscription to the channel " + channel2 + " already exists");
            const sub = new subscription_1.Subscription(this, channel2, options);
            this._subs[channel2] = sub;
            return sub;
        }
        /** getSubscription returns Subscription if it's registered in the internal
     * registry or null. */ getSubscription(channel2) {
            return this._getSub(channel2);
        }
        /** removeSubscription allows removing Subcription from the internal registry. Subscrption
     * must be in unsubscribed state. */ removeSubscription(sub) {
            if (!sub) return;
            if (sub.state !== types_1.SubscriptionState.Unsubscribed) sub.unsubscribe();
            this._removeSubscription(sub);
        }
        /** Get a map with all current client-side subscriptions. */ subscriptions() {
            return this._subs;
        }
        /** ready returns a Promise which resolves upon client goes to Connected
     * state and rejects in case of client goes to Disconnected or Failed state.
     * Users can provide optional timeout in milliseconds. */ ready(timeout2) {
            if (this.state === types_1.State.Disconnected) return Promise.reject({
                code: codes_1.errorCodes.clientDisconnected,
                message: "client disconnected"
            });
            if (this.state === types_1.State.Connected) return Promise.resolve();
            return new Promise((res, rej)=>{
                const ctx = {
                    resolve: res,
                    reject: rej
                };
                if (timeout2) ctx.timeout = setTimeout(function() {
                    rej({
                        code: codes_1.errorCodes.timeout,
                        message: "timeout"
                    });
                }, timeout2);
                this._promises[this._nextPromiseId()] = ctx;
            });
        }
        /** connect to a server. */ connect() {
            if (this._isConnected()) {
                this._debug("connect called when already connected");
                return;
            }
            if (this._isConnecting()) {
                this._debug("connect called when already connecting");
                return;
            }
            this._debug("connect called");
            this._reconnectAttempts = 0;
            this._startConnecting();
        }
        /** disconnect from a server. */ disconnect() {
            this._disconnect(codes_1.disconnectedCodes.disconnectCalled, "disconnect called", false);
        }
        setToken(token2) {
            this._token = token2;
        }
        /** send asynchronous data to a server (without any response from a server
     * expected, see rpc method if you need response). */ send(data) {
            const cmd = {
                send: {
                    data: data
                }
            };
            const self2 = this;
            return this._methodCall().then(function() {
                const sent = self2._transportSendCommands([
                    cmd
                ]);
                if (!sent) return Promise.reject(self2._createErrorObject(codes_1.errorCodes.transportWriteError, "transport write error"));
                return Promise.resolve();
            });
        }
        /** rpc to a server - i.e. a call which waits for a response with data. */ rpc(method, data) {
            const cmd = {
                rpc: {
                    method: method,
                    data: data
                }
            };
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._callPromise(cmd, function(reply) {
                    return {
                        "data": reply.rpc.data
                    };
                });
            });
        }
        /** publish data to a channel. */ publish(channel2, data) {
            const cmd = {
                publish: {
                    channel: channel2,
                    data: data
                }
            };
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._callPromise(cmd, function() {
                    return {};
                });
            });
        }
        /** history for a channel. By default it does not return publications (only current
     *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/ history(channel2, options) {
            const cmd = {
                history: this._getHistoryRequest(channel2, options)
            };
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._callPromise(cmd, function(reply) {
                    const result2 = reply.history;
                    const publications = [];
                    if (result2.publications) for(let i = 0; i < result2.publications.length; i++)publications.push(self2._getPublicationContext(channel2, result2.publications[i]));
                    return {
                        "publications": publications,
                        "epoch": result2.epoch || "",
                        "offset": result2.offset || 0
                    };
                });
            });
        }
        /** presence for a channel. */ presence(channel2) {
            const cmd = {
                presence: {
                    channel: channel2
                }
            };
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._callPromise(cmd, function(reply) {
                    const clients = reply.presence.presence;
                    for(const clientId in clients)if (clients.hasOwnProperty(clientId)) {
                        const connInfo = clients[clientId]["conn_info"];
                        const chanInfo = clients[clientId]["chan_info"];
                        if (connInfo) clients[clientId].connInfo = connInfo;
                        if (chanInfo) clients[clientId].chanInfo = chanInfo;
                    }
                    return {
                        "clients": clients
                    };
                });
            });
        }
        /** presence stats for a channel. */ presenceStats(channel2) {
            const cmd = {
                "presence_stats": {
                    channel: channel2
                }
            };
            const self2 = this;
            return this._methodCall().then(function() {
                return self2._callPromise(cmd, function(reply) {
                    const result2 = reply.presence_stats;
                    return {
                        "numUsers": result2.num_users,
                        "numClients": result2.num_clients
                    };
                });
            });
        }
        /** start command batching (collect into temporary buffer without sending to a server)
     * until stopBatching called.*/ startBatching() {
            this._batching = true;
        }
        /** stop batching commands and flush collected commands to the
     * network (all in one request/frame).*/ stopBatching() {
            const self2 = this;
            Promise.resolve().then(function() {
                Promise.resolve().then(function() {
                    self2._batching = false;
                    self2._flush();
                });
            });
        }
        _debug(...args) {
            if (!this._debugEnabled) return;
            (0, utils_12.log)("debug", args);
        }
        /** @internal */ _setFormat(format2) {
            if (this._formatOverride(format2)) return;
            if (format2 === "protobuf") throw new Error("not implemented by JSON-only Centrifuge client, use client with Protobuf support");
            this._encoder = new json_1.JsonEncoder();
            this._decoder = new json_1.JsonDecoder();
        }
        /** @internal */ _formatOverride(_format) {
            return false;
        }
        _configure() {
            if (!("Promise" in globalThis)) throw new Error("Promise polyfill required");
            if (!this._endpoint) throw new Error("endpoint configuration required");
            if (this._config.protocol !== "json" && this._config.protocol !== "protobuf") throw new Error("unsupported protocol " + this._config.protocol);
            if (this._config.token !== null) this._token = this._config.token;
            if (this._config.data !== null) this._data = this._config.data;
            this._setFormat("json");
            if (this._config.protocol === "protobuf") this._setFormat("protobuf");
            if (this._config.debug === true || typeof localStorage !== "undefined" && localStorage.getItem("centrifuge.debug")) this._debugEnabled = true;
            this._debug("config", this._config);
            if (typeof this._endpoint === "string") ;
            else if (typeof this._endpoint === "object" && this._endpoint instanceof Array) {
                this._transports = this._endpoint;
                this._emulation = true;
                for(const i in this._transports){
                    const transportConfig = this._transports[i];
                    if (!transportConfig.endpoint || !transportConfig.transport) throw new Error("malformed transport configuration");
                    const transportName = transportConfig.transport;
                    if ([
                        "websocket",
                        "http_stream",
                        "sse",
                        "sockjs",
                        "webtransport"
                    ].indexOf(transportName) < 0) throw new Error("unsupported transport name: " + transportName);
                }
            } else throw new Error("unsupported url configuration type: only string or array of objects are supported");
        }
        _setState(newState) {
            if (this.state !== newState) {
                this._reconnecting = false;
                const oldState = this.state;
                this.state = newState;
                this.emit("state", {
                    newState: newState,
                    oldState: oldState
                });
                return true;
            }
            return false;
        }
        _isDisconnected() {
            return this.state === types_1.State.Disconnected;
        }
        _isConnecting() {
            return this.state === types_1.State.Connecting;
        }
        _isConnected() {
            return this.state === types_1.State.Connected;
        }
        _nextCommandId() {
            return ++this._commandId;
        }
        _setNetworkEvents() {
            if (this._networkEventsSet) return;
            let eventTarget = null;
            if (this._config.networkEventTarget !== null) eventTarget = this._config.networkEventTarget;
            else if (typeof globalThis.addEventListener !== "undefined") eventTarget = globalThis;
            if (eventTarget) {
                eventTarget.addEventListener("offline", ()=>{
                    this._debug("offline event triggered");
                    if (this.state === types_1.State.Connected || this.state === types_1.State.Connecting) {
                        this._disconnect(codes_1.connectingCodes.transportClosed, "transport closed", true);
                        this._deviceWentOffline = true;
                    }
                });
                eventTarget.addEventListener("online", ()=>{
                    this._debug("online event triggered");
                    if (this.state !== types_1.State.Connecting) return;
                    if (this._deviceWentOffline && !this._transportClosed) {
                        this._deviceWentOffline = false;
                        this._transportClosed = true;
                    }
                    this._clearReconnectTimeout();
                    this._startReconnecting();
                });
                this._networkEventsSet = true;
            }
        }
        _getReconnectDelay() {
            const delay2 = (0, utils_12.backoff)(this._reconnectAttempts, this._config.minReconnectDelay, this._config.maxReconnectDelay);
            this._reconnectAttempts += 1;
            return delay2;
        }
        _clearOutgoingRequests() {
            for(const id in this._callbacks)if (this._callbacks.hasOwnProperty(id)) {
                const callbacks = this._callbacks[id];
                clearTimeout(callbacks.timeout);
                const errback = callbacks.errback;
                if (!errback) continue;
                errback({
                    error: this._createErrorObject(codes_1.errorCodes.connectionClosed, "connection closed")
                });
            }
            this._callbacks = {};
        }
        _clearConnectedState() {
            this._client = null;
            this._clearServerPingTimeout();
            this._clearRefreshTimeout();
            for(const channel2 in this._subs){
                if (!this._subs.hasOwnProperty(channel2)) continue;
                const sub = this._subs[channel2];
                if (sub.state === types_1.SubscriptionState.Subscribed) sub._setSubscribing(codes_1.subscribingCodes.transportClosed, "transport closed");
            }
            for(const channel2 in this._serverSubs)if (this._serverSubs.hasOwnProperty(channel2)) this.emit("subscribing", {
                channel: channel2
            });
        }
        _handleWriteError(commands) {
            for (const command of commands){
                const id = command.id;
                if (!(id in this._callbacks)) continue;
                const callbacks = this._callbacks[id];
                clearTimeout(this._callbacks[id].timeout);
                delete this._callbacks[id];
                const errback = callbacks.errback;
                errback({
                    error: this._createErrorObject(codes_1.errorCodes.transportWriteError, "transport write error")
                });
            }
        }
        _transportSendCommands(commands) {
            if (!commands.length) return true;
            if (!this._transport) return false;
            try {
                this._transport.send(this._encoder.encodeCommands(commands), this._session, this._node);
            } catch (e2) {
                this._debug("error writing commands", e2);
                this._handleWriteError(commands);
                return false;
            }
            return true;
        }
        _initializeTransport() {
            let websocket2;
            if (this._config.websocket !== null) websocket2 = this._config.websocket;
            else if (!(typeof globalThis.WebSocket !== "function" && typeof globalThis.WebSocket !== "object")) websocket2 = globalThis.WebSocket;
            let sockjs = null;
            if (this._config.sockjs !== null) sockjs = this._config.sockjs;
            else if (typeof globalThis.SockJS !== "undefined") sockjs = globalThis.SockJS;
            let eventsource = null;
            if (this._config.eventsource !== null) eventsource = this._config.eventsource;
            else if (typeof globalThis.EventSource !== "undefined") eventsource = globalThis.EventSource;
            let fetchFunc = null;
            if (this._config.fetch !== null) fetchFunc = this._config.fetch;
            else if (typeof globalThis.fetch !== "undefined") fetchFunc = globalThis.fetch;
            let readableStream = null;
            if (this._config.readableStream !== null) readableStream = this._config.readableStream;
            else if (typeof globalThis.ReadableStream !== "undefined") readableStream = globalThis.ReadableStream;
            if (!this._emulation) {
                if ((0, utils_12.startsWith)(this._endpoint, "http")) throw new Error("Provide explicit transport endpoints configuration in case of using HTTP (i.e. using array of TransportEndpoint instead of a single string), or use ws(s):// scheme in an endpoint if you aimed using WebSocket transport");
                else {
                    this._debug("client will use websocket");
                    this._transport = new transport_websocket_1.WebsocketTransport(this._endpoint, {
                        websocket: websocket2
                    });
                    if (!this._transport.supported()) throw new Error("WebSocket not available");
                }
            } else {
                if (this._currentTransportIndex >= this._transports.length) {
                    this._triedAllTransports = true;
                    this._currentTransportIndex = 0;
                }
                let count2 = 0;
                while(true){
                    if (count2 >= this._transports.length) throw new Error("no supported transport found");
                    const transportConfig = this._transports[this._currentTransportIndex];
                    const transportName = transportConfig.transport;
                    const transportEndpoint = transportConfig.endpoint;
                    if (transportName === "websocket") {
                        this._debug("trying websocket transport");
                        this._transport = new transport_websocket_1.WebsocketTransport(transportEndpoint, {
                            websocket: websocket2
                        });
                        if (!this._transport.supported()) {
                            this._debug("websocket transport not available");
                            this._currentTransportIndex++;
                            count2++;
                            continue;
                        }
                    } else if (transportName === "webtransport") {
                        this._debug("trying webtransport transport");
                        this._transport = new transport_webtransport_1.WebtransportTransport(transportEndpoint, {
                            webtransport: globalThis.WebTransport,
                            decoder: this._decoder,
                            encoder: this._encoder
                        });
                        if (!this._transport.supported()) {
                            this._debug("webtransport transport not available");
                            this._currentTransportIndex++;
                            count2++;
                            continue;
                        }
                    } else if (transportName === "http_stream") {
                        this._debug("trying http_stream transport");
                        this._transport = new transport_http_stream_1.HttpStreamTransport(transportEndpoint, {
                            fetch: fetchFunc,
                            readableStream: readableStream,
                            emulationEndpoint: this._config.emulationEndpoint,
                            decoder: this._decoder,
                            encoder: this._encoder
                        });
                        if (!this._transport.supported()) {
                            this._debug("http_stream transport not available");
                            this._currentTransportIndex++;
                            count2++;
                            continue;
                        }
                    } else if (transportName === "sse") {
                        this._debug("trying sse transport");
                        this._transport = new transport_sse_1.SseTransport(transportEndpoint, {
                            eventsource: eventsource,
                            fetch: fetchFunc,
                            emulationEndpoint: this._config.emulationEndpoint
                        });
                        if (!this._transport.supported()) {
                            this._debug("sse transport not available");
                            this._currentTransportIndex++;
                            count2++;
                            continue;
                        }
                    } else if (transportName === "sockjs") {
                        this._debug("trying sockjs");
                        this._transport = new transport_sockjs_1.SockjsTransport(transportEndpoint, {
                            sockjs: sockjs,
                            sockjsOptions: this._config.sockjsOptions
                        });
                        if (!this._transport.supported()) {
                            this._debug("sockjs transport not available");
                            this._currentTransportIndex++;
                            count2++;
                            continue;
                        }
                    } else throw new Error("unknown transport " + transportName);
                    break;
                }
            }
            const self2 = this;
            const transport = this._transport;
            const transportId = this._nextTransportId();
            self2._debug("id of transport", transportId);
            let wasOpen = false;
            let optimistic = true;
            if (this._transport.name() === "sse") optimistic = false;
            const initialCommands = [];
            if (this._transport.emulation()) {
                const connectCommand = self2._sendConnect(true);
                initialCommands.push(connectCommand);
                if (optimistic) {
                    const subscribeCommands = self2._sendSubscribeCommands(true, true);
                    for(const i in subscribeCommands)initialCommands.push(subscribeCommands[i]);
                }
            }
            this._setNetworkEvents();
            const initialData = this._encoder.encodeCommands(initialCommands);
            this._transportClosed = false;
            let connectTimeout;
            connectTimeout = setTimeout(function() {
                transport.close();
            }, this._config.timeout);
            this._transport.initialize(this._config.protocol, {
                onOpen: function() {
                    if (connectTimeout) {
                        clearTimeout(connectTimeout);
                        connectTimeout = null;
                    }
                    if (self2._transportId != transportId) {
                        self2._debug("open callback from non-actual transport");
                        transport.close();
                        return;
                    }
                    wasOpen = true;
                    self2._debug(transport.subName(), "transport open");
                    self2._transportWasOpen = true;
                    if (transport.emulation()) return;
                    self2.startBatching();
                    self2._sendConnect(false);
                    if (optimistic) self2._sendSubscribeCommands(true, false);
                    self2.stopBatching();
                },
                onError: function(e2) {
                    if (self2._transportId != transportId) {
                        self2._debug("error callback from non-actual transport");
                        return;
                    }
                    self2._debug("transport level error", e2);
                },
                onClose: function(closeEvent) {
                    if (connectTimeout) {
                        clearTimeout(connectTimeout);
                        connectTimeout = null;
                    }
                    if (self2._transportId != transportId) {
                        self2._debug("close callback from non-actual transport");
                        return;
                    }
                    self2._debug(transport.subName(), "transport closed");
                    self2._transportClosed = true;
                    let reason2 = "connection closed";
                    let needReconnect = true;
                    let code = 0;
                    if (closeEvent && "code" in closeEvent && closeEvent.code) code = closeEvent.code;
                    if (closeEvent && closeEvent.reason) try {
                        const advice = JSON.parse(closeEvent.reason);
                        reason2 = advice.reason;
                        needReconnect = advice.reconnect;
                    } catch (e2) {
                        reason2 = closeEvent.reason;
                        if (code >= 3500 && code < 4e3 || code >= 4500 && code < 5e3) needReconnect = false;
                    }
                    if (code < 3e3) {
                        if (code === 1009) {
                            code = codes_1.disconnectedCodes.messageSizeLimit;
                            reason2 = "message size limit exceeded";
                            needReconnect = false;
                        } else {
                            code = codes_1.connectingCodes.transportClosed;
                            reason2 = "transport closed";
                        }
                        if (self2._emulation && !self2._transportWasOpen) {
                            self2._currentTransportIndex++;
                            if (self2._currentTransportIndex >= self2._transports.length) {
                                self2._triedAllTransports = true;
                                self2._currentTransportIndex = 0;
                            }
                        }
                    } else self2._transportWasOpen = true;
                    if (self2._isConnecting() && !wasOpen) self2.emit("error", {
                        type: "transport",
                        error: {
                            code: codes_1.errorCodes.transportClosed,
                            message: "transport closed"
                        },
                        transport: transport.name()
                    });
                    self2._reconnecting = false;
                    self2._disconnect(code, reason2, needReconnect);
                },
                onMessage: function(data) {
                    self2._dataReceived(data);
                }
            }, initialData);
        }
        _sendConnect(skipSending) {
            const connectCommand = this._constructConnectCommand();
            const self2 = this;
            this._call(connectCommand, skipSending).then((resolveCtx)=>{
                const result2 = resolveCtx.reply.connect;
                self2._connectResponse(result2);
                if (resolveCtx.next) resolveCtx.next();
            }, (rejectCtx)=>{
                self2._connectError(rejectCtx.error);
                if (rejectCtx.next) rejectCtx.next();
            });
            return connectCommand;
        }
        _startReconnecting() {
            this._debug("start reconnecting");
            if (!this._isConnecting()) {
                this._debug("stop reconnecting: client not in connecting state");
                return;
            }
            if (this._reconnecting) {
                this._debug("reconnect already in progress, return from reconnect routine");
                return;
            }
            if (this._transportClosed === false) {
                this._debug("waiting for transport close");
                return;
            }
            this._reconnecting = true;
            const self2 = this;
            const emptyToken = this._token === "";
            const needTokenRefresh = this._refreshRequired || emptyToken && this._config.getToken !== null;
            if (!needTokenRefresh) {
                if (this._config.getData) this._config.getData().then(function(data) {
                    if (!self2._isConnecting()) return;
                    self2._data = data;
                    self2._initializeTransport();
                });
                else this._initializeTransport();
                return;
            }
            this._getToken().then(function(token2) {
                if (!self2._isConnecting()) return;
                if (token2 == null || token2 == void 0) {
                    self2._failUnauthorized();
                    return;
                }
                self2._token = token2;
                self2._debug("connection token refreshed");
                if (self2._config.getData) self2._config.getData().then(function(data) {
                    if (!self2._isConnecting()) return;
                    self2._data = data;
                    self2._initializeTransport();
                });
                else self2._initializeTransport();
            }).catch(function(e2) {
                if (!self2._isConnecting()) return;
                if (e2 instanceof UnauthorizedError) {
                    self2._failUnauthorized();
                    return;
                }
                self2.emit("error", {
                    "type": "connectToken",
                    "error": {
                        code: codes_1.errorCodes.clientConnectToken,
                        message: e2 !== void 0 ? e2.toString() : ""
                    }
                });
                const delay2 = self2._getReconnectDelay();
                self2._debug("error on connection token refresh, reconnect after " + delay2 + " milliseconds", e2);
                self2._reconnecting = false;
                self2._reconnectTimeout = setTimeout(()=>{
                    self2._startReconnecting();
                }, delay2);
            });
        }
        _connectError(err) {
            if (this.state !== types_1.State.Connecting) return;
            if (err.code === 109) this._refreshRequired = true;
            if (err.code < 100 || err.temporary === true || err.code === 109) {
                this.emit("error", {
                    "type": "connect",
                    "error": err
                });
                this._debug("closing transport due to connect error");
                this._reconnecting = false;
                this._disconnect(err.code, err.message, true);
            } else this._disconnect(err.code, err.message, false);
        }
        _scheduleReconnect() {
            if (!this._isConnecting()) return;
            let isInitialHandshake = false;
            if (this._emulation && !this._transportWasOpen && !this._triedAllTransports) isInitialHandshake = true;
            let delay2 = this._getReconnectDelay();
            if (isInitialHandshake) delay2 = 0;
            this._debug("reconnect after " + delay2 + " milliseconds");
            this._reconnectTimeout = setTimeout(()=>{
                this._startReconnecting();
            }, delay2);
        }
        _constructConnectCommand() {
            const req = {};
            if (this._token) req.token = this._token;
            if (this._data) req.data = this._data;
            if (this._config.name) req.name = this._config.name;
            if (this._config.version) req.version = this._config.version;
            const subs = {};
            let hasSubs = false;
            for(const channel2 in this._serverSubs)if (this._serverSubs.hasOwnProperty(channel2) && this._serverSubs[channel2].recoverable) {
                hasSubs = true;
                const sub = {
                    "recover": true
                };
                if (this._serverSubs[channel2].offset) sub["offset"] = this._serverSubs[channel2].offset;
                if (this._serverSubs[channel2].epoch) sub["epoch"] = this._serverSubs[channel2].epoch;
                subs[channel2] = sub;
            }
            if (hasSubs) req.subs = subs;
            return {
                connect: req
            };
        }
        _getHistoryRequest(channel2, options) {
            const req = {
                channel: channel2
            };
            if (options !== void 0) {
                if (options.since) {
                    req.since = {
                        offset: options.since.offset
                    };
                    if (options.since.epoch) req.since.epoch = options.since.epoch;
                }
                if (options.limit !== void 0) req.limit = options.limit;
                if (options.reverse === true) req.reverse = true;
            }
            return req;
        }
        _methodCall() {
            if (this._isConnected()) return Promise.resolve();
            return new Promise((res, rej)=>{
                const timeout2 = setTimeout(function() {
                    rej({
                        code: codes_1.errorCodes.timeout,
                        message: "timeout"
                    });
                }, this._config.timeout);
                this._promises[this._nextPromiseId()] = {
                    timeout: timeout2,
                    resolve: res,
                    reject: rej
                };
            });
        }
        _callPromise(cmd, resultCB) {
            return new Promise((resolve, reject)=>{
                this._call(cmd, false).then((resolveCtx)=>{
                    resolve(resultCB(resolveCtx.reply));
                    if (resolveCtx.next) resolveCtx.next();
                }, (rejectCtx)=>{
                    reject(rejectCtx.error);
                    if (rejectCtx.next) rejectCtx.next();
                });
            });
        }
        _dataReceived(data) {
            if (this._serverPing > 0) this._waitServerPing();
            const replies = this._decoder.decodeReplies(data);
            this._dispatchPromise = this._dispatchPromise.then(()=>{
                let finishDispatch;
                this._dispatchPromise = new Promise((resolve)=>{
                    finishDispatch = resolve;
                });
                this._dispatchSynchronized(replies, finishDispatch);
            });
        }
        _dispatchSynchronized(replies, finishDispatch) {
            let p2 = Promise.resolve();
            for(const i in replies)if (replies.hasOwnProperty(i)) p2 = p2.then(()=>{
                return this._dispatchReply(replies[i]);
            });
            p2 = p2.then(()=>{
                finishDispatch();
            });
        }
        _dispatchReply(reply) {
            let next2;
            const p2 = new Promise((resolve)=>{
                next2 = resolve;
            });
            if (reply === void 0 || reply === null) {
                this._debug("dispatch: got undefined or null reply");
                next2();
                return p2;
            }
            const id = reply.id;
            if (id && id > 0) this._handleReply(reply, next2);
            else if (!reply.push) this._handleServerPing(next2);
            else this._handlePush(reply.push, next2);
            return p2;
        }
        _call(cmd, skipSending) {
            return new Promise((resolve, reject)=>{
                cmd.id = this._nextCommandId();
                this._registerCall(cmd.id, resolve, reject);
                if (!skipSending) this._addCommand(cmd);
            });
        }
        _startConnecting() {
            this._debug("start connecting");
            if (this._setState(types_1.State.Connecting)) this.emit("connecting", {
                code: codes_1.connectingCodes.connectCalled,
                reason: "connect called"
            });
            this._client = null;
            this._startReconnecting();
        }
        _disconnect(code, reason2, reconnect) {
            if (this._isDisconnected()) return;
            const previousState = this.state;
            const ctx = {
                code: code,
                reason: reason2
            };
            let needEvent = false;
            if (reconnect) needEvent = this._setState(types_1.State.Connecting);
            else {
                needEvent = this._setState(types_1.State.Disconnected);
                this._rejectPromises({
                    code: codes_1.errorCodes.clientDisconnected,
                    message: "disconnected"
                });
            }
            this._clearOutgoingRequests();
            if (previousState === types_1.State.Connecting) this._clearReconnectTimeout();
            if (previousState === types_1.State.Connected) this._clearConnectedState();
            if (needEvent) {
                if (this._isConnecting()) this.emit("connecting", ctx);
                else this.emit("disconnected", ctx);
            }
            if (this._transport) {
                this._debug("closing existing transport");
                const transport = this._transport;
                this._transport = null;
                transport.close();
                this._transportClosed = true;
                this._nextTransportId();
            } else this._debug("no transport to close");
            this._scheduleReconnect();
        }
        _failUnauthorized() {
            this._disconnect(codes_1.disconnectedCodes.unauthorized, "unauthorized", false);
        }
        _getToken() {
            this._debug("get connection token");
            if (!this._config.getToken) {
                this.emit("error", {
                    type: "configuration",
                    error: {
                        code: codes_1.errorCodes.badConfiguration,
                        message: "token expired but no getToken function set in the configuration"
                    }
                });
                throw new UnauthorizedError("");
            }
            return this._config.getToken({});
        }
        _refresh() {
            const clientId = this._client;
            const self2 = this;
            this._getToken().then(function(token2) {
                if (clientId !== self2._client) return;
                if (!token2) {
                    self2._failUnauthorized();
                    return;
                }
                self2._token = token2;
                self2._debug("connection token refreshed");
                if (!self2._isConnected()) return;
                const cmd = {
                    refresh: {
                        token: self2._token
                    }
                };
                self2._call(cmd, false).then((resolveCtx)=>{
                    const result2 = resolveCtx.reply.refresh;
                    self2._refreshResponse(result2);
                    if (resolveCtx.next) resolveCtx.next();
                }, (rejectCtx)=>{
                    self2._refreshError(rejectCtx.error);
                    if (rejectCtx.next) rejectCtx.next();
                });
            }).catch(function(e2) {
                if (!self2._isConnected()) return;
                if (e2 instanceof UnauthorizedError) {
                    self2._failUnauthorized();
                    return;
                }
                self2.emit("error", {
                    type: "refreshToken",
                    error: {
                        code: codes_1.errorCodes.clientRefreshToken,
                        message: e2 !== void 0 ? e2.toString() : ""
                    }
                });
                self2._refreshTimeout = setTimeout(()=>self2._refresh(), self2._getRefreshRetryDelay());
            });
        }
        _refreshError(err) {
            if (err.code < 100 || err.temporary === true) {
                this.emit("error", {
                    type: "refresh",
                    error: err
                });
                this._refreshTimeout = setTimeout(()=>this._refresh(), this._getRefreshRetryDelay());
            } else this._disconnect(err.code, err.message, false);
        }
        _getRefreshRetryDelay() {
            return (0, utils_12.backoff)(0, 5e3, 1e4);
        }
        _refreshResponse(result2) {
            if (this._refreshTimeout) {
                clearTimeout(this._refreshTimeout);
                this._refreshTimeout = null;
            }
            if (result2.expires) {
                this._client = result2.client;
                this._refreshTimeout = setTimeout(()=>this._refresh(), (0, utils_12.ttlMilliseconds)(result2.ttl));
            }
        }
        _removeSubscription(sub) {
            if (sub === null) return;
            delete this._subs[sub.channel];
        }
        _unsubscribe(sub) {
            if (!this._isConnected()) return;
            const req = {
                channel: sub.channel
            };
            const cmd = {
                unsubscribe: req
            };
            const self2 = this;
            this._call(cmd, false).then((resolveCtx)=>{
                if (resolveCtx.next) resolveCtx.next();
            }, (rejectCtx)=>{
                if (rejectCtx.next) rejectCtx.next();
                self2._disconnect(codes_1.connectingCodes.unsubscribeError, "unsubscribe error", true);
            });
        }
        _getSub(channel2) {
            const sub = this._subs[channel2];
            if (!sub) return null;
            return sub;
        }
        _isServerSub(channel2) {
            return this._serverSubs[channel2] !== void 0;
        }
        _sendSubscribeCommands(optimistic, skipSending) {
            const commands = [];
            for(const channel2 in this._subs){
                if (!this._subs.hasOwnProperty(channel2)) continue;
                const sub = this._subs[channel2];
                if (sub._inflight === true) continue;
                if (sub.state === types_1.SubscriptionState.Subscribing) {
                    const cmd = sub._subscribe(optimistic, skipSending);
                    if (cmd) commands.push(cmd);
                }
            }
            return commands;
        }
        _connectResponse(result2) {
            this._transportWasOpen = true;
            this._reconnectAttempts = 0;
            this._refreshRequired = false;
            if (this._isConnected()) return;
            this._client = result2.client;
            this._setState(types_1.State.Connected);
            if (this._refreshTimeout) clearTimeout(this._refreshTimeout);
            if (result2.expires) this._refreshTimeout = setTimeout(()=>this._refresh(), (0, utils_12.ttlMilliseconds)(result2.ttl));
            this._session = result2.session;
            this._node = result2.node;
            this.startBatching();
            this._sendSubscribeCommands(false, false);
            this.stopBatching();
            const ctx = {
                client: result2.client,
                transport: this._transport.subName()
            };
            if (result2.data) ctx.data = result2.data;
            this.emit("connected", ctx);
            this._resolvePromises();
            this._processServerSubs(result2.subs || {});
            if (result2.ping && result2.ping > 0) {
                this._serverPing = result2.ping * 1e3;
                this._sendPong = result2.pong === true;
                this._waitServerPing();
            } else this._serverPing = 0;
        }
        _processServerSubs(subs) {
            for(const channel2 in subs){
                if (!subs.hasOwnProperty(channel2)) continue;
                const sub = subs[channel2];
                this._serverSubs[channel2] = {
                    "offset": sub.offset,
                    "epoch": sub.epoch,
                    "recoverable": sub.recoverable || false
                };
                const subCtx = this._getSubscribeContext(channel2, sub);
                this.emit("subscribed", subCtx);
            }
            for(const channel2 in subs){
                if (!subs.hasOwnProperty(channel2)) continue;
                const sub = subs[channel2];
                if (sub.recovered) {
                    const pubs = sub.publications;
                    if (pubs && pubs.length > 0) {
                        for(const i in pubs)if (pubs.hasOwnProperty(i)) this._handlePublication(channel2, pubs[i]);
                    }
                }
            }
            for(const channel2 in this._serverSubs){
                if (!this._serverSubs.hasOwnProperty(channel2)) continue;
                if (!subs[channel2]) {
                    this.emit("unsubscribed", {
                        channel: channel2
                    });
                    delete this._serverSubs[channel2];
                }
            }
        }
        _clearRefreshTimeout() {
            if (this._refreshTimeout !== null) {
                clearTimeout(this._refreshTimeout);
                this._refreshTimeout = null;
            }
        }
        _clearReconnectTimeout() {
            if (this._reconnectTimeout !== null) {
                clearTimeout(this._reconnectTimeout);
                this._reconnectTimeout = null;
            }
        }
        _clearServerPingTimeout() {
            if (this._serverPingTimeout !== null) {
                clearTimeout(this._serverPingTimeout);
                this._serverPingTimeout = null;
            }
        }
        _waitServerPing() {
            if (this._config.maxServerPingDelay === 0) return;
            if (!this._isConnected()) return;
            this._clearServerPingTimeout();
            this._serverPingTimeout = setTimeout(()=>{
                if (!this._isConnected()) return;
                this._disconnect(codes_1.connectingCodes.noPing, "no ping", true);
            }, this._serverPing + this._config.maxServerPingDelay);
        }
        _getSubscribeContext(channel2, result2) {
            const ctx = {
                channel: channel2,
                positioned: false,
                recoverable: false,
                wasRecovering: false,
                recovered: false
            };
            if (result2.recovered) ctx.recovered = true;
            if (result2.positioned) ctx.positioned = true;
            if (result2.recoverable) ctx.recoverable = true;
            if (result2.was_recovering) ctx.wasRecovering = true;
            let epoch = "";
            if ("epoch" in result2) epoch = result2.epoch;
            let offset2 = 0;
            if ("offset" in result2) offset2 = result2.offset;
            if (ctx.positioned || ctx.recoverable) ctx.streamPosition = {
                "offset": offset2,
                "epoch": epoch
            };
            if (result2.data) ctx.data = result2.data;
            return ctx;
        }
        _handleReply(reply, next2) {
            const id = reply.id;
            if (!(id in this._callbacks)) {
                next2();
                return;
            }
            const callbacks = this._callbacks[id];
            clearTimeout(this._callbacks[id].timeout);
            delete this._callbacks[id];
            if (!(0, utils_12.errorExists)(reply)) {
                const callback = callbacks.callback;
                if (!callback) return;
                callback({
                    reply: reply,
                    next: next2
                });
            } else {
                const errback = callbacks.errback;
                if (!errback) {
                    next2();
                    return;
                }
                const error2 = reply.error;
                errback({
                    error: error2,
                    next: next2
                });
            }
        }
        _handleJoin(channel2, join) {
            const sub = this._getSub(channel2);
            if (!sub) {
                if (this._isServerSub(channel2)) {
                    const ctx = {
                        channel: channel2,
                        info: this._getJoinLeaveContext(join.info)
                    };
                    this.emit("join", ctx);
                }
                return;
            }
            sub._handleJoin(join);
        }
        _handleLeave(channel2, leave) {
            const sub = this._getSub(channel2);
            if (!sub) {
                if (this._isServerSub(channel2)) {
                    const ctx = {
                        channel: channel2,
                        info: this._getJoinLeaveContext(leave.info)
                    };
                    this.emit("leave", ctx);
                }
                return;
            }
            sub._handleLeave(leave);
        }
        _handleUnsubscribe(channel2, unsubscribe) {
            const sub = this._getSub(channel2);
            if (!sub) {
                if (this._isServerSub(channel2)) {
                    delete this._serverSubs[channel2];
                    this.emit("unsubscribed", {
                        channel: channel2
                    });
                }
                return;
            }
            if (unsubscribe.code < 2500) sub._setUnsubscribed(unsubscribe.code, unsubscribe.reason, false);
            else sub._setSubscribing(unsubscribe.code, unsubscribe.reason);
        }
        _handleSubscribe(channel2, sub) {
            this._serverSubs[channel2] = {
                "offset": sub.offset,
                "epoch": sub.epoch,
                "recoverable": sub.recoverable || false
            };
            this.emit("subscribed", this._getSubscribeContext(channel2, sub));
        }
        _handleDisconnect(disconnect) {
            const code = disconnect.code;
            let reconnect = true;
            if (code >= 3500 && code < 4e3 || code >= 4500 && code < 5e3) reconnect = false;
            this._disconnect(code, disconnect.reason, reconnect);
        }
        _getPublicationContext(channel2, pub) {
            const ctx = {
                channel: channel2,
                data: pub.data
            };
            if (pub.offset) ctx.offset = pub.offset;
            if (pub.info) ctx.info = this._getJoinLeaveContext(pub.info);
            if (pub.tags) ctx.tags = pub.tags;
            return ctx;
        }
        _getJoinLeaveContext(clientInfo) {
            const info2 = {
                client: clientInfo.client,
                user: clientInfo.user
            };
            if (clientInfo.conn_info) info2.connInfo = clientInfo.conn_info;
            if (clientInfo.chan_info) info2.chanInfo = clientInfo.chan_info;
            return info2;
        }
        _handlePublication(channel2, pub) {
            const sub = this._getSub(channel2);
            if (!sub) {
                if (this._isServerSub(channel2)) {
                    const ctx = this._getPublicationContext(channel2, pub);
                    this.emit("publication", ctx);
                    if (pub.offset !== void 0) this._serverSubs[channel2].offset = pub.offset;
                }
                return;
            }
            sub._handlePublication(pub);
        }
        _handleMessage(message2) {
            this.emit("message", {
                data: message2.data
            });
        }
        _handleServerPing(next2) {
            if (this._sendPong) {
                const cmd = {};
                this._transportSendCommands([
                    cmd
                ]);
            }
            next2();
        }
        _handlePush(data, next2) {
            const channel2 = data.channel;
            if (data.pub) this._handlePublication(channel2, data.pub);
            else if (data.message) this._handleMessage(data.message);
            else if (data.join) this._handleJoin(channel2, data.join);
            else if (data.leave) this._handleLeave(channel2, data.leave);
            else if (data.unsubscribe) this._handleUnsubscribe(channel2, data.unsubscribe);
            else if (data.subscribe) this._handleSubscribe(channel2, data.subscribe);
            else if (data.disconnect) this._handleDisconnect(data.disconnect);
            next2();
        }
        _flush() {
            const commands = this._commands.slice(0);
            this._commands = [];
            this._transportSendCommands(commands);
        }
        _createErrorObject(code, message2, temporary) {
            const errObject = {
                code: code,
                message: message2
            };
            if (temporary) errObject.temporary = true;
            return errObject;
        }
        _registerCall(id, callback, errback) {
            this._callbacks[id] = {
                callback: callback,
                errback: errback,
                timeout: null
            };
            this._callbacks[id].timeout = setTimeout(()=>{
                delete this._callbacks[id];
                if ((0, utils_12.isFunction)(errback)) errback({
                    error: this._createErrorObject(codes_1.errorCodes.timeout, "timeout")
                });
            }, this._config.timeout);
        }
        _addCommand(command) {
            if (this._batching) this._commands.push(command);
            else this._transportSendCommands([
                command
            ]);
        }
        _nextPromiseId() {
            return ++this._promiseId;
        }
        _nextTransportId() {
            return ++this._transportId;
        }
        _resolvePromises() {
            for(const id in this._promises){
                if (this._promises[id].timeout) clearTimeout(this._promises[id].timeout);
                this._promises[id].resolve();
                delete this._promises[id];
            }
        }
        _rejectPromises(err) {
            for(const id in this._promises){
                if (this._promises[id].timeout) clearTimeout(this._promises[id].timeout);
                this._promises[id].reject(err);
                delete this._promises[id];
            }
        }
    }
    centrifuge.Centrifuge = Centrifuge;
    Centrifuge.SubscriptionState = types_1.SubscriptionState;
    Centrifuge.State = types_1.State;
    Centrifuge.UnauthorizedError = UnauthorizedError;
    return centrifuge;
}
(function(exports2) {
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m2, k2);
        if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m2[k2];
            }
        };
        Object.defineProperty(o2, k22, desc);
    } : function(o2, m2, k2, k22) {
        if (k22 === void 0) k22 = k2;
        o2[k22] = m2[k2];
    });
    var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports3) {
        for(var p2 in m2)if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2.Subscription = exports2.Centrifuge = void 0;
    const centrifuge_1 = requireCentrifuge();
    Object.defineProperty(exports2, "Centrifuge", {
        enumerable: true,
        get: function() {
            return centrifuge_1.Centrifuge;
        }
    });
    const subscription_1 = requireSubscription();
    Object.defineProperty(exports2, "Subscription", {
        enumerable: true,
        get: function() {
            return subscription_1.Subscription;
        }
    });
    __exportStar(types, exports2);
})(build$2);
var EWSStreamSlotMessageType = /* @__PURE__ */ ((EWSStreamSlotMessageType2)=>{
    EWSStreamSlotMessageType2["ONLINE_STATUS"] = "stream_slot_online_status";
    EWSStreamSlotMessageType2["END"] = "stream_slot_end";
    EWSStreamSlotMessageType2["INFO_UPDATE"] = "stream_slot_info_update";
    EWSStreamSlotMessageType2["LIKE_COUNTER"] = "stream_slot_like_counter";
    EWSStreamSlotMessageType2["START"] = "stream_slot_start";
    return EWSStreamSlotMessageType2;
})(EWSStreamSlotMessageType || {});
const RESUBSCRIBE_TIMEOUT_AFTER_ALREADY_SUBSCRIBED = 1e3;
const _WSClient = class _WSClient {
    static get isConnected() {
        var _a3;
        return ((_a3 = this.centrifuge) == null ? void 0 : _a3.state) === build$2.State.Connected;
    }
    static setToken(token2) {
        this.token = token2;
        return this;
    }
    static updateOptions(options) {
        this.options = {
            ...this.options,
            ...options
        };
        return this;
    }
    static connect() {
        const { hosts: { websocket: websocket2 }, websocket: { isDebug } } = getConfig();
        if (this.isConnected) {
            Log$5.message(`Couldn't connect to websocket. Instance already connected.`);
            return this;
        }
        this.centrifuge = new build$2.Centrifuge(websocket2, {
            debug: isDebug,
            token: this.token,
            getToken: async ()=>{
                const response = await Api$1.webSocket.refreshToken();
                return response.data.token;
            }
        });
        this.centrifuge.on("connected", ()=>this.onConnect());
        this.centrifuge.connect();
        return this;
    }
    static disconnect() {
        var _a3;
        (_a3 = this.centrifuge) == null || _a3.disconnect();
        return this;
    }
    static async presence(channelType) {
        try {
            return await this.centrifuge.presence(this.channels[channelType]);
        } catch (err) {
            throw new Error(err);
        }
    }
    static async presenceStats(channelType) {
        const { numClients, numUsers } = await this.centrifuge.presenceStats(this.channels[channelType]);
        return {
            numClients: numClients,
            numUsers: numUsers
        };
    }
    static async publishEvent(wsChannel, type, data) {
        try {
            await this.centrifuge.publish(wsChannel, {
                type: type,
                data: data
            });
        } catch (err) {
            Log$5.error(`Couldn't publish message into websocket channel "${wsChannel}", reason: `, err);
        }
    }
    static subscribe(payload, options) {
        payload.forEach((subscription2)=>{
            if (this.isConnected) this._subscribe(subscription2.type, subscription2.channel, options == null ? void 0 : options.isPrivate, subscription2.token);
            else {
                const newSubscription = {
                    ...subscription2,
                    useBatching: (options == null ? void 0 : options.useBatching) ?? false,
                    isPrivate: (options == null ? void 0 : options.isPrivate) ?? false
                };
                if (this.pendingSubscriptions[subscription2.type]) this.pendingSubscriptions[subscription2.type].push(newSubscription);
                else this.pendingSubscriptions[subscription2.type] = [
                    newSubscription
                ];
            }
        });
    }
    static unsubscribe(channelType) {
        if (!this.channels[channelType]) return this;
        if (this.subscriptions[channelType]) {
            Object.entries(this.subscriptions[channelType]).forEach(([channel2, subscription2])=>{
                if (this.channelCountSubscriptions(channel2) === 1) {
                    subscription2.unsubscribe();
                    subscription2.removeAllListeners();
                }
            });
            delete this.subscriptions[channelType];
        }
        this.channels[channelType] = null;
        return this;
    }
    static register(handlerObject) {
        const { channel: channel2, message: message2, handler: handler2 } = handlerObject;
        const targetHandlers = this.handlers[channel2];
        targetHandlers[message2].push(handler2);
    }
    static unregister(handlerObject) {
        const { channel: channel2, message: message2, handler: handler2 } = handlerObject;
        const targetHandlers = this.handlers[channel2];
        if (handler2) targetHandlers[message2] = targetHandlers[message2].filter((item2)=>item2 !== handler2);
        else targetHandlers[message2] = [];
    }
    static on(eventName, handler2) {
        this.internalHandlers[eventName].push(handler2);
    }
    static off(eventName, handler2) {
        this.internalHandlers[eventName] = this.internalHandlers[eventName].filter((item2)=>item2 !== handler2);
    }
    static trigger(eventName) {
        this.internalHandlers[eventName].forEach((item2)=>item2());
    }
    static _subscribe(channelType, channel2, isPrivate, token2) {
        const getOptions = ()=>{
            if (isPrivate) return {
                token: token2,
                getToken: async ()=>{
                    var _a3, _b2;
                    const result2 = await Api$1.webSocket.fetchPrivateToken(channel2);
                    return (_b2 = (_a3 = result2.data.data.tokens) == null ? void 0 : _a3.find((item2)=>item2.channel === channel2)) == null ? void 0 : _b2.token;
                }
            };
            return {};
        };
        const subscription2 = this.centrifuge.getSubscription(channel2) || this.centrifuge.newSubscription(channel2, getOptions());
        subscription2.on("publication", (message2)=>{
            this.runHandlers(channelType, message2);
        });
        subscription2.subscribe();
        subscription2.on("error", (error2)=>{
            Log$5.error(`Error WS subscription: `, error2);
            if ((error2 == null ? void 0 : error2.message) === "already subscribed") {
                this.unsubscribe(channelType);
                setTimeout(()=>{
                    this._subscribe(channelType, channel2);
                }, RESUBSCRIBE_TIMEOUT_AFTER_ALREADY_SUBSCRIBED);
            }
        });
        this.subscriptions[channelType] = {
            ...this.subscriptions[channelType] || {},
            [channel2]: subscription2
        };
        this.channels[channelType] = channel2;
        return this;
    }
    static onConnect() {
        setTimeout(()=>this.trigger(EWSEvent.CONNECT));
        if (!Object.keys(this.pendingSubscriptions).length) return;
        const batchedSubscriptions = [];
        Object.values(this.pendingSubscriptions).forEach((subscriptionsList)=>{
            subscriptionsList.forEach((subscription2)=>{
                if (subscription2.useBatching) batchedSubscriptions.push(subscription2);
                else this._subscribe(subscription2.type, subscription2.channel, subscription2.isPrivate, subscription2.token);
            });
        });
        batchedSubscriptions.forEach((subscription2)=>{
            this._subscribe(subscription2.type, subscription2.channel, subscription2.isPrivate, subscription2.token);
        });
        this.pendingSubscriptions = {};
    }
    static runHandlers(channelType, message2) {
        var _a3, _b2;
        const targetHandlers = (_a3 = this.handlers) == null ? void 0 : _a3[channelType];
        (_b2 = targetHandlers == null ? void 0 : targetHandlers[message2.data.type]) == null || _b2.forEach((handler2)=>{
            try {
                handler2(message2);
            } catch (err) {
                if (err instanceof Error) Log$5.error(`Failed processing WS handler of channel ${channelType}
(message=${JSON.stringify(message2)})
(error=${err && err.toString() ? err.toString() : String(err)})`);
            }
        });
    }
    static channelCountSubscriptions(channel2) {
        return Object.values(this.subscriptions).reduce((acc, channelTypeObject)=>channelTypeObject.hasOwnProperty(channel2) ? acc + 1 : acc, 0);
    }
};
_WSClient.token = null;
_WSClient.handlers = {
    [EWSChannel.USER]: {
        [EWSUserMessageType.DIALOG_MESSAGE_COUNTERS]: [],
        [EWSUserMessageType.SUBSCRIBERS_CHANGE_COUNT]: [],
        [EWSUserMessageType.NOTIFICATIONS_SETTINGS_UPDATE]: [],
        [EWSUserMessageType.PUBLISH_POST]: [],
        [EWSUserMessageType.CHAT_BAN]: [],
        [EWSUserMessageType.CHAT_UNBAN]: [],
        [EWSUserMessageType.USER_BAN]: [],
        [EWSUserMessageType.USER_UNBAN]: [],
        [EWSUserMessageType.BLACK_LISTED]: [],
        [EWSUserMessageType.UNBLACK_LISTED]: [],
        [EWSUserMessageType.ACTIONS_JOURNAL_NEW_EVENT]: [],
        [EWSUserMessageType.BLOG_SUBSCRIBER_STAT]: [],
        [EWSUserMessageType.VIDEO_UPLOADED]: [],
        [EWSUserMessageType.VIDEO_UPLOADED_FAILED]: [],
        [EWSUserMessageType.USER_CHANGE_CURRENCY]: [],
        [EWSUserMessageType.BOOSTY_USER_LINK]: [],
        [EWSUserMessageType.UPLOAD_ORIGINAL_SMILE_IMAGE]: [],
        [EWSUserMessageType.UPLOAD_ORIGINAL_BADGE_IMAGE]: [],
        [EWSUserMessageType.UPLOAD_ORIGINAL_REWARD_IMAGE]: [],
        [EWSUserMessageType.UPLOAD_ORIGINAL_POINTS_IMAGE]: [],
        [EWSUserMessageType.UPLOAD_ORIGINAL_ROLE_IMAGE]: [],
        [EWSUserMessageType.BANK_CARDS]: [],
        [EWSUserMessageType.BLACKLIST_ADD]: [],
        [EWSUserMessageType.BLACKLIST_DELETE]: []
    },
    [EWSChannel.CHAT]: {
        [EWSChatMessageType.MESSAGE]: [],
        [EWSChatMessageType.DELETE_MESSAGE]: [],
        [EWSChatMessageType.CLEAN_CHAT_MESSAGES]: [],
        [EWSChatMessageType.STREAM_START]: [],
        [EWSChatMessageType.STREAM_END]: [],
        [EWSChatMessageType.STREAM_LIKE_COUNTER]: [],
        [EWSChatMessageType.STREAM_ONLINE_STATUS]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_PIN]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_EDIT]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_UNPIN]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_REACTION]: [],
        [EWSChatMessageType.CHAT_CLEAN]: [],
        [EWSChatMessageType.CHAT_BAN]: []
    },
    [EWSChannel.PRIVATE]: {
        [EWSChatMessageType.MESSAGE]: [],
        [EWSChatMessageType.DELETE_MESSAGE]: [],
        [EWSChatMessageType.CLEAN_CHAT_MESSAGES]: [],
        [EWSChatMessageType.STREAM_START]: [],
        [EWSChatMessageType.STREAM_END]: [],
        [EWSChatMessageType.STREAM_LIKE_COUNTER]: [],
        [EWSChatMessageType.STREAM_ONLINE_STATUS]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_PIN]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_EDIT]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_UNPIN]: [],
        [EWSChatMessageType.CHAT_PINNED_MESSAGE_REACTION]: [],
        [EWSChatMessageType.CHAT_CLEAN]: [],
        [EWSChatMessageType.CHAT_BAN]: []
    },
    [EWSChannel.PRIVATE_STREAM]: {
        [EWSPrivateStreamMessageType.CP_BALANCE_CHANGE]: [],
        [EWSPrivateStreamMessageType.CP_BONUS_PENDING]: [],
        [EWSPrivateStreamMessageType.DROP_PROGRESS]: [],
        [EWSPrivateStreamMessageType.START_PREDICTION]: [],
        [EWSPrivateStreamMessageType.POLL_START]: [],
        [EWSPrivateStreamMessageType.SUBSCRIPTION_GIFT_BUY]: [],
        [EWSPrivateStreamMessageType.STREAM_POLL]: [],
        [EWSClipMessageType.VIDEO_CLIP_ERROR]: [],
        [EWSClipMessageType.VIDEO_CLIP_READY]: [],
        [EWSClipMessageType.VIDEO_SNIPPET_ERROR]: [],
        [EWSClipMessageType.VIDEO_SNIPPET_READY]: [],
        [EWSStreamMessageType.STREAM_PREDICTION]: []
    },
    [EWSChannel.STREAM]: {
        [EWSStreamMessageType.CHAT_SETTINGS_UPDATE]: [],
        [EWSStreamMessageType.STREAM_START]: [],
        [EWSStreamMessageType.STREAM_END]: [],
        [EWSStreamMessageType.STREAM_LIKE_COUNTER]: [],
        [EWSStreamMessageType.STREAM_ONLINE_STATUS]: [],
        [EWSStreamMessageType.STREAM_INFO_UPDATE]: [],
        [EWSStreamMessageType.CUSTOM_BLOCK_CREATE]: [],
        [EWSStreamMessageType.CUSTOM_BLOCK_UPDATE]: [],
        [EWSStreamMessageType.CUSTOM_BLOCK_DELETE]: [],
        [EWSStreamMessageType.CUSTOM_BLOCK_REORDER]: [],
        [EWSStreamMessageType.STREAM_RAID_STATUS]: [],
        [EWSStreamMessageType.STREAM_PREDICTION]: [],
        [EWSStreamMessageType.STREAM_POLL]: [],
        [EWSStreamMessageType.CHANNEL_STREAM]: [],
        [EWSStreamMessageType.SLOT_ONLINE_STATUS]: [],
        [EWSStreamMessageType.STREAM_SLOT_END]: []
    },
    [EWSChannel.STREAM_MANAGEMENT]: {
        [EWSStreamManagementMessageType.ACTIONS_JOURNAL_NEW_EVENT]: [],
        [EWSStreamManagementMessageType.REWARD_DEMAND]: [],
        [EWSStreamManagementMessageType.CHANNEL_MODERATION_LOG_EVENT]: [],
        [EWSStreamManagementMessageType.STREAM_POLL]: []
    },
    [EWSChannel.DIALOG]: {
        [EWSDialoguesMessageType.DIALOG_MESSAGE]: [],
        [EWSDialoguesMessageType.DIALOG_MESSAGE_READ]: [],
        [EWSDialoguesMessageType.DIALOG_DELETE_MESSAGE]: [],
        [EWSDialoguesMessageType.DIALOG_MESSAGE_PAID]: [],
        [EWSDialoguesMessageType.DIALOG_BROADCAST_MESSAGES_DONE]: []
    },
    [EWSChannel.CUSTOM]: {
        [EWSCustomMessageType.DIALOG_CHATMATE_ACTION]: []
    },
    [EWSChannel.SUBSCRIBED_STREAMS]: {
        [EWSSubscribedStreamsMessageType.STREAM_SLOT_ONLINE_STATUS]: [],
        [EWSSubscribedStreamsMessageType.STREAM_SLOT_END]: []
    },
    [EWSChannel.RECOMMENDED_STREAMS]: {
        [EWSRecommendedStreamsMessageType.STREAM_SLOT_ONLINE_STATUS]: [],
        [EWSRecommendedStreamsMessageType.STREAM_SLOT_END]: []
    },
    [EWSChannel.STREAM_SHOWCASE]: {
        [EWSStreamShowcaseMessageType.STREAM_ONLINE_STATUS]: []
    },
    [EWSChannel.STREAM_SLOT]: {
        [EWSStreamSlotMessageType.START]: [],
        [EWSStreamSlotMessageType.END]: [],
        [EWSStreamSlotMessageType.LIKE_COUNTER]: [],
        [EWSStreamSlotMessageType.INFO_UPDATE]: [],
        [EWSStreamSlotMessageType.ONLINE_STATUS]: []
    }
};
_WSClient.internalHandlers = {
    [EWSEvent.CONNECT]: []
};
_WSClient.channels = {};
_WSClient.subscriptions = {};
_WSClient.pendingSubscriptions = {};
let WSClient = _WSClient;
function lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name2 = "";
            var j2 = i + 1;
            while(j2 < str.length){
                var code = str.charCodeAt(j2);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name2 += str[j2++];
                    continue;
                }
                break;
            }
            if (!name2) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name2
            });
            i = j2;
            continue;
        }
        if (char === "(") {
            var count2 = 1;
            var pattern = "";
            var j2 = i + 1;
            if (str[j2] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j2));
            while(j2 < str.length){
                if (str[j2] === "\\") {
                    pattern += str[j2++] + str[j2++];
                    continue;
                }
                if (str[j2] === ")") {
                    count2--;
                    if (count2 === 0) {
                        j2++;
                        break;
                    }
                } else if (str[j2] === "(") {
                    count2++;
                    if (str[j2 + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j2));
                }
                pattern += str[j2++];
            }
            if (count2) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j2;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function parse(str, options) {
    if (options === void 0) options = {};
    var tokens = lexer(str);
    var _a3 = options.prefixes, prefixes = _a3 === void 0 ? "./" : _a3;
    var defaultPattern2 = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result2 = [];
    var key = 0;
    var i = 0;
    var path2 = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value3 = tryConsume(type);
        if (value3 !== void 0) return value3;
        var _a4 = tokens[i], nextType = _a4.type, index2 = _a4.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index2, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result3 = "";
        var value3;
        while(value3 = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result3 += value3;
        return result3;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name2 = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name2 || pattern) {
            var prefix2 = char || "";
            if (prefixes.indexOf(prefix2) === -1) {
                path2 += prefix2;
                prefix2 = "";
            }
            if (path2) {
                result2.push(path2);
                path2 = "";
            }
            result2.push({
                name: name2 || key++,
                prefix: prefix2,
                suffix: "",
                pattern: pattern || defaultPattern2,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value2 = char || tryConsume("ESCAPED_CHAR");
        if (value2) {
            path2 += value2;
            continue;
        }
        if (path2) {
            result2.push(path2);
            path2 = "";
        }
        var open2 = tryConsume("OPEN");
        if (open2) {
            var prefix2 = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result2.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern2 : pattern_1,
                prefix: prefix2,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result2;
}
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
function regexpToRegexp(path2, keys3) {
    return path2;
}
function arrayToRegexp(paths, keys3, options) {
    var parts = paths.map(function(path2) {
        return pathToRegexp(path2, keys3, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
function stringToRegexp(path2, keys3, options) {
    return tokensToRegexp(parse(path2, options), keys3, options);
}
function tokensToRegexp(tokens, keys3, options) {
    if (options === void 0) options = {};
    var _a3 = options.strict, strict = _a3 === void 0 ? false : _a3, _b2 = options.start, start = _b2 === void 0 ? true : _b2, _c2 = options.end, end = _c2 === void 0 ? true : _c2, _d = options.encode, encode2 = _d === void 0 ? function(x2) {
        return x2;
    } : _d, _e = options.delimiter, delimiter2 = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter2), "]");
    var route = start ? "^" : "";
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token2 = tokens_1[_i];
        if (typeof token2 === "string") route += escapeString(encode2(token2));
        else {
            var prefix2 = escapeString(encode2(token2.prefix));
            var suffix = escapeString(encode2(token2.suffix));
            if (token2.pattern) {
                if (prefix2 || suffix) {
                    if (token2.modifier === "+" || token2.modifier === "*") {
                        var mod = token2.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix2, "((?:").concat(token2.pattern, ")(?:").concat(suffix).concat(prefix2, "(?:").concat(token2.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix2, "(").concat(token2.pattern, ")").concat(suffix, ")").concat(token2.modifier);
                } else if (token2.modifier === "+" || token2.modifier === "*") route += "((?:".concat(token2.pattern, ")").concat(token2.modifier, ")");
                else route += "(".concat(token2.pattern, ")").concat(token2.modifier);
            } else route += "(?:".concat(prefix2).concat(suffix, ")").concat(token2.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === void 0;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, flags(options));
}
function pathToRegexp(path2, keys3, options) {
    if (path2 instanceof RegExp) return regexpToRegexp(path2);
    if (Array.isArray(path2)) return arrayToRegexp(path2, keys3, options);
    return stringToRegexp(path2, keys3, options);
}
const getPathParams = (routes, store2)=>{
    const state = store2.getState();
    const globalBlogUrl = globalBlogUrlSelector(state);
    if (typeof routes === "string") return getPathParams([
        routes
    ], store2);
    let result2 = {};
    try {
        for (const route of routes){
            const match2 = pathToRegexp(route).exec(window.location.pathname);
            if (match2) {
                const params = route.split("/").filter((param)=>param.startsWith(":")).map((param)=>param.slice(1));
                result2 = params.reduce((obj, key, index2)=>({
                        ...obj,
                        [key]: match2[index2 + 1]
                    }), {});
            }
        }
    } catch (ignore) {}
    if (globalBlogUrl) return {
        ...result2,
        blogUrl: globalBlogUrl
    };
    return result2;
};
const onChatMessage = (store2)=>{
    var _a3, _b2;
    const messagesBatchingTime = ((_b2 = (_a3 = getConfig()) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.messagesBatchingTime) || 0;
    const messages2 = [];
    const handleChatMessage = ({ data })=>{
        const message2 = data == null ? void 0 : data.data;
        const state = store2.getState();
        const currentUser2 = currentUserSelector(state);
        const isChatMessagesBatchingEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_MESSAGES_BATCHING);
        store2.dispatch(addMessageToChatHistory({
            message: message2
        }));
        if (isMessageHasCurrentUserMention(message2, currentUser2 == null ? void 0 : currentUser2.id)) store2.dispatch(addNewMentionChatMessage(message2));
        if (isChatMessagesBatchingEnabled && messagesBatchingTime > 0 && message2.author.id !== (currentUser2 == null ? void 0 : currentUser2.id)) messages2.push(message2);
        else store2.dispatch(addNewStreamChatMessages({
            messages: messages2.splice(0).concat(message2),
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id
        }));
    };
    const batchMessages = ()=>{
        const currentUser2 = currentUserSelector(store2.getState());
        if (messages2.length) store2.dispatch(addNewStreamChatMessages({
            messages: messages2.splice(0),
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id
        }));
    };
    const intervalId = setInterval(batchMessages, messagesBatchingTime);
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.MESSAGE,
        handler: handleChatMessage
    });
    WSClient.register({
        channel: EWSChannel.PRIVATE,
        message: EWSChatMessageType.MESSAGE,
        handler: handleChatMessage
    });
    return ()=>{
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.MESSAGE,
            handler: handleChatMessage
        });
        WSClient.unregister({
            channel: EWSChannel.PRIVATE,
            message: EWSChatMessageType.MESSAGE,
            handler: handleChatMessage
        });
        clearInterval(intervalId);
    };
};
const onChatMessageRemoveFromWS = (store2)=>{
    const handleChatMessageRemoveFromWS = ({ data: { id } })=>{
        store2.dispatch(removeStreamChatMessageFromWS({
            messageId: id
        }));
    };
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.DELETE_MESSAGE,
        handler: handleChatMessageRemoveFromWS
    });
    WSClient.register({
        channel: EWSChannel.PRIVATE,
        message: EWSChatMessageType.DELETE_MESSAGE,
        handler: handleChatMessageRemoveFromWS
    });
    return ()=>{
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.DELETE_MESSAGE,
            handler: handleChatMessageRemoveFromWS
        });
        WSClient.unregister({
            channel: EWSChannel.PRIVATE,
            message: EWSChatMessageType.DELETE_MESSAGE,
            handler: handleChatMessageRemoveFromWS
        });
    };
};
const onStreamOnlineStatusChange = (store2)=>{
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.STREAM_ONLINE_STATUS,
        handler: ({ data: { viewers: viewers2, isOnline } })=>{
            store2.dispatch(changeStreamOnlineStatus({
                isOnline: isOnline
            }));
            if (viewers2) store2.dispatch(setStreamViewers({
                viewers: viewers2
            }));
        }
    });
    WSClient.register({
        channel: EWSChannel.STREAM_SLOT,
        message: EWSStreamSlotMessageType.ONLINE_STATUS,
        handler: (params)=>{
            const { data: { data: { stream: { isOnline, streamId, viewers: viewers2 } } } } = params;
            const state = store2.getState();
            const stream2 = streamSelector(state);
            if ((stream2 == null ? void 0 : stream2.id) === streamId) {
                store2.dispatch(setStreamIsOnline({
                    isOnline: isOnline
                }));
                if (viewers2) store2.dispatch(setStreamViewers({
                    viewers: viewers2
                }));
            }
        }
    });
};
const getRefetchStream = (store2)=>()=>{
        const state = store2.getState();
        const blogUrl = blogUrlSelector(state) || globalBlogUrlSelector(state);
        const slotUrl = currentStreamSlotUrlSelector(state);
        const { blogUrl: embedPageBlogUrl } = getPathParams(URLS.EMBED_VIDEO_LIVE, store2);
        store2.dispatch(fetchStream.action({
            blogUrl: blogUrl || embedPageBlogUrl,
            slotUrl: slotUrl
        }));
    };
let refetchStreamTimer = null;
const onStreamStart = (store2)=>{
    const handler2 = getRefetchStream(store2);
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.STREAM_START,
        handler: handler2
    });
    WSClient.register({
        channel: EWSChannel.STREAM_SLOT,
        message: EWSStreamSlotMessageType.START,
        handler: ()=>{
            const state = store2.getState();
            const stream2 = streamSelector(state);
            const streamRefetchMaxDelay = getConfig().stream.refetchMaxDelay;
            if (streamRefetchMaxDelay) {
                window.clearTimeout(refetchStreamTimer);
                refetchStreamTimer = window.setTimeout(handler2, getRequestWithViewersDelay(stream2.count.viewers, streamRefetchMaxDelay));
            } else handler2();
        }
    });
};
const getStreamEndHandler = (store2)=>({ data })=>{
        var _a3;
        const state = store2.getState();
        const stream2 = streamSelector(state);
        if (Number((_a3 = stream2 == null ? void 0 : stream2.data[0]) == null ? void 0 : _a3.vid) === data.data.stream.videoId) store2.dispatch(markStreamEnded());
    };
const onStreamEnd = (store2)=>{
    const handler2 = getStreamEndHandler(store2);
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.STREAM_END,
        handler: handler2
    });
    WSClient.register({
        channel: EWSChannel.STREAM_SLOT,
        message: EWSStreamSlotMessageType.END,
        handler: handler2
    });
};
const getStreamLikeCounterHandler = (store2)=>(message2)=>{
        var _a3, _b2;
        const { data: { data: { stream: { count: { likes }, videoId } } } } = message2;
        const state = store2.getState();
        const stream2 = streamSelector(state);
        if (Number((_b2 = (_a3 = stream2 == null ? void 0 : stream2.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b2.vid) === videoId) store2.dispatch(streamLikesCounterUpdate({
            streamLikesCounter: likes
        }));
    };
const onStreamLikesChange = (store2)=>{
    const handler2 = getStreamLikeCounterHandler(store2);
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.STREAM_LIKE_COUNTER,
        handler: handler2
    });
    WSClient.register({
        channel: EWSChannel.STREAM_SLOT,
        message: EWSStreamSlotMessageType.LIKE_COUNTER,
        handler: handler2
    });
};
const onStreamInfoUpdate = (store2)=>{
    WSClient.register({
        channel: EWSChannel.STREAM_SLOT,
        message: EWSStreamSlotMessageType.INFO_UPDATE,
        handler: ({ channel: channel2, data: { data: { stream: stream2 } } })=>{
            const state = store2.getState();
            const activeStream = streamSelector(state);
            if ((activeStream == null ? void 0 : activeStream.wsStreamSlot) === channel2) store2.dispatch(setStreamData(stream2));
        }
    });
};
const onChatPinnedMessage = (store2)=>{
    const handlePinChatMessage = (data)=>{
        store2.dispatch(pinChatMessageWS(data.data.data));
    };
    const handleUnpinChatMessage = ()=>{
        store2.dispatch(unpinChatMessageWS());
    };
    const handleEditPinnedChatMessage = (data)=>{
        store2.dispatch(editPinnedChatMessageWS(data.data.data));
    };
    const handlePinnedChatMessageReaction = ({ data })=>{
        store2.dispatch(addChatMessageReactionWS(data.reactions));
    };
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_PINNED_MESSAGE_PIN,
        handler: handlePinChatMessage
    });
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_PINNED_MESSAGE_EDIT,
        handler: handleEditPinnedChatMessage
    });
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_PINNED_MESSAGE_UNPIN,
        handler: handleUnpinChatMessage
    });
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_PINNED_MESSAGE_REACTION,
        handler: handlePinnedChatMessageReaction
    });
    return ()=>{
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.CHAT_PINNED_MESSAGE_PIN,
            handler: handlePinChatMessage
        });
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.CHAT_PINNED_MESSAGE_EDIT,
            handler: handleEditPinnedChatMessage
        });
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.CHAT_PINNED_MESSAGE_UNPIN,
            handler: handleUnpinChatMessage
        });
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.CHAT_PINNED_MESSAGE_REACTION,
            handler: handlePinnedChatMessageReaction
        });
    };
};
const onChatClean = (store2)=>{
    const handleCleanChat = ({ data: { data: { messages: messages2 } } })=>{
        store2.dispatch(removeStreamChatMessagesLocally(messages2));
        store2.dispatch(removeStreamChatMessagesFromWS(messages2));
        store2.dispatch(removeStreamChatMessagesFromMentions(messages2));
    };
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_CLEAN,
        handler: handleCleanChat
    });
    return ()=>{
        WSClient.unregister({
            channel: EWSChannel.CHAT,
            message: EWSChatMessageType.CHAT_CLEAN,
            handler: handleCleanChat
        });
    };
};
const registerWsActions = (store2)=>{
    onStreamStart(store2);
    onStreamEnd(store2);
    onStreamOnlineStatusChange(store2);
    onStreamInfoUpdate(store2);
    onStreamLikesChange(store2);
};
const conditionalFeatures = {
    CHAT_MENTIONS: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    VK_PLAYER: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    PLAYBACK_POSITION_SAVING: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    HIDE_CHAT_USER_AVATAR: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    RECORDS_ACCESS: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    DROP_CAMPAIGNS: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    CHAT_SETTINGS: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    CHAT_USER_STAT: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    SDK_CHAT_TABS: {
        threshold: 0,
        users: [],
        apps: [],
        disabledApps: []
    },
    SDK_CHAT_FOOTER: {
        threshold: 0,
        users: [],
        apps: [],
        disabledApps: []
    },
    CHAT_PINNED_MESSAGES: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    },
    CHAT_USERS_LIST: {
        threshold: 1e3,
        users: [],
        apps: [],
        disabledApps: []
    }
};
const hosts = {
    api: "https://apisdk.live.vkvideo.ru/",
    websocket: "wss://pubsub.live.vkvideo.ru/connection/websocket?cf_protocol_version=v2"
};
const locale = "ru_RU";
const websocket = {
    isDebug: "1",
    isEnabled: "1"
};
const config$1 = {
    conditionalFeatures: conditionalFeatures,
    hosts: hosts,
    locale: locale,
    websocket: websocket
};
var dist = {
    exports: {}
};
(function(module2) {
    (()=>{
        var __webpack_require__ = {};
        (()=>{
            __webpack_require__.d = (exports2, definition)=>{
                for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) Object.defineProperty(exports2, key, {
                    enumerable: true,
                    get: definition[key]
                });
            };
        })();
        (()=>{
            __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        })();
        (()=>{
            __webpack_require__.r = (exports2)=>{
                if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(exports2, Symbol.toStringTag, {
                    value: "Module"
                });
                Object.defineProperty(exports2, "__esModule", {
                    value: true
                });
            };
        })();
        var __webpack_exports__ = {};
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, {
            "OverlayPopupsContext": ()=>/* reexport */ OverlayPopupsContext,
            "OverlayPopupsProvider": ()=>/* reexport */ OverlayPopupsProvider,
            "useOverlayPopups": ()=>/* reexport */ useOverlayPopups
        });
        const external_react_namespaceObject = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
        var getRandomValues2;
        var rnds82 = new Uint8Array(16);
        function rng2() {
            if (!getRandomValues2) {
                getRandomValues2 = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
                if (!getRandomValues2) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            }
            return getRandomValues2(rnds82);
        }
        const regex = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
        function validate(uuid) {
            return typeof uuid === "string" && regex.test(uuid);
        }
        const esm_browser_validate = validate;
        var byteToHex2 = [];
        for(var i = 0; i < 256; ++i)byteToHex2.push((i + 256).toString(16).substr(1));
        function stringify(arr) {
            var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            var uuid = (byteToHex2[arr[offset2 + 0]] + byteToHex2[arr[offset2 + 1]] + byteToHex2[arr[offset2 + 2]] + byteToHex2[arr[offset2 + 3]] + "-" + byteToHex2[arr[offset2 + 4]] + byteToHex2[arr[offset2 + 5]] + "-" + byteToHex2[arr[offset2 + 6]] + byteToHex2[arr[offset2 + 7]] + "-" + byteToHex2[arr[offset2 + 8]] + byteToHex2[arr[offset2 + 9]] + "-" + byteToHex2[arr[offset2 + 10]] + byteToHex2[arr[offset2 + 11]] + byteToHex2[arr[offset2 + 12]] + byteToHex2[arr[offset2 + 13]] + byteToHex2[arr[offset2 + 14]] + byteToHex2[arr[offset2 + 15]]).toLowerCase();
            if (!esm_browser_validate(uuid)) throw TypeError("Stringified UUID is invalid");
            return uuid;
        }
        const esm_browser_stringify = stringify;
        function v42(options, buf, offset2) {
            options = options || {};
            var rnds = options.random || (options.rng || rng2)();
            rnds[6] = rnds[6] & 15 | 64;
            rnds[8] = rnds[8] & 63 | 128;
            if (buf) {
                offset2 = offset2 || 0;
                for(var i2 = 0; i2 < 16; ++i2)buf[offset2 + i2] = rnds[i2];
                return buf;
            }
            return esm_browser_stringify(rnds);
        }
        const esm_browser_v4 = v42;
        var OverlayPopupsContext = external_react_namespaceObject.createContext({});
        var useOverlayPopups = function() {
            return external_react_namespaceObject.useContext(OverlayPopupsContext);
        };
        var __assign2 = function() {
            __assign2 = Object.assign || function(t2) {
                for(var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++){
                    s2 = arguments[i2];
                    for(var p2 in s2)if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
                }
                return t2;
            };
            return __assign2.apply(this, arguments);
        };
        var __read = function(o2, n2) {
            var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
            if (!m2) return o2;
            var i2 = m2.call(o2), r2, ar = [], e2;
            try {
                while((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)ar.push(r2.value);
            } catch (error2) {
                e2 = {
                    error: error2
                };
            } finally{
                try {
                    if (r2 && !r2.done && (m2 = i2["return"])) m2.call(i2);
                } finally{
                    if (e2) throw e2.error;
                }
            }
            return ar;
        };
        var OverlayPopupsProvider = function(props) {
            var popups = props.popups;
            var _a3 = __read((0, external_react_namespaceObject.useState)([]), 2), activePopups = _a3[0], setActivePopupsState = _a3[1];
            var activePopupsRef = (0, external_react_namespaceObject.useRef)(activePopups);
            var setActivePopups = function(value2) {
                setActivePopupsState(value2);
                activePopupsRef.current = value2;
            };
            var showPopup = function(params) {
                var animation = popups[params.type].animation;
                var id = esm_browser_v4();
                var popup = {
                    id: id,
                    params: params,
                    isOpened: !Boolean(animation),
                    isAnimated: Boolean(animation),
                    isNew: true
                };
                setActivePopups(activePopupsRef.current.concat(popup));
                return popup;
            };
            var closePopup = function(id) {
                var popup = activePopupsRef.current.find(function(item2) {
                    return item2.id === id;
                });
                if (popup) {
                    var popupConfig = popups[popup.params.type];
                    var animation = popupConfig === null || popupConfig === void 0 ? void 0 : popupConfig.animation;
                    if (animation) {
                        setActivePopups(activePopupsRef.current.map(function(item2) {
                            return item2.id !== id ? item2 : __assign2(__assign2({}, item2), {
                                isOpened: false
                            });
                        }));
                        setTimeout(function() {
                            return removeFromActive(id);
                        }, animation.timeout);
                    } else removeFromActive(id);
                    if (popup.params.onClose) popup.params.onClose();
                }
            };
            var removeFromActive = function(id) {
                setTimeout(function() {
                    setActivePopups(activePopupsRef.current.filter(function(item2) {
                        return item2.id !== id;
                    }));
                });
            };
            var onPopupClose = function(id) {
                var _a4;
                var popup = activePopupsRef.current.find(function(item2) {
                    return item2.id === id;
                });
                if ((_a4 = popup === null || popup === void 0 ? void 0 : popup.params) === null || _a4 === void 0 ? void 0 : _a4.onClose) popup.params.onClose();
                removeFromActive(id);
            };
            (0, external_react_namespaceObject.useEffect)(function() {
                var hasNewAnimated = activePopupsRef.current.some(function(item2) {
                    return item2.isNew && item2.isAnimated;
                });
                if (hasNewAnimated) setActivePopups(activePopupsRef.current.map(function(item2) {
                    return item2.isNew && item2.isAnimated ? __assign2(__assign2({}, item2), {
                        isOpened: true,
                        isNew: false
                    }) : item2;
                }));
            }, [
                activePopups
            ]);
            return external_react_namespaceObject.createElement(OverlayPopupsContext.Provider, {
                value: {
                    showPopup: showPopup,
                    closePopup: closePopup
                }
            }, external_react_namespaceObject.createElement(external_react_namespaceObject.Fragment, null, props.children, activePopups.map(function(item2) {
                var id = item2.id, isOpened = item2.isOpened, _a4 = item2.params, type = _a4.type, data = _a4.data;
                var _b2 = popups[type], Component2 = _b2.component, componentProps = _b2.props;
                return Component2 ? external_react_namespaceObject.createElement(Component2, __assign2({
                    key: id
                }, data, componentProps, {
                    popupId: id,
                    isOpened: isOpened,
                    closePopup: function() {
                        return closePopup(id);
                    },
                    onClose: function() {
                        return onPopupClose(id);
                    }
                })) : null;
            })));
        };
        module2.exports = __webpack_exports__;
    })();
})(dist);
var distExports = dist.exports;
const svg_name_text = {};
const svg_name_social_fb = {
    id: "svg-name-social-fb",
    viewBox: ""
};
const svg_name_social_ok = {
    id: "svg-name-social-ok",
    viewBox: ""
};
const svg_name_social_twitch = {
    id: "svg-name-social-twitch",
    viewBox: ""
};
const svg_name_social_vk = {
    id: "svg-name-social-vk",
    viewBox: ""
};
const svg_name_social_youtube = {
    id: "svg-name-social-youtube",
    viewBox: ""
};
const svg_name_social_mail = {
    id: "svg-name-social-mail",
    viewBox: ""
};
const svg_name_social_google = {
    id: "svg-name-social-google",
    viewBox: ""
};
const svg_name_like_reaction = {
    id: "svg-name-like-reaction",
    viewBox: ""
};
const svg_name_dislike_reaction = {
    id: "svg-name-dislike-reaction",
    viewBox: ""
};
const svg_name_fire_reaction = {
    id: "svg-name-fire-reaction",
    viewBox: ""
};
const svg_name_heart_reaction = {
    id: "svg-name-heart-reaction",
    viewBox: ""
};
const svg_name_laught_reaction = {
    id: "svg-name-laught-reaction",
    viewBox: ""
};
const svg_name_poo_reaction = {
    id: "svg-name-poo-reaction",
    viewBox: ""
};
const svg_name_clown_reaction = {
    id: "svg-name-clown-reaction",
    viewBox: ""
};
const svg_name_add_square_outline_24 = {
    id: "svg-name-add_square_outline_24",
    viewBox: ""
};
const svg_name_apps = {
    id: "svg-name-apps",
    viewBox: ""
};
const svg_name_arrow_long = {
    id: "svg-name-arrow-long",
    viewBox: ""
};
const svg_name_arrow_short = {
    id: "svg-name-arrow-short",
    viewBox: ""
};
const svg_name_arrow_short_right = {
    id: "svg-name-arrow-short-right",
    viewBox: ""
};
const svg_name_arrow_short_bold = {
    id: "svg-name-arrow-short-bold",
    viewBox: ""
};
const svg_name_attach = {
    id: "svg-name-attach",
    viewBox: ""
};
const svg_name_arrow_uturn_left_outline_20 = {
    id: "svg-name-arrow_uturn_left_outline_20",
    viewBox: ""
};
const svg_name_ban = {
    id: "svg-name-ban",
    viewBox: "0 0 20 20"
};
const svg_name_bell = {
    id: "svg-name-bell",
    viewBox: ""
};
const svg_name_bell_with_plus = {
    id: "svg-name-bell-with-plus",
    viewBox: ""
};
const svg_name_block_outline_28 = {
    id: "svg-name-block_outline_28",
    viewBox: ""
};
const svg_name_bonus = {
    id: "svg-name-bonus",
    viewBox: ""
};
const svg_name_box = {
    id: "svg-name-box",
    viewBox: ""
};
const svg_name_block_outline_20 = {
    id: "svg-name-block_outline_20",
    viewBox: ""
};
const svg_name_check_outline_16 = {
    id: "svg-name-check_outline_16",
    viewBox: ""
};
const svg_name_cam = {
    id: "svg-name-cam",
    viewBox: ""
};
const svg_name_cancel_20 = {
    id: "svg-name-cancel_20",
    viewBox: ""
};
const svg_name_cancel_outline_28 = {
    id: "svg-name-cancel_outline_28",
    viewBox: ""
};
const svg_name_check_box_off_20 = {
    id: "svg-name-check_box_off_20",
    viewBox: ""
};
const svg_name_check_box_on_20 = {
    id: "svg-name-check_box_on_20",
    viewBox: ""
};
const svg_name_chevron_left_outline_24 = {
    id: "svg-name-chevron_left_outline_24",
    viewBox: ""
};
const svg_name_clock = {
    id: "svg-name-clock",
    viewBox: "0 0 20 20"
};
const svg_name_clock_outline_28 = {
    id: "svg-name-clock_outline_28",
    viewBox: ""
};
const svg_name_clock_wise = {
    id: "svg-name-clock-wise",
    viewBox: ""
};
const svg_name_close = {
    id: "svg-name-close",
    viewBox: "0 0 25 25"
};
const svg_name_close_new = {
    id: "svg-name-close-new",
    viewBox: "0 0 24 24"
};
const svg_name_coin = {
    id: "svg-name-coin",
    viewBox: ""
};
const svg_name_comment_outline_20 = {
    id: "svg-name-comment_outline_20",
    viewBox: ""
};
const svg_name_copy_outline_28 = {
    id: "svg-name-copy_outline_28",
    viewBox: ""
};
const svg_name_cross = {
    id: "svg-name-cross",
    viewBox: "0 0 20 20"
};
const svg_name_cup = {
    id: "svg-name-cup",
    viewBox: ""
};
const svg_name_cup_outline_20 = {
    id: "svg-name-cup_outline_20",
    viewBox: ""
};
const svg_name_crown_simple = {
    id: "svg-name-crown-simple",
    viewBox: ""
};
const svg_name_chevron_right_outline_20 = {
    id: "svg-name-chevron_right_outline_20",
    viewBox: ""
};
const svg_name_calendar_check_outline_20 = {
    id: "svg-name-calendar_check_outline_20",
    viewBox: ""
};
const svg_name_clock_circle_dashed_outline_24 = {
    id: "svg-name-clock_circle_dashed_outline_24",
    viewBox: ""
};
const svg_name_default_avatar = {
    id: "svg-name-default-avatar",
    viewBox: ""
};
const svg_name_delete = {
    id: "svg-name-delete",
    viewBox: ""
};
const svg_name_delete_outline_20 = {
    id: "svg-name-delete_outline_20",
    viewBox: ""
};
const svg_name_delete_all_messages = {
    id: "svg-name-delete-all-messages",
    viewBox: ""
};
const svg_name_diamond = {
    id: "svg-name-diamond",
    viewBox: ""
};
const svg_name_dice_bage_1 = {
    id: "svg-name-dice-bage-1",
    viewBox: ""
};
const svg_name_dice_bage_2 = {
    id: "svg-name-dice-bage-2",
    viewBox: ""
};
const svg_name_dice_bage_3 = {
    id: "svg-name-dice-bage-3",
    viewBox: ""
};
const svg_name_dice_bage_4 = {
    id: "svg-name-dice-bage-4",
    viewBox: ""
};
const svg_name_dice_bage_5 = {
    id: "svg-name-dice-bage-5",
    viewBox: ""
};
const svg_name_dice_bage_6 = {
    id: "svg-name-dice-bage-6",
    viewBox: ""
};
const svg_name_dots = {
    id: "svg-name-dots",
    viewBox: "0 0 1080 1080"
};
const svg_name_done_16 = {
    id: "svg-name-done_16",
    viewBox: ""
};
const svg_name_dropdown_outline_16 = {
    id: "svg-name-dropdown_outline_16",
    viewBox: ""
};
const svg_name_error = {
    id: "svg-name-error",
    viewBox: ""
};
const svg_name_eye_smoothed_struck_out = {
    id: "svg-name-eye-smoothed-struck-out",
    viewBox: ""
};
const svg_name_favorite_outline_24 = {
    id: "svg-name-favorite_outline_24",
    viewBox: ""
};
const svg_name_gear = {
    id: "svg-name-gear",
    viewBox: ""
};
const svg_name_gift = {
    id: "svg-name-gift",
    viewBox: ""
};
const svg_name_gift_outline_24 = {
    id: "svg-name-gift_outline_24",
    viewBox: ""
};
const svg_name_grant_role = {
    id: "svg-name-grant-role",
    viewBox: "0 0 20 20"
};
const svg_name_hide_outline_20 = {
    id: "svg-name-hide_outline_20",
    viewBox: ""
};
const svg_name_hint = {
    id: "svg-name-hint",
    viewBox: ""
};
const svg_name_infinity = {
    id: "svg-name-infinity",
    viewBox: ""
};
const svg_name_info_circle_outline_20 = {
    id: "svg-name-info_circle_outline_20",
    viewBox: ""
};
const svg_name_like = {
    id: "svg-name-like",
    viewBox: ""
};
const svg_name_like_outline_20 = {
    id: "svg-name-like_outline_20",
    viewBox: ""
};
const svg_name_lock = {
    id: "svg-name-lock",
    viewBox: "0 0 10 10"
};
const svg_name_mention = {
    id: "svg-name-mention",
    viewBox: ""
};
const svg_name_more_vertical_16 = {
    id: "svg-name-more_vertical_16",
    viewBox: ""
};
const svg_name_more_horizontal_24 = {
    id: "svg-name-more_horizontal_24",
    viewBox: ""
};
const svg_name_more_horizontal_28 = {
    id: "svg-name-more_horizontal_28",
    viewBox: ""
};
const svg_name_messages_outline_20 = {
    id: "svg-name-messages_outline_20",
    viewBox: ""
};
const svg_name_mention_outline_24 = {
    id: "svg-name-mention_outline_24",
    viewBox: ""
};
const svg_name_message_cross_outline_20 = {
    id: "svg-name-message_cross_outline_20",
    viewBox: ""
};
const svg_name_notification_outline_24 = {
    id: "svg-name-notification_outline_24",
    viewBox: ""
};
const svg_name_pause = {
    id: "svg-name-pause",
    viewBox: "0 0 14 16"
};
const svg_name_people_couple_rounded = {
    id: "svg-name-people-couple-rounded",
    viewBox: ""
};
const svg_name_pinned_filled = {
    id: "svg-name-pinned-filled",
    viewBox: ""
};
const svg_name_profile_with_person = {
    id: "svg-name-profile-with-person",
    viewBox: ""
};
const svg_name_playlist = {
    id: "svg-name-playlist",
    viewBox: ""
};
const svg_name_pin_outline_20 = {
    id: "svg-name-pin_outline_20",
    viewBox: ""
};
const svg_name_pin_slash_outline_20 = {
    id: "svg-name-pin_slash_outline_20",
    viewBox: ""
};
const svg_name_raid = {
    id: "svg-name-raid",
    viewBox: ""
};
const svg_name_reply = {
    id: "svg-name-reply",
    viewBox: ""
};
const svg_name_roles = {
    id: "svg-name-roles",
    viewBox: ""
};
const svg_name_recent_outline_20 = {
    id: "svg-name-recent_outline_20",
    viewBox: ""
};
const svg_name_search = {
    id: "svg-name-search",
    viewBox: ""
};
const svg_name_search_24 = {
    id: "svg-name-search_24",
    viewBox: ""
};
const svg_name_send_24 = {
    id: "svg-name-send_24",
    viewBox: ""
};
const svg_name_silver_streamer = {
    id: "svg-name-silver-streamer",
    viewBox: ""
};
const svg_name_smile_outline_20 = {
    id: "svg-name-smile_outline_20",
    viewBox: ""
};
const svg_name_smile_outline_24 = {
    id: "svg-name-smile_outline_24",
    viewBox: ""
};
const svg_name_smile_outline_28 = {
    id: "svg-name-smile_outline_28",
    viewBox: ""
};
const svg_name_smile_add_outline_20 = {
    id: "svg-name-smile_add_outline_20",
    viewBox: ""
};
const svg_name_sparks = {
    id: "svg-name-sparks",
    viewBox: "0 0 14 14"
};
const svg_name_star_outline = {
    id: "svg-name-star-outline",
    viewBox: ""
};
const svg_name_sword_new = {
    id: "svg-name-sword-new",
    viewBox: ""
};
const svg_name_shield_keyhole_outline_28 = {
    id: "svg-name-shield_keyhole_outline_28",
    viewBox: ""
};
const svg_name_thread = {
    id: "svg-name-thread",
    viewBox: ""
};
const svg_name_unpin = {
    id: "svg-name-unpin",
    viewBox: ""
};
const svg_name_user_card_outline_28 = {
    id: "svg-name-user_card_outline_28",
    viewBox: ""
};
const svg_name_users_outline_20 = {
    id: "svg-name-users_outline_20",
    viewBox: ""
};
const svg_name_user_start_outline_20 = {
    id: "svg-name-user_start_outline_20",
    viewBox: ""
};
const svg_name_videocam_outline_28 = {
    id: "svg-name-videocam_outline_28",
    viewBox: ""
};
const svg_name_view_outline_20 = {
    id: "svg-name-view_outline_20",
    viewBox: ""
};
const svg_name_warning = {
    id: "svg-name-warning",
    viewBox: ""
};
const svg_name_warning_triangle_outline_20 = {
    id: "svg-name-warning_triangle_outline_20",
    viewBox: ""
};
const svg_name_wave = {
    id: "svg-name-wave",
    viewBox: ""
};
Object.values(EActionsJournalEventType);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const stringToByteArray$1 = function(str) {
    const out = [];
    let p2 = 0;
    for(let i = 0; i < str.length; i++){
        let c2 = str.charCodeAt(i);
        if (c2 < 128) out[p2++] = c2;
        else if (c2 < 2048) {
            out[p2++] = c2 >> 6 | 192;
            out[p2++] = c2 & 63 | 128;
        } else if ((c2 & 64512) === 55296 && i + 1 < str.length && (str.charCodeAt(i + 1) & 64512) === 56320) {
            c2 = 65536 + ((c2 & 1023) << 10) + (str.charCodeAt(++i) & 1023);
            out[p2++] = c2 >> 18 | 240;
            out[p2++] = c2 >> 12 & 63 | 128;
            out[p2++] = c2 >> 6 & 63 | 128;
            out[p2++] = c2 & 63 | 128;
        } else {
            out[p2++] = c2 >> 12 | 224;
            out[p2++] = c2 >> 6 & 63 | 128;
            out[p2++] = c2 & 63 | 128;
        }
    }
    return out;
};
const byteArrayToString = function(bytes) {
    const out = [];
    let pos = 0, c2 = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c2++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c22 = bytes[pos++];
            out[c2++] = String.fromCharCode((c1 & 31) << 6 | c22 & 63);
        } else if (c1 > 239 && c1 < 365) {
            const c22 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u2 = ((c1 & 7) << 18 | (c22 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 65536;
            out[c2++] = String.fromCharCode(55296 + (u2 >> 10));
            out[c2++] = String.fromCharCode(56320 + (u2 & 1023));
        } else {
            const c22 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c2++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
const base64 = {
    /**
   * Maps bytes to characters.
   */ byteToCharMap_: null,
    /**
   * Maps characters to bytes.
   */ charToByteMap_: null,
    /**
   * Maps bytes to websafe characters.
   * @private
   */ byteToCharMapWebSafe_: null,
    /**
   * Maps websafe characters to bytes.
   * @private
   */ charToByteMapWebSafe_: null,
    /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
   * Our websafe alphabet.
   */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */ encodeByteArray (input2, webSafe) {
        if (!Array.isArray(input2)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input2.length; i += 3){
            const byte1 = input2[i];
            const haveByte2 = i + 1 < input2.length;
            const byte2 = haveByte2 ? input2[i + 1] : 0;
            const haveByte3 = i + 2 < input2.length;
            const byte3 = haveByte3 ? input2[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 3) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 15) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 63;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */ encodeString (input2, webSafe) {
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input2);
        return this.encodeByteArray(stringToByteArray$1(input2), webSafe);
    },
    /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */ decodeString (input2, webSafe) {
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input2);
        return byteArrayToString(this.decodeStringToByteArray(input2, webSafe));
    },
    /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */ decodeStringToByteArray (input2, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input2.length;){
            const byte1 = charToByteMap[input2.charAt(i++)];
            const haveByte2 = i < input2.length;
            const byte2 = haveByte2 ? charToByteMap[input2.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input2.length;
            const byte3 = haveByte3 ? charToByteMap[input2.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input2.length;
            const byte4 = haveByte4 ? charToByteMap[input2.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new DecodeBase64StringError();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 240 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 192 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
class DecodeBase64StringError extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
const base64Encode = function(str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
const base64urlEncodeWithoutPadding = function(str) {
    return base64Encode(str).replace(/\./g, "");
};
const base64Decode = function(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e2) {
        console.error("base64Decode failed: ", e2);
    }
    return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getDefaultsFromGlobal = ()=>getGlobal().__FIREBASE_DEFAULTS__;
const getDefaultsFromEnvVariable = ()=>{
    return;
};
const getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match2;
    try {
        match2 = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e2) {
        return;
    }
    const decoded = match2 && base64Decode(match2[1]);
    return decoded && JSON.parse(decoded);
};
const getDefaults = ()=>{
    try {
        return getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
    } catch (e2) {
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e2}`);
        return;
    }
};
const getDefaultAppConfig = ()=>{
    var _a3;
    return (_a3 = getDefaults()) === null || _a3 === void 0 ? void 0 : _a3.config;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Deferred {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */ wrapCallback(callback) {
        return (error2, value2)=>{
            if (error2) this.reject(error2);
            else this.resolve(value2);
            if (typeof callback === "function") {
                this.promise.catch(()=>{});
                if (callback.length === 1) callback(error2);
                else callback(error2, value2);
            }
        };
    }
}
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === "object";
    } catch (e2) {
        return false;
    }
}
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request2 = self.indexedDB.open(DB_CHECK_NAME);
            request2.onsuccess = ()=>{
                request2.result.close();
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request2.onupgradeneeded = ()=>{
                preExist = false;
            };
            request2.onerror = ()=>{
                var _a3;
                reject(((_a3 = request2.error) === null || _a3 === void 0 ? void 0 : _a3.message) || "");
            };
        } catch (error2) {
            reject(error2);
        }
    });
}
function areCookiesEnabled() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_NAME = "FirebaseError";
class FirebaseError extends Error {
    constructor(code, message2, customData){
        super(message2);
        this.code = code;
        this.customData = customData;
        this.name = ERROR_NAME;
        Object.setPrototypeOf(this, FirebaseError.prototype);
        if (Error.captureStackTrace) Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message2 = template ? replaceTemplate(template, customData) : "Error";
        const fullMessage = `${this.serviceName}: ${message2} (${fullCode}).`;
        const error2 = new FirebaseError(fullCode, fullMessage, customData);
        return error2;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_2, key)=>{
        const value2 = data[key];
        return value2 != null ? String(value2) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;
function deepEqual$1(a2, b2) {
    if (a2 === b2) return true;
    const aKeys = Object.keys(a2);
    const bKeys = Object.keys(b2);
    for (const k2 of aKeys){
        if (!bKeys.includes(k2)) return false;
        const aProp = a2[k2];
        const bProp = b2[k2];
        if (isObject$1(aProp) && isObject$1(bProp)) {
            if (!deepEqual$1(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k2 of bKeys){
        if (!aKeys.includes(k2)) return false;
    }
    return true;
}
function isObject$1(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getModularInstance(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
class Component {
    /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */ constructor(name2, instanceFactory, type){
        this.name = name2;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        this.serviceProps = {};
        this.instantiationMode = "LAZY";
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode2) {
        this.instantiationMode = mode2;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ENTRY_NAME$1 = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Provider {
    constructor(name2, container2){
        this.name = name2;
        this.container = container2;
        this.component = null;
        this.instances = /* @__PURE__ */ new Map();
        this.instancesDeferred = /* @__PURE__ */ new Map();
        this.instancesOptions = /* @__PURE__ */ new Map();
        this.onInitCallbacks = /* @__PURE__ */ new Map();
    }
    /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */ get(identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e2) {}
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a3;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a3 = options === null || options === void 0 ? void 0 : options.optional) !== null && _a3 !== void 0 ? _a3 : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e2) {
            if (optional) return null;
            else throw e2;
        }
        else {
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        if (!this.shouldAutoInitialize()) return;
        if (isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: DEFAULT_ENTRY_NAME$1
            });
        } catch (e2) {}
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e2) {}
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME$1) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service).map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service).map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME$1) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME$1) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */ onInit(callback, identifier) {
        var _a3;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a3 = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a3 !== void 0 ? _a3 : /* @__PURE__ */ new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a3) {}
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a3) {}
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME$1) {
        if (this.component) return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME$1;
        else return identifier;
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT";
    }
}
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME$1 ? void 0 : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ComponentContainer {
    constructor(name2){
        this.name = name2;
        this.providers = /* @__PURE__ */ new Map();
    }
    /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */ getProvider(name2) {
        if (this.providers.has(name2)) return this.providers.get(name2);
        const provider = new Provider(name2, this);
        this.providers.set(name2, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var LogLevel;
(function(LogLevel2) {
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["VERBOSE"] = 1] = "VERBOSE";
    LogLevel2[LogLevel2["INFO"] = 2] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 3] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 4] = "ERROR";
    LogLevel2[LogLevel2["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    "debug": LogLevel.DEBUG,
    "verbose": LogLevel.VERBOSE,
    "info": LogLevel.INFO,
    "warn": LogLevel.WARN,
    "error": LogLevel.ERROR,
    "silent": LogLevel.SILENT
};
const defaultLogLevel = LogLevel.INFO;
const ConsoleMethod = {
    [LogLevel.DEBUG]: "log",
    [LogLevel.VERBOSE]: "log",
    [LogLevel.INFO]: "info",
    [LogLevel.WARN]: "warn",
    [LogLevel.ERROR]: "error"
};
const defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now2 = /* @__PURE__ */ new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) console[method](`[${now2}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class Logger {
    /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */ constructor(name2){
        this.name = name2;
        this._logLevel = defaultLogLevel;
        this._logHandler = defaultLogHandler;
        this._userLogHandler = null;
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
   * The functions below are all based on the `console` interface
   */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
const instanceOfAny = (object2, constructors)=>constructors.some((c2)=>object2 instanceof c2);
let idbProxyableTypes;
let cursorAdvanceMethods;
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = /* @__PURE__ */ new WeakMap();
const transactionDoneMap = /* @__PURE__ */ new WeakMap();
const transactionStoreNamesMap = /* @__PURE__ */ new WeakMap();
const transformCache = /* @__PURE__ */ new WeakMap();
const reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(request2) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request2.removeEventListener("success", success);
            request2.removeEventListener("error", error2);
        };
        const success = ()=>{
            resolve(wrap(request2.result));
            unlisten();
        };
        const error2 = ()=>{
            reject(request2.error);
            unlisten();
        };
        request2.addEventListener("success", success);
        request2.addEventListener("error", error2);
    });
    promise.then((value2)=>{
        if (value2 instanceof IDBCursor) cursorRequestMap.set(value2, request2);
    }).catch(()=>{});
    reverseTransformCache.set(promise, request2);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error2);
            tx.removeEventListener("abort", error2);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error2 = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error2);
        tx.addEventListener("abort", error2);
    });
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target2, prop, receiver) {
        if (target2 instanceof IDBTransaction) {
            if (prop === "done") return transactionDoneMap.get(target2);
            if (prop === "objectStoreNames") return target2.objectStoreNames || transactionStoreNamesMap.get(target2);
            if (prop === "store") return receiver.objectStoreNames[1] ? void 0 : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        return wrap(target2[prop]);
    },
    set (target2, prop, value2) {
        target2[prop] = value2;
        return true;
    },
    has (target2, prop) {
        if (target2 instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target2;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value2) {
    if (typeof value2 === "function") return wrapFunction(value2);
    if (value2 instanceof IDBTransaction) cacheDonePromiseForTransaction(value2);
    if (instanceOfAny(value2, getIdbProxyableTypes())) return new Proxy(value2, idbProxyTraps);
    return value2;
}
function wrap(value2) {
    if (value2 instanceof IDBRequest) return promisifyRequest(value2);
    if (transformCache.has(value2)) return transformCache.get(value2);
    const newValue = transformCachableValue(value2);
    if (newValue !== value2) {
        transformCache.set(value2, newValue);
        reverseTransformCache.set(newValue, value2);
    }
    return newValue;
}
const unwrap = (value2)=>reverseTransformCache.get(value2);
function openDB(name2, version2, { blocked, upgrade, blocking, terminated } = {}) {
    const request2 = indexedDB.open(name2, version2);
    const openPromise = wrap(request2);
    if (upgrade) request2.addEventListener("upgradeneeded", (event2)=>{
        upgrade(wrap(request2.result), event2.oldVersion, event2.newVersion, wrap(request2.transaction), event2);
    });
    if (blocked) request2.addEventListener("blocked", (event2)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event2.oldVersion, event2.newVersion, event2));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event2)=>blocking(event2.oldVersion, event2.newVersion, event2));
    }).catch(()=>{});
    return openPromise;
}
function deleteDB(name2, { blocked } = {}) {
    const request2 = indexedDB.deleteDatabase(name2);
    if (blocked) request2.addEventListener("blocked", (event2)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event2.oldVersion, event2));
    return wrap(request2).then(()=>void 0);
}
const readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const cachedMethods = /* @__PURE__ */ new Map();
function getMethod(target2, prop) {
    if (!(target2 instanceof IDBDatabase && !(prop in target2) && typeof prop === "string")) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target3 = tx.store;
        if (useIndex) target3 = target3.index(args.shift());
        return (await Promise.all([
            target3[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target2, prop, receiver)=>getMethod(target2, prop) || oldTraps.get(target2, prop, receiver),
        has: (target2, prop)=>!!getMethod(target2, prop) || oldTraps.has(target2, prop)
    }));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class PlatformLoggerServiceImpl {
    constructor(container2){
        this.container = container2;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        return providers.map((provider)=>{
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION";
}
const name$o = "@firebase/app";
const version$1$1 = "0.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logger = new Logger("@firebase/app");
const name$n = "@firebase/app-compat";
const name$m = "@firebase/analytics-compat";
const name$l = "@firebase/analytics";
const name$k = "@firebase/app-check-compat";
const name$j = "@firebase/app-check";
const name$i = "@firebase/auth";
const name$h = "@firebase/auth-compat";
const name$g = "@firebase/database";
const name$f = "@firebase/database-compat";
const name$e = "@firebase/functions";
const name$d$1 = "@firebase/functions-compat";
const name$c$1 = "@firebase/installations";
const name$b$1 = "@firebase/installations-compat";
const name$a$1 = "@firebase/messaging";
const name$9$1 = "@firebase/messaging-compat";
const name$8$1 = "@firebase/performance";
const name$7$1 = "@firebase/performance-compat";
const name$6$1 = "@firebase/remote-config";
const name$5$1 = "@firebase/remote-config-compat";
const name$4$1 = "@firebase/storage";
const name$3$1 = "@firebase/storage-compat";
const name$2$1 = "@firebase/firestore";
const name$1$1 = "@firebase/firestore-compat";
const name$p = "firebase";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ENTRY_NAME = "[DEFAULT]";
const PLATFORM_LOG_STRING = {
    [name$o]: "fire-core",
    [name$n]: "fire-core-compat",
    [name$l]: "fire-analytics",
    [name$m]: "fire-analytics-compat",
    [name$j]: "fire-app-check",
    [name$k]: "fire-app-check-compat",
    [name$i]: "fire-auth",
    [name$h]: "fire-auth-compat",
    [name$g]: "fire-rtdb",
    [name$f]: "fire-rtdb-compat",
    [name$e]: "fire-fn",
    [name$d$1]: "fire-fn-compat",
    [name$c$1]: "fire-iid",
    [name$b$1]: "fire-iid-compat",
    [name$a$1]: "fire-fcm",
    [name$9$1]: "fire-fcm-compat",
    [name$8$1]: "fire-perf",
    [name$7$1]: "fire-perf-compat",
    [name$6$1]: "fire-rc",
    [name$5$1]: "fire-rc-compat",
    [name$4$1]: "fire-gcs",
    [name$3$1]: "fire-gcs-compat",
    [name$2$1]: "fire-fst",
    [name$1$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [name$p]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _apps = /* @__PURE__ */ new Map();
const _serverApps = /* @__PURE__ */ new Map();
const _components = /* @__PURE__ */ new Map();
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e2) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e2);
    }
}
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    for (const app of _apps.values())_addComponent(app, component);
    for (const serverApp of _serverApps.values())_addComponent(serverApp, component);
    return true;
}
function _getProvider(app, name2) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name2);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERRORS = {
    ["no-app"]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name"]: "Illegal App name: '{$appName}'",
    ["duplicate-app"]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted"]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted"]: "Firebase Server App has been deleted",
    ["no-options"]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument"]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument"]: "First argument to `onLog` must be null or a function.",
    ["idb-open"]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get"]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set"]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete"]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported"]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment"]: "FirebaseServerApp is not for use in browser environments."
};
const ERROR_FACTORY$2 = new ErrorFactory("app", "Firebase", ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FirebaseAppImpl {
    constructor(options, config2, container2){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config2);
        this._name = config2.name;
        this._automaticDataCollectionEnabled = config2.automaticDataCollectionEnabled;
        this._container = container2;
        this.container.addComponent(new Component("app", ()=>this, "PUBLIC"));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY$2.create("app-deleted", {
            appName: this._name
        });
    }
}
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name3 = rawConfig;
        rawConfig = {
            name: name3
        };
    }
    const config2 = Object.assign({
        name: DEFAULT_ENTRY_NAME,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name2 = config2.name;
    if (typeof name2 !== "string" || !name2) throw ERROR_FACTORY$2.create("bad-app-name", {
        appName: String(name2)
    });
    options || (options = getDefaultAppConfig());
    if (!options) throw ERROR_FACTORY$2.create("no-options");
    const existingApp = _apps.get(name2);
    if (existingApp) {
        if (deepEqual$1(options, existingApp.options) && deepEqual$1(config2, existingApp.config)) return existingApp;
        else throw ERROR_FACTORY$2.create("duplicate-app", {
            appName: name2
        });
    }
    const container2 = new ComponentContainer(name2);
    for (const component of _components.values())container2.addComponent(component);
    const newApp = new FirebaseAppImpl(options, config2, container2);
    _apps.set(name2, newApp);
    return newApp;
}
function getApp(name2 = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name2);
    if (!app && name2 === DEFAULT_ENTRY_NAME && getDefaultAppConfig()) return initializeApp();
    if (!app) throw ERROR_FACTORY$2.create("no-app", {
        appName: name2
    });
    return app;
}
function registerVersion(libraryKeyOrName, version2, variant) {
    var _a3;
    let library = (_a3 = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a3 !== void 0 ? _a3 : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version2.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning2 = [
            `Unable to register library "${library}" with version "${version2}":`
        ];
        if (libraryMismatch) warning2.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning2.push("and");
        if (versionMismatch) warning2.push(`version name "${version2}" contains illegal characters (whitespace or "/")`);
        logger.warn(warning2.join(" "));
        return;
    }
    _registerComponent(new Component(`${library}-version`, ()=>({
            library: library,
            version: version2
        }), "VERSION"));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = "firebase-heartbeat-database";
const DB_VERSION = 1;
const STORE_NAME = "firebase-heartbeat-store";
let dbPromise$2 = null;
function getDbPromise$2() {
    if (!dbPromise$2) dbPromise$2 = openDB(DB_NAME, DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore(STORE_NAME);
                    } catch (e2) {
                        console.warn(e2);
                    }
            }
        }
    }).catch((e2)=>{
        throw ERROR_FACTORY$2.create("idb-open", {
            originalErrorMessage: e2.message
        });
    });
    return dbPromise$2;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise$2();
        const tx = db.transaction(STORE_NAME);
        const result2 = await tx.objectStore(STORE_NAME).get(computeKey(app));
        await tx.done;
        return result2;
    } catch (e2) {
        if (e2 instanceof FirebaseError) logger.warn(e2.message);
        else {
            const idbGetError = ERROR_FACTORY$2.create("idb-get", {
                originalErrorMessage: e2 === null || e2 === void 0 ? void 0 : e2.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise$2();
        const tx = db.transaction(STORE_NAME, "readwrite");
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    } catch (e2) {
        if (e2 instanceof FirebaseError) logger.warn(e2.message);
        else {
            const idbGetError = ERROR_FACTORY$2.create("idb-set", {
                originalErrorMessage: e2 === null || e2 === void 0 ? void 0 : e2.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const MAX_HEADER_BYTES = 1024;
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class HeartbeatServiceImpl {
    constructor(container2){
        this.container = container2;
        this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result2)=>{
            this._heartbeatsCache = result2;
            return result2;
        });
    }
    /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */ async triggerHeartbeat() {
        var _a3, _b2;
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        const agent = platformLogger.getPlatformInfoString();
        const date2 = getUTCDateString();
        if (((_a3 = this._heartbeatsCache) === null || _a3 === void 0 ? void 0 : _a3.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            if (((_b2 = this._heartbeatsCache) === null || _b2 === void 0 ? void 0 : _b2.heartbeats) == null) return;
        }
        if (this._heartbeatsCache.lastSentHeartbeatDate === date2 || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date2)) return;
        else this._heartbeatsCache.heartbeats.push({
            date: date2,
            agent: agent
        });
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now2 = Date.now();
            return now2 - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */ async getHeartbeatsHeader() {
        var _a3;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        if (((_a3 = this._heartbeatsCache) === null || _a3 === void 0 ? void 0 : _a3.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date2 = getUTCDateString();
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = base64urlEncodeWithoutPadding(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        this._heartbeatsCache.lastSentHeartbeatDate = date2;
        if (unsentEntries.length > 0) {
            this._heartbeatsCache.heartbeats = unsentEntries;
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = /* @__PURE__ */ new Date();
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    const heartbeatsToSend = [];
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!isIndexedDBAvailable()) return false;
        else return validateIndexedDBOpenable().then(()=>true).catch(()=>false);
    }
    /**
   * Read all heartbeats.
   */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a3;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a3 = heartbeatsObject.lastSentHeartbeatDate) !== null && _a3 !== void 0 ? _a3 : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a3;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a3 = heartbeatsObject.lastSentHeartbeatDate) !== null && _a3 !== void 0 ? _a3 : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
function countBytes(heartbeatsCache) {
    return base64urlEncodeWithoutPadding(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function registerCoreComponents(variant) {
    _registerComponent(new Component("platform-logger", (container2)=>new PlatformLoggerServiceImpl(container2), "PRIVATE"));
    _registerComponent(new Component("heartbeat", (container2)=>new HeartbeatServiceImpl(container2), "PRIVATE"));
    registerVersion(name$o, version$1$1, variant);
    registerVersion(name$o, version$1$1, "esm2017");
    registerVersion("fire-js", "");
}
registerCoreComponents("");
var name$d = "firebase";
var version$2 = "10.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ registerVersion(name$d, version$2, "app");
const name$c = "@firebase/installations";
const version$1 = "0.6.6";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_TIMEOUT_MS = 1e4;
const PACKAGE_VERSION = `w:${version$1}`;
const INTERNAL_AUTH_VERSION = "FIS_v2";
const INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const TOKEN_EXPIRATION_BUFFER = 3600000;
const SERVICE = "installations";
const SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values"]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered"]: "Firebase Installation is not registered.",
    ["installation-not-found"]: "Firebase Installation not found.",
    ["request-failed"]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline"]: "Could not process request. Application offline.",
    ["delete-pending-registration"]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY$1 = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
function isServerError(error2) {
    return error2 instanceof FirebaseError && error2.code.includes("request-failed");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY$1.create("request-failed", {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders$1({ apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders$1(appConfig);
    headers.append("Authorization", getAuthorizationHeader(refreshToken));
    return headers;
}
async function retryIfServerError(fn2) {
    const result2 = await fn2();
    if (result2.status >= 500 && result2.status < 600) return fn2();
    return result2;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    return Number(responseExpiresIn.replace("s", "000"));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders$1(appConfig);
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body2 = {
        fid: fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request2 = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body2)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request2));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = "";
function generateFid() {
    try {
        const fidByteArray = new Uint8Array(17);
        const crypto2 = self.crypto || self.msCrypto;
        crypto2.getRandomValues(fidByteArray);
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    } catch (_a3) {
        return INVALID_FID;
    }
}
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getKey$1(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const fidChangeCallbacks = /* @__PURE__ */ new Map();
function fidChanged(appConfig, fid) {
    const key = getKey$1(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function broadcastFidChange(key, fid) {
    const channel2 = getBroadcastChannel();
    if (channel2) channel2.postMessage({
        key: key,
        fid: fid
    });
    closeBroadcastChannel();
}
let broadcastChannel = null;
function getBroadcastChannel() {
    if (!broadcastChannel && "BroadcastChannel" in self) {
        broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        broadcastChannel.onmessage = (e2)=>{
            callFidChangeCallbacks(e2.data.key, e2.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DATABASE_NAME$1 = "firebase-installations-database";
const DATABASE_VERSION$1 = 1;
const OBJECT_STORE_NAME$1 = "firebase-installations-store";
let dbPromise$1 = null;
function getDbPromise$1() {
    if (!dbPromise$1) dbPromise$1 = openDB(DATABASE_NAME$1, DATABASE_VERSION$1, {
        upgrade: (db, oldVersion)=>{
            switch(oldVersion){
                case 0:
                    db.createObjectStore(OBJECT_STORE_NAME$1);
            }
        }
    });
    return dbPromise$1;
}
async function set$1(appConfig, value2) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, "readwrite");
    const objectStore = tx.objectStore(OBJECT_STORE_NAME$1);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value2, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value2.fid) fidChanged(appConfig, value2.fid);
    return value2;
}
async function remove(appConfig) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, "readwrite");
    await tx.objectStore(OBJECT_STORE_NAME$1).delete(key);
    await tx.done;
}
async function update(appConfig, updateFn) {
    const key = getKey$1(appConfig);
    const db = await getDbPromise$1();
    const tx = db.transaction(OBJECT_STORE_NAME$1, "readwrite");
    const store2 = tx.objectStore(OBJECT_STORE_NAME$1);
    const oldValue = await store2.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === void 0) await store2.delete(key);
    else await store2.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, (oldEntry)=>{
        const installationEntry2 = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry2);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0
    };
    return clearTimedOutRequest(entry);
}
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0) {
        if (!navigator.onLine) {
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY$1.create("app-offline"));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1) return {
        installationEntry: installationEntry,
        registrationPromise: waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set$1(installations.appConfig, registeredInstallationEntry);
    } catch (e2) {
        if (isServerError(e2) && e2.customData.serverCode === 409) await remove(installations.appConfig);
        else await set$1(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0
        });
        throw e2;
    }
}
async function waitUntilFidRegistration(installations) {
    let entry = await updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1){
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0) {
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else return installationEntry;
    }
    return entry;
}
function updateInstallationRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw ERROR_FACTORY$1.create("installation-not-found");
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0
    };
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body2 = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request2 = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body2)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request2));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await getErrorFromResponse("Generate Auth Token", response);
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY$1.create("not-registered");
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) return oldEntry;
        else if (oldAuthToken.requestStatus === 1) {
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            if (!navigator.onLine) throw ERROR_FACTORY$1.create("app-offline");
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1){
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0) return refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY$1.create("not-registered");
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0
            }
        });
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await set$1(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e2) {
        if (isServerError(e2) && (e2.customData.serverCode === 401 || e2.customData.serverCode === 404)) await remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0
                }
            });
            await set$1(installations.appConfig, updatedInstallationEntry);
        }
        throw e2;
    }
}
function isEntryRegistered(installationEntry) {
    return installationEntry !== void 0 && installationEntry.registrationStatus === 2;
}
function isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
    const now2 = Date.now();
    return now2 < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now2 + TOKEN_EXPIRATION_BUFFER;
}
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getToken$2(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function extractAppConfig$1(app) {
    if (!app || !app.options) throw getMissingValueError$1("App Configuration");
    if (!app.name) throw getMissingValueError$1("App Name");
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw getMissingValueError$1(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError$1(valueName) {
    return ERROR_FACTORY$1.create("missing-app-config-values", {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const INSTALLATIONS_NAME = "installations";
const INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const publicFactory = (container2)=>{
    const app = container2.getProvider("app").getImmediate();
    const appConfig = extractAppConfig$1(app);
    const heartbeatServiceProvider = _getProvider(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container2)=>{
    const app = container2.getProvider("app").getImmediate();
    const installations = _getProvider(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>getId(installations),
        getToken: (forceRefresh)=>getToken$2(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    _registerComponent(new Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC"));
    _registerComponent(new Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE"));
}
registerInstallations();
registerVersion(name$c, version$1);
registerVersion(name$c, version$1, "esm2017");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
const DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
const DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
const ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
const CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
const CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
const CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
const CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var MessageType$1;
(function(MessageType2) {
    MessageType2[MessageType2["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType2[MessageType2["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var MessageType;
(function(MessageType2) {
    MessageType2["PUSH_RECEIVED"] = "push-received";
    MessageType2["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function base64ToArray(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base642 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = atob(base642);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const OLD_DB_NAME = "fcm_token_details_db";
const OLD_DB_VERSION = 5;
const OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
async function migrateOldDatabase(senderId) {
    if ("databases" in indexedDB) {
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db2)=>db2.name);
        if (!dbNames.includes(OLD_DB_NAME)) return null;
    }
    let tokenDetails = null;
    const db = await openDB(OLD_DB_NAME, OLD_DB_VERSION, {
        upgrade: async (db2, oldVersion, newVersion, upgradeTransaction)=>{
            var _a3;
            if (oldVersion < 2) return;
            if (!db2.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) return;
            const objectStore = upgradeTransaction.objectStore(OLD_OBJECT_STORE_NAME);
            const value2 = await objectStore.index("fcmSenderId").get(senderId);
            await objectStore.clear();
            if (!value2) return;
            if (oldVersion === 2) {
                const oldDetails = value2;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a3 = oldDetails.createTime) !== null && _a3 !== void 0 ? _a3 : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value2;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value2;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    await deleteDB(OLD_DB_NAME);
    await deleteDB("fcm_vapid_details_db");
    await deleteDB("undefined");
    return checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DATABASE_NAME = "firebase-messaging-database";
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = "firebase-messaging-store";
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore(OBJECT_STORE_NAME);
            }
        }
    });
    return dbPromise;
}
async function dbGet(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tokenDetails = await db.transaction(OBJECT_STORE_NAME).objectStore(OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        const oldTokenDetails = await migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
async function dbSet(firebaseDependencies, tokenDetails) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
async function dbRemove(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function getKey({ appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_MAP = {
    ["missing-app-config-values"]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window"]: "This method is available in a Window context.",
    ["only-available-in-sw"]: "This method is available in a service worker context.",
    ["permission-default"]: "The notification permission was not granted and dismissed instead.",
    ["permission-blocked"]: "The notification permission was not granted and blocked instead.",
    ["unsupported-browser"]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported"]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration"]: "We are unable to register the default service worker. {$browserErrorMessage}",
    ["token-subscribe-failed"]: "A problem occurred while subscribing the user to FCM: {$errorInfo}",
    ["token-subscribe-no-token"]: "FCM returned no token when subscribing the user to push.",
    ["token-unsubscribe-failed"]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed"]: "A problem occurred while updating the user from FCM: {$errorInfo}",
    ["token-update-no-token"]: "FCM returned no token when updating the user to push.",
    ["use-sw-after-get-token"]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration"]: "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
    ["invalid-bg-handler"]: "The input to setBackgroundMessageHandler() must be a function.",
    ["invalid-vapid-key"]: "The public VAPID key must be a string.",
    ["use-vapid-key-after-get-token"]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const ERROR_FACTORY = new ErrorFactory("messaging", "Messaging", ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await getHeaders(firebaseDependencies);
    const body2 = getBody(subscriptionOptions);
    const subscribeOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body2)
    };
    let responseData;
    try {
        const response = await fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw ERROR_FACTORY.create("token-subscribe-failed", {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message2 = responseData.error.message;
        throw ERROR_FACTORY.create("token-subscribe-failed", {
            errorInfo: message2
        });
    }
    if (!responseData.token) throw ERROR_FACTORY.create("token-subscribe-no-token");
    return responseData.token;
}
async function requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await getHeaders(firebaseDependencies);
    const body2 = getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body2)
    };
    let responseData;
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw ERROR_FACTORY.create("token-update-failed", {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message2 = responseData.error.message;
        throw ERROR_FACTORY.create("token-update-failed", {
            errorInfo: message2
        });
    }
    if (!responseData.token) throw ERROR_FACTORY.create("token-update-no-token");
    return responseData.token;
}
async function requestDeleteToken(firebaseDependencies, token2) {
    const headers = await getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: "DELETE",
        headers: headers
    };
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${token2}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message2 = responseData.error.message;
            throw ERROR_FACTORY.create("token-unsubscribe-failed", {
                errorInfo: message2
            });
        }
    } catch (err) {
        throw ERROR_FACTORY.create("token-unsubscribe-failed", {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function getEndpoint({ projectId }) {
    return `${ENDPOINT}/projects/${projectId}/registrations`;
}
async function getHeaders({ appConfig, installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": appConfig.apiKey,
        "x-goog-firebase-installations-auth": `FIS ${authToken}`
    });
}
function getBody({ p256dh, auth, endpoint, vapidKey }) {
    const body2 = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== DEFAULT_VAPID_KEY) body2.web.applicationPubKey = vapidKey;
    return body2;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const TOKEN_EXPIRATION_MS = 604800000;
async function getTokenInternal(messaging) {
    const pushSubscription = await getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: arrayToBase64(pushSubscription.getKey("auth")),
        p256dh: arrayToBase64(pushSubscription.getKey("p256dh"))
    };
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        try {
            await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e2) {
            console.warn(e2);
        }
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) return updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else return tokenDetails.token;
}
async function deleteTokenInternal(messaging) {
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await dbRemove(messaging.firebaseDependencies);
    }
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    return true;
}
async function updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e2) {
        await deleteTokenInternal(messaging);
        throw e2;
    }
}
async function getNewToken(firebaseDependencies, subscriptionOptions) {
    const token2 = await requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token2,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
async function getPushSubscription(swRegistration, vapidKey) {
    const subscription2 = await swRegistration.pushManager.getSubscription();
    if (subscription2) return subscription2;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: base64ToArray(vapidKey)
    });
}
function isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title2 = messagePayloadInternal.notification.title;
    if (!!title2) payload.notification.title = title2;
    const body2 = messagePayloadInternal.notification.body;
    if (!!body2) payload.notification.body = body2;
    const image2 = messagePayloadInternal.notification.image;
    if (!!image2) payload.notification.image = image2;
    const icon2 = messagePayloadInternal.notification.icon;
    if (!!icon2) payload.notification.icon = icon2;
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    var _a3, _b2, _c2, _d, _e;
    if (!messagePayloadInternal.fcmOptions && !((_a3 = messagePayloadInternal.notification) === null || _a3 === void 0 ? void 0 : _a3.click_action)) return;
    payload.fcmOptions = {};
    const link2 = (_c2 = (_b2 = messagePayloadInternal.fcmOptions) === null || _b2 === void 0 ? void 0 : _b2.link) !== null && _c2 !== void 0 ? _c2 : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link2) payload.fcmOptions.link = link2;
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isConsoleMessage(data) {
    return typeof data === "object" && !!data && CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ _mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
_mergeStrings("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function _mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function extractAppConfig(app) {
    if (!app || !app.options) throw getMissingValueError("App Configuration Object");
    if (!app.name) throw getMissingValueError("App Name");
    const configKeys = [
        "projectId",
        "apiKey",
        "appId",
        "messagingSenderId"
    ];
    const { options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values", {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MessagingService {
    constructor(app, installations, analyticsProvider){
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        });
        messaging.swRegistration.update().catch(()=>{});
    } catch (e2) {
        throw ERROR_FACTORY.create("failed-service-worker-registration", {
            browserErrorMessage: e2 === null || e2 === void 0 ? void 0 : e2.message
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw ERROR_FACTORY.create("invalid-sw-registration");
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getToken$1(messaging, options) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window");
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") throw ERROR_FACTORY.create("permission-blocked");
    await updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function logToScion(messaging, messageType, data) {
    const eventType = getEventType(messageType);
    const analytics2 = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics2.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[CONSOLE_CAMPAIGN_ID],
        message_name: data[CONSOLE_CAMPAIGN_NAME],
        message_time: data[CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1e3)
    });
}
function getEventType(messageType) {
    switch(messageType){
        case MessageType.NOTIFICATION_CLICKED:
            return "notification_open";
        case MessageType.PUSH_RECEIVED:
            return "notification_foreground";
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function messageEventListener(messaging, event2) {
    const internalPayload = event2.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === "function") messaging.onMessageHandler(externalizePayload(internalPayload));
        else messaging.onMessageHandler.next(externalizePayload(internalPayload));
    }
    const dataPayload = internalPayload.data;
    if (isConsoleMessage(dataPayload) && dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1") await logToScion(messaging, internalPayload.messageType, dataPayload);
}
const name$b = "@firebase/messaging";
const version = "0.12.7";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const WindowMessagingFactory = (container2)=>{
    const messaging = new MessagingService(container2.getProvider("app").getImmediate(), container2.getProvider("installations-internal").getImmediate(), container2.getProvider("analytics-internal"));
    navigator.serviceWorker.addEventListener("message", (e2)=>messageEventListener(messaging, e2));
    return messaging;
};
const WindowMessagingInternalFactory = (container2)=>{
    const messaging = container2.getProvider("messaging").getImmediate();
    const messagingInternal = {
        getToken: (options)=>getToken$1(messaging, options)
    };
    return messagingInternal;
};
function registerMessagingInWindow() {
    _registerComponent(new Component("messaging", WindowMessagingFactory, "PUBLIC"));
    _registerComponent(new Component("messaging-internal", WindowMessagingInternalFactory, "PRIVATE"));
    registerVersion(name$b, version);
    registerVersion(name$b, version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function isWindowSupported() {
    try {
        await validateIndexedDBOpenable();
    } catch (e2) {
        return false;
    }
    return typeof window !== "undefined" && isIndexedDBAvailable() && areCookiesEnabled() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteToken$1(messaging) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window");
    if (!messaging.swRegistration) await registerDefaultSw(messaging);
    return deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getMessagingInWindow(app = getApp()) {
    isWindowSupported().then((isSupported)=>{
        if (!isSupported) throw ERROR_FACTORY.create("unsupported-browser");
    }, (_2)=>{
        throw ERROR_FACTORY.create("indexed-db-unsupported");
    });
    return _getProvider(getModularInstance(app), "messaging").getImmediate();
}
async function getToken(messaging, options) {
    messaging = getModularInstance(messaging);
    return getToken$1(messaging, options);
}
function deleteToken(messaging) {
    messaging = getModularInstance(messaging);
    return deleteToken$1(messaging);
}
registerMessagingInWindow();
const useSvgImage = (props)=>{
    const { className, classNameSvg, fileName, fill, style = {}, title: title2, onClick } = props;
    const { hosts: { static: staticHost } } = getConfig();
    const [svgProps, setSvgProps] = (0, $acw62.useState)(null);
    const fetchContent = async ()=>{
        const response = await fetch(`${staticHost}${fileName}`);
        const data = await response.text();
        const tempEl = document.createElement("div");
        tempEl.innerHTML = data.trim();
        const svgEl = tempEl.querySelector("svg");
        setSvgProps({
            dangerouslySetInnerHTML: {
                __html: svgEl.innerHTML
            },
            fill: svgEl.getAttribute("fill"),
            height: svgEl.getAttribute("height"),
            width: svgEl.getAttribute("width")
        });
    };
    const shouldShow = {
        svg: Boolean(svgProps)
    };
    (0, $acw62.useEffect)(()=>{
        fetchContent();
    }, []);
    return {
        className: className,
        classNameSvg: classNameSvg,
        fill: fill,
        shouldShow: shouldShow,
        style: style,
        svgProps: svgProps,
        title: title2,
        onClick: onClick
    };
};
const root$1_ = "SvgImage-scss--module__root___-LtOR";
const svg$2 = "SvgImage-scss--module__svg___QbZCu";
const s$3z = {
    root: root$1_,
    svg: svg$2
};
const SvgImage = (props)=>{
    const { className, classNameSvg, fill, shouldShow, style, svgProps, title: title2, onClick } = useSvgImage(props);
    return /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3z.root, className),
        onClick: onClick,
        title: title2,
        style: style
    }, shouldShow.svg && /* @__PURE__ */ $acw62.createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3z.svg, classNameSvg),
        fill: fill,
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps
    }));
};
SvgImage.displayName = "SvgImage";
const block$5 = "Icon-scss--module__block___AaCyB";
const svg$1 = "Icon-scss--module__svg___frD2r";
const icon16 = "Icon-scss--module__icon16___iJ5ZB";
const s$3y = {
    block: block$5,
    svg: svg$1,
    icon16: icon16
};
const Icon = $acw62.memo((props)=>{
    const { className, classNameSvg, glyph, style = {}, title: title2, onClick, ...restProps } = props;
    if (typeof glyph === "string") return /* @__PURE__ */ $acw62.createElement(SvgImage, {
        className: className,
        classNameSvg: classNameSvg,
        fileName: glyph,
        style: style,
        title: title2,
        onClick: onClick,
        ...restProps
    });
    return /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3y.block, className),
        onClick: onClick,
        title: title2,
        style: style
    }, /* @__PURE__ */ $acw62.createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3y.svg, classNameSvg),
        ...restProps
    }, /* @__PURE__ */ $acw62.createElement("use", {
        xlinkHref: `#${glyph.id}`
    })));
});
Icon.displayName = "Icon";
const Icon16 = (props)=>{
    const { className, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3y.icon16, className),
        ...restProps
    });
};
const AccordionContext = (0, $acw62.createContext)({
    handleToggle: noop$2
});
const title$q = "Accordion-scss--module__title___ZBbws";
const arrow$4 = "Accordion-scss--module__arrow___R4il9";
const container$j = "Accordion-scss--module__container___rhNSo";
const containerOpened = "Accordion-scss--module__containerOpened___UhHYW";
const s$3x = {
    title: title$q,
    arrow: arrow$4,
    container: container$j,
    containerOpened: containerOpened
};
const Accordion = (props)=>{
    const { isOpenedByDefault = false, title: title2, children: children2, containerClassName, titleClassName, arrowClassName, itemClassName } = props;
    const [isOpened, setOpened] = (0, $acw62.useState)(isOpenedByDefault);
    const onToggle = ()=>setOpened(!isOpened);
    (0, $acw62.useEffect)(()=>{
        setOpened(isOpenedByDefault);
    }, [
        isOpenedByDefault
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3x.container, {
            [s$3x.containerOpened]: isOpened
        }, containerClassName)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3x.title, titleClassName),
        onClick: onToggle
    }, title2, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_dropdown_outline_16,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3x.arrow, arrowClassName)
    })), isOpened && (Array.isArray(children2) ? (children2 == null ? void 0 : children2.length) > 0 : children2) && /* @__PURE__ */ $acw62.createElement("div", {
        className: itemClassName
    }, /* @__PURE__ */ $acw62.createElement(AccordionContext.Provider, {
        value: {
            handleToggle: onToggle
        }
    }, children2)));
};
const container$i = "TabItem-scss--module__container___lU509";
const active$7 = "TabItem-scss--module__active___c5MKa";
const title$p = "TabItem-scss--module__title___Dz0pZ";
const icon$E = "TabItem-scss--module__icon___KFGYM";
const iconEnd = "TabItem-scss--module__iconEnd___zn7ca";
const s$3w = {
    container: container$i,
    active: active$7,
    title: title$p,
    icon: icon$E,
    iconEnd: iconEnd
};
const TabItemCommon$1 = ({ className, title: title2, onClick, active: active2, id })=>/* @__PURE__ */ $acw62.createElement("span", {
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3w.container, {
            [s$3w.active]: active2
        }, className),
        id: id
    }, title2);
/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function _extends$2() {
    _extends$2 = Object.assign ? Object.assign.bind() : function(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
        }
        return target2;
    };
    return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target2[key] = source[key];
    }
    return target2;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object2) {
    return object2 != null && typeof object2.tagName === "string";
}
function isButtonElement(object2) {
    return isHtmlElement(object2) && object2.tagName.toLowerCase() === "button";
}
function isFormElement(object2) {
    return isHtmlElement(object2) && object2.tagName.toLowerCase() === "form";
}
function isInputElement(object2) {
    return isHtmlElement(object2) && object2.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event2) {
    return !!(event2.metaKey || event2.altKey || event2.ctrlKey || event2.shiftKey);
}
function shouldProcessLinkClick(event2, target2) {
    return event2.button === 0 && // Ignore everything but left clicks
    (!target2 || target2 === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event2);
}
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e2) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target2, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body2;
    if (isFormElement(target2)) {
        let attr2 = target2.getAttribute("action");
        action = attr2 ? stripBasename(attr2, basename) : null;
        method = target2.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target2.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target2);
    } else if (isButtonElement(target2) || isInputElement(target2) && (target2.type === "submit" || target2.type === "image")) {
        let form = target2.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        let attr2 = target2.getAttribute("formaction") || form.getAttribute("action");
        action = attr2 ? stripBasename(attr2, basename) : null;
        method = target2.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target2.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target2);
        if (!isFormDataSubmitterSupported()) {
            let { name: name2, type, value: value2 } = target2;
            if (type === "image") {
                let prefix2 = name2 ? name2 + "." : "";
                formData.append(prefix2 + "x", "0");
                formData.append(prefix2 + "y", "0");
            } else if (name2) formData.append(name2, value2);
        }
    } else if (isHtmlElement(target2)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body2 = target2;
    }
    if (formData && encType === "text/plain") {
        body2 = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body2
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
const ViewTransitionContext = /* @__PURE__ */ $acw62.createContext({
    isTransitioning: false
});
const FetchersContext = /* @__PURE__ */ $acw62.createContext(/* @__PURE__ */ new Map());
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const Link$1 = /* @__PURE__ */ $acw62.forwardRef(function LinkWithRef(_ref7, ref2) {
    let { onClick, relative, reloadDocument, replace, state, target: target2, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose$2(_ref7, _excluded);
    let { basename } = $acw62.useContext(NavigationContext);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        absoluteHref = to;
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path2 = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path2 != null) to = path2 + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e2) {}
    }
    let href = useHref(to, {
        relative: relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace: replace,
        state: state,
        target: target2,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event2) {
        if (onClick) onClick(event2);
        if (!event2.defaultPrevented) internalOnClick(event2);
    }
    return(// eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", _extends$2({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref2,
        target: target2
    })));
});
const NavLink = /* @__PURE__ */ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref2) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children: children2 } = _ref8, rest = _objectWithoutPropertiesLoose$2(_ref8, _excluded2);
    let path2 = useResolvedPath(to, {
        relative: rest.relative
    });
    let location2 = window.location;
    let routerState = $acw62.useContext(DataRouterStateContext);
    let { navigator: navigator2, basename } = $acw62.useContext(NavigationContext);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path2) && unstable_viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path2).pathname : path2.pathname;
    let locationPathname = location2.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement(Link$1, _extends$2({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref2,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children2 === "function" ? children2(renderProps) : children2);
});
const Form$2 = /* @__PURE__ */ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose$2(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event2)=>{
        onSubmit && onSubmit(event2);
        if (event2.defaultPrevented) return;
        event2.preventDefault();
        let submitter = event2.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event2.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", _extends$2({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
var DataRouterHook;
(function(DataRouterHook2) {
    DataRouterHook2["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook2["UseSubmit"] = "useSubmit";
    DataRouterHook2["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook2["UseFetcher"] = "useFetcher";
    DataRouterHook2["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook2) {
    DataRouterStateHook2["UseFetcher"] = "useFetcher";
    DataRouterStateHook2["UseFetchers"] = "useFetchers";
    DataRouterStateHook2["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = $acw62.useContext(DataRouterContext);
    !ctx && invariant(false);
    return ctx;
}
function useLinkClickHandler(to, _temp) {
    let { target: target2, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (value2)=>{
        document.location.href = value2;
    };
    let location2 = useLocation();
    let path2 = useResolvedPath(to, {
        relative: relative
    });
    return $acw62.useCallback((event2)=>{
        if (shouldProcessLinkClick(event2, target2)) {
            event2.preventDefault();
            replaceProp !== void 0 ? replaceProp : (createPath(location2), createPath(path2));
            navigate(to);
        }
    }, [
        location2,
        navigate,
        path2,
        replaceProp,
        state,
        target2,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = $acw62.useContext(NavigationContext);
    let currentRouteId = useRouteId();
    return $acw62.useCallback(function(target2, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body: body2 } = getFormSubmissionInfo(target2, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body2,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body2,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = $acw62.useContext(NavigationContext);
    let routeContext = $acw62.useContext(RouteContext);
    !routeContext && invariant(false);
    let [match2] = routeContext.matches.slice(-1);
    let path2 = _extends$2({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    let location2 = useLocation();
    if (action == null) {
        path2.search = location2.search;
        let params = new URLSearchParams(path2.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path2.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match2.route.index) path2.search = path2.search ? path2.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path2.pathname = path2.pathname === "/" ? basename : joinPaths([
        basename,
        path2.pathname
    ]);
    return createPath(path2);
}
function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext(ViewTransitionContext);
    !(vtContext != null) && invariant(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path2 = useResolvedPath(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path2.pathname, nextPath) != null || matchPath(path2.pathname, currentPath) != null;
}
const root$1Z = "IndicatorPoint-scss--module__root___QAVZa";
const wrapper$4 = "IndicatorPoint-scss--module__wrapper___ZwlMB";
const point$1 = "IndicatorPoint-scss--module__point___4IF1z";
const s$3v = {
    root: root$1Z,
    wrapper: wrapper$4,
    point: point$1
};
const IndicatorPoint = (props)=>{
    const { className } = props;
    return /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3v.root, className)
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$3v.wrapper
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$3v.point
    })));
};
const root$1Y = "IndicatorButton-scss--module__root___eE5i1";
const button$q = "IndicatorButton-scss--module__button___u42Lr";
const s$3u = {
    root: root$1Y,
    button: button$q
};
const locales$1L = {
    new: "\u041D\u043E\u0432\u043E\u0435"
};
const t$1M = distExports$1.getTranslation && locales$1L;
const IndicatorButton = (props)=>{
    const { className } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3u.root, className)
    }, /* @__PURE__ */ $acw62.createElement("button", {
        className: s$3u.button
    }, t$1M.new));
};
const getDateFromString = (date2)=>{
    const [day, month, year] = date2.split(".");
    return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
};
const EVENT_NAME = "updateIndication";
const useIndicator = (params)=>{
    const { keys: keys3, type } = params;
    const { indication: indicatorsList } = getConfig();
    const [isSwitcher, setIsSwitcher] = (0, $acw62.useState)(false);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const currentUserId = currentUser2 == null ? void 0 : currentUser2.id;
    const suitableActiveIndicators = (0, $acw62.useMemo)(()=>{
        return keys3.reduce((acc, key)=>{
            const [name2, storageKey] = Object.entries(key)[0];
            const indicator = indicatorsList[name2];
            const hasIndicator = Object.keys(indicator).length > 1;
            if (hasIndicator && Boolean(currentUserId)) {
                const date2 = getDateFromString(indicator.expirationDate);
                const isNotExpiredDate = Boolean(date2) && date2 > Date.now();
                const isEnabled = indicator.isEnabled;
                const isNotViewed = !Boolean(getParsedFromLocalStorage(`${storageKey}:${currentUserId}`));
                if (isEnabled && isNotExpiredDate && isNotViewed) acc = [
                    ...acc,
                    key
                ];
            }
            return [
                ...acc
            ];
        }, []);
    }, [
        indicatorsList,
        keys3,
        isSwitcher,
        currentUserId
    ]);
    const hasActiveIndicator = suitableActiveIndicators.length > 0;
    const setViewed = (0, $acw62.useCallback)(()=>{
        if (type === EIndicationType.BUTTON) suitableActiveIndicators.forEach((indicator)=>{
            const storageKey = Object.values(indicator)[0];
            setToLocalStorage(`${storageKey}:${currentUserId}`, "true");
            window.dispatchEvent(new CustomEvent(EVENT_NAME, {
                detail: storageKey
            }));
        });
    }, [
        type,
        suitableActiveIndicators,
        currentUserId
    ]);
    const handleStorage = (0, $acw62.useCallback)((event2)=>{
        const hasKey = keys3.map((key)=>Object.values(key)[0]).includes(event2.detail);
        if (hasKey) setIsSwitcher((prevIsSwitcher)=>!prevIsSwitcher);
    }, [
        isSwitcher
    ]);
    (0, $acw62.useEffect)(()=>{
        if (hasActiveIndicator) window.addEventListener(EVENT_NAME, handleStorage);
        return ()=>{
            if (hasActiveIndicator) {
                setViewed();
                window.removeEventListener(EVENT_NAME, handleStorage);
            }
        };
    }, []);
    return {
        hasActiveIndicator: hasActiveIndicator
    };
};
const Indicator = (props)=>{
    const { type, keys: keys3, classNames = {} } = props;
    const { hasActiveIndicator } = useIndicator({
        keys: keys3,
        type: type
    });
    if (!hasActiveIndicator) return null;
    const renderIndicator = ()=>{
        switch(type){
            case EIndicationType.POINT:
                return /* @__PURE__ */ $acw62.createElement(IndicatorPoint, {
                    className: classNames.root
                });
            case EIndicationType.BUTTON:
                return /* @__PURE__ */ $acw62.createElement(IndicatorButton, {
                    className: classNames.root
                });
            default:
                return null;
        }
    };
    return renderIndicator();
};
const TabItemLink$1 = ({ className, iconClassName, icon: icon2, iconEnd: iconEnd2, iconEndClassName, title: title2, onClick, url, id, active: active2, indication })=>/* @__PURE__ */ $acw62.createElement(NavLink, {
        onClick: onClick,
        to: url,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3w.container, className, {
            [s$3w.active]: active2
        }),
        id: id
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: icon2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3w.icon, iconClassName)
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$3w.title
    }, title2), iconEnd2 && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: iconEnd2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3w.iconEnd, iconEndClassName)
    }), Boolean(indication) && /* @__PURE__ */ $acw62.createElement(Indicator, {
        type: indication.type,
        keys: indication.keys
    }));
const TabItem$1 = (props)=>{
    if (props.url) return /* @__PURE__ */ $acw62.createElement(TabItemLink$1, {
        ...props
    });
    return /* @__PURE__ */ $acw62.createElement(TabItemCommon$1, {
        ...props
    });
};
const wrapper$3 = "AsideTabs-scss--module__wrapper___xzZT6";
const s$3t = {
    wrapper: wrapper$3
};
const _AsideTabs = class _AsideTabs extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            activeIndex: this.props.activeTab || 0
        };
        this.isActive = (index2)=>this.state.activeIndex === index2;
        this.onClick = (index2, _event)=>{
            this.setState({
                activeIndex: index2
            });
        };
    }
    componentDidMount() {
        const { activeTab } = this.props;
        if (isNumber(activeTab)) this.setState({
            activeIndex: activeTab
        });
    }
    componentDidUpdate(prevProps) {
        const { activeTab } = this.props;
        if (prevProps.activeTab !== activeTab && isNumber(activeTab)) this.setState({
            activeIndex: activeTab
        });
    }
    render() {
        const { className, classNameActive, children: children2 } = this.props;
        return /* @__PURE__ */ $acw62.createElement("nav", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3t.wrapper, className)
        }, $acw62.Children.map(children2, (child, index2)=>{
            return child ? $acw62.cloneElement(child, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(child.props.className, {
                    [classNameActive ? classNameActive : ""]: classNameActive ?? this.isActive(index2)
                }),
                active: this.isActive(index2),
                onClick: (event2)=>{
                    this.onClick(index2, event2);
                }
            }, child.props.title) : null;
        }));
    }
};
_AsideTabs.Tab = TabItem$1;
let AsideTabs = _AsideTabs;
const block$4 = "Avatar-scss--module__block___jFHeJ";
const avatar$5 = "Avatar-scss--module__avatar___PtfHR";
const defaultAvatar = "Avatar-scss--module__defaultAvatar___09LIo";
const icon$D = "Avatar-scss--module__icon___ehT7Q";
const providerIconContainer = "Avatar-scss--module__providerIconContainer___SVEkc";
const providerIcon = "Avatar-scss--module__providerIcon___Dw1Wh";
const vkIcon = "Avatar-scss--module__vkIcon___9FwDC";
const vkContainer = "Avatar-scss--module__vkContainer___2R5D5";
const googleContainer = "Avatar-scss--module__googleContainer___FJmF2";
const fbIcon = "Avatar-scss--module__fbIcon___2--lW";
const fbContainer = "Avatar-scss--module__fbContainer___PI1l-";
const okIcon = "Avatar-scss--module__okIcon___aP4Xl";
const okContainer = "Avatar-scss--module__okContainer___nyE7X";
const mailIcon = "Avatar-scss--module__mailIcon___2xSOx";
const mailContainer = "Avatar-scss--module__mailContainer___t7-mG";
const youtubeIcon = "Avatar-scss--module__youtubeIcon___nHcO-";
const youtubeContainer = "Avatar-scss--module__youtubeContainer___jMGv-";
const twitchIcon = "Avatar-scss--module__twitchIcon___zjnuE";
const twitchContainer = "Avatar-scss--module__twitchContainer___iBcyw";
const badge$2 = "Avatar-scss--module__badge___A-uzO";
const badgeXXS = "Avatar-scss--module__badgeXXS___ILr-N";
const badgeXS = "Avatar-scss--module__badgeXS___zD7hv";
const badgeS = "Avatar-scss--module__badgeS___XzL9S";
const highlight = "Avatar-scss--module__highlight___-s7rn";
const s$3s = {
    block: block$4,
    avatar: avatar$5,
    defaultAvatar: defaultAvatar,
    icon: icon$D,
    providerIconContainer: providerIconContainer,
    providerIcon: providerIcon,
    vkIcon: vkIcon,
    vkContainer: vkContainer,
    googleContainer: googleContainer,
    fbIcon: fbIcon,
    fbContainer: fbContainer,
    okIcon: okIcon,
    okContainer: okContainer,
    mailIcon: mailIcon,
    mailContainer: mailContainer,
    youtubeIcon: youtubeIcon,
    youtubeContainer: youtubeContainer,
    twitchIcon: twitchIcon,
    twitchContainer: twitchContainer,
    badge: badge$2,
    badgeXXS: badgeXXS,
    badgeXS: badgeXS,
    badgeS: badgeS,
    highlight: highlight
};
const avatarSizes = {
    [EAvatarSize.XXXS]: 16,
    [EAvatarSize.XXS]: 20,
    [EAvatarSize.XXS_OVERSIZE]: 25,
    [EAvatarSize.XS]: 30,
    [EAvatarSize.XS_MIDDLE]: 32,
    [EAvatarSize.XS_OVERSIZE]: 35,
    [EAvatarSize.S_MINUS]: 38,
    [EAvatarSize.S]: 40,
    [EAvatarSize.S_PLUS_EXTRA]: 48,
    [EAvatarSize.S_PLUS]: 42,
    [EAvatarSize.S_OVERSIZE]: 50,
    [EAvatarSize.S_MAX]: 55,
    [EAvatarSize.SM]: 60,
    [EAvatarSize.SM_OVERSIZE]: 65,
    [EAvatarSize.SMM]: 70,
    [EAvatarSize.M_MINUS]: 72,
    [EAvatarSize.M]: 75,
    [EAvatarSize.L]: 80,
    [EAvatarSize.XL]: 84
};
const badgeClassnames = {
    [EAvatarSize.XXXS]: s$3s.badgeXXS,
    [EAvatarSize.XXS]: s$3s.badgeXXS,
    [EAvatarSize.XXS_OVERSIZE]: s$3s.badgeXXS,
    [EAvatarSize.XS]: s$3s.badgeXS,
    [EAvatarSize.XS_MIDDLE]: s$3s.badgeXS,
    [EAvatarSize.XS_OVERSIZE]: s$3s.badgeXS,
    [EAvatarSize.S]: s$3s.badgeS,
    [EAvatarSize.S_PLUS_EXTRA]: s$3s.badgeS,
    [EAvatarSize.S_PLUS]: s$3s.badgeS,
    [EAvatarSize.S_OVERSIZE]: s$3s.badgeS,
    [EAvatarSize.S_MAX]: s$3s.badgeS,
    [EAvatarSize.SM]: s$3s.badgeS,
    [EAvatarSize.SM_OVERSIZE]: s$3s.badgeS,
    [EAvatarSize.SMM]: s$3s.badgeS,
    [EAvatarSize.M_MINUS]: s$3s.badgeS,
    [EAvatarSize.M]: s$3s.badgeS,
    [EAvatarSize.L]: s$3s.badgeS,
    [EAvatarSize.XL]: s$3s.badgeS
};
const icons = {
    [dist$3.ProviderCodes.FB]: {
        glyph: svg_name_social_fb,
        classNameIcon: s$3s.fbIcon,
        classNameContainer: s$3s.fbContainer
    },
    [dist$3.ProviderCodes.Google]: {
        glyph: svg_name_social_google,
        classNameIcon: "",
        classNameContainer: s$3s.googleContainer
    },
    [dist$3.ProviderCodes.Youtube]: {
        glyph: svg_name_social_youtube,
        classNameIcon: s$3s.youtubeIcon,
        classNameContainer: s$3s.youtubeContainer
    },
    [dist$3.ProviderCodes.MailRu]: {
        glyph: svg_name_social_mail,
        classNameIcon: s$3s.mailIcon,
        classNameContainer: s$3s.mailContainer
    },
    [dist$3.ProviderCodes.OK]: {
        glyph: svg_name_social_ok,
        classNameIcon: s$3s.okIcon,
        classNameContainer: s$3s.okContainer
    },
    [dist$3.ProviderCodes.VK]: {
        glyph: svg_name_social_vk,
        classNameIcon: s$3s.vkIcon,
        classNameContainer: s$3s.vkContainer
    },
    [dist$3.ProviderCodes.Twitch]: {
        glyph: svg_name_social_twitch,
        classNameIcon: s$3s.twitchIcon,
        classNameContainer: s$3s.twitchContainer
    }
};
const Avatar = (props)=>{
    const { badge: badge2, img, isHighlighted = false, className, size: size2 = EAvatarSize.S, providerType } = props;
    const avatarSize = avatarSizes[size2];
    const avatarStyles = {
        width: avatarSize,
        height: avatarSize
    };
    const providerName = getProviderCodeBySourceType(providerType);
    const [isError, setIsError] = (0, $acw62.useState)(false);
    const handleError = ()=>{
        setIsError(true);
    };
    const handleLoad = (event2)=>{
        const { currentTarget: { naturalHeight, naturalWidth } } = event2;
        if (naturalHeight === 1 && naturalWidth === 1) setIsError(true);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3s.block, className, (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$3s.highlight]: isHighlighted
        }))
    }, img && !isError && /* @__PURE__ */ $acw62.createElement("img", {
        src: getOptimizedImageUrl({
            url: img,
            width: avatarSize,
            height: avatarSize
        }),
        alt: "avatar",
        className: s$3s.avatar,
        height: avatarSize,
        style: avatarStyles,
        width: avatarSize,
        onError: handleError,
        onLoad: handleLoad
    }), (!img || isError) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$3s.defaultAvatar,
        style: avatarStyles
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_default_avatar,
        className: s$3s.icon
    })), providerName && icons[providerName] && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3s.providerIconContainer, icons[providerName].classNameContainer)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3s.providerIcon, icons[providerName].classNameIcon),
        glyph: icons[providerName].glyph
    })), Boolean(badge2) && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3s.badge, badgeClassnames[size2])
    }, badge2));
};
EAvatarSize.XXXS, EAvatarSize.XXS, EAvatarSize.XXS_OVERSIZE, EAvatarSize.XS, EAvatarSize.XS_MIDDLE, EAvatarSize.XS_OVERSIZE, EAvatarSize.S_MINUS, EAvatarSize.S, EAvatarSize.S_PLUS, EAvatarSize.S_OVERSIZE, EAvatarSize.S_MAX, EAvatarSize.SM, EAvatarSize.SMM, EAvatarSize.M, EAvatarSize.L;
const button$p = "BaseButton-scss--module__button___LAbtI";
const s$3r = {
    button: button$p
};
const BaseButtonWithoutRef = (props)=>{
    const { dataAttributes, innerRef, testId, isDisabled: isDisabled2, children: children2, className, type = EButtonType.BUTTON, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement("button", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3r.button, className),
        disabled: isDisabled2,
        type: type,
        ...restProps,
        ...dataAttributes,
        ...testAttr(testId)
    }, children2);
};
const BaseButton = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(BaseButtonWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const contained = "Button-scss--module__contained___uTh61";
const colorPrimary = "Button-scss--module__colorPrimary___uJ3R-";
const disabled$a = "Button-scss--module__disabled___3t9-7";
const colorSecondary = "Button-scss--module__colorSecondary___W--By";
const colorSecondaryNegative = "Button-scss--module__colorSecondaryNegative___ec7u8";
const colorNegative = "Button-scss--module__colorNegative___XwIyN";
const colorSuccess = "Button-scss--module__colorSuccess___hIN7P";
const root$1X = "Button-scss--module__root___CQyo6";
const sizeSmall = "Button-scss--module__sizeSmall___i7n29";
const sizeMedium = "Button-scss--module__sizeMedium___3pgun";
const sizeLarge = "Button-scss--module__sizeLarge___v-dde";
const fadeIn$8 = "Button-scss--module__fadeIn___iMbgj";
const s$3q = {
    contained: contained,
    colorPrimary: colorPrimary,
    disabled: disabled$a,
    colorSecondary: colorSecondary,
    colorSecondaryNegative: colorSecondaryNegative,
    colorNegative: colorNegative,
    colorSuccess: colorSuccess,
    root: root$1X,
    sizeSmall: sizeSmall,
    sizeMedium: sizeMedium,
    sizeLarge: sizeLarge,
    fadeIn: fadeIn$8
};
const ButtonWithoutRef$1 = (props)=>{
    const { innerRef, className, isDisabled: isDisabled2, variant = "contained", color: color2 = "primary", size: size2 = "large", type = EButtonType.BUTTON, children: children2, ...restProps } = props;
    const classes2 = (0, $acw62.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$3q.contained]: variant === "contained",
            [s$3q.outlined]: variant === "outlined",
            [s$3q.link]: variant === "link",
            [s$3q.disabled]: isDisabled2
        }, s$3q[`size${dist$4.strCapitalize(size2)}`], s$3q[`color${dist$4.strCapitalize(color2)}`]);
    }, [
        size2,
        variant,
        color2,
        isDisabled2
    ]);
    return /* @__PURE__ */ $acw62.createElement("button", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3q.root, className, classes2),
        disabled: isDisabled2,
        type: type,
        ...restProps
    }, children2);
};
const Button$2 = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ButtonWithoutRef$1, {
        innerRef: ref2,
        ...props
    }));
var EContainedButtonBgColor = /* @__PURE__ */ ((EContainedButtonBgColor2)=>{
    EContainedButtonBgColor2["DEFAULT"] = "default";
    EContainedButtonBgColor2["AZURE_RADIANCE"] = "azureRadiance";
    EContainedButtonBgColor2["MAGIC_GREEN"] = "magicGreen";
    EContainedButtonBgColor2["TRANSPARENT"] = "transparent";
    return EContainedButtonBgColor2;
})(EContainedButtonBgColor || {});
const button$o = "ContainedButton-scss--module__button___Dpzfk";
const disabled$9 = "ContainedButton-scss--module__disabled___FWlpR";
const activated$1 = "ContainedButton-scss--module__activated___lThQR";
const withIcon$1 = "ContainedButton-scss--module__withIcon___P0hOc";
const colorDefault = "ContainedButton-scss--module__colorDefault___uZFDD";
const colorMagicGreen = "ContainedButton-scss--module__colorMagicGreen___lUgPi";
const colorTransparent = "ContainedButton-scss--module__colorTransparent___vDBqd";
const s$3p = {
    button: button$o,
    disabled: disabled$9,
    activated: activated$1,
    withIcon: withIcon$1,
    colorDefault: colorDefault,
    colorMagicGreen: colorMagicGreen,
    colorTransparent: colorTransparent
};
const ContainedButton = (props)=>{
    const { withIcon: withIcon2, isActivated, className, bgColor = EContainedButtonBgColor.DEFAULT, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseButton, {
        ...restProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3p.button, className, {
            [s$3p.disabled]: props.isDisabled || props.disabled,
            [s$3p.withIcon]: withIcon2,
            [s$3p.activated]: isActivated,
            [s$3p.colorDefault]: bgColor === EContainedButtonBgColor.DEFAULT,
            [s$3p.colorMagicGreen]: bgColor === EContainedButtonBgColor.MAGIC_GREEN,
            [s$3p.colorTransparent]: bgColor === EContainedButtonBgColor.TRANSPARENT
        })
    }, props.children);
};
const button$n = "OutlinedButton-scss--module__button___urq0Y";
const disabled$8 = "OutlinedButton-scss--module__disabled___XyWT-";
const withIcon = "OutlinedButton-scss--module__withIcon___uoovI";
const s$3o = {
    button: button$n,
    disabled: disabled$8,
    withIcon: withIcon
};
const OutlinedButton = (props)=>{
    const { className, withIcon: withIcon2, isDisabled: isDisabled2, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseButton, {
        ...restProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3o.button, className, {
            [s$3o.disabled]: isDisabled2,
            [s$3o.withIcon]: withIcon2
        })
    }, props.children);
};
const inlineBtn = "InlineButton-scss--module__inlineBtn___lqjbT";
const s$3n = {
    inlineBtn: inlineBtn
};
const InlineButton = ({ dataAttributes, isDisabled: isDisabled2, children: children2, onClick, onMouseDown, className, type = EButtonType.BUTTON, ...props })=>{
    return /* @__PURE__ */ $acw62.createElement("button", {
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3n.inlineBtn, className),
        disabled: isDisabled2,
        onClick: onClick,
        onMouseDown: onMouseDown,
        type: type,
        ...dataAttributes
    }, children2);
};
const button$m = "IconButton-scss--module__button___AexsT";
const disabled$7 = "IconButton-scss--module__disabled___b0-9f";
const activated = "IconButton-scss--module__activated___Swixr";
const buttonMenu = "IconButton-scss--module__buttonMenu___9BE6N";
const buttonInline = "IconButton-scss--module__buttonInline___HI-9m";
const icon$C = "IconButton-scss--module__icon___onNrw";
const s$3m = {
    button: button$m,
    disabled: disabled$7,
    activated: activated,
    buttonMenu: buttonMenu,
    buttonInline: buttonInline,
    icon: icon$C
};
const IconButtonWithoutRef = (props)=>{
    const { classNames, isActivated, innerRef, className, icon: icon2, isDisabled: isDisabled2, title: title2, mode: mode2 = "default", ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseButton, {
        ref: innerRef,
        ...restProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$3m.button]: mode2 === "default",
            [s$3m.buttonInline]: mode2 === "inline",
            [s$3m.buttonMenu]: mode2 === "menu",
            [s$3m.activated]: isActivated,
            [s$3m.disabled]: isDisabled2
        }, className, classNames == null ? void 0 : classNames.button)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: icon2,
        className: s$3m.iconWrapper,
        classNameSvg: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3m.icon, classNames == null ? void 0 : classNames.icon),
        title: title2
    }));
};
$acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(IconButtonWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const TestId = (componentName)=>{
    return (target2)=>{
        target2.prototype.getTestId = getFactoryTestId(componentName);
        return target2;
    };
};
var ETooltipTestId = /* @__PURE__ */ ((ETooltipTestId2)=>{
    ETooltipTestId2["ROOT"] = "ROOT";
    ETooltipTestId2["CONTENT"] = "CONTENT";
    return ETooltipTestId2;
})(ETooltipTestId || {});
var ETooltipTriggers = /* @__PURE__ */ ((ETooltipTriggers2)=>{
    ETooltipTriggers2["HOVER"] = "hover";
    ETooltipTriggers2["CLICK"] = "click";
    return ETooltipTriggers2;
})(ETooltipTriggers || {});
var ETooltipPositions = /* @__PURE__ */ ((ETooltipPositions2)=>{
    ETooltipPositions2["CENTER"] = "center";
    ETooltipPositions2["LEFT"] = "left";
    ETooltipPositions2["RIGHT"] = "right";
    ETooltipPositions2["CENTER_TOP"] = "centerTop";
    ETooltipPositions2["CENTER_BOTTOM"] = "centerBottom";
    ETooltipPositions2["LEFT_TOP"] = "leftTop";
    ETooltipPositions2["RIGHT_TOP"] = "rightTop";
    ETooltipPositions2["CENTER_VIEWPORT"] = "centerViewport";
    ETooltipPositions2["RIGHT_TOP_ALIGNED"] = "rightTopAligned";
    ETooltipPositions2["BOTTOM_RIGHT_ALIGNED"] = "bottomRightAligned";
    return ETooltipPositions2;
})(ETooltipPositions || {});
const useVisibility = (params)=>{
    const { element, container: container2, threshold = 0, thresholds, rootMargin = "0px 0px 0px 0px", debounceTime, lock = false, isEnabled = true } = params;
    const [isVisible, setVisibility] = (0, $acw62.useState)(false);
    const valueRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const debouncedSetVisibility = debounce(setVisibility, debounceTime);
        const setVisibilityState = debounceTime && !lock ? (value2)=>{
            valueRef.current = value2;
            debouncedSetVisibility(valueRef.current);
        } : setVisibility;
        const target2 = element.current;
        const root2 = container2 ? container2.current : window.document;
        if (isEnabled && target2 !== null) {
            const observer = new IntersectionObserver(([entry])=>{
                if (lock) {
                    if (entry.isIntersecting) {
                        setVisibilityState(true);
                        observer.unobserve(target2);
                    }
                } else setVisibilityState(entry.isIntersecting);
            }, {
                root: root2,
                rootMargin: rootMargin,
                threshold: thresholds || threshold
            });
            observer.observe(target2);
            return ()=>{
                observer.unobserve(target2);
            };
        }
        return dist$4.noop;
    }, [
        container2,
        element,
        threshold,
        rootMargin,
        lock,
        thresholds
    ]);
    return isVisible;
};
function useWindowScroll() {
    const [windowScroll, setWindowScroll] = (0, $acw62.useState)({
        y: 0,
        x: 0
    });
    const onScroll = ()=>setWindowScroll({
            x: window.scrollX,
            y: window.scrollY
        });
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("scroll", onScroll);
        onScroll();
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    return windowScroll;
}
function useWindowSize() {
    const [windowSize, setWindowSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const onResize = ()=>setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", onResize);
        window.addEventListener("orientationchange", onResize);
        onResize();
        return ()=>{
            window.removeEventListener("resize", onResize);
            window.removeEventListener("orientationchange", onResize);
        };
    }, []);
    return windowSize;
}
const useAttachFiles = ({ onAttach, isFileValid, acceptedMimetypes })=>{
    const onInputChange = async (event2)=>{
        const [file] = Array.from(event2.target.files);
        if (isFileValid !== void 0) {
            const isValid2 = await isFileValid(file);
            if (isValid2) onAttach([
                file
            ]);
            else removeFile();
        }
    };
    const inputId = (0, $acw62.useRef)();
    const addNewChangeHandler = ()=>{
        const inputElement = document.getElementById(inputId.current);
        inputElement.onchange = (ev)=>{
            onInputChange(ev);
        };
    };
    const createUploadFileInput = ()=>{
        const inputElement = document.createElement("input");
        inputId.current = getRandomStr();
        inputElement.setAttribute("id", inputId.current);
        inputElement.setAttribute("type", "file");
        if (acceptedMimetypes) inputElement.setAttribute("accept", acceptedMimetypes);
        inputElement.style.opacity = "0";
        inputElement.style.position = "fixed";
        inputElement.style.bottom = "0";
        document.body.appendChild(inputElement);
    };
    const removeUploadFileInput = ()=>{
        const inputElement = document.getElementById(inputId.current);
        if (inputElement) inputElement.remove();
        inputId.current = void 0;
    };
    (0, $acw62.useEffect)(()=>()=>{
            removeUploadFileInput();
        }, []);
    const removeFile = ()=>{
        removeUploadFileInput();
    };
    const openAttachDialog = ()=>{
        if (!inputId.current) createUploadFileInput();
        addNewChangeHandler();
        const input2 = document.getElementById(inputId.current);
        input2 == null || input2.click();
    };
    return {
        openAttachDialog: openAttachDialog,
        removeAttachedFile: removeFile
    };
};
const locales$1K = {
    errors: {
        UPLOAD_ERROR: "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u0430\u0439\u043B\u0430 \xab{{fileName}}\xbb \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
        FILE_SIZE_LIMIT: "\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F - {{limit}}",
        IMAGE_WEIGHT_LIMIT: "\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F - {{limit}} px",
        INVALID_FORMAT: "\u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u0430",
        NETWORK_ERROR: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u0441\u0435\u0442\u0438, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435",
        UNKNOWN_ERROR: "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u0430\u0439\u043B\u0430 \xab{{fileName}}\xbb \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
    }
};
const t$1L = distExports$1.getTranslation && locales$1K;
const getUploadImageErrorText = (fileName, errorType)=>{
    const { publisher: { images: { limits: { maxSize, maxWidth, unit } } } } = getConfig();
    let text2 = distExports$1.getParametrizedText(t$1L.errors.UPLOAD_ERROR, {
        fileName: fileName
    });
    switch(errorType){
        case EImageUploaderError.IMAGE_SIZE_LIMIT:
            text2 += ` \u{2014} ${distExports$1.getParametrizedText(t$1L.errors[errorType], {
                limit: getFormattedFileSize(maxSize, unit, EFileSizeUnit.MB)
            })}`;
            break;
        case EImageUploaderError.IMAGE_WIDTH_LIMIT:
            text2 += ` \u{2014} ${distExports$1.getParametrizedText(t$1L.errors[errorType], {
                limit: maxWidth
            })}`;
            break;
        case EImageUploaderError.NETWORK_ERROR:
            text2 += ` \u{2014} ${t$1L.errors[errorType]}`;
            break;
        case EImageUploaderError.INVALID_FORMAT:
            text2 += ` \u{2014} ${t$1L.errors[errorType]}`;
            break;
        case EImageUploaderError.UNKNOWN_ERROR:
            text2 = distExports$1.getParametrizedText(t$1L.errors.UNKNOWN_ERROR, {
                fileName: fileName
            });
            break;
    }
    return text2;
};
const getIsAttachedImageValid = (params)=>async (file)=>{
        const { showAlert, limits: { checkWidth, maxWidth, maxSize, unit } } = params;
        const imageDimensions = await getImageDimensions(file);
        if (checkWidth && (imageDimensions.height >= maxWidth || imageDimensions.width >= maxWidth)) {
            showAlert({
                type: EAlertType.ERROR,
                text: getUploadImageErrorText(file.name, EImageUploaderError.IMAGE_WIDTH_LIMIT),
                isPermanent: true
            });
            return false;
        } else if (getConvertedFileSize(file.size, EFileSizeUnit.B, unit) > maxSize) {
            showAlert({
                type: EAlertType.ERROR,
                text: getUploadImageErrorText(file.name, EImageUploaderError.IMAGE_SIZE_LIMIT),
                isPermanent: true
            });
            return false;
        }
        return true;
    };
const ACCEPTED_MIMETYPES = "image/*";
const useAttachImages = (params)=>{
    const { acceptedMimetypes = ACCEPTED_MIMETYPES, limits = getConfig().publisher.images.limits, uploadsSelector = ()=>({}), showAlert, uploadImage: uploadImage2, onUploadSuccess } = params;
    const [imageUploadIds, setImageUploadIds] = (0, $acw62.useState)([]);
    const mediaDataUploads = (0, $iD0SF.useSelector)(uploadsSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const deleteFile = (uploadId)=>{
        setImageUploadIds(imageUploadIds.filter((id)=>id !== uploadId));
        removeAttachedFile();
    };
    const clearFiles = ()=>{
        setImageUploadIds([]);
        removeAttachedFile();
    };
    const uploadImageToServer = async (file, uploadId)=>{
        try {
            await dispatch(uploadImage2({
                uploadId: uploadId,
                data: file,
                type: EMediaDataType.IMAGE
            }));
            onUploadSuccess == null || onUploadSuccess();
        } catch (err) {
            const error2 = err;
            let errorType = EImageUploaderError.UNKNOWN_ERROR;
            if (!error2.response) errorType = EImageUploaderError.NETWORK_ERROR;
            else {
                const response = error2.response;
                if (response.data.error === "wrong_image_format") errorType = EImageUploaderError.INVALID_FORMAT;
            }
            showAlert({
                type: EAlertType.ERROR,
                text: getUploadImageErrorText(file.name, errorType)
            });
            deleteFile(uploadId);
        }
    };
    const isAttachedImageValid = getIsAttachedImageValid({
        showAlert: showAlert,
        limits: limits
    });
    const onAttach = (files)=>{
        const newImageUploadIds = files.map(()=>getRandomStr());
        setImageUploadIds([
            ...imageUploadIds,
            ...newImageUploadIds
        ]);
        files.forEach((file, i)=>{
            uploadImageToServer(file, newImageUploadIds[i]);
        });
    };
    const { openAttachDialog, removeAttachedFile } = useAttachFiles({
        onAttach: onAttach,
        isFileValid: isAttachedImageValid,
        acceptedMimetypes: acceptedMimetypes
    });
    const images = (0, $acw62.useMemo)(()=>imageUploadIds.map((id)=>{
            const uploadedImage = mediaDataUploads[id];
            if (uploadedImage) return {
                file: uploadedImage.data,
                uploaded: uploadedImage.uploadData,
                status: uploadedImage.meta
            };
            return void 0;
        }).filter((image2)=>Boolean(image2)), [
        mediaDataUploads,
        imageUploadIds
    ]);
    return {
        images: images,
        openAttachDialog: openAttachDialog,
        deleteFile: deleteFile,
        clearFiles: clearFiles
    };
};
function isAttachedImage(image2) {
    return "uploaded" in image2;
}
const ThemeContext = $acw62.createContext({
    theme: EUITheme.SYSTEM,
    setTheme: dist$4.noop
});
const useThemeContext = ()=>$acw62.useContext(ThemeContext);
const Theme = (props)=>{
    const { theme: presetTheme, children: children2 } = props;
    const storedTheme = getCookie(ECookieKey.THEME);
    const { isMobile: isMobile2 } = getConfig();
    const isThemeSwitcherEnabled = isConditionalFeatureEnable(EConditionalFeature.THEME_SWITCHER);
    const defaultTheme = !isThemeSwitcherEnabled || isMobile2 ? EUITheme.DARK : storedTheme || EUITheme.SYSTEM;
    const [theme, setTheme] = (0, $acw62.useState)(presetTheme ?? defaultTheme);
    (0, $acw62.useEffect)(()=>{
        if (storedTheme !== theme) {
            setCookie(ECookieKey.THEME, theme, {
                expires: 3650
            });
            AppStat.log.user.setTheme(theme);
        }
        document.documentElement.className = theme;
    }, [
        theme
    ]);
    return /* @__PURE__ */ $acw62.createElement(ThemeContext.Provider, {
        value: {
            theme: theme,
            setTheme: setTheme
        }
    }, children2);
};
const ThemeProvider = Theme;
const content$f = "TooltipPortal-scss--module__content___AIAHR";
const root$1W = "TooltipPortal-scss--module__root___pqYWP";
const center$1 = "TooltipPortal-scss--module__center___GtXoh";
const right$3 = "TooltipPortal-scss--module__right___95bC8";
const left$4 = "TooltipPortal-scss--module__left___EH1mO";
const leftTop$1 = "TooltipPortal-scss--module__leftTop___8V-Pm";
const centerViewport = "TooltipPortal-scss--module__centerViewport___WIt9Q";
const placeholder$4 = "TooltipPortal-scss--module__placeholder___6H3Sg";
const fadeIn$7 = "TooltipPortal-scss--module__fadeIn___wLmMS";
const s$3l = {
    content: content$f,
    root: root$1W,
    center: center$1,
    right: right$3,
    left: left$4,
    leftTop: leftTop$1,
    centerViewport: centerViewport,
    placeholder: placeholder$4,
    fadeIn: fadeIn$7
};
const stopPropagation = (event2)=>{
    event2.stopPropagation();
};
const TooltipPortal = (props)=>{
    const { classNames, onClickOutSide, onMouseLeave, tooltipRef, align, content: content2, children: children2 } = props;
    const windowScroll = useWindowScroll();
    const windowSize = useWindowSize();
    const { theme } = useThemeContext();
    const { current: tooltipEl } = tooltipRef;
    const { clientWidth, clientHeight } = tooltipEl;
    const { x: leftOffset, y: topOffset } = tooltipEl.getBoundingClientRect();
    const placeholderStyle = (0, $acw62.useMemo)(()=>({
            top: topOffset,
            left: align === ETooltipPositions.CENTER_VIEWPORT ? 0 : leftOffset,
            width: align === ETooltipPositions.CENTER_VIEWPORT ? "100%" : `${clientWidth}px`,
            height: `${clientHeight}px`
        }), [
        windowScroll,
        windowSize
    ]);
    return (0, $1u0KT.createPortal)(/* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.root, s$3l.root, theme),
        onClick: onClickOutSide
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$3l.placeholder,
        style: placeholderStyle,
        onMouseLeave: onMouseLeave
    }, content2, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.content, s$3l.content, s$3l[align]),
        onClick: stopPropagation
    }, children2))), document.getElementById(EPortal.TOOLTIP));
};
const TOOLTIP_TEST_ID$1 = "Tooltip";
const content$e = "Tooltip-scss--module__content___euVVZ";
const root$1V = "Tooltip-scss--module__root___ExwgQ";
const visible$1 = "Tooltip-scss--module__visible___MpaIY";
const byHover = "Tooltip-scss--module__byHover___rZKbR";
const center = "Tooltip-scss--module__center___16seK";
const right$2 = "Tooltip-scss--module__right___MytJU";
const left$3 = "Tooltip-scss--module__left___JkgBq";
const centerTop = "Tooltip-scss--module__centerTop___cW6EV";
const centerBottom = "Tooltip-scss--module__centerBottom___-0BOm";
const leftTop = "Tooltip-scss--module__leftTop___RHg6P";
const rightTop = "Tooltip-scss--module__rightTop___WVdoz";
const rightTopAligned = "Tooltip-scss--module__rightTopAligned___XW9H8";
const bottomRightAligned = "Tooltip-scss--module__bottomRightAligned___RNPxY";
const children$2 = "Tooltip-scss--module__children___xhwtx";
const hidden$2 = "Tooltip-scss--module__hidden___GkwbT";
const fadeIn$6 = "Tooltip-scss--module__fadeIn___AbqYT";
const s$3k = {
    content: content$e,
    root: root$1V,
    visible: visible$1,
    byHover: byHover,
    center: center,
    right: right$2,
    left: left$3,
    centerTop: centerTop,
    centerBottom: centerBottom,
    leftTop: leftTop,
    rightTop: rightTop,
    rightTopAligned: rightTopAligned,
    bottomRightAligned: bottomRightAligned,
    children: children$2,
    hidden: hidden$2,
    fadeIn: fadeIn$6
};
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target2, key, kind)=>{
    var result2 = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target2, key) : target2;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result2 = decorator(result2) || result2;
    return result2;
};
let Tooltip = class extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            isVisible: false
        };
        this.tooltip = $acw62.createRef();
        this.onClick = ()=>{
            if (this.props.trigger === ETooltipTriggers.CLICK) this.setVisibility(true);
        };
        this.onGlobalMouseOver = ()=>{
            if (this.props.trigger === ETooltipTriggers.HOVER && this.props.isGlobal && !this.state.isVisible) this.setVisibility(true);
        };
        this.onGlobalMouseEnter = ()=>{
            if (this.props.trigger === ETooltipTriggers.HOVER && this.props.isGlobal) this.setVisibility(true);
        };
        this.onGlobalMouseLeave = ()=>{
            if (this.props.trigger === ETooltipTriggers.HOVER && this.props.isGlobal) this.setVisibility(false);
        };
        this.onGlobalClickOutSide = (event2)=>{
            event2.stopPropagation();
            if (this.props.trigger === ETooltipTriggers.CLICK) {
                this.setVisibility(false);
                this.props.onClickOutside(event2);
            }
        };
        this.onClickOutside = (event2)=>{
            const { isGlobal } = this.props;
            if (isGlobal || this.tooltip.current && this.tooltip.current.contains(event2.target)) return;
            this.setVisibility(false);
            this.props.onClickOutside(event2);
        };
        this.onKeyUp = (event2)=>{
            if (event2.key === EKeyboardKey.ESCAPE) {
                this.setVisibility(false);
                this.props.onClickOutside(event2);
            }
        };
    }
    componentDidMount() {
        const { isGlobal } = this.props;
        if (!isGlobal) window.addEventListener("click", this.onClickOutside, true);
        window.addEventListener("keyup", this.onKeyUp);
        window.addEventListener("visibilitychange", this.onGlobalMouseLeave);
        window.addEventListener("touchstart", this.onGlobalMouseLeave);
    }
    componentWillUnmount() {
        const { isGlobal } = this.props;
        if (!isGlobal) window.removeEventListener("click", this.onClickOutside, true);
        window.removeEventListener("keyup", this.onKeyUp);
        window.removeEventListener("visibilitychange", this.onGlobalMouseLeave);
        window.removeEventListener("touchstart", this.onGlobalMouseLeave);
    }
    setVisibility(isVisible) {
        if (isVisible) this.props.onTooltipOpen();
        else this.props.onTooltipClose();
        this.setState((state)=>{
            const { isVisible: currentIsVisible } = state;
            if (currentIsVisible !== isVisible) isVisible ? this.props.onDrop() : this.props.onCollapse();
            this.props.onVisibilityChange(isVisible);
            return {
                isVisible: isVisible
            };
        });
    }
    render() {
        const { classNames, content: content2, children: children2, trigger, align, isGlobal } = this.props;
        const { isVisible } = this.state;
        const isPortalMode = Boolean(isGlobal && isVisible && content2);
        return /* @__PURE__ */ $acw62.createElement("div", {
            ref: this.tooltip,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3k.root, classNames.root, {
                [s$3k.byHover]: trigger === ETooltipTriggers.HOVER && !isGlobal,
                [s$3k.visible]: isVisible && !isGlobal
            }),
            onClick: this.onClick,
            onMouseEnter: this.onGlobalMouseEnter,
            onMouseOver: this.onGlobalMouseOver,
            ...testAttr(this.getTestId(ETooltipTestId.ROOT))
        }, content2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3k.content, classNames.content, s$3k[align]),
            ...testAttr(this.getTestId(ETooltipTestId.CONTENT))
        }, content2), isPortalMode && /* @__PURE__ */ $acw62.createElement(TooltipPortal, {
            onMouseLeave: this.onGlobalMouseLeave,
            classNames: classNames,
            onClickOutSide: this.onGlobalClickOutSide,
            tooltipRef: this.tooltip,
            align: align,
            content: children2
        }, content2), /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3k.children, {
                [s$3k.hidden]: isPortalMode
            })
        }, children2));
    }
};
Tooltip.defaultProps = {
    classNames: {},
    trigger: ETooltipTriggers.HOVER,
    align: ETooltipPositions.CENTER,
    isGlobal: false,
    onClickOutside: dist$4.noop,
    onDrop: dist$4.noop,
    onCollapse: dist$4.noop,
    onVisibilityChange: dist$4.noop,
    onTooltipOpen: dist$4.noop,
    onTooltipClose: dist$4.noop
};
Tooltip = __decorateClass$2([
    TestId(TOOLTIP_TEST_ID$1)
], Tooltip);
const container$h = "Dropdown-scss--module__container___NTMmb";
const dropdown = "Dropdown-scss--module__dropdown___LuzmA";
const s$3j = {
    container: container$h,
    dropdown: dropdown
};
class Dropdown extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.state = {
            isActive: false
        };
        this.handleKeyDown = (event2)=>{
            event2.preventDefault();
        };
        this.onButtonClick = (event2)=>{
            event2.stopPropagation();
            event2.preventDefault();
            this.setState((state)=>({
                    ...state,
                    isActive: !state.isActive
                }));
        };
        this.onContainerHide = ()=>this.setState({
                isActive: false
            });
    }
    render() {
        const { isActive } = this.state;
        const { className, classNameButton, classNameContainer, children: children2, button: button2, isShowDropdown, isGlobal, onClickOutside } = this.props;
        const isShow = isShowDropdown ?? isActive;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3j.dropdown, className)
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3j.button, classNameButton),
            onClick: this.onButtonClick
        }, button2), isShow && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3j.container, classNameContainer),
            onKeyDown: this.handleKeyDown
        }, /* @__PURE__ */ $acw62.createElement(Tooltip, {
            onClickOutside: onClickOutside || this.onContainerHide,
            trigger: ETooltipTriggers.CLICK,
            align: ETooltipPositions.RIGHT,
            isGlobal: isGlobal
        }, children2)));
    }
}
const container$g = "DropdownButton-scss--module__container___wHCpX";
const button$l = "DropdownButton-scss--module__button___RTEI0";
const s$3i = {
    container: container$g,
    button: button$l
};
const DropdownButton = (props)=>{
    const { buttonContent, children: children2, className, classNames } = props;
    const { button: buttonClassName } = classNames || {};
    const [isShowDropdown, setIsShowDropdown] = (0, $acw62.useState)(false);
    const buttonDropdownRef = (0, $acw62.useRef)(null);
    const onClose = ()=>{
        setIsShowDropdown(false);
    };
    const handleOutsideDropdown = ()=>{
        if (buttonDropdownRef && !buttonDropdownRef.current.contains(event.target)) setIsShowDropdown(false);
    };
    const handleDropdownClick = ()=>{
        setIsShowDropdown((prevState)=>!prevState);
    };
    return /* @__PURE__ */ $acw62.createElement(Dropdown, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className),
        classNameContainer: s$3i.container,
        isShowDropdown: isShowDropdown,
        onClickOutside: handleOutsideDropdown,
        button: /* @__PURE__ */ $acw62.createElement("button", {
            ref: buttonDropdownRef,
            type: "button",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(buttonClassName, s$3i.button),
            onClick: handleDropdownClick
        }, buttonContent)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        onClick: onClose
    }, children2));
};
const small$3 = "Badge-scss--module__small___8JS0Z";
const medium$3 = "Badge-scss--module__medium___uJyEJ";
const large$3 = "Badge-scss--module__large___ec9RR";
const s$3h = {
    small: small$3,
    medium: medium$3,
    large: large$3
};
const Badge = (props)=>{
    const { classNames = {}, pixelSize: customPixelSize, size: size2, badge: { smallUrl, mediumUrl, largeUrl, name: name2 } } = props;
    const [pixelSize, rootClassName, src2, srcSet] = {
        [EResizableImageSize.SMALL]: [
            "16",
            s$3h.small,
            smallUrl,
            mediumUrl
        ],
        [EResizableImageSize.MEDIUM]: [
            "36",
            s$3h.medium,
            mediumUrl,
            largeUrl
        ],
        [EResizableImageSize.LARGE]: [
            "72",
            s$3h.large,
            largeUrl,
            null
        ],
        [EResizableImageSize.ORIGINAL]: [
            "72",
            s$3h.large,
            largeUrl,
            null
        ]
    }[size2] || [
        "36",
        s$3h.small,
        smallUrl,
        mediumUrl
    ];
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, classNames.root)
    }, /* @__PURE__ */ $acw62.createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3h.image, classNames.image),
        src: src2,
        srcSet: srcSet ? `${srcSet} 2x` : null,
        width: customPixelSize || pixelSize,
        height: customPixelSize || pixelSize,
        alt: name2
    }));
};
const _CheckBoxContainer = class _CheckBoxContainer extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.state = {
            isChecked: this.props.isDefaultChecked
        };
        this.onClick = ()=>{
            const { onToggle, isDisabled: isDisabled2, checked: checked2 } = this.props;
            if (!isDisabled2) {
                if (Object.prototype.hasOwnProperty.call(this.props, "checked")) onToggle(!checked2);
                else this.setState((state)=>({
                        isChecked: !state.isChecked
                    }), ()=>onToggle(this.state.isChecked));
            }
        };
    }
    getCheckedState() {
        if (Object.prototype.hasOwnProperty.call(this.props, "checked")) return this.props.checked;
        return this.state.isChecked;
    }
    render() {
        const { render: render2 } = this.props;
        return /* @__PURE__ */ $acw62.createElement("div", {
            onClick: this.onClick,
            className: this.props.className
        }, render2({
            isChecked: this.getCheckedState()
        }));
    }
};
_CheckBoxContainer.defaultProps = {
    isDefaultChecked: false
};
let CheckBoxContainer = _CheckBoxContainer;
const root$1U = "Link-scss--module__root___Cg1A8";
const link$3 = "Link-scss--module__link___inWRp";
const handler = "Link-scss--module__handler___nplVF";
const s$3g = {
    root: root$1U,
    link: link$3,
    handler: handler
};
const LinkWithoutRef = (props)=>{
    const { className, shouldStyleAsLink = true, to, withHandlerRouting, onClick, innerRef, state = {}, ...restProps } = props;
    const { isError } = getConfig();
    const isExternalLink = /^(https?:\/\/|mailto:|javascript:)/.test(String(to));
    const isSimpleLink = isExternalLink || isError;
    const navigate = (value2)=>{
        document.location.href = value2;
    };
    const { pathname } = window.location;
    const stateLink = {
        ...state,
        previousLocationPath: pathname
    };
    const goTo = (event2)=>{
        onClick == null || onClick(event2);
        if (!to) return;
        navigate(to);
    };
    return !to || withHandlerRouting ? /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3g.root, {
            [s$3g.link]: shouldStyleAsLink,
            [s$3g.handler]: withHandlerRouting
        }, className),
        ref: innerRef,
        ...restProps,
        onClick: goTo
    }, restProps.children) : isSimpleLink ? /* @__PURE__ */ $acw62.createElement("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3g.root, {
            [s$3g.link]: shouldStyleAsLink
        }, className),
        ref: innerRef,
        ...restProps,
        href: String(to)
    }, restProps.children) : /* @__PURE__ */ $acw62.createElement(Link$1, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3g.root, {
            [s$3g.link]: shouldStyleAsLink
        }, className),
        to: to,
        ref: innerRef,
        ...restProps,
        onClick: onClick,
        state: stateLink
    }, restProps.children);
};
const Link = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(LinkWithoutRef, {
        innerRef: ref2,
        ...props
    }));
function hasWindow() {
    return typeof window !== "undefined";
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value2) {
    if (!hasWindow()) return false;
    return value2 instanceof Node || value2 instanceof getWindow(value2).Node;
}
function isElement(value2) {
    if (!hasWindow()) return false;
    return value2 instanceof Element || value2 instanceof getWindow(value2).Element;
}
function isHTMLElement(value2) {
    if (!hasWindow()) return false;
    return value2 instanceof HTMLElement || value2 instanceof getWindow(value2).HTMLElement;
}
function isShadowRoot(value2) {
    if (!hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value2 instanceof ShadowRoot || value2 instanceof getWindow(value2).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow: overflow2, overflowX, overflowY, display: display2 } = getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow2 + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display2);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e2) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value2)=>(css.willChange || "").includes(value2)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value2)=>(css.contain || "").includes(value2));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    const result2 = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result2) ? result2.host : result2;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
    var _node$ownerDocument2;
    if (list2 === void 0) list2 = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function activeElement(doc) {
    let activeElement2 = doc.activeElement;
    while(((_activeElement = activeElement2) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement2 = activeElement2.shadowRoot.activeElement;
    }
    return activeElement2;
}
function contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    if (parent.contains(child)) return true;
    if (rootNode && isShadowRoot(rootNode)) {
        let next2 = child;
        while(next2){
            if (parent === next2) return true;
            next2 = next2.parentNode || next2.host;
        }
    }
    return false;
}
function getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand, version: version2 } = _ref;
        return brand + "/" + version2;
    }).join(" ");
    return navigator.userAgent;
}
function isVirtualClick(event2) {
    if (event2.mozInputSource === 0 && event2.isTrusted) return true;
    if (isAndroid() && event2.pointerType) return event2.type === "click" && event2.buttons === 1;
    return event2.detail === 0 && !event2.pointerType;
}
function isVirtualPointerEvent(event2) {
    if (isJSDOM()) return false;
    return !isAndroid() && event2.width === 0 && event2.height === 0 || isAndroid() && event2.width === 1 && event2.height === 1 && event2.pressure === 0 && event2.detail === 0 && event2.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event2.width < 1 && event2.height < 1 && event2.pressure === 0 && event2.detail === 0 && event2.pointerType === "touch";
}
function isSafari() {
    return /apple/i.test(navigator.vendor);
}
function isAndroid() {
    const re = /android/i;
    return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
    return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
    return getUserAgent().includes("jsdom/");
}
function isMouseLikePointerType(pointerType, strict) {
    const values2 = [
        "mouse",
        "pen"
    ];
    if (!strict) values2.push("", void 0);
    return values2.includes(pointerType);
}
function isReactEvent(event2) {
    return "nativeEvent" in event2;
}
function isRootElement(element) {
    return element.matches("html,body");
}
function getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event2, node) {
    if (node == null) return false;
    if ("composedPath" in event2) return event2.composedPath().includes(node);
    const e2 = event2;
    return e2.target != null && node.contains(e2.target);
}
function getTarget(event2) {
    if ("composedPath" in event2) return event2.composedPath()[0];
    return event2.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
    return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event2) {
    event2.preventDefault();
    event2.stopPropagation();
}
function isTypeableCombobox(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}
const sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const min = Math.min;
const max$1 = Math.max;
const round = Math.round;
const floor$1 = Math.floor;
const createCoords = (v2)=>({
        x: v2,
        y: v2
    });
const oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value2, end) {
    return max$1(start, min(value2, end));
}
function evaluate(value2, param) {
    return typeof value2 === "function" ? value2(param) : value2;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction2, rtl) {
    const alignment = getAlignment(placement);
    let list2 = getSideList(getSide(placement), direction2 === "start", rtl);
    if (alignment) {
        list2 = list2.map((side)=>side + "-" + alignment);
        if (flipAlignment) list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
    return list2;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x: x2, y: y2, width, height } = rect;
    return {
        width: width,
        height: height,
        top: y2,
        left: x2,
        right: x2 + width,
        bottom: y2 + height,
        x: x2,
        y: y2
    };
}
/*!
* tabbable 6.0.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content2 = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content2, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a2, b2) {
    return a2.tabIndex === b2.tabIndex ? a2.documentOrder - b2.documentOrder : a2.tabIndex - b2.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r2 = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r2;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name2) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name2 + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked2 = getCheckedRadio(radioSet, node.form);
    return !checked2 || checked2 === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
    var _nodeRootHost;
    var nodeRootHost = getRootNode(node).host;
    var attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && _nodeRootHost.ownerDocument.contains(nodeRootHost) || node.ownerDocument.contains(node));
    while(!attached && nodeRootHost){
        var _nodeRootHost2;
        nodeRootHost = getRootNode(nodeRootHost).host;
        attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && _nodeRootHost2.ownerDocument.contains(nodeRootHost));
    }
    return attached;
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (isNodeAttached(node)) return !node.getClientRects().length;
        if (displayCheck !== "legacy-full") return true;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item2, i) {
        var isScope = !!item2.scopeParent;
        var element = isScope ? item2.scopeParent : item2;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item2.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item2,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = getSideAxis(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const alignLength = getAxisLength(alignmentAxis);
    const side = getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch(getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
const computePosition$1 = async (reference, floating, config2)=>{
    const { placement = "bottom", strategy = "absolute", middleware = [], platform: platform2 } = config2;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
    let rects = await platform2.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x2, y: y2 } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name2, fn: fn2 } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset: reset2 } = await fn2({
            x: x2,
            y: y2,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform2,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x2 = nextX != null ? nextX : x2;
        y2 = nextY != null ? nextY : y2;
        middlewareData = {
            ...middlewareData,
            [name2]: {
                ...middlewareData[name2],
                ...data
            }
        };
        if (reset2 && resetCount <= 50) {
            resetCount++;
            if (typeof reset2 === "object") {
                if (reset2.placement) statefulPlacement = reset2.placement;
                if (reset2.rects) rects = reset2.rects === true ? await platform2.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset2.rects;
                ({ x: x2, y: y2 } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x2,
        y: y2,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x2, y: y2, platform: platform2, rects, elements, strategy } = state;
    const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = evaluate(options, state);
    const paddingObject = getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
        element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x2,
        y: y2,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
    const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const flip$2 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform: platform2, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = evaluate(options, state);
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = getSide(placement);
            const initialSideAxis = getSideAxis(initialPlacement);
            const isBasePlacement = getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                getOppositePlacement(initialPlacement)
            ] : getExpandedPlacements(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow2 = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow2[side]);
            if (checkCrossAxis) {
                const sides2 = getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow2[sides2[0]], overflow2[sides2[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            if (!overflows.every((side2)=>side2 <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2)=>d2.overflows[0] <= 0).sort((a2, b2)=>a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = getSideAxis(d2.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d2)=>[
                                    d2.placement,
                                    d2.overflows.filter((overflow3)=>overflow3 > 0).reduce((acc, overflow3)=>acc + overflow3, 0)
                                ]).sort((a2, b2)=>a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement2) resetPlacement = placement2;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow2, rect) {
    return {
        top: overflow2.top - rect.height,
        right: overflow2.right - rect.width,
        bottom: overflow2.bottom - rect.height,
        left: overflow2.left - rect.width
    };
}
function isAnySideFullyClipped(overflow2) {
    return sides.some((side)=>overflow2[side] >= 0);
}
const hide$2 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects } = state;
            const { strategy = "referenceHidden", ...detectOverflowOptions } = evaluate(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow2 = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = getSideOffsets(overflow2, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow2 = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow2, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
async function convertValueToCoords(state, options) {
    const { placement, platform: platform2, elements } = state;
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate(options, state);
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
const offset$3 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x2, y: y2, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x2 + diffCoords.x,
                y: y2 + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
const shift$2 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x2, y: y2, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x: x3, y: y3 } = _ref;
                    return {
                        x: x3,
                        y: y3
                    };
                }
            }, ...detectOverflowOptions } = evaluate(options, state);
            const coords = {
                x: x2,
                y: y2
            };
            const overflow2 = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = getSideAxis(getSide(placement));
            const mainAxis = getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min2 = mainAxisCoord + overflow2[minSide];
                const max2 = mainAxisCoord - overflow2[maxSide];
                mainAxisCoord = clamp(min2, mainAxisCoord, max2);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min2 = crossAxisCoord + overflow2[minSide];
                const max2 = crossAxisCoord - overflow2[maxSide];
                crossAxisCoord = clamp(min2, crossAxisCoord, max2);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x2,
                    y: limitedCoords.y - y2,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
const size$2 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform: platform2, elements } = state;
            const { apply: apply2 = ()=>{}, ...detectOverflowOptions } = evaluate(options, state);
            const overflow2 = await detectOverflow(state, detectOverflowOptions);
            const side = getSide(placement);
            const alignment = getAlignment(placement);
            const isYAxis = getSideAxis(placement) === "y";
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow2.top - overflow2.bottom;
            const maximumClippingWidth = width - overflow2.left - overflow2.right;
            const overflowAvailableHeight = min(height - overflow2[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = min(width - overflow2[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = max$1(overflow2.left, 0);
                const xMax = max$1(overflow2.right, 0);
                const yMin = max$1(overflow2.top, 0);
                const yMax = max$1(overflow2.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow2.left, overflow2.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow2.top, overflow2.bottom));
            }
            await apply2({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform2.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
function getCssDimensions(element) {
    const css = getComputedStyle$1(element);
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!isHTMLElement(domElement)) return createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x2 = ($ ? round(rect.width) : rect.width) / width;
    let y2 = ($ ? round(rect.height) : rect.height) / height;
    if (!x2 || !Number.isFinite(x2)) x2 = 1;
    if (!y2 || !Number.isFinite(y2)) y2 = 1;
    return {
        x: x2,
        y: y2
    };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
    const win = getWindow(element);
    if (!isWebKit() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if (isElement(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
    let x2 = (clientRect.left + visualOffsets.x) / scale.x;
    let y2 = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = getWindow(domElement);
        const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = getFrameElement(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle$1(currentIFrame);
            const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x2 *= iframeScale.x;
            y2 *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x2 += left2;
            y2 += top2;
            currentWin = getWindow(currentIFrame);
            currentIFrame = getFrameElement(currentWin);
        }
    }
    return rectToClientRect({
        width: width,
        height: height,
        x: x2,
        y: y2
    });
}
function getWindowScrollBarX(element, rect) {
    const leftScroll = getNodeScroll(element).scrollLeft;
    if (!rect) return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect));
    const y2 = htmlRect.top + scroll.scrollTop;
    return {
        x: x2,
        y: y2
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = getDocumentElement(offsetParent);
    const topLayer = elements ? isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = createCoords(1);
    const offsets = createCoords(0);
    const isOffsetParentAnElement = isHTMLElement(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isHTMLElement(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
    const html = getDocumentElement(element);
    const scroll = getNodeScroll(element);
    const body2 = element.ownerDocument.body;
    const width = max$1(html.scrollWidth, html.clientWidth, body2.scrollWidth, body2.clientWidth);
    const height = max$1(html.scrollHeight, html.clientHeight, body2.scrollHeight, body2.clientHeight);
    let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y2 = -scroll.scrollTop;
    if (getComputedStyle$1(body2).direction === "rtl") x2 += max$1(html.clientWidth, body2.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x2,
        y: y2
    };
}
function getViewportRect(element, strategy) {
    const win = getWindow(element);
    const html = getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x2 = 0;
    let y2 = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x2 = visualViewport.offsetLeft;
            y2 = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x2,
        y: y2
    };
}
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    const top2 = clientRect.top + element.clientTop;
    const left2 = clientRect.left + element.clientLeft;
    const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x2 = left2 * scale.x;
    const y2 = top2 * scale.y;
    return {
        width: width,
        height: height,
        x: x2,
        y: y2
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect(getDocumentElement(element));
    else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = getParentNode(element);
    if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
    return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result2 = getOverflowAncestors(element, [], false).filter((el)=>isElement(el) && getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = getComputedStyle$1(element).position === "fixed";
    let currentNode = elementIsFixed ? getParentNode(element) : element;
    while(isElement(currentNode) && !isLastTraversableNode(currentNode)){
        const computedStyle = getComputedStyle$1(currentNode);
        const currentNodeIsContaining = isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) result2 = result2.filter((ancestor)=>ancestor !== currentNode);
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = getParentNode(currentNode);
    }
    cache.set(element, result2);
    return result2;
}
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = max$1(rect.top, accRect.top);
        accRect.right = min(rect.right, accRect.right);
        accRect.bottom = min(rect.bottom, accRect.bottom);
        accRect.left = max$1(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = isHTMLElement(offsetParent);
    const documentElement = getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
    const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x2,
        y: y2,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill2) {
    if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill2) return polyfill2(element);
    let rawOffsetParent = element.offsetParent;
    if (getDocumentElement(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
function getOffsetParent(element, polyfill2) {
    const win = getWindow(element);
    if (isTopLayer(element)) return win;
    if (!isHTMLElement(element)) {
        let svgOffsetParent = getParentNode(element);
        while(svgOffsetParent && !isLastTraversableNode(svgOffsetParent)){
            if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = getParentNode(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill2);
    while(offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill2);
    if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) return win;
    return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: getDocumentElement,
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: isElement,
    isRTL: isRTL
};
function observeMove(element, onMove) {
    let io = null;
    let timeoutId2;
    const root2 = getDocumentElement(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId2);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left2, top: top2, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = floor$1(top2);
        const insetRight = floor$1(root2.clientWidth - (left2 + width));
        const insetBottom = floor$1(root2.clientHeight - (top2 + height));
        const insetLeft = floor$1(left2);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: max$1(0, min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio2 = entries[0].intersectionRatio;
            if (ratio2 !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio2) timeoutId2 = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1e3);
                else refresh(false, ratio2);
            }
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root2.ownerDocument
            });
        } catch (e2) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
function autoUpdate(reference, floating, update2, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? getOverflowAncestors(referenceEl) : [],
        ...getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update2, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update2);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update2) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update2();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update2();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update2();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update2);
            ancestorResize && ancestor.removeEventListener("resize", update2);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
const offset$2 = offset$3;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const hide$1 = hide$2;
const computePosition = (reference, floating, options)=>{
    const cache = /* @__PURE__ */ new Map();
    const mergedOptions = {
        platform: platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return computePosition$1(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
var index$2 = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function deepEqual(a2, b2) {
    if (a2 === b2) return true;
    if (typeof a2 !== typeof b2) return false;
    if (typeof a2 === "function" && a2.toString() === b2.toString()) return true;
    let length;
    let i;
    let keys3;
    if (a2 && b2 && typeof a2 === "object") {
        if (Array.isArray(a2)) {
            length = a2.length;
            if (length !== b2.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a2[i], b2[i])) return false;
            }
            return true;
        }
        keys3 = Object.keys(a2);
        length = keys3.length;
        if (length !== Object.keys(b2).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b2, keys3[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys3[i];
            if (key === "_owner" && a2.$$typeof) continue;
            if (!deepEqual(a2[key], b2[key])) return false;
        }
        return true;
    }
    return a2 !== a2 && b2 !== b2;
}
function getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value2) {
    const dpr = getDPR(element);
    return Math.round(value2 * dpr) / dpr;
}
function useLatestRef$1(value2) {
    const ref2 = $acw62.useRef(value2);
    index$2(()=>{
        ref2.current = value2;
    });
    return ref2;
}
function useFloating$1(options) {
    if (options === void 0) options = {};
    const { placement = "bottom", strategy = "absolute", middleware = [], platform: platform2, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform2 = true, whileElementsMounted, open: open2 } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
    const platformRef = useLatestRef$1(platform2);
    const openRef = useLatestRef$1(open2);
    const update2 = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config2 = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config2.platform = platformRef.current;
        computePosition(referenceRef.current, floatingRef.current, config2).then((data2)=>{
            const fullData = {
                ...data2,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index$2(()=>{
        if (open2 === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data2)=>({
                    ...data2,
                    isPositioned: false
                }));
        }
    }, [
        open2
    ]);
    const isMountedRef = $acw62.useRef(false);
    index$2(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    index$2(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update2);
            update2();
        }
    }, [
        referenceEl,
        floatingEl,
        update2,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x2 = roundByDPR(elements.floating, data.x);
        const y2 = roundByDPR(elements.floating, data.y);
        if (transform2) return {
            ...initialStyles,
            transform: "translate(" + x2 + "px, " + y2 + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x2,
            top: y2
        };
    }, [
        strategy,
        transform2,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update2,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update2,
        refs,
        elements,
        floatingStyles
    ]);
}
const offset$1 = (options, deps)=>({
        ...offset$2(options),
        options: [
            options,
            deps
        ]
    });
const shift = (options, deps)=>({
        ...shift$1(options),
        options: [
            options,
            deps
        ]
    });
const flip = (options, deps)=>({
        ...flip$1(options),
        options: [
            options,
            deps
        ]
    });
const size = (options, deps)=>({
        ...size$1(options),
        options: [
            options,
            deps
        ]
    });
const hide = (options, deps)=>({
        ...hide$1(options),
        options: [
            options,
            deps
        ]
    });
function useMergeRefs(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref2)=>ref2 == null)) return null;
        return (value2)=>{
            refs.forEach((ref2)=>{
                if (typeof ref2 === "function") ref2(value2);
                else if (ref2 != null) ref2.current = value2;
            });
        };
    }, refs);
}
const SafeReact = {
    ...$acw62
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn2)=>fn2());
function useEffectEvent(callback) {
    const ref2 = $acw62.useRef(()=>{});
    useSafeInsertionEffect(()=>{
        ref2.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref2.current == null ? void 0 : ref2.current(...args);
    }, []);
}
const ARROW_UP = "ArrowUp";
const ARROW_DOWN = "ArrowDown";
const ARROW_LEFT = "ArrowLeft";
const ARROW_RIGHT = "ArrowRight";
function isDifferentRow(index2, cols, prevRow) {
    return Math.floor(index2 / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index2) {
    return index2 < 0 || index2 >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function getMaxIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function findNonDisabledIndex(listRef, _temp) {
    let { startingIndex = -1, decrement = false, disabledIndices, amount = 1 } = _temp === void 0 ? {} : _temp;
    const list2 = listRef.current;
    let index2 = startingIndex;
    do index2 += decrement ? -amount : amount;
    while (index2 >= 0 && index2 <= list2.length - 1 && isDisabled(list2, index2, disabledIndices));
    return index2;
}
function getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event2, orientation, loop, rtl, cols, disabledIndices, minIndex, maxIndex, prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event2.key === ARROW_UP) {
        stop && stopEvent(event2);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset2 = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset2 : offset2 - cols;
            }
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event2.key === ARROW_DOWN) {
        stop && stopEvent(event2);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (orientation === "both") {
        const prevRow = floor$1(prevIndex / cols);
        if (event2.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
            stop && stopEvent(event2);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event2.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
            stop && stopEvent(event2);
            if (prevIndex % cols !== 0) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = floor$1(maxIndex / cols) === prevRow;
        if (isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event2.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
function buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index2)=>{
        let { width, height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j2 = 0; j2 < height; j2++)targetCells.push(startIndex + i + j2 * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell2)=>cellMap[cell2] == null)) {
                targetCells.forEach((cell2)=>{
                    cellMap[cell2] = index2;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    return [
        ...cellMap
    ];
}
function getCellIndexOfCorner(index2, sizes, cellMap, cols, corner) {
    if (index2 === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index2);
    const sizeItem = sizes[index2];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index2);
    }
}
function getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index2, cellIndex)=>indices.includes(index2) ? [
            cellIndex
        ] : []);
}
function isDisabled(list2, index2, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index2);
    const element = list2[index2];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
var index$1 = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function _extends$1() {
    _extends$1 = Object.assign ? Object.assign.bind() : function(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
        }
        return target2;
    };
    return _extends$1.apply(this, arguments);
}
let serverHandoffComplete = false;
let count$3 = 0;
const genId = ()=>// Ensure the id is unique with multiple independent versions of Floating UI
    // on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + count$3++;
function useFloatingId() {
    const [id, setId] = $acw62.useState(()=>serverHandoffComplete ? genId() : void 0);
    index$1(()=>{
        if (id == null) setId(genId());
    }, []);
    $acw62.useEffect(()=>{
        serverHandoffComplete = true;
    }, []);
    return id;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
let devMessageSet;
function warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages2 = new Array(_len), _key = 0; _key < _len; _key++)messages2[_key] = arguments[_key];
    const message2 = "Floating UI: " + messages2.join(" ");
    if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message2))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message2);
        console.warn(message2);
    }
}
function error$5() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages2[_key2] = arguments[_key2];
    const message2 = "Floating UI: " + messages2.join(" ");
    if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message2))) {
        var _devMessageSet4;
        (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message2);
        console.error(message2);
    }
}
function createPubSub() {
    const map = /* @__PURE__ */ new Map();
    return {
        emit (event2, data) {
            var _map$get;
            (_map$get = map.get(event2)) == null || _map$get.forEach((handler2)=>handler2(data));
        },
        on (event2, listener) {
            map.set(event2, [
                ...map.get(event2) || [],
                listener
            ]);
        },
        off (event2, listener) {
            var _map$get2;
            map.set(event2, ((_map$get2 = map.get(event2)) == null ? void 0 : _map$get2.filter((l2)=>l2 !== listener)) || []);
        }
    };
}
const FloatingNodeContext = /* @__PURE__ */ $acw62.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ $acw62.createContext(null);
const useFloatingParentNodeId = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = ()=>$acw62.useContext(FloatingTreeContext);
function createAttribute(name2) {
    return "data-floating-ui-" + name2;
}
function useLatestRef(value2) {
    const ref2 = (0, $acw62.useRef)(value2);
    index$1(()=>{
        ref2.current = value2;
    });
    return ref2;
}
const safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(value2, prop, pointerType) {
    if (pointerType && !isMouseLikePointerType(pointerType)) return 0;
    if (typeof value2 === "number") return value2;
    return value2 == null ? void 0 : value2[prop];
}
function useHover(context, props) {
    if (props === void 0) props = {};
    const { open: open2, onOpenChange, dataRef, events, elements } = context;
    const { enabled = true, delay: delay2 = 0, handleClose = null, mouseOnly = false, restMs = 0, move = true } = props;
    const tree = useFloatingTree();
    const parentId = useFloatingParentNodeId();
    const handleCloseRef = useLatestRef(handleClose);
    const delayRef = useLatestRef(delay2);
    const openRef = useLatestRef(open2);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const restTimeoutPendingRef = $acw62.useRef(false);
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange2(_ref) {
            let { open: open3 } = _ref;
            if (!open3) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange2);
        return ()=>{
            events.off("openchange", onOpenChange2);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open2) return;
        function onLeave(event2) {
            if (isHoverOpen()) onOpenChange(false, event2, "hover");
        }
        const html = getDocument(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open2,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event2, runElseBranch, reason2) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason2 === void 0) reason2 = "hover";
        const closeDelay = getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event2, reason2), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event2, reason2);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = void 0;
    });
    const clearPointerEvents = useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body2 = getDocument(elements.floating).body;
            body2.style.pointerEvents = "";
            body2.removeAttribute(safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            "click",
            "mousedown"
        ].includes(dataRef.current.openEvent.type) : false;
    });
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event2) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, "open")) return;
            const openDelay = getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event2, "hover");
            }, openDelay);
            else if (!open2) onOpenChange(true, event2, "hover");
        }
        function onMouseLeave(event2) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = getDocument(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                if (!open2) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event2.clientX,
                    y: event2.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event2, true, "safe-polygon");
                    }
                });
                const handler2 = handlerRef.current;
                doc.addEventListener("mousemove", handler2);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler2);
                };
                return;
            }
            const shouldClose = pointerTypeRef.current === "touch" ? !contains(elements.floating, event2.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event2);
        }
        function onScrollMouseLeave(event2) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event2.clientX,
                y: event2.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event2);
                }
            })(event2);
        }
        if (isElement(elements.domReference)) {
            var _elements$floating;
            const ref2 = elements.domReference;
            open2 && ref2.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref2.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref2.addEventListener("mouseenter", onMouseEnter);
            ref2.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open2 && ref2.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref2.removeEventListener("mousemove", onMouseEnter);
                ref2.removeEventListener("mouseenter", onMouseEnter);
                ref2.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open2,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    index$1(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open2 && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if (isElement(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body2 = getDocument(elements.floating).body;
                body2.setAttribute(safePolygonIdentifier, "");
                const ref2 = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body2.style.pointerEvents = "none";
                ref2.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body2.style.pointerEvents = "";
                    ref2.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open2,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    index$1(()=>{
        if (!open2) {
            pointerTypeRef.current = void 0;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open2,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event2) {
            pointerTypeRef.current = event2.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event2) {
                const { nativeEvent } = event2;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current)) return;
                if (open2 || restMs === 0) return;
                if (restTimeoutPendingRef.current && event2.movementX ** 2 + event2.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open2,
        openRef,
        restMs
    ]);
    const floating = $acw62.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event2) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event2.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
let rafId = 0;
function enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll = false, cancelPrevious = true, sync = false } = options;
    cancelPrevious && cancelAnimationFrame(rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else rafId = requestAnimationFrame(exec);
}
function getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n2)=>{
                var _node$context2;
                return node.parentId === n2.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children2 = getChildren(nodes, nodeId);
        children2.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
let counterMap = /* @__PURE__ */ new WeakMap();
let uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const unwrapHost = (node)=>node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets)=>targets.map((target2)=>{
        if (parent.contains(target2)) return target2;
        const correctedTarget = unwrapHost(target2);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x2)=>x2 != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body2, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = correctElements(body2, uncorrectedAvoidElements);
    const elementsToKeep = /* @__PURE__ */ new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!markerMap[markerName]) markerMap[markerName] = /* @__PURE__ */ new WeakMap();
    const markerCounter = markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body2);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if (getNodeName(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr2 = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr2 !== null && attr2 !== "false";
                const currentCounterValue = counterMap.get(node) || 0;
                const counterValue = controlAttribute ? currentCounterValue + 1 : currentCounterValue;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = controlAttribute ? currentCounterValue - 1 : currentCounterValue;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        lockCount$1--;
        if (!lockCount$1) {
            counterMap = /* @__PURE__ */ new WeakMap();
            counterMap = /* @__PURE__ */ new WeakMap();
            uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
            markerMap = {};
        }
    };
}
function markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body2 = getDocument(avoidElements[0]).body;
    return applyAttributeToOthers(avoidElements.concat(Array.from(body2.querySelectorAll("[aria-live]"))), body2, ariaHidden, inert);
}
const getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function getTabbableIn(container2, direction2) {
    const allTabbable = tabbable(container2, getTabbableOptions());
    if (direction2 === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf(activeElement(getDocument(container2)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function getNextTabbable() {
    return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
    return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event2, container2) {
    const containerElement = container2 || event2.currentTarget;
    const relatedTarget = event2.relatedTarget;
    return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container2) {
    const tabbableElements = tabbable(container2, getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function enableFocusInside(container2) {
    const elements = container2.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
const HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let timeoutId;
function setActiveElementOnTab(event2) {
    if (event2.key === "Tab") {
        event2.target;
        clearTimeout(timeoutId);
    }
}
const FocusGuard = /* @__PURE__ */ $acw62.forwardRef(function FocusGuard2(props, ref2) {
    const [role2, setRole2] = $acw62.useState();
    index$1(()=>{
        if (isSafari()) setRole2("button");
        document.addEventListener("keydown", setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref2,
        tabIndex: 0,
        // Role is only for VoiceOver
        role: role2,
        "aria-hidden": role2 ? void 0 : true,
        [createAttribute("focus-guard")]: "",
        style: HIDDEN_STYLES
    };
    return /* @__PURE__ */ $acw62.createElement("span", _extends$1({}, props, restProps));
});
const PortalContext = /* @__PURE__ */ $acw62.createContext(null);
const attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(props) {
    if (props === void 0) props = {};
    const { id, root: root2 } = props;
    const uniqueId2 = useId();
    const portalContext = usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    index$1(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    index$1(()=>{
        if (!uniqueId2) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId2;
        subRoot.setAttribute(attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId2
    ]);
    index$1(()=>{
        if (root2 === null) return;
        if (!uniqueId2) return;
        if (portalNodeRef.current) return;
        let container2 = root2 || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container2 && !isElement(container2)) container2 = container2.current;
        container2 = container2 || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container2.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId2;
        subRoot.setAttribute(attr, "");
        container2 = idWrapper || container2;
        container2.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root2,
        uniqueId2,
        portalContext
    ]);
    return portalNode;
}
function FloatingPortal(props) {
    const { children: children2, id, root: root2, preserveTabOrder = true } = props;
    const portalNode = useFloatingPortalNode({
        id: id,
        root: root2
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal2 = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open2 = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root2 || portalNode);
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal2) return;
        function onFocus(event2) {
            if (portalNode && isOutsideEvent(event2)) {
                const focusing = event2.type === "focusin";
                const manageFocus = focusing ? enableFocusInside : disableFocusInside;
                manageFocus(portalNode);
            }
        }
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal2
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open2) return;
        enableFocusInside(portalNode);
    }, [
        open2,
        portalNode
    ]);
    return /* @__PURE__ */ $acw62.createElement(PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /* @__PURE__ */ $acw62.createElement(FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event2)=>{
            if (isOutsideEvent(event2, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /* @__PURE__ */ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: HIDDEN_STYLES
    }), portalNode && /* @__PURE__ */ $1u0KT.createPortal(children2, portalNode), shouldRenderGuards && portalNode && /* @__PURE__ */ $acw62.createElement(FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event2)=>{
            if (isOutsideEvent(event2, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event2.nativeEvent, "focus-out"));
            }
        }
    }));
}
const usePortalContext = ()=>$acw62.useContext(PortalContext);
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
    previouslyFocusedElements = previouslyFocusedElements.filter((el)=>el.isConnected);
    if (element && getNodeName(element) !== "body") {
        previouslyFocusedElements.push(element);
        if (previouslyFocusedElements.length > LIST_LIMIT) previouslyFocusedElements = previouslyFocusedElements.slice(-20);
    }
}
function getPreviouslyFocusedElement() {
    return previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
function getFirstTabbableElement(container2) {
    const tabbableOptions = getTabbableOptions();
    if (isTabbable(container2, tabbableOptions)) return container2;
    return tabbable(container2, tabbableOptions)[0] || container2;
}
const VisuallyHiddenDismiss = /* @__PURE__ */ $acw62.forwardRef(function VisuallyHiddenDismiss2(props, ref2) {
    return /* @__PURE__ */ $acw62.createElement("button", _extends$1({}, props, {
        type: "button",
        ref: ref2,
        tabIndex: -1,
        style: HIDDEN_STYLES
    }));
});
function FloatingFocusManager(props) {
    const { context, children: children2, disabled: disabled2 = false, order = [
        "content"
    ], guards: _guards = true, initialFocus = 0, returnFocus = true, restoreFocus = false, modal: modal2 = true, visuallyHiddenDismiss = false, closeOnFocusOut = true, outsideElementsInert = false } = props;
    const { open: open2, refs, nodeId, onOpenChange, events, dataRef, elements: { domReference, floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;
    const inertSupported = supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = useLatestRef(order);
    const initialFocusRef = useLatestRef(initialFocus);
    const returnFocusRef = useLatestRef(returnFocus);
    const tree = useFloatingTree();
    const portalContext = usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = getFloatingFocusElement(floating);
    const getTabbableContent = useEffectEvent(function(container2) {
        if (container2 === void 0) container2 = floatingFocusElement;
        return container2 ? tabbable(container2, getTabbableOptions()) : [];
    });
    const getTabbableElements = useEffectEvent((container2)=>{
        const content2 = getTabbableContent(container2);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content2;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        if (disabled2) return;
        if (!modal2) return;
        function onKeyDown(event2) {
            if (event2.key === "Tab") {
                if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) stopEvent(event2);
                const els = getTabbableElements();
                const target2 = getTarget(event2);
                if (orderRef.current[0] === "reference" && target2 === domReference) {
                    stopEvent(event2);
                    if (event2.shiftKey) enqueueFocus(els[els.length - 1]);
                    else enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target2 === floatingFocusElement && event2.shiftKey) {
                    stopEvent(event2);
                    enqueueFocus(els[0]);
                }
            }
        }
        const doc = getDocument(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled2,
        domReference,
        floatingFocusElement,
        modal2,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled2) return;
        if (!floating) return;
        function handleFocusIn(event2) {
            const target2 = getTarget(event2);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target2);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled2,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled2) return;
        if (!closeOnFocusOut) return;
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event2) {
            const relatedTarget = event2.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        getFloatingFocusElement((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
                    if (isHTMLElement(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if (isHTMLElement(nodeToFocus)) nodeToFocus.focus();
                }
                if ((isUntrappedTypeableCombobox ? true : !modal2) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event2, "focus-out");
                }
            });
        }
        if (floating && isHTMLElement(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled2,
        domReference,
        floating,
        floatingFocusElement,
        modal2,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    const beforeGuardRef = $acw62.useRef(null);
    const afterGuardRef = $acw62.useRef(null);
    const mergedBeforeGuardRef = useMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = useMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled2) return;
        if (!floating) return;
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
        const ancestorFloatingNodes = tree && !modal2 ? getAncestors(tree == null ? void 0 : tree.nodesRef.current, nodeId).map((node)=>{
            var _node$context6;
            return (_node$context6 = node.context) == null ? void 0 : _node$context6.elements.floating;
        }) : [];
        const insideElements = [
            floating,
            ...portalNodes,
            ...ancestorFloatingNodes,
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x2)=>x2 != null);
        const cleanup = modal2 || isUntrappedTypeableCombobox ? markOthers(insideElements, !useInert, useInert) : markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled2,
        domReference,
        floating,
        modal2,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        nodeId
    ]);
    index$1(()=>{
        if (disabled2 || !isHTMLElement(floatingFocusElement)) return;
        const doc = getDocument(floatingFocusElement);
        const previouslyFocusedElement = activeElement(doc);
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open2) enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled2,
        open2,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    index$1(()=>{
        if (disabled2 || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = getDocument(floatingFocusElement);
        const previouslyFocusedElement = activeElement(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        addPreviouslyFocusedElement(previouslyFocusedElement);
        function onOpenChange2(_ref) {
            let { open: open3, reason: reason2, event: event2, nested } = _ref;
            if (open3) openEvent = event2;
            if (reason2 === "escape-key" && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            if ([
                "hover",
                "safe-polygon"
            ].includes(reason2) && event2.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason2 !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !(isVirtualClick(event2) || isVirtualPointerEvent(event2));
        }
        events.on("openchange", onOpenChange2);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === "boolean") return getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off("openchange", onOpenChange2);
            const activeEl = activeElement(doc);
            const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context7;
                return contains((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                const tabbableReturnElement = getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled2,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $acw62.useEffect(()=>{
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled2
    ]);
    index$1(()=>{
        if (disabled2) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal2,
            closeOnFocusOut: closeOnFocusOut,
            open: open2,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled2,
        portalContext,
        modal2,
        open2,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    index$1(()=>{
        if (disabled2) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = activeElement(getDocument(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled2,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location2) {
        if (disabled2 || !visuallyHiddenDismiss || !modal2) return null;
        return /* @__PURE__ */ $acw62.createElement(VisuallyHiddenDismiss, {
            ref: location2 === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event2)=>onOpenChange(false, event2.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled2 && guards && (modal2 ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal2);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /* @__PURE__ */ $acw62.createElement(FocusGuard, {
        "data-type": "inside",
        ref: mergedBeforeGuardRef,
        onFocus: (event2)=>{
            if (modal2) {
                const els = getTabbableElements();
                enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if (isOutsideEvent(event2, portalContext.portalNode)) {
                    const nextTabbable = getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children2, renderDismissButton("end"), shouldRenderGuards && /* @__PURE__ */ $acw62.createElement(FocusGuard, {
        "data-type": "inside",
        ref: mergedAfterGuardRef,
        onFocus: (event2)=>{
            if (modal2) enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if (isOutsideEvent(event2, portalContext.portalNode)) {
                    const prevTabbable = getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
function isButtonTarget(event2) {
    return isHTMLElement(event2.target) && event2.target.tagName === "BUTTON";
}
function isSpaceIgnored(element) {
    return isTypeableElement(element);
}
function useClick(context, props) {
    if (props === void 0) props = {};
    const { open: open2, onOpenChange, dataRef, elements: { domReference } } = context;
    const { enabled = true, event: eventOption = "click", toggle = true, ignoreMouse = false, keyboardHandlers = true, stickIfOpen = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event2) {
                pointerTypeRef.current = event2.pointerType;
            },
            onMouseDown (event2) {
                const pointerType = pointerTypeRef.current;
                if (event2.button !== 0) return;
                if (eventOption === "click") return;
                if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
                if (open2 && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event2.nativeEvent, "click");
                else {
                    event2.preventDefault();
                    onOpenChange(true, event2.nativeEvent, "click");
                }
            },
            onClick (event2) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = void 0;
                    return;
                }
                if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
                if (open2 && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event2.nativeEvent, "click");
                else onOpenChange(true, event2.nativeEvent, "click");
            },
            onKeyDown (event2) {
                pointerTypeRef.current = void 0;
                if (event2.defaultPrevented || !keyboardHandlers || isButtonTarget(event2)) return;
                if (event2.key === " " && !isSpaceIgnored(domReference)) {
                    event2.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event2.key === "Enter") {
                    if (open2 && toggle) onOpenChange(false, event2.nativeEvent, "click");
                    else onOpenChange(true, event2.nativeEvent, "click");
                }
            },
            onKeyUp (event2) {
                if (event2.defaultPrevented || !keyboardHandlers || isButtonTarget(event2) || isSpaceIgnored(domReference)) return;
                if (event2.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open2 && toggle) onOpenChange(false, event2.nativeEvent, "click");
                    else onOpenChange(true, event2.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open2,
        stickIfOpen,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
function useDismiss(context, props) {
    if (props === void 0) props = {};
    const { open: open2, onOpenChange, elements, dataRef } = context;
    const { enabled = true, escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent = "pointerdown", referencePress = false, referencePressEvent = "pointerdown", ancestorScroll = false, bubbles, capture } = props;
    const tree = useFloatingTree();
    const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = normalizeProp(capture);
    const isComposingRef = $acw62.useRef(false);
    const closeOnEscapeKeyDown = useEffectEvent((event2)=>{
        var _dataRef$current$floa;
        if (!open2 || !enabled || !escapeKey || event2.key !== "Escape") return;
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children2 = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event2.stopPropagation();
            if (children2.length > 0) {
                let shouldDismiss = true;
                children2.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, isReactEvent(event2) ? event2.nativeEvent : event2, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = useEffectEvent((event2)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event2);
            (_getTarget = getTarget(event2)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = getTarget(event2)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = useEffectEvent((event2)=>{
        var _dataRef$current$floa2;
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event2)) return;
        const target2 = getTarget(event2);
        const inertSelector = "[" + createAttribute("inert") + "]";
        const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = isElement(target2) ? target2 : null;
        while(targetRootAncestor && !isLastTraversableNode(targetRootAncestor)){
            const nextParent = getParentNode(targetRootAncestor);
            if (isLastTraversableNode(nextParent) || !isElement(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        if (markers.length && isElement(target2) && !isRootElement(target2) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !contains(target2, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!contains(targetRootAncestor, marker))) return;
        if (isHTMLElement(target2) && floating) {
            const lastTraversableNode = isLastTraversableNode(target2);
            const style = getComputedStyle$1(target2);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target2.clientWidth > 0 && target2.scrollWidth > target2.clientWidth;
            const canScrollY = isScrollableY && target2.clientHeight > 0 && target2.scrollHeight > target2.clientHeight;
            const isRTL2 = style.direction === "rtl";
            const pressedVerticalScrollbar = canScrollY && (isRTL2 ? event2.offsetX <= target2.offsetWidth - target2.clientWidth : event2.offsetX > target2.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event2.offsetY > target2.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return isEventTargetWithin(event2, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if (isEventTargetWithin(event2, elements.floating) || isEventTargetWithin(event2, elements.domReference) || targetIsInsideChildren) return;
        const children2 = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (children2.length > 0) {
            let shouldDismiss = true;
            children2.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event2, "outside-press");
    });
    const closeOnPressOutsideCapture = useEffectEvent((event2)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event2);
            (_getTarget3 = getTarget(event2)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = getTarget(event2)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open2 || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event2) {
            onOpenChange(false, event2, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            isWebKit() ? 5 : 0);
        }
        const doc = getDocument(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if (isElement(elements.domReference)) ancestors = getOverflowAncestors(elements.domReference);
            if (isElement(elements.floating)) ancestors = ancestors.concat(getOverflowAncestors(elements.floating));
            if (!isElement(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat(getOverflowAncestors(elements.reference.contextElement));
        }
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open2,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [bubbleHandlerKeys[referencePressEvent]]: (event2)=>{
                    onOpenChange(false, event2.nativeEvent, "reference-press");
                },
                ...referencePressEvent !== "click" && {
                    onClick (event2) {
                        onOpenChange(false, event2.nativeEvent, "reference-press");
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function useFloatingRootContext(options) {
    const { open: open2 = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = useId();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>createPubSub());
    const nested = useFloatingParentNodeId() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = useEffectEvent((open3, event2, reason2)=>{
        dataRef.current.openEvent = open3 ? event2 : void 0;
        events.emit("openchange", {
            open: open3,
            event: event2,
            reason: reason2,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open3, event2, reason2);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open2,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open2,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
function useFloating(options) {
    if (options === void 0) options = {};
    const { nodeId } = options;
    const internalRootContext = useFloatingRootContext({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = useFloatingTree();
    index$1(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position2 = useFloating$1({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = isElement(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        _setPositionReference(computedPositionReference);
        position2.refs.setReference(computedPositionReference);
    }, [
        position2.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if (isElement(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        if (isElement(position2.refs.reference.current) || position2.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !isElement(node)) position2.refs.setReference(node);
    }, [
        position2.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position2.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position2.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position2.elements,
            domReference: domReference
        }), [
        position2.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position2,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position2,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    index$1(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node2)=>node2.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position2,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position2,
        refs,
        elements,
        context
    ]);
}
function useFocus(context, props) {
    if (props === void 0) props = {};
    const { open: open2, onOpenChange, events, dataRef, elements } = context;
    const { enabled = true, visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = getWindow(elements.domReference);
        function onBlur() {
            if (!open2 && isHTMLElement(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open2,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange2(_ref) {
            let { reason: reason2 } = _ref;
            if (reason2 === "reference-press" || reason2 === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange2);
        return ()=>{
            events.off("openchange", onOpenChange2);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event2) {
                if (isVirtualPointerEvent(event2.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event2) {
                if (blockFocusRef.current) return;
                const target2 = getTarget(event2.nativeEvent);
                if (visibleOnly && isElement(target2)) try {
                    if (isSafari() && isMac()) throw Error();
                    if (!target2.matches(":focus-visible")) return;
                } catch (e2) {
                    if (!keyboardModalityRef.current && !isTypeableElement(target2)) return;
                }
                onOpenChange(true, event2.nativeEvent, "focus");
            },
            onBlur (event2) {
                blockFocusRef.current = false;
                const relatedTarget = event2.relatedTarget;
                const nativeEvent = event2.nativeEvent;
                const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const ACTIVE_KEY = "active";
const SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
    const map = /* @__PURE__ */ new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [ACTIVE_KEY]: _2, [SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value2)=>{
            const propsOrGetProps = value2 ? value2[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value2] = _ref;
                if (isItem && [
                    ACTIVE_KEY,
                    SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value2 === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value2);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn2)=>fn2(...args)).find((val)=>val !== void 0);
                        };
                    }
                } else acc[key] = value2;
            });
            return acc;
        }, {})
    };
}
function useInteractions(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
function doSwitch(orientation, vertical, horizontal2) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal2;
        default:
            return vertical || horizontal2;
    }
}
function isMainOrientationKey(key, orientation) {
    const vertical = key === ARROW_UP || key === ARROW_DOWN;
    const horizontal2 = key === ARROW_LEFT || key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal2);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === ARROW_DOWN;
    const horizontal2 = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal2) || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    const horizontal2 = key === ARROW_DOWN;
    return doSwitch(orientation, vertical, horizontal2);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
    const horizontal2 = key === ARROW_UP;
    return doSwitch(orientation, vertical, horizontal2);
}
function useListNavigation(context, props) {
    const { open: open2, onOpenChange, elements } = context;
    const { listRef, activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled = true, selectedIndex = null, allowEscape = false, loop = false, nested = false, rtl = false, virtual = false, focusItemOnOpen = "auto", focusItemOnHover = true, openOnArrowKeyDown = true, disabledIndices, orientation = "vertical", cols = 1, scrollItemIntoView = true, virtualItemRef, itemSizes, dense = false } = props;
    const floatingFocusElement = getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = useLatestRef(floatingFocusElement);
    const parentId = useFloatingParentNodeId();
    const tree = useFloatingTree();
    const onNavigate = useEffectEvent(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = isTypeableCombobox(elements.domReference);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open2);
    const forceSyncFocusRef = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = useLatestRef(disabledIndices);
    const latestOpenRef = useLatestRef(open2);
    const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
    const selectedIndexRef = useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = useEffectEvent(()=>{
        function runFocus(item3) {
            if (virtual) {
                setActiveId(item3.id);
                tree == null || tree.events.emit("virtualfocus", item3);
                if (virtualItemRef) virtualItemRef.current = item3;
            } else enqueueFocus(item3, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v2)=>v2() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item2 && (forceScrollIntoViewRef.current || !isPointerModalityRef.current);
            if (shouldScrollIntoView) waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    index$1(()=>{
        if (!enabled) return;
        if (open2 && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open2,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    index$1(()=>{
        if (!enabled) return;
        if (!open2) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open2,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    index$1(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = activeElement(getDocument(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && contains(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    index$1(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item3) {
            setVirtualId(item3.id);
            if (virtualItemRef) virtualItemRef.current = item3;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    index$1(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open2;
        previousMountedRef.current = !!elements.floating;
    });
    index$1(()=>{
        if (!open2) keyRef.current = null;
    }, [
        open2
    ]);
    const hasActiveIndex = activeIndex != null;
    const item2 = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open2) return;
            const index2 = listRef.current.indexOf(currentTarget);
            if (index2 !== -1 && indexRef.current !== index2) {
                indexRef.current = index2;
                onNavigate();
            }
        }
        const props2 = {
            onFocus (_ref) {
                let { currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget } = _ref3;
                    forceSyncFocusRef.current = true;
                    forceScrollIntoViewRef.current = false;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    forceSyncFocusRef.current = true;
                    indexRef.current = -1;
                    onNavigate();
                    if (!virtual) {
                        var _floatingFocusElement;
                        (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                            preventScroll: true
                        });
                    }
                }
            }
        };
        return props2;
    }, [
        open2,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = useEffectEvent((event2)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        if (event2.which === 229) return;
        if (!latestOpenRef.current && event2.currentTarget === floatingFocusElementRef.current) return;
        if (nested && isCrossOrientationCloseKey(event2.key, orientation, rtl)) {
            stopEvent(event2);
            onOpenChange(false, event2.nativeEvent, "list-navigation");
            if (isHTMLElement(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit("virtualfocus", elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = getMinIndex(listRef, disabledIndices);
        const maxIndex = getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event2.key === "Home") {
                stopEvent(event2);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event2.key === "End") {
                stopEvent(event2);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            const cellMap = buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index3)=>index3 != null && !isDisabled(listRef.current, index3, disabledIndices));
            const maxGridIndex = cellMap.reduce((foundIndex, index3, cellIndex)=>index3 != null && !isDisabled(listRef.current, index3, disabledIndices) ? cellIndex : foundIndex, -1);
            const index2 = cellMap[getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event2,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: getCellIndices([
                    ...disabledIndices || listRef.current.map((_2, index3)=>isDisabled(listRef.current, index3) ? index3 : void 0),
                    void 0
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event2.key === ARROW_DOWN ? "bl" : event2.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index2 != null) {
                indexRef.current = index2;
                onNavigate();
            }
            if (orientation === "both") return;
        }
        if (isMainOrientationKey(event2.key, orientation)) {
            stopEvent(event2);
            if (open2 && !virtual && activeElement(event2.currentTarget.ownerDocument) === event2.currentTarget) {
                indexRef.current = isMainOrientationToEndKey(event2.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if (isMainOrientationToEndKey(event2.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if (isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open2 && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open2,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? void 0 : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event2) {
            if (focusItemOnOpen === "auto" && isVirtualClick(event2.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event2) {
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && isVirtualPointerEvent(event2.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event2) {
                isPointerModalityRef.current = false;
                const isArrowKey = event2.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event2.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = isCrossOrientationOpenKey(event2.key, orientation, rtl);
                const isCrossCloseKey = isCrossOrientationCloseKey(event2.key, orientation, rtl);
                const isMainKey = isMainOrientationKey(event2.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event2.key === "Enter" || event2.key.trim() === "";
                if (virtual && open2) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event2.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event2.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item3)=>(item3 == null ? void 0 : item3.id) === activeId) : null;
                            if (dispatchItem) {
                                stopEvent(event2);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(void 0);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event2.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                stopEvent(event2);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event2);
                }
                if (!open2 && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event2.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        stopEvent(event2);
                        if (open2) {
                            indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event2.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    stopEvent(event2);
                    if (!open2 && openOnArrowKeyDown) onOpenChange(true, event2.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event2);
                    if (open2) onNavigate();
                }
            },
            onFocus () {
                if (open2 && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open2,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item2
        } : {}, [
        enabled,
        reference,
        floating,
        item2
    ]);
}
const componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
function useRole(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open2, floatingId } = context;
    const { enabled = true, role: role2 = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role2)) != null ? _componentRoleToAriaR : role2;
    const referenceId = useId();
    const parentId = useFloatingParentNodeId();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === "tooltip" || role2 === "label") return {
            ["aria-" + (role2 === "label" ? "labelledby" : "describedby")]: open2 ? floatingId : void 0
        };
        return {
            "aria-expanded": open2 ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open2 ? floatingId : void 0,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role2 === "select" && {
                "aria-autocomplete": "none"
            },
            ...role2 === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open2,
        referenceId,
        role2
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role2 === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role2
    ]);
    const item2 = $acw62.useCallback((_ref)=>{
        let { active: active2, selected: selected2 } = _ref;
        const commonProps = {
            role: "option",
            ...active2 && {
                id: floatingId + "-option"
            }
        };
        switch(role2){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active2 && selected2
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active2 && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role2
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item2
        } : {}, [
        enabled,
        reference,
        floating,
        item2
    ]);
}
var ETooltipFloatingTestId = /* @__PURE__ */ ((ETooltipFloatingTestId2)=>{
    ETooltipFloatingTestId2["ROOT"] = "ROOT";
    ETooltipFloatingTestId2["CONTENT"] = "CONTENT";
    return ETooltipFloatingTestId2;
})(ETooltipFloatingTestId || {});
var ETooltipTrigger = /* @__PURE__ */ ((ETooltipTrigger2)=>{
    ETooltipTrigger2["HOVER"] = "hover";
    ETooltipTrigger2["CLICK"] = "click";
    return ETooltipTrigger2;
})(ETooltipTrigger || {});
var ETooltipPosition = /* @__PURE__ */ ((ETooltipPosition2)=>{
    ETooltipPosition2["TOP"] = "top";
    ETooltipPosition2["RIGHT"] = "right";
    ETooltipPosition2["LEFT"] = "left";
    ETooltipPosition2["BOTTOM"] = "bottom";
    ETooltipPosition2["TOP_START"] = "top-start";
    ETooltipPosition2["TOP_END"] = "top-end";
    ETooltipPosition2["RIGHT_START"] = "right-start";
    ETooltipPosition2["RIGHT_END"] = "right-end";
    ETooltipPosition2["BOTTOM_START"] = "bottom-start";
    ETooltipPosition2["BOTTOM_END"] = "bottom-end";
    ETooltipPosition2["LEFT_START"] = "left-start";
    ETooltipPosition2["LEFT_END"] = "left-end";
    return ETooltipPosition2;
})(ETooltipPosition || {});
var ETooltipCloseStrategy = /* @__PURE__ */ ((ETooltipCloseStrategy2)=>{
    ETooltipCloseStrategy2["OUTSIDE_CLICK"] = "outside-click";
    ETooltipCloseStrategy2["OUTSIDE_CLICK_CLOSE_BUTTON"] = "outside-click-close-button";
    return ETooltipCloseStrategy2;
})(ETooltipCloseStrategy || {});
var ETooltipStrategyType = /* @__PURE__ */ ((ETooltipStrategyType2)=>{
    ETooltipStrategyType2["ABSOLUTE"] = "absolute";
    ETooltipStrategyType2["FIXED"] = "fixed";
    return ETooltipStrategyType2;
})(ETooltipStrategyType || {});
const TOOLTIP_TEST_ID = "Tooltip";
const root$1T = "TooltipContent-scss--module__root___lZXov";
const s$3f = {
    root: root$1T
};
const getTestId$5 = getFactoryTestId(TOOLTIP_TEST_ID);
const TooltipContent = (props)=>{
    const { floatingRef, position: position2, top: top2 = 0, left: left2 = 0, floatingProps, className, children: children2, styles = {} } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: floatingRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3f.root, className),
        style: {
            position: position2,
            top: top2,
            left: left2,
            ...styles
        },
        ...floatingProps,
        ...testAttr(getTestId$5(ETooltipFloatingTestId.CONTENT))
    }, children2);
};
const TooltipContext = (0, $acw62.createContext)({
    handleCloseClick: noop$2
});
const root$1S = "TooltipFloating-scss--module__root___mOZiY";
const closeButton$2 = "TooltipFloating-scss--module__closeButton___6Xdjc";
const content$d = "TooltipFloating-scss--module__content___ICv55";
const s$3e = {
    root: root$1S,
    closeButton: closeButton$2,
    content: content$d
};
const getTestId$4 = getFactoryTestId(TOOLTIP_TEST_ID);
const TooltipFloatingWithoutRef = (props, ref2)=>{
    var _a3;
    const { className, closeStrategy = ETooltipCloseStrategy.OUTSIDE_CLICK, content: content2, children: children2, delay: delay2 = 0, offset: offsetValue = 5, shiftPadding = 15, flipPadding = 5, trigger: triggerProp, position: position2 = ETooltipPosition.BOTTOM, strategyType = ETooltipStrategyType.ABSOLUTE, isGlobal, isDisabled: isDisabled2, hideAfter, classNames = {}, shouldPreventDefault = false, withParentWidth, styles, onHandleClose, onToggleOpen } = props;
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)();
    const tooltipRef = (0, $acw62.useRef)();
    const handleToggleOpen = (isOpened)=>{
        setIsOpen(isOpened);
        if (onToggleOpen) onToggleOpen(isOpened);
    };
    const { isMobile: isMobile2 } = getConfig();
    const trigger = triggerProp || (isMobile2 ? ETooltipTrigger.CLICK : ETooltipTrigger.HOVER);
    const { theme } = useThemeContext();
    const { x: x2, y: y2, refs, strategy, context, middlewareData } = useFloating({
        open: !isDisabled2 && isOpen,
        onOpenChange: handleToggleOpen,
        placement: position2,
        strategy: strategyType,
        whileElementsMounted: autoUpdate,
        middleware: [
            flip({
                padding: flipPadding
            }),
            offset$1(offsetValue),
            shift({
                padding: shiftPadding
            }),
            hide(),
            withParentWidth && size({
                apply (args) {
                    Object.assign(args.elements.floating.style, {
                        maxWidth: `${Math.max(0, args.rects.reference.width)}px`
                    });
                }
            })
        ].filter(Boolean)
    });
    (0, $acw62.useImperativeHandle)(ref2, ()=>({
            close: ()=>setIsOpen(false)
        }));
    (0, $acw62.useEffect)(()=>{
        var _a4;
        if (!hideAfter) return noop$2;
        const reference = refs.reference;
        const handleLeave = ()=>{
            var _a5, _b2, _c2, _d;
            (_a5 = reference.current) == null || _a5.removeEventListener("mouseleave", handleLeave);
            (_b2 = reference.current) == null || _b2.addEventListener("mouseenter", handleEnter);
            (_c2 = tooltipRef.current) == null || _c2.removeEventListener("mouseleave", handleLeave);
            (_d = tooltipRef.current) == null || _d.addEventListener("mouseenter", handleEnter);
            timerRef.current = setTimeout(()=>{
                timerRef.current = null;
                setIsOpen(false);
            }, hideAfter);
        };
        const handleEnter = ()=>{
            var _a5, _b2, _c2, _d;
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            (_a5 = tooltipRef.current) == null || _a5.removeEventListener("mouseenter", handleEnter);
            (_b2 = tooltipRef.current) == null || _b2.addEventListener("mouseleave", handleLeave);
            (_c2 = reference.current) == null || _c2.removeEventListener("mouseenter", handleEnter);
            (_d = reference.current) == null || _d.addEventListener("mouseleave", handleLeave);
        };
        if (isOpen) (_a4 = reference.current) == null || _a4.addEventListener("mouseleave", handleLeave);
        return ()=>{
            var _a5, _b2, _c2, _d;
            (_a5 = tooltipRef.current) == null || _a5.removeEventListener("mouseenter", handleEnter);
            (_b2 = tooltipRef.current) == null || _b2.removeEventListener("mouseleave", handleLeave);
            (_c2 = reference.current) == null || _c2.removeEventListener("mouseenter", handleEnter);
            (_d = reference.current) == null || _d.removeEventListener("mouseleave", handleLeave);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [
        isOpen
    ]);
    const handleClose = (hoverContext)=>{
        onHandleClose && onHandleClose(hoverContext);
        return (event2)=>{};
    };
    handleClose.__options = {
        blockPointerEvents: false
    };
    const hover = useHover(context, {
        restMs: delay2,
        move: false,
        enabled: trigger === ETooltipTrigger.HOVER,
        ...onHandleClose ? {
            handleClose: handleClose
        } : {}
    });
    const click = useClick(context, {
        enabled: trigger === ETooltipTrigger.CLICK
    });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role2 = useRole(context, {
        role: "tooltip"
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        click,
        focus,
        dismiss,
        role2
    ]);
    const handleClick = (event2)=>{
        if (shouldPreventDefault) {
            event2.stopPropagation();
            event2.preventDefault();
        }
    };
    const handleCloseClick = ()=>{
        setIsOpen(false);
    };
    $acw62.useEffect(()=>{
        var _a4;
        if ((_a4 = middlewareData.hide) == null ? void 0 : _a4.referenceHidden) handleToggleOpen(false);
    }, [
        (_a3 = middlewareData == null ? void 0 : middlewareData.hide) == null ? void 0 : _a3.referenceHidden
    ]);
    const getContent = ()=>/* @__PURE__ */ $acw62.createElement(TooltipContent, {
            floatingRef: refs.setFloating,
            floatingProps: getFloatingProps(),
            position: strategy,
            top: y2,
            left: x2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3e.content, classNames.content),
            styles: styles
        }, closeStrategy === ETooltipCloseStrategy.OUTSIDE_CLICK_CLOSE_BUTTON && /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_close,
            className: s$3e.closeButton,
            onClick: handleCloseClick
        }), /* @__PURE__ */ $acw62.createElement(TooltipContext.Provider, {
            value: {
                handleCloseClick: handleCloseClick
            }
        }, content2));
    const shouldShowTooltip = !isDisabled2 && isOpen && content2;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3e.root, className, classNames.root, {
            [classNames.rootWithTooltip]: shouldShowTooltip
        }),
        ...testAttr(getTestId$4(ETooltipFloatingTestId.ROOT)),
        onClick: handleClick
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: classNames.contentWrapper,
        ref: refs.setReference,
        ...getReferenceProps()
    }, children2), isGlobal && /* @__PURE__ */ $acw62.createElement(FloatingPortal, {
        id: EPortal.FLOATING_TOOLTIP
    }, shouldShowTooltip && /* @__PURE__ */ $acw62.createElement("div", {
        className: theme,
        ref: tooltipRef
    }, getContent())), !isGlobal && shouldShowTooltip && getContent());
};
const TooltipFloating = (0, $acw62.forwardRef)(TooltipFloatingWithoutRef);
var entry_nostyle = {};
var Calendar = {};
var propTypes$1 = {
    exports: {}
};
var reactIs = {
    exports: {}
};
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
    if (hasRequiredReactIs_production_min) return reactIs_production_min;
    hasRequiredReactIs_production_min = 1;
    var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e2 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
    function z2(a2) {
        if ("object" === typeof a2 && null !== a2) {
            var u2 = a2.$$typeof;
            switch(u2){
                case c2:
                    switch(a2 = a2.type, a2){
                        case l2:
                        case m2:
                        case e2:
                        case g2:
                        case f2:
                        case p2:
                            return a2;
                        default:
                            switch(a2 = a2 && a2.$$typeof, a2){
                                case k2:
                                case n2:
                                case t2:
                                case r2:
                                case h2:
                                    return a2;
                                default:
                                    return u2;
                            }
                    }
                case d2:
                    return u2;
            }
        }
    }
    function A2(a2) {
        return z2(a2) === m2;
    }
    reactIs_production_min.AsyncMode = l2;
    reactIs_production_min.ConcurrentMode = m2;
    reactIs_production_min.ContextConsumer = k2;
    reactIs_production_min.ContextProvider = h2;
    reactIs_production_min.Element = c2;
    reactIs_production_min.ForwardRef = n2;
    reactIs_production_min.Fragment = e2;
    reactIs_production_min.Lazy = t2;
    reactIs_production_min.Memo = r2;
    reactIs_production_min.Portal = d2;
    reactIs_production_min.Profiler = g2;
    reactIs_production_min.StrictMode = f2;
    reactIs_production_min.Suspense = p2;
    reactIs_production_min.isAsyncMode = function(a2) {
        return A2(a2) || z2(a2) === l2;
    };
    reactIs_production_min.isConcurrentMode = A2;
    reactIs_production_min.isContextConsumer = function(a2) {
        return z2(a2) === k2;
    };
    reactIs_production_min.isContextProvider = function(a2) {
        return z2(a2) === h2;
    };
    reactIs_production_min.isElement = function(a2) {
        return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
    };
    reactIs_production_min.isForwardRef = function(a2) {
        return z2(a2) === n2;
    };
    reactIs_production_min.isFragment = function(a2) {
        return z2(a2) === e2;
    };
    reactIs_production_min.isLazy = function(a2) {
        return z2(a2) === t2;
    };
    reactIs_production_min.isMemo = function(a2) {
        return z2(a2) === r2;
    };
    reactIs_production_min.isPortal = function(a2) {
        return z2(a2) === d2;
    };
    reactIs_production_min.isProfiler = function(a2) {
        return z2(a2) === g2;
    };
    reactIs_production_min.isStrictMode = function(a2) {
        return z2(a2) === f2;
    };
    reactIs_production_min.isSuspense = function(a2) {
        return z2(a2) === p2;
    };
    reactIs_production_min.isValidElementType = function(a2) {
        return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m2 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
    };
    reactIs_production_min.typeOf = z2;
    return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredReactIs_development;
function requireReactIs_development() {
    if (hasRequiredReactIs_development) return reactIs_development;
    hasRequiredReactIs_development = 1;
    return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
    if (hasRequiredReactIs) return reactIs.exports;
    hasRequiredReactIs = 1;
    reactIs.exports = requireReactIs_production_min();
    return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
    if (hasRequiredObjectAssign) return objectAssign;
    hasRequiredObjectAssign = 1;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
        if (val === null || val === void 0) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
    }
    function shouldUseNative() {
        try {
            if (!Object.assign) return false;
            var test1 = new String("abc");
            test1[5] = "de";
            if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
            var test2 = {};
            for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
            var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
                return test2[n2];
            });
            if (order2.join("") !== "0123456789") return false;
            var test3 = {};
            "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
            return true;
        } catch (err) {
            return false;
        }
    }
    objectAssign = shouldUseNative() ? Object.assign : function(target2, source) {
        var from2;
        var to = toObject(target2);
        var symbols;
        for(var s2 = 1; s2 < arguments.length; s2++){
            from2 = Object(arguments[s2]);
            for(var key in from2)if (hasOwnProperty2.call(from2, key)) to[key] = from2[key];
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from2);
                for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from2, symbols[i])) to[symbols[i]] = from2[symbols[i]];
            }
        }
        return to;
    };
    return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
    if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
    hasRequiredReactPropTypesSecret = 1;
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    ReactPropTypesSecret_1 = ReactPropTypesSecret;
    return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
    if (hasRequiredHas) return has;
    hasRequiredHas = 1;
    has = Function.call.bind(Object.prototype.hasOwnProperty);
    return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
    if (hasRequiredCheckPropTypes) return checkPropTypes_1;
    hasRequiredCheckPropTypes = 1;
    var printWarning = function() {};
    var ReactPropTypesSecret, loggedTypeFailures, has2;
    function checkPropTypes(typeSpecs, values2, location2, componentName, getStack) {
        var typeSpecName, error2, err, ex, stack;
    }
    checkPropTypes.resetWarningCache = function() {};
    checkPropTypes_1 = checkPropTypes;
    return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
    if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
    hasRequiredFactoryWithTypeCheckers = 1;
    var ReactIs = requireReactIs();
    var assign = requireObjectAssign();
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var has2 = requireHas();
    var checkPropTypes = requireCheckPropTypes();
    var printWarning = function() {};
    function emptyFunctionThatReturnsNull() {
        return null;
    }
    factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
        var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === "function") return iteratorFn;
        }
        var ANONYMOUS = "<<anonymous>>";
        var ReactPropTypes = {
            array: createPrimitiveTypeChecker("array"),
            bigint: createPrimitiveTypeChecker("bigint"),
            bool: createPrimitiveTypeChecker("boolean"),
            func: createPrimitiveTypeChecker("function"),
            number: createPrimitiveTypeChecker("number"),
            object: createPrimitiveTypeChecker("object"),
            string: createPrimitiveTypeChecker("string"),
            symbol: createPrimitiveTypeChecker("symbol"),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
        };
        function is(x2, y2) {
            if (x2 === y2) return x2 !== 0 || 1 / x2 === 1 / y2;
            else return x2 !== x2 && y2 !== y2;
        }
        function PropTypeError(message2, data) {
            this.message = message2;
            this.data = data && typeof data === "object" ? data : {};
            this.stack = "";
        }
        PropTypeError.prototype = Error.prototype;
        function createChainableTypeChecker(validate) {
            var manualPropTypeCallCache, manualPropTypeWarningCount;
            function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
                componentName = componentName || ANONYMOUS;
                propFullName = propFullName || propName;
                if (secret !== ReactPropTypesSecret) {
                    if (throwOnDirectAccess) {
                        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                        err.name = "Invariant Violation";
                        throw err;
                    } else var cacheKey;
                }
                if (props[propName] == null) {
                    if (isRequired) {
                        if (props[propName] === null) return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                        return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                    }
                    return null;
                } else return validate(props, propName, componentName, location2, propFullName);
            }
            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
        }
        function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location2, propFullName, secret) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== expectedType) {
                    var preciseType = getPreciseType(propValue);
                    return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                        expectedType: expectedType
                    });
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
        }
        function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location2, propFullName) {
                if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                var propValue = props[propName];
                if (!Array.isArray(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                }
                for(var i = 0; i < propValue.length; i++){
                    var error2 = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
                    if (error2 instanceof Error) return error2;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createElementTypeChecker() {
            function validate(props, propName, componentName, location2, propFullName) {
                var propValue = props[propName];
                if (!isValidElement2(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location2, propFullName) {
                var propValue = props[propName];
                if (!ReactIs.isValidElementType(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location2, propFullName) {
                if (!(props[propName] instanceof expectedClass)) {
                    var expectedClassName = expectedClass.name || ANONYMOUS;
                    var actualClassName = getClassName(props[propName]);
                    return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) return emptyFunctionThatReturnsNull;
            function validate(props, propName, componentName, location2, propFullName) {
                var propValue = props[propName];
                for(var i = 0; i < expectedValues.length; i++){
                    if (is(propValue, expectedValues[i])) return null;
                }
                var valuesString = JSON.stringify(expectedValues, function replacer(key, value2) {
                    var type = getPreciseType(value2);
                    if (type === "symbol") return String(value2);
                    return value2;
                });
                return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
            }
            return createChainableTypeChecker(validate);
        }
        function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location2, propFullName) {
                if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                for(var key in propValue)if (has2(propValue, key)) {
                    var error2 = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
                    if (error2 instanceof Error) return error2;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) return emptyFunctionThatReturnsNull;
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (typeof checker !== "function") {
                    printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                    return emptyFunctionThatReturnsNull;
                }
            }
            function validate(props, propName, componentName, location2, propFullName) {
                var expectedTypes = [];
                for(var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++){
                    var checker2 = arrayOfTypeCheckers[i2];
                    var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
                    if (checkerResult == null) return null;
                    if (checkerResult.data && has2(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
                }
                var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
            }
            return createChainableTypeChecker(validate);
        }
        function createNodeChecker() {
            function validate(props, propName, componentName, location2, propFullName) {
                if (!isNode2(props[propName])) return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function invalidValidatorError(componentName, location2, propFullName, key, type) {
            return new PropTypeError((componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
        }
        function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location2, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                for(var key in shapeTypes){
                    var checker = shapeTypes[key];
                    if (typeof checker !== "function") return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
                    var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
                    if (error2) return error2;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location2, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                var allKeys = assign({}, props[propName], shapeTypes);
                for(var key in allKeys){
                    var checker = shapeTypes[key];
                    if (has2(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
                    if (!checker) return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                    var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
                    if (error2) return error2;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function isNode2(propValue) {
            switch(typeof propValue){
                case "number":
                case "string":
                case "undefined":
                    return true;
                case "boolean":
                    return !propValue;
                case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode2);
                    if (propValue === null || isValidElement2(propValue)) return true;
                    var iteratorFn = getIteratorFn(propValue);
                    if (iteratorFn) {
                        var iterator = iteratorFn.call(propValue);
                        var step;
                        if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                            if (!isNode2(step.value)) return false;
                        }
                        else while(!(step = iterator.next()).done){
                            var entry = step.value;
                            if (entry) {
                                if (!isNode2(entry[1])) return false;
                            }
                        }
                    } else return false;
                    return true;
                default:
                    return false;
            }
        }
        function isSymbol2(propType, propValue) {
            if (propType === "symbol") return true;
            if (!propValue) return false;
            if (propValue["@@toStringTag"] === "Symbol") return true;
            if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
            return false;
        }
        function getPropType(propValue) {
            var propType = typeof propValue;
            if (Array.isArray(propValue)) return "array";
            if (propValue instanceof RegExp) return "object";
            if (isSymbol2(propType, propValue)) return "symbol";
            return propType;
        }
        function getPreciseType(propValue) {
            if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
            var propType = getPropType(propValue);
            if (propType === "object") {
                if (propValue instanceof Date) return "date";
                else if (propValue instanceof RegExp) return "regexp";
            }
            return propType;
        }
        function getPostfixForTypeWarning(value2) {
            var type = getPreciseType(value2);
            switch(type){
                case "array":
                case "object":
                    return "an " + type;
                case "boolean":
                case "date":
                case "regexp":
                    return "a " + type;
                default:
                    return type;
            }
        }
        function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
            return propValue.constructor.name;
        }
        ReactPropTypes.checkPropTypes = checkPropTypes;
        ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
    if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
    hasRequiredFactoryWithThrowingShims = 1;
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    factoryWithThrowingShims = function() {
        function shim2(props, propName, componentName, location2, propFullName, secret) {
            if (secret === ReactPropTypesSecret) return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
        }
        shim2.isRequired = shim2;
        function getShim() {
            return shim2;
        }
        var ReactPropTypes = {
            array: shim2,
            bigint: shim2,
            bool: shim2,
            func: shim2,
            number: shim2,
            object: shim2,
            string: shim2,
            symbol: shim2,
            any: shim2,
            arrayOf: getShim,
            element: shim2,
            elementType: shim2,
            instanceOf: getShim,
            node: shim2,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    return factoryWithThrowingShims;
}
var ReactIs, throwOnDirectAccess;
propTypes$1.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes$1.exports;
function componentWillMount() {
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== void 0) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== void 0 ? state : null;
    }
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill$a(Component2) {
    var prototype = Component2.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component2;
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component2.displayName || Component2.name;
        var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
    }
    if (typeof Component2.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component2;
}
const reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    polyfill: polyfill$a
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
function mergeClassNames() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === "string";
    }).join(" ");
}
const esm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: mergeClassNames
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(esm$1);
var Navigation$1 = {};
var dates = {};
Object.defineProperty(dates, "__esModule", {
    value: true
});
dates.getYear = getYear;
dates.getMonth = getMonth;
dates.getMonthIndex = getMonthIndex;
dates.getDay = getDay;
dates.getDayOfWeek = getDayOfWeek;
dates.getBeginOfCenturyYear = getBeginOfCenturyYear;
dates.getBeginOfCentury = getBeginOfCentury;
dates.getEndOfCentury = getEndOfCentury;
dates.getCenturyRange = getCenturyRange;
dates.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
dates.getEndOfPreviousCentury = getEndOfPreviousCentury;
dates.getBeginOfNextCentury = getBeginOfNextCentury;
dates.getBeginOfDecadeYear = getBeginOfDecadeYear;
dates.getBeginOfDecade = getBeginOfDecade;
dates.getEndOfDecade = getEndOfDecade;
dates.getDecadeRange = getDecadeRange;
dates.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
dates.getEndOfPreviousDecade = getEndOfPreviousDecade;
dates.getBeginOfNextDecade = getBeginOfNextDecade;
dates.getBeginOfYear = getBeginOfYear;
dates.getEndOfYear = getEndOfYear;
dates.getYearRange = getYearRange;
dates.getBeginOfPreviousYear = getBeginOfPreviousYear;
dates.getEndOfPreviousYear = getEndOfPreviousYear;
dates.getBeginOfNextYear = getBeginOfNextYear;
dates.getBeginOfMonth = getBeginOfMonth;
dates.getEndOfMonth = getEndOfMonth;
dates.getBeginOfWeek = getBeginOfWeek;
dates.getMonthRange = getMonthRange;
dates.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
dates.getEndOfPreviousMonth = getEndOfPreviousMonth;
dates.getBeginOfNextMonth = getBeginOfNextMonth;
dates.getBeginOfDay = getBeginOfDay;
dates.getEndOfDay = getEndOfDay;
dates.getDayRange = getDayRange;
dates.getWeekNumber = getWeekNumber;
dates.getBegin = getBegin;
dates.getBeginPrevious = getBeginPrevious;
dates.getBeginNext = getBeginNext;
dates.getEnd = getEnd;
dates.getEndPrevious = getEndPrevious;
dates.getRange = getRange;
dates.getValueRange = getValueRange;
dates.getDaysInMonth = getDaysInMonth;
dates.getCenturyLabel = getCenturyLabel;
dates.getDecadeLabel = getDecadeLabel;
dates.isWeekend = isWeekend;
dates.getISOLocalMonth = getISOLocalMonth;
dates.getISOLocalDate = getISOLocalDate;
dates.getEndPrevious2 = dates.getBeginNext2 = dates.getBeginPrevious2 = void 0;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var _map = _toConsumableArray(Array(7)).map(function(el, index2) {
    return index2;
}), _map2 = _slicedToArray(_map, 7), SUNDAY = _map2[0];
_map2[1];
_map2[2];
_map2[3];
_map2[4];
var FRIDAY = _map2[5], SATURDAY = _map2[6];
function getYear(date2) {
    if (date2 instanceof Date) return date2.getFullYear();
    if (typeof date2 === "number") return date2;
    var year = parseInt(date2, 10);
    if (typeof date2 === "string" && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date2, "."));
}
function getMonth(date2) {
    return date2.getMonth() + 1;
}
function getMonthIndex(date2) {
    return date2.getMonth();
}
function getDay(date2) {
    return date2.getDate();
}
function getDayOfWeek(date2) {
    var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ISO 8601";
    var weekday = date2.getDay();
    switch(calendarType){
        case "ISO 8601":
            return (weekday + 6) % 7;
        case "Arabic":
            return (weekday + 1) % 7;
        case "Hebrew":
        case "US":
            return weekday;
        default:
            throw new Error("Unsupported calendar type.");
    }
}
function getBeginOfCenturyYear(date2) {
    var year = getYear(date2) - 1;
    return year + -year % 100 + 1;
}
function getBeginOfCentury(date2) {
    var beginOfCenturyYear = getBeginOfCenturyYear(date2);
    return new Date(beginOfCenturyYear, 0, 1);
}
function getEndOfCentury(date2) {
    var beginOfCenturyYear = getBeginOfCenturyYear(date2);
    return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
}
function getCenturyRange(date2) {
    return [
        getBeginOfCentury(date2),
        getEndOfCentury(date2)
    ];
}
function getBeginOfPreviousCentury(date2) {
    var previousCenturyYear = getYear(date2) - 100;
    return getBeginOfCentury(previousCenturyYear);
}
function getEndOfPreviousCentury(date2) {
    var previousCenturyYear = getYear(date2) - 100;
    return getEndOfCentury(previousCenturyYear);
}
function getBeginOfNextCentury(date2) {
    var nextCenturyYear = getYear(date2) + 100;
    return getBeginOfCentury(nextCenturyYear);
}
function getBeginOfDecadeYear(date2) {
    var year = getYear(date2) - 1;
    return year + -year % 10 + 1;
}
function getBeginOfDecade(date2) {
    var beginOfDecadeYear = getBeginOfDecadeYear(date2);
    return new Date(beginOfDecadeYear, 0, 1);
}
function getEndOfDecade(date2) {
    var beginOfDecadeYear = getBeginOfDecadeYear(date2);
    return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
}
function getDecadeRange(date2) {
    return [
        getBeginOfDecade(date2),
        getEndOfDecade(date2)
    ];
}
function getBeginOfPreviousDecade(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var previousDecadeYear = getBeginOfDecadeYear(date2) - offset2;
    return getBeginOfDecade(previousDecadeYear);
}
function getEndOfPreviousDecade(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var previousDecadeYear = getBeginOfDecadeYear(date2) - offset2;
    return getEndOfDecade(previousDecadeYear);
}
function getBeginOfNextDecade(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var nextDecadeYear = getBeginOfDecadeYear(date2) + offset2;
    return getBeginOfDecade(nextDecadeYear);
}
function getBeginOfYear(date2) {
    var year = getYear(date2);
    return new Date(year, 0, 1);
}
function getEndOfYear(date2) {
    var year = getYear(date2);
    return new Date(year + 1, 0, 1, 0, 0, 0, -1);
}
function getYearRange(date2) {
    return [
        getBeginOfYear(date2),
        getEndOfYear(date2)
    ];
}
function getBeginOfPreviousYear(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var previousYear = getYear(date2) - offset2;
    return getBeginOfYear(previousYear);
}
function getEndOfPreviousYear(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var previousYear = getYear(date2) - offset2;
    return getEndOfYear(previousYear);
}
function getBeginOfNextYear(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var nextYear = getYear(date2) + offset2;
    return getBeginOfYear(nextYear);
}
function getBeginOfMonth(date2) {
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    return new Date(year, monthIndex, 1);
}
function getEndOfMonth(date2) {
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
}
function getBeginOfWeek(date2) {
    var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ISO 8601";
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    var day = date2.getDate() - getDayOfWeek(date2, calendarType);
    return new Date(year, monthIndex, day);
}
function getMonthRange(date2) {
    return [
        getBeginOfMonth(date2),
        getEndOfMonth(date2)
    ];
}
function getDifferentMonth(date2, offset2) {
    var year = getYear(date2);
    var previousMonthIndex = getMonthIndex(date2) + offset2;
    return new Date(year, previousMonthIndex, 1);
}
function getBeginOfPreviousMonth(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var previousMonth = getDifferentMonth(date2, -offset2);
    return getBeginOfMonth(previousMonth);
}
function getEndOfPreviousMonth(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var previousMonth = getDifferentMonth(date2, -offset2);
    return getEndOfMonth(previousMonth);
}
function getBeginOfNextMonth(date2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var nextMonth = getDifferentMonth(date2, offset2);
    return getBeginOfMonth(nextMonth);
}
function getBeginOfDay(date2) {
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    var day = getDay(date2);
    return new Date(year, monthIndex, day);
}
function getEndOfDay(date2) {
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    var day = getDay(date2);
    return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
}
function getDayRange(date2) {
    return [
        getBeginOfDay(date2),
        getEndOfDay(date2)
    ];
}
function getWeekNumber(date2) {
    var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ISO 8601";
    var calendarTypeForWeekNumber = calendarType === "US" ? "US" : "ISO 8601";
    var beginOfWeek = getBeginOfWeek(date2, calendarTypeForWeekNumber);
    var year = getYear(date2) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek;
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === "ISO 8601" ? 4 : 1);
        beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
        year -= 1;
    }while (date2 - beginOfFirstWeek < 0);
    return Math.round((beginOfWeek - beginOfFirstWeek) / (864e5 * 7)) + 1;
}
function getBegin(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getBeginOfCentury(date2);
        case "decade":
            return getBeginOfDecade(date2);
        case "year":
            return getBeginOfYear(date2);
        case "month":
            return getBeginOfMonth(date2);
        case "day":
            return getBeginOfDay(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getBeginPrevious(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getBeginOfPreviousCentury(date2);
        case "decade":
            return getBeginOfPreviousDecade(date2);
        case "year":
            return getBeginOfPreviousYear(date2);
        case "month":
            return getBeginOfPreviousMonth(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getBeginNext(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getBeginOfNextCentury(date2);
        case "decade":
            return getBeginOfNextDecade(date2);
        case "year":
            return getBeginOfNextYear(date2);
        case "month":
            return getBeginOfNextMonth(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var getBeginPrevious2 = function getBeginPrevious22(rangeType, date2) {
    switch(rangeType){
        case "decade":
            return getBeginOfPreviousDecade(date2, 100);
        case "year":
            return getBeginOfPreviousYear(date2, 10);
        case "month":
            return getBeginOfPreviousMonth(date2, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
dates.getBeginPrevious2 = getBeginPrevious2;
var getBeginNext2 = function getBeginNext22(rangeType, date2) {
    switch(rangeType){
        case "decade":
            return getBeginOfNextDecade(date2, 100);
        case "year":
            return getBeginOfNextYear(date2, 10);
        case "month":
            return getBeginOfNextMonth(date2, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
dates.getBeginNext2 = getBeginNext2;
function getEnd(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getEndOfCentury(date2);
        case "decade":
            return getEndOfDecade(date2);
        case "year":
            return getEndOfYear(date2);
        case "month":
            return getEndOfMonth(date2);
        case "day":
            return getEndOfDay(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getEndPrevious(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getEndOfPreviousCentury(date2);
        case "decade":
            return getEndOfPreviousDecade(date2);
        case "year":
            return getEndOfPreviousYear(date2);
        case "month":
            return getEndOfPreviousMonth(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var getEndPrevious2 = function getEndPrevious22(rangeType, date2) {
    switch(rangeType){
        case "decade":
            return getEndOfPreviousDecade(date2, 100);
        case "year":
            return getEndOfPreviousYear(date2, 10);
        case "month":
            return getEndOfPreviousMonth(date2, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
dates.getEndPrevious2 = getEndPrevious2;
function getRange(rangeType, date2) {
    switch(rangeType){
        case "century":
            return getCenturyRange(date2);
        case "decade":
            return getDecadeRange(date2);
        case "year":
            return getYearRange(date2);
        case "month":
            return getMonthRange(date2);
        case "day":
            return getDayRange(date2);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getValueRange(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a2, b2) {
        return a2 - b2;
    });
    return [
        getBegin(rangeType, rawNextValue[0]),
        getEnd(rangeType, rawNextValue[1])
    ];
}
function getDaysInMonth(date2) {
    var year = getYear(date2);
    var monthIndex = getMonthIndex(date2);
    return new Date(year, monthIndex + 1, 0).getDate();
}
function toYearLabel(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), start = _ref2[0], end = _ref2[1];
    return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
}
function getCenturyLabel(date2) {
    return toYearLabel(getCenturyRange(date2));
}
function getDecadeLabel(date2) {
    return toYearLabel(getDecadeRange(date2));
}
function isWeekend(date2) {
    var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ISO 8601";
    var weekday = date2.getDay();
    switch(calendarType){
        case "Arabic":
        case "Hebrew":
            return weekday === FRIDAY || weekday === SATURDAY;
        case "ISO 8601":
        case "US":
            return weekday === SATURDAY || weekday === SUNDAY;
        default:
            throw new Error("Unsupported calendar type.");
    }
}
function getISOLocalMonth(value2) {
    if (!value2) return value2;
    var date2 = new Date(value2);
    if (isNaN(date2.getTime())) throw new Error("Invalid date: ".concat(value2));
    var year = getYear(date2);
    var month = "0".concat(getMonth(date2)).slice(-2);
    return "".concat(year, "-").concat(month);
}
function getISOLocalDate(value2) {
    if (!value2) return value2;
    var date2 = new Date(value2);
    if (isNaN(date2.getTime())) throw new Error("Invalid date: ".concat(value2));
    var year = getYear(date2);
    var month = "0".concat(getMonth(date2)).slice(-2);
    var day = "0".concat(getDay(date2)).slice(-2);
    return "".concat(year, "-").concat(month, "-").concat(day);
}
var dateFormatter = {};
var FUNC_ERROR_TEXT = "Expected a function";
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
function before(n2, func) {
    var result2;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    n2 = toInteger(n2);
    return function() {
        if (--n2 > 0) result2 = func.apply(this, arguments);
        if (n2 <= 1) func = void 0;
        return result2;
    };
}
function once(func) {
    return before(2, func);
}
function isObject(value2) {
    var type = typeof value2;
    return !!value2 && (type == "object" || type == "function");
}
function isObjectLike(value2) {
    return !!value2 && typeof value2 == "object";
}
function isSymbol$1(value2) {
    return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
}
function toFinite(value2) {
    if (!value2) return value2 === 0 ? value2 : 0;
    value2 = toNumber(value2);
    if (value2 === INFINITY || value2 === -Infinity) {
        var sign = value2 < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value2 === value2 ? value2 : 0;
}
function toInteger(value2) {
    var result2 = toFinite(value2), remainder = result2 % 1;
    return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
function toNumber(value2) {
    if (typeof value2 == "number") return value2;
    if (isSymbol$1(value2)) return NAN;
    if (isObject(value2)) {
        var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
        value2 = isObject(other) ? other + "" : other;
    }
    if (typeof value2 != "string") return value2 === 0 ? value2 : +value2;
    value2 = value2.replace(reTrim, "");
    var isBinary = reIsBinary.test(value2);
    return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
}
var lodash_once = once;
const once$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_once);
function filterDuplicates(arr) {
    return arr.filter(function(el, index2, self2) {
        return self2.indexOf(el) === index2;
    });
}
function fixLowercaseProperties(arr) {
    return arr.map(function(el) {
        if (!el || el.indexOf("-") === -1 || el.toLowerCase() !== el) return el;
        var splitEl = el.split("-");
        return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
    });
}
function getUserLocalesInternal() {
    var languageList = [];
    if (typeof window !== "undefined") {
        if (window.navigator.languages) languageList = languageList.concat(window.navigator.languages);
        if (window.navigator.language) languageList.push(window.navigator.language);
        if (window.navigator.userLanguage) languageList.push(window.navigator.userLanguage);
        if (window.navigator.browserLanguage) languageList.push(window.navigator.browserLanguage);
        if (window.navigator.systemLanguage) languageList.push(window.navigator.systemLanguage);
    }
    languageList.push("en-US");
    return fixLowercaseProperties(filterDuplicates(languageList));
}
var getUserLocales = once$1(getUserLocalesInternal);
function getUserLocaleInternal() {
    return getUserLocales()[0];
}
var getUserLocale = once$1(getUserLocaleInternal);
const esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: getUserLocale,
    getUserLocale: getUserLocale,
    getUserLocales: getUserLocales
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(esm);
Object.defineProperty(dateFormatter, "__esModule", {
    value: true
});
dateFormatter.formatShortWeekday = dateFormatter.formatWeekday = dateFormatter.formatMonth = dateFormatter.formatMonthYear = dateFormatter.formatLongDate = dateFormatter.formatDate = void 0;
var _getUserLocale = _interopRequireDefault$4(require$$0);
function _interopRequireDefault$4(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function getFormatter(options) {
    return function(locale2, date2) {
        return date2.toLocaleString(locale2 || (0, _getUserLocale["default"])(), options);
    };
}
function toSafeHour(date2) {
    var safeDate = new Date(date2);
    return new Date(safeDate.setHours(12));
}
function getSafeFormatter(options) {
    return function(locale2, date2) {
        return getFormatter(options)(locale2, toSafeHour(date2));
    };
}
var formatDateOptions = {
    day: "numeric",
    month: "numeric",
    year: "numeric"
};
var formatLongDateOptions = {
    day: "numeric",
    month: "long",
    year: "numeric"
};
var formatMonthYearOptions = {
    month: "long",
    year: "numeric"
};
var formatMonthOptions = {
    month: "long"
};
var formatWeekdayOptions = {
    weekday: "long"
};
var formatShortWeekdayOptions = {
    weekday: "short"
};
var formatDate = getSafeFormatter(formatDateOptions);
dateFormatter.formatDate = formatDate;
var formatLongDate = getSafeFormatter(formatLongDateOptions);
dateFormatter.formatLongDate = formatLongDate;
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
dateFormatter.formatMonthYear = formatMonthYear;
var formatMonth = getSafeFormatter(formatMonthOptions);
dateFormatter.formatMonth = formatMonth;
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
dateFormatter.formatWeekday = formatWeekday;
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
dateFormatter.formatShortWeekday = formatShortWeekday;
var propTypes = {};
Object.defineProperty(propTypes, "__esModule", {
    value: true
});
propTypes.tileProps = propTypes.tileGroupProps = propTypes.isView = propTypes.isClassName = propTypes.isViews = propTypes.isValue = propTypes.isMaxDate = propTypes.isMinDate = propTypes.isCalendarType = void 0;
var _propTypes$1 = _interopRequireDefault$3(propTypesExports);
function _interopRequireDefault$3(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof2(obj2) {
        return typeof obj2;
    };
    else _typeof = function _typeof2(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
    return _typeof(obj);
}
var calendarTypes = [
    "ISO 8601",
    "US",
    "Arabic",
    "Hebrew"
];
var allViews = [
    "century",
    "decade",
    "year",
    "month"
];
var isCalendarType = _propTypes$1["default"].oneOf(calendarTypes);
propTypes.isCalendarType = isCalendarType;
var isMinDate = function isMinDate2(props, propName, componentName) {
    var minDate = props[propName];
    if (minDate) {
        if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
        var maxDate = props.maxDate;
        if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    }
    return null;
};
propTypes.isMinDate = isMinDate;
var isMaxDate = function isMaxDate2(props, propName, componentName) {
    var maxDate = props[propName];
    if (maxDate) {
        if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
        var minDate = props.minDate;
        if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    }
    return null;
};
propTypes.isMaxDate = isMaxDate;
var isValue = _propTypes$1["default"].oneOfType([
    _propTypes$1["default"].instanceOf(Date),
    _propTypes$1["default"].arrayOf(_propTypes$1["default"].instanceOf(Date))
]);
propTypes.isValue = isValue;
var isViews = _propTypes$1["default"].arrayOf(_propTypes$1["default"].oneOf(allViews));
propTypes.isViews = isViews;
var isClassName = _propTypes$1["default"].oneOfType([
    _propTypes$1["default"].string,
    _propTypes$1["default"].arrayOf(_propTypes$1["default"].string)
]);
propTypes.isClassName = isClassName;
var isView = function isView2(props, propName, componentName) {
    var view = props[propName];
    var views = props.views;
    var allowedViews = views || allViews;
    if (view !== void 0 && allowedViews.indexOf(view) === -1) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function(a2) {
        return '"'.concat(a2, '"');
    }).join(", "), "]."));
    return null;
};
propTypes.isView = isView;
isView.isRequired = function(props, propName, componentName) {
    var view = props[propName];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return isView(props, propName, componentName);
};
var tileGroupProps = {
    activeStartDate: _propTypes$1["default"].instanceOf(Date).isRequired,
    hover: _propTypes$1["default"].instanceOf(Date),
    locale: _propTypes$1["default"].string,
    maxDate: isMaxDate,
    minDate: isMinDate,
    onClick: _propTypes$1["default"].func,
    onMouseOver: _propTypes$1["default"].func,
    tileClassName: _propTypes$1["default"].oneOfType([
        _propTypes$1["default"].func,
        isClassName
    ]),
    tileContent: _propTypes$1["default"].oneOfType([
        _propTypes$1["default"].func,
        _propTypes$1["default"].node
    ]),
    value: isValue,
    valueType: _propTypes$1["default"].string
};
propTypes.tileGroupProps = tileGroupProps;
var tileProps = {
    activeStartDate: _propTypes$1["default"].instanceOf(Date).isRequired,
    classes: _propTypes$1["default"].arrayOf(_propTypes$1["default"].string).isRequired,
    date: _propTypes$1["default"].instanceOf(Date).isRequired,
    locale: _propTypes$1["default"].string,
    maxDate: isMaxDate,
    minDate: isMinDate,
    onClick: _propTypes$1["default"].func,
    onMouseOver: _propTypes$1["default"].func,
    style: _propTypes$1["default"].objectOf(_propTypes$1["default"].oneOfType([
        _propTypes$1["default"].string,
        _propTypes$1["default"].number
    ])),
    tileClassName: _propTypes$1["default"].oneOfType([
        _propTypes$1["default"].func,
        isClassName
    ]),
    tileContent: _propTypes$1["default"].oneOfType([
        _propTypes$1["default"].func,
        _propTypes$1["default"].node
    ]),
    tileDisabled: _propTypes$1["default"].func
};
propTypes.tileProps = tileProps;
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Navigation2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _dates2 = dates;
    var _dateFormatter = dateFormatter;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var className = "react-calendar__navigation";
    function Navigation2(_ref) {
        var date2 = _ref.activeStartDate, drillUp = _ref.drillUp, formatMonthYear2 = _ref.formatMonthYear, locale2 = _ref.locale, maxDate = _ref.maxDate, minDate = _ref.minDate, navigationAriaLabel = _ref.navigationAriaLabel, navigationLabel = _ref.navigationLabel, next2AriaLabel = _ref.next2AriaLabel, next2Label = _ref.next2Label, nextAriaLabel = _ref.nextAriaLabel, nextLabel = _ref.nextLabel, prev2AriaLabel = _ref.prev2AriaLabel, prev2Label = _ref.prev2Label, prevAriaLabel = _ref.prevAriaLabel, prevLabel = _ref.prevLabel, setActiveStartDate = _ref.setActiveStartDate, view = _ref.view, views = _ref.views;
        var drillUpAvailable = views.indexOf(view) > 0;
        var shouldShowPrevNext2Buttons = view !== "century";
        var previousActiveStartDate = (0, _dates2.getBeginPrevious)(view, date2);
        var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates2.getBeginPrevious2)(view, date2);
        var nextActiveStartDate = (0, _dates2.getBeginNext)(view, date2);
        var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates2.getBeginNext2)(view, date2);
        var prevButtonDisabled = function() {
            if (previousActiveStartDate.getFullYear() < 1e3) return true;
            var previousActiveEndDate = (0, _dates2.getEndPrevious)(view, date2);
            return minDate && minDate >= previousActiveEndDate;
        }();
        var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
            if (previousActiveStartDate2.getFullYear() < 1e3) return true;
            var previousActiveEndDate = (0, _dates2.getEndPrevious2)(view, date2);
            return minDate && minDate >= previousActiveEndDate;
        }();
        var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
        var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;
        function onClickPrevious() {
            setActiveStartDate(previousActiveStartDate);
        }
        function onClickPrevious2() {
            setActiveStartDate(previousActiveStartDate2);
        }
        function onClickNext() {
            setActiveStartDate(nextActiveStartDate);
        }
        function onClickNext2() {
            setActiveStartDate(nextActiveStartDate2);
        }
        var label2 = function() {
            switch(view){
                case "century":
                    return (0, _dates2.getCenturyLabel)(date2);
                case "decade":
                    return (0, _dates2.getDecadeLabel)(date2);
                case "year":
                    return (0, _dates2.getYear)(date2);
                case "month":
                    return formatMonthYear2(locale2, date2);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return _react2["default"].createElement("div", {
            className: className,
            style: {
                display: "flex"
            }
        }, prev2Label !== null && shouldShowPrevNext2Buttons && _react2["default"].createElement("button", {
            "aria-label": prev2AriaLabel,
            className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
            disabled: prev2ButtonDisabled,
            onClick: onClickPrevious2,
            type: "button"
        }, prev2Label), _react2["default"].createElement("button", {
            "aria-label": prevAriaLabel,
            className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
            disabled: prevButtonDisabled,
            onClick: onClickPrevious,
            type: "button"
        }, prevLabel), _react2["default"].createElement("button", {
            "aria-label": navigationAriaLabel,
            className: "react-calendar__navigation__label",
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button"
        }, navigationLabel ? navigationLabel({
            date: date2,
            view: view,
            label: label2
        }) : label2), _react2["default"].createElement("button", {
            "aria-label": nextAriaLabel,
            className: "".concat(className, "__arrow ").concat(className, "__next-button"),
            disabled: nextButtonDisabled,
            onClick: onClickNext,
            type: "button"
        }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react2["default"].createElement("button", {
            "aria-label": next2AriaLabel,
            className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
            disabled: next2ButtonDisabled,
            onClick: onClickNext2,
            type: "button"
        }, next2Label));
    }
    Navigation2.defaultProps = {
        formatMonthYear: _dateFormatter.formatMonthYear,
        navigationAriaLabel: "",
        next2AriaLabel: "",
        next2Label: "\xbb",
        nextAriaLabel: "",
        nextLabel: "\u203A",
        prev2AriaLabel: "",
        prev2Label: "\xab",
        prevAriaLabel: "",
        prevLabel: "\u2039"
    };
    Navigation2.propTypes = {
        activeStartDate: _propTypes2["default"].instanceOf(Date).isRequired,
        drillUp: _propTypes2["default"].func.isRequired,
        formatMonthYear: _propTypes2["default"].func,
        locale: _propTypes2["default"].string,
        maxDate: _propTypes2["default"].instanceOf(Date),
        minDate: _propTypes2["default"].instanceOf(Date),
        navigationAriaLabel: _propTypes2["default"].string,
        navigationLabel: _propTypes2["default"].func,
        next2AriaLabel: _propTypes2["default"].string,
        next2Label: _propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes2["default"].node
        ]),
        nextAriaLabel: _propTypes2["default"].string,
        nextLabel: _propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes2["default"].node
        ]),
        prev2AriaLabel: _propTypes2["default"].string,
        prev2Label: _propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes2["default"].node
        ]),
        prevAriaLabel: _propTypes2["default"].string,
        prevLabel: _propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes2["default"].node
        ]),
        setActiveStartDate: _propTypes2["default"].func.isRequired,
        view: _propTypes22.isView.isRequired,
        views: _propTypes22.isViews.isRequired
    };
})(Navigation$1);
var CenturyView = {};
var Decades = {};
var TileGroup = {};
var Flex = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Flex2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function toPercent(num2) {
        return "".concat(num2, "%");
    }
    function Flex2(_ref) {
        var children2 = _ref.children, className = _ref.className, direction2 = _ref.direction, count2 = _ref.count, offset2 = _ref.offset, style = _ref.style, wrap2 = _ref.wrap, otherProps = _objectWithoutProperties(_ref, [
            "children",
            "className",
            "direction",
            "count",
            "offset",
            "style",
            "wrap"
        ]);
        return _react2["default"].createElement("div", _extends2({
            className: className,
            style: _objectSpread({
                display: "flex",
                flexDirection: direction2,
                flexWrap: wrap2 ? "wrap" : "no-wrap"
            }, style)
        }, otherProps), _react2["default"].Children.map(children2, function(child, index2) {
            return _react2["default"].cloneElement(child, _objectSpread({}, child.props, {
                style: {
                    flexBasis: toPercent(100 / count2),
                    maxWidth: toPercent(100 / count2),
                    overflow: "hidden",
                    marginLeft: offset2 && index2 === 0 ? toPercent(100 * offset2 / count2) : null
                }
            }));
        }));
    }
    Flex2.propTypes = {
        children: _propTypes2["default"].node,
        className: _propTypes2["default"].string,
        count: _propTypes2["default"].number.isRequired,
        direction: _propTypes2["default"].string,
        offset: _propTypes2["default"].number,
        style: _propTypes2["default"].objectOf(_propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes2["default"].number
        ])),
        wrap: _propTypes2["default"].bool
    };
})(Flex);
var utils = {};
Object.defineProperty(utils, "__esModule", {
    value: true
});
utils.getTileClasses = utils.between = utils.doRangesOverlap = utils.isRangeWithinRange = utils.isValueWithinRange = utils.callIfDefined = utils.mergeFunctions = void 0;
var _dates = dates;
var mergeFunctions = function mergeFunctions2() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return functions.filter(Boolean).forEach(function(f2) {
            return f2.apply(void 0, args);
        });
    };
};
utils.mergeFunctions = mergeFunctions;
var callIfDefined = function callIfDefined2(fn2) {
    if (fn2 && typeof fn2 === "function") {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        fn2.apply(void 0, args);
    }
};
utils.callIfDefined = callIfDefined;
var isValueWithinRange = function isValueWithinRange2(value2, range2) {
    return range2[0] <= value2 && range2[1] >= value2;
};
utils.isValueWithinRange = isValueWithinRange;
var isRangeWithinRange = function isRangeWithinRange2(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};
utils.isRangeWithinRange = isRangeWithinRange;
var doRangesOverlap = function doRangesOverlap2(range1, range2) {
    return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};
utils.doRangesOverlap = doRangesOverlap;
var between$1 = function between(value2, min2, max2) {
    if (min2 && min2 > value2) return min2;
    if (max2 && max2 < value2) return max2;
    return value2;
};
utils.between = between$1;
var getTileClasses = function getTileClasses2() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, value2 = _ref.value, valueType = _ref.valueType, date2 = _ref.date, dateType = _ref.dateType, hover = _ref.hover;
    var className = "react-calendar__tile";
    var classes2 = [
        className
    ];
    if (!date2) return classes2;
    if (!(date2 instanceof Array) && !dateType) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
    var now2 = /* @__PURE__ */ new Date();
    var dateRange = date2 instanceof Array ? date2 : (0, _dates.getRange)(dateType, date2);
    if (isValueWithinRange(now2, dateRange)) classes2.push("".concat(className, "--now"));
    if (!value2) return classes2;
    if (!(value2 instanceof Array) && !valueType) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
    var valueRange = value2 instanceof Array ? value2 : (0, _dates.getRange)(valueType, value2);
    if (isRangeWithinRange(valueRange, dateRange)) classes2.push("".concat(className, "--active"));
    else if (doRangesOverlap(valueRange, dateRange)) classes2.push("".concat(className, "--hasActive"));
    else if (hover && // Date before value
    (dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [
        hover,
        valueRange[0]
    ]) || // Date after value
    dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [
        valueRange[1],
        hover
    ]))) classes2.push("".concat(className, "--hover"));
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
    if (isRangeStart) classes2.push("".concat(className, "--rangeStart"));
    if (isRangeEnd) classes2.push("".concat(className, "--rangeEnd"));
    if (isRangeStart && isRangeEnd) classes2.push("".concat(className, "--rangeBothEnds"));
    return classes2;
};
utils.getTileClasses = getTileClasses;
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = TileGroup2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Flex = _interopRequireDefault2(Flex);
    var _utils = utils;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function TileGroup2(_ref) {
        var className = _ref.className, count2 = _ref.count, dateTransform = _ref.dateTransform, dateType = _ref.dateType, end = _ref.end, hover = _ref.hover, offset2 = _ref.offset, start = _ref.start, step = _ref.step, Tile2 = _ref.tile, value2 = _ref.value, valueType = _ref.valueType, tileProps2 = _objectWithoutProperties(_ref, [
            "className",
            "count",
            "dateTransform",
            "dateType",
            "end",
            "hover",
            "offset",
            "start",
            "step",
            "tile",
            "value",
            "valueType"
        ]);
        var tiles = [];
        for(var point2 = start; point2 <= end; point2 += step){
            var date2 = dateTransform(point2);
            tiles.push(_react2["default"].createElement(Tile2, _extends2({
                key: date2.getTime(),
                classes: (0, _utils.getTileClasses)({
                    value: value2,
                    valueType: valueType,
                    date: date2,
                    dateType: dateType,
                    hover: hover
                }),
                date: date2,
                point: point2
            }, tileProps2)));
        }
        return _react2["default"].createElement(_Flex["default"], {
            className: className,
            count: count2,
            offset: offset2,
            wrap: true
        }, tiles);
    }
    TileGroup2.propTypes = _objectSpread({}, _propTypes22.tileGroupProps, {
        activeStartDate: _propTypes2["default"].instanceOf(Date),
        count: _propTypes2["default"].number,
        dateTransform: _propTypes2["default"].func.isRequired,
        offset: _propTypes2["default"].number,
        step: _propTypes2["default"].number,
        tile: _propTypes2["default"].func.isRequired
    });
    TileGroup2.defaultProps = {
        count: 3,
        step: 1
    };
})(TileGroup);
var Decade = {};
var Tile = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = void 0;
    var _react2 = _interopRequireWildcard2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _mergeClassNames = _interopRequireDefault2(require$$3$1);
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _interopRequireWildcard2(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                    else newObj[key] = obj[key];
                }
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _typeof2(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
            return typeof obj2;
        };
        else _typeof2 = function _typeof3(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
        return _typeof2(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target2, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target2, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _possibleConstructorReturn(self2, call2) {
        if (call2 && (_typeof2(call2) === "object" || typeof call2 === "function")) return call2;
        return _assertThisInitialized(self2);
    }
    function _getPrototypeOf(o2) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
            return o3.__proto__ || Object.getPrototypeOf(o3);
        };
        return _getPrototypeOf(o2);
    }
    function _assertThisInitialized(self2) {
        if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self2;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o2, p2) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
            o3.__proto__ = p3;
            return o3;
        };
        return _setPrototypeOf(o2, p2);
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    var Tile2 = /* @__PURE__ */ function(_Component) {
        _inherits(Tile3, _Component);
        function Tile3() {
            var _getPrototypeOf2;
            var _this;
            _classCallCheck(this, Tile3);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile3)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            _defineProperty(_assertThisInitialized(_this), "state", {});
            return _this;
        }
        _createClass(Tile3, [
            {
                key: "render",
                value: function render2() {
                    var _this$props = this.props, activeStartDate = _this$props.activeStartDate, children2 = _this$props.children, classes2 = _this$props.classes, date2 = _this$props.date, formatAbbr = _this$props.formatAbbr, locale2 = _this$props.locale, maxDate = _this$props.maxDate, maxDateTransform = _this$props.maxDateTransform, minDate = _this$props.minDate, minDateTransform = _this$props.minDateTransform, onClick = _this$props.onClick, onMouseOver = _this$props.onMouseOver, style = _this$props.style, tileDisabled = _this$props.tileDisabled, view = _this$props.view;
                    var _this$state = this.state, tileClassName = _this$state.tileClassName, tileContent = _this$state.tileContent;
                    return _react2["default"].createElement("button", {
                        className: (0, _mergeClassNames["default"])(classes2, tileClassName),
                        disabled: minDate && minDateTransform(minDate) > date2 || maxDate && maxDateTransform(maxDate) < date2 || tileDisabled && tileDisabled({
                            activeStartDate: activeStartDate,
                            date: date2,
                            view: view
                        }),
                        onClick: onClick && function() {
                            return onClick(date2);
                        },
                        onFocus: onMouseOver && function() {
                            return onMouseOver(date2);
                        },
                        onMouseOver: onMouseOver && function() {
                            return onMouseOver(date2);
                        },
                        style: style,
                        type: "button"
                    }, formatAbbr ? _react2["default"].createElement("abbr", {
                        "aria-label": formatAbbr(locale2, date2)
                    }, children2) : children2, tileContent);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, prevState) {
                    var date2 = nextProps.date, tileClassName = nextProps.tileClassName, tileContent = nextProps.tileContent, view = nextProps.view;
                    var nextState = {};
                    if (tileClassName !== prevState.tileClassNameProps) {
                        nextState.tileClassName = typeof tileClassName === "function" ? tileClassName({
                            date: date2,
                            view: view
                        }) : tileClassName;
                        nextState.tileClassNameProps = tileClassName;
                    }
                    if (tileContent !== prevState.tileContentProps) {
                        nextState.tileContent = typeof tileContent === "function" ? tileContent({
                            date: date2,
                            view: view
                        }) : tileContent;
                        nextState.tileContentProps = tileContent;
                    }
                    return nextState;
                }
            }
        ]);
        return Tile3;
    }(_react2.Component);
    exports2["default"] = Tile2;
    Tile2.propTypes = _objectSpread({}, _propTypes22.tileProps, {
        children: _propTypes2["default"].node.isRequired,
        formatAbbr: _propTypes2["default"].func,
        maxDateTransform: _propTypes2["default"].func.isRequired,
        minDateTransform: _propTypes2["default"].func.isRequired
    });
})(Tile);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Decade2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Tile = _interopRequireDefault2(Tile);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    var className = "react-calendar__century-view__decades__decade";
    function Decade2(_ref) {
        var classes2 = _ref.classes, point2 = _ref.point, otherProps = _objectWithoutProperties(_ref, [
            "classes",
            "point"
        ]);
        return _react2["default"].createElement(_Tile["default"], _extends2({}, otherProps, {
            classes: [].concat(classes2, className),
            maxDateTransform: _dates2.getEndOfDecade,
            minDateTransform: _dates2.getBeginOfDecade,
            view: "century"
        }), (0, _dates2.getDecadeLabel)(point2));
    }
    Decade2.propTypes = _objectSpread({}, _propTypes22.tileProps, {
        point: _propTypes2["default"].number.isRequired
    });
})(Decade);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Decades2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _TileGroup = _interopRequireDefault2(TileGroup);
    var _Decade = _interopRequireDefault2(Decade);
    var _dates2 = dates;
    var _propTypes2 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function Decades2(props) {
        var activeStartDate = props.activeStartDate;
        var start = (0, _dates2.getBeginOfCenturyYear)(activeStartDate);
        var end = start + 99;
        return _react2["default"].createElement(_TileGroup["default"], _extends2({}, props, {
            className: "react-calendar__century-view__decades",
            dateTransform: _dates2.getBeginOfDecade,
            dateType: "decade",
            end: end,
            start: start,
            step: 10,
            tile: _Decade["default"]
        }));
    }
    Decades2.propTypes = _objectSpread({}, _propTypes2.tileGroupProps);
})(Decades);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = CenturyView2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _Decades = _interopRequireDefault2(Decades);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function CenturyView2(props) {
        function renderDecades() {
            return _react2["default"].createElement(_Decades["default"], props);
        }
        return _react2["default"].createElement("div", {
            className: "react-calendar__century-view"
        }, renderDecades());
    }
})(CenturyView);
var DecadeView = {};
var Years = {};
var Year = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Year2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Tile = _interopRequireDefault2(Tile);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    var className = "react-calendar__decade-view__years__year";
    function Year2(_ref) {
        var classes2 = _ref.classes, point2 = _ref.point, otherProps = _objectWithoutProperties(_ref, [
            "classes",
            "point"
        ]);
        return _react2["default"].createElement(_Tile["default"], _extends2({}, otherProps, {
            classes: [].concat(classes2, className),
            maxDateTransform: _dates2.getEndOfYear,
            minDateTransform: _dates2.getBeginOfYear,
            view: "decade"
        }), point2);
    }
    Year2.propTypes = _objectSpread({}, _propTypes22.tileProps, {
        point: _propTypes2["default"].number.isRequired
    });
})(Year);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Years2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _TileGroup = _interopRequireDefault2(TileGroup);
    var _Year = _interopRequireDefault2(Year);
    var _dates2 = dates;
    var _propTypes2 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function Years2(props) {
        var activeStartDate = props.activeStartDate;
        var start = (0, _dates2.getBeginOfDecadeYear)(activeStartDate);
        var end = start + 9;
        return _react2["default"].createElement(_TileGroup["default"], _extends2({}, props, {
            className: "react-calendar__decade-view__years",
            dateTransform: function dateTransform(year) {
                return new Date(year, 0, 1);
            },
            dateType: "year",
            end: end,
            start: start,
            tile: _Year["default"]
        }));
    }
    Years2.propTypes = _objectSpread({}, _propTypes2.tileGroupProps);
})(Years);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = DecadeView2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _Years = _interopRequireDefault2(Years);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function DecadeView2(props) {
        function renderYears() {
            return _react2["default"].createElement(_Years["default"], props);
        }
        return _react2["default"].createElement("div", {
            className: "react-calendar__decade-view"
        }, renderYears());
    }
})(DecadeView);
var YearView = {};
var Months = {};
var Month = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Month2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Tile = _interopRequireDefault2(Tile);
    var _dates2 = dates;
    var _dateFormatter = dateFormatter;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    var className = "react-calendar__year-view__months__month";
    function Month2(_ref) {
        var classes2 = _ref.classes, date2 = _ref.date, formatMonth2 = _ref.formatMonth, locale2 = _ref.locale, otherProps = _objectWithoutProperties(_ref, [
            "classes",
            "date",
            "formatMonth",
            "locale"
        ]);
        return _react2["default"].createElement(_Tile["default"], _extends2({}, otherProps, {
            classes: [].concat(classes2, className),
            date: date2,
            formatAbbr: _dateFormatter.formatMonthYear,
            locale: locale2,
            maxDateTransform: _dates2.getEndOfMonth,
            minDateTransform: _dates2.getBeginOfMonth,
            view: "year"
        }), formatMonth2(locale2, date2));
    }
    Month2.defaultProps = {
        formatMonth: _dateFormatter.formatMonth
    };
    Month2.propTypes = _objectSpread({}, _propTypes22.tileProps, {
        formatMonth: _propTypes2["default"].func
    });
})(Month);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Months2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _TileGroup = _interopRequireDefault2(TileGroup);
    var _Month = _interopRequireDefault2(Month);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function Months2(props) {
        var activeStartDate = props.activeStartDate;
        var start = 0;
        var end = 11;
        var year = (0, _dates2.getYear)(activeStartDate);
        return _react2["default"].createElement(_TileGroup["default"], _extends2({}, props, {
            className: "react-calendar__year-view__months",
            dateTransform: function dateTransform(monthIndex) {
                return new Date(year, monthIndex, 1);
            },
            dateType: "month",
            end: end,
            start: start,
            tile: _Month["default"]
        }));
    }
    Months2.propTypes = _objectSpread({}, _propTypes22.tileGroupProps, {
        locale: _propTypes2["default"].string
    });
})(Months);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = YearView2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _Months = _interopRequireDefault2(Months);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function YearView2(props) {
        function renderMonths() {
            return _react2["default"].createElement(_Months["default"], props);
        }
        return _react2["default"].createElement("div", {
            className: "react-calendar__year-view"
        }, renderMonths());
    }
})(YearView);
var MonthView = {};
var Days = {};
var Day = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Day2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Tile = _interopRequireDefault2(Tile);
    var _dates2 = dates;
    var _dateFormatter = dateFormatter;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    var className = "react-calendar__month-view__days__day";
    function Day2(_ref) {
        var calendarType = _ref.calendarType, classes2 = _ref.classes, currentMonthIndex = _ref.currentMonthIndex, date2 = _ref.date, otherProps = _objectWithoutProperties(_ref, [
            "calendarType",
            "classes",
            "currentMonthIndex",
            "date"
        ]);
        return _react2["default"].createElement(_Tile["default"], _extends2({}, otherProps, {
            classes: [].concat(classes2, className, (0, _dates2.isWeekend)(date2, calendarType) ? "".concat(className, "--weekend") : null, date2.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
            date: date2,
            formatAbbr: _dateFormatter.formatLongDate,
            maxDateTransform: _dates2.getEndOfDay,
            minDateTransform: _dates2.getBeginOfDay,
            view: "month"
        }), (0, _dates2.getDay)(date2));
    }
    Day2.propTypes = _objectSpread({}, _propTypes22.tileProps, {
        currentMonthIndex: _propTypes2["default"].number.isRequired
    });
})(Day);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Days2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _TileGroup = _interopRequireDefault2(TileGroup);
    var _Day = _interopRequireDefault2(Day);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function ownKeys(object2, enumerableOnly) {
        var keys3 = Object.keys(object2);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
            });
            keys3.push.apply(keys3, symbols);
        }
        return keys3;
    }
    function _objectSpread(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target2, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target2;
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function Days2(props) {
        var activeStartDate = props.activeStartDate, calendarType = props.calendarType;
        var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, otherProps = _objectWithoutProperties(props, [
            "showFixedNumberOfWeeks",
            "showNeighboringMonth"
        ]);
        var year = (0, _dates2.getYear)(activeStartDate);
        var monthIndex = (0, _dates2.getMonthIndex)(activeStartDate);
        var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
        var dayOfWeek = (0, _dates2.getDayOfWeek)(activeStartDate, calendarType);
        var offset2 = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
        var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
        var end = function() {
            if (showFixedNumberOfWeeks) return start + 42 - 1;
            var daysInMonth = (0, _dates2.getDaysInMonth)(activeStartDate);
            if (showNeighboringMonth) {
                var activeEndDate = new Date(year, monthIndex, daysInMonth);
                return daysInMonth + (7 - (0, _dates2.getDayOfWeek)(activeEndDate, calendarType) - 1);
            }
            return daysInMonth;
        }();
        return _react2["default"].createElement(_TileGroup["default"], _extends2({}, otherProps, {
            className: "react-calendar__month-view__days",
            count: 7,
            currentMonthIndex: monthIndex,
            dateTransform: function dateTransform(day) {
                return new Date(year, monthIndex, day);
            },
            dateType: "day",
            end: end,
            offset: offset2,
            start: start,
            tile: _Day["default"]
        }));
    }
    Days2.propTypes = _objectSpread({
        calendarType: _propTypes22.isCalendarType.isRequired,
        showFixedNumberOfWeeks: _propTypes2["default"].bool,
        showNeighboringMonth: _propTypes2["default"].bool
    }, _propTypes22.tileGroupProps);
})(Days);
var Weekdays = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = Weekdays2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Flex = _interopRequireDefault2(Flex);
    var _dates2 = dates;
    var _dateFormatter = dateFormatter;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function Weekdays2(props) {
        var calendarType = props.calendarType, formatShortWeekday2 = props.formatShortWeekday, locale2 = props.locale, onMouseLeave = props.onMouseLeave;
        var anyDate = /* @__PURE__ */ new Date();
        var beginOfMonth = (0, _dates2.getBeginOfMonth)(anyDate);
        var year = (0, _dates2.getYear)(beginOfMonth);
        var monthIndex = (0, _dates2.getMonthIndex)(beginOfMonth);
        var weekdays = [];
        for(var weekday = 1; weekday <= 7; weekday += 1){
            var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates2.getDayOfWeek)(beginOfMonth, calendarType));
            var abbr = (0, _dateFormatter.formatWeekday)(locale2, weekdayDate);
            weekdays.push(_react2["default"].createElement("div", {
                key: weekday,
                className: "react-calendar__month-view__weekdays__weekday"
            }, _react2["default"].createElement("abbr", {
                "aria-label": abbr,
                title: abbr
            }, formatShortWeekday2(locale2, weekdayDate).replace(".", ""))));
        }
        return _react2["default"].createElement(_Flex["default"], {
            className: "react-calendar__month-view__weekdays",
            count: 7,
            onFocus: onMouseLeave,
            onMouseOver: onMouseLeave
        }, weekdays);
    }
    Weekdays2.defaultProps = {
        formatShortWeekday: _dateFormatter.formatShortWeekday
    };
    Weekdays2.propTypes = {
        calendarType: _propTypes22.isCalendarType.isRequired,
        formatShortWeekday: _propTypes2["default"].func,
        locale: _propTypes2["default"].string,
        onMouseLeave: _propTypes2["default"].func
    };
})(Weekdays);
var WeekNumbers = {};
var WeekNumber = {};
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = WeekNumber2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function WeekNumber2(_ref) {
        var date2 = _ref.date, onClickWeekNumber = _ref.onClickWeekNumber, weekNumber = _ref.weekNumber;
        return onClickWeekNumber ? _react2["default"].createElement("button", {
            className: "react-calendar__tile",
            onClick: function onClick() {
                return onClickWeekNumber(weekNumber, date2);
            },
            style: {
                flexGrow: 1
            },
            type: "button"
        }, _react2["default"].createElement("span", null, weekNumber)) : _react2["default"].createElement("div", {
            className: "react-calendar__tile",
            style: {
                flexGrow: 1
            }
        }, _react2["default"].createElement("span", null, weekNumber));
    }
    WeekNumber2.propTypes = {
        date: _propTypes2["default"].instanceOf(Date).isRequired,
        onClickWeekNumber: _propTypes2["default"].func,
        weekNumber: _propTypes2["default"].number.isRequired
    };
})(WeekNumber);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = WeekNumbers2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _WeekNumber = _interopRequireDefault2(WeekNumber);
    var _Flex = _interopRequireDefault2(Flex);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function WeekNumbers2(props) {
        var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
        var numberOfWeeks = function() {
            if (showFixedNumberOfWeeks) return 6;
            var numberOfDays = (0, _dates2.getDaysInMonth)(activeStartDate);
            var startWeekday = (0, _dates2.getDayOfWeek)(activeStartDate, calendarType);
            var days = numberOfDays - (7 - startWeekday);
            return 1 + Math.ceil(days / 7);
        }();
        var dates2 = function() {
            var year = (0, _dates2.getYear)(activeStartDate);
            var monthIndex = (0, _dates2.getMonthIndex)(activeStartDate);
            var day = (0, _dates2.getDay)(activeStartDate);
            var result2 = [];
            for(var index2 = 0; index2 < numberOfWeeks; index2 += 1)result2.push((0, _dates2.getBeginOfWeek)(new Date(year, monthIndex, day + index2 * 7), calendarType));
            return result2;
        }();
        var weekNumbers = dates2.map(function(date2) {
            return (0, _dates2.getWeekNumber)(date2, calendarType);
        });
        return _react2["default"].createElement(_Flex["default"], {
            className: "react-calendar__month-view__weekNumbers",
            count: numberOfWeeks,
            direction: "column",
            onFocus: onMouseLeave,
            onMouseOver: onMouseLeave,
            style: {
                flexBasis: "calc(100% * (1 / 8)",
                flexShrink: 0
            }
        }, weekNumbers.map(function(weekNumber, weekIndex) {
            return _react2["default"].createElement(_WeekNumber["default"], {
                key: weekNumber,
                date: dates2[weekIndex],
                onClickWeekNumber: onClickWeekNumber,
                weekNumber: weekNumber
            });
        }));
    }
    WeekNumbers2.propTypes = {
        activeStartDate: _propTypes2["default"].instanceOf(Date).isRequired,
        calendarType: _propTypes22.isCalendarType.isRequired,
        onClickWeekNumber: _propTypes2["default"].func,
        onMouseLeave: _propTypes2["default"].func,
        showFixedNumberOfWeeks: _propTypes2["default"].bool
    };
})(WeekNumbers);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = MonthView2;
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _Days = _interopRequireDefault2(Days);
    var _Weekdays = _interopRequireDefault2(Weekdays);
    var _WeekNumbers = _interopRequireDefault2(WeekNumbers);
    var _propTypes22 = propTypes;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target2 = _objectWithoutPropertiesLoose2(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target2[key] = source[key];
            }
        }
        return target2;
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function MonthView2(props) {
        var activeStartDate = props.activeStartDate, locale2 = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
        var calendarTypeProps = props.calendarType, formatShortWeekday2 = props.formatShortWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = _objectWithoutProperties(props, [
            "calendarType",
            "formatShortWeekday",
            "onClickWeekNumber",
            "showWeekNumbers"
        ]);
        var calendarType = function() {
            if (calendarTypeProps) return calendarTypeProps;
            switch(locale2){
                case "en-CA":
                case "en-US":
                case "es-AR":
                case "es-BO":
                case "es-CL":
                case "es-CO":
                case "es-CR":
                case "es-DO":
                case "es-EC":
                case "es-GT":
                case "es-HN":
                case "es-MX":
                case "es-NI":
                case "es-PA":
                case "es-PE":
                case "es-PR":
                case "es-SV":
                case "es-VE":
                case "pt-BR":
                    return "US";
                case "ar":
                case "ar-AE":
                case "ar-BH":
                case "ar-DZ":
                case "ar-EG":
                case "ar-IQ":
                case "ar-JO":
                case "ar-KW":
                case "ar-LY":
                case "ar-OM":
                case "ar-QA":
                case "ar-SA":
                case "ar-SD":
                case "ar-SY":
                case "ar-YE":
                case "dv":
                case "dv-MV":
                case "ps":
                case "ps-AR":
                    return "Arabic";
                case "he":
                case "he-IL":
                    return "Hebrew";
                default:
                    return "ISO 8601";
            }
        }();
        function renderWeekdays() {
            return _react2["default"].createElement(_Weekdays["default"], {
                calendarType: calendarType,
                formatShortWeekday: formatShortWeekday2,
                locale: locale2,
                onMouseLeave: onMouseLeave
            });
        }
        function renderWeekNumbers() {
            if (!showWeekNumbers) return null;
            return _react2["default"].createElement(_WeekNumbers["default"], {
                activeStartDate: activeStartDate,
                calendarType: calendarType,
                onClickWeekNumber: onClickWeekNumber,
                onMouseLeave: onMouseLeave,
                showFixedNumberOfWeeks: showFixedNumberOfWeeks
            });
        }
        function renderDays() {
            return _react2["default"].createElement(_Days["default"], _extends2({
                calendarType: calendarType
            }, childProps));
        }
        var className = "react-calendar__month-view";
        return _react2["default"].createElement("div", {
            className: [
                className,
                showWeekNumbers ? "".concat(className, "--weekNumbers") : ""
            ].join(" ")
        }, _react2["default"].createElement("div", {
            style: {
                display: "flex",
                alignItems: "flex-end"
            }
        }, renderWeekNumbers(), _react2["default"].createElement("div", {
            style: {
                flexGrow: 1,
                width: "100%"
            }
        }, renderWeekdays(), renderDays())));
    }
    MonthView2.propTypes = {
        activeStartDate: _propTypes2["default"].instanceOf(Date).isRequired,
        calendarType: _propTypes22.isCalendarType,
        formatShortWeekday: _propTypes2["default"].func,
        locale: _propTypes2["default"].string,
        maxDate: _propTypes22.isMaxDate,
        minDate: _propTypes22.isMinDate,
        onChange: _propTypes2["default"].func,
        onClickWeekNumber: _propTypes2["default"].func,
        onMouseLeave: _propTypes2["default"].func,
        setActiveRange: _propTypes2["default"].func,
        showFixedNumberOfWeeks: _propTypes2["default"].bool,
        showNeighboringMonth: _propTypes2["default"].bool,
        showWeekNumbers: _propTypes2["default"].bool,
        value: _propTypes22.isValue,
        valueType: _propTypes2["default"].string
    };
})(MonthView);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    exports2["default"] = void 0;
    var _react2 = _interopRequireWildcard2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _reactLifecyclesCompat2 = require$$2;
    var _mergeClassNames = _interopRequireDefault2(require$$3$1);
    var _Navigation = _interopRequireDefault2(Navigation$1);
    var _CenturyView = _interopRequireDefault2(CenturyView);
    var _DecadeView = _interopRequireDefault2(DecadeView);
    var _YearView = _interopRequireDefault2(YearView);
    var _MonthView = _interopRequireDefault2(MonthView);
    var _dates2 = dates;
    var _propTypes22 = propTypes;
    var _utils = utils;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _interopRequireWildcard2(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                    else newObj[key] = obj[key];
                }
            }
            newObj["default"] = obj;
            return newObj;
        }
    }
    function _typeof2(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
            return typeof obj2;
        };
        else _typeof2 = function _typeof3(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
        return _typeof2(obj);
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target2, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target2, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _possibleConstructorReturn(self2, call2) {
        if (call2 && (_typeof2(call2) === "object" || typeof call2 === "function")) return call2;
        return _assertThisInitialized(self2);
    }
    function _getPrototypeOf(o2) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
            return o3.__proto__ || Object.getPrototypeOf(o3);
        };
        return _getPrototypeOf(o2);
    }
    function _assertThisInitialized(self2) {
        if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self2;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o2, p2) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
            o3.__proto__ = p3;
            return o3;
        };
        return _setPrototypeOf(o2, p2);
    }
    function _defineProperty(obj, key, value2) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value2,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value2;
        return obj;
    }
    function _toConsumableArray2(arr) {
        return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _nonIterableSpread2();
    }
    function _nonIterableSpread2() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _iterableToArray2(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _arrayWithoutHoles2(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    var baseClassName = "react-calendar";
    var allViews2 = [
        "century",
        "decade",
        "year",
        "month"
    ];
    var allValueTypes = [].concat(_toConsumableArray2(allViews2.slice(1)), [
        "day"
    ]);
    var datesAreDifferent = function datesAreDifferent2(date1, date2) {
        return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
    };
    var getLimitedViews = function getLimitedViews2(minDetail, maxDetail) {
        return allViews2.slice(allViews2.indexOf(minDetail), allViews2.indexOf(maxDetail) + 1);
    };
    var isViewAllowed = function isViewAllowed2(view, minDetail, maxDetail) {
        var views = getLimitedViews(minDetail, maxDetail);
        return views.indexOf(view) !== -1;
    };
    var getView = function getView2(view, minDetail, maxDetail) {
        if (isViewAllowed(view, minDetail, maxDetail)) return view;
        return getLimitedViews(minDetail, maxDetail).pop();
    };
    var getValueType = function getValueType2(maxDetail) {
        return allValueTypes[allViews2.indexOf(maxDetail)];
    };
    var getValueFrom = function getValueFrom2(value2) {
        if (!value2) return null;
        var rawValueFrom = value2 instanceof Array && value2.length === 2 ? value2[0] : value2;
        if (!rawValueFrom) return null;
        var valueFromDate = new Date(rawValueFrom);
        if (isNaN(valueFromDate.getTime())) throw new Error("Invalid date: ".concat(value2));
        return valueFromDate;
    };
    var getDetailValueFrom = function getDetailValueFrom2(value2, minDate, maxDate, maxDetail) {
        var valueFrom = getValueFrom(value2);
        if (!valueFrom) return null;
        var detailValueFrom = (0, _dates2.getBegin)(getValueType(maxDetail), valueFrom);
        return (0, _utils.between)(detailValueFrom, minDate, maxDate);
    };
    var getValueTo = function getValueTo2(value2) {
        if (!value2) return null;
        var rawValueTo = value2 instanceof Array && value2.length === 2 ? value2[1] : value2;
        if (!rawValueTo) return null;
        var valueToDate = new Date(rawValueTo);
        if (isNaN(valueToDate.getTime())) throw new Error("Invalid date: ".concat(value2));
        return valueToDate;
    };
    var getDetailValueTo = function getDetailValueTo2(value2, minDate, maxDate, maxDetail) {
        var valueTo = getValueTo(value2);
        if (!valueTo) return null;
        var detailValueTo = (0, _dates2.getEnd)(getValueType(maxDetail), valueTo);
        return (0, _utils.between)(detailValueTo, minDate, maxDate);
    };
    var getDetailValueArray = function getDetailValueArray2(value2, minDate, maxDate, maxDetail) {
        if (value2 instanceof Array) return value2;
        return [
            getDetailValueFrom(value2, minDate, maxDate, maxDetail),
            getDetailValueTo(value2, minDate, maxDate, maxDetail)
        ];
    };
    var getActiveStartDate = function getActiveStartDate2(props) {
        var activeStartDate = props.activeStartDate, maxDate = props.maxDate, maxDetail = props.maxDetail, minDate = props.minDate, minDetail = props.minDetail, value2 = props.value, view = props.view;
        var rangeType = getView(view, minDetail, maxDetail);
        var valueFrom = getDetailValueFrom(value2, minDate, maxDate, maxDetail) || activeStartDate || /* @__PURE__ */ new Date();
        return (0, _dates2.getBegin)(rangeType, valueFrom);
    };
    var Calendar2 = /* @__PURE__ */ function(_Component) {
        _inherits(Calendar3, _Component);
        function Calendar3() {
            var _getPrototypeOf2;
            var _this;
            _classCallCheck(this, Calendar3);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar3)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            _defineProperty(_assertThisInitialized(_this), "state", {});
            _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function(activeStartDate) {
                var onActiveDateChange = _this.props.onActiveDateChange;
                _this.setState({
                    activeStartDate: activeStartDate
                }, function() {
                    var view = _this.state.view;
                    (0, _utils.callIfDefined)(onActiveDateChange, {
                        activeStartDate: activeStartDate,
                        view: view
                    });
                });
            });
            _defineProperty(_assertThisInitialized(_this), "drillDown", function(activeStartDate) {
                if (!_this.drillDownAvailable) return;
                var _this$props = _this.props, maxDetail = _this$props.maxDetail, minDetail = _this$props.minDetail, onDrillDown = _this$props.onDrillDown;
                var views = getLimitedViews(minDetail, maxDetail);
                _this.setState(function(prevState) {
                    var nextView = views[views.indexOf(prevState.view) + 1];
                    return {
                        activeStartDate: activeStartDate,
                        view: nextView
                    };
                }, function() {
                    var view = _this.state.view;
                    (0, _utils.callIfDefined)(onDrillDown, {
                        activeStartDate: activeStartDate,
                        view: view
                    });
                });
            });
            _defineProperty(_assertThisInitialized(_this), "drillUp", function() {
                if (!_this.drillUpAvailable) return;
                var _this$props2 = _this.props, maxDetail = _this$props2.maxDetail, minDetail = _this$props2.minDetail, onDrillUp = _this$props2.onDrillUp;
                var views = getLimitedViews(minDetail, maxDetail);
                _this.setState(function(prevState) {
                    var nextView = views[views.indexOf(prevState.view) - 1];
                    var activeStartDate = (0, _dates2.getBegin)(nextView, prevState.activeStartDate);
                    return {
                        activeStartDate: activeStartDate,
                        view: nextView
                    };
                }, function() {
                    var _this$state = _this.state, activeStartDate = _this$state.activeStartDate, view = _this$state.view;
                    (0, _utils.callIfDefined)(onDrillUp, {
                        activeStartDate: activeStartDate,
                        view: view
                    });
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onChange", function(value2) {
                var _this$props3 = _this.props, onChange = _this$props3.onChange, selectRange = _this$props3.selectRange;
                var nextValue;
                var callback;
                if (selectRange) {
                    var previousValue = _this.state.value;
                    if (!previousValue || [].concat(previousValue).length !== 1) nextValue = (0, _dates2.getBegin)(_this.valueType, value2);
                    else {
                        nextValue = (0, _dates2.getValueRange)(_this.valueType, previousValue, value2);
                        callback = function callback2() {
                            return (0, _utils.callIfDefined)(onChange, nextValue);
                        };
                    }
                } else {
                    nextValue = _this.getProcessedValue(value2);
                    callback = function callback2() {
                        return (0, _utils.callIfDefined)(onChange, nextValue);
                    };
                }
                _this.setState({
                    value: nextValue
                }, callback);
            });
            _defineProperty(_assertThisInitialized(_this), "onMouseOver", function(value2) {
                _this.setState(function(prevState) {
                    if (prevState.hover && prevState.hover.getTime() === value2.getTime()) return null;
                    return {
                        hover: value2
                    };
                });
            });
            _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function() {
                _this.setState({
                    hover: null
                });
            });
            return _this;
        }
        _createClass(Calendar3, [
            {
                key: "getProcessedValue",
                /**
       * Gets current value in a desired format.
       */ value: function getProcessedValue(value2) {
                    var _this$props4 = this.props, minDate = _this$props4.minDate, maxDate = _this$props4.maxDate, maxDetail = _this$props4.maxDetail, returnValue = _this$props4.returnValue;
                    var processFunction = function() {
                        switch(returnValue){
                            case "start":
                                return getDetailValueFrom;
                            case "end":
                                return getDetailValueTo;
                            case "range":
                                return getDetailValueArray;
                            default:
                                throw new Error("Invalid returnValue.");
                        }
                    }();
                    return processFunction(value2, minDate, maxDate, maxDetail);
                }
            },
            {
                key: "renderContent",
                value: function renderContent() {
                    var _this$props5 = this.props, calendarType = _this$props5.calendarType, locale2 = _this$props5.locale, maxDate = _this$props5.maxDate, minDate = _this$props5.minDate, renderChildren = _this$props5.renderChildren, selectRange = _this$props5.selectRange, tileClassName = _this$props5.tileClassName, tileContent = _this$props5.tileContent, tileDisabled = _this$props5.tileDisabled;
                    var _this$state2 = this.state, activeStartDate = _this$state2.activeStartDate, hover = _this$state2.hover, value2 = _this$state2.value, view = _this$state2.view;
                    var onMouseOver = this.onMouseOver, valueType = this.valueType;
                    var commonProps = {
                        activeStartDate: activeStartDate,
                        hover: hover,
                        locale: locale2,
                        maxDate: maxDate,
                        minDate: minDate,
                        onMouseOver: selectRange ? onMouseOver : null,
                        tileClassName: tileClassName,
                        tileContent: tileContent || renderChildren,
                        tileDisabled: // For backwards compatibility
                        tileDisabled,
                        value: value2,
                        valueType: valueType
                    };
                    var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;
                    switch(view){
                        case "century":
                            var onClickDecade = this.props.onClickDecade;
                            return _react2["default"].createElement(_CenturyView["default"], _extends2({
                                onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
                            }, commonProps));
                        case "decade":
                            var onClickYear = this.props.onClickYear;
                            return _react2["default"].createElement(_DecadeView["default"], _extends2({
                                onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
                            }, commonProps));
                        case "year":
                            var _this$props6 = this.props, formatMonth2 = _this$props6.formatMonth, onClickMonth = _this$props6.onClickMonth;
                            return _react2["default"].createElement(_YearView["default"], _extends2({
                                formatMonth: formatMonth2,
                                onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
                            }, commonProps));
                        case "month":
                            var _this$props7 = this.props, formatShortWeekday2 = _this$props7.formatShortWeekday, onClickDay = _this$props7.onClickDay, onClickWeekNumber = _this$props7.onClickWeekNumber, showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks, showNeighboringMonth = _this$props7.showNeighboringMonth, showWeekNumbers = _this$props7.showWeekNumbers;
                            var onMouseLeave = this.onMouseLeave;
                            return _react2["default"].createElement(_MonthView["default"], _extends2({
                                calendarType: calendarType,
                                formatShortWeekday: formatShortWeekday2,
                                onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
                                onClickWeekNumber: onClickWeekNumber,
                                onMouseLeave: onMouseLeave,
                                showFixedNumberOfWeeks: showFixedNumberOfWeeks,
                                showNeighboringMonth: showNeighboringMonth,
                                showWeekNumbers: showWeekNumbers
                            }, commonProps));
                        default:
                            throw new Error("Invalid view: ".concat(view, "."));
                    }
                }
            },
            {
                key: "renderNavigation",
                value: function renderNavigation() {
                    var showNavigation = this.props.showNavigation;
                    if (!showNavigation) return null;
                    var _this$props8 = this.props, formatMonthYear2 = _this$props8.formatMonthYear, locale2 = _this$props8.locale, maxDate = _this$props8.maxDate, maxDetail = _this$props8.maxDetail, minDate = _this$props8.minDate, minDetail = _this$props8.minDetail, navigationAriaLabel = _this$props8.navigationAriaLabel, navigationLabel = _this$props8.navigationLabel, next2AriaLabel = _this$props8.next2AriaLabel, next2Label = _this$props8.next2Label, nextAriaLabel = _this$props8.nextAriaLabel, nextLabel = _this$props8.nextLabel, prev2AriaLabel = _this$props8.prev2AriaLabel, prev2Label = _this$props8.prev2Label, prevAriaLabel = _this$props8.prevAriaLabel, prevLabel = _this$props8.prevLabel;
                    var _this$state3 = this.state, activeStartDate = _this$state3.activeStartDate, view = _this$state3.view;
                    return _react2["default"].createElement(_Navigation["default"], {
                        activeStartDate: activeStartDate,
                        drillUp: this.drillUp,
                        formatMonthYear: formatMonthYear2,
                        locale: locale2,
                        maxDate: maxDate,
                        minDate: minDate,
                        navigationAriaLabel: navigationAriaLabel,
                        navigationLabel: navigationLabel,
                        next2AriaLabel: next2AriaLabel,
                        next2Label: next2Label,
                        nextAriaLabel: nextAriaLabel,
                        nextLabel: nextLabel,
                        prev2AriaLabel: prev2AriaLabel,
                        prev2Label: prev2Label,
                        prevAriaLabel: prevAriaLabel,
                        prevLabel: prevLabel,
                        setActiveStartDate: this.setActiveStartDate,
                        view: view,
                        views: getLimitedViews(minDetail, maxDetail)
                    });
                }
            },
            {
                key: "render",
                value: function render2() {
                    var _this$props9 = this.props, className = _this$props9.className, selectRange = _this$props9.selectRange;
                    var value2 = this.state.value;
                    var onMouseLeave = this.onMouseLeave;
                    var valueArray = [].concat(value2);
                    return _react2["default"].createElement("div", {
                        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
                    }, this.renderNavigation(), _react2["default"].createElement("div", {
                        className: "".concat(baseClassName, "__viewContainer"),
                        onBlur: selectRange ? onMouseLeave : null,
                        onMouseLeave: selectRange ? onMouseLeave : null
                    }, this.renderContent()));
                }
            },
            {
                key: "drillDownAvailable",
                get: function get2() {
                    var _this$props10 = this.props, maxDetail = _this$props10.maxDetail, minDetail = _this$props10.minDetail;
                    var view = this.state.view;
                    var views = getLimitedViews(minDetail, maxDetail);
                    return views.indexOf(view) < views.length - 1;
                }
            },
            {
                key: "drillUpAvailable",
                get: function get2() {
                    var _this$props11 = this.props, maxDetail = _this$props11.maxDetail, minDetail = _this$props11.minDetail;
                    var view = this.state.view;
                    var views = getLimitedViews(minDetail, maxDetail);
                    return views.indexOf(view) > 0;
                }
            },
            {
                key: "valueType",
                get: function get2() {
                    var maxDetail = this.props.maxDetail;
                    return getValueType(maxDetail);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, prevState) {
                    nextProps.minDate;
                    nextProps.maxDate;
                    var minDetail = nextProps.minDetail, maxDetail = nextProps.maxDetail;
                    var nextState = {};
                    var nextActiveStartDate = getActiveStartDate(nextProps);
                    if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
                        nextState.activeStartDate = nextActiveStartDate;
                        nextState.activeStartDateProps = nextActiveStartDate;
                    }
                    var nextView = getView(nextProps.view, minDetail, maxDetail);
                    if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
                        nextState.view = nextView;
                        nextState.viewProps = nextView;
                    }
                    var values2 = [
                        nextProps.value,
                        prevState.valueProps
                    ];
                    if (nextState.view || datesAreDifferent.apply(void 0, _toConsumableArray2(values2.map(function(value2) {
                        return getValueFrom(value2);
                    }))) || datesAreDifferent.apply(void 0, _toConsumableArray2(values2.map(function(value2) {
                        return getValueTo(value2);
                    })))) {
                        nextState.value = nextProps.value;
                        nextState.valueProps = nextProps.value;
                    }
                    if (!nextProps.selectRange && prevState.hover) nextState.hover = null;
                    return nextState;
                }
            }
        ]);
        return Calendar3;
    }(_react2.Component);
    exports2["default"] = Calendar2;
    Calendar2.defaultProps = {
        maxDetail: "month",
        minDetail: "century",
        returnValue: "start",
        showNavigation: true,
        showNeighboringMonth: true,
        view: "month"
    };
    Calendar2.propTypes = {
        activeStartDate: _propTypes2["default"].instanceOf(Date),
        calendarType: _propTypes22.isCalendarType,
        className: _propTypes22.isClassName,
        formatMonth: _propTypes2["default"].func,
        formatMonthYear: _propTypes2["default"].func,
        formatShortWeekday: _propTypes2["default"].func,
        locale: _propTypes2["default"].string,
        maxDate: _propTypes22.isMaxDate,
        maxDetail: _propTypes2["default"].oneOf(allViews2),
        minDate: _propTypes22.isMinDate,
        minDetail: _propTypes2["default"].oneOf(allViews2),
        navigationAriaLabel: _propTypes2["default"].string,
        navigationLabel: _propTypes2["default"].func,
        next2AriaLabel: _propTypes2["default"].string,
        next2Label: _propTypes2["default"].node,
        nextAriaLabel: _propTypes2["default"].string,
        nextLabel: _propTypes2["default"].node,
        onActiveDateChange: _propTypes2["default"].func,
        onChange: _propTypes2["default"].func,
        onClickDay: _propTypes2["default"].func,
        onClickDecade: _propTypes2["default"].func,
        onClickMonth: _propTypes2["default"].func,
        onClickWeekNumber: _propTypes2["default"].func,
        onClickYear: _propTypes2["default"].func,
        onDrillDown: _propTypes2["default"].func,
        onDrillUp: _propTypes2["default"].func,
        prev2AriaLabel: _propTypes2["default"].string,
        prev2Label: _propTypes2["default"].node,
        prevAriaLabel: _propTypes2["default"].string,
        prevLabel: _propTypes2["default"].node,
        renderChildren: _propTypes2["default"].func,
        // For backwards compatibility
        returnValue: _propTypes2["default"].oneOf([
            "start",
            "end",
            "range"
        ]),
        selectRange: _propTypes2["default"].bool,
        showFixedNumberOfWeeks: _propTypes2["default"].bool,
        showNavigation: _propTypes2["default"].bool,
        showNeighboringMonth: _propTypes2["default"].bool,
        showWeekNumbers: _propTypes2["default"].bool,
        tileClassName: _propTypes2["default"].oneOfType([
            _propTypes2["default"].func,
            _propTypes22.isClassName
        ]),
        tileContent: _propTypes2["default"].oneOfType([
            _propTypes2["default"].func,
            _propTypes2["default"].node
        ]),
        tileDisabled: _propTypes2["default"].func,
        value: _propTypes2["default"].oneOfType([
            _propTypes2["default"].string,
            _propTypes22.isValue
        ]),
        view: _propTypes2["default"].oneOf(allViews2)
    };
    (0, _reactLifecyclesCompat2.polyfill)(Calendar2);
})(Calendar);
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    Object.defineProperty(exports2, "Calendar", {
        enumerable: true,
        get: function get2() {
            return _Calendar["default"];
        }
    });
    Object.defineProperty(exports2, "CenturyView", {
        enumerable: true,
        get: function get2() {
            return _CenturyView["default"];
        }
    });
    Object.defineProperty(exports2, "DecadeView", {
        enumerable: true,
        get: function get2() {
            return _DecadeView["default"];
        }
    });
    Object.defineProperty(exports2, "YearView", {
        enumerable: true,
        get: function get2() {
            return _YearView["default"];
        }
    });
    Object.defineProperty(exports2, "MonthView", {
        enumerable: true,
        get: function get2() {
            return _MonthView["default"];
        }
    });
    exports2["default"] = void 0;
    var _Calendar = _interopRequireDefault2(Calendar);
    var _CenturyView = _interopRequireDefault2(CenturyView);
    var _DecadeView = _interopRequireDefault2(DecadeView);
    var _YearView = _interopRequireDefault2(YearView);
    var _MonthView = _interopRequireDefault2(MonthView);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var _default2 = _Calendar["default"];
    exports2["default"] = _default2;
})(entry_nostyle);
const container$f = "ScrollableComponent-scss--module__container___MmBO4";
const s$3d = {
    container: container$f
};
const SCROLL_TIMEOUT = 100;
class ScrollableComponentWithoutRef extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.containerRef = this.props.innerRef || $acw62.createRef();
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.scrollInterval = null;
        this.state = {
            hasScrolled: false
        };
        this.onScroll = (e2)=>{
            const { onScroll } = this.props;
            const { scrollTop, scrollLeft } = this.containerRef.current;
            if (scrollTop !== this.scrollTop || scrollLeft !== this.scrollLeft) {
                this.clearScrollInterval();
                this.setState({
                    hasScrolled: true
                });
            }
            if (onScroll) onScroll(e2);
        };
        this.onResize = ()=>{
            this.setScrollInterval();
        };
    }
    componentDidMount() {
        this.scroll();
        this.setScrollInterval();
        window.addEventListener("resize", this.onResize);
        window.addEventListener("orientationchange", this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("orientationchange", this.onResize);
        this.clearScrollInterval();
    }
    setScrollInterval() {
        var _a3;
        if (this.scrollInterval === null && ((_a3 = this.containerRef) == null ? void 0 : _a3.current)) {
            this.scrollTop = this.containerRef.current.scrollTop;
            this.scrollLeft = this.containerRef.current.scrollLeft;
            this.scrollInterval = window.setInterval(()=>this.scroll(), SCROLL_TIMEOUT);
            this.setState({
                hasScrolled: false
            });
        }
    }
    clearScrollInterval() {
        window.clearInterval(this.scrollInterval);
        this.scrollInterval = null;
    }
    scroll() {
        var _a3;
        if ((_a3 = this.containerRef) == null ? void 0 : _a3.current) {
            this.containerRef.current.scrollTop += 1;
            this.containerRef.current.scrollTop -= 1;
        }
    }
    render() {
        const onScroll = this.state.hasScrolled && !this.props.onScroll ? null : this.onScroll;
        return /* @__PURE__ */ $acw62.createElement("div", {
            ref: this.containerRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3d.container, this.props.className),
            onScroll: onScroll,
            onClick: this.props.onClick,
            style: this.props.style,
            "data-role": EHTMLDataRole.SCROLL
        }, this.props.children);
    }
}
const ScrollableComponent = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ScrollableComponentWithoutRef, {
        innerRef: ref2,
        ...props
    }, props.children));
var ESelectTestId = /* @__PURE__ */ ((ESelectTestId2)=>{
    ESelectTestId2["ROOT"] = "ROOT";
    ESelectTestId2["TOGGLE"] = "TOGGLE";
    ESelectTestId2["SIMPLE_OPTION"] = "SIMPLE_OPTION";
    ESelectTestId2["CHECKING_OPTION"] = "CHECKING_OPTION";
    return ESelectTestId2;
})(ESelectTestId || {});
var reactTextMask = {
    exports: {}
};
(function(module2, exports2) {
    !function(e2, t2) {
        module2.exports = t2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    }(commonjsGlobal, function(e2) {
        return function(e3) {
            function t2(n2) {
                if (r2[n2]) return r2[n2].exports;
                var o2 = r2[n2] = {
                    exports: {},
                    id: n2,
                    loaded: false
                };
                return e3[n2].call(o2.exports, o2, o2.exports, t2), o2.loaded = true, o2.exports;
            }
            var r2 = {};
            return t2.m = e3, t2.c = r2, t2.p = "", t2(0);
        }([
            function(e3, t2, r2) {
                function n2(e4) {
                    return e4 && e4.__esModule ? e4 : {
                        default: e4
                    };
                }
                function o2(e4, t3) {
                    var r3 = {};
                    for(var n3 in e4)t3.indexOf(n3) >= 0 || Object.prototype.hasOwnProperty.call(e4, n3) && (r3[n3] = e4[n3]);
                    return r3;
                }
                function i(e4, t3) {
                    if (!(e4 instanceof t3)) throw new TypeError("Cannot call a class as a function");
                }
                function a2(e4, t3) {
                    if (!e4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t3 || "object" != typeof t3 && "function" != typeof t3 ? e4 : t3;
                }
                function u2(e4, t3) {
                    if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function, not " + typeof t3);
                    e4.prototype = Object.create(t3 && t3.prototype, {
                        constructor: {
                            value: e4,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    }), t3 && (Object.setPrototypeOf ? Object.setPrototypeOf(e4, t3) : e4.__proto__ = t3);
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                }), t2.conformToMask = void 0;
                var s2 = Object.assign || function(e4) {
                    for(var t3 = 1; t3 < arguments.length; t3++){
                        var r3 = arguments[t3];
                        for(var n3 in r3)Object.prototype.hasOwnProperty.call(r3, n3) && (e4[n3] = r3[n3]);
                    }
                    return e4;
                }, l2 = /* @__PURE__ */ function() {
                    function e4(e5, t3) {
                        for(var r3 = 0; r3 < t3.length; r3++){
                            var n3 = t3[r3];
                            n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(e5, n3.key, n3);
                        }
                    }
                    return function(t3, r3, n3) {
                        return r3 && e4(t3.prototype, r3), n3 && e4(t3, n3), t3;
                    };
                }(), f2 = r2(3);
                Object.defineProperty(t2, "conformToMask", {
                    enumerable: true,
                    get: function() {
                        return n2(f2).default;
                    }
                });
                var c2 = r2(11), p2 = n2(c2), d2 = r2(9), h2 = n2(d2), v2 = r2(5), y2 = n2(v2), m2 = r2(2), b2 = function(e4) {
                    function t3() {
                        var e5;
                        i(this, t3);
                        for(var r3 = arguments.length, n3 = Array(r3), o3 = 0; o3 < r3; o3++)n3[o3] = arguments[o3];
                        var u3 = a2(this, (e5 = t3.__proto__ || Object.getPrototypeOf(t3)).call.apply(e5, [
                            this
                        ].concat(n3)));
                        return u3.setRef = u3.setRef.bind(u3), u3.onBlur = u3.onBlur.bind(u3), u3.onChange = u3.onChange.bind(u3), u3;
                    }
                    return u2(t3, e4), l2(t3, [
                        {
                            key: "setRef",
                            value: function(e5) {
                                this.inputElement = e5;
                            }
                        },
                        {
                            key: "initTextMask",
                            value: function() {
                                var e5 = this.props, t4 = this.props.value;
                                this.textMaskInputElement = (0, y2.default)(s2({
                                    inputElement: this.inputElement
                                }, e5)), this.textMaskInputElement.update(t4);
                            }
                        },
                        {
                            key: "componentDidMount",
                            value: function() {
                                this.initTextMask();
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(e5) {
                                var t4 = this.props, r3 = t4.value, n3 = t4.pipe, o3 = t4.mask, i2 = t4.guide, a3 = t4.placeholderChar, u3 = t4.showMask, s3 = {
                                    guide: i2,
                                    placeholderChar: a3,
                                    showMask: u3
                                }, l3 = "function" == typeof n3 && "function" == typeof e5.pipe ? n3.toString() !== e5.pipe.toString() : (0, m2.isNil)(n3) && !(0, m2.isNil)(e5.pipe) || !(0, m2.isNil)(n3) && (0, m2.isNil)(e5.pipe), f3 = o3.toString() !== e5.mask.toString(), c3 = Object.keys(s3).some(function(t5) {
                                    return s3[t5] !== e5[t5];
                                }) || f3 || l3, p3 = r3 !== this.inputElement.value;
                                (p3 || c3) && this.initTextMask();
                            }
                        },
                        {
                            key: "render",
                            value: function e5() {
                                var t4 = this.props, e6 = t4.render, r3 = o2(t4, [
                                    "render"
                                ]);
                                return delete r3.mask, delete r3.guide, delete r3.pipe, delete r3.placeholderChar, delete r3.keepCharPositions, delete r3.value, delete r3.onBlur, delete r3.onChange, delete r3.showMask, e6(this.setRef, s2({
                                    onBlur: this.onBlur,
                                    onChange: this.onChange,
                                    defaultValue: this.props.value
                                }, r3));
                            }
                        },
                        {
                            key: "onChange",
                            value: function(e5) {
                                this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e5);
                            }
                        },
                        {
                            key: "onBlur",
                            value: function(e5) {
                                "function" == typeof this.props.onBlur && this.props.onBlur(e5);
                            }
                        }
                    ]), t3;
                }(p2.default.PureComponent);
                t2.default = b2, b2.propTypes = {
                    mask: h2.default.oneOfType([
                        h2.default.array,
                        h2.default.func,
                        h2.default.bool,
                        h2.default.shape({
                            mask: h2.default.oneOfType([
                                h2.default.array,
                                h2.default.func
                            ]),
                            pipe: h2.default.func
                        })
                    ]).isRequired,
                    guide: h2.default.bool,
                    value: h2.default.oneOfType([
                        h2.default.string,
                        h2.default.number
                    ]),
                    pipe: h2.default.func,
                    placeholderChar: h2.default.string,
                    keepCharPositions: h2.default.bool,
                    showMask: h2.default.bool
                }, b2.defaultProps = {
                    render: function(e4, t3) {
                        return p2.default.createElement("input", s2({
                            ref: e4
                        }, t3));
                    }
                };
            },
            function(e3, t2) {
                Object.defineProperty(t2, "__esModule", {
                    value: true
                }), t2.placeholderChar = "_", t2.strFunction = "function";
            },
            function(e3, t2, r2) {
                function n2() {
                    var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f2, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l2.placeholderChar;
                    if (!o2(e4)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
                    if (e4.indexOf(t3) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t3) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e4)));
                    return e4.map(function(e5) {
                        return e5 instanceof RegExp ? t3 : e5;
                    }).join("");
                }
                function o2(e4) {
                    return Array.isArray && Array.isArray(e4) || e4 instanceof Array;
                }
                function i(e4) {
                    return "string" == typeof e4 || e4 instanceof String;
                }
                function a2(e4) {
                    return "number" == typeof e4 && void 0 === e4.length && !isNaN(e4);
                }
                function u2(e4) {
                    return "undefined" == typeof e4 || null === e4;
                }
                function s2(e4) {
                    for(var t3 = [], r3 = void 0; r3 = e4.indexOf(c2), r3 !== -1;)t3.push(r3), e4.splice(r3, 1);
                    return {
                        maskWithoutCaretTraps: e4,
                        indexes: t3
                    };
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                }), t2.convertMaskToPlaceholder = n2, t2.isArray = o2, t2.isString = i, t2.isNumber = a2, t2.isNil = u2, t2.processCaretTraps = s2;
                var l2 = r2(1), f2 = [], c2 = "[]";
            },
            function(e3, t2, r2) {
                function n2() {
                    var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s2, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u2, r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    if (!(0, i.isArray)(t3)) {
                        if (("undefined" == typeof t3 ? "undefined" : o2(t3)) !== a2.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
                        t3 = t3(e4, r3), t3 = (0, i.processCaretTraps)(t3).maskWithoutCaretTraps;
                    }
                    var n3 = r3.guide, l2 = void 0 === n3 || n3, f2 = r3.previousConformedValue, c2 = void 0 === f2 ? s2 : f2, p2 = r3.placeholderChar, d2 = void 0 === p2 ? a2.placeholderChar : p2, h2 = r3.placeholder, v2 = void 0 === h2 ? (0, i.convertMaskToPlaceholder)(t3, d2) : h2, y2 = r3.currentCaretPosition, m2 = r3.keepCharPositions, b2 = l2 === false && void 0 !== c2, g2 = e4.length, k2 = c2.length, C = v2.length, O2 = t3.length, T2 = g2 - k2, P2 = T2 > 0, x2 = y2 + (P2 ? -T2 : 0), w2 = x2 + Math.abs(T2);
                    if (m2 === true && !P2) {
                        for(var S2 = s2, _2 = x2; _2 < w2; _2++)v2[_2] === d2 && (S2 += d2);
                        e4 = e4.slice(0, x2) + S2 + e4.slice(x2, g2);
                    }
                    for(var M2 = e4.split(s2).map(function(e5, t4) {
                        return {
                            char: e5,
                            isNew: t4 >= x2 && t4 < w2
                        };
                    }), j2 = g2 - 1; j2 >= 0; j2--){
                        var E2 = M2[j2].char;
                        if (E2 !== d2) {
                            var R2 = j2 >= x2 && k2 === O2;
                            E2 === v2[R2 ? j2 - T2 : j2] && M2.splice(j2, 1);
                        }
                    }
                    var V2 = s2, N = false;
                    e: for(var A2 = 0; A2 < C; A2++){
                        var B3 = v2[A2];
                        if (B3 === d2) {
                            if (M2.length > 0) for(; M2.length > 0;){
                                var I2 = M2.shift(), F2 = I2.char, q2 = I2.isNew;
                                if (F2 === d2 && b2 !== true) {
                                    V2 += d2;
                                    continue e;
                                }
                                if (t3[A2].test(F2)) {
                                    if (m2 === true && q2 !== false && c2 !== s2 && l2 !== false && P2) {
                                        for(var D2 = M2.length, L2 = null, W2 = 0; W2 < D2; W2++){
                                            var J = M2[W2];
                                            if (J.char !== d2 && J.isNew === false) break;
                                            if (J.char === d2) {
                                                L2 = W2;
                                                break;
                                            }
                                        }
                                        null !== L2 ? (V2 += F2, M2.splice(L2, 1)) : A2--;
                                    } else V2 += F2;
                                    continue e;
                                }
                                N = true;
                            }
                            b2 === false && (V2 += v2.substr(A2, C));
                            break;
                        }
                        V2 += B3;
                    }
                    if (b2 && P2 === false) {
                        for(var U2 = null, H4 = 0; H4 < V2.length; H4++)v2[H4] === d2 && (U2 = H4);
                        V2 = null !== U2 ? V2.substr(0, U2 + 1) : s2;
                    }
                    return {
                        conformedValue: V2,
                        meta: {
                            someCharsRejected: N
                        }
                    };
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                });
                var o2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
                    return typeof e4;
                } : function(e4) {
                    return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
                };
                t2.default = n2;
                var i = r2(2), a2 = r2(1), u2 = [], s2 = "";
            },
            function(e3, t2) {
                function r2(e4) {
                    var t3 = e4.previousConformedValue, r3 = void 0 === t3 ? o2 : t3, i = e4.previousPlaceholder, a2 = void 0 === i ? o2 : i, u2 = e4.currentCaretPosition, s2 = void 0 === u2 ? 0 : u2, l2 = e4.conformedValue, f2 = e4.rawValue, c2 = e4.placeholderChar, p2 = e4.placeholder, d2 = e4.indexesOfPipedChars, h2 = void 0 === d2 ? n2 : d2, v2 = e4.caretTrapIndexes, y2 = void 0 === v2 ? n2 : v2;
                    if (0 === s2 || !f2.length) return 0;
                    var m2 = f2.length, b2 = r3.length, g2 = p2.length, k2 = l2.length, C = m2 - b2, O2 = C > 0, T2 = 0 === b2, P2 = C > 1 && !O2 && !T2;
                    if (P2) return s2;
                    var x2 = O2 && (r3 === l2 || l2 === p2), w2 = 0, S2 = void 0, _2 = void 0;
                    if (x2) w2 = s2 - C;
                    else {
                        var M2 = l2.toLowerCase(), j2 = f2.toLowerCase(), E2 = j2.substr(0, s2).split(o2), R2 = E2.filter(function(e5) {
                            return M2.indexOf(e5) !== -1;
                        });
                        _2 = R2[R2.length - 1];
                        var V2 = a2.substr(0, R2.length).split(o2).filter(function(e5) {
                            return e5 !== c2;
                        }).length, N = p2.substr(0, R2.length).split(o2).filter(function(e5) {
                            return e5 !== c2;
                        }).length, A2 = N !== V2, B3 = void 0 !== a2[R2.length - 1] && void 0 !== p2[R2.length - 2] && a2[R2.length - 1] !== c2 && a2[R2.length - 1] !== p2[R2.length - 1] && a2[R2.length - 1] === p2[R2.length - 2];
                        !O2 && (A2 || B3) && V2 > 0 && p2.indexOf(_2) > -1 && void 0 !== f2[s2] && (S2 = true, _2 = f2[s2]);
                        for(var I2 = h2.map(function(e5) {
                            return M2[e5];
                        }), F2 = I2.filter(function(e5) {
                            return e5 === _2;
                        }).length, q2 = R2.filter(function(e5) {
                            return e5 === _2;
                        }).length, D2 = p2.substr(0, p2.indexOf(c2)).split(o2).filter(function(e5, t4) {
                            return e5 === _2 && f2[t4] !== e5;
                        }).length, L2 = D2 + q2 + F2 + (S2 ? 1 : 0), W2 = 0, J = 0; J < k2; J++){
                            var U2 = M2[J];
                            if (w2 = J + 1, U2 === _2 && W2++, W2 >= L2) break;
                        }
                    }
                    if (O2) {
                        for(var H4 = w2, Y2 = w2; Y2 <= g2; Y2++)if (p2[Y2] === c2 && (H4 = Y2), p2[Y2] === c2 || y2.indexOf(Y2) !== -1 || Y2 === g2) return H4;
                    } else if (S2) {
                        for(var z2 = w2 - 1; z2 >= 0; z2--)if (l2[z2] === _2 || y2.indexOf(z2) !== -1 || 0 === z2) return z2;
                    } else for(var G2 = w2; G2 >= 0; G2--)if (p2[G2 - 1] === c2 || y2.indexOf(G2) !== -1 || 0 === G2) return G2;
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                }), t2.default = r2;
                var n2 = [], o2 = "";
            },
            function(e3, t2, r2) {
                function n2(e4) {
                    return e4 && e4.__esModule ? e4 : {
                        default: e4
                    };
                }
                function o2(e4) {
                    var t3 = {
                        previousConformedValue: void 0,
                        previousPlaceholder: void 0
                    };
                    return {
                        state: t3,
                        update: function(r3) {
                            var n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e4, o3 = n3.inputElement, l3 = n3.mask, c3 = n3.guide, y3 = n3.pipe, b3 = n3.placeholderChar, g3 = void 0 === b3 ? h2.placeholderChar : b3, k2 = n3.keepCharPositions, C = void 0 !== k2 && k2, O2 = n3.showMask, T2 = void 0 !== O2 && O2;
                            if ("undefined" == typeof r3 && (r3 = o3.value), r3 !== t3.previousConformedValue) {
                                ("undefined" == typeof l3 ? "undefined" : s2(l3)) === m2 && void 0 !== l3.pipe && void 0 !== l3.mask && (y3 = l3.pipe, l3 = l3.mask);
                                var P2 = void 0, x2 = void 0;
                                if (l3 instanceof Array && (P2 = (0, d2.convertMaskToPlaceholder)(l3, g3)), l3 !== false) {
                                    var w2 = a2(r3), S2 = o3.selectionEnd, _2 = t3.previousConformedValue, M2 = t3.previousPlaceholder, j2 = void 0;
                                    if (("undefined" == typeof l3 ? "undefined" : s2(l3)) === h2.strFunction) {
                                        if (x2 = l3(w2, {
                                            currentCaretPosition: S2,
                                            previousConformedValue: _2,
                                            placeholderChar: g3
                                        }), x2 === false) return;
                                        var E2 = (0, d2.processCaretTraps)(x2), R2 = E2.maskWithoutCaretTraps, V2 = E2.indexes;
                                        x2 = R2, j2 = V2, P2 = (0, d2.convertMaskToPlaceholder)(x2, g3);
                                    } else x2 = l3;
                                    var N = {
                                        previousConformedValue: _2,
                                        guide: c3,
                                        placeholderChar: g3,
                                        pipe: y3,
                                        placeholder: P2,
                                        currentCaretPosition: S2,
                                        keepCharPositions: C
                                    }, A2 = (0, p2.default)(w2, x2, N), B3 = A2.conformedValue, I2 = ("undefined" == typeof y3 ? "undefined" : s2(y3)) === h2.strFunction, F2 = {};
                                    I2 && (F2 = y3(B3, u2({
                                        rawValue: w2
                                    }, N)), F2 === false ? F2 = {
                                        value: _2,
                                        rejected: true
                                    } : (0, d2.isString)(F2) && (F2 = {
                                        value: F2
                                    }));
                                    var q2 = I2 ? F2.value : B3, D2 = (0, f2.default)({
                                        previousConformedValue: _2,
                                        previousPlaceholder: M2,
                                        conformedValue: q2,
                                        placeholder: P2,
                                        rawValue: w2,
                                        currentCaretPosition: S2,
                                        placeholderChar: g3,
                                        indexesOfPipedChars: F2.indexesOfPipedChars,
                                        caretTrapIndexes: j2
                                    }), L2 = q2 === P2 && 0 === D2, W2 = T2 ? P2 : v2, J = L2 ? W2 : q2;
                                    t3.previousConformedValue = J, t3.previousPlaceholder = P2, o3.value !== J && (o3.value = J, i(o3, D2));
                                }
                            }
                        }
                    };
                }
                function i(e4, t3) {
                    document.activeElement === e4 && (b2 ? g2(function() {
                        return e4.setSelectionRange(t3, t3, y2);
                    }, 0) : e4.setSelectionRange(t3, t3, y2));
                }
                function a2(e4) {
                    if ((0, d2.isString)(e4)) return e4;
                    if ((0, d2.isNumber)(e4)) return String(e4);
                    if (void 0 === e4 || null === e4) return v2;
                    throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e4));
                }
                Object.defineProperty(t2, "__esModule", {
                    value: true
                });
                var u2 = Object.assign || function(e4) {
                    for(var t3 = 1; t3 < arguments.length; t3++){
                        var r3 = arguments[t3];
                        for(var n3 in r3)Object.prototype.hasOwnProperty.call(r3, n3) && (e4[n3] = r3[n3]);
                    }
                    return e4;
                }, s2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
                    return typeof e4;
                } : function(e4) {
                    return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
                };
                t2.default = o2;
                var l2 = r2(4), f2 = n2(l2), c2 = r2(3), p2 = n2(c2), d2 = r2(2), h2 = r2(1), v2 = "", y2 = "none", m2 = "object", b2 = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent), g2 = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
            },
            function(e3, t2) {
                function r2(e4) {
                    return function() {
                        return e4;
                    };
                }
                var n2 = function() {};
                n2.thatReturns = r2, n2.thatReturnsFalse = r2(false), n2.thatReturnsTrue = r2(true), n2.thatReturnsNull = r2(null), n2.thatReturnsThis = function() {
                    return this;
                }, n2.thatReturnsArgument = function(e4) {
                    return e4;
                }, e3.exports = n2;
            },
            function(e3, t2, r2) {
                function n2(e4, t3, r3, n3, i, a2, u2, s2) {
                    if (!e4) {
                        var l2;
                        if (void 0 === t3) l2 = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                        else {
                            var f2 = [
                                r3,
                                n3,
                                i,
                                a2,
                                u2,
                                s2
                            ], c2 = 0;
                            l2 = new Error(t3.replace(/%s/g, function() {
                                return f2[c2++];
                            })), l2.name = "Invariant Violation";
                        }
                        throw l2.framesToPop = 1, l2;
                    }
                }
                e3.exports = n2;
            },
            function(e3, t2, r2) {
                var n2 = r2(6), o2 = r2(7), i = r2(10);
                e3.exports = function() {
                    function e4(e5, t4, r4, n3, a2, u2) {
                        u2 !== i && o2(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    }
                    function t3() {
                        return e4;
                    }
                    e4.isRequired = e4;
                    var r3 = {
                        array: e4,
                        bool: e4,
                        func: e4,
                        number: e4,
                        object: e4,
                        string: e4,
                        symbol: e4,
                        any: e4,
                        arrayOf: t3,
                        element: e4,
                        instanceOf: t3,
                        node: e4,
                        objectOf: t3,
                        oneOf: t3,
                        oneOfType: t3,
                        shape: t3,
                        exact: t3
                    };
                    return r3.checkPropTypes = n2, r3.PropTypes = r3, r3;
                };
            },
            function(e3, t2, r2) {
                e3.exports = r2(8)();
            },
            function(e3, t2) {
                var r2 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                e3.exports = r2;
            },
            function(t2, r2) {
                t2.exports = e2;
            }
        ]);
    });
})(reactTextMask);
var reactTextMaskExports = reactTextMask.exports;
const MaskedInput = /* @__PURE__ */ getDefaultExportFromCjs(reactTextMaskExports);
const inputField = "InputField-scss--module__inputField___y21cK";
const invalid$1 = "InputField-scss--module__invalid___LXseG";
const inputLarge = "InputField-scss--module__inputLarge___VDQhC";
const textArea = "InputField-scss--module__textArea___HiWAh";
const prettyScroll = "InputField-scss--module__prettyScroll___FTPwq";
const s$3c = {
    inputField: inputField,
    invalid: invalid$1,
    inputLarge: inputLarge,
    textArea: textArea,
    prettyScroll: prettyScroll
};
const Input$1 = ({ innerRef, className, autoFocus, disabled: disabled2, id, isValid: isValid2 = true, maxLength, name: name2, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, onPaste, placeholder: placeholder2, value: value2, dataAttributes, autocomplete, readonly, type, style, tabIndex, inputMode = EInputMode.DEFAULT })=>/* @__PURE__ */ $acw62.createElement("input", {
        ref: innerRef,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3c.inputField, {
            [s$3c.inputLarge]: inputMode === EInputMode.LARGE,
            [s$3c.invalid]: !isValid2
        }, className),
        disabled: disabled2,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        name: name2,
        onBlur: onBlur,
        onChange: onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onPaste: onPaste,
        placeholder: placeholder2,
        value: value2,
        autoComplete: autocomplete,
        readOnly: readonly,
        type: type,
        tabIndex: tabIndex,
        ...dataAttributes
    });
const TextArea = ({ innerRef, className, autoFocus, disabled: disabled2, id, isValid: isValid2 = true, maxLength, name: name2, onBlur, onChange, onFocus, onClick, onKeyDown, onKeyUp, placeholder: placeholder2, readonly, rows = 10, value: value2, tabIndex, dataAttributes, testId })=>/* @__PURE__ */ $acw62.createElement("textarea", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3c.inputField, s$3c.textArea, s$3c.prettyScroll, {
            [s$3c.invalid]: !isValid2
        }, className),
        value: value2,
        placeholder: placeholder2,
        id: id,
        autoFocus: autoFocus,
        disabled: disabled2,
        name: name2,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        maxLength: maxLength,
        readOnly: readonly,
        rows: rows,
        tabIndex: tabIndex,
        ...testAttr(testId),
        ...dataAttributes
    });
const InputMask = ({ style, innerRef, className, autoFocus, disabled: disabled2, id, isValid: isValid2 = true, maxLength, name: name2, onBlur, onChange, onFocus, onClick, onKeyDown, onKeyUp, placeholder: placeholder2, value: value2, mask, dataAttributes, testId, guide, keepCharPositions, showMask, pipe, placeholderChar, type, autocomplete, readonly, tabIndex })=>/* @__PURE__ */ $acw62.createElement(MaskedInput, {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3c.inputField, {
            [s$3c.invalid]: !isValid2
        }, className),
        style: style,
        disabled: disabled2,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        name: name2,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder2,
        value: value2,
        mask: mask,
        guide: guide,
        keepCharPositions: keepCharPositions,
        pipe: pipe,
        showMask: showMask,
        placeholderChar: placeholderChar,
        type: type,
        autoComplete: autocomplete,
        readOnly: readonly,
        tabIndex: tabIndex,
        ...testAttr(testId),
        ...dataAttributes
    });
const isMultiLine = ({ multiline, rows })=>!!multiline || !!rows;
const InputFieldWithoutRef = (props)=>{
    return props.mask ? /* @__PURE__ */ $acw62.createElement(InputMask, {
        ...props
    }) : isMultiLine(props) ? /* @__PURE__ */ $acw62.createElement(TextArea, {
        ...props
    }) : /* @__PURE__ */ $acw62.createElement(Input$1, {
        ...props
    });
};
const InputField = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(InputFieldWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const label$7 = "Label-scss--module__label___qqUQQ";
const s$3b = {
    label: label$7
};
const Label = ({ className, text: text2, id, children: children2 })=>{
    return text2 || children2 ? /* @__PURE__ */ $acw62.createElement("label", {
        htmlFor: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3b.label, className)
    }, text2 || children2) : null;
};
const container$e = "Input-scss--module__container___6vYZR";
const inputContainer$1 = "Input-scss--module__inputContainer___jeU6l";
const errorCaption$1 = "Input-scss--module__errorCaption___YOM76";
const errorCaptionStatic = "Input-scss--module__errorCaptionStatic___C0lmR";
const descriptionTopCaption = "Input-scss--module__descriptionTopCaption___H7QSC";
const descriptionTopCaptionWithLabel = "Input-scss--module__descriptionTopCaptionWithLabel___N8euy";
const descriptionBottomCaption = "Input-scss--module__descriptionBottomCaption___-KqY4";
const caption$1 = "Input-scss--module__caption___xAM2y";
const error$4 = "Input-scss--module__error___oTom2";
const counter$1 = "Input-scss--module__counter___AIuaA";
const staticText = "Input-scss--module__staticText___ex3k5";
const leftElement = "Input-scss--module__leftElement___XJTxm";
const rightElement = "Input-scss--module__rightElement___YVLfm";
const rightElementShifted = "Input-scss--module__rightElementShifted___4RbBh";
const bottomElement = "Input-scss--module__bottomElement___CS8uJ";
const s$3a = {
    container: container$e,
    inputContainer: inputContainer$1,
    errorCaption: errorCaption$1,
    errorCaptionStatic: errorCaptionStatic,
    descriptionTopCaption: descriptionTopCaption,
    descriptionTopCaptionWithLabel: descriptionTopCaptionWithLabel,
    descriptionBottomCaption: descriptionBottomCaption,
    caption: caption$1,
    error: error$4,
    counter: counter$1,
    staticText: staticText,
    leftElement: leftElement,
    rightElement: rightElement,
    rightElementShifted: rightElementShifted,
    bottomElement: bottomElement
};
const _InputGroup = class _InputGroup extends $acw62.Component {
    render() {
        const { className, classNameRightElement, classNameLeftElement, classNameLabel, description: description2, descriptionPosition, classNameDescription, classNameError, error: error2, id, isRightElementShifted, isErrorInFlow, label: label2, rightElement: rightElement2, bottomElement: bottomElement2, leftElement: leftElement2 } = this.props;
        const isTopDescription = !!description2 && descriptionPosition === EElementPosition.TOP;
        const isBottomDescription = !!description2 && descriptionPosition === EElementPosition.BOTTOM;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.container, className)
        }, /* @__PURE__ */ $acw62.createElement(Label, {
            text: label2,
            id: id,
            className: classNameLabel
        }), isTopDescription && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.descriptionTopCaption, !!label2 && s$3a.descriptionTopCaptionWithLabel, classNameDescription)
        }, /* @__PURE__ */ $acw62.createElement("span", null, description2)), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$3a.inputContainer
        }, leftElement2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.leftElement, classNameLeftElement)
        }, leftElement2), this.props.children, rightElement2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.rightElement, {
                [s$3a.rightElementShifted]: isRightElementShifted
            }, classNameRightElement)
        }, rightElement2), bottomElement2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: s$3a.bottomElement
        }, bottomElement2)), isBottomDescription && !Boolean(error2) && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.descriptionBottomCaption, classNameDescription)
        }, /* @__PURE__ */ $acw62.createElement("span", null, description2)), error2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.errorCaption, {
                [s$3a.errorCaptionStatic]: isErrorInFlow
            })
        }, /* @__PURE__ */ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.error, s$3a.caption, classNameError)
        }, error2)));
    }
};
_InputGroup.defaultProps = {
    descriptionPosition: EElementPosition.BOTTOM
};
let InputGroup = _InputGroup;
const STATIC_VALUE_OFFSET_ALLOWANCE = 1;
const _InputWithoutRef = class _InputWithoutRef extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.staticValueRef = $acw62.createRef();
        this.state = {
            value: "",
            paddingLeft: 0
        };
        this.onChange = (event2)=>{
            const { onChange } = this.props;
            if (onChange) {
                onChange(event2);
                return;
            }
            this.setState({
                value: event2.target.value
            });
        };
    }
    componentDidMount() {
        if (this.staticValueRef.current) {
            const { offsetWidth, offsetLeft } = this.staticValueRef.current;
            this.setState({
                paddingLeft: offsetWidth + offsetLeft - STATIC_VALUE_OFFSET_ALLOWANCE
            });
        }
    }
    getValue() {
        return this.props.value || this.state.value;
    }
    render() {
        const { innerRef, autoFocus, className, classNameInput, classNameLabel, classNameRightElement, classNameLeftElement, classNameStaticValue, classNameCounter, classNameDescription, classNameError, description: description2, descriptionPosition, disabled: disabled2, error: error2, id, isValid: isValid2, isRightElementShifted, label: label2, limit, multiline, name: name2, inputMode, onBlur, onClick, onFocus, onKeyDown, onKeyUp, onPaste, placeholder: placeholder2, rows, withCounter, staticValue: staticValue2, mask, rightElement: rightElement2, leftElement: leftElement2, bottomElement: bottomElement2, dataAttributes, testId, guide, keepCharPositions, showMask, pipe, placeholderChar, type, autocomplete, readonly, isErrorInFlow } = this.props;
        const { paddingLeft: paddingLeft2 } = this.state;
        const inputFieldStyle = paddingLeft2 ? {
            paddingLeft: `${paddingLeft2}px`
        } : {};
        return /* @__PURE__ */ $acw62.createElement(InputGroup, {
            isErrorInFlow: isErrorInFlow,
            className: className,
            classNameRightElement: classNameRightElement,
            classNameLeftElement: classNameLeftElement,
            classNameDescription: classNameDescription,
            classNameError: classNameError,
            classNameLabel: classNameLabel,
            isValid: isValid2,
            error: error2,
            label: label2,
            description: description2,
            descriptionPosition: descriptionPosition,
            id: id,
            rightElement: rightElement2,
            leftElement: leftElement2,
            bottomElement: bottomElement2,
            isRightElementShifted: isRightElementShifted
        }, staticValue2 && /* @__PURE__ */ $acw62.createElement("label", {
            ref: this.staticValueRef,
            htmlFor: id,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.staticText, classNameStaticValue)
        }, staticValue2), /* @__PURE__ */ $acw62.createElement(InputField, {
            style: inputFieldStyle,
            ref: innerRef,
            className: classNameInput,
            autoFocus: autoFocus,
            disabled: disabled2,
            id: id,
            isValid: isValid2,
            maxLength: limit,
            multiline: multiline,
            name: name2,
            onBlur: onBlur,
            onChange: this.onChange,
            onFocus: onFocus,
            onClick: onClick,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            onPaste: onPaste,
            placeholder: placeholder2,
            rows: rows,
            value: this.getValue(),
            mask: mask,
            dataAttributes: dataAttributes,
            testId: testId,
            guide: guide,
            keepCharPositions: keepCharPositions,
            pipe: pipe,
            placeholderChar: placeholderChar,
            showMask: showMask,
            type: type,
            readonly: readonly,
            autocomplete: autocomplete,
            inputMode: inputMode
        }), withCounter && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3a.counter, classNameCounter)
        }, /* @__PURE__ */ $acw62.createElement("span", null, this.getValue().length), limit && /* @__PURE__ */ $acw62.createElement("span", null, " / ", limit)));
    }
};
_InputWithoutRef.defaultProps = {
    className: "",
    autoFocus: false,
    multiline: false,
    isValid: true,
    onBlur: dist$4.noop,
    onFocus: dist$4.noop,
    onKeyDown: dist$4.noop,
    onKeyUp: dist$4.noop,
    descriptionPosition: EElementPosition.BOTTOM,
    dataAttributes: {},
    guide: true,
    type: "text"
};
let InputWithoutRef = _InputWithoutRef;
const Input = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(InputWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const _PhoneInputWithoutRef = class _PhoneInputWithoutRef extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.getMask = ()=>(value2)=>getPhoneMask(value2);
        this.onChange = (evt)=>{
            const { onChange } = this.props;
            const { target: { value: value2 } } = evt;
            const phoneNumber = value2.replace(new RegExp("^\\+8(\\s\\(9.*)$"), "+7$1");
            onChange(phoneNumber, getCleanPhone(phoneNumber));
        };
    }
    render() {
        const { innerRef, autoFocus, error: error2, label: label2, placeholder: placeholder2, description: description2, name: name2, value: value2, rightElement: rightElement2, dataAttributes, guide, keepCharPositions, showMask, pipe, placeholderChar, isValid: isValid2, isDisabled: isDisabled2, onBlur, onFocus, onKeyDown, onKeyUp } = this.props;
        return /* @__PURE__ */ $acw62.createElement(Input, {
            ref: innerRef,
            autoFocus: autoFocus,
            type: "tel",
            autocomplete: "tel",
            error: error2,
            label: label2,
            placeholder: placeholder2,
            description: description2,
            onChange: this.onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            name: name2,
            value: value2,
            disabled: isDisabled2,
            rightElement: rightElement2,
            mask: this.getMask(),
            showMask: showMask,
            guide: guide,
            keepCharPositions: keepCharPositions,
            placeholderChar: placeholderChar,
            pipe: pipe,
            dataAttributes: dataAttributes,
            isValid: isValid2
        });
    }
};
_PhoneInputWithoutRef.defaultProps = {
    onChange: dist$4.noop
};
let PhoneInputWithoutRef = _PhoneInputWithoutRef;
$acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(PhoneInputWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const SELECT_TEST_ID = "Select";
const container$d = "SimpleCheckBox-scss--module__container___z4ZHh";
const containerDisabled$1 = "SimpleCheckBox-scss--module__containerDisabled___DlRai";
const checkbox$2 = "SimpleCheckBox-scss--module__checkbox___GbQ63";
const checkboxWrapper$1 = "SimpleCheckBox-scss--module__checkboxWrapper___Vv6Bg";
const checked = "SimpleCheckBox-scss--module__checked___TnWcf";
const unchecked = "SimpleCheckBox-scss--module__unchecked___vnJA6";
const label$6 = "SimpleCheckBox-scss--module__label___uTDv6";
const s$39 = {
    container: container$d,
    containerDisabled: containerDisabled$1,
    checkbox: checkbox$2,
    checkboxWrapper: checkboxWrapper$1,
    checked: checked,
    unchecked: unchecked,
    label: label$6
};
const renderCheckBoxContent = ({ label: label2, isDisabled: isDisabled2, labelClassName, checkboxClassName })=>// eslint-disable-next-line react/display-name
    ({ isChecked })=>/* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$39.container, {
                [s$39.containerDisabled]: isDisabled2
            })
        }, isChecked ? /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_check_box_on_20,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$39.checkbox, s$39.checked)
        }) : /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_check_box_off_20,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$39.checkbox, s$39.unchecked)
        }), label2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$39.label, labelClassName, {
                [s$39.labelDisabled]: isDisabled2
            })
        }, label2));
const SimpleCheckBox = ({ onToggle = dist$4.noop, isDefaultChecked, label: label2, isDisabled: isDisabled2, containerClassName, labelClassName, checkboxClassName, ...props })=>/* @__PURE__ */ $acw62.createElement(CheckBoxContainer, {
        onToggle: onToggle,
        isDefaultChecked: isDefaultChecked,
        isDisabled: isDisabled2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$39.checkboxWrapper, containerClassName),
        render: renderCheckBoxContent({
            label: label2,
            isDisabled: isDisabled2,
            labelClassName: labelClassName,
            checkboxClassName: checkboxClassName
        }),
        ...props
    });
const SELECT_OPTION_TEST_ID = "SelectOption";
const option$1 = "SelectOption-scss--module__option___NxeP-";
const disabled$6 = "SelectOption-scss--module__disabled___VQM78";
const optionWithSelected = "SelectOption-scss--module__optionWithSelected___IbINX";
const simpleOptionContainer = "SelectOption-scss--module__simpleOptionContainer___mLI47";
const selected$3 = "SelectOption-scss--module__selected___Wn-1j";
const s$38 = {
    option: option$1,
    disabled: disabled$6,
    optionWithSelected: optionWithSelected,
    simpleOptionContainer: simpleOptionContainer,
    selected: selected$3
};
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target2, key, kind)=>{
    var result2 = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target2, key) : target2;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result2 = decorator(result2) || result2;
    return result2;
};
let SimpleOption = class extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.optionRef = $acw62.createRef();
    }
    componentDidMount() {
        if (this.props.selected) this.scrollToSelected();
    }
    scrollToSelected() {
        const { parentElement } = this.optionRef.current;
        parentElement.scrollTop = this.optionRef.current.offsetTop;
    }
    render() {
        const { id, value: value2, valueObject, label: label2, disabled: disabled2, selected: selected2, onSelect, classNameOption, classNameOptionSelected, Component: Component2, withSelectedIcon = true } = this.props;
        const handleClick = (event2)=>{
            event2.preventDefault();
            event2.stopPropagation();
            if (!disabled2) onSelect(valueObject);
        };
        const selectedClassName = classNameOptionSelected ?? s$38.selected;
        return /* @__PURE__ */ $acw62.createElement("div", {
            ref: this.optionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$38.option, s$38.simpleOptionContainer, {
                [s$38.disabled]: disabled2,
                [s$38.optionWithSelected]: selected2 && withSelectedIcon
            }, classNameOption),
            onClick: handleClick,
            ...testAttr(this.getTestId(ESelectTestId.SIMPLE_OPTION))
        }, Component2 ? /* @__PURE__ */ $acw62.createElement(Component2, {
            id: id,
            valueObject: valueObject,
            selected: selected2,
            label: label2,
            value: value2
        }) : label2, selected2 && withSelectedIcon && /* @__PURE__ */ $acw62.createElement(Icon, {
            className: selectedClassName,
            glyph: svg_name_done_16
        }));
    }
};
SimpleOption = __decorateClass$1([
    TestId(SELECT_OPTION_TEST_ID)
], SimpleOption);
const getSelectOptionTestId = getFactoryTestId(SELECT_OPTION_TEST_ID);
const CheckingOption = ({ id, value: value2, valueObject, label: label2, selected: selected2, classNameOption, classNameOptionCheckBoxLabel, Component: Component2, disabled: disabled2, onSelect })=>{
    const labelCheckBox = Component2 != null ? "" : label2;
    return /* @__PURE__ */ $acw62.createElement("div", {
        title: label2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$38.option, {
            [s$38.disabled]: disabled2
        }, classNameOption),
        onClick: ()=>disabled2 ? void 0 : onSelect(valueObject),
        ...testAttr(getSelectOptionTestId(ESelectTestId.CHECKING_OPTION))
    }, /* @__PURE__ */ $acw62.createElement(SimpleCheckBox, {
        isDefaultChecked: selected2,
        label: labelCheckBox,
        checked: selected2,
        labelClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$38.checkBoxLabel, classNameOptionCheckBoxLabel),
        checkboxClassName: s$38.checkBox
    }), Component2 != null ? /* @__PURE__ */ $acw62.createElement(Component2, {
        id: id,
        valueObject: valueObject,
        selected: selected2,
        label: label2,
        value: value2
    }) : null);
};
const SelectOption = (props)=>{
    const { withCheckBox } = props;
    if (withCheckBox) return /* @__PURE__ */ $acw62.createElement(CheckingOption, {
        ...props
    });
    else return /* @__PURE__ */ $acw62.createElement(SimpleOption, {
        ...props
    });
};
const mainContainer = "Select-scss--module__mainContainer___FiZdL";
const optionsContainer = "Select-scss--module__optionsContainer___tba2l";
const optionsContainerTop = "Select-scss--module__optionsContainerTop___Tl9MZ";
const arrow$3 = "Select-scss--module__arrow___5rJvy";
const reset = "Select-scss--module__reset___g0-fM";
const mainBox = "Select-scss--module__mainBox___CA4nw";
const disabled$5 = "Select-scss--module__disabled___XWIW9";
const invalid = "Select-scss--module__invalid___2QqvQ";
const mainBoxActive = "Select-scss--module__mainBoxActive___IiG6v";
const mainBoxInline = "Select-scss--module__mainBoxInline___qgmm2";
const mainBoxInlineActive = "Select-scss--module__mainBoxInlineActive___4I5Zz";
const placeholder$3 = "Select-scss--module__placeholder___QerWP";
const noOptions = "Select-scss--module__noOptions___Aors-";
const inline = "Select-scss--module__inline___dIehT";
const errorCaption = "Select-scss--module__errorCaption___gKigb";
const caption = "Select-scss--module__caption___jrqk8";
const error$3 = "Select-scss--module__error___cMy5d";
const invalidIcon = "Select-scss--module__invalidIcon___8rb-j";
const s$37 = {
    mainContainer: mainContainer,
    optionsContainer: optionsContainer,
    optionsContainerTop: optionsContainerTop,
    arrow: arrow$3,
    reset: reset,
    mainBox: mainBox,
    disabled: disabled$5,
    invalid: invalid,
    mainBoxActive: mainBoxActive,
    mainBoxInline: mainBoxInline,
    mainBoxInlineActive: mainBoxInlineActive,
    placeholder: placeholder$3,
    noOptions: noOptions,
    inline: inline,
    errorCaption: errorCaption,
    caption: caption,
    error: error$3,
    invalidIcon: invalidIcon
};
const locales$1J = {
    chosenSingle: "\u0412\u044B\u0431\u0440\u0430\u043D",
    chosenMultiple: "\u0412\u044B\u0431\u0440\u0430\u043D\u043E",
    pointsThen1: "\u043F\u0443\u043D\u043A\u0442",
    pointsThen2: "\u043F\u0443\u043D\u043A\u0442\u0430",
    pointsThen5: "\u043F\u0443\u043D\u043A\u0442\u043E\u0432",
    noOptions: "\u043D\u0435\u0442 \u043E\u043F\u0446\u0438\u0439"
};
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target2, key, kind)=>{
    var result2 = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target2, key) : target2;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result2 = decorator(result2) || result2;
    return result2;
};
const t$1K = distExports$1.getTranslation && locales$1J;
let SelectComponent = class extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.optionsWrapperRef = $acw62.createRef();
        this.state = {
            isOpened: false,
            isTop: false
        };
        this.mainBox = $acw62.createRef();
        this.getOption = (option2)=>{
            return {
                label: String(option2[this.props.labelProp]),
                value: String(option2[this.props.valueProp]),
                id: String(option2[this.props.valueProp]),
                valueObject: option2
            };
        };
        this.getMainLabel = ()=>{
            const { isMulti, selected: selected2, placeholder: placeholder2, classNames, ComponentValue } = this.props;
            if (this.props.selectionLabel != null) return this.props.selectionLabel;
            if (isMulti && selected2 && Array.isArray(selected2) && selected2.length) {
                const chosen = declOfNum([
                    t$1K.chosenSingle,
                    t$1K.chosenMultiple,
                    t$1K.chosenMultiple
                ], selected2.length);
                const points2 = declOfNum([
                    t$1K.pointsThen1,
                    t$1K.pointsThen2,
                    t$1K.pointsThen5
                ], selected2.length);
                return `${chosen} ${selected2.length} ${points2}`;
            }
            if (selected2 && !Array.isArray(selected2)) {
                const selectedOption = this.getOption(selected2);
                return ComponentValue ? /* @__PURE__ */ $acw62.createElement(ComponentValue, {
                    ...selectedOption
                }) : this.renderComponent(selectedOption);
            }
            return /* @__PURE__ */ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$37.placeholder, classNames.placeholder)
            }, placeholder2);
        };
        this.calcIntersection = ()=>{
            const target2 = this.optionsWrapperRef.current;
            const { bottom: bottom2 } = (target2 == null ? void 0 : target2.getBoundingClientRect()) || {};
            this.setState({
                isTop: window.innerHeight <= bottom2
            });
        };
        this.onToggle = (event2)=>{
            event2.stopPropagation();
            event2.preventDefault();
            const { isDisabled: isDisabled2 } = this.props;
            const { isOpened } = this.state;
            if (isDisabled2) return;
            if (isOpened) this.setState({
                isOpened: false,
                isTop: false
            });
            else if (!isOpened) this.setState({
                isOpened: true
            }, this.calcIntersection);
        };
        this.onDropdownHide = (event2)=>{
            if (this.isMainBoxContainsTarget(event2.target)) return;
            this.setState({
                isOpened: false
            });
        };
        this.onSelect = (option2)=>{
            const { isMulti, valueProp, onSelect } = this.props;
            if (isMulti === true) {
                const selected2 = this.props.selected != null ? this.props.selected : [];
                const newOptions = selected2.some((item2)=>item2[valueProp] === option2[valueProp]) ? selected2.filter((oldOption)=>option2[valueProp] !== oldOption[valueProp]) : [
                    ...selected2,
                    option2
                ];
                onSelect(newOptions);
            } else {
                onSelect(option2);
                this.setState({
                    isOpened: false
                });
            }
        };
        this.onReset = (event2)=>{
            var _a3;
            event2.stopPropagation();
            (_a3 = this.props) == null || _a3.onReset();
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.isDisabled && this.props.isDisabled && this.state.isOpened) this.setState({
            isOpened: false
        });
    }
    isSelected(option2) {
        const { isMulti, selected: selected2, valueProp } = this.props;
        if (isMulti === true) return selected2 != null ? selected2.some((item2)=>item2[valueProp] === option2[valueProp]) : false;
        else return Boolean(selected2) && Boolean(option2) && selected2[valueProp] === option2[valueProp];
    }
    isMainBoxContainsTarget(target2) {
        return this.mainBox.current.contains(target2);
    }
    getOptions() {
        const res = this.props.options.map(this.getOption);
        if (this.props.allowEmpty) return [
            {
                value: null,
                id: null,
                valueObject: null,
                label: this.props.placeholder
            },
            ...res
        ];
        if (this.props.hideSelected) return res.filter((option2)=>!this.isSelected(option2.valueObject));
        return res;
    }
    renderComponent(selectedOption) {
        const { Component: Component2 } = this.props;
        return Component2 ? /* @__PURE__ */ $acw62.createElement(Component2, {
            ...selectedOption
        }) : selectedOption.label;
    }
    render() {
        const { className, classNames, arrowIconGlyph, isDisabled: isDisabled2, isInline, isMulti, options, label: label2, withSelectedIcon, error: error2, disabledOptionValues = [], onReset } = this.props;
        const { isOpened, isTop } = this.state;
        const formattedOptions = this.getOptions();
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$37.mainContainer, className, {
                [s$37.inline]: isInline
            }),
            ...testAttr(this.getTestId(ESelectTestId.ROOT))
        }, label2 && /* @__PURE__ */ $acw62.createElement(Label, {
            text: label2
        }), /* @__PURE__ */ $acw62.createElement("div", {
            ...testAttr(this.getTestId(ESelectTestId.TOGGLE)),
            ref: this.mainBox,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.mainBox, {
                [s$37.mainBox]: !isInline,
                [s$37.mainBoxActive]: !isInline && isOpened,
                [s$37.mainBoxInline]: isInline,
                [s$37.mainBoxInlineActive]: isInline && isOpened,
                [s$37.disabled]: isDisabled2,
                [s$37.invalid]: !!error2
            }),
            onClick: this.onToggle
        }, /* @__PURE__ */ $acw62.createElement("span", {
            className: classNames.mainLabel
        }, this.getMainLabel()), Boolean(onReset) && !isOpened && /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_close,
            onClick: this.onReset,
            className: s$37.reset
        }), Boolean(formattedOptions.length) && (error2 ? /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_error,
            className: s$37.invalidIcon
        }) : /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: arrowIconGlyph || svg_name_arrow_short,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$37.arrow, classNames.arrow)
        }))), isOpened && Boolean(formattedOptions.length) && /* @__PURE__ */ $acw62.createElement(Tooltip, {
            onClickOutside: this.onDropdownHide,
            trigger: ETooltipTriggers.CLICK
        }, /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
            ref: this.optionsWrapperRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$37.optionsContainer, {
                [s$37.optionsContainerTop]: isTop && !label2
            }, classNames.options)
        }, options ? formattedOptions.map((option2)=>/* @__PURE__ */ $acw62.createElement(SelectOption, {
                ...option2,
                disabled: disabledOptionValues.includes(option2.value),
                selected: this.isSelected(option2.valueObject),
                withCheckBox: isMulti,
                withSelectedIcon: withSelectedIcon,
                onSelect: this.onSelect,
                key: option2.id,
                classNameOption: classNames.option,
                classNameOptionSelected: classNames.optionSelected,
                classNameOptionCheckBoxLabel: classNames.optionCheckBoxLabel,
                Component: this.props.Component
            })) : /* @__PURE__ */ $acw62.createElement("span", {
            className: s$37.noOptions
        }, t$1K.noOptions))), error2 && /* @__PURE__ */ $acw62.createElement("div", {
            className: s$37.errorCaption
        }, /* @__PURE__ */ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$37.error, s$37.caption)
        }, error2)));
    }
};
SelectComponent.defaultProps = {
    classNames: {},
    allowEmpty: false,
    labelProp: "label",
    valueProp: "value"
};
SelectComponent = __decorateClass([
    TestId(SELECT_TEST_ID)
], SelectComponent);
const Select = SelectComponent;
const rootOneLiner = "EllipsisWithTooltip-scss--module__rootOneLiner___EWdX-";
const lineClamp = "EllipsisWithTooltip-scss--module__lineClamp___mMuUR";
const tooltipContent$4 = "EllipsisWithTooltip-scss--module__tooltipContent___KfAMd";
const s$36 = {
    rootOneLiner: rootOneLiner,
    lineClamp: lineClamp,
    tooltipContent: tooltipContent$4
};
const EllipsisWithTooltip = (props)=>{
    const { children: children2, classNames = {}, linesCount = 1, position: position2 = ETooltipPosition.TOP, tooltipContent: tooltipContent2, trigger = ETooltipTrigger.HOVER } = props;
    const ref2 = (0, $acw62.createRef)();
    const [hasEllipsis, setHasEllipsis] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (ref2.current) setHasEllipsis(ref2.current.clientHeight < ref2.current.scrollHeight);
    }, [
        tooltipContent2,
        ref2.current
    ]);
    return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        content: hasEllipsis ? tooltipContent2 : null,
        position: position2,
        isGlobal: true,
        trigger: trigger,
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.root, {
                [s$36.rootOneLiner]: linesCount === 1
            }),
            content: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$36.tooltipContent, classNames.tooltipContent),
            contentWrapper: classNames.contentWrapper
        }
    }, /* @__PURE__ */ $acw62.createElement("div", {
        ref: ref2,
        className: s$36.lineClamp,
        style: {
            WebkitLineClamp: linesCount
        }
    }, children2));
};
var CSSTransition = {
    exports: {}
};
var addClass = {
    exports: {}
};
var interopRequireDefault = {
    exports: {}
};
(function(module2) {
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    module2.exports = _interopRequireDefault2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
var hasClass = {
    exports: {}
};
var hasRequiredHasClass;
function requireHasClass() {
    if (hasRequiredHasClass) return hasClass.exports;
    hasRequiredHasClass = 1;
    (function(module2, exports2) {
        exports2.__esModule = true;
        exports2.default = hasClass2;
        function hasClass2(element, className) {
            if (element.classList) return !!className && element.classList.contains(className);
            else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
        }
        module2.exports = exports2["default"];
    })(hasClass, hasClass.exports);
    return hasClass.exports;
}
(function(module2, exports2) {
    var _interopRequireDefault2 = interopRequireDefaultExports;
    exports2.__esModule = true;
    exports2.default = addClass2;
    var _hasClass = _interopRequireDefault2(requireHasClass());
    function addClass2(element, className) {
        if (element.classList) element.classList.add(className);
        else if (!(0, _hasClass.default)(element, className)) {
            if (typeof element.className === "string") element.className = element.className + " " + className;
            else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
        }
    }
    module2.exports = exports2["default"];
})(addClass, addClass.exports);
var addClassExports = addClass.exports;
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
var removeClass = function removeClass2(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
};
var Transition$1 = {};
var PropTypes$1 = {};
PropTypes$1.__esModule = true;
PropTypes$1.classNamesShape = PropTypes$1.timeoutsShape = void 0;
var _propTypes = _interopRequireDefault$2(propTypesExports);
function _interopRequireDefault$2(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var timeoutsShape = null;
PropTypes$1.timeoutsShape = timeoutsShape;
var classNamesShape = null;
PropTypes$1.classNamesShape = classNamesShape;
Transition$1.__esModule = true;
Transition$1.default = Transition$1.EXITING = Transition$1.ENTERED = Transition$1.ENTERING = Transition$1.EXITED = Transition$1.UNMOUNTED = void 0;
var PropTypes = _interopRequireWildcard(propTypesExports);
var _react$1 = _interopRequireDefault$1((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
var _reactDom = _interopRequireDefault$1((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))));
var _reactLifecyclesCompat = require$$2;
var _PropTypes = PropTypes$1;
function _interopRequireDefault$1(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target2[key] = source[key];
    }
    return target2;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var UNMOUNTED = "unmounted";
Transition$1.UNMOUNTED = UNMOUNTED;
var EXITED = "exited";
Transition$1.EXITED = EXITED;
var ENTERING = "entering";
Transition$1.ENTERING = ENTERING;
var ENTERED = "entered";
Transition$1.ENTERED = ENTERED;
var EXITING = "exiting";
Transition$1.EXITING = EXITING;
var Transition = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose(Transition2, _React$Component);
    function Transition2(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup;
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition2.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null
        };
    };
    Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    };
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout2 = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout2;
        if (timeout2 != null && typeof timeout2 !== "number") {
            exit = timeout2.exit;
            enter = timeout2.enter;
            appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            var node = _reactDom.default.findDOMNode(this);
            if (nextStatus === ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active2 = true;
        this.nextCallback = function(event2) {
            if (active2) {
                active2 = false;
                _this4.nextCallback = null;
                callback(event2);
            }
        };
        this.nextCallback.cancel = function() {
            active2 = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout2, handler2) {
        this.setNextCallback(handler2);
        var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout2 != null) setTimeout(this.nextCallback, timeout2);
    };
    _proto.render = function render2() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children2 = _this$props.children, childProps = _objectWithoutPropertiesLoose$1(_this$props, [
            "children"
        ]);
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children2 === "function") return children2(status, childProps);
        var child = _react$1.default.Children.only(children2);
        return _react$1.default.cloneElement(child, childProps);
    };
    return Transition2;
}(_react$1.default.Component);
Transition.contextTypes = {
    transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
Transition.propTypes = {};
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
Transition$1.default = _default;
(function(module2, exports2) {
    exports2.__esModule = true;
    exports2.default = void 0;
    var PropTypes2 = _interopRequireWildcard2(propTypesExports);
    var _addClass = _interopRequireDefault2(addClassExports);
    var _removeClass = _interopRequireDefault2(removeClass);
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _Transition2 = _interopRequireDefault2(Transition$1);
    var _PropTypes2 = PropTypes$1;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _interopRequireWildcard2(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                    else newObj[key] = obj[key];
                }
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _inheritsLoose2(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var addClass2 = function addClass3(node, classes2) {
        return node && classes2 && classes2.split(" ").forEach(function(c2) {
            return (0, _addClass.default)(node, c2);
        });
    };
    var removeClass$1 = function removeClass3(node, classes2) {
        return node && classes2 && classes2.split(" ").forEach(function(c2) {
            return (0, _removeClass.default)(node, c2);
        });
    };
    var CSSTransition2 = /* @__PURE__ */ function(_React$Component) {
        _inheritsLoose2(CSSTransition3, _React$Component);
        function CSSTransition3() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.onEnter = function(node, appearing) {
                var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
                _this.removeClasses(node, "exit");
                addClass2(node, className);
                if (_this.props.onEnter) _this.props.onEnter(node, appearing);
            };
            _this.onEntering = function(node, appearing) {
                var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
                _this.reflowAndAddClass(node, activeClassName);
                if (_this.props.onEntering) _this.props.onEntering(node, appearing);
            };
            _this.onEntered = function(node, appearing) {
                var appearClassName = _this.getClassNames("appear").doneClassName;
                var enterClassName = _this.getClassNames("enter").doneClassName;
                var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
                _this.removeClasses(node, appearing ? "appear" : "enter");
                addClass2(node, doneClassName);
                if (_this.props.onEntered) _this.props.onEntered(node, appearing);
            };
            _this.onExit = function(node) {
                var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
                _this.removeClasses(node, "appear");
                _this.removeClasses(node, "enter");
                addClass2(node, className);
                if (_this.props.onExit) _this.props.onExit(node);
            };
            _this.onExiting = function(node) {
                var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
                _this.reflowAndAddClass(node, activeClassName);
                if (_this.props.onExiting) _this.props.onExiting(node);
            };
            _this.onExited = function(node) {
                var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
                _this.removeClasses(node, "exit");
                addClass2(node, doneClassName);
                if (_this.props.onExited) _this.props.onExited(node);
            };
            _this.getClassNames = function(type) {
                var classNames = _this.props.classNames;
                var isStringClassNames = typeof classNames === "string";
                var prefix2 = isStringClassNames && classNames ? classNames + "-" : "";
                var className = isStringClassNames ? prefix2 + type : classNames[type];
                var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
                var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
                return {
                    className: className,
                    activeClassName: activeClassName,
                    doneClassName: doneClassName
                };
            };
            return _this;
        }
        var _proto = CSSTransition3.prototype;
        _proto.removeClasses = function removeClasses(node, type) {
            var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
            className && removeClass$1(node, className);
            activeClassName && removeClass$1(node, activeClassName);
            doneClassName && removeClass$1(node, doneClassName);
        };
        _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
            if (className) {
                node && node.scrollTop;
                addClass2(node, className);
            }
        };
        _proto.render = function render2() {
            var props = _extends2({}, this.props);
            delete props.classNames;
            return _react2.default.createElement(_Transition2.default, _extends2({}, props, {
                onEnter: this.onEnter,
                onEntered: this.onEntered,
                onEntering: this.onEntering,
                onExit: this.onExit,
                onExiting: this.onExiting,
                onExited: this.onExited
            }));
        };
        return CSSTransition3;
    }(_react2.default.Component);
    CSSTransition2.defaultProps = {
        classNames: ""
    };
    CSSTransition2.propTypes = {};
    var _default2 = CSSTransition2;
    exports2.default = _default2;
    module2.exports = exports2["default"];
})(CSSTransition, CSSTransition.exports);
var CSSTransitionExports = CSSTransition.exports;
var ReplaceTransition = {
    exports: {}
};
var TransitionGroup = {
    exports: {}
};
var ChildMapping = {};
ChildMapping.__esModule = true;
ChildMapping.getChildMapping = getChildMapping;
ChildMapping.mergeChildMappings = mergeChildMappings;
ChildMapping.getInitialChildMapping = getInitialChildMapping;
ChildMapping.getNextChildMapping = getNextChildMapping;
var _react = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function getChildMapping(children2, mapFn) {
    var mapper = function mapper2(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result2 = /* @__PURE__ */ Object.create(null);
    if (children2) _react.Children.map(children2, function(c2) {
        return c2;
    }).forEach(function(child) {
        result2[child.key] = mapper(child);
    });
    return result2;
}
function mergeChildMappings(prev, next2) {
    prev = prev || {};
    next2 = next2 || {};
    function getValueForKey(key) {
        return key in next2 ? next2[key] : prev[key];
    }
    var nextKeysPending = /* @__PURE__ */ Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next2) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next2){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children2 = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children2).forEach(function(key) {
        var child = children2[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
        if (hasNext && (!hasPrev || isLeaving)) children2[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) children2[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) children2[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children2;
}
(function(module2, exports2) {
    exports2.__esModule = true;
    exports2.default = void 0;
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _reactLifecyclesCompat2 = require$$2;
    var _ChildMapping = ChildMapping;
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function _extends2() {
        _extends2 = Object.assign || function(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
            }
            return target2;
        };
        return _extends2.apply(this, arguments);
    }
    function _inheritsLoose2(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    function _assertThisInitialized(self2) {
        if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self2;
    }
    var values2 = Object.values || function(obj) {
        return Object.keys(obj).map(function(k2) {
            return obj[k2];
        });
    };
    var defaultProps = {
        component: "div",
        childFactory: function childFactory(child) {
            return child;
        }
    };
    var TransitionGroup2 = /* @__PURE__ */ function(_React$Component) {
        _inheritsLoose2(TransitionGroup3, _React$Component);
        function TransitionGroup3(props, context) {
            var _this;
            _this = _React$Component.call(this, props, context) || this;
            var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this)));
            _this.state = {
                handleExited: handleExited,
                firstRender: true
            };
            return _this;
        }
        var _proto = TransitionGroup3.prototype;
        _proto.getChildContext = function getChildContext() {
            return {
                transitionGroup: {
                    isMounting: !this.appeared
                }
            };
        };
        _proto.componentDidMount = function componentDidMount() {
            this.appeared = true;
            this.mounted = true;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.mounted = false;
        };
        TransitionGroup3.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
            var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
            return {
                children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
                firstRender: false
            };
        };
        _proto.handleExited = function handleExited(child, node) {
            var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
            if (child.key in currentChildMapping) return;
            if (child.props.onExited) child.props.onExited(node);
            if (this.mounted) this.setState(function(state) {
                var children2 = _extends2({}, state.children);
                delete children2[child.key];
                return {
                    children: children2
                };
            });
        };
        _proto.render = function render2() {
            var _this$props = this.props, Component2 = _this$props.component, childFactory = _this$props.childFactory, props = _objectWithoutPropertiesLoose2(_this$props, [
                "component",
                "childFactory"
            ]);
            var children2 = values2(this.state.children).map(childFactory);
            delete props.appear;
            delete props.enter;
            delete props.exit;
            if (Component2 === null) return children2;
            return _react2.default.createElement(Component2, props, children2);
        };
        return TransitionGroup3;
    }(_react2.default.Component);
    TransitionGroup2.childContextTypes = {
        transitionGroup: _propTypes2.default.object.isRequired
    };
    TransitionGroup2.propTypes = {};
    TransitionGroup2.defaultProps = defaultProps;
    var _default2 = (0, _reactLifecyclesCompat2.polyfill)(TransitionGroup2);
    exports2.default = _default2;
    module2.exports = exports2["default"];
})(TransitionGroup, TransitionGroup.exports);
var TransitionGroupExports = TransitionGroup.exports;
(function(module2, exports2) {
    exports2.__esModule = true;
    exports2.default = void 0;
    var _propTypes2 = _interopRequireDefault2(propTypesExports);
    var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    var _reactDom2 = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT)));
    var _TransitionGroup2 = _interopRequireDefault2(TransitionGroupExports);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target2 = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target2[key] = source[key];
        }
        return target2;
    }
    function _inheritsLoose2(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var ReplaceTransition2 = /* @__PURE__ */ function(_React$Component) {
        _inheritsLoose2(ReplaceTransition3, _React$Component);
        function ReplaceTransition3() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.handleEnter = function() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return _this.handleLifecycle("onEnter", 0, args);
            };
            _this.handleEntering = function() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return _this.handleLifecycle("onEntering", 0, args);
            };
            _this.handleEntered = function() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return _this.handleLifecycle("onEntered", 0, args);
            };
            _this.handleExit = function() {
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                return _this.handleLifecycle("onExit", 1, args);
            };
            _this.handleExiting = function() {
                for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
                return _this.handleLifecycle("onExiting", 1, args);
            };
            _this.handleExited = function() {
                for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
                return _this.handleLifecycle("onExited", 1, args);
            };
            return _this;
        }
        var _proto = ReplaceTransition3.prototype;
        _proto.handleLifecycle = function handleLifecycle(handler2, idx, originalArgs) {
            var _child$props;
            var children2 = this.props.children;
            var child = _react2.default.Children.toArray(children2)[idx];
            if (child.props[handler2]) (_child$props = child.props)[handler2].apply(_child$props, originalArgs);
            if (this.props[handler2]) this.props[handler2]((0, _reactDom2.findDOMNode)(this));
        };
        _proto.render = function render2() {
            var _this$props = this.props, children2 = _this$props.children, inProp = _this$props.in, props = _objectWithoutPropertiesLoose2(_this$props, [
                "children",
                "in"
            ]);
            var _React$Children$toArr = _react2.default.Children.toArray(children2), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
            delete props.onEnter;
            delete props.onEntering;
            delete props.onEntered;
            delete props.onExit;
            delete props.onExiting;
            delete props.onExited;
            return _react2.default.createElement(_TransitionGroup2.default, props, inProp ? _react2.default.cloneElement(first, {
                key: "first",
                onEnter: this.handleEnter,
                onEntering: this.handleEntering,
                onEntered: this.handleEntered
            }) : _react2.default.cloneElement(second, {
                key: "second",
                onEnter: this.handleExit,
                onEntering: this.handleExiting,
                onEntered: this.handleExited
            }));
        };
        return ReplaceTransition3;
    }(_react2.default.Component);
    ReplaceTransition2.propTypes = {};
    var _default2 = ReplaceTransition2;
    exports2.default = _default2;
    module2.exports = exports2["default"];
})(ReplaceTransition, ReplaceTransition.exports);
var ReplaceTransitionExports = ReplaceTransition.exports;
var _CSSTransition = _interopRequireDefault(CSSTransitionExports);
var _ReplaceTransition = _interopRequireDefault(ReplaceTransitionExports);
var _TransitionGroup = _interopRequireDefault(TransitionGroupExports);
var _Transition = _interopRequireDefault(Transition$1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reactTransitionGroup = {
    Transition: _Transition.default,
    TransitionGroup: _TransitionGroup.default,
    ReplaceTransition: _ReplaceTransition.default,
    CSSTransition: _CSSTransition.default
};
const fade = "FadeIn-scss--module__fade___rVnIZ";
const entering = "FadeIn-scss--module__entering___2vHRF";
const entered = "FadeIn-scss--module__entered___kZw5Z";
const exiting = "FadeIn-scss--module__exiting___MqVzT";
const exited = "FadeIn-scss--module__exited___amfBX";
const s$35 = {
    fade: fade,
    entering: entering,
    entered: entered,
    exiting: exiting,
    exited: exited
};
const classes = {
    entering: s$35.entering,
    entered: s$35.entered,
    exiting: s$35.exiting,
    exited: s$35.exited
};
class FadeIn extends $acw62.Component {
    render() {
        const useIn = this.props.in != null;
        const transitionTimeout = this.props.timeout || 0;
        const transitionIn = useIn ? this.props.in : true;
        return /* @__PURE__ */ $acw62.createElement(reactTransitionGroup.Transition, {
            appear: !useIn,
            timeout: transitionTimeout,
            in: transitionIn
        }, (state)=>this.props.children((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$35.fade, classes[state])));
    }
}
const s$34 = {};
let Form$1 = (_c = class extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.onSubmit = (event2)=>{
            event2.preventDefault();
            this.props.onSubmit(event2);
        };
    }
    render() {
        const { className, withAutocomplete = true, children: children2 } = this.props;
        return /* @__PURE__ */ $acw62.createElement("form", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$34.block, className),
            autoComplete: withAutocomplete ? EFormAutocomplete.ON : EFormAutocomplete.OFF,
            onSubmit: this.onSubmit
        }, children2);
    }
}, _c.defaultProps = {
    onSubmit: dist$4.noop
}, _c);
var isProduction = true;
function warning$1(condition, message2) {
    if (!isProduction) {
        var text2 = "Warning: " + message2;
        if (typeof console !== "undefined") console.warn(text2);
        try {
            throw Error(text2);
        } catch (x2) {}
    }
}
function _extends() {
    _extends = Object.assign || function(target2) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target2[key] = source[key];
        }
        return target2;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target2[key] = source[key];
    }
    return target2;
}
var isFunction$1 = function isFunction(obj) {
    return typeof obj === "function";
};
var isEmptyChildren = function isEmptyChildren2(children2) {
    return (0, $acw62.Children).count(children2) === 0;
};
function getIn(obj, key, def, p2) {
    if (p2 === void 0) p2 = 0;
    var path2 = toPath(key);
    while(obj && p2 < path2.length)obj = obj[path2[p2++]];
    return obj === void 0 ? def : obj;
}
var FormikContext = /* @__PURE__ */ (0, $acw62.createContext)(void 0);
FormikContext.displayName = "FormikContext";
FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && warning$1();
    return formik;
}
function Field(_ref) {
    var validate = _ref.validate, name2 = _ref.name, render2 = _ref.render, children2 = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name2, {
            validate: validate
        });
        return function() {
            unregisterField(name2);
        };
    }, [
        registerField,
        unregisterField,
        name2,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name2
    }, props));
    var meta = formik.getFieldMeta(name2);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render2) return render2(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction$1(children2)) return children2(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children2);
        }
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children2);
    }
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children2);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props), children2);
}
var Form = /* @__PURE__ */ (0, $acw62.forwardRef)(function(props, ref2) {
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref2,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
const FieldInputWithValidation = (0, $acw62.forwardRef)((props, ref2)=>{
    const { InputComponent = Input, name: name2, shouldHideErrorMessage = false, ...restProps } = props;
    const { touched, errors } = useFormikContext();
    return /* @__PURE__ */ $acw62.createElement(Field, {
        name: name2
    }, (fieldProps)=>{
        const { field: { value: value2, onBlur, onChange } } = fieldProps;
        const inputTouched = getIn(touched, name2);
        const inputError = getIn(errors, name2);
        const isValid2 = !inputTouched || !inputError;
        const error2 = !shouldHideErrorMessage && !isValid2 && inputError;
        return /* @__PURE__ */ $acw62.createElement(InputComponent, {
            ref: ref2,
            name: name2,
            onBlur: onBlur,
            onChange: onChange,
            value: value2,
            error: error2,
            isValid: isValid2,
            ...restProps
        });
    });
});
FieldInputWithValidation.displayName = "FieldInputValidation";
const InputNumberWithoutRef = (props)=>{
    const { value: value2, onChange, innerRef, onBlur, ...restProps } = props;
    const [_value, _setValue] = (0, $acw62.useState)(value2);
    const handleChange = (event2)=>{
        if (!/^[\d]*$/.test(event2.target.value)) return;
        _setValue(event2.target.value);
        onChange(event2);
    };
    const handleBlur = (event2)=>{
        if (event2.target.value !== void 0 && event2.target.value.length > 0) _setValue(String(Number(event2.target.value)));
        onBlur == null || onBlur(event2);
    };
    (0, $acw62.useEffect)(()=>{
        _setValue(value2);
    }, [
        value2
    ]);
    return /* @__PURE__ */ $acw62.createElement(Input, {
        innerRef: innerRef,
        value: _value,
        onChange: handleChange,
        onBlur: handleBlur,
        ...restProps
    });
};
const InputNumber = (0, $acw62.forwardRef)((props, ref2)=>/* @__PURE__ */ $acw62.createElement(InputNumberWithoutRef, {
        innerRef: ref2,
        ...props
    }));
InputNumber.displayName = "InputNumber";
const icon$B = "HintWithIcon-scss--module__icon___AwCDz";
const container$c = "HintWithIcon-scss--module__container___itkc6";
const s$33 = {
    icon: icon$B,
    container: container$c
};
const _HintWithIcon = class _HintWithIcon extends $acw62.PureComponent {
    render() {
        const { classNames, children: children2, tooltipAlign, tooltipTrigger, icon: icon2 = svg_name_hint } = this.props;
        return /* @__PURE__ */ $acw62.createElement(Tooltip, {
            classNames: {
                root: classNames.tooltip,
                content: classNames.tooltipContent
            },
            align: tooltipAlign || ETooltipPositions.RIGHT,
            trigger: tooltipTrigger,
            content: /* @__PURE__ */ $acw62.createElement("div", {
                className: s$33.container
            }, children2)
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: icon2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$33.icon, classNames.icon)
        }));
    }
};
_HintWithIcon.defaultProps = {
    classNames: {}
};
let HintWithIcon = _HintWithIcon;
const loader$1 = "Spinner-scss--module__loader___KrYV9";
const circular = "Spinner-scss--module__circular___ULZ1f";
const path = "Spinner-scss--module__path___xJvre";
const pathSolid = "Spinner-scss--module__pathSolid___uHfrx";
const thick = "Spinner-scss--module__thick___UrSik";
const s$32 = {
    loader: loader$1,
    circular: circular,
    path: path,
    pathSolid: pathSolid,
    thick: thick
};
const Spinner = (props)=>{
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$32.loader, props.className),
        style: {
            width: props.size,
            height: props.size
        }
    }, /* @__PURE__ */ $acw62.createElement("svg", {
        className: s$32.circular,
        viewBox: "25 25 50 50"
    }, /* @__PURE__ */ $acw62.createElement("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$32.path]: !props.solid,
            [s$32.pathSolid]: props.solid,
            [s$32.thick]: props.thick
        }),
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeMiterlimit: "10"
    })));
};
Spinner.defaultProps = {
    size: 100
};
var reactPaginate = {
    exports: {}
};
(function(module2, exports2) {
    !function(e2, a2) {
        module2.exports = a2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
    }(commonjsGlobal, (e2)=>(()=>{
            var a2 = {
                703: (e3, a3, t3)=>{
                    var r3 = t3(414);
                    function n3() {}
                    function i() {}
                    i.resetWarningCache = n3, e3.exports = function() {
                        function e4(e5, a5, t5, n4, i2, s2) {
                            if (s2 !== r3) {
                                var o2 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                                throw o2.name = "Invariant Violation", o2;
                            }
                        }
                        function a4() {
                            return e4;
                        }
                        e4.isRequired = e4;
                        var t4 = {
                            array: e4,
                            bigint: e4,
                            bool: e4,
                            func: e4,
                            number: e4,
                            object: e4,
                            string: e4,
                            symbol: e4,
                            any: e4,
                            arrayOf: a4,
                            element: e4,
                            elementType: e4,
                            instanceOf: a4,
                            node: e4,
                            objectOf: a4,
                            oneOf: a4,
                            oneOfType: a4,
                            shape: a4,
                            exact: a4,
                            checkPropTypes: i,
                            resetWarningCache: n3
                        };
                        return t4.PropTypes = t4, t4;
                    };
                },
                697: (e3, a3, t3)=>{
                    e3.exports = t3(703)();
                },
                414: (e3)=>{
                    e3.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                },
                98: (a3)=>{
                    a3.exports = e2;
                }
            }, t2 = {};
            function r2(e3) {
                var n3 = t2[e3];
                if (void 0 !== n3) return n3.exports;
                var i = t2[e3] = {
                    exports: {}
                };
                return a2[e3](i, i.exports, r2), i.exports;
            }
            r2.n = (e3)=>{
                var a3 = e3 && e3.__esModule ? ()=>e3.default : ()=>e3;
                return r2.d(a3, {
                    a: a3
                }), a3;
            }, r2.d = (e3, a3)=>{
                for(var t3 in a3)r2.o(a3, t3) && !r2.o(e3, t3) && Object.defineProperty(e3, t3, {
                    enumerable: true,
                    get: a3[t3]
                });
            }, r2.o = (e3, a3)=>Object.prototype.hasOwnProperty.call(e3, a3), r2.r = (e3)=>{
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(e3, "__esModule", {
                    value: true
                });
            };
            var n2 = {};
            return (()=>{
                r2.r(n2), r2.d(n2, {
                    default: ()=>k2
                });
                var e3 = r2(98), a3 = r2.n(e3), t3 = r2(697), i = r2.n(t3);
                function s2() {
                    return s2 = Object.assign ? Object.assign.bind() : function(e4) {
                        for(var a4 = 1; a4 < arguments.length; a4++){
                            var t4 = arguments[a4];
                            for(var r3 in t4)Object.prototype.hasOwnProperty.call(t4, r3) && (e4[r3] = t4[r3]);
                        }
                        return e4;
                    }, s2.apply(this, arguments);
                }
                var o2 = function(e4) {
                    var t4 = e4.pageClassName, r3 = e4.pageLinkClassName, n3 = e4.page, i2 = e4.selected, o3 = e4.activeClassName, l3 = e4.activeLinkClassName, c3 = e4.getEventListener, p3 = e4.pageSelectedHandler, u3 = e4.href, g3 = e4.extraAriaContext, d3 = e4.pageLabelBuilder, f3 = e4.rel, b3 = e4.ariaLabel || "Page " + n3 + (g3 ? " " + g3 : ""), v3 = null;
                    return i2 && (v3 = "page", b3 = e4.ariaLabel || "Page " + n3 + " is your current page", t4 = void 0 !== t4 ? t4 + " " + o3 : o3, void 0 !== r3 ? void 0 !== l3 && (r3 = r3 + " " + l3) : r3 = l3), a3().createElement("li", {
                        className: t4
                    }, a3().createElement("a", s2({
                        rel: f3,
                        role: u3 ? void 0 : "button",
                        className: r3,
                        href: u3,
                        tabIndex: i2 ? "-1" : "0",
                        "aria-label": b3,
                        "aria-current": v3,
                        onKeyPress: p3
                    }, c3(p3)), d3(n3)));
                };
                o2.propTypes = {
                    pageSelectedHandler: i().func.isRequired,
                    selected: i().bool.isRequired,
                    pageClassName: i().string,
                    pageLinkClassName: i().string,
                    activeClassName: i().string,
                    activeLinkClassName: i().string,
                    extraAriaContext: i().string,
                    href: i().string,
                    ariaLabel: i().string,
                    page: i().number.isRequired,
                    getEventListener: i().func.isRequired,
                    pageLabelBuilder: i().func.isRequired,
                    rel: i().string
                };
                const l2 = o2;
                function c2() {
                    return c2 = Object.assign ? Object.assign.bind() : function(e4) {
                        for(var a4 = 1; a4 < arguments.length; a4++){
                            var t4 = arguments[a4];
                            for(var r3 in t4)Object.prototype.hasOwnProperty.call(t4, r3) && (e4[r3] = t4[r3]);
                        }
                        return e4;
                    }, c2.apply(this, arguments);
                }
                var p2 = function(e4) {
                    var t4 = e4.breakLabel, r3 = e4.breakAriaLabel, n3 = e4.breakClassName, i2 = e4.breakLinkClassName, s3 = e4.breakHandler, o3 = e4.getEventListener, l3 = n3 || "break";
                    return a3().createElement("li", {
                        className: l3
                    }, a3().createElement("a", c2({
                        className: i2,
                        role: "button",
                        tabIndex: "0",
                        "aria-label": r3,
                        onKeyPress: s3
                    }, o3(s3)), t4));
                };
                p2.propTypes = {
                    breakLabel: i().oneOfType([
                        i().string,
                        i().node
                    ]),
                    breakAriaLabel: i().string,
                    breakClassName: i().string,
                    breakLinkClassName: i().string,
                    breakHandler: i().func.isRequired,
                    getEventListener: i().func.isRequired
                };
                const u2 = p2;
                function g2(e4) {
                    var a4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                    return null != e4 ? e4 : a4;
                }
                function d2(e4) {
                    return d2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e5) {
                        return typeof e5;
                    } : function(e5) {
                        return e5 && "function" == typeof Symbol && e5.constructor === Symbol && e5 !== Symbol.prototype ? "symbol" : typeof e5;
                    }, d2(e4);
                }
                function f2() {
                    return f2 = Object.assign ? Object.assign.bind() : function(e4) {
                        for(var a4 = 1; a4 < arguments.length; a4++){
                            var t4 = arguments[a4];
                            for(var r3 in t4)Object.prototype.hasOwnProperty.call(t4, r3) && (e4[r3] = t4[r3]);
                        }
                        return e4;
                    }, f2.apply(this, arguments);
                }
                function b2(e4, a4) {
                    for(var t4 = 0; t4 < a4.length; t4++){
                        var r3 = a4[t4];
                        r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e4, r3.key, r3);
                    }
                }
                function v2(e4, a4) {
                    return v2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e5, a5) {
                        return e5.__proto__ = a5, e5;
                    }, v2(e4, a4);
                }
                function h2(e4, a4) {
                    if (a4 && ("object" === d2(a4) || "function" == typeof a4)) return a4;
                    if (void 0 !== a4) throw new TypeError("Derived constructors may only return object or undefined");
                    return m2(e4);
                }
                function m2(e4) {
                    if (void 0 === e4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e4;
                }
                function y2(e4) {
                    return y2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e5) {
                        return e5.__proto__ || Object.getPrototypeOf(e5);
                    }, y2(e4);
                }
                function C(e4, a4, t4) {
                    return a4 in e4 ? Object.defineProperty(e4, a4, {
                        value: t4,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    }) : e4[a4] = t4, e4;
                }
                var P2 = function(e4) {
                    !function(e5, a4) {
                        if ("function" != typeof a4 && null !== a4) throw new TypeError("Super expression must either be null or a function");
                        e5.prototype = Object.create(a4 && a4.prototype, {
                            constructor: {
                                value: e5,
                                writable: true,
                                configurable: true
                            }
                        }), Object.defineProperty(e5, "prototype", {
                            writable: false
                        }), a4 && v2(e5, a4);
                    }(o3, e4);
                    var t4, r3, n3, i2, s3 = (n3 = o3, i2 = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return false;
                        if (Reflect.construct.sham) return false;
                        if ("function" == typeof Proxy) return true;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), true;
                        } catch (e5) {
                            return false;
                        }
                    }(), function() {
                        var e5, a4 = y2(n3);
                        if (i2) {
                            var t5 = y2(this).constructor;
                            e5 = Reflect.construct(a4, arguments, t5);
                        } else e5 = a4.apply(this, arguments);
                        return h2(this, e5);
                    });
                    function o3(e5) {
                        var t5, r4;
                        return function(e6, a4) {
                            if (!(e6 instanceof a4)) throw new TypeError("Cannot call a class as a function");
                        }(this, o3), C(m2(t5 = s3.call(this, e5)), "handlePreviousPage", function(e6) {
                            var a4 = t5.state.selected;
                            t5.handleClick(e6, null, a4 > 0 ? a4 - 1 : void 0, {
                                isPrevious: true
                            });
                        }), C(m2(t5), "handleNextPage", function(e6) {
                            var a4 = t5.state.selected, r5 = t5.props.pageCount;
                            t5.handleClick(e6, null, a4 < r5 - 1 ? a4 + 1 : void 0, {
                                isNext: true
                            });
                        }), C(m2(t5), "handlePageSelected", function(e6, a4) {
                            if (t5.state.selected === e6) return t5.callActiveCallback(e6), void t5.handleClick(a4, null, void 0, {
                                isActive: true
                            });
                            t5.handleClick(a4, null, e6);
                        }), C(m2(t5), "handlePageChange", function(e6) {
                            t5.state.selected !== e6 && (t5.setState({
                                selected: e6
                            }), t5.callCallback(e6));
                        }), C(m2(t5), "getEventListener", function(e6) {
                            return C({}, t5.props.eventListener, e6);
                        }), C(m2(t5), "handleClick", function(e6, a4, r5) {
                            var n4 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i3 = n4.isPrevious, s4 = void 0 !== i3 && i3, o4 = n4.isNext, l3 = void 0 !== o4 && o4, c3 = n4.isBreak, p3 = void 0 !== c3 && c3, u3 = n4.isActive, g3 = void 0 !== u3 && u3;
                            e6.preventDefault ? e6.preventDefault() : e6.returnValue = false;
                            var d3 = t5.state.selected, f3 = t5.props.onClick, b3 = r5;
                            if (f3) {
                                var v3 = f3({
                                    index: a4,
                                    selected: d3,
                                    nextSelectedPage: r5,
                                    event: e6,
                                    isPrevious: s4,
                                    isNext: l3,
                                    isBreak: p3,
                                    isActive: g3
                                });
                                if (false === v3) return;
                                Number.isInteger(v3) && (b3 = v3);
                            }
                            void 0 !== b3 && t5.handlePageChange(b3);
                        }), C(m2(t5), "handleBreakClick", function(e6, a4) {
                            var r5 = t5.state.selected;
                            t5.handleClick(a4, e6, r5 < e6 ? t5.getForwardJump() : t5.getBackwardJump(), {
                                isBreak: true
                            });
                        }), C(m2(t5), "callCallback", function(e6) {
                            void 0 !== t5.props.onPageChange && "function" == typeof t5.props.onPageChange && t5.props.onPageChange({
                                selected: e6
                            });
                        }), C(m2(t5), "callActiveCallback", function(e6) {
                            void 0 !== t5.props.onPageActive && "function" == typeof t5.props.onPageActive && t5.props.onPageActive({
                                selected: e6
                            });
                        }), C(m2(t5), "getElementPageRel", function(e6) {
                            var a4 = t5.state.selected, r5 = t5.props, n4 = r5.nextPageRel, i3 = r5.prevPageRel, s4 = r5.selectedPageRel;
                            return a4 - 1 === e6 ? i3 : a4 === e6 ? s4 : a4 + 1 === e6 ? n4 : void 0;
                        }), C(m2(t5), "pagination", function() {
                            var e6 = [], r5 = t5.props, n4 = r5.pageRangeDisplayed, i3 = r5.pageCount, s4 = r5.marginPagesDisplayed, o4 = r5.breakLabel, l3 = r5.breakClassName, c3 = r5.breakLinkClassName, p3 = r5.breakAriaLabels, g3 = t5.state.selected;
                            if (i3 <= n4) for(var d3 = 0; d3 < i3; d3++)e6.push(t5.getPageElement(d3));
                            else {
                                var f3 = n4 / 2, b3 = n4 - f3;
                                g3 > i3 - n4 / 2 ? f3 = n4 - (b3 = i3 - g3) : g3 < n4 / 2 && (b3 = n4 - (f3 = g3));
                                var v3, h3, m3 = function(e7) {
                                    return t5.getPageElement(e7);
                                }, y3 = [];
                                for(v3 = 0; v3 < i3; v3++){
                                    var C2 = v3 + 1;
                                    if (C2 <= s4) y3.push({
                                        type: "page",
                                        index: v3,
                                        display: m3(v3)
                                    });
                                    else if (C2 > i3 - s4) y3.push({
                                        type: "page",
                                        index: v3,
                                        display: m3(v3)
                                    });
                                    else if (v3 >= g3 - f3 && v3 <= g3 + (0 === g3 && n4 > 1 ? b3 - 1 : b3)) y3.push({
                                        type: "page",
                                        index: v3,
                                        display: m3(v3)
                                    });
                                    else if (o4 && y3.length > 0 && y3[y3.length - 1].display !== h3 && (n4 > 0 || s4 > 0)) {
                                        var P3 = v3 < g3 ? p3.backward : p3.forward;
                                        h3 = a3().createElement(u2, {
                                            key: v3,
                                            breakAriaLabel: P3,
                                            breakLabel: o4,
                                            breakClassName: l3,
                                            breakLinkClassName: c3,
                                            breakHandler: t5.handleBreakClick.bind(null, v3),
                                            getEventListener: t5.getEventListener
                                        }), y3.push({
                                            type: "break",
                                            index: v3,
                                            display: h3
                                        });
                                    }
                                }
                                y3.forEach(function(a4, t6) {
                                    var r6 = a4;
                                    "break" === a4.type && y3[t6 - 1] && "page" === y3[t6 - 1].type && y3[t6 + 1] && "page" === y3[t6 + 1].type && y3[t6 + 1].index - y3[t6 - 1].index <= 2 && (r6 = {
                                        type: "page",
                                        index: a4.index,
                                        display: m3(a4.index)
                                    }), e6.push(r6.display);
                                });
                            }
                            return e6;
                        }), void 0 !== e5.initialPage && void 0 !== e5.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e5.initialPage, ") and forcePage (").concat(e5.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), r4 = e5.initialPage ? e5.initialPage : e5.forcePage ? e5.forcePage : 0, t5.state = {
                            selected: r4
                        }, t5;
                    }
                    return t4 = o3, r3 = [
                        {
                            key: "componentDidMount",
                            value: function() {
                                var e5 = this.props, a4 = e5.initialPage, t5 = e5.disableInitialCallback, r4 = e5.extraAriaContext, n4 = e5.pageCount, i3 = e5.forcePage;
                                void 0 === a4 || t5 || this.callCallback(a4), r4 && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(n4) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n4, "). Did you forget a Math.ceil()?")), void 0 !== a4 && a4 > n4 - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(a4, " > ").concat(n4 - 1, ").")), void 0 !== i3 && i3 > n4 - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i3, " > ").concat(n4 - 1, ")."));
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(e5) {
                                void 0 !== this.props.forcePage && this.props.forcePage !== e5.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                    selected: this.props.forcePage
                                })), Number.isInteger(e5.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                            }
                        },
                        {
                            key: "getForwardJump",
                            value: function() {
                                var e5 = this.state.selected, a4 = this.props, t5 = a4.pageCount, r4 = e5 + a4.pageRangeDisplayed;
                                return r4 >= t5 ? t5 - 1 : r4;
                            }
                        },
                        {
                            key: "getBackwardJump",
                            value: function() {
                                var e5 = this.state.selected - this.props.pageRangeDisplayed;
                                return e5 < 0 ? 0 : e5;
                            }
                        },
                        {
                            key: "getElementHref",
                            value: function(e5) {
                                var a4 = this.props, t5 = a4.hrefBuilder, r4 = a4.pageCount, n4 = a4.hrefAllControls;
                                if (t5) return n4 || e5 >= 0 && e5 < r4 ? t5(e5 + 1, r4, this.state.selected) : void 0;
                            }
                        },
                        {
                            key: "ariaLabelBuilder",
                            value: function(e5) {
                                var a4 = e5 === this.state.selected;
                                if (this.props.ariaLabelBuilder && e5 >= 0 && e5 < this.props.pageCount) {
                                    var t5 = this.props.ariaLabelBuilder(e5 + 1, a4);
                                    return this.props.extraAriaContext && !a4 && (t5 = t5 + " " + this.props.extraAriaContext), t5;
                                }
                            }
                        },
                        {
                            key: "getPageElement",
                            value: function(e5) {
                                var t5 = this.state.selected, r4 = this.props, n4 = r4.pageClassName, i3 = r4.pageLinkClassName, s4 = r4.activeClassName, o4 = r4.activeLinkClassName, c3 = r4.extraAriaContext, p3 = r4.pageLabelBuilder;
                                return a3().createElement(l2, {
                                    key: e5,
                                    pageSelectedHandler: this.handlePageSelected.bind(null, e5),
                                    selected: t5 === e5,
                                    rel: this.getElementPageRel(e5),
                                    pageClassName: n4,
                                    pageLinkClassName: i3,
                                    activeClassName: s4,
                                    activeLinkClassName: o4,
                                    extraAriaContext: c3,
                                    href: this.getElementHref(e5),
                                    ariaLabel: this.ariaLabelBuilder(e5),
                                    page: e5 + 1,
                                    pageLabelBuilder: p3,
                                    getEventListener: this.getEventListener
                                });
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var e5 = this.props.renderOnZeroPageCount;
                                if (0 === this.props.pageCount && void 0 !== e5) return e5 ? e5(this.props) : e5;
                                var t5 = this.props, r4 = t5.disabledClassName, n4 = t5.disabledLinkClassName, i3 = t5.pageCount, s4 = t5.className, o4 = t5.containerClassName, l3 = t5.previousLabel, c3 = t5.previousClassName, p3 = t5.previousLinkClassName, u3 = t5.previousAriaLabel, d3 = t5.prevRel, b3 = t5.nextLabel, v3 = t5.nextClassName, h3 = t5.nextLinkClassName, m3 = t5.nextAriaLabel, y3 = t5.nextRel, C2 = this.state.selected, P3 = 0 === C2, k3 = C2 === i3 - 1, x2 = "".concat(g2(c3)).concat(P3 ? " ".concat(g2(r4)) : ""), L2 = "".concat(g2(v3)).concat(k3 ? " ".concat(g2(r4)) : ""), N = "".concat(g2(p3)).concat(P3 ? " ".concat(g2(n4)) : ""), O2 = "".concat(g2(h3)).concat(k3 ? " ".concat(g2(n4)) : ""), R2 = P3 ? "true" : "false", E2 = k3 ? "true" : "false";
                                return a3().createElement("ul", {
                                    className: s4 || o4,
                                    role: "navigation",
                                    "aria-label": "Pagination"
                                }, a3().createElement("li", {
                                    className: x2
                                }, a3().createElement("a", f2({
                                    className: N,
                                    href: this.getElementHref(C2 - 1),
                                    tabIndex: P3 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handlePreviousPage,
                                    "aria-disabled": R2,
                                    "aria-label": u3,
                                    rel: d3
                                }, this.getEventListener(this.handlePreviousPage)), l3)), this.pagination(), a3().createElement("li", {
                                    className: L2
                                }, a3().createElement("a", f2({
                                    className: O2,
                                    href: this.getElementHref(C2 + 1),
                                    tabIndex: k3 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handleNextPage,
                                    "aria-disabled": E2,
                                    "aria-label": m3,
                                    rel: y3
                                }, this.getEventListener(this.handleNextPage)), b3)));
                            }
                        }
                    ], b2(t4.prototype, r3), Object.defineProperty(t4, "prototype", {
                        writable: false
                    }), o3;
                }(e3.Component);
                C(P2, "propTypes", {
                    pageCount: i().number.isRequired,
                    pageRangeDisplayed: i().number,
                    marginPagesDisplayed: i().number,
                    previousLabel: i().node,
                    previousAriaLabel: i().string,
                    prevPageRel: i().string,
                    prevRel: i().string,
                    nextLabel: i().node,
                    nextAriaLabel: i().string,
                    nextPageRel: i().string,
                    nextRel: i().string,
                    breakLabel: i().oneOfType([
                        i().string,
                        i().node
                    ]),
                    breakAriaLabels: i().shape({
                        forward: i().string,
                        backward: i().string
                    }),
                    hrefBuilder: i().func,
                    hrefAllControls: i().bool,
                    onPageChange: i().func,
                    onPageActive: i().func,
                    onClick: i().func,
                    initialPage: i().number,
                    forcePage: i().number,
                    disableInitialCallback: i().bool,
                    containerClassName: i().string,
                    className: i().string,
                    pageClassName: i().string,
                    pageLinkClassName: i().string,
                    pageLabelBuilder: i().func,
                    activeClassName: i().string,
                    activeLinkClassName: i().string,
                    previousClassName: i().string,
                    nextClassName: i().string,
                    previousLinkClassName: i().string,
                    nextLinkClassName: i().string,
                    disabledClassName: i().string,
                    disabledLinkClassName: i().string,
                    breakClassName: i().string,
                    breakLinkClassName: i().string,
                    extraAriaContext: i().string,
                    ariaLabelBuilder: i().func,
                    eventListener: i().string,
                    renderOnZeroPageCount: i().func,
                    selectedPageRel: i().string
                }), C(P2, "defaultProps", {
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 3,
                    activeClassName: "selected",
                    previousLabel: "Previous",
                    previousClassName: "previous",
                    previousAriaLabel: "Previous page",
                    prevPageRel: "prev",
                    prevRel: "prev",
                    nextLabel: "Next",
                    nextClassName: "next",
                    nextAriaLabel: "Next page",
                    nextPageRel: "next",
                    nextRel: "next",
                    breakLabel: "...",
                    breakAriaLabels: {
                        forward: "Jump forward",
                        backward: "Jump backward"
                    },
                    disabledClassName: "disabled",
                    disableInitialCallback: false,
                    pageLabelBuilder: function(e4) {
                        return e4;
                    },
                    eventListener: "onClick",
                    renderOnZeroPageCount: void 0,
                    selectedPageRel: "canonical",
                    hrefAllControls: false
                });
                const k2 = P2;
            })(), n2;
        })());
})(reactPaginate);
var reactPaginateExports = reactPaginate.exports;
const ReactPaginate = /* @__PURE__ */ getDefaultExportFromCjs(reactPaginateExports);
const paginationItem = "Pagination-scss--module__paginationItem___96VZe";
const paginationItemSelected = "Pagination-scss--module__paginationItemSelected___Fvtn2";
const arrow$2 = "Pagination-scss--module__arrow___Gc3nV";
const arrowDisabled = "Pagination-scss--module__arrowDisabled___5Ssfr";
const ellipsis = "Pagination-scss--module__ellipsis___RPWnn";
const container$b = "Pagination-scss--module__container___uyte3";
const arrowRight$1 = "Pagination-scss--module__arrowRight___UC-eo";
const link$2 = "Pagination-scss--module__link___RA-h0";
const s$31 = {
    paginationItem: paginationItem,
    paginationItemSelected: paginationItemSelected,
    arrow: arrow$2,
    arrowDisabled: arrowDisabled,
    ellipsis: ellipsis,
    container: container$b,
    arrowRight: arrowRight$1,
    link: link$2
};
const RAGES_PAGES_LIMIT = 3;
const MARGIN_PAGES = 1;
const _Pagination = class _Pagination extends $acw62.PureComponent {
    constructor(){
        super(...arguments);
        this.state = {
            currentPage: 0
        };
        this.onPageChange = ({ selected: pageIndex })=>{
            this.setState({
                currentPage: pageIndex
            }, ()=>this.props.onPageChange(pageIndex));
        };
    }
    componentDidUpdate(prevProps, prevState) {
        const { forcePage } = this.props;
        if (forcePage && forcePage !== this.state.currentPage) this.setState({
            currentPage: this.props.forcePage
        });
    }
    render() {
        const { currentPage } = this.state;
        const { pageCount, marginPages, ragesPagesLimit, initialPage, forcePage, className, itemClassName, disableInitialCallback } = this.props;
        const isFirstPage = currentPage === 0;
        const isLastPage = currentPage === pageCount - 1;
        return /* @__PURE__ */ $acw62.createElement(ReactPaginate, {
            pageCount: pageCount,
            pageRangeDisplayed: ragesPagesLimit,
            marginPagesDisplayed: marginPages,
            containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.container, className),
            pageLinkClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.paginationItem, itemClassName),
            activeLinkClassName: s$31.paginationItemSelected,
            previousLabel: /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.paginationItem, itemClassName)
            }, /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: svg_name_arrow_short,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.arrow, {
                    [s$31.arrowDisabled]: isFirstPage
                })
            })),
            previousLinkClassName: s$31.link,
            nextLabel: /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.paginationItem, itemClassName)
            }, /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: svg_name_arrow_short,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$31.arrow, s$31.arrowRight, {
                    [s$31.arrowDisabled]: isLastPage
                })
            })),
            nextLinkClassName: s$31.link,
            breakLabel: /* @__PURE__ */ $acw62.createElement("div", {
                className: s$31.ellipsis
            }, "..."),
            breakLinkClassName: s$31.link,
            onPageChange: this.onPageChange,
            initialPage: initialPage,
            forcePage: forcePage,
            disableInitialCallback: disableInitialCallback
        });
    }
};
_Pagination.defaultProps = {
    ragesPagesLimit: RAGES_PAGES_LIMIT,
    marginPages: MARGIN_PAGES
};
let Pagination = _Pagination;
const root$1R = "PopoverList-scss--module__root___cgNCp";
const item$8 = "PopoverList-scss--module__item___F5aiC";
const active$6 = "PopoverList-scss--module__active___-bN1V";
const empty$2 = "PopoverList-scss--module__empty___UItBj";
const s$30 = {
    root: root$1R,
    item: item$8,
    active: active$6,
    empty: empty$2
};
const PopoverListItem = (0, $acw62.forwardRef)((props, ref2)=>{
    const { children: children2, isActive, ...rest } = props;
    const id = useId();
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$30.item, {
            [s$30.active]: isActive
        }),
        ref: ref2,
        role: "option",
        id: id,
        tabIndex: isActive ? 0 : -1,
        "aria-selected": isActive,
        ...rest
    }, children2);
});
PopoverListItem.displayName = "PopoverListItem";
const locales$1I = {
    empty: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
};
const t$1J = distExports$1.getTranslation && locales$1I;
const PopoverList = (props)=>{
    const { classNames = {}, items, x: x2, y: y2, floating, strategy, getFloatingProps, onClick, listRef, activeIndex, getItemProps } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$30.root, classNames.root),
        style: {
            position: strategy,
            top: y2 ?? 0,
            left: x2 ?? 0,
            outline: 0
        },
        ...getFloatingProps({
            ref: floating
        })
    }, /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        className: classNames.scrollContainer
    }, Boolean(items == null ? void 0 : items.length) ? items.map((item2, i)=>/* @__PURE__ */ $acw62.createElement(PopoverListItem, {
            key: item2.id,
            ...getItemProps({
                key: item2.id,
                ref (node) {
                    listRef.current[i] = node;
                },
                onClick () {
                    onClick(item2);
                },
                onKeyDown (event2) {
                    if (event2.key === EKeyboardKey.ENTER) onClick(item2);
                }
            }),
            isActive: activeIndex === i
        }, item2.nick || item2.displayName)) : /* @__PURE__ */ $acw62.createElement("div", {
        className: s$30.empty
    }, t$1J.empty)));
};
const PopoverFloating = (props)=>{
    const { context, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(FloatingFocusManager, {
        context: context,
        visuallyHiddenDismiss: true,
        initialFocus: -1
    }, /* @__PURE__ */ $acw62.createElement(PopoverList, {
        ...restProps
    }));
};
var bodyScrollLock_min = {};
(function(exports2) {
    !function(e2, t2) {
        t2(exports2);
    }(commonjsGlobal, function(exports3) {
        function i(e3) {
            if (Array.isArray(e3)) {
                for(var t2 = 0, o3 = Array(e3.length); t2 < e3.length; t2++)o3[t2] = e3[t2];
                return o3;
            }
            return Array.from(e3);
        }
        Object.defineProperty(exports3, "__esModule", {
            value: true
        });
        var l2 = false;
        if ("undefined" != typeof window) {
            var e2 = {
                get passive () {
                    l2 = true;
                }
            };
            window.addEventListener("testPassive", null, e2), window.removeEventListener("testPassive", null, e2);
        }
        function d2(t2) {
            return u2.some(function(e3) {
                return !(!e3.options.allowTouchMove || !e3.options.allowTouchMove(t2));
            });
        }
        function c2(e3) {
            var t2 = e3 || window.event;
            return !!d2(t2.target) || 1 < t2.touches.length || (t2.preventDefault && t2.preventDefault(), false);
        }
        function o2() {
            setTimeout(function() {
                void 0 !== m2 && (document.body.style.paddingRight = m2, m2 = void 0), void 0 !== f2 && (document.body.style.overflow = f2, f2 = void 0);
            });
        }
        var a2 = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), u2 = [], s2 = false, v2 = -1, f2 = void 0, m2 = void 0;
        exports3.disableBodyScroll = function(r2, e3) {
            if (a2) {
                if (!r2) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
                if (r2 && !u2.some(function(e4) {
                    return e4.targetElement === r2;
                })) {
                    var t2 = {
                        targetElement: r2,
                        options: e3 || {}
                    };
                    u2 = [].concat(i(u2), [
                        t2
                    ]), r2.ontouchstart = function(e4) {
                        1 === e4.targetTouches.length && (v2 = e4.targetTouches[0].clientY);
                    }, r2.ontouchmove = function(e4) {
                        var t3, o4, n3, i2;
                        1 === e4.targetTouches.length && (o4 = r2, i2 = (t3 = e4).targetTouches[0].clientY - v2, d2(t3.target) || (o4 && 0 === o4.scrollTop && 0 < i2 || (n3 = o4) && n3.scrollHeight - n3.scrollTop <= n3.clientHeight && i2 < 0 ? c2(t3) : t3.stopPropagation()));
                    }, s2 || (document.addEventListener("touchmove", c2, l2 ? {
                        passive: false
                    } : void 0), s2 = true);
                }
            } else {
                n2 = e3, setTimeout(function() {
                    if (void 0 === m2) {
                        var e4 = !!n2 && true === n2.reserveScrollBarGap, t3 = window.innerWidth - document.documentElement.clientWidth;
                        e4 && 0 < t3 && (m2 = document.body.style.paddingRight, document.body.style.paddingRight = t3 + "px");
                    }
                    void 0 === f2 && (f2 = document.body.style.overflow, document.body.style.overflow = "hidden");
                });
                var o3 = {
                    targetElement: r2,
                    options: e3 || {}
                };
                u2 = [].concat(i(u2), [
                    o3
                ]);
            }
            var n2;
        }, exports3.clearAllBodyScrollLocks = function() {
            a2 ? (u2.forEach(function(e3) {
                e3.targetElement.ontouchstart = null, e3.targetElement.ontouchmove = null;
            }), s2 && (document.removeEventListener("touchmove", c2, l2 ? {
                passive: false
            } : void 0), s2 = false), u2 = [], v2 = -1) : (o2(), u2 = []);
        }, exports3.enableBodyScroll = function(t2) {
            if (a2) {
                if (!t2) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
                t2.ontouchstart = null, t2.ontouchmove = null, u2 = u2.filter(function(e3) {
                    return e3.targetElement !== t2;
                }), s2 && 0 === u2.length && (document.removeEventListener("touchmove", c2, l2 ? {
                    passive: false
                } : void 0), s2 = false);
            } else (u2 = u2.filter(function(e3) {
                return e3.targetElement !== t2;
            })).length || o2();
        };
    });
})(bodyScrollLock_min);
const scrollContainer$1 = "ScrollBox-scss--module__scrollContainer___JoIup";
const scrollContainerFixedHeight = "ScrollBox-scss--module__scrollContainerFixedHeight___z6kas";
const s$2$ = {
    scrollContainer: scrollContainer$1,
    scrollContainerFixedHeight: scrollContainerFixedHeight
};
const ScrollBox = (props)=>{
    const { children: children2, className, isAutoHeight, isVisible, getRef = ()=>null, onClick } = props;
    const ref2 = (0, $acw62.useRef)();
    const lockTargetRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        getRef(ref2.current);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isVisible) {
            bodyScrollLock_min.disableBodyScroll(ref2.current, {
                reserveScrollBarGap: true
            });
            lockTargetRef.current = ref2.current;
        } else bodyScrollLock_min.enableBodyScroll(ref2.current);
        return ()=>{
            bodyScrollLock_min.enableBodyScroll(lockTargetRef.current);
        };
    }, [
        isVisible
    ]);
    return /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        ref: ref2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2$.scrollContainer, className, {
            [s$2$.scrollContainerFixedHeight]: !isAutoHeight
        }),
        onClick: onClick
    }, children2);
};
const block$3 = "PopupContent-scss--module__block___KVFL-";
const close$5 = "PopupContent-scss--module__close___B70UA";
const iconClose$1 = "PopupContent-scss--module__iconClose___8sG6d";
const title$o = "PopupContent-scss--module__title___z9j6O";
const content$c = "PopupContent-scss--module__content___x4iaw";
const footer$a = "PopupContent-scss--module__footer___PSLDz";
const s$2_ = {
    block: block$3,
    close: close$5,
    iconClose: iconClose$1,
    title: title$o,
    content: content$c,
    footer: footer$a
};
const PopupContentWithoutRef = (props)=>{
    const { title: title2, footer: footer2, styles, isHiddenClose, onClose, classNames: { block: blockClassName, close: closeClassName, closeIcon: closeIconClassName, title: titleClassName, content: contentClassName, footer: footerClassName }, testIds, children: children2, innerRef } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.block, blockClassName),
        tabIndex: 0,
        style: styles,
        ref: innerRef,
        ...testAttr(testIds == null ? void 0 : testIds.block)
    }, !isHiddenClose && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.close, closeClassName),
        onClick: onClose
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.iconClose, closeIconClassName),
        glyph: svg_name_cancel_20
    })), title2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.title, titleClassName)
    }, title2), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.content, contentClassName)
    }, children2), footer2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2_.footer, footerClassName)
    }, footer2));
};
const PopupContent = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(PopupContentWithoutRef, {
        innerRef: ref2,
        ...props
    }));
PopupContent.displayName = "PopupContent";
const wrapper$2 = "Popup-scss--module__wrapper___b8wzP";
const blockColorful = "Popup-scss--module__blockColorful___gR6Km";
const colorfulBg = "Popup-scss--module__colorfulBg___jATbC";
const block$2 = "Popup-scss--module__block___Z5sdb";
const s$2Z = {
    wrapper: wrapper$2,
    blockColorful: blockColorful,
    colorfulBg: colorfulBg,
    block: block$2
};
const _Popup = class _Popup extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.popupRef = $acw62.createRef();
        this.getPopupRef = (el)=>{
            this.props.getWrapperRef(el);
        };
        this.onWrapperClick = (event2)=>{
            const { isModal, onClose, onClickOutside } = this.props;
            if (!isModal) onClose();
            if (Boolean(onClickOutside) && !this.popupRef.current.contains(event2.target)) onClickOutside();
        };
        this.onCloseClick = ()=>{
            this.props.onClose();
        };
    }
    componentDidMount() {
        var _a3;
        (_a3 = this.popupRef.current) == null || _a3.focus({
            preventScroll: true
        });
    }
    componentWillUnmount() {
        const { classNames: { root: rootClassName }, inPortal } = this.props;
        if (inPortal && rootClassName) {
            const container2 = document.getElementById("modal");
            container2 == null || container2.classList.remove(rootClassName);
        }
    }
    render() {
        const { classNames: { wrapper: wrapperClassName, root: rootClassName }, isColorful, inPortal } = this.props;
        const content2 = /* @__PURE__ */ $acw62.createElement(FadeIn, null, (fadeClassName)=>/* @__PURE__ */ $acw62.createElement(ScrollBox, {
                isVisible: true,
                getRef: this.getPopupRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Z.wrapper, fadeClassName, wrapperClassName),
                onClick: this.onWrapperClick
            }, /* @__PURE__ */ $acw62.createElement(PopupContent, {
                ref: this.popupRef,
                ...this.props,
                classNames: {
                    ...this.props.classNames,
                    block: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Z.block, this.props.classNames.block, {
                        [s$2Z.blockColorful]: isColorful
                    })
                }
            }, isColorful && /* @__PURE__ */ $acw62.createElement("div", {
                className: s$2Z.colorfulBg
            }, /* @__PURE__ */ $acw62.createElement("div", {
                className: "middleFlash"
            })), this.props.children)));
        if (inPortal) {
            const container2 = document.getElementById("modal");
            if (rootClassName) container2 == null || container2.classList.add(rootClassName);
            return (0, $1u0KT.createPortal)(content2, container2);
        }
        return content2;
    }
};
_Popup.defaultProps = {
    classNames: {},
    isModal: true,
    getWrapperRef: dist$4.noop,
    onClose: dist$4.noop,
    inPortal: false
};
let Popup = _Popup;
var EButtonMode = /* @__PURE__ */ ((EButtonMode2)=>{
    EButtonMode2["PRIMARY"] = "primary";
    EButtonMode2["SECONDARY"] = "secondary";
    EButtonMode2["TERTIARY"] = "tertiary";
    EButtonMode2["LINK"] = "link";
    return EButtonMode2;
})(EButtonMode || {});
var EButtonAppearance = /* @__PURE__ */ ((EButtonAppearance2)=>{
    EButtonAppearance2["ACCENT"] = "accent";
    EButtonAppearance2["NEGATIVE"] = "negative";
    EButtonAppearance2["OVERLAY"] = "overlay";
    EButtonAppearance2["POSITIVE"] = "positive";
    return EButtonAppearance2;
})(EButtonAppearance || {});
var EButtonSize = /* @__PURE__ */ ((EButtonSize2)=>{
    EButtonSize2["SMALL"] = "small";
    EButtonSize2["MEDIUM"] = "medium";
    EButtonSize2["LARGE"] = "large";
    return EButtonSize2;
})(EButtonSize || {});
var EUIPaletteSizeClass = /* @__PURE__ */ ((EUIPaletteSizeClass2)=>{
    EUIPaletteSizeClass2["COMPACT"] = "compact";
    EUIPaletteSizeClass2["REGULAR"] = "regular";
    return EUIPaletteSizeClass2;
})(EUIPaletteSizeClass || {});
const UIPaletteContext = (0, $acw62.createContext)({
    sizeClass: EUIPaletteSizeClass.COMPACT
});
const useUIPaletteContext = ()=>(0, $acw62.useContext)(UIPaletteContext);
const root$1Q = "Button-scss--module__root___dD8ix";
const widthAuto = "Button-scss--module__widthAuto___1N54e";
const regular = "Button-scss--module__regular___aUX0r";
const small$2 = "Button-scss--module__small___EC45e";
const medium$2 = "Button-scss--module__medium___F4Rb6";
const large$2 = "Button-scss--module__large___leAfZ";
const compact = "Button-scss--module__compact___Pnp4V";
const accent = "Button-scss--module__accent___Zm-nm";
const primary = "Button-scss--module__primary___xNNuy";
const secondary = "Button-scss--module__secondary___c4akV";
const tertiary = "Button-scss--module__tertiary___aowhk";
const positive = "Button-scss--module__positive___I7F4O";
const negative = "Button-scss--module__negative___DyTIV";
const overlay = "Button-scss--module__overlay___GpW9b";
const fadeIn$5 = "Button-scss--module__fadeIn___2jaTy";
const s$2Y = {
    root: root$1Q,
    widthAuto: widthAuto,
    regular: regular,
    small: small$2,
    medium: medium$2,
    large: large$2,
    compact: compact,
    accent: accent,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    positive: positive,
    negative: negative,
    overlay: overlay,
    fadeIn: fadeIn$5
};
const ButtonWithoutRef = (props, ref2)=>{
    const { after, appearance = EButtonAppearance.ACCENT, before: before2, className, children: children2, dataAttributes, isDisabled: isDisabled2, mode: mode2 = EButtonMode.PRIMARY, size: size2 = EButtonSize.MEDIUM, sizeClass: sizeClassProp, stretched, ...restProps } = props;
    const { sizeClass: sizeClassContext } = useUIPaletteContext();
    const sizeClass = sizeClassProp ?? sizeClassContext;
    return /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Y.root, s$2Y[appearance], s$2Y[mode2], s$2Y[size2], s$2Y[sizeClass], className, {
            [s$2Y.widthAuto]: stretched
        }),
        ...dataAttributes,
        disabled: isDisabled2,
        ref: ref2,
        ...restProps
    }, Boolean(before2) && before2, children2, Boolean(after) && after);
};
const Button$1 = (0, $acw62.forwardRef)(ButtonWithoutRef);
var EProgressBarDirection = /* @__PURE__ */ ((EProgressBarDirection2)=>{
    EProgressBarDirection2["LEFT_TO_RIGHT"] = "leftToRight";
    EProgressBarDirection2["RIGHT_TO_LEFT"] = "rightToLeft";
    return EProgressBarDirection2;
})(EProgressBarDirection || {});
const root$1P = "ProgressBar-scss--module__root___MRqhe";
const progressLine$2 = "ProgressBar-scss--module__progressLine___1Eo12";
const rightToLeft = "ProgressBar-scss--module__rightToLeft___9L4lh";
const s$2X = {
    root: root$1P,
    progressLine: progressLine$2,
    rightToLeft: rightToLeft
};
const ProgressBar$1 = (props)=>{
    const { classNames = {}, percent, direction: direction2 = EProgressBarDirection.LEFT_TO_RIGHT, styles } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2X.root, classNames.root, {
            [s$2X.rightToLeft]: direction2 === EProgressBarDirection.RIGHT_TO_LEFT
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2X.progressLine, classNames.progressLine),
        style: {
            width: `${percent}%`,
            ...(styles == null ? void 0 : styles.progressLine) || {}
        }
    }));
};
var ERadioButtonMode = /* @__PURE__ */ ((ERadioButtonMode2)=>{
    ERadioButtonMode2["LIGHT"] = "light";
    ERadioButtonMode2["DARK"] = "dark";
    return ERadioButtonMode2;
})(ERadioButtonMode || {});
const radio$1 = "RadioButton-scss--module__radio___My0YI";
const root$1O = "RadioButton-scss--module__root___Cmfhj";
const rootDisabled$1 = "RadioButton-scss--module__rootDisabled___k51pq";
const labelText$1 = "RadioButton-scss--module__labelText___c7FXl";
const labelTextDisabled = "RadioButton-scss--module__labelTextDisabled___iunK0";
const s$2W = {
    radio: radio$1,
    root: root$1O,
    rootDisabled: rootDisabled$1,
    labelText: labelText$1,
    labelTextDisabled: labelTextDisabled
};
const RadioButton = (props)=>{
    const { classNames = {}, id, isChecked, isDefaultChecked, isDisabled: isDisabled2, label: label2, name: name2, value: value2, mode: mode2 = ERadioButtonMode.LIGHT, onRadioButtonClick = dist$4.noop } = props;
    const onChange = (event2)=>{
        if (event2.currentTarget.checked) onRadioButtonClick(event2.currentTarget.value);
    };
    return /* @__PURE__ */ $acw62.createElement("label", {
        htmlFor: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2W.root, {
            [s$2W.rootDisabled]: isDisabled2
        }, classNames.root)
    }, /* @__PURE__ */ $acw62.createElement("input", {
        type: "radio",
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2W.radio, classNames.radio, {
            [s$2W.radioLight]: mode2 === ERadioButtonMode.LIGHT,
            [s$2W.radioDark]: mode2 === ERadioButtonMode.DARK
        }),
        value: value2,
        name: name2,
        disabled: isDisabled2,
        onChange: onChange,
        defaultChecked: isDefaultChecked,
        checked: isChecked
    }), Boolean(label2) && /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2W.labelText, classNames.label, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2W.labelTextDisabled, classNames.labelDisabled)]: isDisabled2
        })
    }, label2));
};
const small$1 = "Role-scss--module__small___bHYey";
const medium$1 = "Role-scss--module__medium___FUabW";
const large$1 = "Role-scss--module__large___WrrFC";
const s$2V = {
    small: small$1,
    medium: medium$1,
    large: large$1
};
const Role = (props)=>{
    const { classNames = {}, size: size2, role: { smallUrl, mediumUrl, largeUrl, name: name2 } } = props;
    const [pixelSize, rootClassName, src2, srcSet] = {
        [EResizableImageSize.SMALL]: [
            "18",
            s$2V.small,
            smallUrl,
            mediumUrl
        ],
        [EResizableImageSize.MEDIUM]: [
            "36",
            s$2V.medium,
            mediumUrl,
            largeUrl
        ],
        [EResizableImageSize.LARGE]: [
            "72",
            s$2V.large,
            largeUrl,
            null
        ],
        [EResizableImageSize.ORIGINAL]: [
            "72",
            s$2V.large,
            largeUrl,
            null
        ]
    }[size2] || [
        "36",
        s$2V.medium,
        mediumUrl,
        largeUrl
    ];
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, classNames.root)
    }, /* @__PURE__ */ $acw62.createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2V.image, classNames.img),
        src: src2,
        srcSet: srcSet ? `${srcSet} 2x` : null,
        width: pixelSize,
        height: pixelSize,
        alt: name2
    }));
};
const small = "Smile-scss--module__small___XTV-d";
const medium = "Smile-scss--module__medium___8QVJy";
const large = "Smile-scss--module__large___fCFi9";
const s$2U = {
    small: small,
    medium: medium,
    large: large
};
const Smile = (props)=>{
    const { classNames = {}, size: size2, smile: { smallUrl, mediumUrl, largeUrl, name: name2 }, onClick = dist$4.noop } = props;
    const [pixelSize, rootClassName, src2, srcSet] = {
        [EResizableImageSize.SMALL]: [
            "28",
            s$2U.small,
            smallUrl,
            mediumUrl
        ],
        [EResizableImageSize.MEDIUM]: [
            "56",
            s$2U.medium,
            mediumUrl,
            largeUrl
        ],
        [EResizableImageSize.LARGE]: [
            "112",
            s$2U.large,
            largeUrl,
            null
        ],
        [EResizableImageSize.ORIGINAL]: [
            "112",
            s$2U.large,
            largeUrl,
            null
        ]
    }[size2] || [
        "56",
        s$2U.medium,
        mediumUrl,
        largeUrl
    ];
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, classNames.root),
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2U.image, classNames.img),
        src: src2,
        srcSet: srcSet ? `${srcSet} 2x` : null,
        width: pixelSize,
        height: pixelSize,
        alt: name2
    }));
};
const root$1N = "StreamPreview-scss--module__root___3QTO6";
const defaultPreview = "StreamPreview-scss--module__defaultPreview___eZklb";
const s$2T = {
    root: root$1N,
    defaultPreview: defaultPreview
};
const StreamPreviewWithoutRef = (props)=>{
    const { className, url, previewUrl, offsetX, offsetY, countPerRow, spriteWidth, spriteHeight, children: children2, innerRef, withPreview = true } = props;
    if (!withPreview && previewUrl) return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2T.root, className),
        style: {
            backgroundImage: `url(${previewUrl})`
        }
    }, children2);
    if (!url) return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2T.defaultPreview, s$2T.root, className)
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2T.root, className),
        ref: innerRef,
        style: {
            backgroundImage: `url(${url})`,
            ...!isNil(offsetX) ? {
                backgroundPositionX: `-${offsetX}px`
            } : {},
            ...!isNil(offsetY) ? {
                backgroundPositionY: `-${offsetY}px`
            } : {},
            ...spriteWidth && spriteHeight ? {
                backgroundSize: `${spriteWidth * countPerRow}px ${spriteHeight * countPerRow}px`
            } : {}
        }
    }, children2);
};
$acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(StreamPreviewWithoutRef, {
        innerRef: ref2,
        ...props
    }, props.children));
const container$a = "TabItem-scss--module__container___KRi91";
const tab = "TabItem-scss--module__tab___-Eubz";
const active$5 = "TabItem-scss--module__active___w2Xh9";
const s$2S = {
    container: container$a,
    tab: tab,
    active: active$5
};
const TabItemCommon = ({ className, title: title2, onClick, active: active2 })=>/* @__PURE__ */ $acw62.createElement("span", {
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2S.container, {
            [s$2S.active]: active2
        }, className)
    }, title2);
const TabItemLink = ({ className, title: title2, onClick, url, active: active2 })=>/* @__PURE__ */ $acw62.createElement(NavLink, {
        onClick: onClick,
        to: url,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2S.container, s$2S.tab, className, {
            [s$2S.active]: active2
        })
    }, title2);
const TabItem = (props)=>{
    if (!!props.url) return /* @__PURE__ */ $acw62.createElement(TabItemLink, {
        ...props
    });
    return /* @__PURE__ */ $acw62.createElement(TabItemCommon, {
        ...props
    });
};
const nav = "Tabs-scss--module__nav___NO8v1";
const s$2R = {
    nav: nav
};
const _Tabs = class _Tabs extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            activeIndex: this.props.activeTab || 0
        };
        this.navRef = $acw62.createRef();
        this.isActive = (index2)=>this.state.activeIndex === index2;
        this.centerActiveTab = (activeTab)=>{
            if (!this.props.shouldCenterActiveTab) return;
            const nav2 = this.navRef.current;
            nav2.scrollLeft = activeTab.offsetLeft - nav2.offsetLeft + activeTab.offsetWidth / 2 - nav2.offsetWidth / 2;
        };
        this.afterOrientationChange = ()=>{
            this.onActiveTabChange();
            window.removeEventListener("resize", this.afterOrientationChange);
        };
        this.onOrientationChange = ()=>{
            window.addEventListener("resize", this.afterOrientationChange);
        };
        this.onActiveTabChange = ()=>{
            const { activeIndex } = this.state;
            const { onChange } = this.props;
            const tab2 = this.navRef.current.childNodes[activeIndex];
            onChange(activeIndex);
            if (tab2) this.centerActiveTab(tab2);
        };
        this.onClick = (index2, event2)=>{
            const { onChange } = this.props;
            this.centerActiveTab(event2.target);
            this.setState({
                activeIndex: index2
            }, ()=>onChange(index2));
        };
    }
    componentDidMount() {
        const { activeTab } = this.props;
        if (activeTab) this.setState({
            activeIndex: activeTab
        }, this.onActiveTabChange);
        window.addEventListener("orientationchange", this.onOrientationChange);
    }
    componentWillUnmount() {
        window.removeEventListener("orientationchange", this.onOrientationChange);
    }
    componentDidUpdate(prevProps) {
        const { activeTab } = this.props;
        if (prevProps.activeTab !== activeTab) this.setState({
            activeIndex: activeTab
        }, this.onActiveTabChange);
    }
    render() {
        const { className, classNameHead, classNameActive, classNameContent, children: children2, withContent } = this.props;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2R.root, className)
        }, /* @__PURE__ */ $acw62.createElement("nav", {
            ref: this.navRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2R.nav, classNameHead)
        }, $acw62.Children.map(children2, (child, index2)=>{
            return child ? $acw62.cloneElement(child, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(child.props.className, {
                    [classNameActive]: this.isActive(index2)
                }),
                active: this.isActive(index2),
                onClick: (event2)=>{
                    this.onClick(index2, event2);
                }
            }, child.props.title) : null;
        })), withContent && $acw62.Children.map(children2, (child, index2)=>{
            return child && this.isActive(index2) ? /* @__PURE__ */ $acw62.createElement("section", {
                className: classNameContent
            }, child.props.children) : null;
        }));
    }
};
_Tabs.Tab = TabItem;
_Tabs.defaultProps = {
    withContent: true,
    shouldCenterActiveTab: false,
    onChange: noop$2
};
let Tabs = _Tabs;
var EToggleSwitchSize = /* @__PURE__ */ ((EToggleSwitchSize2)=>{
    EToggleSwitchSize2["NORMAL"] = "normal";
    EToggleSwitchSize2["SMALL"] = "small";
    EToggleSwitchSize2["MIDDLE"] = "middle";
    return EToggleSwitchSize2;
})(EToggleSwitchSize || {});
const checkbox$1 = "ToggleSwitch-scss--module__checkbox___M-LCi";
const checkboxDisabled = "ToggleSwitch-scss--module__checkboxDisabled___loTzc";
const track = "ToggleSwitch-scss--module__track___LBIV7";
const checkboxChecked = "ToggleSwitch-scss--module__checkboxChecked___JSbYf";
const circle$1 = "ToggleSwitch-scss--module__circle___E8Nba";
const label$5 = "ToggleSwitch-scss--module__label___3FyLR";
const labelText = "ToggleSwitch-scss--module__labelText___Q7LFo";
const left$2 = "ToggleSwitch-scss--module__left___0c9IO";
const disabled$4 = "ToggleSwitch-scss--module__disabled___Lr8rb";
const fadeIn$4 = "ToggleSwitch-scss--module__fadeIn___C0-Tn";
const s$2Q = {
    checkbox: checkbox$1,
    checkboxDisabled: checkboxDisabled,
    track: track,
    checkboxChecked: checkboxChecked,
    circle: circle$1,
    label: label$5,
    labelText: labelText,
    left: left$2,
    disabled: disabled$4,
    fadeIn: fadeIn$4
};
const ToggleSwitchContent = ({ isChecked, size: size2, isDisabled: isDisabled2, classNames })=>/* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.checkbox, s$2Q[`checkbox${dist$4.strCapitalize(size2)}`], {
            [s$2Q.checkboxChecked]: isChecked
        }, {
            [s$2Q.checkboxDisabled]: isDisabled2
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.track, classNames == null ? void 0 : classNames.track)
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.circle, classNames == null ? void 0 : classNames.circle)
    }));
const ToggleSwitch = (props)=>{
    const { label: label2, classNames, size: size2 = EToggleSwitchSize.NORMAL, togglePosition = "right", isDisabled: isDisabled2 } = props;
    return /* @__PURE__ */ $acw62.createElement(CheckBoxContainer, {
        className: props.classNames.wrapper,
        ...props,
        render: (checkboxProps)=>{
            return label2 ? /* @__PURE__ */ $acw62.createElement(Label, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.label, classNames.label, {
                    [s$2Q.left]: togglePosition === "left"
                }, {
                    [s$2Q.disabled]: isDisabled2
                }, {
                    [classNames.labelDisabled]: isDisabled2
                })
            }, togglePosition === "right" ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.labelText, classNames.labelText)
            }, label2), /* @__PURE__ */ $acw62.createElement(ToggleSwitchContent, {
                isDisabled: props.isDisabled,
                classNames: classNames,
                ...checkboxProps,
                size: size2
            })) : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(ToggleSwitchContent, {
                isDisabled: props.isDisabled,
                classNames: classNames,
                ...checkboxProps,
                size: size2
            }), /* @__PURE__ */ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2Q.labelText, classNames.labelText)
            }, label2))) : /* @__PURE__ */ $acw62.createElement(ToggleSwitchContent, {
                ...checkboxProps,
                isDisabled: props.isDisabled,
                size: size2
            });
        }
    });
};
ToggleSwitch.defaultProps = {
    classNames: {}
};
const root$1M = "CountdownCircle-scss--module__root___XyIVN";
const svg = "CountdownCircle-scss--module__svg___kO8n-";
const circle = "CountdownCircle-scss--module__circle___Cyi5N";
const circleBackground = "CountdownCircle-scss--module__circleBackground___-4mZZ";
const s$2P = {
    root: root$1M,
    svg: svg,
    circle: circle,
    circleBackground: circleBackground
};
const FULL_CIRCLE_LENGTH = 56.55;
const CountdownCircle = (props)=>{
    const { className, duration: duration2, timeLeft, onEnd = dist$4.noop, onClick = dist$4.noop } = props;
    const timeRate = (duration2 - timeLeft) / duration2;
    const remainLength = timeRate * FULL_CIRCLE_LENGTH;
    const transitionDuration = timeLeft / 1e3;
    const [style, setStyle] = (0, $acw62.useState)({
        strokeDashoffset: `-${remainLength}px`,
        transitionProperty: "",
        transitionDuration: "",
        transitionTimingFunction: ""
    });
    const timeoutRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!timeLeft) {
            setStyle({
                strokeDashoffset: `0`,
                transitionProperty: "",
                transitionDuration: "",
                transitionTimingFunction: ""
            });
            return void 0;
        }
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setStyle({
            strokeDashoffset: `-${remainLength}px`,
            transitionProperty: "",
            transitionDuration: "",
            transitionTimingFunction: ""
        });
        setTimeout(()=>{
            setStyle({
                strokeDashoffset: `-${FULL_CIRCLE_LENGTH}px`,
                transitionProperty: "stroke-dashoffset",
                transitionDuration: `${transitionDuration}s`,
                transitionTimingFunction: "linear"
            });
        });
        timeoutRef.current = setTimeout(()=>{
            onEnd();
        }, timeLeft);
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        timeLeft
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, s$2P.root),
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: s$2P.svg
    }, /* @__PURE__ */ $acw62.createElement("circle", {
        className: s$2P.circleBackground,
        r: "9",
        cx: "10",
        cy: "10"
    }), /* @__PURE__ */ $acw62.createElement("circle", {
        className: s$2P.circle,
        style: {
            ...style
        },
        r: "9",
        cx: "10",
        cy: "10"
    })));
};
var Action;
(function(Action2) {
    Action2["DragStart"] = "dragStart";
    Action2["DragMove"] = "dragMove";
    Action2["DragEnd"] = "dragEnd";
    Action2["DragCancel"] = "dragCancel";
    Action2["DragOver"] = "dragOver";
    Action2["RegisterDroppable"] = "registerDroppable";
    Action2["SetDroppableDisabled"] = "setDroppableDisabled";
    Action2["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
    x: 0,
    y: 0
});
var Direction;
(function(Direction2) {
    Direction2[Direction2["Forward"] = 1] = "Forward";
    Direction2[Direction2["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
var EventName;
(function(EventName2) {
    EventName2["Click"] = "click";
    EventName2["DragStart"] = "dragstart";
    EventName2["Keydown"] = "keydown";
    EventName2["ContextMenu"] = "contextmenu";
    EventName2["Resize"] = "resize";
    EventName2["SelectionChange"] = "selectionchange";
    EventName2["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
var KeyboardCode;
(function(KeyboardCode2) {
    KeyboardCode2["Space"] = "Space";
    KeyboardCode2["Down"] = "ArrowDown";
    KeyboardCode2["Right"] = "ArrowRight";
    KeyboardCode2["Left"] = "ArrowLeft";
    KeyboardCode2["Up"] = "ArrowUp";
    KeyboardCode2["Esc"] = "Escape";
    KeyboardCode2["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));
KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Esc, KeyboardCode.Space, KeyboardCode.Enter;
var MouseButton;
(function(MouseButton2) {
    MouseButton2[MouseButton2["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
var AutoScrollActivator;
(function(AutoScrollActivator2) {
    AutoScrollActivator2[AutoScrollActivator2["Pointer"] = 0] = "Pointer";
    AutoScrollActivator2[AutoScrollActivator2["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder2) {
    TraversalOrder2[TraversalOrder2["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder2[TraversalOrder2["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
Direction.Backward, Direction.Forward, Direction.Backward, Direction.Forward;
var MeasuringStrategy;
(function(MeasuringStrategy2) {
    MeasuringStrategy2[MeasuringStrategy2["Always"] = 0] = "Always";
    MeasuringStrategy2[MeasuringStrategy2["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy2[MeasuringStrategy2["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency2) {
    MeasuringFrequency2["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
MeasuringStrategy.WhileDragging, MeasuringFrequency.Optimized;
/* @__PURE__ */ (0, $acw62.createContext)({
    ...defaultCoordinates,
    scaleX: 1,
    scaleY: 1
});
var Status;
(function(Status2) {
    Status2[Status2["Uninitialized"] = 0] = "Uninitialized";
    Status2[Status2["Initializing"] = 1] = "Initializing";
    Status2[Status2["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left;
var ETimeMetric = /* @__PURE__ */ ((ETimeMetric2)=>{
    ETimeMetric2[ETimeMetric2["SECONDS"] = 0] = "SECONDS";
    ETimeMetric2[ETimeMetric2["MINUTES"] = 1] = "MINUTES";
    ETimeMetric2[ETimeMetric2["HOURS"] = 2] = "HOURS";
    ETimeMetric2[ETimeMetric2["DAYS"] = 3] = "DAYS";
    return ETimeMetric2;
})(ETimeMetric || {});
ETimeMetric.SECONDS, ETimeMetric.MINUTES, ETimeMetric.HOURS, ETimeMetric.DAYS;
const root$1L = "ButtonCell-scss--module__root___QV807";
const icon$A = "ButtonCell-scss--module__icon___fxi1W";
const s$2O = {
    root: root$1L,
    icon: icon$A
};
const ButtonCell = (props)=>{
    const { left: left2, children: children2, ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(Button$1, {
        className: s$2O.root,
        ...restProps
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: left2,
        className: s$2O.icon
    }), children2);
};
const root$1K = "TimelineCountDown-scss--module__root___aoRPo";
const s$2N = {
    root: root$1K
};
const TimelineCountDown = (props)=>{
    const { className, startTime, duration: duration2, onEnd = dist$4.noop } = props;
    const [timeRatio, setTimeRatio] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            const currentTime = Math.floor(Date.now() / 1e3);
            let ratio2 = (currentTime - startTime) / duration2 * 100;
            if (ratio2 > 100) {
                ratio2 = 100;
                clearInterval(intervalId);
                onEnd();
            }
            setTimeRatio(100 - ratio2);
        }, 1e3);
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        startTime,
        duration2
    ]);
    return /* @__PURE__ */ $acw62.createElement(ProgressBar$1, {
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2N.root, className)
        },
        percent: timeRatio
    });
};
const useBrowserNotifications = (props)=>{
    const { blogUrl, onFinishCheckPermissions } = props;
    const [isGranted, setIsGranted] = (0, $acw62.useState)(false);
    const [isShowedPopup, setIsShowedPopup] = (0, $acw62.useState)(false);
    const appRef = (0, $acw62.useRef)(null);
    const { notifications: { firebase }, pushNotification } = getConfig();
    const dispatch = (0, $2OPjR.useDispatch)();
    const notificationSettings2 = (0, $iD0SF.useSelector)(notificationSettingsSelector);
    const notificationChannelSettings = (0, $iD0SF.useSelector)(notificationChannelSettingsSelector);
    let auth = null;
    try {
        auth = tryGetAuthCookie();
    } catch (ignore) {}
    const updateSettings = (value2, fill)=>{
        if (blogUrl) {
            dispatch((0, $7Uc0p.thunkToAction)(notificationChannelSettingsUpdate.action)({
                blogUrl: blogUrl,
                mail: fill || (notificationChannelSettings == null ? void 0 : notificationChannelSettings.mail) || false,
                mobilePush: fill || (notificationChannelSettings == null ? void 0 : notificationChannelSettings.mobilePush) || false,
                webPush: value2
            }));
            return;
        }
        dispatch((0, $7Uc0p.thunkToAction)(notificationSettingsUpdate.action)({
            ...pushNotification.web.settings,
            value: value2
        }));
    };
    const subscribe = async (fill)=>{
        if (!appRef.current) appRef.current = initializeApp(firebase.config);
        const messaging = getMessagingInWindow(appRef.current);
        const deviceToken = await getToken(messaging, {
            vapidKey: firebase.vapidKey
        });
        if (deviceToken && (auth == null ? void 0 : auth.accessToken)) {
            updateSettings(true, fill);
            dispatch((0, $7Uc0p.thunkToAction)(postDeviceTokenNotifications.action)({
                accessToken: auth.accessToken,
                deviceToken: deviceToken
            }));
        }
    };
    const refreshToken = (0, $acw62.useCallback)(async ()=>{
        var _a3, _b2, _c2;
        if (((_a3 = window.Notification) == null ? void 0 : _a3.permission) !== "granted") return;
        const settings2 = !notificationSettings2 && await dispatch((0, $7Uc0p.thunkToAction)(getNotificationSettings.action)({
            transports: [
                "mail",
                "web_push",
                "mobile_push"
            ]
        }));
        if (!((_c2 = (_b2 = notificationSettings2 || settings2.data.settings) == null ? void 0 : _b2.web_push) == null ? void 0 : _c2.newStream)) return;
        if (!appRef.current) appRef.current = initializeApp(firebase.config);
        const messaging = getMessagingInWindow(appRef.current);
        const deviceToken = await getToken(messaging, {
            vapidKey: firebase.vapidKey
        });
        if (deviceToken && (auth == null ? void 0 : auth.accessToken)) dispatch((0, $7Uc0p.thunkToAction)(postDeviceTokenNotifications.action)({
            accessToken: auth.accessToken,
            deviceToken: deviceToken
        }));
    }, [
        notificationSettings2,
        auth
    ]);
    const refreshTokenInterval = (0, $acw62.useCallback)(()=>{
        if (!firebase.timeToLive) return;
        const expired = getCookie(ECookieKey.BROWSER_NOTIFICATION_REFRESH_EXPIRED);
        if (!expired) {
            setCookie(ECookieKey.BROWSER_NOTIFICATION_REFRESH_EXPIRED, String(Date.now() + Number(firebase.timeToLive)));
            return;
        }
        if (Date.now() >= Number(expired)) {
            setCookie(ECookieKey.BROWSER_NOTIFICATION_REFRESH_EXPIRED, String(Date.now() + Number(firebase.timeToLive)));
            refreshToken();
        }
    }, [
        refreshToken
    ]);
    const unsubscribe = ()=>{
        const messaging = getMessagingInWindow(appRef.current);
        deleteToken(messaging).then(()=>{
            setIsGranted(false);
        });
        updateSettings(false);
    };
    const checkPermission = (fill)=>{
        AppStat.log.notificationSettings.webPushOk();
        Notification.requestPermission().then((permission)=>{
            if (permission === "granted") {
                setIsGranted(true);
                subscribe(fill);
            }
        }).catch(noop$2).finally(()=>{
            setIsShowedPopup(false);
            onFinishCheckPermissions == null || onFinishCheckPermissions();
        });
    };
    return {
        appRef: appRef,
        isGranted: isGranted,
        isShowedPopup: isShowedPopup,
        updateSettings: updateSettings,
        checkPermission: checkPermission,
        setIsShowedPopup: setIsShowedPopup,
        setIsGranted: setIsGranted,
        unsubscribe: unsubscribe,
        refreshToken: refreshToken,
        refreshTokenInterval: refreshTokenInterval
    };
};
const defaultStrategy = [
    EBlogUrlStrategyPart.GLOBAL_STORAGE,
    EBlogUrlStrategyPart.URL,
    EBlogUrlStrategyPart.BLOG
];
const STATIC_OBJECT = {
    blogUrl: null,
    slotUrl: null
};
EBlogUrlStrategyPart.EXTERNAL_BLOG;
const useStreamIdentity = (strategy = defaultStrategy)=>{
    const { blogUrl: blogUrlFromRoute, slotUrl: slotUrlFromRoute } = useParams();
    const blogUrlFromBlog = (0, $iD0SF.useSelector)(blogUrlSelector);
    const blogExternal = (0, $iD0SF.useSelector)(blogExternalSelector);
    const blogUrlFromGlobalStorage = (0, $iD0SF.useSelector)(globalBlogUrlSelector);
    const slotUrlFromGlobalStorage = (0, $iD0SF.useSelector)(globalslotUrlSelector);
    const { blogUrl: blogUrlFromExternalBlog } = blogExternal || {};
    const mappedSources = strategy.map((part)=>{
        switch(part){
            case EBlogUrlStrategyPart.BLOG:
                return {
                    blogUrl: blogUrlFromBlog,
                    slotUrl: null
                };
            case EBlogUrlStrategyPart.EXTERNAL_BLOG:
                return {
                    blogUrl: blogUrlFromExternalBlog,
                    slotUrl: null
                };
            case EBlogUrlStrategyPart.GLOBAL_STORAGE:
                return {
                    blogUrl: blogUrlFromGlobalStorage,
                    slotUrl: slotUrlFromGlobalStorage
                };
            case EBlogUrlStrategyPart.URL:
                return {
                    blogUrl: blogUrlFromRoute,
                    slotUrl: slotUrlFromRoute
                };
            default:
                return null;
        }
    });
    return mappedSources.find((data)=>data.blogUrl) ?? STATIC_OBJECT;
};
const useVKIDWindow = (params)=>{
    const { url, width, height, errorText: errorText2, successText, windowName, allowedActorStatus = EAllowedActorStatus.LINKING, successCallback, errorCallback, showAlert } = params;
    const refWindow = (0, $acw62.useRef)(null);
    const onLoginRef = (0, $acw62.useRef)(noop$2);
    const [isOnMessageHandlerActive, setIsOnMessageHandlerActive] = (0, $acw62.useState)(false);
    const onLogin = (fn2)=>{
        onLoginRef.current = fn2;
    };
    const { clientId } = getConfig();
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        const handleError = ()=>{
            refWindow.current.close();
            setIsOnMessageHandlerActive(false);
            showAlert({
                type: EAlertType.ERROR,
                text: errorText2
            });
            errorCallback == null || errorCallback();
        };
        const handleSuccess = async (payload)=>{
            const resp = await Api$1.user.fetchVKIDToken({
                deviceId: clientId,
                deviceOS: getAppId(),
                silentToken: payload.token,
                uuid: payload.uuid,
                allowedActorStatus: [
                    ...Array.isArray(allowedActorStatus) ? allowedActorStatus : [
                        allowedActorStatus
                    ]
                ]
            });
            if (allowedActorStatus === EAllowedActorStatus.LINKING) await dispatch((0, $7Uc0p.thunkToAction)(fetchUserCurrentLink.action)());
            else onLoginRef.current(resp);
            setIsOnMessageHandlerActive(false);
            showAlert({
                type: EAlertType.SUCCESS,
                text: successText
            });
            refWindow.current.close();
            successCallback == null || successCallback();
        };
        const handleMessage = async (event2)=>{
            try {
                if (Boolean(event2.data.search) && event2.data.name === "AuthRedirectWindowOpened") {
                    window.removeEventListener("message", handleMessage);
                    const searchParams = new URLSearchParams(event2.data.search);
                    const payload = searchParams.get("payload");
                    if (Boolean(payload)) {
                        const data = JSON.parse(payload);
                        await handleSuccess(data);
                    }
                }
            } catch (ignore) {
                handleError();
            }
        };
        if (isOnMessageHandlerActive) window.addEventListener("message", handleMessage);
        return ()=>{
            if (isOnMessageHandlerActive) window.removeEventListener("message", handleMessage);
        };
    }, [
        isOnMessageHandlerActive,
        successCallback,
        errorCallback,
        errorText2,
        successText
    ]);
    const openVKIDWindow = ()=>{
        const options = {
            width: width,
            height: height,
            left: Math.floor(screen.width / 2 - width / 2),
            top: Math.floor(screen.height / 2 - height / 2)
        };
        const optionsString = Object.keys(options).map((key)=>`${key}=${options[key]}`).join(",");
        refWindow.current = window.open(url, windowName, optionsString);
        setIsOnMessageHandlerActive(true);
    };
    return {
        openVKIDWindow: openVKIDWindow,
        onLogin: onLogin
    };
};
const locales$1H = {
    windowName: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F VK ID"
};
const t$1I = distExports$1.getTranslation && locales$1H;
const WINDOW_WIDTH = 700;
const WINDOW_HEIGHT = 616;
const useVKIDAuth = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const isVKIDAuthEnabled = isConditionalFeatureEnable(EConditionalFeature.VK_ID_AUTH);
    const { oauth: { vkId: { oauthUri } } } = getConfig();
    const handleLogin = (data)=>{
        var _a3, _b2, _c2, _d, _e;
        if (!((_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.access_token) || !((_b2 = data == null ? void 0 : data.data) == null ? void 0 : _b2.refresh_token) || !((_c2 = data == null ? void 0 : data.data) == null ? void 0 : _c2.expires_in)) return;
        setAuthCookie({
            accessToken: (_d = data == null ? void 0 : data.data) == null ? void 0 : _d.access_token,
            refreshToken: (_e = data == null ? void 0 : data.data) == null ? void 0 : _e.refresh_token,
            expiresAt: Date.now() + 31536000000
        });
        dispatch((0, $7Uc0p.thunkToAction)(fetchCurrentUser.action)());
    };
    const { openVKIDWindow, onLogin } = useVKIDWindow({
        url: oauthUri,
        width: WINDOW_WIDTH,
        height: WINDOW_HEIGHT,
        windowName: t$1I.windowName,
        allowedActorStatus: [
            EAllowedActorStatus.EXISTING_ACCOUNT,
            EAllowedActorStatus.NEW_ACCOUNT
        ],
        showAlert: noop$2
    });
    const openWindow = (event2)=>{
        if (isVKIDAuthEnabled && window.location.hash !== "#debug_vkplay_login") openVKIDWindow();
        else {
            dispatch(authActions.requestAuth(getOAuthProviderByCode(dist$3.ProviderCodes.VKPlay)));
            AppStat.log.auth.openPopup({
                source: EStatAuthStartSource.HEADER_LOGIN
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        onLogin(handleLogin);
    }, []);
    return {
        openWindow: openWindow
    };
};
const getRights = (currentUser2, blog2, externalBlog, smileData, post, comment, blogUrl)=>{
    const isAuthorized = currentUserIsAuthorized(currentUser2);
    const isAdmin = currentUserIsAdmin(currentUser2, isAuthorized);
    const isBanned = currentUserIsBanned(currentUser2, isAuthorized);
    const isBannedCompletely = currentUserIsBannedCompletely(currentUser2, isAuthorized);
    const canCreateBlog = currentUserCanCreateBlog(blog2, isAuthorized);
    const canCreateBlogComments = currentUserCanCreateBlogComments(blog2, isAuthorized);
    const canDeleteBlogComments = currentUserCanDeleteBlogComments(blog2, isAuthorized);
    const canEditBlog = currentUserCanEditBlog(blog2, isAuthorized);
    const canSetBlogPayout = currentUserCanSetBlogPayout(blog2, isAuthorized);
    const canViewBlog = currentUserCanViewBlog(blog2, isAuthorized);
    const isBlackListed = currentUserIsBlackListed(blog2);
    const isBlogBanned = blogIsBanned(blog2);
    const isPostCommentsEnabled = currentUserIsPostCommentsEnabled(post, isAuthorized);
    const isOwner = currentUserIsBlogOwner(blog2, currentUser2, isAuthorized);
    const isOwnerAgent = currentUserIsBlogOwnerAgent(canEditBlog, canSetBlogPayout, isAdmin, isBannedCompletely);
    const isPostConsumer = currentUserIsPostConsumer(post, isAuthorized);
    const isCommentAuthor = currentUserIsCommentAuthor(comment, blog2, currentUser2, isAuthorized, isOwnerAgent);
    const canReportBlog = currentUserCanReportBlog(isAuthorized, isOwner, isOwnerAgent);
    const canFollowBlog = currentUserCanFollowBlog(isOwner, isOwnerAgent);
    const canViewPost = currentUserCanViewPost(isPostConsumer, canViewBlog);
    const canLikePost = currentUserCanLikePost(isPostConsumer, isBanned);
    const canReactionPost = currentUserCanReactionPost(isPostConsumer, isBanned);
    const canReportPost = currentUserCanReportPost(isPostConsumer, isOwner, isOwnerAgent);
    const canChangeChannel = currentUserCanChangeChannel(currentUser2, blogUrl);
    const canAdministrateChannel = currentUserCanAdministrateChannel(currentUser2, blogUrl);
    const canModerateChannel = currentUserCanModerateChannel(currentUser2, blogUrl);
    const canModerateSomeChannel = currentUserCanModerateSomeChannels(currentUser2);
    const canModerateChatChannel = currentUserCanModerateChatChannel(currentUser2, blogUrl);
    const canPublishComment = currentUserCanPublishComment(isBlogBanned, isPostConsumer, isPostCommentsEnabled, isOwner, isOwnerAgent, isBanned, isBannedCompletely, canCreateBlogComments, isBlackListed);
    const canReactionComment = currentUserCanReactionComment(canViewPost, isBanned);
    const canReplyComment = currentUserCanReplyComment(canViewPost, canPublishComment);
    const canEditComment = currentUserCanEditComment(isCommentAuthor, canPublishComment);
    const canReportComment = currentUserCanReportComment(canViewPost, isCommentAuthor);
    const canRemoveComment = currentUserCanRemoveComment(isCommentAuthor, canDeleteBlogComments);
    const canBlockCommentAuthor = currentUserCanBlockCommentAuthor(isOwner, isOwnerAgent, isCommentAuthor);
    return {
        [ECurrentUserAccessRight.EDIT_OWN_BLOG_SETTINGS]: canEditBlog,
        [ECurrentUserAccessRight.EDIT_OWN_BLOG_POSTS]: canEditBlog,
        [ECurrentUserAccessRight.EDIT_OWN_BLOG_ABOUT_AUTHOR]: canEditBlog,
        [ECurrentUserAccessRight.VIEW_BLOG]: canViewBlog,
        [ECurrentUserAccessRight.REPORT_BLOG]: canReportBlog,
        [ECurrentUserAccessRight.FOLLOW_BLOG]: canFollowBlog,
        [ECurrentUserAccessRight.PUBLISH_POST]: canCreateBlog,
        [ECurrentUserAccessRight.EDIT_POST_SETTINGS]: canEditBlog,
        [ECurrentUserAccessRight.VIEW_POST]: canViewPost,
        [ECurrentUserAccessRight.LIKE_POST]: canLikePost,
        [ECurrentUserAccessRight.REPORT_POST]: canReportPost,
        [ECurrentUserAccessRight.REACTION_POST]: canReactionPost,
        [ECurrentUserAccessRight.PUBLISH_COMMENT]: canPublishComment,
        [ECurrentUserAccessRight.REACTION_COMMENT]: canReactionComment,
        [ECurrentUserAccessRight.REPLY_COMMENT]: canReplyComment,
        [ECurrentUserAccessRight.REPORT_COMMENT]: canReportComment,
        [ECurrentUserAccessRight.REMOVE_COMMENT]: canRemoveComment,
        [ECurrentUserAccessRight.EDIT_COMMENT]: canEditComment,
        [ECurrentUserAccessRight.BLOCK_COMMENT_AUTHOR]: canBlockCommentAuthor,
        [ECurrentUserAccessRight.CHANGE_CHANNEL]: canChangeChannel,
        [ECurrentUserAccessRight.MODERATE_CHANNEL]: canModerateChannel,
        [ECurrentUserAccessRight.MODERATE_SOME_CHANNEL]: canModerateSomeChannel,
        [ECurrentUserAccessRight.ADMINISTRATE_CHANNEL]: canAdministrateChannel,
        [ECurrentUserAccessRight.MODERATE_CHAT_CHANNEL]: canModerateChatChannel
    };
};
const getRoles = (currentUser2, stream2, blog2, externalBlog, smileData, post, comment, blogUrl)=>{
    const isAuthorized = currentUserIsAuthorized(currentUser2);
    const isAdmin = currentUserIsAdmin(currentUser2, isAuthorized);
    const isModerator = currentUserIsModerator(currentUser2, isAuthorized);
    const isCrmManager = currentUserIsCrmManager(currentUser2, isAuthorized);
    const isBanned = currentUserIsBanned(currentUser2, isAuthorized);
    const isBannedCompletely = currentUserIsBannedCompletely(currentUser2, isAuthorized);
    const isStreamer = currentUserIsStreamer(currentUser2, isAuthorized);
    const canEditBlog = currentUserCanEditBlog(blog2, isAuthorized);
    const canSetBlogPayout = currentUserCanSetBlogPayout(blog2, isAuthorized);
    const isOwner = currentUserIsBlogOwner(blog2, currentUser2, isAuthorized);
    const isChannelOwner = currentUserIsChannelOwner(currentUser2, blogUrl);
    const isExternalOwner = currentUserIsExternalBlogOwner(externalBlog, currentUser2, isAuthorized);
    const isOwnerAgent = currentUserIsBlogOwnerAgent(canEditBlog, canSetBlogPayout, isAdmin, isBannedCompletely);
    const isStreamOwner = currentUserIsStreamOwner(stream2, currentUser2, isAuthorized);
    const isSmileOwner = currentUserIsSmileOwner(smileData, currentUser2, isAuthorized);
    const isCommentAuthor = currentUserIsCommentAuthor(comment, blog2, currentUser2, isAuthorized, isOwnerAgent);
    const isChatModerator = currentUserIsChatModerator(stream2, isAuthorized);
    const isChannelAdmin = currentUserHasChannelAdminRole(currentUser2, blog2 == null ? void 0 : blog2.blogUrl);
    const isChannelModerator = currentUserHasChannelModeratorRole(currentUser2, blog2 == null ? void 0 : blog2.blogUrl);
    const isChannelChatModerator = currentUserHasChannelChatModeratorRole(currentUser2, blog2 == null ? void 0 : blog2.blogUrl);
    return {
        [ECurrentUserAccessRole.STREAMER]: isStreamer,
        [ECurrentUserAccessRole.ADMIN]: isAdmin,
        [ECurrentUserAccessRole.MODERATOR]: isModerator,
        [ECurrentUserAccessRole.CRM_MANAGER]: isCrmManager,
        [ECurrentUserAccessRole.BLOG_OWNER]: isOwner,
        [ECurrentUserAccessRole.CHANNEL_OWNER]: isChannelOwner,
        [ECurrentUserAccessRole.BLOG_OWNER_AGENT]: isOwnerAgent,
        [ECurrentUserAccessRole.EXTERNAL_BLOG_OWNER]: isExternalOwner,
        [ECurrentUserAccessRole.STREAM_OWNER]: isStreamOwner,
        /**
    		* @deprecated use ECurrentUserAccessRole.CHANNEL_CHAT_MODERATOR
    	*/ [ECurrentUserAccessRole.CHAT_MODERATOR]: isChatModerator,
        [ECurrentUserAccessRole.CHANNEL_ADMIN]: isChannelAdmin,
        [ECurrentUserAccessRole.CHANNEL_MODERATOR]: isChannelModerator,
        [ECurrentUserAccessRole.CHANNEL_CHAT_MODERATOR]: isChannelChatModerator,
        [ECurrentUserAccessRole.SMILE_OWNER]: isSmileOwner,
        [ECurrentUserAccessRole.BANNED]: isBanned,
        [ECurrentUserAccessRole.BANNED_COMPLETELY]: isBannedCompletely,
        [ECurrentUserAccessRole.COMMENT_AUTHOR]: isCommentAuthor
    };
};
const useCurrentUserAccess = (params = {})=>{
    var _a3, _b2, _c2, _d, _e, _f, _g, _h;
    const { post, comment } = params;
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const externalBlog = (0, $iD0SF.useSelector)(blogExternalSelector);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const streamCurrentUserAccess = (0, $iD0SF.useSelector)(streamCurrentUserAccessSelector);
    const smileData = (0, $iD0SF.useSelector)(smileDataSelector);
    const { blogUrl } = useStreamIdentity();
    const isAuthorized = Boolean(currentUser2);
    const isLinkedToBoosty = isUserLinkedToBoosty(currentUser2);
    const isLinkedToVkPlay = isUserLinkedToVkPlay(currentUser2);
    const isAuthedWithVkId = (currentUser2 == null ? void 0 : currentUser2.authSource.type) === EAuthSource.VK_ID;
    const [rights2, setRights] = (0, $acw62.useState)(getRights(currentUser2, blog2, externalBlog, smileData, post, comment, blogUrl));
    const [roles2, setRoles] = (0, $acw62.useState)(getRoles(currentUser2, streamCurrentUserAccess, blog2, externalBlog, smileData, post, comment, blogUrl));
    const { openWindow: showAuth } = useVKIDAuth();
    const isAuthorizedRef = (0, $acw62.useRef)(isAuthorized);
    const getIsAuthorized = ()=>isAuthorizedRef.current;
    (0, $acw62.useEffect)(()=>{
        setRights(getRights(currentUser2, blog2, externalBlog, smileData, post, comment, blogUrl));
        setRoles(getRoles(currentUser2, streamCurrentUserAccess, blog2, externalBlog, smileData, post, comment, blogUrl));
    }, [
        currentUser2,
        streamCurrentUserAccess == null ? void 0 : streamCurrentUserAccess.isChatModerator,
        streamCurrentUserAccess == null ? void 0 : streamCurrentUserAccess.isChannelModerator,
        streamCurrentUserAccess == null ? void 0 : streamCurrentUserAccess.streamerId,
        (_a3 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _a3.canEdit,
        (_b2 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _b2.canCreate,
        (_c2 = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _c2.canCreateComments,
        (_d = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _d.canDeleteComments,
        (_e = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _e.canSetPayout,
        (_f = blog2 == null ? void 0 : blog2.accessRights) == null ? void 0 : _f.canView,
        blog2 == null ? void 0 : blog2.isBlackListed,
        blog2 == null ? void 0 : blog2.isOwner,
        (_g = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _g.id,
        externalBlog == null ? void 0 : externalBlog.isOwner,
        (_h = smileData == null ? void 0 : smileData.ownerInfo) == null ? void 0 : _h.blog.owner.id,
        post,
        comment,
        blogUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        isAuthorizedRef.current = isAuthorized;
    }, [
        isAuthorized
    ]);
    (0, $acw62.useEffect)(()=>{
        isAuthorizedRef.current = isAuthorized;
    }, [
        isAuthorized
    ]);
    return {
        currentUser: currentUser2,
        isAuthorized: isAuthorized,
        isLinkedToBoosty: isLinkedToBoosty,
        isLinkedToVkPlay: isLinkedToVkPlay,
        isAuthedWithVkId: isAuthedWithVkId,
        ...rights2,
        ...roles2,
        getIsAuthorized: // CALLBACKS
        getIsAuthorized,
        showAuth: showAuth
    };
};
const usePrevious = (value2)=>{
    const ref2 = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref2.current = value2;
    }, [
        value2
    ]);
    return ref2.current;
};
const useRefCapsule = (initialValue)=>{
    const ref2 = (0, $acw62.useRef)(initialValue);
    const get2 = ()=>{
        return ref2.current;
    };
    const save = (value2)=>{
        ref2.current = value2;
    };
    return {
        ref: ref2,
        get: get2,
        save: save
    };
};
EStreamCategoryType.GAME, EStreamCategoryType.IRL;
const getRewardShopFetchAction = (state, options)=>{
    const { blogUrl } = options.params;
    const isAuthorized = currentUserIsAuthorizedSelector(state);
    const pointNeworkStatus = pointNetworkStatusSelector(state);
    const pendingBonusNetworkStatus = pointPendingBonusNetworkStatusSelector(state);
    const bonusesNetworkStatus = pointBonusesNetworkStatusSelector(state);
    const actions2 = [];
    if (!isAuthorized) return actions2;
    if (!pointNeworkStatus.isFetched) actions2.push(()=>(0, $7Uc0p.thunkToAction)(getChannelPoint.action)({
            blogUrl: blogUrl
        }));
    if (!pendingBonusNetworkStatus.isFetched) actions2.push(()=>(0, $7Uc0p.thunkToAction)(getChannelPointPendingBonus.action)({
            blogUrl: blogUrl
        }));
    if (!bonusesNetworkStatus.isFetched) actions2.push(()=>(0, $7Uc0p.thunkToAction)(getChannelPointBonus.action)({
            blogUrl: blogUrl
        }));
    return actions2;
};
const useRewardShopOnPage = (blogUrl, isAuthorized)=>{
    const store2 = (0, $4TSkt.useStore)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const isOtherBlog = (blog2 == null ? void 0 : blog2.blogUrl) !== blogUrl;
    const prevIsAuthorized = usePrevious(isAuthorized);
    const clear = ()=>{
        dispatch(clearChannelPoint());
        dispatch(clearChannelPointPendingBonus());
        dispatch(clearChannelPointBonus());
    };
    const dispatchRewardShopFetchActions = async ()=>{
        const [channelPointAction, ...actions2] = getRewardShopFetchAction(store2.getState(), {
            params: {
                blogUrl: blogUrl
            }
        });
        try {
            await dispatch(channelPointAction());
        } catch (error2) {
            return;
        }
        actions2.forEach((action)=>dispatch(action()));
    };
    (0, $acw62.useEffect)(()=>{
        if (isOtherBlog) clear();
        if (isAuthorized) dispatchRewardShopFetchActions();
        return ()=>{
            clear();
        };
    }, [
        blogUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isAuthorized && prevIsAuthorized === false) dispatchRewardShopFetchActions();
        if (isAuthorized === false) clear();
    }, [
        isAuthorized
    ]);
};
var lib = {};
Object.defineProperty(lib, "__esModule", {
    value: true
});
var AdblockDetector_1 = lib.AdblockDetector = void 0;
class AdblockDetector {
    constructor(){
        this.bannerIds = [
            "AdHeader",
            "AdContainer",
            "AD_Top",
            "homead",
            "ad-lead"
        ];
        this.init();
    }
    /**
   * Init library - add some tags to page with ads ids
   *
   * @returns {void} create detector instance
   * @memberof AdblockDetector
   */ init() {
        if (!this.isBrowser()) {
            console.error("Detection on server side is not supported. Please use library only on client side.");
            return;
        }
        const dataContainer = document.createElement("div");
        dataContainer.innerHTML = this.generatesBannersString();
        document.body.append(dataContainer);
    }
    /**
   * Check enabling adblock
   *
   * @returns {Boolean} Status adblock enabling
   * @memberof AdblockDetector
   */ detect() {
        return !this.isBrowser() ? false : !this.bannerIds.every((bannerId)=>this.checkVisibility(bannerId));
    }
    /**
   * Generate all ads blocks from ids dictionary
   *
   * @returns {String} Ads blocks
   * @private
   * @memberof AdblockDetector
   */ generatesBannersString() {
        return this.bannerIds.map((bannerId)=>`<div id="${bannerId}"></div>`).join("");
    }
    /**
   * Check visibility by banner id
   *
   * @param {Number} bannerId
   * @returns {HTMLElement|null} Return banners if adblock is not enabled
   * @private
   * @memberof AdblockDetector
   */ checkVisibility(bannerId) {
        const element = document.querySelector(`#${bannerId}`);
        if (element) return element.offsetParent;
        return null;
    }
    isBrowser() {
        return typeof window !== "undefined";
    }
}
AdblockDetector_1 = lib.AdblockDetector = AdblockDetector;
new AdblockDetector_1();
const NotificationsContext = $acw62.createContext({});
const useNotificationsContext = ()=>$acw62.useContext(NotificationsContext);
const locales$1G = {
    report: " \u041F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    reportSent: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
    reportSentSuccessfully: "\u0416\u0430\u043B\u043E\u0431\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430"
};
const t$1H = distExports$1.getTranslation && locales$1G;
const useComplaint = (params)=>{
    const { itemType } = params;
    const { blogUrl } = useStreamIdentity();
    (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const { isAuthorized, [ECurrentUserAccessRight.REPORT_BLOG]: canReport, [ECurrentUserAccessRole.SMILE_OWNER]: isSmileOwner, [ECurrentUserAccessRole.STREAM_OWNER]: isStreamOwner } = useCurrentUserAccess();
    const [isComplaintSending, setIsComplaintSending] = (0, $acw62.useState)(false);
    const [isComplaintSent, setIsComplaintSent] = (0, $acw62.useState)(false);
    const [complaintText, setComplaintText] = (0, $acw62.useState)(t$1H.report);
    const [isComplaintAvailable, setIsComplaintAvailable] = (0, $acw62.useState)(false);
    const isItemTypeReportable = ()=>{
        return itemType === "stream";
    };
    const onReportClick = (event2)=>{
        event2.stopPropagation();
        event2.preventDefault();
        if (isComplaintSending || isComplaintSent) return;
        setIsComplaintSending(true);
    };
    (0, $acw62.useEffect)(()=>{
        if (!isComplaintSent) return;
        setComplaintText(t$1H.reportSent);
        showAlert({
            type: EAlertType.SUCCESS,
            text: t$1H.reportSentSuccessfully
        });
    }, [
        isComplaintSent
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsComplaintAvailable(isAuthorized && canReport && isItemTypeReportable());
    }, [
        isAuthorized,
        canReport
    ]);
    return {
        complaintText: // STORE
        // COMPUTED
        complaintText,
        isComplaintAvailable: isComplaintAvailable,
        isComplaintSent: isComplaintSent,
        onReportClick: // CALLBACKS
        onReportClick
    };
};
var EPinnedItem = /* @__PURE__ */ ((EPinnedItem2)=>{
    EPinnedItem2["RAID"] = "RAID";
    EPinnedItem2["MESSAGE"] = "MESSAGE";
    EPinnedItem2["PREDICTION"] = "PREDICTION";
    EPinnedItem2["CHANNEL_POLL"] = "CHANNEL_POLL";
    EPinnedItem2["DROP_BOX"] = "DROP_BOX";
    return EPinnedItem2;
})(EPinnedItem || {});
const useChatPinnedList = (props)=>{
    var _a3;
    const { streamUserId } = props;
    const pinnedMessageNetworkStatus = (0, $iD0SF.useSelector)(streamChatPinnedMessageNetworkStatus);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const streamRaid = (0, $iD0SF.useSelector)(streamRaidSelector);
    const streamRaidLoaded = (0, $iD0SF.useSelector)(streamRaidSelectorLoaded);
    const streamBlocksPinnedHiddenItems = (0, $iD0SF.useSelector)(streamBlocksPinnedHiddenItemsSelector);
    const pinnedMessage = (0, $iD0SF.useSelector)(streamChatPinnedMessage);
    const channelPollData = (0, $iD0SF.useSelector)(channelPollSelector);
    const predictionData = (0, $iD0SF.useSelector)(channelPredictionSelector);
    const isOpen = (0, $iD0SF.useSelector)(isVisiblePredictionSelector);
    const hasDropsProgress = (0, $iD0SF.useSelector)(hasDropsProgressSelector);
    const isStreamRaidEnabled = isConditionalFeatureEnable(EConditionalFeature.STREAM_RAID);
    const isPinnedMessagesEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_PINNED_MESSAGES);
    const { isMobile: isMobile2 } = getConfig();
    const isCurrentUserStream = (currentUser2 == null ? void 0 : currentUser2.id) === streamUserId;
    const isRaidOfOwner = ((_a3 = streamRaid == null ? void 0 : streamRaid.owner) == null ? void 0 : _a3.id) === streamUserId;
    const shouldShowRaidNotification = [
        ERaidStatus.CREATED,
        ERaidStatus.PREPARE,
        ERaidStatus.READY
    ].includes(streamRaid == null ? void 0 : streamRaid.status) && isStreamRaidEnabled && (isRaidOfOwner || isCurrentUserStream) && streamRaidLoaded;
    const shouldShowPrediction = predictionData && predictionData.state !== EPredictionStatus.CANCELED && isOpen;
    const shouldShowChannelPoll = channelPollData && channelPollData.state !== EChannelPollStatus.CANCELED;
    const [showDrops, setShowDrops] = (0, $acw62.useState)(true);
    const shouldShowDropsNotification = hasDropsProgress && showDrops;
    const closeDropNotification = ()=>setShowDrops(false);
    const isPinnedMessageNotEmpty = (0, $acw62.useMemo)(()=>{
        return Boolean(pinnedMessage && typeof pinnedMessage.author !== "undefined" && typeof pinnedMessage.pinner !== "undefined" && typeof pinnedMessage.writtenAt !== "undefined" && typeof pinnedMessage.id !== "undefined");
    }, [
        pinnedMessage
    ]);
    const pinnedMessageId = !isMobile2 && isPinnedMessagesEnabled && isPinnedMessageNotEmpty ? pinnedMessage == null ? void 0 : pinnedMessage.id : 0;
    const predictionId = predictionData == null ? void 0 : predictionData.id;
    const list2 = (0, $acw62.useMemo)(()=>{
        if (!(pinnedMessageNetworkStatus == null ? void 0 : pinnedMessageNetworkStatus.isFetched)) return [];
        return [
            shouldShowRaidNotification && EPinnedItem.RAID,
            shouldShowDropsNotification && EPinnedItem.DROP_BOX,
            shouldShowPrediction && EPinnedItem.PREDICTION,
            shouldShowChannelPoll && EPinnedItem.CHANNEL_POLL,
            pinnedMessageId && `${EPinnedItem.MESSAGE}:${pinnedMessageId}`
        ].filter(Boolean);
    }, [
        shouldShowPrediction,
        shouldShowChannelPoll,
        pinnedMessageId,
        shouldShowRaidNotification,
        pinnedMessageNetworkStatus,
        shouldShowDropsNotification
    ]);
    const pinnedHiddenItemsCount = streamBlocksPinnedHiddenItems.length;
    const totalCountBanners = list2.filter((i)=>i !== EPinnedItem.RAID && i !== EPinnedItem.DROP_BOX).length;
    const isAllBannersHidden = pinnedHiddenItemsCount === totalCountBanners;
    return {
        list: list2,
        pinnedMessage: pinnedMessage,
        pinnedMessageId: pinnedMessageId,
        predictionId: predictionId,
        streamRaid: streamRaid,
        streamRaidLoaded: streamRaidLoaded,
        streamBlocksPinnedHiddenItems: streamBlocksPinnedHiddenItems,
        pinnedHiddenItemsCount: pinnedHiddenItemsCount,
        channelPollData: channelPollData,
        totalCountBanners: totalCountBanners,
        isAllBannersHidden: isAllBannersHidden,
        shouldShowRaidNotification: shouldShowRaidNotification,
        closeDropNotification: closeDropNotification
    };
};
ESchemaType.MAIN;
const usePinnedMessage = (params)=>{
    const { blogUrl } = params;
    const dispatch = (0, $2OPjR.useDispatch)();
    const hasChatPinnedMessage$1 = (0, $iD0SF.useSelector)(hasChatPinnedMessage);
    const isPinnedMessagesEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_PINNED_MESSAGES);
    const fetchPinnedMessage$1 = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchPinnedMessage.action)({
            blogUrl: blogUrl
        }));
    };
    const unpinChatMessage2 = ()=>{
        dispatch(unpinChatMessageWS());
    };
    (0, $acw62.useEffect)(()=>{
        if (isPinnedMessagesEnabled && blogUrl) {
            if (hasChatPinnedMessage$1) fetchPinnedMessage$1();
            else unpinChatMessage2();
        }
    }, [
        isPinnedMessagesEnabled,
        hasChatPinnedMessage$1,
        blogUrl
    ]);
};
const LINE_BREAK_CHAR_REGEX = /\n/g;
const MULTI_LINE_BREAK_REG = /\n+/g;
const LINE_BREAK_HTML_TAG_REGEX = /(<br ?\/?>)/gi;
const MULTI_LINE_BREAK_HTML_TAG_REGEX = /(<br ?\/?>)+/gi;
const LINE_BREAK_HTML_TAG = "<br>";
const LINE_BREAK_HTML_ENTITY = "&#10;";
const NO_BREAK_SPACE$1 = "\xa0";
const MULTI_PARAGRAPH_REG = /(<p><br><\/p>)+/g;
const getBounds = (text2, ranges)=>{
    const flattened = ranges.map((elem)=>[
            elem[EConvertedStyleRange.START],
            elem[EConvertedStyleRange.END]
        ]).flat();
    flattened.push(0, text2.length);
    return Array.from(new Set(flattened)).sort((a2, b2)=>a2 - b2);
};
const getConvertedRanges = (ranges, offset2 = 0)=>{
    if (!Array.isArray(ranges)) return [];
    return ranges.map((elem)=>[
            elem[EPackedStyleRange.STYLE],
            elem[EPackedStyleRange.OFFSET] - offset2,
            elem[EPackedStyleRange.OFFSET] - offset2 + elem[EPackedStyleRange.LENGTH]
        ]);
};
const getStylesForRange = (ranges, start, end)=>{
    const styles = [];
    ranges.forEach((range2)=>{
        if (start >= range2[EConvertedStyleRange.START] && end <= range2[EConvertedStyleRange.END]) styles.push(range2[EConvertedStyleRange.STYLE]);
    });
    return Array.from(new Set(styles));
};
const wrapSliceWithHTML = (text2, style)=>{
    if (style === EStyleType.BOLD) return `<b>${text2}</b>`;
    else if (style === EStyleType.CODE) return `<code>${text2}</code>`;
    else if (style === EStyleType.ITALIC) return `<i>${text2}</i>`;
    else if (style === EStyleType.STRIKETHROUGH) return `<s>${text2}</s>`;
    else if (style === EStyleType.UNDERLINE) return `<u class="cdx-underline">${text2}</u>`;
    else return text2;
};
const wrapTextWithHTML = (text2, bounds, convertedRanges)=>{
    const result2 = [];
    for(let i = 1; i < bounds.length; i++){
        const styles = getStylesForRange(convertedRanges, bounds[i - 1], bounds[i]);
        const slice2 = styles.reduce((acc, style)=>{
            acc = wrapSliceWithHTML(acc, style);
            return acc;
        }, HtmlEntities.encode(text2.slice(bounds[i - 1], bounds[i]))).replace(LINE_BREAK_CHAR_REGEX, LINE_BREAK_HTML_TAG);
        result2.push(slice2);
    }
    return result2.join("");
};
const convertPackedTextToHTML = (content2, offset2)=>{
    const [text2, , styleRanges] = JSON.parse(content2);
    if (styleRanges.length === 0) return HtmlEntities.encode(text2).replace(MULTI_LINE_BREAK_REG, LINE_BREAK_HTML_TAG);
    const convertedRanges = getConvertedRanges(styleRanges, offset2);
    const bounds = getBounds(text2, convertedRanges);
    return wrapTextWithHTML(text2, bounds, convertedRanges);
};
const convertLinkToHTML = (packedLink, offset2)=>{
    const { url } = packedLink;
    const innerMarkup = convertPackedTextToHTML(packedLink.content, offset2);
    return `<a href="${HtmlEntities.escapeURL(url)}" target="_blank" rel="noopener noreferrer">${innerMarkup}</a>`;
};
const convertSmileToHTML = ({ smile: smile2, size: size2 = 28 })=>{
    const { smallUrl, mediumUrl, largeUrl, uniqueId: uniqueId2, id, name: name2 } = smile2;
    return `<img
		alt="${name2}"
		src="${HtmlEntities.escapeURL(smallUrl)}"
		srcset="${HtmlEntities.escapeURL(mediumUrl)} 2x, ${HtmlEntities.escapeURL(largeUrl)} 3x"
		style="vertical-align: middle; width: ${size2}px; height: ${size2}px; cursor: pointer;"
		data-role="${EHTMLDataRole.MESSAGE_SMILE_CONTENT}"
		data-id="${id}"
		data-unique-id="${uniqueId2 || id}"
		data-type="smile"
	/>`;
};
const convertMentionToHTML = (mention2)=>{
    const { id, blogUrl, displayName, className, uniqueId: uniqueId2, style } = mention2;
    const addClass2 = className ? className.toString() : "";
    return `<p
		class="mention ${addClass2}"
		style="${convertStyleToAttrString(style)}"
		data-mention-id="${id}"
		data-blog-url='${blogUrl}'
		data-unique-id="${uniqueId2}"
		data-role="${EHTMLDataRole.MESSAGE_MENTION_CONTENT}"
		data-id="${id}"
		data-type="mention"
		data-display-name="${displayName}"
		contenteditable="false"
		>${displayName}</p>`;
};
const convertSpaceToHtml = ()=>{
    return isFirefoxBrowser() ? `&nbsp;` : `<p class='space' contenteditable="false">${NO_BREAK_SPACE$1}</p>`;
};
const getTextBlock = (type, text2)=>{
    if ([
        EMediaDataType.TEXT,
        EMediaDataType.LINK,
        EMediaDataType.SMILE,
        EMediaDataType.MENTION,
        EMediaDataType.SPACE
    ].includes(type)) return {
        type: "paragraph",
        data: {
            text: text2
        }
    };
    throw new Error(`Invalid type ${type}`);
};
const getImageBlock = (mediaItem)=>{
    return {
        type: EMediaDataType.IMAGE,
        data: {
            id: mediaItem.id,
            url: mediaItem.url,
            complete: true
        }
    };
};
const getEmbedBlock = (mediaItem)=>{
    if (mediaItem.type === EMediaDataType.AUDIO) return {
        type: EMediaDataType.AUDIO,
        data: {
            type: mediaItem.type,
            url: mediaItem.url,
            title: mediaItem.title
        }
    };
    return {
        type: EMediaDataType.VIDEO,
        data: {
            type: mediaItem.type,
            url: mediaItem.url,
            playerUrls: mediaItem.playerUrls,
            defaultPreview: mediaItem.defaultPreview,
            preview: mediaItem.preview,
            previewId: mediaItem.previewId,
            title: mediaItem.title,
            duration: mediaItem.duration,
            vid: mediaItem.vid
        }
    };
};
const getFileBlock = (mediaItem)=>{
    const { id, url, title: title2, size: size2, complete } = mediaItem;
    const data = {
        id: id,
        src: url,
        title: title2,
        size: size2,
        complete: complete
    };
    if (isVideoFile(mediaItem)) {
        const { vid, playerUrls, duration: duration2, defaultPreview: defaultPreview2, preview: preview2, previewId } = mediaItem;
        return {
            type: EMediaDataType.VIDEO_FILE,
            data: {
                ...data,
                complete: true,
                videoId: vid,
                playerUrls: playerUrls,
                duration: duration2,
                defaultPreview: defaultPreview2,
                preview: preview2,
                previewId: previewId,
                vid: vid
            }
        };
    }
    return {
        type: mediaItem.type,
        data: data
    };
};
const isVideoFile = (mediaItem)=>{
    return mediaItem.type === EMediaDataType.VIDEO_FILE;
};
function isText(block2) {
    return block2.type === EMediaDataType.TEXT;
}
function isParagraphEnd(block2) {
    return block2.type === EMediaDataType.TEXT && block2.modificator === EMediaDataTextModificator.BLOCK_END;
}
const getTextBlockContent = (block2)=>{
    const json2 = JSON.parse(block2.content);
    return json2[EPackedTextBlock.TEXT];
};
const getTextLength = (block2)=>{
    return getTextBlockContent(block2).length;
};
const isTextEnd = (item2)=>{
    return !item2 || isParagraphEnd(item2) || !isTextOrLinkItem(item2) && !isSmileMediaDataItem(item2) && !isMentionItem(item2) && !isSpaceItem(item2);
};
const convertBlogPostDataToEditorState = (blogPostData, isDisableLinks)=>{
    const result2 = {
        time: Date.now(),
        blocks: []
    };
    if (!blogPostData) return result2;
    else {
        let markup2 = "";
        let offset2 = 0;
        const addMarkup = (markupToAdd)=>{
            markup2 += markupToAdd;
        };
        const addOffset = (offsetToAdd)=>{
            offset2 += offsetToAdd;
        };
        const resetMarkup = ()=>{
            markup2 = "";
        };
        const resetOffset = ()=>{
            offset2 = 0;
        };
        blogPostData.forEach((item2, index2)=>{
            const prev = blogPostData[index2 - 1];
            const next2 = blogPostData[index2 + 1];
            switch(item2.type){
                case EMediaDataType.TEXT:
                case EMediaDataType.LINK:
                    if (isTextOrLinkItem(item2)) {
                        addMarkup(item2.type === EMediaDataType.LINK && true ? convertLinkToHTML(item2, offset2) : convertPackedTextToHTML(item2.content, offset2));
                        const textLength2 = getTextLength(item2);
                        addOffset(textLength2);
                        if (isTextEnd(next2)) {
                            result2.blocks.push(getTextBlock(item2.type, markup2));
                            resetMarkup();
                            resetOffset();
                        }
                    }
                    break;
                case EMediaDataType.SMILE:
                    addMarkup(convertSmileToHTML({
                        smile: item2
                    }));
                    addOffset(1);
                    if (isTextEnd(next2)) {
                        result2.blocks.push(getTextBlock(item2.type, markup2));
                        resetMarkup();
                        resetOffset();
                    }
                    break;
                case EMediaDataType.MENTION:
                    const prevSpace = generateSpace("prev", prev);
                    const nextSpace = generateSpace("next", next2);
                    const markupText = prevSpace + convertMentionToHTML(item2) + nextSpace;
                    addMarkup(markupText);
                    const textLength = item2.displayName.length;
                    addOffset(textLength);
                    if (isTextEnd(next2)) {
                        result2.blocks.push(getTextBlock(item2.type, markup2));
                        resetMarkup();
                        resetOffset();
                    }
                    break;
                case EMediaDataType.SPACE:
                    addMarkup(convertSpaceToHtml());
                    addOffset(1);
                    if (isTextEnd(next2)) {
                        result2.blocks.push(getTextBlock(item2.type, markup2));
                        resetMarkup();
                        resetOffset();
                    }
                    break;
                case EMediaDataType.IMAGE:
                    result2.blocks.push(getImageBlock(item2));
                    break;
                case EMediaDataType.AUDIO:
                case EMediaDataType.VIDEO:
                    result2.blocks.push(getEmbedBlock(item2));
                    break;
                case EMediaDataType.AUDIO_FILE:
                case EMediaDataType.VIDEO_FILE:
                case EMediaDataType.FILE:
                    result2.blocks.push(getFileBlock(item2));
                    break;
            }
        });
        return result2;
    }
};
const getStyle$1 = (nodeName)=>{
    const map = {
        B: EStyleType.BOLD,
        I: EStyleType.ITALIC,
        S: EStyleType.STRIKETHROUGH,
        U: EStyleType.UNDERLINE,
        CODE: EStyleType.CODE
    };
    return map[nodeName];
};
const convertParagraphToTextBlocks$1 = (text2, options)=>{
    const { allowLinks, customLinkRegexp, shouldAddBlockEnd = true } = options || {};
    const resultText = allowLinks ? linkifyText(text2, customLinkRegexp) : text2;
    const body2 = document.createElement("body");
    const html = $gPJZG(resultText.replace(LINE_BREAK_HTML_TAG_REGEX, LINE_BREAK_HTML_ENTITY), {
        allowedAttributes: {
            p: [
                "class",
                "data-mention-id",
                "data-display-name",
                "data-unique-id"
            ],
            a: [
                "href",
                "name",
                "target"
            ]
        }
    });
    body2.innerHTML = html;
    let offset2 = 0;
    const cleanText = body2.innerText;
    const styleRanges = [];
    const rawLinkBlocks = [];
    const rawTextBlocks = [];
    const rawSmileBlocks = [];
    const rawMentionBlocks = [];
    const rawSpaceBlocks = [];
    const blocks2 = [];
    const traverse = (node)=>{
        if (node.nodeName === "A") rawLinkBlocks.push({
            type: EMediaDataType.LINK,
            href: node.getAttribute("href"),
            start: offset2,
            end: offset2 + node.textContent.length,
            content: cleanText.slice(offset2, offset2 + node.textContent.length),
            styles: []
        });
        if (node.nodeName === "IMG") {
            const id = node.getAttribute("data-id");
            const name2 = node.getAttribute("alt");
            const smallUrl = node.getAttribute("src");
            const srcset = node.getAttribute("srcset") || "";
            const [mediumUrl, largeUrl] = srcset.split(",").map((set2)=>set2.trim().split(" ")[0]);
            rawSmileBlocks.push({
                type: EMediaDataType.SMILE,
                start: offset2,
                end: offset2,
                content: "",
                styles: [],
                id: id,
                name: name2,
                smallUrl: smallUrl,
                mediumUrl: mediumUrl,
                largeUrl: largeUrl
            });
        }
        const mention2 = node.nodeName === "P" && node.classList.contains("mention");
        if (mention2) {
            const id = Number(node.getAttribute("data-mention-id"));
            const displayName = node.getAttribute("data-display-name");
            const uniqueId2 = node.getAttribute("data-unique-id");
            rawMentionBlocks.push({
                type: EMediaDataType.MENTION,
                content: node.textContent,
                start: offset2,
                end: offset2 + node.textContent.length,
                styles: [],
                id: id,
                displayName: displayName,
                uniqueId: uniqueId2
            });
        }
        const spaceBlock = node.nodeName === "P" && node.classList.contains("space");
        if (spaceBlock) rawSpaceBlocks.push({
            type: EMediaDataType.SPACE,
            start: offset2,
            end: offset2 + 1,
            styles: []
        });
        if (node.nodeName !== "A" && node.nodeName !== "IMG" && node.nodeType !== Node.TEXT_NODE && !mention2 && !spaceBlock) styleRanges.push([
            getStyle$1(node.nodeName),
            offset2,
            offset2 + node.textContent.length
        ]);
        if (node.nodeType === Node.TEXT_NODE) offset2 += node.textContent.length;
        else node.childNodes.forEach(traverse);
    };
    body2.childNodes.forEach(traverse);
    const rawCustomBlocks = [
        ...rawLinkBlocks,
        ...rawSmileBlocks,
        ...rawMentionBlocks,
        ...rawSpaceBlocks
    ].sort((a2, b2)=>a2.start - b2.start);
    if (rawCustomBlocks.length > 0) {
        const linksBounds = rawCustomBlocks.reduce((acc, link2)=>{
            acc.push([
                link2.start,
                link2.end
            ]);
            return acc;
        }, []).flat();
        const allBounds = [
            0,
            ...linksBounds,
            cleanText.length
        ];
        for(let i = 0; i < allBounds.length; i += 2){
            if (allBounds[i] === allBounds[i + 1]) continue;
            rawTextBlocks.push({
                type: EMediaDataType.TEXT,
                content: cleanText.slice(allBounds[i], allBounds[i + 1]),
                start: allBounds[i],
                end: allBounds[i + 1],
                styles: []
            });
        }
        const rawBlocks = [
            ...rawCustomBlocks,
            ...rawTextBlocks
        ].sort((a2, b2)=>a2.start - b2.start);
        rawBlocks.forEach((block2)=>{
            styleRanges.forEach((range2)=>{
                if (range2[EPackedStyleRange.OFFSET] >= block2.end || range2[EPackedStyleRange.LENGTH] <= block2.start) return;
                const style = [
                    range2[EPackedStyleRange.STYLE],
                    Math.max(block2.start, range2[EPackedStyleRange.OFFSET]),
                    Math.min(block2.end, range2[EPackedStyleRange.LENGTH])
                ];
                style[EPackedStyleRange.LENGTH] = style[EPackedStyleRange.LENGTH] - style[EPackedStyleRange.OFFSET];
                block2.styles.push(style);
            });
            switch(block2.type){
                case EMediaDataType.SMILE:
                    blocks2.push({
                        type: block2.type,
                        smallUrl: block2.smallUrl,
                        mediumUrl: block2.mediumUrl,
                        largeUrl: block2.largeUrl,
                        id: block2.id,
                        name: block2.name
                    });
                    break;
                case EMediaDataType.LINK:
                    blocks2.push({
                        type: block2.type,
                        content: JSON.stringify([
                            block2.content,
                            EBlockType[0],
                            block2.styles
                        ]),
                        url: block2.href
                    });
                    break;
                case EMediaDataType.MENTION:
                    blocks2.push({
                        type: block2.type,
                        id: block2.id,
                        displayName: block2.displayName,
                        uniqueId: block2.uniqueId
                    });
                    break;
                case EMediaDataType.SPACE:
                    blocks2.push({
                        type: block2.type
                    });
                    break;
                default:
                    blocks2.push({
                        type: block2.type,
                        content: JSON.stringify([
                            block2.content,
                            EBlockType[0],
                            block2.styles
                        ]),
                        modificator: ""
                    });
            }
        });
    } else {
        styleRanges.forEach((range2)=>range2[EPackedStyleRange.LENGTH] = range2[EPackedStyleRange.LENGTH] - range2[EPackedStyleRange.OFFSET]);
        blocks2.push({
            type: EMediaDataType.TEXT,
            content: JSON.stringify([
                cleanText,
                EBlockType[0],
                styleRanges
            ]),
            modificator: ""
        });
    }
    if (shouldAddBlockEnd) blocks2.push({
        type: EMediaDataType.TEXT,
        content: "",
        modificator: EMediaDataTextModificator.BLOCK_END
    });
    return blocks2;
};
const convertSmileToMediaItem = (smile2)=>{
    const { id, name: name2, smallUrl, mediumUrl, largeUrl } = smile2;
    return {
        type: EMediaDataType.SMILE,
        uniqueId: uniqueId(String(id)),
        id: id,
        name: name2,
        smallUrl: smallUrl,
        mediumUrl: mediumUrl,
        largeUrl: largeUrl
    };
};
const convertMentionToMediaItem = (user)=>{
    const { id, name: name2, displayName, nick: nick2 } = user;
    return {
        type: EMediaDataType.MENTION,
        className: "mention",
        uniqueId: uniqueId(String(id)),
        id: id,
        name: name2,
        displayName: displayName,
        nick: nick2
    };
};
Object.values(EKeyboardModifierKey);
var EPublishingShortcut = /* @__PURE__ */ ((EPublishingShortcut2)=>{
    EPublishingShortcut2["ENTER"] = "ENTER";
    EPublishingShortcut2["CTRL_ENTER"] = "CTRL_ENTER";
    return EPublishingShortcut2;
})(EPublishingShortcut || {});
const checkIsTextNode = (node)=>(node == null ? void 0 : node.nodeName) === "#text";
const checkIsBreakLine = (node)=>(node == null ? void 0 : node.nodeName) === "BR";
const getInsertedNodePosition = (list2, element, useNextSibling)=>{
    let position2 = list2.length;
    list2.forEach((listElement2, index2)=>{
        if (listElement2.dataset && listElement2.dataset["uniqueId"] === element.dataset["uniqueId"]) position2 = useNextSibling ? index2 + 2 : index2 + 1;
    });
    return position2;
};
const getCaretPosition = (element, params = {})=>{
    var _a3, _b2;
    const { fromParent, type } = params;
    const selection = window.getSelection();
    if (selection.rangeCount !== 0) {
        const range2 = window.getSelection().getRangeAt(0);
        const preCaretRange = range2.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range2.endContainer, range2.endOffset);
        let itemIndex = 0;
        let offset2 = 0;
        if (!fromParent) {
            itemIndex = preCaretRange.cloneContents().childNodes.length;
            if (checkIsTextNode(range2.endContainer)) offset2 = range2.endOffset;
            else if (range2.endContainer) {
                const endNode = range2.endContainer.childNodes[range2.endOffset - 1];
                offset2 = endNode ? ((_a3 = endNode.innerText) == null ? void 0 : _a3.length) ?? ((_b2 = endNode.data) == null ? void 0 : _b2.length) : 0;
            }
        } else {
            const children2 = Array.from(element.parentNode.childNodes);
            itemIndex = getInsertedNodePosition(children2, element, type !== EMediaDataType.SMILE);
            if (type === EMediaDataType.TEXT) itemIndex = itemIndex + 1;
            offset2 = 1;
        }
        const wrapper2 = element.parentNode.parentNode.parentNode;
        const block2 = element.parentNode.parentNode;
        const blockIndex = Array.prototype.indexOf.call(wrapper2.children, block2);
        const breakItems = Array.prototype.slice.call(wrapper2.children, 0, blockIndex).reduce((count2, parent)=>{
            var _a4, _b3, _c2;
            if (!((_c2 = (_b3 = (_a4 = parent == null ? void 0 : parent.children) == null ? void 0 : _a4[0]) == null ? void 0 : _b3.children) == null ? void 0 : _c2[0])) return count2;
            return count2 + Array.from(parent.children[0].children[0].childNodes).filter((item2, index2, list2)=>!checkIsBreakLine(item2) || !checkIsBreakLine(list2[index2 - 1])).length;
        }, 0);
        return {
            itemIndex: itemIndex,
            offset: offset2,
            breakItems: breakItems,
            blockIndex: blockIndex
        };
    }
    return {
        itemIndex: 0,
        offset: 0,
        breakItems: 0,
        blockIndex: 0
    };
};
const restoreCaretPosition = (element, cursor)=>{
    const { itemIndex, offset: offset2, blockIndex } = cursor;
    const range2 = document.createRange();
    const selection = window.getSelection();
    const wrapper2 = element.parentNode.parentNode.parentNode;
    const activeElement2 = wrapper2.children[blockIndex].children[0].children[0];
    const node = activeElement2.childNodes.item(itemIndex);
    if (checkIsTextNode(node)) {
        range2.setStart(node, offset2);
        range2.setEnd(node, offset2);
    } else if (node) {
        range2.setEndAfter(node);
        range2.setStartAfter(node);
    } else range2.selectNodeContents(activeElement2);
    range2.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range2);
    activeElement2.focus();
};
const isMention = (node)=>node.nodeName === "SPAN" && node.classList.contains("mention");
function isPrintableKey(keyCode) {
    return keyCode > 47 && keyCode < 58 || // number keys
    keyCode === 8 || keyCode === 46 || // Backspace and Delete
    keyCode === 32 || // Space bar
    keyCode === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    keyCode > 1071 && keyCode < 1104 || // letter small cyrillic keys
    keyCode > 1039 && keyCode < 1172 || // letter capital cyrillic keys
    keyCode > 63 && keyCode < 91 || // letter capital keys
    keyCode > 96 && keyCode < 123 || // letter small keys
    keyCode > 185 && keyCode < 193 || // ;=,-./` (in order)
    keyCode > 218 && keyCode < 223;
}
function getKeyAndKeyCode(event2) {
    const key = event2.data;
    const inputType = event2.inputType;
    if (key) return {
        key: key,
        keyCode: key.charCodeAt(0)
    };
    else {
        if (inputType === "deleteContentBackward") return {
            key: EKeyboardKey.BACKSPACE,
            keyCode: 8
        };
        else return {
            key: EKeyboardKey.DELETE,
            keyCode: 46
        };
    }
}
function insertHtmlAfterCursor(html) {
    const selection = window.getSelection();
    if (selection.rangeCount) {
        const renderer = document.createElement("template");
        renderer.innerHTML = html;
        selection.deleteFromDocument();
        selection.getRangeAt(0).insertNode(renderer.content);
        selection.collapseToEnd();
    }
}
const isPublishingShortcutApplied = (event2, shortcut)=>{
    if (shortcut === EPublishingShortcut.CTRL_ENTER) return event2.key === EKeyboardKey.ENTER && event2.ctrlKey && !(event2.metaKey || event2.shiftKey);
    if (shortcut === EPublishingShortcut.ENTER) return event2.key === EKeyboardKey.ENTER && !(event2.ctrlKey || event2.metaKey || event2.shiftKey);
    return false;
};
const setCaretAfterInsertedElement = (list2, element, cursorRef)=>{
    const insertedElementIndex = element.uniqueId ? Array.from(list2.childNodes).findIndex((node)=>{
        var _a3;
        return ((_a3 = node == null ? void 0 : node.dataset) == null ? void 0 : _a3.uniqueId) === element.uniqueId;
    }) : list2.childNodes.length - 1;
    if (element.type === EMediaDataType.MENTION || element.type === EMediaDataType.SMILE || element.type === EMediaDataType.TEXT) cursorRef.current = getCaretPosition(list2.childNodes[insertedElementIndex], {
        fromParent: true,
        type: element.type
    });
    else {
        cursorRef.current.itemIndex++;
        cursorRef.current.offset = 0;
    }
};
const findCurrentWordIndexes = (fullText, caretPosition)=>{
    const firstSpaceIndex = fullText.lastIndexOf(" ", caretPosition - 1) + 1;
    const firstNbspIndex = fullText.lastIndexOf(String.fromCharCode(160), caretPosition - 1) + 1;
    const start = firstSpaceIndex || firstNbspIndex;
    const lastSpaceIndex = fullText.indexOf(" ", caretPosition);
    const end = lastSpaceIndex === -1 ? fullText.length : lastSpaceIndex;
    return {
        start: start,
        end: end
    };
};
const BREAK_LINE = "\n";
const REGULAR_SPACE_CODE = 32;
const NON_BREAK_SPACE_CODE = 160;
const inPlaceInsertingStrategy = (content2, position2, query)=>{
    const firstPart = content2.slice(0, position2);
    const lastPart = content2.slice(position2);
    return {
        firstPart: firstPart,
        lastPart: lastPart
    };
};
const replaceWordOnCursorInsertingStrategy = (content2, position2, query)=>{
    const { start, end } = findCurrentWordIndexes(content2, position2);
    const startIndex = Boolean(query) ? position2 - (query == null ? void 0 : query.length) - 1 : start;
    const firstPart = content2.slice(0, startIndex);
    const lastPart = content2.slice(end);
    return {
        firstPart: firstPart,
        lastPart: lastPart
    };
};
const replaceWithPreviousHardSpaceStrategy = (content2, position2, query)=>{
    const strategyResult = replaceWordOnCursorInsertingStrategy(content2, position2, query);
    if ([
        String.fromCharCode(REGULAR_SPACE_CODE),
        String.fromCharCode(NON_BREAK_SPACE_CODE)
    ].includes(strategyResult.firstPart)) return {
        ...strategyResult,
        firstPart: ""
    };
    return strategyResult;
};
const insertObjectInTextItem = (item2, object2, position2, strategy = inPlaceInsertingStrategy, query)=>{
    const [content2, ...rest] = JSON.parse(item2.content);
    const { firstPart, lastPart } = strategy(content2, position2, query);
    return [
        firstPart.length > 0 && Object.assign({}, item2, {
            content: JSON.stringify([
                firstPart
            ].concat(rest))
        }),
        ...isArray(object2) ? object2 : [
            object2
        ],
        lastPart.length > 0 && Object.assign({}, item2, {
            content: JSON.stringify([
                lastPart
            ].concat(rest))
        })
    ].filter(Boolean);
};
const prepareCursor = (cursor, textData)=>{
    const { itemIndex, offset: offset2, breakItems, blockIndex } = cursor;
    const relativeIndex = breakItems + blockIndex;
    const isMultiLine2 = textData.slice(relativeIndex, relativeIndex + itemIndex).reduce((flag, node)=>flag || isText(node) && node.content && getTextBlockContent(node).indexOf(BREAK_LINE) >= 0, false);
    if (isMultiLine2) {
        let nextCursor = {
            itemIndex: relativeIndex + itemIndex,
            offset: offset2,
            breakItems: breakItems,
            blockIndex: blockIndex
        };
        let count2 = 0;
        textData.some((node, index2)=>{
            const prevCount = count2;
            if (isText(node)) {
                const content2 = node.content && getTextBlockContent(node) || "";
                const breaks = content2.split(BREAK_LINE).reduce((list2, el)=>[
                        ...list2,
                        el,
                        BREAK_LINE
                    ], []).filter(Boolean).slice(0, -1);
                count2 += breaks.length;
                if (count2 >= relativeIndex + itemIndex) {
                    const sliceIndex = breakItems + itemIndex - prevCount - 1;
                    if (breaks[sliceIndex] === BREAK_LINE) {
                        nextCursor = {
                            itemIndex: index2 + 1,
                            offset: breaks.slice(0, sliceIndex + 1).join("").length,
                            breakItems: breakItems,
                            blockIndex: blockIndex
                        };
                        return true;
                    }
                    nextCursor = {
                        itemIndex: index2 + 1,
                        offset: breaks.slice(0, sliceIndex).join("").length + offset2,
                        breakItems: breakItems,
                        blockIndex: blockIndex
                    };
                    return true;
                }
            } else {
                count2++;
                if (count2 >= relativeIndex + itemIndex) {
                    nextCursor = {
                        itemIndex: index2 + 1,
                        offset: 0,
                        breakItems: breakItems,
                        blockIndex: blockIndex
                    };
                    return true;
                }
            }
            return false;
        });
        return nextCursor;
    } else return {
        itemIndex: relativeIndex + itemIndex,
        offset: offset2,
        breakItems: breakItems,
        blockIndex: blockIndex
    };
};
const LINK_REGEXP = /<a[^>]+>.+?<\/a>/ig;
const convertLinksToMediaItems = (content2)=>{
    const allLinks = content2.match(LINK_REGEXP);
    const result2 = [];
    if (allLinks) {
        const splittedContent = content2.split(LINK_REGEXP);
        allLinks.forEach((link2, index2)=>{
            if (splittedContent[index2]) result2.push({
                type: EMediaDataType.TEXT,
                content: JSON.stringify([
                    splittedContent[index2],
                    EBlockType[0],
                    []
                ]),
                modificator: ""
            });
            const body2 = document.createElement("body");
            body2.innerHTML = link2;
            const linkNode = body2.childNodes[0];
            result2.push({
                type: EMediaDataType.LINK,
                content: JSON.stringify([
                    linkNode.textContent,
                    EBlockType[0],
                    []
                ]),
                url: linkNode.href
            });
        });
        const lastElement = splittedContent[splittedContent.length - 1];
        if (lastElement) result2.push({
            type: EMediaDataType.TEXT,
            content: JSON.stringify([
                lastElement,
                EBlockType[0],
                []
            ]),
            modificator: ""
        });
    }
    return result2;
};
EPaymentMethod.CARD, EPaymentMethod.CARD_BANK131, EPaymentMethod.CARD_GLOBAL;
EPaymentType.DONATION, EPaymentType.POST, EPaymentType.MESSAGE;
ESchemaType.SUBSCRIPTION;
const getHeartbeatBlogUrl = (data, activeHeartbeatData)=>{
    if (activeHeartbeatData && (activeHeartbeatData == null ? void 0 : activeHeartbeatData.blogUrl) && (activeHeartbeatData == null ? void 0 : activeHeartbeatData.streamId)) return activeHeartbeatData;
    return data;
};
const DEBOUNCE_TIME_MS$2 = 350;
const useStreamStats = (params)=>{
    const { heartbeats: { defaultInterval } } = getConfig();
    const { data: parameters, autoplay, isDisabled: isDisabled2, source, sourceType } = params;
    const dispatch = (0, $2OPjR.useDispatch)();
    const timerID = (0, $acw62.useRef)();
    const nextRequestInterval = (0, $acw62.useRef)(defaultInterval);
    const isHeartbeatActive = (0, $acw62.useRef)(false);
    const shouldSendHeartbeats = (0, $acw62.useRef)(true);
    const [activeHeartBeatsData, setActiveHeartBeatsData] = (0, $acw62.useState)(null);
    const { get: getSource, save: saveSource } = useRefCapsule(source);
    const { get: getHBData, save: saveHBData } = useRefCapsule(null);
    const sendHeartbeat$1 = async (payload)=>{
        try {
            const { blogUrl, streamId } = getHBData() ?? {};
            if (blogUrl && streamId) {
                const data = await dispatch((0, $7Uc0p.thunkToAction)(sendHeartbeat.action)({
                    blogUrl: blogUrl,
                    streamId: streamId,
                    sourceType: sourceType,
                    ...payload,
                    source: getSource()
                }));
                setActiveHeartBeatsData((payload == null ? void 0 : payload.stop) ? null : {
                    blogUrl: blogUrl,
                    streamId: streamId
                });
                nextRequestInterval.current = getUnixTime(data.nextRequestInterval);
            }
            nextRequestInterval.current = getUnixTime(defaultInterval);
        } catch (err) {
            nextRequestInterval.current = getUnixTime(defaultInterval);
        }
    };
    const debouncedCommitHeartbeat = (0, $acw62.useCallback)(debounce((payload)=>{
        commitHeartbeat(payload);
    }, DEBOUNCE_TIME_MS$2), [
        autoplay
    ]);
    const commitHeartbeat = async (payload)=>{
        if (Boolean(payload.stop) && !shouldSendHeartbeats.current) await sendHeartbeat$1(payload);
        if (shouldSendHeartbeats.current) await sendHeartbeat$1(payload);
        if (isHeartbeatActive.current && !Boolean(payload.stop)) {
            window.clearTimeout(timerID.current);
            timerID.current = window.setTimeout(commitHeartbeat, nextRequestInterval.current, payload);
        }
    };
    const startSendingHeartbeats = (0, $acw62.useCallback)(()=>{
        if (isHeartbeatActive.current) return;
        isHeartbeatActive.current = true;
        debouncedCommitHeartbeat({
            autoplay: autoplay
        });
    }, [
        autoplay
    ]);
    const breakSendingHeartbeats = (0, $acw62.useCallback)(()=>{
        shouldSendHeartbeats.current = false;
    }, []);
    const continueSendingHeartbeats = (0, $acw62.useCallback)(()=>{
        shouldSendHeartbeats.current = true;
    }, []);
    const stopSendingHeartbeats = (0, $acw62.useCallback)(()=>{
        if (!isHeartbeatActive.current) return;
        isHeartbeatActive.current = false;
        window.clearTimeout(timerID.current);
        commitHeartbeat({
            stop: true
        });
    }, [
        autoplay
    ]);
    (0, $acw62.useEffect)(()=>{
        saveSource(source);
    }, [
        source
    ]);
    (0, $acw62.useEffect)(()=>{
        const result2 = getHeartbeatBlogUrl(parameters, activeHeartBeatsData);
        saveHBData(result2);
    }, [
        parameters,
        activeHeartBeatsData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isDisabled2) window.addEventListener("beforeunload", stopSendingHeartbeats);
        return ()=>{
            if (!isDisabled2) {
                stopSendingHeartbeats();
                window.removeEventListener("beforeunload", stopSendingHeartbeats);
            }
        };
    }, [
        isDisabled2
    ]);
    return {
        startSendingHeartbeats: startSendingHeartbeats,
        breakSendingHeartbeats: breakSendingHeartbeats,
        continueSendingHeartbeats: continueSendingHeartbeats,
        stopSendingHeartbeats: stopSendingHeartbeats
    };
};
const locales$1F = {
    activateRewardError: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
    activateRewardSuccess: "\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
};
const t$1G = distExports$1.getTranslation && locales$1F;
const useChannelRewardShop = (blogUrl)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const handleRewardActivate = async (reward2, data)=>{
        let text2;
        try {
            text2 = JSON.stringify(data);
        } catch (err) {}
        dispatch(clearPostponedReward());
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(activateReward.action)({
                blogUrl: blogUrl,
                id: reward2.id,
                text: text2
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: t$1G.activateRewardSuccess
            });
        } catch (err) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$1G.activateRewardError
            });
        }
    };
    return {
        handleRewardActivate: handleRewardActivate
    };
};
const useQuery = ()=>{
    const { search } = window.location;
    return (0, $acw62.useMemo)(()=>Object.fromEntries(new URLSearchParams(search)), [
        search
    ]);
};
const CHAT_MODES = {
    [EChatMode.CHAT]: EChatMode.CHAT,
    [EChatMode.MENTIONS]: EChatMode.MENTIONS,
    [EChatMode.USERS]: EChatMode.USERS
};
const useChatMode = ()=>{
    const { blogUrl } = useParams();
    const { initialMode } = useQuery();
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const chatMode = (0, $iD0SF.useSelector)(streamChatModeSelector);
    const chatCurrentUserMentionMessages = (0, $iD0SF.useSelector)(streamChatCurrentUserMentionMessagesSelector);
    const prevChatCurrentUserMentionMessages = usePrevious(chatCurrentUserMentionMessages);
    const [externalReplyTarget, setExternalReplyTarget] = (0, $acw62.useState)(null);
    const [hasNewMentions, setHasNewMentions] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (CHAT_MODES[initialMode]) updateChatMode({
            mode: CHAT_MODES[initialMode],
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id
        });
    }, [
        blogUrl,
        currentUser2 == null ? void 0 : currentUser2.id
    ]);
    (0, $acw62.useEffect)(()=>{
        setExternalReplyTarget(null);
        if (chatMode === EChatMode.MENTIONS) setHasNewMentions(false);
    }, [
        chatMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (chatMode !== EChatMode.MENTIONS && chatCurrentUserMentionMessages.length > (prevChatCurrentUserMentionMessages == null ? void 0 : prevChatCurrentUserMentionMessages.length)) setHasNewMentions(true);
    }, [
        chatMode,
        chatCurrentUserMentionMessages
    ]);
    (0, $acw62.useEffect)(()=>{
        AppStat.log.chat.tabShow(chatMode);
    }, [
        chatMode
    ]);
    const setChatMode = (0, $acw62.useCallback)((mode2)=>{
        dispatch(updateChatMode({
            mode: mode2,
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id
        }));
    }, [
        currentUser2 == null ? void 0 : currentUser2.id
    ]);
    const onReplyTarget = (user)=>{
        setChatMode(EChatMode.CHAT);
        setExternalReplyTarget(user);
    };
    return {
        chatMode: chatMode,
        externalReplyTarget: externalReplyTarget,
        hasNewMentions: hasNewMentions,
        onReplyTarget: onReplyTarget,
        setChatMode: setChatMode
    };
};
const DEBOUNCE_TIME_MS$1 = 300;
const useChatUsers = (blogUrl, slotUrl)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { currentUser: currentUser2 } = useCurrentUserAccess();
    const streamChatUsers = (0, $iD0SF.useSelector)(streamChatUsersSelector);
    const streamChatUsersNetworkStatus = (0, $iD0SF.useSelector)(streamChatUsersNetworkStatusSelector);
    const streamChatUserStat = (0, $iD0SF.useSelector)(streamChatUserStatSelector);
    const streamChatUserStatNetworkStatus = (0, $iD0SF.useSelector)(streamChatUserStatNetworkStatusSelector);
    const roles2 = (0, $iD0SF.useSelector)(rolesSelector);
    const searchQuery = (0, $iD0SF.useSelector)(streamChatUsersSearchQuerySelector);
    const isCurrentUserModerator = Boolean(streamChatUsers == null ? void 0 : streamChatUsers.moderators.some((user)=>user.id === (currentUser2 == null ? void 0 : currentUser2.id)));
    const isCurrentUserOwner = Boolean((streamChatUsers == null ? void 0 : streamChatUsers.owner.id) && (currentUser2 == null ? void 0 : currentUser2.id) && (streamChatUsers == null ? void 0 : streamChatUsers.owner.id) === (currentUser2 == null ? void 0 : currentUser2.id));
    const currentUserId = currentUser2 == null ? void 0 : currentUser2.id;
    const userStatShownRef = (0, $acw62.useRef)(null);
    const fetchStreamChatUsers$1 = async (query)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUsers.action)({
            blogUrl: blogUrl,
            searchQuery: query
        }));
    };
    const fetchStreamChatUserStat$1 = (0, $acw62.useCallback)(async (userId, context)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUserStat.action)({
            blogUrl: blogUrl,
            userId: userId,
            context: context
        }));
    }, [
        blogUrl
    ]);
    const onFetchRoles = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchRoles.action)({
            blogUrl: blogUrl
        }));
    };
    const onClearRoles = ()=>{
        dispatch(clearRoles());
    };
    const resetChatUserStat = ()=>{
        dispatch(streamChatUserStatReset());
    };
    const onBan = async (userId)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(blockUserPermanently.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId
        }));
        await fetchStreamChatUserStat$1(userId);
    };
    const onTimeout = async (userId, period)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(blockUserTemporarily.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId,
            period: period
        }));
        await fetchStreamChatUserStat$1(userId);
    };
    const onBanCancel = async (userId, byStream)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(unblockUser.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId,
            byStream: byStream
        }));
        await fetchStreamChatUserStat$1(userId);
    };
    const onAssignRole = async (userId, selectedRoles)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(assignUserRoles.action)({
            blogUrl: blogUrl,
            userId: userId,
            selectedRoles: selectedRoles
        }));
    };
    const searchChatUsers = debounce(fetchStreamChatUsers$1, DEBOUNCE_TIME_MS$1);
    const onClickSuperHandler = (0, $acw62.useCallback)((event2)=>{
        var _a3, _b2;
        const target2 = event2.target;
        const closestElementWithRole = target2.closest("[data-role]");
        const role2 = closestElementWithRole == null ? void 0 : closestElementWithRole.dataset.role;
        const rootElement = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`);
        const context = (_a3 = rootElement == null ? void 0 : rootElement.dataset) == null ? void 0 : _a3.context;
        const userId = Number((_b2 = rootElement == null ? void 0 : rootElement.dataset) == null ? void 0 : _b2.userId);
        if (role2 === EHTMLDataRole.MESSAGE_AUTHOR && userStatShownRef.current !== userId) {
            event2.stopPropagation();
            fetchStreamChatUserStat$1(userId, context);
            userStatShownRef.current = userId;
            AppStat.log.chat.userCardShow();
        }
    }, [
        fetchStreamChatUserStat$1
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchStreamChatUsers$1();
    }, [
        blogUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!(streamChatUserStat == null ? void 0 : streamChatUserStat.user.id)) userStatShownRef.current = null;
    }, [
        streamChatUserStat == null ? void 0 : streamChatUserStat.user.id
    ]);
    return {
        streamChatUsers: streamChatUsers,
        streamChatUsersNetworkStatus: streamChatUsersNetworkStatus,
        streamChatUserStat: streamChatUserStat,
        streamChatUserStatNetworkStatus: streamChatUserStatNetworkStatus,
        roles: roles2,
        isCurrentUserModerator: isCurrentUserModerator,
        isCurrentUserOwner: isCurrentUserOwner,
        currentUserId: currentUserId,
        searchQuery: searchQuery,
        onClickSuperHandler: onClickSuperHandler,
        searchChatUsers: searchChatUsers,
        fetchStreamChatUsers: fetchStreamChatUsers$1,
        fetchStreamChatUserStat: fetchStreamChatUserStat$1,
        resetChatUserStat: resetChatUserStat,
        onBan: onBan,
        onTimeout: onTimeout,
        onBanCancel: onBanCancel,
        onFetchRoles: onFetchRoles,
        onClearRoles: onClearRoles,
        onAssignRole: onAssignRole
    };
};
const useCloseOnEscape = (onCloseCallback)=>{
    (0, $acw62.useEffect)(()=>{
        const escapeListener = (event2)=>{
            if (event2.key === EKeyboardKey.ESCAPE) onCloseCallback();
        };
        document.addEventListener("keydown", escapeListener);
        return ()=>{
            document.removeEventListener("keydown", escapeListener);
        };
    }, []);
};
const intervalToDuration = (interval)=>{
    const { start, end } = interval;
    const diff = getDiffBetweenDates(start, end);
    const days = diff.days;
    const hours = diff.hours - days * 24;
    const minutes = diff.minutes - hours * 60 - days * 1440;
    const seconds = diff.seconds - minutes * 60 - hours * 3600 - days * 86400;
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
};
const TIME_UPDATE_DELAY = 1e3;
const useCountdown = (params)=>{
    const { timeLeft, delay: delay2 = TIME_UPDATE_DELAY, onEnd = noop$2 } = params;
    const countTicksRef = (0, $acw62.useRef)(0);
    const timeoutRef = (0, $acw62.useRef)();
    const [duration2, setDuration] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const countTicks = timeLeft / delay2;
        const firstTickDelay = timeLeft % delay2;
        countTicksRef.current = Math.ceil(countTicks);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(onTick, firstTickDelay);
        tick();
        return ()=>clearTimeout(timeoutRef.current);
    }, [
        timeLeft
    ]);
    const tick = ()=>{
        if (countTicksRef.current === 0) {
            setDuration(intervalToDuration({
                start: 0,
                end: 0
            }));
            onEnd();
            return false;
        } else {
            setDuration(intervalToDuration({
                start: countTicksRef.current * delay2,
                end: 0
            }));
            countTicksRef.current--;
            return true;
        }
    };
    const onTick = ()=>{
        if (tick()) timeoutRef.current = setTimeout(onTick, delay2);
        else clearTimeout(timeoutRef.current);
    };
    return duration2;
};
const registerDropProgressUpdateWS = (store2)=>{
    WSClient.register({
        channel: EWSChannel.PRIVATE_STREAM,
        message: EWSPrivateStreamMessageType.DROP_PROGRESS,
        handler: ({ data: { data } })=>{
            store2.dispatch(updateDropsProgress({
                event: data.dropProgresses
            }));
        }
    });
};
const unregisterDropProgressUpdateWS = ()=>{
    WSClient.unregister({
        channel: EWSChannel.PRIVATE_STREAM,
        message: EWSPrivateStreamMessageType.DROP_PROGRESS
    });
};
const getDropsFetchActions = (state, { params })=>{
    const { blogUrl, slotUrl } = params;
    const { isFetched: isDropsProgressFetched } = dropsProgressNetworkStatusSelector(state);
    const isAuthorized = currentUserIsAuthorizedSelector(state);
    const actions2 = [];
    if (!isDropsProgressFetched && isAuthorized) actions2.push(()=>(0, $7Uc0p.thunkToAction)(fetchDropsProgress.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl
        }));
    return actions2;
};
const useDropsView = (props)=>{
    const { blogUrl, slotUrl, ignoreWS, setDropListVisibility, setDropReceivedVisibility } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const store2 = (0, $4TSkt.useStore)();
    const isAuthorized = (0, $iD0SF.useSelector)(currentUserIsAuthorizedSelector);
    const highestDropProgress = (0, $iD0SF.useSelector)(dropsHighestProgressSelector);
    const dropsFinishedProgress = (0, $iD0SF.useSelector)(dropsFinishedProgressSelector);
    const nonReceivedDrops = (0, $iD0SF.useSelector)(nonReceivedDropsProgressSelector);
    const isDropsListEmpty = nonReceivedDrops.length === 0;
    const dropsFinishedProgressCount = dropsFinishedProgress.length;
    const onClick = ()=>{
        dispatch(clearDropRewardsToShow({}));
        if (!dropsFinishedProgressCount) {
            setDropReceivedVisibility == null || setDropReceivedVisibility(false);
            setDropListVisibility == null || setDropListVisibility((value2)=>!value2);
            return;
        }
        setDropListVisibility == null || setDropListVisibility(false);
        dropsFinishedProgress.forEach((finishedDrop)=>{
            const { campaign: { id: dropCampaignId }, currentRule: { id: ruleId } } = finishedDrop;
            dispatch((0, $7Uc0p.thunkToAction)(requestDropRewards.action)({
                dropCampaignId: dropCampaignId,
                ruleId: ruleId
            }));
        });
        setDropReceivedVisibility(true);
    };
    const clear = ()=>{
        dispatch(clearDropsProgress());
    };
    (0, $acw62.useEffect)(()=>{
        getDropsFetchActions(store2.getState(), {
            params: {
                blogUrl: blogUrl,
                slotUrl: slotUrl
            }
        }).forEach((action)=>dispatch(action()));
        return ()=>{
            clear();
        };
    }, [
        isAuthorized,
        blogUrl,
        slotUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (ignoreWS) return noop$1;
        if (isAuthorized) registerDropProgressUpdateWS(store2);
        return ()=>{
            unregisterDropProgressUpdateWS();
        };
    }, [
        isAuthorized
    ]);
    return {
        highestDropProgress: highestDropProgress,
        dropsFinishedProgressCount: dropsFinishedProgressCount,
        isDropsListEmpty: isDropsListEmpty,
        onClick: onClick
    };
};
var FeedbackLoader = {
    exports: {}
};
(function(module2, exports2) {
    !function(e2, t2) {
        t2(exports2);
    }(commonjsGlobal, function(e2) {
        function t2(e3, t3) {
            var r3 = {};
            for(var n3 in e3)Object.prototype.hasOwnProperty.call(e3, n3) && t3.indexOf(n3) < 0 && (r3[n3] = e3[n3]);
            if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
                var i2 = 0;
                for(n3 = Object.getOwnPropertySymbols(e3); i2 < n3.length; i2++)t3.indexOf(n3[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, n3[i2]) && (r3[n3[i2]] = e3[n3[i2]]);
            }
            return r3;
        }
        function r2(e3, t3, r3, n3) {
            return new (r3 || (r3 = Promise))(function(i2, o3) {
                function s3(e4) {
                    try {
                        u3(n3.next(e4));
                    } catch (e5) {
                        o3(e5);
                    }
                }
                function a3(e4) {
                    try {
                        u3(n3.throw(e4));
                    } catch (e5) {
                        o3(e5);
                    }
                }
                function u3(e4) {
                    var t4;
                    e4.done ? i2(e4.value) : (t4 = e4.value, t4 instanceof r3 ? t4 : new r3(function(e5) {
                        e5(t4);
                    })).then(s3, a3);
                }
                u3((n3 = n3.apply(e3, [])).next());
            });
        }
        var n2 = function() {
            this.__data__ = [], this.size = 0;
        };
        var i = function(e3, t3) {
            return e3 === t3 || e3 != e3 && t3 != t3;
        };
        var o2 = function(e3, t3) {
            for(var r3 = e3.length; r3--;)if (i(e3[r3][0], t3)) return r3;
            return -1;
        }, s2 = Array.prototype.splice;
        var a2 = function(e3) {
            var t3 = this.__data__, r3 = o2(t3, e3);
            return !(r3 < 0) && (r3 == t3.length - 1 ? t3.pop() : s2.call(t3, r3, 1), --this.size, true);
        };
        var u2 = function(e3) {
            var t3 = this.__data__, r3 = o2(t3, e3);
            return r3 < 0 ? void 0 : t3[r3][1];
        };
        var c2 = function(e3) {
            return o2(this.__data__, e3) > -1;
        };
        var l2 = function(e3, t3) {
            var r3 = this.__data__, n3 = o2(r3, e3);
            return n3 < 0 ? (++this.size, r3.push([
                e3,
                t3
            ])) : r3[n3][1] = t3, this;
        };
        function h2(e3) {
            var t3 = -1, r3 = null == e3 ? 0 : e3.length;
            for(this.clear(); ++t3 < r3;){
                var n3 = e3[t3];
                this.set(n3[0], n3[1]);
            }
        }
        h2.prototype.clear = n2, h2.prototype.delete = a2, h2.prototype.get = u2, h2.prototype.has = c2, h2.prototype.set = l2;
        var d2 = h2;
        var f2 = function() {
            this.__data__ = new d2(), this.size = 0;
        };
        var v2 = function(e3) {
            var t3 = this.__data__, r3 = t3.delete(e3);
            return this.size = t3.size, r3;
        };
        var p2 = function(e3) {
            return this.__data__.get(e3);
        };
        var y2 = function(e3) {
            return this.__data__.has(e3);
        }, g2 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : {};
        function b2(e3) {
            return e3 && e3.__esModule && Object.prototype.hasOwnProperty.call(e3, "default") ? e3.default : e3;
        }
        function m2(e3, t3) {
            return e3(t3 = {
                exports: {}
            }, t3.exports), t3.exports;
        }
        var w2 = "object" == typeof g2 && g2 && g2.Object === Object && g2, D2 = "object" == typeof self && self && self.Object === Object && self, _2 = w2 || D2 || Function("return this")(), A2 = _2.Symbol, j2 = Object.prototype, B3 = j2.hasOwnProperty, S2 = j2.toString, E2 = A2 ? A2.toStringTag : void 0;
        var O2 = function(e3) {
            var t3 = B3.call(e3, E2), r3 = e3[E2];
            try {
                e3[E2] = void 0;
                var n3 = true;
            } catch (e4) {}
            var i2 = S2.call(e3);
            return n3 && (t3 ? e3[E2] = r3 : delete e3[E2]), i2;
        }, F2 = Object.prototype.toString;
        var C = function(e3) {
            return F2.call(e3);
        }, k2 = A2 ? A2.toStringTag : void 0;
        var I2 = function(e3) {
            return null == e3 ? void 0 === e3 ? "[object Undefined]" : "[object Null]" : k2 && k2 in Object(e3) ? O2(e3) : C(e3);
        };
        var T2 = function(e3) {
            var t3 = typeof e3;
            return null != e3 && ("object" == t3 || "function" == t3);
        };
        var L2, P2 = function(e3) {
            if (!T2(e3)) return false;
            var t3 = I2(e3);
            return "[object Function]" == t3 || "[object GeneratorFunction]" == t3 || "[object AsyncFunction]" == t3 || "[object Proxy]" == t3;
        }, x2 = _2["__core-js_shared__"], M2 = (L2 = /[^.]+$/.exec(x2 && x2.keys && x2.keys.IE_PROTO || "")) ? "Symbol(src)_1." + L2 : "";
        var $ = function(e3) {
            return !!M2 && M2 in e3;
        }, R2 = Function.prototype.toString;
        var N = function(e3) {
            if (null != e3) {
                try {
                    return R2.call(e3);
                } catch (e4) {}
                try {
                    return e3 + "";
                } catch (e4) {}
            }
            return "";
        }, U2 = /^\[object .+?Constructor\]$/, q2 = Function.prototype, z2 = Object.prototype, J = q2.toString, H4 = z2.hasOwnProperty, K = RegExp("^" + J.call(H4).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        var W2 = function(e3) {
            return !(!T2(e3) || $(e3)) && (P2(e3) ? K : U2).test(N(e3));
        };
        var V2 = function(e3, t3) {
            return null == e3 ? void 0 : e3[t3];
        };
        var G2 = function(e3, t3) {
            var r3 = V2(e3, t3);
            return W2(r3) ? r3 : void 0;
        }, Q2 = G2(_2, "Map"), Y2 = G2(Object, "create");
        var X2 = function() {
            this.__data__ = Y2 ? Y2(null) : {}, this.size = 0;
        };
        var Z2 = function(e3) {
            var t3 = this.has(e3) && delete this.__data__[e3];
            return this.size -= t3 ? 1 : 0, t3;
        }, ee = Object.prototype.hasOwnProperty;
        var te = function(e3) {
            var t3 = this.__data__;
            if (Y2) {
                var r3 = t3[e3];
                return "__lodash_hash_undefined__" === r3 ? void 0 : r3;
            }
            return ee.call(t3, e3) ? t3[e3] : void 0;
        }, re = Object.prototype.hasOwnProperty;
        var ne = function(e3) {
            var t3 = this.__data__;
            return Y2 ? void 0 !== t3[e3] : re.call(t3, e3);
        };
        var ie = function(e3, t3) {
            var r3 = this.__data__;
            return this.size += this.has(e3) ? 0 : 1, r3[e3] = Y2 && void 0 === t3 ? "__lodash_hash_undefined__" : t3, this;
        };
        function oe(e3) {
            var t3 = -1, r3 = null == e3 ? 0 : e3.length;
            for(this.clear(); ++t3 < r3;){
                var n3 = e3[t3];
                this.set(n3[0], n3[1]);
            }
        }
        oe.prototype.clear = X2, oe.prototype.delete = Z2, oe.prototype.get = te, oe.prototype.has = ne, oe.prototype.set = ie;
        var se = oe;
        var ae = function() {
            this.size = 0, this.__data__ = {
                hash: new se(),
                map: new (Q2 || d2)(),
                string: new se()
            };
        };
        var ue = function(e3) {
            var t3 = typeof e3;
            return "string" == t3 || "number" == t3 || "symbol" == t3 || "boolean" == t3 ? "__proto__" !== e3 : null === e3;
        };
        var ce = function(e3, t3) {
            var r3 = e3.__data__;
            return ue(t3) ? r3["string" == typeof t3 ? "string" : "hash"] : r3.map;
        };
        var le = function(e3) {
            var t3 = ce(this, e3).delete(e3);
            return this.size -= t3 ? 1 : 0, t3;
        };
        var he = function(e3) {
            return ce(this, e3).get(e3);
        };
        var de = function(e3) {
            return ce(this, e3).has(e3);
        };
        var fe = function(e3, t3) {
            var r3 = ce(this, e3), n3 = r3.size;
            return r3.set(e3, t3), this.size += r3.size == n3 ? 0 : 1, this;
        };
        function ve(e3) {
            var t3 = -1, r3 = null == e3 ? 0 : e3.length;
            for(this.clear(); ++t3 < r3;){
                var n3 = e3[t3];
                this.set(n3[0], n3[1]);
            }
        }
        ve.prototype.clear = ae, ve.prototype.delete = le, ve.prototype.get = he, ve.prototype.has = de, ve.prototype.set = fe;
        var pe = ve;
        var ye = function(e3, t3) {
            var r3 = this.__data__;
            if (r3 instanceof d2) {
                var n3 = r3.__data__;
                if (!Q2 || n3.length < 199) return n3.push([
                    e3,
                    t3
                ]), this.size = ++r3.size, this;
                r3 = this.__data__ = new pe(n3);
            }
            return r3.set(e3, t3), this.size = r3.size, this;
        };
        function ge(e3) {
            var t3 = this.__data__ = new d2(e3);
            this.size = t3.size;
        }
        ge.prototype.clear = f2, ge.prototype.delete = v2, ge.prototype.get = p2, ge.prototype.has = y2, ge.prototype.set = ye;
        var be = ge, me = function() {
            try {
                var e3 = G2(Object, "defineProperty");
                return e3({}, "", {}), e3;
            } catch (e4) {}
        }();
        var we = function(e3, t3, r3) {
            "__proto__" == t3 && me ? me(e3, t3, {
                configurable: true,
                enumerable: true,
                value: r3,
                writable: true
            }) : e3[t3] = r3;
        };
        var De = function(e3, t3, r3) {
            (void 0 !== r3 && !i(e3[t3], r3) || void 0 === r3 && !(t3 in e3)) && we(e3, t3, r3);
        };
        var _e = /* @__PURE__ */ function(e3) {
            return function(t3, r3, n3) {
                for(var i2 = -1, o3 = Object(t3), s3 = n3(t3), a3 = s3.length; a3--;){
                    var u3 = s3[++i2];
                    if (false === r3(o3[u3], u3, o3)) break;
                }
                return t3;
            };
        }(), Ae = m2(function(e3, t3) {
            var r3 = t3 && !t3.nodeType && t3, n3 = r3 && e3 && !e3.nodeType && e3, i2 = n3 && n3.exports === r3 ? _2.Buffer : void 0, o3 = i2 ? i2.allocUnsafe : void 0;
            e3.exports = function(e4, t4) {
                if (t4) return e4.slice();
                var r4 = e4.length, n4 = o3 ? o3(r4) : new e4.constructor(r4);
                return e4.copy(n4), n4;
            };
        }), je = _2.Uint8Array;
        var Be = function(e3) {
            var t3 = new e3.constructor(e3.byteLength);
            return new je(t3).set(new je(e3)), t3;
        };
        var Se = function(e3, t3) {
            var r3 = t3 ? Be(e3.buffer) : e3.buffer;
            return new e3.constructor(r3, e3.byteOffset, e3.length);
        };
        var Ee = function(e3, t3) {
            var r3 = -1, n3 = e3.length;
            for(t3 || (t3 = Array(n3)); ++r3 < n3;)t3[r3] = e3[r3];
            return t3;
        }, Oe = Object.create, Fe = /* @__PURE__ */ function() {
            function e3() {}
            return function(t3) {
                if (!T2(t3)) return {};
                if (Oe) return Oe(t3);
                e3.prototype = t3;
                var r3 = new e3();
                return e3.prototype = void 0, r3;
            };
        }();
        var Ce = function(e3, t3) {
            return function(r3) {
                return e3(t3(r3));
            };
        }, ke = Ce(Object.getPrototypeOf, Object), Ie = Object.prototype;
        var Te = function(e3) {
            var t3 = e3 && e3.constructor;
            return e3 === ("function" == typeof t3 && t3.prototype || Ie);
        };
        var Le = function(e3) {
            return "function" != typeof e3.constructor || Te(e3) ? {} : Fe(ke(e3));
        };
        var Pe = function(e3) {
            return null != e3 && "object" == typeof e3;
        };
        var xe = function(e3) {
            return Pe(e3) && "[object Arguments]" == I2(e3);
        }, Me = Object.prototype, $e = Me.hasOwnProperty, Re = Me.propertyIsEnumerable, Ne = xe(/* @__PURE__ */ function() {
            return arguments;
        }()) ? xe : function(e3) {
            return Pe(e3) && $e.call(e3, "callee") && !Re.call(e3, "callee");
        }, Ue = Array.isArray;
        var qe = function(e3) {
            return "number" == typeof e3 && e3 > -1 && e3 % 1 == 0 && e3 <= 9007199254740991;
        };
        var ze = function(e3) {
            return null != e3 && qe(e3.length) && !P2(e3);
        };
        var Je = function(e3) {
            return Pe(e3) && ze(e3);
        };
        var He = function() {
            return false;
        }, Ke = m2(function(e3, t3) {
            var r3 = t3 && !t3.nodeType && t3, n3 = r3 && e3 && !e3.nodeType && e3, i2 = n3 && n3.exports === r3 ? _2.Buffer : void 0, o3 = (i2 ? i2.isBuffer : void 0) || He;
            e3.exports = o3;
        }), We = Function.prototype, Ve = Object.prototype, Ge = We.toString, Qe = Ve.hasOwnProperty, Ye = Ge.call(Object);
        var Xe = function(e3) {
            if (!Pe(e3) || "[object Object]" != I2(e3)) return false;
            var t3 = ke(e3);
            if (null === t3) return true;
            var r3 = Qe.call(t3, "constructor") && t3.constructor;
            return "function" == typeof r3 && r3 instanceof r3 && Ge.call(r3) == Ye;
        }, Ze = {};
        Ze["[object Float32Array]"] = Ze["[object Float64Array]"] = Ze["[object Int8Array]"] = Ze["[object Int16Array]"] = Ze["[object Int32Array]"] = Ze["[object Uint8Array]"] = Ze["[object Uint8ClampedArray]"] = Ze["[object Uint16Array]"] = Ze["[object Uint32Array]"] = true, Ze["[object Arguments]"] = Ze["[object Array]"] = Ze["[object ArrayBuffer]"] = Ze["[object Boolean]"] = Ze["[object DataView]"] = Ze["[object Date]"] = Ze["[object Error]"] = Ze["[object Function]"] = Ze["[object Map]"] = Ze["[object Number]"] = Ze["[object Object]"] = Ze["[object RegExp]"] = Ze["[object Set]"] = Ze["[object String]"] = Ze["[object WeakMap]"] = false;
        var et = function(e3) {
            return Pe(e3) && qe(e3.length) && !!Ze[I2(e3)];
        };
        var tt = function(e3) {
            return function(t3) {
                return e3(t3);
            };
        }, rt = m2(function(e3, t3) {
            var r3 = t3 && !t3.nodeType && t3, n3 = r3 && e3 && !e3.nodeType && e3, i2 = n3 && n3.exports === r3 && w2.process, o3 = function() {
                try {
                    var e4 = n3 && n3.require && n3.require("util").types;
                    return e4 || i2 && i2.binding && i2.binding("util");
                } catch (e5) {}
            }();
            e3.exports = o3;
        }), nt = rt && rt.isTypedArray, it = nt ? tt(nt) : et;
        var ot = function(e3, t3) {
            if (("constructor" !== t3 || "function" != typeof e3[t3]) && "__proto__" != t3) return e3[t3];
        }, st = Object.prototype.hasOwnProperty;
        var at = function(e3, t3, r3) {
            var n3 = e3[t3];
            st.call(e3, t3) && i(n3, r3) && (void 0 !== r3 || t3 in e3) || we(e3, t3, r3);
        };
        var ut = function(e3, t3, r3, n3) {
            var i2 = !r3;
            r3 || (r3 = {});
            for(var o3 = -1, s3 = t3.length; ++o3 < s3;){
                var a3 = t3[o3], u3 = void 0;
                void 0 === u3 && (u3 = e3[a3]), i2 ? we(r3, a3, u3) : at(r3, a3, u3);
            }
            return r3;
        };
        var ct = function(e3, t3) {
            for(var r3 = -1, n3 = Array(e3); ++r3 < e3;)n3[r3] = t3(r3);
            return n3;
        }, lt = /^(?:0|[1-9]\d*)$/;
        var ht = function(e3, t3) {
            var r3 = typeof e3;
            return !!(t3 = null == t3 ? 9007199254740991 : t3) && ("number" == r3 || "symbol" != r3 && lt.test(e3)) && e3 > -1 && e3 % 1 == 0 && e3 < t3;
        };
        var ft = function(e3, t3) {
            var r3 = Ue(e3), n3 = !r3 && Ne(e3), i2 = !r3 && !n3 && Ke(e3), o3 = !r3 && !n3 && !i2 && it(e3), s3 = r3 || n3 || i2 || o3, a3 = s3 ? ct(e3.length, String) : [], u3 = a3.length;
            for(var c3 in e3)s3 && ("length" == c3 || i2 && ("offset" == c3 || "parent" == c3) || o3 && ("buffer" == c3 || "byteLength" == c3 || "byteOffset" == c3) || ht(c3, u3)) || a3.push(c3);
            return a3;
        };
        var vt = function(e3) {
            var t3 = [];
            if (null != e3) for(var r3 in Object(e3))t3.push(r3);
            return t3;
        }, pt = Object.prototype.hasOwnProperty;
        var yt = function(e3) {
            if (!T2(e3)) return vt(e3);
            var t3 = Te(e3), r3 = [];
            for(var n3 in e3)("constructor" != n3 || !t3 && pt.call(e3, n3)) && r3.push(n3);
            return r3;
        };
        var gt = function(e3) {
            return ze(e3) ? ft(e3) : yt(e3);
        };
        var bt = function(e3) {
            return ut(e3, gt(e3));
        };
        var mt = function(e3, t3, r3, n3, i2, o3, s3) {
            var a3 = ot(e3, r3), u3 = ot(t3, r3), c3 = s3.get(u3);
            if (c3) De(e3, r3, c3);
            else {
                var l3 = void 0, h3 = void 0 === l3;
                if (h3) {
                    var d3 = Ue(u3), f3 = !d3 && Ke(u3), v3 = !d3 && !f3 && it(u3);
                    l3 = u3, d3 || f3 || v3 ? Ue(a3) ? l3 = a3 : Je(a3) ? l3 = Ee(a3) : f3 ? (h3 = false, l3 = Ae(u3, true)) : v3 ? (h3 = false, l3 = Se(u3, true)) : l3 = [] : Xe(u3) || Ne(u3) ? (l3 = a3, Ne(a3) ? l3 = bt(a3) : T2(a3) && !P2(a3) || (l3 = Le(u3))) : h3 = false;
                }
                h3 && (s3.set(u3, l3), i2(l3, u3, n3, o3, s3), s3.delete(u3)), De(e3, r3, l3);
            }
        };
        var wt = function e3(t3, r3, n3, i2, o3) {
            t3 !== r3 && _e(r3, function(s3, a3) {
                if (o3 || (o3 = new be()), T2(s3)) mt(t3, r3, a3, n3, e3, i2, o3);
                else {
                    var u3 = void 0;
                    void 0 === u3 && (u3 = s3), De(t3, a3, u3);
                }
            }, gt);
        };
        var Dt = function(e3) {
            return e3;
        };
        var _t = function(e3, t3, r3) {
            switch(r3.length){
                case 0:
                    return e3.call(t3);
                case 1:
                    return e3.call(t3, r3[0]);
                case 2:
                    return e3.call(t3, r3[0], r3[1]);
                case 3:
                    return e3.call(t3, r3[0], r3[1], r3[2]);
            }
            return e3.apply(t3, r3);
        }, At = Math.max;
        var jt = function(e3, t3, r3) {
            return t3 = At(void 0 === t3 ? e3.length - 1 : t3, 0), function() {
                for(var n3 = arguments, i2 = -1, o3 = At(n3.length - t3, 0), s3 = Array(o3); ++i2 < o3;)s3[i2] = n3[t3 + i2];
                i2 = -1;
                for(var a3 = Array(t3 + 1); ++i2 < t3;)a3[i2] = n3[i2];
                return a3[t3] = r3(s3), _t(e3, this, a3);
            };
        };
        var Bt = function(e3) {
            return function() {
                return e3;
            };
        }, St = me ? function(e3, t3) {
            return me(e3, "toString", {
                configurable: true,
                enumerable: false,
                value: Bt(t3),
                writable: true
            });
        } : Dt, Et = Date.now;
        var Ot = /* @__PURE__ */ function(e3) {
            var t3 = 0, r3 = 0;
            return function() {
                var n3 = Et(), i2 = 16 - (n3 - r3);
                if (r3 = n3, i2 > 0) {
                    if (++t3 >= 800) return arguments[0];
                } else t3 = 0;
                return e3.apply(void 0, arguments);
            };
        }(St);
        var Ft = function(e3, t3) {
            return Ot(jt(e3, t3, Dt), e3 + "");
        };
        var Ct = function(e3, t3, r3) {
            if (!T2(r3)) return false;
            var n3 = typeof t3;
            return !!("number" == n3 ? ze(r3) && ht(t3, r3.length) : "string" == n3 && t3 in r3) && i(r3[t3], e3);
        };
        var kt = function(e3) {
            return Ft(function(t3, r3) {
                var n3 = -1, i2 = r3.length, o3 = i2 > 1 ? r3[i2 - 1] : void 0, s3 = i2 > 2 ? r3[2] : void 0;
                for(o3 = e3.length > 3 && "function" == typeof o3 ? (i2--, o3) : void 0, s3 && Ct(r3[0], r3[1], s3) && (o3 = i2 < 3 ? void 0 : o3, i2 = 1), t3 = Object(t3); ++n3 < i2;){
                    var a3 = r3[n3];
                    a3 && e3(t3, a3, n3, o3);
                }
                return t3;
            });
        }(function(e3, t3, r3) {
            wt(e3, t3, r3);
        });
        var It = function(e3, t3) {
            for(var r3 = -1, n3 = null == e3 ? 0 : e3.length, i2 = Array(n3); ++r3 < n3;)i2[r3] = t3(e3[r3], r3, e3);
            return i2;
        };
        var Tt = function(e3, t3) {
            for(var r3 = -1, n3 = null == e3 ? 0 : e3.length; ++r3 < n3 && false !== t3(e3[r3], r3, e3););
            return e3;
        };
        var Nt = function(e3, t3) {
            for(var r3 = -1, n3 = null == e3 ? 0 : e3.length, i2 = 0, o3 = []; ++r3 < n3;){
                var s3 = e3[r3];
                t3(s3, r3, e3) && (o3[i2++] = s3);
            }
            return o3;
        };
        var Ut = function() {
            return [];
        }, qt = Object.prototype.propertyIsEnumerable, zt = Object.getOwnPropertySymbols, Jt = zt ? function(e3) {
            return null == e3 ? [] : (e3 = Object(e3), Nt(zt(e3), function(t3) {
                return qt.call(e3, t3);
            }));
        } : Ut;
        var Kt = function(e3, t3) {
            for(var r3 = -1, n3 = t3.length, i2 = e3.length; ++r3 < n3;)e3[i2 + r3] = t3[r3];
            return e3;
        }, Wt = Object.getOwnPropertySymbols ? function(e3) {
            for(var t3 = []; e3;)Kt(t3, Jt(e3)), e3 = ke(e3);
            return t3;
        } : Ut;
        var Gt = function(e3, t3, r3) {
            var n3 = t3(e3);
            return Ue(e3) ? n3 : Kt(n3, r3(e3));
        };
        var Yt = function(e3) {
            return Gt(e3, gt, Wt);
        }, Xt = G2(_2, "DataView"), Zt = G2(_2, "Promise"), er = G2(_2, "Set"), tr = G2(_2, "WeakMap"), rr = N(Xt), nr = N(Q2), ir = N(Zt), or2 = N(er), sr = N(tr), ar = I2;
        (Xt && "[object DataView]" != ar(new Xt(new ArrayBuffer(1))) || Q2 && "[object Map]" != ar(new Q2()) || Zt && "[object Promise]" != ar(Zt.resolve()) || er && "[object Set]" != ar(new er()) || tr && "[object WeakMap]" != ar(new tr())) && (ar = function(e3) {
            var t3 = I2(e3), r3 = "[object Object]" == t3 ? e3.constructor : void 0, n3 = r3 ? N(r3) : "";
            if (n3) switch(n3){
                case rr:
                    return "[object DataView]";
                case nr:
                    return "[object Map]";
                case ir:
                    return "[object Promise]";
                case or2:
                    return "[object Set]";
                case sr:
                    return "[object WeakMap]";
            }
            return t3;
        });
        var ur = ar, cr = Object.prototype.hasOwnProperty;
        var lr = function(e3) {
            var t3 = e3.length, r3 = new e3.constructor(t3);
            return t3 && "string" == typeof e3[0] && cr.call(e3, "index") && (r3.index = e3.index, r3.input = e3.input), r3;
        };
        var hr = function(e3, t3) {
            var r3 = Be(e3.buffer);
            return new e3.constructor(r3, e3.byteOffset, e3.byteLength);
        }, dr = /\w*$/;
        var fr = function(e3) {
            var t3 = new e3.constructor(e3.source, dr.exec(e3));
            return t3.lastIndex = e3.lastIndex, t3;
        }, vr = A2 ? A2.prototype : void 0, pr = vr ? vr.valueOf : void 0;
        var yr = function(e3) {
            return pr ? Object(pr.call(e3)) : {};
        };
        var gr = function(e3, t3, r3) {
            var n3 = e3.constructor;
            switch(t3){
                case "[object ArrayBuffer]":
                    return Be(e3);
                case "[object Boolean]":
                case "[object Date]":
                    return new n3(+e3);
                case "[object DataView]":
                    return hr(e3);
                case "[object Float32Array]":
                case "[object Float64Array]":
                case "[object Int8Array]":
                case "[object Int16Array]":
                case "[object Int32Array]":
                case "[object Uint8Array]":
                case "[object Uint8ClampedArray]":
                case "[object Uint16Array]":
                case "[object Uint32Array]":
                    return Se(e3, r3);
                case "[object Map]":
                    return new n3();
                case "[object Number]":
                case "[object String]":
                    return new n3(e3);
                case "[object RegExp]":
                    return fr(e3);
                case "[object Set]":
                    return new n3();
                case "[object Symbol]":
                    return yr(e3);
            }
        };
        var br = function(e3) {
            return Pe(e3) && "[object Map]" == ur(e3);
        }, mr = rt && rt.isMap, wr = mr ? tt(mr) : br;
        var Dr = function(e3) {
            return Pe(e3) && "[object Set]" == ur(e3);
        }, _r = rt && rt.isSet, Ar = _r ? tt(_r) : Dr, jr = {};
        jr["[object Arguments]"] = jr["[object Array]"] = jr["[object ArrayBuffer]"] = jr["[object DataView]"] = jr["[object Boolean]"] = jr["[object Date]"] = jr["[object Float32Array]"] = jr["[object Float64Array]"] = jr["[object Int8Array]"] = jr["[object Int16Array]"] = jr["[object Int32Array]"] = jr["[object Map]"] = jr["[object Number]"] = jr["[object Object]"] = jr["[object RegExp]"] = jr["[object Set]"] = jr["[object String]"] = jr["[object Symbol]"] = jr["[object Uint8Array]"] = jr["[object Uint8ClampedArray]"] = jr["[object Uint16Array]"] = jr["[object Uint32Array]"] = true, jr["[object Error]"] = jr["[object Function]"] = jr["[object WeakMap]"] = false;
        var Br = function e3(t3, r3, n3, i2, o3, s3) {
            var a3, u3 = 1 & r3;
            if (n3 && (a3 = o3 ? n3(t3, i2, o3, s3) : n3(t3)), void 0 !== a3) return a3;
            if (!T2(t3)) return t3;
            var h3 = Ue(t3);
            if (h3) a3 = lr(t3);
            else {
                var d3 = ur(t3), f3 = "[object Function]" == d3 || "[object GeneratorFunction]" == d3;
                if (Ke(t3)) return Ae(t3, u3);
                if ("[object Object]" == d3 || "[object Arguments]" == d3 || f3 && !o3) a3 = {};
                else {
                    if (!jr[d3]) return o3 ? t3 : {};
                    a3 = gr(t3, d3, u3);
                }
            }
            s3 || (s3 = new be());
            var v3 = s3.get(t3);
            if (v3) return v3;
            s3.set(t3, a3), Ar(t3) ? t3.forEach(function(i3) {
                a3.add(e3(i3, r3, n3, i3, t3, s3));
            }) : wr(t3) && t3.forEach(function(i3, o4) {
                a3.set(o4, e3(i3, r3, n3, o4, t3, s3));
            });
            var p3 = h3 ? void 0 : Yt(t3);
            return Tt(p3 || t3, function(i3, o4) {
                p3 && (i3 = t3[o4 = i3]), at(a3, o4, e3(i3, r3, n3, o4, t3, s3));
            }), a3;
        };
        var Sr = function(e3) {
            return "symbol" == typeof e3 || Pe(e3) && "[object Symbol]" == I2(e3);
        }, Er = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Or = /^\w*$/;
        var Fr = function(e3, t3) {
            if (Ue(e3)) return false;
            var r3 = typeof e3;
            return !("number" != r3 && "symbol" != r3 && "boolean" != r3 && null != e3 && !Sr(e3)) || Or.test(e3) || !Er.test(e3) || null != t3 && e3 in Object(t3);
        };
        function Cr(e3, t3) {
            if ("function" != typeof e3 || null != t3 && "function" != typeof t3) throw new TypeError("Expected a function");
            var r3 = function() {
                var n3 = arguments, i2 = t3 ? t3.apply(this, n3) : n3[0], o3 = r3.cache;
                if (o3.has(i2)) return o3.get(i2);
                var s3 = e3.apply(this, n3);
                return r3.cache = o3.set(i2, s3) || o3, s3;
            };
            return r3.cache = new (Cr.Cache || pe)(), r3;
        }
        Cr.Cache = pe;
        var kr = Cr;
        var Ir = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Tr = /\\(\\)?/g, Lr = function(e3) {
            var t3 = kr(e3, function(e4) {
                return 500 === r3.size && r3.clear(), e4;
            }), r3 = t3.cache;
            return t3;
        }(function(e3) {
            var t3 = [];
            return 46 === e3.charCodeAt(0) && t3.push(""), e3.replace(Ir, function(e4, r3, n3, i2) {
                t3.push(n3 ? i2.replace(Tr, "$1") : r3 || e4);
            }), t3;
        }), Pr = A2 ? A2.prototype : void 0, xr = Pr ? Pr.toString : void 0;
        var Mr = function e3(t3) {
            if ("string" == typeof t3) return t3;
            if (Ue(t3)) return It(t3, e3) + "";
            if (Sr(t3)) return xr ? xr.call(t3) : "";
            var r3 = t3 + "";
            return "0" == r3 && 1 / t3 == -1 / 0 ? "-0" : r3;
        };
        var $r = function(e3) {
            return null == e3 ? "" : Mr(e3);
        };
        var Rr = function(e3, t3) {
            return Ue(e3) ? e3 : Fr(e3, t3) ? [
                e3
            ] : Lr($r(e3));
        };
        var Nr = function(e3) {
            var t3 = null == e3 ? 0 : e3.length;
            return t3 ? e3[t3 - 1] : void 0;
        };
        var Ur = function(e3) {
            if ("string" == typeof e3 || Sr(e3)) return e3;
            var t3 = e3 + "";
            return "0" == t3 && 1 / e3 == -1 / 0 ? "-0" : t3;
        };
        var qr = function(e3, t3) {
            for(var r3 = 0, n3 = (t3 = Rr(t3, e3)).length; null != e3 && r3 < n3;)e3 = e3[Ur(t3[r3++])];
            return r3 && r3 == n3 ? e3 : void 0;
        };
        var zr = function(e3, t3, r3) {
            var n3 = -1, i2 = e3.length;
            t3 < 0 && (t3 = -t3 > i2 ? 0 : i2 + t3), (r3 = r3 > i2 ? i2 : r3) < 0 && (r3 += i2), i2 = t3 > r3 ? 0 : r3 - t3 >>> 0, t3 >>>= 0;
            for(var o3 = Array(i2); ++n3 < i2;)o3[n3] = e3[n3 + t3];
            return o3;
        };
        var Jr = function(e3, t3) {
            return t3.length < 2 ? e3 : qr(e3, zr(t3, 0, -1));
        };
        var Hr = function(e3, t3) {
            return t3 = Rr(t3, e3), null == (e3 = Jr(e3, t3)) || delete e3[Ur(Nr(t3))];
        };
        var Kr = function(e3) {
            return Xe(e3) ? void 0 : e3;
        }, Wr = A2 ? A2.isConcatSpreadable : void 0;
        var Vr = function(e3) {
            return Ue(e3) || Ne(e3) || !!(Wr && e3 && e3[Wr]);
        };
        var Gr = function e3(t3, r3, n3, i2, o3) {
            var s3 = -1, a3 = t3.length;
            for(n3 || (n3 = Vr), o3 || (o3 = []); ++s3 < a3;){
                var u3 = t3[s3];
                n3(u3) ? Kt(o3, u3) : o3[o3.length] = u3;
            }
            return o3;
        };
        var Qr = function(e3) {
            return (null == e3 ? 0 : e3.length) ? Gr(e3) : [];
        };
        var Yr = function(e3) {
            return Ot(jt(e3, void 0, Qr), e3 + "");
        }(function(e3, t3) {
            var r3 = {};
            if (null == e3) return r3;
            var n3 = false;
            t3 = It(t3, function(t4) {
                return t4 = Rr(t4, e3), n3 || (n3 = t4.length > 1), t4;
            }), ut(e3, Yt(e3), r3), n3 && (r3 = Br(r3, 7, Kr));
            for(var i2 = t3.length; i2--;)Hr(r3, t3[i2]);
            return r3;
        });
        class Xr {
            constructor(e3 = "", t3 = ""){
                this.userId = e3, this.surveyId = t3;
                try {
                    this.storage = window.localStorage;
                } catch (e4) {
                    this.storage = {};
                }
            }
            checkLocalStorageEnabled() {
                try {
                    return !!window.localStorage;
                } catch (e3) {
                    return false;
                }
            }
            set(e3, t3) {
                const r3 = this.getExpandedKey(e3);
                try {
                    this.storage[r3] = JSON.stringify(t3);
                } catch (e4) {}
            }
            get(e3) {
                const t3 = this.getExpandedKey(e3);
                try {
                    return JSON.parse(this.storage[t3]);
                } catch (e4) {
                    return null;
                }
            }
            getExpandedKey(e3) {
                return [
                    this.surveyId,
                    "feedback",
                    this.userId,
                    e3
                ].filter(Boolean).join(":");
            }
        }
        function Zr(e3) {
            if (null === e3 || true === e3 || false === e3) return NaN;
            var t3 = Number(e3);
            return isNaN(t3) ? t3 : t3 < 0 ? Math.ceil(t3) : Math.floor(t3);
        }
        function en2(e3, t3) {
            if (t3.length < e3) throw new TypeError(e3 + " argument" + (e3 > 1 ? "s" : "") + " required, but only " + t3.length + " present");
        }
        function tn2(e3) {
            return (tn2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
                return typeof e4;
            } : function(e4) {
                return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
            })(e3);
        }
        function rn2(e3) {
            en2(1, arguments);
            var t3 = Object.prototype.toString.call(e3);
            return e3 instanceof Date || "object" === tn2(e3) && "[object Date]" === t3 ? new Date(e3.getTime()) : "number" == typeof e3 || "[object Number]" === t3 ? new Date(e3) : ("string" != typeof e3 && "[object String]" !== t3 || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
        }
        class nn2 {
            constructor(e3, t3){
                this.window = e3, this.origin = t3, this.messageHandlers = [];
            }
            send(e3, t3) {
                const r3 = {
                    type: "feedback-evt",
                    action: e3,
                    params: t3
                };
                this.window.postMessage(r3, this.origin);
            }
            addActionHandler(e3, t3) {
                const r3 = this.createMessageHandler(e3, t3);
                window.addEventListener("message", r3), this.messageHandlers.push(r3);
            }
            clearActionHandlers() {
                this.messageHandlers.forEach((e3)=>{
                    window.removeEventListener("message", e3);
                });
            }
            createMessageHandler(e3, t3) {
                return (r3)=>{
                    const { origin: n3, source: i2, data: o3 } = r3;
                    n3 === this.origin && i2 === this.window && o3 && "feedback-evt" === o3.type && o3.action === e3 && t3(o3);
                };
            }
        }
        var on2 = m2(function(e3) {
            /*!
           * js-logger - http://github.com/jonnyreeves/js-logger
           * Jonny Reeves, http://jonnyreeves.co.uk/
           * js-logger may be freely distributed under the MIT license.
           */ !function(t3) {
                var r3, n3 = {};
                n3.VERSION = "1.6.1";
                var i2 = {}, o3 = function(e4, t4) {
                    return function() {
                        return t4.apply(e4, arguments);
                    };
                }, s3 = function() {
                    var e4, t4, r4 = arguments, n4 = r4[0];
                    for(t4 = 1; t4 < r4.length; t4++)for(e4 in r4[t4])!(e4 in n4) && r4[t4].hasOwnProperty(e4) && (n4[e4] = r4[t4][e4]);
                    return n4;
                }, a3 = function(e4, t4) {
                    return {
                        value: e4,
                        name: t4
                    };
                };
                n3.TRACE = a3(1, "TRACE"), n3.DEBUG = a3(2, "DEBUG"), n3.INFO = a3(3, "INFO"), n3.TIME = a3(4, "TIME"), n3.WARN = a3(5, "WARN"), n3.ERROR = a3(8, "ERROR"), n3.OFF = a3(99, "OFF");
                var u3 = function(e4) {
                    this.context = e4, this.setLevel(e4.filterLevel), this.log = this.info;
                };
                u3.prototype = {
                    setLevel: function(e4) {
                        e4 && "value" in e4 && (this.context.filterLevel = e4);
                    },
                    getLevel: function() {
                        return this.context.filterLevel;
                    },
                    enabledFor: function(e4) {
                        var t4 = this.context.filterLevel;
                        return e4.value >= t4.value;
                    },
                    trace: function() {
                        this.invoke(n3.TRACE, arguments);
                    },
                    debug: function() {
                        this.invoke(n3.DEBUG, arguments);
                    },
                    info: function() {
                        this.invoke(n3.INFO, arguments);
                    },
                    warn: function() {
                        this.invoke(n3.WARN, arguments);
                    },
                    error: function() {
                        this.invoke(n3.ERROR, arguments);
                    },
                    time: function(e4) {
                        "string" == typeof e4 && e4.length > 0 && this.invoke(n3.TIME, [
                            e4,
                            "start"
                        ]);
                    },
                    timeEnd: function(e4) {
                        "string" == typeof e4 && e4.length > 0 && this.invoke(n3.TIME, [
                            e4,
                            "end"
                        ]);
                    },
                    invoke: function(e4, t4) {
                        r3 && this.enabledFor(e4) && r3(t4, s3({
                            level: e4
                        }, this.context));
                    }
                };
                var c3, l3 = new u3({
                    filterLevel: n3.OFF
                });
                (c3 = n3).enabledFor = o3(l3, l3.enabledFor), c3.trace = o3(l3, l3.trace), c3.debug = o3(l3, l3.debug), c3.time = o3(l3, l3.time), c3.timeEnd = o3(l3, l3.timeEnd), c3.info = o3(l3, l3.info), c3.warn = o3(l3, l3.warn), c3.error = o3(l3, l3.error), c3.log = c3.info, n3.setHandler = function(e4) {
                    r3 = e4;
                }, n3.setLevel = function(e4) {
                    for(var t4 in l3.setLevel(e4), i2)i2.hasOwnProperty(t4) && i2[t4].setLevel(e4);
                }, n3.getLevel = function() {
                    return l3.getLevel();
                }, n3.get = function(e4) {
                    return i2[e4] || (i2[e4] = new u3(s3({
                        name: e4
                    }, l3.context)));
                }, n3.createDefaultHandler = function(e4) {
                    (e4 = e4 || {}).formatter = e4.formatter || function(e5, t5) {
                        t5.name && e5.unshift("[" + t5.name + "]");
                    };
                    var t4 = {}, r4 = function(e5, t5) {
                        Function.prototype.apply.call(e5, console, t5);
                    };
                    return "undefined" == typeof console ? function() {} : function(i3, o4) {
                        i3 = Array.prototype.slice.call(i3);
                        var s4, a4 = console.log;
                        o4.level === n3.TIME ? (s4 = (o4.name ? "[" + o4.name + "] " : "") + i3[0], "start" === i3[1] ? console.time ? console.time(s4) : t4[s4] = /* @__PURE__ */ new Date().getTime() : console.timeEnd ? console.timeEnd(s4) : r4(a4, [
                            s4 + ": " + (/* @__PURE__ */ new Date().getTime() - t4[s4]) + "ms"
                        ])) : (o4.level === n3.WARN && console.warn ? a4 = console.warn : o4.level === n3.ERROR && console.error ? a4 = console.error : o4.level === n3.INFO && console.info ? a4 = console.info : o4.level === n3.DEBUG && console.debug ? a4 = console.debug : o4.level === n3.TRACE && console.trace && (a4 = console.trace), e4.formatter(i3, o4), r4(a4, i3));
                    };
                }, n3.useDefaults = function(e4) {
                    n3.setLevel(e4 && e4.defaultLevel || n3.DEBUG), n3.setHandler(n3.createDefaultHandler(e4));
                }, n3.setDefaults = n3.useDefaults, e3.exports ? e3.exports = n3 : (n3._prevLogger = t3.Logger, n3.noConflict = function() {
                    return t3.Logger = n3._prevLogger, n3;
                }, t3.Logger = n3);
            }(g2);
        });
        let sn = 200, an2 = 10;
        const un2 = {
            updates: [
                []
            ],
            triggers: [],
            constructs: []
        };
        let cn2 = false, ln = null;
        const hn = (e3)=>e3 < 10 ? "0" + e3 : e3, dn = ()=>{
            const e3 = /* @__PURE__ */ new Date();
            return `${hn(e3.getDate())}.${hn(e3.getMonth() + 1)}.${e3.getFullYear()} ${hn(e3.getHours())}:${hn(e3.getMinutes())}:${hn(e3.getSeconds())}`;
        }, fn2 = on2.createDefaultHandler({
            formatter (e3) {
                e3.unshift(dn(), "-");
            }
        });
        on2.setHandler((e3, t3)=>{
            const r3 = Array.prototype.slice.call(e3);
            ((e4, t4)=>{
                t4.name && e4.unshift(`[${t4.name}]`), e4.unshift("" + t4.level.name), "EventsLogger" === t4.name ? (un2.triggers.push([
                    dn(),
                    ...e4
                ]), un2.triggers.splice(0, un2.triggers.length - sn)) : e4[e4.length - 1].includes("constructor") ? un2.constructs.push([
                    dn(),
                    ...e4
                ]) : (un2.updates[un2.updates.length - 1].push([
                    dn(),
                    ...e4
                ]), un2.updates.splice(0, un2.updates.length - an2));
            })(r3, t3), cn2 && fn2(r3, t3), null == ln || ln(r3, t3);
        });
        var vn = {
            toConsole () {
                cn2 = true;
            },
            get: (e3)=>on2.get(e3),
            setMaxStackLength (e3) {
                e3.triggers && (sn = e3.triggers), e3.updates && (an2 = e3.updates);
            },
            processLoggerOptions (e3) {
                "OFF" !== (null == e3 ? void 0 : e3.logLevel) ? ((null == e3 ? void 0 : e3.logLevel) || on2.setLevel(on2.INFO), (null == e3 ? void 0 : e3.disableLogToWindow) || (window.FEEDBACK_LOG = un2), e3 && (e3.logLevel && on2.setLevel(on2[e3.logLevel]), e3.consoleLog && (cn2 = true), e3.onLog && (ln = e3.onLog), e3.maxStackLength && this.setMaxStackLength(e3.maxStackLength))) : on2.setLevel(on2.OFF);
            },
            getStack: ()=>un2,
            addUpdate: ()=>un2.updates.push([])
        };
        const pn = (e3)=>e3 ? "\u2705 \u041F\u0440\u043E\u0448\u043B\u0430" : "\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430", yn = vn.get("FrameLoader");
        class gn {
            constructor(e3, t3 = {}){
                this.surveyId = e3, this.frame = null, this.postMessage = null, this.fullLoadTimeout = null, this.handleCloseMessage = ()=>{
                    this.close();
                }, this.handleSetSizeMessage = (e4)=>{
                    const { params: t4 } = e4, { width: r3, height: n3 } = t4 || {};
                    "number" == typeof r3 && "number" == typeof n3 && this.setSize(r3, n3);
                }, this.handleAppLoadedMessage = ()=>{
                    this.frame && (this.frame.style.visibility = "visible");
                }, this.handleSubmitMessage = ()=>{
                    const { successHideTimeout: e4, forTestHideAfterSuccessHideTimeout: t4 } = this.options;
                    e4 && setTimeout(()=>{
                        this.hideIframe(), t4 ? setTimeout(()=>{
                            this.close();
                        }, t4) : this.close();
                    }, e4);
                }, this.handleSurveyLoaded = ()=>{
                    const { animation: e4 } = this.options;
                    this.frame && e4 && (this.fullLoadTimeout && (clearTimeout(this.fullLoadTimeout), this.fullLoadTimeout = null), this.frame.style.transform = "translate(0)");
                }, this.options = kt({}, t3);
            }
            open() {
                var e3, t3;
                if (this.frame) return;
                const r3 = this.createSrc(), { styles: n3 = {}, testId: i2 = "csat", rootElement: o3 } = this.options;
                this.frame = document.createElement("iframe"), this.frame.src = r3, this.frame.width = "320px", this.frame.height = "120px", this.frame.dataset.testId = i2, this.frame.style.border = "none", this.frame.style.display = "block", this.frame.style.position = "fixed", this.frame.style.zIndex = "500", this.frame.style.bottom = "8px", this.frame.style.left = "8px", this.frame.style.borderRadius = "var(--vkui--size_border_radius_promo--regular, 20px)", this.frame.style.boxShadow = "var(--vkui--elevation2, 0 4px 32px 0 rgba(0, 16, 61, 0.32))", this.hideIframe(), this.setAnimationStyles(), Object.keys(n3).forEach((e4)=>{
                    const t4 = n3[e4];
                    t4 && this.frame && (this.frame.style[e4] = t4);
                }), yn.warn("\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C \u043E\u043F\u0440\u043E\u0441. Add survey iframe with host: " + r3), o3 ? o3.appendChild(this.frame) : null === (t3 = null === (e3 = window.document) || void 0 === e3 ? void 0 : e3.body) || void 0 === t3 || t3.appendChild(this.frame), this.frame.contentWindow && (this.postMessage = new nn2(this.frame.contentWindow, this.getFrameOrigin()), this.postMessage.addActionHandler("close", this.handleCloseMessage), this.postMessage.addActionHandler("setSize", this.handleSetSizeMessage), this.postMessage.addActionHandler("appLoaded", this.handleAppLoadedMessage), this.postMessage.addActionHandler("submit", this.handleSubmitMessage), this.postMessage.addActionHandler("surveyLoaded", this.handleSurveyLoaded));
            }
            setDarkTheme(e3) {
                var t3;
                this.options.darkTheme = e3, null === (t3 = this.postMessage) || void 0 === t3 || t3.send("setTheme", {
                    darkMode: e3
                });
            }
            close() {
                var e3, t3, r3, n3;
                null === (e3 = this.postMessage) || void 0 === e3 || e3.clearActionHandlers(), this.postMessage = null, null === (t3 = this.frame) || void 0 === t3 || t3.remove(), this.frame = null, null === (n3 = (r3 = this.options).onClose) || void 0 === n3 || n3.call(r3);
            }
            createSrc() {
                const e3 = new URL(this.getFrameOrigin()), { email: t3, clientId: r3, project: n3, darkTheme: i2, internal: o3, theme: s3, locale: a3 } = this.options;
                return e3.pathname = "feedback/nps", e3.searchParams.append("id", String(this.surveyId)), e3.searchParams.append("mode", "popup"), e3.searchParams.append("type", "csat"), e3.searchParams.append("origin", location.origin), e3.searchParams.append("darkTheme", i2 ? "1" : "0"), e3.searchParams.append("csatV2", "1"), t3 && e3.searchParams.append("email", t3), r3 && e3.searchParams.append("clientId", r3), n3 && e3.searchParams.append("project", n3), o3 && e3.searchParams.append("internal", "1"), s3 && e3.searchParams.append("theme", s3), a3 && e3.searchParams.append("locale", a3), e3.toString();
            }
            getFrameOrigin() {
                return "https://" + (this.options.domain || "e.mail.ru");
            }
            setSize(e3, t3) {
                this.frame && (this.frame.width = e3 + "px", this.frame.height = t3 + "px");
            }
            setAnimationStyles() {
                const { animation: e3 } = this.options;
                if (this.frame && e3) {
                    const { direction: t3 = "left", gap: r3 = "16px", duration: n3 = "0.25s" } = e3;
                    switch(this.frame.style.transition = `transform ${n3} ease 0s`, t3){
                        case "top":
                            this.frame.style.transform = `translateY(calc(-100% - ${r3}))`;
                            break;
                        case "right":
                            this.frame.style.transform = `translateX(calc(100% + ${r3}))`;
                            break;
                        case "bottom":
                            this.frame.style.transform = `translateY(calc(100% + ${r3}))`;
                            break;
                        case "left":
                            this.frame.style.transform = `translateX(calc(-100% - ${r3}))`;
                    }
                    this.fullLoadTimeout = setTimeout(()=>this.handleSurveyLoaded(), 1e4);
                }
            }
            hideIframe() {
                this.frame && (this.frame.style.visibility = "hidden");
            }
        }
        var bn;
        !function(e3) {
            e3.Update = "feedback-loader_update", e3.PassJigurda = "feedback-loader_jigurda-pass", e3.ApiFetchLastVotedDateGroup = "feedback-loader_api-last-voted-date-group", e3.Show = "feedback-loader_show", e3.Close = "feedback-loader_close", e3.EnableDarkMode = "feedback-loader_set-dark_on", e3.DisableDarkMode = "feedback-loader_set-dark_off";
        }(bn || (bn = {}));
        var mn = bn;
        function wn() {
            const e3 = /* @__PURE__ */ new Date();
            return e3.setUTCHours(0, 0, 0, 0), e3.getTime();
        }
        function Dn(e3, t3) {
            return function(e4) {
                return wn() - 864e5 * e4;
            }(t3) >= e3;
        }
        const _n = vn.get("SurveyLoader");
        class An {
            constructor(e3, r3 = {}){
                this.activeShowDelay = null, this.activeTriggerTimer = null;
                const { frameLoaderOptions: n3, storage: i2 } = r3, o3 = t2(r3, [
                    "frameLoaderOptions",
                    "storage"
                ]), { email: s3, clientId: a3 } = o3;
                _n.info("constructor with params: " + JSON.stringify({
                    survey: e3,
                    options: Yr(r3, "frameLoaderOptions.rootElement")
                })), this.survey = e3, this.options = kt({
                    storage: i2
                }, o3), this.storage = new (i2 || Xr)(this.getUserId(), this.id), this.frameLoader = new gn(this.id, Object.assign(Object.assign({}, n3), {
                    email: s3,
                    clientId: a3,
                    internal: this.survey.internal
                }));
            }
            get id() {
                return this.survey.surveyId;
            }
            update(e3 = false) {
                var t3, n3, i2, o3;
                return r2(this, void 0, void 0, function*() {
                    if (e3) return _n.warn("\u2705 \u0418\u0433\u043D\u043E\u0440 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A (update, skipChecks) survey_id: " + this.survey.surveyId), yield this.show(), this.id;
                    if (!this.options.ignoreLocalStorageDisable && !new (this.options.storage || Xr)().checkLocalStorageEnabled()) return _n.warn("\u274C localStorage \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D (update, local_storage_disabled) survey_id: " + this.survey.surveyId), Promise.reject("local_storage_disabled");
                    const r3 = !!this.survey.repeatAfterDays || !!this.survey.showAfterDays;
                    return this.checkFeature() ? this.checkDelay() ? r3 && !this.checkLastShow() ? (_n.warn("\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0443 \u043C\u0435\u0436\u0434\u0443 \u043F\u043E\u043A\u0430\u0437\u0430\u043C\u0438 \u0432\u043D\u0435 \u043A\u0430\u0440\u0430\u043D\u0442\u0438\u043D\u0430 (update, last_show_check_fail) survey_id: " + this.survey.surveyId), Promise.reject("last_show_check_fail")) : this.checkTriggerEvents() ? (yield null === (n3 = (t3 = this.options).checkBeforeJigurda) || void 0 === n3 ? void 0 : n3.call(t3), this.sendRadar(mn.Update), this.checkJigurda() ? (this.sendRadar(mn.PassJigurda), this.options.dryRun ? (_n.warn("\u274C update, dry_run survey_id: " + this.survey.surveyId), Promise.reject("dry_run")) : (yield null === (o3 = (i2 = this.options).checkBeforeShow) || void 0 === o3 ? void 0 : o3.call(i2), yield this.show(), this.id)) : (_n.warn("\u274C \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 permille \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F (update, jigurda_check_fail) survey_id: " + this.survey.surveyId), Promise.reject("jigurda_check_fail"))) : (_n.warn("\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E \u0442\u0440\u0438\u0433\u0433\u0435\u0440\u0430\u043C (\u0442\u0440\u0438\u0433\u0433\u0435\u0440\u0430 \u043D\u0435 \u0431\u044B\u043B\u043E \u0438\u043B\u0438 \u0435\u0449\u0435 \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0430) (update, trigger_events_check_fail) survey_id: " + this.survey.surveyId), Promise.reject("trigger_events_check_fail")) : (_n.warn("\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u043E \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441 \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043E\u043F\u0440\u043E\u0441\u0430 (update, delay_check_fail) survey_id: " + this.survey.surveyId), Promise.reject("delay_check_fail")) : (_n.warn("\u274C \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0444\u0438\u0447\u0438 \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 (update, feature_check_fail) survey_id: " + this.survey.surveyId), Promise.reject("feature_check_fail"));
                });
            }
            close() {
                this.frameLoader.close(), this.sendRadar(mn.Close);
            }
            setDarkTheme(e3) {
                this.frameLoader.setDarkTheme(e3), this.sendRadar(e3 ? mn.EnableDarkMode : mn.DisableDarkMode);
            }
            checkLastShow(e3) {
                const { repeatAfterDays: t3, showAfterDays: r3 = t3 } = this.survey, n3 = null != e3 ? e3 : r3, i2 = this.storage.get("lastShow");
                if (!n3) return _n.info("\u274C \u0412 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043D\u0435\u0442 \u043D\u0438 showAfterDays, \u043D\u0438 repeatAfterDays \u0438\u043B\u0438 \u043E\u043D\u0438 \u0440\u0430\u0432\u043D\u044B 0 (checkLastShow no delay) survey_id: " + this.survey.surveyId), false;
                if (!i2) return _n.debug("\u2705 \u041E\u043F\u0440\u043E\u0441 \u043D\u0435 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u043B\u0441\u044F (checkLastShow no lastShow) survey_id: " + this.survey.surveyId), true;
                const o3 = Dn(i2, n3);
                return e3 || _n.debug(`${o3 ? "\u2705 \u041F\u0440\u043E\u0448\u043B\u043E" : "\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u043E"} \u{434}\u{43E}\u{441}\u{442}\u{430}\u{442}\u{43E}\u{447}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{441} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{435}\u{433}\u{43E} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430} (\u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43F}\u{43E}\u{43A}\u{430}\u{437}: ${i2}, \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}: ${n3}) (checkLastShow isDateOlderThan) survey_id: ${this.survey.surveyId}`), o3;
            }
            checkFeature() {
                const { checkFeature: e3 } = this.options;
                if (e3) {
                    const t3 = e3(this.survey.feature);
                    return _n[t3 ? "debug" : "info"](`${pn(t3)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} \u{444}\u{438}\u{447}\u{438} ${this.survey.feature} (checkFeature) survey_id: ${this.survey.surveyId}`), e3(this.survey.feature);
                }
                return _n.debug("\u2705 \u0423 \u043E\u043F\u0440\u043E\u0441\u0430 \u043D\u0435 \u0437\u0430\u0434\u0430\u0447\u0430 \u0444\u0438\u0447\u0430 (checkFeature) survey_id: " + this.survey.surveyId), true;
            }
            checkDelay() {
                const { delay: e3 } = this.survey;
                let t3 = this.storage.get("activeFrom");
                if (null === t3 && (t3 = Date.now(), this.storage.set("activeFrom", t3)), !e3) return _n.debug("\u2705 \u041D\u0435\u0442 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430 \u043E\u043F\u0440\u043E\u0441\u0430 (checkDelay no delay) survey_id: " + this.survey.surveyId), true;
                const r3 = Number(function(e4, t4) {
                    en2(2, arguments);
                    var r4 = rn2(e4).getTime(), n4 = Zr(t4);
                    return new Date(r4 + n4);
                }(t3, e3)) - Date.now();
                if (r3 < 0) return _n.debug("\u2705 \u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430 \u043F\u043E\u043A\u0430\u0437\u0430 \u0435\u0441\u0442\u044C \u0438 \u0443\u0436\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 (checkDelay no diff) survey_id: " + this.survey.surveyId), true;
                const n3 = this.options.updateAllSurveys;
                return n3 && (this.activeShowDelay && clearTimeout(this.activeShowDelay), _n.debug("\uD83E\uDEB2\u0417\u0430\u043F\u0443\u0449\u0435\u043D \u0442\u0430\u0439\u043C\u0435\u0440 \u0434\u043B\u044F \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430 (checkDelay setTimeout) survey_id: " + this.survey.surveyId), this.activeShowDelay = setTimeout(()=>{
                    this.activeShowDelay = null, n3();
                }, r3)), _n.info(`\u{274C} \u{417}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430} \u{435}\u{441}\u{442}\u{44C} \u{438} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{430} (\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{430}\u{446}\u{438}\u{438} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{430}: ${t3} - \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}: ${e3}\u{43C}\u{441} = ${r3}) (checkDelay) survey_id: ${this.survey.surveyId}`), false;
            }
            checkJigurda() {
                const e3 = this.storage.get("lastCheck"), t3 = this.storage.get("lastCheckState"), r3 = wn();
                if (e3 === r3 && null !== t3) return _n.debug(`${pn(t3)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} permille (checkJigurda lastCheckState) survey_id: ${this.survey.surveyId}`), t3;
                this.storage.set("lastCheck", r3);
                const { permille: n3 } = this.survey, i2 = function(e4) {
                    let t4 = 0, r4 = 0, n4 = 0;
                    t4 ^= -1;
                    for(let i3 = 0, o4 = e4.length; i3 < o4; i3++)n4 = 255 & (t4 ^ e4.charCodeAt(i3)), r4 = "0x" + "00000000 77073096 EE0E612C 990951BA 076DC419 706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B 7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D 6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F 63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1 4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3 45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5 56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87 58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589 06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB 086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED 1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF 15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541 3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73 33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525 206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17 2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739 9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B 9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D 806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F 8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1 A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3 A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795 BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7 B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9 EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661 D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53 DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605 CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37 C30C8EA1 5A05DF1B 2D02EF8D".substr(9 * n4, 8), t4 = t4 >>> 8 ^ r4;
                    return t4 = (-1 ^ t4) >>> 0, t4 %= 1e3, t4;
                }(this.getSaltedUser()), o3 = i2 < n3;
                return this.storage.set("lastCheckState", o3), _n[o3 ? "debug" : "info"](`${pn(o3)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} permille (${n3} permille \u{432} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{431}\u{44B}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435}, \u{447}\u{435}\u{43C} \u{440}\u{430}\u{441}\u{447}\u{435}\u{442}: ${i2}) (checkJigurda) survey_id: ${this.survey.surveyId}`), o3;
            }
            setTriggerTimer() {
                const e3 = this.options.updateAllSurveys, t3 = this.storage.get("triggerTimestamp");
                e3 && t3 && (this.activeTriggerTimer && (clearTimeout(this.activeTriggerTimer), this.activeTriggerTimer = null), this.activeTriggerTimer = setTimeout(()=>{
                    this.activeTriggerTimer = null, this.storage.set("triggerTimestamp", null), e3();
                }, t3 - Date.now()));
            }
            checkTriggerEvents() {
                const e3 = this.storage.get("triggerTimestamp");
                if (e3) return e3 > Date.now() ? (this.activeTriggerTimer || this.setTriggerTimer(), _n.info(`\u{274C} \u{41D}\u{435} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{43E} \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430} \u{43E}\u{442} \u{441}\u{440}\u{430}\u{431}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{442}\u{440}\u{438}\u{433}\u{433}\u{435}\u{440}\u{430} (\u{442}\u{440}\u{438}\u{433}\u{433}\u{435}\u{440} \u{431}\u{443}\u{434}\u{435}\u{442} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{435}\u{43D} \u{432} ${e3}) (checkTriggerEvents triggerTimestamp > Date.now()) survey_id: ${this.survey.surveyId}`), false) : (this.activeTriggerTimer && (clearTimeout(this.activeTriggerTimer), this.activeTriggerTimer = null), this.storage.set("triggerTimestamp", null), _n.debug(`\u{2705} \u{41F}\u{440}\u{43E}\u{448}\u{43B}\u{43E} \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430} \u{43E}\u{442} \u{441}\u{440}\u{430}\u{431}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{442}\u{440}\u{438}\u{433}\u{433}\u{435}\u{440}\u{430} (\u{442}\u{440}\u{438}\u{433}\u{433}\u{435}\u{440} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B}\u{441}\u{44F} \u{432} ${e3}) (checkTriggerEvents triggerTimestamp <= Date.now()) survey_id: ${this.survey.surveyId}`), true);
                const { triggerEvents: t3 } = this.survey, { eventsLogger: r3 } = this.options;
                if (!(null == t3 ? void 0 : t3.length) || !r3) return this.storage.set("triggerTimestamp", null), _n.debug("\u2705 \u0412 \u043E\u043F\u0440\u043E\u0441\u0435 \u043D\u0435\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u043F\u043E \u0442\u0440\u0438\u0433\u0433\u0435\u0440\u0430\u043C (checkTriggerEvents !triggerEvents) survey_id: " + this.survey.surveyId), true;
                const n3 = t3.map((e4)=>r3.getEventTriggerTimesWithDelay(e4)).filter(Boolean).map(Number), i2 = Math.min(...n3);
                return Number.isFinite(i2) ? Date.now() >= i2 ? (_n.debug("\u2705 \u0411\u044B\u043B \u0442\u0440\u0438\u0433\u0433\u0435\u0440 \u0438 \u043F\u0440\u043E\u0448\u043B\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0430 (checkTriggerEvents Date.now() >= minTriggerTimestamp) survey_id: " + this.survey.surveyId), true) : (this.storage.set("triggerTimestamp", i2), this.setTriggerTimer(), _n.info("\u274C \u041D\u0435 \u0431\u044B\u043B\u043E \u0442\u0440\u0438\u0433\u0433\u0435\u0440\u0430 (checkTriggerEvents default) survey_id: " + this.survey.surveyId), false) : (_n.info("\u274C \u0411\u044B\u043B \u0442\u0440\u0438\u0433\u0433\u0435\u0440 \u0438 \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0430 (checkTriggerEvents !Number.isFinite(minTriggerTimestamp)) survey_id: " + this.survey.surveyId), false);
            }
            getSaltedUser() {
                return `${this.getUserId()}${this.id}${wn()}`;
            }
            show() {
                return r2(this, void 0, void 0, function*() {
                    _n.warn("\uD83C\uDF89 \u041F\u043E\u043A\u0430\u0437 \u043E\u043F\u0440\u043E\u0441\u0430 (update, show) survey_id: " + this.survey.surveyId), this.frameLoader.open(), this.storage.set("lastShow", wn()), this.sendRadar(mn.Show);
                });
            }
            sendRadar(e3) {
                const { radar: t3, dryRun: r3 } = this.options, { permille: n3 } = this.survey;
                null == t3 || t3(e3, {
                    userId: this.getUserId(),
                    permille: n3,
                    surveyId: this.id,
                    dryRun: r3
                });
            }
            getUserId() {
                var e3;
                const { email: t3, clientId: r3 } = this.options;
                return null !== (e3 = null != t3 ? t3 : r3) && void 0 !== e3 ? e3 : "";
            }
        }
        function jn(e3) {
            return en2(1, arguments), 1e3 * e3;
        }
        var Bn = m2(function(e3, t3) {
            function r3() {
                return "undefined" == typeof coreKeeper ? void 0 : coreKeeper;
            }
            function n3() {
                return "undefined" != typeof userKeeper ? userKeeper : {
                    add: function() {},
                    time: function() {},
                    timeEnd: function() {}
                };
            }
            Object.defineProperty(t3, "__esModule", {
                value: true
            }), t3.userKeeper = t3.coreKeeperAPI = t3.coreKeeperAppReady = t3.getCoreKeeper = void 0, t3.getCoreKeeper = r3, t3.coreKeeperAppReady = function(e4) {
                var t4;
                null === (t4 = r3()) || void 0 === t4 || t4.appReady(e4);
            }, t3.coreKeeperAPI = function(e4, t4) {
                var n4;
                null === (n4 = r3()) || void 0 === n4 || n4.api(e4, t4);
            };
            var i2 = Object.defineProperties({
                group: function(e4, t4, r4) {
                    var i3 = n3();
                    i3.time(e4);
                    var o3 = t4(), s3 = function() {
                        return i3.timeEnd(e4, r4);
                    };
                    return o3 && "function" == typeof o3.then ? o3.then(s3, s3) : s3(), o3;
                }
            }, {
                add: {
                    get: function() {
                        return n3().add;
                    }
                },
                time: {
                    get: function() {
                        return n3().time;
                    }
                },
                timeEnd: {
                    get: function() {
                        return n3().timeEnd;
                    }
                }
            });
            t3.userKeeper = i2;
        });
        b2(Bn), Bn.userKeeper, Bn.coreKeeperAPI, Bn.coreKeeperAppReady;
        var Sn = Bn.getCoreKeeper, En = m2(function(e3, t3) {
            Object.defineProperty(t3, "__esModule", {
                value: true
            }), t3.now = void 0, t3.now = "undefined" != typeof performance && performance && "function" == typeof performance.now ? function() {
                return performance.now();
            } : Date.now;
        });
        b2(En), En.now;
        var On = m2(function(e3, t3) {
            Object.defineProperty(t3, "__esModule", {
                value: true
            }), t3.keeperFetchResponse = void 0, t3.keeperFetchResponse = function(e4, t4) {
                var r3 = En.now();
                return e4.then(function(e5) {
                    return Promise.all([
                        e5,
                        e5.text()
                    ]);
                }).then(function(e5) {
                    var n3, i2, o3 = e5[0], s3 = e5[1];
                    if ("text" !== t4) try {
                        n3 = o3.ok ? JSON.parse(s3) : null;
                    } catch (e6) {
                        i2 = e6;
                    }
                    return Bn.coreKeeperAPI(o3, {
                        duration: En.now() - r3,
                        responseLength: s3.length,
                        error: i2
                    }), o3.ok ? n3 : Promise.reject(new Error("" + o3.status));
                });
            };
        });
        b2(On);
        var Fn = On.keeperFetchResponse;
        function Cn(e3, t3) {
            var r3 = Object.keys(e3);
            if (Object.getOwnPropertySymbols) {
                var n3 = Object.getOwnPropertySymbols(e3);
                t3 && (n3 = n3.filter(function(t4) {
                    return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
                })), r3.push.apply(r3, n3);
            }
            return r3;
        }
        function kn(e3) {
            for(var t3 = 1; t3 < arguments.length; t3++){
                var r3 = null != arguments[t3] ? arguments[t3] : {};
                t3 % 2 ? Cn(Object(r3), true).forEach(function(t4) {
                    In(e3, t4, r3[t4]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r3)) : Cn(Object(r3)).forEach(function(t4) {
                    Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r3, t4));
                });
            }
            return e3;
        }
        function In(e3, t3, r3) {
            return (t3 = function(e4) {
                var t4 = function(e5, t5) {
                    if ("object" != typeof e5 || null === e5) return e5;
                    var r4 = e5[Symbol.toPrimitive];
                    if (void 0 !== r4) {
                        var n3 = r4.call(e5, t5);
                        if ("object" != typeof n3) return n3;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t5 ? String : Number)(e5);
                }(e4, "string");
                return "symbol" == typeof t4 ? t4 : String(t4);
            }(t3)) in e3 ? Object.defineProperty(e3, t3, {
                value: r3,
                enumerable: true,
                configurable: true,
                writable: true
            }) : e3[t3] = r3, e3;
        }
        function Tn(e3, t3) {
            return Pn(e3) || function(e4, t4) {
                var r3 = null == e4 ? null : "undefined" != typeof Symbol && e4[Symbol.iterator] || e4["@@iterator"];
                if (null != r3) {
                    var n3, i2, o3, s3, a3 = [], u3 = true, c3 = false;
                    try {
                        if (o3 = (r3 = r3.call(e4)).next, 0 === t4) {
                            if (Object(r3) !== r3) return;
                            u3 = false;
                        } else for(; !(u3 = (n3 = o3.call(r3)).done) && (a3.push(n3.value), a3.length !== t4); u3 = true);
                    } catch (e5) {
                        c3 = true, i2 = e5;
                    } finally{
                        try {
                            if (!u3 && null != r3.return && (s3 = r3.return(), Object(s3) !== s3)) return;
                        } finally{
                            if (c3) throw i2;
                        }
                    }
                    return a3;
                }
            }(e3, t3) || xn(e3, t3) || $n();
        }
        function Ln(e3) {
            return Pn(e3) || function(e4) {
                if ("undefined" != typeof Symbol && null != e4[Symbol.iterator] || null != e4["@@iterator"]) return Array.from(e4);
            }(e3) || xn(e3) || $n();
        }
        function Pn(e3) {
            if (Array.isArray(e3)) return e3;
        }
        function xn(e3, t3) {
            if (e3) {
                if ("string" == typeof e3) return Mn(e3, t3);
                var r3 = Object.prototype.toString.call(e3).slice(8, -1);
                return "Object" === r3 && e3.constructor && (r3 = e3.constructor.name), "Map" === r3 || "Set" === r3 ? Array.from(e3) : "Arguments" === r3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r3) ? Mn(e3, t3) : void 0;
            }
        }
        function Mn(e3, t3) {
            (null == t3 || t3 > e3.length) && (t3 = e3.length);
            for(var r3 = 0, n3 = new Array(t3); r3 < t3; r3++)n3[r3] = e3[r3];
            return n3;
        }
        function $n() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function Rn(e3, t3) {
            var r3 = "undefined" != typeof Symbol && e3[Symbol.iterator] || e3["@@iterator"];
            if (!r3) {
                if (Array.isArray(e3) || (r3 = xn(e3)) || t3) {
                    r3 && (e3 = r3);
                    var n3 = 0, i2 = function() {};
                    return {
                        s: i2,
                        n: function() {
                            return n3 >= e3.length ? {
                                done: true
                            } : {
                                done: false,
                                value: e3[n3++]
                            };
                        },
                        e: function(e4) {
                            throw e4;
                        },
                        f: i2
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var o3, s3 = true, a3 = false;
            return {
                s: function() {
                    r3 = r3.call(e3);
                },
                n: function() {
                    var e4 = r3.next();
                    return s3 = e4.done, e4;
                },
                e: function(e4) {
                    a3 = true, o3 = e4;
                },
                f: function() {
                    try {
                        s3 || null == r3.return || r3.return();
                    } finally{
                        if (a3) throw o3;
                    }
                }
            };
        }
        var Nn = /#/g, Un = /&/g, qn = /=/g, zn = /\+/g, Jn = /%5e/gi, Hn = /%60/gi, Kn = /%7c/gi, Wn = /%20/gi;
        function Vn(e3) {
            var t3;
            return (t3 = "string" == typeof e3 ? e3 : JSON.stringify(e3), encodeURI("" + t3).replace(Kn, "|")).replace(zn, "%2B").replace(Wn, "+").replace(Nn, "%23").replace(Un, "%26").replace(Hn, "`").replace(Jn, "^");
        }
        function Gn(e3) {
            return Vn(e3).replace(qn, "%3D");
        }
        function Qn() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            try {
                return decodeURIComponent("" + e3);
            } catch (t3) {
                return "" + e3;
            }
        }
        function Yn(e3) {
            return Qn(e3.replace(zn, " "));
        }
        function Xn(e3) {
            return Object.keys(e3).filter(function(t3) {
                return void 0 !== e3[t3];
            }).map(function(t3) {
                var r3, n3;
                return r3 = t3, "number" != typeof (n3 = e3[t3]) && "boolean" != typeof n3 || (n3 = String(n3)), n3 ? Array.isArray(n3) ? n3.map(function(e4) {
                    return "".concat(Gn(r3), "=").concat(Vn(e4));
                }).join("&") : "".concat(Gn(r3), "=").concat(Vn(n3)) : Gn(r3);
            }).join("&");
        }
        var Zn = /^\w{2,}:([/\\]{1,2})/, ei = /^\w{2,}:([/\\]{2})?/, ti = /^([/\\]\s*){2,}[^/\\]/;
        function ri(e3) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return "boolean" == typeof t3 && (t3 = {
                acceptRelative: t3
            }), t3.strict ? Zn.test(e3) : ei.test(e3) || !!t3.acceptRelative && ti.test(e3);
        }
        var ni, ii = /\/$|\/\?/;
        function oi() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return t3 ? ii.test(e3) : e3.endsWith("/");
        }
        function si() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (!t3) return e3.endsWith("/") ? e3 : e3 + "/";
            if (oi(e3, true)) return e3 || "/";
            var r3 = e3.split("?"), n3 = Ln(r3), i2 = n3[0], o3 = n3.slice(1);
            return i2 + "/" + (o3.length > 0 ? "?".concat(o3.join("?")) : "");
        }
        function ai() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return e3.startsWith("/");
        }
        function ui() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return (ai(e3) ? e3.slice(1) : e3) || "/";
        }
        function ci(e3, t3) {
            var r3 = function e4() {
                var t4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", r4 = arguments.length > 1 ? arguments[1] : void 0;
                if (!ri(t4, {
                    acceptRelative: true
                })) return r4 ? e4(r4 + t4) : hi(t4);
                var n4 = (t4.replace(/\\/g, "/").match(/([^/:]+:)?\/\/([^/@]+@)?(.*)/) || []).splice(1), i2 = Tn(n4, 3), o3 = i2[0], s3 = void 0 === o3 ? "" : o3, a3 = i2[1], u3 = i2[2], c3 = void 0 === u3 ? "" : u3, l3 = (c3.match(/([^#/?]*)(.*)?/) || []).splice(1), h3 = Tn(l3, 2), d3 = h3[0], f3 = void 0 === d3 ? "" : d3, v3 = h3[1], p3 = void 0 === v3 ? "" : v3, y3 = hi(p3.replace(/\/(?=[A-Za-z]:)/, "")), g3 = y3.pathname, b3 = y3.search, m3 = y3.hash;
                return {
                    protocol: s3,
                    auth: a3 ? a3.slice(0, Math.max(0, a3.length - 1)) : "",
                    host: f3,
                    pathname: g3,
                    search: b3,
                    hash: m3
                };
            }(e3), n3 = kn(kn({}, function() {
                var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t4 = {};
                "?" === e4[0] && (e4 = e4.slice(1));
                var r4, n4 = Rn(e4.split("&"));
                try {
                    for(n4.s(); !(r4 = n4.n()).done;){
                        var i2 = r4.value, o3 = i2.match(/([^=]+)=?(.*)/) || [];
                        if (!(o3.length < 2)) {
                            var s3 = Qn(o3[1]);
                            if ("__proto__" !== s3 && "constructor" !== s3) {
                                var a3 = Yn(o3[2] || "");
                                void 0 !== t4[s3] ? Array.isArray(t4[s3]) ? t4[s3].push(a3) : t4[s3] = [
                                    t4[s3],
                                    a3
                                ] : t4[s3] = a3;
                            }
                        }
                    }
                } catch (e5) {
                    n4.e(e5);
                } finally{
                    n4.f();
                }
                return t4;
            }(r3.search)), t3);
            return r3.search = Xn(n3), function(e4) {
                var t4 = e4.pathname + (e4.search ? (e4.search.startsWith("?") ? "" : "?") + e4.search : "") + e4.hash;
                if (!e4.protocol) return t4;
                return e4.protocol + "//" + (e4.auth ? e4.auth + "@" : "") + e4.host + t4;
            }(r3);
        }
        function li(e3) {
            return e3 && "/" !== e3;
        }
        function hi() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t3 = (e3.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1), r3 = Tn(t3, 3), n3 = r3[0], i2 = void 0 === n3 ? "" : n3, o3 = r3[1], s3 = void 0 === o3 ? "" : o3, a3 = r3[2], u3 = void 0 === a3 ? "" : a3;
            return {
                pathname: i2,
                search: s3,
                hash: u3
            };
        }
        !function(e3) {
            e3.SuccessfullySaved = "successfully-saved", e3.UnknownError = "unknown-error", e3.InvalidProject = "invalid-project";
        }(ni || (ni = {}));
        var di = ni;
        const fi = vn.get("SurveyService");
        class vi extends class {
            constructor(e3 = "/api/v1"){
                this.baseUrl = e3, this.requests = /* @__PURE__ */ new Map(), this.abortControllers = /* @__PURE__ */ new Map();
            }
            get(e3) {
                return r2(this, void 0, void 0, function*() {
                    const { path: t3, params: r3, abortKey: n3, cancellable: i2 } = e3, o3 = ci(this.getRequestUrl(t3), r3 || {});
                    return this.request(o3, {
                        method: "GET",
                        requestSalt: n3 && r3 ? JSON.stringify(r3[n3]) : void 0,
                        cancellable: i2
                    });
                });
            }
            post(e3) {
                return r2(this, void 0, void 0, function*() {
                    const { path: t3, data: r3, abortKey: n3, cancellable: i2 } = e3, o3 = this.getRequestUrl(t3);
                    return this.request(o3, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(r3),
                        requestSalt: n3 && r3 ? JSON.stringify(r3[n3]) : void 0,
                        cancellable: i2
                    });
                });
            }
            fetch(e3, t3) {
                return Sn() ? Fn(fetch(e3, t3), "json") : fetch(e3, t3).then((e4)=>e4.ok ? e4.json() : Promise.reject(e4.status));
            }
            request(e3, t3) {
                const { cancellable: r3, requestSalt: n3, method: i2, body: o3 } = t3, s3 = [
                    i2,
                    e3,
                    null != n3 ? n3 : JSON.stringify(o3)
                ].join(":"), a3 = this.abortControllers.get(s3), u3 = new AbortController(), c3 = new Promise((r4, n4)=>{
                    this.fetch(e3, Object.assign(Object.assign({}, t3), {
                        signal: u3.signal
                    })).then((e4)=>{
                        200 !== e4.status && n4(e4), r4(e4.body);
                    }).catch((e4)=>{
                        const t4 = this.requests.get(s3);
                        u3.signal.aborted && t4 && r4(t4), n4(e4);
                    });
                });
                return this.requests.set(s3, c3), this.abortControllers.set(s3, u3), r3 && (null == a3 || a3.abort()), c3;
            }
            getRequestUrl(e3) {
                return function(e4) {
                    for(var t3 = e4 || "", r3 = arguments.length, n3 = new Array(r3 > 1 ? r3 - 1 : 0), i2 = 1; i2 < r3; i2++)n3[i2 - 1] = arguments[i2];
                    var o3, s3 = Rn(n3.filter(function(e5) {
                        return li(e5);
                    }));
                    try {
                        for(s3.s(); !(o3 = s3.n()).done;){
                            var a3 = o3.value;
                            t3 = t3 ? si(t3) + ui(a3) : a3;
                        }
                    } catch (e5) {
                        s3.e(e5);
                    } finally{
                        s3.f();
                    }
                    return t3;
                }(this.baseUrl, e3);
            }
        } {
            fetchLastVotedDate(e3) {
                return r2(this, void 0, void 0, function*() {
                    try {
                        const { without_config: r3, survey_id: n3 } = e3, i2 = t2(e3, [
                            "without_config",
                            "survey_id"
                        ]), o3 = Object.assign({
                            without_config: "1",
                            survey_id: String(n3)
                        }, i2);
                        fi.info("call fetchLastVotedDate (/info) api with params: " + JSON.stringify(o3));
                        const { previous_answer: s3 } = yield this.get({
                            path: "survey/info",
                            params: o3
                        });
                        return jn(s3);
                    } catch (e4) {
                        return fi.error("fail to fetch fetchLastVotedDate (/info) api"), NaN;
                    }
                });
            }
            fetchLastVotedDateForGroup(e3) {
                return r2(this, void 0, void 0, function*() {
                    try {
                        const { survey_ids: t3 } = e3, r3 = Object.assign(Object.assign({}, e3), {
                            survey_ids: JSON.stringify(t3.map(Number))
                        });
                        fi.info("call last_answers api with params: " + JSON.stringify(r3));
                        return (yield this.get({
                            path: "survey/last_answers",
                            params: r3
                        })).last_answers_by_survey_ids.reduce((e4, { id: t4, answer: r4 })=>Object.assign(Object.assign({}, e4), {
                                [t4]: jn(r4)
                            }), {});
                    } catch (e4) {
                        return fi.error("fail to fetch last_answers api"), {};
                    }
                });
            }
            fetchQuestions(e3) {
                return r2(this, void 0, void 0, function*() {
                    try {
                        const { lang: r3 = "ru", without_config: n3, survey_id: i2 } = e3, o3 = t2(e3, [
                            "lang",
                            "without_config",
                            "survey_id"
                        ]), s3 = Object.assign({
                            lang: r3,
                            survey_id: String(i2)
                        }, o3);
                        fi.info("call fetchQuestions (/info) api with params: " + JSON.stringify(s3));
                        const { questions: a3 } = yield this.get({
                            path: "survey/info",
                            params: s3
                        });
                        return a3.map((e4)=>"stars" === e4.type ? Object.assign(Object.assign({}, e4), {
                                options: e4.options || []
                            }) : e4);
                    } catch (e4) {
                        return fi.error("fail to fetch fetchQuestions (/info) api"), [];
                    }
                });
            }
            saveAnswers(e3) {
                var t3, n3;
                return r2(this, void 0, void 0, function*() {
                    try {
                        const { survey_id: t4 } = e3, r3 = Number(t4), n4 = Object.assign(Object.assign({}, e3), {
                            survey_id: Number.isNaN(r3) ? t4 : r3
                        });
                        return fi.info("call save answer api with data: " + JSON.stringify(n4)), yield this.post({
                            path: "survey/answer",
                            abortKey: "survey_id",
                            cancellable: true,
                            data: n4
                        }), di.SuccessfullySaved;
                    } catch (e4) {
                        return 400 === (null == e4 ? void 0 : e4.status) && "invalid" === (null === (n3 = null === (t3 = null == e4 ? void 0 : e4.body) || void 0 === t3 ? void 0 : t3.project) || void 0 === n3 ? void 0 : n3.error) ? (fi.error("fail to fetch save answer api"), di.InvalidProject) : di.UnknownError;
                    }
                });
            }
        }
        const pi = (e3, t3)=>{
            const r3 = t3.map((e4)=>String(e4)), n3 = Object.entries(e3).filter(([e4])=>r3.includes(e4));
            return ((e4)=>Object.values(e4).reduce((e5, t4)=>Math.max(e5, t4), 0))(Object.fromEntries(n3));
        }, yi = vn.get("FeedbackLoader");
        e2.default = class {
            constructor(e3, t3 = {}){
                var r3, n3;
                this.surveys = e3, this.options = {}, this.surveyLoaders = [], this.activeSurveyId = null, this.surveyService = new vi(), this.isObserving = false, this.lastShowCheck = /* @__PURE__ */ new Map(), this.lastAnswerCheck = /* @__PURE__ */ new Map(), this.quarantinePropsSet = /* @__PURE__ */ new Map();
                const { surveyLoaderOptions: i2, apiBaseUrl: o3, loggerOptions: s3 } = t3;
                vn.processLoggerOptions(s3);
                try {
                    yi.info("constructor with params: " + JSON.stringify({
                        version: "3.6.0",
                        surveys: e3,
                        options: Yr(t3, "surveyLoaderOptions.frameLoaderOptions.rootElement")
                    }));
                } catch (e4) {}
                null === (r3 = null == i2 ? void 0 : i2.eventsLogger) || void 0 === r3 || r3.setLogger(vn.get("EventsLogger")), null === (n3 = null == i2 ? void 0 : i2.eventsLogger) || void 0 === n3 || n3.setTriggerCallback(()=>{
                    this.update().catch(()=>{});
                }), (null == i2 ? void 0 : i2.email) || (null == i2 ? void 0 : i2.clientId) ? (this.surveyLoaders = this.surveys.map((e4)=>new An(e4, Object.assign(Object.assign({}, i2), {
                        checkBeforeJigurda: this.checkSurveyBeforeJigurda.bind(this, e4),
                        checkBeforeShow: this.checkSurveyBeforeShow.bind(this, e4),
                        frameLoaderOptions: Object.assign(Object.assign({}, null == i2 ? void 0 : i2.frameLoaderOptions), {
                            onClose: ()=>{
                                var e5, t4;
                                null === (t4 = null === (e5 = null == i2 ? void 0 : i2.frameLoaderOptions) || void 0 === e5 ? void 0 : e5.onClose) || void 0 === t4 || t4.call(e5), this.resetActiveSurveyId();
                            }
                        }),
                        updateAllSurveys: ()=>this.update()
                    }))), this.options = kt({}, t3), this.surveyService = new vi(o3)) : yi.error("\u274C \u0412 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043D\u0435\u0442 \u043D\u0438 email, \u043D\u0438 clientId (constructor, no user)");
            }
            static getClientId(e3 = new Xr()) {
                let t3 = e3.get("clientId");
                return t3 || (t3 = function() {
                    var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21;
                    return crypto.getRandomValues(new Uint8Array(e4)).reduce(function(e5, t4) {
                        return e5 += (t4 &= 63) < 36 ? t4.toString(36) : t4 < 62 ? (t4 - 26).toString(36).toUpperCase() : t4 > 62 ? "-" : "_";
                    }, "");
                }(), e3.set("clientId", t3)), t3;
            }
            update() {
                return r2(this, void 0, void 0, function*() {
                    if (this.activeSurveyId) return this.activeSurveyId;
                    vn.addUpdate(), yi.warn("update");
                    const { forceShowSurveyId: e3, checkBeforeUpdate: t3 = ()=>Promise.resolve() } = this.options, r3 = this.surveyLoaders.find(({ id: t4 })=>t4 === e3);
                    return e3 && !r3 && yi.error("\u274C \u0412 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u043F\u0440\u0438\u043D\u0443\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u0440\u043E\u0441 (update, force show, NOT FIND) survey_id " + e3), this.activeSurveyId = t3().then(()=>r3 ? r3.update(true) : this.surveyLoaders.reduce((e4, t4)=>e4.catch(()=>t4.update()), Promise.reject())), this.activeSurveyId.catch(()=>{
                        this.resetActiveSurveyId();
                    }), this.activeSurveyId;
                });
            }
            close() {
                return r2(this, void 0, void 0, function*() {
                    try {
                        const e3 = yield this.activeSurveyId, t3 = this.surveyLoaders.find(({ id: t4 })=>t4 === e3);
                        null == t3 || t3.close(), this.resetActiveSurveyId();
                    } catch (e3) {}
                });
            }
            setDarkTheme(e3) {
                this.surveyLoaders.forEach((t3)=>{
                    t3.setDarkTheme(e3);
                });
            }
            observe(e3 = 3e4) {
                this.isObserving || (yi.info("observe with timeout: " + e3), this.isObserving = true, this.observerTick(e3));
            }
            disconnect() {
                clearTimeout(this.observerTimeoutId), this.observerTimeoutId = void 0, this.isObserving = false;
            }
            isVisible() {
                return r2(this, void 0, void 0, function*() {
                    return !!this.activeSurveyId && this.activeSurveyId.then(()=>true).catch(()=>false);
                });
            }
            forceShowSurvey(e3) {
                return r2(this, void 0, void 0, function*() {
                    const t3 = this.surveyLoaders.find(({ id: t4 })=>t4 === e3);
                    return yi.info("forceShowSurvey method, survey_id: " + e3), t3 ? (yield this.close(), this.activeSurveyId = t3.update(true), this.activeSurveyId) : (yi.error("\u274C \u0412 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u043F\u0440\u0438\u043D\u0443\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u0440\u043E\u0441 (forceShowSurvey method, NOT FIND) survey_id " + e3), Promise.reject("survey_does_not_exist"));
                });
            }
            observerTick(e3) {
                this.update().catch(()=>{}).finally(()=>{
                    try {
                        window.__DEBUG_CSAT_UPDATED = 1;
                    } catch (e4) {}
                    this.isObserving && (this.observerTimeoutId = setTimeout(()=>{
                        this.observerTick(e3);
                    }, e3));
                });
            }
            resetActiveSurveyId() {
                this.activeSurveyId = null, this.lastShowCheck = /* @__PURE__ */ new Map(), this.lastAnswerCheck = /* @__PURE__ */ new Map();
            }
            checkLastShow(e3) {
                const { surveyId: t3, noDelay: r3, excludeFromCommonQuarantine: n3, surveysByQuarantineIdsWithCurrentFilter: i2 } = this.getQuarantineProps(e3), { ignoreShowInOneDay: o3 } = this.options;
                if (this.lastShowCheck.get(t3)) return this.lastShowCheck.get(t3);
                const { quarantine: { quarantineByShowDays: s3 } = {} } = this.options;
                if (r3) return yi.info("\u274C \u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0430 \u043F\u043E\u043A\u0430\u0437\u0430 \u0438\u043B\u0438 \u043E\u043D\u0430 \u0440\u0430\u0432\u043D\u0430 0 (checkLastShow no delay) survey_id: " + e3.surveyId), false;
                if (o3) return yi.debug("\u2705 \u041C\u043E\u0436\u043D\u043E \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0433\u043E\u0434\u043D\u043E \u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u0432 \u0434\u0435\u043D\u044C (checkLastShow ignoreShowInOneDay) survey_id: " + e3.surveyId), true;
                let a3 = n3;
                if (!n3) {
                    const e4 = i2.find((e5)=>!e5.checkLastShow(s3));
                    a3 = !e4;
                    const r4 = e4 ? ` \u{438}\u{437}-\u{437}\u{430} ${e4.id} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{430}` : "";
                    yi[a3 ? "debug" : "info"](`${a3 ? "\u2705 \u041F\u0440\u043E\u0448\u043B\u043E" : "\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u043E"} \u{434}\u{43E}\u{441}\u{442}\u{430}\u{442}\u{43E}\u{447}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{441} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{435}\u{433}\u{43E} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430} \u{43A}\u{430}\u{440}\u{430}\u{43D}\u{442}\u{438}\u{43D}\u{43D}\u{44B}\u{445} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432}${r4} (checkShow) survey_id: ${t3}`);
                }
                if (!a3) return this.lastShowCheck.set(t3, false), false;
                const u3 = this.surveyLoaders.find((e4)=>!e4.checkLastShow(1)), c3 = !u3, l3 = u3 ? `. \u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F} \u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{44B}\u{432}\u{430}\u{43B}\u{441}\u{44F} ${u3.id} \u{43E}\u{43F}\u{440}\u{43E}\u{441}` : "";
                return yi[c3 ? "debug" : "info"](`${pn(c3)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} \u{43D}\u{430} \u{43D}\u{435} \u{43F}\u{43E}\u{43A}\u{430}\u{437} \u{432}\u{442}\u{43E}\u{440}\u{43E}\u{433}\u{43E} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{437}\u{430} \u{434}\u{435}\u{43D}\u{44C}${l3} (checkTodayShow) survey_id: ${t3}`), this.lastShowCheck.set(t3, c3), c3;
            }
            checkLastAnswer(e3) {
                var t3;
                return r2(this, void 0, void 0, function*() {
                    const { surveyId: r3, repeatAfter: n3, noDelay: i2, quarantineIdsWithCurrent: o3, allIds: s3, surveyIds: a3 } = this.getQuarantineProps(e3);
                    if (this.lastAnswerCheck.get(r3)) {
                        const e4 = this.lastAnswerCheck.get(r3);
                        return yi.debug(`${pn(e4)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{438} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{430} (\u{432}\u{440}\u{435}\u{43C}\u{44F} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{43E}\u{432} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{43F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{432} localStorage \u{43F}\u{43E} \u{43A}\u{43B}\u{44E}\u{447}\u{443} lastVotedDate) (checkLastAnswer cache) survey_id: ${r3}`), e4;
                    }
                    if (i2) return yi.info("\u274C \u0412 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043D\u0435\u0442 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430 (\u0432 \u043A\u0430\u0440\u0430\u043D\u0442\u0438\u043D\u0435 \u0438\u043B\u0438 \u0432 \u043A\u043E\u043D\u0444\u0438\u0433\u0435 \u043E\u043F\u0440\u043E\u0441\u0430) (checkLastAnswer noDelay) survey_id: " + r3), this.lastAnswerCheck.set(r3, false), false;
                    const { email: u3, clientId: c3 } = this.options.surveyLoaderOptions || {}, l3 = new ((null === (t3 = this.options.surveyLoaderOptions) || void 0 === t3 ? void 0 : t3.storage) || Xr)(null != u3 ? u3 : c3, a3.join(":")), h3 = l3.get("lastVotedDate");
                    let d3 = h3 ? JSON.parse(h3) : {};
                    (null === h3 || Dn(pi(d3, o3), n3)) && (this.sendRadar(mn.ApiFetchLastVotedDateGroup), d3 = yield this.surveyService.fetchLastVotedDateForGroup({
                        survey_ids: s3,
                        email: u3,
                        client_id: c3
                    }), l3.set("lastVotedDate", JSON.stringify(d3)));
                    const f3 = Dn(pi(d3, o3), n3);
                    return this.lastAnswerCheck.set(r3, f3), yi[f3 ? "debug" : "info"](`${pn(f3)} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} \u{437}\u{430}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{438} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{430} (checkLastAnswer) survey_id: ${r3}. (\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{43E}\u{432}: ${JSON.stringify(d3)})`), f3;
                });
            }
            checkSurveyBeforeJigurda(e3) {
                return r2(this, void 0, void 0, function*() {
                    if (!this.checkLastShow(e3)) return yi.warn("\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0443 \u043C\u0435\u0436\u0434\u0443 \u043F\u043E\u043A\u0430\u0437\u0430\u043C\u0438 (last_show_check_before_jigurda_fail) survey_id: " + e3.surveyId), Promise.reject("last_show_check_before_jigurda_fail");
                });
            }
            checkSurveyBeforeShow(e3) {
                return r2(this, void 0, void 0, function*() {
                    if (!(yield this.checkLastAnswer(e3))) return yi.warn("\u274C \u041D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0443 \u043C\u0435\u0436\u0434\u0443 \u043E\u0442\u0432\u0435\u0442\u0430\u043C\u0438 (last_answer_check_fail) survey_id: " + e3.surveyId), Promise.reject("last_answer_check_fail");
                });
            }
            sendRadar(e3) {
                const { radar: t3, dryRun: r3 } = this.options.surveyLoaderOptions || {};
                null == t3 || t3(e3, {
                    userId: this.getUserId(),
                    dryRun: r3
                });
            }
            getUserId() {
                var e3;
                const { email: t3, clientId: r3 } = this.options.surveyLoaderOptions || {};
                return null !== (e3 = null != t3 ? t3 : r3) && void 0 !== e3 ? e3 : "";
            }
            getQuarantineProps(e3) {
                var t3, r3;
                const n3 = e3.surveyId;
                if (this.quarantinePropsSet.has(n3)) return this.quarantinePropsSet.get(n3);
                const i2 = !!e3.repeatAfterDays || !!e3.showAfterDays, { quarantine: { quarantineByAnswerDays: o3, quarantineByShowDays: s3, quarantineIds: a3 } = {} } = this.options;
                let u3 = s3, c3 = o3;
                i2 && (u3 = null !== (t3 = e3.showAfterDays) && void 0 !== t3 ? t3 : e3.repeatAfterDays, c3 = null !== (r3 = e3.repeatAfterDays) && void 0 !== r3 ? r3 : e3.showAfterDays);
                const l3 = !u3 || !c3 || !a3 && !i2, h3 = this.surveys.map(({ surveyId: e4 })=>e4), d3 = Array.from(/* @__PURE__ */ new Set([
                    ...a3 || [],
                    ...h3,
                    n3
                ])), f3 = i2 ? [
                    n3
                ] : Array.from(/* @__PURE__ */ new Set([
                    ...a3 || [],
                    n3
                ])), v3 = this.surveyLoaders.filter(({ id: e4 })=>f3.includes(e4)), p3 = {
                    showAfter: u3,
                    repeatAfter: c3,
                    noDelay: l3,
                    excludeFromCommonQuarantine: i2,
                    surveyId: n3,
                    quarantineByAnswerDays: o3,
                    quarantineIds: a3,
                    allIds: d3,
                    surveyIds: h3,
                    quarantineIdsWithCurrent: f3,
                    surveysByQuarantineIdsWithCurrentFilter: v3
                };
                return this.quarantinePropsSet.set(n3, p3), p3;
            }
        }, Object.defineProperty(e2, "__esModule", {
            value: true
        });
    });
})(FeedbackLoader, FeedbackLoader.exports);
const useBrowserNotificationConfirm = ()=>{
    const popupRef = (0, $acw62.useRef)(null);
    const subscribedStreamsBlogUrls = (0, $iD0SF.useSelector)(catalogSubscribedStreamsBlogUrlsSelector);
    const catalogSubscribedStreamsNetworkStatus = (0, $iD0SF.useSelector)(catalogSubscribedStreamsNetworkStatusSelector);
    const hasWebpushPrompt = (0, $iD0SF.useSelector)(currentUserHasWebpushPrompt);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showPopup, closePopup } = distExports.useOverlayPopups();
    const { blogUrl } = useStreamIdentity();
    const handleFinishCheckPermissions = ()=>{
        if (popupRef.current) closePopup(popupRef.current.id);
    };
    const { checkPermission } = useBrowserNotifications({
        blogUrl: blogUrl,
        onFinishCheckPermissions: handleFinishCheckPermissions
    });
    const handleOk = ()=>{
        checkPermission();
    };
    const handleClose = ()=>{
        AppStat.log.notificationSettings.webPushCancel();
    };
    const isUserNewcomer = !subscribedStreamsBlogUrls || (subscribedStreamsBlogUrls == null ? void 0 : subscribedStreamsBlogUrls.length) === 0;
    const isLoaded = catalogSubscribedStreamsNetworkStatus.isFetched;
    const prompt = async ()=>{
        if (Notification.permission !== "granted" && !hasWebpushPrompt) {
            popupRef.current = showPopup({
                type: EPopup.BROWSER_NOTIFICATION,
                data: {
                    onOk: handleOk,
                    onExternalClose: handleClose
                }
            });
            return dispatch((0, $7Uc0p.thunkToAction)(updateUserFlag.action)({
                flag: ECurrentUserFlag.HAS_WEBPUSH_PROMPT
            }));
        }
        return Promise.resolve();
    };
    return {
        subscribedStreamsBlogUrls: subscribedStreamsBlogUrls,
        isLoaded: isLoaded,
        isUserNewcomer: isUserNewcomer,
        prompt: prompt
    };
};
const useFollow$1 = (params = {})=>{
    const { externalBlog, onToggleFollowCallback } = params;
    const getParams = useParams();
    const store2 = (0, $4TSkt.useStore)();
    const { recordId } = getParams;
    const { blogUrl: paramsBlogUrl } = useStreamIdentity();
    const { blogUrl: streamPageBlogUrl, recordId: streamPageRecordId } = getPathParams(STREAM_PAGE_TABS, store2);
    const externalIsFollowing = (externalBlog == null ? void 0 : externalBlog.subscriptionKind) === ESubscriptionKind.FREE;
    const externalIsSubscribed = (externalBlog == null ? void 0 : externalBlog.subscriptionKind) === ESubscriptionKind.PAID;
    const blogUrl = (externalBlog == null ? void 0 : externalBlog.blogUrl) || paramsBlogUrl || streamPageBlogUrl;
    const { isMobile: isMobile2, tmr: { ids: counterIds } } = getConfig();
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showPopup, closePopup } = distExports.useOverlayPopups();
    const { prompt, isUserNewcomer } = useBrowserNotificationConfirm();
    const blogState = (0, $iD0SF.useSelector)(blogSelector);
    const blog2 = externalBlog || blogState;
    const isFreeSubscription = (0, $iD0SF.useSelector)(isFreeSubscriptionSelector);
    const isPaidSubscription = (0, $iD0SF.useSelector)(isPaidSubscriptionSelector);
    const isFollowing = externalBlog ? externalIsFollowing : isFreeSubscription;
    const isSubscribed = externalBlog ? externalIsSubscribed : isPaidSubscription;
    const { isFetching } = (0, $iD0SF.useSelector)(blogFollowNetworkStatusSelector);
    const record2 = (0, $iD0SF.useSelector)(currentRecordSelector);
    const fetchRecord$1 = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchRecord.action)({
            blogUrl: blogUrl,
            recordId: recordId || streamPageRecordId || record2.id
        }));
    };
    const { currentUser: currentUser2, isAuthorized, showAuth } = useCurrentUserAccess();
    const setGoalReached = ()=>{
        setTopMailGoalReached({
            counterId: counterIds[0],
            goalId: ETopMailGoalId.FOLLOW,
            userId: String(currentUser2.id)
        });
    };
    const follow = async ()=>{
        if (!blogUrl) return;
        await dispatch((0, $7Uc0p.thunkToAction)(followBlog.action)({
            blogUrl: blogUrl
        }));
        setGoalReached();
        if (isUserNewcomer) await prompt();
        await refetch();
        onToggleFollowCallback == null || onToggleFollowCallback();
        if ((recordId || streamPageRecordId || (record2 == null ? void 0 : record2.id)) && !Boolean(externalBlog)) fetchRecord$1();
    };
    const unfollow = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(unfollowBlog.action)({
            blogUrl: blogUrl
        }));
        await refetch();
        onToggleFollowCallback == null || onToggleFollowCallback();
    };
    const refetch = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStream.action)({
            blogUrl: paramsBlogUrl || streamPageBlogUrl || blogUrl
        }));
        await dispatch((0, $7Uc0p.thunkToAction)(fetchSmileUserSet.action)({
            blogUrl: blogUrl
        }));
        await dispatch((0, $7Uc0p.thunkToAction)(fetchCatalogSubscribedStreams.action)());
        await dispatch((0, $7Uc0p.thunkToAction)(refetchSubscriptionsSettingsData)());
        await dispatch((0, $7Uc0p.thunkToAction)(fetchCatalogRecommendedStreams.action)({
            limit: 50
        }));
        if (Boolean(externalBlog)) await dispatch((0, $7Uc0p.thunkToAction)(fetchBlogExternal.action)({
            blogUrl: externalBlog.blogUrl
        }));
    };
    const confirmUnfollow = (onConfirm, blogName)=>{
        const { id: unfollowPopupId } = showPopup({
            type: EPopup.UNFOLLOW,
            data: {
                onConfirm: async ()=>{
                    await onConfirm();
                    closePopup(unfollowPopupId);
                },
                blogName: blogName
            }
        });
    };
    const onConfirmUnfollow = async ()=>{
        return unfollow();
    };
    const onFollowToggle = ()=>{
        if (!isAuthorized) {
            showAuth();
            AppStat.log.auth.openPopup({
                source: EStatAuthStartSource.BLOG_FOLLOW
            });
        } else if (blog2 == null ? void 0 : blog2.isSubscribed) {
            if (isMobile2) unfollow();
            else confirmUnfollow(onConfirmUnfollow, blog2.owner.nick);
        } else follow();
    };
    return {
        isFetching: isFetching,
        isFollowing: isFollowing,
        isSubscribed: isSubscribed,
        onFollowToggle: onFollowToggle
    };
};
const useMention = (params)=>{
    const { inlineData, cursorRef, setEditorData } = params;
    const insertedMentionRef = (0, $acw62.useRef)(null);
    const addMentionToInlineData = (0, $acw62.useCallback)(({ user, isReplaceWordOnCursor = false, mentionQuery })=>{
        const mentionData = convertMentionToMediaItem(user);
        const spaceSymbol = {
            type: EMediaDataType.SPACE
        };
        const cursor = cursorRef.current;
        const { itemIndex, offset: offsetCr } = prepareCursor(cursor, inlineData);
        const item2 = inlineData[itemIndex - 1];
        insertedMentionRef.current = {
            position: offsetCr,
            name: user.nick,
            uniqueId: mentionData.uniqueId,
            type: mentionData.type
        };
        if (item2 && isText(item2) && !isParagraphEnd$1(item2)) {
            const previousElement = inlineData[itemIndex - 2];
            const isHardSpacePrevious = (previousElement == null ? void 0 : previousElement.type) === EMediaDataType.SPACE;
            const basicStrategy = isReplaceWordOnCursor ? replaceWordOnCursorInsertingStrategy : inPlaceInsertingStrategy;
            const strategy = isHardSpacePrevious ? replaceWithPreviousHardSpaceStrategy : basicStrategy;
            const slices = insertObjectInTextItem(item2, [
                mentionData,
                spaceSymbol
            ].filter(Boolean), offsetCr, strategy, mentionQuery);
            setEditorData(inlineData.slice(0, itemIndex - 1).concat(previousElement && !isHardSpacePrevious ? [
                spaceSymbol
            ] : []).concat(slices).concat(inlineData.slice(itemIndex)));
        } else if (item2 && isParagraphEnd$1(item2)) setEditorData(inlineData.slice(0, -1).concat(mentionData, spaceSymbol, inlineData.slice(-1)));
        else setEditorData(inlineData.slice(0, itemIndex).concat(mentionData).concat(spaceSymbol).concat(inlineData.slice(itemIndex)));
    }, [
        inlineData,
        setEditorData
    ]);
    return {
        insertedMentionRef: insertedMentionRef,
        addMentionToInlineData: addMentionToInlineData
    };
};
const useChatUsersMentions = (params)=>{
    const { blogUrl, inlineData, cursorRef, setEditorData, restoreCursorPosition } = params;
    const isMentionsEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_USER_MENTION);
    const chatUserSearchList = (0, $iD0SF.useSelector)(streamChatUserSearchListSelector);
    const activeIndex = (0, $iD0SF.useSelector)(activeIndexPopoverSelector);
    const { insertedMentionRef, addMentionToInlineData } = useMention({
        inlineData: inlineData,
        cursorRef: cursorRef,
        setEditorData: setEditorData
    });
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        clearMentionsList();
    }, [
        blogUrl
    ]);
    const isMentionsSuggestOpen = isMentionsEnabled && (chatUserSearchList == null ? void 0 : chatUserSearchList.length) > 0 && !isEmptyMediaData(inlineData);
    const getMentionsList = (0, $acw62.useCallback)((searchQuery)=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchChatUserSearchList.action)({
            blogUrl: blogUrl,
            searchQuery: searchQuery
        }));
    }, [
        blogUrl
    ]);
    const clearMentionsList = (0, $acw62.useCallback)(()=>{
        dispatch(cleanStreamChatUserSearchList());
    }, []);
    const onMentionClick = (0, $acw62.useCallback)((user)=>{
        addMentionToInlineData({
            user: user,
            isReplaceWordOnCursor: true
        });
        clearMentionsList();
    }, [
        addMentionToInlineData,
        clearMentionsList
    ]);
    const insertCurrentMention = (0, $acw62.useCallback)(()=>{
        onMentionClick(chatUserSearchList[activeIndex]);
        restoreCursorPosition();
    }, [
        onMentionClick,
        chatUserSearchList,
        activeIndex,
        restoreCursorPosition
    ]);
    return {
        isMentionsEnabled: isMentionsEnabled,
        insertedMentionRef: insertedMentionRef,
        chatUserSearchList: chatUserSearchList,
        isMentionsSuggestOpen: isMentionsSuggestOpen,
        activeIndex: activeIndex,
        getMentionsList: getMentionsList,
        clearMentionsList: clearMentionsList,
        onMentionClick: onMentionClick,
        addMentionToInlineData: addMentionToInlineData,
        insertCurrentMention: insertCurrentMention
    };
};
const usePlaybackPosition = (params)=>{
    var _a3, _b2, _c2, _d;
    const { unitedVideoId, getPosition, getUnitedVideoId } = params;
    const dispatch = (0, $2OPjR.useDispatch)();
    const store2 = (0, $4TSkt.useStore)();
    const { getIsAuthorized } = useCurrentUserAccess();
    const { blogUrl: paramsBlogUrl, recordId, videoId: paramsVideoId } = {
        ...getPathParams([
            URLS.STREAM,
            URLS.EMBED_VIDEO_LIVE,
            URLS.EMBED_VIDEO_VOD,
            URLS.STREAM_RECORDS,
            URLS.STREAM_RECORD_RECORDS,
            URLS.CHANNEL_VIDEO,
            URLS.CHANNEL_PLAYLIST_ENTITY
        ], store2) ?? {},
        ...useParams()
    };
    const stream2 = (0, $iD0SF.useSelector)(streamStaticFieldsSelector);
    const streamShowcase = (0, $iD0SF.useSelector)(streamShowcaseSelector);
    const blogUrl = paramsBlogUrl !== "random" && paramsBlogUrl || ((_c2 = (_b2 = (_a3 = streamShowcase || stream2) == null ? void 0 : _a3.embedUrl) == null ? void 0 : _b2.split("/")) == null ? void 0 : _c2.pop());
    const videoId = paramsVideoId || ((_d = streamShowcase || stream2) == null ? void 0 : _d.id);
    const timeoutRef = (0, $acw62.useRef)(null);
    const { playbackPosition: { defaultInterval: savePlaybackPositionInterval } } = getConfig();
    const isPlaybackPositionSavingEnabled = isConditionalFeatureEnable(EConditionalFeature.PLAYBACK_POSITION_SAVING);
    const isLive2 = !recordId && !videoId;
    const id = isLive2 ? stream2 == null ? void 0 : stream2.id : recordId || videoId;
    const type = isLive2 || streamShowcase || (stream2 == null ? void 0 : stream2.isOnline) ? EPlaybackPositionType.STREAM : EPlaybackPositionType.RECORD;
    const savePosition = ()=>{
        if (!isPlaybackPositionSavingEnabled || !getIsAuthorized() || false) return;
        const position2 = Math.floor(getPosition());
        if (Number.isNaN(position2) || position2 >= Infinity || unitedVideoId !== getUnitedVideoId() || !id) return;
        dispatch(savePlaybackPosition.action({
            blogUrl: blogUrl,
            id: id,
            position: position2,
            type: type
        }));
    };
    const startAutoSavingPosition = ()=>{
        scheduleSaving();
    };
    const stopAutoSavingPosition = ()=>{
        window.clearTimeout(timeoutRef.current);
    };
    const scheduleSaving = ()=>{
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            savePosition();
            scheduleSaving();
        }, savePlaybackPositionInterval * 1e3 * distributeEvenly(0.8, 1.3));
    };
    (0, $acw62.useEffect)(()=>{
        if (blogUrl && id && type) startAutoSavingPosition();
        return ()=>{
            stopAutoSavingPosition();
        };
    }, [
        blogUrl,
        id,
        type,
        unitedVideoId
    ]);
    return {
        savePlaybackPosition: savePosition,
        startAutoSavingPlaybackPosition: startAutoSavingPosition,
        stopAutoSavingPlaybackPosition: stopAutoSavingPosition
    };
};
const convertLinksToPublisherInlineData = (inlineData)=>{
    return inlineData.reduce((acc, item2)=>{
        if (isTextItem(item2)) {
            const content2 = getTextBlockContent(item2);
            const mediaData2 = convertLinksToMediaItems(content2);
            if (mediaData2.length) acc = [
                ...acc,
                ...mediaData2
            ];
            else acc.push(item2);
        } else acc.push(item2);
        return acc;
    }, []);
};
const convertUrlsToPublisherInlineData = (items)=>{
    return items.reduce((acc, item2)=>{
        if (isTextItem(item2)) {
            const content2 = getTextBlockContent(item2);
            const resultText = linkifyText(content2, URL_LINK_REGEXP);
            const mediaData2 = convertLinksToMediaItems(resultText);
            if (mediaData2.length) acc = [
                ...acc,
                ...mediaData2
            ];
            else acc.push(item2);
        } else acc.push(item2);
        return acc;
    }, []);
};
const getPublisherInlineDataTrimmed = (inlineData, options)=>{
    const startIndex = inlineData.findIndex((item2)=>isTextOrLinkItem(item2) && getTextBlockContent(item2).trim() || !isTextOrLinkItem(item2) && item2.modificator !== EMediaDataTextModificator.BLOCK_END);
    const endIndex = inlineData.length - [
        ...inlineData
    ].reverse().findIndex((item2)=>isTextOrLinkItem(item2) && getTextBlockContent(item2).trim() || !isTextOrLinkItem(item2) && item2.modificator !== EMediaDataTextModificator.BLOCK_END);
    return inlineData.reduce((acc, item2, index2)=>{
        if (isTextOrLinkItem(item2)) {
            if (index2 >= startIndex && index2 <= endIndex) {
                let content2 = getTextBlockContent(item2);
                if (index2 === startIndex) content2 = content2.trimStart();
                if (index2 === endIndex - 1) content2 = content2.trimEnd();
                const blocks2 = convertParagraphToTextBlocks$1(content2, {
                    shouldAddBlockEnd: false
                });
                const nextItem = inlineData[index2 + 1];
                const lastBlockIsEnding = isParagraphEnd$1(blocks2[blocks2.length - 1]);
                if (nextItem && isSmileMediaDataItem(nextItem) && lastBlockIsEnding) blocks2.pop();
                acc.push(...blocks2);
            }
        } else acc.push(item2);
        return acc;
    }, []);
};
const getPublisherInlineData = (textData)=>{
    let text2 = "";
    textData.forEach((el)=>{
        switch(true){
            case isSmileMediaDataItem(el):
                text2 += " ";
                break;
            case isMentionItem(el):
                const { displayName } = el;
                text2 += displayName;
                break;
            case isTextOrLinkItem(el):
                text2 += getTextBlockContent(el);
                break;
        }
    });
    return text2;
};
const getPublisherInlineDataLength = (textData)=>{
    if (!textData) return 0;
    const text2 = getPublisherInlineData(getPublisherInlineDataTrimmed(textData));
    return text2.length;
};
const usePublisherImages = (params)=>{
    const { showAlert, initialImages } = params;
    const { publisher: { images: { limits } } } = getConfig();
    const [serverStoredImages, setServerStoredImages] = (0, $acw62.useState)(initialImages);
    const uploadImage$1 = (image2)=>{
        return (0, $7Uc0p.thunkToAction)(uploadImage)({
            image: image2
        });
    };
    const { images: justAttachedImages, openAttachDialog, deleteFile: deleteJustAttachedFile, clearFiles: clearJustAttachedFiles } = useAttachImages({
        limits: limits,
        uploadsSelector: mediaDataUploadsSelector,
        showAlert: showAlert,
        uploadImage: uploadImage$1
    });
    const deleteFile = (imageIdToDelete)=>{
        const foundServerStoredImageToDeleteIndex = serverStoredImages.findIndex((image2)=>image2.id === imageIdToDelete);
        if (foundServerStoredImageToDeleteIndex > -1) {
            const newServerStoredImages = [
                ...serverStoredImages
            ];
            newServerStoredImages.splice(foundServerStoredImageToDeleteIndex, 1);
            setServerStoredImages(newServerStoredImages);
        } else deleteJustAttachedFile(imageIdToDelete);
    };
    const clearFiles = ()=>{
        setServerStoredImages([]);
        clearJustAttachedFiles();
    };
    (0, $acw62.useEffect)(()=>{
        setServerStoredImages(initialImages);
        if (!initialImages.length) clearJustAttachedFiles();
    }, [
        initialImages
    ]);
    const images = [
        ...serverStoredImages,
        ...justAttachedImages
    ];
    return {
        images: images,
        openAttachDialog: openAttachDialog,
        deleteFile: deleteFile,
        clearFiles: clearFiles
    };
};
const parseInitialDataToEditor = (initialValue)=>{
    const inlineData = [];
    const images = [];
    initialValue == null || initialValue.forEach((item2)=>{
        if (isTextOrLinkItem(item2) || isSmileMediaDataItem(item2)) inlineData.push(item2);
        if (item2.type === EMediaDataType.IMAGE) images.push(item2);
    });
    return {
        initialInlineData: inlineData,
        initialImages: images
    };
};
const usePublisher = (params)=>{
    const { initialValue, clearOnSubmit = true, canPostLinks, maxInlineDataLength, isBanned, publish, showAlert, onPublishError = noop$2, currentUserMessages } = params;
    const blogUrl = (0, $iD0SF.useSelector)(blogUrlSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const prevInitialValue = usePrevious(initialValue);
    const { initialInlineData, initialImages } = parseInitialDataToEditor(initialValue);
    const [inlineData, setInlineData] = (0, $acw62.useState)(initialInlineData);
    const [editorData, setEditorData] = (0, $acw62.useState)(initialInlineData);
    const [imagesData, setImagesData] = (0, $acw62.useState)(initialImages);
    const settedPrevMessageRef = (0, $acw62.useRef)(null);
    const messageCursor = (0, $acw62.useRef)(-1);
    const { images, openAttachDialog, deleteFile, clearFiles } = usePublisherImages({
        initialImages: imagesData,
        showAlert: showAlert
    });
    (0, $acw62.useEffect)(()=>{
        if (prevInitialValue !== initialValue) {
            setImagesData(initialImages);
            setEditorData(initialInlineData);
        }
    }, [
        initialImages,
        initialInlineData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isBanned && (inlineData.length || editorData.length)) clearData();
    }, [
        isBanned
    ]);
    const onInlineDataChange = (value2)=>{
        setInlineData(value2);
    };
    const clearData = ()=>{
        setEditorData([]);
        setInlineData([]);
        setImagesData([]);
        clearFiles();
    };
    const fetchPopularSmiles = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchSmileUserPopularSet.action)({
            blogUrl: blogUrl
        }));
    };
    const onPublish = async (inlineDataToPublish)=>{
        let newInlineData = convertLinksToPublisherInlineData(inlineDataToPublish || inlineData);
        const inlineDataLength2 = getPublisherInlineDataLength(newInlineData);
        if (isEmptyMediaData(newInlineData) && !images.length) {
            setEditorData([]);
            setInlineData([]);
            setImagesData([]);
            return;
        }
        if (maxInlineDataLength && inlineDataLength2 >= maxInlineDataLength) return;
        if (newInlineData.length || images.length) {
            if (canPostLinks) newInlineData = convertUrlsToPublisherInlineData(newInlineData);
            const convertedImages = images.map((image2)=>{
                if (isAttachedImage(image2)) return {
                    type: EMediaDataType.IMAGE,
                    id: image2.file.id,
                    url: image2.file.url
                };
                return image2;
            });
            if (clearOnSubmit) clearData();
            try {
                await publish({
                    inlineData: newInlineData,
                    imagesData: convertedImages
                });
                const hasSmiles = newInlineData.find(({ type })=>type === EMediaDataType.SMILE);
                if (hasSmiles) fetchPopularSmiles();
            } catch (err) {
                onPublishError(err);
                setEditorData(newInlineData);
            }
        }
        messageCursor.current = -1;
    };
    const text2 = getPublisherInlineData(inlineData);
    const inlineDataLength = text2.length;
    const canPublish = text2.length && !Boolean(text2.match(/^[\n]+$/g));
    const handleKeyUp = (event2)=>{
        var _a3;
        if ([
            EKeyboardKey.ARROW_UP,
            EKeyboardKey.ARROW_DOWN
        ].includes(event2.key)) {
            const isPrevTrigger = event2.key === EKeyboardKey.ARROW_UP;
            const cleanInlineData = inlineData.filter((item2)=>!((item2 == null ? void 0 : item2.content) === '["","unstyled",[]]' || (item2 == null ? void 0 : item2.modificator) === EMediaDataTextModificator.BLOCK_END));
            const isEmptyInput = cleanInlineData.length === 0;
            const cursor = messageCursor.current;
            if (isEmptyInput) messageCursor.current = event2.key === EKeyboardKey.ARROW_UP ? currentUserMessages.length - 1 : -1;
            else {
                const twinMessagesIndexes = currentUserMessages.map((item2, index2)=>[
                        item2,
                        index2
                    ]).filter(([item2])=>isEqualMediaData(inlineData, item2.data)).map(([, index2])=>index2);
                const hasPrevCursor = messageCursor.current >= 0;
                if (twinMessagesIndexes.length > 1) {
                    if (hasPrevCursor) {
                        if (isPrevTrigger) messageCursor.current = messageCursor.current > 0 ? messageCursor.current - 1 : messageCursor.current;
                        else messageCursor.current = messageCursor.current < currentUserMessages.length - 1 ? messageCursor.current + 1 : messageCursor.current;
                    } else messageCursor.current = isPrevTrigger ? twinMessagesIndexes[twinMessagesIndexes.length - 1] : -1;
                } else if (twinMessagesIndexes.length === 1) {
                    if (hasPrevCursor) {
                        if (isPrevTrigger) messageCursor.current = twinMessagesIndexes[0] > 0 ? twinMessagesIndexes[0] - 1 : messageCursor.current;
                        else messageCursor.current = twinMessagesIndexes[0] < currentUserMessages.length - 1 ? twinMessagesIndexes[0] + 1 : messageCursor.current;
                    } else if (isPrevTrigger) messageCursor.current = currentUserMessages.length - 1;
                }
            }
            let message2 = messageCursor.current >= 0 && cursor !== messageCursor.current && ((_a3 = currentUserMessages[messageCursor.current]) == null ? void 0 : _a3.data);
            if (message2 == null ? void 0 : message2.length) {
                message2 = message2.filter((item2)=>!((item2 == null ? void 0 : item2.content) === '["","unstyled",[]]'));
                setEditorData(message2);
                setInlineData(message2);
                settedPrevMessageRef.current = message2;
            }
        }
    };
    return {
        editorData: editorData,
        inlineData: inlineData,
        inlineDataLength: inlineDataLength,
        canPublish: canPublish,
        images: images,
        settedPrevMessageRef: settedPrevMessageRef,
        onInlineDataChange: onInlineDataChange,
        onPublish: onPublish,
        openAttachDialog: openAttachDialog,
        deleteFile: deleteFile,
        setEditorData: setEditorData,
        handleKeyUp: handleKeyUp
    };
};
const INVALID_FOR_SUGGEST_TYPES = [
    ESmileUserSetType.USER_POPULAR
];
const useSmilesSuggest = (params)=>{
    const { onAvailableSmileClick, onUnavailableSmileClick, onPublish, isOutlineClick, getEditorData, inlineData } = params;
    const smiles2 = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetSelector);
    const isShowSuggestWithoutMaximalLimit = isConditionalFeatureEnable(EConditionalFeature.SMILE_SUGGEST_WITHOUT_MAXIMAL_LIMIT);
    const isSuggestEnabled = isConditionalFeatureEnable(EConditionalFeature.SMILE_SUGGEST);
    const isNavigationEnabled = isConditionalFeatureEnable(EConditionalFeature.SMILE_SUGGEST_NAVIGATION);
    const [autoReplaceText, setAutoReplaceText] = (0, $acw62.useState)(null);
    const [textBeforeSpace, setTextBeforeSpace] = (0, $acw62.useState)(null);
    const [suggestedSmiles, setSuggestedSmiles] = (0, $acw62.useState)([]);
    const [selectedSmileIndex, setSelectedSmileIndex] = (0, $acw62.useState)();
    const [isPublishAllowed, setIsPublishAllowed] = (0, $acw62.useState)(false);
    const selectedSmileRef = (0, $acw62.useRef)(null);
    const autoPublish = async ()=>{
        const publisherData = await getEditorData();
        onPublish(publisherData);
    };
    (0, $acw62.useEffect)(()=>{
        if (isPublishAllowed) {
            autoPublish();
            setIsPublishAllowed(false);
        }
    }, [
        inlineData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (autoReplaceText && textBeforeSpace && textBeforeSpace.endsWith(autoReplaceText)) replaceSmile(suggestedSmiles[0]);
    }, [
        autoReplaceText,
        textBeforeSpace,
        suggestedSmiles
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOutlineClick = (event2)=>{
            if (isOutlineClick(event2)) setSuggestedSmiles([]);
        };
        document.body.addEventListener("click", handleOutlineClick);
        return ()=>{
            document.body.removeEventListener("click", handleOutlineClick);
        };
    }, [
        isOutlineClick
    ]);
    const replaceSmile = (0, $acw62.useCallback)((smile2)=>{
        onAvailableSmileClick({
            smile: smile2,
            isReplaceWordOnCursor: true
        });
        setAutoReplaceText(null);
        setSuggestedSmiles([]);
    }, [
        onAvailableSmileClick,
        setSuggestedSmiles
    ]);
    const replaceSelectedSmile = (0, $acw62.useCallback)(()=>{
        const smile2 = suggestedSmiles[selectedSmileIndex];
        if (!smile2.access || smile2.access.allowed) {
            replaceSmile(smile2);
            return;
        }
        onUnavailableSmileClick(smile2.id, selectedSmileRef.current);
    }, [
        replaceSmile,
        suggestedSmiles,
        selectedSmileIndex
    ]);
    const replaceLastSmileAndPublish = (0, $acw62.useCallback)(()=>{
        if (autoReplaceText) {
            setIsPublishAllowed(true);
            replaceSmile(suggestedSmiles[0]);
            setAutoReplaceText(null);
            return;
        }
        autoPublish();
        if (!autoReplaceText) setSuggestedSmiles([]);
    }, [
        autoReplaceText,
        suggestedSmiles,
        replaceSmile,
        onPublish,
        setSuggestedSmiles
    ]);
    const onSmileClick = (0, $acw62.useCallback)((smile2, event2)=>{
        if (!smile2.access || smile2.access.allowed) {
            replaceSmile(smile2);
            return;
        }
        onUnavailableSmileClick(smile2.id, event2.target);
    }, [
        replaceSmile,
        onUnavailableSmileClick
    ]);
    const getSmileForSearch = (smile2, keySearchFor)=>({
            ...smile2,
            internalSearchName: smile2[keySearchFor].toLowerCase()
        });
    const getSmilesMap = (rawSmiles)=>{
        return rawSmiles.reduce((acc, smileBlock)=>{
            if (INVALID_FOR_SUGGEST_TYPES.includes(smileBlock.type)) return acc;
            const block2 = smileBlock.smiles.reduce((accumulator, smile2)=>{
                if (smile2.name !== smile2.baseName) accumulator.push(getSmileForSearch(smile2, "baseName"));
                accumulator.push(getSmileForSearch(smile2, "name"));
                return accumulator;
            }, []);
            acc.push(...block2);
            return acc;
        }, []);
    };
    const smilesComparatorByAccess = (a2, b2)=>{
        var _a3, _b2;
        const aAllowed = ((_a3 = a2.access) == null ? void 0 : _a3.allowed) === void 0;
        const bAllowed = ((_b2 = b2.access) == null ? void 0 : _b2.allowed) === void 0;
        if (aAllowed === bAllowed) return 0;
        if (aAllowed > bAllowed) return -1;
        return 1;
    };
    const smilesComparatorBySymbols = (a2, b2)=>a2.internalSearchName > b2.internalSearchName ? 1 : -1;
    const findMatches = (smilesMap2, currentStr)=>{
        if (!smilesMap2.length || !currentStr) return [];
        const lowerCurrentStr = currentStr.toLowerCase();
        let end = smilesMap2.length;
        let start = 0;
        let index2 = start + Math.ceil((end - start) / 2);
        while(start !== index2 && index2 !== end){
            if (smilesMap2[index2].internalSearchName.startsWith(lowerCurrentStr)) return findSpread(smilesMap2, index2, lowerCurrentStr);
            if (smilesMap2[index2].internalSearchName < lowerCurrentStr) start = index2;
            else end = index2;
            index2 = start + Math.ceil((end - start) / 2);
        }
        return [];
    };
    const findSpread = (smilesMap2, index2, currentStr)=>{
        let start = index2 - 1;
        let end = index2 + 1;
        while(smilesMap2[start] && smilesMap2[start].internalSearchName.startsWith(currentStr))--start;
        while(smilesMap2[end] && smilesMap2[end].internalSearchName.startsWith(currentStr))++end;
        return smilesMap2.slice(start + 1, end);
    };
    const smilesMap = (0, $acw62.useMemo)(()=>{
        if (!smiles2 || !smiles2.length) return [];
        return getSmilesMap(smiles2).sort(smilesComparatorBySymbols);
    }, [
        smiles2
    ]);
    const checkIsFullMatch = (matches2, str)=>matches2.length === 1 && (!matches2[0].access || matches2[0].access.allowed) && matches2[0].name.toLowerCase() === str.toLowerCase();
    const onSelectNextSmile = (0, $acw62.useCallback)(()=>{
        const nextIndex = selectedSmileIndex === suggestedSmiles.length - 1 ? 0 : selectedSmileIndex + 1;
        setSelectedSmileIndex(nextIndex);
    }, [
        suggestedSmiles.length,
        selectedSmileIndex
    ]);
    const onSelectPrevSmile = (0, $acw62.useCallback)(()=>{
        const prevIndex = selectedSmileIndex === 0 ? suggestedSmiles.length - 1 : selectedSmileIndex - 1;
        setSelectedSmileIndex(prevIndex);
    }, [
        suggestedSmiles.length,
        selectedSmileIndex
    ]);
    const getSuggestedSmiles = (0, $acw62.useCallback)((searchString, stringBeforeSpace)=>{
        setTextBeforeSpace(stringBeforeSpace);
        const matches2 = findMatches(smilesMap, searchString).sort(smilesComparatorByAccess);
        setAutoReplaceText(checkIsFullMatch(matches2, searchString) ? searchString : null);
        if (!isShowSuggestWithoutMaximalLimit && matches2.length > 5) {
            setSuggestedSmiles([]);
            return;
        }
        setSuggestedSmiles(matches2.slice(0, 5));
        setSelectedSmileIndex(0);
    }, [
        smilesMap
    ]);
    return {
        selectedSmileIndex: selectedSmileIndex,
        suggestedSmiles: suggestedSmiles,
        isSuggestEnabled: isSuggestEnabled,
        isNavigationEnabled: isNavigationEnabled,
        selectedSmileRef: selectedSmileRef,
        onSmileClick: onSmileClick,
        getSuggestedSmiles: getSuggestedSmiles,
        replaceLastSmileAndPublish: replaceLastSmileAndPublish,
        replaceSelectedSmile: replaceSelectedSmile,
        onSelectNextSmile: onSelectNextSmile,
        onSelectPrevSmile: onSelectPrevSmile
    };
};
const useUserStat = (blogUrl, slotUrl)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const [userStatPopupUserId, setUserStatPopupUserId] = (0, $acw62.useState)(null);
    const [userStatPopupOffset, setUserStatPopupOffset] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (userStatPopupUserId) fetchStreamChatUserStat$1(userStatPopupUserId);
    }, [
        userStatPopupUserId
    ]);
    const onUserClick = (0, $acw62.useCallback)((userId)=>{
        setUserStatPopupUserId(userId);
    }, []);
    const onCloseUserStatPopup = (0, $acw62.useCallback)(()=>{
        setUserStatPopupUserId(null);
        setUserStatPopupOffset(null);
    }, []);
    const onCalculateUserPopupOffset = (offset2)=>{
        setUserStatPopupOffset(offset2);
    };
    const fetchStreamChatUserStat$1 = (0, $acw62.useCallback)(async (userId, context)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUserStat.action)({
            blogUrl: blogUrl,
            userId: userId,
            context: context
        }));
    }, [
        blogUrl
    ]);
    const onBan = (0, $acw62.useCallback)(async (userId)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(blockUserPermanently.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId
        }));
        fetchStreamChatUserStat$1(userId);
    }, [
        blogUrl
    ]);
    const onBanCancel = (0, $acw62.useCallback)(async (userId, byStream)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(unblockUser.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId,
            byStream: byStream
        }));
        fetchStreamChatUserStat$1(userId);
    }, [
        blogUrl
    ]);
    const onHandleTimeout = (0, $acw62.useCallback)(async (userId, period)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(blockUserTemporarily.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            userId: userId,
            period: period
        }));
        fetchStreamChatUserStat$1(userId);
    }, [
        blogUrl
    ]);
    const onRoleChange = async (role2, userId)=>{
        if (role2 === EModeratorRoles.NONE) await dispatch((0, $7Uc0p.thunkToAction)(deleteRole)({
            blogUrl: blogUrl,
            userId: userId
        }));
        else await dispatch((0, $7Uc0p.thunkToAction)(setRole.action)({
            blogUrl: blogUrl,
            userId: userId,
            role: role2
        }));
    };
    return {
        userStatPopupUserId: userStatPopupUserId,
        userStatPopupOffset: userStatPopupOffset,
        onUserClick: onUserClick,
        onCloseUserStatPopup: onCloseUserStatPopup,
        onBan: onBan,
        onBanCancel: onBanCancel,
        onHandleTimeout: onHandleTimeout,
        onCalculateUserPopupOffset: onCalculateUserPopupOffset,
        onRoleChange: onRoleChange
    };
};
const useSubscribe$1 = (params)=>{
    const { externalBlogUrl, requiredLevelId, subscriptionPurchaseSource = EStatSubscriptionPurchaseStartSource.DIRECT } = params;
    const { isBlogOwner } = useCurrentUserAccess();
    const { blogUrl } = useStreamIdentity();
    const hasExternalBlog = Boolean(externalBlogUrl);
    const blogUrlParam = externalBlogUrl || blogUrl;
    const store2 = (0, $4TSkt.useStore)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const location2 = window.location;
    const navigate = (value2)=>{
        document.location.href = value2;
    };
    const { isAuthorized, showAuth } = useCurrentUserAccess();
    const isPaidSubscriptionBlog = (0, $iD0SF.useSelector)(isPaidSubscriptionSelector);
    const isPaidSubscriptionExternalBlog = (0, $iD0SF.useSelector)(isPaidSubscriptionExternalBlogSelector);
    const subscriptionLevels = (0, $iD0SF.useSelector)(subscriptionLevelsSelector);
    const subscriptionLevelsExternalBlog = (0, $iD0SF.useSelector)(subscriptionLevelsExternalBlogSelector);
    const levels = hasExternalBlog ? subscriptionLevelsExternalBlog : subscriptionLevels;
    const currentLevelBlog = (0, $iD0SF.useSelector)(currentLevelSelector);
    const currentLevelExternalBlog = (0, $iD0SF.useSelector)(currentLevelExternalBlogSelector);
    const currentLevel = hasExternalBlog ? currentLevelExternalBlog : currentLevelBlog;
    const previousLevel = usePrevious(currentLevel);
    const record2 = (0, $iD0SF.useSelector)(currentRecordSelector);
    const isPaidSubscription = hasExternalBlog ? isPaidSubscriptionExternalBlog : isPaidSubscriptionBlog;
    const isPaidSubscriptionRef = (0, $acw62.useRef)(0);
    const { blogUrl: streamPageBlogUrl, recordId: streamPageRecordId } = getPathParams(STREAM_PAGE_TABS, store2);
    const fetchRecord$1 = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchRecord.action)({
            blogUrl: blogUrlParam || streamPageBlogUrl,
            recordId: streamPageRecordId || record2.id
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (isPaidSubscriptionRef.current === 0 && !isPaidSubscription) isPaidSubscriptionRef.current = 1;
        if (isPaidSubscriptionRef.current === 1 && isPaidSubscription) {
            isPaidSubscriptionRef.current = 2;
            setTimeout(()=>{
                !hasExternalBlog && fetchRecord$1();
            }, 0);
        }
    }, [
        isPaidSubscription,
        blogUrlParam,
        streamPageBlogUrl,
        streamPageRecordId,
        record2
    ]);
    (0, $acw62.useEffect)(()=>{
        const isViewNotAllowed = (record2 == null ? void 0 : record2.accessRestrictions.view.allowed) === false;
        if (isViewNotAllowed && previousLevel && currentLevel.levelId !== previousLevel.levelId) fetchRecord$1();
    }, [
        currentLevel,
        record2
    ]);
    const requiredLevel = levels.find((level)=>level.id === requiredLevelId);
    const isAlreadySubscribed = requiredLevelId && currentLevel ? (requiredLevel == null ? void 0 : requiredLevel.price) <= (currentLevel == null ? void 0 : currentLevel.price) : isPaidSubscription;
    const showSubscriptionLevels = ()=>{
        const prevLocation = location2.pathname;
        navigate(getParametrizedUrl(`${prevLocation}/subscription`, {}, {
            [SUBSCRIPTION_PURCHASE_SOURCE_QUERY_PARAM_NAME]: subscriptionPurchaseSource
        }));
    };
    const showSubscriptionLevelPurchase = ()=>{
        const prevLocation = location2.pathname.replace("/subscription", "");
        navigate(getParametrizedUrl(`${prevLocation}/purchase/${requiredLevelId}`, {}, {
            [SUBSCRIPTION_PURCHASE_SOURCE_QUERY_PARAM_NAME]: subscriptionPurchaseSource
        }));
    };
    const onSubscribe = ()=>{
        if (!isAuthorized) {
            showAuth();
            AppStat.log.auth.openPopup({
                source: EStatAuthStartSource.SUBSCRIBE
            });
        } else if (requiredLevelId) showSubscriptionLevelPurchase();
        else showSubscriptionLevels();
    };
    const onRevertUnsubscribe = ()=>{
        dispatch(revertUnsubscribe.action({
            blogUrl: blogUrlParam
        }));
    };
    return {
        isBlogOwner: isBlogOwner,
        isAlreadySubscribed: isAlreadySubscribed,
        onRevertUnsubscribe: onRevertUnsubscribe,
        onSubscribe: onSubscribe
    };
};
const useChatSlowmodeTimer = (blogUrl)=>{
    const key = `${ELocalStorageKey.CHAT_SLOWMODE_START_TIME}:${blogUrl}`;
    const { anyMessageTimeout } = (0, $iD0SF.useSelector)(streamChatSettingsSelector);
    const anyMessageTimeoutMs = anyMessageTimeout * 1e3;
    const getStartTime = ()=>{
        return parseInt(getFromLocalStorage(key));
    };
    const setStartTime = (msTime)=>{
        setToLocalStorage(key, String(msTime));
    };
    const getTimer = ()=>{
        const expirationTime = getStartTime() + anyMessageTimeoutMs;
        return Math.max(expirationTime - Date.now(), 0);
    };
    const setTimer = (remainingTimeMs = anyMessageTimeoutMs)=>{
        setStartTime(Date.now() + remainingTimeMs - anyMessageTimeoutMs);
    };
    return {
        getTimer: getTimer,
        setTimer: setTimer
    };
};
const locales$1E = {
    timeoutOptions: {
        tenMinutes: "\u041D\u0430 10 \u043C\u0438\u043D\u0443\u0442",
        oneHour: "\u041D\u0430 \u0447\u0430\u0441",
        untilStreamEnd: "\u0414\u043E \u043A\u043E\u043D\u0446\u0430 \u0441\u0442\u0440\u0438\u043C\u0430"
    }
};
const t$1F = distExports$1.getTranslation && locales$1E;
const useChatTimeoutOptions = ()=>{
    return Object.values(EStreamUserTimeoutOptions).map((value2)=>({
            value: value2,
            label: t$1F.timeoutOptions[value2]
        }));
};
const useEditorCursorPosition = (params)=>{
    const { editorRef, handleKeyUp } = params;
    const cursorRef = (0, $acw62.useRef)({
        itemIndex: 0,
        offset: 0,
        breakItems: 0,
        blockIndex: 0
    });
    const onRestoreCursorPosition = (insertedElement)=>{
        var _a3;
        const paragraphs = editorRef.current.querySelectorAll(".ce-paragraph.cdx-block");
        if (paragraphs.length) {
            const paragraphIndex = ((_a3 = cursorRef.current) == null ? void 0 : _a3.blockIndex) ?? paragraphs.length - 1;
            const paragraph = paragraphs[paragraphIndex];
            if (insertedElement) setCaretAfterInsertedElement(paragraph, insertedElement, cursorRef);
            restoreCaretPosition(paragraph, cursorRef.current);
        }
    };
    const onKeyUp = (event2)=>{
        handleKeyUp == null || handleKeyUp(event2);
        cursorRef.current = getCaretPosition(event2.target);
    };
    const onMouseUp = (event2)=>{
        cursorRef.current = getCaretPosition(event2.target);
    };
    return {
        cursorRef: cursorRef,
        onKeyUp: onKeyUp,
        onMouseUp: onMouseUp,
        onRestoreCursorPosition: onRestoreCursorPosition
    };
};
const usePinnedMessageSettings = (blogUrl)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const editPinnedChatMessage$1 = ({ kind, reactable })=>{
        setToLocalStorage(ELocalStorageKey.PINNED_MESSAGE_SETTINGS, JSON.stringify({
            kind: kind,
            reactable: reactable
        }));
        dispatch((0, $7Uc0p.thunkToAction)(editPinnedChatMessage.action)({
            blogUrl: blogUrl,
            kind: kind,
            reactable: reactable
        }));
    };
    const unpinChatMessage$1 = ()=>{
        dispatch(unpinChatMessage.action({
            blogUrl: blogUrl
        }));
    };
    const addPinnedChatMessageReaction$1 = (reaction)=>{
        dispatch((0, $7Uc0p.thunkToAction)(addPinnedChatMessageReaction.action)({
            blogUrl: blogUrl,
            reaction: reaction
        }));
    };
    const getSettings = (0, $acw62.useCallback)(()=>{
        const settings2 = getFromLocalStorage(ELocalStorageKey.PINNED_MESSAGE_SETTINGS);
        if (settings2) try {
            return JSON.parse(settings2);
        } catch (e2) {}
        return {
            kind: EPinnedMessageKind.PERMANENT,
            reactable: true
        };
    }, []);
    const pinChatMessage$1 = (0, $acw62.useCallback)((messageId)=>{
        const { kind, reactable } = getSettings();
        dispatch(pinChatMessage.action({
            blogUrl: blogUrl,
            kind: kind,
            messageId: messageId,
            reactable: reactable
        }));
    }, [
        getSettings,
        blogUrl
    ]);
    return {
        editPinnedChatMessage: editPinnedChatMessage$1,
        unpinChatMessage: unpinChatMessage$1,
        addPinnedChatMessageReaction: addPinnedChatMessageReaction$1,
        pinChatMessage: pinChatMessage$1
    };
};
var OutsideClickHandler$1 = {};
var mocks;
var hasRequiredMocks;
function requireMocks() {
    if (hasRequiredMocks) return mocks;
    hasRequiredMocks = 1;
    function noop2() {
        return null;
    }
    noop2.isRequired = noop2;
    function noopThunk() {
        return noop2;
    }
    mocks = {
        and: noopThunk,
        between: noopThunk,
        booleanSome: noopThunk,
        childrenHavePropXorChildren: noopThunk,
        childrenOf: noopThunk,
        childrenOfType: noopThunk,
        childrenSequenceOf: noopThunk,
        componentWithName: noopThunk,
        disallowedIf: noopThunk,
        elementType: noopThunk,
        empty: noopThunk,
        explicitNull: noopThunk,
        forbidExtraProps: Object,
        integer: noopThunk,
        keysOf: noopThunk,
        mutuallyExclusiveProps: noopThunk,
        mutuallyExclusiveTrueProps: noopThunk,
        nChildren: noopThunk,
        nonNegativeInteger: noop2,
        nonNegativeNumber: noopThunk,
        numericString: noopThunk,
        object: noopThunk,
        or: noopThunk,
        predicate: noopThunk,
        range: noopThunk,
        ref: noopThunk,
        requiredBy: noopThunk,
        restrictedProp: noopThunk,
        sequenceOf: noopThunk,
        shape: noopThunk,
        stringEndsWith: noopThunk,
        stringStartsWith: noopThunk,
        uniqueArray: noopThunk,
        uniqueArrayOf: noopThunk,
        valuesOf: noopThunk,
        withShape: noopThunk
    };
    return mocks;
}
var build$1 = {
    exports: {}
};
var toStr$2 = Object.prototype.toString;
var isArguments = function isArguments2(value2) {
    var str = toStr$2.call(value2);
    var isArgs2 = str === "[object Arguments]";
    if (!isArgs2) isArgs2 = str !== "[object Array]" && value2 !== null && typeof value2 === "object" && typeof value2.length === "number" && value2.length >= 0 && toStr$2.call(value2.callee) === "[object Function]";
    return isArgs2;
};
var implementation$e;
var hasRequiredImplementation$6;
function requireImplementation$6() {
    if (hasRequiredImplementation$6) return implementation$e;
    hasRequiredImplementation$6 = 1;
    var keysShim2;
    if (!Object.keys) {
        var has2 = Object.prototype.hasOwnProperty;
        var toStr2 = Object.prototype.toString;
        var isArgs2 = isArguments;
        var isEnumerable = Object.prototype.propertyIsEnumerable;
        var hasDontEnumBug = !isEnumerable.call({
            toString: null
        }, "toString");
        var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
        var dontEnums = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ];
        var equalsConstructorPrototype = function(o2) {
            var ctor = o2.constructor;
            return ctor && ctor.prototype === o2;
        };
        var excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var hasAutomationEqualityBug = function() {
            if (typeof window === "undefined") return false;
            for(var k2 in window)try {
                if (!excludedKeys["$" + k2] && has2.call(window, k2) && window[k2] !== null && typeof window[k2] === "object") try {
                    equalsConstructorPrototype(window[k2]);
                } catch (e2) {
                    return true;
                }
            } catch (e2) {
                return true;
            }
            return false;
        }();
        var equalsConstructorPrototypeIfNotBuggy = function(o2) {
            if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o2);
            try {
                return equalsConstructorPrototype(o2);
            } catch (e2) {
                return false;
            }
        };
        keysShim2 = function keys3(object2) {
            var isObject2 = object2 !== null && typeof object2 === "object";
            var isFunction3 = toStr2.call(object2) === "[object Function]";
            var isArguments3 = isArgs2(object2);
            var isString2 = isObject2 && toStr2.call(object2) === "[object String]";
            var theKeys = [];
            if (!isObject2 && !isFunction3 && !isArguments3) throw new TypeError("Object.keys called on a non-object");
            var skipProto = hasProtoEnumBug && isFunction3;
            if (isString2 && object2.length > 0 && !has2.call(object2, 0)) for(var i = 0; i < object2.length; ++i)theKeys.push(String(i));
            if (isArguments3 && object2.length > 0) for(var j2 = 0; j2 < object2.length; ++j2)theKeys.push(String(j2));
            else {
                for(var name2 in object2)if (!(skipProto && name2 === "prototype") && has2.call(object2, name2)) theKeys.push(String(name2));
            }
            if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
                for(var k2 = 0; k2 < dontEnums.length; ++k2)if (!(skipConstructor && dontEnums[k2] === "constructor") && has2.call(object2, dontEnums[k2])) theKeys.push(dontEnums[k2]);
            }
            return theKeys;
        };
    }
    implementation$e = keysShim2;
    return implementation$e;
}
var slice = Array.prototype.slice;
var isArgs = isArguments;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o2) {
    return origKeys(o2);
} : requireImplementation$6();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys3(object2) {
            if (isArgs(object2)) return originalKeys(slice.call(object2));
            return originalKeys(object2);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
var objectKeys = keysShim;
var shams$1 = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$2 = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};
var test = {
    foo: {}
};
var $Object = Object;
var hasProto$1 = function hasProto() {
    return ({
        __proto__: test
    }).foo === test.foo && !(({
        __proto__: null
    }) instanceof $Object);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$1 = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a2, b2) {
    var arr = [];
    for(var i = 0; i < a2.length; i += 1)arr[i] = a2[i];
    for(var j2 = 0; j2 < b2.length; j2 += 1)arr[j2 + a2.length] = b2[j2];
    return arr;
};
var slicy = function slicy2(arrLike, offset2) {
    var arr = [];
    for(var i = offset2, j2 = 0; i < arrLike.length; i += 1, j2 += 1)arr[j2] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
var implementation$d = function bind2(that) {
    var target2 = this;
    if (typeof target2 !== "function" || toStr$1.apply(target2) !== funcType) throw new TypeError(ERROR_MESSAGE + target2);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result2 = target2.apply(this, concatty(args, arguments));
            if (Object(result2) === result2) return result2;
            return this;
        }
        return target2.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target2.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target2.prototype) {
        var Empty = function Empty2() {};
        Empty.prototype = target2.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};
var implementation$c = implementation$d;
var functionBind = Function.prototype.bind || implementation$c;
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;
var hasown = bind$1.call(call, $hasOwn);
var undefined$1;
var $SyntaxError$1 = SyntaxError;
var $Function = Function;
var $TypeError$3 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e2) {}
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) try {
    $gOPD$1({}, "");
} catch (e2) {
    $gOPD$1 = null;
}
var throwTypeError = function() {
    throw new $TypeError$3();
};
var ThrowTypeError = $gOPD$1 ? function() {
    try {
        arguments.callee;
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            return $gOPD$1(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols$1 = hasSymbols$2();
var hasProto2 = hasProto$1();
var getProto = Object.getPrototypeOf || (hasProto2 ? function(x2) {
    return x2.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols$1 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols$1 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$1 || !getProto ? undefined$1 : getProto(/* @__PURE__ */ new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$1 || !getProto ? undefined$1 : getProto(/* @__PURE__ */ new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols$1 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols$1 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError$1,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError$3,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto) try {
    null.error;
} catch (e2) {
    var errorProto = getProto(getProto(e2));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval2(name2) {
    var value2;
    if (name2 === "%AsyncFunction%") value2 = getEvalledConstructor("async function () {}");
    else if (name2 === "%GeneratorFunction%") value2 = getEvalledConstructor("function* () {}");
    else if (name2 === "%AsyncGeneratorFunction%") value2 = getEvalledConstructor("async function* () {}");
    else if (name2 === "%AsyncGenerator%") {
        var fn2 = doEval2("%AsyncGeneratorFunction%");
        if (fn2) value2 = fn2.prototype;
    } else if (name2 === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen && getProto) value2 = getProto(gen.prototype);
    }
    INTRINSICS[name2] = value2;
    return value2;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind3 = functionBind;
var hasOwn = hasown;
var $concat = bind3.call(Function.call, Array.prototype.concat);
var $spliceApply = bind3.call(Function.apply, Array.prototype.splice);
var $replace = bind3.call(Function.call, String.prototype.replace);
var $strSlice = bind3.call(Function.call, String.prototype.slice);
var $exec = bind3.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
    var first = $strSlice(string, 0, 1);
    var last2 = $strSlice(string, -1);
    if (first === "%" && last2 !== "%") throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
    else if (last2 === "%" && first !== "%") throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
    var result2 = [];
    $replace(string, rePropName, function(match2, number, quote, subString) {
        result2[result2.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match2;
    });
    return result2;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
    var intrinsicName = name2;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value2 = INTRINSICS[intrinsicName];
        if (value2 === needsEval) value2 = doEval(intrinsicName);
        if (typeof value2 === "undefined" && !allowMissing) throw new $TypeError$3("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value2
        };
    }
    throw new $SyntaxError$1("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
    if (typeof name2 !== "string" || name2.length === 0) throw new $TypeError$3("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError$3('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name2) === null) throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name2);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value2 = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last2 = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last2 === '"' || last2 === "'" || last2 === "`") && first !== last2) throw new $SyntaxError$1("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value2 = INTRINSICS[intrinsicRealName];
        else if (value2 != null) {
            if (!(part in value2)) {
                if (!allowMissing) throw new $TypeError$3("base intrinsic for " + name2 + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD$1 && i + 1 >= parts.length) {
                var desc = $gOPD$1(value2, part);
                isOwn = !!desc;
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value2 = desc.get;
                else value2 = value2[part];
            } else {
                isOwn = hasOwn(value2, part);
                value2 = value2[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value2;
        }
    }
    return value2;
};
var GetIntrinsic$5 = getIntrinsic;
var $defineProperty$1 = GetIntrinsic$5("%Object.defineProperty%", true);
var hasPropertyDescriptors$1 = function hasPropertyDescriptors() {
    if ($defineProperty$1) try {
        $defineProperty$1({}, "a", {
            value: 1
        });
        return true;
    } catch (e2) {
        return false;
    }
    return false;
};
hasPropertyDescriptors$1.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    if (!hasPropertyDescriptors$1()) return null;
    try {
        return $defineProperty$1([], "length", {
            value: 1
        }).length !== 1;
    } catch (e2) {
        return true;
    }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors$1;
var GetIntrinsic$4 = getIntrinsic;
var $gOPD = GetIntrinsic$4("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e2) {
    $gOPD = null;
}
var gopd$1 = $gOPD;
var hasPropertyDescriptors2 = hasPropertyDescriptors_1();
var GetIntrinsic$3 = getIntrinsic;
var $defineProperty = hasPropertyDescriptors2 && GetIntrinsic$3("%Object.defineProperty%", true);
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e2) {
    $defineProperty = false;
}
var $SyntaxError = GetIntrinsic$3("%SyntaxError%");
var $TypeError$2 = GetIntrinsic$3("%TypeError%");
var gopd = gopd$1;
var defineDataProperty$1 = function defineDataProperty(obj, property2, value2) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError$2("`obj` must be an object or a function`");
    if (typeof property2 !== "string" && typeof property2 !== "symbol") throw new $TypeError$2("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError$2("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError$2("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError$2("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError$2("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    var desc = !!gopd && gopd(obj, property2);
    if ($defineProperty) $defineProperty(obj, property2, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value2,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) obj[property2] = value2;
    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};
var keys2 = objectKeys;
var hasSymbols2 = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty2 = defineDataProperty$1;
var isFunction2 = function(fn2) {
    return typeof fn2 === "function" && toStr.call(fn2) === "[object Function]";
};
var supportsDescriptors = hasPropertyDescriptors_1();
var defineProperty = function(object2, name2, value2, predicate2) {
    if (name2 in object2) {
        if (predicate2 === true) {
            if (object2[name2] === value2) return;
        } else if (!isFunction2(predicate2) || !predicate2()) return;
    }
    if (supportsDescriptors) defineDataProperty2(object2, name2, value2, true);
    else defineDataProperty2(object2, name2, value2);
};
var defineProperties = function(object2, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys2(map);
    if (hasSymbols2) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object2, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;
var callBind$2 = {
    exports: {}
};
var GetIntrinsic$2 = getIntrinsic;
var define$3 = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var gOPD = gopd$1;
var $TypeError$1 = GetIntrinsic$2("%TypeError%");
var $floor = GetIntrinsic$2("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn2, length) {
    if (typeof fn2 !== "function") throw new $TypeError$1("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) throw new $TypeError$1("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn2 && gOPD) {
        var desc = gOPD(fn2, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define$3(/** @type {Parameters<define>[0]} */ fn2, "length", length, true, true);
        else define$3(/** @type {Parameters<define>[0]} */ fn2, "length", length);
    }
    return fn2;
};
(function(module2) {
    var bind4 = functionBind;
    var GetIntrinsic3 = getIntrinsic;
    var setFunctionLength$1 = setFunctionLength;
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    var $apply = GetIntrinsic3("%Function.prototype.apply%");
    var $call = GetIntrinsic3("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind4.call($call, $apply);
    var $defineProperty2 = GetIntrinsic3("%Object.defineProperty%", true);
    var $max = GetIntrinsic3("%Math.max%");
    if ($defineProperty2) try {
        $defineProperty2({}, "a", {
            value: 1
        });
    } catch (e2) {
        $defineProperty2 = null;
    }
    module2.exports = function callBind2(originalFunction) {
        if (typeof originalFunction !== "function") throw new $TypeError2("a function is required");
        var func = $reflectApply(bind4, $call, arguments);
        return setFunctionLength$1(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
    };
    var applyBind = function applyBind2() {
        return $reflectApply(bind4, $apply, arguments);
    };
    if ($defineProperty2) $defineProperty2(module2.exports, "apply", {
        value: applyBind
    });
    else module2.exports.apply = applyBind;
})(callBind$2);
var callBindExports = callBind$2.exports;
var GetIntrinsic$1 = getIntrinsic;
var callBind$1 = callBindExports;
var $indexOf = callBind$1(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name2, allowMissing) {
    var intrinsic = GetIntrinsic$1(name2, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) return callBind$1(intrinsic);
    return intrinsic;
};
var implementation$b;
var hasRequiredImplementation$5;
function requireImplementation$5() {
    if (hasRequiredImplementation$5) return implementation$b;
    hasRequiredImplementation$5 = 1;
    var objectKeys$1 = objectKeys;
    var hasSymbols3 = shams$1();
    var callBound2 = callBound$1;
    var toObject = Object;
    var $push2 = callBound2("Array.prototype.push");
    var $propIsEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
    var originalGetSymbols = hasSymbols3 ? Object.getOwnPropertySymbols : null;
    implementation$b = function assign(target2, source1) {
        if (target2 == null) throw new TypeError("target must be an object");
        var to = toObject(target2);
        if (arguments.length === 1) return to;
        for(var s2 = 1; s2 < arguments.length; ++s2){
            var from2 = toObject(arguments[s2]);
            var keys3 = objectKeys$1(from2);
            var getSymbols2 = hasSymbols3 && (Object.getOwnPropertySymbols || originalGetSymbols);
            if (getSymbols2) {
                var syms = getSymbols2(from2);
                for(var j2 = 0; j2 < syms.length; ++j2){
                    var key = syms[j2];
                    if ($propIsEnumerable(from2, key)) $push2(keys3, key);
                }
            }
            for(var i = 0; i < keys3.length; ++i){
                var nextKey = keys3[i];
                if ($propIsEnumerable(from2, nextKey)) {
                    var propValue = from2[nextKey];
                    to[nextKey] = propValue;
                }
            }
        }
        return to;
    };
    return implementation$b;
}
var polyfill$9;
var hasRequiredPolyfill$5;
function requirePolyfill$5() {
    if (hasRequiredPolyfill$5) return polyfill$9;
    hasRequiredPolyfill$5 = 1;
    var implementation2 = requireImplementation$5();
    var lacksProperEnumerationOrder = function() {
        if (!Object.assign) return false;
        var str = "abcdefghijklmnopqrst";
        var letters = str.split("");
        var map = {};
        for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
        var obj = Object.assign({}, map);
        var actual = "";
        for(var k2 in obj)actual += k2;
        return str !== actual;
    };
    var assignHasPendingExceptions = function() {
        if (!Object.assign || !Object.preventExtensions) return false;
        var thrower = Object.preventExtensions({
            1: 2
        });
        try {
            Object.assign(thrower, "xy");
        } catch (e2) {
            return thrower[1] === "y";
        }
        return false;
    };
    polyfill$9 = function getPolyfill4() {
        if (!Object.assign) return implementation2;
        if (lacksProperEnumerationOrder()) return implementation2;
        if (assignHasPendingExceptions()) return implementation2;
        return Object.assign;
    };
    return polyfill$9;
}
var shim$9;
var hasRequiredShim$6;
function requireShim$6() {
    if (hasRequiredShim$6) return shim$9;
    hasRequiredShim$6 = 1;
    var define2 = defineProperties_1;
    var getPolyfill4 = requirePolyfill$5();
    shim$9 = function shimAssign() {
        var polyfill2 = getPolyfill4();
        define2(Object, {
            assign: polyfill2
        }, {
            assign: function() {
                return Object.assign !== polyfill2;
            }
        });
        return polyfill2;
    };
    return shim$9;
}
var object_assign;
var hasRequiredObject_assign;
function requireObject_assign() {
    if (hasRequiredObject_assign) return object_assign;
    hasRequiredObject_assign = 1;
    var defineProperties2 = defineProperties_1;
    var callBind2 = callBindExports;
    var implementation2 = requireImplementation$5();
    var getPolyfill4 = requirePolyfill$5();
    var shim2 = requireShim$6();
    var polyfill2 = callBind2.apply(getPolyfill4());
    var bound = function assign(target2, source1) {
        return polyfill2(Object, arguments);
    };
    defineProperties2(bound, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    object_assign = bound;
    return object_assign;
}
var src;
var hasRequiredSrc;
function requireSrc() {
    if (hasRequiredSrc) return src;
    hasRequiredSrc = 1;
    var hasOwnProperty2 = {}.hasOwnProperty;
    var call2 = Function.prototype.call;
    src = call2.bind ? call2.bind(hasOwnProperty2) : function(O2, P2) {
        return call2.call(hasOwnProperty2, O2, P2);
    };
    return src;
}
var isPlainObject$1 = {
    exports: {}
};
var hasRequiredIsPlainObject$1;
function requireIsPlainObject$1() {
    if (hasRequiredIsPlainObject$1) return isPlainObject$1.exports;
    hasRequiredIsPlainObject$1 = 1;
    (function(module2, exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports2["default"] = isPlainObject2;
        function isPlainObject2(x2) {
            return x2 && (typeof x2 === "undefined" ? "undefined" : _typeof2(x2)) === "object" && !Array.isArray(x2);
        }
        module2.exports = exports2["default"];
    })(isPlainObject$1, isPlainObject$1.exports);
    return isPlainObject$1.exports;
}
var hasRequiredBuild$1;
function requireBuild$1() {
    if (hasRequiredBuild$1) return build$1.exports;
    hasRequiredBuild$1 = 1;
    (function(module2, exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = forbidExtraProps;
        var _object = requireObject_assign();
        var _object2 = _interopRequireDefault2(_object);
        var _has = requireSrc();
        var _has2 = _interopRequireDefault2(_has);
        var _isPlainObject = requireIsPlainObject$1();
        var _isPlainObject2 = _interopRequireDefault2(_isPlainObject);
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        var zeroWidthSpace = "\u200B";
        var specialProperty = "prop-types-exact: " + zeroWidthSpace;
        var semaphore = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"](specialProperty) : /* istanbul ignore next */ specialProperty;
        function brand(fn2) {
            return (0, _object2["default"])(fn2, _defineProperty({}, specialProperty, semaphore));
        }
        function isBranded(value2) {
            return value2 && value2[specialProperty] === semaphore;
        }
        function forbidExtraProps(propTypes2) {
            if (!(0, _isPlainObject2["default"])(propTypes2)) throw new TypeError("given propTypes must be an object");
            if ((0, _has2["default"])(propTypes2, specialProperty) && !isBranded(propTypes2[specialProperty])) throw new TypeError("Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`");
            return (0, _object2["default"])({}, propTypes2, _defineProperty({}, specialProperty, brand(/* @__PURE__ */ function() {
                function forbidUnknownProps(props, _2, componentName) {
                    var unknownProps = Object.keys(props).filter(function(prop) {
                        return !(0, _has2["default"])(propTypes2, prop);
                    });
                    if (unknownProps.length > 0) return new TypeError(String(componentName) + ": unknown props found: " + String(unknownProps.join(", ")));
                    return null;
                }
                return forbidUnknownProps;
            }())));
        }
        module2.exports = exports2["default"];
    })(build$1, build$1.exports);
    return build$1.exports;
}
var and = {};
var wrapValidator = {};
var hasRequiredWrapValidator;
function requireWrapValidator() {
    if (hasRequiredWrapValidator) return wrapValidator;
    hasRequiredWrapValidator = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = wrapValidator2;
        var _object = _interopRequireDefault2(requireObject_assign());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function wrapValidator2(validator2, typeName) {
            var typeChecker = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            return (0, _object["default"])(validator2.bind(), {
                typeName: typeName,
                typeChecker: typeChecker,
                isRequired: (0, _object["default"])(validator2.isRequired.bind(), {
                    typeName: typeName,
                    typeChecker: typeChecker,
                    typeRequired: true
                })
            });
        }
    })(wrapValidator);
    return wrapValidator;
}
var hasRequiredAnd;
function requireAnd() {
    if (hasRequiredAnd) return and;
    hasRequiredAnd = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = andValidator;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function andValidator(validators2) {
            var name2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and";
            if (!Array.isArray(validators2)) throw new TypeError("and: 2 or more validators are required");
            if (validators2.length <= 1) throw new RangeError("and: 2 or more validators are required");
            var validator2 = function and2() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var firstError = null;
                validators2.some(function(validatorFn) {
                    firstError = validatorFn.apply(void 0, args);
                    return firstError != null;
                });
                return firstError == null ? null : firstError;
            };
            validator2.isRequired = function andIsRequired() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                var firstError = null;
                validators2.some(function(validatorFn) {
                    firstError = validatorFn.isRequired.apply(validatorFn, args);
                    return firstError != null;
                });
                return firstError == null ? null : firstError;
            };
            return (0, _wrapValidator["default"])(validator2, name2, validators2);
        }
    })(and);
    return and;
}
var between2 = {};
var GetIntrinsic2 = getIntrinsic;
var $TypeError = GetIntrinsic2("%TypeError%");
var CheckObjectCoercible = function CheckObjectCoercible2(value2, optMessage) {
    if (value2 == null) throw new $TypeError(optMessage || "Cannot call method on " + value2);
    return value2;
};
var RequireObjectCoercible$1 = CheckObjectCoercible;
var implementation$a;
var hasRequiredImplementation$4;
function requireImplementation$4() {
    if (hasRequiredImplementation$4) return implementation$a;
    hasRequiredImplementation$4 = 1;
    var RequireObjectCoercible2 = RequireObjectCoercible$1;
    var callBound2 = callBound$1;
    var $isEnumerable2 = callBound2("Object.prototype.propertyIsEnumerable");
    var $push2 = callBound2("Array.prototype.push");
    implementation$a = function entries(O2) {
        var obj = RequireObjectCoercible2(O2);
        var entrys = [];
        for(var key in obj)if ($isEnumerable2(obj, key)) $push2(entrys, [
            key,
            obj[key]
        ]);
        return entrys;
    };
    return implementation$a;
}
var polyfill$8;
var hasRequiredPolyfill$4;
function requirePolyfill$4() {
    if (hasRequiredPolyfill$4) return polyfill$8;
    hasRequiredPolyfill$4 = 1;
    var implementation2 = requireImplementation$4();
    polyfill$8 = function getPolyfill4() {
        return typeof Object.entries === "function" ? Object.entries : implementation2;
    };
    return polyfill$8;
}
var shim$8;
var hasRequiredShim$5;
function requireShim$5() {
    if (hasRequiredShim$5) return shim$8;
    hasRequiredShim$5 = 1;
    var getPolyfill4 = requirePolyfill$4();
    var define2 = defineProperties_1;
    shim$8 = function shimEntries() {
        var polyfill2 = getPolyfill4();
        define2(Object, {
            entries: polyfill2
        }, {
            entries: function testEntries() {
                return Object.entries !== polyfill2;
            }
        });
        return polyfill2;
    };
    return shim$8;
}
var object_entries;
var hasRequiredObject_entries;
function requireObject_entries() {
    if (hasRequiredObject_entries) return object_entries;
    hasRequiredObject_entries = 1;
    var define2 = defineProperties_1;
    var callBind2 = callBindExports;
    var implementation2 = requireImplementation$4();
    var getPolyfill4 = requirePolyfill$4();
    var shim2 = requireShim$5();
    var polyfill2 = callBind2(getPolyfill4(), Object);
    define2(polyfill2, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    object_entries = polyfill2;
    return object_entries;
}
var shape = {};
var isPlainObject = {};
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
    if (hasRequiredIsPlainObject) return isPlainObject;
    hasRequiredIsPlainObject = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _isPlainObject = _interopRequireDefault2(requireIsPlainObject$1());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var _default2 = _isPlainObject["default"];
        exports2["default"] = _default2;
    })(isPlainObject);
    return isPlainObject;
}
var hasRequiredShape;
function requireShape() {
    if (hasRequiredShape) return shape;
    hasRequiredShape = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = shapeValidator;
        var _isPlainObject = _interopRequireDefault2(requireIsPlainObject());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function shapeValidator(shapeTypes) {
            if (!(0, _isPlainObject["default"])(shapeTypes)) throw new TypeError("shape must be a normal object");
            function shape2(props, propName, componentName, location2) {
                var propValue = props[propName];
                if (propValue == null) return null;
                for(var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)rest[_key - 4] = arguments[_key];
                for(var key in shapeTypes){
                    var checker = shapeTypes[key];
                    if (checker) {
                        var error2 = checker.apply(void 0, [
                            propValue,
                            key,
                            componentName,
                            location2
                        ].concat(rest));
                        if (error2) return error2;
                    }
                }
                return null;
            }
            shape2.isRequired = function shapeRequired(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return shape2.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(shape2, "shape", shapeTypes);
        }
    })(shape);
    return shape;
}
var valuesOf = {};
var isPrimitive$2 = {};
var hasRequiredIsPrimitive$2;
function requireIsPrimitive$2() {
    if (hasRequiredIsPrimitive$2) return isPrimitive$2;
    hasRequiredIsPrimitive$2 = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = isPrimitive2;
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function isPrimitive2(x2) {
            return !x2 || _typeof2(x2) !== "object" && typeof x2 !== "function";
        }
    })(isPrimitive$2);
    return isPrimitive$2;
}
var hasRequiredValuesOf;
function requireValuesOf() {
    if (hasRequiredValuesOf) return valuesOf;
    hasRequiredValuesOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = valuesOfValidator;
        var _isPrimitive = _interopRequireDefault2(requireIsPrimitive$2());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function valuesOfValidator(propType) {
            if (typeof propType !== "function") throw new TypeError("objectOf: propType must be a function");
            var validator2 = function valuesOf2(props, propName, componentName, location2, propFullName) {
                for(var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
                var propValue = props[propName];
                if (propValue == null || (0, _isPrimitive["default"])(propValue)) return null;
                var firstError;
                Object.keys(propValue).some(function(key) {
                    firstError = propType.apply(void 0, [
                        propValue,
                        key,
                        componentName,
                        location2,
                        "".concat(propFullName, ".").concat(key)
                    ].concat(rest));
                    return firstError;
                });
                return firstError || null;
            };
            validator2.isRequired = function valuesOfRequired(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return validator2.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "valuesOf", propType);
        }
    })(valuesOf);
    return valuesOf;
}
var hasRequiredBetween;
function requireBetween() {
    if (hasRequiredBetween) return between2;
    hasRequiredBetween = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = betweenValidator;
        var _object = _interopRequireDefault2(requireObject_entries());
        var _shape = _interopRequireDefault2(requireShape());
        var _valuesOf = _interopRequireDefault2(requireValuesOf());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        function _slicedToArray2(arr, i) {
            return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest2();
        }
        function _nonIterableRest2() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o2, minLen) {
            if (!o2) return;
            if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
            var n2 = Object.prototype.toString.call(o2).slice(8, -1);
            if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o2);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
        }
        function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;
            for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
            return arr2;
        }
        function _iterableToArrayLimit2(arr, i) {
            if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = void 0;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"] != null) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        function _arrayWithHoles2(arr) {
            if (Array.isArray(arr)) return arr;
        }
        function number(props, propName, componentName) {
            var value2 = props[propName];
            if (typeof value2 === "number" && !isNaN(value2)) return null;
            return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
        }
        function numberOrPropsFunc(props, propName) {
            var value2 = props[propName];
            if (typeof value2 === "function") return null;
            if (typeof value2 === "number" && !isNaN(value2)) return null;
            return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
        }
        function lowerCompare(value2, _ref) {
            var gt = _ref.gt, gte = _ref.gte;
            if (typeof gt === "number") return value2 > gt;
            if (typeof gte === "number") return value2 >= gte;
            return true;
        }
        function upperCompare(value2, _ref2) {
            var lt = _ref2.lt, lte = _ref2.lte;
            if (typeof lt === "number") return value2 < lt;
            if (typeof lte === "number") return value2 <= lte;
            return true;
        }
        function greaterThanError(_ref3) {
            var gt = _ref3.gt, gte = _ref3.gte;
            if (typeof gt === "number") return "greater than ".concat(gt);
            if (typeof gte === "number") return "greater than or equal to ".concat(gte);
            return "";
        }
        function lessThanError(_ref4) {
            var lt = _ref4.lt, lte = _ref4.lte;
            if (typeof lt === "number") return "less than ".concat(lt);
            if (typeof lte === "number") return "less than or equal to ".concat(lte);
            return "";
        }
        function errorMessage(componentName, propName, opts) {
            var errors = [
                greaterThanError(opts),
                lessThanError(opts)
            ].filter(Boolean).join(" and ");
            return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
        }
        function propsThunkify(opts) {
            return (0, _object["default"])(opts).reduce(function(acc, _ref5) {
                var _ref6 = _slicedToArray2(_ref5, 2), key = _ref6[0], value2 = _ref6[1];
                var numberThunk = typeof value2 === "number" ? function() {
                    return value2;
                } : value2;
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, numberThunk));
            }, {});
        }
        function invokeWithProps(optsThunks, props) {
            return (0, _object["default"])(optsThunks).reduce(function(acc, _ref7) {
                var _ref8 = _slicedToArray2(_ref7, 2), key = _ref8[0], thunk = _ref8[1];
                var value2 = thunk(props);
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value2));
            }, {});
        }
        var argValidators = [
            (0, _shape["default"])({
                lt: numberOrPropsFunc,
                gt: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                lte: numberOrPropsFunc,
                gt: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                lt: numberOrPropsFunc,
                gte: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                lte: numberOrPropsFunc,
                gte: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                lt: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                lte: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                gt: numberOrPropsFunc
            }).isRequired,
            (0, _shape["default"])({
                gte: numberOrPropsFunc
            }).isRequired
        ];
        function argValidator(props, propName) {
            return argValidators.every(function(validator2) {
                return !!validator2(props, propName);
            });
        }
        var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;
        function betweenValidator(options) {
            var argError = argValidator({
                options: options
            }, "options");
            if (argError) throw new TypeError("between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.");
            var optsThunks = propsThunkify(options);
            var validator2 = function between3(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return null;
                if (typeof propValue !== "number") return new RangeError("".concat(componentName, ": ").concat(propName, ' must be a number, got "').concat(_typeof2(propValue), '"'));
                var opts = invokeWithProps(optsThunks, props);
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                var thunkValuesError = thunkValueValidator.apply(void 0, [
                    _defineProperty({}, propName, opts),
                    propName,
                    componentName
                ].concat(rest));
                if (thunkValuesError) return thunkValuesError;
                if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) return new RangeError(errorMessage(componentName, propName, opts));
                return null;
            };
            validator2.isRequired = function betweenRequired(props, propName, componentName) {
                var propValue = props[propName];
                if (typeof propValue !== "number") return new RangeError("".concat(componentName, ": ").concat(propName, ' must be a number, got "').concat(_typeof2(propValue), '"'));
                var opts = invokeWithProps(optsThunks, props);
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                var thunkValuesError = thunkValueValidator.apply(void 0, [
                    _defineProperty({}, propName, opts),
                    propName,
                    componentName
                ].concat(rest));
                if (thunkValuesError) return thunkValuesError;
                if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) return new RangeError(errorMessage(componentName, propName, opts));
                return null;
            };
            return (0, _wrapValidator["default"])(validator2, "between", options);
        }
    })(between2);
    return between2;
}
var booleanSome = {};
var hasRequiredBooleanSome;
function requireBooleanSome() {
    if (hasRequiredBooleanSome) return booleanSome;
    hasRequiredBooleanSome = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = booleanSomeValidator;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function booleanSomeValidator() {
            for(var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++)notAllPropsFalse[_key] = arguments[_key];
            if (notAllPropsFalse.length < 1) throw new TypeError("at least one prop (one of which must be `true`) is required");
            if (!notAllPropsFalse.every(function(x2) {
                return typeof x2 === "string";
            })) throw new TypeError("all booleanSome props must be strings");
            var propsList = notAllPropsFalse.join(", or ");
            var validator2 = function booleanSome2(props, propName, componentName) {
                var countFalse = function countFalse2(count2, prop) {
                    return count2 + (props[prop] === false ? 1 : 0);
                };
                var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);
                if (falsePropCount === notAllPropsFalse.length) return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return _propTypes2.bool.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            validator2.isRequired = function booleanSomeRequired(props, propName, componentName) {
                var countFalse = function countFalse2(count2, prop) {
                    return count2 + (props[prop] === false ? 1 : 0);
                };
                var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);
                if (falsePropCount === notAllPropsFalse.length) return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return _propTypes2.bool.isRequired.apply(_propTypes2.bool, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "booleanSome: ".concat(propsList), notAllPropsFalse);
        }
    })(booleanSome);
    return booleanSome;
}
var childrenHavePropXorChildren = {};
var hasRequiredChildrenHavePropXorChildren;
function requireChildrenHavePropXorChildren() {
    if (hasRequiredChildrenHavePropXorChildren) return childrenHavePropXorChildren;
    hasRequiredChildrenHavePropXorChildren = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = childrenHavePropXorChildren2;
        var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function childrenHavePropXorChildren2(prop) {
            if (typeof prop !== "string" && _typeof2(prop) !== "symbol") throw new TypeError("invalid prop: must be string or symbol");
            var validator2 = function childrenHavePropXorChildrenWithProp(_ref, _2, componentName) {
                var children2 = _ref.children;
                var truthyChildrenCount = 0;
                var propCount = 0;
                var grandchildrenCount = 0;
                _react2["default"].Children.forEach(children2, function(child) {
                    if (!child) return;
                    truthyChildrenCount += 1;
                    if (child.props[prop]) propCount += 1;
                    if (_react2["default"].Children.count(child.props.children)) grandchildrenCount += 1;
                });
                if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) return null;
                return new TypeError("`".concat(componentName, "` requires children to all have prop \u201C").concat(prop, "\u201D, all have children, or all have neither."));
            };
            validator2.isRequired = validator2;
            return (0, _wrapValidator["default"])(validator2, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
        }
    })(childrenHavePropXorChildren);
    return childrenHavePropXorChildren;
}
var childrenOf = {};
var renderableChildren = {};
var hasRequiredRenderableChildren;
function requireRenderableChildren() {
    if (hasRequiredRenderableChildren) return renderableChildren;
    hasRequiredRenderableChildren = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = renderableChildren2;
        var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function renderableChildren2(childrenProp) {
            return _react2["default"].Children.toArray(childrenProp).filter(function(child) {
                return child === 0 || child;
            });
        }
    })(renderableChildren);
    return renderableChildren;
}
var hasRequiredChildrenOf;
function requireChildrenOf() {
    if (hasRequiredChildrenOf) return childrenOf;
    hasRequiredChildrenOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = childrenOf2;
        var _renderableChildren = _interopRequireDefault2(requireRenderableChildren());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        function validateChildren(propType, children2, props) {
            for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
            var error2;
            children2.some(function(child) {
                error2 = propType.apply(void 0, [
                    _objectSpread(_objectSpread({}, props), {}, {
                        children: child
                    }),
                    "children"
                ].concat(rest));
                return error2;
            });
            return error2 || null;
        }
        function childrenOf2(propType) {
            function childrenOfPropType(props, propName, componentName) {
                if (propName !== "children") return new TypeError("".concat(componentName, ' is using the childrenOf validator on non-children prop "').concat(propName, '"'));
                var propValue = props[propName];
                if (propValue == null) return null;
                var children2 = (0, _renderableChildren["default"])(propValue);
                if (children2.length === 0) return null;
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return validateChildren.apply(void 0, [
                    propType,
                    children2,
                    props,
                    componentName
                ].concat(rest));
            }
            childrenOfPropType.isRequired = function(props, propName, componentName) {
                if (propName !== "children") return new TypeError("".concat(componentName, ' is using the childrenOf validator on non-children prop "').concat(propName, '"'));
                var children2 = (0, _renderableChildren["default"])(props[propName]);
                if (children2.length === 0) return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return validateChildren.apply(void 0, [
                    propType,
                    children2,
                    props,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(childrenOfPropType, "childrenOf", propType);
        }
    })(childrenOf);
    return childrenOf;
}
var childrenOfType = {};
var ToObject;
var hasRequiredToObject;
function requireToObject() {
    if (hasRequiredToObject) return ToObject;
    hasRequiredToObject = 1;
    var GetIntrinsic3 = getIntrinsic;
    var $Object2 = GetIntrinsic3("%Object%");
    var RequireObjectCoercible2 = RequireObjectCoercible$1;
    ToObject = function ToObject2(value2) {
        RequireObjectCoercible2(value2);
        return $Object2(value2);
    };
    return ToObject;
}
var maxSafeInteger;
var hasRequiredMaxSafeInteger;
function requireMaxSafeInteger() {
    if (hasRequiredMaxSafeInteger) return maxSafeInteger;
    hasRequiredMaxSafeInteger = 1;
    maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
    return maxSafeInteger;
}
var isPrimitive$1;
var hasRequiredIsPrimitive$1;
function requireIsPrimitive$1() {
    if (hasRequiredIsPrimitive$1) return isPrimitive$1;
    hasRequiredIsPrimitive$1 = 1;
    isPrimitive$1 = function isPrimitive2(value2) {
        return value2 === null || typeof value2 !== "function" && typeof value2 !== "object";
    };
    return isPrimitive$1;
}
var isPrimitive;
var hasRequiredIsPrimitive;
function requireIsPrimitive() {
    if (hasRequiredIsPrimitive) return isPrimitive;
    hasRequiredIsPrimitive = 1;
    isPrimitive = function isPrimitive2(value2) {
        return value2 === null || typeof value2 !== "function" && typeof value2 !== "object";
    };
    return isPrimitive;
}
var isCallable;
var hasRequiredIsCallable$1;
function requireIsCallable$1() {
    if (hasRequiredIsCallable$1) return isCallable;
    hasRequiredIsCallable$1 = 1;
    var fnToStr = Function.prototype.toString;
    var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
    var badArrayLike;
    var isCallableMarker;
    if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
        badArrayLike = Object.defineProperty({}, "length", {
            get: function() {
                throw isCallableMarker;
            }
        });
        isCallableMarker = {};
        reflectApply(function() {
            throw 42;
        }, null, badArrayLike);
    } catch (_2) {
        if (_2 !== isCallableMarker) reflectApply = null;
    }
    else reflectApply = null;
    var constructorRegex = /^\s*class\b/;
    var isES6ClassFn = function isES6ClassFunction(value2) {
        try {
            var fnStr = fnToStr.call(value2);
            return constructorRegex.test(fnStr);
        } catch (e2) {
            return false;
        }
    };
    var tryFunctionObject = function tryFunctionToStr(value2) {
        try {
            if (isES6ClassFn(value2)) return false;
            fnToStr.call(value2);
            return true;
        } catch (e2) {
            return false;
        }
    };
    var toStr2 = Object.prototype.toString;
    var objectClass = "[object Object]";
    var fnClass = "[object Function]";
    var genClass = "[object GeneratorFunction]";
    var ddaClass = "[object HTMLAllCollection]";
    var ddaClass2 = "[object HTML document.all class]";
    var ddaClass3 = "[object HTMLCollection]";
    var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
    var isIE68 = !(0 in [
        , 
    ]);
    var isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === "object") {
        var all2 = document.all;
        if (toStr2.call(all2) === toStr2.call(document.all)) isDDA = function isDocumentDotAll(value2) {
            if ((isIE68 || !value2) && (typeof value2 === "undefined" || typeof value2 === "object")) try {
                var str = toStr2.call(value2);
                return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value2("") == null;
            } catch (e2) {}
            return false;
        };
    }
    isCallable = reflectApply ? function isCallable2(value2) {
        if (isDDA(value2)) return true;
        if (!value2) return false;
        if (typeof value2 !== "function" && typeof value2 !== "object") return false;
        try {
            reflectApply(value2, null, badArrayLike);
        } catch (e2) {
            if (e2 !== isCallableMarker) return false;
        }
        return !isES6ClassFn(value2) && tryFunctionObject(value2);
    } : function isCallable2(value2) {
        if (isDDA(value2)) return true;
        if (!value2) return false;
        if (typeof value2 !== "function" && typeof value2 !== "object") return false;
        if (hasToStringTag) return tryFunctionObject(value2);
        if (isES6ClassFn(value2)) return false;
        var strClass = toStr2.call(value2);
        if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
        return tryFunctionObject(value2);
    };
    return isCallable;
}
var shams;
var hasRequiredShams;
function requireShams() {
    if (hasRequiredShams) return shams;
    hasRequiredShams = 1;
    var hasSymbols3 = shams$1;
    shams = function hasToStringTagShams() {
        return hasSymbols3() && !!Symbol.toStringTag;
    };
    return shams;
}
var isDateObject;
var hasRequiredIsDateObject;
function requireIsDateObject() {
    if (hasRequiredIsDateObject) return isDateObject;
    hasRequiredIsDateObject = 1;
    var getDay2 = Date.prototype.getDay;
    var tryDateObject = function tryDateGetDayCall(value2) {
        try {
            getDay2.call(value2);
            return true;
        } catch (e2) {
            return false;
        }
    };
    var toStr2 = Object.prototype.toString;
    var dateClass = "[object Date]";
    var hasToStringTag = requireShams()();
    isDateObject = function isDateObject2(value2) {
        if (typeof value2 !== "object" || value2 === null) return false;
        return hasToStringTag ? tryDateObject(value2) : toStr2.call(value2) === dateClass;
    };
    return isDateObject;
}
var isSymbol = {
    exports: {}
};
var hasRequiredIsSymbol;
function requireIsSymbol() {
    if (hasRequiredIsSymbol) return isSymbol.exports;
    hasRequiredIsSymbol = 1;
    var toStr2 = Object.prototype.toString;
    var hasSymbols3 = hasSymbols$2();
    if (hasSymbols3) {
        var symToStr = Symbol.prototype.toString;
        var symStringRegex = /^Symbol\(.*\)$/;
        var isSymbolObject = function isRealSymbolObject(value2) {
            if (typeof value2.valueOf() !== "symbol") return false;
            return symStringRegex.test(symToStr.call(value2));
        };
        isSymbol.exports = function isSymbol2(value2) {
            if (typeof value2 === "symbol") return true;
            if (toStr2.call(value2) !== "[object Symbol]") return false;
            try {
                return isSymbolObject(value2);
            } catch (e2) {
                return false;
            }
        };
    } else isSymbol.exports = function isSymbol2(value2) {
        return false;
    };
    return isSymbol.exports;
}
var es2015;
var hasRequiredEs2015;
function requireEs2015() {
    if (hasRequiredEs2015) return es2015;
    hasRequiredEs2015 = 1;
    var hasSymbols3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol";
    var isPrimitive2 = requireIsPrimitive();
    var isCallable2 = requireIsCallable$1();
    var isDate2 = requireIsDateObject();
    var isSymbol2 = requireIsSymbol();
    var ordinaryToPrimitive = function OrdinaryToPrimitive(O2, hint) {
        if (typeof O2 === "undefined" || O2 === null) throw new TypeError("Cannot call method on " + O2);
        if (typeof hint !== "string" || hint !== "number" && hint !== "string") throw new TypeError('hint must be "string" or "number"');
        var methodNames = hint === "string" ? [
            "toString",
            "valueOf"
        ] : [
            "valueOf",
            "toString"
        ];
        var method, result2, i;
        for(i = 0; i < methodNames.length; ++i){
            method = O2[methodNames[i]];
            if (isCallable2(method)) {
                result2 = method.call(O2);
                if (isPrimitive2(result2)) return result2;
            }
        }
        throw new TypeError("No default value");
    };
    var GetMethod = function GetMethod2(O2, P2) {
        var func = O2[P2];
        if (func !== null && typeof func !== "undefined") {
            if (!isCallable2(func)) throw new TypeError(func + " returned for property " + P2 + " of object " + O2 + " is not a function");
            return func;
        }
        return void 0;
    };
    es2015 = function ToPrimitive2(input2) {
        if (isPrimitive2(input2)) return input2;
        var hint = "default";
        if (arguments.length > 1) {
            if (arguments[1] === String) hint = "string";
            else if (arguments[1] === Number) hint = "number";
        }
        var exoticToPrim;
        if (hasSymbols3) {
            if (Symbol.toPrimitive) exoticToPrim = GetMethod(input2, Symbol.toPrimitive);
            else if (isSymbol2(input2)) exoticToPrim = Symbol.prototype.valueOf;
        }
        if (typeof exoticToPrim !== "undefined") {
            var result2 = exoticToPrim.call(input2, hint);
            if (isPrimitive2(result2)) return result2;
            throw new TypeError("unable to convert exotic object to primitive");
        }
        if (hint === "default" && (isDate2(input2) || isSymbol2(input2))) hint = "string";
        return ordinaryToPrimitive(input2, hint === "default" ? "number" : hint);
    };
    return es2015;
}
var ToPrimitive;
var hasRequiredToPrimitive;
function requireToPrimitive() {
    if (hasRequiredToPrimitive) return ToPrimitive;
    hasRequiredToPrimitive = 1;
    var toPrimitive = requireEs2015();
    ToPrimitive = function ToPrimitive2(input2) {
        if (arguments.length > 1) return toPrimitive(input2, arguments[1]);
        return toPrimitive(input2);
    };
    return ToPrimitive;
}
var isRegex;
var hasRequiredIsRegex;
function requireIsRegex() {
    if (hasRequiredIsRegex) return isRegex;
    hasRequiredIsRegex = 1;
    var callBound2 = callBound$1;
    var hasToStringTag = requireShams()();
    var has2;
    var $exec2;
    var isRegexMarker;
    var badStringifier;
    if (hasToStringTag) {
        has2 = callBound2("Object.prototype.hasOwnProperty");
        $exec2 = callBound2("RegExp.prototype.exec");
        isRegexMarker = {};
        var throwRegexMarker = function() {
            throw isRegexMarker;
        };
        badStringifier = {
            toString: throwRegexMarker,
            valueOf: throwRegexMarker
        };
        if (typeof Symbol.toPrimitive === "symbol") badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    }
    var $toString = callBound2("Object.prototype.toString");
    var gOPD2 = Object.getOwnPropertyDescriptor;
    var regexClass = "[object RegExp]";
    isRegex = hasToStringTag ? function isRegex2(value2) {
        if (!value2 || typeof value2 !== "object") return false;
        var descriptor = gOPD2(value2, "lastIndex");
        var hasLastIndexDataProperty = descriptor && has2(descriptor, "value");
        if (!hasLastIndexDataProperty) return false;
        try {
            $exec2(value2, badStringifier);
        } catch (e2) {
            return e2 === isRegexMarker;
        }
    } : function isRegex2(value2) {
        if (!value2 || typeof value2 !== "object" && typeof value2 !== "function") return false;
        return $toString(value2) === regexClass;
    };
    return isRegex;
}
var safeRegexTest;
var hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
    if (hasRequiredSafeRegexTest) return safeRegexTest;
    hasRequiredSafeRegexTest = 1;
    var callBound2 = callBound$1;
    var GetIntrinsic3 = getIntrinsic;
    var isRegex2 = requireIsRegex();
    var $exec2 = callBound2("RegExp.prototype.exec");
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    safeRegexTest = function regexTester(regex) {
        if (!isRegex2(regex)) throw new $TypeError2("`regex` must be a RegExp");
        return function test2(s2) {
            return $exec2(regex, s2) !== null;
        };
    };
    return safeRegexTest;
}
var ToString;
var hasRequiredToString;
function requireToString() {
    if (hasRequiredToString) return ToString;
    hasRequiredToString = 1;
    var GetIntrinsic3 = getIntrinsic;
    var $String = GetIntrinsic3("%String%");
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    ToString = function ToString2(argument) {
        if (typeof argument === "symbol") throw new $TypeError2("Cannot convert a Symbol value to a string");
        return $String(argument);
    };
    return ToString;
}
var implementation$9;
var hasRequiredImplementation$3;
function requireImplementation$3() {
    if (hasRequiredImplementation$3) return implementation$9;
    hasRequiredImplementation$3 = 1;
    var RequireObjectCoercible2 = RequireObjectCoercible$1;
    var ToString2 = requireToString();
    var callBound2 = callBound$1;
    var $replace2 = callBound2("String.prototype.replace");
    var mvsIsWS = /^\s$/.test("\u180E");
    var leftWhitespace = mvsIsWS ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
    var rightWhitespace = mvsIsWS ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
    implementation$9 = function trim2() {
        var S2 = ToString2(RequireObjectCoercible2(this));
        return $replace2($replace2(S2, leftWhitespace, ""), rightWhitespace, "");
    };
    return implementation$9;
}
var polyfill$7;
var hasRequiredPolyfill$3;
function requirePolyfill$3() {
    if (hasRequiredPolyfill$3) return polyfill$7;
    hasRequiredPolyfill$3 = 1;
    var implementation2 = requireImplementation$3();
    var zeroWidthSpace = "\u200B";
    var mongolianVowelSeparator = "\u180E";
    polyfill$7 = function getPolyfill4() {
        if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace && mongolianVowelSeparator.trim() === mongolianVowelSeparator && ("_" + mongolianVowelSeparator).trim() === "_" + mongolianVowelSeparator && (mongolianVowelSeparator + "_").trim() === mongolianVowelSeparator + "_") return String.prototype.trim;
        return implementation2;
    };
    return polyfill$7;
}
var shim$7;
var hasRequiredShim$4;
function requireShim$4() {
    if (hasRequiredShim$4) return shim$7;
    hasRequiredShim$4 = 1;
    var define2 = defineProperties_1;
    var getPolyfill4 = requirePolyfill$3();
    shim$7 = function shimStringTrim() {
        var polyfill2 = getPolyfill4();
        define2(String.prototype, {
            trim: polyfill2
        }, {
            trim: function testTrim() {
                return String.prototype.trim !== polyfill2;
            }
        });
        return polyfill2;
    };
    return shim$7;
}
var string_prototype_trim;
var hasRequiredString_prototype_trim;
function requireString_prototype_trim() {
    if (hasRequiredString_prototype_trim) return string_prototype_trim;
    hasRequiredString_prototype_trim = 1;
    var callBind2 = callBindExports;
    var define2 = defineProperties_1;
    var RequireObjectCoercible2 = RequireObjectCoercible$1;
    var implementation2 = requireImplementation$3();
    var getPolyfill4 = requirePolyfill$3();
    var shim2 = requireShim$4();
    var bound = callBind2(getPolyfill4());
    var boundMethod = function trim2(receiver) {
        RequireObjectCoercible2(receiver);
        return bound(receiver);
    };
    define2(boundMethod, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    string_prototype_trim = boundMethod;
    return string_prototype_trim;
}
var Type$1;
var hasRequiredType$1;
function requireType$1() {
    if (hasRequiredType$1) return Type$1;
    hasRequiredType$1 = 1;
    Type$1 = function Type2(x2) {
        if (x2 === null) return "Null";
        if (typeof x2 === "undefined") return "Undefined";
        if (typeof x2 === "function" || typeof x2 === "object") return "Object";
        if (typeof x2 === "number") return "Number";
        if (typeof x2 === "boolean") return "Boolean";
        if (typeof x2 === "string") return "String";
    };
    return Type$1;
}
var Type;
var hasRequiredType;
function requireType() {
    if (hasRequiredType) return Type;
    hasRequiredType = 1;
    var ES5Type = requireType$1();
    Type = function Type2(x2) {
        if (typeof x2 === "symbol") return "Symbol";
        if (typeof x2 === "bigint") return "BigInt";
        return ES5Type(x2);
    };
    return Type;
}
var StringToNumber;
var hasRequiredStringToNumber;
function requireStringToNumber() {
    if (hasRequiredStringToNumber) return StringToNumber;
    hasRequiredStringToNumber = 1;
    var GetIntrinsic3 = getIntrinsic;
    var $Number = GetIntrinsic3("%Number%");
    var $RegExp = GetIntrinsic3("%RegExp%");
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    var $parseInteger = GetIntrinsic3("%parseInt%");
    var callBound2 = callBound$1;
    var regexTester = requireSafeRegexTest();
    var $strSlice2 = callBound2("String.prototype.slice");
    var isBinary = regexTester(/^0b[01]+$/i);
    var isOctal = regexTester(/^0o[0-7]+$/i);
    var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
    var nonWS = [
        "\x85",
        "\u200B",
        "\uFFFE"
    ].join("");
    var nonWSregex = new $RegExp("[" + nonWS + "]", "g");
    var hasNonWS = regexTester(nonWSregex);
    var $trim = requireString_prototype_trim();
    var Type2 = requireType();
    StringToNumber = function StringToNumber2(argument) {
        if (Type2(argument) !== "String") throw new $TypeError2("Assertion failed: `argument` is not a String");
        if (isBinary(argument)) return $Number($parseInteger($strSlice2(argument, 2), 2));
        if (isOctal(argument)) return $Number($parseInteger($strSlice2(argument, 2), 8));
        if (hasNonWS(argument) || isInvalidHexLiteral(argument)) return NaN;
        var trimmed = $trim(argument);
        if (trimmed !== argument) return StringToNumber2(trimmed);
        return $Number(argument);
    };
    return StringToNumber;
}
var ToNumber;
var hasRequiredToNumber;
function requireToNumber() {
    if (hasRequiredToNumber) return ToNumber;
    hasRequiredToNumber = 1;
    var GetIntrinsic3 = getIntrinsic;
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    var $Number = GetIntrinsic3("%Number%");
    var isPrimitive2 = requireIsPrimitive$1();
    var ToPrimitive2 = requireToPrimitive();
    var StringToNumber2 = requireStringToNumber();
    ToNumber = function ToNumber2(argument) {
        var value2 = isPrimitive2(argument) ? argument : ToPrimitive2(argument, $Number);
        if (typeof value2 === "symbol") throw new $TypeError2("Cannot convert a Symbol value to a number");
        if (typeof value2 === "bigint") throw new $TypeError2("Conversion from 'BigInt' to 'number' is not allowed.");
        if (typeof value2 === "string") return StringToNumber2(value2);
        return $Number(value2);
    };
    return ToNumber;
}
var floor;
var hasRequiredFloor;
function requireFloor() {
    if (hasRequiredFloor) return floor;
    hasRequiredFloor = 1;
    var Type2 = requireType();
    var $floor2 = Math.floor;
    floor = function floor2(x2) {
        if (Type2(x2) === "BigInt") return x2;
        return $floor2(x2);
    };
    return floor;
}
var truncate;
var hasRequiredTruncate;
function requireTruncate() {
    if (hasRequiredTruncate) return truncate;
    hasRequiredTruncate = 1;
    var GetIntrinsic3 = getIntrinsic;
    var floor2 = requireFloor();
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    truncate = function truncate2(x2) {
        if (typeof x2 !== "number" && typeof x2 !== "bigint") throw new $TypeError2("argument must be a Number or a BigInt");
        var result2 = x2 < 0 ? -floor2(-x2) : floor2(x2);
        return result2 === 0 ? 0 : result2;
    };
    return truncate;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
    if (hasRequired_isNaN) return _isNaN;
    hasRequired_isNaN = 1;
    _isNaN = Number.isNaN || function isNaN2(a2) {
        return a2 !== a2;
    };
    return _isNaN;
}
var _isFinite;
var hasRequired_isFinite;
function require_isFinite() {
    if (hasRequired_isFinite) return _isFinite;
    hasRequired_isFinite = 1;
    var $isNaN = require_isNaN();
    _isFinite = function(x2) {
        return (typeof x2 === "number" || typeof x2 === "bigint") && !$isNaN(x2) && x2 !== Infinity && x2 !== -Infinity;
    };
    return _isFinite;
}
var ToIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;
function requireToIntegerOrInfinity() {
    if (hasRequiredToIntegerOrInfinity) return ToIntegerOrInfinity;
    hasRequiredToIntegerOrInfinity = 1;
    var ToNumber2 = requireToNumber();
    var truncate2 = requireTruncate();
    var $isNaN = require_isNaN();
    var $isFinite = require_isFinite();
    ToIntegerOrInfinity = function ToIntegerOrInfinity2(value2) {
        var number = ToNumber2(value2);
        if ($isNaN(number) || number === 0) return 0;
        if (!$isFinite(number)) return number;
        return truncate2(number);
    };
    return ToIntegerOrInfinity;
}
var ToLength;
var hasRequiredToLength;
function requireToLength() {
    if (hasRequiredToLength) return ToLength;
    hasRequiredToLength = 1;
    var MAX_SAFE_INTEGER2 = requireMaxSafeInteger();
    var ToIntegerOrInfinity2 = requireToIntegerOrInfinity();
    ToLength = function ToLength2(argument) {
        var len = ToIntegerOrInfinity2(argument);
        if (len <= 0) return 0;
        if (len > MAX_SAFE_INTEGER2) return MAX_SAFE_INTEGER2;
        return len;
    };
    return ToLength;
}
var IsCallable;
var hasRequiredIsCallable;
function requireIsCallable() {
    if (hasRequiredIsCallable) return IsCallable;
    hasRequiredIsCallable = 1;
    IsCallable = requireIsCallable$1();
    return IsCallable;
}
var implementation$8;
var hasRequiredImplementation$2;
function requireImplementation$2() {
    if (hasRequiredImplementation$2) return implementation$8;
    hasRequiredImplementation$2 = 1;
    var ToObject2 = requireToObject();
    var ToLength2 = requireToLength();
    var IsCallable2 = requireIsCallable();
    implementation$8 = function find(predicate2) {
        var list2 = ToObject2(this);
        var length = ToLength2(list2.length);
        if (!IsCallable2(predicate2)) throw new TypeError("Array#find: predicate must be a function");
        if (length === 0) return void 0;
        var thisArg;
        if (arguments.length > 0) thisArg = arguments[1];
        for(var i = 0, value2; i < length; i++){
            value2 = list2[i];
            if (predicate2.apply(thisArg, [
                value2,
                i,
                list2
            ])) return value2;
        }
        return void 0;
    };
    return implementation$8;
}
var polyfill$6;
var hasRequiredPolyfill$2;
function requirePolyfill$2() {
    if (hasRequiredPolyfill$2) return polyfill$6;
    hasRequiredPolyfill$2 = 1;
    polyfill$6 = function getPolyfill4() {
        var implemented = Array.prototype.find && [
            ,
            1
        ].find(function() {
            return true;
        }) !== 1;
        return implemented ? Array.prototype.find : requireImplementation$2();
    };
    return polyfill$6;
}
var esShimUnscopables;
var hasRequiredEsShimUnscopables;
function requireEsShimUnscopables() {
    if (hasRequiredEsShimUnscopables) return esShimUnscopables;
    hasRequiredEsShimUnscopables = 1;
    var hasOwn2 = hasown;
    var hasUnscopables = typeof Symbol === "function" && typeof Symbol.unscopables === "symbol";
    var map = hasUnscopables && Array.prototype[Symbol.unscopables];
    var $TypeError2 = TypeError;
    esShimUnscopables = function shimUnscopables(method) {
        if (typeof method !== "string" || !method) throw new $TypeError2("method must be a non-empty string");
        if (!hasOwn2(Array.prototype, method)) throw new $TypeError2("method must be on Array.prototype");
        if (hasUnscopables) map[method] = true;
    };
    return esShimUnscopables;
}
var shim$6;
var hasRequiredShim$3;
function requireShim$3() {
    if (hasRequiredShim$3) return shim$6;
    hasRequiredShim$3 = 1;
    var define2 = defineProperties_1;
    var shimUnscopables = requireEsShimUnscopables();
    var getPolyfill4 = requirePolyfill$2();
    shim$6 = function shimArrayPrototypeFind() {
        var polyfill2 = getPolyfill4();
        define2(Array.prototype, {
            find: polyfill2
        }, {
            find: function() {
                return Array.prototype.find !== polyfill2;
            }
        });
        shimUnscopables("find");
        return polyfill2;
    };
    return shim$6;
}
var array_prototype_find;
var hasRequiredArray_prototype_find;
function requireArray_prototype_find() {
    if (hasRequiredArray_prototype_find) return array_prototype_find;
    hasRequiredArray_prototype_find = 1;
    var define2 = defineProperties_1;
    var callBound2 = callBound$1;
    var RequireObjectCoercible2 = RequireObjectCoercible$1;
    var implementation2 = requireImplementation$2();
    var getPolyfill4 = requirePolyfill$2();
    var shim2 = requireShim$3();
    var $slice = callBound2("Array.prototype.slice");
    var polyfill2 = getPolyfill4();
    var boundFindShim = function find(array, predicate2) {
        RequireObjectCoercible2(array);
        var args = $slice(arguments, 1);
        return polyfill2.apply(array, args);
    };
    define2(boundFindShim, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    array_prototype_find = boundFindShim;
    return array_prototype_find;
}
var getComponentName = {};
var IsPropertyKey;
var hasRequiredIsPropertyKey;
function requireIsPropertyKey() {
    if (hasRequiredIsPropertyKey) return IsPropertyKey;
    hasRequiredIsPropertyKey = 1;
    IsPropertyKey = function IsPropertyKey2(argument) {
        return typeof argument === "string" || typeof argument === "symbol";
    };
    return IsPropertyKey;
}
var HasOwnProperty;
var hasRequiredHasOwnProperty;
function requireHasOwnProperty() {
    if (hasRequiredHasOwnProperty) return HasOwnProperty;
    hasRequiredHasOwnProperty = 1;
    var GetIntrinsic3 = getIntrinsic;
    var $TypeError2 = GetIntrinsic3("%TypeError%");
    var hasOwn2 = hasown;
    var IsPropertyKey2 = requireIsPropertyKey();
    var Type2 = requireType();
    HasOwnProperty = function HasOwnProperty2(O2, P2) {
        if (Type2(O2) !== "Object") throw new $TypeError2("Assertion failed: `O` must be an Object");
        if (!IsPropertyKey2(P2)) throw new $TypeError2("Assertion failed: `P` must be a Property Key");
        return hasOwn2(O2, P2);
    };
    return HasOwnProperty;
}
var functionsHaveNames_1;
var hasRequiredFunctionsHaveNames;
function requireFunctionsHaveNames() {
    if (hasRequiredFunctionsHaveNames) return functionsHaveNames_1;
    hasRequiredFunctionsHaveNames = 1;
    var functionsHaveNames = function functionsHaveNames2() {
        return typeof (function f2() {}).name === "string";
    };
    var gOPD2 = Object.getOwnPropertyDescriptor;
    if (gOPD2) try {
        gOPD2([], "length");
    } catch (e2) {
        gOPD2 = null;
    }
    functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
        if (!functionsHaveNames() || !gOPD2) return false;
        var desc = gOPD2(function() {}, "name");
        return !!desc && !!desc.configurable;
    };
    var $bind = Function.prototype.bind;
    functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
        return functionsHaveNames() && typeof $bind === "function" && (function f2() {}).bind().name !== "";
    };
    functionsHaveNames_1 = functionsHaveNames;
    return functionsHaveNames_1;
}
var implementation$7;
var hasRequiredImplementation$1;
function requireImplementation$1() {
    if (hasRequiredImplementation$1) return implementation$7;
    hasRequiredImplementation$1 = 1;
    var IsCallable2 = requireIsCallable();
    var HasOwnProperty2 = requireHasOwnProperty();
    var functionsHaveNames = requireFunctionsHaveNames()();
    var callBound2 = callBound$1;
    var $functionToString = callBound2("Function.prototype.toString");
    var $stringMatch = callBound2("String.prototype.match");
    var toStr2 = callBound2("Object.prototype.toString");
    var classRegex = /^class /;
    var isClass = function isClassConstructor(fn2) {
        if (IsCallable2(fn2)) return false;
        if (typeof fn2 !== "function") return false;
        try {
            var match2 = $stringMatch($functionToString(fn2), classRegex);
            return !!match2;
        } catch (e2) {}
        return false;
    };
    var regex = /\s*function\s+([^(\s]*)\s*/;
    var isIE68 = !(0 in [
        , 
    ]);
    var objectClass = "[object Object]";
    var ddaClass = "[object HTMLAllCollection]";
    var functionProto = Function.prototype;
    var isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === "object") {
        var all2 = document.all;
        if (toStr2(all2) === toStr2(document.all)) isDDA = function isDocumentDotAll(value2) {
            if ((isIE68 || !value2) && (typeof value2 === "undefined" || typeof value2 === "object")) try {
                var str = toStr2(value2);
                return (str === ddaClass || str === objectClass) && value2("") == null;
            } catch (e2) {}
            return false;
        };
    }
    implementation$7 = function getName() {
        if (isDDA(this) || !isClass(this) && !IsCallable2(this)) throw new TypeError("Function.prototype.name sham getter called on non-function");
        if (functionsHaveNames && HasOwnProperty2(this, "name")) return this.name;
        if (this === functionProto) return "";
        var str = $functionToString(this);
        var match2 = $stringMatch(str, regex);
        var name2 = match2 && match2[1];
        return name2;
    };
    return implementation$7;
}
var polyfill$5;
var hasRequiredPolyfill$1;
function requirePolyfill$1() {
    if (hasRequiredPolyfill$1) return polyfill$5;
    hasRequiredPolyfill$1 = 1;
    var implementation2 = requireImplementation$1();
    polyfill$5 = function getPolyfill4() {
        return implementation2;
    };
    return polyfill$5;
}
var shim$5;
var hasRequiredShim$2;
function requireShim$2() {
    if (hasRequiredShim$2) return shim$5;
    hasRequiredShim$2 = 1;
    var supportsDescriptors2 = defineProperties_1.supportsDescriptors;
    var functionsHaveNames = requireFunctionsHaveNames()();
    var getPolyfill4 = requirePolyfill$1();
    var defineProperty2 = Object.defineProperty;
    var TypeErr = TypeError;
    shim$5 = function shimName() {
        var polyfill2 = getPolyfill4();
        if (functionsHaveNames) return polyfill2;
        if (!supportsDescriptors2) throw new TypeErr("Shimming Function.prototype.name support requires ES5 property descriptor support.");
        var functionProto = Function.prototype;
        defineProperty2(functionProto, "name", {
            configurable: true,
            enumerable: false,
            get: function() {
                var name2 = polyfill2.call(this);
                if (this !== functionProto) defineProperty2(this, "name", {
                    configurable: true,
                    enumerable: false,
                    value: name2,
                    writable: false
                });
                return name2;
            }
        });
        return polyfill2;
    };
    return shim$5;
}
var function_prototype_name;
var hasRequiredFunction_prototype_name;
function requireFunction_prototype_name() {
    if (hasRequiredFunction_prototype_name) return function_prototype_name;
    hasRequiredFunction_prototype_name = 1;
    var define2 = defineProperties_1;
    var callBind2 = callBindExports;
    var implementation2 = requireImplementation$1();
    var getPolyfill4 = requirePolyfill$1();
    var shim2 = requireShim$2();
    var bound = callBind2(implementation2);
    define2(bound, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    function_prototype_name = bound;
    return function_prototype_name;
}
var hasRequiredGetComponentName;
function requireGetComponentName() {
    if (hasRequiredGetComponentName) return getComponentName;
    hasRequiredGetComponentName = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = getComponentName2;
        var _functionPrototype = _interopRequireDefault2(requireFunction_prototype_name());
        var _reactIs = requireReactIs();
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function getComponentName2(Component2) {
            if (typeof Component2 === "string") return Component2;
            if (typeof Component2 === "function") return Component2.displayName || (0, _functionPrototype["default"])(Component2);
            if ((0, _reactIs.isForwardRef)({
                type: Component2,
                $$typeof: _reactIs.Element
            })) return Component2.displayName;
            if ((0, _reactIs.isMemo)(Component2)) return getComponentName2(Component2.type);
            return null;
        }
    })(getComponentName);
    return getComponentName;
}
var hasRequiredChildrenOfType;
function requireChildrenOfType() {
    if (hasRequiredChildrenOfType) return childrenOfType;
    hasRequiredChildrenOfType = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _arrayPrototype = _interopRequireDefault2(requireArray_prototype_find());
        var _getComponentName = _interopRequireDefault2(requireGetComponentName());
        var _renderableChildren = _interopRequireDefault2(requireRenderableChildren());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function onlyTypes(types2, children2, componentName) {
            if (!children2.every(function(child) {
                return child && (0, _arrayPrototype["default"])(types2, function(Type2) {
                    return Type2 === "*" || child.type === Type2;
                });
            })) {
                var typeNames = types2.map(_getComponentName["default"]).join(", or ");
                return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
            }
            return null;
        }
        function isRequired(types2, children2, componentName) {
            if (children2.length === 0) {
                var typeNames = types2.map(_getComponentName["default"]).join(", or ");
                return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
            }
            return null;
        }
        function childrenOfType2() {
            for(var _len = arguments.length, types2 = new Array(_len), _key = 0; _key < _len; _key++)types2[_key] = arguments[_key];
            if (types2.length < 1) throw new TypeError("childrenOfType: at least 1 type is required");
            function validator2(props, propName, componentName) {
                return onlyTypes(types2, (0, _renderableChildren["default"])(props[propName]), componentName);
            }
            validator2.isRequired = function(props, propName, componentName) {
                var children2 = (0, _renderableChildren["default"])(props[propName]);
                return isRequired(types2, children2, componentName) || onlyTypes(types2, children2, componentName);
            };
            return (0, _wrapValidator["default"])(validator2, "childrenOfType", types2);
        }
        var _default2 = childrenOfType2;
        exports2["default"] = _default2;
    })(childrenOfType);
    return childrenOfType;
}
var childrenSequenceOf = {};
var sequenceOf = {};
var nonNegativeInteger = {};
var integer = {};
var isInteger = {};
var hasRequiredIsInteger;
function requireIsInteger() {
    if (hasRequiredIsInteger) return isInteger;
    hasRequiredIsInteger = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var floor2 = Math.floor;
        var finite = isFinite;
        var _default2 = Number.isInteger || /* istanbul ignore next */ function(x2) {
            return typeof x2 === "number" && finite(x2) && floor2(x2) === x2;
        };
        exports2["default"] = _default2;
    })(isInteger);
    return isInteger;
}
var hasRequiredInteger;
function requireInteger() {
    if (hasRequiredInteger) return integer;
    hasRequiredInteger = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _isInteger = _interopRequireDefault2(requireIsInteger());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function requiredInteger(props, propName, componentName) {
            var propValue = props[propName];
            if (propValue == null || !(0, _isInteger["default"])(propValue)) return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
            return null;
        }
        var validator2 = function integer2(props, propName) {
            var propValue = props[propName];
            if (propValue == null) return null;
            for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)rest[_key - 2] = arguments[_key];
            return requiredInteger.apply(void 0, [
                props,
                propName
            ].concat(rest));
        };
        validator2.isRequired = requiredInteger;
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(validator2, "integer");
        };
        exports2["default"] = _default2;
    })(integer);
    return integer;
}
var nonNegativeNumber = {};
var implementation$6;
var hasRequiredImplementation;
function requireImplementation() {
    if (hasRequiredImplementation) return implementation$6;
    hasRequiredImplementation = 1;
    var numberIsNaN = function(value2) {
        return value2 !== value2;
    };
    implementation$6 = function is(a2, b2) {
        if (a2 === 0 && b2 === 0) return 1 / a2 === 1 / b2;
        if (a2 === b2) return true;
        if (numberIsNaN(a2) && numberIsNaN(b2)) return true;
        return false;
    };
    return implementation$6;
}
var polyfill$4;
var hasRequiredPolyfill;
function requirePolyfill() {
    if (hasRequiredPolyfill) return polyfill$4;
    hasRequiredPolyfill = 1;
    var implementation2 = requireImplementation();
    polyfill$4 = function getPolyfill4() {
        return typeof Object.is === "function" ? Object.is : implementation2;
    };
    return polyfill$4;
}
var shim$4;
var hasRequiredShim$1;
function requireShim$1() {
    if (hasRequiredShim$1) return shim$4;
    hasRequiredShim$1 = 1;
    var getPolyfill4 = requirePolyfill();
    var define2 = defineProperties_1;
    shim$4 = function shimObjectIs() {
        var polyfill2 = getPolyfill4();
        define2(Object, {
            is: polyfill2
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill2;
            }
        });
        return polyfill2;
    };
    return shim$4;
}
var objectIs;
var hasRequiredObjectIs;
function requireObjectIs() {
    if (hasRequiredObjectIs) return objectIs;
    hasRequiredObjectIs = 1;
    var define2 = defineProperties_1;
    var callBind2 = callBindExports;
    var implementation2 = requireImplementation();
    var getPolyfill4 = requirePolyfill();
    var shim2 = requireShim$1();
    var polyfill2 = callBind2(getPolyfill4(), Object);
    define2(polyfill2, {
        getPolyfill: getPolyfill4,
        implementation: implementation2,
        shim: shim2
    });
    objectIs = polyfill2;
    return objectIs;
}
var hasRequiredNonNegativeNumber;
function requireNonNegativeNumber() {
    if (hasRequiredNonNegativeNumber) return nonNegativeNumber;
    hasRequiredNonNegativeNumber = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _objectIs = _interopRequireDefault2(requireObjectIs());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function isNonNegative(x2) {
            return typeof x2 === "number" && isFinite(x2) && x2 >= 0 && !(0, _objectIs["default"])(x2, -0);
        }
        function nonNegativeNumber2(props, propName, componentName) {
            var value2 = props[propName];
            if (value2 == null || isNonNegative(value2)) return null;
            return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
        }
        function requiredNonNegativeNumber(props, propName, componentName) {
            var value2 = props[propName];
            if (isNonNegative(value2)) return null;
            return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
        }
        nonNegativeNumber2.isRequired = requiredNonNegativeNumber;
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(nonNegativeNumber2, "nonNegativeNumber");
        };
        exports2["default"] = _default2;
    })(nonNegativeNumber);
    return nonNegativeNumber;
}
var hasRequiredNonNegativeInteger;
function requireNonNegativeInteger() {
    if (hasRequiredNonNegativeInteger) return nonNegativeInteger;
    hasRequiredNonNegativeInteger = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _and = _interopRequireDefault2(requireAnd());
        var _integer = _interopRequireDefault2(requireInteger());
        var _nonNegativeNumber = _interopRequireDefault2(requireNonNegativeNumber());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var _default2 = (0, _and["default"])([
            (0, _integer["default"])(),
            (0, _nonNegativeNumber["default"])()
        ], "nonNegativeInteger");
        exports2["default"] = _default2;
    })(nonNegativeInteger);
    return nonNegativeInteger;
}
var object = {};
var typeOf = {};
var hasRequiredTypeOf;
function requireTypeOf() {
    if (hasRequiredTypeOf) return typeOf;
    hasRequiredTypeOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = typeOf2;
        var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function typeOf2(child) {
            if (child === null) return "null";
            if (Array.isArray(child)) return "array";
            if (_typeof2(child) !== "object") return _typeof2(child);
            if (/* @__PURE__ */ _react2["default"].isValidElement(child)) return child.type;
            return child;
        }
    })(typeOf);
    return typeOf;
}
var hasRequiredObject;
function requireObject() {
    if (hasRequiredObject) return object;
    hasRequiredObject = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _isPlainObject = _interopRequireDefault2(requireIsPlainObject());
        var _typeOf = _interopRequireDefault2(requireTypeOf());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var ReactPropTypeLocationNames = {
            prop: "prop",
            context: "context",
            childContext: "child context"
        };
        function object2(props, propName, componentName, location2, propFullName) {
            var propValue = props[propName];
            if (propValue == null) return null;
            if ((0, _isPlainObject["default"])(propValue)) return null;
            var locationName = ReactPropTypeLocationNames[location2] || location2;
            return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
        }
        object2.isRequired = function objectRequired(props, propName, componentName, location2, propFullName) {
            var propValue = props[propName];
            if (propValue == null) {
                var locationName = ReactPropTypeLocationNames[location2] || location2;
                return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
            }
            for(var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
            return object2.apply(void 0, [
                props,
                propName,
                componentName,
                location2,
                propFullName
            ].concat(rest));
        };
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(object2, "object");
        };
        exports2["default"] = _default2;
    })(object);
    return object;
}
var withShape = {};
var hasRequiredWithShape;
function requireWithShape() {
    if (hasRequiredWithShape) return withShape;
    hasRequiredWithShape = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = withShape2;
        var _and = _interopRequireDefault2(requireAnd());
        var _shape = _interopRequireDefault2(requireShape());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function withShape2(type, shapeTypes) {
            if (typeof type !== "function") throw new TypeError("type must be a valid PropType");
            var shapeValidator = (0, _shape["default"])(shapeTypes);
            return (0, _and["default"])([
                type,
                shapeValidator
            ], "withShape");
        }
    })(withShape);
    return withShape;
}
var hasRequiredSequenceOf;
function requireSequenceOf() {
    if (hasRequiredSequenceOf) return sequenceOf;
    hasRequiredSequenceOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = sequenceOfValidator;
        var _propTypes2 = propTypesExports;
        var _and = _interopRequireDefault2(requireAnd());
        var _between = _interopRequireDefault2(requireBetween());
        var _nonNegativeInteger = _interopRequireDefault2(requireNonNegativeInteger());
        var _object = _interopRequireDefault2(requireObject());
        var _withShape = _interopRequireDefault2(requireWithShape());
        var _typeOf = _interopRequireDefault2(requireTypeOf());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        var minValidator = _nonNegativeInteger["default"];
        var maxValidator = (0, _and["default"])([
            _nonNegativeInteger["default"],
            (0, _between["default"])({
                gte: 1
            })
        ]);
        function validateRange(min2, max2) {
            if (typeof max2 !== "number" || typeof min2 !== "number") return null;
            if (min2 <= max2) return null;
            return new RangeError("min must be less than or equal to max");
        }
        var specifierShape = {
            validator: function validator2(props, propName) {
                var propValue = props[propName];
                if (typeof propValue !== "function") return new TypeError('"validator" must be a propType validator function');
                return null;
            },
            min: function min2(props, propName) {
                return minValidator(props, propName) || validateRange(props.min, props.max);
            },
            max: function max2(props, propName) {
                return maxValidator(props, propName) || validateRange(props.min, props.max);
            }
        };
        function getMinMax(_ref) {
            var min2 = _ref.min, max2 = _ref.max;
            var minimum;
            var maximum;
            if (typeof min2 !== "number" && typeof max2 !== "number") {
                minimum = 1;
                maximum = 1;
            } else {
                minimum = typeof min2 === "number" ? min2 : 1;
                maximum = typeof max2 === "number" ? max2 : Infinity;
            }
            return {
                minimum: minimum,
                maximum: maximum
            };
        }
        function chunkByType(items) {
            var chunk = [];
            var lastType;
            return items.reduce(function(chunks, item2) {
                var itemType = (0, _typeOf["default"])(item2);
                if (!lastType || itemType === lastType) chunk.push(item2);
                else {
                    chunks.push(chunk);
                    chunk = [
                        item2
                    ];
                }
                lastType = itemType;
                return chunks;
            }, []).concat(chunk.length > 0 ? [
                chunk
            ] : []);
        }
        function validateChunks(specifiers, props, propName, componentName) {
            var items = props[propName];
            var chunks = chunkByType(items);
            for(var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)rest[_key - 4] = arguments[_key];
            for(var i = 0; i < specifiers.length; i += 1){
                var _specifiers$i = specifiers[i], validator2 = _specifiers$i.validator, min2 = _specifiers$i.min, max2 = _specifiers$i.max;
                var _getMinMax = getMinMax({
                    min: min2,
                    max: max2
                }), minimum = _getMinMax.minimum, maximum = _getMinMax.maximum;
                if (chunks.length === 0 && minimum === 0) continue;
                var arrayOfValidator = (0, _propTypes2.arrayOf)(validator2).isRequired;
                var chunk = chunks.shift();
                var chunkError = arrayOfValidator.apply(void 0, [
                    _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, chunk)),
                    propName,
                    componentName
                ].concat(rest));
                if (chunkError) {
                    if (minimum === 0) {
                        chunks.unshift(chunk);
                        continue;
                    }
                    return chunkError;
                }
                if (chunk.length < minimum) return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min2, " items, but only has ").concat(chunk.length, "."));
                if (chunk.length > maximum) return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max2, " items, but has ").concat(chunk.length, "."));
            }
            if (chunks.length > 0) return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
            return null;
        }
        var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;
        function sequenceOfValidator() {
            for(var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)specifiers[_key2] = arguments[_key2];
            if (specifiers.length === 0) throw new RangeError("sequenceOf: at least one specifier is required");
            var errors = specifiers.map(function(specifier, i) {
                return specifierValidator({
                    specifier: specifier
                }, "specifier", "sequenceOf specifier", "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
            });
            if (errors.some(Boolean)) throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function(e2, i) {
                return " - Argument index ".concat(i, ": ").concat(e2.message);
            }).join(",\n        "), "\n    "));
            var validator2 = function sequenceOf2(props, propName) {
                var propValue = props[propName];
                if (propValue == null) return null;
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                var error2 = _propTypes2.array.apply(void 0, [
                    props,
                    propName
                ].concat(rest));
                if (error2) return error2;
                return validateChunks.apply(void 0, [
                    specifiers,
                    props,
                    propName
                ].concat(rest));
            };
            validator2.isRequired = function sequenceOfRequired(props, propName, componentName) {
                for(var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)rest[_key4 - 3] = arguments[_key4];
                var error2 = _propTypes2.array.isRequired.apply(_propTypes2.array, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
                if (error2) return error2;
                return validateChunks.apply(void 0, [
                    specifiers,
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "sequenceOf", specifiers);
        }
    })(sequenceOf);
    return sequenceOf;
}
var hasRequiredChildrenSequenceOf;
function requireChildrenSequenceOf() {
    if (hasRequiredChildrenSequenceOf) return childrenSequenceOf;
    hasRequiredChildrenSequenceOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = childrenSequenceOfValidator;
        var _sequenceOf = _interopRequireDefault2(requireSequenceOf());
        var _renderableChildren = _interopRequireDefault2(requireRenderableChildren());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        function childrenSequenceOfValidator() {
            for(var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++)specifiers[_key] = arguments[_key];
            var seq = _sequenceOf["default"].apply(void 0, specifiers);
            var validator2 = function childrenSequenceOf2(props, propName, componentName) {
                if (propName !== "children") return new TypeError("".concat(componentName, ' is using the childrenSequenceOf validator on non-children prop "').concat(propName, '"'));
                var propValue = props[propName];
                var children2 = (0, _renderableChildren["default"])(propValue);
                if (children2.length === 0) return null;
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return seq.apply(void 0, [
                    _objectSpread(_objectSpread({}, props), {}, {
                        children: children2
                    }),
                    propName,
                    componentName
                ].concat(rest));
            };
            validator2.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
                if (propName !== "children") return new TypeError("".concat(componentName, ' is using the childrenSequenceOf validator on non-children prop "').concat(propName, '"'));
                var propValue = props[propName];
                var children2 = (0, _renderableChildren["default"])(propValue);
                if (children2.length === 0) return new TypeError("".concat(componentName, ": renderable children are required."));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return seq.isRequired.apply(seq, [
                    _objectSpread(_objectSpread({}, props), {}, {
                        children: children2
                    }),
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "childrenSequenceOf", specifiers);
        }
    })(childrenSequenceOf);
    return childrenSequenceOf;
}
var componentWithName = {};
var hasRequiredComponentWithName;
function requireComponentWithName() {
    if (hasRequiredComponentWithName) return componentWithName;
    hasRequiredComponentWithName = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = componentWithName2;
        var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
        var _isRegex = _interopRequireDefault2(requireIsRegex());
        var _arrayPrototype = _interopRequireDefault2(requireArray_prototype_find());
        var _getComponentName = _interopRequireDefault2(requireGetComponentName());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function stripHOCs(fullName, namesOfHOCsToStrip) {
            var innerName = fullName;
            while(/\([^()]*\)/g.test(innerName)){
                var HOC = innerName;
                var previousHOC = void 0;
                do {
                    previousHOC = HOC;
                    HOC = previousHOC.replace(/\([^()]*\)/g, "");
                }while (previousHOC !== HOC);
                if (namesOfHOCsToStrip.indexOf(HOC) === -1) return innerName;
                innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), "g"), "");
            }
            return innerName;
        }
        function hasName(name2, namesOfHOCsToStrip, propValue, propName, componentName) {
            for(var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
            if (Array.isArray(propValue)) return (0, _arrayPrototype["default"])(propValue.map(function(item2) {
                return hasName.apply(void 0, [
                    name2,
                    namesOfHOCsToStrip,
                    item2,
                    propName,
                    componentName
                ].concat(rest));
            }), Boolean) || null;
            if (!/* @__PURE__ */ _react2["default"].isValidElement(propValue)) return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
            var type = propValue.type;
            var componentNameFromType = (0, _getComponentName["default"])(type);
            var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;
            if ((0, _isRegex["default"])(name2) && !name2.test(innerComponentName)) return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name2));
            if (!(0, _isRegex["default"])(name2) && innerComponentName !== name2) return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name2, ", got ").concat(innerComponentName));
            return null;
        }
        function componentWithName2(name2) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (typeof name2 !== "string" && !(0, _isRegex["default"])(name2)) throw new TypeError("name must be a string or a regex");
            var passedOptions = Object.keys(options);
            if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== "stripHOCs") throw new TypeError("The only options supported are: \u201CstripHOCs\u201D, got: \u201C".concat(passedOptions.join("\u201D, \u201C"), "\u201D"));
            var _options$stripHOCs = options.stripHOCs, namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
            var allHOCNamesAreValid = namesOfHOCsToStrip.every(function(x2) {
                if (typeof x2 !== "string" || /[()]/g.test(x2)) return false;
                return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x2);
            });
            if (!allHOCNamesAreValid) throw new TypeError("every provided HOC name must be a string with no parens, and in camelCase");
            function componentWithNameValidator(props, propName, componentName) {
                var propValue = props[propName];
                if (props[propName] == null) return null;
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return hasName.apply(void 0, [
                    name2,
                    namesOfHOCsToStrip,
                    propValue,
                    propName,
                    componentName
                ].concat(rest));
            }
            componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name2));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return hasName.apply(void 0, [
                    name2,
                    namesOfHOCsToStrip,
                    propValue,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name2), name2);
        }
    })(componentWithName);
    return componentWithName;
}
var disallowedIf = {};
var hasRequiredDisallowedIf;
function requireDisallowedIf() {
    if (hasRequiredDisallowedIf) return disallowedIf;
    hasRequiredDisallowedIf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = disallowedIf2;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function disallowedIf2(propType, otherPropName, otherPropType) {
            if (typeof propType !== "function" || typeof propType.isRequired !== "function") throw new TypeError("a propType validator is required; propType validators must also provide `.isRequired`");
            if (typeof otherPropName !== "string") throw new TypeError("other prop name must be a string");
            if (typeof otherPropType !== "function") throw new TypeError("other prop type validator is required");
            function disallowedIfRequired(props, propName, componentName) {
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                var error2 = propType.isRequired.apply(propType, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
                if (error2) return error2;
                if (props[otherPropName] == null) return null;
                var otherError = otherPropType.apply(void 0, [
                    props,
                    otherPropName,
                    componentName
                ].concat(rest));
                if (otherError) return null;
                return new Error("prop \u201C".concat(propName, "\u201D is disallowed when \u201C").concat(otherPropName, "\u201D matches the provided validator"));
            }
            var validator2 = function disallowedIfPropType(props, propName) {
                if (props[propName] == null) return null;
                for(var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)rest[_key2 - 2] = arguments[_key2];
                return disallowedIfRequired.apply(void 0, [
                    props,
                    propName
                ].concat(rest));
            };
            validator2.isRequired = disallowedIfRequired;
            return (0, _wrapValidator["default"])(validator2, "disallowedIf", {
                propType: propType,
                otherPropName: otherPropName,
                otherPropType: otherPropType
            });
        }
    })(disallowedIf);
    return disallowedIf;
}
var elementType = {};
var hasRequiredElementType;
function requireElementType() {
    if (hasRequiredElementType) return elementType;
    hasRequiredElementType = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = elementTypeValidator;
        var _propTypes2 = propTypesExports;
        var _reactIs = requireReactIs();
        var _and = _interopRequireDefault2(requireAnd());
        var _getComponentName = _interopRequireDefault2(requireGetComponentName());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function getTypeName(Type2) {
            if (typeof Type2 === "string") return Type2;
            var type = (0, _getComponentName["default"])(Type2);
            return type || "Anonymous Component";
        }
        function validateElementType(Type2, props, propName, componentName) {
            var type = props[propName].type;
            if (type === Type2) return null;
            return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type2)));
        }
        function elementTypeValidator(Type2) {
            if (Type2 === "*") return (0, _wrapValidator["default"])(_propTypes2.element, "elementType(*)", Type2);
            if (!(0, _reactIs.isValidElementType)(Type2)) throw new TypeError('Type must be a React Component, an HTML element tag name, or "*". Got an '.concat(_typeof2(Type2)));
            function elementType2(props, propName, componentName) {
                if (props[propName] == null) return null;
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                return validateElementType.apply(void 0, [
                    Type2,
                    props,
                    propName,
                    componentName
                ].concat(rest));
            }
            elementType2.isRequired = elementType2;
            var typeName = getTypeName(Type2);
            var validatorName = "elementType(".concat(typeName, ")");
            return (0, _wrapValidator["default"])((0, _and["default"])([
                _propTypes2.element,
                elementType2
            ], validatorName), validatorName, Type2);
        }
    })(elementType);
    return elementType;
}
var empty$1 = {};
var or = {};
var hasRequiredOr;
function requireOr() {
    if (hasRequiredOr) return or;
    hasRequiredOr = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = or2;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _toConsumableArray2(arr) {
            return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread2();
        }
        function _nonIterableSpread2() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o2, minLen) {
            if (!o2) return;
            if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
            var n2 = Object.prototype.toString.call(o2).slice(8, -1);
            if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o2);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
        }
        function _iterableToArray2(iter) {
            if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
        }
        function _arrayWithoutHoles2(arr) {
            if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;
            for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
            return arr2;
        }
        function oneOfTypeValidator(validators2) {
            var validator2 = function oneOfType(props, propName, componentName) {
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                var propValue = props[propName];
                if (typeof propValue === "undefined") return null;
                var errors = validators2.map(function(v2) {
                    return v2.apply(void 0, [
                        props,
                        propName,
                        componentName
                    ].concat(rest));
                }).filter(Boolean);
                if (errors.length < validators2.length) return null;
                return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
            };
            validator2.isRequired = function oneOfTypeRequired(props, propName, componentName) {
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                var propValue = props[propName];
                if (typeof propValue === "undefined") return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
                var errors = validators2.map(function(v2) {
                    return v2.apply(void 0, [
                        props,
                        propName,
                        componentName
                    ].concat(rest));
                }).filter(Boolean);
                if (errors.length === validators2.length) return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
                return null;
            };
            return (0, _wrapValidator["default"])(validator2, "oneOfType", validators2);
        }
        function or2(validators2) {
            var name2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "or";
            if (!Array.isArray(validators2)) throw new TypeError("or: 2 or more validators are required");
            if (validators2.length <= 1) throw new RangeError("or: 2 or more validators are required");
            var validator2 = oneOfTypeValidator([
                (0, _propTypes2.arrayOf)(oneOfTypeValidator(validators2))
            ].concat(_toConsumableArray2(validators2)));
            return (0, _wrapValidator["default"])(validator2, name2, validators2);
        }
    })(or);
    return or;
}
var explicitNull = {};
var hasRequiredExplicitNull;
function requireExplicitNull() {
    if (hasRequiredExplicitNull) return explicitNull;
    hasRequiredExplicitNull = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
            };
            else _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
            return _typeof2(obj);
        }
        function explicitNull2(props, propName, componentName) {
            if (props[propName] == null) return null;
            return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null or undefined; received ").concat(_typeof2(props[propName])));
        }
        explicitNull2.isRequired = function explicitNullRequired(props, propName, componentName) {
            if (props[propName] === null) return null;
            return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null; received ").concat(_typeof2(props[propName])));
        };
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(explicitNull2, "explicitNull");
        };
        exports2["default"] = _default2;
    })(explicitNull);
    return explicitNull;
}
var hasRequiredEmpty;
function requireEmpty() {
    if (hasRequiredEmpty) return empty$1;
    hasRequiredEmpty = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _propTypes2 = propTypesExports;
        var _or = _interopRequireDefault2(requireOr());
        var _explicitNull = _interopRequireDefault2(requireExplicitNull());
        var _withShape = _interopRequireDefault2(requireWithShape());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var arrayOfValidator;
        var validator2 = (0, _or["default"])([
            _explicitNull["default"],
            // null/undefined
            (0, _propTypes2.oneOf)([
                false,
                "",
                NaN
            ]),
            (0, _withShape["default"])(_propTypes2.array, {
                length: (0, _propTypes2.oneOf)([
                    0
                ]).isRequired
            }).isRequired,
            function() {
                return arrayOfValidator.apply(void 0, arguments);
            }
        ]);
        arrayOfValidator = (0, _propTypes2.arrayOf)(validator2).isRequired;
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(validator2, "empty");
        };
        exports2["default"] = _default2;
    })(empty$1);
    return empty$1;
}
var keysOf = {};
var hasRequiredKeysOf;
function requireKeysOf() {
    if (hasRequiredKeysOf) return keysOf;
    hasRequiredKeysOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = keysOfValidator;
        var _isPrimitive = _interopRequireDefault2(requireIsPrimitive$2());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        function keysOfValidator(propType) {
            var name2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keysOf";
            if (typeof propType !== "function") throw new TypeError("argument to keysOf must be a valid PropType function");
            var validator2 = function keysOf2(props, propName, componentName, location2, propFullName) {
                for(var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
                var propValue = props[propName];
                if (propValue == null || (0, _isPrimitive["default"])(propValue)) return null;
                var firstError = null;
                Object.keys(propValue).some(function(key) {
                    firstError = propType.apply(void 0, [
                        _defineProperty({}, key, key),
                        key,
                        componentName,
                        location2,
                        "(".concat(propFullName, ").").concat(key)
                    ].concat(rest));
                    return firstError != null;
                });
                return firstError || null;
            };
            validator2.isRequired = function keyedByRequired(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return validator2.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, name2, propType);
        }
    })(keysOf);
    return keysOf;
}
var mutuallyExclusiveProps = {};
var hasRequiredMutuallyExclusiveProps;
function requireMutuallyExclusiveProps() {
    if (hasRequiredMutuallyExclusiveProps) return mutuallyExclusiveProps;
    hasRequiredMutuallyExclusiveProps = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = mutuallyExclusiveOfType;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        function mutuallyExclusiveOfType(propType) {
            if (typeof propType !== "function") throw new TypeError("a propType is required");
            for(var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)exclusiveProps[_key - 1] = arguments[_key];
            if (exclusiveProps.length < 1) throw new TypeError("at least one prop that is mutually exclusive with this propType is required");
            var propList = exclusiveProps.join(", or ");
            var map = exclusiveProps.reduce(function(acc, prop) {
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prop, true));
            }, {});
            var countProps = function countProps2(count2, prop) {
                return count2 + (map[prop] ? 1 : 0);
            };
            var validator2 = function mutuallyExclusiveProps2(props, propName, componentName) {
                var exclusivePropCount = Object.keys(props).filter(function(prop) {
                    return props[prop] != null;
                }).reduce(countProps, 0);
                if (exclusivePropCount > 1) return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return propType.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            validator2.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
                var exclusivePropCount = Object.keys(props).filter(function(prop) {
                    return prop === propName || props[prop] != null;
                }).reduce(countProps, 0);
                if (exclusivePropCount > 1) return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return propType.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
        }
    })(mutuallyExclusiveProps);
    return mutuallyExclusiveProps;
}
var mutuallyExclusiveTrueProps = {};
var hasRequiredMutuallyExclusiveTrueProps;
function requireMutuallyExclusiveTrueProps() {
    if (hasRequiredMutuallyExclusiveTrueProps) return mutuallyExclusiveTrueProps;
    hasRequiredMutuallyExclusiveTrueProps = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = mutuallyExclusiveTrue;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function mutuallyExclusiveTrue() {
            for(var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++)exclusiveProps[_key] = arguments[_key];
            if (exclusiveProps.length < 1) throw new TypeError("at least one prop that is mutually exclusive is required");
            if (!exclusiveProps.every(function(x2) {
                return typeof x2 === "string";
            })) throw new TypeError("all exclusive true props must be strings");
            var propsList = exclusiveProps.join(", or ");
            var validator2 = function mutuallyExclusiveTrueProps2(props, propName, componentName) {
                var countProps = function countProps2(count2, prop) {
                    return count2 + (props[prop] ? 1 : 0);
                };
                var exclusivePropCount = exclusiveProps.reduce(countProps, 0);
                if (exclusivePropCount > 1) return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return _propTypes2.bool.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            validator2.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
                var countProps = function countProps2(count2, prop) {
                    return count2 + (props[prop] ? 1 : 0);
                };
                var exclusivePropCount = exclusiveProps.reduce(countProps, 0);
                if (exclusivePropCount > 1) return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
                for(var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)rest[_key3 - 3] = arguments[_key3];
                return _propTypes2.bool.isRequired.apply(_propTypes2.bool, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(validator2, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
        }
    })(mutuallyExclusiveTrueProps);
    return mutuallyExclusiveTrueProps;
}
var nChildren = {};
var hasRequiredNChildren;
function requireNChildren() {
    if (hasRequiredNChildren) return nChildren;
    hasRequiredNChildren = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = nChildren2;
        var _react2 = _interopRequireDefault2((0, (/*@__PURE__*/$parcel$interopDefault($acw62))));
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function nChildren2(n2) {
            var propType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _propTypes2.node;
            if (typeof n2 !== "number" || isNaN(n2) || n2 < 0) throw new TypeError("a non-negative number is required");
            var validator2 = function nChildrenValidator(props, propName, componentName) {
                if (propName !== "children") return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
                var children2 = props.children;
                var childrenCount = _react2["default"].Children.count(children2);
                if (childrenCount !== n2) return new RangeError("".concat(componentName, " expects to receive ").concat(n2, " children, but received ").concat(childrenCount, " children."));
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                return propType.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            validator2.isRequired = validator2;
            return (0, _wrapValidator["default"])(validator2, "nChildren:".concat(n2), n2);
        }
    })(nChildren);
    return nChildren;
}
var numericString = {};
var hasRequiredNumericString;
function requireNumericString() {
    if (hasRequiredNumericString) return numericString;
    hasRequiredNumericString = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;
        var validator2 = function numericString2(props, propName, componentName) {
            if (props[propName] == null) return null;
            for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
            var stringError = _propTypes2.string.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
            if (stringError) return stringError;
            var value2 = props[propName];
            var passesRegex = validNumericChars.test(value2);
            if (passesRegex) return null;
            return new TypeError("".concat(componentName, ': prop "').concat(propName, '" (value "').concat(value2, '") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  '));
        };
        validator2.isRequired = function numericStringRequired(props, propName, componentName) {
            if (props[propName] == null) return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
            for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
            return validator2.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
        };
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(validator2, "numericString");
        };
        exports2["default"] = _default2;
    })(numericString);
    return numericString;
}
var predicate = {};
var hasRequiredPredicate;
function requirePredicate() {
    if (hasRequiredPredicate) return predicate;
    hasRequiredPredicate = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = predicate2;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function predicate2(fn2) {
            var message2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            if (typeof fn2 !== "function") throw new TypeError("`fn` must be a function");
            if (typeof message2 !== "string") throw new TypeError("`message`, if provided, must be a string");
            function requiredValidator(props, propName, componentName) {
                var result2 = fn2(props[propName]);
                if (result2) return null;
                return new TypeError("`".concat(componentName, "` requires that `").concat(propName, "` pass a predicate function").concat(message2 ? ": ".concat(message2) : "", "."));
            }
            function validator2(props, propName) {
                if (props[propName] == null) return null;
                for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)rest[_key - 2] = arguments[_key];
                return requiredValidator.apply(void 0, [
                    props,
                    propName
                ].concat(rest));
            }
            validator2.isRequired = requiredValidator;
            return (0, _wrapValidator["default"])(validator2, "predicate", fn2);
        }
    })(predicate);
    return predicate;
}
var range = {};
var hasRequiredRange;
function requireRange() {
    if (hasRequiredRange) return range;
    hasRequiredRange = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = range2;
        var _and = _interopRequireDefault2(requireAnd());
        var _between = _interopRequireDefault2(requireBetween());
        var _integer = _interopRequireDefault2(requireInteger());
        var _isInteger = _interopRequireDefault2(requireIsInteger());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var MAX_SAFE_INTEGER2 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ Math.pow(2, 53) - 1;
        function isValidLength(x2) {
            return (0, _isInteger["default"])(x2) && Math.abs(x2) < MAX_SAFE_INTEGER2;
        }
        function range2(min2, max2) {
            if (!isValidLength(min2) || !isValidLength(max2)) throw new RangeError('"range" requires two integers: '.concat(min2, " and ").concat(max2, " given"));
            if (min2 === max2) throw new RangeError("min and max must not be the same");
            return (0, _wrapValidator["default"])((0, _and["default"])([
                (0, _integer["default"])(),
                (0, _between["default"])({
                    gte: min2,
                    lt: max2
                })
            ], "range"), "range", {
                min: min2,
                max: max2
            });
        }
    })(range);
    return range;
}
var ref = {};
var hasRequiredRef;
function requireRef() {
    if (hasRequiredRef) return ref;
    hasRequiredRef = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _react2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
        var _isPlainObject = _interopRequireDefault2(requireIsPlainObject());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var isPrototypeOf = Object.prototype.isPrototypeOf;
        function isNewRef(prop) {
            if (!(0, _isPlainObject["default"])(prop)) return false;
            var ownProperties = Object.keys(prop);
            return ownProperties.length === 1 && ownProperties[0] === "current";
        }
        function isCallbackRef(prop) {
            return typeof prop === "function" && !isPrototypeOf.call(_react2.Component, prop) && (!_react2.PureComponent || !isPrototypeOf.call(_react2.PureComponent, prop));
        }
        function requiredRef(props, propName, componentName) {
            var propValue = props[propName];
            if (isCallbackRef(propValue) || isNewRef(propValue)) return null;
            return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
        }
        function ref2(props, propName, componentName) {
            var propValue = props[propName];
            if (propValue == null) return null;
            for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
            return requiredRef.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
        }
        ref2.isRequired = requiredRef;
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(ref2, "ref");
        };
        exports2["default"] = _default2;
    })(ref);
    return ref;
}
var requiredBy = {};
var hasRequiredRequiredBy;
function requireRequiredBy() {
    if (hasRequiredRequiredBy) return requiredBy;
    hasRequiredRequiredBy = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = getRequiredBy;
        var _objectIs = _interopRequireDefault2(requireObjectIs());
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function getRequiredBy(requiredByPropName, propType) {
            var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            function requiredBy2(props, propName, componentName) {
                if (props[requiredByPropName]) {
                    var propValue = props[propName];
                    if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === "undefined") return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop \u201C").concat(propName, "\u201D must be present."));
                }
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                return propType.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            }
            requiredBy2.isRequired = function requiredByRequired(props, propName, componentName) {
                var propValue = props[propName];
                if ((0, _objectIs["default"])(propValue, defaultValue)) return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be present."));
                for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
                return propType.isRequired.apply(propType, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
            };
            return (0, _wrapValidator["default"])(requiredBy2, "requiredBy \u201C".concat(requiredByPropName, "\u201D"), [
                requiredByPropName,
                defaultValue
            ]);
        }
    })(requiredBy);
    return requiredBy;
}
var restrictedProp = {};
var hasRequiredRestrictedProp;
function requireRestrictedProp() {
    if (hasRequiredRestrictedProp) return restrictedProp;
    hasRequiredRestrictedProp = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function customMessageWrapper(messsageFunction) {
            function restrictedProp2(props, propName, componentName, location2) {
                if (props[propName] == null) return null;
                if (messsageFunction && typeof messsageFunction === "function") {
                    for(var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)rest[_key - 4] = arguments[_key];
                    return new TypeError(messsageFunction.apply(void 0, [
                        props,
                        propName,
                        componentName,
                        location2
                    ].concat(rest)));
                }
                return new TypeError("The ".concat(propName, " ").concat(location2, " on ").concat(componentName, " is not allowed."));
            }
            restrictedProp2.isRequired = restrictedProp2;
            return restrictedProp2;
        }
        var _default2 = function _default3() {
            var messsageFunction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), "restrictedProp");
        };
        exports2["default"] = _default2;
    })(restrictedProp);
    return restrictedProp;
}
var stringEndsWith = {};
var hasRequiredStringEndsWith;
function requireStringEndsWith() {
    if (hasRequiredStringEndsWith) return stringEndsWith;
    hasRequiredStringEndsWith = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = stringEndsWithValidator;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function stringEndsWithValidator(end) {
            if (typeof end !== "string" || end.length === 0) throw new TypeError("a non-empty string is required");
            var validator2 = function stringEndsWith2(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return null;
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                var stringError = _propTypes2.string.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
                if (stringError) return stringError;
                if (!propValue.endsWith(end) || propValue.length <= end.length) return new TypeError("".concat(componentName, ": ").concat(propName, ' does not end with "').concat(end, '"'));
                return null;
            };
            validator2.isRequired = function requiredStringEndsWith() {
                var stringError = _propTypes2.string.isRequired.apply(_propTypes2.string, arguments);
                if (stringError) return stringError;
                return validator2.apply(void 0, arguments);
            };
            return (0, _wrapValidator["default"])(validator2, "stringEndsWith: ".concat(end));
        }
    })(stringEndsWith);
    return stringEndsWith;
}
var stringStartsWith = {};
var hasRequiredStringStartsWith;
function requireStringStartsWith() {
    if (hasRequiredStringStartsWith) return stringStartsWith;
    hasRequiredStringStartsWith = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = stringStartsWithValidator;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function stringStartsWithValidator(start) {
            if (typeof start !== "string" || start.length === 0) throw new TypeError("a non-empty string is required");
            var validator2 = function stringStartsWith2(props, propName, componentName) {
                var propValue = props[propName];
                if (propValue == null) return null;
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
                var stringError = _propTypes2.string.apply(void 0, [
                    props,
                    propName,
                    componentName
                ].concat(rest));
                if (stringError) return stringError;
                if (!propValue.startsWith(start) || propValue.length <= start.length) return new TypeError("".concat(componentName, ": ").concat(propName, ' does not start with "').concat(start, '"'));
                return null;
            };
            validator2.isRequired = function requiredStringStartsWith() {
                var stringError = _propTypes2.string.isRequired.apply(_propTypes2.string, arguments);
                if (stringError) return stringError;
                return validator2.apply(void 0, arguments);
            };
            return (0, _wrapValidator["default"])(validator2, "stringStartsWith: ".concat(start));
        }
    })(stringStartsWith);
    return stringStartsWith;
}
var uniqueArray = {};
var hasRequiredUniqueArray;
function requireUniqueArray() {
    if (hasRequiredUniqueArray) return uniqueArray;
    hasRequiredUniqueArray = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = void 0;
        var _propTypes2 = propTypesExports;
        var _wrapValidator = _interopRequireDefault2(requireWrapValidator());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function uniqueCountWithSet(arr) {
            return new Set(arr).size;
        }
        function uniqueCountLegacy(arr) {
            var seen = [];
            arr.forEach(function(item2) {
                if (seen.indexOf(item2) === -1) seen.push(item2);
            });
            return seen.length;
        }
        var getUniqueCount = typeof Set === "function" ? uniqueCountWithSet : /* istanbul ignore next */ uniqueCountLegacy;
        function requiredUniqueArray(props, propName, componentName) {
            for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
            var result2 = _propTypes2.array.isRequired.apply(_propTypes2.array, [
                props,
                propName,
                componentName
            ].concat(rest));
            if (result2 != null) return result2;
            var propValue = props[propName];
            var uniqueCount = getUniqueCount(propValue);
            if (uniqueCount !== propValue.length) return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
            return null;
        }
        function uniqueArray2(props, propName) {
            var propValue = props[propName];
            if (propValue == null) return null;
            for(var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)rest[_key2 - 2] = arguments[_key2];
            return requiredUniqueArray.apply(void 0, [
                props,
                propName
            ].concat(rest));
        }
        uniqueArray2.isRequired = requiredUniqueArray;
        var _default2 = function _default3() {
            return (0, _wrapValidator["default"])(uniqueArray2, "uniqueArray");
        };
        exports2["default"] = _default2;
    })(uniqueArray);
    return uniqueArray;
}
var uniqueArrayOf = {};
var hasRequiredUniqueArrayOf;
function requireUniqueArrayOf() {
    if (hasRequiredUniqueArrayOf) return uniqueArrayOf;
    hasRequiredUniqueArrayOf = 1;
    (function(exports2) {
        Object.defineProperty(exports2, "__esModule", {
            value: true
        });
        exports2["default"] = uniqueArrayOfTypeValidator;
        var _propTypes2 = propTypesExports;
        var _and = _interopRequireDefault2(requireAnd());
        var _uniqueArray = _interopRequireDefault2(requireUniqueArray());
        function _interopRequireDefault2(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function ownKeys(object2, enumerableOnly) {
            var keys3 = Object.keys(object2);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object2);
                if (enumerableOnly) symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
                });
                keys3.push.apply(keys3, symbols);
            }
            return keys3;
        }
        function _objectSpread(target2) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i] != null ? arguments[i] : {};
                if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target2, key, source[key]);
                });
                else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source));
                else ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target2;
        }
        function _defineProperty(obj, key, value2) {
            if (key in obj) Object.defineProperty(obj, key, {
                value: value2,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value2;
            return obj;
        }
        var unique = (0, _uniqueArray["default"])();
        function uniqueArrayOfTypeValidator(type) {
            if (typeof type !== "function") throw new TypeError("type must be a validator function");
            var mapper = null;
            var name2 = "uniqueArrayOfType";
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
            if (rest.length === 1) {
                if (typeof rest[0] === "function") mapper = rest[0];
                else if (typeof rest[0] === "string") name2 = rest[0];
                else throw new TypeError("single input must either be string or function");
            } else if (rest.length === 2) {
                if (typeof rest[0] === "function" && typeof rest[1] === "string") {
                    mapper = rest[0];
                    name2 = rest[1];
                } else throw new TypeError("multiple inputs must be in [function, string] order");
            } else if (rest.length > 2) throw new TypeError("only [], [name], [mapper], and [mapper, name] are valid inputs");
            function uniqueArrayOfMapped(props, propName) {
                var propValue = props[propName];
                if (propValue == null) return null;
                var values2 = propValue.map(mapper);
                for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                return unique.apply(void 0, [
                    _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, values2)),
                    propName
                ].concat(args));
            }
            uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
                var propValue = props[propName];
                for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
                if (propValue == null) return _propTypes2.array.isRequired.apply(_propTypes2.array, [
                    props,
                    propName
                ].concat(args));
                return uniqueArrayOfMapped.apply(void 0, [
                    props,
                    propName
                ].concat(args));
            };
            var arrayValidator = (0, _propTypes2.arrayOf)(type);
            var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
            var validator2 = (0, _and["default"])([
                arrayValidator,
                uniqueValidator
            ], name2);
            validator2.isRequired = (0, _and["default"])([
                uniqueValidator.isRequired,
                arrayValidator.isRequired
            ], "".concat(name2, ".isRequired"));
            return validator2;
        }
    })(uniqueArrayOf);
    return uniqueArrayOf;
}
var build;
var hasRequiredBuild;
function requireBuild() {
    if (hasRequiredBuild) return build;
    hasRequiredBuild = 1;
    var _propTypesExact = _interopRequireDefault2(requireBuild$1());
    var _and = _interopRequireDefault2(requireAnd());
    var _between = _interopRequireDefault2(requireBetween());
    var _booleanSome = _interopRequireDefault2(requireBooleanSome());
    var _childrenHavePropXorChildren = _interopRequireDefault2(requireChildrenHavePropXorChildren());
    var _childrenOf = _interopRequireDefault2(requireChildrenOf());
    var _childrenOfType = _interopRequireDefault2(requireChildrenOfType());
    var _childrenSequenceOf = _interopRequireDefault2(requireChildrenSequenceOf());
    var _componentWithName = _interopRequireDefault2(requireComponentWithName());
    var _disallowedIf = _interopRequireDefault2(requireDisallowedIf());
    var _elementType = _interopRequireDefault2(requireElementType());
    var _empty = _interopRequireDefault2(requireEmpty());
    var _explicitNull = _interopRequireDefault2(requireExplicitNull());
    var _integer = _interopRequireDefault2(requireInteger());
    var _keysOf = _interopRequireDefault2(requireKeysOf());
    var _mutuallyExclusiveProps = _interopRequireDefault2(requireMutuallyExclusiveProps());
    var _mutuallyExclusiveTrueProps = _interopRequireDefault2(requireMutuallyExclusiveTrueProps());
    var _nChildren = _interopRequireDefault2(requireNChildren());
    var _nonNegativeInteger = _interopRequireDefault2(requireNonNegativeInteger());
    var _nonNegativeNumber = _interopRequireDefault2(requireNonNegativeNumber());
    var _numericString = _interopRequireDefault2(requireNumericString());
    var _object = _interopRequireDefault2(requireObject());
    var _or = _interopRequireDefault2(requireOr());
    var _predicate = _interopRequireDefault2(requirePredicate());
    var _range = _interopRequireDefault2(requireRange());
    var _ref = _interopRequireDefault2(requireRef());
    var _requiredBy = _interopRequireDefault2(requireRequiredBy());
    var _restrictedProp = _interopRequireDefault2(requireRestrictedProp());
    var _sequenceOf = _interopRequireDefault2(requireSequenceOf());
    var _shape = _interopRequireDefault2(requireShape());
    var _stringEndsWith = _interopRequireDefault2(requireStringEndsWith());
    var _stringStartsWith = _interopRequireDefault2(requireStringStartsWith());
    var _uniqueArray = _interopRequireDefault2(requireUniqueArray());
    var _uniqueArrayOf = _interopRequireDefault2(requireUniqueArrayOf());
    var _valuesOf = _interopRequireDefault2(requireValuesOf());
    var _withShape = _interopRequireDefault2(requireWithShape());
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    build = {
        and: _and["default"],
        between: _between["default"],
        booleanSome: _booleanSome["default"],
        childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
        childrenOf: _childrenOf["default"],
        childrenOfType: _childrenOfType["default"],
        childrenSequenceOf: _childrenSequenceOf["default"],
        componentWithName: _componentWithName["default"],
        disallowedIf: _disallowedIf["default"],
        elementType: _elementType["default"],
        empty: _empty["default"],
        explicitNull: _explicitNull["default"],
        forbidExtraProps: _propTypesExact["default"],
        integer: _integer["default"],
        keysOf: _keysOf["default"],
        mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
        mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
        nChildren: _nChildren["default"],
        nonNegativeInteger: _nonNegativeInteger["default"],
        nonNegativeNumber: _nonNegativeNumber["default"],
        numericString: _numericString["default"],
        object: _object["default"],
        or: _or["default"],
        predicate: _predicate["default"],
        range: _range["default"],
        ref: _ref["default"],
        requiredBy: _requiredBy["default"],
        restrictedProp: _restrictedProp["default"],
        sequenceOf: _sequenceOf["default"],
        shape: _shape["default"],
        stringEndsWith: _stringEndsWith["default"],
        stringStartsWith: _stringStartsWith["default"],
        uniqueArray: _uniqueArray["default"],
        uniqueArrayOf: _uniqueArrayOf["default"],
        valuesOf: _valuesOf["default"],
        withShape: _withShape["default"]
    };
    return build;
}
var airbnbPropTypes = requireMocks();
var CAN_USE_DOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function testPassiveEventListeners() {
    if (!CAN_USE_DOM) return false;
    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) return false;
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            // eslint-disable-next-line getter-return
            get: /* @__PURE__ */ function() {
                function get2() {
                    supportsPassiveOption = true;
                }
                return get2;
            }()
        });
        var noop2 = function noop3() {};
        window.addEventListener("testPassiveEventSupport", noop2, opts);
        window.removeEventListener("testPassiveEventSupport", noop2, opts);
    } catch (e2) {}
    return supportsPassiveOption;
}
var memoized = void 0;
function canUsePassiveEventListeners() {
    if (memoized === void 0) memoized = testPassiveEventListeners();
    return memoized;
}
function normalizeEventOptions(eventOptions) {
    if (!eventOptions) return void 0;
    if (!canUsePassiveEventListeners()) return !!eventOptions.capture;
    return eventOptions;
}
function eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) return 0;
    if (normalizedEventOptions === true) return 100;
    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once2 = normalizedEventOptions.once << 2;
    return capture + passive + once2;
}
function ensureCanMutateNextEventHandlers(eventHandlers) {
    if (eventHandlers.handlers === eventHandlers.nextHandlers) eventHandlers.nextHandlers = eventHandlers.handlers.slice();
}
function TargetEventHandlers(target2) {
    this.target = target2;
    this.events = {};
}
TargetEventHandlers.prototype.getEventHandlers = /* @__PURE__ */ function() {
    function getEventHandlers(eventName, options) {
        var key = String(eventName) + " " + String(eventOptionsKey(options));
        if (!this.events[key]) {
            this.events[key] = {
                handlers: [],
                handleEvent: void 0
            };
            this.events[key].nextHandlers = this.events[key].handlers;
        }
        return this.events[key];
    }
    return getEventHandlers;
}();
TargetEventHandlers.prototype.handleEvent = /* @__PURE__ */ function() {
    function handleEvent(eventName, options, event2) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function(handler2) {
            if (handler2) handler2(event2);
        });
    }
    return handleEvent;
}();
TargetEventHandlers.prototype.add = /* @__PURE__ */ function() {
    function add(eventName, listener, options) {
        var _this = this;
        var eventHandlers = this.getEventHandlers(eventName, options);
        ensureCanMutateNextEventHandlers(eventHandlers);
        if (eventHandlers.nextHandlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }
        eventHandlers.nextHandlers.push(listener);
        var isSubscribed = true;
        var unsubscribe = /* @__PURE__ */ function() {
            function unsubscribe2() {
                if (!isSubscribed) return;
                isSubscribed = false;
                ensureCanMutateNextEventHandlers(eventHandlers);
                var index2 = eventHandlers.nextHandlers.indexOf(listener);
                eventHandlers.nextHandlers.splice(index2, 1);
                if (eventHandlers.nextHandlers.length === 0) {
                    if (_this.target) _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                    eventHandlers.handleEvent = void 0;
                }
            }
            return unsubscribe2;
        }();
        return unsubscribe;
    }
    return add;
}();
var EVENT_HANDLERS_KEY = "__consolidated_events_handlers__";
function addEventListener(target2, eventName, listener, options) {
    if (!target2[EVENT_HANDLERS_KEY]) target2[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target2);
    var normalizedEventOptions = normalizeEventOptions(options);
    return target2[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    addEventListener: addEventListener
}, Symbol.toStringTag, {
    value: "Module"
}));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var RequireObjectCoercible = RequireObjectCoercible$1;
var callBound = callBound$1;
var $isEnumerable = callBound("Object.prototype.propertyIsEnumerable");
var $push = callBound("Array.prototype.push");
var implementation$5 = function values(O2) {
    var obj = RequireObjectCoercible(O2);
    var vals = [];
    for(var key in obj)if ($isEnumerable(obj, key)) $push(vals, obj[key]);
    return vals;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill() {
    return typeof Object.values === "function" ? Object.values : implementation$4;
};
var getPolyfill$2 = polyfill$3;
var define$2 = defineProperties_1;
var shim$3 = function shimValues() {
    var polyfill2 = getPolyfill$2();
    define$2(Object, {
        values: polyfill2
    }, {
        values: function testValues() {
            return Object.values !== polyfill2;
        }
    });
    return polyfill2;
};
var define$1 = defineProperties_1;
var callBind = callBindExports;
var implementation$3 = implementation$5;
var getPolyfill$1 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind(getPolyfill$1(), Object);
define$1(polyfill$2, {
    getPolyfill: getPolyfill$1,
    implementation: implementation$3,
    shim: shim$2
});
var object_values = polyfill$2;
var implementation$2 = function contains2(other) {
    if (arguments.length < 1) throw new TypeError("1 argument is required");
    if (typeof other !== "object") throw new TypeError("Argument 1 (\u201Dother\u201C) to Node.contains must be an instance of Node");
    var node = other;
    do {
        if (this === node) return true;
        if (node) node = node.parentNode;
    }while (node);
    return false;
};
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill2() {
    if (typeof document !== "undefined") {
        if (document.contains) return document.contains;
        if (document.body && document.body.contains) try {
            if (typeof document.body.contains.call(document, "") === "boolean") return document.body.contains;
        } catch (e2) {}
    }
    return implementation$1;
};
var shim$1;
var hasRequiredShim;
function requireShim() {
    if (hasRequiredShim) return shim$1;
    hasRequiredShim = 1;
    var define2 = defineProperties_1;
    var getPolyfill4 = polyfill$1;
    shim$1 = function shimContains() {
        var polyfill2 = getPolyfill4();
        if (typeof document !== "undefined") {
            define2(document, {
                contains: polyfill2
            }, {
                contains: function() {
                    return document.contains !== polyfill2;
                }
            });
            if (typeof Element !== "undefined") define2(Element.prototype, {
                contains: polyfill2
            }, {
                contains: function() {
                    return Element.prototype.contains !== polyfill2;
                }
            });
        }
        return polyfill2;
    };
    return shim$1;
}
var define = defineProperties_1;
var implementation = implementation$2;
var getPolyfill3 = polyfill$1;
var polyfill = getPolyfill3();
var shim = requireShim();
var boundContains = function contains3(node, other) {
    return polyfill.apply(node, [
        other
    ]);
};
define(boundContains, {
    getPolyfill: getPolyfill3,
    implementation: implementation,
    shim: shim
});
var document_contains = boundContains;
(function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
        value: true
    });
    var _createClass = /* @__PURE__ */ function() {
        function defineProperties2(target2, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target2, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties2(Constructor.prototype, protoProps);
            if (staticProps) defineProperties2(Constructor, staticProps);
            return Constructor;
        };
    }();
    var _react2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
    var _react22 = _interopRequireDefault2(_react2);
    var _propTypes2 = propTypesExports;
    var _propTypes22 = _interopRequireDefault2(_propTypes2);
    var _airbnbPropTypes = airbnbPropTypes;
    var _consolidatedEvents = require$$3;
    var _object = object_values;
    var _object2 = _interopRequireDefault2(_object);
    var _document = document_contains;
    var _document2 = _interopRequireDefault2(_document);
    function _interopRequireDefault2(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self2, call2) {
        if (!self2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var DISPLAY = {
        BLOCK: "block",
        FLEX: "flex",
        INLINE: "inline",
        INLINE_BLOCK: "inline-block",
        CONTENTS: "contents"
    };
    var propTypes2 = (0, _airbnbPropTypes.forbidExtraProps)({
        children: _propTypes22["default"].node.isRequired,
        onOutsideClick: _propTypes22["default"].func.isRequired,
        disabled: _propTypes22["default"].bool,
        useCapture: _propTypes22["default"].bool,
        display: _propTypes22["default"].oneOf((0, _object2["default"])(DISPLAY))
    });
    var defaultProps = {
        disabled: false,
        // `useCapture` is set to true by default so that a `stopPropagation` in the
        // children will not prevent all outside click handlers from firing - maja
        useCapture: true,
        display: DISPLAY.BLOCK
    };
    var OutsideClickHandler2 = function(_React$Component) {
        _inherits(OutsideClickHandler3, _React$Component);
        function OutsideClickHandler3() {
            var _ref;
            _classCallCheck(this, OutsideClickHandler3);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler3.__proto__ || Object.getPrototypeOf(OutsideClickHandler3)).call.apply(_ref, [
                this
            ].concat(args)));
            _this.onMouseDown = _this.onMouseDown.bind(_this);
            _this.onMouseUp = _this.onMouseUp.bind(_this);
            _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
            return _this;
        }
        _createClass(OutsideClickHandler3, [
            {
                key: "componentDidMount",
                value: /* @__PURE__ */ function() {
                    function componentDidMount() {
                        var _props = this.props, disabled2 = _props.disabled, useCapture = _props.useCapture;
                        if (!disabled2) this.addMouseDownEventListener(useCapture);
                    }
                    return componentDidMount;
                }()
            },
            {
                key: "componentDidUpdate",
                value: /* @__PURE__ */ function() {
                    function componentDidUpdate(_ref2) {
                        var prevDisabled = _ref2.disabled;
                        var _props2 = this.props, disabled2 = _props2.disabled, useCapture = _props2.useCapture;
                        if (prevDisabled !== disabled2) {
                            if (disabled2) this.removeEventListeners();
                            else this.addMouseDownEventListener(useCapture);
                        }
                    }
                    return componentDidUpdate;
                }()
            },
            {
                key: "componentWillUnmount",
                value: /* @__PURE__ */ function() {
                    function componentWillUnmount() {
                        this.removeEventListeners();
                    }
                    return componentWillUnmount;
                }()
            },
            {
                key: "onMouseDown",
                value: /* @__PURE__ */ function() {
                    function onMouseDown(e2) {
                        var useCapture = this.props.useCapture;
                        var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e2.target);
                        if (!isDescendantOfRoot) {
                            if (this.removeMouseUp) {
                                this.removeMouseUp();
                                this.removeMouseUp = null;
                            }
                            this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, "mouseup", this.onMouseUp, {
                                capture: useCapture
                            });
                        }
                    }
                    return onMouseDown;
                }()
            },
            {
                key: "onMouseUp",
                value: /* @__PURE__ */ function() {
                    function onMouseUp(e2) {
                        var onOutsideClick = this.props.onOutsideClick;
                        var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e2.target);
                        if (this.removeMouseUp) {
                            this.removeMouseUp();
                            this.removeMouseUp = null;
                        }
                        if (!isDescendantOfRoot) onOutsideClick(e2);
                    }
                    return onMouseUp;
                }()
            },
            {
                key: "setChildNodeRef",
                value: /* @__PURE__ */ function() {
                    function setChildNodeRef(ref2) {
                        this.childNode = ref2;
                    }
                    return setChildNodeRef;
                }()
            },
            {
                key: "addMouseDownEventListener",
                value: /* @__PURE__ */ function() {
                    function addMouseDownEventListener(useCapture) {
                        this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, "mousedown", this.onMouseDown, {
                            capture: useCapture
                        });
                    }
                    return addMouseDownEventListener;
                }()
            },
            {
                key: "removeEventListeners",
                value: /* @__PURE__ */ function() {
                    function removeEventListeners() {
                        if (this.removeMouseDown) this.removeMouseDown();
                        if (this.removeMouseUp) this.removeMouseUp();
                    }
                    return removeEventListeners;
                }()
            },
            {
                key: "render",
                value: /* @__PURE__ */ function() {
                    function render2() {
                        var _props3 = this.props, children2 = _props3.children, display2 = _props3.display;
                        return _react22["default"].createElement("div", {
                            ref: this.setChildNodeRef,
                            style: display2 !== DISPLAY.BLOCK && (0, _object2["default"])(DISPLAY).includes(display2) ? {
                                display: display2
                            } : void 0
                        }, children2);
                    }
                    return render2;
                }()
            }
        ]);
        return OutsideClickHandler3;
    }(_react22["default"].Component);
    exports2["default"] = OutsideClickHandler2;
    OutsideClickHandler2.propTypes = propTypes2;
    OutsideClickHandler2.defaultProps = defaultProps;
})(OutsideClickHandler$1);
var reactOutsideClickHandler = OutsideClickHandler$1;
const OutsideClickHandlerBase = /* @__PURE__ */ getDefaultExportFromCjs(reactOutsideClickHandler);
const OutsideClickHandler = (props)=>{
    const { onOutsideClick, children: children2 } = props;
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandlerBase, {
        onOutsideClick: onOutsideClick
    }, children2);
};
const root$1J = "BanInfo-scss--module__root___dkfOo";
const prefix = "BanInfo-scss--module__prefix___lTpQi";
const s$2M = {
    root: root$1J,
    prefix: prefix
};
const locales$1D = {
    timeout: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442",
    banned: "\u0417\u0430\u0431\u0430\u043D\u0435\u043D",
    by: "\u043E\u0442",
    minute1: "\u043C\u0438\u043D\u0443\u0442\u0430",
    minute2: "\u043C\u0438\u043D\u0443\u0442\u044B",
    minute5: "\u043C\u0438\u043D\u0443\u0442",
    untilStreamEnd: "\u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u0441\u0442\u0440\u0438\u043C\u0430"
};
const t$1E = distExports$1.getTranslation && locales$1D;
const BanInfo = (props)=>{
    const { className, ban, onTimeoutEnd } = props;
    const [now2, setNow] = (0, $acw62.useState)(Date.now());
    (0, $acw62.useEffect)(()=>{
        let interval = 0;
        if (ban.isTemporary) interval = window.setInterval(()=>{
            setNow(Date.now());
            if (Date.now() >= getUnixTime(ban.expireTime)) {
                window.clearInterval(interval);
                onTimeoutEnd();
            }
        }, 1e3);
        return ()=>{
            window.clearInterval(interval);
        };
    }, [
        ban
    ]);
    const getPostfix = ()=>{
        const { minutes, seconds } = getDiffBetweenDates(now2, getUnixTime(ban.expireTime));
        const mins = declOfNum([
            t$1E.minute1,
            t$1E.minute2,
            t$1E.minute5
        ], minutes);
        return `${minutes}:${addLeadZero(seconds % 60)} ${mins}`;
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2M.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2M.prefix
    }, Boolean(ban.isPermanent) && t$1E.banned, Boolean(ban.isTemporary) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, t$1E.timeout, " ", getPostfix()), Boolean(ban.isByStream) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, t$1E.timeout, " ", t$1E.untilStreamEnd)), "\xa0", t$1E.by, "\xa0", ban.moderator.nick);
};
const root$1I = "RoleCard-scss--module__root___pL58i";
const label$4 = "RoleCard-scss--module__label___V-EfI";
const name$a = "RoleCard-scss--module__name___z3eYx";
const s$2L = {
    root: root$1I,
    label: label$4,
    name: name$a
};
const RoleCard = (props)=>{
    const { classNames = {}, role: role2, isChecked, size: size2 = EResizableImageSize.SMALL, onToggle } = props;
    const handleCheckbox = (checked2)=>{
        onToggle(checked2, role2);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2L.root, classNames.root)
    }, /* @__PURE__ */ $acw62.createElement(SimpleCheckBox, {
        containerClassName: classNames.container,
        labelClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2L.label, classNames.label),
        isDefaultChecked: isChecked,
        label: /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(Role, {
            role: role2,
            size: size2
        }), /* @__PURE__ */ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2L.name, classNames.name)
        }, role2.name)),
        onToggle: handleCheckbox
    }));
};
const root$1H = "Roles-scss--module__root___z9yCY";
const empty = "Roles-scss--module__empty___o9vlC";
const title$n = "Roles-scss--module__title___6j0MK";
const description$a = "Roles-scss--module__description___vj1Hx";
const settings = "Roles-scss--module__settings___rFS25";
const role = "Roles-scss--module__role___vhF2p";
const name$9 = "Roles-scss--module__name___Gn3r9";
const scrollContainer = "Roles-scss--module__scrollContainer___YSlva";
const s$2K = {
    root: root$1H,
    empty: empty,
    title: title$n,
    description: description$a,
    settings: settings,
    role: role,
    name: name$9,
    scrollContainer: scrollContainer
};
const locales$1C = {
    title: "\u0412\u044B \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u0438\u043B\u0438 \u0440\u043E\u043B\u0438",
    description: "\u0414\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0440\u043E\u043B\u0435\u0439 \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
    settings: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"
};
const t$1D = distExports$1.getTranslation && locales$1C;
const DEBOUNCE_TIME_MS = 800;
const Roles = (props)=>{
    const { userId, createdRoles, userRoles = [], backLink: backLink2, onAssignRole } = props;
    const hasRoles = (createdRoles == null ? void 0 : createdRoles.length) > 0;
    const ids = userRoles.map((role2)=>role2.id);
    const [selectedRoles, setSelectedRoles] = (0, $acw62.useState)(userRoles);
    const prevSelectedRoles = usePrevious(selectedRoles);
    const { blogUrl } = useStreamIdentity();
    (0, $acw62.useEffect)(()=>{
        if (userId && Boolean(selectedRoles) && Boolean(prevSelectedRoles)) debouncedAssignRoles(userId, selectedRoles);
    }, [
        selectedRoles,
        userId
    ]);
    const debouncedAssignRoles = (0, $acw62.useCallback)(debounce(async (id, selected2)=>{
        try {
            await onAssignRole(id, selected2);
        } catch (ignore) {}
    }, DEBOUNCE_TIME_MS), []);
    const handleToggleRole = (isChecked, role2)=>{
        setSelectedRoles((prevState)=>{
            if (!isChecked) return prevState.filter((item2)=>item2.id !== role2.id);
            return [
                ...prevState,
                role2
            ];
        });
    };
    const renderEmptyBlock = ()=>{
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2K.empty
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2K.title
        }, t$1D.title), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2K.description
        }, t$1D.description), /* @__PURE__ */ $acw62.createElement(Link, {
            to: dist$4.getParametrizedUrl(URLS.COMMUNITY_ROLES, {
                blogUrl: blogUrl
            }),
            className: s$2K.settings
        }, t$1D.settings));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2K.root
    }, /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        className: s$2K.scrollContainer
    }, backLink2, hasRoles ? createdRoles.map((role2)=>/* @__PURE__ */ $acw62.createElement(RoleCard, {
            key: role2.id,
            role: role2,
            classNames: {
                root: s$2K.role,
                label: s$2K.label,
                name: s$2K.name
            },
            isChecked: ids.includes(role2.id),
            onToggle: handleToggleRole
        })) : renderEmptyBlock()));
};
const item$7 = "Controls-scss--module__item___GjQ-W";
const icon$z = "Controls-scss--module__icon___LI9Jh";
const backLink = "Controls-scss--module__backLink___Qv-dC";
const backIcon = "Controls-scss--module__backIcon___8OCyu";
const giftIcon = "Controls-scss--module__giftIcon___-X2PI";
const sticky = "Controls-scss--module__sticky___Y3cZ5";
const timeoutHelp = "Controls-scss--module__timeoutHelp___-YVex";
const option = "Controls-scss--module__option___Bttz0";
const s$2J = {
    item: item$7,
    icon: icon$z,
    backLink: backLink,
    backIcon: backIcon,
    giftIcon: giftIcon,
    sticky: sticky,
    timeoutHelp: timeoutHelp,
    option: option
};
const locales$1B = {
    gift: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0434\u0430\u0440\u043E\u043A",
    mention: "\u0423\u043F\u043E\u043C\u044F\u043D\u0443\u0442\u044C",
    timeout: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442",
    cancelTimeout: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0430\u0439\u043C\u0430\u0443\u0442",
    ban: "\u0411\u0430\u043D",
    cancelBan: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u0430\u043D",
    vkPageProfile: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 VK",
    vkPlayProfile: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u0432 VK Play",
    channel: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B",
    deleteMessages: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
    back: "\u041D\u0430\u0437\u0430\u0434",
    selectTimeout: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0442\u0430\u0439\u043C\u0430\u0443\u0442\u0430",
    manageRoles: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0440\u043E\u043B\u044F\u043C\u0438",
    promote: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C",
    reply: "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C",
    block: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
};
const t$1C = distExports$1.getTranslation && locales$1B;
const Controls = (props)=>{
    var _a3, _b2, _c2;
    const { blogUrl, userStat, roles: roles2, threadId, className, isCurrentUserModerator, isCurrentUserOwner, isOwner, isCurrentUser, isRolesVisible, isChatContext, isChannelRolesEnabled, isOnlyRecordChatMode, onClose, onBan, onTimeout, onBanCancel, onMention, onToggleRoleVisibility, onAssignRole, onRightsClick, onReply, onGiftClick } = props;
    const { isAuthorized, isChannelAdmin: isCurrentUserChannelAdmin, isChannelModerator: isCurrentUserChannelModerator, isChannelChatModerator: isCurrentUserChatModerator } = useCurrentUserAccess();
    const location2 = window.location;
    const isIsolatedPage = isPathMatching(location2.pathname, ISOLATED_WINDOW_URLS);
    const { showPopup } = distExports.useOverlayPopups();
    const { role: moderatorRole } = (userStat == null ? void 0 : userStat.moderator) || {};
    const getProfileLink = (type)=>{
        var _a4, _b3, _c3;
        return (_c3 = (_b3 = (_a4 = userStat == null ? void 0 : userStat.user) == null ? void 0 : _a4.profileLinks) == null ? void 0 : _b3.find((item2)=>item2.type === type)) == null ? void 0 : _c3.link;
    };
    const isAdmin = moderatorRole === EModeratorRoles.CHANNEL_ADMIN;
    const isModerator = moderatorRole === EModeratorRoles.CHANNEL_MODERATOR;
    const isChatModerator = moderatorRole === EModeratorRoles.CHANNEL_CHAT_MODERATOR;
    const userId = userStat == null ? void 0 : userStat.user.id;
    const userName = userStat == null ? void 0 : userStat.user.displayName;
    const userBlogUrl = (_a3 = userStat == null ? void 0 : userStat.blog) == null ? void 0 : _a3.blogUrl;
    const bans = (userStat == null ? void 0 : userStat.bans) || [];
    const channelLink = getParametrizedUrl(URLS.BLOG, {
        blogUrl: userBlogUrl
    });
    const isFollower = Boolean((_b2 = userStat == null ? void 0 : userStat.subscriberInfo) == null ? void 0 : _b2.subscriptionLevel);
    const vkProfileLink = getProfileLink(EExternalLinksSource.VK);
    const vkplayProfileLink = getProfileLink(EExternalLinksSource.VKPLAY);
    const [isTimeoutSelectVisible, setIsTimeoutSelectVisible] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const timeoutOptions = useChatTimeoutOptions();
    const subscriptionLevels = (0, $iD0SF.useSelector)(subscriptionLevelsSelector);
    const [ban] = bans;
    const handleTimeoutClick = ()=>{
        if ((ban == null ? void 0 : ban.isTemporary) || (ban == null ? void 0 : ban.isByStream)) onBanCancel(userId, Boolean(ban == null ? void 0 : ban.isByStream));
        else setIsTimeoutSelectVisible(true);
    };
    const handleBanClick = ()=>{
        if (ban == null ? void 0 : ban.isPermanent) onBanCancel(userId, false);
        else onBan(userId);
    };
    const handleMentionClick = ()=>onMention(userStat.user);
    const handlePromoteClick = ()=>onRightsClick();
    const handleBackClick = ()=>setIsTimeoutSelectVisible(false);
    const handleTimeoutSelect = (key)=>{
        onTimeout(userId, key);
        setIsTimeoutSelectVisible(false);
    };
    const handleMessagesDeleteClick = ()=>dispatch(cleanStreamChatMessages.action({
            blogUrl: blogUrl,
            userId: userId
        }));
    const handleTimeoutEnd = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUserStat.action)({
            blogUrl: blogUrl,
            userId: userId
        }));
    };
    const handleReplyClick = ()=>{
        onReply(userStat.user);
    };
    const showBlackListUserPopup = (event2)=>{
        event2.stopPropagation();
        event2.preventDefault();
        if (isIsolatedPage) onClose();
        showPopup({
            type: EPopup.BLACK_LIST,
            data: {
                blogUrl: blogUrl,
                userId: userId,
                userName: userName
            }
        });
    };
    if (isRolesVisible) return /* @__PURE__ */ $acw62.createElement(Roles, {
        backLink: /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2J.backLink, s$2J.sticky),
            onClick: onToggleRoleVisibility
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$2J.backIcon,
            glyph: svg_name_arrow_short
        }), t$1C.back),
        userId: userId,
        createdRoles: roles2,
        userRoles: (_c2 = userStat.user) == null ? void 0 : _c2.roles,
        onAssignRole: onAssignRole
    });
    if (isTimeoutSelectVisible) return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.backLink,
        onClick: handleBackClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.backIcon,
        glyph: svg_name_arrow_short
    }), t$1C.back), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.timeoutHelp
    }, t$1C.selectTimeout), /* @__PURE__ */ $acw62.createElement("div", null, timeoutOptions.map(({ value: value2, label: label2 })=>/* @__PURE__ */ $acw62.createElement("div", {
            key: value2,
            className: s$2J.option,
            onClick: ()=>onTimeout && handleTimeoutSelect(value2)
        }, label2))));
    const shouldShowVkProfileLink = Boolean(vkProfileLink);
    const shouldShowVkPlayProfileLink = Boolean(vkplayProfileLink);
    const shouldShowMentionButton = !isCurrentUser && onMention && !isOnlyRecordChatMode;
    const shouldShowGiftButton = !isCurrentUser && !isOwner && Boolean(subscriptionLevels.length);
    const shouldShowReplyButton = !isCurrentUser && Boolean(threadId) && onReply && !isOnlyRecordChatMode;
    const shouldShowChannelButton = Boolean(userBlogUrl) && !isOwner;
    const shouldShowModerationButtons = isCurrentUserOwner || (isCurrentUserChannelAdmin || isCurrentUserChannelModerator || isCurrentUserChatModerator) && !isOwner && !isAdmin && !isModerator && !isChatModerator;
    const shouldShowTimeoutButton = !isOnlyRecordChatMode;
    const shouldShowDeleteMessages = isChatContext && (isCurrentUserOwner || isCurrentUserModerator) && !isOwner && !isCurrentUser && !isOnlyRecordChatMode;
    const shouldShowUserRoles = (isCurrentUserOwner || isCurrentUserChannelAdmin && !isOwner && (isCurrentUser || !isAdmin) || isCurrentUserChannelModerator && !isOwner && !isAdmin && (isCurrentUser || !isModerator)) && isChannelRolesEnabled;
    const isPromotionActionsAvailable = isCurrentUserOwner && !isCurrentUser && onRightsClick && !ban;
    const shouldShowGrantModeratorRoleButton = isPromotionActionsAvailable && isFollower;
    const shouldShowBlockButton = !isCurrentUser && isAuthorized;
    const openChannel = ()=>{
        window.open(channelLink, "_blank");
    };
    if (!shouldShowMentionButton && !shouldShowChannelButton && !shouldShowModerationButtons && !isPromotionActionsAvailable && !shouldShowGiftButton && !shouldShowUserRoles && !shouldShowBlockButton) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, shouldShowGiftButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: onGiftClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2J.icon, s$2J.giftIcon),
        glyph: svg_name_gift
    }), t$1C.gift), Boolean(ban) && /* @__PURE__ */ $acw62.createElement(BanInfo, {
        ban: ban,
        onTimeoutEnd: handleTimeoutEnd
    }), shouldShowMentionButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handleMentionClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_mention
    }), t$1C.mention), shouldShowReplyButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handleReplyClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_reply
    }), t$1C.reply), shouldShowVkProfileLink && /* @__PURE__ */ $acw62.createElement(Link, {
        className: s$2J.item,
        to: vkProfileLink,
        target: "_blank"
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_user_card_outline_28
    }), t$1C.vkPageProfile), shouldShowVkPlayProfileLink && /* @__PURE__ */ $acw62.createElement(Link, {
        className: s$2J.item,
        to: vkplayProfileLink,
        target: "_blank"
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_profile_with_person
    }), t$1C.vkPlayProfile), shouldShowUserRoles && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: onToggleRoleVisibility
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_roles
    }), t$1C.manageRoles), shouldShowChannelButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: openChannel
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_cam
    }), t$1C.channel), shouldShowDeleteMessages && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handleMessagesDeleteClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_delete_all_messages
    }), t$1C.deleteMessages), shouldShowGrantModeratorRoleButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handlePromoteClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_grant_role
    }), t$1C.promote), shouldShowModerationButtons && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, shouldShowTimeoutButton && onTimeout && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handleTimeoutClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_clock
    }), (ban == null ? void 0 : ban.isTemporary) || (ban == null ? void 0 : ban.isByStream) ? t$1C.cancelTimeout : t$1C.timeout), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: handleBanClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_ban
    }), (ban == null ? void 0 : ban.isPermanent) ? t$1C.cancelBan : t$1C.ban)), shouldShowBlockButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2J.item,
        onClick: showBlackListUserPopup
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2J.icon,
        glyph: svg_name_hide_outline_20
    }), t$1C.block));
};
const root$1G = "ChatBadge-scss--module__root___OHm-F";
const image$4 = "ChatBadge-scss--module__image___MqJgC";
const s$2I = {
    root: root$1G,
    image: image$4
};
const locales$1A = {
    owner: "\u0410\u0432\u0442\u043E\u0440 \u0441\u0442\u0440\u0438\u043C\u0430",
    moderator: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440",
    paid_subscriber: "\u041F\u043B\u0430\u0442\u043D\u044B\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A",
    subscription_00: "\u0411\u0430\u0437\u043E\u0432\u044B\u0439",
    subscription_02: "2 \u043C\u0435\u0441\u044F\u0446\u0430",
    subscription_03: "3 \u043C\u0435\u0441\u044F\u0446\u0430",
    subscription_06: "6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
    subscription_09: "9 \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
    subscription_12: "1 \u0433\u043E\u0434",
    subscription_18: "1.5 \u0433\u043E\u0434\u0430",
    subscription_24: "2 \u0433\u043E\u0434\u0430",
    subscription_30: "2.5 \u0433\u043E\u0434\u0430",
    subscription_36: "3 \u0433\u043E\u0434\u0430",
    internal_chatbot: "\u0427\u0430\u0442-\u0411\u043E\u0442",
    vkplay_team: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 {{projectName}}",
    vk_video_live_team: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 {{projectName}}",
    vip_streamer: "VIP-\u0441\u0442\u0440\u0438\u043C\u0435\u0440",
    // eslint-disable-next-line sonarjs/no-duplicate-string
    decision_00: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decision_01: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decision_02: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decision_03: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decision_04: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decision_05: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0438\u0441\u0445\u043E\u0434 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    gifter_00: "\u0422\u043E\u043F \u21161 \u0434\u0430\u0440\u0438\u0442\u0435\u043B\u044C \u043A\u0430\u043D\u0430\u043B\u0430",
    gifter_01: "\u0422\u043E\u043F \u21162 \u0434\u0430\u0440\u0438\u0442\u0435\u043B\u044C \u043A\u0430\u043D\u0430\u043B\u0430",
    gifter_02: "\u0422\u043E\u043F \u21163 \u0434\u0430\u0440\u0438\u0442\u0435\u043B\u044C \u043A\u0430\u043D\u0430\u043B\u0430",
    gifter_03: "\u0422\u043E\u043F \u21164 \u0434\u0430\u0440\u0438\u0442\u0435\u043B\u044C \u043A\u0430\u043D\u0430\u043B\u0430",
    gifter_04: "\u0422\u043E\u043F \u21165 \u0434\u0430\u0440\u0438\u0442\u0435\u043B\u044C \u043A\u0430\u043D\u0430\u043B\u0430",
    verified_streamer: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B",
    level_0: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 0",
    level_1: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 1",
    level_2: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 2",
    level_3: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 3",
    level_4: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 4",
    level_5: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 5",
    level_6: "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B | \u0423\u0440\u043E\u0432\u0435\u043D\u044C 6",
    channel_admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
    channel_moderator: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440",
    channel_chat_moderator: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440 \u0447\u0430\u0442\u0430"
};
const t$1B = distExports$1.getTranslation && locales$1A;
const getTooltipText = (badge2)=>{
    const { achievement: { name: achievementName, type }, name: name2 } = badge2;
    const achievement = distExports$1.getParametrizedText(t$1B[achievementName], {
        projectName: getProjectName()
    });
    if (name2 && type === EBadgeAchievementType.SUBSCRIPTION && achievementName !== "subscription_00") return `${name2} ${achievement}`;
    return name2 || achievement;
};
const ChatBadge = (props)=>{
    const { badge: badge2, classNames, pixelSize, size: size2 = EResizableImageSize.SMALL } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        key: badge2.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2I.root, classNames == null ? void 0 : classNames.root),
        title: getTooltipText(badge2)
    }, /* @__PURE__ */ $acw62.createElement(Badge, {
        badge: badge2,
        classNames: {
            root: classNames == null ? void 0 : classNames.badgeRoot,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2I.image, classNames == null ? void 0 : classNames.badgeImage)
        },
        pixelSize: pixelSize,
        size: size2
    }));
};
ChatBadge.displayName = "ChatBadge";
const root$1F = "ChatRole-scss--module__root___5m4Ug";
const image$3 = "ChatRole-scss--module__image___VUXWz";
const s$2H = {
    root: root$1F,
    image: image$3
};
const ChatRole = (props)=>{
    const { role: role2, classNames, size: size2 = EResizableImageSize.SMALL } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        key: role2.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2H.root, classNames == null ? void 0 : classNames.root),
        title: role2.name
    }, /* @__PURE__ */ $acw62.createElement(Role, {
        role: role2,
        classNames: {
            root: classNames == null ? void 0 : classNames.roleRoot,
            img: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2H.image, classNames == null ? void 0 : classNames.roleImage)
        },
        size: size2
    }));
};
const title$m = "Insignia-scss--module__title___q9XyK";
const container$9 = "Insignia-scss--module__container___cemWf";
const item$6 = "Insignia-scss--module__item___YaFAO";
const itemImage = "Insignia-scss--module__itemImage___7WgGp";
const s$2G = {
    title: title$m,
    container: container$9,
    item: item$6,
    itemImage: itemImage
};
const locales$1z = {
    title: "\u0417\u043D\u0430\u0447\u043A\u0438"
};
const t$1A = distExports$1.getTranslation && locales$1z;
const Insignia = (props)=>{
    const { badges: badges2, roles: roles2, className } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2G.title
    }, t$1A.title), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2G.container
    }, badges2.map((badge2)=>/* @__PURE__ */ $acw62.createElement(ChatBadge, {
            key: badge2.id,
            badge: badge2,
            classNames: {
                badgeRoot: s$2G.item,
                badgeImage: s$2G.itemImage
            },
            pixelSize: 28,
            size: EResizableImageSize.LARGE
        })), Boolean(roles2 == null ? void 0 : roles2.length) && (roles2 == null ? void 0 : roles2.map((role2)=>/* @__PURE__ */ $acw62.createElement(ChatRole, {
            key: role2.id,
            role: role2,
            classNames: {
                roleRoot: s$2G.item,
                roleImage: s$2G.itemImage
            },
            size: EResizableImageSize.LARGE
        })))));
};
var ESubscriptionLevels = /* @__PURE__ */ ((ESubscriptionLevels2)=>{
    ESubscriptionLevels2["FOLLOWER"] = "Follower";
    return ESubscriptionLevels2;
})(ESubscriptionLevels || {});
const root$1E = "Subscription-scss--module__root___RpbB0";
const icon$y = "Subscription-scss--module__icon___jxeJq";
const iconFollows = "Subscription-scss--module__iconFollows___KCqrd";
const label$3 = "Subscription-scss--module__label___BJpvr";
const delimiter$2 = "Subscription-scss--module__delimiter___8kHlm";
const s$2F = {
    root: root$1E,
    icon: icon$y,
    iconFollows: iconFollows,
    label: label$3,
    delimiter: delimiter$2
};
const locales$1y = {
    level: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C",
    follows: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0435\u0442",
    subscribed: "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u043D",
    month1: "\u043C\u0435\u0441\u044F\u0446",
    month2: "\u043C\u0435\u0441\u044F\u0446\u0430",
    month5: "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
    year1: "\u0433\u043E\u0434",
    year2: "\u0433\u043E\u0434\u0430",
    year5: "\u043B\u0435\u0442",
    lessThanAMonth: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0435\u0441\u044F\u0446\u0430",
    and: "\u0438"
};
const t$1z = distExports$1.getTranslation && locales$1y;
const MONTHS_IN_YEAR = 12;
const getDurationLabel = (num2)=>{
    if (num2 <= 0) return t$1z.lessThanAMonth;
    const months = num2 % MONTHS_IN_YEAR;
    const years = Math.floor(num2 / MONTHS_IN_YEAR);
    if (years > 0) {
        if (months > 0) return `${years} ${declOfNum([
            t$1z.year1,
            t$1z.year2,
            t$1z.year5
        ], years)} ${t$1z.and} ${months} ${declOfNum([
            t$1z.month1,
            t$1z.month2,
            t$1z.month5
        ], months)}`;
        return `${years} ${declOfNum([
            t$1z.year1,
            t$1z.year2,
            t$1z.year5
        ], years)}`;
    }
    return `${months} ${declOfNum([
        t$1z.month1,
        t$1z.month2,
        t$1z.month5
    ], months)}`;
};
const Subscription = (props)=>{
    var _a3, _b2;
    const { subscriberInfo } = props;
    const { months: subscriptionMonths } = getDiffBetweenDates(Date.now(), Date.now() - subscriberInfo.subscriptionDaysDuration * MS_PER_DAY);
    const { months: paidSubscriptionMonths } = getDiffBetweenDates(Date.now(), Date.now() - subscriberInfo.paidSubscriptionDaysDuration * MS_PER_DAY);
    if (!(subscriberInfo == null ? void 0 : subscriberInfo.subscriptionLevel)) return null;
    const isFollower = ((_a3 = subscriberInfo == null ? void 0 : subscriberInfo.subscriptionLevel) == null ? void 0 : _a3.name) === ESubscriptionLevels.FOLLOWER;
    const level = (_b2 = subscriberInfo == null ? void 0 : subscriberInfo.subscriptionLevel) == null ? void 0 : _b2.name;
    const hasSubLevel = level && !isFollower;
    const subscriptionLabel = getDurationLabel(subscriptionMonths);
    const paidSubscriptionLabel = getDurationLabel(paidSubscriptionMonths);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2F.root
    }, hasSubLevel && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2F.label
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2F.icon,
        glyph: svg_name_user_start_outline_20
    }), t$1z.level, ": ", level), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2F.label
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2F.icon, s$2F.iconFollows),
        glyph: svg_name_done_16
    }), t$1z.follows, ": ", subscriptionLabel), !isFollower && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2F.label
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2F.icon,
        glyph: svg_name_calendar_check_outline_20
    }), t$1z.subscribed, ": ", paidSubscriptionLabel)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2F.delimiter
    }));
};
class Timer extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            currentTimer: this.props.timeout
        };
        this.counter = ()=>{
            const { currentTimer } = this.state;
            const { onTimeout } = this.props;
            const nextTick = currentTimer - 1;
            if (nextTick < 0) {
                onTimeout();
                window.clearInterval(this.timerId);
            } else this.setState({
                currentTimer: currentTimer - 1
            });
        };
    }
    componentDidMount() {
        this.timerId = window.setInterval(this.counter, 1e3);
    }
    componentWillUnmount() {
        window.clearInterval(this.timerId);
    }
    render() {
        const { currentTimer } = this.state;
        const minutes = Math.floor(currentTimer / 60);
        const seconds = currentTimer - minutes * 60;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, String(minutes).padStart(2, "0"), ":", String(seconds).padStart(2, "0"));
    }
}
var EModerationPopupInfoTestId = /* @__PURE__ */ ((EModerationPopupInfoTestId2)=>{
    EModerationPopupInfoTestId2["ROOT"] = "root";
    return EModerationPopupInfoTestId2;
})(EModerationPopupInfoTestId || {});
const POPUP_INFO_TEST_ID = "UserStatPopupInfo";
const footer$9 = "PopupInfo-scss--module__footer___v58v3";
const counter = "PopupInfo-scss--module__counter___PRG4j";
const counterClickable = "PopupInfo-scss--module__counterClickable___8ARX-";
const counterClickableIcon = "PopupInfo-scss--module__counterClickableIcon___Q-r3I";
const count$2 = "PopupInfo-scss--module__count___sb8-H";
const label$2 = "PopupInfo-scss--module__label___HXnND";
const statuses = "PopupInfo-scss--module__statuses___-UuOb";
const banStatus = "PopupInfo-scss--module__banStatus___Y0G-O";
const banStatusName = "PopupInfo-scss--module__banStatusName___ZVaie";
const banStatusModerator = "PopupInfo-scss--module__banStatusModerator___vtzOu";
const slider = "PopupInfo-scss--module__slider___Btec9";
const buttonArrow = "PopupInfo-scss--module__buttonArrow___5XRoX";
const buttonArrowRight = "PopupInfo-scss--module__buttonArrowRight___StAQJ";
const iconArrow$3 = "PopupInfo-scss--module__iconArrow___QEyC9";
const iconArrowShorts = "PopupInfo-scss--module__iconArrowShorts___pold1";
const s$2E = {
    footer: footer$9,
    counter: counter,
    counterClickable: counterClickable,
    counterClickableIcon: counterClickableIcon,
    count: count$2,
    label: label$2,
    statuses: statuses,
    banStatus: banStatus,
    banStatusName: banStatusName,
    banStatusModerator: banStatusModerator,
    slider: slider,
    buttonArrow: buttonArrow,
    buttonArrowRight: buttonArrowRight,
    iconArrow: iconArrow$3,
    iconArrowShorts: iconArrowShorts
};
const locales$1x = {
    messages1: "\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    messages2: "\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
    messages5: "\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439",
    timeout1: "\u0442\u0430\u0439\u043C\u0430\u0443\u0442",
    timeout2: "\u0442\u0430\u0439\u043C\u0430\u0443\u0442\u0430",
    timeout5: "\u0442\u0430\u0439\u043C\u0430\u0443\u0442\u043E\u0432",
    ban1: "\u0431\u0430\u043D",
    ban2: "\u0431\u0430\u043D\u0430",
    ban5: "\u0431\u0430\u043D\u043E\u0432",
    banned: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D",
    timeoutByTime: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442 \u043D\u0430",
    timeoutByStream: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442 \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438",
    minute1: "\u043C\u0438\u043D\u0443\u0442\u0430",
    minute2: "\u043C\u0438\u043D\u0443\u0442\u044B",
    minute5: "\u043C\u0438\u043D\u0443\u0442",
    by: "\u043E\u0442",
    gift1: "\u043F\u043E\u0434\u0430\u0440\u043E\u043A",
    gift2: "\u043F\u043E\u0434\u0430\u0440\u043A\u0430",
    gift5: "\u043F\u043E\u0434\u0430\u0440\u043A\u043E\u0432"
};
const t$1y = distExports$1.getTranslation && locales$1x;
const getTestId$3 = getFactoryTestId(POPUP_INFO_TEST_ID);
const PopupInfo = (props)=>{
    const { messageCount, timeoutCount, banCount, giftCount, timeoutByTimeStatus, timeoutByStreamStatus, banStatus: banStatus2, isMessageHistoryAvailable, onMessageHistory, onTimeoutEnd = dist$4.noop } = props;
    const [isScrolled, setScrolled] = (0, $acw62.useState)(false);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.container,
        ...testAttr(getTestId$3(EModerationPopupInfoTestId.ROOT))
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.statuses
    }, timeoutByTimeStatus && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.banStatus
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusName
    }, t$1y.timeoutByTime, " ", /* @__PURE__ */ $acw62.createElement(Timer, {
        timeout: timeoutByTimeStatus.period ?? 0,
        onTimeout: onTimeoutEnd
    }), " ", declOfNum([
        t$1y.minute1,
        t$1y.minute2,
        t$1y.minute5
    ], Math.floor((timeoutByTimeStatus.period ?? 0) / 60))), " ", /* @__PURE__ */ $acw62.createElement("span", null, t$1y.by), " ", /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusModerator
    }, timeoutByTimeStatus.moderator)), timeoutByStreamStatus && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.banStatus
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusName
    }, t$1y.timeoutByStream), " ", /* @__PURE__ */ $acw62.createElement("span", null, t$1y.by), " ", /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusModerator
    }, timeoutByStreamStatus.moderator)), banStatus2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.banStatus
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusName
    }, t$1y.banned), " ", /* @__PURE__ */ $acw62.createElement("span", null, t$1y.by), " ", /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.banStatusModerator
    }, banStatus2.moderator))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.footer
    }, isScrolled && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.buttonArrow,
        onClick: ()=>setScrolled(false)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$2E.iconArrow
    })), !isScrolled && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2E.buttonArrow, s$2E.buttonArrowRight),
        onClick: ()=>setScrolled(true)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$2E.iconArrow
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.slider
    }, !isScrolled && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2E.counter, {
            [s$2E.counterClickable]: isMessageHistoryAvailable
        }),
        onClick: onMessageHistory
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.count
    }, getShortNum(messageCount, {
        limit100KDisabled: false,
        limit10KDisabled: true
    }), isMessageHistoryAvailable && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2E.iconArrowShorts, s$2E.counterClickableIcon)
    })), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.label
    }, declOfNum([
        t$1y.messages1,
        t$1y.messages2,
        t$1y.messages5
    ], messageCount))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.counter
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.count
    }, giftCount), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.label
    }, declOfNum([
        t$1y.gift1,
        t$1y.gift2,
        t$1y.gift5
    ], giftCount))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.counter
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.count
    }, timeoutCount), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.label
    }, declOfNum([
        t$1y.timeout1,
        t$1y.timeout2,
        t$1y.timeout5
    ], timeoutCount))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2E.counter
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.count
    }, banCount), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2E.label
    }, declOfNum([
        t$1y.ban1,
        t$1y.ban2,
        t$1y.ban5
    ], banCount))))));
};
var EModerationPopupUserTestId = /* @__PURE__ */ ((EModerationPopupUserTestId2)=>{
    EModerationPopupUserTestId2["ROOT"] = "root";
    return EModerationPopupUserTestId2;
})(EModerationPopupUserTestId || {});
const POPUP_USER_TEST_ID = "UserStatModerationPopupUser";
const container$8 = "PopupUser-scss--module__container___DGM2P";
const avatar$4 = "PopupUser-scss--module__avatar___yHwQQ";
const info$3 = "PopupUser-scss--module__info___fqbA9";
const username = "PopupUser-scss--module__username___4fQA-";
const registrationDate = "PopupUser-scss--module__registrationDate___jc24V";
const s$2D = {
    container: container$8,
    avatar: avatar$4,
    info: info$3,
    username: username,
    registrationDate: registrationDate
};
const locales$1w = {
    registeredAt: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F {{createdAt}}"
};
const t$1x = distExports$1.getTranslation && locales$1w;
const getTestId$2 = getFactoryTestId(POPUP_USER_TEST_ID);
const PopupUser = ({ avatarUrl, name: name2, createdAt })=>{
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2D.container,
        ...testAttr(getTestId$2(EModerationPopupUserTestId.ROOT))
    }, /* @__PURE__ */ $acw62.createElement(Avatar, {
        className: s$2D.avatar,
        size: EAvatarSize.S_OVERSIZE,
        img: avatarUrl
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2D.info
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2D.username
    }, name2), Boolean(createdAt) && /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2D.registrationDate
    }, distExports$1.getParametrizedText(t$1x.registeredAt, {
        createdAt: getFormattedDate(createdAt, "dd/MM/yyyy")
    }))));
};
var visibilitySensor = {
    exports: {}
};
(function(module2, exports2) {
    (function webpackUniversalModuleDefinition(root2, factory) {
        module2.exports = factory((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))));
    })(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
        return /******/ function(modules) {
            var installedModules = {};
            function __webpack_require__(moduleId) {
                if (installedModules[moduleId]) return installedModules[moduleId].exports;
                var module3 = installedModules[moduleId] = {
                    /******/ i: moduleId,
                    /******/ l: false,
                    /******/ exports: {}
                };
                modules[moduleId].call(module3.exports, module3, module3.exports, __webpack_require__);
                module3.l = true;
                return module3.exports;
            }
            __webpack_require__.m = modules;
            __webpack_require__.c = installedModules;
            __webpack_require__.d = function(exports3, name2, getter) {
                if (!__webpack_require__.o(exports3, name2)) Object.defineProperty(exports3, name2, {
                    enumerable: true,
                    get: getter
                });
            };
            __webpack_require__.r = function(exports3) {
                if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(exports3, Symbol.toStringTag, {
                    value: "Module"
                });
                Object.defineProperty(exports3, "__esModule", {
                    value: true
                });
            };
            __webpack_require__.t = function(value2, mode2) {
                if (mode2 & 1) value2 = __webpack_require__(value2);
                if (mode2 & 8) return value2;
                if (mode2 & 4 && typeof value2 === "object" && value2 && value2.__esModule) return value2;
                var ns = /* @__PURE__ */ Object.create(null);
                __webpack_require__.r(ns);
                Object.defineProperty(ns, "default", {
                    enumerable: true,
                    value: value2
                });
                if (mode2 & 2 && typeof value2 != "string") for(var key in value2)__webpack_require__.d(ns, key, (function(key2) {
                    return value2[key2];
                }).bind(null, key));
                return ns;
            };
            __webpack_require__.n = function(module3) {
                var getter = module3 && module3.__esModule ? /******/ function getDefault() {
                    return module3["default"];
                } : /******/ function getModuleExports() {
                    return module3;
                };
                __webpack_require__.d(getter, "a", getter);
                return getter;
            };
            __webpack_require__.o = function(object2, property2) {
                return Object.prototype.hasOwnProperty.call(object2, property2);
            };
            __webpack_require__.p = "";
            return __webpack_require__(__webpack_require__.s = 4);
        }([
            /* 0 */ /***/ function(module3, exports3, __webpack_require__) {
                module3.exports = __webpack_require__(5)();
            },
            /* 1 */ /***/ function(module3, exports3) {
                module3.exports = __WEBPACK_EXTERNAL_MODULE__1__;
            },
            /* 2 */ /***/ function(module3, exports3) {
                module3.exports = __WEBPACK_EXTERNAL_MODULE__2__;
            },
            /* 3 */ /***/ function(module3, exports3) {
                module3.exports = function(offset2, rect, containmentRect) {
                    var offsetDir = offset2.direction;
                    var offsetVal = offset2.value;
                    switch(offsetDir){
                        case "top":
                            return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;
                        case "left":
                            return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;
                        case "bottom":
                            return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;
                        case "right":
                            return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
                    }
                };
            },
            /* 4 */ /***/ function(module3, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                __webpack_require__.d(__webpack_exports__, "default", function() {
                    return VisibilitySensor;
                });
                var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
                var react__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
                var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
                var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
                var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
                var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
                var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
                var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /* @__PURE__ */ __webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);
                function _typeof2(obj) {
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof2 = function _typeof3(obj2) {
                        return typeof obj2;
                    };
                    else _typeof2 = function _typeof3(obj2) {
                        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                    };
                    return _typeof2(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target2, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target2, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    return Constructor;
                }
                function _possibleConstructorReturn(self2, call2) {
                    if (call2 && (_typeof2(call2) === "object" || typeof call2 === "function")) return call2;
                    return _assertThisInitialized(self2);
                }
                function _getPrototypeOf(o2) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
                        return o3.__proto__ || Object.getPrototypeOf(o3);
                    };
                    return _getPrototypeOf(o2);
                }
                function _assertThisInitialized(self2) {
                    if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self2;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o2, p2) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
                        o3.__proto__ = p3;
                        return o3;
                    };
                    return _setPrototypeOf(o2, p2);
                }
                function _defineProperty(obj, key, value2) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value2,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value2;
                    return obj;
                }
                function normalizeRect(rect) {
                    if (rect.width === void 0) rect.width = rect.right - rect.left;
                    if (rect.height === void 0) rect.height = rect.bottom - rect.top;
                    return rect;
                }
                var VisibilitySensor = /* @__PURE__ */ function(_React$Component) {
                    _inherits(VisibilitySensor2, _React$Component);
                    function VisibilitySensor2(props) {
                        var _this;
                        _classCallCheck(this, VisibilitySensor2);
                        _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor2).call(this, props));
                        _defineProperty(_assertThisInitialized(_this), "getContainer", function() {
                            return _this.props.containment || window;
                        });
                        _defineProperty(_assertThisInitialized(_this), "addEventListener", function(target2, event2, delay2, throttle2) {
                            if (!_this.debounceCheck) _this.debounceCheck = {};
                            var timeout2;
                            var func;
                            var later = function later2() {
                                timeout2 = null;
                                _this.check();
                            };
                            if (throttle2 > -1) func = function func2() {
                                if (!timeout2) timeout2 = setTimeout(later, throttle2 || 0);
                            };
                            else func = function func2() {
                                clearTimeout(timeout2);
                                timeout2 = setTimeout(later, delay2 || 0);
                            };
                            var info2 = {
                                target: target2,
                                fn: func,
                                getLastTimeout: function getLastTimeout() {
                                    return timeout2;
                                }
                            };
                            target2.addEventListener(event2, info2.fn);
                            _this.debounceCheck[event2] = info2;
                        });
                        _defineProperty(_assertThisInitialized(_this), "startWatching", function() {
                            if (_this.debounceCheck || _this.interval) return;
                            if (_this.props.intervalCheck) _this.interval = setInterval(_this.check, _this.props.intervalDelay);
                            if (_this.props.scrollCheck) _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
                            if (_this.props.resizeCheck) _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
                            !_this.props.delayedCall && _this.check();
                        });
                        _defineProperty(_assertThisInitialized(_this), "stopWatching", function() {
                            if (_this.debounceCheck) {
                                for(var debounceEvent in _this.debounceCheck)if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
                                    var debounceInfo = _this.debounceCheck[debounceEvent];
                                    clearTimeout(debounceInfo.getLastTimeout());
                                    debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
                                    _this.debounceCheck[debounceEvent] = null;
                                }
                            }
                            _this.debounceCheck = null;
                            if (_this.interval) _this.interval = clearInterval(_this.interval);
                        });
                        _defineProperty(_assertThisInitialized(_this), "check", function() {
                            var el = _this.node;
                            var rect;
                            var containmentRect;
                            if (!el) return _this.state;
                            rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));
                            if (_this.props.containment) {
                                var containmentDOMRect = _this.props.containment.getBoundingClientRect();
                                containmentRect = {
                                    top: containmentDOMRect.top,
                                    left: containmentDOMRect.left,
                                    bottom: containmentDOMRect.bottom,
                                    right: containmentDOMRect.right
                                };
                            } else containmentRect = {
                                top: 0,
                                left: 0,
                                bottom: window.innerHeight || document.documentElement.clientHeight,
                                right: window.innerWidth || document.documentElement.clientWidth
                            };
                            var offset2 = _this.props.offset || {};
                            var hasValidOffset = _typeof2(offset2) === "object";
                            if (hasValidOffset) {
                                containmentRect.top += offset2.top || 0;
                                containmentRect.left += offset2.left || 0;
                                containmentRect.bottom -= offset2.bottom || 0;
                                containmentRect.right -= offset2.right || 0;
                            }
                            var visibilityRect = {
                                top: rect.top >= containmentRect.top,
                                left: rect.left >= containmentRect.left,
                                bottom: rect.bottom <= containmentRect.bottom,
                                right: rect.right <= containmentRect.right
                            };
                            var hasSize = rect.height > 0 && rect.width > 0;
                            var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right;
                            if (hasSize && _this.props.partialVisibility) {
                                var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left;
                                if (typeof _this.props.partialVisibility === "string") partialVisible = visibilityRect[_this.props.partialVisibility];
                                isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
                            }
                            if (typeof offset2.direction === "string" && typeof offset2.value === "number") {
                                console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset2.direction, offset2.value);
                                isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset2, rect, containmentRect);
                            }
                            var state = _this.state;
                            if (_this.state.isVisible !== isVisible) {
                                state = {
                                    isVisible: isVisible,
                                    visibilityRect: visibilityRect
                                };
                                _this.setState(state);
                                if (_this.props.onChange) _this.props.onChange(isVisible);
                            }
                            return state;
                        });
                        _this.state = {
                            isVisible: null,
                            visibilityRect: {}
                        };
                        return _this;
                    }
                    _createClass(VisibilitySensor2, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                                if (this.props.active) this.startWatching();
                            }
                        },
                        {
                            key: "componentWillUnmount",
                            value: function componentWillUnmount() {
                                this.stopWatching();
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function componentDidUpdate(prevProps) {
                                this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                                if (this.props.active && !prevProps.active) {
                                    this.setState({
                                        isVisible: null,
                                        visibilityRect: {}
                                    });
                                    this.startWatching();
                                } else if (!this.props.active) this.stopWatching();
                            }
                        },
                        {
                            key: "roundRectDown",
                            value: function roundRectDown(rect) {
                                return {
                                    top: Math.floor(rect.top),
                                    left: Math.floor(rect.left),
                                    bottom: Math.floor(rect.bottom),
                                    right: Math.floor(rect.right)
                                };
                            }
                        },
                        {
                            key: "render",
                            value: function render2() {
                                if (this.props.children instanceof Function) return this.props.children({
                                    isVisible: this.state.isVisible,
                                    visibilityRect: this.state.visibilityRect
                                });
                                return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
                            }
                        }
                    ]);
                    return VisibilitySensor2;
                }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
                _defineProperty(VisibilitySensor, "defaultProps", {
                    active: true,
                    partialVisibility: false,
                    minTopValue: 0,
                    scrollCheck: false,
                    scrollDelay: 250,
                    scrollThrottle: -1,
                    resizeCheck: false,
                    resizeDelay: 250,
                    resizeThrottle: -1,
                    intervalCheck: true,
                    intervalDelay: 100,
                    delayedCall: false,
                    offset: {},
                    containment: null,
                    children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
                });
                _defineProperty(VisibilitySensor, "propTypes", {
                    onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
                    active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ])
                    ]),
                    delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                            top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                            left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                            bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                            right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                        }),
                        // deprecated offset property
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                            direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                                "top",
                                "right",
                                "bottom",
                                "left"
                            ]),
                            value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                        })
                    ]),
                    scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                    scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                    resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                    resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                    intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                    containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                    children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element,
                        prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
                    ]),
                    minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                });
            },
            /* 5 */ /***/ function(module3, exports3, __webpack_require__) {
                var ReactPropTypesSecret = __webpack_require__(6);
                function emptyFunction() {}
                function emptyFunctionWithReset() {}
                emptyFunctionWithReset.resetWarningCache = emptyFunction;
                module3.exports = function() {
                    function shim2(props, propName, componentName, location2, propFullName, secret) {
                        if (secret === ReactPropTypesSecret) return;
                        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        err.name = "Invariant Violation";
                        throw err;
                    }
                    shim2.isRequired = shim2;
                    function getShim() {
                        return shim2;
                    }
                    var ReactPropTypes = {
                        array: shim2,
                        bool: shim2,
                        func: shim2,
                        number: shim2,
                        object: shim2,
                        string: shim2,
                        symbol: shim2,
                        any: shim2,
                        arrayOf: getShim,
                        element: shim2,
                        elementType: shim2,
                        instanceOf: getShim,
                        node: shim2,
                        objectOf: getShim,
                        oneOf: getShim,
                        oneOfType: getShim,
                        shape: getShim,
                        exact: getShim,
                        checkPropTypes: emptyFunctionWithReset,
                        resetWarningCache: emptyFunction
                    };
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            },
            /* 6 */ /***/ function(module3, exports3, __webpack_require__) {
                var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                module3.exports = ReactPropTypesSecret;
            }
        ]);
    });
})(visibilitySensor);
var visibilitySensorExports = visibilitySensor.exports;
const ReactVisibilitySensor = /* @__PURE__ */ getDefaultExportFromCjs(visibilitySensorExports);
const pixel = "VisibilityTracker-scss--module__pixel___10c0E";
const s$2C = {
    pixel: pixel
};
class VisibilityTracker extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            gotOnScreen: false
        };
        this.onChange = (isVisible)=>{
            if (isVisible) {
                this.setState({
                    gotOnScreen: true
                });
                this.props.onShow();
            }
        };
    }
    render() {
        return /* @__PURE__ */ $acw62.createElement(ReactVisibilitySensor, {
            partialVisibility: true,
            active: !this.state.gotOnScreen,
            onChange: this.onChange,
            delayedCall: true
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2C.pixel, this.props.className)
        }));
    }
}
const getHighlightText = (text2, highlight2)=>{
    const match2 = highlight2.match(/<b>(.*?)<\/b>/g);
    if (!match2) return text2;
    const words = match2.map((value2)=>value2.replace(/<\/?b>/g, "")).join("|");
    const regExp = new RegExp(`${words}`, "gi");
    return text2.replace(regExp, `<mark>$&</mark>`);
};
const BLOG_POST_FROM_WITH_INDENT = [
    EBlogPostFrom.ABOUT_AUTHOR,
    EBlogPostFrom.BLOG,
    EBlogPostFrom.BLOG_POST,
    EBlogPostFrom.SEARCH_BY_POSTS
];
const markup = "BlockRenderer-scss--module__markup___LBDIr";
const realEmpty = "BlockRenderer-scss--module__realEmpty___eYWfK";
const noIndent = "BlockRenderer-scss--module__noIndent___hziac";
const textEllipsis = "BlockRenderer-scss--module__textEllipsis___d3HDc";
const s$2B = {
    markup: markup,
    realEmpty: realEmpty,
    noIndent: noIndent,
    textEllipsis: textEllipsis
};
const NO_BREAK_SPACE = "\xa0";
const MarkupBlockWithoutRef = ({ innerRef, headline, blockData, isTextEllipsis, className, onClick })=>{
    const from2 = useBlogPostFrom();
    const elementType2 = from2 === EBlogPostFrom.BLOG_STREAM_CHAT_MESSAGE || from2 === EBlogPostFrom.ACTIVITY_CONTENT ? "span" : "div";
    const text2 = headline ? getHighlightText(blockData.text, headline) : blockData.text.replace(new RegExp(NO_BREAK_SPACE, "ig"), " ");
    return $acw62.createElement(elementType2, {
        dangerouslySetInnerHTML: {
            __html: text2
        },
        ref: innerRef,
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2B.markup, className, {
            [s$2B.textEllipsis]: isTextEllipsis,
            [s$2B.noIndent]: !BLOG_POST_FROM_WITH_INDENT.includes(from2),
            [s$2B.realEmpty]: from2 === EBlogPostFrom.SUBSCRIPTION_LEVEL_ITEM
        }),
        ["data-role"]: EHTMLDataRole.MARKUP
    });
};
const MarkupBlock = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(MarkupBlockWithoutRef, {
        innerRef: ref2,
        ...props
    }));
MarkupBlock.displayName = "MarkupBlock";
function isMarkupBlock(block2) {
    return block2.type === "markup";
}
const MarkupRendererComponentWithoutRef = (props)=>{
    const { innerRef, block: block2, headline, isTextEllipsis, markupClassName, onClick } = props;
    try {
        if (isMarkupBlock(block2)) return /* @__PURE__ */ $acw62.createElement(MarkupBlock, {
            blockData: block2.data,
            headline: headline,
            isTextEllipsis: isTextEllipsis,
            innerRef: innerRef,
            onClick: onClick,
            className: markupClassName
        });
        return null;
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed parse content: ${err && err.toString() ? err.toString() : String(err)}`);
        return null;
    }
};
const MarkupRenderer = (0, $acw62.forwardRef)((props, ref2)=>/* @__PURE__ */ $acw62.createElement(MarkupRendererComponentWithoutRef, {
        innerRef: ref2,
        ...props
    }));
MarkupRenderer.displayName = "MarkupRenderer";
class HtmlText {
    constructor(text2 = "", offset2 = 0){
        this.addHtmlText = (textToAdd)=>{
            this._text += textToAdd;
        };
        this.addOffset = (offsetToAdd)=>{
            this._offset += offsetToAdd;
        };
        this.reset = ()=>{
            this._text = "";
            this._offset = 0;
        };
        this._text = text2;
        this._offset = offset2;
    }
    get currentOffset() {
        return this._offset;
    }
    get currentText() {
        return this._text;
    }
}
const getInlineMarkupBlock = (type, text2)=>{
    if (type === EMediaDataType.TEXT || type === EMediaDataType.LINK || type === EMediaDataType.SMILE || type === EMediaDataType.MENTION) return {
        type: "markup",
        data: {
            text: text2
        }
    };
    throw new Error(`Invalid type ${type}`);
};
const isInlineBlockEnd = (item2)=>{
    return !item2 || isParagraphEnd(item2) || !isTextOrLinkItem(item2) && !isSmileMediaDataItem(item2) && !isMentionItem(item2);
};
const convertMediaData = (contentData, params = {})=>{
    const blocks2 = [];
    if (!contentData) return blocks2;
    else {
        const htmlText = new HtmlText();
        contentData.forEach((item2, index2)=>{
            if (isTextOrLinkItem(item2) || isSmileMediaDataItem(item2) || isMentionItem(item2)) {
                const isConvertableLink = item2.type === EMediaDataType.LINK && !params.linksDisabled;
                let markupText = "";
                if (isConvertableLink) markupText = convertLinkToHTML(item2, htmlText.currentOffset);
                else if (isSmileMediaDataItem(item2)) markupText = convertSmileToHTML({
                    smile: item2,
                    size: params == null ? void 0 : params.smileSize
                });
                else if (isMentionItem(item2)) {
                    const prevSpace = generateSpace("prev", contentData[index2 - 1]);
                    const nextSpace = generateSpace("next", contentData[index2 + 1]);
                    markupText = prevSpace + convertMentionToHTML(item2) + nextSpace;
                } else markupText = convertPackedTextToHTML(item2.content, htmlText.currentOffset);
                htmlText.addHtmlText(markupText);
                if (isSmileMediaDataItem(item2)) htmlText.addOffset(1);
                else {
                    const textLength = isMentionItem(item2) ? item2.displayName.length : getTextLength(item2);
                    htmlText.addOffset(textLength);
                }
                const next2 = contentData[index2 + 1];
                if (isInlineBlockEnd(next2)) {
                    blocks2.push(getInlineMarkupBlock(item2.type, htmlText.currentText));
                    htmlText.reset();
                }
            } else blocks2.push(item2);
        });
        return blocks2;
    }
};
const convertMediaDataToPlainText = (contentData, params = {})=>{
    if (!contentData) return "";
    else {
        let markupText = "";
        contentData.forEach((item2, index2)=>{
            if (isTextOrLinkItem(item2) || isSmileMediaDataItem(item2) || isMentionItem(item2)) {
                const isConvertableLink = item2.type === EMediaDataType.LINK && !params.linksDisabled;
                if (isConvertableLink) markupText += ` ${HtmlEntities.escapeURL(item2.url)} `;
                else if (isSmileMediaDataItem(item2)) markupText += ` ${item2.name} `;
                else if (isMentionItem(item2)) markupText += ` @${item2.displayName} `;
                else {
                    const [text2] = JSON.parse(item2.content);
                    markupText += text2;
                }
            }
        });
        return markupText;
    }
};
const mention = "ContentRenderer-scss--module__mention___P38CX";
const s$2A = {
    mention: mention
};
const ContentRendererComponentWithoutRef = ({ data, headline, smileSize, messageId, classNames, hasMentionHighlight, isTextEllipsis, shouldHighlightCurrentUser = false, innerRef, onClick, style: styleProp = {} })=>{
    const currentUserId = (0, $iD0SF.useSelector)(currentUserIdSelector);
    const { theme } = useThemeContext();
    const modifiedData = data.map((item2)=>{
        let style;
        const isMention2 = isMentionItem(item2);
        const shouldBePainted = hasMentionHighlight && isMention2 && isMentionInteractive(item2, currentUserId, shouldHighlightCurrentUser);
        if (shouldBePainted) style = {
            color: getChatNicknameColor(Number(item2.nickColor), theme),
            cursor: "pointer",
            ...styleProp
        };
        return {
            ...item2,
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [s$2A.mention]: isMention2
            })
        };
    });
    try {
        const blocks2 = convertMediaData(modifiedData, {
            smileSize: smileSize,
            messageId: messageId
        });
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, blocks2.map((block2, index2)=>/* @__PURE__ */ $acw62.createElement(MarkupRenderer, {
                key: index2,
                headline: headline,
                block: block2,
                isTextEllipsis: isTextEllipsis,
                innerRef: innerRef,
                onClick: onClick,
                markupClassName: classNames == null ? void 0 : classNames.markup
            })));
    } catch (err) {
        if (err instanceof Error) Log$5.error(`Failed parse content: ${err && err.toString() ? err.toString() : String(err)}`);
        return null;
    }
};
const ContentRenderer = (0, $acw62.forwardRef)((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ContentRendererComponentWithoutRef, {
        innerRef: ref2,
        ...props
    }));
ContentRenderer.displayName = "ContentRenderer";
var EChatMessageTestId = /* @__PURE__ */ ((EChatMessageTestId2)=>{
    EChatMessageTestId2["ROOT"] = "root";
    EChatMessageTestId2["AUTHOR"] = "author";
    EChatMessageTestId2["MESSAGE"] = "message";
    return EChatMessageTestId2;
})(EChatMessageTestId || {});
const VERIFIED_STREAMER$1 = "verified_streamer";
const verifiedIcon$1 = "ChatMessageAuthorPanel-scss--module__verifiedIcon___Hg-VS";
const name$8 = "ChatMessageAuthorPanel-scss--module__name___CEue7";
const bannedName = "ChatMessageAuthorPanel-scss--module__bannedName___nMkr1";
const bannedNameIcon = "ChatMessageAuthorPanel-scss--module__bannedNameIcon___UhV1U";
const author$2 = "ChatMessageAuthorPanel-scss--module__author___L1IML";
const avatar$3 = "ChatMessageAuthorPanel-scss--module__avatar___9A9H-";
const s$2z = {
    verifiedIcon: verifiedIcon$1,
    name: name$8,
    bannedName: bannedName,
    bannedNameIcon: bannedNameIcon,
    author: author$2,
    avatar: avatar$3
};
const locales$1v = {
    ban: {
        title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"
    }
};
const t$1w = distExports$1.getTranslation && locales$1v;
const ChatMessageAuthorPanel = (props)=>{
    const { isBanned, isBadgesDisabled, withSeparator = true, author: author2 } = props;
    const { badge: badge2 } = getConfig();
    const isHideUserAvatarEnabled = isConditionalFeatureEnable(EConditionalFeature.HIDE_CHAT_USER_AVATAR);
    const hasChatUserColorConfig = isConditionalFeatureEnable(EConditionalFeature.CHAT_USER_COLOR_CONFIG);
    const { theme } = useThemeContext();
    const badges2 = (author2 == null ? void 0 : author2.badges) || [];
    const roles2 = (author2 == null ? void 0 : author2.roles) || [];
    const nicknameColor = (0, $acw62.useMemo)(()=>{
        return getChatNicknameColor(hasChatUserColorConfig ? author2 == null ? void 0 : author2.nickColor : author2 == null ? void 0 : author2.nick, theme);
    }, [
        author2 == null ? void 0 : author2.nickColor,
        author2 == null ? void 0 : author2.nick,
        theme,
        hasChatUserColorConfig
    ]);
    const renderBadges = (0, $acw62.useCallback)(()=>{
        return badges2.map((badgeItem)=>badgeItem.achievement.name === VERIFIED_STREAMER$1 && badge2.levels.silver.includes(author2.id) ? /* @__PURE__ */ $acw62.createElement(Icon, {
                key: badgeItem.id,
                glyph: svg_name_silver_streamer,
                className: s$2z.verifiedIcon
            }) : /* @__PURE__ */ $acw62.createElement(ChatBadge, {
                key: badgeItem.id,
                badge: badgeItem
            }));
    }, []);
    const renderNameAndBadges = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !isBadgesDisabled && renderBadges(), !isBadgesDisabled && Boolean(roles2 == null ? void 0 : roles2.length) && /* @__PURE__ */ $acw62.createElement(ChatRole, {
            key: roles2[0].id,
            role: roles2[0]
        }), /* @__PURE__ */ $acw62.createElement("span", {
            style: {
                color: nicknameColor
            },
            className: s$2z.name
        }, author2 == null ? void 0 : author2.nick, withSeparator && ":"));
    };
    const renderBannedPlate = ()=>{
        return /* @__PURE__ */ $acw62.createElement("span", {
            className: s$2z.bannedName
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$2z.bannedNameIcon,
            glyph: svg_name_ban
        }), t$1w.ban.title);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2z.author,
        ["data-role"]: EHTMLDataRole.MESSAGE_AUTHOR
    }, !isHideUserAvatarEnabled && /* @__PURE__ */ $acw62.createElement(Avatar, {
        size: EAvatarSize.XXXS,
        img: author2 == null ? void 0 : author2.avatarUrl,
        className: s$2z.avatar
    }), isBanned ? renderBannedPlate() : renderNameAndBadges());
};
const CHAT_MESSAGE_TEST_ID = "ChatMessage";
const SMILE_SIZE_PARENT_MESSAGE = 14;
const iconReplyMessage = "ChatMessageParentMessage-scss--module__iconReplyMessage___mD-ax";
const parentMessage = "ChatMessageParentMessage-scss--module__parentMessage___Ivimv";
const firstUserMessage$1 = "ChatMessageParentMessage-scss--module__firstUserMessage___sjyJq";
const parentMessageAuthor = "ChatMessageParentMessage-scss--module__parentMessageAuthor___em2Wz";
const parentMessageDeleted = "ChatMessageParentMessage-scss--module__parentMessageDeleted___EugLY";
const parentMessageTooltipRoot = "ChatMessageParentMessage-scss--module__parentMessageTooltipRoot___ZYPcp";
const s$2y = {
    iconReplyMessage: iconReplyMessage,
    parentMessage: parentMessage,
    firstUserMessage: firstUserMessage$1,
    parentMessageAuthor: parentMessageAuthor,
    parentMessageDeleted: parentMessageDeleted,
    parentMessageTooltipRoot: parentMessageTooltipRoot
};
const locales$1u = {
    deletedMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E"
};
const t$1v = distExports$1.getTranslation && locales$1u;
const ChatMessageParentMessage = (props)=>{
    const { parent, blackListIds, flags: flags2, isFirstMessage } = props;
    const renderMessageContent = ()=>/* @__PURE__ */ $acw62.createElement(ContentRenderer, {
            key: `ContentRenderer-parentElement-${parent.id}`,
            messageId: parent.id,
            data: parent.data,
            isTextEllipsis: true,
            smileSize: SMILE_SIZE_PARENT_MESSAGE
        });
    const renderMessage = ()=>{
        if (flags2.isParentDeleted) return /* @__PURE__ */ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2y.parentMessageDeleted, {
                [s$2y.firstUserMessage]: isFirstMessage
            })
        }, t$1v.deletedMessage);
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2y.parentMessageAuthor, {
                [s$2y.firstUserMessage]: isFirstMessage
            })
        }, parent.author.nick, ":"), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2y.parentMessageTooltipRoot,
            title: convertMediaDataToPlainText(parent.data)
        }, renderMessageContent()));
    };
    if (blackListIds.includes(parent.author.id)) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2y.parentMessage, {
            [s$2y.firstUserMessage]: isFirstMessage
        }),
        ["data-role"]: !flags2.isParentDeleted && EHTMLDataRole.MESSAGE_PARENT_MESSAGE
    }, /* @__PURE__ */ $acw62.createElement("span", null, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2y.iconReplyMessage,
        glyph: svg_name_reply
    })), renderMessage());
};
const useChatMessage = (props)=>{
    const { message: message2, blogUrl, currentUserId, hasMentionHighlight, isOnlyMentionsMode, isPrivateHightlightDisabled } = props;
    const { author: author2, data, isPrivate, styles, flags: flags2, parent: parentMessage2, isDeleted } = message2;
    const isControlsOnClickEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_CONTROLS_ON_CLICK);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const canModerateChatChannel = currentUserCanModerateChatChannel(currentUser2, blogUrl);
    const blackListIds = (0, $iD0SF.useSelector)(blackListIdsSelector);
    const rendererRef = (0, $acw62.useRef)(null);
    const isCurrentUserMentioned = data.some((item2)=>item2.type === EMediaDataType.MENTION && item2.id === currentUserId);
    const hasRootMention2 = currentUserId && hasMentionHighlight !== false && (isCurrentUserMentioned || currentUserId === (parentMessage2 == null ? void 0 : parentMessage2.author.id));
    const shouldHighlightFirstUserMessage = Boolean(flags2 == null ? void 0 : flags2.isFirstMessage) && !hasRootMention2 && !isOnlyMentionsMode;
    const isCurrentUserMessage = currentUserId === author2.id;
    const shouldHighlightPrivate = isPrivate && !isPrivateHightlightDisabled;
    const shouldHighLightDeleted = isDeleted;
    const isMarked = styles == null ? void 0 : styles.some((style)=>style === "marked");
    return {
        rendererRef: rendererRef,
        hasRootMention: hasRootMention2,
        shouldHighlightFirstUserMessage: shouldHighlightFirstUserMessage,
        isControlsOnClickEnabled: isControlsOnClickEnabled,
        isCurrentUserMessage: isCurrentUserMessage,
        isMarked: isMarked,
        shouldHighlightPrivate: shouldHighlightPrivate,
        shouldHighLightDeleted: shouldHighLightDeleted,
        canModerateChatChannel: canModerateChatChannel,
        blackListIds: blackListIds
    };
};
const useMessageVisibility = (props)=>{
    const { messageIndex, messageCreatedTime, visibilityContainerRef, onVisibilityChange } = props;
    const rootEl = (0, $acw62.useRef)(null);
    const isVisible = useVisibility({
        element: rootEl,
        container: visibilityContainerRef,
        isEnabled: Boolean(onVisibilityChange),
        rootMargin: "-30px 0px 0px 0px",
        threshold: 1
    });
    (0, $acw62.useEffect)(()=>{
        onVisibilityChange == null || onVisibilityChange(messageCreatedTime, isVisible, messageIndex);
    }, [
        isVisible
    ]);
    return {
        rootEl: rootEl,
        isVisible: isVisible
    };
};
const root$1D = "ChatMessage-scss--module__root___QCsxu";
const msgBanned = "ChatMessage-scss--module__msgBanned___6DGAh";
const userBanned = "ChatMessage-scss--module__userBanned___4krGW";
const hasRootMention = "ChatMessage-scss--module__hasRootMention___lkqm7";
const firstUserMessage = "ChatMessage-scss--module__firstUserMessage___f4xxn";
const deleted = "ChatMessage-scss--module__deleted___wY7gp";
const firstMessage = "ChatMessage-scss--module__firstMessage___nCjoc";
const marked = "ChatMessage-scss--module__marked___HCbIF";
const publishTime = "ChatMessage-scss--module__publishTime___knUha";
const message$4 = "ChatMessage-scss--module__message___tmziE";
const iconDeleted = "ChatMessage-scss--module__iconDeleted___37Mom";
const iconSparks = "ChatMessage-scss--module__iconSparks___b0RxN";
const iconPrivate = "ChatMessage-scss--module__iconPrivate___ns00e";
const deletedMessage = "ChatMessage-scss--module__deletedMessage___M7JCn";
const newMemberTitle = "ChatMessage-scss--module__newMemberTitle___Qi-2i";
const privateTitle = "ChatMessage-scss--module__privateTitle___F-9s2";
const s$2x = {
    root: root$1D,
    msgBanned: msgBanned,
    userBanned: userBanned,
    hasRootMention: hasRootMention,
    firstUserMessage: firstUserMessage,
    "private": "ChatMessage-scss--module__private___-P38h",
    deleted: deleted,
    firstMessage: firstMessage,
    marked: marked,
    publishTime: publishTime,
    message: message$4,
    iconDeleted: iconDeleted,
    iconSparks: iconSparks,
    iconPrivate: iconPrivate,
    deletedMessage: deletedMessage,
    newMemberTitle: newMemberTitle,
    privateTitle: privateTitle
};
const locales$1t = {
    deletedMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E",
    newMember: "\u041D\u043E\u0432\u044B\u0439 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u0447\u0430\u0442\u0430",
    privateMessage: "\u0421\u043A\u0440\u044B\u0442\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"
};
const t$1u = distExports$1.getTranslation && locales$1t;
const getTestId$1 = getFactoryTestId(CHAT_MESSAGE_TEST_ID);
const ChatMessageBase = (props)=>{
    const { className, isFirstMessage, message: message2, isCurrentUserBanned, isBanned, hasMentionHighlight, isBadgesDisabled } = props;
    const { shouldHighlightPrivate, shouldHighlightFirstUserMessage, shouldHighLightDeleted, hasRootMention: hasRootMention2, isControlsOnClickEnabled, isCurrentUserMessage, rendererRef, isMarked, blackListIds, canModerateChatChannel } = useChatMessage(props);
    const shouldBeShown = canModerateChatChannel || !canModerateChatChannel && !message2.isDeleted;
    const renderMessageContent = ()=>{
        if (isBanned) return null;
        return /* @__PURE__ */ $acw62.createElement(ContentRenderer, {
            messageId: message2.id,
            data: message2.data,
            ref: rendererRef,
            hasMentionHighlight: hasMentionHighlight
        });
    };
    if (!shouldBeShown) return null;
    if (blackListIds.includes(message2.author.id)) return null;
    return /* @__PURE__ */ $acw62.createElement(BlogPostFromContext.Provider, {
        value: EBlogPostFrom.BLOG_STREAM_CHAT_MESSAGE
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2x.root, className, {
            [s$2x.msgBanned]: isBanned,
            [s$2x.userBanned]: isCurrentUserBanned,
            [s$2x.ownMessage]: isCurrentUserMessage,
            [s$2x.private]: shouldHighlightPrivate,
            [s$2x.marked]: isMarked,
            [s$2x.hasRootMention]: hasRootMention2,
            [s$2x.manualControl]: isControlsOnClickEnabled,
            [s$2x.firstMessage]: isFirstMessage,
            [s$2x.firstUserMessage]: shouldHighlightFirstUserMessage,
            [s$2x.deleted]: shouldHighLightDeleted
        }),
        ...testAttr(getTestId$1(EChatMessageTestId.ROOT)),
        ["data-role"]: EHTMLDataRole.MESSAGE_CONTAINER,
        ["data-message-id"]: message2.id,
        key: message2.id
    }, shouldHighlightFirstUserMessage && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2x.newMemberTitle
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2x.iconSparks,
        glyph: svg_name_sparks
    }), t$1u.newMember), shouldHighLightDeleted && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2x.deletedMessage
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2x.iconDeleted,
        glyph: svg_name_ban
    }), t$1u.deletedMessage), shouldHighlightPrivate && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2x.privateTitle
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2x.iconPrivate,
        glyph: svg_name_eye_smoothed_struck_out
    }), t$1u.privateMessage), Boolean(message2.parent) && /* @__PURE__ */ $acw62.createElement(ChatMessageParentMessage, {
        parent: message2.parent,
        flags: message2.flags,
        blackListIds: blackListIds,
        isFirstMessage: shouldHighlightFirstUserMessage
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2x.message
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2x.publishTime
    }, getFormattedDate(message2.createdAt, "HH/mm")), /* @__PURE__ */ $acw62.createElement("div", {
        ["data-role"]: EHTMLDataRole.MESSAGE_MAIN_CONTENT
    }, /* @__PURE__ */ $acw62.createElement(ChatMessageAuthorPanel, {
        author: message2.author,
        isBadgesDisabled: isBadgesDisabled,
        isBanned: isBanned
    }), renderMessageContent()))));
};
const ChatMessage = $acw62.memo(ChatMessageBase);
const ChatMessageWithVisibility = (props)=>{
    const { onVisibilityChange, message: message2, messageIndex, visibilityContainerRef } = props;
    const { rootEl, isVisible } = useMessageVisibility({
        onVisibilityChange: onVisibilityChange,
        messageIndex: messageIndex,
        visibilityContainerRef: visibilityContainerRef,
        messageCreatedTime: message2.createdAt
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: rootEl
    }, /* @__PURE__ */ $acw62.createElement(ChatMessage, {
        ...props,
        isVisible: isVisible
    }));
};
const useFloatingDateController = (props)=>{
    const { displayedDatesRef, setDisplayedDate, containerRef, isElementsLoaded } = props;
    (0, $acw62.useEffect)(()=>{
        const onScroll = throttle(()=>{
            let maxLength = 0;
            let currentStart = null;
            let currentEnd = null;
            const keysList = Object.keys(displayedDatesRef.current);
            keysList.forEach((key, index2)=>{
                const isPrevElementConsistent = keysList[index2 - 1] !== void 0 && Number(keysList[index2 - 1]) === Number(key) - 1;
                const isNextElementConsistent = keysList[index2 + 1] !== void 0 && Number(keysList[index2 + 1]) === Number(key) + 1;
                if (!isPrevElementConsistent && !isNextElementConsistent && keysList.length > 1) {
                    delete displayedDatesRef.current[key];
                    return;
                }
                if (!isPrevElementConsistent) currentStart = key;
                if (!isNextElementConsistent) currentEnd = key;
                if (currentStart && currentEnd) {
                    const currentLength = currentEnd - currentStart + 1;
                    if (currentLength > maxLength) {
                        maxLength = currentLength;
                        currentStart = null;
                        currentEnd = null;
                        return;
                    }
                    for(let currentKey = currentStart; currentKey <= currentEnd; currentKey++)delete displayedDatesRef.current[currentKey];
                }
            });
            const lastKey = Object.keys(displayedDatesRef.current).pop();
            setDisplayedDate(displayedDatesRef.current[Number(lastKey)]);
        }, 200);
        containerRef.current.addEventListener("scroll", onScroll);
        return ()=>{
            containerRef.current.removeEventListener("scroll", onScroll);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const setupFirstDate = (depth = 0)=>{
            const prevLastKey = Number(Object.keys(displayedDatesRef.current).pop());
            setTimeout(()=>{
                const lastKey = Number(Object.keys(displayedDatesRef.current).pop());
                if (depth === 10) return;
                if (lastKey === void 0 || Number.isNaN(lastKey) || lastKey !== prevLastKey) {
                    setupFirstDate(depth + 1);
                    return;
                }
                setDisplayedDate(displayedDatesRef.current[lastKey]);
            }, 400);
        };
        if (isElementsLoaded) setupFirstDate();
    }, [
        isElementsLoaded
    ]);
};
const root$1C = "ChatHistory-scss--module__root___Qj6GW";
const container$7 = "ChatHistory-scss--module__container___x7s6e";
const noMessagesTitle = "ChatHistory-scss--module__noMessagesTitle___upZv7";
const controls$4 = "ChatHistory-scss--module__controls___Ijr6m";
const backButton$1 = "ChatHistory-scss--module__backButton___gd6HM";
const iconBack$2 = "ChatHistory-scss--module__iconBack___WgXtu";
const filler = "ChatHistory-scss--module__filler___2mD60";
const date = "ChatHistory-scss--module__date___FtE-r";
const s$2w = {
    root: root$1C,
    container: container$7,
    noMessagesTitle: noMessagesTitle,
    controls: controls$4,
    backButton: backButton$1,
    iconBack: iconBack$2,
    filler: filler,
    date: date
};
const locales$1s = {
    backButton: "\u041D\u0430\u0437\u0430\u0434",
    noMessages: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0435\u0449\u0435 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043F\u0438\u0441\u0430\u043B"
};
const t$1t = distExports$1.getTranslation && locales$1s;
const ChatHistory = (props)=>{
    const { userId, isHistoriesStoringEnabled, onBackClick } = props;
    const messages2 = (0, $iD0SF.useSelector)(userChatHistorySelector(userId));
    const isLast = (0, $iD0SF.useSelector)(userChatHistoryIsFullyFetchedSelector(userId));
    const networkStatus2 = (0, $iD0SF.useSelector)(userChatHistoriesNetworkStatusSelector);
    const currentUserId = (0, $iD0SF.useSelector)(currentUserIdSelector);
    const { blogUrl } = useStreamIdentity();
    const dispatch = (0, $2OPjR.useDispatch)();
    const containerRef = (0, $acw62.useRef)(null);
    const visibilityContainerRef = (0, $acw62.useRef)(null);
    const [displayedDate, setDisplayedDate] = (0, $acw62.useState)();
    const displayedDatesRef = (0, $acw62.useRef)({});
    useFloatingDateController({
        displayedDatesRef: displayedDatesRef,
        setDisplayedDate: setDisplayedDate,
        containerRef: containerRef,
        isElementsLoaded: networkStatus2.isFetched
    });
    const handleMessageVisibilityChange = (0, $acw62.useCallback)((messageCreatedTime, isVisible, messageIndex)=>{
        if (!messageCreatedTime) return;
        if (!isVisible) {
            delete displayedDatesRef.current[messageIndex];
            return;
        }
        displayedDatesRef.current[messageIndex] = messageCreatedTime;
    }, []);
    const onShowMore = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchUserChatHistory)({
            blogUrl: blogUrl,
            userId: userId,
            after: messages2[messages2.length - 1].id
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (!isHistoriesStoringEnabled) dispatch(clearUserChatHistory());
        if (!messages2.length || !isHistoriesStoringEnabled) dispatch((0, $7Uc0p.thunkToAction)(fetchUserChatHistory)({
            blogUrl: blogUrl,
            userId: userId
        }));
    }, [
        blogUrl,
        userId
    ]);
    const renderDate = ()=>{
        if (!displayedDate) return null;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2w.date
        }, getFormattedDate(displayedDate, "dd/LLL"));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2w.root,
        ref: visibilityContainerRef
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2w.controls
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2w.backButton,
        onClick: onBackClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$2w.iconBack
    }), t$1t.backButton)), renderDate(), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2w.container, "publishTimeVisible"),
        ref: containerRef
    }, /* @__PURE__ */ $acw62.createElement("div", {
        key: "filler",
        className: s$2w.filler
    }), !messages2.length && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2w.noMessagesTitle
    }, t$1t.noMessages), messages2.map((message2, index2)=>/* @__PURE__ */ $acw62.createElement(ChatMessageWithVisibility, {
            key: message2.id,
            blogUrl: blogUrl,
            message: message2,
            isCurrentUserBanned: false,
            currentUserId: currentUserId,
            messageIndex: index2,
            isBadgesDisabled: true,
            isPrivateHightlightDisabled: true,
            visibilityContainerRef: visibilityContainerRef,
            onVisibilityChange: handleMessageVisibilityChange
        })), !networkStatus2.isFetching && !isLast && /* @__PURE__ */ $acw62.createElement("div", {
        key: "trackerContainer"
    }, /* @__PURE__ */ $acw62.createElement(VisibilityTracker, {
        key: "tracker",
        onShow: onShowMore
    }))));
};
const locales$1r = {
    success: "\u041F\u043E\u0434\u0430\u0440\u043E\u043A \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D!",
    copyNick: "\u041D\u0438\u043A\u043D\u0435\u0439\u043C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D!"
};
const t$1s = distExports$1.getTranslation && locales$1r;
const useGiftingPanel = (props)=>{
    var _a3, _b2;
    const { user, subscriptionLevelPrice, blogUrl, onClose } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const internalGifts = (0, $iD0SF.useSelector)(nonZeroCountSubscriptionGiftSelector);
    const { isFetched } = (0, $iD0SF.useSelector)(subscriptionGiftNetworkStatusSelector);
    const [selectedGiftId, setSelectedGiftId] = (0, $acw62.useState)(((_b2 = (_a3 = internalGifts.find((gift2)=>gift2.subscriptionLevel.price > subscriptionLevelPrice)) == null ? void 0 : _a3.subscriptionLevel) == null ? void 0 : _b2.id) ?? null);
    const { onSubscribe } = useSubscribe$1({
        requiredLevelId: null,
        subscriptionPurchaseSource: EStatSubscriptionPurchaseStartSource.BLOG_STREAM_SUBSCRIBE
    });
    const selectGift = (subscriptionLevelId)=>{
        setSelectedGiftId(subscriptionLevelId);
    };
    const handleSendGift = async ()=>{
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(sendSubscriptionGift.action)({
                blogUrl: blogUrl,
                levelId: selectedGiftId,
                count: 1,
                userId: [
                    user.id
                ]
            }));
            dispatch(decrementSubscriptionGift({
                levelId: selectedGiftId,
                count: 1
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: t$1s.success
            });
            onClose();
        } catch (error2) {
            handleSendGiftError(error2, showAlert);
        }
    };
    const handleSubscribe = ()=>{
        copyToClipboard$1(user.nick, ()=>{
            showAlert({
                type: EAlertType.SUCCESS,
                text: t$1s.copyNick
            });
        });
        onClose();
        onSubscribe();
    };
    return {
        selectedGiftId: selectedGiftId,
        internalGifts: internalGifts,
        isFetched: isFetched,
        onSubscribe: handleSubscribe,
        selectGift: selectGift,
        onSendGift: handleSendGift
    };
};
const root$1B = "GiftingPanel-scss--module__root___aVb2p";
const controls$3 = "GiftingPanel-scss--module__controls___zewDY";
const iconBack$1 = "GiftingPanel-scss--module__iconBack___SPBKK";
const list$6 = "GiftingPanel-scss--module__list___ftRfK";
const listElement$1 = "GiftingPanel-scss--module__listElement___ULnOb";
const disabled$3 = "GiftingPanel-scss--module__disabled___a8uZK";
const listElementName = "GiftingPanel-scss--module__listElementName___DLawW";
const footer$8 = "GiftingPanel-scss--module__footer___lgupQ";
const button$k = "GiftingPanel-scss--module__button___saBat";
const noGiftsAvailable = "GiftingPanel-scss--module__noGiftsAvailable___AHpE-";
const noGiftsAvailableText = "GiftingPanel-scss--module__noGiftsAvailableText___9-2Hp";
const radio = "GiftingPanel-scss--module__radio___JRFow";
const s$2v = {
    root: root$1B,
    controls: controls$3,
    iconBack: iconBack$1,
    list: list$6,
    listElement: listElement$1,
    disabled: disabled$3,
    listElementName: listElementName,
    footer: footer$8,
    button: button$k,
    noGiftsAvailable: noGiftsAvailable,
    noGiftsAvailableText: noGiftsAvailableText,
    radio: radio
};
const locales$1q = {
    backButton: "\u041D\u0430\u0437\u0430\u0434",
    sendButton: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    noGiftsAvailable: "\u041D\u0435\u0442 \u043A\u0443\u043F\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u043E\u0434\u043F\u0438\u0441\u043E\u043A",
    buyGifts: "\u041A\u0443\u043F\u0438\u0442\u044C \u043F\u043E\u0434\u0430\u0440\u043A\u0438"
};
const t$1r = distExports$1.getTranslation && locales$1q;
const GiftingPanel = (props)=>{
    const { user, blogUrl, subscriptionLevelPrice = 0, onBackClick, onClose } = props;
    const { internalGifts, selectedGiftId, isFetched, selectGift, onSubscribe, onSendGift } = useGiftingPanel({
        blogUrl: blogUrl,
        user: user,
        subscriptionLevelPrice: subscriptionLevelPrice,
        onClose: onClose
    });
    const renderList = ()=>{
        if (internalGifts.length === 0 && isFetched) return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2v.noGiftsAvailable
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2v.noGiftsAvailableText
        }, t$1r.noGiftsAvailable), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2v.button,
            onClick: onSubscribe
        }, t$1r.buyGifts));
        const isSendDisabled = internalGifts.every((gift2)=>gift2.subscriptionLevel.price <= subscriptionLevelPrice);
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
            className: s$2v.list
        }, internalGifts.map((gift2)=>{
            const isGiftNotAvailable = gift2.subscriptionLevel.price <= subscriptionLevelPrice;
            return /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2v.listElement, {
                    [s$2v.disabled]: isGiftNotAvailable
                }),
                key: gift2.subscriptionLevel.id,
                onClick: ()=>!isGiftNotAvailable && selectGift(gift2.subscriptionLevel.id)
            }, /* @__PURE__ */ $acw62.createElement(RadioButton, {
                classNames: {
                    root: s$2v.listElementRadio,
                    radio: s$2v.radio
                },
                isChecked: gift2.subscriptionLevel.id === selectedGiftId,
                isDisabled: isGiftNotAvailable
            }), /* @__PURE__ */ $acw62.createElement("div", {
                className: s$2v.listElementName
            }, gift2.subscriptionLevel.name), /* @__PURE__ */ $acw62.createElement("div", {
                className: s$2v.listElementCount
            }, gift2.count));
        })), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$2v.footer
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2v.button, {
                [s$2v.disabled]: isSendDisabled
            }),
            onClick: ()=>isSendDisabled ? dist$4.noop() : void onSendGift()
        }, t$1r.sendButton)));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2v.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2v.controls
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2v.button,
        onClick: onBackClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_long,
        className: s$2v.iconBack
    }), t$1r.backButton)), renderList());
};
const root$1A = "SubMenu-scss--module__root___DXx72";
const backButton = "SubMenu-scss--module__backButton___Psv2q";
const iconBack = "SubMenu-scss--module__iconBack___JClqe";
const s$2u = {
    root: root$1A,
    backButton: backButton,
    iconBack: iconBack
};
const locales$1p = {
    backButton: "\u041D\u0430\u0437\u0430\u0434"
};
const t$1q = distExports$1.getTranslation && locales$1p;
const SubMenu = (props)=>{
    const { children: children2, className, onBackClick } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2u.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2u.backButton,
        onClick: onBackClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_long,
        className: s$2u.iconBack
    }), t$1q.backButton), children2);
};
const item$5 = "Rights-scss--module__item___KIU-0";
const s$2t = {
    item: item$5
};
const locales$1o = {
    none: "\u041D\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
    owner: "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446",
    channel_admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
    channel_moderator: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440",
    channel_chat_moderator: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440 \u0447\u0430\u0442\u0430",
    error: "\u041F\u0440\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u043E\u043B\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
    alreadyAssignedModerator: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0443\u0436\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0430 \u0440\u043E\u043B\u044C"
};
const t$1p = distExports$1.getTranslation && locales$1o;
const roles = [
    EModeratorRoles.CHANNEL_ADMIN,
    EModeratorRoles.CHANNEL_MODERATOR,
    EModeratorRoles.CHANNEL_CHAT_MODERATOR
];
const Rights = (props)=>{
    const { className, value: value2, onChange = dist$4.noop } = props;
    const [innerValue, setInnereValue] = (0, $acw62.useState)(value2);
    const { showAlert } = useNotificationsContext();
    const handleClick = async (id)=>{
        const prevValue = innerValue;
        setInnereValue(id);
        try {
            await onChange(id);
        } catch (error2) {
            setInnereValue(prevValue);
            showAlert({
                type: EAlertType.ERROR,
                text: t$1p.error
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        setInnereValue(value2);
    }, [
        value2
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement("label", {
        className: s$2t.item
    }, /* @__PURE__ */ $acw62.createElement(RadioButton, {
        classNames: {
            radio: s$2t.radio
        },
        mode: ERadioButtonMode.DARK,
        name: "name",
        value: EModeratorRoles.NONE,
        isChecked: !innerValue || innerValue === EModeratorRoles.NONE,
        onRadioButtonClick: handleClick
    }), t$1p["none"]), roles && roles.map((role2)=>/* @__PURE__ */ $acw62.createElement("label", {
            className: s$2t.item,
            key: role2
        }, /* @__PURE__ */ $acw62.createElement(RadioButton, {
            classNames: {
                radio: s$2t.radio
            },
            mode: ERadioButtonMode.DARK,
            name: "name",
            value: role2,
            isChecked: role2 === innerValue,
            onRadioButtonClick: handleClick
        }), t$1p[role2])));
};
var EUserStatMode = /* @__PURE__ */ ((EUserStatMode2)=>{
    EUserStatMode2["ACTIONS"] = "actions";
    EUserStatMode2["MESSAGE_HISTORY"] = "messageHistory";
    EUserStatMode2["GIFTING_PANEL"] = "giftingPanel";
    EUserStatMode2["RIGHTS"] = "rights";
    return EUserStatMode2;
})(EUserStatMode || {});
const root$1z = "UserStat-scss--module__root___Hr59c";
const offset = "UserStat-scss--module__offset___p4-sR";
const header$8 = "UserStat-scss--module__header___RwfAB";
const close$4 = "UserStat-scss--module__close___huxLb";
const closeIcon$2 = "UserStat-scss--module__closeIcon___otF1S";
const block$1 = "UserStat-scss--module__block___5kKCK";
const blockInfo = "UserStat-scss--module__blockInfo___YYNtV";
const rights = "UserStat-scss--module__rights___j-bmP";
const delimiter$1 = "UserStat-scss--module__delimiter___NK9oU";
const s$2s = {
    root: root$1z,
    offset: offset,
    header: header$8,
    close: close$4,
    closeIcon: closeIcon$2,
    block: block$1,
    blockInfo: blockInfo,
    rights: rights,
    delimiter: delimiter$1
};
const UserStat = (props)=>{
    var _a3, _b2, _c2;
    const { classNames = {}, blogUrl, offset: offset2, userId, ownerId, threadId, isCurrentUserModerator, isCurrentUserOwner, isChatContext = true, isMessageHistoryEnabled, isHistoriesStoringEnabled, isOnlyRecordChatMode, onClose, onBan, onTimeout, onBanCancel, onMention, onCalculateOffset, onReply, onRoleChange = dist$4.noop } = props;
    const { roles: roles2, onAssignRole, streamChatUserStat: userStat, currentUserId, onFetchRoles, onClearRoles } = useChatUsers(blogUrl);
    const [mode2, setMode] = (0, $acw62.useState)(EUserStatMode.ACTIONS);
    const isOwner = ownerId === userId;
    const isCurrentUser = currentUserId === userId;
    const containerRef = (0, $acw62.useRef)(null);
    const isChannelRolesEnabled = isConditionalFeatureEnable(EConditionalFeature.CHANNEL_ROLES);
    const handleMessageHistory = (0, $acw62.useCallback)(()=>{
        setMode(EUserStatMode.MESSAGE_HISTORY);
    }, []);
    const handleActions = (0, $acw62.useCallback)(()=>{
        setMode(EUserStatMode.ACTIONS);
    }, []);
    const handleGiftClick = (0, $acw62.useCallback)(()=>{
        setMode(EUserStatMode.GIFTING_PANEL);
    }, []);
    const handleRightsClick = ()=>{
        setMode(EUserStatMode.RIGHTS);
    };
    (0, $acw62.useEffect)(()=>{
        if ((isCurrentUserOwner || isCurrentUserModerator) && isChannelRolesEnabled) onFetchRoles();
        return ()=>{
            onClearRoles();
        };
    }, [
        isCurrentUserOwner,
        isCurrentUserModerator
    ]);
    (0, $acw62.useEffect)(()=>{
        if ((userStat == null ? void 0 : userStat.user.id) === userId && onCalculateOffset && containerRef.current) onCalculateOffset(containerRef.current.getBoundingClientRect());
    }, [
        userStat == null ? void 0 : userStat.user.id,
        userId,
        mode2
    ]);
    const [isRolesVisible, setIsRolesVisible] = (0, $acw62.useState)(false);
    if ((userStat == null ? void 0 : userStat.user.id) !== userId) return null;
    const renderInfo = ()=>/* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, (userStat == null ? void 0 : userStat.stat) !== void 0 && /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2s.block, s$2s.blockInfo)
        }, /* @__PURE__ */ $acw62.createElement(PopupInfo, {
            messageCount: userStat.stat.messagesCount,
            timeoutCount: userStat.stat.temporaryBansCount,
            banCount: userStat.stat.permanentBansCount,
            giftCount: userStat.stat.giftsCount,
            isMessageHistoryAvailable: isMessageHistoryEnabled,
            onMessageHistory: handleMessageHistory
        })));
    const renderActions = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !isRolesVisible && renderInfo(), /* @__PURE__ */ $acw62.createElement(Controls, {
            className: s$2s.block,
            blogUrl: blogUrl,
            onBan: onBan,
            onTimeout: onTimeout,
            onMention: onMention,
            onBanCancel: onBanCancel,
            onRightsClick: handleRightsClick,
            userStat: userStat,
            roles: roles2,
            isChannelRolesEnabled: isChannelRolesEnabled,
            threadId: threadId,
            isOwner: isOwner,
            isCurrentUser: isCurrentUser,
            isCurrentUserModerator: isCurrentUserModerator,
            isCurrentUserOwner: isCurrentUserOwner,
            isRolesVisible: isRolesVisible,
            isChatContext: isChatContext,
            isOnlyRecordChatMode: isOnlyRecordChatMode,
            onToggleRoleVisibility: handleToggleRoleVisibility,
            onAssignRole: onAssignRole,
            onReply: onReply,
            onGiftClick: handleGiftClick,
            onClose: onClose
        }));
    };
    const handleToggleRoleVisibility = ()=>{
        setIsRolesVisible(!isRolesVisible);
    };
    const handleRightChange = async (right2)=>{
        await onRoleChange(right2, userStat == null ? void 0 : userStat.user.id);
    };
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2s.root, classNames.root, {
            [s$2s.offset]: offset2
        }),
        style: offset2 ? {
            top: offset2.top,
            left: offset2.left,
            bottom: offset2.bottom
        } : {}
    }, /* @__PURE__ */ $acw62.createElement("button", {
        className: s$2s.close,
        type: "button",
        onClick: onClose
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2s.closeIcon,
        glyph: svg_name_close
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2s.header
    }, /* @__PURE__ */ $acw62.createElement(PopupUser, {
        avatarUrl: userStat.user.avatarUrl,
        name: userStat.user.nick,
        createdAt: userStat.user.createdAt
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2s.delimiter
    }), /* @__PURE__ */ $acw62.createElement(Subscription, {
        subscriberInfo: userStat.subscriberInfo
    }), /* @__PURE__ */ $acw62.createElement("div", null, !isRolesVisible && (userStat.user.badges.length > 0 || (userStat.user.roles ?? []).length > 0) && /* @__PURE__ */ $acw62.createElement(Insignia, {
        className: s$2s.block,
        badges: userStat.user.badges,
        roles: userStat.user.roles
    }), mode2 === EUserStatMode.ACTIONS && renderActions(), mode2 === EUserStatMode.RIGHTS && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, renderInfo(), /* @__PURE__ */ $acw62.createElement(SubMenu, {
        className: s$2s.block,
        onBackClick: handleActions
    }, /* @__PURE__ */ $acw62.createElement(Rights, {
        className: s$2s.rights,
        value: (_a3 = userStat.moderator) == null ? void 0 : _a3.role,
        onChange: handleRightChange
    }))), mode2 === EUserStatMode.GIFTING_PANEL && /* @__PURE__ */ $acw62.createElement(GiftingPanel, {
        user: userStat.user,
        blogUrl: blogUrl,
        subscriptionLevelPrice: ((_c2 = (_b2 = userStat == null ? void 0 : userStat.subscriberInfo) == null ? void 0 : _b2.subscriptionLevel) == null ? void 0 : _c2.price) ?? 0,
        onClose: onClose,
        onBackClick: handleActions
    }), isMessageHistoryEnabled && mode2 === EUserStatMode.MESSAGE_HISTORY && /* @__PURE__ */ $acw62.createElement(ChatHistory, {
        userId: userId,
        onBackClick: handleActions,
        isHistoriesStoringEnabled: isHistoriesStoringEnabled
    }))));
};
const root$1y = "SmileBaseInfo-scss--module__root___FpfUA";
const description$9 = "SmileBaseInfo-scss--module__description___0iuJO";
const leftBlock = "SmileBaseInfo-scss--module__leftBlock___rsj4i";
const smile = "SmileBaseInfo-scss--module__smile___z7CXo";
const clickable = "SmileBaseInfo-scss--module__clickable___1kLST";
const smileImg = "SmileBaseInfo-scss--module__smileImg___NRtvC";
const textBlock = "SmileBaseInfo-scss--module__textBlock___q01ln";
const name$7 = "SmileBaseInfo-scss--module__name___ZERHx";
const iconClose = "SmileBaseInfo-scss--module__iconClose___eR81M";
const s$2r = {
    root: root$1y,
    description: description$9,
    leftBlock: leftBlock,
    smile: smile,
    clickable: clickable,
    smileImg: smileImg,
    textBlock: textBlock,
    name: name$7,
    iconClose: iconClose
};
const locales$1n = {
    description: {
        global: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u043C\u0430\u0439\u043B\u0438\u043A VK Play",
        followers: "\u0421\u043C\u0430\u0439\u043B\u0438\u043A \u0434\u043B\u044F \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u0432",
        subscribers: "\u0421\u043C\u0430\u0439\u043B\u0438\u043A \u0434\u043B\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u0432",
        owner: "\u0421\u043C\u0430\u0439\u043B\u0438\u043A \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u043D\u0430\u0431\u043E\u0440\u0430"
    }
};
const t$1o = distExports$1.getTranslation && locales$1n;
const SmileBaseInfo = (props)=>{
    var _a3;
    const { smile: smile2, className, isOwnerSmile, onClose } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const description2 = (0, $acw62.useMemo)(()=>{
        if (isOwnerSmile) return t$1o.description.owner;
        else if (smile2.access.type === ESmileAccessType.GLOBAL) return t$1o.description.global;
        else if (smile2.access.subscriptionLevel.price === 0) return t$1o.description.followers;
        else return t$1o.description.subscribers;
    }, [
        smile2,
        isOwnerSmile
    ]);
    const handleCloseClick = ()=>{
        onClose();
    };
    const handleSmileClick = ()=>{
        var _a4;
        if ((_a4 = smile2.access) == null ? void 0 : _a4.allowed) dispatch(selectSmileInfoChatAction({
            smile: smile2
        }));
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch(clearSmileInfoChat());
        };
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2r.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2r.leftBlock
    }, /* @__PURE__ */ $acw62.createElement(Smile, {
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2r.smile, {
                [s$2r.clickable]: (_a3 = smile2.access) == null ? void 0 : _a3.allowed
            }),
            img: s$2r.smileImg
        },
        smile: smile2,
        size: EResizableImageSize.MEDIUM,
        onClick: handleSmileClick
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2r.textBlock
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2r.name
    }, smile2.name), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2r.description
    }, description2))), /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_close_new,
        className: s$2r.iconClose,
        onClick: handleCloseClick
    }));
};
const iconContainer$2 = "ExtraActionsMenu-scss--module__iconContainer___Xm5WZ";
const icon$x = "ExtraActionsMenu-scss--module__icon___-iKcD";
const s$2q = {
    iconContainer: iconContainer$2,
    icon: icon$x
};
const ExtraActionsMenu = (props)=>{
    const { children: children2, classNames = {}, iconGlyph, targetNode } = props;
    return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        classNames: {
            root: classNames.root,
            content: classNames.dropdown,
            contentWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2q.iconContainer, classNames.button)
        },
        isGlobal: true,
        content: children2,
        trigger: ETooltipTrigger.CLICK,
        shouldPreventDefault: true,
        position: ETooltipPosition.TOP_START
    }, Boolean(targetNode) && targetNode, !Boolean(targetNode) && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: iconGlyph || svg_name_dots,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2q.icon, classNames.icon)
    }));
};
const root$1x = "ExtraActionsMenuItem-scss--module__root___RvAMQ";
const withOverflow = "ExtraActionsMenuItem-scss--module__withOverflow___NS6FZ";
const noHover = "ExtraActionsMenuItem-scss--module__noHover___vcOvi";
const s$2p = {
    root: root$1x,
    withOverflow: withOverflow,
    noHover: noHover
};
const ExtraActionsMenuItem = (props)=>{
    const { text: text2, className, onClick, isClickableOnce, isHoverDisabled, isOverflowAvailable, children: children2 } = props;
    const [isClicked, setClicked] = (0, $acw62.useState)(false);
    const handleClick = (event2)=>{
        onClick(event2);
        setClicked(true);
    };
    return /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2p.root, className, {
            [s$2p.noHover]: isHoverDisabled,
            [s$2p.withOverflow]: isOverflowAvailable
        }),
        type: "button",
        onClick: handleClick,
        disabled: isClickableOnce && isClicked
    }, children2 || text2);
};
var EFollowButtonTestId = /* @__PURE__ */ ((EFollowButtonTestId2)=>{
    EFollowButtonTestId2["ROOT"] = "root";
    return EFollowButtonTestId2;
})(EFollowButtonTestId || {});
const FOLLOW_BUTTON_TEST_ID = "FollowButton";
const root$1w = "FollowButton-scss--module__root___-4YKG";
const shortened$1 = "FollowButton-scss--module__shortened___ychWl";
const icon$w = "FollowButton-scss--module__icon___x4yWV";
const text$8 = "FollowButton-scss--module__text___dFTHv";
const iconDisabled = "FollowButton-scss--module__iconDisabled___O6alB";
const iconActive$1 = "FollowButton-scss--module__iconActive___bvWsc";
const s$2o = {
    root: root$1w,
    shortened: shortened$1,
    icon: icon$w,
    text: text$8,
    iconDisabled: iconDisabled,
    iconActive: iconActive$1
};
const locales$1m = {
    follow: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C",
    following: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u044E",
    unfollow: "\u041F\u0435\u0440\u0435\u0441\u0442\u0430\u0442\u044C \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C"
};
const t$1n = distExports$1.getTranslation && locales$1m;
const getTestId = getFactoryTestId(FOLLOW_BUTTON_TEST_ID);
const ButtonWrapper = ({ as: Component2, ...props })=>{
    return /* @__PURE__ */ $acw62.createElement(Component2, {
        ...props
    });
};
const FollowButton = (props)=>{
    const { isDisabled: isDisabled2, classNames = {}, withBell = false, isShortened = false, externalBlog, FollowButtonComponent, onClick, onToggleFollowCallback } = props;
    const { isFetching, isFollowing, isSubscribed, onFollowToggle } = useFollow$1({
        externalBlog: externalBlog,
        onToggleFollowCallback: onToggleFollowCallback
    });
    const [isButtonHovered, setIsButtonHovered] = (0, $acw62.useState)(false);
    const isActiveIcon = isFollowing || isSubscribed;
    const isButtonDisabled = isSubscribed || isDisabled2 || isFetching;
    const hasIcon = !isFollowing || !isButtonHovered;
    const getIcon = ()=>{
        if (isActiveIcon) return svg_name_done_16;
        else if (withBell) return svg_name_bell_with_plus;
        else return svg_name_add_square_outline_24;
    };
    const handleClick = ()=>{
        if (!isSubscribed) {
            onFollowToggle();
            onClick == null || onClick();
        }
    };
    const handleMouseEnter = ()=>{
        setIsButtonHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsButtonHovered(false);
    };
    if (FollowButtonComponent) return /* @__PURE__ */ $acw62.createElement(FollowButtonComponent, {
        onClick: handleClick
    });
    return /* @__PURE__ */ $acw62.createElement(ButtonWrapper, {
        as: isActiveIcon ? OutlinedButton : ContainedButton,
        ...testAttr(getTestId(EFollowButtonTestId.ROOT)),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2o.root, classNames.root, {
            [s$2o.shortened]: isShortened
        }),
        isDisabled: isButtonDisabled,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, hasIcon && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: getIcon(),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2o.icon, classNames.icon, {
            [s$2o.iconActive]: isActiveIcon,
            [s$2o.iconDisabled]: isSubscribed
        })
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2o.text
    }, t$1n[isFollowing ? isButtonHovered && !isSubscribed ? "unfollow" : "following" : "follow"]));
};
const root$1v = "SubscribeButtonBase-scss--module__root___zknqO";
const icon$v = "SubscribeButtonBase-scss--module__icon___Va3p1";
const text$7 = "SubscribeButtonBase-scss--module__text___2Ve9x";
const shortened = "SubscribeButtonBase-scss--module__shortened___ZZhX9";
const separator$2 = "SubscribeButtonBase-scss--module__separator___ibyOW";
const separatorForFollower = "SubscribeButtonBase-scss--module__separatorForFollower___NUxCf";
const s$2n = {
    root: root$1v,
    icon: icon$v,
    text: text$7,
    shortened: shortened,
    separator: separator$2,
    separatorForFollower: separatorForFollower
};
const locales$1l = {
    subscribe: "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F",
    gift: "\u041F\u043E\u0434\u0430\u0440\u0438\u0442\u044C"
};
const t$1m = distExports$1.getTranslation && locales$1l;
const SubscribeButtonBase = (props)=>{
    const { externalBlogUrl, className, requiredLevelId, subscriptionPurchaseSource, isShortened, ButtonComponent } = props;
    const { isBlogOwner, isAlreadySubscribed, onSubscribe } = useSubscribe$1({
        externalBlogUrl: externalBlogUrl,
        requiredLevelId: requiredLevelId,
        subscriptionPurchaseSource: subscriptionPurchaseSource
    });
    const { isFollowing } = useFollow$1({});
    if (ButtonComponent) return /* @__PURE__ */ $acw62.createElement(ButtonComponent, {
        onClick: onSubscribe
    });
    const startButtonContent = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_favorite_outline_24,
        className: s$2n.icon
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2n.text
    }, t$1m.subscribe), /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2n.separator, {
            [s$2n.separatorForFollower]: isFollowing
        })
    }), /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_gift_outline_24,
        className: s$2n.icon
    }));
    const subscribedButtonContent = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_gift_outline_24,
        className: s$2n.icon
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$2n.text
    }, t$1m.gift));
    const buttonColor = isAlreadySubscribed || isBlogOwner ? "success" : isFollowing ? "primary" : "secondary";
    return /* @__PURE__ */ $acw62.createElement(Button$2, {
        color: buttonColor,
        onClick: onSubscribe,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, s$2n.root, {
            [s$2n.shortened]: isShortened
        })
    }, isAlreadySubscribed || isBlogOwner ? subscribedButtonContent : startButtonContent);
};
const container$6 = "ViewersCounterSkeleton-scss--module__container___Zwh13";
const s$2m = {
    container: container$6
};
const ViewersCounterSkeleton = (props)=>{
    const { isVerbose = false, isNormal = false } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2m.container, {
            [s$2m.normal]: isNormal
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2m.count
    }, "\xa0"), isVerbose && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2m.viewers
    }));
};
const container$5 = "ViewersCounter-scss--module__container___cOeg8";
const retranslation = "ViewersCounter-scss--module__retranslation___1UcRl";
const containerNormal = "ViewersCounter-scss--module__containerNormal___tYeW4";
const containerTransparentFlatBg = "ViewersCounter-scss--module__containerTransparentFlatBg___kqSvk";
const containerGrayBg = "ViewersCounter-scss--module__containerGrayBg___74yyb";
const withCrown = "ViewersCounter-scss--module__withCrown___zjhf-";
const isLive = "ViewersCounter-scss--module__isLive___c9DQ4";
const retranslationIcon = "ViewersCounter-scss--module__retranslationIcon___VFF-h";
const icon$u = "ViewersCounter-scss--module__icon___Ys6Ma";
const s$2l = {
    container: container$5,
    retranslation: retranslation,
    containerNormal: containerNormal,
    containerTransparentFlatBg: containerTransparentFlatBg,
    containerGrayBg: containerGrayBg,
    withCrown: withCrown,
    isLive: isLive,
    retranslationIcon: retranslationIcon,
    icon: icon$u
};
const locales$1k = {
    viewers: [
        "\u0437\u0440\u0438\u0442\u0435\u043B\u044C",
        "\u0437\u0440\u0438\u0442\u0435\u043B\u044F",
        "\u0437\u0440\u0438\u0442\u0435\u043B\u0435\u0439"
    ]
};
const t$1l = distExports$1.getTranslation && locales$1k;
const WINDOW_WIDTH_LIMIT = 1366;
const ViewersCounter = (props)=>{
    const { className, count: count2, isTransparentFlatBg, isGrayBg, isVerbose = false, isNormal = false, isLive: isLive2 = true, isRetranslationActive, withCrown: withCrown2 = false, isFullCountAvailable = false } = props;
    const { width: windowWidth } = useWindowSize();
    if (count2 == null && !isRetranslationActive) return /* @__PURE__ */ $acw62.createElement(ViewersCounterSkeleton, {
        isNormal: isNormal,
        isVerbose: isVerbose
    });
    const renderCount = (num2)=>{
        if (windowWidth >= WINDOW_WIDTH_LIMIT && isFullCountAvailable) return count2.toLocaleString("en");
        return getShortNum(num2);
    };
    const renderContent = ()=>{
        const countWithSeparators = count2 == null ? void 0 : count2.toLocaleString("en");
        if (isRetranslationActive) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_wave,
            className: s$2l.retranslationIcon
        }), /* @__PURE__ */ $acw62.createElement("div", null, countWithSeparators));
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, withCrown2 && isLive2 && /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_crown_simple,
            className: s$2l.icon
        }), /* @__PURE__ */ $acw62.createElement("div", null, renderCount(count2)), isVerbose && /* @__PURE__ */ $acw62.createElement("div", null, "\xa0", declOfNum(t$1l.viewers, count2)));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2l.container, className, {
            [s$2l.containerNormal]: isNormal,
            [s$2l.containerTransparentFlatBg]: isTransparentFlatBg,
            [s$2l.containerGrayBg]: isGrayBg,
            [s$2l.isLive]: isLive2,
            [s$2l.retranslation]: isRetranslationActive,
            [s$2l.withCrown]: withCrown2
        })
    }, renderContent());
};
const SCROLL_WIDTH = 7;
const calculateSmileTooltipPosition = (target2, tooltip2)=>{
    const newPosition = {
        left: "50%",
        bottom: "calc(100% + 5px)",
        top: ""
    };
    const container2 = target2.closest('[data-role="container"]');
    const { width: targetWidth, left: targetLeft } = target2.getBoundingClientRect();
    const targetCenter = Math.ceil(targetLeft + targetWidth / 2);
    tooltip2.style.display = "block";
    tooltip2.style.opacity = "0";
    const { width: tooltipWidth, top: tooltipTop } = tooltip2.getBoundingClientRect();
    tooltip2.style.display = "";
    tooltip2.style.opacity = "";
    const halfOfTooltipWidth = Math.ceil(tooltipWidth / 2);
    const { left: containerLeft, right: containerRight, top: containerTop, width: containerWidth } = container2.getBoundingClientRect();
    if (tooltipTop < containerTop) {
        newPosition["top"] = "calc(100% + 5px)";
        newPosition["bottom"] = "unset";
    }
    if (targetCenter - halfOfTooltipWidth < containerLeft || tooltipWidth > containerWidth) {
        newPosition["left"] = `calc(50% + ${Math.ceil(containerLeft - (targetCenter - halfOfTooltipWidth))}px)`;
        return newPosition;
    }
    if (targetCenter + halfOfTooltipWidth + SCROLL_WIDTH > containerRight) {
        newPosition["left"] = `calc(50% - ${Math.ceil(targetCenter + halfOfTooltipWidth - containerRight + SCROLL_WIDTH)}px)`;
        return newPosition;
    }
    return newPosition;
};
const smileContainer$2 = "SmileItem-scss--module__smileContainer___1n6CI";
const smileContainerLoading = "SmileItem-scss--module__smileContainerLoading___QXpdR";
const smileImage = "SmileItem-scss--module__smileImage___BzaHR";
const iconContainer$1 = "SmileItem-scss--module__iconContainer___zmrvn";
const icon$t = "SmileItem-scss--module__icon___1VPPV";
const tooltip$4 = "SmileItem-scss--module__tooltip___G4rMX";
const tooltipVisible = "SmileItem-scss--module__tooltipVisible___3p3fM";
const tooltipContent$3 = "SmileItem-scss--module__tooltipContent___Wa2pm";
const s$2k = {
    smileContainer: smileContainer$2,
    smileContainerLoading: smileContainerLoading,
    smileImage: smileImage,
    iconContainer: iconContainer$1,
    icon: icon$t,
    tooltip: tooltip$4,
    tooltipVisible: tooltipVisible,
    tooltipContent: tooltipContent$3
};
const SmileItem = (props)=>{
    const { smile: smile2, classNames = {}, hasLockOverlay, hasHeartOverlay, activeSmileRef, selected: selected2, onClick } = props;
    const { smallUrl, mediumUrl } = smile2;
    const [tooltipPosition, setTooltipPosition] = (0, $acw62.useState)(null);
    const ref2 = (0, $acw62.useRef)(null);
    const tooltipRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const onMouseOver = (event2)=>{
            setTooltipPosition(calculateSmileTooltipPosition(event2.target, tooltipRef.current));
        };
        const onMouseOut = ()=>{
            setTooltipPosition(null);
        };
        ref2.current.addEventListener("mouseenter", onMouseOver);
        ref2.current.addEventListener("mouseleave", onMouseOut);
        return ()=>{
            var _a3, _b2;
            (_a3 = ref2.current) == null || _a3.removeEventListener("mouseenter", onMouseOver);
            (_b2 = ref2.current) == null || _b2.removeEventListener("mouseleave", onMouseOut);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (selected2 && activeSmileRef) activeSmileRef.current = ref2.current;
    }, [
        selected2
    ]);
    const isVisible = useVisibility({
        element: ref2,
        lock: true
    });
    const hasOverlay = hasLockOverlay || hasHeartOverlay;
    const handleClick = (event2)=>{
        onClick(smile2, event2);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2k.smileContainer, classNames.smileContainer, {
            [s$2k.smileContainerLoading]: !isVisible
        }),
        ref: ref2,
        onClick: handleClick
    }, isVisible && hasOverlay && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2k.iconContainer
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: hasHeartOverlay ? svg_name_like : svg_name_lock,
        className: s$2k.icon
    })), isVisible && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("img", {
        src: smallUrl,
        srcSet: `${mediumUrl} 2x`,
        alt: "",
        className: s$2k.smileImage
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2k.tooltip, s$2k.tooltipContent, {
            [s$2k.tooltipVisible]: Boolean(tooltipPosition)
        }),
        ref: tooltipRef,
        style: tooltipPosition ?? {}
    }, smile2.name)));
};
const smileContainer$1 = "SmilesList-scss--module__smileContainer___zSXql";
const buttonPrev = "SmilesList-scss--module__buttonPrev___nOVsc";
const buttonNext = "SmilesList-scss--module__buttonNext___z5pvr";
const root$1u = "SmilesList-scss--module__root___LGKzU";
const list$5 = "SmilesList-scss--module__list___Y3m2t";
const button$j = "SmilesList-scss--module__button___zzOCr";
const arrow$1 = "SmilesList-scss--module__arrow___Nx1HU";
const buttonHidden = "SmilesList-scss--module__buttonHidden___sfJjj";
const tooltip$3 = "SmilesList-scss--module__tooltip___zv7lc";
const tooltipContent$2 = "SmilesList-scss--module__tooltipContent___upSpv";
const s$2j = {
    smileContainer: smileContainer$1,
    buttonPrev: buttonPrev,
    buttonNext: buttonNext,
    root: root$1u,
    list: list$5,
    button: button$j,
    arrow: arrow$1,
    buttonHidden: buttonHidden,
    tooltip: tooltip$3,
    tooltipContent: tooltipContent$2
};
const SMILE_WIDTH = 42;
const DEFAULT_SMILES_PER_PAGE = 7;
const SmilesList$1 = (props)=>{
    const { smiles: smiles2, subscriptionPrice } = props;
    const [currentPageIndex, setPageIndex] = (0, $acw62.useState)(0);
    const [smilesPerPage, setSmilesPerPage] = (0, $acw62.useState)(DEFAULT_SMILES_PER_PAGE);
    const listRef = (0, $acw62.useRef)(null);
    const { isMobile: isMobile2 } = getConfig();
    const isFirstPage = currentPageIndex === 0;
    const lastPageIndex = Math.ceil(smiles2.length / smilesPerPage) - 1;
    const isLastPage = currentPageIndex === lastPageIndex;
    const listLeft = `-${currentPageIndex * SMILE_WIDTH * smilesPerPage}px`;
    (0, $acw62.useEffect)(()=>{
        if (isMobile2) {
            onResize();
            window.addEventListener("resize", onResize);
        }
        return ()=>{
            window.removeEventListener("resize", onResize);
        };
    }, []);
    const handlePrevClick = ()=>{
        if (!isFirstPage) setPageIndex(currentPageIndex - 1);
    };
    const handleNextClick = ()=>{
        if (!isLastPage) setPageIndex(currentPageIndex + 1);
    };
    const onResize = ()=>{
        setPageIndex(0);
        setSmilesPerPage(Math.floor(listRef.current.clientWidth / SMILE_WIDTH));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2j.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2j.button, s$2j.buttonPrev, {
            [s$2j.buttonHidden]: isFirstPage
        }),
        onClick: handlePrevClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$2j.arrow
    })), /* @__PURE__ */ $acw62.createElement("div", {
        ref: listRef,
        className: s$2j.list,
        style: {
            left: listLeft
        }
    }, smiles2.map((smile2)=>{
        var _a3, _b2;
        const hasLockOverlay = ((_b2 = (_a3 = smile2.access) == null ? void 0 : _a3.subscriptionLevel) == null ? void 0 : _b2.price) > subscriptionPrice && !smile2.access.allowed;
        if (isMobile2) return /* @__PURE__ */ $acw62.createElement(SmileItem, {
            key: smile2.id,
            smile: smile2,
            hasLockOverlay: hasLockOverlay,
            classNames: {
                smileContainer: s$2j.smileContainer
            },
            onClick: noop$2
        });
        else return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            key: smile2.id,
            content: smile2.name,
            position: ETooltipPosition.TOP,
            isGlobal: true,
            offset: 2,
            classNames: {
                root: s$2j.tooltip,
                content: s$2j.tooltipContent
            }
        }, /* @__PURE__ */ $acw62.createElement(SmileItem, {
            key: smile2.id,
            smile: smile2,
            hasLockOverlay: hasLockOverlay,
            classNames: {
                smileContainer: s$2j.smileContainer
            },
            onClick: noop$2
        }));
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2j.button, s$2j.buttonNext, {
            [s$2j.buttonHidden]: isLastPage
        }),
        onClick: handleNextClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$2j.arrow
    })));
};
const root$1t = "SmileSubscribeInfo-scss--module__root___lpLgr";
const delimiter = "SmileSubscribeInfo-scss--module__delimiter___iUfBQ";
const topBlock$1 = "SmileSubscribeInfo-scss--module__topBlock___D5nO6";
const ownerBlock = "SmileSubscribeInfo-scss--module__ownerBlock___JRvQr";
const avatar$2 = "SmileSubscribeInfo-scss--module__avatar___gB4TN";
const link$1 = "SmileSubscribeInfo-scss--module__link___0tWR8";
const dots$1 = "SmileSubscribeInfo-scss--module__dots___ef6O8";
const dotsIcon = "SmileSubscribeInfo-scss--module__dotsIcon___z1axr";
const description$8 = "SmileSubscribeInfo-scss--module__description___E6saY";
const buttonsBlock = "SmileSubscribeInfo-scss--module__buttonsBlock___jvkdQ";
const subscribeButton$1 = "SmileSubscribeInfo-scss--module__subscribeButton___6-DNy";
const followButton$1 = "SmileSubscribeInfo-scss--module__followButton___0pabJ";
const followButtonActive = "SmileSubscribeInfo-scss--module__followButtonActive___sQET-";
const followButtonIcon = "SmileSubscribeInfo-scss--module__followButtonIcon___MG93t";
const viewers = "SmileSubscribeInfo-scss--module__viewers___3aSwf";
const s$2i = {
    root: root$1t,
    delimiter: delimiter,
    topBlock: topBlock$1,
    ownerBlock: ownerBlock,
    avatar: avatar$2,
    link: link$1,
    dots: dots$1,
    dotsIcon: dotsIcon,
    description: description$8,
    buttonsBlock: buttonsBlock,
    subscribeButton: subscribeButton$1,
    followButton: followButton$1,
    followButtonActive: followButtonActive,
    followButtonIcon: followButtonIcon,
    viewers: viewers
};
const locales$1j = {
    smile1: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A",
    smile2: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0430",
    smile5: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432",
    shouldFollow: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043A\u0430\u043D\u0430\u043B {{channelName}}, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 \u0447\u0430\u0442\u0435 \u0441\u043C\u0430\u0439\u043B\u0438\u043A {{smileName}}",
    shouldSubscribe: "\u0421\u0442\u0430\u043D\u044C\u0442\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u043C \u0443\u0440\u043E\u0432\u043D\u044F: \xab{{subscriptionName}}\xbb \u043D\u0430 \u043A\u0430\u043D\u0430\u043B {{channelName}}, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 \u0447\u0430\u0442\u0435 \u0441\u043C\u0430\u0439\u043B\u0438\u043A {{smileName}}",
    includingSmilesWhenShould: "\u0438 \u0435\u0449\u0435 {{smiles}} \u043A\u0430\u043D\u0430\u043B\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F:",
    isFollowing: "\u0412\u044B \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0435\u0442\u0435 {{channelName}} \u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u043C\u0430\u0439\u043B\u0438\u043A {{smileName}},",
    isSubscribed: "\u0412\u044B \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u044B \u043D\u0430 \u0443\u0440\u043E\u0432\u0435\u043D\u044C: \xab{{subscriptionName}}\xbb \u043A\u0430\u043D\u0430\u043B\u0430 {{channelName}} \u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u043C\u0430\u0439\u043B\u0438\u043A {{smileName}},",
    includingSmilesWhenIs: "\u0430 \u0442\u0430\u043A\u0436\u0435 {{smiles}} \u043A\u0430\u043D\u0430\u043B\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F:"
};
const t$1k = distExports$1.getTranslation && locales$1j;
const ROLE$2 = "container";
const SmileSubscribeInfo = (props)=>{
    var _a3, _b2;
    const { smileData: { smile: smile2, set: set2, ownerInfo: { blog: { owner: { avatarUrl, displayName }, blogUrl: smileBlogUrl, subscriptionKind }, stream: stream2 } }, refetch } = props;
    const { name: name2, id: smileId, access: { allowed, subscriptionLevel: { price, name: subscriptionName, id: smileSubscriptionLevelId } } } = smile2;
    const { blogUrl } = (0, $iD0SF.useSelector)(blogSelector);
    const hasExternalBlog = smileBlogUrl !== blogUrl;
    const blogLink = getParametrizedUrl(URLS.BLOG, {
        blogUrl: smileBlogUrl
    });
    const isFollowSmile = price === 0;
    const hasViewersCounter = (stream2 == null ? void 0 : stream2.isOnline) && typeof (stream2 == null ? void 0 : stream2.count.viewers) === "number";
    const followSmilesCount = (0, $acw62.useMemo)(()=>{
        return set2.smiles.filter((item2)=>{
            var _a4, _b3;
            return ((_b3 = (_a4 = item2.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price) === 0;
        }).length;
    }, [
        props.smileData
    ]);
    const subscribeSmilesCount = (0, $acw62.useMemo)(()=>{
        return set2.smiles.filter((item2)=>{
            var _a4, _b3;
            return ((_b3 = (_a4 = item2.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price) <= price;
        }).length;
    }, [
        props.smileData
    ]);
    const smilesForList = (0, $acw62.useMemo)(()=>{
        if (isFollowSmile) return set2.smiles.filter((item2)=>item2.id !== smileId).sort((smileA, smileB)=>{
            var _a4, _b3, _c2, _d;
            return ((_b3 = (_a4 = smileA.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price) - ((_d = (_c2 = smileB.access) == null ? void 0 : _c2.subscriptionLevel) == null ? void 0 : _d.price);
        });
        else return set2.smiles.filter((item2)=>{
            var _a4, _b3;
            return price >= ((_b3 = (_a4 = item2.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price) && item2.id !== smileId;
        }).sort((smileA, smileB)=>{
            var _a4, _b3, _c2, _d;
            return ((_b3 = (_a4 = smileB.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price) - ((_d = (_c2 = smileA.access) == null ? void 0 : _c2.subscriptionLevel) == null ? void 0 : _d.price);
        }).concat(set2.smiles.filter((item2)=>{
            var _a4, _b3;
            return price < ((_b3 = (_a4 = item2.access) == null ? void 0 : _a4.subscriptionLevel) == null ? void 0 : _b3.price);
        }));
    }, [
        props.smileData
    ]);
    const firstSubscriptionLevelId = (0, $acw62.useMemo)(()=>{
        var _a4;
        const filteredLevels = set2.smiles.filter((item2)=>{
            var _a5, _b3;
            return ((_b3 = (_a5 = item2.access) == null ? void 0 : _a5.subscriptionLevel) == null ? void 0 : _b3.price) > 0;
        });
        return (_a4 = filteredLevels[0]) == null ? void 0 : _a4.access.subscriptionLevel.id;
    }, [
        props.smileData
    ]);
    const hasFreeSubscription = subscriptionKind === ESubscriptionKind.FREE;
    const hasPaidSubscription = subscriptionKind === ESubscriptionKind.PAID;
    const hasSubscription = hasFreeSubscription || hasPaidSubscription;
    const subscriptionLevelIdToSubscribe = isFollowSmile ? firstSubscriptionLevelId : smileSubscriptionLevelId;
    const { isComplaintAvailable, complaintText, onReportClick } = useComplaint({
        itemType: "smile"
    });
    const getDescription = (generalText, includingSmilesText, smilesCount)=>/* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("span", null, distExports$1.getParametrizedText(generalText, {
            subscriptionName: subscriptionName,
            channelName: displayName,
            smileName: name2
        })), smilesCount > 1 && /* @__PURE__ */ $acw62.createElement("span", null, "\xa0", distExports$1.getParametrizedText(includingSmilesText, {
            smiles: `${smilesCount - 1} ${declOfNum([
                t$1k.smile1,
                t$1k.smile2,
                t$1k.smile5
            ], smilesCount - 1)}`
        })));
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.root,
        "data-role": ROLE$2
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.delimiter
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.topBlock
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.ownerBlock
    }, /* @__PURE__ */ $acw62.createElement(Avatar, {
        img: avatarUrl,
        size: EAvatarSize.XS,
        className: s$2i.avatar
    }), /* @__PURE__ */ $acw62.createElement(Link, {
        to: blogLink,
        className: s$2i.link,
        target: "_blank"
    }, displayName), hasViewersCounter && /* @__PURE__ */ $acw62.createElement(ViewersCounter, {
        count: stream2.count.viewers,
        className: s$2i.viewers
    })), isComplaintAvailable && /* @__PURE__ */ $acw62.createElement(ExtraActionsMenu, {
        classNames: {
            root: s$2i.dots,
            icon: s$2i.dotsIcon
        },
        iconGlyph: svg_name_dots
    }, [
        /* @__PURE__ */ $acw62.createElement(ExtraActionsMenuItem, {
            text: complaintText,
            key: "report",
            onClick: onReportClick
        })
    ])), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.description
    }, isFollowSmile && hasSubscription && getDescription(t$1k.isFollowing, t$1k.includingSmilesWhenIs, followSmilesCount), isFollowSmile && !hasSubscription && getDescription(t$1k.shouldFollow, t$1k.includingSmilesWhenShould, followSmilesCount), !isFollowSmile && hasPaidSubscription && getDescription(t$1k.isSubscribed, t$1k.includingSmilesWhenIs, subscribeSmilesCount), !isFollowSmile && !hasPaidSubscription && getDescription(t$1k.shouldSubscribe, t$1k.includingSmilesWhenShould, subscribeSmilesCount)), /* @__PURE__ */ $acw62.createElement(SmilesList$1, {
        smiles: smilesForList,
        subscriptionPrice: price
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2i.buttonsBlock
    }, /* @__PURE__ */ $acw62.createElement(FollowButton, {
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2i.followButton, {
                [s$2i.followButtonActive]: hasSubscription
            }),
            icon: s$2i.followButtonIcon
        },
        onToggleFollowCallback: refetch,
        externalBlog: (_b2 = (_a3 = props == null ? void 0 : props.smileData) == null ? void 0 : _a3.ownerInfo) == null ? void 0 : _b2.blog
    }), Boolean(subscriptionLevelIdToSubscribe) && /* @__PURE__ */ $acw62.createElement(SubscribeButtonBase, {
        className: s$2i.subscribeButton,
        externalBlogUrl: hasExternalBlog ? smileBlogUrl : void 0,
        requiredLevelId: allowed ? null : subscriptionLevelIdToSubscribe,
        subscriptionPurchaseSource: hasExternalBlog ? EStatSubscriptionPurchaseStartSource.BLOG_EXTERNAL_STREAM_SUBSCRIBE : EStatSubscriptionPurchaseStartSource.SMILE_INFO_TOOLTIP
    })));
};
const useSmileInfo = (params)=>{
    const { smileId } = params;
    const [hasExternalBlog, setHasExternalBlog] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const smileData = (0, $iD0SF.useSelector)(smileDataSelector);
    const { blogUrl } = useStreamIdentity();
    const { isFetched: isSmileDataIsFetched } = (0, $iD0SF.useSelector)(smileDataSelectorNetworkStatusSelector);
    const { isFetched: isSubscriptionLevelsExternalFetched } = (0, $iD0SF.useSelector)(subscriptionLevelsExternalBlogNetworkStatusSelector);
    const { isFetched: isBlogExternalFetched } = (0, $iD0SF.useSelector)(blogExternalNetworkStatusSelector);
    const isLoaded = isSmileDataIsFetched && (hasExternalBlog ? isSubscriptionLevelsExternalFetched && isBlogExternalFetched : true);
    const { isAuthorized, [ECurrentUserAccessRole.SMILE_OWNER]: isSmileOwner } = useCurrentUserAccess();
    (0, $acw62.useEffect)(()=>{
        if (smileId) fetchData();
        return ()=>{
            clearData();
        };
    }, [
        smileId,
        isAuthorized
    ]);
    const fetchData = async ()=>{
        const { ownerInfo: { blog: { blogUrl: smileBlogUrl } } } = await dispatch((0, $7Uc0p.thunkToAction)(fetchSmileData.action)({
            smileId: smileId
        }));
        const hasExtblog = blogUrl !== smileBlogUrl;
        setHasExternalBlog(hasExtblog);
        if (hasExtblog) {
            dispatch(fetchBlogSubscriptionLevels.action({
                blogUrl: smileBlogUrl,
                isExternalBlog: true
            }));
            dispatch(fetchBlogExternal.action({
                blogUrl: smileBlogUrl
            }));
        }
    };
    const clearData = ()=>{
        dispatch(clearSmileData());
    };
    return {
        smileData: smileData,
        isLoaded: isLoaded,
        isSmileOwner: isSmileOwner,
        fetchData: fetchData
    };
};
const content$b = "SmileInfo-scss--module__content___HTzh5";
const baseInfo = "SmileInfo-scss--module__baseInfo___bWoWw";
const spinner$1 = "SmileInfo-scss--module__spinner___Bq5Ng";
const closeButton$1 = "SmileInfo-scss--module__closeButton___gwTMo";
const s$2h = {
    content: content$b,
    baseInfo: baseInfo,
    spinner: spinner$1,
    closeButton: closeButton$1
};
const locales$1i = {
    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
};
const t$1j = distExports$1.getTranslation && locales$1i;
const SmileInfo = (props)=>{
    const { smileId, className, onClose } = props;
    const { smileData, isSmileOwner, isLoaded, fetchData } = useSmileInfo({
        smileId: smileId
    });
    const hasLoader = !isLoaded;
    const hasSubscribeInfo = !isSmileOwner && (smileData == null ? void 0 : smileData.type) !== ESmileAccessType.GLOBAL;
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2h.content
    }, hasLoader && /* @__PURE__ */ $acw62.createElement(Spinner, {
        size: 34,
        className: s$2h.spinner
    }), !hasLoader && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(SmileBaseInfo, {
        smile: smileData == null ? void 0 : smileData.smile,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$2h.baseInfo]: hasSubscribeInfo
        }),
        isOwnerSmile: isSmileOwner,
        onClose: onClose
    }), hasSubscribeInfo && /* @__PURE__ */ $acw62.createElement(SmileSubscribeInfo, {
        smileData: smileData,
        refetch: fetchData
    }), !hasSubscribeInfo && /* @__PURE__ */ $acw62.createElement(OutlinedButton, {
        className: s$2h.closeButton,
        onClick: onClose
    }, t$1j.close)))));
};
var EChatModerationPopupOpeningDirection = /* @__PURE__ */ ((EChatModerationPopupOpeningDirection2)=>{
    EChatModerationPopupOpeningDirection2["TOP"] = "top";
    EChatModerationPopupOpeningDirection2["BOTTOM"] = "bottom";
    return EChatModerationPopupOpeningDirection2;
})(EChatModerationPopupOpeningDirection || {});
const root$1s = "ChatBoxBase-scss--module__root___kIW-p";
const wrapper$1 = "ChatBoxBase-scss--module__wrapper___uNlVM";
const scrollButton = "ChatBoxBase-scss--module__scrollButton___wGKlD";
const scrollButtonIconArrow = "ChatBoxBase-scss--module__scrollButtonIconArrow___OWcCI";
const scrollButtonIconPause = "ChatBoxBase-scss--module__scrollButtonIconPause___8MDwh";
const scrollButtonIconHover = "ChatBoxBase-scss--module__scrollButtonIconHover___Lx64G";
const withHover = "ChatBoxBase-scss--module__withHover___8N9CG";
const countdown = "ChatBoxBase-scss--module__countdown___6Hm--";
const countdownSvg$1 = "ChatBoxBase-scss--module__countdownSvg___f7LNY";
const countdownSvgCircle$1 = "ChatBoxBase-scss--module__countdownSvgCircle___XGksv";
const hoverElements = "ChatBoxBase-scss--module__hoverElements___OImxw";
const active$4 = "ChatBoxBase-scss--module__active___k6QdA";
const button$i = "ChatBoxBase-scss--module__button___ryI-7";
const buttonIcon = "ChatBoxBase-scss--module__buttonIcon___Gbkdw";
const s$2g = {
    root: root$1s,
    wrapper: wrapper$1,
    scrollButton: scrollButton,
    scrollButtonIconArrow: scrollButtonIconArrow,
    scrollButtonIconPause: scrollButtonIconPause,
    scrollButtonIconHover: scrollButtonIconHover,
    withHover: withHover,
    countdown: countdown,
    countdownSvg: countdownSvg$1,
    countdownSvgCircle: countdownSvgCircle$1,
    hoverElements: hoverElements,
    active: active$4,
    button: button$i,
    buttonIcon: buttonIcon
};
const locales$1h = {
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    reply: "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C"
};
const t$1i = distExports$1.getTranslation && locales$1h;
const ChatMessageHoverElement = (props)=>{
    const { containerRef, isVisible, hoverActions } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.hoverElements, {
            [s$2g.active]: isVisible
        }),
        ["data-role"]: EHTMLDataRole.MESSAGE_HOVERS_CONTAINER
    }, hoverActions.includes(EChatHoverAction.DELETE_SINGLE_MESSAGE) && /* @__PURE__ */ $acw62.createElement("button", {
        className: s$2g.button,
        title: t$1i.delete,
        type: "button",
        ["data-role"]: EHTMLDataRole.DELETE_MESSAGE_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2g.buttonIcon,
        glyph: svg_name_delete
    })), hoverActions.includes(EChatHoverAction.REPLY) && /* @__PURE__ */ $acw62.createElement("button", {
        className: s$2g.button,
        type: "button",
        title: t$1i.reply,
        ["data-role"]: EHTMLDataRole.REPLY_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2g.buttonIcon,
        glyph: svg_name_reply
    })), hoverActions.includes(EChatHoverAction.THREAD) && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.button, s$2g.reply),
        type: "button",
        title: t$1i.reply,
        ["data-role"]: EHTMLDataRole.THREAD_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2g.buttonIcon,
        glyph: svg_name_thread
    })));
};
const button$h = "ChatTimeoutMenuButton-scss--module__button___5UcCx";
const icon$s = "ChatTimeoutMenuButton-scss--module__icon___JZPYm";
const dropDownButtonItem = "ChatTimeoutMenuButton-scss--module__dropDownButtonItem___aqNZV";
const s$2f = {
    button: button$h,
    icon: icon$s,
    dropDownButtonItem: dropDownButtonItem
};
const locales$1g = {
    timeout: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442",
    cancelTimeout: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0430\u0439\u043C\u0430\u0443\u0442"
};
const t$1h = distExports$1.getTranslation && locales$1g;
const ChatTimeoutMenuButton = (props)=>{
    const { authorId, ban, className } = props;
    const buttonDropdownRef = (0, $acw62.useRef)(null);
    const timeoutOptions = useChatTimeoutOptions();
    const isTimeout = (ban == null ? void 0 : ban.isTemporary) || (ban == null ? void 0 : ban.isByStream);
    const timeoutList = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, timeoutOptions.map(({ value: value2, label: label2 })=>/* @__PURE__ */ $acw62.createElement("div", {
            key: value2,
            className: s$2f.dropDownButtonItem,
            ["data-role"]: EHTMLDataRole.TIMEOUT_BUTTON,
            ["data-value"]: value2
        }, label2)));
    return isTimeout ? /* @__PURE__ */ $acw62.createElement("button", {
        ref: buttonDropdownRef,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, s$2f.button),
        ["data-role"]: EHTMLDataRole.UNBAN_BUTTON,
        ["data-author-id"]: authorId,
        ["data-by-stream"]: Boolean(ban == null ? void 0 : ban.isByStream)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2f.icon,
        glyph: svg_name_recent_outline_20
    }), " ", t$1h.cancelTimeout) : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(DropdownButton, {
        className: className,
        buttonContent: /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$2f.icon,
            glyph: svg_name_recent_outline_20
        }), " ", t$1h.timeout)
    }, timeoutList));
};
const menuWrapper = "ChatMessageMenu-scss--module__menuWrapper___iyEkd";
const menuButtonIcon = "ChatMessageMenu-scss--module__menuButtonIcon___JpIyD";
const visible = "ChatMessageMenu-scss--module__visible___CQ0p0";
const button$g = "ChatMessageMenu-scss--module__button___vh-1z";
const menuButton = "ChatMessageMenu-scss--module__menuButton___hY1sJ";
const banInfo = "ChatMessageMenu-scss--module__banInfo___JHyOz";
const s$2e = {
    menuWrapper: menuWrapper,
    menuButtonIcon: menuButtonIcon,
    visible: visible,
    button: button$g,
    menuButton: menuButton,
    "delete": "ChatMessageMenu-scss--module__delete___LiH8x",
    banInfo: banInfo
};
const locales$1f = {
    reply: "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C",
    thread: "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C",
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    pin: "\u0417\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    copy: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    unpin: "\u042D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0436\u0435 \u0437\u0430\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043E",
    ban: "\u0411\u0430\u043D",
    deleteMessages: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"
};
const t$1g = distExports$1.getTranslation && locales$1f;
const ChatMessageMenu = (props)=>{
    const { blogUrl, module: module2, elements, messageId, userId, containerRef } = props;
    const userStat = (0, $iD0SF.useSelector)(streamChatUserStatSelector);
    const pinnedMessageId = (0, $iD0SF.useSelector)(streamChatPinnedMessageId);
    const dispatch = (0, $2OPjR.useDispatch)();
    const [ban] = (userStat == null ? void 0 : userStat.bans) || [];
    const handleTimeoutEnd = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUserStat.action)({
            blogUrl: blogUrl,
            userId: userId
        }));
    };
    (0, $acw62.useEffect)(()=>{
        dispatch(streamChatUserStatReset());
        dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatUserStat.action)({
            blogUrl: blogUrl,
            userId: userId
        }));
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.menuWrapper, {
            [s$2e.visible]: elements && elements.length > 0
        }),
        ref: containerRef,
        ["data-role"]: EHTMLDataRole.MESSAGE_MENU,
        ["data-module"]: module2
    }, (elements == null ? void 0 : elements.includes(EChatAction.BAN_INFO)) && Boolean(ban) && /* @__PURE__ */ $acw62.createElement(BanInfo, {
        className: s$2e.banInfo,
        ban: ban,
        onTimeoutEnd: handleTimeoutEnd
    }), (elements == null ? void 0 : elements.includes(EChatAction.REPLY)) && /* @__PURE__ */ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.REPLY_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_arrow_uturn_left_outline_20
    }), " ", t$1g.reply), (elements == null ? void 0 : elements.includes(EChatAction.THREAD)) && /* @__PURE__ */ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.THREAD_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_thread
    }), " ", t$1g.thread), (elements == null ? void 0 : elements.includes(EChatAction.COPY)) && /* @__PURE__ */ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.COPY_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_copy_outline_28
    }), " ", t$1g.copy), (elements == null ? void 0 : elements.includes(EChatAction.PIN)) && /* @__PURE__ */ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.PIN_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_pin_outline_20
    }), " ", pinnedMessageId === messageId ? t$1g.unpin : t$1g.pin), (elements == null ? void 0 : elements.includes(EChatAction.MODERATION)) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, (elements == null ? void 0 : elements.includes(EChatAction.TIMEOUT)) && /* @__PURE__ */ $acw62.createElement(ChatTimeoutMenuButton, {
        authorId: userId,
        ban: ban
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.BAN_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_block_outline_20
    }), t$1g.ban)), (elements == null ? void 0 : elements.includes(EChatAction.DELETE_ALL_USER_MESSAGES)) && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton),
        ["data-role"]: EHTMLDataRole.DELETE_ALL_USER_MESSAGES_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_message_cross_outline_20
    }), t$1g.deleteMessages), (elements == null ? void 0 : elements.includes(EChatAction.DELETE_SINGLE_MESSAGE)) && /* @__PURE__ */ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2e.button, s$2e.menuButton, s$2e.delete),
        ["data-role"]: EHTMLDataRole.DELETE_MESSAGE_BUTTON
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$2e.menuButtonIcon,
        glyph: svg_name_delete_outline_20
    }), " ", t$1g.delete));
};
const smileTooltip = "ChatSmileTooltip-scss--module__smileTooltip___uFmh7";
const s$2d = {
    smileTooltip: smileTooltip
};
const ChatSmileTooltip = (props)=>{
    const { containerRef } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2d.smileTooltip,
        ref: containerRef
    });
};
const SLOW_MODE_VALUES = [
    0,
    3,
    10,
    30,
    60,
    120,
    300,
    600
];
const SLOW_MODE_DEFAULT_VALUE = 30;
const locales$1e = {
    chatDefaultTitle: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0447\u0430\u0442\u0430",
    chatMode: "\u0420\u0435\u0436\u0438\u043C \u0447\u0430\u0442\u0430",
    chatAvailability: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0447\u0430\u0442\u0430",
    chatSlowMode: "\u041C\u0435\u0434\u043B\u0435\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
    chatPausingMode: "\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0447\u0430\u0442\u0430",
    chatProfile: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u0447\u0430\u0442\u0430",
    chatStyle: "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0447\u0430\u0442\u0430",
    accessLevels: {
        any: "\u0427\u0430\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432\u0441\u0435\u043C",
        paid_subscribers: "\u0414\u043B\u044F \u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u0432",
        subscribers: "\u0414\u043B\u044F \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u0432"
    },
    slowmode: {
        disabled: "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D",
        default: "(\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E)"
    },
    seconds1: "\u0441\u0435\u043A\u0443\u043D\u0434\u0443",
    seconds2: "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
    seconds5: "\u0441\u0435\u043A\u0443\u043D\u0434",
    pauseTypes: {
        scroll: "\u0422\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430",
        mouseover: "\u041D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0443\u0440\u0441\u043E\u0440\u0430 \u043C\u044B\u0448\u0438",
        alt: "\u0423\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0438 Alt",
        mouseover_alt: "\u041D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0443\u0440\u0441\u043E\u0440\u0430 / Alt"
    },
    ioModes: {
        general: "\u041E\u0431\u044B\u0447\u043D\u044B\u0439",
        only_smiles: "\u0422\u043E\u043B\u044C\u043A\u043E \u0441\u043C\u0430\u0439\u043B\u044B"
    }
};
const t$1f = distExports$1.getTranslation && locales$1e;
const getSubscriptionDurationsEnumFromSeconds = (seconds)=>{
    if (seconds >= 7776000) return ESubscriptionDuration.LONGER_THAN_3_MONTHS;
    else if (seconds >= 2592000) return ESubscriptionDuration.LONGER_THAN_1_MONTH;
    else if (seconds >= 604800) return ESubscriptionDuration.LONGER_THAN_1_WEEK;
    else if (seconds >= 86400) return ESubscriptionDuration.LONGER_THAN_1_DAY;
    else if (seconds >= 3600) return ESubscriptionDuration.LONGER_THAN_1_HOUR;
    else if (seconds >= 1800) return ESubscriptionDuration.LONGER_THAN_30_MINUTES;
    else if (seconds >= 600) return ESubscriptionDuration.LONGER_THAN_10_MINUTES;
    else return ESubscriptionDuration.LONGER_THAN_0_MINUTES;
};
const getSubscriptionDurationInSeconds = (subscriptionDuration)=>{
    return ({
        [ESubscriptionDuration.LONGER_THAN_0_MINUTES]: 0,
        [ESubscriptionDuration.LONGER_THAN_10_MINUTES]: 600,
        [ESubscriptionDuration.LONGER_THAN_30_MINUTES]: 1800,
        [ESubscriptionDuration.LONGER_THAN_1_HOUR]: 3600,
        [ESubscriptionDuration.LONGER_THAN_1_DAY]: 86400,
        [ESubscriptionDuration.LONGER_THAN_1_WEEK]: 604800,
        [ESubscriptionDuration.LONGER_THAN_1_MONTH]: 2592000,
        [ESubscriptionDuration.LONGER_THAN_3_MONTHS]: 7776000
    })[subscriptionDuration];
};
const getChatAccessLevelTitle = (accessLevel)=>{
    return t$1f.accessLevels[accessLevel];
};
const getSlowmodeTitle = (slowmodeValue)=>{
    let title2 = slowmodeValue === 0 ? t$1f.slowmode.disabled : `${slowmodeValue} ${declOfNum([
        t$1f.seconds1,
        t$1f.seconds2,
        t$1f.seconds5
    ], slowmodeValue)}`;
    if (slowmodeValue === SLOW_MODE_DEFAULT_VALUE) title2 += ` ${t$1f.slowmode.default}`;
    return title2;
};
const getPauseTypeTitle = (type)=>{
    return t$1f.pauseTypes[type];
};
const getIOModeTitle = (mode2)=>{
    return t$1f.ioModes[mode2];
};
const t$1e = distExports$1.getTranslation && locales$1e;
const useChatSettings = (props)=>{
    const { isModerationDisabled } = props ?? {};
    const [mode2, setMode] = (0, $acw62.useState)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { blogUrl } = useStreamIdentity();
    const isSlowmodeSettingsEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_SLOWMODE_SETTINGS);
    const { allowAccess: accessLevel = EChatAccessLevel.ANY, allowAccessAfter, isMessagePublishTimeVisible, anyMessageTimeout, messageTextSize, pauseType, mode: chatIOMode } = (0, $iD0SF.useSelector)(streamChatSettingsSelector);
    const { isBlogOwnerAgent: isAgent, canModerateChatChannel, isBlogOwner, isAuthorized } = useCurrentUserAccess();
    const { displayName, nickColor } = (0, $iD0SF.useSelector)(currentUserSelector) ?? {};
    const canModerateChat = isAgent || canModerateChatChannel;
    const subscriptionDuration = getSubscriptionDurationsEnumFromSeconds(allowAccessAfter);
    const saveCookieSettings = (chatSettingsFromCookies)=>{
        setStringifiedToCookies(ECookieKey.CHAT_SETTINGS, chatSettingsFromCookies, {
            expires: 3650
        });
        dispatch(updateChatSettingsFromCookies({
            chatSettingsFromCookies: chatSettingsFromCookies
        }));
    };
    const onChatMessagePublishTimeVisibilityChange = (isPublishTimeVisible)=>{
        saveCookieSettings({
            messageTextSize: messageTextSize,
            isMessagePublishTimeVisible: isPublishTimeVisible,
            pauseType: pauseType
        });
    };
    const onChatMessageTextSizeChange = (option2)=>{
        saveCookieSettings({
            messageTextSize: option2.value,
            isMessagePublishTimeVisible: isMessagePublishTimeVisible,
            pauseType: pauseType
        });
    };
    const onChatPauseTypeChange = (type)=>{
        saveCookieSettings({
            messageTextSize: messageTextSize,
            isMessagePublishTimeVisible: isMessagePublishTimeVisible,
            pauseType: type
        });
    };
    const onChatAccessSettingsChange = (chatAccessSettings)=>{
        dispatch(saveChatSettings.action({
            blogUrl: blogUrl,
            anyMessageTimeout: anyMessageTimeout,
            allowAccess: chatAccessSettings.accessLevel,
            allowAccessAfter: getSubscriptionDurationInSeconds(chatAccessSettings.subscriptionDuration)
        }));
    };
    const onChatSlomodeSettingsChange = (0, $acw62.useCallback)((timeout2)=>{
        dispatch(saveChatSettings.action({
            blogUrl: blogUrl,
            anyMessageTimeout: timeout2,
            allowAccess: accessLevel,
            allowAccessAfter: allowAccessAfter
        }));
    }, [
        blogUrl,
        accessLevel,
        allowAccessAfter
    ]);
    (0, $acw62.useCallback)(()=>{
        const url = getParametrizedUrl(URLS.CHAT, {
            blogUrl: blogUrl
        });
        window.open(url, "chat", "width=400,height=800,menu,menubar=no,toolbar=no,location=no,status=no");
    }, [
        blogUrl
    ]);
    const updateNicknameColor$1 = (0, $acw62.useCallback)(async (color2)=>{
        await dispatch((0, $7Uc0p.thunkToAction)(updateNicknameColor.action)({
            color: color2
        }));
    }, []);
    const hasChatPauseSettings = isStreamApp() && isConditionalFeatureEnable(EConditionalFeature.CHAT_PAUSE);
    const onBack = ()=>{
        setMode(null);
    };
    const elements = [
        canModerateChat && !isModerationDisabled && {
            title: t$1e.chatMode,
            state: getIOModeTitle(chatIOMode.value),
            mode: EChatSettingsMode.IO,
            onClick: ()=>setMode(EChatSettingsMode.IO)
        },
        canModerateChat && !isModerationDisabled && {
            title: t$1e.chatAvailability,
            state: getChatAccessLevelTitle(accessLevel),
            mode: EChatSettingsMode.AVAILABILITY,
            onClick: ()=>setMode(EChatSettingsMode.AVAILABILITY)
        },
        canModerateChat && !isModerationDisabled && isSlowmodeSettingsEnabled && {
            title: t$1e.chatSlowMode,
            state: getSlowmodeTitle(anyMessageTimeout),
            mode: EChatSettingsMode.SLOWING,
            onClick: ()=>setMode(EChatSettingsMode.SLOWING)
        },
        hasChatPauseSettings && {
            title: t$1e.chatPausingMode,
            state: getPauseTypeTitle(pauseType),
            mode: EChatSettingsMode.PAUSING,
            onClick: ()=>setMode(EChatSettingsMode.PAUSING)
        },
        !isBlogOwner && isAuthorized && {
            title: t$1e.chatProfile,
            mode: EChatSettingsMode.PROFILE,
            onClick: ()=>setMode(EChatSettingsMode.PROFILE)
        },
        {
            title: t$1e.chatStyle,
            mode: EChatSettingsMode.STYLE,
            onClick: ()=>setMode(EChatSettingsMode.STYLE)
        },
        false
    ].filter(Boolean);
    const getHeaderTitle = ()=>{
        const foundElement = elements.find((element)=>element.mode === mode2);
        return foundElement ? foundElement.title : t$1e.chatDefaultTitle;
    };
    const selectIOMode = (IOValue)=>{
        dispatch(saveChatSettings.action({
            blogUrl: blogUrl,
            mode: IOValue
        }));
    };
    return {
        elements: elements,
        accessLevel: accessLevel,
        subscriptionDuration: subscriptionDuration,
        messageTextSize: messageTextSize,
        isMessagePublishTimeVisible: isMessagePublishTimeVisible,
        pauseType: pauseType,
        isSlowmodeSettingsEnabled: isSlowmodeSettingsEnabled,
        anyMessageTimeout: anyMessageTimeout,
        mode: mode2,
        canModerateChat: canModerateChat,
        hasChatPauseSettings: hasChatPauseSettings,
        displayName: displayName,
        nickColor: nickColor,
        chatIOMode: chatIOMode,
        selectIOMode: selectIOMode,
        onBack: onBack,
        getHeaderTitle: getHeaderTitle,
        onChatAccessSettingsChange: onChatAccessSettingsChange,
        onChatSlomodeSettingsChange: onChatSlomodeSettingsChange,
        onChatMessagePublishTimeVisibilityChange: onChatMessagePublishTimeVisibilityChange,
        onChatMessageTextSizeChange: onChatMessageTextSizeChange,
        onChatPauseTypeChange: onChatPauseTypeChange,
        updateNicknameColor: updateNicknameColor$1
    };
};
let fetchRaidStateTimer = null;
const useRaid = (params)=>{
    const { streamViewiers, blogUrl, isDisabled: isDisabled2 } = params;
    const prevBlogUrl = usePrevious(blogUrl);
    const store2 = (0, $4TSkt.useStore)();
    const hasStreamRaid = isConditionalFeatureEnable(EConditionalFeature.STREAM_RAID);
    const { stream: { raidTransitionMaxDelay } } = getConfig();
    const dispatch = (0, $2OPjR.useDispatch)();
    const streamRaid = (0, $iD0SF.useSelector)(streamRaidSelector);
    (0, $acw62.useEffect)(()=>{
        if (isDisabled2) return;
        if (hasStreamRaid && (streamRaid == null ? void 0 : streamRaid.status) === ERaidStatus.STARTED && (streamRaid == null ? void 0 : streamRaid.ownerBlogUrl) === blogUrl) {
            if (raidTransitionMaxDelay) {
                window.clearTimeout(fetchRaidStateTimer);
                fetchRaidStateTimer = window.setTimeout(fetchRaidUserState$1, getRequestWithViewersDelay(streamViewiers, raidTransitionMaxDelay));
            } else fetchRaidUserState$1();
        }
    }, [
        streamRaid,
        blogUrl,
        isDisabled2
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!prevBlogUrl && blogUrl && !isDisabled2) dispatch((0, $7Uc0p.thunkToAction)(fetchStreamRaid.action)({
            blogUrl: blogUrl
        }));
    }, [
        prevBlogUrl,
        blogUrl,
        isDisabled2
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            window.clearTimeout(fetchRaidStateTimer);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isDisabled2) return noop$1;
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_RAID_STATUS,
            handler: ({ data })=>{
                var _a3, _b2;
                const { data: { target: { blogUrl: raidTargetBlogUrl, owner: targetOwner }, owner: { owner }, viewersCount, status } } = data;
                store2.dispatch(setStreamRaid({
                    blogUrl: raidTargetBlogUrl,
                    owner: owner,
                    targetOwner: targetOwner,
                    viewersCount: viewersCount,
                    status: status,
                    ownerBlogUrl: (_b2 = (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.owner) == null ? void 0 : _b2.blogUrl
                }));
            }
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_RAID_STATUS
            });
        };
    }, []);
    const cleanStreamRaid$1 = ()=>{
        dispatch(cleanStreamRaid());
    };
    const fetchRaidUserState$1 = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchRaidUserState.action)({
            blogUrl: blogUrl
        }));
    };
    return {
        streamRaid: streamRaid,
        cleanStreamRaid: cleanStreamRaid$1,
        fetchRaidUserState: fetchRaidUserState$1
    };
};
const useChatThreadMessages = (threadId)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const blogUrl = (0, $iD0SF.useSelector)(blogUrlSelector);
    const threadMainMessage = (0, $iD0SF.useSelector)(streamChatThreadMainMessageSelector);
    const threadReplies = (0, $iD0SF.useSelector)(streamChatThreadRepliesSelector);
    const networkStatus2 = (0, $iD0SF.useSelector)(streamChatThreadMessagesNetworkStatusSelector);
    const blackListIds = (0, $iD0SF.useSelector)(blackListIdsSelector);
    const onClearThreadMessages = ()=>{
        dispatch(clearStreamChatThreadMessages());
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChatThreadMessages.action)({
            blogUrl: blogUrl,
            threadId: threadId
        }));
        return ()=>{
            onClearThreadMessages();
        };
    }, []);
    return {
        threadMainMessage: threadMainMessage,
        threadReplies: threadReplies,
        networkStatus: networkStatus2,
        blackListIds: blackListIds,
        onClearThreadMessages: onClearThreadMessages
    };
};
const useMessageAuthorStatVisibilityReset = (props)=>{
    const { isOpenedUserStat, currentUserStatMessageIdRef } = props;
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        if (!isOpenedUserStat) window.setTimeout(()=>{
            if (mounted) currentUserStatMessageIdRef.current = null;
        }, 0);
        return ()=>{
            mounted = false;
        };
    }, [
        isOpenedUserStat
    ]);
};
const CHAT_BOT_NICK_NAME = "ChatBot";
const USER_POPUP_MARGINS = {
    left: 15,
    top: 15,
    bottom: 15,
    verticalGap: 10
};
const SMILE_INFO_PADDING = 12;
const CONTAINER_MIN_HEIGHT = 400;
const PUBLISHER_MIN_HEIGHT = 52;
const getStreamChatMessageByMessageId = (state, messageId)=>{
    if (isNil(messageId)) return null;
    const streamChatMessages = streamChatMessagesSelector(state);
    const streamChatFromWebSocket = streamChatMessagesFromWSSelector(state);
    const message2 = [
        ...streamChatMessages,
        ...streamChatFromWebSocket
    ].find((messageElement)=>messageElement.id === messageId);
    return isChatUserMessage(message2) && message2;
};
const getRecordChatMessageByMessageId = (state, messageId)=>{
    if (isNil(messageId)) return null;
    const recordChatMessages = recordChatDataSelector(state);
    const message2 = recordChatMessages.find((messageElement)=>messageElement.id === messageId);
    return isChatUserMessage(message2) && message2;
};
const getMessageId = (target2)=>{
    return target2 ? Number(target2.dataset.messageId) : null;
};
const getClosestRoleAndDataset = (target2)=>{
    const closestElementWithRole = target2.closest("[data-role]");
    return {
        role: closestElementWithRole == null ? void 0 : closestElementWithRole.dataset.role,
        dataset: closestElementWithRole == null ? void 0 : closestElementWithRole.dataset
    };
};
const getHoverActions = (params)=>{
    const { message: message2, streamerId, currentUserId, canAdministrateChannel, canModerateChatChannel } = params;
    const isAuthorOwner = streamerId === message2.author.id;
    const isCurrentUserOwner = streamerId === currentUserId;
    const isChatBotMessage = message2.author.nick === CHAT_BOT_NICK_NAME;
    const shouldShowDelete = isCurrentUserOwner || canAdministrateChannel || canModerateChatChannel && !isAuthorOwner;
    const shouldShowThread = Boolean(message2.parent || message2.threadId);
    const shouldShowReply = !shouldShowThread && !isChatBotMessage;
    return [
        shouldShowDelete && EChatHoverAction.DELETE_SINGLE_MESSAGE,
        shouldShowThread && EChatHoverAction.THREAD,
        shouldShowReply && EChatHoverAction.REPLY
    ].filter(Boolean);
};
var toggleSelection = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active2 = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active2.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active2.blur();
            break;
        default:
            active2 = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range2) {
            selection.addRange(range2);
        });
        active2 && active2.focus();
    };
};
var deselectCurrent = toggleSelection;
var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message2) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message2.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text2, options) {
    var debug, message2, reselectPrevious, range2, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = deselectCurrent();
        range2 = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text2;
        mark.style.all = "unset";
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        mark.style.whiteSpace = "pre";
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e2) {
            e2.stopPropagation();
            if (options.format) {
                e2.preventDefault();
                if (typeof e2.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format2 = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format2, text2);
                } else {
                    e2.clipboardData.clearData();
                    e2.clipboardData.setData(options.format, text2);
                }
            }
            if (options.onCopy) {
                e2.preventDefault();
                options.onCopy(e2.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range2.selectNodeContents(mark);
        selection.addRange(range2);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text2);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err2) {
            debug && console.error("unable to copy using clipboardData: ", err2);
            debug && console.error("falling back to prompt");
            message2 = format("message" in options ? options.message : defaultMessage);
            window.prompt(message2, text2);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range2);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
var copyToClipboard = copy;
const copy$1 = /* @__PURE__ */ getDefaultExportFromCjs(copyToClipboard);
const useCopyClick = (props)=>{
    const { closeMenu } = props;
    const getSmileDataFromHTML = (value2)=>{
        return value2.replace(/(<img(.*?)alt="(.*?)"(.*?)>)/g, "$3 ").trim();
    };
    const getMentionDataFromHTML = (value2)=>{
        return value2.replace(/(<p(.*?)data-mention-id="(.*?)"(.*?)>(.*?)<\/p>)/g, '@"$5"|$3 ').trim();
    };
    return (target2, messageId)=>{
        const markup2 = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_MENU}]`).parentNode.querySelector(`[data-message-id="${messageId}"] [data-role=${EHTMLDataRole.MESSAGE_MAIN_CONTENT}] [data-role=${EHTMLDataRole.MARKUP}]`);
        const text2 = getMentionDataFromHTML(getSmileDataFromHTML(markup2.innerHTML));
        copy$1(text2);
        closeMenu();
    };
};
const useAuthorClick = (props)=>{
    const { currentUserStatMessageIdRef, addMentionRef, isOnlyRecordChatMode, closeMenu, onAuthorClick } = props;
    const { chat: { messageAuthorDoubleClickDelay } } = getConfig();
    const authorClickTimeoutRef = (0, $acw62.useRef)(null);
    return (message2, rootMsgRect)=>{
        var _a3;
        const { author: author2, id: messageId } = message2;
        if (author2.nick === CHAT_BOT_NICK_NAME) return;
        if (authorClickTimeoutRef.current && addMentionRef && !isOnlyRecordChatMode) {
            clearTimeout(authorClickTimeoutRef.current);
            authorClickTimeoutRef.current = null;
            (_a3 = addMentionRef.current) == null || _a3.call(addMentionRef, {
                user: author2
            });
            return;
        }
        authorClickTimeoutRef.current = setTimeout(()=>{
            authorClickTimeoutRef.current = null;
            closeMenu();
            if (currentUserStatMessageIdRef.current === message2.id) return;
            currentUserStatMessageIdRef.current = messageId;
            onAuthorClick(author2, messageId, rootMsgRect);
        }, messageAuthorDoubleClickDelay);
    };
};
const useMentionClick = (props)=>{
    const { isMentionHandlerEnabled, onMentionClick } = props;
    const store2 = (0, $4TSkt.useStore)();
    return (event2, message2, rootMsgRect)=>{
        const dataset = event2.target.dataset;
        const currentUserId = currentUserIdSelector(store2.getState());
        if (isMentionHandlerEnabled && isMentionInteractive({
            id: Number(dataset.id)
        }, currentUserId)) {
            event2.stopPropagation();
            onMentionClick(Number(dataset.mentionId), rootMsgRect);
        }
    };
};
const useMessageDeleteClick = (props)=>{
    const { closeMenu, onMessageDelete } = props;
    return (message2)=>{
        onMessageDelete(message2.id);
        closeMenu();
    };
};
const useMessagesDeleteClick = (props)=>{
    const { blogUrl } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    return (message2)=>{
        dispatch((0, $7Uc0p.thunkToAction)(cleanStreamChatMessages.action)({
            blogUrl: blogUrl,
            userId: message2.author.id
        }));
    };
};
const useBanCancelClick = (props)=>{
    const { onBanCancel, blogUrl } = props;
    return async (message2)=>{
        const result2 = await Api$1.blogPostChat.fetchBanStat(blogUrl, message2.author.id);
        const isByStream = result2.data.bans.some((item2)=>item2.isByStream);
        onBanCancel(message2.author.id, isByStream);
    };
};
const useReplyClick = (props)=>{
    const { closeMenu, onReplyClick } = props;
    return (message2)=>{
        onReplyClick(message2.author, message2.id, message2.data);
        closeMenu();
    };
};
const useTimeoutClick = (props)=>{
    const { onTimeout } = props;
    return (dataset, message2)=>{
        const period = dataset.value;
        onTimeout(message2.author.id, period);
    };
};
const usePinnedClick = (props)=>{
    const { closeMenu, onPinnedClick } = props;
    return (message2)=>{
        onPinnedClick(message2.id);
        closeMenu();
    };
};
const useBanClick = (props)=>{
    const { onBan } = props;
    return (message2)=>{
        onBan(message2.author.id);
    };
};
const useThreadClick = (props)=>{
    const { closeMenu, onThreadClick } = props;
    return (message2)=>{
        onThreadClick(message2.author, message2.id, message2.threadId);
        closeMenu();
    };
};
const useSmileClick = (props)=>{
    const { onSmileClick } = props;
    return (event2, dataset)=>{
        onSmileClick(dataset.id, event2.target, dataset.uniqueId);
    };
};
const getActions = (state, message2, isMobile2, isOnlyRecordChatMode, canAdministrateChannel, canModerateChatChannel)=>{
    const streamerId = streamerIdSelector(state);
    const userStat = streamChatUserStatSelector(state);
    const currentUserId = currentUserIdSelector(state);
    const isAdmin = currentUserIsAdminSelector(state);
    const isAdminModerator = currentUserIsModeratorSelector(state);
    const isPinnedMessagesEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_PINNED_MESSAGES);
    const [ban] = (userStat == null ? void 0 : userStat.bans) || [];
    const isAuthorChatModerator = userStat == null ? void 0 : userStat.user.isChatModerator;
    const isAuthorOwner = streamerId === message2.author.id;
    const isAuthorCurrentUser = message2.author.id === currentUserId;
    const isCurrentUserOwner = streamerId === currentUserId;
    const isChatBotMessage = message2.author.nick === CHAT_BOT_NICK_NAME;
    const isCurrentUserCanSuspendMessageAuthor = isCurrentUserOwner || canAdministrateChannel || canModerateChatChannel && !isAuthorChatModerator;
    const isMessageCanBeModerated = !isAuthorOwner && !isAuthorCurrentUser && !isChatBotMessage;
    const isUserHaveModerationRights = isCurrentUserOwner || canModerateChatChannel;
    const isUserHaveAdminRights = isAdmin || isAdminModerator;
    const shouldShowBanInfo = Boolean(ban);
    const shouldShowModerationButtons = isCurrentUserCanSuspendMessageAuthor && isMessageCanBeModerated;
    const shouldShowDeleteMessages = isUserHaveModerationRights && isMessageCanBeModerated && !isOnlyRecordChatMode;
    const shouldShowDelete = isCurrentUserOwner || canAdministrateChannel || canModerateChatChannel && !isAuthorOwner && !isOnlyRecordChatMode;
    const shouldShowThread = Boolean(message2.parent || message2.threadId) && !isOnlyRecordChatMode;
    const shouldShowReply = !shouldShowThread && !isChatBotMessage && !isOnlyRecordChatMode;
    const shouldShowPin = !isMobile2 && isPinnedMessagesEnabled && (isUserHaveModerationRights || isUserHaveAdminRights) && !isChatBotMessage && !isOnlyRecordChatMode;
    const shouldShowCopy = !isChatBotMessage;
    const shouldShowTimeoutButton = shouldShowModerationButtons && !isOnlyRecordChatMode;
    return [
        shouldShowBanInfo && EChatAction.BAN_INFO,
        shouldShowModerationButtons && EChatAction.MODERATION,
        shouldShowDeleteMessages && EChatAction.DELETE_ALL_USER_MESSAGES,
        shouldShowDelete && EChatAction.DELETE_SINGLE_MESSAGE,
        shouldShowThread && EChatAction.THREAD,
        shouldShowReply && EChatAction.REPLY,
        shouldShowPin && EChatAction.PIN,
        shouldShowCopy && EChatAction.COPY,
        shouldShowTimeoutButton && EChatAction.TIMEOUT
    ].filter(Boolean);
};
const useContextMenu = (props)=>{
    const { module: module2, isOnlyRecordChatMode, menuData, menuRef, setMenuData, onContextMenuOpen } = props;
    const { canAdministrateChannel, canModerateChatChannel } = useCurrentUserAccess();
    const { isMobile: isMobile2 } = getConfig();
    const store2 = (0, $4TSkt.useStore)();
    const closeMenu = (0, $acw62.useCallback)(()=>{
        setMenuData((prevState)=>{
            prevState == null || prevState.cleanupCalculations();
            prevState == null || prevState.cleanupMessageStyle();
            return null;
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onPressEscape = (event2)=>{
            if (event2.key === EKeyboardKey.ESCAPE) closeMenu();
        };
        const handleClick = (event2)=>{
            var _a3;
            const target2 = event2.target;
            const menu2 = document.querySelector(`[data-role=${EHTMLDataRole.MESSAGE_MENU}][data-module=${module2}]`);
            const isClickedInCurrentMenuZone = (_a3 = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`)) == null ? void 0 : _a3.contains(menu2);
            if (isClickedInCurrentMenuZone) return;
            closeMenu();
        };
        window.addEventListener("keydown", onPressEscape);
        window.addEventListener("click", handleClick);
        return ()=>{
            window.removeEventListener("keydown", onPressEscape);
            window.removeEventListener("click", handleClick);
        };
    }, [
        closeMenu
    ]);
    const shouldOpenSystemContextMenu = (target2)=>{
        var _a3;
        const isLinkTarget = target2.nodeName === "A";
        const selection = window.getSelection();
        const hasSelection = selection.toString().length > 0 && Boolean((_a3 = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`)) == null ? void 0 : _a3.contains(selection.focusNode));
        return isLinkTarget || hasSelection;
    };
    const handleContextMenuOpen = (message2, rootElement)=>{
        var _a3;
        const state = store2.getState();
        if (!menuData) {
            const elements = getActions(state, message2, isMobile2, isOnlyRecordChatMode, canAdministrateChannel, canModerateChatChannel);
            rootElement.classList.add("menuBody");
            const cleanupMessageStyle = ()=>{
                rootElement.classList.remove("menuBody");
            };
            const cleanupCalculations = autoUpdate(rootElement, menuRef.current, ()=>{
                computePosition(rootElement, menuRef.current, {
                    placement: EFloatingItemPlacement.BOTTOM,
                    middleware: [
                        offset$1(6),
                        flip()
                    ]
                }).then(({ x: x2, y: y2 })=>{
                    Object.assign(menuRef.current.style, {
                        left: `${x2}px`,
                        top: `${y2}px`
                    });
                });
            });
            setMenuData({
                messageId: message2.id,
                elements: elements,
                authorId: (_a3 = message2 == null ? void 0 : message2.author) == null ? void 0 : _a3.id,
                cleanupCalculations: cleanupCalculations,
                cleanupMessageStyle: cleanupMessageStyle
            });
            onContextMenuOpen(message2.author, message2.id);
        } else closeMenu();
    };
    return {
        onContextMenuOpen: handleContextMenuOpen,
        shouldOpenSystemContextMenu: shouldOpenSystemContextMenu,
        closeMenu: closeMenu
    };
};
const useMouseOver = (props)=>{
    const { setMessageNode, blogUrl, isOnlyRecordChatMode, smileTooltipRef } = props;
    const store2 = (0, $4TSkt.useStore)();
    const [, setCleanupFnc] = (0, $acw62.useState)();
    return (event2)=>{
        const target2 = event2.target;
        const rootMessageElement = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`);
        const isHoverContainerHovered = !rootMessageElement && Boolean(target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_HOVERS_CONTAINER}]`));
        const result2 = rootMessageElement ?? null;
        if (result2 && !result2.dataset.hoverActions) {
            const state = store2.getState();
            const streamerId = streamerIdSelector(state);
            const currentUser2 = currentUserSelector(state);
            const canAdministrateChannel = currentUserCanAdministrateChannel(currentUser2, blogUrl);
            const canModerateChatChannel = currentUserCanModerateChatChannel(currentUser2, blogUrl);
            const message2 = isOnlyRecordChatMode ? getRecordChatMessageByMessageId(state, getMessageId(rootMessageElement)) : getStreamChatMessageByMessageId(state, getMessageId(rootMessageElement));
            const hoverActions = getHoverActions({
                currentUserId: currentUser2 == null ? void 0 : currentUser2.id,
                message: message2,
                streamerId: streamerId,
                canAdministrateChannel: canAdministrateChannel,
                canModerateChatChannel: canModerateChatChannel
            });
            result2.dataset.hoverActions = hoverActions.join(",");
            if (message2.isPrivate) result2.dataset.isPrivate = "true";
        }
        setMessageNode((prevState)=>{
            if (prevState === result2 || isHoverContainerHovered) return prevState;
            return result2;
        });
        if (target2.dataset.type === "smile") {
            const cleanup = autoUpdate(target2, smileTooltipRef.current, ()=>{
                computePosition(target2, smileTooltipRef.current, {
                    placement: "top",
                    middleware: [
                        flip({
                            padding: 5
                        }),
                        offset$1(5),
                        shift({
                            padding: 15
                        })
                    ]
                }).then(({ x: x2, y: y2 })=>{
                    Object.assign(smileTooltipRef.current.style, {
                        left: `${x2}px`,
                        top: `${y2}px`,
                        display: "block"
                    });
                });
            });
            setCleanupFnc((prevState)=>{
                if (prevState) prevState();
                return cleanup;
            });
            smileTooltipRef.current.innerHTML = target2.getAttribute("alt");
            return;
        }
        setCleanupFnc((prevState)=>{
            if (prevState) prevState();
            return null;
        });
        Object.assign(smileTooltipRef.current.style, {
            left: `${0}px`,
            top: `${0}px`,
            display: "none"
        });
    };
};
const useMouseLeave = (props)=>{
    const { setMessageNode } = props;
    return ()=>{
        setMessageNode(null);
    };
};
const useMessageCallbacks = (props)=>{
    const { isOnlyRecordChatMode, messageNode, menuData } = props;
    const store2 = (0, $4TSkt.useStore)();
    const { onContextMenuOpen: handleContextMenu, shouldOpenSystemContextMenu, closeMenu } = useContextMenu(props);
    const handleAuthorClick = useAuthorClick({
        ...props,
        closeMenu: closeMenu
    });
    const handleCopyClick = useCopyClick({
        closeMenu: closeMenu
    });
    const handleMentionClick = useMentionClick(props);
    const handleMessageDeleteClick = useMessageDeleteClick({
        ...props,
        closeMenu: closeMenu
    });
    const handleMessagesDeleteClick = useMessagesDeleteClick(props);
    const handleReplyClick = useReplyClick({
        ...props,
        closeMenu: closeMenu
    });
    const handleBanCancelClick = useBanCancelClick(props);
    const handleTimeoutClick = useTimeoutClick(props);
    const handleSmileClick = useSmileClick(props);
    const handleThreadClick = useThreadClick({
        ...props,
        closeMenu: closeMenu
    });
    const handleBanClick = useBanClick(props);
    const handlePinnedClick = usePinnedClick({
        ...props,
        closeMenu: closeMenu
    });
    const onMouseOver = useMouseOver(props);
    const onMouseLeave = useMouseLeave(props);
    const onClickSuperHandler = (event2)=>{
        const state = store2.getState();
        const target2 = event2.target;
        const rootMessageElement = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`);
        const getMessageByMessageId = isOnlyRecordChatMode ? getRecordChatMessageByMessageId : getStreamChatMessageByMessageId;
        const messageId = getMessageId(rootMessageElement ? rootMessageElement : messageNode) || (menuData == null ? void 0 : menuData.messageId);
        const message2 = getMessageByMessageId(state, messageId);
        if (!message2) return;
        const { role: role2, dataset } = getClosestRoleAndDataset(target2);
        if (isOnlyRecordChatMode) {
            if (role2 === EHTMLDataRole.MESSAGE_AUTHOR) {
                event2.stopPropagation();
                handleAuthorClick(message2, rootMessageElement.getBoundingClientRect());
            }
            if (role2 === EHTMLDataRole.MESSAGE_MENTION_CONTENT) {
                event2.stopPropagation();
                handleMentionClick(event2, message2, rootMessageElement.getBoundingClientRect());
            }
            return;
        }
        switch(role2){
            case EHTMLDataRole.MESSAGE_SMILE_CONTENT:
                handleSmileClick(event2, dataset);
                break;
            case EHTMLDataRole.MESSAGE_MENTION_CONTENT:
                handleMentionClick(event2, message2, rootMessageElement.getBoundingClientRect());
                break;
            case EHTMLDataRole.MESSAGE_AUTHOR:
                event2.stopPropagation();
                handleAuthorClick(message2, rootMessageElement.getBoundingClientRect());
                break;
            case EHTMLDataRole.MESSAGE_PARENT_MESSAGE:
            case EHTMLDataRole.THREAD_BUTTON:
                handleThreadClick(message2);
                break;
            case EHTMLDataRole.PIN_BUTTON:
                handlePinnedClick(message2);
                break;
            case EHTMLDataRole.BAN_BUTTON:
                handleBanClick(message2);
                break;
            case EHTMLDataRole.COPY_BUTTON:
                handleCopyClick(target2, message2.id);
                break;
            case EHTMLDataRole.REPLY_BUTTON:
                handleReplyClick(message2);
                break;
            case EHTMLDataRole.TIMEOUT_BUTTON:
                handleTimeoutClick(dataset, message2);
                break;
            case EHTMLDataRole.UNBAN_BUTTON:
                handleBanCancelClick(message2);
                break;
            case EHTMLDataRole.DELETE_MESSAGE_BUTTON:
                handleMessageDeleteClick(message2);
                break;
            case EHTMLDataRole.DELETE_ALL_USER_MESSAGES_BUTTON:
                handleMessagesDeleteClick(message2);
                break;
        }
    };
    const onContextMenuSuperHandler = (event2)=>{
        const state = store2.getState();
        const target2 = event2.target;
        const rootMessageElement = target2.closest(`[data-role=${EHTMLDataRole.MESSAGE_CONTAINER}]`);
        const message2 = getStreamChatMessageByMessageId(state, getMessageId(rootMessageElement));
        if (!message2 || shouldOpenSystemContextMenu(target2)) {
            closeMenu();
            return;
        }
        event2.preventDefault();
        handleContextMenu(message2, rootMessageElement);
    };
    return {
        onClickSuperHandler: onClickSuperHandler,
        onContextMenuSuperHandler: onContextMenuSuperHandler,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    };
};
const SCROLL_GAP = 25;
const CHAT_PAUSE_MOUSEOVER_TIMEOUT = 5e3;
var EChatPauseActionType = /* @__PURE__ */ ((EChatPauseActionType2)=>{
    EChatPauseActionType2["SCROLL"] = "scroll";
    EChatPauseActionType2["ALT"] = "alt";
    EChatPauseActionType2["MOUSEOVER"] = "mouseover";
    return EChatPauseActionType2;
})(EChatPauseActionType || {});
const usePause = (params)=>{
    const { hasReachedBottom, pauseType, scrollToBottom, setHasReachedBottom } = params;
    const { isMobile: isMobile2 } = getConfig();
    const pauseTimerRef = (0, $acw62.useRef)(null);
    const [isAltPressed, setIsAltPressed] = (0, $acw62.useState)(false);
    const [pausedBy, setPausedBy] = (0, $acw62.useState)(null);
    const isMouseOnElementRef = (0, $acw62.useRef)(false);
    const isChatPausingEnabled = !isMobile2 && isConditionalFeatureEnable(EConditionalFeature.CHAT_PAUSE);
    const isPauseByAltEnabled = isChatPausingEnabled && (pauseType === EChatPauseType.ALT || pauseType === EChatPauseType.MOUSEOVER_ALT);
    const isPauseByMouseoverEnabled = isChatPausingEnabled && (pauseType === EChatPauseType.MOUSEOVER || pauseType === EChatPauseType.MOUSEOVER_ALT);
    const pauseByEvent = (type)=>{
        setHasReachedBottom(false);
        setPausedBy(type);
    };
    const resumeByEvent = ()=>{
        scrollToBottom();
        setPausedBy(null);
    };
    const onMouseOver = ()=>{
        if (isPauseByMouseoverEnabled && pausedBy === null && !isMouseOnElementRef.current) {
            window.clearTimeout(pauseTimerRef.current);
            pauseTimerRef.current = window.setTimeout(()=>{
                pauseTimerRef.current = null;
                resumeByEvent();
            }, CHAT_PAUSE_MOUSEOVER_TIMEOUT);
            isMouseOnElementRef.current = true;
            pauseByEvent(EChatPauseActionType.MOUSEOVER);
        }
    };
    const onMouseLeave = ()=>{
        if (isPauseByMouseoverEnabled && isMouseOnElementRef.current) {
            if (pausedBy === EChatPauseActionType.MOUSEOVER) {
                window.clearTimeout(pauseTimerRef.current);
                pauseTimerRef.current = null;
                resumeByEvent();
            }
            isMouseOnElementRef.current = false;
        }
    };
    const handleBottomButtonClick = ()=>{
        if (pausedBy === EChatPauseActionType.MOUSEOVER) {
            window.clearTimeout(pauseTimerRef.current);
            pauseTimerRef.current = null;
        }
        resumeByEvent();
    };
    const shouldShowScrollPauseButton = !hasReachedBottom && pausedBy === EChatPauseActionType.SCROLL;
    const shouldShowAltPauseButton = !hasReachedBottom && pausedBy === EChatPauseActionType.ALT;
    const shouldShowMouseoverPauseButton = !hasReachedBottom && pausedBy === EChatPauseActionType.MOUSEOVER;
    (0, $acw62.useEffect)(()=>{
        if (!isPauseByAltEnabled) return noop$2;
        const handleKeyDown = (event2)=>{
            if (event2.key === EKeyboardKey.ALT) {
                event2.preventDefault();
                setIsAltPressed(true);
                if (pausedBy === null && !isAltPressed) pauseByEvent(EChatPauseActionType.ALT);
            }
        };
        const handleKeyUp = (event2)=>{
            if (event2.key === EKeyboardKey.ALT) {
                event2.preventDefault();
                setIsAltPressed(false);
                if (pausedBy === EChatPauseActionType.ALT || !pausedBy) resumeByEvent();
            }
        };
        window.addEventListener("keydown", handleKeyDown, true);
        window.addEventListener("keyup", handleKeyUp, true);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown, true);
            window.removeEventListener("keyup", handleKeyUp, true);
        };
    }, [
        isPauseByAltEnabled,
        pausedBy,
        isAltPressed
    ]);
    return {
        shouldShowScrollPauseButton: shouldShowScrollPauseButton,
        shouldShowAltPauseButton: shouldShowAltPauseButton,
        shouldShowMouseoverPauseButton: shouldShowMouseoverPauseButton,
        pausedBy: pausedBy,
        pauseTimerRef: pauseTimerRef,
        setPausedBy: setPausedBy,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        handleBottomButtonClick: handleBottomButtonClick
    };
};
const useScroll = (params)=>{
    const { blogUrl, listRef, boxRef, isAuthorized, currentUserId, pauseType, isOnlyRecordChatMode } = params;
    const [hasReachedBottom, setHasReachedBottom] = (0, $acw62.useState)(false);
    const isFirstRenderRef = (0, $acw62.useRef)(true);
    const scrollToBottom = (0, $acw62.useCallback)(()=>{
        var _a3;
        const lastChild = (_a3 = listRef.current) == null ? void 0 : _a3.lastChild;
        if (lastChild) {
            lastChild.scrollIntoView({
                block: "nearest"
            });
            setHasReachedBottom(true);
        }
    }, []);
    const { pausedBy, pauseTimerRef, setPausedBy, ...pauseParams } = usePause({
        hasReachedBottom: hasReachedBottom,
        pauseType: pauseType,
        scrollToBottom: scrollToBottom,
        setHasReachedBottom: setHasReachedBottom
    });
    const handleScroll = throttle((event2)=>{
        const { clientHeight, scrollHeight, scrollTop } = event2.target;
        if (!clientHeight || Math.ceil(scrollHeight - scrollTop) <= Math.ceil(clientHeight) + SCROLL_GAP) {
            setHasReachedBottom(true);
            setPausedBy(null);
            return;
        }
        if (pauseTimerRef.current) {
            window.clearTimeout(pauseTimerRef.current);
            pauseTimerRef.current = null;
        }
        setHasReachedBottom(false);
        setPausedBy(EChatPauseActionType.SCROLL);
    }, 100);
    (0, $acw62.useEffect)(()=>{
        if (hasReachedBottom) setPausedBy(null);
    }, [
        hasReachedBottom
    ]);
    const onNewMessage = (0, $acw62.useCallback)((newMessage)=>{
        var _a3;
        const isUserTypedMessageWhileScrollPaused = !hasReachedBottom && !isOnlyRecordChatMode && isAuthorized && isChatUserMessage(newMessage) && currentUserId === ((_a3 = newMessage == null ? void 0 : newMessage.user) == null ? void 0 : _a3.id);
        if (pausedBy && !isUserTypedMessageWhileScrollPaused) return;
        scrollToBottom();
    }, [
        hasReachedBottom,
        isAuthorized,
        pausedBy,
        currentUserId
    ]);
    (0, $acw62.useEffect)(()=>{
        let raqId;
        const resetFunction = ()=>{
            isFirstRenderRef.current = true;
        };
        const raq = ()=>{
            var _a3;
            const lastChild = (_a3 = listRef.current) == null ? void 0 : _a3.lastChild;
            if (!lastChild) {
                raqId = requestAnimationFrame(raq);
                return;
            }
            const scrollContainer2 = lastChild.parentElement.parentElement;
            if (isFirstRenderRef.current && lastChild) setTimeout(()=>{
                lastChild.scrollIntoView({
                    block: "nearest"
                });
            }, 350);
            if (scrollContainer2.scrollTop) {
                isFirstRenderRef.current = false;
                return;
            }
            raqId = requestAnimationFrame(raq);
        };
        raqId = requestAnimationFrame(raq);
        setTimeout(()=>{
            cancelAnimationFrame(raqId);
        }, 1500);
        return resetFunction;
    }, [
        blogUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        let oldHeight = 0;
        const resizeHandler = (changes)=>{
            const height = changes[0].contentRect.height;
            if (height !== oldHeight) {
                oldHeight = height;
                scrollToBottom();
            }
        };
        const resizeObserver = new ResizeObserver(resizeHandler);
        resizeObserver.observe(boxRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return {
        ...pauseParams,
        hasReachedBottom: hasReachedBottom,
        handleScroll: handleScroll,
        scrollToBottom: scrollToBottom,
        setHasReachedBottom: setHasReachedBottom,
        onNewMessage: onNewMessage
    };
};
const STATIC_ARRAY$2 = [];
const useMessageHoverPosition = ()=>{
    var _a3;
    const [messageNode, setMessageNode] = (0, $acw62.useState)();
    const hoverRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!messageNode) return dist$4.noop;
        const cleanup = autoUpdate(messageNode, hoverRef.current, ()=>{
            computePosition(messageNode, hoverRef.current, {
                placement: EFloatingItemPlacement.TOP_END,
                middleware: [
                    offset$1(-6),
                    flip()
                ]
            }).then(({ x: x2, y: y2 })=>{
                Object.assign(hoverRef.current.style, {
                    left: `${x2}px`,
                    top: `${y2}px`
                });
            });
        });
        return ()=>{
            cleanup();
        };
    }, [
        messageNode
    ]);
    const hoverActions = ((_a3 = messageNode == null ? void 0 : messageNode.dataset.hoverActions) == null ? void 0 : _a3.split(",").filter(Boolean)) ?? STATIC_ARRAY$2;
    return {
        messageNode: messageNode,
        hoverRef: hoverRef,
        hoverActions: hoverActions,
        setMessageNode: setMessageNode
    };
};
const chatSettingsProps = {};
const ChatBoxBase = (props)=>{
    var _a3;
    const { currentUser: currentUser2, lastBannedMessageId, className, renderMessagesList, module: module2, blogUrl } = props;
    const listRef = (0, $acw62.useRef)(null);
    const boxRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const smileTooltipRef = (0, $acw62.useRef)(null);
    const currentUserStatMessageIdRef = (0, $acw62.useRef)(null);
    const [menuMessageData, setMenuMessageData] = (0, $acw62.useState)(null);
    const { messageTextSize, isMessagePublishTimeVisible, pauseType } = useChatSettings(chatSettingsProps);
    const { shouldShowAltPauseButton, shouldShowMouseoverPauseButton, shouldShowScrollPauseButton, handleBottomButtonClick, onMouseLeave: onScrollMouseLeave, onMouseOver: onScrollMouseOver, handleScroll, onNewMessage } = useScroll({
        ...props,
        currentUserId: currentUser2 == null ? void 0 : currentUser2.id,
        listRef: listRef,
        boxRef: boxRef,
        pauseType: pauseType
    });
    useMessageAuthorStatVisibilityReset({
        ...props,
        currentUserStatMessageIdRef: currentUserStatMessageIdRef
    });
    const { messageNode, setMessageNode, hoverRef, hoverActions } = useMessageHoverPosition();
    const { onContextMenuSuperHandler, onClickSuperHandler, onMouseLeave: onHoverMouseLeave, onMouseOver: onHoverMouseOver } = useMessageCallbacks({
        ...props,
        containerRef: boxRef,
        menuRef: menuRef,
        currentUserStatMessageIdRef: currentUserStatMessageIdRef,
        setMessageNode: setMessageNode,
        messageNode: messageNode,
        menuData: menuMessageData,
        smileTooltipRef: smileTooltipRef,
        setMenuData: setMenuMessageData
    });
    const isMenuOpen = Boolean(menuMessageData);
    const isPrivate = (_a3 = messageNode == null ? void 0 : messageNode.dataset) == null ? void 0 : _a3.isPrivate;
    const handleMouseOver = (target2)=>{
        onScrollMouseOver();
        onHoverMouseOver(target2);
    };
    const handleMouseLeave = ()=>{
        onScrollMouseLeave();
        onHoverMouseLeave();
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2g.wrapper
    }, /* @__PURE__ */ $acw62.createElement("div", {
        ref: boxRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.root, className, {
            textSizeSmall: messageTextSize === EChatMessageTextSize.SMALL,
            textSizeNormal: messageTextSize === EChatMessageTextSize.NORMAL,
            textSizeBig: messageTextSize === EChatMessageTextSize.BIG,
            textSizeExtraBig: messageTextSize === EChatMessageTextSize.EXTRA_BIG,
            textSizeLarge: messageTextSize === EChatMessageTextSize.LARGE,
            publishTimeVisible: isMessagePublishTimeVisible
        }),
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave,
        onScroll: handleScroll,
        onClick: onClickSuperHandler,
        onContextMenu: onContextMenuSuperHandler
    }, renderMessagesList(listRef, boxRef, onNewMessage, lastBannedMessageId), shouldShowScrollPauseButton && /* @__PURE__ */ $acw62.createElement("button", {
        className: s$2g.scrollButton,
        type: "button",
        onClick: handleBottomButtonClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButtonIconArrow),
        glyph: svg_name_arrow_long
    })), shouldShowAltPauseButton && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButton, s$2g.withHover),
        type: "button",
        onClick: handleBottomButtonClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButtonIconPause),
        glyph: svg_name_pause
    }), /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButtonIconArrow, s$2g.scrollButtonIconHover),
        glyph: svg_name_arrow_long
    })), shouldShowMouseoverPauseButton && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButton, s$2g.withHover),
        type: "button",
        onClick: handleBottomButtonClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButtonIconPause),
        glyph: svg_name_pause
    }), /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2g.scrollButtonIconArrow, s$2g.scrollButtonIconHover),
        glyph: svg_name_arrow_long
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2g.countdown
    }, /* @__PURE__ */ $acw62.createElement("svg", {
        className: s$2g.countdownSvg
    }, /* @__PURE__ */ $acw62.createElement("circle", {
        className: s$2g.countdownSvgCircle,
        r: "18",
        cx: "20",
        cy: "20"
    })))), /* @__PURE__ */ $acw62.createElement(ChatMessageHoverElement, {
        containerRef: hoverRef,
        isVisible: Boolean(messageNode) && !isMenuOpen && !isPrivate && hoverActions.length > 0,
        hoverActions: hoverActions
    }), /* @__PURE__ */ $acw62.createElement(ChatMessageMenu, {
        blogUrl: blogUrl,
        module: module2,
        elements: menuMessageData == null ? void 0 : menuMessageData.elements,
        userId: menuMessageData == null ? void 0 : menuMessageData.authorId,
        messageId: menuMessageData == null ? void 0 : menuMessageData.messageId,
        containerRef: menuRef
    }), /* @__PURE__ */ $acw62.createElement(ChatSmileTooltip, {
        containerRef: smileTooltipRef
    })));
};
const root$1r = "ChatSystemMessage-scss--module__root___2Ks9X";
const s$2c = {
    root: root$1r
};
const locales$1d = {
    welcome: "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u0432 \u0447\u0430\u0442",
    offline: "\u0421\u0442\u0440\u0438\u043C\u0435\u0440 \u043D\u0435 \u0432 \u0441\u0435\u0442\u0438, \u043D\u043E \u0447\u0430\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u043D\u0438\u044F",
    streamStarted: "\u0422\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044F \u043D\u0430\u0447\u0430\u043B\u0430\u0441\u044C",
    streamEnded: "\u0422\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044F \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430, \u043D\u043E \u0432 \u0447\u0430\u0442\u0435 \u043C\u043E\u0436\u043D\u043E \u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F",
    hostInProgress: "\u0418\u0434\u0435\u0442 \u0440\u0435\u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044F"
};
const t$1d = distExports$1.getTranslation && locales$1d;
const ChatSystemMessageBase = (props)=>{
    const { className, type } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$2c.root, className)
    }, t$1d[type]);
};
const ChatSystemMessage = $acw62.memo(ChatSystemMessageBase);
const scrollMarker = "MessagesList-scss--module__scrollMarker___JnGDk";
const message$3 = "MessagesList-scss--module__message___0NnrB";
const infoMessage = "MessagesList-scss--module__infoMessage___lw1Xu";
const singleMessage = "MessagesList-scss--module__singleMessage___ef3fm";
const s$2b = {
    scrollMarker: scrollMarker,
    message: message$3,
    infoMessage: infoMessage,
    singleMessage: singleMessage
};
const MessagesList = (props)=>{
    const { listRef, blogUrl, currentUserId, messages: messages2, messagesFromWebSocket = [], isSingleMessage, isOnlyMentionsMode, lastBannedMessageId, isCurrentUserBanned, hasMentionHighlight } = props;
    const renderChatSystemMessage = (message2, isFirst, key)=>{
        return /* @__PURE__ */ $acw62.createElement(ChatSystemMessage, {
            key: key,
            className: s$2b.infoMessage,
            type: message2.type
        });
    };
    const renderChatUserMessage = (message2, isFirst)=>{
        return /* @__PURE__ */ $acw62.createElement(ChatMessage, {
            key: message2.id,
            className: s$2b.message,
            isFirstMessage: isFirst,
            blogUrl: blogUrl,
            message: message2,
            isBanned: message2.id === lastBannedMessageId,
            isCurrentUserBanned: isCurrentUserBanned,
            currentUserId: currentUserId,
            hasMentionHighlight: hasMentionHighlight,
            isOnlyMentionsMode: isOnlyMentionsMode
        });
    };
    const renderMessage = (message2, index2)=>{
        const isFirst = index2 === 0;
        const isSystemMessage = isChatSystemMessage(message2);
        const key = isSystemMessage ? (message2 == null ? void 0 : message2.id) || `{${index2}-${message2.type}}` : `${message2.id}`;
        const isSingle = !hasMentionHighlight && isSingleMessage;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [s$2b.singleMessage]: isSingle
            }),
            key: key
        }, isSystemMessage && renderChatSystemMessage(message2, isFirst, key), isChatUserMessage(message2) && renderChatUserMessage(message2, isFirst));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: listRef
    }, messages2.map((message2, index2)=>{
        return renderMessage(message2, index2);
    }), messagesFromWebSocket.map((message2, index2)=>{
        return renderMessage(message2, messages2.length + index2);
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2b.scrollMarker
    }));
};
const ChatMessagesList = (props)=>{
    const { onNewMessage } = props;
    const streamChatMessages = (0, $iD0SF.useSelector)(streamChatMessagesSelector);
    const streamChatFromWebSocket = (0, $iD0SF.useSelector)(streamChatMessagesFromWSSelector);
    const lastMessage = streamChatFromWebSocket[streamChatFromWebSocket.length - 1] || streamChatMessages[streamChatMessages.length - 1];
    const isSingleMessage = streamChatMessages.length + streamChatFromWebSocket.length === 1;
    (0, $acw62.useEffect)(()=>{
        onNewMessage(lastMessage);
    }, [
        lastMessage
    ]);
    return /* @__PURE__ */ $acw62.createElement(MessagesList, {
        ...props,
        messages: streamChatMessages,
        messagesFromWebSocket: streamChatFromWebSocket,
        isSingleMessage: isSingleMessage
    });
};
const STATIC_ARRAY$1 = [];
const ChatMentionsList = (props)=>{
    const { onNewMessage } = props;
    const streamChatMentions = (0, $iD0SF.useSelector)(streamChatMentionsSelector);
    const lastMessage = streamChatMentions[streamChatMentions.length - 1];
    const isSingleMessage = streamChatMentions.length === 1;
    (0, $acw62.useEffect)(()=>{
        onNewMessage(lastMessage);
    }, [
        lastMessage
    ]);
    return /* @__PURE__ */ $acw62.createElement(MessagesList, {
        ...props,
        messages: STATIC_ARRAY$1,
        messagesFromWebSocket: streamChatMentions,
        isSingleMessage: isSingleMessage
    });
};
const STATIC_ARRAY = [];
const ChatRecordMessagesList = (props)=>{
    const { onNewMessage } = props;
    const recordChatMessages = (0, $iD0SF.useSelector)(recordChatSelector);
    const lastMessage = recordChatMessages[recordChatMessages.length - 1];
    const isSingleMessage = recordChatMessages.length === 1;
    (0, $acw62.useEffect)(()=>{
        onNewMessage(lastMessage);
    }, [
        lastMessage
    ]);
    return /* @__PURE__ */ $acw62.createElement(MessagesList, {
        ...props,
        messages: STATIC_ARRAY,
        messagesFromWebSocket: recordChatMessages,
        isSingleMessage: isSingleMessage
    });
};
const useChatMentionsBox = ()=>{
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const hasStreamChatMentions = (0, $iD0SF.useSelector)(hasStreamChatMentionsSelector);
    return {
        currentUser: currentUser2,
        hasStreamChatMentions: hasStreamChatMentions
    };
};
const welcome = "ChatMentionsBox-scss--module__welcome___4nk7o";
const s$2a = {
    welcome: welcome
};
const locales$1c = {
    welcome: "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0441 \u0443\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435\u043C \u0432\u0430\u0441 \u0438 \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0432\u044B \u0443\u043F\u043E\u043C\u044F\u043D\u0443\u043B\u0438 \u043A\u043E\u0433\u043E-\u0442\u043E"
};
const t$1c = distExports$1.getTranslation && locales$1c;
const ChatMentionsBox = (props)=>{
    const { blogUrl, isCurrentUserBanned } = props;
    const { currentUser: currentUser2, hasStreamChatMentions } = useChatMentionsBox();
    const renderMessagesList = (listRef, boxRef, onNewMessage, lastBannedMessageId)=>{
        return /* @__PURE__ */ $acw62.createElement(ChatMentionsList, {
            listRef: listRef,
            onNewMessage: onNewMessage,
            boxRef: boxRef,
            blogUrl: blogUrl,
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id,
            lastBannedMessageId: lastBannedMessageId,
            isCurrentUserBanned: isCurrentUserBanned,
            isOnlyMentionsMode: true,
            hasMentionHighlight: false
        });
    };
    if (!hasStreamChatMentions) return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2a.welcome
    }, t$1c.welcome);
    return /* @__PURE__ */ $acw62.createElement(ChatBoxBase, {
        ...props,
        isMentionHandlerEnabled: false,
        module: EChatModule.MENTIONS,
        currentUser: currentUser2,
        renderMessagesList: renderMessagesList
    });
};
const useChatMessagesBox = ()=>{
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    return {
        currentUser: currentUser2
    };
};
const ChatMessagesBox = (props)=>{
    const { blogUrl, isCurrentUserBanned } = props;
    const { currentUser: currentUser2 } = useChatMessagesBox();
    usePinnedMessage({
        blogUrl: blogUrl
    });
    const renderMessagesList = (listRef, boxRef, onNewMessage, lastBannedMessageId)=>{
        return /* @__PURE__ */ $acw62.createElement(ChatMessagesList, {
            listRef: listRef,
            boxRef: boxRef,
            blogUrl: blogUrl,
            onNewMessage: onNewMessage,
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id,
            hasMentionHighlight: true,
            lastBannedMessageId: lastBannedMessageId,
            isCurrentUserBanned: isCurrentUserBanned
        });
    };
    return /* @__PURE__ */ $acw62.createElement(ChatBoxBase, {
        ...props,
        isMentionHandlerEnabled: true,
        module: EChatModule.STREAM,
        blogUrl: blogUrl,
        currentUser: currentUser2,
        renderMessagesList: renderMessagesList
    });
};
const useChatRecordMessagesBox = ()=>{
    var _a3;
    const { blogUrl, recordId: recordIdFromUrl, videoClipId } = useParams();
    const dispatch = (0, $2OPjR.useDispatch)();
    const recordChatMessages = (0, $iD0SF.useSelector)(recordChatSelector);
    const streamerId = (0, $iD0SF.useSelector)(streamerIdSelector);
    const record2 = (0, $iD0SF.useSelector)(currentRecordSelector);
    const clip = (0, $iD0SF.useSelector)(currentVideoClipDataSelector);
    const recordId = recordIdFromUrl ?? (record2 == null ? void 0 : record2.id);
    const clipId = videoClipId ?? (clip == null ? void 0 : clip.id);
    const recordChatLeft = (0, $iD0SF.useSelector)(recordChatLeftMessagesSelector);
    const recordChatExtra = (0, $iD0SF.useSelector)(recordChatExtraSelector);
    const recordChatNetworkStatus = (0, $iD0SF.useSelector)(recordChatNetworkStatusSelector);
    const prevRecordId = usePrevious(recordId);
    const prevClipId = usePrevious(clipId);
    const { currentUser: currentUser2 } = useCurrentUserAccess();
    (0, $acw62.useEffect)(()=>{
        if (recordId !== prevRecordId || clipId !== prevClipId) dispatch(clearRecordChat());
    }, [
        recordId,
        clipId
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a4, _b2;
        if ((record2 == null ? void 0 : record2.id) !== void 0 && (record2 == null ? void 0 : record2.id) === prevRecordId && recordChatLeft.length <= RECORD_CHAT_FETCH_LIMIT / 2 && !recordChatExtra.isLast && ((_a4 = recordChatLeft[recordChatLeft.length - 1]) == null ? void 0 : _a4.id) && !recordChatNetworkStatus.isFetching) dispatch((0, $7Uc0p.thunkToAction)(fetchRecordChat.action)({
            blogUrl: blogUrl,
            recordId: recordId,
            lastMessageId: (_b2 = recordChatLeft[recordChatLeft.length - 1]) == null ? void 0 : _b2.id
        }));
    }, [
        recordChatLeft.length
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a4;
        if ((record2 == null ? void 0 : record2.id) && ((_a4 = record2 == null ? void 0 : record2.accessRestrictions) == null ? void 0 : _a4.view.allowed)) {
            const timeCode = (record2 == null ? void 0 : record2.duration) !== (record2 == null ? void 0 : record2.timeCode) ? record2 == null ? void 0 : record2.timeCode : void 0;
            dispatch((0, $7Uc0p.thunkToAction)(fetchRecordChat.action)({
                blogUrl: blogUrl,
                recordId: recordId,
                timeCode: isNumber(timeCode) && Math.trunc(timeCode)
            }));
        }
    }, [
        record2 == null ? void 0 : record2.id,
        (_a3 = record2 == null ? void 0 : record2.accessRestrictions) == null ? void 0 : _a3.view.allowed
    ]);
    (0, $acw62.useEffect)(()=>{
        if (clipId) dispatch((0, $7Uc0p.thunkToAction)(fetchClipChat.action)({
            blogUrl: blogUrl,
            videoClipId: clipId
        }));
    }, [
        clipId
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a4, _b2;
        if (clipId !== void 0 && clipId === prevClipId && recordChatLeft.length <= RECORD_CHAT_FETCH_LIMIT / 2 && !recordChatExtra.isLast && ((_a4 = recordChatLeft[recordChatLeft.length - 1]) == null ? void 0 : _a4.id) && !recordChatNetworkStatus.isFetching) dispatch((0, $7Uc0p.thunkToAction)(fetchClipChat.action)({
            blogUrl: blogUrl,
            videoClipId: clipId,
            lastMessageId: (_b2 = recordChatLeft[recordChatLeft.length - 1]) == null ? void 0 : _b2.id
        }));
    }, [
        recordChatLeft.length
    ]);
    return {
        streamerId: streamerId,
        currentUser: currentUser2,
        messages: recordChatMessages
    };
};
const ChatRecordMessagesBox = (props)=>{
    const { blogUrl, isCurrentUserBanned } = props;
    const { currentUser: currentUser2 } = useChatRecordMessagesBox();
    const renderMessagesList = (listRef, boxRef, onNewMessage, lastBannedMessageId)=>{
        return /* @__PURE__ */ $acw62.createElement(ChatRecordMessagesList, {
            listRef: listRef,
            boxRef: boxRef,
            onNewMessage: onNewMessage,
            lastBannedMessageId: lastBannedMessageId,
            blogUrl: blogUrl,
            currentUserId: currentUser2 == null ? void 0 : currentUser2.id,
            isCurrentUserBanned: isCurrentUserBanned,
            hasMentionHighlight: true
        });
    };
    return /* @__PURE__ */ $acw62.createElement(ChatBoxBase, {
        ...props,
        isMentionHandlerEnabled: true,
        module: EChatModule.RECORD,
        renderMessagesList: renderMessagesList,
        currentUser: currentUser2,
        isOnlyRecordChatMode: true
    });
};
const ChatBox = (props)=>{
    const { isOnlyMentionsMode, isOnlyRecordChatMode, ...commonProps } = props;
    if (isOnlyMentionsMode) return /* @__PURE__ */ $acw62.createElement(ChatMentionsBox, {
        ...commonProps
    });
    if (isOnlyRecordChatMode) return /* @__PURE__ */ $acw62.createElement(ChatRecordMessagesBox, {
        ...commonProps
    });
    return /* @__PURE__ */ $acw62.createElement(ChatMessagesBox, {
        ...commonProps
    });
};
const ACCESS_LEVELS = [
    EChatAccessLevel.ANY,
    EChatAccessLevel.PAID_SUBSCRIBERS,
    EChatAccessLevel.SUBSCRIBERS
];
const SUBSCRIPTION_DURATIONS = [
    ESubscriptionDuration.LONGER_THAN_0_MINUTES,
    ESubscriptionDuration.LONGER_THAN_10_MINUTES,
    ESubscriptionDuration.LONGER_THAN_30_MINUTES,
    ESubscriptionDuration.LONGER_THAN_1_HOUR,
    ESubscriptionDuration.LONGER_THAN_1_DAY,
    ESubscriptionDuration.LONGER_THAN_1_WEEK,
    ESubscriptionDuration.LONGER_THAN_1_MONTH,
    ESubscriptionDuration.LONGER_THAN_3_MONTHS
];
const locales$1b = {
    subscriptionDurations: {
        longer_than_0_minutes: "0 \u043C\u0438\u043D\u0443\u0442 (\u0432\u0441\u0435 \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u044B)",
        longer_than_10_minutes: "10 \u043C\u0438\u043D\u0443\u0442 (\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0447\u0430\u0449\u0435 \u0432\u0441\u0435\u0433\u043E)",
        longer_than_30_minutes: "30 \u043C\u0438\u043D\u0443\u0442",
        longer_than_1_hour: "1 \u0447\u0430\u0441",
        longer_than_1_day: "1 \u0434\u0435\u043D\u044C",
        longer_than_1_week: "1 \u043D\u0435\u0434\u0435\u043B\u044E",
        longer_than_1_month: "1 \u043C\u0435\u0441\u044F\u0446",
        longer_than_3_months: "3 \u043C\u0435\u0441\u044F\u0446\u0430"
    }
};
const t$1b = distExports$1.getTranslation && locales$1b;
const useChatAccessSettings = (props)=>{
    const { accessLevel, subscriptionDuration, onChange } = props;
    const [selectedAccessLevel, setSelectedAccessLevel] = (0, $acw62.useState)({
        id: accessLevel,
        label: getChatAccessLevelTitle(accessLevel),
        value: accessLevel
    });
    const [selectedSubscriptionDuration, setSelectedSubscriptionDuration] = (0, $acw62.useState)({
        id: subscriptionDuration,
        label: t$1b.subscriptionDurations[subscriptionDuration],
        value: subscriptionDuration
    });
    const handleSubscriptionDurationSelect = (option2)=>setSelectedSubscriptionDuration(option2);
    const handleAccessLevelRadioClick = (value2)=>{
        const option2 = accessLevelOptions.find((optionElement)=>optionElement.value === value2);
        setSelectedAccessLevel(option2);
    };
    const subscriptionDurationOptions = (0, $acw62.useMemo)(()=>SUBSCRIPTION_DURATIONS.map((duration2)=>({
                id: duration2,
                label: t$1b.subscriptionDurations[duration2],
                value: duration2
            })), []);
    const accessLevelOptions = (0, $acw62.useMemo)(()=>ACCESS_LEVELS.map((level)=>({
                id: level,
                label: getChatAccessLevelTitle(level),
                value: level
            })), []);
    (0, $acw62.useEffect)(()=>{
        onChange({
            accessLevel: selectedAccessLevel.value,
            subscriptionDuration: selectedSubscriptionDuration.value
        });
    }, [
        selectedAccessLevel,
        selectedSubscriptionDuration
    ]);
    return {
        selectedSubscriptionDuration: selectedSubscriptionDuration,
        selectedAccessLevel: selectedAccessLevel,
        accessLevelOptions: accessLevelOptions,
        subscriptionDurationOptions: subscriptionDurationOptions,
        handleSubscriptionDurationSelect: handleSubscriptionDurationSelect,
        handleAccessLevelRadioClick: handleAccessLevelRadioClick,
        setSelectedAccessLevel: setSelectedAccessLevel
    };
};
const root$1q = "ChatAccessSettings-scss--module__root___9Eee8";
const subscriptionDurationOption = "ChatAccessSettings-scss--module__subscriptionDurationOption___hlyEu";
const radioList$3 = "ChatAccessSettings-scss--module__radioList___avNZo";
const radioRoot$3 = "ChatAccessSettings-scss--module__radioRoot___65Seb";
const radioLabel$3 = "ChatAccessSettings-scss--module__radioLabel___AF1m-";
const durationSelect = "ChatAccessSettings-scss--module__durationSelect___aAPMA";
const s$29 = {
    root: root$1q,
    subscriptionDurationOption: subscriptionDurationOption,
    radioList: radioList$3,
    radioRoot: radioRoot$3,
    radioLabel: radioLabel$3,
    durationSelect: durationSelect
};
const ChatAccessSettingsList = (props)=>{
    const { selectedSubscriptionDuration, selectedAccessLevel, accessLevelOptions, subscriptionDurationOptions, handleAccessLevelRadioClick, handleSubscriptionDurationSelect } = useChatAccessSettings(props);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$29.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$29.radioList
    }, accessLevelOptions.map((option2)=>{
        return /* @__PURE__ */ $acw62.createElement(RadioButton, {
            classNames: {
                root: s$29.radioRoot,
                label: s$29.radioLabel
            },
            mode: ERadioButtonMode.DARK,
            value: option2.value,
            key: option2.id,
            label: option2.label,
            isChecked: selectedAccessLevel.value === option2.value,
            onRadioButtonClick: handleAccessLevelRadioClick
        });
    })), selectedAccessLevel.value === EChatAccessLevel.SUBSCRIBERS && /* @__PURE__ */ $acw62.createElement(Select, {
        options: subscriptionDurationOptions,
        selected: selectedSubscriptionDuration,
        className: s$29.durationSelect,
        classNames: {
            option: s$29.subscriptionDurationOption
        },
        onSelect: handleSubscriptionDurationSelect
    }));
};
const locales$1a = {
    noLinks: "\u0417\u0430\u043F\u0440\u0435\u0442 \u0441\u0441\u044B\u043B\u043E\u043A",
    onlyText: "\u0417\u0430\u043F\u0440\u0435\u0442 \u0441\u043F\u0435\u0446\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
    noCaps: "\u0417\u0430\u043F\u0440\u0435\u0442 \u043A\u0430\u043F\u0441\u0430"
};
const t$1a = distExports$1.getTranslation && locales$1a;
const OPTIONS_LIST = [
    {
        id: EChatIOMode.GENERAL,
        value: EChatIOMode.GENERAL,
        getLabel: ()=>getIOModeTitle(EChatIOMode.GENERAL),
        checkboxes: [
            {
                id: EChatIOCheckbox.LINKS_PROHIBITED,
                value: EChatIOCheckbox.LINKS_PROHIBITED,
                getLabel: ()=>t$1a.noLinks,
                isDefaultChecked: false
            },
            {
                id: EChatIOCheckbox.RU_EN_NUMBERS,
                value: EChatIOCheckbox.RU_EN_NUMBERS,
                getLabel: ()=>t$1a.onlyText,
                isDefaultChecked: false
            },
            {
                id: EChatIOCheckbox.CAPS_PROHIBITED,
                value: EChatIOCheckbox.CAPS_PROHIBITED,
                getLabel: ()=>t$1a.noCaps,
                isDefaultChecked: false
            }
        ]
    },
    {
        id: EChatIOMode.ONLY_SMILES,
        value: EChatIOMode.ONLY_SMILES,
        getLabel: ()=>getIOModeTitle(EChatIOMode.ONLY_SMILES)
    }
];
const useChatIOSettings = (props)=>{
    const { data, selectData } = props;
    const onToggleCheckbox = (element, checked2)=>{
        const newParameters = checked2 ? [
            ...data.parameters,
            element.value
        ] : data.parameters.filter((param)=>param !== element.value);
        selectData({
            ...data,
            parameters: newParameters
        });
    };
    const onRadioButtonClick = (element)=>{
        var _a3, _b2;
        const parameters = ((_b2 = (_a3 = element.checkboxes) == null ? void 0 : _a3.map((box)=>{
            return box.isDefaultChecked && box.value;
        })) == null ? void 0 : _b2.filter(Boolean)) ?? [];
        selectData({
            value: element.value,
            parameters: parameters
        });
    };
    return {
        onToggleCheckbox: onToggleCheckbox,
        onRadioButtonClick: onRadioButtonClick
    };
};
const radioList$2 = "ChatIOSettings-scss--module__radioList___AEEn2";
const radioRoot$2 = "ChatIOSettings-scss--module__radioRoot___-vHUu";
const radioLabel$2 = "ChatIOSettings-scss--module__radioLabel___Gh1cE";
const checkboxWrapper = "ChatIOSettings-scss--module__checkboxWrapper___2-n-3";
const checkboxGroupWrapper = "ChatIOSettings-scss--module__checkboxGroupWrapper___vEP0g";
const s$28 = {
    radioList: radioList$2,
    radioRoot: radioRoot$2,
    radioLabel: radioLabel$2,
    checkboxWrapper: checkboxWrapper,
    checkboxGroupWrapper: checkboxGroupWrapper
};
const ChatIOSettingsList = (props)=>{
    const { data } = props;
    const { onToggleCheckbox, onRadioButtonClick } = useChatIOSettings(props);
    const renderRadioCheckbox = (element, radioGroupId)=>{
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$28.checkboxWrapper,
            key: element.id + "checkbox"
        }, /* @__PURE__ */ $acw62.createElement(SimpleCheckBox, {
            key: element.id,
            isDisabled: data.value !== radioGroupId,
            checked: data.parameters.includes(element.value),
            label: element.getLabel(),
            onToggle: (checked2)=>onToggleCheckbox(element, checked2)
        }));
    };
    const renderListRadio = (element)=>{
        var _a3;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$28.radioWrapper,
            key: element.id
        }, /* @__PURE__ */ $acw62.createElement(RadioButton, {
            classNames: {
                root: s$28.radioRoot,
                label: s$28.radioLabel
            },
            mode: ERadioButtonMode.DARK,
            value: element.value,
            label: element.getLabel(),
            isChecked: data.value === element.value,
            onRadioButtonClick: ()=>onRadioButtonClick(element)
        }), ((_a3 = element.checkboxes) == null ? void 0 : _a3.length) > 0 && /* @__PURE__ */ $acw62.createElement("div", {
            className: s$28.checkboxGroupWrapper
        }, element.checkboxes.map((box)=>renderRadioCheckbox(box, element.value))));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$28.radioList
    }, OPTIONS_LIST.map((element)=>renderListRadio(element)));
};
var EOptionSwitcherSize = /* @__PURE__ */ ((EOptionSwitcherSize2)=>{
    EOptionSwitcherSize2["M"] = "m";
    EOptionSwitcherSize2["L"] = "l";
    return EOptionSwitcherSize2;
})(EOptionSwitcherSize || {});
const root$1p = "OptionSwitcher-scss--module__root___25nLz";
const m = "OptionSwitcher-scss--module__m___uTQvJ";
const l = "OptionSwitcher-scss--module__l___KTWio";
const container$4 = "OptionSwitcher-scss--module__container___zEN2C";
const containerDisabled = "OptionSwitcher-scss--module__containerDisabled___5rGU8";
const item$4 = "OptionSwitcher-scss--module__item___R7JFM";
const itemDisabled = "OptionSwitcher-scss--module__itemDisabled___zuT7W";
const active$3 = "OptionSwitcher-scss--module__active___MsSve";
const activeBlock = "OptionSwitcher-scss--module__activeBlock___-1NfF";
const fadeIn$3 = "OptionSwitcher-scss--module__fadeIn___HNRkQ";
const s$27 = {
    root: root$1p,
    m: m,
    l: l,
    container: container$4,
    containerDisabled: containerDisabled,
    item: item$4,
    itemDisabled: itemDisabled,
    active: active$3,
    activeBlock: activeBlock,
    fadeIn: fadeIn$3
};
const OptionSwitcher = (props)=>{
    const { options, selected: selected2, className, disabled: disabled2 = false, size: size2 = EOptionSwitcherSize.M, onChange } = props;
    const setRefs = (0, $acw62.useRef)({});
    const [params, setParams] = (0, $acw62.useState)(null);
    const activeIndex = options.findIndex((item2)=>item2.value === selected2.value);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a3;
        if (!isNil(activeIndex) && activeIndex !== -1 && ((_a3 = setRefs == null ? void 0 : setRefs.current) == null ? void 0 : _a3[activeIndex])) {
            const { width } = setRefs.current[activeIndex].getBoundingClientRect();
            setParams({
                elementWidth: width,
                offset: width * activeIndex
            });
        }
    }, [
        activeIndex
    ]);
    const handleClick = (option2)=>()=>{
            !disabled2 && onChange(option2);
        };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$27.root, className, s$27[size2])
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$27.container, {
            [s$27.containerDisabled]: disabled2
        })
    }, options.map((option2, index2)=>/* @__PURE__ */ $acw62.createElement("div", {
            ref: (ref2)=>setRefs.current[index2] = ref2,
            onClick: handleClick(option2),
            key: index2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$27.item, {
                [s$27.active]: index2 === activeIndex,
                [s$27.itemDisabled]: disabled2
            })
        }, option2.label)), params && /* @__PURE__ */ $acw62.createElement("span", {
        className: s$27.activeBlock,
        style: {
            width: `${params.elementWidth}px`,
            transform: `translateX(${params.offset}px)`
        }
    })));
};
const title$l = "ChatMessageSettings-scss--module__title___xkHl-";
const textSizeSwitcher = "ChatMessageSettings-scss--module__textSizeSwitcher___QjVxV";
const publishTimeVisibilityToggler = "ChatMessageSettings-scss--module__publishTimeVisibilityToggler___wpIF-";
const margin = "ChatMessageSettings-scss--module__margin___v3GDr";
const s$26 = {
    title: title$l,
    textSizeSwitcher: textSizeSwitcher,
    publishTimeVisibilityToggler: publishTimeVisibilityToggler,
    margin: margin
};
const locales$19 = {
    textSize: "\u0420\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
    showPublishTime: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u0432\u0440\u0435\u043C\u044F"
};
const t$19 = distExports$1.getTranslation && locales$19;
const TEXT_SIZE_OPTIONS = [
    {
        value: EChatMessageTextSize.SMALL,
        label: EChatMessageTextSize.SMALL
    },
    {
        value: EChatMessageTextSize.NORMAL,
        label: EChatMessageTextSize.NORMAL
    },
    {
        value: EChatMessageTextSize.BIG,
        label: EChatMessageTextSize.BIG
    },
    {
        value: EChatMessageTextSize.EXTRA_BIG,
        label: EChatMessageTextSize.EXTRA_BIG
    },
    {
        value: EChatMessageTextSize.LARGE,
        label: EChatMessageTextSize.LARGE
    }
];
const ChatMessageSettings = (props)=>{
    const { messageTextSize, isMessagePublishTimeVisible, withMargins, onMessagePublishTimeVisibilityChange, onMessageTextSizeChange } = props;
    const selectedMessage = TEXT_SIZE_OPTIONS.find((textSize)=>textSize.value === messageTextSize);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$26.margin]: withMargins
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$26.title
    }, t$19.textSize), /* @__PURE__ */ $acw62.createElement(OptionSwitcher, {
        className: s$26.textSizeSwitcher,
        options: TEXT_SIZE_OPTIONS,
        selected: selectedMessage,
        onChange: onMessageTextSizeChange
    }), /* @__PURE__ */ $acw62.createElement(ToggleSwitch, {
        togglePosition: "right",
        size: EToggleSwitchSize.MIDDLE,
        checked: isMessagePublishTimeVisible,
        classNames: {
            labelText: s$26.publishTimeVisibilityToggler
        },
        label: t$19.showPublishTime,
        onToggle: onMessagePublishTimeVisibilityChange
    }));
};
const PAUSE_TYPES = [
    EChatPauseType.SCROLL,
    EChatPauseType.MOUSEOVER,
    EChatPauseType.ALT,
    EChatPauseType.MOUSEOVER_ALT
];
const useChatPauseSettings = (props)=>{
    const { pauseType, onChange } = props;
    const [selectedPauseType, setSelectedPauseType] = (0, $acw62.useState)({
        id: pauseType,
        label: getPauseTypeTitle(pauseType),
        value: pauseType
    });
    (0, $acw62.useEffect)(()=>onChange(selectedPauseType.value), [
        selectedPauseType
    ]);
    const pauseTypeOptions = (0, $acw62.useMemo)(()=>PAUSE_TYPES.map((type)=>({
                id: type,
                label: getPauseTypeTitle(type),
                value: type
            })), []);
    const handlePauseTypeRadioClick = (value2)=>{
        const foundPauseType = pauseTypeOptions.find((element)=>element.value === value2);
        setSelectedPauseType(foundPauseType);
    };
    return {
        pauseTypeOptions: pauseTypeOptions,
        selectedPauseType: selectedPauseType,
        setSelectedPauseType: setSelectedPauseType,
        handlePauseTypeRadioClick: handlePauseTypeRadioClick
    };
};
const root$1o = "ChatPauseSettings-scss--module__root___qW4-G";
const radioList$1 = "ChatPauseSettings-scss--module__radioList___3wlCK";
const radioRoot$1 = "ChatPauseSettings-scss--module__radioRoot___wZ0Xi";
const radioLabel$1 = "ChatPauseSettings-scss--module__radioLabel___nzMf2";
const s$25 = {
    root: root$1o,
    radioList: radioList$1,
    radioRoot: radioRoot$1,
    radioLabel: radioLabel$1
};
const ChatPauseSettingsList = (props)=>{
    const { handlePauseTypeRadioClick, selectedPauseType, pauseTypeOptions } = useChatPauseSettings(props);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$25.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$25.radioList
    }, pauseTypeOptions.map((option2)=>/* @__PURE__ */ $acw62.createElement(RadioButton, {
            classNames: {
                root: s$25.radioRoot,
                label: s$25.radioLabel
            },
            mode: ERadioButtonMode.DARK,
            value: option2.value,
            key: option2.id,
            label: option2.label,
            isChecked: selectedPauseType.value === option2.value,
            onRadioButtonClick: handlePauseTypeRadioClick
        }))));
};
const color = "PaletteItem-scss--module__color___48vkq";
const selected$2 = "PaletteItem-scss--module__selected___HpdI4";
const s$24 = {
    color: color,
    selected: selected$2
};
const PaletteItem = (props)=>{
    const { isSelected, value: value2, onClick = noop$1 } = props;
    const { theme } = useThemeContext();
    const colorNumber = (0, $acw62.useMemo)(()=>{
        const palette = CHAT_COLORS[getColorPaletteTheme(theme) === EUITheme.LIGHT ? "LIGHT" : "DARK"];
        return palette.findIndex((color2)=>color2 === value2);
    }, [
        value2,
        theme
    ]);
    return /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$24.color, {
            [s$24.selected]: isSelected
        }),
        style: {
            "--color": value2
        },
        onClick: ()=>onClick(colorNumber)
    });
};
const root$1n = "Palette-scss--module__root___9lFXS";
const grid = "Palette-scss--module__grid___kRH0B";
const s$23 = {
    root: root$1n,
    grid: grid
};
const Palette = (props)=>{
    const { isGrid, selected: selected2, onChange, className } = props;
    const { theme } = useThemeContext();
    const palette = CHAT_COLORS[getColorPaletteTheme(theme) === EUITheme.LIGHT ? "LIGHT" : "DARK"];
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$23.root, className, {
            [s$23.grid]: isGrid
        })
    }, Object.entries(palette).map(([key, value2])=>/* @__PURE__ */ $acw62.createElement(PaletteItem, {
            key: key,
            value: value2,
            isSelected: Number(key) === selected2,
            onClick: onChange
        })));
};
const locales$18 = {
    change: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
    save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
    bindingsError: "\u0418\u043C\u044F \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043E\u0442 5 \u0434\u043E 50 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0438 \u043D\u0435 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C",
    error: "\u0418\u043C\u044F \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0435 \u0447\u0430\u0449\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0430 \u0432 {{period}}."
};
const t$18 = distExports$1.getTranslation && locales$18;
const MIN_NICKNAME_LENGTH = 5;
const MAX_NICKNAME_LENGTH = 50;
const useChatProfileSettings = (props)=>{
    const { nickColor, nickName } = props;
    const { theme } = useThemeContext();
    const dispatch = (0, $2OPjR.useDispatch)();
    const [isNickNameChangeDisabled, setIsNickNameChangeDisabled] = $acw62.useState(true);
    const [nickNameValue, setNickNameValue] = (0, $acw62.useState)(nickName);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isValid2, setIsValid] = (0, $acw62.useState)(true);
    const [error2, setError] = (0, $acw62.useState)();
    const nickNameInputRef = $acw62.useRef(null);
    const changeNameTitle = isNickNameChangeDisabled ? t$18.change : t$18.save;
    const changeLockPeriod = (0, $acw62.useRef)(getConfig().user.nick.changeLockPeriod);
    const nameChangePeriodText = (0, $acw62.useMemo)(()=>getPeriodText(changeLockPeriod.current, t$18.error), []);
    const checkIsNameValid = (value2)=>{
        const result2 = value2 && value2.length > MIN_NICKNAME_LENGTH && value2.length < MAX_NICKNAME_LENGTH;
        if (!result2) setError(t$18.bindingsError);
        return result2;
    };
    const checkIsNameAvailable = async (value2)=>{
        setIsLoading(true);
        let result2 = true;
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(checkNick.action)({
                nick: value2
            }));
            setError(null);
        } catch (err) {
            result2 = false;
            const errorText2 = getNameChangeErrorText(err, value2, nameChangePeriodText);
            setIsLoading(false);
            setError(errorText2);
        }
        setIsLoading(false);
        return result2;
    };
    const submitNickNameChange = async ()=>{
        if (!isLoading && isValid2) {
            await dispatch((0, $7Uc0p.thunkToAction)(updateUserData.action)({
                nick: nickNameValue.trim()
            }));
            setIsNickNameChangeDisabled(true);
        }
    };
    const handleChangeNickNameClick = async ()=>{
        if (isLoading && !isValid2) return;
        if (!isNickNameChangeDisabled) {
            await submitNickNameChange();
            return;
        }
        setIsNickNameChangeDisabled(false);
    };
    const validateNick = debounce(async (value2)=>{
        if (await checkIsNameAvailable(value2) && checkIsNameValid(value2)) {
            setIsValid(true);
            return;
        }
        setIsValid(false);
    }, 250);
    const handleNickNameChange = (element)=>{
        setNickNameValue(element.target.value);
    };
    const color2 = (0, $acw62.useMemo)(()=>{
        return getChatNicknameColor(nickColor, theme);
    }, [
        nickColor,
        theme
    ]);
    (0, $acw62.useEffect)(()=>{
        if (nickNameValue !== nickName) validateNick(nickNameValue.trim());
    }, [
        nickNameValue
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isNickNameChangeDisabled) nickNameInputRef.current.focus();
    }, [
        isNickNameChangeDisabled
    ]);
    return {
        color: color2,
        error: error2,
        isValid: isValid2,
        isNickNameChangeDisabled: isNickNameChangeDisabled,
        changeNameTitle: changeNameTitle,
        nameChangePeriodText: nameChangePeriodText,
        nickNameValue: nickNameValue,
        nickNameInputRef: nickNameInputRef,
        handleChangeNickNameClick: handleChangeNickNameClick,
        handleNickNameChange: handleNickNameChange
    };
};
const root$1m = "ChatProfileSettings-scss--module__root___-MU02";
const nickname = "ChatProfileSettings-scss--module__nickname___kXjf5";
const error$2 = "ChatProfileSettings-scss--module__error___gjlIw";
const disabled$2 = "ChatProfileSettings-scss--module__disabled___SqeHU";
const input$4 = "ChatProfileSettings-scss--module__input___OlXqA";
const header$7 = "ChatProfileSettings-scss--module__header___e0gmx";
const headerText = "ChatProfileSettings-scss--module__headerText___W64Ez";
const headerAction = "ChatProfileSettings-scss--module__headerAction___lEX6W";
const tooltip$2 = "ChatProfileSettings-scss--module__tooltip___9mRln";
const description$7 = "ChatProfileSettings-scss--module__description___GS0lE";
const s$22 = {
    root: root$1m,
    nickname: nickname,
    error: error$2,
    disabled: disabled$2,
    input: input$4,
    header: header$7,
    headerText: headerText,
    headerAction: headerAction,
    tooltip: tooltip$2,
    description: description$7
};
const locales$17 = {
    label: "\u041D\u0438\u043A\u043D\u0435\u0439\u043C"
};
const t$17 = distExports$1.getTranslation && locales$17;
const ChatProfileSettings = (props)=>{
    const { nickColor, onChange } = props;
    const { error: error2, isNickNameChangeDisabled, isValid: isValid2, color: color2, changeNameTitle, nameChangePeriodText, nickNameValue, nickNameInputRef, handleChangeNickNameClick, handleNickNameChange } = useChatProfileSettings(props);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$22.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$22.header
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$22.headerText
    }, t$17.label), /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$22.headerText, s$22.headerAction, {
            [s$22.disabled]: !isValid2
        }),
        onClick: handleChangeNickNameClick
    }, changeNameTitle)), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$22.nickname, {
            [s$22.disabled]: isNickNameChangeDisabled,
            [s$22.error]: Boolean(error2) || !isValid2
        })
    }, /* @__PURE__ */ $acw62.createElement("input", {
        style: {
            color: color2
        },
        className: s$22.input,
        value: nickNameValue,
        onChange: handleNickNameChange,
        disabled: isNickNameChangeDisabled,
        ref: nickNameInputRef
    }), /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        content: /* @__PURE__ */ $acw62.createElement(Palette, {
            selected: nickColor,
            onChange: onChange,
            isGrid: true
        }),
        trigger: ETooltipTrigger.CLICK,
        isGlobal: true,
        classNames: {
            content: s$22.tooltip
        }
    }, /* @__PURE__ */ $acw62.createElement(PaletteItem, {
        value: color2
    }))), /* @__PURE__ */ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$22.description, {
            [s$22.error]: Boolean(error2)
        })
    }, error2 ?? nameChangePeriodText));
};
const useChatSlowmodeSettings = (props)=>{
    const { timeout: timeout2, onChange } = props;
    const [slowmodeValues, setSlowmodeValues] = (0, $acw62.useState)(SLOW_MODE_VALUES);
    (0, $acw62.useEffect)(()=>{
        if (!slowmodeValues.includes(timeout2)) setSlowmodeValues((prevSlowmodeValues)=>[
                ...prevSlowmodeValues,
                timeout2
            ]);
    }, [
        timeout2
    ]);
    const slowmodeSelectOptions = (0, $acw62.useMemo)(()=>{
        return slowmodeValues.sort((a2, b2)=>a2 - b2).map((option2)=>({
                label: getSlowmodeTitle(option2),
                value: option2
            }));
    }, [
        slowmodeValues
    ]);
    const selectedItem = (0, $acw62.useMemo)(()=>{
        return slowmodeSelectOptions.find((element)=>element.value === timeout2) || slowmodeSelectOptions[0];
    }, [
        slowmodeSelectOptions,
        timeout2
    ]);
    const handleSelect = (0, $acw62.useCallback)((item2)=>{
        onChange(item2.value);
    }, [
        onChange
    ]);
    const handleRadioButtonClick = (0, $acw62.useCallback)((value2)=>{
        onChange(value2);
    }, [
        onChange
    ]);
    return {
        slowmodeSelectOptions: slowmodeSelectOptions,
        selectedItem: selectedItem,
        handleSelect: handleSelect,
        handleRadioButtonClick: handleRadioButtonClick
    };
};
const radioList = "ChatSlowmodeSettings-scss--module__radioList___GapkZ";
const radioRoot = "ChatSlowmodeSettings-scss--module__radioRoot___r68rN";
const radioLabel = "ChatSlowmodeSettings-scss--module__radioLabel___ebMLA";
const s$21 = {
    radioList: radioList,
    radioRoot: radioRoot,
    radioLabel: radioLabel
};
const ChatSlowmodeSettingsList = (props)=>{
    const { slowmodeSelectOptions, selectedItem, handleRadioButtonClick } = useChatSlowmodeSettings(props);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$21.radioList
    }, slowmodeSelectOptions.map((option2)=>/* @__PURE__ */ $acw62.createElement(RadioButton, {
            classNames: {
                root: s$21.radioRoot,
                label: s$21.radioLabel
            },
            value: String(option2.value),
            key: option2.value,
            label: option2.label,
            isChecked: selectedItem.value === option2.value,
            onRadioButtonClick: handleRadioButtonClick
        })));
};
const root$1l = "ChatSettings-scss--module__root___cwxyU";
const topPanel = "ChatSettings-scss--module__topPanel___upB41";
const title$k = "ChatSettings-scss--module__title___uztj8";
const headerIcon = "ChatSettings-scss--module__headerIcon___NGd-v";
const left$1 = "ChatSettings-scss--module__left___J19Ox";
const right$1 = "ChatSettings-scss--module__right___fWsvj";
const reverted = "ChatSettings-scss--module__reverted___1hl13";
const listContainer = "ChatSettings-scss--module__listContainer___N-FOK";
const listElement = "ChatSettings-scss--module__listElement___yjWNy";
const listElementText = "ChatSettings-scss--module__listElementText___vaDCH";
const listElementTextWrapper = "ChatSettings-scss--module__listElementTextWrapper___DXiPW";
const listElementTitle = "ChatSettings-scss--module__listElementTitle___Z6YPp";
const listElementState = "ChatSettings-scss--module__listElementState___iaNK7";
const listArrowIcon = "ChatSettings-scss--module__listArrowIcon___z-I8V";
const s$20 = {
    root: root$1l,
    topPanel: topPanel,
    title: title$k,
    headerIcon: headerIcon,
    left: left$1,
    right: right$1,
    reverted: reverted,
    "new": "ChatSettings-scss--module__new___U5LuC",
    listContainer: listContainer,
    listElement: listElement,
    listElementText: listElementText,
    listElementTextWrapper: listElementTextWrapper,
    listElementTitle: listElementTitle,
    listElementState: listElementState,
    listArrowIcon: listArrowIcon
};
const ChatSettings = (props)=>{
    const { className, onClose } = props;
    const { accessLevel, subscriptionDuration, messageTextSize, isMessagePublishTimeVisible, pauseType, anyMessageTimeout, onChatSlomodeSettingsChange, displayName, nickColor, updateNicknameColor: updateNicknameColor2, chatIOMode, selectIOMode, onChatAccessSettingsChange, onChatMessagePublishTimeVisibilityChange, onChatMessageTextSizeChange, onChatPauseTypeChange, elements, mode: mode2, getHeaderTitle, onBack } = useChatSettings(props);
    const renderHeader = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, mode2 && /* @__PURE__ */ $acw62.createElement(Icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$20.headerIcon, s$20.left, s$20.reverted),
            glyph: svg_name_arrow_short_right,
            onClick: onBack
        }), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$20.title
        }, getHeaderTitle()), /* @__PURE__ */ $acw62.createElement(Icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$20.headerIcon, s$20.right),
            glyph: svg_name_close,
            onClick: onClose
        }));
    };
    const renderListElements = ()=>{
        return elements.map((element)=>{
            return /* @__PURE__ */ $acw62.createElement("div", {
                key: element.mode,
                className: s$20.listElement,
                onClick: element.onClick
            }, /* @__PURE__ */ $acw62.createElement("div", {
                className: s$20.listElementTextWrapper
            }, /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$20.listElementText, s$20.listElementTitle)
            }, element.title), element.state && /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$20.listElementText, s$20.listElementState)
            }, element.state)), /* @__PURE__ */ $acw62.createElement(Icon, {
                className: s$20.listArrowIcon,
                glyph: element.icon ?? svg_name_arrow_short_right
            }));
        });
    };
    const renderMode = ()=>{
        switch(mode2){
            case EChatSettingsMode.IO:
                return /* @__PURE__ */ $acw62.createElement(ChatIOSettingsList, {
                    data: chatIOMode,
                    selectData: selectIOMode
                });
            case EChatSettingsMode.AVAILABILITY:
                return /* @__PURE__ */ $acw62.createElement(ChatAccessSettingsList, {
                    accessLevel: accessLevel,
                    subscriptionDuration: subscriptionDuration,
                    onChange: onChatAccessSettingsChange
                });
            case EChatSettingsMode.SLOWING:
                return /* @__PURE__ */ $acw62.createElement(ChatSlowmodeSettingsList, {
                    timeout: anyMessageTimeout,
                    onChange: onChatSlomodeSettingsChange
                });
            case EChatSettingsMode.PAUSING:
                return /* @__PURE__ */ $acw62.createElement(ChatPauseSettingsList, {
                    pauseType: pauseType,
                    onChange: onChatPauseTypeChange
                });
            case EChatSettingsMode.STYLE:
                return /* @__PURE__ */ $acw62.createElement(ChatMessageSettings, {
                    withMargins: true,
                    messageTextSize: messageTextSize,
                    isMessagePublishTimeVisible: isMessagePublishTimeVisible,
                    onMessagePublishTimeVisibilityChange: onChatMessagePublishTimeVisibilityChange,
                    onMessageTextSizeChange: onChatMessageTextSizeChange
                });
            case EChatSettingsMode.PROFILE:
                return /* @__PURE__ */ $acw62.createElement(ChatProfileSettings, {
                    nickName: displayName,
                    nickColor: nickColor,
                    onChange: updateNicknameColor2
                });
            default:
                return /* @__PURE__ */ $acw62.createElement("div", {
                    className: s$20.listContainer
                }, renderListElements());
        }
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$20.root, s$20.new, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$20.topPanel
    }, renderHeader()), renderMode());
};
const icon$r = "Settings-scss--module__icon___ev6GH";
const button$f = "Settings-scss--module__button___-hqPN";
const settingsButton = "Settings-scss--module__settingsButton___JZfmN";
const settingsTooltip = "Settings-scss--module__settingsTooltip___zXvPi";
const iconMobile = "Settings-scss--module__iconMobile___0N-bn";
const s$1$ = {
    icon: icon$r,
    button: button$f,
    settingsButton: settingsButton,
    settingsTooltip: settingsTooltip,
    iconMobile: iconMobile
};
const locales$16 = {
    chatSettings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0447\u0430\u0442\u0430"
};
const t$16 = distExports$1.getTranslation && locales$16;
const Settings$1 = (props)=>{
    const { classNames = {}, isModerationDisabled } = props;
    const { isMobile: isMobile2 } = getConfig();
    const { blogUrl } = useStreamIdentity();
    const isButtonVisible = isConditionalFeatureEnable(EConditionalFeature.CHAT_SETTINGS);
    const [isPopupVisible, setIsPopupVisible] = (0, $acw62.useState)(false);
    const handleButtonClick = ()=>{
        AppStat.log.chat.settingsShow();
        setIsPopupVisible(!isPopupVisible);
    };
    const handlePopupClose = (0, $acw62.useCallback)(()=>{
        setIsPopupVisible(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        handlePopupClose();
    }, [
        blogUrl
    ]);
    const button2 = /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1$.button, classNames.button),
        onClick: handleButtonClick,
        type: "button"
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_gear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1$.icon, classNames.icon)
    }));
    const getButton = ()=>{
        if (isMobile2) return /* @__PURE__ */ $acw62.createElement(Icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1$.iconMobile, classNames.button),
            glyph: svg_name_more_horizontal_28,
            onClick: handleButtonClick
        });
        return /* @__PURE__ */ $acw62.createElement(Tooltip, {
            trigger: ETooltipTriggers.HOVER,
            align: ETooltipPositions.LEFT_TOP,
            classNames: {
                root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1$.settingsButton, classNames.buttonTooltip),
                content: s$1$.settingsTooltip
            },
            content: t$16.chatSettings
        }, button2);
    };
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, isButtonVisible && getButton(), isPopupVisible && /* @__PURE__ */ $acw62.createElement(ChatSettings, {
        className: classNames.popup,
        onClose: handlePopupClose,
        isModerationDisabled: isModerationDisabled
    }));
};
const root$1k = "ChatFooter-scss--module__root___3iUOF";
const buttonSettings$1 = "ChatFooter-scss--module__buttonSettings___Y0F0H";
const buttonTooltip = "ChatFooter-scss--module__buttonTooltip___eTIEH";
const authText$1 = "ChatFooter-scss--module__authText___K9Q6e";
const separator$1 = "ChatFooter-scss--module__separator___5t6yT";
const tooltipContainer$1 = "ChatFooter-scss--module__tooltipContainer___CjozL";
const linkToStudio = "ChatFooter-scss--module__linkToStudio___4kmkg";
const icon$q = "ChatFooter-scss--module__icon___T3GmB";
const s$1_ = {
    root: root$1k,
    buttonSettings: buttonSettings$1,
    buttonTooltip: buttonTooltip,
    authText: authText$1,
    separator: separator$1,
    tooltipContainer: tooltipContainer$1,
    linkToStudio: linkToStudio,
    icon: icon$q
};
const locales$15 = {
    studio: "\u0421\u0442\u0443\u0434\u0438\u044F"
};
const t$15 = distExports$1.getTranslation && locales$15;
const ChatFooterWithoutRef = (props)=>{
    const { innerRef, blogUrl, children: children2, isAuthorized, isStudioButtonEnabled = true, isSettingsButtonEnabled, isSettingsModerationDisabled, showAuth } = props;
    const childrenNode = !children2 ? /* @__PURE__ */ $acw62.createElement("div", null) : children2;
    const linkToStudio2 = getParametrizedUrl(URLS.STREAM_STUDIO, {
        blogUrl: blogUrl
    });
    const { canModerateChatChannel } = useCurrentUserAccess();
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1_.root,
        ref: innerRef
    }, !isAuthorized && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1_.authText
    }, false), isAuthorized && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, childrenNode, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1_.separator
    }), canModerateChatChannel && isStudioButtonEnabled && /* @__PURE__ */ $acw62.createElement(Tooltip, {
        trigger: ETooltipTriggers.HOVER,
        align: ETooltipPositions.LEFT_TOP,
        classNames: {
            root: s$1_.tooltipContainer
        },
        content: t$15.studio
    }, /* @__PURE__ */ $acw62.createElement(Link, {
        to: linkToStudio2,
        className: s$1_.linkToStudio
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_sword_new,
        className: s$1_.icon
    })))), isSettingsButtonEnabled && /* @__PURE__ */ $acw62.createElement(Settings$1, {
        classNames: {
            button: s$1_.buttonSettings,
            buttonTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                [s$1_.buttonTooltip]: !isAuthorized
            })
        },
        isModerationDisabled: isSettingsModerationDisabled
    }));
};
const ChatFooter = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ChatFooterWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const root$1j = "ChatFooterMobileView-scss--module__root___pxHbf";
const publisher = "ChatFooterMobileView-scss--module__publisher___3tvUE";
const separator = "ChatFooterMobileView-scss--module__separator___-CI-0";
const buttonSettings = "ChatFooterMobileView-scss--module__buttonSettings___kHfdo";
const authText = "ChatFooterMobileView-scss--module__authText___QO3Ax";
const link = "ChatFooterMobileView-scss--module__link___e-3ix";
const s$1Z = {
    root: root$1j,
    publisher: publisher,
    separator: separator,
    buttonSettings: buttonSettings,
    authText: authText,
    link: link
};
const locales$14 = {
    auth: "<Link>\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0443\u0439\u0442\u0435\u0441\u044C</Link>, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u0447\u0430\u0442"
};
const t$14 = distExports$1.getTranslation && locales$14;
const ChatFooterMobileViewWithoutRef = (props)=>{
    const { innerRef, children: children2, isAuthorized, isSettingsButtonEnabled, isSettingsModerationDisabled, showAuth, renderChatPublisher } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1Z.root,
        ref: innerRef
    }, !isAuthorized && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1Z.authText
    }, distExports$1.getReactText(t$14.auth, {
        Link: ({ text: text2 })=>/* @__PURE__ */ $acw62.createElement("span", {
                className: s$1Z.link,
                onClick: showAuth
            }, text2)
    })), isAuthorized && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, children2, renderChatPublisher({
        className: s$1Z.publisher
    })), isSettingsButtonEnabled && /* @__PURE__ */ $acw62.createElement(Settings$1, {
        classNames: {
            button: s$1Z.buttonSettings
        },
        isModerationDisabled: isSettingsModerationDisabled
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1Z.separator
    }));
};
const ChatFooterMobileView = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ChatFooterMobileViewWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const config = [
    {
        color: "#4bb44b",
        icon: svg_name_dice_bage_1
    },
    {
        color: "#ff5c5c",
        icon: svg_name_dice_bage_2
    },
    {
        color: "#ffa000",
        icon: svg_name_dice_bage_3
    },
    {
        color: "#b265f0",
        icon: svg_name_dice_bage_4
    },
    {
        color: "#e03fab",
        icon: svg_name_dice_bage_5
    },
    {
        color: "#70b2ff",
        icon: svg_name_dice_bage_6
    }
];
const getDecisionConfig = (order)=>config[order] || config[0];
const onlyTwoElementsInArray = (arr)=>arr.length === 2;
var EDecisionTitleCellMode = /* @__PURE__ */ ((EDecisionTitleCellMode2)=>{
    EDecisionTitleCellMode2["HEAD"] = "head";
    EDecisionTitleCellMode2["CELL"] = "cell";
    return EDecisionTitleCellMode2;
})(EDecisionTitleCellMode || {});
const root$1i = "DecisionTitle-scss--module__root___k68UW";
const icon$p = "DecisionTitle-scss--module__icon___b70sR";
const value$2 = "DecisionTitle-scss--module__value___M2-G-";
const cell$2 = "DecisionTitle-scss--module__cell___83Hif";
const head$2 = "DecisionTitle-scss--module__head___5OcLd";
const fadeIn$2 = "DecisionTitle-scss--module__fadeIn___U2ZEN";
const s$1Y = {
    root: root$1i,
    icon: icon$p,
    value: value$2,
    cell: cell$2,
    head: head$2,
    fadeIn: fadeIn$2
};
const DecisionTitle = (props)=>{
    const { className, value: value2, glyph, mode: mode2 = EDecisionTitleCellMode.CELL } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1Y.root, className)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: glyph,
        className: s$1Y.icon
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1Y.value, s$1Y[mode2])
    }, value2));
};
const root$1h = "DecisionCardBase-scss--module__root___LcOGs";
const selectable$1 = "DecisionCardBase-scss--module__selectable___CUIvV";
const s$1X = {
    root: root$1h,
    selectable: selectable$1
};
const DecisionCardBase = (props)=>{
    const { children: children2, className, color: color2, isSelected = false, isSelectable = true, onClick = dist$4.noop } = props;
    const boxShadow2 = isSelected ? `0 0 0 1px ${color2}` : "";
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1X.root, className, {
            [s$1X.selectable]: isSelectable && !isSelected
        }),
        style: {
            color: color2,
            boxShadow: boxShadow2
        },
        onClick: onClick
    }, children2);
};
const root$1g = "DecisionCardShortLayout-scss--module__root___5VGK7";
const s$1W = {
    root: root$1g
};
const DecisionCardShortLayout = (props)=>{
    const { data: { order, name: name2 }, isSelected, onClick } = props;
    const { color: color2, icon: icon2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement(DecisionCardBase, {
        className: s$1W.root,
        color: color2,
        isSelected: isSelected,
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement(DecisionTitle, {
        glyph: icon2,
        value: name2
    }));
};
const useDecision = (props)=>{
    const { order, pointsBank, pointsBankPrediction } = props;
    const pointIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    const outcome = pointsBankPrediction > 0 ? Math.round(pointsBank / pointsBankPrediction * 100) : 0;
    return {
        pointIconUrl: pointIconUrl,
        outcome: outcome,
        ...getDecisionConfig(order)
    };
};
const root$1f = "Button-scss--module__root___BjYe8";
const disabled$1 = "Button-scss--module__disabled___dFIQe";
const s$1V = {
    root: root$1f,
    disabled: disabled$1
};
const Button = (props)=>{
    const { children: children2, className, isDisabled: isDisabled2 = false, onClick = dist$4.noop } = props;
    const handleClick = ()=>{
        if (!isDisabled2) onClick();
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1V.root, className, {
            [s$1V.disabled]: isDisabled2
        }),
        onClick: handleClick
    }, children2);
};
const root$1e = "ConfirmPopup-scss--module__root___YfUIq";
const layout$1 = "ConfirmPopup-scss--module__layout___NB0-y";
const title$j = "ConfirmPopup-scss--module__title___P-vLM";
const text$6 = "ConfirmPopup-scss--module__text___klDCh";
const actions$1 = "ConfirmPopup-scss--module__actions___S-MLa";
const confirm = "ConfirmPopup-scss--module__confirm___Drp1G";
const s$1U = {
    root: root$1e,
    layout: layout$1,
    title: title$j,
    text: text$6,
    actions: actions$1,
    confirm: confirm
};
const locales$13 = {
    toVoice: "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u043F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C",
    confirm: "\u0414\u0430, \u043F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C",
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0430"
};
const t$13 = distExports$1.getTranslation && locales$13;
const ConfirmPopup$1 = (props)=>{
    const { classNames, confirmButtonText = t$13.confirm, title: title2 = t$13.toVoice, text: text2, onCancel = dist$4.noop, onConfirm = dist$4.noop } = props;
    const { confirmButton: confirmButtonClassName } = classNames || {};
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1U.layout
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1U.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1U.title,
        "data-test-id": "title"
    }, title2), text2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1U.text
    }, text2), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1U.actions
    }, /* @__PURE__ */ $acw62.createElement(Button, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1U.confirm, confirmButtonClassName),
        onClick: onConfirm
    }, confirmButtonText), /* @__PURE__ */ $acw62.createElement(Button, {
        onClick: onCancel
    }, t$13.cancel))));
};
const confirmButton = "useDelete-scss--module__confirmButton___-Y4GX";
const s$1T = {
    confirmButton: confirmButton
};
const locales$12 = {
    confirmTitle: "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    confirmText: "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0433\u043D\u043E\u0437. \u0412\u0441\u0435 \u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0431\u0430\u043B\u043B\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C.",
    confirmButtonText: "\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C"
};
const t$12 = distExports$1.getTranslation && locales$12;
const useDelete = (props)=>{
    const { onConfirm = dist$4.noop, onCancel = dist$4.noop } = props;
    const [showConfirm, setShowConfirm] = (0, $acw62.useState)(false);
    const handleCancel = ()=>{
        setShowConfirm(false);
        onCancel();
    };
    const handleConfirm = ()=>{
        setShowConfirm(false);
        onConfirm();
    };
    const confirm2 = /* @__PURE__ */ $acw62.createElement(ConfirmPopup$1, {
        classNames: {
            confirmButton: s$1T.confirmButton
        },
        title: t$12.confirmTitle,
        text: t$12.confirmText,
        confirmButtonText: t$12.confirmButtonText,
        onCancel: handleCancel,
        onConfirm: handleConfirm
    });
    const open2 = ()=>{
        setShowConfirm(true);
    };
    return [
        showConfirm && confirm2,
        open2
    ];
};
var EDecisionBadgesBarMode = /* @__PURE__ */ ((EDecisionBadgesBarMode2)=>{
    EDecisionBadgesBarMode2["COLUMN"] = "column";
    EDecisionBadgesBarMode2["ROW"] = "row";
    return EDecisionBadgesBarMode2;
})(EDecisionBadgesBarMode || {});
const root$1d = "DefaultIcon-scss--module__root___NUL-e";
const s$1S = {
    root: root$1d
};
const DefaultIcon$1 = (props)=>{
    const { src: src2 = "", alt = "", className, glyph } = props;
    const image2 = /* @__PURE__ */ $acw62.createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1S.root, className),
        src: src2,
        alt: alt
    });
    const imagePlaceholder = /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1S.root, className),
        glyph: glyph
    });
    return !src2.length ? imagePlaceholder : image2;
};
const RewardIcon = (props)=>{
    const { className = "", ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(DefaultIcon$1, {
        className: className,
        ...restProps,
        glyph: svg_name_diamond
    });
};
const root$1c = "PointsIcon-scss--module__root___rSUm6";
const s$1R = {
    root: root$1c
};
const PointsIcon$1 = (props)=>{
    const { className = "", ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(DefaultIcon$1, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1R.root, className),
        ...restProps,
        glyph: svg_name_coin
    });
};
const root$1b = "PointsPriceBalloon-scss--module__root___-sZ5l";
const icon$o = "PointsPriceBalloon-scss--module__icon___LlIHF";
const s$1Q = {
    root: root$1b,
    icon: icon$o
};
const PointsPriceBalloon = (props)=>{
    const { iconUrl, price = 0, className, iconClassName } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1Q.root, className)
    }, /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1Q.icon, iconClassName),
        src: iconUrl
    }), /* @__PURE__ */ $acw62.createElement("span", null, price));
};
const root$1a = "RewardPreviewMedium-scss--module__root___qWh1E";
const reward = "RewardPreviewMedium-scss--module__reward___fHbyz";
const rewardIcon = "RewardPreviewMedium-scss--module__rewardIcon___2NksK";
const block = "RewardPreviewMedium-scss--module__block___mLKy-";
const title$i = "RewardPreviewMedium-scss--module__title___CTskK";
const text$5 = "RewardPreviewMedium-scss--module__text___lhpdf";
const skeleton = "RewardPreviewMedium-scss--module__skeleton___SL29d";
const skeletonShort = "RewardPreviewMedium-scss--module__skeletonShort___2Lrki";
const s$1P = {
    root: root$1a,
    reward: reward,
    rewardIcon: rewardIcon,
    block: block,
    title: title$i,
    text: text$5,
    skeleton: skeleton,
    skeletonShort: skeletonShort
};
const locales$11 = {
    highlightMessage: "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"
};
const t$11 = distExports$1.getTranslation && locales$11;
const RewardPreviewMedium = (props)=>{
    const { className, name: name2 = "", price = 0, bgcolor = 0, rewardIconSrc, pointsIconSrc } = props;
    const { theme } = useThemeContext();
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1P.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1P.reward,
        style: {
            background: getChatNicknameColor(bgcolor, theme)
        }
    }, /* @__PURE__ */ $acw62.createElement(RewardIcon, {
        className: s$1P.rewardIcon,
        src: rewardIconSrc
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1P.block
    }, (name2 || price) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1P.title
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1P.text
    }, t$11.highlightMessage), /* @__PURE__ */ $acw62.createElement(PointsPriceBalloon, {
        iconUrl: pointsIconSrc,
        price: price
    }))), !(name2 || price) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1P.skeleton
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1P.skeleton, s$1P.skeletonShort)
    }))));
};
var EPreviewError = /* @__PURE__ */ ((EPreviewError2)=>{
    EPreviewError2["EMPTY_TEXT"] = "emptyText";
    return EPreviewError2;
})(EPreviewError || {});
const root$19 = "RewardChatWarning-scss--module__root___vOqJx";
const content$a = "RewardChatWarning-scss--module__content___MGHMx";
const icon$n = "RewardChatWarning-scss--module__icon___-xga8";
const preview$1 = "RewardChatWarning-scss--module__preview___k-gZs";
const error$1 = "RewardChatWarning-scss--module__error___FrtAN";
const errorIcon = "RewardChatWarning-scss--module__errorIcon___Gt-gy";
const errorIconWarning = "RewardChatWarning-scss--module__errorIconWarning___X5HtM";
const errorIconError = "RewardChatWarning-scss--module__errorIconError___TCWej";
const errorText = "RewardChatWarning-scss--module__errorText___TlK-F";
const s$1O = {
    root: root$19,
    content: content$a,
    icon: icon$n,
    preview: preview$1,
    error: error$1,
    errorIcon: errorIcon,
    errorIconWarning: errorIconWarning,
    errorIconError: errorIconError,
    errorText: errorText
};
const RewardChatWarning = (props)=>{
    const { className, name: name2, price, bgcolor, iconColor = "red", rewardIconUrl, error: error2, pointsIconUrl, onClose = dist$4.noop } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1O.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1O.content
    }, /* @__PURE__ */ $acw62.createElement(RewardPreviewMedium, {
        className: s$1O.preview,
        name: name2,
        price: price,
        bgcolor: bgcolor,
        rewardIconSrc: rewardIconUrl,
        pointsIconSrc: pointsIconUrl
    }), /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$1O.icon,
        glyph: svg_name_cancel_20,
        onClick: onClose
    })), error2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1O.error
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1O.errorIcon, {
            [s$1O.errorIconWarning]: iconColor === "yellow",
            [s$1O.errorIconError]: iconColor === "red"
        }),
        glyph: svg_name_warning
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$1O.errorText
    }, error2)));
};
const root$18 = "DecisionBadgesBar-scss--module__root___pAwmb";
const column = "DecisionBadgesBar-scss--module__column___Wd3Wb";
const cell$1 = "DecisionBadgesBar-scss--module__cell___zz99O";
const badge$1 = "DecisionBadgesBar-scss--module__badge___JnekJ";
const value$1 = "DecisionBadgesBar-scss--module__value___LqCSS";
const fadeIn$1 = "DecisionBadgesBar-scss--module__fadeIn___CxfVf";
const s$1N = {
    root: root$18,
    column: column,
    cell: cell$1,
    badge: badge$1,
    value: value$1,
    fadeIn: fadeIn$1
};
const DecisionBadgesBar = (props)=>{
    const { className, pointIconUrl, data: { pointsBank, proportion, userAmount }, mode: mode2 = EDecisionBadgesBarMode.ROW } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1N.root, s$1N[mode2], className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.cell
    }, /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        src: pointIconUrl,
        className: s$1N.badge
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.value
    }, getShortNum(pointsBank, {
        limit10KDisabled: true
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.cell
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_cup,
        className: s$1N.badge
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.value
    }, proportion ? `1:${proportion}` : 0)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.cell
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_people_couple_rounded,
        className: s$1N.badge
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1N.value
    }, userAmount)));
};
const root$17 = "DecisionRatioCell-scss--module__root___lXJTq";
const s$1M = {
    root: root$17
};
const DecisionRatioCell = (props)=>{
    const { className, value: value2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1M.root, className)
    }, `${value2}%`);
};
const row$2 = "DecisionCardRowLayout-scss--module__row___DsvyQ";
const cellName = "DecisionCardRowLayout-scss--module__cellName___1sGnP";
const ratio = "DecisionCardRowLayout-scss--module__ratio___90-Vj";
const badges = "DecisionCardRowLayout-scss--module__badges___XJ-XM";
const s$1L = {
    row: row$2,
    cellName: cellName,
    ratio: ratio,
    badges: badges
};
const DecisionCardRowLayout = (props)=>{
    const { className, data: { id, order, name: name2, pointsBank }, isSelected, pointsBankPrediction, isSelectable = true, onClick = dist$4.noop } = props;
    const { pointIconUrl, outcome, color: color2, icon: icon2 } = useDecision({
        order: order,
        pointsBankPrediction: pointsBankPrediction,
        pointsBank: pointsBank
    });
    return /* @__PURE__ */ $acw62.createElement(DecisionCardBase, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1L.row, className),
        color: color2,
        onClick: ()=>isSelectable && onClick(id),
        isSelected: isSelected,
        isSelectable: isSelectable
    }, /* @__PURE__ */ $acw62.createElement(DecisionTitle, {
        className: s$1L.cellName,
        glyph: icon2,
        value: name2
    }), /* @__PURE__ */ $acw62.createElement(DecisionBadgesBar, {
        className: s$1L.badges,
        data: props.data,
        pointIconUrl: pointIconUrl
    }), /* @__PURE__ */ $acw62.createElement(DecisionRatioCell, {
        className: s$1L.ratio,
        value: outcome
    }));
};
const root$16 = "DecisionContentColumnLayout-scss--module__root___vnVA3";
const title$h = "DecisionContentColumnLayout-scss--module__title___f70lF";
const badgesBar = "DecisionContentColumnLayout-scss--module__badgesBar___ZUk1z";
const percentage = "DecisionContentColumnLayout-scss--module__percentage___G3D08";
const progressBar$2 = "DecisionContentColumnLayout-scss--module__progressBar___jDkqF";
const s$1K = {
    root: root$16,
    title: title$h,
    badgesBar: badgesBar,
    percentage: percentage,
    progressBar: progressBar$2
};
const DecisionContentColumnLayout = (props)=>{
    const { className, data, pointsBankPrediction } = props;
    const { order, name: name2, pointsBank } = data;
    const { pointIconUrl, outcome, color: color2, icon: icon2 } = useDecision({
        order: order,
        pointsBankPrediction: pointsBankPrediction,
        pointsBank: pointsBank
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1K.root, className)
    }, /* @__PURE__ */ $acw62.createElement(DecisionTitle, {
        className: s$1K.title,
        mode: EDecisionTitleCellMode.HEAD,
        glyph: icon2,
        value: name2
    }), /* @__PURE__ */ $acw62.createElement(DecisionBadgesBar, {
        className: s$1K.badgesBar,
        mode: EDecisionBadgesBarMode.COLUMN,
        pointIconUrl: pointIconUrl,
        data: data
    }), /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1K.percentage
    }, `${outcome}%`), /* @__PURE__ */ $acw62.createElement(ProgressBar$1, {
        classNames: {
            root: s$1K.progressBar
        },
        styles: {
            progressLine: {
                backgroundColor: color2
            }
        },
        percent: outcome,
        direction: EProgressBarDirection.LEFT_TO_RIGHT
    })));
};
const root$15 = "DecisionCardColumnLayout-scss--module__root___HEzpv";
const content$9 = "DecisionCardColumnLayout-scss--module__content___ik8UO";
const s$1J = {
    root: root$15,
    content: content$9
};
const DecisionCardColumnLayout = (props)=>{
    const { className, data, isSelected, pointsBankPrediction, isSelectable } = props;
    const { order } = data;
    const { color: color2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement(DecisionCardBase, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1J.root, className),
        color: color2,
        isSelected: isSelected,
        isSelectable: isSelectable
    }, /* @__PURE__ */ $acw62.createElement(DecisionContentColumnLayout, {
        className: s$1J.content,
        data: data,
        pointsBankPrediction: pointsBankPrediction
    }));
};
const root$14 = "ButtonAlert-scss--module__root___Xy2IU";
const disabled = "ButtonAlert-scss--module__disabled___Br52y";
const s$1I = {
    root: root$14,
    disabled: disabled
};
const ButtonAlert = (props)=>{
    const { children: children2, className, color: color2, isDisabled: isDisabled2, onClick = dist$4.noop } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1I.root, className, {
            [s$1I.disabled]: isDisabled2
        }),
        style: {
            backgroundColor: color2
        },
        onClick: isDisabled2 ? dist$4.noop : onClick
    }, children2);
};
const root$13 = "VoteInput-scss--module__root___Ubril";
const input$3 = "VoteInput-scss--module__input___BYe75";
const inputContainer = "VoteInput-scss--module__inputContainer___JX2sr";
const staticValue = "VoteInput-scss--module__staticValue___4bReU";
const button$e = "VoteInput-scss--module__button___5nJ-5";
const s$1H = {
    root: root$13,
    input: input$3,
    inputContainer: inputContainer,
    staticValue: staticValue,
    button: button$e
};
const locales$10 = {
    voice: "\u0413\u043E\u043B\u043E\u0441"
};
const t$10 = distExports$1.getTranslation && locales$10;
const VoteInput = (0, $acw62.forwardRef)((props, ref2)=>{
    const { id, className, color: color2, isDisabled: isDisabled2 = false, onVoice = dist$4.noop } = props;
    const [points2, setPoints] = (0, $acw62.useState)("");
    const pointIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    const pointsBalance = (0, $iD0SF.useSelector)(pointBalanceSelector);
    const isEmptyPoints = !Number(points2);
    const isPointsEnough = Number(points2) <= pointsBalance;
    const handleClick = ()=>{
        onVoice(id, Number(points2));
    };
    const handleKeyDown = (event2)=>{
        if (!isEmptyPoints && isPointsEnough && event2.key === EKeyboardKey.ENTER) onVoice(id, Number(points2));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1H.root, className)
    }, /* @__PURE__ */ $acw62.createElement(InputNumber, {
        ref: ref2,
        className: s$1H.inputContainer,
        classNameInput: s$1H.input,
        classNameStaticValue: s$1H.staticValue,
        disabled: isDisabled2,
        staticValue: /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
            className: s$1H.icon,
            src: pointIconUrl
        }),
        limit: 5,
        value: points2.toString(),
        onChange: (evt)=>{
            setPoints(evt.target.value);
        },
        onKeyDown: handleKeyDown
    }), /* @__PURE__ */ $acw62.createElement(ButtonAlert, {
        className: s$1H.button,
        color: color2,
        isDisabled: isDisabled2 || isEmptyPoints || !isPointsEnough,
        onClick: handleClick
    }, t$10.voice));
});
VoteInput.displayName = "VoiceInput";
const root$12 = "DecisionCardColumnLayoutWithInput-scss--module__root___cRwPd";
const input$2 = "DecisionCardColumnLayoutWithInput-scss--module__input___rBDy0";
const decision = "DecisionCardColumnLayoutWithInput-scss--module__decision___uMLCD";
const hidden$1 = "DecisionCardColumnLayoutWithInput-scss--module__hidden___5fizZ";
const s$1G = {
    root: root$12,
    input: input$2,
    decision: decision,
    hidden: hidden$1
};
const DecisionCardColumnLayoutWithInput = (0, $acw62.forwardRef)((props, ref2)=>{
    const { className, data, isDisabled: isDisabled2, isSelected, pointsBankPrediction, isSelectable, onVoice = dist$4.noop } = props;
    const { id, order } = data;
    const { color: color2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement(DecisionCardBase, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1G.root, className),
        color: color2,
        isSelectable: isSelectable,
        isSelected: isSelected
    }, /* @__PURE__ */ $acw62.createElement(DecisionContentColumnLayout, {
        className: s$1G.decision,
        data: data,
        pointsBankPrediction: pointsBankPrediction
    }), /* @__PURE__ */ $acw62.createElement(VoteInput, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1G.input, {
            [s$1G.hidden]: isDisabled2
        }),
        id: id,
        color: color2,
        isDisabled: isDisabled2,
        ref: ref2,
        onVoice: onVoice
    }));
});
DecisionCardColumnLayoutWithInput.displayName = "DecisionCardColumnLayoutWithInput";
const titleRow = "DecisionCardRowLayoutSelectedWithInput-scss--module__titleRow___AmJ8s";
const cellTitle = "DecisionCardRowLayoutSelectedWithInput-scss--module__cellTitle___UadhV";
const flexNone = "DecisionCardRowLayoutSelectedWithInput-scss--module__flexNone___g-L8P";
const inputRow = "DecisionCardRowLayoutSelectedWithInput-scss--module__inputRow___F7RTc";
const s$1F = {
    titleRow: titleRow,
    cellTitle: cellTitle,
    flexNone: flexNone,
    inputRow: inputRow
};
const DecisionCardRowLayoutSelectedWithInput = (props)=>{
    const { data: { id, order, name: name2, pointsBank }, isDisabled: isDisabled2, pointsBankPrediction, onVoice } = props;
    const inputRef = (0, $acw62.useRef)();
    const { pointIconUrl, outcome, color: color2, icon: icon2 } = useDecision({
        order: order,
        pointsBankPrediction: pointsBankPrediction,
        pointsBank: pointsBank
    });
    (0, $acw62.useEffect)(()=>{
        var _a3;
        (_a3 = inputRef.current) == null || _a3.focus();
    }, []);
    return /* @__PURE__ */ $acw62.createElement(DecisionCardBase, {
        color: color2,
        isSelected: true
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1F.titleRow
    }, /* @__PURE__ */ $acw62.createElement(DecisionTitle, {
        className: s$1F.cellTitle,
        glyph: icon2,
        value: name2
    }), /* @__PURE__ */ $acw62.createElement(DecisionRatioCell, {
        className: s$1F.flexNone,
        value: outcome
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1F.inputRow
    }, /* @__PURE__ */ $acw62.createElement(DecisionBadgesBar, {
        data: props.data,
        pointIconUrl: pointIconUrl
    }), !isDisabled2 && Boolean(onVoice) && /* @__PURE__ */ $acw62.createElement(VoteInput, {
        id: id,
        color: color2,
        isDisabled: isDisabled2,
        ref: inputRef,
        onVoice: onVoice
    })));
};
const list$4 = "BoxChooseWinnerStreamer-scss--module__list___a252Q";
const actions = "BoxChooseWinnerStreamer-scss--module__actions___6cpfG";
const s$1E = {
    list: list$4,
    actions: actions
};
const locales$$ = {
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    choose: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"
};
const t$$ = distExports$1.getTranslation && locales$$;
const BoxChooseWinnerStreamer = (props)=>{
    const { data: { decisions }, onChoose = dist$4.noop, onDelete = dist$4.noop } = props;
    const [isSelected, setIsSelected] = (0, $acw62.useState)();
    const [confirmNode, onOpen] = useDelete({
        onConfirm: onDelete
    });
    return /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1E.list
    }, decisions.map((item2)=>/* @__PURE__ */ $acw62.createElement(DecisionCardShortLayout, {
            key: item2.id,
            data: item2,
            isSelected: isSelected === item2.id,
            onClick: ()=>setIsSelected(item2.id)
        }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1E.actions
    }, /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.NEGATIVE,
        mode: EButtonMode.TERTIARY,
        size: EButtonSize.SMALL,
        onClick: onOpen
    }, t$$.delete), /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.ACCENT,
        isDisabled: isSelected === void 0,
        size: EButtonSize.SMALL,
        onClick: ()=>onChoose(isSelected)
    }, t$$.choose)), confirmNode);
};
const root$11 = "DecisionListColumnLayout-scss--module__root___TqCsu";
const s$1D = {
    root: root$11
};
const DecisionListColumnLayout = (props)=>{
    const { className, data: { decisions, pointsBank }, isSelectable, isSelected } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1D.root, className)
    }, decisions.map((item2)=>{
        const { id } = item2;
        return /* @__PURE__ */ $acw62.createElement(DecisionCardRowLayout, {
            key: id,
            data: item2,
            isSelected: Boolean(isSelected) && isSelected(item2),
            pointsBankPrediction: pointsBank,
            isSelectable: isSelectable
        });
    }));
};
const root$10 = "DecisionListRowLayout-scss--module__root___h9598";
const item$3 = "DecisionListRowLayout-scss--module__item___8tITB";
const s$1C = {
    root: root$10,
    item: item$3
};
const DecisionListRowLayout = (props)=>{
    const { className, data: { decisions, pointsBank }, isSelectable, isSelected } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1C.root, className)
    }, decisions.map((item2)=>{
        const { id } = item2;
        return /* @__PURE__ */ $acw62.createElement(DecisionCardColumnLayout, {
            className: s$1C.item,
            key: id,
            data: item2,
            isSelected: Boolean(isSelected) && isSelected(item2),
            pointsBankPrediction: pointsBank,
            isSelectable: isSelectable
        });
    }));
};
const DecisionList = (props)=>{
    const { className, isSelectable, data, isSelected } = props;
    const { decisions } = data;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, onlyTwoElementsInArray(decisions) ? /* @__PURE__ */ $acw62.createElement(DecisionListRowLayout, {
        isSelected: isSelected,
        isSelectable: isSelectable,
        data: data
    }) : /* @__PURE__ */ $acw62.createElement(DecisionListColumnLayout, {
        isSelected: isSelected,
        isSelectable: isSelectable,
        data: data
    }));
};
const root$$ = "DecisionListColumnLayoutSelectableWithVoice-scss--module__root___s-rZh";
const s$1B = {
    root: root$$
};
const DecisionListColumnLayoutSelectableWithVoice = (props)=>{
    const { className, data: { decisions, pointsBank }, onVoice = dist$4.noop } = props;
    const [selectedDecision, setSelectedDecision] = (0, $acw62.useState)();
    const hasChoice = decisions.some((item2)=>item2.previousDecision);
    const handleClick = (id)=>{
        setSelectedDecision(id);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1B.root, className)
    }, decisions.map((item2)=>{
        const { id, previousDecision } = item2;
        return selectedDecision === id ? /* @__PURE__ */ $acw62.createElement(DecisionCardRowLayoutSelectedWithInput, {
            key: id,
            data: item2,
            isDisabled: hasChoice && !previousDecision,
            pointsBankPrediction: pointsBank,
            onVoice: onVoice
        }) : /* @__PURE__ */ $acw62.createElement(DecisionCardRowLayout, {
            key: id,
            data: item2,
            isSelected: hasChoice && previousDecision,
            pointsBankPrediction: pointsBank,
            onClick: handleClick
        });
    }));
};
const root$_ = "DecisionListRowLayoutWithInput-scss--module__root___-WWZO";
const item$2 = "DecisionListRowLayoutWithInput-scss--module__item___vKFdy";
const s$1A = {
    root: root$_,
    item: item$2
};
const DecisionListRowLayoutWithInput = (props)=>{
    const { className, data, onVoice } = props;
    const { decisions, pointsBank } = data;
    const itemsRef = (0, $acw62.useRef)([]);
    const hasChoice = decisions.some((item2)=>item2.previousDecision);
    (0, $acw62.useEffect)(()=>{
        var _a3;
        (_a3 = itemsRef.current[0]) == null || _a3.focus();
        itemsRef.current.some((item2)=>{
            if (item2) item2.focus();
            return item2;
        });
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1A.root, className)
    }, decisions.map((item2, i)=>{
        const { id, previousDecision } = item2;
        return /* @__PURE__ */ $acw62.createElement(DecisionCardColumnLayoutWithInput, {
            key: id,
            className: s$1A.item,
            data: item2,
            ref: (inst)=>inst && (itemsRef.current[i] = inst),
            isDisabled: hasChoice && !previousDecision,
            isSelected: hasChoice && previousDecision,
            isSelectable: false,
            pointsBankPrediction: pointsBank,
            onVoice: onVoice
        });
    }));
};
const DecisionListSelectableWithVoice = (props)=>{
    const { data, onVoice } = props;
    const { decisions } = data;
    return /* @__PURE__ */ $acw62.createElement("div", null, onlyTwoElementsInArray(decisions) ? /* @__PURE__ */ $acw62.createElement(DecisionListRowLayoutWithInput, {
        data: data,
        onVoice: onVoice
    }) : /* @__PURE__ */ $acw62.createElement(DecisionListColumnLayoutSelectableWithVoice, {
        data: data,
        onVoice: onVoice
    }));
};
const root$Z = "DecisionListColumnLayoutSelectable-scss--module__root___GxKJi";
const s$1z = {
    root: root$Z
};
const DecisionListColumnLayoutSelectable = (props)=>{
    const { className, data: { decisions, pointsBank } } = props;
    const [selectedDecision, setSelectedDecision] = (0, $acw62.useState)();
    const handleClick = (id)=>{
        setSelectedDecision(id);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1z.root, className)
    }, decisions.map((item2)=>{
        const { id } = item2;
        return selectedDecision === id ? /* @__PURE__ */ $acw62.createElement(DecisionCardRowLayoutSelectedWithInput, {
            key: id,
            data: item2,
            pointsBankPrediction: pointsBank
        }) : /* @__PURE__ */ $acw62.createElement(DecisionCardRowLayout, {
            key: id,
            data: item2,
            pointsBankPrediction: pointsBank,
            onClick: handleClick
        });
    }));
};
const DecisionListSelectable = (props)=>{
    const { data } = props;
    const { decisions } = data;
    return /* @__PURE__ */ $acw62.createElement("div", null, onlyTwoElementsInArray(decisions) ? /* @__PURE__ */ $acw62.createElement(DecisionListRowLayout, {
        data: data
    }) : /* @__PURE__ */ $acw62.createElement(DecisionListColumnLayoutSelectable, {
        data: data
    }));
};
const root$Y = "PredictionResultInfo-scss--module__root___-Qd1N";
const icon$m = "PredictionResultInfo-scss--module__icon___Ute0z";
const s$1y = {
    root: root$Y,
    icon: icon$m
};
const locales$_ = {
    send: "{{biggestWinAmount}} \u0443\u0445\u043E\u0434\u044F\u0442 {{biggestBidUserNick}} \u0438 \u0435\u0449\u0435 {{userAmount}}",
    sendToOne: "{{biggestWinAmount}} \u0443\u0445\u043E\u0434\u044F\u0442 {{biggestBidUserNick}}",
    unknown: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439",
    participant1: "\u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0443",
    participant2: "\u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C",
    participant5: "\u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C"
};
const t$_ = distExports$1.getTranslation && locales$_;
const PredictionResultInfo = (props)=>{
    const { className, data: { biggestBidUser, biggestWinAmount, userAmount } } = props;
    const pointIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    if (!biggestBidUser) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null);
    const { nick: biggestBidUserNick } = biggestBidUser;
    const infoText = userAmount === 1 || userAmount === 0 ? distExports$1.getParametrizedText(t$_.sendToOne, {
        biggestWinAmount: biggestWinAmount,
        biggestBidUserNick: biggestBidUserNick || t$_.unknown
    }) : distExports$1.getParametrizedText(t$_.send, {
        biggestWinAmount: biggestWinAmount,
        biggestBidUserNick: biggestBidUserNick || t$_.unknown,
        userAmount: userAmount ? declOfNum([
            t$_.participant1,
            t$_.participant2,
            t$_.participant5
        ], userAmount - 1) : 0
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1y.root, className)
    }, /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        className: s$1y.icon,
        src: pointIconUrl
    }), infoText);
};
const result$1 = "BoxPredictionResultStreamer-scss--module__result___X6vQh";
const info$2 = "BoxPredictionResultStreamer-scss--module__info___3lAAM";
const s$1x = {
    result: result$1,
    info: info$2
};
const locales$Z = {
    result: "\u0418\u0441\u0445\u043E\u0434"
};
const t$Z = distExports$1.getTranslation && locales$Z;
const BoxPredictionResultStreamer = (props)=>{
    const { data } = props;
    const winningDecision = data.decisions.find((item2)=>item2.isWinner);
    const { name: name2, order } = winningDecision || {};
    const { color: color2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(DecisionList, {
        data: data,
        isSelected: (decision2)=>decision2.isWinner,
        isSelectable: false
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1x.result
    }, /* @__PURE__ */ $acw62.createElement("div", null, t$Z.result), /* @__PURE__ */ $acw62.createElement("div", {
        style: {
            color: color2
        }
    }, name2)), /* @__PURE__ */ $acw62.createElement(PredictionResultInfo, {
        className: s$1x.info,
        data: winningDecision
    }));
};
const decisionActions = "BoxPredictionStreamer-scss--module__decisionActions___1WJ9X";
const s$1w = {
    decisionActions: decisionActions
};
const locales$Y = {
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    done: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C",
    confirmDoneTitle: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    confirmDoneText: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043F\u0440\u0438\u0435\u043C \u0433\u043E\u043B\u043E\u0441\u043E\u0432 \u0434\u043E\u0441\u0440\u043E\u0447\u043D\u043E?",
    confirmButtonDoneText: "\u0414\u0430, \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C"
};
const t$Y = distExports$1.getTranslation && locales$Y;
const BoxPredictionStreamer = (props)=>{
    const { data, onDelete = dist$4.noop, onDone = dist$4.noop } = props;
    const [shouldShowDoneConfirm, setShouldShowDoneConfirm] = (0, $acw62.useState)(false);
    const [confirmNode, onOpen] = useDelete({
        onConfirm: onDelete
    });
    const handleDone = ()=>{
        setShouldShowDoneConfirm(true);
    };
    const handleDoneCancel = ()=>{
        setShouldShowDoneConfirm(false);
    };
    const handleDoneConfirm = ()=>{
        onDone();
        setShouldShowDoneConfirm(false);
    };
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(DecisionListSelectable, {
        data: data
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1w.decisionActions
    }, /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.NEGATIVE,
        mode: EButtonMode.TERTIARY,
        size: EButtonSize.SMALL,
        onClick: onOpen
    }, t$Y.delete), /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.ACCENT,
        size: EButtonSize.SMALL,
        onClick: handleDone
    }, t$Y.done)), shouldShowDoneConfirm && /* @__PURE__ */ $acw62.createElement(ConfirmPopup$1, {
        title: t$Y.confirmDoneTitle,
        text: t$Y.confirmDoneText,
        confirmButtonText: t$Y.confirmButtonDoneText,
        onCancel: handleDoneCancel,
        onConfirm: handleDoneConfirm
    }), confirmNode);
};
const name$6 = "PreviousDecision-scss--module__name___bYfKR";
const icon$l = "PreviousDecision-scss--module__icon___opU92";
const s$1v = {
    name: name$6,
    icon: icon$l
};
const locales$X = {
    for: "\u0437\u0430"
};
const t$X = distExports$1.getTranslation && locales$X;
const PreviousDecision = (props)=>{
    const { order, name: name2, userBid } = props;
    const pointsIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    const { color: color2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$1v.name,
        style: {
            color: color2
        }
    }, `\xab${name2}\xbb`), t$X.for, /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        className: s$1v.icon,
        src: pointsIconUrl
    }), userBid);
};
const root$X = "PreviousDecisionYouChose-scss--module__root___leAy0";
const s$1u = {
    root: root$X,
    "await": "PreviousDecisionYouChose-scss--module__await___zfv93"
};
const locales$W = {
    youChose: "\u0412\u044B \u0432\u044B\u0431\u0440\u0430\u043B\u0438",
    waitForResult: "\u041E\u0436\u0438\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430"
};
const t$W = distExports$1.getTranslation && locales$W;
const PreviousDecisionYouChose = (props)=>{
    const { className, data: { name: name2, order, userBid } } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1u.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", null, t$W.youChose, /* @__PURE__ */ $acw62.createElement(PreviousDecision, {
        name: name2,
        order: order,
        userBid: userBid
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1u.await
    }, t$W.waitForResult));
};
const footer$7 = "BoxPredictionUser-scss--module__footer___AkPGd";
const confirmTitle = "BoxPredictionUser-scss--module__confirmTitle___r1Mxq";
const s$1t = {
    footer: footer$7,
    confirmTitle: confirmTitle
};
const locales$V = {
    toVoice: "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u043F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C"
};
const t$V = distExports$1.getTranslation && locales$V;
const BoxPredictionUser = (props)=>{
    const { data, onVoice = dist$4.noop } = props;
    const { decisions } = data;
    const [shouldShowPopup, setShouldShowPopup] = (0, $acw62.useState)(false);
    const [selectedDecision, setSelectedDecision] = (0, $acw62.useState)();
    const [selectedPoints, setSelectedPoints] = (0, $acw62.useState)();
    const previousDecision = decisions.find((item2)=>item2.previousDecision);
    const getConfirmTitle = ()=>{
        const { name: name2, order } = decisions.find((item2)=>item2.id === selectedDecision);
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", null, t$V.toVoice), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$1t.confirmTitle
        }, /* @__PURE__ */ $acw62.createElement(PreviousDecision, {
            name: name2,
            order: order,
            userBid: selectedPoints
        })));
    };
    const clear = ()=>{
        setShouldShowPopup(false);
        setSelectedDecision(void 0);
        setSelectedPoints(void 0);
    };
    const handleVoice = (id, points2)=>{
        setShouldShowPopup(true);
        setSelectedDecision(id);
        setSelectedPoints(points2);
    };
    const handleCancel = ()=>{
        clear();
    };
    const handleConfirm = ()=>{
        onVoice(selectedDecision, selectedPoints);
        clear();
    };
    return /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(DecisionListSelectableWithVoice, {
        data: data,
        onVoice: handleVoice
    }), Boolean(previousDecision) && /* @__PURE__ */ $acw62.createElement(PreviousDecisionYouChose, {
        className: s$1t.footer,
        data: previousDecision
    }), shouldShowPopup && (0, $1u0KT.createPortal)(/* @__PURE__ */ $acw62.createElement(ConfirmPopup$1, {
        title: getConfirmTitle(),
        onCancel: handleCancel,
        onConfirm: handleConfirm
    }), document.getElementById(EPortal.PREDICTION_MODAL)));
};
const root$W = "PredictionResultImage-scss--module__root___N8eOk";
const s$1s = {
    root: root$W
};
const PredictionResultImage = (props)=>{
    const { className } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1s.root, className)
    });
};
const info$1 = "PredictionResultOrigin-scss--module__info___Fyff6";
const diceLooser1 = "PredictionResultOrigin-scss--module__diceLooser1___dKvA6";
const diceLooser2 = "PredictionResultOrigin-scss--module__diceLooser2___I3IWH";
const diceLooser3 = "PredictionResultOrigin-scss--module__diceLooser3___XvgSB";
const diceLooser4 = "PredictionResultOrigin-scss--module__diceLooser4___PkzsE";
const diceLooser5 = "PredictionResultOrigin-scss--module__diceLooser5___n51Kg";
const diceLooser6 = "PredictionResultOrigin-scss--module__diceLooser6___gtIP-";
const s$1r = {
    info: info$1,
    diceLooser1: diceLooser1,
    diceLooser2: diceLooser2,
    diceLooser3: diceLooser3,
    diceLooser4: diceLooser4,
    diceLooser5: diceLooser5,
    diceLooser6: diceLooser6
};
const mapOrderToClassName = [
    "diceLooser1",
    "diceLooser2",
    "diceLooser3",
    "diceLooser4",
    "diceLooser5",
    "diceLooser6"
];
const PredictionResultOrigin = (props)=>{
    const { className, data } = props;
    const { order } = data;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement(PredictionResultImage, {
        className: s$1r[mapOrderToClassName[order]]
    }), /* @__PURE__ */ $acw62.createElement(PredictionResultInfo, {
        className: s$1r.info,
        data: data
    }));
};
const next = "PredictionResultLooser-scss--module__next___oKkvo";
const s$1q = {
    next: next
};
const locales$U = {
    next: "\u041F\u043E\u0432\u0435\u0437\u0435\u0442 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437!"
};
const t$U = distExports$1.getTranslation && locales$U;
const PredictionResultLooser = (props)=>{
    const { data } = props;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(PredictionResultOrigin, {
        data: data
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1q.next
    }, t$U.next));
};
const root$V = "PredictionResultWinner-scss--module__root___-xApN";
const youWin = "PredictionResultWinner-scss--module__youWin___vwIT7";
const diceWinner1 = "PredictionResultWinner-scss--module__diceWinner1___VxyRh";
const diceWinner2 = "PredictionResultWinner-scss--module__diceWinner2___iXX00";
const diceWinner3 = "PredictionResultWinner-scss--module__diceWinner3___jg-a4";
const diceWinner4 = "PredictionResultWinner-scss--module__diceWinner4___MoR3M";
const diceWinner5 = "PredictionResultWinner-scss--module__diceWinner5___-9tAo";
const diceWinner6 = "PredictionResultWinner-scss--module__diceWinner6___EvH9P";
const icon$k = "PredictionResultWinner-scss--module__icon___dDDv6";
const fadeIn = "PredictionResultWinner-scss--module__fadeIn___8RvAj";
const s$1p = {
    root: root$V,
    youWin: youWin,
    diceWinner1: diceWinner1,
    diceWinner2: diceWinner2,
    diceWinner3: diceWinner3,
    diceWinner4: diceWinner4,
    diceWinner5: diceWinner5,
    diceWinner6: diceWinner6,
    icon: icon$k,
    fadeIn: fadeIn
};
const locales$T = {
    youWin: "\u0412\u044B \u0432\u044B\u0438\u0433\u0440\u0430\u043B\u0438"
};
const t$T = distExports$1.getTranslation && locales$T;
const mapOrderToWinnerClassName = [
    "diceWinner1",
    "diceWinner2",
    "diceWinner3",
    "diceWinner4",
    "diceWinner5",
    "diceWinner6"
];
const PredictionResultWinner = (props)=>{
    const { className, data } = props;
    const { order, pointsWinAmount } = data;
    const pointIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement(PredictionResultImage, {
        className: s$1p[mapOrderToWinnerClassName[order]]
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1p.youWin
    }, t$T.youWin, !isNil(pointsWinAmount) && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        className: s$1p.icon,
        src: pointIconUrl
    }), `${pointsWinAmount}!`)), /* @__PURE__ */ $acw62.createElement(PredictionResultInfo, {
        data: data
    }));
};
const root$U = "PredictionResult-scss--module__root___oHKTT";
const button$d = "PredictionResult-scss--module__button___O1VV4";
const s$1o = {
    root: root$U,
    button: button$d
};
const locales$S = {
    details: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
};
const t$S = distExports$1.getTranslation && locales$S;
const PredictionResult = (props)=>{
    const { className, data, onDetails = dist$4.noop } = props;
    const { decisions } = data;
    let box;
    const previousDecision = decisions.find((item2)=>item2.previousDecision);
    const winnerDecision = decisions.find((item2)=>item2.isWinner);
    if (previousDecision) box = previousDecision.isWinner ? /* @__PURE__ */ $acw62.createElement(PredictionResultWinner, {
        data: winnerDecision
    }) : /* @__PURE__ */ $acw62.createElement(PredictionResultLooser, {
        data: winnerDecision
    });
    else box = /* @__PURE__ */ $acw62.createElement(PredictionResultOrigin, {
        data: winnerDecision
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1o.root, className)
    }, box, /* @__PURE__ */ $acw62.createElement(Button$1, {
        className: s$1o.button,
        mode: EButtonMode.SECONDARY,
        onClick: onDetails
    }, t$S.details));
};
const button$c = "PredictionResultDetails-scss--module__button___J0bx5";
const row$1 = "PredictionResultDetails-scss--module__row___JddF5";
const s$1n = {
    button: button$c,
    row: row$1
};
const locales$R = {
    close: "\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438"
};
const t$R = distExports$1.getTranslation && locales$R;
const PredictionResultDetails = (props)=>{
    const { className, data, onClose = dist$4.noop } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement(DecisionList, {
        data: data,
        isSelectable: false,
        isSelected: (decision2)=>decision2.isWinner
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1n.row
    }, /* @__PURE__ */ $acw62.createElement(Button$1, {
        className: s$1n.button,
        onClick: onClose,
        mode: EButtonMode.SECONDARY
    }, t$R.close)));
};
const root$T = "PredictionResultForUnauthorized-scss--module__root___AAYQL";
const button$b = "PredictionResultForUnauthorized-scss--module__button___2G-h4";
const s$1m = {
    root: root$T,
    button: button$b
};
const locales$Q = {
    details: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
};
const t$Q = distExports$1.getTranslation && locales$Q;
const PredictionResultForUnauthorized = (props)=>{
    const { data: { decisions }, onDetails } = props;
    const winnerDecision = decisions.find((item2)=>item2.isWinner);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1m.root
    }, /* @__PURE__ */ $acw62.createElement(PredictionResultOrigin, {
        data: winnerDecision
    }), /* @__PURE__ */ $acw62.createElement(Button, {
        className: s$1m.button,
        onClick: onDetails
    }, t$Q.details));
};
const details = "BoxPredictionResultUser-scss--module__details___fm0XC";
const result = "BoxPredictionResultUser-scss--module__result___ORq8G";
const s$1l = {
    details: details,
    result: result
};
const BoxPredictionResultUser = (props)=>{
    const { data, isAuthorized = true } = props;
    const [shouldShowDetails, setShouldShowDetails] = (0, $acw62.useState)(false);
    const handleDetails = ()=>{
        setShouldShowDetails(true);
    };
    const handleClose = ()=>{
        setShouldShowDetails(false);
    };
    const Component2 = isAuthorized ? PredictionResult : PredictionResultForUnauthorized;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !shouldShowDetails && /* @__PURE__ */ $acw62.createElement(Component2, {
        className: s$1l.result,
        data: data,
        onDetails: handleDetails
    }), shouldShowDetails && /* @__PURE__ */ $acw62.createElement(PredictionResultDetails, {
        className: s$1l.details,
        data: data,
        onClose: handleClose
    }));
};
const footer$6 = "BoxAwaitResultUser-scss--module__footer___QBmsk";
const s$1k = {
    footer: footer$6
};
const BoxAwaitResultUser = (props)=>{
    const { data } = props;
    const { decisions } = data;
    const previousDecision = decisions.find((item2)=>item2.previousDecision);
    return /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(DecisionList, {
        isSelectable: false,
        data: data,
        isSelected: (item2)=>item2.previousDecision
    }), Boolean(previousDecision) && /* @__PURE__ */ $acw62.createElement(PreviousDecisionYouChose, {
        className: s$1k.footer,
        data: previousDecision
    }));
};
const BoxPredictionNotAuthorized = (props)=>{
    const { data } = props;
    return /* @__PURE__ */ $acw62.createElement(DecisionListSelectable, {
        data: data
    });
};
const root$S = "PredictionPopupActionClose-scss--module__root___C6OUZ";
const s$1j = {
    root: root$S
};
const PredictionPopupActionClose = (props)=>{
    const { className, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_cancel_outline_28,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1j.root, className),
        onClick: onClose
    });
};
const root$R = "PredictionPopupHeader-scss--module__root___Uze0m";
const s$1i = {
    root: root$R
};
const PredictionPopupHeader = (props)=>{
    const { title: title2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1i.root
    }, title2);
};
const root$Q = "PredictionPopupLayout-scss--module__root___TRxEr";
const s$1h = {
    root: root$Q
};
const PredictionPopupLayout = (props)=>{
    const { children: children2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1h.root,
        id: EPortal.PREDICTION_MODAL
    }, children2);
};
const root$P = "PredictionPopupTopBar-scss--module__root___ZOhtO";
const s$1g = {
    root: root$P
};
const PredictionPopupTopBar = (props)=>{
    const { children: children2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1g.root
    }, children2);
};
const controls$2 = "PredictionPopup-scss--module__controls___Rtv05";
const icon$j = "PredictionPopup-scss--module__icon___-Lq1h";
const iconArrow$2 = "PredictionPopup-scss--module__iconArrow___AUmaR";
const iconArrowRotated$2 = "PredictionPopup-scss--module__iconArrowRotated___wpf9K";
const titlePrediction = "PredictionPopup-scss--module__titlePrediction___ov8kS";
const titlePredictionExpanded = "PredictionPopup-scss--module__titlePredictionExpanded___96PRx";
const titlePredictionCollapsed = "PredictionPopup-scss--module__titlePredictionCollapsed___z5BF-";
const children$1 = "PredictionPopup-scss--module__children___LT3nE";
const s$1f = {
    controls: controls$2,
    icon: icon$j,
    iconArrow: iconArrow$2,
    iconArrowRotated: iconArrowRotated$2,
    titlePrediction: titlePrediction,
    titlePredictionExpanded: titlePredictionExpanded,
    titlePredictionCollapsed: titlePredictionCollapsed,
    children: children$1
};
const PredictionPopup = (props)=>{
    const { children: children2, title: title2, data, isTimebar = true, withExpand = true, onClose } = props;
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(!withExpand);
    const handelExpandClick = ()=>{
        setIsExpanded((prev)=>!prev);
    };
    return /* @__PURE__ */ $acw62.createElement(PredictionPopupLayout, null, /* @__PURE__ */ $acw62.createElement(PredictionPopupTopBar, null, /* @__PURE__ */ $acw62.createElement(PredictionPopupHeader, {
        title: title2
    }), withExpand && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1f.controls
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        onClick: handelExpandClick,
        glyph: svg_name_chevron_left_outline_24,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1f.icon, s$1f.iconArrow, {
            [s$1f.iconArrowRotated]: isExpanded
        })
    }), /* @__PURE__ */ $acw62.createElement(PredictionPopupActionClose, {
        onClose: onClose
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1f.titlePrediction, {
            [s$1f.titlePredictionExpanded]: isExpanded,
            [s$1f.titlePredictionCollapsed]: !isExpanded
        })
    }, data.title), isTimebar && /* @__PURE__ */ $acw62.createElement(TimelineCountDown, {
        startTime: data.createdAt,
        duration: data.duration
    }), isExpanded && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1f.children
    }, children2));
};
const title$g = "PredictionPopupResult-scss--module__title___NjX05";
const head$1 = "PredictionPopupResult-scss--module__head___al6Tf";
const winner = "PredictionPopupResult-scss--module__winner___7GpZu";
const s$1e = {
    title: title$g,
    head: head$1,
    winner: winner
};
const PredictionPopupResult = (props)=>{
    const { children: children2, title: title2, data, onClose } = props;
    const { order, name: name2 } = data.decisions.find((item2)=>item2.isWinner) || {};
    const { color: color2 } = getDecisionConfig(order);
    return /* @__PURE__ */ $acw62.createElement(PredictionPopupLayout, null, /* @__PURE__ */ $acw62.createElement(PredictionPopupTopBar, null, /* @__PURE__ */ $acw62.createElement(PredictionPopupHeader, {
        title: title2
    }), /* @__PURE__ */ $acw62.createElement(PredictionPopupActionClose, {
        onClose: onClose
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1e.head
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1e.title
    }, data.title), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1e.winner,
        style: {
            color: color2
        }
    }, name2)), children2);
};
const locales$P = {
    title: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0437\u0430 \u0431\u0430\u043B\u043B\u044B",
    chooseWinner: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u0441\u0445\u043E\u0434",
    results: "\u0418\u0441\u0445\u043E\u0434",
    predict: "\u041F\u0440\u0435\u0434\u0441\u043A\u0430\u0437\u0430\u0442\u044C",
    predictionSummary: "\u0418\u0442\u043E\u0433\u0438 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    unknownStatus: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441",
    awaitResult: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0438\u0442\u043E\u0433\u043E\u0432",
    deletePredictionSuccess: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0443\u0434\u0430\u043B\u0451\u043D",
    deletePredictionError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    donePredictionSuccess: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D",
    donePredictionError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430",
    decisionPredictionSuccess: "\u0412\u044B\u0431\u043E\u0440 \u0441\u0434\u0435\u043B\u0430\u043D",
    decisionPredictionError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u0438\u0441\u0445\u043E\u0434\u0430",
    voicePredictionSuccess: "\u0412\u044B\u0431\u043E\u0440 \u0441\u0434\u0435\u043B\u0430\u043D",
    voicePredictionError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u0438"
};
const t$P = distExports$1.getTranslation && locales$P;
const Prediction = (props)=>{
    const { blogUrl, predictionData: prediction, isAuthorized, isInChatPinned = false, onClose, onOpen = noop$1 } = props;
    const { creator: { id: creatorId } } = prediction;
    const currentUserId = (0, $iD0SF.useSelector)(currentUserIdSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const { canAdministrateChannel, canModerateChatChannel } = useCurrentUserAccess();
    const isCreator = creatorId === currentUserId;
    const hasOwnerAccess = canAdministrateChannel || canModerateChatChannel && isCreator;
    const handleCloseClick = ()=>{
        onClose();
    };
    const handleDeleteClick = async ()=>{
        if (!isInChatPinned) onClose();
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(deletePrediction.action)({
                blogUrl: blogUrl
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: t$P.deletePredictionSuccess
            });
        } catch (err) {
            onOpen();
            showAlert({
                type: EAlertType.ERROR,
                text: t$P.deletePredictionError
            });
        }
    };
    const handleDoneClick = async ()=>{
        dispatch(setStatePrediction({
            state: EPredictionStatus.DECISION
        }));
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(donePrediction.action)({
                blogUrl: blogUrl
            }));
        } catch (err) {
            dispatch(setStatePrediction({
                state: EPredictionStatus.ACTIVE
            }));
            showAlert({
                type: EAlertType.ERROR,
                text: t$P.donePredictionError
            });
        }
    };
    const handleChoose = async (id)=>{
        dispatch(setWinnerPrediction({
            id: id
        }));
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(manageDecisionPrediction.action)({
                blogUrl: blogUrl,
                id: id
            }));
        } catch (error2) {
            dispatch(setStatePrediction({
                state: EPredictionStatus.DECISION
            }));
            showAlert({
                type: EAlertType.ERROR,
                text: t$P.decisionPredictionError
            });
        }
    };
    const handleVoice = async (id, amount)=>{
        const { id: previousDecisionId } = ((prediction == null ? void 0 : prediction.decisions) || []).find((item2)=>item2.id === id && item2.previousDecision) || {};
        dispatch(decisionPredictionVoice({
            id: id,
            amount: amount
        }));
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(decisionPrediction.action)({
                blogUrl: blogUrl,
                id: id,
                amount: amount
            }));
        } catch (err) {
            previousDecisionId ? dispatch(subtractVoicePrediction({
                id: id,
                amount: amount
            })) : dispatch(decisionPredictionUnvoice({
                id: id,
                amount: amount
            }));
            showAlert({
                type: EAlertType.ERROR,
                text: t$P.voicePredictionError
            });
        }
    };
    const boxPredictionStreamer = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.title,
        data: prediction,
        onClose: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionStreamer, {
        data: prediction,
        onDelete: handleDeleteClick,
        onDone: handleDoneClick
    }));
    const boxPredictionNotAuthorized = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.title,
        data: prediction,
        onClose: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionNotAuthorized, {
        data: prediction
    }));
    const boxPredictionAwaitResultNotAuthorized = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.awaitResult,
        data: prediction,
        onClose: handleCloseClick,
        isTimebar: false
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionNotAuthorized, {
        data: prediction
    }));
    const boxChooseWinnerStreamer = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.chooseWinner,
        data: prediction,
        onClose: handleCloseClick,
        isTimebar: false
    }, /* @__PURE__ */ $acw62.createElement(BoxChooseWinnerStreamer, {
        data: prediction,
        onChoose: handleChoose,
        onDelete: handleDeleteClick
    }));
    const boxPredictionResultStreamer = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.results,
        data: prediction,
        onClose: handleCloseClick,
        isTimebar: false
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionResultStreamer, {
        data: prediction
    }));
    const isPreviousDecision = prediction.decisions.some((item2)=>item2.previousDecision);
    const boxPredictionUser = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: isPreviousDecision ? t$P.awaitResult : t$P.title,
        data: prediction,
        onClose: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionUser, {
        onVoice: handleVoice,
        data: prediction
    }));
    const boxAwaitResultUser = /* @__PURE__ */ $acw62.createElement(PredictionPopup, {
        title: t$P.awaitResult,
        data: prediction,
        onClose: handleCloseClick,
        isTimebar: false
    }, /* @__PURE__ */ $acw62.createElement(BoxAwaitResultUser, {
        data: prediction
    }));
    const boxResultUser = /* @__PURE__ */ $acw62.createElement(PredictionPopupResult, {
        title: t$P.predictionSummary,
        data: prediction,
        onClose: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionResultUser, {
        data: prediction,
        isAuthorized: true
    }));
    const boxResultNotAuthorized = /* @__PURE__ */ $acw62.createElement(PredictionPopupResult, {
        title: t$P.predictionSummary,
        data: prediction,
        onClose: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(BoxPredictionResultUser, {
        data: prediction,
        isAuthorized: false
    }));
    let box;
    switch(prediction == null ? void 0 : prediction.state){
        case EPredictionStatus.ACTIVE:
            box = isAuthorized ? hasOwnerAccess ? boxPredictionStreamer : boxPredictionUser : boxPredictionNotAuthorized;
            break;
        case EPredictionStatus.DECISION:
            box = isAuthorized ? hasOwnerAccess ? boxChooseWinnerStreamer : boxAwaitResultUser : boxPredictionAwaitResultNotAuthorized;
            break;
        case EPredictionStatus.ENDED:
            box = isAuthorized ? hasOwnerAccess ? boxPredictionResultStreamer : boxResultUser : boxResultNotAuthorized;
            break;
    }
    return Boolean(box) && box;
};
const root$O = "ListItem-scss--module__root___DtSVU";
const selected$1 = "ListItem-scss--module__selected___IXqZY";
const selectable = "ListItem-scss--module__selectable___jb0JL";
const s$1d = {
    root: root$O,
    selected: selected$1,
    selectable: selectable
};
const ListItem = (0, $acw62.forwardRef)((props, ref2)=>{
    const { children: children2, className, isSelectable = false, isSelected = false, onClick } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1d.root, {
            [s$1d.selected]: isSelected,
            [s$1d.selectable]: isSelectable
        }, className),
        ref: ref2,
        onClick: onClick
    }, children2);
});
ListItem.displayName = "ListItem";
const name$5 = "DecisionItem-scss--module__name___OoIih";
const icon$i = "DecisionItem-scss--module__icon___Af9aD";
const s$1c = {
    name: name$5,
    icon: icon$i
};
const DecisionItem = (props)=>{
    const { data, onClick = dist$4.noop, ...restProps } = props;
    const handleClick = ()=>{
        onClick(data);
    };
    return /* @__PURE__ */ $acw62.createElement(ListItem, {
        onClick: handleClick,
        ...restProps
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1c.name
    }, data.name), Boolean(data.previousDecision) && /* @__PURE__ */ $acw62.createElement(Icon16, {
        className: s$1c.icon,
        glyph: svg_name_check_outline_16
    }));
};
const progressLine$1 = "DecisionItemActualState-scss--module__progressLine___-XGAs";
const name$4 = "DecisionItemActualState-scss--module__name___eGIwb";
const icon$h = "DecisionItemActualState-scss--module__icon___-YSa8";
const info = "DecisionItemActualState-scss--module__info___J9hlK";
const progress = "DecisionItemActualState-scss--module__progress___uAwOh";
const highlighted = "DecisionItemActualState-scss--module__highlighted___vfqzn";
const bar = "DecisionItemActualState-scss--module__bar___mG8ek";
const s$1b = {
    progressLine: progressLine$1,
    name: name$4,
    icon: icon$h,
    info: info,
    progress: progress,
    highlighted: highlighted,
    bar: bar
};
const DecisionItemActualState = (props)=>{
    const { className, data, isHighlighted, votesCount, onClick, ...restProps } = props;
    const [rootWidth, setRootWidth] = (0, $acw62.useState)(0);
    const rootRef = (0, $acw62.useRef)(null);
    const percent = votesCount ? Math.floor((data.votesCount || 0) / votesCount * 100) : 0;
    const handleClick = ()=>{
        onClick == null || onClick(data);
    };
    (0, $acw62.useLayoutEffect)(()=>{
        if (!rootRef.current) return void 0;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries)if (entry.contentBoxSize) setRootWidth(entry.contentBoxSize[0].inlineSize);
        });
        observer.observe(rootRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /* @__PURE__ */ $acw62.createElement(ListItem, {
        className: className,
        ref: rootRef,
        onClick: handleClick,
        ...restProps
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.progressLine,
        style: {
            width: `${percent}%`
        }
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1b.progress, {
            [s$1b.highlighted]: isHighlighted
        }),
        style: {
            width: `${rootWidth}px`
        }
    }, isHighlighted && /* @__PURE__ */ $acw62.createElement(Icon16, {
        className: s$1b.iconCup,
        glyph: svg_name_cup_outline_20
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.name
    }, data.name), Boolean(data.previousDecision) && /* @__PURE__ */ $acw62.createElement(Icon16, {
        className: s$1b.icon,
        glyph: svg_name_check_outline_16
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.info
    }, `${percent}% (${data.votesCount || 0})`))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.bar
    }, isHighlighted && /* @__PURE__ */ $acw62.createElement(Icon16, {
        className: s$1b.iconCup,
        glyph: svg_name_cup_outline_20
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.name
    }, data.name), Boolean(data.previousDecision) && /* @__PURE__ */ $acw62.createElement(Icon16, {
        className: s$1b.icon,
        glyph: svg_name_check_outline_16
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$1b.info
    }, `${percent}% (${data.votesCount || 0})`)));
};
const useDecsionItemComponent = (data)=>{
    const ItemComponentActualState = (0, $acw62.useMemo)(()=>function DecisionItemActualStateAdapter(decisionItemProps) {
            if (!data) return null;
            return /* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                votesCount: data.votesCount,
                ...decisionItemProps
            });
        }, [
        data
    ]);
    if (data.hideResults) return DecisionItem;
    else return ItemComponentActualState;
};
const root$N = "DefaultIcon-scss--module__root___7qiTp";
const s$1a = {
    root: root$N
};
const DefaultIcon = (props)=>{
    const { src: src2 = "", alt = "", className, glyph } = props;
    const image2 = /* @__PURE__ */ $acw62.createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1a.root, className),
        src: src2,
        alt: alt
    });
    const imagePlaceholder = /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1a.root, className),
        glyph: glyph
    });
    return !src2.length ? imagePlaceholder : image2;
};
const root$M = "PointsIcon-scss--module__root___vcQPS";
const s$19 = {
    root: root$M
};
const PointsIcon = (props)=>{
    const { className = "", ...restProps } = props;
    return /* @__PURE__ */ $acw62.createElement(DefaultIcon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$19.root, className),
        ...restProps,
        glyph: svg_name_coin
    });
};
const root$L = "ConfirmPopup-scss--module__root___dP4Gx";
const layout = "ConfirmPopup-scss--module__layout___eW-50";
const header$6 = "ConfirmPopup-scss--module__header___LvOFF";
const icon$g = "ConfirmPopup-scss--module__icon___yMlLn";
const label$1 = "ConfirmPopup-scss--module__label___ji1bC";
const checkbox = "ConfirmPopup-scss--module__checkbox___WfIBC";
const footer$5 = "ConfirmPopup-scss--module__footer___D1lJn";
const s$18 = {
    root: root$L,
    layout: layout,
    header: header$6,
    icon: icon$g,
    label: label$1,
    checkbox: checkbox,
    footer: footer$5
};
const locales$O = {
    title: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u043E\u043B\u043E\u0441 \u0431\u0443\u0434\u0435\u0442 \u0441\u0442\u043E\u0438\u0442\u044C {{price}}",
    dontShowAgain: "\u041D\u0435 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
    cancel: "\u041E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F",
    vote: "\u041F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C"
};
const t$O = distExports$1.getTranslation && locales$O;
const ConfirmPopup = (props)=>{
    const { data, onClose, onConfirm, onShowAgainChecked } = props;
    const pointsIconUrl = (0, $iD0SF.useSelector)(pointMediumImageSelector);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$18.layout
    }, /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$18.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$18.header
    }, distExports$1.getParametrizedText(t$O.title, {
        price: data.votePrice
    }), /* @__PURE__ */ $acw62.createElement(PointsIcon, {
        className: s$18.icon,
        src: pointsIconUrl
    })), /* @__PURE__ */ $acw62.createElement(SimpleCheckBox, {
        containerClassName: s$18.checkbox,
        labelClassName: s$18.label,
        label: t$O.dontShowAgain,
        onToggle: onShowAgainChecked
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$18.footer
    }, /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.ACCENT,
        mode: EButtonMode.SECONDARY,
        onClick: onClose
    }, t$O.cancel), /* @__PURE__ */ $acw62.createElement(Button$1, {
        appearance: EButtonAppearance.ACCENT,
        onClick: onConfirm
    }, t$O.vote)))));
};
const root$K = "ListLayout-scss--module__root___mQm6K";
const s$17 = {
    root: root$K
};
const ListLayout = (props)=>{
    const { children: children2, className } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$17.root, className)
    }, children2);
};
const DecisionsList = (props)=>{
    const { className, ItemComponent = "div", data } = props;
    return /* @__PURE__ */ $acw62.createElement(ListLayout, {
        className: className
    }, data.map((item2)=>/* @__PURE__ */ $acw62.createElement(ItemComponent, {
            key: item2.id,
            data: item2
        })));
};
const DecisionsListSelectable = (props)=>{
    const { className, data, ItemComponent, value: value2, onChange } = props;
    const [selected2, setSelected] = (0, $acw62.useState)(value2);
    const handleSelectClick = (decision2)=>{
        setSelected(decision2);
        onChange(decision2);
    };
    (0, $acw62.useEffect)(()=>{
        setSelected(value2);
    }, [
        value2
    ]);
    return /* @__PURE__ */ $acw62.createElement(ListLayout, {
        className: className
    }, data.map((item2)=>/* @__PURE__ */ $acw62.createElement(ItemComponent, {
            key: item2.id,
            data: item2,
            isSelectable: true,
            isSelected: item2.id === (selected2 == null ? void 0 : selected2.id),
            onClick: handleSelectClick
        })));
};
const button$a = "VoteForm-scss--module__button___CXTFJ";
const s$16 = {
    button: button$a
};
const locales$N = {
    vote: "\u041F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C",
    voteFor: "\u041F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0442\u044C \u0437\u0430 {{price}}",
    voteError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u0438",
    voteSuccess: '\u0412\u044B \u043F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043B\u0438 \u0437\u0430 "{{name}}"',
    for: "\u0437\u0430",
    additionalVote: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u043E\u043B\u043E\u0441 \u0431\u0443\u0434\u0435\u0442 \u0441\u0442\u043E\u0438\u0442\u044C",
    balanceError: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0431\u0430\u043B\u043B\u043E\u0432 \u0437\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u043E\u043B\u043E\u0441"
};
const t$N = distExports$1.getTranslation && locales$N;
const VoteForm = (props)=>{
    const { blogUrl, className, data, DecisionItemComponent } = props;
    const [selected2, setSelected] = (0, $acw62.useState)(null);
    const [shouldShowConfirm, setShouldShowConfirm] = (0, $acw62.useState)(false);
    const [isShowAgainConfirmChecked, setIsShowAgainConfirmChecked] = (0, $acw62.useState)(false);
    const pointsIconUrl = (0, $iD0SF.useSelector)(pointMediumImageSelector);
    const pointBalance = (0, $iD0SF.useSelector)(pointBalanceSelector);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const confirmRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const previousDecision = data.decisions.find((item2)=>item2.previousDecision);
    const canMakeAdditionalDecision = data.allowAdditionalVotes;
    const freeDecisionWasMade = (previousDecision == null ? void 0 : previousDecision.userVotesCount) >= 1;
    const handleChange = (decision2)=>{
        setSelected(decision2);
    };
    const handleVoteClick = async ()=>{
        try {
            const selectedDecision = data.decisions.find((decision2)=>decision2.id === selected2.id);
            dispatch(setVoteChannelPoll({
                decisionId: selected2.id
            }));
            await dispatch((0, $7Uc0p.thunkToAction)(voteChannelPoll.action)({
                blogUrl: blogUrl,
                decisionId: (selected2 == null ? void 0 : selected2.id) || 0
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: distExports$1.getParametrizedText(t$N.voteSuccess, {
                    name: selectedDecision.name
                })
            });
        } catch (ignore) {
            dispatch(unsetVoteChannelPoll({
                decisionId: selected2.id
            }));
            showAlert({
                type: EAlertType.ERROR,
                text: t$N.voteError
            });
        }
    };
    const handleVoteConfirm = async ()=>{
        var _a3;
        if ((_a3 = currentUser2.flags) == null ? void 0 : _a3[ECurrentUserFlag.IS_CHANNEL_POLL_ADDITIONAL_VOTE_CONFIRM]) return Promise.resolve();
        setShouldShowConfirm(true);
        return new Promise((resolve, reject)=>{
            confirmRef.current = {
                resolve: resolve,
                reject: reject
            };
        });
    };
    const handleAdditionalVoteClick = async ()=>{
        if (data.votePrice > pointBalance) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$N.balanceError
            });
            return;
        }
        try {
            await handleVoteConfirm();
            await handleVoteClick();
        } catch (ignore) {}
    };
    const setFlag = async ()=>{
        try {
            dispatch(setUserFlag({
                flag: ECurrentUserFlag.IS_CHANNEL_POLL_ADDITIONAL_VOTE_CONFIRM
            }));
            await dispatch((0, $7Uc0p.thunkToAction)(updateUserFlag.action)({
                flag: ECurrentUserFlag.IS_CHANNEL_POLL_ADDITIONAL_VOTE_CONFIRM
            }));
        } catch (ignore) {
            dispatch(unsetUserFlag({
                flag: ECurrentUserFlag.IS_CHANNEL_POLL_ADDITIONAL_VOTE_CONFIRM
            }));
        }
    };
    const closeConfirm = ()=>{
        if (isShowAgainConfirmChecked) setFlag();
        setShouldShowConfirm(false);
    };
    const handleClose = ()=>{
        closeConfirm();
        if (confirmRef.current) {
            confirmRef.current.reject();
            confirmRef.current = null;
        }
    };
    const handleConfirm = ()=>{
        closeConfirm();
        if (confirmRef.current) {
            confirmRef.current.resolve();
            confirmRef.current = null;
        }
    };
    const renderContent = ()=>{
        if (freeDecisionWasMade && !canMakeAdditionalDecision) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(DecisionsList, {
            data: data.decisions,
            ItemComponent: DecisionItemComponent
        }), /* @__PURE__ */ $acw62.createElement(Button$1, {
            className: s$16.button,
            disabled: true,
            stretched: true
        }, t$N.vote));
        else if (freeDecisionWasMade && canMakeAdditionalDecision) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(DecisionsListSelectable, {
            data: data.decisions,
            ItemComponent: DecisionItemComponent,
            value: selected2,
            onChange: handleChange
        }), /* @__PURE__ */ $acw62.createElement(Button$1, {
            after: /* @__PURE__ */ $acw62.createElement(PointsIcon, {
                src: pointsIconUrl
            }),
            className: s$16.button,
            disabled: !selected2 || selected2.id !== (previousDecision == null ? void 0 : previousDecision.id),
            stretched: true,
            onClick: handleAdditionalVoteClick
        }, distExports$1.getParametrizedText(t$N.voteFor, {
            price: data.votePrice
        })));
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(DecisionsListSelectable, {
            data: data.decisions,
            ItemComponent: DecisionItemComponent,
            value: selected2,
            onChange: handleChange
        }), /* @__PURE__ */ $acw62.createElement(Button$1, {
            className: s$16.button,
            disabled: !selected2,
            stretched: true,
            onClick: handleVoteClick
        }, t$N.vote));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, renderContent(), shouldShowConfirm && (0, $1u0KT.createPortal)(/* @__PURE__ */ $acw62.createElement(ConfirmPopup, {
        data: data,
        onClose: handleClose,
        onConfirm: handleConfirm,
        onShowAgainChecked: setIsShowAgainConfirmChecked
    }), document.getElementById(EPortal.CHANNEL_POLL_MODAL)));
};
const ChannelPollActiveUser = (props)=>{
    const { data } = props;
    const DecisionItemComponent = useDecsionItemComponent(data);
    return /* @__PURE__ */ $acw62.createElement(VoteForm, {
        data: data,
        DecisionItemComponent: DecisionItemComponent,
        ...props
    });
};
const ChannelPollActiveOwner = (props)=>{
    const { className, data } = props;
    const ItemComponent = (0, $acw62.useMemo)(()=>function DecisionItemAdapter(decisionItemAdapterProps) {
            if (!data) return null;
            return /* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                votesCount: data.votesCount,
                ...decisionItemAdapterProps
            });
        }, [
        data
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement(DecisionsList, {
        ItemComponent: ItemComponent,
        data: data.decisions
    }));
};
const ChannelPollActiveUnauthorized = (props)=>{
    const { className, data } = props;
    const ItemComponent = (0, $acw62.useMemo)(()=>function DecisionItemAdapter(decisionItemAdapterProps) {
            if (!data) return null;
            if (data.hideResults) return /* @__PURE__ */ $acw62.createElement(DecisionItem, {
                ...decisionItemAdapterProps
            });
            return /* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                votesCount: data.votesCount,
                ...decisionItemAdapterProps
            });
        }, [
        data
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: className
    }, /* @__PURE__ */ $acw62.createElement(DecisionsList, {
        data: data.decisions,
        ItemComponent: ItemComponent
    }));
};
const stat = "ChannelPollEnded-scss--module__stat___KO5wH";
const cell = "ChannelPollEnded-scss--module__cell___4OhM0";
const num = "ChannelPollEnded-scss--module__num___bJu-T";
const text$4 = "ChannelPollEnded-scss--module__text___sdrJp";
const withBottomSpace = "ChannelPollEnded-scss--module__withBottomSpace___YKXHx";
const decisionsList = "ChannelPollEnded-scss--module__decisionsList___PKWnp";
const head = "ChannelPollEnded-scss--module__head___pW9Mi";
const topVotersList = "ChannelPollEnded-scss--module__topVotersList___6oBia";
const voter = "ChannelPollEnded-scss--module__voter___6qGDS";
const index = "ChannelPollEnded-scss--module__index___vMBGq";
const name$3 = "ChannelPollEnded-scss--module__name___oGz-4";
const points$1 = "ChannelPollEnded-scss--module__points___zPuoe";
const s$15 = {
    stat: stat,
    cell: cell,
    num: num,
    text: text$4,
    withBottomSpace: withBottomSpace,
    decisionsList: decisionsList,
    head: head,
    topVotersList: topVotersList,
    voter: voter,
    index: index,
    name: name$3,
    points: points$1
};
const locales$M = {
    votes: "\u0433\u043E\u043B\u043E\u0441\u043E\u0432",
    voters: "\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u0432\u0448\u0438\u0445",
    points: "\u0431\u0430\u043B\u043B\u043E\u0432 \u043F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u043E",
    spentPoints: "\u041F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u0431\u0430\u043B\u043B\u044B"
};
const t$M = distExports$1.getTranslation && locales$M;
const ChannelPollEnded = (props)=>{
    var _a3;
    const { data } = props;
    const mediumPointsIcon = (0, $iD0SF.useSelector)(pointMediumImageSelector);
    const hasSpentPointsBlock = Boolean((_a3 = data.topVoters) == null ? void 0 : _a3.length);
    const ItemComponentActualState = (0, $acw62.useMemo)(()=>function DecisionItemActualStateAdapter(decisionItemProps) {
            const { data: decisionData } = decisionItemProps;
            if (!decisionData) return null;
            return /* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                isHighlighted: decisionData.isWinner,
                votesCount: data.votesCount,
                ...decisionItemProps
            });
        }, [
        data
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(DecisionsList, {
        className: s$15.decisionsList,
        data: data.decisions,
        ItemComponent: ItemComponentActualState
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$15.stat, {
            [s$15.withBottomSpace]: hasSpentPointsBlock
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.cell
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.num
    }, data.votesCount), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.text
    }, t$M.votes)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.cell
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.num
    }, data.votersCount), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.text
    }, t$M.voters)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.cell
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.num
    }, data.pointsBank), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.text
    }, t$M.points))), hasSpentPointsBlock && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$15.head
    }, /* @__PURE__ */ $acw62.createElement(PointsIcon, {
        src: mediumPointsIcon
    }), /* @__PURE__ */ $acw62.createElement("div", null, t$M.spentPoints)), /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        className: s$15.topVotersList
    }, data.topVoters.map((item2, index2)=>/* @__PURE__ */ $acw62.createElement("div", {
            key: item2.voter.id,
            className: s$15.voter
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$15.index
        }, `${index2 + 1}.`), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$15.name
        }, item2.voter.name), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$15.points
        }, item2.pointsSpent))))));
};
const ChannelPollActiveModerator = (props)=>{
    const { data, ...restProps } = props;
    const ItemComponentActualState = (0, $acw62.useMemo)(()=>function DecisionItemActualStateAdapter(decisionItemProps) {
            if (!data) return null;
            return /* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                votesCount: data.votesCount,
                ...decisionItemProps
            });
        }, [
        data
    ]);
    return /* @__PURE__ */ $acw62.createElement(VoteForm, {
        data: data,
        DecisionItemComponent: ItemComponentActualState,
        ...restProps
    });
};
const root$J = "PinnedBlockHeader-scss--module__root___nznJS";
const s$14 = {
    root: root$J
};
const PinnedBlockHeader = (props)=>{
    const { title: title2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$14.root
    }, title2);
};
const root$I = "PinnedBlockLayout-scss--module__root___5hoQf";
const s$13 = {
    root: root$I
};
const PinnedBlockLayout = (props)=>{
    const { children: children2, className, portalId } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$13.root, className),
        id: portalId
    }, children2);
};
const root$H = "PinnedBlockTopBar-scss--module__root___sHYg2";
const s$12 = {
    root: root$H
};
const PinnedBlockTopBar = (props)=>{
    const { className, children: children2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$12.root, className)
    }, children2);
};
const root$G = "ProgressBar-scss--module__root___U6hqF";
const s$11 = {
    root: root$G
};
const ProgressBar = (props)=>{
    const { color: color2, percent, classNames } = props;
    return /* @__PURE__ */ $acw62.createElement(ProgressBar$1, {
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$11.root, classNames == null ? void 0 : classNames.root)
        },
        styles: {
            progressLine: {
                backgroundColor: color2 || ""
            }
        },
        percent: percent
    });
};
const controls$1 = "PinnedBlock-scss--module__controls___VSVWu";
const icon$f = "PinnedBlock-scss--module__icon___TJvo9";
const iconArrow$1 = "PinnedBlock-scss--module__iconArrow___kZjpH";
const iconArrowRotated$1 = "PinnedBlock-scss--module__iconArrowRotated___6giE0";
const onlyTopPadding = "PinnedBlock-scss--module__onlyTopPadding___zHO-Q";
const sidePadding = "PinnedBlock-scss--module__sidePadding___jtuO5";
const description$6 = "PinnedBlock-scss--module__description___EmT-7";
const content$8 = "PinnedBlock-scss--module__content___viahh";
const s$10 = {
    controls: controls$1,
    icon: icon$f,
    iconArrow: iconArrow$1,
    iconArrowRotated: iconArrowRotated$1,
    onlyTopPadding: onlyTopPadding,
    sidePadding: sidePadding,
    description: description$6,
    content: content$8
};
const PinnedBlock = (props)=>{
    const { children: children2, title: title2, timebar, timelineNode, withOnlyTopPadding, isExpandable = true, portalId, collapsedContent, renderDescription, renderControls, renderFooter, onClose } = props;
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    const handleExpandClick = ()=>{
        setIsExpanded((prev)=>!prev);
    };
    const renderTimebar = ()=>{
        if (!timebar) return null;
        if (timebar.render) return timebar.render(isExpanded);
        return /* @__PURE__ */ $acw62.createElement(ProgressBar, {
            percent: timebar.percent ?? 0
        });
    };
    const renderControlsBlock = ()=>{
        if (!onClose && !isExpandable && !renderControls) return null;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$10.controls
        }, renderControls && renderControls(isExpanded), isExpandable && /* @__PURE__ */ $acw62.createElement(Icon, {
            onClick: handleExpandClick,
            glyph: svg_name_arrow_short_bold,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$10.icon, s$10.iconArrow, {
                [s$10.iconArrowRotated]: isExpanded
            })
        }), onClose && /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_close_new,
            className: s$10.icon,
            onClick: onClose
        }));
    };
    const timeline = timelineNode ? timelineNode : renderTimebar();
    return /* @__PURE__ */ $acw62.createElement(PinnedBlockLayout, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$10.onlyTopPadding]: withOnlyTopPadding
        }),
        portalId: portalId
    }, /* @__PURE__ */ $acw62.createElement(PinnedBlockTopBar, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$10.sidePadding]: withOnlyTopPadding
        })
    }, title2 && /* @__PURE__ */ $acw62.createElement(PinnedBlockHeader, {
        title: title2
    }), renderControlsBlock()), renderDescription && renderDescription(isExpanded, s$10.description), timeline, !isExpanded && Boolean(collapsedContent) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$10.content
    }, collapsedContent), isExpanded && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$10.content
    }, children2), renderFooter && renderFooter(isExpanded));
};
const title$f = "ChannelPoll-scss--module__title___8TMA6";
const more = "ChannelPoll-scss--module__more___vuAVA";
const moreMenu = "ChannelPoll-scss--module__moreMenu___MFjxk";
const moreMenuItem = "ChannelPoll-scss--module__moreMenuItem___1wwSN";
const moreMenuDelete = "ChannelPoll-scss--module__moreMenuDelete___ArQfc";
const resultsList = "ChannelPoll-scss--module__resultsList___3QEx4";
const s$$ = {
    title: title$f,
    more: more,
    moreMenu: moreMenu,
    moreMenuItem: moreMenuItem,
    moreMenuDelete: moreMenuDelete,
    resultsList: resultsList
};
const locales$L = {
    title: "\u041E\u043F\u0440\u043E\u0441",
    titleEnd: "\u0418\u0442\u043E\u0433\u0438 \u043E\u043F\u0440\u043E\u0441\u0430",
    done: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C",
    delete: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    deleteSuccess: '\u041E\u043F\u0440\u043E\u0441 "{{title}}" \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D',
    deleteError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u043E\u043F\u0440\u043E\u0441\u0430",
    doneSuccess: "\u041E\u043F\u0440\u043E\u0441 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D",
    errorSuccess: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438"
};
const t$L = distExports$1.getTranslation && locales$L;
const ChannelPoll = (props)=>{
    const { blogUrl, data, onClose } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const { isAuthorized, isStreamOwner, canModerateChatChannel } = useCurrentUserAccess();
    const currentUserId = (0, $iD0SF.useSelector)(currentUserIdSelector);
    const tooltipRef = (0, $acw62.useRef)();
    const { showAlert } = useNotificationsContext();
    const isPollCreator = currentUserId === get(data, "creator.id");
    const hasPollOwnerAccess = isPollCreator || isStreamOwner;
    const handleDoneClick = async ()=>{
        tooltipRef.current.close();
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(doneChannelPoll.action)({
                blogUrl: blogUrl
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: t$L.doneSuccess
            });
        } catch (ignore) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$L.errorSuccess
            });
        }
    };
    const handleDeleteClick = async ()=>{
        tooltipRef.current.close();
        const prevData = data;
        try {
            dispatch(clearChannelPoll());
            await dispatch((0, $7Uc0p.thunkToAction)(deleteChannelPoll.action)({
                blogUrl: blogUrl
            }));
            showAlert({
                type: EAlertType.SUCCESS,
                text: distExports$1.getParametrizedText(t$L.deleteSuccess, {
                    title: prevData.title
                })
            });
        } catch (ignore) {
            dispatch(setChannelPoll({
                poll: prevData
            }));
            showAlert({
                type: EAlertType.ERROR,
                text: t$L.deleteError
            });
        }
    };
    const renderControls = ()=>{
        if (hasPollOwnerAccess && data.state === EChannelPollStatus.ACTIVE) return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            content: /* @__PURE__ */ $acw62.createElement("div", {
                className: s$$.moreMenu
            }, /* @__PURE__ */ $acw62.createElement("div", {
                className: s$$.moreMenuItem,
                onClick: handleDoneClick
            }, t$L.done), /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$$.moreMenuItem, s$$.moreMenuDelete),
                onClick: handleDeleteClick
            }, t$L.delete)),
            isGlobal: true,
            position: ETooltipPosition.BOTTOM_END,
            ref: tooltipRef,
            trigger: ETooltipTrigger.CLICK
        }, /* @__PURE__ */ $acw62.createElement(Icon16, {
            className: s$$.more,
            glyph: svg_name_more_vertical_16
        }));
        return null;
    };
    const renderDescription = (_2, descriptionClassName)=>/* @__PURE__ */ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$$.title, descriptionClassName)
        }, data.title);
    let channelPollNodeCalc = null;
    let timelineNodeCalc = null;
    let collapsedContentCalc = null;
    let titleCalc = "";
    switch(data.state){
        case EChannelPollStatus.ACTIVE:
            timelineNodeCalc = /* @__PURE__ */ $acw62.createElement(TimelineCountDown, {
                startTime: data.createdAt,
                duration: data.duration
            });
            collapsedContentCalc = null;
            titleCalc = t$L.title;
            if (!isAuthorized) channelPollNodeCalc = /* @__PURE__ */ $acw62.createElement(ChannelPollActiveUnauthorized, {
                data: data
            });
            else if (hasPollOwnerAccess) channelPollNodeCalc = /* @__PURE__ */ $acw62.createElement(ChannelPollActiveOwner, {
                data: data
            });
            else if (canModerateChatChannel) channelPollNodeCalc = /* @__PURE__ */ $acw62.createElement(ChannelPollActiveModerator, {
                blogUrl: blogUrl,
                data: data
            });
            else channelPollNodeCalc = /* @__PURE__ */ $acw62.createElement(ChannelPollActiveUser, {
                blogUrl: blogUrl,
                data: data
            });
            break;
        case EChannelPollStatus.ENDED:
            const wonDecisions = data.decisions.filter((item2)=>item2.isWinner);
            timelineNodeCalc = null;
            collapsedContentCalc = /* @__PURE__ */ $acw62.createElement("div", {
                className: s$$.resultsList
            }, wonDecisions.map((item2)=>/* @__PURE__ */ $acw62.createElement(DecisionItemActualState, {
                    data: item2,
                    isHighlighted: true,
                    key: item2.id,
                    votesCount: data.votesCount
                })));
            titleCalc = t$L.titleEnd;
            channelPollNodeCalc = /* @__PURE__ */ $acw62.createElement(ChannelPollEnded, {
                data: data
            });
            break;
    }
    return /* @__PURE__ */ $acw62.createElement(PinnedBlock, {
        collapsedContent: collapsedContentCalc,
        timelineNode: timelineNodeCalc,
        title: titleCalc,
        portalId: EPortal.CHANNEL_POLL_MODAL,
        onClose: onClose,
        renderControls: renderControls,
        renderDescription: renderDescription
    }, channelPollNodeCalc);
};
const useDropNotification = ()=>{
    const totalDrops = (0, $iD0SF.useSelector)(dropsProgressSelector);
    const drops = totalDrops.slice(0, 5);
    return {
        drops: drops
    };
};
const title$e = "DropsNotification-scss--module__title___6xv6A";
const category = "DropsNotification-scss--module__category___jTEQD";
const description$5 = "DropsNotification-scss--module__description___yztRq";
const list$3 = "DropsNotification-scss--module__list___jAAEl";
const listItem = "DropsNotification-scss--module__listItem___mmy0L";
const buttonsWrapper = "DropsNotification-scss--module__buttonsWrapper___zbrSa";
const button$9 = "DropsNotification-scss--module__button___G2WGA";
const card$2 = "DropsNotification-scss--module__card___1kOHA";
const cardImage$1 = "DropsNotification-scss--module__cardImage___hV75f";
const cardDescription = "DropsNotification-scss--module__cardDescription___eZPff";
const progressBar$1 = "DropsNotification-scss--module__progressBar___9-tXp";
const progressLine = "DropsNotification-scss--module__progressLine___DAOe6";
const s$_ = {
    title: title$e,
    category: category,
    description: description$5,
    list: list$3,
    listItem: listItem,
    buttonsWrapper: buttonsWrapper,
    button: button$9,
    card: card$2,
    cardImage: cardImage$1,
    cardDescription: cardDescription,
    progressBar: progressBar$1,
    progressLine: progressLine
};
const locales$K = {
    title: "\u0411\u043E\u043A\u0441-\u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0438",
    description: "\u041D\u0430 \u044D\u0442\u043E\u043C \u043A\u0430\u043D\u0430\u043B\u0435 \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043A\u0441\u044B",
    instructionButton: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043A\u0441\u044B",
    link: "\u041A \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u044F\u043C",
    defaultCategoryTitle: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"
};
const t$K = distExports$1.getTranslation && locales$K;
const DropsNotification = (props)=>{
    const { onClose } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const { drops: { notificationTimeout } } = getConfig();
    const { drops } = useDropNotification();
    const [progress2, setProgress] = (0, $acw62.useState)(0);
    const timeoutRef = (0, $acw62.useRef)();
    const requestRef = (0, $acw62.useRef)(null);
    const startDateRef = (0, $acw62.useRef)(Date.now());
    const animate = ()=>{
        const deltaTime = Date.now() - startDateRef.current;
        const playback = deltaTime / notificationTimeout;
        setProgress(Math.floor(playback * 100));
        if (playback < notificationTimeout) requestRef.current = requestAnimationFrame(animate);
        else onClose();
    };
    (0, $acw62.useEffect)(()=>{
        requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            cancelAnimationFrame(requestRef.current);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        timeoutRef.current = setTimeout(()=>{
            onClose();
        }, notificationTimeout);
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleInstruction = ()=>{
        dispatch(toggleVisibilityDropInstruction(true));
        onClose();
    };
    const isSingleDrop = drops.length === 1;
    const renderCard = (drop2)=>{
        var _a3, _b2;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.card
        }, /* @__PURE__ */ $acw62.createElement("img", {
            src: drop2.campaign.logoUrl,
            className: s$_.cardImage
        }), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.cardDescription
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.title
        }, drop2.campaign.title), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.category
        }, ((_b2 = (_a3 = drop2.campaign) == null ? void 0 : _a3.category) == null ? void 0 : _b2.title) || t$K.defaultCategoryTitle)));
    };
    const renderList = ()=>/* @__PURE__ */ $acw62.createElement("ul", {
            className: s$_.list
        }, drops.map((drop2)=>/* @__PURE__ */ $acw62.createElement("li", {
                className: s$_.listItem,
                key: drop2.campaign.id
            }, drop2.campaign.title)));
    const renderDescription = ()=>/* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.description
        }, t$K.description, ":"), isSingleDrop && renderCard(drops[0]), !isSingleDrop && renderList(), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$_.buttonsWrapper
        }, /* @__PURE__ */ $acw62.createElement(InlineButton, {
            className: s$_.button,
            onClick: handleInstruction
        }, t$K.instructionButton), /* @__PURE__ */ $acw62.createElement("a", {
            className: s$_.button,
            href: URLS.DROPS_CAMPAIGNS
        }, /* @__PURE__ */ $acw62.createElement(InlineButton, {
            className: s$_.button
        }, t$K.link))), /* @__PURE__ */ $acw62.createElement(ProgressBar$1, {
            classNames: {
                root: s$_.progressBar,
                progressLine: s$_.progressLine
            },
            direction: EProgressBarDirection.RIGHT_TO_LEFT,
            percent: progress2
        }));
    return /* @__PURE__ */ $acw62.createElement(PinnedBlock, {
        title: t$K.title,
        renderDescription: renderDescription,
        isExpandable: false,
        onClose: onClose
    });
};
const root$F = "DurationSelector-scss--module__root___W6Yge";
const menu = "DurationSelector-scss--module__menu___B1d5l";
const icon$e = "DurationSelector-scss--module__icon___diJQ5";
const label = "DurationSelector-scss--module__label___Lgk-b";
const list$2 = "DurationSelector-scss--module__list___F6iz4";
const item$1 = "DurationSelector-scss--module__item___2lZVJ";
const s$Z = {
    root: root$F,
    menu: menu,
    icon: icon$e,
    label: label,
    list: list$2,
    item: item$1
};
const locales$J = {
    permanent: "\u0422\u043E\u043B\u044C\u043A\u043E \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
    stream: "\u041F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438",
    temporary: ""
};
const t$J = distExports$1.getTranslation && locales$J;
const DurationSelector = (props)=>{
    const { value: value2, onChange } = props;
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const handleToggle = ()=>{
        setIsVisible(!isVisible);
    };
    const handleClose = ()=>{
        setIsVisible(false);
    };
    const handleItemClick = (kind)=>{
        onChange(kind);
        setIsVisible(false);
    };
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: handleClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.menu,
        onClick: handleToggle
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.label
    }, t$J[value2]), /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$Z.icon,
        glyph: svg_name_arrow_short_bold
    })), isVisible && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.list
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.item,
        onClick: ()=>handleItemClick(EPinnedMessageKind.PERMANENT)
    }, t$J[EPinnedMessageKind.PERMANENT]), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Z.item,
        onClick: ()=>handleItemClick(EPinnedMessageKind.STREAM)
    }, t$J[EPinnedMessageKind.STREAM]))));
};
const root$E = "Settings-scss--module__root___p5hqN";
const settingsItem = "Settings-scss--module__settingsItem___7W-4W";
const icon$d = "Settings-scss--module__icon___X5EUN";
const s$Y = {
    root: root$E,
    settingsItem: settingsItem,
    icon: icon$d
};
const locales$I = {
    durationTitle: "\u041A\u043E\u0433\u0434\u0430 \u043E\u0442\u043A\u0440\u0435\u043F\u0438\u0442\u044C",
    reaction: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0435\u0430\u043A\u0446\u0438\u0438",
    unpin: "\u041E\u0442\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"
};
const t$I = distExports$1.getTranslation && locales$I;
const Settings = (props)=>{
    const { pinnedMessage, onClose, onUnpin, onChangeDuration, onChangeReaction } = props;
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Y.root
    }, /* @__PURE__ */ $acw62.createElement("div", null, t$I.durationTitle), /* @__PURE__ */ $acw62.createElement(DurationSelector, {
        value: pinnedMessage.kind,
        onChange: onChangeDuration
    }), /* @__PURE__ */ $acw62.createElement(ToggleSwitch, {
        togglePosition: "left",
        size: EToggleSwitchSize.SMALL,
        label: t$I.reaction,
        classNames: {
            label: s$Y.label,
            labelDisabled: s$Y.label,
            labelText: s$Y.labelText
        },
        onToggle: onChangeReaction,
        checked: pinnedMessage.reactable
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Y.settingsItem,
        onClick: onUnpin
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$Y.icon,
        glyph: svg_name_unpin
    }), t$I.unpin)));
};
var EPinnedReactionType = /* @__PURE__ */ ((EPinnedReactionType2)=>{
    EPinnedReactionType2["LIKE"] = "like";
    EPinnedReactionType2["DISLIKE"] = "dislike";
    EPinnedReactionType2["FIRE"] = "fire";
    EPinnedReactionType2["HEART"] = "heart";
    EPinnedReactionType2["LAUGHT"] = "laught";
    EPinnedReactionType2["WONDER"] = "wonder";
    EPinnedReactionType2["SAD"] = "sad";
    EPinnedReactionType2["ANGRY"] = "angry";
    EPinnedReactionType2["POO"] = "poo";
    EPinnedReactionType2["CLOWN"] = "clown";
    return EPinnedReactionType2;
})(EPinnedReactionType || {});
const REACTIONS = [
    {
        id: EPinnedReactionType.LIKE,
        icon: svg_name_like_reaction
    },
    {
        id: EPinnedReactionType.DISLIKE,
        icon: svg_name_dislike_reaction
    },
    {
        id: EPinnedReactionType.HEART,
        icon: svg_name_heart_reaction
    },
    {
        id: EPinnedReactionType.FIRE,
        icon: svg_name_fire_reaction
    },
    {
        id: EPinnedReactionType.LAUGHT,
        icon: svg_name_laught_reaction
    },
    {
        id: EPinnedReactionType.POO,
        icon: svg_name_poo_reaction
    },
    {
        id: EPinnedReactionType.CLOWN,
        icon: svg_name_clown_reaction
    }
];
const tooltipContainer = "ReactionSelector-scss--module__tooltipContainer___ENeK0";
const tooltipContent$1 = "ReactionSelector-scss--module__tooltipContent___3Cp2Y";
const content$7 = "ReactionSelector-scss--module__content___i8ofl";
const reactionItem$1 = "ReactionSelector-scss--module__reactionItem___Wxlig";
const icon$c = "ReactionSelector-scss--module__icon___wRgu0";
const s$X = {
    tooltipContainer: tooltipContainer,
    tooltipContent: tooltipContent$1,
    content: content$7,
    reactionItem: reactionItem$1,
    icon: icon$c
};
const ReactionItem = (props)=>{
    const { type, icon: icon2, onReactionClick } = props;
    const handleClick = ()=>onReactionClick(type);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$X.reactionItem,
        onClick: handleClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$X.icon,
        glyph: icon2
    }));
};
const ReactionSelector = (props)=>{
    const { children: children2, onReactionClick } = props;
    return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        trigger: ETooltipTrigger.CLICK,
        position: ETooltipPosition.TOP_START,
        classNames: {
            root: s$X.tooltipContainer,
            content: s$X.tooltipContent
        },
        content: /* @__PURE__ */ $acw62.createElement("div", {
            className: s$X.content
        }, REACTIONS.map(({ id, icon: icon2 })=>{
            return /* @__PURE__ */ $acw62.createElement(ReactionItem, {
                key: id,
                type: id,
                icon: icon2,
                onReactionClick: onReactionClick
            });
        }))
    }, children2);
};
const root$D = "GradientWrapper-scss--module__root___ecFuJ";
const top = "GradientWrapper-scss--module__top___ZqKIW";
const bottom = "GradientWrapper-scss--module__bottom___ikbXc";
const s$W = {
    root: root$D,
    top: top,
    bottom: bottom
};
const GradientWrapper = (props)=>{
    const { children: children2, contentRef, pinnedMessageId } = props;
    const [contentGradients, setContentGradients] = (0, $acw62.useState)([
        false,
        false
    ]);
    const handleContentWheel = ()=>{
        if (contentRef.current) {
            const { scrollTop, scrollHeight, offsetHeight } = contentRef.current;
            setContentGradients([
                scrollTop > 0,
                Number(offsetHeight) + Number(scrollTop) < scrollHeight
            ]);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (contentRef.current) contentRef.current.scrollTo(0, 0);
        handleContentWheel();
    }, [
        contentRef.current,
        pinnedMessageId
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$W.root, {
            [s$W.top]: contentGradients[0],
            [s$W.bottom]: contentGradients[1]
        }),
        onWheel: handleContentWheel
    }, children2);
};
const pinnedTitle = "MessageTitle-scss--module__pinnedTitle___7-30x";
const pinnedLabel = "MessageTitle-scss--module__pinnedLabel___-L-AY";
const pinnedIcon = "MessageTitle-scss--module__pinnedIcon___eyJJN";
const titleContent = "MessageTitle-scss--module__titleContent___kveRs";
const pinner = "MessageTitle-scss--module__pinner___fN-GE";
const pinnerName = "MessageTitle-scss--module__pinnerName___n91ub";
const s$V = {
    pinnedTitle: pinnedTitle,
    pinnedLabel: pinnedLabel,
    pinnedIcon: pinnedIcon,
    titleContent: titleContent,
    pinner: pinner,
    pinnerName: pinnerName
};
const MessageTitle = (props)=>{
    const { pinnerBadge, pinnerName: pinnerName2 } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$V.pinnedTitle
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$V.titleContent
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$V.pinner
    }, Boolean(pinnerBadge) && /* @__PURE__ */ $acw62.createElement(ChatBadge, {
        key: pinnerBadge.id,
        badge: pinnerBadge
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$V.pinnerName
    }, pinnerName2)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$V.pinnedLabel
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$V.pinnedIcon,
        glyph: svg_name_pinned_filled
    }))));
};
const root$C = "Message-scss--module__root___cmbrK";
const author$1 = "Message-scss--module__author___bcas-";
const titleControlsIcon = "Message-scss--module__titleControlsIcon___qOZ-U";
const contentWrapper = "Message-scss--module__contentWrapper___SqVab";
const content$6 = "Message-scss--module__content___SJs0p";
const contentExpanded = "Message-scss--module__contentExpanded___D--9t";
const authorName$1 = "Message-scss--module__authorName___zL7Oo";
const pinnedBy = "Message-scss--module__pinnedBy___CW-wl";
const writtenAt = "Message-scss--module__writtenAt___vxIOT";
const footer$4 = "Message-scss--module__footer___IrR8N";
const reactionLink = "Message-scss--module__reactionLink___OYl6r";
const reactionItem = "Message-scss--module__reactionItem___YomQz";
const reactionItemActive = "Message-scss--module__reactionItemActive___jqgqX";
const reactionItemIcon = "Message-scss--module__reactionItemIcon___DFZPC";
const reactionIcon = "Message-scss--module__reactionIcon___sgjsS";
const count$1 = "Message-scss--module__count___6Ff-E";
const countSelected = "Message-scss--module__countSelected___gXmq1";
const s$U = {
    root: root$C,
    author: author$1,
    titleControlsIcon: titleControlsIcon,
    contentWrapper: contentWrapper,
    content: content$6,
    contentExpanded: contentExpanded,
    authorName: authorName$1,
    pinnedBy: pinnedBy,
    writtenAt: writtenAt,
    footer: footer$4,
    reactionLink: reactionLink,
    reactionItem: reactionItem,
    reactionItemActive: reactionItemActive,
    reactionItemIcon: reactionItemIcon,
    reactionIcon: reactionIcon,
    count: count$1,
    countSelected: countSelected
};
const locales$H = {
    sent: "\u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E"
};
const t$H = distExports$1.getTranslation && locales$H;
const Message = (props)=>{
    var _a3, _b2, _c2;
    const { blogUrl, pinnedMessage, isAdmin, isAdminModerator, isChatModerator, isOwner, currentUser: currentUser2, onClose } = props;
    const { editPinnedChatMessage: editPinnedChatMessage2, unpinChatMessage: unpinChatMessage2, addPinnedChatMessageReaction: addPinnedChatMessageReaction2 } = usePinnedMessageSettings(blogUrl);
    const { theme } = useThemeContext();
    const contentRef = (0, $acw62.useRef)(null);
    const [shouldShowSettings, setShouldShowSettings] = (0, $acw62.useState)(false);
    const hasAccess = isChatModerator || isOwner || isAdmin || isAdminModerator;
    const isChatSettingsShowed = hasAccess && shouldShowSettings;
    const [authorBadge] = ((_a3 = pinnedMessage == null ? void 0 : pinnedMessage.author) == null ? void 0 : _a3.badges) || [];
    const [pinnerBadge] = ((_b2 = pinnedMessage == null ? void 0 : pinnedMessage.pinner) == null ? void 0 : _b2.badges) || [];
    const showToggleSettingsClick = ()=>{
        setShouldShowSettings(!shouldShowSettings);
    };
    const handleSettingsClose = ()=>{
        setTimeout(()=>setShouldShowSettings(false), 0);
    };
    const handleUnpin = ()=>{
        unpinChatMessage2();
    };
    const handleHide = ()=>{
        onClose();
        setShouldShowSettings(false);
    };
    const handleChangeDuration = (kind)=>{
        editPinnedChatMessage2({
            kind: kind,
            reactable: pinnedMessage.reactable
        });
    };
    const handleChangeReaction = (reactable)=>{
        editPinnedChatMessage2({
            kind: pinnedMessage.kind,
            reactable: reactable
        });
    };
    const nicknameColor = getChatNicknameColor((_c2 = pinnedMessage == null ? void 0 : pinnedMessage.author) == null ? void 0 : _c2.nickColor, theme);
    const writtenAtLabel = (0, $acw62.useMemo)(()=>{
        const dateNow = Date.now();
        const amountDays = getDaysBetweenDates(getUnixTime(pinnedMessage.writtenAt), dateNow);
        const isToday = amountDays < 1;
        const datetime = isToday ? getFormattedDate(pinnedMessage.writtenAt, "&/HH/mm") : getFormattedDate(pinnedMessage.writtenAt, "d/MMMM");
        return `${t$H.sent} ${datetime}`;
    }, [
        pinnedMessage.writtenAt
    ]);
    const renderTitle = ()=>{
        return /* @__PURE__ */ $acw62.createElement(MessageTitle, {
            pinnerBadge: pinnerBadge,
            pinnerName: pinnedMessage.pinner.nick
        });
    };
    const renderIcon = ()=>{
        if (hasAccess) return /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$U.titleControlsIcon,
            glyph: svg_name_dots,
            onClick: showToggleSettingsClick
        });
        return null;
    };
    const handleReactionClick = (reactionType)=>()=>!pinnedMessage.reacted && addPinnedChatMessageReaction2(reactionType);
    const renderFooter = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, pinnedMessage.reactable && /* @__PURE__ */ $acw62.createElement("div", {
            className: s$U.footer
        }, pinnedMessage.reactions.map((reaction)=>/* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$U.reactionItem, {
                    [s$U.reactionItemActive]: !pinnedMessage.reacted
                }),
                key: reaction.type,
                onClick: handleReactionClick(reaction.type)
            }, /* @__PURE__ */ $acw62.createElement(Icon, {
                className: s$U.reactionItemIcon,
                glyph: REACTIONS.find((item2)=>item2.id === reaction.type).icon
            }), /* @__PURE__ */ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$U.count, {
                    [s$U.countSelected]: reaction.type === pinnedMessage.reacted
                })
            }, reaction.count))), !pinnedMessage.reacted && Boolean(currentUser2) && /* @__PURE__ */ $acw62.createElement(ReactionSelector, {
            onReactionClick: addPinnedChatMessageReaction2
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$U.reactionLink
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$U.reactionIcon,
            glyph: svg_name_smile_add_outline_20
        })))), isChatSettingsShowed && /* @__PURE__ */ $acw62.createElement(Settings, {
            pinnedMessage: pinnedMessage,
            onClose: handleSettingsClose,
            onUnpin: handleUnpin,
            onChangeDuration: handleChangeDuration,
            onChangeReaction: handleChangeReaction
        }));
    };
    const renderDescription = (isExpanded)=>{
        if (isExpanded) return null;
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$U.root
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$U.contentWrapper
        }, /* @__PURE__ */ $acw62.createElement("div", {
            ref: contentRef,
            className: s$U.content
        }, /* @__PURE__ */ $acw62.createElement(ContentRenderer, {
            data: pinnedMessage.data
        }))));
    };
    return /* @__PURE__ */ $acw62.createElement(PinnedBlock, {
        title: renderTitle(),
        renderControls: renderIcon,
        renderFooter: renderFooter,
        renderDescription: renderDescription,
        onClose: handleHide
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$U.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$U.contentWrapper
    }, /* @__PURE__ */ $acw62.createElement(GradientWrapper, {
        contentRef: contentRef,
        pinnedMessageId: pinnedMessage.id
    }, /* @__PURE__ */ $acw62.createElement("div", {
        ref: contentRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$U.content, s$U.contentExpanded)
    }, /* @__PURE__ */ $acw62.createElement(ContentRenderer, {
        data: pinnedMessage.data
    })))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$U.pinnedBy
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$U.author
    }, Boolean(authorBadge) && /* @__PURE__ */ $acw62.createElement(ChatBadge, {
        key: authorBadge.id,
        badge: authorBadge
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$U.authorName,
        style: {
            color: nicknameColor
        }
    }, pinnedMessage.author.nick)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$U.writtenAt
    }, writtenAtLabel))));
};
const content$5 = "RaidNotification-scss--module__content___VTu9J";
const footer$3 = "RaidNotification-scss--module__footer___7d-CQ";
const progressBar = "RaidNotification-scss--module__progressBar___Tf-S8";
const progressBarLine = "RaidNotification-scss--module__progressBarLine___0DNKU";
const title$d = "RaidNotification-scss--module__title___FphpB";
const button$8 = "RaidNotification-scss--module__button___bcT-D";
const s$T = {
    content: content$5,
    footer: footer$3,
    progressBar: progressBar,
    progressBarLine: progressBarLine,
    title: title$d,
    button: button$8
};
const locales$G = {
    title: "\u0420\u0435\u0439\u0434",
    messageStreamer: "{{viewersCount}} \u0437\u0440\u0438\u0442\u0435\u043B\u0435\u0439 \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0435\u0439\u0434 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B {{target}} \u043F\u0440\u044F\u043C\u043E \u0441\u0435\u0439\u0447\u0430\u0441",
    messageViewer: "{{owner}} \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442 \u0440\u0435\u0439\u0434 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B {{target}} c {{viewersCount}} \u0440\u0435\u0439\u0434\u0435\u0440\u0430\u043C\u0438",
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
    startRaid: "\u041D\u0430\u0447\u0430\u0442\u044C \u0440\u0435\u0439\u0434",
    reject: "\u041E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F"
};
const t$G = distExports$1.getTranslation && locales$G;
const WAITING_TIME = 15;
const DURATION = 60;
const RaidNotification = (props)=>{
    const { streamRaid, isCurrentUserStream, onClose } = props;
    const { canModerateChannel } = useCurrentUserAccess();
    const hasPossibilityToStartRaid = isCurrentUserStream || canModerateChannel;
    const { blogUrl } = useStreamIdentity();
    const dispatch = (0, $2OPjR.useDispatch)();
    const interval = (0, $acw62.useRef)();
    const [isTimeout, setIsTimeout] = (0, $acw62.useState)(false);
    const [progress2, setProgress] = (0, $acw62.useState)(0);
    const clearStreamChatMessages = ()=>{
        dispatch(clearStreamChat());
        dispatch(cleanStreamChatMessagesFromWS());
        dispatch(cleanStreamChatMentions());
    };
    const handleRejectRaidClick = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(rejectRaid.action)({
            blogUrl: blogUrl
        }));
        onClose();
    };
    const handleCancelRaidClick = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(cancelRaid.action)({
            blogUrl: blogUrl
        }));
        onClose();
    };
    const handleStartRaidClick = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(startRaid.action)({
            blogUrl: blogUrl
        }));
        clearStreamChatMessages();
    };
    const text2 = distExports$1.getParametrizedText(hasPossibilityToStartRaid ? t$G.messageStreamer : t$G.messageViewer, {
        viewersCount: streamRaid.viewersCount,
        owner: streamRaid.owner.nick,
        target: streamRaid.targetOwner.nick
    });
    (0, $acw62.useEffect)(()=>{
        const timerMin = setTimeout(()=>{
            setIsTimeout(true);
        }, WAITING_TIME * 1e3);
        return ()=>{
            clearTimeout(timerMin);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isTimeout) interval.current = setInterval(()=>{
            setProgress((prev)=>prev + 100 / DURATION);
        }, 1e3);
        else clearInterval(interval.current);
    }, [
        isTimeout
    ]);
    (0, $acw62.useEffect)(()=>{
        if (progress2 > 100) {
            clearInterval(interval.current);
            setIsTimeout(false);
        }
    }, [
        progress2
    ]);
    const renderDescription = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$T.title
        }, t$G.title), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$T.content
        }, /* @__PURE__ */ $acw62.createElement(Avatar, {
            img: streamRaid.owner.avatarUrl,
            size: EAvatarSize.XS
        }), /* @__PURE__ */ $acw62.createElement("div", null, text2)), /* @__PURE__ */ $acw62.createElement(ProgressBar$1, {
            percent: progress2,
            direction: EProgressBarDirection.RIGHT_TO_LEFT,
            classNames: {
                root: s$T.progressBar,
                progressLine: s$T.progressBarLine
            }
        }), /* @__PURE__ */ $acw62.createElement("div", {
            className: s$T.footer
        }, hasPossibilityToStartRaid ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(OutlinedButton, {
            className: s$T.button,
            onClick: handleCancelRaidClick
        }, t$G.cancel), /* @__PURE__ */ $acw62.createElement(ContainedButton, {
            className: s$T.button,
            disabled: !isTimeout,
            onClick: handleStartRaidClick
        }, t$G.startRaid)) : /* @__PURE__ */ $acw62.createElement(OutlinedButton, {
            disabled: isTimeout,
            onClick: handleRejectRaidClick
        }, t$G.reject)));
    };
    return /* @__PURE__ */ $acw62.createElement(PinnedBlock, {
        renderDescription: renderDescription,
        isExpandable: false
    });
};
const usePredictionBox = ()=>{
    const predictionData = (0, $iD0SF.useSelector)(channelPredictionSelector);
    const isOpen = (0, $iD0SF.useSelector)(isVisiblePredictionSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const shouldShow = predictionData && predictionData.state !== EPredictionStatus.CANCELED && isOpen;
    const onClose = ()=>{
        dispatch(setVisibilityPrediction({
            isVisible: false
        }));
    };
    const onOpen = ()=>{
        dispatch(setVisibilityPrediction({
            isVisible: true
        }));
    };
    return {
        predictionData: predictionData,
        shouldShow: shouldShow,
        onClose: onClose,
        onOpen: onOpen
    };
};
const root$B = "ChatPinned-scss--module__root___kk2Yq";
const container$3 = "ChatPinned-scss--module__container___9ldNJ";
const containerWithoutArrows = "ChatPinned-scss--module__containerWithoutArrows___-CuwB";
const blocks = "ChatPinned-scss--module__blocks___WMpEt";
const button$7 = "ChatPinned-scss--module__button___s-LsE";
const buttonLeft = "ChatPinned-scss--module__buttonLeft___K6zwc";
const buttonRight = "ChatPinned-scss--module__buttonRight___7sPH0";
const arrow = "ChatPinned-scss--module__arrow___eCHGv";
const arrowRight = "ChatPinned-scss--module__arrowRight___CDL2y";
const dots = "ChatPinned-scss--module__dots___fydy-";
const dot = "ChatPinned-scss--module__dot___7EePL";
const dotActive = "ChatPinned-scss--module__dotActive___QbUA-";
const s$S = {
    root: root$B,
    container: container$3,
    containerWithoutArrows: containerWithoutArrows,
    blocks: blocks,
    button: button$7,
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    arrow: arrow,
    arrowRight: arrowRight,
    dots: dots,
    dot: dot,
    dotActive: dotActive
};
const ChatPinned = (props)=>{
    const { streamUserId, blogUrl, isAdmin, isAdminModerator, isAuthorized, isChatModerator, isHidden: isHidden3 = false } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    const streamStatusRaid = (0, $iD0SF.useSelector)(streamRaidStatusSelector);
    const prevStreamStatusRaid = usePrevious(streamStatusRaid);
    const prevBlogUrl = usePrevious(blogUrl);
    const cleanStreamRaid$1 = ()=>{
        dispatch(cleanStreamRaid());
    };
    const prefetchRaid = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchStreamRaid.action)({
            blogUrl: blogUrl
        }));
    };
    const resetStreamRaidLoaded$1 = ()=>{
        dispatch(resetStreamRaidLoaded());
    };
    const isCurrentUserStream = (currentUser2 == null ? void 0 : currentUser2.id) === streamUserId;
    const { isMobile: isMobile2 } = getConfig();
    const { predictionData, onOpen: onPredictionOpen } = usePredictionBox();
    const [index2, setIndex] = (0, $acw62.useState)(0);
    const { list: list2, channelPollData, pinnedMessage, pinnedMessageId, streamRaid, streamRaidLoaded, streamBlocksPinnedHiddenItems, pinnedHiddenItemsCount, isAllBannersHidden, closeDropNotification } = useChatPinnedList({
        streamUserId: streamUserId
    });
    const prevList = usePrevious(list2);
    const filteredList = difference(list2, streamBlocksPinnedHiddenItems);
    (0, $acw62.useEffect)(()=>{
        if (list2.length && (prevList == null ? void 0 : prevList.length)) {
            const diff = difference(list2, prevList);
            if (diff.length) {
                const newIndex = Math.max(0, Math.min(list2.indexOf(diff[0]), list2.length - 1));
                setIndex(newIndex);
            } else setIndex((i)=>Math.max(0, Math.min(i, list2.length - 1)));
        } else setIndex(0);
    }, [
        JSON.stringify(list2)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isAllBannersHidden) setIndex(0);
    }, [
        isAllBannersHidden
    ]);
    (0, $acw62.useEffect)(()=>{
        if (filteredList.length && index2 > filteredList.length - 1) setIndex((prevIndex)=>Math.max(0, Math.min(prevIndex, filteredList.length - 1)));
    }, [
        filteredList,
        index2
    ]);
    const goToPrev = ()=>{
        setIndex((i)=>{
            if (i <= 0) return list2.length - 1;
            return i - 1;
        });
    };
    const goToNext = ()=>{
        setIndex((i)=>{
            if (i >= list2.length - 1) return 0;
            return i + 1;
        });
    };
    const goToIndex = (value2)=>()=>{
            setIndex(Math.min(Math.max(value2, 0), list2.length - 1));
        };
    const currentBlock = filteredList[index2];
    const bannersCount = list2.length - pinnedHiddenItemsCount;
    const isMoreThanOneBanner = bannersCount > 1;
    const isEmptyList = bannersCount === 0;
    const shouldShowArrows = isMoreThanOneBanner && !isMobile2;
    const handleHidePinned = (type)=>()=>{
            const hiddenItems = [
                ...streamBlocksPinnedHiddenItems,
                ...type === EPinnedItem.MESSAGE ? [
                    `${EPinnedItem.MESSAGE}:${pinnedMessageId}`
                ] : [],
                ...type === EPinnedItem.PREDICTION ? [
                    EPinnedItem.PREDICTION
                ] : [],
                ...type === EPinnedItem.CHANNEL_POLL ? [
                    EPinnedItem.CHANNEL_POLL
                ] : []
            ];
            dispatch(setStreamBlocksPinnedHidden(hiddenItems));
        };
    (0, $acw62.useEffect)(()=>{
        if (!streamRaidLoaded) prefetchRaid();
    }, [
        streamRaidLoaded
    ]);
    (0, $acw62.useEffect)(()=>{
        if (streamStatusRaid === ERaidStatus.CREATED && streamStatusRaid !== prevStreamStatusRaid || !streamStatusRaid && blogUrl !== prevBlogUrl) resetStreamRaidLoaded$1();
    }, [
        streamStatusRaid,
        prevStreamStatusRaid,
        blogUrl,
        prevBlogUrl
    ]);
    const drawBlock = (name2)=>{
        const [key] = (name2 == null ? void 0 : name2.split(":")) || [];
        switch(key){
            case EPinnedItem.PREDICTION:
                return /* @__PURE__ */ $acw62.createElement(Prediction, {
                    key: EPinnedItem.PREDICTION,
                    predictionData: predictionData,
                    isAuthorized: isAuthorized,
                    isInChatPinned: true,
                    blogUrl: blogUrl,
                    onOpen: onPredictionOpen,
                    onClose: handleHidePinned(EPinnedItem.PREDICTION)
                });
            case EPinnedItem.CHANNEL_POLL:
                return /* @__PURE__ */ $acw62.createElement(ChannelPoll, {
                    blogUrl: blogUrl,
                    data: channelPollData,
                    key: EPinnedItem.CHANNEL_POLL,
                    onClose: handleHidePinned(EPinnedItem.CHANNEL_POLL)
                });
            case EPinnedItem.MESSAGE:
                return /* @__PURE__ */ $acw62.createElement(Message, {
                    key: EPinnedItem.MESSAGE,
                    blogUrl: blogUrl,
                    pinnedMessage: pinnedMessage,
                    isAdmin: isAdmin,
                    isAdminModerator: isAdminModerator,
                    isChatModerator: isChatModerator,
                    isOwner: isCurrentUserStream,
                    currentUser: currentUser2,
                    onClose: handleHidePinned(EPinnedItem.MESSAGE)
                });
            case EPinnedItem.RAID:
                return /* @__PURE__ */ $acw62.createElement(RaidNotification, {
                    key: EPinnedItem.RAID,
                    streamRaid: streamRaid,
                    isCurrentUserStream: isCurrentUserStream,
                    onClose: cleanStreamRaid$1
                });
            case EPinnedItem.DROP_BOX:
                return /* @__PURE__ */ $acw62.createElement(DropsNotification, {
                    onClose: closeDropNotification
                });
        }
        return null;
    };
    if (isHidden3 || isEmptyList) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$S.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$S.container, {
            [s$S.containerWithoutArrows]: !shouldShowArrows
        })
    }, shouldShowArrows && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$S.button, s$S.buttonLeft),
        onClick: goToPrev
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$S.arrow,
        glyph: svg_name_arrow_short_bold
    })), !isEmptyList && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$S.blocks
    }, drawBlock(currentBlock)), shouldShowArrows && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$S.button, s$S.buttonRight),
        onClick: goToNext
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$S.arrow, s$S.arrowRight),
        glyph: svg_name_arrow_short_bold
    }))), isMoreThanOneBanner && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$S.dots
    }, filteredList.map((key, i)=>/* @__PURE__ */ $acw62.createElement("div", {
            key: key,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$S.dot, {
                [s$S.dotActive]: i === index2
            }),
            onClick: goToIndex(i)
        }))));
};
var ECountdownMode = /* @__PURE__ */ ((ECountdownMode2)=>{
    ECountdownMode2["DEFAULT"] = "default";
    ECountdownMode2["STATION"] = "station";
    ECountdownMode2["CLOCK"] = "clock";
    return ECountdownMode2;
})(ECountdownMode || {});
const locales$F = {
    days1: "\u0434\u0435\u043D\u044C",
    days2: "\u0434\u043D\u044F",
    days5: "\u0434\u043D\u0435\u0439",
    hours1: "\u0447\u0430\u0441",
    hours2: "\u0447\u0430\u0441\u0430",
    hours5: "\u0447\u0430\u0441\u043E\u0432",
    minutes1: "\u043C\u0438\u043D\u0443\u0442\u0443",
    minutes2: "\u043C\u0438\u043D\u0443\u0442\u044B",
    minutes5: "\u043C\u0438\u043D\u0443\u0442",
    seconds1: "\u0441\u0435\u043A\u0443\u043D\u0434\u0443",
    seconds2: "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
    seconds5: "\u0441\u0435\u043A\u0443\u043D\u0434",
    daysShort: "\u0434\u043D",
    hoursShort: "\u0447",
    minutesShort: "\u043C\u0438\u043D",
    secondsShort: "\u0441\u0435\u043A"
};
const t$F = distExports$1.getTranslation && locales$F;
const DAYS_PER_WEEK = 7;
const leadZeroNumberFormat = (num2)=>{
    return num2 >= 10 ? num2 : num2 > 0 ? `0${num2}` : "00";
};
const Countdown = (props)=>{
    const { className, timeLeft, mode: mode2 = ECountdownMode.DEFAULT, onEnd } = props;
    const duration2 = useCountdown({
        timeLeft: timeLeft,
        onEnd: onEnd
    });
    const counterText = (0, $acw62.useMemo)(()=>{
        const { days, hours, minutes, seconds } = duration2 || {};
        let shouldShow;
        if (mode2 === ECountdownMode.STATION) {
            shouldShow = {
                days: Boolean(days),
                hours: Boolean(hours) || Boolean(days),
                minutes: Boolean(minutes) || Boolean(hours),
                seconds: true
            };
            return [
                ...shouldShow.days ? [
                    `${days} ${t$F.daysShort}`
                ] : [],
                ...shouldShow.hours ? [
                    `${leadZeroNumberFormat(hours)} ${t$F.hoursShort}`
                ] : [],
                ...shouldShow.minutes ? [
                    `${leadZeroNumberFormat(minutes)} ${t$F.minutesShort}`
                ] : [],
                ...shouldShow.seconds ? [
                    `${leadZeroNumberFormat(seconds)} ${t$F.secondsShort}`
                ] : []
            ].join(" ");
        }
        if (mode2 === ECountdownMode.CLOCK) {
            shouldShow = {
                days: Boolean(days),
                hours: Boolean(hours) || Boolean(days),
                minutes: true,
                seconds: true
            };
            return [
                ...shouldShow.days ? [
                    `${days}`
                ] : [],
                ...shouldShow.hours ? [
                    `${hours}`
                ] : [],
                ...shouldShow.minutes ? [
                    `${minutes}`
                ] : [],
                ...shouldShow.seconds ? [
                    `${leadZeroNumberFormat(seconds)}`
                ] : []
            ].join(":");
        }
        shouldShow = {
            days: Boolean(days),
            hours: hours && days < DAYS_PER_WEEK,
            minutes: minutes && !days,
            seconds: true
        };
        return [
            ...shouldShow.days ? [
                `${days} ${declOfNum([
                    t$F.days1,
                    t$F.days2,
                    t$F.days5
                ], days)}`
            ] : [],
            ...shouldShow.hours ? [
                `${hours} ${declOfNum([
                    t$F.hours1,
                    t$F.hours2,
                    t$F.hours5
                ], hours)}`
            ] : [],
            ...shouldShow.minutes ? [
                `${minutes} ${declOfNum([
                    t$F.minutes1,
                    t$F.minutes2,
                    t$F.minutes5
                ], minutes)}`
            ] : [],
            ...shouldShow.seconds ? [
                `${seconds} ${declOfNum([
                    t$F.seconds1,
                    t$F.seconds2,
                    t$F.seconds5
                ], seconds)}`
            ] : []
        ].join(" ");
    }, [
        duration2
    ]);
    if (!duration2) return null;
    return /* @__PURE__ */ $acw62.createElement("span", {
        className: className
    }, counterText);
};
const getStyle = (nodeName)=>{
    const map = {
        B: EStyleType.BOLD,
        I: EStyleType.ITALIC,
        S: EStyleType.STRIKETHROUGH,
        U: EStyleType.UNDERLINE,
        CODE: EStyleType.CODE
    };
    return map[nodeName];
};
const convertParagraphToTextBlocks = (list2)=>{
    let offset2 = 0;
    let cleanText = "";
    const styleRanges = [];
    const rawLinkBlocks = [];
    const rawTextBlocks = [];
    const rawSmileBlocks = [];
    const rawMentionBlocks = [];
    const rawSpaceBlocks = [];
    const blocks2 = [];
    const traverse = (node)=>{
        cleanText += node.innerText ? node.innerText : node.nodeValue ? node.nodeValue : "";
        if (node.nodeName === "A") rawLinkBlocks.push({
            type: EMediaDataType.LINK,
            href: node.getAttribute("href"),
            start: offset2,
            end: offset2 + node.textContent.length,
            content: node.innerText,
            styles: []
        });
        if (node.nodeName === "IMG") {
            const id = node.getAttribute("data-id");
            const name2 = node.getAttribute("alt");
            const smallUrl = node.getAttribute("src");
            const srcset = node.getAttribute("srcset") || "";
            const [mediumUrl, largeUrl] = srcset.split(",").map((set2)=>set2.trim().split(" ")[0]);
            rawSmileBlocks.push({
                type: EMediaDataType.SMILE,
                start: offset2,
                end: offset2,
                content: "",
                styles: [],
                id: id,
                name: name2,
                smallUrl: smallUrl,
                mediumUrl: mediumUrl,
                largeUrl: largeUrl
            });
        }
        const mention2 = node.nodeName === "P" && node.classList.contains("mention");
        if (mention2) {
            const id = Number(node.getAttribute("data-mention-id"));
            const displayName = node.getAttribute("data-display-name");
            const uniqueId2 = node.getAttribute("data-unique-id");
            rawMentionBlocks.push({
                type: EMediaDataType.MENTION,
                content: node.textContent,
                start: offset2,
                end: offset2 + node.textContent.length,
                styles: [],
                id: id,
                displayName: displayName,
                uniqueId: uniqueId2
            });
        }
        const spaceBlock = node.nodeName === "P" && node.classList.contains("space");
        if (spaceBlock) rawSpaceBlocks.push({
            type: EMediaDataType.SPACE,
            start: offset2,
            end: offset2 + 1,
            styles: []
        });
        if (node.nodeName !== "A" && node.nodeName !== "IMG" && node.nodeType !== Node.TEXT_NODE && !mention2 && !spaceBlock) styleRanges.push([
            getStyle(node.nodeName),
            offset2,
            offset2 + node.textContent.length
        ]);
        if (node.nodeType === Node.TEXT_NODE || mention2 || spaceBlock) offset2 += node.textContent.length;
    };
    list2.forEach(traverse);
    const rawCustomBlocks = [
        ...rawLinkBlocks,
        ...rawSmileBlocks,
        ...rawMentionBlocks,
        ...rawSpaceBlocks
    ].sort((a2, b2)=>a2.start - b2.start);
    if (rawCustomBlocks.length > 0) {
        const linksBounds = rawCustomBlocks.reduce((acc, link2)=>{
            acc.push([
                link2.start,
                link2.end
            ]);
            return acc;
        }, []).flat();
        const allBounds = [
            0,
            ...linksBounds,
            cleanText.length
        ];
        for(let i = 0; i < allBounds.length; i += 2){
            if (allBounds[i] === allBounds[i + 1]) continue;
            rawTextBlocks.push({
                type: EMediaDataType.TEXT,
                content: cleanText.slice(allBounds[i], allBounds[i + 1]),
                start: allBounds[i],
                end: allBounds[i + 1],
                styles: []
            });
        }
        const rawBlocks = [
            ...rawCustomBlocks,
            ...rawTextBlocks
        ].sort((a2, b2)=>a2.start - b2.start);
        rawBlocks.forEach((block2)=>{
            styleRanges.forEach((range2)=>{
                if (range2[EPackedStyleRange.OFFSET] >= block2.end || range2[EPackedStyleRange.LENGTH] <= block2.start) return;
                const style = [
                    range2[EPackedStyleRange.STYLE],
                    Math.max(block2.start, range2[EPackedStyleRange.OFFSET]),
                    Math.min(block2.end, range2[EPackedStyleRange.LENGTH])
                ];
                style[EPackedStyleRange.LENGTH] = style[EPackedStyleRange.LENGTH] - style[EPackedStyleRange.OFFSET];
                block2.styles.push(style);
            });
            switch(block2.type){
                case EMediaDataType.SMILE:
                    blocks2.push({
                        type: block2.type,
                        smallUrl: block2.smallUrl,
                        mediumUrl: block2.mediumUrl,
                        largeUrl: block2.largeUrl,
                        id: block2.id,
                        name: block2.name
                    });
                    break;
                case EMediaDataType.LINK:
                    blocks2.push({
                        type: block2.type,
                        content: JSON.stringify([
                            block2.content,
                            EBlockType[0],
                            block2.styles
                        ]),
                        url: block2.href
                    });
                    break;
                case EMediaDataType.MENTION:
                    blocks2.push({
                        type: block2.type,
                        id: block2.id,
                        displayName: block2.displayName,
                        uniqueId: block2.uniqueId
                    });
                    break;
                case EMediaDataType.SPACE:
                    blocks2.push({
                        type: block2.type
                    });
                    break;
                default:
                    blocks2.push({
                        type: block2.type,
                        content: JSON.stringify([
                            block2.content,
                            EBlockType[0],
                            block2.styles
                        ]),
                        modificator: ""
                    });
            }
        });
    } else {
        styleRanges.forEach((range2)=>range2[EPackedStyleRange.LENGTH] = range2[EPackedStyleRange.LENGTH] - range2[EPackedStyleRange.OFFSET]);
        blocks2.push({
            type: EMediaDataType.TEXT,
            content: JSON.stringify([
                cleanText,
                EBlockType[0],
                styleRanges
            ]),
            modificator: ""
        });
    }
    blocks2.push({
        type: EMediaDataType.TEXT,
        content: "",
        modificator: EMediaDataTextModificator.BLOCK_END
    });
    return blocks2;
};
const convertNodesToBlogPostData = (list2)=>{
    const range2 = new Range();
    const result2 = [];
    list2.forEach((element)=>{
        range2.selectNodeContents(element);
        const blocks2 = range2.cloneContents().childNodes;
        result2.push(...convertParagraphToTextBlocks(blocks2));
    });
    return result2;
};
var ESmilesSelectorMode = /* @__PURE__ */ ((ESmilesSelectorMode2)=>{
    ESmilesSelectorMode2[ESmilesSelectorMode2["LIST"] = 0] = "LIST";
    ESmilesSelectorMode2[ESmilesSelectorMode2["SEARCH"] = 1] = "SEARCH";
    ESmilesSelectorMode2[ESmilesSelectorMode2["FOLLOW"] = 2] = "FOLLOW";
    ESmilesSelectorMode2[ESmilesSelectorMode2["SUBSCRIBE"] = 3] = "SUBSCRIBE";
    ESmilesSelectorMode2[ESmilesSelectorMode2["LOADING"] = 4] = "LOADING";
    return ESmilesSelectorMode2;
})(ESmilesSelectorMode || {});
const button$6 = "FollowButtonWithTooltip-scss--module__button___7OTsu";
const tooltipContent = "FollowButtonWithTooltip-scss--module__tooltipContent___ZRIsD";
const s$R = {
    button: button$6,
    tooltipContent: tooltipContent
};
const locales$E = {
    follow: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C",
    following: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u044E",
    unfollow: "\u041F\u0435\u0440\u0435\u0441\u0442\u0430\u0442\u044C \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C"
};
const t$E = distExports$1.getTranslation && locales$E;
const FollowButtonWithTooltip = (props)=>{
    const { isDisabled: isDisabled2, classNames = {} } = props;
    const { isMobile: isMobile2 } = getConfig();
    const { isFetching, isFollowing, isSubscribed, onFollowToggle } = useFollow$1({});
    const isButtonDisabled = isSubscribed || isDisabled2 || isFetching;
    const isFollower = isFollowing || isSubscribed;
    const tooltipContent2 = !isMobile2 && isFollower ? t$E.unfollow : null;
    const handleClick = ()=>{
        if (!isSubscribed) onFollowToggle();
    };
    return /* @__PURE__ */ $acw62.createElement(Tooltip, {
        trigger: ETooltipTriggers.HOVER,
        align: ETooltipPositions.CENTER_TOP,
        content: tooltipContent2,
        classNames: {
            root: classNames.root,
            content: s$R.tooltipContent
        }
    }, isFollowing && /* @__PURE__ */ $acw62.createElement(ButtonCell, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$R.button, classNames.button),
        isDisabled: isButtonDisabled,
        left: svg_name_notification_outline_24,
        mode: EButtonMode.SECONDARY,
        onClick: handleClick
    }, t$E.following), !isFollowing && /* @__PURE__ */ $acw62.createElement(ButtonCell, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$R.button, classNames.button),
        isDisabled: isButtonDisabled,
        left: svg_name_add_square_outline_24,
        onClick: handleClick
    }, t$E.follow));
};
const titleContainer = "SmilesList-scss--module__titleContainer___ri0bF";
const avatar$1 = "SmilesList-scss--module__avatar___Kfjzf";
const title$c = "SmilesList-scss--module__title___9Kt4S";
const smilesList = "SmilesList-scss--module__smilesList___INy7O";
const selected = "SmilesList-scss--module__selected___Mi7b-";
const s$Q = {
    titleContainer: titleContainer,
    avatar: avatar$1,
    title: title$c,
    smilesList: smilesList,
    selected: selected
};
const selectedSmileClassNames = {
    smileContainer: s$Q.selected
};
const SmilesList = $acw62.memo((props)=>{
    const { smiles: smiles2, selectedSmileIndex, activeSmileRef, titleAvatarUrl, title: title2, onSmileClick = dist$4.noop } = props;
    const { isMobile: isMobile2 } = getConfig();
    const hasTitleBlock = title2 || titleAvatarUrl;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, hasTitleBlock && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Q.titleContainer
    }, titleAvatarUrl && /* @__PURE__ */ $acw62.createElement(Avatar, {
        img: titleAvatarUrl,
        size: EAvatarSize.XXS,
        className: s$Q.avatar
    }), title2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Q.title
    }, title2)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$Q.smilesList
    }, smiles2.map((smile2, index2)=>{
        var _a3, _b2;
        const hasOverlay = smile2.access && !smile2.access.allowed;
        const isFreeSubscription = ((_b2 = (_a3 = smile2.access) == null ? void 0 : _a3.subscriptionLevel) == null ? void 0 : _b2.price) === 0;
        const hasLockOverlay = hasOverlay && !isFreeSubscription;
        const hasHeartOverlay = hasOverlay && isFreeSubscription;
        const isSelected = index2 === selectedSmileIndex;
        const classNames = isSelected && selectedSmileClassNames;
        if (isMobile2) return /* @__PURE__ */ $acw62.createElement(SmileItem, {
            key: smile2.id,
            smile: smile2,
            hasLockOverlay: hasLockOverlay,
            hasHeartOverlay: hasHeartOverlay,
            onClick: onSmileClick
        });
        else return /* @__PURE__ */ $acw62.createElement(SmileItem, {
            key: smile2.id,
            smile: smile2,
            classNames: classNames,
            hasLockOverlay: hasLockOverlay,
            hasHeartOverlay: hasHeartOverlay,
            activeSmileRef: activeSmileRef,
            selected: isSelected,
            onClick: onSmileClick
        });
    })));
});
SmilesList.displayName = "Smiles.List";
const root$A = "SubscribeContent-scss--module__root___TiVWX";
const topBlock = "SubscribeContent-scss--module__topBlock___tGX69";
const back$1 = "SubscribeContent-scss--module__back___khgr4";
const arrowIcon$1 = "SubscribeContent-scss--module__arrowIcon___s0KOx";
const closeContainer = "SubscribeContent-scss--module__closeContainer___N-g53";
const closeIcon$1 = "SubscribeContent-scss--module__closeIcon___FGvCc";
const streamerBlock = "SubscribeContent-scss--module__streamerBlock___hM6h7";
const avatar = "SubscribeContent-scss--module__avatar___3viOa";
const title$b = "SubscribeContent-scss--module__title___3M9-f";
const description$4 = "SubscribeContent-scss--module__description___w47Gh";
const smallText = "SubscribeContent-scss--module__smallText___Oz7rv";
const smilesTitle = "SubscribeContent-scss--module__smilesTitle___v-SV0";
const s$P = {
    root: root$A,
    topBlock: topBlock,
    back: back$1,
    arrowIcon: arrowIcon$1,
    closeContainer: closeContainer,
    closeIcon: closeIcon$1,
    streamerBlock: streamerBlock,
    avatar: avatar,
    title: title$b,
    description: description$4,
    smallText: smallText,
    smilesTitle: smilesTitle
};
const locales$D = {
    smilesTitle: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0438: {{count}} \u0448\u0442."
};
const t$D = distExports$1.getTranslation && locales$D;
const SubscribeContent = (props)=>{
    const { smiles: smiles2, owner, title: title2, description: description2, children: children2, onBackClick, onClose } = props;
    const smilesCount = smiles2.length;
    const handleBackClick = ()=>{
        onBackClick();
    };
    const handleCloseClick = ()=>{
        onClose();
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.topBlock
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.back,
        onClick: handleBackClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short_right,
        className: s$P.arrowIcon
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.closeContainer,
        onClick: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_close_new,
        className: s$P.closeIcon
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.streamerBlock
    }, /* @__PURE__ */ $acw62.createElement(Avatar, {
        size: EAvatarSize.S_PLUS,
        img: owner == null ? void 0 : owner.avatarUrl,
        className: s$P.avatar
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$P.title
    }, title2)), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$P.description, s$P.smallText)
    }, description2), children2, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$P.smilesTitle, s$P.smallText)
    }, distExports$1.getParametrizedText(t$D.smilesTitle, {
        count: smilesCount
    })), /* @__PURE__ */ $acw62.createElement(SmilesList, {
        smiles: smiles2
    }));
};
const root$z = "Follow-scss--module__root___ioNsU";
const followButton = "Follow-scss--module__followButton___QQBWz";
const s$O = {
    root: root$z,
    followButton: followButton
};
const locales$C = {
    title: "\u0421\u043C\u0430\u0439\u043B\u0438\u043A\u0438 \u0434\u043B\u044F \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u0432 \u043A\u0430\u043D\u0430\u043B\u0430 {{username}}",
    description: "\u0427\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C {{smiles}}, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043A\u0430\u043D\u0430\u043B {{username}}.",
    smiles1: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A",
    smiles2: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0430",
    smiles5: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432"
};
const t$C = distExports$1.getTranslation && locales$C;
const Follow = (props)=>{
    const { smiles: smiles2, owner, onBackClick, onClose } = props;
    const smilesCount = smiles2.length;
    const title2 = distExports$1.getParametrizedText(t$C.title, {
        username: owner == null ? void 0 : owner.nick
    });
    const description2 = distExports$1.getParametrizedText(t$C.description, {
        username: owner == null ? void 0 : owner.nick,
        smiles: `${smilesCount} ${declOfNum([
            t$C.smiles1,
            t$C.smiles2,
            t$C.smiles5
        ], smilesCount)}`
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$O.root
    }, /* @__PURE__ */ $acw62.createElement(SubscribeContent, {
        smiles: smiles2,
        owner: owner,
        title: title2,
        description: description2,
        onClose: onClose,
        onBackClick: onBackClick
    }, /* @__PURE__ */ $acw62.createElement(FollowButtonWithTooltip, {
        classNames: {
            button: s$O.followButton
        }
    })));
};
const root$y = "List-scss--module__root___2UFF-";
const set = "List-scss--module__set___Lv94O";
const s$N = {
    root: root$y,
    set: set
};
const locales$B = {
    titles: {
        user_popular: "\u0427\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435",
        global: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u044B\u0435"
    }
};
const PADDING = 15;
const SCROLL_THRESHOLD_TIME = 300;
const ROLE$1 = "container";
const t$B = distExports$1.getTranslation && locales$B;
const List = (props)=>{
    const { currentUser: currentUser2, smiles: smiles2, activeSetIndex, onChangeActiveIndexByScroll, onSmileClick } = props;
    const rootRef = (0, $acw62.useRef)();
    const setsRefs = (0, $acw62.useRef)({});
    const lastScrollTime = (0, $acw62.useRef)(0);
    const scrollToSet = (0, $acw62.useCallback)((index2)=>{
        const setRef = setsRefs.current[index2];
        const indexChangedNotByScroll = Date.now() - lastScrollTime.current > SCROLL_THRESHOLD_TIME;
        if (setRef && indexChangedNotByScroll) {
            const rootTop = rootRef.current.offsetTop;
            const setTop = setRef.offsetTop;
            const rootScrollTop = setTop - rootTop - PADDING;
            rootRef.current.scrollTop = rootScrollTop;
        }
    }, []);
    const getIndexByScroll = ()=>{
        const rootScrollTop = rootRef.current.scrollTop;
        const rootTop = rootRef.current.offsetTop;
        return smiles2.findIndex((set2, index2)=>{
            const setRef = setsRefs.current[index2];
            if (setRef) return setRef.offsetTop - rootTop + setRef.clientHeight - PADDING > rootScrollTop;
            return false;
        });
    };
    const getSetTitle = (set2)=>{
        switch(set2.type){
            case ESmileUserSetType.GLOBAL:
            case ESmileUserSetType.USER_POPULAR:
                return t$B.titles[set2.type];
            case ESmileUserSetType.CURRENT_BLOG:
            case ESmileUserSetType.OTHER_BLOGS:
                return set2.blog.owner.nick;
            case ESmileUserSetType.SELF_BLOG:
                return currentUser2.nick;
            default:
                return "";
        }
    };
    const getSetAvatar = (set2)=>{
        switch(set2.type){
            case ESmileUserSetType.GLOBAL:
            case ESmileUserSetType.USER_POPULAR:
                return null;
            case ESmileUserSetType.CURRENT_BLOG:
            case ESmileUserSetType.OTHER_BLOGS:
                return set2.blog.owner.avatarUrl;
            case ESmileUserSetType.SELF_BLOG:
                return currentUser2.avatarUrl;
            default:
                return "";
        }
    };
    const handleScroll = ()=>{
        const index2 = getIndexByScroll();
        if (index2 !== activeSetIndex) onChangeActiveIndexByScroll(index2);
        lastScrollTime.current = Date.now();
    };
    (0, $acw62.useEffect)(()=>{
        scrollToSet(activeSetIndex);
    }, [
        activeSetIndex
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$N.root,
        ref: rootRef,
        onScroll: handleScroll,
        "data-role": ROLE$1
    }, smiles2.map((set2, index2)=>/* @__PURE__ */ $acw62.createElement("div", {
            key: index2,
            className: s$N.set,
            ref: (ref2)=>setsRefs.current[index2] = ref2
        }, /* @__PURE__ */ $acw62.createElement(SmilesList, {
            smiles: set2.smiles,
            title: getSetTitle(set2),
            titleAvatarUrl: getSetAvatar(set2),
            onSmileClick: onSmileClick
        }))));
};
const Loading = ()=>{
    return /* @__PURE__ */ $acw62.createElement("div", null);
};
const root$x = "Search-scss--module__root___bzd0L";
const title$a = "Search-scss--module__title___YXVlg";
const resultsTitle = "Search-scss--module__resultsTitle___O-ZBk";
const s$M = {
    root: root$x,
    title: title$a,
    resultsTitle: resultsTitle
};
const locales$A = {
    results: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430",
    empty: {
        title: "\u041F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
    }
};
const t$A = distExports$1.getTranslation && locales$A;
const Search = (props)=>{
    const { searchResults, onSmileClick } = props;
    const isEmpty2 = searchResults.length === 0;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$M.root
    }, isEmpty2 ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$M.title
    }, t$A.empty.title)) : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$M.title, s$M.resultsTitle)
    }, t$A.results), /* @__PURE__ */ $acw62.createElement(SmilesList, {
        smiles: searchResults,
        onSmileClick: onSmileClick
    })));
};
const useSubscribeButton = (props)=>{
    const { externalBlogUrl } = props;
    const hasCurrentBlogSubscriptionLevels = (0, $iD0SF.useSelector)(blogHasSubscriptionLevelsSelector);
    const hasExternalBlogSubscriptionLevels = (0, $iD0SF.useSelector)(blogExternalHasSubscriptionLevelsSelector);
    const hasSubscriptionLevels = Boolean(externalBlogUrl) ? hasExternalBlogSubscriptionLevels : hasCurrentBlogSubscriptionLevels;
    const shouldShow = {
        null: !hasSubscriptionLevels
    };
    return {
        shouldShow: shouldShow
    };
};
const SubscribeButton = (props)=>{
    const { shouldShow } = useSubscribeButton(props);
    if (shouldShow.null) return null;
    return /* @__PURE__ */ $acw62.createElement(SubscribeButtonBase, {
        ...props
    });
};
const root$w = "Subscribe-scss--module__root___aBgWm";
const subscribeButton = "Subscribe-scss--module__subscribeButton___K3uy1";
const s$L = {
    root: root$w,
    subscribeButton: subscribeButton
};
const locales$z = {
    title: "{{username}} \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430:",
    description: "\u0427\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C {{smiles}}, \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u043D\u0443\u044E \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B {{username}}.",
    smiles1: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A",
    smiles2: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0430",
    smiles5: "\u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432"
};
const t$z = distExports$1.getTranslation && locales$z;
const Subscribe = (props)=>{
    const { owner, requiredLevelId, smiles: smiles2, subscriptionName, subscriptionPurchaseSource, onClose, onBackClick } = props;
    const smilesCount = smiles2.length;
    const description2 = distExports$1.getParametrizedText(t$z.description, {
        username: owner == null ? void 0 : owner.nick,
        smiles: `${smilesCount} ${declOfNum([
            t$z.smiles1,
            t$z.smiles2,
            t$z.smiles5
        ], smilesCount)}`
    });
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$L.root
    }, /* @__PURE__ */ $acw62.createElement(SubscribeContent, {
        title: getTitle(owner == null ? void 0 : owner.nick, subscriptionName),
        description: description2,
        owner: owner,
        smiles: smiles2,
        onClose: onClose,
        onBackClick: onBackClick
    }, /* @__PURE__ */ $acw62.createElement(SubscribeButton, {
        className: s$L.subscribeButton,
        requiredLevelId: requiredLevelId,
        subscriptionPurchaseSource: subscriptionPurchaseSource
    })));
};
const getTitle = (username2, subscriptionName)=>{
    const title2 = distExports$1.getParametrizedText(t$z.title, {
        username: username2
    });
    return /* @__PURE__ */ $acw62.createElement("div", null, title2, /* @__PURE__ */ $acw62.createElement("div", null, "\xab", subscriptionName, "\xbb"));
};
const root$v = "NavigationItem-scss--module__root___YLgv-";
const active$2 = "NavigationItem-scss--module__active___ZKPX4";
const horizontal$2 = "NavigationItem-scss--module__horizontal___vXwID";
const s$K = {
    root: root$v,
    active: active$2,
    horizontal: horizontal$2
};
const NavigationItem = $acw62.memo((props)=>{
    const { children: children2, isHorizontalNavigation, isActive, elementIndex, onClick } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$K.root, {
            [s$K.active]: isActive,
            [s$K.horizontal]: isHorizontalNavigation
        }),
        onClick: ()=>onClick(elementIndex)
    }, children2);
});
NavigationItem.displayName = "NavigationItem";
const NavigationItemAvatar = $acw62.memo((props)=>{
    const { isActive, isHorizontalNavigation, avatarUrl, elementIndex, onClick } = props;
    return /* @__PURE__ */ $acw62.createElement(NavigationItem, {
        isActive: isActive,
        isHorizontalNavigation: isHorizontalNavigation,
        elementIndex: elementIndex,
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement(Avatar, {
        size: EAvatarSize.XXS,
        img: avatarUrl
    }));
});
NavigationItemAvatar.displayName = "NavigationItemAvatar";
const icon$b = "NavigationItemIcon-scss--module__icon___EnXpj";
const s$J = {
    icon: icon$b
};
const NavigationItemIcon = $acw62.memo((props)=>{
    const { isActive, isHorizontalNavigation, icon: icon2, elementIndex, onClick } = props;
    return /* @__PURE__ */ $acw62.createElement(NavigationItem, {
        isActive: isActive,
        isHorizontalNavigation: isHorizontalNavigation,
        elementIndex: elementIndex,
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$J.icon,
        glyph: icon2
    }));
});
NavigationItemIcon.displayName = "NavigationItemIcon";
const root$u = "Navigation-scss--module__root___qR2lB";
const horizontal$1 = "Navigation-scss--module__horizontal___ddN9c";
const s$I = {
    root: root$u,
    horizontal: horizontal$1
};
const Navigation = (props)=>{
    const { currentUser: currentUser2, isHorizontalNavigation, smiles: smiles2, activeSetIndex, onItemClick } = props;
    const handleNavigationItemClick = (0, $acw62.useCallback)((setIndex)=>{
        onItemClick(setIndex);
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$I.root, {
            [s$I.horizontal]: isHorizontalNavigation
        })
    }, smiles2.map((set2, index2)=>{
        const isActive = activeSetIndex === index2;
        switch(set2.type){
            case ESmileUserSetType.USER_POPULAR:
                return /* @__PURE__ */ $acw62.createElement(NavigationItemIcon, {
                    key: index2,
                    elementIndex: index2,
                    icon: svg_name_clock_circle_dashed_outline_24,
                    isHorizontalNavigation: isHorizontalNavigation,
                    isActive: isActive,
                    onClick: handleNavigationItemClick
                });
            case ESmileUserSetType.CURRENT_BLOG:
            case ESmileUserSetType.OTHER_BLOGS:
                return /* @__PURE__ */ $acw62.createElement(NavigationItemAvatar, {
                    key: index2,
                    elementIndex: index2,
                    isHorizontalNavigation: isHorizontalNavigation,
                    avatarUrl: set2.blog.owner.avatarUrl,
                    isActive: isActive,
                    onClick: handleNavigationItemClick
                });
            case ESmileUserSetType.SELF_BLOG:
                return /* @__PURE__ */ $acw62.createElement(NavigationItemAvatar, {
                    key: index2,
                    elementIndex: index2,
                    isHorizontalNavigation: isHorizontalNavigation,
                    avatarUrl: currentUser2.avatarUrl,
                    isActive: isActive,
                    onClick: handleNavigationItemClick
                });
            case ESmileUserSetType.GLOBAL:
                return /* @__PURE__ */ $acw62.createElement(NavigationItemIcon, {
                    key: index2,
                    elementIndex: index2,
                    icon: svg_name_apps,
                    isHorizontalNavigation: isHorizontalNavigation,
                    isActive: isActive,
                    onClick: handleNavigationItemClick
                });
        }
        return null;
    }));
};
const icon$a = "SearchInput-scss--module__icon___vswh-";
const iconActive = "SearchInput-scss--module__iconActive___7F5Ii";
const root$t = "SearchInput-scss--module__root___sDI0h";
const fullSize = "SearchInput-scss--module__fullSize___YkjBg";
const iconSearch$1 = "SearchInput-scss--module__iconSearch___YKhSt";
const iconClear = "SearchInput-scss--module__iconClear___6yekA";
const inputWrapper$1 = "SearchInput-scss--module__inputWrapper___q5gkw";
const input$1 = "SearchInput-scss--module__input___UhgA7";
const close$3 = "SearchInput-scss--module__close___430es";
const closeIcon = "SearchInput-scss--module__closeIcon___972Ky";
const s$H = {
    icon: icon$a,
    iconActive: iconActive,
    root: root$t,
    fullSize: fullSize,
    iconSearch: iconSearch$1,
    iconClear: iconClear,
    inputWrapper: inputWrapper$1,
    input: input$1,
    close: close$3,
    closeIcon: closeIcon
};
const locales$y = {
    placeholder: "\u041F\u043E\u0438\u0441\u043A \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432"
};
const t$y = distExports$1.getTranslation && locales$y;
let timerId = null;
const SearchInput$1 = $acw62.memo((props)=>{
    const { value: value2, closeButtonClassName, showCloseButton = true, onChange, onCloseClick } = props;
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)(null);
    const { isMobile: isMobile2 } = getConfig();
    const isMobileSafari = isMobile2 && isSafariBrowser();
    (0, $acw62.useEffect)(()=>{
        if (isMobileSafari) timerId = window.setTimeout(()=>{
            inputRef.current.focus({
                preventScroll: true
            });
        }, 350);
        return ()=>{
            window.clearTimeout(timerId);
        };
    }, []);
    const handleChange = (event2)=>{
        onChange(event2.target.value);
    };
    const handleFocus = ()=>{
        window.clearTimeout(timerId);
        setFocused(true);
    };
    const handleBlur = ()=>{
        setFocused(false);
    };
    const handleCloseClick = ()=>{
        onCloseClick(value2);
    };
    const handleClear = ()=>{
        onChange("");
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$H.root, {
            [s$H.fullSize]: !showCloseButton
        })
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_search,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$H.icon, s$H.iconSearch, {
            [s$H.iconActive]: isFocused
        })
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$H.inputWrapper
    }, /* @__PURE__ */ $acw62.createElement(Input, {
        ref: inputRef,
        classNameInput: s$H.input,
        value: value2,
        placeholder: t$y.placeholder,
        autoFocus: true,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur
    })), showCloseButton && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$H.close, closeButtonClassName),
        onClick: handleCloseClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_close_new,
        className: s$H.closeIcon
    })), !showCloseButton && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_close_new,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$H.icon, s$H.iconClear),
        onClick: handleClear
    }));
});
SearchInput$1.displayName = "SearchInput";
const useFollow = (params)=>{
    const { onBackClick, onClose } = params;
    const freeSubscriptionSmiles = (0, $iD0SF.useSelector)(currentBlogFreeSubscriptionSmilesSelector);
    const smilesData = (0, $iD0SF.useSelector)(currentBlogSmilesDataSelector);
    return {
        owner: smilesData == null ? void 0 : smilesData.blog.owner,
        smiles: freeSubscriptionSmiles,
        onBackClick: onBackClick,
        onClose: onClose
    };
};
const useList = (params)=>{
    const { activeSetIndex, onChangeActiveIndexByScroll, onSmileClick } = params;
    const { currentUser: currentUser2 } = useCurrentUserAccess();
    const smiles2 = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetSelector) || [];
    return {
        // STORE
        currentUser: currentUser2,
        smiles: smiles2,
        activeSetIndex: // COMPUTED
        activeSetIndex,
        onChangeActiveIndexByScroll: // CALLBACKS
        onChangeActiveIndexByScroll,
        onSmileClick: onSmileClick
    };
};
const useSearch = (params)=>{
    const { searchQuery, onSmileClick } = params;
    const smilesData = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetSelector);
    const searchResults = (0, $acw62.useMemo)(()=>{
        if (searchQuery) {
            const smilesList2 = smilesData.map((item2)=>item2.smiles).flat();
            const resultsStartsWith = smilesList2.filter((smile2)=>smile2.name.toLowerCase().startsWith(searchQuery.toLowerCase()));
            const resultsIncludes = smilesList2.filter((smile2)=>smile2.name.toLowerCase().includes(searchQuery.toLowerCase()));
            return uniqBy(resultsStartsWith.concat(resultsIncludes), "id");
        }
        return [];
    }, [
        searchQuery
    ]);
    return {
        searchResults: searchResults,
        onSmileClick: onSmileClick
    };
};
const useSubscribe = (params)=>{
    const { requiredLevelId, subscriptionPrice, subscriptionName, subscriptionPurchaseSource, onBackClick, onClose } = params;
    const smilesData = (0, $iD0SF.useSelector)(currentBlogSmilesDataSelector);
    const smiles2 = (0, $iD0SF.useSelector)((state)=>currentBlogSubscriptionSmilesSelector(state, subscriptionPrice));
    return {
        smiles: smiles2,
        owner: smilesData == null ? void 0 : smilesData.blog.owner,
        requiredLevelId: requiredLevelId,
        subscriptionName: subscriptionName,
        subscriptionPurchaseSource: subscriptionPurchaseSource,
        onBackClick: onBackClick,
        onClose: onClose
    };
};
const useSmilesSelector = (params)=>{
    const { onClose, onSelect } = params;
    const [mode2, setMode] = (0, $acw62.useState)(ESmilesSelectorMode.LIST);
    const [activeSetIndex, setActiveSetIndex] = (0, $acw62.useState)(null);
    const [subscriptionLevel, setSubscriptionLevel] = (0, $acw62.useState)(null);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const { currentUser: currentUser2 } = useCurrentUserAccess();
    const smiles2 = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetSelector);
    const smilesNetworkStatus = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetNetworkStatusSelector);
    const followNetworkStatus = (0, $iD0SF.useSelector)(blogFollowNetworkStatusSelector);
    const isSearchInputDisplayed = [
        ESmilesSelectorMode.SEARCH,
        ESmilesSelectorMode.LIST
    ].includes(mode2);
    const onSearchQueryChange = (0, $acw62.useCallback)((value2)=>{
        const query = value2.trim();
        setSearchQuery(query);
        if (query.length > 0) setMode(ESmilesSelectorMode.SEARCH);
        else setMode(ESmilesSelectorMode.LIST);
    }, []);
    const onNavigationItemClick = (0, $acw62.useCallback)((setIndex)=>{
        setActiveSetIndex(setIndex);
    }, []);
    const handleModeFollowBack = ()=>setMode(ESmilesSelectorMode.LIST);
    const handleSubscribeModeBack = ()=>setMode(ESmilesSelectorMode.LIST);
    const handleListModeChangeActiveIndexByScroll = (setIndex)=>setActiveSetIndex(setIndex);
    const handleSmileClick = (0, $acw62.useCallback)((smile2)=>{
        var _a3;
        if (!smile2.access || smile2.access.allowed) onSelect({
            smile: smile2
        });
        else if (((_a3 = smile2.access.subscriptionLevel) == null ? void 0 : _a3.price) === 0) setMode(ESmilesSelectorMode.FOLLOW);
        else {
            setSubscriptionLevel(smile2.access.subscriptionLevel);
            setMode(ESmilesSelectorMode.SUBSCRIBE);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (followNetworkStatus.isFetching) setMode(ESmilesSelectorMode.LOADING);
    }, [
        followNetworkStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        if (smilesNetworkStatus.isFetching && !(smiles2 == null ? void 0 : smiles2.length)) setMode(ESmilesSelectorMode.LOADING);
        if (smilesNetworkStatus.isFetched && !searchQuery) setMode(ESmilesSelectorMode.LIST);
    }, [
        smilesNetworkStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        if (smiles2) setActiveSetIndex(smiles2[0] ? 0 : null);
    }, [
        smiles2
    ]);
    return {
        // STORE
        currentUser: currentUser2,
        smiles: smiles2,
        // STATE
        mode: mode2,
        activeSetIndex: activeSetIndex,
        searchQuery: searchQuery,
        isSearchInputDisplayed: // COMPUTED
        isSearchInputDisplayed,
        modes: {
            follow: useFollow({
                onClose: onClose,
                onBackClick: handleModeFollowBack
            }),
            list: useList({
                activeSetIndex: activeSetIndex,
                onChangeActiveIndexByScroll: handleListModeChangeActiveIndexByScroll,
                onSmileClick: handleSmileClick
            }),
            search: useSearch({
                searchQuery: searchQuery,
                onSmileClick: handleSmileClick
            }),
            subscribe: useSubscribe({
                subscriptionPrice: subscriptionLevel == null ? void 0 : subscriptionLevel.price,
                subscriptionName: subscriptionLevel == null ? void 0 : subscriptionLevel.name,
                requiredLevelId: subscriptionLevel == null ? void 0 : subscriptionLevel.id,
                subscriptionPurchaseSource: EStatSubscriptionPurchaseStartSource.SMILES_SELECTOR,
                onClose: onClose,
                onBackClick: handleSubscribeModeBack
            })
        },
        onSearchQueryChange: // CALLBACKS
        onSearchQueryChange,
        onNavigationItemClick: onNavigationItemClick
    };
};
const root$s = "SmilesSelector-scss--module__root___4Y3QL";
const mode = "SmilesSelector-scss--module__mode___nS-73";
const navigation = "SmilesSelector-scss--module__navigation___oDTPS";
const closeButton = "SmilesSelector-scss--module__closeButton___GciRb";
const content$4 = "SmilesSelector-scss--module__content___fvUsd";
const contentWithoutSearch = "SmilesSelector-scss--module__contentWithoutSearch___24wum";
const horizontal = "SmilesSelector-scss--module__horizontal___I9-G2";
const s$G = {
    root: root$s,
    mode: mode,
    navigation: navigation,
    closeButton: closeButton,
    content: content$4,
    contentWithoutSearch: contentWithoutSearch,
    horizontal: horizontal
};
const MODES_WITHOUT_SEARCH = [
    ESmilesSelectorMode.FOLLOW,
    ESmilesSelectorMode.SUBSCRIBE
];
const SmilesSelector = $acw62.memo((props)=>{
    const { blogUrl, isHorizontalNavigation, onClose, onSelect } = props;
    const { currentUser: currentUser2, smiles: smiles2, mode: mode2, activeSetIndex, searchQuery, isSearchInputDisplayed, modes: { follow: modeFollow, list: modeList, search: modeSearch, subscribe: modeSubscribe }, onSearchQueryChange, onNavigationItemClick } = useSmilesSelector({
        onClose: onClose,
        onSelect: onSelect
    });
    const clearSearchQuery = (0, $acw62.useCallback)(()=>{
        onSearchQueryChange("");
    }, [
        onSearchQueryChange
    ]);
    const handleCloseClick = (0, $acw62.useCallback)((searchQueryValue)=>{
        if (searchQueryValue) {
            clearSearchQuery();
            return;
        }
        onClose();
    }, [
        clearSearchQuery,
        onClose
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$G.root, {
            [s$G.horizontal]: isHorizontalNavigation
        })
    }, isSearchInputDisplayed && /* @__PURE__ */ $acw62.createElement(SearchInput$1, {
        value: searchQuery,
        closeButtonClassName: !isHorizontalNavigation && s$G.closeButton,
        onChange: onSearchQueryChange,
        onCloseClick: handleCloseClick,
        showCloseButton: mode2 !== ESmilesSelectorMode.SEARCH
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$G.content, {
            [s$G.contentWithoutSearch]: MODES_WITHOUT_SEARCH.includes(mode2)
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$G.mode
    }, mode2 === ESmilesSelectorMode.FOLLOW && /* @__PURE__ */ $acw62.createElement(Follow, {
        ...modeFollow
    }), mode2 === ESmilesSelectorMode.LIST && /* @__PURE__ */ $acw62.createElement(List, {
        ...modeList
    }), mode2 === ESmilesSelectorMode.LOADING && /* @__PURE__ */ $acw62.createElement(Loading, null), mode2 === ESmilesSelectorMode.SEARCH && /* @__PURE__ */ $acw62.createElement(Search, {
        ...modeSearch
    }), mode2 === ESmilesSelectorMode.SUBSCRIBE && /* @__PURE__ */ $acw62.createElement(Subscribe, {
        ...modeSubscribe
    })), mode2 === ESmilesSelectorMode.LIST && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$G.navigation
    }, smiles2 && /* @__PURE__ */ $acw62.createElement(Navigation, {
        currentUser: currentUser2,
        isHorizontalNavigation: isHorizontalNavigation,
        smiles: smiles2,
        activeSetIndex: activeSetIndex,
        onItemClick: onNavigationItemClick
    }))));
});
SmilesSelector.displayName = "SmilesSelector";
const useSmiles = (params)=>{
    const { hasSmilesSelector, blogUrl, cursorRef, preventScrollOnMobileFocus, editorJS, setEditorData, getEditorData } = params;
    const dispatch = (0, $2OPjR.useDispatch)();
    const smileSelectorWrapperRef = (0, $acw62.useRef)();
    const smileButtonRef = (0, $acw62.useRef)();
    const innerHeightRef = (0, $acw62.useRef)(null);
    const insertedSmileRef = (0, $acw62.useRef)(null);
    const { isMobile: isMobile2 } = getConfig();
    const smilesNetworkStatus = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetNetworkStatusSelector);
    const smiles2 = (0, $iD0SF.useSelector)(currentBlogSmilesUserSetSelector);
    const { isAlreadySubscribed } = useSubscribe$1({
        requiredLevelId: null,
        subscriptionPurchaseSource: EStatSubscriptionPurchaseStartSource.SMILES_SELECTOR
    });
    const prevIsAlreadySubscribed = usePrevious(isAlreadySubscribed);
    const prevBlogUrl = usePrevious(blogUrl);
    const [isSmileSelectorOpened, setIsSmileSelectorOpened] = (0, $acw62.useState)(false);
    const [isNeedToFetchSmiles, setIsNeedToFetchSmiles] = (0, $acw62.useState)(false);
    const fetchSmiles = async ()=>{
        await dispatch((0, $7Uc0p.thunkToAction)(fetchSmileUserSet.action)({
            blogUrl: blogUrl
        }));
    };
    const handleCloseSmilesSelector = (0, $acw62.useCallback)(()=>{
        setIsSmileSelectorOpened(false);
    }, []);
    const findSmileByName = (0, $acw62.useCallback)((name2)=>{
        let smile2 = null;
        for (const smileBlock of smiles2){
            smile2 = smileBlock.smiles.find((smileElement)=>smileElement.name === name2);
            if (smile2) break;
        }
        return smile2;
    }, [
        smiles2
    ]);
    const onClickOutside = (event2)=>{
        const isClickOnContainer = [
            smileSelectorWrapperRef,
            smileButtonRef
        ].some((elm)=>{
            var _a3;
            return (_a3 = elm.current) == null ? void 0 : _a3.contains(event2.target);
        });
        if (isClickOnContainer) return;
        handleCloseSmilesSelector();
    };
    const onResize = ()=>{
        const hasKeyboard = window.innerHeight < innerHeightRef.current;
        if (hasKeyboard) {
            setTimeout(()=>window.scrollTo(0, document.body.scrollHeight));
            window.removeEventListener("resize", onResize);
        }
    };
    const onSmilesButtonClick = (0, $acw62.useCallback)(()=>{
        var _a3;
        setIsSmileSelectorOpened(!isSmileSelectorOpened);
        if (preventScrollOnMobileFocus && isMobile2) {
            if (!isSafariBrowser()) {
                const isPortrait = window.innerHeight > window.innerWidth;
                if (isPortrait) {
                    innerHeightRef.current = window.innerHeight;
                    window.addEventListener("resize", onResize);
                }
            } else (_a3 = editorJS.current) == null || _a3.focus(true);
        }
    }, [
        isSmileSelectorOpened,
        preventScrollOnMobileFocus
    ]);
    const addSmileToInlineData = (0, $acw62.useCallback)(async ({ smile: smile2, isReplaceWordOnCursor = false })=>{
        const inlineData = await getEditorData();
        const smileData = convertSmileToMediaItem(smile2);
        const cursor = cursorRef.current;
        let { itemIndex, offset: offsetCr } = prepareCursor(cursor, inlineData);
        let item2 = inlineData[itemIndex - 1];
        if (item2 && isSpaceItem(item2) && itemIndex < inlineData.length - 1) {
            item2 = inlineData[itemIndex];
            itemIndex = itemIndex + 1;
        }
        insertedSmileRef.current = {
            position: offsetCr,
            uniqueId: smileData.uniqueId,
            type: smileData.type
        };
        if (item2 && isText(item2) && !isParagraphEnd$1(item2)) {
            const strategy = isReplaceWordOnCursor ? replaceWordOnCursorInsertingStrategy : inPlaceInsertingStrategy;
            const slices = insertObjectInTextItem(item2, smileData, offsetCr, strategy);
            setEditorData(inlineData.slice(0, itemIndex - 1).concat(slices).concat(inlineData.slice(itemIndex)));
        } else if (item2 && isParagraphEnd$1(item2)) setEditorData(inlineData.slice(0, -1).concat(smileData, inlineData.slice(-1)));
        else setEditorData(inlineData.slice(0, itemIndex).concat(smileData).concat(inlineData.slice(itemIndex)));
    }, [
        setEditorData,
        getEditorData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prevBlogUrl && blogUrl && prevBlogUrl !== blogUrl) setIsNeedToFetchSmiles(true);
    }, [
        blogUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof prevIsAlreadySubscribed === "boolean" && isAlreadySubscribed) setIsNeedToFetchSmiles(true);
    }, [
        isAlreadySubscribed
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("click", onClickOutside, true);
        return ()=>{
            window.removeEventListener("click", onClickOutside, true);
            window.removeEventListener("resize", onResize);
        };
    }, [
        onClickOutside
    ]);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        const { isFetching } = smilesNetworkStatus;
        if (hasSmilesSelector && !isFetching) setTimeout(()=>{
            if (mounted) setIsNeedToFetchSmiles(true);
        }, 1e3);
        else setIsSmileSelectorOpened(false);
        return ()=>{
            mounted = false;
        };
    }, [
        hasSmilesSelector
    ]);
    (0, $acw62.useEffect)(()=>{
        const { isFetching } = smilesNetworkStatus;
        if (!isFetching && isNeedToFetchSmiles) {
            fetchSmiles();
            setIsNeedToFetchSmiles(false);
        }
    }, [
        isNeedToFetchSmiles
    ]);
    return {
        isSmileSelectorOpened: isSmileSelectorOpened,
        smileSelectorWrapperRef: smileSelectorWrapperRef,
        smileButtonRef: smileButtonRef,
        insertedSmileRef: insertedSmileRef,
        addSmileToInlineData: addSmileToInlineData,
        findSmileByName: findSmileByName,
        onSmilesButtonClick: onSmilesButtonClick,
        onCloseSmilesSelector: handleCloseSmilesSelector
    };
};
const useTextToolBridge = (params)=>{
    const { getSuggestedSmiles, findSmileByName, clearMentionsList, insertCurrentMention, isMentionsSuggestOpen, getMentionsList } = params;
    const bridgeRef = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.getSuggestedSmiles = getSuggestedSmiles;
    }, [
        getSuggestedSmiles
    ]);
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.findSmileByName = findSmileByName;
    }, [
        findSmileByName
    ]);
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.clearMentionsList = clearMentionsList;
    }, [
        clearMentionsList
    ]);
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.isMentionsSuggestOpen = isMentionsSuggestOpen;
    }, [
        isMentionsSuggestOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.insertCurrentMention = insertCurrentMention;
    }, [
        insertCurrentMention
    ]);
    (0, $acw62.useEffect)(()=>{
        bridgeRef.current.getMentionsList = getMentionsList;
    }, [
        getMentionsList
    ]);
    const getBridgeData = (0, $acw62.useCallback)(()=>{
        return bridgeRef.current;
    }, []);
    return {
        getBridgeData: getBridgeData
    };
};
class MentionTool {
    static get isInline() {
        return true;
    }
    static get sanitize() {
        return {
            p: {
                class: true,
                contenteditable: true,
                ["data-mention-id"]: true,
                ["data-display-name"]: true,
                ["data-id"]: true,
                ["data-type"]: true,
                ["data-unique-id"]: true
            }
        };
    }
    render() {
        return document.createElement("p");
    }
    surround(range2) {}
    checkState(selection) {
        return false;
    }
}
class SmileTool {
    static get isInline() {
        return true;
    }
    static get sanitize() {
        return {
            img: {
                src: true,
                srcset: true,
                alt: true,
                ["data-id"]: true
            }
        };
    }
    render() {
        return document.createElement("button");
    }
    surround(range2) {}
    checkState(selection) {
        return false;
    }
}
class SpaceTool {
    static get isInline() {
        return true;
    }
    static get sanitize() {
        return {
            p: true
        };
    }
    render() {
        return document.createElement("div");
    }
    surround(range2) {}
    checkState(selection) {
        return false;
    }
}
const PROBABLY_SMILES_REGEX = /(^|\s)[a-zA-Z0-9\-]+/g;
const MENTIONS_REGEX = /\@"(.*?)"\|[0-9]*/g;
class TextTool {
    constructor({ data, config: config2, api: api2, readOnly }){
        this.mentionsArr = [];
        this.replaceAllEntities = (text2)=>{
            const { findSmileByName } = this.getBridgeData();
            const textCopy = text2;
            const allSeparateStringsSet = new Set(textCopy.match(PROBABLY_SMILES_REGEX));
            const allMentions = textCopy.match(MENTIONS_REGEX);
            const newText = new HtmlText(textCopy);
            allSeparateStringsSet && allSeparateStringsSet.forEach((str)=>{
                const trimmedStr = str.trim();
                const smile2 = findSmileByName(trimmedStr);
                if (smile2) {
                    const parts = newText.currentText.split(trimmedStr);
                    newText.reset();
                    const smileMediaItem = convertSmileToMediaItem(smile2);
                    const smileHTML = convertSmileToHTML({
                        smile: smileMediaItem
                    });
                    parts.forEach((part, index2)=>{
                        newText.addHtmlText(part);
                        if (parts.length - 1 !== index2) newText.addHtmlText(smileHTML);
                    });
                }
            });
            allMentions && allMentions.forEach((mention2)=>{
                const [name2, id] = mention2.replace(/[\@\"]/g, "").split("|");
                const parts = newText.currentText.split(mention2);
                newText.reset();
                const mentionHTML = convertMentionToHTML({
                    id: Number(id),
                    uniqueId: uniqueId(),
                    type: EMediaDataType.MENTION,
                    displayName: name2
                });
                parts.forEach((part, index2)=>{
                    newText.addHtmlText(part);
                    if (parts.length - 1 !== index2) newText.addHtmlText(mentionHTML);
                });
            });
            return newText.currentText;
        };
        this.isTag = (event2)=>event2.type === "tag";
        this.api = api2;
        this.readOnly = readOnly;
        this._placeholder = config2.placeholder ? config2.placeholder : TextTool.DEFAULT_PLACEHOLDER;
        this._data = {};
        this._preserveBlank = config2.preserveBlank || false;
        this._parseLinks = config2.parseLinks || false;
        this.isSmileSuggestEnabled = config2.isSmileSuggestEnabled;
        this.isMentionsEnabled = config2.isMentionsEnabled;
        this.getBridgeData = config2.getBridgeData;
        this.mentionQueryLength = config2.mentionQueryLength;
        this._element = this.drawView();
        this.data = data;
    }
    static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    get CSS() {
        return {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        };
    }
    drawView() {
        const div = document.createElement("DIV");
        div.classList.add(this.CSS.wrapper, this.CSS.block);
        div.contentEditable = "false";
        div.dataset.placeholder = this.api.i18n.t(this._placeholder);
        if (!this.readOnly) {
            div.contentEditable = "true";
            div.addEventListener("paste", this.handlePaste.bind(this));
            div.addEventListener("keydown", this.handleKeyDown.bind(this));
            div.addEventListener("input", this.handleInput.bind(this));
            if (this.isSmileSuggestEnabled) div.addEventListener("click", this.handleClick.bind(this));
        }
        return div;
    }
    handlePaste(event2) {
        let pastedText = sanitizePastedText(event2.clipboardData.getData("text/plain"));
        let pastedHTML = sanitizePastedText(event2.clipboardData.getData("text/html"));
        if (pastedHTML) {
            pastedHTML = this.replaceAllEntities(pastedHTML);
            pastedHTML = pastedHTML.replace(MULTI_PARAGRAPH_REG, "<br>");
            insertHtmlAfterCursor(pastedHTML.replace(MULTI_LINE_BREAK_HTML_TAG_REGEX, "<br>"));
            event2.preventDefault();
            event2.stopPropagation();
            return;
        }
        if (pastedText.match(MULTI_LINE_BREAK_REG)) {
            pastedText = this.replaceAllEntities(pastedText);
            insertHtmlAfterCursor(pastedText.replace(MULTI_LINE_BREAK_REG, "<br>"));
            event2.preventDefault();
            event2.stopPropagation();
        }
    }
    getTextBeforeSpace(textContent, caretPosition, key) {
        if (key === EKeyboardKey.SPACE) return textContent.substring(0, caretPosition - 1);
        return null;
    }
    getCurrentModifyingWord(textContent, caretPosition) {
        const fullText = textContent;
        if (Boolean(this.mentionQueryLength) && caretPosition > this.mentionQueryLength) {
            const startIndex = fullText.lastIndexOf("@", caretPosition - 1);
            if (fullText[startIndex] === "@" && !charIsBreakspace(fullText[startIndex + 1])) return fullText.slice(startIndex, caretPosition);
        }
        const { start, end } = findCurrentWordIndexes(fullText, caretPosition);
        return fullText.slice(start, end);
    }
    checkFirstRateSign(textContent) {
        const isRateSignFound = (textContent == null ? void 0 : textContent[0]) === "@";
        return {
            isRateSignFound: isRateSignFound,
            textAfterSign: isRateSignFound ? textContent.slice(1) : ""
        };
    }
    handleClick() {
        const { clearMentionsList, getSuggestedSmiles, getMentionsList } = this.getBridgeData();
        const selection = window.getSelection();
        const caretPosition = getCaretPosition(selection.anchorNode.parentElement).offset;
        const currentModifyingWord = this.getCurrentModifyingWord(selection.focusNode.textContent, caretPosition);
        const { isRateSignFound, textAfterSign } = this.checkFirstRateSign(currentModifyingWord);
        if (!isRateSignFound) {
            clearMentionsList();
            getSuggestedSmiles(currentModifyingWord);
            return;
        }
        getSuggestedSmiles("");
        getMentionsList(textAfterSign);
    }
    handleKeyDown(event2) {
        const { isMentionsSuggestOpen, insertCurrentMention } = this.getBridgeData();
        if (event2.key === EKeyboardKey.ENTER && isMentionsSuggestOpen) {
            event2.preventDefault();
            event2.stopPropagation();
            insertCurrentMention();
            this._element.focus();
        }
    }
    getCleanTextPositions(node) {
        let position2 = 0;
        const cleanTextPositions = [];
        if (node.tagName === void 0) return null;
        node.childNodes.forEach((childNode)=>{
            const nodeLength = childNode.textContent.length;
            if (childNode.tagName === void 0) cleanTextPositions.push([
                position2 === 0 ? 0 : position2 + 1,
                position2 + nodeLength - 1
            ]);
            position2 += nodeLength;
        });
        return cleanTextPositions;
    }
    handleInput(event2) {
        const { key, keyCode } = getKeyAndKeyCode(event2);
        const { clearMentionsList, getSuggestedSmiles, getMentionsList } = this.getBridgeData();
        if (!isPrintableKey(keyCode)) return;
        const selection = window.getSelection();
        const isEmpty2 = selection.focusNode.textContent.length === 0;
        if (isEmpty2) {
            getSuggestedSmiles == null || getSuggestedSmiles("");
            return;
        }
        const accurateCaretPosition = getCaretPosition(selection.anchorNode.parentElement).offset;
        const currentModifyingWord = this.getCurrentModifyingWord(selection.focusNode.textContent, accurateCaretPosition);
        const { isRateSignFound, textAfterSign } = this.checkFirstRateSign(currentModifyingWord);
        if (!isRateSignFound) {
            clearMentionsList();
            const cleanTextPositions = this.getCleanTextPositions(selection.focusNode);
            let isCleanText = true;
            if (cleanTextPositions) {
                isCleanText = false;
                cleanTextPositions.forEach((position2)=>{
                    if (position2[0] < accurateCaretPosition && accurateCaretPosition < position2[1]) isCleanText = true;
                });
            }
            if (this.isSmileSuggestEnabled && isCleanText) {
                const textBeforeSpace = this.getTextBeforeSpace(selection.focusNode.textContent, accurateCaretPosition, key);
                getSuggestedSmiles(currentModifyingWord, textBeforeSpace);
            }
            return;
        }
        getSuggestedSmiles == null || getSuggestedSmiles("");
        if (this.isMentionsEnabled) getMentionsList(textAfterSign);
    }
    render() {
        return this._element;
    }
    merge(data) {
        this.data = {
            text: this.data.text + data.text
        };
    }
    validate(savedData) {
        return !(savedData.text.trim() === "" && !this._preserveBlank);
    }
    save(toolsContent) {
        return {
            text: toolsContent.innerHTML
        };
    }
    onKeyUp(event2) {
        if (event2.code !== "Backspace" && event2.code !== "Delete") return;
        const { textContent } = this._element;
        if (textContent === "") this._element.innerHTML = "";
    }
    onPaste(event2) {
        if (this.isTag(event2)) this.data = {
            text: event2.detail.data.innerHTML
        };
    }
    static get conversionConfig() {
        return {
            export: "text",
            import: "text"
        };
    }
    static get sanitize() {
        return {
            text: {
                br: true,
                [NO_BREAK_SPACE$1]: true
            }
        };
    }
    static get isReadOnlySupported() {
        return true;
    }
    static get enableLineBreaks() {
        return true;
    }
    get data() {
        this._data.text = this._element.innerHTML;
        return this._data;
    }
    set data(data) {
        this._data = data || {};
        this._element.innerHTML = this._data.text || "";
        this.mentionsArr = Array.from(this._element.childNodes).filter(isMention);
    }
    static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    static get toolbox() {
        return {
            icon: svg_name_text.content,
            title: "Text"
        };
    }
}
const editor$1 = "Publisher-scss--module__editor___ce6On";
const editorDisabled = "Publisher-scss--module__editorDisabled___M2aSL";
const sendContainer$1 = "Publisher-scss--module__sendContainer___GYmgz";
const iconSend = "Publisher-scss--module__iconSend___1YAMr";
const smileContainer = "Publisher-scss--module__smileContainer___2Asbo";
const smileContainerActive = "Publisher-scss--module__smileContainerActive___pAo4m";
const iconSmile = "Publisher-scss--module__iconSmile___kE-3O";
const attachContainer = "Publisher-scss--module__attachContainer___ZqX-H";
const iconAttach = "Publisher-scss--module__iconAttach___UDrs9";
const editorWrapper = "Publisher-scss--module__editorWrapper___FEhlk";
const actionsContainer$1 = "Publisher-scss--module__actionsContainer___6-quX";
const root$r = "Publisher-scss--module__root___kHsnO";
const wide = "Publisher-scss--module__wide___vpreL";
const error = "Publisher-scss--module__error___-ZwxS";
const rootDisabled = "Publisher-scss--module__rootDisabled___bHKyC";
const smileSelectorWrapper = "Publisher-scss--module__smileSelectorWrapper___3X3Eg";
const smileSuggestWrapper = "Publisher-scss--module__smileSuggestWrapper___Ff5jK";
const popoverFloating = "Publisher-scss--module__popoverFloating___uTFFE";
const mentionSuggestReference = "Publisher-scss--module__mentionSuggestReference___nMj8C";
const placeholder$2 = "Publisher-scss--module__placeholder___4wM9g";
const placeholderIcon = "Publisher-scss--module__placeholderIcon___0Glb1";
const s$F = {
    editor: editor$1,
    editorDisabled: editorDisabled,
    sendContainer: sendContainer$1,
    iconSend: iconSend,
    smileContainer: smileContainer,
    smileContainerActive: smileContainerActive,
    iconSmile: iconSmile,
    attachContainer: attachContainer,
    iconAttach: iconAttach,
    editorWrapper: editorWrapper,
    actionsContainer: actionsContainer$1,
    root: root$r,
    wide: wide,
    error: error,
    rootDisabled: rootDisabled,
    smileSelectorWrapper: smileSelectorWrapper,
    smileSuggestWrapper: smileSuggestWrapper,
    popoverFloating: popoverFloating,
    mentionSuggestReference: mentionSuggestReference,
    placeholder: placeholder$2,
    placeholderIcon: placeholderIcon
};
const MIN_SLOWMODE_TIMEOUT_SEC = 1;
const ROLE = "container";
const BLOCKS_SELECTOR = ".ce-paragraph.cdx-block";
let controller = new AbortController();

const Publisher = (0, $acw62.forwardRef)((props, ref2)=>{
    const { inlineData, editorData, settedPrevMessageRef, placeholder: placeholder2, isDisabled: isDisabled2, isWide, isSubmitButtonDisabled, isBlogOwner = false, isChatModerator = false, isBlogOwnerAgent, classNames = {}, submitIcon = svg_name_send_24, hasAttachButton, hasSubmitButton = true, hasSmilesSelector = false, preventScrollOnMobileFocus = true, hasAutoFocus, hasError, blogUrl, addMentionRef, onInlineDataChange, setEditorData, onUnavailableSmileSuggestClick = noop$2, onKeyDown, onPublish, onToggleSmilesSuggest = noop$2, onAttachFile = noop$2, publishingShortcut = EPublishingShortcut.CTRL_ENTER, wrapperId, onKeyUp: handleKeyUp } = props;
    const [, setForceUpdate] = (0, $acw62.useState)(false);
    const [isEditorJsEmpty, setIsEditorJsEmpty] = (0, $acw62.useState)(true);
    const { anyMessageTimeout, notRestrictable } = (0, $iD0SF.useSelector)(streamChatSettingsSelector);
    const prevBlogUrl = usePrevious(blogUrl);
    const { focus: focusEditor } = (0, $iD0SF.useSelector)(publisherStateSelector);
    const store2 = (0, $4TSkt.useStore)();
    const listRef = (0, $acw62.useRef)([]);
    const editorRef = (0, $acw62.useRef)();
    const editorJS = (0, $acw62.useRef)(null);
    const mutationObserver = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const prevEditorData = usePrevious(editorData);
    const selectedSmile = (0, $iD0SF.useSelector)(selectedSmileSelector);
    const { isMobile: isMobile2 } = getConfig();
    const { getTimer, setTimer } = useChatSlowmodeTimer(blogUrl);
    const isSlowmodeEnabled = anyMessageTimeout > MIN_SLOWMODE_TIMEOUT_SEC;
    const hasSpecialRights = isBlogOwner || isBlogOwnerAgent || isChatModerator || notRestrictable;
    const timer = !hasSpecialRights && !isChatModerator ? getTimer() : 0;
    const publisherPlaceholder = isSlowmodeEnabled || !hasSubmitButton ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, placeholder2, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$F.placeholderIcon,
        glyph: svg_name_clock_wise
    })) : placeholder2;
    const isComplexPlaceholder = (0, $acw62.isValidElement)(publisherPlaceholder);
    const isOutlineClick = (0, $acw62.useCallback)((event2)=>{
        const suggestWrapper = document.getElementById(wrapperId);
        const editorWrapper2 = editorRef.current;
        return !(suggestWrapper == null ? void 0 : suggestWrapper.contains(event2.target)) && !(editorWrapper2 == null ? void 0 : editorWrapper2.contains(event2.target));
    }, [
        wrapperId,
        editorRef
    ]);
    const getEditorData = (0, $acw62.useCallback)(async ()=>{
        clearDeepL();
        await editorJS.current.isReady;
        if (!editorRef.current) return void 0;
        const paragraphs = editorRef.current.querySelectorAll(BLOCKS_SELECTOR);
        return convertNodesToBlogPostData(paragraphs);
    }, []);
    const setCaretPosition = ()=>{
        var _a3;
        if (!editorRef.current) return;
        const paragraphs = editorRef.current.querySelectorAll(BLOCKS_SELECTOR);
        if (paragraphs.length) {
            const paragraphIndex = ((_a3 = cursorRef.current) == null ? void 0 : _a3.blockIndex) ?? paragraphs.length - 1;
            const paragraph = paragraphs[paragraphIndex];
            cursorRef.current = getCaretPosition(paragraph);
        }
    };
    const { cursorRef, onMouseUp, onKeyUp, onRestoreCursorPosition } = useEditorCursorPosition({
        editorRef: editorRef,
        handleKeyUp: handleKeyUp
    });
    const handlePublish = (data)=>{
        if (isEmptyMediaData(data)) return;
        onPublish(data);
        if (!hasSpecialRights && isSlowmodeEnabled && !timer) setTimer();
    };
    const { isSmileSelectorOpened, smileSelectorWrapperRef, smileButtonRef, insertedSmileRef, addSmileToInlineData, onSmilesButtonClick, onCloseSmilesSelector, findSmileByName } = useSmiles({
        blogUrl: blogUrl,
        hasSmilesSelector: hasSmilesSelector,
        cursorRef: cursorRef,
        preventScrollOnMobileFocus: preventScrollOnMobileFocus,
        editorJS: editorJS,
        setEditorData: setEditorData,
        getEditorData: getEditorData
    });
    const { isSuggestEnabled: isSmileSuggestEnabled, isNavigationEnabled: isSmileSuggestNavigationEnabled, suggestedSmiles, selectedSmileIndex, selectedSmileRef, onSmileClick, replaceLastSmileAndPublish, replaceSelectedSmile, onSelectNextSmile, onSelectPrevSmile, getSuggestedSmiles } = useSmilesSuggest({
        onUnavailableSmileClick: onUnavailableSmileSuggestClick,
        onAvailableSmileClick: addSmileToInlineData,
        onPublish: handlePublish,
        getEditorData: getEditorData,
        inlineData: inlineData,
        isOutlineClick: isOutlineClick
    });
    const { isMentionsEnabled, isMentionsSuggestOpen, chatUserSearchList, insertedMentionRef, activeIndex, onMentionClick, getMentionsList, insertCurrentMention, addMentionToInlineData, clearMentionsList } = useChatUsersMentions({
        blogUrl: blogUrl,
        cursorRef: cursorRef,
        restoreCursorPosition: onRestoreCursorPosition,
        inlineData: inlineData,
        setEditorData: setEditorData
    });
    const { getBridgeData } = useTextToolBridge({
        clearMentionsList: clearMentionsList,
        findSmileByName: findSmileByName,
        getSuggestedSmiles: getSuggestedSmiles,
        insertCurrentMention: insertCurrentMention,
        isMentionsSuggestOpen: isMentionsSuggestOpen,
        getMentionsList: getMentionsList
    });
    const isSmileSuggestOpen = hasSmilesSelector && suggestedSmiles.length > 0 && wrapperId;
    (0, $acw62.useEffect)(()=>{
        if (prevBlogUrl && prevBlogUrl !== blogUrl) setEditorData([]);
    }, [
        blogUrl
    ]);
    (0, $acw62.useImperativeHandle)(ref2, ()=>({
            focus: async ()=>{
                var _a3, _b2, _c2;
                if (!editorJS.current) return;
                if ((_a3 = editorJS.current) == null ? void 0 : _a3.focus) (_b2 = editorJS.current) == null || _b2.focus(true);
                else {
                    await editorJS.current.isReady;
                    (_c2 = editorJS.current) == null || _c2.focus(true);
                }
                setCaretPosition();
            },
            scrollIntoView: ()=>{
                var _a3;
                (_a3 = editorRef.current) == null || _a3.scrollIntoView(getScrollIntoViewOptions("nearest"));
            }
        }));
    (0, $acw62.useEffect)(()=>{
        addMentionRef.current = addMentionToInlineData;
    }, [
        addMentionToInlineData
    ]);
    (0, $acw62.useEffect)(()=>onToggleSmilesSuggest(isSmileSelectorOpened), [
        isSmileSelectorOpened
    ]);
    (0, $acw62.useEffect)(()=>{
        if (editorData !== prevEditorData && editorJS.current) editorJS.current.isReady.then(()=>{
            if (!settedPrevMessageRef.current) editorJS.current.clear();
            if (editorData == null ? void 0 : editorData.length) {
                editorJS.current.render(convertBlogPostDataToEditorState(editorData));
                setTimeout(()=>{
                    if (settedPrevMessageRef.current) {
                        editorJS.current.focus();
                        onRestoreCursorPosition({
                            type: EMediaDataType.TEXT
                        });
                        settedPrevMessageRef.current = null;
                    }
                    if (insertedMentionRef.current) {
                        onRestoreCursorPosition(insertedMentionRef.current);
                        insertedMentionRef.current = null;
                    }
                    if (insertedSmileRef.current) {
                        onRestoreCursorPosition(insertedSmileRef.current);
                        insertedSmileRef.current = null;
                    }
                });
            }
            onInlineDataChange(editorData);
        });
    }, [
        editorData,
        prevEditorData
    ]);
    const reInit = async (signal)=>{
        var _a3, _b2;
        if (signal.aborted) return;
        let isAborted = false;
        const abort = ()=>{
            isAborted = true;
        };
        signal.addEventListener("abort", abort);
        if (mutationObserver.current) mutationObserver.current.disconnect();
        if (editorJS.current) {
            await editorJS.current.isReady;
            if (!isAborted) (_b2 = (_a3 = editorJS.current).destroy) == null || _b2.call(_a3);
            else {
                signal.removeEventListener("abort", abort);
                return;
            }
        }
        initEditorJSAwaitRef.current = await (parcelRequire("lXLT6")).then((n2)=>n2.e);
        if (!isAborted) initEditorJS();
        signal.removeEventListener("abort", abort);
    };
    (0, $acw62.useEffect)(()=>{
        controller.abort();
        controller = new AbortController();
        reInit(controller.signal);
    }, [
        placeholder2,
        isComplexPlaceholder
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            destroyEditorJS();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        var _a3;
        (_a3 = editorJS.current) == null || _a3.isReady.then(()=>{
            var _a4, _b2;
            (_b2 = (_a4 = editorJS.current) == null ? void 0 : _a4.readOnly) == null || _b2.toggle(isDisabled2);
        });
    }, [
        isDisabled2
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedSmile) addSmileToInlineData({
            smile: selectedSmile
        });
    }, [
        selectedSmile
    ]);
    const initEditorJSAwaitRef = (0, $acw62.useRef)(null);
    const initEditorJS = ()=>{
        const { default: EditorJS2 } = initEditorJSAwaitRef.current;
        if (!editorRef.current) return;
        const editorConfig = {
            holder: editorRef.current,
            placeholder: isComplexPlaceholder ? "" : publisherPlaceholder,
            data: convertBlogPostDataToEditorState(inlineData),
            inlineToolbar: false,
            readOnly: isDisabled2,
            tools: {
                paragraph: {
                    class: TextTool,
                    config: {
                        preserveBlank: true,
                        parseLinks: false,
                        store: store2,
                        isSmileSuggestEnabled: isSmileSuggestEnabled,
                        isMentionsEnabled: isMentionsEnabled,
                        getBridgeData: getBridgeData
                    }
                },
                [EMediaDataType.SMILE]: SmileTool,
                [EMediaDataType.MENTION]: MentionTool,
                [EMediaDataType.SPACE]: SpaceTool
            },
            onChange: async ()=>{
                if (!Object.keys(editorJS.current).length) return;
                const newData = await getEditorData();
                onInlineDataChange(newData);
            }
        };
        editorJS.current = new EditorJS2(editorConfig);
        if (hasAutoFocus) editorJS.current.focus(true);
        setTimeout(async ()=>{
            await editorJS.current.isReady;
            if (!editorRef.current) return;
            const paragraphs = editorRef.current.querySelectorAll(".codex-editor");
            if (paragraphs.length) {
                mutationObserver.current = new MutationObserver(handleChange);
                mutationObserver.current.observe(paragraphs[0], {
                    subtree: true,
                    childList: true,
                    characterData: true
                });
            }
            function handleChange(changes) {
                const target2 = paragraphs[0];
                if (target2) {
                    const block2 = target2.querySelector(BLOCKS_SELECTOR);
                    const isEmptyBlock = (block2 == null ? void 0 : block2.childNodes.length) === 0 || (block2 == null ? void 0 : block2.childNodes.length) === 1 && head$3(block2 == null ? void 0 : block2.childNodes).nodeName.toLowerCase() === "br";
                    setIsEditorJsEmpty(isEmptyBlock);
                }
                if (changes.length === 2 && changes.every((item2)=>item2.type === "childList")) setCaretPosition();
            }
        });
    };
    const destroyEditorJS = async ()=>{
        var _a3, _b2;
        if (mutationObserver.current) mutationObserver.current.disconnect();
        if (editorJS.current) {
            await editorJS.current.isReady;
            (_b2 = (_a3 = editorJS.current).destroy) == null || _b2.call(_a3);
        }
    };
    const setActiveIndex = (value2)=>{
        store2.dispatch(setActiveIndexPopover({
            activeIndexPopover: value2
        }));
    };
    const handlePublishClick = ()=>{
        replaceLastSmileAndPublish();
    };
    const handleAttachButtonClick = ()=>{
        onAttachFile();
    };
    const handleSmileSuggestNavigation = (event2)=>{
        if (!isSmileSuggestOpen || !isSmileSuggestNavigationEnabled) return;
        if (event2.key === EKeyboardKey.ARROW_UP) {
            event2.preventDefault();
            onSelectPrevSmile();
        }
        if (event2.key === EKeyboardKey.ARROW_DOWN) {
            event2.preventDefault();
            onSelectNextSmile();
        }
        if (event2.key === EKeyboardKey.TAB) {
            event2.preventDefault();
            replaceSelectedSmile();
        }
    };
    const handleMentionsSuggestShortcut = (event2)=>{
        if (!isMentionsSuggestOpen) return;
        const userSearchListLength = chatUserSearchList.length;
        if (EKeyboardKey.TAB === event2.key && chatUserSearchList[activeIndex]) {
            event2.preventDefault();
            onMentionClick(chatUserSearchList[activeIndex]);
        }
        if (event2.key === EKeyboardKey.ARROW_DOWN) {
            event2.preventDefault();
            const activeUserIndex = activeIndex >= userSearchListLength - 1 ? 0 : activeIndex + 1;
            setActiveIndex(activeUserIndex);
        }
        if (event2.key === EKeyboardKey.ARROW_UP) {
            event2.preventDefault();
            const activeUserIndex = activeIndex <= 0 ? userSearchListLength - 1 : activeIndex - 1;
            setActiveIndex(activeUserIndex);
        }
    };
    const handleKeyDown = (event2)=>{
        handleSmileSuggestNavigation(event2);
        handleMentionsSuggestShortcut(event2);
        if (isPublishingShortcutApplied(event2, publishingShortcut)) {
            event2.preventDefault();
            replaceLastSmileAndPublish();
        }
        onKeyDown && onKeyDown(event2);
    };
    const { x: x2, y: y2, refs, strategy, context } = useFloating({
        open: isMentionsSuggestOpen,
        middleware: [
            offset$1(5),
            size({
                // eslint-disable-next-line
                apply ({ rects, elements }) {
                    Object.assign(elements.floating.style, {
                        // eslint-disable-next-line
                        width: `${rects.reference.width}px`
                    });
                }
            }),
            shift()
        ],
        whileElementsMounted: autoUpdate,
        placement: "top"
    });
    const click = useClick(context, {
        keyboardHandlers: false
    });
    const dismiss = useDismiss(context);
    const role2 = useRole(context, {
        role: "listbox"
    });
    const listNav = useListNavigation(context, {
        listRef: listRef,
        activeIndex: activeIndex,
        onNavigate: setActiveIndex,
        virtual: true,
        loop: true
    });
    const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
        click,
        dismiss,
        role2,
        listNav
    ]);
    const isActionsContainerVisible = hasSmilesSelector || hasAttachButton || hasSubmitButton;
    const shouldShowDynamicPlaceholder = Boolean(isComplexPlaceholder) && isEditorJsEmpty;
    const iconSmile2 = isMobile2 ? svg_name_smile_outline_24 : svg_name_smile_outline_20;
    (0, $acw62.useEffect)(()=>{
        if (hasSmilesSelector && isSmileSelectorOpened && wrapperId) AppStat.log.chat.smilePopupShow();
    }, [
        isSmileSelectorOpened
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a3;
        if (focusEditor) (_a3 = editorJS.current) == null || _a3.focus();
    }, [
        focusEditor
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!editorRef.current) return void 0;
        const handleFocusOut = ()=>{
            dispatch(focusPublisher({
                focus: false
            }));
        };
        editorRef.current.addEventListener("focusout", handleFocusOut);
        return ()=>{
            var _a3;
            (_a3 = editorRef.current) == null || _a3.removeEventListener("focusout", handleFocusOut);
        };
    }, [
        editorRef.current
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.root, classNames.root, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.rootDisabled, classNames.rootDisabled)]: isDisabled2,
            [s$F.error]: hasError,
            [s$F.wide]: isWide
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$F.mentionSuggestReference,
        ref: refs.setReference,
        ...getReferenceProps()
    }), isMentionsSuggestOpen && /* @__PURE__ */ $acw62.createElement(PopoverFloating, {
        classNames: {
            root: s$F.popoverFloating
        },
        items: chatUserSearchList,
        x: x2,
        y: y2,
        context: context,
        floating: refs.setFloating,
        strategy: strategy,
        getFloatingProps: getFloatingProps,
        onClick: onMentionClick,
        listRef: listRef,
        activeIndex: activeIndex,
        getItemProps: getItemProps
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$F.editorWrapper
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.editor, classNames.editor, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.editorDisabled, classNames.editorDisabled)]: isDisabled2
        }),
        onKeyDown: handleKeyDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        ref: editorRef
    }), shouldShowDynamicPlaceholder && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$F.placeholder
    }, Boolean(timer) ? /* @__PURE__ */ $acw62.createElement(Countdown, {
        timeLeft: timer,
        onEnd: ()=>{
            setForceUpdate((prev)=>!prev);
        },
        mode: ECountdownMode.CLOCK
    }) : publisherPlaceholder)), isActionsContainerVisible && /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.actionsContainer, classNames.actionsContainer, {
            [classNames.actionsContainerDisabled]: isDisabled2
        })
    }, hasSmilesSelector && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.smileContainer, isSmileSelectorOpened && s$F.smileContainerActive, classNames.smileContainer),
        disabled: isDisabled2,
        ref: smileButtonRef
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: iconSmile2,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.iconSmile, classNames.iconSmile),
        onClick: onSmilesButtonClick
    })), hasAttachButton && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.attachContainer, classNames.attachContainer),
        disabled: isDisabled2
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_attach,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.iconAttach, classNames.iconAttach),
        onClick: handleAttachButtonClick
    })), hasSubmitButton && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, isSlowmodeEnabled && timer ? /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.sendContainer, classNames.sendContainer)
    }, /* @__PURE__ */ $acw62.createElement(CountdownCircle, {
        timeLeft: timer,
        duration: anyMessageTimeout * 1e3,
        onEnd: ()=>{
            setForceUpdate((prev)=>!prev);
        },
        onClick: handlePublishClick
    })) : /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.sendContainer, classNames.sendContainer),
        disabled: isDisabled2 || isSubmitButtonDisabled,
        onClick: handlePublishClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: submitIcon,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.iconSend, classNames.iconSend)
    })))), hasSmilesSelector && isSmileSelectorOpened && wrapperId && (0, $1u0KT.createPortal)(/* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.smileSelectorWrapper, classNames.smileSelectorWrapper),
        ref: smileSelectorWrapperRef
    }, /* @__PURE__ */ $acw62.createElement(SmilesSelector, {
        blogUrl: blogUrl,
        onSelect: addSmileToInlineData,
        onClose: onCloseSmilesSelector
    })), document.getElementById(wrapperId)), isSmileSuggestOpen && (0, $1u0KT.createPortal)(/* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$F.smileSuggestWrapper),
        "data-role": ROLE
    }, /* @__PURE__ */ $acw62.createElement(SmilesList, {
        selectedSmileIndex: selectedSmileIndex,
        activeSmileRef: selectedSmileRef,
        smiles: suggestedSmiles,
        onSmileClick: onSmileClick
    })), document.getElementById(wrapperId)));
});
Publisher.displayName = "Publisher";
var EChatWarningType = /* @__PURE__ */ ((EChatWarningType2)=>{
    EChatWarningType2["BANNED_PERMANENTLY"] = "bannedPermanently";
    EChatWarningType2["BANNED_TEMPORARILY"] = "bannedTemporarily";
    EChatWarningType2["CHAR_LIMIT"] = "charLimit";
    EChatWarningType2["FREQUENT_SENDING"] = "frequentSending";
    EChatWarningType2["IDENTICAL_MESSAGE"] = "identicalMessage";
    EChatWarningType2["INVALID_PARAM"] = "invalidParam";
    EChatWarningType2["PAID_SUBSCRIBERS_ONLY"] = "paidSubscribersOnly";
    EChatWarningType2["SUBSCRIBERS_ONLY"] = "subscribersOnly";
    EChatWarningType2["POSTPONED_REWARD"] = "postponedReward";
    EChatWarningType2["INVALID_SMILES_USED"] = "invalidSmilesUsed";
    EChatWarningType2["RETRANSLATION_ACTIVE"] = "retranslationActive";
    EChatWarningType2["LINKS_PROHIBITED"] = "linksProhibited";
    EChatWarningType2["ONLY_LETTERS"] = "onlyLetters";
    EChatWarningType2["ONLY_SMILES"] = "onlySmiles";
    return EChatWarningType2;
})(EChatWarningType || {});
const root$q = "CardLayoutWarning-scss--module__root___--Xkt";
const blocker = "CardLayoutWarning-scss--module__blocker___JyT1b";
const s$E = {
    root: root$q,
    blocker: blocker
};
const CardLayoutWarning = (props)=>{
    const { className, withPublisherBlocker, children: children2, onClick } = props;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$E.root, {
            [s$E.blocker]: withPublisherBlocker
        }, className),
        onClick: onClick
    }, children2);
};
var ETitleLayoutWarningType = /* @__PURE__ */ ((ETitleLayoutWarningType2)=>{
    ETitleLayoutWarningType2["INFO"] = "info";
    ETitleLayoutWarningType2["RETRANSLATION"] = "retranslation";
    ETitleLayoutWarningType2["WARNING"] = "warning";
    return ETitleLayoutWarningType2;
})(ETitleLayoutWarningType || {});
const root$p = "TitleLayoutWarning-scss--module__root___bSf4t";
const text$3 = "TitleLayoutWarning-scss--module__text___-xYfJ";
const icon$9 = "TitleLayoutWarning-scss--module__icon___WhT6I";
const iconWarning = "TitleLayoutWarning-scss--module__iconWarning___7f18b";
const iconInfo = "TitleLayoutWarning-scss--module__iconInfo___CabOs";
const iconRetranslation = "TitleLayoutWarning-scss--module__iconRetranslation___8FuIG";
const s$D = {
    root: root$p,
    text: text$3,
    icon: icon$9,
    iconWarning: iconWarning,
    iconInfo: iconInfo,
    iconRetranslation: iconRetranslation
};
const TitleLayoutWarning = (props)=>{
    const { className, title: title2, type = ETitleLayoutWarningType.INFO } = props;
    let icon2 = null;
    switch(type){
        case ETitleLayoutWarningType.INFO:
            icon2 = /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: svg_name_info_circle_outline_20,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$D.icon, s$D.iconInfo)
            });
            break;
        case ETitleLayoutWarningType.WARNING:
            icon2 = /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: svg_name_warning_triangle_outline_20,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$D.icon, s$D.iconWarning)
            });
            break;
        case ETitleLayoutWarningType.RETRANSLATION:
            icon2 = /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: svg_name_wave,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$D.icon, s$D.iconRetranslation)
            });
            break;
    }
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$D.root, className)
    }, icon2, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$D.text
    }, title2));
};
const close$2 = "BaseLayoutWarningExpanded-scss--module__close___M8-8s";
const title$9 = "BaseLayoutWarningExpanded-scss--module__title___etPtG";
const description$3 = "BaseLayoutWarningExpanded-scss--module__description___nH0xg";
const s$C = {
    close: close$2,
    title: title$9,
    description: description$3
};
const BaseLayoutWarningExpanded = (props)=>{
    const { children: children2, className, title: title2, type = ETitleLayoutWarningType.INFO, withPublisherBlocker = true, onClose } = props;
    const isCloseButtonExist = Boolean(onClose);
    const handleClose = ()=>{
        onClose == null || onClose();
    };
    return /* @__PURE__ */ $acw62.createElement(CardLayoutWarning, {
        className: className,
        withPublisherBlocker: withPublisherBlocker
    }, isCloseButtonExist && /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$C.close,
        glyph: svg_name_cancel_20,
        onClick: handleClose
    }), /* @__PURE__ */ $acw62.createElement(TitleLayoutWarning, {
        className: s$C.title,
        title: title2,
        type: type
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$C.description)
    }, children2));
};
const title$8 = "BaseLayoutWarning-scss--module__title___EUOlo";
const hidden = "BaseLayoutWarning-scss--module__hidden___Vejkg";
const s$B = {
    title: title$8,
    hidden: hidden
};
const BaseLayoutWarning = (props)=>{
    const { children: children2, title: title2, withTypingBlocker = true } = props;
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    const handleClick = ()=>{
        if (!isExpanded) setIsExpanded(true);
    };
    const handleClose = ()=>{
        setIsExpanded(false);
    };
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$B.hidden]: !isExpanded
        }),
        title: title2,
        type: ETitleLayoutWarningType.WARNING,
        withPublisherBlocker: withTypingBlocker,
        onClose: handleClose
    }, children2), /* @__PURE__ */ $acw62.createElement(CardLayoutWarning, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            [s$B.hidden]: isExpanded
        }),
        withPublisherBlocker: withTypingBlocker,
        onClick: handleClick
    }, /* @__PURE__ */ $acw62.createElement(TitleLayoutWarning, {
        className: s$B.title,
        title: title2
    })));
};
const locales$x = {
    youAreBanned: "\u0412\u0430\u0441 \u0437\u0430\u0431\u0430\u043D\u0438\u043B \u0441\u0442\u0440\u0438\u043C\u0435\u0440 \u0438\u043B\u0438 \u043C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440 \u043A\u0430\u043D\u0430\u043B\u0430",
    youHaveBeenBannedPermanently: "\u0412\u0430\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043B\u0438 \u043D\u0430 \u044D\u0442\u043E\u043C \u043A\u0430\u043D\u0430\u043B\u0435."
};
const t$x = distExports$1.getTranslation && locales$x;
const BannedPermanentlyWarning = ()=>{
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarning, {
        title: t$x.youAreBanned
    }, t$x.youHaveBeenBannedPermanently);
};
const locales$w = {
    chatTimeout: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442 \u0432 \u0447\u0430\u0442\u0435",
    youHaveBeenBannedTemporarily: "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u0442\u0430\u0439\u043C\u0430\u0443\u0442 \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E \u0447\u0430\u0442\u0430 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0435.",
    banWillExpireBy: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437",
    banWillBeValidUntilStreamEnd: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438"
};
const t$w = distExports$1.getTranslation && locales$w;
const BannedTemporarilyWarning = (props)=>{
    const { timeout: timeout2, onClose: onEnd } = props;
    const isBannedForSomeTime = Boolean(timeout2);
    const isBannedByStreamEnd = !isBannedForSomeTime;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarning, {
        title: t$w.chatTimeout
    }, isBannedForSomeTime && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, t$w.youHaveBeenBannedTemporarily, " ", t$w.banWillExpireBy, " ", /* @__PURE__ */ $acw62.createElement(Countdown, {
        timeLeft: timeout2,
        onEnd: onEnd
    })), isBannedByStreamEnd && /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, t$w.youHaveBeenBannedTemporarily, " ", t$w.banWillBeValidUntilStreamEnd));
};
const locales$v = {
    charLimitExceeded: "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
    maxCharCount: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B-\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432: {{count}}"
};
const t$v = distExports$1.getTranslation && locales$v;
const CharLimitWarning = (props)=>{
    const { count: count2, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: t$v.charLimitExceeded,
        onClose: onClose
    }, distExports$1.getParametrizedText(t$v.maxCharCount, {
        count: count2
    }));
};
const locales$u = {
    slowmode: "\u041C\u0435\u0434\u043B\u0435\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
    sendMessage: "\u0412\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0447\u0435\u0440\u0435\u0437"
};
const t$u = distExports$1.getTranslation && locales$u;
const FrequentSendingWarning = (props)=>{
    const { timeout: timeout2, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: t$u.slowmode,
        onClose: onClose
    }, t$u.sendMessage, " ", /* @__PURE__ */ $acw62.createElement(Countdown, {
        timeLeft: timeout2,
        onEnd: onClose
    }));
};
const description$2 = "IdenticalMessageWarning-scss--module__description___39KZw";
const s$A = {
    description: description$2
};
const locales$t = {
    messageIsNotSent: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
    identicalMessage: "\u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u043C, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u043C\u0435\u043D\u0435\u0435 {{count}} \u0441\u0435\u043A. \u043D\u0430\u0437\u0430\u0434.",
    resendAfter: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u0447\u0435\u0440\u0435\u0437"
};
const t$t = distExports$1.getTranslation && locales$t;
const IdenticalMessageWarning = (props)=>{
    const { count: count2, timeout: timeout2, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: t$t.messageIsNotSent,
        onClose: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$A.description
    }, distExports$1.getParametrizedText(t$t.identicalMessage, {
        count: count2
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$A.description
    }, t$t.resendAfter, " ", /* @__PURE__ */ $acw62.createElement(Countdown, {
        timeLeft: timeout2,
        onEnd: onClose
    })));
};
const locales$s = {
    messageNotSent: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
    errorOccurredWhileSending: "\u041F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430"
};
const t$s = distExports$1.getTranslation && locales$s;
const InvalidParamWarning = (props)=>{
    const { description: description2 = t$s.errorOccurredWhileSending, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: t$s.messageNotSent,
        onClose: onClose
    }, description2);
};
const nick$1 = "PaidSubscribersOnlyWarning-scss--module__nick___borwO";
const button$5 = "PaidSubscribersOnlyWarning-scss--module__button___kJBpU";
const s$z = {
    nick: nick$1,
    button: button$5
};
const locales$r = {
    chatOnlyForPaidSubscribers: "\u0427\u0430\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u0432",
    youShouldBePaidSubscriberOf: "\u0414\u043B\u044F \u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0432 \u0447\u0430\u0442\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u043C {{name}}",
    ofLevel: " \u0443\u0440\u043E\u0432\u043D\u044F {{levelName}}",
    subscribe: "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F"
};
const t$r = distExports$1.getTranslation && locales$r;
const PaidSubscribersOnlyWarning = (props)=>{
    var _a3;
    const { requiredSubscriptionLevel } = props;
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const ButtonComponent = ({ onClick })=>/* @__PURE__ */ $acw62.createElement(ButtonCell, {
            className: s$z.button,
            left: svg_name_favorite_outline_24,
            onClick: onClick
        }, t$r.subscribe);
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarning, {
        title: t$r.chatOnlyForPaidSubscribers
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$z.nick
    }, distExports$1.getParametrizedText(t$r.youShouldBePaidSubscriberOf, {
        name: (_a3 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _a3.nick
    }), (requiredSubscriptionLevel == null ? void 0 : requiredSubscriptionLevel.name) && distExports$1.getParametrizedText(t$r.ofLevel, {
        levelName: requiredSubscriptionLevel == null ? void 0 : requiredSubscriptionLevel.name
    })), /* @__PURE__ */ $acw62.createElement(SubscribeButton, {
        className: s$z.button,
        requiredLevelId: requiredSubscriptionLevel == null ? void 0 : requiredSubscriptionLevel.id,
        subscriptionPurchaseSource: null,
        ButtonComponent: ButtonComponent
    }));
};
const nick = "SubscribersOnlyWarning-scss--module__nick___ez9nw";
const buttonRoot = "SubscribersOnlyWarning-scss--module__buttonRoot___GiyIV";
const button$4 = "SubscribersOnlyWarning-scss--module__button___FwIFc";
const s$y = {
    nick: nick,
    buttonRoot: buttonRoot,
    button: button$4
};
const locales$q = {
    chatOnlyForSubscribers: "\u0427\u0430\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u0432",
    youShouldBeSubscriberOf: "\u0414\u043B\u044F \u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0432 \u0447\u0430\u0442\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u043C {{name}}",
    youShouldBeSubscriberLongerThen: "\u0414\u043B\u044F \u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0432 \u0447\u0430\u0442\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u043C {{durationToFollow}}. \u0416\u0434\u0430\u0442\u044C \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C",
    subscriptionDurations: {
        ["10_minutes"]: "10 \u043C\u0438\u043D\u0443\u0442",
        ["30_minutes"]: "30 \u043C\u0438\u043D\u0443\u0442",
        ["1_hour"]: "1 \u0447\u0430\u0441",
        ["1_day"]: "1 \u0434\u0435\u043D\u044C",
        ["1_week"]: "1 \u043D\u0435\u0434\u0435\u043B\u044E",
        ["1_month"]: "1 \u043C\u0435\u0441\u044F\u0446",
        ["3_months"]: "3 \u043C\u0435\u0441\u044F\u0446\u0430"
    }
};
const t$q = distExports$1.getTranslation && locales$q;
const SubscribersOnlyWarning = (props)=>{
    var _a3;
    const { timeout: timeout2, onClose: onEnd } = props;
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const { allowAccessAfter } = (0, $iD0SF.useSelector)(streamChatSettingsSelector);
    const getDurationToFollow = ()=>{
        if (allowAccessAfter >= 7776000) return t$q.subscriptionDurations["3_months"];
        else if (allowAccessAfter >= 2592000) return t$q.subscriptionDurations["1_month"];
        else if (allowAccessAfter >= 604800) return t$q.subscriptionDurations["1_week"];
        else if (allowAccessAfter >= 86400) return t$q.subscriptionDurations["1_day"];
        else if (allowAccessAfter >= 3600) return t$q.subscriptionDurations["1_hour"];
        else if (allowAccessAfter >= 1800) return t$q.subscriptionDurations["30_minutes"];
        else if (allowAccessAfter >= 600) return t$q.subscriptionDurations["10_minutes"];
        else return "";
    };
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarning, {
        title: t$q.chatOnlyForSubscribers
    }, allowAccessAfter > 0 && timeout2 ? /* @__PURE__ */ $acw62.createElement("div", {
        className: s$y.nick
    }, distExports$1.getParametrizedText(t$q.youShouldBeSubscriberLongerThen, {
        durationToFollow: getDurationToFollow()
    }), " ", /* @__PURE__ */ $acw62.createElement(Countdown, {
        timeLeft: timeout2,
        onEnd: onEnd
    })) : /* @__PURE__ */ $acw62.createElement("div", {
        className: s$y.nick
    }, distExports$1.getParametrizedText(t$q.youShouldBeSubscriberOf, {
        name: (_a3 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _a3.nick
    })), /* @__PURE__ */ $acw62.createElement(FollowButtonWithTooltip, {
        classNames: {
            root: s$y.buttonRoot,
            button: s$y.button
        }
    }));
};
const locales$p = {
    error: {
        emptyText: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u043D\u0430\u0433\u0440\u0430\u0434\u044B"
    }
};
const t$p = distExports$1.getTranslation && locales$p;
const PosponedRewardWarning = (props)=>{
    const { canPublish = true } = props;
    const { name: name2, bgcolor, price, mediumUrl } = (0, $iD0SF.useSelector)(getPostponedRewardSelector) || {};
    const pointsIconUrl = (0, $iD0SF.useSelector)(pointMediumImageSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const publisherError = !canPublish ? EPreviewError.EMPTY_TEXT : void 0;
    const handleClose = ()=>{
        dispatch(clearPostponedReward());
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            handleClose();
        };
    }, []);
    return /* @__PURE__ */ $acw62.createElement(RewardChatWarning, {
        name: name2,
        bgcolor: bgcolor,
        price: price,
        iconColor: "yellow",
        rewardIconUrl: mediumUrl,
        error: t$p.error[publisherError],
        pointsIconUrl: pointsIconUrl,
        onClose: handleClose
    });
};
const description$1 = "ActiveRetranslationWarning-scss--module__description___O8bN2";
const s$x = {
    description: description$1
};
const locales$o = {
    title: "\u0418\u0434\u0435\u0442 \u0440\u0435\u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u044F",
    chatInRetranslationMode: "\u0427\u0430\u0442 {{owner}} \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438.",
    joinToHostTargetChat: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u043A \u043E\u0431\u0449\u0435\u043D\u0438\u044E \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0435",
    button: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B"
};
const t$o = distExports$1.getTranslation && locales$o;
const ActiveRetranslationWarning = (props)=>{
    const { onClose } = props;
    const navigate = (value2)=>{
        document.location.href = value2;
    };
    const streamerName = (0, $iD0SF.useSelector)(streamerNameSelector);
    const { hostFor, hostUrl } = (0, $iD0SF.useSelector)(streamHostForStreamerSelector);
    const handleButtonClick = ()=>{
        navigate(`/${hostUrl}`);
    };
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: t$o.title,
        type: ETitleLayoutWarningType.RETRANSLATION,
        withPublisherBlocker: false,
        onClose: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$x.description
    }, distExports$1.getParametrizedText(t$o.chatInRetranslationMode, {
        owner: streamerName
    }), /* @__PURE__ */ $acw62.createElement("br", null), t$o.joinToHostTargetChat, /* @__PURE__ */ $acw62.createElement("br", null), hostFor), /* @__PURE__ */ $acw62.createElement(ContainedButton, {
        onClick: handleButtonClick
    }, t$o.button));
};
const TextWarning = (props)=>{
    const { title: title2, description: description2, withTypingBlocker, onClose } = props;
    return /* @__PURE__ */ $acw62.createElement(BaseLayoutWarningExpanded, {
        title: title2,
        withPublisherBlocker: withTypingBlocker,
        onClose: onClose
    }, description2);
};
const locales$n = {
    errorOccurredWithInvalidSmiles: "\u0412 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0432\u0430\u043C \u0441\u043C\u0430\u0439\u043B\u044B",
    messageDidntSent: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
    linksProhibited: "\u0412 \u0434\u0430\u043D\u043D\u044B\u0439 \u0447\u0430\u0442 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    onlyLetters: "\u0412 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0447\u0430\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0437\u0430\u043F\u0440\u0435\u0442\u0430 \u0441\u043F\u0435\u0446\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
    onlySmiles: "\u0427\u0430\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432",
    onlySmilesDescription: "\u0427\u0430\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432. \u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0438, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u0430 \u0432 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u043C \u043F\u043E\u043B\u0435 \u0447\u0430\u0442\u0430"
};
const t$n = distExports$1.getTranslation && locales$n;
const ChatWarning = (props)=>{
    const { warning: { type, count: count2, timeout: timeout2, requiredSubscriptionLevel }, canPublish, onClose } = props;
    switch(type){
        case EChatWarningType.BANNED_PERMANENTLY:
            return /* @__PURE__ */ $acw62.createElement(BannedPermanentlyWarning, null);
        case EChatWarningType.BANNED_TEMPORARILY:
            return /* @__PURE__ */ $acw62.createElement(BannedTemporarilyWarning, {
                timeout: timeout2,
                onClose: onClose
            });
        case EChatWarningType.RETRANSLATION_ACTIVE:
            return /* @__PURE__ */ $acw62.createElement(ActiveRetranslationWarning, {
                onClose: onClose
            });
        case EChatWarningType.PAID_SUBSCRIBERS_ONLY:
            return /* @__PURE__ */ $acw62.createElement(PaidSubscribersOnlyWarning, {
                requiredSubscriptionLevel: requiredSubscriptionLevel
            });
        case EChatWarningType.SUBSCRIBERS_ONLY:
            return /* @__PURE__ */ $acw62.createElement(SubscribersOnlyWarning, {
                timeout: timeout2,
                onClose: onClose
            });
        case EChatWarningType.ONLY_SMILES:
            return /* @__PURE__ */ $acw62.createElement(TextWarning, {
                onClose: onClose,
                title: t$n.onlySmiles,
                description: t$n.onlySmilesDescription
            });
        case EChatWarningType.ONLY_LETTERS:
            return /* @__PURE__ */ $acw62.createElement(TextWarning, {
                onClose: onClose,
                title: t$n.onlyLetters
            });
        case EChatWarningType.LINKS_PROHIBITED:
            return /* @__PURE__ */ $acw62.createElement(TextWarning, {
                onClose: onClose,
                title: t$n.messageDidntSent,
                description: t$n.linksProhibited
            });
        case EChatWarningType.INVALID_SMILES_USED:
            return /* @__PURE__ */ $acw62.createElement(InvalidParamWarning, {
                onClose: onClose,
                description: t$n.errorOccurredWithInvalidSmiles
            });
        case EChatWarningType.POSTPONED_REWARD:
            return /* @__PURE__ */ $acw62.createElement(PosponedRewardWarning, {
                canPublish: canPublish,
                onClose: onClose
            });
        case EChatWarningType.CHAR_LIMIT:
            return /* @__PURE__ */ $acw62.createElement(CharLimitWarning, {
                count: count2,
                onClose: onClose
            });
        case EChatWarningType.IDENTICAL_MESSAGE:
            return /* @__PURE__ */ $acw62.createElement(IdenticalMessageWarning, {
                count: count2,
                timeout: timeout2,
                onClose: onClose
            });
        case EChatWarningType.FREQUENT_SENDING:
            return /* @__PURE__ */ $acw62.createElement(FrequentSendingWarning, {
                timeout: timeout2,
                onClose: onClose
            });
        case EChatWarningType.INVALID_PARAM:
            return /* @__PURE__ */ $acw62.createElement(InvalidParamWarning, {
                onClose: onClose
            });
        default:
            return null;
    }
};
const verifiedIcon = "ChatAuthor-scss--module__verifiedIcon___Qi7PE";
const name$2 = "ChatAuthor-scss--module__name___3e-5j";
const s$w = {
    verifiedIcon: verifiedIcon,
    name: name$2
};
const VERIFIED_STREAMER = "verified_streamer";
const ChatAuthor = (props)=>{
    const { theme } = useThemeContext();
    const { author: author2, classNames, onAuthorClick } = props;
    const { badge: badge2 } = getConfig();
    const renderBadges = (badges2)=>{
        if (badge2.levels.silver.includes(author2.id)) return badges2.map((badgeItem)=>badgeItem.achievement.name === VERIFIED_STREAMER ? /* @__PURE__ */ $acw62.createElement(Icon, {
                key: badgeItem.id,
                glyph: svg_name_silver_streamer,
                className: s$w.verifiedIcon
            }) : /* @__PURE__ */ $acw62.createElement(ChatBadge, {
                classNames: {
                    root: classNames == null ? void 0 : classNames.badge
                },
                key: badgeItem.id,
                badge: badgeItem
            }));
        return badges2.map((badgeItem)=>/* @__PURE__ */ $acw62.createElement(ChatBadge, {
                classNames: {
                    root: classNames == null ? void 0 : classNames.badge
                },
                key: badgeItem.id,
                badge: badgeItem
            }));
    };
    const handleAuthorClick = ()=>{
        onAuthorClick(author2);
    };
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, renderBadges(author2.badges), Boolean(author2.roles.length) && /* @__PURE__ */ $acw62.createElement(ChatRole, {
        classNames: {
            root: classNames == null ? void 0 : classNames.role
        },
        key: author2.roles[0].id,
        role: author2.roles[0]
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$w.name, classNames == null ? void 0 : classNames.name),
        style: {
            color: getChatNicknameColor(author2.nickColor, theme)
        },
        onClick: handleAuthorClick
    }, author2.nick, ":"));
};
ChatAuthor.displayName = "ChatAuthor";
const root$o = "ChatReply-scss--module__root___fYUea";
const body$1 = "ChatReply-scss--module__body___5Zoqz";
const arrowIcon = "ChatReply-scss--module__arrowIcon___dNjvT";
const open = "ChatReply-scss--module__open___c93mY";
const header$5 = "ChatReply-scss--module__header___IeLKw";
const slash = "ChatReply-scss--module__slash___Lsbhx";
const message$2 = "ChatReply-scss--module__message___OGExH";
const title$7 = "ChatReply-scss--module__title___88AVR";
const cancelBtn$1 = "ChatReply-scss--module__cancelBtn___Gx4yV";
const switcherBtn = "ChatReply-scss--module__switcherBtn___u5vKi";
const cancelIcon$1 = "ChatReply-scss--module__cancelIcon___VkdaZ";
const authorBage = "ChatReply-scss--module__authorBage___k0iHP";
const authorRole = "ChatReply-scss--module__authorRole___vcnbI";
const authorName = "ChatReply-scss--module__authorName___Wyveg";
const s$v = {
    root: root$o,
    body: body$1,
    arrowIcon: arrowIcon,
    open: open,
    header: header$5,
    slash: slash,
    message: message$2,
    title: title$7,
    cancelBtn: cancelBtn$1,
    switcherBtn: switcherBtn,
    cancelIcon: cancelIcon$1,
    authorBage: authorBage,
    authorRole: authorRole,
    authorName: authorName
};
const ChatReply = (props)=>{
    const { replyTarget, replyMessageId, replyMessageData, isOpenReplyMessage, isOpenUserStat, onClickOutside, onReplyCancel, onSwitchVisibilityReplyMessage, onAuthorClick } = props;
    const containerRef = (0, $acw62.useRef)(null);
    const messageRef = (0, $acw62.useRef)(null);
    const [isActive, setIsActive] = (0, $acw62.useState)(null);
    const [isVisibleSwitcher, setIsVisibleSwitcher] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!messageRef.current) return;
        setIsVisibleSwitcher(messageRef.current.offsetWidth < messageRef.current.scrollWidth);
    }, [
        replyMessageData
    ]);
    (0, $acw62.useEffect)(()=>{
        let timeoutId2;
        if (!isOpenUserStat && isActive) timeoutId2 = setTimeout(()=>{
            setIsActive(false);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId2);
        };
    }, [
        isOpenUserStat
    ]);
    useCloseOnEscape(onReplyCancel);
    const handleOutsideClick = (event2)=>{
        if (isOpenUserStat) return;
        onClickOutside(event2.target, onReplyCancel);
    };
    const handleAuthorClick = (author2)=>{
        setIsActive(true);
        onAuthorClick(author2, replyMessageId, containerRef.current.getBoundingClientRect(), true);
    };
    return /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: handleOutsideClick
    }, /* @__PURE__ */ $acw62.createElement("div", {
        ref: containerRef,
        className: s$v.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$v.slash
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$v.body, {
            [s$v.open]: isOpenReplyMessage
        })
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$v.header
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$v.title
    }, /* @__PURE__ */ $acw62.createElement(ChatAuthor, {
        classNames: {
            badge: s$v.authorBage,
            name: s$v.authorName,
            role: s$v.authorRole
        },
        author: replyTarget,
        onAuthorClick: isActive ? dist$4.noop : handleAuthorClick
    })), isVisibleSwitcher && /* @__PURE__ */ $acw62.createElement("button", {
        className: s$v.switcherBtn,
        type: "button",
        onClick: onSwitchVisibilityReplyMessage
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: s$v.arrowIcon
    })), /* @__PURE__ */ $acw62.createElement("button", {
        className: s$v.cancelBtn,
        type: "button",
        onClick: onReplyCancel
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$v.cancelIcon,
        glyph: svg_name_close
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$v.message
    }, /* @__PURE__ */ $acw62.createElement(ContentRenderer, {
        innerRef: messageRef,
        data: replyMessageData,
        isTextEllipsis: !isOpenReplyMessage
    })))));
};
const author = "ChatThreadMessage-scss--module__author___-I--B";
const text$2 = "ChatThreadMessage-scss--module__text___bX4eX";
const s$u = {
    author: author,
    text: text$2
};
const ChatThreadMessage = (props)=>{
    const { classNames = {}, message: message2, blackListIds, isOpenUserStat, onAuthorClick } = props;
    const containerRef = (0, $acw62.useRef)(null);
    const [messageAuthorStatShown, setMessageAuthorStatShown] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let timeoutId2;
        if (!isOpenUserStat && Boolean(messageAuthorStatShown)) timeoutId2 = setTimeout(()=>{
            setMessageAuthorStatShown(null);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId2);
        };
    }, [
        isOpenUserStat
    ]);
    const handleAuthorClick = (author2)=>{
        setMessageAuthorStatShown(message2.id);
        onAuthorClick(author2, message2.id, containerRef.current.getBoundingClientRect(), true);
    };
    const isAuthorStatShown = message2.id === messageAuthorStatShown;
    if (blackListIds.includes(message2.author.id)) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: classNames.root,
        ref: containerRef
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$u.author
    }, /* @__PURE__ */ $acw62.createElement(ChatAuthor, {
        author: message2.author,
        onAuthorClick: isAuthorStatShown ? dist$4.noop : handleAuthorClick
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$u.text
    }, /* @__PURE__ */ $acw62.createElement(ContentRenderer, {
        data: message2.data
    })));
};
const root$n = "ChatThreadMessagesList-scss--module__root___DiFjx";
const threadBorder = "ChatThreadMessagesList-scss--module__threadBorder___Udl1w";
const messages = "ChatThreadMessagesList-scss--module__messages___3aH8a";
const message$1 = "ChatThreadMessagesList-scss--module__message___x1UuJ";
const messagesScroll = "ChatThreadMessagesList-scss--module__messagesScroll___EXhz7";
const s$t = {
    root: root$n,
    threadBorder: threadBorder,
    messages: messages,
    message: message$1,
    messagesScroll: messagesScroll
};
const ChatThreadMessagesList = (props)=>{
    const { messages: messages2, blackListIds, isOpenUserStat, onAuthorClick } = props;
    const containerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if ((containerRef == null ? void 0 : containerRef.current) && messages2) {
            const scrollHeight = containerRef.current.scrollHeight;
            const height = containerRef.current.clientHeight;
            containerRef.current.scrollTop = scrollHeight - height;
        }
    }, [
        messages2
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$t.root
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$t.threadBorder
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$t.messages
    }, /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        className: s$t.messagesScroll,
        innerRef: containerRef
    }, messages2.map((message2)=>/* @__PURE__ */ $acw62.createElement(ChatThreadMessage, {
            key: message2.id,
            message: message2,
            blackListIds: blackListIds,
            classNames: {
                root: s$t.message
            },
            isOpenUserStat: isOpenUserStat,
            onAuthorClick: onAuthorClick
        })))));
};
const root$m = "ChatThread-scss--module__root___-xX0G";
const header$4 = "ChatThread-scss--module__header___5AYEW";
const title$6 = "ChatThread-scss--module__title___KWbLn";
const threadIcon = "ChatThread-scss--module__threadIcon___PMZky";
const cancelBtn = "ChatThread-scss--module__cancelBtn___OUe-k";
const cancelIcon = "ChatThread-scss--module__cancelIcon___aDdkG";
const content$3 = "ChatThread-scss--module__content___sv7lB";
const s$s = {
    root: root$m,
    header: header$4,
    title: title$6,
    threadIcon: threadIcon,
    cancelBtn: cancelBtn,
    cancelIcon: cancelIcon,
    content: content$3
};
const locales$m = {
    discussion: "\u041E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u0435",
    deletedMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E"
};
const t$m = distExports$1.getTranslation && locales$m;
const ChatThread = (props)=>{
    const { className, replyTarget, threadId, isOpenUserStat, onClickOutside, onThreadCancel, onSetReplyMessageId, onAuthorClick } = props;
    const { threadMainMessage, threadReplies, networkStatus: networkStatus2, blackListIds, onClearThreadMessages } = useChatThreadMessages(threadId);
    const currentUserAccess = useCurrentUserAccess();
    const { currentUser: currentUser2 } = currentUserAccess;
    (0, $acw62.useEffect)(()=>{
        if (threadId && threadReplies && (currentUser2 == null ? void 0 : currentUser2.id) === replyTarget.id) {
            const otherUserMessages = threadReplies.filter((message2)=>message2.author.id !== (currentUser2 == null ? void 0 : currentUser2.id));
            const lastMessage = otherUserMessages[otherUserMessages.length - 1];
            const messageId = lastMessage == null ? void 0 : lastMessage.id;
            if (Boolean(messageId)) onSetReplyMessageId(messageId);
            else onSetReplyMessageId(threadMainMessage == null ? void 0 : threadMainMessage.id);
        }
    }, [
        threadId,
        threadReplies
    ]);
    const handleThreadCancelClick = ()=>{
        onClearThreadMessages();
        onThreadCancel();
    };
    useCloseOnEscape(handleThreadCancelClick);
    const hasThreads = (threadMainMessage || threadReplies) && networkStatus2.isFetched;
    if (!hasThreads) return null;
    const handleOutsideClick = (event2)=>{
        if (isOpenUserStat) return;
        onClickOutside(event2.target, ()=>{
            onClearThreadMessages();
            onThreadCancel();
        });
    };
    return /* @__PURE__ */ $acw62.createElement(BlogPostFromContext.Provider, {
        value: EBlogPostFrom.BLOG_STREAM_CHAT_MESSAGE
    }, /* @__PURE__ */ $acw62.createElement(OutsideClickHandler, {
        onOutsideClick: handleOutsideClick
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$s.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$s.header
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$s.title
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_comment_outline_20,
        className: s$s.threadIcon
    }), t$m.discussion), /* @__PURE__ */ $acw62.createElement("button", {
        className: s$s.cancelBtn,
        type: "button",
        onClick: handleThreadCancelClick
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$s.cancelIcon,
        glyph: svg_name_cancel_20
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$s.content
    }, Boolean(threadMainMessage) ? /* @__PURE__ */ $acw62.createElement(ChatThreadMessage, {
        message: threadMainMessage,
        blackListIds: blackListIds,
        isOpenUserStat: isOpenUserStat,
        onAuthorClick: onAuthorClick
    }) : t$m.deletedMessage), Boolean(threadReplies == null ? void 0 : threadReplies.length) && /* @__PURE__ */ $acw62.createElement(ChatThreadMessagesList, {
        messages: threadReplies,
        blackListIds: blackListIds,
        isOpenUserStat: isOpenUserStat,
        onAuthorClick: onAuthorClick
    }))));
};
const root$l = "ChatPublisherWrapper-scss--module__root___AafdJ";
const active$1 = "ChatPublisherWrapper-scss--module__active___Zirle";
const children = "ChatPublisherWrapper-scss--module__children___zwO6q";
const warning = "ChatPublisherWrapper-scss--module__warning___-I9BU";
const onlySmilesInfo = "ChatPublisherWrapper-scss--module__onlySmilesInfo___ebX1s";
const s$r = {
    root: root$l,
    active: active$1,
    children: children,
    warning: warning,
    onlySmilesInfo: onlySmilesInfo
};
const locales$l = {
    onlySmiles: "\u0427\u0430\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0441\u043C\u0430\u0439\u043B\u0438\u043A\u043E\u0432"
};
const t$l = distExports$1.getTranslation && locales$l;
const ChatPublisherWrapper = (props)=>{
    const { isOpenReplyMessage, isOpenUserStat, isShownSmilesSuggest, isSmileModeEnabled, children: children2, warning: warning2, replyTarget, replyMessageId, replyMessageData, threadId, canPublish, onReplyCancel, onThreadCancel, onWarningClose, onSwitchVisibilityReplyMessage, onSetReplyMessageId, onClickOutside, onAuthorClick, onPublisherFocus } = props;
    const shouldShowReply = Boolean(replyTarget && !threadId);
    const shouldShowThread = Boolean(replyTarget && threadId) && !isShownSmilesSuggest;
    const handleClickOutside = (target2, callback)=>{
        const { role: role2 } = getClosestRoleAndDataset(target2);
        if (role2 === EHTMLDataRole.REPLY_BUTTON || role2 === EHTMLDataRole.THREAD_BUTTON) {
            onPublisherFocus();
            return;
        }
        onClickOutside(target2, callback);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$r.root, {
            [s$r.active]: warning2 || replyTarget
        })
    }, isSmileModeEnabled && !Boolean(warning2) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$r.onlySmilesInfo
    }, /* @__PURE__ */ $acw62.createElement(TextWarning, {
        title: t$l.onlySmiles,
        withTypingBlocker: false
    })), Boolean(warning2) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$r.warning
    }, /* @__PURE__ */ $acw62.createElement(ChatWarning, {
        warning: warning2,
        canPublish: canPublish,
        onClose: onWarningClose
    })), shouldShowReply && /* @__PURE__ */ $acw62.createElement(ChatReply, {
        replyTarget: replyTarget,
        replyMessageId: replyMessageId,
        replyMessageData: replyMessageData,
        isOpenUserStat: isOpenUserStat,
        isOpenReplyMessage: isOpenReplyMessage,
        onClickOutside: handleClickOutside,
        onReplyCancel: onReplyCancel,
        onSwitchVisibilityReplyMessage: onSwitchVisibilityReplyMessage,
        onAuthorClick: onAuthorClick
    }), shouldShowThread && /* @__PURE__ */ $acw62.createElement(ChatThread, {
        className: s$r.thread,
        replyTarget: replyTarget,
        threadId: threadId,
        isOpenUserStat: isOpenUserStat,
        onClickOutside: handleClickOutside,
        onThreadCancel: onThreadCancel,
        onSetReplyMessageId: onSetReplyMessageId,
        onAuthorClick: onAuthorClick
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$r.children
    }, children2));
};
const useChatPublisherWarning = (params)=>{
    const { chatSettings, publishServerError, subscribedAt } = params;
    const { chat: { maxMessageLength } } = getConfig();
    const dispatch = (0, $2OPjR.useDispatch)();
    const [chatWarning, setChatWarning] = (0, $acw62.useState)(null);
    const isSubscriber = (0, $iD0SF.useSelector)(isFreeSubscriptionSelector);
    const wasSubscriber = usePrevious(isSubscriber);
    const isPaidSubscriber = (0, $iD0SF.useSelector)(isPaidSubscriptionSelector);
    const postponedReward2 = (0, $iD0SF.useSelector)(getPostponedRewardSelector);
    const wasPaidSubscriber = usePrevious(isPaidSubscriber);
    const streamChatExtra = (0, $iD0SF.useSelector)(streamChatExtraSelector);
    const stream2 = (0, $iD0SF.useSelector)(streamSelector);
    const subscriptionLevels = (0, $iD0SF.useSelector)(subscriptionLevelsSelector);
    const { isChatModerator } = (0, $iD0SF.useSelector)(streamCurrentUserAccessSelector);
    const subscriptionLevel = (0, $iD0SF.useSelector)(streamSubscriptionLevelFieldSelector);
    const isViewAvailable = (0, $iD0SF.useSelector)(hasStreamAccessSelector);
    const { isHostActive } = (0, $iD0SF.useSelector)(streamHostForStreamerSelector);
    const { blogUrl } = useStreamIdentity();
    const { getTimer } = useChatSlowmodeTimer(blogUrl);
    const isOtherStream = stream2.blogUrl !== blogUrl;
    const viewAllowedSubscriptionLevelFromList = subscriptionLevel && (subscriptionLevels == null ? void 0 : subscriptionLevels.find((level)=>level.name === subscriptionLevel.name));
    const { isBlogOwner: isOwner, isBlogOwnerAgent: isAgent } = useCurrentUserAccess();
    const hasSpecialRights = isOwner || isAgent || isChatModerator || chatSettings.notRestrictable;
    const isBlocking = (warningType)=>{
        return [
            EChatWarningType.BANNED_PERMANENTLY,
            EChatWarningType.BANNED_TEMPORARILY,
            EChatWarningType.FREQUENT_SENDING,
            EChatWarningType.IDENTICAL_MESSAGE,
            EChatWarningType.PAID_SUBSCRIBERS_ONLY,
            EChatWarningType.SUBSCRIBERS_ONLY,
            EChatWarningType.ONLY_LETTERS,
            EChatWarningType.ONLY_SMILES,
            EChatWarningType.LINKS_PROHIBITED
        ].includes(warningType);
    };
    const getChatWarning = (messageData = [])=>{
        const isBannedByStreamEnd = streamChatExtra.isBanned && streamChatExtra.isBannedByStreamEnd;
        const isBannedForSomeTime = streamChatExtra.isBanned && streamChatExtra.banRemainingTime && !isBannedByStreamEnd;
        const isBannedTemporarily = isBannedByStreamEnd || isBannedForSomeTime;
        const isBannedPermanently = streamChatExtra.isBanned && !isBannedTemporarily;
        const isChatSettingsEnabled = isConditionalFeatureEnable(EConditionalFeature.CHAT_SETTINGS);
        const subscriptionDuration = isSubscriber ? Date.now() - subscribedAt : 0;
        const isValidSubscriber = isSubscriber && (subscriptionDuration >= chatSettings.allowAccessAfter * 1e3 || chatSettings.remainingTime === null);
        const timeoutToBeValidSubscriber = chatSettings.remainingTime * 1e3;
        const isPaidSubscriberWarning = isChatSettingsEnabled && chatSettings.allowAccess === EChatAccessLevel.PAID_SUBSCRIBERS && !(isPaidSubscriber || hasSpecialRights);
        const isFollowingRequired = !isViewAvailable && subscriptionLevel && isFollowerLevel(subscriptionLevel);
        const isSubscribingRequired = !isViewAvailable && subscriptionLevel && !isFollowerLevel(subscriptionLevel);
        const isSubscriberWarning = isChatSettingsEnabled && chatSettings.allowAccess === EChatAccessLevel.SUBSCRIBERS && !(isValidSubscriber || isPaidSubscriber || hasSpecialRights);
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.ONLY_SMILES_ALLOWED) return {
            type: EChatWarningType.ONLY_SMILES
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.LINKS_NOT_ALLOWED) return {
            type: EChatWarningType.LINKS_PROHIBITED
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.ONLY_RU_EN_NUMBERS_ALLOWED) return {
            type: EChatWarningType.ONLY_LETTERS
        };
        if (isHostActive) return {
            type: EChatWarningType.RETRANSLATION_ACTIVE
        };
        if (postponedReward2) return {
            type: EChatWarningType.POSTPONED_REWARD
        };
        if (isPaidSubscriberWarning || isSubscribingRequired) return {
            type: EChatWarningType.PAID_SUBSCRIBERS_ONLY,
            requiredSubscriptionLevel: isSubscribingRequired ? viewAllowedSubscriptionLevelFromList : null
        };
        if (!isOtherStream && (isSubscriberWarning || isFollowingRequired)) return {
            type: EChatWarningType.SUBSCRIBERS_ONLY,
            timeout: isSubscriber ? timeoutToBeValidSubscriber : null
        };
        if (isBannedPermanently) return {
            type: EChatWarningType.BANNED_PERMANENTLY
        };
        if (isBannedTemporarily) return {
            type: EChatWarningType.BANNED_TEMPORARILY,
            timeout: isBannedForSomeTime ? streamChatExtra.banRemainingTime * 1e3 : null
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.CANT_SEND) {
            const data = publishServerError.data;
            if (size$3(data.reasons)) {
                const reason2 = head$3(data.reasons);
                switch(reason2.type){
                    case ECantSendReason.SLOW_MODE_COOLDOWN:
                        return {
                            type: EChatWarningType.FREQUENT_SENDING,
                            count: chatSettings.anyMessageTimeout,
                            timeout: getTimer()
                        };
                    case ECantSendReason.SAME_MESSAGE_COOLDOWN:
                        return {
                            type: EChatWarningType.IDENTICAL_MESSAGE,
                            count: chatSettings.sameMessageTimeout,
                            timeout: reason2.remainingTime * 1e3
                        };
                    case ECantSendReason.FOLLOW_MODE_COOLDOWN:
                        return {
                            type: EChatWarningType.SUBSCRIBERS_ONLY,
                            timeout: getTimer()
                        };
                    case ECantSendReason.FOR_PAID_SUBSCRIBERS:
                        return {
                            type: EChatWarningType.PAID_SUBSCRIBERS_ONLY,
                            requiredSubscriptionLevel: isSubscribingRequired ? viewAllowedSubscriptionLevelFromList : null
                        };
                }
                return null;
            }
            return null;
        }
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.SAME_MESSAGE) return {
            type: EChatWarningType.IDENTICAL_MESSAGE,
            count: chatSettings.sameMessageTimeout,
            timeout: chatSettings.sameMessageTimeout * 1e3
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.MESSAGE_TOO_LONG) return {
            type: EChatWarningType.CHAR_LIMIT,
            count: maxMessageLength
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.INVALID_PARAM) return {
            type: EChatWarningType.INVALID_PARAM
        };
        if ((publishServerError == null ? void 0 : publishServerError.error) === ESendStreamChatMessageError.INVALID_SMILES_USED) return {
            type: EChatWarningType.INVALID_SMILES_USED
        };
        return null;
    };
    const checkWarnings = ()=>{
        setChatWarning(getChatWarning());
    };
    const isPublishingBlockedByWarning = (messageData)=>{
        const warning2 = getChatWarning(messageData);
        setChatWarning(warning2);
        return isBlocking(warning2 == null ? void 0 : warning2.type);
    };
    const onWarningClose = ()=>{
        setChatWarning(null);
    };
    (0, $acw62.useEffect)(()=>{
        checkWarnings();
    }, [
        chatSettings,
        streamChatExtra,
        publishServerError,
        isSubscriber,
        isPaidSubscriber,
        postponedReward2,
        hasSpecialRights,
        isOwner,
        subscribedAt
    ]);
    (0, $acw62.useEffect)(()=>{
        const hasUnsubscribed = wasSubscriber && !isSubscriber || wasPaidSubscriber && !isPaidSubscriber;
        if (hasUnsubscribed) dispatch(fetchStream.action({
            blogUrl: blogUrl
        }));
    }, [
        isSubscriber,
        isPaidSubscriber
    ]);
    return {
        chatWarning: chatWarning,
        hasWarning: Boolean(chatWarning),
        isPublishingBlockedByWarning: isPublishingBlockedByWarning,
        onWarningClose: onWarningClose
    };
};
const actionsContainer = "ChatPublisher-scss--module__actionsContainer___bOb0C";
const sendContainer = "ChatPublisher-scss--module__sendContainer___02sAi";
const editor = "ChatPublisher-scss--module__editor___dxpq9";
const root$k = "ChatPublisher-scss--module__root___c7mNj";
const publisherRoot = "ChatPublisher-scss--module__publisherRoot___8MLSD";
const smileSelector = "ChatPublisher-scss--module__smileSelector___p-2TM";
const isReply = "ChatPublisher-scss--module__isReply___r966P";
const s$q = {
    actionsContainer: actionsContainer,
    sendContainer: sendContainer,
    editor: editor,
    root: root$k,
    publisherRoot: publisherRoot,
    smileSelector: smileSelector,
    isReply: isReply
};
const locales$k = {
    placeholder: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    reply: "\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C"
};
const t$k = distExports$1.getTranslation && locales$k;
const ROOT_ID = "chat-pub-root";
const ChatPublisherWithoutRef = (props)=>{
    var _a3, _b2, _c2;
    const { className, innerRef, isBanned, isOpenUserStat, isOpenReplyMessage, isSmileSelectorVisible = true, isSendButtonVisible = true, replyTarget, replyMessageData, replyMessageId, threadId, isDisabled: isDisabled2, isWide, classNames = {}, isModerator, blogUrl, preventScrollOnMobileFocus = true, chatSettings, addMentionRef, placeholder: placeholder2, onReplyCancel, onThreadCancel, onPublish, onUnavailableSmileSuggestClick, onSwitchVisibilityReplyMessage, onSetReplyMessageId, onAuthorClick } = props;
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const [subscribedAt, setSubscribedAt] = (0, $acw62.useState)(((_a3 = blog2 == null ? void 0 : blog2.subscription) == null ? void 0 : _a3.onTime) ? blog2.subscription.onTime * 1e3 : chatSettings.remainingTime ? Date.now() - (chatSettings.allowAccessAfter - chatSettings.remainingTime) * 1e3 : null);
    const [isShownSmilesSuggest, toogleIsShownSmilesSuggest] = (0, $acw62.useState)(false);
    const editorRef = (0, $acw62.useRef)();
    const [publishServerError, setPublishServerError] = (0, $acw62.useState)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { isAuthorized, isBlogOwner, isChatModerator, isBlogOwnerAgent } = useCurrentUserAccess();
    const { setTimer } = useChatSlowmodeTimer(blogUrl);
    const streamChatCurrentUserMessages = (0, $iD0SF.useSelector)(streamChatCurrentUserMessagesSelector);
    const isFollowing = (0, $iD0SF.useSelector)(isFreeSubscriptionSelector);
    const prevIsFollowing = usePrevious(isFollowing);
    const getRightToPostLinks = (linkUsageType)=>{
        let couldUseLink;
        switch(linkUsageType){
            case null:
            case void 0:
            case EChatLinkUsageType.ALL:
                couldUseLink = true;
                break;
            case EChatLinkUsageType.NOBODY:
                couldUseLink = false;
                break;
            default:
                couldUseLink = isBlogOwner || isBlogOwnerAgent || isModerator;
                break;
        }
        return couldUseLink;
    };
    const { chat: chat2 } = getConfig();
    const canPostLinks = getRightToPostLinks(chat2 == null ? void 0 : chat2.linkUsageType);
    const publish = async (params)=>{
        const data = params.inlineData;
        await onPublish(data, replyMessageId);
        setTimeout(()=>{
            editorRef.current.focus();
        });
    };
    const handlePublishError = (error2)=>{
        if (error2 instanceof ApiError) {
            setPublishServerError(error2.serverError);
            if (error2.serverError.error === ESendStreamChatMessageError.CANT_SEND) {
                const data = error2.serverError.data;
                if (size$3(data.reasons)) {
                    const reason2 = head$3(data.reasons);
                    if (reason2.type === ECantSendReason.SLOW_MODE_COOLDOWN || reason2.type === ECantSendReason.FOLLOW_MODE_COOLDOWN) setTimer(reason2.remainingTime * 1e3);
                }
            }
        }
    };
    const { editorData, inlineData, canPublish, settedPrevMessageRef, onInlineDataChange, onPublish: onPublishMessage, setEditorData, handleKeyUp } = usePublisher({
        canPostLinks: canPostLinks,
        isBanned: isBanned,
        showAlert: noop$2,
        publish: publish,
        onPublishError: handlePublishError,
        currentUserMessages: streamChatCurrentUserMessages
    });
    const { chatWarning, isPublishingBlockedByWarning, onWarningClose } = useChatPublisherWarning({
        chatSettings: chatSettings,
        publishServerError: publishServerError,
        subscribedAt: subscribedAt
    });
    (0, $acw62.useEffect)(()=>{
        if (replyTarget) setTimeout(()=>{
            handlePublisherFocus();
            dispatch(disableHotkeys({
                isDisabled: false
            }));
        }, 50);
    }, [
        replyTarget
    ]);
    const handlePublisherFocus = async ()=>{
        var _a4;
        await ((_a4 = editorRef.current) == null ? void 0 : _a4.focus());
    };
    const handleChange = (value2)=>{
        onInlineDataChange(value2);
    };
    const handlePublish = (data)=>{
        if (!isPublishingBlockedByWarning(data)) onPublishMessage(data);
    };
    const handleWarningClose = ()=>{
        onWarningClose();
        setPublishServerError(null);
    };
    const handleKeyDown = ()=>{
        if ((chatWarning == null ? void 0 : chatWarning.type) === EChatWarningType.FREQUENT_SENDING) return;
        setPublishServerError(null);
    };
    const handleClickOutside = (target2, callback)=>{
        if (innerRef.current.contains(target2)) return;
        callback();
    };
    (0, $acw62.useEffect)(()=>{
        if (prevIsFollowing === false && isFollowing) setSubscribedAt(Date.now());
    }, [
        prevIsFollowing,
        isFollowing
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a4;
        if ((_a4 = blog2 == null ? void 0 : blog2.subscription) == null ? void 0 : _a4.onTime) setSubscribedAt(blog2.subscription.onTime * 1e3);
    }, [
        (_b2 = blog2 == null ? void 0 : blog2.subscription) == null ? void 0 : _b2.onTime
    ]);
    (0, $acw62.useEffect)(()=>{
        setPublishServerError(null);
    }, [
        blogUrl
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$q.root, className),
        id: ROOT_ID
    }, isAuthorized && /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(ChatPublisherWrapper, {
        warning: chatWarning,
        isOpenReplyMessage: isOpenReplyMessage,
        isOpenUserStat: isOpenUserStat,
        isShownSmilesSuggest: isShownSmilesSuggest,
        isSmileModeEnabled: ((_c2 = chatSettings == null ? void 0 : chatSettings.mode) == null ? void 0 : _c2.value) === EChatIOMode.ONLY_SMILES,
        replyTarget: replyTarget,
        replyMessageId: replyMessageId,
        replyMessageData: replyMessageData,
        threadId: threadId,
        onSwitchVisibilityReplyMessage: onSwitchVisibilityReplyMessage,
        onSetReplyMessageId: onSetReplyMessageId,
        canPublish: canPublish,
        onReplyCancel: onReplyCancel,
        onThreadCancel: onThreadCancel,
        onWarningClose: handleWarningClose,
        onClickOutside: handleClickOutside,
        onAuthorClick: onAuthorClick,
        onPublisherFocus: handlePublisherFocus
    }, /* @__PURE__ */ $acw62.createElement(Publisher, {
        ref: editorRef,
        classNames: {
            root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.root, s$q.publisherRoot),
            rootDisabled: classNames.rootDisabled,
            editor: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.editor, s$q.editor),
            editorDisabled: classNames.editorDisabled,
            sendContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.sendContainer, s$q.sendContainer),
            iconSend: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.iconSend),
            actionsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.actionsContainer, s$q.actionsContainer),
            smileSelectorWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$q.smileSelector, replyTarget && s$q.isReply),
            actionsContainerDisabled: classNames.actionsContainerDisabled
        },
        isDisabled: isDisabled2,
        isWide: isWide,
        addMentionRef: addMentionRef,
        isSubmitButtonDisabled: !canPublish,
        isBlogOwner: isBlogOwner,
        settedPrevMessageRef: settedPrevMessageRef,
        isChatModerator: isChatModerator,
        isBlogOwnerAgent: isBlogOwnerAgent,
        placeholder: replyTarget ? t$k.reply : placeholder2 ?? t$k.placeholder,
        editorData: editorData,
        inlineData: inlineData,
        hasSmilesSelector: !isBanned && isSmileSelectorVisible,
        onUnavailableSmileSuggestClick: onUnavailableSmileSuggestClick,
        onInlineDataChange: handleChange,
        onPublish: handlePublish,
        publishingShortcut: EPublishingShortcut.ENTER,
        blogUrl: blogUrl,
        setEditorData: setEditorData,
        preventScrollOnMobileFocus: preventScrollOnMobileFocus,
        hasSubmitButton: !isBanned && isSendButtonVisible,
        wrapperId: ROOT_ID,
        onKeyDown: handleKeyDown,
        onToggleSmilesSuggest: toogleIsShownSmilesSuggest,
        onKeyUp: handleKeyUp
    }))));
};
const ChatPublisher = $acw62.forwardRef((props, ref2)=>/* @__PURE__ */ $acw62.createElement(ChatPublisherWithoutRef, {
        innerRef: ref2,
        ...props
    }));
const root$j = "Chat-scss--module__root___3Cjo7";
const chat$1 = "Chat-scss--module__chat___DsWdK";
const smileInfo = "Chat-scss--module__smileInfo___9Ur7B";
const smileInfoAbsolute = "Chat-scss--module__smileInfoAbsolute___SW1KH";
const stub = "Chat-scss--module__stub___-KVBG";
const unavailable = "Chat-scss--module__unavailable___ndhKf";
const recordModePlaceholder = "Chat-scss--module__recordModePlaceholder___S-BzD";
const recordModeIcon = "Chat-scss--module__recordModeIcon___3BFOp";
const s$p = {
    root: root$j,
    chat: chat$1,
    smileInfo: smileInfo,
    smileInfoAbsolute: smileInfoAbsolute,
    stub: stub,
    unavailable: unavailable,
    recordModePlaceholder: recordModePlaceholder,
    recordModeIcon: recordModeIcon
};
const locales$j = {
    "chatIsUnavailableSubscriber": "\u0427\u0430\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u0432 \u0443\u0440\u043E\u0432\u043D\u044F {{level}} \u0438 \u0432\u044B\u0448\u0435",
    "chatIsUnavailableFollower": "\u0427\u0430\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0444\u043E\u043B\u043B\u043E\u0432\u0435\u0440\u043E\u0432",
    "recordChatMode": "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0447\u0430\u0442\u0430"
};
const t$j = distExports$1.getTranslation && locales$j;
const Chat$1 = (props)=>{
    var _a3;
    const { classNames = {}, height, blogUrl, slotUrl, streamUserId, preventScrollOnMobileFocus, externalReplyTarget, isSmileInfoAbsolute, isOnlyRecordChatMode, isWide, isOnlyMentionsMode, footerNode, enabledOnlyFor, isSettings, isStudio } = props;
    const { userStatPopupUserId, userStatPopupOffset, onUserClick, onCloseUserStatPopup, onBan, onBanCancel, onHandleTimeout, onCalculateUserPopupOffset, onRoleChange } = useUserStat(blogUrl, slotUrl);
    const currentUserAccess = useCurrentUserAccess();
    const { isAuthorized, isAdmin, isModerator: isAdminModerator, canModerateChatChannel, showAuth } = currentUserAccess;
    const { pinChatMessage: pinChatMessage2 } = usePinnedMessageSettings(blogUrl);
    const chatContainerRef = (0, $acw62.useRef)(null);
    const chatRef = (0, $acw62.useRef)(null);
    const chatPublisherRef = (0, $acw62.useRef)(null);
    const chatFooterRef = (0, $acw62.useRef)(null);
    const chatUnbanTimer = (0, $acw62.useRef)(null);
    const addMentionRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showPopup } = distExports.useOverlayPopups();
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const chatSettings = (0, $iD0SF.useSelector)(streamChatSettingsSelector);
    const postponeReward2 = (0, $iD0SF.useSelector)(getPostponedRewardSelector);
    const { handleRewardActivate } = useChannelRewardShop(blogUrl);
    const streamChatExtra = (0, $iD0SF.useSelector)(streamChatExtraSelector);
    const streamerId = (0, $iD0SF.useSelector)(streamerIdSelector);
    const streamViewers = (0, $iD0SF.useSelector)(streamViewersSelector);
    const [isOpenReplyMessage, setIsOpenReplyMessage] = (0, $acw62.useState)(false);
    const [moderationPopupSourceMessageId, setModerationPopupSourceMessageId] = (0, $acw62.useState)(null);
    const [lastBannedMessageId, setLastBannedMessageId] = (0, $acw62.useState)(null);
    const [replyTarget, setReplyTarget] = (0, $acw62.useState)(null);
    const [replyMessageId, setReplyMessageId] = (0, $acw62.useState)(null);
    const [replyMessageData, setReplyMessageData] = (0, $acw62.useState)(null);
    const [smileInfoStyles, setSmileInfoStyles] = (0, $acw62.useState)(null);
    const [smileInfoId, setSmileInfoId] = (0, $acw62.useState)(null);
    const [smilePopupShown, setSmilePopupShown] = (0, $acw62.useState)(null);
    const [threadId, setThreadId2] = (0, $acw62.useState)(null);
    const [messageRect, setMessageRect] = (0, $acw62.useState)(null);
    const isBanned = streamChatExtra.isBanned || currentUserAccess.isBanned;
    const { isMobile: isMobile2 } = getConfig();
    useRaid({
        blogUrl: blogUrl,
        streamViewiers: streamViewers,
        isDisabled: isOnlyRecordChatMode
    });
    (0, $acw62.useEffect)(()=>{
        window.clearTimeout(chatUnbanTimer.current);
        if (streamChatExtra.isBanned && streamChatExtra.banRemainingTime) chatUnbanTimer.current = window.setTimeout(()=>{
            var _a4, _b2;
            dispatch(updateChatBanStatusFromWS({
                isBanned: false,
                blogId: (_a4 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _a4.id,
                ownerId: (_b2 = blog2 == null ? void 0 : blog2.owner) == null ? void 0 : _b2.id
            }));
        }, streamChatExtra.banRemainingTime * 1e3);
        return ()=>{
            window.clearTimeout(chatUnbanTimer.current);
        };
    }, [
        streamChatExtra.isBanned
    ]);
    const getModerationPopupOffset = (msgRect, userStatRect)=>{
        var _a4;
        const { height: msgHeight, y: msgY } = msgRect;
        const msgOffsetTop = msgY - chatRef.current.getBoundingClientRect().y;
        const userStatHeight = userStatRect.height;
        const chatPublisherHeight = !threadId ? chatPublisherRef.current.offsetHeight : PUBLISHER_MIN_HEIGHT;
        const chatFooterHeight = ((_a4 = chatFooterRef.current) == null ? void 0 : _a4.offsetHeight) || 0;
        const containerHeight = chatRef.current.offsetHeight - chatPublisherHeight - chatFooterHeight;
        const availableHeightBottom = containerHeight - msgOffsetTop;
        const direction2 = userStatHeight > availableHeightBottom ? EChatModerationPopupOpeningDirection.TOP : EChatModerationPopupOpeningDirection.BOTTOM;
        const offsetBottom = containerHeight - msgOffsetTop - msgHeight;
        const top2 = Math.floor(msgOffsetTop + USER_POPUP_MARGINS.top + USER_POPUP_MARGINS.verticalGap);
        const bottom2 = Math.floor(chatPublisherHeight + chatFooterHeight + USER_POPUP_MARGINS.bottom);
        if (containerHeight < CONTAINER_MIN_HEIGHT) {
            if (direction2 === EChatModerationPopupOpeningDirection.TOP) return {
                left: USER_POPUP_MARGINS.left,
                bottom: bottom2
            };
            return {
                left: USER_POPUP_MARGINS.left,
                top: top2
            };
        }
        if (direction2 === EChatModerationPopupOpeningDirection.TOP) {
            const shouldBeWithinContainer2 = msgOffsetTop - userStatHeight > 0;
            return {
                left: USER_POPUP_MARGINS.left,
                bottom: shouldBeWithinContainer2 ? Math.floor(offsetBottom + msgHeight + chatPublisherHeight + chatFooterHeight) : bottom2
            };
        }
        const shouldBeWithinContainer = containerHeight - userStatHeight - msgOffsetTop > 0;
        return {
            left: USER_POPUP_MARGINS.left,
            top: shouldBeWithinContainer ? top2 : USER_POPUP_MARGINS.top
        };
    };
    const handleCalculatePopupOffset = (0, $acw62.useCallback)((userStatRect)=>{
        onCalculateUserPopupOffset(getModerationPopupOffset(messageRect, userStatRect));
    }, [
        messageRect
    ]);
    const handleMentionClick = (0, $acw62.useCallback)((mentionId, msgRect)=>{
        onUserClick(mentionId);
        setMessageRect(msgRect);
    }, []);
    const handleAuthorClick = (0, $acw62.useCallback)((data, messageId, msgRect, fromReplyTargetBlock = false)=>{
        setMessageRect(msgRect);
        onUserClick(data.id);
        setModerationPopupSourceMessageId(messageId);
        if (!fromReplyTargetBlock && Boolean(replyTarget)) {
            resetReplyTargetBlock();
            return;
        }
        if (fromReplyTargetBlock && Boolean(threadId)) setReplyMessageId(messageId);
    }, [
        replyTarget,
        threadId
    ]);
    const handleContextMenuOpen = (0, $acw62.useCallback)((ignore, messageId)=>{
        setModerationPopupSourceMessageId(messageId);
    }, []);
    const resetReplyTargetBlock = ()=>{
        if (threadId) handleThreadCancel();
        else handleReplyCancel();
    };
    const handleCloseUserStat = (0, $acw62.useCallback)(()=>{
        onCloseUserStatPopup();
        dispatch(streamChatUserStatReset());
        setModerationPopupSourceMessageId(null);
    }, []);
    const handleThreadClick = (0, $acw62.useCallback)((author2, messageId, id)=>{
        setThreadId2(id);
        setReplyTarget(author2);
        setReplyMessageId(messageId);
    }, []);
    const handleMentionUserStatClick = (user)=>{
        var _a4;
        (_a4 = addMentionRef.current) == null || _a4.call(addMentionRef, {
            user: user
        });
        handleCloseUserStat();
    };
    const handleReplyClick = (0, $acw62.useCallback)((author2, messageId, data)=>{
        setReplyTarget(author2);
        setModerationPopupSourceMessageId(null);
        setIsOpenReplyMessage(false);
        onCloseUserStatPopup();
        if (threadId) setThreadId2(null);
        if (messageId && data) {
            setReplyMessageId(messageId);
            setReplyMessageData(data);
        }
        dispatch(disableHotkeys({
            isDisabled: true
        }));
    }, [
        threadId
    ]);
    const handleReplyAfterUserStatClick = (0, $acw62.useCallback)((author2)=>{
        setReplyTarget(author2);
        onCloseUserStatPopup();
    }, []);
    const handleReplyCancel = (0, $acw62.useCallback)(()=>{
        setReplyTarget(null);
        setReplyMessageId(null);
        setReplyMessageData(null);
        setIsOpenReplyMessage(false);
    }, []);
    const handleThreadCancel = (0, $acw62.useCallback)(()=>{
        setReplyTarget(null);
        setReplyMessageId(null);
        setThreadId2(null);
    }, []);
    const handleSwitchVisibilityReplyMessage = (0, $acw62.useCallback)(()=>{
        setIsOpenReplyMessage(!isOpenReplyMessage);
    }, [
        isOpenReplyMessage,
        setIsOpenReplyMessage
    ]);
    const handleMessageDelete = (0, $acw62.useCallback)((messageId)=>{
        dispatch(removeStreamChatMessage.action({
            blogUrl: blogUrl,
            messageId: messageId
        }));
    }, [
        blogUrl
    ]);
    const handleBan = (0, $acw62.useCallback)(async (userId)=>{
        await onBan(userId);
        setLastBannedMessageId(moderationPopupSourceMessageId);
    }, [
        onBan,
        moderationPopupSourceMessageId
    ]);
    const handleTimeout = (0, $acw62.useCallback)(async (userId, period)=>{
        await onHandleTimeout(userId, period);
        setLastBannedMessageId(moderationPopupSourceMessageId);
    }, [
        onHandleTimeout,
        moderationPopupSourceMessageId
    ]);
    const handleBanCancel = (0, $acw62.useCallback)(async (userId, byStream)=>{
        await onBanCancel(userId, byStream);
        setLastBannedMessageId(null);
    }, [
        onBanCancel,
        blogUrl
    ]);
    const handlePinnedClick = (0, $acw62.useCallback)((messageId)=>{
        pinChatMessage2(messageId);
    }, [
        pinChatMessage2
    ]);
    const handlePublish = async (data, replyToId)=>{
        if (Boolean(postponeReward2)) await handleRewardActivate(postponeReward2, data);
        else await dispatch((0, $7Uc0p.thunkToAction)(sendStreamChatMessage.action)({
            blogUrl: blogUrl,
            slotUrl: slotUrl,
            data: data,
            replyToId: replyToId
        }));
        if (replyTarget) threadId ? handleThreadCancel() : handleReplyCancel();
    };
    (0, $acw62.useEffect)(()=>{
        if (externalReplyTarget) setTimeout(()=>{
            var _a4;
            (_a4 = addMentionRef.current) == null || _a4.call(addMentionRef, {
                user: externalReplyTarget
            });
        });
    }, [
        externalReplyTarget
    ]);
    const handleCloseSmileInfo = (0, $acw62.useCallback)(()=>{
        setSmileInfoId(null);
        setSmileInfoStyles(null);
    }, []);
    (0, $acw62.useEffect)(()=>{
        let mounted = true;
        if (!smileInfoId) window.setTimeout(()=>{
            if (mounted) setSmilePopupShown(null);
        }, 0);
        return ()=>{
            mounted = false;
        };
    }, [
        smileInfoId
    ]);
    const updateSmileInfoStyles = (0, $acw62.useCallback)((smileElement)=>{
        const { top: smileTop, bottom: smileBottom } = smileElement.getBoundingClientRect();
        const isElementBeforeCenter = window.innerHeight / 2 > smileTop;
        const { top: containerTop } = chatContainerRef.current.getBoundingClientRect();
        if (isElementBeforeCenter) setSmileInfoStyles({
            top: `${smileBottom - (isSmileInfoAbsolute ? containerTop : 0) + SMILE_INFO_PADDING}px`,
            left: "15px"
        });
        else setSmileInfoStyles({
            top: `${smileTop - (isSmileInfoAbsolute ? containerTop : 0) - SMILE_INFO_PADDING}px`
        });
    }, [
        isSmileInfoAbsolute
    ]);
    const showSmileInfoPopup = (0, $acw62.useCallback)((smileId)=>{
        showPopup({
            type: EPopup.SMILE_INFO,
            data: {
                smileId: smileId
            },
            onClose: handleCloseSmileInfo
        });
    }, [
        showPopup,
        handleCloseSmileInfo
    ]);
    const handleSmileClick = (0, $acw62.useCallback)((id, smileElement, uniqueId2)=>{
        if (smilePopupShown === uniqueId2) return;
        setSmileInfoId(id);
        window.setTimeout(setSmilePopupShown.bind(null, uniqueId2), 0);
        if (isMobile2) showSmileInfoPopup(id);
        else updateSmileInfoStyles(smileElement);
    }, [
        smilePopupShown,
        isMobile2,
        showSmileInfoPopup,
        updateSmileInfoStyles
    ]);
    const hasUserStat = isConditionalFeatureEnable(EConditionalFeature.CHAT_USER_STAT);
    (0, $acw62.useEffect)(()=>{
        if (userStatPopupUserId && hasUserStat) AppStat.log.chat.userCardShow();
    }, [
        userStatPopupUserId
    ]);
    const renderChatBox = ()=>{
        if (Boolean(enabledOnlyFor)) {
            const isFollowerRequired = enabledOnlyFor.priority === 0;
            return /* @__PURE__ */ $acw62.createElement("div", {
                className: s$p.stub
            }, /* @__PURE__ */ $acw62.createElement("span", {
                className: s$p.unavailable
            }, isFollowerRequired ? t$j.chatIsUnavailableFollower : distExports$1.getParametrizedText(t$j.chatIsUnavailableSubscriber, {
                "level": enabledOnlyFor.name
            })));
        }
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !isOnlyRecordChatMode && /* @__PURE__ */ $acw62.createElement(ChatPinned, {
            streamUserId: streamerId,
            blogUrl: blogUrl,
            isAdmin: isAdmin,
            isAdminModerator: isAdminModerator,
            isAuthorized: isAuthorized,
            isChatModerator: canModerateChatChannel,
            isHidden: isOnlyMentionsMode
        }), /* @__PURE__ */ $acw62.createElement(ChatBox, {
            className: classNames.chatBox,
            isAuthorized: isAuthorized,
            blogUrl: blogUrl,
            lastBannedMessageId: lastBannedMessageId,
            isCurrentUserBanned: isBanned,
            isOnlyMentionsMode: isOnlyMentionsMode,
            isOnlyRecordChatMode: isOnlyRecordChatMode,
            isOpenedUserStat: Boolean(userStatPopupUserId),
            onBan: handleBan,
            addMentionRef: addMentionRef,
            onBanCancel: handleBanCancel,
            onMessageDelete: handleMessageDelete,
            onReplyClick: handleReplyClick,
            onThreadClick: handleThreadClick,
            onAuthorClick: handleAuthorClick,
            onMentionClick: handleMentionClick,
            onSmileClick: handleSmileClick,
            onPinnedClick: handlePinnedClick,
            onTimeout: handleTimeout,
            onContextMenuOpen: handleContextMenuOpen
        }));
    };
    const renderChatPublisher = (renderChatPublisherProps)=>{
        if (isOnlyRecordChatMode) return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$p.recordModePlaceholder,
            ref: chatPublisherRef
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_clock_circle_dashed_outline_24,
            className: s$p.recordModeIcon
        }), t$j.recordChatMode);
        return /* @__PURE__ */ $acw62.createElement(ChatPublisher, {
            className: renderChatPublisherProps == null ? void 0 : renderChatPublisherProps.className,
            ref: chatPublisherRef,
            blogUrl: blogUrl,
            chatSettings: chatSettings,
            classNames: classNames.publisher,
            addMentionRef: addMentionRef,
            isBanned: isBanned,
            isDisabled: isBanned || Boolean(enabledOnlyFor),
            isModerator: canModerateChatChannel,
            isWide: isWide,
            isOpenReplyMessage: isOpenReplyMessage,
            isOpenUserStat: Boolean(userStatPopupUserId),
            replyTarget: replyTarget,
            replyMessageId: replyMessageId,
            replyMessageData: replyMessageData,
            threadId: threadId,
            preventScrollOnMobileFocus: preventScrollOnMobileFocus,
            onUnavailableSmileSuggestClick: handleSmileClick,
            onPublish: handlePublish,
            onReplyCancel: handleReplyCancel,
            onThreadCancel: handleThreadCancel,
            onSwitchVisibilityReplyMessage: handleSwitchVisibilityReplyMessage,
            onSetReplyMessageId: setReplyMessageId,
            onAuthorClick: handleAuthorClick
        });
    };
    const renderChatFooter = ()=>{
        if (isMobile2) return /* @__PURE__ */ $acw62.createElement(ChatFooterMobileView, {
            ref: chatFooterRef,
            isAuthorized: isAuthorized,
            isSettingsButtonEnabled: isSettings,
            isSettingsModerationDisabled: isOnlyRecordChatMode,
            renderChatPublisher: renderChatPublisher,
            showAuth: showAuth
        }, footerNode);
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, renderChatPublisher(), Boolean(footerNode) && /* @__PURE__ */ $acw62.createElement(ChatFooter, {
            ref: chatFooterRef,
            blogUrl: blogUrl,
            isAuthorized: isAuthorized,
            isSettingsButtonEnabled: isSettings,
            isStudioButtonEnabled: Boolean(isStudio) && !isOnlyRecordChatMode,
            isSettingsModerationDisabled: isOnlyRecordChatMode,
            showAuth: showAuth
        }, footerNode));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: chatContainerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.root, s$p.root),
        style: height ? {
            height: `${height}px`
        } : null
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$p.chat,
        ref: chatRef
    }, renderChatBox(), renderChatFooter(), Boolean(userStatPopupUserId) && hasUserStat && /* @__PURE__ */ $acw62.createElement(UserStat, {
        blogUrl: blogUrl,
        userId: userStatPopupUserId,
        ownerId: streamUserId,
        threadId: threadId,
        offset: userStatPopupOffset,
        isCurrentUserModerator: canModerateChatChannel,
        isCurrentUserOwner: streamUserId === ((_a3 = currentUserAccess.currentUser) == null ? void 0 : _a3.id),
        isMessageHistoryEnabled: true,
        isHistoriesStoringEnabled: true,
        isOnlyRecordChatMode: isOnlyRecordChatMode,
        onClose: handleCloseUserStat,
        onBan: handleBan,
        onTimeout: handleTimeout,
        onMention: handleMentionUserStatClick,
        onBanCancel: handleBanCancel,
        onCalculateOffset: handleCalculatePopupOffset,
        onReply: handleReplyAfterUserStatClick,
        onRoleChange: onRoleChange
    })), !isMobile2 && smileInfoId && /* @__PURE__ */ $acw62.createElement("div", {
        style: smileInfoStyles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$p.smileInfo, {
            [s$p.smileInfoAbsolute]: isSmileInfoAbsolute
        })
    }, /* @__PURE__ */ $acw62.createElement(SmileInfo, {
        smileId: smileInfoId,
        onClose: handleCloseSmileInfo
    })));
};
var ESearchInputViewIconPosition = /* @__PURE__ */ ((ESearchInputViewIconPosition2)=>{
    ESearchInputViewIconPosition2["LEFT"] = "left";
    ESearchInputViewIconPosition2["RIGHT"] = "right";
    return ESearchInputViewIconPosition2;
})(ESearchInputViewIconPosition || {});
const iconSearch = "SearchInputView-scss--module__iconSearch___3gxGg";
const iconReset = "SearchInputView-scss--module__iconReset___WZ-si";
const iconSearchFocused = "SearchInputView-scss--module__iconSearchFocused___1Y3a9";
const inputWrapper = "SearchInputView-scss--module__inputWrapper___vr4qJ";
const inputWithButton = "SearchInputView-scss--module__inputWithButton___nik6v";
const iconArrow = "SearchInputView-scss--module__iconArrow___tGAnj";
const iconLeft = "SearchInputView-scss--module__iconLeft___ky2Qt";
const iconRight = "SearchInputView-scss--module__iconRight___l-xZz";
const inputWithLeftIcon = "SearchInputView-scss--module__inputWithLeftIcon___lo925";
const inputWithRightIcon = "SearchInputView-scss--module__inputWithRightIcon___fwDQD";
const iconArrowDisabled = "SearchInputView-scss--module__iconArrowDisabled___nFG-n";
const iconArrowRotated = "SearchInputView-scss--module__iconArrowRotated___nEUZp";
const buttons = "SearchInputView-scss--module__buttons___pgDy8";
const resetButton = "SearchInputView-scss--module__resetButton___3RKxe";
const searchButton = "SearchInputView-scss--module__searchButton___BnMAd";
const s$o = {
    iconSearch: iconSearch,
    iconReset: iconReset,
    iconSearchFocused: iconSearchFocused,
    inputWrapper: inputWrapper,
    inputWithButton: inputWithButton,
    iconArrow: iconArrow,
    iconLeft: iconLeft,
    iconRight: iconRight,
    inputWithLeftIcon: inputWithLeftIcon,
    inputWithRightIcon: inputWithRightIcon,
    iconArrowDisabled: iconArrowDisabled,
    iconArrowRotated: iconArrowRotated,
    buttons: buttons,
    resetButton: resetButton,
    searchButton: searchButton
};
const locales$i = {
    defaultPlaceholder: "\u0418\u0441\u043A\u0430\u0442\u044C",
    searchButton: "\u041D\u0430\u0439\u0442\u0438"
};
const t$i = distExports$1.getTranslation && locales$i;
const SearchInputView = (props)=>{
    const { classNames = {}, iconPosition = ESearchInputViewIconPosition.LEFT, iconSearchSymbol = svg_name_search_24, iconCrossSymbol = svg_name_cross, placeholder: placeholder2 = t$i.defaultPlaceholder, inputRef, limit, value: value2, error: error2, isValid: isValid2, onChange = noop$2, onFocus = noop$2, onBlur = noop$2, onKeyDown = noop$2, onReset = noop$2, onSearch = noop$2, onArrowClick = noop$2, isDisabled: isDisabled2, isAutoFocus, isFocused, isIconSearchHidden, isResetButtonHidden, isSearchButtonHidden, isVisibleArrowIcon = false, inputMode } = props;
    const isButtonsHidden = isResetButtonHidden && isSearchButtonHidden;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$o.inputWrapper, classNames.inputContainer)
    }, /* @__PURE__ */ $acw62.createElement(Input, {
        classNameInput: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classNames.input, {
            [s$o.inputWithButton]: !isSearchButtonHidden,
            [s$o.inputWithLeftIcon]: !isIconSearchHidden && iconPosition === ESearchInputViewIconPosition.LEFT,
            [s$o.inputWithRightIcon]: isVisibleArrowIcon || !isIconSearchHidden && iconPosition === ESearchInputViewIconPosition.RIGHT
        }),
        innerRef: inputRef,
        limit: limit,
        value: value2,
        placeholder: placeholder2,
        error: error2,
        isValid: isValid2,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        disabled: isDisabled2,
        autoFocus: isAutoFocus,
        inputMode: inputMode
    }), !isIconSearchHidden && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: iconSearchSymbol,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$o.iconSearch, classNames.iconSearch, {
            [s$o.iconSearchFocused]: isFocused,
            [s$o.iconLeft]: iconPosition === ESearchInputViewIconPosition.LEFT,
            [s$o.iconRight]: iconPosition === ESearchInputViewIconPosition.RIGHT
        })
    }), isVisibleArrowIcon && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_short,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$o.iconArrow, s$o.iconRight, {
            [s$o.iconArrowRotated]: isVisibleArrowIcon,
            [s$o.iconArrowDisabled]: isDisabled2
        }),
        onClick: onArrowClick
    }), !isButtonsHidden && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$o.buttons
    }, !isResetButtonHidden && /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$o.resetButton, s$o.iconRight),
        type: "button",
        onClick: onReset
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: iconCrossSymbol,
        className: s$o.iconReset
    })), !isSearchButtonHidden && /* @__PURE__ */ $acw62.createElement("button", {
        className: s$o.searchButton,
        type: "button",
        onClick: onSearch
    }, t$i.searchButton)));
};
const input = "SearchInput-scss--module__input___Xtua-";
const s$n = {
    input: input
};
const locales$h = {
    placeholder: "\u041F\u043E\u0438\u0441\u043A"
};
const t$h = distExports$1.getTranslation && locales$h;
const SearchInput = (props)=>{
    const { onSearch } = props;
    const [value2, setValue] = (0, $acw62.useState)("");
    const handleChange = (event2)=>{
        setValue(event2.target.value);
        onSearch(event2.target.value);
    };
    const handleReset = ()=>{
        setValue("");
    };
    return /* @__PURE__ */ $acw62.createElement(SearchInputView, {
        classNames: {
            input: s$n.input
        },
        onChange: handleChange,
        onReset: handleReset,
        value: value2,
        placeholder: t$h.placeholder,
        isSearchButtonHidden: true,
        isResetButtonHidden: value2.length === 0
    });
};
const root$i = "ChatUsers-scss--module__root___DXk0H";
const searchWrapper = "ChatUsers-scss--module__searchWrapper___EEL1Y";
const usersWrapper = "ChatUsers-scss--module__usersWrapper___rCBCW";
const accordionTitle = "ChatUsers-scss--module__accordionTitle___Ed-Ye";
const accordionArrow = "ChatUsers-scss--module__accordionArrow___O3Mha";
const accordionContent = "ChatUsers-scss--module__accordionContent___ogpY-";
const accordionContainer = "ChatUsers-scss--module__accordionContainer___3x1lr";
const title$5 = "ChatUsers-scss--module__title___kSJOW";
const s$m = {
    root: root$i,
    searchWrapper: searchWrapper,
    usersWrapper: usersWrapper,
    accordionTitle: accordionTitle,
    accordionArrow: accordionArrow,
    accordionContent: accordionContent,
    accordionContainer: accordionContainer,
    title: title$5
};
const locales$g = {
    owner: "\u0421\u0442\u0440\u0438\u043C\u0435\u0440",
    moderators: "\u041C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440\u044B",
    users: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0437\u0440\u0438\u0442\u0435\u043B\u0438",
    temporaryBannedUsers: "\u0422\u0430\u0439\u043C\u0430\u0443\u0442",
    permanentBannedUsers: "\u0411\u0430\u043D"
};
const t$g = distExports$1.getTranslation && locales$g;
const accordionClasslist = {
    titleClassName: s$m.accordionTitle,
    itemClassName: s$m.accordionContent,
    containerClassName: s$m.accordionContainer,
    arrowClassName: s$m.accordionArrow
};
const ChatUsers = (props)=>{
    var _a3, _b2;
    const { blogUrl, slotUrl, onReplyTarget } = props;
    const { streamChatUsers, streamChatUserStat, isCurrentUserModerator, isCurrentUserOwner, searchQuery, searchChatUsers, fetchStreamChatUsers: fetchStreamChatUsers2, onClickSuperHandler, resetChatUserStat, onBan, onTimeout, onBanCancel } = useChatUsers(blogUrl, slotUrl);
    const renderUsers = (users, context)=>users.map((user)=>/* @__PURE__ */ $acw62.createElement("div", {
                key: String(user.id),
                ["data-role"]: EHTMLDataRole.MESSAGE_CONTAINER,
                ["data-context"]: context,
                ["data-user-id"]: user.id
            }, /* @__PURE__ */ $acw62.createElement(ChatMessageAuthorPanel, {
                author: user,
                isBadgesDisabled: true,
                isBanned: false,
                withSeparator: false
            }), (streamChatUserStat == null ? void 0 : streamChatUserStat.user.id) === user.id && streamChatUserStat.context === context && /* @__PURE__ */ $acw62.createElement(UserStat, {
                blogUrl: blogUrl,
                userId: user.id,
                ownerId: streamChatUsers == null ? void 0 : streamChatUsers.owner.id,
                isCurrentUserModerator: isCurrentUserModerator,
                isCurrentUserOwner: isCurrentUserOwner,
                isMessageHistoryEnabled: true,
                isHistoriesStoringEnabled: true,
                onClose: resetChatUserStat,
                onBan: onBan,
                onTimeout: onTimeout,
                onMention: onReplyTarget,
                onBanCancel: onBanCancel
            })));
    const renderTitle = (icon2, title2)=>/* @__PURE__ */ $acw62.createElement("div", {
            className: s$m.title
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: icon2
        }), title2);
    (0, $acw62.useEffect)(()=>{
        resetChatUserStat();
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchStreamChatUsers2();
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$m.root,
        onClick: onClickSuperHandler
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$m.searchWrapper
    }, /* @__PURE__ */ $acw62.createElement(SearchInput, {
        onSearch: searchChatUsers
    })), Boolean(streamChatUsers) && /* @__PURE__ */ $acw62.createElement(ScrollableComponent, {
        className: s$m.usersWrapper
    }, /* @__PURE__ */ $acw62.createElement(Accordion, {
        ...accordionClasslist,
        title: renderTitle(svg_name_videocam_outline_28, t$g.owner)
    }, renderUsers([
        streamChatUsers.owner
    ], EUsersStatsContext.OWNER)), /* @__PURE__ */ $acw62.createElement(Accordion, {
        ...accordionClasslist,
        title: renderTitle(svg_name_shield_keyhole_outline_28, t$g.moderators),
        isOpenedByDefault: Boolean(searchQuery) && streamChatUsers.moderators.length > 0
    }, renderUsers(streamChatUsers.moderators, EUsersStatsContext.MODERATORS)), /* @__PURE__ */ $acw62.createElement(Accordion, {
        ...accordionClasslist,
        title: renderTitle(svg_name_smile_outline_28, t$g.users),
        isOpenedByDefault: Boolean(searchQuery) && streamChatUsers.users.length > 0
    }, renderUsers(streamChatUsers.users, EUsersStatsContext.USERS)), Boolean((_a3 = streamChatUsers.temporaryBannedUsers) == null ? void 0 : _a3.length) && /* @__PURE__ */ $acw62.createElement(Accordion, {
        ...accordionClasslist,
        title: renderTitle(svg_name_clock_outline_28, t$g.temporaryBannedUsers),
        isOpenedByDefault: Boolean(searchQuery) && streamChatUsers.temporaryBannedUsers.length > 0
    }, renderUsers(streamChatUsers.temporaryBannedUsers, EUsersStatsContext.TEMPORARYBANNEDUSERS)), Boolean((_b2 = streamChatUsers.permanentBannedUsers) == null ? void 0 : _b2.length) && /* @__PURE__ */ $acw62.createElement(Accordion, {
        ...accordionClasslist,
        title: renderTitle(svg_name_block_outline_28, t$g.permanentBannedUsers),
        isOpenedByDefault: Boolean(searchQuery) && streamChatUsers.permanentBannedUsers.length > 0
    }, renderUsers(streamChatUsers.permanentBannedUsers, EUsersStatsContext.PERMANENTBANNEDUSERS))));
};
const root$h = "DropInstruction-scss--module__root___3GddJ";
const container$2 = "DropInstruction-scss--module__container___BZXf0";
const close$1 = "DropInstruction-scss--module__close___h-Iae";
const back = "DropInstruction-scss--module__back___wgd3W";
const header$3 = "DropInstruction-scss--module__header___UW1RD";
const title$4 = "DropInstruction-scss--module__title___8Gs9U";
const text$1 = "DropInstruction-scss--module__text___WapcL";
const s$l = {
    root: root$h,
    container: container$2,
    close: close$1,
    back: back,
    header: header$3,
    title: title$4,
    text: text$1
};
const locales$f = {
    title: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043A\u0441\u044B",
    text: "\u0411\u043E\u043A\u0441\u044B \u2014 \u044D\u0442\u043E \u043D\u0430\u0433\u0440\u0430\u0434\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0439 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0430\u0445-\u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u0445 \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0439. \u0415\u0441\u043B\u0438 \u0432\u043D\u0438\u0437\u0443 \u0447\u0430\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441, \u0437\u043D\u0430\u0447\u0438\u0442, \u0432\u044B \u0443\u0436\u0435 \u043D\u0430 \u043F\u0443\u0442\u0438 \u043A \u043D\u0430\u0433\u0440\u0430\u0434\u0435. <Br> </Br> \u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441, \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434 \u0438 \u0441\u0440\u043E\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0439 \u043A\u043B\u0438\u043A\u043D\u0443\u0432 \u043F\u043E \u0448\u043A\u0430\u043B\u0435 \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0430 \u043D\u0438\u0436\u0435. \u041A\u043E\u0433\u0434\u0430 \u0448\u043A\u0430\u043B\u0430 \u043F\u0440\u0435\u0432\u0440\u0430\u0442\u0438\u0442\u0441\u044F \u0432 \u0438\u043A\u043E\u043D\u043A\u0443 \u0411\u043E\u043A\u0441\u0430 \u2014 \u043D\u0430\u0433\u0440\u0430\u0434\u0443 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0431\u0440\u0430\u0442\u044C."
};
const t$f = distExports$1.getTranslation && locales$f;
const DropInstruction = (props)=>{
    const { onClose, onBack, className } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch(toggleVisibilityDropInstruction(false));
        };
    }, []);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$l.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$l.container
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$l.header
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_long,
        className: s$l.back,
        onClick: onBack
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$l.title
    }, t$f.title), /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_cross,
        className: s$l.close,
        onClick: onClose
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$l.text
    }, distExports$1.getReactText(t$f.text, {
        Br: ()=>/* @__PURE__ */ $acw62.createElement("br", null)
    }))));
};
const root$g = "DropReceived-scss--module__root___1huRO";
const container$1 = "DropReceived-scss--module__container___He5gg";
const body = "DropReceived-scss--module__body___3torB";
const singleCard = "DropReceived-scss--module__singleCard___J7tki";
const singleCardImage = "DropReceived-scss--module__singleCardImage___9Bz7j";
const singleCardTextContainer = "DropReceived-scss--module__singleCardTextContainer___70Npq";
const singleCardDescription = "DropReceived-scss--module__singleCardDescription___-1rlm";
const list$1 = "DropReceived-scss--module__list___xdZFu";
const loader = "DropReceived-scss--module__loader___OauIi";
const card$1 = "DropReceived-scss--module__card___BljXH";
const cardImage = "DropReceived-scss--module__cardImage___dqf-E";
const cardData = "DropReceived-scss--module__cardData___Tv848";
const cardTextContainer = "DropReceived-scss--module__cardTextContainer___eJIoB";
const cardError = "DropReceived-scss--module__cardError___18obg";
const header$2 = "DropReceived-scss--module__header___kJWwD";
const title$3 = "DropReceived-scss--module__title___w6-Mh";
const button$3 = "DropReceived-scss--module__button___U-2CG";
const footer$2 = "DropReceived-scss--module__footer___QLpRG";
const icon$8 = "DropReceived-scss--module__icon___sa6qn";
const iconContainer = "DropReceived-scss--module__iconContainer___MvWg6";
const submitButton = "DropReceived-scss--module__submitButton___6-DZo";
const message = "DropReceived-scss--module__message___z-bxh";
const s$k = {
    root: root$g,
    container: container$1,
    body: body,
    singleCard: singleCard,
    singleCardImage: singleCardImage,
    singleCardTextContainer: singleCardTextContainer,
    singleCardDescription: singleCardDescription,
    list: list$1,
    loader: loader,
    card: card$1,
    cardImage: cardImage,
    cardData: cardData,
    cardTextContainer: cardTextContainer,
    cardError: cardError,
    header: header$2,
    title: title$3,
    button: button$3,
    footer: footer$2,
    icon: icon$8,
    iconContainer: iconContainer,
    submitButton: submitButton,
    message: message
};
const locales$e = {
    title: "\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430",
    button: "\u0412 \u043C\u0430\u0440\u043A\u0435\u0442",
    error: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0431\u043E\u043A\u0441\u0430",
    submit: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E",
    VK_ID: {
        title: "\u041D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D VK ID",
        description: "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u0431\u043E\u043A\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C VK ID.",
        button: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 VK ID",
        error: "\u041D\u0435 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D VK ID"
    },
    vkPlayLink: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A VK Play",
    vkPlayLinkError: "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u0431\u043E\u043A\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C VK ID.",
    vkPlayLinkErrorTitle: "\u041D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D VK Play"
};
const t$e = distExports$1.getTranslation && locales$e;
const VK_ID_ERROR = "need_vk_link";
const VKPLAY_ERROR = "need_vkplay_link";
const DropReceived = (props)=>{
    var _a3, _b2;
    const { className, setDropListVisibility, onClose } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const navigate = (value2)=>{
        document.location.href = value2;
    };
    const receivedDrops = (0, $iD0SF.useSelector)(dropProductsToShowSelector);
    const externalLink = (0, $iD0SF.useSelector)(campaignExternalLinkSelector);
    const { isFetching, error: error2 } = (0, $iD0SF.useSelector)(dropsProgressNetworkStatusSelector);
    const prevReceivedDrops = usePrevious(receivedDrops);
    const needVKPlayLinkError = get(error2, "serverError.error") === VKPLAY_ERROR;
    const hasDropWithVKIDError = ((_a3 = error2 == null ? void 0 : error2.serverError) == null ? void 0 : _a3.error) === VK_ID_ERROR && receivedDrops.length === 1;
    const isOnlyErrorsInDrops = receivedDrops.reduce((acc, drop2)=>{
        if (!drop2.error) return false;
        return acc;
    }, true);
    const vkPlayMarketLink = ((_b2 = receivedDrops == null ? void 0 : receivedDrops[0]) == null ? void 0 : _b2.inventoryLink) ?? externalLink;
    const handleClose = ()=>{
        dispatch(clearDropRewardsToShow({}));
        onClose();
    };
    const handleButtonClick = ()=>{
        dispatch(clearDropRewardsToShow({}));
        if (hasDropWithVKIDError || needVKPlayLinkError) {
            navigate(URLS.SETTINGS_EXTERNAL_APP);
            return;
        }
        onClose();
    };
    const handleBackClick = ()=>{
        setDropListVisibility(true);
        onClose();
    };
    (0, $acw62.useEffect)(()=>{
        if (prevReceivedDrops !== void 0 && prevReceivedDrops.length !== 0 && (receivedDrops == null ? void 0 : receivedDrops.length) === 0) handleClose();
    }, [
        receivedDrops.length
    ]);
    const renderSingleDrop = ()=>{
        const singleDrop = receivedDrops[0];
        if (hasDropWithVKIDError) return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$k.singleCard
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$k.singleCardDescription
        }, t$e.VK_ID.description));
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$k.singleCard
        }, /* @__PURE__ */ $acw62.createElement("img", {
            src: singleDrop.logoUrl,
            className: s$k.singleCardImage
        }), /* @__PURE__ */ $acw62.createElement(EllipsisWithTooltip, {
            tooltipContent: singleDrop.title,
            classNames: {
                root: s$k.singleCardTextContainer,
                contentWrapper: s$k.singleCardText
            }
        }, singleDrop.title), singleDrop.error && renderError(singleDrop.error));
    };
    const renderError = (err)=>{
        var _a4;
        let text2 = t$e.error;
        if (((_a4 = err.serverError) == null ? void 0 : _a4.error) === VK_ID_ERROR) text2 = t$e.VK_ID.error;
        return /* @__PURE__ */ $acw62.createElement("span", {
            className: s$k.cardError
        }, text2);
    };
    const renderDropsList = ()=>{
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$k.list
        }, receivedDrops.map((product)=>/* @__PURE__ */ $acw62.createElement("div", {
                className: s$k.card,
                key: product.id
            }, /* @__PURE__ */ $acw62.createElement("img", {
                src: product.logoUrl,
                className: s$k.cardImage
            }), /* @__PURE__ */ $acw62.createElement("div", {
                className: s$k.cardData
            }, /* @__PURE__ */ $acw62.createElement(EllipsisWithTooltip, {
                tooltipContent: product.title,
                classNames: {
                    root: s$k.cardTextContainer,
                    contentWrapper: s$k.cardText
                }
            }, product.title), product.error && renderError(product.error)))));
    };
    const renderContent = ()=>{
        if (!receivedDrops.length && isFetching) return /* @__PURE__ */ $acw62.createElement(Spinner, {
            className: s$k.loader
        });
        if (needVKPlayLinkError) return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$k.message
        }, t$e.vkPlayLinkError);
        if (!receivedDrops.length && error2) return t$e.error;
        if (receivedDrops.length === 1) return renderSingleDrop();
        return renderDropsList();
    };
    const renderTitle = ()=>{
        if (isFetching) return "";
        if (hasDropWithVKIDError) return t$e.VK_ID.title;
        else if (needVKPlayLinkError) return t$e.vkPlayLinkErrorTitle;
        else if (isOnlyErrorsInDrops) return t$e.error;
        return t$e.title;
    };
    const renderFooter = ()=>{
        if (isFetching) return null;
        if (needVKPlayLinkError) return /* @__PURE__ */ $acw62.createElement(Button$1, {
            onClick: handleButtonClick
        }, t$e.vkPlayLink);
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(ContainedButton, {
            onClick: handleButtonClick,
            className: s$k.submitButton
        }, hasDropWithVKIDError ? t$e.VK_ID.button : t$e.submit), Boolean(vkPlayMarketLink) && /* @__PURE__ */ $acw62.createElement("a", {
            className: s$k.button,
            href: vkPlayMarketLink,
            target: "_blank",
            rel: "noreferrer",
            onClick: handleClose
        }, t$e.button));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$k.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.container
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.header
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.iconContainer
    }, hasDropWithVKIDError && /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_arrow_long,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$k.icon),
        onClick: handleBackClick
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.title
    }, renderTitle()), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.iconContainer
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_cancel_20,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$k.icon),
        onClick: handleClose
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.body
    }, renderContent()), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$k.footer
    }, renderFooter())));
};
const root$f = "DropBox-scss--module__root___EYfKD";
const icon$7 = "DropBox-scss--module__icon___GhatF";
const badge = "DropBox-scss--module__badge___6VkSS";
const text = "DropBox-scss--module__text___tOGU5";
const s$j = {
    root: root$f,
    icon: icon$7,
    badge: badge,
    text: text
};
const locales$d = {
    text: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C"
};
const t$d = distExports$1.getTranslation && locales$d;
const DropBox = (props)=>{
    const { gatherReadyCount, onClick, hasText = false, className } = props;
    return /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$j.root, className),
        type: "button",
        onClick: onClick
    }, gatherReadyCount && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$j.badge
    }, gatherReadyCount), /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_box,
        className: s$j.icon
    }), hasText && /* @__PURE__ */ $acw62.createElement("span", {
        className: s$j.text
    }, t$d.text));
};
const root$e = "CircularProgressBar-scss--module__root___0eWIz";
const withPointer = "CircularProgressBar-scss--module__withPointer___c7XNm";
const countdownPercent = "CircularProgressBar-scss--module__countdownPercent___y3CjV";
const countdownSvg = "CircularProgressBar-scss--module__countdownSvg___numDH";
const countdownSvgCircle = "CircularProgressBar-scss--module__countdownSvgCircle___wNI27";
const countdownSvgCircleBackground = "CircularProgressBar-scss--module__countdownSvgCircleBackground___3f9NU";
const s$i = {
    root: root$e,
    withPointer: withPointer,
    countdownPercent: countdownPercent,
    countdownSvg: countdownSvg,
    countdownSvgCircle: countdownSvgCircle,
    countdownSvgCircleBackground: countdownSvgCircleBackground
};
const CIRCLE_PARTS = 82;
const CircularProgressBar = (props)=>{
    const { percent, onClick } = props;
    const filledParts = CIRCLE_PARTS - Math.trunc(CIRCLE_PARTS * percent / 100);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$i.root, {
            [s$i.withPointer]: Boolean(onClick)
        }),
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$i.countdownPercent
    }, percent, "%"), /* @__PURE__ */ $acw62.createElement("svg", {
        className: s$i.countdownSvg
    }, /* @__PURE__ */ $acw62.createElement("circle", {
        className: s$i.countdownSvgCircleBackground,
        r: "13",
        cx: "15",
        cy: "15"
    }), /* @__PURE__ */ $acw62.createElement("circle", {
        className: s$i.countdownSvgCircle,
        r: "13",
        cx: "15",
        cy: "15",
        style: {
            strokeDashoffset: filledParts
        }
    })));
};
const root$d = "DropsBar-scss--module__root___GBnOZ";
const header$1 = "DropsBar-scss--module__header___mvcNt";
const title$2 = "DropsBar-scss--module__title___Z3vln";
const titleText = "DropsBar-scss--module__titleText___1T9YP";
const image$2 = "DropsBar-scss--module__image___UdwGs";
const moreProductsImage = "DropsBar-scss--module__moreProductsImage___Lc0-9";
const restDrops = "DropsBar-scss--module__restDrops___kcdtI";
const restDropsContentWrapper = "DropsBar-scss--module__restDropsContentWrapper___NBUp8";
const restDropsContent = "DropsBar-scss--module__restDropsContent___xsHpu";
const restDropsElement = "DropsBar-scss--module__restDropsElement___AKb4t";
const restDropsDetailTooltip = "DropsBar-scss--module__restDropsDetailTooltip___gUIaM";
const divider = "DropsBar-scss--module__divider___ocbD6";
const footer$1 = "DropsBar-scss--module__footer___Fx6Lv";
const right = "DropsBar-scss--module__right___bn8cv";
const left = "DropsBar-scss--module__left___uIQ-J";
const from = "DropsBar-scss--module__from___Mgf4K";
const dropButton = "DropsBar-scss--module__dropButton___GUsG1";
const s$h = {
    root: root$d,
    header: header$1,
    title: title$2,
    titleText: titleText,
    image: image$2,
    moreProductsImage: moreProductsImage,
    restDrops: restDrops,
    restDropsContentWrapper: restDropsContentWrapper,
    restDropsContent: restDropsContent,
    restDropsElement: restDropsElement,
    restDropsDetailTooltip: restDropsDetailTooltip,
    divider: divider,
    footer: footer$1,
    right: right,
    left: left,
    from: from,
    dropButton: dropButton
};
const locales$c = {
    moreProducts: "\u0438 \u0435\u0449\u0435 {{count}}",
    to: "\u0434\u043E",
    from: "\u043E\u0442"
};
const DATE_TIME_FORMAT = "dd/MMMM/HH/mm";
const t$c = distExports$1.getTranslation && locales$c;
const DropsBar = (props)=>{
    const { timePassedPercent, title: title2, imageUrl, classNames = {}, dropsCampaignId, ruleId, restProducts, onDropProductCollect, goal, stopAt } = props;
    const isProgressFinished = timePassedPercent === 100;
    const handleDropProductCollect = ()=>{
        onDropProductCollect(dropsCampaignId, ruleId);
    };
    const renderElementFromRestList = (product)=>{
        return /* @__PURE__ */ $acw62.createElement(EllipsisWithTooltip, {
            tooltipContent: product.title,
            classNames: {
                contentWrapper: s$h.restDropsContentWrapper,
                tooltipContent: s$h.restDropsContent,
                root: s$h.restDropsDetailTooltip
            }
        }, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$h.restDropsElementText
        }, product.title));
    };
    const renderRestList = ()=>{
        return /* @__PURE__ */ $acw62.createElement("div", {
            className: s$h.restDropsList
        }, restProducts.map((product)=>/* @__PURE__ */ $acw62.createElement("div", {
                key: product.id,
                className: s$h.restDropsElement
            }, /* @__PURE__ */ $acw62.createElement("img", {
                src: product.logoUrl,
                alt: product.title,
                className: s$h.moreProductsImage
            }), renderElementFromRestList(product))));
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$h.root, classNames.root)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$h.header, classNames.header)
    }, Boolean(imageUrl) && /* @__PURE__ */ $acw62.createElement("img", {
        className: s$h.image,
        alt: title2,
        src: imageUrl
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.title
    }, /* @__PURE__ */ $acw62.createElement(EllipsisWithTooltip, {
        position: ETooltipPosition.TOP_END,
        tooltipContent: title2,
        classNames: {
            contentWrapper: s$h.titleText
        }
    }, title2)), restProducts && restProducts.length > 0 && /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        position: ETooltipPosition.TOP_START,
        trigger: ETooltipTrigger.CLICK,
        content: renderRestList(),
        classNames: {
            contentWrapper: s$h.restDropsContentWrapper,
            content: s$h.restDropsContent
        },
        isGlobal: true
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.restDrops
    }, `${distExports$1.getParametrizedText(t$c.moreProducts, {
        count: restProducts.length
    })}`))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.divider
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.footer
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.left
    }, isProgressFinished ? /* @__PURE__ */ $acw62.createElement(DropBox, {
        onClick: handleDropProductCollect,
        hasText: true,
        className: s$h.dropButton
    }) : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement(CircularProgressBar, {
        percent: timePassedPercent
    }), /* @__PURE__ */ $acw62.createElement("span", {
        className: s$h.from
    }, " ", t$c.from, " ", getDropsDurationText(goal)))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$h.right
    }, " ", t$c.to, " ", getFormattedDate(stopAt, DATE_TIME_FORMAT))));
};
const root$c = "DropsList-scss--module__root___GyvyW";
const header = "DropsList-scss--module__header___xcst0";
const title$1 = "DropsList-scss--module__title___-gh8L";
const close = "DropsList-scss--module__close___1p0nZ";
const item = "DropsList-scss--module__item___8B303";
const container = "DropsList-scss--module__container___T6ttx";
const instructionButton = "DropsList-scss--module__instructionButton___HpDWt";
const s$g = {
    root: root$c,
    header: header,
    title: title$1,
    close: close,
    item: item,
    container: container,
    instructionButton: instructionButton
};
const locales$b = {
    drops: "\u0411\u043E\u043A\u0441\u044B",
    dropReceivingError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0431\u043E\u043A\u0441\u0430",
    instruction: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043A\u0441\u044B"
};
const t$b = distExports$1.getTranslation && locales$b;
const DROP_RECEIVING_ERROR_TIMEOUT = 2e3;
const DropsList = (props)=>{
    const { className, setDropReceivedVisibility, setDropInstructionVisibility, onClose } = props;
    const { showAlert } = useNotificationsContext();
    const drops = (0, $iD0SF.useSelector)(nonReceivedDropsProgressSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const handleDropProductCollect = (0, $acw62.useCallback)(async (dropCampaignId, ruleId)=>{
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(requestDropRewards.action)({
                dropCampaignId: dropCampaignId,
                ruleId: ruleId
            }));
            onClose();
            setDropReceivedVisibility(true);
        } catch (error2) {
            if (error2 instanceof ApiError && error2.serverError.error === "need_vk_link") {
                onClose();
                setDropReceivedVisibility(true);
                return;
            }
            showAlert({
                type: EAlertType.ERROR,
                text: t$b.dropReceivingError,
                timeout: DROP_RECEIVING_ERROR_TIMEOUT
            });
        }
    }, [
        onClose
    ]);
    if (!(drops == null ? void 0 : drops.length)) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$g.root, className)
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: svg_name_cross,
        className: s$g.close,
        onClick: onClose
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$g.header
    }, /* @__PURE__ */ $acw62.createElement("span", {
        className: s$g.title
    }, t$b.drops)), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$g.container
    }, drops.map(({ campaign: { id: campaignId, stopAt, title: title2, logoUrl }, currentRule: { progress: progress2, products, id: ruleId } }, index2)=>{
        const [showedProduct, ...restProducts] = products;
        return /* @__PURE__ */ $acw62.createElement(DropsBar, {
            key: index2,
            classNames: {
                root: s$g.item
            },
            timePassedPercent: getProgressPercent(progress2.goal, progress2.current),
            title: showedProduct == null ? void 0 : showedProduct.title,
            imageUrl: showedProduct == null ? void 0 : showedProduct.logoUrl,
            dropsCampaignId: campaignId,
            ruleId: ruleId,
            restProducts: restProducts,
            onDropProductCollect: handleDropProductCollect,
            goal: progress2.goal,
            stopAt: stopAt
        });
    }), /* @__PURE__ */ $acw62.createElement(InlineButton, {
        className: s$g.instructionButton,
        onClick: setDropInstructionVisibility
    }, t$b.instruction)));
};
const locales$a = {
    tooltip: "\u0411\u043E\u043A\u0441\u044B",
    getDrops: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043A\u0441\u044B"
};
const t$a = distExports$1.getTranslation && locales$a;
const DropView = (props)=>{
    const { isDropPopupOpen, setDropListVisibility, setDropReceivedVisibility } = props;
    const { blogUrl, slotUrl } = useStreamIdentity();
    const { highestDropProgress, dropsFinishedProgressCount, isDropsListEmpty, onClick } = useDropsView({
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        setDropListVisibility: setDropListVisibility,
        setDropReceivedVisibility: setDropReceivedVisibility
    });
    const isAnyFinishedCount = Boolean(dropsFinishedProgressCount);
    if (isDropsListEmpty && !isAnyFinishedCount) return null;
    return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        content: isAnyFinishedCount ? t$a.getDrops : t$a.tooltip,
        isDisabled: isDropPopupOpen
    }, !isDropsListEmpty && !isAnyFinishedCount && /* @__PURE__ */ $acw62.createElement(CircularProgressBar, {
        percent: highestDropProgress,
        onClick: onClick
    }), isAnyFinishedCount && /* @__PURE__ */ $acw62.createElement(DropBox, {
        onClick: onClick,
        gatherReadyCount: dropsFinishedProgressCount
    }));
};
var EShopStep = /* @__PURE__ */ ((EShopStep2)=>{
    EShopStep2["REWARDS_LIST"] = "REWARDS_LIST";
    EShopStep2["SELECTED_REWARD"] = "SELECTED_REWARD";
    EShopStep2["PRICE_LIST"] = "PRICE_LIST";
    return EShopStep2;
})(EShopStep || {});
const bonusTypeToIconMap = {
    [EBonusType.STREAM_VIEW]: svg_name_view_outline_20,
    [EBonusType.STREAM_ACTIVE_VIEW]: svg_name_view_outline_20,
    [EBonusType.CHAT_MESSAGE]: svg_name_comment_outline_20,
    [EBonusType.STREAM_RAID]: svg_name_raid,
    [EBonusType.STREAM_LIKE]: svg_name_like_outline_20,
    [EBonusType.CHANNEL_FOLLOW]: svg_name_bell,
    [EBonusType.MULTIPLIER]: svg_name_star_outline
};
const pointRewardManagerNavigate = (blogUrl, id)=>{
    const query = void 0;
    const url = getParametrizedUrl(URLS.REWARD_MANAGER, {
        blogUrl: blogUrl
    }, query);
    window.open(url, "rewardManager", "width=850,height=700,menu,menubar=no,toolbar=no,location=no,status=no");
};
const root$b = "ShopWrapper-scss--module__root___vAqtr";
const panel = "ShopWrapper-scss--module__panel___0KugP";
const title = "ShopWrapper-scss--module__title___LwvUJ";
const icon$6 = "ShopWrapper-scss--module__icon___1Ojzu";
const content$2 = "ShopWrapper-scss--module__content___u-lZ4";
const menuItem = "ShopWrapper-scss--module__menuItem___mc2Mt";
const dotsDropdown = "ShopWrapper-scss--module__dotsDropdown___6WHyw";
const s$f = {
    root: root$b,
    panel: panel,
    title: title,
    icon: icon$6,
    content: content$2,
    menuItem: menuItem,
    dotsDropdown: dotsDropdown
};
const locales$9 = {
    activatedRewardsManager: "\u041C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u0433\u0440\u0430\u0434",
    manageRewards: "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0430\u043C\u0438"
};
const t$9 = distExports$1.getTranslation && locales$9;
const ShopWrapper = (props)=>{
    const { className, classNameContent, hasBack = false, title: title2 = "", children: children2, onBack = dist$4.noop, onClose = dist$4.noop } = props;
    const { blogUrl } = useStreamIdentity();
    const { canModerateChatChannel, canAdministrateChannel } = useCurrentUserAccess();
    const navigate = (value2)=>{
        document.location.href = value2;
    };
    const handleManageRewardsClick = ()=>{
        navigate(dist$4.getParametrizedUrl(URLS.COMMUNITY_BLOG_POINTS, {
            blogUrl: blogUrl
        }));
    };
    const handleActivatedRewardsManagerClick = ()=>{
        pointRewardManagerNavigate(blogUrl);
    };
    const renderCornerControl = ()=>{
        if (hasBack) return /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$f.icon,
            glyph: svg_name_chevron_right_outline_20,
            onClick: onBack
        });
        if (canModerateChatChannel) return /* @__PURE__ */ $acw62.createElement(ExtraActionsMenu, {
            iconGlyph: svg_name_more_horizontal_24,
            classNames: {
                icon: s$f.icon,
                dropdown: s$f.dotsDropdown
            }
        }, canAdministrateChannel && /* @__PURE__ */ $acw62.createElement(ExtraActionsMenuItem, {
            onClick: handleManageRewardsClick,
            className: s$f.menuItem
        }, t$9.manageRewards), /* @__PURE__ */ $acw62.createElement(ExtraActionsMenuItem, {
            onClick: handleActivatedRewardsManagerClick,
            className: s$f.menuItem
        }, t$9.activatedRewardsManager));
        return /* @__PURE__ */ $acw62.createElement("div", null, "\xa0");
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$f.root, className)
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$f.panel
    }, renderCornerControl(), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$f.title,
        title: typeof title2 === "string" ? title2 : ""
    }, title2), /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$f.icon,
        glyph: svg_name_cancel_20,
        onClick: onClose
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$f.content, classNameContent)
    }, children2));
};
const root$a = "PriceCard-scss--module__root___duYEJ";
const icon$5 = "PriceCard-scss--module__icon___joaLX";
const row = "PriceCard-scss--module__row___pVkAO";
const name$1 = "PriceCard-scss--module__name___XUrjw";
const tooltip$1 = "PriceCard-scss--module__tooltip___6cA-o";
const value = "PriceCard-scss--module__value___lXnJ0";
const s$e = {
    root: root$a,
    icon: icon$5,
    row: row,
    name: name$1,
    tooltip: tooltip$1,
    value: value
};
const locales$8 = {
    howToMakePoints: "\u041A\u0430\u043A \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C {{pointName}}"
};
const t$8 = distExports$1.getTranslation && locales$8;
const PriceCard = (props)=>{
    const { bonuses, bonusMultipliers, onBack, onClose } = props;
    const sortedData = (0, $acw62.useMemo)(()=>bonuses.sort((prev, next2)=>{
            return (prev == null ? void 0 : prev.channelPointAmount) - (next2 == null ? void 0 : next2.channelPointAmount);
        }), bonuses);
    const pointName = (0, $iD0SF.useSelector)(pointNameSelector);
    return /* @__PURE__ */ $acw62.createElement(ShopWrapper, {
        title: distExports$1.getParametrizedText(t$8.howToMakePoints, {
            pointName: pointName
        }),
        hasBack: true,
        onBack: onBack,
        onClose: onClose
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$e.root
    }, sortedData.map(({ name: name2, description: description2, channelPointAmount, type, multiplier }, index2)=>/* @__PURE__ */ $acw62.createElement("div", {
            key: index2,
            className: s$e.row
        }, bonusTypeToIconMap[type] && /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$e.icon,
            glyph: bonusTypeToIconMap[type]
        }), /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            classNames: {
                root: s$e.name,
                content: s$e.tooltip
            },
            position: ETooltipPosition.TOP_START,
            content: description2,
            isGlobal: true
        }, /* @__PURE__ */ $acw62.createElement("span", null, name2)), /* @__PURE__ */ $acw62.createElement("span", {
            className: s$e.value
        }, "+", channelPointAmount))), bonusMultipliers.map(({ name: name2, description: description2, type, bonusMultiplier }, index2)=>/* @__PURE__ */ $acw62.createElement("div", {
            key: index2,
            className: s$e.row
        }, bonusTypeToIconMap[type] && /* @__PURE__ */ $acw62.createElement(Icon, {
            className: s$e.icon,
            glyph: bonusTypeToIconMap[type]
        }), /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            classNames: {
                root: s$e.name,
                content: s$e.tooltip
            },
            position: ETooltipPosition.TOP_START,
            content: description2,
            isGlobal: true
        }, /* @__PURE__ */ $acw62.createElement("span", null, name2)), /* @__PURE__ */ $acw62.createElement("span", {
            className: s$e.value
        }, "x", "\xa0", bonusMultiplier)))));
};
const reasonText = "DenyReason-scss--module__reasonText___sKcx7";
const s$d = {
    reasonText: reasonText
};
const locales$7 = {
    noActiveStrem: "\u042D\u0442\u0443 \u043D\u0430\u0433\u0440\u0430\u0434\u0443 \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438",
    cooldownNotExpired: "\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0430. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0435\u0435 \u0447\u0435\u0440\u0435\u0437:",
    activationLimitIsReached: "\u042D\u0442\u0438 \u043D\u0430\u0433\u0440\u0430\u0434\u044B \u043F\u043E\u043A\u0430 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438\u0441\u044C, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435",
    notEnoughChannelPoints: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0431\u0430\u043B\u043B\u043E\u0432 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
    rewardUnknownError: "\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0435\u0440\u043D\u0443\u0442\u0441\u044F \u0437\u0430 \u043D\u0435\u0439 \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
    userIsBanned: "\u0412\u044B \u0437\u0430\u0431\u0430\u043D\u0435\u043D\u044B \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0435, \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430"
};
const t$7 = distExports$1.getTranslation && locales$7;
const DenyReason = (props)=>{
    const { reason: reason2, onUpdate } = props;
    const renderCooldownNotExpiredReason = (denyReason)=>{
        const leftTime = ((reason2 == null ? void 0 : reason2.lastActivationTime) + (denyReason == null ? void 0 : denyReason.repairTimeout)) * 1e3 - Date.now();
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
            className: s$d.reasonText
        }, t$7.cooldownNotExpired), /* @__PURE__ */ $acw62.createElement("div", null, /* @__PURE__ */ $acw62.createElement(Countdown, {
            timeLeft: leftTime,
            onEnd: onUpdate,
            mode: ECountdownMode.STATION
        })));
    };
    switch(reason2 == null ? void 0 : reason2.reason){
        case ERewardDenyReasonType.NO_ACTIVE_STREAM:
            return /* @__PURE__ */ $acw62.createElement("span", null, t$7.noActiveStrem);
        case ERewardDenyReasonType.ACTIVATION_LIMIT_IS_REACHED:
            return /* @__PURE__ */ $acw62.createElement("span", null, t$7.activationLimitIsReached);
        case ERewardDenyReasonType.NOT_ENOUGH_CHANNEL_POINTS:
            return /* @__PURE__ */ $acw62.createElement("span", null, t$7.notEnoughChannelPoints);
        case ERewardDenyReasonType.COOLDOWN_NOT_EXPIRED:
            return renderCooldownNotExpiredReason(reason2);
        case ERewardDenyReasonType.USER_IS_BANNED:
            return /* @__PURE__ */ $acw62.createElement("span", null, t$7.userIsBanned);
        default:
            return /* @__PURE__ */ $acw62.createElement("span", null, t$7.rewardUnknownError);
    }
};
const root$9 = "RewardPreviewLarge-scss--module__root___xtBH3";
const imageContainer = "RewardPreviewLarge-scss--module__imageContainer___HGrhk";
const image$1 = "RewardPreviewLarge-scss--module__image___ScX5V";
const icon$4 = "RewardPreviewLarge-scss--module__icon___ciCrx";
const button$2 = "RewardPreviewLarge-scss--module__button___-wMd-";
const notAvailable = "RewardPreviewLarge-scss--module__notAvailable___nSgxw";
const description = "RewardPreviewLarge-scss--module__description___0gNz5";
const notInteractive = "RewardPreviewLarge-scss--module__notInteractive___svczJ";
const reason = "RewardPreviewLarge-scss--module__reason___-cC6m";
const s$c = {
    root: root$9,
    imageContainer: imageContainer,
    image: image$1,
    icon: icon$4,
    button: button$2,
    notAvailable: notAvailable,
    description: description,
    notInteractive: notInteractive,
    reason: reason
};
const locales$6 = {
    activateFor: "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430 {{price}}"
};
const t$6 = distExports$1.getTranslation && locales$6;
const RewardPreviewLarge = (props)=>{
    const { className, description: description2 = "", bgcolor, rewardIconSrc, pointsIconSrc, price = 0, isAvailable = true, isInteractive = true, denyReason, onActivateClick = dist$4.noop } = props;
    const onButtonClick = ()=>{
        if (!isAvailable) return;
        onActivateClick();
    };
    const { theme } = useThemeContext();
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, s$c.root, !isInteractive && s$c.notInteractive)
    }, description2 && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$c.description
    }, description2), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$c.imageContainer,
        style: {
            background: getChatNicknameColor(bgcolor, theme)
        }
    }, /* @__PURE__ */ $acw62.createElement(RewardIcon, {
        className: s$c.image,
        src: rewardIconSrc
    })), Boolean(denyReason) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$c.reason
    }, denyReason), /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$c.button, {
            [s$c.notAvailable]: !isAvailable || Boolean(denyReason)
        }),
        onClick: onButtonClick
    }, /* @__PURE__ */ $acw62.createElement("span", null, distExports$1.getParametrizedText(t$6.activateFor, {
        price: price
    })), /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
        className: s$c.icon,
        src: pointsIconSrc
    })));
};
const reasonContainer = "RewardCard-scss--module__reasonContainer___ieiuz";
const reloadSpinner = "RewardCard-scss--module__reloadSpinner___fsduj";
const showWrapperContent = "RewardCard-scss--module__showWrapperContent___AyFWi";
const rewardPreviewRoot = "RewardCard-scss--module__rewardPreviewRoot___-Os5m";
const s$b = {
    reasonContainer: reasonContainer,
    reloadSpinner: reloadSpinner,
    showWrapperContent: showWrapperContent,
    rewardPreviewRoot: rewardPreviewRoot
};
const RewardCard = (props)=>{
    const { rewardData, pointData, onClose = dist$4.noop, onBack = dist$4.noop, onActivate = dist$4.noop } = props;
    const { blogUrl } = useParams();
    const prevBlogUrl = usePrevious(blogUrl);
    const dispatch = (0, $2OPjR.useDispatch)();
    const [reload, setReload] = (0, $acw62.useState)(false);
    const [reason2, setReason] = (0, $acw62.useState)();
    const reloadData = async ()=>{
        setReload(true);
        try {
            const reward2 = await dispatch((0, $7Uc0p.thunkToAction)(fetchRewardById.action)({
                blogUrl: blogUrl,
                id: rewardData.id
            }));
            setReason(reward2 == null ? void 0 : reward2.denyReason);
        } catch (err) {
            setReason({
                reason: ERewardDenyReasonType.UNKNOWN
            });
        } finally{
            setReload(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (rewardData) setReason(rewardData.denyReason);
    }, [
        rewardData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prevBlogUrl && blogUrl && prevBlogUrl !== blogUrl) onClose();
    }, [
        prevBlogUrl,
        blogUrl
    ]);
    const renderReason = ()=>{
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, reload && /* @__PURE__ */ $acw62.createElement("div", {
            className: s$b.reasonContainer
        }, /* @__PURE__ */ $acw62.createElement(Spinner, {
            className: s$b.reloadSpinner
        })), !reload && /* @__PURE__ */ $acw62.createElement(DenyReason, {
            blogUrl: blogUrl,
            reason: reason2,
            onUpdate: reloadData
        }));
    };
    return /* @__PURE__ */ $acw62.createElement(ShopWrapper, {
        title: rewardData == null ? void 0 : rewardData.name,
        onBack: onBack,
        hasBack: true,
        onClose: onClose,
        classNameContent: s$b.showWrapperContent
    }, !Boolean(rewardData) && /* @__PURE__ */ $acw62.createElement(Spinner, null), Boolean(rewardData) && /* @__PURE__ */ $acw62.createElement(RewardPreviewLarge, {
        className: s$b.rewardPreviewRoot,
        description: rewardData.description,
        bgcolor: rewardData.bgcolor,
        rewardIconSrc: rewardData.largeUrl,
        pointsIconSrc: pointData == null ? void 0 : pointData.mediumUrl,
        price: rewardData.price,
        isAvailable: rewardData.isAvailable,
        denyReason: Boolean(reason2) && renderReason(),
        onActivateClick: onActivate
    }));
};
const root$8 = "RewardPreviewSmall-scss--module__root___-AyY1";
const wrapper = "RewardPreviewSmall-scss--module__wrapper___wRu6c";
const card = "RewardPreviewSmall-scss--module__card___-4O8u";
const image = "RewardPreviewSmall-scss--module__image___5E-CB";
const name = "RewardPreviewSmall-scss--module__name___wyRqA";
const opaque = "RewardPreviewSmall-scss--module__opaque___JaPeA";
const s$a = {
    root: root$8,
    wrapper: wrapper,
    card: card,
    image: image,
    name: name,
    opaque: opaque
};
const RewardPreviewSmall = (props)=>{
    const { name: name2 = "", price = 0, isAffordable = true, isAvailable = true, bgcolor, rewardIconSrc, pointsIconSrc, className, onClick = dist$4.noop } = props;
    const { theme } = useThemeContext();
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$a.root, className, {
            [s$a.opaque]: isAffordable && !isAvailable
        }),
        onClick: onClick
    }, /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        position: ETooltipPosition.TOP,
        content: name2,
        isGlobal: true,
        className: s$a.wrapper
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$a.card,
        style: {
            background: getChatNicknameColor(bgcolor, theme)
        }
    }, /* @__PURE__ */ $acw62.createElement(RewardIcon, {
        className: s$a.image,
        src: rewardIconSrc
    }), /* @__PURE__ */ $acw62.createElement(PointsPriceBalloon, {
        iconUrl: pointsIconSrc,
        price: price
    })), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$a.name
    }, name2)));
};
const table = "ShopList-scss--module__table___cx4VN";
const content$1 = "ShopList-scss--module__content___rUEUe";
const footer = "ShopList-scss--module__footer___mnpKW";
const placeholder$1 = "ShopList-scss--module__placeholder___56dZU";
const list = "ShopList-scss--module__list___tkFTt";
const preview = "ShopList-scss--module__preview___eyCI4";
const spinner = "ShopList-scss--module__spinner___SBauO";
const s$9 = {
    table: table,
    content: content$1,
    footer: footer,
    placeholder: placeholder$1,
    list: list,
    preview: preview,
    spinner: spinner
};
const locales$5 = {
    rewards: "\u041D\u0430\u0433\u0440\u0430\u0434\u044B",
    noActiveRewards: "\u0423 \u0441\u0442\u0440\u0438\u043C\u0435\u0440\u0430 \u043D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043D\u0430\u0433\u0440\u0430\u0434",
    howToMake: "\u041A\u0430\u043A \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C"
};
const t$5 = distExports$1.getTranslation && locales$5;
const ShopList = (props)=>{
    const { rewardsData = [], pointData, loading = false, onClose = dist$4.noop, onSelect = dist$4.noop, onHowToMakeMoney = dist$4.noop } = props;
    const pointName = (0, $iD0SF.useSelector)(pointNameSelector);
    const { blogUrl } = useParams();
    const prevBlogUrl = usePrevious(blogUrl);
    const onRewardClick = (id)=>{
        onSelect(id);
    };
    const title2 = /* @__PURE__ */ $acw62.createElement("div", null, t$5.rewards);
    (0, $acw62.useEffect)(()=>{
        if (prevBlogUrl && blogUrl && prevBlogUrl !== blogUrl) onClose();
    }, [
        prevBlogUrl,
        blogUrl
    ]);
    return /* @__PURE__ */ $acw62.createElement(ShopWrapper, {
        title: title2,
        onClose: onClose
    }, loading && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.spinner
    }, /* @__PURE__ */ $acw62.createElement(Spinner, null)), !loading && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.table
    }, !rewardsData.length && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.placeholder
    }, t$5.noActiveRewards), Boolean(rewardsData.length) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.content
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.list
    }, rewardsData.map((reward2)=>{
        var _a3;
        return /* @__PURE__ */ $acw62.createElement(RewardPreviewSmall, {
            className: s$9.preview,
            key: reward2.id,
            name: reward2.name,
            isAffordable: ((_a3 = reward2.denyReason) == null ? void 0 : _a3.reason) !== ERewardDenyReasonType.NOT_ENOUGH_CHANNEL_POINTS,
            isAvailable: reward2.isAvailable,
            price: reward2.price,
            bgcolor: reward2.bgcolor,
            rewardIconSrc: reward2.largeUrl,
            pointsIconSrc: pointData == null ? void 0 : pointData.smallUrl,
            onClick: ()=>onRewardClick(reward2.id)
        });
    }))), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$9.footer,
        onClick: onHowToMakeMoney
    }, `${t$5.howToMake} ${pointName}`)));
};
const root$7 = "Shop-scss--module__root___PZrjF";
const s$8 = {
    root: root$7
};
const locales$4 = {
    activateRewardError: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
    fetchRewardByIdError: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
    loadingRewardListError: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u043F\u0438\u0441\u043A\u0430 \u043D\u0430\u0433\u0440\u0430\u0434"
};
const t$4 = distExports$1.getTranslation && locales$4;
const Shop = (props)=>{
    const { className, onClose } = props;
    const [selectedId, setSelectedId] = (0, $acw62.useState)(null);
    const [step, setStep] = (0, $acw62.useState)(EShopStep.REWARDS_LIST);
    const [loadinRewardList, setLoadinRewardList] = (0, $acw62.useState)(false);
    const { blogUrl } = useStreamIdentity();
    const dispatch = (0, $2OPjR.useDispatch)();
    const { showAlert } = useNotificationsContext();
    const rewards2 = (0, $iD0SF.useSelector)(rewardsSelector);
    const channelPoint2 = (0, $iD0SF.useSelector)(pointSelector);
    const selectedReward = (0, $iD0SF.useSelector)(getRewardByIdSelector(selectedId));
    const bonuses = (0, $iD0SF.useSelector)(pointBonusesSelector);
    const bonusMultipliers = (0, $iD0SF.useSelector)(pointBonusMultipliersSelector);
    const onHowToMakeMoney = ()=>{
        setStep(EShopStep.PRICE_LIST);
    };
    const handleRewardSelect = (id)=>{
        setStep(EShopStep.SELECTED_REWARD);
        dispatch((0, $7Uc0p.thunkToAction)(fetchRewardById.action)({
            blogUrl: blogUrl,
            id: id
        })).then(()=>{
            setSelectedId(id);
        }, ()=>{
            setStep(EShopStep.REWARDS_LIST);
            setSelectedId(null);
            showAlert({
                type: EAlertType.ERROR,
                text: t$4.fetchRewardByIdError
            });
        });
    };
    const handleRewardCardBack = ()=>{
        setStep(EShopStep.REWARDS_LIST);
        setSelectedId(null);
    };
    const handleActivate = async ()=>{
        if (selectedReward.isTextRequired) {
            dispatch(postponeReward(selectedReward));
            onClose();
            return;
        }
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(activateReward.action)({
                blogUrl: blogUrl,
                id: selectedReward.id
            }));
            onClose();
        } catch (err) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$4.activateRewardError
            });
        }
    };
    const handlePriceCardBack = ()=>{
        setStep(EShopStep.REWARDS_LIST);
    };
    const loadRewardsData = async ()=>{
        setLoadinRewardList(true);
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(fetchRewards.action)({
                blogUrl: blogUrl
            }));
        } catch (err) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$4.loadingRewardListError
            });
            onClose();
        } finally{
            setLoadinRewardList(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        loadRewardsData();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (step === EShopStep.PRICE_LIST) AppStat.log.chat.rewardPriceListShow();
    }, [
        step
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$8.root, className)
    }, /* @__PURE__ */ $acw62.createElement(Tooltip, {
        classNames: {
            root: s$8.tooltip
        }
    }, step === EShopStep.REWARDS_LIST && /* @__PURE__ */ $acw62.createElement(ShopList, {
        rewardsData: rewards2,
        pointData: channelPoint2,
        loading: loadinRewardList,
        onClose: onClose,
        onSelect: handleRewardSelect,
        onHowToMakeMoney: onHowToMakeMoney
    }), step === EShopStep.SELECTED_REWARD && /* @__PURE__ */ $acw62.createElement(RewardCard, {
        rewardData: selectedReward,
        pointData: channelPoint2,
        onClose: onClose,
        onBack: handleRewardCardBack,
        onActivate: handleActivate
    }), step === EShopStep.PRICE_LIST && /* @__PURE__ */ $acw62.createElement(PriceCard, {
        bonuses: bonuses,
        bonusMultipliers: bonusMultipliers,
        onBack: handlePriceCardBack,
        onClose: onClose
    })));
};
const useRefreshShopWS = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        WSClient.register({
            channel: EWSChannel.PRIVATE_STREAM,
            message: EWSPrivateStreamMessageType.CP_BALANCE_CHANGE,
            handler: (message2)=>{
                dispatch(updateChannelPointBalance(message2.data.data));
            }
        });
        WSClient.register({
            channel: EWSChannel.PRIVATE_STREAM,
            message: EWSPrivateStreamMessageType.CP_BONUS_PENDING,
            handler: (message2)=>{
                dispatch(updateChannelPointPendingBonus(message2.data.data));
            }
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.PRIVATE_STREAM,
                message: EWSPrivateStreamMessageType.CP_BALANCE_CHANGE
            });
            WSClient.unregister({
                channel: EWSChannel.PRIVATE_STREAM,
                message: EWSPrivateStreamMessageType.CP_BONUS_PENDING
            });
        };
    }, []);
};
const icon$3 = "ReasonIcon-scss--module__icon___JaYr3";
const s$7 = {
    icon: icon$3
};
const ReasonIcon = (props)=>{
    const { reason: reason2 } = props;
    switch(reason2 == null ? void 0 : reason2.type){
        case EChannelPointUpdaterReasonType.BONUS:
            const glyph = bonusTypeToIconMap[reason2.bonus.type];
            return glyph ? /* @__PURE__ */ $acw62.createElement(Icon, {
                glyph: glyph,
                className: s$7.icon
            }) : null;
        case EChannelPointUpdaterReasonType.REWARD:
            return /* @__PURE__ */ $acw62.createElement(RewardIcon, {
                src: reason2.reward.mediumUrl
            });
        default:
            return null;
    }
};
const root$6 = "PointUpdater-scss--module__root___pEowU";
const s$6 = {
    root: root$6
};
const PointUpdater = (props)=>{
    const rootRef = (0, $acw62.useRef)();
    const { updater: { delta, reason: reason2 }, onAnimationEnd } = props;
    const deltaSigned = isNumber(delta) ? `${delta > 0 ? "+" : ""} ${delta}` : "";
    (0, $acw62.useEffect)(()=>{
        const element = rootRef.current;
        if (!element) return void 0;
        const handleAnimationEnd = ()=>{
            onAnimationEnd();
        };
        element.addEventListener("animationend", handleAnimationEnd);
        return ()=>{
            element.removeEventListener("animationend", handleAnimationEnd);
        };
    }, [
        rootRef.current,
        onAnimationEnd
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        ref: rootRef,
        className: s$6.root
    }, /* @__PURE__ */ $acw62.createElement(ReasonIcon, {
        reason: reason2
    }), /* @__PURE__ */ $acw62.createElement("span", null, deltaSigned));
};
const root$5 = "PointActions-scss--module__root___HYa-s";
const points = "PointActions-scss--module__points___p1Qo1";
const buttonPoints = "PointActions-scss--module__buttonPoints___E49Nl";
const buttonBonus = "PointActions-scss--module__buttonBonus___Bzk4A";
const icon$2 = "PointActions-scss--module__icon___43OQc";
const pointsIcon = "PointActions-scss--module__pointsIcon___1ISEN";
const tooltip = "PointActions-scss--module__tooltip___HItw7";
const bonusIconWingle = "PointActions-scss--module__bonusIconWingle___uuGtq";
const s$5 = {
    root: root$5,
    points: points,
    buttonPoints: buttonPoints,
    buttonBonus: buttonBonus,
    icon: icon$2,
    pointsIcon: pointsIcon,
    tooltip: tooltip,
    bonusIconWingle: bonusIconWingle
};
const locales$3 = {
    bonus: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043D\u0443\u0441",
    gatherBonusError: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0431\u0430\u043B\u043B\u043E\u0432"
};
const t$3 = distExports$1.getTranslation && locales$3;
const PointActions = (props)=>{
    const { className, hasTooltip = true, onClick = dist$4.noop } = props;
    const [isNotificationShown, setIsNotificationShown] = (0, $acw62.useState)(false);
    const [isShowBonusButton, setIsShowBonusButton] = (0, $acw62.useState)(true);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { blogUrl } = useStreamIdentity();
    const { showAlert } = useNotificationsContext();
    const { name: pointName, balance } = (0, $iD0SF.useSelector)(pointSelector) || {};
    const pointUpdater = (0, $iD0SF.useSelector)(pointUpdaterSelector);
    const pointsIconUrl = (0, $iD0SF.useSelector)(pointSmallImageSelector);
    const blogIsOwner = (0, $iD0SF.useSelector)(blogIsOwnerSelector);
    const hasPendingBonus = (0, $iD0SF.useSelector)(hasPointPendingBonusSelector);
    const pendindBonus = (0, $iD0SF.useSelector)(pointPendingBonusSelector)[0];
    const convertedBalanceLabel = blogIsOwner ? /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$5.icon,
        glyph: svg_name_infinity
    }) : getShortNum(balance, {
        limit10KDisabled: true
    });
    const rawBalanceLabel = blogIsOwner ? /* @__PURE__ */ $acw62.createElement(Icon, {
        className: s$5.icon,
        glyph: svg_name_infinity
    }) : balance;
    const showBonusButton = isShowBonusButton && hasPendingBonus && !isNotificationShown;
    const onBonusClick = async (event2)=>{
        event2.stopPropagation();
        setIsShowBonusButton(false);
        try {
            await dispatch((0, $7Uc0p.thunkToAction)(gatherChannelPointPendingBonus.action)({
                blogUrl: blogUrl,
                id: pendindBonus.id
            }));
            dispatch(clearChannelPointPendingBonus());
        } catch (err) {
            showAlert({
                type: EAlertType.ERROR,
                text: t$3.gatherBonusError
            });
        } finally{
            setIsShowBonusButton(true);
        }
    };
    const onPointsClickHandler = ()=>{
        onClick();
    };
    useRefreshShopWS();
    const handleAnimationEnd = ()=>{
        setIsNotificationShown(false);
        dispatch(clearChannelPointUpdater());
    };
    (0, $acw62.useEffect)(()=>{
        const { reason: reason2 } = pointUpdater || {};
        if (!reason2) return;
        setIsNotificationShown(true);
        if (reason2.type === EChannelPointUpdaterReasonType.BONUS && reason2.bonus.type === EBonusType.STREAM_ACTIVE_VIEW) dispatch(clearChannelPointPendingBonus());
    }, [
        pointUpdater
    ]);
    const renderActionIcon = ()=>{
        if (showBonusButton) return /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            position: ETooltipPosition.BOTTOM_END,
            content: t$3.bonus
        }, /* @__PURE__ */ $acw62.createElement("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$5.buttonBonus, s$5.pulseAnimation),
            type: "button",
            onClick: onBonusClick
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: svg_name_bonus,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$5.icon, s$5.bonusIconWingle)
        })));
        return /* @__PURE__ */ $acw62.createElement(PointsIcon$1, {
            src: pointsIconUrl,
            className: s$5.pointsIcon
        });
    };
    const pointsButton = /* @__PURE__ */ $acw62.createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$5.buttonPoints, {
            [s$5.withChest]: showBonusButton
        }),
        onClick: onPointsClickHandler,
        type: "button"
    }, renderActionIcon(), /* @__PURE__ */ $acw62.createElement("span", null, convertedBalanceLabel));
    const shouldWrapPointsButton = hasTooltip && !showBonusButton;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$5.root, className)
    }, !isNotificationShown && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$5.points
    }, !shouldWrapPointsButton && pointsButton, shouldWrapPointsButton && /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        position: ETooltipPosition.BOTTOM_END,
        content: /* @__PURE__ */ $acw62.createElement("div", {
            className: s$5.tooltip
        }, rawBalanceLabel, " ", pointName)
    }, pointsButton)), isNotificationShown && /* @__PURE__ */ $acw62.createElement(PointUpdater, {
        updater: pointUpdater,
        onAnimationEnd: handleAnimationEnd
    })));
};
const root$4 = "StreamChatFooter-scss--module__root___h-PHZ";
const modal = "StreamChatFooter-scss--module__modal___4c2N-";
const s$4 = {
    root: root$4,
    modal: modal
};
const StreamChatFooter = ()=>{
    const { isAuthorized } = useCurrentUserAccess();
    const [isShopVisible, setIsShopVisible] = (0, $acw62.useState)(false);
    const [isDropsListVisible, setIsDropsListVisible] = (0, $acw62.useState)(false);
    const [isDropReceivedVisible, setIsDropReceivedVisible] = (0, $acw62.useState)(false);
    const isDropInstructionVisible = (0, $iD0SF.useSelector)(streamChatIsDropInstructionSelector);
    const isPointsEnabled = (0, $iD0SF.useSelector)(pointIsEnabledSelector);
    const isDropsEnabled = isConditionalFeatureEnable(EConditionalFeature.DROP_CAMPAIGNS);
    const dispatch = (0, $2OPjR.useDispatch)();
    const hasPoints = isAuthorized && isPointsEnabled;
    const hasDrops = isAuthorized && isDropsEnabled;
    const closeDropInstruction = ()=>{
        dispatch(toggleVisibilityDropInstruction(false));
    };
    const handleDropReceivedClose = ()=>{
        setIsDropReceivedVisible(false);
    };
    const handlePointsClick = ()=>{
        setIsDropsListVisible(false);
        setIsDropReceivedVisible(false);
        dispatch(clearDropRewardsToShow({}));
        setIsShopVisible(!isShopVisible);
    };
    const handleShopClose = ()=>{
        setIsShopVisible(false);
    };
    const handleDropsListClose = ()=>{
        setIsDropsListVisible(false);
    };
    const handleDropInstructionClose = ()=>{
        closeDropInstruction();
    };
    const handleDropInstructionBack = ()=>{
        closeDropInstruction();
        setIsDropsListVisible(true);
    };
    const handleDropsInstructionOpen = ()=>{
        if (!isDropInstructionVisible) dispatch(toggleVisibilityDropInstruction(true));
        setIsDropsListVisible(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (isDropInstructionVisible) handleDropsInstructionOpen();
    }, [
        isDropInstructionVisible
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch(clearChannelPointUpdater());
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isShopVisible) AppStat.log.chat.rewardShopShow();
    }, [
        isShopVisible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDropsListVisible) AppStat.log.chat.dropsShow();
    }, [
        isDropsListVisible
    ]);
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$4.root
    }, hasPoints && /* @__PURE__ */ $acw62.createElement(PointActions, {
        onClick: handlePointsClick
    }), hasDrops && /* @__PURE__ */ $acw62.createElement(DropView, {
        isDropPopupOpen: isDropsListVisible || isDropReceivedVisible,
        setDropListVisibility: setIsDropsListVisible,
        setDropReceivedVisibility: setIsDropReceivedVisible
    }), isShopVisible && /* @__PURE__ */ $acw62.createElement(Shop, {
        className: s$4.modal,
        onClose: handleShopClose
    }), isDropsListVisible && /* @__PURE__ */ $acw62.createElement(DropsList, {
        className: s$4.modal,
        onClose: handleDropsListClose,
        setDropReceivedVisibility: setIsDropReceivedVisible,
        setDropInstructionVisibility: handleDropsInstructionOpen
    }), isDropInstructionVisible && /* @__PURE__ */ $acw62.createElement(DropInstruction, {
        className: s$4.modal,
        onClose: handleDropInstructionClose,
        onBack: handleDropInstructionBack
    }), isDropReceivedVisible && /* @__PURE__ */ $acw62.createElement(DropReceived, {
        className: s$4.modal,
        onClose: handleDropReceivedClose,
        setDropListVisibility: setIsDropsListVisible
    }));
};
const root$3 = "ModeSelector-scss--module__root___XW3pQ";
const content = "ModeSelector-scss--module__content___kZS0D";
const icon$1 = "ModeSelector-scss--module__icon___USKgf";
const button$1 = "ModeSelector-scss--module__button___ptb61";
const point = "ModeSelector-scss--module__point___A-DVT";
const tooltipRoot = "ModeSelector-scss--module__tooltipRoot___oImpV";
const active = "ModeSelector-scss--module__active___c5hoQ";
const s$3 = {
    root: root$3,
    content: content,
    icon: icon$1,
    button: button$1,
    point: point,
    tooltipRoot: tooltipRoot,
    active: active
};
const locales$2 = {
    chat: "\u0427\u0430\u0442 \u0442\u0440\u0430\u043D\u0441\u043B\u044F\u0446\u0438\u0438",
    mentions: "\u0423\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F",
    users: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
    playlist: "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"
};
const t$2 = distExports$1.getTranslation && locales$2;
const getControls = (enabledModes)=>[
        {
            mode: EChatMode.PLAYLIST,
            icon: svg_name_playlist,
            tooltipText: t$2.playlist
        },
        {
            mode: EChatMode.CHAT,
            icon: svg_name_messages_outline_20,
            tooltipText: t$2.chat
        },
        {
            mode: EChatMode.MENTIONS,
            isEnabled: isConditionalFeatureEnable(EConditionalFeature.CHAT_MENTIONS),
            icon: svg_name_mention_outline_24,
            tooltipText: t$2.mentions
        },
        {
            mode: EChatMode.USERS,
            isEnabled: isConditionalFeatureEnable(EConditionalFeature.CHAT_USERS_LIST),
            icon: svg_name_users_outline_20,
            tooltipText: t$2.users
        }
    ].filter(({ isEnabled, mode: mode2 })=>(isEnabled === void 0 || isEnabled) && enabledModes.includes(mode2));
const ModeSelector = (props)=>{
    const { activeMode, hasNewMentions, enabledModes, onClick } = props;
    const handleClick = (mode2)=>{
        onClick(mode2);
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$3.root
    }, getControls(enabledModes).map(({ mode: mode2, icon: icon2, tooltipText })=>/* @__PURE__ */ $acw62.createElement(TooltipFloating, {
            key: mode2,
            position: ETooltipPosition.BOTTOM,
            content: tooltipText,
            classNames: {
                root: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3.tooltipRoot, {
                    [s$3.active]: activeMode === mode2
                }),
                contentWrapper: s$3.content
            }
        }, /* @__PURE__ */ $acw62.createElement("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$3.button, {
                [s$3.point]: hasNewMentions && mode2 === EChatMode.MENTIONS
            }),
            onClick: ()=>handleClick(mode2),
            type: "button"
        }, /* @__PURE__ */ $acw62.createElement(Icon, {
            glyph: icon2,
            className: s$3.icon
        })))));
};
const root$2 = "StreamChatTopPanel-scss--module__root___FMiDv";
const placeholder = "StreamChatTopPanel-scss--module__placeholder___owpQj";
const icon = "StreamChatTopPanel-scss--module__icon___qpx8M";
const button = "StreamChatTopPanel-scss--module__button___3ZoyB";
const controls = "StreamChatTopPanel-scss--module__controls___INj9J";
const pinnedBlock = "StreamChatTopPanel-scss--module__pinnedBlock___UxhHh";
const count = "StreamChatTopPanel-scss--module__count___tUHkG";
const s$2 = {
    root: root$2,
    placeholder: placeholder,
    icon: icon,
    button: button,
    controls: controls,
    pinnedBlock: pinnedBlock,
    count: count
};
const locales$1 = {
    hideAll: "\u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435 \u0431\u0430\u043D\u043D\u0435\u0440\u044B",
    showPinned: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u0440\u044B\u0442\u044B\u0435 \u0431\u0430\u043D\u043D\u0435\u0440\u044B",
    hideTheRest: "\u0421\u043A\u0440\u044B\u0442\u044C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u0430\u043D\u043D\u0435\u0440\u044B"
};
const t$1 = distExports$1.getTranslation && locales$1;
const ENABLED_CHAT_MODES = [
    EChatMode.CHAT,
    EChatMode.MENTIONS,
    EChatMode.USERS
];
const StreamChatTopPanel = (props)=>{
    const { leftPanel, chatMode, hasNewMentions, onModeSelectorClick } = props;
    const dispatch = (0, $2OPjR.useDispatch)();
    const streamerId = (0, $iD0SF.useSelector)(streamerIdSelector);
    const { pinnedMessageId, predictionId, channelPollData, pinnedHiddenItemsCount, totalCountBanners, isAllBannersHidden, shouldShowRaidNotification } = useChatPinnedList({
        streamUserId: streamerId
    });
    const pinnedBlockText = isAllBannersHidden ? t$1.showPinned : pinnedHiddenItemsCount === 0 ? t$1.hideAll : t$1.hideTheRest;
    const icon2 = isAllBannersHidden ? svg_name_pin_outline_20 : svg_name_pin_slash_outline_20;
    const { shouldShow: shouldShowPrediction } = usePredictionBox();
    (0, $acw62.useEffect)(()=>{
        if (shouldShowPrediction || pinnedMessageId || shouldShowRaidNotification) dispatch(clearStreamBlocksPinnedHidden());
    }, [
        shouldShowPrediction,
        pinnedMessageId,
        shouldShowRaidNotification
    ]);
    const handlePinnedClick = ()=>{
        if (isAllBannersHidden) dispatch(clearStreamBlocksPinnedHidden());
        else {
            const hiddenItems = [
                ...pinnedMessageId ? [
                    `${EPinnedItem.MESSAGE}:${pinnedMessageId}`
                ] : [],
                ...predictionId ? [
                    EPinnedItem.PREDICTION
                ] : [],
                ...(channelPollData == null ? void 0 : channelPollData.id) ? [
                    EPinnedItem.CHANNEL_POLL
                ] : []
            ];
            dispatch(setStreamBlocksPinnedHidden(hiddenItems));
        }
    };
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2.root
    }, leftPanel || /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2.placeholder
    }), /* @__PURE__ */ $acw62.createElement(ModeSelector, {
        activeMode: chatMode,
        hasNewMentions: hasNewMentions,
        enabledModes: ENABLED_CHAT_MODES,
        onClick: onModeSelectorClick
    }), /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2.controls
    }, Boolean(totalCountBanners) && /* @__PURE__ */ $acw62.createElement(TooltipFloating, {
        position: ETooltipPosition.BOTTOM_END,
        content: pinnedBlockText
    }, /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2.pinnedBlock
    }, /* @__PURE__ */ $acw62.createElement("button", {
        className: s$2.button,
        onClick: handlePinnedClick,
        type: "button"
    }, /* @__PURE__ */ $acw62.createElement(Icon, {
        glyph: icon2,
        className: s$2.icon
    })), Boolean(pinnedHiddenItemsCount) && /* @__PURE__ */ $acw62.createElement("div", {
        className: s$2.count
    }, pinnedHiddenItemsCount)))));
};
const useChannelStreamChatToggler = ()=>{
    const { blogUrl, slotUrl } = useStreamIdentity();
    const { streamerId } = (0, $iD0SF.useSelector)(streamStaticFieldsSelector);
    const { chatMode, externalReplyTarget, hasNewMentions, onReplyTarget, setChatMode } = useChatMode();
    const shouldShow = {
        chat: chatMode === EChatMode.CHAT || chatMode === EChatMode.MENTIONS,
        chatUsers: chatMode === EChatMode.USERS
    };
    return {
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        chatMode: chatMode,
        externalReplyTarget: externalReplyTarget,
        hasNewMentions: hasNewMentions,
        shouldShow: shouldShow,
        streamerId: streamerId,
        onReplyTarget: onReplyTarget,
        setChatMode: setChatMode
    };
};
const onBanChatUsers = (store2)=>{
    WSClient.register({
        channel: EWSChannel.CHAT,
        message: EWSChatMessageType.CHAT_BAN,
        handler: ({ data: { isTemporary, isPermanent, isByStream, expireTime, bannedUser } })=>{
            if (isTemporary || isByStream && expireTime === 0) {
                store2.dispatch(updateStreamChatTemporaryBannedUsersFromWS({
                    expireTime: expireTime,
                    ...bannedUser,
                    byStream: isByStream
                }));
                store2.dispatch(addChannelTemporaryBanFromWS({
                    expireTime: expireTime,
                    ...bannedUser,
                    byStream: isByStream
                }));
            }
            if (isPermanent) {
                store2.dispatch(updateStreamChatPermanentBannedUsersFromWS(bannedUser));
                store2.dispatch(addChannelPermanentBanFromWS(bannedUser));
            }
        }
    });
};
const useChatWs = ()=>{
    const store2 = (0, $4TSkt.useStore)();
    const { isViewAllowed } = (0, $iD0SF.useSelector)(streamStaticFieldsSelector);
    const { wsChatChannel, wsChatChannelPrivate, wsLimitedChatChannel, wsLimitedChatChannelPrivate, wsLimitedChatChannelToken, wsLimitedChatChannelPrivateToken } = (0, $iD0SF.useSelector)(streamWsChannelsSelector);
    const subscriptionLevel = (0, $iD0SF.useSelector)(streamSubscriptionLevelFieldSelector);
    const isLimitedAccessAllowed = Boolean(subscriptionLevel) && isViewAllowed;
    (0, $acw62.useEffect)(()=>{
        const unregisterActions = [
            onChatMessage(store2),
            onChatMessageRemoveFromWS(store2),
            onChatPinnedMessage(store2),
            onChatClean(store2),
            onBanChatUsers(store2)
        ];
        return ()=>{
            unregisterActions.forEach((unregister)=>unregister == null ? void 0 : unregister());
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const chatChannels = [
            wsChatChannel && {
                type: EWSChannel.CHAT,
                channel: wsChatChannel
            },
            wsChatChannelPrivate && {
                type: EWSChannel.PRIVATE,
                channel: wsChatChannelPrivate
            }
        ].filter(Boolean);
        WSClient.subscribe(chatChannels);
        return ()=>{
            WSClient.unsubscribe(EWSChannel.CHAT);
            WSClient.unsubscribe(EWSChannel.PRIVATE);
        };
    }, [
        wsChatChannel,
        wsChatChannelPrivate
    ]);
    (0, $acw62.useEffect)(()=>{
        const limitedChatChannels = [
            wsLimitedChatChannel && wsLimitedChatChannelToken && {
                type: EWSChannel.CHAT,
                channel: wsLimitedChatChannel,
                token: wsLimitedChatChannelToken
            },
            wsLimitedChatChannelPrivate && wsLimitedChatChannelPrivateToken && {
                type: EWSChannel.PRIVATE,
                channel: wsLimitedChatChannelPrivate,
                token: wsLimitedChatChannelPrivateToken
            }
        ].filter(Boolean);
        if (isLimitedAccessAllowed) WSClient.subscribe(limitedChatChannels, {
            isPrivate: true,
            useBatching: true
        });
        return ()=>{
            if (isLimitedAccessAllowed) {
                WSClient.unsubscribe(EWSChannel.CHAT);
                WSClient.unsubscribe(EWSChannel.PRIVATE);
            }
        };
    }, [
        isLimitedAccessAllowed,
        wsLimitedChatChannel,
        wsLimitedChatChannelPrivate
    ]);
};
const useWebSocket = ()=>{
    const { websocket: { isEnabled: isWebsocketEnabled } } = getConfig();
    const { wsStreamChannel, wsStreamViewersChannel } = (0, $iD0SF.useSelector)(streamWsChannelsSelector);
    const dispatch = (0, $2OPjR.useDispatch)();
    const websocketToken = (0, $iD0SF.useSelector)(webSocketTokenSelector);
    const prevWebsocketToken = usePrevious(websocketToken);
    const { isAuthorized } = useCurrentUserAccess();
    const prevIsAuthorized = usePrevious(isAuthorized);
    (0, $acw62.useEffect)(()=>{
        if (prevIsAuthorized !== isAuthorized) fetchWSToken();
    }, [
        prevIsAuthorized,
        isAuthorized
    ]);
    (0, $acw62.useEffect)(()=>{
        if (websocketToken && prevWebsocketToken !== websocketToken) {
            disconnectWebSocket();
            connectWebSocket();
        }
    }, [
        prevWebsocketToken,
        websocketToken
    ]);
    (0, $acw62.useEffect)(()=>{
        const channels = [
            wsStreamChannel && {
                type: EWSChannel.STREAM,
                channel: wsStreamChannel
            },
            wsStreamViewersChannel && {
                type: EWSChannel.VIEWERS,
                channel: wsStreamViewersChannel
            }
        ].filter(Boolean);
        WSClient.subscribe(channels, {
            useBatching: true
        });
        return ()=>{
            if (wsStreamChannel) WSClient.unsubscribe(EWSChannel.STREAM);
            if (wsStreamViewersChannel) WSClient.unsubscribe(EWSChannel.VIEWERS);
        };
    }, [
        wsStreamChannel,
        wsStreamViewersChannel,
        websocketToken
    ]);
    const fetchWSToken = ()=>{
        dispatch((0, $7Uc0p.thunkToAction)(fetchWebSocketToken.action)());
    };
    const connectWebSocket = ()=>{
        if (isWebsocketEnabled) WSClient.setToken(websocketToken).connect();
    };
    const disconnectWebSocket = ()=>{
        if (isWebsocketEnabled) WSClient.disconnect();
    };
};
const CHAT_MESSAGE_LIMIT = 200;
const useChat = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const stream2 = (0, $iD0SF.useSelector)(streamSelector);
    const streamNetworkStatus = (0, $iD0SF.useSelector)(streamNetworkStatusSelector);
    const isAuthorized = (0, $iD0SF.useSelector)(currentUserIsAuthorizedSelector);
    const { blogUrl, slotUrl } = useStreamIdentity();
    const streamerId = (0, $iD0SF.useSelector)(streamerIdSelector);
    useChatWs();
    useRewardShopOnPage(blogUrl, isAuthorized);
    (0, $acw62.useEffect)(()=>{
        dispatch(clearStreamChat());
        dispatch(cleanStreamChatMessagesFromWS());
        dispatch((0, $7Uc0p.thunkToAction)(fetchStreamChat.action)({
            blogUrl: blogUrl,
            limit: CHAT_MESSAGE_LIMIT
        }));
        if (!streamNetworkStatus.isFetching && !streamNetworkStatus.isFetched) dispatch((0, $7Uc0p.thunkToAction)(fetchStream.action)({
            blogUrl: blogUrl
        }));
    }, [
        blogUrl,
        streamNetworkStatus.isFetching,
        streamNetworkStatus.isFetched
    ]);
    return {
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        streamerId: streamerId,
        hasStream: Boolean(stream2),
        isAuthorized: isAuthorized
    };
};
const root$1 = "Chat-scss--module__root___KcM2G";
const chat = "Chat-scss--module__chat___Xy3xG";
const s$1 = {
    root: root$1,
    chat: chat
};
const Chat = $acw62.memo((props)=>{
    const { withTabs = true, withFooter = true } = props || {};
    const { blogUrl, slotUrl, hasStream, streamerId } = useChat();
    const { chatMode, hasNewMentions, shouldShow, setChatMode } = useChannelStreamChatToggler();
    if (!hasStream) return null;
    return /* @__PURE__ */ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s$1.root, "desktop")
    }, withTabs && /* @__PURE__ */ $acw62.createElement(StreamChatTopPanel, {
        chatMode: chatMode,
        hasNewMentions: hasNewMentions,
        isNewWindowButtonVisible: true,
        onModeSelectorClick: setChatMode
    }), shouldShow.chat && /* @__PURE__ */ $acw62.createElement(Chat$1, {
        classNames: withTabs ? {
            root: s$1.chat
        } : {},
        slotUrl: slotUrl,
        blogUrl: blogUrl,
        streamUserId: streamerId,
        isSettings: withFooter,
        footerNode: withFooter ? /* @__PURE__ */ $acw62.createElement(StreamChatFooter, null) : null,
        isSmileInfoAbsolute: true,
        isOnlyMentionsMode: chatMode === EChatMode.MENTIONS
    }), shouldShow.chatUsers && /* @__PURE__ */ $acw62.createElement(ChatUsers, {
        blogUrl: blogUrl,
        slotUrl: slotUrl,
        onReplyTarget: ()=>{}
    }));
});
const useLike = (channelUrl, slotUrl)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const stream2 = (0, $iD0SF.useSelector)(streamSelector);
    (0, $acw62.useEffect)(()=>{
        const like = SdkEventEmitter.addListener(ESdkControlsEvents.LIKE, handleLike);
        return ()=>{
            like.remove();
        };
    }, [
        stream2,
        channelUrl
    ]);
    const handleLike = ()=>{
        if (stream2 == null ? void 0 : stream2.isLiked) {
            dispatch((0, $7Uc0p.thunkToAction)(unlikeStream.action)({
                blogUrl: channelUrl,
                slotUrl: slotUrl
            }));
            return;
        }
        dispatch((0, $7Uc0p.thunkToAction)(likeStream.action)({
            blogUrl: channelUrl,
            slotUrl: slotUrl
        }));
    };
};
const useLikesCount = ()=>{
    (0, $acw62.useEffect)(()=>{
        const handler2 = ({ data: { counter: counter2 } })=>{
            SdkEventEmitter.emit(ESdkControlsEvents.LIKES_COUNT, counter2);
        };
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_LIKE_COUNTER,
            handler: handler2
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_LIKE_COUNTER,
                handler: handler2
            });
        };
    }, []);
};
const useViewersCount = ()=>{
    (0, $acw62.useEffect)(()=>{
        const handler2 = ({ data: { viewers: viewers2 } })=>{
            SdkEventEmitter.emit(ESdkControlsEvents.VIEWERS_COUNT, viewers2);
        };
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_ONLINE_STATUS,
            handler: handler2
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_ONLINE_STATUS,
                handler: handler2
            });
        };
    }, []);
};
const useStreamInfoUpdate = ()=>{
    const stream2 = (0, $iD0SF.useSelector)(streamSelector);
    const blog2 = (0, $iD0SF.useSelector)(blogSelector);
    const currentUser2 = (0, $iD0SF.useSelector)(currentUserSelector);
    (0, $acw62.useEffect)(()=>{
        SdkEventEmitter.emit(ESdkControlsEvents.AUTHORIZED_STATUS_UPDATE, Boolean(currentUser2));
        if (!stream2 || !blog2) return;
        SdkEventEmitter.emit(ESdkControlsEvents.STREAM_TITLE_UPDATE, stream2.title);
        SdkEventEmitter.emit(ESdkControlsEvents.STREAM_CATEGORY_UPDATE, {
            id: stream2.category.id,
            title: stream2.category.title
        });
        SdkEventEmitter.emit(ESdkControlsEvents.STREAM_INFO_UPDATE, {
            nickname: stream2.user.nick,
            description: blog2.description,
            avatar: stream2.user.avatarUrl
        });
        SdkEventEmitter.emit(ESdkControlsEvents.STREAM_SUBSCRIBERS_UPDATE, blog2.count.subscribers);
        SdkEventEmitter.emit(ESdkControlsEvents.STREAM_DATE_UPDATE, {
            endTime: stream2.endTime,
            text: getLastStreamText(stream2.endTime)
        });
        SdkEventEmitter.emit(ESdkControlsEvents.LIKES_COUNT, stream2.count.likes);
        SdkEventEmitter.emit(ESdkControlsEvents.VIEWERS_COUNT, stream2.count.viewers);
    }, [
        stream2,
        blog2,
        currentUser2
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler2 = ({ data: { data: { stream: { title: title2, category: category2 } } } })=>{
            SdkEventEmitter.emit(ESdkControlsEvents.STREAM_TITLE_UPDATE, title2);
            SdkEventEmitter.emit(ESdkControlsEvents.STREAM_CATEGORY_UPDATE, {
                id: category2.id,
                title: category2.title
            });
        };
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_INFO_UPDATE,
            handler: handler2
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_INFO_UPDATE,
                handler: handler2
            });
        };
    });
};
const useVideoActions = (channelUrl)=>{
    const stream2 = (0, $iD0SF.useSelector)(streamSelector);
    const position2 = (0, $acw62.useRef)(null);
    const getBlogUrlRef = (0, $acw62.useRef)(()=>channelUrl);
    const { startSendingHeartbeats, stopSendingHeartbeats } = useStreamStats({
        data: {
            blogUrl: channelUrl,
            streamId: stream2 == null ? void 0 : stream2.id
        }
    });
    const { savePlaybackPosition: savePlaybackPosition2, startAutoSavingPlaybackPosition, stopAutoSavingPlaybackPosition } = usePlaybackPosition({
        unitedVideoId: null,
        getPosition: ()=>position2.current,
        getUnitedVideoId: ()=>null
    });
    const handleStart = ()=>{
        startSendingHeartbeats();
        startAutoSavingPlaybackPosition();
    };
    const handlePlay = ()=>{
        startSendingHeartbeats();
        startAutoSavingPlaybackPosition();
    };
    const handleSeek = (timeCode)=>{
        setPosition(timeCode);
        startSendingHeartbeats();
        stopAutoSavingPlaybackPosition();
        savePlaybackPosition2();
        startAutoSavingPlaybackPosition();
    };
    const handlePause = (timeCode)=>{
        setPosition(timeCode);
        stopSendingHeartbeats();
        stopAutoSavingPlaybackPosition();
        savePlaybackPosition2();
    };
    const handleEnd = (timeCode)=>{
        setPosition(timeCode);
        stopSendingHeartbeats();
        stopAutoSavingPlaybackPosition();
        savePlaybackPosition2();
    };
    const setPosition = (timeCode)=>{
        if (timeCode) position2.current = timeCode;
    };
    (0, $acw62.useEffect)(()=>{
        getBlogUrlRef.current = ()=>channelUrl;
    }, [
        channelUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        const startVideo = SdkEventEmitter.addListener(ESdkControlsEvents.START_VIDEO, handleStart);
        const playVideo = SdkEventEmitter.addListener(ESdkControlsEvents.PLAY_VIDEO, handlePlay);
        const seekVideo = SdkEventEmitter.addListener(ESdkControlsEvents.SEEK_VIDEO, ({ timeCode })=>handleSeek(timeCode));
        const pauseVideo = SdkEventEmitter.addListener(ESdkControlsEvents.PAUSE_VIDEO, ({ timeCode })=>handlePause(timeCode));
        const endVideo = SdkEventEmitter.addListener(ESdkControlsEvents.END_VIDEO, ({ timeCode })=>handleEnd(timeCode));
        return ()=>{
            startVideo.remove();
            playVideo.remove();
            seekVideo.remove();
            pauseVideo.remove();
            endVideo.remove();
        };
    }, [
        stream2,
        channelUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        const handlerStart = ()=>{
            SdkEventEmitter.emit(ESdkControlsEvents.START_VIDEO);
        };
        const handlerEnd = ()=>{
            SdkEventEmitter.emit(ESdkControlsEvents.END_VIDEO);
        };
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_START,
            handler: handlerStart
        });
        WSClient.register({
            channel: EWSChannel.STREAM,
            message: EWSStreamMessageType.STREAM_END,
            handler: handlerEnd
        });
        return ()=>{
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_START,
                handler: handlerStart
            });
            WSClient.unregister({
                channel: EWSChannel.STREAM,
                message: EWSStreamMessageType.STREAM_END,
                handler: handlerEnd
            });
        };
    }, []);
};
const useChannelUrlUpdate = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        const channelUrl = SdkEventEmitter.addListener(ESdkControlsEvents.CHANNEL_URL_UPDATE, (channelUrl2)=>{
            dispatch(setGlobalBlogUrl({
                blogUrl: channelUrl2
            }));
        });
        return ()=>{
            channelUrl.remove();
        };
    }, []);
};
const locales = {
    system: "C\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F",
    light: "\u0421\u0432\u0435\u0442\u043B\u0430\u044F",
    dark: "\u0422\u0435\u043C\u043D\u0430\u044F"
};
const t = distExports$1.getTranslation && locales;
const themes = [
    {
        name: EUITheme.LIGHT,
        getText: ()=>t.light
    },
    {
        name: EUITheme.DARK,
        getText: ()=>t.dark
    },
    {
        name: EUITheme.SYSTEM,
        getText: ()=>t.system
    }
];
const useThemeSwitcher = ()=>{
    const { theme: selectedTheme, setTheme } = useThemeContext();
    const theme = themes.find((item2)=>item2.name === selectedTheme);
    const onSelect = (selected2)=>{
        setTheme(selected2.name);
    };
    return {
        theme: theme,
        onSelect: onSelect
    };
};
const useThemes = ()=>{
    const { theme, onSelect } = useThemeSwitcher();
    (0, $acw62.useEffect)(()=>{
        SdkEventEmitter.addListener(ESdkControlsEvents.SET_THEME, (newTheme)=>{
            onSelect(themes.find((e2)=>e2.name === newTheme));
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        SdkEventEmitter.emit(ESdkControlsEvents.THEME_UPDATED, theme);
    }, [
        theme
    ]);
};
const SdkControls = ()=>{
    const { blogUrl: channelUrl, slotUrl } = useStreamIdentity();
    useChannelUrlUpdate();
    useLikesCount();
    useViewersCount();
    useStreamInfoUpdate();
    useLike(channelUrl, slotUrl);
    useVideoActions(channelUrl);
    useThemes();
    return null;
};
const Portal = ({ container: container2, children: children2 })=>{
    if (typeof container2 === "string") container2 = document.querySelector(container2);
    if (!container2) return;
    return (0, $1u0KT.createPortal)(children2, container2);
};
const root = "App-scss--module__root___iJz7O";
const s = {
    root: root
};
registerWsActions(store);
const renderCache = {};
let renderItem = (key, container2, props)=>{
    renderCache[key] = {
        container: container2,
        props: props
    };
};
let getCurrentUser = ()=>{};
const renderChat = (container2, props)=>renderItem(EContainers.chat, container2, props);
const setAuth = (data)=>{
    setAuthTokenData(data);
    getCurrentUser();
    setAppId(data == null ? void 0 : data.appId);
};
const setAuthBySilentToken = async (data)=>{
    try {
        const resp = await Api$1.user.fetchVKIDToken({
            silentToken: data.silentToken,
            deviceId: data.deviceId,
            deviceOS: data.deviceOS,
            uuid: data.uuid,
            allowedActorStatus: [
                EAllowedActorStatus.EXISTING_ACCOUNT
            ]
        });
        setAuth({
            accessToken: resp.access_token,
            refreshToken: resp.refresh_token,
            expiresAt: resp.expires_in,
            appId: data.appId
        });
    } catch (error2) {
        console.log("Error:", error2);
    }
};
const setOnTokenRefreshError = (callback)=>{
    setRefreshTokenCallback(callback);
};
const setOnAuthorize = (callback)=>{};
const App = ()=>{
    const [containersKeys, setContainersKeys] = (0, $acw62.useState)({});
    const dispatch = (0, $2OPjR.useDispatch)();
    const { blogUrl, slotUrl } = useStreamIdentity();
    useWebSocket();
    (0, $acw62.useEffect)(()=>{
        if (blogUrl) {
            dispatch((0, $7Uc0p.thunkToAction)(fetchStream.action)({
                blogUrl: blogUrl,
                slotUrl: slotUrl
            }));
            dispatch((0, $7Uc0p.thunkToAction)(fetchBlog.action)({
                blogUrl: blogUrl
            }));
        }
    }, [
        blogUrl,
        slotUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        renderItem = (key, container2, props)=>{
            setContainersKeys((value2)=>({
                    ...value2,
                    [key]: {
                        container: container2,
                        props: props
                    }
                }));
        };
        Object.entries(renderCache).forEach(([key, { container: container2, props }])=>renderItem(key, container2, props));
    }, []);
    (0, $acw62.useEffect)(()=>{
        getCurrentUser = async ()=>{
            try {
                const response = await Api$1.user.fetchCurrent();
                dispatch(setCurrentUser.action({
                    user: response.data
                }));
            } catch (error2) {
                console.log(error2);
            }
        };
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SdkControls, null), Boolean(containersKeys[EContainers.chat]) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Portal, {
        container: containersKeys[EContainers.chat].container
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s.root, "live")
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Chat, {
        ...containersKeys[EContainers.chat].props
    }))));
};
var Buffer = (0, (/*@__PURE__*/$parcel$interopDefault($6ZWSX))).Buffer;
var CRC_TABLE = [
    0,
    1996959894,
    3993919788,
    2567524794,
    124634137,
    1886057615,
    3915621685,
    2657392035,
    249268274,
    2044508324,
    3772115230,
    2547177864,
    162941995,
    2125561021,
    3887607047,
    2428444049,
    498536548,
    1789927666,
    4089016648,
    2227061214,
    450548861,
    1843258603,
    4107580753,
    2211677639,
    325883990,
    1684777152,
    4251122042,
    2321926636,
    335633487,
    1661365465,
    4195302755,
    2366115317,
    997073096,
    1281953886,
    3579855332,
    2724688242,
    1006888145,
    1258607687,
    3524101629,
    2768942443,
    901097722,
    1119000684,
    3686517206,
    2898065728,
    853044451,
    1172266101,
    3705015759,
    2882616665,
    651767980,
    1373503546,
    3369554304,
    3218104598,
    565507253,
    1454621731,
    3485111705,
    3099436303,
    671266974,
    1594198024,
    3322730930,
    2970347812,
    795835527,
    1483230225,
    3244367275,
    3060149565,
    1994146192,
    31158534,
    2563907772,
    4023717930,
    1907459465,
    112637215,
    2680153253,
    3904427059,
    2013776290,
    251722036,
    2517215374,
    3775830040,
    2137656763,
    141376813,
    2439277719,
    3865271297,
    1802195444,
    476864866,
    2238001368,
    4066508878,
    1812370925,
    453092731,
    2181625025,
    4111451223,
    1706088902,
    314042704,
    2344532202,
    4240017532,
    1658658271,
    366619977,
    2362670323,
    4224994405,
    1303535960,
    984961486,
    2747007092,
    3569037538,
    1256170817,
    1037604311,
    2765210733,
    3554079995,
    1131014506,
    879679996,
    2909243462,
    3663771856,
    1141124467,
    855842277,
    2852801631,
    3708648649,
    1342533948,
    654459306,
    3188396048,
    3373015174,
    1466479909,
    544179635,
    3110523913,
    3462522015,
    1591671054,
    702138776,
    2966460450,
    3352799412,
    1504918807,
    783551873,
    3082640443,
    3233442989,
    3988292384,
    2596254646,
    62317068,
    1957810842,
    3939845945,
    2647816111,
    81470997,
    1943803523,
    3814918930,
    2489596804,
    225274430,
    2053790376,
    3826175755,
    2466906013,
    167816743,
    2097651377,
    4027552580,
    2265490386,
    503444072,
    1762050814,
    4150417245,
    2154129355,
    426522225,
    1852507879,
    4275313526,
    2312317920,
    282753626,
    1742555852,
    4189708143,
    2394877945,
    397917763,
    1622183637,
    3604390888,
    2714866558,
    953729732,
    1340076626,
    3518719985,
    2797360999,
    1068828381,
    1219638859,
    3624741850,
    2936675148,
    906185462,
    1090812512,
    3747672003,
    2825379669,
    829329135,
    1181335161,
    3412177804,
    3160834842,
    628085408,
    1382605366,
    3423369109,
    3138078467,
    570562233,
    1426400815,
    3317316542,
    2998733608,
    733239954,
    1555261956,
    3268935591,
    3050360625,
    752459403,
    1541320221,
    2607071920,
    3965973030,
    1969922972,
    40735498,
    2617837225,
    3943577151,
    1913087877,
    83908371,
    2512341634,
    3803740692,
    2075208622,
    213261112,
    2463272603,
    3855990285,
    2094854071,
    198958881,
    2262029012,
    4057260610,
    1759359992,
    534414190,
    2176718541,
    4139329115,
    1873836001,
    414664567,
    2282248934,
    4279200368,
    1711684554,
    285281116,
    2405801727,
    4167216745,
    1634467795,
    376229701,
    2685067896,
    3608007406,
    1308918612,
    956543938,
    2808555105,
    3495958263,
    1231636301,
    1047427035,
    2932959818,
    3654703836,
    1088359270,
    936918e3,
    2847714899,
    3736837829,
    1202900863,
    817233897,
    3183342108,
    3401237130,
    1404277552,
    615818150,
    3134207493,
    3453421203,
    1423857449,
    601450431,
    3009837614,
    3294710456,
    1567103746,
    711928724,
    3020668471,
    3272380065,
    1510334235,
    755167117
];
if (typeof Int32Array !== "undefined") CRC_TABLE = new Int32Array(CRC_TABLE);
function ensureBuffer(input2) {
    if (Buffer.isBuffer(input2)) return input2;
    var hasNewBufferAPI = typeof Buffer.alloc === "function" && typeof Buffer.from === "function";
    if (typeof input2 === "number") return hasNewBufferAPI ? Buffer.alloc(input2) : new Buffer(input2);
    else if (typeof input2 === "string") return hasNewBufferAPI ? Buffer.from(input2) : new Buffer(input2);
    else throw new Error("input must be buffer, number, or string, received " + typeof input2);
}
function bufferizeInt(num2) {
    var tmp = ensureBuffer(4);
    tmp.writeInt32BE(num2, 0);
    return tmp;
}
function _crc32(buf, previous) {
    buf = ensureBuffer(buf);
    if (Buffer.isBuffer(previous)) previous = previous.readUInt32BE(0);
    var crc = ~~previous ^ -1;
    for(var n2 = 0; n2 < buf.length; n2++)crc = CRC_TABLE[(crc ^ buf[n2]) & 255] ^ crc >>> 8;
    return crc ^ -1;
}
function crc32() {
    return bufferizeInt(_crc32.apply(null, arguments));
}
crc32.signed = function() {
    return _crc32.apply(null, arguments);
};
crc32.unsigned = function() {
    return _crc32.apply(null, arguments) >>> 0;
};
updateConfig(config$1);
updateConfig({
    clientId: getClientIdCookies()
});
const setChannelUrl = (channelUrl, slotUrl)=>{
    SdkEventEmitter.emit(ESdkControlsEvents.CHANNEL_URL_UPDATE, channelUrl);
    if (channelUrl !== store.getState().globalData.blogUrl) store.dispatch(setGlobalBlogUrl({
        blogUrl: channelUrl,
        slotUrl: slotUrl
    }));
};
const updateTheme = (theme)=>{
    SdkEventEmitter.emit(ESdkControlsEvents.SET_THEME, theme);
};
const init = (params)=>{
    const { auth, xSdkApp, channelUrl, theme = EUITheme.DARK, onTokenRefreshError, onAuthorize } = params;
    if (channelUrl) setChannelUrl(channelUrl);
    if (onTokenRefreshError) setRefreshTokenCallback(onTokenRefreshError);
    if (auth) setAuth(auth);
    HttpTransportBrowser.setup(getAuthTokenData, xSdkApp);
    Api$1.setTransport(HttpTransportBrowser);
    Api$1.setContext(EApiContext.STREAMS);
    const container2 = document.createElement("div");
    (0, $1u0KT.render)(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4hUQH.default), {
        store: store
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThemeProvider, {
        theme: theme
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(App, null))), container2);
};
const VERSION = "1.0.8";
((spriteNodeId, spriteGlobalVarName)=>{
    let sprite;
    const isSpriteExists = Object.prototype.hasOwnProperty.call(window, spriteGlobalVarName);
    if (isSpriteExists) sprite = window[spriteGlobalVarName];
    else {
        sprite = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="position: absolute; width: 0; height: 0;" aria-hidden="true"><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-add_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0l-.001-6H5a1 1 0 1 1 0-2h5.999L11 5a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-add_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 5a.9.9 0 0 1 .9.9v3.2h3.2a.9.9 0 0 1 0 1.8h-3.2v3.2a.9.9 0 0 1-1.8 0v-3.2H5.9a.9.9 0 0 1 0-1.8h3.2V5.9A.9.9 0 0 1 10 5" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 1.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M.1 10C.1 4.532 4.532.1 10 .1s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9S.1 15.468.1 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-add_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M10 2.5a.75.75 0 0 1 .75.75v6h6a.75.75 0 1 1 0 1.5h-6v6a.75.75 0 0 1-1.5 0v-6h-6a.75.75 0 0 1 0-1.5h6v-6A.75.75 0 0 1 10 2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-add_square_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.219 1.5H9.78c.674 0 1.224 0 1.672.037.463.037.882.118 1.273.317a3.25 3.25 0 0 1 1.42 1.42c.199.391.28.81.317 1.273.037.447.037.998.037 1.672V9.78c0 .674 0 1.224-.037 1.672-.037.463-.118.882-.317 1.273a3.25 3.25 0 0 1-1.42 1.42c-.391.199-.81.28-1.273.317-.447.037-.998.037-1.672.037H6.22c-.674 0-1.225 0-1.672-.037-.463-.037-.882-.118-1.272-.317a3.25 3.25 0 0 1-1.42-1.42c-.2-.391-.28-.81-.318-1.273-.037-.447-.037-.998-.037-1.672V6.22c0-.674 0-1.224.037-1.672.037-.463.118-.882.317-1.272a3.25 3.25 0 0 1 1.42-1.42c.391-.2.81-.28 1.273-.318.448-.037.998-.037 1.672-.037m-1.55 1.532c-.37.03-.57.085-.713.159a1.75 1.75 0 0 0-.765.765c-.074.144-.13.343-.16.713C3.002 5.05 3 5.538 3 6.25v3.5c0 .712 0 1.202.032 1.58.03.371.085.57.159.714.168.33.435.598.765.765.144.074.343.13.713.16.38.03.869.031 1.581.031h3.5c.712 0 1.202 0 1.58-.032.371-.03.57-.085.714-.159a1.75 1.75 0 0 0 .765-.764c.074-.145.13-.344.16-.714.03-.38.031-.869.031-1.581v-3.5c0-.712 0-1.202-.032-1.58-.03-.371-.085-.57-.159-.714a1.75 1.75 0 0 0-.764-.765c-.145-.074-.344-.13-.714-.16C10.95 3.002 10.462 3 9.75 3h-3.5c-.712 0-1.202 0-1.58.032M8 4.5a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2A.75.75 0 0 1 8 4.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-add_square_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.5 7a.9.9 0 0 1 .9.9v3.2h3.2a.9.9 0 0 1 0 1.8h-3.2v3.2a.9.9 0 0 1-1.8 0v-3.2H8.4a.9.9 0 1 1 0-1.8h3.2V7.9a.9.9 0 0 1 .9-.9" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.962 3h5.076c.948 0 1.714 0 2.334.05.64.053 1.203.163 1.726.43a4.4 4.4 0 0 1 1.922 1.922c.267.523.377 1.087.43 1.726.05.62.05 1.386.05 2.334v5.076c0 .948 0 1.714-.05 2.334-.053.64-.163 1.203-.43 1.726a4.4 4.4 0 0 1-1.922 1.922c-.523.267-1.087.377-1.726.43-.62.05-1.386.05-2.334.05H9.962c-.948 0-1.714 0-2.334-.05-.64-.053-1.203-.163-1.726-.43a4.4 4.4 0 0 1-1.922-1.922c-.267-.523-.377-1.087-.43-1.726-.05-.62-.05-1.386-.05-2.334V9.462c0-.948 0-1.714.05-2.334.053-.64.163-1.203.43-1.726A4.4 4.4 0 0 1 5.902 3.48c.523-.267 1.087-.377 1.726-.43C8.248 3 9.014 3 9.962 3M7.775 4.845c-.528.043-.83.123-1.055.238A2.6 2.6 0 0 0 5.583 6.22c-.115.226-.195.527-.238 1.055C5.3 7.813 5.3 8.505 5.3 9.5v5c0 .995 0 1.687.045 2.226.043.527.123.828.238 1.054a2.6 2.6 0 0 0 1.137 1.137c.226.115.527.195 1.055.238.538.044 1.23.045 2.225.045h5c.995 0 1.687 0 2.226-.045.527-.043.828-.123 1.054-.238a2.6 2.6 0 0 0 1.137-1.137c.115-.226.195-.527.238-1.055.044-.538.045-1.23.045-2.225v-5c0-.995 0-1.687-.045-2.226-.043-.527-.123-.828-.238-1.054a2.6 2.6 0 0 0-1.137-1.137c-.226-.115-.527-.195-1.055-.238C16.688 4.8 15.996 4.8 15 4.8h-5c-.995 0-1.687 0-2.226.045" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-angry-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M8.845 12.25s1.66-.005 2.23 1.315c.035.085.06.175.065.265.015.185-.115.375-.43.25-.505-.2-1.375-.3-1.865-.3s-1.355.1-1.865.3c-.315.125-.445-.065-.43-.25.005-.09.03-.18.065-.265.575-1.32 2.23-1.315 2.23-1.315"/><path fill="url(#d)" d="M6.39 11.03c.425 0 .77-.522.77-1.165S6.815 8.7 6.39 8.7s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#e)" d="M6.085 9.445c.45 0 .825.46.935 1.085.09-.19.14-.42.14-.67 0-.645-.345-1.165-.77-1.165-.37 0-.68.39-.755.915a.72.72 0 0 1 .45-.165"/><path fill="url(#f)" d="M5.565 7.025c-.69 0-1.28.795-.51.915s2.17.785 2.765 1.245c.045.055.22.035.205-.1 0-.52-1.62-2.06-2.46-2.06"/><path fill="url(#g)" d="M8.845 12.685s1.35-.005 2.275 1.035a.6.6 0 0 0-.05-.155c-.57-1.32-2.23-1.315-2.23-1.315s-1.66-.005-2.23 1.315q-.029.074-.05.155c.935-1.04 2.285-1.035 2.285-1.035"/><path fill="url(#h)" d="M11.61 11.03c.425 0 .77-.522.77-1.165S12.035 8.7 11.61 8.7s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#i)" d="M11.915 9.445c-.45 0-.825.46-.935 1.085-.09-.19-.14-.42-.14-.67 0-.645.345-1.165.77-1.165.37 0 .68.39.755.915a.72.72 0 0 0-.45-.165"/><path fill="url(#j)" d="M12.435 7.025c.69 0 1.28.795.51.915s-2.17.785-2.765 1.245c-.045.055-.22.035-.205-.1 0-.52 1.62-2.06 2.46-2.06"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(7.01283 -3.99972 3.26753 5.72906 7.197 5.815)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF9214"/><stop offset="1" stop-color="#FF4E0D"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(7.01283 -3.99972 3.26753 5.72906 7.197 5.815)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF9214"/><stop offset="1" stop-color="#FF4E0D"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="matrix(1.75166 0 0 .9331 8.846 13.186)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -3.503 9.04)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="matrix(-.31433 1.08576 -.70247 -.20337 11.868 9.873)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><linearGradient id="e" x1="6.397" x2="6.397" y1="9.053" y2="10.096" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="f" x1="6.359" x2="6.359" y1="9.796" y2="7.379" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="g" x1="8.846" x2="8.846" y1="11.682" y2="12.941" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="i" x1="11.603" x2="11.603" y1="9.053" y2="10.096" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="j" x1="11.642" x2="11.642" y1="9.796" y2="7.379" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#643800"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-apps" class="svg-sprite__symbol"><rect width="7" height="7" x="2" y="2" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-width="1.5" d="M12.76 3.975c.56-1.119.84-1.678 1.219-1.858.33-.156.712-.156 1.042 0 .38.18.66.74 1.22 1.858l1.108 2.213c.466.931.699 1.397.643 1.775-.05.33-.232.626-.506.818C17.172 9 16.65 9 15.608 9h-2.216c-1.043 0-1.564 0-1.878-.22a1.21 1.21 0 0 1-.506-.817c-.056-.378.177-.844.644-1.775z"/><rect width="7" height="7" x="11" y="11" stroke="currentColor" stroke-width="1.5" rx="2"/><rect width="7" height="7" x="2" y="11" stroke="currentColor" stroke-width="1.5" rx="3.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-long" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 10h15M3 10l6.5-6.5M3 10l6.5 6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-right" class="svg-sprite__symbol"><path fill="currentColor" d="M13.354 6.646a.5.5 0 0 0-.708.708zM16 10l.354.354a.5.5 0 0 0 0-.708zm-3.354 2.646a.5.5 0 0 0 .708.708zM4 9.5a.5.5 0 0 0 0 1zm8.646-2.146 3 3 .708-.708-3-3zm3 2.292-3 3 .708.708 3-3zM16 9.5H4v1h12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-short" class="svg-sprite__symbol"><path fill="currentColor" d="M4.53 6.47a.75.75 0 0 0-1.06 1.06zM10 13l-.53.53a.75.75 0 0 0 1.06 0zm6.53-5.47a.75.75 0 0 0-1.06-1.06zm-13.06 0 6 6 1.06-1.06-6-6zm7.06 6 6-6-1.06-1.06-6 6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="16" fill="none" id="svg-name-arrow-short-bold" class="svg-sprite__symbol"><path fill="currentColor" d="M3.53 5.22a.75.75 0 0 0-1.06 1.06zm3.97 5.03-.53.53a.75.75 0 0 0 1.06 0zm5.03-3.97a.75.75 0 0 0-1.06-1.06zm-10.06 0 4.5 4.5 1.06-1.06-4.5-4.5zm5.56 4.5 4.5-4.5-1.06-1.06-4.5 4.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-short-right" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 16 6-6-6-6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-arrow-thick" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 2v8.4M6 2 3 5.12M6 2l3 3.12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-arrow_left_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.293 6.293a1 1 0 1 1 1.414 1.414L8.414 13H22a1 1 0 0 1 .993.883L23 14a1 1 0 0 1-1 1H8.414l5.293 5.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0l-7-7-.073-.082-.007-.008a1 1 0 0 1-.067-.096 1 1 0 0 1-.11-.255A1 1 0 0 1 5 14l.004.09L5 14.02V14a1 1 0 0 1 .094-.423 1 1 0 0 1 .199-.284l-.08.09a1 1 0 0 1 .08-.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-arrow_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="m22.707 13.293-7-7a1 1 0 0 0-1.497 1.32l.083.094L19.586 13H6a1 1 0 0 0-.993.883L5 14a1 1 0 0 0 .883.993L6 15h13.586l-5.293 5.293a1 1 0 0 0-.083 1.32l.083.094a1 1 0 0 0 1.32.083l.094-.083 7-7 .097-.112.071-.11.054-.114.035-.105.025-.117.007-.06.004-.108-.004-.07-.016-.112-.03-.111-.044-.111-.052-.098-.067-.096a1 1 0 0 0-.08-.09l-7-7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="3 3 18 18" id="svg-name-arrow_up_right_out_square_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.136 6.273a.955.955 0 0 1 0 1.909c-.637 0-.816.004-.946.03a1.59 1.59 0 0 0-1.25 1.25c-.026.13-.03.31-.03.947v3.564c0 .728 0 1.217.03 1.594.03.365.084.54.143.655.152.3.395.543.695.695.115.06.29.112.655.142.377.031.866.032 1.594.032h3.564c.637 0 .816-.005.947-.03a1.59 1.59 0 0 0 1.25-1.25c.026-.131.03-.31.03-.947a.955.955 0 0 1 1.91 0c0 .545.004.957-.068 1.319a3.5 3.5 0 0 1-2.75 2.75c-.34.067-.726.067-1.226.067H9.99c-.68 0-1.248 0-1.711-.038-.484-.04-.938-.125-1.367-.343a3.5 3.5 0 0 1-1.53-1.53c-.218-.43-.304-.883-.343-1.367C5 15.26 5 14.692 5 14.012v-3.696c0-.5 0-.886.067-1.226a3.5 3.5 0 0 1 2.75-2.75c.362-.072.774-.067 1.32-.067" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.636 5.955c0-.528.428-.955.955-.955h4.455c.527 0 .954.427.954.955v4.454a.955.955 0 0 1-1.91 0V8.26l-4.097 4.098a.955.955 0 0 1-1.35-1.35l4.098-4.098h-2.15a.955.955 0 0 1-.955-.954" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow_uturn_left_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7.63 2.72a.75.75 0 0 1 0 1.06L5.81 5.6h5.24a5.45 5.45 0 1 1 0 10.9H6.4a.75.75 0 0 1 0-1.5h4.65a3.95 3.95 0 0 0 0-7.9H5.81l1.82 1.82a.75.75 0 0 1-1.06 1.06l-3.1-3.1a.75.75 0 0 1 0-1.06l3.1-3.1a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" id="svg-name-asterisk" class="svg-sprite__symbol"><path d="M11 3v6.563L5.281 6.28 3.313 9.72 9.03 13l-5.719 3.281 1.97 3.438L11 16.437V23h4v-6.562l5.719 3.28 1.968-3.437L16.97 13l5.718-3.281L20.72 6.28 15 9.563V3Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-attach" class="svg-sprite__symbol"><path fill="currentColor" d="M15.655 5.544a.75.75 0 0 0-1.033-1.088zm7.718 6.666a.75.75 0 1 0-1.033-1.087zm-9.553 8.043-.517-.544zm-2.494-2.882-.522-.538zm3.296-12.915-8.206 7.796L7.45 13.34l8.205-7.796zM11.848 17.91l7.968-7.732L18.77 9.1l-7.967 7.732zm-.06-16.093L3.648 9.548l1.033 1.088 8.138-7.733zm2.548 18.98 9.037-8.586-1.033-1.087-9.037 8.586zM3.458 20.61a7.76 7.76 0 0 0 10.878.187l-1.033-1.087a6.26 6.26 0 0 1-8.775-.151zm.191-11.06a7.76 7.76 0 0 0-.19 11.06l1.07-1.051a6.26 6.26 0 0 1 .153-8.922zm16.194-7.664a5.796 5.796 0 0 0-8.056-.069l1.033 1.087a4.296 4.296 0 0 1 5.972.052zm-.027 8.292a5.796 5.796 0 0 0 .027-8.292l-1.051 1.07a4.296 4.296 0 0 1-.02 6.146zM6.299 17.82a3.92 3.92 0 0 0 5.55.088l-1.045-1.076a2.42 2.42 0 0 1-3.427-.054zm.117-5.569a3.92 3.92 0 0 0-.117 5.57l1.078-1.043a2.42 2.42 0 0 1 .073-3.44z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-audio" class="svg-sprite__symbol"><path d="M16 12.5V4.887a1 1 0 0 0-1.316-.948L8.368 6.044A2 2 0 0 0 7 7.942V15M7.026 15.227c.152.648-.357 1.624-1.606 1.916s-2.138-.359-2.289-1.007.357-1.623 1.607-1.915c1.25-.291 2.137.358 2.288 1.006"/><path d="M16.026 12.727c.151.648-.357 1.624-1.606 1.916s-2.138-.359-2.289-1.007.357-1.623 1.607-1.915c1.25-.291 2.137.358 2.288 1.006"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-badge-rt" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="#fff" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-7" x2="17.166" y1="-6" y2="-4.762" gradientUnits="userSpaceOnUse"><stop stop-color="#6DCFEE"/><stop offset=".83" stop-color="#046ADE"/></linearGradient><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-ban" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 4 4 16"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-basketball_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m5.47 2.953 4.205 4.204 1.123-1.123A8.47 8.47 0 0 1 8.882 2a6.96 6.96 0 0 0-3.411.952m4.975-.804a7 7 0 0 0 1.417 2.82l1.47-1.469a7 7 0 0 0-2.887-1.35m3.958 2.4-1.465 1.466a7 7 0 0 0 2.867 1.336 7 7 0 0 0-1.402-2.801M16 8.91a8.47 8.47 0 0 1-4.128-1.827l-1.136 1.136 4.312 4.311a6.97 6.97 0 0 0 .952-3.62m-1.855 4.839-4.47-4.47-1.206 1.207a8.47 8.47 0 0 1 2.03 5.354 7 7 0 0 0 3.646-2.091M9 16c0-1.69-.599-3.24-1.597-4.45L4.55 14.403A6.97 6.97 0 0 0 9 16m-5.5-2.669 2.831-2.83A6.97 6.97 0 0 0 2.001 9H2c0 1.636.56 3.14 1.5 4.331m-1.34-5.83a8.47 8.47 0 0 1 5.238 1.933l1.216-1.216-4.362-4.362a7 7 0 0 0-2.091 3.645m1.681-5.257A8.47 8.47 0 0 1 9.59.52a8.47 8.47 0 0 1 5.362 2.41A8.48 8.48 0 0 1 17.5 9c0 1.939-.65 3.728-1.744 5.159A8.49 8.49 0 0 1 9 17.5a8.48 8.48 0 0 1-6.07-2.549A8.48 8.48 0 0 1 .537 8.214a8.5 8.5 0 0 1 3.305-5.97" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-bell" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M19.662 19.2H4.217c-.861 0-1.45-.883-1.149-1.689.555-1.482 1.252-3.578 1.252-4.74 0-1.929-1.28-11.572 7.68-11.572s7.68 9 7.68 11.572c0 1.45.61 3.308 1.143 4.654.328.828-.27 1.774-1.16 1.774ZM9 19.8s0 3 3 3 3-3 3-3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-bell-crossed-out" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M9 19.438s0 2.944 3 2.944 3-2.945 3-2.945"/><path fill="currentColor" fill-rule="evenodd" d="M6.243 19.595h13.404c1.468 0 2.37-1.53 1.856-2.813-.527-1.313-1.073-2.996-1.073-4.247 0-.205.011-.472.024-.787.058-1.435.156-3.875-.538-6.066a8.2 8.2 0 0 0-.964-2.055l-.996 1.251c.216.395.39.817.53 1.257.603 1.905.525 3.976.47 5.437-.013.362-.026.687-.026.963 0 1.565.65 3.484 1.18 4.805.152.378-.142.755-.463.755H7.436zM16.736 3.361a5 5 0 0 0-.21-.169c-.982-.747-2.412-1.266-4.525-1.266-2.102 0-3.527.552-4.51 1.343-.99.796-1.603 1.892-1.974 3.097-.615 2.002-.525 4.126-.47 5.421.013.297.024.55.024.748 0 .679-.199 1.556-.441 2.394a33 33 0 0 1-.845 2.486c-.128.338.129.68.446.68h.778l-1.164 1.463c-1.187-.232-1.901-1.52-1.462-2.676.272-.716.574-1.566.806-2.37.238-.823.382-1.526.382-1.977 0-.137-.01-.335-.02-.581-.058-1.244-.172-3.737.533-6.029C4.514 4.526 5.26 3.137 6.55 2.1 7.847 1.057 9.622.426 12 .426c2.367 0 4.137.585 5.435 1.573q.12.092.235.188z" clip-rule="evenodd"/><path fill="currentColor" d="M2.838 23.047 20.853.412l1.287.954L4.125 24z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none" id="svg-name-bell-with-plus" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.047 12.012c.012.301.023.558.023.759 0 .693-.2 1.594-.446 2.455a35 35 0 0 1-.853 2.548c-.125.336.13.675.446.675h6.64q.364.793.86 1.5H7.76a3 3 0 0 0 .286 1.016c.143.286.345.55.635.743.286.19.7.343 1.319.343.616 0 1.029-.151 1.314-.34a9.5 9.5 0 0 0 1.256.911q-.188.179-.42.334c-.558.372-1.269.595-2.15.595s-1.592-.223-2.15-.595a3.4 3.4 0 0 1-1.146-1.32 4.4 4.4 0 0 1-.446-1.653l-.003-.034H2.217c-1.405 0-2.328-1.424-1.85-2.7a33 33 0 0 0 .814-2.434c.242-.847.39-1.575.39-2.044 0-.141-.01-.343-.021-.595-.057-1.268-.17-3.801.532-6.13.429-1.422 1.174-2.834 2.463-3.89C5.842 1.093 7.619.449 10 .449c2.37 0 4.142.597 5.44 1.604 1.044.81 1.735 1.848 2.19 2.948a9.6 9.6 0 0 0-1.597.112 5.4 5.4 0 0 0-1.512-1.875C13.539 2.477 12.11 1.95 10 1.95c-2.1 0-3.522.562-4.505 1.367-.992.813-1.606 1.931-1.978 3.162-.617 2.045-.526 4.216-.471 5.534" clip-rule="evenodd"/><path fill="#07F" fill-rule="evenodd" d="M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 11.107v7.215M21.107 14.715h-7.214"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-block_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m4.391-3.048a7 7 0 0 1-9.843-9.843zm1.06-1.06L5.61 4.547a7 7 0 0 1 9.843 9.843" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-block_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M20.329 21.743 6.257 7.67A9.96 9.96 0 0 0 4 14c0 5.523 4.477 10 10 10a9.96 9.96 0 0 0 6.329-2.257m1.414-1.414A9.96 9.96 0 0 0 24 14c0-5.523-4.477-10-10-10a9.96 9.96 0 0 0-6.329 2.257zM14 26C7.373 26 2 20.627 2 14S7.373 2 14 2s12 5.373 12 12-5.373 12-12 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bold" class="svg-sprite__symbol"><path fill="currentColor" d="M5.25 17a.75.75 0 0 0 1.5 0zm1.5-14a.75.75 0 0 0-1.5 0zm0 14V3h-1.5v14z"/><path stroke="currentColor" stroke-width="1.5" d="M6 3h5a3 3 0 1 1 0 6H6M6 9h6a4 4 0 0 1 0 8H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bold-active" class="svg-sprite__symbol"><path fill="#F15F2C" d="M5.25 17a.75.75 0 0 0 1.5 0zm1.5-14a.75.75 0 0 0-1.5 0zm0 14V3h-1.5v14z"/><path stroke="#F15F2C" stroke-width="1.5" d="M6 3h5a3 3 0 1 1 0 6H6M6 9h6a4 4 0 0 1 0 8H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bonus" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 9.666H2v8.69h16z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.63 9.666h2.739a.013.013 0 0 1 .012.013v2.654a1.38 1.38 0 0 1-2.36.977c-.258-.259-.404-.61-.404-.976V9.679a.012.012 0 0 1 .013-.013M5.417 2h9.166A3.417 3.417 0 0 1 18 5.417H2A3.417 3.417 0 0 1 5.417 2M18 5.416l-1.875 4.25M2 5.416l1.875 4.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-boosty" class="svg-sprite__symbol"><path fill="url(#a)" d="M2.522 11.946 5.926 0h5.223l-1.056 3.704a.4.4 0 0 0-.027.066l-2.774 9.78H9.88Q8.26 17.663 7.343 20c-4.777-.054-6.116-3.526-4.943-7.634zM7.36 20l6.297-9.2h-2.672l2.325-5.893c3.989.423 5.86 3.608 4.76 7.458C16.889 16.508 12.11 20 7.458 20z"/><path fill="url(#b)" d="M2.522 11.946 5.926 0h5.223l-1.056 3.704a.4.4 0 0 0-.027.066l-2.774 9.78H9.88Q8.26 17.663 7.343 20c-4.777-.054-6.116-3.526-4.943-7.634zM7.36 20l6.297-9.2h-2.672l2.325-5.893c3.989.423 5.86 3.608 4.76 7.458C16.889 16.508 12.11 20 7.458 20z"/><defs><linearGradient id="a" x1="18.381" x2="2" y1="10" y2="10" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient><linearGradient id="b" x1="3.503" x2="-6.009" y1="-1.507" y2="20.566" gradientUnits="userSpaceOnUse"><stop stop-color="#EF7829"/><stop offset=".28" stop-color="#F0692A"/><stop offset=".63" stop-color="#F15E2C"/><stop offset="1" stop-color="#F15A2C"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-boosty-white" class="svg-sprite__symbol"><path fill="#fff" d="M3.782 17.92 8.888 0h7.836l-1.585 5.556a.6.6 0 0 0-.04.099l-4.162 14.67h3.883Q12.39 26.496 11.014 30c-7.164-.08-9.173-5.29-7.415-11.45zM11.041 30l9.445-13.8h-4.008l3.486-8.84c5.984.635 8.79 5.412 7.14 11.188C25.334 24.762 18.166 30 11.187 30z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-box" class="svg-sprite__symbol"><path stroke="#F1F1F1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 8.3 1.5 4.9l4.25-1.7L10 1.5l8.5 3.4-4.25 1.7z" clip-rule="evenodd"/><path fill="currentColor" d="M9.721 19.2a.75.75 0 0 0 .557-1.393zM1.5 15.103H.75a.75.75 0 0 0 .471.697zm.75-10.2a.75.75 0 0 0-1.5 0zm7.471 12.904a.75.75 0 0 0 .557 1.393zm8.779-2.704.279.697a.75.75 0 0 0 .471-.697zm.75-10.2a.75.75 0 0 0-1.5 0zm-10 13.6a.75.75 0 0 0 1.5 0zm1.5-10.2a.75.75 0 0 0-1.5 0zM6.279 2.406a.75.75 0 1 0-.558 1.393zm7.943 4.793a.75.75 0 0 0 .556-1.393zm-3.943 10.609-8.5-3.4L1.22 15.8l8.5 3.4zM2.25 15.103v-10.2H.75v10.2zm8.028 4.097 8.5-3.4-.556-1.393-8.5 3.4zm8.972-4.097v-10.2h-1.5v10.2zm-8.5 3.4v-10.2h-1.5v10.2zM5.721 3.798l8.5 3.4.557-1.393-8.5-3.4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-box-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M14.542 5H5.458C4.107 5 3 6.098 3 7.439v.694h14V7.44C17 6.099 15.893 5 14.542 5"/><path fill="url(#c)" d="M12.116 11.963c0 .21-.179.388-.39.388H8.258a.395.395 0 0 1-.39-.388V8.895H3v5.49c0 .34.277.614.619.614H16.38a.616.616 0 0 0 .619-.613V8.895h-4.884z"/><path fill="url(#d)" d="M8.649 8.895v2.68h2.702v-2.68zM10 10.833a.581.581 0 1 1 0-1.163.581.581 0 1 1 0 1.163"/><defs><linearGradient id="a" x1="1.5" x2="25" y1="22.5" y2="-5" gradientUnits="userSpaceOnUse"><stop stop-color="#4EA1FF"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="b" x1="-3.16" x2="13.219" y1="3.192" y2="14.469" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><linearGradient id="c" x1="-3.16" x2="18.303" y1="5.372" y2="12.956" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><linearGradient id="d" x1="7.46" x2="12.01" y1="7.348" y2="8.054" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-broadcast" class="svg-sprite__symbol"><circle cx="10" cy="10" r="1.25" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M7.45 6.6a.75.75 0 0 0-.901-1.2zm6.001-1.2a.75.75 0 1 0-.901 1.2zm-6.902 9.2a.75.75 0 1 0 .901-1.2zm6.001-1.2a.75.75 0 1 0 .901 1.2zM5.75 10c0-1.39.666-2.624 1.7-3.4l-.901-1.2A5.74 5.74 0 0 0 4.25 10zm6.8-3.4a4.24 4.24 0 0 1 1.7 3.4h1.5a5.74 5.74 0 0 0-2.299-4.6zm-5.1 6.8a4.24 4.24 0 0 1-1.7-3.4h-1.5c0 1.881.904 3.552 2.299 4.6zm6.8-3.4c0 1.39-.666 2.624-1.7 3.4l.901 1.2A5.74 5.74 0 0 0 15.75 10zM5.45 2.6a.75.75 0 1 0-.9-1.2zm-.9 16a.75.75 0 0 0 .9-1.2zM1.75 10a9.23 9.23 0 0 1 3.7-7.4l-.9-1.2A10.73 10.73 0 0 0 .25 10zm3.7 7.4a9.23 9.23 0 0 1-3.7-7.4H.25c0 3.517 1.69 6.64 4.3 8.6zM14.55 2.6a.75.75 0 0 1 .9-1.2zm.9 16a.75.75 0 0 1-.9-1.2zm2.8-8.6a9.23 9.23 0 0 0-3.7-7.4l.9-1.2c2.61 1.96 4.3 5.083 4.3 8.6zm-3.7 7.4a9.23 9.23 0 0 0 3.7-7.4h1.5c0 3.517-1.69 6.64-4.3 8.6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" id="svg-name-broadcast-struck-out" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M28.4 21.2a1.5 1.5 0 0 0-1.8-2.4C20.165 23.634 16 31.33 16 40c0 5.98 1.982 11.496 5.322 15.93q.054-.07.12-.135l2.018-2.019A23.4 23.4 0 0 1 19 40c0-7.686 3.69-14.51 9.4-18.8m-3.02 34.898-1.817 1.818a1.5 1.5 0 0 1-.347.259A26.7 26.7 0 0 0 26.6 61.2a1.5 1.5 0 0 0 1.802-2.4 23.7 23.7 0 0 1-3.02-2.702m5.487-5.486 2.128-2.129q.198.164.404.318a1.5 1.5 0 1 1-1.803 2.398q-.375-.28-.73-.587m.095-4.338-2.148 2.148A13.94 13.94 0 0 1 26 40c0-4.58 2.201-8.647 5.598-11.199a1.5 1.5 0 0 1 1.802 2.399 10.98 10.98 0 0 0-4.4 8.8c0 2.332.725 4.494 1.963 6.274m6.32-2.077a5 5 0 0 0 6.916-6.916l-2.253 2.252A2.004 2.004 0 0 1 40 42q-.241 0-.467-.055zm1.035-5.278-2.954 2.954a5 5 0 0 1 6.51-6.51l-2.954 2.954a2 2 0 0 0-.602.602m10.165-5.922A10.95 10.95 0 0 1 50.999 40c0 3.598-1.726 6.791-4.4 8.801a1.5 1.5 0 1 0 1.802 2.398A13.98 13.98 0 0 0 53.999 40c0-3.49-1.278-6.681-3.389-9.132zm-.062-4.181-2.105 2.105a1.5 1.5 0 0 1 2.105-2.105m7.567-3.324A23.4 23.4 0 0 1 61 40c0 7.686-3.69 14.51-9.4 18.8a1.5 1.5 0 1 0 1.8 2.4C59.835 56.367 64 48.67 64 40a26.4 26.4 0 0 0-5.879-16.643zm.118-4.36-2.121 2.12a24 24 0 0 0-2.385-2.052 1.5 1.5 0 0 1 1.802-2.4 27 27 0 0 1 2.704 2.331" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M60.356 21.5 22.5 59"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-broadcast_outline" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.914 4.978a1.05 1.05 0 0 1-.006 1.484A10.58 10.58 0 0 0 3.768 14c0 2.948 1.2 5.613 3.14 7.538A1.05 1.05 0 1 1 5.43 23.03 12.68 12.68 0 0 1 1.668 14c0-3.53 1.44-6.726 3.762-9.028a1.05 1.05 0 0 1 1.484.006M22.086 4.978a1.05 1.05 0 0 1 1.485-.006A12.68 12.68 0 0 1 27.332 14c0 3.53-1.44 6.726-3.761 9.03a1.05 1.05 0 0 1-1.48-1.492A10.58 10.58 0 0 0 25.233 14c0-2.947-1.2-5.613-3.14-7.538a1.05 1.05 0 0 1-.006-1.484" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.992 8.45a1.05 1.05 0 0 1 .048 1.485A5.93 5.93 0 0 0 8.435 14c0 1.543.584 3.044 1.514 4.083a1.05 1.05 0 1 1-1.564 1.4c-1.287-1.436-2.05-3.44-2.05-5.483 0-2.126.826-4.062 2.172-5.5a1.05 1.05 0 0 1 1.485-.05M19.01 8.45a1.05 1.05 0 0 1 1.484.05 8.03 8.03 0 0 1 2.173 5.5c0 2.043-.764 4.047-2.05 5.484a1.05 1.05 0 0 1-1.565-1.4c.931-1.04 1.515-2.54 1.515-4.084a5.93 5.93 0 0 0-1.605-4.065 1.05 1.05 0 0 1 .048-1.484" clip-rule="evenodd"/><path fill="currentColor" d="M16.835 14a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-burger-wide" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h22M1 12h22M1 19h22"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="22" fill="none" id="svg-name-burger-with-check-mark" class="svg-sprite__symbol"><mask id="a" width="26" height="22" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="currentColor" fill-rule="evenodd" d="M23 0H0v22h23V11.377l2.427-2.511a2.113 2.113 0 0 0 .021-2.871C24.943 5.452 23.872 4.993 23 5zm0 5c-.412.004-.78.111-1.023.364l-7.693 7.366-1.843-1.62c-.756-.786-2.9-.974-4.111.201s-1.1 3.093-.345 3.88l5.527 6.006L23 11.377z" clip-rule="evenodd"/></mask><g fill="currentColor" mask="url(#a)"><rect width="15.111" height="2.188" x="1" y="3" rx="1.094"/><rect width="15.111" height="2.188" x="1" y="8.25" rx="1.094"/><rect width="15.111" height="2.188" x="1" y="13.5" rx="1.094"/></g><path fill="currentColor" d="M11.127 12.368a1.25 1.25 0 0 0-1.754 1.781l4.534 4.463 7.59-7.471a1.25 1.25 0 1 0-1.753-1.782l-5.837 5.745z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-calendar-light" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M1 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm0 0h18"/><path fill="currentColor" d="M4.25 3a.75.75 0 0 0 1.5 0zm1.5-2a.75.75 0 0 0-1.5 0zm8.5 2a.75.75 0 0 0 1.5 0zm1.5-2a.75.75 0 0 0-1.5 0zm-10 2V1h-1.5v2zm10 0V1h-1.5v2z"/><path stroke="currentColor" stroke-width="1.5" d="M12 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" id="svg-name-calendar_check_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.5.75a.75.75 0 0 0-1.5 0v.257Q10.412.998 9.683 1H6.317q-.73-.002-1.32.007V.75a.75.75 0 0 0-1.5 0v.356a3.8 3.8 0 0 0-1.176.357A4.25 4.25 0 0 0 .463 3.321C.21 3.818.102 4.36.05 4.99 0 5.603 0 6.364 0 7.316v3.366c0 .952 0 1.713.05 2.327.052.63.16 1.172.413 1.67a4.25 4.25 0 0 0 1.858 1.857c.497.253 1.04.361 1.67.413.613.05 1.374.05 2.326.05h3.366c.952 0 1.713 0 2.327-.05.63-.052 1.172-.16 1.67-.413a4.25 4.25 0 0 0 1.857-1.857c.253-.498.361-1.04.413-1.67.05-.614.05-1.375.05-2.327V7.317c0-.952 0-1.713-.05-2.327-.052-.63-.16-1.172-.413-1.67a4.25 4.25 0 0 0-1.857-1.857 3.8 3.8 0 0 0-1.18-.357zm-9.002 2v-.12c-.202.044-.36.1-.496.17A2.75 2.75 0 0 0 1.8 4.002c-.128.25-.21.573-.255 1.11-.044.546-.045 1.246-.045 2.238v3.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 3.002 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 14.2 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238v-3.3c0-.992 0-1.692-.045-2.238-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 13 2.8a2 2 0 0 0-.499-.17v.12a.75.75 0 0 1-1.5 0v-.243A80 80 0 0 0 9.65 2.5h-3.3c-.526 0-.97 0-1.352.007v.243a.75.75 0 0 1-1.5 0m8.032 4.78a.75.75 0 0 0-1.06-1.06L7 9.94 5.53 8.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-calendar_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .75.75v.257Q7.588 1.998 8.317 2h3.366q.729-.002 1.317.007V1.75a.75.75 0 0 1 1.5 0v.356c.428.064.816.172 1.18.357a4.25 4.25 0 0 1 1.857 1.858c.253.497.361 1.04.413 1.67.05.613.05 1.374.05 2.326v3.366c0 .952 0 1.713-.05 2.327-.052.63-.16 1.172-.413 1.67a4.25 4.25 0 0 1-1.857 1.857c-.498.253-1.04.361-1.67.413-.614.05-1.375.05-2.327.05H8.317c-.952 0-1.713 0-2.327-.05-.63-.052-1.172-.16-1.67-.413a4.25 4.25 0 0 1-1.857-1.857c-.253-.498-.361-1.04-.413-1.67C2 13.396 2 12.635 2 11.683V8.317c0-.952 0-1.713.05-2.327.052-.63.16-1.172.413-1.67a4.25 4.25 0 0 1 1.858-1.857A3.8 3.8 0 0 1 5.5 2.106V1.75A.75.75 0 0 1 6.25 1M5.5 3.63c-.203.044-.361.1-.498.17A2.75 2.75 0 0 0 3.8 5.002c-.128.25-.21.573-.255 1.11-.02.255-.032.543-.038.878h12.986a14 14 0 0 0-.038-.878c-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 15 3.8a2 2 0 0 0-.499-.17v.12a.75.75 0 0 1-1.5 0v-.243a80 80 0 0 0-1.35-.007h-3.3c-.525 0-.968 0-1.35.007v.243a.75.75 0 0 1-1.5 0zm11 4.86h-13v3.16c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 5.002 16.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 16.2 15c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="14" fill="none" id="svg-name-cam" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 .998h5a4 4 0 0 1 4 4v.125l1.94-1.213A2 2 0 0 1 19 5.606V8.39a2 2 0 0 1-3.06 1.7L14 8.873v.125a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14 5.123v3.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-camera" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M5 3.999h5a4 4 0 0 1 4 4v.125l1.94-1.213A2 2 0 0 1 19 8.607v2.784a2 2 0 0 1-3.06 1.7L14 11.874v.125a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M7.5 11.999a2 2 0 1 1 0-4 2 2 0 0 1 0 4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14 8.124v3.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-camera_off_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M26.5 19.5A1.5 1.5 0 0 1 28 18c5.523 0 10 4.477 10 10a1.5 1.5 0 0 1-3 0 7 7 0 0 0-7-7 1.5 1.5 0 0 1-1.5-1.5M6.128 14.424C4.758 16.284 4 18.774 4 21.437V34c0 .582.08 1.804.228 3.038.143 1.185.374 2.632.747 3.535.53 1.282 1.294 2.578 2.307 3.629 1.134 1.359 2.79 2.292 4.466 2.887 1.714.608 3.584.911 5.252.911h21c2.788 0 4.984-.348 6.798-1.08l3.641 3.64a1.5 1.5 0 0 0 2.122-2.12l-42-42a1.5 1.5 0 1 0-2.122 2.12l3.155 3.156c-1.389.524-2.568 1.488-3.466 2.708M12 14.28c-1.323 0-2.53.666-3.457 1.923C7.607 17.475 7 19.315 7 21.437V34c0 .418.066 1.51.207 2.68.147 1.222.346 2.276.54 2.747.422 1.02.998 1.98 1.772 2.772.823 1.006 2.026 1.634 3.233 2.062 1.386.492 2.916.739 4.248.739h21c1.83 0 3.263-.165 4.421-.457l-8.49-8.49A9.96 9.96 0 0 1 28 38c-5.523 0-10-4.477-10-10 0-2.22.724-4.272 1.948-5.931l-7.79-7.79zM21 28a7 7 0 0 0 7 7 6.96 6.96 0 0 0 3.775-1.104l-9.671-9.671A6.96 6.96 0 0 0 21 28" clip-rule="evenodd"/><path fill="currentColor" d="M22 5.5c-1.21 0-2.21.592-2.92 1.16-.724.578-1.326 1.28-1.74 1.773-.102.121-.198.248-.297.372a1.5 1.5 0 1 0 2.348 1.867l.254-.318c.407-.486.842-.979 1.308-1.352.482-.385.826-.502 1.047-.502h12c.221 0 .565.117 1.047.502.498.399.94.89 1.336 1.386l.43.542 1.015 1.273c.625.784 1.571 1.284 2.422 1.588a8.4 8.4 0 0 0 2.75.489h1c1.323 0 2.53.666 3.457 1.923.936 1.272 1.543 3.112 1.543 5.234V34c0 .495 0 1.43-.105 2.476-.107 1.069-.312 2.129-.663 2.909q-.159.353-.333.697a1.5 1.5 0 0 0 2.675 1.358q.209-.412.394-.825c.549-1.22.794-2.66.912-3.84.12-1.2.12-2.26.12-2.768v-12.57c0-2.664-.757-5.152-2.128-7.013C48.492 12.55 46.45 11.28 44 11.28h-1a5.4 5.4 0 0 1-1.742-.315c-.608-.217-.957-.473-1.086-.634l-.985-1.238-.527-.66c-.414-.493-1.016-1.195-1.74-1.774C36.21 6.092 35.21 5.5 34 5.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="16" fill="none" id="svg-name-camera_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.5 3.5c.574 0 1.009-.204 1.34-.521.243-.234.427-.536.553-.743l.055-.089c.15-.24.258-.382.391-.478.113-.082.297-.169.66-.169h3c.364 0 .548.087.66.169.133.096.242.238.392.478l.055.09c.126.206.31.508.554.742.33.317.765.521 1.34.521.732 0 .99.004 1.188.043a2.25 2.25 0 0 1 1.768 1.768c.04.2.043.456.043 1.189v3.45c0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.912a2.25 2.25 0 0 1-.983.983c-.198.1-.458.17-.912.207-.463.037-1.057.038-1.91.038h-6.9c-.853 0-1.448 0-1.91-.038-.454-.037-.715-.107-.912-.207a2.25 2.25 0 0 1-.984-.984c-.1-.197-.17-.458-.207-.912-.037-.462-.038-1.056-.038-1.909V6.501c0-.734.004-.991.043-1.19a2.25 2.25 0 0 1 1.767-1.768c.2-.04.457-.043 1.191-.043m3-3.5c-.637 0-1.14.163-1.543.456-.383.279-.619.637-.781.897l-.075.12c-.136.22-.207.334-.3.423-.06.058-.126.104-.302.104h-.087c-.614 0-1.033 0-1.397.072A3.75 3.75 0 0 0 .07 5.017c-.072.364-.072.783-.072 1.397v3.568c0 .813 0 1.469.043 2 .045.546.14 1.026.366 1.47a3.75 3.75 0 0 0 1.639 1.64c.444.226.924.32 1.47.365.532.043 1.187.043 2 .043h6.966c.812 0 1.468 0 1.999-.043.547-.045 1.027-.14 1.47-.366a3.75 3.75 0 0 0 1.64-1.638c.226-.445.32-.925.365-1.471.044-.531.044-1.187.043-2V6.413c0-.613 0-1.031-.072-1.395a3.75 3.75 0 0 0-2.946-2.946C14.617 2 14.2 2 13.586 2H13.5c-.175 0-.24-.046-.3-.104-.094-.09-.165-.204-.3-.422l-.076-.121c-.162-.26-.398-.618-.78-.897C11.638.163 11.135 0 10.498 0zm3.75 8.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m1.5 0a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" id="svg-name-cancel_12" class="svg-sprite__symbol"><path fill="currentColor" d="M1.525.464a.75.75 0 0 0-1.06 1.06L2.94 4 .465 6.474a.75.75 0 1 0 1.06 1.06L4 5.06l2.475 2.475a.75.75 0 0 0 1.06-1.06L5.062 3.998l2.475-2.475a.75.75 0 1 0-1.06-1.06L4 2.939z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_16" class="svg-sprite__symbol"><path fill="currentColor" d="M3.536 2.264a.9.9 0 0 0-1.272 1.272L6.727 8l-4.463 4.464a.9.9 0 0 0 1.272 1.272L8 9.273l4.464 4.463a.9.9 0 1 0 1.272-1.272L9.273 8l4.463-4.464a.9.9 0 1 0-1.272-1.272L8 6.727z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" id="svg-name-cancel_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.72 5.22a.75.75 0 0 1 1.06 0L10 9.44l4.22-4.22a.75.75 0 1 1 1.06 1.06l-4.22 4.22 4.22 4.22a.75.75 0 1 1-1.06 1.06L10 11.56l-4.22 4.22a.75.75 0 0 1-1.06-1.06l4.22-4.22-4.22-4.22a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-cancel_24" class="svg-sprite__symbol"><path fill="currentColor" d="M7.536 6.264a.9.9 0 0 0-1.272 1.272L10.727 12l-4.463 4.464a.9.9 0 0 0 1.272 1.272L12 13.273l4.464 4.463a.9.9 0 1 0 1.272-1.272L13.273 12l4.463-4.464a.9.9 0 1 0-1.272-1.272L12 10.727z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_circle_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0M4.563 4.564a.9.9 0 0 0 0 1.272L6.727 8l-2.164 2.164a.9.9 0 1 0 1.273 1.272L8 9.273l2.164 2.163a.9.9 0 0 0 1.272-1.272L9.273 8l2.163-2.164a.9.9 0 1 0-1.272-1.272L8 6.727 5.836 4.564a.9.9 0 0 0-1.273 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.405 3.595a.57.57 0 0 1 0 .808L8.809 8l3.596 3.596c.206.206.222.53.047.754l-.047.054a.57.57 0 0 1-.808 0L8 8.808l-3.596 3.595a.57.57 0 0 1-.754.048l-.054-.048a.57.57 0 0 1 0-.808L7.192 8 3.597 4.403a.57.57 0 0 1-.048-.754l.048-.054a.57.57 0 0 1 .808 0L8 7.191l3.596-3.596a.57.57 0 0 1 .754-.047z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-card" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M17 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2ZM1 8h18"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-cart-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M16.287 5.858H6.726l-.337-1.333A.72.72 0 0 0 5.693 4H3.718A.7.7 0 0 0 3 4.7a.7.7 0 0 0 .718.7h1.414l1.773 6.885c.09.306.36.525.696.525h7.317a.72.72 0 0 0 .696-.525l1.37-5.53a.7.7 0 0 0-.136-.59.62.62 0 0 0-.56-.307"/><path fill="url(#c)" d="M8.589 16c.694 0 1.257-.549 1.257-1.225s-.563-1.224-1.257-1.224-1.257.548-1.257 1.224.563 1.224 1.257 1.224"/><path fill="url(#d)" d="M13.571 16c.694 0 1.257-.549 1.257-1.225s-.562-1.224-1.257-1.224-1.256.548-1.256 1.224.562 1.224 1.256 1.224"/><defs><linearGradient id="a" x1="1.5" x2="25" y1="22.5" y2="-5" gradientUnits="userSpaceOnUse"><stop stop-color="#7603D0"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="b" x1="1" x2="8" y1="8.405" y2=".092" gradientUnits="userSpaceOnUse"><stop stop-color="#822CE3"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient><linearGradient id="c" x1="6.973" x2="8.88" y1="14.775" y2="13.312" gradientUnits="userSpaceOnUse"><stop stop-color="#6C0ED5"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient><linearGradient id="d" x1="11.955" x2="13.862" y1="14.775" y2="13.312" gradientUnits="userSpaceOnUse"><stop stop-color="#6C0ED5"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-casino-dices" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M21.25 36.25H8.75c-2.75 0-5-2.25-5-5v-12.5c0-2.75 2.25-5 5-5h12.5c2.75 0 5 2.25 5 5v12.5c0 2.75-2.25 5-5 5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M15 26.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M10 21.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 31.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M10 31.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M13.75 13.75v-5c0-2.75 2.25-5 5-5h12.5c2.75 0 5 2.25 5 5v12.5c0 2.75-2.25 5-5 5h-5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M30 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 21.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chart" class="svg-sprite__symbol"><path fill="currentColor" d="M17.073 19a.75.75 0 0 0 1.5 0zm1.5-15a.75.75 0 0 0-1.5 0zM6.786 19a.75.75 0 0 0 1.5 0zm1.5-15a.75.75 0 0 0-1.5 0zm3.644 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zM1.645 19a.75.75 0 0 0 1.5 0zm1.5-7a.75.75 0 0 0-1.5 0zm15.428 7V4h-1.5v15zM8.286 19V4h-1.5v15zm5.144 0V9h-1.5v10zM3.145 19v-7h-1.5v7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chat" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m13.58 4.563-.194 1.255q.353.054.69.15a6.7 6.7 0 0 0-.497-1.405m-5.025 11.12a5.77 5.77 0 0 0 5.249 1.418c.35-.103.753-.077 1.083-.031.37.052.777.148 1.173.26.314.09.632.19.935.294a7 7 0 0 1-.145-.41 4 4 0 0 1-.195-.924c-.022-.297-.002-.678.2-1.018l.03-.052.038-.046A5.72 5.72 0 0 0 18.25 11.5a5.75 5.75 0 0 0-2.535-4.768 8.2 8.2 0 0 0-.413-1.92 7.252 7.252 0 0 1 2.85 11.23 1 1 0 0 0-.001.136q.017.227.128.581c.15.468.39.976.587 1.354a.965.965 0 0 1-.14 1.09.96.96 0 0 1-1.073.262c-.509-.2-1.277-.486-2.001-.691a8 8 0 0 0-.972-.218 2 2 0 0 0-.332-.026.6.6 0 0 0-.115.01v-.001l-.03.01-.03.007a7.3 7.3 0 0 1-1.673.194 7.24 7.24 0 0 1-5.91-3.05 8.4 8.4 0 0 0 1.965-.017M7.449 14.25a6 6 0 0 1-.259-.539l-.991.414q.609.12 1.25.125" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="1.5" d="M14 7.5a6.5 6.5 0 0 1-8 6.326c-.748-.244-2.892.533-3.928.94-.18.072-.363-.134-.273-.306.409-.784 1.054-2.208.701-2.806A6.5 6.5 0 1 1 14 7.5Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chatbot" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.049a2 2 0 0 0-1.993-2L4.007 3.007a2 2 0 0 0-2.007 2V18l3-3h10.984a2 2 0 0 0 2-2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.252h8.5M5.75 10.752h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-check" class="svg-sprite__symbol"><path fill="currentColor" d="M4.474 11.62a1 1 0 0 0-.948 1.76zM10.5 16l-.474.88a1 1 0 0 0 1.383-.463zm6.41-11.583a1 1 0 0 0-1.82-.834zM3.525 13.38l6.5 3.5.948-1.761-6.5-3.5zm7.883 3.036 5.5-12-1.818-.834-5.5 12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-check-round" class="svg-sprite__symbol"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="3"/><path fill="currentColor" d="M14.587 21.62a1.5 1.5 0 1 0-1.174 2.76zM21.05 26l-.587 1.38a1.5 1.5 0 0 0 1.974-.808zm6.337-11.428a1.5 1.5 0 0 0-2.774-1.144zM13.413 24.38l7.05 3 1.174-2.76-7.05-3zm9.024 2.192 4.95-12-2.774-1.144-4.95 12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.53 5.22a.75.75 0 0 1 0 1.06l-9.5 9.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.97 3.97 8.97-8.97a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_box_off_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.046 2.534C4.788 2.138 5.517 2 7.128 2h5.744c1.61 0 2.34.138 3.082.534.65.348 1.164.862 1.512 1.512.396.742.534 1.471.534 3.082v5.744c0 1.61-.138 2.34-.534 3.082a3.64 3.64 0 0 1-1.512 1.512c-.742.396-1.472.534-3.082.534H7.128c-1.61 0-2.34-.138-3.082-.534a3.64 3.64 0 0 1-1.512-1.512C2.138 15.212 2 14.482 2 12.872V7.128c0-1.61.138-2.34.534-3.082a3.65 3.65 0 0 1 1.512-1.512m3.082.966c-1.531 0-1.962.136-2.374.357a2.15 2.15 0 0 0-.897.897c-.22.412-.357.843-.357 2.374v5.744c0 1.531.136 1.962.357 2.374q.313.585.897.897c.412.22.843.357 2.374.357h5.744c1.531 0 1.962-.136 2.374-.357q.585-.313.897-.897c.22-.412.357-.843.357-2.374V7.128c0-1.531-.136-1.962-.357-2.374a2.15 2.15 0 0 0-.897-.897c-.412-.22-.843-.357-2.374-.357z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_box_on_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.436 4.184C2 5.04 2 6.16 2 8.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 18 6.16 18 8.4 18h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C18 14.96 18 13.84 18 11.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C14.96 2 13.84 2 11.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748m12.2 3.803a.9.9 0 1 0-1.272-1.274l-4.673 4.665-2.055-2.052A.9.9 0 0 0 5.364 10.6l2.691 2.687a.9.9 0 0 0 1.272 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-check_circle_on_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m6.207-14.793a1 1 0 0 0-1.414-1.414L10 14.586l-2.793-2.793a1 1 0 0 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-check_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M14.965 9.263a.9.9 0 0 1 1.273 1.273l-4.6 4.6a.9.9 0 0 1-1.273 0l-2.6-2.6a.9.9 0 0 1 1.272-1.273l1.964 1.964z"/><path fill="currentColor" fill-rule="evenodd" d="M12.001 2.1c5.467 0 9.9 4.432 9.9 9.9 0 5.467-4.433 9.9-9.9 9.9s-9.9-4.433-9.9-9.9 4.433-9.9 9.9-9.9m0 1.8a8.1 8.1 0 0 0-8.1 8.1 8.1 8.1 0 0 0 8.1 8.1 8.1 8.1 0 0 0 8.1-8.1 8.1 8.1 0 0 0-8.1-8.1" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-check_circle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M28 4c13.255 0 24 10.745 24 24S41.255 52 28 52 4 41.255 4 28 14.745 4 28 4m0 3C16.402 7 7 16.402 7 28s9.402 21 21 21 21-9.402 21-21S39.598 7 28 7m8.94 13.94a1.5 1.5 0 0 1 2.12 2.12l-14 14a1.5 1.5 0 0 1-2.12 0l-7-7a1.5 1.5 0 0 1 2.12-2.12L24 33.878z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-check_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.782 4.722a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0L3.22 9.281a.75.75 0 0 1 1.06-1.06l1.971 1.97 5.47-5.47a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-check_shield_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M13.484 1.502c.35-.05.682-.05 1.032 0 .345.05.633.127 1.296.348l6.82 2.274A2 2 0 0 1 24 6.02v9.28c0 4.794-2.878 8.466-8.458 10.942l-.368.16a3 3 0 0 1-2.348 0C7.007 23.928 4 20.202 4 15.3V6.02a2 2 0 0 1 1.368-1.896l7.008-2.336c.533-.174.797-.241 1.108-.286m.75 1.98a1.6 1.6 0 0 0-.467 0c-.2.029-.389.08-.947.266L6 6.02v9.28c0 4.015 2.471 7.077 7.609 9.26.25.107.532.107.775.004l.354-.154C19.641 22.236 22 19.226 22 15.301V6.02l-6.977-2.325a6 6 0 0 0-.668-.193z"/><path fill="currentColor" d="M19.057 10.693a1 1 0 0 0-1.414 0l-4.893 4.893-1.893-1.893a1 1 0 0 0-1.414 1.414l2.6 2.6a1 1 0 0 0 1.414 0l5.6-5.6a1 1 0 0 0 0-1.414"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-check_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.924 3c1.958.02 2.955.232 3.988.784a5.54 5.54 0 0 1 2.3 2.3c.553 1.034.764 2.03.785 3.989v7.851c-.021 1.958-.232 2.955-.785 3.988a5.54 5.54 0 0 1-2.3 2.3c-1.033.553-2.03.764-3.988.785h-7.851c-1.959-.021-2.955-.232-3.988-.785a5.54 5.54 0 0 1-2.3-2.3c-.553-1.033-.764-2.03-.785-3.988v-7.851c.02-1.959.232-2.955.784-3.988a5.54 5.54 0 0 1 2.3-2.3c1.034-.553 2.03-.764 3.989-.785zm-.335 1.998h-7.181l-.557.005c-1.48.028-2.142.18-2.823.545-.64.343-1.137.84-1.48 1.48-.364.681-.517 1.343-.545 2.823l-.005.557v7.18l.005.558c.028 1.48.18 2.142.545 2.823.343.64.84 1.137 1.48 1.48.681.364 1.343.516 2.823.544l.557.005h7.18l.558-.005c1.48-.028 2.142-.18 2.823-.544a3.54 3.54 0 0 0 1.48-1.48c.364-.681.516-1.344.544-2.823l.005-.557v-7.181l-.005-.557c-.028-1.48-.18-2.142-.544-2.823a3.54 3.54 0 0 0-1.48-1.48c-.681-.364-1.344-.517-2.823-.545zm.054 5.695a1 1 0 0 1 1.414 1.414l-5.6 5.6a1 1 0 0 1-1.414 0l-2.6-2.6a1 1 0 1 1 1.414-1.414l1.893 1.893z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="7" height="10" fill="none" id="svg-name-chevron_16" class="svg-sprite__symbol"><path fill="currentColor" d="M4.227 5 .864 1.636A.9.9 0 1 1 2.136.364l4 4a.9.9 0 0 1 0 1.272l-4 4A.9.9 0 1 1 .864 8.364z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-chevron_down_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M7.65 11.24a1 1 0 1 0-1.3 1.52l7 6a1 1 0 0 0 1.3 0l7-6a1 1 0 0 0-1.3-1.52L14 16.684z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-chevron_left_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="m8.414 12 7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 1 1 1.414 1.414z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chevron_left_small_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.28 14.78a.75.75 0 0 0 0-1.06L8.56 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L6.97 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 0 0 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chevron_right_outline_20" class="svg-sprite__symbol"><path fill="#76787A" fill-rule="evenodd" d="M12.53 15.783a.75.75 0 0 0 0-1.061L7.815 10l4.717-4.722a.75.75 0 0 0-1.062-1.06L6.224 9.47a.75.75 0 0 0 0 1.06l5.245 5.252a.75.75 0 0 0 1.061 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-chevron_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M20.35 16.76a1 1 0 1 0 1.3-1.52l-7-6a1 1 0 0 0-1.3 0l-7 6a1 1 0 0 0 1.3 1.52L14 11.316z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-circle-arrow" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 10a8 8 0 1 1-2.708-6"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 2v3h-3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-clapperboard" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m4.763 4.3 12.106-2.442c.426-.086.793-.16 1.135-.14a2.57 2.57 0 0 1 2.14 1.424c.193.388.257.83.342 1.252.04.197.09.438.075.67a1.71 1.71 0 0 1-.948 1.427c-.22.11-.464.154-.703.202l-9.318 1.88h9.637c.216 0 .427 0 .605.014.196.016.427.054.66.173.322.164.584.426.748.749.118.232.156.464.172.66.015.178.015.388.014.605v5.72c0 .69 0 1.26-.037 1.723-.04.482-.124.925-.336 1.34a3.43 3.43 0 0 1-1.497 1.5c-.416.211-.858.296-1.34.335-.464.038-1.033.038-1.722.038H7.517c-.69 0-1.259 0-1.722-.038-.482-.04-.924-.124-1.34-.336a3.43 3.43 0 0 1-1.497-1.498c-.212-.416-.297-.86-.336-1.34-.038-.465-.038-1.034-.038-1.724v-5.72c0-.216 0-.427.015-.605.016-.196.053-.428.172-.66q.07-.136.161-.258a1.7 1.7 0 0 1-.426-.545c-.123-.249-.165-.527-.22-.797-.086-.427-.16-.795-.14-1.136.058-.917.6-1.733 1.423-2.142.37-.184.791-.25 1.194-.33m.339 1.681c-.575.116-.696.148-.772.186a.86.86 0 0 0-.474.714c-.005.084.013.208.128.783.028.138.044.213.057.268l.002.008.01-.001c.055-.009.13-.024.268-.051l14.25-2.876c.138-.028.213-.043.268-.057l.008-.002v-.009a7 7 0 0 0-.052-.268c-.116-.575-.148-.697-.186-.772a.86.86 0 0 0-.713-.475c-.084-.005-.208.013-.783.129zm-.795 4.316v.011c-.009.1-.01.24-.01.493v5.657c0 .735.001 1.234.032 1.62.031.375.087.567.155.701.164.323.426.585.749.75.134.068.326.124.701.154.386.032.885.033 1.618.033h8.909c.733 0 1.232-.001 1.617-.033.376-.03.568-.086.702-.154.322-.165.584-.427.749-.75.068-.134.124-.326.154-.701.032-.386.032-.885.032-1.62v-5.657c0-.254 0-.393-.008-.493l-.001-.011-.012-.001a7 7 0 0 0-.492-.009H4.811c-.255 0-.394 0-.494.009zm6.64 2.202a.43.43 0 0 0-.231-.068.42.42 0 0 0-.423.416v4.31q0 .118.063.219a.426.426 0 0 0 .582.135l3.438-2.09a.412.412 0 0 0 .01-.702z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-clapperboard_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m5.557 5.016 14.123-2.85c.497-.1.926-.188 1.324-.163 1.07.068 2.021.7 2.497 1.66.225.454.3.969.399 1.461.047.23.105.512.088.782a2 2 0 0 1-1.106 1.665c-.257.128-.542.18-.82.236L11.192 10h11.242c.252 0 .497 0 .706.017.228.019.497.063.769.2a2 2 0 0 1 .873.875c.138.271.182.541.201.77.017.208.017.454.017.706v6.673c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.747 1.748c-.485.247-1 .346-1.563.392-.54.044-1.204.044-2.009.044H8.77c-.805 0-1.469 0-2.01-.044-.561-.046-1.078-.145-1.563-.392a4 4 0 0 1-1.746-1.748c-.248-.485-.346-1.002-.392-1.564-.044-.541-.044-1.206-.044-2.01v-6.674c0-.252 0-.498.017-.706.018-.229.063-.499.2-.77q.082-.16.19-.3a2 2 0 0 1-.498-.636c-.144-.29-.193-.616-.257-.93-.1-.498-.188-.928-.163-1.326a3 3 0 0 1 1.66-2.499c.433-.215.923-.29 1.393-.385m.395 1.96c-.67.136-.812.173-.9.217a1 1 0 0 0-.553.833c-.006.098.014.243.15.914.032.16.05.248.066.312l.002.01.01-.002c.065-.01.153-.027.314-.06l16.626-3.354c.16-.032.248-.05.311-.066l.01-.003v-.01a8 8 0 0 0-.06-.314c-.136-.67-.173-.812-.217-.9a1 1 0 0 0-.832-.554c-.098-.006-.243.015-.914.15zm-.927 5.035-.001.014c-.01.116-.01.278-.01.575v6.6c0 .856 0 1.439.037 1.889.036.438.1.662.18.819a2 2 0 0 0 .874.874c.156.08.38.145.818.18.45.037 1.032.038 1.888.038h10.393c.856 0 1.438 0 1.888-.038.438-.035.662-.1.818-.18a2 2 0 0 0 .874-.874c.08-.157.144-.38.18-.82.037-.45.037-1.032.037-1.888v-6.6c0-.297 0-.459-.01-.575l-.001-.014h-.013a8 8 0 0 0-.575-.011H5.613c-.296 0-.458 0-.575.01zm7.747 2.57a.5.5 0 0 0-.27-.08.49.49 0 0 0-.493.485v5.03c0 .09.025.178.073.254.143.228.447.3.679.158l4.01-2.438a.481.481 0 0 0 .011-.82z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-clock" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M9.25 10a.75.75 0 0 0 1.5 0zm1.5-5a.75.75 0 0 0-1.5 0zm0 5V5h-1.5v5z"/><path fill="currentColor" d="M12.455 11.88a.75.75 0 1 0 .596-1.375zm-2.157-2.568a.75.75 0 1 0-.596 1.376zm2.753 1.193-2.753-1.193-.596 1.376 2.752 1.193z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-clock-rewind" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10a9 9 0 1 1-9-9c2.283 0 4.367.85 5.953 2.25L17.5 5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 2v3h-3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M10 10V5M12.753 11.191 10 10"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-clock-wise" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.911 6.164v3.412h3.267"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-clock_circle_dashed_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="m11.75 2.634.01.001a8.4 8.4 0 0 1 3.126.918l.01.005a8.4 8.4 0 0 1 1.377.903l.009.008a8.4 8.4 0 0 1 2.085 2.496l.007.012a8.4 8.4 0 0 1 .643 1.515l.004.013a8.4 8.4 0 0 1 .347 3.232l-.001.014a8.4 8.4 0 0 1-.307 1.618l-.003.011a8.4 8.4 0 0 1-1.511 2.885l-.006.008a8.4 8.4 0 0 1-1.154 1.174l-.008.007a8.4 8.4 0 0 1-2.863 1.562l-.006.002a8.4 8.4 0 0 1-1.461.317h-.006l-.145.018a.9.9 0 1 0 .192 1.79 10 10 0 0 0 .962-.15A10.2 10.2 0 0 0 11.001.8h-.09a.9.9 0 0 0 .016 1.8 8 8 0 0 1 .824.033M1.693 10.182a.9.9 0 0 1 .908.892q.003.414.047.823a.9.9 0 0 1-1.79.192q-.052-.496-.057-1a.9.9 0 0 1 .892-.907M3.627 15.025a.9.9 0 0 0-1.58.862 10.2 10.2 0 0 0 1.125 1.653.9.9 0 1 0 1.382-1.154 8.4 8.4 0 0 1-.927-1.361M5.89 18.823a.9.9 0 0 1 1.215-.38 8.4 8.4 0 0 0 1.527.617.9.9 0 1 1-.507 1.727 10.2 10.2 0 0 1-1.854-.749.9.9 0 0 1-.38-1.215"/><path fill="currentColor" d="M11.4 7a.9.9 0 0 0-1.8 0v4.433a.9.9 0 0 0 .525.817l4.5 2.069a.9.9 0 0 0 .751-1.636L11.4 10.856z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-clock_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 2c6.626 0 12 5.372 12 12s-5.374 12-12 12C7.372 26 2 20.628 2 14S7.372 2 14 2m0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.478 10-10S19.522 4 14 4m-.5 4a1 1 0 0 1 1 1v5.104l4.875 1.969a1 1 0 0 1-.75 1.854l-5.5-2.222a1 1 0 0 1-.625-.927V9a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" stroke-width="2" viewBox="0 0 25 25" id="svg-name-close" class="svg-sprite__symbol"><path fill="none" stroke="currentColor" d="m12.5 12.5-8.839 8.839L12.5 12.5 3.661 3.661 12.5 12.5l8.839-8.839L12.5 12.5l8.839 8.839z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" id="svg-name-close-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 6 12 12M18 6 6 18"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-close-thick" class="svg-sprite__symbol"><path fill="#F5F5F7" fill-rule="evenodd" d="M13.42 15.559c.59.59 1.547.59 2.138 0 .59-.591.59-1.548 0-2.139L10.138 8l5.419-5.42a1.51 1.51 0 0 0 0-2.137 1.51 1.51 0 0 0-2.137 0L8 5.863 2.58.443a1.51 1.51 0 0 0-2.137 0 1.51 1.51 0 0 0 0 2.138L5.862 8l-5.42 5.42a1.515 1.515 0 0 0 0 2.138c.591.59 1.548.59 2.139 0L8 10.139z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-clown-reaction" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M14.7 29.335c7.039 0 12.744-5.706 12.744-12.744S21.739 3.848 14.701 3.848 1.957 9.553 1.957 16.59s5.706 12.744 12.744 12.744Z"/><path fill="url(#c)" d="M14.7 29.335c7.039 0 12.744-5.706 12.744-12.744S21.739 3.848 14.701 3.848 1.957 9.553 1.957 16.59s5.706 12.744 12.744 12.744Z" opacity=".5"/><path fill="url(#d)" d="M26.09 18.738c-.232-1.043-.9-1.856-1.84-2.246l-.04-.016a2.8 2.8 0 0 0-.765-.183 1.02 1.02 0 0 1-.916-1.012v-.016c0-2.405-1.609-4.285-3.656-4.285-1.003 0-1.935.454-2.628 1.275a1.42 1.42 0 0 1-1.179.502 5 5 0 0 0-.709 0 1.41 1.41 0 0 1-1.179-.502c-.685-.82-1.617-1.275-2.628-1.275-2.055 0-3.656 1.88-3.656 4.285v.016c0 .526-.398.956-.924 1.012a2.7 2.7 0 0 0-.756.183c-.964.382-1.65 1.203-1.888 2.262-.2.868-.08 1.872.35 3.067l.048.127c.542 1.274 1.561 3.114 3.314 4.635 2.094 1.824 4.675 2.748 7.67 2.748 2.986 0 5.559-.924 7.662-2.748 1.752-1.52 2.771-3.36 3.32-4.635l.057-.135c.422-1.187.533-2.19.342-3.059Z"/><path fill="url(#e)" d="M14.7 20.648c-1.578 0-2.868-1.075-2.963-2.43 0 .049-.008.104-.008.152 0 1.426 1.202 2.804 2.97 2.804 1.784 0 2.971-1.394 2.971-2.82q.002-.07-.008-.143c-.087 1.362-1.378 2.437-2.963 2.437Z"/><path fill="url(#f)" d="M23.31 18.747a.47.47 0 0 0-.295-.016 30.4 30.4 0 0 1-8.307 1.154c-2.82 0-5.615-.39-8.307-1.154a.42.42 0 0 0-.295.015c-.295.12-.749.558-.143 2.239.916 2.142 3.297 5.91 8.753 5.91 5.432 0 7.83-3.776 8.745-5.918.598-1.673.136-2.111-.151-2.23"/><path fill="url(#g)" d="M14.7 26.301c2.255 0 3.95-.693 5.217-1.64-1.394-.63-3.106-1.044-5.217-1.044s-3.83.414-5.224 1.044c1.274.947 2.97 1.64 5.224 1.64"/><path fill="url(#h)" d="M23.142 18.703c-.016 0-.04 0-.056.008a30.3 30.3 0 0 1-8.379 1.179c-2.851 0-5.67-.398-8.379-1.179-.016-.008-.04-.008-.055-.008-.184.016-1.06.2-.311 2.278a10.7 10.7 0 0 0 1.935 3.035c-.892-1.06.208-1.65 2.175-1.41 1.967.239 4.643.239 4.643.239s2.684-.008 4.644-.24c1.967-.238 3.066.351 2.174 1.41.956-1.043 1.561-2.166 1.935-3.034.733-2.079-.143-2.262-.326-2.278"/><path fill="url(#i)" d="M18.865 17.24c.735 0 1.33-.898 1.33-2.006 0-1.109-.595-2.007-1.33-2.007-.734 0-1.33.898-1.33 2.007s.596 2.007 1.33 2.007Z"/><path fill="#1300E3" d="M18.865 16.563c-.573 0-1.067-.494-1.33-1.227.016 1.083.605 1.96 1.33 1.96s1.314-.877 1.33-1.96c-.262.733-.764 1.226-1.33 1.226Z"/><path fill="url(#j)" d="M10.543 17.265c.744 0 1.346-.91 1.346-2.03 0-1.123-.602-2.032-1.346-2.032-.743 0-1.346.91-1.346 2.031 0 1.122.603 2.031 1.346 2.031"/><path fill="#1300E3" d="M10.543 16.524c.582 0 1.084-.502 1.346-1.243-.016 1.1-.613 1.984-1.346 1.984-.732 0-1.33-.885-1.346-1.984.263.741.773 1.243 1.346 1.243"/><path fill="url(#k)" d="M17.524 9.816c.032-.51.598-.796 1.546-.748.804.047 2.548.59 3.68 2.222.206.303-.144.438-.36.239-.716-.677-2.675-1.61-4.252-1.53-.63.048-.614-.183-.614-.183"/><path fill="url(#l)" d="M11.878 9.824c-.032-.51-.598-.796-1.545-.749-.805.048-2.549.59-3.68 2.223-.207.302.143.438.358.239.717-.677 2.677-1.61 4.254-1.53.62.048.613-.183.613-.183"/><path fill="red" d="M23.31 18.747a.47.47 0 0 0-.295-.016 30.4 30.4 0 0 1-8.307 1.154c-2.82 0-5.615-.39-8.307-1.154a.42.42 0 0 0-.295.015c-.295.12-.749.558-.143 2.239.916 2.142 3.297 5.91 8.753 5.91 5.432 0 7.83-3.776 8.745-5.918.598-1.673.136-2.111-.151-2.23m-.749 1.887c-.86 2-3.026 5.313-7.86 5.313-4.804 0-6.962-3.25-7.838-5.25l-.016-.039a4.5 4.5 0 0 1-.231-.868 31.3 31.3 0 0 0 16.152 0c-.008.183-.071.454-.207.844"/><path fill="url(#m)" d="M22.354 20.227a31.7 31.7 0 0 1-15.308 0q.046.141.103.318l.008.024c.136.31.311.661.526 1.027l.096.024a33 33 0 0 0 6.921.741c2.334 0 4.66-.247 6.921-.74l.088-.024c.223-.39.406-.757.55-1.092a2 2 0 0 0 .095-.278"/><path fill="url(#n)" d="M12.175 19.785a2.9 2.9 0 0 0 1.02 1.028c.501.024 1.003.04 1.505.04.501 0 1.003-.017 1.505-.04a2.9 2.9 0 0 0 1.02-1.028 30 30 0 0 1-2.525.104c-.845 0-1.68-.032-2.525-.104"/><path fill="url(#o)" d="M14.7 20.642c1.64 0 2.97-1.156 2.97-2.581s-1.33-2.58-2.97-2.58-2.971 1.155-2.971 2.58 1.33 2.58 2.97 2.58Z"/><path fill="url(#p)" d="M15.296 16.28c.247.566-.223 1.322-1.068 1.697-.844.374-1.72.223-1.975-.343-.247-.565.223-1.322 1.067-1.696.845-.375 1.729-.216 1.976.342"/><path fill="url(#q)" d="M2.187 14.213c.693 0 .175-1.418 1.6-2.509.845-.645.957-1.999.957-1.999.23-.096.525-.287.812-.526-.04-1.274-2.095-1.465-3.21-1.282-1.234.2-2.23-.542-2.23-.542-.279 2.692-.08 3.011.86 4.373 0 .008 0 2.079 1.21 2.485Z"/><path fill="url(#r)" d="M1.645 8.361s-.446 3.01 2.453 2.453a2.25 2.25 0 0 1 .653-1.107c.23-.095.526-.287.812-.525-.047-1.275-2.102-1.466-3.217-1.283-.287.048-.558.04-.813.008 0 0 .112.128.112.454"/><path fill="url(#s)" d="M6.647 7.263c.287-.43.812-.78 1.394-.923.852-.216 1.274-.956 1.226-1.275-.709-1.234-3.114-1.147-3.4-2.182-.614.948-1.681 2.27-1.084 4.046.207.613.637.534 1.864.334"/><path fill="url(#t)" d="M6.783 5.612c-.191-.462-.749-1.075-1.856-1.155-.31.7-.47 1.521-.143 2.47.207.604.637.533 1.863.334.287-.43.813-.78 1.394-.924-.008 0-1.043-.183-1.258-.725"/><path fill="url(#u)" d="M1.883 9.033c.104 1.298 1.442 2.095 2.613 1.657.207-.518.247-.988.247-.988.581-.239 1.648-1.115 1.672-1.808.016-.358.223-.717.55-1.003-.151-.128-.335-.414-.542-.972-.637-1.68-2.843-1.37-5.033-1.163 1.306 2.509.374 2.772.493 4.277"/><path fill="url(#v)" d="M3 12.628s-.287.438-.996.048-.223-1.8-.717-2.15C.1 9.696.117 7.355.117 7.355c-.28 2.691-.08 3.01.86 4.372 0 0 0 2.079 1.21 2.485.502 0 .366-.749.812-1.585Z"/><path fill="url(#w)" d="M1.883 9.035c.104 1.298 1.442 2.095 2.613 1.656.207-.517.247-.987.247-.987-1.06-.128-2.198-.478-1.928-1.872.414-2.11-1.425-3.074-1.425-3.074 1.306 2.509.374 2.772.493 4.277"/><path fill="url(#x)" d="M6.965 6.898c-.151-.127-.335-.414-.542-.971C5.786 4.238 3.58 4.549 1.39 4.756c0 0 2.82-.255 3.687.47.86.732.144 2.676 1.338 2.676.016-.367.223-.717.55-1.004"/><path fill="url(#y)" d="M7.021 4.181c1.235.239 1.991 1.29 1.736 1.792.367-.303.534-.7.51-.908-.709-1.234-3.114-1.147-3.4-2.182 0 0-.08 1.06 1.154 1.298"/><path fill="url(#z)" d="M27.22 14.212c-.692 0-.175-1.418-1.6-2.509-.845-.645-.956-1.999-.956-1.999-.231-.095-.526-.287-.812-.525.047-1.283 2.094-1.466 3.21-1.29 1.234.198 2.938.15 2.938.15-.334 2.685-.629 2.318-1.569 3.68 0 .016 0 2.087-1.21 2.493Z"/><path fill="url(#A)" d="M25.31 10.814c2.898.55 2.452-2.453 2.452-2.453-.032-.239.128-.295.128-.366a13 13 0 0 1-.829-.096c-1.115-.183-3.162.008-3.21 1.29.287.24.582.43.813.526 0-.008.494.43.645 1.1Z"/><path fill="url(#B)" d="M22.759 7.259c-.287-.43-.813-.78-1.394-.924-.852-.215-1.274-.956-1.227-1.274.71-1.235 3.314-.988 3.784-1.952.438 1.044 1.298 2.047.7 3.815-.206.614-.637.534-1.863.335"/><path fill="url(#C)" d="M22.624 5.612c.19-.462.748-1.075 1.855-1.155.311.7.47 1.521.144 2.47-.207.604-.637.533-1.864.334-.287-.43-.812-.78-1.394-.924 0 0 1.036-.183 1.259-.725"/><path fill="url(#D)" d="M27.523 9.036c-.104 1.299-1.442 2.095-2.613 1.657a3.8 3.8 0 0 1-.246-.988c-.582-.239-1.65-1.115-1.673-1.808-.016-.358-.223-.716-.55-1.003.152-.128.335-.414.542-.972.63-1.688 2.222-1.434 4.412-1.649-.804 2.716.247 3.258.128 4.763"/><path fill="url(#E)" d="M26.407 12.63s.287.439.996.048c.709-.39.223-1.8.717-2.15C29.306 9.699 30 8.05 30 8.05c-.335 2.684-.63 2.317-1.57 3.68 0 0 0 2.078-1.21 2.485-.502 0-.367-.75-.813-1.585"/><path fill="url(#F)" d="M27.523 9.036c-.103 1.298-1.441 2.095-2.612 1.657a3.9 3.9 0 0 1-.247-.988c1.06-.127 2.198-.478 1.927-1.871-.414-2.111.805-3.553.805-3.553-.805 2.708.247 3.25.127 4.755"/><path fill="url(#G)" d="M22.441 6.902c.152-.128.335-.415.542-.972.63-1.689 2.222-1.434 4.412-1.649 0 0-2.206.223-3.066.956s-.143 2.668-1.338 2.668c-.016-.366-.231-.717-.55-1.003"/><path fill="url(#H)" d="M22.56 4.352c-1.25.064-2.166 1.115-1.911 1.617-.367-.303-.534-.701-.51-.908.709-1.235 3.313-.988 3.783-1.952 0 0 .24 1.163-1.362 1.243"/><path fill="url(#I)" d="M20.865 5.627c0 .82-2.317 1.808-6.156 1.808-3.84 0-6.157-1.067-6.157-1.888V4.91c.717-.66 2.86-.374 6.157-.374 3.456 0 5.615-.335 6.156.374z"/><path fill="url(#J)" d="M20.865 4.914c0 .82-2.317 1.649-6.156 1.649-3.84 0-6.157-.829-6.157-1.649s2.318-2.047 6.157-2.047 6.156 1.227 6.156 2.047"/><path fill="url(#K)" d="M18.954 4.917c0 .558-1.465 1.02-4.245 1.02-2.788 0-4.245-.454-4.245-1.02 0-2.214.66-4.26 4.245-4.26 3.576 0 4.245 2.046 4.245 4.26"/><path fill="url(#L)" d="M8.528 5.648c-.04.048-.064.072-.072.088a1 1 0 0 1 .072-.088"/><path fill="url(#M)" d="m8.552 5.621-.025.025c.009 0 .017-.017.025-.025"/><path fill="url(#N)" d="m8.45 5.73-.01.01c0 .01.01 0 .01-.01"/><path fill="url(#O)" d="M20.706 6.02c-.582.717-2.74 1.426-6.006 1.426-3.193 0-5.336-.733-5.965-1.458q-.058.048-.128.096c.39 1.314 2.438 2.222 6.093 2.222 3.72 0 5.775-.868 6.11-2.214q-.058-.036-.104-.072"/><path fill="url(#P)" d="M14.7 4.741c-2.709 0-4.134-.613-4.142-1.17-.08.43-.112.883-.112 1.353 0 .558 1.466 1.012 4.245 1.012s4.262-.454 4.262-1.012c0-.462-.032-.924-.112-1.354 0 .566-1.434 1.171-4.142 1.171Z"/></g><defs><linearGradient id="h" x1="23.647" x2="5.866" y1="21.361" y2="21.361" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset=".5" stop-color="#512D00"/><stop offset="1" stop-color="#3C2200"/></linearGradient><linearGradient id="k" x1="20.172" x2="20.172" y1="7.923" y2="10.196" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="l" x1="9.229" x2="9.229" y1="7.931" y2="10.204" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="q" x1=".185" x2="5.063" y1="6.105" y2="13.672" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="r" x1="2.487" x2="3.801" y1="5.357" y2="9.897" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="s" x1="7.806" x2="6.412" y1="1.818" y2="7.453" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="t" x1="3.075" x2="7.735" y1="6.069" y2="5.77" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3640FF" stop-opacity="0"/><stop offset=".94" stop-color="#3640FF" stop-opacity=".94"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="u" x1="1.005" x2="8.234" y1="4.965" y2="11.219" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="v" x1=".721" x2="1.756" y1="5.857" y2="12.813" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="w" x1="-1.225" x2="5.605" y1="3.472" y2="11.895" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="x" x1="4.077" x2="4.196" y1="9.276" y2="5.115" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="y" x1="8.076" x2="7.458" y1="6.707" y2="3.501" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="z" x1="29.098" x2="24.359" y1="6.296" y2="13.646" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="A" x1="26.338" x2="25.781" y1="6.016" y2="9.321" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="B" x1="21.726" x2="23.023" y1="2.211" y2="7.456" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="C" x1="26.329" x2="21.67" y1="6.069" y2="5.77" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3640FF" stop-opacity="0"/><stop offset=".94" stop-color="#3640FF" stop-opacity=".94"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="D" x1="28.265" x2="21.212" y1="5.051" y2="11.151" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="E" x1="28.769" x2="27.818" y1="6.576" y2="12.961" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="F" x1="30.393" x2="23.579" y1="3.309" y2="11.711" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="G" x1="25.03" x2="24.901" y1="9.403" y2="4.91" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="H" x1="21.556" x2="22.147" y1="6.721" y2="3.649" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="I" x1="13.361" x2="14.714" y1="13.268" y2="5.223" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#9F00E8"/><stop offset="1" stop-color="#7000A3"/></linearGradient><linearGradient id="J" x1="10.21" x2="18.613" y1="11.507" y2="-.839" gradientUnits="userSpaceOnUse"><stop stop-color="#761662"/><stop offset=".473" stop-color="#9F00E8"/><stop offset="1" stop-color="#4F0940"/></linearGradient><linearGradient id="K" x1="18.954" x2="12.104" y1=".483" y2="5.793" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#9F00E8"/><stop offset="1" stop-color="#7000A3"/></linearGradient><linearGradient id="L" x1="8.484" x2="8.492" y1="5.567" y2="5.84" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="M" x1="8.536" x2="8.539" y1="5.596" y2="5.688" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="N" x1="8.445" x2="8.447" y1="5.721" y2="5.767" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="O" x1="14.638" x2="14.867" y1="3.438" y2="11.578" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="P" x1="14.767" x2="14.648" y1="-2.381" y2="11.119" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#FBE07A"/><stop offset="1" stop-color="#FF40BF"/></linearGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(12.197 11.427)scale(15.3734)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(12.197 11.427)scale(12.095)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="translate(15.246 14.958)scale(24.758)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".182" stop-color="#FFFBF8"/><stop offset=".453" stop-color="#FEF1E3"/><stop offset=".778" stop-color="#FDE0C3"/><stop offset="1" stop-color="#FCD2A8"/></radialGradient><radialGradient id="e" cx="0" cy="0" r="1" gradientTransform="matrix(4.53666 0 0 4.53665 14.162 19.066)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A9BCBE"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="translate(14.703 22.808)scale(7.02018)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="g" cx="0" cy="0" r="1" gradientTransform="matrix(5.8182 0 0 1.75884 14.809 24.663)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="matrix(-.54168 -1.87106 1.21054 -.35046 18.872 14.76)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="rotate(-106.147 10.753 3.558)scale(1.97178 1.27555)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="translate(14.703 21.295)scale(13.9779)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A9BCBE"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="matrix(4.48522 0 0 4.48521 14.622 24.556)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="o" cx="0" cy="0" r="1" gradientTransform="translate(14.161 16.97)scale(5.63201)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset=".864" stop-color="#C20000"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="matrix(1.49547 -.601 .34943 .8695 13.601 16.66)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff" stop-opacity=".5"/><stop offset=".849" stop-color="#fff" stop-opacity="0"/></radialGradient><clipPath id="a"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-coin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.976 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.944 8.944 10 7l1.056 1.944L13 10l-1.944 1.056L10 13l-1.056-1.944L7 10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-coins" class="svg-sprite__symbol"><ellipse cx="5.5" cy="9.687" stroke="currentColor" stroke-width="1.5" rx="4.5" ry="2.25"/><path stroke="currentColor" stroke-width="1.5" d="M10 13.063c0 1.242-2.015 2.25-4.5 2.25S1 14.305 1 13.063"/><path stroke="currentColor" stroke-width="1.5" d="M1 9.688v7.2c0 .993 2.015 1.8 4.5 1.8s4.5-.806 4.5-1.8v-7.2"/><ellipse cx="14.5" cy="4.062" stroke="currentColor" stroke-width="1.5" rx="4.5" ry="2.25"/><path stroke="currentColor" stroke-width="1.5" d="M19 7.438c0 1.242-2.015 2.25-4.5 2.25S10 8.68 10 7.437M19 10.813c0 1.242-2.015 2.25-4.5 2.25s-4.5-1.008-4.5-2.25"/><path stroke="currentColor" stroke-width="1.5" d="M10 4.063V14.67c0 .976 2.015 1.767 4.5 1.767s4.5-.791 4.5-1.768V4.063"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-coins_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M23.995 19.178C23.831 22.31 19.351 24.5 14 24.5c-5.452 0-10-2.274-10-5.5V9l.005-.178C4.169 5.69 8.649 3.5 14 3.5c5.452 0 10 2.274 10 5.5v10zm-1.994-6.812C20.165 13.696 17.242 14.5 14 14.5s-6.164-.804-8-2.134V14c0 1.745 3.51 3.5 8 3.5s8-1.755 8-3.5zM14 5.5C9.51 5.5 6 7.255 6 9s3.51 3.5 8 3.5 8-1.755 8-3.5-3.51-3.5-8-3.5m8.001 11.866C20.165 18.696 17.242 19.5 14 19.5s-6.164-.804-8-2.134V19l.005.116C6.157 20.822 9.611 22.5 14 22.5c4.49 0 8-1.755 8-3.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-comment_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.426 18.886A1.5 1.5 0 0 1 5.5 17.5v-2c-.37 0-.719-.004-1.019-.028-.376-.03-.805-.102-1.234-.32a3.2 3.2 0 0 1-1.398-1.4c-.219-.428-.29-.857-.32-1.233-.03-.346-.029-.756-.029-1.19V6.67c0-.433 0-.843.028-1.189.03-.376.102-.805.32-1.234a3.2 3.2 0 0 1 1.4-1.398c.428-.219.857-.29 1.233-.32.346-.03.756-.029 1.19-.029h8.659c.433 0 .843 0 1.189.028.376.03.805.102 1.234.32a3.2 3.2 0 0 1 1.398 1.4c.219.428.29.857.32 1.233.03.346.029.756.029 1.19v4.659c0 .433 0 .843-.028 1.189-.03.376-.102.805-.32 1.234a3.2 3.2 0 0 1-1.4 1.398c-.428.219-.857.29-1.233.32-.346.03-.756.03-1.19.029h-3.166c-.03 0-.05.008-.071.03l-3.031 3.03a1.5 1.5 0 0 1-1.635.326M7 15.12c0-.392 0-.588-.076-.738a.7.7 0 0 0-.306-.306C6.468 14 6.272 14 5.88 14h-.16c-.952 0-1.428 0-1.792-.185a1.7 1.7 0 0 1-.743-.743C3 12.708 3 12.232 3 11.28V6.72c0-.952 0-1.428.185-1.792a1.7 1.7 0 0 1 .743-.743C4.292 4 4.768 4 5.72 4h8.56c.952 0 1.428 0 1.792.185.32.163.58.423.743.743.185.364.185.84.185 1.792v4.56c0 .952 0 1.428-.185 1.792a1.7 1.7 0 0 1-.743.743c-.364.185-.84.185-1.792.185h-3.117c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L7 17.5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-comment_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.06 20.354c.299-.26.68-.404 1.076-.404h4.448c1.17 0 1.867-.697 1.867-1.867V8.75c0-1.17-.697-1.867-1.867-1.867h-14c-1.17 0-1.867.697-1.867 1.867v9.333c0 1.17.697 1.867 1.867 1.867h2.915c.816.235.816.235 1.051 1.051v3.3zm-5.752 5.934c-.55-.413-.857-1.142-.857-1.788v-2.45H7.584c-2.33 0-3.967-1.637-3.967-3.967V8.75c0-2.33 1.637-3.967 3.967-3.967h14c2.33 0 3.967 1.637 3.967 3.967v9.333c0 2.33-1.637 3.967-3.967 3.967h-4.272l-4.346 3.802c-.855.839-1.854 1.039-2.658.436"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-configurate" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 15v3M6 2v9M14 2v3M14 9v9"/><circle cx="6" cy="13" r="2" stroke="currentColor" stroke-width="1.5"/><circle cx="14" cy="7" r="2" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="11" id="svg-name-connect" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M5.227 0a5.228 5.228 0 0 0 0 10.455H9.41V8.364H5.227a3.136 3.136 0 1 1 0-6.273H9.41V0zm8.364 0v2.09h4.182a3.136 3.136 0 1 1 0 6.274H13.59v2.09h4.182a5.228 5.228 0 0 0 0-10.454zM6.273 4.182v2.09h10.454v-2.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-copy" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7 15V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"/><path fill="currentColor" d="M2.25 14a.75.75 0 0 0 1.5 0zM13 3.75a.75.75 0 0 0 0-1.5zM3.75 14V5h-1.5v9zM5 3.75h8v-1.5H5zM3.75 5c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 2.25 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy-button" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7 15V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Z"/><path fill="currentColor" d="M2.25 14a.75.75 0 0 0 1.5 0zM13 3.75a.75.75 0 0 0 0-1.5zM3.75 14V5h-1.5v9zM5 3.75h8v-1.5H5zM3.75 5c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 2.25 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy-new" class="svg-sprite__symbol"><rect width="9" height="10.679" x="4.402" y="5.828" stroke="currentColor" rx="1.5"/><path stroke="currentColor" d="M6.102 4h6a3 3 0 0 1 3 3v7.647"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-copy_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M1.827 2.638C1.5 3.28 1.5 4.12 1.5 5.8v3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.122.062.255.107.408.138V5.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 2.5 5.08 2.5 6.2 2.5h5.22a1.6 1.6 0 0 0-.138-.408 2 2 0 0 0-.874-.874C9.98 1 9.42 1 8.3 1h-2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311M7.7 5.5h3.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v4.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.3 1.3 0 0 1-.242.035c-.258.02-.606.022-1.191.022H7.7c-.585 0-.933-.001-1.191-.022a1.3 1.3 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.3 1.3 0 0 1-.035-.242C6.002 12.733 6 12.385 6 11.8V7.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022m5.038.06-.003-.002zm.203.202v.003zm0 7.473v.003zm-.203.206h-.003zm-6.473 0h-.003.003m-.206-.203v-.003zm0-7.473v-.003.002m.203-.206h.003zM4.5 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.02 4 6.58 4 7.7 4h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v4.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.98 15 12.42 15 11.3 15H7.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4.5 13.48 4.5 12.92 4.5 11.8z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-copy_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M9.7 3c-1.284 0-2.158.001-2.833.056-.658.054-.994.151-1.228.271a3 3 0 0 0-1.312 1.311c-.12.235-.216.57-.27 1.229C4.002 6.542 4 7.415 4 8.7v2.6c0 .585.002.933.023 1.191.009.11.02.176.027.212v.097c0 .761 0 1.264.069 1.642a1.7 1.7 0 0 1-.526-.16 2 2 0 0 1-.875-.874C2.5 12.98 2.5 12.42 2.5 11.3V8.7c0-2.52 0-3.78.491-4.743A4.5 4.5 0 0 1 4.958 1.99C5.92 1.5 7.18 1.5 9.7 1.5h2c1.12 0 1.68 0 2.109.218a2 2 0 0 1 .874.874c.07.137.117.288.15.466C14.46 3 13.971 3 13.25 3z"/><path fill="currentColor" fill-rule="evenodd" d="M5.6 7.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .875-.874C7.12 4.5 7.68 4.5 8.8 4.5h6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 6.02 18 6.58 18 7.7v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.873.874c-.428.218-.988.218-2.108.218h-6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.875-.874C5.6 16.98 5.6 16.42 5.6 15.3zM8.8 6h6c.585 0 .934.001 1.192.022.158.013.224.03.242.036a.5.5 0 0 1 .209.209c.005.018.022.084.035.242.021.258.022.606.022 1.191v7.6c0 .585 0 .933-.022 1.191-.013.158-.03.224-.035.242a.5.5 0 0 1-.21.21 1.3 1.3 0 0 1-.241.035c-.258.02-.607.022-1.192.022h-6c-.584 0-.933-.001-1.191-.022a1.3 1.3 0 0 1-.242-.036.5.5 0 0 1-.209-.209 1.3 1.3 0 0 1-.035-.242c-.021-.258-.023-.606-.023-1.191V7.7c0-.585.002-.933.023-1.191.013-.158.03-.224.035-.242a.5.5 0 0 1 .21-.21c.017-.005.083-.022.241-.035C7.867 6.002 8.216 6 8.8 6m7.439.06-.003-.002zm.202.202.001.003zm0 10.476.001-.003zm-.202.203h-.003zm-8.877 0h.003zm-.202-.203-.001-.003zm0-10.476-.001.003zm.203-.203h.002z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.143 1.428c.933 0 1.726.596 2.02 1.428h-6.93c-1.273 0-1.735.133-2.2.382a2.6 2.6 0 0 0-1.08 1.08c-.25.466-.382.927-.382 2.201v7.644a2.14 2.14 0 0 1-1.428-2.021V5.713a4.286 4.286 0 0 1 4.285-4.285zM15 4.285c1.183 0 2.143.96 2.143 2.143v9.285c0 1.184-.96 2.143-2.143 2.143H7.143A2.143 2.143 0 0 1 5 15.713V6.428c0-1.184.96-2.143 2.143-2.143zm0 1.428H7.143a.714.714 0 0 0-.715.715v9.285c0 .395.32.715.715.715H15c.394 0 .714-.32.714-.715V6.428A.714.714 0 0 0 15 5.713"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="svg-name-cross" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M5.53 4.47a.75.75 0 0 0-1.06 1.06L8.94 10l-4.47 4.47a.75.75 0 1 0 1.06 1.06L10 11.06l4.47 4.47a.75.75 0 1 0 1.06-1.06L11.06 10l4.47-4.47a.75.75 0 0 0-1.06-1.06L10 8.94z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-crown-simple" class="svg-sprite__symbol"><path fill="currentColor" d="m2.183 4.421 2.656 1.627 2.646-3.405a.6.6 0 0 1 .226-.179.68.68 0 0 1 .579 0 .6.6 0 0 1 .225.18l2.647 3.404 2.656-1.627a.67.67 0 0 1 .68-.011.6.6 0 0 1 .239.242c.053.1.073.21.059.321l-1.04 8.114a.57.57 0 0 1-.207.366.67.67 0 0 1-.42.147H2.871a.67.67 0 0 1-.42-.147.57.57 0 0 1-.208-.366L1.204 4.972a.54.54 0 0 1 .06-.32.6.6 0 0 1 .238-.242.68.68 0 0 1 .68.011"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-cube_box_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.407 1.547a3.8 3.8 0 0 1 1.186 0c.445.071.866.248 1.474.503l.08.034 4.421 1.855.093.039c.44.183.826.345 1.121.62.26.241.458.54.58.872.14.38.139.798.138 1.274v5.996c0 .654.001 1.168-.169 1.63-.149.406-.391.771-.708 1.066-.36.335-.834.533-1.438.786l-.107.045-3.931 1.65q-.04.016-.08.033c-.608.255-1.03.431-1.474.503a3.8 3.8 0 0 1-1.186 0c-.445-.072-.865-.248-1.473-.503l-.08-.034-3.931-1.65-.108-.044c-.604-.253-1.077-.45-1.438-.786a2.75 2.75 0 0 1-.708-1.066c-.17-.462-.17-.976-.169-1.63V6.745c0-.477-.001-.896.138-1.275.122-.332.32-.631.58-.872.296-.275.682-.437 1.121-.62l.093-.04 4.422-1.854.08-.034c.608-.255 1.028-.432 1.473-.503m1.343 15.315c.186-.067.435-.17.816-.33l3.932-1.649c.763-.32.964-.416 1.104-.546.143-.134.254-.3.322-.485.065-.178.076-.4.076-1.23v-5.75l-4.853 2.036-.08.034c-.539.226-.93.39-1.321.474a1 1 0 0 1 .004.084zM9.255 9.416a1 1 0 0 0-.005.084v7.362c-.186-.067-.434-.17-.816-.33l-3.931-1.649c-.764-.32-.965-.416-1.104-.546a1.25 1.25 0 0 1-.322-.485c-.066-.178-.077-.4-.077-1.23v-5.75l4.854 2.036.08.034c.538.226.93.39 1.32.474M3.603 5.498l4.83 2.026c.72.302.966.4 1.211.44q.356.056.712 0c.245-.04.492-.138 1.21-.44l.726-.304L6.26 4.69a.75.75 0 0 1-.273-.196l-1.975.829c-.174.073-.307.13-.409.175M7.83 3.72l6.401 2.686 2.166-.91a23 23 0 0 0-.409-.174l-4.422-1.855c-.718-.302-.965-.4-1.21-.44a2.3 2.3 0 0 0-.712 0c-.245.04-.492.138-1.21.44z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-cup" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M6.648 7.094a.65.65 0 0 0-1.3 0zm-1.3 3.362a.65.65 0 0 0 1.3 0zm.409-2.76a.65.65 0 0 0 .482-1.207zM3.798 4.467a.65.65 0 0 0-1.096.699zM5.756 6.49a.65.65 0 1 0 .482 1.207zm3.537-1.323a.65.65 0 0 0-1.096-.699zm-3.295 5.938a.65.65 0 1 0 0-1.3zm-1.432-1.3a.65.65 0 1 0 0 1.3zm1.431 0a.65.65 0 1 0 0 1.3zm1.431 1.3a.65.65 0 1 0 0-1.3zm-5.707-8.78a.65.65 0 1 0 1.296-.096zM3.433 1.2l-.042.649.042.001zm5.13 0v.65l.043-.001zm.777.295.462-.457zm-.36.732a.65.65 0 1 0 1.296.095zm-6.611.697a.65.65 0 0 0 0-1.3zm-1.23-.65-.044.648.044.002zm-.382.138-.449-.471zM.6 2.788h.65v-.012zM2.049 4.94l-.245.603.057.02zm.145.02v-.65h-.012zm.666 0 .001-.65H2.86zm.813.346a.65.65 0 1 0-.855-.98zM3.01 2.189a.65.65 0 1 0-1.288.173zM2.69 5.147a.65.65 0 1 0 1.119-.662zm6.937-3.524a.65.65 0 1 0 0 1.3zm1.234.65v.65q.023 0 .045-.002zm.383.138.448-.471zm.156.375-.65-.012v.012zM9.952 4.938l.187.622.057-.02zm-.146.02.012-.65h-.012zm-.666 0v-.65zm.042-.634a.65.65 0 0 0-.855.979zm1.098-1.962a.65.65 0 1 0-1.289-.173zM8.194 4.485a.65.65 0 1 0 1.118.662zM5.348 7.094v3.362h1.3V7.094zm.891-.605A5.17 5.17 0 0 1 3.8 4.467l-1.097.699a6.47 6.47 0 0 0 3.055 2.53zm0 1.207a6.47 6.47 0 0 0 3.054-2.53l-1.096-.699A5.17 5.17 0 0 1 5.756 6.49zm-.241 2.108H4.566v1.3h1.432zm0 1.3h1.43v-1.3h-1.43zm-2.98-8.876a.35.35 0 0 1 .1-.274l-.923-.915c-.337.34-.51.808-.474 1.284zm.1-.274a.35.35 0 0 1 .273-.104L3.475.553a1.65 1.65 0 0 0-1.28.486zm.315-.103h5.13v-1.3h-5.13zm5.173-.001a.35.35 0 0 1 .273.104l.923-.915a1.65 1.65 0 0 0-1.28-.486zm.273.104a.35.35 0 0 1 .1.274l1.297.095a1.65 1.65 0 0 0-.474-1.284zm-6.51-.33h-1.23v1.3h1.23zm-1.185.002a1.16 1.16 0 0 0-.876.316l.897.942a.14.14 0 0 1-.11.04zm-.876.316A1.16 1.16 0 0 0-.05 2.8l1.3-.025c0 .04-.016.08-.045.108zm-.358.846c0 1.21.733 2.3 1.854 2.754l.489-1.205A1.67 1.67 0 0 1 1.25 2.788zM1.86 5.562q.17.051.346.047l-.025-1.3q.027 0 .054.008zm.333.048h.666v-1.3h-.666zm.664 0c.3 0 .59-.108.815-.305l-.855-.98a.07.07 0 0 1 .043-.015zM1.723 2.362c.132.984.46 1.931.966 2.785l1.119-.662a6.1 6.1 0 0 1-.797-2.296zm7.903.56h1.234v-1.3H9.626zm1.279 0a.14.14 0 0 1-.11-.04l.896-.942a1.16 1.16 0 0 0-.876-.316zm-.11-.04a.14.14 0 0 1-.045-.108l1.3.025a1.16 1.16 0 0 0-.36-.86zm-.046-.096c0 .68-.412 1.293-1.043 1.55l.489 1.204a2.97 2.97 0 0 0 1.854-2.754zm-.986 1.53a.2.2 0 0 1 .054-.008l-.024 1.3q.175.003.345-.048zm.042-.008h-.666v1.3h.666zm-.667 0q.024 0 .043.016l-.855.979c.226.197.515.305.815.305zM8.99 2.189a6.1 6.1 0 0 1-.796 2.296l1.118.662a7.4 7.4 0 0 0 .966-2.785z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="none" id="svg-name-cup-thin" class="svg-sprite__symbol"><path fill="currentColor" d="M10.733 10.82a.737.737 0 0 0-1.473 0zM9.26 16.424a.736.736 0 1 0 1.473 0zm.464-4.919a.736.736 0 1 0 .547-1.368zM6.038 6.631a.736.736 0 0 0-1.242.792zm3.685 3.506a.737.737 0 0 0 .546 1.368zm5.474-2.714a.737.737 0 1 0-1.242-.792zm-5.2 9.737a.737.737 0 1 0 0-1.473zm-2.385-1.473a.737.737 0 0 0 0 1.473zm2.384 0a.737.737 0 0 0 0 1.473zm2.385 1.473a.736.736 0 1 0 0-1.473zM3.213 2.848a.737.737 0 0 0 1.47-.109zm2.508-1.845-.047.735.047.002zm8.551 0v.737q.024 0 .048-.002zm1.295.492.523-.518zm-.256 1.244a.737.737 0 0 0 1.47.109zm-11.363.792a.736.736 0 1 0 0-1.473zM1.9 2.795l-.051.735.05.001zm-.638.23L.754 2.49zM1 3.65h.737v-.014zm2.415 3.585-.277.683.065.023zm.243.034v-.737h-.014zm1.109 0 .001-.737h-.001zm1.127.314a.736.736 0 0 0-.969-1.11zM4.677 2.695a.736.736 0 1 0-1.46.196zm.105 4.708a.736.736 0 1 0 1.268-.75zm11.262-5.345a.736.736 0 1 0 0 1.473zm2.056.737v.736l.051-.001zm.638.23.508-.534zM19 3.65l-.736-.014v.014zm-2.415 3.585.212.706.065-.023zm-.243.034.014-.737h-.014zm-1.109 0v-.737h-.001zm-.158-.795a.737.737 0 0 0-.969 1.11zM16.79 2.89a.737.737 0 0 0-1.46-.196zm-2.833 3.761a.736.736 0 1 0 1.267.75zM9.26 10.82v5.604h1.473V10.82zm1.01-.683a8.96 8.96 0 0 1-4.232-3.506l-1.242.792a10.44 10.44 0 0 0 4.928 4.082zm0 1.368a10.44 10.44 0 0 0 4.927-4.082l-1.242-.792a8.96 8.96 0 0 1-4.232 3.506zm-.273 4.182H7.612v1.473h2.385zm0 1.473h2.384v-1.473H9.996zM4.681 2.74a.93.93 0 0 1 .268-.727L3.904.977a2.4 2.4 0 0 0-.69 1.87zm.268-.727a.93.93 0 0 1 .724-.275l.094-1.47a2.4 2.4 0 0 0-1.864.709zm.771-.273h8.551V.267h-8.55zm8.599-.002a.93.93 0 0 1 .723.275L16.09.977a2.4 2.4 0 0 0-1.865-.709zm.723.275c.19.192.288.457.268.726l1.47.109A2.4 2.4 0 0 0 16.09.977zm-11.095.045H1.9v1.473h2.048zM1.95 2.06a1.58 1.58 0 0 0-1.196.431l1.015 1.067q.034-.03.08-.028zm-1.196.431c-.32.305-.499.731-.49 1.174l1.473-.028q-.001-.046.032-.079zm-.49 1.16a4.605 4.605 0 0 0 2.874 4.268l.554-1.365A3.13 3.13 0 0 1 1.737 3.65zm2.939 4.29q.23.07.469.065l-.028-1.473q-.009 0-.017-.002zm.455.065h1.109V6.533h-1.11zm1.107 0c.415.001.816-.149 1.129-.422l-.969-1.11a.24.24 0 0 1-.157.06zM3.217 2.891a12 12 0 0 0 1.565 4.512l1.268-.75a10.5 10.5 0 0 1-1.373-3.958zm12.827.64H18.1V2.058h-2.056zm2.107-.001a.1.1 0 0 1 .08.028l1.015-1.067a1.58 1.58 0 0 0-1.197-.43zm.08.028c.021.02.033.05.032.079l1.473.028a1.58 1.58 0 0 0-.49-1.174zm.032.093a3.13 3.13 0 0 1-1.955 2.903l.554 1.365a4.605 4.605 0 0 0 2.874-4.268zm-1.89 2.88-.017.002-.028 1.473q.24.004.47-.064zm-.03.002h-1.11v1.473h1.11zm-1.111 0a.24.24 0 0 1-.157-.058l-.969 1.11a1.7 1.7 0 0 0 1.129.421zm.098-3.838a10.5 10.5 0 0 1-1.373 3.957l1.267.75a12 12 0 0 0 1.566-4.511z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cup_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.87 2.439c-.092-.032-.211-.04-.737-.04H5.866c-.525 0-.644.008-.737.04a.8.8 0 0 0-.473.511c-.024.097-.024.198.013.668.151 1.918.546 3.561 1.149 4.705.602 1.143 1.344 1.678 2.187 1.678.841 0 1.582-.534 2.182-1.677.601-1.144.994-2.788 1.144-4.706.037-.47.037-.571.013-.668a.8.8 0 0 0-.473-.511m-.657-1.24c.402 0 .74 0 1.046.105.595.203 1.09.738 1.247 1.347.064.25.061.499.043.775.34-.054.692-.017 1.004.095.683.247 1.245.877 1.245 1.818 0 .936-.584 1.67-1.265 2.18-.607.453-1.363.788-2.1.99q-.089.193-.184.373c-.42.798-.966 1.466-1.649 1.877.014.894.22 1.214.38 1.422q.04.052.094.116c.209.247.53.628.53 1.302v.6a.6.6 0 0 1-.6.6h-4a.6.6 0 0 1-.6-.6v-.6c0-.672.318-1.052.525-1.3q.054-.062.095-.116c.157-.208.363-.53.375-1.43-.679-.41-1.224-1.075-1.643-1.87a8 8 0 0 1-.183-.372c-.739-.203-1.497-.538-2.105-.993-.68-.509-1.265-1.243-1.265-2.179 0-.941.562-1.57 1.245-1.817.312-.113.663-.15 1.003-.096-.018-.276-.021-.524.043-.774A2 2 0 0 1 4.74 1.304c.307-.106.645-.105 1.046-.105h4.427M3.581 4.752l-.005.005c-.138-.138-.43-.212-.72-.107-.25.09-.453.297-.453.69 0 .396.249.817.784 1.217.249.187.541.353.854.493a16 16 0 0 1-.46-2.298m4 6.421c-.069.871-.316 1.358-.6 1.734q-.105.137-.176.224c-.163.204-.2.25-.2.468h2.8c0-.216-.037-.261-.202-.465-.048-.059-.106-.131-.178-.225-.287-.376-.537-.863-.606-1.735a3.2 3.2 0 0 1-.838-.001m4.38-4.124a4.5 4.5 0 0 0 .853-.492c.535-.4.784-.82.784-1.218 0-.392-.203-.599-.452-.689-.292-.105-.583-.031-.72.107l-.006-.005a16 16 0 0 1-.458 2.297" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-cup_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.043 2h-6.086c-.66 0-1.22 0-1.684.042-.49.044-.954.141-1.397.382a3.63 3.63 0 0 0-1.54 1.68c-.26.599-.29 1.233-.249 1.953a3.76 3.76 0 0 0-1.848.142C3.045 6.607 2 7.674 2 9.333c0 1.568.935 2.993 2.15 3.984a7.55 7.55 0 0 0 3.754 1.628q.255.605.545 1.148c.72 1.345 1.645 2.452 2.785 3.14-.033.553-.114.93-.204 1.195-.111.327-.25.518-.4.685-.062.069-.114.123-.18.19l-.117.12a3.6 3.6 0 0 0-.385.46c-.288.421-.448.917-.448 1.567V25a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-1.55c0-.65-.16-1.146-.448-1.566a3.6 3.6 0 0 0-.385-.462l-.117-.12a5 5 0 0 1-.18-.189 1.85 1.85 0 0 1-.4-.685c-.09-.264-.171-.642-.204-1.195 1.14-.688 2.065-1.795 2.785-3.14q.29-.543.545-1.147a7.55 7.55 0 0 0 3.755-1.63C25.065 12.327 26 10.902 26 9.334c0-1.659-1.045-2.726-2.24-3.134a3.76 3.76 0 0 0-1.848-.142c.041-.72.013-1.354-.248-1.954a3.63 3.63 0 0 0-1.54-1.68c-.444-.24-.906-.337-1.397-.381C18.264 2 17.703 2 17.043 2m-2.22 17.939a5.5 5.5 0 0 1-1.647 0 5.8 5.8 0 0 1-.253 1.135 3.8 3.8 0 0 1-.803 1.373c-.093.104-.197.21-.276.29l-.07.073a2 2 0 0 0-.175.203c-.04.059-.099.153-.099.437V24h5v-.55c0-.284-.059-.378-.099-.437a1.7 1.7 0 0 0-.197-.226l-.048-.05c-.079-.08-.183-.186-.276-.29a3.8 3.8 0 0 1-.803-1.373 5.8 5.8 0 0 1-.253-1.135m7.764-8.172c-.502.409-1.094.74-1.725.955.377-1.351.657-2.843.845-4.432.25-.25.82-.398 1.407-.198.515.176.886.567.886 1.241 0 .766-.482 1.674-1.413 2.434m-15.449.955c-.377-1.351-.657-2.843-.845-4.432-.25-.25-.82-.398-1.407-.198C4.37 8.268 4 8.66 4 9.333c0 .766.482 1.674 1.413 2.434.502.409 1.094.74 1.725.955m1.692-8.54c.114-.062.278-.117.623-.148C9.816 4 10.285 4 11 4h6c.714 0 1.184 0 1.547.034.345.031.509.086.623.148.268.145.538.44.66.72.129.295.128.63.008 2.007-.298 3.431-1.001 6.28-2.05 8.24C16.744 17.098 15.463 18 14 18s-2.744-.901-3.788-2.852C9.162 13.19 8.46 10.34 8.162 6.91c-.12-1.377-.12-1.712.008-2.008.122-.28.392-.574.66-.72" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" id="svg-name-default-avatar" class="svg-sprite__symbol"><path fill="#CBCBCB" fill-rule="nonzero" d="M20 29.21c5.007 0 15 2.54 15 7.58V41H5v-4.21c0-5.04 9.993-7.58 15-7.58M20 25a7 7 0 1 1 0-14 7 7 0 0 1 0 14"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 4h14"/><path stroke="currentColor" stroke-width="1.5" d="M4 6v9.5a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6M8 6v10.5M12 6v10.5M12 4V3a2 2 0 1 0-4 0v1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete-all-messages" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m18.041 1.959-4.628 4.628m-.001-4.628 4.628 4.628"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M16 10.964c0 3.847-3.134 6.965-7 6.965a7 7 0 0 1-1.615-.187c-.757-.245-2.845.476-4.018.926-.262.1-.527-.202-.401-.452.435-.864 1-2.21.65-2.802A6.9 6.9 0 0 1 2 10.965C2 7.118 5.134 4 9 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.837 4H2.75a.75.75 0 0 0 0 1.5h.545l.907 9.248c.051.523.094.96.157 1.314.066.37.163.711.353 1.028a2.9 2.9 0 0 0 1.247 1.131c.334.158.682.222 1.058.25.36.029.797.029 1.323.029h3.32c.526 0 .964 0 1.323-.028.376-.03.724-.093 1.058-.25a2.9 2.9 0 0 0 1.247-1.132c.19-.317.287-.657.353-1.028.063-.355.106-.79.157-1.314l.907-9.248h.545a.75.75 0 0 0 0-1.5h-4.087a3.25 3.25 0 0 0-6.326 0m1.581 0h3.164a1.751 1.751 0 0 0-3.164 0m6.78 1.5H4.802l.89 9.073c.054.56.091.936.143 1.227.05.281.104.422.162.52a1.4 1.4 0 0 0 .603.546c.102.048.248.088.533.11.294.024.673.024 1.235.024h3.262c.562 0 .941 0 1.235-.023.285-.023.43-.063.533-.111a1.4 1.4 0 0 0 .603-.547c.058-.097.112-.238.162-.52.052-.29.09-.667.144-1.226zm-2.886 2.002a.75.75 0 0 1 .685.81l-.5 6.003a.75.75 0 0 1-1.494-.124l.5-6.003a.75.75 0 0 1 .81-.686m-4.624 0a.75.75 0 0 1 .81.686l.5 6.002a.75.75 0 0 1-1.495.125l-.5-6.003a.75.75 0 0 1 .685-.81" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.13 6.752a.75.75 0 0 1 .702.795l-.417 6.667a.75.75 0 1 1-1.497-.094l.417-6.666a.75.75 0 0 1 .795-.702M7.87 6.752a.75.75 0 0 0-.702.795l.417 6.667a.75.75 0 1 0 1.497-.094l-.417-6.666a.75.75 0 0 0-.795-.702" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2.5 3.417a.75.75 0 0 0 0 1.5h.984l.962 10.263c.038.404.07.749.12 1.031.05.299.13.587.291.858.246.412.608.742 1.041.948.286.135.58.187.881.21.287.023.633.023 1.038.023h4.366c.405 0 .751 0 1.038-.022a2.5 2.5 0 0 0 .88-.211 2.4 2.4 0 0 0 1.041-.948c.162-.271.241-.559.293-.858.049-.282.081-.627.12-1.03l.961-10.264h.984a.75.75 0 0 0 0-1.5h-4.337a3.251 3.251 0 0 0-6.326 0zm3.437 11.596c.04.438.068.724.106.942.036.21.073.296.104.347.093.157.23.282.394.36.054.025.144.054.356.07.22.018.508.018.948.018h4.31c.44 0 .728 0 .948-.017.212-.017.302-.046.356-.071a.9.9 0 0 0 .394-.36c.03-.05.068-.138.104-.347.038-.218.065-.504.106-.942l.947-10.096H4.99zM10 2.417c-.698 0-1.3.409-1.582 1h3.164a1.75 1.75 0 0 0-1.582-1" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-description" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.049a2 2 0 0 0-1.993-2L4.007 3.007a2 2 0 0 0-2.007 2V18l3-3h10.984a2 2 0 0 0 2-2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.252h8.5M5.75 10.752h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-description-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C18 4.28 18 5.12 18 6.8v6.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 18 14.88 18 13.2 18H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 15.72 2 14.88 2 13.2z"/><path fill="currentColor" d="M2 6.25a.75.75 0 0 0 0 1.5zm16 1.5a.75.75 0 0 0 0-1.5zm-16 0h16v-1.5H2zM5 10.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5zM5 13.25a.75.75 0 0 0 0 1.5zm6 1.5a.75.75 0 0 0 0-1.5zm-6 0h6v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="33" height="30" id="svg-name-desktop" class="svg-sprite__symbol"><path fill="currentColor" d="M29.73 0a2.7 2.7 0 0 1 2.702 2.703v18.919a2.7 2.7 0 0 1-2.702 2.702H17.837v2.703h5.136c.439-.006.85.2 1.107.549l.08.121a1.351 1.351 0 0 1-1.187 2.033H9.459a1.351 1.351 0 1 1 0-2.703h5.135v-2.703H2.703a2.7 2.7 0 0 1-2.698-2.531L0 21.622V2.702A2.7 2.7 0 0 1 2.703 0zM16.216 20.27a1.352 1.352 0 1 0 .001 2.704 1.352 1.352 0 0 0 0-2.704zM29.73 2.703H2.703v16.216H29.73z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" id="svg-name-diamond" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2.27 13.899 6.413-9.62c.2-.3.538-.481.899-.481h16.844c.361 0 .698.18.899.48l6.414 9.621c.273.41.234.955-.096 1.322l-15.64 17.376L2.366 15.221a1.08 1.08 0 0 1-.096-1.322" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m13.328 18.199-3.426-3.6 2.694-3.601"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-diamond_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.063 4a1 1 0 0 0-.442.103l-4.05 1.994a1 1 0 0 0-.431.393l-2.985 4.975a1 1 0 0 0-.11.237 1 1 0 0 0 .118.845q.06.095.144.174l10.98 10.98.04.039a1 1 0 0 0 .601.257l.024.002h.002a1 1 0 0 0 .759-.297l10.98-10.98.015-.015a1 1 0 0 0 .259-.449 1 1 0 0 0-.16-.85L22.32 6.427a1 1 0 0 0-.349-.31l-3.544-1.989a1 1 0 0 0-.49-.128zM21.12 8.202l-3.39 1.233 1.206 3.214q0 .004.003.008l4.432-1.24zM16.932 13l-1.125-3h-3.614l-1.125 3zm-7.871-.343q0-.004.003-.008l1.191-3.177-3.81-1.27-1.913 3.188zM8.627 6.82 10.296 6h7.38l1.434.805L15.824 8h-3.661zm2.272 11.664L6.405 13.99l2.851.797zM14 20.538 11.54 15h4.923zm3.101-2.053 1.643-3.697 2.851-.797z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-1" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-2" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m5.6-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-3" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6m2.8-2.8c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-4" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m0-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m5.6 0c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m0 5.6c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-5" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m0-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6m2.8-2.8c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m0 5.6c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-6" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" fill-rule="evenodd" d="M3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0m1.4 2c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4-1.4-.63-1.4-1.4S4.13 2 4.9 2m0 3.6c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4S3.5 7.77 3.5 7s.63-1.4 1.4-1.4m5.6-2.2c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4.63 1.4 1.4 1.4 1.4-.63 1.4-1.4M9.1 5.6c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4S7.7 7.77 7.7 7s.63-1.4 1.4-1.4m-2.8 5c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4.63 1.4 1.4 1.4 1.4-.63 1.4-1.4m2.8-1.4c.77 0 1.4.63 1.4 1.4S9.87 12 9.1 12s-1.4-.63-1.4-1.4.63-1.4 1.4-1.4" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-dice-outlined" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" clip-path="url(#a)"><path d="M15 19H5c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4"/><path d="M10 10.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-dice_5_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.6 5h2.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v2.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-2.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C5.001 18.278 5 17.113 5 15.4v-2.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36C9.722 5.001 10.887 5 12.6 5M3 12.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C7.56 3 9.24 3 12.6 3h2.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C25 7.56 25 9.24 25 12.6v2.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C20.44 25 18.76 25 15.4 25h-2.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C3 20.44 3 18.76 3 15.4zm6.25 7.9a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M11 9.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3 6.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m6.5-6.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M18.75 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" id="svg-name-dislike-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M6.958 15.519c-.025.504.016.981.212 1.348.104.195.253.361.454.475.199.113.419.158.64.158.165 0 .38-.05.598-.137.227-.091.49-.238.74-.461.514-.459.935-1.206.935-2.34 0-1.016-.194-1.76-.335-2.304l-.021-.081c-.156-.602-.155-.76-.07-.893.03-.048.098-.108.244-.16s.328-.081.524-.092a4 4 0 0 1 .713.033h.01v.001l.37.06.161-.337L13.29 8.38l.054-.114-.006-.126-.242-5.005-.004-.093-.038-.085-.723-1.641-.09-.206-.215-.068-.153.476.153-.476h-.001l-.002-.001-.005-.002-.016-.005-.056-.016-.205-.054c-.178-.044-.438-.1-.776-.155A17 17 0 0 0 8.038.606c-.886.01-1.79.399-2.457.743a19 19 0 0 0-.856.474 5 5 0 0 1-.254.139l-.007.003c-.159-.01-.528-.049-.976-.1-.511-.06-1.078-.13-1.421-.177a.72.72 0 0 0-.572.18 1.3 1.3 0 0 0-.28.37c-.134.255-.239.595-.323.962-.17.743-.28 1.725-.314 2.696-.034.968.006 1.96.152 2.718.072.373.177.73.339 1.004.16.27.455.574.91.535q.214-.018.393-.037c.395-.04.684-.069.974-.026.322.048.655.193 1.063.656a7.6 7.6 0 0 0 1.25 1.17c.24.184.464.356.797.688.32.321.475.84.526 1.434.041.473.012.919-.01 1.256zM4.424 1.983Z"/><path fill="url(#b)" stroke="currentColor" d="M8.556 9.357c.02.516.267.907.626 1.174.339.253.768.391 1.186.472.832.161 1.815.126 2.469.101h.023l.08-.003a4 4 0 0 0 1.089-.216 2.24 2.24 0 0 0 .905-.587c.274-.307.445-.713.44-1.219a1.58 1.58 0 0 0-.358-1.021 1.77 1.77 0 0 0-.762-.512c-.516-.187-1.074-.18-1.314-.171l-2.118.08c-.58.023-1.154.12-1.586.416-.478.328-.704.84-.68 1.486Z"/><path fill="url(#c)" stroke="currentColor" d="M10.154 2.778c.61-.106 1.41-.186 2.155-.205.373-.01.74-.004 1.065.023.317.026.629.075.875.167zm0 0c-.578.102-1.001.38-1.259.762-.25.373-.316.805-.261 1.176zm3.359 3.16c-.271.009-.495.013-.688.016-.423.008-.7.013-1.004.049a9 9 0 0 1-1.007.065zm0 0c1.17-.033 1.703-1.023 1.682-1.746-.02-.702-.418-1.231-.946-1.429zm-3.936-.121c-.364-.17-.856-.507-.943-1.1zm0 0c.38.176.81.262 1.078.254z"/><path fill="url(#d)" stroke="currentColor" d="M13.317.74C13 .64 12.477.56 11.94.522 11.401.485 10.79.49 10.295.583c-.504.097-.899.292-1.148.64-.24.335-.279.725-.279 1.05 0 .903.756 1.45 1.402 1.45.237 0 .421-.04.584-.076l.06-.014a4.5 4.5 0 0 1 .775-.1 5 5 0 0 1 .534.026c.209.017.454.037.681.037.235 0 .573-.026.857-.225.323-.226.462-.59.462-1.015 0-.343-.04-.68-.173-.968a1.18 1.18 0 0 0-.733-.648Z"/><path fill="url(#e)" stroke="currentColor" d="M15.847 6.558c-.005-.294-.079-.774-.46-1.174-.389-.408-1.01-.641-1.915-.623a79 79 0 0 0-2.729.103c-.291.015-.5.025-.616.028a1.95 1.95 0 0 0-1.038.337c-.389.274-.687.732-.674 1.4.013.636.272 1.098.65 1.388.35.269.764.36 1.088.358l.038.002.166.007c.148.005.375.011.69.016.63.008 1.614.01 3.043-.019.654-.013 1.117-.307 1.401-.697.268-.37.363-.803.356-1.126Z"/><g clip-path="url(#f)"><path fill="url(#g)" d="M8.265 17c-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.076-.76-2.025-1.836-.95-1.077-1.74-.855-2.848-.76-1.392.12-.918-7.606.063-7.472.696.095 2.279.285 2.532.285S6.52 1.122 8.043 1.106c2.468-.026 3.83.412 3.83.412l.723 1.64.242 5.006-1.155 2.408s-1.551-.253-1.994.444c-.443.696.348 1.551.348 3.546S8.581 17 8.265 17"/><path fill="url(#h)" d="m11.959 1.533-.094.342c-.279.03-.636-.097-1.125-.093-2.334.018-4.565.688-5.522 1.447-.627.496-.902 1.157-1.345.967-.547-.234-2.097-.599-2.668.123.16-1.235.445-2.184.794-2.136.696.095 2.279.285 2.532.285s1.94-1.31 3.512-1.362a19.4 19.4 0 0 1 3.84.284z"/><path fill="url(#i)" d="M2.924 9.167c.918-.253 1.5.166 1.97.736.466.566.87 1.069 2.041 1.828s1.02 2.85.926 3.546c-.095.697-.032 1.723.404 1.723-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.075-.76-2.025-1.836s-1.74-.855-2.848-.76c0-.24.07-.235.988-.488"/><path fill="url(#j)" d="M9.689 11.016c-.443.697.348 1.551.348 3.546S8.582 17 8.265 17a.9.9 0 0 1-.224-.027c1.291-.081 2.069-1.71 1.624-3.39-.361-1.363-.541-2.455.048-3.096.382-.415 1.14-.344 1.97.086 0 0-1.551-.254-1.994.443"/><path fill="url(#k)" d="M9.776 10.305c-.76-.253-2.678-.85-4.13-2.167-3.682-3.34 2.604-3.76 3.902-6.616.248-.546 1.699 2.864 1.699 2.864l.469.79-1.356 3.61z"/><path fill="url(#l)" d="M9.887 10.016c-.76-.253-3.862-2.242-3.862-3.224 0-2.833 2.149-1.435 3.31-4.779.16-.463.729-.852.729-.852.47.384 1.183 3.225 1.183 3.225l.469.79-1.356 3.61z"/><path fill="url(#m)" d="m11.64 1.33 1.454 1.663.32 6.946-3.638.366c-.836-.45-.932-1.064-.622-2.052.13-.416-.4-.535-.434-1.745-.024-.84.525-.843.525-1.093s-.273-.227-.364-.95c-.13-1.033.735-1.053.735-1.274s-.48-.353-.45-1.195c.037-1.069-1.947-.853-3.288.12-.55.399-1.031.44-1.406.35l.058.001c.253 0 1.953-1.361 3.513-1.361 1.823 0 3.085.107 3.597.224"/><path fill="url(#n)" d="M11.974 9.847c-1.123 0-1.74-1.098-1.313-1.942s-.791-1.96-.665-2.51c.127-.55.349-1.942.522-2.172s-.285-.753-.285-.753l1.425-.174 1.329.586-.048 4.02.142 2.517z"/><path fill="url(#o)" d="M4.784 10.414c-.617-.699-1.167-.85-1.78-.845.177-.285.3-.597.287-.902-.033-.8.143-1.786.277-.76.103.78.632 1.746 1.269 2.567z"/><path fill="url(#p)" d="M12.825 10.604c-1.328.051-3.716.126-3.769-1.266-.038-1.01.677-1.34 1.784-1.383l2.119-.08c.459-.018 1.9-.01 1.915 1.21.017 1.523-2.049 1.52-2.049 1.52"/><path fill="url(#q)" d="M10.64 5.571c-.355.01-1.413-.256-1.511-.928-.078-.528.191-1.21 1.111-1.372 1.166-.204 3.108-.311 3.834-.04.324.122.607.461.621.976a1.21 1.21 0 0 1-1.197 1.232c-.83.024-1.263.011-1.736.067-.57.067-.836.057-1.121.065"/><path fill="url(#r)" d="M10.27 3.223a.94.94 0 0 1-.902-.95c0-.593.154-1.032 1.02-1.199.867-.166 2.256-.023 2.778.143.407.13.557.51.557 1.14s-.391.738-.819.738-.945-.077-1.241-.062c-.827.044-.99.19-1.393.19"/><path fill="url(#s)" d="M12.712 10.323c-1.16.044-3.245.111-3.287-.99-.03-.797.596-1.061 1.563-1.098.966-.037 3.509-.084 3.517.88.011 1.204-1.793 1.208-1.793 1.208"/><path fill="url(#t)" d="M10.748 5.288c-.31.009-1.178-.065-1.26-.707-.057-.434.168-.992.97-1.125 1.014-.17 2.705-.26 3.337-.038.281.099.527.376.54.798.012.421-.377.938-1.1.96-.723.02-1.107-.047-1.52 0-.494.055-.72.105-.967.112"/><path fill="url(#u)" d="M10.443 3.007c-.35 0-.78-.287-.78-.765s.133-.832.882-.965c.75-.134 1.95-.02 2.402.114.352.105.483.411.483.918s-.339.595-.708.595c-.37 0-.819-.063-1.075-.05-.715.035-.855.153-1.204.153"/><path fill="url(#v)" d="M10.23 9.333c.029.759.633 1.122 1.397 1.29-1.219-.029-2.531-.257-2.571-1.285-.038-1.01.677-1.34 1.784-1.383q.183-.007.346-.013c-.622.182-.986.592-.956 1.391"/><path fill="url(#w)" d="M10.334 10.485c-.71-.155-1.253-.49-1.278-1.147-.032-.84.458-1.21 1.26-1.335-1.627.65-1.043 2.25.018 2.482"/><path fill="url(#x)" d="M7.228 2.937c-.126-.452-1.007-.602-1.966-.335-.96.268-1.635.852-1.509 1.305s1.007.603 1.966.335 1.635-.851 1.51-1.305"/><path fill="url(#y)" d="M13.82 9.13c-.009-.583-.787-.86-1.64-.91-.696-.043-1.469.45-1.449 1.02.02.568.121 1.072 1.569 1.022.853-.03 1.53-.563 1.52-1.132"/><path fill="url(#z)" d="M13.975 4.01c-.004-.807-.891-.653-1.743-.709-1.08-.071-1.796.265-1.796.835-.001.57.41.984 1.858.986.853.002 1.687-.076 1.681-1.113"/><path fill="url(#A)" d="M13.194 1.976c-.004-.688-.81-.781-1.573-.782-.763 0-1.591.404-1.592.89 0 .485.367.839 1.662.84.763.002 1.509-.065 1.503-.948"/><path fill="url(#B)" d="M10.119 4.48c.121.918.825.865 1.633.96-.93.07-1.32.08-1.32.08a1.4 1.4 0 0 1-.284-.002c-.302-.067-.644-.204-.848-.462a1.1 1.1 0 0 1-.161-.351l-.01-.061c-.066-.53.191-1.212 1.111-1.373q.201-.035.426-.065l.234-.03.068-.008c-.507.24-.938.637-.85 1.312"/><path fill="url(#C)" d="M10.344 5.525a2 2 0 0 1-.197-.007c-.304-.068-.65-.207-.852-.469a1.1 1.1 0 0 1-.156-.345l-.01-.06c-.093-.523.165-1.138.97-1.342-1.372.757-.787 2.222.245 2.223"/><path fill="url(#D)" d="M11.142 3.083c-.405.06-.572.14-.872.14a.94.94 0 0 1-.902-.949c0-.216.021-.41.088-.58.068-.14.168-.27.304-.38.15-.105.353-.186.629-.24.185-.035.394-.056.614-.066-.424.246-1.141.378-.99 1.202.166.909.708.786 1.13.873"/><path fill="url(#E)" d="M10.252 3.223a.944.944 0 0 1-.884-.95c0-.543.13-.958.818-1.15-1.074.69-.73 1.855.066 2.1"/><path fill="url(#F)" d="M14.874 9.085q.001.203-.043.374c.107-.476-.317-.949-1.44-1.178-.745-.152-2.722-.342-4.09.201.295-.357.839-.5 1.54-.526l2.118-.081c.459-.018 1.9-.01 1.915 1.21"/><path fill="url(#G)" d="M14.696 4.24c-.002.51-.385 1.176-1.198 1.199-.83.024-1.263.011-1.736.067-.57.067-.837.057-1.121.065-.215.007-.746-.058-1.107-.283a4.8 4.8 0 0 1 1.997-.293c2.23.144 2.864-.126 3.164-.756"/><path fill="url(#H)" d="M10.163 7.875c-.475.01-1.228-.27-1.248-1.256-.02-.985.842-1.22 1.222-1.228.38-.007 1.707-.098 3.345-.13 1.637-.033 1.856.846 1.866 1.306.009.461-.283 1.294-1.268 1.314-2.848.058-3.917-.006-3.917-.006"/><path fill="url(#I)" d="M10.418 7.589c-.413.008-1.067-.206-1.082-.966s.734-.943 1.064-.95 1.484-.079 2.907-.107c1.424-.029 1.613.649 1.62 1.005s-.042.998-.898 1.015c-2.476.05-3.611.003-3.611.003"/><path fill="url(#J)" d="M9.934 6.715c.047 1.011.753 1.014 1.55 1.19-.932-.007-1.321-.03-1.321-.03-.475.01-1.228-.27-1.248-1.255-.02-.986.842-1.22 1.222-1.228.137-.003.397-.016.75-.034-.526.217-.988.612-.953 1.357"/><path fill="url(#K)" d="M14.513 6.61c.033-.806-.861-.958-1.714-.998s-1.8.39-1.828.959c-.027.568.364 1.002 1.81 1.072.854.041 1.69.002 1.732-1.033"/><path fill="url(#L)" d="M10.074 7.873c-.474-.025-1.14-.327-1.16-1.253-.018-.937.76-1.196 1.163-1.225-1.56.63-1.049 2.385-.003 2.478"/><path fill="url(#M)" d="M15.345 6.667c-.206-1.458-4.06-1.19-6.141-.878.28-.3.699-.392.933-.397.38-.008 1.707-.098 3.345-.131 1.637-.033 1.856.846 1.866 1.307q0 .047-.003.1"/><path fill="url(#N)" d="M13.415 3.42c-.747-.033-2.722-.278-4.161.493.16-.298.471-.552.986-.642 1.166-.204 3.108-.311 3.834-.04.324.122.607.461.621.976-.047-.448-.474-.751-1.28-.787"/><path fill="url(#O)" d="M13.666 1.8c-.489-.373-1.334-.592-2.554-.386-.753.127-1.27.17-1.609.18.136-.246.398-.426.886-.52.866-.166 2.255-.024 2.777.142.268.086.424.281.5.584"/><path fill="url(#P)" d="M9.529 2.808c.903.329 1.346-.16 2.313-.16 1.004 0 1.483.406 1.84.02-.113.356-.433.428-.777.428-.428 0-.946-.078-1.242-.063-.827.044-.99.19-1.393.19a.94.94 0 0 1-.741-.415"/><path fill="url(#Q)" d="M1.999 2.183c.696.095 2.279.285 2.532.285C2.236 4.109 3.256 7.6 4.103 9.365c.119.248.192.452.232.624-.764-.582-1.47-.414-2.4-.334-1.39.119-.917-7.606.064-7.472"/><path fill="url(#R)" d="M4.53 2.467c-.196.168-.433.45-.647.723 0 0-1.152-.59-2.388-.312.143-.451.314-.721.504-.695.696.094 2.279.284 2.532.284"/><path fill="url(#S)" d="M9.003 14.096c-.45-.097-.816.526-1.023 1.253-.169.595.06 1.352.504 1.438.443.085.852.089 1.096-1.172.143-.742-.136-1.424-.577-1.519"/><path fill="url(#T)" d="M11.683 10.573s-1.551-.253-1.994.443c-.443.697.348 1.552.348 3.546 0 1.995-1.456 2.438-1.772 2.438-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.076-.76-2.025-1.836-.95-1.076 5.885-.3 6.898.158"/><path fill="#804B24" d="M10.252 3.223a.91.91 0 0 1-.675-.3.98.98 0 0 1-.249-.712c.008-.248.046-.518.208-.726.16-.21.411-.309.65-.363-.231.084-.461.202-.598.401-.139.197-.175.447-.177.69a.94.94 0 0 0 .214.668.97.97 0 0 0 .627.342M9.854 5.431a1.3 1.3 0 0 1-.473-.251.9.9 0 0 1-.279-.467v-.002a1.3 1.3 0 0 1-.013-.486 1.1 1.1 0 0 1 .195-.446c.195-.268.505-.418.813-.477-.3.097-.58.264-.754.519a1.14 1.14 0 0 0-.168.875l-.001-.003c.046.166.114.33.241.45.125.12.276.217.44.288"/><path fill="#804B24" d="M10.074 7.873a1.22 1.22 0 0 1-.824-.315c-.227-.208-.344-.514-.369-.814-.024-.299.025-.623.212-.87.184-.248.472-.392.762-.445-.283.083-.548.244-.71.483-.164.238-.21.538-.18.825.017.288.127.57.33.776.202.205.485.327.779.36M10.334 10.485c-.32-.056-.645-.154-.913-.359a1.05 1.05 0 0 1-.406-.886c0-.33.114-.686.382-.9.262-.218.597-.3.919-.337-.318.068-.639.171-.877.384-.242.212-.346.536-.342.854a1 1 0 0 0 .364.836c.247.203.56.322.873.408M9.254 3.913c.094-.19.245-.352.428-.466a1.7 1.7 0 0 1 .603-.211q.628-.11 1.262-.164c.424-.027.848-.04 1.273-.029.422.015.854.04 1.254.19a2.7 2.7 0 0 0-.623-.106 7 7 0 0 0-.633-.028 14 14 0 0 0-1.265.056q-.632.038-1.259.135c-.41.056-.825.25-1.04.623"/><path fill="#804B24" d="M9.204 5.789c.152-.17.357-.292.576-.36.222-.073.458-.063.683-.078l1.364-.067 1.365-.04c.45-.025.926-.01 1.348.17-.434-.149-.895-.142-1.347-.115l-1.364.067-1.365.04c-.229.01-.456-.004-.672.061-.219.055-.427.16-.588.322M14.08 7.882c-.652.035-1.306.048-1.959.055-.653.01-1.306.01-1.96-.03h.003a1.3 1.3 0 0 1-.92-.366 1.1 1.1 0 0 1-.258-.429 1.7 1.7 0 0 1-.07-.492c.014.33.125.66.361.888.232.23.565.34.885.335h.003c.325.012.652.014.978.017l.978.013.98.002c.326-.004.652.006.979.007"/></g><defs><linearGradient id="a" x1="11.734" x2="6.973" y1="9.184" y2="8.993" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="b" x1="14.649" x2="9.986" y1="9.248" y2="9.248" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="c" x1="14.649" x2="9.983" y1="4.32" y2="4.32" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="d" x1="14.649" x2="9.985" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="e" x1="14.649" x2="9.985" y1="6.582" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="g" x1="11.734" x2="6.973" y1="9.184" y2="8.993" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="h" x1="6.934" x2="6.601" y1="6.705" y2="3.132" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="i" x1="5.985" x2="9.571" y1="12.007" y2="6.88" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="j" x1="3.39" x2="12.575" y1="14.05" y2="13.362" gradientUnits="userSpaceOnUse"><stop offset=".312" stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FF8900"/></linearGradient><linearGradient id="k" x1="3.215" x2="15.276" y1="5.884" y2="5.884" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="l" x1="1.27" x2="25.099" y1="5.865" y2="5.107" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="m" x1="5.056" x2="8.997" y1="2.752" y2="4.887" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="n" x1="9.57" x2="12.857" y1="5.783" y2="6.215" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="o" x1="3.738" x2="4.451" y1="13.038" y2="1.237" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="p" x1="14.649" x2="9.986" y1="9.248" y2="9.248" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="q" x1="14.649" x2="9.983" y1="4.32" y2="4.32" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="r" x1="14.649" x2="9.986" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="s" x1="9.357" x2="11.786" y1="9.225" y2="9.28" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="t" x1="13.604" x2="11.129" y1="4.287" y2="4.287" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="u" x1="13.604" x2="11.129" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="v" x1="10.582" x2="9.261" y1="9.282" y2="9.282" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="w" x1="10.345" x2="8.826" y1="9.244" y2="9.244" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#E89043"/></linearGradient><linearGradient id="B" x1="10.74" x2="8.826" y1="4.346" y2="4.346" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="C" x1="10.334" x2="9.302" y1="4.413" y2="4.413" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="D" x1="10.672" x2="8.433" y1="2.099" y2="2.51" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="E" x1="10.44" x2="9.494" y1="2.172" y2="2.172" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="F" x1="11.949" x2="12.55" y1="9.542" y2="6.629" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="G" x1="12.406" x2="11.749" y1="3.787" y2="6.156" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="H" x1="14.649" x2="9.985" y1="6.582" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="I" x1="9.797" x2="13.369" y1="6.712" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset=".738" stop-color="#FFD748"/><stop offset="1" stop-color="#FFCB4B"/></linearGradient><linearGradient id="J" x1="11.191" x2="8.523" y1="6.63" y2="6.63" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="L" x1="9.951" x2="9.108" y1="6.634" y2="6.634" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="M" x1="12.17" x2="12.677" y1="6.891" y2="3.669" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="N" x1="11.819" x2="13.117" y1="4.398" y2="1.581" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="O" x1="11.56" x2="11.75" y1="1.927" y2=".146" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="P" x1="11.605" x2="11.605" y1="2.197" y2="3.485" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="Q" x1="2.754" x2="1.091" y1="6.923" y2="11.993" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="R" x1="3.044" x2="2.949" y1="3.847" y2=".214" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="T" x1="8.129" x2="9.348" y1="9.87" y2="20.896" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="matrix(1.78622 -.4985 .23148 .82945 5.318 3.733)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(1.58576 -.05613 .03684 1.04078 12.278 9.237)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="matrix(1.70407 .00162 -.00087 .91862 12.201 4.123)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="A" cx="0" cy="0" r="1" gradientTransform="matrix(1.5602 .00147 -.00092 .9765 11.612 2.058)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="K" cx="0" cy="0" r="1" gradientTransform="matrix(1.74287 .08329 -.05467 1.14396 12.74 6.625)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="S" cx="0" cy="0" r="1" gradientTransform="matrix(.31719 -1.64272 .96366 .18607 8.786 15.45)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><clipPath id="f"><path fill="#fff" d="M0 1h16v16H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-donation-alerts" class="svg-sprite__symbol"><path fill="url(#a)" d="M18.254 4.436 14.7.301C14.525.1 14.3 0 14.05 0H3.436c-.45 0-.801.326-.851.752L1.309 15.288a.8.8 0 0 0 .226.652.85.85 0 0 0 .625.275h2.078L3.912 20l4.105-3.785h4.656a.72.72 0 0 0 .575-.25l4.38-4.26a.87.87 0 0 0 .25-.527l.526-6.14c.05-.2-.025-.426-.15-.602M15 10.026c-.025.2-.1.4-.25.525l-2.528 2.431a.84.84 0 0 1-.576.226H5.44c-.375 0-.7-.25-.8-.601-.05-.1-.05-.201-.05-.301l.75-8.522a.843.843 0 0 1 .826-.776h6.307c.25 0 .476.1.626.275L15.1 5.59c.15.175.226.4.2.627zm-4.955 1.628H8.818c-.075 0-.15-.025-.175-.075s-.075-.125-.075-.2l.1-1.229c0-.125.125-.225.25-.225h1.227c.075 0 .15.025.175.075s.075.125.075.2l-.1 1.229c0 .125-.125.225-.25.225m.225-2.33H9.018c-.15 0-.25-.1-.25-.251l.325-3.885c.025-.125.126-.226.25-.226h1.252c.15 0 .25.1.25.251l-.35 3.885c0 .125-.1.225-.225.225"/><defs><linearGradient id="a" x1="14.758" x2="-.462" y1="-1.213" y2="16.522" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none" id="svg-name-done_16" class="svg-sprite__symbol"><path fill="currentColor" d="M11.743.756a.87.87 0 0 1 0 1.237l-7.317 7.25a.88.88 0 0 1-1.242 0L.257 6.366a.87.87 0 0 1 0-1.237.88.88 0 0 1 1.242 0L3.805 7.39 10.5.756a.88.88 0 0 1 1.242 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-door_arrow_left_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M15.628 16.972c-.635.34-1.26.445-2.568.445h-2.227a.75.75 0 0 1 0-1.5h2.227c1.24 0 1.559-.106 1.86-.268q.42-.225.645-.644c.162-.302.268-.622.268-1.86V6.856c0-1.239-.106-1.559-.268-1.86a1.54 1.54 0 0 0-.644-.645c-.302-.161-.622-.268-1.86-.268h-2.212a.75.75 0 1 1-.016-1.5h2.227c1.308 0 1.933.106 2.568.445.541.29.97.719 1.26 1.26.34.635.445 1.26.445 2.568v6.287c0 1.308-.105 1.933-.445 2.568a3.04 3.04 0 0 1-1.26 1.26"/><path fill="currentColor" d="m7.803 12.804 2.053-2.053H3.25a.75.75 0 0 1 0-1.5h6.606L7.803 7.198a.75.75 0 0 1 1.06-1.06l3.334 3.332a.75.75 0 0 1 0 1.061l-3.333 3.333a.75.75 0 1 1-1.061-1.06"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-door_arrow_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.357 3H13a1 1 0 1 1 0 2h-2.6c-1.137 0-1.929 0-2.546.051-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C5.001 8.471 5 9.264 5 10.4v7.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051H13a1 1 0 1 1 0 2h-2.643c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C3 19.6 3 18.727 3 17.643v-7.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 5.73 3.544c.592-.302 1.233-.428 1.961-.487C8.4 3 9.273 3 10.357 3m8.936 6.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L21.586 15H12a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 0-1.414" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="16" height="16" viewBox="0 0 1080 1080" id="svg-name-dots" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M135 675a135 135 0 1 1 0-270 135 135 0 0 1 0 270m405 0a135 135 0 1 1 0-270 135 135 0 0 1 0 270m405 0a135 135 0 1 1 0-270 135 135 0 0 1 0 270"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download" class="svg-sprite__symbol"><path fill="currentColor" d="M3.293 9.707a1 1 0 0 1 1.414-1.414zM10 15l.707.707a1 1 0 0 1-1.414 0zm5.293-6.707a1 1 0 1 1 1.414 1.414zm-10.586 0 6 6-1.414 1.414-6-6zm4.586 6 6-6 1.414 1.414-6 6z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 19h18M10 1v13"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download-thin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 19.25h18.5M10 17V2m0 15-6.5-6.5M10 17l6.5-6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4 17.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/><path fill="currentColor" d="M10.75 2.726c0-.401-.336-.726-.75-.726a.74.74 0 0 0-.75.726v9.722l-3.97-3.97a.75.75 0 0 0-1.06 1.06l5.245 5.246a.75.75 0 0 0 1.06 0l5.256-5.256a.75.75 0 0 0-1.06-1.061l-3.972 3.971z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-download_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.502 2a.9.9 0 0 1 .9.9v11.002l4.562-4.631a.9.9 0 0 1 1.283 1.263l-6.104 6.195a.9.9 0 0 1-1.283-.001l-6.09-6.206a.9.9 0 0 1 1.285-1.26l4.547 4.634V2.9a.9.9 0 0 1 .9-.9m-8 18.1a.9.9 0 0 1 .9-.9h14.2a.9.9 0 0 1 0 1.8h-14.2a.9.9 0 0 1-.9-.9" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-download_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM14 2a1 1 0 0 1 1 1v13.585l5.293-5.292a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L13 16.585V3a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-draggable" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" id="svg-name-dropdown_12" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.156 2.295a.75.75 0 0 1 1.051-.137L6 4.306l2.793-2.148a.75.75 0 0 1 .914 1.189l-3.25 2.5a.75.75 0 0 1-.914 0l-3.25-2.5a.75.75 0 0 1-.137-1.052" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="12" fill="none" id="svg-name-dropdown_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="m8 6.778 3.773-3.107a.75.75 0 0 1 .954 1.158l-4.25 3.5a.75.75 0 0 1-.954 0l-4.25-3.5a.75.75 0 0 1 .954-1.158z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-edit" class="svg-sprite__symbol"><path fill="currentColor" d="M9.5 2.75a.75.75 0 0 0 0-1.5zm9.25 7.75a.75.75 0 0 0-1.5 0zM3 19.75h13v-1.5H3zm6.5-18.5H3v1.5h6.5zM18.75 17v-6.5h-1.5V17zM.25 4v13h1.5V4zM3 1.25A2.75 2.75 0 0 0 .25 4h1.5c0-.69.56-1.25 1.25-1.25zm0 17c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 0 0 3 19.75zm13 1.5A2.75 2.75 0 0 0 18.75 17h-1.5c0 .69-.56 1.25-1.25 1.25z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m17.07 4.93-7.724 7.724-3.476 1.159 1.159-3.476 7.723-7.723M17.07 4.93l-2.317-2.317M17.07 4.93 18.5 3.5a.71.71 0 0 0 0-1.003l-1.314-1.313a.71.71 0 0 0-1.004 0l-1.429 1.429"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-edit_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.56 2.382a2.14 2.14 0 0 0-1.945 0c-.306.156-.572.422-.879.73l-9.393 9.394c-.253.253-.435.434-.584.64-.298.41-.495.885-.575 1.386-.04.251-.04.508-.04.866v.802c0 .201-.001.449.07.67.142.434.483.775.918.917.22.072.468.07.67.07h.802c.357 0 .614 0 .865-.04.501-.08.976-.276 1.387-.574.205-.15.387-.331.64-.584l9.393-9.394c.308-.307.575-.573.73-.878a2.14 2.14 0 0 0 0-1.946c-.155-.306-.422-.571-.73-.879l-.45-.45c-.307-.308-.573-.574-.879-.73m-1.297 1.273a.71.71 0 0 1 .649 0c.075.038.17.12.585.535l.314.315c.416.415.497.51.536.585a.71.71 0 0 1 0 .648c-.039.076-.12.17-.536.585l-.613.613-2.132-2.133.612-.613c.416-.415.51-.497.585-.535m-2.207 2.158L4.389 13.48c-.304.303-.4.402-.475.505a1.8 1.8 0 0 0-.319.77c-.02.127-.022.264-.022.694v.693c0 .141 0 .218.004.274v.008h.009c.055.004.132.004.273.004h.693c.43 0 .568-.002.694-.022.278-.044.542-.153.77-.319.103-.075.202-.17.506-.475l7.666-7.666z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-embed" class="svg-sprite__symbol"><path fill="currentColor" d="M11.735 5.147a.75.75 0 1 0-1.47-.294zm-3.47 9.706a.75.75 0 1 0 1.47.294zm-2.792-1.36a.75.75 0 0 0 1.054-1.07zM3 10l-.527-.534a.75.75 0 0 0 0 1.068zm3.527-2.424a.75.75 0 0 0-1.054-1.068zm6.95 4.802a.75.75 0 1 0 1.046 1.076zM17 10l.523.538a.75.75 0 0 0 .007-1.068zm-2.47-3.53a.75.75 0 1 0-1.06 1.06zm-4.265-1.617-2 10 1.47.294 2-10zm-3.738 7.57-3-2.957-1.054 1.068 3 2.958zm-3-1.889 3-2.958-1.054-1.068-3 2.958zm10.996 2.92 3-2.916-1.046-1.076-3 2.916zM17.53 9.47l-3-3-1.06 1.06 3 3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-empty" class="svg-sprite__symbol"><path fill="currentColor" d="M6.25 7.321c-2.322 0-3.631 5.239-5 7.679-.12 1.548.893 4.107 8.393 4.286 7.01.167 8.75-2.322 8.75-3.75-.536-1.072-2.143-4.465-3.75-4.465s-1.607 2.143-3.572 2.143c-1.964 0-2.5-5.893-4.821-5.893"/><path fill="currentColor" fill-rule="evenodd" d="M5.377 18.292c.807.262 1.853.28 4.623.28s3.816-.018 4.623-.28a5.72 5.72 0 0 0 3.669-3.669c.262-.807.28-1.853.28-4.623s-.018-3.816-.28-4.623a5.71 5.71 0 0 0-3.669-3.669c-.807-.262-1.853-.28-4.623-.28s-3.816.018-4.623.28a5.71 5.71 0 0 0-3.669 3.669c-.262.807-.28 1.853-.28 4.623s.018 3.816.28 4.623a5.71 5.71 0 0 0 3.669 3.669M.35 4.936C0 6.012 0 7.34 0 10s0 3.989.35 5.064a7.14 7.14 0 0 0 4.586 4.586C6.012 20 7.34 20 10 20s3.989 0 5.064-.35a7.14 7.14 0 0 0 4.586-4.586C20 13.99 20 12.66 20 10s0-3.988-.35-5.064A7.14 7.14 0 0 0 15.064.35C13.99 0 12.66 0 10 0S6.012 0 4.936.35A7.14 7.14 0 0 0 .35 4.936" clip-rule="evenodd"/><path fill="currentColor" d="M13.764 8.241a1.978 1.978 0 1 0 0-3.955 1.978 1.978 0 0 0 0 3.955"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="92" height="81" fill="none" id="svg-name-empty-search" class="svg-sprite__symbol"><path fill="#303030" fill-rule="evenodd" d="M68.036 5.499c11.61 5.409 19.692 16.597 21.92 29.227 2.433 13.787.449 29.288-9.933 38.699-10.029 9.09-24.852 6.857-38.229 4.957-12.81-1.82-26.274-4.512-33.62-15.163C.455 52.027-1.657 36.626 4.678 24.567 10.377 13.72 24.558 13.248 36.28 9.72 47.042 6.481 57.861.76 68.036 5.5" clip-rule="evenodd"/><circle cx="39" cy="28" r="26" stroke="#F1F1F1" stroke-width="3"/><path fill="#F1F1F1" d="M74.938 66.06a1.5 1.5 0 0 0 2.122-2.12zm-19-19 19 19 2.122-2.12-19-19zM29.04 38.848a1.5 1.5 0 1 0 1.921 2.304zm18 2.304a1.5 1.5 0 1 0 1.921-2.304zM30.002 40l.96 1.153h-.001l-.001.002h-.002.001a2 2 0 0 1 .11-.086c.088-.066.227-.166.412-.29.372-.247.928-.585 1.641-.925 1.43-.68 3.459-1.354 5.88-1.354v-3c-2.978 0-5.45.827-7.17 1.646-.862.41-1.543.822-2.015 1.137a12 12 0 0 0-.766.557l-.007.006h-.001c0 .001-.001.002.96 1.154m9-1.5c2.422 0 4.45.673 5.88 1.354.713.34 1.27.678 1.641.925a9 9 0 0 1 .522.376q.002 0 0 0l-.002-.001v-.001l.96-1.153c.96-1.152.959-1.153.959-1.153h-.002l-.007-.007-.06-.049-.154-.118c-.13-.098-.315-.232-.552-.39a16 16 0 0 0-2.015-1.137c-1.72-.82-4.191-1.646-7.17-1.646z"/><circle cx="29.999" cy="24" r="4" fill="#F1F1F1"/><circle cx="48" cy="24" r="4" fill="#F1F1F1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-error" class="svg-sprite__symbol"><path fill="#CD3544" fill-rule="evenodd" d="M7.888 2.308c.881-1.41 2.935-1.41 3.816 0l7.294 11.67c.936 1.498-.141 3.442-1.908 3.442H2.502c-1.767 0-2.844-1.944-1.908-3.443zm2.544.795a.75.75 0 0 0-1.272 0l-7.294 11.67a.75.75 0 0 0 .636 1.147H17.09a.75.75 0 0 0 .636-1.148z" clip-rule="evenodd"/><circle cx="10.05" cy="13.05" r=".75" fill="#CD3544" transform="rotate(-180 10.05 13.05)"/><rect width="1.5" height="5" x="10.8" y="11.3" fill="#CD3544" rx=".75" transform="rotate(-180 10.8 11.3)"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-error-outline" class="svg-sprite__symbol"><g clip-path="url(#a)"><path stroke="#CD3544" stroke-width="2" d="M8.524 2.705a1.5 1.5 0 0 1 2.544 0l7.294 11.67a1.5 1.5 0 0 1-1.272 2.295H2.502a1.5 1.5 0 0 1-1.272-2.295z"/><path stroke="#CD3544" stroke-linecap="round" stroke-width="2" d="M10 7v3"/><circle cx="10" cy="13" r="1" fill="#CD3544"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-error_circle_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4" clip-rule="evenodd"/><path fill="currentColor" d="M8.9 11.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-error_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.93 4.929A9.97 9.97 0 0 1 12 2a9.97 9.97 0 0 1 7.071 2.929A9.97 9.97 0 0 1 22.001 12a9.97 9.97 0 0 1-2.929 7.071A9.97 9.97 0 0 1 12.001 22a9.97 9.97 0 0 1-7.071-2.929A9.97 9.97 0 0 1 2 12 9.97 9.97 0 0 1 4.93 4.929M12 3.8a8.17 8.17 0 0 0-5.798 2.402A8.17 8.17 0 0 0 3.8 12c0 2.265.917 4.313 2.402 5.798A8.17 8.17 0 0 0 12 20.2a8.17 8.17 0 0 0 5.798-2.402A8.17 8.17 0 0 0 20.201 12a8.17 8.17 0 0 0-2.402-5.798A8.17 8.17 0 0 0 12.001 3.8" clip-rule="evenodd"/><path fill="currentColor" d="M13.001 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M12.001 7a.9.9 0 0 1 .9.9v5.2a.9.9 0 0 1-1.8 0V7.9a.9.9 0 0 1 .9-.9" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-error_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M28 4c13.255 0 24 10.745 24 24S41.255 52 28 52 4 41.255 4 28 14.745 4 28 4m0 3C16.402 7 7 16.402 7 28s9.402 21 21 21 21-9.402 21-21S39.598 7 28 7m0 27a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-17.5a1.5 1.5 0 0 1 1.5 1.5v11l-.007.145A1.5 1.5 0 0 1 26.5 29V18l.007-.145A1.5 1.5 0 0 1 28 16.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-error_triangle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M30.598 8.5 48.785 40c1.155 2-.289 4.5-2.598 4.5H9.814c-2.31 0-3.753-2.5-2.598-4.5L25.402 8.5c1.155-2 4.041-2 5.196 0M22.804 7c2.31-4 8.083-4 10.392 0l18.187 31.5c2.31 4-.578 9-5.196 9H9.814c-4.62 0-7.506-5-5.197-9z" clip-rule="evenodd"/><path fill="currentColor" d="M30 36a2 2 0 1 0-4 0 2 2 0 0 0 4 0M29.5 18a1.5 1.5 0 0 0-2.993-.145L26.5 18v11a1.5 1.5 0 0 0 2.993.145L29.5 29z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-expand" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 10H7m9 0-5.2 5m5.2-5-5.2-5"/><path fill="currentColor" d="M3.25 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zm0 10V5h-1.5v10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-expand-full-size" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M21.6 13.202v4.8a3.6 3.6 0 0 1-3.6 3.6H6a3.6 3.6 0 0 1-3.6-3.6v-12a3.6 3.6 0 0 1 3.6-3.6h4.8"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.6 2.4v6m0-6h-6m6 0L12 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-expand-stream" class="svg-sprite__symbol"><path fill="currentColor" d="M9.47 9.47a.75.75 0 1 1 1.06 1.06zM4 16v.75a.75.75 0 0 1-.75-.75zm-.75-6a.75.75 0 0 1 1.5 0zM10 15.25a.75.75 0 0 1 0 1.5zm.53-4.72-6 6-1.06-1.06 6-6zM3.25 16v-6h1.5v6zm.75-.75h6v1.5H4z"/><path fill="currentColor" d="M6.03 15.03a.75.75 0 0 1-1.06-1.06zM16 4v-.75a.75.75 0 0 1 .75.75zm.75 6a.75.75 0 0 1-1.5 0zM10 4.75a.75.75 0 0 1 0-1.5zm-5.03 9.22 10.5-10.5 1.06 1.06-10.5 10.5zM16.75 4v6h-1.5V4zm-.75.75h-6v-1.5h6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-export" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 18.5H4.5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 18.5v-6.2m0 6.2 2.692-3m-2.693 3-2.692-3"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M19 10c0 2-4.03 6.5-9 6.5s-9-5-9-6.5 4.03-6.5 9-6.5S19 8 19 10Z"/><circle cx="10" cy="10" r="2.25" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-close" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M10.439 10v4m0-4c1.663 0 3.221-.399 4.561-.99m-4.561.99c-1.585 0-3.074-.402-4.37-.99M19 6c-.716 1.009-2.15 2.193-4 3.01M2 6c.777.965 2.228 2.175 4.069 3.01m8.931 0 2.5 3.49M6.069 9.01 3.5 12.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-smoothed" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 9.992c0 2.84-3.582 5.143-8 5.143s-8-2.302-8-5.143S5.582 4.85 10 4.85s8 2.302 8 5.142" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9.99a2.001 2.001 0 1 1-4 0 2.001 2.001 0 1 1 4 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-smoothed-struck-out" class="svg-sprite__symbol"><path fill="currentColor" d="M10 4.709a.75.75 0 0 0 0-1.5zm-5.338 8.897a.75.75 0 1 0 .676-1.339zm5.336-10.4a.75.75 0 0 0 .004 1.5zm2.97 1.884a.75.75 0 1 0 .386-1.45zM4.448 16.56a.75.75 0 0 0 1.104 1.016zm4.046-2.178a.75.75 0 0 0-1.103-1.016zM18.55 3.456a.75.75 0 0 0-1.105-1.014zm-3.41 1.497a.75.75 0 0 0 1.106 1.015zm-7.75 8.414a.75.75 0 0 0 1.103 1.016zm3.294-2.47.552.509zm1.24-1.349-.552-.508zm4.317-3.581a.75.75 0 1 0-1.103-1.016zm-8.177 7.168a.75.75 0 1 0-.246 1.48zm1.934.909v-.75zm8-5.042h.75q0-.027-.002-.054zm-1.957-4.206a.75.75 0 1 0-.702 1.326zm-8.272 5.829a.75.75 0 0 0 1.217-.877zm.445-2.534.67.34zm1.787-1.107L10 6.234h-.005zm.654.937a.75.75 0 0 0 .796-1.27zM10 3.21c-2.329 0-4.472.593-6.057 1.592C2.368 5.794 1.25 7.26 1.25 9h1.5c0-1.044.673-2.1 1.993-2.931C6.053 5.244 7.91 4.709 10 4.709zM1.25 9c0 1.992 1.456 3.618 3.412 4.605l.676-1.339c-1.701-.859-2.588-2.075-2.588-3.266zm8.752-4.295a11.4 11.4 0 0 1 2.966.384l.386-1.45a12.9 12.9 0 0 0-3.356-.434zm-4.45 12.87 2.942-3.195-1.103-1.016-2.943 3.194zM17.445 2.441l-2.304 2.511 1.105 1.015 2.304-2.512zm-8.952 11.94 2.743-2.976-1.103-1.017-2.743 2.978zm2.743-2.977 1.24-1.35-1.104-1.014-1.24 1.35zm1.24-1.349 3.765-4.089-1.103-1.016-3.766 4.089zm-4.658 4.559q1.083.18 2.181.179l-.001-1.5q-.974 0-1.934-.16zm2.18.179c2.329 0 4.472-.593 6.057-1.592 1.575-.993 2.693-2.459 2.693-4.2h-1.5c0 1.043-.673 2.099-1.993 2.93-1.31.826-3.167 1.362-5.257 1.362zm8.748-5.846a5.11 5.11 0 0 0-2.705-4.152l-.702 1.326a3.61 3.61 0 0 1 1.911 2.933zm-9.76.8a1.27 1.27 0 0 1-.103-1.318l-1.338-.678a2.77 2.77 0 0 0 .224 2.873zM8.883 8.43a1.27 1.27 0 0 1 1.124-.696l-.012-1.5a2.77 2.77 0 0 0-2.45 1.518zm1.119-.696c.23 0 .457.065.653.187l.796-1.27A2.73 2.73 0 0 0 10 6.233z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-favorite_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.983 4.694a.577.577 0 0 0-1.078 0l-1.57 3.9a.88.88 0 0 1-.752.554l-4.01.267c-.52.034-.738.698-.347 1.05l3.176 2.858c.245.22.35.563.274.888l-.904 3.852c-.12.513.415.924.859.66l3.376-2.002c.27-.16.603-.16.874 0l3.376 2.003c.444.263.978-.148.858-.66l-.904-3.853a.92.92 0 0 1 .275-.888l3.175-2.858c.392-.352.173-1.016-.346-1.05l-4.01-.267a.88.88 0 0 1-.753-.554zm-2.695-.688a2.31 2.31 0 0 1 4.312 0l1.36 3.382 3.467.23c2.077.138 2.953 2.792 1.387 4.202l-2.777 2.499.78 3.322c.48 2.05-1.659 3.696-3.435 2.642l-2.938-1.744-2.939 1.744c-1.776 1.054-3.915-.592-3.434-2.642l.78-3.322-2.777-2.5c-1.566-1.41-.69-4.063 1.386-4.2l3.467-.23z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-favorite_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m36.682 16.815.047.112.122.01 7.784.621c1.1.088 2.12.17 2.92.305.735.125 2.007.39 2.983 1.368a5 5 0 0 1 1.4 4.318c-.218 1.364-1.093 2.325-1.615 2.856-.57.58-1.346 1.244-2.187 1.96l-5.912 5.045-.093.08q.014.054.029.118l1.81 7.556c.256 1.07.493 2.06.611 2.862.109.736.25 2.024-.375 3.253a5 5 0 0 1-3.664 2.669c-1.361.218-2.544-.31-3.212-.64-.727-.358-1.597-.887-2.536-1.459l-6.69-4.07-.103-.063-.104.063-6.69 4.07c-.939.572-1.809 1.101-2.536 1.46-.667.329-1.85.858-3.211.639a5 5 0 0 1-3.664-2.67c-.625-1.228-.484-2.516-.376-3.252.119-.802.356-1.793.612-2.862l1.81-7.556.028-.119-.093-.08-5.912-5.044c-.84-.716-1.618-1.38-2.187-1.96-.521-.53-1.397-1.492-1.614-2.856a5 5 0 0 1 1.4-4.318c.975-.978 2.248-1.243 2.982-1.368.801-.136 1.82-.217 2.92-.305l.123-.01 7.661-.611.122-.01.047-.113 2.96-7.089.048-.113c.422-1.013.814-1.95 1.19-2.667.347-.658.992-1.78 2.219-2.403a5 5 0 0 1 4.53 0c1.227.624 1.872 1.745 2.218 2.403.376.716.768 1.654 1.19 2.667zm-9.587-9.598c-.656.333-1.12 1.444-2.047 3.664l-2.96 7.09c-.274.654-.41.981-.63 1.23a2 2 0 0 1-.704.51c-.304.132-.658.16-1.365.216l-7.66.612c-2.415.193-3.621.29-4.143.811a2 2 0 0 0-.56 1.727c.117.729 1.038 1.515 2.88 3.086l5.818 4.964c.542.463.813.694.982.98a2 2 0 0 1 .27.83c.032.331-.051.677-.217 1.37l-1.78 7.436c-.563 2.346-.843 3.519-.51 4.175a2 2 0 0 0 1.466 1.068c.727.117 1.758-.51 3.818-1.764l6.584-4.005c.605-.368.907-.552 1.23-.624.286-.063.582-.063.867 0 .323.072.626.256 1.23.624l6.584 4.005c2.06 1.254 3.091 1.88 3.818 1.764a2 2 0 0 0 1.466-1.068c.334-.656.053-1.83-.509-4.175l-1.78-7.436c-.166-.693-.25-1.039-.218-1.37.028-.293.12-.577.27-.83.17-.286.44-.517.982-.98l5.819-4.964c1.842-1.571 2.763-2.357 2.879-3.086a2 2 0 0 0-.56-1.727c-.521-.522-1.728-.618-4.142-.811l-7.66-.612c-.708-.056-1.061-.084-1.366-.216-.269-.117-.51-.29-.703-.51-.22-.249-.357-.576-.63-1.23l-2.96-7.09c-.928-2.22-1.391-3.33-2.047-3.664a2 2 0 0 0-1.812 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="21" id="svg-name-fb" class="svg-sprite__symbol"><path fill="#FFF" fill-rule="evenodd" d="M19.845 0H1.159A1.16 1.16 0 0 0 0 1.159v18.682A1.16 1.16 0 0 0 1.16 21h10.06v-8.132H8.481v-3.17h2.737V7.362c0-2.712 1.657-4.19 4.077-4.19q1.226-.003 2.446.126V6.13h-1.678c-1.317 0-1.574.626-1.574 1.543v2.024h3.139l-.409 3.17h-2.73V21h5.35A1.16 1.16 0 0 0 21 19.841V1.159C21 .52 20.484.002 19.845 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-file" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M3.5 17.5v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V17.5a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1Z"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="20" id="svg-name-file-white" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#242B2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M2.403 1.043a1.31 1.31 0 0 0-1.364 1.25v15.423a1.31 1.31 0 0 0 1.364 1.25h12.234A1.31 1.31 0 0 0 16 17.716V5.185a1.2 1.2 0 0 0-.4-.884l-3.292-3.018a1.43 1.43 0 0 0-.964-.366z"/><path d="M10 2v3.4c0 .789.64 1.428 1.428 1.429H15"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-file-with-arrow-down" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 18.5H4.5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 18.5v-6.2m0 6.2 2.692-3m-2.692 3-2.692-3"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-filter" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 15v3M6 2v9M14 2v3M14 9v9"/><circle cx="6" cy="13" r="2" stroke="currentColor" stroke-width="1.5"/><circle cx="14" cy="7" r="2" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-filter-button" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M2 2v1.63a1 1 0 0 0 .24.65L8 11h4l5.76-6.72a1 1 0 0 0 .24-.65V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1ZM8 11v6.382a1 1 0 0 0 1.447.894l2-1a1 1 0 0 0 .553-.894V11"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="none" id="svg-name-fire-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M2.92 9.486 2.735 8.02l-.743 1.276c-.384.66-.892 1.851-.892 3.523 0 1.048.643 2.41 1.716 3.493 1.09 1.1 2.682 1.976 4.662 1.976a7.42 7.42 0 0 0 4.827-1.788c1.21-1.044 2.002-2.447 2.002-3.813 0-.92-.25-2.114-.843-2.99l-.802-1.185-.111 1.426a3.4 3.4 0 0 1-.118.693q-.056.188-.126.31c.048-.212.099-.467.141-.746.112-.738.179-1.736-.116-2.525l-.448-1.2-.483 1.186c-.077.188-.17.383-.273.543-.184-.855-.8-1.387-1.345-1.857l-.044-.038c-.502-.435-.956-.835-1.257-1.4-.291-.544-.46-1.287-.271-2.427l.176-1.056-.923.543c-.786.463-2.305 1.747-1.93 4.324v.001a3.5 3.5 0 0 1-.12 1.534L5.386 7.8c-.145-.145-.333-.482-.341-1.007L5.028 5.59l-.84.86c-.4.41-1.06 1.218-1.06 2.204 0 .794.222 1.627.407 2.18-.362-.314-.549-.82-.615-1.348Zm7.953-.996Z"/><path fill="url(#b)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454"/><path fill="url(#c)" d="M2.424 9.548c-.349.598-.824 1.704-.824 3.27 0 1.751 2.23 4.97 5.878 4.97 3.562 0 6.33-2.743 6.33-5.1 0-.853-.236-1.94-.758-2.712-.038.485-.156 1.144-.518 1.488a.83.83 0 0 1-.682.23l-.264-.023.08-.25c.01-.023.692-2.254.198-3.576-.198.484-.537 1.11-.951 1.143l-.235.02.004-.236c.02-.974-.578-1.492-1.27-2.09-.988-.856-2.104-1.826-1.694-4.287-.687.405-2.024 1.52-1.69 3.822.17 1.152-.23 2.009-.244 2.047l-.047.098-.104.02c-.198.037-.405-.043-.593-.222-.254-.25-.485-.72-.494-1.36-.386.395-.918 1.078-.918 1.854 0 1.275.622 2.65.626 2.664l.174.386-.414-.09c-1.082-.235-1.487-1.242-1.59-2.066" opacity=".5"/><path fill="url(#d)" d="M7.167 3.2c-1.562 2.447.466 5.03-.579 6.579s-2.103.117-2.174-.852c0 0 .01 3.134 1.558 4.372s-2.979.97-3.6-.541c0 0 0 5.03 5.106 5.03s5.957-4.682 5.957-4.682-1.859 1.586-3.096.348c0 0 .927-1.623 1.162-3.29 0 0-.64.405-1.623.25 0 0 .546-2.339-.57-3.106-1.43-.983-2.64-3.327-2.14-4.108"/><path fill="url(#e)" d="M7.558 6.08c-.82 1.078.776 3.845-.9 4.941-.926.607-1.458-.122-1.458-.122s.25 1.12 1.247 2.117c.998.998-1.501 2.349-3.53.603 0 0 .697 4.193 5.417 3.487 5.21-.777 4.824-4.65 4.824-4.65s-1.412 2.222-3.422 1.158c0 0 1.266-1.765 1.266-2.776 0 0-.856.508-1.835.018 0 0 .466-2.353-.09-2.705-1.331-.852-1.52-2.071-1.52-2.071"/><path fill="url(#f)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#g)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#h)" d="M1.92 11.727c.108 2.659 2.297 5.845 5.718 5.845s5.13-3.61 5.237-5.723c0 0-.64 1.243-2.084 1.492-1.445.25.098-2.484-.913-4.103 0 0-.894 2.819-2.165 2.922s-2.348-1.864-2.348-2.922c0 0-.781 1.906-.588 3.42.296 2.302-2.857-.93-2.857-.93"/><path fill="url(#i)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#j)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#k)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><path fill="url(#l)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><path fill="url(#m)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><defs><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="matrix(6.49825 0 0 5.27528 7.727 14.26)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset=".294" stop-color="#FFBF4B" stop-opacity=".707"/><stop offset=".562" stop-color="#FEC656" stop-opacity=".438"/><stop offset=".82" stop-color="#FCD368" stop-opacity=".18"/><stop offset="1" stop-color="#FBE07A" stop-opacity="0"/></radialGradient><radialGradient id="g" cx="0" cy="0" r="1" gradientTransform="matrix(6.298 0 0 5.11272 7.727 13.994)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="matrix(7.73665 0 0 9.00779 4.966 15.155)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C" stop-opacity=".6"/><stop offset=".948" stop-color="#FFED1C" stop-opacity=".026"/><stop offset=".991" stop-color="#FFED1C" stop-opacity="0"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="matrix(-.12318 2.44205 -1.98235 -.1 7.728 13.993)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="translate(8.462 3.042)scale(8.66023)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FF4C00"/><stop offset=".135" stop-color="#FF5B0C" stop-opacity=".866"/><stop offset=".394" stop-color="#FF842C" stop-opacity=".607"/><stop offset=".749" stop-color="#FFC45F" stop-opacity=".251"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="k" cx="0" cy="0" r="1" gradientTransform="translate(12.401 10.058)scale(4.59671)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C"/><stop offset=".2" stop-color="#FFEE2B" stop-opacity=".801"/><stop offset=".584" stop-color="#FFF254" stop-opacity=".417"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="translate(2.992 11.696)scale(4.8995)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C"/><stop offset=".2" stop-color="#FFEE2B" stop-opacity=".801"/><stop offset=".584" stop-color="#FFF254" stop-opacity=".417"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="rotate(86.11 -1.902 9.449)scale(8.39248 5.10177)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF4C00" stop-opacity="0"/><stop offset=".987" stop-color="#FF4C00" stop-opacity=".989"/><stop offset=".999" stop-color="#FF4C00"/></radialGradient><linearGradient id="a" x1="8.528" x2="2.224" y1="14.881" y2="-3.122" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".639" stop-color="#FF5B00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="b" x1="8.605" x2="5.72" y1="18.442" y2="-2.464" gradientUnits="userSpaceOnUse"><stop stop-color="red"/><stop offset=".232" stop-color="#FF1500"/><stop offset=".737" stop-color="#FF3D00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="c" x1="8.528" x2="2.224" y1="14.881" y2="-3.122" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".639" stop-color="#FF5B00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="d" x1="6.08" x2="8.359" y1="2.867" y2="15.653" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".023" stop-color="#FE7F02" stop-opacity=".977"/><stop offset=".666" stop-color="#ED582A" stop-opacity=".334"/><stop offset="1" stop-color="#E74939" stop-opacity="0"/></linearGradient><linearGradient id="e" x1="7.85" x2="8.342" y1="16.684" y2="7.706" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47"/><stop offset=".187" stop-color="#FFB137" stop-opacity=".813"/><stop offset=".722" stop-color="#FF940F" stop-opacity=".278"/><stop offset="1" stop-color="#FF8900" stop-opacity="0"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-flag" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M4 2v16M6 3v8M6 3h9l-2.454 4L15 11H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none" id="svg-name-game_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7 .5H5c-3.75 0-5 3-5 6C0 8.25.5 10 2 10c.655 0 1.024-.524 1.44-1.114C3.976 8.123 4.59 7.25 6 7.25h2c1.409 0 2.024.873 2.56 1.636.416.59.785 1.114 1.44 1.114 1.5 0 2-1.75 2-3.5 0-3-1.25-6-5-6zm2 4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6-1a.5.5 0 0 1 1 0V4h.5a.5.5 0 0 1 0 1H4v.5a.5.5 0 0 1-1 0V5h-.5a.5.5 0 0 1 0-1H3z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-game_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.5 4h-3c-2.317 0-4.245.431-5.577 1.761C1.593 7.088 1.02 9.147 1 11.995c-.005.8.055 1.982.455 2.99.204.512.511 1.02.98 1.402.483.391 1.09.613 1.815.613.8 0 1.374-.327 1.811-.77.311-.314.58-.722.805-1.066q.084-.13.161-.243c.284-.418.556-.759.916-1.005.344-.235.819-.416 1.557-.416h1c.74 0 1.214.181 1.558.416.36.246.632.587.915 1.005q.077.113.162.243c.226.344.494.752.805 1.066.437.443 1.011.77 1.81.77.725 0 1.333-.222 1.815-.613.47-.382.777-.89.98-1.402.4-1.008.461-2.19.455-2.99-.02-2.848-.593-4.907-1.922-6.234C15.745 4.431 13.818 4 11.5 4m-1 8h-1c-1.01 0-1.786.256-2.403.678-.601.41-1.001.944-1.311 1.4q-.124.184-.225.339c-.212.32-.37.56-.567.759-.21.213-.418.324-.744.324-.4 0-.668-.115-.868-.277q-.319-.259-.533-.792c-.29-.728-.354-1.67-.349-2.426.02-2.707.572-4.273 1.483-5.182C4.89 5.916 6.317 5.5 8.5 5.5h3c2.183 0 3.61.417 4.518 1.323.911.91 1.463 2.475 1.482 5.182.006.756-.06 1.698-.349 2.426q-.213.534-.532.792c-.2.162-.469.277-.869.277-.326 0-.533-.11-.743-.324-.197-.199-.355-.439-.567-.759l-.225-.338c-.31-.457-.71-.991-1.311-1.402-.617-.42-1.392-.677-2.404-.677M7.25 7.5a.75.75 0 1 0-1.5 0v.75H5a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 0 0 1.5 0v-.75H8a.75.75 0 1 0 0-1.5h-.75zm5.25.75a.75.75 0 0 0 0 1.5h2a.75.75 0 1 0 0-1.5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-game_outline_24" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M17.123 4.2c2.904 0 4.83 1.834 5.893 4.875.71 2.031.984 4.397.984 6.739 0 3.407-.837 4.757-3.39 4.757-1.254 0-2.115-.794-3.638-2.76-1.219-1.573-1.682-2.062-1.841-2.062H8.869c-.195 0-.835.616-2.034 2.065l-.016.02C5.037 19.987 4.435 20.57 3.39 20.57.837 20.57 0 19.22 0 15.813c0-2.34.275-4.707.984-6.738 1.062-3.04 2.989-4.876 5.893-4.876zm0 1.8H6.877C3.269 6 1.8 10.205 1.8 15.813c0 2.539.259 2.957 1.59 2.957.192 0 .826-.615 2.042-2.085l.017-.02c1.75-2.115 2.375-2.717 3.42-2.717h6.262c1.065 0 1.4.355 3.264 2.76 1.123 1.449 1.787 2.062 2.215 2.062 1.331 0 1.59-.418 1.59-2.958C22.2 10.206 20.73 6 17.123 6M7.14 7.712c.317 0 .574.258.574.575v1.14h1.14c.317 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-1.14v1.14a.574.574 0 0 1-.574.574h-.566A.574.574 0 0 1 6 12.282v-1.14H4.86a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574H6v-1.14c0-.317.257-.575.574-.575zm10.286 3.43c.317 0 .574.256.574.573v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574zM15.71 9.427c.318 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-.565a.574.574 0 0 1-.575-.574v-.566c0-.317.258-.574.575-.574zm3.429 0c.317 0 .574.257.574.574v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574zm-1.714-1.715c.317 0 .574.258.574.575v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.575v-.565c0-.317.257-.575.574-.575z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" id="svg-name-gb" class="svg-sprite__symbol"><clipPath id="a"><path d="M30 15h30v15zv15H0zH0V0zV0h30z"/></clipPath><path fill="#00247d" d="M0 0v30h60V0z"/><path stroke="#fff" stroke-width="6" d="m0 0 60 30m0-30L0 30"/><path stroke="#cf142b" stroke-width="4" d="m0 0 60 30m0-30L0 30" clip-path="url(#a)"/><path stroke="#fff" stroke-width="10" d="M30 0v30M0 15h60"/><path stroke="#cf142b" stroke-width="6" d="M30 0v30M0 15h60"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gear" class="svg-sprite__symbol"><path fill="currentColor" d="m8.544 2.165-.747-.067zm2.54-.1-.74.126zm.108.633-.74.127zm1.054 1.189-.248.708zm1.73-.148.431.614zm.407-.285-.43-.614zm1.745.144-.526.535zm.168 1.751-.618-.425zm-.364.53.618.425zm-.145 1.61.691-.291zm1.925 1.228-.123.74zm.022 2.638.136.737zm-.44.08.136.738zm-1.179 1.059-.708-.248zm.15 1.74.613-.43zm.281.402-.614.43zm-.144 1.745.535.526zm-1.751.168-.425.619zm-.528-.362-.425.618zm-1.614-.146-.29-.692zm-1.132 1.333-.74-.127zm-.09.517.74.128zm-2.63 0 .738-.127zm-.102-.588-.74.127zM7.505 16.1l.262-.702zm-1.737.145-.436-.61zm-.398.284.436.61zm-1.754-.146-.53.53zM3.47 14.63l-.61-.436zm.324-.453.61.436zm.161-1.621-.691.29zm-1.319-1.121-.127.739zm-.55-.095.126-.74zm.053-2.584-.096-.744zm.428-.055.096.744zm1.357-1.153.702.265zm-.162-1.703.608-.44zm-.283-.391-.608.44zm.161-1.735.516.544zm1.678-.117-.435.61zm.484.346.436-.61zm1.663.134.267.701zm1.02-1.268.747.068zM9.82.25c-1.05 0-1.928.801-2.023 1.848l1.494.135a.53.53 0 0 1 .53-.483zm2.002 1.687A2.03 2.03 0 0 0 9.82.25v1.5c.259 0 .48.186.524.441zm.11.634-.11-.634-1.478.254.109.634zm.563.608c-.319-.111-.52-.353-.564-.608l-1.478.254c.15.867.789 1.505 1.545 1.77zm1.05-.054c-.236.166-.618.206-1.05.054l-.497 1.416c.717.251 1.648.292 2.41-.242zm.408-.285-.407.285.861 1.228.407-.285zm2.7.223a2.12 2.12 0 0 0-2.7-.223l.86 1.228a.62.62 0 0 1 .79.065zm.261 2.711a2.12 2.12 0 0 0-.26-2.71l-1.052 1.07c.214.21.246.543.076.79zm-.364.53.364-.53-1.236-.85-.364.53zm-.072.894a.92.92 0 0 1 .072-.894l-1.236-.85c-.484.705-.534 1.574-.219 2.325zm.77.68c-.302-.05-.61-.3-.77-.68l-1.383.581c.317.753.995 1.428 1.906 1.58zm.587.099-.587-.098L17 9.359l.588.097zm1.746 2.06a2.09 2.09 0 0 0-1.746-2.06l-.246 1.48a.59.59 0 0 1 .492.58zm-1.711 2.055a2.09 2.09 0 0 0 1.711-2.054h-1.5a.59.59 0 0 1-.482.58zm-.44.081.44-.08-.271-1.476-.44.081zm-.607.568c.111-.318.351-.52.607-.568l-.271-1.475c-.86.158-1.49.796-1.752 1.548zm.055 1.063c-.168-.24-.207-.626-.055-1.063l-1.416-.495c-.252.72-.292 1.656.243 2.42zm.282.402-.282-.402-1.228.861.282.402zm-.223 2.7c.716-.728.81-1.864.223-2.7l-1.228.86a.62.62 0 0 1-.065.79zm-2.711.262c.847.582 1.99.472 2.71-.261l-1.07-1.052a.62.62 0 0 1-.79.076zm-.528-.363.528.363.85-1.237-.528-.362zm-.899-.073c.32-.134.647-.1.899.073l.85-1.236c-.706-.486-1.578-.536-2.33-.22zm-.683.769c.052-.302.302-.609.684-.769l-.582-1.383c-.75.316-1.424.99-1.58 1.898zm-.09.517.09-.517-1.479-.254-.088.517zM9.973 19.75a2.085 2.085 0 0 0 2.055-1.732l-1.478-.254a.585.585 0 0 1-.577.486zm-2.055-1.732c.172 1 1.04 1.732 2.055 1.732v-1.5a.585.585 0 0 1-.577-.486zm-.101-.588.101.588 1.478-.254-.101-.589zm-.573-.626c.326.122.529.37.573.626l1.478-.255c-.149-.866-.786-1.5-1.527-1.776zm-1.04.052c.236-.169.618-.21 1.04-.052l.524-1.405c-.729-.272-1.672-.309-2.435.236zm-.397.284.397-.284-.871-1.22-.398.283zm-2.72-.225c.73.73 1.88.825 2.72.225l-.872-1.22a.61.61 0 0 1-.788-.066zm-.226-2.72c-.6.84-.505 1.99.225 2.72l1.061-1.061a.61.61 0 0 1-.065-.788zm.323-.453-.323.452 1.22.872.324-.453zm.08-.896a.91.91 0 0 1-.08.896l1.221.871c.503-.704.562-1.587.243-2.347zm-.754-.672c.296.05.597.297.755.672l1.383-.58c-.312-.745-.982-1.415-1.884-1.57zm-.551-.095.55.095.255-1.479-.55-.094zM.25 10.052c0 1.001.721 1.857 1.708 2.027l.254-1.478a.56.56 0 0 1-.462-.549zm1.793-2.04a2.06 2.06 0 0 0-1.793 2.04h1.5c0-.28.208-.516.485-.552zm.428-.055-.428.055.192 1.488.428-.055zm.752-.675c-.15.396-.451.636-.752.675l.192 1.488c.964-.125 1.66-.835 1.963-1.632zm-.068-.997c.173.24.217.605.068.997l1.403.531c.281-.743.282-1.664-.256-2.407zm-.284-.392.284.392 1.215-.88-.284-.391zm.253-2.718a2.07 2.07 0 0 0-.253 2.718l1.215-.88a.57.57 0 0 1 .07-.75zm2.63-.183a2.07 2.07 0 0 0-2.63.183l1.032 1.088a.57.57 0 0 1 .727-.05zm.484.346-.484-.346-.871 1.22.483.346zm.96.043c-.393.15-.745.11-.96-.043l-.872 1.22c.743.53 1.66.494 2.366.225zm.54-.635c-.023.253-.212.51-.54.635l.534 1.402c.77-.293 1.417-.984 1.5-1.9zm.06-.648-.06.648 1.494.136.059-.649zm2.118 5.586c1.294 0 2.4 1.106 2.4 2.4h1.5c0-2.122-1.778-3.9-3.9-3.9zm-2.4 2.4c0-1.294 1.105-2.4 2.4-2.4v-1.5c-2.123 0-3.9 1.778-3.9 3.9zm2.4 2.4c-1.295 0-2.4-1.105-2.4-2.4h-1.5c0 2.123 1.777 3.9 3.9 3.9zm2.4-2.4c0 1.295-1.106 2.4-2.4 2.4v1.5c2.122 0 3.9-1.777 3.9-3.9z"/><path fill="currentColor" d="m8.544 2.165-.747-.067zm2.54-.1-.74.126zm.108.633-.74.127zm1.054 1.189-.248.708zm1.73-.148.431.614zm.407-.285-.43-.614zm1.745.144-.526.535zm.168 1.751-.618-.425zm-.364.53.618.425zm-.145 1.61.691-.291zm1.925 1.228-.123.74zm.022 2.638.136.737zm-.44.08.136.738zm-1.179 1.059-.708-.248zm.15 1.74.613-.43zm.281.402-.614.43zm-.144 1.745.535.526zm-1.751.168-.425.619zm-.528-.362-.425.618zm-1.614-.146-.29-.692zm-1.132 1.333-.74-.127zm-.09.517.74.128zm-2.63 0 .738-.127zm-.102-.588-.74.127zM7.505 16.1l.262-.702zm-1.737.145-.436-.61zm-.398.284.436.61zm-1.754-.146-.53.53zM3.47 14.63l-.61-.436zm.324-.453.61.436zm.161-1.621-.691.29zm-1.319-1.121-.127.739zm-.55-.095.126-.74zm.053-2.584-.096-.744zm.428-.055.096.744zm1.357-1.153.702.265zm-.162-1.703.608-.44zm-.283-.391-.608.44zm.161-1.735.516.544zm1.678-.117-.435.61zm.484.346.436-.61zm1.663.134.267.701zm1.02-1.268.747.068zM9.82.25c-1.05 0-1.928.801-2.023 1.848l1.494.135a.53.53 0 0 1 .53-.483zm2.002 1.687A2.03 2.03 0 0 0 9.82.25v1.5c.259 0 .48.186.524.441zm.11.634-.11-.634-1.478.254.109.634zm.563.608c-.319-.111-.52-.353-.564-.608l-1.478.254c.15.867.789 1.505 1.545 1.77zm1.05-.054c-.236.166-.618.206-1.05.054l-.497 1.416c.717.251 1.648.292 2.41-.242zm.408-.285-.407.285.861 1.228.407-.285zm2.7.223a2.12 2.12 0 0 0-2.7-.223l.86 1.228a.62.62 0 0 1 .79.065zm.261 2.711a2.12 2.12 0 0 0-.26-2.71l-1.052 1.07c.214.21.246.543.076.79zm-.364.53.364-.53-1.236-.85-.364.53zm-.072.894a.92.92 0 0 1 .072-.894l-1.236-.85c-.484.705-.534 1.574-.219 2.325zm.77.68c-.302-.05-.61-.3-.77-.68l-1.383.581c.317.753.995 1.428 1.906 1.58zm.587.099-.587-.098L17 9.359l.588.097zm1.746 2.06a2.09 2.09 0 0 0-1.746-2.06l-.246 1.48a.59.59 0 0 1 .492.58zm-1.711 2.055a2.09 2.09 0 0 0 1.711-2.054h-1.5a.59.59 0 0 1-.482.58zm-.44.081.44-.08-.271-1.476-.44.081zm-.607.568c.111-.318.351-.52.607-.568l-.271-1.475c-.86.158-1.49.796-1.752 1.548zm.055 1.063c-.168-.24-.207-.626-.055-1.063l-1.416-.495c-.252.72-.292 1.656.243 2.42zm.282.402-.282-.402-1.228.861.282.402zm-.223 2.7c.716-.728.81-1.864.223-2.7l-1.228.86a.62.62 0 0 1-.065.79zm-2.711.262c.847.582 1.99.472 2.71-.261l-1.07-1.052a.62.62 0 0 1-.79.076zm-.528-.363.528.363.85-1.237-.528-.362zm-.899-.073c.32-.134.647-.1.899.073l.85-1.236c-.706-.486-1.578-.536-2.33-.22zm-.683.769c.052-.302.302-.609.684-.769l-.582-1.383c-.75.316-1.424.99-1.58 1.898zm-.09.517.09-.517-1.479-.254-.088.517zM9.973 19.75a2.085 2.085 0 0 0 2.055-1.732l-1.478-.254a.585.585 0 0 1-.577.486zm-2.055-1.732c.172 1 1.04 1.732 2.055 1.732v-1.5a.585.585 0 0 1-.577-.486zm-.101-.588.101.588 1.478-.254-.101-.589zm-.573-.626c.326.122.529.37.573.626l1.478-.255c-.149-.866-.786-1.5-1.527-1.776zm-1.04.052c.236-.169.618-.21 1.04-.052l.524-1.405c-.729-.272-1.672-.309-2.435.236zm-.397.284.397-.284-.871-1.22-.398.283zm-2.72-.225c.73.73 1.88.825 2.72.225l-.872-1.22a.61.61 0 0 1-.788-.066zm-.226-2.72c-.6.84-.505 1.99.225 2.72l1.061-1.061a.61.61 0 0 1-.065-.788zm.323-.453-.323.452 1.22.872.324-.453zm.08-.896a.91.91 0 0 1-.08.896l1.221.871c.503-.704.562-1.587.243-2.347zm-.754-.672c.296.05.597.297.755.672l1.383-.58c-.312-.745-.982-1.415-1.884-1.57zm-.551-.095.55.095.255-1.479-.55-.094zM.25 10.052c0 1.001.721 1.857 1.708 2.027l.254-1.478a.56.56 0 0 1-.462-.549zm1.793-2.04a2.06 2.06 0 0 0-1.793 2.04h1.5c0-.28.208-.516.485-.552zm.428-.055-.428.055.192 1.488.428-.055zm.752-.675c-.15.396-.451.636-.752.675l.192 1.488c.964-.125 1.66-.835 1.963-1.632zm-.068-.997c.173.24.217.605.068.997l1.403.531c.281-.743.282-1.664-.256-2.407zm-.284-.392.284.392 1.215-.88-.284-.391zm.253-2.718a2.07 2.07 0 0 0-.253 2.718l1.215-.88a.57.57 0 0 1 .07-.75zm2.63-.183a2.07 2.07 0 0 0-2.63.183l1.032 1.088a.57.57 0 0 1 .727-.05zm.484.346-.484-.346-.871 1.22.483.346zm.96.043c-.393.15-.745.11-.96-.043l-.872 1.22c.743.53 1.66.494 2.366.225zm.54-.635c-.023.253-.212.51-.54.635l.534 1.402c.77-.293 1.417-.984 1.5-1.9zm.06-.648-.06.648 1.494.136.059-.649z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gear_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m7.222 3.378.01-.033a4 4 0 0 1 .17-.476c.358-.821.944-1.285 1.854-1.36l.166-.009h1.208c1.051.033 1.735.608 2.095 1.692l.057.186.044.166q.025.096.06.203l.05.137.03.015.06-.02.116-.044.135-.059.168-.074.036-.015a4 4 0 0 1 .424-.15c.932-.27 1.685-.075 2.32.618l.108.125.714.88c.636.833.617 1.723-.004 2.683l-.109.161-.102.139q-.06.081-.123.177l-.062.1-.029.05.004.017.08.052.11.066.133.072c1.209.614 1.707 1.42 1.515 2.541l-.032.162-.213.916c-.137.593-.245.873-.67 1.258a2.13 2.13 0 0 1-1.059.518l-.01.003a4 4 0 0 1-.438.059l-.191.012-.173.006-.052.001h-.006q-.075.004-.156.01l-.158.02.012.123.011.083.029.154q.102.482.098.89v.012c-.015.84-.38 1.45-1.132 1.87l-.147.076-1.023.494c-.901.403-1.722.234-2.484-.467a4 4 0 0 1-.144-.14l-.133-.142-.113-.13a3 3 0 0 0-.147-.161l-.085-.083-.043-.04-.08.076-.091.093-.103.115c-.828.981-1.703 1.334-2.763.923l-.153-.063-.915-.443-.271-.138c-.415-.225-.647-.44-.874-.918a2.15 2.15 0 0 1-.209-1.01v-.016c.006-.19.03-.388.07-.603l.038-.195.001-.004q.02-.096.035-.206l.016-.148-.003-.003-.09-.012-.128-.012-.151-.006a4 4 0 0 1-.862-.098l-.012-.003c-.837-.198-1.363-.69-1.608-1.524l-.043-.16-.254-1.102c-.204-1.026.205-1.818 1.186-2.41l.17-.098.152-.08q.09-.045.188-.105l.134-.087.004-.017-.055-.093-.07-.108-.089-.124a5 5 0 0 1-.286-.423c-.54-.905-.534-1.72.046-2.523l.1-.132.717-.877c.687-.792 1.566-.958 2.64-.554l.18.072.158.07a3 3 0 0 0 .193.08l.118.042.032-.014.029-.077.04-.12.04-.143q.02-.085.044-.166m4.24.841.013.038.05.138a1.5 1.5 0 0 0 .743.833l.03.014a1.5 1.5 0 0 0 1.136.082l.06-.02.065-.023.117-.044.062-.025.135-.059.035-.015.12-.053q.165-.07.295-.107c.268-.078.407-.06.47-.043.057.015.16.056.314.22l.077.09.682.84c.138.185.15.295.15.359 0 .084-.03.267-.225.573l-.082.122-.08.108a4 4 0 0 0-.18.26l-.014.022-.062.099-.008.013-.01.018-.03.05a1.5 1.5 0 0 0-.178 1.056l.004.017a1.5 1.5 0 0 0 .648.959l.08.052.05.032.11.066.06.034.133.072.034.018c.456.231.62.421.676.516.036.06.084.162.042.417l-.023.117-.207.892c-.066.285-.095.35-.105.369 0 0 0 .003-.01.013a1 1 0 0 1-.101.103c-.082.074-.166.124-.354.161a2 2 0 0 1-.257.035l-.153.01-.138.004-.071.002a5 5 0 0 0-.28.02l-.158.019a1.5 1.5 0 0 0-1.318 1.628l.011.123.008.07.012.083.01.06.028.154.008.045c.05.236.068.419.066.557-.003.206-.046.301-.073.348-.028.046-.094.131-.276.235l-.105.056-.977.471c-.204.088-.317.082-.382.07-.076-.015-.228-.068-.456-.279l-.08-.076-.1-.107-.088-.102a4 4 0 0 0-.217-.236l-.018-.018-.084-.082-.036-.034-.043-.04a1.5 1.5 0 0 0-2.047.014l-.08.075-.042.041-.09.094-.048.05-.103.116-.025.03c-.315.371-.532.495-.646.535-.073.025-.183.05-.415-.038l-.094-.039-.864-.418-.238-.12a1 1 0 0 1-.13-.083l-.004-.003-.003-.003-.013-.018a1 1 0 0 1-.07-.13.67.67 0 0 1-.063-.339c.003-.09.015-.207.043-.365l.035-.174a4 4 0 0 0 .058-.35l.016-.149a1.5 1.5 0 0 0-.434-1.224l-.004-.003a1.5 1.5 0 0 0-.86-.423l-.09-.012-.064-.008-.128-.01-.068-.005-.15-.007-.04-.001a2.7 2.7 0 0 1-.549-.06c-.215-.05-.305-.115-.346-.154s-.109-.12-.17-.319l-.03-.114-.242-1.052c-.042-.224-.006-.329.023-.387.038-.076.146-.23.459-.42l.128-.074.119-.062a4 4 0 0 0 .316-.18l.134-.087a1.5 1.5 0 0 0 .65-.947l.004-.017a1.5 1.5 0 0 0-.171-1.066l-.055-.093-.037-.062-.07-.108-.04-.057-.088-.124-.024-.031c-.307-.406-.369-.647-.378-.754-.006-.067-.004-.18.148-.395l.072-.094.684-.838c.154-.173.262-.211.33-.225.09-.018.28-.027.623.1l.138.055.123.055a4 4 0 0 0 .316.13l.118.042a1.5 1.5 0 0 0 1.134-.058l.031-.015a1.5 1.5 0 0 0 .764-.823l.03-.077.023-.066.04-.12.02-.065.04-.143.01-.037.03-.119q.056-.191.114-.323c.1-.23.192-.319.243-.357.044-.033.134-.086.343-.105l.1-.006h1.14c.234.01.333.071.386.114.067.056.192.195.308.538l.043.14.034.129q.04.15.088.298" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gift" class="svg-sprite__symbol"><path d="M3 10h14v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM2 6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM5 5h5C8.5 2 6 1 5 2c-.8.8-.333 2.333 0 3M15 5h-5c1.5-3 4-4 5-3 .8.8.333 2.333 0 3M10 5v13"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-gift-box" class="svg-sprite__symbol"><path fill="#3C1F56" fill-opacity=".992" d="m23.087 1.41-1.817.176q1.133-.6 1.817-.177"/><path fill="#5400C2" d="M23.087 1.41q1.02.423 1.36 1.573-.49-.826-.937-.967-.533-.67-1.28-.42-.707-.057-1.073.357c-.744.836-1.61 1.576-2.207 2.486q-.764 1.164-1.473 2.364-.128.213-.357.173.767-1.22 1.397-2.48.99-1.98 2.753-2.91z"/><path fill="#B251FC" d="M22.23 1.596q-.057.35.59.89a.42.42 0 0 1 .15.27q.116.79.344 1.527.165.537 0 1.107-.04.136.08.213.36.226.72-.003.116-.074.036-.187-.27-.377-.193-.89a.7.7 0 0 0-.037-.347 6.4 6.4 0 0 1-.41-2.16q.447.14.937.967l.707 2.516q-.084.477.093.657a.56.56 0 0 1 .16.337l.063.51a.15.15 0 0 1-.27.106c-.596-.823-1.68-.863-2.616-.84-1.014.024-2.064.987-2.944 1.694q-.72.495-1.473.946c-.573.344-1.04.317-1.643.457q-.044.01-.054-.037l-.02-.086a.114.114 0 0 1 .077-.134 7.8 7.8 0 0 0 3-1.603l2.73-1.893a.76.76 0 0 0 .31-.787l-.14-.646a.46.46 0 0 0-.163-.27 1.52 1.52 0 0 1-.524-.904.407.407 0 0 0-.673-.226q-2.016 1.826-3.207 4.093-.356.59-.837.857-.15.082-.176-.087l-.02-.127.293-.54q.23.04.357-.173.71-1.2 1.473-2.364c.597-.91 1.463-1.65 2.207-2.486q.366-.414 1.073-.357"/><path fill="#D69DF4" d="M22.23 1.596q.747-.25 1.28.42a6.4 6.4 0 0 0 .41 2.16c.042.112.054.231.037.347q-.077.513.193.89.08.114-.037.187a.625.625 0 0 1-.72.003q-.12-.077-.08-.213.168-.57 0-1.107-.226-.737-.343-1.527a.42.42 0 0 0-.15-.27q-.647-.54-.59-.89M11.417 2.72q.003.205.12.27.006.375-.433.323a.55.55 0 0 0-.31.057l-1.134.573a.7.7 0 0 0-.25.223q-.3.45-.833.53-.177.027-.19.204-.033.426.27.673.82 1.026.31 1.113l-1.82-1.71q1.836-1.35 3.617-2.283a.55.55 0 0 1 .326-.074q.164.02.327.1"/><path fill="#A001FF" d="m19.527 7.506-.104-.283 1.147-1.104q.054-.052 0-.106l-.063-.064q-.027-.023-.037-.013a9.8 9.8 0 0 1-1.926 1.523q-.37.226-.73.03.446-.783.046-.616 1.191-2.267 3.207-4.093a.407.407 0 0 1 .673.226q.107.554.524.904a.46.46 0 0 1 .163.27l.14.646a.76.76 0 0 1-.31.787z"/><path fill="#5400C2" d="M11.417 2.72q2.41 1.392 3.687 3.77-.15.595.396.7.167.646.554.546l.02.11q-.04.277-.144.243a14.55 14.55 0 0 0-6.673.59q-.037-.266-.16-.346c-.91-.607-1.964-1.45-2.407-2.484a.44.44 0 0 1-.01-.333q.16-.45.467-.54l1.82 1.71.783 1.07a.39.39 0 0 0 .463.134l.72-.294a.8.8 0 0 1 .357-.05 1 1 0 0 0 .41-.046q.184-.067.064-.22a.37.37 0 0 1-.08-.177q-.027-.127.103-.133a.3.3 0 0 1 .113.016q.33.35.72.387.173.016.224-.154.135-.489.01-1.053l.39.213q.083.51.433.677a.44.44 0 0 0 .353.017.82.82 0 0 1 .56-.017q.723.234.343-.423a11 11 0 0 0-3.396-3.643q-.117-.065-.12-.27"/><path fill="#B251FC" d="M11.537 2.99a11 11 0 0 1 3.396 3.643q.381.657-.343.423a.82.82 0 0 0-.56.017.44.44 0 0 1-.353-.017q-.35-.166-.434-.677.408.035.784.387a.137.137 0 0 0 .213-.036l.044-.09a.2.2 0 0 0-.017-.214c-.773-1.003-1.607-2.276-2.76-2.846a.51.51 0 0 0-.55.063l-2.3 1.93q-.303-.247-.27-.673.013-.177.19-.204a1.17 1.17 0 0 0 .833-.53.7.7 0 0 1 .25-.223l1.134-.573a.55.55 0 0 1 .31-.057q.44.053.433-.323"/><path fill="#A001FF" d="m13.244 6.38-.39-.214a1.13 1.13 0 0 0-.317-.64q-.177-.167-.164.073l.054.98a.17.17 0 0 1-.083.158.18.18 0 0 1-.18.006L10.05 5.596a.127.127 0 0 0-.183.14l.033.157a.37.37 0 0 0 .204.253l1.796.84a.3.3 0 0 0-.113-.016q-.13.006-.104.133a.37.37 0 0 0 .08.177q.12.153-.063.22a1 1 0 0 1-.41.046.8.8 0 0 0-.356.05l-.72.294a.39.39 0 0 1-.464-.134l-.783-1.07q.51-.087-.31-1.113l2.3-1.93a.51.51 0 0 1 .55-.063c1.153.57 1.987 1.843 2.76 2.846q.035.046.04.104a.2.2 0 0 1-.023.11l-.044.09a.14.14 0 0 1-.097.07.14.14 0 0 1-.116-.034q-.376-.353-.784-.387"/><path fill="#B251FC" d="M12.854 6.166q.125.564-.01 1.053-.05.17-.224.154-.39-.037-.72-.387l-1.796-.84a.37.37 0 0 1-.204-.253l-.033-.157a.127.127 0 0 1 .183-.14l2.114 1.147a.18.18 0 0 0 .18-.006.18.18 0 0 0 .083-.158l-.053-.98q-.015-.24.163-.073.25.244.317.64"/><path fill="#5400C2" d="M25.154 5.5q1.289 1.842-.44 2.91-.531.325.09.37l1.516.11-1.203.003q-1.33-.137-2.703.58l-4.657.186 1.93-.306q.343-.053.043-.233a.56.56 0 0 0-.393-.074.2.2 0 0 1-.17-.046q-.197-.18.04-.3l.443-.227a.43.43 0 0 0 .217-.243q.09-.24-.227-.267c.88-.707 1.93-1.67 2.944-1.694.936-.023 2.02.017 2.616.84a.15.15 0 0 0 .27-.106l-.063-.51a.56.56 0 0 0-.16-.337q-.177-.18-.093-.657m-.734 2.71a.13.13 0 0 0-.003-.12.31.31 0 0 0-.277-.18c-1.25-.074-2.6.473-3.797.91q-.562.205.027.31a4.2 4.2 0 0 0 1.77-.057q1.263-.31 2.453-.713a.1.1 0 0 1 .037-.004q.024.005.004.02a.03.03 0 0 1-.03.004.12.12 0 0 0-.064-.01q-.19.013-.12-.16"/><path fill="#B251FC" d="M19.424 7.223a5.1 5.1 0 0 1-1.637.88.183.183 0 0 1-.244-.19q.018-.214.27-.424.36.196.73-.03a9.8 9.8 0 0 0 1.927-1.523q.01-.01.037.013l.063.064q.054.052 0 .106z"/><path fill="#3C1F56" fill-opacity=".992" d="m15.104 6.49.396.7q-.546-.105-.396-.7"/><path fill="#4008A8" d="M17.814 7.49q-.255.21-.27.423a.19.19 0 0 0 .07.161.18.18 0 0 0 .173.029 5.1 5.1 0 0 0 1.637-.88l.103.283a7.8 7.8 0 0 1-3 1.603.113.113 0 0 0-.077.134l.02.086q.01.047.054.037c.603-.14 1.07-.113 1.643-.457q.753-.45 1.473-.946.317.026.227.267a.43.43 0 0 1-.217.243l-.443.227q-.237.12-.04.3a.2.2 0 0 0 .17.046q.21-.036.393.074.3.18-.043.233l-1.93.306-.98.137q-.483.067-.027.244.984.38 2.233.356 1.42.48 1.99 1.547.324.883.567 2.056.177.861.047 1.637-.217 1.323-.217 1.59 0 .843.004 1.773a.25.25 0 0 0 .09.19.17.17 0 0 1 .056.114q.22 2.01.737 4.106.17.687.437 1.32c.363.867.696 1.27 1.336 1.73q.18.018.374.37-.141-.09-.327.004l-.91-.644q.153-.13-.253-.166l-.447-1.054a.4.4 0 0 0-.217-.213q-.293-.12-.2-.507l-.75-3.65a27.5 27.5 0 0 1-.05-5.306q.32-1.67-.65-3.144-.016-.022-.036-.003a.1.1 0 0 1-.024.023q-.29-1.005-1.38-1.17a60 60 0 0 0-2.106-.286.44.44 0 0 0-.297.07l-2.28 1.527q-.547.12-.774.743l.02 2.35q.09.283.217.257.256.249.187.913v3.187l-.04 4.26q-.346-.074-.283-.704a480 480 0 0 1-.047-6.696q0-.244-.063-.4-.18-.447-.487-.07l-3.517-.714a.5.5 0 0 0-.143-.4.11.11 0 0 0-.113-.026.11.11 0 0 0-.074.09c-.266 1.996-.95 3.756-1.663 5.59-.487 1.253-1.207 2.436-1.677 3.733a.3.3 0 0 0-.033-.097.124.124 0 0 0-.187-.026l-.406.353q.8-1.464 1.58-2.913c.45-.837.643-1.734.973-2.617q.33-.88.557-1.974.45-2.16 1.043-4.24 1.687-2.383 4.42-2.77.619.097 1.223.057.316-.02.484-.236a.6.6 0 0 1 .186-.164q.234-.133.034-.31l-.15-.133a.4.4 0 0 0 .1.007q.076-.01.096-.08.167-.524.333-1.04.117-.364-.2-.394l-.02-.11q.597-.003.774-.22l.02.127q.027.17.176.087.48-.267.837-.857.4-.167-.046.616m-3.147 3.816q-1.45-1.003-3.17.3-.4.046-.913.84l-.474.533q-.403.638-.316 1.57.016.18.196.224l2.94.674q.407.156.444-.198.11-1.056-.084-2.42a13.2 13.2 0 0 1 3.074-2.07.11.11 0 0 0 .054-.132.1.1 0 0 0-.028-.044l-.07-.073q-.056-.057-.126-.017z"/><path fill="#D69DF4" d="M16.074 7.846q.315.03.2.394-.168.515-.334 1.04-.02.07-.096.08a.4.4 0 0 1-.1-.007 1.7 1.7 0 0 1-.04-.617q0-.256.226-.647.104.034.143-.243"/><path fill="#A001FF" d="M15.93 8.09q-.226.39-.226.646.043-.24-.117-.23a2 2 0 0 1-.677-.066c-.85-.227-1.71-.05-2.5.36q-.173.086-.086.263l.043.093q.01.02.03.01 1.187-.503 2.357-.483a.23.23 0 0 1 .18.09.12.12 0 0 1 .03.11q-.027.126-.157.137-1.394.096-2.787.806a.134.134 0 0 0-.072.146.14.14 0 0 0 .122.114l.19.02-2.383 1.49q-.17.107-.187-.097a.21.21 0 0 1 .057-.163 3.6 3.6 0 0 1 1.113-.81.15.15 0 0 0 .084-.096l.03-.1q.073-.234-.17-.217-.697.044-1.007-.964-.183-.59-.947-.31l.407-.16q3.263-1.073 6.673-.59M24.54 8.37a.12.12 0 0 1 .064.01.03.03 0 0 0 .03-.004q.02-.015-.004-.02a.1.1 0 0 0-.037.004q-1.189.403-2.453.713a4.2 4.2 0 0 1-1.77.057q-.59-.105-.027-.31c1.197-.437 2.547-.984 3.797-.91a.31.31 0 0 1 .277.18q.03.056.003.12-.07.173.12.16"/><path fill="#5400C2" d="M15.704 8.736q-.038.334.04.617l.15.133q.2.177-.034.31a.6.6 0 0 0-.186.164q-.168.216-.484.236-.603.04-1.223-.057l1.283-.076a.134.134 0 0 0 .125-.113.13.13 0 0 0-.005-.06l-.05-.154q-.043-.136-.19-.146a6.04 6.04 0 0 0-2.87.516l-.19-.02a.14.14 0 0 1-.122-.114.135.135 0 0 1 .072-.146q1.394-.71 2.787-.806.13-.01.157-.137a.12.12 0 0 0-.03-.11.23.23 0 0 0-.18-.09q-1.17-.02-2.357.483-.02.01-.03-.01l-.043-.093q-.088-.177.086-.263c.79-.41 1.65-.587 2.5-.36q.334.09.677.066.16-.01.117.23"/><path fill="#C374FE" d="M12.26 10.106a6.04 6.04 0 0 1 2.87-.516q.147.01.19.146l.05.154a.13.13 0 0 1-.017.116.13.13 0 0 1-.103.057l-1.283.076q-2.734.388-4.42 2.77-.19.224-.353.284-.256.096-.15-.157.115-.28.25-.547.159-.309-.167-.18a.4.4 0 0 0-.167.127.42.42 0 0 1-.353.177 7.6 7.6 0 0 0-1.233.096q-.22.034-.314-.17a.193.193 0 0 0-.323-.05q-.324.367-.503.177l.523-1.656.443-.61q.58-.937 1.65-1.56.764-.28.947.31.31 1.006 1.007.963.243-.017.17.216l-.03.1a.15.15 0 0 1-.084.097 3.6 3.6 0 0 0-1.113.81.21.21 0 0 0-.057.163q.017.204.187.097z"/><path fill="#4DACFF" d="M25.117 8.893q.846.39 2.27.16.58 1.12.06 2.82a8.3 8.3 0 0 0 .08-2.127q-.007-.063-.067-.06h-.003q-.063.004-.067.067-.04.747.004 1.493c.02.414-.284.7-.66.797a.54.54 0 0 0-.267.16q-.393.437-.633-.097l.123-1.86q.014-.17-.15-.223-.423-.147-.694.033a.9.9 0 0 1-.316-.047q-.11-.045.007-.076a.3.3 0 0 0 .096-.04q.06-.047-.01-.08-.456-.215-.64-.2a5.6 5.6 0 0 1-1.836-.14q1.373-.717 2.703-.58"/><path fill="#4DACFF" d="m25.117 8.893 1.203-.004 1.067.164q-1.424.23-2.27-.16"/><path fill="#A001FF" d="M22.414 9.473a5.6 5.6 0 0 0 1.836.14q.184-.015.64.2.07.033.01.08a.3.3 0 0 1-.096.04q-.117.03-.007.076a.9.9 0 0 0 .316.047l-1.04.624a.38.38 0 0 1-.496-.104q-.525-.73-1.32-.487a2.4 2.4 0 0 0-1.4.024q-.27.083-.07.287.15.152.23.35a.24.24 0 0 1 .007.176.12.12 0 0 1-.09.084.17.17 0 0 1-.17-.047 3.1 3.1 0 0 0-1.637-.843.15.15 0 0 0-.13.04q-.037.033-.007.076.037.055-.006.16-1.25.024-2.234-.357-.456-.175.027-.243l.98-.136z"/><path fill="#4894FF" d="m27.447 11.873-.034 11.65q0 .172-.15.256l-.573.32q-.974-1.61-1.083-2.68-.377-3.673.227-9.313.24.534.633.097a.54.54 0 0 1 .267-.16c.376-.097.68-.383.66-.797q-.044-.746-.004-1.493.003-.063.067-.067h.003q.06-.003.067.06.096 1.067-.08 2.127"/><path fill="#C374FE" d="M22.257 10.09c1.446.586 2.566 1.89 2.426 3.506a21.3 21.3 0 0 0 .034 3.787.9.9 0 0 0 .083.31q.077.153.077.323a14.2 14.2 0 0 0 1.38 6.067q.3.637.826 1.036.864 1.367 1.64 1.65 1.508.55-.096.48-1.42-.06-2.537-1.156-.043-.297.084-.454.09-.112 0-.226a.88.88 0 0 1-.18-.61 14.3 14.3 0 0 1-.914-2.347 8 8 0 0 0-.467-1.193q-.353-.747-.323-1.267.093-1.796.12-3.6l-.193-2.33q.073-.87-.377-1.23c-.483-.387-1.056-1.133-1.733-.503a.26.26 0 0 0-.07.303q.293.79-.243.453-.235-.856-.82-1.146-.57-1.067-1.99-1.547.042-.105.006-.16-.03-.043.007-.076a.15.15 0 0 1 .13-.04 3.1 3.1 0 0 1 1.637.843.17.17 0 0 0 .17.047.12.12 0 0 0 .09-.084.24.24 0 0 0-.007-.176 1.1 1.1 0 0 0-.23-.35q-.2-.204.07-.287.72-.22 1.4-.024"/><path fill="#5400C2" d="M25.114 10.056q.27-.18.693-.033.163.053.15.223l-.123 1.86q-.604 5.64-.227 9.313.11 1.07 1.083 2.68-.16.204.11.52.2.237.284.5a2.75 2.75 0 0 1-.827-1.037 14.2 14.2 0 0 1-1.38-6.066.7.7 0 0 0-.077-.323.9.9 0 0 1-.083-.31 21.3 21.3 0 0 1-.034-3.787c.14-1.617-.98-2.92-2.426-3.507q.795-.243 1.32.487a.37.37 0 0 0 .496.104z"/><path fill="#83D5ED" d="m7.2 10.4-.443.61q-.31-.057-.12-.07-.548.01-.84.296-.21.204-.224.76a6.7 6.7 0 0 1-.12 1.113q-.22-.963-.016-1.803a.33.33 0 0 1 .2-.237z"/><path fill="#B251FC" d="M13.29 12.83q-1.083.352-2.62-.27-.08-.034-.086-.114.513-.793.913-.84.723.416 1.53.5c.693.07 1.163-.35 1.64-.8l1.527-.813q.07-.04.126.017l.07.073a.11.11 0 0 1 .013.143.1.1 0 0 1-.04.034 13.2 13.2 0 0 0-3.073 2.07"/><path fill="#4DACFF" d="M20.54 12.17q-.203.05-.16.106-.002-.213-.236-.24a.4.4 0 0 0-.247.05q-.556.323-1.147.647-.435.243-1.156.15a30 30 0 0 1-3.117-.573l2.28-1.527a.44.44 0 0 1 .297-.07q1.07.126 2.106.287 1.09.162 1.38 1.17"/><path fill="#A001FF" d="M14.667 11.306c-.477.45-.947.87-1.64.8a3.8 3.8 0 0 1-1.53-.5q1.72-1.303 3.17-.3"/><path fill="#83D5ED" d="M6.637 10.94a7.6 7.6 0 0 0-.87 2.48q-.143-.024-.11.15l-.213.083a1.5 1.5 0 0 1 .01-.544q.105-.549.12-1.113.013-.556.223-.76.293-.287.84-.297"/><path fill="#C374FE" d="M6.637 10.94q-.19.012.12.07l-.523 1.656a1.6 1.6 0 0 1-.467.753 7.6 7.6 0 0 1 .87-2.48"/><path fill="#A001FF" d="M20.974 11.943q.586.29.82 1.146.443 1.623.26 2.663-.36 2.027-.114 3.254c.147.723.09 1.31.114 2.01a.3.3 0 0 0 .04.13 1 1 0 0 0 .076.1.47.47 0 0 1 .134.29q.213 2.467 1.726 4.923c-.64-.46-.973-.863-1.336-1.73a9 9 0 0 1-.437-1.32 31.5 31.5 0 0 1-.737-4.106.17.17 0 0 0-.056-.114.25.25 0 0 1-.09-.19l-.004-1.773q0-.267.217-1.59a4.4 4.4 0 0 0-.047-1.637 15 15 0 0 0-.566-2.056"/><path fill="#83D5ED" d="M20.38 12.276q-.713.407-1.467.747-.69.313-1.163.25a21 21 0 0 1-1.717-.307 1.4 1.4 0 0 0-.746.03.12.12 0 0 0 .03.233q1.38.07 2.593.437.137.04.133.18l-.033 2.057q-.007.369-.373.313l-3.697-.556q-.126.026-.217-.257a.2.2 0 0 0 .057-.137q.007-.123.13-.117a.74.74 0 0 1 .357.117.8.8 0 0 0 .303.11l2.51.383q.59.094.58-.503l-.013-.75q-.014-.707-.707-.837l-3.237-.616q.228-.624.774-.743 1.566.373 3.117.573.72.093 1.156-.15.59-.323 1.147-.647a.4.4 0 0 1 .247-.05q.233.027.236.24"/><path fill="#B251FC" d="M24.217 14.066q-.546-.87-1.453-.767-.44.048-.394.49a8.6 8.6 0 0 1-.02 2.087c-.263 1.973-.033 4.127.244 6.077q.156 1.093.75 2.043.636 1.017 1.22 1.957a4.2 4.2 0 0 0 1.83 1.626q.26.124.043-.066a.27.27 0 0 0-.163-.064.084.084 0 0 1-.077-.116.1.1 0 0 1 .037-.04.5.5 0 0 1 .17-.05q.66.79 1.533 1.026a.063.063 0 0 1-.013.123q-1.128.067-2.167-.546l-1.353-1.016q-.194-.354-.374-.37-1.513-2.458-1.726-4.924a.47.47 0 0 0-.134-.29 1 1 0 0 1-.076-.1.3.3 0 0 1-.04-.13c-.024-.7.033-1.287-.114-2.01q-.246-1.226.114-3.254.183-1.039-.26-2.663.536.337.243-.453a.26.26 0 0 1 .07-.303c.677-.63 1.25.116 1.733.503q.45.36.377 1.23"/><path fill="#4894FF" d="M20.54 12.17a.1.1 0 0 0 .024-.024q.02-.02.036.003.97 1.474.65 3.144l-2.583 1.237a.21.21 0 0 0-.13.216l.103 3.514a.287.287 0 0 0 .27.28.3.3 0 0 0 .14-.024q.614-.277 1.37-.136.156.03.237.173a.37.37 0 0 0 .343.2q.273.003.3-.153l.75 3.65.017 2.336q-.74.48-.587.623-.186.164-.55.287-.316.023-.703.257-1.12.846-2.16 1.093.107-1.307.077-2.513-.047-1.703-.017-2.507a67 67 0 0 0-.13-7.11q-.886.08-1.197-.163a.57.57 0 0 0-.29-.12q-1.07-.144-2.136-.293-.334-.047-.247.433.07-.663-.187-.913l3.697.556q.366.056.373-.313l.033-2.057q.004-.14-.133-.18a10.8 10.8 0 0 0-2.593-.437.12.12 0 0 1-.03-.233 1.4 1.4 0 0 1 .746-.03 21 21 0 0 0 1.717.307q.473.063 1.163-.25a18 18 0 0 0 1.467-.747q-.043-.057.16-.107"/><path fill="#B251FC" d="M9.547 12.91a60 60 0 0 0-1.043 4.24 13.4 13.4 0 0 1-.557 1.973c-.33.883-.523 1.78-.973 2.616q-.78 1.45-1.58 2.914c-.684.997-1.88 2.19-3.134 2.393q-.237.036-.057-.12 1.124-.98 1.254-2.71a.13.13 0 0 0-.049-.115.14.14 0 0 0-.125-.028q-1.266.319-2.35-.037-.932-.303.04-.43.258-.033.877-.303.024.35.277.407.18.04.333-.053 1.538-.95 2.144-2.374.49-1.154.766-2.513.07-.34-.236-.174-.024.015-.144.377l.347-2.047.32-3.356q-.033-.174.11-.15.333-.298.467-.754.18.19.503-.177a.194.194 0 0 1 .323.05q.094.204.314.17a7.6 7.6 0 0 1 1.233-.096.42.42 0 0 0 .353-.177.4.4 0 0 1 .167-.127q.326-.129.167.18-.135.267-.25.547-.107.253.15.157.163-.06.353-.284m-5.05 11.623a.13.13 0 0 0 .08-.044 18 18 0 0 0 2.203-3.27q.367-.693.56-1.486c.304-1.234.757-2.364.937-3.637q.154-1.08.4-2.123.11-.464-.337-.304a8 8 0 0 1-1.346.357.29.29 0 0 1-.284-.11.4.4 0 0 0-.11-.093.255.255 0 0 0-.303.031.25.25 0 0 0-.06.089q-.243.603-.323 1.236a31 31 0 0 0-.204 4.824c.054 1.476-.916 2.97-1.593 4.223a.26.26 0 0 0 .02.273q.164.227.293.07a.1.1 0 0 1 .067-.036"/><path fill="#A001FF" d="M10.584 12.446q.006.08.086.113 1.537.624 2.62.27.194 1.364.084 2.42-.037.354-.444.197a.23.23 0 0 0 .107-.093q.07-.147-.09-.18l-2.52-.517a.37.37 0 0 1-.297-.36l-.02-1.317z"/><path fill="#B251FC" d="m10.11 12.98.02 1.316a.38.38 0 0 0 .297.36l2.52.517q.16.033.09.18a.23.23 0 0 1-.107.094l-2.94-.674q-.18-.043-.196-.223-.087-.933.316-1.57"/><path fill="#4DACFF" d="m13.704 13.053 3.236.616q.693.13.707.837l.013.75q.01.597-.58.503l-2.51-.383a.8.8 0 0 1-.303-.11.74.74 0 0 0-.357-.117q-.123-.006-.13.117a.2.2 0 0 1-.057.137z"/><path fill="#A001FF" d="m24.217 14.066.193 2.33a2.1 2.1 0 0 0-.21 1.074.35.35 0 0 1-.163.333q-.607.417-.697 1.177-.246 2.136.903 4.177.345.605 1.75 1.646a.88.88 0 0 0 .18.61q.09.112 0 .226-.125.157-.083.454-.074-.105-.146-.107-.137-.4-.407-.497-.197-.073-.163.134.03.183.196.336l.834 1.284a.5.5 0 0 0-.17.05.083.083 0 0 0 .04.156q.09.004.163.064.216.19-.043.066a4.2 4.2 0 0 1-1.83-1.626q-.584-.941-1.22-1.957a5.2 5.2 0 0 1-.75-2.043c-.277-1.95-.507-4.104-.244-6.077a8.6 8.6 0 0 0 .02-2.087q-.046-.442.394-.49.906-.103 1.453.767M5.657 13.57l-.32 3.356a.8.8 0 0 1-.247.177l.354-3.45zM4.43 24.57q-.13.155-.293-.07a.26.26 0 0 1-.02-.274c.677-1.253 1.647-2.747 1.593-4.223a31 31 0 0 1 .204-4.824q.079-.633.323-1.236a.25.25 0 0 1 .153-.144.25.25 0 0 1 .21.024.4.4 0 0 1 .11.093.29.29 0 0 0 .284.11q.692-.12 1.346-.357.447-.16.337.304a24 24 0 0 0-.4 2.123c-.18 1.273-.633 2.403-.937 3.637a6.4 6.4 0 0 1-.56 1.486 18 18 0 0 1-2.203 3.27.13.13 0 0 1-.08.044.1.1 0 0 0-.067.036"/><path fill="#4894FF" d="m9.69 15.436.017.483-.133 10.244-3.034-.697q-.165-.035-.21.13l-.026.117a.137.137 0 0 0 .1.167l2.76.693-3.054-.72a.245.245 0 0 1-.2-.214 2.44 2.44 0 0 1 .11-1.216c.47-1.297 1.19-2.48 1.677-3.734.713-1.833 1.397-3.593 1.663-5.59a.11.11 0 0 1 .187-.063.5.5 0 0 1 .143.4"/><path fill="#4DACFF" d="M21.25 15.293a27.5 27.5 0 0 0 .05 5.307q-.027.156-.3.153a.37.37 0 0 1-.343-.2.33.33 0 0 0-.237-.173q-.756-.14-1.37.136a.296.296 0 0 1-.372-.121.3.3 0 0 1-.038-.135l-.103-3.514a.21.21 0 0 1 .13-.216z"/><path fill="#A001FF" d="m13.207 16.15.09 11.15q0 .17-.167.2a2.2 2.2 0 0 1-.7.013l-2.166-.587q-.014-.107-.147-.253l.176.043a.203.203 0 0 0 .237-.14q.55-1.88.52-3.82-.04-2.28-.15-4.864a1.9 1.9 0 0 0-.267-.903 9 9 0 0 0-.586-.873q-.187.577-.34-.197l-.017-.483z"/><path fill="#826BC8" fill-opacity=".996" d="M9.707 15.92q.153.772.34.196-.167.656-.04.98l.063 9.417q.087-.054.047.16.134.146.146.253-.662-.05-1.1-.353a.38.38 0 0 1 .234 0q.157.039.187-.12a.53.53 0 0 0-.01-.29z"/><path fill="#B251FC" d="m13.804 23.316-.087 4.08q-.003.174-.177.174h-.816a.9.9 0 0 1-.294-.057q.367.05.7-.013.167-.03.167-.2l-.09-11.15q.307-.378.487.07.063.156.063.4 0 3.352.047 6.696"/><path fill="#4DACFF" d="M17.997 16.716a3.2 3.2 0 0 0-.267 1.877q-.657 1.04-1.146 1.08-.645.054-1.417.203-.163.034-.133.197.023.117-.114.147a.265.265 0 0 0-.2.24q-.03.456-.246.763-.345.483-.347-.11v-4.54q-.087-.48.247-.433 1.066.15 2.136.293a.57.57 0 0 1 .29.12q.31.243 1.197.163"/><path fill="#B251FC" d="M10.117 26.673q.039-.213-.047-.16l.163-.047q.164-.043.164-.213c0-.357-.11-.677-.1-1.023q.106-3.734.006-7.474a.5.5 0 0 0-.103-.293 1.1 1.1 0 0 1-.193-.367q-.127-.324.04-.98.34.45.586.873.247.424.267.903.11 2.584.15 4.864a12.8 12.8 0 0 1-.52 3.82.203.203 0 0 1-.236.14zM24.41 16.397a97 97 0 0 1-.12 3.6q-.03.519.323 1.266.317.674.467 1.193.34 1.18.914 2.347-1.407-1.04-1.75-1.646-1.15-2.04-.904-4.177.09-.761.697-1.177a.35.35 0 0 0 .163-.333 2.1 2.1 0 0 1 .21-1.073"/><path fill="#83D5ED" d="M17.997 16.716q.253 3.584.13 7.11-.03.803.017 2.507.03 1.206-.077 2.513l-.993-.276-1.5-.51-.144-.044q-.126-.036-.05-.146.084-.123.243-.097.98.164 1.834.47a.186.186 0 0 0 .25-.173l.023-9.477a3.2 3.2 0 0 1 .267-1.877"/><path fill="#A001FF" d="m5.337 16.926-.347 2.047a3.3 3.3 0 0 1-.5.97l.6-2.84a.8.8 0 0 0 .247-.177"/><path fill="#D69DF4" d="M10.007 17.096q.053.183.193.367a.5.5 0 0 1 .104.293q.1 3.74-.007 7.474c-.01.346.1.666.1 1.023q0 .17-.164.213l-.163.047zM1.85 23.303c1.514-.66 2-1.684 2.64-3.36q.317-.417.5-.97.12-.363.144-.377.306-.166.236.174-.277 1.36-.766 2.513-.608 1.423-2.144 2.374a.44.44 0 0 1-.333.053q-.253-.057-.277-.407"/><path fill="#4894FF" d="m17.73 18.593-.023 9.477a.187.187 0 0 1-.25.173 10.5 10.5 0 0 0-1.834-.47q-.159-.026-.243.097-.076.11.05.146l.144.044-.727-.014a1.12 1.12 0 0 1-.61-.256.34.34 0 0 1-.13-.277l-.02-3.493.04-4.26v1.353q.003.593.347.11.216-.306.246-.763a.26.26 0 0 1 .2-.24q.137-.03.114-.147-.03-.163.133-.197.773-.15 1.417-.203.489-.04 1.146-1.08"/><path fill="#5400C2" d="M13.804 23.316q-.064.63.283.704l.02 3.493q0 .17.13.276.274.224.61.257a.34.34 0 0 0-.17.047l-1.953-.523h.816q.174 0 .177-.174zM22.05 24.25q-.093.386.2.506a.39.39 0 0 1 .217.213l.447 1.054q-.164.483-.847.563z"/><path fill="#3C1F56" fill-opacity=".992" d="M25.944 25.986a.55.55 0 0 0-.374-.027.6.6 0 0 1-.196-.336q-.034-.207.163-.134.27.097.407.497"/><path fill="#83D5ED" d="M9.574 26.163a.53.53 0 0 1 .01.29q-.03.159-.187.12a.38.38 0 0 0-.233 0l-2.76-.693a.14.14 0 0 1-.103-.113.14.14 0 0 1 .003-.054l.026-.117q.045-.165.21-.13z"/><path fill="#4894FF" d="M22.914 26.023q.406.036.253.166l-1.687 1.02q-.153-.143.587-.623.684-.08.847-.563"/><path fill="#3C1F56" fill-opacity=".992" d="M24.077 26.833q.186-.094.327-.003l1.353 1.016a4.7 4.7 0 0 1-1.68-1.013"/><path fill="#4894FF" d="M20.93 27.496a1.23 1.23 0 0 1-.68.457.6.6 0 0 0-.023-.2q.387-.233.703-.257"/><path fill="#4894FF" d="M20.227 27.753q.03.1.023.2l-1.777 1.016a.4.4 0 0 1-.306.04l-1.607-.416a.76.76 0 0 1 .514-.023l.993.276q1.04-.247 2.16-1.093"/><path fill="#826BC8" fill-opacity=".996" d="M14.677 28.093a.34.34 0 0 1 .17-.047l.727.014 1.5.51a.76.76 0 0 0-.514.023z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-gift_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M11 3.309C12.294.98 14.737.697 16.133 2.093c1.14 1.14 1.16 2.983-.135 4.325h.502a3.667 3.667 0 0 1 3.666 3.666v.393c0 .923-.127 1.418-.367 1.867a2.52 2.52 0 0 1-1.464 1.224l-.002 1.899c0 1.634-.17 2.227-.49 2.824a3.33 3.33 0 0 1-1.386 1.386c-.597.32-1.19.49-2.824.49H8.366c-1.635 0-2.227-.17-2.825-.49a3.33 3.33 0 0 1-1.386-1.386c-.32-.597-.49-1.19-.49-2.824v-1.899a2.52 2.52 0 0 1-1.466-1.224c-.22-.411-.345-.861-.364-1.644l-.003-.616a3.667 3.667 0 0 1 3.667-3.667l.505.001c-1.295-1.342-1.276-3.184-.136-4.325C7.266.696 9.711.981 11.001 3.31m-.826 10.441h-4.86l.002 1.94c.012.616-.004 1.266.294 1.823.503.94 1.581.995 2.533 1.003h2.03zm6.508 0h-4.858v4.766h2.03c.951-.018 2.03-.061 2.533-1.003.204-.382.285-.756.294-1.823zm-.183-5.683-4.675.001V12.1h5.155c.5-.005 1.1-.04 1.364-.535.108-.2.161-.425.17-.914l.002-.567A2.017 2.017 0 0 0 16.5 8.067m-11 0a2.017 2.017 0 0 0-2.017 2.017l.002.567c.01.49.063.713.17.914.265.494.862.53 1.361.535h5.159V8.068zM7.035 3.26c-.98.98-.07 2.82 2.908 3.134l.234.021C9.938 3.244 8.133 2.162 7.035 3.26m7.93 0c-1.098-1.098-2.903-.016-3.141 3.155l.233-.021c2.979-.314 3.888-2.154 2.908-3.134"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-grant-role" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.7 12h-6.2m6.2 0-3-2.691m3 2.692-3 2.692"/><path fill="currentColor" fill-rule="evenodd" d="M4.297 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.004.008c.012.015.053.052.138.052h15.59c.085 0 .126-.037.138-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.456-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.305.411-.8.658-1.342.658H2.205c-.54 0-1.036-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.495.737-5.703 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-graph_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M6 16a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m5-12a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m5 8a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1m5-4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="14" fill="none" id="svg-name-group" class="svg-sprite__symbol"><path fill="currentColor" d="M17.91 9.58A4.59 4.59 0 0 0 13.76 7h-1.52a4.6 4.6 0 0 0-2.45.7c.408.422.748.904 1.01 1.43.13.268.198.562.2.86V14h6a1.003 1.003 0 0 0 1-1V9.99a1 1 0 0 0-.09-.41M5.764 7H4.236A4.59 4.59 0 0 0 .094 9.576.96.96 0 0 0 0 10v3a1 1 0 0 0 1 1h9V9.993a.9.9 0 0 0-.094-.417A4.59 4.59 0 0 0 5.764 7M5 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6M13 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.929 19-7.593-8.638C.948 8.872.604 6.594 1.48 4.708c.656-1.409 1.902-2.393 3.349-2.645s2.804.259 3.84 1.372l1.259 1.54 1.258-1.54c1.037-1.113 2.536-1.624 3.983-1.372s2.693 1.236 3.349 2.645c.877 1.886.533 4.163-.855 5.654z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.929 19-7.593-8.638C.948 8.872.604 6.594 1.48 4.708c.656-1.409 1.902-2.393 3.349-2.645s2.804.259 3.84 1.372l1.259 1.54 1.258-1.54c1.037-1.113 2.536-1.624 3.983-1.372s2.693 1.236 3.349 2.645c.877 1.886.533 4.163-.855 5.654z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-heart-reaction" class="svg-sprite__symbol"><path fill="#fff" stroke="currentColor" d="m8.998 16.064-.258.428.258.155.257-.155zm0 0 .257.428.002-.001.005-.003.02-.012.07-.043c.06-.038.15-.094.261-.166a27.616 27.616 0 0 0 3.725-2.907c1.018-.953 2.051-2.087 2.832-3.339.78-1.25 1.325-2.644 1.325-4.104a4.886 4.886 0 0 0-4.884-4.884 4.87 4.87 0 0 0-3.613 1.601 4.87 4.87 0 0 0-3.614-1.6A4.886 4.886 0 0 0 .5 5.916c0 1.46.546 2.854 1.325 4.104.781 1.252 1.814 2.386 2.832 3.338a27.6 27.6 0 0 0 4.057 3.117l.019.012.005.003h.001v.001z"/><path fill="url(#a)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384"/><path fill="url(#b)" d="M14.426 1.923c2.399 3.824.19 8.843-2.464 10.267-2.93 1.575-4.934.835-9.083-1.52 2.365 3.135 6.118 5.389 6.118 5.389s7.998-4.804 7.998-10.147a4.39 4.39 0 0 0-2.57-3.989" opacity=".5"/><path fill="url(#c)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384" opacity=".5"/><path fill="url(#d)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384" opacity=".5"/><path fill="url(#e)" d="M7.903 3.313c.44 1.034-.535 2.439-2.18 3.134-1.644.694-3.328.425-3.768-.605s.535-2.44 2.179-3.134c1.644-.695 3.329-.43 3.769.605" opacity=".24"/><path fill="url(#f)" d="M13.261 2.473c.625.69.24 2.054-.855 3.044s-2.489 1.235-3.114.545c-.624-.69-.24-2.054.855-3.044s2.49-1.235 3.114-.545" opacity=".24"/><path fill="url(#g)" d="M12.691 2.698c2.2.75 4.299 3.999.75 8.047-2.124 2.425-4.443 3.65-7.393 3.17a27 27 0 0 0 2.955 2.149S17 11.26 17 5.917a4.393 4.393 0 0 0-4.389-4.384c-1.5 0-2.824.755-3.613 1.905 0 0 2.084-1.29 3.693-.74" opacity=".32"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 13.999 -9.992)scale(12.5142 9.92695)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset=".864" stop-color="#C20000"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 12.69 -10.965)scale(10.7743 8.54677)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 13.999 -9.992)scale(12.5142 9.92695)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity=".25"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(8.18957 -4.04683 1.9997 4.0468 11.209 9.835)" gradientUnits="userSpaceOnUse"><stop stop-color="#BD2719" stop-opacity=".25"/><stop offset="1" stop-color="#BD2719" stop-opacity="0"/></radialGradient><radialGradient id="e" cx="0" cy="0" r="1" gradientTransform="matrix(3.0175 -1.20025 .74557 1.87442 4.928 4.577)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(-40.763 11.386 -13.033)scale(2.6887 1.67029)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><linearGradient id="g" x1="10.648" x2="12.197" y1="21.77" y2=".877" gradientUnits="userSpaceOnUse"><stop stop-color="#860805"/><stop offset="1" stop-color="#BD2719" stop-opacity="0"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart-with-coins" class="svg-sprite__symbol"><ellipse cx="15" cy="11" stroke="currentColor" stroke-width="1.5" rx="4" ry="2"/><path stroke="currentColor" stroke-width="1.5" d="M19 14c0 1.105-1.79 2-4 2s-4-.895-4-2"/><path stroke="currentColor" stroke-width="1.5" d="M11 10.75v6.929c0 .867 1.79 1.571 4 1.571s4-.704 4-1.571V10.75"/><path fill="currentColor" fill-rule="evenodd" d="M4.105 1.788c.85-.146 1.653.134 2.3.809l-4.353.795c.411-.868 1.181-1.455 2.053-1.604m9.868 4.258a3.18 3.18 0 0 0-.025-2.654c-.411-.868-1.181-1.455-2.054-1.604a2.72 2.72 0 0 0-2.41.809L8.52 3.755a.75.75 0 0 1-1.153 0l-.963-1.158-4.353.795c-.553 1.168-.33 2.576.532 3.487l.014.016L7.95 12.88 9 11.727v2.228l-.501.55a.75.75 0 0 1-1.114-.005L1.487 7.902C.197 6.532-.114 4.462.697 2.75 1.305 1.463 2.473.545 3.851.31 5.247.07 6.548.565 7.51 1.581l.032.036.402.484.402-.484.033-.036A4.22 4.22 0 0 1 12.148.309c1.378.236 2.546 1.154 3.155 2.44.49 1.036.57 2.202.272 3.265a12 12 0 0 0-1.602.032" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-heart_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14 2a11.97 11.97 0 0 0-8.485 3.515A11.97 11.97 0 0 0 2 14c0 3.313 1.344 6.315 3.515 8.485A11.97 11.97 0 0 0 14 26c3.313 0 6.315-1.344 8.485-3.515A11.97 11.97 0 0 0 26 14c0-3.313-1.344-6.315-3.515-8.485A11.97 11.97 0 0 0 14 2M6.929 6.929A9.97 9.97 0 0 1 14 4a9.97 9.97 0 0 1 7.071 2.929A9.97 9.97 0 0 1 24 14a9.97 9.97 0 0 1-2.929 7.071A9.97 9.97 0 0 1 14 24a9.97 9.97 0 0 1-7.071-2.929A9.97 9.97 0 0 1 4 14a9.97 9.97 0 0 1 2.929-7.071M11.422 9C9.275 9 7.5 10.733 7.5 12.9c0 1.127.306 2.018 1.031 2.916.665.824 1.694 1.662 3.076 2.743l.003.002 1.429 1.11c.565.439 1.357.439 1.922 0l1.43-1.11.003-.002c1.38-1.081 2.41-1.92 3.075-2.743.725-.898 1.031-1.789 1.031-2.916 0-2.167-1.775-3.9-3.922-3.9-.98 0-1.845.334-2.583.937-.74-.6-1.6-.937-2.573-.937M9.5 12.9c0-1.043.86-1.9 1.922-1.9.62 0 1.214.267 1.806.987a1 1 0 0 0 1.55-.008c.572-.71 1.162-.979 1.8-.979 1.062 0 1.922.857 1.922 1.9 0 .675-.152 1.122-.587 1.66-.494.612-1.327 1.308-2.75 2.423l-.002.001-1.161.901-1.16-.901-.002-.001c-1.424-1.115-2.256-1.811-2.751-2.423-.434-.538-.587-.985-.587-1.66" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-help-encircled" class="svg-sprite__symbol"><circle cx="8" cy="8" r="7.2" stroke="currentColor" stroke-width="1.2"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M5.6 6.4c0-3.357 4.8-3.357 4.8 0 0 1.6-1.6 2-2.4 3.2"/><path stroke="currentColor" stroke-width=".8" d="M8.4 12a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-help_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="M7.972 9.598c.376 0 .583-.21.662-.572.07-.454.228-.686.933-1.102.746-.449 1.133-1.005 1.133-1.82 0-1.26-1.012-2.102-2.516-2.102-1.139 0-1.986.46-2.325 1.172-.106.206-.159.41-.159.643 0 .41.26.675.678.675.323 0 .561-.15.694-.497.17-.48.519-.74 1.038-.74.583 0 .985.368.985.897 0 .497-.206.767-.89 1.183-.625.373-.948.794-.948 1.431v.076c0 .443.265.756.715.756"/><path fill="currentColor" fill-rule="evenodd" d="M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8" clip-rule="evenodd"/><path fill="currentColor" d="M8.9 11.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-help_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10 6.25a1.25 1.25 0 0 0-1.21.937.75.75 0 0 1-1.453-.374 2.75 2.75 0 0 1 5.413.687c0 1.211-.654 1.84-1.145 2.298l-.008.008c-.478.446-.772.72-.854 1.3a.75.75 0 0 1-1.485-.212c.158-1.11.803-1.709 1.256-2.13l.068-.062c.447-.417.668-.663.668-1.202 0-.69-.56-1.25-1.25-1.25M10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/><path fill="currentColor" fill-rule="evenodd" d="M10 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-help_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M25.46 18.099c-.63.377-1.176.98-1.567 1.958a1.5 1.5 0 1 1-2.786-1.114c.61-1.523 1.562-2.669 2.809-3.417C25.145 14.79 26.556 14.5 28 14.5c4.473 0 7 3.85 7 7 0 2.81-1.717 4.354-2.983 5.494l-.257.232c-1.307 1.19-2.26 2.19-2.26 4.274a1.5 1.5 0 0 1-3 0c0-3.416 1.797-5.177 3.24-6.492l.071-.065C31.24 23.643 32 22.949 32 21.5c0-1.85-1.518-4-4-4-1.056 0-1.895.211-2.54.599M28 41a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill="currentColor" fill-rule="evenodd" d="M28 52c13.255 0 24-10.745 24-24S41.255 4 28 4 4 14.745 4 28s10.745 24 24 24m0-3c11.598 0 21-9.402 21-21S39.598 7 28 7 7 16.402 7 28s9.402 21 21 21" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hide-eye" class="svg-sprite__symbol"><path fill="currentColor" d="M10 4.709a.75.75 0 0 0 0-1.5zm-5.338 8.897a.75.75 0 1 0 .676-1.339zm5.336-10.4a.75.75 0 0 0 .004 1.5zm2.97 1.884a.75.75 0 1 0 .386-1.45zm-8.52 11.47a.75.75 0 0 0 1.104 1.016zm4.046-2.178a.75.75 0 0 0-1.103-1.016zM18.55 3.456a.75.75 0 0 0-1.105-1.014zm-3.41 1.497a.75.75 0 0 0 1.106 1.015l-1.105-1.015Zm-7.75 8.413a.75.75 0 1 0 1.104 1.017l-1.103-1.017Zm3.295-2.469.552.509v-.001zm1.24-1.35-.552-.507.552.508Zm4.317-3.58A.75.75 0 1 0 15.14 4.95l1.103 1.016Zm-8.177 7.168a.75.75 0 0 0-.246 1.48zm1.934.909v-.75zM18 9h.75q0-.026-.002-.053zm-1.957-4.205a.75.75 0 0 0-.702 1.326zM7.77 10.624a.75.75 0 0 0 1.217-.877zm.445-2.534.67.34zm1.787-1.107L10 6.234h-.005l.006.75Zm.654.937a.75.75 0 0 0 .796-1.27zM10 3.21c-2.329 0-4.472.593-6.057 1.592C2.368 5.794 1.25 7.26 1.25 9h1.5c0-1.044.673-2.1 1.993-2.931 1.31-.825 3.167-1.36 5.257-1.36v-1.5ZM1.25 9c0 1.992 1.456 3.618 3.412 4.605l.676-1.339C3.637 11.407 2.75 10.191 2.75 9zm8.752-4.295a11.4 11.4 0 0 1 2.966.384l.386-1.45a12.9 12.9 0 0 0-3.356-.434zm-4.45 12.87 2.942-3.195-1.103-1.016-2.943 3.194 1.104 1.016ZM17.445 2.441l-2.304 2.511 1.105 1.015 2.304-2.512zm-8.951 11.94 2.743-2.976-1.103-1.017-2.743 2.977zm2.744-2.977 1.24-1.35-1.105-1.015-1.24 1.35zm1.239-1.35 3.765-4.088L15.14 4.95l-3.767 4.09 1.104 1.016Zm-4.658 4.56q1.083.18 2.181.179l-.001-1.5a12 12 0 0 1-1.934-.16l-.246 1.48Zm2.18.179c2.329 0 4.472-.594 6.057-1.593 1.575-.992 2.693-2.458 2.693-4.2h-1.5c0 1.044-.673 2.1-1.993 2.931-1.31.826-3.167 1.362-5.257 1.362zm8.748-5.846a5.11 5.11 0 0 0-2.705-4.152l-.702 1.326a3.61 3.61 0 0 1 1.911 2.933zm-9.76.8a1.27 1.27 0 0 1-.104-1.318l-1.338-.678a2.77 2.77 0 0 0 .224 2.873zM8.882 8.43a1.27 1.27 0 0 1 1.124-.696l-.012-1.5a2.77 2.77 0 0 0-2.45 1.518zm1.119-.696c.23 0 .457.065.653.187l.796-1.27A2.73 2.73 0 0 0 10 6.233l.002 1.5Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hide_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.964 5.5A.75.75 0 0 1 9.958 4a11.9 11.9 0 0 1 5.918 1.578C17.566 6.558 19 8.068 19 10c0 1.003-.393 1.901-.999 2.659a.75.75 0 1 1-1.171-.937c.442-.553.67-1.13.67-1.722 0-1.13-.858-2.245-2.376-3.125A10.4 10.4 0 0 0 9.964 5.5M4.124 14.422C5.844 15.42 8.036 16 10 16c1.605 0 3.355-.388 4.873-1.066l.847.846a.75.75 0 1 0 1.06-1.06L5.28 3.22a.75.75 0 0 0-1.06 1.06l.823.824c-.974.445-1.87 1.02-2.57 1.712C1.606 7.672 1 8.752 1 10c0 1.932 1.433 3.443 3.124 4.422M8.5 10a1.5 1.5 0 0 0 2.53 1.09L8.91 8.97c-.254.269-.41.631-.41 1.03M7 10a3 3 0 0 0 5.09 2.151l1.635 1.635c-1.201.458-2.523.714-3.725.714-1.702 0-3.635-.513-5.124-1.376C3.358 12.244 2.5 11.13 2.5 10c0-.731.35-1.448 1.028-2.117.66-.653 1.593-1.217 2.66-1.635l1.66 1.661A3 3 0 0 0 7 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-hide_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M12.44 10.44a1.5 1.5 0 0 1 2.12 0l31 31a1.5 1.5 0 0 1-2.12 2.12l-2.515-2.513C37.03 43.573 32.652 45 28 45c-6.256 0-12.004-2.583-16.639-6.832C7.644 34.761 5 30.485 5 28c0-3.35 4.362-9.256 9.932-12.947l-2.493-2.492a1.5 1.5 0 0 1 0-2.122m4.662 6.784C12.052 20.387 8 25.732 8 28c0 1.454 2.232 5.063 5.389 7.957C17.505 39.73 22.556 42 28 42c3.828 0 7.46-1.118 10.75-3.129l-4.446-4.446a9 9 0 0 1-12.728-12.728zM28 11c6.256 0 12.004 2.583 16.639 6.832C48.356 21.239 51 25.515 51 28c0 1.99-1.714 5.171-4.331 8.11a1.5 1.5 0 1 1-2.24-1.996C46.6 31.676 48 29.078 48 28c0-1.454-2.231-5.063-5.389-7.957C38.496 16.27 33.444 14 28 14c-1.443 0-2.86.159-4.248.468a1.5 1.5 0 0 1-.652-2.928A22.5 22.5 0 0 1 28 11m-4.302 12.819a6 6 0 0 0 8.484 8.485zm5.93-3.296a1.5 1.5 0 0 1 1.974-.773 9.03 9.03 0 0 1 4.651 4.651 1.5 1.5 0 0 1-2.75 1.2 6.03 6.03 0 0 0-3.102-3.102 1.5 1.5 0 0 1-.774-1.976"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hint" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9"/><path d="M7 8c0-4.196 6-4.196 6 0 0 2-2 2.5-3 4M10 14.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-home_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="m24 11.15-8.9-8.5c-.6-.6-1.6-.6-2.3 0l-8.9 8.5c-.6.6-.9 1.4-.9 2.2v8.6c0 1.4 1.1 2.5 2.5 2.5h6c.6 0 1-.4 1-1v-7h3v7c0 .6.4 1 1 1h6c1.4 0 2.5-1.1 2.5-2.5v-8.6c0-.8-.4-1.6-1-2.2m-1 10.8c0 .3-.2.5-.5.5h-5v-7c0-.6-.4-1-1-1h-5c-.6 0-1 .4-1 1v7h-5c-.3 0-.5-.2-.5-.5v-8.6c0-.3.1-.5.3-.7l8.7-8.3 8.7 8.3c.2.2.3.5.3.7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-icon_close_20" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5 5 10 10M15 5 5 15"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-image" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" rx="2"/><path d="m4 19 2.781-4.768a1 1 0 0 1 1.632-.136l.665.798a1 1 0 0 0 1.636-.144l2.511-4.395a1 1 0 0 1 1.682-.085L19 16"/><circle cx="7" cy="7" r="2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-infinity" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.367 7.644A4.05 4.05 0 0 0 5.093 6C2.835 6 1 7.793 1 10s1.835 4 4.093 4c1.52 0 2.932-.782 3.715-2.057L10.005 10l1.187-1.943A4.36 4.36 0 0 1 14.907 6C17.165 6 19 7.793 19 10s-1.835 4-4.093 4c-1.35 0-2.528-.65-3.274-1.644"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-info_circle_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/><path fill="currentColor" d="M11 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M3.99 3.99A8.48 8.48 0 0 1 10 1.5c2.347 0 4.473.952 6.01 2.49A8.48 8.48 0 0 1 18.5 10a8.48 8.48 0 0 1-2.49 6.01A8.48 8.48 0 0 1 10 18.5a8.48 8.48 0 0 1-6.01-2.49A8.48 8.48 0 0 1 1.5 10c0-2.347.952-4.473 2.49-6.01M10 3a6.98 6.98 0 0 0-4.95 2.05A6.98 6.98 0 0 0 3 10c0 1.933.783 3.682 2.05 4.95A6.98 6.98 0 0 0 10 17a6.98 6.98 0 0 0 4.95-2.05A6.98 6.98 0 0 0 17 10a6.98 6.98 0 0 0-2.05-4.95A6.98 6.98 0 0 0 10 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-information" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" d="M10.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path fill="currentColor" d="M9.25 14a.75.75 0 0 0 1.5 0zm1.5-5a.75.75 0 0 0-1.5 0zm0 5V9h-1.5v5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-italic" class="svg-sprite__symbol"><path fill="currentColor" d="M7.279 16.794a.75.75 0 1 0 1.442.412zM12.72 3.206a.75.75 0 1 0-1.442-.412zm-4 14 4-14-1.442-.412-4 14z"/><path fill="currentColor" d="M10 2.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM6 16.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5H6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-italic-active" class="svg-sprite__symbol"><path fill="#F15F2C" d="M7.279 16.794a.75.75 0 1 0 1.442.412zM12.72 3.206a.75.75 0 1 0-1.442-.412zm-4 14 4-14-1.442-.412-4 14z"/><path fill="#F15F2C" d="M10 2.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM6 16.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5H6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-laught-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><g clip-path="url(#b)"><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#d)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#e)" d="M7.24 4.855c0-.32-.346-.521-.941-.521-.506 0-1.619.28-2.385 1.265-.142.182.074.283.215.164.473-.402 1.734-.915 2.72-.808.395.045.391-.1.391-.1"/><path fill="url(#f)" d="M6.388 8.743c.425 0 .77-.521.77-1.164 0-.644-.345-1.165-.77-1.165s-.77.521-.77 1.165c0 .643.345 1.164.77 1.164"/><path fill="url(#g)" d="M6.388 6.805c.331 0 .618.286.77.714-.011-.629-.35-1.135-.77-1.135s-.76.506-.77 1.135c.152-.424.439-.714.77-.714"/><path fill="url(#h)" d="M10.76 4.855c0-.32.346-.521.941-.521.506 0 1.619.279 2.385 1.265.142.182-.074.283-.215.164-.473-.402-1.734-.916-2.72-.808-.395.045-.391-.1-.391-.1"/><path fill="url(#i)" d="M11.612 8.743c.426 0 .77-.521.77-1.164 0-.644-.344-1.165-.77-1.165-.425 0-.77.521-.77 1.165 0 .643.345 1.164.77 1.164"/><path fill="url(#j)" d="M11.612 6.805c-.33 0-.617.286-.77.714.011-.629.35-1.135.77-1.135s.76.506.77 1.135c-.152-.424-.439-.714-.77-.714"/><path fill="url(#k)" d="M14.403 10.354a.3.3 0 0 0-.186-.007 19 19 0 0 1-5.213.726c-1.771 0-3.528-.246-5.213-.726a.3.3 0 0 0-.186.007c-.183.075-.473.35-.09 1.403v.004C4.081 13.108 5.58 15.474 9 15.474c3.412 0 4.912-2.37 5.492-3.713.38-1.057.093-1.332-.09-1.407"/><path fill="url(#l)" d="M9 15.099c1.418 0 2.482-.436 3.278-1.031-.874-.395-1.953-.651-3.278-.651s-2.404.26-3.278.658C6.518 14.663 7.582 15.1 9 15.1"/><path fill="url(#m)" d="M14.295 10.332q-.015-.001-.037.004c-1.704.491-3.472.74-5.262.74s-3.557-.249-5.261-.74q-.016-.005-.037-.004c-.116.011-.666.127-.194 1.429v.004c.23.543.614 1.254 1.213 1.905-.562-.666.13-1.035 1.362-.886s2.917.153 2.917.153 1.682-.004 2.918-.153c1.231-.149 1.923.22 1.361.886a6.7 6.7 0 0 0 1.213-1.905v-.004c.473-1.306-.078-1.421-.193-1.429"/><path fill="url(#n)" d="M13.346 12.163c.469-.1.822-.491.867-.971l.045-.47a19.4 19.4 0 0 1-10.516 0l.045.47c.045.476.398.867.867.97a20.722 20.722 0 0 0 8.692 0"/></g><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFDF30"/><stop offset="1" stop-color="#FFB82E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFDF30"/><stop offset="1" stop-color="#FFB82E"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE95F"/><stop offset="1" stop-color="#FFBB47" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -1.983 7.897)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .63 11.373)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="k" cx="0" cy="0" r="1" gradientTransform="translate(9 12.905)scale(4.40705)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="matrix(3.65248 0 0 1.10415 9.066 14.455)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C10000"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="matrix(9.66477 0 0 9.66478 9 11.675)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A8BBBD"/></radialGradient><linearGradient id="e" x1="5.553" x2="5.553" y1="5.391" y2="4.548" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="g" x1="6.388" x2="6.388" y1="6.405" y2="7.491" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="h" x1="12.447" x2="12.447" y1="5.391" y2="4.548" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="j" x1="11.612" x2="11.612" y1="6.405" y2="7.491" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="m" x1="14.615" x2="3.453" y1="11.999" y2="11.999" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset=".5" stop-color="#512D00"/><stop offset="1" stop-color="#3C2200"/></linearGradient><clipPath id="b"><path fill="#fff" d="M1 1h16v16H1z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-lightning-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M8.33 15.535c-.384 1.605.193 1.938 1.226.766l4.338-5.17c1.004-1.27.752-2.29-.693-2.546l-2.092-.402a.233.233 0 0 1-.177-.284l.805-3.444c.385-1.616-.258-1.909-1.222-.763a607 607 0 0 1-3.157 3.67q-.376.433-1.213 1.35c-1.22 1.406-.578 2.425.834 2.68l2 .372a.233.233 0 0 1 .178.285z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE149"/><stop offset="1" stop-color="#E96D1E"/></linearGradient><linearGradient id="b" x1="5.056" x2="16.529" y1="18.726" y2="11.303" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="svg-name-like" class="svg-sprite__symbol"><path fill-rule="evenodd" d="m11.913 22-9.28-10.163C.936 10.084.516 7.404 1.588 5.186 2.39 3.529 3.913 2.37 5.681 2.074c1.769-.296 3.427.304 4.693 1.614l1.539 1.59 1.538-1.59a5.53 5.53 0 0 1 4.868-1.614c1.768.297 3.291 1.455 4.093 3.112 1.072 2.218.652 4.898-1.045 6.651z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" id="svg-name-like-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M6.958 2.481c-.025-.504.016-.981.212-1.349.104-.194.253-.36.454-.474.199-.113.419-.158.64-.158.165 0 .38.05.598.137.227.091.49.238.74.461.514.459.935 1.206.935 2.34 0 1.016-.194 1.76-.335 2.304l-.021.081c-.156.602-.155.76-.07.893.03.048.098.108.244.16s.328.081.524.092a4 4 0 0 0 .713-.033h.01v-.001l.37-.06.161.337L13.29 9.62l.054.114-.006.126-.242 5.005-.004.093-.038.085-.723 1.641-.09.206-.215.068-.153-.476.153.476h-.001l-.002.001-.005.002-.016.005-.056.016-.205.054c-.178.043-.438.1-.776.155-.675.11-1.661.216-2.926.203-.886-.01-1.79-.399-2.457-.743-.284-.146-.54-.293-.744-.41l-.112-.064a5 5 0 0 0-.254-.139l-.007-.003c-.159.01-.528.049-.976.1-.511.06-1.078.13-1.421.177a.72.72 0 0 1-.572-.18 1.3 1.3 0 0 1-.28-.37c-.134-.255-.239-.595-.323-.962-.17-.743-.28-1.726-.314-2.696-.034-.968.006-1.96.152-2.718.072-.373.177-.73.339-1.004.16-.27.455-.574.91-.535q.214.018.393.037c.395.04.684.069.974.026.322-.048.655-.193 1.063-.656a7.6 7.6 0 0 1 1.124-1.073l.127-.097c.239-.184.463-.356.796-.688.32-.321.475-.84.526-1.434.041-.473.012-.919-.01-1.256z"/><path fill="url(#b)" stroke="currentColor" d="M8.556 8.643c.02-.516.267-.907.626-1.174.339-.253.768-.391 1.186-.472.832-.161 1.815-.126 2.469-.101h.023l.08.003a3.9 3.9 0 0 1 1.089.216c.303.112.64.292.905.587.274.307.445.713.44 1.219a1.58 1.58 0 0 1-.358 1.021c-.218.26-.498.416-.762.512-.516.188-1.074.18-1.314.171l-2.118-.08c-.58-.023-1.154-.12-1.586-.416-.478-.328-.704-.84-.68-1.486Zm.5.019Z"/><path fill="url(#c)" stroke="currentColor" d="M10.154 15.222c.61.106 1.41.186 2.155.205.373.01.74.004 1.065-.023.317-.026.629-.075.875-.167zm0 0c-.578-.102-1.001-.38-1.259-.762a1.68 1.68 0 0 1-.261-1.176zm3.359-3.16c-.271-.009-.495-.013-.688-.016-.423-.008-.7-.013-1.004-.049a9 9 0 0 0-1.007-.065zm0 0c1.17.033 1.703 1.023 1.682 1.746-.02.702-.418 1.231-.946 1.429zm-3.936.122c-.364.169-.856.506-.943 1.1zm0 0c.38-.177.81-.263 1.078-.255z"/><path fill="url(#d)" stroke="currentColor" d="M13.317 17.26c-.317.1-.84.181-1.377.218-.539.037-1.151.033-1.645-.061-.504-.097-.899-.292-1.148-.64-.24-.335-.279-.725-.279-1.05 0-.903.756-1.45 1.402-1.45.237 0 .421.04.584.077l.06.013c.175.038.395.08.775.1a5 5 0 0 0 .534-.026c.209-.017.454-.037.681-.037.235 0 .573.026.857.225.323.226.462.59.462 1.015 0 .343-.04.681-.173.968a1.18 1.18 0 0 1-.733.648Z"/><path fill="url(#e)" stroke="currentColor" d="M15.847 11.442c-.005.294-.079.774-.46 1.174-.389.408-1.01.641-1.915.623a78 78 0 0 1-2.729-.103 27 27 0 0 0-.616-.027 1.95 1.95 0 0 1-1.038-.338c-.389-.274-.687-.732-.674-1.4.013-.636.272-1.098.65-1.388.35-.269.764-.36 1.088-.358l.038-.002.166-.007c.148-.005.375-.011.69-.016.63-.008 1.614-.01 3.043.019.654.013 1.117.307 1.401.697.268.37.363.803.356 1.126Z"/><g clip-path="url(#f)"><path fill="url(#g)" d="M8.265 1c-.62 0-.855.496-.807 1.456.032.634.245 2.399-.649 3.293-.833.834-1.076.76-2.025 1.836-.95 1.077-1.74.855-2.848.76-1.392-.12-.918 7.606.063 7.472.696-.095 2.279-.285 2.532-.285s1.989 1.346 3.512 1.362c2.468.026 3.83-.412 3.83-.412l.723-1.64.242-5.006-1.155-2.408s-1.551.253-1.994-.444c-.443-.696.348-1.551.348-3.546S8.581 1 8.265 1"/><path fill="url(#h)" d="m11.959 16.467-.094-.342c-.279-.03-.636.097-1.125.093-2.334-.018-4.565-.688-5.522-1.447-.627-.496-.902-1.157-1.345-.967-.547.234-2.097.599-2.668-.123.16 1.235.445 2.184.794 2.136.696-.095 2.279-.285 2.532-.285s1.94 1.31 3.512 1.362c2.034.066 3.84-.284 3.84-.284z"/><path fill="url(#i)" d="M2.924 8.833c.918.253 1.5-.166 1.97-.736.466-.566.87-1.069 2.041-1.828s1.02-2.85.926-3.546C7.766 2.026 7.829 1 8.265 1c-.62 0-.855.496-.807 1.456.032.633.245 2.399-.649 3.293-.833.834-1.075.76-2.025 1.836s-1.74.855-2.848.76c0 .24.07.235.988.488"/><path fill="url(#j)" d="M9.689 6.984c-.443-.696.348-1.551.348-3.546S8.582 1 8.265 1a1 1 0 0 0-.224.027c1.291.081 2.069 1.71 1.624 3.39-.361 1.362-.541 2.455.048 3.096.382.415 1.14.344 1.97-.086 0 0-1.551.254-1.994-.443"/><path fill="url(#k)" d="M9.776 7.695c-.76.253-2.678.85-4.13 2.167-3.682 3.34 2.604 3.76 3.902 6.616.248.546 1.699-2.864 1.699-2.864l.469-.79-1.356-3.61z"/><path fill="url(#l)" d="M9.887 7.984c-.76.253-3.862 2.242-3.862 3.224 0 2.833 2.149 1.435 3.31 4.779.16.463.729.852.729.852.47-.384 1.183-3.225 1.183-3.225l.469-.79-1.356-3.61z"/><path fill="url(#m)" d="m11.64 16.67 1.454-1.663.32-6.946-3.638-.366c-.836.45-.932 1.064-.622 2.052.13.416-.4.535-.434 1.745-.024.84.525.843.525 1.093s-.273.227-.364.95c-.13 1.033.735 1.053.735 1.274s-.48.353-.45 1.195c.037 1.069-1.947.853-3.288-.12-.55-.399-1.031-.44-1.406-.35l.058-.001c.253 0 1.953 1.361 3.513 1.361 1.823 0 3.085-.107 3.597-.224"/><path fill="url(#n)" d="M11.974 8.153c-1.123 0-1.74 1.098-1.313 1.942s-.791 1.96-.665 2.51c.127.55.349 1.942.522 2.172s-.285.753-.285.753l1.425.174 1.329-.586-.048-4.02.142-2.517z"/><path fill="url(#o)" d="M4.784 7.586c-.617.699-1.167.85-1.78.845.177.285.3.597.287.902-.033.8.143 1.785.277.76.103-.78.632-1.746 1.269-2.567z"/><path fill="url(#p)" d="M12.825 7.396c-1.328-.051-3.716-.126-3.769 1.266-.038 1.01.677 1.34 1.784 1.383l2.119.08c.459.018 1.9.01 1.915-1.21.017-1.523-2.049-1.52-2.049-1.52"/><path fill="url(#q)" d="M10.64 12.429c-.355-.01-1.413.256-1.511.928-.078.528.191 1.21 1.111 1.372 1.166.204 3.108.311 3.834.04.324-.122.607-.461.621-.976a1.21 1.21 0 0 0-1.197-1.232c-.83-.024-1.263-.011-1.736-.067-.57-.067-.836-.057-1.121-.065"/><path fill="url(#r)" d="M10.27 14.777a.94.94 0 0 0-.902.95c0 .593.154 1.032 1.02 1.199.867.166 2.256.023 2.778-.143.407-.13.557-.51.557-1.14s-.391-.739-.819-.739-.945.078-1.241.063c-.827-.044-.99-.19-1.393-.19"/><path fill="url(#s)" d="M12.712 7.677c-1.16-.044-3.245-.111-3.287.99-.03.797.596 1.061 1.563 1.098.966.037 3.509.084 3.517-.88.011-1.204-1.793-1.208-1.793-1.208"/><path fill="url(#t)" d="M10.748 12.712c-.31-.009-1.178.065-1.26.707-.057.434.168.992.97 1.125 1.014.17 2.705.26 3.337.038.281-.099.527-.376.54-.798.012-.421-.377-.938-1.1-.96-.723-.02-1.107.047-1.52 0-.494-.056-.72-.105-.967-.112"/><path fill="url(#u)" d="M10.443 14.993c-.35 0-.78.287-.78.765s.133.832.882.965c.75.134 1.95.02 2.402-.114.352-.105.483-.411.483-.918s-.339-.595-.708-.595c-.37 0-.819.063-1.075.05-.715-.035-.855-.153-1.204-.153"/><path fill="url(#v)" d="M10.23 8.667c.029-.759.633-1.122 1.397-1.29-1.219.029-2.531.257-2.571 1.285-.038 1.01.677 1.34 1.784 1.383q.183.008.346.013c-.622-.182-.986-.592-.956-1.391"/><path fill="url(#w)" d="M10.334 7.515c-.71.155-1.253.49-1.278 1.147-.032.84.458 1.21 1.26 1.335-1.627-.65-1.043-2.25.018-2.482"/><path fill="url(#x)" d="M7.228 15.063c-.126.452-1.007.602-1.966.335-.96-.268-1.635-.852-1.509-1.305s1.007-.603 1.966-.335 1.635.851 1.51 1.305"/><path fill="url(#y)" d="M13.82 8.87c-.009.583-.787.86-1.64.91-.696.043-1.469-.45-1.449-1.02.02-.568.121-1.072 1.569-1.022.853.03 1.53.563 1.52 1.132"/><path fill="url(#z)" d="M13.975 13.99c-.004.807-.891.653-1.743.709-1.08.071-1.796-.265-1.796-.835-.001-.57.41-.984 1.858-.986.853-.002 1.687.076 1.681 1.113"/><path fill="url(#A)" d="M13.194 16.024c-.004.688-.81.781-1.573.782-.763 0-1.591-.404-1.592-.89 0-.485.367-.839 1.662-.84.763-.002 1.509.065 1.503.948"/><path fill="url(#B)" d="M10.119 13.52c.121-.918.825-.865 1.633-.96-.93-.07-1.32-.08-1.32-.08a1.5 1.5 0 0 0-.284.002c-.302.067-.644.204-.848.462a1.1 1.1 0 0 0-.161.351l-.01.062c-.066.53.191 1.21 1.111 1.372q.201.035.426.065l.234.03.068.008c-.507-.24-.938-.637-.85-1.312"/><path fill="url(#C)" d="M10.344 12.475q-.094-.003-.197.007c-.304.068-.65.207-.852.469a1.1 1.1 0 0 0-.156.345l-.01.06c-.093.523.165 1.138.97 1.342-1.372-.757-.787-2.222.245-2.223"/><path fill="url(#D)" d="M11.142 14.917c-.405-.06-.572-.14-.872-.14a.94.94 0 0 0-.902.949c0 .216.021.41.088.58.068.14.168.27.304.38.15.105.353.186.629.24.185.035.394.056.614.066-.424-.246-1.141-.378-.99-1.202.166-.909.708-.786 1.13-.873"/><path fill="url(#E)" d="M10.252 14.777a.944.944 0 0 0-.884.95c0 .543.13.957.818 1.15-1.074-.69-.73-1.855.066-2.1"/><path fill="url(#F)" d="M14.874 8.915a1.4 1.4 0 0 0-.043-.374c.107.476-.317.949-1.44 1.178-.745.152-2.722.342-4.09-.201.295.357.839.5 1.54.526l2.118.081c.459.018 1.9.01 1.915-1.21"/><path fill="url(#G)" d="M14.696 13.76c-.002-.51-.385-1.176-1.198-1.199-.83-.024-1.263-.011-1.736-.067-.57-.067-.837-.057-1.121-.065-.215-.007-.746.058-1.107.283.406.14 1.067.352 1.997.293 2.23-.144 2.864.126 3.164.755"/><path fill="url(#H)" d="M10.163 10.125c-.475-.01-1.228.27-1.248 1.256s.842 1.22 1.222 1.228c.38.007 1.707.098 3.345.13 1.637.033 1.856-.846 1.866-1.307.009-.46-.283-1.293-1.268-1.313-2.848-.058-3.917.006-3.917.006"/><path fill="url(#I)" d="M10.418 10.411c-.413-.008-1.067.206-1.082.966s.734.943 1.064.95 1.484.079 2.907.107c1.424.029 1.613-.649 1.62-1.004.007-.356-.042-.999-.898-1.016-2.476-.05-3.611-.003-3.611-.003"/><path fill="url(#J)" d="M9.934 11.286c.047-1.012.753-1.015 1.55-1.19-.932.006-1.321.029-1.321.029-.475-.01-1.228.27-1.248 1.255-.02.986.842 1.22 1.222 1.228.137.003.397.016.75.034-.526-.217-.988-.612-.953-1.356"/><path fill="url(#K)" d="M14.513 11.39c.033.806-.861.958-1.714.998s-1.8-.39-1.828-.959c-.027-.568.364-1.002 1.81-1.072.854-.041 1.69-.002 1.732 1.033"/><path fill="url(#L)" d="M10.074 10.127c-.474.025-1.14.327-1.16 1.253-.018.937.76 1.196 1.163 1.225-1.56-.63-1.049-2.385-.003-2.478"/><path fill="url(#M)" d="M15.345 11.333c-.206 1.458-4.06 1.19-6.141.878.28.3.699.392.933.397.38.008 1.707.098 3.345.131 1.637.033 1.856-.847 1.866-1.307q0-.047-.003-.1"/><path fill="url(#N)" d="M13.415 14.58c-.747.033-2.722.278-4.161-.493.16.298.471.552.986.642 1.166.204 3.108.311 3.834.04.324-.122.607-.461.621-.976-.047.448-.474.751-1.28.787"/><path fill="url(#O)" d="M13.666 16.2c-.489.373-1.334.592-2.554.386-.753-.127-1.27-.17-1.609-.18.136.246.398.426.886.52.866.166 2.255.024 2.777-.142.268-.086.424-.281.5-.584"/><path fill="url(#P)" d="M9.529 15.192c.903-.329 1.346.16 2.313.16 1.004 0 1.483-.406 1.84-.02-.113-.356-.433-.428-.777-.428-.428 0-.946.078-1.242.063-.827-.044-.99-.19-1.393-.19a.94.94 0 0 0-.741.415"/><path fill="url(#Q)" d="M1.999 15.817c.696-.095 2.279-.285 2.532-.285-2.295-1.641-1.275-5.132-.428-6.897.119-.248.192-.452.232-.624-.764.582-1.47.414-2.4.334-1.39-.119-.917 7.606.064 7.472"/><path fill="url(#R)" d="M4.53 15.533c-.196-.168-.433-.45-.647-.723 0 0-1.152.59-2.388.312.143.451.314.721.504.695.696-.095 2.279-.284 2.532-.284"/><path fill="url(#S)" d="M9.003 3.904C8.553 4 8.187 3.378 7.98 2.65c-.169-.595.06-1.352.504-1.438.443-.085.852-.089 1.096 1.172.143.742-.136 1.424-.577 1.519"/><path fill="url(#T)" d="M11.683 7.427s-1.551.253-1.994-.443c-.443-.697.348-1.552.348-3.546C10.037 1.443 8.581 1 8.265 1c-.62 0-.855.496-.807 1.456.032.633.245 2.399-.649 3.293-.833.834-1.076.76-2.025 1.836-.95 1.076 5.885.3 6.898-.158"/><path fill="#804B24" d="M10.252 14.777a.91.91 0 0 0-.675.3.98.98 0 0 0-.249.712c.008.248.046.518.208.726.16.21.411.309.65.363-.231-.084-.461-.202-.598-.401-.139-.197-.175-.447-.177-.69a.94.94 0 0 1 .214-.668.97.97 0 0 1 .627-.342M9.854 12.569c-.168.054-.337.129-.473.251a.9.9 0 0 0-.279.467v.002c-.03.157-.046.325-.013.486.032.16.099.314.195.446.195.268.505.418.813.477-.3-.097-.58-.264-.754-.518a1.14 1.14 0 0 1-.168-.876l-.001.002c.046-.165.114-.329.241-.448.125-.121.276-.218.44-.29"/><path fill="#804B24" d="M10.074 10.127c-.296.003-.6.104-.824.315-.227.208-.344.514-.369.814-.024.299.025.623.212.87.184.248.472.392.762.445-.283-.083-.548-.244-.71-.483-.164-.238-.21-.538-.18-.825.017-.288.127-.57.33-.776.202-.205.485-.327.779-.36M10.334 7.515c-.32.056-.645.154-.913.359a1.05 1.05 0 0 0-.406.886c0 .33.114.686.382.9.262.218.597.3.919.337-.318-.068-.639-.171-.877-.384-.242-.212-.346-.536-.342-.854a1 1 0 0 1 .364-.836c.247-.203.56-.322.873-.408M9.254 14.087c.094.19.245.352.428.466.183.112.393.176.603.211q.628.11 1.262.164c.424.027.848.04 1.273.029.422-.015.854-.04 1.254-.19a2.7 2.7 0 0 1-.623.106 7 7 0 0 1-.633.028c-.422.002-.844-.02-1.265-.056a14 14 0 0 1-1.259-.135c-.41-.056-.825-.25-1.04-.623"/><path fill="#804B24" d="M9.204 12.211c.152.17.357.292.576.36.222.073.458.063.683.078l1.364.068 1.365.039c.45.025.926.01 1.348-.17-.434.149-.895.142-1.347.115l-1.364-.067-1.365-.04c-.229-.01-.456.004-.672-.061a1.26 1.26 0 0 1-.588-.322M14.08 10.118a45 45 0 0 0-1.959-.055c-.653-.01-1.306-.01-1.96.03h.003a1.3 1.3 0 0 0-.92.366c-.119.12-.206.27-.258.429-.05.16-.068.327-.07.492.014-.33.125-.66.361-.888.232-.23.565-.34.885-.335h.003c.325-.012.652-.014.978-.017l.978-.013.98-.002c.326.004.652-.006.979-.007"/></g><defs><linearGradient id="a" x1="11.734" x2="6.973" y1="8.816" y2="9.007" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="b" x1="14.649" x2="9.986" y1="8.752" y2="8.752" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="c" x1="14.649" x2="9.983" y1="13.68" y2="13.68" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="d" x1="14.649" x2="9.985" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="e" x1="14.649" x2="9.985" y1="11.418" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="g" x1="11.734" x2="6.973" y1="8.816" y2="9.007" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="h" x1="6.934" x2="6.601" y1="11.295" y2="14.868" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="i" x1="5.985" x2="9.571" y1="5.993" y2="11.12" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="j" x1="3.39" x2="12.575" y1="3.95" y2="4.638" gradientUnits="userSpaceOnUse"><stop offset=".312" stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FF8900"/></linearGradient><linearGradient id="k" x1="3.215" x2="15.276" y1="12.116" y2="12.116" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="l" x1="1.27" x2="25.099" y1="12.134" y2="12.893" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="m" x1="5.056" x2="8.997" y1="15.248" y2="13.113" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="n" x1="9.57" x2="12.857" y1="12.216" y2="11.785" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="o" x1="3.738" x2="4.451" y1="4.962" y2="16.764" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="p" x1="14.649" x2="9.986" y1="8.752" y2="8.752" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="q" x1="14.649" x2="9.983" y1="13.68" y2="13.68" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="r" x1="14.649" x2="9.986" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="s" x1="9.357" x2="11.786" y1="8.775" y2="8.72" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="t" x1="13.604" x2="11.129" y1="13.713" y2="13.713" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="u" x1="13.604" x2="11.129" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="v" x1="10.582" x2="9.261" y1="8.718" y2="8.718" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="w" x1="10.345" x2="8.826" y1="8.756" y2="8.756" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#E89043"/></linearGradient><linearGradient id="B" x1="10.74" x2="8.826" y1="13.654" y2="13.654" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="C" x1="10.334" x2="9.302" y1="13.587" y2="13.587" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="D" x1="10.672" x2="8.433" y1="15.901" y2="15.49" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="E" x1="10.44" x2="9.494" y1="15.828" y2="15.828" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="F" x1="11.949" x2="12.55" y1="8.458" y2="11.371" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="G" x1="12.406" x2="11.749" y1="14.213" y2="11.844" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="H" x1="14.649" x2="9.985" y1="11.418" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="I" x1="9.797" x2="13.369" y1="11.288" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset=".738" stop-color="#FFD748"/><stop offset="1" stop-color="#FFCB4B"/></linearGradient><linearGradient id="J" x1="11.191" x2="8.523" y1="11.37" y2="11.37" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="L" x1="9.951" x2="9.108" y1="11.366" y2="11.366" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="M" x1="12.17" x2="12.677" y1="11.109" y2="14.331" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="N" x1="11.819" x2="13.117" y1="13.602" y2="16.419" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="O" x1="11.56" x2="11.75" y1="16.073" y2="17.854" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="P" x1="11.605" x2="11.605" y1="15.803" y2="14.515" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="Q" x1="2.754" x2="1.091" y1="11.076" y2="6.007" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="R" x1="3.044" x2="2.949" y1="14.153" y2="17.786" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="T" x1="8.129" x2="9.348" y1="8.13" y2="-2.896" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="matrix(1.78622 .4985 -.23148 .82945 5.318 14.267)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(1.58576 .05613 -.03684 1.04078 12.278 8.763)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="matrix(1.70407 -.00162 .00087 .91862 12.201 13.877)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="A" cx="0" cy="0" r="1" gradientTransform="matrix(1.5602 -.00147 .00092 .9765 11.612 15.942)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="K" cx="0" cy="0" r="1" gradientTransform="matrix(1.74287 -.08329 .05467 1.14396 12.74 11.375)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="S" cx="0" cy="0" r="1" gradientTransform="matrix(.31719 1.64272 -.96366 .18607 8.786 2.55)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><clipPath id="f"><path fill="#fff" d="M0 17h16V1H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-like_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12.111 5.7c1.128-1.057 2.43-1.63 3.88-1.694L16.267 4C19.423 4 22 6.56 22 9.717c0 2.959-1.035 4.427-5.573 8.061l-.933.74-2.364 1.843a1.84 1.84 0 0 1-2.26 0l-2.688-2.098C3.127 14.269 2 12.805 2 9.717 2 6.56 4.577 4 7.734 4c1.54 0 2.929.576 4.138 1.695l.122.118z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none" id="svg-name-like_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.04 2C2.652 2 1.5 3.155 1.5 4.617c0 .858.15 1.388.617 2.027.542.742 1.517 1.63 3.33 3.074L7 10.954l1.552-1.236c1.814-1.444 2.789-2.332 3.332-3.074.467-.639.616-1.169.616-2.027C12.5 3.155 11.347 2 9.96 2c-.734 0-1.302.335-1.71.707-.226.206-.44.448-.596.715a.75.75 0 0 1-1.309-.001 3.1 3.1 0 0 0-.595-.714C5.343 2.335 4.775 2 4.04 2M7 1.832a5 5 0 0 0-.239-.234C6.18 1.068 5.267.5 4.04.5 1.792.5 0 2.36 0 4.617 0 5.739.22 6.593.906 7.53c.678.926 1.809 1.93 3.607 3.362l1.654 1.316a1.334 1.334 0 0 0 1.666 0l1.654-1.316c1.798-1.432 2.929-2.436 3.607-3.362.685-.937.906-1.79.906-2.913C14 2.36 12.208.5 9.96.5c-1.226 0-2.138.568-2.72 1.098a5 5 0 0 0-.24.234" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-like_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.629 2.5A5.37 5.37 0 0 1 19 7.871c0 2.837-1.081 4.275-5.702 7.869l-1.993 1.55a2.125 2.125 0 0 1-2.61 0l-1.993-1.55C2.082 12.146 1 10.708 1 7.87A5.37 5.37 0 0 1 6.371 2.5c1.256 0 2.403.46 3.414 1.346l.215.197.215-.197c1.01-.886 2.158-1.346 3.414-1.346m0 1.5c-1.124 0-2.137.53-3.055 1.622a.75.75 0 0 1-1.148 0C8.508 4.53 7.496 4 6.37 4A3.87 3.87 0 0 0 2.5 7.871c0 2.238.838 3.352 5.123 6.685l1.993 1.55a.625.625 0 0 0 .768 0l1.993-1.55c4.09-3.182 5.04-4.341 5.118-6.386l.005-.299A3.87 3.87 0 0 0 13.629 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-like_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M15.992 4.006c-1.452.064-2.753.637-3.881 1.694l-.117.113-.122-.118C10.662 4.576 9.275 4 7.734 4 4.577 4 2 6.56 2 9.717c0 3.088 1.127 4.552 6.182 8.546l2.688 2.098a1.84 1.84 0 0 0 2.26 0l2.364-1.843.933-.74C20.965 14.144 22 12.676 22 9.718 22 6.56 19.423 4 16.266 4zm.274 1.794c2.165 0 3.934 1.757 3.934 3.917l-.005.294c-.076 2.156-1.062 3.341-5.509 6.852l-2.663 2.078a.04.04 0 0 1-.046 0l-2.364-1.843-.874-.691c-4.142-3.31-4.939-4.44-4.939-6.69C3.8 7.557 5.569 5.8 7.734 5.8c1.333 0 2.507.618 3.57 1.915a.9.9 0 0 0 1.398-.007C13.739 6.416 14.909 5.8 16.266 5.8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="11" id="svg-name-link" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M5.227 0a5.228 5.228 0 0 0 0 10.455H9.41V8.364H5.227a3.136 3.136 0 1 1 0-6.273H9.41V0zm8.364 0v2.09h4.182a3.136 3.136 0 1 1 0 6.274H13.59v2.09h4.182a5.228 5.228 0 0 0 0-10.454zM6.273 4.182v2.09h10.454v-2.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-link-tool" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 10.25h10.5"/><path fill="currentColor" d="M7 6.75a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0-1.5zm-2 0h2v-1.5H5zm2-9.5H5v1.5h2zm-2 0A4.75 4.75 0 0 0 .25 10h1.5A3.25 3.25 0 0 1 5 6.75zm0 8A3.25 3.25 0 0 1 1.75 10H.25A4.75 4.75 0 0 0 5 14.75zM13 6.75a.75.75 0 0 1 0-1.5zm0 8a.75.75 0 0 1 0-1.5zm2 0h-2v-1.5h2zm-2-9.5h2v1.5h-2zm2 0A4.75 4.75 0 0 1 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75zm0 8A3.25 3.25 0 0 0 18.25 10h1.5A4.75 4.75 0 0 1 15 14.75z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-link-tool-active" class="svg-sprite__symbol"><path stroke="#F15F2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 10.25h10.5"/><path fill="#F15F2C" d="M7 6.75a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0-1.5zm-2 0h2v-1.5H5zm2-9.5H5v1.5h2zm-2 0A4.75 4.75 0 0 0 .25 10h1.5A3.25 3.25 0 0 1 5 6.75zm0 8A3.25 3.25 0 0 1 1.75 10H.25A4.75 4.75 0 0 0 5 14.75zM13 6.75a.75.75 0 0 1 0-1.5zm0 8a.75.75 0 0 1 0-1.5zm2 0h-2v-1.5h2zm-2-9.5h2v1.5h-2zm2 0A4.75 4.75 0 0 1 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75zm0 8A3.25 3.25 0 0 0 18.25 10h1.5A4.75 4.75 0 0 1 15 14.75z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="11" fill="none" id="svg-name-list_add_20" class="svg-sprite__symbol"><path fill="currentColor" d="M.5 1.25A.75.75 0 0 1 1.25.5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M.5 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M1.25 6.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM8 7.25a.75.75 0 0 1 .75-.75H11V4.25a.75.75 0 0 1 1.5 0V6.5h2.25a.75.75 0 0 1 0 1.5H12.5v2.25a.75.75 0 0 1-1.5 0V8H8.75A.75.75 0 0 1 8 7.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_bullet_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.36 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.002 2.878.075 3.778.072.877.202 1.325.361 1.638a4 4 0 0 0 1.748 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5M3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.56 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622" clip-rule="evenodd"/><path fill="currentColor" d="M8 10a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 10M12 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M8 18a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 18M12 18a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M8 14a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 14M12 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_check_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M26.701 15.287a1 1 0 0 1 .095 1.319l-6.945 7.095a1 1 0 0 1-1.33.086l-4.232-4.272a1 1 0 0 1 1.329-1.49l3.517 3.55 6.152-6.276a1 1 0 0 1 1.414-.012M10 18a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm12-6a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_like_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21.46 11.998c2.5 0 4.54 1.99 4.54 4.459 0 2.322-.913 3.5-4.426 6.19l-1.464 1.111c-.899.683-2.123.72-3.058.114l-.162-.114-1.51-1.146-.57-.443C11.804 19.808 11 18.637 11 16.457c0-2.47 2.04-4.459 4.54-4.459.929 0 1.784.292 2.55.849l.207.158.202.173.217-.183c.667-.534 1.406-.862 2.204-.963l.268-.025zm.063 1.998-.224.007-.186.02a2.3 2.3 0 0 0-.937.375l-.173.127-1.19 1a.5.5 0 0 1-.646-.002l-1.126-.961c-.477-.385-.964-.565-1.501-.565-1.41 0-2.54 1.108-2.54 2.46 0 1.407.447 2.11 3.072 4.162l.518.4 1.509 1.147a.66.66 0 0 0 .71.059l.092-.06 1.692-1.286C23.524 18.62 24 17.907 24 16.457c0-1.298-1.042-2.37-2.317-2.455zM8 17.996a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0-5.998a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zM22 6a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="12" fill="none" id="svg-name-list_play_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M17.684 7.431a.67.67 0 0 1 0 1.138l-4.737 2.842c-.42.253-.947-.063-.947-.568V5.157c0-.505.526-.82.947-.568zM0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75M0 5.75A.75.75 0 0 1 .75 5h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 5.75M0 10.75A.75.75 0 0 1 .75 10h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-live_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/><path fill="currentColor" fill-rule="evenodd" d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m7-8.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10" id="svg-name-lock" class="svg-sprite__symbol"><path fill="currentColor" d="M7.598 4.162h-.247l-.001-1.23A2.435 2.435 0 0 0 4.917.5a2.435 2.435 0 0 0-2.431 2.433l.002 1.231H2.4A.835.835 0 0 0 1.566 5v3.665c0 .461.375.835.836.835L7.6 9.497a.834.834 0 0 0 .834-.835V4.996a.835.835 0 0 0-.836-.834m-4.214.002-.002-1.23c0-.848.688-1.537 1.535-1.538.847 0 1.536.69 1.536 1.535l.002 1.231z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-locked" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M4 16v-6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/><path stroke="currentColor" d="M10.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path stroke="currentColor" stroke-width="1.5" d="M13 8V5.5a3 3 0 0 0-6 0V8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-logo-boosty" class="svg-sprite__symbol"><path fill="url(#a)" d="M5.044 23.892 11.852 0h10.447l-2.113 7.408a1 1 0 0 0-.054.132L14.584 27.1h5.177Q16.52 35.328 14.686 40c-9.553-.108-12.23-7.052-9.886-15.268zM14.72 40l12.594-18.4h-5.344L26.62 9.814c7.977.846 11.719 7.215 9.52 14.917C33.778 33.015 24.22 40 14.916 40z"/><path fill="url(#b)" d="M5.044 23.892 11.852 0h10.447l-2.113 7.408a1 1 0 0 0-.054.132L14.584 27.1h5.177Q16.52 35.328 14.686 40c-9.553-.108-12.23-7.052-9.886-15.268zM14.72 40l12.594-18.4h-5.344L26.62 9.814c7.977.846 11.719 7.215 9.52 14.917C33.778 33.015 24.22 40 14.916 40z"/><defs><linearGradient id="a" x1="36.762" x2="4.001" y1="20" y2="20" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient><linearGradient id="b" x1="7.006" x2="-12.017" y1="-3.014" y2="41.133" gradientUnits="userSpaceOnUse"><stop stop-color="#EF7829"/><stop offset=".28" stop-color="#F0692A"/><stop offset=".63" stop-color="#F15E2C"/><stop offset="1" stop-color="#F15A2C"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" id="svg-name-logo-play" class="svg-sprite__symbol"><path fill="#F18D8D" d="M0 0h50v50H0z"/><path fill="#0177FE" d="M0 0h50v50H0z"/><g clip-path="url(#a)"><rect width="48.828" height="48.828" x=".586" y=".586" fill="#07F" rx="24.414"/><g filter="url(#b)"><path fill="#020BB2" d="M31.229 13.827c7.046 4.501 10.569 6.752 11.201 9.86.2.985.2 2 0 2.983-.632 3.109-4.155 5.36-11.201 9.861-8.057 5.148-12.086 7.722-15.359 6.755a7.5 7.5 0 0 1-2.79-1.528c-2.576-2.238-2.576-7.018-2.576-16.58 0-9.56 0-14.34 2.577-16.579a7.5 7.5 0 0 1 2.789-1.528c3.273-.966 7.302 1.608 15.359 6.756"/></g><path fill="#fff" fill-rule="evenodd" d="M31.896 23.517a1.662 1.662 0 1 0 0 3.324 1.662 1.662 0 0 0 0-3.324m-5.35 1.662a5.35 5.35 0 0 1 5.35-5.347 5.35 5.35 0 0 1 5.349 5.347 5.35 5.35 0 0 1-5.35 5.346 5.35 5.35 0 0 1-5.348-5.346M16.46 25.179l-2.75 2.747 2.601 2.599 2.749-2.747 2.749 2.747 2.6-2.6-2.749-2.746 2.749-2.748-2.6-2.599-2.75 2.747-2.748-2.747-2.6 2.6z" clip-rule="evenodd"/></g><defs><clipPath id="a"><rect width="48.828" height="48.828" x=".586" y=".586" fill="#fff" rx="24.414"/></clipPath><filter id="b" width="3186.07" height="3190.61" x="-1566.49" y="-1269.75" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="300.38"/><feGaussianBlur stdDeviation="788.499"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_31642_184982"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_31642_184982" result="shape"/></filter></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="110" height="24" fill="none" viewBox="0 0 155 24" id="svg-name-logo-vk-video-live" class="svg-sprite__symbol"><g clip-path="url(#a)"><g clip-path="url(#b)"><path fill="#07F" d="M0 8.774C0 1.55 1.549 0 8.774 0h6.452C22.45 0 24 1.549 24 8.774v6.452C24 22.45 22.451 24 15.226 24H8.774C1.55 24 0 22.451 0 15.226z"/><path fill="#FF2B42" d="M12.896 24h2.288c7.09 0 8.74-1.477 8.813-8.276q.003-.244.003-.498V8.774q0-.273-.003-.537C23.917 1.471 22.261 0 15.184 0h-2.288C5.636 0 4.08 1.549 4.08 8.774v6.452C4.08 22.45 5.636 24 12.896 24"/><path fill="#fff" d="M16.935 9.924c1.213.7 1.82 1.05 2.024 1.508.177.399.177.854 0 1.253-.204.457-.81.807-2.024 1.508l-3.325 1.92c-1.213.7-1.82 1.05-2.317.998a1.54 1.54 0 0 1-1.086-.627c-.294-.405-.294-1.105-.294-2.506v-3.84c0-1.4 0-2.1.294-2.506a1.54 1.54 0 0 1 1.085-.626c.498-.053 1.105.298 2.318.998z"/></g><path fill="currentColor" d="M36.259 18.058h2.993L43.647 6h-2.172l-3.523 9.937h-.342L34.206 6H32zM54.887 18.058l-5.541-6.243L54.46 6h-2.532l-4.275 4.909h-.496V6h-2.053v12.058h2.053v-5.165h.513l4.515 5.165zM66.662 11.867c1.06-.411 1.727-1.352 1.727-2.583C68.39 7.368 66.8 6 64.473 6h-4.704v12.058h5.046c2.343 0 3.933-1.368 3.933-3.37 0-1.402-.786-2.445-2.086-2.822m-4.84-4.071h2.65c1.095 0 1.848.667 1.848 1.659 0 .975-.753 1.642-1.847 1.642h-2.651zm2.993 8.466h-2.993v-3.37h2.993c1.077 0 1.83.685 1.83 1.677 0 1.009-.753 1.693-1.83 1.693M70.622 18.058h2.788l3.318-6.602H77v6.602h1.882V9.164h-2.788l-3.318 6.602h-.274V9.164h-1.881zM80.17 20.709h1.967v-2.651h6.397v2.651H90.5v-4.447h-1.54V9.164h-6.516L82 13.714c-.154 1.607-.632 2.548-1.607 2.548h-.223zm2.993-4.447c.48-.462.684-1.248.821-2.583l.274-2.719h2.737v5.302zM100.423 13.508c0-2.565-1.915-4.515-4.618-4.515-2.702 0-4.618 1.933-4.618 4.618s1.916 4.618 4.618 4.618c1.847 0 3.592-.872 4.259-2.566l-1.847-.307c-.428.632-1.249 1.077-2.292 1.077-1.505 0-2.497-.924-2.685-2.292h7.149c.017-.188.034-.393.034-.633m-4.618-2.805c1.232 0 2.155.787 2.48 1.899H93.36c.325-1.146 1.249-1.899 2.446-1.899M106.197 18.229c2.788 0 4.755-1.916 4.755-4.618s-1.967-4.618-4.755-4.618-4.754 1.916-4.754 4.618 1.967 4.618 4.754 4.618m0-1.796c-1.607 0-2.702-1.146-2.702-2.822s1.095-2.822 2.702-2.822c1.608 0 2.703 1.146 2.703 2.822s-1.095 2.822-2.703 2.822"/></g><path fill="#FF2B42" d="M119 12c0-5.398 0-8.097 1.557-9.869q.27-.307.577-.576C122.908 0 125.611 0 131.017 0h11.966c5.406 0 8.109 0 9.883 1.555q.307.27.577.576C155 3.903 155 6.601 155 12c0 5.398 0 8.097-1.557 9.869q-.27.307-.577.576C151.092 24 148.389 24 142.983 24h-11.966c-5.406 0-8.109 0-9.883-1.555a6 6 0 0 1-.577-.576C119 20.097 119 17.399 119 12"/><path fill="#fff" d="M130.731 18.177h-5.845V5.894h1.832v10.54h4.013zM133.638 18.177h-1.832V5.894h1.832zM140.072 18.177h-2.809l-2.635-12.283h1.885l2.041 10.053h.262l2.146-10.053h1.866zM149.75 18.177h-6.036V5.894h5.914v1.743h-4.083v3.484h3.612v1.707h-3.612v3.607h4.205z"/><defs><clipPath id="a"><path fill="#fff" d="M0 0h111v24H0z"/></clipPath><clipPath id="b"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-logo_android_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.4 3.2a1 1 0 0 1 1.4.2l2.306 3.075A9 9 0 0 1 10 6a9 9 0 0 1 2.893.475L15.2 3.4a1 1 0 0 1 1.6 1.2l-2.06 2.748A9 9 0 0 1 19 15H1a9 9 0 0 1 4.26-7.652L3.2 4.6a1 1 0 0 1 .2-1.4m9.669 7.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-logo_vk" class="svg-sprite__symbol"><path fill="#07F" d="M.398 19.2c0-9.051 0-13.576 2.812-16.388S10.547 0 19.598 0h1.6c9.051 0 13.577 0 16.389 2.812s2.811 7.337 2.811 16.388v1.6c0 9.051 0 13.576-2.811 16.388S30.249 40 21.198 40h-1.6c-9.05 0-13.576 0-16.388-2.812S.398 29.851.398 20.8z"/><path fill="#fff" d="M21.682 28.817c-9.117 0-14.317-6.25-14.534-16.65h4.567c.15 7.633 3.517 10.866 6.183 11.533V12.167h4.3v6.583c2.634-.283 5.4-3.283 6.334-6.583h4.3c-.717 4.066-3.717 7.066-5.85 8.3 2.133 1 5.55 3.616 6.85 8.35h-4.734c-1.016-3.167-3.55-5.617-6.9-5.95v5.95z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="82" height="40" fill="none" id="svg-name-logo_vkid" class="svg-sprite__symbol"><path fill="#fff" d="M50.398 32.4h4.107v-24h-4.107zM59.818 32.4h9.256c7.323 0 12.524-4.97 12.524-12.017 0-7.013-5.201-11.983-12.524-11.983h-9.256zm4.107-3.745v-16.51h5.149c4.893 0 8.247 3.37 8.247 8.238 0 4.902-3.354 8.272-8.247 8.272z"/><path fill="#07F" d="M.398 19.2c0-9.051 0-13.576 2.812-16.388S10.547 0 19.598 0h1.6c9.051 0 13.577 0 16.389 2.812s2.811 7.337 2.811 16.388v1.6c0 9.051 0 13.576-2.811 16.388S30.249 40 21.198 40h-1.6c-9.05 0-13.576 0-16.388-2.812S.398 29.851.398 20.8z"/><path fill="#fff" d="M21.682 28.817c-9.117 0-14.317-6.25-14.534-16.65h4.567c.15 7.633 3.517 10.866 6.183 11.533V12.167h4.3v6.583c2.634-.283 5.4-3.283 6.334-6.583h4.3c-.717 4.066-3.717 7.066-5.85 8.3 2.133 1 5.55 3.616 6.85 8.35h-4.734c-1.016-3.167-3.55-5.617-6.9-5.95v5.95z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-mail_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M19.383 8c-5.019 0-7.117.465-9.244 1.603a10.93 10.93 0 0 0-4.536 4.536C4.465 16.266 4 18.364 4 23.383v9.234c0 5.019.465 7.117 1.603 9.244a10.92 10.92 0 0 0 4.536 4.536C12.266 47.535 14.364 48 19.383 48h17.234c5.019 0 7.117-.465 9.244-1.603a10.92 10.92 0 0 0 4.536-4.536C51.535 39.734 52 37.636 52 32.617v-9.234c0-5.019-.465-7.117-1.603-9.244a10.93 10.93 0 0 0-4.536-4.536C43.734 8.465 41.636 8 36.617 8zm-7.83 4.248c1.486-.794 3-1.248 7.83-1.248h17.234c4.83 0 6.344.454 7.83 1.248q.384.207.738.445l-9.76 9.761c-2.03 2.03-3.448 3.444-4.66 4.368-1.178.898-1.982 1.193-2.765 1.193s-1.587-.295-2.765-1.193c-1.212-.924-2.63-2.338-4.66-4.368l-9.76-9.76q.354-.24.739-.446m-2.86 2.567q-.24.354-.445.739c-.794 1.485-1.248 3-1.248 7.83v9.233c0 4.83.454 6.344 1.248 7.83a7.93 7.93 0 0 0 3.306 3.305c1.485.794 3 1.248 7.83 1.248h17.233c4.83 0 6.344-.454 7.83-1.248a7.93 7.93 0 0 0 3.305-3.306c.794-1.485 1.248-3 1.248-7.83v-9.233c0-4.83-.454-6.344-1.248-7.83a8 8 0 0 0-.445-.738l-9.761 9.76-.078.078c-1.934 1.934-3.493 3.493-4.884 4.554-1.444 1.102-2.882 1.808-4.584 1.808-1.703 0-3.14-.706-4.584-1.808-1.391-1.061-2.95-2.62-4.884-4.554l-.078-.078z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-masks_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.285 15.84c-.485.25-1.177.608-2.285.608s-1.8-.357-2.285-.608c-.447-.23-.719-.37-.979-.062-.544.644.544 3.22 3.264 3.22s3.808-2.576 3.264-3.22c-.26-.309-.533-.168-.979.062M10.811 10.009c.937.08 1.647.7 1.585 1.386-.061.686-.87 1.176-1.807 1.097-.937-.08-1.647-.701-1.585-1.387.061-.686.87-1.176 1.807-1.097M18.996 11.105c-.061-.686-.87-1.176-1.807-1.097-.937.08-1.647.701-1.585 1.387.061.686.87 1.176 1.807 1.097.937-.08 1.647-.701 1.585-1.387"/><path fill="currentColor" fill-rule="evenodd" d="M23.443 4.262c2.36 2.44 1.77 9.15 0 13.419S18.13 25 14 25s-7.672-3.05-9.443-7.32c-1.77-4.269-2.36-10.978 0-13.418C6.11 2.657 7.663 2.908 9.89 3.267c1.157.187 2.496.404 4.111.404s2.954-.217 4.111-.404c2.226-.359 3.779-.61 5.332.995m-1.437 1.391c.253.262.536.762.737 1.6.197.822.283 1.838.25 2.974-.067 2.282-.609 4.786-1.397 6.688C20.024 20.705 17.068 23 14 23s-6.024-2.295-7.595-6.085c-.79-1.902-1.331-4.406-1.398-6.688-.033-1.136.053-2.152.25-2.973.201-.839.484-1.34.737-1.601.37-.381.653-.517.893-.582.28-.076.66-.098 1.295-.03.301.031.694.094 1.157.168 1.204.193 2.882.462 4.661.462 1.78 0 3.457-.269 4.661-.462.463-.074.856-.137 1.157-.169.635-.067 1.014-.045 1.295.031.24.065.524.2.893.582" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-medal-rt" class="svg-sprite__symbol"><path fill="currentColor" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M10.003 7.931c.807 0 1.568.182 2.246.506L13.674 3H6.33l1.425 5.437a5.2 5.2 0 0 1 2.248-.506"/><path fill="url(#c)" d="M10.001 10.36c-1.338 0-2.427 1.036-2.427 2.31 0 1.273 1.09 2.31 2.427 2.31 1.338 0 2.428-1.037 2.428-2.31 0-1.276-1.09-2.31-2.428-2.31"/><path fill="url(#d)" d="M12.43 9.118c-.045-.026-.183-.112-.266-.151a4.64 4.64 0 0 0-2.163-.53 4.66 4.66 0 0 0-2.165.53c-.037.026-.127.066-.262.15C6.328 9.882 5.5 11.21 5.5 12.722c.002 2.36 2.02 4.282 4.503 4.282 2.48 0 4.5-1.921 4.5-4.282-.003-1.512-.828-2.84-2.072-3.603m-2.429 6.366c-1.632 0-2.958-1.262-2.958-2.815 0-1.554 1.326-2.816 2.958-2.816s2.959 1.262 2.959 2.816-1.327 2.815-2.959 2.815"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FFC062"/><stop offset="1" stop-color="#F7A148"/></linearGradient><linearGradient id="b" x1="6.33" x2="11.324" y1="3" y2="10.819" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient><linearGradient id="c" x1="7.574" x2="12.163" y1="10.359" y2="15.948" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient><linearGradient id="d" x1="5.5" x2="14.006" y1="8.438" y2="18.799" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-mention" class="svg-sprite__symbol"><path fill="currentColor" d="M15 19.75a.75.75 0 0 0 0-1.5zm-5-1.5A8.25 8.25 0 0 1 1.75 10H.25A9.75 9.75 0 0 0 10 19.75zM1.75 10A8.25 8.25 0 0 1 10 1.75V.25A9.75 9.75 0 0 0 .25 10zM10 1.75A8.25 8.25 0 0 1 18.25 10h1.5A9.75 9.75 0 0 0 10 .25zM15 19v-.75h-5v1.5h5zm3.25-9v1.5h1.5V10zm-3.5 1.5V10h-1.5v1.5zm1.75 1.75a1.75 1.75 0 0 1-1.75-1.75h-1.5a3.25 3.25 0 0 0 3.25 3.25zm1.75-1.75a1.75 1.75 0 0 1-1.75 1.75v1.5a3.25 3.25 0 0 0 3.25-3.25z"/><circle cx="10" cy="10" r="4" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-mention_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.084 9.975c0 5.086 3.462 8.108 8.264 8.108 1.223 0 2.309-.156 3.032-.4.587-.196.793-.46.793-.803 0-.342-.225-.557-.626-.557-.098 0-.225.01-.382.039-.88.215-1.555.352-2.513.352-4.206 0-7.042-2.445-7.042-6.68 0-4.098 2.63-6.925 6.63-6.925 3.492 0 6.319 2.142 6.319 6.084 0 2.054-.743 3.492-1.829 3.492-.704 0-1.085-.382-1.085-1.047V6.787c0-.548-.313-.88-.842-.88-.518 0-.84.332-.84.88v.489h-.099c-.4-.87-1.31-1.37-2.386-1.37-1.946 0-3.325 1.644-3.325 4.06 0 2.455 1.379 4.137 3.393 4.137 1.135 0 2.015-.568 2.446-1.565h.097c.176.988 1.096 1.565 2.309 1.565 2.278 0 3.687-2.103 3.687-5.027 0-4.46-3.277-7.326-7.825-7.326-4.831 0-8.176 3.237-8.176 8.225m7.805 2.602c-1.213 0-1.927-.978-1.927-2.602 0-1.613.724-2.572 1.927-2.572 1.232 0 2.015.998 2.015 2.563 0 1.604-.793 2.61-2.015 2.61" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="none" id="svg-name-menu_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M19 7H1a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2m0-7H1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2M1 16h18a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message-clear" class="svg-sprite__symbol"><g stroke="#F1F1F1" stroke-linecap="round" stroke-width="1.5" clip-path="url(#a)"><path stroke-linejoin="round" d="m13.414 6.59 4.628-4.628M13.413 1.96l4.628 4.63"/><path d="M16 10.964c0 3.847-3.134 6.965-7 6.965a7 7 0 0 1-1.615-.187c-.757-.245-2.845.476-4.018.926-.262.1-.527-.202-.401-.452.435-.864 1-2.21.65-2.802A6.9 6.9 0 0 1 2 10.965C2 7.118 5.134 4 9 4"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message_cross_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.25 2.5C5.813 2.5 2 5.706 2 9.993c0 1.445.446 2.822 1.261 4-.082.457-.338 1.189-.896 2.292l-.24.475a1.2 1.2 0 0 0 1.164 1.736l.532-.041c1.472-.115 2.804-.51 3.768-1.361.85.26 1.745.392 2.66.392 4.435 0 8.25-3.206 8.25-7.493S14.684 2.5 10.25 2.5M3.5 9.993C3.5 6.693 6.473 4 10.25 4c3.774 0 6.75 2.693 6.75 5.994s-2.976 5.995-6.75 5.995c-.91 0-1.788-.156-2.602-.455a.75.75 0 0 0-.82.207c-.61.687-1.64 1.105-3.124 1.22.682-1.347 1.045-2.376 1.085-3.13a.75.75 0 0 0-.15-.49 5.52 5.52 0 0 1-1.14-3.347m9.524-2.778a.75.75 0 0 1 0 1.06l-1.717 1.72 1.718 1.721a.75.75 0 0 1-1.061 1.06l-1.717-1.719-1.717 1.72a.75.75 0 1 1-1.062-1.06l1.719-1.721-1.719-1.72a.75.75 0 0 1 1.062-1.06l1.717 1.719 1.717-1.72a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-message_cross_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.459 10.043a1 1 0 0 1 0 1.414L15.416 13.5l2.043 2.043a1 1 0 0 1-1.414 1.414l-2.043-2.043-2.043 2.043a1 1 0 0 1-1.414-1.414l2.043-2.043-2.043-2.043a1 1 0 0 1 1.414-1.414l2.043 2.043 2.043-2.043a1 1 0 0 1 1.414 0"/><path fill="currentColor" fill-rule="evenodd" d="M14.02 3.5C7.828 3.5 2.54 7.839 2.54 13.499c0 1.873.59 3.62 1.607 5.101-.044.617-.219 1.272-.475 1.966-.227.616-.498 1.21-.774 1.815l-.27.597c-.438.974.317 2.062 1.363 2.02 2.568-.1 4.667-.748 6.112-2.097 1.225.387 2.545.597 3.918.597 6.193 0 11.482-4.34 11.482-10 0-5.659-5.29-9.998-11.482-9.998M4.54 13.499c0-4.28 4.096-7.999 9.481-7.999s9.482 3.719 9.482 7.999-4.097 7.999-9.482 7.999c-1.372 0-2.673-.246-3.845-.687a1 1 0 0 0-1.114.289c-.813.957-2.162 1.615-4.218 1.834.24-.53.492-1.102.704-1.675.337-.911.61-1.921.61-2.963a1 1 0 0 0-.197-.596c-.907-1.222-1.421-2.664-1.421-4.201" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M6.828 15.752a.75.75 0 0 1 .821-.208A7.5 7.5 0 0 0 10.25 16c3.772 0 6.75-2.694 6.75-6s-2.978-6-6.75-6S3.5 6.694 3.5 10c0 1.21.4 2.367 1.14 3.349a.75.75 0 0 1 .15.49c-.04.756-.403 1.785-1.085 3.135 1.483-.116 2.514-.534 3.123-1.223M3.242 18.5a1.203 1.203 0 0 1-1.101-1.767c.644-1.216 1.016-2.14 1.121-2.73A7 7 0 0 1 2 10c0-4.17 3.681-7.5 8.25-7.5S18.5 5.83 18.5 10s-3.681 7.5-8.25 7.5a9 9 0 0 1-2.66-.393c-.996.881-2.456 1.336-4.348 1.393"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-messages_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 2C4.44 2 1.5 4.518 1.5 7.754c0 1.084.336 2.12.954 3.014-.094.407-.361 1.038-.82 1.877-.3.547-.073 1.21.46 1.483.167.086.352.127.538.121 1.426-.041 2.563-.365 3.366-1.015.64.18 1.313.274 2.002.274 3.56 0 6.5-2.518 6.5-5.754S11.56 2 8 2m0 1.5c-2.917 0-5 2.02-5 4.254 0 .788.25 1.55.726 2.216l.134.188a.75.75 0 0 1 .128.572l-.042.226c-.09.49-.324 1.087-.648 1.742.873-.107 1.438-.357 1.795-.662l.24-.206a.75.75 0 0 1 .701-.15l.308.092c.523.155 1.08.236 1.658.236 2.917 0 5-2.02 5-4.254S10.917 3.5 8 3.5" clip-rule="evenodd"/><path fill="currentColor" d="M16.157 8.575a.75.75 0 0 1 1.187-.916 5.45 5.45 0 0 1 1.156 3.345 5.4 5.4 0 0 1-.914 3.008c.088.411.346 1.049.789 1.895a1.09 1.09 0 0 1-.992 1.593c-1.363-.042-2.456-.363-3.231-1.01a6.8 6.8 0 0 1-1.902.268 6.7 6.7 0 0 1-2.57-.5.75.75 0 0 1 .572-1.388c.6.248 1.275.388 1.998.388.546 0 1.073-.08 1.568-.233l.294-.092a.75.75 0 0 1 .722.158l.23.206c.33.294.85.538 1.652.646-.311-.657-.535-1.253-.622-1.743l-.04-.225a.75.75 0 0 1 .12-.554l.129-.188A3.93 3.93 0 0 0 17 11.003c0-.894-.306-1.733-.843-2.429"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-messages_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21.197 8.281c1.254 1.245 1.966 2.86 1.966 4.576 0 1.088-.286 2.14-.823 3.085.086.517.336 1.302.75 2.328l.222.535.049.143.021.085a1.2 1.2 0 0 1-1.24 1.435c-1.635-.086-2.94-.485-3.89-1.22a8.6 8.6 0 0 1-2.804.466c-.99 0-1.955-.166-2.856-.485a.857.857 0 0 1 .572-1.616c.718.254 1.49.387 2.284.387.931 0 1.83-.182 2.646-.527a.86.86 0 0 1 .943.186c.47.476 1.175.807 2.127.978l.243.04c-.492-1.248-.762-2.19-.808-2.866a.86.86 0 0 1 .13-.518c.471-.742.72-1.573.72-2.436 0-1.246-.52-2.427-1.46-3.359a.857.857 0 0 1 1.207-1.217m-10.892-5.71c4.237 0 7.715 3.043 7.715 6.857s-3.478 6.858-7.715 6.858c-.97 0-1.918-.16-2.803-.467-.951.736-2.256 1.135-3.891 1.22a1.2 1.2 0 0 1-1.24-1.435l.022-.084.049-.144.114-.273c.442-1.066.719-1.893.833-2.455l.025-.135-.13-.239a6.2 6.2 0 0 1-.693-2.846c0-3.814 3.477-6.857 7.714-6.857m0 1.715c-3.337 0-6 2.33-6 5.142 0 .863.249 1.694.719 2.437a.86.86 0 0 1 .13.518c-.043.627-.278 1.484-.705 2.603l-.102.262.243-.04c.951-.17 1.656-.502 2.127-.977a.86.86 0 0 1 .943-.187 6.8 6.8 0 0 0 2.645.527c3.338 0 6-2.33 6-5.143s-2.662-5.142-6-5.142"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="34" height="30" id="svg-name-mobile" class="svg-sprite__symbol"><path fill="currentColor" d="M14.351.035a3.25 3.25 0 0 0-3.244 3.245v1.622h3.244V3.28h16.222v21.088h-6.489a1.623 1.623 0 0 1-3.244 0h-1.622v4.867h11.355a3.25 3.25 0 0 0 3.245-3.244V3.28A3.25 3.25 0 0 0 30.573.035zM3.853 7.29a3.244 3.244 0 0 0-3.245 3.244v16.223A3.244 3.244 0 0 0 3.853 30h9.733a3.244 3.244 0 0 0 3.244-3.244V10.533a3.244 3.244 0 0 0-3.244-3.244zm0 3.244h9.733v16.223h-3.244c0 .895-.751 1.622-1.623 1.622a1.64 1.64 0 0 1-1.622-1.622H3.853z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-money-x2" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.276.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678l-.297-.295.297.295C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1L18.6 1.4l-.313.316c.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.409.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.276 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.409-1.102-2.668C.444 14.36.444 12.72.444 10.481z"/><path fill="url(#b)" d="M3.21 14v-1.047l2.778-2.723q.399-.402.664-.714.265-.313.399-.606.133-.292.133-.625a1.2 1.2 0 0 0-.172-.648 1.14 1.14 0 0 0-.473-.422 1.5 1.5 0 0 0-.684-.149q-.394 0-.69.164a1.13 1.13 0 0 0-.462.457q-.16.297-.16.708H3.164q0-.762.348-1.325a2.33 2.33 0 0 1 .957-.87q.613-.31 1.406-.31.804 0 1.414.301.609.3.945.825.34.523.34 1.195 0 .45-.172.883-.171.434-.605.96-.43.528-1.207 1.278l-1.38 1.402v.055h3.485V14H3.211z"/><path fill="url(#c)" d="m11.332 6 1.762 2.93h.062L14.926 6h1.652l-2.465 4 2.504 4h-1.68l-1.78-2.91h-.063L11.313 14H9.64l2.527-4-2.496-4z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE149"/><stop offset="1" stop-color="#E96D1E"/></linearGradient><linearGradient id="b" x1="2.5" x2="8.924" y1="15" y2="4.275" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient><linearGradient id="c" x1="2.5" x2="8.924" y1="15" y2="4.275" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-money-x3" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M5.982 14.11q-.843 0-1.5-.29a2.5 2.5 0 0 1-1.03-.804 2.1 2.1 0 0 1-.403-1.192h1.469a.97.97 0 0 0 .214.567q.196.238.52.37a1.9 1.9 0 0 0 .727.134q.43 0 .761-.149.333-.152.52-.422a1.04 1.04 0 0 0 .183-.62 1.08 1.08 0 0 0-.187-.642 1.25 1.25 0 0 0-.555-.433 2.2 2.2 0 0 0-.867-.156h-.707V9.355h.707q.418 0 .73-.144.317-.145.497-.406.18-.266.175-.614a1.07 1.07 0 0 0-.152-.59q-.153-.253-.434-.394a1.4 1.4 0 0 0-.652-.14 1.7 1.7 0 0 0-.68.132 1.24 1.24 0 0 0-.504.38.96.96 0 0 0-.203.577H3.217q.016-.671.387-1.18.375-.51 1-.796.625-.29 1.402-.29.8 0 1.39.301.594.297.918.801t.325 1.113q.004.677-.399 1.133a1.87 1.87 0 0 1-1.047.598v.062q.845.118 1.293.625.453.504.45 1.254 0 .672-.383 1.204a2.54 2.54 0 0 1-1.047.828q-.664.3-1.524.3"/><path fill="url(#c)" d="m11.565 6 1.762 2.93h.063L15.16 6h1.651l-2.464 4 2.504 4h-1.68l-1.781-2.91h-.063L11.546 14H9.874l2.527-4-2.496-4z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FFB017"/><stop offset="1" stop-color="#EA371F"/></linearGradient><linearGradient id="b" x1="13.5" x2="6.5" y1="6" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE44A"/><stop offset="1" stop-color="#E65917"/></linearGradient><linearGradient id="c" x1="13.5" x2="6.5" y1="6" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE44A"/><stop offset="1" stop-color="#E65917"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-money_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.1 10.357A3.355 3.355 0 0 0 13.747 7h-3.1a.85.85 0 0 0-.849.85V12h-.692a.857.857 0 0 0 0 1.714h.691V15H9a.75.75 0 0 0 0 1.5h.798l.001.65a.85.85 0 1 0 1.698 0v-.65h1.499a.75.75 0 0 0 0-1.5h-1.499v-1.286h2.25a3.355 3.355 0 0 0 3.354-3.357m-5.604-1.786h2.283a1.713 1.713 0 0 1 0 3.429h-2.283z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.5 2a9.97 9.97 0 0 0-7.071 2.929A9.97 9.97 0 0 0 2.5 12a9.97 9.97 0 0 0 2.929 7.071A9.97 9.97 0 0 0 12.5 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22.5 12a9.97 9.97 0 0 0-2.929-7.071A9.97 9.97 0 0 0 12.5 2M6.702 6.202A8.17 8.17 0 0 1 12.5 3.8c2.265 0 4.313.917 5.798 2.402A8.17 8.17 0 0 1 20.7 12a8.17 8.17 0 0 1-2.402 5.798A8.17 8.17 0 0 1 12.5 20.2a8.17 8.17 0 0 1-5.798-2.402A8.17 8.17 0 0 1 4.3 12c0-2.265.917-4.313 2.402-5.798" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-money_send_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M24 12.846c0-1.068-.073-1.449-.282-1.84a1.73 1.73 0 0 0-.724-.723c-.391-.21-.772-.283-1.84-.283H4v9.154c0 1.068.073 1.449.283 1.84q.252.47.723.724c.391.209.772.282 1.84.282h15.739l-1.292-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L22.585 24H6.845c-1.37 0-2.062-.134-2.782-.519a3.73 3.73 0 0 1-1.544-1.544C2.134 21.217 2 20.524 2 19.154V8h.002v-.055c.017-1 .14-1.558.45-2.138a3.27 3.27 0 0 1 1.355-1.355C4.435 4.116 5.037 4 6.205 4h11.59c1.167 0 1.77.116 2.398.452a3.27 3.27 0 0 1 1.355 1.355c.317.594.439 1.166.451 2.213.845.055 1.383.202 1.938.499.663.355 1.19.881 1.544 1.544.385.72.519 1.413.519 2.783V17a1 1 0 1 1-2 0zM20 15a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm-2.205-9H6.205c-.865 0-1.156.056-1.454.216q-.35.185-.535.535C4.069 7.024 4.01 7.29 4 8H20c-.01-.709-.069-.976-.215-1.25a1.27 1.27 0 0 0-.534-.534C18.95 6.056 18.66 6 17.795 6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-more" class="svg-sprite__symbol"><circle cx="3" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="21" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-more_horizontal_24" class="svg-sprite__symbol"><path fill="currentColor" d="M18 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m-6 4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m-6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-more_horizontal_28" class="svg-sprite__symbol"><path fill="currentColor" d="M6.071 10A1.786 1.786 0 1 1 2.5 10a1.786 1.786 0 0 1 3.571 0M11.786 10a1.786 1.786 0 1 1-3.572 0 1.786 1.786 0 0 1 3.572 0M15.714 11.785a1.786 1.786 0 1 0 0-3.571 1.786 1.786 0 0 0 0 3.571"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="16" fill="none" id="svg-name-more_vertical_16" class="svg-sprite__symbol"><path fill="currentColor" d="M6 4.5c.825 0 1.5-.675 1.5-1.5S6.825 1.5 6 1.5 4.5 2.175 4.5 3 5.175 4.5 6 4.5m0 2c-.825 0-1.5.675-1.5 1.5S5.175 9.5 6 9.5 7.5 8.825 7.5 8 6.825 6.5 6 6.5m0 5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-mute-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M12.98 18.823c-.031 1.207-.67 1.609-1.828.62-1.719-1.469-3.609-3.194-4.242-3.721-.632-.529-1.645-.62-3.073-.62s-1.815-.621-1.815-1.241-.014-1.83-.014-2.001c0-.055.005-.086.014-.13.02-.095-.058-.973 0-1.59.085-.906.388-1.241 1.815-1.241s2.44-.092 3.073-.62c.633-.529 2.523-2.253 4.242-3.722 1.158-.989 1.797-.587 1.829.62.043 1.607 0 3.85 0 6.683 0 2.83.043 5.356 0 6.963m2.901-8.704A.875.875 0 1 1 17.12 8.88c.176.177.41.47.64.872.384.671.616 1.425.616 2.247s-.232 1.576-.615 2.247a4.2 4.2 0 0 1-.641.872.875.875 0 1 1-1.238-1.238c.074-.073.214-.249.36-.503.241-.423.384-.887.384-1.378s-.143-.955-.385-1.378a2.6 2.6 0 0 0-.359-.503m3-2A.875.875 0 1 1 20.12 6.88c.263.264.62.74.966 1.432.517 1.033.843 2.255.89 3.716-.047 1.403-.373 2.625-.89 3.658-.346.692-.703 1.168-.966 1.432a.875.875 0 1 1-1.238-1.238c.138-.137.383-.464.639-.976.407-.814.667-1.79.705-2.876-.038-1.144-.298-2.12-.705-2.934-.256-.512-.501-.839-.639-.976"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-new-boosty" class="svg-sprite__symbol"><rect width="30" height="30" fill="#E65C2C" rx="8"/><g clip-path="url(#a)"><path fill="#fff" d="M8.646 16.557 11.356 7h4.16l-.84 2.963a.3.3 0 0 0-.022.053l-2.21 7.824h2.062q-1.29 3.291-2.02 5.16c-3.805-.043-4.871-2.82-3.938-6.107zM12.499 23l5.015-7.36h-2.128l1.851-4.715c3.177.339 4.667 2.887 3.79 5.967-.94 3.314-4.745 6.108-8.45 6.108z"/></g><defs><clipPath id="a"><path fill="#fff" d="M8.23 7h13.54v16H8.23z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-new_logo_vk_color_20" class="svg-sprite__symbol"><rect width="30" height="30" fill="#07F" rx="6.667"/><path fill="#fff" d="M15.813 20C10.408 20 7.128 16.246 7 10h2.737c.086 4.588 2.168 6.527 3.765 6.927V10h2.623v3.962c1.54-.171 3.152-1.975 3.694-3.962H22.4c-.413 2.444-2.168 4.24-3.408 4.982 1.24.6 3.237 2.174 4.007 5.018h-2.838c-.6-1.9-2.067-3.366-4.036-3.565V20z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-newsfeed_lines_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.59 3c2.183 0 3.233.203 4.324.786a5.54 5.54 0 0 1 2.3 2.3c.583 1.091.786 2.14.786 4.324v7.18c0 2.183-.203 3.233-.786 4.324a5.54 5.54 0 0 1-2.3 2.3c-1.091.583-2.14.786-4.324.786h-7.18c-2.183 0-3.233-.203-4.324-.786a5.54 5.54 0 0 1-2.3-2.3C3.203 20.823 3 19.774 3 17.59v-7.18c0-2.183.203-3.233.786-4.324a5.54 5.54 0 0 1 2.3-2.3C7.177 3.203 8.226 3 10.41 3zM5 11 5 17.59c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.76.408 1.499.55 3.38.55h7.18c1.881 0 2.62-.142 3.38-.55a3.54 3.54 0 0 0 1.48-1.48c.408-.76.55-1.499.55-3.38L22.999 11zM17.59 5h-7.18c-1.881 0-2.62.142-3.38.55-.641.342-1.138.839-1.48 1.48-.286.534-.441 1.056-.509 1.97H22.96c-.068-.914-.223-1.436-.509-1.97a3.54 3.54 0 0 0-1.48-1.48c-.76-.408-1.499-.55-3.38-.55"/><path fill="currentColor" d="M8 15c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H9.09C8.489 16 8 15.552 8 15M8 19c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H9.09C8.489 20 8 19.552 8 19"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-nft_heptagon_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.53 8.78a.75.75 0 0 0-1.06-1.06L9 11.19 7.78 9.97a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0z"/><path fill="currentColor" fill-rule="evenodd" d="M8.479 1.55a1.95 1.95 0 0 0-1.82.522L2.072 6.66a1.95 1.95 0 0 0-.522 1.82l1.595 6.912a1.95 1.95 0 0 0 1.464 1.464l6.912 1.595a1.95 1.95 0 0 0 1.82-.522l4.587-4.587a1.95 1.95 0 0 0 .522-1.82L16.855 4.61a1.95 1.95 0 0 0-1.464-1.464zm-.76 1.583c.11-.11.27-.156.423-.121l6.912 1.595c.168.039.3.17.34.34l1.594 6.911a.45.45 0 0 1-.12.423l-4.587 4.586a.45.45 0 0 1-.423.121l-6.912-1.595a.45.45 0 0 1-.34-.34L3.013 8.143a.45.45 0 0 1 .12-.423z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-nft_heptagon_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M18.707 12.207a1 1 0 1 0-1.414-1.414L12.5 15.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0z"/><path fill="currentColor" fill-rule="evenodd" d="M11.827 2.07a2.71 2.71 0 0 0-2.524.723l-6.51 6.51a2.71 2.71 0 0 0-.724 2.524l2.264 9.81a2.71 2.71 0 0 0 2.03 2.03l9.81 2.264c.91.21 1.864-.064 2.524-.724l6.51-6.51c.66-.66.934-1.614.724-2.523l-2.264-9.811a2.71 2.71 0 0 0-2.03-2.03zm-1.11 2.137a.71.71 0 0 1 .66-.189l9.81 2.264c.264.061.47.267.53.53l2.265 9.811a.71.71 0 0 1-.19.66l-6.51 6.51a.71.71 0 0 1-.659.189l-9.81-2.264a.71.71 0 0 1-.53-.53l-2.265-9.811a.71.71 0 0 1 .19-.66z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="192" height="192" id="svg-name-no-image" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#E0E0E0" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"><path d="M161.054 30.946c35.928 35.928 35.928 94.18 0 130.108s-94.179 35.928-130.108 0c-35.928-35.928-35.928-94.179 0-130.108 35.928-35.928 94.18-35.928 130.108 0M51.44 51.44 30.96 30.96M161.04 161.04l-17.44-17.36"/><g transform="translate(58 60)"><path d="M70.583 77H6.417A6.417 6.417 0 0 1 0 70.583V6.417A6.417 6.417 0 0 1 6.417 0h64.166A6.417 6.417 0 0 1 77 6.417v64.166A6.417 6.417 0 0 1 70.583 77"/><circle cx="26.469" cy="25.667" r="9.625"/><path d="M77 62.563 61.658 39.546a4.812 4.812 0 0 0-7.95-.09L40.906 57.75l-7.93-6.346a4.82 4.82 0 0 0-7.014 1.09L9.625 77"/></g></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="192" height="192" id="svg-name-no-video" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#E0E0E0" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"><path d="M161.054 30.946c35.928 35.928 35.928 94.18 0 130.108s-94.179 35.928-130.108 0c-35.928-35.928-35.928-94.179 0-130.108 35.928-35.928 94.18-35.928 130.108 0M51.44 51.44 30.96 30.96M161.04 161.04l-17.44-17.36"/><path d="M134.284 62.516a3.8 3.8 0 0 0-3.8-3.8H62.072a3.8 3.8 0 0 0-3.8 3.8v68.412a3.8 3.8 0 0 0 3.8 3.8h68.412a3.8 3.8 0 0 0 3.8-3.8z"/><path d="M87.916 111.058a2.052 2.052 0 0 1-3.04-1.794V83.557a2.052 2.052 0 0 1 3.067-1.779l22.507 12.861a2.049 2.049 0 0 1 0 3.558z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-note" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.188" d="m16.245 7.829-.735 3.135c-.63 2.707-1.875 3.802-4.215 3.577a8 8 0 0 1-1.215-.202l-1.26-.3c-3.127-.743-4.095-2.288-3.36-5.423l.735-3.142c.15-.638.33-1.193.555-1.65.878-1.815 2.37-2.303 4.875-1.71l1.253.292c3.142.735 4.102 2.288 3.367 5.423"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.188" d="M11.295 14.546c-.465.315-1.05.577-1.763.81l-1.185.39c-2.977.96-4.545.157-5.512-2.82l-.96-2.963c-.96-2.977-.165-4.552 2.812-5.512l1.185-.39c.308-.098.6-.18.878-.233-.225.458-.405 1.013-.555 1.65L5.46 8.621c-.735 3.135.232 4.68 3.36 5.422l1.26.3q.652.158 1.215.203"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-notification" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M16.385 16H3.514c-.717 0-1.208-.735-.957-1.407.462-1.235 1.043-2.982 1.043-3.95C3.6 9.036 2.533 1 10 1s6.4 7.5 6.4 9.643c0 1.208.509 2.757.952 3.878.274.69-.224 1.479-.967 1.479ZM7.5 16.5S7.5 19 10 19s2.5-2.5 2.5-2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-notification_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12.006 2.1c4.015 0 6.896 3.278 6.896 7.531v1.6c0 .229.193.532.72 1.076l.27.275c1.082 1.097 1.51 1.728 1.51 2.745 0 .444-.052.79-.268 1.206-.456.878-1.424 1.367-2.87 1.367h-1.911c-.63 2.333-2.13 3.6-4.351 3.6-2.245 0-3.755-1.294-4.372-3.674l.02.074H5.738c-1.488 0-2.465-.503-2.902-1.411-.19-.397-.234-.72-.234-1.162 0-1.017.427-1.648 1.509-2.745.139-.14.202-.206.27-.275.527-.544.72-.848.72-1.076v-1.6C5.102 5.38 7.99 2.1 12.007 2.1M14.467 17.9H9.537c.456 1.247 1.241 1.799 2.466 1.799 1.224 0 2.01-.552 2.465-1.799M12.006 3.9c-2.968 0-5.104 2.426-5.104 5.731v1.6c0 .852-.39 1.463-1.228 2.328l-.282.287c-.746.757-.99 1.117-.99 1.48 0 .193.013.293.056.383.108.223.433.39 1.28.39h12.527c.82 0 1.153-.168 1.272-.396.05-.095.065-.198.065-.376 0-.364-.244-.724-.991-1.481-.139-.14-.208-.211-.281-.287-.839-.865-1.228-1.476-1.228-2.328v-1.6c0-3.307-2.13-5.731-5.096-5.731"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-notification_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14.005 3.5C18.535 3.5 22 7.294 22 12.082l-.005 1.826c0 .307.2.663.738 1.297l.271.315c1.07 1.238 1.496 1.954 1.496 3.068 0 .501-.057.89-.294 1.358C23.7 20.94 22.618 21.5 21 21.5h-2.601C17.73 23.766 16.212 25 14 25s-3.731-1.235-4.399-3.5H7c-1.665 0-2.758-.574-3.242-1.604-.21-.446-.258-.809-.258-1.308 0-1.113.425-1.83 1.493-3.068.139-.16.203-.235.27-.314.539-.635.737-.99.737-1.299V12.08C6 7.296 9.472 3.5 14.005 3.5m2.274 18h-4.558C12.17 22.544 12.899 23 14 23s1.829-.457 2.28-1.5m-2.274-16C10.618 5.5 8 8.362 8 12.079v1.828c0 .928-.384 1.617-1.212 2.592l-.28.328c-.76.88-1.008 1.298-1.008 1.761 0 .226.016.347.068.457.124.264.488.455 1.432.455h14c.914 0 1.286-.192 1.423-.46.059-.117.077-.241.077-.452 0-.463-.248-.88-1.009-1.76l-.282-.328c-.828-.976-1.214-1.665-1.214-2.593L20 12.08C20 8.36 17.389 5.5 14.005 5.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-notification_slash_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.006 2.1c4.162 0 6.896 3.445 6.896 7.531v1.6c0 .25.146.538.578.992.473.496 1.016.934 1.401 1.508.318.474.533 1.043.52 1.69a.9.9 0 0 1-1.8-.037c.017-.816-.93-1.402-1.424-1.92-.474-.497-1.075-1.234-1.075-2.233v-1.6c0-3.312-2.135-5.731-5.096-5.731-1.008 0-1.885.268-2.623.735a.9.9 0 0 1-.962-1.522A6.67 6.67 0 0 1 12.006 2.1M16.353 17.9c-.63 2.333-2.13 3.6-4.351 3.6s-3.723-1.267-4.352-3.6H5.738c-1.488 0-2.465-.503-2.902-1.411-.19-.397-.234-.72-.234-1.162 0-1.293.941-2.156 1.78-3.02.526-.544.72-.848.72-1.076 0-1.493-.038-2.969.454-4.404l-2.29-2.291a.9.9 0 0 1 1.272-1.273l16.2 16.2a.9.9 0 0 1-1.273 1.273l-2.835-2.835zm-6.817.002h4.932c-.456 1.246-1.242 1.798-2.466 1.798s-2.01-.552-2.466-1.799M6.902 11.23c0-.976-.06-1.971.122-2.936L14.83 16.1h-9.09c-.848 0-1.173-.168-1.28-.39-.336-.698.52-1.445.933-1.864.723-.731 1.51-1.518 1.51-2.615" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" id="svg-name-notifications" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.214 13.532a6.06 6.06 0 0 1 2.814-2.999C15.22 9.105 16.475 8 18 8s2.782 1.105 2.972 2.533a6.08 6.08 0 0 1 2.822 2.999s.677 1.26.87 3.369c.064.68.319 1.697.673 2.364.438.826 1.493 2.231 1.622 3.757q.04.213.041.433c0 .404-.104.796-.3 1.168l-.02.044c-.116.25-.223.404-.323.477C25.029 26.82 21.787 28 18 28c-3.799 0-7.047-1.188-8.368-2.87-.089-.074-.185-.212-.288-.427A2.5 2.5 0 0 1 9 23.455q.002-.246.053-.484c.149-1.507 1.184-2.89 1.617-3.706.354-.667.61-1.684.672-2.364.195-2.108.872-3.37.872-3.37zM18 26.002c-3.52 0-6.637-1.16-6.637-2.366 0-.834 1.636-1.56 3.65-1.926.134 1.486 1.42 2.654 2.987 2.654 1.57 0 2.854-1.168 2.987-2.654 2.015.366 3.652 1.092 3.652 1.926 0 1.206-3.117 2.367-6.639 2.367z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="22" id="svg-name-ok" class="svg-sprite__symbol"><path fill="#FFF" fill-rule="evenodd" d="M6.77 0C3.491 0 .833 2.552.833 5.701s2.658 5.701 5.937 5.701 5.937-2.552 5.937-5.701S10.049 0 6.77 0m3.953 11.916a1.66 1.66 0 0 1 2.269.24 1.51 1.51 0 0 1-.25 2.179c-.075.058-1.5 1.139-3.876 1.603l3.587 3.415c.631.605.632 1.586.002 2.192a1.66 1.66 0 0 1-2.283.002L6.69 18.29l-3.163 3.236c-.317.315-.74.474-1.162.474-.404 0-.807-.144-1.12-.434a1.507 1.507 0 0 1-.042-2.192l3.405-3.417C2.164 15.503.681 14.394.604 14.335a1.51 1.51 0 0 1-.249-2.18 1.66 1.66 0 0 1 2.27-.239c.014.011 1.565 1.13 4.064 1.132 2.5-.002 4.019-1.12 4.034-1.132M6.77 3.344c1.355 0 2.454 1.056 2.454 2.357S8.125 8.058 6.77 8.058 4.316 7.003 4.316 5.701c0-1.301 1.099-2.357 2.454-2.357"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="12" fill="none" id="svg-name-open" class="svg-sprite__symbol"><path fill="currentColor" d="M17.684 7.431a.67.67 0 0 1 0 1.138l-4.737 2.842c-.42.253-.947-.063-.947-.568V5.157c0-.505.526-.82.947-.568zM0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75M0 5.75A.75.75 0 0 1 .75 5h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 5.75M0 10.75A.75.75 0 0 1 .75 10h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-palette_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10.8 6.05a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M14.45 8.2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M4.3 9.45a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M7.85 4.8a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"/><path fill="currentColor" fill-rule="evenodd" d="M14.177 14.037c2.142.23 4.323-.743 4.323-4.037a8.47 8.47 0 0 0-2.49-6.01A8.47 8.47 0 0 0 10 1.5a8.47 8.47 0 0 0-6.01 2.49A8.47 8.47 0 0 0 1.5 10c0 2.347.951 4.472 2.49 6.01A8.47 8.47 0 0 0 10 18.5c1.13 0 2.255-1.007 1.977-2.425-.047-.24-.11-.472-.168-.688-.254-.94-.43-1.59 1.076-1.487.036.002.455.047 1.292.137m.16-1.491-.246-.027c-.653-.07-1.037-.11-1.103-.116-.525-.036-1.172-.024-1.74.264a2 2 0 0 0-1.102 1.687c-.033.476.088.944.154 1.197l.072.27c.053.197.097.357.133.542a.6.6 0 0 1-.003.277.44.44 0 0 1-.099.173A.57.57 0 0 1 10 17a6.97 6.97 0 0 1-4.95-2.05A6.97 6.97 0 0 1 3 10c0-1.933.782-3.681 2.05-4.95A6.97 6.97 0 0 1 10 3c1.933 0 3.681.782 4.95 2.05A6.97 6.97 0 0 1 17 10c0 1.297-.412 1.873-.774 2.152-.412.317-1.065.482-1.889.394" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10a9 9 0 1 0-18 0"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M13.15 10 10 19l9-9"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute-with-arrow-down" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M19 10a9 9 0 1 0-18 0"/><path d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M15.693 18.2V12m0 6.2 2.692-3m-2.693 3L13 15.2"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute-with-arrow-up" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M19 10a9 9 0 1 0-18 0"/><path d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M15.693 12v6.2m0-6.2 2.692 3m-2.693-3L13 15"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 16" id="svg-name-pause" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 2.969V13.03c0 .52-.034 1.018-.097 1.387-.062.37-.147.579-.236.582h-.334c-.089-.003-.174-.213-.236-.582A9 9 0 0 1 12 13.031V2.97c0-.52.034-1.018.097-1.387.062-.37.147-.579.236-.582h.334c.089.003.174.212.236.582.063.369.098.868.097 1.387M2 2.969V13.03c0 .52-.034 1.018-.097 1.387-.062.37-.147.579-.236.582h-.334c-.089-.003-.174-.213-.236-.582A9 9 0 0 1 1 13.031V2.97c0-.52.034-1.018.097-1.387.062-.37.147-.579.236-.582h.334c.089.003.174.212.236.582.063.369.098.868.097 1.387" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pause-audio" class="svg-sprite__symbol"><rect width="14" height="14" x="3" y="3" stroke="#fff" stroke-width="1.5" rx="3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-pause-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M6 6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C6.76 5 7.04 5 7.6 5h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C10 5.76 10 6.04 10 6.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C9.24 19 8.96 19 8.4 19h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 18.24 6 17.96 6 17.4zM14 6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C14.76 5 15.04 5 15.6 5h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C18 5.76 18 6.04 18 6.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C17.24 19 16.96 19 16.4 19h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C14 18.24 14 17.96 14 17.4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" id="svg-name-paused" class="svg-sprite__symbol"><circle cx="40" cy="40" r="40" fill="#F1F1F1" opacity=".1"/><rect width="13" height="40" x="22" y="20" stroke="#fff" stroke-width="2" rx="3"/><rect width="13" height="40" x="45" y="20" stroke="#fff" stroke-width="2" rx="3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-payment_card_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.797 4.1c1.152 0 1.739.113 2.35.44.564.302 1.013.75 1.314 1.314s.422 1.108.439 2.094l.002.256v7.59l-.003.257c-.016.986-.136 1.53-.438 2.094a3.17 3.17 0 0 1-1.314 1.314l-.14.072c-.565.272-1.147.369-2.21.369H6.207c-1.064 0-1.646-.097-2.21-.369l-.14-.072a3.17 3.17 0 0 1-1.315-1.314c-.302-.564-.422-1.108-.438-2.094l-.002-.256v-7.59c0-1.152.113-1.74.44-2.35A3.17 3.17 0 0 1 3.856 4.54c.564-.302 1.108-.422 2.094-.438l.256-.002zM20.1 9.9v5.895c0 .88-.059 1.186-.227 1.501q-.2.375-.576.576c-.29.155-.574.218-1.308.227H6.013c-.734-.01-1.017-.072-1.308-.227a1.37 1.37 0 0 1-.576-.576c-.168-.315-.227-.621-.227-1.501L3.9 9.9zm-13.895-4H17.99c.734.01 1.018.072 1.308.227q.375.2.576.576c.155.29.218.574.227 1.308L20.1 8.1H3.902V8.01c.01-.734.072-1.017.227-1.308q.2-.375.576-.576c.315-.168.621-.227 1.501-.227" clip-rule="evenodd"/><path fill="currentColor" d="M6.002 14.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C6.382 14 6.522 14 6.802 14h.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C7.622 16 7.482 16 7.202 16h-.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218c-.054-.107-.054-.247-.054-.527z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" id="svg-name-pen" class="svg-sprite__symbol"><path d="M14.603 0a.94.94 0 0 0-.67.278l-1.617 1.617 3.789 3.79 1.617-1.618c.37-.37.37-.97 0-1.34l-2.45-2.45a.94.94 0 0 0-.67-.277zm-3.708 3.316L0 14.21V18h3.79L14.683 7.105l-3.79-3.79z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="svg-name-pen-stroked" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M18.5 5.914a2 2 0 0 0 0-2.828L16.914 1.5a2 2 0 0 0-2.828 0l-1.793 1.793-10 10a1 1 0 0 0-.242.39l-1.5 4.5a1 1 0 0 0 1.265 1.266l4.5-1.5a1 1 0 0 0 .391-.242l10-10zm-3-3L17.086 4.5 16 5.586 14.414 4zm-2.5 2.5L14.586 7 5.46 16.126l-2.379.793.793-2.379z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pen-stroked-thin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7 6 17l-4.5 1.5L3 14 13 4m3 3-3-3m3 3 1.793-1.793a1 1 0 0 0 0-1.414l-1.586-1.586a1 1 0 0 0-1.414 0L13 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none" id="svg-name-pen-underlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="m10.971 1.471 1.621 1.32a.804.804 0 0 1-.007 1.158l-1.231 1.5-4.192 5.114a.53.53 0 0 1-.279.172l-2.173.5a.55.55 0 0 1-.57-.487l.101-2.144a.5.5 0 0 1 .124-.296l4.01-4.888 1.413-1.723a.885.885 0 0 1 1.183-.226" clip-rule="evenodd"/><path fill="currentColor" d="M1.167 13.202a.625.625 0 1 0 0 1.25zm11.417 1.25a.625.625 0 0 0 0-1.25zM8.954 3.184a.625.625 0 1 0-1.158.468zm2.537 2.874a.625.625 0 0 0-.275-1.219zM1.167 14.452h11.417v-1.25H1.167zm6.629-10.8c.193.48.592 1.165 1.185 1.692.603.537 1.463.95 2.51.714l-.275-1.219c-.536.121-.998-.068-1.405-.429a3.5 3.5 0 0 1-.856-1.226z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-pen_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.536 1.664a1.95 1.95 0 0 0-1.565 0 2 2 0 0 0-.513.342c-.137.121-.292.276-.465.45l-7.39 7.389c-.295.295-.528.527-.699.806-.15.245-.261.513-.328.793-.076.317-.076 1.112-.076 1.53 0 .122 0 .254.01.368.01.13.036.3.126.477.12.235.31.425.545.545.176.09.347.116.477.127.114.009.246.009.368.009.418 0 1.213 0 1.53-.076.28-.067.548-.178.793-.328.279-.171.511-.404.806-.7l7.39-7.389c.173-.173.328-.328.449-.465.128-.146.253-.31.342-.513a1.95 1.95 0 0 0 0-1.565 2 2 0 0 0-.342-.513c-.121-.137-.276-.292-.45-.465l-.03-.03a11 11 0 0 0-.465-.45 2 2 0 0 0-.513-.342m-.963 1.37a.45.45 0 0 1 .361 0 .6.6 0 0 1 .127.096c.097.085.217.205.41.398.194.194.314.314.399.41.08.092.094.124.096.128.05.115.05.246 0 .361a.6.6 0 0 1-.096.127 10 10 0 0 1-.398.41l-.724.724-1.436-1.436.724-.724c.193-.193.313-.313.41-.398a.6.6 0 0 1 .127-.096M9.252 5.312l-5.54 5.54c-.37.37-.465.472-.532.58a1.3 1.3 0 0 0-.15.361 4 4 0 0 0-.022.432c-.01.418-.014.628.008.672.028.058.032.061.09.09.044.022.252.018.67.008.209-.004.372-.012.431-.026q.192-.045.36-.15c.109-.066.211-.161.581-.531l5.54-5.54z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-people-couple" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M13.999 16.125c-.273-.803-.79-1.901-1.72-2.792-.914-.874-2.26-1.583-4.279-1.583s-3.365.709-4.278 1.583c-.931.89-1.448 1.99-1.72 2.792-.01.025-.007.037-.007.04a.1.1 0 0 0 .013.026c.02.024.067.059.148.059h11.688c.081 0 .129-.035.148-.059a.1.1 0 0 0 .013-.025c0-.004.002-.016-.006-.041Z"/><path fill="currentColor" fill-rule="evenodd" d="M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6M11.625 3.333a3 3 0 1 1 0 5.334c.295-.4.526-.853.676-1.34a1.5 1.5 0 1 0 0-2.655 4.5 4.5 0 0 0-.676-1.339M16.68 17h2.164c.61 0 1.061-.54.865-1.117C19.119 14.149 17.437 11 13 11h-.066a8.5 8.5 0 0 1 1.7 1.697 4.75 4.75 0 0 1 2.126 1.178c.52.498.9 1.079 1.17 1.625h-1.748c.215.546.378 1.058.498 1.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-people-couple-rounded" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" clip-path="url(#a)"><path d="M6 2.4a1.8 1.8 0 1 1-3.599 0 1.8 1.8 0 0 1 3.6 0M7.8 8.879c0 1.388-1.611 2.52-3.6 2.52S.6 10.271.6 8.88s1.612-2.52 3.6-2.52c1.99 0 3.6 1.128 3.6 2.52M9.811 4.08a1.08 1.08 0 1 1-2.16 0 1.08 1.08 0 0 1 2.16 0" clip-rule="evenodd"/><path d="M9.24 10.68a2.006 2.006 0 0 0 2.16-1.801 2.006 2.006 0 0 0-2.16-1.8"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="81" height="52" fill="none" id="svg-name-people-monochrome" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M68.33 30.47c3.518 0 6.33-2.813 6.33-6.235S71.849 18 68.33 18 62 20.813 62 24.235s2.812 6.236 6.33 6.236m0 2c4.601 0 8.33-3.686 8.33-8.235S72.932 16 68.33 16c-4.6 0-8.33 3.687-8.33 8.235 0 4.549 3.73 8.236 8.33 8.236M60.98 50h17.598c-.019-.345-.05-.768-.104-1.249-.151-1.363-.474-3.162-1.15-4.945-.678-1.786-1.692-3.51-3.198-4.781-1.488-1.257-3.513-2.123-6.324-2.123s-4.836.866-6.324 2.123c-.858.725-1.556 1.596-2.123 2.542l-.074-.196c-.25-.66-.538-1.325-.87-1.981a11.5 11.5 0 0 1 1.777-1.893c1.864-1.574 4.35-2.595 7.614-2.595s5.75 1.02 7.615 2.595c1.845 1.559 3.022 3.61 3.777 5.6s1.105 3.966 1.268 5.433c.082.737.117 1.352.132 1.787a17 17 0 0 1 .01.65v.054l-1-.021 1 .022-.023.978H60.976l.022-.978v-.019l.001-.046v-.17a20 20 0 0 0-.018-.787m-2.195 0h.194zm-3.78.491c1.294-.256 2.412-.45 2.495.297.044.399.497-.043.89-.427a5 5 0 0 1 .395-.361h-3.761a21 21 0 0 0-.019.491M60 51l1 .022z" clip-rule="evenodd" opacity=".11"/><path fill="currentColor" fill-rule="evenodd" d="M45.235 26.235c4.569 0 8.234-3.656 8.234-8.117S49.804 10 45.234 10 37 13.656 37 18.118s3.665 8.117 8.234 8.117m0 2c5.652 0 10.234-4.53 10.234-10.117S50.887 8 45.234 8 35 12.53 35 18.118s4.582 10.117 10.234 10.117M35.988 50h22.991a27 27 0 0 0-.14-1.788c-.188-1.687-.587-3.917-1.428-6.132-.84-2.217-2.105-4.371-3.994-5.967-1.871-1.58-4.412-2.662-7.917-2.662s-6.045 1.082-7.917 2.662c-1.423 1.203-2.492 2.723-3.293 4.348a24.866 24.866 0 0 0-.951-2.408c.782-1.261 1.751-2.452 2.954-3.468 2.247-1.897 5.25-3.134 9.207-3.134s6.96 1.237 9.207 3.134c2.229 1.883 3.657 4.366 4.574 6.786.92 2.422 1.346 4.829 1.545 6.62.1.899.143 1.649.161 2.178a21 21 0 0 1 .013.788l-.001.046v.018l-1-.021 1 .022-.023.978H35.98l.022-.977-1-.023 1 .022V51l.001-.054v-.198a25 25 0 0 0-.014-.75m-3.965-.052-.002.052h1.965-2.525q.291-.028.562-.052m-2.01.195.763-.075.685-.068H30.02z" clip-rule="evenodd" opacity=".39"/><path fill="currentColor" fill-rule="evenodd" d="M28.002 12c0 5.523-4.478 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m2 0c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12m3.984 38H2.016c.022-.575.07-1.376.175-2.328.22-2.011.692-4.673 1.684-7.32.994-2.65 2.492-5.236 4.737-7.154C10.84 31.296 13.856 30 18.002 30c4.145 0 7.163 1.296 9.389 3.198 2.245 1.918 3.743 4.503 4.737 7.153.992 2.648 1.463 5.31 1.684 7.32.105.953.153 1.754.174 2.329m2.015 1.022-1-.022zL35.98 52H.024l-.022-.977 1-.023-1 .022V51L0 50.947v-.198c0-.17.003-.417.014-.728.021-.623.071-1.508.188-2.568.232-2.114.73-4.952 1.8-7.804 1.069-2.85 2.727-5.765 5.31-7.972C9.915 29.454 13.397 28 18.002 28c4.604 0 8.087 1.454 10.688 3.677 2.583 2.207 4.241 5.122 5.31 7.972 1.07 2.852 1.568 5.69 1.8 7.804.117 1.06.167 1.945.188 2.568a25 25 0 0 1 .014.926v.075" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" fill="none" id="svg-name-person-check" class="svg-sprite__symbol"><path fill="#F1F1F1" fill-rule="evenodd" d="M9.09 10.076q.357-.676.814-1.282a3.001 3.001 0 1 1 4.078-3.121 9.4 9.4 0 0 1 1.451-.448 4.501 4.501 0 1 0-6.342 4.851m-.884 2.446c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.305.41.8.657 1.342.657H9.58a9.5 9.5 0 0 1-.812-1.5H3.205c-.086 0-.127-.037-.138-.052l-.005-.008q0-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.691-.512 1.577-.972 2.712-1.272q.035-.814.198-1.587M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#262626" d="M15.294 15.06a.75.75 0 0 0-.588 1.38zM17.937 17l-.293.69a.75.75 0 0 0 .987-.404zm2.756-4.714a.75.75 0 1 0-1.386-.572zm-5.987 4.154 2.938 1.25.587-1.38-2.937-1.25zm3.925.846 2.062-5-1.386-.572-2.063 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-minus" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" fill-rule="evenodd" d="M10.313 11.253 10 11.25c-1.19 0-2.245.13-3.179.36-3.782.925-5.446 3.413-6.124 4.95a1.52 1.52 0 0 0 .166 1.534c.306.41.801.656 1.341.656h8.112a6 6 0 0 1-.88-1.5H2.204c-.085 0-.127-.037-.138-.052l-.004-.007q-.001-.005.008-.026c.55-1.25 1.908-3.316 5.108-4.099.663-.162 1.41-.27 2.253-.305.22-.547.52-1.054.882-1.508" clip-rule="evenodd"/><circle cx="15" cy="15" r="4" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 15h4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M10 12c-5.68 0-7.848 3.12-8.616 4.86-.252.574.195 1.14.82 1.14h15.591c.626 0 1.073-.566.82-1.14C17.849 15.12 15.68 12 10 12Z"/><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-plus" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.7 12H13m2.7 0V9.308m0 2.692v2.692m0-2.692h2.8"/><path fill="currentColor" fill-rule="evenodd" d="M4.296 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.005.008c.011.015.052.052.138.052h15.59c.085 0 .126-.037.137-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.455-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.306.411-.801.658-1.342.658H2.205c-.541 0-1.037-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.496.737-5.704 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-with-coins" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 9.032A4.5 4.5 0 1 1 14.5 5v.01a12 12 0 0 0-1.5.033V5a3 3 0 1 0-4.83 2.378 1.7 1.7 0 0 0-.17.744zm0 2.352q-.619.088-1.179.225c-3.782.926-5.446 3.414-6.124 4.95a1.52 1.52 0 0 0 .166 1.535c.306.41.801.656 1.341.656H8.02a1 1 0 0 1-.02-.203V17.25H2.204c-.085 0-.127-.037-.138-.052l-.004-.007q-.001-.005.008-.026c.55-1.25 1.908-3.316 5.108-4.099q.39-.097.822-.165z" clip-rule="evenodd"/><ellipse cx="14" cy="10" stroke="currentColor" stroke-width="1.5" rx="4" ry="2"/><path stroke="currentColor" stroke-width="1.5" d="M18 13c0 1.105-1.79 2-4 2s-4-.895-4-2"/><path stroke="currentColor" stroke-width="1.5" d="M10 9.75v6.929c0 .867 1.79 1.571 4 1.571s4-.704 4-1.571V9.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-personalization" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.9 9.992c0 2.84-3.76 5.143-8.4 5.143s-8.4-2.302-8.4-5.143S5.86 4.85 10.5 4.85s8.4 2.302 8.4 5.142" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.6 9.99c.026.731-.368 1.417-1.029 1.79a2.19 2.19 0 0 1-2.142 0c-.66-.373-1.055-1.059-1.029-1.79-.026-.73.369-1.416 1.03-1.789a2.19 2.19 0 0 1 2.141 0c.66.373 1.055 1.059 1.03 1.79" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-picture" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-width="1.5" d="m4 19 2.781-4.768a1 1 0 0 1 1.632-.136l.665.798a1 1 0 0 0 1.636-.144l2.511-4.395a1 1 0 0 1 1.682-.085L19 16"/><circle cx="7" cy="7" r="2.25" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-picture_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M9 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/><path fill="currentColor" fill-rule="evenodd" d="M9.462 3h5.076c.948 0 1.714 0 2.334.05.64.053 1.203.163 1.726.43a4.4 4.4 0 0 1 1.922 1.922c.267.523.377 1.087.43 1.726.05.62.05 1.386.05 2.334v5.076c0 .948 0 1.714-.05 2.334-.053.64-.163 1.203-.43 1.726a4.4 4.4 0 0 1-1.922 1.922c-.523.267-1.087.377-1.726.43-.62.05-1.386.05-2.334.05H9.462c-.948 0-1.714 0-2.334-.05-.64-.053-1.203-.163-1.726-.43a4.4 4.4 0 0 1-1.922-1.922c-.267-.523-.377-1.087-.43-1.726C3 16.252 3 15.486 3 14.538V9.462c0-.948 0-1.714.05-2.334.053-.64.163-1.203.43-1.726A4.4 4.4 0 0 1 5.402 3.48c.523-.267 1.087-.377 1.726-.43C7.748 3 8.514 3 9.462 3M7.275 4.845c-.528.043-.83.123-1.055.238A2.6 2.6 0 0 0 5.083 6.22c-.115.226-.195.527-.238 1.055C4.8 7.813 4.8 8.505 4.8 9.5v5c0 .995 0 1.687.045 2.226l.011.126 2.893-2.893c.18-.18.352-.352.509-.485.17-.145.381-.296.654-.384a1.9 1.9 0 0 1 1.177.002c.273.09.483.241.654.386.155.134.326.306.506.488l.754.759 2.76-2.76c.18-.18.351-.352.507-.484.17-.145.38-.295.653-.384a1.9 1.9 0 0 1 1.174 0c.272.089.482.24.653.384.156.132.327.303.507.483l.943.944V9.5c0-.995 0-1.687-.045-2.226-.043-.527-.123-.828-.238-1.054a2.6 2.6 0 0 0-1.137-1.137c-.226-.115-.527-.195-1.055-.238-.538-.044-1.23-.045-2.225-.045h-5c-.995 0-1.687 0-2.226.045M6.22 18.917a2.6 2.6 0 0 1-.527-.356L9 15.253c.209-.21.328-.328.421-.407q.045-.037.06-.047a.1.1 0 0 1 .03 0q.016.01.06.047c.094.08.212.198.42.409l1.37 1.379a.9.9 0 0 0 1.274.002l3.379-3.378c.208-.208.327-.326.42-.405l.06-.047a.1.1 0 0 1 .03 0l.06.047c.093.079.211.197.42.405l2.193 2.193c-.004.515-.014.927-.043 1.274-.043.528-.123.83-.238 1.055a2.6 2.6 0 0 1-1.137 1.137c-.226.115-.527.195-1.055.238-.538.044-1.23.045-2.225.045h-5c-.995 0-1.687 0-2.226-.045-.527-.043-.828-.123-1.054-.238" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pin_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11.332 2.604a.75.75 0 0 1 1.266-.384l5.182 5.183a.75.75 0 0 1-.383 1.265l-1.54.308a.3.3 0 0 0-.152.082l-2.463 2.463a.3.3 0 0 0-.086.187l-.297 3.858c-.065.853-1.105 1.258-1.724.638l-3.139-3.139-4.716 4.716a.75.75 0 0 1-1.133-.977l4.788-4.8-3.139-3.138c-.6-.601-.245-1.632.638-1.725l3.859-.296a.3.3 0 0 0 .187-.086l2.463-2.464a.3.3 0 0 0 .081-.151zm1.196 1.668c-.08.409-.192.748-.524 1.084L9.54 7.819a1.8 1.8 0 0 1-1.133.521l-2.801.216 5.837 5.837.216-2.8c.034-.437.23-.815.521-1.133l2.464-2.463c.302-.302.644-.458 1.083-.525z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pin_slash_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.965 8.15a.75.75 0 0 1-.57.519l-1.567.315a.25.25 0 0 0-.134.075c-.224.241-.457.472-.69.705a.75.75 0 0 1-1.06-1.06l.65-.665c.25-.269.578-.453.938-.525l.194-.04-3.2-3.198-.036.182a1.75 1.75 0 0 1-.48.901l-.708.706a.75.75 0 0 1-1.057-1.064l.704-.702a.25.25 0 0 0 .069-.13l.306-1.563a.75.75 0 0 1 1.266-.386l5.187 5.183a.75.75 0 0 1 .188.747M7.996 13.065l3.139 3.14c.607.606 1.616.23 1.719-.586.084-.835.13-1.674.194-2.51l1.672 1.671a.75.75 0 1 0 1.06-1.06l-9.5-9.5a.75.75 0 1 0-1.06 1.06l1.67 1.67c-.845.067-1.718.076-2.555.206-.81.157-1.116 1.132-.539 1.71l3.139 3.138-4.788 4.8a.75.75 0 0 0 1.133.977zm3.448 1.33.208-2.682-3.369-3.369-2.67.212z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pinned" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.741 15.655 2.957-2.957 2.957-2.957c.667-.688.77-1.746.248-2.55a3.03 3.03 0 0 0-2.415-1.506c-1.357.027-2.909.3-3.877-.67L6.084 1.489a1.64 1.64 0 0 0-2.314-.02L1.469 3.767a1.64 1.64 0 0 0 .019 2.315l3.528 3.531c.968.969.694 2.52.668 3.877a3.03 3.03 0 0 0 1.507 2.414 2.06 2.06 0 0 0 2.55-.248Z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m12.698 12.7 6.3 6.3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pinned-crossed" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.616.96a2.39 2.39 0 0 0-3.37-.027h-.001L3.24.938.94 3.235l-.006.006a2.39 2.39 0 0 0 .026 3.371l3.526 3.53c.303.303.447.724.49 1.317.03.413.01.812-.011 1.252a25 25 0 0 0-.029.809l1.554-1.68a7 7 0 0 0-.018-.49c-.056-.763-.26-1.602-.925-2.268L2.018 5.55l-.003-.003a.89.89 0 0 1-.013-1.253l2.295-2.292a.89.89 0 0 1 1.254.013l.003.003L9.08 5.546c.665.666 1.505.87 2.268.925l.1.007 1.407-1.52q-.072.002-.14.006c-.442.022-.844.042-1.258.011-.593-.043-1.014-.187-1.316-.49zm8.063 4.236L13.527 6.44a2.28 2.28 0 0 1 1.747 1.158c.33.51.266 1.179-.154 1.616l-2.919 2.92a1 1 0 0 0-.063.062L9.215 15.12a1.31 1.31 0 0 1-1.648.134 2.28 2.28 0 0 1-1.026-1.262l-1.1 1.19A3.8 3.8 0 0 0 6.8 16.544a2.81 2.81 0 0 0 3.463-.35l.008-.008 2.43-2.43 5.768 5.77a.75.75 0 1 0 1.06-1.06l-5.768-5.77 2.425-2.425.008-.008a2.81 2.81 0 0 0 .35-3.463 3.78 3.78 0 0 0-1.865-1.604" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.807 2.68 3.333 18.326"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-pinned-filled" class="svg-sprite__symbol"><path fill="currentColor" d="m8.235.106 3.657 3.663c.225.226.064.633-.263.633h-.523a.9.9 0 0 0-.633.263L8.758 6.38a.9.9 0 0 0-.262.633v2.996c0 .554-.7.858-1.1.456l-2.301-2.3-3.57 3.57A.893.893 0 1 1 .26 10.473L3.83 6.898l-2.29-2.29c-.391-.392-.109-1.102.456-1.102H4.99a.9.9 0 0 0 .633-.262L7.338 1.53a.9.9 0 0 0 .263-.634V.37c0-.32.403-.495.634-.263"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="svg-name-play" class="svg-sprite__symbol"><path d="M7.5 7.662A4.574 4.574 0 0 0 3 12.307v3.318a4.574 4.574 0 0 0 4.5 4.645h9a4.574 4.574 0 0 0 4.5-4.645v-3.318a4.574 4.574 0 0 0-4.5-4.645z" style="fill-rule:evenodd;clip-rule:evenodd;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round"/><path fill="currentColor" d="M11.23 7a.75.75 0 0 0 1.5 0zm.007-2.916.204-.722-.02-.005zm-.921-.104v.75h.017zM9.76 2a.75.75 0 1 0-1.5 0zM8.036 15.626a.75.75 0 0 0 1.5 0zm1.5-1.99a.75.75 0 0 0-1.5 0zm-1.5 0a.75.75 0 0 0 1.5 0zm1.5-1.991a.75.75 0 0 0-1.5 0zm-.75 1.241a.75.75 0 0 0 0 1.5zm1.928 1.5a.75.75 0 0 0 0-1.5zm-1.928 0a.75.75 0 0 0 0-1.5zm-1.929-1.5a.75.75 0 0 0 0 1.5zm7.176-.435a.75.75 0 1 0 1.077 1.044zm2.363-.283a.75.75 0 1 0-1.078-1.044zm-1.078 2.942a.75.75 0 1 0 1.077 1.044zm2.363-.283a.75.75 0 1 0-1.077-1.044zM12.73 7c0-.459.056-1.248-.017-1.86-.072-.607-.316-1.51-1.271-1.778l-.407 1.444c.002 0 .128.002.188.51.06.5.007 1.034.007 1.684zm-1.308-3.643a4.2 4.2 0 0 0-1.123-.127l.035 1.5a2.7 2.7 0 0 1 .72.08zm-1.105-.127c-.292 0-.411-.057-.448-.08-.023-.015-.045-.034-.068-.1a1.4 1.4 0 0 1-.05-.41 7 7 0 0 1 .004-.302c.003-.103.007-.224.007-.338h-1.5c0 .087-.003.18-.006.296-.003.11-.006.235-.005.364.004.25.025.567.132.876.112.327.32.652.685.882.351.222.777.312 1.249.312zm-.78 12.396v-1.99h-1.5v1.99zm0-1.99v-1.991h-1.5v1.991zm-.75.75h1.928v-1.5H8.786zm0-1.5H6.857v1.5h1.929zm6.324.609 1.286-1.327-1.078-1.044-1.285 1.327zm1.286 2.659 1.285-1.327-1.077-1.044-1.286 1.327z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-play-audio" class="svg-sprite__symbol"><path stroke="#fff" stroke-width="1.5" d="M3 14.764V5.236a2 2 0 0 1 2.894-1.789l9.528 4.764c1.474.737 1.474 2.84 0 3.578l-9.528 4.764A2 2 0 0 1 3 14.763Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none" id="svg-name-play-outlined" class="svg-sprite__symbol"><path stroke="#fff" stroke-width="2" d="M3.8 29.153V8.466c0-2.184 2.26-3.636 4.246-2.73l20.688 9.437c2.25 1.026 2.361 4.183.188 5.365L8.234 31.788c-1.999 1.088-4.433-.36-4.433-2.635Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-play-superellipse-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.984 6.965 4.516 3.069a.953.953 0 0 1 0 1.645l-4.516 3.358c-.857.58-2.154.085-2.154-.823V7.785c0-.904 1.299-1.401 2.154-.82" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 9.571v2.858A8.57 8.57 0 0 0 9.571 21h2.858A8.57 8.57 0 0 0 21 12.429V9.57A8.57 8.57 0 0 0 12.429 1H9.57A8.57 8.57 0 0 0 1 9.571" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-play-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M17.671 10.923c.82.483.82 1.67 0 2.154l-8.787 5.175A1.25 1.25 0 0 1 7 17.174V6.826a1.25 1.25 0 0 1 1.884-1.078z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-playlist" class="svg-sprite__symbol"><g fill="currentColor" clip-path="url(#a)"><path d="M19.684 11.432a.67.67 0 0 1 0 1.136l-4.737 2.843c-.42.253-.947-.063-.947-.568V9.157c0-.505.526-.82.947-.568zM2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75M2 9.75A.75.75 0 0 1 2.75 9h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 2 9.75M2 14.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-plus-default" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.93 9a1 1 0 1 0 0 2H9v6.071a1 1 0 1 0 2 0V11h6.072a1 1 0 1 0 0-2h-6.071V2.929a1 1 0 1 0-2 0V9z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="8" height="20" fill="none" id="svg-name-pointer" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 10c0 3-8 6-8 10V0c0 3.975 8 7 8 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" id="svg-name-poll" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.375h10.5M2.75 10.375h14.5M2.75 15.375h8.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-poll_icons" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7.5 17a1.5 1.5 0 0 0 0-3h-3a1.5 1.5 0 0 0 0 3zM11.5 11a1.5 1.5 0 0 0 0-3h-7a1.5 1.5 0 0 0 0 3z"/><path fill="currentColor" stroke="currentColor" stroke-width="1.5" d="M15.5 5a1.5 1.5 0 0 0 0-3h-11a1.5 1.5 0 1 0 0 3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-poll_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10.75 6.413a.75.75 0 0 0-1.5 0v7.175a.75.75 0 0 0 1.5 0zM6.5 8.288a.75.75 0 0 1 .75.75v4.55a.75.75 0 0 1-1.5 0v-4.55a.75.75 0 0 1 .75-.75M14.25 10.788a.75.75 0 0 0-1.5 0v2.8a.75.75 0 0 0 1.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M3.752 1.983c.794-.425 1.57-.608 3.376-.608h5.744c1.806 0 2.582.183 3.376.608a4.26 4.26 0 0 1 1.769 1.769c.425.794.608 1.57.608 3.376v5.744c0 1.806-.183 2.582-.608 3.376a4.26 4.26 0 0 1-1.769 1.769c-.794.425-1.57.608-3.376.608H7.128c-1.806 0-2.582-.183-3.376-.608a4.26 4.26 0 0 1-1.769-1.769c-.425-.794-.608-1.57-.608-3.376V7.128c0-1.806.183-2.582.608-3.376a4.26 4.26 0 0 1 1.769-1.769m3.376.892c-1.69 0-2.185.172-2.669.43q-.751.404-1.153 1.154c-.26.484-.431.979-.431 2.669v5.744c0 1.69.172 2.185.43 2.669q.404.751 1.154 1.153c.484.26.979.431 2.669.431h5.744c1.69 0 2.185-.172 2.669-.43a2.76 2.76 0 0 0 1.153-1.154c.26-.484.431-.979.431-2.669V7.128c0-1.69-.172-2.185-.43-2.669a2.76 2.76 0 0 0-1.154-1.153c-.484-.26-.979-.431-2.669-.431z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-poll_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M10.692 5c-2.137 0-2.897.147-3.68.565a3.45 3.45 0 0 0-1.447 1.448C5.147 7.795 5 8.555 5 10.692v6.616c0 2.137.147 2.898.565 3.68q.504.942 1.448 1.447c.782.418 1.542.565 3.679.565h6.616c2.137 0 2.898-.147 3.68-.565a3.45 3.45 0 0 0 1.447-1.448c.418-.781.565-1.542.565-3.679v-6.616c0-2.137-.147-2.897-.565-3.68a3.45 3.45 0 0 0-1.448-1.447C20.206 5.147 19.445 5 17.308 5zm0-2h6.616c2.675 0 3.645.278 4.622.801A5.45 5.45 0 0 1 24.2 6.07c.522.978.801 1.948.801 4.623v6.616c0 2.675-.279 3.645-.801 4.622A5.45 5.45 0 0 1 21.93 24.2c-.977.522-1.947.801-4.622.801h-6.616c-2.675 0-3.645-.279-4.623-.801a5.45 5.45 0 0 1-2.268-2.269C3.278 20.954 3 19.984 3 17.309v-6.616c0-2.675.278-3.645.801-4.623A5.45 5.45 0 0 1 6.07 3.801C7.047 3.278 8.017 3 10.692 3M11 19a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0zm4 0a1 1 0 1 1-2 0V9a1 1 0 1 1 2 0zm4 0a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-poo-reaction" class="svg-sprite__symbol"><path fill="url(#a)" d="M25.966 20.514c3.037-5.605-3.31-6.787-3.31-6.787 1.801-5.605-3.803-6.143-3.803-6.143.732-2.198-3.83-4.555-3.24-5.923.212-.52-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963-.009.46-4.034.415-3.698 5.632.017.264-.08.503-.327.608-2.957 1.245-3.08 4.775-2.577 5.914 0 0 .132-.009-.062.009C.865 20.505 0 22.632 0 24.345c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.511-4.034-4.511"/><path fill="url(#b)" d="M25.966 20.514c3.037-5.605-3.31-6.787-3.31-6.787 1.801-5.605-3.803-6.143-3.803-6.143.732-2.198-3.83-4.555-3.24-5.923.212-.52-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963-.009.46-4.034.415-3.698 5.632.017.264-.08.503-.327.608-2.957 1.245-3.08 4.775-2.577 5.914 0 0 .132-.009-.062.009C.865 20.505 0 22.632 0 24.345c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.511-4.034-4.511"/><path fill="url(#c)" d="M22.657 13.727c1.8-5.605-3.804-6.143-3.804-6.143.732-2.198-3.725-4.44-3.24-5.923.177-.538-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.964-.009.458-4.034.414-3.698 5.63.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778"/><path fill="url(#d)" d="M22.657 13.727c1.8-5.605-3.804-6.143-3.804-6.143.732-2.198-3.725-4.44-3.24-5.923.177-.538-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.964-.009.458-4.034.414-3.698 5.63.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778"/><path fill="url(#e)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z"/><path fill="url(#f)" d="M11.412 4.145c-1.041 1.482-1.341 3.045-1.35 3.962 0 0-.477 5.526 12.595 5.623-10.142-.618-13.169-5.305-11.245-9.585"/><path fill="url(#g)" d="M25.968 20.515c.468-.91.698-1.704.768-2.392-.768 2.392-7.387 2.533-12.798.362-4.819-1.933-7.228-4.59-7.51-6.4a7.7 7.7 0 0 0-.054 1.66c.018.265-.07.521-.326.61 2.462.238 4.74 7.28 19.92 6.16"/><path fill="url(#h)" d="M3.339 20.276c.044-.01.088-.01.123-.018-.017 0-.035 0-.053.009-.026 0-.052.009-.07.009"/><path fill="url(#i)" d="M18.853 7.584c.732-2.198-3.76-4.475-3.24-5.923.186-.53-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963 0 0-.477 5.526 12.595 5.623 1.8-5.605-3.804-6.143-3.804-6.143" opacity=".5"/><path fill="url(#j)" d="M18.853 7.584c.732-2.198-3.76-4.475-3.24-5.923.186-.53-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963 0 0-.477 5.526 12.595 5.623 1.8-5.605-3.804-6.143-3.804-6.143" opacity=".5"/><path fill="url(#k)" d="M15.058 5.74c.75 1.651 3.795 1.845 3.795 1.845.653-1.95-2.807-3.963-3.24-5.401.01 0-1.252 2.012-.555 3.557Z"/><path fill="url(#l)" d="M15.058 5.74c.75 1.651 3.795 1.845 3.795 1.845.653-1.95-2.807-3.963-3.24-5.401.01 0-1.252 2.012-.555 3.557Z"/><path fill="url(#m)" d="M22.657 13.728C9.594 13.63 10.062 8.105 10.062 8.105c-.009.46-4.034.415-3.698 5.631.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778" opacity=".5"/><path fill="url(#n)" d="M6.374 13.738c.018.265-.079.503-.326.61.247-.089.344-.345.326-.61"/><path fill="url(#o)" d="M25.966 20.516c-15.172 1.13-16.637-6.16-19.92-6.16-2.957 1.244-3.08 4.774-2.577 5.913 0 0 .132-.009-.062.009C.865 20.508 0 22.634 0 24.347c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.51-4.034-4.51Z" opacity=".5"/><path fill="url(#p)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z"/><path fill="url(#q)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z" opacity=".24"/><path fill="url(#r)" d="M25.966 20.325c-15.172 1.13-16.637-6.16-19.92-6.16-2.957 1.244-3.08 4.774-2.577 5.913 0 0 .132-.01-.062.008C.865 20.316 0 22.443 0 24.156c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.335 12.304.335h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.51-4.034-4.51" opacity=".24"/><path fill="url(#s)" d="M16.152 15.269c0 1.933 1.43 3.495 3.195 3.495 1.766 0 3.195-1.562 3.195-3.495s-1.43-3.292-3.195-3.292-3.195 1.359-3.195 3.292" opacity=".75"/><path fill="url(#t)" d="M16.152 15.71c0 1.933 1.43 3.495 3.195 3.495 1.766 0 3.195-1.562 3.195-3.495s-1.43-3.222-3.195-3.222-3.195 1.289-3.195 3.222" opacity=".75"/><path fill="url(#u)" d="M7.458 15.269c0 1.933 1.43 3.495 3.195 3.495s3.195-1.562 3.195-3.495-1.43-3.292-3.195-3.292-3.195 1.359-3.195 3.292" opacity=".75"/><path fill="url(#v)" d="M7.458 15.71c0 1.933 1.43 3.495 3.195 3.495s3.195-1.562 3.195-3.495-1.43-3.222-3.195-3.222-3.195 1.289-3.195 3.222" opacity=".75"/><path fill="url(#w)" d="M19.355 18.765a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#fff" d="M20.928 18.138a2.957 2.957 0 1 0-3.145-5.007 2.957 2.957 0 0 0 3.145 5.007"/><path fill="url(#x)" d="M19.355 18.597a2.957 2.957 0 1 0 0-5.913 2.957 2.957 0 0 0 0 5.913"/><path fill="url(#y)" d="M19.355 18.597a2.957 2.957 0 1 0 0-5.913 2.957 2.957 0 0 0 0 5.913"/><path fill="url(#z)" d="M19.355 18.831a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#282828" d="M19.356 17.106a1.465 1.465 0 1 0 0-2.93 1.465 1.465 0 0 0 0 2.93"/><path fill="url(#A)" d="M19.357 16.661a1.79 1.79 0 0 0 1.42-.688 1.465 1.465 0 0 1-1.42 1.138 1.45 1.45 0 0 1-1.421-1.138c.326.414.838.688 1.42.688Z"/><path fill="url(#B)" d="M15.004 24.89c-4.069 0-5.366-4.361-4.13-3.681 1.659.918 2.718 1.006 4.13 1.006s2.463-.088 4.13-1.006c1.236-.68-.061 3.68-4.13 3.68Z"/><path fill="url(#C)" d="M19.133 21.21c-1.659.918-2.718 1.006-4.13 1.006s-2.463-.088-4.131-1.006c-.432-.238-.556.132-.362.724 0-.01.062-.645.645-.203 0 0 2.144 1.288 3.839 1.288s3.84-1.288 3.84-1.288c.582-.433.643.194.643.203.212-.583.089-.962-.344-.724"/><path fill="url(#D)" d="M10.651 18.765a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#fff" d="M12.222 18.068a2.957 2.957 0 1 0-3.145-5.008 2.957 2.957 0 0 0 3.145 5.008"/><path fill="url(#E)" d="M10.648 18.519a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914"/><path fill="url(#F)" d="M10.648 18.519a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914"/><path fill="url(#G)" d="M10.647 18.761a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#282828" d="M10.648 17.036a1.465 1.465 0 1 0 0-2.93 1.465 1.465 0 0 0 0 2.93"/><path fill="url(#H)" d="M10.65 16.661a1.79 1.79 0 0 0 1.42-.688 1.464 1.464 0 0 1-1.42 1.138 1.45 1.45 0 0 1-1.421-1.138 1.83 1.83 0 0 0 1.42.688Z"/><defs><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(-3.447 9.77356 -25.5089 -8.99662 8.54 32.728)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(12.73596 .405 -.18493 5.81554 25.326 22.54)" gradientUnits="userSpaceOnUse"><stop stop-color="#835129"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="rotate(28.78 -21.144 25.611)scale(12.4888 6.73295)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="matrix(8.09258 3.72092 -1.74778 3.80123 18.995 8.161)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="matrix(13.2128 0 0 13.2564 10.453 -1.967)" gradientUnits="userSpaceOnUse"><stop stop-color="#835129"/><stop offset="1" stop-color="#7D4D26"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="matrix(11.0135 0 0 11.0498 19.856 9.121)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="rotate(18.953 -58.298 43.647)scale(11.8019 4.34689)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="o" cx="0" cy="0" r="1" gradientTransform="matrix(14.21988 4.88325 -1.48392 4.32113 .937 15.155)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="matrix(4.01865 -5.39556 10.47373 7.8009 11.014 20.572)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="q" cx="0" cy="0" r="1" gradientTransform="matrix(.67822 -2.88732 10.77483 2.53096 4.308 24.256)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="r" cx="0" cy="0" r="1" gradientTransform="matrix(-7.47939 .07454 -.0281 -2.82048 25.175 22.463)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="s" cx="0" cy="0" r="1" gradientTransform="matrix(-3.17864 0 0 -3.47566 19.25 13.858)" gradientUnits="userSpaceOnUse"><stop stop-color="#362501" stop-opacity=".4"/><stop offset="1" stop-color="#362501" stop-opacity="0"/></radialGradient><radialGradient id="t" cx="0" cy="0" r="1" gradientTransform="translate(19.562 16.022)scale(3.35003)" gradientUnits="userSpaceOnUse"><stop stop-color="#3D2A20" stop-opacity=".4"/><stop offset=".167" stop-color="#4B3021" stop-opacity=".5"/><stop offset=".716" stop-color="#734423" stop-opacity=".829"/><stop offset="1" stop-color="#824B24"/></radialGradient><radialGradient id="u" cx="0" cy="0" r="1" gradientTransform="matrix(-3.17864 0 0 -3.47566 10.556 13.858)" gradientUnits="userSpaceOnUse"><stop stop-color="#362501" stop-opacity=".4"/><stop offset="1" stop-color="#362501" stop-opacity="0"/></radialGradient><radialGradient id="v" cx="0" cy="0" r="1" gradientTransform="translate(10.867 16.022)scale(3.35003)" gradientUnits="userSpaceOnUse"><stop stop-color="#3D2A20" stop-opacity=".4"/><stop offset=".167" stop-color="#4B3021" stop-opacity=".5"/><stop offset=".716" stop-color="#734423" stop-opacity=".829"/><stop offset="1" stop-color="#824B24"/></radialGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="scale(3.75793 3.71271)rotate(90 .42 4.73)" gradientUnits="userSpaceOnUse"><stop stop-color="#CFDCDE" stop-opacity="0"/><stop offset=".887" stop-color="#CFDCDE" stop-opacity=".887"/><stop offset="1" stop-color="#CFDCDE"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(-3.1903 0 0 -3.19031 19.385 15.843)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity="0"/><stop offset=".438" stop-color="#FDFEFE" stop-opacity=".35"/><stop offset=".595" stop-color="#F6F8F9" stop-opacity=".476"/><stop offset=".708" stop-color="#EBEFF0" stop-opacity=".566"/><stop offset=".798" stop-color="#DAE2E3" stop-opacity=".638"/><stop offset=".875" stop-color="#C4D1D3" stop-opacity=".7"/><stop offset=".9" stop-color="#BBCACC" stop-opacity=".72"/><stop offset="1" stop-color="#99AFB3"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="rotate(180 9.665 7.817)scale(3.24284)" gradientUnits="userSpaceOnUse"><stop offset=".883" stop-color="#643800" stop-opacity="0"/><stop offset=".916" stop-color="#3C2200" stop-opacity=".5"/><stop offset=".987" stop-color="#643800" stop-opacity="0"/></radialGradient><radialGradient id="E" cx="0" cy="0" r="1" gradientTransform="matrix(0 3.7127 -3.75794 0 10.652 15.92)" gradientUnits="userSpaceOnUse"><stop stop-color="#CFDCDE" stop-opacity="0"/><stop offset=".887" stop-color="#CFDCDE" stop-opacity=".887"/><stop offset="1" stop-color="#CFDCDE"/></radialGradient><radialGradient id="F" cx="0" cy="0" r="1" gradientTransform="rotate(180 5.343 7.882)scale(3.1903)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity="0"/><stop offset=".438" stop-color="#FDFEFE" stop-opacity=".35"/><stop offset=".595" stop-color="#F6F8F9" stop-opacity=".476"/><stop offset=".708" stop-color="#EBEFF0" stop-opacity=".566"/><stop offset=".798" stop-color="#DAE2E3" stop-opacity=".638"/><stop offset=".875" stop-color="#C4D1D3" stop-opacity=".7"/><stop offset=".9" stop-color="#BBCACC" stop-opacity=".72"/><stop offset="1" stop-color="#99AFB3"/></radialGradient><radialGradient id="G" cx="0" cy="0" r="1" gradientTransform="rotate(180 5.315 7.782)scale(3.24284)" gradientUnits="userSpaceOnUse"><stop offset=".883" stop-color="#643800" stop-opacity="0"/><stop offset=".916" stop-color="#3C2200" stop-opacity=".5"/><stop offset=".987" stop-color="#643800" stop-opacity="0"/></radialGradient><linearGradient id="a" x1="17.349" x2="13.704" y1="15.388" y2="29.705" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#906338"/><stop offset="1" stop-color="#906338"/></linearGradient><linearGradient id="c" x1="15.835" x2="17.828" y1="21.181" y2="3.396" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#976D42"/><stop offset="1" stop-color="#835129"/></linearGradient><linearGradient id="e" x1="10.254" x2="12.845" y1="12.156" y2="28.379" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#895A31"/><stop offset="1" stop-color="#976A40"/></linearGradient><linearGradient id="f" x1="16.613" x2="14.883" y1="9.227" y2="19.455" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="g" x1="7.131" x2="23.381" y1="23.813" y2="10.334" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#835129"/></linearGradient><linearGradient id="h" x1="5.754" x2=".389" y1="13.148" y2="29.35" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="k" x1="15.71" x2="19.488" y1="6.712" y2="2.192" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#7A4400"/><stop offset="1" stop-color="#A66C3F"/></linearGradient><linearGradient id="w" x1="21.414" x2="19.076" y1="30.595" y2="13.56" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="A" x1="19.352" x2="19.352" y1="15.35" y2="17.557" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1"/></linearGradient><linearGradient id="B" x1="15.004" x2="15.004" y1="24.451" y2="21.913" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#EEEEEF"/><stop offset="1" stop-color="#E2D8CC"/></linearGradient><linearGradient id="C" x1="15.002" x2="15.002" y1="23.305" y2="14.655" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#D5D5D5"/><stop offset="1"/></linearGradient><linearGradient id="D" x1="12.718" x2="10.379" y1="30.595" y2="13.56" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="H" x1="10.654" x2="10.654" y1="15.35" y2="17.557" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-portal" class="svg-sprite__symbol"><path fill="url(#a)" d="M3 9.25a.75.75 0 0 0 0 1.5zm14 1.5a.75.75 0 0 0 0-1.5zM4.75 6.582a.75.75 0 0 0 0 1.5zm10.5 1.5a.75.75 0 0 0 0-1.5zM6.5 3.918a.75.75 0 0 0 0 1.5zm7 1.5a.75.75 0 0 0 0-1.5zM8.25 1.25a.75.75 0 0 0 0 1.5zm3.5 1.5a.75.75 0 0 0 0-1.5zm3.5 10.668a.75.75 0 0 0 0-1.5zm-10.5-1.5a.75.75 0 0 0 0 1.5zm8.75 4.164a.75.75 0 0 0 0-1.5zm-7-1.5a.75.75 0 0 0 0 1.5zm5.25 4.168a.75.75 0 0 0 0-1.5zm-3.5-1.5a.75.75 0 0 0 0 1.5zM3 10.75h14v-1.5H3zm1.75-2.668h10.5v-1.5H4.75zM6.5 5.418h7v-1.5h-7zM8.25 2.75h3.5v-1.5h-3.5zm7 9.168H4.75v1.5h10.5zm-1.75 2.664h-7v1.5h7zm-1.75 2.668h-3.5v1.5h3.5z"/><defs><linearGradient id="a" x1="3" x2="17" y1="10" y2="10" gradientUnits="userSpaceOnUse"><stop stop-color="#37C0FD"/><stop offset=".718" stop-color="#825FED"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-profile" class="svg-sprite__symbol"><path fill="currentColor" d="M7.5 3.75a.75.75 0 0 0 0-1.5zm5-1.5a.75.75 0 0 0 0 1.5zM1.062 7.218l.74.117zm17.876 0 .741-.117zm-4.156-4.156.117-.741zM5.218 18.938l.117-.74zm-4.156-4.156.74-.117zm13.72 4.156.117.741zM7 19.75h6v-1.5H7zM19.75 13V9h-1.5v4zM7.5 2.25H7v1.5h.5zm5.5 0h-.5v1.5h.5zM.25 9v4h1.5V9zM7 2.25c-.9 0-1.438-.002-1.9.07l.235 1.482c.316-.05.707-.052 1.665-.052zM1.75 9c0-.958.002-1.35.052-1.665L.321 7.101C.248 7.562.25 8.1.25 9zM5.1 2.32A5.75 5.75 0 0 0 .32 7.1l1.482.235a4.25 4.25 0 0 1 3.533-3.533zM19.75 9c0-.9.002-1.438-.07-1.9l-1.482.235c.05.316.052.707.052 1.665zM13 3.75c.958 0 1.35.002 1.665.052l.235-1.481c-.462-.073-1-.071-1.9-.071zm6.68 3.35a5.75 5.75 0 0 0-4.78-4.78l-.235 1.482a4.25 4.25 0 0 1 3.533 3.533zM7 18.25c-.958 0-1.35-.002-1.665-.052l-.234 1.481c.461.073.999.071 1.899.071zM.25 13c0 .9-.002 1.438.07 1.9l1.482-.235c-.05-.316-.052-.707-.052-1.665zm5.085 5.198a4.25 4.25 0 0 1-3.533-3.533L.321 14.9a5.75 5.75 0 0 0 4.78 4.78zM13 19.75c.9 0 1.438.002 1.9-.07l-.235-1.482c-.316.05-.707.052-1.665.052zM18.25 13c0 .958-.002 1.35-.052 1.665l1.481.235c.073-.462.071-1 .071-1.9zm-3.35 6.68a5.75 5.75 0 0 0 4.78-4.78l-1.482-.235a4.25 4.25 0 0 1-3.533 3.533zM9.25 4a.75.75 0 0 0 1.5 0zm1.5-3a.75.75 0 0 0-1.5 0zm0 3V1h-1.5v3zM5 13.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5zM11 7.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM11 10.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4z"/><rect width="3" height="3" x="5" y="8" stroke="currentColor" stroke-width="1.5" rx="1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-profile-with-person" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 5v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 8h3M13 11h3"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M3 14c2.783-3.137 6.052-2.151 8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="21" id="svg-name-qr" class="svg-sprite__symbol"><path fill="currentColor" d="M1.167 0C.523 0 0 .523 0 1.167v4.666C0 6.477.523 7 1.167 7h4.666C6.477 7 7 6.477 7 5.833V1.167C7 .523 6.477 0 5.833 0zm8.166 0v2.333h2.334V0zm5.834 0C14.523 0 14 .523 14 1.167v4.666C14 6.477 14.523 7 15.167 7h4.666C20.477 7 21 6.477 21 5.833V1.167C21 .523 20.477 0 19.833 0zM2.333 2.333h2.334v2.334H2.333zm14 0h2.334v2.334h-2.334zm-7 2.334V7h2.334V4.667zM0 9.333v2.334h2.333V9.333zm4.667 0v2.334H7V9.333zm4.666 0v2.334h2.334V9.333zm2.334 2.334V14H14v-2.333zm2.333 0h2.333V9.333H14zm2.333 0V14h2.334v-2.333zm2.334 0H21V9.333h-2.333zm0 2.333v2.333H21V14zm0 2.333h-2.334v2.334h2.334zm0 2.334V21H21v-2.333zm-2.334 0H14V21h2.333zm-2.333 0v-2.334h-2.333v2.334zm-2.333 0H9.333V21h2.334zm0-2.334V14H9.333v2.333zm2.333 0h2.333V14H14zM1.167 14C.523 14 0 14.523 0 15.167v4.666C0 20.477.523 21 1.167 21h4.666C6.477 21 7 20.477 7 19.833v-4.666C7 14.523 6.477 14 5.833 14zm1.166 2.333h2.334v2.334H2.333z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-qr-small" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M2 1.75a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5A.25.25 0 0 0 7.25 7V2A.25.25 0 0 0 7 1.75zM.25 2C.25 1.034 1.034.25 2 .25h5c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 7 8.75H2A1.75 1.75 0 0 1 .25 7zm3 2.1c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M12.75 2a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25zM13 .25A1.75 1.75 0 0 0 11.25 2v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 19.75 7V2A1.75 1.75 0 0 0 18 .25zm1.25 3.85c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M1.75 13a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25zM2 11.25A1.75 1.75 0 0 0 .25 13v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 8.75 18v-5A1.75 1.75 0 0 0 7 11.25zm1.25 3.85c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112m7.712-4.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.049.063.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112m4.75-.288c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.064.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M15.1 14.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.049.063.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112M11.25 18.1c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.048.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112m5.712-1.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.048.064.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-qr_code_24" class="svg-sprite__symbol"><path fill="currentColor" d="M5.665 8.666c.92 0 1.667.747 1.667 1.667V13c0 .92-.746 1.666-1.667 1.666H3c-.92 0-1.667-.746-1.667-1.666v-2.667c0-.92.746-1.667 1.667-1.667zm8.334 4c.184 0 .333.15.333.334v1c0 .184-.15.333-.333.333h-1a.333.333 0 0 1-.334-.333v-1c0-.184.15-.334.334-.334zm-3.667 0c.184 0 .333.15.333.334v1c0 .184-.149.333-.333.333h-1A.333.333 0 0 1 8.999 14v-1c0-.184.149-.334.333-.334zM5.499 9.833H3.165a.667.667 0 0 0-.666.667v2.333c0 .368.298.667.666.667H5.5a.667.667 0 0 0 .666-.667V10.5a.667.667 0 0 0-.666-.667m6.666 1c.185 0 .334.15.334.333v1c0 .184-.15.334-.334.334h-1a.333.333 0 0 1-.333-.334v-1c0-.184.15-.333.333-.333zm-7.333 0c.184 0 .333.15.333.333v1c0 .184-.149.334-.333.334h-1a.333.333 0 0 1-.333-.334v-1c0-.184.149-.333.333-.333zM13.999 9c.184 0 .333.149.333.333v1c0 .184-.15.333-.333.333h-1a.333.333 0 0 1-.334-.333v-1c0-.184.15-.333.334-.333zm-3.667 0c.184 0 .333.149.333.333v1c0 .184-.149.333-.333.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.149-.333.333-.333zm2.667-7.667c.92 0 1.666.746 1.666 1.667v2.666c0 .92-.746 1.667-1.666 1.667h-2.667c-.92 0-1.667-.746-1.667-1.667V3c0-.92.747-1.667 1.667-1.667zm-7.334 0c.92 0 1.667.746 1.667 1.667v2.666c0 .92-.746 1.667-1.667 1.667H3c-.92 0-1.667-.746-1.667-1.667V3c0-.92.746-1.667 1.667-1.667zM12.832 2.5h-2.333a.667.667 0 0 0-.667.666V5.5c0 .368.298.666.667.666h2.333a.667.667 0 0 0 .667-.666V3.166a.667.667 0 0 0-.667-.666m-7.333 0H3.165a.667.667 0 0 0-.666.666V5.5c0 .368.298.666.666.666H5.5a.667.667 0 0 0 .666-.666V3.166A.667.667 0 0 0 5.5 2.5m6.666 1c.185 0 .334.149.334.333v1c0 .184-.15.333-.334.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.15-.333.333-.333zm-7.333 0c.184 0 .333.149.333.333v1c0 .184-.149.333-.333.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.149-.333.333-.333z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-qr_code_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9.346 15c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078C3.132 23.078 3 22.617 3 21.346v-2.692c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381zm14.192 7c.335 0 .456.035.578.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm-6.5 0c.335 0 .456.035.578.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zM9.52 17H6.654c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 21.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253v-2.692c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143M8.29 18.75c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.577-.1zm12 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm-3.25-3.25c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm6.5 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zM9.346 3c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078C3.132 11.078 3 10.617 3 9.346V6.654c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077C4.922 3.132 5.383 3 6.654 3zm12 0c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381h-2.692c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078c-.249-.464-.381-.925-.381-2.196V6.654c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381zM9.52 5H6.654c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 9.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143m12 0h-2.866c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L17 9.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143M8.29 6.75c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.7.7 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.7.7 0 0 1 .284-.284c.122-.065.243-.1.577-.1zm12 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-radiowaves_left_and_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M7.491 5.697a1 1 0 0 1-.033 1.414l-.033.031-.02.02A9.47 9.47 0 0 0 4.5 14a9.47 9.47 0 0 0 2.935 6.866 1 1 0 0 1-1.383 1.445A11.47 11.47 0 0 1 2.5 14c0-3.163 1.284-6.124 3.516-8.277l.026-.025.035-.034a1 1 0 0 1 1.414.033m13.018 0a1 1 0 0 1 1.45.001l.026.025A11.47 11.47 0 0 1 25.5 14c0 3.18-1.299 6.156-3.552 8.311a1 1 0 0 1-1.383-1.445A9.47 9.47 0 0 0 23.5 14a9.47 9.47 0 0 0-2.904-6.838l-.021-.02-.033-.03a1 1 0 0 1-.033-1.415m-9.671 3.397a1 1 0 0 1-.057 1.413A4.73 4.73 0 0 0 9.25 14c0 1.345.56 2.597 1.53 3.492a1 1 0 1 1-1.356 1.47A6.73 6.73 0 0 1 7.25 14c0-1.91.799-3.694 2.175-4.963a1 1 0 0 1 1.413.057m6.324 0a1 1 0 0 1 1.413-.057A6.73 6.73 0 0 1 20.75 14c0 1.909-.798 3.692-2.174 4.961a1 1 0 1 1-1.356-1.47A4.73 4.73 0 0 0 18.75 14c0-1.346-.56-2.599-1.53-3.493a1 1 0 0 1-.058-1.413M14 11.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" id="svg-name-raid" class="svg-sprite__symbol"><path fill="currentColor" d="M35.358 17.317a.4.4 0 0 0 .083-.258 1 1 0 0 0 0-.159 17.5 17.5 0 0 0-34.917 0q.016.16.042.317a1 1 0 0 0 .058.1.8.8 0 0 0 .109.175l16.666 17.725h.05q.084.075.184.125h.083a.76.76 0 0 0 .6 0h.075a.8.8 0 0 0 .183-.125h.05l16.667-17.725a1 1 0 0 0 .067-.175M17.999 2.167c2.167 0 4.567 4.525 4.825 11.15A6.82 6.82 0 0 0 18 11.592a6.83 6.83 0 0 0-4.8 1.667C13.6 7.8 16.224 2.167 18 2.167Zm4.734 14.892-4.734 14.866-4.733-14.866c.067-2.8 2.575-3.8 4.733-3.8 2.159 0 4.667 1 4.734 3.8m-11.142.108a1 1 0 0 0 0 .125 1 1 0 0 0 0 .125L16.05 31.41 2.3 16.709a4.71 4.71 0 0 1 4.542-3.45c2.192 0 4.75 1.025 4.75 3.908Zm12.775.25a1 1 0 0 0 0-.133 1 1 0 0 0 0-.125c0-2.883 2.558-3.908 4.75-3.908a4.716 4.716 0 0 1 4.542 3.45l-13.75 14.708zM33 12.842a6.4 6.4 0 0 0-3.808-1.25 6.95 6.95 0 0 0-4.667 1.567c-.191-4.542-1.358-8.383-3.058-10.6A15.88 15.88 0 0 1 33 12.842M14.966 2.476c-1.858 2.5-3.142 6.983-3.425 10.708a6.93 6.93 0 0 0-4.7-1.592A6.4 6.4 0 0 0 3 12.842 15.88 15.88 0 0 1 14.966 2.476"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-reaction" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.964 3.418H15.2M12.582.8v5.236"/><path fill="currentColor" d="M13.182 9.31a.6.6 0 0 0-1.2 0zM6.69 4.017a.6.6 0 0 0 0-1.2zm5.29 5.291a5.29 5.29 0 0 1-5.29 5.291v1.2a6.49 6.49 0 0 0 6.49-6.49zM6.692 14.6a5.29 5.29 0 0 1-5.29-5.29H.2a6.49 6.49 0 0 0 6.491 6.49zm-5.29-5.29a5.29 5.29 0 0 1 5.29-5.292v-1.2A6.49 6.49 0 0 0 .2 9.31z"/><path fill="currentColor" d="M3.934 10.312a.6.6 0 1 0-1.032.613zm6.545.613a.6.6 0 0 0-1.031-.613zm-3.788 1.057c-1.125 0-2.146-.642-2.757-1.67l-1.032.613c.796 1.339 2.182 2.257 3.789 2.257zm2.757-1.67c-.611 1.028-1.632 1.67-2.757 1.67v1.2c1.607 0 2.993-.918 3.788-2.257zM5.382 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0M9.31 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-recent_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M18.5 10a8.5 8.5 0 1 0-17 0 8.5 8.5 0 0 0 17 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.75 6a.75.75 0 0 1 .75.75v3.287l3.085 1.542a.75.75 0 1 1-.67 1.342l-3.5-1.75A.75.75 0 0 1 9 10.5V6.75A.75.75 0 0 1 9.75 6" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-replay_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.636 6.706a.75.75 0 1 1-1.06 1.061l-2.14-2.139-.01-.01a3 3 0 0 1-.173-.183 1.1 1.1 0 0 1-.208-.362 1.06 1.06 0 0 1 0-.656c.054-.168.144-.287.208-.363.055-.064.12-.13.173-.182l.01-.01 2.14-2.14a.75.75 0 0 1 1.06 1.061l-1.224 1.224a7 7 0 1 1-7.407 6.725.75.75 0 1 1 1.499.056 5.5 5.5 0 1 0 5.938-5.275z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-reply" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.8 5.6 2.8-2.8M2.8 5.6l2.8 2.8M2.8 5.6h4.4a4 4 0 0 1 4 4v1.6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-reset" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 10a8 8 0 1 1-2.708-6"/><path fill="currentColor" d="M16.75 2a.75.75 0 0 0-1.5 0zM16 5v.75a.75.75 0 0 0 .75-.75zm-3-.75a.75.75 0 0 0 0 1.5zM15.25 2v3h1.5V2zM16 4.25h-3v1.5h3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-restore" class="svg-sprite__symbol"><path fill="currentColor" d="M9 2.75a.75.75 0 0 0 0-1.5zM18.75 11a.75.75 0 0 0-1.5 0zM15 17.25H5v1.5h10zM2.75 15V5h-1.5v10zM5 2.75h4v-1.5H5zM17.25 11v4h1.5v-4zM5 17.25A2.25 2.25 0 0 1 2.75 15h-1.5A3.75 3.75 0 0 0 5 18.75zm10 1.5A3.75 3.75 0 0 0 18.75 15h-1.5A2.25 2.25 0 0 1 15 17.25zM2.75 5A2.25 2.25 0 0 1 5 2.75v-1.5A3.75 3.75 0 0 0 1.25 5zM18 2h.75a.75.75 0 0 0-.75-.75zm-5-.75a.75.75 0 0 0 0 1.5zM17.25 7a.75.75 0 0 0 1.5 0zM9.47 9.47a.75.75 0 1 0 1.06 1.06zM18 1.25h-5v1.5h5zm-.75.75v5h1.5V2zm.22-.53-8 8 1.06 1.06 8-8z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-revoke-role" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.92 12.204-1.849-1.967m1.85 1.967 1.961-1.844m-1.962 1.844-1.961 1.844m1.961-1.844 1.918 2.04"/><path fill="currentColor" fill-rule="evenodd" d="M4.297 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.004.008c.012.015.053.052.138.052h15.59c.085 0 .126-.037.138-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.456-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.305.411-.8.658-1.342.658H2.205c-.54 0-1.036-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.495.737-5.703 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" id="svg-name-role" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.024" opacity=".5"><path d="M6.146 15.022h4.097c3.415 0 4.78-1.366 4.78-4.78V6.143c0-3.415-1.365-4.78-4.78-4.78H6.146c-3.415 0-4.78 1.365-4.78 4.78v4.097c0 3.415 1.365 4.78 4.78 4.78"/><path stroke-miterlimit="10" d="M4.781 5.637a1.764 1.764 0 0 0 2.486 0M9.123 5.637a1.764 1.764 0 0 0 2.486 0M5.736 8.875h4.917c.341 0 .614.273.614.615 0 1.7-1.372 3.073-3.073 3.073A3.07 3.07 0 0 1 5.121 9.49c0-.342.273-.615.615-.615"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-admin" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="18" height="18" fill="#07F" rx="2"/></g><g fill="#fff" clip-path="url(#b)"><path d="m10.742 15.998 3.761-3.108-.213-4.902c-.107-2.236-1.837-4.078-4.118-4.539.178.773.303 1.678.303 2.648 0 1.2-.196 2.286-.428 3.158h2.71l-.535 2.089-1.48 1.118zM7.172 16.001v-3.536l-1.39-1.118-.446-2.09h2.62A12.4 12.4 0 0 1 7.53 6.1c0-.97.125-1.858.303-2.631-2.246.493-3.958 2.302-4.065 4.523l-.267 4.9z"/><path d="M7.172 6.1c0 2.78 1.836 4.767 1.836 4.767S10.844 8.88 10.844 6.1c0-2.779-1.836-4.1-1.836-4.1S7.172 3.321 7.172 6.1"/></g><defs><clipPath id="a"><rect width="18" height="18" fill="#fff" rx="2"/></clipPath><clipPath id="b"><path fill="#fff" d="M3 1h12v15H3z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-chat-moderator" class="svg-sprite__symbol"><rect width="18" height="18" fill="#59A840" rx="2"/><path fill="#F1F1F1" d="m14.158 3.817-5-1.79a.47.47 0 0 0-.316 0l-5 1.79a.5.5 0 0 0-.25.198.55.55 0 0 0-.092.311v5.883c-.003.341.066.68.204.99 1.422 3.117 5.135 4.774 5.135 4.774A.6.6 0 0 0 9 16h.172a.5.5 0 0 0 .156-.027s3.605-1.661 4.98-4.786c.13-.303.195-.631.192-.963V4.326a.55.55 0 0 0-.093-.311.5.5 0 0 0-.249-.198"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-moderator" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="18" height="18" fill="#59A840" rx="2"/><path fill="#fff" d="m15.423 2.254-1.811.303a4.35 4.35 0 0 0-2.61 1.482l-4.36 5.153-.165-.166a.873.873 0 0 0-1.232 0l-.678.677a.283.283 0 0 0 0 .4l.92.917-1.85 1.85a1.44 1.44 0 0 0-.965.416 1.441 1.441 0 0 0 1.02 2.464c.372 0 .74-.14 1.022-.422.267-.267.402-.616.416-.964l1.85-1.851.872.875a.29.29 0 0 0 .2.084.28.28 0 0 0 .2-.084l.677-.678a.86.86 0 0 0 .256-.616c0-.233-.09-.45-.256-.616l-.12-.12 5.152-4.36a4.35 4.35 0 0 0 1.482-2.61l.303-1.811a.282.282 0 0 0-.323-.323"/></g><defs><clipPath id="a"><rect width="18" height="18" fill="#fff" rx="2"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-roles" class="svg-sprite__symbol"><path fill="currentColor" d="M9.632 9.314c-.347.179-.841.434-1.632.434-.792 0-1.286-.255-1.633-.434-.318-.164-.513-.265-.699-.044-.388.46.389 2.3 2.332 2.3s2.72-1.84 2.331-2.3c-.186-.22-.38-.12-.699.044M5.722 5.149c.67.057 1.176.5 1.132.99s-.622.84-1.29.783c-.67-.057-1.177-.5-1.133-.99s.622-.84 1.291-.783M11.569 5.932c-.044-.49-.623-.84-1.292-.783s-1.176.5-1.132.99.622.84 1.291.783c.67-.057 1.176-.5 1.133-.99"/><path fill="currentColor" fill-rule="evenodd" d="M14.745 1.044c1.686 1.743 1.264 6.535 0 9.585S10.95 15.857 8 15.857s-5.48-2.178-6.745-5.228-1.686-7.842 0-9.585C2.365-.102 3.474.077 5.063.334 5.89.467 6.846.622 8 .622s2.11-.155 2.936-.288c1.59-.257 2.7-.436 3.809.71m-1.027.994c.181.187.383.544.527 1.143.14.587.202 1.312.178 2.124-.047 1.63-.434 3.418-.998 4.777-1.123 2.707-3.234 4.346-5.425 4.346s-4.303-1.64-5.426-4.346c-.563-1.359-.95-3.148-.998-4.777-.024-.812.038-1.537.179-2.124.143-.599.345-.956.526-1.143.264-.273.466-.37.638-.416.2-.054.472-.07.925-.022.215.023.496.068.826.12.86.138 2.059.33 3.33.33s2.469-.192 3.329-.33c.33-.052.611-.097.827-.12.453-.048.724-.032.924.022.172.046.374.143.638.416" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-rss" class="svg-sprite__symbol"><circle cx="3" cy="17" r="2.25" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M1.032 8.25a.75.75 0 1 0-.064 1.5zm9.219 10.782a.75.75 0 1 0 1.498-.064zM.968 9.75a9.715 9.715 0 0 1 9.283 9.283l1.498-.064C11.501 13.16 6.84 8.499 1.032 8.25z"/><path fill="currentColor" d="M1.095 1.256a.75.75 0 1 0-.19 1.488zm16.161 17.84a.75.75 0 1 0 1.488-.191zM.905 2.743c8.514 1.09 15.261 7.837 16.351 16.351l1.488-.19C17.568 9.713 10.287 2.432 1.095 1.256z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6" id="svg-name-ru" class="svg-sprite__symbol"><path fill="#fff" d="M0 0h9v3H0z"/><path fill="#d52b1e" d="M0 3h9v3H0z"/><path fill="#0039a6" d="M0 2h9v2H0z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-sad-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#d)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#e)" d="M7.27 5.19c-.02-.385-.38-.605-.975-.575-.505.03-1.6.425-2.3 1.645-.13.225.095.335.225.185.445-.505 1.67-1.19 2.66-1.115.4.03.39-.14.39-.14"/><path fill="url(#f)" d="M6.39 9.34c.425 0 .77-.522.77-1.165S6.815 7.01 6.39 7.01s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#g)" d="M6.39 7.405c.33 0 .62.29.77.715-.01-.63-.35-1.135-.77-1.135s-.76.505-.77 1.135c.15-.425.435-.715.77-.715"/><path fill="url(#h)" d="M11.61 9.34c.425 0 .77-.522.77-1.165s-.345-1.165-.77-1.165-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#i)" d="M10.73 5.22c.02-.385.38-.605.975-.575.505.03 1.6.425 2.3 1.645.13.225-.095.335-.225.185-.445-.505-1.67-1.19-2.66-1.115-.4.03-.39-.14-.39-.14"/><path fill="url(#j)" d="M11.61 7.435c-.33 0-.62.29-.77.715.01-.63.35-1.135.77-1.135s.76.505.77 1.135c-.15-.425-.435-.715-.77-.715"/><path fill="#643800" d="M9 11.96c2.345 0 3.1 2.32 2.38 1.955-.96-.485-1.565-.535-2.38-.535s-1.425.045-2.38.535c-.72.365.035-1.955 2.38-1.955"/><path fill="url(#k)" d="M9 12.37c1.385 0 2.26.78 2.64 1.43.02-.47-.84-1.84-2.64-1.84-1.805 0-2.665 1.37-2.64 1.84.38-.645 1.255-1.43 2.64-1.43"/><path fill="url(#l)" d="M5.86 13.115c.475 1.19-.355 2.27-1.33 2.45s-2.04-.47-2.115-1.69C2.25 11.09 5.47 9.39 5.47 9.39s-.25 2.12.39 3.725"/><path fill="url(#m)" d="M4.56 13.33c-.385 1.2-2.18 1.275-2.12-.11-.03.21-.035.43-.025.655.07 1.22 1.14 1.87 2.115 1.69s1.805-1.26 1.33-2.45c-.64-1.605-.385-3.725-.385-3.725-1.16 2.51-.725 3.35-.915 3.94"/><path fill="url(#n)" d="M5.255 12.44c.37 2.07-1.96 2.89-2.8 1.72a1.77 1.77 0 0 0 2.075 1.405c.975-.18 1.805-1.26 1.33-2.45-.64-1.605-.385-3.725-.385-3.725s-.525 1.355-.22 3.05"/><path fill="url(#o)" d="M5.345 13.685c-.375 1.555-2.08 1.53-2.815.76.155.425.455.745.815.94 1.895.59 2.8-1.36 2.535-2.2-.01-.02-.015-.045-.025-.065-.01-.03-.025-.06-.035-.09-.595-1.59-.35-3.635-.35-3.635-.6 2.315.335 2.39-.125 4.29"/><path fill="url(#p)" d="M5.86 13.115c.475 1.19-.355 2.27-1.33 2.45s-2.04-.47-2.115-1.69C2.25 11.09 5.47 9.39 5.47 9.39s-.25 2.12.39 3.725"/><defs><linearGradient id="e" x1="5.62" x2="5.565" y1="5.925" y2="4.915" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="g" x1="6.388" x2="6.388" y1="7.005" y2="8.091" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="i" x1="12.38" x2="12.435" y1="5.954" y2="4.944" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="j" x1="11.612" x2="11.612" y1="7.034" y2="8.12" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="k" x1="9" x2="9" y1="11.355" y2="13.206" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="l" x1="1.435" x2="6.829" y1="10.978" y2="13.537" gradientUnits="userSpaceOnUse"><stop offset=".072" stop-color="#17BBFE"/><stop offset=".208" stop-color="#D1F2FF"/><stop offset=".668" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="m" x1="8.504" x2="1.068" y1="15.152" y2="10.14" gradientUnits="userSpaceOnUse"><stop stop-color="#D1F2FF"/><stop offset=".668" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="n" x1="2.152" x2="7.11" y1="9.805" y2="15.676" gradientUnits="userSpaceOnUse"><stop offset=".566" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="o" x1="2.56" x2="6.521" y1="10.028" y2="15.368" gradientUnits="userSpaceOnUse"><stop offset=".566" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(72.692 -5.943 10.313)scale(7.22705 3.88715)" gradientUnits="userSpaceOnUse"><stop stop-color="#EB672A" stop-opacity=".5"/><stop offset=".346" stop-color="#DC641B" stop-opacity=".285"/><stop offset=".804" stop-color="#C25E00" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -2.382 8.197)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .23 11.673)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="rotate(-76.619 9.843 3.836)scale(2.51225 1.47918)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity=".45"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-safety" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M18 3.562v11.052a2 2 0 0 1-1.298 1.873l-6 2.25a2 2 0 0 1-1.404 0l-6-2.25A2 2 0 0 1 2 14.614V3.562c0-.918.624-1.716 1.526-1.888C5.053 1.382 7.526 1 10 1c2.473 0 4.947.382 6.474.674.902.172 1.526.97 1.526 1.888Z"/><path fill="currentColor" d="M7.294 10.81a.75.75 0 1 0-.588 1.38zM10.525 13l-.294.69a.75.75 0 0 0 .987-.404zm3.168-5.714a.75.75 0 1 0-1.386-.572zM6.706 12.19l3.525 1.5.588-1.38-3.525-1.5zm4.512 1.096 2.475-6-1.386-.572-2.475 6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-safety-filled" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15 11.955v-9.51c0-.916-.621-1.712-1.52-1.881C12.133.31 10.067 0 8 0S3.867.31 2.52.564C1.621.734 1 1.529 1 2.444v9.511a2 2 0 0 0 1.288 1.869l5 1.905a2 2 0 0 0 1.424 0l5-1.905A2 2 0 0 0 15 11.955m-3.076-6.574a1 1 0 1 0-1.848-.762l-2.09 5.065L5.392 8.58a1 1 0 1 0-.784 1.84l3.525 1.5a1 1 0 0 0 1.316-.539z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-search" class="svg-sprite__symbol"><circle cx="8.5" cy="8.5" r="7.5" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M18.47 19.53a.75.75 0 1 0 1.06-1.06zm-5.5-5.5 5.5 5.5 1.06-1.06-5.5-5.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-search-thick" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13.334 15.7a8.52 8.52 0 0 1-4.762 1.446C3.842 17.146 0 13.305 0 8.573S3.841 0 8.572 0c4.732 0 8.573 3.842 8.573 8.573a8.53 8.53 0 0 1-1.446 4.762l3.811 3.81a1.674 1.674 0 0 1-2.365 2.365zM8.572 3.027a5.55 5.55 0 0 1 5.546 5.546 5.55 5.55 0 0 1-5.546 5.546 5.55 5.55 0 0 1-5.546-5.546 5.55 5.55 0 0 1 5.546-5.546" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-search_24" class="svg-sprite__symbol"><path fill="currentColor" d="M7.75.5a7.25 7.25 0 0 1 5.785 11.62l4.172 4.173a1 1 0 0 1-1.414 1.414l-4.173-4.172A7.25 7.25 0 1 1 7.75.5m0 2a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-search_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="M6.5 1a5.5 5.5 0 0 1 4.384 8.823l3.895 3.9a.75.75 0 0 1-1.061 1.06l-3.895-3.9A5.5 5.5 0 1 1 6.5 1m0 1.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-search_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13 4a9 9 0 1 0 5.618 16.032l4.675 4.675a1 1 0 0 0 1.414-1.414l-4.675-4.675A9 9 0 0 0 13 4m0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-0" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#535B63" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-1" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-4" x2="17.07" y1="-3.5" y2="-1.232" gradientUnits="userSpaceOnUse"><stop offset=".136" stop-color="#9CF6A6"/><stop offset=".847" stop-color="#47B143"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-2" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-4.5" x2="19.524" y1="-3.5" y2="-1.823" gradientUnits="userSpaceOnUse"><stop offset=".105" stop-color="#00FDF4"/><stop offset=".847" stop-color="#05B9B9"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-3" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-7.92" x2="22.4" y1="-10.385" y2="-5.713" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-4" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-3.96" x2="21.566" y1="-5.019" y2="-1.175" gradientUnits="userSpaceOnUse"><stop stop-color="#55A5FF"/><stop offset=".847" stop-color="#BE35FF"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-5" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-3" x2="19.623" y1="-6.5" y2="-3.084" gradientUnits="userSpaceOnUse"><stop stop-color="#C446FF"/><stop offset=".847" stop-color="#FF8A00"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-6" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="0" x2="20.088" y1="1.731" y2="3.842" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8B4E"/><stop offset=".847" stop-color="#FF1000"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-select-item" class="svg-sprite__symbol"><rect width="19" height="19" x=".5" y=".5" stroke="currentColor" rx="9.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-select-item-checked" class="svg-sprite__symbol"><rect width="15" height="15" x="2.5" y="2.5" stroke="currentColor" stroke-width="5" rx="7.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-send" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 12 3 22v-8l6-2-6-2V2z" opacity=".3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-send_24" class="svg-sprite__symbol"><path fill="currentColor" d="M4.783 13.128q-.856 2.318-1.077 3.258c-.461 1.968-.797 2.412.922 1.476s10.039-5.57 11.895-6.6c2.42-1.342 2.452-1.237-.13-2.662C14.427 7.514 6.204 3 4.628 2.115c-1.576-.887-1.383-.493-.922 1.476q.223.951 1.093 3.287a3.33 3.33 0 0 0 2.49 2.11l4.803.93a.083.083 0 0 1 0 .163l-4.814.93a3.33 3.33 0 0 0-2.495 2.117"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-services_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9.116 15c1.065 0 1.623.108 2.204.419.541.29.972.72 1.261 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42H6.884c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26C3.108 22.739 3 22.18 3 21.116v-2.231c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261.582-.311 1.14-.419 2.205-.419zm12 0c1.065 0 1.623.108 2.205.419.54.29.971.72 1.26 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42h-2.232c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26-.311-.582-.419-1.14-.419-2.205v-2.231c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261.582-.311 1.14-.419 2.205-.419zm-12 2H6.884c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44c-.135.252-.183.498-.183 1.262v2.23c0 .764.048 1.01.182 1.263q.153.287.44.44c.253.135.499.182 1.262.182h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.253.183-.499.183-1.262v-2.231c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44c-.253-.135-.499-.183-1.262-.183m12 0h-2.232c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44c-.135.252-.183.498-.183 1.262v2.23c0 .764.048 1.01.182 1.263q.153.287.44.44c.253.135.499.182 1.262.182h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.253.183-.499.183-1.262v-2.231c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44c-.253-.135-.499-.183-1.262-.183m-.224-14.587c.63.191 1.101.51 1.855 1.263l1.577 1.578c.754.753 1.072 1.224 1.263 1.855a3.04 3.04 0 0 1 0 1.783c-.19.63-.51 1.102-1.263 1.855l-1.577 1.578c-.754.753-1.225 1.071-1.855 1.263a3.04 3.04 0 0 1-1.783 0c-.631-.192-1.102-.51-1.856-1.263l-1.577-1.578c-.754-.753-1.072-1.224-1.263-1.855a3.04 3.04 0 0 1 0-1.783c.19-.631.51-1.102 1.263-1.855l1.577-1.578c.754-.754 1.225-1.072 1.855-1.263a3.04 3.04 0 0 1 1.784 0M9.116 3c1.065 0 1.623.108 2.204.419.541.29.972.72 1.261 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42H6.884c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26C3.108 10.739 3 10.18 3 9.116V6.885c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261C5.261 3.108 5.82 3 6.884 3zm10.573 1.327c-.274.083-.482.223-1.021.763L17.09 6.668c-.54.54-.68.747-.763 1.02a1.05 1.05 0 0 0 0 .624c.082.273.223.48.763 1.02l1.578 1.578c.54.54.747.68 1.02.764.21.063.415.063.623 0 .274-.083.482-.224 1.021-.764l1.578-1.577c.54-.54.68-.748.763-1.021a1.05 1.05 0 0 0 0-.623c-.082-.274-.223-.481-.763-1.021L21.332 5.09c-.54-.54-.747-.68-1.02-.763a1.05 1.05 0 0 0-.623 0M9.116 5H6.884c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44C5.047 5.875 5 6.12 5 6.885v2.23c0 .764.048 1.01.182 1.262q.153.288.44.44c.253.136.499.183 1.262.183h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.252.183-.499.183-1.262V6.885c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44C10.124 5.048 9.878 5 9.115 5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-settings" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m19.251 9.707-.505-1.225s1.175-2.708 1.071-2.812l-1.555-1.55c-.108-.107-2.759 1.128-2.759 1.128l-1.223-.504S13.2 2 13.052 2h-2.195c-.153 0-1.152 2.75-1.152 2.75l-1.221.506s-2.707-1.175-2.81-1.07L4.12 5.738c-.108.107 1.128 2.76 1.128 2.76L4.744 9.72S2 10.801 2 10.946v2.198c0 .153 2.75 1.153 2.75 1.153l.505 1.221s-1.174 2.706-1.071 2.81l1.554 1.554c.106.105 2.758-1.13 2.758-1.13l1.224.506S10.8 22 10.949 22h2.195c.152 0 1.152-2.75 1.152-2.75l1.225-.506s2.701 1.175 2.806 1.072l1.554-1.553c.109-.108-1.13-2.759-1.13-2.759l.504-1.223S22 13.199 22 13.05v-2.194c0-.153-2.749-1.15-2.749-1.15m-3.099 2.37c0 2.233-1.778 4.05-3.963 4.05-2.182 0-3.962-1.817-3.962-4.05 0-2.231 1.78-4.046 3.963-4.046 2.185.001 3.962 1.815 3.962 4.047" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-settings_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M15.148 2.04c.428.07.832.233 1.195.523.595.476.878 1.076 1.097 1.952.056.224.153.486.275.74q.417.176.815.393c.262-.065.513-.15.714-.244 1.412-.658 2.597-.623 3.567.423.082.089.131.148.238.28l.629.776c.17.21.241.305.348.482.692 1.152.422 2.224-.452 3.386a4 4 0 0 0-.417.71q.117.425.195.86c.223.178.46.334.668.441.805.41 1.325.822 1.655 1.508.202.42.27.85.24 1.282-.015.229-.04.356-.105.64l-.226.975c-.065.285-.099.41-.185.622a2.5 2.5 0 0 1-.778 1.047c-.598.473-1.246.614-2.148.63a4 4 0 0 0-.773.1q-.265.365-.563.704c.003.275.03.544.077.764.187.884.196 1.547-.13 2.236-.2.42-.491.744-.845.993a3.5 3.5 0 0 1-.565.32l-.899.44c-.263.127-.381.18-.6.247-.414.125-.85.156-1.303.054-.744-.167-1.261-.582-1.842-1.273a4 4 0 0 0-.591-.561 10 10 0 0 1-.877 0c-.229.18-.438.378-.592.56-.58.692-1.098 1.107-1.842 1.274a2.5 2.5 0 0 1-1.303-.054 3.5 3.5 0 0 1-.6-.248l-.899-.438-.185-.093c-1.312-.683-1.696-1.847-1.355-3.457.047-.22.074-.49.077-.764a10 10 0 0 1-.563-.705 4 4 0 0 0-.772-.099c-.903-.016-1.551-.157-2.149-.63a2.5 2.5 0 0 1-.778-1.047 3.5 3.5 0 0 1-.185-.622l-.225-.974a3.4 3.4 0 0 1-.109-.681 2.5 2.5 0 0 1 .296-1.346c.339-.629.84-1.015 1.602-1.404.209-.107.446-.263.668-.441q.078-.435.195-.86a4 4 0 0 0-.417-.71c-.874-1.162-1.144-2.234-.452-3.386.107-.177.179-.273.348-.482l.63-.777c.106-.131.155-.19.237-.279.97-1.046 2.155-1.08 3.567-.423.201.093.452.18.714.244q.398-.216.816-.394c.12-.253.218-.515.274-.74.219-.875.502-1.475 1.097-1.95.363-.291.768-.455 1.195-.523.18-.03.3-.038.49-.04L14.5 2c.293 0 .422.005.648.04M14.586 4H13.5c-.5 0-.75 0-1 1a6.4 6.4 0 0 1-.836 1.87 7.5 7.5 0 0 0-1.8.872 6.4 6.4 0 0 1-1.952-.525c-.934-.435-1.092-.24-1.406.148l-.63.777c-.314.389-.472.583.148 1.406.35.464.721 1.15.937 1.857a7.5 7.5 0 0 0-.429 1.894 6.4 6.4 0 0 1-1.643 1.245c-.918.468-.862.712-.75 1.199l.225.974c.113.487.17.731 1.2.75.57.01 1.323.135 2.003.39.345.575.765 1.1 1.247 1.56a6.4 6.4 0 0 1-.072 2.032c-.213 1.008.011 1.118.46 1.337l.9.438c.45.22.674.33 1.337-.46a6.4 6.4 0 0 1 1.59-1.326 7.6 7.6 0 0 0 1.942 0 6.4 6.4 0 0 1 1.59 1.326c.663.79.888.68 1.337.46l.9-.438c.449-.219.673-.329.46-1.337a6.4 6.4 0 0 1-.072-2.031 7.5 7.5 0 0 0 1.248-1.56 6.4 6.4 0 0 1 2.002-.391c1.031-.019 1.087-.263 1.2-.75l.225-.974c.112-.487.168-.73-.75-1.2a6.4 6.4 0 0 1-1.643-1.244 7.5 7.5 0 0 0-.43-1.894 6.3 6.3 0 0 1 .938-1.857c.62-.823.462-1.017.148-1.406l-.63-.777c-.314-.389-.472-.583-1.406-.148a6.4 6.4 0 0 1-1.952.525 7.5 7.5 0 0 0-1.8-.871A6.4 6.4 0 0 1 15.5 5c-.235-.941-.47-.997-.914-1M14 9.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="svg-name-share" class="svg-sprite__symbol"><circle cx="19" cy="4" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle cx="19" cy="20" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle cx="5" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 10.857 10.055-5.745M7 13.142l9.85 5.63"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-share_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M11.998 3.725a2.15 2.15 0 0 0-1.996 2.145L10 7.987l-.02.005a9.904 9.904 0 0 0-7.827 10.72c.083.812 1.116 1.103 1.61.455l.187-.236a9.08 9.08 0 0 1 5.836-3.265l.214-.026v2.494a2.15 2.15 0 0 0 3.477 1.692l7.824-6.132a2.15 2.15 0 0 0 0-3.384l-7.824-6.132a2.15 2.15 0 0 0-1.326-.458zm.154 1.795a.35.35 0 0 1 .216.074l7.823 6.132a.35.35 0 0 1 0 .551l-7.823 6.132a.35.35 0 0 1-.566-.275l-.001-3.447a.9.9 0 0 0-.915-.9l-.233.004-.343.016a10.9 10.9 0 0 0-6.118 2.366l-.174.144.023-.136a8.1 8.1 0 0 1 6.969-6.536.9.9 0 0 0 .79-.893l.002-2.882a.35.35 0 0 1 .35-.35"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-share_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.627 4.652c0-.316.346-.465.569-.29l6.809 5.345a.37.37 0 0 1 0 .58l-6.81 5.346a.354.354 0 0 1-.568-.29v-3.204a.714.714 0 0 0-.715-.714c-2.546 0-4.465 1.035-5.899 2.334.258-1.544.823-2.72 1.589-3.604 1.07-1.237 2.597-1.986 4.442-2.333a.714.714 0 0 0 .583-.701zm1.451-1.413c-1.181-.928-2.88-.067-2.88 1.413v1.89c-1.832.436-3.467 1.28-4.677 2.679-1.34 1.55-2.091 3.703-2.091 6.53a.714.714 0 0 0 1.277.44c1.243-1.59 2.982-3.066 5.49-3.304v2.456c0 1.48 1.7 2.34 2.881 1.413l6.809-5.346a1.8 1.8 0 0 0 0-2.826z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-shield_keyhole_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.5 12.5A2.5 2.5 0 0 1 15 14.79V17a1 1 0 1 1-2 0v-2.208a2.5 2.5 0 1 1 3.5-2.292"/><path fill="currentColor" fill-rule="evenodd" d="M14.594 2.044a4 4 0 0 0-1.187 0c-.446.067-.868.233-1.427.451L5.654 4.967l-.078.03c-.281.108-.635.245-.912.494a2 2 0 0 0-.536.784c-.13.348-.129.728-.128 1.03v8.694c0 2.647 1.346 7.118 7.65 10.332l.061.03c.523.267.928.474 1.499.58a4.5 4.5 0 0 0 1.524-.012c.57-.115.99-.338 1.533-.626l.068-.037C19.393 24.646 24 21.51 24 16V7.303c.002-.302.003-.682-.127-1.03a2 2 0 0 0-.536-.784c-.277-.249-.631-.386-.913-.494l-.078-.03-6.325-2.47c-.559-.219-.981-.384-1.427-.45m-.89 1.978a2 2 0 0 1 .593 0c.196.03.399.102 1.086.37l6.236 2.436c.125.049.253.095.375.153.01.135.006.27.006.405V16c0 4.256-3.564 6.891-6.6 8.5-.632.334-.804.417-1.063.47-.195.04-.565.042-.762.005-.261-.048-.42-.122-1.016-.425C6.934 21.682 6 17.906 6 15.999V7.39c0-.136-.003-.272.007-.406.122-.058.25-.105.375-.154l6.236-2.436c.687-.269.89-.341 1.086-.37" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-silver-streamer" class="svg-sprite__symbol"><g clip-path="url(#a)"><mask id="b" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M18 0H0v18h18z"/></mask><g mask="url(#b)"><path fill="url(#c)" d="M7.984.56a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.707a2 2 0 0 1 .986 1.708L16.8 9l-.027 3.367a2 2 0 0 1-.986 1.708l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.14 9.002l.027-3.366a2 2 0 0 1 .986-1.708L5.055 2.22z"/><path fill="#fff" d="M12.748 7.643 8.675 11.47a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.213 9.283a.73.73 0 0 1-.233-.53.73.73 0 0 1 .233-.53A.83.83 0 0 1 5.78 8c.213 0 .417.08.567.222l1.76 1.655 3.504-3.294a.83.83 0 0 1 .568-.223c.213 0 .417.08.567.223a.73.73 0 0 1 .233.53.73.73 0 0 1-.232.53Z"/></g><mask id="d" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M18 0H0v18h18z"/></mask><g mask="url(#d)"><path fill="url(#e)" d="M7.984.56a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.707a2 2 0 0 1 .986 1.708L16.8 9l-.027 3.367a2 2 0 0 1-.986 1.708l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.14 9.002l.027-3.366a2 2 0 0 1 .986-1.708L5.055 2.22z"/><path fill="#fff" d="M12.768 7.283 8.695 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.232.53Z"/></g></g><defs><linearGradient id="c" x1="2.1" x2="8.97" y1="4.11" y2="18" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ECEFF4"/><stop offset=".135" stop-color="#CFD3DE"/><stop offset=".531" stop-color="#7A7D85"/><stop offset=".99" stop-color="#ABAFBA"/></linearGradient><linearGradient id="e" x1="9" x2="8.97" y1=".3" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#CFD3DE"/><stop offset="0" stop-color="#CED8E9"/><stop offset=".151" stop-color="#BAC1CF"/><stop offset=".427" stop-color="#7A7E87"/><stop offset=".599" stop-color="#737D85"/><stop offset=".823" stop-color="#A7AEB7"/><stop offset="1" stop-color="#CED8E9"/></linearGradient><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sliders_vertical_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M4.918 3.25a.75.75 0 0 0-1.5 0v1h-1a.75.75 0 0 0 0 1.5h1v11a.75.75 0 0 0 1.5 0v-11h1a.75.75 0 1 0 0-1.5h-1zM10.751 3.252a.75.75 0 0 0-1.5 0v7.665h-1a.75.75 0 0 0 0 1.5h1v4.331a.75.75 0 0 0 1.5 0v-4.331h.996a.75.75 0 0 0 0-1.5h-.996zM15.835 2.502a.75.75 0 0 1 .75.75v4.331h.998a.75.75 0 1 1 0 1.5h-.998v7.668a.75.75 0 0 1-1.5 0V9.083h-.999a.75.75 0 0 1 0-1.5h.999V3.252a.75.75 0 0 1 .75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-smile" class="svg-sprite__symbol"><circle cx="12" cy="12" r="10.8" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M6 14.4c1.29 2.17 3.496 3.6 6 3.6s4.71-1.43 6-3.6"/><path stroke="currentColor" stroke-width="1.2" d="M9 8.4a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0ZM16.2 8.4a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-smile-plus" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.964 3.418H15.2M12.582.8v5.237"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M12.582 9.309A5.89 5.89 0 1 1 6.69 3.418"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M3.418 10.617c.704 1.184 1.907 1.964 3.273 1.964s2.569-.78 3.272-1.964"/><path fill="currentColor" d="M5.382 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0m3.927 0a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-smile_add_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 1.5a8.48 8.48 0 0 0-6.01 2.49A8.48 8.48 0 0 0 1.5 10c0 2.347.952 4.473 2.49 6.01A8.48 8.48 0 0 0 10 18.5a.75.75 0 0 0 0-1.5 6.98 6.98 0 0 1-4.95-2.05A6.98 6.98 0 0 1 3 10c0-1.933.783-3.682 2.05-4.95A6.98 6.98 0 0 1 10 3c1.933 0 3.682.783 4.95 2.05A6.98 6.98 0 0 1 17 10a.75.75 0 0 0 1.5 0 8.48 8.48 0 0 0-2.49-6.01A8.48 8.48 0 0 0 10 1.5M8.75 8.373a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m3.625 1.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m5.875 6.752a.75.75 0 0 0 0-1.5h-2v-2a.75.75 0 0 0-1.5 0v2h-1.995a.75.75 0 0 0 0 1.5h1.995v2.003a.75.75 0 0 0 1.5 0V16.25zm-9.935-4.497a.75.75 0 0 0-1.123.994A3.73 3.73 0 0 0 10 14c1.11 0 2.117-.473 2.808-1.253a.75.75 0 0 0-1.123-.994A2.23 2.23 0 0 1 10 12.5a2.23 2.23 0 0 1-1.685-.747" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-smile_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10 1.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m3.067 9.057c.3.285.312.76.027 1.06a4 4 0 0 1-.855.653A4.36 4.36 0 0 1 10 14.4a4.36 4.36 0 0 1-2.239-.63 4 4 0 0 1-.854-.653.75.75 0 0 1 1.004-1.109l.197.18c.098.083.239.186.417.292.446.263.942.42 1.475.42s1.029-.157 1.475-.42c.178-.106.32-.21.417-.292l.115-.105a.75.75 0 0 1 1.06-.027M7.625 7.25a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m4.75 0a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-smile_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M8.44 14.297a.9.9 0 0 1 1.258.133c.014.016.197.223.53.431.383.24.97.489 1.774.489.803 0 1.39-.25 1.773-.489.19-.119.381-.26.53-.431a.9.9 0 0 1 1.4 1.132c-.273.328-.616.6-.976.826a5.1 5.1 0 0 1-2.727.762 5.1 5.1 0 0 1-2.727-.762 4 4 0 0 1-.976-.826.9.9 0 0 1 .14-1.265M10.252 10.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.002 11.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/><path fill="currentColor" fill-rule="evenodd" d="M12.002 2.1c-5.468 0-9.9 4.432-9.9 9.9 0 5.467 4.432 9.9 9.9 9.9 5.467 0 9.9-4.433 9.9-9.9s-4.433-9.9-9.9-9.9m-8.1 9.9a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-smile_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 26C7.373 26 2 20.627 2 14S7.373 2 14 2s12 5.373 12 12-5.373 12-12 12m0-2c5.523 0 10-4.477 10-10S19.523 4 14 4 4 8.477 4 14s4.477 10 10 10m-4.388-5.908a1 1 0 0 1 1.463-1.364 4 4 0 0 0 5.85 0 1 1 0 1 1 1.46 1.367q-.141.15-.293.293a6 6 0 0 1-8.48-.297m7.763-4.842a1.625 1.625 0 1 1 0-3.25 1.625 1.625 0 0 1 0 3.25m-6.75 0a1.625 1.625 0 1 1 0-3.25 1.625 1.625 0 0 1 0 3.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="14" id="svg-name-social-behance" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M16.783 3.454q1.197-.002 2.095.466a4.2 4.2 0 0 1 1.47 1.25q.573.782.828 1.788a6.7 6.7 0 0 1 .18 2.098h-6.801c0 .745.251 1.45.64 1.83.388.378.949.568 1.675.568q.783 0 1.352-.395c.375-.263.603-.544.691-.835h2.28c-.366 1.134-.922 1.944-1.68 2.432-.75.489-1.664.733-2.73.733q-1.111 0-2.01-.357c-.6-.24-1.1-.575-1.522-1.013a4.6 4.6 0 0 1-.958-1.57 5.8 5.8 0 0 1-.338-2.01q.002-1.057.348-1.971c.235-.61.56-1.138.988-1.58a4.7 4.7 0 0 1 1.526-1.05 4.9 4.9 0 0 1 1.966-.384M6.347.129c.623 0 1.185.053 1.699.165A3.7 3.7 0 0 1 9.36.83q.545.371.85.993c.198.41.298.922.298 1.528q0 .984-.447 1.64-.448.656-1.327 1.073 1.199.347 1.787 1.212.591.87.59 2.09 0 .99-.38 1.706a3.3 3.3 0 0 1-1.03 1.18q-.646.456-1.48.675a6.6 6.6 0 0 1-1.702.218H.21V.129zm-.155 7.215H3.076v3.585h3.06q.423.001.803-.082c.256-.056.483-.145.675-.276.191-.127.351-.3.466-.52q.173-.328.172-.844-.001-1.004-.565-1.436c-.376-.285-.878-.427-1.495-.427m10.514-1.935q-.62 0-1.03.211-.404.21-.656.519-.248.313-.347.664-.1.346-.118.621h4.212c-.062-.66-.288-1.148-.597-1.49-.308-.341-.829-.525-1.464-.525M5.758 2.346H3.076v3.042h2.901q.762 0 1.26-.366c.331-.24.49-.638.49-1.183q0-.455-.159-.748a1.2 1.2 0 0 0-.442-.452 1.8 1.8 0 0 0-.63-.229 4 4 0 0 0-.738-.064M19.3 1.002v1.284h-5.276V1.002z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-social-discord" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#fff" d="M20.57 4.738c2.74 3.877 4.094 8.25 3.588 13.286a.08.08 0 0 1-.032.054 20.4 20.4 0 0 1-6.068 2.946.1.1 0 0 1-.047 0 .1.1 0 0 1-.038-.028 15.5 15.5 0 0 1-1.238-1.938.074.074 0 0 1 .04-.104c.662-.24 1.29-.527 1.894-.867a.073.073 0 0 0 .007-.124 10 10 0 0 1-.377-.284.08.08 0 0 0-.079-.01c-3.924 1.744-8.223 1.744-12.193 0a.08.08 0 0 0-.079.01 10 10 0 0 1-.376.284.073.073 0 0 0 .008.124c.604.334 1.233.627 1.893.868.042.016.063.063.042.103a14 14 0 0 1-1.24 1.94.08.08 0 0 1-.085.026 20.4 20.4 0 0 1-6.058-2.946.08.08 0 0 1-.032-.055c-.422-4.355.44-8.765 3.584-13.286a.07.07 0 0 1 .033-.027 20.5 20.5 0 0 1 4.938-1.474.08.08 0 0 1 .08.036c.214.365.459.833.624 1.216a19.2 19.2 0 0 1 5.547 0c.166-.375.402-.85.615-1.216a.1.1 0 0 1 .034-.03.1.1 0 0 1 .046-.006c1.733.288 3.391.791 4.938 1.474a.06.06 0 0 1 .031.028m-10.282 8.28c.02-1.287-.956-2.352-2.18-2.352-1.215 0-2.18 1.056-2.18 2.353 0 1.296.984 2.352 2.18 2.352 1.214 0 2.18-1.056 2.18-2.352m8.062 0c.019-1.287-.957-2.352-2.18-2.352-1.215 0-2.181 1.056-2.181 2.353 0 1.296.985 2.352 2.18 2.352 1.224 0 2.18-1.056 2.18-2.352"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24.262v24.262H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-discord-round" class="svg-sprite__symbol"><defs><linearGradient id="a" x1="7.021%" y1="0%" y2="100%"><stop offset="0%" stop-color="#7184CA"/><stop offset="100%" stop-color="#4A62BA"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><circle cx="13" cy="13" r="13" fill="url(#a)"/><path fill="#FFF" fill-rule="nonzero" d="m10.725 7.8.13.156c-2.34.676-3.419 1.703-3.419 1.703s.286-.156.767-.377c1.391-.61 2.496-.78 2.951-.819.078-.013.143-.026.221-.026a10.6 10.6 0 0 1 6.539 1.222s-1.027-.975-3.237-1.65l.182-.209h.055c.314.008 1.92.106 3.598 1.365 0 0 1.872 3.393 1.872 7.58 0 0-1.105 1.884-3.978 1.975 0 0-.468-.559-.858-1.053 1.703-.48 2.353-1.547 2.353-1.547a7.4 7.4 0 0 1-1.495.767 8.6 8.6 0 0 1-1.885.56 9.1 9.1 0 0 1-3.367-.014 11 11 0 0 1-1.911-.559 8 8 0 0 1-.949-.442c-.039-.026-.078-.039-.117-.065a.2.2 0 0 1-.052-.039c-.234-.13-.364-.22-.364-.22s.624 1.04 2.275 1.533c-.39.494-.871 1.08-.871 1.08-2.873-.092-3.965-1.977-3.965-1.977 0-4.186 1.872-7.579 1.872-7.579C8.944 7.761 10.725 7.8 10.725 7.8m-.364 4.85c-.741 0-1.326.65-1.326 1.442 0 .793.598 1.443 1.326 1.443.741 0 1.326-.65 1.326-1.443.013-.793-.585-1.443-1.326-1.443zm4.745 0c-.741 0-1.326.65-1.326 1.442 0 .793.598 1.443 1.326 1.443.741 0 1.326-.65 1.326-1.443s-.585-1.443-1.326-1.443z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-social-dribbble" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10c5.51 0 10-4.48 10-10S15.51 0 10 0m6.605 4.61a8.5 8.5 0 0 1 1.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25 25 0 0 0-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362M10 1.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.7 8.7 0 0 1 10 1.475m-3.633.803a54 54 0 0 1 3.167 4.935c-3.992 1.062-7.517 1.04-7.896 1.04a8.58 8.58 0 0 1 4.729-5.975M1.453 10.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.52 8.52 0 0 1-2.19-5.705zM10 18.547a8.48 8.48 0 0 1-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.3 35.3 0 0 1 1.823 6.475 8.4 8.4 0 0 1-3.341.684m4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.47 8.47 0 0 1-3.655 5.715"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-fb" class="svg-sprite__symbol"><path fill="currentColor" d="M26 13.079C26 5.855 20.18 0 13 0S0 5.855 0 13.079C0 19.609 4.753 25.019 10.969 26v-9.14h-3.3v-3.782h3.3v-2.88c0-3.279 1.94-5.09 4.91-5.09 1.421 0 2.91.256 2.91.256v3.219h-1.64c-1.615 0-2.118 1.008-2.118 2.043v2.453h3.606l-.576 3.78h-3.03V26C21.247 25.019 26 19.608 26 13.079"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-google" class="svg-sprite__symbol"><g fill="none" fill-rule="nonzero"><path fill="#FFF" d="M8.944.711c-3.218 1.08-5.96 3.443-7.488 6.434a12.7 12.7 0 0 0-1.15 3.262 12.8 12.8 0 0 0 1.143 8.385 13.1 13.1 0 0 0 3.588 4.33 13.3 13.3 0 0 0 4.802 2.376c2.202.579 4.546.565 6.763.07 2.003-.453 3.9-1.394 5.413-2.76 1.598-1.443 2.742-3.34 3.346-5.382.66-2.223.746-4.6.334-6.887H13.263V15.6h7.203c-.277 1.617-1.257 3.095-2.643 4.008-.873.579-1.875.948-2.912 1.13-1.037.174-2.117.194-3.154-.008a7.9 7.9 0 0 1-2.941-1.247 8.03 8.03 0 0 1-3.026-3.98 7.73 7.73 0 0 1 0-5.047 8.1 8.1 0 0 1 1.918-3.06 7.9 7.9 0 0 1 3.95-2.154 8 8 0 0 1 3.878.153 7.14 7.14 0 0 1 2.849 1.645l2.43-2.384c.425-.425.873-.836 1.285-1.275A12.9 12.9 0 0 0 17.845.795C15.003-.237 11.807-.258 8.944.71"/><path fill="#EA4335" d="M8.944.711a13.62 13.62 0 0 1 8.9.077A12.9 12.9 0 0 1 22.1 3.374c-.412.439-.86.85-1.286 1.275l-2.43 2.384a7.2 7.2 0 0 0-2.848-1.645 7.95 7.95 0 0 0-3.879-.153 7.94 7.94 0 0 0-3.95 2.154 8 8 0 0 0-1.917 3.06C4.348 9.347 2.905 8.253 1.456 7.152 2.984 4.154 5.726 1.792 8.944.71"/><path fill="#FBBC05" d="M.313 10.4c.234-1.13.618-2.23 1.15-3.262 1.442 1.101 2.885 2.196 4.334 3.297a7.68 7.68 0 0 0 0 5.047 1779 1779 0 0 1-4.327 3.297A12.7 12.7 0 0 1 .313 10.4"/><path fill="#4285F4" d="M13.263 10.532h12.432c.412 2.28.32 4.657-.334 6.887-.604 2.043-1.748 3.939-3.346 5.382l-4.199-3.2c1.386-.913 2.366-2.39 2.643-4.008h-7.203q.009-2.53.007-5.06"/><path fill="#34A853" d="M1.456 18.786q2.163-1.644 4.327-3.298a8.07 8.07 0 0 0 3.026 3.98 7.95 7.95 0 0 0 2.94 1.248c1.038.21 2.11.182 3.155.007 1.037-.18 2.039-.55 2.912-1.129l4.199 3.2c-1.513 1.373-3.41 2.307-5.413 2.76-2.217.495-4.561.509-6.763-.07a13.15 13.15 0 0 1-4.802-2.377 13.1 13.1 0 0 1-3.58-4.321"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-social-instagram" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14.228 0H5.772A5.773 5.773 0 0 0 0 5.773v8.452A5.77 5.77 0 0 0 5.772 20h8.456A5.77 5.77 0 0 0 20 14.225V5.773A5.773 5.773 0 0 0 14.228 0m3.93 14.376a3.83 3.83 0 0 1-3.832 3.832H5.674a3.83 3.83 0 0 1-3.832-3.832V5.724a3.83 3.83 0 0 1 3.832-3.832h8.652a3.83 3.83 0 0 1 3.832 3.832zM10 4.861a5.19 5.19 0 1 1 0 10.378 5.19 5.19 0 0 1 0-10.378m0 8.553a3.364 3.364 0 1 0 0-6.729 3.364 3.364 0 0 0 0 6.729m5.363-7.542a1.209 1.209 0 1 0 0-2.418 1.209 1.209 0 0 0 0 2.418"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-instagram-colored" class="svg-sprite__symbol"><path fill="url(#a)" fill-rule="evenodd" d="M13 2.342c3.471 0 3.882.014 5.253.076 1.268.058 1.956.27 2.414.448.566.208 1.077.54 1.497.972.432.42.764.932.973 1.497.177.458.39 1.147.447 2.414.062 1.371.076 1.782.076 5.253s-.014 3.882-.076 5.253c-.058 1.268-.27 1.956-.447 2.415a4.3 4.3 0 0 1-2.468 2.467c-.458.178-1.146.39-2.414.447-1.37.063-1.782.076-5.253.076s-3.883-.014-5.253-.076c-1.268-.058-1.956-.27-2.414-.447a4 4 0 0 1-1.497-.973 4 4 0 0 1-.972-1.497c-.178-.458-.39-1.146-.448-2.414-.062-1.37-.076-1.782-.076-5.253s.014-3.882.076-5.253c.058-1.268.27-1.956.448-2.414.208-.566.54-1.077.972-1.497.42-.432.931-.764 1.497-.972.458-.178 1.146-.39 2.414-.448 1.37-.062 1.782-.076 5.253-.076zm.002-2.344c-3.53 0-3.973.015-5.36.078-1.387.064-2.33.285-3.158.607a6.4 6.4 0 0 0-2.302 1.499A6.4 6.4 0 0 0 .685 4.484C.361 5.312.141 6.257.078 7.64S0 9.47 0 13s.015 3.974.078 5.36c.064 1.387.283 2.329.605 3.156a6.4 6.4 0 0 0 1.499 2.302 6.4 6.4 0 0 0 2.302 1.5c.826.32 1.772.54 3.156.604C9.023 25.986 9.47 26 13 26s3.974-.015 5.36-.078 2.328-.283 3.156-.604a6.65 6.65 0 0 0 3.802-3.802c.32-.826.54-1.772.604-3.156.063-1.383.078-1.83.078-5.36s-.015-3.973-.078-5.36-.283-2.328-.604-3.156a6.4 6.4 0 0 0-1.5-2.302A6.4 6.4 0 0 0 21.516.685C20.688.361 19.744.142 18.36.08 16.977.016 16.53 0 13 0zM13 6.325a6.676 6.676 0 1 0 0 13.352 6.676 6.676 0 0 0 0-13.352m0 11.008a4.335 4.335 0 1 1 0-8.669 4.335 4.335 0 0 1 0 8.67M21.5 6.06a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0" clip-rule="evenodd"/><defs><linearGradient id="a" x1="13" x2="4" y1="-4" y2="26" gradientUnits="userSpaceOnUse"><stop stop-color="#DC3495"/><stop offset="1" stop-color="#F06130"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-social-instagram-error" class="svg-sprite__symbol"><path fill="url(#a)" fill-rule="evenodd" d="M14.58 6.002C14.16 6 13.649 6 13 6l.002-.002c-2.716 0-3.057.012-4.124.06-1.066.05-1.792.22-2.428.467a4.9 4.9 0 0 0-1.772 1.153c-.508.5-.9 1.104-1.15 1.771-.25.636-.42 1.363-.468 2.428S3 13.284 3 16s.012 3.056.06 4.123c.05 1.066.218 1.79.465 2.427a4.9 4.9 0 0 0 1.153 1.771 4.9 4.9 0 0 0 1.772 1.154c.635.247 1.363.416 2.427.465 1.064.048 1.407.06 4.123.06s3.057-.012 4.123-.06c1.067-.049 1.791-.218 2.427-.465a5.11 5.11 0 0 0 2.925-2.925c.247-.635.416-1.363.465-2.427.043-.927.056-1.307.06-3.185a8 8 0 0 1-1.8.022c-.004 1.81-.017 2.17-.058 3.082-.045.975-.208 1.505-.345 1.857a3.31 3.31 0 0 1-1.898 1.898c-.352.137-.882.3-1.856.344-1.055.048-1.371.059-4.041.059s-2.987-.01-4.041-.059c-.975-.044-1.505-.207-1.857-.344a3.1 3.1 0 0 1-1.151-.748 3.1 3.1 0 0 1-.749-1.151c-.137-.353-.3-.883-.344-1.857-.048-1.055-.058-1.371-.058-4.041s.01-2.987.058-4.041c.045-.975.207-1.505.344-1.857.16-.435.416-.829.749-1.151a3.1 3.1 0 0 1 1.15-.749c.353-.137.883-.3 1.858-.344C10.015 7.81 10.33 7.8 13 7.8L13 7.8l1.09.001c.093-.627.26-1.23.49-1.8m-.322 5.02a5.136 5.136 0 1 0 3.877 4.984 8.02 8.02 0 0 1-3.877-4.985m-3.11 7.75a3.334 3.334 0 1 0 3.704-5.546 3.334 3.334 0 0 0-3.704 5.545" clip-rule="evenodd"/><circle cx="22" cy="9" r="5.25" fill="#fff" stroke="#E74B63" stroke-width="1.5"/><path stroke="#E74B62" stroke-width="1.5" d="m26 5-8 8"/><defs><linearGradient id="a" x1="13" x2="6.077" y1="2.923" y2="26" gradientUnits="userSpaceOnUse"><stop stop-color="#DC3495"/><stop offset="1" stop-color="#F06130"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" id="svg-name-social-mail" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M13 0C5.83 0 0 5.831 0 13s5.831 13 13 13a12.96 12.96 0 0 0 7.323-2.26l-1.704-1.982a10.37 10.37 0 0 1-5.62 1.65C7.261 23.407 2.592 18.738 2.592 13c0-5.74 4.669-10.41 10.407-10.41 5.74 0 10.41 4.67 10.41 10.41 0 .754-.086 1.506-.247 2.238-.333 1.368-1.288 1.79-2.02 1.733-.722-.058-1.516-.574-1.586-1.846v-2.125a6.563 6.563 0 0 0-6.557-6.556 6.56 6.56 0 0 0-6.555 6.556A6.563 6.563 0 0 0 13 19.556a6.53 6.53 0 0 0 4.681-1.973 4.19 4.19 0 0 0 3.255 1.973 4.34 4.34 0 0 0 2.97-.871c.783-.595 1.353-1.44 1.672-2.462a1.3 1.3 0 0 0 .071-.209l.075-.338c.184-.876.277-1.773.277-2.675C26 5.83 20.169 0 13 0M9.036 13a3.967 3.967 0 0 1 3.962-3.963A3.97 3.97 0 0 1 16.963 13 3.967 3.967 0 0 1 13 16.963a3.967 3.967 0 0 1-3.962-3.962" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="26" fill="currentColor" id="svg-name-social-ok" class="svg-sprite__symbol"><path d="M7.883 0a6.738 6.738 0 1 0 0 13.475A6.738 6.738 0 0 0 7.883 0m0 9.523a2.785 2.785 0 1 1 0-5.57 2.785 2.785 0 0 1 0 5.57M10.262 18.836c2.697-.55 4.313-1.826 4.399-1.895a1.832 1.832 0 0 0-2.292-2.858c-.017.013-1.74 1.335-4.577 1.337-2.837-.002-4.597-1.324-4.614-1.338a1.832 1.832 0 0 0-2.292 2.859c.087.07 1.77 1.38 4.543 1.917l-3.865 4.038a1.832 1.832 0 1 0 2.638 2.544l3.59-3.825 3.952 3.85a1.832 1.832 0 1 0 2.59-2.593z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="27" height="12" id="svg-name-social-soundcloud" class="svg-sprite__symbol"><path fill="currentColor" d="M15.818 0C13.748 0 12 .989 10.91 2.625V12h11.455c2.07 0 3.818-1.747 3.818-3.818s-1.747-3.818-3.818-3.818c-.218 0-.533-.009-.75.102C20.957 1.849 18.545 0 15.818 0m-7.09 2.182V12h1.09V2.284c-.328-.11-.763-.102-1.09-.102m-1.092.102c-.434.11-.762.332-1.09.443V12h1.09zM5.455 3.716a3.35 3.35 0 0 0-.99 1.943h-.101V12h1.09V3.716zM3.273 5.455c-.435 0-.763.093-1.091.204v6.136c.328.111.656.205 1.09.205zM1.09 6.34A3.1 3.1 0 0 0 0 8.727a3.1 3.1 0 0 0 1.09 2.387z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="20" id="svg-name-social-telegram" class="svg-sprite__symbol"><path fill="currentColor" d="M19.314.036a2.6 2.6 0 0 0-.83.198c-.227.09-1.043.432-2.342.977-1.298.545-3.02 1.267-4.853 2.038-3.67 1.543-7.792 3.279-9.904 4.168-.072.03-.367.12-.692.369-.327.249-.689.79-.689 1.38 0 .478.238.963.526 1.242.287.278.579.408.822.505v-.003l3.867 1.546c.207.622 1.098 3.286 1.31 3.956h-.002c.15.474.296.782.5 1.04.1.13.222.246.37.338q.087.052.184.089.013.005.026.008l-.024-.006c.018.007.035.018.053.025.03.01.052.01.093.018.145.045.289.075.423.075.573 0 .925-.312.925-.312l.023-.016 2.477-2.096 3.034 2.807c.055.078.49.666 1.494.666.6 0 1.074-.297 1.377-.608.303-.312.492-.63.577-1.062l.002-.002c.068-.348 2.972-14.932 2.972-14.932l-.006.024c.09-.403.117-.793.01-1.191a1.7 1.7 0 0 0-.742-.99 1.74 1.74 0 0 0-.98-.25zm-.416 2.31c-.115.577-2.716 13.648-2.877 14.467l-4.382-4.054-2.962 2.504.82-3.207s5.66-5.728 6-6.061c.275-.267.332-.36.332-.454 0-.123-.064-.212-.21-.212-.132 0-.311.127-.406.186-1.207.752-6.347 3.681-8.875 5.12-.152-.062-2.436-.979-3.667-1.47L16.96 3.157a451 451 0 0 1 1.939-.81z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-social-telegram-filled" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#fff" d="M1.471 11.042s10.615-4.356 14.296-5.89c1.412-.614 6.197-2.577 6.197-2.577s2.21-.859 2.025 1.227c-.061.86-.552 3.866-1.043 7.118-.736 4.601-1.534 9.632-1.534 9.632s-.123 1.412-1.166 1.657-2.76-.859-3.067-1.104c-.246-.184-4.602-2.945-6.197-4.295-.43-.368-.92-1.105.06-1.964 2.21-2.024 4.848-4.54 6.443-6.135.737-.737 1.473-2.455-1.595-.368-4.356 3.006-8.651 5.828-8.651 5.828s-.982.614-2.823.062S.428 12.944.428 12.944s-1.472-.92 1.043-1.902"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-telegram-new" class="svg-sprite__symbol"><path fill="currentColor" d="M18.455 2.62c-.3-.254-.771-.29-1.259-.095-.512.206-14.505 6.207-15.074 6.453-.104.036-1.009.373-.916 1.125.084.678.81.959.9.991l3.557 1.218c.236.786 1.106 3.684 1.298 4.304.12.386.316.893.659.997.3.116.6.01.793-.142l2.175-2.017 3.51 2.738.084.05q.358.158.685.158.253 0 .485-.095c.526-.215.736-.717.758-.773L18.732 3.9c.16-.728-.062-1.099-.277-1.28M8.8 12.8 7.6 16l-1.2-4 9.2-6.8z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-telegram-round" class="svg-sprite__symbol"><defs><linearGradient id="a" x1="66.7%" x2="41.7%" y1="16.7%" y2="75%"><stop offset="0%" stop-color="#37AEE2"/><stop offset="100%" stop-color="#1E96C8"/></linearGradient><linearGradient id="b" x1="66%" x2="85.1%" y1="43.7%" y2="80.2%"><stop offset="0%" stop-color="#EFF7FC"/><stop offset="100%" stop-color="#FFF"/></linearGradient></defs><g fill="none"><circle cx="13" cy="13" r="13" fill="url(#a)"/><path fill="#C8DAEA" d="M10.617 18.958c-.422 0-.35-.159-.495-.56l-1.239-4.076 9.534-5.655"/><path fill="#A9C9DD" d="M10.617 18.958c.325 0 .468-.148.65-.325L13 16.948l-2.162-1.304"/><path fill="url(#b)" d="m10.838 15.644 5.239 3.871c.598.33 1.029.16 1.178-.555l2.132-10.05c.219-.875-.333-1.272-.905-1.012L5.96 12.726c-.855.343-.85.82-.156 1.033l3.213 1.003 7.44-4.694c.351-.213.673-.098.409.136"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-tiktok" class="svg-sprite__symbol"><path fill="currentColor" d="M18.99 5.008a5.24 5.24 0 0 1-3.118-1.018A5.04 5.04 0 0 1 13.909.945a5 5 0 0 1-.1-.945h-3.345v8.923l-.004 4.888c0 1.306-.872 2.414-2.08 2.804a3.1 3.1 0 0 1-2.509-.27c-.872-.509-1.464-1.433-1.48-2.49-.025-1.652 1.343-2.999 3.034-2.999.334 0 .655.053.955.15V7.69a7 7 0 0 0-.965-.07 6.49 6.49 0 0 0-4.82 2.105 6.05 6.05 0 0 0-1.583 3.696c-.113 1.797.56 3.506 1.867 4.766q.288.277.605.516A6.52 6.52 0 0 0 7.416 20q.489 0 .964-.07a6.45 6.45 0 0 0 3.572-1.743c1.206-1.163 1.872-2.707 1.879-4.351l-.018-7.299a8.5 8.5 0 0 0 1.88 1.07A8.6 8.6 0 0 0 19 8.258V5.007z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" id="svg-name-social-twitch" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M2.6 4.643 7.204 0H24.7v13l-8.287 8.357h-3.684L8.125 26v-4.643H2.6zm16.575 11.143 3.683-3.715V1.857H8.125v13.929h4.144v3.25l3.223-3.25z" clip-rule="evenodd"/><path d="M20.096 5.107h-1.842v5.572h1.842zM15.031 5.107H13.19v5.572h1.841z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="16" id="svg-name-social-twitter" class="svg-sprite__symbol"><path fill="currentColor" d="M19.941 1.89a8.3 8.3 0 0 1-2.35.633 4.05 4.05 0 0 0 1.8-2.229c-.803.47-1.682.8-2.598.978A4.12 4.12 0 0 0 13.806 0c-2.26 0-4.091 1.803-4.091 4.029q.002.473.105.917A11.68 11.68 0 0 1 1.388.736a3.97 3.97 0 0 0-.554 2.026c0 1.397.723 2.63 1.82 3.353a4.1 4.1 0 0 1-1.853-.504v.05c0 1.952 1.41 3.58 3.282 3.95a4.2 4.2 0 0 1-1.848.07 4.09 4.09 0 0 0 3.822 2.797 8.3 8.3 0 0 1-5.081 1.725A8 8 0 0 1 0 14.146a11.7 11.7 0 0 0 6.27 1.81c7.527 0 11.642-6.138 11.642-11.46q0-.263-.012-.522a8.2 8.2 0 0 0 2.04-2.084z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-vk" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M14.19 21.384C5.328 21.384.273 15.31.063 5.2H4.5c.148 7.42 3.418 10.561 6.012 11.21V5.217h4.18v6.4c2.559-.276 5.25-3.192 6.156-6.4h4.18c-.696 3.95-3.612 6.867-5.685 8.068a12.8 12.8 0 0 1 6.657 8.1h-4.6c-.988-3.076-3.45-5.444-6.708-5.782v5.782z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h26v26H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-vk-new" class="svg-sprite__symbol"><path fill="#fff" d="M2.996 2h16v16h-16z"/><g clip-path="url(#a)"><path fill="#07F" fill-rule="evenodd" d="M1.4 1.4C0 2.812 0 5.074 0 9.6v.914c0 4.456 0 6.698 1.4 8.086C2.812 20 5.074 20 9.6 20h.914c4.456 0 6.698 0 8.086-1.4 1.4-1.412 1.4-3.674 1.4-8.2v-.914c0-4.456 0-6.698-1.4-8.086C17.188 0 14.926 0 10.4 0h-.914C5.03 0 2.788 0 1.4 1.4m1.979 4.676c.108 5.2 2.708 8.324 7.266 8.324h.258v-2.974c1.676.174 2.942 1.392 3.45 2.974h2.366a6.58 6.58 0 0 0-3.424-4.166c1.066-.618 2.566-2.118 2.924-4.15h-2.15c-.466 1.65-1.85 3.15-3.166 3.292V6.084h-2.15v5.758c-1.334-.334-3.016-1.95-3.092-5.766z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="14" id="svg-name-social-youtube" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M19.5 2.162c.415 1.542.415 4.76.415 4.76s0 3.218-.416 4.76a2.49 2.49 0 0 1-1.76 1.748c-1.553.414-7.781.414-7.781.414s-6.228 0-7.781-.414a2.49 2.49 0 0 1-1.76-1.748C0 10.14 0 6.922 0 6.922s0-3.218.416-4.76A2.49 2.49 0 0 1 2.176.413C3.73 0 9.959 0 9.959 0s6.228 0 7.78.413A2.49 2.49 0 0 1 19.5 2.162M7.965 9.888l5.174-2.966-5.174-2.967z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="svg-name-sparks" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.5 12.5a4.34 4.34 0 0 0-4-4 4.34 4.34 0 0 0 4-4 4.34 4.34 0 0 0 4 4 4.34 4.34 0 0 0-4 4M10.5 1.5a2.17 2.17 0 0 1-2 2 2.17 2.17 0 0 1 2 2 2.17 2.17 0 0 1 2-2 2.17 2.17 0 0 1-2-2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-square_stack_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13.262 2.66a1.75 1.75 0 0 1 1.473 0l10.25 4.752c1.351.627 1.351 2.548 0 3.175l-10.25 4.755a1.75 1.75 0 0 1-1.472 0L3.014 10.596c-1.351-.627-1.352-2.548-.001-3.175zm.737 1.864L4.344 9.007l9.654 4.472L23.654 9zm11.908 9.524a1 1 0 0 1-.485 1.329l-10.687 4.96a1.75 1.75 0 0 1-1.472.001L2.582 15.393a1 1 0 0 1 .84-1.815l10.576 4.897 10.581-4.913a1 1 0 0 1 1.328.486m-.48 6.253a1 1 0 1 0-.852-1.81l-10.577 4.98-10.57-4.964a1 1 0 1 0-.851 1.81l10.677 5.014a1.75 1.75 0 0 0 1.49 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-star" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="20" height="20" fill="#07F" rx="2.222"/><path fill="#fff" fill-rule="evenodd" d="M9.214 2.686 7.204 6.93l-4.659.6a.87.87 0 0 0-.487 1.497l3.417 3.224-.87 4.616a.871.871 0 0 0 1.275.925L10 15.54l4.122 2.253a.871.871 0 0 0 1.273-.925l-.869-4.616 3.417-3.224a.87.87 0 0 0-.487-1.497l-4.659-.6-2.01-4.245a.87.87 0 0 0-1.574 0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><rect width="20" height="20" fill="#fff" rx="2.222"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-star-outline" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M9.055 1.728c.31-.897 1.58-.897 1.89 0l1.546 4.466a1 1 0 0 0 .925.672l4.716.097c.947.019 1.34 1.222.585 1.795l-3.765 2.865a1 1 0 0 0-.352 1.085l1.367 4.534c.274.909-.752 1.652-1.53 1.109l-3.864-2.7a1 1 0 0 0-1.146 0l-3.864 2.7c-.778.543-1.804-.2-1.53-1.109L5.4 12.708a1 1 0 0 0-.352-1.085L1.283 8.758c-.754-.573-.362-1.776.585-1.795l4.716-.097a1 1 0 0 0 .925-.672z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" id="svg-name-subscribe" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.234 7.38a2.501 2.501 0 1 1 3.264-2.498 9.4 9.4 0 0 1 1.45-.535 4.001 4.001 0 1 0-5.611 4.292q.398-.668.897-1.259m-2.028 4.142c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.376a9.5 9.5 0 0 1-.812-1.5H2.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.271q.034-.814.198-1.588" clip-rule="evenodd"/><path fill-rule="evenodd" d="M16.5 21.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#fff" fill-rule="evenodd" d="M17.25 10.108a.75.75 0 0 0-1.5 0v2.857h-2.857a.75.75 0 1 0 0 1.5h2.857v2.857a.75.75 0 0 0 1.5 0v-2.857h2.857a.75.75 0 1 0 0-1.5H17.25z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="20" fill="none" id="svg-name-subscribe-category" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.654 1.484c-.544-1.57-2.764-1.57-3.307 0L6.8 5.949a.25.25 0 0 1-.231.168l-4.716.097C.195 6.248-.49 8.352.829 9.356l3.765 2.865a.25.25 0 0 1 .088.271l-1.367 4.535c-.48 1.59 1.317 2.89 2.677 1.94l2.068-1.444a9 9 0 0 1-.738-1.315l-2.188 1.529a.25.25 0 0 1-.383-.277l1.367-4.535a1.75 1.75 0 0 0-.616-1.898L1.737 8.162a.25.25 0 0 1 .146-.449L6.6 7.617A1.75 1.75 0 0 0 8.217 6.44l1.547-4.465a.25.25 0 0 1 .472 0l.974 2.812q.661-.354 1.382-.593z" clip-rule="evenodd"/><path fill="#07f" fill-rule="evenodd" d="M15.362 20a7.429 7.429 0 1 0 0-14.857 7.429 7.429 0 0 0 0 14.857" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.393" d="M15.362 9.42v6.7M18.711 12.772h-6.699"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" fill="none" id="svg-name-subscribed" class="svg-sprite__symbol"><path fill="#fff" fill-rule="evenodd" d="M9.091 10.076q.357-.676.814-1.282a3.001 3.001 0 1 1 4.078-3.121 9.4 9.4 0 0 1 1.45-.448A4.501 4.501 0 0 0 6.5 6a4.5 4.5 0 0 0 2.591 4.076m-.884 2.446c-1.583.33-2.828.932-3.803 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.377a9.5 9.5 0 0 1-.813-1.5H3.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.272q.034-.814.199-1.587" clip-rule="evenodd"/><path fill="#07F" fill-rule="evenodd" d="M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 15.75 17.938 17 20 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-subscribers-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M13.999 16.125c-.273-.803-.79-1.901-1.72-2.792-.914-.874-2.26-1.583-4.279-1.583s-3.365.709-4.278 1.583c-.931.89-1.448 1.99-1.72 2.792-.01.025-.007.037-.007.04a.1.1 0 0 0 .013.026c.02.024.067.059.148.059h11.688c.081 0 .129-.035.148-.059a.1.1 0 0 0 .013-.025c0-.004.002-.016-.006-.041Z"/><path fill="currentColor" fill-rule="evenodd" d="M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6M11.625 3.333a3 3 0 1 1 0 5.334c.295-.4.526-.853.676-1.34a1.5 1.5 0 1 0 0-2.655 4.5 4.5 0 0 0-.676-1.339M16.68 17h2.164c.61 0 1.061-.54.865-1.117C19.119 14.149 17.437 11 13 11h-.065a8.5 8.5 0 0 1 1.7 1.697 4.75 4.75 0 0 1 2.125 1.178c.52.498.9 1.079 1.17 1.625h-1.748c.216.546.378 1.058.499 1.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-subsribers-stat" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="#59A840" stroke-width="1.5"/><path stroke="#59A840" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.7 12H13m2.7 0V9.308m0 2.692v2.692m0-2.692h2.8"/><path fill="#59A840" fill-rule="evenodd" d="M4.296 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.005.008c.011.015.052.052.138.052h15.59c.085 0 .126-.037.137-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.455-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.306.411-.801.658-1.342.658H2.205c-.541 0-1.037-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.496.737-5.704 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="25" id="svg-name-success" class="svg-sprite__symbol"><g fill="inherit" fill-rule="evenodd"><rect width="25" height="25" rx="12.5"/><path fill="#FFF" d="M17.238 6 19 6.904 12.902 20 6 16.285l.895-1.832 5.123 2.758z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sword" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="20" height="20" fill="#59A840" rx="2.222"/><g clip-path="url(#b)"><path fill="#fff" d="m17.137 2.504-2.013.337a4.83 4.83 0 0 0-2.9 1.647l-4.843 5.725-.184-.184a.97.97 0 0 0-1.37 0l-.752.753a.315.315 0 0 0 0 .443l1.022 1.019L4.04 14.3a1.6 1.6 0 0 0-1.072.463A1.602 1.602 0 0 0 4.103 17.5c.413 0 .822-.156 1.134-.469A1.6 1.6 0 0 0 5.7 15.96l2.056-2.057.969.972c.059.06.14.094.222.094a.31.31 0 0 0 .221-.094l.753-.753a.95.95 0 0 0 .285-.684c0-.26-.1-.5-.285-.685l-.134-.134 5.725-4.843a4.83 4.83 0 0 0 1.647-2.9l.337-2.013a.313.313 0 0 0-.36-.36Z"/></g></g><defs><clipPath id="a"><rect width="20" height="20" fill="#fff" rx="2.222"/></clipPath><clipPath id="b"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sword-new" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.65" clip-path="url(#a)"><path d="m5.953 10.328 5.938-7.187 4.984-.016-.015 4.984-7.188 5.938"/><path d="M6.415 15.425 4.079 17.76a.625.625 0 0 1-.883 0l-.96-.961a.625.625 0 0 1 0-.883L4.57 13.58a.626.626 0 0 0 0-.89l-1.625-1.626a.625.625 0 0 1 0-.89l.984-.985a.625.625 0 0 1 .891 0l5.984 5.985a.626.626 0 0 1 0 .89l-.984.985a.624.624 0 0 1-.89 0l-1.626-1.625a.626.626 0 0 0-.89 0"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0.2 -0.3 9 11.4" id="svg-name-text" class="svg-sprite__symbol"><path d="M0 2.77V.92A1 1 0 0 1 .2.28C.35.1.56 0 .83 0h7.66c.28.01.48.1.63.28.14.17.21.38.21.64v1.85a1 1 0 0 1-.23.66c-.15.17-.37.26-.66.26-.28 0-.5-.09-.64-.26a1 1 0 0 1-.21-.66V1.69H5.6v7.58h.5c.25 0 .45.08.6.23.17.16.25.35.25.6s-.08.45-.24.6a.87.87 0 0 1-.62.22H3.21a.87.87 0 0 1-.61-.22.78.78 0 0 1-.24-.6c0-.25.08-.44.24-.6a.85.85 0 0 1 .61-.23h.5V1.7H1.73v1.08a1 1 0 0 1-.23.66c-.15.17-.37.26-.66.26-.28 0-.5-.09-.64-.26a1 1 0 0 1-.2-.67"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-text_style_1_28" class="svg-sprite__symbol"><path fill="currentColor" d="M10.883 18.41c-.596 0-.97-.349-.97-.9 0-.16.044-.375.126-.61l2.501-6.811c.267-.743.717-1.086 1.441-1.086.749 0 1.193.33 1.466 1.08l2.514 6.817c.089.248.12.419.12.61 0 .526-.4.9-.958.9-.54 0-.825-.247-.997-.844l-.482-1.447h-3.307l-.482 1.428c-.178.61-.464.864-.972.864m1.873-3.776H15.2l-1.213-3.752h-.044z"/><path fill="currentColor" fill-rule="evenodd" d="M6.07 3.801C7.164 3.216 8.243 3 10.691 3h6.616c2.448 0 3.527.216 4.622.801A5.47 5.47 0 0 1 24.2 6.07c.585 1.096.801 2.175.801 4.623v6.616c0 2.448-.216 3.527-.801 4.622A5.47 5.47 0 0 1 21.93 24.2c-1.095.585-2.174.801-4.622.801h-6.616c-2.448 0-3.527-.216-4.623-.801a5.47 5.47 0 0 1-2.268-2.269C3.216 20.836 3 19.757 3 17.309v-6.616c0-2.448.216-3.527.801-4.623A5.47 5.47 0 0 1 6.07 3.801M10.691 5c-2.335 0-3.019.212-3.68.565a3.47 3.47 0 0 0-1.447 1.448C5.212 7.673 5 8.357 5 10.692v6.616c0 2.335.212 3.019.565 3.68a3.47 3.47 0 0 0 1.448 1.447c.66.353 1.344.565 3.679.565h6.616c2.335 0 3.019-.212 3.68-.565a3.47 3.47 0 0 0 1.447-1.448c.353-.66.565-1.344.565-3.679v-6.616c0-2.335-.212-3.019-.565-3.68a3.47 3.47 0 0 0-1.448-1.447C20.327 5.212 19.643 5 17.308 5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="svg-name-theatre" class="svg-sprite__symbol"><rect width="22" height="16" x="1" y="4" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M19 4v16"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-thread" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.903a2.857 2.857 0 0 0-2.847-2.857L4.867 3.01A2.857 2.857 0 0 0 2 5.867V18l3-3h10.127a2.857 2.857 0 0 0 2.857-2.857z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.25h8.5M5.75 10.75h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-thumbs_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M5 24a1 1 0 1 1-2 0V12a1 1 0 1 1 2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M13.081 4c-.548 0-1.048.316-1.282.812L9.353 9.98A3.7 3.7 0 0 0 9 11.549V20.5a2.5 2.5 0 0 0 2.5 2.5h7.009a2.5 2.5 0 0 0 2.323-1.576l2.982-7.5a2.5 2.5 0 0 0-2.323-3.424h-5.609A1.38 1.38 0 0 1 14.5 9.118v-3.7C14.5 4.636 13.865 4 13.081 4m-3.09-.044A3.419 3.419 0 0 1 16.5 5.42V8.5h4.991c3.18 0 5.357 3.208 4.182 6.163l-2.983 7.5A4.5 4.5 0 0 1 18.51 25H11.5A4.5 4.5 0 0 1 7 20.5v-8.951c0-.839.186-1.667.545-2.425z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" id="svg-name-time" class="svg-sprite__symbol"><g stroke="currentColor" stroke-width="1.125" clip-path="url(#a)"><circle cx="7.5" cy="7.5" r="6.75"/><path stroke-linecap="round" d="M7.5 7.5V3.75M9.565 8.395 7.5 7.5M7.5 7.5V3.75M9.565 8.395 7.5 7.5"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h15v15H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-tip" class="svg-sprite__symbol"><circle cx="12" cy="12" r="10.8" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M12 15.535a.75.75 0 0 0 0 1.5zM10.217 10.8l.525-.536a1 1 0 0 0-.093-.077zm-.594-1.2.75.026V9.6zM12 8.465a.75.75 0 0 0 0-1.5zm-.031 8.57a.75.75 0 0 0 .062-1.498zm-1.603-3.511a.75.75 0 1 0-1.487-.199zm2.384 2.761a.75.75 0 0 0-1.5 0zM11.25 18a.75.75 0 0 0 1.5 0zm.707-11.034a.75.75 0 1 0 .085 1.498zm1.846 1.49-.556.503zm-.169 1.771a.75.75 0 1 0 1.485.212zM11.25 7.715a.75.75 0 0 0 1.5 0zM12.75 6a.75.75 0 0 0-1.5 0zM12 17.035c.488 0 1.221-.112 1.861-.482.678-.392 1.266-1.092 1.266-2.176h-1.5c0 .443-.203.696-.517.877-.35.203-.805.281-1.11.281zm3.127-2.658c0-.67-.207-1.209-.58-1.644-.349-.406-.81-.68-1.235-.902-.908-.474-1.783-.795-2.57-1.566l-1.05 1.07c.996.977 2.201 1.447 2.927 1.826.392.204.637.37.79.549.128.15.218.338.218.667zm-4.478-4.19a.66.66 0 0 1-.276-.561l-1.5-.052c-.024.727.317 1.42.912 1.84zm-.276-.587c0-.338.073-.538.148-.66a.77.77 0 0 1 .327-.286c.323-.16.758-.19 1.152-.19v-1.5c-.398 0-1.152.015-1.82.347-.35.174-.689.44-.936.842q-.37.602-.371 1.447zm1.658 5.937a1.74 1.74 0 0 1-1.27-.63l-1.153.958a3.24 3.24 0 0 0 2.36 1.17zm-1.27-.63a1.8 1.8 0 0 1-.395-1.383l-1.487-.199a3.3 3.3 0 0 0 .729 2.54zm.489 1.378V18h1.5v-1.715zm.792-7.821c.454-.026.896.155 1.206.495l1.11-1.008a3.01 3.01 0 0 0-2.4-.985zm1.206.495c.31.342.452.807.386 1.268l1.485.212a3.06 3.06 0 0 0-.76-2.488zm-.498-1.244V6h-1.5v1.715z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-toggler-arrow" class="svg-sprite__symbol"><path stroke="#F1F1F1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 10H7m9 0-5.2 5m5.2-5-5.2-5"/><path fill="#F1F1F1" d="M3.25 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zm0 10V5h-1.5v10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="18" id="svg-name-trash" class="svg-sprite__symbol"><path fill-rule="evenodd" d="m5.4 0-.9.9H0v1.8h14.4V.9H9.9L9 0zM.9 4.5v11.7c0 .99.81 1.8 1.8 1.8h9c.99 0 1.8-.81 1.8-1.8V4.5zm2.7 1.8h1.8v9.9H3.6zm5.4 0h1.8v9.9H9z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trash-draft" class="svg-sprite__symbol"><path fill="currentColor" d="M10 0a3 3 0 0 0-3 3H3a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2h-4a3 3 0 0 0-3-3m1 3a1 1 0 1 0-2 0zM3 15.5V6h2v9.5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6h2v9.5a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4M7 6v10.5h2V6zm4 10.5V6h2v10.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-triangle-in-circle" class="svg-sprite__symbol"><rect width="12.6" height="12.6" x=".7" y=".7" stroke="currentColor" stroke-width="1.05" rx="6.3"/><path stroke="currentColor" stroke-width="1.05" d="M4.9 8.668V5.333a.7.7 0 0 1 1.013-.626l3.335 1.667a.7.7 0 0 1 0 1.252L5.913 9.294A.7.7 0 0 1 4.9 8.668Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trophy" class="svg-sprite__symbol"><path fill="currentColor" d="M10.733 11.822a.737.737 0 0 0-1.473 0zM9.26 17.425a.736.736 0 1 0 1.473 0zm.464-4.919a.736.736 0 1 0 .546-1.368zM6.038 7.633a.736.736 0 1 0-1.242.791zm3.685 3.505a.737.737 0 0 0 .546 1.368zm5.474-2.714a.737.737 0 0 0-1.242-.791zm-5.2 9.738a.737.737 0 1 0 0-1.473zm-2.385-1.473a.736.736 0 1 0 0 1.473zm2.384 0a.736.736 0 1 0 0 1.473zm2.385 1.473a.737.737 0 0 0 0-1.473zM3.213 3.848a.737.737 0 0 0 1.47-.109zm2.508-1.845-.047.735.047.002zm8.551 0v.737q.024 0 .048-.002zm1.295.492.523-.518zm-.256 1.244a.737.737 0 0 0 1.47.109zm-11.363.79a.736.736 0 1 0 0-1.472V4.53zM1.9 3.794l-.051.735.05.002zm-.638.23L.754 3.49zM1 4.65h.737v-.014zm2.415 3.586-.277.682.065.023zm.243.033v-.736h-.014zm1.109 0 .001-.736h-.001zm1.127.315a.736.736 0 0 0-.969-1.11zM4.677 3.696a.736.736 0 0 0-1.46.196zm.105 4.708a.736.736 0 1 0 1.268-.751l-1.268.75zm11.262-5.347a.737.737 0 0 0 0 1.473zm2.056.736v.737l.051-.002zm.638.23.508-.533zM19 4.65l-.736-.014v.014zm-2.415 3.586.212.705.065-.023zm-.243.033.014-.736h-.014zm-1.109 0v-.736h-.001zm-.158-.795a.737.737 0 0 0-.969 1.11zm1.715-3.581a.736.736 0 1 0-1.46-.196zm-2.833 3.761a.737.737 0 0 0 1.267.75zM9.26 11.822v5.603h1.473v-5.603zm1.01-.684a8.96 8.96 0 0 1-4.232-3.505l-1.242.791a10.44 10.44 0 0 0 4.928 4.082zm0 1.368a10.44 10.44 0 0 0 4.928-4.082l-1.243-.791a8.96 8.96 0 0 1-4.232 3.505l.546 1.368zm-.273 4.183H7.612v1.473h2.385zm0 1.473h2.384v-1.473H9.996zM4.681 3.739a.93.93 0 0 1 .268-.726L3.904 1.977a2.4 2.4 0 0 0-.69 1.87l1.468-.108zm.268-.726a.93.93 0 0 1 .724-.275l.094-1.47a2.4 2.4 0 0 0-1.864.709L4.95 3.013zm.771-.273h8.551V1.267h-8.55V2.74zm8.599-.002a.93.93 0 0 1 .723.275l1.047-1.036a2.4 2.4 0 0 0-1.865-.709zm.723.275c.19.192.288.457.268.726l1.47.109a2.4 2.4 0 0 0-.691-1.871zm-11.095.044H1.9V4.53h2.048zm-1.998.002a1.58 1.58 0 0 0-1.196.43l1.015 1.068q.034-.03.08-.029zm-1.196.43c-.32.306-.499.732-.49 1.174l1.473-.028a.1.1 0 0 1 .032-.078L.754 3.49zm-.49 1.16a4.605 4.605 0 0 0 2.874 4.268l.554-1.365A3.13 3.13 0 0 1 1.737 4.65H.264zm2.94 4.291q.23.07.469.065l-.028-1.473q-.008 0-.017-.002zm.455.065h1.109V7.532h-1.11v1.473zm1.107 0c.415 0 .816-.15 1.129-.422l-.969-1.11a.24.24 0 0 1-.157.059zM3.217 3.892a12 12 0 0 0 1.565 4.512l1.268-.751a10.5 10.5 0 0 1-1.373-3.957zm12.827.638H18.1V3.057h-2.056zm2.107-.002a.1.1 0 0 1 .08.029l1.015-1.067a1.58 1.58 0 0 0-1.196-.431zm.08.029c.021.02.033.049.033.078l1.472.028a1.58 1.58 0 0 0-.49-1.173zm.032.092a3.13 3.13 0 0 1-1.955 2.903l.554 1.365a4.605 4.605 0 0 0 2.874-4.268zm-1.89 2.88-.017.003-.028 1.473q.24.004.47-.065zm-.03.003h-1.11v1.473h1.11zm-1.111 0a.24.24 0 0 1-.157-.059l-.969 1.11c.313.273.714.423 1.129.422zm.098-3.836a10.5 10.5 0 0 1-1.373 3.957l1.267.75a12 12 0 0 0 1.566-4.511z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trophy-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><g clip-path="url(#b)"><path fill="url(#c)" d="M7.423 3.297A2.63 2.63 0 0 0 4.8 5.92c0 1.426.574 3.015 1.362 4.31.394.647.842 1.222 1.334 1.653s1.04.745 1.662.745h1.636c.655 0 1.2-.366 1.689-.84.49-.473.934-1.093 1.326-1.77.784-1.35 1.362-2.89 1.343-4.103a2.63 2.63 0 0 0-2.622-2.618z"/><path fill="url(#d)" d="M7.255 13.21c-.744 0-1.36.622-1.36 1.366v.775c0 .744.616 1.36 1.36 1.36h5.443a1.37 1.37 0 0 0 1.36-1.36v-.775c0-.744-.616-1.365-1.36-1.365z"/><path fill="url(#e)" d="M3.604 5.043a.583.583 0 0 0-.582.582c0 1.48-.069 2.556.418 3.436.243.44.66.789 1.176.978.283.104.598.167.949.206-.805-1.4-1.379-3.064-1.379-4.57 0-.217.028-.428.073-.632zm12.09 0c.044.203.072.412.072.628.022 1.356-.625 3.078-1.501 4.589.42-.035.79-.102 1.116-.221a2.2 2.2 0 0 0 1.175-.978c.486-.88.422-1.955.422-3.436a.583.583 0 0 0-.585-.582z"/></g><defs><linearGradient id="a" x1="12.5" x2="3.326" y1="8" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#A50FEB"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="c" x1="14.085" x2="9.325" y1="2.687" y2="10.67" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><linearGradient id="d" x1="13.217" x2="12.151" y1="12.982" y2="16.74" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><linearGradient id="e" x1="15.542" x2="14.132" y1="4.702" y2="10.404" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><clipPath id="b"><path fill="#fff" d="M3 3h14v14H3z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="70" height="70" fill="none" id="svg-name-tv" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3" d="m37.148 23.027 6.12 6.012-6.12 6.011m-11.019-6.01h16.969"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10.004 20.168v18.246c-.166 6.55 5.039 11.995 11.63 12.167h26.728c6.593-.17 11.8-5.616 11.634-12.167V20.168c.166-6.55-5.039-11.996-11.63-12.168H21.634c-6.591.172-11.796 5.618-11.63 12.168" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="3" d="M17.146 61.225h35.71"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-tv_text_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M14.578 12.745h-.101l-2.324-6.78c-.218-.662-.56-.965-1.104-.965-.606 0-1.049.36-1.049.879 0 .202.062.483.171.778l2.62 6.989c.341.943.846 1.354 1.724 1.354.863 0 1.353-.403 1.695-1.354l2.627-6.989c.093-.267.163-.59.163-.785C19 5.353 18.565 5 17.966 5c-.56 0-.878.281-1.096.965zM4.996 15.002c.615 0 1-.4 1-1.047V6.653h2.146c.503 0 .858-.342.858-.822 0-.487-.355-.83-.858-.83H1.858c-.495 0-.858.35-.858.83 0 .473.363.822.858.822h2.14v7.302c0 .654.377 1.047.998 1.047"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-underline" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 3v6a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5V3"/><path fill="currentColor" d="M5 16.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-underline-active" class="svg-sprite__symbol"><path stroke="#F15F2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 3v6a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5V3"/><path fill="#F15F2C" d="M5 16.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-unlocked" class="svg-sprite__symbol"><path fill="inherit" fill-rule="evenodd" d="M6.25 5.5a3.75 3.75 0 1 1 7.5 0v1.75H14A2.75 2.75 0 0 1 16.75 10v6A2.75 2.75 0 0 1 14 18.75H6A2.75 2.75 0 0 1 3.25 16v-6A2.75 2.75 0 0 1 6 7.25h6.25V5.5a2.25 2.25 0 0 0-4.5 0zM6 8.75c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-6c0-.69-.56-1.25-1.25-1.25zM10 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-unmute-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="m20 10.763 2.381-2.382A.875.875 0 1 1 23.62 9.62L21.237 12l2.382 2.381a.875.875 0 1 1-1.238 1.238L20 13.237l-2.381 2.382a.875.875 0 1 1-1.238-1.238L18.763 12 16.38 9.619A.875.875 0 1 1 17.62 8.38zm-7.02 8.06c-.031 1.207-.67 1.609-1.828.62-1.719-1.469-3.609-3.194-4.242-3.721-.632-.529-1.645-.62-3.073-.62s-1.815-.621-1.815-1.241-.014-1.83-.014-2.001c0-.055.005-.086.014-.13.02-.095-.058-.973 0-1.59.085-.906.388-1.241 1.815-1.241s2.44-.092 3.073-.62c.633-.529 2.523-2.253 4.242-3.722 1.158-.989 1.797-.587 1.829.62.043 1.607 0 3.85 0 6.683 0 2.83.043 5.356 0 6.963"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-unpin" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.616.96a2.39 2.39 0 0 0-3.37-.027h-.001L3.24.938.94 3.235l-.006.006A2.39 2.39 0 0 0 .96 6.612l3.526 3.53c.303.303.447.724.49 1.317.03.413.01.812-.011 1.252a25 25 0 0 0-.029.809l1.554-1.68a7 7 0 0 0-.018-.49c-.056-.763-.26-1.602-.925-2.268L2.018 5.55l-.003-.003a.89.89 0 0 1-.013-1.253l2.295-2.292a.89.89 0 0 1 1.254.013l.003.003L9.08 5.546c.665.666 1.505.87 2.268.925l.1.007 1.407-1.52q-.071.002-.14.006c-.442.022-.844.042-1.258.011-.593-.043-1.014-.187-1.316-.49zm8.063 4.236L13.527 6.44a2.28 2.28 0 0 1 1.747 1.158c.33.51.266 1.179-.154 1.616l-2.919 2.92a1 1 0 0 0-.063.062L9.215 15.12a1.31 1.31 0 0 1-1.648.134 2.28 2.28 0 0 1-1.026-1.262l-1.1 1.19A3.8 3.8 0 0 0 6.8 16.544a2.81 2.81 0 0 0 3.463-.35l.008-.008 2.43-2.43 5.768 5.77a.75.75 0 1 0 1.06-1.06l-5.768-5.77 2.425-2.425.008-.008a2.81 2.81 0 0 0 .35-3.463 3.78 3.78 0 0 0-1.865-1.604" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.807 2.68 3.333 18.326"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" id="svg-name-unsubscribe" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.234 7.38a2.501 2.501 0 1 1 3.264-2.498 9.4 9.4 0 0 1 1.45-.535 4.001 4.001 0 1 0-5.611 4.292q.398-.668.897-1.259m-2.028 4.142c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.376a9.5 9.5 0 0 1-.812-1.5H2.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.271q.034-.814.198-1.588" clip-rule="evenodd"/><path fill-rule="evenodd" d="M16.5 21.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#fff" d="M14.294 14.06a.75.75 0 0 0-.588 1.38zM16.937 16l-.293.69a.75.75 0 0 0 .987-.404zm2.756-4.714a.75.75 0 1 0-1.386-.572zm-5.987 4.154 2.938 1.25.587-1.38-2.937-1.25zm3.925.846 2.062-5-1.386-.572-2.063 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="20" fill="none" id="svg-name-unsubscribe-category" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.654 1.484c-.544-1.57-2.764-1.57-3.307 0L6.8 5.949a.25.25 0 0 1-.231.168l-4.716.097C.195 6.248-.49 8.352.829 9.356l3.765 2.865a.25.25 0 0 1 .088.271l-1.367 4.535c-.48 1.59 1.317 2.89 2.677 1.94l2.068-1.444a9 9 0 0 1-.738-1.315l-2.188 1.529a.25.25 0 0 1-.383-.277l1.367-4.535a1.75 1.75 0 0 0-.616-1.898L1.737 8.162a.25.25 0 0 1 .146-.449L6.6 7.617A1.75 1.75 0 0 0 8.217 6.44l1.547-4.465a.25.25 0 0 1 .472 0l.974 2.812q.661-.354 1.382-.593z" clip-rule="evenodd"/><path fill="#07f" fill-rule="evenodd" d="M15.362 20a7.429 7.429 0 1 0 0-14.857 7.429 7.429 0 0 0 0 14.857" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.393" d="m13.04 13.732 2.728 1.16 1.915-4.642"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-user" class="svg-sprite__symbol"><path d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0m0 3.575a4.225 4.225 0 1 1 0 8.45 4.225 4.225 0 0 1 0-8.45M13 23.4c-3.17 0-6.007-1.418-7.914-3.656a1.32 1.32 0 0 1 .224-1.912C7.284 16.35 10.877 15.6 13 15.6s5.717.749 7.69 2.232c.61.459.721 1.333.226 1.912A10.38 10.38 0 0 1 13 23.4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-user-new" class="svg-sprite__symbol"><g clip-path="url(#a)" filter="url(#b)"><path fill="currentColor" fill-rule="evenodd" d="M12.113 10.582c2.142 0 3.88-1.697 3.88-3.791S14.254 3 12.112 3s-3.88 1.697-3.88 3.791 1.737 3.791 3.88 3.791m-.89 1.058c-3.437 0-6.223 2.686-6.223 6v1.11C5 19.993 6.045 21 7.333 21h9.334C17.955 21 19 19.993 19 18.75v-1.11c0-3.314-2.786-6-6.222-6h-1.556" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath><filter id="b" width="20" height="24" x="2" y="1" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6951_87215"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_6951_87215" result="shape"/></filter></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M10 12c-5.68 0-7.848 3.12-8.616 4.86-.252.574.195 1.14.82 1.14h15.591c.626 0 1.073-.566.82-1.14C17.849 15.12 15.68 12 10 12Z"/><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user_book_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14.254 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M3 6.58h.006v1.28H2.25a.75.75 0 1 0 0 1.5h.756v1.28H2.25a.75.75 0 0 0 0 1.5h.756v1.28H2.25a.75.75 0 0 0 0 1.5H3a1 1 0 0 0 .107-.008C3.507 16.682 5.044 18 6.88 18h7.748c2.14 0 3.874-1.79 3.874-4V6c0-2.21-1.735-4-3.874-4H6.88C5.044 2 3.507 3.318 3.107 5.088A1 1 0 0 0 3 5.08h-.75a.75.75 0 1 0 0 1.5zM4.506 14c0 .388.082.75.227 1.071a10.185 10.185 0 0 1 12.039.008c.147-.323.23-.688.23-1.079V6c0-1.426-1.108-2.5-2.374-2.5H6.88C5.614 3.5 4.506 4.574 4.506 6zm6.24.608a8.7 8.7 0 0 1 5.01 1.59c-.34.194-.726.302-1.128.302H6.88c-.406 0-.795-.11-1.137-.307a8.68 8.68 0 0 1 5.003-1.585" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_card_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16 11a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zM17 16a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1M11 10a2 2 0 1 1 .001 3.999A2 2 0 0 1 11 10M7.503 18A.503.503 0 0 1 7 17.497C7 15.607 9.5 15 11 15s4 .5 4 2.5v-.003a.503.503 0 0 1-.502.503z"/><path fill="currentColor" fill-rule="evenodd" d="M10.956 4c-1.363 0-2.447 0-3.321.071-.896.074-1.66.227-2.359.583a6 6 0 0 0-2.622 2.622c-.356.7-.51 1.463-.583 2.359C2 10.509 2 11.593 2 12.956v2.088c0 1.363 0 2.447.071 3.321.074.896.227 1.66.583 2.359a6 6 0 0 0 2.622 2.622c.7.356 1.463.51 2.359.583.874.071 1.958.071 3.321.071h6.088c1.363 0 2.447 0 3.321-.071.896-.074 1.66-.227 2.359-.583a6 6 0 0 0 2.622-2.622c.356-.7.51-1.463.583-2.359.071-.874.071-1.958.071-3.321v-2.088c0-1.363 0-2.447-.071-3.321-.074-.896-.227-1.66-.583-2.359a6 6 0 0 0-2.622-2.622c-.7-.356-1.463-.51-2.359-.583C19.491 4 18.407 4 17.044 4zM6.184 6.436c.37-.189.842-.308 1.613-.371C8.581 6 9.583 6 11 6h6c1.417 0 2.419 0 3.203.065.771.063 1.243.182 1.613.371a4 4 0 0 1 1.748 1.748c.189.37.308.842.371 1.613C24 10.581 24 11.583 24 13v2c0 1.417 0 2.419-.065 3.203-.063.771-.182 1.243-.371 1.613a4 4 0 0 1-1.748 1.748c-.37.189-.841.308-1.613.371C19.419 22 18.417 22 17 22h-6c-1.417 0-2.419 0-3.203-.065-.771-.063-1.243-.182-1.613-.371a4 4 0 0 1-1.748-1.748c-.189-.37-.308-.841-.371-1.613C4 17.419 4 16.417 4 15v-2c0-1.417 0-2.419.065-3.203.063-.771.182-1.243.371-1.613a4 4 0 0 1 1.748-1.748" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3 3a9.87 9.87 0 0 1 7-2.9c2.733 0 5.21 1.11 7 2.9a9.87 9.87 0 0 1 2.9 7c0 2.734-1.11 5.21-2.9 7a9.87 9.87 0 0 1-7 2.9A9.87 9.87 0 0 1 3 17a9.87 9.87 0 0 1-2.9-7C.1 7.267 1.21 4.79 3 3m7 12.3c1.654 0 3.175.565 4.382 1.514A8.06 8.06 0 0 1 10 18.1a8.06 8.06 0 0 1-4.382-1.287A7.07 7.07 0 0 1 10 15.3m0-13.4c-2.237 0-4.26.906-5.728 2.373A8.07 8.07 0 0 0 1.9 10a8.07 8.07 0 0 0 2.297 5.652A8.87 8.87 0 0 1 10 13.5c2.217 0 4.245.811 5.803 2.152A8.07 8.07 0 0 0 18.1 10c0-2.237-.906-4.26-2.373-5.727A8.07 8.07 0 0 0 10 1.9" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 1.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14.5 2c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12m0 18.5c-2.086 0-4.08.582-5.797 1.649A9.95 9.95 0 0 0 14.5 24c2.16 0 4.161-.685 5.796-1.85A10.94 10.94 0 0 0 14.5 20.5m0-16.5c-5.523 0-10 4.477-10 10a9.96 9.96 0 0 0 2.648 6.779A12.93 12.93 0 0 1 14.5 18.5c2.67 0 5.215.808 7.353 2.277A9.96 9.96 0 0 0 24.5 14c0-5.523-4.477-10-10-10m0 3.5a4.75 4.75 0 0 1 4.75 4.75A4.75 4.75 0 0 1 14.5 17a4.75 4.75 0 0 1-4.75-4.75A4.75 4.75 0 0 1 14.5 7.5m0 2c-1.52 0-2.75 1.23-2.75 2.75S12.98 15 14.5 15s2.75-1.23 2.75-2.75S16.02 9.5 14.5 9.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="57" height="57" fill="none" id="svg-name-user_circle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M37.531 24.531c0 5.249-4.251 9.5-9.5 9.5a9.5 9.5 0 0 1-9.5-9.5c0-5.248 4.252-9.5 9.5-9.5s9.5 4.252 9.5 9.5m-3 0c0-3.591-2.908-6.5-6.5-6.5a6.5 6.5 0 0 0-6.5 6.5c0 3.592 2.909 6.5 6.5 6.5s6.5-2.908 6.5-6.5" clip-rule="evenodd"/><path fill="currentColor" d="M28.031 37.533a27.4 27.4 0 0 1 17.107 5.966l-2.25 2.05a24.4 24.4 0 0 0-14.857-5.016 24.4 24.4 0 0 0-14.857 5.015l-2.25-2.05a27.4 27.4 0 0 1 17.107-5.965"/><path fill="currentColor" fill-rule="evenodd" d="M52.031 28.031c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24m-3 0c0 11.598-9.402 21-21 21s-21-9.402-21-21 9.402-21 21-21 21 9.402 21 21" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_minus_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.75 15c4.951 0 9.25 1.763 9.25 5.643 0 2.016-.781 2.857-2.456 2.857H10.956c-1.675 0-2.456-.84-2.456-2.857 0-3.88 4.299-5.643 9.25-5.643m0 2c-3.946 0-7.25 1.355-7.25 3.643 0 .89-.072.863.372.858l13.672-.001c.536 0 .456.086.456-.857C25 18.355 21.696 17 17.75 17M5 11h4a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h4m12.5-8C20.538 3 23 5.461 23 8.5S20.538 14 17.5 14A5.5 5.5 0 0 1 12 8.5C12 5.461 14.461 3 17.5 3m0 2A3.5 3.5 0 0 0 14 8.5c0 1.934 1.566 3.5 3.5 3.5S21 10.434 21 8.5 19.434 5 17.5 5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14 3a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m-3.5 5.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M4.5 21.975c0-4.109 4.415-6.475 9.5-6.475s9.5 2.366 9.5 6.475c0 2.135-.802 3.025-2.522 3.025H7.022c-1.72 0-2.522-.89-2.522-3.025m2 0c0-1.224.618-2.266 1.916-3.09C9.758 18.032 11.735 17.5 14 17.5s4.242.532 5.584 1.385c1.297.824 1.916 1.866 1.916 3.09 0 .417-.04.69-.085.859a1 1 0 0 1-.042.127c-.06.016-.182.039-.395.039H7.022c-.213 0-.335-.023-.395-.039a1 1 0 0 1-.042-.127c-.045-.168-.085-.442-.085-.86" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="17" fill="none" id="svg-name-user_start_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.421 2.099a.93.93 0 0 0-.834 0c-.052.026-.193.135-.447.602-.243.447-.52 1.084-.914 1.997l-.492 1.136-.005.012c-.02.05-.083.201-.193.327q-.136.158-.325.248c-.15.072-.314.093-.367.1l-.012.001-.687.097c-.995.14-1.69.238-2.192.355-.523.122-.668.23-.708.275a.94.94 0 0 0-.222.814c.011.058.081.226.47.596.372.356.921.794 1.708 1.42l.224.18.012.008c.05.039.205.158.306.326.083.138.131.294.141.455.012.195-.048.381-.068.442l-.004.014-.451 1.477c-.185.605-.308 1.01-.373 1.325-.065.309-.053.437-.035.504a.94.94 0 0 0 .408.55c.058.037.177.086.492.114.32.029.743.03 1.376.03h5.502c.618 0 1.031-.001 1.343-.029.307-.027.424-.075.483-.111a.94.94 0 0 0 .409-.538c.02-.066.034-.192-.022-.495-.056-.308-.166-.707-.332-1.302l-.43-1.55-.003-.013c-.018-.06-.072-.242-.057-.433.013-.157.062-.309.143-.443.1-.164.251-.28.3-.318l.012-.009.231-.185c.785-.626 1.333-1.064 1.705-1.42.387-.37.457-.537.469-.596a.94.94 0 0 0-.223-.813c-.04-.045-.185-.153-.707-.275-.5-.117-1.195-.215-2.19-.355l-.685-.097q-.005 0-.012-.002a1.2 1.2 0 0 1-.368-.099 1 1 0 0 1-.325-.248 1.2 1.2 0 0 1-.193-.327l-.005-.012-.491-1.136c-.395-.913-.672-1.55-.915-1.997-.253-.467-.395-.576-.447-.602M7.915.758a2.43 2.43 0 0 1 2.179 0c.494.248.82.725 1.092 1.227.28.513.582 1.213.958 2.082l.431.996.535.076c.947.133 1.709.24 2.283.374.56.131 1.11.32 1.482.733a2.44 2.44 0 0 1 .577 2.113c-.11.544-.487.986-.903 1.384-.426.407-1.027.887-1.775 1.484l-.086.068.379 1.366c.154.554.282 1.017.352 1.399.073.394.102.789-.012 1.183a2.44 2.44 0 0 1-1.063 1.398c-.35.215-.738.293-1.137.328-.386.035-.867.035-1.442.035h-5.57c-.59 0-1.081 0-1.476-.036-.406-.036-.802-.116-1.155-.337a2.44 2.44 0 0 1-1.059-1.43c-.109-.402-.07-.804.015-1.204.08-.387.224-.857.396-1.42l.393-1.29-.073-.059c-.75-.596-1.352-1.076-1.779-1.483-.416-.398-.795-.84-.905-1.385a2.44 2.44 0 0 1 .577-2.114c.372-.413.922-.602 1.483-.733.575-.134 1.338-.241 2.286-.374l.535-.076.431-.996c.377-.87.68-1.569.958-2.082.273-.502.599-.98 1.093-1.227" clip-rule="evenodd"/><path fill="currentColor" d="M5.5 13.577v.461c0 .247.201.462.437.462h6.125c.235 0 .437-.215.437-.462v-.461c0-1.616-2.332-2.077-3.5-2.077s-3.5.461-3.5 2.077M10.75 8.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" id="svg-name-users_16" class="svg-sprite__symbol"><path fill="currentColor" d="M11.357 9c1.533 0 4.343.571 4.343 2.857 0 1-.255 1.143-.766 1.143l-4.07.001q.159-.49.159-1.144c0-1.149-.422-2.045-1.118-2.708A7.4 7.4 0 0 1 11.357 9M5.343 9c1.533 0 4.343.571 4.343 2.857 0 1-.255 1.143-.766 1.143H1.766C1.256 13 1 12.857 1 11.857 1 9.571 3.81 9 5.343 9m0-5c1.108 0 2.005.895 2.005 2S6.45 8 5.343 8A2 2 0 0 1 3.34 6c0-1.105.897-2 2.004-2m6.014 0c1.107 0 2.004.895 2.004 2s-.897 2-2.004 2a2 2 0 0 1-2.005-2c0-1.105.897-2 2.005-2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-users_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.5 10.5c1.941 0 5.5.714 5.5 3.571 0 1.25-.323 1.429-.97 1.429l-4.738.001q.208-.601.208-1.43c0-1.483-.592-2.62-1.555-3.436A9.4 9.4 0 0 1 13.5 10.5m-7 0c1.941 0 5.5.714 5.5 3.571 0 1.25-.323 1.429-.97 1.429H1.97c-.646 0-.97-.179-.97-1.429C1 11.214 4.559 10.5 6.5 10.5m0-6.5a2.5 2.5 0 1 1 .001 4.999A2.5 2.5 0 0 1 6.5 4m7 0a2.5 2.5 0 1 1 .001 4.999A2.5 2.5 0 0 1 13.5 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-users_3_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.286 17.91C9.39 18.461 9 19.128 9 19.786c0 .481.153.744.325.898.189.168.527.316 1.075.316h7.2c.548 0 .886-.148 1.075-.316.172-.154.325-.417.325-.898 0-.658-.39-1.325-1.286-1.876-.899-.552-2.208-.91-3.714-.91s-2.815.358-3.714.91M9.24 16.206C10.516 15.422 12.207 15 14 15s3.484.422 4.76 1.206c1.279.785 2.24 2.011 2.24 3.58 0 .952-.327 1.796-.995 2.391-.651.58-1.513.823-2.405.823h-7.2c-.892 0-1.754-.242-2.405-.823C7.327 21.582 7 20.738 7 19.786c0-1.569.961-2.795 2.24-3.58M3.805 17.082c-.52.346-.805.806-.805 1.418 0 .523.17.88.395 1.105.224.225.582.395 1.105.395a1 1 0 1 1 0 2c-.977 0-1.87-.33-2.52-.98S1 19.477 1 18.5c0-1.388.715-2.428 1.695-3.082.951-.634 2.157-.918 3.305-.918a1 1 0 1 1 0 2c-.852 0-1.646.216-2.195.582M24.195 17.082c.52.346.805.806.805 1.418 0 .523-.17.88-.395 1.105-.224.225-.582.395-1.105.395a1 1 0 1 0 0 2c.977 0 1.87-.33 2.52-.98s.98-1.543.98-2.52c0-1.388-.715-2.428-1.695-3.082-.951-.634-2.157-.918-3.305-.918a1 1 0 1 0 0 2c.852 0 1.646.216 2.195.582M11.5 8.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M14 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M7 6.5a2 2 0 1 0 0 4 1 1 0 1 1 0 2 4 4 0 0 1 0-8 1 1 0 0 1 0 2M21 6.5a2 2 0 1 1 0 4 1 1 0 1 0 0 2 4 4 0 0 0 0-8 1 1 0 1 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-users_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.25 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1.5 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M2.688 11.57c.96-.555 2.226-.82 3.562-.82s2.602.265 3.562.82c.977.563 1.688 1.467 1.688 2.68 0 .707-.275 1.306-.781 1.71-.484.387-1.105.54-1.719.54H3.5c-.614 0-1.235-.153-1.719-.54C1.276 15.557 1 14.958 1 14.25c0-1.213.71-2.117 1.688-2.68m.75 1.298c-.649.374-.938.845-.938 1.382 0 .293.1.444.219.54.141.113.395.21.781.21H9c.386 0 .64-.097.781-.21.12-.096.219-.247.219-.54 0-.537-.29-1.008-.937-1.382-.665-.383-1.65-.618-2.813-.618s-2.148.235-2.813.618M13.75 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1.5 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0" clip-rule="evenodd"/><path fill="currentColor" d="M13.75 12.25q-.34 0-.677.033a.75.75 0 1 1-.146-1.493q.409-.04.823-.04c1.336 0 2.602.265 3.562.82.977.563 1.688 1.467 1.688 2.68 0 .707-.276 1.306-.782 1.71-.483.387-1.104.54-1.718.54h-3a.75.75 0 0 1 0-1.5h3c.386 0 .64-.097.782-.21.119-.096.218-.247.218-.54 0-.537-.29-1.008-.937-1.382-.665-.383-1.65-.618-2.813-.618"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-users_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9 15c3.997 0 7.5 1.542 7.5 4.929 0 1.774-.69 2.571-2.147 2.571H3.647c-1.458 0-2.147-.797-2.147-2.571C1.5 16.542 5.003 15 9 15m10.5 0c3.997 0 7.5 1.542 7.5 4.929 0 1.774-.69 2.571-2.147 2.571H19a1 1 0 1 1 0-2h5.913q.025 0 .042.002l.013.001.002-.015c.01-.081.024-.22.029-.427l.001-.132C25 18.095 22.512 17 19.5 17c-.428 0-.898.03-1.37.09a1 1 0 0 1-.256-1.983A13 13 0 0 1 19.5 15M9 17c-3.013 0-5.5 1.095-5.5 2.929 0 .28.017.462.03.56l.001.014.014-.001.019-.001h10.891l.013.002.002-.015c.013-.097.03-.28.03-.56C14.5 18.096 12.012 17 9 17M19.5 5a4.25 4.25 0 0 1 4.25 4.25 4.25 4.25 0 0 1-4.25 4.25 4.25 4.25 0 0 1-4.25-4.25A4.25 4.25 0 0 1 19.5 5M9 5a4.25 4.25 0 0 1 4.25 4.25A4.25 4.25 0 0 1 9 13.5a4.25 4.25 0 0 1-4.25-4.25A4.25 4.25 0 0 1 9 5m10.5 2a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 1 0 0-4.5M9 7a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 1 0 9 7"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-verified-streamer" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="#fff" d="M12.768 7.283 8.695 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-video" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" rx="2"/><path d="M7 12.382V7.618a1 1 0 0 1 1.447-.894l4.764 2.382a1 1 0 0 1 0 1.788l-4.764 2.382A1 1 0 0 1 7 12.382"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" id="svg-name-video_add_square_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.317 1h2.931a.75.75 0 0 1 0 1.5H6.35c-.992 0-1.692 0-2.238.045-.537.044-.86.127-1.11.255A2.75 2.75 0 0 0 1.8 4.002c-.128.25-.21.573-.255 1.11-.044.546-.045 1.246-.045 2.238v3.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 3.002 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 14.2 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238V7.749a.75.75 0 0 1 1.5 0v2.934c0 .952 0 1.713-.05 2.327-.052.63-.16 1.172-.413 1.67a4.25 4.25 0 0 1-1.857 1.857c-.498.253-1.04.361-1.67.413-.614.05-1.375.05-2.327.05H6.317c-.952 0-1.713 0-2.327-.05-.63-.052-1.172-.16-1.67-.413A4.25 4.25 0 0 1 .464 14.68C.21 14.182.102 13.64.05 13.01 0 12.396 0 11.635 0 10.683V7.317c0-.952 0-1.713.05-2.327.052-.63.16-1.172.413-1.67a4.25 4.25 0 0 1 1.858-1.857c.497-.253 1.04-.361 1.67-.413C4.603 1 5.364 1 6.316 1" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M14.1 0a.75.75 0 0 1 .75.75v1.4h1.4a.75.75 0 0 1 0 1.5h-1.4v1.6a.75.75 0 0 1-1.5 0v-1.6h-1.6a.75.75 0 0 1 0-1.5h1.6V.75A.75.75 0 0 1 14.1 0M6.706 7.045a.2.2 0 0 0-.025.06 9.7 9.7 0 0 0 .008 3.79q.01.043.025.06.015.02.035.032a.1.1 0 0 0 .038.013.1.1 0 0 0 .046-.008A9.4 9.4 0 0 0 9.952 9.11a.146.146 0 0 0 0-.217 9.4 9.4 0 0 0-3.127-1.885A.1.1 0 0 0 6.78 7a.1.1 0 0 0-.037.013.1.1 0 0 0-.036.032m.628-1.449a1.607 1.607 0 0 0-2.124 1.22 11.2 11.2 0 0 0 .008 4.374 1.607 1.607 0 0 0 2.125 1.213 10.9 10.9 0 0 0 3.617-2.183c.72-.653.72-1.784 0-2.438a10.9 10.9 0 0 0-3.626-2.186" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-video_arrow_square_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M13.202 7.576a.675.675 0 1 0 1.35 0V3.808l.794.795a.675.675 0 1 0 .955-.954L14.355 1.7a.675.675 0 0 0-.955 0l-1.952 1.95a.675.675 0 0 0 .954.955l.8-.8z"/><path fill="currentColor" d="M7.096 2.251h1.98a.675.675 0 1 1 0 1.35H7.124c-.746 0-1.265 0-1.67.034-.395.032-.62.092-.79.179a1.95 1.95 0 0 0-.852.852c-.087.17-.147.395-.18.791-.032.404-.033.923-.033 1.67v3.75c0 .745 0 1.265.034 1.668.032.396.092.622.179.791.186.367.485.666.852.853.17.086.395.146.79.179.405.033.924.033 1.67.033h3.75c.746 0 1.265 0 1.669-.033.396-.033.621-.093.791-.18a1.95 1.95 0 0 0 .852-.852c.087-.17.147-.395.18-.79.032-.404.033-.924.033-1.67v-.45a.675.675 0 1 1 1.35 0v.479c0 .71 0 1.285-.038 1.75-.04.48-.122.903-.322 1.294a3.3 3.3 0 0 1-1.442 1.443c-.392.2-.815.282-1.294.321-.466.038-1.04.038-1.75.038H7.095c-.71 0-1.285 0-1.75-.038-.48-.039-.902-.122-1.294-.321a3.3 3.3 0 0 1-1.442-1.443c-.2-.391-.283-.814-.322-1.294-.038-.465-.038-1.04-.038-1.75V7.097c0-.71 0-1.285.038-1.75.04-.48.122-.902.322-1.294a3.3 3.3 0 0 1 1.442-1.442c.392-.2.814-.283 1.294-.322.465-.038 1.04-.038 1.75-.038"/><path fill="currentColor" fill-rule="evenodd" d="M8.395 6.084A1.392 1.392 0 0 0 6.556 7.13a9.5 9.5 0 0 0 .008 3.748 1.392 1.392 0 0 0 1.838 1.04 9.4 9.4 0 0 0 3.13-1.87c.624-.561.624-1.53 0-2.09a9.4 9.4 0 0 0-3.137-1.874M7.89 7.368a.1.1 0 0 0-.01.024 8.2 8.2 0 0 0 .007 3.218.1.1 0 0 0 .01.024l.013.012.015.005q.004.001.022-.004a8.1 8.1 0 0 0 2.683-1.603.1.1 0 0 0 .016-.02.1.1 0 0 0 .004-.022.1.1 0 0 0-.004-.02.1.1 0 0 0-.016-.02 8.1 8.1 0 0 0-2.69-1.607.1.1 0 0 0-.021-.004l-.016.006z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" id="svg-name-video_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.915 11.681c.183-.129.407-.314.534-.6.165-.37.165-.792 0-1.162-.127-.286-.351-.471-.534-.6-.18-.127-.415-.263-.673-.412L10.26 7.763c-.26-.15-.494-.285-.694-.377-.203-.094-.476-.195-.787-.162a1.43 1.43 0 0 0-1.006.58c-.184.254-.232.54-.253.763-.02.22-.02.49-.02.79v2.287c0 .299 0 .57.02.79.02.222.07.509.253.762a1.43 1.43 0 0 0 1.006.58c.311.033.584-.068.787-.162.2-.092.435-.228.694-.377l1.98-1.144c.26-.149.495-.285.674-.412m-1.414-1.552a9 9 0 0 1 .61.371l-.02.015c-.12.084-.296.187-.59.356l-1.928 1.114a9 9 0 0 1-.627.342l-.001-.015-.001-.01a9 9 0 0 1-.014-.688V9.387a9 9 0 0 1 .016-.714l.023.01c.132.061.31.163.604.333z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M18.573 10.5a8.571 8.571 0 1 1-17.143 0 8.571 8.571 0 0 1 17.143 0m-1.429 0a7.143 7.143 0 1 1-14.286 0 7.143 7.143 0 0 1 14.286 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-video_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M37.745 6c3.566 0 4.859.371 6.162 1.069a7.27 7.27 0 0 1 3.025 3.024C47.629 11.396 48 12.69 48 16.256v23.489c0 3.566-.371 4.859-1.069 6.162a7.27 7.27 0 0 1-3.024 3.025C42.604 49.629 41.311 50 37.745 50h-19.49c-3.565 0-4.859-.371-6.162-1.069a7.27 7.27 0 0 1-3.024-3.024C8.37 44.604 8 43.311 8 39.745v-23.49c0-3.565.371-4.859 1.069-6.162a7.27 7.27 0 0 1 3.024-3.024C13.396 6.37 14.69 6 18.256 6zm.314 3H18.256c-2.799 0-3.761.186-4.749.714a4.27 4.27 0 0 0-1.793 1.793c-.508.95-.7 1.876-.713 4.434L11 39.745c0 2.798.186 3.76.714 4.748a4.27 4.27 0 0 0 1.793 1.793c.988.528 1.95.714 4.749.714h19.489c2.798 0 3.76-.186 4.748-.714a4.27 4.27 0 0 0 1.793-1.793c.528-.988.714-1.95.714-4.748v-23.49c0-2.798-.186-3.76-.714-4.748a4.27 4.27 0 0 0-1.793-1.793c-.95-.508-1.876-.7-4.434-.713M18.72 38c.445 0 .607.046.77.134q.245.132.377.378c.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-video_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.806 7.88c.282-1.402 1.743-2.222 3.105-1.742a16 16 0 0 1 5.3 3.122 2.316 2.316 0 0 1 0 3.483 16 16 0 0 1-5.287 3.118c-1.36.48-2.818-.334-3.105-1.733a15.7 15.7 0 0 1-.319-3.154c0-1.058.105-2.092.306-3.093m2.44.144c-.236-.083-.44.061-.479.25a13.7 13.7 0 0 0-.267 2.7c0 .944.096 1.864.278 2.752.039.19.244.333.48.25a14 14 0 0 0 4.625-2.728.317.317 0 0 0 0-.492 14 14 0 0 0-4.637-2.732" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M7.692 0C5.244 0 4.165.216 3.069.801A5.47 5.47 0 0 0 .801 3.07C.216 4.165 0 5.244 0 7.692v6.616c0 2.448.216 3.527.801 4.622A5.47 5.47 0 0 0 3.07 21.2c1.096.585 2.175.801 4.623.801h6.616c2.448 0 3.527-.216 4.622-.801A5.47 5.47 0 0 0 21.2 18.93c.585-1.095.801-2.174.801-4.622V7.692c0-2.448-.216-3.527-.801-4.623A5.47 5.47 0 0 0 18.93.801C17.836.216 16.757 0 14.308 0zm0 2c-2.335 0-3.019.212-3.68.565a3.47 3.47 0 0 0-1.447 1.448C2.212 4.673 2 5.357 2 7.692v6.616c0 2.335.212 3.019.565 3.68a3.47 3.47 0 0 0 1.448 1.447c.66.353 1.344.565 3.679.565h6.616c2.335 0 3.019-.212 3.68-.565a3.47 3.47 0 0 0 1.447-1.448c.353-.66.565-1.344.565-3.679V7.692c0-2.335-.212-3.019-.565-3.68a3.47 3.47 0 0 0-1.448-1.447C17.327 2.212 16.643 2 14.308 2z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-videocam_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7.817 3c-.952 0-1.713 0-2.327.05-.63.052-1.172.16-1.67.413a4.25 4.25 0 0 0-1.857 1.858c-.253.497-.361 1.04-.413 1.67-.05.613-.05 1.374-.05 2.326v1.366c0 .952 0 1.713.05 2.327.052.63.16 1.172.413 1.67a4.25 4.25 0 0 0 1.858 1.857c.497.253 1.04.361 1.67.413.613.05 1.374.05 2.326.05h1.366c.952 0 1.713 0 2.327-.05.63-.052 1.172-.16 1.67-.413a4.25 4.25 0 0 0 1.857-1.857c.155-.304.255-.625.322-.971l1.532 1.02c1.329.887 3.109-.066 3.109-1.663V6.934c0-1.597-1.78-2.55-3.11-1.664L15.36 6.291a3.6 3.6 0 0 0-.322-.97 4.25 4.25 0 0 0-1.857-1.858c-.498-.253-1.04-.361-1.67-.413C10.896 3 10.135 3 9.183 3zM15.5 9.26V12l2.223 1.482a.5.5 0 0 0 .777-.416V6.934a.5.5 0 0 0-.777-.416L15.5 8zm-1.5.09c0-.992 0-1.692-.045-2.238-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 12.5 4.8c-.252-.128-.574-.21-1.111-.255-.546-.044-1.245-.045-2.238-.045h-1.3c-.992 0-1.692 0-2.238.045-.537.044-.86.127-1.11.255A2.75 2.75 0 0 0 3.3 6.002c-.128.25-.21.573-.255 1.11C3.001 7.658 3 8.358 3 9.35v1.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 4.502 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h1.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 13.7 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-videocam_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11 7h1c1.425 0 2.394.001 3.147.052.735.05 1.117.142 1.384.252a4 4 0 0 1 2.165 2.165c.11.267.201.65.252 1.384.05.753.052 1.722.052 3.147s-.001 2.394-.052 3.147c-.05.735-.142 1.117-.253 1.384a4 4 0 0 1-2.164 2.165c-.267.11-.65.201-1.384.252-.753.05-1.722.052-3.147.052h-1c-1.425 0-2.394-.001-3.147-.052-.735-.05-1.117-.142-1.384-.253a4 4 0 0 1-2.165-2.164c-.11-.267-.201-.65-.252-1.384C4.002 16.394 4 15.425 4 14s.001-2.394.052-3.147c.05-.735.142-1.117.252-1.384A4 4 0 0 1 6.47 7.304c.267-.11.65-.201 1.384-.252C8.606 7.002 9.575 7 11 7m9.793 2.53a4.6 4.6 0 0 0-.25-.826 6 6 0 0 0-3.247-3.247C16.194 5 14.796 5 12 5h-1c-2.796 0-4.193 0-5.296.457a6 6 0 0 0-3.247 3.247C2 9.807 2 11.204 2 14s0 4.194.457 5.296a6 6 0 0 0 3.247 3.247C6.807 23 8.204 23 11 23h1c2.796 0 4.194 0 5.296-.457a6 6 0 0 0 3.247-3.247c.106-.255.187-.526.25-.826l1.44 1.422C24 21.64 27 20.386 27 17.9v-7.8c0-2.486-2.998-3.739-4.767-1.992zM21 14v1.53a.8.8 0 0 0 .238.57l2.4 2.37A.8.8 0 0 0 25 17.9v-7.8a.8.8 0 0 0-1.362-.57l-2.4 2.37a.8.8 0 0 0-.238.57z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-videocam_slash_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.38 10.502a1.5 1.5 0 0 1 2.118-.121l37 33a1.5 1.5 0 1 1-1.996 2.239l-3.54-3.157a9.5 9.5 0 0 1-2.15 1.502c-1.101.561-2.309.804-3.735.921C29.68 45 27.95 45 25.767 45h-7.533c-2.184 0-3.915 0-5.31-.114-1.427-.117-2.634-.36-3.737-.921a9.5 9.5 0 0 1-4.152-4.152c-.561-1.102-.804-2.31-.921-3.736C4 34.68 4 32.95 4 30.766v-5.532c0-2.184 0-3.915.114-5.31.117-1.427.36-2.634.921-3.737q.382-.748.884-1.412L3.502 12.62a1.5 1.5 0 0 1-.121-2.118m4.788 6.28q-.255.366-.46.767c-.31.609-.503 1.378-.604 2.619C7.001 21.427 7 23.035 7 25.3v5.4c0 2.265.001 3.874.104 5.132.101 1.242.294 2.01.604 2.619a6.5 6.5 0 0 0 2.841 2.84c.609.31 1.378.504 2.619.605 1.259.103 2.867.104 5.132.104h7.4c2.265 0 3.874-.001 5.132-.104 1.242-.101 2.01-.294 2.619-.604a6.5 6.5 0 0 0 1.258-.839zM44.641 16.65c-.607.304-1.307.74-2.022 1.186l-2.766 1.722c-.128-1.27-.375-2.364-.888-3.37a9.5 9.5 0 0 0-4.152-4.152c-1.102-.562-2.31-.805-3.737-.922C29.682 11 27.95 11 25.767 11H14.5a1.5 1.5 0 0 0 0 3h11.2c2.265 0 3.874.001 5.132.104 1.242.101 2.01.294 2.619.605a6.5 6.5 0 0 1 2.84 2.84c.31.609.504 1.378.605 2.619.103 1.259.104 2.867.104 5.132v7.699a3 3 0 0 0 1.415 2.547l4.109 2.557.095.06c.715.445 1.416.881 2.023 1.186.613.308 1.591.73 2.765.634a5 5 0 0 0 3.609-2.004c.702-.946.86-2 .922-2.683.062-.676.062-1.501.062-2.344v-9.906c0-.843 0-1.668-.062-2.344-.062-.684-.22-1.737-.922-2.684a5 5 0 0 0-3.61-2.004c-1.174-.096-2.152.327-2.765.635M40 23l4.109-2.558c1.596-.994 2.395-1.491 3.054-1.438a2 2 0 0 1 1.443.802c.394.53.394 1.471.394 3.352v9.682c0 1.88 0 2.82-.394 3.352a2 2 0 0 1-1.443.801c-.659.054-1.457-.443-3.054-1.437L40 33V23" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" id="svg-name-view_12" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12 4c0-.8-2.4-4-6-4S0 3.2 0 4s2.4 4 6 4 6-3.2 6-4M9 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-view_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19 10c0 3.5-5 6-9 6s-9-2.5-9-6 5-6 9-6 9 2.5 9 6m-1.5 0c0 .983-.72 2.084-2.278 3.03-1.517.92-3.497 1.47-5.222 1.47s-3.705-.55-5.222-1.47C3.22 12.084 2.5 10.983 2.5 10s.72-2.084 2.278-3.03C6.295 6.05 8.275 5.5 10 5.5s3.705.55 5.222 1.47C16.78 7.916 17.5 9.017 17.5 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-view_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 6c5.994 0 11.5 4.557 11.5 8s-5.506 8-11.5 8-11.5-4.557-11.5-8S8.006 6 14 6m0 2c-4.964 0-9.5 3.754-9.5 6s4.536 6 9.5 6 9.5-3.754 9.5-6-4.536-6-9.5-6m0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="32.02" height="19.98" viewBox="8.1 14.6 32.02 19.98" id="svg-name-vk" class="svg-sprite__symbol"><path fill="#FFF" d="M25.54 34.58c-10.94 0-17.18-7.5-17.44-19.98h5.48c.18 9.16 4.22 13.04 7.42 13.84V14.6h5.16v7.9c3.16-.34 6.48-3.94 7.6-7.9h5.16c-.86 4.88-4.46 8.48-7.02 9.96 2.56 1.2 6.66 4.34 8.22 10.02h-5.68c-1.22-3.8-4.26-6.74-8.28-7.14v7.14z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-vkplay" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M10.42 0c4.52 0 6.78 0 8.18 1.4S20 5.06 20 9.58v.84c0 4.52 0 6.78-1.4 8.18S14.94 20 10.42 20h-.84c-4.52 0-6.78 0-8.18-1.4S0 14.94 0 10.42v-.84C0 5.06 0 2.8 1.4 1.4S5.06 0 9.58 0z"/><path fill="#0009B4" d="M.06 5.62C0 6.7 0 8 0 9.58v.84c0 1.2 0 2.22.02 3.12C2.64 14.82 6.16 15.6 10 15.6s7.36-.78 9.98-2.06c.02-.9.02-1.94.02-3.12v-.84C20 8 20 6.7 19.94 5.6H.06z"/><path stroke="#fff" stroke-width="1.998" d="M13.9 12a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM8.4 12.4 4 8M8.4 8 4 12.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-vkplay_transparent" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M10.42 0c4.52 0 6.78 0 8.18 1.4S20 5.06 20 9.58v.84c0 4.52 0 6.78-1.4 8.18S14.94 20 10.42 20h-.84c-4.52 0-6.78 0-8.18-1.4S0 14.94 0 10.42v-.84C0 5.06 0 2.8 1.4 1.4S5.06 0 9.58 0z"/><path fill="#0009B4" d="M.06 5.62C0 6.7 0 8 0 9.58v.84c0 1.2 0 2.22.02 3.12C2.64 14.82 6.16 15.6 10 15.6s7.36-.78 9.98-2.06c.02-.9.02-1.94.02-3.12v-.84C20 8 20 6.7 19.94 5.6H.06z"/><path stroke="#fff" stroke-width="1.998" d="M13.9 12a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM8.4 12.4 4 8M8.4 8 4 12.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-vlc" class="svg-sprite__symbol"><path fill="currentColor" d="m23.401 19.322-3.083-1.193L16.04 6.722a1.11 1.11 0 0 0-2.08 0L12.812 9.78s-.004.01-.004.014l-.014.038-1.316 3.513a.3.3 0 0 0-.03.08l-1.282 3.415-.489 1.287v.004L6.6 19.321c-.37.145-.599.437-.599.766 0 .33.23.623.599.765l7.926 3.067a1.44 1.44 0 0 0 .948 0l7.928-3.067c.37-.144.599-.437.599-.765 0-.331-.23-.624-.599-.765m-10.215-9.177a25 25 0 0 0 3.624 0l1.172 3.13c-.896.13-1.92.196-2.982.196a21.4 21.4 0 0 1-2.986-.196zM15 20.94c-3.437 0-5.356-.662-5.476-1.033l.063-.162a.1.1 0 0 0 .01-.03l.497-1.325.445-1.181c1.117.306 2.72.479 4.461.479 1.737 0 3.342-.173 4.456-.48l.446 1.182.506 1.346.063.173c-.12.369-2.039 1.03-5.471 1.03"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-voice_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.692 12.48a.75.75 0 0 1 .162 1.048 7.25 7.25 0 0 1-5.103 2.934v1.788a.75.75 0 0 1-1.5 0v-1.789a7.28 7.28 0 0 1-5.1-2.931.75.75 0 1 1 1.207-.89A5.77 5.77 0 0 0 10 15a5.74 5.74 0 0 0 4.643-2.358.75.75 0 0 1 1.048-.162" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5.75 5.75a4.25 4.25 0 0 1 8.5 0v3.5a4.25 4.25 0 0 1-8.5 0zM10 3a2.75 2.75 0 0 0-2.75 2.75v3.5a2.75 2.75 0 1 0 5.5 0v-3.5A2.75 2.75 0 0 0 10 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" id="svg-name-volume" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M9.25 4A.25.25 0 0 0 9 3.75h-.902a.25.25 0 0 0-.19.088L4.945 7.305l-.224.263H2a.25.25 0 0 0-.25.25v4.364c0 .138.112.25.25.25h2.721l.224.263 2.963 3.467a.25.25 0 0 0 .19.088H9a.25.25 0 0 0 .25-.25zM9 2.25c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 9 17.75h-.902a1.75 1.75 0 0 1-1.33-.613l-2.739-3.205H2a1.75 1.75 0 0 1-1.75-1.75V7.818c0-.966.784-1.75 1.75-1.75h2.03l2.738-3.205a1.75 1.75 0 0 1 1.33-.613zM12.25 8a.75.75 0 0 1 .75-.75 2.75 2.75 0 1 1 0 5.5.75.75 0 0 1 0-1.5 1.25 1.25 0 1 0 0-2.5.75.75 0 0 1-.75-.75m3.05-3.271a.75.75 0 0 0-.6 1.374 4.251 4.251 0 0 1 0 7.794.75.75 0 0 0 .6 1.374 5.751 5.751 0 0 0 0-10.542" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-wallet" class="svg-sprite__symbol"><path fill="currentColor" d="M1.75 3.33a.75.75 0 0 0-1.5 0zm15.662-1.58a.75.75 0 0 0 0-1.5zM.25 3.33V17h1.5V3.33zM3 19.75h14v-1.5H3zM19.75 17V7.235h-1.5V17zM17 4.485H3.118v1.5H17zM3.118 1.75h14.294V.25H3.118zM1.75 3.118c0-.756.612-1.368 1.368-1.368V.25A2.87 2.87 0 0 0 .25 3.118zm1.368 1.367A1.37 1.37 0 0 1 1.75 3.118H.25a2.87 2.87 0 0 0 2.868 2.867zm16.632 2.75A2.75 2.75 0 0 0 17 4.485v1.5c.69 0 1.25.56 1.25 1.25zM17 19.75A2.75 2.75 0 0 0 19.75 17h-1.5c0 .69-.56 1.25-1.25 1.25zM.25 17A2.75 2.75 0 0 0 3 19.75v-1.5c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentColor" stroke-width="1.5" d="M15 12.5a.5.5 0 0 1-1 0 .5.5 0 0 1 1 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-warning" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M8.524 2.705a1.5 1.5 0 0 1 2.544 0l7.294 11.67a1.5 1.5 0 0 1-1.272 2.295H2.502a1.5 1.5 0 0 1-1.272-2.295z"/><path stroke="currentColor" d="M10.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path fill="currentColor" d="M9.25 10a.75.75 0 0 0 1.5 0zm1.5-4a.75.75 0 0 0-1.5 0zm0 4V6h-1.5v4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-warning_triangle_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11 14.001a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M12.375 3.364c-.157-.27-.886-1.362-2.376-1.362s-2.21 1.077-2.375 1.362L1.523 13.853a2.76 2.76 0 0 0-.21 2.327 2.76 2.76 0 0 0 2.6 1.822h12.173a2.76 2.76 0 0 0 2.39-4.149zm3.711 13.14a1.264 1.264 0 0 0 1.094-1.898L11.078 4.117s-.328-.621-1.08-.621c-.75 0-1.077.621-1.077.621L2.82 14.606a1.262 1.262 0 0 0 1.093 1.897z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 6.001a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-wave" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.18 2c2.81 3.63 2.81 8.37 0 12M7.09 3.6c2.06 2.67 2.06 6.14 0 8.81M4 5.8c1.03 1.33 1.03 3.07 0 4.4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-wonder-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#d)" d="M6.39 9.34c.425 0 .77-.522.77-1.165S6.815 7.01 6.39 7.01s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#e)" d="M6.39 7.405c.33 0 .62.29.77.715-.01-.63-.35-1.135-.77-1.135s-.76.505-.77 1.135c.15-.43.44-.715.77-.715"/><path fill="url(#f)" d="M11.615 9.34c.425 0 .77-.522.77-1.165s-.345-1.165-.77-1.165-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#g)" d="M11.615 7.43c-.33 0-.62.29-.77.715.01-.63.35-1.135.77-1.135s.76.505.77 1.135c-.15-.425-.44-.715-.77-.715"/><path fill="url(#h)" d="M10.775 4.76c.02-.32.375-.5.97-.47.505.03 1.6.37 2.31 1.395.13.19-.09.275-.225.15-.45-.425-1.68-1.01-2.67-.96-.395.025-.385-.115-.385-.115"/><path fill="url(#i)" d="M7.225 4.76c-.02-.32-.375-.5-.97-.47-.505.03-1.6.37-2.31 1.395-.13.19.09.275.225.15.45-.425 1.68-1.01 2.67-.96.395.025.385-.115.385-.115"/><path fill="url(#j)" d="M9 14.44a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9"/><path fill="url(#k)" d="M9 11.99c.625 0 1.165.35 1.44.865A1.454 1.454 0 0 0 9 11.54c-.755 0-1.375.575-1.44 1.315A1.63 1.63 0 0 1 9 11.99"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -2.382 8.196)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .23 11.672)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="rotate(73.853 -4.241 12.472)scale(1.7567 1.1364)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><linearGradient id="e" x1="6.389" x2="6.389" y1="7.003" y2="8.089" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="g" x1="11.613" x2="11.613" y1="7.032" y2="8.117" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="h" x1="12.425" x2="12.472" y1="5.385" y2="4.543" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="i" x1="5.578" x2="5.531" y1="5.385" y2="4.543" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="k" x1="9.001" x2="9.001" y1="10.86" y2="13.221" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-world" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9.25" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-width="1.5" d="M13.25 10c0 2.69-.438 5.092-1.118 6.793-.34.852-.728 1.492-1.12 1.906-.39.412-.732.551-1.012.551s-.622-.139-1.012-.551c-.392-.414-.78-1.054-1.12-1.907-.68-1.7-1.118-4.102-1.118-6.792s.438-5.092 1.118-6.793c.34-.852.728-1.492 1.12-1.906C9.378.89 9.72.75 10 .75s.622.139 1.012.551c.392.414.78 1.054 1.12 1.906.68 1.701 1.118 4.103 1.118 6.793ZM2 6h16M1 10h18M2 14h16"/></symbol></svg>`;
        window[spriteGlobalVarName] = sprite;
    }
    const loadSprite = ()=>{
        let svgSprite = document.getElementById(spriteNodeId);
        if (!svgSprite) {
            svgSprite = document.createElement("svg");
            document.body.prepend(svgSprite);
        }
        svgSprite.outerHTML = sprite;
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", (e2)=>{
        loadSprite();
    });
    else loadSprite();
})("__SVG_SPRITE_NODE__", "__SVG_SPRITE__");

});
parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("4TSkt")).useStore);
parcelRequire("gCPmi");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("4TSkt")).useStore);

var $4hUQH = parcelRequire("4hUQH");

var $2g8Bt = parcelRequire("2g8Bt");

var $7iEsg = parcelRequire("7iEsg");

var $hrvfy = parcelRequire("hrvfy");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $acw62.useMemo)(function() {
        var subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $acw62.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $7iEsg.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});
parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
var $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    var batch = (0, $lnBci.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $de1db2bafb2c3b5a$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $de1db2bafb2c3b5a$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
var $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
var $f9089991fdc24c9c$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $f9089991fdc24c9c$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $f9089991fdc24c9c$var$batch;
};

});


parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});


parcelRegister("2g8Bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a53bfd8072ab080$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $1a53bfd8072ab080$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $1a53bfd8072ab080$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $1a53bfd8072ab080$var$EMPTY_ARRAY = [];
var $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1a53bfd8072ab080$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1a53bfd8072ab080$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $1a53bfd8072ab080$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1a53bfd8072ab080$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $1a53bfd8072ab080$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $1a53bfd8072ab080$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $7iEsg.ReactReduxContext) : _ref2$context, connectOptions = (0, $1En50.default)(_ref2, $1a53bfd8072ab080$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $8nd05.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $acw62.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $acw62.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $1En50.default)(props, $1a53bfd8072ab080$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $acw62.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $acw62.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $acw62.useMemo)(function() {
                if (!shouldHandleStateChanges) return $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $acw62.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $acw62.useReducer)($1a53bfd8072ab080$var$storeStateUpdatesReducer, $1a53bfd8072ab080$var$EMPTY_ARRAY, $1a53bfd8072ab080$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $acw62.useRef)();
            var lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $acw62.useRef)();
            var renderIsScheduled = (0, $acw62.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $acw62.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $acw62.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});


parcelRegister("cfvvO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cgj07"));

});


parcelRegister("hrvfy", function(module, exports) {

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $2g8Bt = parcelRequire("2g8Bt");

var $8PZ7r = parcelRequire("8PZ7r");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $40Fxm = parcelRequire("40Fxm");
var $cb2d32d6c07199e9$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $cb2d32d6c07199e9$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $cb2d32d6c07199e9$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $cb2d32d6c07199e9$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $2g8Bt.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $kSE8V.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $ih4tx.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7EQ16.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $40Fxm.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $cb2d32d6c07199e9$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $8PZ7r.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $8PZ7r.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $8PZ7r.default) : _ref3$areMergedPropsE, extraOptions = (0, $1En50.default)(_ref3, $cb2d32d6c07199e9$var$_excluded);
        var initMapStateToProps = $cb2d32d6c07199e9$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $cb2d32d6c07199e9$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $cb2d32d6c07199e9$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $8nd05.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $cb2d32d6c07199e9$export$2e2bcd8739ae039 = /*#__PURE__*/ $cb2d32d6c07199e9$export$9f9feb656dec1fc4();

});
parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4dd493c66c4df43$export$2e2bcd8739ae039);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");
function $d4dd493c66c4df43$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $d4dd493c66c4df43$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d4dd493c66c4df43$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $96XmR.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d4dd493c66c4df43$export$2e2bcd8739ae039 = [
    $d4dd493c66c4df43$export$a9f27b4b187c1166,
    $d4dd493c66c4df43$export$ba20d1a7aa0c4a90,
    $d4dd493c66c4df43$export$94a6e55709d4d961
];

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);
parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f337fd5395077a96$export$2e2bcd8739ae039);

var $3TktP = parcelRequire("3TktP");
function $f337fd5395077a96$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $f337fd5395077a96$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f337fd5395077a96$export$2e2bcd8739ae039 = [
    $f337fd5395077a96$export$23fc470827b14aa,
    $f337fd5395077a96$export$514bc8c1a53c1d66
];

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "default", () => $59349e43bbd01749$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jKoYp");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : undefined;
}
function $59349e43bbd01749$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $59349e43bbd01749$export$691c327fc30bc857;
    } : undefined;
}
var $59349e43bbd01749$export$2e2bcd8739ae039 = [
    $59349e43bbd01749$export$d61b680184bc3f00,
    $59349e43bbd01749$export$a13ba70ef50dda6d
];

});

parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
parcelRequire("d6Wo0");
var $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1En50.default)(_ref2, $2eb761e6a8ffbe36$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f : $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7CByU.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $20d80f3cecee513e$export$8ad76b76a4c905f8);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $acw62.useContext)((0, $7iEsg.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $d8fc8d639f906efc$export$2105062e25df4afe);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $d8fc8d639f906efc$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $acw62.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $acw62.useMemo)(function() {
        return (0, $j4jJy.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $acw62.useRef)();
    var latestSelector = (0, $acw62.useRef)();
    var latestStoreState = (0, $acw62.useRef)();
    var latestSelectedState = (0, $acw62.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8fc8d639f906efc$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $1u0KT = parcelRequire("1u0KT");

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});



parcelRegister("kSjqI", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 

var $f327ec2f2a725cd1$var$fbemitter = {
    EventEmitter: (parcelRequire("44lbX")),
    EmitterSubscription: (parcelRequire("ldJTP"))
};
module.exports = $f327ec2f2a725cd1$var$fbemitter;

});
parcelRegister("44lbX", function(module, exports) {
"use strict";

var $ldJTP = parcelRequire("ldJTP");

var $ap3LK = parcelRequire("ap3LK");

var $lUGgA = parcelRequire("lUGgA");

var $9Nafg = parcelRequire("9Nafg");
/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */ var $2f67f96ceac464e0$var$BaseEventEmitter = /*#__PURE__*/ function() {
    /**
   * @constructor
   */ function BaseEventEmitter() {
        this._subscriber = new $ap3LK();
        this._currentSubscription = null;
    }
    /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */ var _proto = BaseEventEmitter.prototype;
    _proto.addListener = function addListener(eventType, listener, context) {
        return this._subscriber.addSubscription(eventType, new $ldJTP(this._subscriber, listener, context));
    } /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */ ;
    _proto.once = function once(eventType, listener, context) {
        var emitter = this;
        return this.addListener(eventType, function() {
            emitter.removeCurrentListener();
            listener.apply(context, arguments);
        });
    } /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */ ;
    _proto.removeAllListeners = function removeAllListeners(eventType) {
        this._subscriber.removeAllSubscriptions(eventType);
    } /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */ ;
    _proto.removeCurrentListener = function removeCurrentListener() {
        !!!this._currentSubscription && $lUGgA(false);
        this._subscriber.removeSubscription(this._currentSubscription);
    } /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */ ;
    _proto.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */ {
        var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
        return subscriptions ? subscriptions.filter($9Nafg.thatReturnsTrue).map(function(subscription) {
            return subscription.listener;
        }) : [];
    } /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */ ;
    _proto.emit = function emit(eventType) {
        var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
        if (subscriptions) {
            var keys = Object.keys(subscriptions);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                var subscription = subscriptions[key]; // The subscription may have been removed during this event loop.
                if (subscription) {
                    this._currentSubscription = subscription;
                    this.__emitToSubscription.apply(this, [
                        subscription
                    ].concat(Array.prototype.slice.call(arguments)));
                }
            }
            this._currentSubscription = null;
        }
    } /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */ ;
    _proto.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
        var args = Array.prototype.slice.call(arguments, 2);
        subscription.listener.apply(subscription.context, args);
    };
    return BaseEventEmitter;
}();
module.exports = $2f67f96ceac464e0$var$BaseEventEmitter;

});
parcelRegister("ldJTP", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EmitterSubscription
 * @typechecks
 */ 'use strict';
function $f72e6a8d33ad636d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

var $jjvsO = parcelRequire("jjvsO");
/**
 * EmitterSubscription represents a subscription with listener and context data.
 */ var $f72e6a8d33ad636d$var$EmitterSubscription = /*#__PURE__*/ function(_EventSubscription) {
    $f72e6a8d33ad636d$var$_inheritsLoose(EmitterSubscription, _EventSubscription);
    /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */ function EmitterSubscription(subscriber, listener, context) {
        var _this;
        _this = _EventSubscription.call(this, subscriber) || this;
        _this.listener = listener;
        _this.context = context;
        return _this;
    }
    return EmitterSubscription;
}($jjvsO);
module.exports = $f72e6a8d33ad636d$var$EmitterSubscription;

});
parcelRegister("jjvsO", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */ 'use strict';
/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */ var $e0f832b6b132ea7e$var$EventSubscription = /*#__PURE__*/ function() {
    /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */ function EventSubscription(subscriber) {
        this.subscriber = subscriber;
    }
    /**
   * Removes this subscription from the subscriber that controls it.
   */ var _proto = EventSubscription.prototype;
    _proto.remove = function remove() {
        if (this.subscriber) {
            this.subscriber.removeSubscription(this);
            this.subscriber = null;
        }
    };
    return EventSubscription;
}();
module.exports = $e0f832b6b132ea7e$var$EventSubscription;

});


parcelRegister("ap3LK", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */ 'use strict';

var $lUGgA = parcelRequire("lUGgA");
/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */ var $792f29a435bb8a72$var$EventSubscriptionVendor = /*#__PURE__*/ function() {
    function EventSubscriptionVendor() {
        this._subscriptionsForType = {};
        this._currentSubscription = null;
    }
    /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */ var _proto = EventSubscriptionVendor.prototype;
    _proto.addSubscription = function addSubscription(eventType, subscription) {
        !(subscription.subscriber === this) && $lUGgA(false);
        if (!this._subscriptionsForType[eventType]) this._subscriptionsForType[eventType] = [];
        var key = this._subscriptionsForType[eventType].length;
        this._subscriptionsForType[eventType].push(subscription);
        subscription.eventType = eventType;
        subscription.key = key;
        return subscription;
    } /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */ ;
    _proto.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
        if (eventType === undefined) this._subscriptionsForType = {};
        else delete this._subscriptionsForType[eventType];
    } /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */ ;
    _proto.removeSubscription = function removeSubscription(subscription) {
        var eventType = subscription.eventType;
        var key = subscription.key;
        var subscriptionsForType = this._subscriptionsForType[eventType];
        if (subscriptionsForType) delete subscriptionsForType[key];
    } /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */ ;
    _proto.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
        return this._subscriptionsForType[eventType];
    };
    return EventSubscriptionVendor;
}();
module.exports = $792f29a435bb8a72$var$EventSubscriptionVendor;

});
parcelRegister("lUGgA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ 'use strict';
var $ff3f9d2b5a590b43$var$validateFormat = function(format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */ function $ff3f9d2b5a590b43$var$invariant(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    $ff3f9d2b5a590b43$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return String(args[argIndex++]);
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // Skip invariant's own stack frame.
        throw error;
    }
}
module.exports = $ff3f9d2b5a590b43$var$invariant;

});


parcelRegister("9Nafg", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $7210a323e2a92597$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $7210a323e2a92597$var$emptyFunction = function emptyFunction() {};
$7210a323e2a92597$var$emptyFunction.thatReturns = $7210a323e2a92597$var$makeEmptyFunction;
$7210a323e2a92597$var$emptyFunction.thatReturnsFalse = $7210a323e2a92597$var$makeEmptyFunction(false);
$7210a323e2a92597$var$emptyFunction.thatReturnsTrue = $7210a323e2a92597$var$makeEmptyFunction(true);
$7210a323e2a92597$var$emptyFunction.thatReturnsNull = $7210a323e2a92597$var$makeEmptyFunction(null);
$7210a323e2a92597$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$7210a323e2a92597$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $7210a323e2a92597$var$emptyFunction;

});



parcelRegister("gPJZG", function(module, exports) {
parcelRequire("ihibj");
var $aM8sl = parcelRequire("aM8sl");

var $gj93u = parcelRequire("gj93u");

var $b6Dha = parcelRequire("b6Dha");
var $c4151634a703ddc0$require$isPlainObject = $b6Dha.isPlainObject;

var $bc5yV = parcelRequire("bc5yV");

var $83WDE = parcelRequire("83WDE");

var $aw4IU = parcelRequire("aw4IU");
var $c4151634a703ddc0$require$postcssParse = $aw4IU.parse;
// Tags that can conceivably represent stand-alone media.
const $c4151634a703ddc0$var$mediaTags = [
    'img',
    'audio',
    'video',
    'picture',
    'svg',
    'object',
    'map',
    'iframe',
    'embed'
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $c4151634a703ddc0$var$vulnerableTags = [
    'script',
    'style'
];
function $c4151634a703ddc0$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $c4151634a703ddc0$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $c4151634a703ddc0$var$filter(a, cb) {
    const n = [];
    $c4151634a703ddc0$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $c4151634a703ddc0$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($c4151634a703ddc0$var$has(obj, key)) return false;
    }
    return true;
}
function $c4151634a703ddc0$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error('URL missing');
        return part.url + (part.w ? ` ${part.w}w` : '') + (part.h ? ` ${part.h}h` : '') + (part.d ? ` ${part.d}x` : '');
    }).join(', ');
}
module.exports = $c4151634a703ddc0$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $c4151634a703ddc0$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $c4151634a703ddc0$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return '';
    if (typeof html === 'number') html = html.toString();
    let result = '';
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    let tempResult = '';
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ''; // Node inner text
        this.openingTagLength = 0;
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $c4151634a703ddc0$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $c4151634a703ddc0$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $c4151634a703ddc0$var$htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $c4151634a703ddc0$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn(`

\u{26A0}\u{FE0F} Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    const nonTextTagsArray = options.nonTextTags || [
        'script',
        'style',
        'textarea',
        'option'
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $c4151634a703ddc0$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($gj93u(obj).replace(/\\\*/g, '.*'));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $c4151634a703ddc0$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$c4151634a703ddc0$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push('class');
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            const globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($gj93u(obj).replace(/\\\*/g, '.*'));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $c4151634a703ddc0$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === 'function') transFun = transform;
        else if (typeof transform === 'string') transFun = $c4151634a703ddc0$var$sanitizeHtml.simpleTransform(transform);
        if (tag === '*') transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser = new $aM8sl.Parser({
        onopentag: function(name, attribs) {
            if (options.onOpenTag) options.onOpenTag(name, attribs);
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === 'html') initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($c4151634a703ddc0$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === 'recursiveEscape' && !$c4151634a703ddc0$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    // We want the contents but not this tag
                    if (frame.innerText && !hasText) {
                        const escaped = escapeHtml(frame.innerText);
                        if (options.textFilter) result += options.textFilter(escaped, name);
                        else result += escaped;
                        addedText = true;
                    }
                    return;
                }
                tempResult = result;
                result = '';
            }
            result += '<' + name;
            if (name === 'script') {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = '';
            }
            if (!allowedAttributesMap || $c4151634a703ddc0$var$has(allowedAttributesMap, name) || allowedAttributesMap['*']) $c4151634a703ddc0$var$each(attribs, function(value, a) {
                if (!$c4151634a703ddc0$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, check if the attribute is in the allowedEmptyAttributes array.
                // If it is not in the allowedEmptyAttributes array, and it is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === '' && !options.allowedEmptyAttributes.includes(a) && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $c4151634a703ddc0$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || $c4151634a703ddc0$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($c4151634a703ddc0$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = '';
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(' ');
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === '') newValue = s;
                                else newValue += ' ' + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === 'script' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === 'iframe' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $c4151634a703ddc0$var$has(options, 'allowIframeRelativeUrls') ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'srcset') try {
                        let parsed = $83WDE(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref('srcset', value.url)) value.evil = true;
                        });
                        parsed = $c4151634a703ddc0$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $c4151634a703ddc0$var$stringifySrcset($c4151634a703ddc0$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === 'class') {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap['*'];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesRegex = allowedClassesRegexMap['*'];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $bc5yV(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'style') {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $c4151634a703ddc0$require$postcssParse(name + ' {' + value + '}', {
                                map: false
                            });
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== 'undefined') console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
                    }
                    result += ' ' + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                    else if (options.allowedEmptyAttributes.includes(a)) result += '=""';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += ' />';
            else {
                result += '>';
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
            frame.openingTagLength = result.length - frame.tagPosition;
        },
        ontext: function(text) {
            if (skipText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === 'completelyDiscard' && !tagAllowed(tag)) text = '';
            else if ((options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && (tag === 'script' || tag === 'style')) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else if (!addedText) {
                const escaped = escapeHtml(text, false);
                if (options.textFilter) result += options.textFilter(escaped, tag);
                else result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (options.onCloseTag) options.onCloseTag(name, isImplied);
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === 'html' : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = '';
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter) {
                const filterResult = options.exclusiveFilter(frame);
                if (filterResult === 'excludeTag') {
                    if (skip) {
                        // no longer escaping the tag since it's not added at all
                        result = tempResult;
                        tempResult = '';
                    }
                    // remove the opening tag from the result
                    result = result.substring(0, frame.tagPosition) + result.substring(frame.tagPosition + frame.openingTagLength);
                    return;
                } else if (filterResult) {
                    result = result.substring(0, frame.tagPosition);
                    return;
                }
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                'escape',
                'recursiveEscape'
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = '';
                }
                return;
            }
            result += '</' + name + '>';
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = '';
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== 'string') s = s + '';
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            if (quote) s = s.replace(/"/g, '&quot;');
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
        if (quote) s = s.replace(/"/g, '&quot;');
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, '');
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            const firstIndex = href.indexOf('<!--');
            if (firstIndex === -1) break;
            const lastIndex = href.indexOf('-->', firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        const scheme = matches[1].toLowerCase();
        if ($c4151634a703ddc0$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
        if (value.startsWith('relative:')) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error('relative: exploit attempt');
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = 'relative://relative-site';
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles['*']) selectedRule = $bc5yV(allowedStyles[astRules.selector], allowedStyles['*']);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`);
            return extractedAttributes;
        }, []).join(';');
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($c4151634a703ddc0$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(' ');
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $c4151634a703ddc0$var$htmlParserDefaults = {
    decodeEntities: true
};
$c4151634a703ddc0$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        'address',
        'article',
        'aside',
        'footer',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hgroup',
        'main',
        'nav',
        'section',
        // Text content
        'blockquote',
        'dd',
        'div',
        'dl',
        'dt',
        'figcaption',
        'figure',
        'hr',
        'li',
        'menu',
        'ol',
        'p',
        'pre',
        'ul',
        // Inline text semantics
        'a',
        'abbr',
        'b',
        'bdi',
        'bdo',
        'br',
        'cite',
        'code',
        'data',
        'dfn',
        'em',
        'i',
        'kbd',
        'mark',
        'q',
        'rb',
        'rp',
        'rt',
        'rtc',
        'ruby',
        's',
        'samp',
        'small',
        'span',
        'strong',
        'sub',
        'sup',
        'time',
        'u',
        'var',
        'wbr',
        // Table content
        'caption',
        'col',
        'colgroup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr'
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        'abbr',
        'accept',
        'accept-charset',
        'accesskey',
        'action',
        'allow',
        'alt',
        'as',
        'autocapitalize',
        'autocomplete',
        'blocking',
        'charset',
        'cite',
        'class',
        'color',
        'cols',
        'colspan',
        'content',
        'contenteditable',
        'coords',
        'crossorigin',
        'data',
        'datetime',
        'decoding',
        'dir',
        'dirname',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'fetchpriority',
        'for',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formtarget',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'http-equiv',
        'id',
        'imagesizes',
        'imagesrcset',
        'inputmode',
        'integrity',
        'is',
        'itemid',
        'itemprop',
        'itemref',
        'itemtype',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'name',
        'nonce',
        'optimum',
        'pattern',
        'ping',
        'placeholder',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'referrerpolicy',
        'rel',
        'rows',
        'rowspan',
        'sandbox',
        'scope',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'spellcheck',
        'src',
        'srcdoc',
        'srclang',
        'srcset',
        'start',
        'step',
        'style',
        'tabindex',
        'target',
        'title',
        'translate',
        'type',
        'usemap',
        'value',
        'width',
        'wrap',
        // Event handlers
        'onauxclick',
        'onafterprint',
        'onbeforematch',
        'onbeforeprint',
        'onbeforeunload',
        'onbeforetoggle',
        'onblur',
        'oncancel',
        'oncanplay',
        'oncanplaythrough',
        'onchange',
        'onclick',
        'onclose',
        'oncontextlost',
        'oncontextmenu',
        'oncontextrestored',
        'oncopy',
        'oncuechange',
        'oncut',
        'ondblclick',
        'ondrag',
        'ondragend',
        'ondragenter',
        'ondragleave',
        'ondragover',
        'ondragstart',
        'ondrop',
        'ondurationchange',
        'onemptied',
        'onended',
        'onerror',
        'onfocus',
        'onformdata',
        'onhashchange',
        'oninput',
        'oninvalid',
        'onkeydown',
        'onkeypress',
        'onkeyup',
        'onlanguagechange',
        'onload',
        'onloadeddata',
        'onloadedmetadata',
        'onloadstart',
        'onmessage',
        'onmessageerror',
        'onmousedown',
        'onmouseenter',
        'onmouseleave',
        'onmousemove',
        'onmouseout',
        'onmouseover',
        'onmouseup',
        'onoffline',
        'ononline',
        'onpagehide',
        'onpageshow',
        'onpaste',
        'onpause',
        'onplay',
        'onplaying',
        'onpopstate',
        'onprogress',
        'onratechange',
        'onreset',
        'onresize',
        'onrejectionhandled',
        'onscroll',
        'onscrollend',
        'onsecuritypolicyviolation',
        'onseeked',
        'onseeking',
        'onselect',
        'onslotchange',
        'onstalled',
        'onstorage',
        'onsubmit',
        'onsuspend',
        'ontimeupdate',
        'ontoggle',
        'onunhandledrejection',
        'onunload',
        'onvolumechange',
        'onwaiting',
        'onwheel'
    ],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
        a: [
            'href',
            'name',
            'target'
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height',
            'loading'
        ]
    },
    allowedEmptyAttributes: [
        'alt'
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        'img',
        'br',
        'hr',
        'area',
        'base',
        'basefont',
        'input',
        'link',
        'meta'
    ],
    // URL schemes we permit
    allowedSchemes: [
        'http',
        'https',
        'ftp',
        'mailto',
        'tel'
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        'href',
        'src',
        'cite'
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$c4151634a703ddc0$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};

});
parcelRegister("ihibj", function(module, exports) {

$parcel$export(module.exports, "Parser", () => (parcelRequire("aM8sl")).Parser);

var $aM8sl = parcelRequire("aM8sl");

var $7Z39T = parcelRequire("7Z39T");

var $fof8C = parcelRequire("fof8C");

var $hREhV = parcelRequire("hREhV");
parcelRequire("CeYTB");
var $2FnQg = parcelRequire("2FnQg");
function $d4e7eaf97d0b330d$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $7Z39T.DomHandler)(undefined, options);
    new (0, $aM8sl.Parser)(handler, options).end(data);
    return handler.root;
}
function $d4e7eaf97d0b330d$export$d66b332881d9723f(data, options) {
    return $d4e7eaf97d0b330d$export$b6a9369736b19f4d(data, options).children;
}
function $d4e7eaf97d0b330d$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $7Z39T.DomHandler)(callback, options, elementCallback);
    return new (0, $aM8sl.Parser)(handler, options);
}
const $d4e7eaf97d0b330d$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $d4e7eaf97d0b330d$export$5267abf679cd576b(feed, options = $d4e7eaf97d0b330d$var$parseFeedDefaultOptions) {
    return (0, $2FnQg.getFeed)($d4e7eaf97d0b330d$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("aM8sl", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $7d84f24eb05ad815$export$7acfa6ed01010e37);

var $fof8C = parcelRequire("fof8C");

var $9Qycb = parcelRequire("9Qycb");
const $7d84f24eb05ad815$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $7d84f24eb05ad815$var$pTag = new Set([
    "p"
]);
const $7d84f24eb05ad815$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $7d84f24eb05ad815$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $7d84f24eb05ad815$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $7d84f24eb05ad815$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h1",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h2",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h3",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h4",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h5",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "h6",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "select",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "input",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "output",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "button",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "datalist",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "textarea",
        $7d84f24eb05ad815$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $7d84f24eb05ad815$var$ddtTags
    ],
    [
        "dt",
        $7d84f24eb05ad815$var$ddtTags
    ],
    [
        "address",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "article",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "aside",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "blockquote",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "details",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "div",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "dl",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "fieldset",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "figcaption",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "figure",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "footer",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "form",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "header",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "hr",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "main",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "nav",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "ol",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "pre",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "section",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "table",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "ul",
        $7d84f24eb05ad815$var$pTag
    ],
    [
        "rt",
        $7d84f24eb05ad815$var$rtpTags
    ],
    [
        "rp",
        $7d84f24eb05ad815$var$rtpTags
    ],
    [
        "tbody",
        $7d84f24eb05ad815$var$tableSectionTags
    ],
    [
        "tfoot",
        $7d84f24eb05ad815$var$tableSectionTags
    ]
]);
const $7d84f24eb05ad815$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $7d84f24eb05ad815$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $7d84f24eb05ad815$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $7d84f24eb05ad815$var$reNameEnd = /\s|\//;
class $7d84f24eb05ad815$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $fof8C.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $9Qycb.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $7d84f24eb05ad815$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $7d84f24eb05ad815$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($7d84f24eb05ad815$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($7d84f24eb05ad815$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($7d84f24eb05ad815$var$foreignContextElements.has(name) || $7d84f24eb05ad815$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $9Qycb.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $fof8C.QuoteType).Double ? '"' : quote === (0, $fof8C.QuoteType).Single ? "'" : quote === (0, $fof8C.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($7d84f24eb05ad815$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}

});
parcelRegister("fof8C", function(module, exports) {

$parcel$export(module.exports, "QuoteType", () => $b344d705acf01ec5$export$cbf5509cea2ad22);
$parcel$export(module.exports, "default", () => $b344d705acf01ec5$export$2e2bcd8739ae039);

var $9Qycb = parcelRequire("9Qycb");
var $b344d705acf01ec5$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($b344d705acf01ec5$var$CharCodes || ($b344d705acf01ec5$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $b344d705acf01ec5$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($b344d705acf01ec5$var$State || ($b344d705acf01ec5$var$State = {}));
function $b344d705acf01ec5$var$isWhitespace(c) {
    return c === $b344d705acf01ec5$var$CharCodes.Space || c === $b344d705acf01ec5$var$CharCodes.NewLine || c === $b344d705acf01ec5$var$CharCodes.Tab || c === $b344d705acf01ec5$var$CharCodes.FormFeed || c === $b344d705acf01ec5$var$CharCodes.CarriageReturn;
}
function $b344d705acf01ec5$var$isEndOfTagSection(c) {
    return c === $b344d705acf01ec5$var$CharCodes.Slash || c === $b344d705acf01ec5$var$CharCodes.Gt || $b344d705acf01ec5$var$isWhitespace(c);
}
function $b344d705acf01ec5$var$isNumber(c) {
    return c >= $b344d705acf01ec5$var$CharCodes.Zero && c <= $b344d705acf01ec5$var$CharCodes.Nine;
}
function $b344d705acf01ec5$var$isASCIIAlpha(c) {
    return c >= $b344d705acf01ec5$var$CharCodes.LowerA && c <= $b344d705acf01ec5$var$CharCodes.LowerZ || c >= $b344d705acf01ec5$var$CharCodes.UpperA && c <= $b344d705acf01ec5$var$CharCodes.UpperZ;
}
function $b344d705acf01ec5$var$isHexDigit(c) {
    return c >= $b344d705acf01ec5$var$CharCodes.UpperA && c <= $b344d705acf01ec5$var$CharCodes.UpperF || c >= $b344d705acf01ec5$var$CharCodes.LowerA && c <= $b344d705acf01ec5$var$CharCodes.LowerF;
}
var $b344d705acf01ec5$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($b344d705acf01ec5$export$cbf5509cea2ad22 || ($b344d705acf01ec5$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $b344d705acf01ec5$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $b344d705acf01ec5$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $b344d705acf01ec5$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $b344d705acf01ec5$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $9Qycb.xmlDecodeTree) : (0, $9Qycb.htmlDecodeTree);
    }
    reset() {
        this.state = $b344d705acf01ec5$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $b344d705acf01ec5$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $b344d705acf01ec5$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $b344d705acf01ec5$var$CharCodes.Amp) this.state = $b344d705acf01ec5$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $b344d705acf01ec5$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $b344d705acf01ec5$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $b344d705acf01ec5$var$CharCodes.Gt || $b344d705acf01ec5$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $b344d705acf01ec5$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $b344d705acf01ec5$var$CharCodes.Amp) this.state = $b344d705acf01ec5$var$State.BeforeEntity;
            } else if (this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $b344d705acf01ec5$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $b344d705acf01ec5$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $b344d705acf01ec5$var$Sequences.Cdata.length) {
                this.state = $b344d705acf01ec5$var$State.InCommentLike;
                this.currentSequence = $b344d705acf01ec5$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $b344d705acf01ec5$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $b344d705acf01ec5$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $b344d705acf01ec5$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$b344d705acf01ec5$var$isEndOfTagSection(c) : $b344d705acf01ec5$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $b344d705acf01ec5$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.ExclamationMark) {
            this.state = $b344d705acf01ec5$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $b344d705acf01ec5$var$CharCodes.Questionmark) {
            this.state = $b344d705acf01ec5$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $b344d705acf01ec5$var$Sequences.TitleEnd[2]) this.startSpecial($b344d705acf01ec5$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $b344d705acf01ec5$var$Sequences.ScriptEnd[2] ? $b344d705acf01ec5$var$State.BeforeSpecialS : $b344d705acf01ec5$var$State.InTagName;
        } else if (c === $b344d705acf01ec5$var$CharCodes.Slash) this.state = $b344d705acf01ec5$var$State.BeforeClosingTagName;
        else {
            this.state = $b344d705acf01ec5$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($b344d705acf01ec5$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b344d705acf01ec5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($b344d705acf01ec5$var$isWhitespace(c)) ;
        else if (c === $b344d705acf01ec5$var$CharCodes.Gt) this.state = $b344d705acf01ec5$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $b344d705acf01ec5$var$State.InClosingTagName : $b344d705acf01ec5$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt || $b344d705acf01ec5$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b344d705acf01ec5$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $b344d705acf01ec5$var$CharCodes.Gt || this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Gt)) {
            this.state = $b344d705acf01ec5$var$State.Text;
            this.baseState = $b344d705acf01ec5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $b344d705acf01ec5$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $b344d705acf01ec5$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $b344d705acf01ec5$var$CharCodes.Slash) this.state = $b344d705acf01ec5$var$State.InSelfClosingTag;
        else if (!$b344d705acf01ec5$var$isWhitespace(c)) {
            this.state = $b344d705acf01ec5$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $b344d705acf01ec5$var$State.Text;
            this.baseState = $b344d705acf01ec5$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$b344d705acf01ec5$var$isWhitespace(c)) {
            this.state = $b344d705acf01ec5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Eq || $b344d705acf01ec5$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b344d705acf01ec5$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Eq) this.state = $b344d705acf01ec5$var$State.BeforeAttributeValue;
        else if (c === $b344d705acf01ec5$var$CharCodes.Slash || c === $b344d705acf01ec5$var$CharCodes.Gt) {
            this.cbs.onattribend($b344d705acf01ec5$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $b344d705acf01ec5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$b344d705acf01ec5$var$isWhitespace(c)) {
            this.cbs.onattribend($b344d705acf01ec5$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $b344d705acf01ec5$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.DoubleQuote) {
            this.state = $b344d705acf01ec5$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $b344d705acf01ec5$var$CharCodes.SingleQuote) {
            this.state = $b344d705acf01ec5$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$b344d705acf01ec5$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $b344d705acf01ec5$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $b344d705acf01ec5$var$CharCodes.DoubleQuote ? $b344d705acf01ec5$export$cbf5509cea2ad22.Double : $b344d705acf01ec5$export$cbf5509cea2ad22.Single, this.index);
            this.state = $b344d705acf01ec5$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $b344d705acf01ec5$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $b344d705acf01ec5$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $b344d705acf01ec5$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $b344d705acf01ec5$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($b344d705acf01ec5$var$isWhitespace(c) || c === $b344d705acf01ec5$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($b344d705acf01ec5$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $b344d705acf01ec5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $b344d705acf01ec5$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $b344d705acf01ec5$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.OpeningSquareBracket) {
            this.state = $b344d705acf01ec5$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $b344d705acf01ec5$var$CharCodes.Dash ? $b344d705acf01ec5$var$State.BeforeComment : $b344d705acf01ec5$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt || this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $b344d705acf01ec5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt || this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $b344d705acf01ec5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Dash) {
            this.state = $b344d705acf01ec5$var$State.InCommentLike;
            this.currentSequence = $b344d705acf01ec5$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $b344d705acf01ec5$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Gt || this.fastForwardTo($b344d705acf01ec5$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $b344d705acf01ec5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $b344d705acf01ec5$var$Sequences.ScriptEnd[3]) this.startSpecial($b344d705acf01ec5$var$Sequences.ScriptEnd, 4);
        else if (lower === $b344d705acf01ec5$var$Sequences.StyleEnd[3]) this.startSpecial($b344d705acf01ec5$var$Sequences.StyleEnd, 4);
        else {
            this.state = $b344d705acf01ec5$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $b344d705acf01ec5$var$CharCodes.Number) this.state = $b344d705acf01ec5$var$State.BeforeNumericEntity;
        else if (c === $b344d705acf01ec5$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $b344d705acf01ec5$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $9Qycb.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $9Qycb.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $b344d705acf01ec5$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $9Qycb.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $9Qycb.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $b344d705acf01ec5$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $b344d705acf01ec5$var$State.InHexEntity;
        } else {
            this.state = $b344d705acf01ec5$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $b344d705acf01ec5$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $9Qycb.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($b344d705acf01ec5$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $b344d705acf01ec5$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $b344d705acf01ec5$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($b344d705acf01ec5$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $b344d705acf01ec5$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($b344d705acf01ec5$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $b344d705acf01ec5$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $b344d705acf01ec5$var$State.Text || this.baseState === $b344d705acf01ec5$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $b344d705acf01ec5$var$State.Text || this.state === $b344d705acf01ec5$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $b344d705acf01ec5$var$State.InAttributeValueDq || this.state === $b344d705acf01ec5$var$State.InAttributeValueSq || this.state === $b344d705acf01ec5$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $b344d705acf01ec5$var$State.Text:
                    this.stateText(c);
                    break;
                case $b344d705acf01ec5$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $b344d705acf01ec5$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $b344d705acf01ec5$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $b344d705acf01ec5$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $b344d705acf01ec5$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $b344d705acf01ec5$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $b344d705acf01ec5$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $b344d705acf01ec5$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $b344d705acf01ec5$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $b344d705acf01ec5$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $b344d705acf01ec5$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $b344d705acf01ec5$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $b344d705acf01ec5$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $b344d705acf01ec5$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $b344d705acf01ec5$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $b344d705acf01ec5$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $b344d705acf01ec5$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $b344d705acf01ec5$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $b344d705acf01ec5$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $b344d705acf01ec5$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $b344d705acf01ec5$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $b344d705acf01ec5$var$State.InCommentLike) {
            if (this.currentSequence === $b344d705acf01ec5$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $b344d705acf01ec5$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $b344d705acf01ec5$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $b344d705acf01ec5$var$State.InTagName || this.state === $b344d705acf01ec5$var$State.BeforeAttributeName || this.state === $b344d705acf01ec5$var$State.BeforeAttributeValue || this.state === $b344d705acf01ec5$var$State.AfterAttributeName || this.state === $b344d705acf01ec5$var$State.InAttributeName || this.state === $b344d705acf01ec5$var$State.InAttributeValueSq || this.state === $b344d705acf01ec5$var$State.InAttributeValueDq || this.state === $b344d705acf01ec5$var$State.InAttributeValueNq || this.state === $b344d705acf01ec5$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $b344d705acf01ec5$var$State.Text && this.baseState !== $b344d705acf01ec5$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $b344d705acf01ec5$var$State.Text && this.baseState !== $b344d705acf01ec5$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
}

});
parcelRegister("9Qycb", function(module, exports) {
"use strict";
var $72b37ee893519d5e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $72b37ee893519d5e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $72b37ee893519d5e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $72b37ee893519d5e$var$__createBinding(result, mod, k);
    }
    $72b37ee893519d5e$var$__setModuleDefault(result, mod);
    return result;
};
var $72b37ee893519d5e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $72b37ee893519d5e$var$decode_data_html_js_1 = $72b37ee893519d5e$var$__importDefault((parcelRequire("1j1sX")));
module.exports.htmlDecodeTree = $72b37ee893519d5e$var$decode_data_html_js_1.default;

var $72b37ee893519d5e$var$decode_data_xml_js_1 = $72b37ee893519d5e$var$__importDefault((parcelRequire("jlGhZ")));
module.exports.xmlDecodeTree = $72b37ee893519d5e$var$decode_data_xml_js_1.default;

var $72b37ee893519d5e$var$decode_codepoint_js_1 = $72b37ee893519d5e$var$__importStar((parcelRequire("2XKUe")));
module.exports.decodeCodePoint = $72b37ee893519d5e$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("2XKUe")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("2XKUe")).fromCodePoint;
    }
});
var $72b37ee893519d5e$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($72b37ee893519d5e$var$CharCodes || ($72b37ee893519d5e$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $72b37ee893519d5e$var$TO_LOWER_BIT = 32;
var $72b37ee893519d5e$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($72b37ee893519d5e$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $72b37ee893519d5e$var$isNumber(code) {
    return code >= $72b37ee893519d5e$var$CharCodes.ZERO && code <= $72b37ee893519d5e$var$CharCodes.NINE;
}
function $72b37ee893519d5e$var$isHexadecimalCharacter(code) {
    return code >= $72b37ee893519d5e$var$CharCodes.UPPER_A && code <= $72b37ee893519d5e$var$CharCodes.UPPER_F || code >= $72b37ee893519d5e$var$CharCodes.LOWER_A && code <= $72b37ee893519d5e$var$CharCodes.LOWER_F;
}
function $72b37ee893519d5e$var$isAsciiAlphaNumeric(code) {
    return code >= $72b37ee893519d5e$var$CharCodes.UPPER_A && code <= $72b37ee893519d5e$var$CharCodes.UPPER_Z || code >= $72b37ee893519d5e$var$CharCodes.LOWER_A && code <= $72b37ee893519d5e$var$CharCodes.LOWER_Z || $72b37ee893519d5e$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $72b37ee893519d5e$var$isEntityInAttributeInvalidEnd(code) {
    return code === $72b37ee893519d5e$var$CharCodes.EQUALS || $72b37ee893519d5e$var$isAsciiAlphaNumeric(code);
}
var $72b37ee893519d5e$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($72b37ee893519d5e$var$EntityDecoderState || ($72b37ee893519d5e$var$EntityDecoderState = {}));
var $72b37ee893519d5e$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($72b37ee893519d5e$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $72b37ee893519d5e$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $72b37ee893519d5e$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $72b37ee893519d5e$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $72b37ee893519d5e$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $72b37ee893519d5e$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $72b37ee893519d5e$var$CharCodes.NUM) {
                    this.state = $72b37ee893519d5e$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $72b37ee893519d5e$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $72b37ee893519d5e$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $72b37ee893519d5e$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $72b37ee893519d5e$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $72b37ee893519d5e$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $72b37ee893519d5e$var$TO_LOWER_BIT) === $72b37ee893519d5e$var$CharCodes.LOWER_X) {
            this.state = $72b37ee893519d5e$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $72b37ee893519d5e$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($72b37ee893519d5e$var$isNumber(char) || $72b37ee893519d5e$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($72b37ee893519d5e$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $72b37ee893519d5e$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $72b37ee893519d5e$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $72b37ee893519d5e$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $72b37ee893519d5e$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $72b37ee893519d5e$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $72b37ee893519d5e$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $72b37ee893519d5e$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $72b37ee893519d5e$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $72b37ee893519d5e$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $72b37ee893519d5e$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $72b37ee893519d5e$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $72b37ee893519d5e$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$72b37ee893519d5e$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $72b37ee893519d5e$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $72b37ee893519d5e$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $72b37ee893519d5e$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $72b37ee893519d5e$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $72b37ee893519d5e$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $72b37ee893519d5e$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $72b37ee893519d5e$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $72b37ee893519d5e$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $72b37ee893519d5e$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $72b37ee893519d5e$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $72b37ee893519d5e$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $72b37ee893519d5e$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $72b37ee893519d5e$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $72b37ee893519d5e$var$determineBranch;
var $72b37ee893519d5e$var$htmlDecoder = $72b37ee893519d5e$var$getDecoder($72b37ee893519d5e$var$decode_data_html_js_1.default);
var $72b37ee893519d5e$var$xmlDecoder = $72b37ee893519d5e$var$getDecoder($72b37ee893519d5e$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $72b37ee893519d5e$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $72b37ee893519d5e$var$DecodingMode.Legacy;
    return $72b37ee893519d5e$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $72b37ee893519d5e$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $72b37ee893519d5e$var$decodeHTMLAttribute(str) {
    return $72b37ee893519d5e$var$htmlDecoder(str, $72b37ee893519d5e$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $72b37ee893519d5e$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $72b37ee893519d5e$var$decodeHTMLStrict(str) {
    return $72b37ee893519d5e$var$htmlDecoder(str, $72b37ee893519d5e$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $72b37ee893519d5e$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $72b37ee893519d5e$var$decodeXML(str) {
    return $72b37ee893519d5e$var$xmlDecoder(str, $72b37ee893519d5e$var$DecodingMode.Strict);
}
module.exports.decodeXML = $72b37ee893519d5e$var$decodeXML;

});



parcelRegister("7Z39T", function(module, exports) {
$parcel$export(module.exports, "CDATA", () => (parcelRequire("3zekA")).CDATA);
$parcel$export(module.exports, "Comment", () => (parcelRequire("3zekA")).Comment);
$parcel$export(module.exports, "Document", () => (parcelRequire("3zekA")).Document);
$parcel$export(module.exports, "Element", () => (parcelRequire("3zekA")).Element);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("3zekA")).hasChildren);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("3zekA")).isCDATA);
$parcel$export(module.exports, "isComment", () => (parcelRequire("3zekA")).isComment);
$parcel$export(module.exports, "isTag", () => (parcelRequire("3zekA")).isTag);
$parcel$export(module.exports, "isText", () => (parcelRequire("3zekA")).isText);
$parcel$export(module.exports, "ProcessingInstruction", () => (parcelRequire("3zekA")).ProcessingInstruction);
$parcel$export(module.exports, "Text", () => (parcelRequire("3zekA")).Text);

$parcel$export(module.exports, "DomHandler", () => $5d00ae21c5789654$export$ff8ccbac9225de62);

var $hREhV = parcelRequire("hREhV");

var $3zekA = parcelRequire("3zekA");
// Default options
const $5d00ae21c5789654$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $5d00ae21c5789654$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $3zekA.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $5d00ae21c5789654$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $5d00ae21c5789654$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $3zekA.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $hREhV.ElementType).Tag : undefined;
        const element = new (0, $3zekA.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $hREhV.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $3zekA.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $hREhV.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $3zekA.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $3zekA.Text)("");
        const node = new (0, $3zekA.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $3zekA.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $5d00ae21c5789654$export$2e2bcd8739ae039 = $5d00ae21c5789654$export$ff8ccbac9225de62;

});
parcelRegister("hREhV", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $d016a34ede83f3d0$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $d016a34ede83f3d0$export$3bf645f08efe3292);
$parcel$export(module.exports, "Root", () => $d016a34ede83f3d0$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Text", () => $d016a34ede83f3d0$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Directive", () => $d016a34ede83f3d0$export$befdefbdce210f91);
$parcel$export(module.exports, "Comment", () => $d016a34ede83f3d0$export$4d299b491347818a);
$parcel$export(module.exports, "Script", () => $d016a34ede83f3d0$export$2f8b47a141e57afc);
$parcel$export(module.exports, "Style", () => $d016a34ede83f3d0$export$d9e45bc13d335801);
$parcel$export(module.exports, "Tag", () => $d016a34ede83f3d0$export$3288d34c523a1192);
$parcel$export(module.exports, "CDATA", () => $d016a34ede83f3d0$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Doctype", () => $d016a34ede83f3d0$export$31b44af36ff2c60f);
/** Types of elements found in htmlparser2's DOM */ var $d016a34ede83f3d0$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($d016a34ede83f3d0$export$b992dc138d950e31 || ($d016a34ede83f3d0$export$b992dc138d950e31 = {}));
function $d016a34ede83f3d0$export$3bf645f08efe3292(elem) {
    return elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Tag || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Script || elem.type === $d016a34ede83f3d0$export$b992dc138d950e31.Style;
}
const $d016a34ede83f3d0$export$be92b6f5f03c0fe9 = $d016a34ede83f3d0$export$b992dc138d950e31.Root;
const $d016a34ede83f3d0$export$5f1af8db9871e1d6 = $d016a34ede83f3d0$export$b992dc138d950e31.Text;
const $d016a34ede83f3d0$export$befdefbdce210f91 = $d016a34ede83f3d0$export$b992dc138d950e31.Directive;
const $d016a34ede83f3d0$export$4d299b491347818a = $d016a34ede83f3d0$export$b992dc138d950e31.Comment;
const $d016a34ede83f3d0$export$2f8b47a141e57afc = $d016a34ede83f3d0$export$b992dc138d950e31.Script;
const $d016a34ede83f3d0$export$d9e45bc13d335801 = $d016a34ede83f3d0$export$b992dc138d950e31.Style;
const $d016a34ede83f3d0$export$3288d34c523a1192 = $d016a34ede83f3d0$export$b992dc138d950e31.Tag;
const $d016a34ede83f3d0$export$1f8b8f7e5c763232 = $d016a34ede83f3d0$export$b992dc138d950e31.CDATA;
const $d016a34ede83f3d0$export$31b44af36ff2c60f = $d016a34ede83f3d0$export$b992dc138d950e31.Doctype;

});

parcelRegister("3zekA", function(module, exports) {

$parcel$export(module.exports, "Text", () => $298fc1d08428934f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $298fc1d08428934f$export$4d299b491347818a);
$parcel$export(module.exports, "ProcessingInstruction", () => $298fc1d08428934f$export$9269dce19ee35e96);
$parcel$export(module.exports, "CDATA", () => $298fc1d08428934f$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Document", () => $298fc1d08428934f$export$b34a105447964f9f);
$parcel$export(module.exports, "Element", () => $298fc1d08428934f$export$db77ccec0bb4ccac);
$parcel$export(module.exports, "isTag", () => $298fc1d08428934f$export$3bf645f08efe3292);
$parcel$export(module.exports, "isCDATA", () => $298fc1d08428934f$export$c2d65aed98d39b56);
$parcel$export(module.exports, "isText", () => $298fc1d08428934f$export$1879817ac5c922b7);
$parcel$export(module.exports, "isComment", () => $298fc1d08428934f$export$3ab01370f5e64ac8);
$parcel$export(module.exports, "hasChildren", () => $298fc1d08428934f$export$bd5ff50f0e53d41c);

var $hREhV = parcelRequire("hREhV");
class $298fc1d08428934f$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $298fc1d08428934f$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $298fc1d08428934f$export$c3569d91cd44d357 extends $298fc1d08428934f$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $298fc1d08428934f$export$5f1af8db9871e1d6 extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $298fc1d08428934f$export$4d299b491347818a extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $298fc1d08428934f$export$9269dce19ee35e96 extends $298fc1d08428934f$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $hREhV.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $298fc1d08428934f$export$62be934f90997196 extends $298fc1d08428934f$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $298fc1d08428934f$export$1f8b8f7e5c763232 extends $298fc1d08428934f$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $298fc1d08428934f$export$b34a105447964f9f extends $298fc1d08428934f$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $hREhV.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $298fc1d08428934f$export$db77ccec0bb4ccac extends $298fc1d08428934f$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $hREhV.ElementType).Script : name === "style" ? (0, $hREhV.ElementType).Style : (0, $hREhV.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $298fc1d08428934f$export$3bf645f08efe3292(node) {
    return (0, $hREhV.isTag)(node);
}
function $298fc1d08428934f$export$c2d65aed98d39b56(node) {
    return node.type === (0, $hREhV.ElementType).CDATA;
}
function $298fc1d08428934f$export$1879817ac5c922b7(node) {
    return node.type === (0, $hREhV.ElementType).Text;
}
function $298fc1d08428934f$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $hREhV.ElementType).Comment;
}
function $298fc1d08428934f$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $hREhV.ElementType).Directive;
}
function $298fc1d08428934f$export$62858bae88b53fd0(node) {
    return node.type === (0, $hREhV.ElementType).Root;
}
function $298fc1d08428934f$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $298fc1d08428934f$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($298fc1d08428934f$export$1879817ac5c922b7(node)) result = new $298fc1d08428934f$export$5f1af8db9871e1d6(node.data);
    else if ($298fc1d08428934f$export$3ab01370f5e64ac8(node)) result = new $298fc1d08428934f$export$4d299b491347818a(node.data);
    else if ($298fc1d08428934f$export$3bf645f08efe3292(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($298fc1d08428934f$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($298fc1d08428934f$export$62858bae88b53fd0(node)) {
        const children = recursive ? $298fc1d08428934f$var$cloneChildren(node.children) : [];
        const clone = new $298fc1d08428934f$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($298fc1d08428934f$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $298fc1d08428934f$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $298fc1d08428934f$var$cloneChildren(childs) {
    const children = childs.map((child)=>$298fc1d08428934f$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("CeYTB", function(module, exports) {
$parcel$export(module.exports, "getFeed", () => (parcelRequire("2FnQg")).getFeed);
parcelRequire("86PNL");
parcelRequire("cWyns");
parcelRequire("2VlnM");
parcelRequire("bPZtU");
parcelRequire("dYR1U");
parcelRequire("7ZYrI");
parcelRequire("2FnQg");
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

});
parcelRegister("86PNL", function(module, exports) {

$parcel$export(module.exports, "textContent", () => $5e7710faf81de260$export$e0e0794250e9118f);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $k4wK2 = parcelRequire("k4wK2");

var $hREhV = parcelRequire("hREhV");
function $5e7710faf81de260$export$39484b727cc2f324(node, options) {
    return (0, $k4wK2.default)(node, options);
}
function $5e7710faf81de260$export$7ed15b4d2218408(node, options) {
    return (0, $3zekA.hasChildren)(node) ? node.children.map((node)=>$5e7710faf81de260$export$39484b727cc2f324(node, options)).join("") : "";
}
function $5e7710faf81de260$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$c72d34660a162238).join("");
    if ((0, $3zekA.isTag)(node)) return node.name === "br" ? "\n" : $5e7710faf81de260$export$c72d34660a162238(node.children);
    if ((0, $3zekA.isCDATA)(node)) return $5e7710faf81de260$export$c72d34660a162238(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}
function $5e7710faf81de260$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$e0e0794250e9118f).join("");
    if ((0, $3zekA.hasChildren)(node) && !(0, $3zekA.isComment)(node)) return $5e7710faf81de260$export$e0e0794250e9118f(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}
function $5e7710faf81de260$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($5e7710faf81de260$export$5864bc2a45f1eb81).join("");
    if ((0, $3zekA.hasChildren)(node) && (node.type === (0, $hREhV.ElementType).Tag || (0, $3zekA.isCDATA)(node))) return $5e7710faf81de260$export$5864bc2a45f1eb81(node.children);
    if ((0, $3zekA.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("k4wK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd942395a2f848$export$2e2bcd8739ae039);
/*
 * Module dependencies
 */ 
var $hREhV = parcelRequire("hREhV");
parcelRequire("72ovm");
var $k5nvo = parcelRequire("k5nvo");

var $h1j8A = parcelRequire("h1j8A");
const $e9cd942395a2f848$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $e9cd942395a2f848$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $e9cd942395a2f848$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $e9cd942395a2f848$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $k5nvo.encodeXML) : (0, $k5nvo.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $h1j8A.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $e9cd942395a2f848$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $e9cd942395a2f848$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $e9cd942395a2f848$var$renderNode(nodes[i], options);
    return output;
}
var $e9cd942395a2f848$export$2e2bcd8739ae039 = $e9cd942395a2f848$export$b3890eb0ae9dca99;
function $e9cd942395a2f848$var$renderNode(node, options) {
    switch(node.type){
        case $hREhV.Root:
            return $e9cd942395a2f848$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $hREhV.Doctype:
        case $hREhV.Directive:
            return $e9cd942395a2f848$var$renderDirective(node);
        case $hREhV.Comment:
            return $e9cd942395a2f848$var$renderComment(node);
        case $hREhV.CDATA:
            return $e9cd942395a2f848$var$renderCdata(node);
        case $hREhV.Script:
        case $hREhV.Style:
        case $hREhV.Tag:
            return $e9cd942395a2f848$var$renderTag(node, options);
        case $hREhV.Text:
            return $e9cd942395a2f848$var$renderText(node, options);
    }
}
const $e9cd942395a2f848$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $e9cd942395a2f848$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $e9cd942395a2f848$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $h1j8A.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $e9cd942395a2f848$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $e9cd942395a2f848$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $e9cd942395a2f848$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $e9cd942395a2f848$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $e9cd942395a2f848$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$e9cd942395a2f848$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $e9cd942395a2f848$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $e9cd942395a2f848$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $e9cd942395a2f848$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $k5nvo.encodeXML)(data) : (0, $k5nvo.escapeText)(data);
    return data;
}
function $e9cd942395a2f848$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $e9cd942395a2f848$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRegister("72ovm", function(module, exports) {

$parcel$export(module.exports, "encodeXML", () => (parcelRequire("k5nvo")).encodeXML);
$parcel$export(module.exports, "escapeAttribute", () => (parcelRequire("k5nvo")).escapeAttribute);
$parcel$export(module.exports, "escapeText", () => (parcelRequire("k5nvo")).escapeText);

var $9kjeY = parcelRequire("9kjeY");

var $hSfxK = parcelRequire("hSfxK");

var $k5nvo = parcelRequire("k5nvo");
var $51fbba7aa6100194$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($51fbba7aa6100194$export$b8c86583d9718b50 || ($51fbba7aa6100194$export$b8c86583d9718b50 = {}));
var $51fbba7aa6100194$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($51fbba7aa6100194$export$1851b20d614eb756 || ($51fbba7aa6100194$export$1851b20d614eb756 = {}));
function $51fbba7aa6100194$export$2f872c0f2117be69(data, options = $51fbba7aa6100194$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $51fbba7aa6100194$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $9kjeY.decodeHTML)(data, mode);
    }
    return (0, $9kjeY.decodeXML)(data);
}
function $51fbba7aa6100194$export$c94669f4c7d36be4(data, options = $51fbba7aa6100194$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $9kjeY.DecodingMode).Strict;
    return $51fbba7aa6100194$export$2f872c0f2117be69(data, opts);
}
function $51fbba7aa6100194$export$c564cdbbe6da493(data, options = $51fbba7aa6100194$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $51fbba7aa6100194$export$1851b20d614eb756.UTF8) return (0, $k5nvo.escapeUTF8)(data);
    if (opts.mode === $51fbba7aa6100194$export$1851b20d614eb756.Attribute) return (0, $k5nvo.escapeAttribute)(data);
    if (opts.mode === $51fbba7aa6100194$export$1851b20d614eb756.Text) return (0, $k5nvo.escapeText)(data);
    if (opts.level === $51fbba7aa6100194$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $51fbba7aa6100194$export$1851b20d614eb756.ASCII) return (0, $hSfxK.encodeNonAsciiHTML)(data);
        return (0, $hSfxK.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $k5nvo.encodeXML)(data);
}

});
parcelRegister("9kjeY", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $6ca4e818ac206989$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $6ca4e818ac206989$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $6ca4e818ac206989$export$88e3b9643a8bd06e);

var $5Odbq = parcelRequire("5Odbq");

var $fxy3I = parcelRequire("fxy3I");

var $fN5Fe = parcelRequire("fN5Fe");
var $6ca4e818ac206989$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($6ca4e818ac206989$var$CharCodes || ($6ca4e818ac206989$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $6ca4e818ac206989$var$TO_LOWER_BIT = 32;
var $6ca4e818ac206989$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($6ca4e818ac206989$export$6a4325c613e0faec || ($6ca4e818ac206989$export$6a4325c613e0faec = {}));
function $6ca4e818ac206989$var$isNumber(code) {
    return code >= $6ca4e818ac206989$var$CharCodes.ZERO && code <= $6ca4e818ac206989$var$CharCodes.NINE;
}
function $6ca4e818ac206989$var$isHexadecimalCharacter(code) {
    return code >= $6ca4e818ac206989$var$CharCodes.UPPER_A && code <= $6ca4e818ac206989$var$CharCodes.UPPER_F || code >= $6ca4e818ac206989$var$CharCodes.LOWER_A && code <= $6ca4e818ac206989$var$CharCodes.LOWER_F;
}
function $6ca4e818ac206989$var$isAsciiAlphaNumeric(code) {
    return code >= $6ca4e818ac206989$var$CharCodes.UPPER_A && code <= $6ca4e818ac206989$var$CharCodes.UPPER_Z || code >= $6ca4e818ac206989$var$CharCodes.LOWER_A && code <= $6ca4e818ac206989$var$CharCodes.LOWER_Z || $6ca4e818ac206989$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $6ca4e818ac206989$var$isEntityInAttributeInvalidEnd(code) {
    return code === $6ca4e818ac206989$var$CharCodes.EQUALS || $6ca4e818ac206989$var$isAsciiAlphaNumeric(code);
}
var $6ca4e818ac206989$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($6ca4e818ac206989$var$EntityDecoderState || ($6ca4e818ac206989$var$EntityDecoderState = {}));
var $6ca4e818ac206989$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($6ca4e818ac206989$export$8c8f129ce60f53c || ($6ca4e818ac206989$export$8c8f129ce60f53c = {}));
class $6ca4e818ac206989$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $6ca4e818ac206989$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $6ca4e818ac206989$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $6ca4e818ac206989$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $6ca4e818ac206989$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $6ca4e818ac206989$var$CharCodes.NUM) {
                    this.state = $6ca4e818ac206989$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $6ca4e818ac206989$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $6ca4e818ac206989$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $6ca4e818ac206989$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $6ca4e818ac206989$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $6ca4e818ac206989$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $6ca4e818ac206989$var$TO_LOWER_BIT) === $6ca4e818ac206989$var$CharCodes.LOWER_X) {
            this.state = $6ca4e818ac206989$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $6ca4e818ac206989$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6ca4e818ac206989$var$isNumber(char) || $6ca4e818ac206989$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6ca4e818ac206989$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $6ca4e818ac206989$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $6ca4e818ac206989$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $fN5Fe.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $6ca4e818ac206989$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $6ca4e818ac206989$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $6ca4e818ac206989$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $6ca4e818ac206989$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $6ca4e818ac206989$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $6ca4e818ac206989$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $6ca4e818ac206989$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $6ca4e818ac206989$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $6ca4e818ac206989$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$6ca4e818ac206989$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $6ca4e818ac206989$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $6ca4e818ac206989$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $6ca4e818ac206989$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $6ca4e818ac206989$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $6ca4e818ac206989$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $6ca4e818ac206989$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $6ca4e818ac206989$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $6ca4e818ac206989$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $fN5Fe.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $6ca4e818ac206989$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $6ca4e818ac206989$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $6ca4e818ac206989$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $6ca4e818ac206989$var$htmlDecoder = $6ca4e818ac206989$var$getDecoder((0, $5Odbq.default));
const $6ca4e818ac206989$var$xmlDecoder = $6ca4e818ac206989$var$getDecoder((0, $fxy3I.default));
function $6ca4e818ac206989$export$f045cb747ce77a19(str, mode = $6ca4e818ac206989$export$8c8f129ce60f53c.Legacy) {
    return $6ca4e818ac206989$var$htmlDecoder(str, mode);
}
function $6ca4e818ac206989$export$49f5e8089adb006a(str) {
    return $6ca4e818ac206989$var$htmlDecoder(str, $6ca4e818ac206989$export$8c8f129ce60f53c.Attribute);
}
function $6ca4e818ac206989$export$da52f4371b3f37de(str) {
    return $6ca4e818ac206989$var$htmlDecoder(str, $6ca4e818ac206989$export$8c8f129ce60f53c.Strict);
}
function $6ca4e818ac206989$export$88e3b9643a8bd06e(str) {
    return $6ca4e818ac206989$var$xmlDecoder(str, $6ca4e818ac206989$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("5Odbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $43abd9319ca70d6c$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $43abd9319ca70d6c$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("fxy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5045b7e62664927$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $b5045b7e62664927$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("fN5Fe", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $b7efd35d5c69ac19$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $b7efd35d5c69ac19$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $b7efd35d5c69ac19$var$_a;
const $b7efd35d5c69ac19$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $b7efd35d5c69ac19$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($b7efd35d5c69ac19$var$_a = String.fromCodePoint) !== null && $b7efd35d5c69ac19$var$_a !== void 0 ? $b7efd35d5c69ac19$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $b7efd35d5c69ac19$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $b7efd35d5c69ac19$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $b7efd35d5c69ac19$export$2e2bcd8739ae039(codePoint) {
    return $b7efd35d5c69ac19$export$73bfc63873071f74($b7efd35d5c69ac19$export$b978ab756102108a(codePoint));
}

});


parcelRegister("hSfxK", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $d0338967d42f295f$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $d0338967d42f295f$export$e6e86c76506f1190);

var $eKL55 = parcelRequire("eKL55");

var $k5nvo = parcelRequire("k5nvo");
const $d0338967d42f295f$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $d0338967d42f295f$export$f9d6449b9af28dc1(data) {
    return $d0338967d42f295f$var$encodeHTMLTrieRe($d0338967d42f295f$var$htmlReplacer, data);
}
function $d0338967d42f295f$export$e6e86c76506f1190(data) {
    return $d0338967d42f295f$var$encodeHTMLTrieRe((0, $k5nvo.xmlReplacer), data);
}
function $d0338967d42f295f$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $eKL55.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $k5nvo.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("eKL55", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd9e1e54bf6640e$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $abd9e1e54bf6640e$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$abd9e1e54bf6640e$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $abd9e1e54bf6640e$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $abd9e1e54bf6640e$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $abd9e1e54bf6640e$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $abd9e1e54bf6640e$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("k5nvo", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $e9f681ef7a035311$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $e9f681ef7a035311$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $e9f681ef7a035311$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $e9f681ef7a035311$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $e9f681ef7a035311$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $e9f681ef7a035311$export$96e6fc3a139b2555);
const $e9f681ef7a035311$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $e9f681ef7a035311$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $e9f681ef7a035311$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $e9f681ef7a035311$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $e9f681ef7a035311$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $e9f681ef7a035311$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$e9f681ef7a035311$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $e9f681ef7a035311$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $e9f681ef7a035311$export$4e7f196112fea3c5 = $e9f681ef7a035311$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $e9f681ef7a035311$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $e9f681ef7a035311$export$9e081872deefdcb0 = $e9f681ef7a035311$var$getEscaper(/[&<>'"]/g, $e9f681ef7a035311$var$xmlCodeMap);
const $e9f681ef7a035311$export$30330f3d5eb70e11 = $e9f681ef7a035311$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $e9f681ef7a035311$export$96e6fc3a139b2555 = $e9f681ef7a035311$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("h1j8A", function(module, exports) {

$parcel$export(module.exports, "elementNames", () => $c6415ff239ea0ed7$export$82b917442d249e05);
$parcel$export(module.exports, "attributeNames", () => $c6415ff239ea0ed7$export$b4cfbfd90280b005);
const $c6415ff239ea0ed7$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $c6415ff239ea0ed7$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRegister("cWyns", function(module, exports) {
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $96c591732bbe9fd9$export$f8cf48ee793b41be(elem) {
    return (0, $3zekA.hasChildren)(elem) ? elem.children : [];
}
function $96c591732bbe9fd9$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $96c591732bbe9fd9$export$f312c3733b79ac0d(elem) {
    const parent = $96c591732bbe9fd9$export$58081aedf094d85b(elem);
    if (parent != null) return $96c591732bbe9fd9$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $96c591732bbe9fd9$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $96c591732bbe9fd9$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $96c591732bbe9fd9$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $96c591732bbe9fd9$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $3zekA.isTag)(next))({ next: next } = next);
    return next;
}
function $96c591732bbe9fd9$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $3zekA.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRegister("2VlnM", function(module, exports) {
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $22117dbf00ca9159$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $22117dbf00ca9159$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $22117dbf00ca9159$export$1b8e57c9ea42f1d2(parent, child) {
    $22117dbf00ca9159$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $22117dbf00ca9159$export$10d8903dec122b9d(elem, next) {
    $22117dbf00ca9159$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $22117dbf00ca9159$export$47b51e6d100007bc(parent, child) {
    $22117dbf00ca9159$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $22117dbf00ca9159$export$68159836694e22c1(elem, prev) {
    $22117dbf00ca9159$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("bPZtU", function(module, exports) {

$parcel$export(module.exports, "filter", () => $89e4260ec6b7089c$export$3dea766d36a8935f);
$parcel$export(module.exports, "findOne", () => $89e4260ec6b7089c$export$a541876d5d7daf90);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $89e4260ec6b7089c$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $89e4260ec6b7089c$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $89e4260ec6b7089c$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $3zekA.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $89e4260ec6b7089c$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $89e4260ec6b7089c$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(let i = 0; i < searchedNodes.length; i++){
        const node = searchedNodes[i];
        if ((0, $3zekA.isTag)(node) && test(node)) return node;
        if (recurse && (0, $3zekA.hasChildren)(node) && node.children.length > 0) {
            const found = $89e4260ec6b7089c$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $89e4260ec6b7089c$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $3zekA.isTag)(node) && test(node) || (0, $3zekA.hasChildren)(node) && $89e4260ec6b7089c$export$9d99dce58ac4a31b(test, node.children));
}
function $89e4260ec6b7089c$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if ((0, $3zekA.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $3zekA.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("dYR1U", function(module, exports) {

$parcel$export(module.exports, "getElementsByTagName", () => $a2da03981bf43417$export$af941c3c7c3b40f5);
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");

var $bPZtU = parcelRequire("bPZtU");
/**
 * A map of functions to check nodes against.
 */ const $a2da03981bf43417$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $3zekA.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $3zekA.isTag;
        return (elem)=>(0, $3zekA.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $3zekA.isText)(elem) && data(elem.data);
        return (elem)=>(0, $3zekA.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $a2da03981bf43417$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $3zekA.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $3zekA.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $a2da03981bf43417$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $a2da03981bf43417$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($a2da03981bf43417$var$Checks, key) ? $a2da03981bf43417$var$Checks[key](value) : $a2da03981bf43417$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($a2da03981bf43417$var$combineFuncs);
}
function $a2da03981bf43417$export$7b31db6b5a0b2f32(options, node) {
    const test = $a2da03981bf43417$var$compileTest(options);
    return test ? test(node) : true;
}
function $a2da03981bf43417$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $a2da03981bf43417$var$compileTest(options);
    return test ? (0, $bPZtU.filter)(test, nodes, recurse, limit) : [];
}
function $a2da03981bf43417$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $bPZtU.findOne)($a2da03981bf43417$var$getAttribCheck("id", id), nodes, recurse);
}
function $a2da03981bf43417$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $a2da03981bf43417$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $a2da03981bf43417$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $bPZtU.filter)($a2da03981bf43417$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("7ZYrI", function(module, exports) {
parcelRequire("7Z39T");
var $3zekA = parcelRequire("3zekA");
function $5d2d1e3b58306e70$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $5d2d1e3b58306e70$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($5d2d1e3b58306e70$export$406a59d989e8005a || ($5d2d1e3b58306e70$export$406a59d989e8005a = {}));
function $5d2d1e3b58306e70$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $3zekA.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $3zekA.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $5d2d1e3b58306e70$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING | $5d2d1e3b58306e70$export$406a59d989e8005a.CONTAINED_BY;
        return $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING | $5d2d1e3b58306e70$export$406a59d989e8005a.CONTAINS;
    return $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING;
}
function $5d2d1e3b58306e70$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $5d2d1e3b58306e70$export$17303b8fea718ecc(a, b);
        if (relative & $5d2d1e3b58306e70$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $5d2d1e3b58306e70$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("2FnQg", function(module, exports) {

$parcel$export(module.exports, "getFeed", () => $1f11e7a1ecde59b5$export$ad32138c9e09ad4);

var $86PNL = parcelRequire("86PNL");

var $dYR1U = parcelRequire("dYR1U");
function $1f11e7a1ecde59b5$export$ad32138c9e09ad4(doc) {
    const feedRoot = $1f11e7a1ecde59b5$var$getOneElement($1f11e7a1ecde59b5$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $1f11e7a1ecde59b5$var$getAtomFeed(feedRoot) : $1f11e7a1ecde59b5$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $1f11e7a1ecde59b5$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $dYR1U.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $1f11e7a1ecde59b5$var$getMediaElements(children)
            };
            $1f11e7a1ecde59b5$var$addConditionally(entry, "id", "id", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $1f11e7a1ecde59b5$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $1f11e7a1ecde59b5$var$fetch("summary", children) || $1f11e7a1ecde59b5$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $1f11e7a1ecde59b5$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $1f11e7a1ecde59b5$var$addConditionally(feed, "id", "id", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $1f11e7a1ecde59b5$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $1f11e7a1ecde59b5$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $1f11e7a1ecde59b5$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $1f11e7a1ecde59b5$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $1f11e7a1ecde59b5$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $dYR1U.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $1f11e7a1ecde59b5$var$getMediaElements(children)
            };
            $1f11e7a1ecde59b5$var$addConditionally(entry, "id", "guid", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "title", "title", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "link", "link", children);
            $1f11e7a1ecde59b5$var$addConditionally(entry, "description", "description", children);
            const pubDate = $1f11e7a1ecde59b5$var$fetch("pubDate", children) || $1f11e7a1ecde59b5$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $1f11e7a1ecde59b5$var$addConditionally(feed, "title", "title", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "link", "link", childs);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "description", "description", childs);
    const updated = $1f11e7a1ecde59b5$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $1f11e7a1ecde59b5$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $1f11e7a1ecde59b5$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $1f11e7a1ecde59b5$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $1f11e7a1ecde59b5$var$getMediaElements(where) {
    return (0, $dYR1U.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $1f11e7a1ecde59b5$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $1f11e7a1ecde59b5$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $1f11e7a1ecde59b5$var$getOneElement(tagName, node) {
    return (0, $dYR1U.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $1f11e7a1ecde59b5$var$fetch(tagName, where, recurse = false) {
    return (0, $86PNL.textContent)((0, $dYR1U.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $1f11e7a1ecde59b5$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $1f11e7a1ecde59b5$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $1f11e7a1ecde59b5$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRegister("gj93u", function(module, exports) {
'use strict';
module.exports = (string)=>{
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

});

parcelRegister("b6Dha", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $afd83d4e8b737667$export$53b83ca8eaab0383);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $afd83d4e8b737667$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $afd83d4e8b737667$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($afd83d4e8b737667$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($afd83d4e8b737667$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}

});

parcelRegister("bc5yV", function(module, exports) {
'use strict';
var $82652140c2d744c1$var$isMergeableObject = function isMergeableObject(value) {
    return $82652140c2d744c1$var$isNonNullObject(value) && !$82652140c2d744c1$var$isSpecial(value);
};
function $82652140c2d744c1$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $82652140c2d744c1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $82652140c2d744c1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $82652140c2d744c1$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $82652140c2d744c1$var$REACT_ELEMENT_TYPE = $82652140c2d744c1$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $82652140c2d744c1$var$isReactElement(value) {
    return value.$$typeof === $82652140c2d744c1$var$REACT_ELEMENT_TYPE;
}
function $82652140c2d744c1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $82652140c2d744c1$var$deepmerge($82652140c2d744c1$var$emptyTarget(value), value, options) : value;
}
function $82652140c2d744c1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $82652140c2d744c1$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $82652140c2d744c1$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $82652140c2d744c1$var$deepmerge;
}
function $82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $82652140c2d744c1$var$getKeys(target) {
    return Object.keys(target).concat($82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target));
}
function $82652140c2d744c1$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $82652140c2d744c1$var$propertyIsUnsafe(target, key) {
    return $82652140c2d744c1$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $82652140c2d744c1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $82652140c2d744c1$var$getKeys(target).forEach(function(key) {
        destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $82652140c2d744c1$var$getKeys(source).forEach(function(key) {
        if ($82652140c2d744c1$var$propertyIsUnsafe(target, key)) return;
        if ($82652140c2d744c1$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $82652140c2d744c1$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $82652140c2d744c1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $82652140c2d744c1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $82652140c2d744c1$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $82652140c2d744c1$var$mergeObject(target, source, options);
}
$82652140c2d744c1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $82652140c2d744c1$var$deepmerge(prev, next, options);
    }, {});
};
var $82652140c2d744c1$var$deepmerge_1 = $82652140c2d744c1$var$deepmerge;
module.exports = $82652140c2d744c1$var$deepmerge_1;

});

parcelRegister("83WDE", function(module, exports) {
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})(module.exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === "\u0020" || // space
            c === "\u0009" || // horizontal tab
            c === "\u000A" || // new line
            c === "\u000C" || // form feed
            c === "\u000D"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "\u0028") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});

});

parcelRegister("aw4IU", function(module, exports) {
'use strict';

var $7p0G1 = parcelRequire("7p0G1");

var $iBhJ0 = parcelRequire("iBhJ0");

var $khwgh = parcelRequire("khwgh");

var $lL4PP = parcelRequire("lL4PP");

var $g1eQr = parcelRequire("g1eQr");

var $fgZ4H = parcelRequire("fgZ4H");

var $lxhMw = parcelRequire("lxhMw");

var $4iXhf = parcelRequire("4iXhf");

var $bRV7L = parcelRequire("bRV7L");

var $1rVuN = parcelRequire("1rVuN");

var $5m4HE = parcelRequire("5m4HE");

var $h3g9A = parcelRequire("h3g9A");

var $5USc3 = parcelRequire("5USc3");

var $8qhiK = parcelRequire("8qhiK");

var $k7cLY = parcelRequire("k7cLY");

var $hzje4 = parcelRequire("hzje4");

var $cz61E = parcelRequire("cz61E");

var $7xCxF = parcelRequire("7xCxF");
function $7a808e805768f360$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $5USc3(plugins);
}
$7a808e805768f360$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $5USc3().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, 'postcss', {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $7a808e805768f360$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$7a808e805768f360$var$postcss.stringify = $cz61E;
$7a808e805768f360$var$postcss.parse = $h3g9A;
$7a808e805768f360$var$postcss.fromJSON = $lxhMw;
$7a808e805768f360$var$postcss.list = $1rVuN;
$7a808e805768f360$var$postcss.comment = (defaults)=>new $iBhJ0(defaults);
$7a808e805768f360$var$postcss.atRule = (defaults)=>new $7p0G1(defaults);
$7a808e805768f360$var$postcss.decl = (defaults)=>new $g1eQr(defaults);
$7a808e805768f360$var$postcss.rule = (defaults)=>new $hzje4(defaults);
$7a808e805768f360$var$postcss.root = (defaults)=>new $k7cLY(defaults);
$7a808e805768f360$var$postcss.document = (defaults)=>new $fgZ4H(defaults);
$7a808e805768f360$var$postcss.CssSyntaxError = $lL4PP;
$7a808e805768f360$var$postcss.Declaration = $g1eQr;
$7a808e805768f360$var$postcss.Container = $khwgh;
$7a808e805768f360$var$postcss.Processor = $5USc3;
$7a808e805768f360$var$postcss.Document = $fgZ4H;
$7a808e805768f360$var$postcss.Comment = $iBhJ0;
$7a808e805768f360$var$postcss.Warning = $7xCxF;
$7a808e805768f360$var$postcss.AtRule = $7p0G1;
$7a808e805768f360$var$postcss.Result = $8qhiK;
$7a808e805768f360$var$postcss.Input = $4iXhf;
$7a808e805768f360$var$postcss.Rule = $hzje4;
$7a808e805768f360$var$postcss.Root = $k7cLY;
$7a808e805768f360$var$postcss.Node = $5m4HE;
$bRV7L.registerPostcss($7a808e805768f360$var$postcss);
module.exports = $7a808e805768f360$var$postcss;
$7a808e805768f360$var$postcss.default = $7a808e805768f360$var$postcss;

});
parcelRegister("7p0G1", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");
class $563b64967a12cbc2$var$AtRule extends $khwgh {
    constructor(defaults){
        super(defaults);
        this.type = 'atrule';
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
module.exports = $563b64967a12cbc2$var$AtRule;
$563b64967a12cbc2$var$AtRule.default = $563b64967a12cbc2$var$AtRule;
$khwgh.registerAtRule($563b64967a12cbc2$var$AtRule);

});
parcelRegister("khwgh", function(module, exports) {
'use strict';

var $iBhJ0 = parcelRequire("iBhJ0");

var $g1eQr = parcelRequire("g1eQr");

var $5m4HE = parcelRequire("5m4HE");

var $a9m3g = parcelRequire("a9m3g");
var $ec3e6ba3c947f753$require$isClean = $a9m3g.isClean;
var $ec3e6ba3c947f753$require$my = $a9m3g.my;
let $ec3e6ba3c947f753$var$AtRule, $ec3e6ba3c947f753$var$parse, $ec3e6ba3c947f753$var$Root, $ec3e6ba3c947f753$var$Rule;
function $ec3e6ba3c947f753$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $ec3e6ba3c947f753$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $ec3e6ba3c947f753$var$markTreeDirty(node) {
    node[$ec3e6ba3c947f753$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$ec3e6ba3c947f753$var$markTreeDirty(i);
}
class $ec3e6ba3c947f753$var$Container extends $5m4HE {
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (!node[prop]) return node[prop];
                else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === 'function') return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === 'every' || prop === 'some') return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === 'root') return ()=>node.root().toProxy();
                else if (prop === 'nodes') return node.nodes.map((i)=>i.toProxy());
                else if (prop === 'first' || prop === 'last') return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'name' || prop === 'params' || prop === 'selector') node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === 'number') return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? 'prepend' : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === 'string') nodes = $ec3e6ba3c947f753$var$cleanSource($ec3e6ba3c947f753$var$parse(nodes).nodes);
        else if (typeof nodes === 'undefined') nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type === 'root' && this.type !== 'document') {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === 'undefined') throw new Error('Value field is missed in node creation');
            else if (typeof nodes.value !== 'string') nodes.value = String(nodes.value);
            nodes = [
                new $g1eQr(nodes)
            ];
        } else if (nodes.selector || nodes.selectors) nodes = [
            new $ec3e6ba3c947f753$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $ec3e6ba3c947f753$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $iBhJ0(nodes)
        ];
        else throw new Error('Unknown node type in node creation');
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$ec3e6ba3c947f753$require$my]) $ec3e6ba3c947f753$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$ec3e6ba3c947f753$require$isClean]) $ec3e6ba3c947f753$var$markTreeDirty(i);
            if (!i.raws) i.raws = {};
            if (typeof i.raws.before === 'undefined') {
                if (sample && typeof sample.raws.before !== 'undefined') i.raws.before = sample.raws.before.replace(/\S/g, '');
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, 'prepend').reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === 'atrule') return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'atrule' && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'atrule' && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === 'comment') return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === 'decl') return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'decl' && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'decl' && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === 'rule') return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'rule' && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'rule' && child.selector === selector) return callback(child, i);
        });
    }
}
$ec3e6ba3c947f753$var$Container.registerParse = (dependant)=>{
    $ec3e6ba3c947f753$var$parse = dependant;
};
$ec3e6ba3c947f753$var$Container.registerRule = (dependant)=>{
    $ec3e6ba3c947f753$var$Rule = dependant;
};
$ec3e6ba3c947f753$var$Container.registerAtRule = (dependant)=>{
    $ec3e6ba3c947f753$var$AtRule = dependant;
};
$ec3e6ba3c947f753$var$Container.registerRoot = (dependant)=>{
    $ec3e6ba3c947f753$var$Root = dependant;
};
module.exports = $ec3e6ba3c947f753$var$Container;
$ec3e6ba3c947f753$var$Container.default = $ec3e6ba3c947f753$var$Container;
/* c8 ignore start */ $ec3e6ba3c947f753$var$Container.rebuild = (node)=>{
    if (node.type === 'atrule') Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$AtRule.prototype);
    else if (node.type === 'rule') Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$Rule.prototype);
    else if (node.type === 'decl') Object.setPrototypeOf(node, $g1eQr.prototype);
    else if (node.type === 'comment') Object.setPrototypeOf(node, $iBhJ0.prototype);
    else if (node.type === 'root') Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$Root.prototype);
    node[$ec3e6ba3c947f753$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $ec3e6ba3c947f753$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;

});
parcelRegister("iBhJ0", function(module, exports) {
'use strict';

var $5m4HE = parcelRequire("5m4HE");
class $d8a96e81fb4e1683$var$Comment extends $5m4HE {
    constructor(defaults){
        super(defaults);
        this.type = 'comment';
    }
}
module.exports = $d8a96e81fb4e1683$var$Comment;
$d8a96e81fb4e1683$var$Comment.default = $d8a96e81fb4e1683$var$Comment;

});
parcelRegister("5m4HE", function(module, exports) {
'use strict';

var $lL4PP = parcelRequire("lL4PP");

var $g7Euv = parcelRequire("g7Euv");

var $cz61E = parcelRequire("cz61E");

var $a9m3g = parcelRequire("a9m3g");
var $3e62a7c46a076c9d$require$isClean = $a9m3g.isClean;
var $3e62a7c46a076c9d$require$my = $a9m3g.my;
function $3e62a7c46a076c9d$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === 'proxyCache') continue;
        let value = obj[i];
        let type = typeof value;
        if (i === 'parent' && type === 'object') {
            if (parent) cloned[i] = parent;
        } else if (i === 'source') cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$3e62a7c46a076c9d$var$cloneNode(j, cloned));
        else {
            if (type === 'object' && value !== null) value = $3e62a7c46a076c9d$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
function $3e62a7c46a076c9d$var$sourceOffset(inputCSS, position) {
    // Not all custom syntaxes support `offset` in `source.start` and `source.end`
    if (position && typeof position.offset !== 'undefined') return position.offset;
    let column = 1;
    let line = 1;
    let offset = 0;
    for(let i = 0; i < inputCSS.length; i++){
        if (line === position.line && column === position.column) {
            offset = i;
            break;
        }
        if (inputCSS[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
    }
    return offset;
}
class $3e62a7c46a076c9d$var$Node {
    get proxyOf() {
        return this;
    }
    constructor(defaults = {}){
        this.raws = {};
        this[$3e62a7c46a076c9d$require$isClean] = false;
        this[$3e62a7c46a076c9d$require$my] = true;
        for(let name in defaults)if (name === 'nodes') {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === 'function') this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $3e62a7c46a076c9d$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $lL4PP(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (prop === 'root') return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' || /* c8 ignore next */ prop === 'text') node.markDirty();
                return true;
            }
        };
    }
    /* c8 ignore next 3 */ markClean() {
        this[$3e62a7c46a076c9d$require$isClean] = true;
    }
    markDirty() {
        if (this[$3e62a7c46a076c9d$require$isClean]) {
            this[$3e62a7c46a076c9d$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$3e62a7c46a076c9d$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index);
        else if (opts.word) {
            let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
            let stringRepresentation = inputString.slice($3e62a7c46a076c9d$var$sourceOffset(inputString, this.source.start), $3e62a7c46a076c9d$var$sourceOffset(inputString, this.source.end));
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index);
        }
        return pos;
    }
    positionInside(index) {
        let column = this.source.start.column;
        let line = this.source.start.line;
        let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        let offset = $3e62a7c46a076c9d$var$sourceOffset(inputString, this.source.start);
        let end = offset + index;
        for(let i = offset; i < end; i++)if (inputString[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
            let stringRepresentation = inputString.slice($3e62a7c46a076c9d$var$sourceOffset(inputString, this.source.start), $3e62a7c46a076c9d$var$sourceOffset(inputString, this.source.end));
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index);
                end = this.positionInside(index + opts.word.length);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === 'number') end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $g7Euv();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== 'document')result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === 'parent' || name === 'proxyCache') continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === 'object' && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === 'object' && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === 'source') {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $cz61E) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = '';
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
}
module.exports = $3e62a7c46a076c9d$var$Node;
$3e62a7c46a076c9d$var$Node.default = $3e62a7c46a076c9d$var$Node;

});
parcelRegister("lL4PP", function(module, exports) {
'use strict';

var $lrcwG = parcelRequire("lrcwG");

var $kjyEk = parcelRequire("kjyEk");
class $fd71bcdaa1a35b05$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = 'CssSyntaxError';
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
            if (typeof line === 'number') {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $fd71bcdaa1a35b05$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ': ' : '';
        this.message += this.file ? this.file : '<css input>';
        if (typeof this.line !== 'undefined') this.message += ':' + this.line + ':' + this.column;
        this.message += ': ' + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return '';
        let css = this.source;
        if (color == null) color = $lrcwG.isColorSupported;
        let aside = (text)=>text;
        let mark = (text)=>text;
        let highlight = (text)=>text;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $lrcwG.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
            if ($kjyEk) highlight = (text)=>$kjyEk(text);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
            if (number === this.line) {
                if (line.length > 160) {
                    let padding = 20;
                    let subLineStart = Math.max(0, this.column - padding);
                    let subLineEnd = Math.max(this.column + padding, this.endColumn + padding);
                    let subLine = line.slice(subLineStart, subLineEnd);
                    let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, Math.min(this.column - 1, padding - 1)).replace(/[^\t]/g, ' ');
                    return mark('>') + aside(gutter) + highlight(subLine) + '\n ' + spacing + mark('^');
                }
                let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
                return mark('>') + aside(gutter) + highlight(line) + '\n ' + spacing + mark('^');
            }
            return ' ' + aside(gutter) + highlight(line);
        }).join('\n');
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = '\n\n' + code + '\n';
        return this.name + ': ' + this.message + code;
    }
}
module.exports = $fd71bcdaa1a35b05$var$CssSyntaxError;
$fd71bcdaa1a35b05$var$CssSyntaxError.default = $fd71bcdaa1a35b05$var$CssSyntaxError;

});
parcelRegister("lrcwG", function(module, exports) {
var $f9b5d605f52d8009$var$x = String;
var $f9b5d605f52d8009$var$create = function() {
    return {
        isColorSupported: false,
        reset: $f9b5d605f52d8009$var$x,
        bold: $f9b5d605f52d8009$var$x,
        dim: $f9b5d605f52d8009$var$x,
        italic: $f9b5d605f52d8009$var$x,
        underline: $f9b5d605f52d8009$var$x,
        inverse: $f9b5d605f52d8009$var$x,
        hidden: $f9b5d605f52d8009$var$x,
        strikethrough: $f9b5d605f52d8009$var$x,
        black: $f9b5d605f52d8009$var$x,
        red: $f9b5d605f52d8009$var$x,
        green: $f9b5d605f52d8009$var$x,
        yellow: $f9b5d605f52d8009$var$x,
        blue: $f9b5d605f52d8009$var$x,
        magenta: $f9b5d605f52d8009$var$x,
        cyan: $f9b5d605f52d8009$var$x,
        white: $f9b5d605f52d8009$var$x,
        gray: $f9b5d605f52d8009$var$x,
        bgBlack: $f9b5d605f52d8009$var$x,
        bgRed: $f9b5d605f52d8009$var$x,
        bgGreen: $f9b5d605f52d8009$var$x,
        bgYellow: $f9b5d605f52d8009$var$x,
        bgBlue: $f9b5d605f52d8009$var$x,
        bgMagenta: $f9b5d605f52d8009$var$x,
        bgCyan: $f9b5d605f52d8009$var$x,
        bgWhite: $f9b5d605f52d8009$var$x,
        blackBright: $f9b5d605f52d8009$var$x,
        redBright: $f9b5d605f52d8009$var$x,
        greenBright: $f9b5d605f52d8009$var$x,
        yellowBright: $f9b5d605f52d8009$var$x,
        blueBright: $f9b5d605f52d8009$var$x,
        magentaBright: $f9b5d605f52d8009$var$x,
        cyanBright: $f9b5d605f52d8009$var$x,
        whiteBright: $f9b5d605f52d8009$var$x,
        bgBlackBright: $f9b5d605f52d8009$var$x,
        bgRedBright: $f9b5d605f52d8009$var$x,
        bgGreenBright: $f9b5d605f52d8009$var$x,
        bgYellowBright: $f9b5d605f52d8009$var$x,
        bgBlueBright: $f9b5d605f52d8009$var$x,
        bgMagentaBright: $f9b5d605f52d8009$var$x,
        bgCyanBright: $f9b5d605f52d8009$var$x,
        bgWhiteBright: $f9b5d605f52d8009$var$x
    };
};
module.exports = $f9b5d605f52d8009$var$create();
module.exports.createColors = $f9b5d605f52d8009$var$create;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("g7Euv", function(module, exports) {
'use strict';
const $bbccb5753b9764cb$var$DEFAULT_RAW = {
    after: '\n',
    beforeClose: '\n',
    beforeComment: '\n',
    beforeDecl: '\n',
    beforeOpen: ' ',
    beforeRule: '\n',
    colon: ': ',
    commentLeft: ' ',
    commentRight: ' ',
    emptyBody: '',
    indent: '    ',
    semicolon: false
};
function $bbccb5753b9764cb$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $bbccb5753b9764cb$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let name = '@' + node.name;
        let params = node.params ? this.rawValue(node, 'params') : '';
        if (typeof node.raws.afterName !== 'undefined') name += node.raws.afterName;
        else if (params) name += ' ';
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || '') + (semicolon ? ';' : '');
            this.builder(name + params + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === 'decl') value = this.raw(node, null, 'beforeDecl');
        else if (node.type === 'comment') value = this.raw(node, null, 'beforeComment');
        else if (detect === 'before') value = this.raw(node, null, 'beforeRule');
        else value = this.raw(node, null, 'beforeClose');
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== 'root'){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes('\n')) {
            let indent = this.raw(node, null, 'indent');
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, 'between', 'beforeOpen');
        this.builder(start + between + '{', node, 'start');
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, 'after');
        } else after = this.raw(node, 'after', 'emptyBody');
        if (after) this.builder(after);
        this.builder('}', node, 'end');
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== 'comment') break;
            last -= 1;
        }
        let semicolon = this.raw(node, 'semicolon');
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, 'before');
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, 'left', 'commentLeft');
        let right = this.raw(node, 'right', 'commentRight');
        this.builder('/*' + left + node.text + right + '*/', node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, 'between', 'colon');
        let string = node.prop + between + this.rawValue(node, 'value');
        if (node.important) string += node.raws.important || ' !important';
        if (semicolon) string += ';';
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== 'undefined') return value;
        }
        let parent = node.parent;
        if (detect === 'before') {
            // Hack for first rule in CSS
            if (!parent || parent.type === 'root' && parent.first === node) return '';
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === 'document') return '';
        }
        // Floating child without parent
        if (!parent) return $bbccb5753b9764cb$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== 'undefined') return root.rawCache[detect];
        if (detect === 'before' || detect === 'after') return this.beforeAfter(node, detect);
        else {
            let method = 'raw' + $bbccb5753b9764cb$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== 'undefined') return false;
            });
        }
        if (typeof value === 'undefined') value = $bbccb5753b9764cb$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== 'undefined') {
                    value = i.raws.after;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeDecl');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeRule');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== 'decl') {
                value = i.raws.between;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== 'undefined') {
                    value = i.raws.before;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== 'undefined') {
                value = i.raws.between.replace(/[^\s:]/g, '');
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== 'undefined') {
                    let parts = i.raws.before.split('\n');
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, '');
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === 'decl') {
                value = i.raws.semicolon;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, 'selector'));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, 'end');
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
module.exports = $bbccb5753b9764cb$var$Stringifier;
$bbccb5753b9764cb$var$Stringifier.default = $bbccb5753b9764cb$var$Stringifier;

});

parcelRegister("cz61E", function(module, exports) {
'use strict';

var $g7Euv = parcelRequire("g7Euv");
function $925d6d7facb3cb65$var$stringify(node, builder) {
    let str = new $g7Euv(builder);
    str.stringify(node);
}
module.exports = $925d6d7facb3cb65$var$stringify;
$925d6d7facb3cb65$var$stringify.default = $925d6d7facb3cb65$var$stringify;

});

parcelRegister("a9m3g", function(module, exports) {

$parcel$export(module.exports, "isClean", () => $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9, (v) => $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9 = v);
$parcel$export(module.exports, "my", () => $763bd9a0a4fb5ee7$export$94fa0a6beb22f989, (v) => $763bd9a0a4fb5ee7$export$94fa0a6beb22f989 = v);
var $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9;
var $763bd9a0a4fb5ee7$export$94fa0a6beb22f989;
'use strict';
$763bd9a0a4fb5ee7$export$ae5e7911ce0728f9 = Symbol('isClean');
$763bd9a0a4fb5ee7$export$94fa0a6beb22f989 = Symbol('my');

});



parcelRegister("g1eQr", function(module, exports) {
'use strict';

var $5m4HE = parcelRequire("5m4HE");
class $ba9841313f34e122$var$Declaration extends $5m4HE {
    get variable() {
        return this.prop.startsWith('--') || this.prop[0] === '$';
    }
    constructor(defaults){
        if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = 'decl';
    }
}
module.exports = $ba9841313f34e122$var$Declaration;
$ba9841313f34e122$var$Declaration.default = $ba9841313f34e122$var$Declaration;

});



parcelRegister("fgZ4H", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");
let $b1e7b9ccdcfdc3cc$var$LazyResult, $b1e7b9ccdcfdc3cc$var$Processor;
class $b1e7b9ccdcfdc3cc$var$Document extends $khwgh {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: 'document',
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $b1e7b9ccdcfdc3cc$var$LazyResult(new $b1e7b9ccdcfdc3cc$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$b1e7b9ccdcfdc3cc$var$Document.registerLazyResult = (dependant)=>{
    $b1e7b9ccdcfdc3cc$var$LazyResult = dependant;
};
$b1e7b9ccdcfdc3cc$var$Document.registerProcessor = (dependant)=>{
    $b1e7b9ccdcfdc3cc$var$Processor = dependant;
};
module.exports = $b1e7b9ccdcfdc3cc$var$Document;
$b1e7b9ccdcfdc3cc$var$Document.default = $b1e7b9ccdcfdc3cc$var$Document;

});

parcelRegister("lxhMw", function(module, exports) {
'use strict';

var $7p0G1 = parcelRequire("7p0G1");

var $iBhJ0 = parcelRequire("iBhJ0");

var $g1eQr = parcelRequire("g1eQr");

var $4iXhf = parcelRequire("4iXhf");

var $h9p4c = parcelRequire("h9p4c");

var $k7cLY = parcelRequire("k7cLY");

var $hzje4 = parcelRequire("hzje4");
function $fada791b0db7ac9e$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$fada791b0db7ac9e$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $4iXhf.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $h9p4c.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$fada791b0db7ac9e$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === 'root') return new $k7cLY(defaults);
    else if (defaults.type === 'decl') return new $g1eQr(defaults);
    else if (defaults.type === 'rule') return new $hzje4(defaults);
    else if (defaults.type === 'comment') return new $iBhJ0(defaults);
    else if (defaults.type === 'atrule') return new $7p0G1(defaults);
    else throw new Error('Unknown node type: ' + json.type);
}
module.exports = $fada791b0db7ac9e$var$fromJSON;
$fada791b0db7ac9e$var$fromJSON.default = $fada791b0db7ac9e$var$fromJSON;

});
parcelRegister("4iXhf", function(module, exports) {
'use strict';

var $4Kuwt = parcelRequire("4Kuwt");
var $3226d30fa7b80476$require$nanoid = $4Kuwt.nanoid;

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$isAbsolute = $kjyEk.isAbsolute;
var $3226d30fa7b80476$require$resolve = $kjyEk.resolve;

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $3226d30fa7b80476$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$fileURLToPath = $kjyEk.fileURLToPath;
var $3226d30fa7b80476$require$pathToFileURL = $kjyEk.pathToFileURL;

var $lL4PP = parcelRequire("lL4PP");

var $h9p4c = parcelRequire("h9p4c");

var $kjyEk = parcelRequire("kjyEk");
let $3226d30fa7b80476$var$fromOffsetCache = Symbol('fromOffsetCache');
let $3226d30fa7b80476$var$sourceMapAvailable = Boolean($3226d30fa7b80476$require$SourceMapConsumer && $3226d30fa7b80476$require$SourceMapGenerator);
let $3226d30fa7b80476$var$pathAvailable = Boolean($3226d30fa7b80476$require$resolve && $3226d30fa7b80476$require$isAbsolute);
class $3226d30fa7b80476$var$Input {
    get from() {
        return this.file || this.id;
    }
    constructor(css, opts = {}){
        if (css === null || typeof css === 'undefined' || typeof css === 'object' && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        this.document = this.css;
        if (opts.document) this.document = opts.document.toString();
        if (opts.from) {
            if (!$3226d30fa7b80476$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $3226d30fa7b80476$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $3226d30fa7b80476$require$resolve(opts.from);
        }
        if ($3226d30fa7b80476$var$pathAvailable && $3226d30fa7b80476$var$sourceMapAvailable) {
            let map = new $h9p4c(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = '<input css ' + $3226d30fa7b80476$require$nanoid(6) + '>';
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let endColumn, endLine, result;
        if (line && typeof line === 'object') {
            let start = line;
            let end = column;
            if (typeof start.offset === 'number') {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === 'number') {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $lL4PP(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $lL4PP(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($3226d30fa7b80476$require$pathToFileURL) result.input.url = $3226d30fa7b80476$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$3226d30fa7b80476$var$fromOffsetCache]) {
            let lines = this.css.split('\n');
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$3226d30fa7b80476$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$3226d30fa7b80476$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $3226d30fa7b80476$require$resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === 'number') to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($3226d30fa7b80476$require$isAbsolute(from.source)) fromUrl = $3226d30fa7b80476$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $3226d30fa7b80476$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === 'file:') {
            if ($3226d30fa7b80476$require$fileURLToPath) result.file = $3226d30fa7b80476$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            'hasBOM',
            'css',
            'file',
            'id'
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
}
module.exports = $3226d30fa7b80476$var$Input;
$3226d30fa7b80476$var$Input.default = $3226d30fa7b80476$var$Input;
if ($kjyEk && $kjyEk.registerInput) $kjyEk.registerInput($3226d30fa7b80476$var$Input);

});
parcelRegister("4Kuwt", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $3753227fdc8a3f3b$export$ac4959f4f1338dfc);
let $3753227fdc8a3f3b$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $3753227fdc8a3f3b$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3753227fdc8a3f3b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $3753227fdc8a3f3b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRegister("h9p4c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c7c6b8ac5988220d$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$existsSync = $kjyEk.existsSync;
var $c7c6b8ac5988220d$require$readFileSync = $kjyEk.readFileSync;

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$dirname = $kjyEk.dirname;
var $c7c6b8ac5988220d$require$join = $kjyEk.join;

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $c7c6b8ac5988220d$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;
function $c7c6b8ac5988220d$var$fromBase64(str) {
    if ($c7c6b8ac5988220d$require$Buffer) return $c7c6b8ac5988220d$require$Buffer.from(str, 'base64').toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $c7c6b8ac5988220d$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, 'data:');
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $c7c6b8ac5988220d$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $c7c6b8ac5988220d$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        let uriMatch = text.match(charsetUri) || text.match(uri);
        if (uriMatch) return decodeURIComponent(text.substr(uriMatch[0].length));
        let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
        if (baseUriMatch) return $c7c6b8ac5988220d$var$fromBase64(text.substr(baseUriMatch[0].length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error('Unsupported source map encoding ' + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
    }
    isMap(map) {
        if (typeof map !== 'object') return false;
        return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/g);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf('*/', start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $c7c6b8ac5988220d$require$dirname(path);
        if ($c7c6b8ac5988220d$require$existsSync(path)) {
            this.mapFile = path;
            return $c7c6b8ac5988220d$require$readFileSync(path, 'utf-8').toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === 'string') return prev;
            else if (typeof prev === 'function') {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error('Unable to load previous source map: ' + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $c7c6b8ac5988220d$require$SourceMapConsumer) return $c7c6b8ac5988220d$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $c7c6b8ac5988220d$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error('Unsupported previous source map format: ' + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $c7c6b8ac5988220d$require$join($c7c6b8ac5988220d$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
module.exports = $c7c6b8ac5988220d$var$PreviousMap;
$c7c6b8ac5988220d$var$PreviousMap.default = $c7c6b8ac5988220d$var$PreviousMap;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("k7cLY", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");
let $ea4e5e8196cbb851$var$LazyResult, $ea4e5e8196cbb851$var$Processor;
class $ea4e5e8196cbb851$var$Root extends $khwgh {
    constructor(defaults){
        super(defaults);
        this.type = 'root';
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === 'prepend') {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $ea4e5e8196cbb851$var$LazyResult(new $ea4e5e8196cbb851$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$ea4e5e8196cbb851$var$Root.registerLazyResult = (dependant)=>{
    $ea4e5e8196cbb851$var$LazyResult = dependant;
};
$ea4e5e8196cbb851$var$Root.registerProcessor = (dependant)=>{
    $ea4e5e8196cbb851$var$Processor = dependant;
};
module.exports = $ea4e5e8196cbb851$var$Root;
$ea4e5e8196cbb851$var$Root.default = $ea4e5e8196cbb851$var$Root;
$khwgh.registerRoot($ea4e5e8196cbb851$var$Root);

});

parcelRegister("hzje4", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");

var $1rVuN = parcelRequire("1rVuN");
class $cca49e6d08250472$var$Rule extends $khwgh {
    get selectors() {
        return $1rVuN.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
        this.selector = values.join(sep);
    }
    constructor(defaults){
        super(defaults);
        this.type = 'rule';
        if (!this.nodes) this.nodes = [];
    }
}
module.exports = $cca49e6d08250472$var$Rule;
$cca49e6d08250472$var$Rule.default = $cca49e6d08250472$var$Rule;
$khwgh.registerRule($cca49e6d08250472$var$Rule);

});
parcelRegister("1rVuN", function(module, exports) {
'use strict';
let $10e4e97fa3c9470d$var$list = {
    comma (string) {
        return $10e4e97fa3c9470d$var$list.split(string, [
            ','
        ], true);
    },
    space (string) {
        let spaces = [
            ' ',
            '\n',
            '\t'
        ];
        return $10e4e97fa3c9470d$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = '';
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = '';
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === '\\') escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === '(') func += 1;
            else if (letter === ')') {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== '') array.push(current.trim());
                current = '';
                split = false;
            } else current += letter;
        }
        if (last || current !== '') array.push(current.trim());
        return array;
    }
};
module.exports = $10e4e97fa3c9470d$var$list;
$10e4e97fa3c9470d$var$list.default = $10e4e97fa3c9470d$var$list;

});



parcelRegister("bRV7L", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");

var $fgZ4H = parcelRequire("fgZ4H");

var $98nYS = parcelRequire("98nYS");

var $h3g9A = parcelRequire("h3g9A");

var $8qhiK = parcelRequire("8qhiK");

var $k7cLY = parcelRequire("k7cLY");

var $cz61E = parcelRequire("cz61E");

var $a9m3g = parcelRequire("a9m3g");
var $8a40f4a2119ab8f2$require$isClean = $a9m3g.isClean;
var $8a40f4a2119ab8f2$require$my = $a9m3g.my;
parcelRequire("jYV5o");
const $8a40f4a2119ab8f2$var$TYPE_TO_CLASS_NAME = {
    atrule: 'AtRule',
    comment: 'Comment',
    decl: 'Declaration',
    document: 'Document',
    root: 'Root',
    rule: 'Rule'
};
const $8a40f4a2119ab8f2$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $8a40f4a2119ab8f2$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $8a40f4a2119ab8f2$var$CHILDREN = 0;
function $8a40f4a2119ab8f2$var$isPromise(obj) {
    return typeof obj === 'object' && typeof obj.then === 'function';
}
function $8a40f4a2119ab8f2$var$getEvents(node) {
    let key = false;
    let type = $8a40f4a2119ab8f2$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === 'decl') key = node.prop.toLowerCase();
    else if (node.type === 'atrule') key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + '-' + key,
        $8a40f4a2119ab8f2$var$CHILDREN,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (key) return [
        type,
        type + '-' + key,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (node.append) return [
        type,
        $8a40f4a2119ab8f2$var$CHILDREN,
        type + 'Exit'
    ];
    else return [
        type,
        type + 'Exit'
    ];
}
function $8a40f4a2119ab8f2$var$toStack(node) {
    let events;
    if (node.type === 'document') events = [
        'Document',
        $8a40f4a2119ab8f2$var$CHILDREN,
        'DocumentExit'
    ];
    else if (node.type === 'root') events = [
        'Root',
        $8a40f4a2119ab8f2$var$CHILDREN,
        'RootExit'
    ];
    else events = $8a40f4a2119ab8f2$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $8a40f4a2119ab8f2$var$cleanMarks(node) {
    node[$8a40f4a2119ab8f2$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$8a40f4a2119ab8f2$var$cleanMarks(i));
    return node;
}
let $8a40f4a2119ab8f2$var$postcss = {};
class $8a40f4a2119ab8f2$var$LazyResult {
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return 'LazyResult';
    }
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) root = $8a40f4a2119ab8f2$var$cleanMarks(css);
        else if (css instanceof $8a40f4a2119ab8f2$var$LazyResult || css instanceof $8qhiK) {
            root = $8a40f4a2119ab8f2$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === 'undefined') opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $h3g9A;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$8a40f4a2119ab8f2$require$my]) /* c8 ignore next 2 */ $khwgh.rebuild(root);
        }
        this.result = new $8qhiK(processor, root, opts);
        this.helpers = {
            ...$8a40f4a2119ab8f2$var$postcss,
            postcss: $8a40f4a2119ab8f2$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === 'object' && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error('Use process(css).then(cb) to work with async plugins');
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === 'CssSyntaxError' && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === 'object') for(let event in plugin){
                if (!$8a40f4a2119ab8f2$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$8a40f4a2119ab8f2$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === 'object') {
                        for(let filter in plugin[event])if (filter === '*') add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === 'function') add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$8a40f4a2119ab8f2$require$isClean]){
                root[$8a40f4a2119ab8f2$require$isClean] = true;
                let stack = [
                    $8a40f4a2119ab8f2$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($8a40f4a2119ab8f2$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === 'document') {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === 'object' && plugin.Once) {
                if (this.result.root.type === 'document') {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($8a40f4a2119ab8f2$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === 'function') return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $cz61E;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $98nYS(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$8a40f4a2119ab8f2$require$isClean]){
                root[$8a40f4a2119ab8f2$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === 'document') for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== 'root' && node.type !== 'document' && !node.parent) return true;
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$8a40f4a2119ab8f2$require$isClean]) {
                    child[$8a40f4a2119ab8f2$require$isClean] = true;
                    stack.push($8a40f4a2119ab8f2$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $8a40f4a2119ab8f2$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$8a40f4a2119ab8f2$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        node[$8a40f4a2119ab8f2$require$isClean] = true;
        let events = $8a40f4a2119ab8f2$var$getEvents(node);
        for (let event of events){
            if (event === $8a40f4a2119ab8f2$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$8a40f4a2119ab8f2$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
}
$8a40f4a2119ab8f2$var$LazyResult.registerPostcss = (dependant)=>{
    $8a40f4a2119ab8f2$var$postcss = dependant;
};
module.exports = $8a40f4a2119ab8f2$var$LazyResult;
$8a40f4a2119ab8f2$var$LazyResult.default = $8a40f4a2119ab8f2$var$LazyResult;
$k7cLY.registerLazyResult($8a40f4a2119ab8f2$var$LazyResult);
$fgZ4H.registerLazyResult($8a40f4a2119ab8f2$var$LazyResult);

});
parcelRegister("98nYS", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6a67768850890379$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$dirname = $kjyEk.dirname;
var $6a67768850890379$require$relative = $kjyEk.relative;
var $6a67768850890379$require$resolve = $kjyEk.resolve;
var $6a67768850890379$require$sep = $kjyEk.sep;

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $6a67768850890379$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$pathToFileURL = $kjyEk.pathToFileURL;

var $4iXhf = parcelRequire("4iXhf");
let $6a67768850890379$var$sourceMapAvailable = Boolean($6a67768850890379$require$SourceMapConsumer && $6a67768850890379$require$SourceMapGenerator);
let $6a67768850890379$var$pathAvailable = Boolean($6a67768850890379$require$dirname && $6a67768850890379$require$resolve && $6a67768850890379$require$relative && $6a67768850890379$require$sep);
class $6a67768850890379$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === 'string') content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === 'function') content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + '.map';
        let eol = '\n';
        if (this.css.includes('\r\n')) eol = '\r\n';
        this.css += eol + '/*# sourceMappingURL=' + content + ' */';
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $6a67768850890379$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6a67768850890379$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== 'comment') continue;
                if (node.text.startsWith('# sourceMappingURL=')) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, '');
    }
    generate() {
        this.clearAnnotation();
        if ($6a67768850890379$var$pathAvailable && $6a67768850890379$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = '';
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6a67768850890379$require$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $6a67768850890379$require$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = '';
        this.map = new $6a67768850890379$require$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = '<no source>';
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ''
        };
        let last, lines;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== 'end') {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf('\n');
                column = str.length - last;
            } else column += str.length;
            if (node && type !== 'start') {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== 'undefined') return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== 'undefined') return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== 'undefined' && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== 'undefined') return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== 'undefined') return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return 'to.css';
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $6a67768850890379$require$dirname(this.opts.to) : '.';
        if (typeof this.mapOpts.annotation === 'string') from = $6a67768850890379$require$dirname($6a67768850890379$require$resolve(from, this.mapOpts.annotation));
        let path = $6a67768850890379$require$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $4iXhf(this.originalCSS, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($6a67768850890379$require$Buffer) return $6a67768850890379$require$Buffer.from(str).toString('base64');
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($6a67768850890379$require$pathToFileURL) {
            let fileURL = $6a67768850890379$require$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error('`map.absolute` option is not available in this PostCSS build');
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($6a67768850890379$require$sep === '\\') path = path.replace(/\\/g, '/');
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
}
module.exports = $6a67768850890379$var$MapGenerator;

});

parcelRegister("h3g9A", function(module, exports) {
'use strict';

var $khwgh = parcelRequire("khwgh");

var $4iXhf = parcelRequire("4iXhf");

var $is2Ec = parcelRequire("is2Ec");
function $c69f3f459d97c2a6$var$parse(css, opts) {
    let input = new $4iXhf(css, opts);
    let parser = new $is2Ec(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
module.exports = $c69f3f459d97c2a6$var$parse;
$c69f3f459d97c2a6$var$parse.default = $c69f3f459d97c2a6$var$parse;
$khwgh.registerParse($c69f3f459d97c2a6$var$parse);

});
parcelRegister("is2Ec", function(module, exports) {
'use strict';

var $7p0G1 = parcelRequire("7p0G1");

var $iBhJ0 = parcelRequire("iBhJ0");

var $g1eQr = parcelRequire("g1eQr");

var $k7cLY = parcelRequire("k7cLY");

var $hzje4 = parcelRequire("hzje4");

var $4zYLI = parcelRequire("4zYLI");
const $d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $d6ece5395d662d1b$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $d6ece5395d662d1b$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $k7cLY();
        this.current = this.root;
        this.spaces = '';
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $7p0G1();
        node.name = token[1].slice(1);
        if (node.name === '') this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === '(' || type === '[') brackets.push(type === '(' ? ')' : ']');
            else if (type === '{' && brackets.length > 0) brackets.push('}');
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ';') {
                    node.source.end = this.getPosition(token[2]);
                    node.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === '{') {
                    open = true;
                    break;
                } else if (type === '}') {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === 'space')prev = params[--shift];
                        if (prev) {
                            node.source.end = this.getPosition(prev[3] || prev[2]);
                            node.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, 'params', params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                this.spaces = node.raws.between;
                node.raws.between = '';
            }
        } else {
            node.raws.afterName = '';
            node.params = '';
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== 'space') {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let prev, token, type;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === '(') brackets += 1;
            if (type === ')') brackets -= 1;
            if (brackets === 0 && type === ':') {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === 'word' && prev[1] === 'progid') continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $iBhJ0();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = '';
            node.raws.left = text;
            node.raws.right = '';
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $4zYLI(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $g1eQr();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ';') {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $d6ece5395d662d1b$var$findLastWithPosition(tokens));
        node.source.end.offset++;
        while(tokens[0][0] !== 'word'){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = '';
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ':' || type === 'space' || type === 'comment') break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = '';
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ':') {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === 'word' && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === '_' || node.prop[0] === '*') {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== 'space' && next !== 'comment') break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === '!important') {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== ' !important') node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === 'important') {
                let cache = tokens.slice(0);
                let str = '';
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().startsWith('!') && type !== 'space') break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().startsWith('!')) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== 'space' && token[0] !== 'comment') break;
        }
        let hasWord = tokens.some((i)=>i[0] !== 'space' && i[0] !== 'comment');
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join('');
            firstSpaces = [];
        }
        this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(':') && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error('Double colon', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $hzje4();
        this.init(node, token[2]);
        node.selector = '';
        node.raws.between = '';
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.spaces = '';
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = '';
                prev.source.end = this.getPosition(token[2]);
                prev.source.end.offset += prev.raws.ownSemicolon.length;
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = '';
        if (node.type !== 'comment') this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith('--');
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === '(' || type === '[') {
                if (!bracket) bracket = token;
                brackets.push(type === '(' ? ')' : ']');
            } else if (customProperty && colon && type === '{') {
                if (!bracket) bracket = token;
                brackets.push('}');
            } else if (brackets.length === 0) {
                if (type === ';') {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === '{') {
                    this.rule(tokens);
                    return;
                } else if (type === '}') {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ':') colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== 'space' && token !== 'comment') break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case 'space':
                    this.spaces += token[1];
                    break;
                case ';':
                    this.freeSemicolon(token);
                    break;
                case '}':
                    this.end(token);
                    break;
                case 'comment':
                    this.comment(token);
                    break;
                case 'at-word':
                    this.atrule(token);
                    break;
                case '{':
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = '';
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === 'space' && i === length - 1 && !customProperty) clean = false;
            else if (type === 'comment') {
                prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
                next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
                if (!$d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR[prev] && !$d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ',') clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], '');
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $hzje4();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, 'selector', tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = '';
        while(tokens.length){
            next = tokens[0][0];
            if (next !== 'space' && next !== 'comment') break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = '';
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error('Unclosed block', pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error('Unclosed bracket', {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error('Unexpected }', {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error('Unknown word ' + tokens[0][1], {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error('At-rule without name', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
module.exports = $d6ece5395d662d1b$var$Parser;

});
parcelRegister("4zYLI", function(module, exports) {
'use strict';
const $355991b60a97b476$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $355991b60a97b476$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $355991b60a97b476$var$BACKSLASH = '\\'.charCodeAt(0);
const $355991b60a97b476$var$SLASH = '/'.charCodeAt(0);
const $355991b60a97b476$var$NEWLINE = '\n'.charCodeAt(0);
const $355991b60a97b476$var$SPACE = ' '.charCodeAt(0);
const $355991b60a97b476$var$FEED = '\f'.charCodeAt(0);
const $355991b60a97b476$var$TAB = '\t'.charCodeAt(0);
const $355991b60a97b476$var$CR = '\r'.charCodeAt(0);
const $355991b60a97b476$var$OPEN_SQUARE = '['.charCodeAt(0);
const $355991b60a97b476$var$CLOSE_SQUARE = ']'.charCodeAt(0);
const $355991b60a97b476$var$OPEN_PARENTHESES = '('.charCodeAt(0);
const $355991b60a97b476$var$CLOSE_PARENTHESES = ')'.charCodeAt(0);
const $355991b60a97b476$var$OPEN_CURLY = '{'.charCodeAt(0);
const $355991b60a97b476$var$CLOSE_CURLY = '}'.charCodeAt(0);
const $355991b60a97b476$var$SEMICOLON = ';'.charCodeAt(0);
const $355991b60a97b476$var$ASTERISK = '*'.charCodeAt(0);
const $355991b60a97b476$var$COLON = ':'.charCodeAt(0);
const $355991b60a97b476$var$AT = '@'.charCodeAt(0);
const $355991b60a97b476$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $355991b60a97b476$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $355991b60a97b476$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $355991b60a97b476$var$RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, content, escape, next, quote;
    let currentToken, escaped, escapePos, n, prev;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error('Unclosed ' + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $355991b60a97b476$var$NEWLINE:
            case $355991b60a97b476$var$SPACE:
            case $355991b60a97b476$var$TAB:
            case $355991b60a97b476$var$CR:
            case $355991b60a97b476$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $355991b60a97b476$var$SPACE || code === $355991b60a97b476$var$NEWLINE || code === $355991b60a97b476$var$TAB || code === $355991b60a97b476$var$CR || code === $355991b60a97b476$var$FEED);
                currentToken = [
                    'space',
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $355991b60a97b476$var$OPEN_SQUARE:
            case $355991b60a97b476$var$CLOSE_SQUARE:
            case $355991b60a97b476$var$OPEN_CURLY:
            case $355991b60a97b476$var$CLOSE_CURLY:
            case $355991b60a97b476$var$COLON:
            case $355991b60a97b476$var$SEMICOLON:
            case $355991b60a97b476$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $355991b60a97b476$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : '';
                n = css.charCodeAt(pos + 1);
                if (prev === 'url' && n !== $355991b60a97b476$var$SINGLE_QUOTE && n !== $355991b60a97b476$var$DOUBLE_QUOTE && n !== $355991b60a97b476$var$SPACE && n !== $355991b60a97b476$var$NEWLINE && n !== $355991b60a97b476$var$TAB && n !== $355991b60a97b476$var$FEED && n !== $355991b60a97b476$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(')', next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed('bracket');
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $355991b60a97b476$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        'brackets',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(')', pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $355991b60a97b476$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        '(',
                        '(',
                        pos
                    ];
                    else {
                        currentToken = [
                            'brackets',
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $355991b60a97b476$var$SINGLE_QUOTE:
            case $355991b60a97b476$var$DOUBLE_QUOTE:
                quote = code === $355991b60a97b476$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed('string');
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $355991b60a97b476$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    'string',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $355991b60a97b476$var$AT:
                $355991b60a97b476$var$RE_AT_END.lastIndex = pos + 1;
                $355991b60a97b476$var$RE_AT_END.test(css);
                if ($355991b60a97b476$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $355991b60a97b476$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    'at-word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $355991b60a97b476$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $355991b60a97b476$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $355991b60a97b476$var$SLASH && code !== $355991b60a97b476$var$SPACE && code !== $355991b60a97b476$var$NEWLINE && code !== $355991b60a97b476$var$TAB && code !== $355991b60a97b476$var$CR && code !== $355991b60a97b476$var$FEED) {
                    next += 1;
                    if ($355991b60a97b476$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($355991b60a97b476$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $355991b60a97b476$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    'word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $355991b60a97b476$var$SLASH && css.charCodeAt(pos + 1) === $355991b60a97b476$var$ASTERISK) {
                    next = css.indexOf('*/', pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed('comment');
                    }
                    currentToken = [
                        'comment',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $355991b60a97b476$var$RE_WORD_END.lastIndex = pos + 1;
                    $355991b60a97b476$var$RE_WORD_END.test(css);
                    if ($355991b60a97b476$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $355991b60a97b476$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        'word',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};

});



parcelRegister("8qhiK", function(module, exports) {
'use strict';

var $7xCxF = parcelRequire("7xCxF");
class $621e2c1e489080d5$var$Result {
    get content() {
        return this.css;
    }
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $7xCxF(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === 'warning');
    }
}
module.exports = $621e2c1e489080d5$var$Result;
$621e2c1e489080d5$var$Result.default = $621e2c1e489080d5$var$Result;

});
parcelRegister("7xCxF", function(module, exports) {
'use strict';
class $57d9831eed7a7e90$var$Warning {
    constructor(text, opts = {}){
        this.type = 'warning';
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ': ' + this.text;
        return this.text;
    }
}
module.exports = $57d9831eed7a7e90$var$Warning;
$57d9831eed7a7e90$var$Warning.default = $57d9831eed7a7e90$var$Warning;

});


parcelRegister("jYV5o", function(module, exports) {
/* eslint-disable no-console */ 'use strict';
let $e8bfe6fe946eb8a1$var$printed = {};
module.exports = function warnOnce(message) {
    if ($e8bfe6fe946eb8a1$var$printed[message]) return;
    $e8bfe6fe946eb8a1$var$printed[message] = true;
    if (typeof console !== 'undefined' && console.warn) console.warn(message);
};

});


parcelRegister("5USc3", function(module, exports) {
'use strict';

var $fgZ4H = parcelRequire("fgZ4H");

var $bRV7L = parcelRequire("bRV7L");

var $430u9 = parcelRequire("430u9");

var $k7cLY = parcelRequire("k7cLY");
class $44ec38660d9d72fd$var$Processor {
    constructor(plugins = []){
        this.version = '8.5.3';
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === 'object' && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === 'object' && i.postcssPlugin) normalized.push(i);
            else if (typeof i === 'function') normalized.push(i);
            else if (typeof i === 'object' && (i.parse || i.stringify)) ;
            else throw new Error(i + ' is not a PostCSS plugin');
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $430u9(this, css, opts);
        else return new $bRV7L(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
module.exports = $44ec38660d9d72fd$var$Processor;
$44ec38660d9d72fd$var$Processor.default = $44ec38660d9d72fd$var$Processor;
$k7cLY.registerProcessor($44ec38660d9d72fd$var$Processor);
$fgZ4H.registerProcessor($44ec38660d9d72fd$var$Processor);

});
parcelRegister("430u9", function(module, exports) {
'use strict';

var $98nYS = parcelRequire("98nYS");

var $h3g9A = parcelRequire("h3g9A");

var $8qhiK = parcelRequire("8qhiK");

var $cz61E = parcelRequire("cz61E");
parcelRequire("jYV5o");
class $2f27d19f43c9584e$var$NoWorkResult {
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $h3g9A;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return 'NoWorkResult';
    }
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $cz61E;
        this.result = new $8qhiK(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, 'root', {
            get () {
                return self.root;
            }
        });
        let map = new $98nYS(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
}
module.exports = $2f27d19f43c9584e$var$NoWorkResult;
$2f27d19f43c9584e$var$NoWorkResult.default = $2f27d19f43c9584e$var$NoWorkResult;

});




parcelRegister("99y5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Returns `true` if action has the same type as action creator.
 * Defines Type Guard that lets TypeScript know `payload` type inside blocks
 * where `isType` returned `true`.
 *
 * @example
 *
 *    const somethingHappened =
 *      actionCreator<{foo: string}>('SOMETHING_HAPPENED');
 *
 *    if (isType(action, somethingHappened)) {
 *      // action.payload has type {foo: string}
 *    }
 */ function $6a9f656d654565a5$var$isType(action, actionCreator) {
    return action.type === actionCreator.type;
}
module.exports.isType = $6a9f656d654565a5$var$isType;
/**
 * Creates Action Creator factory with optional prefix for action types.
 * @param prefix Prefix to be prepended to action types as `<prefix>/<type>`.
 * @param defaultIsError Function that detects whether action is error given the
 *   payload. Default is `payload => payload instanceof Error`.
 */ function $6a9f656d654565a5$var$actionCreatorFactory(prefix, defaultIsError) {
    if (defaultIsError === void 0) defaultIsError = function(p) {
        return p instanceof Error;
    };
    var actionTypes = {};
    var base = prefix ? prefix + "/" : '';
    function actionCreator(type, commonMeta, isError) {
        if (isError === void 0) isError = defaultIsError;
        var fullType = base + type;
        return Object.assign(function(payload, meta) {
            var action = {
                type: fullType,
                payload: payload
            };
            if (commonMeta || meta) action.meta = Object.assign({}, commonMeta, meta);
            if (isError && (typeof isError === 'boolean' || isError(payload))) action.error = true;
            return action;
        }, {
            type: fullType,
            toString: function() {
                return fullType;
            },
            match: function(action) {
                return action.type === fullType;
            }
        });
    }
    function asyncActionCreators(type, commonMeta) {
        return {
            type: base + type,
            started: actionCreator(type + "_STARTED", commonMeta, false),
            done: actionCreator(type + "_DONE", commonMeta, false),
            failed: actionCreator(type + "_FAILED", commonMeta, true)
        };
    }
    return Object.assign(actionCreator, {
        async: asyncActionCreators
    });
}
module.exports.actionCreatorFactory = $6a9f656d654565a5$var$actionCreatorFactory;
module.exports.default = $6a9f656d654565a5$var$actionCreatorFactory;

});

parcelRegister("7Uc0p", function(module, exports) {

$parcel$export(module.exports, "asyncFactory", () => $5c17136ac84c7464$export$c83655ef6ded7a0d);
$parcel$export(module.exports, "thunkToAction", () => $5c17136ac84c7464$export$924bc00532a1ef3d);
/**
 * Factory function to easily create a thunk
 * @param factory typescript-fsa action creator factory
 * @returns an function that takes
 *  - the `type` of the action,
 *  - the your worker thunk function
 * And returns object with the async actions and the thunk itself
 */ var $5c17136ac84c7464$export$c83655ef6ded7a0d = function(factory, resolve) {
    if (resolve === void 0) resolve = Promise.resolve.bind(Promise);
    return function(type, worker, commonMeta) {
        var async = factory.async(type, commonMeta);
        var fn = function(params) {
            return function(dispatch, getState, extraArgument) {
                return resolve().then(function() {
                    dispatch(async.started(params));
                }).then(function() {
                    return worker(params, dispatch, getState, extraArgument);
                }).then(function(result) {
                    dispatch(async.done({
                        params: params,
                        result: result
                    }));
                    return result;
                }, function(error) {
                    dispatch(async.failed({
                        params: params,
                        error: error
                    }));
                    throw error;
                });
            };
        };
        fn.action = function(params) {
            return fn(params);
        };
        fn.async = async;
        return fn;
    };
};
function $5c17136ac84c7464$export$924bc00532a1ef3d(thunkCreator) {
    return thunkCreator;
}
var $5c17136ac84c7464$export$2e2bcd8739ae039 = $5c17136ac84c7464$export$c83655ef6ded7a0d;

});

parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("ki1Eq", function(module, exports) {
"use strict";
var $ec56c4eee63034f1$var$__assign = module.exports && module.exports.__assign || function() {
    $ec56c4eee63034f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec56c4eee63034f1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ec56c4eee63034f1$var$reducerWithInitialState(initialState) {
    return $ec56c4eee63034f1$var$makeReducer(initialState);
}
module.exports.reducerWithInitialState = $ec56c4eee63034f1$var$reducerWithInitialState;
function $ec56c4eee63034f1$var$reducerWithoutInitialState() {
    return $ec56c4eee63034f1$var$makeReducer();
}
module.exports.reducerWithoutInitialState = $ec56c4eee63034f1$var$reducerWithoutInitialState;
function $ec56c4eee63034f1$var$upcastingReducer() {
    return $ec56c4eee63034f1$var$makeReducer();
}
module.exports.upcastingReducer = $ec56c4eee63034f1$var$upcastingReducer;
function $ec56c4eee63034f1$var$makeReducer(initialState) {
    var handlersByActionType = {};
    var reducer = $ec56c4eee63034f1$var$getReducerFunction(initialState, handlersByActionType);
    reducer.caseWithAction = function(actionCreator, handler) {
        handlersByActionType[actionCreator.type] = handler;
        return reducer;
    };
    reducer.case = function(actionCreator, handler) {
        return reducer.caseWithAction(actionCreator, function(state, action) {
            return handler(state, action.payload);
        });
    };
    reducer.casesWithAction = function(actionCreators, handler) {
        for(var _i = 0, actionCreators_1 = actionCreators; _i < actionCreators_1.length; _i++){
            var actionCreator = actionCreators_1[_i];
            reducer.caseWithAction(actionCreator, handler);
        }
        return reducer;
    };
    reducer.cases = function(actionCreators, handler) {
        return reducer.casesWithAction(actionCreators, function(state, action) {
            return handler(state, action.payload);
        });
    };
    reducer.withHandling = function(updateBuilder) {
        return updateBuilder(reducer);
    };
    reducer.default = function(defaultHandler) {
        return $ec56c4eee63034f1$var$getReducerFunction(initialState, $ec56c4eee63034f1$var$__assign({}, handlersByActionType), defaultHandler);
    };
    reducer.build = function() {
        return $ec56c4eee63034f1$var$getReducerFunction(initialState, $ec56c4eee63034f1$var$__assign({}, handlersByActionType));
    };
    return reducer;
}
function $ec56c4eee63034f1$var$getReducerFunction(initialState, handlersByActionType, defaultHandler) {
    return function(passedState, action) {
        var state = passedState !== undefined ? passedState : initialState;
        var handler = handlersByActionType[action.type] || defaultHandler;
        return handler ? handler(state, action) : state;
    };
}

});

parcelRegister("a1McR", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $74cf642ba7fa99c2$export$7d8a5b498da695ac);

var $i4CZ2 = parcelRequire("i4CZ2");

var $eShmq = parcelRequire("eShmq");

var $6SpLG = parcelRequire("6SpLG");

var $eNuyV = parcelRequire("eNuyV");
var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $6SpLG.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $i4CZ2.isDraft)(value) ? (0, $i4CZ2.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $eShmq.compose;
    return (0, $eShmq.compose).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$export$b956e38827fca970(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $74cf642ba7fa99c2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $74cf642ba7fa99c2$var$hasMatchFunction(action);
}
function $74cf642ba7fa99c2$export$ebd532f9034651f3(action) {
    return $74cf642ba7fa99c2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $74cf642ba7fa99c2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $74cf642ba7fa99c2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $74cf642ba7fa99c2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $i4CZ2.isDraftable)(val) ? (0, $i4CZ2.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = true;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $eNuyV.default));
        else middlewareArray.push((0, $eNuyV.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = true;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $eShmq.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $eShmq.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $eShmq.compose);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $74cf642ba7fa99c2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $eShmq.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i4CZ2.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i4CZ2.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i4CZ2.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i4CZ2.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i4CZ2.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$74cf642ba7fa99c2$export$b956e38827fca970(action)) return next(action);
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i4CZ2.enableES5)();

});
parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("6SpLG", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $501bc638b8425ea6$export$595d22ed68ca2841);

var $9EdUm = parcelRequire("9EdUm");
function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $9EdUm.defaultMemoize));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("9EdUm", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $7062a3595350e02d$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = 'NOT_FOUND';
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("eNuyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5d5956ce0b399b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;

});


parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("lXLT6", function(module, exports) {
module.exports = import("iRivb").then(()=>parcelRequire('3wb8F'));

});


// https://sandbox.gh.nbauer.ru/
parcelRequire("acw62");
parcelRequire("jHTLJ");
parcelRequire("1u0KT");

var $7c5y3 = parcelRequire("7c5y3");



((spriteNodeId, spriteGlobalVarName)=>{
    let sprite;
    const isSpriteExists = Object.prototype.hasOwnProperty.call(window, spriteGlobalVarName);
    if (isSpriteExists) sprite = window[spriteGlobalVarName];
    else {
        sprite = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="position: absolute; width: 0; height: 0;" aria-hidden="true"><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-add_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0l-.001-6H5a1 1 0 1 1 0-2h5.999L11 5a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-add_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 5a.9.9 0 0 1 .9.9v3.2h3.2a.9.9 0 0 1 0 1.8h-3.2v3.2a.9.9 0 0 1-1.8 0v-3.2H5.9a.9.9 0 0 1 0-1.8h3.2V5.9A.9.9 0 0 1 10 5" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 1.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M.1 10C.1 4.532 4.532.1 10 .1s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9S.1 15.468.1 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-add_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M10 2.5a.75.75 0 0 1 .75.75v6h6a.75.75 0 1 1 0 1.5h-6v6a.75.75 0 0 1-1.5 0v-6h-6a.75.75 0 0 1 0-1.5h6v-6A.75.75 0 0 1 10 2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-add_square_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.219 1.5H9.78c.674 0 1.224 0 1.672.037.463.037.882.118 1.273.317a3.25 3.25 0 0 1 1.42 1.42c.199.391.28.81.317 1.273.037.447.037.998.037 1.672V9.78c0 .674 0 1.224-.037 1.672-.037.463-.118.882-.317 1.273a3.25 3.25 0 0 1-1.42 1.42c-.391.199-.81.28-1.273.317-.447.037-.998.037-1.672.037H6.22c-.674 0-1.225 0-1.672-.037-.463-.037-.882-.118-1.272-.317a3.25 3.25 0 0 1-1.42-1.42c-.2-.391-.28-.81-.318-1.273-.037-.447-.037-.998-.037-1.672V6.22c0-.674 0-1.224.037-1.672.037-.463.118-.882.317-1.272a3.25 3.25 0 0 1 1.42-1.42c.391-.2.81-.28 1.273-.318.448-.037.998-.037 1.672-.037m-1.55 1.532c-.37.03-.57.085-.713.159a1.75 1.75 0 0 0-.765.765c-.074.144-.13.343-.16.713C3.002 5.05 3 5.538 3 6.25v3.5c0 .712 0 1.202.032 1.58.03.371.085.57.159.714.168.33.435.598.765.765.144.074.343.13.713.16.38.03.869.031 1.581.031h3.5c.712 0 1.202 0 1.58-.032.371-.03.57-.085.714-.159a1.75 1.75 0 0 0 .765-.764c.074-.145.13-.344.16-.714.03-.38.031-.869.031-1.581v-3.5c0-.712 0-1.202-.032-1.58-.03-.371-.085-.57-.159-.714a1.75 1.75 0 0 0-.764-.765c-.145-.074-.344-.13-.714-.16C10.95 3.002 10.462 3 9.75 3h-3.5c-.712 0-1.202 0-1.58.032M8 4.5a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2A.75.75 0 0 1 8 4.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-add_square_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.5 7a.9.9 0 0 1 .9.9v3.2h3.2a.9.9 0 0 1 0 1.8h-3.2v3.2a.9.9 0 0 1-1.8 0v-3.2H8.4a.9.9 0 1 1 0-1.8h3.2V7.9a.9.9 0 0 1 .9-.9" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.962 3h5.076c.948 0 1.714 0 2.334.05.64.053 1.203.163 1.726.43a4.4 4.4 0 0 1 1.922 1.922c.267.523.377 1.087.43 1.726.05.62.05 1.386.05 2.334v5.076c0 .948 0 1.714-.05 2.334-.053.64-.163 1.203-.43 1.726a4.4 4.4 0 0 1-1.922 1.922c-.523.267-1.087.377-1.726.43-.62.05-1.386.05-2.334.05H9.962c-.948 0-1.714 0-2.334-.05-.64-.053-1.203-.163-1.726-.43a4.4 4.4 0 0 1-1.922-1.922c-.267-.523-.377-1.087-.43-1.726-.05-.62-.05-1.386-.05-2.334V9.462c0-.948 0-1.714.05-2.334.053-.64.163-1.203.43-1.726A4.4 4.4 0 0 1 5.902 3.48c.523-.267 1.087-.377 1.726-.43C8.248 3 9.014 3 9.962 3M7.775 4.845c-.528.043-.83.123-1.055.238A2.6 2.6 0 0 0 5.583 6.22c-.115.226-.195.527-.238 1.055C5.3 7.813 5.3 8.505 5.3 9.5v5c0 .995 0 1.687.045 2.226.043.527.123.828.238 1.054a2.6 2.6 0 0 0 1.137 1.137c.226.115.527.195 1.055.238.538.044 1.23.045 2.225.045h5c.995 0 1.687 0 2.226-.045.527-.043.828-.123 1.054-.238a2.6 2.6 0 0 0 1.137-1.137c.115-.226.195-.527.238-1.055.044-.538.045-1.23.045-2.225v-5c0-.995 0-1.687-.045-2.226-.043-.527-.123-.828-.238-1.054a2.6 2.6 0 0 0-1.137-1.137c-.226-.115-.527-.195-1.055-.238C16.688 4.8 15.996 4.8 15 4.8h-5c-.995 0-1.687 0-2.226.045" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-angry-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M8.845 12.25s1.66-.005 2.23 1.315c.035.085.06.175.065.265.015.185-.115.375-.43.25-.505-.2-1.375-.3-1.865-.3s-1.355.1-1.865.3c-.315.125-.445-.065-.43-.25.005-.09.03-.18.065-.265.575-1.32 2.23-1.315 2.23-1.315"/><path fill="url(#d)" d="M6.39 11.03c.425 0 .77-.522.77-1.165S6.815 8.7 6.39 8.7s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#e)" d="M6.085 9.445c.45 0 .825.46.935 1.085.09-.19.14-.42.14-.67 0-.645-.345-1.165-.77-1.165-.37 0-.68.39-.755.915a.72.72 0 0 1 .45-.165"/><path fill="url(#f)" d="M5.565 7.025c-.69 0-1.28.795-.51.915s2.17.785 2.765 1.245c.045.055.22.035.205-.1 0-.52-1.62-2.06-2.46-2.06"/><path fill="url(#g)" d="M8.845 12.685s1.35-.005 2.275 1.035a.6.6 0 0 0-.05-.155c-.57-1.32-2.23-1.315-2.23-1.315s-1.66-.005-2.23 1.315q-.029.074-.05.155c.935-1.04 2.285-1.035 2.285-1.035"/><path fill="url(#h)" d="M11.61 11.03c.425 0 .77-.522.77-1.165S12.035 8.7 11.61 8.7s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#i)" d="M11.915 9.445c-.45 0-.825.46-.935 1.085-.09-.19-.14-.42-.14-.67 0-.645.345-1.165.77-1.165.37 0 .68.39.755.915a.72.72 0 0 0-.45-.165"/><path fill="url(#j)" d="M12.435 7.025c.69 0 1.28.795.51.915s-2.17.785-2.765 1.245c-.045.055-.22.035-.205-.1 0-.52 1.62-2.06 2.46-2.06"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(7.01283 -3.99972 3.26753 5.72906 7.197 5.815)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF9214"/><stop offset="1" stop-color="#FF4E0D"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(7.01283 -3.99972 3.26753 5.72906 7.197 5.815)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF9214"/><stop offset="1" stop-color="#FF4E0D"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="matrix(1.75166 0 0 .9331 8.846 13.186)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -3.503 9.04)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="matrix(-.31433 1.08576 -.70247 -.20337 11.868 9.873)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><linearGradient id="e" x1="6.397" x2="6.397" y1="9.053" y2="10.096" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="f" x1="6.359" x2="6.359" y1="9.796" y2="7.379" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="g" x1="8.846" x2="8.846" y1="11.682" y2="12.941" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="i" x1="11.603" x2="11.603" y1="9.053" y2="10.096" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="j" x1="11.642" x2="11.642" y1="9.796" y2="7.379" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#643800"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-apps" class="svg-sprite__symbol"><rect width="7" height="7" x="2" y="2" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-width="1.5" d="M12.76 3.975c.56-1.119.84-1.678 1.219-1.858.33-.156.712-.156 1.042 0 .38.18.66.74 1.22 1.858l1.108 2.213c.466.931.699 1.397.643 1.775-.05.33-.232.626-.506.818C17.172 9 16.65 9 15.608 9h-2.216c-1.043 0-1.564 0-1.878-.22a1.21 1.21 0 0 1-.506-.817c-.056-.378.177-.844.644-1.775z"/><rect width="7" height="7" x="11" y="11" stroke="currentColor" stroke-width="1.5" rx="2"/><rect width="7" height="7" x="2" y="11" stroke="currentColor" stroke-width="1.5" rx="3.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-long" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 10h15M3 10l6.5-6.5M3 10l6.5 6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-right" class="svg-sprite__symbol"><path fill="currentColor" d="M13.354 6.646a.5.5 0 0 0-.708.708zM16 10l.354.354a.5.5 0 0 0 0-.708zm-3.354 2.646a.5.5 0 0 0 .708.708zM4 9.5a.5.5 0 0 0 0 1zm8.646-2.146 3 3 .708-.708-3-3zm3 2.292-3 3 .708.708 3-3zM16 9.5H4v1h12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-short" class="svg-sprite__symbol"><path fill="currentColor" d="M4.53 6.47a.75.75 0 0 0-1.06 1.06zM10 13l-.53.53a.75.75 0 0 0 1.06 0zm6.53-5.47a.75.75 0 0 0-1.06-1.06zm-13.06 0 6 6 1.06-1.06-6-6zm7.06 6 6-6-1.06-1.06-6 6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="16" fill="none" id="svg-name-arrow-short-bold" class="svg-sprite__symbol"><path fill="currentColor" d="M3.53 5.22a.75.75 0 0 0-1.06 1.06zm3.97 5.03-.53.53a.75.75 0 0 0 1.06 0zm5.03-3.97a.75.75 0 0 0-1.06-1.06zm-10.06 0 4.5 4.5 1.06-1.06-4.5-4.5zm5.56 4.5 4.5-4.5-1.06-1.06-4.5 4.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow-short-right" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 16 6-6-6-6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-arrow-thick" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 2v8.4M6 2 3 5.12M6 2l3 3.12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-arrow_left_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.293 6.293a1 1 0 1 1 1.414 1.414L8.414 13H22a1 1 0 0 1 .993.883L23 14a1 1 0 0 1-1 1H8.414l5.293 5.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0l-7-7-.073-.082-.007-.008a1 1 0 0 1-.067-.096 1 1 0 0 1-.11-.255A1 1 0 0 1 5 14l.004.09L5 14.02V14a1 1 0 0 1 .094-.423 1 1 0 0 1 .199-.284l-.08.09a1 1 0 0 1 .08-.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-arrow_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="m22.707 13.293-7-7a1 1 0 0 0-1.497 1.32l.083.094L19.586 13H6a1 1 0 0 0-.993.883L5 14a1 1 0 0 0 .883.993L6 15h13.586l-5.293 5.293a1 1 0 0 0-.083 1.32l.083.094a1 1 0 0 0 1.32.083l.094-.083 7-7 .097-.112.071-.11.054-.114.035-.105.025-.117.007-.06.004-.108-.004-.07-.016-.112-.03-.111-.044-.111-.052-.098-.067-.096a1 1 0 0 0-.08-.09l-7-7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="3 3 18 18" id="svg-name-arrow_up_right_out_square_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.136 6.273a.955.955 0 0 1 0 1.909c-.637 0-.816.004-.946.03a1.59 1.59 0 0 0-1.25 1.25c-.026.13-.03.31-.03.947v3.564c0 .728 0 1.217.03 1.594.03.365.084.54.143.655.152.3.395.543.695.695.115.06.29.112.655.142.377.031.866.032 1.594.032h3.564c.637 0 .816-.005.947-.03a1.59 1.59 0 0 0 1.25-1.25c.026-.131.03-.31.03-.947a.955.955 0 0 1 1.91 0c0 .545.004.957-.068 1.319a3.5 3.5 0 0 1-2.75 2.75c-.34.067-.726.067-1.226.067H9.99c-.68 0-1.248 0-1.711-.038-.484-.04-.938-.125-1.367-.343a3.5 3.5 0 0 1-1.53-1.53c-.218-.43-.304-.883-.343-1.367C5 15.26 5 14.692 5 14.012v-3.696c0-.5 0-.886.067-1.226a3.5 3.5 0 0 1 2.75-2.75c.362-.072.774-.067 1.32-.067" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.636 5.955c0-.528.428-.955.955-.955h4.455c.527 0 .954.427.954.955v4.454a.955.955 0 0 1-1.91 0V8.26l-4.097 4.098a.955.955 0 0 1-1.35-1.35l4.098-4.098h-2.15a.955.955 0 0 1-.955-.954" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-arrow_uturn_left_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7.63 2.72a.75.75 0 0 1 0 1.06L5.81 5.6h5.24a5.45 5.45 0 1 1 0 10.9H6.4a.75.75 0 0 1 0-1.5h4.65a3.95 3.95 0 0 0 0-7.9H5.81l1.82 1.82a.75.75 0 0 1-1.06 1.06l-3.1-3.1a.75.75 0 0 1 0-1.06l3.1-3.1a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" id="svg-name-asterisk" class="svg-sprite__symbol"><path d="M11 3v6.563L5.281 6.28 3.313 9.72 9.03 13l-5.719 3.281 1.97 3.438L11 16.437V23h4v-6.562l5.719 3.28 1.968-3.437L16.97 13l5.718-3.281L20.72 6.28 15 9.563V3Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-attach" class="svg-sprite__symbol"><path fill="currentColor" d="M15.655 5.544a.75.75 0 0 0-1.033-1.088zm7.718 6.666a.75.75 0 1 0-1.033-1.087zm-9.553 8.043-.517-.544zm-2.494-2.882-.522-.538zm3.296-12.915-8.206 7.796L7.45 13.34l8.205-7.796zM11.848 17.91l7.968-7.732L18.77 9.1l-7.967 7.732zm-.06-16.093L3.648 9.548l1.033 1.088 8.138-7.733zm2.548 18.98 9.037-8.586-1.033-1.087-9.037 8.586zM3.458 20.61a7.76 7.76 0 0 0 10.878.187l-1.033-1.087a6.26 6.26 0 0 1-8.775-.151zm.191-11.06a7.76 7.76 0 0 0-.19 11.06l1.07-1.051a6.26 6.26 0 0 1 .153-8.922zm16.194-7.664a5.796 5.796 0 0 0-8.056-.069l1.033 1.087a4.296 4.296 0 0 1 5.972.052zm-.027 8.292a5.796 5.796 0 0 0 .027-8.292l-1.051 1.07a4.296 4.296 0 0 1-.02 6.146zM6.299 17.82a3.92 3.92 0 0 0 5.55.088l-1.045-1.076a2.42 2.42 0 0 1-3.427-.054zm.117-5.569a3.92 3.92 0 0 0-.117 5.57l1.078-1.043a2.42 2.42 0 0 1 .073-3.44z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-audio" class="svg-sprite__symbol"><path d="M16 12.5V4.887a1 1 0 0 0-1.316-.948L8.368 6.044A2 2 0 0 0 7 7.942V15M7.026 15.227c.152.648-.357 1.624-1.606 1.916s-2.138-.359-2.289-1.007.357-1.623 1.607-1.915c1.25-.291 2.137.358 2.288 1.006"/><path d="M16.026 12.727c.151.648-.357 1.624-1.606 1.916s-2.138-.359-2.289-1.007.357-1.623 1.607-1.915c1.25-.291 2.137.358 2.288 1.006"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-badge-rt" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="#fff" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-7" x2="17.166" y1="-6" y2="-4.762" gradientUnits="userSpaceOnUse"><stop stop-color="#6DCFEE"/><stop offset=".83" stop-color="#046ADE"/></linearGradient><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-ban" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 4 4 16"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-basketball_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m5.47 2.953 4.205 4.204 1.123-1.123A8.47 8.47 0 0 1 8.882 2a6.96 6.96 0 0 0-3.411.952m4.975-.804a7 7 0 0 0 1.417 2.82l1.47-1.469a7 7 0 0 0-2.887-1.35m3.958 2.4-1.465 1.466a7 7 0 0 0 2.867 1.336 7 7 0 0 0-1.402-2.801M16 8.91a8.47 8.47 0 0 1-4.128-1.827l-1.136 1.136 4.312 4.311a6.97 6.97 0 0 0 .952-3.62m-1.855 4.839-4.47-4.47-1.206 1.207a8.47 8.47 0 0 1 2.03 5.354 7 7 0 0 0 3.646-2.091M9 16c0-1.69-.599-3.24-1.597-4.45L4.55 14.403A6.97 6.97 0 0 0 9 16m-5.5-2.669 2.831-2.83A6.97 6.97 0 0 0 2.001 9H2c0 1.636.56 3.14 1.5 4.331m-1.34-5.83a8.47 8.47 0 0 1 5.238 1.933l1.216-1.216-4.362-4.362a7 7 0 0 0-2.091 3.645m1.681-5.257A8.47 8.47 0 0 1 9.59.52a8.47 8.47 0 0 1 5.362 2.41A8.48 8.48 0 0 1 17.5 9c0 1.939-.65 3.728-1.744 5.159A8.49 8.49 0 0 1 9 17.5a8.48 8.48 0 0 1-6.07-2.549A8.48 8.48 0 0 1 .537 8.214a8.5 8.5 0 0 1 3.305-5.97" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-bell" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M19.662 19.2H4.217c-.861 0-1.45-.883-1.149-1.689.555-1.482 1.252-3.578 1.252-4.74 0-1.929-1.28-11.572 7.68-11.572s7.68 9 7.68 11.572c0 1.45.61 3.308 1.143 4.654.328.828-.27 1.774-1.16 1.774ZM9 19.8s0 3 3 3 3-3 3-3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-bell-crossed-out" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M9 19.438s0 2.944 3 2.944 3-2.945 3-2.945"/><path fill="currentColor" fill-rule="evenodd" d="M6.243 19.595h13.404c1.468 0 2.37-1.53 1.856-2.813-.527-1.313-1.073-2.996-1.073-4.247 0-.205.011-.472.024-.787.058-1.435.156-3.875-.538-6.066a8.2 8.2 0 0 0-.964-2.055l-.996 1.251c.216.395.39.817.53 1.257.603 1.905.525 3.976.47 5.437-.013.362-.026.687-.026.963 0 1.565.65 3.484 1.18 4.805.152.378-.142.755-.463.755H7.436zM16.736 3.361a5 5 0 0 0-.21-.169c-.982-.747-2.412-1.266-4.525-1.266-2.102 0-3.527.552-4.51 1.343-.99.796-1.603 1.892-1.974 3.097-.615 2.002-.525 4.126-.47 5.421.013.297.024.55.024.748 0 .679-.199 1.556-.441 2.394a33 33 0 0 1-.845 2.486c-.128.338.129.68.446.68h.778l-1.164 1.463c-1.187-.232-1.901-1.52-1.462-2.676.272-.716.574-1.566.806-2.37.238-.823.382-1.526.382-1.977 0-.137-.01-.335-.02-.581-.058-1.244-.172-3.737.533-6.029C4.514 4.526 5.26 3.137 6.55 2.1 7.847 1.057 9.622.426 12 .426c2.367 0 4.137.585 5.435 1.573q.12.092.235.188z" clip-rule="evenodd"/><path fill="currentColor" d="M2.838 23.047 20.853.412l1.287.954L4.125 24z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none" id="svg-name-bell-with-plus" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.047 12.012c.012.301.023.558.023.759 0 .693-.2 1.594-.446 2.455a35 35 0 0 1-.853 2.548c-.125.336.13.675.446.675h6.64q.364.793.86 1.5H7.76a3 3 0 0 0 .286 1.016c.143.286.345.55.635.743.286.19.7.343 1.319.343.616 0 1.029-.151 1.314-.34a9.5 9.5 0 0 0 1.256.911q-.188.179-.42.334c-.558.372-1.269.595-2.15.595s-1.592-.223-2.15-.595a3.4 3.4 0 0 1-1.146-1.32 4.4 4.4 0 0 1-.446-1.653l-.003-.034H2.217c-1.405 0-2.328-1.424-1.85-2.7a33 33 0 0 0 .814-2.434c.242-.847.39-1.575.39-2.044 0-.141-.01-.343-.021-.595-.057-1.268-.17-3.801.532-6.13.429-1.422 1.174-2.834 2.463-3.89C5.842 1.093 7.619.449 10 .449c2.37 0 4.142.597 5.44 1.604 1.044.81 1.735 1.848 2.19 2.948a9.6 9.6 0 0 0-1.597.112 5.4 5.4 0 0 0-1.512-1.875C13.539 2.477 12.11 1.95 10 1.95c-2.1 0-3.522.562-4.505 1.367-.992.813-1.606 1.931-1.978 3.162-.617 2.045-.526 4.216-.471 5.534" clip-rule="evenodd"/><path fill="#07F" fill-rule="evenodd" d="M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 11.107v7.215M21.107 14.715h-7.214"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-block_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m4.391-3.048a7 7 0 0 1-9.843-9.843zm1.06-1.06L5.61 4.547a7 7 0 0 1 9.843 9.843" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-block_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M20.329 21.743 6.257 7.67A9.96 9.96 0 0 0 4 14c0 5.523 4.477 10 10 10a9.96 9.96 0 0 0 6.329-2.257m1.414-1.414A9.96 9.96 0 0 0 24 14c0-5.523-4.477-10-10-10a9.96 9.96 0 0 0-6.329 2.257zM14 26C7.373 26 2 20.627 2 14S7.373 2 14 2s12 5.373 12 12-5.373 12-12 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bold" class="svg-sprite__symbol"><path fill="currentColor" d="M5.25 17a.75.75 0 0 0 1.5 0zm1.5-14a.75.75 0 0 0-1.5 0zm0 14V3h-1.5v14z"/><path stroke="currentColor" stroke-width="1.5" d="M6 3h5a3 3 0 1 1 0 6H6M6 9h6a4 4 0 0 1 0 8H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bold-active" class="svg-sprite__symbol"><path fill="#F15F2C" d="M5.25 17a.75.75 0 0 0 1.5 0zm1.5-14a.75.75 0 0 0-1.5 0zm0 14V3h-1.5v14z"/><path stroke="#F15F2C" stroke-width="1.5" d="M6 3h5a3 3 0 1 1 0 6H6M6 9h6a4 4 0 0 1 0 8H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-bonus" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 9.666H2v8.69h16z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.63 9.666h2.739a.013.013 0 0 1 .012.013v2.654a1.38 1.38 0 0 1-2.36.977c-.258-.259-.404-.61-.404-.976V9.679a.012.012 0 0 1 .013-.013M5.417 2h9.166A3.417 3.417 0 0 1 18 5.417H2A3.417 3.417 0 0 1 5.417 2M18 5.416l-1.875 4.25M2 5.416l1.875 4.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-boosty" class="svg-sprite__symbol"><path fill="url(#a)" d="M2.522 11.946 5.926 0h5.223l-1.056 3.704a.4.4 0 0 0-.027.066l-2.774 9.78H9.88Q8.26 17.663 7.343 20c-4.777-.054-6.116-3.526-4.943-7.634zM7.36 20l6.297-9.2h-2.672l2.325-5.893c3.989.423 5.86 3.608 4.76 7.458C16.889 16.508 12.11 20 7.458 20z"/><path fill="url(#b)" d="M2.522 11.946 5.926 0h5.223l-1.056 3.704a.4.4 0 0 0-.027.066l-2.774 9.78H9.88Q8.26 17.663 7.343 20c-4.777-.054-6.116-3.526-4.943-7.634zM7.36 20l6.297-9.2h-2.672l2.325-5.893c3.989.423 5.86 3.608 4.76 7.458C16.889 16.508 12.11 20 7.458 20z"/><defs><linearGradient id="a" x1="18.381" x2="2" y1="10" y2="10" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient><linearGradient id="b" x1="3.503" x2="-6.009" y1="-1.507" y2="20.566" gradientUnits="userSpaceOnUse"><stop stop-color="#EF7829"/><stop offset=".28" stop-color="#F0692A"/><stop offset=".63" stop-color="#F15E2C"/><stop offset="1" stop-color="#F15A2C"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-boosty-white" class="svg-sprite__symbol"><path fill="#fff" d="M3.782 17.92 8.888 0h7.836l-1.585 5.556a.6.6 0 0 0-.04.099l-4.162 14.67h3.883Q12.39 26.496 11.014 30c-7.164-.08-9.173-5.29-7.415-11.45zM11.041 30l9.445-13.8h-4.008l3.486-8.84c5.984.635 8.79 5.412 7.14 11.188C25.334 24.762 18.166 30 11.187 30z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-box" class="svg-sprite__symbol"><path stroke="#F1F1F1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 8.3 1.5 4.9l4.25-1.7L10 1.5l8.5 3.4-4.25 1.7z" clip-rule="evenodd"/><path fill="currentColor" d="M9.721 19.2a.75.75 0 0 0 .557-1.393zM1.5 15.103H.75a.75.75 0 0 0 .471.697zm.75-10.2a.75.75 0 0 0-1.5 0zm7.471 12.904a.75.75 0 0 0 .557 1.393zm8.779-2.704.279.697a.75.75 0 0 0 .471-.697zm.75-10.2a.75.75 0 0 0-1.5 0zm-10 13.6a.75.75 0 0 0 1.5 0zm1.5-10.2a.75.75 0 0 0-1.5 0zM6.279 2.406a.75.75 0 1 0-.558 1.393zm7.943 4.793a.75.75 0 0 0 .556-1.393zm-3.943 10.609-8.5-3.4L1.22 15.8l8.5 3.4zM2.25 15.103v-10.2H.75v10.2zm8.028 4.097 8.5-3.4-.556-1.393-8.5 3.4zm8.972-4.097v-10.2h-1.5v10.2zm-8.5 3.4v-10.2h-1.5v10.2zM5.721 3.798l8.5 3.4.557-1.393-8.5-3.4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-box-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M14.542 5H5.458C4.107 5 3 6.098 3 7.439v.694h14V7.44C17 6.099 15.893 5 14.542 5"/><path fill="url(#c)" d="M12.116 11.963c0 .21-.179.388-.39.388H8.258a.395.395 0 0 1-.39-.388V8.895H3v5.49c0 .34.277.614.619.614H16.38a.616.616 0 0 0 .619-.613V8.895h-4.884z"/><path fill="url(#d)" d="M8.649 8.895v2.68h2.702v-2.68zM10 10.833a.581.581 0 1 1 0-1.163.581.581 0 1 1 0 1.163"/><defs><linearGradient id="a" x1="1.5" x2="25" y1="22.5" y2="-5" gradientUnits="userSpaceOnUse"><stop stop-color="#4EA1FF"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="b" x1="-3.16" x2="13.219" y1="3.192" y2="14.469" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><linearGradient id="c" x1="-3.16" x2="18.303" y1="5.372" y2="12.956" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><linearGradient id="d" x1="7.46" x2="12.01" y1="7.348" y2="8.054" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-broadcast" class="svg-sprite__symbol"><circle cx="10" cy="10" r="1.25" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M7.45 6.6a.75.75 0 0 0-.901-1.2zm6.001-1.2a.75.75 0 1 0-.901 1.2zm-6.902 9.2a.75.75 0 1 0 .901-1.2zm6.001-1.2a.75.75 0 1 0 .901 1.2zM5.75 10c0-1.39.666-2.624 1.7-3.4l-.901-1.2A5.74 5.74 0 0 0 4.25 10zm6.8-3.4a4.24 4.24 0 0 1 1.7 3.4h1.5a5.74 5.74 0 0 0-2.299-4.6zm-5.1 6.8a4.24 4.24 0 0 1-1.7-3.4h-1.5c0 1.881.904 3.552 2.299 4.6zm6.8-3.4c0 1.39-.666 2.624-1.7 3.4l.901 1.2A5.74 5.74 0 0 0 15.75 10zM5.45 2.6a.75.75 0 1 0-.9-1.2zm-.9 16a.75.75 0 0 0 .9-1.2zM1.75 10a9.23 9.23 0 0 1 3.7-7.4l-.9-1.2A10.73 10.73 0 0 0 .25 10zm3.7 7.4a9.23 9.23 0 0 1-3.7-7.4H.25c0 3.517 1.69 6.64 4.3 8.6zM14.55 2.6a.75.75 0 0 1 .9-1.2zm.9 16a.75.75 0 0 1-.9-1.2zm2.8-8.6a9.23 9.23 0 0 0-3.7-7.4l.9-1.2c2.61 1.96 4.3 5.083 4.3 8.6zm-3.7 7.4a9.23 9.23 0 0 0 3.7-7.4h1.5c0 3.517-1.69 6.64-4.3 8.6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" id="svg-name-broadcast-struck-out" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M28.4 21.2a1.5 1.5 0 0 0-1.8-2.4C20.165 23.634 16 31.33 16 40c0 5.98 1.982 11.496 5.322 15.93q.054-.07.12-.135l2.018-2.019A23.4 23.4 0 0 1 19 40c0-7.686 3.69-14.51 9.4-18.8m-3.02 34.898-1.817 1.818a1.5 1.5 0 0 1-.347.259A26.7 26.7 0 0 0 26.6 61.2a1.5 1.5 0 0 0 1.802-2.4 23.7 23.7 0 0 1-3.02-2.702m5.487-5.486 2.128-2.129q.198.164.404.318a1.5 1.5 0 1 1-1.803 2.398q-.375-.28-.73-.587m.095-4.338-2.148 2.148A13.94 13.94 0 0 1 26 40c0-4.58 2.201-8.647 5.598-11.199a1.5 1.5 0 0 1 1.802 2.399 10.98 10.98 0 0 0-4.4 8.8c0 2.332.725 4.494 1.963 6.274m6.32-2.077a5 5 0 0 0 6.916-6.916l-2.253 2.252A2.004 2.004 0 0 1 40 42q-.241 0-.467-.055zm1.035-5.278-2.954 2.954a5 5 0 0 1 6.51-6.51l-2.954 2.954a2 2 0 0 0-.602.602m10.165-5.922A10.95 10.95 0 0 1 50.999 40c0 3.598-1.726 6.791-4.4 8.801a1.5 1.5 0 1 0 1.802 2.398A13.98 13.98 0 0 0 53.999 40c0-3.49-1.278-6.681-3.389-9.132zm-.062-4.181-2.105 2.105a1.5 1.5 0 0 1 2.105-2.105m7.567-3.324A23.4 23.4 0 0 1 61 40c0 7.686-3.69 14.51-9.4 18.8a1.5 1.5 0 1 0 1.8 2.4C59.835 56.367 64 48.67 64 40a26.4 26.4 0 0 0-5.879-16.643zm.118-4.36-2.121 2.12a24 24 0 0 0-2.385-2.052 1.5 1.5 0 0 1 1.802-2.4 27 27 0 0 1 2.704 2.331" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M60.356 21.5 22.5 59"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-broadcast_outline" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.914 4.978a1.05 1.05 0 0 1-.006 1.484A10.58 10.58 0 0 0 3.768 14c0 2.948 1.2 5.613 3.14 7.538A1.05 1.05 0 1 1 5.43 23.03 12.68 12.68 0 0 1 1.668 14c0-3.53 1.44-6.726 3.762-9.028a1.05 1.05 0 0 1 1.484.006M22.086 4.978a1.05 1.05 0 0 1 1.485-.006A12.68 12.68 0 0 1 27.332 14c0 3.53-1.44 6.726-3.761 9.03a1.05 1.05 0 0 1-1.48-1.492A10.58 10.58 0 0 0 25.233 14c0-2.947-1.2-5.613-3.14-7.538a1.05 1.05 0 0 1-.006-1.484" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.992 8.45a1.05 1.05 0 0 1 .048 1.485A5.93 5.93 0 0 0 8.435 14c0 1.543.584 3.044 1.514 4.083a1.05 1.05 0 1 1-1.564 1.4c-1.287-1.436-2.05-3.44-2.05-5.483 0-2.126.826-4.062 2.172-5.5a1.05 1.05 0 0 1 1.485-.05M19.01 8.45a1.05 1.05 0 0 1 1.484.05 8.03 8.03 0 0 1 2.173 5.5c0 2.043-.764 4.047-2.05 5.484a1.05 1.05 0 0 1-1.565-1.4c.931-1.04 1.515-2.54 1.515-4.084a5.93 5.93 0 0 0-1.605-4.065 1.05 1.05 0 0 1 .048-1.484" clip-rule="evenodd"/><path fill="currentColor" d="M16.835 14a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-burger-wide" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h22M1 12h22M1 19h22"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="22" fill="none" id="svg-name-burger-with-check-mark" class="svg-sprite__symbol"><mask id="a" width="26" height="22" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="currentColor" fill-rule="evenodd" d="M23 0H0v22h23V11.377l2.427-2.511a2.113 2.113 0 0 0 .021-2.871C24.943 5.452 23.872 4.993 23 5zm0 5c-.412.004-.78.111-1.023.364l-7.693 7.366-1.843-1.62c-.756-.786-2.9-.974-4.111.201s-1.1 3.093-.345 3.88l5.527 6.006L23 11.377z" clip-rule="evenodd"/></mask><g fill="currentColor" mask="url(#a)"><rect width="15.111" height="2.188" x="1" y="3" rx="1.094"/><rect width="15.111" height="2.188" x="1" y="8.25" rx="1.094"/><rect width="15.111" height="2.188" x="1" y="13.5" rx="1.094"/></g><path fill="currentColor" d="M11.127 12.368a1.25 1.25 0 0 0-1.754 1.781l4.534 4.463 7.59-7.471a1.25 1.25 0 1 0-1.753-1.782l-5.837 5.745z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-calendar-light" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M1 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm0 0h18"/><path fill="currentColor" d="M4.25 3a.75.75 0 0 0 1.5 0zm1.5-2a.75.75 0 0 0-1.5 0zm8.5 2a.75.75 0 0 0 1.5 0zm1.5-2a.75.75 0 0 0-1.5 0zm-10 2V1h-1.5v2zm10 0V1h-1.5v2z"/><path stroke="currentColor" stroke-width="1.5" d="M12 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" id="svg-name-calendar_check_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.5.75a.75.75 0 0 0-1.5 0v.257Q10.412.998 9.683 1H6.317q-.73-.002-1.32.007V.75a.75.75 0 0 0-1.5 0v.356a3.8 3.8 0 0 0-1.176.357A4.25 4.25 0 0 0 .463 3.321C.21 3.818.102 4.36.05 4.99 0 5.603 0 6.364 0 7.316v3.366c0 .952 0 1.713.05 2.327.052.63.16 1.172.413 1.67a4.25 4.25 0 0 0 1.858 1.857c.497.253 1.04.361 1.67.413.613.05 1.374.05 2.326.05h3.366c.952 0 1.713 0 2.327-.05.63-.052 1.172-.16 1.67-.413a4.25 4.25 0 0 0 1.857-1.857c.253-.498.361-1.04.413-1.67.05-.614.05-1.375.05-2.327V7.317c0-.952 0-1.713-.05-2.327-.052-.63-.16-1.172-.413-1.67a4.25 4.25 0 0 0-1.857-1.857 3.8 3.8 0 0 0-1.18-.357zm-9.002 2v-.12c-.202.044-.36.1-.496.17A2.75 2.75 0 0 0 1.8 4.002c-.128.25-.21.573-.255 1.11-.044.546-.045 1.246-.045 2.238v3.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 3.002 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 14.2 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238v-3.3c0-.992 0-1.692-.045-2.238-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 13 2.8a2 2 0 0 0-.499-.17v.12a.75.75 0 0 1-1.5 0v-.243A80 80 0 0 0 9.65 2.5h-3.3c-.526 0-.97 0-1.352.007v.243a.75.75 0 0 1-1.5 0m8.032 4.78a.75.75 0 0 0-1.06-1.06L7 9.94 5.53 8.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-calendar_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .75.75v.257Q7.588 1.998 8.317 2h3.366q.729-.002 1.317.007V1.75a.75.75 0 0 1 1.5 0v.356c.428.064.816.172 1.18.357a4.25 4.25 0 0 1 1.857 1.858c.253.497.361 1.04.413 1.67.05.613.05 1.374.05 2.326v3.366c0 .952 0 1.713-.05 2.327-.052.63-.16 1.172-.413 1.67a4.25 4.25 0 0 1-1.857 1.857c-.498.253-1.04.361-1.67.413-.614.05-1.375.05-2.327.05H8.317c-.952 0-1.713 0-2.327-.05-.63-.052-1.172-.16-1.67-.413a4.25 4.25 0 0 1-1.857-1.857c-.253-.498-.361-1.04-.413-1.67C2 13.396 2 12.635 2 11.683V8.317c0-.952 0-1.713.05-2.327.052-.63.16-1.172.413-1.67a4.25 4.25 0 0 1 1.858-1.857A3.8 3.8 0 0 1 5.5 2.106V1.75A.75.75 0 0 1 6.25 1M5.5 3.63c-.203.044-.361.1-.498.17A2.75 2.75 0 0 0 3.8 5.002c-.128.25-.21.573-.255 1.11-.02.255-.032.543-.038.878h12.986a14 14 0 0 0-.038-.878c-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 15 3.8a2 2 0 0 0-.499-.17v.12a.75.75 0 0 1-1.5 0v-.243a80 80 0 0 0-1.35-.007h-3.3c-.525 0-.968 0-1.35.007v.243a.75.75 0 0 1-1.5 0zm11 4.86h-13v3.16c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 5.002 16.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 16.2 15c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="14" fill="none" id="svg-name-cam" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 .998h5a4 4 0 0 1 4 4v.125l1.94-1.213A2 2 0 0 1 19 5.606V8.39a2 2 0 0 1-3.06 1.7L14 8.873v.125a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14 5.123v3.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-camera" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M5 3.999h5a4 4 0 0 1 4 4v.125l1.94-1.213A2 2 0 0 1 19 8.607v2.784a2 2 0 0 1-3.06 1.7L14 11.874v.125a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M7.5 11.999a2 2 0 1 1 0-4 2 2 0 0 1 0 4" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14 8.124v3.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-camera_off_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M26.5 19.5A1.5 1.5 0 0 1 28 18c5.523 0 10 4.477 10 10a1.5 1.5 0 0 1-3 0 7 7 0 0 0-7-7 1.5 1.5 0 0 1-1.5-1.5M6.128 14.424C4.758 16.284 4 18.774 4 21.437V34c0 .582.08 1.804.228 3.038.143 1.185.374 2.632.747 3.535.53 1.282 1.294 2.578 2.307 3.629 1.134 1.359 2.79 2.292 4.466 2.887 1.714.608 3.584.911 5.252.911h21c2.788 0 4.984-.348 6.798-1.08l3.641 3.64a1.5 1.5 0 0 0 2.122-2.12l-42-42a1.5 1.5 0 1 0-2.122 2.12l3.155 3.156c-1.389.524-2.568 1.488-3.466 2.708M12 14.28c-1.323 0-2.53.666-3.457 1.923C7.607 17.475 7 19.315 7 21.437V34c0 .418.066 1.51.207 2.68.147 1.222.346 2.276.54 2.747.422 1.02.998 1.98 1.772 2.772.823 1.006 2.026 1.634 3.233 2.062 1.386.492 2.916.739 4.248.739h21c1.83 0 3.263-.165 4.421-.457l-8.49-8.49A9.96 9.96 0 0 1 28 38c-5.523 0-10-4.477-10-10 0-2.22.724-4.272 1.948-5.931l-7.79-7.79zM21 28a7 7 0 0 0 7 7 6.96 6.96 0 0 0 3.775-1.104l-9.671-9.671A6.96 6.96 0 0 0 21 28" clip-rule="evenodd"/><path fill="currentColor" d="M22 5.5c-1.21 0-2.21.592-2.92 1.16-.724.578-1.326 1.28-1.74 1.773-.102.121-.198.248-.297.372a1.5 1.5 0 1 0 2.348 1.867l.254-.318c.407-.486.842-.979 1.308-1.352.482-.385.826-.502 1.047-.502h12c.221 0 .565.117 1.047.502.498.399.94.89 1.336 1.386l.43.542 1.015 1.273c.625.784 1.571 1.284 2.422 1.588a8.4 8.4 0 0 0 2.75.489h1c1.323 0 2.53.666 3.457 1.923.936 1.272 1.543 3.112 1.543 5.234V34c0 .495 0 1.43-.105 2.476-.107 1.069-.312 2.129-.663 2.909q-.159.353-.333.697a1.5 1.5 0 0 0 2.675 1.358q.209-.412.394-.825c.549-1.22.794-2.66.912-3.84.12-1.2.12-2.26.12-2.768v-12.57c0-2.664-.757-5.152-2.128-7.013C48.492 12.55 46.45 11.28 44 11.28h-1a5.4 5.4 0 0 1-1.742-.315c-.608-.217-.957-.473-1.086-.634l-.985-1.238-.527-.66c-.414-.493-1.016-1.195-1.74-1.774C36.21 6.092 35.21 5.5 34 5.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="16" fill="none" id="svg-name-camera_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.5 3.5c.574 0 1.009-.204 1.34-.521.243-.234.427-.536.553-.743l.055-.089c.15-.24.258-.382.391-.478.113-.082.297-.169.66-.169h3c.364 0 .548.087.66.169.133.096.242.238.392.478l.055.09c.126.206.31.508.554.742.33.317.765.521 1.34.521.732 0 .99.004 1.188.043a2.25 2.25 0 0 1 1.768 1.768c.04.2.043.456.043 1.189v3.45c0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.912a2.25 2.25 0 0 1-.983.983c-.198.1-.458.17-.912.207-.463.037-1.057.038-1.91.038h-6.9c-.853 0-1.448 0-1.91-.038-.454-.037-.715-.107-.912-.207a2.25 2.25 0 0 1-.984-.984c-.1-.197-.17-.458-.207-.912-.037-.462-.038-1.056-.038-1.909V6.501c0-.734.004-.991.043-1.19a2.25 2.25 0 0 1 1.767-1.768c.2-.04.457-.043 1.191-.043m3-3.5c-.637 0-1.14.163-1.543.456-.383.279-.619.637-.781.897l-.075.12c-.136.22-.207.334-.3.423-.06.058-.126.104-.302.104h-.087c-.614 0-1.033 0-1.397.072A3.75 3.75 0 0 0 .07 5.017c-.072.364-.072.783-.072 1.397v3.568c0 .813 0 1.469.043 2 .045.546.14 1.026.366 1.47a3.75 3.75 0 0 0 1.639 1.64c.444.226.924.32 1.47.365.532.043 1.187.043 2 .043h6.966c.812 0 1.468 0 1.999-.043.547-.045 1.027-.14 1.47-.366a3.75 3.75 0 0 0 1.64-1.638c.226-.445.32-.925.365-1.471.044-.531.044-1.187.043-2V6.413c0-.613 0-1.031-.072-1.395a3.75 3.75 0 0 0-2.946-2.946C14.617 2 14.2 2 13.586 2H13.5c-.175 0-.24-.046-.3-.104-.094-.09-.165-.204-.3-.422l-.076-.121c-.162-.26-.398-.618-.78-.897C11.638.163 11.135 0 10.498 0zm3.75 8.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m1.5 0a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" id="svg-name-cancel_12" class="svg-sprite__symbol"><path fill="currentColor" d="M1.525.464a.75.75 0 0 0-1.06 1.06L2.94 4 .465 6.474a.75.75 0 1 0 1.06 1.06L4 5.06l2.475 2.475a.75.75 0 0 0 1.06-1.06L5.062 3.998l2.475-2.475a.75.75 0 1 0-1.06-1.06L4 2.939z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_16" class="svg-sprite__symbol"><path fill="currentColor" d="M3.536 2.264a.9.9 0 0 0-1.272 1.272L6.727 8l-4.463 4.464a.9.9 0 0 0 1.272 1.272L8 9.273l4.464 4.463a.9.9 0 1 0 1.272-1.272L9.273 8l4.463-4.464a.9.9 0 1 0-1.272-1.272L8 6.727z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" id="svg-name-cancel_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.72 5.22a.75.75 0 0 1 1.06 0L10 9.44l4.22-4.22a.75.75 0 1 1 1.06 1.06l-4.22 4.22 4.22 4.22a.75.75 0 1 1-1.06 1.06L10 11.56l-4.22 4.22a.75.75 0 0 1-1.06-1.06l4.22-4.22-4.22-4.22a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-cancel_24" class="svg-sprite__symbol"><path fill="currentColor" d="M7.536 6.264a.9.9 0 0 0-1.272 1.272L10.727 12l-4.463 4.464a.9.9 0 0 0 1.272 1.272L12 13.273l4.464 4.463a.9.9 0 1 0 1.272-1.272L13.273 12l4.463-4.464a.9.9 0 1 0-1.272-1.272L12 10.727z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_circle_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0M4.563 4.564a.9.9 0 0 0 0 1.272L6.727 8l-2.164 2.164a.9.9 0 1 0 1.273 1.272L8 9.273l2.164 2.163a.9.9 0 0 0 1.272-1.272L9.273 8l2.163-2.164a.9.9 0 1 0-1.272-1.272L8 6.727 5.836 4.564a.9.9 0 0 0-1.273 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cancel_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.405 3.595a.57.57 0 0 1 0 .808L8.809 8l3.596 3.596c.206.206.222.53.047.754l-.047.054a.57.57 0 0 1-.808 0L8 8.808l-3.596 3.595a.57.57 0 0 1-.754.048l-.054-.048a.57.57 0 0 1 0-.808L7.192 8 3.597 4.403a.57.57 0 0 1-.048-.754l.048-.054a.57.57 0 0 1 .808 0L8 7.191l3.596-3.596a.57.57 0 0 1 .754-.047z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-card" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M17 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2ZM1 8h18"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-cart-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M16.287 5.858H6.726l-.337-1.333A.72.72 0 0 0 5.693 4H3.718A.7.7 0 0 0 3 4.7a.7.7 0 0 0 .718.7h1.414l1.773 6.885c.09.306.36.525.696.525h7.317a.72.72 0 0 0 .696-.525l1.37-5.53a.7.7 0 0 0-.136-.59.62.62 0 0 0-.56-.307"/><path fill="url(#c)" d="M8.589 16c.694 0 1.257-.549 1.257-1.225s-.563-1.224-1.257-1.224-1.257.548-1.257 1.224.563 1.224 1.257 1.224"/><path fill="url(#d)" d="M13.571 16c.694 0 1.257-.549 1.257-1.225s-.562-1.224-1.257-1.224-1.256.548-1.256 1.224.562 1.224 1.256 1.224"/><defs><linearGradient id="a" x1="1.5" x2="25" y1="22.5" y2="-5" gradientUnits="userSpaceOnUse"><stop stop-color="#7603D0"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="b" x1="1" x2="8" y1="8.405" y2=".092" gradientUnits="userSpaceOnUse"><stop stop-color="#822CE3"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient><linearGradient id="c" x1="6.973" x2="8.88" y1="14.775" y2="13.312" gradientUnits="userSpaceOnUse"><stop stop-color="#6C0ED5"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient><linearGradient id="d" x1="11.955" x2="13.862" y1="14.775" y2="13.312" gradientUnits="userSpaceOnUse"><stop stop-color="#6C0ED5"/><stop offset=".847" stop-color="#4BA2FF"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-casino-dices" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M21.25 36.25H8.75c-2.75 0-5-2.25-5-5v-12.5c0-2.75 2.25-5 5-5h12.5c2.75 0 5 2.25 5 5v12.5c0 2.75-2.25 5-5 5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M15 26.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M10 21.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 31.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M10 31.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M13.75 13.75v-5c0-2.75 2.25-5 5-5h12.5c2.75 0 5 2.25 5 5v12.5c0 2.75-2.25 5-5 5h-5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M30 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 21.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chart" class="svg-sprite__symbol"><path fill="currentColor" d="M17.073 19a.75.75 0 0 0 1.5 0zm1.5-15a.75.75 0 0 0-1.5 0zM6.786 19a.75.75 0 0 0 1.5 0zm1.5-15a.75.75 0 0 0-1.5 0zm3.644 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zM1.645 19a.75.75 0 0 0 1.5 0zm1.5-7a.75.75 0 0 0-1.5 0zm15.428 7V4h-1.5v15zM8.286 19V4h-1.5v15zm5.144 0V9h-1.5v10zM3.145 19v-7h-1.5v7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chat" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m13.58 4.563-.194 1.255q.353.054.69.15a6.7 6.7 0 0 0-.497-1.405m-5.025 11.12a5.77 5.77 0 0 0 5.249 1.418c.35-.103.753-.077 1.083-.031.37.052.777.148 1.173.26.314.09.632.19.935.294a7 7 0 0 1-.145-.41 4 4 0 0 1-.195-.924c-.022-.297-.002-.678.2-1.018l.03-.052.038-.046A5.72 5.72 0 0 0 18.25 11.5a5.75 5.75 0 0 0-2.535-4.768 8.2 8.2 0 0 0-.413-1.92 7.252 7.252 0 0 1 2.85 11.23 1 1 0 0 0-.001.136q.017.227.128.581c.15.468.39.976.587 1.354a.965.965 0 0 1-.14 1.09.96.96 0 0 1-1.073.262c-.509-.2-1.277-.486-2.001-.691a8 8 0 0 0-.972-.218 2 2 0 0 0-.332-.026.6.6 0 0 0-.115.01v-.001l-.03.01-.03.007a7.3 7.3 0 0 1-1.673.194 7.24 7.24 0 0 1-5.91-3.05 8.4 8.4 0 0 0 1.965-.017M7.449 14.25a6 6 0 0 1-.259-.539l-.991.414q.609.12 1.25.125" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="1.5" d="M14 7.5a6.5 6.5 0 0 1-8 6.326c-.748-.244-2.892.533-3.928.94-.18.072-.363-.134-.273-.306.409-.784 1.054-2.208.701-2.806A6.5 6.5 0 1 1 14 7.5Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chatbot" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.049a2 2 0 0 0-1.993-2L4.007 3.007a2 2 0 0 0-2.007 2V18l3-3h10.984a2 2 0 0 0 2-2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.252h8.5M5.75 10.752h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-check" class="svg-sprite__symbol"><path fill="currentColor" d="M4.474 11.62a1 1 0 0 0-.948 1.76zM10.5 16l-.474.88a1 1 0 0 0 1.383-.463zm6.41-11.583a1 1 0 0 0-1.82-.834zM3.525 13.38l6.5 3.5.948-1.761-6.5-3.5zm7.883 3.036 5.5-12-1.818-.834-5.5 12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-check-round" class="svg-sprite__symbol"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="3"/><path fill="currentColor" d="M14.587 21.62a1.5 1.5 0 1 0-1.174 2.76zM21.05 26l-.587 1.38a1.5 1.5 0 0 0 1.974-.808zm6.337-11.428a1.5 1.5 0 0 0-2.774-1.144zM13.413 24.38l7.05 3 1.174-2.76-7.05-3zm9.024 2.192 4.95-12-2.774-1.144-4.95 12z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.53 5.22a.75.75 0 0 1 0 1.06l-9.5 9.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.97 3.97 8.97-8.97a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_box_off_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.046 2.534C4.788 2.138 5.517 2 7.128 2h5.744c1.61 0 2.34.138 3.082.534.65.348 1.164.862 1.512 1.512.396.742.534 1.471.534 3.082v5.744c0 1.61-.138 2.34-.534 3.082a3.64 3.64 0 0 1-1.512 1.512c-.742.396-1.472.534-3.082.534H7.128c-1.61 0-2.34-.138-3.082-.534a3.64 3.64 0 0 1-1.512-1.512C2.138 15.212 2 14.482 2 12.872V7.128c0-1.61.138-2.34.534-3.082a3.65 3.65 0 0 1 1.512-1.512m3.082.966c-1.531 0-1.962.136-2.374.357a2.15 2.15 0 0 0-.897.897c-.22.412-.357.843-.357 2.374v5.744c0 1.531.136 1.962.357 2.374q.313.585.897.897c.412.22.843.357 2.374.357h5.744c1.531 0 1.962-.136 2.374-.357q.585-.313.897-.897c.22-.412.357-.843.357-2.374V7.128c0-1.531-.136-1.962-.357-2.374a2.15 2.15 0 0 0-.897-.897c-.412-.22-.843-.357-2.374-.357z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-check_box_on_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.436 4.184C2 5.04 2 6.16 2 8.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 18 6.16 18 8.4 18h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C18 14.96 18 13.84 18 11.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C14.96 2 13.84 2 11.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748m12.2 3.803a.9.9 0 1 0-1.272-1.274l-4.673 4.665-2.055-2.052A.9.9 0 0 0 5.364 10.6l2.691 2.687a.9.9 0 0 0 1.272 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-check_circle_on_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m6.207-14.793a1 1 0 0 0-1.414-1.414L10 14.586l-2.793-2.793a1 1 0 0 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-check_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M14.965 9.263a.9.9 0 0 1 1.273 1.273l-4.6 4.6a.9.9 0 0 1-1.273 0l-2.6-2.6a.9.9 0 0 1 1.272-1.273l1.964 1.964z"/><path fill="currentColor" fill-rule="evenodd" d="M12.001 2.1c5.467 0 9.9 4.432 9.9 9.9 0 5.467-4.433 9.9-9.9 9.9s-9.9-4.433-9.9-9.9 4.433-9.9 9.9-9.9m0 1.8a8.1 8.1 0 0 0-8.1 8.1 8.1 8.1 0 0 0 8.1 8.1 8.1 8.1 0 0 0 8.1-8.1 8.1 8.1 0 0 0-8.1-8.1" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-check_circle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M28 4c13.255 0 24 10.745 24 24S41.255 52 28 52 4 41.255 4 28 14.745 4 28 4m0 3C16.402 7 7 16.402 7 28s9.402 21 21 21 21-9.402 21-21S39.598 7 28 7m8.94 13.94a1.5 1.5 0 0 1 2.12 2.12l-14 14a1.5 1.5 0 0 1-2.12 0l-7-7a1.5 1.5 0 0 1 2.12-2.12L24 33.878z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-check_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.782 4.722a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0L3.22 9.281a.75.75 0 0 1 1.06-1.06l1.971 1.97 5.47-5.47a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-check_shield_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M13.484 1.502c.35-.05.682-.05 1.032 0 .345.05.633.127 1.296.348l6.82 2.274A2 2 0 0 1 24 6.02v9.28c0 4.794-2.878 8.466-8.458 10.942l-.368.16a3 3 0 0 1-2.348 0C7.007 23.928 4 20.202 4 15.3V6.02a2 2 0 0 1 1.368-1.896l7.008-2.336c.533-.174.797-.241 1.108-.286m.75 1.98a1.6 1.6 0 0 0-.467 0c-.2.029-.389.08-.947.266L6 6.02v9.28c0 4.015 2.471 7.077 7.609 9.26.25.107.532.107.775.004l.354-.154C19.641 22.236 22 19.226 22 15.301V6.02l-6.977-2.325a6 6 0 0 0-.668-.193z"/><path fill="currentColor" d="M19.057 10.693a1 1 0 0 0-1.414 0l-4.893 4.893-1.893-1.893a1 1 0 0 0-1.414 1.414l2.6 2.6a1 1 0 0 0 1.414 0l5.6-5.6a1 1 0 0 0 0-1.414"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-check_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.924 3c1.958.02 2.955.232 3.988.784a5.54 5.54 0 0 1 2.3 2.3c.553 1.034.764 2.03.785 3.989v7.851c-.021 1.958-.232 2.955-.785 3.988a5.54 5.54 0 0 1-2.3 2.3c-1.033.553-2.03.764-3.988.785h-7.851c-1.959-.021-2.955-.232-3.988-.785a5.54 5.54 0 0 1-2.3-2.3c-.553-1.033-.764-2.03-.785-3.988v-7.851c.02-1.959.232-2.955.784-3.988a5.54 5.54 0 0 1 2.3-2.3c1.034-.553 2.03-.764 3.989-.785zm-.335 1.998h-7.181l-.557.005c-1.48.028-2.142.18-2.823.545-.64.343-1.137.84-1.48 1.48-.364.681-.517 1.343-.545 2.823l-.005.557v7.18l.005.558c.028 1.48.18 2.142.545 2.823.343.64.84 1.137 1.48 1.48.681.364 1.343.516 2.823.544l.557.005h7.18l.558-.005c1.48-.028 2.142-.18 2.823-.544a3.54 3.54 0 0 0 1.48-1.48c.364-.681.516-1.344.544-2.823l.005-.557v-7.181l-.005-.557c-.028-1.48-.18-2.142-.544-2.823a3.54 3.54 0 0 0-1.48-1.48c-.681-.364-1.344-.517-2.823-.545zm.054 5.695a1 1 0 0 1 1.414 1.414l-5.6 5.6a1 1 0 0 1-1.414 0l-2.6-2.6a1 1 0 1 1 1.414-1.414l1.893 1.893z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="7" height="10" fill="none" id="svg-name-chevron_16" class="svg-sprite__symbol"><path fill="currentColor" d="M4.227 5 .864 1.636A.9.9 0 1 1 2.136.364l4 4a.9.9 0 0 1 0 1.272l-4 4A.9.9 0 1 1 .864 8.364z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-chevron_down_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M7.65 11.24a1 1 0 1 0-1.3 1.52l7 6a1 1 0 0 0 1.3 0l7-6a1 1 0 0 0-1.3-1.52L14 16.684z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-chevron_left_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="m8.414 12 7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 1 1 1.414 1.414z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chevron_left_small_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.28 14.78a.75.75 0 0 0 0-1.06L8.56 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L6.97 9.47a.75.75 0 0 0 0 1.06l4.25 4.25a.75.75 0 0 0 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-chevron_right_outline_20" class="svg-sprite__symbol"><path fill="#76787A" fill-rule="evenodd" d="M12.53 15.783a.75.75 0 0 0 0-1.061L7.815 10l4.717-4.722a.75.75 0 0 0-1.062-1.06L6.224 9.47a.75.75 0 0 0 0 1.06l5.245 5.252a.75.75 0 0 0 1.061 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-chevron_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M20.35 16.76a1 1 0 1 0 1.3-1.52l-7-6a1 1 0 0 0-1.3 0l-7 6a1 1 0 0 0 1.3 1.52L14 11.316z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-circle-arrow" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 10a8 8 0 1 1-2.708-6"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 2v3h-3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-clapperboard" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m4.763 4.3 12.106-2.442c.426-.086.793-.16 1.135-.14a2.57 2.57 0 0 1 2.14 1.424c.193.388.257.83.342 1.252.04.197.09.438.075.67a1.71 1.71 0 0 1-.948 1.427c-.22.11-.464.154-.703.202l-9.318 1.88h9.637c.216 0 .427 0 .605.014.196.016.427.054.66.173.322.164.584.426.748.749.118.232.156.464.172.66.015.178.015.388.014.605v5.72c0 .69 0 1.26-.037 1.723-.04.482-.124.925-.336 1.34a3.43 3.43 0 0 1-1.497 1.5c-.416.211-.858.296-1.34.335-.464.038-1.033.038-1.722.038H7.517c-.69 0-1.259 0-1.722-.038-.482-.04-.924-.124-1.34-.336a3.43 3.43 0 0 1-1.497-1.498c-.212-.416-.297-.86-.336-1.34-.038-.465-.038-1.034-.038-1.724v-5.72c0-.216 0-.427.015-.605.016-.196.053-.428.172-.66q.07-.136.161-.258a1.7 1.7 0 0 1-.426-.545c-.123-.249-.165-.527-.22-.797-.086-.427-.16-.795-.14-1.136.058-.917.6-1.733 1.423-2.142.37-.184.791-.25 1.194-.33m.339 1.681c-.575.116-.696.148-.772.186a.86.86 0 0 0-.474.714c-.005.084.013.208.128.783.028.138.044.213.057.268l.002.008.01-.001c.055-.009.13-.024.268-.051l14.25-2.876c.138-.028.213-.043.268-.057l.008-.002v-.009a7 7 0 0 0-.052-.268c-.116-.575-.148-.697-.186-.772a.86.86 0 0 0-.713-.475c-.084-.005-.208.013-.783.129zm-.795 4.316v.011c-.009.1-.01.24-.01.493v5.657c0 .735.001 1.234.032 1.62.031.375.087.567.155.701.164.323.426.585.749.75.134.068.326.124.701.154.386.032.885.033 1.618.033h8.909c.733 0 1.232-.001 1.617-.033.376-.03.568-.086.702-.154.322-.165.584-.427.749-.75.068-.134.124-.326.154-.701.032-.386.032-.885.032-1.62v-5.657c0-.254 0-.393-.008-.493l-.001-.011-.012-.001a7 7 0 0 0-.492-.009H4.811c-.255 0-.394 0-.494.009zm6.64 2.202a.43.43 0 0 0-.231-.068.42.42 0 0 0-.423.416v4.31q0 .118.063.219a.426.426 0 0 0 .582.135l3.438-2.09a.412.412 0 0 0 .01-.702z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-clapperboard_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m5.557 5.016 14.123-2.85c.497-.1.926-.188 1.324-.163 1.07.068 2.021.7 2.497 1.66.225.454.3.969.399 1.461.047.23.105.512.088.782a2 2 0 0 1-1.106 1.665c-.257.128-.542.18-.82.236L11.192 10h11.242c.252 0 .497 0 .706.017.228.019.497.063.769.2a2 2 0 0 1 .873.875c.138.271.182.541.201.77.017.208.017.454.017.706v6.673c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.747 1.748c-.485.247-1 .346-1.563.392-.54.044-1.204.044-2.009.044H8.77c-.805 0-1.469 0-2.01-.044-.561-.046-1.078-.145-1.563-.392a4 4 0 0 1-1.746-1.748c-.248-.485-.346-1.002-.392-1.564-.044-.541-.044-1.206-.044-2.01v-6.674c0-.252 0-.498.017-.706.018-.229.063-.499.2-.77q.082-.16.19-.3a2 2 0 0 1-.498-.636c-.144-.29-.193-.616-.257-.93-.1-.498-.188-.928-.163-1.326a3 3 0 0 1 1.66-2.499c.433-.215.923-.29 1.393-.385m.395 1.96c-.67.136-.812.173-.9.217a1 1 0 0 0-.553.833c-.006.098.014.243.15.914.032.16.05.248.066.312l.002.01.01-.002c.065-.01.153-.027.314-.06l16.626-3.354c.16-.032.248-.05.311-.066l.01-.003v-.01a8 8 0 0 0-.06-.314c-.136-.67-.173-.812-.217-.9a1 1 0 0 0-.832-.554c-.098-.006-.243.015-.914.15zm-.927 5.035-.001.014c-.01.116-.01.278-.01.575v6.6c0 .856 0 1.439.037 1.889.036.438.1.662.18.819a2 2 0 0 0 .874.874c.156.08.38.145.818.18.45.037 1.032.038 1.888.038h10.393c.856 0 1.438 0 1.888-.038.438-.035.662-.1.818-.18a2 2 0 0 0 .874-.874c.08-.157.144-.38.18-.82.037-.45.037-1.032.037-1.888v-6.6c0-.297 0-.459-.01-.575l-.001-.014h-.013a8 8 0 0 0-.575-.011H5.613c-.296 0-.458 0-.575.01zm7.747 2.57a.5.5 0 0 0-.27-.08.49.49 0 0 0-.493.485v5.03c0 .09.025.178.073.254.143.228.447.3.679.158l4.01-2.438a.481.481 0 0 0 .011-.82z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-clock" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M9.25 10a.75.75 0 0 0 1.5 0zm1.5-5a.75.75 0 0 0-1.5 0zm0 5V5h-1.5v5z"/><path fill="currentColor" d="M12.455 11.88a.75.75 0 1 0 .596-1.375zm-2.157-2.568a.75.75 0 1 0-.596 1.376zm2.753 1.193-2.753-1.193-.596 1.376 2.752 1.193z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-clock-rewind" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10a9 9 0 1 1-9-9c2.283 0 4.367.85 5.953 2.25L17.5 5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 2v3h-3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M10 10V5M12.753 11.191 10 10"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-clock-wise" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.911 6.164v3.412h3.267"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-clock_circle_dashed_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="m11.75 2.634.01.001a8.4 8.4 0 0 1 3.126.918l.01.005a8.4 8.4 0 0 1 1.377.903l.009.008a8.4 8.4 0 0 1 2.085 2.496l.007.012a8.4 8.4 0 0 1 .643 1.515l.004.013a8.4 8.4 0 0 1 .347 3.232l-.001.014a8.4 8.4 0 0 1-.307 1.618l-.003.011a8.4 8.4 0 0 1-1.511 2.885l-.006.008a8.4 8.4 0 0 1-1.154 1.174l-.008.007a8.4 8.4 0 0 1-2.863 1.562l-.006.002a8.4 8.4 0 0 1-1.461.317h-.006l-.145.018a.9.9 0 1 0 .192 1.79 10 10 0 0 0 .962-.15A10.2 10.2 0 0 0 11.001.8h-.09a.9.9 0 0 0 .016 1.8 8 8 0 0 1 .824.033M1.693 10.182a.9.9 0 0 1 .908.892q.003.414.047.823a.9.9 0 0 1-1.79.192q-.052-.496-.057-1a.9.9 0 0 1 .892-.907M3.627 15.025a.9.9 0 0 0-1.58.862 10.2 10.2 0 0 0 1.125 1.653.9.9 0 1 0 1.382-1.154 8.4 8.4 0 0 1-.927-1.361M5.89 18.823a.9.9 0 0 1 1.215-.38 8.4 8.4 0 0 0 1.527.617.9.9 0 1 1-.507 1.727 10.2 10.2 0 0 1-1.854-.749.9.9 0 0 1-.38-1.215"/><path fill="currentColor" d="M11.4 7a.9.9 0 0 0-1.8 0v4.433a.9.9 0 0 0 .525.817l4.5 2.069a.9.9 0 0 0 .751-1.636L11.4 10.856z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-clock_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 2c6.626 0 12 5.372 12 12s-5.374 12-12 12C7.372 26 2 20.628 2 14S7.372 2 14 2m0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.478 10-10S19.522 4 14 4m-.5 4a1 1 0 0 1 1 1v5.104l4.875 1.969a1 1 0 0 1-.75 1.854l-5.5-2.222a1 1 0 0 1-.625-.927V9a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" stroke-width="2" viewBox="0 0 25 25" id="svg-name-close" class="svg-sprite__symbol"><path fill="none" stroke="currentColor" d="m12.5 12.5-8.839 8.839L12.5 12.5 3.661 3.661 12.5 12.5l8.839-8.839L12.5 12.5l8.839 8.839z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" id="svg-name-close-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 6 12 12M18 6 6 18"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-close-thick" class="svg-sprite__symbol"><path fill="#F5F5F7" fill-rule="evenodd" d="M13.42 15.559c.59.59 1.547.59 2.138 0 .59-.591.59-1.548 0-2.139L10.138 8l5.419-5.42a1.51 1.51 0 0 0 0-2.137 1.51 1.51 0 0 0-2.137 0L8 5.863 2.58.443a1.51 1.51 0 0 0-2.137 0 1.51 1.51 0 0 0 0 2.138L5.862 8l-5.42 5.42a1.515 1.515 0 0 0 0 2.138c.591.59 1.548.59 2.139 0L8 10.139z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-clown-reaction" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M14.7 29.335c7.039 0 12.744-5.706 12.744-12.744S21.739 3.848 14.701 3.848 1.957 9.553 1.957 16.59s5.706 12.744 12.744 12.744Z"/><path fill="url(#c)" d="M14.7 29.335c7.039 0 12.744-5.706 12.744-12.744S21.739 3.848 14.701 3.848 1.957 9.553 1.957 16.59s5.706 12.744 12.744 12.744Z" opacity=".5"/><path fill="url(#d)" d="M26.09 18.738c-.232-1.043-.9-1.856-1.84-2.246l-.04-.016a2.8 2.8 0 0 0-.765-.183 1.02 1.02 0 0 1-.916-1.012v-.016c0-2.405-1.609-4.285-3.656-4.285-1.003 0-1.935.454-2.628 1.275a1.42 1.42 0 0 1-1.179.502 5 5 0 0 0-.709 0 1.41 1.41 0 0 1-1.179-.502c-.685-.82-1.617-1.275-2.628-1.275-2.055 0-3.656 1.88-3.656 4.285v.016c0 .526-.398.956-.924 1.012a2.7 2.7 0 0 0-.756.183c-.964.382-1.65 1.203-1.888 2.262-.2.868-.08 1.872.35 3.067l.048.127c.542 1.274 1.561 3.114 3.314 4.635 2.094 1.824 4.675 2.748 7.67 2.748 2.986 0 5.559-.924 7.662-2.748 1.752-1.52 2.771-3.36 3.32-4.635l.057-.135c.422-1.187.533-2.19.342-3.059Z"/><path fill="url(#e)" d="M14.7 20.648c-1.578 0-2.868-1.075-2.963-2.43 0 .049-.008.104-.008.152 0 1.426 1.202 2.804 2.97 2.804 1.784 0 2.971-1.394 2.971-2.82q.002-.07-.008-.143c-.087 1.362-1.378 2.437-2.963 2.437Z"/><path fill="url(#f)" d="M23.31 18.747a.47.47 0 0 0-.295-.016 30.4 30.4 0 0 1-8.307 1.154c-2.82 0-5.615-.39-8.307-1.154a.42.42 0 0 0-.295.015c-.295.12-.749.558-.143 2.239.916 2.142 3.297 5.91 8.753 5.91 5.432 0 7.83-3.776 8.745-5.918.598-1.673.136-2.111-.151-2.23"/><path fill="url(#g)" d="M14.7 26.301c2.255 0 3.95-.693 5.217-1.64-1.394-.63-3.106-1.044-5.217-1.044s-3.83.414-5.224 1.044c1.274.947 2.97 1.64 5.224 1.64"/><path fill="url(#h)" d="M23.142 18.703c-.016 0-.04 0-.056.008a30.3 30.3 0 0 1-8.379 1.179c-2.851 0-5.67-.398-8.379-1.179-.016-.008-.04-.008-.055-.008-.184.016-1.06.2-.311 2.278a10.7 10.7 0 0 0 1.935 3.035c-.892-1.06.208-1.65 2.175-1.41 1.967.239 4.643.239 4.643.239s2.684-.008 4.644-.24c1.967-.238 3.066.351 2.174 1.41.956-1.043 1.561-2.166 1.935-3.034.733-2.079-.143-2.262-.326-2.278"/><path fill="url(#i)" d="M18.865 17.24c.735 0 1.33-.898 1.33-2.006 0-1.109-.595-2.007-1.33-2.007-.734 0-1.33.898-1.33 2.007s.596 2.007 1.33 2.007Z"/><path fill="#1300E3" d="M18.865 16.563c-.573 0-1.067-.494-1.33-1.227.016 1.083.605 1.96 1.33 1.96s1.314-.877 1.33-1.96c-.262.733-.764 1.226-1.33 1.226Z"/><path fill="url(#j)" d="M10.543 17.265c.744 0 1.346-.91 1.346-2.03 0-1.123-.602-2.032-1.346-2.032-.743 0-1.346.91-1.346 2.031 0 1.122.603 2.031 1.346 2.031"/><path fill="#1300E3" d="M10.543 16.524c.582 0 1.084-.502 1.346-1.243-.016 1.1-.613 1.984-1.346 1.984-.732 0-1.33-.885-1.346-1.984.263.741.773 1.243 1.346 1.243"/><path fill="url(#k)" d="M17.524 9.816c.032-.51.598-.796 1.546-.748.804.047 2.548.59 3.68 2.222.206.303-.144.438-.36.239-.716-.677-2.675-1.61-4.252-1.53-.63.048-.614-.183-.614-.183"/><path fill="url(#l)" d="M11.878 9.824c-.032-.51-.598-.796-1.545-.749-.805.048-2.549.59-3.68 2.223-.207.302.143.438.358.239.717-.677 2.677-1.61 4.254-1.53.62.048.613-.183.613-.183"/><path fill="red" d="M23.31 18.747a.47.47 0 0 0-.295-.016 30.4 30.4 0 0 1-8.307 1.154c-2.82 0-5.615-.39-8.307-1.154a.42.42 0 0 0-.295.015c-.295.12-.749.558-.143 2.239.916 2.142 3.297 5.91 8.753 5.91 5.432 0 7.83-3.776 8.745-5.918.598-1.673.136-2.111-.151-2.23m-.749 1.887c-.86 2-3.026 5.313-7.86 5.313-4.804 0-6.962-3.25-7.838-5.25l-.016-.039a4.5 4.5 0 0 1-.231-.868 31.3 31.3 0 0 0 16.152 0c-.008.183-.071.454-.207.844"/><path fill="url(#m)" d="M22.354 20.227a31.7 31.7 0 0 1-15.308 0q.046.141.103.318l.008.024c.136.31.311.661.526 1.027l.096.024a33 33 0 0 0 6.921.741c2.334 0 4.66-.247 6.921-.74l.088-.024c.223-.39.406-.757.55-1.092a2 2 0 0 0 .095-.278"/><path fill="url(#n)" d="M12.175 19.785a2.9 2.9 0 0 0 1.02 1.028c.501.024 1.003.04 1.505.04.501 0 1.003-.017 1.505-.04a2.9 2.9 0 0 0 1.02-1.028 30 30 0 0 1-2.525.104c-.845 0-1.68-.032-2.525-.104"/><path fill="url(#o)" d="M14.7 20.642c1.64 0 2.97-1.156 2.97-2.581s-1.33-2.58-2.97-2.58-2.971 1.155-2.971 2.58 1.33 2.58 2.97 2.58Z"/><path fill="url(#p)" d="M15.296 16.28c.247.566-.223 1.322-1.068 1.697-.844.374-1.72.223-1.975-.343-.247-.565.223-1.322 1.067-1.696.845-.375 1.729-.216 1.976.342"/><path fill="url(#q)" d="M2.187 14.213c.693 0 .175-1.418 1.6-2.509.845-.645.957-1.999.957-1.999.23-.096.525-.287.812-.526-.04-1.274-2.095-1.465-3.21-1.282-1.234.2-2.23-.542-2.23-.542-.279 2.692-.08 3.011.86 4.373 0 .008 0 2.079 1.21 2.485Z"/><path fill="url(#r)" d="M1.645 8.361s-.446 3.01 2.453 2.453a2.25 2.25 0 0 1 .653-1.107c.23-.095.526-.287.812-.525-.047-1.275-2.102-1.466-3.217-1.283-.287.048-.558.04-.813.008 0 0 .112.128.112.454"/><path fill="url(#s)" d="M6.647 7.263c.287-.43.812-.78 1.394-.923.852-.216 1.274-.956 1.226-1.275-.709-1.234-3.114-1.147-3.4-2.182-.614.948-1.681 2.27-1.084 4.046.207.613.637.534 1.864.334"/><path fill="url(#t)" d="M6.783 5.612c-.191-.462-.749-1.075-1.856-1.155-.31.7-.47 1.521-.143 2.47.207.604.637.533 1.863.334.287-.43.813-.78 1.394-.924-.008 0-1.043-.183-1.258-.725"/><path fill="url(#u)" d="M1.883 9.033c.104 1.298 1.442 2.095 2.613 1.657.207-.518.247-.988.247-.988.581-.239 1.648-1.115 1.672-1.808.016-.358.223-.717.55-1.003-.151-.128-.335-.414-.542-.972-.637-1.68-2.843-1.37-5.033-1.163 1.306 2.509.374 2.772.493 4.277"/><path fill="url(#v)" d="M3 12.628s-.287.438-.996.048-.223-1.8-.717-2.15C.1 9.696.117 7.355.117 7.355c-.28 2.691-.08 3.01.86 4.372 0 0 0 2.079 1.21 2.485.502 0 .366-.749.812-1.585Z"/><path fill="url(#w)" d="M1.883 9.035c.104 1.298 1.442 2.095 2.613 1.656.207-.517.247-.987.247-.987-1.06-.128-2.198-.478-1.928-1.872.414-2.11-1.425-3.074-1.425-3.074 1.306 2.509.374 2.772.493 4.277"/><path fill="url(#x)" d="M6.965 6.898c-.151-.127-.335-.414-.542-.971C5.786 4.238 3.58 4.549 1.39 4.756c0 0 2.82-.255 3.687.47.86.732.144 2.676 1.338 2.676.016-.367.223-.717.55-1.004"/><path fill="url(#y)" d="M7.021 4.181c1.235.239 1.991 1.29 1.736 1.792.367-.303.534-.7.51-.908-.709-1.234-3.114-1.147-3.4-2.182 0 0-.08 1.06 1.154 1.298"/><path fill="url(#z)" d="M27.22 14.212c-.692 0-.175-1.418-1.6-2.509-.845-.645-.956-1.999-.956-1.999-.231-.095-.526-.287-.812-.525.047-1.283 2.094-1.466 3.21-1.29 1.234.198 2.938.15 2.938.15-.334 2.685-.629 2.318-1.569 3.68 0 .016 0 2.087-1.21 2.493Z"/><path fill="url(#A)" d="M25.31 10.814c2.898.55 2.452-2.453 2.452-2.453-.032-.239.128-.295.128-.366a13 13 0 0 1-.829-.096c-1.115-.183-3.162.008-3.21 1.29.287.24.582.43.813.526 0-.008.494.43.645 1.1Z"/><path fill="url(#B)" d="M22.759 7.259c-.287-.43-.813-.78-1.394-.924-.852-.215-1.274-.956-1.227-1.274.71-1.235 3.314-.988 3.784-1.952.438 1.044 1.298 2.047.7 3.815-.206.614-.637.534-1.863.335"/><path fill="url(#C)" d="M22.624 5.612c.19-.462.748-1.075 1.855-1.155.311.7.47 1.521.144 2.47-.207.604-.637.533-1.864.334-.287-.43-.812-.78-1.394-.924 0 0 1.036-.183 1.259-.725"/><path fill="url(#D)" d="M27.523 9.036c-.104 1.299-1.442 2.095-2.613 1.657a3.8 3.8 0 0 1-.246-.988c-.582-.239-1.65-1.115-1.673-1.808-.016-.358-.223-.716-.55-1.003.152-.128.335-.414.542-.972.63-1.688 2.222-1.434 4.412-1.649-.804 2.716.247 3.258.128 4.763"/><path fill="url(#E)" d="M26.407 12.63s.287.439.996.048c.709-.39.223-1.8.717-2.15C29.306 9.699 30 8.05 30 8.05c-.335 2.684-.63 2.317-1.57 3.68 0 0 0 2.078-1.21 2.485-.502 0-.367-.75-.813-1.585"/><path fill="url(#F)" d="M27.523 9.036c-.103 1.298-1.441 2.095-2.612 1.657a3.9 3.9 0 0 1-.247-.988c1.06-.127 2.198-.478 1.927-1.871-.414-2.111.805-3.553.805-3.553-.805 2.708.247 3.25.127 4.755"/><path fill="url(#G)" d="M22.441 6.902c.152-.128.335-.415.542-.972.63-1.689 2.222-1.434 4.412-1.649 0 0-2.206.223-3.066.956s-.143 2.668-1.338 2.668c-.016-.366-.231-.717-.55-1.003"/><path fill="url(#H)" d="M22.56 4.352c-1.25.064-2.166 1.115-1.911 1.617-.367-.303-.534-.701-.51-.908.709-1.235 3.313-.988 3.783-1.952 0 0 .24 1.163-1.362 1.243"/><path fill="url(#I)" d="M20.865 5.627c0 .82-2.317 1.808-6.156 1.808-3.84 0-6.157-1.067-6.157-1.888V4.91c.717-.66 2.86-.374 6.157-.374 3.456 0 5.615-.335 6.156.374z"/><path fill="url(#J)" d="M20.865 4.914c0 .82-2.317 1.649-6.156 1.649-3.84 0-6.157-.829-6.157-1.649s2.318-2.047 6.157-2.047 6.156 1.227 6.156 2.047"/><path fill="url(#K)" d="M18.954 4.917c0 .558-1.465 1.02-4.245 1.02-2.788 0-4.245-.454-4.245-1.02 0-2.214.66-4.26 4.245-4.26 3.576 0 4.245 2.046 4.245 4.26"/><path fill="url(#L)" d="M8.528 5.648c-.04.048-.064.072-.072.088a1 1 0 0 1 .072-.088"/><path fill="url(#M)" d="m8.552 5.621-.025.025c.009 0 .017-.017.025-.025"/><path fill="url(#N)" d="m8.45 5.73-.01.01c0 .01.01 0 .01-.01"/><path fill="url(#O)" d="M20.706 6.02c-.582.717-2.74 1.426-6.006 1.426-3.193 0-5.336-.733-5.965-1.458q-.058.048-.128.096c.39 1.314 2.438 2.222 6.093 2.222 3.72 0 5.775-.868 6.11-2.214q-.058-.036-.104-.072"/><path fill="url(#P)" d="M14.7 4.741c-2.709 0-4.134-.613-4.142-1.17-.08.43-.112.883-.112 1.353 0 .558 1.466 1.012 4.245 1.012s4.262-.454 4.262-1.012c0-.462-.032-.924-.112-1.354 0 .566-1.434 1.171-4.142 1.171Z"/></g><defs><linearGradient id="h" x1="23.647" x2="5.866" y1="21.361" y2="21.361" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset=".5" stop-color="#512D00"/><stop offset="1" stop-color="#3C2200"/></linearGradient><linearGradient id="k" x1="20.172" x2="20.172" y1="7.923" y2="10.196" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="l" x1="9.229" x2="9.229" y1="7.931" y2="10.204" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="q" x1=".185" x2="5.063" y1="6.105" y2="13.672" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="r" x1="2.487" x2="3.801" y1="5.357" y2="9.897" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="s" x1="7.806" x2="6.412" y1="1.818" y2="7.453" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="t" x1="3.075" x2="7.735" y1="6.069" y2="5.77" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3640FF" stop-opacity="0"/><stop offset=".94" stop-color="#3640FF" stop-opacity=".94"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="u" x1="1.005" x2="8.234" y1="4.965" y2="11.219" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="v" x1=".721" x2="1.756" y1="5.857" y2="12.813" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="w" x1="-1.225" x2="5.605" y1="3.472" y2="11.895" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="x" x1="4.077" x2="4.196" y1="9.276" y2="5.115" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="y" x1="8.076" x2="7.458" y1="6.707" y2="3.501" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="z" x1="29.098" x2="24.359" y1="6.296" y2="13.646" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="A" x1="26.338" x2="25.781" y1="6.016" y2="9.321" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="B" x1="21.726" x2="23.023" y1="2.211" y2="7.456" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="C" x1="26.329" x2="21.67" y1="6.069" y2="5.77" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3640FF" stop-opacity="0"/><stop offset=".94" stop-color="#3640FF" stop-opacity=".94"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="D" x1="28.265" x2="21.212" y1="5.051" y2="11.151" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="E" x1="28.769" x2="27.818" y1="6.576" y2="12.961" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="F" x1="30.393" x2="23.579" y1="3.309" y2="11.711" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></linearGradient><linearGradient id="G" x1="25.03" x2="24.901" y1="9.403" y2="4.91" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="H" x1="21.556" x2="22.147" y1="6.721" y2="3.649" gradientUnits="userSpaceOnUse"><stop stop-color="#0099D6" stop-opacity="0"/><stop offset=".334" stop-color="#029CD9" stop-opacity=".334"/><stop offset=".629" stop-color="#08A5E4" stop-opacity=".629"/><stop offset=".907" stop-color="#13B4F6" stop-opacity=".907"/><stop offset="1" stop-color="#17BBFE"/></linearGradient><linearGradient id="I" x1="13.361" x2="14.714" y1="13.268" y2="5.223" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#9F00E8"/><stop offset="1" stop-color="#7000A3"/></linearGradient><linearGradient id="J" x1="10.21" x2="18.613" y1="11.507" y2="-.839" gradientUnits="userSpaceOnUse"><stop stop-color="#761662"/><stop offset=".473" stop-color="#9F00E8"/><stop offset="1" stop-color="#4F0940"/></linearGradient><linearGradient id="K" x1="18.954" x2="12.104" y1=".483" y2="5.793" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#9F00E8"/><stop offset="1" stop-color="#7000A3"/></linearGradient><linearGradient id="L" x1="8.484" x2="8.492" y1="5.567" y2="5.84" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="M" x1="8.536" x2="8.539" y1="5.596" y2="5.688" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="N" x1="8.445" x2="8.447" y1="5.721" y2="5.767" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="O" x1="14.638" x2="14.867" y1="3.438" y2="11.578" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></linearGradient><linearGradient id="P" x1="14.767" x2="14.648" y1="-2.381" y2="11.119" gradientUnits="userSpaceOnUse"><stop offset=".254" stop-color="#FBE07A"/><stop offset="1" stop-color="#FF40BF"/></linearGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(12.197 11.427)scale(15.3734)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(12.197 11.427)scale(12.095)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="translate(15.246 14.958)scale(24.758)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".182" stop-color="#FFFBF8"/><stop offset=".453" stop-color="#FEF1E3"/><stop offset=".778" stop-color="#FDE0C3"/><stop offset="1" stop-color="#FCD2A8"/></radialGradient><radialGradient id="e" cx="0" cy="0" r="1" gradientTransform="matrix(4.53666 0 0 4.53665 14.162 19.066)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A9BCBE"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="translate(14.703 22.808)scale(7.02018)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="g" cx="0" cy="0" r="1" gradientTransform="matrix(5.8182 0 0 1.75884 14.809 24.663)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="matrix(-.54168 -1.87106 1.21054 -.35046 18.872 14.76)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="rotate(-106.147 10.753 3.558)scale(1.97178 1.27555)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#0099D6"/><stop offset=".234" stop-color="#0296D8"/><stop offset=".44" stop-color="#098BDD"/><stop offset=".635" stop-color="#1479E5"/><stop offset=".822" stop-color="#2360F0"/><stop offset="1" stop-color="#3640FF"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="translate(14.703 21.295)scale(13.9779)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A9BCBE"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="matrix(4.48522 0 0 4.48521 14.622 24.556)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="o" cx="0" cy="0" r="1" gradientTransform="translate(14.161 16.97)scale(5.63201)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset=".864" stop-color="#C20000"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="matrix(1.49547 -.601 .34943 .8695 13.601 16.66)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff" stop-opacity=".5"/><stop offset=".849" stop-color="#fff" stop-opacity="0"/></radialGradient><clipPath id="a"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-coin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.976 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.944 8.944 10 7l1.056 1.944L13 10l-1.944 1.056L10 13l-1.056-1.944L7 10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-coins" class="svg-sprite__symbol"><ellipse cx="5.5" cy="9.687" stroke="currentColor" stroke-width="1.5" rx="4.5" ry="2.25"/><path stroke="currentColor" stroke-width="1.5" d="M10 13.063c0 1.242-2.015 2.25-4.5 2.25S1 14.305 1 13.063"/><path stroke="currentColor" stroke-width="1.5" d="M1 9.688v7.2c0 .993 2.015 1.8 4.5 1.8s4.5-.806 4.5-1.8v-7.2"/><ellipse cx="14.5" cy="4.062" stroke="currentColor" stroke-width="1.5" rx="4.5" ry="2.25"/><path stroke="currentColor" stroke-width="1.5" d="M19 7.438c0 1.242-2.015 2.25-4.5 2.25S10 8.68 10 7.437M19 10.813c0 1.242-2.015 2.25-4.5 2.25s-4.5-1.008-4.5-2.25"/><path stroke="currentColor" stroke-width="1.5" d="M10 4.063V14.67c0 .976 2.015 1.767 4.5 1.767s4.5-.791 4.5-1.768V4.063"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-coins_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M23.995 19.178C23.831 22.31 19.351 24.5 14 24.5c-5.452 0-10-2.274-10-5.5V9l.005-.178C4.169 5.69 8.649 3.5 14 3.5c5.452 0 10 2.274 10 5.5v10zm-1.994-6.812C20.165 13.696 17.242 14.5 14 14.5s-6.164-.804-8-2.134V14c0 1.745 3.51 3.5 8 3.5s8-1.755 8-3.5zM14 5.5C9.51 5.5 6 7.255 6 9s3.51 3.5 8 3.5 8-1.755 8-3.5-3.51-3.5-8-3.5m8.001 11.866C20.165 18.696 17.242 19.5 14 19.5s-6.164-.804-8-2.134V19l.005.116C6.157 20.822 9.611 22.5 14 22.5c4.49 0 8-1.755 8-3.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-comment_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.426 18.886A1.5 1.5 0 0 1 5.5 17.5v-2c-.37 0-.719-.004-1.019-.028-.376-.03-.805-.102-1.234-.32a3.2 3.2 0 0 1-1.398-1.4c-.219-.428-.29-.857-.32-1.233-.03-.346-.029-.756-.029-1.19V6.67c0-.433 0-.843.028-1.189.03-.376.102-.805.32-1.234a3.2 3.2 0 0 1 1.4-1.398c.428-.219.857-.29 1.233-.32.346-.03.756-.029 1.19-.029h8.659c.433 0 .843 0 1.189.028.376.03.805.102 1.234.32a3.2 3.2 0 0 1 1.398 1.4c.219.428.29.857.32 1.233.03.346.029.756.029 1.19v4.659c0 .433 0 .843-.028 1.189-.03.376-.102.805-.32 1.234a3.2 3.2 0 0 1-1.4 1.398c-.428.219-.857.29-1.233.32-.346.03-.756.03-1.19.029h-3.166c-.03 0-.05.008-.071.03l-3.031 3.03a1.5 1.5 0 0 1-1.635.326M7 15.12c0-.392 0-.588-.076-.738a.7.7 0 0 0-.306-.306C6.468 14 6.272 14 5.88 14h-.16c-.952 0-1.428 0-1.792-.185a1.7 1.7 0 0 1-.743-.743C3 12.708 3 12.232 3 11.28V6.72c0-.952 0-1.428.185-1.792a1.7 1.7 0 0 1 .743-.743C4.292 4 4.768 4 5.72 4h8.56c.952 0 1.428 0 1.792.185.32.163.58.423.743.743.185.364.185.84.185 1.792v4.56c0 .952 0 1.428-.185 1.792a1.7 1.7 0 0 1-.743.743c-.364.185-.84.185-1.792.185h-3.117c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L7 17.5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-comment_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.06 20.354c.299-.26.68-.404 1.076-.404h4.448c1.17 0 1.867-.697 1.867-1.867V8.75c0-1.17-.697-1.867-1.867-1.867h-14c-1.17 0-1.867.697-1.867 1.867v9.333c0 1.17.697 1.867 1.867 1.867h2.915c.816.235.816.235 1.051 1.051v3.3zm-5.752 5.934c-.55-.413-.857-1.142-.857-1.788v-2.45H7.584c-2.33 0-3.967-1.637-3.967-3.967V8.75c0-2.33 1.637-3.967 3.967-3.967h14c2.33 0 3.967 1.637 3.967 3.967v9.333c0 2.33-1.637 3.967-3.967 3.967h-4.272l-4.346 3.802c-.855.839-1.854 1.039-2.658.436"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-configurate" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 15v3M6 2v9M14 2v3M14 9v9"/><circle cx="6" cy="13" r="2" stroke="currentColor" stroke-width="1.5"/><circle cx="14" cy="7" r="2" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="11" id="svg-name-connect" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M5.227 0a5.228 5.228 0 0 0 0 10.455H9.41V8.364H5.227a3.136 3.136 0 1 1 0-6.273H9.41V0zm8.364 0v2.09h4.182a3.136 3.136 0 1 1 0 6.274H13.59v2.09h4.182a5.228 5.228 0 0 0 0-10.454zM6.273 4.182v2.09h10.454v-2.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-copy" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7 15V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"/><path fill="currentColor" d="M2.25 14a.75.75 0 0 0 1.5 0zM13 3.75a.75.75 0 0 0 0-1.5zM3.75 14V5h-1.5v9zM5 3.75h8v-1.5H5zM3.75 5c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 2.25 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy-button" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7 15V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Z"/><path fill="currentColor" d="M2.25 14a.75.75 0 0 0 1.5 0zM13 3.75a.75.75 0 0 0 0-1.5zM3.75 14V5h-1.5v9zM5 3.75h8v-1.5H5zM3.75 5c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 2.25 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy-new" class="svg-sprite__symbol"><rect width="9" height="10.679" x="4.402" y="5.828" stroke="currentColor" rx="1.5"/><path stroke="currentColor" d="M6.102 4h6a3 3 0 0 1 3 3v7.647"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-copy_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M1.827 2.638C1.5 3.28 1.5 4.12 1.5 5.8v3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.122.062.255.107.408.138V5.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 2.5 5.08 2.5 6.2 2.5h5.22a1.6 1.6 0 0 0-.138-.408 2 2 0 0 0-.874-.874C9.98 1 9.42 1 8.3 1h-2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311M7.7 5.5h3.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v4.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.3 1.3 0 0 1-.242.035c-.258.02-.606.022-1.191.022H7.7c-.585 0-.933-.001-1.191-.022a1.3 1.3 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.3 1.3 0 0 1-.035-.242C6.002 12.733 6 12.385 6 11.8V7.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022m5.038.06-.003-.002zm.203.202v.003zm0 7.473v.003zm-.203.206h-.003zm-6.473 0h-.003.003m-.206-.203v-.003zm0-7.473v-.003.002m.203-.206h.003zM4.5 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.02 4 6.58 4 7.7 4h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v4.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.98 15 12.42 15 11.3 15H7.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4.5 13.48 4.5 12.92 4.5 11.8z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-copy_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M9.7 3c-1.284 0-2.158.001-2.833.056-.658.054-.994.151-1.228.271a3 3 0 0 0-1.312 1.311c-.12.235-.216.57-.27 1.229C4.002 6.542 4 7.415 4 8.7v2.6c0 .585.002.933.023 1.191.009.11.02.176.027.212v.097c0 .761 0 1.264.069 1.642a1.7 1.7 0 0 1-.526-.16 2 2 0 0 1-.875-.874C2.5 12.98 2.5 12.42 2.5 11.3V8.7c0-2.52 0-3.78.491-4.743A4.5 4.5 0 0 1 4.958 1.99C5.92 1.5 7.18 1.5 9.7 1.5h2c1.12 0 1.68 0 2.109.218a2 2 0 0 1 .874.874c.07.137.117.288.15.466C14.46 3 13.971 3 13.25 3z"/><path fill="currentColor" fill-rule="evenodd" d="M5.6 7.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .875-.874C7.12 4.5 7.68 4.5 8.8 4.5h6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 6.02 18 6.58 18 7.7v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.873.874c-.428.218-.988.218-2.108.218h-6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.875-.874C5.6 16.98 5.6 16.42 5.6 15.3zM8.8 6h6c.585 0 .934.001 1.192.022.158.013.224.03.242.036a.5.5 0 0 1 .209.209c.005.018.022.084.035.242.021.258.022.606.022 1.191v7.6c0 .585 0 .933-.022 1.191-.013.158-.03.224-.035.242a.5.5 0 0 1-.21.21 1.3 1.3 0 0 1-.241.035c-.258.02-.607.022-1.192.022h-6c-.584 0-.933-.001-1.191-.022a1.3 1.3 0 0 1-.242-.036.5.5 0 0 1-.209-.209 1.3 1.3 0 0 1-.035-.242c-.021-.258-.023-.606-.023-1.191V7.7c0-.585.002-.933.023-1.191.013-.158.03-.224.035-.242a.5.5 0 0 1 .21-.21c.017-.005.083-.022.241-.035C7.867 6.002 8.216 6 8.8 6m7.439.06-.003-.002zm.202.202.001.003zm0 10.476.001-.003zm-.202.203h-.003zm-8.877 0h.003zm-.202-.203-.001-.003zm0-10.476-.001.003zm.203-.203h.002z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-copy_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M12.143 1.428c.933 0 1.726.596 2.02 1.428h-6.93c-1.273 0-1.735.133-2.2.382a2.6 2.6 0 0 0-1.08 1.08c-.25.466-.382.927-.382 2.201v7.644a2.14 2.14 0 0 1-1.428-2.021V5.713a4.286 4.286 0 0 1 4.285-4.285zM15 4.285c1.183 0 2.143.96 2.143 2.143v9.285c0 1.184-.96 2.143-2.143 2.143H7.143A2.143 2.143 0 0 1 5 15.713V6.428c0-1.184.96-2.143 2.143-2.143zm0 1.428H7.143a.714.714 0 0 0-.715.715v9.285c0 .395.32.715.715.715H15c.394 0 .714-.32.714-.715V6.428A.714.714 0 0 0 15 5.713"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="svg-name-cross" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M5.53 4.47a.75.75 0 0 0-1.06 1.06L8.94 10l-4.47 4.47a.75.75 0 1 0 1.06 1.06L10 11.06l4.47 4.47a.75.75 0 1 0 1.06-1.06L11.06 10l4.47-4.47a.75.75 0 0 0-1.06-1.06L10 8.94z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-crown-simple" class="svg-sprite__symbol"><path fill="currentColor" d="m2.183 4.421 2.656 1.627 2.646-3.405a.6.6 0 0 1 .226-.179.68.68 0 0 1 .579 0 .6.6 0 0 1 .225.18l2.647 3.404 2.656-1.627a.67.67 0 0 1 .68-.011.6.6 0 0 1 .239.242c.053.1.073.21.059.321l-1.04 8.114a.57.57 0 0 1-.207.366.67.67 0 0 1-.42.147H2.871a.67.67 0 0 1-.42-.147.57.57 0 0 1-.208-.366L1.204 4.972a.54.54 0 0 1 .06-.32.6.6 0 0 1 .238-.242.68.68 0 0 1 .68.011"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-cube_box_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.407 1.547a3.8 3.8 0 0 1 1.186 0c.445.071.866.248 1.474.503l.08.034 4.421 1.855.093.039c.44.183.826.345 1.121.62.26.241.458.54.58.872.14.38.139.798.138 1.274v5.996c0 .654.001 1.168-.169 1.63-.149.406-.391.771-.708 1.066-.36.335-.834.533-1.438.786l-.107.045-3.931 1.65q-.04.016-.08.033c-.608.255-1.03.431-1.474.503a3.8 3.8 0 0 1-1.186 0c-.445-.072-.865-.248-1.473-.503l-.08-.034-3.931-1.65-.108-.044c-.604-.253-1.077-.45-1.438-.786a2.75 2.75 0 0 1-.708-1.066c-.17-.462-.17-.976-.169-1.63V6.745c0-.477-.001-.896.138-1.275.122-.332.32-.631.58-.872.296-.275.682-.437 1.121-.62l.093-.04 4.422-1.854.08-.034c.608-.255 1.028-.432 1.473-.503m1.343 15.315c.186-.067.435-.17.816-.33l3.932-1.649c.763-.32.964-.416 1.104-.546.143-.134.254-.3.322-.485.065-.178.076-.4.076-1.23v-5.75l-4.853 2.036-.08.034c-.539.226-.93.39-1.321.474a1 1 0 0 1 .004.084zM9.255 9.416a1 1 0 0 0-.005.084v7.362c-.186-.067-.434-.17-.816-.33l-3.931-1.649c-.764-.32-.965-.416-1.104-.546a1.25 1.25 0 0 1-.322-.485c-.066-.178-.077-.4-.077-1.23v-5.75l4.854 2.036.08.034c.538.226.93.39 1.32.474M3.603 5.498l4.83 2.026c.72.302.966.4 1.211.44q.356.056.712 0c.245-.04.492-.138 1.21-.44l.726-.304L6.26 4.69a.75.75 0 0 1-.273-.196l-1.975.829c-.174.073-.307.13-.409.175M7.83 3.72l6.401 2.686 2.166-.91a23 23 0 0 0-.409-.174l-4.422-1.855c-.718-.302-.965-.4-1.21-.44a2.3 2.3 0 0 0-.712 0c-.245.04-.492.138-1.21.44z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-cup" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M6.648 7.094a.65.65 0 0 0-1.3 0zm-1.3 3.362a.65.65 0 0 0 1.3 0zm.409-2.76a.65.65 0 0 0 .482-1.207zM3.798 4.467a.65.65 0 0 0-1.096.699zM5.756 6.49a.65.65 0 1 0 .482 1.207zm3.537-1.323a.65.65 0 0 0-1.096-.699zm-3.295 5.938a.65.65 0 1 0 0-1.3zm-1.432-1.3a.65.65 0 1 0 0 1.3zm1.431 0a.65.65 0 1 0 0 1.3zm1.431 1.3a.65.65 0 1 0 0-1.3zm-5.707-8.78a.65.65 0 1 0 1.296-.096zM3.433 1.2l-.042.649.042.001zm5.13 0v.65l.043-.001zm.777.295.462-.457zm-.36.732a.65.65 0 1 0 1.296.095zm-6.611.697a.65.65 0 0 0 0-1.3zm-1.23-.65-.044.648.044.002zm-.382.138-.449-.471zM.6 2.788h.65v-.012zM2.049 4.94l-.245.603.057.02zm.145.02v-.65h-.012zm.666 0 .001-.65H2.86zm.813.346a.65.65 0 1 0-.855-.98zM3.01 2.189a.65.65 0 1 0-1.288.173zM2.69 5.147a.65.65 0 1 0 1.119-.662zm6.937-3.524a.65.65 0 1 0 0 1.3zm1.234.65v.65q.023 0 .045-.002zm.383.138.448-.471zm.156.375-.65-.012v.012zM9.952 4.938l.187.622.057-.02zm-.146.02.012-.65h-.012zm-.666 0v-.65zm.042-.634a.65.65 0 0 0-.855.979zm1.098-1.962a.65.65 0 1 0-1.289-.173zM8.194 4.485a.65.65 0 1 0 1.118.662zM5.348 7.094v3.362h1.3V7.094zm.891-.605A5.17 5.17 0 0 1 3.8 4.467l-1.097.699a6.47 6.47 0 0 0 3.055 2.53zm0 1.207a6.47 6.47 0 0 0 3.054-2.53l-1.096-.699A5.17 5.17 0 0 1 5.756 6.49zm-.241 2.108H4.566v1.3h1.432zm0 1.3h1.43v-1.3h-1.43zm-2.98-8.876a.35.35 0 0 1 .1-.274l-.923-.915c-.337.34-.51.808-.474 1.284zm.1-.274a.35.35 0 0 1 .273-.104L3.475.553a1.65 1.65 0 0 0-1.28.486zm.315-.103h5.13v-1.3h-5.13zm5.173-.001a.35.35 0 0 1 .273.104l.923-.915a1.65 1.65 0 0 0-1.28-.486zm.273.104a.35.35 0 0 1 .1.274l1.297.095a1.65 1.65 0 0 0-.474-1.284zm-6.51-.33h-1.23v1.3h1.23zm-1.185.002a1.16 1.16 0 0 0-.876.316l.897.942a.14.14 0 0 1-.11.04zm-.876.316A1.16 1.16 0 0 0-.05 2.8l1.3-.025c0 .04-.016.08-.045.108zm-.358.846c0 1.21.733 2.3 1.854 2.754l.489-1.205A1.67 1.67 0 0 1 1.25 2.788zM1.86 5.562q.17.051.346.047l-.025-1.3q.027 0 .054.008zm.333.048h.666v-1.3h-.666zm.664 0c.3 0 .59-.108.815-.305l-.855-.98a.07.07 0 0 1 .043-.015zM1.723 2.362c.132.984.46 1.931.966 2.785l1.119-.662a6.1 6.1 0 0 1-.797-2.296zm7.903.56h1.234v-1.3H9.626zm1.279 0a.14.14 0 0 1-.11-.04l.896-.942a1.16 1.16 0 0 0-.876-.316zm-.11-.04a.14.14 0 0 1-.045-.108l1.3.025a1.16 1.16 0 0 0-.36-.86zm-.046-.096c0 .68-.412 1.293-1.043 1.55l.489 1.204a2.97 2.97 0 0 0 1.854-2.754zm-.986 1.53a.2.2 0 0 1 .054-.008l-.024 1.3q.175.003.345-.048zm.042-.008h-.666v1.3h.666zm-.667 0q.024 0 .043.016l-.855.979c.226.197.515.305.815.305zM8.99 2.189a6.1 6.1 0 0 1-.796 2.296l1.118.662a7.4 7.4 0 0 0 .966-2.785z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="none" id="svg-name-cup-thin" class="svg-sprite__symbol"><path fill="currentColor" d="M10.733 10.82a.737.737 0 0 0-1.473 0zM9.26 16.424a.736.736 0 1 0 1.473 0zm.464-4.919a.736.736 0 1 0 .547-1.368zM6.038 6.631a.736.736 0 0 0-1.242.792zm3.685 3.506a.737.737 0 0 0 .546 1.368zm5.474-2.714a.737.737 0 1 0-1.242-.792zm-5.2 9.737a.737.737 0 1 0 0-1.473zm-2.385-1.473a.737.737 0 0 0 0 1.473zm2.384 0a.737.737 0 0 0 0 1.473zm2.385 1.473a.736.736 0 1 0 0-1.473zM3.213 2.848a.737.737 0 0 0 1.47-.109zm2.508-1.845-.047.735.047.002zm8.551 0v.737q.024 0 .048-.002zm1.295.492.523-.518zm-.256 1.244a.737.737 0 0 0 1.47.109zm-11.363.792a.736.736 0 1 0 0-1.473zM1.9 2.795l-.051.735.05.001zm-.638.23L.754 2.49zM1 3.65h.737v-.014zm2.415 3.585-.277.683.065.023zm.243.034v-.737h-.014zm1.109 0 .001-.737h-.001zm1.127.314a.736.736 0 0 0-.969-1.11zM4.677 2.695a.736.736 0 1 0-1.46.196zm.105 4.708a.736.736 0 1 0 1.268-.75zm11.262-5.345a.736.736 0 1 0 0 1.473zm2.056.737v.736l.051-.001zm.638.23.508-.534zM19 3.65l-.736-.014v.014zm-2.415 3.585.212.706.065-.023zm-.243.034.014-.737h-.014zm-1.109 0v-.737h-.001zm-.158-.795a.737.737 0 0 0-.969 1.11zM16.79 2.89a.737.737 0 0 0-1.46-.196zm-2.833 3.761a.736.736 0 1 0 1.267.75zM9.26 10.82v5.604h1.473V10.82zm1.01-.683a8.96 8.96 0 0 1-4.232-3.506l-1.242.792a10.44 10.44 0 0 0 4.928 4.082zm0 1.368a10.44 10.44 0 0 0 4.927-4.082l-1.242-.792a8.96 8.96 0 0 1-4.232 3.506zm-.273 4.182H7.612v1.473h2.385zm0 1.473h2.384v-1.473H9.996zM4.681 2.74a.93.93 0 0 1 .268-.727L3.904.977a2.4 2.4 0 0 0-.69 1.87zm.268-.727a.93.93 0 0 1 .724-.275l.094-1.47a2.4 2.4 0 0 0-1.864.709zm.771-.273h8.551V.267h-8.55zm8.599-.002a.93.93 0 0 1 .723.275L16.09.977a2.4 2.4 0 0 0-1.865-.709zm.723.275c.19.192.288.457.268.726l1.47.109A2.4 2.4 0 0 0 16.09.977zm-11.095.045H1.9v1.473h2.048zM1.95 2.06a1.58 1.58 0 0 0-1.196.431l1.015 1.067q.034-.03.08-.028zm-1.196.431c-.32.305-.499.731-.49 1.174l1.473-.028q-.001-.046.032-.079zm-.49 1.16a4.605 4.605 0 0 0 2.874 4.268l.554-1.365A3.13 3.13 0 0 1 1.737 3.65zm2.939 4.29q.23.07.469.065l-.028-1.473q-.009 0-.017-.002zm.455.065h1.109V6.533h-1.11zm1.107 0c.415.001.816-.149 1.129-.422l-.969-1.11a.24.24 0 0 1-.157.06zM3.217 2.891a12 12 0 0 0 1.565 4.512l1.268-.75a10.5 10.5 0 0 1-1.373-3.958zm12.827.64H18.1V2.058h-2.056zm2.107-.001a.1.1 0 0 1 .08.028l1.015-1.067a1.58 1.58 0 0 0-1.197-.43zm.08.028c.021.02.033.05.032.079l1.473.028a1.58 1.58 0 0 0-.49-1.174zm.032.093a3.13 3.13 0 0 1-1.955 2.903l.554 1.365a4.605 4.605 0 0 0 2.874-4.268zm-1.89 2.88-.017.002-.028 1.473q.24.004.47-.064zm-.03.002h-1.11v1.473h1.11zm-1.111 0a.24.24 0 0 1-.157-.058l-.969 1.11a1.7 1.7 0 0 0 1.129.421zm.098-3.838a10.5 10.5 0 0 1-1.373 3.957l1.267.75a12 12 0 0 0 1.566-4.511z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-cup_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.87 2.439c-.092-.032-.211-.04-.737-.04H5.866c-.525 0-.644.008-.737.04a.8.8 0 0 0-.473.511c-.024.097-.024.198.013.668.151 1.918.546 3.561 1.149 4.705.602 1.143 1.344 1.678 2.187 1.678.841 0 1.582-.534 2.182-1.677.601-1.144.994-2.788 1.144-4.706.037-.47.037-.571.013-.668a.8.8 0 0 0-.473-.511m-.657-1.24c.402 0 .74 0 1.046.105.595.203 1.09.738 1.247 1.347.064.25.061.499.043.775.34-.054.692-.017 1.004.095.683.247 1.245.877 1.245 1.818 0 .936-.584 1.67-1.265 2.18-.607.453-1.363.788-2.1.99q-.089.193-.184.373c-.42.798-.966 1.466-1.649 1.877.014.894.22 1.214.38 1.422q.04.052.094.116c.209.247.53.628.53 1.302v.6a.6.6 0 0 1-.6.6h-4a.6.6 0 0 1-.6-.6v-.6c0-.672.318-1.052.525-1.3q.054-.062.095-.116c.157-.208.363-.53.375-1.43-.679-.41-1.224-1.075-1.643-1.87a8 8 0 0 1-.183-.372c-.739-.203-1.497-.538-2.105-.993-.68-.509-1.265-1.243-1.265-2.179 0-.941.562-1.57 1.245-1.817.312-.113.663-.15 1.003-.096-.018-.276-.021-.524.043-.774A2 2 0 0 1 4.74 1.304c.307-.106.645-.105 1.046-.105h4.427M3.581 4.752l-.005.005c-.138-.138-.43-.212-.72-.107-.25.09-.453.297-.453.69 0 .396.249.817.784 1.217.249.187.541.353.854.493a16 16 0 0 1-.46-2.298m4 6.421c-.069.871-.316 1.358-.6 1.734q-.105.137-.176.224c-.163.204-.2.25-.2.468h2.8c0-.216-.037-.261-.202-.465-.048-.059-.106-.131-.178-.225-.287-.376-.537-.863-.606-1.735a3.2 3.2 0 0 1-.838-.001m4.38-4.124a4.5 4.5 0 0 0 .853-.492c.535-.4.784-.82.784-1.218 0-.392-.203-.599-.452-.689-.292-.105-.583-.031-.72.107l-.006-.005a16 16 0 0 1-.458 2.297" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-cup_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.043 2h-6.086c-.66 0-1.22 0-1.684.042-.49.044-.954.141-1.397.382a3.63 3.63 0 0 0-1.54 1.68c-.26.599-.29 1.233-.249 1.953a3.76 3.76 0 0 0-1.848.142C3.045 6.607 2 7.674 2 9.333c0 1.568.935 2.993 2.15 3.984a7.55 7.55 0 0 0 3.754 1.628q.255.605.545 1.148c.72 1.345 1.645 2.452 2.785 3.14-.033.553-.114.93-.204 1.195-.111.327-.25.518-.4.685-.062.069-.114.123-.18.19l-.117.12a3.6 3.6 0 0 0-.385.46c-.288.421-.448.917-.448 1.567V25a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-1.55c0-.65-.16-1.146-.448-1.566a3.6 3.6 0 0 0-.385-.462l-.117-.12a5 5 0 0 1-.18-.189 1.85 1.85 0 0 1-.4-.685c-.09-.264-.171-.642-.204-1.195 1.14-.688 2.065-1.795 2.785-3.14q.29-.543.545-1.147a7.55 7.55 0 0 0 3.755-1.63C25.065 12.327 26 10.902 26 9.334c0-1.659-1.045-2.726-2.24-3.134a3.76 3.76 0 0 0-1.848-.142c.041-.72.013-1.354-.248-1.954a3.63 3.63 0 0 0-1.54-1.68c-.444-.24-.906-.337-1.397-.381C18.264 2 17.703 2 17.043 2m-2.22 17.939a5.5 5.5 0 0 1-1.647 0 5.8 5.8 0 0 1-.253 1.135 3.8 3.8 0 0 1-.803 1.373c-.093.104-.197.21-.276.29l-.07.073a2 2 0 0 0-.175.203c-.04.059-.099.153-.099.437V24h5v-.55c0-.284-.059-.378-.099-.437a1.7 1.7 0 0 0-.197-.226l-.048-.05c-.079-.08-.183-.186-.276-.29a3.8 3.8 0 0 1-.803-1.373 5.8 5.8 0 0 1-.253-1.135m7.764-8.172c-.502.409-1.094.74-1.725.955.377-1.351.657-2.843.845-4.432.25-.25.82-.398 1.407-.198.515.176.886.567.886 1.241 0 .766-.482 1.674-1.413 2.434m-15.449.955c-.377-1.351-.657-2.843-.845-4.432-.25-.25-.82-.398-1.407-.198C4.37 8.268 4 8.66 4 9.333c0 .766.482 1.674 1.413 2.434.502.409 1.094.74 1.725.955m1.692-8.54c.114-.062.278-.117.623-.148C9.816 4 10.285 4 11 4h6c.714 0 1.184 0 1.547.034.345.031.509.086.623.148.268.145.538.44.66.72.129.295.128.63.008 2.007-.298 3.431-1.001 6.28-2.05 8.24C16.744 17.098 15.463 18 14 18s-2.744-.901-3.788-2.852C9.162 13.19 8.46 10.34 8.162 6.91c-.12-1.377-.12-1.712.008-2.008.122-.28.392-.574.66-.72" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" id="svg-name-default-avatar" class="svg-sprite__symbol"><path fill="#CBCBCB" fill-rule="nonzero" d="M20 29.21c5.007 0 15 2.54 15 7.58V41H5v-4.21c0-5.04 9.993-7.58 15-7.58M20 25a7 7 0 1 1 0-14 7 7 0 0 1 0 14"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 4h14"/><path stroke="currentColor" stroke-width="1.5" d="M4 6v9.5a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6M8 6v10.5M12 6v10.5M12 4V3a2 2 0 1 0-4 0v1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete-all-messages" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m18.041 1.959-4.628 4.628m-.001-4.628 4.628 4.628"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M16 10.964c0 3.847-3.134 6.965-7 6.965a7 7 0 0 1-1.615-.187c-.757-.245-2.845.476-4.018.926-.262.1-.527-.202-.401-.452.435-.864 1-2.21.65-2.802A6.9 6.9 0 0 1 2 10.965C2 7.118 5.134 4 9 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.837 4H2.75a.75.75 0 0 0 0 1.5h.545l.907 9.248c.051.523.094.96.157 1.314.066.37.163.711.353 1.028a2.9 2.9 0 0 0 1.247 1.131c.334.158.682.222 1.058.25.36.029.797.029 1.323.029h3.32c.526 0 .964 0 1.323-.028.376-.03.724-.093 1.058-.25a2.9 2.9 0 0 0 1.247-1.132c.19-.317.287-.657.353-1.028.063-.355.106-.79.157-1.314l.907-9.248h.545a.75.75 0 0 0 0-1.5h-4.087a3.25 3.25 0 0 0-6.326 0m1.581 0h3.164a1.751 1.751 0 0 0-3.164 0m6.78 1.5H4.802l.89 9.073c.054.56.091.936.143 1.227.05.281.104.422.162.52a1.4 1.4 0 0 0 .603.546c.102.048.248.088.533.11.294.024.673.024 1.235.024h3.262c.562 0 .941 0 1.235-.023.285-.023.43-.063.533-.111a1.4 1.4 0 0 0 .603-.547c.058-.097.112-.238.162-.52.052-.29.09-.667.144-1.226zm-2.886 2.002a.75.75 0 0 1 .685.81l-.5 6.003a.75.75 0 0 1-1.494-.124l.5-6.003a.75.75 0 0 1 .81-.686m-4.624 0a.75.75 0 0 1 .81.686l.5 6.002a.75.75 0 0 1-1.495.125l-.5-6.003a.75.75 0 0 1 .685-.81" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-delete_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.13 6.752a.75.75 0 0 1 .702.795l-.417 6.667a.75.75 0 1 1-1.497-.094l.417-6.666a.75.75 0 0 1 .795-.702M7.87 6.752a.75.75 0 0 0-.702.795l.417 6.667a.75.75 0 1 0 1.497-.094l-.417-6.666a.75.75 0 0 0-.795-.702" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2.5 3.417a.75.75 0 0 0 0 1.5h.984l.962 10.263c.038.404.07.749.12 1.031.05.299.13.587.291.858.246.412.608.742 1.041.948.286.135.58.187.881.21.287.023.633.023 1.038.023h4.366c.405 0 .751 0 1.038-.022a2.5 2.5 0 0 0 .88-.211 2.4 2.4 0 0 0 1.041-.948c.162-.271.241-.559.293-.858.049-.282.081-.627.12-1.03l.961-10.264h.984a.75.75 0 0 0 0-1.5h-4.337a3.251 3.251 0 0 0-6.326 0zm3.437 11.596c.04.438.068.724.106.942.036.21.073.296.104.347.093.157.23.282.394.36.054.025.144.054.356.07.22.018.508.018.948.018h4.31c.44 0 .728 0 .948-.017.212-.017.302-.046.356-.071a.9.9 0 0 0 .394-.36c.03-.05.068-.138.104-.347.038-.218.065-.504.106-.942l.947-10.096H4.99zM10 2.417c-.698 0-1.3.409-1.582 1h3.164a1.75 1.75 0 0 0-1.582-1" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-description" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.049a2 2 0 0 0-1.993-2L4.007 3.007a2 2 0 0 0-2.007 2V18l3-3h10.984a2 2 0 0 0 2-2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.252h8.5M5.75 10.752h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-description-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C18 4.28 18 5.12 18 6.8v6.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 18 14.88 18 13.2 18H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 15.72 2 14.88 2 13.2z"/><path fill="currentColor" d="M2 6.25a.75.75 0 0 0 0 1.5zm16 1.5a.75.75 0 0 0 0-1.5zm-16 0h16v-1.5H2zM5 10.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5zM5 13.25a.75.75 0 0 0 0 1.5zm6 1.5a.75.75 0 0 0 0-1.5zm-6 0h6v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="33" height="30" id="svg-name-desktop" class="svg-sprite__symbol"><path fill="currentColor" d="M29.73 0a2.7 2.7 0 0 1 2.702 2.703v18.919a2.7 2.7 0 0 1-2.702 2.702H17.837v2.703h5.136c.439-.006.85.2 1.107.549l.08.121a1.351 1.351 0 0 1-1.187 2.033H9.459a1.351 1.351 0 1 1 0-2.703h5.135v-2.703H2.703a2.7 2.7 0 0 1-2.698-2.531L0 21.622V2.702A2.7 2.7 0 0 1 2.703 0zM16.216 20.27a1.352 1.352 0 1 0 .001 2.704 1.352 1.352 0 0 0 0-2.704zM29.73 2.703H2.703v16.216H29.73z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" id="svg-name-diamond" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2.27 13.899 6.413-9.62c.2-.3.538-.481.899-.481h16.844c.361 0 .698.18.899.48l6.414 9.621c.273.41.234.955-.096 1.322l-15.64 17.376L2.366 15.221a1.08 1.08 0 0 1-.096-1.322" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m13.328 18.199-3.426-3.6 2.694-3.601"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-diamond_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.063 4a1 1 0 0 0-.442.103l-4.05 1.994a1 1 0 0 0-.431.393l-2.985 4.975a1 1 0 0 0-.11.237 1 1 0 0 0 .118.845q.06.095.144.174l10.98 10.98.04.039a1 1 0 0 0 .601.257l.024.002h.002a1 1 0 0 0 .759-.297l10.98-10.98.015-.015a1 1 0 0 0 .259-.449 1 1 0 0 0-.16-.85L22.32 6.427a1 1 0 0 0-.349-.31l-3.544-1.989a1 1 0 0 0-.49-.128zM21.12 8.202l-3.39 1.233 1.206 3.214q0 .004.003.008l4.432-1.24zM16.932 13l-1.125-3h-3.614l-1.125 3zm-7.871-.343q0-.004.003-.008l1.191-3.177-3.81-1.27-1.913 3.188zM8.627 6.82 10.296 6h7.38l1.434.805L15.824 8h-3.661zm2.272 11.664L6.405 13.99l2.851.797zM14 20.538 11.54 15h4.923zm3.101-2.053 1.643-3.697 2.851-.797z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-1" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-2" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m5.6-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-3" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6m2.8-2.8c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-4" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m0-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m5.6 0c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m0 5.6c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-5" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" d="M10.5 14h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5m-6.3-2.8c.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4-1.4.63-1.4 1.4.63 1.4 1.4 1.4m0-8.4c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4M7 5.6c-.77 0-1.4.63-1.4 1.4S6.23 8.4 7 8.4 8.4 7.77 8.4 7 7.77 5.6 7 5.6m2.8-2.8c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4m0 5.6c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4 1.4-.63 1.4-1.4-.63-1.4-1.4-1.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-dice-bage-6" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="14" height="14" fill="#F1F1F1" rx="3.889"/><path fill="currentColor" fill-rule="evenodd" d="M3.5 0h7C12.46 0 14 1.54 14 3.5v7c0 1.96-1.54 3.5-3.5 3.5h-7C1.54 14 0 12.46 0 10.5v-7C0 1.54 1.54 0 3.5 0m1.4 2c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4-1.4-.63-1.4-1.4S4.13 2 4.9 2m0 3.6c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4S3.5 7.77 3.5 7s.63-1.4 1.4-1.4m5.6-2.2c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4.63 1.4 1.4 1.4 1.4-.63 1.4-1.4M9.1 5.6c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4S7.7 7.77 7.7 7s.63-1.4 1.4-1.4m-2.8 5c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4.63 1.4 1.4 1.4 1.4-.63 1.4-1.4m2.8-1.4c.77 0 1.4.63 1.4 1.4S9.87 12 9.1 12s-1.4-.63-1.4-1.4.63-1.4 1.4-1.4" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-dice-outlined" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" clip-path="url(#a)"><path d="M15 19H5c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4"/><path d="M10 10.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-dice_5_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.6 5h2.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v2.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-2.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C5.001 18.278 5 17.113 5 15.4v-2.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36C9.722 5.001 10.887 5 12.6 5M3 12.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C7.56 3 9.24 3 12.6 3h2.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C25 7.56 25 9.24 25 12.6v2.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C20.44 25 18.76 25 15.4 25h-2.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C3 20.44 3 18.76 3 15.4zm6.25 7.9a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M11 9.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3 6.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m6.5-6.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M18.75 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" id="svg-name-dislike-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M6.958 15.519c-.025.504.016.981.212 1.348.104.195.253.361.454.475.199.113.419.158.64.158.165 0 .38-.05.598-.137.227-.091.49-.238.74-.461.514-.459.935-1.206.935-2.34 0-1.016-.194-1.76-.335-2.304l-.021-.081c-.156-.602-.155-.76-.07-.893.03-.048.098-.108.244-.16s.328-.081.524-.092a4 4 0 0 1 .713.033h.01v.001l.37.06.161-.337L13.29 8.38l.054-.114-.006-.126-.242-5.005-.004-.093-.038-.085-.723-1.641-.09-.206-.215-.068-.153.476.153-.476h-.001l-.002-.001-.005-.002-.016-.005-.056-.016-.205-.054c-.178-.044-.438-.1-.776-.155A17 17 0 0 0 8.038.606c-.886.01-1.79.399-2.457.743a19 19 0 0 0-.856.474 5 5 0 0 1-.254.139l-.007.003c-.159-.01-.528-.049-.976-.1-.511-.06-1.078-.13-1.421-.177a.72.72 0 0 0-.572.18 1.3 1.3 0 0 0-.28.37c-.134.255-.239.595-.323.962-.17.743-.28 1.725-.314 2.696-.034.968.006 1.96.152 2.718.072.373.177.73.339 1.004.16.27.455.574.91.535q.214-.018.393-.037c.395-.04.684-.069.974-.026.322.048.655.193 1.063.656a7.6 7.6 0 0 0 1.25 1.17c.24.184.464.356.797.688.32.321.475.84.526 1.434.041.473.012.919-.01 1.256zM4.424 1.983Z"/><path fill="url(#b)" stroke="currentColor" d="M8.556 9.357c.02.516.267.907.626 1.174.339.253.768.391 1.186.472.832.161 1.815.126 2.469.101h.023l.08-.003a4 4 0 0 0 1.089-.216 2.24 2.24 0 0 0 .905-.587c.274-.307.445-.713.44-1.219a1.58 1.58 0 0 0-.358-1.021 1.77 1.77 0 0 0-.762-.512c-.516-.187-1.074-.18-1.314-.171l-2.118.08c-.58.023-1.154.12-1.586.416-.478.328-.704.84-.68 1.486Z"/><path fill="url(#c)" stroke="currentColor" d="M10.154 2.778c.61-.106 1.41-.186 2.155-.205.373-.01.74-.004 1.065.023.317.026.629.075.875.167zm0 0c-.578.102-1.001.38-1.259.762-.25.373-.316.805-.261 1.176zm3.359 3.16c-.271.009-.495.013-.688.016-.423.008-.7.013-1.004.049a9 9 0 0 1-1.007.065zm0 0c1.17-.033 1.703-1.023 1.682-1.746-.02-.702-.418-1.231-.946-1.429zm-3.936-.121c-.364-.17-.856-.507-.943-1.1zm0 0c.38.176.81.262 1.078.254z"/><path fill="url(#d)" stroke="currentColor" d="M13.317.74C13 .64 12.477.56 11.94.522 11.401.485 10.79.49 10.295.583c-.504.097-.899.292-1.148.64-.24.335-.279.725-.279 1.05 0 .903.756 1.45 1.402 1.45.237 0 .421-.04.584-.076l.06-.014a4.5 4.5 0 0 1 .775-.1 5 5 0 0 1 .534.026c.209.017.454.037.681.037.235 0 .573-.026.857-.225.323-.226.462-.59.462-1.015 0-.343-.04-.68-.173-.968a1.18 1.18 0 0 0-.733-.648Z"/><path fill="url(#e)" stroke="currentColor" d="M15.847 6.558c-.005-.294-.079-.774-.46-1.174-.389-.408-1.01-.641-1.915-.623a79 79 0 0 0-2.729.103c-.291.015-.5.025-.616.028a1.95 1.95 0 0 0-1.038.337c-.389.274-.687.732-.674 1.4.013.636.272 1.098.65 1.388.35.269.764.36 1.088.358l.038.002.166.007c.148.005.375.011.69.016.63.008 1.614.01 3.043-.019.654-.013 1.117-.307 1.401-.697.268-.37.363-.803.356-1.126Z"/><g clip-path="url(#f)"><path fill="url(#g)" d="M8.265 17c-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.076-.76-2.025-1.836-.95-1.077-1.74-.855-2.848-.76-1.392.12-.918-7.606.063-7.472.696.095 2.279.285 2.532.285S6.52 1.122 8.043 1.106c2.468-.026 3.83.412 3.83.412l.723 1.64.242 5.006-1.155 2.408s-1.551-.253-1.994.444c-.443.696.348 1.551.348 3.546S8.581 17 8.265 17"/><path fill="url(#h)" d="m11.959 1.533-.094.342c-.279.03-.636-.097-1.125-.093-2.334.018-4.565.688-5.522 1.447-.627.496-.902 1.157-1.345.967-.547-.234-2.097-.599-2.668.123.16-1.235.445-2.184.794-2.136.696.095 2.279.285 2.532.285s1.94-1.31 3.512-1.362a19.4 19.4 0 0 1 3.84.284z"/><path fill="url(#i)" d="M2.924 9.167c.918-.253 1.5.166 1.97.736.466.566.87 1.069 2.041 1.828s1.02 2.85.926 3.546c-.095.697-.032 1.723.404 1.723-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.075-.76-2.025-1.836s-1.74-.855-2.848-.76c0-.24.07-.235.988-.488"/><path fill="url(#j)" d="M9.689 11.016c-.443.697.348 1.551.348 3.546S8.582 17 8.265 17a.9.9 0 0 1-.224-.027c1.291-.081 2.069-1.71 1.624-3.39-.361-1.363-.541-2.455.048-3.096.382-.415 1.14-.344 1.97.086 0 0-1.551-.254-1.994.443"/><path fill="url(#k)" d="M9.776 10.305c-.76-.253-2.678-.85-4.13-2.167-3.682-3.34 2.604-3.76 3.902-6.616.248-.546 1.699 2.864 1.699 2.864l.469.79-1.356 3.61z"/><path fill="url(#l)" d="M9.887 10.016c-.76-.253-3.862-2.242-3.862-3.224 0-2.833 2.149-1.435 3.31-4.779.16-.463.729-.852.729-.852.47.384 1.183 3.225 1.183 3.225l.469.79-1.356 3.61z"/><path fill="url(#m)" d="m11.64 1.33 1.454 1.663.32 6.946-3.638.366c-.836-.45-.932-1.064-.622-2.052.13-.416-.4-.535-.434-1.745-.024-.84.525-.843.525-1.093s-.273-.227-.364-.95c-.13-1.033.735-1.053.735-1.274s-.48-.353-.45-1.195c.037-1.069-1.947-.853-3.288.12-.55.399-1.031.44-1.406.35l.058.001c.253 0 1.953-1.361 3.513-1.361 1.823 0 3.085.107 3.597.224"/><path fill="url(#n)" d="M11.974 9.847c-1.123 0-1.74-1.098-1.313-1.942s-.791-1.96-.665-2.51c.127-.55.349-1.942.522-2.172s-.285-.753-.285-.753l1.425-.174 1.329.586-.048 4.02.142 2.517z"/><path fill="url(#o)" d="M4.784 10.414c-.617-.699-1.167-.85-1.78-.845.177-.285.3-.597.287-.902-.033-.8.143-1.786.277-.76.103.78.632 1.746 1.269 2.567z"/><path fill="url(#p)" d="M12.825 10.604c-1.328.051-3.716.126-3.769-1.266-.038-1.01.677-1.34 1.784-1.383l2.119-.08c.459-.018 1.9-.01 1.915 1.21.017 1.523-2.049 1.52-2.049 1.52"/><path fill="url(#q)" d="M10.64 5.571c-.355.01-1.413-.256-1.511-.928-.078-.528.191-1.21 1.111-1.372 1.166-.204 3.108-.311 3.834-.04.324.122.607.461.621.976a1.21 1.21 0 0 1-1.197 1.232c-.83.024-1.263.011-1.736.067-.57.067-.836.057-1.121.065"/><path fill="url(#r)" d="M10.27 3.223a.94.94 0 0 1-.902-.95c0-.593.154-1.032 1.02-1.199.867-.166 2.256-.023 2.778.143.407.13.557.51.557 1.14s-.391.738-.819.738-.945-.077-1.241-.062c-.827.044-.99.19-1.393.19"/><path fill="url(#s)" d="M12.712 10.323c-1.16.044-3.245.111-3.287-.99-.03-.797.596-1.061 1.563-1.098.966-.037 3.509-.084 3.517.88.011 1.204-1.793 1.208-1.793 1.208"/><path fill="url(#t)" d="M10.748 5.288c-.31.009-1.178-.065-1.26-.707-.057-.434.168-.992.97-1.125 1.014-.17 2.705-.26 3.337-.038.281.099.527.376.54.798.012.421-.377.938-1.1.96-.723.02-1.107-.047-1.52 0-.494.055-.72.105-.967.112"/><path fill="url(#u)" d="M10.443 3.007c-.35 0-.78-.287-.78-.765s.133-.832.882-.965c.75-.134 1.95-.02 2.402.114.352.105.483.411.483.918s-.339.595-.708.595c-.37 0-.819-.063-1.075-.05-.715.035-.855.153-1.204.153"/><path fill="url(#v)" d="M10.23 9.333c.029.759.633 1.122 1.397 1.29-1.219-.029-2.531-.257-2.571-1.285-.038-1.01.677-1.34 1.784-1.383q.183-.007.346-.013c-.622.182-.986.592-.956 1.391"/><path fill="url(#w)" d="M10.334 10.485c-.71-.155-1.253-.49-1.278-1.147-.032-.84.458-1.21 1.26-1.335-1.627.65-1.043 2.25.018 2.482"/><path fill="url(#x)" d="M7.228 2.937c-.126-.452-1.007-.602-1.966-.335-.96.268-1.635.852-1.509 1.305s1.007.603 1.966.335 1.635-.851 1.51-1.305"/><path fill="url(#y)" d="M13.82 9.13c-.009-.583-.787-.86-1.64-.91-.696-.043-1.469.45-1.449 1.02.02.568.121 1.072 1.569 1.022.853-.03 1.53-.563 1.52-1.132"/><path fill="url(#z)" d="M13.975 4.01c-.004-.807-.891-.653-1.743-.709-1.08-.071-1.796.265-1.796.835-.001.57.41.984 1.858.986.853.002 1.687-.076 1.681-1.113"/><path fill="url(#A)" d="M13.194 1.976c-.004-.688-.81-.781-1.573-.782-.763 0-1.591.404-1.592.89 0 .485.367.839 1.662.84.763.002 1.509-.065 1.503-.948"/><path fill="url(#B)" d="M10.119 4.48c.121.918.825.865 1.633.96-.93.07-1.32.08-1.32.08a1.4 1.4 0 0 1-.284-.002c-.302-.067-.644-.204-.848-.462a1.1 1.1 0 0 1-.161-.351l-.01-.061c-.066-.53.191-1.212 1.111-1.373q.201-.035.426-.065l.234-.03.068-.008c-.507.24-.938.637-.85 1.312"/><path fill="url(#C)" d="M10.344 5.525a2 2 0 0 1-.197-.007c-.304-.068-.65-.207-.852-.469a1.1 1.1 0 0 1-.156-.345l-.01-.06c-.093-.523.165-1.138.97-1.342-1.372.757-.787 2.222.245 2.223"/><path fill="url(#D)" d="M11.142 3.083c-.405.06-.572.14-.872.14a.94.94 0 0 1-.902-.949c0-.216.021-.41.088-.58.068-.14.168-.27.304-.38.15-.105.353-.186.629-.24.185-.035.394-.056.614-.066-.424.246-1.141.378-.99 1.202.166.909.708.786 1.13.873"/><path fill="url(#E)" d="M10.252 3.223a.944.944 0 0 1-.884-.95c0-.543.13-.958.818-1.15-1.074.69-.73 1.855.066 2.1"/><path fill="url(#F)" d="M14.874 9.085q.001.203-.043.374c.107-.476-.317-.949-1.44-1.178-.745-.152-2.722-.342-4.09.201.295-.357.839-.5 1.54-.526l2.118-.081c.459-.018 1.9-.01 1.915 1.21"/><path fill="url(#G)" d="M14.696 4.24c-.002.51-.385 1.176-1.198 1.199-.83.024-1.263.011-1.736.067-.57.067-.837.057-1.121.065-.215.007-.746-.058-1.107-.283a4.8 4.8 0 0 1 1.997-.293c2.23.144 2.864-.126 3.164-.756"/><path fill="url(#H)" d="M10.163 7.875c-.475.01-1.228-.27-1.248-1.256-.02-.985.842-1.22 1.222-1.228.38-.007 1.707-.098 3.345-.13 1.637-.033 1.856.846 1.866 1.306.009.461-.283 1.294-1.268 1.314-2.848.058-3.917-.006-3.917-.006"/><path fill="url(#I)" d="M10.418 7.589c-.413.008-1.067-.206-1.082-.966s.734-.943 1.064-.95 1.484-.079 2.907-.107c1.424-.029 1.613.649 1.62 1.005s-.042.998-.898 1.015c-2.476.05-3.611.003-3.611.003"/><path fill="url(#J)" d="M9.934 6.715c.047 1.011.753 1.014 1.55 1.19-.932-.007-1.321-.03-1.321-.03-.475.01-1.228-.27-1.248-1.255-.02-.986.842-1.22 1.222-1.228.137-.003.397-.016.75-.034-.526.217-.988.612-.953 1.357"/><path fill="url(#K)" d="M14.513 6.61c.033-.806-.861-.958-1.714-.998s-1.8.39-1.828.959c-.027.568.364 1.002 1.81 1.072.854.041 1.69.002 1.732-1.033"/><path fill="url(#L)" d="M10.074 7.873c-.474-.025-1.14-.327-1.16-1.253-.018-.937.76-1.196 1.163-1.225-1.56.63-1.049 2.385-.003 2.478"/><path fill="url(#M)" d="M15.345 6.667c-.206-1.458-4.06-1.19-6.141-.878.28-.3.699-.392.933-.397.38-.008 1.707-.098 3.345-.131 1.637-.033 1.856.846 1.866 1.307q0 .047-.003.1"/><path fill="url(#N)" d="M13.415 3.42c-.747-.033-2.722-.278-4.161.493.16-.298.471-.552.986-.642 1.166-.204 3.108-.311 3.834-.04.324.122.607.461.621.976-.047-.448-.474-.751-1.28-.787"/><path fill="url(#O)" d="M13.666 1.8c-.489-.373-1.334-.592-2.554-.386-.753.127-1.27.17-1.609.18.136-.246.398-.426.886-.52.866-.166 2.255-.024 2.777.142.268.086.424.281.5.584"/><path fill="url(#P)" d="M9.529 2.808c.903.329 1.346-.16 2.313-.16 1.004 0 1.483.406 1.84.02-.113.356-.433.428-.777.428-.428 0-.946-.078-1.242-.063-.827.044-.99.19-1.393.19a.94.94 0 0 1-.741-.415"/><path fill="url(#Q)" d="M1.999 2.183c.696.095 2.279.285 2.532.285C2.236 4.109 3.256 7.6 4.103 9.365c.119.248.192.452.232.624-.764-.582-1.47-.414-2.4-.334-1.39.119-.917-7.606.064-7.472"/><path fill="url(#R)" d="M4.53 2.467c-.196.168-.433.45-.647.723 0 0-1.152-.59-2.388-.312.143-.451.314-.721.504-.695.696.094 2.279.284 2.532.284"/><path fill="url(#S)" d="M9.003 14.096c-.45-.097-.816.526-1.023 1.253-.169.595.06 1.352.504 1.438.443.085.852.089 1.096-1.172.143-.742-.136-1.424-.577-1.519"/><path fill="url(#T)" d="M11.683 10.573s-1.551-.253-1.994.443c-.443.697.348 1.552.348 3.546 0 1.995-1.456 2.438-1.772 2.438-.62 0-.855-.496-.807-1.456.032-.633.245-2.399-.649-3.293-.833-.834-1.076-.76-2.025-1.836-.95-1.076 5.885-.3 6.898.158"/><path fill="#804B24" d="M10.252 3.223a.91.91 0 0 1-.675-.3.98.98 0 0 1-.249-.712c.008-.248.046-.518.208-.726.16-.21.411-.309.65-.363-.231.084-.461.202-.598.401-.139.197-.175.447-.177.69a.94.94 0 0 0 .214.668.97.97 0 0 0 .627.342M9.854 5.431a1.3 1.3 0 0 1-.473-.251.9.9 0 0 1-.279-.467v-.002a1.3 1.3 0 0 1-.013-.486 1.1 1.1 0 0 1 .195-.446c.195-.268.505-.418.813-.477-.3.097-.58.264-.754.519a1.14 1.14 0 0 0-.168.875l-.001-.003c.046.166.114.33.241.45.125.12.276.217.44.288"/><path fill="#804B24" d="M10.074 7.873a1.22 1.22 0 0 1-.824-.315c-.227-.208-.344-.514-.369-.814-.024-.299.025-.623.212-.87.184-.248.472-.392.762-.445-.283.083-.548.244-.71.483-.164.238-.21.538-.18.825.017.288.127.57.33.776.202.205.485.327.779.36M10.334 10.485c-.32-.056-.645-.154-.913-.359a1.05 1.05 0 0 1-.406-.886c0-.33.114-.686.382-.9.262-.218.597-.3.919-.337-.318.068-.639.171-.877.384-.242.212-.346.536-.342.854a1 1 0 0 0 .364.836c.247.203.56.322.873.408M9.254 3.913c.094-.19.245-.352.428-.466a1.7 1.7 0 0 1 .603-.211q.628-.11 1.262-.164c.424-.027.848-.04 1.273-.029.422.015.854.04 1.254.19a2.7 2.7 0 0 0-.623-.106 7 7 0 0 0-.633-.028 14 14 0 0 0-1.265.056q-.632.038-1.259.135c-.41.056-.825.25-1.04.623"/><path fill="#804B24" d="M9.204 5.789c.152-.17.357-.292.576-.36.222-.073.458-.063.683-.078l1.364-.067 1.365-.04c.45-.025.926-.01 1.348.17-.434-.149-.895-.142-1.347-.115l-1.364.067-1.365.04c-.229.01-.456-.004-.672.061-.219.055-.427.16-.588.322M14.08 7.882c-.652.035-1.306.048-1.959.055-.653.01-1.306.01-1.96-.03h.003a1.3 1.3 0 0 1-.92-.366 1.1 1.1 0 0 1-.258-.429 1.7 1.7 0 0 1-.07-.492c.014.33.125.66.361.888.232.23.565.34.885.335h.003c.325.012.652.014.978.017l.978.013.98.002c.326-.004.652.006.979.007"/></g><defs><linearGradient id="a" x1="11.734" x2="6.973" y1="9.184" y2="8.993" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="b" x1="14.649" x2="9.986" y1="9.248" y2="9.248" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="c" x1="14.649" x2="9.983" y1="4.32" y2="4.32" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="d" x1="14.649" x2="9.985" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="e" x1="14.649" x2="9.985" y1="6.582" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="g" x1="11.734" x2="6.973" y1="9.184" y2="8.993" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="h" x1="6.934" x2="6.601" y1="6.705" y2="3.132" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="i" x1="5.985" x2="9.571" y1="12.007" y2="6.88" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="j" x1="3.39" x2="12.575" y1="14.05" y2="13.362" gradientUnits="userSpaceOnUse"><stop offset=".312" stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FF8900"/></linearGradient><linearGradient id="k" x1="3.215" x2="15.276" y1="5.884" y2="5.884" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="l" x1="1.27" x2="25.099" y1="5.865" y2="5.107" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="m" x1="5.056" x2="8.997" y1="2.752" y2="4.887" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="n" x1="9.57" x2="12.857" y1="5.783" y2="6.215" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="o" x1="3.738" x2="4.451" y1="13.038" y2="1.237" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="p" x1="14.649" x2="9.986" y1="9.248" y2="9.248" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="q" x1="14.649" x2="9.983" y1="4.32" y2="4.32" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="r" x1="14.649" x2="9.986" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="s" x1="9.357" x2="11.786" y1="9.225" y2="9.28" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="t" x1="13.604" x2="11.129" y1="4.287" y2="4.287" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="u" x1="13.604" x2="11.129" y1="2.111" y2="2.111" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="v" x1="10.582" x2="9.261" y1="9.282" y2="9.282" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="w" x1="10.345" x2="8.826" y1="9.244" y2="9.244" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#E89043"/></linearGradient><linearGradient id="B" x1="10.74" x2="8.826" y1="4.346" y2="4.346" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="C" x1="10.334" x2="9.302" y1="4.413" y2="4.413" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="D" x1="10.672" x2="8.433" y1="2.099" y2="2.51" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="E" x1="10.44" x2="9.494" y1="2.172" y2="2.172" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="F" x1="11.949" x2="12.55" y1="9.542" y2="6.629" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="G" x1="12.406" x2="11.749" y1="3.787" y2="6.156" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="H" x1="14.649" x2="9.985" y1="6.582" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="I" x1="9.797" x2="13.369" y1="6.712" y2="6.582" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset=".738" stop-color="#FFD748"/><stop offset="1" stop-color="#FFCB4B"/></linearGradient><linearGradient id="J" x1="11.191" x2="8.523" y1="6.63" y2="6.63" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="L" x1="9.951" x2="9.108" y1="6.634" y2="6.634" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="M" x1="12.17" x2="12.677" y1="6.891" y2="3.669" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="N" x1="11.819" x2="13.117" y1="4.398" y2="1.581" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="O" x1="11.56" x2="11.75" y1="1.927" y2=".146" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="P" x1="11.605" x2="11.605" y1="2.197" y2="3.485" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="Q" x1="2.754" x2="1.091" y1="6.923" y2="11.993" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="R" x1="3.044" x2="2.949" y1="3.847" y2=".214" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="T" x1="8.129" x2="9.348" y1="9.87" y2="20.896" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="matrix(1.78622 -.4985 .23148 .82945 5.318 3.733)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(1.58576 -.05613 .03684 1.04078 12.278 9.237)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="matrix(1.70407 .00162 -.00087 .91862 12.201 4.123)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="A" cx="0" cy="0" r="1" gradientTransform="matrix(1.5602 .00147 -.00092 .9765 11.612 2.058)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="K" cx="0" cy="0" r="1" gradientTransform="matrix(1.74287 .08329 -.05467 1.14396 12.74 6.625)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="S" cx="0" cy="0" r="1" gradientTransform="matrix(.31719 -1.64272 .96366 .18607 8.786 15.45)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><clipPath id="f"><path fill="#fff" d="M0 1h16v16H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-donation-alerts" class="svg-sprite__symbol"><path fill="url(#a)" d="M18.254 4.436 14.7.301C14.525.1 14.3 0 14.05 0H3.436c-.45 0-.801.326-.851.752L1.309 15.288a.8.8 0 0 0 .226.652.85.85 0 0 0 .625.275h2.078L3.912 20l4.105-3.785h4.656a.72.72 0 0 0 .575-.25l4.38-4.26a.87.87 0 0 0 .25-.527l.526-6.14c.05-.2-.025-.426-.15-.602M15 10.026c-.025.2-.1.4-.25.525l-2.528 2.431a.84.84 0 0 1-.576.226H5.44c-.375 0-.7-.25-.8-.601-.05-.1-.05-.201-.05-.301l.75-8.522a.843.843 0 0 1 .826-.776h6.307c.25 0 .476.1.626.275L15.1 5.59c.15.175.226.4.2.627zm-4.955 1.628H8.818c-.075 0-.15-.025-.175-.075s-.075-.125-.075-.2l.1-1.229c0-.125.125-.225.25-.225h1.227c.075 0 .15.025.175.075s.075.125.075.2l-.1 1.229c0 .125-.125.225-.25.225m.225-2.33H9.018c-.15 0-.25-.1-.25-.251l.325-3.885c.025-.125.126-.226.25-.226h1.252c.15 0 .25.1.25.251l-.35 3.885c0 .125-.1.225-.225.225"/><defs><linearGradient id="a" x1="14.758" x2="-.462" y1="-1.213" y2="16.522" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none" id="svg-name-done_16" class="svg-sprite__symbol"><path fill="currentColor" d="M11.743.756a.87.87 0 0 1 0 1.237l-7.317 7.25a.88.88 0 0 1-1.242 0L.257 6.366a.87.87 0 0 1 0-1.237.88.88 0 0 1 1.242 0L3.805 7.39 10.5.756a.88.88 0 0 1 1.242 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-door_arrow_left_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M15.628 16.972c-.635.34-1.26.445-2.568.445h-2.227a.75.75 0 0 1 0-1.5h2.227c1.24 0 1.559-.106 1.86-.268q.42-.225.645-.644c.162-.302.268-.622.268-1.86V6.856c0-1.239-.106-1.559-.268-1.86a1.54 1.54 0 0 0-.644-.645c-.302-.161-.622-.268-1.86-.268h-2.212a.75.75 0 1 1-.016-1.5h2.227c1.308 0 1.933.106 2.568.445.541.29.97.719 1.26 1.26.34.635.445 1.26.445 2.568v6.287c0 1.308-.105 1.933-.445 2.568a3.04 3.04 0 0 1-1.26 1.26"/><path fill="currentColor" d="m7.803 12.804 2.053-2.053H3.25a.75.75 0 0 1 0-1.5h6.606L7.803 7.198a.75.75 0 0 1 1.06-1.06l3.334 3.332a.75.75 0 0 1 0 1.061l-3.333 3.333a.75.75 0 1 1-1.061-1.06"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-door_arrow_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.357 3H13a1 1 0 1 1 0 2h-2.6c-1.137 0-1.929 0-2.546.051-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C5.001 8.471 5 9.264 5 10.4v7.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051H13a1 1 0 1 1 0 2h-2.643c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C3 19.6 3 18.727 3 17.643v-7.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 5.73 3.544c.592-.302 1.233-.428 1.961-.487C8.4 3 9.273 3 10.357 3m8.936 6.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L21.586 15H12a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 0-1.414" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="16" height="16" viewBox="0 0 1080 1080" id="svg-name-dots" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M135 675a135 135 0 1 1 0-270 135 135 0 0 1 0 270m405 0a135 135 0 1 1 0-270 135 135 0 0 1 0 270m405 0a135 135 0 1 1 0-270 135 135 0 0 1 0 270"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download" class="svg-sprite__symbol"><path fill="currentColor" d="M3.293 9.707a1 1 0 0 1 1.414-1.414zM10 15l.707.707a1 1 0 0 1-1.414 0zm5.293-6.707a1 1 0 1 1 1.414 1.414zm-10.586 0 6 6-1.414 1.414-6-6zm4.586 6 6-6 1.414 1.414-6 6z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 19h18M10 1v13"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download-thin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 19.25h18.5M10 17V2m0 15-6.5-6.5M10 17l6.5-6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-download_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4 17.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/><path fill="currentColor" d="M10.75 2.726c0-.401-.336-.726-.75-.726a.74.74 0 0 0-.75.726v9.722l-3.97-3.97a.75.75 0 0 0-1.06 1.06l5.245 5.246a.75.75 0 0 0 1.06 0l5.256-5.256a.75.75 0 0 0-1.06-1.061l-3.972 3.971z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-download_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.502 2a.9.9 0 0 1 .9.9v11.002l4.562-4.631a.9.9 0 0 1 1.283 1.263l-6.104 6.195a.9.9 0 0 1-1.283-.001l-6.09-6.206a.9.9 0 0 1 1.285-1.26l4.547 4.634V2.9a.9.9 0 0 1 .9-.9m-8 18.1a.9.9 0 0 1 .9-.9h14.2a.9.9 0 0 1 0 1.8h-14.2a.9.9 0 0 1-.9-.9" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-download_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM14 2a1 1 0 0 1 1 1v13.585l5.293-5.292a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L13 16.585V3a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-draggable" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" id="svg-name-dropdown_12" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.156 2.295a.75.75 0 0 1 1.051-.137L6 4.306l2.793-2.148a.75.75 0 0 1 .914 1.189l-3.25 2.5a.75.75 0 0 1-.914 0l-3.25-2.5a.75.75 0 0 1-.137-1.052" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="12" fill="none" id="svg-name-dropdown_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="m8 6.778 3.773-3.107a.75.75 0 0 1 .954 1.158l-4.25 3.5a.75.75 0 0 1-.954 0l-4.25-3.5a.75.75 0 0 1 .954-1.158z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-edit" class="svg-sprite__symbol"><path fill="currentColor" d="M9.5 2.75a.75.75 0 0 0 0-1.5zm9.25 7.75a.75.75 0 0 0-1.5 0zM3 19.75h13v-1.5H3zm6.5-18.5H3v1.5h6.5zM18.75 17v-6.5h-1.5V17zM.25 4v13h1.5V4zM3 1.25A2.75 2.75 0 0 0 .25 4h1.5c0-.69.56-1.25 1.25-1.25zm0 17c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 0 0 3 19.75zm13 1.5A2.75 2.75 0 0 0 18.75 17h-1.5c0 .69-.56 1.25-1.25 1.25z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m17.07 4.93-7.724 7.724-3.476 1.159 1.159-3.476 7.723-7.723M17.07 4.93l-2.317-2.317M17.07 4.93 18.5 3.5a.71.71 0 0 0 0-1.003l-1.314-1.313a.71.71 0 0 0-1.004 0l-1.429 1.429"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-edit_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.56 2.382a2.14 2.14 0 0 0-1.945 0c-.306.156-.572.422-.879.73l-9.393 9.394c-.253.253-.435.434-.584.64-.298.41-.495.885-.575 1.386-.04.251-.04.508-.04.866v.802c0 .201-.001.449.07.67.142.434.483.775.918.917.22.072.468.07.67.07h.802c.357 0 .614 0 .865-.04.501-.08.976-.276 1.387-.574.205-.15.387-.331.64-.584l9.393-9.394c.308-.307.575-.573.73-.878a2.14 2.14 0 0 0 0-1.946c-.155-.306-.422-.571-.73-.879l-.45-.45c-.307-.308-.573-.574-.879-.73m-1.297 1.273a.71.71 0 0 1 .649 0c.075.038.17.12.585.535l.314.315c.416.415.497.51.536.585a.71.71 0 0 1 0 .648c-.039.076-.12.17-.536.585l-.613.613-2.132-2.133.612-.613c.416-.415.51-.497.585-.535m-2.207 2.158L4.389 13.48c-.304.303-.4.402-.475.505a1.8 1.8 0 0 0-.319.77c-.02.127-.022.264-.022.694v.693c0 .141 0 .218.004.274v.008h.009c.055.004.132.004.273.004h.693c.43 0 .568-.002.694-.022.278-.044.542-.153.77-.319.103-.075.202-.17.506-.475l7.666-7.666z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-embed" class="svg-sprite__symbol"><path fill="currentColor" d="M11.735 5.147a.75.75 0 1 0-1.47-.294zm-3.47 9.706a.75.75 0 1 0 1.47.294zm-2.792-1.36a.75.75 0 0 0 1.054-1.07zM3 10l-.527-.534a.75.75 0 0 0 0 1.068zm3.527-2.424a.75.75 0 0 0-1.054-1.068zm6.95 4.802a.75.75 0 1 0 1.046 1.076zM17 10l.523.538a.75.75 0 0 0 .007-1.068zm-2.47-3.53a.75.75 0 1 0-1.06 1.06zm-4.265-1.617-2 10 1.47.294 2-10zm-3.738 7.57-3-2.957-1.054 1.068 3 2.958zm-3-1.889 3-2.958-1.054-1.068-3 2.958zm10.996 2.92 3-2.916-1.046-1.076-3 2.916zM17.53 9.47l-3-3-1.06 1.06 3 3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-empty" class="svg-sprite__symbol"><path fill="currentColor" d="M6.25 7.321c-2.322 0-3.631 5.239-5 7.679-.12 1.548.893 4.107 8.393 4.286 7.01.167 8.75-2.322 8.75-3.75-.536-1.072-2.143-4.465-3.75-4.465s-1.607 2.143-3.572 2.143c-1.964 0-2.5-5.893-4.821-5.893"/><path fill="currentColor" fill-rule="evenodd" d="M5.377 18.292c.807.262 1.853.28 4.623.28s3.816-.018 4.623-.28a5.72 5.72 0 0 0 3.669-3.669c.262-.807.28-1.853.28-4.623s-.018-3.816-.28-4.623a5.71 5.71 0 0 0-3.669-3.669c-.807-.262-1.853-.28-4.623-.28s-3.816.018-4.623.28a5.71 5.71 0 0 0-3.669 3.669c-.262.807-.28 1.853-.28 4.623s.018 3.816.28 4.623a5.71 5.71 0 0 0 3.669 3.669M.35 4.936C0 6.012 0 7.34 0 10s0 3.989.35 5.064a7.14 7.14 0 0 0 4.586 4.586C6.012 20 7.34 20 10 20s3.989 0 5.064-.35a7.14 7.14 0 0 0 4.586-4.586C20 13.99 20 12.66 20 10s0-3.988-.35-5.064A7.14 7.14 0 0 0 15.064.35C13.99 0 12.66 0 10 0S6.012 0 4.936.35A7.14 7.14 0 0 0 .35 4.936" clip-rule="evenodd"/><path fill="currentColor" d="M13.764 8.241a1.978 1.978 0 1 0 0-3.955 1.978 1.978 0 0 0 0 3.955"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="92" height="81" fill="none" id="svg-name-empty-search" class="svg-sprite__symbol"><path fill="#303030" fill-rule="evenodd" d="M68.036 5.499c11.61 5.409 19.692 16.597 21.92 29.227 2.433 13.787.449 29.288-9.933 38.699-10.029 9.09-24.852 6.857-38.229 4.957-12.81-1.82-26.274-4.512-33.62-15.163C.455 52.027-1.657 36.626 4.678 24.567 10.377 13.72 24.558 13.248 36.28 9.72 47.042 6.481 57.861.76 68.036 5.5" clip-rule="evenodd"/><circle cx="39" cy="28" r="26" stroke="#F1F1F1" stroke-width="3"/><path fill="#F1F1F1" d="M74.938 66.06a1.5 1.5 0 0 0 2.122-2.12zm-19-19 19 19 2.122-2.12-19-19zM29.04 38.848a1.5 1.5 0 1 0 1.921 2.304zm18 2.304a1.5 1.5 0 1 0 1.921-2.304zM30.002 40l.96 1.153h-.001l-.001.002h-.002.001a2 2 0 0 1 .11-.086c.088-.066.227-.166.412-.29.372-.247.928-.585 1.641-.925 1.43-.68 3.459-1.354 5.88-1.354v-3c-2.978 0-5.45.827-7.17 1.646-.862.41-1.543.822-2.015 1.137a12 12 0 0 0-.766.557l-.007.006h-.001c0 .001-.001.002.96 1.154m9-1.5c2.422 0 4.45.673 5.88 1.354.713.34 1.27.678 1.641.925a9 9 0 0 1 .522.376q.002 0 0 0l-.002-.001v-.001l.96-1.153c.96-1.152.959-1.153.959-1.153h-.002l-.007-.007-.06-.049-.154-.118c-.13-.098-.315-.232-.552-.39a16 16 0 0 0-2.015-1.137c-1.72-.82-4.191-1.646-7.17-1.646z"/><circle cx="29.999" cy="24" r="4" fill="#F1F1F1"/><circle cx="48" cy="24" r="4" fill="#F1F1F1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-error" class="svg-sprite__symbol"><path fill="#CD3544" fill-rule="evenodd" d="M7.888 2.308c.881-1.41 2.935-1.41 3.816 0l7.294 11.67c.936 1.498-.141 3.442-1.908 3.442H2.502c-1.767 0-2.844-1.944-1.908-3.443zm2.544.795a.75.75 0 0 0-1.272 0l-7.294 11.67a.75.75 0 0 0 .636 1.147H17.09a.75.75 0 0 0 .636-1.148z" clip-rule="evenodd"/><circle cx="10.05" cy="13.05" r=".75" fill="#CD3544" transform="rotate(-180 10.05 13.05)"/><rect width="1.5" height="5" x="10.8" y="11.3" fill="#CD3544" rx=".75" transform="rotate(-180 10.8 11.3)"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-error-outline" class="svg-sprite__symbol"><g clip-path="url(#a)"><path stroke="#CD3544" stroke-width="2" d="M8.524 2.705a1.5 1.5 0 0 1 2.544 0l7.294 11.67a1.5 1.5 0 0 1-1.272 2.295H2.502a1.5 1.5 0 0 1-1.272-2.295z"/><path stroke="#CD3544" stroke-linecap="round" stroke-width="2" d="M10 7v3"/><circle cx="10" cy="13" r="1" fill="#CD3544"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-error_circle_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4" clip-rule="evenodd"/><path fill="currentColor" d="M8.9 11.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-error_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.93 4.929A9.97 9.97 0 0 1 12 2a9.97 9.97 0 0 1 7.071 2.929A9.97 9.97 0 0 1 22.001 12a9.97 9.97 0 0 1-2.929 7.071A9.97 9.97 0 0 1 12.001 22a9.97 9.97 0 0 1-7.071-2.929A9.97 9.97 0 0 1 2 12 9.97 9.97 0 0 1 4.93 4.929M12 3.8a8.17 8.17 0 0 0-5.798 2.402A8.17 8.17 0 0 0 3.8 12c0 2.265.917 4.313 2.402 5.798A8.17 8.17 0 0 0 12 20.2a8.17 8.17 0 0 0 5.798-2.402A8.17 8.17 0 0 0 20.201 12a8.17 8.17 0 0 0-2.402-5.798A8.17 8.17 0 0 0 12.001 3.8" clip-rule="evenodd"/><path fill="currentColor" d="M13.001 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M12.001 7a.9.9 0 0 1 .9.9v5.2a.9.9 0 0 1-1.8 0V7.9a.9.9 0 0 1 .9-.9" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-error_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M28 4c13.255 0 24 10.745 24 24S41.255 52 28 52 4 41.255 4 28 14.745 4 28 4m0 3C16.402 7 7 16.402 7 28s9.402 21 21 21 21-9.402 21-21S39.598 7 28 7m0 27a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-17.5a1.5 1.5 0 0 1 1.5 1.5v11l-.007.145A1.5 1.5 0 0 1 26.5 29V18l.007-.145A1.5 1.5 0 0 1 28 16.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-error_triangle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M30.598 8.5 48.785 40c1.155 2-.289 4.5-2.598 4.5H9.814c-2.31 0-3.753-2.5-2.598-4.5L25.402 8.5c1.155-2 4.041-2 5.196 0M22.804 7c2.31-4 8.083-4 10.392 0l18.187 31.5c2.31 4-.578 9-5.196 9H9.814c-4.62 0-7.506-5-5.197-9z" clip-rule="evenodd"/><path fill="currentColor" d="M30 36a2 2 0 1 0-4 0 2 2 0 0 0 4 0M29.5 18a1.5 1.5 0 0 0-2.993-.145L26.5 18v11a1.5 1.5 0 0 0 2.993.145L29.5 29z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-expand" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 10H7m9 0-5.2 5m5.2-5-5.2-5"/><path fill="currentColor" d="M3.25 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zm0 10V5h-1.5v10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-expand-full-size" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M21.6 13.202v4.8a3.6 3.6 0 0 1-3.6 3.6H6a3.6 3.6 0 0 1-3.6-3.6v-12a3.6 3.6 0 0 1 3.6-3.6h4.8"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.6 2.4v6m0-6h-6m6 0L12 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-expand-stream" class="svg-sprite__symbol"><path fill="currentColor" d="M9.47 9.47a.75.75 0 1 1 1.06 1.06zM4 16v.75a.75.75 0 0 1-.75-.75zm-.75-6a.75.75 0 0 1 1.5 0zM10 15.25a.75.75 0 0 1 0 1.5zm.53-4.72-6 6-1.06-1.06 6-6zM3.25 16v-6h1.5v6zm.75-.75h6v1.5H4z"/><path fill="currentColor" d="M6.03 15.03a.75.75 0 0 1-1.06-1.06zM16 4v-.75a.75.75 0 0 1 .75.75zm.75 6a.75.75 0 0 1-1.5 0zM10 4.75a.75.75 0 0 1 0-1.5zm-5.03 9.22 10.5-10.5 1.06 1.06-10.5 10.5zM16.75 4v6h-1.5V4zm-.75.75h-6v-1.5h6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-export" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 18.5H4.5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 18.5v-6.2m0 6.2 2.692-3m-2.693 3-2.692-3"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M19 10c0 2-4.03 6.5-9 6.5s-9-5-9-6.5 4.03-6.5 9-6.5S19 8 19 10Z"/><circle cx="10" cy="10" r="2.25" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-close" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M10.439 10v4m0-4c1.663 0 3.221-.399 4.561-.99m-4.561.99c-1.585 0-3.074-.402-4.37-.99M19 6c-.716 1.009-2.15 2.193-4 3.01M2 6c.777.965 2.228 2.175 4.069 3.01m8.931 0 2.5 3.49M6.069 9.01 3.5 12.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-smoothed" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 9.992c0 2.84-3.582 5.143-8 5.143s-8-2.302-8-5.143S5.582 4.85 10 4.85s8 2.302 8 5.142" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9.99a2.001 2.001 0 1 1-4 0 2.001 2.001 0 1 1 4 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-eye-smoothed-struck-out" class="svg-sprite__symbol"><path fill="currentColor" d="M10 4.709a.75.75 0 0 0 0-1.5zm-5.338 8.897a.75.75 0 1 0 .676-1.339zm5.336-10.4a.75.75 0 0 0 .004 1.5zm2.97 1.884a.75.75 0 1 0 .386-1.45zM4.448 16.56a.75.75 0 0 0 1.104 1.016zm4.046-2.178a.75.75 0 0 0-1.103-1.016zM18.55 3.456a.75.75 0 0 0-1.105-1.014zm-3.41 1.497a.75.75 0 0 0 1.106 1.015zm-7.75 8.414a.75.75 0 0 0 1.103 1.016zm3.294-2.47.552.509zm1.24-1.349-.552-.508zm4.317-3.581a.75.75 0 1 0-1.103-1.016zm-8.177 7.168a.75.75 0 1 0-.246 1.48zm1.934.909v-.75zm8-5.042h.75q0-.027-.002-.054zm-1.957-4.206a.75.75 0 1 0-.702 1.326zm-8.272 5.829a.75.75 0 0 0 1.217-.877zm.445-2.534.67.34zm1.787-1.107L10 6.234h-.005zm.654.937a.75.75 0 0 0 .796-1.27zM10 3.21c-2.329 0-4.472.593-6.057 1.592C2.368 5.794 1.25 7.26 1.25 9h1.5c0-1.044.673-2.1 1.993-2.931C6.053 5.244 7.91 4.709 10 4.709zM1.25 9c0 1.992 1.456 3.618 3.412 4.605l.676-1.339c-1.701-.859-2.588-2.075-2.588-3.266zm8.752-4.295a11.4 11.4 0 0 1 2.966.384l.386-1.45a12.9 12.9 0 0 0-3.356-.434zm-4.45 12.87 2.942-3.195-1.103-1.016-2.943 3.194zM17.445 2.441l-2.304 2.511 1.105 1.015 2.304-2.512zm-8.952 11.94 2.743-2.976-1.103-1.017-2.743 2.978zm2.743-2.977 1.24-1.35-1.104-1.014-1.24 1.35zm1.24-1.349 3.765-4.089-1.103-1.016-3.766 4.089zm-4.658 4.559q1.083.18 2.181.179l-.001-1.5q-.974 0-1.934-.16zm2.18.179c2.329 0 4.472-.593 6.057-1.592 1.575-.993 2.693-2.459 2.693-4.2h-1.5c0 1.043-.673 2.099-1.993 2.93-1.31.826-3.167 1.362-5.257 1.362zm8.748-5.846a5.11 5.11 0 0 0-2.705-4.152l-.702 1.326a3.61 3.61 0 0 1 1.911 2.933zm-9.76.8a1.27 1.27 0 0 1-.103-1.318l-1.338-.678a2.77 2.77 0 0 0 .224 2.873zM8.883 8.43a1.27 1.27 0 0 1 1.124-.696l-.012-1.5a2.77 2.77 0 0 0-2.45 1.518zm1.119-.696c.23 0 .457.065.653.187l.796-1.27A2.73 2.73 0 0 0 10 6.233z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-favorite_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.983 4.694a.577.577 0 0 0-1.078 0l-1.57 3.9a.88.88 0 0 1-.752.554l-4.01.267c-.52.034-.738.698-.347 1.05l3.176 2.858c.245.22.35.563.274.888l-.904 3.852c-.12.513.415.924.859.66l3.376-2.002c.27-.16.603-.16.874 0l3.376 2.003c.444.263.978-.148.858-.66l-.904-3.853a.92.92 0 0 1 .275-.888l3.175-2.858c.392-.352.173-1.016-.346-1.05l-4.01-.267a.88.88 0 0 1-.753-.554zm-2.695-.688a2.31 2.31 0 0 1 4.312 0l1.36 3.382 3.467.23c2.077.138 2.953 2.792 1.387 4.202l-2.777 2.499.78 3.322c.48 2.05-1.659 3.696-3.435 2.642l-2.938-1.744-2.939 1.744c-1.776 1.054-3.915-.592-3.434-2.642l.78-3.322-2.777-2.5c-1.566-1.41-.69-4.063 1.386-4.2l3.467-.23z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-favorite_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m36.682 16.815.047.112.122.01 7.784.621c1.1.088 2.12.17 2.92.305.735.125 2.007.39 2.983 1.368a5 5 0 0 1 1.4 4.318c-.218 1.364-1.093 2.325-1.615 2.856-.57.58-1.346 1.244-2.187 1.96l-5.912 5.045-.093.08q.014.054.029.118l1.81 7.556c.256 1.07.493 2.06.611 2.862.109.736.25 2.024-.375 3.253a5 5 0 0 1-3.664 2.669c-1.361.218-2.544-.31-3.212-.64-.727-.358-1.597-.887-2.536-1.459l-6.69-4.07-.103-.063-.104.063-6.69 4.07c-.939.572-1.809 1.101-2.536 1.46-.667.329-1.85.858-3.211.639a5 5 0 0 1-3.664-2.67c-.625-1.228-.484-2.516-.376-3.252.119-.802.356-1.793.612-2.862l1.81-7.556.028-.119-.093-.08-5.912-5.044c-.84-.716-1.618-1.38-2.187-1.96-.521-.53-1.397-1.492-1.614-2.856a5 5 0 0 1 1.4-4.318c.975-.978 2.248-1.243 2.982-1.368.801-.136 1.82-.217 2.92-.305l.123-.01 7.661-.611.122-.01.047-.113 2.96-7.089.048-.113c.422-1.013.814-1.95 1.19-2.667.347-.658.992-1.78 2.219-2.403a5 5 0 0 1 4.53 0c1.227.624 1.872 1.745 2.218 2.403.376.716.768 1.654 1.19 2.667zm-9.587-9.598c-.656.333-1.12 1.444-2.047 3.664l-2.96 7.09c-.274.654-.41.981-.63 1.23a2 2 0 0 1-.704.51c-.304.132-.658.16-1.365.216l-7.66.612c-2.415.193-3.621.29-4.143.811a2 2 0 0 0-.56 1.727c.117.729 1.038 1.515 2.88 3.086l5.818 4.964c.542.463.813.694.982.98a2 2 0 0 1 .27.83c.032.331-.051.677-.217 1.37l-1.78 7.436c-.563 2.346-.843 3.519-.51 4.175a2 2 0 0 0 1.466 1.068c.727.117 1.758-.51 3.818-1.764l6.584-4.005c.605-.368.907-.552 1.23-.624.286-.063.582-.063.867 0 .323.072.626.256 1.23.624l6.584 4.005c2.06 1.254 3.091 1.88 3.818 1.764a2 2 0 0 0 1.466-1.068c.334-.656.053-1.83-.509-4.175l-1.78-7.436c-.166-.693-.25-1.039-.218-1.37.028-.293.12-.577.27-.83.17-.286.44-.517.982-.98l5.819-4.964c1.842-1.571 2.763-2.357 2.879-3.086a2 2 0 0 0-.56-1.727c-.521-.522-1.728-.618-4.142-.811l-7.66-.612c-.708-.056-1.061-.084-1.366-.216-.269-.117-.51-.29-.703-.51-.22-.249-.357-.576-.63-1.23l-2.96-7.09c-.928-2.22-1.391-3.33-2.047-3.664a2 2 0 0 0-1.812 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="21" id="svg-name-fb" class="svg-sprite__symbol"><path fill="#FFF" fill-rule="evenodd" d="M19.845 0H1.159A1.16 1.16 0 0 0 0 1.159v18.682A1.16 1.16 0 0 0 1.16 21h10.06v-8.132H8.481v-3.17h2.737V7.362c0-2.712 1.657-4.19 4.077-4.19q1.226-.003 2.446.126V6.13h-1.678c-1.317 0-1.574.626-1.574 1.543v2.024h3.139l-.409 3.17h-2.73V21h5.35A1.16 1.16 0 0 0 21 19.841V1.159C21 .52 20.484.002 19.845 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-file" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M3.5 17.5v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V17.5a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1Z"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="20" id="svg-name-file-white" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#242B2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M2.403 1.043a1.31 1.31 0 0 0-1.364 1.25v15.423a1.31 1.31 0 0 0 1.364 1.25h12.234A1.31 1.31 0 0 0 16 17.716V5.185a1.2 1.2 0 0 0-.4-.884l-3.292-3.018a1.43 1.43 0 0 0-.964-.366z"/><path d="M10 2v3.4c0 .789.64 1.428 1.428 1.429H15"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-file-with-arrow-down" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 18.5H4.5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h8.086a1 1 0 0 1 .707.293l3.914 3.914a1 1 0 0 1 .293.707V9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 18.5v-6.2m0 6.2 2.692-3m-2.692 3-2.692-3"/><path stroke="currentColor" stroke-width="1.5" d="M12.5 1.5v4a1 1 0 0 0 1 1H17"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-filter" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 15v3M6 2v9M14 2v3M14 9v9"/><circle cx="6" cy="13" r="2" stroke="currentColor" stroke-width="1.5"/><circle cx="14" cy="7" r="2" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-filter-button" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M2 2v1.63a1 1 0 0 0 .24.65L8 11h4l5.76-6.72a1 1 0 0 0 .24-.65V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1ZM8 11v6.382a1 1 0 0 0 1.447.894l2-1a1 1 0 0 0 .553-.894V11"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="none" id="svg-name-fire-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M2.92 9.486 2.735 8.02l-.743 1.276c-.384.66-.892 1.851-.892 3.523 0 1.048.643 2.41 1.716 3.493 1.09 1.1 2.682 1.976 4.662 1.976a7.42 7.42 0 0 0 4.827-1.788c1.21-1.044 2.002-2.447 2.002-3.813 0-.92-.25-2.114-.843-2.99l-.802-1.185-.111 1.426a3.4 3.4 0 0 1-.118.693q-.056.188-.126.31c.048-.212.099-.467.141-.746.112-.738.179-1.736-.116-2.525l-.448-1.2-.483 1.186c-.077.188-.17.383-.273.543-.184-.855-.8-1.387-1.345-1.857l-.044-.038c-.502-.435-.956-.835-1.257-1.4-.291-.544-.46-1.287-.271-2.427l.176-1.056-.923.543c-.786.463-2.305 1.747-1.93 4.324v.001a3.5 3.5 0 0 1-.12 1.534L5.386 7.8c-.145-.145-.333-.482-.341-1.007L5.028 5.59l-.84.86c-.4.41-1.06 1.218-1.06 2.204 0 .794.222 1.627.407 2.18-.362-.314-.549-.82-.615-1.348Zm7.953-.996Z"/><path fill="url(#b)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454"/><path fill="url(#c)" d="M2.424 9.548c-.349.598-.824 1.704-.824 3.27 0 1.751 2.23 4.97 5.878 4.97 3.562 0 6.33-2.743 6.33-5.1 0-.853-.236-1.94-.758-2.712-.038.485-.156 1.144-.518 1.488a.83.83 0 0 1-.682.23l-.264-.023.08-.25c.01-.023.692-2.254.198-3.576-.198.484-.537 1.11-.951 1.143l-.235.02.004-.236c.02-.974-.578-1.492-1.27-2.09-.988-.856-2.104-1.826-1.694-4.287-.687.405-2.024 1.52-1.69 3.822.17 1.152-.23 2.009-.244 2.047l-.047.098-.104.02c-.198.037-.405-.043-.593-.222-.254-.25-.485-.72-.494-1.36-.386.395-.918 1.078-.918 1.854 0 1.275.622 2.65.626 2.664l.174.386-.414-.09c-1.082-.235-1.487-1.242-1.59-2.066" opacity=".5"/><path fill="url(#d)" d="M7.167 3.2c-1.562 2.447.466 5.03-.579 6.579s-2.103.117-2.174-.852c0 0 .01 3.134 1.558 4.372s-2.979.97-3.6-.541c0 0 0 5.03 5.106 5.03s5.957-4.682 5.957-4.682-1.859 1.586-3.096.348c0 0 .927-1.623 1.162-3.29 0 0-.64.405-1.623.25 0 0 .546-2.339-.57-3.106-1.43-.983-2.64-3.327-2.14-4.108"/><path fill="url(#e)" d="M7.558 6.08c-.82 1.078.776 3.845-.9 4.941-.926.607-1.458-.122-1.458-.122s.25 1.12 1.247 2.117c.998.998-1.501 2.349-3.53.603 0 0 .697 4.193 5.417 3.487 5.21-.777 4.824-4.65 4.824-4.65s-1.412 2.222-3.422 1.158c0 0 1.266-1.765 1.266-2.776 0 0-.856.508-1.835.018 0 0 .466-2.353-.09-2.705-1.331-.852-1.52-2.071-1.52-2.071"/><path fill="url(#f)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#g)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#h)" d="M1.92 11.727c.108 2.659 2.297 5.845 5.718 5.845s5.13-3.61 5.237-5.723c0 0-.64 1.243-2.084 1.492-1.445.25.098-2.484-.913-4.103 0 0-.894 2.819-2.165 2.922s-2.348-1.864-2.348-2.922c0 0-.781 1.906-.588 3.42.296 2.302-2.857-.93-2.857-.93"/><path fill="url(#i)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#j)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".5"/><path fill="url(#k)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><path fill="url(#l)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><path fill="url(#m)" d="M10.894 8.772C10.946 6.169 6.993 6.527 8.01 2c0 0-2.654 1.045-2.188 4.25.16 1.1-.226 1.924-.226 1.924-.39.08-.997-.696-.786-1.896 0 0-1.393 1.04-1.393 2.376 0 1.337.645 2.753.645 2.753-1.605-.348-1.445-2.513-1.445-2.513S1.6 10.254 1.6 12.82C1.6 14.814 3.85 18 7.478 18s6.54-2.814 6.54-5.318c0-1.096-.371-2.513-1.176-3.284 0 0 .109 2.188-.974 2.084 0 0 .894-2.856-.042-4.164 0 0-.452 1.411-.932 1.454" opacity=".25"/><defs><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="matrix(6.49825 0 0 5.27528 7.727 14.26)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset=".294" stop-color="#FFBF4B" stop-opacity=".707"/><stop offset=".562" stop-color="#FEC656" stop-opacity=".438"/><stop offset=".82" stop-color="#FCD368" stop-opacity=".18"/><stop offset="1" stop-color="#FBE07A" stop-opacity="0"/></radialGradient><radialGradient id="g" cx="0" cy="0" r="1" gradientTransform="matrix(6.298 0 0 5.11272 7.727 13.994)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="matrix(7.73665 0 0 9.00779 4.966 15.155)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C" stop-opacity=".6"/><stop offset=".948" stop-color="#FFED1C" stop-opacity=".026"/><stop offset=".991" stop-color="#FFED1C" stop-opacity="0"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="matrix(-.12318 2.44205 -1.98235 -.1 7.728 13.993)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="translate(8.462 3.042)scale(8.66023)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FF4C00"/><stop offset=".135" stop-color="#FF5B0C" stop-opacity=".866"/><stop offset=".394" stop-color="#FF842C" stop-opacity=".607"/><stop offset=".749" stop-color="#FFC45F" stop-opacity=".251"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="k" cx="0" cy="0" r="1" gradientTransform="translate(12.401 10.058)scale(4.59671)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C"/><stop offset=".2" stop-color="#FFEE2B" stop-opacity=".801"/><stop offset=".584" stop-color="#FFF254" stop-opacity=".417"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="translate(2.992 11.696)scale(4.8995)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFED1C"/><stop offset=".2" stop-color="#FFEE2B" stop-opacity=".801"/><stop offset=".584" stop-color="#FFF254" stop-opacity=".417"/><stop offset="1" stop-color="#FFF686" stop-opacity="0"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="rotate(86.11 -1.902 9.449)scale(8.39248 5.10177)" gradientUnits="userSpaceOnUse"><stop stop-color="#FF4C00" stop-opacity="0"/><stop offset=".987" stop-color="#FF4C00" stop-opacity=".989"/><stop offset=".999" stop-color="#FF4C00"/></radialGradient><linearGradient id="a" x1="8.528" x2="2.224" y1="14.881" y2="-3.122" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".639" stop-color="#FF5B00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="b" x1="8.605" x2="5.72" y1="18.442" y2="-2.464" gradientUnits="userSpaceOnUse"><stop stop-color="red"/><stop offset=".232" stop-color="#FF1500"/><stop offset=".737" stop-color="#FF3D00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="c" x1="8.528" x2="2.224" y1="14.881" y2="-3.122" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".639" stop-color="#FF5B00"/><stop offset=".999" stop-color="#FF4C00"/></linearGradient><linearGradient id="d" x1="6.08" x2="8.359" y1="2.867" y2="15.653" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8000"/><stop offset=".023" stop-color="#FE7F02" stop-opacity=".977"/><stop offset=".666" stop-color="#ED582A" stop-opacity=".334"/><stop offset="1" stop-color="#E74939" stop-opacity="0"/></linearGradient><linearGradient id="e" x1="7.85" x2="8.342" y1="16.684" y2="7.706" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47"/><stop offset=".187" stop-color="#FFB137" stop-opacity=".813"/><stop offset=".722" stop-color="#FF940F" stop-opacity=".278"/><stop offset="1" stop-color="#FF8900" stop-opacity="0"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-flag" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M4 2v16M6 3v8M6 3h9l-2.454 4L15 11H6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none" id="svg-name-game_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7 .5H5c-3.75 0-5 3-5 6C0 8.25.5 10 2 10c.655 0 1.024-.524 1.44-1.114C3.976 8.123 4.59 7.25 6 7.25h2c1.409 0 2.024.873 2.56 1.636.416.59.785 1.114 1.44 1.114 1.5 0 2-1.75 2-3.5 0-3-1.25-6-5-6zm2 4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6-1a.5.5 0 0 1 1 0V4h.5a.5.5 0 0 1 0 1H4v.5a.5.5 0 0 1-1 0V5h-.5a.5.5 0 0 1 0-1H3z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-game_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.5 4h-3c-2.317 0-4.245.431-5.577 1.761C1.593 7.088 1.02 9.147 1 11.995c-.005.8.055 1.982.455 2.99.204.512.511 1.02.98 1.402.483.391 1.09.613 1.815.613.8 0 1.374-.327 1.811-.77.311-.314.58-.722.805-1.066q.084-.13.161-.243c.284-.418.556-.759.916-1.005.344-.235.819-.416 1.557-.416h1c.74 0 1.214.181 1.558.416.36.246.632.587.915 1.005q.077.113.162.243c.226.344.494.752.805 1.066.437.443 1.011.77 1.81.77.725 0 1.333-.222 1.815-.613.47-.382.777-.89.98-1.402.4-1.008.461-2.19.455-2.99-.02-2.848-.593-4.907-1.922-6.234C15.745 4.431 13.818 4 11.5 4m-1 8h-1c-1.01 0-1.786.256-2.403.678-.601.41-1.001.944-1.311 1.4q-.124.184-.225.339c-.212.32-.37.56-.567.759-.21.213-.418.324-.744.324-.4 0-.668-.115-.868-.277q-.319-.259-.533-.792c-.29-.728-.354-1.67-.349-2.426.02-2.707.572-4.273 1.483-5.182C4.89 5.916 6.317 5.5 8.5 5.5h3c2.183 0 3.61.417 4.518 1.323.911.91 1.463 2.475 1.482 5.182.006.756-.06 1.698-.349 2.426q-.213.534-.532.792c-.2.162-.469.277-.869.277-.326 0-.533-.11-.743-.324-.197-.199-.355-.439-.567-.759l-.225-.338c-.31-.457-.71-.991-1.311-1.402-.617-.42-1.392-.677-2.404-.677M7.25 7.5a.75.75 0 1 0-1.5 0v.75H5a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 0 0 1.5 0v-.75H8a.75.75 0 1 0 0-1.5h-.75zm5.25.75a.75.75 0 0 0 0 1.5h2a.75.75 0 1 0 0-1.5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-game_outline_24" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M17.123 4.2c2.904 0 4.83 1.834 5.893 4.875.71 2.031.984 4.397.984 6.739 0 3.407-.837 4.757-3.39 4.757-1.254 0-2.115-.794-3.638-2.76-1.219-1.573-1.682-2.062-1.841-2.062H8.869c-.195 0-.835.616-2.034 2.065l-.016.02C5.037 19.987 4.435 20.57 3.39 20.57.837 20.57 0 19.22 0 15.813c0-2.34.275-4.707.984-6.738 1.062-3.04 2.989-4.876 5.893-4.876zm0 1.8H6.877C3.269 6 1.8 10.205 1.8 15.813c0 2.539.259 2.957 1.59 2.957.192 0 .826-.615 2.042-2.085l.017-.02c1.75-2.115 2.375-2.717 3.42-2.717h6.262c1.065 0 1.4.355 3.264 2.76 1.123 1.449 1.787 2.062 2.215 2.062 1.331 0 1.59-.418 1.59-2.958C22.2 10.206 20.73 6 17.123 6M7.14 7.712c.317 0 .574.258.574.575v1.14h1.14c.317 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-1.14v1.14a.574.574 0 0 1-.574.574h-.566A.574.574 0 0 1 6 12.282v-1.14H4.86a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574H6v-1.14c0-.317.257-.575.574-.575zm10.286 3.43c.317 0 .574.256.574.573v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574zM15.71 9.427c.318 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-.565a.574.574 0 0 1-.575-.574v-.566c0-.317.258-.574.575-.574zm3.429 0c.317 0 .574.257.574.574v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574zm-1.714-1.715c.317 0 .574.258.574.575v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.575v-.565c0-.317.257-.575.574-.575z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" id="svg-name-gb" class="svg-sprite__symbol"><clipPath id="a"><path d="M30 15h30v15zv15H0zH0V0zV0h30z"/></clipPath><path fill="#00247d" d="M0 0v30h60V0z"/><path stroke="#fff" stroke-width="6" d="m0 0 60 30m0-30L0 30"/><path stroke="#cf142b" stroke-width="4" d="m0 0 60 30m0-30L0 30" clip-path="url(#a)"/><path stroke="#fff" stroke-width="10" d="M30 0v30M0 15h60"/><path stroke="#cf142b" stroke-width="6" d="M30 0v30M0 15h60"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gear" class="svg-sprite__symbol"><path fill="currentColor" d="m8.544 2.165-.747-.067zm2.54-.1-.74.126zm.108.633-.74.127zm1.054 1.189-.248.708zm1.73-.148.431.614zm.407-.285-.43-.614zm1.745.144-.526.535zm.168 1.751-.618-.425zm-.364.53.618.425zm-.145 1.61.691-.291zm1.925 1.228-.123.74zm.022 2.638.136.737zm-.44.08.136.738zm-1.179 1.059-.708-.248zm.15 1.74.613-.43zm.281.402-.614.43zm-.144 1.745.535.526zm-1.751.168-.425.619zm-.528-.362-.425.618zm-1.614-.146-.29-.692zm-1.132 1.333-.74-.127zm-.09.517.74.128zm-2.63 0 .738-.127zm-.102-.588-.74.127zM7.505 16.1l.262-.702zm-1.737.145-.436-.61zm-.398.284.436.61zm-1.754-.146-.53.53zM3.47 14.63l-.61-.436zm.324-.453.61.436zm.161-1.621-.691.29zm-1.319-1.121-.127.739zm-.55-.095.126-.74zm.053-2.584-.096-.744zm.428-.055.096.744zm1.357-1.153.702.265zm-.162-1.703.608-.44zm-.283-.391-.608.44zm.161-1.735.516.544zm1.678-.117-.435.61zm.484.346.436-.61zm1.663.134.267.701zm1.02-1.268.747.068zM9.82.25c-1.05 0-1.928.801-2.023 1.848l1.494.135a.53.53 0 0 1 .53-.483zm2.002 1.687A2.03 2.03 0 0 0 9.82.25v1.5c.259 0 .48.186.524.441zm.11.634-.11-.634-1.478.254.109.634zm.563.608c-.319-.111-.52-.353-.564-.608l-1.478.254c.15.867.789 1.505 1.545 1.77zm1.05-.054c-.236.166-.618.206-1.05.054l-.497 1.416c.717.251 1.648.292 2.41-.242zm.408-.285-.407.285.861 1.228.407-.285zm2.7.223a2.12 2.12 0 0 0-2.7-.223l.86 1.228a.62.62 0 0 1 .79.065zm.261 2.711a2.12 2.12 0 0 0-.26-2.71l-1.052 1.07c.214.21.246.543.076.79zm-.364.53.364-.53-1.236-.85-.364.53zm-.072.894a.92.92 0 0 1 .072-.894l-1.236-.85c-.484.705-.534 1.574-.219 2.325zm.77.68c-.302-.05-.61-.3-.77-.68l-1.383.581c.317.753.995 1.428 1.906 1.58zm.587.099-.587-.098L17 9.359l.588.097zm1.746 2.06a2.09 2.09 0 0 0-1.746-2.06l-.246 1.48a.59.59 0 0 1 .492.58zm-1.711 2.055a2.09 2.09 0 0 0 1.711-2.054h-1.5a.59.59 0 0 1-.482.58zm-.44.081.44-.08-.271-1.476-.44.081zm-.607.568c.111-.318.351-.52.607-.568l-.271-1.475c-.86.158-1.49.796-1.752 1.548zm.055 1.063c-.168-.24-.207-.626-.055-1.063l-1.416-.495c-.252.72-.292 1.656.243 2.42zm.282.402-.282-.402-1.228.861.282.402zm-.223 2.7c.716-.728.81-1.864.223-2.7l-1.228.86a.62.62 0 0 1-.065.79zm-2.711.262c.847.582 1.99.472 2.71-.261l-1.07-1.052a.62.62 0 0 1-.79.076zm-.528-.363.528.363.85-1.237-.528-.362zm-.899-.073c.32-.134.647-.1.899.073l.85-1.236c-.706-.486-1.578-.536-2.33-.22zm-.683.769c.052-.302.302-.609.684-.769l-.582-1.383c-.75.316-1.424.99-1.58 1.898zm-.09.517.09-.517-1.479-.254-.088.517zM9.973 19.75a2.085 2.085 0 0 0 2.055-1.732l-1.478-.254a.585.585 0 0 1-.577.486zm-2.055-1.732c.172 1 1.04 1.732 2.055 1.732v-1.5a.585.585 0 0 1-.577-.486zm-.101-.588.101.588 1.478-.254-.101-.589zm-.573-.626c.326.122.529.37.573.626l1.478-.255c-.149-.866-.786-1.5-1.527-1.776zm-1.04.052c.236-.169.618-.21 1.04-.052l.524-1.405c-.729-.272-1.672-.309-2.435.236zm-.397.284.397-.284-.871-1.22-.398.283zm-2.72-.225c.73.73 1.88.825 2.72.225l-.872-1.22a.61.61 0 0 1-.788-.066zm-.226-2.72c-.6.84-.505 1.99.225 2.72l1.061-1.061a.61.61 0 0 1-.065-.788zm.323-.453-.323.452 1.22.872.324-.453zm.08-.896a.91.91 0 0 1-.08.896l1.221.871c.503-.704.562-1.587.243-2.347zm-.754-.672c.296.05.597.297.755.672l1.383-.58c-.312-.745-.982-1.415-1.884-1.57zm-.551-.095.55.095.255-1.479-.55-.094zM.25 10.052c0 1.001.721 1.857 1.708 2.027l.254-1.478a.56.56 0 0 1-.462-.549zm1.793-2.04a2.06 2.06 0 0 0-1.793 2.04h1.5c0-.28.208-.516.485-.552zm.428-.055-.428.055.192 1.488.428-.055zm.752-.675c-.15.396-.451.636-.752.675l.192 1.488c.964-.125 1.66-.835 1.963-1.632zm-.068-.997c.173.24.217.605.068.997l1.403.531c.281-.743.282-1.664-.256-2.407zm-.284-.392.284.392 1.215-.88-.284-.391zm.253-2.718a2.07 2.07 0 0 0-.253 2.718l1.215-.88a.57.57 0 0 1 .07-.75zm2.63-.183a2.07 2.07 0 0 0-2.63.183l1.032 1.088a.57.57 0 0 1 .727-.05zm.484.346-.484-.346-.871 1.22.483.346zm.96.043c-.393.15-.745.11-.96-.043l-.872 1.22c.743.53 1.66.494 2.366.225zm.54-.635c-.023.253-.212.51-.54.635l.534 1.402c.77-.293 1.417-.984 1.5-1.9zm.06-.648-.06.648 1.494.136.059-.649zm2.118 5.586c1.294 0 2.4 1.106 2.4 2.4h1.5c0-2.122-1.778-3.9-3.9-3.9zm-2.4 2.4c0-1.294 1.105-2.4 2.4-2.4v-1.5c-2.123 0-3.9 1.778-3.9 3.9zm2.4 2.4c-1.295 0-2.4-1.105-2.4-2.4h-1.5c0 2.123 1.777 3.9 3.9 3.9zm2.4-2.4c0 1.295-1.106 2.4-2.4 2.4v1.5c2.122 0 3.9-1.777 3.9-3.9z"/><path fill="currentColor" d="m8.544 2.165-.747-.067zm2.54-.1-.74.126zm.108.633-.74.127zm1.054 1.189-.248.708zm1.73-.148.431.614zm.407-.285-.43-.614zm1.745.144-.526.535zm.168 1.751-.618-.425zm-.364.53.618.425zm-.145 1.61.691-.291zm1.925 1.228-.123.74zm.022 2.638.136.737zm-.44.08.136.738zm-1.179 1.059-.708-.248zm.15 1.74.613-.43zm.281.402-.614.43zm-.144 1.745.535.526zm-1.751.168-.425.619zm-.528-.362-.425.618zm-1.614-.146-.29-.692zm-1.132 1.333-.74-.127zm-.09.517.74.128zm-2.63 0 .738-.127zm-.102-.588-.74.127zM7.505 16.1l.262-.702zm-1.737.145-.436-.61zm-.398.284.436.61zm-1.754-.146-.53.53zM3.47 14.63l-.61-.436zm.324-.453.61.436zm.161-1.621-.691.29zm-1.319-1.121-.127.739zm-.55-.095.126-.74zm.053-2.584-.096-.744zm.428-.055.096.744zm1.357-1.153.702.265zm-.162-1.703.608-.44zm-.283-.391-.608.44zm.161-1.735.516.544zm1.678-.117-.435.61zm.484.346.436-.61zm1.663.134.267.701zm1.02-1.268.747.068zM9.82.25c-1.05 0-1.928.801-2.023 1.848l1.494.135a.53.53 0 0 1 .53-.483zm2.002 1.687A2.03 2.03 0 0 0 9.82.25v1.5c.259 0 .48.186.524.441zm.11.634-.11-.634-1.478.254.109.634zm.563.608c-.319-.111-.52-.353-.564-.608l-1.478.254c.15.867.789 1.505 1.545 1.77zm1.05-.054c-.236.166-.618.206-1.05.054l-.497 1.416c.717.251 1.648.292 2.41-.242zm.408-.285-.407.285.861 1.228.407-.285zm2.7.223a2.12 2.12 0 0 0-2.7-.223l.86 1.228a.62.62 0 0 1 .79.065zm.261 2.711a2.12 2.12 0 0 0-.26-2.71l-1.052 1.07c.214.21.246.543.076.79zm-.364.53.364-.53-1.236-.85-.364.53zm-.072.894a.92.92 0 0 1 .072-.894l-1.236-.85c-.484.705-.534 1.574-.219 2.325zm.77.68c-.302-.05-.61-.3-.77-.68l-1.383.581c.317.753.995 1.428 1.906 1.58zm.587.099-.587-.098L17 9.359l.588.097zm1.746 2.06a2.09 2.09 0 0 0-1.746-2.06l-.246 1.48a.59.59 0 0 1 .492.58zm-1.711 2.055a2.09 2.09 0 0 0 1.711-2.054h-1.5a.59.59 0 0 1-.482.58zm-.44.081.44-.08-.271-1.476-.44.081zm-.607.568c.111-.318.351-.52.607-.568l-.271-1.475c-.86.158-1.49.796-1.752 1.548zm.055 1.063c-.168-.24-.207-.626-.055-1.063l-1.416-.495c-.252.72-.292 1.656.243 2.42zm.282.402-.282-.402-1.228.861.282.402zm-.223 2.7c.716-.728.81-1.864.223-2.7l-1.228.86a.62.62 0 0 1-.065.79zm-2.711.262c.847.582 1.99.472 2.71-.261l-1.07-1.052a.62.62 0 0 1-.79.076zm-.528-.363.528.363.85-1.237-.528-.362zm-.899-.073c.32-.134.647-.1.899.073l.85-1.236c-.706-.486-1.578-.536-2.33-.22zm-.683.769c.052-.302.302-.609.684-.769l-.582-1.383c-.75.316-1.424.99-1.58 1.898zm-.09.517.09-.517-1.479-.254-.088.517zM9.973 19.75a2.085 2.085 0 0 0 2.055-1.732l-1.478-.254a.585.585 0 0 1-.577.486zm-2.055-1.732c.172 1 1.04 1.732 2.055 1.732v-1.5a.585.585 0 0 1-.577-.486zm-.101-.588.101.588 1.478-.254-.101-.589zm-.573-.626c.326.122.529.37.573.626l1.478-.255c-.149-.866-.786-1.5-1.527-1.776zm-1.04.052c.236-.169.618-.21 1.04-.052l.524-1.405c-.729-.272-1.672-.309-2.435.236zm-.397.284.397-.284-.871-1.22-.398.283zm-2.72-.225c.73.73 1.88.825 2.72.225l-.872-1.22a.61.61 0 0 1-.788-.066zm-.226-2.72c-.6.84-.505 1.99.225 2.72l1.061-1.061a.61.61 0 0 1-.065-.788zm.323-.453-.323.452 1.22.872.324-.453zm.08-.896a.91.91 0 0 1-.08.896l1.221.871c.503-.704.562-1.587.243-2.347zm-.754-.672c.296.05.597.297.755.672l1.383-.58c-.312-.745-.982-1.415-1.884-1.57zm-.551-.095.55.095.255-1.479-.55-.094zM.25 10.052c0 1.001.721 1.857 1.708 2.027l.254-1.478a.56.56 0 0 1-.462-.549zm1.793-2.04a2.06 2.06 0 0 0-1.793 2.04h1.5c0-.28.208-.516.485-.552zm.428-.055-.428.055.192 1.488.428-.055zm.752-.675c-.15.396-.451.636-.752.675l.192 1.488c.964-.125 1.66-.835 1.963-1.632zm-.068-.997c.173.24.217.605.068.997l1.403.531c.281-.743.282-1.664-.256-2.407zm-.284-.392.284.392 1.215-.88-.284-.391zm.253-2.718a2.07 2.07 0 0 0-.253 2.718l1.215-.88a.57.57 0 0 1 .07-.75zm2.63-.183a2.07 2.07 0 0 0-2.63.183l1.032 1.088a.57.57 0 0 1 .727-.05zm.484.346-.484-.346-.871 1.22.483.346zm.96.043c-.393.15-.745.11-.96-.043l-.872 1.22c.743.53 1.66.494 2.366.225zm.54-.635c-.023.253-.212.51-.54.635l.534 1.402c.77-.293 1.417-.984 1.5-1.9zm.06-.648-.06.648 1.494.136.059-.649z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gear_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m7.222 3.378.01-.033a4 4 0 0 1 .17-.476c.358-.821.944-1.285 1.854-1.36l.166-.009h1.208c1.051.033 1.735.608 2.095 1.692l.057.186.044.166q.025.096.06.203l.05.137.03.015.06-.02.116-.044.135-.059.168-.074.036-.015a4 4 0 0 1 .424-.15c.932-.27 1.685-.075 2.32.618l.108.125.714.88c.636.833.617 1.723-.004 2.683l-.109.161-.102.139q-.06.081-.123.177l-.062.1-.029.05.004.017.08.052.11.066.133.072c1.209.614 1.707 1.42 1.515 2.541l-.032.162-.213.916c-.137.593-.245.873-.67 1.258a2.13 2.13 0 0 1-1.059.518l-.01.003a4 4 0 0 1-.438.059l-.191.012-.173.006-.052.001h-.006q-.075.004-.156.01l-.158.02.012.123.011.083.029.154q.102.482.098.89v.012c-.015.84-.38 1.45-1.132 1.87l-.147.076-1.023.494c-.901.403-1.722.234-2.484-.467a4 4 0 0 1-.144-.14l-.133-.142-.113-.13a3 3 0 0 0-.147-.161l-.085-.083-.043-.04-.08.076-.091.093-.103.115c-.828.981-1.703 1.334-2.763.923l-.153-.063-.915-.443-.271-.138c-.415-.225-.647-.44-.874-.918a2.15 2.15 0 0 1-.209-1.01v-.016c.006-.19.03-.388.07-.603l.038-.195.001-.004q.02-.096.035-.206l.016-.148-.003-.003-.09-.012-.128-.012-.151-.006a4 4 0 0 1-.862-.098l-.012-.003c-.837-.198-1.363-.69-1.608-1.524l-.043-.16-.254-1.102c-.204-1.026.205-1.818 1.186-2.41l.17-.098.152-.08q.09-.045.188-.105l.134-.087.004-.017-.055-.093-.07-.108-.089-.124a5 5 0 0 1-.286-.423c-.54-.905-.534-1.72.046-2.523l.1-.132.717-.877c.687-.792 1.566-.958 2.64-.554l.18.072.158.07a3 3 0 0 0 .193.08l.118.042.032-.014.029-.077.04-.12.04-.143q.02-.085.044-.166m4.24.841.013.038.05.138a1.5 1.5 0 0 0 .743.833l.03.014a1.5 1.5 0 0 0 1.136.082l.06-.02.065-.023.117-.044.062-.025.135-.059.035-.015.12-.053q.165-.07.295-.107c.268-.078.407-.06.47-.043.057.015.16.056.314.22l.077.09.682.84c.138.185.15.295.15.359 0 .084-.03.267-.225.573l-.082.122-.08.108a4 4 0 0 0-.18.26l-.014.022-.062.099-.008.013-.01.018-.03.05a1.5 1.5 0 0 0-.178 1.056l.004.017a1.5 1.5 0 0 0 .648.959l.08.052.05.032.11.066.06.034.133.072.034.018c.456.231.62.421.676.516.036.06.084.162.042.417l-.023.117-.207.892c-.066.285-.095.35-.105.369 0 0 0 .003-.01.013a1 1 0 0 1-.101.103c-.082.074-.166.124-.354.161a2 2 0 0 1-.257.035l-.153.01-.138.004-.071.002a5 5 0 0 0-.28.02l-.158.019a1.5 1.5 0 0 0-1.318 1.628l.011.123.008.07.012.083.01.06.028.154.008.045c.05.236.068.419.066.557-.003.206-.046.301-.073.348-.028.046-.094.131-.276.235l-.105.056-.977.471c-.204.088-.317.082-.382.07-.076-.015-.228-.068-.456-.279l-.08-.076-.1-.107-.088-.102a4 4 0 0 0-.217-.236l-.018-.018-.084-.082-.036-.034-.043-.04a1.5 1.5 0 0 0-2.047.014l-.08.075-.042.041-.09.094-.048.05-.103.116-.025.03c-.315.371-.532.495-.646.535-.073.025-.183.05-.415-.038l-.094-.039-.864-.418-.238-.12a1 1 0 0 1-.13-.083l-.004-.003-.003-.003-.013-.018a1 1 0 0 1-.07-.13.67.67 0 0 1-.063-.339c.003-.09.015-.207.043-.365l.035-.174a4 4 0 0 0 .058-.35l.016-.149a1.5 1.5 0 0 0-.434-1.224l-.004-.003a1.5 1.5 0 0 0-.86-.423l-.09-.012-.064-.008-.128-.01-.068-.005-.15-.007-.04-.001a2.7 2.7 0 0 1-.549-.06c-.215-.05-.305-.115-.346-.154s-.109-.12-.17-.319l-.03-.114-.242-1.052c-.042-.224-.006-.329.023-.387.038-.076.146-.23.459-.42l.128-.074.119-.062a4 4 0 0 0 .316-.18l.134-.087a1.5 1.5 0 0 0 .65-.947l.004-.017a1.5 1.5 0 0 0-.171-1.066l-.055-.093-.037-.062-.07-.108-.04-.057-.088-.124-.024-.031c-.307-.406-.369-.647-.378-.754-.006-.067-.004-.18.148-.395l.072-.094.684-.838c.154-.173.262-.211.33-.225.09-.018.28-.027.623.1l.138.055.123.055a4 4 0 0 0 .316.13l.118.042a1.5 1.5 0 0 0 1.134-.058l.031-.015a1.5 1.5 0 0 0 .764-.823l.03-.077.023-.066.04-.12.02-.065.04-.143.01-.037.03-.119q.056-.191.114-.323c.1-.23.192-.319.243-.357.044-.033.134-.086.343-.105l.1-.006h1.14c.234.01.333.071.386.114.067.056.192.195.308.538l.043.14.034.129q.04.15.088.298" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-gift" class="svg-sprite__symbol"><path d="M3 10h14v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM2 6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM5 5h5C8.5 2 6 1 5 2c-.8.8-.333 2.333 0 3M15 5h-5c1.5-3 4-4 5-3 .8.8.333 2.333 0 3M10 5v13"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-gift-box" class="svg-sprite__symbol"><path fill="#3C1F56" fill-opacity=".992" d="m23.087 1.41-1.817.176q1.133-.6 1.817-.177"/><path fill="#5400C2" d="M23.087 1.41q1.02.423 1.36 1.573-.49-.826-.937-.967-.533-.67-1.28-.42-.707-.057-1.073.357c-.744.836-1.61 1.576-2.207 2.486q-.764 1.164-1.473 2.364-.128.213-.357.173.767-1.22 1.397-2.48.99-1.98 2.753-2.91z"/><path fill="#B251FC" d="M22.23 1.596q-.057.35.59.89a.42.42 0 0 1 .15.27q.116.79.344 1.527.165.537 0 1.107-.04.136.08.213.36.226.72-.003.116-.074.036-.187-.27-.377-.193-.89a.7.7 0 0 0-.037-.347 6.4 6.4 0 0 1-.41-2.16q.447.14.937.967l.707 2.516q-.084.477.093.657a.56.56 0 0 1 .16.337l.063.51a.15.15 0 0 1-.27.106c-.596-.823-1.68-.863-2.616-.84-1.014.024-2.064.987-2.944 1.694q-.72.495-1.473.946c-.573.344-1.04.317-1.643.457q-.044.01-.054-.037l-.02-.086a.114.114 0 0 1 .077-.134 7.8 7.8 0 0 0 3-1.603l2.73-1.893a.76.76 0 0 0 .31-.787l-.14-.646a.46.46 0 0 0-.163-.27 1.52 1.52 0 0 1-.524-.904.407.407 0 0 0-.673-.226q-2.016 1.826-3.207 4.093-.356.59-.837.857-.15.082-.176-.087l-.02-.127.293-.54q.23.04.357-.173.71-1.2 1.473-2.364c.597-.91 1.463-1.65 2.207-2.486q.366-.414 1.073-.357"/><path fill="#D69DF4" d="M22.23 1.596q.747-.25 1.28.42a6.4 6.4 0 0 0 .41 2.16c.042.112.054.231.037.347q-.077.513.193.89.08.114-.037.187a.625.625 0 0 1-.72.003q-.12-.077-.08-.213.168-.57 0-1.107-.226-.737-.343-1.527a.42.42 0 0 0-.15-.27q-.647-.54-.59-.89M11.417 2.72q.003.205.12.27.006.375-.433.323a.55.55 0 0 0-.31.057l-1.134.573a.7.7 0 0 0-.25.223q-.3.45-.833.53-.177.027-.19.204-.033.426.27.673.82 1.026.31 1.113l-1.82-1.71q1.836-1.35 3.617-2.283a.55.55 0 0 1 .326-.074q.164.02.327.1"/><path fill="#A001FF" d="m19.527 7.506-.104-.283 1.147-1.104q.054-.052 0-.106l-.063-.064q-.027-.023-.037-.013a9.8 9.8 0 0 1-1.926 1.523q-.37.226-.73.03.446-.783.046-.616 1.191-2.267 3.207-4.093a.407.407 0 0 1 .673.226q.107.554.524.904a.46.46 0 0 1 .163.27l.14.646a.76.76 0 0 1-.31.787z"/><path fill="#5400C2" d="M11.417 2.72q2.41 1.392 3.687 3.77-.15.595.396.7.167.646.554.546l.02.11q-.04.277-.144.243a14.55 14.55 0 0 0-6.673.59q-.037-.266-.16-.346c-.91-.607-1.964-1.45-2.407-2.484a.44.44 0 0 1-.01-.333q.16-.45.467-.54l1.82 1.71.783 1.07a.39.39 0 0 0 .463.134l.72-.294a.8.8 0 0 1 .357-.05 1 1 0 0 0 .41-.046q.184-.067.064-.22a.37.37 0 0 1-.08-.177q-.027-.127.103-.133a.3.3 0 0 1 .113.016q.33.35.72.387.173.016.224-.154.135-.489.01-1.053l.39.213q.083.51.433.677a.44.44 0 0 0 .353.017.82.82 0 0 1 .56-.017q.723.234.343-.423a11 11 0 0 0-3.396-3.643q-.117-.065-.12-.27"/><path fill="#B251FC" d="M11.537 2.99a11 11 0 0 1 3.396 3.643q.381.657-.343.423a.82.82 0 0 0-.56.017.44.44 0 0 1-.353-.017q-.35-.166-.434-.677.408.035.784.387a.137.137 0 0 0 .213-.036l.044-.09a.2.2 0 0 0-.017-.214c-.773-1.003-1.607-2.276-2.76-2.846a.51.51 0 0 0-.55.063l-2.3 1.93q-.303-.247-.27-.673.013-.177.19-.204a1.17 1.17 0 0 0 .833-.53.7.7 0 0 1 .25-.223l1.134-.573a.55.55 0 0 1 .31-.057q.44.053.433-.323"/><path fill="#A001FF" d="m13.244 6.38-.39-.214a1.13 1.13 0 0 0-.317-.64q-.177-.167-.164.073l.054.98a.17.17 0 0 1-.083.158.18.18 0 0 1-.18.006L10.05 5.596a.127.127 0 0 0-.183.14l.033.157a.37.37 0 0 0 .204.253l1.796.84a.3.3 0 0 0-.113-.016q-.13.006-.104.133a.37.37 0 0 0 .08.177q.12.153-.063.22a1 1 0 0 1-.41.046.8.8 0 0 0-.356.05l-.72.294a.39.39 0 0 1-.464-.134l-.783-1.07q.51-.087-.31-1.113l2.3-1.93a.51.51 0 0 1 .55-.063c1.153.57 1.987 1.843 2.76 2.846q.035.046.04.104a.2.2 0 0 1-.023.11l-.044.09a.14.14 0 0 1-.097.07.14.14 0 0 1-.116-.034q-.376-.353-.784-.387"/><path fill="#B251FC" d="M12.854 6.166q.125.564-.01 1.053-.05.17-.224.154-.39-.037-.72-.387l-1.796-.84a.37.37 0 0 1-.204-.253l-.033-.157a.127.127 0 0 1 .183-.14l2.114 1.147a.18.18 0 0 0 .18-.006.18.18 0 0 0 .083-.158l-.053-.98q-.015-.24.163-.073.25.244.317.64"/><path fill="#5400C2" d="M25.154 5.5q1.289 1.842-.44 2.91-.531.325.09.37l1.516.11-1.203.003q-1.33-.137-2.703.58l-4.657.186 1.93-.306q.343-.053.043-.233a.56.56 0 0 0-.393-.074.2.2 0 0 1-.17-.046q-.197-.18.04-.3l.443-.227a.43.43 0 0 0 .217-.243q.09-.24-.227-.267c.88-.707 1.93-1.67 2.944-1.694.936-.023 2.02.017 2.616.84a.15.15 0 0 0 .27-.106l-.063-.51a.56.56 0 0 0-.16-.337q-.177-.18-.093-.657m-.734 2.71a.13.13 0 0 0-.003-.12.31.31 0 0 0-.277-.18c-1.25-.074-2.6.473-3.797.91q-.562.205.027.31a4.2 4.2 0 0 0 1.77-.057q1.263-.31 2.453-.713a.1.1 0 0 1 .037-.004q.024.005.004.02a.03.03 0 0 1-.03.004.12.12 0 0 0-.064-.01q-.19.013-.12-.16"/><path fill="#B251FC" d="M19.424 7.223a5.1 5.1 0 0 1-1.637.88.183.183 0 0 1-.244-.19q.018-.214.27-.424.36.196.73-.03a9.8 9.8 0 0 0 1.927-1.523q.01-.01.037.013l.063.064q.054.052 0 .106z"/><path fill="#3C1F56" fill-opacity=".992" d="m15.104 6.49.396.7q-.546-.105-.396-.7"/><path fill="#4008A8" d="M17.814 7.49q-.255.21-.27.423a.19.19 0 0 0 .07.161.18.18 0 0 0 .173.029 5.1 5.1 0 0 0 1.637-.88l.103.283a7.8 7.8 0 0 1-3 1.603.113.113 0 0 0-.077.134l.02.086q.01.047.054.037c.603-.14 1.07-.113 1.643-.457q.753-.45 1.473-.946.317.026.227.267a.43.43 0 0 1-.217.243l-.443.227q-.237.12-.04.3a.2.2 0 0 0 .17.046q.21-.036.393.074.3.18-.043.233l-1.93.306-.98.137q-.483.067-.027.244.984.38 2.233.356 1.42.48 1.99 1.547.324.883.567 2.056.177.861.047 1.637-.217 1.323-.217 1.59 0 .843.004 1.773a.25.25 0 0 0 .09.19.17.17 0 0 1 .056.114q.22 2.01.737 4.106.17.687.437 1.32c.363.867.696 1.27 1.336 1.73q.18.018.374.37-.141-.09-.327.004l-.91-.644q.153-.13-.253-.166l-.447-1.054a.4.4 0 0 0-.217-.213q-.293-.12-.2-.507l-.75-3.65a27.5 27.5 0 0 1-.05-5.306q.32-1.67-.65-3.144-.016-.022-.036-.003a.1.1 0 0 1-.024.023q-.29-1.005-1.38-1.17a60 60 0 0 0-2.106-.286.44.44 0 0 0-.297.07l-2.28 1.527q-.547.12-.774.743l.02 2.35q.09.283.217.257.256.249.187.913v3.187l-.04 4.26q-.346-.074-.283-.704a480 480 0 0 1-.047-6.696q0-.244-.063-.4-.18-.447-.487-.07l-3.517-.714a.5.5 0 0 0-.143-.4.11.11 0 0 0-.113-.026.11.11 0 0 0-.074.09c-.266 1.996-.95 3.756-1.663 5.59-.487 1.253-1.207 2.436-1.677 3.733a.3.3 0 0 0-.033-.097.124.124 0 0 0-.187-.026l-.406.353q.8-1.464 1.58-2.913c.45-.837.643-1.734.973-2.617q.33-.88.557-1.974.45-2.16 1.043-4.24 1.687-2.383 4.42-2.77.619.097 1.223.057.316-.02.484-.236a.6.6 0 0 1 .186-.164q.234-.133.034-.31l-.15-.133a.4.4 0 0 0 .1.007q.076-.01.096-.08.167-.524.333-1.04.117-.364-.2-.394l-.02-.11q.597-.003.774-.22l.02.127q.027.17.176.087.48-.267.837-.857.4-.167-.046.616m-3.147 3.816q-1.45-1.003-3.17.3-.4.046-.913.84l-.474.533q-.403.638-.316 1.57.016.18.196.224l2.94.674q.407.156.444-.198.11-1.056-.084-2.42a13.2 13.2 0 0 1 3.074-2.07.11.11 0 0 0 .054-.132.1.1 0 0 0-.028-.044l-.07-.073q-.056-.057-.126-.017z"/><path fill="#D69DF4" d="M16.074 7.846q.315.03.2.394-.168.515-.334 1.04-.02.07-.096.08a.4.4 0 0 1-.1-.007 1.7 1.7 0 0 1-.04-.617q0-.256.226-.647.104.034.143-.243"/><path fill="#A001FF" d="M15.93 8.09q-.226.39-.226.646.043-.24-.117-.23a2 2 0 0 1-.677-.066c-.85-.227-1.71-.05-2.5.36q-.173.086-.086.263l.043.093q.01.02.03.01 1.187-.503 2.357-.483a.23.23 0 0 1 .18.09.12.12 0 0 1 .03.11q-.027.126-.157.137-1.394.096-2.787.806a.134.134 0 0 0-.072.146.14.14 0 0 0 .122.114l.19.02-2.383 1.49q-.17.107-.187-.097a.21.21 0 0 1 .057-.163 3.6 3.6 0 0 1 1.113-.81.15.15 0 0 0 .084-.096l.03-.1q.073-.234-.17-.217-.697.044-1.007-.964-.183-.59-.947-.31l.407-.16q3.263-1.073 6.673-.59M24.54 8.37a.12.12 0 0 1 .064.01.03.03 0 0 0 .03-.004q.02-.015-.004-.02a.1.1 0 0 0-.037.004q-1.189.403-2.453.713a4.2 4.2 0 0 1-1.77.057q-.59-.105-.027-.31c1.197-.437 2.547-.984 3.797-.91a.31.31 0 0 1 .277.18q.03.056.003.12-.07.173.12.16"/><path fill="#5400C2" d="M15.704 8.736q-.038.334.04.617l.15.133q.2.177-.034.31a.6.6 0 0 0-.186.164q-.168.216-.484.236-.603.04-1.223-.057l1.283-.076a.134.134 0 0 0 .125-.113.13.13 0 0 0-.005-.06l-.05-.154q-.043-.136-.19-.146a6.04 6.04 0 0 0-2.87.516l-.19-.02a.14.14 0 0 1-.122-.114.135.135 0 0 1 .072-.146q1.394-.71 2.787-.806.13-.01.157-.137a.12.12 0 0 0-.03-.11.23.23 0 0 0-.18-.09q-1.17-.02-2.357.483-.02.01-.03-.01l-.043-.093q-.088-.177.086-.263c.79-.41 1.65-.587 2.5-.36q.334.09.677.066.16-.01.117.23"/><path fill="#C374FE" d="M12.26 10.106a6.04 6.04 0 0 1 2.87-.516q.147.01.19.146l.05.154a.13.13 0 0 1-.017.116.13.13 0 0 1-.103.057l-1.283.076q-2.734.388-4.42 2.77-.19.224-.353.284-.256.096-.15-.157.115-.28.25-.547.159-.309-.167-.18a.4.4 0 0 0-.167.127.42.42 0 0 1-.353.177 7.6 7.6 0 0 0-1.233.096q-.22.034-.314-.17a.193.193 0 0 0-.323-.05q-.324.367-.503.177l.523-1.656.443-.61q.58-.937 1.65-1.56.764-.28.947.31.31 1.006 1.007.963.243-.017.17.216l-.03.1a.15.15 0 0 1-.084.097 3.6 3.6 0 0 0-1.113.81.21.21 0 0 0-.057.163q.017.204.187.097z"/><path fill="#4DACFF" d="M25.117 8.893q.846.39 2.27.16.58 1.12.06 2.82a8.3 8.3 0 0 0 .08-2.127q-.007-.063-.067-.06h-.003q-.063.004-.067.067-.04.747.004 1.493c.02.414-.284.7-.66.797a.54.54 0 0 0-.267.16q-.393.437-.633-.097l.123-1.86q.014-.17-.15-.223-.423-.147-.694.033a.9.9 0 0 1-.316-.047q-.11-.045.007-.076a.3.3 0 0 0 .096-.04q.06-.047-.01-.08-.456-.215-.64-.2a5.6 5.6 0 0 1-1.836-.14q1.373-.717 2.703-.58"/><path fill="#4DACFF" d="m25.117 8.893 1.203-.004 1.067.164q-1.424.23-2.27-.16"/><path fill="#A001FF" d="M22.414 9.473a5.6 5.6 0 0 0 1.836.14q.184-.015.64.2.07.033.01.08a.3.3 0 0 1-.096.04q-.117.03-.007.076a.9.9 0 0 0 .316.047l-1.04.624a.38.38 0 0 1-.496-.104q-.525-.73-1.32-.487a2.4 2.4 0 0 0-1.4.024q-.27.083-.07.287.15.152.23.35a.24.24 0 0 1 .007.176.12.12 0 0 1-.09.084.17.17 0 0 1-.17-.047 3.1 3.1 0 0 0-1.637-.843.15.15 0 0 0-.13.04q-.037.033-.007.076.037.055-.006.16-1.25.024-2.234-.357-.456-.175.027-.243l.98-.136z"/><path fill="#4894FF" d="m27.447 11.873-.034 11.65q0 .172-.15.256l-.573.32q-.974-1.61-1.083-2.68-.377-3.673.227-9.313.24.534.633.097a.54.54 0 0 1 .267-.16c.376-.097.68-.383.66-.797q-.044-.746-.004-1.493.003-.063.067-.067h.003q.06-.003.067.06.096 1.067-.08 2.127"/><path fill="#C374FE" d="M22.257 10.09c1.446.586 2.566 1.89 2.426 3.506a21.3 21.3 0 0 0 .034 3.787.9.9 0 0 0 .083.31q.077.153.077.323a14.2 14.2 0 0 0 1.38 6.067q.3.637.826 1.036.864 1.367 1.64 1.65 1.508.55-.096.48-1.42-.06-2.537-1.156-.043-.297.084-.454.09-.112 0-.226a.88.88 0 0 1-.18-.61 14.3 14.3 0 0 1-.914-2.347 8 8 0 0 0-.467-1.193q-.353-.747-.323-1.267.093-1.796.12-3.6l-.193-2.33q.073-.87-.377-1.23c-.483-.387-1.056-1.133-1.733-.503a.26.26 0 0 0-.07.303q.293.79-.243.453-.235-.856-.82-1.146-.57-1.067-1.99-1.547.042-.105.006-.16-.03-.043.007-.076a.15.15 0 0 1 .13-.04 3.1 3.1 0 0 1 1.637.843.17.17 0 0 0 .17.047.12.12 0 0 0 .09-.084.24.24 0 0 0-.007-.176 1.1 1.1 0 0 0-.23-.35q-.2-.204.07-.287.72-.22 1.4-.024"/><path fill="#5400C2" d="M25.114 10.056q.27-.18.693-.033.163.053.15.223l-.123 1.86q-.604 5.64-.227 9.313.11 1.07 1.083 2.68-.16.204.11.52.2.237.284.5a2.75 2.75 0 0 1-.827-1.037 14.2 14.2 0 0 1-1.38-6.066.7.7 0 0 0-.077-.323.9.9 0 0 1-.083-.31 21.3 21.3 0 0 1-.034-3.787c.14-1.617-.98-2.92-2.426-3.507q.795-.243 1.32.487a.37.37 0 0 0 .496.104z"/><path fill="#83D5ED" d="m7.2 10.4-.443.61q-.31-.057-.12-.07-.548.01-.84.296-.21.204-.224.76a6.7 6.7 0 0 1-.12 1.113q-.22-.963-.016-1.803a.33.33 0 0 1 .2-.237z"/><path fill="#B251FC" d="M13.29 12.83q-1.083.352-2.62-.27-.08-.034-.086-.114.513-.793.913-.84.723.416 1.53.5c.693.07 1.163-.35 1.64-.8l1.527-.813q.07-.04.126.017l.07.073a.11.11 0 0 1 .013.143.1.1 0 0 1-.04.034 13.2 13.2 0 0 0-3.073 2.07"/><path fill="#4DACFF" d="M20.54 12.17q-.203.05-.16.106-.002-.213-.236-.24a.4.4 0 0 0-.247.05q-.556.323-1.147.647-.435.243-1.156.15a30 30 0 0 1-3.117-.573l2.28-1.527a.44.44 0 0 1 .297-.07q1.07.126 2.106.287 1.09.162 1.38 1.17"/><path fill="#A001FF" d="M14.667 11.306c-.477.45-.947.87-1.64.8a3.8 3.8 0 0 1-1.53-.5q1.72-1.303 3.17-.3"/><path fill="#83D5ED" d="M6.637 10.94a7.6 7.6 0 0 0-.87 2.48q-.143-.024-.11.15l-.213.083a1.5 1.5 0 0 1 .01-.544q.105-.549.12-1.113.013-.556.223-.76.293-.287.84-.297"/><path fill="#C374FE" d="M6.637 10.94q-.19.012.12.07l-.523 1.656a1.6 1.6 0 0 1-.467.753 7.6 7.6 0 0 1 .87-2.48"/><path fill="#A001FF" d="M20.974 11.943q.586.29.82 1.146.443 1.623.26 2.663-.36 2.027-.114 3.254c.147.723.09 1.31.114 2.01a.3.3 0 0 0 .04.13 1 1 0 0 0 .076.1.47.47 0 0 1 .134.29q.213 2.467 1.726 4.923c-.64-.46-.973-.863-1.336-1.73a9 9 0 0 1-.437-1.32 31.5 31.5 0 0 1-.737-4.106.17.17 0 0 0-.056-.114.25.25 0 0 1-.09-.19l-.004-1.773q0-.267.217-1.59a4.4 4.4 0 0 0-.047-1.637 15 15 0 0 0-.566-2.056"/><path fill="#83D5ED" d="M20.38 12.276q-.713.407-1.467.747-.69.313-1.163.25a21 21 0 0 1-1.717-.307 1.4 1.4 0 0 0-.746.03.12.12 0 0 0 .03.233q1.38.07 2.593.437.137.04.133.18l-.033 2.057q-.007.369-.373.313l-3.697-.556q-.126.026-.217-.257a.2.2 0 0 0 .057-.137q.007-.123.13-.117a.74.74 0 0 1 .357.117.8.8 0 0 0 .303.11l2.51.383q.59.094.58-.503l-.013-.75q-.014-.707-.707-.837l-3.237-.616q.228-.624.774-.743 1.566.373 3.117.573.72.093 1.156-.15.59-.323 1.147-.647a.4.4 0 0 1 .247-.05q.233.027.236.24"/><path fill="#B251FC" d="M24.217 14.066q-.546-.87-1.453-.767-.44.048-.394.49a8.6 8.6 0 0 1-.02 2.087c-.263 1.973-.033 4.127.244 6.077q.156 1.093.75 2.043.636 1.017 1.22 1.957a4.2 4.2 0 0 0 1.83 1.626q.26.124.043-.066a.27.27 0 0 0-.163-.064.084.084 0 0 1-.077-.116.1.1 0 0 1 .037-.04.5.5 0 0 1 .17-.05q.66.79 1.533 1.026a.063.063 0 0 1-.013.123q-1.128.067-2.167-.546l-1.353-1.016q-.194-.354-.374-.37-1.513-2.458-1.726-4.924a.47.47 0 0 0-.134-.29 1 1 0 0 1-.076-.1.3.3 0 0 1-.04-.13c-.024-.7.033-1.287-.114-2.01q-.246-1.226.114-3.254.183-1.039-.26-2.663.536.337.243-.453a.26.26 0 0 1 .07-.303c.677-.63 1.25.116 1.733.503q.45.36.377 1.23"/><path fill="#4894FF" d="M20.54 12.17a.1.1 0 0 0 .024-.024q.02-.02.036.003.97 1.474.65 3.144l-2.583 1.237a.21.21 0 0 0-.13.216l.103 3.514a.287.287 0 0 0 .27.28.3.3 0 0 0 .14-.024q.614-.277 1.37-.136.156.03.237.173a.37.37 0 0 0 .343.2q.273.003.3-.153l.75 3.65.017 2.336q-.74.48-.587.623-.186.164-.55.287-.316.023-.703.257-1.12.846-2.16 1.093.107-1.307.077-2.513-.047-1.703-.017-2.507a67 67 0 0 0-.13-7.11q-.886.08-1.197-.163a.57.57 0 0 0-.29-.12q-1.07-.144-2.136-.293-.334-.047-.247.433.07-.663-.187-.913l3.697.556q.366.056.373-.313l.033-2.057q.004-.14-.133-.18a10.8 10.8 0 0 0-2.593-.437.12.12 0 0 1-.03-.233 1.4 1.4 0 0 1 .746-.03 21 21 0 0 0 1.717.307q.473.063 1.163-.25a18 18 0 0 0 1.467-.747q-.043-.057.16-.107"/><path fill="#B251FC" d="M9.547 12.91a60 60 0 0 0-1.043 4.24 13.4 13.4 0 0 1-.557 1.973c-.33.883-.523 1.78-.973 2.616q-.78 1.45-1.58 2.914c-.684.997-1.88 2.19-3.134 2.393q-.237.036-.057-.12 1.124-.98 1.254-2.71a.13.13 0 0 0-.049-.115.14.14 0 0 0-.125-.028q-1.266.319-2.35-.037-.932-.303.04-.43.258-.033.877-.303.024.35.277.407.18.04.333-.053 1.538-.95 2.144-2.374.49-1.154.766-2.513.07-.34-.236-.174-.024.015-.144.377l.347-2.047.32-3.356q-.033-.174.11-.15.333-.298.467-.754.18.19.503-.177a.194.194 0 0 1 .323.05q.094.204.314.17a7.6 7.6 0 0 1 1.233-.096.42.42 0 0 0 .353-.177.4.4 0 0 1 .167-.127q.326-.129.167.18-.135.267-.25.547-.107.253.15.157.163-.06.353-.284m-5.05 11.623a.13.13 0 0 0 .08-.044 18 18 0 0 0 2.203-3.27q.367-.693.56-1.486c.304-1.234.757-2.364.937-3.637q.154-1.08.4-2.123.11-.464-.337-.304a8 8 0 0 1-1.346.357.29.29 0 0 1-.284-.11.4.4 0 0 0-.11-.093.255.255 0 0 0-.303.031.25.25 0 0 0-.06.089q-.243.603-.323 1.236a31 31 0 0 0-.204 4.824c.054 1.476-.916 2.97-1.593 4.223a.26.26 0 0 0 .02.273q.164.227.293.07a.1.1 0 0 1 .067-.036"/><path fill="#A001FF" d="M10.584 12.446q.006.08.086.113 1.537.624 2.62.27.194 1.364.084 2.42-.037.354-.444.197a.23.23 0 0 0 .107-.093q.07-.147-.09-.18l-2.52-.517a.37.37 0 0 1-.297-.36l-.02-1.317z"/><path fill="#B251FC" d="m10.11 12.98.02 1.316a.38.38 0 0 0 .297.36l2.52.517q.16.033.09.18a.23.23 0 0 1-.107.094l-2.94-.674q-.18-.043-.196-.223-.087-.933.316-1.57"/><path fill="#4DACFF" d="m13.704 13.053 3.236.616q.693.13.707.837l.013.75q.01.597-.58.503l-2.51-.383a.8.8 0 0 1-.303-.11.74.74 0 0 0-.357-.117q-.123-.006-.13.117a.2.2 0 0 1-.057.137z"/><path fill="#A001FF" d="m24.217 14.066.193 2.33a2.1 2.1 0 0 0-.21 1.074.35.35 0 0 1-.163.333q-.607.417-.697 1.177-.246 2.136.903 4.177.345.605 1.75 1.646a.88.88 0 0 0 .18.61q.09.112 0 .226-.125.157-.083.454-.074-.105-.146-.107-.137-.4-.407-.497-.197-.073-.163.134.03.183.196.336l.834 1.284a.5.5 0 0 0-.17.05.083.083 0 0 0 .04.156q.09.004.163.064.216.19-.043.066a4.2 4.2 0 0 1-1.83-1.626q-.584-.941-1.22-1.957a5.2 5.2 0 0 1-.75-2.043c-.277-1.95-.507-4.104-.244-6.077a8.6 8.6 0 0 0 .02-2.087q-.046-.442.394-.49.906-.103 1.453.767M5.657 13.57l-.32 3.356a.8.8 0 0 1-.247.177l.354-3.45zM4.43 24.57q-.13.155-.293-.07a.26.26 0 0 1-.02-.274c.677-1.253 1.647-2.747 1.593-4.223a31 31 0 0 1 .204-4.824q.079-.633.323-1.236a.25.25 0 0 1 .153-.144.25.25 0 0 1 .21.024.4.4 0 0 1 .11.093.29.29 0 0 0 .284.11q.692-.12 1.346-.357.447-.16.337.304a24 24 0 0 0-.4 2.123c-.18 1.273-.633 2.403-.937 3.637a6.4 6.4 0 0 1-.56 1.486 18 18 0 0 1-2.203 3.27.13.13 0 0 1-.08.044.1.1 0 0 0-.067.036"/><path fill="#4894FF" d="m9.69 15.436.017.483-.133 10.244-3.034-.697q-.165-.035-.21.13l-.026.117a.137.137 0 0 0 .1.167l2.76.693-3.054-.72a.245.245 0 0 1-.2-.214 2.44 2.44 0 0 1 .11-1.216c.47-1.297 1.19-2.48 1.677-3.734.713-1.833 1.397-3.593 1.663-5.59a.11.11 0 0 1 .187-.063.5.5 0 0 1 .143.4"/><path fill="#4DACFF" d="M21.25 15.293a27.5 27.5 0 0 0 .05 5.307q-.027.156-.3.153a.37.37 0 0 1-.343-.2.33.33 0 0 0-.237-.173q-.756-.14-1.37.136a.296.296 0 0 1-.372-.121.3.3 0 0 1-.038-.135l-.103-3.514a.21.21 0 0 1 .13-.216z"/><path fill="#A001FF" d="m13.207 16.15.09 11.15q0 .17-.167.2a2.2 2.2 0 0 1-.7.013l-2.166-.587q-.014-.107-.147-.253l.176.043a.203.203 0 0 0 .237-.14q.55-1.88.52-3.82-.04-2.28-.15-4.864a1.9 1.9 0 0 0-.267-.903 9 9 0 0 0-.586-.873q-.187.577-.34-.197l-.017-.483z"/><path fill="#826BC8" fill-opacity=".996" d="M9.707 15.92q.153.772.34.196-.167.656-.04.98l.063 9.417q.087-.054.047.16.134.146.146.253-.662-.05-1.1-.353a.38.38 0 0 1 .234 0q.157.039.187-.12a.53.53 0 0 0-.01-.29z"/><path fill="#B251FC" d="m13.804 23.316-.087 4.08q-.003.174-.177.174h-.816a.9.9 0 0 1-.294-.057q.367.05.7-.013.167-.03.167-.2l-.09-11.15q.307-.378.487.07.063.156.063.4 0 3.352.047 6.696"/><path fill="#4DACFF" d="M17.997 16.716a3.2 3.2 0 0 0-.267 1.877q-.657 1.04-1.146 1.08-.645.054-1.417.203-.163.034-.133.197.023.117-.114.147a.265.265 0 0 0-.2.24q-.03.456-.246.763-.345.483-.347-.11v-4.54q-.087-.48.247-.433 1.066.15 2.136.293a.57.57 0 0 1 .29.12q.31.243 1.197.163"/><path fill="#B251FC" d="M10.117 26.673q.039-.213-.047-.16l.163-.047q.164-.043.164-.213c0-.357-.11-.677-.1-1.023q.106-3.734.006-7.474a.5.5 0 0 0-.103-.293 1.1 1.1 0 0 1-.193-.367q-.127-.324.04-.98.34.45.586.873.247.424.267.903.11 2.584.15 4.864a12.8 12.8 0 0 1-.52 3.82.203.203 0 0 1-.236.14zM24.41 16.397a97 97 0 0 1-.12 3.6q-.03.519.323 1.266.317.674.467 1.193.34 1.18.914 2.347-1.407-1.04-1.75-1.646-1.15-2.04-.904-4.177.09-.761.697-1.177a.35.35 0 0 0 .163-.333 2.1 2.1 0 0 1 .21-1.073"/><path fill="#83D5ED" d="M17.997 16.716q.253 3.584.13 7.11-.03.803.017 2.507.03 1.206-.077 2.513l-.993-.276-1.5-.51-.144-.044q-.126-.036-.05-.146.084-.123.243-.097.98.164 1.834.47a.186.186 0 0 0 .25-.173l.023-9.477a3.2 3.2 0 0 1 .267-1.877"/><path fill="#A001FF" d="m5.337 16.926-.347 2.047a3.3 3.3 0 0 1-.5.97l.6-2.84a.8.8 0 0 0 .247-.177"/><path fill="#D69DF4" d="M10.007 17.096q.053.183.193.367a.5.5 0 0 1 .104.293q.1 3.74-.007 7.474c-.01.346.1.666.1 1.023q0 .17-.164.213l-.163.047zM1.85 23.303c1.514-.66 2-1.684 2.64-3.36q.317-.417.5-.97.12-.363.144-.377.306-.166.236.174-.277 1.36-.766 2.513-.608 1.423-2.144 2.374a.44.44 0 0 1-.333.053q-.253-.057-.277-.407"/><path fill="#4894FF" d="m17.73 18.593-.023 9.477a.187.187 0 0 1-.25.173 10.5 10.5 0 0 0-1.834-.47q-.159-.026-.243.097-.076.11.05.146l.144.044-.727-.014a1.12 1.12 0 0 1-.61-.256.34.34 0 0 1-.13-.277l-.02-3.493.04-4.26v1.353q.003.593.347.11.216-.306.246-.763a.26.26 0 0 1 .2-.24q.137-.03.114-.147-.03-.163.133-.197.773-.15 1.417-.203.489-.04 1.146-1.08"/><path fill="#5400C2" d="M13.804 23.316q-.064.63.283.704l.02 3.493q0 .17.13.276.274.224.61.257a.34.34 0 0 0-.17.047l-1.953-.523h.816q.174 0 .177-.174zM22.05 24.25q-.093.386.2.506a.39.39 0 0 1 .217.213l.447 1.054q-.164.483-.847.563z"/><path fill="#3C1F56" fill-opacity=".992" d="M25.944 25.986a.55.55 0 0 0-.374-.027.6.6 0 0 1-.196-.336q-.034-.207.163-.134.27.097.407.497"/><path fill="#83D5ED" d="M9.574 26.163a.53.53 0 0 1 .01.29q-.03.159-.187.12a.38.38 0 0 0-.233 0l-2.76-.693a.14.14 0 0 1-.103-.113.14.14 0 0 1 .003-.054l.026-.117q.045-.165.21-.13z"/><path fill="#4894FF" d="M22.914 26.023q.406.036.253.166l-1.687 1.02q-.153-.143.587-.623.684-.08.847-.563"/><path fill="#3C1F56" fill-opacity=".992" d="M24.077 26.833q.186-.094.327-.003l1.353 1.016a4.7 4.7 0 0 1-1.68-1.013"/><path fill="#4894FF" d="M20.93 27.496a1.23 1.23 0 0 1-.68.457.6.6 0 0 0-.023-.2q.387-.233.703-.257"/><path fill="#4894FF" d="M20.227 27.753q.03.1.023.2l-1.777 1.016a.4.4 0 0 1-.306.04l-1.607-.416a.76.76 0 0 1 .514-.023l.993.276q1.04-.247 2.16-1.093"/><path fill="#826BC8" fill-opacity=".996" d="M14.677 28.093a.34.34 0 0 1 .17-.047l.727.014 1.5.51a.76.76 0 0 0-.514.023z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-gift_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M11 3.309C12.294.98 14.737.697 16.133 2.093c1.14 1.14 1.16 2.983-.135 4.325h.502a3.667 3.667 0 0 1 3.666 3.666v.393c0 .923-.127 1.418-.367 1.867a2.52 2.52 0 0 1-1.464 1.224l-.002 1.899c0 1.634-.17 2.227-.49 2.824a3.33 3.33 0 0 1-1.386 1.386c-.597.32-1.19.49-2.824.49H8.366c-1.635 0-2.227-.17-2.825-.49a3.33 3.33 0 0 1-1.386-1.386c-.32-.597-.49-1.19-.49-2.824v-1.899a2.52 2.52 0 0 1-1.466-1.224c-.22-.411-.345-.861-.364-1.644l-.003-.616a3.667 3.667 0 0 1 3.667-3.667l.505.001c-1.295-1.342-1.276-3.184-.136-4.325C7.266.696 9.711.981 11.001 3.31m-.826 10.441h-4.86l.002 1.94c.012.616-.004 1.266.294 1.823.503.94 1.581.995 2.533 1.003h2.03zm6.508 0h-4.858v4.766h2.03c.951-.018 2.03-.061 2.533-1.003.204-.382.285-.756.294-1.823zm-.183-5.683-4.675.001V12.1h5.155c.5-.005 1.1-.04 1.364-.535.108-.2.161-.425.17-.914l.002-.567A2.017 2.017 0 0 0 16.5 8.067m-11 0a2.017 2.017 0 0 0-2.017 2.017l.002.567c.01.49.063.713.17.914.265.494.862.53 1.361.535h5.159V8.068zM7.035 3.26c-.98.98-.07 2.82 2.908 3.134l.234.021C9.938 3.244 8.133 2.162 7.035 3.26m7.93 0c-1.098-1.098-2.903-.016-3.141 3.155l.233-.021c2.979-.314 3.888-2.154 2.908-3.134"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-grant-role" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.7 12h-6.2m6.2 0-3-2.691m3 2.692-3 2.692"/><path fill="currentColor" fill-rule="evenodd" d="M4.297 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.004.008c.012.015.053.052.138.052h15.59c.085 0 .126-.037.138-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.456-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.305.411-.8.658-1.342.658H2.205c-.54 0-1.036-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.495.737-5.703 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-graph_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M6 16a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m5-12a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m5 8a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1m5-4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="14" fill="none" id="svg-name-group" class="svg-sprite__symbol"><path fill="currentColor" d="M17.91 9.58A4.59 4.59 0 0 0 13.76 7h-1.52a4.6 4.6 0 0 0-2.45.7c.408.422.748.904 1.01 1.43.13.268.198.562.2.86V14h6a1.003 1.003 0 0 0 1-1V9.99a1 1 0 0 0-.09-.41M5.764 7H4.236A4.59 4.59 0 0 0 .094 9.576.96.96 0 0 0 0 10v3a1 1 0 0 0 1 1h9V9.993a.9.9 0 0 0-.094-.417A4.59 4.59 0 0 0 5.764 7M5 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6M13 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.929 19-7.593-8.638C.948 8.872.604 6.594 1.48 4.708c.656-1.409 1.902-2.393 3.349-2.645s2.804.259 3.84 1.372l1.259 1.54 1.258-1.54c1.037-1.113 2.536-1.624 3.983-1.372s2.693 1.236 3.349 2.645c.877 1.886.533 4.163-.855 5.654z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.929 19-7.593-8.638C.948 8.872.604 6.594 1.48 4.708c.656-1.409 1.902-2.393 3.349-2.645s2.804.259 3.84 1.372l1.259 1.54 1.258-1.54c1.037-1.113 2.536-1.624 3.983-1.372s2.693 1.236 3.349 2.645c.877 1.886.533 4.163-.855 5.654z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-heart-reaction" class="svg-sprite__symbol"><path fill="#fff" stroke="currentColor" d="m8.998 16.064-.258.428.258.155.257-.155zm0 0 .257.428.002-.001.005-.003.02-.012.07-.043c.06-.038.15-.094.261-.166a27.616 27.616 0 0 0 3.725-2.907c1.018-.953 2.051-2.087 2.832-3.339.78-1.25 1.325-2.644 1.325-4.104a4.886 4.886 0 0 0-4.884-4.884 4.87 4.87 0 0 0-3.613 1.601 4.87 4.87 0 0 0-3.614-1.6A4.886 4.886 0 0 0 .5 5.916c0 1.46.546 2.854 1.325 4.104.781 1.252 1.814 2.386 2.832 3.338a27.6 27.6 0 0 0 4.057 3.117l.019.012.005.003h.001v.001z"/><path fill="url(#a)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384"/><path fill="url(#b)" d="M14.426 1.923c2.399 3.824.19 8.843-2.464 10.267-2.93 1.575-4.934.835-9.083-1.52 2.365 3.135 6.118 5.389 6.118 5.389s7.998-4.804 7.998-10.147a4.39 4.39 0 0 0-2.57-3.989" opacity=".5"/><path fill="url(#c)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384" opacity=".5"/><path fill="url(#d)" d="M12.611 1.533c-1.5 0-2.824.755-3.613 1.905a4.38 4.38 0 0 0-3.614-1.905A4.386 4.386 0 0 0 1 5.917c0 5.343 7.998 10.147 7.998 10.147s7.997-4.804 7.997-10.147a4.386 4.386 0 0 0-4.384-4.384" opacity=".5"/><path fill="url(#e)" d="M7.903 3.313c.44 1.034-.535 2.439-2.18 3.134-1.644.694-3.328.425-3.768-.605s.535-2.44 2.179-3.134c1.644-.695 3.329-.43 3.769.605" opacity=".24"/><path fill="url(#f)" d="M13.261 2.473c.625.69.24 2.054-.855 3.044s-2.489 1.235-3.114.545c-.624-.69-.24-2.054.855-3.044s2.49-1.235 3.114-.545" opacity=".24"/><path fill="url(#g)" d="M12.691 2.698c2.2.75 4.299 3.999.75 8.047-2.124 2.425-4.443 3.65-7.393 3.17a27 27 0 0 0 2.955 2.149S17 11.26 17 5.917a4.393 4.393 0 0 0-4.389-4.384c-1.5 0-2.824.755-3.613 1.905 0 0 2.084-1.29 3.693-.74" opacity=".32"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 13.999 -9.992)scale(12.5142 9.92695)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset=".864" stop-color="#C20000"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 12.69 -10.965)scale(10.7743 8.54677)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C20000"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="rotate(-29.408 13.999 -9.992)scale(12.5142 9.92695)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity=".25"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(8.18957 -4.04683 1.9997 4.0468 11.209 9.835)" gradientUnits="userSpaceOnUse"><stop stop-color="#BD2719" stop-opacity=".25"/><stop offset="1" stop-color="#BD2719" stop-opacity="0"/></radialGradient><radialGradient id="e" cx="0" cy="0" r="1" gradientTransform="matrix(3.0175 -1.20025 .74557 1.87442 4.928 4.577)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(-40.763 11.386 -13.033)scale(2.6887 1.67029)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient><linearGradient id="g" x1="10.648" x2="12.197" y1="21.77" y2=".877" gradientUnits="userSpaceOnUse"><stop stop-color="#860805"/><stop offset="1" stop-color="#BD2719" stop-opacity="0"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-heart-with-coins" class="svg-sprite__symbol"><ellipse cx="15" cy="11" stroke="currentColor" stroke-width="1.5" rx="4" ry="2"/><path stroke="currentColor" stroke-width="1.5" d="M19 14c0 1.105-1.79 2-4 2s-4-.895-4-2"/><path stroke="currentColor" stroke-width="1.5" d="M11 10.75v6.929c0 .867 1.79 1.571 4 1.571s4-.704 4-1.571V10.75"/><path fill="currentColor" fill-rule="evenodd" d="M4.105 1.788c.85-.146 1.653.134 2.3.809l-4.353.795c.411-.868 1.181-1.455 2.053-1.604m9.868 4.258a3.18 3.18 0 0 0-.025-2.654c-.411-.868-1.181-1.455-2.054-1.604a2.72 2.72 0 0 0-2.41.809L8.52 3.755a.75.75 0 0 1-1.153 0l-.963-1.158-4.353.795c-.553 1.168-.33 2.576.532 3.487l.014.016L7.95 12.88 9 11.727v2.228l-.501.55a.75.75 0 0 1-1.114-.005L1.487 7.902C.197 6.532-.114 4.462.697 2.75 1.305 1.463 2.473.545 3.851.31 5.247.07 6.548.565 7.51 1.581l.032.036.402.484.402-.484.033-.036A4.22 4.22 0 0 1 12.148.309c1.378.236 2.546 1.154 3.155 2.44.49 1.036.57 2.202.272 3.265a12 12 0 0 0-1.602.032" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-heart_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14 2a11.97 11.97 0 0 0-8.485 3.515A11.97 11.97 0 0 0 2 14c0 3.313 1.344 6.315 3.515 8.485A11.97 11.97 0 0 0 14 26c3.313 0 6.315-1.344 8.485-3.515A11.97 11.97 0 0 0 26 14c0-3.313-1.344-6.315-3.515-8.485A11.97 11.97 0 0 0 14 2M6.929 6.929A9.97 9.97 0 0 1 14 4a9.97 9.97 0 0 1 7.071 2.929A9.97 9.97 0 0 1 24 14a9.97 9.97 0 0 1-2.929 7.071A9.97 9.97 0 0 1 14 24a9.97 9.97 0 0 1-7.071-2.929A9.97 9.97 0 0 1 4 14a9.97 9.97 0 0 1 2.929-7.071M11.422 9C9.275 9 7.5 10.733 7.5 12.9c0 1.127.306 2.018 1.031 2.916.665.824 1.694 1.662 3.076 2.743l.003.002 1.429 1.11c.565.439 1.357.439 1.922 0l1.43-1.11.003-.002c1.38-1.081 2.41-1.92 3.075-2.743.725-.898 1.031-1.789 1.031-2.916 0-2.167-1.775-3.9-3.922-3.9-.98 0-1.845.334-2.583.937-.74-.6-1.6-.937-2.573-.937M9.5 12.9c0-1.043.86-1.9 1.922-1.9.62 0 1.214.267 1.806.987a1 1 0 0 0 1.55-.008c.572-.71 1.162-.979 1.8-.979 1.062 0 1.922.857 1.922 1.9 0 .675-.152 1.122-.587 1.66-.494.612-1.327 1.308-2.75 2.423l-.002.001-1.161.901-1.16-.901-.002-.001c-1.424-1.115-2.256-1.811-2.751-2.423-.434-.538-.587-.985-.587-1.66" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-help-encircled" class="svg-sprite__symbol"><circle cx="8" cy="8" r="7.2" stroke="currentColor" stroke-width="1.2"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M5.6 6.4c0-3.357 4.8-3.357 4.8 0 0 1.6-1.6 2-2.4 3.2"/><path stroke="currentColor" stroke-width=".8" d="M8.4 12a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-help_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="M7.972 9.598c.376 0 .583-.21.662-.572.07-.454.228-.686.933-1.102.746-.449 1.133-1.005 1.133-1.82 0-1.26-1.012-2.102-2.516-2.102-1.139 0-1.986.46-2.325 1.172-.106.206-.159.41-.159.643 0 .41.26.675.678.675.323 0 .561-.15.694-.497.17-.48.519-.74 1.038-.74.583 0 .985.368.985.897 0 .497-.206.767-.89 1.183-.625.373-.948.794-.948 1.431v.076c0 .443.265.756.715.756"/><path fill="currentColor" fill-rule="evenodd" d="M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8" clip-rule="evenodd"/><path fill="currentColor" d="M8.9 11.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-help_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10 6.25a1.25 1.25 0 0 0-1.21.937.75.75 0 0 1-1.453-.374 2.75 2.75 0 0 1 5.413.687c0 1.211-.654 1.84-1.145 2.298l-.008.008c-.478.446-.772.72-.854 1.3a.75.75 0 0 1-1.485-.212c.158-1.11.803-1.709 1.256-2.13l.068-.062c.447-.417.668-.663.668-1.202 0-.69-.56-1.25-1.25-1.25M10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/><path fill="currentColor" fill-rule="evenodd" d="M10 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-help_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M25.46 18.099c-.63.377-1.176.98-1.567 1.958a1.5 1.5 0 1 1-2.786-1.114c.61-1.523 1.562-2.669 2.809-3.417C25.145 14.79 26.556 14.5 28 14.5c4.473 0 7 3.85 7 7 0 2.81-1.717 4.354-2.983 5.494l-.257.232c-1.307 1.19-2.26 2.19-2.26 4.274a1.5 1.5 0 0 1-3 0c0-3.416 1.797-5.177 3.24-6.492l.071-.065C31.24 23.643 32 22.949 32 21.5c0-1.85-1.518-4-4-4-1.056 0-1.895.211-2.54.599M28 41a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill="currentColor" fill-rule="evenodd" d="M28 52c13.255 0 24-10.745 24-24S41.255 4 28 4 4 14.745 4 28s10.745 24 24 24m0-3c11.598 0 21-9.402 21-21S39.598 7 28 7 7 16.402 7 28s9.402 21 21 21" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hide-eye" class="svg-sprite__symbol"><path fill="currentColor" d="M10 4.709a.75.75 0 0 0 0-1.5zm-5.338 8.897a.75.75 0 1 0 .676-1.339zm5.336-10.4a.75.75 0 0 0 .004 1.5zm2.97 1.884a.75.75 0 1 0 .386-1.45zm-8.52 11.47a.75.75 0 0 0 1.104 1.016zm4.046-2.178a.75.75 0 0 0-1.103-1.016zM18.55 3.456a.75.75 0 0 0-1.105-1.014zm-3.41 1.497a.75.75 0 0 0 1.106 1.015l-1.105-1.015Zm-7.75 8.413a.75.75 0 1 0 1.104 1.017l-1.103-1.017Zm3.295-2.469.552.509v-.001zm1.24-1.35-.552-.507.552.508Zm4.317-3.58A.75.75 0 1 0 15.14 4.95l1.103 1.016Zm-8.177 7.168a.75.75 0 0 0-.246 1.48zm1.934.909v-.75zM18 9h.75q0-.026-.002-.053zm-1.957-4.205a.75.75 0 0 0-.702 1.326zM7.77 10.624a.75.75 0 0 0 1.217-.877zm.445-2.534.67.34zm1.787-1.107L10 6.234h-.005l.006.75Zm.654.937a.75.75 0 0 0 .796-1.27zM10 3.21c-2.329 0-4.472.593-6.057 1.592C2.368 5.794 1.25 7.26 1.25 9h1.5c0-1.044.673-2.1 1.993-2.931 1.31-.825 3.167-1.36 5.257-1.36v-1.5ZM1.25 9c0 1.992 1.456 3.618 3.412 4.605l.676-1.339C3.637 11.407 2.75 10.191 2.75 9zm8.752-4.295a11.4 11.4 0 0 1 2.966.384l.386-1.45a12.9 12.9 0 0 0-3.356-.434zm-4.45 12.87 2.942-3.195-1.103-1.016-2.943 3.194 1.104 1.016ZM17.445 2.441l-2.304 2.511 1.105 1.015 2.304-2.512zm-8.951 11.94 2.743-2.976-1.103-1.017-2.743 2.977zm2.744-2.977 1.24-1.35-1.105-1.015-1.24 1.35zm1.239-1.35 3.765-4.088L15.14 4.95l-3.767 4.09 1.104 1.016Zm-4.658 4.56q1.083.18 2.181.179l-.001-1.5a12 12 0 0 1-1.934-.16l-.246 1.48Zm2.18.179c2.329 0 4.472-.594 6.057-1.593 1.575-.992 2.693-2.458 2.693-4.2h-1.5c0 1.044-.673 2.1-1.993 2.931-1.31.826-3.167 1.362-5.257 1.362zm8.748-5.846a5.11 5.11 0 0 0-2.705-4.152l-.702 1.326a3.61 3.61 0 0 1 1.911 2.933zm-9.76.8a1.27 1.27 0 0 1-.104-1.318l-1.338-.678a2.77 2.77 0 0 0 .224 2.873zM8.882 8.43a1.27 1.27 0 0 1 1.124-.696l-.012-1.5a2.77 2.77 0 0 0-2.45 1.518zm1.119-.696c.23 0 .457.065.653.187l.796-1.27A2.73 2.73 0 0 0 10 6.233l.002 1.5Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hide_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.964 5.5A.75.75 0 0 1 9.958 4a11.9 11.9 0 0 1 5.918 1.578C17.566 6.558 19 8.068 19 10c0 1.003-.393 1.901-.999 2.659a.75.75 0 1 1-1.171-.937c.442-.553.67-1.13.67-1.722 0-1.13-.858-2.245-2.376-3.125A10.4 10.4 0 0 0 9.964 5.5M4.124 14.422C5.844 15.42 8.036 16 10 16c1.605 0 3.355-.388 4.873-1.066l.847.846a.75.75 0 1 0 1.06-1.06L5.28 3.22a.75.75 0 0 0-1.06 1.06l.823.824c-.974.445-1.87 1.02-2.57 1.712C1.606 7.672 1 8.752 1 10c0 1.932 1.433 3.443 3.124 4.422M8.5 10a1.5 1.5 0 0 0 2.53 1.09L8.91 8.97c-.254.269-.41.631-.41 1.03M7 10a3 3 0 0 0 5.09 2.151l1.635 1.635c-1.201.458-2.523.714-3.725.714-1.702 0-3.635-.513-5.124-1.376C3.358 12.244 2.5 11.13 2.5 10c0-.731.35-1.448 1.028-2.117.66-.653 1.593-1.217 2.66-1.635l1.66 1.661A3 3 0 0 0 7 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-hide_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M12.44 10.44a1.5 1.5 0 0 1 2.12 0l31 31a1.5 1.5 0 0 1-2.12 2.12l-2.515-2.513C37.03 43.573 32.652 45 28 45c-6.256 0-12.004-2.583-16.639-6.832C7.644 34.761 5 30.485 5 28c0-3.35 4.362-9.256 9.932-12.947l-2.493-2.492a1.5 1.5 0 0 1 0-2.122m4.662 6.784C12.052 20.387 8 25.732 8 28c0 1.454 2.232 5.063 5.389 7.957C17.505 39.73 22.556 42 28 42c3.828 0 7.46-1.118 10.75-3.129l-4.446-4.446a9 9 0 0 1-12.728-12.728zM28 11c6.256 0 12.004 2.583 16.639 6.832C48.356 21.239 51 25.515 51 28c0 1.99-1.714 5.171-4.331 8.11a1.5 1.5 0 1 1-2.24-1.996C46.6 31.676 48 29.078 48 28c0-1.454-2.231-5.063-5.389-7.957C38.496 16.27 33.444 14 28 14c-1.443 0-2.86.159-4.248.468a1.5 1.5 0 0 1-.652-2.928A22.5 22.5 0 0 1 28 11m-4.302 12.819a6 6 0 0 0 8.484 8.485zm5.93-3.296a1.5 1.5 0 0 1 1.974-.773 9.03 9.03 0 0 1 4.651 4.651 1.5 1.5 0 0 1-2.75 1.2 6.03 6.03 0 0 0-3.102-3.102 1.5 1.5 0 0 1-.774-1.976"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-hint" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9"/><path d="M7 8c0-4.196 6-4.196 6 0 0 2-2 2.5-3 4M10 14.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-home_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="m24 11.15-8.9-8.5c-.6-.6-1.6-.6-2.3 0l-8.9 8.5c-.6.6-.9 1.4-.9 2.2v8.6c0 1.4 1.1 2.5 2.5 2.5h6c.6 0 1-.4 1-1v-7h3v7c0 .6.4 1 1 1h6c1.4 0 2.5-1.1 2.5-2.5v-8.6c0-.8-.4-1.6-1-2.2m-1 10.8c0 .3-.2.5-.5.5h-5v-7c0-.6-.4-1-1-1h-5c-.6 0-1 .4-1 1v7h-5c-.3 0-.5-.2-.5-.5v-8.6c0-.3.1-.5.3-.7l8.7-8.3 8.7 8.3c.2.2.3.5.3.7z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-icon_close_20" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5 5 10 10M15 5 5 15"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-image" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" rx="2"/><path d="m4 19 2.781-4.768a1 1 0 0 1 1.632-.136l.665.798a1 1 0 0 0 1.636-.144l2.511-4.395a1 1 0 0 1 1.682-.085L19 16"/><circle cx="7" cy="7" r="2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-infinity" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.367 7.644A4.05 4.05 0 0 0 5.093 6C2.835 6 1 7.793 1 10s1.835 4 4.093 4c1.52 0 2.932-.782 3.715-2.057L10.005 10l1.187-1.943A4.36 4.36 0 0 1 14.907 6C17.165 6 19 7.793 19 10s-1.835 4-4.093 4c-1.35 0-2.528-.65-3.274-1.644"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-info_circle_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/><path fill="currentColor" d="M11 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M3.99 3.99A8.48 8.48 0 0 1 10 1.5c2.347 0 4.473.952 6.01 2.49A8.48 8.48 0 0 1 18.5 10a8.48 8.48 0 0 1-2.49 6.01A8.48 8.48 0 0 1 10 18.5a8.48 8.48 0 0 1-6.01-2.49A8.48 8.48 0 0 1 1.5 10c0-2.347.952-4.473 2.49-6.01M10 3a6.98 6.98 0 0 0-4.95 2.05A6.98 6.98 0 0 0 3 10c0 1.933.783 3.682 2.05 4.95A6.98 6.98 0 0 0 10 17a6.98 6.98 0 0 0 4.95-2.05A6.98 6.98 0 0 0 17 10a6.98 6.98 0 0 0-2.05-4.95A6.98 6.98 0 0 0 10 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-information" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" d="M10.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path fill="currentColor" d="M9.25 14a.75.75 0 0 0 1.5 0zm1.5-5a.75.75 0 0 0-1.5 0zm0 5V9h-1.5v5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-italic" class="svg-sprite__symbol"><path fill="currentColor" d="M7.279 16.794a.75.75 0 1 0 1.442.412zM12.72 3.206a.75.75 0 1 0-1.442-.412zm-4 14 4-14-1.442-.412-4 14z"/><path fill="currentColor" d="M10 2.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM6 16.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5H6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-italic-active" class="svg-sprite__symbol"><path fill="#F15F2C" d="M7.279 16.794a.75.75 0 1 0 1.442.412zM12.72 3.206a.75.75 0 1 0-1.442-.412zm-4 14 4-14-1.442-.412-4 14z"/><path fill="#F15F2C" d="M10 2.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM6 16.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5H6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-laught-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><g clip-path="url(#b)"><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#d)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#e)" d="M7.24 4.855c0-.32-.346-.521-.941-.521-.506 0-1.619.28-2.385 1.265-.142.182.074.283.215.164.473-.402 1.734-.915 2.72-.808.395.045.391-.1.391-.1"/><path fill="url(#f)" d="M6.388 8.743c.425 0 .77-.521.77-1.164 0-.644-.345-1.165-.77-1.165s-.77.521-.77 1.165c0 .643.345 1.164.77 1.164"/><path fill="url(#g)" d="M6.388 6.805c.331 0 .618.286.77.714-.011-.629-.35-1.135-.77-1.135s-.76.506-.77 1.135c.152-.424.439-.714.77-.714"/><path fill="url(#h)" d="M10.76 4.855c0-.32.346-.521.941-.521.506 0 1.619.279 2.385 1.265.142.182-.074.283-.215.164-.473-.402-1.734-.916-2.72-.808-.395.045-.391-.1-.391-.1"/><path fill="url(#i)" d="M11.612 8.743c.426 0 .77-.521.77-1.164 0-.644-.344-1.165-.77-1.165-.425 0-.77.521-.77 1.165 0 .643.345 1.164.77 1.164"/><path fill="url(#j)" d="M11.612 6.805c-.33 0-.617.286-.77.714.011-.629.35-1.135.77-1.135s.76.506.77 1.135c-.152-.424-.439-.714-.77-.714"/><path fill="url(#k)" d="M14.403 10.354a.3.3 0 0 0-.186-.007 19 19 0 0 1-5.213.726c-1.771 0-3.528-.246-5.213-.726a.3.3 0 0 0-.186.007c-.183.075-.473.35-.09 1.403v.004C4.081 13.108 5.58 15.474 9 15.474c3.412 0 4.912-2.37 5.492-3.713.38-1.057.093-1.332-.09-1.407"/><path fill="url(#l)" d="M9 15.099c1.418 0 2.482-.436 3.278-1.031-.874-.395-1.953-.651-3.278-.651s-2.404.26-3.278.658C6.518 14.663 7.582 15.1 9 15.1"/><path fill="url(#m)" d="M14.295 10.332q-.015-.001-.037.004c-1.704.491-3.472.74-5.262.74s-3.557-.249-5.261-.74q-.016-.005-.037-.004c-.116.011-.666.127-.194 1.429v.004c.23.543.614 1.254 1.213 1.905-.562-.666.13-1.035 1.362-.886s2.917.153 2.917.153 1.682-.004 2.918-.153c1.231-.149 1.923.22 1.361.886a6.7 6.7 0 0 0 1.213-1.905v-.004c.473-1.306-.078-1.421-.193-1.429"/><path fill="url(#n)" d="M13.346 12.163c.469-.1.822-.491.867-.971l.045-.47a19.4 19.4 0 0 1-10.516 0l.045.47c.045.476.398.867.867.97a20.722 20.722 0 0 0 8.692 0"/></g><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFDF30"/><stop offset="1" stop-color="#FFB82E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFDF30"/><stop offset="1" stop-color="#FFB82E"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE95F"/><stop offset="1" stop-color="#FFBB47" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -1.983 7.897)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .63 11.373)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="k" cx="0" cy="0" r="1" gradientTransform="translate(9 12.905)scale(4.40705)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="matrix(3.65248 0 0 1.10415 9.066 14.455)" gradientUnits="userSpaceOnUse"><stop offset=".248" stop-color="red"/><stop offset="1" stop-color="#C10000"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="matrix(9.66477 0 0 9.66478 9 11.675)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#fff"/><stop offset="1" stop-color="#A8BBBD"/></radialGradient><linearGradient id="e" x1="5.553" x2="5.553" y1="5.391" y2="4.548" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="g" x1="6.388" x2="6.388" y1="6.405" y2="7.491" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="h" x1="12.447" x2="12.447" y1="5.391" y2="4.548" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="j" x1="11.612" x2="11.612" y1="6.405" y2="7.491" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="m" x1="14.615" x2="3.453" y1="11.999" y2="11.999" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset=".5" stop-color="#512D00"/><stop offset="1" stop-color="#3C2200"/></linearGradient><clipPath id="b"><path fill="#fff" d="M1 1h16v16H1z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-lightning-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M8.33 15.535c-.384 1.605.193 1.938 1.226.766l4.338-5.17c1.004-1.27.752-2.29-.693-2.546l-2.092-.402a.233.233 0 0 1-.177-.284l.805-3.444c.385-1.616-.258-1.909-1.222-.763a607 607 0 0 1-3.157 3.67q-.376.433-1.213 1.35c-1.22 1.406-.578 2.425.834 2.68l2 .372a.233.233 0 0 1 .178.285z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE149"/><stop offset="1" stop-color="#E96D1E"/></linearGradient><linearGradient id="b" x1="5.056" x2="16.529" y1="18.726" y2="11.303" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="svg-name-like" class="svg-sprite__symbol"><path fill-rule="evenodd" d="m11.913 22-9.28-10.163C.936 10.084.516 7.404 1.588 5.186 2.39 3.529 3.913 2.37 5.681 2.074c1.769-.296 3.427.304 4.693 1.614l1.539 1.59 1.538-1.59a5.53 5.53 0 0 1 4.868-1.614c1.768.297 3.291 1.455 4.093 3.112 1.072 2.218.652 4.898-1.045 6.651z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" id="svg-name-like-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M6.958 2.481c-.025-.504.016-.981.212-1.349.104-.194.253-.36.454-.474.199-.113.419-.158.64-.158.165 0 .38.05.598.137.227.091.49.238.74.461.514.459.935 1.206.935 2.34 0 1.016-.194 1.76-.335 2.304l-.021.081c-.156.602-.155.76-.07.893.03.048.098.108.244.16s.328.081.524.092a4 4 0 0 0 .713-.033h.01v-.001l.37-.06.161.337L13.29 9.62l.054.114-.006.126-.242 5.005-.004.093-.038.085-.723 1.641-.09.206-.215.068-.153-.476.153.476h-.001l-.002.001-.005.002-.016.005-.056.016-.205.054c-.178.043-.438.1-.776.155-.675.11-1.661.216-2.926.203-.886-.01-1.79-.399-2.457-.743-.284-.146-.54-.293-.744-.41l-.112-.064a5 5 0 0 0-.254-.139l-.007-.003c-.159.01-.528.049-.976.1-.511.06-1.078.13-1.421.177a.72.72 0 0 1-.572-.18 1.3 1.3 0 0 1-.28-.37c-.134-.255-.239-.595-.323-.962-.17-.743-.28-1.726-.314-2.696-.034-.968.006-1.96.152-2.718.072-.373.177-.73.339-1.004.16-.27.455-.574.91-.535q.214.018.393.037c.395.04.684.069.974.026.322-.048.655-.193 1.063-.656a7.6 7.6 0 0 1 1.124-1.073l.127-.097c.239-.184.463-.356.796-.688.32-.321.475-.84.526-1.434.041-.473.012-.919-.01-1.256z"/><path fill="url(#b)" stroke="currentColor" d="M8.556 8.643c.02-.516.267-.907.626-1.174.339-.253.768-.391 1.186-.472.832-.161 1.815-.126 2.469-.101h.023l.08.003a3.9 3.9 0 0 1 1.089.216c.303.112.64.292.905.587.274.307.445.713.44 1.219a1.58 1.58 0 0 1-.358 1.021c-.218.26-.498.416-.762.512-.516.188-1.074.18-1.314.171l-2.118-.08c-.58-.023-1.154-.12-1.586-.416-.478-.328-.704-.84-.68-1.486Zm.5.019Z"/><path fill="url(#c)" stroke="currentColor" d="M10.154 15.222c.61.106 1.41.186 2.155.205.373.01.74.004 1.065-.023.317-.026.629-.075.875-.167zm0 0c-.578-.102-1.001-.38-1.259-.762a1.68 1.68 0 0 1-.261-1.176zm3.359-3.16c-.271-.009-.495-.013-.688-.016-.423-.008-.7-.013-1.004-.049a9 9 0 0 0-1.007-.065zm0 0c1.17.033 1.703 1.023 1.682 1.746-.02.702-.418 1.231-.946 1.429zm-3.936.122c-.364.169-.856.506-.943 1.1zm0 0c.38-.177.81-.263 1.078-.255z"/><path fill="url(#d)" stroke="currentColor" d="M13.317 17.26c-.317.1-.84.181-1.377.218-.539.037-1.151.033-1.645-.061-.504-.097-.899-.292-1.148-.64-.24-.335-.279-.725-.279-1.05 0-.903.756-1.45 1.402-1.45.237 0 .421.04.584.077l.06.013c.175.038.395.08.775.1a5 5 0 0 0 .534-.026c.209-.017.454-.037.681-.037.235 0 .573.026.857.225.323.226.462.59.462 1.015 0 .343-.04.681-.173.968a1.18 1.18 0 0 1-.733.648Z"/><path fill="url(#e)" stroke="currentColor" d="M15.847 11.442c-.005.294-.079.774-.46 1.174-.389.408-1.01.641-1.915.623a78 78 0 0 1-2.729-.103 27 27 0 0 0-.616-.027 1.95 1.95 0 0 1-1.038-.338c-.389-.274-.687-.732-.674-1.4.013-.636.272-1.098.65-1.388.35-.269.764-.36 1.088-.358l.038-.002.166-.007c.148-.005.375-.011.69-.016.63-.008 1.614-.01 3.043.019.654.013 1.117.307 1.401.697.268.37.363.803.356 1.126Z"/><g clip-path="url(#f)"><path fill="url(#g)" d="M8.265 1c-.62 0-.855.496-.807 1.456.032.634.245 2.399-.649 3.293-.833.834-1.076.76-2.025 1.836-.95 1.077-1.74.855-2.848.76-1.392-.12-.918 7.606.063 7.472.696-.095 2.279-.285 2.532-.285s1.989 1.346 3.512 1.362c2.468.026 3.83-.412 3.83-.412l.723-1.64.242-5.006-1.155-2.408s-1.551.253-1.994-.444c-.443-.696.348-1.551.348-3.546S8.581 1 8.265 1"/><path fill="url(#h)" d="m11.959 16.467-.094-.342c-.279-.03-.636.097-1.125.093-2.334-.018-4.565-.688-5.522-1.447-.627-.496-.902-1.157-1.345-.967-.547.234-2.097.599-2.668-.123.16 1.235.445 2.184.794 2.136.696-.095 2.279-.285 2.532-.285s1.94 1.31 3.512 1.362c2.034.066 3.84-.284 3.84-.284z"/><path fill="url(#i)" d="M2.924 8.833c.918.253 1.5-.166 1.97-.736.466-.566.87-1.069 2.041-1.828s1.02-2.85.926-3.546C7.766 2.026 7.829 1 8.265 1c-.62 0-.855.496-.807 1.456.032.633.245 2.399-.649 3.293-.833.834-1.075.76-2.025 1.836s-1.74.855-2.848.76c0 .24.07.235.988.488"/><path fill="url(#j)" d="M9.689 6.984c-.443-.696.348-1.551.348-3.546S8.582 1 8.265 1a1 1 0 0 0-.224.027c1.291.081 2.069 1.71 1.624 3.39-.361 1.362-.541 2.455.048 3.096.382.415 1.14.344 1.97-.086 0 0-1.551.254-1.994-.443"/><path fill="url(#k)" d="M9.776 7.695c-.76.253-2.678.85-4.13 2.167-3.682 3.34 2.604 3.76 3.902 6.616.248.546 1.699-2.864 1.699-2.864l.469-.79-1.356-3.61z"/><path fill="url(#l)" d="M9.887 7.984c-.76.253-3.862 2.242-3.862 3.224 0 2.833 2.149 1.435 3.31 4.779.16.463.729.852.729.852.47-.384 1.183-3.225 1.183-3.225l.469-.79-1.356-3.61z"/><path fill="url(#m)" d="m11.64 16.67 1.454-1.663.32-6.946-3.638-.366c-.836.45-.932 1.064-.622 2.052.13.416-.4.535-.434 1.745-.024.84.525.843.525 1.093s-.273.227-.364.95c-.13 1.033.735 1.053.735 1.274s-.48.353-.45 1.195c.037 1.069-1.947.853-3.288-.12-.55-.399-1.031-.44-1.406-.35l.058-.001c.253 0 1.953 1.361 3.513 1.361 1.823 0 3.085-.107 3.597-.224"/><path fill="url(#n)" d="M11.974 8.153c-1.123 0-1.74 1.098-1.313 1.942s-.791 1.96-.665 2.51c.127.55.349 1.942.522 2.172s-.285.753-.285.753l1.425.174 1.329-.586-.048-4.02.142-2.517z"/><path fill="url(#o)" d="M4.784 7.586c-.617.699-1.167.85-1.78.845.177.285.3.597.287.902-.033.8.143 1.785.277.76.103-.78.632-1.746 1.269-2.567z"/><path fill="url(#p)" d="M12.825 7.396c-1.328-.051-3.716-.126-3.769 1.266-.038 1.01.677 1.34 1.784 1.383l2.119.08c.459.018 1.9.01 1.915-1.21.017-1.523-2.049-1.52-2.049-1.52"/><path fill="url(#q)" d="M10.64 12.429c-.355-.01-1.413.256-1.511.928-.078.528.191 1.21 1.111 1.372 1.166.204 3.108.311 3.834.04.324-.122.607-.461.621-.976a1.21 1.21 0 0 0-1.197-1.232c-.83-.024-1.263-.011-1.736-.067-.57-.067-.836-.057-1.121-.065"/><path fill="url(#r)" d="M10.27 14.777a.94.94 0 0 0-.902.95c0 .593.154 1.032 1.02 1.199.867.166 2.256.023 2.778-.143.407-.13.557-.51.557-1.14s-.391-.739-.819-.739-.945.078-1.241.063c-.827-.044-.99-.19-1.393-.19"/><path fill="url(#s)" d="M12.712 7.677c-1.16-.044-3.245-.111-3.287.99-.03.797.596 1.061 1.563 1.098.966.037 3.509.084 3.517-.88.011-1.204-1.793-1.208-1.793-1.208"/><path fill="url(#t)" d="M10.748 12.712c-.31-.009-1.178.065-1.26.707-.057.434.168.992.97 1.125 1.014.17 2.705.26 3.337.038.281-.099.527-.376.54-.798.012-.421-.377-.938-1.1-.96-.723-.02-1.107.047-1.52 0-.494-.056-.72-.105-.967-.112"/><path fill="url(#u)" d="M10.443 14.993c-.35 0-.78.287-.78.765s.133.832.882.965c.75.134 1.95.02 2.402-.114.352-.105.483-.411.483-.918s-.339-.595-.708-.595c-.37 0-.819.063-1.075.05-.715-.035-.855-.153-1.204-.153"/><path fill="url(#v)" d="M10.23 8.667c.029-.759.633-1.122 1.397-1.29-1.219.029-2.531.257-2.571 1.285-.038 1.01.677 1.34 1.784 1.383q.183.008.346.013c-.622-.182-.986-.592-.956-1.391"/><path fill="url(#w)" d="M10.334 7.515c-.71.155-1.253.49-1.278 1.147-.032.84.458 1.21 1.26 1.335-1.627-.65-1.043-2.25.018-2.482"/><path fill="url(#x)" d="M7.228 15.063c-.126.452-1.007.602-1.966.335-.96-.268-1.635-.852-1.509-1.305s1.007-.603 1.966-.335 1.635.851 1.51 1.305"/><path fill="url(#y)" d="M13.82 8.87c-.009.583-.787.86-1.64.91-.696.043-1.469-.45-1.449-1.02.02-.568.121-1.072 1.569-1.022.853.03 1.53.563 1.52 1.132"/><path fill="url(#z)" d="M13.975 13.99c-.004.807-.891.653-1.743.709-1.08.071-1.796-.265-1.796-.835-.001-.57.41-.984 1.858-.986.853-.002 1.687.076 1.681 1.113"/><path fill="url(#A)" d="M13.194 16.024c-.004.688-.81.781-1.573.782-.763 0-1.591-.404-1.592-.89 0-.485.367-.839 1.662-.84.763-.002 1.509.065 1.503.948"/><path fill="url(#B)" d="M10.119 13.52c.121-.918.825-.865 1.633-.96-.93-.07-1.32-.08-1.32-.08a1.5 1.5 0 0 0-.284.002c-.302.067-.644.204-.848.462a1.1 1.1 0 0 0-.161.351l-.01.062c-.066.53.191 1.21 1.111 1.372q.201.035.426.065l.234.03.068.008c-.507-.24-.938-.637-.85-1.312"/><path fill="url(#C)" d="M10.344 12.475q-.094-.003-.197.007c-.304.068-.65.207-.852.469a1.1 1.1 0 0 0-.156.345l-.01.06c-.093.523.165 1.138.97 1.342-1.372-.757-.787-2.222.245-2.223"/><path fill="url(#D)" d="M11.142 14.917c-.405-.06-.572-.14-.872-.14a.94.94 0 0 0-.902.949c0 .216.021.41.088.58.068.14.168.27.304.38.15.105.353.186.629.24.185.035.394.056.614.066-.424-.246-1.141-.378-.99-1.202.166-.909.708-.786 1.13-.873"/><path fill="url(#E)" d="M10.252 14.777a.944.944 0 0 0-.884.95c0 .543.13.957.818 1.15-1.074-.69-.73-1.855.066-2.1"/><path fill="url(#F)" d="M14.874 8.915a1.4 1.4 0 0 0-.043-.374c.107.476-.317.949-1.44 1.178-.745.152-2.722.342-4.09-.201.295.357.839.5 1.54.526l2.118.081c.459.018 1.9.01 1.915-1.21"/><path fill="url(#G)" d="M14.696 13.76c-.002-.51-.385-1.176-1.198-1.199-.83-.024-1.263-.011-1.736-.067-.57-.067-.837-.057-1.121-.065-.215-.007-.746.058-1.107.283.406.14 1.067.352 1.997.293 2.23-.144 2.864.126 3.164.755"/><path fill="url(#H)" d="M10.163 10.125c-.475-.01-1.228.27-1.248 1.256s.842 1.22 1.222 1.228c.38.007 1.707.098 3.345.13 1.637.033 1.856-.846 1.866-1.307.009-.46-.283-1.293-1.268-1.313-2.848-.058-3.917.006-3.917.006"/><path fill="url(#I)" d="M10.418 10.411c-.413-.008-1.067.206-1.082.966s.734.943 1.064.95 1.484.079 2.907.107c1.424.029 1.613-.649 1.62-1.004.007-.356-.042-.999-.898-1.016-2.476-.05-3.611-.003-3.611-.003"/><path fill="url(#J)" d="M9.934 11.286c.047-1.012.753-1.015 1.55-1.19-.932.006-1.321.029-1.321.029-.475-.01-1.228.27-1.248 1.255-.02.986.842 1.22 1.222 1.228.137.003.397.016.75.034-.526-.217-.988-.612-.953-1.356"/><path fill="url(#K)" d="M14.513 11.39c.033.806-.861.958-1.714.998s-1.8-.39-1.828-.959c-.027-.568.364-1.002 1.81-1.072.854-.041 1.69-.002 1.732 1.033"/><path fill="url(#L)" d="M10.074 10.127c-.474.025-1.14.327-1.16 1.253-.018.937.76 1.196 1.163 1.225-1.56-.63-1.049-2.385-.003-2.478"/><path fill="url(#M)" d="M15.345 11.333c-.206 1.458-4.06 1.19-6.141.878.28.3.699.392.933.397.38.008 1.707.098 3.345.131 1.637.033 1.856-.847 1.866-1.307q0-.047-.003-.1"/><path fill="url(#N)" d="M13.415 14.58c-.747.033-2.722.278-4.161-.493.16.298.471.552.986.642 1.166.204 3.108.311 3.834.04.324-.122.607-.461.621-.976-.047.448-.474.751-1.28.787"/><path fill="url(#O)" d="M13.666 16.2c-.489.373-1.334.592-2.554.386-.753-.127-1.27-.17-1.609-.18.136.246.398.426.886.52.866.166 2.255.024 2.777-.142.268-.086.424-.281.5-.584"/><path fill="url(#P)" d="M9.529 15.192c.903-.329 1.346.16 2.313.16 1.004 0 1.483-.406 1.84-.02-.113-.356-.433-.428-.777-.428-.428 0-.946.078-1.242.063-.827-.044-.99-.19-1.393-.19a.94.94 0 0 0-.741.415"/><path fill="url(#Q)" d="M1.999 15.817c.696-.095 2.279-.285 2.532-.285-2.295-1.641-1.275-5.132-.428-6.897.119-.248.192-.452.232-.624-.764.582-1.47.414-2.4.334-1.39-.119-.917 7.606.064 7.472"/><path fill="url(#R)" d="M4.53 15.533c-.196-.168-.433-.45-.647-.723 0 0-1.152.59-2.388.312.143.451.314.721.504.695.696-.095 2.279-.284 2.532-.284"/><path fill="url(#S)" d="M9.003 3.904C8.553 4 8.187 3.378 7.98 2.65c-.169-.595.06-1.352.504-1.438.443-.085.852-.089 1.096 1.172.143.742-.136 1.424-.577 1.519"/><path fill="url(#T)" d="M11.683 7.427s-1.551.253-1.994-.443c-.443-.697.348-1.552.348-3.546C10.037 1.443 8.581 1 8.265 1c-.62 0-.855.496-.807 1.456.032.633.245 2.399-.649 3.293-.833.834-1.076.76-2.025 1.836-.95 1.076 5.885.3 6.898-.158"/><path fill="#804B24" d="M10.252 14.777a.91.91 0 0 0-.675.3.98.98 0 0 0-.249.712c.008.248.046.518.208.726.16.21.411.309.65.363-.231-.084-.461-.202-.598-.401-.139-.197-.175-.447-.177-.69a.94.94 0 0 1 .214-.668.97.97 0 0 1 .627-.342M9.854 12.569c-.168.054-.337.129-.473.251a.9.9 0 0 0-.279.467v.002c-.03.157-.046.325-.013.486.032.16.099.314.195.446.195.268.505.418.813.477-.3-.097-.58-.264-.754-.518a1.14 1.14 0 0 1-.168-.876l-.001.002c.046-.165.114-.329.241-.448.125-.121.276-.218.44-.29"/><path fill="#804B24" d="M10.074 10.127c-.296.003-.6.104-.824.315-.227.208-.344.514-.369.814-.024.299.025.623.212.87.184.248.472.392.762.445-.283-.083-.548-.244-.71-.483-.164-.238-.21-.538-.18-.825.017-.288.127-.57.33-.776.202-.205.485-.327.779-.36M10.334 7.515c-.32.056-.645.154-.913.359a1.05 1.05 0 0 0-.406.886c0 .33.114.686.382.9.262.218.597.3.919.337-.318-.068-.639-.171-.877-.384-.242-.212-.346-.536-.342-.854a1 1 0 0 1 .364-.836c.247-.203.56-.322.873-.408M9.254 14.087c.094.19.245.352.428.466.183.112.393.176.603.211q.628.11 1.262.164c.424.027.848.04 1.273.029.422-.015.854-.04 1.254-.19a2.7 2.7 0 0 1-.623.106 7 7 0 0 1-.633.028c-.422.002-.844-.02-1.265-.056a14 14 0 0 1-1.259-.135c-.41-.056-.825-.25-1.04-.623"/><path fill="#804B24" d="M9.204 12.211c.152.17.357.292.576.36.222.073.458.063.683.078l1.364.068 1.365.039c.45.025.926.01 1.348-.17-.434.149-.895.142-1.347.115l-1.364-.067-1.365-.04c-.229-.01-.456.004-.672-.061a1.26 1.26 0 0 1-.588-.322M14.08 10.118a45 45 0 0 0-1.959-.055c-.653-.01-1.306-.01-1.96.03h.003a1.3 1.3 0 0 0-.92.366c-.119.12-.206.27-.258.429-.05.16-.068.327-.07.492.014-.33.125-.66.361-.888.232-.23.565-.34.885-.335h.003c.325-.012.652-.014.978-.017l.978-.013.98-.002c.326.004.652-.006.979-.007"/></g><defs><linearGradient id="a" x1="11.734" x2="6.973" y1="8.816" y2="9.007" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="b" x1="14.649" x2="9.986" y1="8.752" y2="8.752" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="c" x1="14.649" x2="9.983" y1="13.68" y2="13.68" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="d" x1="14.649" x2="9.985" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="e" x1="14.649" x2="9.985" y1="11.418" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="g" x1="11.734" x2="6.973" y1="8.816" y2="9.007" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="h" x1="6.934" x2="6.601" y1="11.295" y2="14.868" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="i" x1="5.985" x2="9.571" y1="5.993" y2="11.12" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="j" x1="3.39" x2="12.575" y1="3.95" y2="4.638" gradientUnits="userSpaceOnUse"><stop offset=".312" stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FF8900"/></linearGradient><linearGradient id="k" x1="3.215" x2="15.276" y1="12.116" y2="12.116" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="l" x1="1.27" x2="25.099" y1="12.134" y2="12.893" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="m" x1="5.056" x2="8.997" y1="15.248" y2="13.113" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="n" x1="9.57" x2="12.857" y1="12.216" y2="11.785" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#643800"/></linearGradient><linearGradient id="o" x1="3.738" x2="4.451" y1="4.962" y2="16.764" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#FFA754"/></linearGradient><linearGradient id="p" x1="14.649" x2="9.986" y1="8.752" y2="8.752" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="q" x1="14.649" x2="9.983" y1="13.68" y2="13.68" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="r" x1="14.649" x2="9.986" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="s" x1="9.357" x2="11.786" y1="8.775" y2="8.72" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="t" x1="13.604" x2="11.129" y1="13.713" y2="13.713" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="u" x1="13.604" x2="11.129" y1="15.889" y2="15.889" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="v" x1="10.582" x2="9.261" y1="8.718" y2="8.718" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="w" x1="10.345" x2="8.826" y1="8.756" y2="8.756" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#E89043"/></linearGradient><linearGradient id="B" x1="10.74" x2="8.826" y1="13.654" y2="13.654" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="C" x1="10.334" x2="9.302" y1="13.587" y2="13.587" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="D" x1="10.672" x2="8.433" y1="15.901" y2="15.49" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="E" x1="10.44" x2="9.494" y1="15.828" y2="15.828" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="F" x1="11.949" x2="12.55" y1="8.458" y2="11.371" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="G" x1="12.406" x2="11.749" y1="14.213" y2="11.844" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="H" x1="14.649" x2="9.985" y1="11.418" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FFD748"/></linearGradient><linearGradient id="I" x1="9.797" x2="13.369" y1="11.288" y2="11.418" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFCB4B"/><stop offset=".738" stop-color="#FFD748"/><stop offset="1" stop-color="#FFCB4B"/></linearGradient><linearGradient id="J" x1="11.191" x2="8.523" y1="11.37" y2="11.37" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FBA23B" stop-opacity="0"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="L" x1="9.951" x2="9.108" y1="11.366" y2="11.366" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#FFBC47"/><stop offset="1" stop-color="#FBA23B"/></linearGradient><linearGradient id="M" x1="12.17" x2="12.677" y1="11.109" y2="14.331" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="N" x1="11.819" x2="13.117" y1="13.602" y2="16.419" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="O" x1="11.56" x2="11.75" y1="16.073" y2="17.854" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="P" x1="11.605" x2="11.605" y1="15.803" y2="14.515" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="Q" x1="2.754" x2="1.091" y1="11.076" y2="6.007" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="R" x1="3.044" x2="2.949" y1="14.153" y2="17.786" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><linearGradient id="T" x1="8.129" x2="9.348" y1="8.13" y2="-2.896" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBC47" stop-opacity="0"/><stop offset="1" stop-color="#C86F34"/></linearGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="matrix(1.78622 .4985 -.23148 .82945 5.318 14.267)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(1.58576 .05613 -.03684 1.04078 12.278 8.763)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="matrix(1.70407 -.00162 .00087 .91862 12.201 13.877)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="A" cx="0" cy="0" r="1" gradientTransform="matrix(1.5602 -.00147 .00092 .9765 11.612 15.942)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="K" cx="0" cy="0" r="1" gradientTransform="matrix(1.74287 -.08329 .05467 1.14396 12.74 11.375)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><radialGradient id="S" cx="0" cy="0" r="1" gradientTransform="matrix(.31719 1.64272 -.96366 .18607 8.786 2.55)" gradientUnits="userSpaceOnUse"><stop stop-color="#FBE07A"/><stop offset="1" stop-color="#FFD748" stop-opacity="0"/></radialGradient><clipPath id="f"><path fill="#fff" d="M0 17h16V1H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-like_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12.111 5.7c1.128-1.057 2.43-1.63 3.88-1.694L16.267 4C19.423 4 22 6.56 22 9.717c0 2.959-1.035 4.427-5.573 8.061l-.933.74-2.364 1.843a1.84 1.84 0 0 1-2.26 0l-2.688-2.098C3.127 14.269 2 12.805 2 9.717 2 6.56 4.577 4 7.734 4c1.54 0 2.929.576 4.138 1.695l.122.118z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none" id="svg-name-like_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M4.04 2C2.652 2 1.5 3.155 1.5 4.617c0 .858.15 1.388.617 2.027.542.742 1.517 1.63 3.33 3.074L7 10.954l1.552-1.236c1.814-1.444 2.789-2.332 3.332-3.074.467-.639.616-1.169.616-2.027C12.5 3.155 11.347 2 9.96 2c-.734 0-1.302.335-1.71.707-.226.206-.44.448-.596.715a.75.75 0 0 1-1.309-.001 3.1 3.1 0 0 0-.595-.714C5.343 2.335 4.775 2 4.04 2M7 1.832a5 5 0 0 0-.239-.234C6.18 1.068 5.267.5 4.04.5 1.792.5 0 2.36 0 4.617 0 5.739.22 6.593.906 7.53c.678.926 1.809 1.93 3.607 3.362l1.654 1.316a1.334 1.334 0 0 0 1.666 0l1.654-1.316c1.798-1.432 2.929-2.436 3.607-3.362.685-.937.906-1.79.906-2.913C14 2.36 12.208.5 9.96.5c-1.226 0-2.138.568-2.72 1.098a5 5 0 0 0-.24.234" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-like_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.629 2.5A5.37 5.37 0 0 1 19 7.871c0 2.837-1.081 4.275-5.702 7.869l-1.993 1.55a2.125 2.125 0 0 1-2.61 0l-1.993-1.55C2.082 12.146 1 10.708 1 7.87A5.37 5.37 0 0 1 6.371 2.5c1.256 0 2.403.46 3.414 1.346l.215.197.215-.197c1.01-.886 2.158-1.346 3.414-1.346m0 1.5c-1.124 0-2.137.53-3.055 1.622a.75.75 0 0 1-1.148 0C8.508 4.53 7.496 4 6.37 4A3.87 3.87 0 0 0 2.5 7.871c0 2.238.838 3.352 5.123 6.685l1.993 1.55a.625.625 0 0 0 .768 0l1.993-1.55c4.09-3.182 5.04-4.341 5.118-6.386l.005-.299A3.87 3.87 0 0 0 13.629 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-like_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M15.992 4.006c-1.452.064-2.753.637-3.881 1.694l-.117.113-.122-.118C10.662 4.576 9.275 4 7.734 4 4.577 4 2 6.56 2 9.717c0 3.088 1.127 4.552 6.182 8.546l2.688 2.098a1.84 1.84 0 0 0 2.26 0l2.364-1.843.933-.74C20.965 14.144 22 12.676 22 9.718 22 6.56 19.423 4 16.266 4zm.274 1.794c2.165 0 3.934 1.757 3.934 3.917l-.005.294c-.076 2.156-1.062 3.341-5.509 6.852l-2.663 2.078a.04.04 0 0 1-.046 0l-2.364-1.843-.874-.691c-4.142-3.31-4.939-4.44-4.939-6.69C3.8 7.557 5.569 5.8 7.734 5.8c1.333 0 2.507.618 3.57 1.915a.9.9 0 0 0 1.398-.007C13.739 6.416 14.909 5.8 16.266 5.8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="11" id="svg-name-link" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M5.227 0a5.228 5.228 0 0 0 0 10.455H9.41V8.364H5.227a3.136 3.136 0 1 1 0-6.273H9.41V0zm8.364 0v2.09h4.182a3.136 3.136 0 1 1 0 6.274H13.59v2.09h4.182a5.228 5.228 0 0 0 0-10.454zM6.273 4.182v2.09h10.454v-2.09z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-link-tool" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 10.25h10.5"/><path fill="currentColor" d="M7 6.75a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0-1.5zm-2 0h2v-1.5H5zm2-9.5H5v1.5h2zm-2 0A4.75 4.75 0 0 0 .25 10h1.5A3.25 3.25 0 0 1 5 6.75zm0 8A3.25 3.25 0 0 1 1.75 10H.25A4.75 4.75 0 0 0 5 14.75zM13 6.75a.75.75 0 0 1 0-1.5zm0 8a.75.75 0 0 1 0-1.5zm2 0h-2v-1.5h2zm-2-9.5h2v1.5h-2zm2 0A4.75 4.75 0 0 1 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75zm0 8A3.25 3.25 0 0 0 18.25 10h1.5A4.75 4.75 0 0 1 15 14.75z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-link-tool-active" class="svg-sprite__symbol"><path stroke="#F15F2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 10.25h10.5"/><path fill="#F15F2C" d="M7 6.75a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0-1.5zm-2 0h2v-1.5H5zm2-9.5H5v1.5h2zm-2 0A4.75 4.75 0 0 0 .25 10h1.5A3.25 3.25 0 0 1 5 6.75zm0 8A3.25 3.25 0 0 1 1.75 10H.25A4.75 4.75 0 0 0 5 14.75zM13 6.75a.75.75 0 0 1 0-1.5zm0 8a.75.75 0 0 1 0-1.5zm2 0h-2v-1.5h2zm-2-9.5h2v1.5h-2zm2 0A4.75 4.75 0 0 1 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75zm0 8A3.25 3.25 0 0 0 18.25 10h1.5A4.75 4.75 0 0 1 15 14.75z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="11" fill="none" id="svg-name-list_add_20" class="svg-sprite__symbol"><path fill="currentColor" d="M.5 1.25A.75.75 0 0 1 1.25.5h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M.5 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M1.25 6.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM8 7.25a.75.75 0 0 1 .75-.75H11V4.25a.75.75 0 0 1 1.5 0V6.5h2.25a.75.75 0 0 1 0 1.5H12.5v2.25a.75.75 0 0 1-1.5 0V8H8.75A.75.75 0 0 1 8 7.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_bullet_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.36 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.002 2.878.075 3.778.072.877.202 1.325.361 1.638a4 4 0 0 0 1.748 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5M3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.56 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622" clip-rule="evenodd"/><path fill="currentColor" d="M8 10a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 10M12 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M8 18a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 18M12 18a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M8 14a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 14M12 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_check_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M26.701 15.287a1 1 0 0 1 .095 1.319l-6.945 7.095a1 1 0 0 1-1.33.086l-4.232-4.272a1 1 0 0 1 1.329-1.49l3.517 3.55 6.152-6.276a1 1 0 0 1 1.414-.012M10 18a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm12-6a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-list_like_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21.46 11.998c2.5 0 4.54 1.99 4.54 4.459 0 2.322-.913 3.5-4.426 6.19l-1.464 1.111c-.899.683-2.123.72-3.058.114l-.162-.114-1.51-1.146-.57-.443C11.804 19.808 11 18.637 11 16.457c0-2.47 2.04-4.459 4.54-4.459.929 0 1.784.292 2.55.849l.207.158.202.173.217-.183c.667-.534 1.406-.862 2.204-.963l.268-.025zm.063 1.998-.224.007-.186.02a2.3 2.3 0 0 0-.937.375l-.173.127-1.19 1a.5.5 0 0 1-.646-.002l-1.126-.961c-.477-.385-.964-.565-1.501-.565-1.41 0-2.54 1.108-2.54 2.46 0 1.407.447 2.11 3.072 4.162l.518.4 1.509 1.147a.66.66 0 0 0 .71.059l.092-.06 1.692-1.286C23.524 18.62 24 17.907 24 16.457c0-1.298-1.042-2.37-2.317-2.455zM8 17.996a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0-5.998a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zM22 6a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="12" fill="none" id="svg-name-list_play_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M17.684 7.431a.67.67 0 0 1 0 1.138l-4.737 2.842c-.42.253-.947-.063-.947-.568V5.157c0-.505.526-.82.947-.568zM0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75M0 5.75A.75.75 0 0 1 .75 5h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 5.75M0 10.75A.75.75 0 0 1 .75 10h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-live_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/><path fill="currentColor" fill-rule="evenodd" d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m7-8.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10" id="svg-name-lock" class="svg-sprite__symbol"><path fill="currentColor" d="M7.598 4.162h-.247l-.001-1.23A2.435 2.435 0 0 0 4.917.5a2.435 2.435 0 0 0-2.431 2.433l.002 1.231H2.4A.835.835 0 0 0 1.566 5v3.665c0 .461.375.835.836.835L7.6 9.497a.834.834 0 0 0 .834-.835V4.996a.835.835 0 0 0-.836-.834m-4.214.002-.002-1.23c0-.848.688-1.537 1.535-1.538.847 0 1.536.69 1.536 1.535l.002 1.231z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-locked" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M4 16v-6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/><path stroke="currentColor" d="M10.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path stroke="currentColor" stroke-width="1.5" d="M13 8V5.5a3 3 0 0 0-6 0V8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-logo-boosty" class="svg-sprite__symbol"><path fill="url(#a)" d="M5.044 23.892 11.852 0h10.447l-2.113 7.408a1 1 0 0 0-.054.132L14.584 27.1h5.177Q16.52 35.328 14.686 40c-9.553-.108-12.23-7.052-9.886-15.268zM14.72 40l12.594-18.4h-5.344L26.62 9.814c7.977.846 11.719 7.215 9.52 14.917C33.778 33.015 24.22 40 14.916 40z"/><path fill="url(#b)" d="M5.044 23.892 11.852 0h10.447l-2.113 7.408a1 1 0 0 0-.054.132L14.584 27.1h5.177Q16.52 35.328 14.686 40c-9.553-.108-12.23-7.052-9.886-15.268zM14.72 40l12.594-18.4h-5.344L26.62 9.814c7.977.846 11.719 7.215 9.52 14.917C33.778 33.015 24.22 40 14.916 40z"/><defs><linearGradient id="a" x1="36.762" x2="4.001" y1="20" y2="20" gradientUnits="userSpaceOnUse"><stop stop-color="#F59C07"/><stop offset="1" stop-color="#F57507"/></linearGradient><linearGradient id="b" x1="7.006" x2="-12.017" y1="-3.014" y2="41.133" gradientUnits="userSpaceOnUse"><stop stop-color="#EF7829"/><stop offset=".28" stop-color="#F0692A"/><stop offset=".63" stop-color="#F15E2C"/><stop offset="1" stop-color="#F15A2C"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" id="svg-name-logo-play" class="svg-sprite__symbol"><path fill="#F18D8D" d="M0 0h50v50H0z"/><path fill="#0177FE" d="M0 0h50v50H0z"/><g clip-path="url(#a)"><rect width="48.828" height="48.828" x=".586" y=".586" fill="#07F" rx="24.414"/><g filter="url(#b)"><path fill="#020BB2" d="M31.229 13.827c7.046 4.501 10.569 6.752 11.201 9.86.2.985.2 2 0 2.983-.632 3.109-4.155 5.36-11.201 9.861-8.057 5.148-12.086 7.722-15.359 6.755a7.5 7.5 0 0 1-2.79-1.528c-2.576-2.238-2.576-7.018-2.576-16.58 0-9.56 0-14.34 2.577-16.579a7.5 7.5 0 0 1 2.789-1.528c3.273-.966 7.302 1.608 15.359 6.756"/></g><path fill="#fff" fill-rule="evenodd" d="M31.896 23.517a1.662 1.662 0 1 0 0 3.324 1.662 1.662 0 0 0 0-3.324m-5.35 1.662a5.35 5.35 0 0 1 5.35-5.347 5.35 5.35 0 0 1 5.349 5.347 5.35 5.35 0 0 1-5.35 5.346 5.35 5.35 0 0 1-5.348-5.346M16.46 25.179l-2.75 2.747 2.601 2.599 2.749-2.747 2.749 2.747 2.6-2.6-2.749-2.746 2.749-2.748-2.6-2.599-2.75 2.747-2.748-2.747-2.6 2.6z" clip-rule="evenodd"/></g><defs><clipPath id="a"><rect width="48.828" height="48.828" x=".586" y=".586" fill="#fff" rx="24.414"/></clipPath><filter id="b" width="3186.07" height="3190.61" x="-1566.49" y="-1269.75" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="300.38"/><feGaussianBlur stdDeviation="788.499"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_31642_184982"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_31642_184982" result="shape"/></filter></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="110" height="24" fill="none" viewBox="0 0 155 24" id="svg-name-logo-vk-video-live" class="svg-sprite__symbol"><g clip-path="url(#a)"><g clip-path="url(#b)"><path fill="#07F" d="M0 8.774C0 1.55 1.549 0 8.774 0h6.452C22.45 0 24 1.549 24 8.774v6.452C24 22.45 22.451 24 15.226 24H8.774C1.55 24 0 22.451 0 15.226z"/><path fill="#FF2B42" d="M12.896 24h2.288c7.09 0 8.74-1.477 8.813-8.276q.003-.244.003-.498V8.774q0-.273-.003-.537C23.917 1.471 22.261 0 15.184 0h-2.288C5.636 0 4.08 1.549 4.08 8.774v6.452C4.08 22.45 5.636 24 12.896 24"/><path fill="#fff" d="M16.935 9.924c1.213.7 1.82 1.05 2.024 1.508.177.399.177.854 0 1.253-.204.457-.81.807-2.024 1.508l-3.325 1.92c-1.213.7-1.82 1.05-2.317.998a1.54 1.54 0 0 1-1.086-.627c-.294-.405-.294-1.105-.294-2.506v-3.84c0-1.4 0-2.1.294-2.506a1.54 1.54 0 0 1 1.085-.626c.498-.053 1.105.298 2.318.998z"/></g><path fill="currentColor" d="M36.259 18.058h2.993L43.647 6h-2.172l-3.523 9.937h-.342L34.206 6H32zM54.887 18.058l-5.541-6.243L54.46 6h-2.532l-4.275 4.909h-.496V6h-2.053v12.058h2.053v-5.165h.513l4.515 5.165zM66.662 11.867c1.06-.411 1.727-1.352 1.727-2.583C68.39 7.368 66.8 6 64.473 6h-4.704v12.058h5.046c2.343 0 3.933-1.368 3.933-3.37 0-1.402-.786-2.445-2.086-2.822m-4.84-4.071h2.65c1.095 0 1.848.667 1.848 1.659 0 .975-.753 1.642-1.847 1.642h-2.651zm2.993 8.466h-2.993v-3.37h2.993c1.077 0 1.83.685 1.83 1.677 0 1.009-.753 1.693-1.83 1.693M70.622 18.058h2.788l3.318-6.602H77v6.602h1.882V9.164h-2.788l-3.318 6.602h-.274V9.164h-1.881zM80.17 20.709h1.967v-2.651h6.397v2.651H90.5v-4.447h-1.54V9.164h-6.516L82 13.714c-.154 1.607-.632 2.548-1.607 2.548h-.223zm2.993-4.447c.48-.462.684-1.248.821-2.583l.274-2.719h2.737v5.302zM100.423 13.508c0-2.565-1.915-4.515-4.618-4.515-2.702 0-4.618 1.933-4.618 4.618s1.916 4.618 4.618 4.618c1.847 0 3.592-.872 4.259-2.566l-1.847-.307c-.428.632-1.249 1.077-2.292 1.077-1.505 0-2.497-.924-2.685-2.292h7.149c.017-.188.034-.393.034-.633m-4.618-2.805c1.232 0 2.155.787 2.48 1.899H93.36c.325-1.146 1.249-1.899 2.446-1.899M106.197 18.229c2.788 0 4.755-1.916 4.755-4.618s-1.967-4.618-4.755-4.618-4.754 1.916-4.754 4.618 1.967 4.618 4.754 4.618m0-1.796c-1.607 0-2.702-1.146-2.702-2.822s1.095-2.822 2.702-2.822c1.608 0 2.703 1.146 2.703 2.822s-1.095 2.822-2.703 2.822"/></g><path fill="#FF2B42" d="M119 12c0-5.398 0-8.097 1.557-9.869q.27-.307.577-.576C122.908 0 125.611 0 131.017 0h11.966c5.406 0 8.109 0 9.883 1.555q.307.27.577.576C155 3.903 155 6.601 155 12c0 5.398 0 8.097-1.557 9.869q-.27.307-.577.576C151.092 24 148.389 24 142.983 24h-11.966c-5.406 0-8.109 0-9.883-1.555a6 6 0 0 1-.577-.576C119 20.097 119 17.399 119 12"/><path fill="#fff" d="M130.731 18.177h-5.845V5.894h1.832v10.54h4.013zM133.638 18.177h-1.832V5.894h1.832zM140.072 18.177h-2.809l-2.635-12.283h1.885l2.041 10.053h.262l2.146-10.053h1.866zM149.75 18.177h-6.036V5.894h5.914v1.743h-4.083v3.484h3.612v1.707h-3.612v3.607h4.205z"/><defs><clipPath id="a"><path fill="#fff" d="M0 0h111v24H0z"/></clipPath><clipPath id="b"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-logo_android_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.4 3.2a1 1 0 0 1 1.4.2l2.306 3.075A9 9 0 0 1 10 6a9 9 0 0 1 2.893.475L15.2 3.4a1 1 0 0 1 1.6 1.2l-2.06 2.748A9 9 0 0 1 19 15H1a9 9 0 0 1 4.26-7.652L3.2 4.6a1 1 0 0 1 .2-1.4m9.669 7.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" id="svg-name-logo_vk" class="svg-sprite__symbol"><path fill="#07F" d="M.398 19.2c0-9.051 0-13.576 2.812-16.388S10.547 0 19.598 0h1.6c9.051 0 13.577 0 16.389 2.812s2.811 7.337 2.811 16.388v1.6c0 9.051 0 13.576-2.811 16.388S30.249 40 21.198 40h-1.6c-9.05 0-13.576 0-16.388-2.812S.398 29.851.398 20.8z"/><path fill="#fff" d="M21.682 28.817c-9.117 0-14.317-6.25-14.534-16.65h4.567c.15 7.633 3.517 10.866 6.183 11.533V12.167h4.3v6.583c2.634-.283 5.4-3.283 6.334-6.583h4.3c-.717 4.066-3.717 7.066-5.85 8.3 2.133 1 5.55 3.616 6.85 8.35h-4.734c-1.016-3.167-3.55-5.617-6.9-5.95v5.95z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="82" height="40" fill="none" id="svg-name-logo_vkid" class="svg-sprite__symbol"><path fill="#fff" d="M50.398 32.4h4.107v-24h-4.107zM59.818 32.4h9.256c7.323 0 12.524-4.97 12.524-12.017 0-7.013-5.201-11.983-12.524-11.983h-9.256zm4.107-3.745v-16.51h5.149c4.893 0 8.247 3.37 8.247 8.238 0 4.902-3.354 8.272-8.247 8.272z"/><path fill="#07F" d="M.398 19.2c0-9.051 0-13.576 2.812-16.388S10.547 0 19.598 0h1.6c9.051 0 13.577 0 16.389 2.812s2.811 7.337 2.811 16.388v1.6c0 9.051 0 13.576-2.811 16.388S30.249 40 21.198 40h-1.6c-9.05 0-13.576 0-16.388-2.812S.398 29.851.398 20.8z"/><path fill="#fff" d="M21.682 28.817c-9.117 0-14.317-6.25-14.534-16.65h4.567c.15 7.633 3.517 10.866 6.183 11.533V12.167h4.3v6.583c2.634-.283 5.4-3.283 6.334-6.583h4.3c-.717 4.066-3.717 7.066-5.85 8.3 2.133 1 5.55 3.616 6.85 8.35h-4.734c-1.016-3.167-3.55-5.617-6.9-5.95v5.95z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-mail_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M19.383 8c-5.019 0-7.117.465-9.244 1.603a10.93 10.93 0 0 0-4.536 4.536C4.465 16.266 4 18.364 4 23.383v9.234c0 5.019.465 7.117 1.603 9.244a10.92 10.92 0 0 0 4.536 4.536C12.266 47.535 14.364 48 19.383 48h17.234c5.019 0 7.117-.465 9.244-1.603a10.92 10.92 0 0 0 4.536-4.536C51.535 39.734 52 37.636 52 32.617v-9.234c0-5.019-.465-7.117-1.603-9.244a10.93 10.93 0 0 0-4.536-4.536C43.734 8.465 41.636 8 36.617 8zm-7.83 4.248c1.486-.794 3-1.248 7.83-1.248h17.234c4.83 0 6.344.454 7.83 1.248q.384.207.738.445l-9.76 9.761c-2.03 2.03-3.448 3.444-4.66 4.368-1.178.898-1.982 1.193-2.765 1.193s-1.587-.295-2.765-1.193c-1.212-.924-2.63-2.338-4.66-4.368l-9.76-9.76q.354-.24.739-.446m-2.86 2.567q-.24.354-.445.739c-.794 1.485-1.248 3-1.248 7.83v9.233c0 4.83.454 6.344 1.248 7.83a7.93 7.93 0 0 0 3.306 3.305c1.485.794 3 1.248 7.83 1.248h17.233c4.83 0 6.344-.454 7.83-1.248a7.93 7.93 0 0 0 3.305-3.306c.794-1.485 1.248-3 1.248-7.83v-9.233c0-4.83-.454-6.344-1.248-7.83a8 8 0 0 0-.445-.738l-9.761 9.76-.078.078c-1.934 1.934-3.493 3.493-4.884 4.554-1.444 1.102-2.882 1.808-4.584 1.808-1.703 0-3.14-.706-4.584-1.808-1.391-1.061-2.95-2.62-4.884-4.554l-.078-.078z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-masks_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.285 15.84c-.485.25-1.177.608-2.285.608s-1.8-.357-2.285-.608c-.447-.23-.719-.37-.979-.062-.544.644.544 3.22 3.264 3.22s3.808-2.576 3.264-3.22c-.26-.309-.533-.168-.979.062M10.811 10.009c.937.08 1.647.7 1.585 1.386-.061.686-.87 1.176-1.807 1.097-.937-.08-1.647-.701-1.585-1.387.061-.686.87-1.176 1.807-1.097M18.996 11.105c-.061-.686-.87-1.176-1.807-1.097-.937.08-1.647.701-1.585 1.387.061.686.87 1.176 1.807 1.097.937-.08 1.647-.701 1.585-1.387"/><path fill="currentColor" fill-rule="evenodd" d="M23.443 4.262c2.36 2.44 1.77 9.15 0 13.419S18.13 25 14 25s-7.672-3.05-9.443-7.32c-1.77-4.269-2.36-10.978 0-13.418C6.11 2.657 7.663 2.908 9.89 3.267c1.157.187 2.496.404 4.111.404s2.954-.217 4.111-.404c2.226-.359 3.779-.61 5.332.995m-1.437 1.391c.253.262.536.762.737 1.6.197.822.283 1.838.25 2.974-.067 2.282-.609 4.786-1.397 6.688C20.024 20.705 17.068 23 14 23s-6.024-2.295-7.595-6.085c-.79-1.902-1.331-4.406-1.398-6.688-.033-1.136.053-2.152.25-2.973.201-.839.484-1.34.737-1.601.37-.381.653-.517.893-.582.28-.076.66-.098 1.295-.03.301.031.694.094 1.157.168 1.204.193 2.882.462 4.661.462 1.78 0 3.457-.269 4.661-.462.463-.074.856-.137 1.157-.169.635-.067 1.014-.045 1.295.031.24.065.524.2.893.582" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-medal-rt" class="svg-sprite__symbol"><path fill="currentColor" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M10.003 7.931c.807 0 1.568.182 2.246.506L13.674 3H6.33l1.425 5.437a5.2 5.2 0 0 1 2.248-.506"/><path fill="url(#c)" d="M10.001 10.36c-1.338 0-2.427 1.036-2.427 2.31 0 1.273 1.09 2.31 2.427 2.31 1.338 0 2.428-1.037 2.428-2.31 0-1.276-1.09-2.31-2.428-2.31"/><path fill="url(#d)" d="M12.43 9.118c-.045-.026-.183-.112-.266-.151a4.64 4.64 0 0 0-2.163-.53 4.66 4.66 0 0 0-2.165.53c-.037.026-.127.066-.262.15C6.328 9.882 5.5 11.21 5.5 12.722c.002 2.36 2.02 4.282 4.503 4.282 2.48 0 4.5-1.921 4.5-4.282-.003-1.512-.828-2.84-2.072-3.603m-2.429 6.366c-1.632 0-2.958-1.262-2.958-2.815 0-1.554 1.326-2.816 2.958-2.816s2.959 1.262 2.959 2.816-1.327 2.815-2.959 2.815"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FFC062"/><stop offset="1" stop-color="#F7A148"/></linearGradient><linearGradient id="b" x1="6.33" x2="11.324" y1="3" y2="10.819" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient><linearGradient id="c" x1="7.574" x2="12.163" y1="10.359" y2="15.948" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient><linearGradient id="d" x1="5.5" x2="14.006" y1="8.438" y2="18.799" gradientUnits="userSpaceOnUse"><stop offset=".309" stop-color="#FFC062"/><stop offset=".5" stop-color="#FFDFAE"/><stop offset=".684" stop-color="#E5A037"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-mention" class="svg-sprite__symbol"><path fill="currentColor" d="M15 19.75a.75.75 0 0 0 0-1.5zm-5-1.5A8.25 8.25 0 0 1 1.75 10H.25A9.75 9.75 0 0 0 10 19.75zM1.75 10A8.25 8.25 0 0 1 10 1.75V.25A9.75 9.75 0 0 0 .25 10zM10 1.75A8.25 8.25 0 0 1 18.25 10h1.5A9.75 9.75 0 0 0 10 .25zM15 19v-.75h-5v1.5h5zm3.25-9v1.5h1.5V10zm-3.5 1.5V10h-1.5v1.5zm1.75 1.75a1.75 1.75 0 0 1-1.75-1.75h-1.5a3.25 3.25 0 0 0 3.25 3.25zm1.75-1.75a1.75 1.75 0 0 1-1.75 1.75v1.5a3.25 3.25 0 0 0 3.25-3.25z"/><circle cx="10" cy="10" r="4" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-mention_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.084 9.975c0 5.086 3.462 8.108 8.264 8.108 1.223 0 2.309-.156 3.032-.4.587-.196.793-.46.793-.803 0-.342-.225-.557-.626-.557-.098 0-.225.01-.382.039-.88.215-1.555.352-2.513.352-4.206 0-7.042-2.445-7.042-6.68 0-4.098 2.63-6.925 6.63-6.925 3.492 0 6.319 2.142 6.319 6.084 0 2.054-.743 3.492-1.829 3.492-.704 0-1.085-.382-1.085-1.047V6.787c0-.548-.313-.88-.842-.88-.518 0-.84.332-.84.88v.489h-.099c-.4-.87-1.31-1.37-2.386-1.37-1.946 0-3.325 1.644-3.325 4.06 0 2.455 1.379 4.137 3.393 4.137 1.135 0 2.015-.568 2.446-1.565h.097c.176.988 1.096 1.565 2.309 1.565 2.278 0 3.687-2.103 3.687-5.027 0-4.46-3.277-7.326-7.825-7.326-4.831 0-8.176 3.237-8.176 8.225m7.805 2.602c-1.213 0-1.927-.978-1.927-2.602 0-1.613.724-2.572 1.927-2.572 1.232 0 2.015.998 2.015 2.563 0 1.604-.793 2.61-2.015 2.61" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="none" id="svg-name-menu_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M19 7H1a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2m0-7H1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2M1 16h18a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message-clear" class="svg-sprite__symbol"><g stroke="#F1F1F1" stroke-linecap="round" stroke-width="1.5" clip-path="url(#a)"><path stroke-linejoin="round" d="m13.414 6.59 4.628-4.628M13.413 1.96l4.628 4.63"/><path d="M16 10.964c0 3.847-3.134 6.965-7 6.965a7 7 0 0 1-1.615-.187c-.757-.245-2.845.476-4.018.926-.262.1-.527-.202-.401-.452.435-.864 1-2.21.65-2.802A6.9 6.9 0 0 1 2 10.965C2 7.118 5.134 4 9 4"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message_cross_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.25 2.5C5.813 2.5 2 5.706 2 9.993c0 1.445.446 2.822 1.261 4-.082.457-.338 1.189-.896 2.292l-.24.475a1.2 1.2 0 0 0 1.164 1.736l.532-.041c1.472-.115 2.804-.51 3.768-1.361.85.26 1.745.392 2.66.392 4.435 0 8.25-3.206 8.25-7.493S14.684 2.5 10.25 2.5M3.5 9.993C3.5 6.693 6.473 4 10.25 4c3.774 0 6.75 2.693 6.75 5.994s-2.976 5.995-6.75 5.995c-.91 0-1.788-.156-2.602-.455a.75.75 0 0 0-.82.207c-.61.687-1.64 1.105-3.124 1.22.682-1.347 1.045-2.376 1.085-3.13a.75.75 0 0 0-.15-.49 5.52 5.52 0 0 1-1.14-3.347m9.524-2.778a.75.75 0 0 1 0 1.06l-1.717 1.72 1.718 1.721a.75.75 0 0 1-1.061 1.06l-1.717-1.719-1.717 1.72a.75.75 0 1 1-1.062-1.06l1.719-1.721-1.719-1.72a.75.75 0 0 1 1.062-1.06l1.717 1.719 1.717-1.72a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-message_cross_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.459 10.043a1 1 0 0 1 0 1.414L15.416 13.5l2.043 2.043a1 1 0 0 1-1.414 1.414l-2.043-2.043-2.043 2.043a1 1 0 0 1-1.414-1.414l2.043-2.043-2.043-2.043a1 1 0 0 1 1.414-1.414l2.043 2.043 2.043-2.043a1 1 0 0 1 1.414 0"/><path fill="currentColor" fill-rule="evenodd" d="M14.02 3.5C7.828 3.5 2.54 7.839 2.54 13.499c0 1.873.59 3.62 1.607 5.101-.044.617-.219 1.272-.475 1.966-.227.616-.498 1.21-.774 1.815l-.27.597c-.438.974.317 2.062 1.363 2.02 2.568-.1 4.667-.748 6.112-2.097 1.225.387 2.545.597 3.918.597 6.193 0 11.482-4.34 11.482-10 0-5.659-5.29-9.998-11.482-9.998M4.54 13.499c0-4.28 4.096-7.999 9.481-7.999s9.482 3.719 9.482 7.999-4.097 7.999-9.482 7.999c-1.372 0-2.673-.246-3.845-.687a1 1 0 0 0-1.114.289c-.813.957-2.162 1.615-4.218 1.834.24-.53.492-1.102.704-1.675.337-.911.61-1.921.61-2.963a1 1 0 0 0-.197-.596c-.907-1.222-1.421-2.664-1.421-4.201" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-message_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M6.828 15.752a.75.75 0 0 1 .821-.208A7.5 7.5 0 0 0 10.25 16c3.772 0 6.75-2.694 6.75-6s-2.978-6-6.75-6S3.5 6.694 3.5 10c0 1.21.4 2.367 1.14 3.349a.75.75 0 0 1 .15.49c-.04.756-.403 1.785-1.085 3.135 1.483-.116 2.514-.534 3.123-1.223M3.242 18.5a1.203 1.203 0 0 1-1.101-1.767c.644-1.216 1.016-2.14 1.121-2.73A7 7 0 0 1 2 10c0-4.17 3.681-7.5 8.25-7.5S18.5 5.83 18.5 10s-3.681 7.5-8.25 7.5a9 9 0 0 1-2.66-.393c-.996.881-2.456 1.336-4.348 1.393"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-messages_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 2C4.44 2 1.5 4.518 1.5 7.754c0 1.084.336 2.12.954 3.014-.094.407-.361 1.038-.82 1.877-.3.547-.073 1.21.46 1.483.167.086.352.127.538.121 1.426-.041 2.563-.365 3.366-1.015.64.18 1.313.274 2.002.274 3.56 0 6.5-2.518 6.5-5.754S11.56 2 8 2m0 1.5c-2.917 0-5 2.02-5 4.254 0 .788.25 1.55.726 2.216l.134.188a.75.75 0 0 1 .128.572l-.042.226c-.09.49-.324 1.087-.648 1.742.873-.107 1.438-.357 1.795-.662l.24-.206a.75.75 0 0 1 .701-.15l.308.092c.523.155 1.08.236 1.658.236 2.917 0 5-2.02 5-4.254S10.917 3.5 8 3.5" clip-rule="evenodd"/><path fill="currentColor" d="M16.157 8.575a.75.75 0 0 1 1.187-.916 5.45 5.45 0 0 1 1.156 3.345 5.4 5.4 0 0 1-.914 3.008c.088.411.346 1.049.789 1.895a1.09 1.09 0 0 1-.992 1.593c-1.363-.042-2.456-.363-3.231-1.01a6.8 6.8 0 0 1-1.902.268 6.7 6.7 0 0 1-2.57-.5.75.75 0 0 1 .572-1.388c.6.248 1.275.388 1.998.388.546 0 1.073-.08 1.568-.233l.294-.092a.75.75 0 0 1 .722.158l.23.206c.33.294.85.538 1.652.646-.311-.657-.535-1.253-.622-1.743l-.04-.225a.75.75 0 0 1 .12-.554l.129-.188A3.93 3.93 0 0 0 17 11.003c0-.894-.306-1.733-.843-2.429"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" id="svg-name-messages_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M21.197 8.281c1.254 1.245 1.966 2.86 1.966 4.576 0 1.088-.286 2.14-.823 3.085.086.517.336 1.302.75 2.328l.222.535.049.143.021.085a1.2 1.2 0 0 1-1.24 1.435c-1.635-.086-2.94-.485-3.89-1.22a8.6 8.6 0 0 1-2.804.466c-.99 0-1.955-.166-2.856-.485a.857.857 0 0 1 .572-1.616c.718.254 1.49.387 2.284.387.931 0 1.83-.182 2.646-.527a.86.86 0 0 1 .943.186c.47.476 1.175.807 2.127.978l.243.04c-.492-1.248-.762-2.19-.808-2.866a.86.86 0 0 1 .13-.518c.471-.742.72-1.573.72-2.436 0-1.246-.52-2.427-1.46-3.359a.857.857 0 0 1 1.207-1.217m-10.892-5.71c4.237 0 7.715 3.043 7.715 6.857s-3.478 6.858-7.715 6.858c-.97 0-1.918-.16-2.803-.467-.951.736-2.256 1.135-3.891 1.22a1.2 1.2 0 0 1-1.24-1.435l.022-.084.049-.144.114-.273c.442-1.066.719-1.893.833-2.455l.025-.135-.13-.239a6.2 6.2 0 0 1-.693-2.846c0-3.814 3.477-6.857 7.714-6.857m0 1.715c-3.337 0-6 2.33-6 5.142 0 .863.249 1.694.719 2.437a.86.86 0 0 1 .13.518c-.043.627-.278 1.484-.705 2.603l-.102.262.243-.04c.951-.17 1.656-.502 2.127-.977a.86.86 0 0 1 .943-.187 6.8 6.8 0 0 0 2.645.527c3.338 0 6-2.33 6-5.143s-2.662-5.142-6-5.142"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="34" height="30" id="svg-name-mobile" class="svg-sprite__symbol"><path fill="currentColor" d="M14.351.035a3.25 3.25 0 0 0-3.244 3.245v1.622h3.244V3.28h16.222v21.088h-6.489a1.623 1.623 0 0 1-3.244 0h-1.622v4.867h11.355a3.25 3.25 0 0 0 3.245-3.244V3.28A3.25 3.25 0 0 0 30.573.035zM3.853 7.29a3.244 3.244 0 0 0-3.245 3.244v16.223A3.244 3.244 0 0 0 3.853 30h9.733a3.244 3.244 0 0 0 3.244-3.244V10.533a3.244 3.244 0 0 0-3.244-3.244zm0 3.244h9.733v16.223h-3.244c0 .895-.751 1.622-1.623 1.622a1.64 1.64 0 0 1-1.622-1.622H3.853z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-money-x2" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.276.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678l-.297-.295.297.295C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1L18.6 1.4l-.313.316c.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.409.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.276 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.409-1.102-2.668C.444 14.36.444 12.72.444 10.481z"/><path fill="url(#b)" d="M3.21 14v-1.047l2.778-2.723q.399-.402.664-.714.265-.313.399-.606.133-.292.133-.625a1.2 1.2 0 0 0-.172-.648 1.14 1.14 0 0 0-.473-.422 1.5 1.5 0 0 0-.684-.149q-.394 0-.69.164a1.13 1.13 0 0 0-.462.457q-.16.297-.16.708H3.164q0-.762.348-1.325a2.33 2.33 0 0 1 .957-.87q.613-.31 1.406-.31.804 0 1.414.301.609.3.945.825.34.523.34 1.195 0 .45-.172.883-.171.434-.605.96-.43.528-1.207 1.278l-1.38 1.402v.055h3.485V14H3.211z"/><path fill="url(#c)" d="m11.332 6 1.762 2.93h.062L14.926 6h1.652l-2.465 4 2.504 4h-1.68l-1.78-2.91h-.063L11.313 14H9.64l2.527-4-2.496-4z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE149"/><stop offset="1" stop-color="#E96D1E"/></linearGradient><linearGradient id="b" x1="2.5" x2="8.924" y1="15" y2="4.275" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient><linearGradient id="c" x1="2.5" x2="8.924" y1="15" y2="4.275" gradientUnits="userSpaceOnUse"><stop stop-color="#E1400D"/><stop offset="1" stop-color="#FDE44A"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-money-x3" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><path fill="url(#b)" d="M5.982 14.11q-.843 0-1.5-.29a2.5 2.5 0 0 1-1.03-.804 2.1 2.1 0 0 1-.403-1.192h1.469a.97.97 0 0 0 .214.567q.196.238.52.37a1.9 1.9 0 0 0 .727.134q.43 0 .761-.149.333-.152.52-.422a1.04 1.04 0 0 0 .183-.62 1.08 1.08 0 0 0-.187-.642 1.25 1.25 0 0 0-.555-.433 2.2 2.2 0 0 0-.867-.156h-.707V9.355h.707q.418 0 .73-.144.317-.145.497-.406.18-.266.175-.614a1.07 1.07 0 0 0-.152-.59q-.153-.253-.434-.394a1.4 1.4 0 0 0-.652-.14 1.7 1.7 0 0 0-.68.132 1.24 1.24 0 0 0-.504.38.96.96 0 0 0-.203.577H3.217q.016-.671.387-1.18.375-.51 1-.796.625-.29 1.402-.29.8 0 1.39.301.594.297.918.801t.325 1.113q.004.677-.399 1.133a1.87 1.87 0 0 1-1.047.598v.062q.845.118 1.293.625.453.504.45 1.254 0 .672-.383 1.204a2.54 2.54 0 0 1-1.047.828q-.664.3-1.524.3"/><path fill="url(#c)" d="m11.565 6 1.762 2.93h.063L15.16 6h1.651l-2.464 4 2.504 4h-1.68l-1.781-2.91h-.063L11.546 14H9.874l2.527-4-2.496-4z"/><defs><linearGradient id="a" x1="17.548" x2="3.326" y1="-1.249" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#FFB017"/><stop offset="1" stop-color="#EA371F"/></linearGradient><linearGradient id="b" x1="13.5" x2="6.5" y1="6" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE44A"/><stop offset="1" stop-color="#E65917"/></linearGradient><linearGradient id="c" x1="13.5" x2="6.5" y1="6" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#FDE44A"/><stop offset="1" stop-color="#E65917"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-money_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.1 10.357A3.355 3.355 0 0 0 13.747 7h-3.1a.85.85 0 0 0-.849.85V12h-.692a.857.857 0 0 0 0 1.714h.691V15H9a.75.75 0 0 0 0 1.5h.798l.001.65a.85.85 0 1 0 1.698 0v-.65h1.499a.75.75 0 0 0 0-1.5h-1.499v-1.286h2.25a3.355 3.355 0 0 0 3.354-3.357m-5.604-1.786h2.283a1.713 1.713 0 0 1 0 3.429h-2.283z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.5 2a9.97 9.97 0 0 0-7.071 2.929A9.97 9.97 0 0 0 2.5 12a9.97 9.97 0 0 0 2.929 7.071A9.97 9.97 0 0 0 12.5 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22.5 12a9.97 9.97 0 0 0-2.929-7.071A9.97 9.97 0 0 0 12.5 2M6.702 6.202A8.17 8.17 0 0 1 12.5 3.8c2.265 0 4.313.917 5.798 2.402A8.17 8.17 0 0 1 20.7 12a8.17 8.17 0 0 1-2.402 5.798A8.17 8.17 0 0 1 12.5 20.2a8.17 8.17 0 0 1-5.798-2.402A8.17 8.17 0 0 1 4.3 12c0-2.265.917-4.313 2.402-5.798" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-money_send_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M24 12.846c0-1.068-.073-1.449-.282-1.84a1.73 1.73 0 0 0-.724-.723c-.391-.21-.772-.283-1.84-.283H4v9.154c0 1.068.073 1.449.283 1.84q.252.47.723.724c.391.209.772.282 1.84.282h15.739l-1.292-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L22.585 24H6.845c-1.37 0-2.062-.134-2.782-.519a3.73 3.73 0 0 1-1.544-1.544C2.134 21.217 2 20.524 2 19.154V8h.002v-.055c.017-1 .14-1.558.45-2.138a3.27 3.27 0 0 1 1.355-1.355C4.435 4.116 5.037 4 6.205 4h11.59c1.167 0 1.77.116 2.398.452a3.27 3.27 0 0 1 1.355 1.355c.317.594.439 1.166.451 2.213.845.055 1.383.202 1.938.499.663.355 1.19.881 1.544 1.544.385.72.519 1.413.519 2.783V17a1 1 0 1 1-2 0zM20 15a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm-2.205-9H6.205c-.865 0-1.156.056-1.454.216q-.35.185-.535.535C4.069 7.024 4.01 7.29 4 8H20c-.01-.709-.069-.976-.215-1.25a1.27 1.27 0 0 0-.534-.534C18.95 6.056 18.66 6 17.795 6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-more" class="svg-sprite__symbol"><circle cx="3" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="21" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-more_horizontal_24" class="svg-sprite__symbol"><path fill="currentColor" d="M18 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m-6 4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m-6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-more_horizontal_28" class="svg-sprite__symbol"><path fill="currentColor" d="M6.071 10A1.786 1.786 0 1 1 2.5 10a1.786 1.786 0 0 1 3.571 0M11.786 10a1.786 1.786 0 1 1-3.572 0 1.786 1.786 0 0 1 3.572 0M15.714 11.785a1.786 1.786 0 1 0 0-3.571 1.786 1.786 0 0 0 0 3.571"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="16" fill="none" id="svg-name-more_vertical_16" class="svg-sprite__symbol"><path fill="currentColor" d="M6 4.5c.825 0 1.5-.675 1.5-1.5S6.825 1.5 6 1.5 4.5 2.175 4.5 3 5.175 4.5 6 4.5m0 2c-.825 0-1.5.675-1.5 1.5S5.175 9.5 6 9.5 7.5 8.825 7.5 8 6.825 6.5 6 6.5m0 5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-mute-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M12.98 18.823c-.031 1.207-.67 1.609-1.828.62-1.719-1.469-3.609-3.194-4.242-3.721-.632-.529-1.645-.62-3.073-.62s-1.815-.621-1.815-1.241-.014-1.83-.014-2.001c0-.055.005-.086.014-.13.02-.095-.058-.973 0-1.59.085-.906.388-1.241 1.815-1.241s2.44-.092 3.073-.62c.633-.529 2.523-2.253 4.242-3.722 1.158-.989 1.797-.587 1.829.62.043 1.607 0 3.85 0 6.683 0 2.83.043 5.356 0 6.963m2.901-8.704A.875.875 0 1 1 17.12 8.88c.176.177.41.47.64.872.384.671.616 1.425.616 2.247s-.232 1.576-.615 2.247a4.2 4.2 0 0 1-.641.872.875.875 0 1 1-1.238-1.238c.074-.073.214-.249.36-.503.241-.423.384-.887.384-1.378s-.143-.955-.385-1.378a2.6 2.6 0 0 0-.359-.503m3-2A.875.875 0 1 1 20.12 6.88c.263.264.62.74.966 1.432.517 1.033.843 2.255.89 3.716-.047 1.403-.373 2.625-.89 3.658-.346.692-.703 1.168-.966 1.432a.875.875 0 1 1-1.238-1.238c.138-.137.383-.464.639-.976.407-.814.667-1.79.705-2.876-.038-1.144-.298-2.12-.705-2.934-.256-.512-.501-.839-.639-.976"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-new-boosty" class="svg-sprite__symbol"><rect width="30" height="30" fill="#E65C2C" rx="8"/><g clip-path="url(#a)"><path fill="#fff" d="M8.646 16.557 11.356 7h4.16l-.84 2.963a.3.3 0 0 0-.022.053l-2.21 7.824h2.062q-1.29 3.291-2.02 5.16c-3.805-.043-4.871-2.82-3.938-6.107zM12.499 23l5.015-7.36h-2.128l1.851-4.715c3.177.339 4.667 2.887 3.79 5.967-.94 3.314-4.745 6.108-8.45 6.108z"/></g><defs><clipPath id="a"><path fill="#fff" d="M8.23 7h13.54v16H8.23z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-new_logo_vk_color_20" class="svg-sprite__symbol"><rect width="30" height="30" fill="#07F" rx="6.667"/><path fill="#fff" d="M15.813 20C10.408 20 7.128 16.246 7 10h2.737c.086 4.588 2.168 6.527 3.765 6.927V10h2.623v3.962c1.54-.171 3.152-1.975 3.694-3.962H22.4c-.413 2.444-2.168 4.24-3.408 4.982 1.24.6 3.237 2.174 4.007 5.018h-2.838c-.6-1.9-2.067-3.366-4.036-3.565V20z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-newsfeed_lines_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.59 3c2.183 0 3.233.203 4.324.786a5.54 5.54 0 0 1 2.3 2.3c.583 1.091.786 2.14.786 4.324v7.18c0 2.183-.203 3.233-.786 4.324a5.54 5.54 0 0 1-2.3 2.3c-1.091.583-2.14.786-4.324.786h-7.18c-2.183 0-3.233-.203-4.324-.786a5.54 5.54 0 0 1-2.3-2.3C3.203 20.823 3 19.774 3 17.59v-7.18c0-2.183.203-3.233.786-4.324a5.54 5.54 0 0 1 2.3-2.3C7.177 3.203 8.226 3 10.41 3zM5 11 5 17.59c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.76.408 1.499.55 3.38.55h7.18c1.881 0 2.62-.142 3.38-.55a3.54 3.54 0 0 0 1.48-1.48c.408-.76.55-1.499.55-3.38L22.999 11zM17.59 5h-7.18c-1.881 0-2.62.142-3.38.55-.641.342-1.138.839-1.48 1.48-.286.534-.441 1.056-.509 1.97H22.96c-.068-.914-.223-1.436-.509-1.97a3.54 3.54 0 0 0-1.48-1.48c-.76-.408-1.499-.55-3.38-.55"/><path fill="currentColor" d="M8 15c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H9.09C8.489 16 8 15.552 8 15M8 19c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H9.09C8.489 20 8 19.552 8 19"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-nft_heptagon_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.53 8.78a.75.75 0 0 0-1.06-1.06L9 11.19 7.78 9.97a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0z"/><path fill="currentColor" fill-rule="evenodd" d="M8.479 1.55a1.95 1.95 0 0 0-1.82.522L2.072 6.66a1.95 1.95 0 0 0-.522 1.82l1.595 6.912a1.95 1.95 0 0 0 1.464 1.464l6.912 1.595a1.95 1.95 0 0 0 1.82-.522l4.587-4.587a1.95 1.95 0 0 0 .522-1.82L16.855 4.61a1.95 1.95 0 0 0-1.464-1.464zm-.76 1.583c.11-.11.27-.156.423-.121l6.912 1.595c.168.039.3.17.34.34l1.594 6.911a.45.45 0 0 1-.12.423l-4.587 4.586a.45.45 0 0 1-.423.121l-6.912-1.595a.45.45 0 0 1-.34-.34L3.013 8.143a.45.45 0 0 1 .12-.423z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-nft_heptagon_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M18.707 12.207a1 1 0 1 0-1.414-1.414L12.5 15.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0z"/><path fill="currentColor" fill-rule="evenodd" d="M11.827 2.07a2.71 2.71 0 0 0-2.524.723l-6.51 6.51a2.71 2.71 0 0 0-.724 2.524l2.264 9.81a2.71 2.71 0 0 0 2.03 2.03l9.81 2.264c.91.21 1.864-.064 2.524-.724l6.51-6.51c.66-.66.934-1.614.724-2.523l-2.264-9.811a2.71 2.71 0 0 0-2.03-2.03zm-1.11 2.137a.71.71 0 0 1 .66-.189l9.81 2.264c.264.061.47.267.53.53l2.265 9.811a.71.71 0 0 1-.19.66l-6.51 6.51a.71.71 0 0 1-.659.189l-9.81-2.264a.71.71 0 0 1-.53-.53l-2.265-9.811a.71.71 0 0 1 .19-.66z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="192" height="192" id="svg-name-no-image" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#E0E0E0" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"><path d="M161.054 30.946c35.928 35.928 35.928 94.18 0 130.108s-94.179 35.928-130.108 0c-35.928-35.928-35.928-94.179 0-130.108 35.928-35.928 94.18-35.928 130.108 0M51.44 51.44 30.96 30.96M161.04 161.04l-17.44-17.36"/><g transform="translate(58 60)"><path d="M70.583 77H6.417A6.417 6.417 0 0 1 0 70.583V6.417A6.417 6.417 0 0 1 6.417 0h64.166A6.417 6.417 0 0 1 77 6.417v64.166A6.417 6.417 0 0 1 70.583 77"/><circle cx="26.469" cy="25.667" r="9.625"/><path d="M77 62.563 61.658 39.546a4.812 4.812 0 0 0-7.95-.09L40.906 57.75l-7.93-6.346a4.82 4.82 0 0 0-7.014 1.09L9.625 77"/></g></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="192" height="192" id="svg-name-no-video" class="svg-sprite__symbol"><g fill="none" fill-rule="evenodd" stroke="#E0E0E0" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"><path d="M161.054 30.946c35.928 35.928 35.928 94.18 0 130.108s-94.179 35.928-130.108 0c-35.928-35.928-35.928-94.179 0-130.108 35.928-35.928 94.18-35.928 130.108 0M51.44 51.44 30.96 30.96M161.04 161.04l-17.44-17.36"/><path d="M134.284 62.516a3.8 3.8 0 0 0-3.8-3.8H62.072a3.8 3.8 0 0 0-3.8 3.8v68.412a3.8 3.8 0 0 0 3.8 3.8h68.412a3.8 3.8 0 0 0 3.8-3.8z"/><path d="M87.916 111.058a2.052 2.052 0 0 1-3.04-1.794V83.557a2.052 2.052 0 0 1 3.067-1.779l22.507 12.861a2.049 2.049 0 0 1 0 3.558z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-note" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.188" d="m16.245 7.829-.735 3.135c-.63 2.707-1.875 3.802-4.215 3.577a8 8 0 0 1-1.215-.202l-1.26-.3c-3.127-.743-4.095-2.288-3.36-5.423l.735-3.142c.15-.638.33-1.193.555-1.65.878-1.815 2.37-2.303 4.875-1.71l1.253.292c3.142.735 4.102 2.288 3.367 5.423"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.188" d="M11.295 14.546c-.465.315-1.05.577-1.763.81l-1.185.39c-2.977.96-4.545.157-5.512-2.82l-.96-2.963c-.96-2.977-.165-4.552 2.812-5.512l1.185-.39c.308-.098.6-.18.878-.233-.225.458-.405 1.013-.555 1.65L5.46 8.621c-.735 3.135.232 4.68 3.36 5.422l1.26.3q.652.158 1.215.203"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-notification" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M16.385 16H3.514c-.717 0-1.208-.735-.957-1.407.462-1.235 1.043-2.982 1.043-3.95C3.6 9.036 2.533 1 10 1s6.4 7.5 6.4 9.643c0 1.208.509 2.757.952 3.878.274.69-.224 1.479-.967 1.479ZM7.5 16.5S7.5 19 10 19s2.5-2.5 2.5-2.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-notification_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M12.006 2.1c4.015 0 6.896 3.278 6.896 7.531v1.6c0 .229.193.532.72 1.076l.27.275c1.082 1.097 1.51 1.728 1.51 2.745 0 .444-.052.79-.268 1.206-.456.878-1.424 1.367-2.87 1.367h-1.911c-.63 2.333-2.13 3.6-4.351 3.6-2.245 0-3.755-1.294-4.372-3.674l.02.074H5.738c-1.488 0-2.465-.503-2.902-1.411-.19-.397-.234-.72-.234-1.162 0-1.017.427-1.648 1.509-2.745.139-.14.202-.206.27-.275.527-.544.72-.848.72-1.076v-1.6C5.102 5.38 7.99 2.1 12.007 2.1M14.467 17.9H9.537c.456 1.247 1.241 1.799 2.466 1.799 1.224 0 2.01-.552 2.465-1.799M12.006 3.9c-2.968 0-5.104 2.426-5.104 5.731v1.6c0 .852-.39 1.463-1.228 2.328l-.282.287c-.746.757-.99 1.117-.99 1.48 0 .193.013.293.056.383.108.223.433.39 1.28.39h12.527c.82 0 1.153-.168 1.272-.396.05-.095.065-.198.065-.376 0-.364-.244-.724-.991-1.481-.139-.14-.208-.211-.281-.287-.839-.865-1.228-1.476-1.228-2.328v-1.6c0-3.307-2.13-5.731-5.096-5.731"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-notification_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14.005 3.5C18.535 3.5 22 7.294 22 12.082l-.005 1.826c0 .307.2.663.738 1.297l.271.315c1.07 1.238 1.496 1.954 1.496 3.068 0 .501-.057.89-.294 1.358C23.7 20.94 22.618 21.5 21 21.5h-2.601C17.73 23.766 16.212 25 14 25s-3.731-1.235-4.399-3.5H7c-1.665 0-2.758-.574-3.242-1.604-.21-.446-.258-.809-.258-1.308 0-1.113.425-1.83 1.493-3.068.139-.16.203-.235.27-.314.539-.635.737-.99.737-1.299V12.08C6 7.296 9.472 3.5 14.005 3.5m2.274 18h-4.558C12.17 22.544 12.899 23 14 23s1.829-.457 2.28-1.5m-2.274-16C10.618 5.5 8 8.362 8 12.079v1.828c0 .928-.384 1.617-1.212 2.592l-.28.328c-.76.88-1.008 1.298-1.008 1.761 0 .226.016.347.068.457.124.264.488.455 1.432.455h14c.914 0 1.286-.192 1.423-.46.059-.117.077-.241.077-.452 0-.463-.248-.88-1.009-1.76l-.282-.328c-.828-.976-1.214-1.665-1.214-2.593L20 12.08C20 8.36 17.389 5.5 14.005 5.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-notification_slash_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.006 2.1c4.162 0 6.896 3.445 6.896 7.531v1.6c0 .25.146.538.578.992.473.496 1.016.934 1.401 1.508.318.474.533 1.043.52 1.69a.9.9 0 0 1-1.8-.037c.017-.816-.93-1.402-1.424-1.92-.474-.497-1.075-1.234-1.075-2.233v-1.6c0-3.312-2.135-5.731-5.096-5.731-1.008 0-1.885.268-2.623.735a.9.9 0 0 1-.962-1.522A6.67 6.67 0 0 1 12.006 2.1M16.353 17.9c-.63 2.333-2.13 3.6-4.351 3.6s-3.723-1.267-4.352-3.6H5.738c-1.488 0-2.465-.503-2.902-1.411-.19-.397-.234-.72-.234-1.162 0-1.293.941-2.156 1.78-3.02.526-.544.72-.848.72-1.076 0-1.493-.038-2.969.454-4.404l-2.29-2.291a.9.9 0 0 1 1.272-1.273l16.2 16.2a.9.9 0 0 1-1.273 1.273l-2.835-2.835zm-6.817.002h4.932c-.456 1.246-1.242 1.798-2.466 1.798s-2.01-.552-2.466-1.799M6.902 11.23c0-.976-.06-1.971.122-2.936L14.83 16.1h-9.09c-.848 0-1.173-.168-1.28-.39-.336-.698.52-1.445.933-1.864.723-.731 1.51-1.518 1.51-2.615" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" id="svg-name-notifications" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.214 13.532a6.06 6.06 0 0 1 2.814-2.999C15.22 9.105 16.475 8 18 8s2.782 1.105 2.972 2.533a6.08 6.08 0 0 1 2.822 2.999s.677 1.26.87 3.369c.064.68.319 1.697.673 2.364.438.826 1.493 2.231 1.622 3.757q.04.213.041.433c0 .404-.104.796-.3 1.168l-.02.044c-.116.25-.223.404-.323.477C25.029 26.82 21.787 28 18 28c-3.799 0-7.047-1.188-8.368-2.87-.089-.074-.185-.212-.288-.427A2.5 2.5 0 0 1 9 23.455q.002-.246.053-.484c.149-1.507 1.184-2.89 1.617-3.706.354-.667.61-1.684.672-2.364.195-2.108.872-3.37.872-3.37zM18 26.002c-3.52 0-6.637-1.16-6.637-2.366 0-.834 1.636-1.56 3.65-1.926.134 1.486 1.42 2.654 2.987 2.654 1.57 0 2.854-1.168 2.987-2.654 2.015.366 3.652 1.092 3.652 1.926 0 1.206-3.117 2.367-6.639 2.367z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="22" id="svg-name-ok" class="svg-sprite__symbol"><path fill="#FFF" fill-rule="evenodd" d="M6.77 0C3.491 0 .833 2.552.833 5.701s2.658 5.701 5.937 5.701 5.937-2.552 5.937-5.701S10.049 0 6.77 0m3.953 11.916a1.66 1.66 0 0 1 2.269.24 1.51 1.51 0 0 1-.25 2.179c-.075.058-1.5 1.139-3.876 1.603l3.587 3.415c.631.605.632 1.586.002 2.192a1.66 1.66 0 0 1-2.283.002L6.69 18.29l-3.163 3.236c-.317.315-.74.474-1.162.474-.404 0-.807-.144-1.12-.434a1.507 1.507 0 0 1-.042-2.192l3.405-3.417C2.164 15.503.681 14.394.604 14.335a1.51 1.51 0 0 1-.249-2.18 1.66 1.66 0 0 1 2.27-.239c.014.011 1.565 1.13 4.064 1.132 2.5-.002 4.019-1.12 4.034-1.132M6.77 3.344c1.355 0 2.454 1.056 2.454 2.357S8.125 8.058 6.77 8.058 4.316 7.003 4.316 5.701c0-1.301 1.099-2.357 2.454-2.357"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="12" fill="none" id="svg-name-open" class="svg-sprite__symbol"><path fill="currentColor" d="M17.684 7.431a.67.67 0 0 1 0 1.138l-4.737 2.842c-.42.253-.947-.063-.947-.568V5.157c0-.505.526-.82.947-.568zM0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75M0 5.75A.75.75 0 0 1 .75 5h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 5.75M0 10.75A.75.75 0 0 1 .75 10h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-palette_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10.8 6.05a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M14.45 8.2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M4.3 9.45a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M7.85 4.8a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"/><path fill="currentColor" fill-rule="evenodd" d="M14.177 14.037c2.142.23 4.323-.743 4.323-4.037a8.47 8.47 0 0 0-2.49-6.01A8.47 8.47 0 0 0 10 1.5a8.47 8.47 0 0 0-6.01 2.49A8.47 8.47 0 0 0 1.5 10c0 2.347.951 4.472 2.49 6.01A8.47 8.47 0 0 0 10 18.5c1.13 0 2.255-1.007 1.977-2.425-.047-.24-.11-.472-.168-.688-.254-.94-.43-1.59 1.076-1.487.036.002.455.047 1.292.137m.16-1.491-.246-.027c-.653-.07-1.037-.11-1.103-.116-.525-.036-1.172-.024-1.74.264a2 2 0 0 0-1.102 1.687c-.033.476.088.944.154 1.197l.072.27c.053.197.097.357.133.542a.6.6 0 0 1-.003.277.44.44 0 0 1-.099.173A.57.57 0 0 1 10 17a6.97 6.97 0 0 1-4.95-2.05A6.97 6.97 0 0 1 3 10c0-1.933.782-3.681 2.05-4.95A6.97 6.97 0 0 1 10 3c1.933 0 3.681.782 4.95 2.05A6.97 6.97 0 0 1 17 10c0 1.297-.412 1.873-.774 2.152-.412.317-1.065.482-1.889.394" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10a9 9 0 1 0-18 0"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M13.15 10 10 19l9-9"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute-with-arrow-down" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M19 10a9 9 0 1 0-18 0"/><path d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M15.693 18.2V12m0 6.2 2.692-3m-2.693 3L13 15.2"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-parachute-with-arrow-up" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M19 10a9 9 0 1 0-18 0"/><path d="M19 10c0-1.493-1.314-2.7-2.925-2.7-1.62 0-2.925 1.207-2.925 2.7 0-1.493-1.413-2.7-3.15-2.7S6.85 8.508 6.85 10c0-1.493-1.314-2.7-2.925-2.7C2.305 7.3 1 8.508 1 10M1 10l9 9-3.15-9M15.693 12v6.2m0-6.2 2.692 3m-2.693-3L13 15"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 16" id="svg-name-pause" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 2.969V13.03c0 .52-.034 1.018-.097 1.387-.062.37-.147.579-.236.582h-.334c-.089-.003-.174-.213-.236-.582A9 9 0 0 1 12 13.031V2.97c0-.52.034-1.018.097-1.387.062-.37.147-.579.236-.582h.334c.089.003.174.212.236.582.063.369.098.868.097 1.387M2 2.969V13.03c0 .52-.034 1.018-.097 1.387-.062.37-.147.579-.236.582h-.334c-.089-.003-.174-.213-.236-.582A9 9 0 0 1 1 13.031V2.97c0-.52.034-1.018.097-1.387.062-.37.147-.579.236-.582h.334c.089.003.174.212.236.582.063.369.098.868.097 1.387" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pause-audio" class="svg-sprite__symbol"><rect width="14" height="14" x="3" y="3" stroke="#fff" stroke-width="1.5" rx="3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-pause-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M6 6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C6.76 5 7.04 5 7.6 5h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C10 5.76 10 6.04 10 6.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C9.24 19 8.96 19 8.4 19h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 18.24 6 17.96 6 17.4zM14 6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C14.76 5 15.04 5 15.6 5h.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C18 5.76 18 6.04 18 6.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C17.24 19 16.96 19 16.4 19h-.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C14 18.24 14 17.96 14 17.4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" id="svg-name-paused" class="svg-sprite__symbol"><circle cx="40" cy="40" r="40" fill="#F1F1F1" opacity=".1"/><rect width="13" height="40" x="22" y="20" stroke="#fff" stroke-width="2" rx="3"/><rect width="13" height="40" x="45" y="20" stroke="#fff" stroke-width="2" rx="3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-payment_card_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.797 4.1c1.152 0 1.739.113 2.35.44.564.302 1.013.75 1.314 1.314s.422 1.108.439 2.094l.002.256v7.59l-.003.257c-.016.986-.136 1.53-.438 2.094a3.17 3.17 0 0 1-1.314 1.314l-.14.072c-.565.272-1.147.369-2.21.369H6.207c-1.064 0-1.646-.097-2.21-.369l-.14-.072a3.17 3.17 0 0 1-1.315-1.314c-.302-.564-.422-1.108-.438-2.094l-.002-.256v-7.59c0-1.152.113-1.74.44-2.35A3.17 3.17 0 0 1 3.856 4.54c.564-.302 1.108-.422 2.094-.438l.256-.002zM20.1 9.9v5.895c0 .88-.059 1.186-.227 1.501q-.2.375-.576.576c-.29.155-.574.218-1.308.227H6.013c-.734-.01-1.017-.072-1.308-.227a1.37 1.37 0 0 1-.576-.576c-.168-.315-.227-.621-.227-1.501L3.9 9.9zm-13.895-4H17.99c.734.01 1.018.072 1.308.227q.375.2.576.576c.155.29.218.574.227 1.308L20.1 8.1H3.902V8.01c.01-.734.072-1.017.227-1.308q.2-.375.576-.576c.315-.168.621-.227 1.501-.227" clip-rule="evenodd"/><path fill="currentColor" d="M6.002 14.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C6.382 14 6.522 14 6.802 14h.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C7.622 16 7.482 16 7.202 16h-.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218c-.054-.107-.054-.247-.054-.527z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" id="svg-name-pen" class="svg-sprite__symbol"><path d="M14.603 0a.94.94 0 0 0-.67.278l-1.617 1.617 3.789 3.79 1.617-1.618c.37-.37.37-.97 0-1.34l-2.45-2.45a.94.94 0 0 0-.67-.277zm-3.708 3.316L0 14.21V18h3.79L14.683 7.105l-3.79-3.79z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="svg-name-pen-stroked" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M18.5 5.914a2 2 0 0 0 0-2.828L16.914 1.5a2 2 0 0 0-2.828 0l-1.793 1.793-10 10a1 1 0 0 0-.242.39l-1.5 4.5a1 1 0 0 0 1.265 1.266l4.5-1.5a1 1 0 0 0 .391-.242l10-10zm-3-3L17.086 4.5 16 5.586 14.414 4zm-2.5 2.5L14.586 7 5.46 16.126l-2.379.793.793-2.379z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pen-stroked-thin" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7 6 17l-4.5 1.5L3 14 13 4m3 3-3-3m3 3 1.793-1.793a1 1 0 0 0 0-1.414l-1.586-1.586a1 1 0 0 0-1.414 0L13 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none" id="svg-name-pen-underlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="m10.971 1.471 1.621 1.32a.804.804 0 0 1-.007 1.158l-1.231 1.5-4.192 5.114a.53.53 0 0 1-.279.172l-2.173.5a.55.55 0 0 1-.57-.487l.101-2.144a.5.5 0 0 1 .124-.296l4.01-4.888 1.413-1.723a.885.885 0 0 1 1.183-.226" clip-rule="evenodd"/><path fill="currentColor" d="M1.167 13.202a.625.625 0 1 0 0 1.25zm11.417 1.25a.625.625 0 0 0 0-1.25zM8.954 3.184a.625.625 0 1 0-1.158.468zm2.537 2.874a.625.625 0 0 0-.275-1.219zM1.167 14.452h11.417v-1.25H1.167zm6.629-10.8c.193.48.592 1.165 1.185 1.692.603.537 1.463.95 2.51.714l-.275-1.219c-.536.121-.998-.068-1.405-.429a3.5 3.5 0 0 1-.856-1.226z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-pen_outline_16" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.536 1.664a1.95 1.95 0 0 0-1.565 0 2 2 0 0 0-.513.342c-.137.121-.292.276-.465.45l-7.39 7.389c-.295.295-.528.527-.699.806-.15.245-.261.513-.328.793-.076.317-.076 1.112-.076 1.53 0 .122 0 .254.01.368.01.13.036.3.126.477.12.235.31.425.545.545.176.09.347.116.477.127.114.009.246.009.368.009.418 0 1.213 0 1.53-.076.28-.067.548-.178.793-.328.279-.171.511-.404.806-.7l7.39-7.389c.173-.173.328-.328.449-.465.128-.146.253-.31.342-.513a1.95 1.95 0 0 0 0-1.565 2 2 0 0 0-.342-.513c-.121-.137-.276-.292-.45-.465l-.03-.03a11 11 0 0 0-.465-.45 2 2 0 0 0-.513-.342m-.963 1.37a.45.45 0 0 1 .361 0 .6.6 0 0 1 .127.096c.097.085.217.205.41.398.194.194.314.314.399.41.08.092.094.124.096.128.05.115.05.246 0 .361a.6.6 0 0 1-.096.127 10 10 0 0 1-.398.41l-.724.724-1.436-1.436.724-.724c.193-.193.313-.313.41-.398a.6.6 0 0 1 .127-.096M9.252 5.312l-5.54 5.54c-.37.37-.465.472-.532.58a1.3 1.3 0 0 0-.15.361 4 4 0 0 0-.022.432c-.01.418-.014.628.008.672.028.058.032.061.09.09.044.022.252.018.67.008.209-.004.372-.012.431-.026q.192-.045.36-.15c.109-.066.211-.161.581-.531l5.54-5.54z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-people-couple" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M13.999 16.125c-.273-.803-.79-1.901-1.72-2.792-.914-.874-2.26-1.583-4.279-1.583s-3.365.709-4.278 1.583c-.931.89-1.448 1.99-1.72 2.792-.01.025-.007.037-.007.04a.1.1 0 0 0 .013.026c.02.024.067.059.148.059h11.688c.081 0 .129-.035.148-.059a.1.1 0 0 0 .013-.025c0-.004.002-.016-.006-.041Z"/><path fill="currentColor" fill-rule="evenodd" d="M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6M11.625 3.333a3 3 0 1 1 0 5.334c.295-.4.526-.853.676-1.34a1.5 1.5 0 1 0 0-2.655 4.5 4.5 0 0 0-.676-1.339M16.68 17h2.164c.61 0 1.061-.54.865-1.117C19.119 14.149 17.437 11 13 11h-.066a8.5 8.5 0 0 1 1.7 1.697 4.75 4.75 0 0 1 2.126 1.178c.52.498.9 1.079 1.17 1.625h-1.748c.215.546.378 1.058.498 1.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-people-couple-rounded" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" clip-path="url(#a)"><path d="M6 2.4a1.8 1.8 0 1 1-3.599 0 1.8 1.8 0 0 1 3.6 0M7.8 8.879c0 1.388-1.611 2.52-3.6 2.52S.6 10.271.6 8.88s1.612-2.52 3.6-2.52c1.99 0 3.6 1.128 3.6 2.52M9.811 4.08a1.08 1.08 0 1 1-2.16 0 1.08 1.08 0 0 1 2.16 0" clip-rule="evenodd"/><path d="M9.24 10.68a2.006 2.006 0 0 0 2.16-1.801 2.006 2.006 0 0 0-2.16-1.8"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="81" height="52" fill="none" id="svg-name-people-monochrome" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M68.33 30.47c3.518 0 6.33-2.813 6.33-6.235S71.849 18 68.33 18 62 20.813 62 24.235s2.812 6.236 6.33 6.236m0 2c4.601 0 8.33-3.686 8.33-8.235S72.932 16 68.33 16c-4.6 0-8.33 3.687-8.33 8.235 0 4.549 3.73 8.236 8.33 8.236M60.98 50h17.598c-.019-.345-.05-.768-.104-1.249-.151-1.363-.474-3.162-1.15-4.945-.678-1.786-1.692-3.51-3.198-4.781-1.488-1.257-3.513-2.123-6.324-2.123s-4.836.866-6.324 2.123c-.858.725-1.556 1.596-2.123 2.542l-.074-.196c-.25-.66-.538-1.325-.87-1.981a11.5 11.5 0 0 1 1.777-1.893c1.864-1.574 4.35-2.595 7.614-2.595s5.75 1.02 7.615 2.595c1.845 1.559 3.022 3.61 3.777 5.6s1.105 3.966 1.268 5.433c.082.737.117 1.352.132 1.787a17 17 0 0 1 .01.65v.054l-1-.021 1 .022-.023.978H60.976l.022-.978v-.019l.001-.046v-.17a20 20 0 0 0-.018-.787m-2.195 0h.194zm-3.78.491c1.294-.256 2.412-.45 2.495.297.044.399.497-.043.89-.427a5 5 0 0 1 .395-.361h-3.761a21 21 0 0 0-.019.491M60 51l1 .022z" clip-rule="evenodd" opacity=".11"/><path fill="currentColor" fill-rule="evenodd" d="M45.235 26.235c4.569 0 8.234-3.656 8.234-8.117S49.804 10 45.234 10 37 13.656 37 18.118s3.665 8.117 8.234 8.117m0 2c5.652 0 10.234-4.53 10.234-10.117S50.887 8 45.234 8 35 12.53 35 18.118s4.582 10.117 10.234 10.117M35.988 50h22.991a27 27 0 0 0-.14-1.788c-.188-1.687-.587-3.917-1.428-6.132-.84-2.217-2.105-4.371-3.994-5.967-1.871-1.58-4.412-2.662-7.917-2.662s-6.045 1.082-7.917 2.662c-1.423 1.203-2.492 2.723-3.293 4.348a24.866 24.866 0 0 0-.951-2.408c.782-1.261 1.751-2.452 2.954-3.468 2.247-1.897 5.25-3.134 9.207-3.134s6.96 1.237 9.207 3.134c2.229 1.883 3.657 4.366 4.574 6.786.92 2.422 1.346 4.829 1.545 6.62.1.899.143 1.649.161 2.178a21 21 0 0 1 .013.788l-.001.046v.018l-1-.021 1 .022-.023.978H35.98l.022-.977-1-.023 1 .022V51l.001-.054v-.198a25 25 0 0 0-.014-.75m-3.965-.052-.002.052h1.965-2.525q.291-.028.562-.052m-2.01.195.763-.075.685-.068H30.02z" clip-rule="evenodd" opacity=".39"/><path fill="currentColor" fill-rule="evenodd" d="M28.002 12c0 5.523-4.478 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m2 0c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12m3.984 38H2.016c.022-.575.07-1.376.175-2.328.22-2.011.692-4.673 1.684-7.32.994-2.65 2.492-5.236 4.737-7.154C10.84 31.296 13.856 30 18.002 30c4.145 0 7.163 1.296 9.389 3.198 2.245 1.918 3.743 4.503 4.737 7.153.992 2.648 1.463 5.31 1.684 7.32.105.953.153 1.754.174 2.329m2.015 1.022-1-.022zL35.98 52H.024l-.022-.977 1-.023-1 .022V51L0 50.947v-.198c0-.17.003-.417.014-.728.021-.623.071-1.508.188-2.568.232-2.114.73-4.952 1.8-7.804 1.069-2.85 2.727-5.765 5.31-7.972C9.915 29.454 13.397 28 18.002 28c4.604 0 8.087 1.454 10.688 3.677 2.583 2.207 4.241 5.122 5.31 7.972 1.07 2.852 1.568 5.69 1.8 7.804.117 1.06.167 1.945.188 2.568a25 25 0 0 1 .014.926v.075" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" fill="none" id="svg-name-person-check" class="svg-sprite__symbol"><path fill="#F1F1F1" fill-rule="evenodd" d="M9.09 10.076q.357-.676.814-1.282a3.001 3.001 0 1 1 4.078-3.121 9.4 9.4 0 0 1 1.451-.448 4.501 4.501 0 1 0-6.342 4.851m-.884 2.446c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.305.41.8.657 1.342.657H9.58a9.5 9.5 0 0 1-.812-1.5H3.205c-.086 0-.127-.037-.138-.052l-.005-.008q0-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.691-.512 1.577-.972 2.712-1.272q.035-.814.198-1.587M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#262626" d="M15.294 15.06a.75.75 0 0 0-.588 1.38zM17.937 17l-.293.69a.75.75 0 0 0 .987-.404zm2.756-4.714a.75.75 0 1 0-1.386-.572zm-5.987 4.154 2.938 1.25.587-1.38-2.937-1.25zm3.925.846 2.062-5-1.386-.572-2.063 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-minus" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" fill-rule="evenodd" d="M10.313 11.253 10 11.25c-1.19 0-2.245.13-3.179.36-3.782.925-5.446 3.413-6.124 4.95a1.52 1.52 0 0 0 .166 1.534c.306.41.801.656 1.341.656h8.112a6 6 0 0 1-.88-1.5H2.204c-.085 0-.127-.037-.138-.052l-.004-.007q-.001-.005.008-.026c.55-1.25 1.908-3.316 5.108-4.099.663-.162 1.41-.27 2.253-.305.22-.547.52-1.054.882-1.508" clip-rule="evenodd"/><circle cx="15" cy="15" r="4" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 15h4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M10 12c-5.68 0-7.848 3.12-8.616 4.86-.252.574.195 1.14.82 1.14h15.591c.626 0 1.073-.566.82-1.14C17.849 15.12 15.68 12 10 12Z"/><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-plus" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.7 12H13m2.7 0V9.308m0 2.692v2.692m0-2.692h2.8"/><path fill="currentColor" fill-rule="evenodd" d="M4.296 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.005.008c.011.015.052.052.138.052h15.59c.085 0 .126-.037.137-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.455-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.306.411-.801.658-1.342.658H2.205c-.541 0-1.037-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.496.737-5.704 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-person-with-coins" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 9.032A4.5 4.5 0 1 1 14.5 5v.01a12 12 0 0 0-1.5.033V5a3 3 0 1 0-4.83 2.378 1.7 1.7 0 0 0-.17.744zm0 2.352q-.619.088-1.179.225c-3.782.926-5.446 3.414-6.124 4.95a1.52 1.52 0 0 0 .166 1.535c.306.41.801.656 1.341.656H8.02a1 1 0 0 1-.02-.203V17.25H2.204c-.085 0-.127-.037-.138-.052l-.004-.007q-.001-.005.008-.026c.55-1.25 1.908-3.316 5.108-4.099q.39-.097.822-.165z" clip-rule="evenodd"/><ellipse cx="14" cy="10" stroke="currentColor" stroke-width="1.5" rx="4" ry="2"/><path stroke="currentColor" stroke-width="1.5" d="M18 13c0 1.105-1.79 2-4 2s-4-.895-4-2"/><path stroke="currentColor" stroke-width="1.5" d="M10 9.75v6.929c0 .867 1.79 1.571 4 1.571s4-.704 4-1.571V9.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" id="svg-name-personalization" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.9 9.992c0 2.84-3.76 5.143-8.4 5.143s-8.4-2.302-8.4-5.143S5.86 4.85 10.5 4.85s8.4 2.302 8.4 5.142" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.6 9.99c.026.731-.368 1.417-1.029 1.79a2.19 2.19 0 0 1-2.142 0c-.66-.373-1.055-1.059-1.029-1.79-.026-.73.369-1.416 1.03-1.789a2.19 2.19 0 0 1 2.141 0c.66.373 1.055 1.059 1.03 1.79" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-picture" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-width="1.5" d="m4 19 2.781-4.768a1 1 0 0 1 1.632-.136l.665.798a1 1 0 0 0 1.636-.144l2.511-4.395a1 1 0 0 1 1.682-.085L19 16"/><circle cx="7" cy="7" r="2.25" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-picture_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M9 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/><path fill="currentColor" fill-rule="evenodd" d="M9.462 3h5.076c.948 0 1.714 0 2.334.05.64.053 1.203.163 1.726.43a4.4 4.4 0 0 1 1.922 1.922c.267.523.377 1.087.43 1.726.05.62.05 1.386.05 2.334v5.076c0 .948 0 1.714-.05 2.334-.053.64-.163 1.203-.43 1.726a4.4 4.4 0 0 1-1.922 1.922c-.523.267-1.087.377-1.726.43-.62.05-1.386.05-2.334.05H9.462c-.948 0-1.714 0-2.334-.05-.64-.053-1.203-.163-1.726-.43a4.4 4.4 0 0 1-1.922-1.922c-.267-.523-.377-1.087-.43-1.726C3 16.252 3 15.486 3 14.538V9.462c0-.948 0-1.714.05-2.334.053-.64.163-1.203.43-1.726A4.4 4.4 0 0 1 5.402 3.48c.523-.267 1.087-.377 1.726-.43C7.748 3 8.514 3 9.462 3M7.275 4.845c-.528.043-.83.123-1.055.238A2.6 2.6 0 0 0 5.083 6.22c-.115.226-.195.527-.238 1.055C4.8 7.813 4.8 8.505 4.8 9.5v5c0 .995 0 1.687.045 2.226l.011.126 2.893-2.893c.18-.18.352-.352.509-.485.17-.145.381-.296.654-.384a1.9 1.9 0 0 1 1.177.002c.273.09.483.241.654.386.155.134.326.306.506.488l.754.759 2.76-2.76c.18-.18.351-.352.507-.484.17-.145.38-.295.653-.384a1.9 1.9 0 0 1 1.174 0c.272.089.482.24.653.384.156.132.327.303.507.483l.943.944V9.5c0-.995 0-1.687-.045-2.226-.043-.527-.123-.828-.238-1.054a2.6 2.6 0 0 0-1.137-1.137c-.226-.115-.527-.195-1.055-.238-.538-.044-1.23-.045-2.225-.045h-5c-.995 0-1.687 0-2.226.045M6.22 18.917a2.6 2.6 0 0 1-.527-.356L9 15.253c.209-.21.328-.328.421-.407q.045-.037.06-.047a.1.1 0 0 1 .03 0q.016.01.06.047c.094.08.212.198.42.409l1.37 1.379a.9.9 0 0 0 1.274.002l3.379-3.378c.208-.208.327-.326.42-.405l.06-.047a.1.1 0 0 1 .03 0l.06.047c.093.079.211.197.42.405l2.193 2.193c-.004.515-.014.927-.043 1.274-.043.528-.123.83-.238 1.055a2.6 2.6 0 0 1-1.137 1.137c-.226.115-.527.195-1.055.238-.538.044-1.23.045-2.225.045h-5c-.995 0-1.687 0-2.226-.045-.527-.043-.828-.123-1.054-.238" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pin_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11.332 2.604a.75.75 0 0 1 1.266-.384l5.182 5.183a.75.75 0 0 1-.383 1.265l-1.54.308a.3.3 0 0 0-.152.082l-2.463 2.463a.3.3 0 0 0-.086.187l-.297 3.858c-.065.853-1.105 1.258-1.724.638l-3.139-3.139-4.716 4.716a.75.75 0 0 1-1.133-.977l4.788-4.8-3.139-3.138c-.6-.601-.245-1.632.638-1.725l3.859-.296a.3.3 0 0 0 .187-.086l2.463-2.464a.3.3 0 0 0 .081-.151zm1.196 1.668c-.08.409-.192.748-.524 1.084L9.54 7.819a1.8 1.8 0 0 1-1.133.521l-2.801.216 5.837 5.837.216-2.8c.034-.437.23-.815.521-1.133l2.464-2.463c.302-.302.644-.458 1.083-.525z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pin_slash_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M17.965 8.15a.75.75 0 0 1-.57.519l-1.567.315a.25.25 0 0 0-.134.075c-.224.241-.457.472-.69.705a.75.75 0 0 1-1.06-1.06l.65-.665c.25-.269.578-.453.938-.525l.194-.04-3.2-3.198-.036.182a1.75 1.75 0 0 1-.48.901l-.708.706a.75.75 0 0 1-1.057-1.064l.704-.702a.25.25 0 0 0 .069-.13l.306-1.563a.75.75 0 0 1 1.266-.386l5.187 5.183a.75.75 0 0 1 .188.747M7.996 13.065l3.139 3.14c.607.606 1.616.23 1.719-.586.084-.835.13-1.674.194-2.51l1.672 1.671a.75.75 0 1 0 1.06-1.06l-9.5-9.5a.75.75 0 1 0-1.06 1.06l1.67 1.67c-.845.067-1.718.076-2.555.206-.81.157-1.116 1.132-.539 1.71l3.139 3.138-4.788 4.8a.75.75 0 0 0 1.133.977zm3.448 1.33.208-2.682-3.369-3.369-2.67.212z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pinned" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.741 15.655 2.957-2.957 2.957-2.957c.667-.688.77-1.746.248-2.55a3.03 3.03 0 0 0-2.415-1.506c-1.357.027-2.909.3-3.877-.67L6.084 1.489a1.64 1.64 0 0 0-2.314-.02L1.469 3.767a1.64 1.64 0 0 0 .019 2.315l3.528 3.531c.968.969.694 2.52.668 3.877a3.03 3.03 0 0 0 1.507 2.414 2.06 2.06 0 0 0 2.55-.248Z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m12.698 12.7 6.3 6.3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-pinned-crossed" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.616.96a2.39 2.39 0 0 0-3.37-.027h-.001L3.24.938.94 3.235l-.006.006a2.39 2.39 0 0 0 .026 3.371l3.526 3.53c.303.303.447.724.49 1.317.03.413.01.812-.011 1.252a25 25 0 0 0-.029.809l1.554-1.68a7 7 0 0 0-.018-.49c-.056-.763-.26-1.602-.925-2.268L2.018 5.55l-.003-.003a.89.89 0 0 1-.013-1.253l2.295-2.292a.89.89 0 0 1 1.254.013l.003.003L9.08 5.546c.665.666 1.505.87 2.268.925l.1.007 1.407-1.52q-.072.002-.14.006c-.442.022-.844.042-1.258.011-.593-.043-1.014-.187-1.316-.49zm8.063 4.236L13.527 6.44a2.28 2.28 0 0 1 1.747 1.158c.33.51.266 1.179-.154 1.616l-2.919 2.92a1 1 0 0 0-.063.062L9.215 15.12a1.31 1.31 0 0 1-1.648.134 2.28 2.28 0 0 1-1.026-1.262l-1.1 1.19A3.8 3.8 0 0 0 6.8 16.544a2.81 2.81 0 0 0 3.463-.35l.008-.008 2.43-2.43 5.768 5.77a.75.75 0 1 0 1.06-1.06l-5.768-5.77 2.425-2.425.008-.008a2.81 2.81 0 0 0 .35-3.463 3.78 3.78 0 0 0-1.865-1.604" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.807 2.68 3.333 18.326"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" id="svg-name-pinned-filled" class="svg-sprite__symbol"><path fill="currentColor" d="m8.235.106 3.657 3.663c.225.226.064.633-.263.633h-.523a.9.9 0 0 0-.633.263L8.758 6.38a.9.9 0 0 0-.262.633v2.996c0 .554-.7.858-1.1.456l-2.301-2.3-3.57 3.57A.893.893 0 1 1 .26 10.473L3.83 6.898l-2.29-2.29c-.391-.392-.109-1.102.456-1.102H4.99a.9.9 0 0 0 .633-.262L7.338 1.53a.9.9 0 0 0 .263-.634V.37c0-.32.403-.495.634-.263"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="svg-name-play" class="svg-sprite__symbol"><path d="M7.5 7.662A4.574 4.574 0 0 0 3 12.307v3.318a4.574 4.574 0 0 0 4.5 4.645h9a4.574 4.574 0 0 0 4.5-4.645v-3.318a4.574 4.574 0 0 0-4.5-4.645z" style="fill-rule:evenodd;clip-rule:evenodd;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round"/><path fill="currentColor" d="M11.23 7a.75.75 0 0 0 1.5 0zm.007-2.916.204-.722-.02-.005zm-.921-.104v.75h.017zM9.76 2a.75.75 0 1 0-1.5 0zM8.036 15.626a.75.75 0 0 0 1.5 0zm1.5-1.99a.75.75 0 0 0-1.5 0zm-1.5 0a.75.75 0 0 0 1.5 0zm1.5-1.991a.75.75 0 0 0-1.5 0zm-.75 1.241a.75.75 0 0 0 0 1.5zm1.928 1.5a.75.75 0 0 0 0-1.5zm-1.928 0a.75.75 0 0 0 0-1.5zm-1.929-1.5a.75.75 0 0 0 0 1.5zm7.176-.435a.75.75 0 1 0 1.077 1.044zm2.363-.283a.75.75 0 1 0-1.078-1.044zm-1.078 2.942a.75.75 0 1 0 1.077 1.044zm2.363-.283a.75.75 0 1 0-1.077-1.044zM12.73 7c0-.459.056-1.248-.017-1.86-.072-.607-.316-1.51-1.271-1.778l-.407 1.444c.002 0 .128.002.188.51.06.5.007 1.034.007 1.684zm-1.308-3.643a4.2 4.2 0 0 0-1.123-.127l.035 1.5a2.7 2.7 0 0 1 .72.08zm-1.105-.127c-.292 0-.411-.057-.448-.08-.023-.015-.045-.034-.068-.1a1.4 1.4 0 0 1-.05-.41 7 7 0 0 1 .004-.302c.003-.103.007-.224.007-.338h-1.5c0 .087-.003.18-.006.296-.003.11-.006.235-.005.364.004.25.025.567.132.876.112.327.32.652.685.882.351.222.777.312 1.249.312zm-.78 12.396v-1.99h-1.5v1.99zm0-1.99v-1.991h-1.5v1.991zm-.75.75h1.928v-1.5H8.786zm0-1.5H6.857v1.5h1.929zm6.324.609 1.286-1.327-1.078-1.044-1.285 1.327zm1.286 2.659 1.285-1.327-1.077-1.044-1.286 1.327z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-play-audio" class="svg-sprite__symbol"><path stroke="#fff" stroke-width="1.5" d="M3 14.764V5.236a2 2 0 0 1 2.894-1.789l9.528 4.764c1.474.737 1.474 2.84 0 3.578l-9.528 4.764A2 2 0 0 1 3 14.763Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none" id="svg-name-play-outlined" class="svg-sprite__symbol"><path stroke="#fff" stroke-width="2" d="M3.8 29.153V8.466c0-2.184 2.26-3.636 4.246-2.73l20.688 9.437c2.25 1.026 2.361 4.183.188 5.365L8.234 31.788c-1.999 1.088-4.433-.36-4.433-2.635Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-play-superellipse-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.984 6.965 4.516 3.069a.953.953 0 0 1 0 1.645l-4.516 3.358c-.857.58-2.154.085-2.154-.823V7.785c0-.904 1.299-1.401 2.154-.82" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 9.571v2.858A8.57 8.57 0 0 0 9.571 21h2.858A8.57 8.57 0 0 0 21 12.429V9.57A8.57 8.57 0 0 0 12.429 1H9.57A8.57 8.57 0 0 0 1 9.571" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-play-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="M17.671 10.923c.82.483.82 1.67 0 2.154l-8.787 5.175A1.25 1.25 0 0 1 7 17.174V6.826a1.25 1.25 0 0 1 1.884-1.078z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-playlist" class="svg-sprite__symbol"><g fill="currentColor" clip-path="url(#a)"><path d="M19.684 11.432a.67.67 0 0 1 0 1.136l-4.737 2.843c-.42.253-.947-.063-.947-.568V9.157c0-.505.526-.82.947-.568zM2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75M2 9.75A.75.75 0 0 1 2.75 9h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 2 9.75M2 14.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-plus-default" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M2.93 9a1 1 0 1 0 0 2H9v6.071a1 1 0 1 0 2 0V11h6.072a1 1 0 1 0 0-2h-6.071V2.929a1 1 0 1 0-2 0V9z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="8" height="20" fill="none" id="svg-name-pointer" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M8 10c0 3-8 6-8 10V0c0 3.975 8 7 8 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" id="svg-name-poll" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.375h10.5M2.75 10.375h14.5M2.75 15.375h8.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-poll_icons" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M7.5 17a1.5 1.5 0 0 0 0-3h-3a1.5 1.5 0 0 0 0 3zM11.5 11a1.5 1.5 0 0 0 0-3h-7a1.5 1.5 0 0 0 0 3z"/><path fill="currentColor" stroke="currentColor" stroke-width="1.5" d="M15.5 5a1.5 1.5 0 0 0 0-3h-11a1.5 1.5 0 1 0 0 3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-poll_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10.75 6.413a.75.75 0 0 0-1.5 0v7.175a.75.75 0 0 0 1.5 0zM6.5 8.288a.75.75 0 0 1 .75.75v4.55a.75.75 0 0 1-1.5 0v-4.55a.75.75 0 0 1 .75-.75M14.25 10.788a.75.75 0 0 0-1.5 0v2.8a.75.75 0 0 0 1.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M3.752 1.983c.794-.425 1.57-.608 3.376-.608h5.744c1.806 0 2.582.183 3.376.608a4.26 4.26 0 0 1 1.769 1.769c.425.794.608 1.57.608 3.376v5.744c0 1.806-.183 2.582-.608 3.376a4.26 4.26 0 0 1-1.769 1.769c-.794.425-1.57.608-3.376.608H7.128c-1.806 0-2.582-.183-3.376-.608a4.26 4.26 0 0 1-1.769-1.769c-.425-.794-.608-1.57-.608-3.376V7.128c0-1.806.183-2.582.608-3.376a4.26 4.26 0 0 1 1.769-1.769m3.376.892c-1.69 0-2.185.172-2.669.43q-.751.404-1.153 1.154c-.26.484-.431.979-.431 2.669v5.744c0 1.69.172 2.185.43 2.669q.404.751 1.154 1.153c.484.26.979.431 2.669.431h5.744c1.69 0 2.185-.172 2.669-.43a2.76 2.76 0 0 0 1.153-1.154c.26-.484.431-.979.431-2.669V7.128c0-1.69-.172-2.185-.43-2.669a2.76 2.76 0 0 0-1.154-1.153c-.484-.26-.979-.431-2.669-.431z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-poll_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M10.692 5c-2.137 0-2.897.147-3.68.565a3.45 3.45 0 0 0-1.447 1.448C5.147 7.795 5 8.555 5 10.692v6.616c0 2.137.147 2.898.565 3.68q.504.942 1.448 1.447c.782.418 1.542.565 3.679.565h6.616c2.137 0 2.898-.147 3.68-.565a3.45 3.45 0 0 0 1.447-1.448c.418-.781.565-1.542.565-3.679v-6.616c0-2.137-.147-2.897-.565-3.68a3.45 3.45 0 0 0-1.448-1.447C20.206 5.147 19.445 5 17.308 5zm0-2h6.616c2.675 0 3.645.278 4.622.801A5.45 5.45 0 0 1 24.2 6.07c.522.978.801 1.948.801 4.623v6.616c0 2.675-.279 3.645-.801 4.622A5.45 5.45 0 0 1 21.93 24.2c-.977.522-1.947.801-4.622.801h-6.616c-2.675 0-3.645-.279-4.623-.801a5.45 5.45 0 0 1-2.268-2.269C3.278 20.954 3 19.984 3 17.309v-6.616c0-2.675.278-3.645.801-4.623A5.45 5.45 0 0 1 6.07 3.801C7.047 3.278 8.017 3 10.692 3M11 19a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0zm4 0a1 1 0 1 1-2 0V9a1 1 0 1 1 2 0zm4 0a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-poo-reaction" class="svg-sprite__symbol"><path fill="url(#a)" d="M25.966 20.514c3.037-5.605-3.31-6.787-3.31-6.787 1.801-5.605-3.803-6.143-3.803-6.143.732-2.198-3.83-4.555-3.24-5.923.212-.52-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963-.009.46-4.034.415-3.698 5.632.017.264-.08.503-.327.608-2.957 1.245-3.08 4.775-2.577 5.914 0 0 .132-.009-.062.009C.865 20.505 0 22.632 0 24.345c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.511-4.034-4.511"/><path fill="url(#b)" d="M25.966 20.514c3.037-5.605-3.31-6.787-3.31-6.787 1.801-5.605-3.803-6.143-3.803-6.143.732-2.198-3.83-4.555-3.24-5.923.212-.52-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963-.009.46-4.034.415-3.698 5.632.017.264-.08.503-.327.608-2.957 1.245-3.08 4.775-2.577 5.914 0 0 .132-.009-.062.009C.865 20.505 0 22.632 0 24.345c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.511-4.034-4.511"/><path fill="url(#c)" d="M22.657 13.727c1.8-5.605-3.804-6.143-3.804-6.143.732-2.198-3.725-4.44-3.24-5.923.177-.538-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.964-.009.458-4.034.414-3.698 5.63.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778"/><path fill="url(#d)" d="M22.657 13.727c1.8-5.605-3.804-6.143-3.804-6.143.732-2.198-3.725-4.44-3.24-5.923.177-.538-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.964-.009.458-4.034.414-3.698 5.63.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778"/><path fill="url(#e)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z"/><path fill="url(#f)" d="M11.412 4.145c-1.041 1.482-1.341 3.045-1.35 3.962 0 0-.477 5.526 12.595 5.623-10.142-.618-13.169-5.305-11.245-9.585"/><path fill="url(#g)" d="M25.968 20.515c.468-.91.698-1.704.768-2.392-.768 2.392-7.387 2.533-12.798.362-4.819-1.933-7.228-4.59-7.51-6.4a7.7 7.7 0 0 0-.054 1.66c.018.265-.07.521-.326.61 2.462.238 4.74 7.28 19.92 6.16"/><path fill="url(#h)" d="M3.339 20.276c.044-.01.088-.01.123-.018-.017 0-.035 0-.053.009-.026 0-.052.009-.07.009"/><path fill="url(#i)" d="M18.853 7.584c.732-2.198-3.76-4.475-3.24-5.923.186-.53-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963 0 0-.477 5.526 12.595 5.623 1.8-5.605-3.804-6.143-3.804-6.143" opacity=".5"/><path fill="url(#j)" d="M18.853 7.584c.732-2.198-3.76-4.475-3.24-5.923.186-.53-.097-.52-.097-.52-4.501 1.606-5.428 5.313-5.454 6.963 0 0-.477 5.526 12.595 5.623 1.8-5.605-3.804-6.143-3.804-6.143" opacity=".5"/><path fill="url(#k)" d="M15.058 5.74c.75 1.651 3.795 1.845 3.795 1.845.653-1.95-2.807-3.963-3.24-5.401.01 0-1.252 2.012-.555 3.557Z"/><path fill="url(#l)" d="M15.058 5.74c.75 1.651 3.795 1.845 3.795 1.845.653-1.95-2.807-3.963-3.24-5.401.01 0-1.252 2.012-.555 3.557Z"/><path fill="url(#m)" d="M22.657 13.728C9.594 13.63 10.062 8.105 10.062 8.105c-.009.46-4.034.415-3.698 5.631.017.265-.07.521-.327.61 3.283 0 4.749 7.29 19.92 6.16 2.966-5.825-3.3-6.778-3.3-6.778" opacity=".5"/><path fill="url(#n)" d="M6.374 13.738c.018.265-.079.503-.326.61.247-.089.344-.345.326-.61"/><path fill="url(#o)" d="M25.966 20.516c-15.172 1.13-16.637-6.16-19.92-6.16-2.957 1.244-3.08 4.774-2.577 5.913 0 0 .132-.009-.062.009C.865 20.508 0 22.634 0 24.347c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.336 12.304.336h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.51-4.034-4.51Z" opacity=".5"/><path fill="url(#p)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z"/><path fill="url(#q)" d="M12.868 28.52c4.722 0 6.32.335 12.304.335-15.507 0-18.914-8.597-21.712-8.597-.009 0 0 0 0 0-2.727.3-3.46 2.489-3.46 4.086 0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.31-.335 8.031-.335Z" opacity=".24"/><path fill="url(#r)" d="M25.966 20.325c-15.172 1.13-16.637-6.16-19.92-6.16-2.957 1.244-3.08 4.774-2.577 5.913 0 0 .132-.01-.062.008C.865 20.316 0 22.443 0 24.156c0 1.8 1.236 4.51 4.837 4.51 1.994 0 3.318-.336 8.031-.336s6.32.335 12.304.335h.786c1.12 0 4.042-1.015 4.042-3.83s-2.692-4.51-4.034-4.51" opacity=".24"/><path fill="url(#s)" d="M16.152 15.269c0 1.933 1.43 3.495 3.195 3.495 1.766 0 3.195-1.562 3.195-3.495s-1.43-3.292-3.195-3.292-3.195 1.359-3.195 3.292" opacity=".75"/><path fill="url(#t)" d="M16.152 15.71c0 1.933 1.43 3.495 3.195 3.495 1.766 0 3.195-1.562 3.195-3.495s-1.43-3.222-3.195-3.222-3.195 1.289-3.195 3.222" opacity=".75"/><path fill="url(#u)" d="M7.458 15.269c0 1.933 1.43 3.495 3.195 3.495s3.195-1.562 3.195-3.495-1.43-3.292-3.195-3.292-3.195 1.359-3.195 3.292" opacity=".75"/><path fill="url(#v)" d="M7.458 15.71c0 1.933 1.43 3.495 3.195 3.495s3.195-1.562 3.195-3.495-1.43-3.222-3.195-3.222-3.195 1.289-3.195 3.222" opacity=".75"/><path fill="url(#w)" d="M19.355 18.765a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#fff" d="M20.928 18.138a2.957 2.957 0 1 0-3.145-5.007 2.957 2.957 0 0 0 3.145 5.007"/><path fill="url(#x)" d="M19.355 18.597a2.957 2.957 0 1 0 0-5.913 2.957 2.957 0 0 0 0 5.913"/><path fill="url(#y)" d="M19.355 18.597a2.957 2.957 0 1 0 0-5.913 2.957 2.957 0 0 0 0 5.913"/><path fill="url(#z)" d="M19.355 18.831a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#282828" d="M19.356 17.106a1.465 1.465 0 1 0 0-2.93 1.465 1.465 0 0 0 0 2.93"/><path fill="url(#A)" d="M19.357 16.661a1.79 1.79 0 0 0 1.42-.688 1.465 1.465 0 0 1-1.42 1.138 1.45 1.45 0 0 1-1.421-1.138c.326.414.838.688 1.42.688Z"/><path fill="url(#B)" d="M15.004 24.89c-4.069 0-5.366-4.361-4.13-3.681 1.659.918 2.718 1.006 4.13 1.006s2.463-.088 4.13-1.006c1.236-.68-.061 3.68-4.13 3.68Z"/><path fill="url(#C)" d="M19.133 21.21c-1.659.918-2.718 1.006-4.13 1.006s-2.463-.088-4.131-1.006c-.432-.238-.556.132-.362.724 0-.01.062-.645.645-.203 0 0 2.144 1.288 3.839 1.288s3.84-1.288 3.84-1.288c.582-.433.643.194.643.203.212-.583.089-.962-.344-.724"/><path fill="url(#D)" d="M10.651 18.765a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#fff" d="M12.222 18.068a2.957 2.957 0 1 0-3.145-5.008 2.957 2.957 0 0 0 3.145 5.008"/><path fill="url(#E)" d="M10.648 18.519a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914"/><path fill="url(#F)" d="M10.648 18.519a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914"/><path fill="url(#G)" d="M10.647 18.761a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39"/><path fill="#282828" d="M10.648 17.036a1.465 1.465 0 1 0 0-2.93 1.465 1.465 0 0 0 0 2.93"/><path fill="url(#H)" d="M10.65 16.661a1.79 1.79 0 0 0 1.42-.688 1.464 1.464 0 0 1-1.42 1.138 1.45 1.45 0 0 1-1.421-1.138 1.83 1.83 0 0 0 1.42.688Z"/><defs><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(-3.447 9.77356 -25.5089 -8.99662 8.54 32.728)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(12.73596 .405 -.18493 5.81554 25.326 22.54)" gradientUnits="userSpaceOnUse"><stop stop-color="#835129"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="i" cx="0" cy="0" r="1" gradientTransform="rotate(28.78 -21.144 25.611)scale(12.4888 6.73295)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="matrix(8.09258 3.72092 -1.74778 3.80123 18.995 8.161)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="l" cx="0" cy="0" r="1" gradientTransform="matrix(13.2128 0 0 13.2564 10.453 -1.967)" gradientUnits="userSpaceOnUse"><stop stop-color="#835129"/><stop offset="1" stop-color="#7D4D26"/></radialGradient><radialGradient id="m" cx="0" cy="0" r="1" gradientTransform="matrix(11.0135 0 0 11.0498 19.856 9.121)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="n" cx="0" cy="0" r="1" gradientTransform="rotate(18.953 -58.298 43.647)scale(11.8019 4.34689)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="o" cx="0" cy="0" r="1" gradientTransform="matrix(14.21988 4.88325 -1.48392 4.32113 .937 15.155)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="matrix(4.01865 -5.39556 10.47373 7.8009 11.014 20.572)" gradientUnits="userSpaceOnUse"><stop stop-color="#3C2200"/><stop offset="1" stop-color="#3C2200" stop-opacity="0"/></radialGradient><radialGradient id="q" cx="0" cy="0" r="1" gradientTransform="matrix(.67822 -2.88732 10.77483 2.53096 4.308 24.256)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="r" cx="0" cy="0" r="1" gradientTransform="matrix(-7.47939 .07454 -.0281 -2.82048 25.175 22.463)" gradientUnits="userSpaceOnUse"><stop stop-color="#C86F34"/><stop offset="1" stop-color="#C86F34" stop-opacity="0"/></radialGradient><radialGradient id="s" cx="0" cy="0" r="1" gradientTransform="matrix(-3.17864 0 0 -3.47566 19.25 13.858)" gradientUnits="userSpaceOnUse"><stop stop-color="#362501" stop-opacity=".4"/><stop offset="1" stop-color="#362501" stop-opacity="0"/></radialGradient><radialGradient id="t" cx="0" cy="0" r="1" gradientTransform="translate(19.562 16.022)scale(3.35003)" gradientUnits="userSpaceOnUse"><stop stop-color="#3D2A20" stop-opacity=".4"/><stop offset=".167" stop-color="#4B3021" stop-opacity=".5"/><stop offset=".716" stop-color="#734423" stop-opacity=".829"/><stop offset="1" stop-color="#824B24"/></radialGradient><radialGradient id="u" cx="0" cy="0" r="1" gradientTransform="matrix(-3.17864 0 0 -3.47566 10.556 13.858)" gradientUnits="userSpaceOnUse"><stop stop-color="#362501" stop-opacity=".4"/><stop offset="1" stop-color="#362501" stop-opacity="0"/></radialGradient><radialGradient id="v" cx="0" cy="0" r="1" gradientTransform="translate(10.867 16.022)scale(3.35003)" gradientUnits="userSpaceOnUse"><stop stop-color="#3D2A20" stop-opacity=".4"/><stop offset=".167" stop-color="#4B3021" stop-opacity=".5"/><stop offset=".716" stop-color="#734423" stop-opacity=".829"/><stop offset="1" stop-color="#824B24"/></radialGradient><radialGradient id="x" cx="0" cy="0" r="1" gradientTransform="scale(3.75793 3.71271)rotate(90 .42 4.73)" gradientUnits="userSpaceOnUse"><stop stop-color="#CFDCDE" stop-opacity="0"/><stop offset=".887" stop-color="#CFDCDE" stop-opacity=".887"/><stop offset="1" stop-color="#CFDCDE"/></radialGradient><radialGradient id="y" cx="0" cy="0" r="1" gradientTransform="matrix(-3.1903 0 0 -3.19031 19.385 15.843)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity="0"/><stop offset=".438" stop-color="#FDFEFE" stop-opacity=".35"/><stop offset=".595" stop-color="#F6F8F9" stop-opacity=".476"/><stop offset=".708" stop-color="#EBEFF0" stop-opacity=".566"/><stop offset=".798" stop-color="#DAE2E3" stop-opacity=".638"/><stop offset=".875" stop-color="#C4D1D3" stop-opacity=".7"/><stop offset=".9" stop-color="#BBCACC" stop-opacity=".72"/><stop offset="1" stop-color="#99AFB3"/></radialGradient><radialGradient id="z" cx="0" cy="0" r="1" gradientTransform="rotate(180 9.665 7.817)scale(3.24284)" gradientUnits="userSpaceOnUse"><stop offset=".883" stop-color="#643800" stop-opacity="0"/><stop offset=".916" stop-color="#3C2200" stop-opacity=".5"/><stop offset=".987" stop-color="#643800" stop-opacity="0"/></radialGradient><radialGradient id="E" cx="0" cy="0" r="1" gradientTransform="matrix(0 3.7127 -3.75794 0 10.652 15.92)" gradientUnits="userSpaceOnUse"><stop stop-color="#CFDCDE" stop-opacity="0"/><stop offset=".887" stop-color="#CFDCDE" stop-opacity=".887"/><stop offset="1" stop-color="#CFDCDE"/></radialGradient><radialGradient id="F" cx="0" cy="0" r="1" gradientTransform="rotate(180 5.343 7.882)scale(3.1903)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity="0"/><stop offset=".438" stop-color="#FDFEFE" stop-opacity=".35"/><stop offset=".595" stop-color="#F6F8F9" stop-opacity=".476"/><stop offset=".708" stop-color="#EBEFF0" stop-opacity=".566"/><stop offset=".798" stop-color="#DAE2E3" stop-opacity=".638"/><stop offset=".875" stop-color="#C4D1D3" stop-opacity=".7"/><stop offset=".9" stop-color="#BBCACC" stop-opacity=".72"/><stop offset="1" stop-color="#99AFB3"/></radialGradient><radialGradient id="G" cx="0" cy="0" r="1" gradientTransform="rotate(180 5.315 7.782)scale(3.24284)" gradientUnits="userSpaceOnUse"><stop offset=".883" stop-color="#643800" stop-opacity="0"/><stop offset=".916" stop-color="#3C2200" stop-opacity=".5"/><stop offset=".987" stop-color="#643800" stop-opacity="0"/></radialGradient><linearGradient id="a" x1="17.349" x2="13.704" y1="15.388" y2="29.705" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#906338"/><stop offset="1" stop-color="#906338"/></linearGradient><linearGradient id="c" x1="15.835" x2="17.828" y1="21.181" y2="3.396" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#976D42"/><stop offset="1" stop-color="#835129"/></linearGradient><linearGradient id="e" x1="10.254" x2="12.845" y1="12.156" y2="28.379" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#895A31"/><stop offset="1" stop-color="#976A40"/></linearGradient><linearGradient id="f" x1="16.613" x2="14.883" y1="9.227" y2="19.455" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="g" x1="7.131" x2="23.381" y1="23.813" y2="10.334" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#835129"/></linearGradient><linearGradient id="h" x1="5.754" x2=".389" y1="13.148" y2="29.35" gradientUnits="userSpaceOnUse"><stop stop-color="#643800" stop-opacity="0"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="k" x1="15.71" x2="19.488" y1="6.712" y2="2.192" gradientUnits="userSpaceOnUse"><stop offset=".31" stop-color="#7A4400"/><stop offset="1" stop-color="#A66C3F"/></linearGradient><linearGradient id="w" x1="21.414" x2="19.076" y1="30.595" y2="13.56" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="A" x1="19.352" x2="19.352" y1="15.35" y2="17.557" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1"/></linearGradient><linearGradient id="B" x1="15.004" x2="15.004" y1="24.451" y2="21.913" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#EEEEEF"/><stop offset="1" stop-color="#E2D8CC"/></linearGradient><linearGradient id="C" x1="15.002" x2="15.002" y1="23.305" y2="14.655" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#D5D5D5"/><stop offset="1"/></linearGradient><linearGradient id="D" x1="12.718" x2="10.379" y1="30.595" y2="13.56" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="H" x1="10.654" x2="10.654" y1="15.35" y2="17.557" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-portal" class="svg-sprite__symbol"><path fill="url(#a)" d="M3 9.25a.75.75 0 0 0 0 1.5zm14 1.5a.75.75 0 0 0 0-1.5zM4.75 6.582a.75.75 0 0 0 0 1.5zm10.5 1.5a.75.75 0 0 0 0-1.5zM6.5 3.918a.75.75 0 0 0 0 1.5zm7 1.5a.75.75 0 0 0 0-1.5zM8.25 1.25a.75.75 0 0 0 0 1.5zm3.5 1.5a.75.75 0 0 0 0-1.5zm3.5 10.668a.75.75 0 0 0 0-1.5zm-10.5-1.5a.75.75 0 0 0 0 1.5zm8.75 4.164a.75.75 0 0 0 0-1.5zm-7-1.5a.75.75 0 0 0 0 1.5zm5.25 4.168a.75.75 0 0 0 0-1.5zm-3.5-1.5a.75.75 0 0 0 0 1.5zM3 10.75h14v-1.5H3zm1.75-2.668h10.5v-1.5H4.75zM6.5 5.418h7v-1.5h-7zM8.25 2.75h3.5v-1.5h-3.5zm7 9.168H4.75v1.5h10.5zm-1.75 2.664h-7v1.5h7zm-1.75 2.668h-3.5v1.5h3.5z"/><defs><linearGradient id="a" x1="3" x2="17" y1="10" y2="10" gradientUnits="userSpaceOnUse"><stop stop-color="#37C0FD"/><stop offset=".718" stop-color="#825FED"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-profile" class="svg-sprite__symbol"><path fill="currentColor" d="M7.5 3.75a.75.75 0 0 0 0-1.5zm5-1.5a.75.75 0 0 0 0 1.5zM1.062 7.218l.74.117zm17.876 0 .741-.117zm-4.156-4.156.117-.741zM5.218 18.938l.117-.74zm-4.156-4.156.74-.117zm13.72 4.156.117.741zM7 19.75h6v-1.5H7zM19.75 13V9h-1.5v4zM7.5 2.25H7v1.5h.5zm5.5 0h-.5v1.5h.5zM.25 9v4h1.5V9zM7 2.25c-.9 0-1.438-.002-1.9.07l.235 1.482c.316-.05.707-.052 1.665-.052zM1.75 9c0-.958.002-1.35.052-1.665L.321 7.101C.248 7.562.25 8.1.25 9zM5.1 2.32A5.75 5.75 0 0 0 .32 7.1l1.482.235a4.25 4.25 0 0 1 3.533-3.533zM19.75 9c0-.9.002-1.438-.07-1.9l-1.482.235c.05.316.052.707.052 1.665zM13 3.75c.958 0 1.35.002 1.665.052l.235-1.481c-.462-.073-1-.071-1.9-.071zm6.68 3.35a5.75 5.75 0 0 0-4.78-4.78l-.235 1.482a4.25 4.25 0 0 1 3.533 3.533zM7 18.25c-.958 0-1.35-.002-1.665-.052l-.234 1.481c.461.073.999.071 1.899.071zM.25 13c0 .9-.002 1.438.07 1.9l1.482-.235c-.05-.316-.052-.707-.052-1.665zm5.085 5.198a4.25 4.25 0 0 1-3.533-3.533L.321 14.9a5.75 5.75 0 0 0 4.78 4.78zM13 19.75c.9 0 1.438.002 1.9-.07l-.235-1.482c-.316.05-.707.052-1.665.052zM18.25 13c0 .958-.002 1.35-.052 1.665l1.481.235c.073-.462.071-1 .071-1.9zm-3.35 6.68a5.75 5.75 0 0 0 4.78-4.78l-1.482-.235a4.25 4.25 0 0 1-3.533 3.533zM9.25 4a.75.75 0 0 0 1.5 0zm1.5-3a.75.75 0 0 0-1.5 0zm0 3V1h-1.5v3zM5 13.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5zM11 7.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4zM11 10.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-4 0h4v-1.5h-4z"/><rect width="3" height="3" x="5" y="8" stroke="currentColor" stroke-width="1.5" rx="1"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-profile-with-person" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 5v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 8h3M13 11h3"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M3 14c2.783-3.137 6.052-2.151 8 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="21" height="21" id="svg-name-qr" class="svg-sprite__symbol"><path fill="currentColor" d="M1.167 0C.523 0 0 .523 0 1.167v4.666C0 6.477.523 7 1.167 7h4.666C6.477 7 7 6.477 7 5.833V1.167C7 .523 6.477 0 5.833 0zm8.166 0v2.333h2.334V0zm5.834 0C14.523 0 14 .523 14 1.167v4.666C14 6.477 14.523 7 15.167 7h4.666C20.477 7 21 6.477 21 5.833V1.167C21 .523 20.477 0 19.833 0zM2.333 2.333h2.334v2.334H2.333zm14 0h2.334v2.334h-2.334zm-7 2.334V7h2.334V4.667zM0 9.333v2.334h2.333V9.333zm4.667 0v2.334H7V9.333zm4.666 0v2.334h2.334V9.333zm2.334 2.334V14H14v-2.333zm2.333 0h2.333V9.333H14zm2.333 0V14h2.334v-2.333zm2.334 0H21V9.333h-2.333zm0 2.333v2.333H21V14zm0 2.333h-2.334v2.334h2.334zm0 2.334V21H21v-2.333zm-2.334 0H14V21h2.333zm-2.333 0v-2.334h-2.333v2.334zm-2.333 0H9.333V21h2.334zm0-2.334V14H9.333v2.333zm2.333 0h2.333V14H14zM1.167 14C.523 14 0 14.523 0 15.167v4.666C0 20.477.523 21 1.167 21h4.666C6.477 21 7 20.477 7 19.833v-4.666C7 14.523 6.477 14 5.833 14zm1.166 2.333h2.334v2.334H2.333z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-qr-small" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M2 1.75a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5A.25.25 0 0 0 7.25 7V2A.25.25 0 0 0 7 1.75zM.25 2C.25 1.034 1.034.25 2 .25h5c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 7 8.75H2A1.75 1.75 0 0 1 .25 7zm3 2.1c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M12.75 2a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25zM13 .25A1.75 1.75 0 0 0 11.25 2v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 19.75 7V2A1.75 1.75 0 0 0 18 .25zm1.25 3.85c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M1.75 13a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25zM2 11.25A1.75 1.75 0 0 0 .25 13v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 8.75 18v-5A1.75 1.75 0 0 0 7 11.25zm1.25 3.85c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112m7.712-4.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.049.063.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112m4.75-.288c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.064.049.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112M15.1 14.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.049.063.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112M11.25 18.1c0-.47.38-.85.85-.85h.8c.47 0 .85.38.85.85v.8c0 .47-.38.85-.85.85h-.8a.85.85 0 0 1-.85-.85zm1.138.4a.7.7 0 0 1 .112-.112q.063.048.112.112a.7.7 0 0 1-.112.112.7.7 0 0 1-.112-.112m5.712-1.25a.85.85 0 0 0-.85.85v.8c0 .47.38.85.85.85h.8c.47 0 .85-.38.85-.85v-.8a.85.85 0 0 0-.85-.85zm.4 1.138a.7.7 0 0 0-.112.112q.048.064.112.112a.7.7 0 0 0 .112-.112.7.7 0 0 0-.112-.112" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-qr_code_24" class="svg-sprite__symbol"><path fill="currentColor" d="M5.665 8.666c.92 0 1.667.747 1.667 1.667V13c0 .92-.746 1.666-1.667 1.666H3c-.92 0-1.667-.746-1.667-1.666v-2.667c0-.92.746-1.667 1.667-1.667zm8.334 4c.184 0 .333.15.333.334v1c0 .184-.15.333-.333.333h-1a.333.333 0 0 1-.334-.333v-1c0-.184.15-.334.334-.334zm-3.667 0c.184 0 .333.15.333.334v1c0 .184-.149.333-.333.333h-1A.333.333 0 0 1 8.999 14v-1c0-.184.149-.334.333-.334zM5.499 9.833H3.165a.667.667 0 0 0-.666.667v2.333c0 .368.298.667.666.667H5.5a.667.667 0 0 0 .666-.667V10.5a.667.667 0 0 0-.666-.667m6.666 1c.185 0 .334.15.334.333v1c0 .184-.15.334-.334.334h-1a.333.333 0 0 1-.333-.334v-1c0-.184.15-.333.333-.333zm-7.333 0c.184 0 .333.15.333.333v1c0 .184-.149.334-.333.334h-1a.333.333 0 0 1-.333-.334v-1c0-.184.149-.333.333-.333zM13.999 9c.184 0 .333.149.333.333v1c0 .184-.15.333-.333.333h-1a.333.333 0 0 1-.334-.333v-1c0-.184.15-.333.334-.333zm-3.667 0c.184 0 .333.149.333.333v1c0 .184-.149.333-.333.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.149-.333.333-.333zm2.667-7.667c.92 0 1.666.746 1.666 1.667v2.666c0 .92-.746 1.667-1.666 1.667h-2.667c-.92 0-1.667-.746-1.667-1.667V3c0-.92.747-1.667 1.667-1.667zm-7.334 0c.92 0 1.667.746 1.667 1.667v2.666c0 .92-.746 1.667-1.667 1.667H3c-.92 0-1.667-.746-1.667-1.667V3c0-.92.746-1.667 1.667-1.667zM12.832 2.5h-2.333a.667.667 0 0 0-.667.666V5.5c0 .368.298.666.667.666h2.333a.667.667 0 0 0 .667-.666V3.166a.667.667 0 0 0-.667-.666m-7.333 0H3.165a.667.667 0 0 0-.666.666V5.5c0 .368.298.666.666.666H5.5a.667.667 0 0 0 .666-.666V3.166A.667.667 0 0 0 5.5 2.5m6.666 1c.185 0 .334.149.334.333v1c0 .184-.15.333-.334.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.15-.333.333-.333zm-7.333 0c.184 0 .333.149.333.333v1c0 .184-.149.333-.333.333h-1a.333.333 0 0 1-.333-.333v-1c0-.184.149-.333.333-.333z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-qr_code_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9.346 15c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078C3.132 23.078 3 22.617 3 21.346v-2.692c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381zm14.192 7c.335 0 .456.035.578.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm-6.5 0c.335 0 .456.035.578.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zM9.52 17H6.654c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 21.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253v-2.692c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143M8.29 18.75c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.577-.1zm12 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm-3.25-3.25c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zm6.5 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1zM9.346 3c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078C3.132 11.078 3 10.617 3 9.346V6.654c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077C4.922 3.132 5.383 3 6.654 3zm12 0c1.27 0 1.732.132 2.196.38a2.6 2.6 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.6 2.6 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381h-2.692c-1.27 0-1.732-.132-2.196-.38a2.6 2.6 0 0 1-1.077-1.078c-.249-.464-.381-.925-.381-2.196V6.654c0-1.27.132-1.732.38-2.196a2.6 2.6 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381zM9.52 5H6.654c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 9.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143m12 0h-2.866c-.857 0-1.054.038-1.253.144a.6.6 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L17 9.346c0 .857.038 1.054.144 1.253a.6.6 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.6.6 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.6.6 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143M8.29 6.75c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.7.7 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.7.7 0 0 1 .284-.284c.122-.065.243-.1.577-.1zm12 0c.334 0 .455.035.577.1a.7.7 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.7.7 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.7.7 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.7.7 0 0 1 .284-.284c.122-.065.243-.1.578-.1z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-radiowaves_left_and_right_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M7.491 5.697a1 1 0 0 1-.033 1.414l-.033.031-.02.02A9.47 9.47 0 0 0 4.5 14a9.47 9.47 0 0 0 2.935 6.866 1 1 0 0 1-1.383 1.445A11.47 11.47 0 0 1 2.5 14c0-3.163 1.284-6.124 3.516-8.277l.026-.025.035-.034a1 1 0 0 1 1.414.033m13.018 0a1 1 0 0 1 1.45.001l.026.025A11.47 11.47 0 0 1 25.5 14c0 3.18-1.299 6.156-3.552 8.311a1 1 0 0 1-1.383-1.445A9.47 9.47 0 0 0 23.5 14a9.47 9.47 0 0 0-2.904-6.838l-.021-.02-.033-.03a1 1 0 0 1-.033-1.415m-9.671 3.397a1 1 0 0 1-.057 1.413A4.73 4.73 0 0 0 9.25 14c0 1.345.56 2.597 1.53 3.492a1 1 0 1 1-1.356 1.47A6.73 6.73 0 0 1 7.25 14c0-1.91.799-3.694 2.175-4.963a1 1 0 0 1 1.413.057m6.324 0a1 1 0 0 1 1.413-.057A6.73 6.73 0 0 1 20.75 14c0 1.909-.798 3.692-2.174 4.961a1 1 0 1 1-1.356-1.47A4.73 4.73 0 0 0 18.75 14c0-1.346-.56-2.599-1.53-3.493a1 1 0 0 1-.058-1.413M14 11.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" id="svg-name-raid" class="svg-sprite__symbol"><path fill="currentColor" d="M35.358 17.317a.4.4 0 0 0 .083-.258 1 1 0 0 0 0-.159 17.5 17.5 0 0 0-34.917 0q.016.16.042.317a1 1 0 0 0 .058.1.8.8 0 0 0 .109.175l16.666 17.725h.05q.084.075.184.125h.083a.76.76 0 0 0 .6 0h.075a.8.8 0 0 0 .183-.125h.05l16.667-17.725a1 1 0 0 0 .067-.175M17.999 2.167c2.167 0 4.567 4.525 4.825 11.15A6.82 6.82 0 0 0 18 11.592a6.83 6.83 0 0 0-4.8 1.667C13.6 7.8 16.224 2.167 18 2.167Zm4.734 14.892-4.734 14.866-4.733-14.866c.067-2.8 2.575-3.8 4.733-3.8 2.159 0 4.667 1 4.734 3.8m-11.142.108a1 1 0 0 0 0 .125 1 1 0 0 0 0 .125L16.05 31.41 2.3 16.709a4.71 4.71 0 0 1 4.542-3.45c2.192 0 4.75 1.025 4.75 3.908Zm12.775.25a1 1 0 0 0 0-.133 1 1 0 0 0 0-.125c0-2.883 2.558-3.908 4.75-3.908a4.716 4.716 0 0 1 4.542 3.45l-13.75 14.708zM33 12.842a6.4 6.4 0 0 0-3.808-1.25 6.95 6.95 0 0 0-4.667 1.567c-.191-4.542-1.358-8.383-3.058-10.6A15.88 15.88 0 0 1 33 12.842M14.966 2.476c-1.858 2.5-3.142 6.983-3.425 10.708a6.93 6.93 0 0 0-4.7-1.592A6.4 6.4 0 0 0 3 12.842 15.88 15.88 0 0 1 14.966 2.476"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-reaction" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.964 3.418H15.2M12.582.8v5.236"/><path fill="currentColor" d="M13.182 9.31a.6.6 0 0 0-1.2 0zM6.69 4.017a.6.6 0 0 0 0-1.2zm5.29 5.291a5.29 5.29 0 0 1-5.29 5.291v1.2a6.49 6.49 0 0 0 6.49-6.49zM6.692 14.6a5.29 5.29 0 0 1-5.29-5.29H.2a6.49 6.49 0 0 0 6.491 6.49zm-5.29-5.29a5.29 5.29 0 0 1 5.29-5.292v-1.2A6.49 6.49 0 0 0 .2 9.31z"/><path fill="currentColor" d="M3.934 10.312a.6.6 0 1 0-1.032.613zm6.545.613a.6.6 0 0 0-1.031-.613zm-3.788 1.057c-1.125 0-2.146-.642-2.757-1.67l-1.032.613c.796 1.339 2.182 2.257 3.789 2.257zm2.757-1.67c-.611 1.028-1.632 1.67-2.757 1.67v1.2c1.607 0 2.993-.918 3.788-2.257zM5.382 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0M9.31 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-recent_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M18.5 10a8.5 8.5 0 1 0-17 0 8.5 8.5 0 0 0 17 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.75 6a.75.75 0 0 1 .75.75v3.287l3.085 1.542a.75.75 0 1 1-.67 1.342l-3.5-1.75A.75.75 0 0 1 9 10.5V6.75A.75.75 0 0 1 9.75 6" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-replay_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.636 6.706a.75.75 0 1 1-1.06 1.061l-2.14-2.139-.01-.01a3 3 0 0 1-.173-.183 1.1 1.1 0 0 1-.208-.362 1.06 1.06 0 0 1 0-.656c.054-.168.144-.287.208-.363.055-.064.12-.13.173-.182l.01-.01 2.14-2.14a.75.75 0 0 1 1.06 1.061l-1.224 1.224a7 7 0 1 1-7.407 6.725.75.75 0 1 1 1.499.056 5.5 5.5 0 1 0 5.938-5.275z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-reply" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.8 5.6 2.8-2.8M2.8 5.6l2.8 2.8M2.8 5.6h4.4a4 4 0 0 1 4 4v1.6"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-reset" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 10a8 8 0 1 1-2.708-6"/><path fill="currentColor" d="M16.75 2a.75.75 0 0 0-1.5 0zM16 5v.75a.75.75 0 0 0 .75-.75zm-3-.75a.75.75 0 0 0 0 1.5zM15.25 2v3h1.5V2zM16 4.25h-3v1.5h3z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-restore" class="svg-sprite__symbol"><path fill="currentColor" d="M9 2.75a.75.75 0 0 0 0-1.5zM18.75 11a.75.75 0 0 0-1.5 0zM15 17.25H5v1.5h10zM2.75 15V5h-1.5v10zM5 2.75h4v-1.5H5zM17.25 11v4h1.5v-4zM5 17.25A2.25 2.25 0 0 1 2.75 15h-1.5A3.75 3.75 0 0 0 5 18.75zm10 1.5A3.75 3.75 0 0 0 18.75 15h-1.5A2.25 2.25 0 0 1 15 17.25zM2.75 5A2.25 2.25 0 0 1 5 2.75v-1.5A3.75 3.75 0 0 0 1.25 5zM18 2h.75a.75.75 0 0 0-.75-.75zm-5-.75a.75.75 0 0 0 0 1.5zM17.25 7a.75.75 0 0 0 1.5 0zM9.47 9.47a.75.75 0 1 0 1.06 1.06zM18 1.25h-5v1.5h5zm-.75.75v5h1.5V2zm.22-.53-8 8 1.06 1.06 8-8z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-revoke-role" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.92 12.204-1.849-1.967m1.85 1.967 1.961-1.844m-1.962 1.844-1.961 1.844m1.961-1.844 1.918 2.04"/><path fill="currentColor" fill-rule="evenodd" d="M4.297 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.004.008c.012.015.053.052.138.052h15.59c.085 0 .126-.037.138-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.456-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.305.411-.8.658-1.342.658H2.205c-.54 0-1.036-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.495.737-5.703 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" id="svg-name-role" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.024" opacity=".5"><path d="M6.146 15.022h4.097c3.415 0 4.78-1.366 4.78-4.78V6.143c0-3.415-1.365-4.78-4.78-4.78H6.146c-3.415 0-4.78 1.365-4.78 4.78v4.097c0 3.415 1.365 4.78 4.78 4.78"/><path stroke-miterlimit="10" d="M4.781 5.637a1.764 1.764 0 0 0 2.486 0M9.123 5.637a1.764 1.764 0 0 0 2.486 0M5.736 8.875h4.917c.341 0 .614.273.614.615 0 1.7-1.372 3.073-3.073 3.073A3.07 3.07 0 0 1 5.121 9.49c0-.342.273-.615.615-.615"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-admin" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="18" height="18" fill="#07F" rx="2"/></g><g fill="#fff" clip-path="url(#b)"><path d="m10.742 15.998 3.761-3.108-.213-4.902c-.107-2.236-1.837-4.078-4.118-4.539.178.773.303 1.678.303 2.648 0 1.2-.196 2.286-.428 3.158h2.71l-.535 2.089-1.48 1.118zM7.172 16.001v-3.536l-1.39-1.118-.446-2.09h2.62A12.4 12.4 0 0 1 7.53 6.1c0-.97.125-1.858.303-2.631-2.246.493-3.958 2.302-4.065 4.523l-.267 4.9z"/><path d="M7.172 6.1c0 2.78 1.836 4.767 1.836 4.767S10.844 8.88 10.844 6.1c0-2.779-1.836-4.1-1.836-4.1S7.172 3.321 7.172 6.1"/></g><defs><clipPath id="a"><rect width="18" height="18" fill="#fff" rx="2"/></clipPath><clipPath id="b"><path fill="#fff" d="M3 1h12v15H3z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-chat-moderator" class="svg-sprite__symbol"><rect width="18" height="18" fill="#59A840" rx="2"/><path fill="#F1F1F1" d="m14.158 3.817-5-1.79a.47.47 0 0 0-.316 0l-5 1.79a.5.5 0 0 0-.25.198.55.55 0 0 0-.092.311v5.883c-.003.341.066.68.204.99 1.422 3.117 5.135 4.774 5.135 4.774A.6.6 0 0 0 9 16h.172a.5.5 0 0 0 .156-.027s3.605-1.661 4.98-4.786c.13-.303.195-.631.192-.963V4.326a.55.55 0 0 0-.093-.311.5.5 0 0 0-.249-.198"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-role-moderator" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="18" height="18" fill="#59A840" rx="2"/><path fill="#fff" d="m15.423 2.254-1.811.303a4.35 4.35 0 0 0-2.61 1.482l-4.36 5.153-.165-.166a.873.873 0 0 0-1.232 0l-.678.677a.283.283 0 0 0 0 .4l.92.917-1.85 1.85a1.44 1.44 0 0 0-.965.416 1.441 1.441 0 0 0 1.02 2.464c.372 0 .74-.14 1.022-.422.267-.267.402-.616.416-.964l1.85-1.851.872.875a.29.29 0 0 0 .2.084.28.28 0 0 0 .2-.084l.677-.678a.86.86 0 0 0 .256-.616c0-.233-.09-.45-.256-.616l-.12-.12 5.152-4.36a4.35 4.35 0 0 0 1.482-2.61l.303-1.811a.282.282 0 0 0-.323-.323"/></g><defs><clipPath id="a"><rect width="18" height="18" fill="#fff" rx="2"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-roles" class="svg-sprite__symbol"><path fill="currentColor" d="M9.632 9.314c-.347.179-.841.434-1.632.434-.792 0-1.286-.255-1.633-.434-.318-.164-.513-.265-.699-.044-.388.46.389 2.3 2.332 2.3s2.72-1.84 2.331-2.3c-.186-.22-.38-.12-.699.044M5.722 5.149c.67.057 1.176.5 1.132.99s-.622.84-1.29.783c-.67-.057-1.177-.5-1.133-.99s.622-.84 1.291-.783M11.569 5.932c-.044-.49-.623-.84-1.292-.783s-1.176.5-1.132.99.622.84 1.291.783c.67-.057 1.176-.5 1.133-.99"/><path fill="currentColor" fill-rule="evenodd" d="M14.745 1.044c1.686 1.743 1.264 6.535 0 9.585S10.95 15.857 8 15.857s-5.48-2.178-6.745-5.228-1.686-7.842 0-9.585C2.365-.102 3.474.077 5.063.334 5.89.467 6.846.622 8 .622s2.11-.155 2.936-.288c1.59-.257 2.7-.436 3.809.71m-1.027.994c.181.187.383.544.527 1.143.14.587.202 1.312.178 2.124-.047 1.63-.434 3.418-.998 4.777-1.123 2.707-3.234 4.346-5.425 4.346s-4.303-1.64-5.426-4.346c-.563-1.359-.95-3.148-.998-4.777-.024-.812.038-1.537.179-2.124.143-.599.345-.956.526-1.143.264-.273.466-.37.638-.416.2-.054.472-.07.925-.022.215.023.496.068.826.12.86.138 2.059.33 3.33.33s2.469-.192 3.329-.33c.33-.052.611-.097.827-.12.453-.048.724-.032.924.022.172.046.374.143.638.416" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-rss" class="svg-sprite__symbol"><circle cx="3" cy="17" r="2.25" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M1.032 8.25a.75.75 0 1 0-.064 1.5zm9.219 10.782a.75.75 0 1 0 1.498-.064zM.968 9.75a9.715 9.715 0 0 1 9.283 9.283l1.498-.064C11.501 13.16 6.84 8.499 1.032 8.25z"/><path fill="currentColor" d="M1.095 1.256a.75.75 0 1 0-.19 1.488zm16.161 17.84a.75.75 0 1 0 1.488-.191zM.905 2.743c8.514 1.09 15.261 7.837 16.351 16.351l1.488-.19C17.568 9.713 10.287 2.432 1.095 1.256z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6" id="svg-name-ru" class="svg-sprite__symbol"><path fill="#fff" d="M0 0h9v3H0z"/><path fill="#d52b1e" d="M0 3h9v3H0z"/><path fill="#0039a6" d="M0 2h9v2H0z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-sad-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#d)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#e)" d="M7.27 5.19c-.02-.385-.38-.605-.975-.575-.505.03-1.6.425-2.3 1.645-.13.225.095.335.225.185.445-.505 1.67-1.19 2.66-1.115.4.03.39-.14.39-.14"/><path fill="url(#f)" d="M6.39 9.34c.425 0 .77-.522.77-1.165S6.815 7.01 6.39 7.01s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#g)" d="M6.39 7.405c.33 0 .62.29.77.715-.01-.63-.35-1.135-.77-1.135s-.76.505-.77 1.135c.15-.425.435-.715.77-.715"/><path fill="url(#h)" d="M11.61 9.34c.425 0 .77-.522.77-1.165s-.345-1.165-.77-1.165-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#i)" d="M10.73 5.22c.02-.385.38-.605.975-.575.505.03 1.6.425 2.3 1.645.13.225-.095.335-.225.185-.445-.505-1.67-1.19-2.66-1.115-.4.03-.39-.14-.39-.14"/><path fill="url(#j)" d="M11.61 7.435c-.33 0-.62.29-.77.715.01-.63.35-1.135.77-1.135s.76.505.77 1.135c-.15-.425-.435-.715-.77-.715"/><path fill="#643800" d="M9 11.96c2.345 0 3.1 2.32 2.38 1.955-.96-.485-1.565-.535-2.38-.535s-1.425.045-2.38.535c-.72.365.035-1.955 2.38-1.955"/><path fill="url(#k)" d="M9 12.37c1.385 0 2.26.78 2.64 1.43.02-.47-.84-1.84-2.64-1.84-1.805 0-2.665 1.37-2.64 1.84.38-.645 1.255-1.43 2.64-1.43"/><path fill="url(#l)" d="M5.86 13.115c.475 1.19-.355 2.27-1.33 2.45s-2.04-.47-2.115-1.69C2.25 11.09 5.47 9.39 5.47 9.39s-.25 2.12.39 3.725"/><path fill="url(#m)" d="M4.56 13.33c-.385 1.2-2.18 1.275-2.12-.11-.03.21-.035.43-.025.655.07 1.22 1.14 1.87 2.115 1.69s1.805-1.26 1.33-2.45c-.64-1.605-.385-3.725-.385-3.725-1.16 2.51-.725 3.35-.915 3.94"/><path fill="url(#n)" d="M5.255 12.44c.37 2.07-1.96 2.89-2.8 1.72a1.77 1.77 0 0 0 2.075 1.405c.975-.18 1.805-1.26 1.33-2.45-.64-1.605-.385-3.725-.385-3.725s-.525 1.355-.22 3.05"/><path fill="url(#o)" d="M5.345 13.685c-.375 1.555-2.08 1.53-2.815.76.155.425.455.745.815.94 1.895.59 2.8-1.36 2.535-2.2-.01-.02-.015-.045-.025-.065-.01-.03-.025-.06-.035-.09-.595-1.59-.35-3.635-.35-3.635-.6 2.315.335 2.39-.125 4.29"/><path fill="url(#p)" d="M5.86 13.115c.475 1.19-.355 2.27-1.33 2.45s-2.04-.47-2.115-1.69C2.25 11.09 5.47 9.39 5.47 9.39s-.25 2.12.39 3.725"/><defs><linearGradient id="e" x1="5.62" x2="5.565" y1="5.925" y2="4.915" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="g" x1="6.388" x2="6.388" y1="7.005" y2="8.091" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="i" x1="12.38" x2="12.435" y1="5.954" y2="4.944" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="j" x1="11.612" x2="11.612" y1="7.034" y2="8.12" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="k" x1="9" x2="9" y1="11.355" y2="13.206" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="l" x1="1.435" x2="6.829" y1="10.978" y2="13.537" gradientUnits="userSpaceOnUse"><stop offset=".072" stop-color="#17BBFE"/><stop offset=".208" stop-color="#D1F2FF"/><stop offset=".668" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="m" x1="8.504" x2="1.068" y1="15.152" y2="10.14" gradientUnits="userSpaceOnUse"><stop stop-color="#D1F2FF"/><stop offset=".668" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="n" x1="2.152" x2="7.11" y1="9.805" y2="15.676" gradientUnits="userSpaceOnUse"><stop offset=".566" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><linearGradient id="o" x1="2.56" x2="6.521" y1="10.028" y2="15.368" gradientUnits="userSpaceOnUse"><stop offset=".566" stop-color="#80DAFE"/><stop offset="1" stop-color="#0099D6"/></linearGradient><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.426 5.758)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(72.692 -5.943 10.313)scale(7.22705 3.88715)" gradientUnits="userSpaceOnUse"><stop stop-color="#EB672A" stop-opacity=".5"/><stop offset=".346" stop-color="#DC641B" stop-opacity=".285"/><stop offset=".804" stop-color="#C25E00" stop-opacity="0"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -2.382 8.197)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="h" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .23 11.673)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="p" cx="0" cy="0" r="1" gradientTransform="rotate(-76.619 9.843 3.836)scale(2.51225 1.47918)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff" stop-opacity=".45"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-safety" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M18 3.562v11.052a2 2 0 0 1-1.298 1.873l-6 2.25a2 2 0 0 1-1.404 0l-6-2.25A2 2 0 0 1 2 14.614V3.562c0-.918.624-1.716 1.526-1.888C5.053 1.382 7.526 1 10 1c2.473 0 4.947.382 6.474.674.902.172 1.526.97 1.526 1.888Z"/><path fill="currentColor" d="M7.294 10.81a.75.75 0 1 0-.588 1.38zM10.525 13l-.294.69a.75.75 0 0 0 .987-.404zm3.168-5.714a.75.75 0 1 0-1.386-.572zM6.706 12.19l3.525 1.5.588-1.38-3.525-1.5zm4.512 1.096 2.475-6-1.386-.572-2.475 6z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-safety-filled" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15 11.955v-9.51c0-.916-.621-1.712-1.52-1.881C12.133.31 10.067 0 8 0S3.867.31 2.52.564C1.621.734 1 1.529 1 2.444v9.511a2 2 0 0 0 1.288 1.869l5 1.905a2 2 0 0 0 1.424 0l5-1.905A2 2 0 0 0 15 11.955m-3.076-6.574a1 1 0 1 0-1.848-.762l-2.09 5.065L5.392 8.58a1 1 0 1 0-.784 1.84l3.525 1.5a1 1 0 0 0 1.316-.539z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-search" class="svg-sprite__symbol"><circle cx="8.5" cy="8.5" r="7.5" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M18.47 19.53a.75.75 0 1 0 1.06-1.06zm-5.5-5.5 5.5 5.5 1.06-1.06-5.5-5.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-search-thick" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13.334 15.7a8.52 8.52 0 0 1-4.762 1.446C3.842 17.146 0 13.305 0 8.573S3.841 0 8.572 0c4.732 0 8.573 3.842 8.573 8.573a8.53 8.53 0 0 1-1.446 4.762l3.811 3.81a1.674 1.674 0 0 1-2.365 2.365zM8.572 3.027a5.55 5.55 0 0 1 5.546 5.546 5.55 5.55 0 0 1-5.546 5.546 5.55 5.55 0 0 1-5.546-5.546 5.55 5.55 0 0 1 5.546-5.546" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-search_24" class="svg-sprite__symbol"><path fill="currentColor" d="M7.75.5a7.25 7.25 0 0 1 5.785 11.62l4.172 4.173a1 1 0 0 1-1.414 1.414l-4.173-4.172A7.25 7.25 0 1 1 7.75.5m0 2a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-search_outline_16" class="svg-sprite__symbol"><path fill="currentColor" d="M6.5 1a5.5 5.5 0 0 1 4.384 8.823l3.895 3.9a.75.75 0 0 1-1.061 1.06l-3.895-3.9A5.5 5.5 0 1 1 6.5 1m0 1.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-search_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13 4a9 9 0 1 0 5.618 16.032l4.675 4.675a1 1 0 0 0 1.414-1.414l-4.675-4.675A9 9 0 0 0 13 4m0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-0" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#535B63" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-1" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-4" x2="17.07" y1="-3.5" y2="-1.232" gradientUnits="userSpaceOnUse"><stop offset=".136" stop-color="#9CF6A6"/><stop offset=".847" stop-color="#47B143"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-2" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-4.5" x2="19.524" y1="-3.5" y2="-1.823" gradientUnits="userSpaceOnUse"><stop offset=".105" stop-color="#00FDF4"/><stop offset=".847" stop-color="#05B9B9"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-3" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-7.92" x2="22.4" y1="-10.385" y2="-5.713" gradientUnits="userSpaceOnUse"><stop stop-color="#41C7F1"/><stop offset=".176" stop-color="#41C7F1"/><stop offset=".847" stop-color="#07F"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-4" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-3.96" x2="21.566" y1="-5.019" y2="-1.175" gradientUnits="userSpaceOnUse"><stop stop-color="#55A5FF"/><stop offset=".847" stop-color="#BE35FF"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-5" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="-3" x2="19.623" y1="-6.5" y2="-3.084" gradientUnits="userSpaceOnUse"><stop stop-color="#C446FF"/><stop offset=".847" stop-color="#FF8A00"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-season-tick-6" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="url(#b)" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="currentColor" d="M12.768 7.283 8.696 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53"/></g><defs><linearGradient id="b" x1="0" x2="20.088" y1="1.731" y2="3.842" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8B4E"/><stop offset=".847" stop-color="#FF1000"/></linearGradient><clipPath id="a"><path fill="currentColor" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-select-item" class="svg-sprite__symbol"><rect width="19" height="19" x=".5" y=".5" stroke="currentColor" rx="9.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-select-item-checked" class="svg-sprite__symbol"><rect width="15" height="15" x="2.5" y="2.5" stroke="currentColor" stroke-width="5" rx="7.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-send" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 12 3 22v-8l6-2-6-2V2z" opacity=".3"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-send_24" class="svg-sprite__symbol"><path fill="currentColor" d="M4.783 13.128q-.856 2.318-1.077 3.258c-.461 1.968-.797 2.412.922 1.476s10.039-5.57 11.895-6.6c2.42-1.342 2.452-1.237-.13-2.662C14.427 7.514 6.204 3 4.628 2.115c-1.576-.887-1.383-.493-.922 1.476q.223.951 1.093 3.287a3.33 3.33 0 0 0 2.49 2.11l4.803.93a.083.083 0 0 1 0 .163l-4.814.93a3.33 3.33 0 0 0-2.495 2.117"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-services_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9.116 15c1.065 0 1.623.108 2.204.419.541.29.972.72 1.261 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42H6.884c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26C3.108 22.739 3 22.18 3 21.116v-2.231c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261.582-.311 1.14-.419 2.205-.419zm12 0c1.065 0 1.623.108 2.205.419.54.29.971.72 1.26 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42h-2.232c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26-.311-.582-.419-1.14-.419-2.205v-2.231c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261.582-.311 1.14-.419 2.205-.419zm-12 2H6.884c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44c-.135.252-.183.498-.183 1.262v2.23c0 .764.048 1.01.182 1.263q.153.287.44.44c.253.135.499.182 1.262.182h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.253.183-.499.183-1.262v-2.231c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44c-.253-.135-.499-.183-1.262-.183m12 0h-2.232c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44c-.135.252-.183.498-.183 1.262v2.23c0 .764.048 1.01.182 1.263q.153.287.44.44c.253.135.499.182 1.262.182h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.253.183-.499.183-1.262v-2.231c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44c-.253-.135-.499-.183-1.262-.183m-.224-14.587c.63.191 1.101.51 1.855 1.263l1.577 1.578c.754.753 1.072 1.224 1.263 1.855a3.04 3.04 0 0 1 0 1.783c-.19.63-.51 1.102-1.263 1.855l-1.577 1.578c-.754.753-1.225 1.071-1.855 1.263a3.04 3.04 0 0 1-1.783 0c-.631-.192-1.102-.51-1.856-1.263l-1.577-1.578c-.754-.753-1.072-1.224-1.263-1.855a3.04 3.04 0 0 1 0-1.783c.19-.631.51-1.102 1.263-1.855l1.577-1.578c.754-.754 1.225-1.072 1.855-1.263a3.04 3.04 0 0 1 1.784 0M9.116 3c1.065 0 1.623.108 2.204.419.541.29.972.72 1.261 1.26.311.582.419 1.14.419 2.206v2.23c0 1.066-.108 1.624-.419 2.206-.289.54-.72.971-1.26 1.26-.582.311-1.14.42-2.205.42H6.884c-1.065 0-1.623-.109-2.205-.42-.54-.289-.971-.72-1.26-1.26C3.108 10.739 3 10.18 3 9.116V6.885c0-1.066.108-1.624.419-2.205.289-.541.72-.972 1.26-1.261C5.261 3.108 5.82 3 6.884 3zm10.573 1.327c-.274.083-.482.223-1.021.763L17.09 6.668c-.54.54-.68.747-.763 1.02a1.05 1.05 0 0 0 0 .624c.082.273.223.48.763 1.02l1.578 1.578c.54.54.747.68 1.02.764.21.063.415.063.623 0 .274-.083.482-.224 1.021-.764l1.578-1.577c.54-.54.68-.748.763-1.021a1.05 1.05 0 0 0 0-.623c-.082-.274-.223-.481-.763-1.021L21.332 5.09c-.54-.54-.747-.68-1.02-.763a1.05 1.05 0 0 0-.623 0M9.116 5H6.884c-.763 0-1.01.048-1.261.183a1.05 1.05 0 0 0-.44.44C5.047 5.875 5 6.12 5 6.885v2.23c0 .764.048 1.01.182 1.262q.153.288.44.44c.253.136.499.183 1.262.183h2.232c.763 0 1.01-.047 1.261-.182q.288-.153.44-.44c.135-.252.183-.499.183-1.262V6.885c0-.764-.048-1.01-.182-1.262a1.05 1.05 0 0 0-.44-.44C10.124 5.048 9.878 5 9.115 5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-settings" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="m19.251 9.707-.505-1.225s1.175-2.708 1.071-2.812l-1.555-1.55c-.108-.107-2.759 1.128-2.759 1.128l-1.223-.504S13.2 2 13.052 2h-2.195c-.153 0-1.152 2.75-1.152 2.75l-1.221.506s-2.707-1.175-2.81-1.07L4.12 5.738c-.108.107 1.128 2.76 1.128 2.76L4.744 9.72S2 10.801 2 10.946v2.198c0 .153 2.75 1.153 2.75 1.153l.505 1.221s-1.174 2.706-1.071 2.81l1.554 1.554c.106.105 2.758-1.13 2.758-1.13l1.224.506S10.8 22 10.949 22h2.195c.152 0 1.152-2.75 1.152-2.75l1.225-.506s2.701 1.175 2.806 1.072l1.554-1.553c.109-.108-1.13-2.759-1.13-2.759l.504-1.223S22 13.199 22 13.05v-2.194c0-.153-2.749-1.15-2.749-1.15m-3.099 2.37c0 2.233-1.778 4.05-3.963 4.05-2.182 0-3.962-1.817-3.962-4.05 0-2.231 1.78-4.046 3.963-4.046 2.185.001 3.962 1.815 3.962 4.047" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-settings_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M15.148 2.04c.428.07.832.233 1.195.523.595.476.878 1.076 1.097 1.952.056.224.153.486.275.74q.417.176.815.393c.262-.065.513-.15.714-.244 1.412-.658 2.597-.623 3.567.423.082.089.131.148.238.28l.629.776c.17.21.241.305.348.482.692 1.152.422 2.224-.452 3.386a4 4 0 0 0-.417.71q.117.425.195.86c.223.178.46.334.668.441.805.41 1.325.822 1.655 1.508.202.42.27.85.24 1.282-.015.229-.04.356-.105.64l-.226.975c-.065.285-.099.41-.185.622a2.5 2.5 0 0 1-.778 1.047c-.598.473-1.246.614-2.148.63a4 4 0 0 0-.773.1q-.265.365-.563.704c.003.275.03.544.077.764.187.884.196 1.547-.13 2.236-.2.42-.491.744-.845.993a3.5 3.5 0 0 1-.565.32l-.899.44c-.263.127-.381.18-.6.247-.414.125-.85.156-1.303.054-.744-.167-1.261-.582-1.842-1.273a4 4 0 0 0-.591-.561 10 10 0 0 1-.877 0c-.229.18-.438.378-.592.56-.58.692-1.098 1.107-1.842 1.274a2.5 2.5 0 0 1-1.303-.054 3.5 3.5 0 0 1-.6-.248l-.899-.438-.185-.093c-1.312-.683-1.696-1.847-1.355-3.457.047-.22.074-.49.077-.764a10 10 0 0 1-.563-.705 4 4 0 0 0-.772-.099c-.903-.016-1.551-.157-2.149-.63a2.5 2.5 0 0 1-.778-1.047 3.5 3.5 0 0 1-.185-.622l-.225-.974a3.4 3.4 0 0 1-.109-.681 2.5 2.5 0 0 1 .296-1.346c.339-.629.84-1.015 1.602-1.404.209-.107.446-.263.668-.441q.078-.435.195-.86a4 4 0 0 0-.417-.71c-.874-1.162-1.144-2.234-.452-3.386.107-.177.179-.273.348-.482l.63-.777c.106-.131.155-.19.237-.279.97-1.046 2.155-1.08 3.567-.423.201.093.452.18.714.244q.398-.216.816-.394c.12-.253.218-.515.274-.74.219-.875.502-1.475 1.097-1.95.363-.291.768-.455 1.195-.523.18-.03.3-.038.49-.04L14.5 2c.293 0 .422.005.648.04M14.586 4H13.5c-.5 0-.75 0-1 1a6.4 6.4 0 0 1-.836 1.87 7.5 7.5 0 0 0-1.8.872 6.4 6.4 0 0 1-1.952-.525c-.934-.435-1.092-.24-1.406.148l-.63.777c-.314.389-.472.583.148 1.406.35.464.721 1.15.937 1.857a7.5 7.5 0 0 0-.429 1.894 6.4 6.4 0 0 1-1.643 1.245c-.918.468-.862.712-.75 1.199l.225.974c.113.487.17.731 1.2.75.57.01 1.323.135 2.003.39.345.575.765 1.1 1.247 1.56a6.4 6.4 0 0 1-.072 2.032c-.213 1.008.011 1.118.46 1.337l.9.438c.45.22.674.33 1.337-.46a6.4 6.4 0 0 1 1.59-1.326 7.6 7.6 0 0 0 1.942 0 6.4 6.4 0 0 1 1.59 1.326c.663.79.888.68 1.337.46l.9-.438c.449-.219.673-.329.46-1.337a6.4 6.4 0 0 1-.072-2.031 7.5 7.5 0 0 0 1.248-1.56 6.4 6.4 0 0 1 2.002-.391c1.031-.019 1.087-.263 1.2-.75l.225-.974c.112-.487.168-.73-.75-1.2a6.4 6.4 0 0 1-1.643-1.244 7.5 7.5 0 0 0-.43-1.894 6.3 6.3 0 0 1 .938-1.857c.62-.823.462-1.017.148-1.406l-.63-.777c-.314-.389-.472-.583-1.406-.148a6.4 6.4 0 0 1-1.952.525 7.5 7.5 0 0 0-1.8-.871A6.4 6.4 0 0 1 15.5 5c-.235-.941-.47-.997-.914-1M14 9.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="svg-name-share" class="svg-sprite__symbol"><circle cx="19" cy="4" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle cx="19" cy="20" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle cx="5" cy="12" r="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 10.857 10.055-5.745M7 13.142l9.85 5.63"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-share_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M11.998 3.725a2.15 2.15 0 0 0-1.996 2.145L10 7.987l-.02.005a9.904 9.904 0 0 0-7.827 10.72c.083.812 1.116 1.103 1.61.455l.187-.236a9.08 9.08 0 0 1 5.836-3.265l.214-.026v2.494a2.15 2.15 0 0 0 3.477 1.692l7.824-6.132a2.15 2.15 0 0 0 0-3.384l-7.824-6.132a2.15 2.15 0 0 0-1.326-.458zm.154 1.795a.35.35 0 0 1 .216.074l7.823 6.132a.35.35 0 0 1 0 .551l-7.823 6.132a.35.35 0 0 1-.566-.275l-.001-3.447a.9.9 0 0 0-.915-.9l-.233.004-.343.016a10.9 10.9 0 0 0-6.118 2.366l-.174.144.023-.136a8.1 8.1 0 0 1 6.969-6.536.9.9 0 0 0 .79-.893l.002-2.882a.35.35 0 0 1 .35-.35"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-share_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.627 4.652c0-.316.346-.465.569-.29l6.809 5.345a.37.37 0 0 1 0 .58l-6.81 5.346a.354.354 0 0 1-.568-.29v-3.204a.714.714 0 0 0-.715-.714c-2.546 0-4.465 1.035-5.899 2.334.258-1.544.823-2.72 1.589-3.604 1.07-1.237 2.597-1.986 4.442-2.333a.714.714 0 0 0 .583-.701zm1.451-1.413c-1.181-.928-2.88-.067-2.88 1.413v1.89c-1.832.436-3.467 1.28-4.677 2.679-1.34 1.55-2.091 3.703-2.091 6.53a.714.714 0 0 0 1.277.44c1.243-1.59 2.982-3.066 5.49-3.304v2.456c0 1.48 1.7 2.34 2.881 1.413l6.809-5.346a1.8 1.8 0 0 0 0-2.826z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-shield_keyhole_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16.5 12.5A2.5 2.5 0 0 1 15 14.79V17a1 1 0 1 1-2 0v-2.208a2.5 2.5 0 1 1 3.5-2.292"/><path fill="currentColor" fill-rule="evenodd" d="M14.594 2.044a4 4 0 0 0-1.187 0c-.446.067-.868.233-1.427.451L5.654 4.967l-.078.03c-.281.108-.635.245-.912.494a2 2 0 0 0-.536.784c-.13.348-.129.728-.128 1.03v8.694c0 2.647 1.346 7.118 7.65 10.332l.061.03c.523.267.928.474 1.499.58a4.5 4.5 0 0 0 1.524-.012c.57-.115.99-.338 1.533-.626l.068-.037C19.393 24.646 24 21.51 24 16V7.303c.002-.302.003-.682-.127-1.03a2 2 0 0 0-.536-.784c-.277-.249-.631-.386-.913-.494l-.078-.03-6.325-2.47c-.559-.219-.981-.384-1.427-.45m-.89 1.978a2 2 0 0 1 .593 0c.196.03.399.102 1.086.37l6.236 2.436c.125.049.253.095.375.153.01.135.006.27.006.405V16c0 4.256-3.564 6.891-6.6 8.5-.632.334-.804.417-1.063.47-.195.04-.565.042-.762.005-.261-.048-.42-.122-1.016-.425C6.934 21.682 6 17.906 6 15.999V7.39c0-.136-.003-.272.007-.406.122-.058.25-.105.375-.154l6.236-2.436c.687-.269.89-.341 1.086-.37" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-silver-streamer" class="svg-sprite__symbol"><g clip-path="url(#a)"><mask id="b" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M18 0H0v18h18z"/></mask><g mask="url(#b)"><path fill="url(#c)" d="M7.984.56a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.707a2 2 0 0 1 .986 1.708L16.8 9l-.027 3.367a2 2 0 0 1-.986 1.708l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.14 9.002l.027-3.366a2 2 0 0 1 .986-1.708L5.055 2.22z"/><path fill="#fff" d="M12.748 7.643 8.675 11.47a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.213 9.283a.73.73 0 0 1-.233-.53.73.73 0 0 1 .233-.53A.83.83 0 0 1 5.78 8c.213 0 .417.08.567.222l1.76 1.655 3.504-3.294a.83.83 0 0 1 .568-.223c.213 0 .417.08.567.223a.73.73 0 0 1 .233.53.73.73 0 0 1-.232.53Z"/></g><mask id="d" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M18 0H0v18h18z"/></mask><g mask="url(#d)"><path fill="url(#e)" d="M7.984.56a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.707a2 2 0 0 1 .986 1.708L16.8 9l-.027 3.367a2 2 0 0 1-.986 1.708l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.14 9.002l.027-3.366a2 2 0 0 1 .986-1.708L5.055 2.22z"/><path fill="#fff" d="M12.768 7.283 8.695 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.232.53Z"/></g></g><defs><linearGradient id="c" x1="2.1" x2="8.97" y1="4.11" y2="18" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ECEFF4"/><stop offset=".135" stop-color="#CFD3DE"/><stop offset=".531" stop-color="#7A7D85"/><stop offset=".99" stop-color="#ABAFBA"/></linearGradient><linearGradient id="e" x1="9" x2="8.97" y1=".3" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#CFD3DE"/><stop offset="0" stop-color="#CED8E9"/><stop offset=".151" stop-color="#BAC1CF"/><stop offset=".427" stop-color="#7A7E87"/><stop offset=".599" stop-color="#737D85"/><stop offset=".823" stop-color="#A7AEB7"/><stop offset="1" stop-color="#CED8E9"/></linearGradient><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sliders_vertical_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M4.918 3.25a.75.75 0 0 0-1.5 0v1h-1a.75.75 0 0 0 0 1.5h1v11a.75.75 0 0 0 1.5 0v-11h1a.75.75 0 1 0 0-1.5h-1zM10.751 3.252a.75.75 0 0 0-1.5 0v7.665h-1a.75.75 0 0 0 0 1.5h1v4.331a.75.75 0 0 0 1.5 0v-4.331h.996a.75.75 0 0 0 0-1.5h-.996zM15.835 2.502a.75.75 0 0 1 .75.75v4.331h.998a.75.75 0 1 1 0 1.5h-.998v7.668a.75.75 0 0 1-1.5 0V9.083h-.999a.75.75 0 0 1 0-1.5h.999V3.252a.75.75 0 0 1 .75-.75"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-smile" class="svg-sprite__symbol"><circle cx="12" cy="12" r="10.8" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M6 14.4c1.29 2.17 3.496 3.6 6 3.6s4.71-1.43 6-3.6"/><path stroke="currentColor" stroke-width="1.2" d="M9 8.4a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0ZM16.2 8.4a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-smile-plus" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.964 3.418H15.2M12.582.8v5.237"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M12.582 9.309A5.89 5.89 0 1 1 6.69 3.418"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M3.418 10.617c.704 1.184 1.907 1.964 3.273 1.964s2.569-.78 3.272-1.964"/><path fill="currentColor" d="M5.382 7.345a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0m3.927 0a.655.655 0 1 1-1.31 0 .655.655 0 0 1 1.31 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-smile_add_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 1.5a8.48 8.48 0 0 0-6.01 2.49A8.48 8.48 0 0 0 1.5 10c0 2.347.952 4.473 2.49 6.01A8.48 8.48 0 0 0 10 18.5a.75.75 0 0 0 0-1.5 6.98 6.98 0 0 1-4.95-2.05A6.98 6.98 0 0 1 3 10c0-1.933.783-3.682 2.05-4.95A6.98 6.98 0 0 1 10 3c1.933 0 3.682.783 4.95 2.05A6.98 6.98 0 0 1 17 10a.75.75 0 0 0 1.5 0 8.48 8.48 0 0 0-2.49-6.01A8.48 8.48 0 0 0 10 1.5M8.75 8.373a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m3.625 1.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m5.875 6.752a.75.75 0 0 0 0-1.5h-2v-2a.75.75 0 0 0-1.5 0v2h-1.995a.75.75 0 0 0 0 1.5h1.995v2.003a.75.75 0 0 0 1.5 0V16.25zm-9.935-4.497a.75.75 0 0 0-1.123.994A3.73 3.73 0 0 0 10 14c1.11 0 2.117-.473 2.808-1.253a.75.75 0 0 0-1.123-.994A2.23 2.23 0 0 1 10 12.5a2.23 2.23 0 0 1-1.685-.747" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-smile_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M10 1.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m3.067 9.057c.3.285.312.76.027 1.06a4 4 0 0 1-.855.653A4.36 4.36 0 0 1 10 14.4a4.36 4.36 0 0 1-2.239-.63 4 4 0 0 1-.854-.653.75.75 0 0 1 1.004-1.109l.197.18c.098.083.239.186.417.292.446.263.942.42 1.475.42s1.029-.157 1.475-.42c.178-.106.32-.21.417-.292l.115-.105a.75.75 0 0 1 1.06-.027M7.625 7.25a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m4.75 0a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-smile_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M8.44 14.297a.9.9 0 0 1 1.258.133c.014.016.197.223.53.431.383.24.97.489 1.774.489.803 0 1.39-.25 1.773-.489.19-.119.381-.26.53-.431a.9.9 0 0 1 1.4 1.132c-.273.328-.616.6-.976.826a5.1 5.1 0 0 1-2.727.762 5.1 5.1 0 0 1-2.727-.762 4 4 0 0 1-.976-.826.9.9 0 0 1 .14-1.265M10.252 10.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.002 11.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/><path fill="currentColor" fill-rule="evenodd" d="M12.002 2.1c-5.468 0-9.9 4.432-9.9 9.9 0 5.467 4.432 9.9 9.9 9.9 5.467 0 9.9-4.433 9.9-9.9s-4.433-9.9-9.9-9.9m-8.1 9.9a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-smile_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 26C7.373 26 2 20.627 2 14S7.373 2 14 2s12 5.373 12 12-5.373 12-12 12m0-2c5.523 0 10-4.477 10-10S19.523 4 14 4 4 8.477 4 14s4.477 10 10 10m-4.388-5.908a1 1 0 0 1 1.463-1.364 4 4 0 0 0 5.85 0 1 1 0 1 1 1.46 1.367q-.141.15-.293.293a6 6 0 0 1-8.48-.297m7.763-4.842a1.625 1.625 0 1 1 0-3.25 1.625 1.625 0 0 1 0 3.25m-6.75 0a1.625 1.625 0 1 1 0-3.25 1.625 1.625 0 0 1 0 3.25"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="14" id="svg-name-social-behance" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M16.783 3.454q1.197-.002 2.095.466a4.2 4.2 0 0 1 1.47 1.25q.573.782.828 1.788a6.7 6.7 0 0 1 .18 2.098h-6.801c0 .745.251 1.45.64 1.83.388.378.949.568 1.675.568q.783 0 1.352-.395c.375-.263.603-.544.691-.835h2.28c-.366 1.134-.922 1.944-1.68 2.432-.75.489-1.664.733-2.73.733q-1.111 0-2.01-.357c-.6-.24-1.1-.575-1.522-1.013a4.6 4.6 0 0 1-.958-1.57 5.8 5.8 0 0 1-.338-2.01q.002-1.057.348-1.971c.235-.61.56-1.138.988-1.58a4.7 4.7 0 0 1 1.526-1.05 4.9 4.9 0 0 1 1.966-.384M6.347.129c.623 0 1.185.053 1.699.165A3.7 3.7 0 0 1 9.36.83q.545.371.85.993c.198.41.298.922.298 1.528q0 .984-.447 1.64-.448.656-1.327 1.073 1.199.347 1.787 1.212.591.87.59 2.09 0 .99-.38 1.706a3.3 3.3 0 0 1-1.03 1.18q-.646.456-1.48.675a6.6 6.6 0 0 1-1.702.218H.21V.129zm-.155 7.215H3.076v3.585h3.06q.423.001.803-.082c.256-.056.483-.145.675-.276.191-.127.351-.3.466-.52q.173-.328.172-.844-.001-1.004-.565-1.436c-.376-.285-.878-.427-1.495-.427m10.514-1.935q-.62 0-1.03.211-.404.21-.656.519-.248.313-.347.664-.1.346-.118.621h4.212c-.062-.66-.288-1.148-.597-1.49-.308-.341-.829-.525-1.464-.525M5.758 2.346H3.076v3.042h2.901q.762 0 1.26-.366c.331-.24.49-.638.49-1.183q0-.455-.159-.748a1.2 1.2 0 0 0-.442-.452 1.8 1.8 0 0 0-.63-.229 4 4 0 0 0-.738-.064M19.3 1.002v1.284h-5.276V1.002z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-social-discord" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#fff" d="M20.57 4.738c2.74 3.877 4.094 8.25 3.588 13.286a.08.08 0 0 1-.032.054 20.4 20.4 0 0 1-6.068 2.946.1.1 0 0 1-.047 0 .1.1 0 0 1-.038-.028 15.5 15.5 0 0 1-1.238-1.938.074.074 0 0 1 .04-.104c.662-.24 1.29-.527 1.894-.867a.073.073 0 0 0 .007-.124 10 10 0 0 1-.377-.284.08.08 0 0 0-.079-.01c-3.924 1.744-8.223 1.744-12.193 0a.08.08 0 0 0-.079.01 10 10 0 0 1-.376.284.073.073 0 0 0 .008.124c.604.334 1.233.627 1.893.868.042.016.063.063.042.103a14 14 0 0 1-1.24 1.94.08.08 0 0 1-.085.026 20.4 20.4 0 0 1-6.058-2.946.08.08 0 0 1-.032-.055c-.422-4.355.44-8.765 3.584-13.286a.07.07 0 0 1 .033-.027 20.5 20.5 0 0 1 4.938-1.474.08.08 0 0 1 .08.036c.214.365.459.833.624 1.216a19.2 19.2 0 0 1 5.547 0c.166-.375.402-.85.615-1.216a.1.1 0 0 1 .034-.03.1.1 0 0 1 .046-.006c1.733.288 3.391.791 4.938 1.474a.06.06 0 0 1 .031.028m-10.282 8.28c.02-1.287-.956-2.352-2.18-2.352-1.215 0-2.18 1.056-2.18 2.353 0 1.296.984 2.352 2.18 2.352 1.214 0 2.18-1.056 2.18-2.352m8.062 0c.019-1.287-.957-2.352-2.18-2.352-1.215 0-2.181 1.056-2.181 2.353 0 1.296.985 2.352 2.18 2.352 1.224 0 2.18-1.056 2.18-2.352"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24.262v24.262H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-discord-round" class="svg-sprite__symbol"><defs><linearGradient id="a" x1="7.021%" y1="0%" y2="100%"><stop offset="0%" stop-color="#7184CA"/><stop offset="100%" stop-color="#4A62BA"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><circle cx="13" cy="13" r="13" fill="url(#a)"/><path fill="#FFF" fill-rule="nonzero" d="m10.725 7.8.13.156c-2.34.676-3.419 1.703-3.419 1.703s.286-.156.767-.377c1.391-.61 2.496-.78 2.951-.819.078-.013.143-.026.221-.026a10.6 10.6 0 0 1 6.539 1.222s-1.027-.975-3.237-1.65l.182-.209h.055c.314.008 1.92.106 3.598 1.365 0 0 1.872 3.393 1.872 7.58 0 0-1.105 1.884-3.978 1.975 0 0-.468-.559-.858-1.053 1.703-.48 2.353-1.547 2.353-1.547a7.4 7.4 0 0 1-1.495.767 8.6 8.6 0 0 1-1.885.56 9.1 9.1 0 0 1-3.367-.014 11 11 0 0 1-1.911-.559 8 8 0 0 1-.949-.442c-.039-.026-.078-.039-.117-.065a.2.2 0 0 1-.052-.039c-.234-.13-.364-.22-.364-.22s.624 1.04 2.275 1.533c-.39.494-.871 1.08-.871 1.08-2.873-.092-3.965-1.977-3.965-1.977 0-4.186 1.872-7.579 1.872-7.579C8.944 7.761 10.725 7.8 10.725 7.8m-.364 4.85c-.741 0-1.326.65-1.326 1.442 0 .793.598 1.443 1.326 1.443.741 0 1.326-.65 1.326-1.443.013-.793-.585-1.443-1.326-1.443zm4.745 0c-.741 0-1.326.65-1.326 1.442 0 .793.598 1.443 1.326 1.443.741 0 1.326-.65 1.326-1.443s-.585-1.443-1.326-1.443z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-social-dribbble" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10c5.51 0 10-4.48 10-10S15.51 0 10 0m6.605 4.61a8.5 8.5 0 0 1 1.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25 25 0 0 0-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362M10 1.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.7 8.7 0 0 1 10 1.475m-3.633.803a54 54 0 0 1 3.167 4.935c-3.992 1.062-7.517 1.04-7.896 1.04a8.58 8.58 0 0 1 4.729-5.975M1.453 10.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.52 8.52 0 0 1-2.19-5.705zM10 18.547a8.48 8.48 0 0 1-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.3 35.3 0 0 1 1.823 6.475 8.4 8.4 0 0 1-3.341.684m4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.47 8.47 0 0 1-3.655 5.715"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-fb" class="svg-sprite__symbol"><path fill="currentColor" d="M26 13.079C26 5.855 20.18 0 13 0S0 5.855 0 13.079C0 19.609 4.753 25.019 10.969 26v-9.14h-3.3v-3.782h3.3v-2.88c0-3.279 1.94-5.09 4.91-5.09 1.421 0 2.91.256 2.91.256v3.219h-1.64c-1.615 0-2.118 1.008-2.118 2.043v2.453h3.606l-.576 3.78h-3.03V26C21.247 25.019 26 19.608 26 13.079"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-google" class="svg-sprite__symbol"><g fill="none" fill-rule="nonzero"><path fill="#FFF" d="M8.944.711c-3.218 1.08-5.96 3.443-7.488 6.434a12.7 12.7 0 0 0-1.15 3.262 12.8 12.8 0 0 0 1.143 8.385 13.1 13.1 0 0 0 3.588 4.33 13.3 13.3 0 0 0 4.802 2.376c2.202.579 4.546.565 6.763.07 2.003-.453 3.9-1.394 5.413-2.76 1.598-1.443 2.742-3.34 3.346-5.382.66-2.223.746-4.6.334-6.887H13.263V15.6h7.203c-.277 1.617-1.257 3.095-2.643 4.008-.873.579-1.875.948-2.912 1.13-1.037.174-2.117.194-3.154-.008a7.9 7.9 0 0 1-2.941-1.247 8.03 8.03 0 0 1-3.026-3.98 7.73 7.73 0 0 1 0-5.047 8.1 8.1 0 0 1 1.918-3.06 7.9 7.9 0 0 1 3.95-2.154 8 8 0 0 1 3.878.153 7.14 7.14 0 0 1 2.849 1.645l2.43-2.384c.425-.425.873-.836 1.285-1.275A12.9 12.9 0 0 0 17.845.795C15.003-.237 11.807-.258 8.944.71"/><path fill="#EA4335" d="M8.944.711a13.62 13.62 0 0 1 8.9.077A12.9 12.9 0 0 1 22.1 3.374c-.412.439-.86.85-1.286 1.275l-2.43 2.384a7.2 7.2 0 0 0-2.848-1.645 7.95 7.95 0 0 0-3.879-.153 7.94 7.94 0 0 0-3.95 2.154 8 8 0 0 0-1.917 3.06C4.348 9.347 2.905 8.253 1.456 7.152 2.984 4.154 5.726 1.792 8.944.71"/><path fill="#FBBC05" d="M.313 10.4c.234-1.13.618-2.23 1.15-3.262 1.442 1.101 2.885 2.196 4.334 3.297a7.68 7.68 0 0 0 0 5.047 1779 1779 0 0 1-4.327 3.297A12.7 12.7 0 0 1 .313 10.4"/><path fill="#4285F4" d="M13.263 10.532h12.432c.412 2.28.32 4.657-.334 6.887-.604 2.043-1.748 3.939-3.346 5.382l-4.199-3.2c1.386-.913 2.366-2.39 2.643-4.008h-7.203q.009-2.53.007-5.06"/><path fill="#34A853" d="M1.456 18.786q2.163-1.644 4.327-3.298a8.07 8.07 0 0 0 3.026 3.98 7.95 7.95 0 0 0 2.94 1.248c1.038.21 2.11.182 3.155.007 1.037-.18 2.039-.55 2.912-1.129l4.199 3.2c-1.513 1.373-3.41 2.307-5.413 2.76-2.217.495-4.561.509-6.763-.07a13.15 13.15 0 0 1-4.802-2.377 13.1 13.1 0 0 1-3.58-4.321"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-social-instagram" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14.228 0H5.772A5.773 5.773 0 0 0 0 5.773v8.452A5.77 5.77 0 0 0 5.772 20h8.456A5.77 5.77 0 0 0 20 14.225V5.773A5.773 5.773 0 0 0 14.228 0m3.93 14.376a3.83 3.83 0 0 1-3.832 3.832H5.674a3.83 3.83 0 0 1-3.832-3.832V5.724a3.83 3.83 0 0 1 3.832-3.832h8.652a3.83 3.83 0 0 1 3.832 3.832zM10 4.861a5.19 5.19 0 1 1 0 10.378 5.19 5.19 0 0 1 0-10.378m0 8.553a3.364 3.364 0 1 0 0-6.729 3.364 3.364 0 0 0 0 6.729m5.363-7.542a1.209 1.209 0 1 0 0-2.418 1.209 1.209 0 0 0 0 2.418"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-instagram-colored" class="svg-sprite__symbol"><path fill="url(#a)" fill-rule="evenodd" d="M13 2.342c3.471 0 3.882.014 5.253.076 1.268.058 1.956.27 2.414.448.566.208 1.077.54 1.497.972.432.42.764.932.973 1.497.177.458.39 1.147.447 2.414.062 1.371.076 1.782.076 5.253s-.014 3.882-.076 5.253c-.058 1.268-.27 1.956-.447 2.415a4.3 4.3 0 0 1-2.468 2.467c-.458.178-1.146.39-2.414.447-1.37.063-1.782.076-5.253.076s-3.883-.014-5.253-.076c-1.268-.058-1.956-.27-2.414-.447a4 4 0 0 1-1.497-.973 4 4 0 0 1-.972-1.497c-.178-.458-.39-1.146-.448-2.414-.062-1.37-.076-1.782-.076-5.253s.014-3.882.076-5.253c.058-1.268.27-1.956.448-2.414.208-.566.54-1.077.972-1.497.42-.432.931-.764 1.497-.972.458-.178 1.146-.39 2.414-.448 1.37-.062 1.782-.076 5.253-.076zm.002-2.344c-3.53 0-3.973.015-5.36.078-1.387.064-2.33.285-3.158.607a6.4 6.4 0 0 0-2.302 1.499A6.4 6.4 0 0 0 .685 4.484C.361 5.312.141 6.257.078 7.64S0 9.47 0 13s.015 3.974.078 5.36c.064 1.387.283 2.329.605 3.156a6.4 6.4 0 0 0 1.499 2.302 6.4 6.4 0 0 0 2.302 1.5c.826.32 1.772.54 3.156.604C9.023 25.986 9.47 26 13 26s3.974-.015 5.36-.078 2.328-.283 3.156-.604a6.65 6.65 0 0 0 3.802-3.802c.32-.826.54-1.772.604-3.156.063-1.383.078-1.83.078-5.36s-.015-3.973-.078-5.36-.283-2.328-.604-3.156a6.4 6.4 0 0 0-1.5-2.302A6.4 6.4 0 0 0 21.516.685C20.688.361 19.744.142 18.36.08 16.977.016 16.53 0 13 0zM13 6.325a6.676 6.676 0 1 0 0 13.352 6.676 6.676 0 0 0 0-13.352m0 11.008a4.335 4.335 0 1 1 0-8.669 4.335 4.335 0 0 1 0 8.67M21.5 6.06a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0" clip-rule="evenodd"/><defs><linearGradient id="a" x1="13" x2="4" y1="-4" y2="26" gradientUnits="userSpaceOnUse"><stop stop-color="#DC3495"/><stop offset="1" stop-color="#F06130"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-social-instagram-error" class="svg-sprite__symbol"><path fill="url(#a)" fill-rule="evenodd" d="M14.58 6.002C14.16 6 13.649 6 13 6l.002-.002c-2.716 0-3.057.012-4.124.06-1.066.05-1.792.22-2.428.467a4.9 4.9 0 0 0-1.772 1.153c-.508.5-.9 1.104-1.15 1.771-.25.636-.42 1.363-.468 2.428S3 13.284 3 16s.012 3.056.06 4.123c.05 1.066.218 1.79.465 2.427a4.9 4.9 0 0 0 1.153 1.771 4.9 4.9 0 0 0 1.772 1.154c.635.247 1.363.416 2.427.465 1.064.048 1.407.06 4.123.06s3.057-.012 4.123-.06c1.067-.049 1.791-.218 2.427-.465a5.11 5.11 0 0 0 2.925-2.925c.247-.635.416-1.363.465-2.427.043-.927.056-1.307.06-3.185a8 8 0 0 1-1.8.022c-.004 1.81-.017 2.17-.058 3.082-.045.975-.208 1.505-.345 1.857a3.31 3.31 0 0 1-1.898 1.898c-.352.137-.882.3-1.856.344-1.055.048-1.371.059-4.041.059s-2.987-.01-4.041-.059c-.975-.044-1.505-.207-1.857-.344a3.1 3.1 0 0 1-1.151-.748 3.1 3.1 0 0 1-.749-1.151c-.137-.353-.3-.883-.344-1.857-.048-1.055-.058-1.371-.058-4.041s.01-2.987.058-4.041c.045-.975.207-1.505.344-1.857.16-.435.416-.829.749-1.151a3.1 3.1 0 0 1 1.15-.749c.353-.137.883-.3 1.858-.344C10.015 7.81 10.33 7.8 13 7.8L13 7.8l1.09.001c.093-.627.26-1.23.49-1.8m-.322 5.02a5.136 5.136 0 1 0 3.877 4.984 8.02 8.02 0 0 1-3.877-4.985m-3.11 7.75a3.334 3.334 0 1 0 3.704-5.546 3.334 3.334 0 0 0-3.704 5.545" clip-rule="evenodd"/><circle cx="22" cy="9" r="5.25" fill="#fff" stroke="#E74B63" stroke-width="1.5"/><path stroke="#E74B62" stroke-width="1.5" d="m26 5-8 8"/><defs><linearGradient id="a" x1="13" x2="6.077" y1="2.923" y2="26" gradientUnits="userSpaceOnUse"><stop stop-color="#DC3495"/><stop offset="1" stop-color="#F06130"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" id="svg-name-social-mail" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M13 0C5.83 0 0 5.831 0 13s5.831 13 13 13a12.96 12.96 0 0 0 7.323-2.26l-1.704-1.982a10.37 10.37 0 0 1-5.62 1.65C7.261 23.407 2.592 18.738 2.592 13c0-5.74 4.669-10.41 10.407-10.41 5.74 0 10.41 4.67 10.41 10.41 0 .754-.086 1.506-.247 2.238-.333 1.368-1.288 1.79-2.02 1.733-.722-.058-1.516-.574-1.586-1.846v-2.125a6.563 6.563 0 0 0-6.557-6.556 6.56 6.56 0 0 0-6.555 6.556A6.563 6.563 0 0 0 13 19.556a6.53 6.53 0 0 0 4.681-1.973 4.19 4.19 0 0 0 3.255 1.973 4.34 4.34 0 0 0 2.97-.871c.783-.595 1.353-1.44 1.672-2.462a1.3 1.3 0 0 0 .071-.209l.075-.338c.184-.876.277-1.773.277-2.675C26 5.83 20.169 0 13 0M9.036 13a3.967 3.967 0 0 1 3.962-3.963A3.97 3.97 0 0 1 16.963 13 3.967 3.967 0 0 1 13 16.963a3.967 3.967 0 0 1-3.962-3.962" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="26" fill="currentColor" id="svg-name-social-ok" class="svg-sprite__symbol"><path d="M7.883 0a6.738 6.738 0 1 0 0 13.475A6.738 6.738 0 0 0 7.883 0m0 9.523a2.785 2.785 0 1 1 0-5.57 2.785 2.785 0 0 1 0 5.57M10.262 18.836c2.697-.55 4.313-1.826 4.399-1.895a1.832 1.832 0 0 0-2.292-2.858c-.017.013-1.74 1.335-4.577 1.337-2.837-.002-4.597-1.324-4.614-1.338a1.832 1.832 0 0 0-2.292 2.859c.087.07 1.77 1.38 4.543 1.917l-3.865 4.038a1.832 1.832 0 1 0 2.638 2.544l3.59-3.825 3.952 3.85a1.832 1.832 0 1 0 2.59-2.593z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="27" height="12" id="svg-name-social-soundcloud" class="svg-sprite__symbol"><path fill="currentColor" d="M15.818 0C13.748 0 12 .989 10.91 2.625V12h11.455c2.07 0 3.818-1.747 3.818-3.818s-1.747-3.818-3.818-3.818c-.218 0-.533-.009-.75.102C20.957 1.849 18.545 0 15.818 0m-7.09 2.182V12h1.09V2.284c-.328-.11-.763-.102-1.09-.102m-1.092.102c-.434.11-.762.332-1.09.443V12h1.09zM5.455 3.716a3.35 3.35 0 0 0-.99 1.943h-.101V12h1.09V3.716zM3.273 5.455c-.435 0-.763.093-1.091.204v6.136c.328.111.656.205 1.09.205zM1.09 6.34A3.1 3.1 0 0 0 0 8.727a3.1 3.1 0 0 0 1.09 2.387z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="20" id="svg-name-social-telegram" class="svg-sprite__symbol"><path fill="currentColor" d="M19.314.036a2.6 2.6 0 0 0-.83.198c-.227.09-1.043.432-2.342.977-1.298.545-3.02 1.267-4.853 2.038-3.67 1.543-7.792 3.279-9.904 4.168-.072.03-.367.12-.692.369-.327.249-.689.79-.689 1.38 0 .478.238.963.526 1.242.287.278.579.408.822.505v-.003l3.867 1.546c.207.622 1.098 3.286 1.31 3.956h-.002c.15.474.296.782.5 1.04.1.13.222.246.37.338q.087.052.184.089.013.005.026.008l-.024-.006c.018.007.035.018.053.025.03.01.052.01.093.018.145.045.289.075.423.075.573 0 .925-.312.925-.312l.023-.016 2.477-2.096 3.034 2.807c.055.078.49.666 1.494.666.6 0 1.074-.297 1.377-.608.303-.312.492-.63.577-1.062l.002-.002c.068-.348 2.972-14.932 2.972-14.932l-.006.024c.09-.403.117-.793.01-1.191a1.7 1.7 0 0 0-.742-.99 1.74 1.74 0 0 0-.98-.25zm-.416 2.31c-.115.577-2.716 13.648-2.877 14.467l-4.382-4.054-2.962 2.504.82-3.207s5.66-5.728 6-6.061c.275-.267.332-.36.332-.454 0-.123-.064-.212-.21-.212-.132 0-.311.127-.406.186-1.207.752-6.347 3.681-8.875 5.12-.152-.062-2.436-.979-3.667-1.47L16.96 3.157a451 451 0 0 1 1.939-.81z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-social-telegram-filled" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#fff" d="M1.471 11.042s10.615-4.356 14.296-5.89c1.412-.614 6.197-2.577 6.197-2.577s2.21-.859 2.025 1.227c-.061.86-.552 3.866-1.043 7.118-.736 4.601-1.534 9.632-1.534 9.632s-.123 1.412-1.166 1.657-2.76-.859-3.067-1.104c-.246-.184-4.602-2.945-6.197-4.295-.43-.368-.92-1.105.06-1.964 2.21-2.024 4.848-4.54 6.443-6.135.737-.737 1.473-2.455-1.595-.368-4.356 3.006-8.651 5.828-8.651 5.828s-.982.614-2.823.062S.428 12.944.428 12.944s-1.472-.92 1.043-1.902"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-telegram-new" class="svg-sprite__symbol"><path fill="currentColor" d="M18.455 2.62c-.3-.254-.771-.29-1.259-.095-.512.206-14.505 6.207-15.074 6.453-.104.036-1.009.373-.916 1.125.084.678.81.959.9.991l3.557 1.218c.236.786 1.106 3.684 1.298 4.304.12.386.316.893.659.997.3.116.6.01.793-.142l2.175-2.017 3.51 2.738.084.05q.358.158.685.158.253 0 .485-.095c.526-.215.736-.717.758-.773L18.732 3.9c.16-.728-.062-1.099-.277-1.28M8.8 12.8 7.6 16l-1.2-4 9.2-6.8z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-social-telegram-round" class="svg-sprite__symbol"><defs><linearGradient id="a" x1="66.7%" x2="41.7%" y1="16.7%" y2="75%"><stop offset="0%" stop-color="#37AEE2"/><stop offset="100%" stop-color="#1E96C8"/></linearGradient><linearGradient id="b" x1="66%" x2="85.1%" y1="43.7%" y2="80.2%"><stop offset="0%" stop-color="#EFF7FC"/><stop offset="100%" stop-color="#FFF"/></linearGradient></defs><g fill="none"><circle cx="13" cy="13" r="13" fill="url(#a)"/><path fill="#C8DAEA" d="M10.617 18.958c-.422 0-.35-.159-.495-.56l-1.239-4.076 9.534-5.655"/><path fill="#A9C9DD" d="M10.617 18.958c.325 0 .468-.148.65-.325L13 16.948l-2.162-1.304"/><path fill="url(#b)" d="m10.838 15.644 5.239 3.871c.598.33 1.029.16 1.178-.555l2.132-10.05c.219-.875-.333-1.272-.905-1.012L5.96 12.726c-.855.343-.85.82-.156 1.033l3.213 1.003 7.44-4.694c.351-.213.673-.098.409.136"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-tiktok" class="svg-sprite__symbol"><path fill="currentColor" d="M18.99 5.008a5.24 5.24 0 0 1-3.118-1.018A5.04 5.04 0 0 1 13.909.945a5 5 0 0 1-.1-.945h-3.345v8.923l-.004 4.888c0 1.306-.872 2.414-2.08 2.804a3.1 3.1 0 0 1-2.509-.27c-.872-.509-1.464-1.433-1.48-2.49-.025-1.652 1.343-2.999 3.034-2.999.334 0 .655.053.955.15V7.69a7 7 0 0 0-.965-.07 6.49 6.49 0 0 0-4.82 2.105 6.05 6.05 0 0 0-1.583 3.696c-.113 1.797.56 3.506 1.867 4.766q.288.277.605.516A6.52 6.52 0 0 0 7.416 20q.489 0 .964-.07a6.45 6.45 0 0 0 3.572-1.743c1.206-1.163 1.872-2.707 1.879-4.351l-.018-7.299a8.5 8.5 0 0 0 1.88 1.07A8.6 8.6 0 0 0 19 8.258V5.007z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" id="svg-name-social-twitch" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M2.6 4.643 7.204 0H24.7v13l-8.287 8.357h-3.684L8.125 26v-4.643H2.6zm16.575 11.143 3.683-3.715V1.857H8.125v13.929h4.144v3.25l3.223-3.25z" clip-rule="evenodd"/><path d="M20.096 5.107h-1.842v5.572h1.842zM15.031 5.107H13.19v5.572h1.841z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="16" id="svg-name-social-twitter" class="svg-sprite__symbol"><path fill="currentColor" d="M19.941 1.89a8.3 8.3 0 0 1-2.35.633 4.05 4.05 0 0 0 1.8-2.229c-.803.47-1.682.8-2.598.978A4.12 4.12 0 0 0 13.806 0c-2.26 0-4.091 1.803-4.091 4.029q.002.473.105.917A11.68 11.68 0 0 1 1.388.736a3.97 3.97 0 0 0-.554 2.026c0 1.397.723 2.63 1.82 3.353a4.1 4.1 0 0 1-1.853-.504v.05c0 1.952 1.41 3.58 3.282 3.95a4.2 4.2 0 0 1-1.848.07 4.09 4.09 0 0 0 3.822 2.797 8.3 8.3 0 0 1-5.081 1.725A8 8 0 0 1 0 14.146a11.7 11.7 0 0 0 6.27 1.81c7.527 0 11.642-6.138 11.642-11.46q0-.263-.012-.522a8.2 8.2 0 0 0 2.04-2.084z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" id="svg-name-social-vk" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="currentColor" d="M14.19 21.384C5.328 21.384.273 15.31.063 5.2H4.5c.148 7.42 3.418 10.561 6.012 11.21V5.217h4.18v6.4c2.559-.276 5.25-3.192 6.156-6.4h4.18c-.696 3.95-3.612 6.867-5.685 8.068a12.8 12.8 0 0 1 6.657 8.1h-4.6c-.988-3.076-3.45-5.444-6.708-5.782v5.782z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h26v26H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-social-vk-new" class="svg-sprite__symbol"><path fill="#fff" d="M2.996 2h16v16h-16z"/><g clip-path="url(#a)"><path fill="#07F" fill-rule="evenodd" d="M1.4 1.4C0 2.812 0 5.074 0 9.6v.914c0 4.456 0 6.698 1.4 8.086C2.812 20 5.074 20 9.6 20h.914c4.456 0 6.698 0 8.086-1.4 1.4-1.412 1.4-3.674 1.4-8.2v-.914c0-4.456 0-6.698-1.4-8.086C17.188 0 14.926 0 10.4 0h-.914C5.03 0 2.788 0 1.4 1.4m1.979 4.676c.108 5.2 2.708 8.324 7.266 8.324h.258v-2.974c1.676.174 2.942 1.392 3.45 2.974h2.366a6.58 6.58 0 0 0-3.424-4.166c1.066-.618 2.566-2.118 2.924-4.15h-2.15c-.466 1.65-1.85 3.15-3.166 3.292V6.084h-2.15v5.758c-1.334-.334-3.016-1.95-3.092-5.766z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="14" id="svg-name-social-youtube" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M19.5 2.162c.415 1.542.415 4.76.415 4.76s0 3.218-.416 4.76a2.49 2.49 0 0 1-1.76 1.748c-1.553.414-7.781.414-7.781.414s-6.228 0-7.781-.414a2.49 2.49 0 0 1-1.76-1.748C0 10.14 0 6.922 0 6.922s0-3.218.416-4.76A2.49 2.49 0 0 1 2.176.413C3.73 0 9.959 0 9.959 0s6.228 0 7.78.413A2.49 2.49 0 0 1 19.5 2.162M7.965 9.888l5.174-2.966-5.174-2.967z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="svg-name-sparks" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.5 12.5a4.34 4.34 0 0 0-4-4 4.34 4.34 0 0 0 4-4 4.34 4.34 0 0 0 4 4 4.34 4.34 0 0 0-4 4M10.5 1.5a2.17 2.17 0 0 1-2 2 2.17 2.17 0 0 1 2 2 2.17 2.17 0 0 1 2-2 2.17 2.17 0 0 1-2-2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-square_stack_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13.262 2.66a1.75 1.75 0 0 1 1.473 0l10.25 4.752c1.351.627 1.351 2.548 0 3.175l-10.25 4.755a1.75 1.75 0 0 1-1.472 0L3.014 10.596c-1.351-.627-1.352-2.548-.001-3.175zm.737 1.864L4.344 9.007l9.654 4.472L23.654 9zm11.908 9.524a1 1 0 0 1-.485 1.329l-10.687 4.96a1.75 1.75 0 0 1-1.472.001L2.582 15.393a1 1 0 0 1 .84-1.815l10.576 4.897 10.581-4.913a1 1 0 0 1 1.328.486m-.48 6.253a1 1 0 1 0-.852-1.81l-10.577 4.98-10.57-4.964a1 1 0 1 0-.851 1.81l10.677 5.014a1.75 1.75 0 0 0 1.49 0z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-star" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="20" height="20" fill="#07F" rx="2.222"/><path fill="#fff" fill-rule="evenodd" d="M9.214 2.686 7.204 6.93l-4.659.6a.87.87 0 0 0-.487 1.497l3.417 3.224-.87 4.616a.871.871 0 0 0 1.275.925L10 15.54l4.122 2.253a.871.871 0 0 0 1.273-.925l-.869-4.616 3.417-3.224a.87.87 0 0 0-.487-1.497l-4.659-.6-2.01-4.245a.87.87 0 0 0-1.574 0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><rect width="20" height="20" fill="#fff" rx="2.222"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-star-outline" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M9.055 1.728c.31-.897 1.58-.897 1.89 0l1.546 4.466a1 1 0 0 0 .925.672l4.716.097c.947.019 1.34 1.222.585 1.795l-3.765 2.865a1 1 0 0 0-.352 1.085l1.367 4.534c.274.909-.752 1.652-1.53 1.109l-3.864-2.7a1 1 0 0 0-1.146 0l-3.864 2.7c-.778.543-1.804-.2-1.53-1.109L5.4 12.708a1 1 0 0 0-.352-1.085L1.283 8.758c-.754-.573-.362-1.776.585-1.795l4.716-.097a1 1 0 0 0 .925-.672z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" id="svg-name-subscribe" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.234 7.38a2.501 2.501 0 1 1 3.264-2.498 9.4 9.4 0 0 1 1.45-.535 4.001 4.001 0 1 0-5.611 4.292q.398-.668.897-1.259m-2.028 4.142c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.376a9.5 9.5 0 0 1-.812-1.5H2.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.271q.034-.814.198-1.588" clip-rule="evenodd"/><path fill-rule="evenodd" d="M16.5 21.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#fff" fill-rule="evenodd" d="M17.25 10.108a.75.75 0 0 0-1.5 0v2.857h-2.857a.75.75 0 1 0 0 1.5h2.857v2.857a.75.75 0 0 0 1.5 0v-2.857h2.857a.75.75 0 1 0 0-1.5H17.25z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="20" fill="none" id="svg-name-subscribe-category" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.654 1.484c-.544-1.57-2.764-1.57-3.307 0L6.8 5.949a.25.25 0 0 1-.231.168l-4.716.097C.195 6.248-.49 8.352.829 9.356l3.765 2.865a.25.25 0 0 1 .088.271l-1.367 4.535c-.48 1.59 1.317 2.89 2.677 1.94l2.068-1.444a9 9 0 0 1-.738-1.315l-2.188 1.529a.25.25 0 0 1-.383-.277l1.367-4.535a1.75 1.75 0 0 0-.616-1.898L1.737 8.162a.25.25 0 0 1 .146-.449L6.6 7.617A1.75 1.75 0 0 0 8.217 6.44l1.547-4.465a.25.25 0 0 1 .472 0l.974 2.812q.661-.354 1.382-.593z" clip-rule="evenodd"/><path fill="#07f" fill-rule="evenodd" d="M15.362 20a7.429 7.429 0 1 0 0-14.857 7.429 7.429 0 0 0 0 14.857" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.393" d="M15.362 9.42v6.7M18.711 12.772h-6.699"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" fill="none" id="svg-name-subscribed" class="svg-sprite__symbol"><path fill="#fff" fill-rule="evenodd" d="M9.091 10.076q.357-.676.814-1.282a3.001 3.001 0 1 1 4.078-3.121 9.4 9.4 0 0 1 1.45-.448A4.501 4.501 0 0 0 6.5 6a4.5 4.5 0 0 0 2.591 4.076m-.884 2.446c-1.583.33-2.828.932-3.803 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.377a9.5 9.5 0 0 1-.813-1.5H3.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.272q.034-.814.199-1.587" clip-rule="evenodd"/><path fill="#07F" fill-rule="evenodd" d="M17.5 22.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 15.75 17.938 17 20 12"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-subscribers-new" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M13.999 16.125c-.273-.803-.79-1.901-1.72-2.792-.914-.874-2.26-1.583-4.279-1.583s-3.365.709-4.278 1.583c-.931.89-1.448 1.99-1.72 2.792-.01.025-.007.037-.007.04a.1.1 0 0 0 .013.026c.02.024.067.059.148.059h11.688c.081 0 .129-.035.148-.059a.1.1 0 0 0 .013-.025c0-.004.002-.016-.006-.041Z"/><path fill="currentColor" fill-rule="evenodd" d="M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6M11.625 3.333a3 3 0 1 1 0 5.334c.295-.4.526-.853.676-1.34a1.5 1.5 0 1 0 0-2.655 4.5 4.5 0 0 0-.676-1.339M16.68 17h2.164c.61 0 1.061-.54.865-1.117C19.119 14.149 17.437 11 13 11h-.065a8.5 8.5 0 0 1 1.7 1.697 4.75 4.75 0 0 1 2.125 1.178c.52.498.9 1.079 1.17 1.625h-1.748c.216.546.378 1.058.499 1.5" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-subsribers-stat" class="svg-sprite__symbol"><circle cx="10" cy="5" r="3.75" stroke="#59A840" stroke-width="1.5"/><path stroke="#59A840" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.7 12H13m2.7 0V9.308m0 2.692v2.692m0-2.692h2.8"/><path fill="#59A840" fill-rule="evenodd" d="M4.296 14.38a6.96 6.96 0 0 0-2.226 2.784.1.1 0 0 0-.008.026l.005.008c.011.015.052.052.138.052h15.59c.085 0 .126-.037.137-.052l.005-.008a.1.1 0 0 0-.008-.027 7 7 0 0 0-.455-.861.75.75 0 1 1 1.274-.792l.063.103c.203.338.364.658.49.945.24.542.15 1.112-.164 1.534-.306.411-.801.658-1.342.658H2.205c-.541 0-1.037-.246-1.342-.657a1.52 1.52 0 0 1-.165-1.535 8.46 8.46 0 0 1 2.706-3.383C4.892 12.074 7.014 11.25 10 11.25a.75.75 0 0 1 0 1.5c-2.693 0-4.496.737-5.704 1.63" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="25" height="25" id="svg-name-success" class="svg-sprite__symbol"><g fill="inherit" fill-rule="evenodd"><rect width="25" height="25" rx="12.5"/><path fill="#FFF" d="M17.238 6 19 6.904 12.902 20 6 16.285l.895-1.832 5.123 2.758z"/></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sword" class="svg-sprite__symbol"><g clip-path="url(#a)"><rect width="20" height="20" fill="#59A840" rx="2.222"/><g clip-path="url(#b)"><path fill="#fff" d="m17.137 2.504-2.013.337a4.83 4.83 0 0 0-2.9 1.647l-4.843 5.725-.184-.184a.97.97 0 0 0-1.37 0l-.752.753a.315.315 0 0 0 0 .443l1.022 1.019L4.04 14.3a1.6 1.6 0 0 0-1.072.463A1.602 1.602 0 0 0 4.103 17.5c.413 0 .822-.156 1.134-.469A1.6 1.6 0 0 0 5.7 15.96l2.056-2.057.969.972c.059.06.14.094.222.094a.31.31 0 0 0 .221-.094l.753-.753a.95.95 0 0 0 .285-.684c0-.26-.1-.5-.285-.685l-.134-.134 5.725-4.843a4.83 4.83 0 0 0 1.647-2.9l.337-2.013a.313.313 0 0 0-.36-.36Z"/></g></g><defs><clipPath id="a"><rect width="20" height="20" fill="#fff" rx="2.222"/></clipPath><clipPath id="b"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-sword-new" class="svg-sprite__symbol"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.65" clip-path="url(#a)"><path d="m5.953 10.328 5.938-7.187 4.984-.016-.015 4.984-7.188 5.938"/><path d="M6.415 15.425 4.079 17.76a.625.625 0 0 1-.883 0l-.96-.961a.625.625 0 0 1 0-.883L4.57 13.58a.626.626 0 0 0 0-.89l-1.625-1.626a.625.625 0 0 1 0-.89l.984-.985a.625.625 0 0 1 .891 0l5.984 5.985a.626.626 0 0 1 0 .89l-.984.985a.624.624 0 0 1-.89 0l-1.626-1.625a.626.626 0 0 0-.89 0"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0.2 -0.3 9 11.4" id="svg-name-text" class="svg-sprite__symbol"><path d="M0 2.77V.92A1 1 0 0 1 .2.28C.35.1.56 0 .83 0h7.66c.28.01.48.1.63.28.14.17.21.38.21.64v1.85a1 1 0 0 1-.23.66c-.15.17-.37.26-.66.26-.28 0-.5-.09-.64-.26a1 1 0 0 1-.21-.66V1.69H5.6v7.58h.5c.25 0 .45.08.6.23.17.16.25.35.25.6s-.08.45-.24.6a.87.87 0 0 1-.62.22H3.21a.87.87 0 0 1-.61-.22.78.78 0 0 1-.24-.6c0-.25.08-.44.24-.6a.85.85 0 0 1 .61-.23h.5V1.7H1.73v1.08a1 1 0 0 1-.23.66c-.15.17-.37.26-.66.26-.28 0-.5-.09-.64-.26a1 1 0 0 1-.2-.67"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-text_style_1_28" class="svg-sprite__symbol"><path fill="currentColor" d="M10.883 18.41c-.596 0-.97-.349-.97-.9 0-.16.044-.375.126-.61l2.501-6.811c.267-.743.717-1.086 1.441-1.086.749 0 1.193.33 1.466 1.08l2.514 6.817c.089.248.12.419.12.61 0 .526-.4.9-.958.9-.54 0-.825-.247-.997-.844l-.482-1.447h-3.307l-.482 1.428c-.178.61-.464.864-.972.864m1.873-3.776H15.2l-1.213-3.752h-.044z"/><path fill="currentColor" fill-rule="evenodd" d="M6.07 3.801C7.164 3.216 8.243 3 10.691 3h6.616c2.448 0 3.527.216 4.622.801A5.47 5.47 0 0 1 24.2 6.07c.585 1.096.801 2.175.801 4.623v6.616c0 2.448-.216 3.527-.801 4.622A5.47 5.47 0 0 1 21.93 24.2c-1.095.585-2.174.801-4.622.801h-6.616c-2.448 0-3.527-.216-4.623-.801a5.47 5.47 0 0 1-2.268-2.269C3.216 20.836 3 19.757 3 17.309v-6.616c0-2.448.216-3.527.801-4.623A5.47 5.47 0 0 1 6.07 3.801M10.691 5c-2.335 0-3.019.212-3.68.565a3.47 3.47 0 0 0-1.447 1.448C5.212 7.673 5 8.357 5 10.692v6.616c0 2.335.212 3.019.565 3.68a3.47 3.47 0 0 0 1.448 1.447c.66.353 1.344.565 3.679.565h6.616c2.335 0 3.019-.212 3.68-.565a3.47 3.47 0 0 0 1.447-1.448c.353-.66.565-1.344.565-3.679v-6.616c0-2.335-.212-3.019-.565-3.68a3.47 3.47 0 0 0-1.448-1.447C20.327 5.212 19.643 5 17.308 5z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="svg-name-theatre" class="svg-sprite__symbol"><rect width="22" height="16" x="1" y="4" stroke="currentColor" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M19 4v16"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-thread" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.984 5.903a2.857 2.857 0 0 0-2.847-2.857L4.867 3.01A2.857 2.857 0 0 0 2 5.867V18l3-3h10.127a2.857 2.857 0 0 0 2.857-2.857z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.75 7.25h8.5M5.75 10.75h6.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-thumbs_up_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M5 24a1 1 0 1 1-2 0V12a1 1 0 1 1 2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M13.081 4c-.548 0-1.048.316-1.282.812L9.353 9.98A3.7 3.7 0 0 0 9 11.549V20.5a2.5 2.5 0 0 0 2.5 2.5h7.009a2.5 2.5 0 0 0 2.323-1.576l2.982-7.5a2.5 2.5 0 0 0-2.323-3.424h-5.609A1.38 1.38 0 0 1 14.5 9.118v-3.7C14.5 4.636 13.865 4 13.081 4m-3.09-.044A3.419 3.419 0 0 1 16.5 5.42V8.5h4.991c3.18 0 5.357 3.208 4.182 6.163l-2.983 7.5A4.5 4.5 0 0 1 18.51 25H11.5A4.5 4.5 0 0 1 7 20.5v-8.951c0-.839.186-1.667.545-2.425z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" id="svg-name-time" class="svg-sprite__symbol"><g stroke="currentColor" stroke-width="1.125" clip-path="url(#a)"><circle cx="7.5" cy="7.5" r="6.75"/><path stroke-linecap="round" d="M7.5 7.5V3.75M9.565 8.395 7.5 7.5M7.5 7.5V3.75M9.565 8.395 7.5 7.5"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h15v15H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-tip" class="svg-sprite__symbol"><circle cx="12" cy="12" r="10.8" stroke="currentColor" stroke-width="1.5"/><path fill="currentColor" d="M12 15.535a.75.75 0 0 0 0 1.5zM10.217 10.8l.525-.536a1 1 0 0 0-.093-.077zm-.594-1.2.75.026V9.6zM12 8.465a.75.75 0 0 0 0-1.5zm-.031 8.57a.75.75 0 0 0 .062-1.498zm-1.603-3.511a.75.75 0 1 0-1.487-.199zm2.384 2.761a.75.75 0 0 0-1.5 0zM11.25 18a.75.75 0 0 0 1.5 0zm.707-11.034a.75.75 0 1 0 .085 1.498zm1.846 1.49-.556.503zm-.169 1.771a.75.75 0 1 0 1.485.212zM11.25 7.715a.75.75 0 0 0 1.5 0zM12.75 6a.75.75 0 0 0-1.5 0zM12 17.035c.488 0 1.221-.112 1.861-.482.678-.392 1.266-1.092 1.266-2.176h-1.5c0 .443-.203.696-.517.877-.35.203-.805.281-1.11.281zm3.127-2.658c0-.67-.207-1.209-.58-1.644-.349-.406-.81-.68-1.235-.902-.908-.474-1.783-.795-2.57-1.566l-1.05 1.07c.996.977 2.201 1.447 2.927 1.826.392.204.637.37.79.549.128.15.218.338.218.667zm-4.478-4.19a.66.66 0 0 1-.276-.561l-1.5-.052c-.024.727.317 1.42.912 1.84zm-.276-.587c0-.338.073-.538.148-.66a.77.77 0 0 1 .327-.286c.323-.16.758-.19 1.152-.19v-1.5c-.398 0-1.152.015-1.82.347-.35.174-.689.44-.936.842q-.37.602-.371 1.447zm1.658 5.937a1.74 1.74 0 0 1-1.27-.63l-1.153.958a3.24 3.24 0 0 0 2.36 1.17zm-1.27-.63a1.8 1.8 0 0 1-.395-1.383l-1.487-.199a3.3 3.3 0 0 0 .729 2.54zm.489 1.378V18h1.5v-1.715zm.792-7.821c.454-.026.896.155 1.206.495l1.11-1.008a3.01 3.01 0 0 0-2.4-.985zm1.206.495c.31.342.452.807.386 1.268l1.485.212a3.06 3.06 0 0 0-.76-2.488zm-.498-1.244V6h-1.5v1.715z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-toggler-arrow" class="svg-sprite__symbol"><path stroke="#F1F1F1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 10H7m9 0-5.2 5m5.2-5-5.2-5"/><path fill="#F1F1F1" d="M3.25 15a.75.75 0 0 0 1.5 0zm1.5-10a.75.75 0 0 0-1.5 0zm0 10V5h-1.5v10z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="15" height="18" id="svg-name-trash" class="svg-sprite__symbol"><path fill-rule="evenodd" d="m5.4 0-.9.9H0v1.8h14.4V.9H9.9L9 0zM.9 4.5v11.7c0 .99.81 1.8 1.8 1.8h9c.99 0 1.8-.81 1.8-1.8V4.5zm2.7 1.8h1.8v9.9H3.6zm5.4 0h1.8v9.9H9z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trash-draft" class="svg-sprite__symbol"><path fill="currentColor" d="M10 0a3 3 0 0 0-3 3H3a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2h-4a3 3 0 0 0-3-3m1 3a1 1 0 1 0-2 0zM3 15.5V6h2v9.5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6h2v9.5a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4M7 6v10.5h2V6zm4 10.5V6h2v10.5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" id="svg-name-triangle-in-circle" class="svg-sprite__symbol"><rect width="12.6" height="12.6" x=".7" y=".7" stroke="currentColor" stroke-width="1.05" rx="6.3"/><path stroke="currentColor" stroke-width="1.05" d="M4.9 8.668V5.333a.7.7 0 0 1 1.013-.626l3.335 1.667a.7.7 0 0 1 0 1.252L5.913 9.294A.7.7 0 0 1 4.9 8.668Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trophy" class="svg-sprite__symbol"><path fill="currentColor" d="M10.733 11.822a.737.737 0 0 0-1.473 0zM9.26 17.425a.736.736 0 1 0 1.473 0zm.464-4.919a.736.736 0 1 0 .546-1.368zM6.038 7.633a.736.736 0 1 0-1.242.791zm3.685 3.505a.737.737 0 0 0 .546 1.368zm5.474-2.714a.737.737 0 0 0-1.242-.791zm-5.2 9.738a.737.737 0 1 0 0-1.473zm-2.385-1.473a.736.736 0 1 0 0 1.473zm2.384 0a.736.736 0 1 0 0 1.473zm2.385 1.473a.737.737 0 0 0 0-1.473zM3.213 3.848a.737.737 0 0 0 1.47-.109zm2.508-1.845-.047.735.047.002zm8.551 0v.737q.024 0 .048-.002zm1.295.492.523-.518zm-.256 1.244a.737.737 0 0 0 1.47.109zm-11.363.79a.736.736 0 1 0 0-1.472V4.53zM1.9 3.794l-.051.735.05.002zm-.638.23L.754 3.49zM1 4.65h.737v-.014zm2.415 3.586-.277.682.065.023zm.243.033v-.736h-.014zm1.109 0 .001-.736h-.001zm1.127.315a.736.736 0 0 0-.969-1.11zM4.677 3.696a.736.736 0 0 0-1.46.196zm.105 4.708a.736.736 0 1 0 1.268-.751l-1.268.75zm11.262-5.347a.737.737 0 0 0 0 1.473zm2.056.736v.737l.051-.002zm.638.23.508-.533zM19 4.65l-.736-.014v.014zm-2.415 3.586.212.705.065-.023zm-.243.033.014-.736h-.014zm-1.109 0v-.736h-.001zm-.158-.795a.737.737 0 0 0-.969 1.11zm1.715-3.581a.736.736 0 1 0-1.46-.196zm-2.833 3.761a.737.737 0 0 0 1.267.75zM9.26 11.822v5.603h1.473v-5.603zm1.01-.684a8.96 8.96 0 0 1-4.232-3.505l-1.242.791a10.44 10.44 0 0 0 4.928 4.082zm0 1.368a10.44 10.44 0 0 0 4.928-4.082l-1.243-.791a8.96 8.96 0 0 1-4.232 3.505l.546 1.368zm-.273 4.183H7.612v1.473h2.385zm0 1.473h2.384v-1.473H9.996zM4.681 3.739a.93.93 0 0 1 .268-.726L3.904 1.977a2.4 2.4 0 0 0-.69 1.87l1.468-.108zm.268-.726a.93.93 0 0 1 .724-.275l.094-1.47a2.4 2.4 0 0 0-1.864.709L4.95 3.013zm.771-.273h8.551V1.267h-8.55V2.74zm8.599-.002a.93.93 0 0 1 .723.275l1.047-1.036a2.4 2.4 0 0 0-1.865-.709zm.723.275c.19.192.288.457.268.726l1.47.109a2.4 2.4 0 0 0-.691-1.871zm-11.095.044H1.9V4.53h2.048zm-1.998.002a1.58 1.58 0 0 0-1.196.43l1.015 1.068q.034-.03.08-.029zm-1.196.43c-.32.306-.499.732-.49 1.174l1.473-.028a.1.1 0 0 1 .032-.078L.754 3.49zm-.49 1.16a4.605 4.605 0 0 0 2.874 4.268l.554-1.365A3.13 3.13 0 0 1 1.737 4.65H.264zm2.94 4.291q.23.07.469.065l-.028-1.473q-.008 0-.017-.002zm.455.065h1.109V7.532h-1.11v1.473zm1.107 0c.415 0 .816-.15 1.129-.422l-.969-1.11a.24.24 0 0 1-.157.059zM3.217 3.892a12 12 0 0 0 1.565 4.512l1.268-.751a10.5 10.5 0 0 1-1.373-3.957zm12.827.638H18.1V3.057h-2.056zm2.107-.002a.1.1 0 0 1 .08.029l1.015-1.067a1.58 1.58 0 0 0-1.196-.431zm.08.029c.021.02.033.049.033.078l1.472.028a1.58 1.58 0 0 0-.49-1.173zm.032.092a3.13 3.13 0 0 1-1.955 2.903l.554 1.365a4.605 4.605 0 0 0 2.874-4.268zm-1.89 2.88-.017.003-.028 1.473q.24.004.47-.065zm-.03.003h-1.11v1.473h1.11zm-1.111 0a.24.24 0 0 1-.157-.059l-.969 1.11c.313.273.714.423 1.129.422zm.098-3.836a10.5 10.5 0 0 1-1.373 3.957l1.267.75a12 12 0 0 0 1.566-4.511z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-trophy-rt" class="svg-sprite__symbol"><path fill="#1F1F1F" stroke="url(#a)" stroke-width=".889" d="M.444 9.6c0-2.275.001-3.937.172-5.209.168-1.259.495-2.068 1.1-2.678L1.4 1.4l.316.313C2.318 1.105 3.124.778 4.384.61 5.64.444 7.28.444 9.519.444h.881c2.275 0 3.937.001 5.209.172 1.258.168 2.068.495 2.678 1.1.608.602.935 1.408 1.102 2.668.167 1.257.167 2.897.167 5.135v.881c0 2.275-.001 3.937-.172 5.209-.168 1.258-.495 2.068-1.1 2.678-.602.608-1.408.935-2.668 1.102-1.257.167-2.897.167-5.135.167H9.6c-2.275 0-3.937-.001-5.209-.172-1.259-.168-2.068-.495-2.678-1.1-.608-.602-.935-1.408-1.102-2.668C.444 14.36.444 12.72.444 10.481V9.6Z"/><g clip-path="url(#b)"><path fill="url(#c)" d="M7.423 3.297A2.63 2.63 0 0 0 4.8 5.92c0 1.426.574 3.015 1.362 4.31.394.647.842 1.222 1.334 1.653s1.04.745 1.662.745h1.636c.655 0 1.2-.366 1.689-.84.49-.473.934-1.093 1.326-1.77.784-1.35 1.362-2.89 1.343-4.103a2.63 2.63 0 0 0-2.622-2.618z"/><path fill="url(#d)" d="M7.255 13.21c-.744 0-1.36.622-1.36 1.366v.775c0 .744.616 1.36 1.36 1.36h5.443a1.37 1.37 0 0 0 1.36-1.36v-.775c0-.744-.616-1.365-1.36-1.365z"/><path fill="url(#e)" d="M3.604 5.043a.583.583 0 0 0-.582.582c0 1.48-.069 2.556.418 3.436.243.44.66.789 1.176.978.283.104.598.167.949.206-.805-1.4-1.379-3.064-1.379-4.57 0-.217.028-.428.073-.632zm12.09 0c.044.203.072.412.072.628.022 1.356-.625 3.078-1.501 4.589.42-.035.79-.102 1.116-.221a2.2 2.2 0 0 0 1.175-.978c.486-.88.422-1.955.422-3.436a.583.583 0 0 0-.585-.582z"/></g><defs><linearGradient id="a" x1="12.5" x2="3.326" y1="8" y2="19.839" gradientUnits="userSpaceOnUse"><stop stop-color="#A50FEB"/><stop offset="1" stop-color="#0177FF"/></linearGradient><linearGradient id="c" x1="14.085" x2="9.325" y1="2.687" y2="10.67" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><linearGradient id="d" x1="13.217" x2="12.151" y1="12.982" y2="16.74" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><linearGradient id="e" x1="15.542" x2="14.132" y1="4.702" y2="10.404" gradientUnits="userSpaceOnUse"><stop stop-color="#0355FF"/><stop offset="1" stop-color="#A510EB"/></linearGradient><clipPath id="b"><path fill="#fff" d="M3 3h14v14H3z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="70" height="70" fill="none" id="svg-name-tv" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3" d="m37.148 23.027 6.12 6.012-6.12 6.011m-11.019-6.01h16.969"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10.004 20.168v18.246c-.166 6.55 5.039 11.995 11.63 12.167h26.728c6.593-.17 11.8-5.616 11.634-12.167V20.168c.166-6.55-5.039-11.996-11.63-12.168H21.634c-6.591.172-11.796 5.618-11.63 12.168" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-width="3" d="M17.146 61.225h35.71"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-tv_text_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M14.578 12.745h-.101l-2.324-6.78c-.218-.662-.56-.965-1.104-.965-.606 0-1.049.36-1.049.879 0 .202.062.483.171.778l2.62 6.989c.341.943.846 1.354 1.724 1.354.863 0 1.353-.403 1.695-1.354l2.627-6.989c.093-.267.163-.59.163-.785C19 5.353 18.565 5 17.966 5c-.56 0-.878.281-1.096.965zM4.996 15.002c.615 0 1-.4 1-1.047V6.653h2.146c.503 0 .858-.342.858-.822 0-.487-.355-.83-.858-.83H1.858c-.495 0-.858.35-.858.83 0 .473.363.822.858.822h2.14v7.302c0 .654.377 1.047.998 1.047"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-underline" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 3v6a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5V3"/><path fill="currentColor" d="M5 16.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-underline-active" class="svg-sprite__symbol"><path stroke="#F15F2C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 3v6a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5V3"/><path fill="#F15F2C" d="M5 16.25a.75.75 0 0 0 0 1.5zm10 1.5a.75.75 0 0 0 0-1.5zm-10 0h10v-1.5H5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="svg-name-unlocked" class="svg-sprite__symbol"><path fill="inherit" fill-rule="evenodd" d="M6.25 5.5a3.75 3.75 0 1 1 7.5 0v1.75H14A2.75 2.75 0 0 1 16.75 10v6A2.75 2.75 0 0 1 14 18.75H6A2.75 2.75 0 0 1 3.25 16v-6A2.75 2.75 0 0 1 6 7.25h6.25V5.5a2.25 2.25 0 0 0-4.5 0zM6 8.75c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-6c0-.69-.56-1.25-1.25-1.25zM10 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-unmute-vk-player" class="svg-sprite__symbol"><path fill="currentColor" d="m20 10.763 2.381-2.382A.875.875 0 1 1 23.62 9.62L21.237 12l2.382 2.381a.875.875 0 1 1-1.238 1.238L20 13.237l-2.381 2.382a.875.875 0 1 1-1.238-1.238L18.763 12 16.38 9.619A.875.875 0 1 1 17.62 8.38zm-7.02 8.06c-.031 1.207-.67 1.609-1.828.62-1.719-1.469-3.609-3.194-4.242-3.721-.632-.529-1.645-.62-3.073-.62s-1.815-.621-1.815-1.241-.014-1.83-.014-2.001c0-.055.005-.086.014-.13.02-.095-.058-.973 0-1.59.085-.906.388-1.241 1.815-1.241s2.44-.092 3.073-.62c.633-.529 2.523-2.253 4.242-3.722 1.158-.989 1.797-.587 1.829.62.043 1.607 0 3.85 0 6.683 0 2.83.043 5.356 0 6.963"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-unpin" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.616.96a2.39 2.39 0 0 0-3.37-.027h-.001L3.24.938.94 3.235l-.006.006A2.39 2.39 0 0 0 .96 6.612l3.526 3.53c.303.303.447.724.49 1.317.03.413.01.812-.011 1.252a25 25 0 0 0-.029.809l1.554-1.68a7 7 0 0 0-.018-.49c-.056-.763-.26-1.602-.925-2.268L2.018 5.55l-.003-.003a.89.89 0 0 1-.013-1.253l2.295-2.292a.89.89 0 0 1 1.254.013l.003.003L9.08 5.546c.665.666 1.505.87 2.268.925l.1.007 1.407-1.52q-.071.002-.14.006c-.442.022-.844.042-1.258.011-.593-.043-1.014-.187-1.316-.49zm8.063 4.236L13.527 6.44a2.28 2.28 0 0 1 1.747 1.158c.33.51.266 1.179-.154 1.616l-2.919 2.92a1 1 0 0 0-.063.062L9.215 15.12a1.31 1.31 0 0 1-1.648.134 2.28 2.28 0 0 1-1.026-1.262l-1.1 1.19A3.8 3.8 0 0 0 6.8 16.544a2.81 2.81 0 0 0 3.463-.35l.008-.008 2.43-2.43 5.768 5.77a.75.75 0 1 0 1.06-1.06l-5.768-5.77 2.425-2.425.008-.008a2.81 2.81 0 0 0 .35-3.463 3.78 3.78 0 0 0-1.865-1.604" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.807 2.68 3.333 18.326"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="23" id="svg-name-unsubscribe" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.234 7.38a2.501 2.501 0 1 1 3.264-2.498 9.4 9.4 0 0 1 1.45-.535 4.001 4.001 0 1 0-5.611 4.292q.398-.668.897-1.259m-2.028 4.142c-1.582.33-2.828.932-3.802 1.653a8.46 8.46 0 0 0-2.706 3.383 1.52 1.52 0 0 0 .165 1.535c.306.41.801.657 1.342.657h6.376a9.5 9.5 0 0 1-.812-1.5H2.205c-.085 0-.126-.037-.138-.052l-.004-.008q-.001-.004.008-.026a6.96 6.96 0 0 1 2.226-2.783c.69-.512 1.576-.972 2.711-1.271q.034-.814.198-1.588" clip-rule="evenodd"/><path fill-rule="evenodd" d="M16.5 21.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill="#fff" d="M14.294 14.06a.75.75 0 0 0-.588 1.38zM16.937 16l-.293.69a.75.75 0 0 0 .987-.404zm2.756-4.714a.75.75 0 1 0-1.386-.572zm-5.987 4.154 2.938 1.25.587-1.38-2.937-1.25zm3.925.846 2.062-5-1.386-.572-2.063 5z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="23" height="20" fill="none" id="svg-name-unsubscribe-category" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11.654 1.484c-.544-1.57-2.764-1.57-3.307 0L6.8 5.949a.25.25 0 0 1-.231.168l-4.716.097C.195 6.248-.49 8.352.829 9.356l3.765 2.865a.25.25 0 0 1 .088.271l-1.367 4.535c-.48 1.59 1.317 2.89 2.677 1.94l2.068-1.444a9 9 0 0 1-.738-1.315l-2.188 1.529a.25.25 0 0 1-.383-.277l1.367-4.535a1.75 1.75 0 0 0-.616-1.898L1.737 8.162a.25.25 0 0 1 .146-.449L6.6 7.617A1.75 1.75 0 0 0 8.217 6.44l1.547-4.465a.25.25 0 0 1 .472 0l.974 2.812q.661-.354 1.382-.593z" clip-rule="evenodd"/><path fill="#07f" fill-rule="evenodd" d="M15.362 20a7.429 7.429 0 1 0 0-14.857 7.429 7.429 0 0 0 0 14.857" clip-rule="evenodd"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.393" d="m13.04 13.732 2.728 1.16 1.915-4.642"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="svg-name-user" class="svg-sprite__symbol"><path d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0m0 3.575a4.225 4.225 0 1 1 0 8.45 4.225 4.225 0 0 1 0-8.45M13 23.4c-3.17 0-6.007-1.418-7.914-3.656a1.32 1.32 0 0 1 .224-1.912C7.284 16.35 10.877 15.6 13 15.6s5.717.749 7.69 2.232c.61.459.721 1.333.226 1.912A10.38 10.38 0 0 1 13 23.4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="svg-name-user-new" class="svg-sprite__symbol"><g clip-path="url(#a)" filter="url(#b)"><path fill="currentColor" fill-rule="evenodd" d="M12.113 10.582c2.142 0 3.88-1.697 3.88-3.791S14.254 3 12.112 3s-3.88 1.697-3.88 3.791 1.737 3.791 3.88 3.791m-.89 1.058c-3.437 0-6.223 2.686-6.223 6v1.11C5 19.993 6.045 21 7.333 21h9.334C17.955 21 19 19.993 19 18.75v-1.11c0-3.314-2.786-6-6.222-6h-1.556" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath><filter id="b" width="20" height="24" x="2" y="1" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6951_87215"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_6951_87215" result="shape"/></filter></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user-outlined" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M10 12c-5.68 0-7.848 3.12-8.616 4.86-.252.574.195 1.14.82 1.14h15.591c.626 0 1.073-.566.82-1.14C17.849 15.12 15.68 12 10 12Z"/><circle cx="10" cy="5" r="3.75" stroke="currentColor" stroke-width="1.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user_book_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14.254 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M3 6.58h.006v1.28H2.25a.75.75 0 1 0 0 1.5h.756v1.28H2.25a.75.75 0 0 0 0 1.5h.756v1.28H2.25a.75.75 0 0 0 0 1.5H3a1 1 0 0 0 .107-.008C3.507 16.682 5.044 18 6.88 18h7.748c2.14 0 3.874-1.79 3.874-4V6c0-2.21-1.735-4-3.874-4H6.88C5.044 2 3.507 3.318 3.107 5.088A1 1 0 0 0 3 5.08h-.75a.75.75 0 1 0 0 1.5zM4.506 14c0 .388.082.75.227 1.071a10.185 10.185 0 0 1 12.039.008c.147-.323.23-.688.23-1.079V6c0-1.426-1.108-2.5-2.374-2.5H6.88C5.614 3.5 4.506 4.574 4.506 6zm6.24.608a8.7 8.7 0 0 1 5.01 1.59c-.34.194-.726.302-1.128.302H6.88c-.406 0-.795-.11-1.137-.307a8.68 8.68 0 0 1 5.003-1.585" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_card_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M16 11a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zM17 16a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1M11 10a2 2 0 1 1 .001 3.999A2 2 0 0 1 11 10M7.503 18A.503.503 0 0 1 7 17.497C7 15.607 9.5 15 11 15s4 .5 4 2.5v-.003a.503.503 0 0 1-.502.503z"/><path fill="currentColor" fill-rule="evenodd" d="M10.956 4c-1.363 0-2.447 0-3.321.071-.896.074-1.66.227-2.359.583a6 6 0 0 0-2.622 2.622c-.356.7-.51 1.463-.583 2.359C2 10.509 2 11.593 2 12.956v2.088c0 1.363 0 2.447.071 3.321.074.896.227 1.66.583 2.359a6 6 0 0 0 2.622 2.622c.7.356 1.463.51 2.359.583.874.071 1.958.071 3.321.071h6.088c1.363 0 2.447 0 3.321-.071.896-.074 1.66-.227 2.359-.583a6 6 0 0 0 2.622-2.622c.356-.7.51-1.463.583-2.359.071-.874.071-1.958.071-3.321v-2.088c0-1.363 0-2.447-.071-3.321-.074-.896-.227-1.66-.583-2.359a6 6 0 0 0-2.622-2.622c-.7-.356-1.463-.51-2.359-.583C19.491 4 18.407 4 17.044 4zM6.184 6.436c.37-.189.842-.308 1.613-.371C8.581 6 9.583 6 11 6h6c1.417 0 2.419 0 3.203.065.771.063 1.243.182 1.613.371a4 4 0 0 1 1.748 1.748c.189.37.308.842.371 1.613C24 10.581 24 11.583 24 13v2c0 1.417 0 2.419-.065 3.203-.063.771-.182 1.243-.371 1.613a4 4 0 0 1-1.748 1.748c-.37.189-.841.308-1.613.371C19.419 22 18.417 22 17 22h-6c-1.417 0-2.419 0-3.203-.065-.771-.063-1.243-.182-1.613-.371a4 4 0 0 1-1.748-1.748c-.189-.37-.308-.841-.371-1.613C4 17.419 4 16.417 4 15v-2c0-1.417 0-2.419.065-3.203.063-.771.182-1.243.371-1.613a4 4 0 0 1 1.748-1.748" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-user_circle_outline_24" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3 3a9.87 9.87 0 0 1 7-2.9c2.733 0 5.21 1.11 7 2.9a9.87 9.87 0 0 1 2.9 7c0 2.734-1.11 5.21-2.9 7a9.87 9.87 0 0 1-7 2.9A9.87 9.87 0 0 1 3 17a9.87 9.87 0 0 1-2.9-7C.1 7.267 1.21 4.79 3 3m7 12.3c1.654 0 3.175.565 4.382 1.514A8.06 8.06 0 0 1 10 18.1a8.06 8.06 0 0 1-4.382-1.287A7.07 7.07 0 0 1 10 15.3m0-13.4c-2.237 0-4.26.906-5.728 2.373A8.07 8.07 0 0 0 1.9 10a8.07 8.07 0 0 0 2.297 5.652A8.87 8.87 0 0 1 10 13.5c2.217 0 4.245.811 5.803 2.152A8.07 8.07 0 0 0 18.1 10c0-2.237-.906-4.26-2.373-5.727A8.07 8.07 0 0 0 10 1.9" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 1.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14.5 2c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12m0 18.5c-2.086 0-4.08.582-5.797 1.649A9.95 9.95 0 0 0 14.5 24c2.16 0 4.161-.685 5.796-1.85A10.94 10.94 0 0 0 14.5 20.5m0-16.5c-5.523 0-10 4.477-10 10a9.96 9.96 0 0 0 2.648 6.779A12.93 12.93 0 0 1 14.5 18.5c2.67 0 5.215.808 7.353 2.277A9.96 9.96 0 0 0 24.5 14c0-5.523-4.477-10-10-10m0 3.5a4.75 4.75 0 0 1 4.75 4.75A4.75 4.75 0 0 1 14.5 17a4.75 4.75 0 0 1-4.75-4.75A4.75 4.75 0 0 1 14.5 7.5m0 2c-1.52 0-2.75 1.23-2.75 2.75S12.98 15 14.5 15s2.75-1.23 2.75-2.75S16.02 9.5 14.5 9.5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="57" height="57" fill="none" id="svg-name-user_circle_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M37.531 24.531c0 5.249-4.251 9.5-9.5 9.5a9.5 9.5 0 0 1-9.5-9.5c0-5.248 4.252-9.5 9.5-9.5s9.5 4.252 9.5 9.5m-3 0c0-3.591-2.908-6.5-6.5-6.5a6.5 6.5 0 0 0-6.5 6.5c0 3.592 2.909 6.5 6.5 6.5s6.5-2.908 6.5-6.5" clip-rule="evenodd"/><path fill="currentColor" d="M28.031 37.533a27.4 27.4 0 0 1 17.107 5.966l-2.25 2.05a24.4 24.4 0 0 0-14.857-5.016 24.4 24.4 0 0 0-14.857 5.015l-2.25-2.05a27.4 27.4 0 0 1 17.107-5.965"/><path fill="currentColor" fill-rule="evenodd" d="M52.031 28.031c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24m-3 0c0 11.598-9.402 21-21 21s-21-9.402-21-21 9.402-21 21-21 21 9.402 21 21" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_minus_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M17.75 15c4.951 0 9.25 1.763 9.25 5.643 0 2.016-.781 2.857-2.456 2.857H10.956c-1.675 0-2.456-.84-2.456-2.857 0-3.88 4.299-5.643 9.25-5.643m0 2c-3.946 0-7.25 1.355-7.25 3.643 0 .89-.072.863.372.858l13.672-.001c.536 0 .456.086.456-.857C25 18.355 21.696 17 17.75 17M5 11h4a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h4m12.5-8C20.538 3 23 5.461 23 8.5S20.538 14 17.5 14A5.5 5.5 0 0 1 12 8.5C12 5.461 14.461 3 17.5 3m0 2A3.5 3.5 0 0 0 14 8.5c0 1.934 1.566 3.5 3.5 3.5S21 10.434 21 8.5 19.434 5 17.5 5"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-user_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M14 3a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m-3.5 5.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M4.5 21.975c0-4.109 4.415-6.475 9.5-6.475s9.5 2.366 9.5 6.475c0 2.135-.802 3.025-2.522 3.025H7.022c-1.72 0-2.522-.89-2.522-3.025m2 0c0-1.224.618-2.266 1.916-3.09C9.758 18.032 11.735 17.5 14 17.5s4.242.532 5.584 1.385c1.297.824 1.916 1.866 1.916 3.09 0 .417-.04.69-.085.859a1 1 0 0 1-.042.127c-.06.016-.182.039-.395.039H7.022c-.213 0-.335-.023-.395-.039a1 1 0 0 1-.042-.127c-.045-.168-.085-.442-.085-.86" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="17" fill="none" id="svg-name-user_start_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M9.421 2.099a.93.93 0 0 0-.834 0c-.052.026-.193.135-.447.602-.243.447-.52 1.084-.914 1.997l-.492 1.136-.005.012c-.02.05-.083.201-.193.327q-.136.158-.325.248c-.15.072-.314.093-.367.1l-.012.001-.687.097c-.995.14-1.69.238-2.192.355-.523.122-.668.23-.708.275a.94.94 0 0 0-.222.814c.011.058.081.226.47.596.372.356.921.794 1.708 1.42l.224.18.012.008c.05.039.205.158.306.326.083.138.131.294.141.455.012.195-.048.381-.068.442l-.004.014-.451 1.477c-.185.605-.308 1.01-.373 1.325-.065.309-.053.437-.035.504a.94.94 0 0 0 .408.55c.058.037.177.086.492.114.32.029.743.03 1.376.03h5.502c.618 0 1.031-.001 1.343-.029.307-.027.424-.075.483-.111a.94.94 0 0 0 .409-.538c.02-.066.034-.192-.022-.495-.056-.308-.166-.707-.332-1.302l-.43-1.55-.003-.013c-.018-.06-.072-.242-.057-.433.013-.157.062-.309.143-.443.1-.164.251-.28.3-.318l.012-.009.231-.185c.785-.626 1.333-1.064 1.705-1.42.387-.37.457-.537.469-.596a.94.94 0 0 0-.223-.813c-.04-.045-.185-.153-.707-.275-.5-.117-1.195-.215-2.19-.355l-.685-.097q-.005 0-.012-.002a1.2 1.2 0 0 1-.368-.099 1 1 0 0 1-.325-.248 1.2 1.2 0 0 1-.193-.327l-.005-.012-.491-1.136c-.395-.913-.672-1.55-.915-1.997-.253-.467-.395-.576-.447-.602M7.915.758a2.43 2.43 0 0 1 2.179 0c.494.248.82.725 1.092 1.227.28.513.582 1.213.958 2.082l.431.996.535.076c.947.133 1.709.24 2.283.374.56.131 1.11.32 1.482.733a2.44 2.44 0 0 1 .577 2.113c-.11.544-.487.986-.903 1.384-.426.407-1.027.887-1.775 1.484l-.086.068.379 1.366c.154.554.282 1.017.352 1.399.073.394.102.789-.012 1.183a2.44 2.44 0 0 1-1.063 1.398c-.35.215-.738.293-1.137.328-.386.035-.867.035-1.442.035h-5.57c-.59 0-1.081 0-1.476-.036-.406-.036-.802-.116-1.155-.337a2.44 2.44 0 0 1-1.059-1.43c-.109-.402-.07-.804.015-1.204.08-.387.224-.857.396-1.42l.393-1.29-.073-.059c-.75-.596-1.352-1.076-1.779-1.483-.416-.398-.795-.84-.905-1.385a2.44 2.44 0 0 1 .577-2.114c.372-.413.922-.602 1.483-.733.575-.134 1.338-.241 2.286-.374l.535-.076.431-.996c.377-.87.68-1.569.958-2.082.273-.502.599-.98 1.093-1.227" clip-rule="evenodd"/><path fill="currentColor" d="M5.5 13.577v.461c0 .247.201.462.437.462h6.125c.235 0 .437-.215.437-.462v-.461c0-1.616-2.332-2.077-3.5-2.077s-3.5.461-3.5 2.077M10.75 8.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" id="svg-name-users_16" class="svg-sprite__symbol"><path fill="currentColor" d="M11.357 9c1.533 0 4.343.571 4.343 2.857 0 1-.255 1.143-.766 1.143l-4.07.001q.159-.49.159-1.144c0-1.149-.422-2.045-1.118-2.708A7.4 7.4 0 0 1 11.357 9M5.343 9c1.533 0 4.343.571 4.343 2.857 0 1-.255 1.143-.766 1.143H1.766C1.256 13 1 12.857 1 11.857 1 9.571 3.81 9 5.343 9m0-5c1.108 0 2.005.895 2.005 2S6.45 8 5.343 8A2 2 0 0 1 3.34 6c0-1.105.897-2 2.004-2m6.014 0c1.107 0 2.004.895 2.004 2s-.897 2-2.004 2a2 2 0 0 1-2.005-2c0-1.105.897-2 2.005-2"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-users_20" class="svg-sprite__symbol"><path fill="currentColor" d="M13.5 10.5c1.941 0 5.5.714 5.5 3.571 0 1.25-.323 1.429-.97 1.429l-4.738.001q.208-.601.208-1.43c0-1.483-.592-2.62-1.555-3.436A9.4 9.4 0 0 1 13.5 10.5m-7 0c1.941 0 5.5.714 5.5 3.571 0 1.25-.323 1.429-.97 1.429H1.97c-.646 0-.97-.179-.97-1.429C1 11.214 4.559 10.5 6.5 10.5m0-6.5a2.5 2.5 0 1 1 .001 4.999A2.5 2.5 0 0 1 6.5 4m7 0a2.5 2.5 0 1 1 .001 4.999A2.5 2.5 0 0 1 13.5 4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-users_3_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M10.286 17.91C9.39 18.461 9 19.128 9 19.786c0 .481.153.744.325.898.189.168.527.316 1.075.316h7.2c.548 0 .886-.148 1.075-.316.172-.154.325-.417.325-.898 0-.658-.39-1.325-1.286-1.876-.899-.552-2.208-.91-3.714-.91s-2.815.358-3.714.91M9.24 16.206C10.516 15.422 12.207 15 14 15s3.484.422 4.76 1.206c1.279.785 2.24 2.011 2.24 3.58 0 .952-.327 1.796-.995 2.391-.651.58-1.513.823-2.405.823h-7.2c-.892 0-1.754-.242-2.405-.823C7.327 21.582 7 20.738 7 19.786c0-1.569.961-2.795 2.24-3.58M3.805 17.082c-.52.346-.805.806-.805 1.418 0 .523.17.88.395 1.105.224.225.582.395 1.105.395a1 1 0 1 1 0 2c-.977 0-1.87-.33-2.52-.98S1 19.477 1 18.5c0-1.388.715-2.428 1.695-3.082.951-.634 2.157-.918 3.305-.918a1 1 0 1 1 0 2c-.852 0-1.646.216-2.195.582M24.195 17.082c.52.346.805.806.805 1.418 0 .523-.17.88-.395 1.105-.224.225-.582.395-1.105.395a1 1 0 1 0 0 2c.977 0 1.87-.33 2.52-.98s.98-1.543.98-2.52c0-1.388-.715-2.428-1.695-3.082-.951-.634-2.157-.918-3.305-.918a1 1 0 1 0 0 2c.852 0 1.646.216 2.195.582M11.5 8.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M14 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M7 6.5a2 2 0 1 0 0 4 1 1 0 1 1 0 2 4 4 0 0 1 0-8 1 1 0 0 1 0 2M21 6.5a2 2 0 1 1 0 4 1 1 0 1 0 0 2 4 4 0 0 0 0-8 1 1 0 1 0 0 2" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-users_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.25 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1.5 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M2.688 11.57c.96-.555 2.226-.82 3.562-.82s2.602.265 3.562.82c.977.563 1.688 1.467 1.688 2.68 0 .707-.275 1.306-.781 1.71-.484.387-1.105.54-1.719.54H3.5c-.614 0-1.235-.153-1.719-.54C1.276 15.557 1 14.958 1 14.25c0-1.213.71-2.117 1.688-2.68m.75 1.298c-.649.374-.938.845-.938 1.382 0 .293.1.444.219.54.141.113.395.21.781.21H9c.386 0 .64-.097.781-.21.12-.096.219-.247.219-.54 0-.537-.29-1.008-.937-1.382-.665-.383-1.65-.618-2.813-.618s-2.148.235-2.813.618M13.75 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1.5 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0" clip-rule="evenodd"/><path fill="currentColor" d="M13.75 12.25q-.34 0-.677.033a.75.75 0 1 1-.146-1.493q.409-.04.823-.04c1.336 0 2.602.265 3.562.82.977.563 1.688 1.467 1.688 2.68 0 .707-.276 1.306-.782 1.71-.483.387-1.104.54-1.718.54h-3a.75.75 0 0 1 0-1.5h3c.386 0 .64-.097.782-.21.119-.096.218-.247.218-.54 0-.537-.29-1.008-.937-1.382-.665-.383-1.65-.618-2.813-.618"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-users_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M9 15c3.997 0 7.5 1.542 7.5 4.929 0 1.774-.69 2.571-2.147 2.571H3.647c-1.458 0-2.147-.797-2.147-2.571C1.5 16.542 5.003 15 9 15m10.5 0c3.997 0 7.5 1.542 7.5 4.929 0 1.774-.69 2.571-2.147 2.571H19a1 1 0 1 1 0-2h5.913q.025 0 .042.002l.013.001.002-.015c.01-.081.024-.22.029-.427l.001-.132C25 18.095 22.512 17 19.5 17c-.428 0-.898.03-1.37.09a1 1 0 0 1-.256-1.983A13 13 0 0 1 19.5 15M9 17c-3.013 0-5.5 1.095-5.5 2.929 0 .28.017.462.03.56l.001.014.014-.001.019-.001h10.891l.013.002.002-.015c.013-.097.03-.28.03-.56C14.5 18.096 12.012 17 9 17M19.5 5a4.25 4.25 0 0 1 4.25 4.25 4.25 4.25 0 0 1-4.25 4.25 4.25 4.25 0 0 1-4.25-4.25A4.25 4.25 0 0 1 19.5 5M9 5a4.25 4.25 0 0 1 4.25 4.25A4.25 4.25 0 0 1 9 13.5a4.25 4.25 0 0 1-4.25-4.25A4.25 4.25 0 0 1 9 5m10.5 2a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 1 0 0-4.5M9 7a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 1 0 9 7"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-verified-streamer" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M8.014.559a2 2 0 0 1 1.972 0l2.929 1.66 2.902 1.706a2 2 0 0 1 .986 1.709L16.83 9l-.027 3.366a2 2 0 0 1-.986 1.709l-2.902 1.706-2.929 1.66a2 2 0 0 1-1.972 0l-2.929-1.66-2.902-1.706a2 2 0 0 1-.986-1.709L1.17 9l.027-3.366a2 2 0 0 1 .986-1.709L5.085 2.22z"/><path fill="#fff" d="M12.768 7.283 8.695 11.11a.83.83 0 0 1-.568.222.83.83 0 0 1-.568-.222L5.233 8.922A.73.73 0 0 1 5 8.392a.73.73 0 0 1 .233-.53.83.83 0 0 1 .568-.222c.213 0 .417.08.567.222l1.76 1.655 3.504-3.295A.83.83 0 0 1 12.2 6c.213 0 .417.08.567.222a.73.73 0 0 1 .233.53.73.73 0 0 1-.233.53Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-video" class="svg-sprite__symbol"><rect width="18" height="18" x="1" y="1" rx="2"/><path d="M7 12.382V7.618a1 1 0 0 1 1.447-.894l4.764 2.382a1 1 0 0 1 0 1.788l-4.764 2.382A1 1 0 0 1 7 12.382"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" id="svg-name-video_add_square_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.317 1h2.931a.75.75 0 0 1 0 1.5H6.35c-.992 0-1.692 0-2.238.045-.537.044-.86.127-1.11.255A2.75 2.75 0 0 0 1.8 4.002c-.128.25-.21.573-.255 1.11-.044.546-.045 1.246-.045 2.238v3.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 3.002 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h3.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 14.2 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238V7.749a.75.75 0 0 1 1.5 0v2.934c0 .952 0 1.713-.05 2.327-.052.63-.16 1.172-.413 1.67a4.25 4.25 0 0 1-1.857 1.857c-.498.253-1.04.361-1.67.413-.614.05-1.375.05-2.327.05H6.317c-.952 0-1.713 0-2.327-.05-.63-.052-1.172-.16-1.67-.413A4.25 4.25 0 0 1 .464 14.68C.21 14.182.102 13.64.05 13.01 0 12.396 0 11.635 0 10.683V7.317c0-.952 0-1.713.05-2.327.052-.63.16-1.172.413-1.67a4.25 4.25 0 0 1 1.858-1.857c.497-.253 1.04-.361 1.67-.413C4.603 1 5.364 1 6.316 1" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M14.1 0a.75.75 0 0 1 .75.75v1.4h1.4a.75.75 0 0 1 0 1.5h-1.4v1.6a.75.75 0 0 1-1.5 0v-1.6h-1.6a.75.75 0 0 1 0-1.5h1.6V.75A.75.75 0 0 1 14.1 0M6.706 7.045a.2.2 0 0 0-.025.06 9.7 9.7 0 0 0 .008 3.79q.01.043.025.06.015.02.035.032a.1.1 0 0 0 .038.013.1.1 0 0 0 .046-.008A9.4 9.4 0 0 0 9.952 9.11a.146.146 0 0 0 0-.217 9.4 9.4 0 0 0-3.127-1.885A.1.1 0 0 0 6.78 7a.1.1 0 0 0-.037.013.1.1 0 0 0-.036.032m.628-1.449a1.607 1.607 0 0 0-2.124 1.22 11.2 11.2 0 0 0 .008 4.374 1.607 1.607 0 0 0 2.125 1.213 10.9 10.9 0 0 0 3.617-2.183c.72-.653.72-1.784 0-2.438a10.9 10.9 0 0 0-3.626-2.186" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-video_arrow_square_outline_24" class="svg-sprite__symbol"><path fill="currentColor" d="M13.202 7.576a.675.675 0 1 0 1.35 0V3.808l.794.795a.675.675 0 1 0 .955-.954L14.355 1.7a.675.675 0 0 0-.955 0l-1.952 1.95a.675.675 0 0 0 .954.955l.8-.8z"/><path fill="currentColor" d="M7.096 2.251h1.98a.675.675 0 1 1 0 1.35H7.124c-.746 0-1.265 0-1.67.034-.395.032-.62.092-.79.179a1.95 1.95 0 0 0-.852.852c-.087.17-.147.395-.18.791-.032.404-.033.923-.033 1.67v3.75c0 .745 0 1.265.034 1.668.032.396.092.622.179.791.186.367.485.666.852.853.17.086.395.146.79.179.405.033.924.033 1.67.033h3.75c.746 0 1.265 0 1.669-.033.396-.033.621-.093.791-.18a1.95 1.95 0 0 0 .852-.852c.087-.17.147-.395.18-.79.032-.404.033-.924.033-1.67v-.45a.675.675 0 1 1 1.35 0v.479c0 .71 0 1.285-.038 1.75-.04.48-.122.903-.322 1.294a3.3 3.3 0 0 1-1.442 1.443c-.392.2-.815.282-1.294.321-.466.038-1.04.038-1.75.038H7.095c-.71 0-1.285 0-1.75-.038-.48-.039-.902-.122-1.294-.321a3.3 3.3 0 0 1-1.442-1.443c-.2-.391-.283-.814-.322-1.294-.038-.465-.038-1.04-.038-1.75V7.097c0-.71 0-1.285.038-1.75.04-.48.122-.902.322-1.294a3.3 3.3 0 0 1 1.442-1.442c.392-.2.814-.283 1.294-.322.465-.038 1.04-.038 1.75-.038"/><path fill="currentColor" fill-rule="evenodd" d="M8.395 6.084A1.392 1.392 0 0 0 6.556 7.13a9.5 9.5 0 0 0 .008 3.748 1.392 1.392 0 0 0 1.838 1.04 9.4 9.4 0 0 0 3.13-1.87c.624-.561.624-1.53 0-2.09a9.4 9.4 0 0 0-3.137-1.874M7.89 7.368a.1.1 0 0 0-.01.024 8.2 8.2 0 0 0 .007 3.218.1.1 0 0 0 .01.024l.013.012.015.005q.004.001.022-.004a8.1 8.1 0 0 0 2.683-1.603.1.1 0 0 0 .016-.02.1.1 0 0 0 .004-.022.1.1 0 0 0-.004-.02.1.1 0 0 0-.016-.02 8.1 8.1 0 0 0-2.69-1.607.1.1 0 0 0-.021-.004l-.016.006z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" id="svg-name-video_circle_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12.915 11.681c.183-.129.407-.314.534-.6.165-.37.165-.792 0-1.162-.127-.286-.351-.471-.534-.6-.18-.127-.415-.263-.673-.412L10.26 7.763c-.26-.15-.494-.285-.694-.377-.203-.094-.476-.195-.787-.162a1.43 1.43 0 0 0-1.006.58c-.184.254-.232.54-.253.763-.02.22-.02.49-.02.79v2.287c0 .299 0 .57.02.79.02.222.07.509.253.762a1.43 1.43 0 0 0 1.006.58c.311.033.584-.068.787-.162.2-.092.435-.228.694-.377l1.98-1.144c.26-.149.495-.285.674-.412m-1.414-1.552a9 9 0 0 1 .61.371l-.02.015c-.12.084-.296.187-.59.356l-1.928 1.114a9 9 0 0 1-.627.342l-.001-.015-.001-.01a9 9 0 0 1-.014-.688V9.387a9 9 0 0 1 .016-.714l.023.01c.132.061.31.163.604.333z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M18.573 10.5a8.571 8.571 0 1 1-17.143 0 8.571 8.571 0 0 1 17.143 0m-1.429 0a7.143 7.143 0 1 1-14.286 0 7.143 7.143 0 0 1 14.286 0" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-video_outline_56" class="svg-sprite__symbol"><path fill="currentColor" d="M37.745 6c3.566 0 4.859.371 6.162 1.069a7.27 7.27 0 0 1 3.025 3.024C47.629 11.396 48 12.69 48 16.256v23.489c0 3.566-.371 4.859-1.069 6.162a7.27 7.27 0 0 1-3.024 3.025C42.604 49.629 41.311 50 37.745 50h-19.49c-3.565 0-4.859-.371-6.162-1.069a7.27 7.27 0 0 1-3.024-3.024C8.37 44.604 8 43.311 8 39.745v-23.49c0-3.565.371-4.859 1.069-6.162a7.27 7.27 0 0 1 3.024-3.024C13.396 6.37 14.69 6 18.256 6zm.314 3H18.256c-2.799 0-3.761.186-4.749.714a4.27 4.27 0 0 0-1.793 1.793c-.508.95-.7 1.876-.713 4.434L11 39.745c0 2.798.186 3.76.714 4.748a4.27 4.27 0 0 0 1.793 1.793c.988.528 1.95.714 4.749.714h19.489c2.798 0 3.76-.186 4.748-.714a4.27 4.27 0 0 0 1.793-1.793c.528-.988.714-1.95.714-4.748v-23.49c0-2.798-.186-3.76-.714-4.748a4.27 4.27 0 0 0-1.793-1.793c-.95-.508-1.876-.7-4.434-.713M18.72 38c.445 0 .607.046.77.134q.245.132.377.378c.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.607-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134zm-20-8c.445 0 .607.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.162-.088.324-.134.77-.134zm20 0c.445 0 .606.046.77.134q.245.132.377.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.9.9 0 0 1-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.9.9 0 0 1-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.607.134-.77a.9.9 0 0 1 .378-.378c.163-.088.324-.134.77-.134z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" id="svg-name-video_square_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M6.806 7.88c.282-1.402 1.743-2.222 3.105-1.742a16 16 0 0 1 5.3 3.122 2.316 2.316 0 0 1 0 3.483 16 16 0 0 1-5.287 3.118c-1.36.48-2.818-.334-3.105-1.733a15.7 15.7 0 0 1-.319-3.154c0-1.058.105-2.092.306-3.093m2.44.144c-.236-.083-.44.061-.479.25a13.7 13.7 0 0 0-.267 2.7c0 .944.096 1.864.278 2.752.039.19.244.333.48.25a14 14 0 0 0 4.625-2.728.317.317 0 0 0 0-.492 14 14 0 0 0-4.637-2.732" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M7.692 0C5.244 0 4.165.216 3.069.801A5.47 5.47 0 0 0 .801 3.07C.216 4.165 0 5.244 0 7.692v6.616c0 2.448.216 3.527.801 4.622A5.47 5.47 0 0 0 3.07 21.2c1.096.585 2.175.801 4.623.801h6.616c2.448 0 3.527-.216 4.622-.801A5.47 5.47 0 0 0 21.2 18.93c.585-1.095.801-2.174.801-4.622V7.692c0-2.448-.216-3.527-.801-4.623A5.47 5.47 0 0 0 18.93.801C17.836.216 16.757 0 14.308 0zm0 2c-2.335 0-3.019.212-3.68.565a3.47 3.47 0 0 0-1.447 1.448C2.212 4.673 2 5.357 2 7.692v6.616c0 2.335.212 3.019.565 3.68a3.47 3.47 0 0 0 1.448 1.447c.66.353 1.344.565 3.679.565h6.616c2.335 0 3.019-.212 3.68-.565a3.47 3.47 0 0 0 1.447-1.448c.353-.66.565-1.344.565-3.679V7.692c0-2.335-.212-3.019-.565-3.68a3.47 3.47 0 0 0-1.448-1.447C17.327 2.212 16.643 2 14.308 2z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-videocam_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M7.817 3c-.952 0-1.713 0-2.327.05-.63.052-1.172.16-1.67.413a4.25 4.25 0 0 0-1.857 1.858c-.253.497-.361 1.04-.413 1.67-.05.613-.05 1.374-.05 2.326v1.366c0 .952 0 1.713.05 2.327.052.63.16 1.172.413 1.67a4.25 4.25 0 0 0 1.858 1.857c.497.253 1.04.361 1.67.413.613.05 1.374.05 2.326.05h1.366c.952 0 1.713 0 2.327-.05.63-.052 1.172-.16 1.67-.413a4.25 4.25 0 0 0 1.857-1.857c.155-.304.255-.625.322-.971l1.532 1.02c1.329.887 3.109-.066 3.109-1.663V6.934c0-1.597-1.78-2.55-3.11-1.664L15.36 6.291a3.6 3.6 0 0 0-.322-.97 4.25 4.25 0 0 0-1.857-1.858c-.498-.253-1.04-.361-1.67-.413C10.896 3 10.135 3 9.183 3zM15.5 9.26V12l2.223 1.482a.5.5 0 0 0 .777-.416V6.934a.5.5 0 0 0-.777-.416L15.5 8zm-1.5.09c0-.992 0-1.692-.045-2.238-.044-.537-.127-.86-.255-1.11A2.75 2.75 0 0 0 12.5 4.8c-.252-.128-.574-.21-1.111-.255-.546-.044-1.245-.045-2.238-.045h-1.3c-.992 0-1.692 0-2.238.045-.537.044-.86.127-1.11.255A2.75 2.75 0 0 0 3.3 6.002c-.128.25-.21.573-.255 1.11C3.001 7.658 3 8.358 3 9.35v1.3c0 .992 0 1.692.045 2.238.044.537.127.86.255 1.11A2.75 2.75 0 0 0 4.502 15.2c.25.128.573.21 1.11.255.546.044 1.246.045 2.238.045h1.3c.992 0 1.692 0 2.238-.045.537-.044.86-.127 1.11-.255A2.75 2.75 0 0 0 13.7 14c.128-.252.21-.574.255-1.111.044-.546.045-1.245.045-2.238z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-videocam_outline_28" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M11 7h1c1.425 0 2.394.001 3.147.052.735.05 1.117.142 1.384.252a4 4 0 0 1 2.165 2.165c.11.267.201.65.252 1.384.05.753.052 1.722.052 3.147s-.001 2.394-.052 3.147c-.05.735-.142 1.117-.253 1.384a4 4 0 0 1-2.164 2.165c-.267.11-.65.201-1.384.252-.753.05-1.722.052-3.147.052h-1c-1.425 0-2.394-.001-3.147-.052-.735-.05-1.117-.142-1.384-.253a4 4 0 0 1-2.165-2.164c-.11-.267-.201-.65-.252-1.384C4.002 16.394 4 15.425 4 14s.001-2.394.052-3.147c.05-.735.142-1.117.252-1.384A4 4 0 0 1 6.47 7.304c.267-.11.65-.201 1.384-.252C8.606 7.002 9.575 7 11 7m9.793 2.53a4.6 4.6 0 0 0-.25-.826 6 6 0 0 0-3.247-3.247C16.194 5 14.796 5 12 5h-1c-2.796 0-4.193 0-5.296.457a6 6 0 0 0-3.247 3.247C2 9.807 2 11.204 2 14s0 4.194.457 5.296a6 6 0 0 0 3.247 3.247C6.807 23 8.204 23 11 23h1c2.796 0 4.194 0 5.296-.457a6 6 0 0 0 3.247-3.247c.106-.255.187-.526.25-.826l1.44 1.422C24 21.64 27 20.386 27 17.9v-7.8c0-2.486-2.998-3.739-4.767-1.992zM21 14v1.53a.8.8 0 0 0 .238.57l2.4 2.37A.8.8 0 0 0 25 17.9v-7.8a.8.8 0 0 0-1.362-.57l-2.4 2.37a.8.8 0 0 0-.238.57z" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" id="svg-name-videocam_slash_outline_56" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M3.38 10.502a1.5 1.5 0 0 1 2.118-.121l37 33a1.5 1.5 0 1 1-1.996 2.239l-3.54-3.157a9.5 9.5 0 0 1-2.15 1.502c-1.101.561-2.309.804-3.735.921C29.68 45 27.95 45 25.767 45h-7.533c-2.184 0-3.915 0-5.31-.114-1.427-.117-2.634-.36-3.737-.921a9.5 9.5 0 0 1-4.152-4.152c-.561-1.102-.804-2.31-.921-3.736C4 34.68 4 32.95 4 30.766v-5.532c0-2.184 0-3.915.114-5.31.117-1.427.36-2.634.921-3.737q.382-.748.884-1.412L3.502 12.62a1.5 1.5 0 0 1-.121-2.118m4.788 6.28q-.255.366-.46.767c-.31.609-.503 1.378-.604 2.619C7.001 21.427 7 23.035 7 25.3v5.4c0 2.265.001 3.874.104 5.132.101 1.242.294 2.01.604 2.619a6.5 6.5 0 0 0 2.841 2.84c.609.31 1.378.504 2.619.605 1.259.103 2.867.104 5.132.104h7.4c2.265 0 3.874-.001 5.132-.104 1.242-.101 2.01-.294 2.619-.604a6.5 6.5 0 0 0 1.258-.839zM44.641 16.65c-.607.304-1.307.74-2.022 1.186l-2.766 1.722c-.128-1.27-.375-2.364-.888-3.37a9.5 9.5 0 0 0-4.152-4.152c-1.102-.562-2.31-.805-3.737-.922C29.682 11 27.95 11 25.767 11H14.5a1.5 1.5 0 0 0 0 3h11.2c2.265 0 3.874.001 5.132.104 1.242.101 2.01.294 2.619.605a6.5 6.5 0 0 1 2.84 2.84c.31.609.504 1.378.605 2.619.103 1.259.104 2.867.104 5.132v7.699a3 3 0 0 0 1.415 2.547l4.109 2.557.095.06c.715.445 1.416.881 2.023 1.186.613.308 1.591.73 2.765.634a5 5 0 0 0 3.609-2.004c.702-.946.86-2 .922-2.683.062-.676.062-1.501.062-2.344v-9.906c0-.843 0-1.668-.062-2.344-.062-.684-.22-1.737-.922-2.684a5 5 0 0 0-3.61-2.004c-1.174-.096-2.152.327-2.765.635M40 23l4.109-2.558c1.596-.994 2.395-1.491 3.054-1.438a2 2 0 0 1 1.443.802c.394.53.394 1.471.394 3.352v9.682c0 1.88 0 2.82-.394 3.352a2 2 0 0 1-1.443.801c-.659.054-1.457-.443-3.054-1.437L40 33V23" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" id="svg-name-view_12" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M12 4c0-.8-2.4-4-6-4S0 3.2 0 4s2.4 4 6 4 6-3.2 6-4M9 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-view_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19 10c0 3.5-5 6-9 6s-9-2.5-9-6 5-6 9-6 9 2.5 9 6m-1.5 0c0 .983-.72 2.084-2.278 3.03-1.517.92-3.497 1.47-5.222 1.47s-3.705-.55-5.222-1.47C3.22 12.084 2.5 10.983 2.5 10s.72-2.084 2.278-3.03C6.295 6.05 8.275 5.5 10 5.5s3.705.55 5.222 1.47C16.78 7.916 17.5 9.017 17.5 10" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" id="svg-name-view_outline_28" class="svg-sprite__symbol"><path fill="currentColor" d="M14 6c5.994 0 11.5 4.557 11.5 8s-5.506 8-11.5 8-11.5-4.557-11.5-8S8.006 6 14 6m0 2c-4.964 0-9.5 3.754-9.5 6s4.536 6 9.5 6 9.5-3.754 9.5-6-4.536-6-9.5-6m0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="32.02" height="19.98" viewBox="8.1 14.6 32.02 19.98" id="svg-name-vk" class="svg-sprite__symbol"><path fill="#FFF" d="M25.54 34.58c-10.94 0-17.18-7.5-17.44-19.98h5.48c.18 9.16 4.22 13.04 7.42 13.84V14.6h5.16v7.9c3.16-.34 6.48-3.94 7.6-7.9h5.16c-.86 4.88-4.46 8.48-7.02 9.96 2.56 1.2 6.66 4.34 8.22 10.02h-5.68c-1.22-3.8-4.26-6.74-8.28-7.14v7.14z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-vkplay" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M10.42 0c4.52 0 6.78 0 8.18 1.4S20 5.06 20 9.58v.84c0 4.52 0 6.78-1.4 8.18S14.94 20 10.42 20h-.84c-4.52 0-6.78 0-8.18-1.4S0 14.94 0 10.42v-.84C0 5.06 0 2.8 1.4 1.4S5.06 0 9.58 0z"/><path fill="#0009B4" d="M.06 5.62C0 6.7 0 8 0 9.58v.84c0 1.2 0 2.22.02 3.12C2.64 14.82 6.16 15.6 10 15.6s7.36-.78 9.98-2.06c.02-.9.02-1.94.02-3.12v-.84C20 8 20 6.7 19.94 5.6H.06z"/><path stroke="#fff" stroke-width="1.998" d="M13.9 12a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM8.4 12.4 4 8M8.4 8 4 12.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-vkplay_transparent" class="svg-sprite__symbol"><g clip-path="url(#a)"><path fill="#07F" d="M10.42 0c4.52 0 6.78 0 8.18 1.4S20 5.06 20 9.58v.84c0 4.52 0 6.78-1.4 8.18S14.94 20 10.42 20h-.84c-4.52 0-6.78 0-8.18-1.4S0 14.94 0 10.42v-.84C0 5.06 0 2.8 1.4 1.4S5.06 0 9.58 0z"/><path fill="#0009B4" d="M.06 5.62C0 6.7 0 8 0 9.58v.84c0 1.2 0 2.22.02 3.12C2.64 14.82 6.16 15.6 10 15.6s7.36-.78 9.98-2.06c.02-.9.02-1.94.02-3.12v-.84C20 8 20 6.7 19.94 5.6H.06z"/><path stroke="#fff" stroke-width="1.998" d="M13.9 12a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM8.4 12.4 4 8M8.4 8 4 12.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" id="svg-name-vlc" class="svg-sprite__symbol"><path fill="currentColor" d="m23.401 19.322-3.083-1.193L16.04 6.722a1.11 1.11 0 0 0-2.08 0L12.812 9.78s-.004.01-.004.014l-.014.038-1.316 3.513a.3.3 0 0 0-.03.08l-1.282 3.415-.489 1.287v.004L6.6 19.321c-.37.145-.599.437-.599.766 0 .33.23.623.599.765l7.926 3.067a1.44 1.44 0 0 0 .948 0l7.928-3.067c.37-.144.599-.437.599-.765 0-.331-.23-.624-.599-.765m-10.215-9.177a25 25 0 0 0 3.624 0l1.172 3.13c-.896.13-1.92.196-2.982.196a21.4 21.4 0 0 1-2.986-.196zM15 20.94c-3.437 0-5.356-.662-5.476-1.033l.063-.162a.1.1 0 0 0 .01-.03l.497-1.325.445-1.181c1.117.306 2.72.479 4.461.479 1.737 0 3.342-.173 4.456-.48l.446 1.182.506 1.346.063.173c-.12.369-2.039 1.03-5.471 1.03"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-voice_outline_20" class="svg-sprite__symbol"><path fill="currentColor" fill-rule="evenodd" d="M15.692 12.48a.75.75 0 0 1 .162 1.048 7.25 7.25 0 0 1-5.103 2.934v1.788a.75.75 0 0 1-1.5 0v-1.789a7.28 7.28 0 0 1-5.1-2.931.75.75 0 1 1 1.207-.89A5.77 5.77 0 0 0 10 15a5.74 5.74 0 0 0 4.643-2.358.75.75 0 0 1 1.048-.162" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5.75 5.75a4.25 4.25 0 0 1 8.5 0v3.5a4.25 4.25 0 0 1-8.5 0zM10 3a2.75 2.75 0 0 0-2.75 2.75v3.5a2.75 2.75 0 1 0 5.5 0v-3.5A2.75 2.75 0 0 0 10 3" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" id="svg-name-volume" class="svg-sprite__symbol"><path fill-rule="evenodd" d="M9.25 4A.25.25 0 0 0 9 3.75h-.902a.25.25 0 0 0-.19.088L4.945 7.305l-.224.263H2a.25.25 0 0 0-.25.25v4.364c0 .138.112.25.25.25h2.721l.224.263 2.963 3.467a.25.25 0 0 0 .19.088H9a.25.25 0 0 0 .25-.25zM9 2.25c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 9 17.75h-.902a1.75 1.75 0 0 1-1.33-.613l-2.739-3.205H2a1.75 1.75 0 0 1-1.75-1.75V7.818c0-.966.784-1.75 1.75-1.75h2.03l2.738-3.205a1.75 1.75 0 0 1 1.33-.613zM12.25 8a.75.75 0 0 1 .75-.75 2.75 2.75 0 1 1 0 5.5.75.75 0 0 1 0-1.5 1.25 1.25 0 1 0 0-2.5.75.75 0 0 1-.75-.75m3.05-3.271a.75.75 0 0 0-.6 1.374 4.251 4.251 0 0 1 0 7.794.75.75 0 0 0 .6 1.374 5.751 5.751 0 0 0 0-10.542" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-wallet" class="svg-sprite__symbol"><path fill="currentColor" d="M1.75 3.33a.75.75 0 0 0-1.5 0zm15.662-1.58a.75.75 0 0 0 0-1.5zM.25 3.33V17h1.5V3.33zM3 19.75h14v-1.5H3zM19.75 17V7.235h-1.5V17zM17 4.485H3.118v1.5H17zM3.118 1.75h14.294V.25H3.118zM1.75 3.118c0-.756.612-1.368 1.368-1.368V.25A2.87 2.87 0 0 0 .25 3.118zm1.368 1.367A1.37 1.37 0 0 1 1.75 3.118H.25a2.87 2.87 0 0 0 2.868 2.867zm16.632 2.75A2.75 2.75 0 0 0 17 4.485v1.5c.69 0 1.25.56 1.25 1.25zM17 19.75A2.75 2.75 0 0 0 19.75 17h-1.5c0 .69-.56 1.25-1.25 1.25zM.25 17A2.75 2.75 0 0 0 3 19.75v-1.5c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentColor" stroke-width="1.5" d="M15 12.5a.5.5 0 0 1-1 0 .5.5 0 0 1 1 0Z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-warning" class="svg-sprite__symbol"><path stroke="currentColor" stroke-width="1.5" d="M8.524 2.705a1.5 1.5 0 0 1 2.544 0l7.294 11.67a1.5 1.5 0 0 1-1.272 2.295H2.502a1.5 1.5 0 0 1-1.272-2.295z"/><path stroke="currentColor" d="M10.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/><path fill="currentColor" d="M9.25 10a.75.75 0 0 0 1.5 0zm1.5-4a.75.75 0 0 0-1.5 0zm0 4V6h-1.5v4z"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" id="svg-name-warning_triangle_outline_20" class="svg-sprite__symbol"><path fill="currentColor" d="M11 14.001a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentColor" fill-rule="evenodd" d="M12.375 3.364c-.157-.27-.886-1.362-2.376-1.362s-2.21 1.077-2.375 1.362L1.523 13.853a2.76 2.76 0 0 0-.21 2.327 2.76 2.76 0 0 0 2.6 1.822h12.173a2.76 2.76 0 0 0 2.39-4.149zm3.711 13.14a1.264 1.264 0 0 0 1.094-1.898L11.078 4.117s-.328-.621-1.08-.621c-.75 0-1.077.621-1.077.621L2.82 14.606a1.262 1.262 0 0 0 1.093 1.897z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 6.001a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" id="svg-name-wave" class="svg-sprite__symbol"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.18 2c2.81 3.63 2.81 8.37 0 12M7.09 3.6c2.06 2.67 2.06 6.14 0 8.81M4 5.8c1.03 1.33 1.03 3.07 0 4.4"/></symbol><symbol xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" id="svg-name-wonder-reaction" class="svg-sprite__symbol"><path fill="url(#a)" stroke="currentColor" d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z"/><path fill="url(#b)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"/><path fill="url(#c)" d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16" opacity=".5"/><path fill="url(#d)" d="M6.39 9.34c.425 0 .77-.522.77-1.165S6.815 7.01 6.39 7.01s-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#e)" d="M6.39 7.405c.33 0 .62.29.77.715-.01-.63-.35-1.135-.77-1.135s-.76.505-.77 1.135c.15-.43.44-.715.77-.715"/><path fill="url(#f)" d="M11.615 9.34c.425 0 .77-.522.77-1.165s-.345-1.165-.77-1.165-.77.522-.77 1.165.345 1.165.77 1.165"/><path fill="url(#g)" d="M11.615 7.43c-.33 0-.62.29-.77.715.01-.63.35-1.135.77-1.135s.76.505.77 1.135c-.15-.425-.44-.715-.77-.715"/><path fill="url(#h)" d="M10.775 4.76c.02-.32.375-.5.97-.47.505.03 1.6.37 2.31 1.395.13.19-.09.275-.225.15-.45-.425-1.68-1.01-2.67-.96-.395.025-.385-.115-.385-.115"/><path fill="url(#i)" d="M7.225 4.76c-.02-.32-.375-.5-.97-.47-.505.03-1.6.37-2.31 1.395-.13.19.09.275.225.15.45-.425 1.68-1.01 2.67-.96.395.025.385-.115.385-.115"/><path fill="url(#j)" d="M9 14.44a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9"/><path fill="url(#k)" d="M9 11.99c.625 0 1.165.35 1.44.865A1.454 1.454 0 0 0 9 11.54c-.755 0-1.375.575-1.44 1.315A1.63 1.63 0 0 1 9 11.99"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(9.65096)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE030"/><stop offset="1" stop-color="#FFB92E"/></radialGradient><radialGradient id="c" cx="0" cy="0" r="1" gradientTransform="translate(7.428 5.756)scale(7.59284)" gradientUnits="userSpaceOnUse"><stop stop-color="#FFEA5F"/><stop offset="1" stop-color="#FFBC47" stop-opacity="0"/></radialGradient><radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 -2.382 8.196)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="f" cx="0" cy="0" r="1" gradientTransform="rotate(73.854 .23 11.672)scale(1.13034 .73131)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><radialGradient id="j" cx="0" cy="0" r="1" gradientTransform="rotate(73.853 -4.241 12.472)scale(1.7567 1.1364)" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#7A4400"/><stop offset="1" stop-color="#643800"/></radialGradient><linearGradient id="e" x1="6.389" x2="6.389" y1="7.003" y2="8.089" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="g" x1="11.613" x2="11.613" y1="7.032" y2="8.117" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient><linearGradient id="h" x1="12.425" x2="12.472" y1="5.385" y2="4.543" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="i" x1="5.578" x2="5.531" y1="5.385" y2="4.543" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#7A4400"/></linearGradient><linearGradient id="k" x1="9.001" x2="9.001" y1="10.86" y2="13.221" gradientUnits="userSpaceOnUse"><stop offset=".001" stop-color="#3C2200"/><stop offset="1" stop-color="#512D00"/></linearGradient></defs></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="svg-name-world" class="svg-sprite__symbol"><circle cx="10" cy="10" r="9.25" stroke="currentColor" stroke-width="1.5"/><path stroke="currentColor" stroke-width="1.5" d="M13.25 10c0 2.69-.438 5.092-1.118 6.793-.34.852-.728 1.492-1.12 1.906-.39.412-.732.551-1.012.551s-.622-.139-1.012-.551c-.392-.414-.78-1.054-1.12-1.907-.68-1.7-1.118-4.102-1.118-6.792s.438-5.092 1.118-6.793c.34-.852.728-1.492 1.12-1.906C9.378.89 9.72.75 10 .75s.622.139 1.012.551c.392.414.78 1.054 1.12 1.906.68 1.701 1.118 4.103 1.118 6.793ZM2 6h16M1 10h18M2 14h16"/></symbol></svg>`;
        window[spriteGlobalVarName] = sprite;
    }
    const loadSprite = ()=>{
        let svgSprite = document.getElementById(spriteNodeId);
        if (!svgSprite) {
            svgSprite = document.createElement("svg");
            document.body.prepend(svgSprite);
        }
        svgSprite.outerHTML = sprite;
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", (e2)=>{
        loadSprite();
    });
    else loadSprite();
})("__SVG_SPRITE_NODE__", "__SVG_SPRITE__");


var $7c5y3 = parcelRequire("7c5y3");

let $8b232ea25b4fd2a3$var$i = 0;
const $8b232ea25b4fd2a3$var$Log = (text, data)=>{
    const item = document.createElement('div');
    (item || {}).innerText = `${$8b232ea25b4fd2a3$var$i++}: ${text} ${typeof data !== 'undefined' ? JSON.stringify(data) : ''}`;
    const container = document.querySelector('#events');
    container?.appendChild(item);
    container?.scrollTo(0, container.scrollHeight);
};
const $8b232ea25b4fd2a3$var$authFromStorage = window.localStorage.getItem('auth');
if ($8b232ea25b4fd2a3$var$authFromStorage) {
    const parsedAuthData = JSON.parse($8b232ea25b4fd2a3$var$authFromStorage);
    document.querySelector('#input-auth-access-token').value = parsedAuthData.accessToken || document.querySelector('#input-auth-access-token').value;
    document.querySelector('#input-auth-refresh-token').value = parsedAuthData.refreshToken || document.querySelector('#input-auth-refresh-token').value;
    document.querySelector('#input-auth-expired-at').value = parsedAuthData.expiredAt || document.querySelector('#input-auth-expired-at').value;
    document.querySelector('#input-auth-x-app').value = parsedAuthData.appId || document.querySelector('#input-auth-x-app').value;
}
(0, $7c5y3.S).addListener((0, $7c5y3.E).CHANNEL_URL_UPDATE, (data)=>{
    $8b232ea25b4fd2a3$var$Log("\u041F\u0435\u0440\u0435\u0445\u043E\u0434 \u043D\u0430 \u043A\u0430\u043D\u0430\u043B: ", data);
    document.querySelector('#input-stream-url').value = data;
});
(document.querySelector('#input-stream-url') || {}).value = document.location.hash.slice(1) || 'romasan';
console.log('====', (0, $7c5y3.a)());
(0, $7c5y3.u)({
    hosts: {
    }
});
(0, $7c5y3.i)({
    xSdkApp: 'test_app_qwerty',
    channelUrl: document.querySelector('#input-stream-url')?.value,
    onAuthorize: ()=>{
        $8b232ea25b4fd2a3$var$Log("\u041D\u0430\u0436\u0430\u0442\u0430 \u043A\u043D\u043E\u043F\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438");
    },
    onTokenRefreshError: (error)=>{
        $8b232ea25b4fd2a3$var$Log("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0442\u043E\u043A\u0435\u043D\u0430 ", error);
    }
});
(0, $7c5y3.r)('#vklive-chat', {
});
document.querySelector('#button-stream-url')?.addEventListener('click', ()=>{
    const value = document.querySelector('#input-stream-url').value;
    (0, $7c5y3.e)(value);
});
document.querySelector('#button-auth')?.addEventListener('click', ()=>{
    const accessToken = document.querySelector('#input-auth-access-token').value;
    const refreshToken = document.querySelector('#input-auth-refresh-token').value;
    const expiredAt = document.querySelector('#input-auth-expired-at').value;
    const appId = document.querySelector('#input-auth-x-app').value;
    window.localStorage.setItem('auth', JSON.stringify({
        accessToken: accessToken,
        refreshToken: refreshToken,
        expiredAt: expiredAt,
        appId: appId
    }));
    (0, $7c5y3.s)({
        accessToken: accessToken,
        refreshToken: refreshToken,
        expiredAt: expiredAt,
        appId: appId
    });
});
// controls
document.querySelector('#button-play-video')?.addEventListener('click', ()=>{
    (0, $7c5y3.S).emit((0, $7c5y3.E).PLAY_VIDEO);
});
document.querySelector('#button-pause-video')?.addEventListener('click', ()=>{
    (0, $7c5y3.S).emit((0, $7c5y3.E).PAUSE_VIDEO, {
        timeCode: 123
    });
});
document.querySelector('#button-like')?.addEventListener('click', ()=>{
    (0, $7c5y3.S).emit((0, $7c5y3.E).LIKE);
});
document.querySelector('#button-seek-video')?.addEventListener('click', ()=>{
    (0, $7c5y3.S).emit((0, $7c5y3.E).SEEK_VIDEO, {
        timeCode: 123
    });
});
// events
const $8b232ea25b4fd2a3$var$events = {
    likes: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0430\u0439\u043A\u043E\u0432",
    viewers: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0440\u0438\u0442\u0435\u043B\u0435\u0439",
    subscribers: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u043E\u0432",
    info: "\u0418\u0437\u043C\u0435\u043D\u0438\u043B\u0438\u0441\u044C \u043D\u0438\u043A \u0430\u0432\u0442\u043E\u0440\u0430 \u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u0442\u0440\u0438\u043C\u0430",
    title: "\u0418\u0437\u043C\u0435\u043D\u0438\u043B\u0441\u044F \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
    category: "\u0418\u0437\u043C\u0435\u043D\u0438\u043B\u0430\u0441\u044C \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0441\u0442\u0440\u0438\u043C\u0430",
    date: "\u0418\u0437\u043C\u0435\u043D\u0438\u043B\u043E\u0441\u044C \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0441\u0442\u0440\u0438\u043C\u0430",
    start: "\u0421\u0442\u0440\u0438\u043C \u043D\u0430\u0447\u0430\u043B\u0441\u044F",
    end: "\u0417\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0441\u044F \u0441\u0442\u0440\u0438\u043C",
    authorize: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438"
};
(0, $7c5y3.S).addListener((0, $7c5y3.E).LIKES_COUNT, (counter)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.likes}: `, counter);
    (document.querySelector('#stream-likes') || {}).innerText = counter;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).VIEWERS_COUNT, (counter)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.viewers}: `, counter);
    (document.querySelector('#stream-online') || {}).innerText = counter;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).STREAM_TITLE_UPDATE, (payload)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.title}: `, payload.title);
    (document.querySelector('#stream-title') || {}).innerText = payload;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).STREAM_CATEGORY_UPDATE, (payload)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.category}: `, `${payload.title} - ${payload.id}`);
    (document.querySelector('#stream-category') || {}).innerText = payload.title;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).STREAM_SUBSCRIBERS_UPDATE, (payload)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.subscribers}: `, payload);
    (document.querySelector('#stream-subscribers') || {}).innerText = payload;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).STREAM_INFO_UPDATE, (payload)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.info}: `, `${payload.nickname}; ${payload.description}`);
    (document.querySelector('#stream-nickname') || {}).innerText = payload.nickname;
    (document.querySelector('#stream-description') || {}).innerText = payload.description;
    (document.querySelector('#stream-avatar') || {}).src = payload.avatar;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).STREAM_DATE_UPDATE, (payload)=>{
    $8b232ea25b4fd2a3$var$Log(`${$8b232ea25b4fd2a3$var$events.date}: `, `${payload.endTime}; ${payload.text}`);
    (document.querySelector('#stream-time') || {}).innerText = payload.text;
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).START_VIDEO, (data)=>{
    $8b232ea25b4fd2a3$var$Log($8b232ea25b4fd2a3$var$events.start, data);
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).END_VIDEO, (data)=>{
    $8b232ea25b4fd2a3$var$Log($8b232ea25b4fd2a3$var$events.end, data);
});
(0, $7c5y3.S).addListener((0, $7c5y3.E).AUTHORIZED_STATUS_UPDATE, (data)=>{
    $8b232ea25b4fd2a3$var$Log($8b232ea25b4fd2a3$var$events.authorize, data);
    (document.querySelector('#authorized') || {}).innerText = String(data);
});


//# sourceMappingURL=pages.7ab26d87.js.map
